var Cj = Object.defineProperty;
var Oy = (t) => {
  throw TypeError(t);
};
var wj = (t, e, r) => e in t ? Cj(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var ke = (t, e, r) => wj(t, typeof e != "symbol" ? e + "" : e, r), Fy = (t, e, r) => e.has(t) || Oy("Cannot " + r);
var xt = (t, e, r) => (Fy(t, e, "read from private field"), r ? r.call(t) : e.get(t)), NA = (t, e, r) => e.has(t) ? Oy("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), On = (t, e, r, n) => (Fy(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
import { jsx as h, jsxs as k, Fragment as Ze } from "react/jsx-runtime";
import * as ar from "react";
import re, { createContext as UA, useState as N, useEffect as le, version as bj, useContext as Xe, useRef as gt, useMemo as MA, useCallback as Kn, forwardRef as ol, useLayoutEffect as _p, Component as $p, Fragment as X6, useReducer as Bj, isValidElement as QA, cloneElement as vn, useImperativeHandle as fm, Children as xa, PureComponent as es, createElement as gP } from "react";
import gd, { createPortal as Ej } from "react-dom";
var R1 = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var Ty;
function xj() {
  if (Ty) return R1;
  Ty = 1, R1.parse = o, R1.serialize = c;
  var t = Object.prototype.toString, e = Object.prototype.hasOwnProperty, r = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, n = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, A = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, i = /^[\u0020-\u003A\u003D-\u007E]*$/;
  function o(d, g) {
    if (typeof d != "string")
      throw new TypeError("argument str must be a string");
    var m = {}, p = d.length;
    if (p < 2) return m;
    var v = g && g.decode || l, C = 0, w = 0, B = 0;
    do {
      if (w = d.indexOf("=", C), w === -1) break;
      if (B = d.indexOf(";", C), B === -1)
        B = p;
      else if (w > B) {
        C = d.lastIndexOf(";", w - 1) + 1;
        continue;
      }
      var y = s(d, C, w), b = a(d, w, y), q = d.slice(y, b);
      if (!e.call(m, q)) {
        var E = s(d, w + 1, B), x = a(d, B, E);
        d.charCodeAt(E) === 34 && d.charCodeAt(x - 1) === 34 && (E++, x--);
        var M = d.slice(E, x);
        m[q] = f(M, v);
      }
      C = B + 1;
    } while (C < p);
    return m;
  }
  function s(d, g, m) {
    do {
      var p = d.charCodeAt(g);
      if (p !== 32 && p !== 9) return g;
    } while (++g < m);
    return m;
  }
  function a(d, g, m) {
    for (; g > m; ) {
      var p = d.charCodeAt(--g);
      if (p !== 32 && p !== 9) return g + 1;
    }
    return m;
  }
  function c(d, g, m) {
    var p = m && m.encode || encodeURIComponent;
    if (typeof p != "function")
      throw new TypeError("option encode is invalid");
    if (!r.test(d))
      throw new TypeError("argument name is invalid");
    var v = p(g);
    if (!n.test(v))
      throw new TypeError("argument val is invalid");
    var C = d + "=" + v;
    if (!m) return C;
    if (m.maxAge != null) {
      var w = Math.floor(m.maxAge);
      if (!isFinite(w))
        throw new TypeError("option maxAge is invalid");
      C += "; Max-Age=" + w;
    }
    if (m.domain) {
      if (!A.test(m.domain))
        throw new TypeError("option domain is invalid");
      C += "; Domain=" + m.domain;
    }
    if (m.path) {
      if (!i.test(m.path))
        throw new TypeError("option path is invalid");
      C += "; Path=" + m.path;
    }
    if (m.expires) {
      var B = m.expires;
      if (!u(B) || isNaN(B.valueOf()))
        throw new TypeError("option expires is invalid");
      C += "; Expires=" + B.toUTCString();
    }
    if (m.httpOnly && (C += "; HttpOnly"), m.secure && (C += "; Secure"), m.partitioned && (C += "; Partitioned"), m.priority) {
      var y = typeof m.priority == "string" ? m.priority.toLowerCase() : m.priority;
      switch (y) {
        case "low":
          C += "; Priority=Low";
          break;
        case "medium":
          C += "; Priority=Medium";
          break;
        case "high":
          C += "; Priority=High";
          break;
        default:
          throw new TypeError("option priority is invalid");
      }
    }
    if (m.sameSite) {
      var b = typeof m.sameSite == "string" ? m.sameSite.toLowerCase() : m.sameSite;
      switch (b) {
        case !0:
          C += "; SameSite=Strict";
          break;
        case "lax":
          C += "; SameSite=Lax";
          break;
        case "strict":
          C += "; SameSite=Strict";
          break;
        case "none":
          C += "; SameSite=None";
          break;
        default:
          throw new TypeError("option sameSite is invalid");
      }
    }
    return C;
  }
  function l(d) {
    return d.indexOf("%") !== -1 ? decodeURIComponent(d) : d;
  }
  function u(d) {
    return t.call(d) === "[object Date]";
  }
  function f(d, g) {
    try {
      return g(d);
    } catch {
      return d;
    }
  }
  return R1;
}
var sh = xj();
function Ij() {
  const t = typeof global > "u" ? void 0 : global.TEST_HAS_DOCUMENT_COOKIE;
  return typeof t == "boolean" ? t : typeof document == "object" && typeof document.cookie == "string";
}
function Sj(t) {
  return typeof t == "string" ? sh.parse(t) : typeof t == "object" && t !== null ? t : {};
}
function c9(t, e = {}) {
  const r = Pj(t);
  if (!e.doNotParse)
    try {
      return JSON.parse(r);
    } catch {
    }
  return t;
}
function Pj(t) {
  return t && t[0] === "j" && t[1] === ":" ? t.substr(2) : t;
}
class zn {
  constructor(e, r = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const A = this.cookies;
      this.cookies = sh.parse(document.cookie), this._checkChanges(A);
    };
    const n = typeof document > "u" ? "" : document.cookie;
    this.cookies = Sj(e || n), this.defaultSetOptions = r, this.HAS_DOCUMENT_COOKIE = Ij();
  }
  _emitChange(e) {
    for (let r = 0; r < this.changeListeners.length; ++r)
      this.changeListeners[r](e);
  }
  _checkChanges(e) {
    new Set(Object.keys(e).concat(Object.keys(this.cookies))).forEach((n) => {
      e[n] !== this.cookies[n] && this._emitChange({
        name: n,
        value: c9(this.cookies[n])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(e, r = {}) {
    return r.doNotUpdate || this.update(), c9(this.cookies[e], r);
  }
  getAll(e = {}) {
    e.doNotUpdate || this.update();
    const r = {};
    for (let n in this.cookies)
      r[n] = c9(this.cookies[n], e);
    return r;
  }
  set(e, r, n) {
    n ? n = Object.assign(Object.assign({}, this.defaultSetOptions), n) : n = this.defaultSetOptions;
    const A = typeof r == "string" ? r : JSON.stringify(r);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [e]: A }), this.HAS_DOCUMENT_COOKIE && (document.cookie = sh.serialize(e, A, n)), this._emitChange({ name: e, value: r, options: n });
  }
  remove(e, r) {
    const n = r = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), r), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[e], this.HAS_DOCUMENT_COOKIE && (document.cookie = sh.serialize(e, "", n)), this._emitChange({ name: e, value: void 0, options: r });
  }
  addChangeListener(e) {
    this.changeListeners.push(e), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(e) {
    const r = this.changeListeners.indexOf(e);
    r >= 0 && this.changeListeners.splice(r, 1), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
var oa;
let Ve = (oa = class {
}, ke(oa, "BACKEND_URL", "https://api.questlabs.ai/"), ke(oa, "BASE_IPFS_URL", "https://pin.questprotocol.xyz/ipfs/"), ke(oa, "BACKEND_URL_STAGING", "https://staging-api.questlabs.ai/"), ke(oa, "FLAG_CONSTRAINTS", {
  OnboardingFlag: "quest.sdk.onboardings",
  AnalyticsFlag: "quest.sdk.analytics",
  PaymentFlag: "quest.sdk.payment",
  ChatFlag: "quest.sdk.chat",
  FeedbackWorkflowFlag: "quest.sdk.feedback_workflow",
  GetStartedFlag: "quest.sdk.get_started"
}), ke(oa, "PHRASE_PROJECT_ID", "e618cdb0b6998e73076a4e43a2fbe7ed"), ke(oa, "PHRASE_ACCESS_TOKEN", "c7e17018c71c5d07b970b4de79983c94a6403c883bd80e66a0b70e70d7e6c527"), oa);
function mP(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: kj } = Object.prototype, { getPrototypeOf: hm } = Object, eg = /* @__PURE__ */ ((t) => (e) => {
  const r = kj.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), mo = (t) => (t = t.toLowerCase(), (e) => eg(e) === t), tg = (t) => (e) => typeof e === t, { isArray: md } = Array, u2 = tg("undefined");
function Oj(t) {
  return t !== null && !u2(t) && t.constructor !== null && !u2(t.constructor) && yi(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const vP = mo("ArrayBuffer");
function Fj(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && vP(t.buffer), e;
}
const Tj = tg("string"), yi = tg("function"), qP = tg("number"), rg = (t) => t !== null && typeof t == "object", Mj = (t) => t === !0 || t === !1, ah = (t) => {
  if (eg(t) !== "object")
    return !1;
  const e = hm(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Hj = mo("Date"), Dj = mo("File"), Qj = mo("Blob"), Uj = mo("FileList"), Nj = (t) => rg(t) && yi(t.pipe), jj = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || yi(t.append) && ((e = eg(t)) === "formdata" || // detect form-data instance
  e === "object" && yi(t.toString) && t.toString() === "[object FormData]"));
}, Lj = mo("URLSearchParams"), [Gj, Rj, zj, Yj] = ["ReadableStream", "Request", "Response", "Headers"].map(mo), Vj = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function d1(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, A;
  if (typeof t != "object" && (t = [t]), md(t))
    for (n = 0, A = t.length; n < A; n++)
      e.call(null, t[n], n, t);
  else {
    const i = r ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let s;
    for (n = 0; n < o; n++)
      s = i[n], e.call(null, t[s], s, t);
  }
}
function yP(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, A;
  for (; n-- > 0; )
    if (A = r[n], e === A.toLowerCase())
      return A;
  return null;
}
const vc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, CP = (t) => !u2(t) && t !== vc;
function K6() {
  const { caseless: t } = CP(this) && this || {}, e = {}, r = (n, A) => {
    const i = t && yP(e, A) || A;
    ah(e[i]) && ah(n) ? e[i] = K6(e[i], n) : ah(n) ? e[i] = K6({}, n) : md(n) ? e[i] = n.slice() : e[i] = n;
  };
  for (let n = 0, A = arguments.length; n < A; n++)
    arguments[n] && d1(arguments[n], r);
  return e;
}
const Wj = (t, e, r, { allOwnKeys: n } = {}) => (d1(e, (A, i) => {
  r && yi(A) ? t[i] = mP(A, r) : t[i] = A;
}, { allOwnKeys: n }), t), Xj = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Kj = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, Zj = (t, e, r, n) => {
  let A, i, o;
  const s = {};
  if (e = e || {}, t == null) return e;
  do {
    for (A = Object.getOwnPropertyNames(t), i = A.length; i-- > 0; )
      o = A[i], (!n || n(o, t, e)) && !s[o] && (e[o] = t[o], s[o] = !0);
    t = r !== !1 && hm(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, Jj = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, _j = (t) => {
  if (!t) return null;
  if (md(t)) return t;
  let e = t.length;
  if (!qP(e)) return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, $j = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && hm(Uint8Array)), eL = (t, e) => {
  const n = (t && t[Symbol.iterator]).call(t);
  let A;
  for (; (A = n.next()) && !A.done; ) {
    const i = A.value;
    e.call(t, i[0], i[1]);
  }
}, tL = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, rL = mo("HTMLFormElement"), nL = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, A) {
    return n.toUpperCase() + A;
  }
), My = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), AL = mo("RegExp"), wP = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  d1(r, (A, i) => {
    let o;
    (o = e(A, i, t)) !== !1 && (n[i] = o || A);
  }), Object.defineProperties(t, n);
}, iL = (t) => {
  wP(t, (e, r) => {
    if (yi(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (yi(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, oL = (t, e) => {
  const r = {}, n = (A) => {
    A.forEach((i) => {
      r[i] = !0;
    });
  };
  return md(t) ? n(t) : n(String(t).split(e)), r;
}, sL = () => {
}, aL = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, l9 = "abcdefghijklmnopqrstuvwxyz", Hy = "0123456789", bP = {
  DIGIT: Hy,
  ALPHA: l9,
  ALPHA_DIGIT: l9 + l9.toUpperCase() + Hy
}, cL = (t = 16, e = bP.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = e;
  for (; t--; )
    r += e[Math.random() * n | 0];
  return r;
};
function lL(t) {
  return !!(t && yi(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const uL = (t) => {
  const e = new Array(10), r = (n, A) => {
    if (rg(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        e[A] = n;
        const i = md(n) ? [] : {};
        return d1(n, (o, s) => {
          const a = r(o, A + 1);
          !u2(a) && (i[s] = a);
        }), e[A] = void 0, i;
      }
    }
    return n;
  };
  return r(t, 0);
}, dL = mo("AsyncFunction"), fL = (t) => t && (rg(t) || yi(t)) && yi(t.then) && yi(t.catch), BP = ((t, e) => t ? setImmediate : e ? ((r, n) => (vc.addEventListener("message", ({ source: A, data: i }) => {
  A === vc && i === r && n.length && n.shift()();
}, !1), (A) => {
  n.push(A), vc.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  yi(vc.postMessage)
), hL = typeof queueMicrotask < "u" ? queueMicrotask.bind(vc) : typeof process < "u" && process.nextTick || BP, ye = {
  isArray: md,
  isArrayBuffer: vP,
  isBuffer: Oj,
  isFormData: jj,
  isArrayBufferView: Fj,
  isString: Tj,
  isNumber: qP,
  isBoolean: Mj,
  isObject: rg,
  isPlainObject: ah,
  isReadableStream: Gj,
  isRequest: Rj,
  isResponse: zj,
  isHeaders: Yj,
  isUndefined: u2,
  isDate: Hj,
  isFile: Dj,
  isBlob: Qj,
  isRegExp: AL,
  isFunction: yi,
  isStream: Nj,
  isURLSearchParams: Lj,
  isTypedArray: $j,
  isFileList: Uj,
  forEach: d1,
  merge: K6,
  extend: Wj,
  trim: Vj,
  stripBOM: Xj,
  inherits: Kj,
  toFlatObject: Zj,
  kindOf: eg,
  kindOfTest: mo,
  endsWith: Jj,
  toArray: _j,
  forEachEntry: eL,
  matchAll: tL,
  isHTMLForm: rL,
  hasOwnProperty: My,
  hasOwnProp: My,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: wP,
  freezeMethods: iL,
  toObjectSet: oL,
  toCamelCase: nL,
  noop: sL,
  toFiniteNumber: aL,
  findKey: yP,
  global: vc,
  isContextDefined: CP,
  ALPHABET: bP,
  generateString: cL,
  isSpecCompliantForm: lL,
  toJSONObject: uL,
  isAsyncFn: dL,
  isThenable: fL,
  setImmediate: BP,
  asap: hL
};
function Ar(t, e, r, n, A) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), A && (this.response = A, this.status = A.status ? A.status : null);
}
ye.inherits(Ar, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ye.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const EP = Ar.prototype, xP = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  xP[t] = { value: t };
});
Object.defineProperties(Ar, xP);
Object.defineProperty(EP, "isAxiosError", { value: !0 });
Ar.from = (t, e, r, n, A, i) => {
  const o = Object.create(EP);
  return ye.toFlatObject(t, o, function(a) {
    return a !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Ar.call(o, t.message, e, r, n, A), o.cause = t, o.name = t.name, i && Object.assign(o, i), o;
};
const pL = null;
function Z6(t) {
  return ye.isPlainObject(t) || ye.isArray(t);
}
function IP(t) {
  return ye.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Dy(t, e, r) {
  return t ? t.concat(e).map(function(A, i) {
    return A = IP(A), !r && i ? "[" + A + "]" : A;
  }).join(r ? "." : "") : e;
}
function gL(t) {
  return ye.isArray(t) && !t.some(Z6);
}
const mL = ye.toFlatObject(ye, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function ng(t, e, r) {
  if (!ye.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = ye.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, p) {
    return !ye.isUndefined(p[m]);
  });
  const n = r.metaTokens, A = r.visitor || l, i = r.dots, o = r.indexes, a = (r.Blob || typeof Blob < "u" && Blob) && ye.isSpecCompliantForm(e);
  if (!ye.isFunction(A))
    throw new TypeError("visitor must be a function");
  function c(g) {
    if (g === null) return "";
    if (ye.isDate(g))
      return g.toISOString();
    if (!a && ye.isBlob(g))
      throw new Ar("Blob is not supported. Use a Buffer instead.");
    return ye.isArrayBuffer(g) || ye.isTypedArray(g) ? a && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function l(g, m, p) {
    let v = g;
    if (g && !p && typeof g == "object") {
      if (ye.endsWith(m, "{}"))
        m = n ? m : m.slice(0, -2), g = JSON.stringify(g);
      else if (ye.isArray(g) && gL(g) || (ye.isFileList(g) || ye.endsWith(m, "[]")) && (v = ye.toArray(g)))
        return m = IP(m), v.forEach(function(w, B) {
          !(ye.isUndefined(w) || w === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Dy([m], B, i) : o === null ? m : m + "[]",
            c(w)
          );
        }), !1;
    }
    return Z6(g) ? !0 : (e.append(Dy(p, m, i), c(g)), !1);
  }
  const u = [], f = Object.assign(mL, {
    defaultVisitor: l,
    convertValue: c,
    isVisitable: Z6
  });
  function d(g, m) {
    if (!ye.isUndefined(g)) {
      if (u.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(g), ye.forEach(g, function(v, C) {
        (!(ye.isUndefined(v) || v === null) && A.call(
          e,
          v,
          ye.isString(C) ? C.trim() : C,
          m,
          f
        )) === !0 && d(v, m ? m.concat(C) : [C]);
      }), u.pop();
    }
  }
  if (!ye.isObject(t))
    throw new TypeError("data must be an object");
  return d(t), e;
}
function Qy(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function pm(t, e) {
  this._pairs = [], t && ng(t, this, e);
}
const SP = pm.prototype;
SP.append = function(e, r) {
  this._pairs.push([e, r]);
};
SP.toString = function(e) {
  const r = e ? function(n) {
    return e.call(this, n, Qy);
  } : Qy;
  return this._pairs.map(function(A) {
    return r(A[0]) + "=" + r(A[1]);
  }, "").join("&");
};
function vL(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function PP(t, e, r) {
  if (!e)
    return t;
  const n = r && r.encode || vL;
  ye.isFunction(r) && (r = {
    serialize: r
  });
  const A = r && r.serialize;
  let i;
  if (A ? i = A(e, r) : i = ye.isURLSearchParams(e) ? e.toString() : new pm(e, r).toString(n), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class Uy {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    ye.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const kP = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, qL = typeof URLSearchParams < "u" ? URLSearchParams : pm, yL = typeof FormData < "u" ? FormData : null, CL = typeof Blob < "u" ? Blob : null, wL = {
  isBrowser: !0,
  classes: {
    URLSearchParams: qL,
    FormData: yL,
    Blob: CL
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, gm = typeof window < "u" && typeof document < "u", J6 = typeof navigator == "object" && navigator || void 0, bL = gm && (!J6 || ["ReactNative", "NativeScript", "NS"].indexOf(J6.product) < 0), BL = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", EL = gm && window.location.href || "http://localhost", xL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: gm,
  hasStandardBrowserEnv: bL,
  hasStandardBrowserWebWorkerEnv: BL,
  navigator: J6,
  origin: EL
}, Symbol.toStringTag, { value: "Module" })), HA = {
  ...xL,
  ...wL
};
function IL(t, e) {
  return ng(t, new HA.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, A, i) {
      return HA.isNode && ye.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function SL(t) {
  return ye.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function PL(t) {
  const e = {}, r = Object.keys(t);
  let n;
  const A = r.length;
  let i;
  for (n = 0; n < A; n++)
    i = r[n], e[i] = t[i];
  return e;
}
function OP(t) {
  function e(r, n, A, i) {
    let o = r[i++];
    if (o === "__proto__") return !0;
    const s = Number.isFinite(+o), a = i >= r.length;
    return o = !o && ye.isArray(A) ? A.length : o, a ? (ye.hasOwnProp(A, o) ? A[o] = [A[o], n] : A[o] = n, !s) : ((!A[o] || !ye.isObject(A[o])) && (A[o] = []), e(r, n, A[o], i) && ye.isArray(A[o]) && (A[o] = PL(A[o])), !s);
  }
  if (ye.isFormData(t) && ye.isFunction(t.entries)) {
    const r = {};
    return ye.forEachEntry(t, (n, A) => {
      e(SL(n), A, r, 0);
    }), r;
  }
  return null;
}
function kL(t, e, r) {
  if (ye.isString(t))
    try {
      return (e || JSON.parse)(t), ye.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(t);
}
const f1 = {
  transitional: kP,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const n = r.getContentType() || "", A = n.indexOf("application/json") > -1, i = ye.isObject(e);
    if (i && ye.isHTMLForm(e) && (e = new FormData(e)), ye.isFormData(e))
      return A ? JSON.stringify(OP(e)) : e;
    if (ye.isArrayBuffer(e) || ye.isBuffer(e) || ye.isStream(e) || ye.isFile(e) || ye.isBlob(e) || ye.isReadableStream(e))
      return e;
    if (ye.isArrayBufferView(e))
      return e.buffer;
    if (ye.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let s;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return IL(e, this.formSerializer).toString();
      if ((s = ye.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return ng(
          s ? { "files[]": e } : e,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return i || A ? (r.setContentType("application/json", !1), kL(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || f1.transitional, n = r && r.forcedJSONParsing, A = this.responseType === "json";
    if (ye.isResponse(e) || ye.isReadableStream(e))
      return e;
    if (e && ye.isString(e) && (n && !this.responseType || A)) {
      const o = !(r && r.silentJSONParsing) && A;
      try {
        return JSON.parse(e);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? Ar.from(s, Ar.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: HA.classes.FormData,
    Blob: HA.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ye.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  f1.headers[t] = {};
});
const OL = ye.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), FL = (t) => {
  const e = {};
  let r, n, A;
  return t && t.split(`
`).forEach(function(o) {
    A = o.indexOf(":"), r = o.substring(0, A).trim().toLowerCase(), n = o.substring(A + 1).trim(), !(!r || e[r] && OL[r]) && (r === "set-cookie" ? e[r] ? e[r].push(n) : e[r] = [n] : e[r] = e[r] ? e[r] + ", " + n : n);
  }), e;
}, Ny = Symbol("internals");
function n0(t) {
  return t && String(t).trim().toLowerCase();
}
function ch(t) {
  return t === !1 || t == null ? t : ye.isArray(t) ? t.map(ch) : String(t);
}
function TL(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(t); )
    e[n[1]] = n[2];
  return e;
}
const ML = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function u9(t, e, r, n, A) {
  if (ye.isFunction(n))
    return n.call(this, e, r);
  if (A && (e = r), !!ye.isString(e)) {
    if (ye.isString(n))
      return e.indexOf(n) !== -1;
    if (ye.isRegExp(n))
      return n.test(e);
  }
}
function HL(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, n) => r.toUpperCase() + n);
}
function DL(t, e) {
  const r = ye.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(t, n + r, {
      value: function(A, i, o) {
        return this[n].call(this, e, A, i, o);
      },
      configurable: !0
    });
  });
}
let ai = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, n) {
    const A = this;
    function i(s, a, c) {
      const l = n0(a);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const u = ye.findKey(A, l);
      (!u || A[u] === void 0 || c === !0 || c === void 0 && A[u] !== !1) && (A[u || a] = ch(s));
    }
    const o = (s, a) => ye.forEach(s, (c, l) => i(c, l, a));
    if (ye.isPlainObject(e) || e instanceof this.constructor)
      o(e, r);
    else if (ye.isString(e) && (e = e.trim()) && !ML(e))
      o(FL(e), r);
    else if (ye.isHeaders(e))
      for (const [s, a] of e.entries())
        i(a, s, n);
    else
      e != null && i(r, e, n);
    return this;
  }
  get(e, r) {
    if (e = n0(e), e) {
      const n = ye.findKey(this, e);
      if (n) {
        const A = this[n];
        if (!r)
          return A;
        if (r === !0)
          return TL(A);
        if (ye.isFunction(r))
          return r.call(this, A, n);
        if (ye.isRegExp(r))
          return r.exec(A);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = n0(e), e) {
      const n = ye.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!r || u9(this, this[n], n, r)));
    }
    return !1;
  }
  delete(e, r) {
    const n = this;
    let A = !1;
    function i(o) {
      if (o = n0(o), o) {
        const s = ye.findKey(n, o);
        s && (!r || u9(n, n[s], s, r)) && (delete n[s], A = !0);
      }
    }
    return ye.isArray(e) ? e.forEach(i) : i(e), A;
  }
  clear(e) {
    const r = Object.keys(this);
    let n = r.length, A = !1;
    for (; n--; ) {
      const i = r[n];
      (!e || u9(this, this[i], i, e, !0)) && (delete this[i], A = !0);
    }
    return A;
  }
  normalize(e) {
    const r = this, n = {};
    return ye.forEach(this, (A, i) => {
      const o = ye.findKey(n, i);
      if (o) {
        r[o] = ch(A), delete r[i];
        return;
      }
      const s = e ? HL(i) : String(i).trim();
      s !== i && delete r[i], r[s] = ch(A), n[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return ye.forEach(this, (n, A) => {
      n != null && n !== !1 && (r[A] = e && ye.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const n = new this(e);
    return r.forEach((A) => n.set(A)), n;
  }
  static accessor(e) {
    const n = (this[Ny] = this[Ny] = {
      accessors: {}
    }).accessors, A = this.prototype;
    function i(o) {
      const s = n0(o);
      n[s] || (DL(A, o), n[s] = !0);
    }
    return ye.isArray(e) ? e.forEach(i) : i(e), this;
  }
};
ai.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ye.reduceDescriptors(ai.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(n) {
      this[r] = n;
    }
  };
});
ye.freezeMethods(ai);
function d9(t, e) {
  const r = this || f1, n = e || r, A = ai.from(n.headers);
  let i = n.data;
  return ye.forEach(t, function(s) {
    i = s.call(r, i, A.normalize(), e ? e.status : void 0);
  }), A.normalize(), i;
}
function FP(t) {
  return !!(t && t.__CANCEL__);
}
function vd(t, e, r) {
  Ar.call(this, t ?? "canceled", Ar.ERR_CANCELED, e, r), this.name = "CanceledError";
}
ye.inherits(vd, Ar, {
  __CANCEL__: !0
});
function TP(t, e, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? t(r) : e(new Ar(
    "Request failed with status code " + r.status,
    [Ar.ERR_BAD_REQUEST, Ar.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function QL(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function UL(t, e) {
  t = t || 10;
  const r = new Array(t), n = new Array(t);
  let A = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(a) {
    const c = Date.now(), l = n[i];
    o || (o = c), r[A] = a, n[A] = c;
    let u = i, f = 0;
    for (; u !== A; )
      f += r[u++], u = u % t;
    if (A = (A + 1) % t, A === i && (i = (i + 1) % t), c - o < e)
      return;
    const d = l && c - l;
    return d ? Math.round(f * 1e3 / d) : void 0;
  };
}
function NL(t, e) {
  let r = 0, n = 1e3 / e, A, i;
  const o = (c, l = Date.now()) => {
    r = l, A = null, i && (clearTimeout(i), i = null), t.apply(null, c);
  };
  return [(...c) => {
    const l = Date.now(), u = l - r;
    u >= n ? o(c, l) : (A = c, i || (i = setTimeout(() => {
      i = null, o(A);
    }, n - u)));
  }, () => A && o(A)];
}
const Fh = (t, e, r = 3) => {
  let n = 0;
  const A = UL(50, 250);
  return NL((i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, a = o - n, c = A(a), l = o <= s;
    n = o;
    const u = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: a,
      rate: c || void 0,
      estimated: c && s && l ? (s - o) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [e ? "download" : "upload"]: !0
    };
    t(u);
  }, r);
}, jy = (t, e) => {
  const r = t != null;
  return [(n) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: n
  }), e[1]];
}, Ly = (t) => (...e) => ye.asap(() => t(...e)), jL = HA.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (r) => (r = new URL(r, HA.origin), t.protocol === r.protocol && t.host === r.host && (e || t.port === r.port)))(
  new URL(HA.origin),
  HA.navigator && /(msie|trident)/i.test(HA.navigator.userAgent)
) : () => !0, LL = HA.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, n, A, i) {
      const o = [t + "=" + encodeURIComponent(e)];
      ye.isNumber(r) && o.push("expires=" + new Date(r).toGMTString()), ye.isString(n) && o.push("path=" + n), ye.isString(A) && o.push("domain=" + A), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function GL(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function RL(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function MP(t, e) {
  return t && !GL(e) ? RL(t, e) : e;
}
const Gy = (t) => t instanceof ai ? { ...t } : t;
function zc(t, e) {
  e = e || {};
  const r = {};
  function n(c, l, u, f) {
    return ye.isPlainObject(c) && ye.isPlainObject(l) ? ye.merge.call({ caseless: f }, c, l) : ye.isPlainObject(l) ? ye.merge({}, l) : ye.isArray(l) ? l.slice() : l;
  }
  function A(c, l, u, f) {
    if (ye.isUndefined(l)) {
      if (!ye.isUndefined(c))
        return n(void 0, c, u, f);
    } else return n(c, l, u, f);
  }
  function i(c, l) {
    if (!ye.isUndefined(l))
      return n(void 0, l);
  }
  function o(c, l) {
    if (ye.isUndefined(l)) {
      if (!ye.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, l);
  }
  function s(c, l, u) {
    if (u in e)
      return n(c, l);
    if (u in t)
      return n(void 0, c);
  }
  const a = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (c, l, u) => A(Gy(c), Gy(l), u, !0)
  };
  return ye.forEach(Object.keys(Object.assign({}, t, e)), function(l) {
    const u = a[l] || A, f = u(t[l], e[l], l);
    ye.isUndefined(f) && u !== s || (r[l] = f);
  }), r;
}
const HP = (t) => {
  const e = zc({}, t);
  let { data: r, withXSRFToken: n, xsrfHeaderName: A, xsrfCookieName: i, headers: o, auth: s } = e;
  e.headers = o = ai.from(o), e.url = PP(MP(e.baseURL, e.url), t.params, t.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let a;
  if (ye.isFormData(r)) {
    if (HA.hasStandardBrowserEnv || HA.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((a = o.getContentType()) !== !1) {
      const [c, ...l] = a ? a.split(";").map((u) => u.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (HA.hasStandardBrowserEnv && (n && ye.isFunction(n) && (n = n(e)), n || n !== !1 && jL(e.url))) {
    const c = A && i && LL.read(i);
    c && o.set(A, c);
  }
  return e;
}, zL = typeof XMLHttpRequest < "u", YL = zL && function(t) {
  return new Promise(function(r, n) {
    const A = HP(t);
    let i = A.data;
    const o = ai.from(A.headers).normalize();
    let { responseType: s, onUploadProgress: a, onDownloadProgress: c } = A, l, u, f, d, g;
    function m() {
      d && d(), g && g(), A.cancelToken && A.cancelToken.unsubscribe(l), A.signal && A.signal.removeEventListener("abort", l);
    }
    let p = new XMLHttpRequest();
    p.open(A.method.toUpperCase(), A.url, !0), p.timeout = A.timeout;
    function v() {
      if (!p)
        return;
      const w = ai.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), y = {
        data: !s || s === "text" || s === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: w,
        config: t,
        request: p
      };
      TP(function(q) {
        r(q), m();
      }, function(q) {
        n(q), m();
      }, y), p = null;
    }
    "onloadend" in p ? p.onloadend = v : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, p.onabort = function() {
      p && (n(new Ar("Request aborted", Ar.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function() {
      n(new Ar("Network Error", Ar.ERR_NETWORK, t, p)), p = null;
    }, p.ontimeout = function() {
      let B = A.timeout ? "timeout of " + A.timeout + "ms exceeded" : "timeout exceeded";
      const y = A.transitional || kP;
      A.timeoutErrorMessage && (B = A.timeoutErrorMessage), n(new Ar(
        B,
        y.clarifyTimeoutError ? Ar.ETIMEDOUT : Ar.ECONNABORTED,
        t,
        p
      )), p = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in p && ye.forEach(o.toJSON(), function(B, y) {
      p.setRequestHeader(y, B);
    }), ye.isUndefined(A.withCredentials) || (p.withCredentials = !!A.withCredentials), s && s !== "json" && (p.responseType = A.responseType), c && ([f, g] = Fh(c, !0), p.addEventListener("progress", f)), a && p.upload && ([u, d] = Fh(a), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", d)), (A.cancelToken || A.signal) && (l = (w) => {
      p && (n(!w || w.type ? new vd(null, t, p) : w), p.abort(), p = null);
    }, A.cancelToken && A.cancelToken.subscribe(l), A.signal && (A.signal.aborted ? l() : A.signal.addEventListener("abort", l)));
    const C = QL(A.url);
    if (C && HA.protocols.indexOf(C) === -1) {
      n(new Ar("Unsupported protocol " + C + ":", Ar.ERR_BAD_REQUEST, t));
      return;
    }
    p.send(i || null);
  });
}, VL = (t, e) => {
  const { length: r } = t = t ? t.filter(Boolean) : [];
  if (e || r) {
    let n = new AbortController(), A;
    const i = function(c) {
      if (!A) {
        A = !0, s();
        const l = c instanceof Error ? c : this.reason;
        n.abort(l instanceof Ar ? l : new vd(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new Ar(`timeout ${e} of ms exceeded`, Ar.ETIMEDOUT));
    }, e);
    const s = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: a } = n;
    return a.unsubscribe = () => ye.asap(s), a;
  }
}, WL = function* (t, e) {
  let r = t.byteLength;
  if (r < e) {
    yield t;
    return;
  }
  let n = 0, A;
  for (; n < r; )
    A = n + e, yield t.slice(n, A), n = A;
}, XL = async function* (t, e) {
  for await (const r of KL(t))
    yield* WL(r, e);
}, KL = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await e.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, Ry = (t, e, r, n) => {
  const A = XL(t, e);
  let i = 0, o, s = (a) => {
    o || (o = !0, n && n(a));
  };
  return new ReadableStream({
    async pull(a) {
      try {
        const { done: c, value: l } = await A.next();
        if (c) {
          s(), a.close();
          return;
        }
        let u = l.byteLength;
        if (r) {
          let f = i += u;
          r(f);
        }
        a.enqueue(new Uint8Array(l));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(a) {
      return s(a), A.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ag = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", DP = Ag && typeof ReadableStream == "function", ZL = Ag && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), QP = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, JL = DP && QP(() => {
  let t = !1;
  const e = new Request(HA.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), zy = 64 * 1024, _6 = DP && QP(() => ye.isReadableStream(new Response("").body)), Th = {
  stream: _6 && ((t) => t.body)
};
Ag && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Th[e] && (Th[e] = ye.isFunction(t[e]) ? (r) => r[e]() : (r, n) => {
      throw new Ar(`Response type '${e}' is not supported`, Ar.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const _L = async (t) => {
  if (t == null)
    return 0;
  if (ye.isBlob(t))
    return t.size;
  if (ye.isSpecCompliantForm(t))
    return (await new Request(HA.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (ye.isArrayBufferView(t) || ye.isArrayBuffer(t))
    return t.byteLength;
  if (ye.isURLSearchParams(t) && (t = t + ""), ye.isString(t))
    return (await ZL(t)).byteLength;
}, $L = async (t, e) => {
  const r = ye.toFiniteNumber(t.getContentLength());
  return r ?? _L(e);
}, eG = Ag && (async (t) => {
  let {
    url: e,
    method: r,
    data: n,
    signal: A,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: a,
    responseType: c,
    headers: l,
    withCredentials: u = "same-origin",
    fetchOptions: f
  } = HP(t);
  c = c ? (c + "").toLowerCase() : "text";
  let d = VL([A, i && i.toAbortSignal()], o), g;
  const m = d && d.unsubscribe && (() => {
    d.unsubscribe();
  });
  let p;
  try {
    if (a && JL && r !== "get" && r !== "head" && (p = await $L(l, n)) !== 0) {
      let y = new Request(e, {
        method: "POST",
        body: n,
        duplex: "half"
      }), b;
      if (ye.isFormData(n) && (b = y.headers.get("content-type")) && l.setContentType(b), y.body) {
        const [q, E] = jy(
          p,
          Fh(Ly(a))
        );
        n = Ry(y.body, zy, q, E);
      }
    }
    ye.isString(u) || (u = u ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    g = new Request(e, {
      ...f,
      signal: d,
      method: r.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: v ? u : void 0
    });
    let C = await fetch(g);
    const w = _6 && (c === "stream" || c === "response");
    if (_6 && (s || w && m)) {
      const y = {};
      ["status", "statusText", "headers"].forEach((x) => {
        y[x] = C[x];
      });
      const b = ye.toFiniteNumber(C.headers.get("content-length")), [q, E] = s && jy(
        b,
        Fh(Ly(s), !0)
      ) || [];
      C = new Response(
        Ry(C.body, zy, q, () => {
          E && E(), m && m();
        }),
        y
      );
    }
    c = c || "text";
    let B = await Th[ye.findKey(Th, c) || "text"](C, t);
    return !w && m && m(), await new Promise((y, b) => {
      TP(y, b, {
        data: B,
        headers: ai.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: t,
        request: g
      });
    });
  } catch (v) {
    throw m && m(), v && v.name === "TypeError" && /fetch/i.test(v.message) ? Object.assign(
      new Ar("Network Error", Ar.ERR_NETWORK, t, g),
      {
        cause: v.cause || v
      }
    ) : Ar.from(v, v && v.code, t, g);
  }
}), $6 = {
  http: pL,
  xhr: YL,
  fetch: eG
};
ye.forEach($6, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Yy = (t) => `- ${t}`, tG = (t) => ye.isFunction(t) || t === null || t === !1, UP = {
  getAdapter: (t) => {
    t = ye.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, n;
    const A = {};
    for (let i = 0; i < e; i++) {
      r = t[i];
      let o;
      if (n = r, !tG(r) && (n = $6[(o = String(r)).toLowerCase()], n === void 0))
        throw new Ar(`Unknown adapter '${o}'`);
      if (n)
        break;
      A[o || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(A).map(
        ([s, a]) => `adapter ${s} ` + (a === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? i.length > 1 ? `since :
` + i.map(Yy).join(`
`) : " " + Yy(i[0]) : "as no adapter specified";
      throw new Ar(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: $6
};
function f9(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new vd(null, t);
}
function Vy(t) {
  return f9(t), t.headers = ai.from(t.headers), t.data = d9.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), UP.getAdapter(t.adapter || f1.adapter)(t).then(function(n) {
    return f9(t), n.data = d9.call(
      t,
      t.transformResponse,
      n
    ), n.headers = ai.from(n.headers), n;
  }, function(n) {
    return FP(n) || (f9(t), n && n.response && (n.response.data = d9.call(
      t,
      t.transformResponse,
      n.response
    ), n.response.headers = ai.from(n.response.headers))), Promise.reject(n);
  });
}
const NP = "1.7.9", ig = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ig[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Wy = {};
ig.transitional = function(e, r, n) {
  function A(i, o) {
    return "[Axios v" + NP + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, s) => {
    if (e === !1)
      throw new Ar(
        A(o, " has been removed" + (r ? " in " + r : "")),
        Ar.ERR_DEPRECATED
      );
    return r && !Wy[o] && (Wy[o] = !0, console.warn(
      A(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, o, s) : !0;
  };
};
ig.spelling = function(e) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function rG(t, e, r) {
  if (typeof t != "object")
    throw new Ar("options must be an object", Ar.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(t);
  let A = n.length;
  for (; A-- > 0; ) {
    const i = n[A], o = e[i];
    if (o) {
      const s = t[i], a = s === void 0 || o(s, i, t);
      if (a !== !0)
        throw new Ar("option " + i + " must be " + a, Ar.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Ar("Unknown option " + i, Ar.ERR_BAD_OPTION);
  }
}
const lh = {
  assertOptions: rG,
  validators: ig
}, xo = lh.validators;
let Mc = class {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Uy(),
      response: new Uy()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (n) {
      if (n instanceof Error) {
        let A = {};
        Error.captureStackTrace ? Error.captureStackTrace(A) : A = new Error();
        const i = A.stack ? A.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = zc(this.defaults, r);
    const { transitional: n, paramsSerializer: A, headers: i } = r;
    n !== void 0 && lh.assertOptions(n, {
      silentJSONParsing: xo.transitional(xo.boolean),
      forcedJSONParsing: xo.transitional(xo.boolean),
      clarifyTimeoutError: xo.transitional(xo.boolean)
    }, !1), A != null && (ye.isFunction(A) ? r.paramsSerializer = {
      serialize: A
    } : lh.assertOptions(A, {
      encode: xo.function,
      serialize: xo.function
    }, !0)), lh.assertOptions(r, {
      baseUrl: xo.spelling("baseURL"),
      withXsrfToken: xo.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && ye.merge(
      i.common,
      i[r.method]
    );
    i && ye.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete i[g];
      }
    ), r.headers = ai.concat(o, i);
    const s = [];
    let a = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(r) === !1 || (a = a && m.synchronous, s.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let l, u = 0, f;
    if (!a) {
      const g = [Vy.bind(this), void 0];
      for (g.unshift.apply(g, s), g.push.apply(g, c), f = g.length, l = Promise.resolve(r); u < f; )
        l = l.then(g[u++], g[u++]);
      return l;
    }
    f = s.length;
    let d = r;
    for (u = 0; u < f; ) {
      const g = s[u++], m = s[u++];
      try {
        d = g(d);
      } catch (p) {
        m.call(this, p);
        break;
      }
    }
    try {
      l = Vy.call(this, d);
    } catch (g) {
      return Promise.reject(g);
    }
    for (u = 0, f = c.length; u < f; )
      l = l.then(c[u++], c[u++]);
    return l;
  }
  getUri(e) {
    e = zc(this.defaults, e);
    const r = MP(e.baseURL, e.url);
    return PP(r, e.params, e.paramsSerializer);
  }
};
ye.forEach(["delete", "get", "head", "options"], function(e) {
  Mc.prototype[e] = function(r, n) {
    return this.request(zc(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
ye.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(i, o, s) {
      return this.request(zc(s || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Mc.prototype[e] = r(), Mc.prototype[e + "Form"] = r(!0);
});
let nG = class jP {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((A) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](A);
      n._listeners = null;
    }), this.promise.then = (A) => {
      let i;
      const o = new Promise((s) => {
        n.subscribe(s), i = s;
      }).then(A);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, e(function(i, o, s) {
      n.reason || (n.reason = new vd(i, o, s), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), r = (n) => {
      e.abort(n);
    };
    return this.subscribe(r), e.signal.unsubscribe = () => this.unsubscribe(r), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new jP(function(A) {
        e = A;
      }),
      cancel: e
    };
  }
};
function AG(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function iG(t) {
  return ye.isObject(t) && t.isAxiosError === !0;
}
const e5 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(e5).forEach(([t, e]) => {
  e5[e] = t;
});
function LP(t) {
  const e = new Mc(t), r = mP(Mc.prototype.request, e);
  return ye.extend(r, Mc.prototype, e, { allOwnKeys: !0 }), ye.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(A) {
    return LP(zc(t, A));
  }, r;
}
const Oe = LP(f1);
Oe.Axios = Mc;
Oe.CanceledError = vd;
Oe.CancelToken = nG;
Oe.isCancel = FP;
Oe.VERSION = NP;
Oe.toFormData = ng;
Oe.AxiosError = Ar;
Oe.Cancel = Oe.CanceledError;
Oe.all = function(e) {
  return Promise.all(e);
};
Oe.spread = AG;
Oe.isAxiosError = iG;
Oe.mergeConfig = zc;
Oe.AxiosHeaders = ai;
Oe.formToJSON = (t) => OP(ye.isHTMLForm(t) ? new FormData(t) : t);
Oe.getAdapter = UP.getAdapter;
Oe.HttpStatusCode = e5;
Oe.default = Oe;
const {
  Axios: oG,
  AxiosError: GP,
  CanceledError: sG,
  isCancel: aG,
  CancelToken: cG,
  VERSION: lG,
  all: uG,
  Cancel: dG,
  isAxiosError: fG,
  spread: hG,
  toFormData: pG,
  AxiosHeaders: gG,
  HttpStatusCode: mG,
  formToJSON: vG,
  getAdapter: qG,
  mergeConfig: yG
} = Oe, CG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Axios: oG,
  AxiosError: GP,
  AxiosHeaders: gG,
  Cancel: dG,
  CancelToken: cG,
  CanceledError: sG,
  HttpStatusCode: mG,
  VERSION: lG,
  all: uG,
  default: Oe,
  formToJSON: vG,
  getAdapter: qG,
  isAxiosError: fG,
  isCancel: aG,
  mergeConfig: yG,
  spread: hG,
  toFormData: pG
}, Symbol.toStringTag, { value: "Module" })), RP = UA({
  apiKey: "",
  apiSecret: "",
  entityId: "",
  user: {},
  setUser: (t) => {
  },
  featureFlags: {},
  apiType: "PRODUCTION",
  themeConfig: {}
}), wG = (t) => {
  const [e, r] = N({}), [n, A] = N({});
  return le(() => {
  }, []), /* @__PURE__ */ h(
    RP.Provider,
    {
      value: {
        apiKey: t.apiKey,
        apiSecret: t.apiSecret,
        entityId: t.entityId,
        featureFlags: n || {},
        apiType: t.apiType || "PRODUCTION",
        user: e,
        setUser: r,
        themeConfig: t.themeConfig || {}
      },
      children: t.children
    }
  );
}, ct = {
  Context: RP,
  QuestProvider: wG
};
var Xy = function(t) {
  return typeof t == "object" && t !== null;
}, bG = function(t) {
  var e = t.value, r = e === void 0 ? "" : e, n = t.numInputs, A = n === void 0 ? 4 : n, i = t.onChange, o = t.onPaste, s = t.renderInput, a = t.shouldAutoFocus, c = a === void 0 ? !1 : a, l = t.inputType, u = l === void 0 ? "text" : l, f = t.renderSeparator, d = t.placeholder, g = t.containerStyle, m = t.inputStyle, p = t.skipDefaultStyles, v = p === void 0 ? !1 : p, C = re.useState(0), w = C[0], B = C[1], y = re.useRef([]), b = function() {
    return r ? r.toString().split("") : [];
  }, q = u === "number" || u === "tel";
  re.useEffect(function() {
    y.current = y.current.slice(0, A);
  }, [A]), re.useEffect(function() {
    var D;
    c && ((D = y.current[0]) === null || D === void 0 || D.focus());
  }, [c]);
  var E = function() {
    if (typeof d == "string") {
      if (d.length === A)
        return d;
      d.length > 0 && console.error("Length of the placeholder should be equal to the number of inputs.");
    }
  }, x = function(D) {
    var Q = q ? !isNaN(Number(D)) : typeof D == "string";
    return Q && D.trim().length === 1;
  }, M = function(D) {
    var Q = D.target.value;
    x(Q) && (F(Q), H(w + 1));
  }, O = function(D) {
    var Q = D.nativeEvent, Y = D.target.value;
    if (!x(Y)) {
      if (Y.length === A) {
        var j = Y.split("").some(function(Z) {
          return !x(Z);
        });
        j || (T(Y.split("")), H(A - 1));
      }
      Q.data === null && Q.inputType === "deleteContentBackward" && (D.preventDefault(), F(""), H(w - 1)), D.target.value = "";
    }
  }, I = function(D) {
    return function(Q) {
      B(Q), D.target.select();
    };
  }, S = function() {
    B(w - 1);
  }, P = function(D) {
    var Q = b();
    [D.code, D.key].includes("Backspace") ? (D.preventDefault(), F(""), H(w - 1)) : D.code === "Delete" ? (D.preventDefault(), F("")) : D.code === "ArrowLeft" ? (D.preventDefault(), H(w - 1)) : D.code === "ArrowRight" || D.key === Q[w] ? (D.preventDefault(), H(w + 1)) : (D.code === "Spacebar" || D.code === "Space" || D.code === "ArrowUp" || D.code === "ArrowDown") && D.preventDefault();
  }, H = function(D) {
    var Q, Y, j = Math.max(Math.min(A - 1, D), 0);
    y.current[j] && ((Q = y.current[j]) === null || Q === void 0 || Q.focus(), (Y = y.current[j]) === null || Y === void 0 || Y.select(), B(j));
  }, F = function(D) {
    var Q = b();
    Q[w] = D[0], T(Q);
  }, T = function(D) {
    var Q = D.join("");
    i(Q);
  }, U = function(D) {
    var Q;
    D.preventDefault();
    var Y = b(), j = w, Z = D.clipboardData.getData("text/plain").slice(0, A - w).split("");
    if (!(q && Z.some(function(R) {
      return isNaN(Number(R));
    }))) {
      for (var W = 0; W < A; ++W)
        W >= w && Z.length > 0 && (Y[W] = (Q = Z.shift()) !== null && Q !== void 0 ? Q : "", j++);
      H(j), T(Y);
    }
  };
  return re.createElement("div", { style: Object.assign({ display: "flex", alignItems: "center" }, Xy(g) && g), className: typeof g == "string" ? g : void 0, onPaste: o }, Array.from({ length: A }, function(D, Q) {
    return Q;
  }).map(function(D) {
    var Q, Y, j;
    return re.createElement(
      re.Fragment,
      { key: D },
      s({
        value: (Q = b()[D]) !== null && Q !== void 0 ? Q : "",
        placeholder: (j = (Y = E()) === null || Y === void 0 ? void 0 : Y[D]) !== null && j !== void 0 ? j : void 0,
        ref: function(Z) {
          return y.current[D] = Z;
        },
        onChange: M,
        onFocus: function(Z) {
          return I(Z)(D);
        },
        onBlur: S,
        onKeyDown: P,
        onPaste: U,
        autoComplete: "off",
        "aria-label": "Please enter OTP character ".concat(D + 1),
        style: Object.assign(v ? {} : { width: "1em", textAlign: "center" }, Xy(m) ? m : {}),
        className: typeof m == "string" ? m : void 0,
        type: u,
        inputMode: q ? "numeric" : "text",
        onInput: O
      }, D),
      D < A - 1 && (typeof f == "function" ? f(D) : f)
    );
  }));
}, jn;
(function(t) {
  t[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
})(jn || (jn = {}));
function BG(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function j0(t) {
  const e = t == null ? void 0 : t.host;
  return (e == null ? void 0 : e.shadowRoot) === t;
}
function L0(t) {
  return Object.prototype.toString.call(t) === "[object ShadowRoot]";
}
function EG(t) {
  return t.includes(" background-clip: text;") && !t.includes(" -webkit-background-clip: text;") && (t = t.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), t;
}
function xG(t) {
  const { cssText: e } = t;
  if (e.split('"').length < 3)
    return e;
  const r = ["@import", `url(${JSON.stringify(t.href)})`];
  return t.layerName === "" ? r.push("layer") : t.layerName && r.push(`layer(${t.layerName})`), t.supportsText && r.push(`supports(${t.supportsText})`), t.media.length && r.push(t.media.mediaText), r.join(" ") + ";";
}
function Mh(t) {
  try {
    const e = t.rules || t.cssRules;
    return e ? EG(Array.from(e, zP).join("")) : null;
  } catch {
    return null;
  }
}
function zP(t) {
  let e;
  if (SG(t))
    try {
      e = Mh(t.styleSheet) || xG(t);
    } catch {
    }
  else if (PG(t) && t.selectorText.includes(":"))
    return IG(t.cssText);
  return e || t.cssText;
}
function IG(t) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return t.replace(e, "$1\\$2");
}
function SG(t) {
  return "styleSheet" in t;
}
function PG(t) {
  return "selectorText" in t;
}
let YP = class {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(e) {
    var r;
    if (!e)
      return -1;
    const n = (r = this.getMeta(e)) === null || r === void 0 ? void 0 : r.id;
    return n ?? -1;
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  removeNodeFromMap(e) {
    const r = this.getId(e);
    this.idNodeMap.delete(r), e.childNodes && e.childNodes.forEach((n) => this.removeNodeFromMap(n));
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, r) {
    const n = r.id;
    this.idNodeMap.set(n, e), this.nodeMetaMap.set(e, r);
  }
  replace(e, r) {
    const n = this.getNode(e);
    if (n) {
      const A = this.nodeMetaMap.get(n);
      A && this.nodeMetaMap.set(r, A);
    }
    this.idNodeMap.set(e, r);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
};
function kG() {
  return new YP();
}
function mm({ element: t, maskInputOptions: e, tagName: r, type: n, value: A, maskInputFn: i }) {
  let o = A || "";
  const s = n && Yc(n);
  return (e[r.toLowerCase()] || s && e[s]) && (i ? o = i(o, t) : o = "*".repeat(o.length)), o;
}
function Yc(t) {
  return t.toLowerCase();
}
const Ky = "__rrweb_original__";
function OG(t) {
  const e = t.getContext("2d");
  if (!e)
    return !0;
  const r = 50;
  for (let n = 0; n < t.width; n += r)
    for (let A = 0; A < t.height; A += r) {
      const i = e.getImageData, o = Ky in i ? i[Ky] : i;
      if (new Uint32Array(o.call(e, n, A, Math.min(r, t.width - n), Math.min(r, t.height - A)).data.buffer).some((a) => a !== 0))
        return !1;
    }
  return !0;
}
function vm(t) {
  const e = t.type;
  return t.hasAttribute("data-rr-is-password") ? "password" : e ? Yc(e) : null;
}
function VP(t, e) {
  var r;
  let n;
  try {
    n = new URL(t, e ?? window.location.href);
  } catch {
    return null;
  }
  const A = /\.([0-9a-z]+)(?:$)/i, i = n.pathname.match(A);
  return (r = i == null ? void 0 : i[1]) !== null && r !== void 0 ? r : null;
}
let FG = 1;
const TG = new RegExp("[^a-z0-9-_:]"), d2 = -2;
function WP() {
  return FG++;
}
function MG(t) {
  if (t instanceof HTMLFormElement)
    return "form";
  const e = Yc(t.tagName);
  return TG.test(e) ? "div" : e;
}
function HG(t) {
  let e = "";
  return t.indexOf("//") > -1 ? e = t.split("/").slice(0, 3).join("/") : e = t.split("/")[0], e = e.split("?")[0], e;
}
let ml, Zy;
const DG = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, QG = /^(?:[a-z+]+:)?\/\//i, UG = /^www\..*/i, NG = /^(data:)([^,]*),(.*)/i;
function Hh(t, e) {
  return (t || "").replace(DG, (r, n, A, i, o, s) => {
    const a = A || o || s, c = n || i || "";
    if (!a)
      return r;
    if (QG.test(a) || UG.test(a))
      return `url(${c}${a}${c})`;
    if (NG.test(a))
      return `url(${c}${a}${c})`;
    if (a[0] === "/")
      return `url(${c}${HG(e) + a}${c})`;
    const l = e.split("/"), u = a.split("/");
    l.pop();
    for (const f of u)
      f !== "." && (f === ".." ? l.pop() : l.push(f));
    return `url(${c}${l.join("/")}${c})`;
  });
}
const jG = /^[^ \t\n\r\u000c]+/, LG = /^[, \t\n\r\u000c]+/;
function GG(t, e) {
  if (e.trim() === "")
    return e;
  let r = 0;
  function n(i) {
    let o;
    const s = i.exec(e.substring(r));
    return s ? (o = s[0], r += o.length, o) : "";
  }
  const A = [];
  for (; n(LG), !(r >= e.length); ) {
    let i = n(jG);
    if (i.slice(-1) === ",")
      i = Nl(t, i.substring(0, i.length - 1)), A.push(i);
    else {
      let o = "";
      i = Nl(t, i);
      let s = !1;
      for (; ; ) {
        const a = e.charAt(r);
        if (a === "") {
          A.push((i + o).trim());
          break;
        } else if (s)
          a === ")" && (s = !1);
        else if (a === ",") {
          r += 1, A.push((i + o).trim());
          break;
        } else a === "(" && (s = !0);
        o += a, r += 1;
      }
    }
  }
  return A.join(", ");
}
function Nl(t, e) {
  if (!e || e.trim() === "")
    return e;
  const r = t.createElement("a");
  return r.href = e, r.href;
}
function RG(t) {
  return !!(t.tagName === "svg" || t.ownerSVGElement);
}
function qm() {
  const t = document.createElement("a");
  return t.href = "", t.href;
}
function XP(t, e, r, n) {
  return n && (r === "src" || r === "href" && !(e === "use" && n[0] === "#") || r === "xlink:href" && n[0] !== "#" || r === "background" && (e === "table" || e === "td" || e === "th") ? Nl(t, n) : r === "srcset" ? GG(t, n) : r === "style" ? Hh(n, qm()) : e === "object" && r === "data" ? Nl(t, n) : n);
}
function KP(t, e, r) {
  return (t === "video" || t === "audio") && e === "autoplay";
}
function zG(t, e, r) {
  try {
    if (typeof e == "string") {
      if (t.classList.contains(e))
        return !0;
    } else
      for (let n = t.classList.length; n--; ) {
        const A = t.classList[n];
        if (e.test(A))
          return !0;
      }
    if (r)
      return t.matches(r);
  } catch {
  }
  return !1;
}
function Dh(t, e, r) {
  if (!t)
    return !1;
  if (t.nodeType !== t.ELEMENT_NODE)
    return r ? Dh(t.parentNode, e, r) : !1;
  for (let n = t.classList.length; n--; ) {
    const A = t.classList[n];
    if (e.test(A))
      return !0;
  }
  return r ? Dh(t.parentNode, e, r) : !1;
}
function ZP(t, e, r, n) {
  try {
    const A = t.nodeType === t.ELEMENT_NODE ? t : t.parentElement;
    if (A === null)
      return !1;
    if (typeof e == "string") {
      if (n) {
        if (A.closest(`.${e}`))
          return !0;
      } else if (A.classList.contains(e))
        return !0;
    } else if (Dh(A, e, n))
      return !0;
    if (r) {
      if (n) {
        if (A.closest(r))
          return !0;
      } else if (A.matches(r))
        return !0;
    }
  } catch {
  }
  return !1;
}
function YG(t, e, r) {
  const n = t.contentWindow;
  if (!n)
    return;
  let A = !1, i;
  try {
    i = n.document.readyState;
  } catch {
    return;
  }
  if (i !== "complete") {
    const s = setTimeout(() => {
      A || (e(), A = !0);
    }, r);
    t.addEventListener("load", () => {
      clearTimeout(s), A = !0, e();
    });
    return;
  }
  const o = "about:blank";
  if (n.location.href !== o || t.src === o || t.src === "")
    return setTimeout(e, 0), t.addEventListener("load", e);
  t.addEventListener("load", e);
}
function VG(t, e, r) {
  let n = !1, A;
  try {
    A = t.sheet;
  } catch {
    return;
  }
  if (A)
    return;
  const i = setTimeout(() => {
    n || (e(), n = !0);
  }, r);
  t.addEventListener("load", () => {
    clearTimeout(i), n = !0, e();
  });
}
function WG(t, e) {
  const { doc: r, mirror: n, blockClass: A, blockSelector: i, needsMask: o, inlineStylesheet: s, maskInputOptions: a = {}, maskTextFn: c, maskInputFn: l, dataURLOptions: u = {}, inlineImages: f, recordCanvas: d, keepIframeSrcFn: g, newlyAddedElement: m = !1 } = e, p = XG(r, n);
  switch (t.nodeType) {
    case t.DOCUMENT_NODE:
      return t.compatMode !== "CSS1Compat" ? {
        type: jn.Document,
        childNodes: [],
        compatMode: t.compatMode
      } : {
        type: jn.Document,
        childNodes: []
      };
    case t.DOCUMENT_TYPE_NODE:
      return {
        type: jn.DocumentType,
        name: t.name,
        publicId: t.publicId,
        systemId: t.systemId,
        rootId: p
      };
    case t.ELEMENT_NODE:
      return ZG(t, {
        doc: r,
        blockClass: A,
        blockSelector: i,
        inlineStylesheet: s,
        maskInputOptions: a,
        maskInputFn: l,
        dataURLOptions: u,
        inlineImages: f,
        recordCanvas: d,
        keepIframeSrcFn: g,
        newlyAddedElement: m,
        rootId: p
      });
    case t.TEXT_NODE:
      return KG(t, {
        needsMask: o,
        maskTextFn: c,
        rootId: p
      });
    case t.CDATA_SECTION_NODE:
      return {
        type: jn.CDATA,
        textContent: "",
        rootId: p
      };
    case t.COMMENT_NODE:
      return {
        type: jn.Comment,
        textContent: t.textContent || "",
        rootId: p
      };
    default:
      return !1;
  }
}
function XG(t, e) {
  if (!e.hasNode(t))
    return;
  const r = e.getId(t);
  return r === 1 ? void 0 : r;
}
function KG(t, e) {
  var r;
  const { needsMask: n, maskTextFn: A, rootId: i } = e, o = t.parentNode && t.parentNode.tagName;
  let s = t.textContent;
  const a = o === "STYLE" ? !0 : void 0, c = o === "SCRIPT" ? !0 : void 0;
  if (a && s) {
    try {
      t.nextSibling || t.previousSibling || !((r = t.parentNode.sheet) === null || r === void 0) && r.cssRules && (s = Mh(t.parentNode.sheet));
    } catch (l) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${l}`, t);
    }
    s = Hh(s, qm());
  }
  return c && (s = "SCRIPT_PLACEHOLDER"), !a && !c && s && n && (s = A ? A(s, t.parentElement) : s.replace(/[\S]/g, "*")), {
    type: jn.Text,
    textContent: s || "",
    isStyle: a,
    rootId: i
  };
}
function ZG(t, e) {
  const { doc: r, blockClass: n, blockSelector: A, inlineStylesheet: i, maskInputOptions: o = {}, maskInputFn: s, dataURLOptions: a = {}, inlineImages: c, recordCanvas: l, keepIframeSrcFn: u, newlyAddedElement: f = !1, rootId: d } = e, g = zG(t, n, A), m = MG(t);
  let p = {};
  const v = t.attributes.length;
  for (let w = 0; w < v; w++) {
    const B = t.attributes[w];
    KP(m, B.name, B.value) || (p[B.name] = XP(r, m, Yc(B.name), B.value));
  }
  if (m === "link" && i) {
    const w = Array.from(r.styleSheets).find((y) => y.href === t.href);
    let B = null;
    w && (B = Mh(w)), B && (delete p.rel, delete p.href, p._cssText = Hh(B, w.href));
  }
  if (m === "style" && t.sheet && !(t.innerText || t.textContent || "").trim().length) {
    const w = Mh(t.sheet);
    w && (p._cssText = Hh(w, qm()));
  }
  if (m === "input" || m === "textarea" || m === "select") {
    const w = t.value, B = t.checked;
    p.type !== "radio" && p.type !== "checkbox" && p.type !== "submit" && p.type !== "button" && w ? p.value = mm({
      element: t,
      type: vm(t),
      tagName: m,
      value: w,
      maskInputOptions: o,
      maskInputFn: s
    }) : B && (p.checked = B);
  }
  if (m === "option" && (t.selected && !o.select ? p.selected = !0 : delete p.selected), m === "canvas" && l) {
    if (t.__context === "2d")
      OG(t) || (p.rr_dataURL = t.toDataURL(a.type, a.quality));
    else if (!("__context" in t)) {
      const w = t.toDataURL(a.type, a.quality), B = document.createElement("canvas");
      B.width = t.width, B.height = t.height;
      const y = B.toDataURL(a.type, a.quality);
      w !== y && (p.rr_dataURL = w);
    }
  }
  if (m === "img" && c) {
    ml || (ml = r.createElement("canvas"), Zy = ml.getContext("2d"));
    const w = t, B = w.crossOrigin;
    w.crossOrigin = "anonymous";
    const y = () => {
      w.removeEventListener("load", y);
      try {
        ml.width = w.naturalWidth, ml.height = w.naturalHeight, Zy.drawImage(w, 0, 0), p.rr_dataURL = ml.toDataURL(a.type, a.quality);
      } catch (b) {
        console.warn(`Cannot inline img src=${w.currentSrc}! Error: ${b}`);
      }
      B ? p.crossOrigin = B : w.removeAttribute("crossorigin");
    };
    w.complete && w.naturalWidth !== 0 ? y() : w.addEventListener("load", y);
  }
  if (m === "audio" || m === "video") {
    const w = p;
    w.rr_mediaState = t.paused ? "paused" : "played", w.rr_mediaCurrentTime = t.currentTime, w.rr_mediaPlaybackRate = t.playbackRate, w.rr_mediaMuted = t.muted, w.rr_mediaLoop = t.loop, w.rr_mediaVolume = t.volume;
  }
  if (f || (t.scrollLeft && (p.rr_scrollLeft = t.scrollLeft), t.scrollTop && (p.rr_scrollTop = t.scrollTop)), g) {
    const { width: w, height: B } = t.getBoundingClientRect();
    p = {
      class: p.class,
      rr_width: `${w}px`,
      rr_height: `${B}px`
    };
  }
  m === "iframe" && !u(p.src) && (t.contentDocument || (p.rr_src = p.src), delete p.src);
  let C;
  try {
    customElements.get(m) && (C = !0);
  } catch {
  }
  return {
    type: jn.Element,
    tagName: m,
    attributes: p,
    childNodes: [],
    isSVG: RG(t) || void 0,
    needBlock: g,
    rootId: d,
    isCustom: C
  };
}
function Wr(t) {
  return t == null ? "" : t.toLowerCase();
}
function JG(t, e) {
  if (e.comment && t.type === jn.Comment)
    return !0;
  if (t.type === jn.Element) {
    if (e.script && (t.tagName === "script" || t.tagName === "link" && (t.attributes.rel === "preload" || t.attributes.rel === "modulepreload") && t.attributes.as === "script" || t.tagName === "link" && t.attributes.rel === "prefetch" && typeof t.attributes.href == "string" && VP(t.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (t.tagName === "link" && t.attributes.rel === "shortcut icon" || t.tagName === "meta" && (Wr(t.attributes.name).match(/^msapplication-tile(image|color)$/) || Wr(t.attributes.name) === "application-name" || Wr(t.attributes.rel) === "icon" || Wr(t.attributes.rel) === "apple-touch-icon" || Wr(t.attributes.rel) === "shortcut icon")))
      return !0;
    if (t.tagName === "meta") {
      if (e.headMetaDescKeywords && Wr(t.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (Wr(t.attributes.property).match(/^(og|twitter|fb):/) || Wr(t.attributes.name).match(/^(og|twitter):/) || Wr(t.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (Wr(t.attributes.name) === "robots" || Wr(t.attributes.name) === "googlebot" || Wr(t.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && t.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (Wr(t.attributes.name) === "author" || Wr(t.attributes.name) === "generator" || Wr(t.attributes.name) === "framework" || Wr(t.attributes.name) === "publisher" || Wr(t.attributes.name) === "progid" || Wr(t.attributes.property).match(/^article:/) || Wr(t.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (Wr(t.attributes.name) === "google-site-verification" || Wr(t.attributes.name) === "yandex-verification" || Wr(t.attributes.name) === "csrf-token" || Wr(t.attributes.name) === "p:domain_verify" || Wr(t.attributes.name) === "verify-v1" || Wr(t.attributes.name) === "verification" || Wr(t.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function jl(t, e) {
  const { doc: r, mirror: n, blockClass: A, blockSelector: i, maskTextClass: o, maskTextSelector: s, skipChild: a = !1, inlineStylesheet: c = !0, maskInputOptions: l = {}, maskTextFn: u, maskInputFn: f, slimDOMOptions: d, dataURLOptions: g = {}, inlineImages: m = !1, recordCanvas: p = !1, onSerialize: v, onIframeLoad: C, iframeLoadTimeout: w = 5e3, onStylesheetLoad: B, stylesheetLoadTimeout: y = 5e3, keepIframeSrcFn: b = () => !1, newlyAddedElement: q = !1 } = e;
  let { needsMask: E } = e, { preserveWhiteSpace: x = !0 } = e;
  !E && t.childNodes && (E = ZP(t, o, s, E === void 0));
  const M = WG(t, {
    doc: r,
    mirror: n,
    blockClass: A,
    blockSelector: i,
    needsMask: E,
    inlineStylesheet: c,
    maskInputOptions: l,
    maskTextFn: u,
    maskInputFn: f,
    dataURLOptions: g,
    inlineImages: m,
    recordCanvas: p,
    keepIframeSrcFn: b,
    newlyAddedElement: q
  });
  if (!M)
    return console.warn(t, "not serialized"), null;
  let O;
  n.hasNode(t) ? O = n.getId(t) : JG(M, d) || !x && M.type === jn.Text && !M.isStyle && !M.textContent.replace(/^\s+|\s+$/gm, "").length ? O = d2 : O = WP();
  const I = Object.assign(M, { id: O });
  if (n.add(t, I), O === d2)
    return null;
  v && v(t);
  let S = !a;
  if (I.type === jn.Element) {
    S = S && !I.needBlock, delete I.needBlock;
    const P = t.shadowRoot;
    P && L0(P) && (I.isShadowHost = !0);
  }
  if ((I.type === jn.Document || I.type === jn.Element) && S) {
    d.headWhitespace && I.type === jn.Element && I.tagName === "head" && (x = !1);
    const P = {
      doc: r,
      mirror: n,
      blockClass: A,
      blockSelector: i,
      needsMask: E,
      maskTextClass: o,
      maskTextSelector: s,
      skipChild: a,
      inlineStylesheet: c,
      maskInputOptions: l,
      maskTextFn: u,
      maskInputFn: f,
      slimDOMOptions: d,
      dataURLOptions: g,
      inlineImages: m,
      recordCanvas: p,
      preserveWhiteSpace: x,
      onSerialize: v,
      onIframeLoad: C,
      iframeLoadTimeout: w,
      onStylesheetLoad: B,
      stylesheetLoadTimeout: y,
      keepIframeSrcFn: b
    };
    if (!(I.type === jn.Element && I.tagName === "textarea" && I.attributes.value !== void 0)) for (const H of Array.from(t.childNodes)) {
      const F = jl(H, P);
      F && I.childNodes.push(F);
    }
    if (BG(t) && t.shadowRoot)
      for (const H of Array.from(t.shadowRoot.childNodes)) {
        const F = jl(H, P);
        F && (L0(t.shadowRoot) && (F.isShadow = !0), I.childNodes.push(F));
      }
  }
  return t.parentNode && j0(t.parentNode) && L0(t.parentNode) && (I.isShadow = !0), I.type === jn.Element && I.tagName === "iframe" && YG(t, () => {
    const P = t.contentDocument;
    if (P && C) {
      const H = jl(P, {
        doc: P,
        mirror: n,
        blockClass: A,
        blockSelector: i,
        needsMask: E,
        maskTextClass: o,
        maskTextSelector: s,
        skipChild: !1,
        inlineStylesheet: c,
        maskInputOptions: l,
        maskTextFn: u,
        maskInputFn: f,
        slimDOMOptions: d,
        dataURLOptions: g,
        inlineImages: m,
        recordCanvas: p,
        preserveWhiteSpace: x,
        onSerialize: v,
        onIframeLoad: C,
        iframeLoadTimeout: w,
        onStylesheetLoad: B,
        stylesheetLoadTimeout: y,
        keepIframeSrcFn: b
      });
      H && C(t, H);
    }
  }, w), I.type === jn.Element && I.tagName === "link" && typeof I.attributes.rel == "string" && (I.attributes.rel === "stylesheet" || I.attributes.rel === "preload" && typeof I.attributes.href == "string" && VP(I.attributes.href) === "css") && VG(t, () => {
    if (B) {
      const P = jl(t, {
        doc: r,
        mirror: n,
        blockClass: A,
        blockSelector: i,
        needsMask: E,
        maskTextClass: o,
        maskTextSelector: s,
        skipChild: !1,
        inlineStylesheet: c,
        maskInputOptions: l,
        maskTextFn: u,
        maskInputFn: f,
        slimDOMOptions: d,
        dataURLOptions: g,
        inlineImages: m,
        recordCanvas: p,
        preserveWhiteSpace: x,
        onSerialize: v,
        onIframeLoad: C,
        iframeLoadTimeout: w,
        onStylesheetLoad: B,
        stylesheetLoadTimeout: y,
        keepIframeSrcFn: b
      });
      P && B(t, P);
    }
  }, y), I;
}
function _G(t, e) {
  const { mirror: r = new YP(), blockClass: n = "rr-block", blockSelector: A = null, maskTextClass: i = "rr-mask", maskTextSelector: o = null, inlineStylesheet: s = !0, inlineImages: a = !1, recordCanvas: c = !1, maskAllInputs: l = !1, maskTextFn: u, maskInputFn: f, slimDOM: d = !1, dataURLOptions: g, preserveWhiteSpace: m, onSerialize: p, onIframeLoad: v, iframeLoadTimeout: C, onStylesheetLoad: w, stylesheetLoadTimeout: B, keepIframeSrcFn: y = () => !1 } = e;
  return jl(t, {
    doc: t,
    mirror: r,
    blockClass: n,
    blockSelector: A,
    maskTextClass: i,
    maskTextSelector: o,
    skipChild: !1,
    inlineStylesheet: s,
    maskInputOptions: l === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : l === !1 ? {
      password: !0
    } : l,
    maskTextFn: u,
    maskInputFn: f,
    slimDOMOptions: d === !0 || d === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: d === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : d === !1 ? {} : d,
    dataURLOptions: g,
    inlineImages: a,
    recordCanvas: c,
    preserveWhiteSpace: m,
    onSerialize: p,
    onIframeLoad: v,
    iframeLoadTimeout: C,
    onStylesheetLoad: w,
    stylesheetLoadTimeout: B,
    keepIframeSrcFn: y,
    newlyAddedElement: !1
  });
}
function zA(t, e, r = document) {
  const n = { capture: !0, passive: !0 };
  return r.addEventListener(t, e, n), () => r.removeEventListener(t, e, n);
}
const Ml = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Jy = {
  map: {},
  getId() {
    return console.error(Ml), -1;
  },
  getNode() {
    return console.error(Ml), null;
  },
  removeNodeFromMap() {
    console.error(Ml);
  },
  has() {
    return console.error(Ml), !1;
  },
  reset() {
    console.error(Ml);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Jy = new Proxy(Jy, {
  get(t, e, r) {
    return e === "map" && console.error(Ml), Reflect.get(t, e, r);
  }
}));
function f2(t, e, r = {}) {
  let n = null, A = 0;
  return function(...i) {
    const o = Date.now();
    !A && r.leading === !1 && (A = o);
    const s = e - (o - A), a = this;
    s <= 0 || s > e ? (n && (clearTimeout(n), n = null), A = o, t.apply(a, i)) : !n && r.trailing !== !1 && (n = setTimeout(() => {
      A = r.leading === !1 ? 0 : Date.now(), n = null, t.apply(a, i);
    }, s));
  };
}
function og(t, e, r, n, A = window) {
  const i = A.Object.getOwnPropertyDescriptor(t, e);
  return A.Object.defineProperty(t, e, n ? r : {
    set(o) {
      setTimeout(() => {
        r.set.call(this, o);
      }, 0), i && i.set && i.set.call(this, o);
    }
  }), () => og(t, e, i || {}, !0);
}
function qd(t, e, r) {
  try {
    if (!(e in t))
      return () => {
      };
    const n = t[e], A = r(n);
    return typeof A == "function" && (A.prototype = A.prototype || {}, Object.defineProperties(A, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), t[e] = A, () => {
      t[e] = n;
    };
  } catch {
    return () => {
    };
  }
}
let Qh = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (Qh = () => (/* @__PURE__ */ new Date()).getTime());
function JP(t) {
  var e, r, n, A, i, o;
  const s = t.document;
  return {
    left: s.scrollingElement ? s.scrollingElement.scrollLeft : t.pageXOffset !== void 0 ? t.pageXOffset : (s == null ? void 0 : s.documentElement.scrollLeft) || ((r = (e = s == null ? void 0 : s.body) === null || e === void 0 ? void 0 : e.parentElement) === null || r === void 0 ? void 0 : r.scrollLeft) || ((n = s == null ? void 0 : s.body) === null || n === void 0 ? void 0 : n.scrollLeft) || 0,
    top: s.scrollingElement ? s.scrollingElement.scrollTop : t.pageYOffset !== void 0 ? t.pageYOffset : (s == null ? void 0 : s.documentElement.scrollTop) || ((i = (A = s == null ? void 0 : s.body) === null || A === void 0 ? void 0 : A.parentElement) === null || i === void 0 ? void 0 : i.scrollTop) || ((o = s == null ? void 0 : s.body) === null || o === void 0 ? void 0 : o.scrollTop) || 0
  };
}
function _P() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $P() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function ek(t) {
  return t ? t.nodeType === t.ELEMENT_NODE ? t : t.parentElement : null;
}
function YA(t, e, r, n) {
  if (!t)
    return !1;
  const A = ek(t);
  if (!A)
    return !1;
  try {
    if (typeof e == "string") {
      if (A.classList.contains(e) || n && A.closest("." + e) !== null)
        return !0;
    } else if (Dh(A, e, n))
      return !0;
  } catch {
  }
  return !!(r && (A.matches(r) || n && A.closest(r) !== null));
}
function $G(t, e) {
  return e.getId(t) !== -1;
}
function h9(t, e) {
  return e.getId(t) === d2;
}
function tk(t, e) {
  if (j0(t))
    return !1;
  const r = e.getId(t);
  return e.has(r) ? t.parentNode && t.parentNode.nodeType === t.DOCUMENT_NODE ? !1 : t.parentNode ? tk(t.parentNode, e) : !0 : !0;
}
function t5(t) {
  return !!t.changedTouches;
}
function eR(t = window) {
  "NodeList" in t && !t.NodeList.prototype.forEach && (t.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in t && !t.DOMTokenList.prototype.forEach && (t.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...e) => {
    let r = e[0];
    if (!(0 in e))
      throw new TypeError("1 argument is required");
    do
      if (this === r)
        return !0;
    while (r = r && r.parentNode);
    return !1;
  });
}
function rk(t, e) {
  return !!(t.nodeName === "IFRAME" && e.getMeta(t));
}
function nk(t, e) {
  return !!(t.nodeName === "LINK" && t.nodeType === t.ELEMENT_NODE && t.getAttribute && t.getAttribute("rel") === "stylesheet" && e.getMeta(t));
}
function r5(t) {
  return !!(t != null && t.shadowRoot);
}
let tR = class {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(e) {
    var r;
    return (r = this.styleIDMap.get(e)) !== null && r !== void 0 ? r : -1;
  }
  has(e) {
    return this.styleIDMap.has(e);
  }
  add(e, r) {
    if (this.has(e))
      return this.getId(e);
    let n;
    return r === void 0 ? n = this.id++ : n = r, this.styleIDMap.set(e, n), this.idStyleMap.set(n, e), n;
  }
  getStyle(e) {
    return this.idStyleMap.get(e) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
};
function Ak(t) {
  var e, r;
  let n = null;
  return ((r = (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t)) === null || r === void 0 ? void 0 : r.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && t.getRootNode().host && (n = t.getRootNode().host), n;
}
function rR(t) {
  let e = t, r;
  for (; r = Ak(e); )
    e = r;
  return e;
}
function nR(t) {
  const e = t.ownerDocument;
  if (!e)
    return !1;
  const r = rR(t);
  return e.contains(r);
}
function ik(t) {
  const e = t.ownerDocument;
  return e ? e.contains(t) || nR(t) : !1;
}
var xr = /* @__PURE__ */ ((t) => (t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))(xr || {}), vr = /* @__PURE__ */ ((t) => (t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))(vr || {}), ei = /* @__PURE__ */ ((t) => (t[t.MouseUp = 0] = "MouseUp", t[t.MouseDown = 1] = "MouseDown", t[t.Click = 2] = "Click", t[t.ContextMenu = 3] = "ContextMenu", t[t.DblClick = 4] = "DblClick", t[t.Focus = 5] = "Focus", t[t.Blur = 6] = "Blur", t[t.TouchStart = 7] = "TouchStart", t[t.TouchMove_Departed = 8] = "TouchMove_Departed", t[t.TouchEnd = 9] = "TouchEnd", t[t.TouchCancel = 10] = "TouchCancel", t))(ei || {}), ls = /* @__PURE__ */ ((t) => (t[t.Mouse = 0] = "Mouse", t[t.Pen = 1] = "Pen", t[t.Touch = 2] = "Touch", t))(ls || {}), qu = /* @__PURE__ */ ((t) => (t[t["2D"] = 0] = "2D", t[t.WebGL = 1] = "WebGL", t[t.WebGL2 = 2] = "WebGL2", t))(qu || {});
function _y(t) {
  return "__ln" in t;
}
let AR = class {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(e) {
    if (e >= this.length)
      throw new Error("Position outside of list range");
    let r = this.head;
    for (let n = 0; n < e; n++)
      r = (r == null ? void 0 : r.next) || null;
    return r;
  }
  addNode(e) {
    const r = {
      value: e,
      previous: null,
      next: null
    };
    if (e.__ln = r, e.previousSibling && _y(e.previousSibling)) {
      const n = e.previousSibling.__ln.next;
      r.next = n, r.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = r, n && (n.previous = r);
    } else if (e.nextSibling && _y(e.nextSibling) && e.nextSibling.__ln.previous) {
      const n = e.nextSibling.__ln.previous;
      r.previous = n, r.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = r, n && (n.next = r);
    } else
      this.head && (this.head.previous = r), r.next = this.head, this.head = r;
    r.next === null && (this.tail = r), this.length++;
  }
  removeNode(e) {
    const r = e.__ln;
    this.head && (r.previous ? (r.previous.next = r.next, r.next ? r.next.previous = r.previous : this.tail = r.previous) : (this.head = r.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
  }
};
const $y = (t, e) => `${t}@${e}`;
let iR = class {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (e) => {
      e.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const e = [], r = /* @__PURE__ */ new Set(), n = new AR(), A = (a) => {
        let c = a, l = d2;
        for (; l === d2; )
          c = c && c.nextSibling, l = c && this.mirror.getId(c);
        return l;
      }, i = (a) => {
        if (!a.parentNode || !ik(a) || a.parentNode.tagName === "TEXTAREA")
          return;
        const c = j0(a.parentNode) ? this.mirror.getId(Ak(a)) : this.mirror.getId(a.parentNode), l = A(a);
        if (c === -1 || l === -1)
          return n.addNode(a);
        const u = jl(a, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (f) => {
            rk(f, this.mirror) && this.iframeManager.addIframe(f), nk(f, this.mirror) && this.stylesheetManager.trackLinkElement(f), r5(a) && this.shadowDomManager.addShadowRoot(a.shadowRoot, this.doc);
          },
          onIframeLoad: (f, d) => {
            this.iframeManager.attachIframe(f, d), this.shadowDomManager.observeAttachShadow(f);
          },
          onStylesheetLoad: (f, d) => {
            this.stylesheetManager.attachLinkElement(f, d);
          }
        });
        u && (e.push({
          parentId: c,
          nextId: l,
          node: u
        }), r.add(u.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const a of this.movedSet)
        eC(this.removes, a, this.mirror) && !this.movedSet.has(a.parentNode) || i(a);
      for (const a of this.addedSet)
        !tC(this.droppedSet, a) && !eC(this.removes, a, this.mirror) || tC(this.movedSet, a) ? i(a) : this.droppedSet.add(a);
      let o = null;
      for (; n.length; ) {
        let a = null;
        if (o) {
          const c = this.mirror.getId(o.value.parentNode), l = A(o.value);
          c !== -1 && l !== -1 && (a = o);
        }
        if (!a) {
          let c = n.tail;
          for (; c; ) {
            const l = c;
            if (c = c.previous, l) {
              const u = this.mirror.getId(l.value.parentNode);
              if (A(l.value) === -1)
                continue;
              if (u !== -1) {
                a = l;
                break;
              } else {
                const d = l.value;
                if (d.parentNode && d.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const g = d.parentNode.host;
                  if (this.mirror.getId(g) !== -1) {
                    a = l;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!a) {
          for (; n.head; )
            n.removeNode(n.head.value);
          break;
        }
        o = a.previous, n.removeNode(a.value), i(a.value);
      }
      const s = {
        texts: this.texts.map((a) => {
          const c = a.node;
          return c.parentNode && c.parentNode.tagName === "TEXTAREA" && this.genTextAreaValueMutation(c.parentNode), {
            id: this.mirror.getId(c),
            value: a.value
          };
        }).filter((a) => !r.has(a.id)).filter((a) => this.mirror.has(a.id)),
        attributes: this.attributes.map((a) => {
          const { attributes: c } = a;
          if (typeof c.style == "string") {
            const l = JSON.stringify(a.styleDiff), u = JSON.stringify(a._unchangedStyles);
            l.length < c.style.length && (l + u).split("var(").length === c.style.split("var(").length && (c.style = a.styleDiff);
          }
          return {
            id: this.mirror.getId(a.node),
            attributes: c
          };
        }).filter((a) => !r.has(a.id)).filter((a) => this.mirror.has(a.id)),
        removes: this.removes,
        adds: e
      };
      !s.texts.length && !s.attributes.length && !s.removes.length && !s.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(s));
    }, this.genTextAreaValueMutation = (e) => {
      let r = this.attributeMap.get(e);
      r || (r = {
        node: e,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(r), this.attributeMap.set(e, r)), r.attributes.value = Array.from(e.childNodes, (n) => n.textContent || "").join("");
    }, this.processMutation = (e) => {
      if (!h9(e.target, this.mirror))
        switch (e.type) {
          case "characterData": {
            const r = e.target.textContent;
            !YA(e.target, this.blockClass, this.blockSelector, !1) && r !== e.oldValue && this.texts.push({
              value: ZP(e.target, this.maskTextClass, this.maskTextSelector, !0) && r ? this.maskTextFn ? this.maskTextFn(r, ek(e.target)) : r.replace(/[\S]/g, "*") : r,
              node: e.target
            });
            break;
          }
          case "attributes": {
            const r = e.target;
            let n = e.attributeName, A = e.target.getAttribute(n);
            if (n === "value") {
              const o = vm(r);
              A = mm({
                element: r,
                maskInputOptions: this.maskInputOptions,
                tagName: r.tagName,
                type: o,
                value: A,
                maskInputFn: this.maskInputFn
              });
            }
            if (YA(e.target, this.blockClass, this.blockSelector, !1) || A === e.oldValue)
              return;
            let i = this.attributeMap.get(e.target);
            if (r.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(A))
              if (!r.contentDocument)
                n = "rr_src";
              else
                return;
            if (i || (i = {
              node: e.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(i), this.attributeMap.set(e.target, i)), n === "type" && r.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && r.setAttribute("data-rr-is-password", "true"), !KP(r.tagName, n) && (i.attributes[n] = XP(this.doc, Yc(r.tagName), Yc(n), A), n === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              e.oldValue && o.setAttribute("style", e.oldValue);
              for (const s of Array.from(r.style)) {
                const a = r.style.getPropertyValue(s), c = r.style.getPropertyPriority(s);
                a !== o.style.getPropertyValue(s) || c !== o.style.getPropertyPriority(s) ? c === "" ? i.styleDiff[s] = a : i.styleDiff[s] = [a, c] : i._unchangedStyles[s] = [a, c];
              }
              for (const s of Array.from(o.style))
                r.style.getPropertyValue(s) === "" && (i.styleDiff[s] = !1);
            }
            break;
          }
          case "childList": {
            if (YA(e.target, this.blockClass, this.blockSelector, !0))
              return;
            if (e.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(e.target);
              return;
            }
            e.addedNodes.forEach((r) => this.genAdds(r, e.target)), e.removedNodes.forEach((r) => {
              const n = this.mirror.getId(r), A = j0(e.target) ? this.mirror.getId(e.target.host) : this.mirror.getId(e.target);
              YA(e.target, this.blockClass, this.blockSelector, !1) || h9(r, this.mirror) || !$G(r, this.mirror) || (this.addedSet.has(r) ? (n5(this.addedSet, r), this.droppedSet.add(r)) : this.addedSet.has(e.target) && n === -1 || tk(e.target, this.mirror) || (this.movedSet.has(r) && this.movedMap[$y(n, A)] ? n5(this.movedSet, r) : this.removes.push({
                parentId: A,
                id: n,
                isShadow: j0(e.target) && L0(e.target) ? !0 : void 0
              })), this.mapRemoves.push(r));
            });
            break;
          }
        }
    }, this.genAdds = (e, r) => {
      if (!this.processedNodeManager.inOtherBuffer(e, this) && !(this.addedSet.has(e) || this.movedSet.has(e))) {
        if (this.mirror.hasNode(e)) {
          if (h9(e, this.mirror))
            return;
          this.movedSet.add(e);
          let n = null;
          r && this.mirror.hasNode(r) && (n = this.mirror.getId(r)), n && n !== -1 && (this.movedMap[$y(this.mirror.getId(e), n)] = !0);
        } else
          this.addedSet.add(e), this.droppedSet.delete(e);
        YA(e, this.blockClass, this.blockSelector, !1) || (e.childNodes.forEach((n) => this.genAdds(n)), r5(e) && e.shadowRoot.childNodes.forEach((n) => {
          this.processedNodeManager.add(n, this), this.genAdds(n, e);
        }));
      }
    };
  }
  init(e) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((r) => {
      this[r] = e[r];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
};
function n5(t, e) {
  t.delete(e), e.childNodes.forEach((r) => n5(t, r));
}
function eC(t, e, r) {
  return t.length === 0 ? !1 : ok(t, e, r);
}
function ok(t, e, r) {
  const { parentNode: n } = e;
  if (!n)
    return !1;
  const A = r.getId(n);
  return t.some((i) => i.id === A) ? !0 : ok(t, n, r);
}
function tC(t, e) {
  return t.size === 0 ? !1 : sk(t, e);
}
function sk(t, e) {
  const { parentNode: r } = e;
  return r ? t.has(r) ? !0 : sk(t, r) : !1;
}
let G0;
function oR(t) {
  G0 = t;
}
function sR() {
  G0 = void 0;
}
const wr = (t) => G0 ? (...r) => {
  try {
    return t(...r);
  } catch (n) {
    if (G0 && G0(n) === !0)
      return;
    throw n;
  }
} : t, qc = [];
function h1(t) {
  try {
    if ("composedPath" in t) {
      const e = t.composedPath();
      if (e.length)
        return e[0];
    } else if ("path" in t && t.path.length)
      return t.path[0];
  } catch {
  }
  return t && t.target;
}
function ak(t, e) {
  var r, n;
  const A = new iR();
  qc.push(A), A.init(t);
  let i = window.MutationObserver || window.__rrMutationObserver;
  const o = (n = (r = window == null ? void 0 : window.Zone) === null || r === void 0 ? void 0 : r.__symbol__) === null || n === void 0 ? void 0 : n.call(r, "MutationObserver");
  o && window[o] && (i = window[o]);
  const s = new i(wr(A.processMutations.bind(A)));
  return s.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), s;
}
function aR({ mousemoveCb: t, sampling: e, doc: r, mirror: n }) {
  if (e.mousemove === !1)
    return () => {
    };
  const A = typeof e.mousemove == "number" ? e.mousemove : 50, i = typeof e.mousemoveCallback == "number" ? e.mousemoveCallback : 500;
  let o = [], s;
  const a = f2(wr((u) => {
    const f = Date.now() - s;
    t(o.map((d) => (d.timeOffset -= f, d)), u), o = [], s = null;
  }), i), c = wr(f2(wr((u) => {
    const f = h1(u), { clientX: d, clientY: g } = t5(u) ? u.changedTouches[0] : u;
    s || (s = Qh()), o.push({
      x: d,
      y: g,
      id: n.getId(f),
      timeOffset: Qh() - s
    }), a(typeof DragEvent < "u" && u instanceof DragEvent ? vr.Drag : u instanceof MouseEvent ? vr.MouseMove : vr.TouchMove);
  }), A, {
    trailing: !1
  })), l = [
    zA("mousemove", c, r),
    zA("touchmove", c, r),
    zA("drag", c, r)
  ];
  return wr(() => {
    l.forEach((u) => u());
  });
}
function cR({ mouseInteractionCb: t, doc: e, mirror: r, blockClass: n, blockSelector: A, sampling: i }) {
  if (i.mouseInteraction === !1)
    return () => {
    };
  const o = i.mouseInteraction === !0 || i.mouseInteraction === void 0 ? {} : i.mouseInteraction, s = [];
  let a = null;
  const c = (l) => (u) => {
    const f = h1(u);
    if (YA(f, n, A, !0))
      return;
    let d = null, g = l;
    if ("pointerType" in u) {
      switch (u.pointerType) {
        case "mouse":
          d = ls.Mouse;
          break;
        case "touch":
          d = ls.Touch;
          break;
        case "pen":
          d = ls.Pen;
          break;
      }
      d === ls.Touch ? ei[l] === ei.MouseDown ? g = "TouchStart" : ei[l] === ei.MouseUp && (g = "TouchEnd") : ls.Pen;
    } else t5(u) && (d = ls.Touch);
    d !== null ? (a = d, (g.startsWith("Touch") && d === ls.Touch || g.startsWith("Mouse") && d === ls.Mouse) && (d = null)) : ei[l] === ei.Click && (d = a, a = null);
    const m = t5(u) ? u.changedTouches[0] : u;
    if (!m)
      return;
    const p = r.getId(f), { clientX: v, clientY: C } = m;
    wr(t)(Object.assign({ type: ei[g], id: p, x: v, y: C }, d !== null && { pointerType: d }));
  };
  return Object.keys(ei).filter((l) => Number.isNaN(Number(l)) && !l.endsWith("_Departed") && o[l] !== !1).forEach((l) => {
    let u = Yc(l);
    const f = c(l);
    if (window.PointerEvent)
      switch (ei[l]) {
        case ei.MouseDown:
        case ei.MouseUp:
          u = u.replace("mouse", "pointer");
          break;
        case ei.TouchStart:
        case ei.TouchEnd:
          return;
      }
    s.push(zA(u, f, e));
  }), wr(() => {
    s.forEach((l) => l());
  });
}
function ck({ scrollCb: t, doc: e, mirror: r, blockClass: n, blockSelector: A, sampling: i }) {
  const o = wr(f2(wr((s) => {
    const a = h1(s);
    if (!a || YA(a, n, A, !0))
      return;
    const c = r.getId(a);
    if (a === e && e.defaultView) {
      const l = JP(e.defaultView);
      t({
        id: c,
        x: l.left,
        y: l.top
      });
    } else
      t({
        id: c,
        x: a.scrollLeft,
        y: a.scrollTop
      });
  }), i.scroll || 100));
  return zA("scroll", o, e);
}
function lR({ viewportResizeCb: t }, { win: e }) {
  let r = -1, n = -1;
  const A = wr(f2(wr(() => {
    const i = _P(), o = $P();
    (r !== i || n !== o) && (t({
      width: Number(o),
      height: Number(i)
    }), r = i, n = o);
  }), 200));
  return zA("resize", A, e);
}
const uR = ["INPUT", "TEXTAREA", "SELECT"], rC = /* @__PURE__ */ new WeakMap();
function dR({ inputCb: t, doc: e, mirror: r, blockClass: n, blockSelector: A, ignoreClass: i, ignoreSelector: o, maskInputOptions: s, maskInputFn: a, sampling: c, userTriggeredOnInput: l }) {
  function u(C) {
    let w = h1(C);
    const B = C.isTrusted, y = w && w.tagName;
    if (w && y === "OPTION" && (w = w.parentElement), !w || !y || uR.indexOf(y) < 0 || YA(w, n, A, !0) || w.classList.contains(i) || o && w.matches(o))
      return;
    let b = w.value, q = !1;
    const E = vm(w) || "";
    E === "radio" || E === "checkbox" ? q = w.checked : (s[y.toLowerCase()] || s[E]) && (b = mm({
      element: w,
      maskInputOptions: s,
      tagName: y,
      type: E,
      value: b,
      maskInputFn: a
    })), f(w, l ? { text: b, isChecked: q, userTriggered: B } : { text: b, isChecked: q });
    const x = w.name;
    E === "radio" && x && q && e.querySelectorAll(`input[type="radio"][name="${x}"]`).forEach((M) => {
      if (M !== w) {
        const O = M.value;
        f(M, l ? { text: O, isChecked: !q, userTriggered: !1 } : { text: O, isChecked: !q });
      }
    });
  }
  function f(C, w) {
    const B = rC.get(C);
    if (!B || B.text !== w.text || B.isChecked !== w.isChecked) {
      rC.set(C, w);
      const y = r.getId(C);
      wr(t)(Object.assign(Object.assign({}, w), { id: y }));
    }
  }
  const g = (c.input === "last" ? ["change"] : ["input", "change"]).map((C) => zA(C, wr(u), e)), m = e.defaultView;
  if (!m)
    return () => {
      g.forEach((C) => C());
    };
  const p = m.Object.getOwnPropertyDescriptor(m.HTMLInputElement.prototype, "value"), v = [
    [m.HTMLInputElement.prototype, "value"],
    [m.HTMLInputElement.prototype, "checked"],
    [m.HTMLSelectElement.prototype, "value"],
    [m.HTMLTextAreaElement.prototype, "value"],
    [m.HTMLSelectElement.prototype, "selectedIndex"],
    [m.HTMLOptionElement.prototype, "selected"]
  ];
  return p && p.set && g.push(...v.map((C) => og(C[0], C[1], {
    set() {
      wr(u)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, m))), wr(() => {
    g.forEach((C) => C());
  });
}
function Uh(t) {
  const e = [];
  function r(n, A) {
    if (z1("CSSGroupingRule") && n.parentRule instanceof CSSGroupingRule || z1("CSSMediaRule") && n.parentRule instanceof CSSMediaRule || z1("CSSSupportsRule") && n.parentRule instanceof CSSSupportsRule || z1("CSSConditionRule") && n.parentRule instanceof CSSConditionRule) {
      const o = Array.from(n.parentRule.cssRules).indexOf(n);
      A.unshift(o);
    } else if (n.parentStyleSheet) {
      const o = Array.from(n.parentStyleSheet.cssRules).indexOf(n);
      A.unshift(o);
    }
    return A;
  }
  return r(t, e);
}
function aa(t, e, r) {
  let n, A;
  return t ? (t.ownerNode ? n = e.getId(t.ownerNode) : A = r.getId(t), {
    styleId: A,
    id: n
  }) : {};
}
function fR({ styleSheetRuleCb: t, mirror: e, stylesheetManager: r }, { win: n }) {
  if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype)
    return () => {
    };
  const A = n.CSSStyleSheet.prototype.insertRule;
  n.CSSStyleSheet.prototype.insertRule = new Proxy(A, {
    apply: wr((l, u, f) => {
      const [d, g] = f, { id: m, styleId: p } = aa(u, e, r.styleMirror);
      return (m && m !== -1 || p && p !== -1) && t({
        id: m,
        styleId: p,
        adds: [{ rule: d, index: g }]
      }), l.apply(u, f);
    })
  });
  const i = n.CSSStyleSheet.prototype.deleteRule;
  n.CSSStyleSheet.prototype.deleteRule = new Proxy(i, {
    apply: wr((l, u, f) => {
      const [d] = f, { id: g, styleId: m } = aa(u, e, r.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        removes: [{ index: d }]
      }), l.apply(u, f);
    })
  });
  let o;
  n.CSSStyleSheet.prototype.replace && (o = n.CSSStyleSheet.prototype.replace, n.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: wr((l, u, f) => {
      const [d] = f, { id: g, styleId: m } = aa(u, e, r.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        replace: d
      }), l.apply(u, f);
    })
  }));
  let s;
  n.CSSStyleSheet.prototype.replaceSync && (s = n.CSSStyleSheet.prototype.replaceSync, n.CSSStyleSheet.prototype.replaceSync = new Proxy(s, {
    apply: wr((l, u, f) => {
      const [d] = f, { id: g, styleId: m } = aa(u, e, r.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        replaceSync: d
      }), l.apply(u, f);
    })
  }));
  const a = {};
  Y1("CSSGroupingRule") ? a.CSSGroupingRule = n.CSSGroupingRule : (Y1("CSSMediaRule") && (a.CSSMediaRule = n.CSSMediaRule), Y1("CSSConditionRule") && (a.CSSConditionRule = n.CSSConditionRule), Y1("CSSSupportsRule") && (a.CSSSupportsRule = n.CSSSupportsRule));
  const c = {};
  return Object.entries(a).forEach(([l, u]) => {
    c[l] = {
      insertRule: u.prototype.insertRule,
      deleteRule: u.prototype.deleteRule
    }, u.prototype.insertRule = new Proxy(c[l].insertRule, {
      apply: wr((f, d, g) => {
        const [m, p] = g, { id: v, styleId: C } = aa(d.parentStyleSheet, e, r.styleMirror);
        return (v && v !== -1 || C && C !== -1) && t({
          id: v,
          styleId: C,
          adds: [
            {
              rule: m,
              index: [
                ...Uh(d),
                p || 0
              ]
            }
          ]
        }), f.apply(d, g);
      })
    }), u.prototype.deleteRule = new Proxy(c[l].deleteRule, {
      apply: wr((f, d, g) => {
        const [m] = g, { id: p, styleId: v } = aa(d.parentStyleSheet, e, r.styleMirror);
        return (p && p !== -1 || v && v !== -1) && t({
          id: p,
          styleId: v,
          removes: [
            { index: [...Uh(d), m] }
          ]
        }), f.apply(d, g);
      })
    });
  }), wr(() => {
    n.CSSStyleSheet.prototype.insertRule = A, n.CSSStyleSheet.prototype.deleteRule = i, o && (n.CSSStyleSheet.prototype.replace = o), s && (n.CSSStyleSheet.prototype.replaceSync = s), Object.entries(a).forEach(([l, u]) => {
      u.prototype.insertRule = c[l].insertRule, u.prototype.deleteRule = c[l].deleteRule;
    });
  });
}
function lk({ mirror: t, stylesheetManager: e }, r) {
  var n, A, i;
  let o = null;
  r.nodeName === "#document" ? o = t.getId(r) : o = t.getId(r.host);
  const s = r.nodeName === "#document" ? (n = r.defaultView) === null || n === void 0 ? void 0 : n.Document : (i = (A = r.ownerDocument) === null || A === void 0 ? void 0 : A.defaultView) === null || i === void 0 ? void 0 : i.ShadowRoot, a = s != null && s.prototype ? Object.getOwnPropertyDescriptor(s == null ? void 0 : s.prototype, "adoptedStyleSheets") : void 0;
  return o === null || o === -1 || !s || !a ? () => {
  } : (Object.defineProperty(r, "adoptedStyleSheets", {
    configurable: a.configurable,
    enumerable: a.enumerable,
    get() {
      var c;
      return (c = a.get) === null || c === void 0 ? void 0 : c.call(this);
    },
    set(c) {
      var l;
      const u = (l = a.set) === null || l === void 0 ? void 0 : l.call(this, c);
      if (o !== null && o !== -1)
        try {
          e.adoptStyleSheets(c, o);
        } catch {
        }
      return u;
    }
  }), wr(() => {
    Object.defineProperty(r, "adoptedStyleSheets", {
      configurable: a.configurable,
      enumerable: a.enumerable,
      get: a.get,
      set: a.set
    });
  }));
}
function hR({ styleDeclarationCb: t, mirror: e, ignoreCSSAttributes: r, stylesheetManager: n }, { win: A }) {
  const i = A.CSSStyleDeclaration.prototype.setProperty;
  A.CSSStyleDeclaration.prototype.setProperty = new Proxy(i, {
    apply: wr((s, a, c) => {
      var l;
      const [u, f, d] = c;
      if (r.has(u))
        return i.apply(a, [u, f, d]);
      const { id: g, styleId: m } = aa((l = a.parentRule) === null || l === void 0 ? void 0 : l.parentStyleSheet, e, n.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        set: {
          property: u,
          value: f,
          priority: d
        },
        index: Uh(a.parentRule)
      }), s.apply(a, c);
    })
  });
  const o = A.CSSStyleDeclaration.prototype.removeProperty;
  return A.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: wr((s, a, c) => {
      var l;
      const [u] = c;
      if (r.has(u))
        return o.apply(a, [u]);
      const { id: f, styleId: d } = aa((l = a.parentRule) === null || l === void 0 ? void 0 : l.parentStyleSheet, e, n.styleMirror);
      return (f && f !== -1 || d && d !== -1) && t({
        id: f,
        styleId: d,
        remove: {
          property: u
        },
        index: Uh(a.parentRule)
      }), s.apply(a, c);
    })
  }), wr(() => {
    A.CSSStyleDeclaration.prototype.setProperty = i, A.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function pR({ mediaInteractionCb: t, blockClass: e, blockSelector: r, mirror: n, sampling: A, doc: i }) {
  const o = wr((a) => f2(wr((c) => {
    const l = h1(c);
    if (!l || YA(l, e, r, !0))
      return;
    const { currentTime: u, volume: f, muted: d, playbackRate: g, loop: m } = l;
    t({
      type: a,
      id: n.getId(l),
      currentTime: u,
      volume: f,
      muted: d,
      playbackRate: g,
      loop: m
    });
  }), A.media || 500)), s = [
    zA("play", o(0), i),
    zA("pause", o(1), i),
    zA("seeked", o(2), i),
    zA("volumechange", o(3), i),
    zA("ratechange", o(4), i)
  ];
  return wr(() => {
    s.forEach((a) => a());
  });
}
function gR({ fontCb: t, doc: e }) {
  const r = e.defaultView;
  if (!r)
    return () => {
    };
  const n = [], A = /* @__PURE__ */ new WeakMap(), i = r.FontFace;
  r.FontFace = function(a, c, l) {
    const u = new i(a, c, l);
    return A.set(u, {
      family: a,
      buffer: typeof c != "string",
      descriptors: l,
      fontSource: typeof c == "string" ? c : JSON.stringify(Array.from(new Uint8Array(c)))
    }), u;
  };
  const o = qd(e.fonts, "add", function(s) {
    return function(a) {
      return setTimeout(wr(() => {
        const c = A.get(a);
        c && (t(c), A.delete(a));
      }), 0), s.apply(this, [a]);
    };
  });
  return n.push(() => {
    r.FontFace = i;
  }), n.push(o), wr(() => {
    n.forEach((s) => s());
  });
}
function mR(t) {
  const { doc: e, mirror: r, blockClass: n, blockSelector: A, selectionCb: i } = t;
  let o = !0;
  const s = wr(() => {
    const a = e.getSelection();
    if (!a || o && (a != null && a.isCollapsed))
      return;
    o = a.isCollapsed || !1;
    const c = [], l = a.rangeCount || 0;
    for (let u = 0; u < l; u++) {
      const f = a.getRangeAt(u), { startContainer: d, startOffset: g, endContainer: m, endOffset: p } = f;
      YA(d, n, A, !0) || YA(m, n, A, !0) || c.push({
        start: r.getId(d),
        startOffset: g,
        end: r.getId(m),
        endOffset: p
      });
    }
    i({ ranges: c });
  });
  return s(), zA("selectionchange", s);
}
function vR({ doc: t, customElementCb: e }) {
  const r = t.defaultView;
  return !r || !r.customElements ? () => {
  } : qd(r.customElements, "define", function(A) {
    return function(i, o, s) {
      try {
        e({
          define: {
            name: i
          }
        });
      } catch {
        console.warn(`Custom element callback failed for ${i}`);
      }
      return A.apply(this, [i, o, s]);
    };
  });
}
function qR(t, e) {
  const { mutationCb: r, mousemoveCb: n, mouseInteractionCb: A, scrollCb: i, viewportResizeCb: o, inputCb: s, mediaInteractionCb: a, styleSheetRuleCb: c, styleDeclarationCb: l, canvasMutationCb: u, fontCb: f, selectionCb: d, customElementCb: g } = t;
  t.mutationCb = (...m) => {
    e.mutation && e.mutation(...m), r(...m);
  }, t.mousemoveCb = (...m) => {
    e.mousemove && e.mousemove(...m), n(...m);
  }, t.mouseInteractionCb = (...m) => {
    e.mouseInteraction && e.mouseInteraction(...m), A(...m);
  }, t.scrollCb = (...m) => {
    e.scroll && e.scroll(...m), i(...m);
  }, t.viewportResizeCb = (...m) => {
    e.viewportResize && e.viewportResize(...m), o(...m);
  }, t.inputCb = (...m) => {
    e.input && e.input(...m), s(...m);
  }, t.mediaInteractionCb = (...m) => {
    e.mediaInteaction && e.mediaInteaction(...m), a(...m);
  }, t.styleSheetRuleCb = (...m) => {
    e.styleSheetRule && e.styleSheetRule(...m), c(...m);
  }, t.styleDeclarationCb = (...m) => {
    e.styleDeclaration && e.styleDeclaration(...m), l(...m);
  }, t.canvasMutationCb = (...m) => {
    e.canvasMutation && e.canvasMutation(...m), u(...m);
  }, t.fontCb = (...m) => {
    e.font && e.font(...m), f(...m);
  }, t.selectionCb = (...m) => {
    e.selection && e.selection(...m), d(...m);
  }, t.customElementCb = (...m) => {
    e.customElement && e.customElement(...m), g(...m);
  };
}
function yR(t, e = {}) {
  const r = t.doc.defaultView;
  if (!r)
    return () => {
    };
  qR(t, e);
  let n;
  t.recordDOM && (n = ak(t, t.doc));
  const A = aR(t), i = cR(t), o = ck(t), s = lR(t, {
    win: r
  }), a = dR(t), c = pR(t);
  let l = () => {
  }, u = () => {
  }, f = () => {
  }, d = () => {
  };
  t.recordDOM && (l = fR(t, { win: r }), u = lk(t, t.doc), f = hR(t, {
    win: r
  }), t.collectFonts && (d = gR(t)));
  const g = mR(t), m = vR(t), p = [];
  for (const v of t.plugins)
    p.push(v.observer(v.callback, r, v.options));
  return wr(() => {
    qc.forEach((v) => v.reset()), n == null || n.disconnect(), A(), i(), o(), s(), a(), c(), l(), u(), f(), d(), g(), m(), p.forEach((v) => v());
  });
}
function z1(t) {
  return typeof window[t] < "u";
}
function Y1(t) {
  return !!(typeof window[t] < "u" && window[t].prototype && "insertRule" in window[t].prototype && "deleteRule" in window[t].prototype);
}
let nC = class {
  constructor(e) {
    this.generateIdFn = e, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(e, r, n, A) {
    const i = n || this.getIdToRemoteIdMap(e), o = A || this.getRemoteIdToIdMap(e);
    let s = i.get(r);
    return s || (s = this.generateIdFn(), i.set(r, s), o.set(s, r)), s;
  }
  getIds(e, r) {
    const n = this.getIdToRemoteIdMap(e), A = this.getRemoteIdToIdMap(e);
    return r.map((i) => this.getId(e, i, n, A));
  }
  getRemoteId(e, r, n) {
    const A = n || this.getRemoteIdToIdMap(e);
    if (typeof r != "number")
      return r;
    const i = A.get(r);
    return i || -1;
  }
  getRemoteIds(e, r) {
    const n = this.getRemoteIdToIdMap(e);
    return r.map((A) => this.getRemoteId(e, A, n));
  }
  reset(e) {
    if (!e) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
  }
  getIdToRemoteIdMap(e) {
    let r = this.iframeIdToRemoteIdMap.get(e);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, r)), r;
  }
  getRemoteIdToIdMap(e) {
    let r = this.iframeRemoteIdToIdMap.get(e);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, r)), r;
  }
}, CR = class {
  constructor(e) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new nC(WP), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new nC(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(e) {
    this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
  }
  addLoadListener(e) {
    this.loadListener = e;
  }
  attachIframe(e, r) {
    var n;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(e),
          nextId: null,
          node: r
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), (n = this.loadListener) === null || n === void 0 || n.call(this, e), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(e.contentDocument.adoptedStyleSheets, this.mirror.getId(e.contentDocument));
  }
  handleMessage(e) {
    const r = e;
    if (r.data.type !== "rrweb" || r.origin !== r.data.origin || !e.source)
      return;
    const A = this.crossOriginIframeMap.get(e.source);
    if (!A)
      return;
    const i = this.transformCrossOriginEvent(A, r.data.event);
    i && this.wrappedEmit(i, r.data.isCheckout);
  }
  transformCrossOriginEvent(e, r) {
    var n;
    switch (r.type) {
      case xr.FullSnapshot: {
        this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(r.data.node, e);
        const A = r.data.node.id;
        return this.crossOriginIframeRootIdMap.set(e, A), this.patchRootIdOnNode(r.data.node, A), {
          timestamp: r.timestamp,
          type: xr.IncrementalSnapshot,
          data: {
            source: vr.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(e),
                nextId: null,
                node: r.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case xr.Meta:
      case xr.Load:
      case xr.DomContentLoaded:
        return !1;
      case xr.Plugin:
        return r;
      case xr.Custom:
        return this.replaceIds(r.data.payload, e, ["id", "parentId", "previousId", "nextId"]), r;
      case xr.IncrementalSnapshot:
        switch (r.data.source) {
          case vr.Mutation:
            return r.data.adds.forEach((A) => {
              this.replaceIds(A, e, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(A.node, e);
              const i = this.crossOriginIframeRootIdMap.get(e);
              i && this.patchRootIdOnNode(A.node, i);
            }), r.data.removes.forEach((A) => {
              this.replaceIds(A, e, ["parentId", "id"]);
            }), r.data.attributes.forEach((A) => {
              this.replaceIds(A, e, ["id"]);
            }), r.data.texts.forEach((A) => {
              this.replaceIds(A, e, ["id"]);
            }), r;
          case vr.Drag:
          case vr.TouchMove:
          case vr.MouseMove:
            return r.data.positions.forEach((A) => {
              this.replaceIds(A, e, ["id"]);
            }), r;
          case vr.ViewportResize:
            return !1;
          case vr.MediaInteraction:
          case vr.MouseInteraction:
          case vr.Scroll:
          case vr.CanvasMutation:
          case vr.Input:
            return this.replaceIds(r.data, e, ["id"]), r;
          case vr.StyleSheetRule:
          case vr.StyleDeclaration:
            return this.replaceIds(r.data, e, ["id"]), this.replaceStyleIds(r.data, e, ["styleId"]), r;
          case vr.Font:
            return r;
          case vr.Selection:
            return r.data.ranges.forEach((A) => {
              this.replaceIds(A, e, ["start", "end"]);
            }), r;
          case vr.AdoptedStyleSheet:
            return this.replaceIds(r.data, e, ["id"]), this.replaceStyleIds(r.data, e, ["styleIds"]), (n = r.data.styles) === null || n === void 0 || n.forEach((A) => {
              this.replaceStyleIds(A, e, ["styleId"]);
            }), r;
        }
    }
    return !1;
  }
  replace(e, r, n, A) {
    for (const i of A)
      !Array.isArray(r[i]) && typeof r[i] != "number" || (Array.isArray(r[i]) ? r[i] = e.getIds(n, r[i]) : r[i] = e.getId(n, r[i]));
    return r;
  }
  replaceIds(e, r, n) {
    return this.replace(this.crossOriginIframeMirror, e, r, n);
  }
  replaceStyleIds(e, r, n) {
    return this.replace(this.crossOriginIframeStyleMirror, e, r, n);
  }
  replaceIdOnNode(e, r) {
    this.replaceIds(e, r, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((n) => {
      this.replaceIdOnNode(n, r);
    });
  }
  patchRootIdOnNode(e, r) {
    e.type !== jn.Document && !e.rootId && (e.rootId = r), "childNodes" in e && e.childNodes.forEach((n) => {
      this.patchRootIdOnNode(n, r);
    });
  }
}, wR = class {
  constructor(e) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(e, r) {
    if (!L0(e) || this.shadowDoms.has(e))
      return;
    this.shadowDoms.add(e);
    const n = ak(Object.assign(Object.assign({}, this.bypassOptions), { doc: r, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), e);
    this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(ck(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: e, mirror: this.mirror }))), setTimeout(() => {
      e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(e.adoptedStyleSheets, this.mirror.getId(e.host)), this.restoreHandlers.push(lk({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, e));
    }, 0);
  }
  observeAttachShadow(e) {
    !e.contentWindow || !e.contentDocument || this.patchAttachShadow(e.contentWindow.Element, e.contentDocument);
  }
  patchAttachShadow(e, r) {
    const n = this;
    this.restoreHandlers.push(qd(e.prototype, "attachShadow", function(A) {
      return function(i) {
        const o = A.call(this, i);
        return this.shadowRoot && ik(this) && n.addShadowRoot(this.shadowRoot, r), o;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((e) => {
      try {
        e();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function bR(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var A = 0, n = Object.getOwnPropertySymbols(t); A < n.length; A++)
      e.indexOf(n[A]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[A]) && (r[n[A]] = t[n[A]]);
  return r;
}
function BR(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, [])).next());
  });
}
var Ll = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ER = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var V1 = 0; V1 < Ll.length; V1++)
  ER[Ll.charCodeAt(V1)] = V1;
var xR = function(t) {
  var e = new Uint8Array(t), r, n = e.length, A = "";
  for (r = 0; r < n; r += 3)
    A += Ll[e[r] >> 2], A += Ll[(e[r] & 3) << 4 | e[r + 1] >> 4], A += Ll[(e[r + 1] & 15) << 2 | e[r + 2] >> 6], A += Ll[e[r + 2] & 63];
  return n % 3 === 2 ? A = A.substring(0, A.length - 1) + "=" : n % 3 === 1 && (A = A.substring(0, A.length - 2) + "=="), A;
};
const AC = /* @__PURE__ */ new Map();
function IR(t, e) {
  let r = AC.get(t);
  return r || (r = /* @__PURE__ */ new Map(), AC.set(t, r)), r.has(e) || r.set(e, []), r.get(e);
}
const uk = (t, e, r) => {
  if (!t || !(fk(t, e) || typeof t == "object"))
    return;
  const n = t.constructor.name, A = IR(r, n);
  let i = A.indexOf(t);
  return i === -1 && (i = A.length, A.push(t)), i;
};
function uh(t, e, r) {
  if (t instanceof Array)
    return t.map((n) => uh(n, e, r));
  if (t === null)
    return t;
  if (t instanceof Float32Array || t instanceof Float64Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Uint8Array || t instanceof Uint16Array || t instanceof Int16Array || t instanceof Int8Array || t instanceof Uint8ClampedArray)
    return {
      rr_type: t.constructor.name,
      args: [Object.values(t)]
    };
  if (t instanceof ArrayBuffer) {
    const n = t.constructor.name, A = xR(t);
    return {
      rr_type: n,
      base64: A
    };
  } else {
    if (t instanceof DataView)
      return {
        rr_type: t.constructor.name,
        args: [
          uh(t.buffer, e, r),
          t.byteOffset,
          t.byteLength
        ]
      };
    if (t instanceof HTMLImageElement) {
      const n = t.constructor.name, { src: A } = t;
      return {
        rr_type: n,
        src: A
      };
    } else if (t instanceof HTMLCanvasElement) {
      const n = "HTMLImageElement", A = t.toDataURL();
      return {
        rr_type: n,
        src: A
      };
    } else {
      if (t instanceof ImageData)
        return {
          rr_type: t.constructor.name,
          args: [uh(t.data, e, r), t.width, t.height]
        };
      if (fk(t, e) || typeof t == "object") {
        const n = t.constructor.name, A = uk(t, e, r);
        return {
          rr_type: n,
          index: A
        };
      }
    }
  }
  return t;
}
const dk = (t, e, r) => t.map((n) => uh(n, e, r)), fk = (t, e) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  "WebGLVertexArrayObjectOES"
].filter((A) => typeof e[A] == "function").find((A) => t instanceof e[A]);
function SR(t, e, r, n) {
  const A = [], i = Object.getOwnPropertyNames(e.CanvasRenderingContext2D.prototype);
  for (const o of i)
    try {
      if (typeof e.CanvasRenderingContext2D.prototype[o] != "function")
        continue;
      const s = qd(e.CanvasRenderingContext2D.prototype, o, function(a) {
        return function(...c) {
          return YA(this.canvas, r, n, !0) || setTimeout(() => {
            const l = dk(c, e, this);
            t(this.canvas, {
              type: qu["2D"],
              property: o,
              args: l
            });
          }, 0), a.apply(this, c);
        };
      });
      A.push(s);
    } catch {
      const a = og(e.CanvasRenderingContext2D.prototype, o, {
        set(c) {
          t(this.canvas, {
            type: qu["2D"],
            property: o,
            args: [c],
            setter: !0
          });
        }
      });
      A.push(a);
    }
  return () => {
    A.forEach((o) => o());
  };
}
function PR(t) {
  return t === "experimental-webgl" ? "webgl" : t;
}
function iC(t, e, r, n) {
  const A = [];
  try {
    const i = qd(t.HTMLCanvasElement.prototype, "getContext", function(o) {
      return function(s, ...a) {
        if (!YA(this, e, r, !0)) {
          const c = PR(s);
          if ("__context" in this || (this.__context = c), n && ["webgl", "webgl2"].includes(c))
            if (a[0] && typeof a[0] == "object") {
              const l = a[0];
              l.preserveDrawingBuffer || (l.preserveDrawingBuffer = !0);
            } else
              a.splice(0, 1, {
                preserveDrawingBuffer: !0
              });
        }
        return o.apply(this, [s, ...a]);
      };
    });
    A.push(i);
  } catch {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    A.forEach((i) => i());
  };
}
function oC(t, e, r, n, A, i, o) {
  const s = [], a = Object.getOwnPropertyNames(t);
  for (const c of a)
    if (![
      "isContextLost",
      "canvas",
      "drawingBufferWidth",
      "drawingBufferHeight"
    ].includes(c))
      try {
        if (typeof t[c] != "function")
          continue;
        const l = qd(t, c, function(u) {
          return function(...f) {
            const d = u.apply(this, f);
            if (uk(d, o, this), "tagName" in this.canvas && !YA(this.canvas, n, A, !0)) {
              const g = dk(f, o, this), m = {
                type: e,
                property: c,
                args: g
              };
              r(this.canvas, m);
            }
            return d;
          };
        });
        s.push(l);
      } catch {
        const u = og(t, c, {
          set(f) {
            r(this.canvas, {
              type: e,
              property: c,
              args: [f],
              setter: !0
            });
          }
        });
        s.push(u);
      }
  return s;
}
function kR(t, e, r, n, A) {
  const i = [];
  return i.push(...oC(e.WebGLRenderingContext.prototype, qu.WebGL, t, r, n, A, e)), typeof e.WebGL2RenderingContext < "u" && i.push(...oC(e.WebGL2RenderingContext.prototype, qu.WebGL2, t, r, n, A, e)), () => {
    i.forEach((o) => o());
  };
}
function OR(t, e) {
  var r = t.toString(), n = r.split(`
`);
  n.pop(), n.shift();
  for (var A = n[0].search(/\S/), i = /(['"])__worker_loader_strict__(['"])/g, o = 0, s = n.length; o < s; ++o)
    n[o] = n[o].substring(A).replace(i, "$1use strict$2") + `
`;
  return n;
}
function FR(t, e) {
  var r = OR(t), n = new Blob(r, { type: "application/javascript" });
  return URL.createObjectURL(n);
}
function TR(t, e) {
  var r;
  return function(A) {
    return r = r || FR(t), new Worker(r, A);
  };
}
var MR = TR(
  /* rollup-plugin-web-worker-loader */
  function() {
    (function() {
      "__worker_loader_strict__";
      /*! *****************************************************************************
          Copyright (c) Microsoft Corporation.
      
          Permission to use, copy, modify, and/or distribute this software for any
          purpose with or without fee is hereby granted.
      
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
          REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
          AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
          INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
          LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
          OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
          PERFORMANCE OF THIS SOFTWARE.
          ***************************************************************************** */
      function t(c, l, u, f) {
        function d(g) {
          return g instanceof u ? g : new u(function(m) {
            m(g);
          });
        }
        return new (u || (u = Promise))(function(g, m) {
          function p(w) {
            try {
              C(f.next(w));
            } catch (B) {
              m(B);
            }
          }
          function v(w) {
            try {
              C(f.throw(w));
            } catch (B) {
              m(B);
            }
          }
          function C(w) {
            w.done ? g(w.value) : d(w.value).then(p, v);
          }
          C((f = f.apply(c, [])).next());
        });
      }
      for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = typeof Uint8Array > "u" ? [] : new Uint8Array(256), n = 0; n < e.length; n++)
        r[e.charCodeAt(n)] = n;
      var A = function(c) {
        var l = new Uint8Array(c), u, f = l.length, d = "";
        for (u = 0; u < f; u += 3)
          d += e[l[u] >> 2], d += e[(l[u] & 3) << 4 | l[u + 1] >> 4], d += e[(l[u + 1] & 15) << 2 | l[u + 2] >> 6], d += e[l[u + 2] & 63];
        return f % 3 === 2 ? d = d.substring(0, d.length - 1) + "=" : f % 3 === 1 && (d = d.substring(0, d.length - 2) + "=="), d;
      };
      const i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      function s(c, l, u) {
        return t(this, void 0, void 0, function* () {
          const f = `${c}-${l}`;
          if ("OffscreenCanvas" in globalThis) {
            if (o.has(f))
              return o.get(f);
            const d = new OffscreenCanvas(c, l);
            d.getContext("2d");
            const m = yield (yield d.convertToBlob(u)).arrayBuffer(), p = A(m);
            return o.set(f, p), p;
          } else
            return "";
        });
      }
      const a = self;
      a.onmessage = function(c) {
        return t(this, void 0, void 0, function* () {
          if ("OffscreenCanvas" in globalThis) {
            const { id: l, bitmap: u, width: f, height: d, dataURLOptions: g } = c.data, m = s(f, d, g), p = new OffscreenCanvas(f, d);
            p.getContext("2d").drawImage(u, 0, 0), u.close();
            const C = yield p.convertToBlob(g), w = C.type, B = yield C.arrayBuffer(), y = A(B);
            if (!i.has(l) && (yield m) === y)
              return i.set(l, y), a.postMessage({ id: l });
            if (i.get(l) === y)
              return a.postMessage({ id: l });
            a.postMessage({
              id: l,
              type: w,
              base64: y,
              width: f,
              height: d
            }), i.set(l, y);
          } else
            return a.postMessage({ id: c.data.id });
        });
      };
    })();
  }
);
class HR {
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  constructor(e) {
    this.pendingCanvasMutations = /* @__PURE__ */ new Map(), this.rafStamps = { latestId: 0, invokeId: null }, this.frozen = !1, this.locked = !1, this.processMutation = (a, c) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(a) || this.pendingCanvasMutations.set(a, []), this.pendingCanvasMutations.get(a).push(c);
    };
    const { sampling: r = "all", win: n, blockClass: A, blockSelector: i, recordCanvas: o, dataURLOptions: s } = e;
    this.mutationCb = e.mutationCb, this.mirror = e.mirror, o && r === "all" && this.initCanvasMutationObserver(n, A, i), o && typeof r == "number" && this.initCanvasFPSObserver(r, n, A, i, {
      dataURLOptions: s
    });
  }
  initCanvasFPSObserver(e, r, n, A, i) {
    const o = iC(r, n, A, !0), s = /* @__PURE__ */ new Map(), a = new MR();
    a.onmessage = (g) => {
      const { id: m } = g.data;
      if (s.set(m, !1), !("base64" in g.data))
        return;
      const { base64: p, type: v, width: C, height: w } = g.data;
      this.mutationCb({
        id: m,
        type: qu["2D"],
        commands: [
          {
            property: "clearRect",
            args: [0, 0, C, w]
          },
          {
            property: "drawImage",
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: p }],
                    type: v
                  }
                ]
              },
              0,
              0
            ]
          }
        ]
      });
    };
    const c = 1e3 / e;
    let l = 0, u;
    const f = () => {
      const g = [];
      return r.document.querySelectorAll("canvas").forEach((m) => {
        YA(m, n, A, !0) || g.push(m);
      }), g;
    }, d = (g) => {
      if (l && g - l < c) {
        u = requestAnimationFrame(d);
        return;
      }
      l = g, f().forEach((m) => BR(this, void 0, void 0, function* () {
        var p;
        const v = this.mirror.getId(m);
        if (s.get(v) || m.width === 0 || m.height === 0)
          return;
        if (s.set(v, !0), ["webgl", "webgl2"].includes(m.__context)) {
          const w = m.getContext(m.__context);
          ((p = w == null ? void 0 : w.getContextAttributes()) === null || p === void 0 ? void 0 : p.preserveDrawingBuffer) === !1 && w.clear(w.COLOR_BUFFER_BIT);
        }
        const C = yield createImageBitmap(m);
        a.postMessage({
          id: v,
          bitmap: C,
          width: m.width,
          height: m.height,
          dataURLOptions: i.dataURLOptions
        }, [C]);
      })), u = requestAnimationFrame(d);
    };
    u = requestAnimationFrame(d), this.resetObservers = () => {
      o(), cancelAnimationFrame(u);
    };
  }
  initCanvasMutationObserver(e, r, n) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const A = iC(e, r, n, !1), i = SR(this.processMutation.bind(this), e, r, n), o = kR(this.processMutation.bind(this), e, r, n, this.mirror);
    this.resetObservers = () => {
      A(), i(), o();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const e = (r) => {
      this.rafStamps.latestId = r, requestAnimationFrame(e);
    };
    requestAnimationFrame(e);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach((e, r) => {
      const n = this.mirror.getId(r);
      this.flushPendingCanvasMutationFor(r, n);
    }), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(e, r) {
    if (this.frozen || this.locked)
      return;
    const n = this.pendingCanvasMutations.get(e);
    if (!n || r === -1)
      return;
    const A = n.map((o) => bR(o, ["type"])), { type: i } = n[0];
    this.mutationCb({ id: r, type: i, commands: A }), this.pendingCanvasMutations.delete(e);
  }
}
let DR = class {
  constructor(e) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new tR(), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
  }
  attachLinkElement(e, r) {
    "_cssText" in r.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: r.id,
          attributes: r.attributes
        }
      ]
    }), this.trackLinkElement(e);
  }
  trackLinkElement(e) {
    this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
  }
  adoptStyleSheets(e, r) {
    if (e.length === 0)
      return;
    const n = {
      id: r,
      styleIds: []
    }, A = [];
    for (const i of e) {
      let o;
      this.styleMirror.has(i) ? o = this.styleMirror.getId(i) : (o = this.styleMirror.add(i), A.push({
        styleId: o,
        rules: Array.from(i.rules || CSSRule, (s, a) => ({
          rule: zP(s),
          index: a
        }))
      })), n.styleIds.push(o);
    }
    A.length > 0 && (n.styles = A), this.adoptedStyleSheetCb(n);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(e) {
  }
}, QR = class {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
  }
  periodicallyClear() {
    requestAnimationFrame(() => {
      this.clear(), this.loop && this.periodicallyClear();
    });
  }
  inOtherBuffer(e, r) {
    const n = this.nodeMap.get(e);
    return n && Array.from(n).some((A) => A !== r);
  }
  add(e, r) {
    this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(r));
  }
  clear() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
  }
  destroy() {
    this.loop = !1;
  }
};
function Dn(t) {
  return Object.assign(Object.assign({}, t), { timestamp: Qh() });
}
let mn, dh, p9, Nh = !1;
const $i = kG();
function p1(t = {}) {
  const { emit: e, checkoutEveryNms: r, checkoutEveryNth: n, blockClass: A = "rr-block", blockSelector: i = null, ignoreClass: o = "rr-ignore", ignoreSelector: s = null, maskTextClass: a = "rr-mask", maskTextSelector: c = null, inlineStylesheet: l = !0, maskAllInputs: u, maskInputOptions: f, slimDOMOptions: d, maskInputFn: g, maskTextFn: m, hooks: p, packFn: v, sampling: C = {}, dataURLOptions: w = {}, mousemoveWait: B, recordDOM: y = !0, recordCanvas: b = !1, recordCrossOriginIframes: q = !1, recordAfter: E = t.recordAfter === "DOMContentLoaded" ? t.recordAfter : "load", userTriggeredOnInput: x = !1, collectFonts: M = !1, inlineImages: O = !1, plugins: I, keepIframeSrcFn: S = () => !1, ignoreCSSAttributes: P = /* @__PURE__ */ new Set([]), errorHandler: H } = t;
  oR(H);
  const F = q ? window.parent === window : !0;
  let T = !1;
  if (!F)
    try {
      window.parent.document && (T = !1);
    } catch {
      T = !0;
    }
  if (F && !e)
    throw new Error("emit function is required");
  B !== void 0 && C.mousemove === void 0 && (C.mousemove = B), $i.reset();
  const U = u === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : f !== void 0 ? f : { password: !0 }, D = d === !0 || d === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: d === "all",
    headMetaDescKeywords: d === "all"
  } : d || {};
  eR();
  let Q, Y = 0;
  const j = (J) => {
    for (const X of I || [])
      X.eventProcessor && (J = X.eventProcessor(J));
    return v && !T && (J = v(J)), J;
  };
  mn = (J, X) => {
    var ne;
    if (!((ne = qc[0]) === null || ne === void 0) && ne.isFrozen() && J.type !== xr.FullSnapshot && !(J.type === xr.IncrementalSnapshot && J.data.source === vr.Mutation) && qc.forEach((ee) => ee.unfreeze()), F)
      e == null || e(j(J), X);
    else if (T) {
      const ee = {
        type: "rrweb",
        event: j(J),
        origin: window.location.origin,
        isCheckout: X
      };
      window.parent.postMessage(ee, "*");
    }
    if (J.type === xr.FullSnapshot)
      Q = J, Y = 0;
    else if (J.type === xr.IncrementalSnapshot) {
      if (J.data.source === vr.Mutation && J.data.isAttachIframe)
        return;
      Y++;
      const ee = n && Y >= n, $ = r && J.timestamp - Q.timestamp > r;
      (ee || $) && dh(!0);
    }
  };
  const Z = (J) => {
    mn(Dn({
      type: xr.IncrementalSnapshot,
      data: Object.assign({ source: vr.Mutation }, J)
    }));
  }, W = (J) => mn(Dn({
    type: xr.IncrementalSnapshot,
    data: Object.assign({ source: vr.Scroll }, J)
  })), R = (J) => mn(Dn({
    type: xr.IncrementalSnapshot,
    data: Object.assign({ source: vr.CanvasMutation }, J)
  })), K = (J) => mn(Dn({
    type: xr.IncrementalSnapshot,
    data: Object.assign({ source: vr.AdoptedStyleSheet }, J)
  })), L = new DR({
    mutationCb: Z,
    adoptedStyleSheetCb: K
  }), G = new CR({
    mirror: $i,
    mutationCb: Z,
    stylesheetManager: L,
    recordCrossOriginIframes: q,
    wrappedEmit: mn
  });
  for (const J of I || [])
    J.getMirror && J.getMirror({
      nodeMirror: $i,
      crossOriginIframeMirror: G.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: G.crossOriginIframeStyleMirror
    });
  const V = new QR();
  p9 = new HR({
    recordCanvas: b,
    mutationCb: R,
    win: window,
    blockClass: A,
    blockSelector: i,
    mirror: $i,
    sampling: C.canvas,
    dataURLOptions: w
  });
  const _ = new wR({
    mutationCb: Z,
    scrollCb: W,
    bypassOptions: {
      blockClass: A,
      blockSelector: i,
      maskTextClass: a,
      maskTextSelector: c,
      inlineStylesheet: l,
      maskInputOptions: U,
      dataURLOptions: w,
      maskTextFn: m,
      maskInputFn: g,
      recordCanvas: b,
      inlineImages: O,
      sampling: C,
      slimDOMOptions: D,
      iframeManager: G,
      stylesheetManager: L,
      canvasManager: p9,
      keepIframeSrcFn: S,
      processedNodeManager: V
    },
    mirror: $i
  });
  dh = (J = !1) => {
    if (!y)
      return;
    mn(Dn({
      type: xr.Meta,
      data: {
        href: window.location.href,
        width: $P(),
        height: _P()
      }
    }), J), L.reset(), _.init(), qc.forEach((ne) => ne.lock());
    const X = _G(document, {
      mirror: $i,
      blockClass: A,
      blockSelector: i,
      maskTextClass: a,
      maskTextSelector: c,
      inlineStylesheet: l,
      maskAllInputs: U,
      maskTextFn: m,
      slimDOM: D,
      dataURLOptions: w,
      recordCanvas: b,
      inlineImages: O,
      onSerialize: (ne) => {
        rk(ne, $i) && G.addIframe(ne), nk(ne, $i) && L.trackLinkElement(ne), r5(ne) && _.addShadowRoot(ne.shadowRoot, document);
      },
      onIframeLoad: (ne, ee) => {
        G.attachIframe(ne, ee), _.observeAttachShadow(ne);
      },
      onStylesheetLoad: (ne, ee) => {
        L.attachLinkElement(ne, ee);
      },
      keepIframeSrcFn: S
    });
    if (!X)
      return console.warn("Failed to snapshot the document");
    mn(Dn({
      type: xr.FullSnapshot,
      data: {
        node: X,
        initialOffset: JP(window)
      }
    }), J), qc.forEach((ne) => ne.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && L.adoptStyleSheets(document.adoptedStyleSheets, $i.getId(document));
  };
  try {
    const J = [], X = (ee) => {
      var $;
      return wr(yR)({
        mutationCb: Z,
        mousemoveCb: (te, ae) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: {
            source: ae,
            positions: te
          }
        })),
        mouseInteractionCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.MouseInteraction }, te)
        })),
        scrollCb: W,
        viewportResizeCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.ViewportResize }, te)
        })),
        inputCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.Input }, te)
        })),
        mediaInteractionCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.MediaInteraction }, te)
        })),
        styleSheetRuleCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.StyleSheetRule }, te)
        })),
        styleDeclarationCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.StyleDeclaration }, te)
        })),
        canvasMutationCb: R,
        fontCb: (te) => mn(Dn({
          type: xr.IncrementalSnapshot,
          data: Object.assign({ source: vr.Font }, te)
        })),
        selectionCb: (te) => {
          mn(Dn({
            type: xr.IncrementalSnapshot,
            data: Object.assign({ source: vr.Selection }, te)
          }));
        },
        customElementCb: (te) => {
          mn(Dn({
            type: xr.IncrementalSnapshot,
            data: Object.assign({ source: vr.CustomElement }, te)
          }));
        },
        blockClass: A,
        ignoreClass: o,
        ignoreSelector: s,
        maskTextClass: a,
        maskTextSelector: c,
        maskInputOptions: U,
        inlineStylesheet: l,
        sampling: C,
        recordDOM: y,
        recordCanvas: b,
        inlineImages: O,
        userTriggeredOnInput: x,
        collectFonts: M,
        doc: ee,
        maskInputFn: g,
        maskTextFn: m,
        keepIframeSrcFn: S,
        blockSelector: i,
        slimDOMOptions: D,
        dataURLOptions: w,
        mirror: $i,
        iframeManager: G,
        stylesheetManager: L,
        shadowDomManager: _,
        processedNodeManager: V,
        canvasManager: p9,
        ignoreCSSAttributes: P,
        plugins: (($ = I == null ? void 0 : I.filter((te) => te.observer)) === null || $ === void 0 ? void 0 : $.map((te) => ({
          observer: te.observer,
          options: te.options,
          callback: (ae) => mn(Dn({
            type: xr.Plugin,
            data: {
              plugin: te.name,
              payload: ae
            }
          }))
        }))) || []
      }, p);
    };
    G.addLoadListener((ee) => {
      try {
        J.push(X(ee.contentDocument));
      } catch ($) {
        console.warn($);
      }
    });
    const ne = () => {
      dh(), J.push(X(document)), Nh = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? ne() : (J.push(zA("DOMContentLoaded", () => {
      mn(Dn({
        type: xr.DomContentLoaded,
        data: {}
      })), E === "DOMContentLoaded" && ne();
    })), J.push(zA("load", () => {
      mn(Dn({
        type: xr.Load,
        data: {}
      })), E === "load" && ne();
    }, window))), () => {
      J.forEach((ee) => ee()), V.destroy(), Nh = !1, sR();
    };
  } catch (J) {
    console.warn(J);
  }
}
p1.addCustomEvent = (t, e) => {
  if (!Nh)
    throw new Error("please add custom event after start recording");
  mn(Dn({
    type: xr.Custom,
    data: {
      tag: t,
      payload: e
    }
  }));
};
p1.freezePage = () => {
  qc.forEach((t) => t.freeze());
};
p1.takeFullSnapshot = (t) => {
  if (!Nh)
    throw new Error("please take full snapshot after start recording");
  dh(t);
};
p1.mirror = $i;
var hk = /* @__PURE__ */ ((t) => (t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))(hk || {}), To = /* @__PURE__ */ ((t) => (t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))(To || {}), fo = {
  DEBUG: !1,
  LIB_VERSION: "2.59.0"
}, wt;
if (typeof window > "u") {
  var sC = {
    hostname: ""
  };
  wt = {
    navigator: { userAgent: "", onLine: !0 },
    document: {
      createElement: function() {
        return {};
      },
      location: sC,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: sC,
    addEventListener: function() {
    },
    removeEventListener: function() {
    }
  };
} else
  wt = window;
var aC = wt.setImmediate, Ma, A5, i5, pk = Object.prototype.toString, UR = typeof aC < "u" ? function(e) {
  return aC(e);
} : setTimeout;
try {
  Object.defineProperty({}, "x", {}), Ma = function(e, r, n, A) {
    return Object.defineProperty(e, r, {
      value: n,
      writable: !0,
      configurable: A !== !1
    });
  };
} catch {
  Ma = function(r, n, A) {
    return r[n] = A, r;
  };
}
i5 = /* @__PURE__ */ function() {
  var e, r, n;
  function A(i, o) {
    this.fn = i, this.self = o, this.next = void 0;
  }
  return {
    add: function(o, s) {
      n = new A(o, s), r ? r.next = n : e = n, r = n, n = void 0;
    },
    drain: function() {
      var o = e;
      for (e = r = A5 = void 0; o; )
        o.fn.call(o.self), o = o.next;
    }
  };
}();
function jh(t, e) {
  i5.add(t, e), A5 || (A5 = UR(i5.drain));
}
function gk(t) {
  var e, r = typeof t;
  return t !== null && (r === "object" || r === "function") && (e = t.then), typeof e == "function" ? e : !1;
}
function ym() {
  for (var t = 0; t < this.chain.length; t++)
    NR(
      this,
      this.state === 1 ? this.chain[t].success : this.chain[t].failure,
      this.chain[t]
    );
  this.chain.length = 0;
}
function NR(t, e, r) {
  var n, A;
  try {
    e === !1 ? r.reject(t.msg) : (e === !0 ? n = t.msg : n = e.call(void 0, t.msg), n === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (A = gk(n)) ? A.call(n, r.resolve, r.reject) : r.resolve(n));
  } catch (i) {
    r.reject(i);
  }
}
function mk(t) {
  var e, r = this;
  if (!r.triggered) {
    r.triggered = !0, r.def && (r = r.def);
    try {
      (e = gk(t)) ? jh(function() {
        var n = new cC(r);
        try {
          e.call(
            t,
            function() {
              mk.apply(n, arguments);
            },
            function() {
              R0.apply(n, arguments);
            }
          );
        } catch (A) {
          R0.call(n, A);
        }
      }) : (r.msg = t, r.state = 1, r.chain.length > 0 && jh(ym, r));
    } catch (n) {
      R0.call(new cC(r), n);
    }
  }
}
function R0(t) {
  var e = this;
  e.triggered || (e.triggered = !0, e.def && (e = e.def), e.msg = t, e.state = 2, e.chain.length > 0 && jh(ym, e));
}
function vk(t, e, r, n) {
  for (var A = 0; A < e.length; A++)
    (function(o) {
      t.resolve(e[o]).then(
        function(a) {
          r(o, a);
        },
        n
      );
    })(A);
}
function cC(t) {
  this.def = t, this.triggered = !1;
}
function jR(t) {
  this.promise = t, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
}
function Wa(t) {
  if (typeof t != "function")
    throw TypeError("Not a function");
  if (this.__NPO__ !== 0)
    throw TypeError("Not a promise");
  this.__NPO__ = 1;
  var e = new jR(this);
  this.then = function(n, A) {
    var i = {
      success: typeof n == "function" ? n : !0,
      failure: typeof A == "function" ? A : !1
    };
    return i.promise = new this.constructor(function(s, a) {
      if (typeof s != "function" || typeof a != "function")
        throw TypeError("Not a function");
      i.resolve = s, i.reject = a;
    }), e.chain.push(i), e.state !== 0 && jh(ym, e), i.promise;
  }, this.catch = function(n) {
    return this.then(void 0, n);
  };
  try {
    t.call(
      void 0,
      function(n) {
        mk.call(e, n);
      },
      function(n) {
        R0.call(e, n);
      }
    );
  } catch (r) {
    R0.call(e, r);
  }
}
var qk = Ma(
  {},
  "constructor",
  Wa,
  /*configurable=*/
  !1
);
Wa.prototype = qk;
Ma(
  qk,
  "__NPO__",
  0,
  /*configurable=*/
  !1
);
Ma(Wa, "resolve", function(e) {
  var r = this;
  return e && typeof e == "object" && e.__NPO__ === 1 ? e : new r(function(A, i) {
    if (typeof A != "function" || typeof i != "function")
      throw TypeError("Not a function");
    A(e);
  });
});
Ma(Wa, "reject", function(e) {
  return new this(function(n, A) {
    if (typeof n != "function" || typeof A != "function")
      throw TypeError("Not a function");
    A(e);
  });
});
Ma(Wa, "all", function(e) {
  var r = this;
  return pk.call(e) !== "[object Array]" ? r.reject(TypeError("Not an array")) : e.length === 0 ? r.resolve([]) : new r(function(A, i) {
    if (typeof A != "function" || typeof i != "function")
      throw TypeError("Not a function");
    var o = e.length, s = Array(o), a = 0;
    vk(r, e, function(l, u) {
      s[l] = u, ++a === o && A(s);
    }, i);
  });
});
Ma(Wa, "race", function(e) {
  var r = this;
  return pk.call(e) !== "[object Array]" ? r.reject(TypeError("Not an array")) : new r(function(A, i) {
    if (typeof A != "function" || typeof i != "function")
      throw TypeError("Not a function");
    vk(r, e, function(s, a) {
      A(a);
    }, i);
  });
});
var bn;
typeof Promise < "u" && Promise.toString().indexOf("[native code]") !== -1 ? bn = Promise : bn = Wa;
var z0 = 24 * 60 * 60 * 1e3, g9 = 8 * 1e3, sg = Array.prototype, LR = Function.prototype, yk = Object.prototype, va = sg.slice, g1 = yk.toString, ag = yk.hasOwnProperty, Fn = wt.console, qa = wt.navigator, Nr = wt.document, W1 = wt.opera, Lh = wt.screen, Mo = qa.userAgent, m9 = LR.bind, lC = sg.forEach, uC = sg.indexOf, dC = sg.map, GR = Array.isArray, o5 = {}, z = {
  trim: function(t) {
    return t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, Sr = {
  /** @type {function(...*)} */
  log: function() {
    if (fo.DEBUG && !z.isUndefined(Fn) && Fn)
      try {
        Fn.log.apply(Fn, arguments);
      } catch {
        z.each(arguments, function(e) {
          Fn.log(e);
        });
      }
  },
  /** @type {function(...*)} */
  warn: function() {
    if (fo.DEBUG && !z.isUndefined(Fn) && Fn) {
      var t = ["Mixpanel warning:"].concat(z.toArray(arguments));
      try {
        Fn.warn.apply(Fn, t);
      } catch {
        z.each(t, function(r) {
          Fn.warn(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  error: function() {
    if (fo.DEBUG && !z.isUndefined(Fn) && Fn) {
      var t = ["Mixpanel error:"].concat(z.toArray(arguments));
      try {
        Fn.error.apply(Fn, t);
      } catch {
        z.each(t, function(r) {
          Fn.error(r);
        });
      }
    }
  },
  /** @type {function(...*)} */
  critical: function() {
    if (!z.isUndefined(Fn) && Fn) {
      var t = ["Mixpanel error:"].concat(z.toArray(arguments));
      try {
        Fn.error.apply(Fn, t);
      } catch {
        z.each(t, function(r) {
          Fn.error(r);
        });
      }
    }
  }
}, v9 = function(t, e) {
  return function() {
    return arguments[0] = "[" + e + "] " + arguments[0], t.apply(Sr, arguments);
  };
}, yd = function(t) {
  return {
    log: v9(Sr.log, t),
    error: v9(Sr.error, t),
    critical: v9(Sr.critical, t)
  };
}, Cm = function(t) {
  return function() {
    try {
      return t.apply(this, arguments);
    } catch (e) {
      Sr.critical("Implementation error. Please turn on debug and contact support@mixpanel.com."), fo.DEBUG && Sr.critical(e);
    }
  };
}, RR = function(t) {
  var e = t.prototype;
  for (var r in e)
    typeof e[r] == "function" && (e[r] = Cm(e[r]));
};
z.bind = function(t, e) {
  var r, n;
  if (m9 && t.bind === m9)
    return m9.apply(t, va.call(arguments, 1));
  if (!z.isFunction(t))
    throw new TypeError();
  return r = va.call(arguments, 2), n = function() {
    if (!(this instanceof n))
      return t.apply(e, r.concat(va.call(arguments)));
    var A = {};
    A.prototype = t.prototype;
    var i = new A();
    A.prototype = null;
    var o = t.apply(i, r.concat(va.call(arguments)));
    return Object(o) === o ? o : i;
  }, n;
};
z.each = function(t, e, r) {
  if (t != null) {
    if (lC && t.forEach === lC)
      t.forEach(e, r);
    else if (t.length === +t.length) {
      for (var n = 0, A = t.length; n < A; n++)
        if (n in t && e.call(r, t[n], n, t) === o5)
          return;
    } else
      for (var i in t)
        if (ag.call(t, i) && e.call(r, t[i], i, t) === o5)
          return;
  }
};
z.extend = function(t) {
  return z.each(va.call(arguments, 1), function(e) {
    for (var r in e)
      e[r] !== void 0 && (t[r] = e[r]);
  }), t;
};
z.isArray = GR || function(t) {
  return g1.call(t) === "[object Array]";
};
z.isFunction = function(t) {
  try {
    return /^\s*\bfunction\b/.test(t);
  } catch {
    return !1;
  }
};
z.isArguments = function(t) {
  return !!(t && ag.call(t, "callee"));
};
z.toArray = function(t) {
  return t ? t.toArray ? t.toArray() : z.isArray(t) || z.isArguments(t) ? va.call(t) : z.values(t) : [];
};
z.map = function(t, e, r) {
  if (dC && t.map === dC)
    return t.map(e, r);
  var n = [];
  return z.each(t, function(A) {
    n.push(e.call(r, A));
  }), n;
};
z.keys = function(t) {
  var e = [];
  return t === null || z.each(t, function(r, n) {
    e[e.length] = n;
  }), e;
};
z.values = function(t) {
  var e = [];
  return t === null || z.each(t, function(r) {
    e[e.length] = r;
  }), e;
};
z.include = function(t, e) {
  var r = !1;
  return t === null ? r : uC && t.indexOf === uC ? t.indexOf(e) != -1 : (z.each(t, function(n) {
    if (r || (r = n === e))
      return o5;
  }), r);
};
z.includes = function(t, e) {
  return t.indexOf(e) !== -1;
};
z.inherit = function(t, e) {
  return t.prototype = new e(), t.prototype.constructor = t, t.superclass = e.prototype, t;
};
z.isObject = function(t) {
  return t === Object(t) && !z.isArray(t);
};
z.isEmptyObject = function(t) {
  if (z.isObject(t)) {
    for (var e in t)
      if (ag.call(t, e))
        return !1;
    return !0;
  }
  return !1;
};
z.isUndefined = function(t) {
  return t === void 0;
};
z.isString = function(t) {
  return g1.call(t) == "[object String]";
};
z.isDate = function(t) {
  return g1.call(t) == "[object Date]";
};
z.isNumber = function(t) {
  return g1.call(t) == "[object Number]";
};
z.isElement = function(t) {
  return !!(t && t.nodeType === 1);
};
z.encodeDates = function(t) {
  return z.each(t, function(e, r) {
    z.isDate(e) ? t[r] = z.formatDate(e) : z.isObject(e) && (t[r] = z.encodeDates(e));
  }), t;
};
z.timestamp = function() {
  return Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, Date.now();
};
z.formatDate = function(t) {
  function e(r) {
    return r < 10 ? "0" + r : r;
  }
  return t.getUTCFullYear() + "-" + e(t.getUTCMonth() + 1) + "-" + e(t.getUTCDate()) + "T" + e(t.getUTCHours()) + ":" + e(t.getUTCMinutes()) + ":" + e(t.getUTCSeconds());
};
z.strip_empty_properties = function(t) {
  var e = {};
  return z.each(t, function(r, n) {
    z.isString(r) && r.length > 0 && (e[n] = r);
  }), e;
};
z.truncate = function(t, e) {
  var r;
  return typeof t == "string" ? r = t.slice(0, e) : z.isArray(t) ? (r = [], z.each(t, function(n) {
    r.push(z.truncate(n, e));
  })) : z.isObject(t) ? (r = {}, z.each(t, function(n, A) {
    r[A] = z.truncate(n, e);
  })) : r = t, r;
};
z.JSONEncode = /* @__PURE__ */ function() {
  return function(t) {
    var e = t, r = function(A) {
      var i = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, o = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return i.lastIndex = 0, i.test(A) ? '"' + A.replace(i, function(s) {
        var a = o[s];
        return typeof a == "string" ? a : "\\u" + ("0000" + s.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + A + '"';
    }, n = function(A, i) {
      var o = "", s = "    ", a = 0, c = "", l = "", u = 0, f = o, d = [], g = i[A];
      switch (g && typeof g == "object" && typeof g.toJSON == "function" && (g = g.toJSON(A)), typeof g) {
        case "string":
          return r(g);
        case "number":
          return isFinite(g) ? String(g) : "null";
        case "boolean":
        case "null":
          return String(g);
        case "object":
          if (!g)
            return "null";
          if (o += s, d = [], g1.apply(g) === "[object Array]") {
            for (u = g.length, a = 0; a < u; a += 1)
              d[a] = n(a, g) || "null";
            return l = d.length === 0 ? "[]" : o ? `[
` + o + d.join(`,
` + o) + `
` + f + "]" : "[" + d.join(",") + "]", o = f, l;
          }
          for (c in g)
            ag.call(g, c) && (l = n(c, g), l && d.push(r(c) + (o ? ": " : ":") + l));
          return l = d.length === 0 ? "{}" : o ? "{" + d.join(",") + f + "}" : "{" + d.join(",") + "}", o = f, l;
      }
    };
    return n("", {
      "": e
    });
  };
}();
z.JSONDecode = function() {
  var t, e, r = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, n, A = function(d) {
    var g = new SyntaxError(d);
    throw g.at = t, g.text = n, g;
  }, i = function(d) {
    return d && d !== e && A("Expected '" + d + "' instead of '" + e + "'"), e = n.charAt(t), t += 1, e;
  }, o = function() {
    var d, g = "";
    for (e === "-" && (g = "-", i("-")); e >= "0" && e <= "9"; )
      g += e, i();
    if (e === ".")
      for (g += "."; i() && e >= "0" && e <= "9"; )
        g += e;
    if (e === "e" || e === "E")
      for (g += e, i(), (e === "-" || e === "+") && (g += e, i()); e >= "0" && e <= "9"; )
        g += e, i();
    if (d = +g, !isFinite(d))
      A("Bad number");
    else
      return d;
  }, s = function() {
    var d, g, m = "", p;
    if (e === '"')
      for (; i(); ) {
        if (e === '"')
          return i(), m;
        if (e === "\\")
          if (i(), e === "u") {
            for (p = 0, g = 0; g < 4 && (d = parseInt(i(), 16), !!isFinite(d)); g += 1)
              p = p * 16 + d;
            m += String.fromCharCode(p);
          } else if (typeof r[e] == "string")
            m += r[e];
          else
            break;
        else
          m += e;
      }
    A("Bad string");
  }, a = function() {
    for (; e && e <= " "; )
      i();
  }, c = function() {
    switch (e) {
      case "t":
        return i("t"), i("r"), i("u"), i("e"), !0;
      case "f":
        return i("f"), i("a"), i("l"), i("s"), i("e"), !1;
      case "n":
        return i("n"), i("u"), i("l"), i("l"), null;
    }
    A('Unexpected "' + e + '"');
  }, l, u = function() {
    var d = [];
    if (e === "[") {
      if (i("["), a(), e === "]")
        return i("]"), d;
      for (; e; ) {
        if (d.push(l()), a(), e === "]")
          return i("]"), d;
        i(","), a();
      }
    }
    A("Bad array");
  }, f = function() {
    var d, g = {};
    if (e === "{") {
      if (i("{"), a(), e === "}")
        return i("}"), g;
      for (; e; ) {
        if (d = s(), a(), i(":"), Object.hasOwnProperty.call(g, d) && A('Duplicate key "' + d + '"'), g[d] = l(), a(), e === "}")
          return i("}"), g;
        i(","), a();
      }
    }
    A("Bad object");
  };
  return l = function() {
    switch (a(), e) {
      case "{":
        return f();
      case "[":
        return u();
      case '"':
        return s();
      case "-":
        return o();
      default:
        return e >= "0" && e <= "9" ? o() : c();
    }
  }, function(d) {
    var g;
    return n = d, t = 0, e = " ", g = l(), a(), e && A("Syntax error"), g;
  };
}();
z.base64Encode = function(t) {
  var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r, n, A, i, o, s, a, c, l = 0, u = 0, f = "", d = [];
  if (!t)
    return t;
  t = z.utf8Encode(t);
  do
    r = t.charCodeAt(l++), n = t.charCodeAt(l++), A = t.charCodeAt(l++), c = r << 16 | n << 8 | A, i = c >> 18 & 63, o = c >> 12 & 63, s = c >> 6 & 63, a = c & 63, d[u++] = e.charAt(i) + e.charAt(o) + e.charAt(s) + e.charAt(a);
  while (l < t.length);
  switch (f = d.join(""), t.length % 3) {
    case 1:
      f = f.slice(0, -2) + "==";
      break;
    case 2:
      f = f.slice(0, -1) + "=";
      break;
  }
  return f;
};
z.utf8Encode = function(t) {
  t = (t + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var e = "", r, n, A = 0, i;
  for (r = n = 0, A = t.length, i = 0; i < A; i++) {
    var o = t.charCodeAt(i), s = null;
    o < 128 ? n++ : o > 127 && o < 2048 ? s = String.fromCharCode(o >> 6 | 192, o & 63 | 128) : s = String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, o & 63 | 128), s !== null && (n > r && (e += t.substring(r, n)), e += s, r = n = i + 1);
  }
  return n > r && (e += t.substring(r, t.length)), e;
};
z.UUID = /* @__PURE__ */ function() {
  var t = function() {
    var n = 1 * /* @__PURE__ */ new Date(), A;
    if (wt.performance && wt.performance.now)
      A = wt.performance.now();
    else
      for (A = 0; n == 1 * /* @__PURE__ */ new Date(); )
        A++;
    return n.toString(16) + Math.floor(A).toString(16);
  }, e = function() {
    return Math.random().toString(16).replace(".", "");
  }, r = function() {
    var n = Mo, A, i, o = [], s = 0;
    function a(c, l) {
      var u, f = 0;
      for (u = 0; u < l.length; u++)
        f |= o[u] << u * 8;
      return c ^ f;
    }
    for (A = 0; A < n.length; A++)
      i = n.charCodeAt(A), o.unshift(i & 255), o.length >= 4 && (s = a(s, o), o = []);
    return o.length > 0 && (s = a(s, o)), s.toString(16);
  };
  return function() {
    var n = (Lh.height * Lh.width).toString(16);
    return t() + "-" + e() + "-" + r() + "-" + n + "-" + t();
  };
}();
var fC = [
  "ahrefsbot",
  "ahrefssiteaudit",
  "amazonbot",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "chrome-lighthouse",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandex",
  // a whole bunch of goog-specific crawlers
  // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
z.isBlockedUA = function(t) {
  var e;
  for (t = t.toLowerCase(), e = 0; e < fC.length; e++)
    if (t.indexOf(fC[e]) !== -1)
      return !0;
  return !1;
};
z.HTTPBuildQuery = function(t, e) {
  var r, n, A = [];
  return z.isUndefined(e) && (e = "&"), z.each(t, function(i, o) {
    r = encodeURIComponent(i.toString()), n = encodeURIComponent(o), A[A.length] = n + "=" + r;
  }), A.join(e);
};
z.getQueryParam = function(t, e) {
  e = e.replace(/[[]/g, "\\[").replace(/[\]]/g, "\\]");
  var r = "[\\?&]" + e + "=([^&#]*)", n = new RegExp(r), A = n.exec(t);
  if (A === null || A && typeof A[1] != "string" && A[1].length)
    return "";
  var i = A[1];
  try {
    i = decodeURIComponent(i);
  } catch {
    Sr.error("Skipping decoding for malformed query param: " + i);
  }
  return i.replace(/\+/g, " ");
};
z.cookie = {
  get: function(t) {
    for (var e = t + "=", r = Nr.cookie.split(";"), n = 0; n < r.length; n++) {
      for (var A = r[n]; A.charAt(0) == " "; )
        A = A.substring(1, A.length);
      if (A.indexOf(e) === 0)
        return decodeURIComponent(A.substring(e.length, A.length));
    }
    return null;
  },
  parse: function(t) {
    var e;
    try {
      e = z.JSONDecode(z.cookie.get(t)) || {};
    } catch {
    }
    return e;
  },
  set_seconds: function(t, e, r, n, A, i, o) {
    var s = "", a = "", c = "";
    if (o)
      s = "; domain=" + o;
    else if (n) {
      var l = hC(Nr.location.hostname);
      s = l ? "; domain=." + l : "";
    }
    if (r) {
      var u = /* @__PURE__ */ new Date();
      u.setTime(u.getTime() + r * 1e3), a = "; expires=" + u.toGMTString();
    }
    i && (A = !0, c = "; SameSite=None"), A && (c += "; secure"), Nr.cookie = t + "=" + encodeURIComponent(e) + a + "; path=/" + s + c;
  },
  set: function(t, e, r, n, A, i, o) {
    var s = "", a = "", c = "";
    if (o)
      s = "; domain=" + o;
    else if (n) {
      var l = hC(Nr.location.hostname);
      s = l ? "; domain=." + l : "";
    }
    if (r) {
      var u = /* @__PURE__ */ new Date();
      u.setTime(u.getTime() + r * 24 * 60 * 60 * 1e3), a = "; expires=" + u.toGMTString();
    }
    i && (A = !0, c = "; SameSite=None"), A && (c += "; secure");
    var f = t + "=" + encodeURIComponent(e) + a + "; path=/" + s + c;
    return Nr.cookie = f, f;
  },
  remove: function(t, e, r) {
    z.cookie.set(t, "", -1, e, !1, !1, r);
  }
};
var q9 = null, Gh = function(t, e) {
  if (q9 !== null && !e)
    return q9;
  var r = !0;
  try {
    t = t || wt.localStorage;
    var n = "__mplss_" + wm(8), A = "xyz";
    t.setItem(n, A), t.getItem(n) !== A && (r = !1), t.removeItem(n);
  } catch {
    r = !1;
  }
  return q9 = r, r;
};
z.localStorage = {
  is_supported: function(t) {
    var e = Gh(null, t);
    return e || Sr.error("localStorage unsupported; falling back to cookie store"), e;
  },
  error: function(t) {
    Sr.error("localStorage error: " + t);
  },
  get: function(t) {
    try {
      return wt.localStorage.getItem(t);
    } catch (e) {
      z.localStorage.error(e);
    }
    return null;
  },
  parse: function(t) {
    try {
      return z.JSONDecode(z.localStorage.get(t)) || {};
    } catch {
    }
    return null;
  },
  set: function(t, e) {
    try {
      wt.localStorage.setItem(t, e);
    } catch (r) {
      z.localStorage.error(r);
    }
  },
  remove: function(t) {
    try {
      wt.localStorage.removeItem(t);
    } catch (e) {
      z.localStorage.error(e);
    }
  }
};
z.register_event = function() {
  var t = function(n, A, i, o, s) {
    if (!n) {
      Sr.error("No valid element provided to register_event");
      return;
    }
    if (n.addEventListener && !o)
      n.addEventListener(A, i, !!s);
    else {
      var a = "on" + A, c = n[a];
      n[a] = e(n, i, c);
    }
  };
  function e(n, A, i) {
    var o = function(s) {
      if (s = s || r(wt.event), !!s) {
        var a = !0, c, l;
        return z.isFunction(i) && (c = i(s)), l = A.call(n, s), (c === !1 || l === !1) && (a = !1), a;
      }
    };
    return o;
  }
  function r(n) {
    return n && (n.preventDefault = r.preventDefault, n.stopPropagation = r.stopPropagation), n;
  }
  return r.preventDefault = function() {
    this.returnValue = !1;
  }, r.stopPropagation = function() {
    this.cancelBubble = !0;
  }, t;
}();
var zR = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
z.dom_query = /* @__PURE__ */ function() {
  function t(A) {
    return A.all ? A.all : A.getElementsByTagName("*");
  }
  var e = /[\t\r\n]/g;
  function r(A, i) {
    var o = " " + i + " ";
    return (" " + A.className + " ").replace(e, " ").indexOf(o) >= 0;
  }
  function n(A) {
    if (!Nr.getElementsByTagName)
      return [];
    var i = A.split(" "), o, s, a, c, l, u, f, d, g, m, p = [Nr];
    for (u = 0; u < i.length; u++) {
      if (o = i[u].replace(/^\s+/, "").replace(/\s+$/, ""), o.indexOf("#") > -1) {
        s = o.split("#"), a = s[0];
        var v = s[1], C = Nr.getElementById(v);
        if (!C || a && C.nodeName.toLowerCase() != a)
          return [];
        p = [C];
        continue;
      }
      if (o.indexOf(".") > -1) {
        s = o.split("."), a = s[0];
        var w = s[1];
        for (a || (a = "*"), c = [], l = 0, f = 0; f < p.length; f++)
          for (a == "*" ? g = t(p[f]) : g = p[f].getElementsByTagName(a), d = 0; d < g.length; d++)
            c[l++] = g[d];
        for (p = [], m = 0, f = 0; f < c.length; f++)
          c[f].className && z.isString(c[f].className) && // some SVG elements have classNames which are not strings
          r(c[f], w) && (p[m++] = c[f]);
        continue;
      }
      var B = o.match(zR);
      if (B) {
        a = B[1];
        var y = B[2], b = B[3], q = B[4];
        for (a || (a = "*"), c = [], l = 0, f = 0; f < p.length; f++)
          for (a == "*" ? g = t(p[f]) : g = p[f].getElementsByTagName(a), d = 0; d < g.length; d++)
            c[l++] = g[d];
        p = [], m = 0;
        var E;
        switch (b) {
          case "=":
            E = function(x) {
              return x.getAttribute(y) == q;
            };
            break;
          case "~":
            E = function(x) {
              return x.getAttribute(y).match(new RegExp("\\b" + q + "\\b"));
            };
            break;
          case "|":
            E = function(x) {
              return x.getAttribute(y).match(new RegExp("^" + q + "-?"));
            };
            break;
          case "^":
            E = function(x) {
              return x.getAttribute(y).indexOf(q) === 0;
            };
            break;
          case "$":
            E = function(x) {
              return x.getAttribute(y).lastIndexOf(q) == x.getAttribute(y).length - q.length;
            };
            break;
          case "*":
            E = function(x) {
              return x.getAttribute(y).indexOf(q) > -1;
            };
            break;
          default:
            E = function(x) {
              return x.getAttribute(y);
            };
        }
        for (p = [], m = 0, f = 0; f < c.length; f++)
          E(c[f]) && (p[m++] = c[f]);
        continue;
      }
      for (a = o, c = [], l = 0, f = 0; f < p.length; f++)
        for (g = p[f].getElementsByTagName(a), d = 0; d < g.length; d++)
          c[l++] = g[d];
      p = c;
    }
    return p;
  }
  return function(A) {
    return z.isElement(A) ? [A] : z.isObject(A) && !z.isUndefined(A.length) ? A : n.call(this, A);
  };
}();
var YR = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "utm_source_platform", "utm_campaign_id", "utm_creative_format", "utm_marketing_tactic"], VR = ["dclid", "fbclid", "gclid", "ko_click_id", "li_fat_id", "msclkid", "sccid", "ttclid", "twclid", "wbraid"];
z.info = {
  campaignParams: function(t) {
    var e = "", r = {};
    return z.each(YR, function(n) {
      e = z.getQueryParam(Nr.URL, n), e.length ? r[n] = e : t !== void 0 && (r[n] = t);
    }), r;
  },
  clickParams: function() {
    var t = "", e = {};
    return z.each(VR, function(r) {
      t = z.getQueryParam(Nr.URL, r), t.length && (e[r] = t);
    }), e;
  },
  marketingParams: function() {
    return z.extend(z.info.campaignParams(), z.info.clickParams());
  },
  searchEngine: function(t) {
    return t.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : t.search("https?://(.*)bing.com") === 0 ? "bing" : t.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : t.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(t) {
    var e = z.info.searchEngine(t), r = e != "yahoo" ? "q" : "p", n = {};
    if (e !== null) {
      n.$search_engine = e;
      var A = z.getQueryParam(t, r);
      A.length && (n.mp_keyword = A);
    }
    return n;
  },
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  browser: function(t, e, r) {
    return e = e || "", r || z.includes(t, " OPR/") ? z.includes(t, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(t) ? "BlackBerry" : z.includes(t, "IEMobile") || z.includes(t, "WPDesktop") ? "Internet Explorer Mobile" : z.includes(t, "SamsungBrowser/") ? "Samsung Internet" : z.includes(t, "Edge") || z.includes(t, "Edg/") ? "Microsoft Edge" : z.includes(t, "FBIOS") ? "Facebook Mobile" : z.includes(t, "Chrome") ? "Chrome" : z.includes(t, "CriOS") ? "Chrome iOS" : z.includes(t, "UCWEB") || z.includes(t, "UCBrowser") ? "UC Browser" : z.includes(t, "FxiOS") ? "Firefox iOS" : z.includes(e, "Apple") ? z.includes(t, "Mobile") ? "Mobile Safari" : "Safari" : z.includes(t, "Android") ? "Android Mobile" : z.includes(t, "Konqueror") ? "Konqueror" : z.includes(t, "Firefox") ? "Firefox" : z.includes(t, "MSIE") || z.includes(t, "Trident/") ? "Internet Explorer" : z.includes(t, "Gecko") ? "Mozilla" : "";
  },
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion: function(t, e, r) {
    var n = z.info.browser(t, e, r), A = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    }, i = A[n];
    if (i === void 0)
      return null;
    var o = t.match(i);
    return o ? parseFloat(o[o.length - 2]) : null;
  },
  os: function() {
    var t = Mo;
    return /Windows/i.test(t) ? /Phone/.test(t) || /WPDesktop/.test(t) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(t) ? "iOS" : /Android/.test(t) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(t) ? "BlackBerry" : /Mac/i.test(t) ? "Mac OS X" : /Linux/.test(t) ? "Linux" : /CrOS/.test(t) ? "Chrome OS" : "";
  },
  device: function(t) {
    return /Windows Phone/i.test(t) || /WPDesktop/.test(t) ? "Windows Phone" : /iPad/.test(t) ? "iPad" : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(t) ? "BlackBerry" : /Android/.test(t) ? "Android" : "";
  },
  referringDomain: function(t) {
    var e = t.split("/");
    return e.length >= 3 ? e[2] : "";
  },
  currentUrl: function() {
    return wt.location.href;
  },
  properties: function(t) {
    return typeof t != "object" && (t = {}), z.extend(z.strip_empty_properties({
      $os: z.info.os(),
      $browser: z.info.browser(Mo, qa.vendor, W1),
      $referrer: Nr.referrer,
      $referring_domain: z.info.referringDomain(Nr.referrer),
      $device: z.info.device(Mo)
    }), {
      $current_url: z.info.currentUrl(),
      $browser_version: z.info.browserVersion(Mo, qa.vendor, W1),
      $screen_height: Lh.height,
      $screen_width: Lh.width,
      mp_lib: "web",
      $lib_version: fo.LIB_VERSION,
      $insert_id: wm(),
      time: z.timestamp() / 1e3
      // epoch time in seconds
    }, z.strip_empty_properties(t));
  },
  people_properties: function() {
    return z.extend(z.strip_empty_properties({
      $os: z.info.os(),
      $browser: z.info.browser(Mo, qa.vendor, W1)
    }), {
      $browser_version: z.info.browserVersion(Mo, qa.vendor, W1)
    });
  },
  mpPageViewProperties: function() {
    return z.strip_empty_properties({
      current_page_title: Nr.title,
      current_domain: wt.location.hostname,
      current_url_path: wt.location.pathname,
      current_url_protocol: wt.location.protocol,
      current_url_search: wt.location.search
    });
  }
};
var wm = function(t) {
  var e = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return t ? e.substring(0, t) : e;
}, WR = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, XR = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, hC = function(t) {
  var e = XR, r = t.split("."), n = r[r.length - 1];
  (n.length > 4 || n === "com" || n === "org") && (e = WR);
  var A = t.match(e);
  return A ? A[0] : "";
}, KR = function() {
  var t = wt.navigator.onLine;
  return z.isUndefined(t) || t;
}, Rh = null, zh = null;
typeof JSON < "u" && (Rh = JSON.stringify, zh = JSON.parse);
Rh = Rh || z.JSONEncode;
zh = zh || z.JSONDecode;
z.toArray = z.toArray;
z.isObject = z.isObject;
z.JSONEncode = z.JSONEncode;
z.JSONDecode = z.JSONDecode;
z.isBlockedUA = z.isBlockedUA;
z.isEmptyObject = z.isEmptyObject;
z.info = z.info;
z.info.device = z.info.device;
z.info.browser = z.info.browser;
z.info.browserVersion = z.info.browserVersion;
z.info.properties = z.info.properties;
z.NPO = Wa;
var ZR = "__mp_opt_in_out_";
function JR(t, e) {
  bk(!0, t, e);
}
function _R(t, e) {
  bk(!1, t, e);
}
function $R(t, e) {
  return wk(t, e) === "1";
}
function Ck(t, e) {
  if (tz(e))
    return Sr.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var r = wk(t, e) === "0";
  return r && Sr.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), r;
}
function Xa(t) {
  return Em(t, function(e) {
    return this.get_config(e);
  });
}
function Ka(t) {
  return Em(t, function(e) {
    return this._get_config(e);
  });
}
function Cd(t) {
  return Em(t, function(e) {
    return this._get_config(e);
  });
}
function ez(t, e) {
  e = e || {}, bm(e).remove(
    Bm(t, e),
    !!e.crossSubdomainCookie,
    e.cookieDomain
  );
}
function bm(t) {
  return t = t || {}, t.persistenceType === "localStorage" ? z.localStorage : z.cookie;
}
function Bm(t, e) {
  return e = e || {}, (e.persistencePrefix || ZR) + t;
}
function wk(t, e) {
  return bm(e).get(Bm(t, e));
}
function tz(t) {
  if (t && t.ignoreDnt)
    return !1;
  var e = t && t.window || wt, r = e.navigator || {}, n = !1;
  return z.each([
    r.doNotTrack,
    // standard
    r.msDoNotTrack,
    e.doNotTrack
  ], function(A) {
    z.includes([!0, 1, "1", "yes"], A) && (n = !0);
  }), n;
}
function bk(t, e, r) {
  if (!z.isString(e) || !e.length) {
    Sr.error("gdpr." + (t ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  r = r || {}, bm(r).set(
    Bm(e, r),
    t ? 1 : 0,
    z.isNumber(r.cookieExpiration) ? r.cookieExpiration : null,
    !!r.crossSubdomainCookie,
    !!r.secureCookie,
    !!r.crossSiteCookie,
    r.cookieDomain
  ), r.track && t && r.track(r.trackEventName || "$opt_in", r.trackProperties, {
    send_immediately: !0
  });
}
function Em(t, e) {
  return function() {
    var r = !1;
    try {
      var n = e.call(this, "token"), A = e.call(this, "ignore_dnt"), i = e.call(this, "opt_out_tracking_persistence_type"), o = e.call(this, "opt_out_tracking_cookie_prefix"), s = e.call(this, "window");
      n && (r = Ck(n, {
        ignoreDnt: A,
        persistenceType: i,
        persistencePrefix: o,
        window: s
      }));
    } catch (c) {
      Sr.error("Unexpected error when checking tracking opt-out status: " + c);
    }
    if (!r)
      return t.apply(this, arguments);
    var a = arguments[arguments.length - 1];
    typeof a == "function" && a(0);
  };
}
var rz = yd("lock"), Bk = function(t, e) {
  e = e || {}, this.storageKey = t, this.storage = e.storage || window.localStorage, this.pollIntervalMS = e.pollIntervalMS || 100, this.timeoutMS = e.timeoutMS || 2e3, this.promiseImpl = e.promiseImpl || bn;
};
Bk.prototype.withLock = function(t, e) {
  var r = this.promiseImpl;
  return new r(z.bind(function(n, A) {
    var i = e || (/* @__PURE__ */ new Date()).getTime() + "|" + Math.random(), o = (/* @__PURE__ */ new Date()).getTime(), s = this.storageKey, a = this.pollIntervalMS, c = this.timeoutMS, l = this.storage, u = s + ":X", f = s + ":Y", d = s + ":Z", g = function(w) {
      if ((/* @__PURE__ */ new Date()).getTime() - o > c) {
        rz.error("Timeout waiting for mutex on " + s + "; clearing lock. [" + i + "]"), l.removeItem(d), l.removeItem(f), v();
        return;
      }
      setTimeout(function() {
        try {
          w();
        } catch (B) {
          A(B);
        }
      }, a * (Math.random() + 0.1));
    }, m = function(w, B) {
      w() ? B() : g(function() {
        m(w, B);
      });
    }, p = function() {
      var w = l.getItem(f);
      return w && w !== i ? !1 : (l.setItem(f, i), l.getItem(f) === i ? !0 : (Gh(l, !0) || A(new Error("localStorage support dropped while acquiring lock")), !1));
    }, v = function() {
      l.setItem(u, i), m(p, function() {
        if (l.getItem(u) === i) {
          C();
          return;
        }
        g(function() {
          if (l.getItem(f) !== i) {
            v();
            return;
          }
          m(function() {
            return !l.getItem(d);
          }, C);
        });
      });
    }, C = function() {
      l.setItem(d, "1");
      var w = function() {
        l.removeItem(d), l.getItem(f) === i && l.removeItem(f), l.getItem(u) === i && l.removeItem(u);
      };
      t().then(function(B) {
        w(), n(B);
      }).catch(function(B) {
        w(), A(B);
      });
    };
    try {
      if (Gh(l, !0))
        v();
      else
        throw new Error("localStorage support check failed");
    } catch (w) {
      A(w);
    }
  }, this));
};
var m1 = function(t) {
  this.storage = t || localStorage;
};
m1.prototype.init = function() {
  return bn.resolve();
};
m1.prototype.setItem = function(t, e) {
  return new bn(z.bind(function(r, n) {
    try {
      this.storage.setItem(t, e);
    } catch (A) {
      n(A);
    }
    r();
  }, this));
};
m1.prototype.getItem = function(t) {
  return new bn(z.bind(function(e, r) {
    var n;
    try {
      n = this.storage.getItem(t);
    } catch (A) {
      r(A);
    }
    e(n);
  }, this));
};
m1.prototype.removeItem = function(t) {
  return new bn(z.bind(function(e, r) {
    try {
      this.storage.removeItem(t);
    } catch (n) {
      r(n);
    }
    e();
  }, this));
};
var pC = yd("batch"), js = function(t, e) {
  e = e || {}, this.storageKey = t, this.usePersistence = e.usePersistence, this.usePersistence && (this.queueStorage = e.queueStorage || new m1(), this.lock = new Bk(t, { storage: e.sharedLockStorage || window.localStorage }), this.queueStorage.init()), this.reportError = e.errorReporter || z.bind(pC.error, pC), this.pid = e.pid || null, this.memQueue = [], this.initialized = !1;
};
js.prototype.ensureInit = function() {
  return this.initialized ? bn.resolve() : this.queueStorage.init().then(z.bind(function() {
    this.initialized = !0;
  }, this)).catch(z.bind(function(t) {
    this.reportError("Error initializing queue persistence. Disabling persistence", t), this.initialized = !0, this.usePersistence = !1;
  }, this));
};
js.prototype.enqueue = function(t, e) {
  var r = {
    id: wm(),
    flushAfter: (/* @__PURE__ */ new Date()).getTime() + e * 2,
    payload: t
  };
  if (this.usePersistence) {
    var n = z.bind(function() {
      return this.ensureInit().then(z.bind(function() {
        return this.readFromStorage();
      }, this)).then(z.bind(function(A) {
        return A.push(r), this.saveToStorage(A);
      }, this)).then(z.bind(function(A) {
        return A && this.memQueue.push(r), A;
      }, this)).catch(z.bind(function(A) {
        return this.reportError("Error enqueueing item", A, t), !1;
      }, this));
    }, this);
    return this.lock.withLock(n, this.pid).catch(z.bind(function(A) {
      return this.reportError("Error acquiring storage lock", A), !1;
    }, this));
  } else
    return this.memQueue.push(r), bn.resolve(!0);
};
js.prototype.fillBatch = function(t) {
  var e = this.memQueue.slice(0, t);
  return this.usePersistence && e.length < t ? this.ensureInit().then(z.bind(function() {
    return this.readFromStorage();
  }, this)).then(z.bind(function(r) {
    if (r.length) {
      var n = {};
      z.each(e, function(o) {
        n[o.id] = !0;
      });
      for (var A = 0; A < r.length; A++) {
        var i = r[A];
        if ((/* @__PURE__ */ new Date()).getTime() > i.flushAfter && !n[i.id] && (i.orphaned = !0, e.push(i), e.length >= t))
          break;
      }
    }
    return e;
  }, this)) : bn.resolve(e);
};
var gC = function(t, e) {
  var r = [];
  return z.each(t, function(n) {
    n.id && !e[n.id] && r.push(n);
  }), r;
};
js.prototype.removeItemsByID = function(t) {
  var e = {};
  if (z.each(t, function(n) {
    e[n] = !0;
  }), this.memQueue = gC(this.memQueue, e), this.usePersistence) {
    var r = z.bind(function() {
      return this.ensureInit().then(z.bind(function() {
        return this.readFromStorage();
      }, this)).then(z.bind(function(n) {
        return n = gC(n, e), this.saveToStorage(n);
      }, this)).then(z.bind(function() {
        return this.readFromStorage();
      }, this)).then(z.bind(function(n) {
        for (var A = 0; A < n.length; A++) {
          var i = n[A];
          if (i.id && e[i.id])
            throw new Error("Item not removed from storage");
        }
        return !0;
      }, this)).catch(z.bind(function(n) {
        return this.reportError("Error removing items", n, t), !1;
      }, this));
    }, this);
    return this.lock.withLock(r, this.pid).catch(z.bind(function(n) {
      return this.reportError("Error acquiring storage lock", n), Gh(this.queueStorage.storage, !0) ? !1 : r().then(z.bind(function(A) {
        return A || this.queueStorage.removeItem(this.storageKey).then(function() {
          return A;
        });
      }, this)).catch(z.bind(function(A) {
        return this.reportError("Error clearing queue", A), !1;
      }, this));
    }, this));
  } else
    return bn.resolve(!0);
};
var mC = function(t, e) {
  var r = [];
  return z.each(t, function(n) {
    var A = n.id;
    if (A in e) {
      var i = e[A];
      i !== null && (n.payload = i, r.push(n));
    } else
      r.push(n);
  }), r;
};
js.prototype.updatePayloads = function(t) {
  return this.memQueue = mC(this.memQueue, t), this.usePersistence ? this.lock.withLock(z.bind(function() {
    return this.ensureInit().then(z.bind(function() {
      return this.readFromStorage();
    }, this)).then(z.bind(function(r) {
      return r = mC(r, t), this.saveToStorage(r);
    }, this)).catch(z.bind(function(r) {
      return this.reportError("Error updating items", t, r), !1;
    }, this));
  }, this), this.pid).catch(z.bind(function(e) {
    return this.reportError("Error acquiring storage lock", e), !1;
  }, this)) : bn.resolve(!0);
};
js.prototype.readFromStorage = function() {
  return this.ensureInit().then(z.bind(function() {
    return this.queueStorage.getItem(this.storageKey);
  }, this)).then(z.bind(function(t) {
    return t && (t = zh(t), z.isArray(t) || (this.reportError("Invalid storage entry:", t), t = null)), t || [];
  }, this)).catch(z.bind(function(t) {
    return this.reportError("Error retrieving queue", t), [];
  }, this));
};
js.prototype.saveToStorage = function(t) {
  try {
    var e = Rh(t);
  } catch (r) {
    return this.reportError("Error serializing queue", r), bn.resolve(!1);
  }
  return this.ensureInit().then(z.bind(function() {
    return this.queueStorage.setItem(this.storageKey, e);
  }, this)).then(function() {
    return !0;
  }).catch(z.bind(function(r) {
    return this.reportError("Error saving queue", r), !1;
  }, this));
};
js.prototype.clear = function() {
  return this.memQueue = [], this.usePersistence ? this.ensureInit().then(z.bind(function() {
    return this.queueStorage.removeItem(this.storageKey);
  }, this)) : bn.resolve();
};
var nz = 10 * 60 * 1e3, Y0 = yd("batch"), Wi = function(t, e) {
  this.errorReporter = e.errorReporter, this.queue = new js(t, {
    errorReporter: z.bind(this.reportError, this),
    queueStorage: e.queueStorage,
    sharedLockStorage: e.sharedLockStorage,
    usePersistence: e.usePersistence
  }), this.libConfig = e.libConfig, this.sendRequest = e.sendRequestFunc, this.beforeSendHook = e.beforeSendHook, this.stopAllBatching = e.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0, this.itemIdsSentSuccessfully = {}, this.flushOnlyOnInterval = e.flushOnlyOnInterval || !1;
};
Wi.prototype.enqueue = function(t) {
  return this.queue.enqueue(t, this.flushInterval);
};
Wi.prototype.start = function() {
  return this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
Wi.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
Wi.prototype.clear = function() {
  return this.queue.clear();
};
Wi.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
Wi.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
Wi.prototype.scheduleFlush = function(t) {
  this.flushInterval = t, this.stopped || (this.timeoutID = setTimeout(z.bind(function() {
    this.stopped || this.flush();
  }, this), this.flushInterval));
};
Wi.prototype.sendRequestPromise = function(t, e) {
  return new bn(z.bind(function(r) {
    this.sendRequest(t, e, r);
  }, this));
};
Wi.prototype.flush = function(t) {
  if (this.requestInProgress)
    return Y0.log("Flush: Request already in progress"), bn.resolve();
  this.requestInProgress = !0, t = t || {};
  var e = this.libConfig.batch_request_timeout_ms, r = (/* @__PURE__ */ new Date()).getTime(), n = this.batchSize;
  return this.queue.fillBatch(n).then(z.bind(function(A) {
    var i = A.length === n, o = [], s = {};
    if (z.each(A, function(u) {
      var f = u.payload;
      if (this.beforeSendHook && !u.orphaned && (f = this.beforeSendHook(f)), f) {
        f.event && f.properties && (f.properties = z.extend(
          {},
          f.properties,
          { mp_sent_by_lib_version: fo.LIB_VERSION }
        ));
        var d = !0, g = u.id;
        g ? (this.itemIdsSentSuccessfully[g] || 0) > 5 && (this.reportError("[dupe] item ID sent too many times, not sending", {
          item: u,
          batchSize: A.length,
          timesSent: this.itemIdsSentSuccessfully[g]
        }), d = !1) : this.reportError("[dupe] found item with no ID", { item: u }), d && o.push(f);
      }
      s[u.id] = f;
    }, this), o.length < 1)
      return this.requestInProgress = !1, this.resetFlush(), bn.resolve();
    var a = z.bind(function() {
      return this.queue.removeItemsByID(
        z.map(A, function(u) {
          return u.id;
        })
      ).then(z.bind(function(u) {
        return z.each(A, z.bind(function(f) {
          var d = f.id;
          d ? (this.itemIdsSentSuccessfully[d] = this.itemIdsSentSuccessfully[d] || 0, this.itemIdsSentSuccessfully[d]++, this.itemIdsSentSuccessfully[d] > 5 && this.reportError("[dupe] item ID sent too many times", {
            item: f,
            batchSize: A.length,
            timesSent: this.itemIdsSentSuccessfully[d]
          })) : this.reportError("[dupe] found item with no ID while removing", { item: f });
        }, this)), u ? (this.consecutiveRemovalFailures = 0, this.flushOnlyOnInterval && !i ? (this.resetFlush(), bn.resolve()) : this.flush()) : (++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush(), bn.resolve());
      }, this));
    }, this), c = z.bind(function(u) {
      this.requestInProgress = !1;
      try {
        if (t.unloading)
          return this.queue.updatePayloads(s);
        if (z.isObject(u) && u.error === "timeout" && (/* @__PURE__ */ new Date()).getTime() - r >= e)
          return this.reportError("Network timeout; retrying"), this.flush();
        if (z.isObject(u) && (u.httpStatusCode >= 500 || u.httpStatusCode === 429 || u.httpStatusCode <= 0 && !KR() || u.error === "timeout")) {
          var f = this.flushInterval * 2;
          return u.retryAfter && (f = parseInt(u.retryAfter, 10) * 1e3 || f), f = Math.min(nz, f), this.reportError("Error; retry in " + f + " ms"), this.scheduleFlush(f), bn.resolve();
        } else if (z.isObject(u) && u.httpStatusCode === 413)
          if (A.length > 1) {
            var d = Math.max(1, Math.floor(n / 2));
            return this.batchSize = Math.min(this.batchSize, d, A.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush(), bn.resolve();
          } else
            return this.reportError("Single-event request too large; dropping", A), this.resetBatchSize(), a();
        else
          return a();
      } catch (g) {
        this.reportError("Error handling API response", g), this.resetFlush();
      }
    }, this), l = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      // eslint-disable-line camelcase
      timeout_ms: e
      // eslint-disable-line camelcase
    };
    return t.unloading && (l.transport = "sendBeacon"), Y0.log("MIXPANEL REQUEST:", o), this.sendRequestPromise(o, l).then(c);
  }, this)).catch(z.bind(function(A) {
    this.reportError("Error flushing request queue", A), this.resetFlush();
  }, this));
};
Wi.prototype.reportError = function(t, e) {
  if (Y0.error.apply(Y0.error, arguments), this.errorReporter)
    try {
      e instanceof Error || (e = new Error(t)), this.errorReporter(t, e);
    } catch (r) {
      Y0.error(r);
    }
};
var tu = yd("recorder"), vC = wt.CompressionStream, Az = {
  batch_size: 1e3,
  batch_flush_interval_ms: 10 * 1e3,
  batch_request_timeout_ms: 90 * 1e3,
  batch_autostart: !0
}, iz = /* @__PURE__ */ new Set([
  To.MouseMove,
  To.MouseInteraction,
  To.Scroll,
  To.ViewportResize,
  To.Input,
  To.TouchMove,
  To.MediaInteraction,
  To.Drag,
  To.Selection
]);
function oz(t) {
  return t.type === hk.IncrementalSnapshot && iz.has(t.data.source);
}
var vo = function(t) {
  this._mixpanel = t.mixpanelInstance, this._onIdleTimeout = t.onIdleTimeout, this._onMaxLengthReached = t.onMaxLengthReached, this._rrwebRecord = t.rrwebRecord, this.replayId = t.replayId, this._stopRecording = null, this.seqNo = 0, this.replayStartTime = null, this.replayStartUrl = null, this.batchStartUrl = null, this.idleTimeoutId = null, this.maxTimeoutId = null, this.recordMaxMs = z0, this.recordMinMs = 0;
  var e = "__mprec_" + this.getConfig("token") + "_" + this.replayId;
  this.batcher = new Wi(e, {
    errorReporter: z.bind(this.reportError, this),
    flushOnlyOnInterval: !0,
    libConfig: Az,
    sendRequestFunc: z.bind(this.flushEventsWithOptOut, this),
    usePersistence: !1
  });
};
vo.prototype.getConfig = function(t) {
  return this._mixpanel.get_config(t);
};
vo.prototype.get_config = function(t) {
  return this.getConfig(t);
};
vo.prototype.startRecording = function(t) {
  if (this._stopRecording !== null) {
    tu.log("Recording already in progress, skipping startRecording.");
    return;
  }
  this.recordMaxMs = this.getConfig("record_max_ms"), this.recordMaxMs > z0 && (this.recordMaxMs = z0, tu.critical("record_max_ms cannot be greater than " + z0 + "ms. Capping value.")), this.recordMinMs = this.getConfig("record_min_ms"), this.recordMinMs > g9 && (this.recordMinMs = g9, tu.critical("record_min_ms cannot be greater than " + g9 + "ms. Capping value.")), this.replayStartTime = (/* @__PURE__ */ new Date()).getTime(), this.batchStartUrl = z.info.currentUrl(), this.replayStartUrl = z.info.currentUrl(), t || this.recordMinMs > 0 ? this.batcher.stop() : this.batcher.start();
  var e = z.bind(function() {
    clearTimeout(this.idleTimeoutId), this.idleTimeoutId = setTimeout(this._onIdleTimeout, this.getConfig("record_idle_timeout_ms"));
  }, this), r = this.getConfig("record_block_selector");
  if ((r === "" || r === null) && (r = void 0), this._stopRecording = this._rrwebRecord({
    emit: z.bind(function(n) {
      this.batcher.enqueue(n), oz(n) && (this.batcher.stopped && (/* @__PURE__ */ new Date()).getTime() - this.replayStartTime >= this.recordMinMs && this.batcher.start(), e());
    }, this),
    blockClass: this.getConfig("record_block_class"),
    blockSelector: r,
    collectFonts: this.getConfig("record_collect_fonts"),
    dataURLOptions: {
      // canvas image options (https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataURL)
      type: "image/webp",
      quality: 0.6
    },
    maskAllInputs: !0,
    maskTextClass: this.getConfig("record_mask_text_class"),
    maskTextSelector: this.getConfig("record_mask_text_selector"),
    recordCanvas: this.getConfig("record_canvas"),
    sampling: {
      canvas: 15
    }
  }), typeof this._stopRecording != "function") {
    this.reportError("rrweb failed to start, skipping this recording."), this._stopRecording = null, this.stopRecording();
    return;
  }
  e(), this.maxTimeoutId = setTimeout(z.bind(this._onMaxLengthReached, this), this.recordMaxMs);
};
vo.prototype.stopRecording = function() {
  if (!this.isRrwebStopped()) {
    try {
      this._stopRecording();
    } catch (t) {
      this.reportError("Error with rrweb stopRecording", t);
    }
    this._stopRecording = null;
  }
  this.batcher.stopped ? this.batcher.clear() : (this.batcher.flush(), this.batcher.stop()), clearTimeout(this.idleTimeoutId), clearTimeout(this.maxTimeoutId);
};
vo.prototype.isRrwebStopped = function() {
  return this._stopRecording === null;
};
vo.prototype.flushEventsWithOptOut = function(t, e, r) {
  this._flushEvents(t, e, r, z.bind(this._onOptOut, this));
};
vo.prototype._onOptOut = function(t) {
  t === 0 && this.stopRecording();
};
vo.prototype._sendRequest = function(t, e, r, n) {
  var A = z.bind(function(i, o) {
    i.status === 200 && this.replayId === t && (this.seqNo++, this.batchStartUrl = z.info.currentUrl()), n({
      status: 0,
      httpStatusCode: i.status,
      responseBody: o,
      retryAfter: i.headers.get("Retry-After")
    });
  }, this);
  wt.fetch(this.getConfig("api_host") + "/" + this.getConfig("api_routes").record + "?" + new URLSearchParams(e), {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa(this.getConfig("token") + ":"),
      "Content-Type": "application/octet-stream"
    },
    body: r
  }).then(function(i) {
    i.json().then(function(o) {
      A(i, o);
    }).catch(function(o) {
      n({ error: o });
    });
  }).catch(function(i) {
    n({ error: i, httpStatusCode: 0 });
  });
};
vo.prototype._flushEvents = Xa(function(t, e, r) {
  const n = t.length;
  if (n > 0) {
    var A = this.replayId, i = t[0].timestamp;
    (this.seqNo === 0 || !this.replayStartTime) && (this.seqNo !== 0 && this.reportError("Replay start time not set but seqNo is not 0. Using current batch start time as a fallback."), this.replayStartTime = i);
    var o = t[n - 1].timestamp - this.replayStartTime, s = {
      $current_url: this.batchStartUrl,
      $lib_version: fo.LIB_VERSION,
      batch_start_time: i / 1e3,
      distinct_id: String(this._mixpanel.get_distinct_id()),
      mp_lib: "web",
      replay_id: A,
      replay_length_ms: o,
      replay_start_time: this.replayStartTime / 1e3,
      replay_start_url: this.replayStartUrl,
      seq: this.seqNo
    }, a = z.JSONEncode(t), c = this._mixpanel.get_property("$device_id");
    c && (s.$device_id = c);
    var l = this._mixpanel.get_property("$user_id");
    if (l && (s.$user_id = l), vC) {
      var u = new Blob([a], { type: "application/json" }).stream(), f = u.pipeThrough(new vC("gzip"));
      new Response(f).blob().then(z.bind(function(d) {
        s.format = "gzip", this._sendRequest(A, s, d, r);
      }, this));
    } else
      s.format = "body", this._sendRequest(A, s, a, r);
  }
});
vo.prototype.reportError = function(t, e) {
  tu.error.apply(tu.error, arguments);
  try {
    !e && !(t instanceof Error) && (t = new Error(t)), this.getConfig("error_reporter")(t, e);
  } catch (r) {
    tu.error(r);
  }
};
var y9 = yd("recorder"), wd = function(t) {
  this._mixpanel = t, this.activeRecording = null;
};
wd.prototype.startRecording = function(t) {
  if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
    y9.log("Recording already in progress, skipping startRecording.");
    return;
  }
  var e = z.bind(function() {
    y9.log("Idle timeout reached, restarting recording."), this.resetRecording();
  }, this), r = z.bind(function() {
    y9.log("Max recording length reached, stopping recording."), this.resetRecording();
  }, this);
  this.activeRecording = new vo({
    mixpanelInstance: this._mixpanel,
    onIdleTimeout: e,
    onMaxLengthReached: r,
    replayId: z.UUID(),
    rrwebRecord: p1
  }), this.activeRecording.startRecording(t);
};
wd.prototype.stopRecording = function() {
  this.activeRecording && (this.activeRecording.stopRecording(), this.activeRecording = null);
};
wd.prototype.resetRecording = function() {
  this.stopRecording(), this.startRecording(!0);
};
wd.prototype.getActiveReplayId = function() {
  return this.activeRecording && !this.activeRecording.isRrwebStopped() ? this.activeRecording.replayId : null;
};
Object.defineProperty(wd.prototype, "replayId", {
  get: function() {
    return this.getActiveReplayId();
  }
});
wt.__mp_recorder = wd;
var Yh = "change", h2 = "click", qC = "hashchange", vl = "mp_locationchange", yC = "popstate", CC = "scrollend", s5 = "submit", sz = [
  "clientX",
  "clientY",
  "offsetX",
  "offsetY",
  "pageX",
  "pageY",
  "screenX",
  "screenY",
  "x",
  "y"
], wC = ["mp-include"], Ek = ["mp-no-track"], bC = Ek.concat(["mp-sensitive"]), az = [
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "href",
  "name",
  "role",
  "title",
  "type"
], Ss = yd("autocapture");
function a5(t) {
  for (var e = {}, r = xk(t).split(" "), n = 0; n < r.length; n++) {
    var A = r[n];
    A && (e[A] = !0);
  }
  return e;
}
function xk(t) {
  switch (typeof t.className) {
    case "string":
      return t.className;
    case "object":
      return t.className.baseVal || t.getAttribute("class") || "";
    default:
      return "";
  }
}
function cz(t) {
  if (t.previousElementSibling)
    return t.previousElementSibling;
  do
    t = t.previousSibling;
  while (t && !Ik(t));
  return t;
}
function BC(t) {
  var e = {
    $classes: xk(t).split(" "),
    $tag_name: t.tagName.toLowerCase()
  }, r = t.id;
  r && (e.$id = r), xm(t) && z.each(az, function(o) {
    if (t.hasAttribute(o)) {
      var s = t.getAttribute(o);
      Im(s) && (e["$attr-" + o] = s);
    }
  });
  for (var n = 1, A = 1, i = t; i = cz(i); )
    n++, i.tagName === t.tagName && A++;
  return e.$nth_child = n, e.$nth_of_type = A, e;
}
function lz(t, e, r) {
  e = e || [];
  var n = null, A = typeof t.target > "u" ? t.srcElement : t.target;
  if (Sk(A) && (A = A.parentNode), fz(A, t)) {
    for (var i = [A], o = A; o.parentNode && !Uo(o, "body"); )
      i.push(o.parentNode), o = o.parentNode;
    var s = [], a, c = !1;
    if (z.each(i, function(d) {
      var g = xm(d);
      d.tagName.toLowerCase() === "a" && (a = d.getAttribute("href"), a = g && Im(a) && a);
      var m = a5(d);
      z.each(Ek, function(p) {
        m[p] && (c = !0);
      }), c || z.each(e, function(p) {
        try {
          d.matches(p) && (c = !0);
        } catch (v) {
          Ss.critical("Error while checking selector: " + p, v);
        }
      }), s.push(BC(d));
    }, this), !c) {
      var l = Nr.documentElement;
      if (n = {
        $event_type: t.type,
        $host: wt.location.host,
        $pathname: wt.location.pathname,
        $elements: s,
        $el_attr__href: a,
        $viewportHeight: Math.max(l.clientHeight, wt.innerHeight || 0),
        $viewportWidth: Math.max(l.clientWidth, wt.innerWidth || 0)
      }, r && (u = EC(A), u && u.length && (n.$el_text = u)), t.type === h2 && (z.each(sz, function(d) {
        d in t && (n["$" + d] = t[d]);
      }), A = uz(t)), r) {
        var u = EC(A);
        u && u.length && (n.$el_text = u);
      }
      if (A) {
        var f = BC(A);
        n.$target = f, n.$el_classes = f.$classes, z.extend(n, z.strip_empty_properties({
          $el_id: f.$id,
          $el_tag_name: f.$tag_name
        }));
      }
    }
  }
  return n;
}
function EC(t) {
  var e = "";
  return xm(t) && t.childNodes && t.childNodes.length && z.each(t.childNodes, function(r) {
    Sk(r) && r.textContent && (e += z.trim(r.textContent).split(/(\s+)/).filter(Im).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255));
  }), z.trim(e);
}
function uz(t) {
  for (var e = t.target, r = t.composedPath(), n = 0; n < r.length; n++) {
    var A = r[n];
    if (Uo(A, "a") || Uo(A, "button") || Uo(A, "input") || Uo(A, "select") || A.getAttribute && A.getAttribute("role") === "button") {
      e = A;
      break;
    }
    if (A === e)
      break;
  }
  return e;
}
function Ik(t) {
  return t && t.nodeType === 1;
}
function Uo(t, e) {
  return t && t.tagName && t.tagName.toLowerCase() === e.toLowerCase();
}
function Sk(t) {
  return t && t.nodeType === 3;
}
function dz() {
  try {
    var t = Nr.createElement("div");
    return !!t.matches;
  } catch {
    return !1;
  }
}
function fz(t, e) {
  if (!t || Uo(t, "html") || !Ik(t))
    return !1;
  var r = t.tagName.toLowerCase();
  switch (r) {
    case "form":
      return e.type === s5;
    case "input":
      return ["button", "submit"].indexOf(t.getAttribute("type")) === -1 ? e.type === Yh : e.type === h2;
    case "select":
    case "textarea":
      return e.type === Yh;
    default:
      return e.type === h2;
  }
}
function xm(t) {
  for (var e, r = t; r.parentNode && !Uo(r, "body"); r = r.parentNode) {
    var n = a5(r);
    for (e = 0; e < bC.length; e++)
      if (n[bC[e]])
        return !1;
  }
  var A = a5(t);
  for (e = 0; e < wC.length; e++)
    if (A[wC[e]])
      return !0;
  if (Uo(t, "input") || Uo(t, "select") || Uo(t, "textarea") || t.getAttribute("contenteditable") === "true")
    return !1;
  var i = t.type || "";
  if (typeof i == "string")
    switch (i.toLowerCase()) {
      case "hidden":
        return !1;
      case "password":
        return !1;
    }
  var o = t.name || t.id || "";
  if (typeof o == "string") {
    var s = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
    if (s.test(o.replace(/[^a-zA-Z0-9]/g, "")))
      return !1;
  }
  return !0;
}
function Im(t) {
  if (t === null || z.isUndefined(t))
    return !1;
  if (typeof t == "string") {
    t = z.trim(t);
    var e = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (e.test((t || "").replace(/[- ]/g, "")))
      return !1;
    var r = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (r.test(t))
      return !1;
  }
  return !0;
}
var Pk = "autocapture", hz = "track_pageview", kk = "full-url", pz = "url-with-path-and-query-string", gz = "url-with-path", mz = "block_selectors", vz = "block_url_regexes", Ok = "capture_text_content", c5 = "click", l5 = "input", Fk = "pageview", u5 = "scroll", d5 = "submit", Ha = {};
Ha[Ok] = !1;
Ha[c5] = !0;
Ha[l5] = !0;
Ha[Fk] = kk;
Ha[u5] = !0;
Ha[d5] = !0;
var Vh = {
  $mp_autocapture: !0
}, qz = "$mp_click", yz = "$mp_input_change", Cz = "$mp_scroll", wz = "$mp_submit", Bi = function(t) {
  this.mp = t;
};
Bi.prototype.init = function() {
  if (!dz()) {
    Ss.critical("Autocapture unavailable: missing required DOM APIs");
    return;
  }
  this.initPageviewTracking(), this.initClickTracking(), this.initInputTracking(), this.initScrollTracking(), this.initSubmitTracking();
};
Bi.prototype.getFullConfig = function() {
  var t = this.mp.get_config(Pk);
  return t ? z.isObject(t) ? z.extend({}, Ha, t) : Ha : {};
};
Bi.prototype.getConfig = function(t) {
  return this.getFullConfig()[t];
};
Bi.prototype.currentUrlBlocked = function() {
  var t = this.getConfig(vz) || [];
  if (!t.length)
    return !1;
  for (var e = z.info.currentUrl(), r = 0; r < t.length; r++)
    try {
      if (e.match(t[r]))
        return !0;
    } catch (n) {
      return Ss.critical("Error while checking block URL regex: " + t[r], n), !0;
    }
  return !1;
};
Bi.prototype.pageviewTrackingConfig = function() {
  return this.mp.get_config(Pk) ? this.getConfig(Fk) : this.mp.get_config(hz);
};
Bi.prototype.trackDomEvent = function(t, e) {
  if (!this.currentUrlBlocked()) {
    var r = lz(
      t,
      this.getConfig(mz),
      this.getConfig(Ok)
    );
    r && (z.extend(r, Vh), this.mp.track(e, r));
  }
};
Bi.prototype.initClickTracking = function() {
  wt.removeEventListener(h2, this.listenerClick), this.getConfig(c5) && (Ss.log("Initializing click tracking"), this.listenerClick = wt.addEventListener(h2, (function(t) {
    this.getConfig(c5) && this.trackDomEvent(t, qz);
  }).bind(this)));
};
Bi.prototype.initInputTracking = function() {
  wt.removeEventListener(Yh, this.listenerChange), this.getConfig(l5) && (Ss.log("Initializing input tracking"), this.listenerChange = wt.addEventListener(Yh, (function(t) {
    this.getConfig(l5) && this.trackDomEvent(t, yz);
  }).bind(this)));
};
Bi.prototype.initPageviewTracking = function() {
  if (wt.removeEventListener(yC, this.listenerPopstate), wt.removeEventListener(qC, this.listenerHashchange), wt.removeEventListener(vl, this.listenerLocationchange), !!this.pageviewTrackingConfig()) {
    Ss.log("Initializing pageview tracking");
    var t = "", e = !1;
    this.currentUrlBlocked() || (e = this.mp.track_pageview(Vh)), e && (t = z.info.currentUrl()), this.listenerPopstate = wt.addEventListener(yC, function() {
      wt.dispatchEvent(new Event(vl));
    }), this.listenerHashchange = wt.addEventListener(qC, function() {
      wt.dispatchEvent(new Event(vl));
    });
    var r = wt.history.pushState;
    typeof r == "function" && (wt.history.pushState = function(A, i, o) {
      r.call(wt.history, A, i, o), wt.dispatchEvent(new Event(vl));
    });
    var n = wt.history.replaceState;
    typeof n == "function" && (wt.history.replaceState = function(A, i, o) {
      n.call(wt.history, A, i, o), wt.dispatchEvent(new Event(vl));
    }), this.listenerLocationchange = wt.addEventListener(vl, Cm((function() {
      if (!this.currentUrlBlocked()) {
        var A = z.info.currentUrl(), i = !1, o = this.pageviewTrackingConfig();
        if (o === kk ? i = A !== t : o === pz ? i = A.split("#")[0] !== t.split("#")[0] : o === gz && (i = A.split("#")[0].split("?")[0] !== t.split("#")[0].split("?")[0]), i) {
          var s = this.mp.track_pageview(Vh);
          s && (t = A);
        }
      }
    }).bind(this)));
  }
};
Bi.prototype.initScrollTracking = function() {
  wt.removeEventListener(CC, this.listenerScroll), this.getConfig(u5) && (Ss.log("Initializing scroll tracking"), this.listenerScroll = wt.addEventListener(CC, Cm((function() {
    if (this.getConfig(u5) && !this.currentUrlBlocked()) {
      var t = wt.scrollY, e = z.extend({ $scroll_top: t }, Vh);
      try {
        var r = Nr.body.scrollHeight, n = Math.round(t / (r - wt.innerHeight) * 100);
        e.$scroll_height = r, e.$scroll_percentage = n;
      } catch (A) {
        Ss.critical("Error while calculating scroll percentage", A);
      }
      this.mp.track(Cz, e);
    }
  }).bind(this))));
};
Bi.prototype.initSubmitTracking = function() {
  wt.removeEventListener(s5, this.listenerSubmit), this.getConfig(d5) && (Ss.log("Initializing submit tracking"), this.listenerSubmit = wt.addEventListener(s5, (function(t) {
    this.getConfig(d5) && this.trackDomEvent(t, wz);
  }).bind(this)));
};
RR(Bi);
var Ls = function() {
};
Ls.prototype.create_properties = function() {
};
Ls.prototype.event_handler = function() {
};
Ls.prototype.after_track_handler = function() {
};
Ls.prototype.init = function(t) {
  return this.mp = t, this;
};
Ls.prototype.track = function(t, e, r, n) {
  var A = this, i = z.dom_query(t);
  if (i.length === 0) {
    Sr.error("The DOM query (" + t + ") returned 0 elements");
    return;
  }
  return z.each(i, function(o) {
    z.register_event(o, this.override_event, function(s) {
      var a = {}, c = A.create_properties(r, this), l = A.mp.get_config("track_links_timeout");
      A.event_handler(s, this, a), window.setTimeout(A.track_callback(n, c, a, !0), l), A.mp.track(e, c, A.track_callback(n, c, a));
    });
  }, this), !0;
};
Ls.prototype.track_callback = function(t, e, r, n) {
  n = n || !1;
  var A = this;
  return function() {
    r.callback_fired || (r.callback_fired = !0, !(t && t(n, e) === !1) && A.after_track_handler(e, r, n));
  };
};
Ls.prototype.create_properties = function(t, e) {
  var r;
  return typeof t == "function" ? r = t(e) : r = z.extend({}, t), r;
};
var yu = function() {
  this.override_event = "click";
};
z.inherit(yu, Ls);
yu.prototype.create_properties = function(t, e) {
  var r = yu.superclass.create_properties.apply(this, arguments);
  return e.href && (r.url = e.href), r;
};
yu.prototype.event_handler = function(t, e, r) {
  r.new_tab = t.which === 2 || t.metaKey || t.ctrlKey || e.target === "_blank", r.href = e.href, r.new_tab || t.preventDefault();
};
yu.prototype.after_track_handler = function(t, e) {
  e.new_tab || setTimeout(function() {
    window.location = e.href;
  }, 0);
};
var cg = function() {
  this.override_event = "submit";
};
z.inherit(cg, Ls);
cg.prototype.event_handler = function(t, e, r) {
  r.element = e, t.preventDefault();
};
cg.prototype.after_track_handler = function(t, e) {
  setTimeout(function() {
    e.element.submit();
  }, 0);
};
var Da = "$set", Cu = "$set_once", oo = "$unset", Vc = "$add", Ro = "$append", Wc = "$union", qs = "$remove", bz = "$delete", Tk = {
  set_action: function(t, e) {
    var r = {}, n = {};
    return z.isObject(t) ? z.each(t, function(A, i) {
      this._is_reserved_property(i) || (n[i] = A);
    }, this) : n[t] = e, r[Da] = n, r;
  },
  unset_action: function(t) {
    var e = {}, r = [];
    return z.isArray(t) || (t = [t]), z.each(t, function(n) {
      this._is_reserved_property(n) || r.push(n);
    }, this), e[oo] = r, e;
  },
  set_once_action: function(t, e) {
    var r = {}, n = {};
    return z.isObject(t) ? z.each(t, function(A, i) {
      this._is_reserved_property(i) || (n[i] = A);
    }, this) : n[t] = e, r[Cu] = n, r;
  },
  union_action: function(t, e) {
    var r = {}, n = {};
    return z.isObject(t) ? z.each(t, function(A, i) {
      this._is_reserved_property(i) || (n[i] = z.isArray(A) ? A : [A]);
    }, this) : n[t] = z.isArray(e) ? e : [e], r[Wc] = n, r;
  },
  append_action: function(t, e) {
    var r = {}, n = {};
    return z.isObject(t) ? z.each(t, function(A, i) {
      this._is_reserved_property(i) || (n[i] = A);
    }, this) : n[t] = e, r[Ro] = n, r;
  },
  remove_action: function(t, e) {
    var r = {}, n = {};
    return z.isObject(t) ? z.each(t, function(A, i) {
      this._is_reserved_property(i) || (n[i] = A);
    }, this) : n[t] = e, r[qs] = n, r;
  },
  delete_action: function() {
    var t = {};
    return t[bz] = "", t;
  }
}, nn = function() {
};
z.extend(nn.prototype, Tk);
nn.prototype._init = function(t, e, r) {
  this._mixpanel = t, this._group_key = e, this._group_id = r;
};
nn.prototype.set = Cd(function(t, e, r) {
  var n = this.set_action(t, e);
  return z.isObject(t) && (r = e), this._send_request(n, r);
});
nn.prototype.set_once = Cd(function(t, e, r) {
  var n = this.set_once_action(t, e);
  return z.isObject(t) && (r = e), this._send_request(n, r);
});
nn.prototype.unset = Cd(function(t, e) {
  var r = this.unset_action(t);
  return this._send_request(r, e);
});
nn.prototype.union = Cd(function(t, e, r) {
  z.isObject(t) && (r = e);
  var n = this.union_action(t, e);
  return this._send_request(n, r);
});
nn.prototype.delete = Cd(function(t) {
  var e = this.delete_action();
  return this._send_request(e, t);
});
nn.prototype.remove = Cd(function(t, e, r) {
  var n = this.remove_action(t, e);
  return this._send_request(n, r);
});
nn.prototype._send_request = function(t, e) {
  t.$group_key = this._group_key, t.$group_id = this._group_id, t.$token = this._get_config("token");
  var r = z.encodeDates(t);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: r,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").groups,
    batcher: this._mixpanel.request_batchers.groups
  }, e);
};
nn.prototype._is_reserved_property = function(t) {
  return t === "$group_key" || t === "$group_id";
};
nn.prototype._get_config = function(t) {
  return this._mixpanel.get_config(t);
};
nn.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
nn.prototype.remove = nn.prototype.remove;
nn.prototype.set = nn.prototype.set;
nn.prototype.set_once = nn.prototype.set_once;
nn.prototype.union = nn.prototype.union;
nn.prototype.unset = nn.prototype.unset;
nn.prototype.toString = nn.prototype.toString;
var er = function() {
};
z.extend(er.prototype, Tk);
er.prototype._init = function(t) {
  this._mixpanel = t;
};
er.prototype.set = Ka(function(t, e, r) {
  var n = this.set_action(t, e);
  return z.isObject(t) && (r = e), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), n[Da] = z.extend(
    {},
    z.info.people_properties(),
    n[Da]
  ), this._send_request(n, r);
});
er.prototype.set_once = Ka(function(t, e, r) {
  var n = this.set_once_action(t, e);
  return z.isObject(t) && (r = e), this._send_request(n, r);
});
er.prototype.unset = Ka(function(t, e) {
  var r = this.unset_action(t);
  return this._send_request(r, e);
});
er.prototype.increment = Ka(function(t, e, r) {
  var n = {}, A = {};
  return z.isObject(t) ? (z.each(t, function(i, o) {
    if (!this._is_reserved_property(o))
      if (isNaN(parseFloat(i))) {
        Sr.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        A[o] = i;
  }, this), r = e) : (z.isUndefined(e) && (e = 1), A[t] = e), n[Vc] = A, this._send_request(n, r);
});
er.prototype.append = Ka(function(t, e, r) {
  z.isObject(t) && (r = e);
  var n = this.append_action(t, e);
  return this._send_request(n, r);
});
er.prototype.remove = Ka(function(t, e, r) {
  z.isObject(t) && (r = e);
  var n = this.remove_action(t, e);
  return this._send_request(n, r);
});
er.prototype.union = Ka(function(t, e, r) {
  z.isObject(t) && (r = e);
  var n = this.union_action(t, e);
  return this._send_request(n, r);
});
er.prototype.track_charge = Ka(function(t, e, r) {
  if (!z.isNumber(t) && (t = parseFloat(t), isNaN(t))) {
    Sr.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
    return;
  }
  return this.append("$transactions", z.extend({
    $amount: t
  }, e), r);
});
er.prototype.clear_charges = function(t) {
  return this.set("$transactions", [], t);
};
er.prototype.delete_user = function() {
  if (!this._identify_called()) {
    Sr.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var t = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(t);
};
er.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
er.prototype._send_request = function(t, e) {
  t.$token = this._get_config("token"), t.$distinct_id = this._mixpanel.get_distinct_id();
  var r = this._mixpanel.get_property("$device_id"), n = this._mixpanel.get_property("$user_id"), A = this._mixpanel.get_property("$had_persisted_distinct_id");
  r && (t.$device_id = r), n && (t.$user_id = n), A && (t.$had_persisted_distinct_id = A);
  var i = z.encodeDates(t);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: i,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").engage,
    batcher: this._mixpanel.request_batchers.people
  }, e) : (this._enqueue(t), z.isUndefined(e) || (this._get_config("verbose") ? e({ status: -1, error: null }) : e(-1)), z.truncate(i, 255));
};
er.prototype._get_config = function(t) {
  return this._mixpanel.get_config(t);
};
er.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
er.prototype._enqueue = function(t) {
  Da in t ? this._mixpanel.persistence._add_to_people_queue(Da, t) : Cu in t ? this._mixpanel.persistence._add_to_people_queue(Cu, t) : oo in t ? this._mixpanel.persistence._add_to_people_queue(oo, t) : Vc in t ? this._mixpanel.persistence._add_to_people_queue(Vc, t) : Ro in t ? this._mixpanel.persistence._add_to_people_queue(Ro, t) : qs in t ? this._mixpanel.persistence._add_to_people_queue(qs, t) : Wc in t ? this._mixpanel.persistence._add_to_people_queue(Wc, t) : Sr.error("Invalid call to _enqueue():", t);
};
er.prototype._flush_one_queue = function(t, e, r, n) {
  var A = this, i = z.extend({}, this._mixpanel.persistence.load_queue(t)), o = i;
  !z.isUndefined(i) && z.isObject(i) && !z.isEmptyObject(i) && (A._mixpanel.persistence._pop_from_people_queue(t, i), A._mixpanel.persistence.save(), n && (o = n(i)), e.call(A, o, function(s, a) {
    s === 0 && A._mixpanel.persistence._add_to_people_queue(t, i), z.isUndefined(r) || r(s, a);
  }));
};
er.prototype._flush = function(t, e, r, n, A, i, o) {
  var s = this;
  this._flush_one_queue(Da, this.set, t), this._flush_one_queue(Cu, this.set_once, n), this._flush_one_queue(oo, this.unset, i, function(p) {
    return z.keys(p);
  }), this._flush_one_queue(Vc, this.increment, e), this._flush_one_queue(Wc, this.union, A);
  var a = this._mixpanel.persistence.load_queue(Ro);
  if (!z.isUndefined(a) && z.isArray(a) && a.length)
    for (var c, l = function(p, v) {
      p === 0 && s._mixpanel.persistence._add_to_people_queue(Ro, c), z.isUndefined(r) || r(p, v);
    }, u = a.length - 1; u >= 0; u--)
      a = this._mixpanel.persistence.load_queue(Ro), c = a.pop(), s._mixpanel.persistence.save(), z.isEmptyObject(c) || s.append(c, l);
  var f = this._mixpanel.persistence.load_queue(qs);
  if (!z.isUndefined(f) && z.isArray(f) && f.length)
    for (var d, g = function(p, v) {
      p === 0 && s._mixpanel.persistence._add_to_people_queue(qs, d), z.isUndefined(o) || o(p, v);
    }, m = f.length - 1; m >= 0; m--)
      f = this._mixpanel.persistence.load_queue(qs), d = f.pop(), s._mixpanel.persistence.save(), z.isEmptyObject(d) || s.remove(d, g);
};
er.prototype._is_reserved_property = function(t) {
  return t === "$distinct_id" || t === "$token" || t === "$device_id" || t === "$user_id" || t === "$had_persisted_distinct_id";
};
er.prototype.set = er.prototype.set;
er.prototype.set_once = er.prototype.set_once;
er.prototype.unset = er.prototype.unset;
er.prototype.increment = er.prototype.increment;
er.prototype.append = er.prototype.append;
er.prototype.remove = er.prototype.remove;
er.prototype.union = er.prototype.union;
er.prototype.track_charge = er.prototype.track_charge;
er.prototype.clear_charges = er.prototype.clear_charges;
er.prototype.delete_user = er.prototype.delete_user;
er.prototype.toString = er.prototype.toString;
var Sm = "__mps", Pm = "__mpso", km = "__mpus", Om = "__mpa", Fm = "__mpap", Tm = "__mpr", Mm = "__mpu", Mk = "$people_distinct_id", Wh = "__alias", p2 = "__timers", Bz = [
  Sm,
  Pm,
  km,
  Om,
  Fm,
  Tm,
  Mm,
  Mk,
  Wh,
  p2
], pr = function(t) {
  this.props = {}, this.campaign_params_saved = !1, t.persistence_name ? this.name = "mp_" + t.persistence_name : this.name = "mp_" + t.token + "_mixpanel";
  var e = t.persistence;
  e !== "cookie" && e !== "localStorage" && (Sr.critical("Unknown persistence type " + e + "; falling back to cookie"), e = t.persistence = "cookie"), e === "localStorage" && z.localStorage.is_supported() ? this.storage = z.localStorage : this.storage = z.cookie, this.load(), this.update_config(t), this.upgrade(), this.save();
};
pr.prototype.properties = function() {
  var t = {};
  return this.load(), z.each(this.props, function(e, r) {
    z.include(Bz, r) || (t[r] = e);
  }), t;
};
pr.prototype.load = function() {
  if (!this.disabled) {
    var t = this.storage.parse(this.name);
    t && (this.props = z.extend({}, t));
  }
};
pr.prototype.upgrade = function() {
  var t, e;
  this.storage === z.localStorage ? (t = z.cookie.parse(this.name), z.cookie.remove(this.name), z.cookie.remove(this.name, !0), t && this.register_once(t)) : this.storage === z.cookie && (e = z.localStorage.parse(this.name), z.localStorage.remove(this.name), e && this.register_once(e));
};
pr.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    z.JSONEncode(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
pr.prototype.load_prop = function(t) {
  return this.load(), this.props[t];
};
pr.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
pr.prototype.clear = function() {
  this.remove(), this.props = {};
};
pr.prototype.register_once = function(t, e, r) {
  return z.isObject(t) ? (typeof e > "u" && (e = "None"), this.expire_days = typeof r > "u" ? this.default_expiry : r, this.load(), z.each(t, function(n, A) {
    (!this.props.hasOwnProperty(A) || this.props[A] === e) && (this.props[A] = n);
  }, this), this.save(), !0) : !1;
};
pr.prototype.register = function(t, e) {
  return z.isObject(t) ? (this.expire_days = typeof e > "u" ? this.default_expiry : e, this.load(), z.extend(this.props, t), this.save(), !0) : !1;
};
pr.prototype.unregister = function(t) {
  this.load(), t in this.props && (delete this.props[t], this.save());
};
pr.prototype.update_search_keyword = function(t) {
  this.register(z.info.searchInfo(t));
};
pr.prototype.update_referrer_info = function(t) {
  this.register_once({
    $initial_referrer: t || "$direct",
    $initial_referring_domain: z.info.referringDomain(t) || "$direct"
  }, "");
};
pr.prototype.get_referrer_info = function() {
  return z.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
pr.prototype.update_config = function(t) {
  this.default_expiry = this.expire_days = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cookie_domain(t.cookie_domain), this.set_cross_site(t.cross_site_cookie), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie);
};
pr.prototype.set_disabled = function(t) {
  this.disabled = t, this.disabled ? this.remove() : this.save();
};
pr.prototype.set_cookie_domain = function(t) {
  t !== this.cookie_domain && (this.remove(), this.cookie_domain = t, this.save());
};
pr.prototype.set_cross_site = function(t) {
  t !== this.cross_site && (this.cross_site = t, this.remove(), this.save());
};
pr.prototype.set_cross_subdomain = function(t) {
  t !== this.cross_subdomain && (this.cross_subdomain = t, this.remove(), this.save());
};
pr.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
pr.prototype.set_secure = function(t) {
  t !== this.secure && (this.secure = !!t, this.remove(), this.save());
};
pr.prototype._add_to_people_queue = function(t, e) {
  var r = this._get_queue_key(t), n = e[t], A = this._get_or_create_queue(Da), i = this._get_or_create_queue(Cu), o = this._get_or_create_queue(oo), s = this._get_or_create_queue(Vc), a = this._get_or_create_queue(Wc), c = this._get_or_create_queue(qs, []), l = this._get_or_create_queue(Ro, []);
  r === Sm ? (z.extend(A, n), this._pop_from_people_queue(Vc, n), this._pop_from_people_queue(Wc, n), this._pop_from_people_queue(oo, n)) : r === Pm ? (z.each(n, function(u, f) {
    f in i || (i[f] = u);
  }), this._pop_from_people_queue(oo, n)) : r === km ? z.each(n, function(u) {
    z.each([A, i, s, a], function(f) {
      u in f && delete f[u];
    }), z.each(l, function(f) {
      u in f && delete f[u];
    }), o[u] = !0;
  }) : r === Om ? (z.each(n, function(u, f) {
    f in A ? A[f] += u : (f in s || (s[f] = 0), s[f] += u);
  }, this), this._pop_from_people_queue(oo, n)) : r === Mm ? (z.each(n, function(u, f) {
    z.isArray(u) && (f in a || (a[f] = []), a[f] = a[f].concat(u));
  }), this._pop_from_people_queue(oo, n)) : r === Tm ? (c.push(n), this._pop_from_people_queue(Ro, n)) : r === Fm && (l.push(n), this._pop_from_people_queue(oo, n)), Sr.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), Sr.log(e), this.save();
};
pr.prototype._pop_from_people_queue = function(t, e) {
  var r = this.props[this._get_queue_key(t)];
  z.isUndefined(r) || z.each(e, function(n, A) {
    t === Ro || t === qs ? z.each(r, function(i) {
      i[A] === n && delete i[A];
    }) : delete r[A];
  }, this);
};
pr.prototype.load_queue = function(t) {
  return this.load_prop(this._get_queue_key(t));
};
pr.prototype._get_queue_key = function(t) {
  if (t === Da)
    return Sm;
  if (t === Cu)
    return Pm;
  if (t === oo)
    return km;
  if (t === Vc)
    return Om;
  if (t === Ro)
    return Fm;
  if (t === qs)
    return Tm;
  if (t === Wc)
    return Mm;
  Sr.error("Invalid queue:", t);
};
pr.prototype._get_or_create_queue = function(t, e) {
  var r = this._get_queue_key(t);
  return e = z.isUndefined(e) ? {} : e, this.props[r] || (this.props[r] = e);
};
pr.prototype.set_event_timer = function(t, e) {
  var r = this.load_prop(p2) || {};
  r[t] = e, this.props[p2] = r, this.save();
};
pr.prototype.remove_event_timer = function(t) {
  var e = this.load_prop(p2) || {}, r = e[t];
  return z.isUndefined(r) || (delete this.props[p2][t], this.save()), r;
};
var Hm, Hk = function(t, e) {
  throw new Error(t + " not available in this build.");
}, kA, Dk = 0, Ez = 1, xz = function(t) {
  return t;
}, g2 = function() {
}, Qi = "mixpanel", Qk = "base64", Iz = "json", Dm = "$device:", ru = wt.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), Uk = !ru && Mo.indexOf("MSIE") === -1 && Mo.indexOf("Mozilla") === -1, Xh = null;
qa.sendBeacon && (Xh = function() {
  return qa.sendBeacon.apply(qa, arguments);
});
var Nk = {
  track: "track/",
  engage: "engage/",
  groups: "groups/",
  record: "record/"
}, xC = {
  api_host: "https://api-js.mixpanel.com",
  api_routes: Nk,
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: Qk,
  app_host: "https://mixpanel.com",
  autocapture: !1,
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: g2,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: g2,
  mp_loader: null,
  track_marketing: !0,
  track_pageview: !1,
  skip_first_touch_marketing: !1,
  store_google: !0,
  stop_utm_persistence: !1,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  // { header: value, header2: value }
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {},
  record_block_class: new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
  record_block_selector: "img, video",
  record_canvas: !1,
  record_collect_fonts: !1,
  record_idle_timeout_ms: 30 * 60 * 1e3,
  // 30 minutes
  record_mask_text_class: new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
  record_mask_text_selector: "*",
  record_max_ms: z0,
  record_min_ms: 0,
  record_sessions_percent: 0,
  recorder_src: "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
}, jk = !1, we = function() {
}, f5 = function(t, e, r) {
  var n, A = r === Qi ? kA : kA[r];
  if (A && Hm === Dk)
    n = A;
  else {
    if (A && !z.isArray(A)) {
      Sr.error("You have already initialized " + r);
      return;
    }
    n = new we();
  }
  if (n._cached_groups = {}, n._init(t, e, r), n.people = new er(), n.people._init(n), !n.get_config("skip_first_touch_marketing")) {
    var i = z.info.campaignParams(null), o = {}, s = !1;
    z.each(i, function(a, c) {
      o["initial_" + c] = a, a && (s = !0);
    }), s && n.people.set_once(o);
  }
  return fo.DEBUG = fo.DEBUG || n.get_config("debug"), !z.isUndefined(A) && z.isArray(A) && (n._execute_array.call(n.people, A.people), n._execute_array(A)), n;
};
we.prototype.init = function(t, e, r) {
  if (z.isUndefined(r)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (r === Qi) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var n = f5(t, e, r);
  return kA[r] = n, n._loaded(), n;
};
we.prototype._init = function(t, e, r) {
  e = e || {}, this.__loaded = !0, this.config = {};
  var n = {};
  if (!("api_payload_format" in e)) {
    var A = e.api_host || xC.api_host;
    A.match(/\.mixpanel\.com/) && (n.api_payload_format = Iz);
  }
  if (this.set_config(z.extend({}, xC, n, e, {
    name: r,
    token: t,
    callback_fn: (r === Qi ? r : Qi + "." + r) + "._jsc"
  })), this._jsc = g2, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!z.localStorage.is_supported(!0) || !ru)
      this._batch_requests = !1, Sr.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support"), z.each(this.get_batcher_configs(), function(s) {
        Sr.log("Clearing batch queue " + s.queue_key), z.localStorage.remove(s.queue_key);
      });
    else if (this.init_batchers(), Xh && wt.addEventListener) {
      var i = z.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      wt.addEventListener("pagehide", function(s) {
        s.persisted && i();
      }), wt.addEventListener("visibilitychange", function() {
        Nr.visibilityState === "hidden" && i();
      });
    }
  }
  this.persistence = this.cookie = new pr(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var o = z.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: Dm + o,
    $device_id: o
  }, ""), this.autocapture = new Bi(this), this.autocapture.init(), this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent") && this.start_session_recording();
};
we.prototype.start_session_recording = Xa(function() {
  if (!wt.MutationObserver) {
    Sr.critical("Browser does not support MutationObserver; skipping session recording");
    return;
  }
  var t = z.bind(function() {
    this._recorder = this._recorder || new wt.__mp_recorder(this), this._recorder.startRecording();
  }, this);
  z.isUndefined(wt.__mp_recorder) ? Hk(this.get_config("recorder_src"), t) : t();
});
we.prototype.stop_session_recording = function() {
  this._recorder ? this._recorder.stopRecording() : Sr.critical("Session recorder module not loaded");
};
we.prototype.get_session_recording_properties = function() {
  var t = {}, e = this._get_session_replay_id();
  return e && (t.$mp_replay_id = e), t;
};
we.prototype.get_session_replay_url = function() {
  var t = null, e = this._get_session_replay_id();
  if (e) {
    var r = z.HTTPBuildQuery({
      replay_id: e,
      distinct_id: this.get_distinct_id(),
      token: this.get_config("token")
    });
    t = "https://mixpanel.com/projects/replay-redirect?" + r;
  }
  return t;
};
we.prototype._get_session_replay_id = function() {
  var t = null;
  return this._recorder && (t = this._recorder.replayId), t || null;
};
we.prototype._loaded = function() {
  if (this.get_config("loaded")(this), this._set_default_superprops(), this.people.set_once(this.persistence.get_referrer_info()), this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
    var t = z.info.campaignParams(null);
    z.each(t, (function(e, r) {
      this.unregister(r);
    }).bind(this));
  }
};
we.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(Nr.referrer), this.get_config("store_google") && !this.get_config("stop_utm_persistence") && this.register(z.info.campaignParams()), this.get_config("save_referrer") && this.persistence.update_referrer_info(Nr.referrer);
};
we.prototype._dom_loaded = function() {
  z.each(this.__dom_loaded_queue, function(t) {
    this._track_dom.apply(this, t);
  }, this), this.has_opted_out_tracking() || z.each(this.__request_queue, function(t) {
    this._send_request.apply(this, t);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
we.prototype._track_dom = function(t, e) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!jk)
    return this.__dom_loaded_queue.push([t, e]), !1;
  var r = new t().init(this);
  return r.track.apply(r, e);
};
we.prototype._prepare_callback = function(t, e) {
  if (z.isUndefined(t))
    return null;
  if (ru) {
    var r = function(o) {
      t(o, e);
    };
    return r;
  } else {
    var n = this._jsc, A = "" + Math.floor(Math.random() * 1e8), i = this.get_config("callback_fn") + "[" + A + "]";
    return n[A] = function(o) {
      delete n[A], t(o, e);
    }, i;
  }
};
we.prototype._send_request = function(t, e, r, n) {
  var A = !0;
  if (Uk)
    return this.__request_queue.push(arguments), A;
  var i = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, o = null;
  !n && (z.isFunction(r) || typeof r == "string") && (n = r, r = null), r = z.extend(i, r || {}), ru || (r.method = "GET");
  var s = r.method === "POST", a = Xh && s && r.transport.toLowerCase() === "sendbeacon", c = r.verbose;
  e.verbose && (c = !0), this.get_config("test") && (e.test = 1), c && (e.verbose = 1), this.get_config("img") && (e.img = 1), ru || (n ? e.callback = n : (c || this.get_config("test")) && (e.callback = "(function(){})")), e.ip = this.get_config("ip") ? 1 : 0, e._ = (/* @__PURE__ */ new Date()).getTime().toString(), s && (o = "data=" + encodeURIComponent(e.data), delete e.data), t += "?" + z.HTTPBuildQuery(e);
  var l = this;
  if ("img" in e) {
    var u = Nr.createElement("img");
    u.src = t, Nr.body.appendChild(u);
  } else if (a) {
    try {
      A = Xh(t, o);
    } catch (v) {
      l.report_error(v), A = !1;
    }
    try {
      n && n(A ? 1 : 0);
    } catch (v) {
      l.report_error(v);
    }
  } else if (ru)
    try {
      var f = new XMLHttpRequest();
      f.open(r.method, t, !0);
      var d = this.get_config("xhr_headers");
      if (s && (d["Content-Type"] = "application/x-www-form-urlencoded"), z.each(d, function(v, C) {
        f.setRequestHeader(C, v);
      }), r.timeout_ms && typeof f.timeout < "u") {
        f.timeout = r.timeout_ms;
        var g = (/* @__PURE__ */ new Date()).getTime();
      }
      f.withCredentials = !0, f.onreadystatechange = function() {
        if (f.readyState === 4)
          if (f.status === 200) {
            if (n)
              if (c) {
                var v;
                try {
                  v = z.JSONDecode(f.responseText);
                } catch (B) {
                  if (l.report_error(B), r.ignore_json_errors)
                    v = f.responseText;
                  else
                    return;
                }
                n(v);
              } else
                n(Number(f.responseText));
          } else {
            var C;
            if (f.timeout && !f.status && (/* @__PURE__ */ new Date()).getTime() - g >= f.timeout ? C = "timeout" : C = "Bad HTTP status: " + f.status + " " + f.statusText, l.report_error(C), n)
              if (c) {
                var w = f.responseHeaders || {};
                n({ status: 0, httpStatusCode: f.status, error: C, retryAfter: w["Retry-After"] });
              } else
                n(0);
          }
      }, f.send(o);
    } catch (v) {
      l.report_error(v), A = !1;
    }
  else {
    var m = Nr.createElement("script");
    m.type = "text/javascript", m.async = !0, m.defer = !0, m.src = t;
    var p = Nr.getElementsByTagName("script")[0];
    p.parentNode.insertBefore(m, p);
  }
  return A;
};
we.prototype._execute_array = function(t) {
  var e, r = [], n = [], A = [];
  z.each(t, function(o) {
    o && (e = o[0], z.isArray(e) ? A.push(o) : typeof o == "function" ? o.call(this) : z.isArray(o) && e === "alias" ? r.push(o) : z.isArray(o) && e.indexOf("track") !== -1 && typeof this[e] == "function" ? A.push(o) : n.push(o));
  }, this);
  var i = function(o, s) {
    z.each(o, function(a) {
      if (z.isArray(a[0])) {
        var c = s;
        z.each(a, function(l) {
          c = c[l[0]].apply(c, l.slice(1));
        });
      } else
        this[a[0]].apply(this, a.slice(1));
    }, s);
  };
  i(r, this), i(n, this), i(A, this);
};
we.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
we.prototype.get_batcher_configs = function() {
  var t = "__mpq_" + this.get_config("token"), e = this.get_config("api_routes");
  return this._batcher_configs = this._batcher_configs || {
    events: { type: "events", endpoint: "/" + e.track, queue_key: t + "_ev" },
    people: { type: "people", endpoint: "/" + e.engage, queue_key: t + "_pp" },
    groups: { type: "groups", endpoint: "/" + e.groups, queue_key: t + "_gr" }
  }, this._batcher_configs;
};
we.prototype.init_batchers = function() {
  if (!this.are_batchers_initialized()) {
    var t = z.bind(function(r) {
      return new Wi(
        r.queue_key,
        {
          libConfig: this.config,
          errorReporter: this.get_config("error_reporter"),
          sendRequestFunc: z.bind(function(n, A, i) {
            this._send_request(
              this.get_config("api_host") + r.endpoint,
              this._encode_data_for_request(n),
              A,
              this._prepare_callback(i, n)
            );
          }, this),
          beforeSendHook: z.bind(function(n) {
            return this._run_hook("before_send_" + r.type, n);
          }, this),
          stopAllBatchingFunc: z.bind(this.stop_batch_senders, this),
          usePersistence: !0
        }
      );
    }, this), e = this.get_batcher_configs();
    this.request_batchers = {
      events: t(e.events),
      people: t(e.people),
      groups: t(e.groups)
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
we.prototype.start_batch_senders = function() {
  this._batchers_were_started = !0, this.are_batchers_initialized() && (this._batch_requests = !0, z.each(this.request_batchers, function(t) {
    t.start();
  }));
};
we.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, z.each(this.request_batchers, function(t) {
    t.stop(), t.clear();
  });
};
we.prototype.push = function(t) {
  this._execute_array([t]);
};
we.prototype.disable = function(t) {
  typeof t > "u" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(t);
};
we.prototype._encode_data_for_request = function(t) {
  var e = z.JSONEncode(t);
  return this.get_config("api_payload_format") === Qk && (e = z.base64Encode(e)), { data: e };
};
we.prototype._track_or_batch = function(t, e) {
  var r = z.truncate(t.data, 255), n = t.endpoint, A = t.batcher, i = t.should_send_immediately, o = t.send_request_options || {};
  e = e || g2;
  var s = !0, a = z.bind(function() {
    return o.skip_hooks || (r = this._run_hook("before_send_" + t.type, r)), r ? (Sr.log("MIXPANEL REQUEST:"), Sr.log(r), this._send_request(
      n,
      this._encode_data_for_request(r),
      o,
      this._prepare_callback(e, r)
    )) : null;
  }, this);
  return this._batch_requests && !i ? A.enqueue(r).then(function(c) {
    c ? e(1, r) : a();
  }) : s = a(), s && r;
};
we.prototype.track = Xa(function(t, e, r, n) {
  !n && typeof r == "function" && (n = r, r = null), r = r || {};
  var A = r.transport;
  A && (r.transport = A);
  var i = r.send_immediately;
  if (typeof n != "function" && (n = g2), z.isUndefined(t)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(t)) {
    n(0);
    return;
  }
  e = z.extend({}, e), e.token = this.get_config("token");
  var o = this.persistence.remove_event_timer(t);
  if (!z.isUndefined(o)) {
    var s = (/* @__PURE__ */ new Date()).getTime() - o;
    e.$duration = parseFloat((s / 1e3).toFixed(3));
  }
  this._set_default_superprops();
  var a = this.get_config("track_marketing") ? z.info.marketingParams() : {};
  e = z.extend(
    {},
    z.info.properties({ mp_loader: this.get_config("mp_loader") }),
    a,
    this.persistence.properties(),
    this.unpersisted_superprops,
    this.get_session_recording_properties(),
    e
  );
  var c = this.get_config("property_blacklist");
  z.isArray(c) ? z.each(c, function(f) {
    delete e[f];
  }) : this.report_error("Invalid value for property_blacklist config: " + c);
  var l = {
    event: t,
    properties: e
  }, u = this._track_or_batch({
    type: "events",
    data: l,
    endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes").track,
    batcher: this.request_batchers.events,
    should_send_immediately: i,
    send_request_options: r
  }, n);
  return u;
});
we.prototype.set_group = Xa(function(t, e, r) {
  z.isArray(e) || (e = [e]);
  var n = {};
  return n[t] = e, this.register(n), this.people.set(t, e, r);
});
we.prototype.add_group = Xa(function(t, e, r) {
  var n = this.get_property(t), A = {};
  return n === void 0 ? (A[t] = [e], this.register(A)) : n.indexOf(e) === -1 && (n.push(e), A[t] = n, this.register(A)), this.people.union(t, e, r);
});
we.prototype.remove_group = Xa(function(t, e, r) {
  var n = this.get_property(t);
  if (n !== void 0) {
    var A = n.indexOf(e);
    A > -1 && (n.splice(A, 1), this.register({ group_key: n })), n.length === 0 && this.unregister(t);
  }
  return this.people.remove(t, e, r);
});
we.prototype.track_with_groups = Xa(function(t, e, r, n) {
  var A = z.extend({}, e || {});
  return z.each(r, function(i, o) {
    i != null && (A[o] = i);
  }), this.track(t, A, n);
});
we.prototype._create_map_key = function(t, e) {
  return t + "_" + JSON.stringify(e);
};
we.prototype._remove_group_from_cache = function(t, e) {
  delete this._cached_groups[this._create_map_key(t, e)];
};
we.prototype.get_group = function(t, e) {
  var r = this._create_map_key(t, e), n = this._cached_groups[r];
  return (n === void 0 || n._group_key !== t || n._group_id !== e) && (n = new nn(), n._init(this, t, e), this._cached_groups[r] = n), n;
};
we.prototype.track_pageview = Xa(function(t, e) {
  typeof t != "object" && (t = {}), e = e || {};
  var r = e.event_name || "$mp_web_page_view", n = z.extend(
    z.info.mpPageViewProperties(),
    z.info.campaignParams(),
    z.info.clickParams()
  ), A = z.extend(
    {},
    n,
    t
  );
  return this.track(r, A);
});
we.prototype.track_links = function() {
  return this._track_dom.call(this, yu, arguments);
};
we.prototype.track_forms = function() {
  return this._track_dom.call(this, cg, arguments);
};
we.prototype.time_event = function(t) {
  if (z.isUndefined(t)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(t) || this.persistence.set_event_timer(t, (/* @__PURE__ */ new Date()).getTime());
};
var Sz = {
  persistent: !0
}, Qm = function(t) {
  var e;
  return z.isObject(t) ? e = t : z.isUndefined(t) ? e = {} : e = { days: t }, z.extend({}, Sz, e);
};
we.prototype.register = function(t, e) {
  var r = Qm(e);
  r.persistent ? this.persistence.register(t, r.days) : z.extend(this.unpersisted_superprops, t);
};
we.prototype.register_once = function(t, e, r) {
  var n = Qm(r);
  n.persistent ? this.persistence.register_once(t, e, n.days) : (typeof e > "u" && (e = "None"), z.each(t, function(A, i) {
    (!this.unpersisted_superprops.hasOwnProperty(i) || this.unpersisted_superprops[i] === e) && (this.unpersisted_superprops[i] = A);
  }, this));
};
we.prototype.unregister = function(t, e) {
  e = Qm(e), e.persistent ? this.persistence.unregister(t) : delete this.unpersisted_superprops[t];
};
we.prototype._register_single = function(t, e) {
  var r = {};
  r[t] = e, this.register(r);
};
we.prototype.identify = function(t, e, r, n, A, i, o, s) {
  var a = this.get_distinct_id();
  if (t && a !== t) {
    if (typeof t == "string" && t.indexOf(Dm) === 0)
      return this.report_error("distinct_id cannot have $device: prefix"), -1;
    this.register({ $user_id: t });
  }
  if (!this.get_property("$device_id")) {
    var c = a;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: c
    }, "");
  }
  t !== a && t !== this.get_property(Wh) && (this.unregister(Wh), this.register({ distinct_id: t })), this._flags.identify_called = !0, this.people._flush(e, r, n, A, i, o, s), t !== a && this.track("$identify", {
    distinct_id: t,
    $anon_distinct_id: a
  }, { skip_hooks: !0 });
};
we.prototype.reset = function() {
  this.persistence.clear(), this._flags.identify_called = !1;
  var t = z.UUID();
  this.register_once({
    distinct_id: Dm + t,
    $device_id: t
  }, "");
};
we.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
we.prototype.alias = function(t, e) {
  if (t === this.get_property(Mk))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var r = this;
  return z.isUndefined(e) && (e = this.get_distinct_id()), t !== e ? (this._register_single(Wh, t), this.track("$create_alias", {
    alias: t,
    distinct_id: e
  }, {
    skip_hooks: !0
  }, function() {
    r.identify(t);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(t), -1);
};
we.prototype.name_tag = function(t) {
  this._register_single("mp_name_tag", t);
};
we.prototype.set_config = function(t) {
  if (z.isObject(t)) {
    z.extend(this.config, t);
    var e = t.batch_size;
    e && z.each(this.request_batchers, function(r) {
      r.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), fo.DEBUG = fo.DEBUG || this.get_config("debug"), "autocapture" in t && this.autocapture && this.autocapture.init();
  }
};
we.prototype.get_config = function(t) {
  return this.config[t];
};
we.prototype._run_hook = function(t) {
  var e = (this.config.hooks[t] || xz).apply(this, va.call(arguments, 1));
  return typeof e > "u" && (this.report_error(t + " hook did not return a value"), e = null), e;
};
we.prototype.get_property = function(t) {
  return this.persistence.load_prop([t]);
};
we.prototype.toString = function() {
  var t = this.get_config("name");
  return t !== Qi && (t = Qi + "." + t), t;
};
we.prototype._event_is_disabled = function(t) {
  return z.isBlockedUA(Mo) || this._flags.disable_all_events || z.include(this.__disabled_events, t);
};
we.prototype._gdpr_init = function() {
  var t = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  t && z.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || z.cookie.get("mp_optout")) && (z.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
we.prototype._gdpr_update_persistence = function(t) {
  var e;
  if (t && t.clear_persistence)
    e = !0;
  else if (t && t.enable_persistence)
    e = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== e && this.persistence.set_disabled(e), e ? this.stop_batch_senders() : this._batchers_were_started && this.start_batch_senders();
};
we.prototype._gdpr_call_func = function(t, e) {
  return e = z.extend({
    track: z.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, e), z.localStorage.is_supported() || (e.persistence_type = "cookie"), t(this.get_config("token"), {
    track: e.track,
    trackEventName: e.track_event_name,
    trackProperties: e.track_properties,
    persistenceType: e.persistence_type,
    persistencePrefix: e.cookie_prefix,
    cookieDomain: e.cookie_domain,
    cookieExpiration: e.cookie_expiration,
    crossSiteCookie: e.cross_site_cookie,
    crossSubdomainCookie: e.cross_subdomain_cookie,
    secureCookie: e.secure_cookie,
    ignoreDnt: e.ignore_dnt
  });
};
we.prototype.opt_in_tracking = function(t) {
  t = z.extend({
    enable_persistence: !0
  }, t), this._gdpr_call_func(JR, t), this._gdpr_update_persistence(t);
};
we.prototype.opt_out_tracking = function(t) {
  t = z.extend({
    clear_persistence: !0,
    delete_user: !0
  }, t), t.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(_R, t), this._gdpr_update_persistence(t);
};
we.prototype.has_opted_in_tracking = function(t) {
  return this._gdpr_call_func($R, t);
};
we.prototype.has_opted_out_tracking = function(t) {
  return this._gdpr_call_func(Ck, t);
};
we.prototype.clear_opt_in_out_tracking = function(t) {
  t = z.extend({
    enable_persistence: !0
  }, t), this._gdpr_call_func(ez, t), this._gdpr_update_persistence(t);
};
we.prototype.report_error = function(t, e) {
  Sr.error.apply(Sr.error, arguments);
  try {
    !e && !(t instanceof Error) && (t = new Error(t)), this.get_config("error_reporter")(t, e);
  } catch (r) {
    Sr.error(r);
  }
};
we.prototype.init = we.prototype.init;
we.prototype.reset = we.prototype.reset;
we.prototype.disable = we.prototype.disable;
we.prototype.time_event = we.prototype.time_event;
we.prototype.track = we.prototype.track;
we.prototype.track_links = we.prototype.track_links;
we.prototype.track_forms = we.prototype.track_forms;
we.prototype.track_pageview = we.prototype.track_pageview;
we.prototype.register = we.prototype.register;
we.prototype.register_once = we.prototype.register_once;
we.prototype.unregister = we.prototype.unregister;
we.prototype.identify = we.prototype.identify;
we.prototype.alias = we.prototype.alias;
we.prototype.name_tag = we.prototype.name_tag;
we.prototype.set_config = we.prototype.set_config;
we.prototype.get_config = we.prototype.get_config;
we.prototype.get_property = we.prototype.get_property;
we.prototype.get_distinct_id = we.prototype.get_distinct_id;
we.prototype.toString = we.prototype.toString;
we.prototype.opt_out_tracking = we.prototype.opt_out_tracking;
we.prototype.opt_in_tracking = we.prototype.opt_in_tracking;
we.prototype.has_opted_out_tracking = we.prototype.has_opted_out_tracking;
we.prototype.has_opted_in_tracking = we.prototype.has_opted_in_tracking;
we.prototype.clear_opt_in_out_tracking = we.prototype.clear_opt_in_out_tracking;
we.prototype.get_group = we.prototype.get_group;
we.prototype.set_group = we.prototype.set_group;
we.prototype.add_group = we.prototype.add_group;
we.prototype.remove_group = we.prototype.remove_group;
we.prototype.track_with_groups = we.prototype.track_with_groups;
we.prototype.start_batch_senders = we.prototype.start_batch_senders;
we.prototype.stop_batch_senders = we.prototype.stop_batch_senders;
we.prototype.start_session_recording = we.prototype.start_session_recording;
we.prototype.stop_session_recording = we.prototype.stop_session_recording;
we.prototype.get_session_recording_properties = we.prototype.get_session_recording_properties;
we.prototype.get_session_replay_url = we.prototype.get_session_replay_url;
we.prototype.DEFAULT_API_ROUTES = Nk;
pr.prototype.properties = pr.prototype.properties;
pr.prototype.update_search_keyword = pr.prototype.update_search_keyword;
pr.prototype.update_referrer_info = pr.prototype.update_referrer_info;
pr.prototype.get_cross_subdomain = pr.prototype.get_cross_subdomain;
pr.prototype.clear = pr.prototype.clear;
var Gl = {}, Pz = function() {
  z.each(Gl, function(t, e) {
    e !== Qi && (kA[e] = t);
  }), kA._ = z;
}, kz = function() {
  kA.init = function(t, e, r) {
    if (r)
      return kA[r] || (kA[r] = Gl[r] = f5(t, e, r), kA[r]._loaded()), kA[r];
    var n = kA;
    Gl[Qi] ? n = Gl[Qi] : t && (n = f5(t, e, Qi), n._loaded(), Gl[Qi] = n), kA = n, Hm === Ez && (wt[Qi] = kA), Pz();
  };
}, Oz = function() {
  function t() {
    t.done || (t.done = !0, jk = !0, Uk = !1, z.each(Gl, function(n) {
      n._dom_loaded();
    }));
  }
  function e() {
    try {
      Nr.documentElement.doScroll("left");
    } catch {
      setTimeout(e, 1);
      return;
    }
    t();
  }
  if (Nr.addEventListener)
    Nr.readyState === "complete" ? t() : Nr.addEventListener("DOMContentLoaded", t, !1);
  else if (Nr.attachEvent) {
    Nr.attachEvent("onreadystatechange", t);
    var r = !1;
    try {
      r = wt.frameElement === null;
    } catch {
    }
    Nr.documentElement.doScroll && r && e();
  }
  z.register_event(wt, "load", t, !0);
};
function Fz(t) {
  return Hk = t, Hm = Dk, kA = new we(), kz(), kA.init(), Oz(), kA;
}
function Tz(t, e) {
  e();
}
var IC = Fz(Tz), rt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Mz(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var A = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, A.get ? A : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var Ia = {}, DA = {};
Object.defineProperty(DA, "__esModule", { value: !0 });
DA.TEXT_CAMPAIGN_SESSION_ID = DA.SENTRY_PROJECT_ID = DA.questEntityId = DA.STAGING_URL = DA.PRODUCTION_URL = void 0;
DA.PRODUCTION_URL = "https://api.questlabs.ai/api";
DA.STAGING_URL = "https://staging-api.questlabs.ai/api";
DA.questEntityId = "e-0000000000";
DA.SENTRY_PROJECT_ID = "https://8ee118168877cbbe20242e6a180504b6@o1016721.ingest.sentry.io/4506304794263552";
DA.TEXT_CAMPAIGN_SESSION_ID = "quest-text-campaign-session-id";
var Um = {}, lg = {}, ir = {};
Object.defineProperty(ir, "__esModule", { value: !0 });
ir.EligibilityCriteriaFrequencyConst = ir.EntityTokenRecordTypeConst = ir.QuestRewardTypeConst = ir.EligibilityCriteriaSource = ir.EligibilityCriteriaTypeConst = ir.EligibilityCriteriaImportanceConst = ir.EligibilityCriteriaEffortConst = ir.USER_AGENT = ir.HTTP_METHOD = void 0;
ir.HTTP_METHOD = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  DELETE: "DELETE"
};
ir.USER_AGENT = {
  MOBILE: "MOBILE",
  BROWSER: "BROWSER",
  SERVER: "SERVER"
};
ir.EligibilityCriteriaEffortConst = {
  /**
   * Less than 1 min
   */
  E1: "E1",
  /**
   * 1 - 5 mins
   */
  E2: "E2",
  /**
   * 5 - 10 mins
   */
  E3: "E3",
  /**
   * 10 - 30 mins
   */
  E4: "E4",
  /**
   * 30 - 60 mins
   */
  E5: "E5"
};
ir.EligibilityCriteriaImportanceConst = {
  /**
   * Low importance
   */
  I1: "I1",
  /**
   * Moderate importance
   */
  I2: "I2",
  /**
   * Medium importance
   */
  I3: "I3",
  /**
   * High importance
   */
  I4: "I4",
  /**
   * Super importance
   */
  I5: "I5"
};
ir.EligibilityCriteriaTypeConst = {
  NONE: "NONE",
  TWITTER_FOLLOW_ACCOUNT: "TWITTER_FOLLOW_ACCOUNT",
  TWITTER_LIKE_POST: "TWITTER_LIKE_POST",
  TWITTER_COMMENT_POST: "TWITTER_COMMENT_POST",
  TWITTER_RETWEET_POST: "TWITTER_RETWEET_POST",
  TWITTER_JOIN_SPACE: "TWITTER_JOIN_SPACE",
  DISCORD_JOIN_GUILD: "DISCORD_JOIN_GUILD",
  DISCORD_ASSIGNED_ROLE: "DISCORD_ASSIGNED_ROLE",
  LINK_OPEN_READ: "LINK_OPEN_READ",
  CONTRACT_MIN_OWNERSHIP: "CONTRACT_MIN_OWNERSHIP",
  DAPP_METRIC_THRESHOLD: "DAPP_METRIC_THRESHOLD",
  DAPP_STREAK_THRESHOLD: "DAPP_STREAK_THRESHOLD",
  USER_INPUT_TEXT: "USER_INPUT_TEXT",
  USER_INPUT_SINGLE_CHOICE: "USER_INPUT_SINGLE_CHOICE",
  USER_INPUT_MULTI_CHOICE: "USER_INPUT_MULTI_CHOICE",
  USER_INPUT_DATE: "USER_INPUT_DATE",
  TELEGRAM_JOIN_CHANNEL: "TELEGRAM_JOIN_CHANNEL",
  SNAPSHOT_JOIN_SPACE: "SNAPSHOT_JOIN_SPACE",
  SNAPSHOT_VOTE_PROPOSAL: "SNAPSHOT_VOTE_PROPOSAL",
  INSTAGRAM_FOLLOW_ACCOUNT: "INSTAGRAM_FOLLOW_ACCOUNT",
  INSTAGRAM_LIKE_POST: "INSTAGRAM_LIKE_POST",
  INSTAGRAM_COMMENT_POST: "INSTAGRAM_COMMENT_POST",
  MEDIUM_FOLLOW_ACCOUNT: "MEDIUM_FOLLOW_ACCOUNT",
  MEDIUM_LIKE_POST: "MEDIUM_LIKE_POST",
  FACEBOOK_FOLLOW_PAGE: "FACEBOOK_FOLLOW_PAGE",
  LINKEDIN_FOLLOW_PAGE: "LINKEDIN_FOLLOW_PAGE"
};
ir.EligibilityCriteriaSource = {
  USER_INPUT: "USER_INPUT",
  USER_EVENT: "USER_EVENT",
  LINK: "LINK",
  DISCORD: "DISCORD",
  TWITTER: "TWITTER"
};
ir.QuestRewardTypeConst = {
  REWARD_BADGE: "REWARD_BADGE",
  REWARD_XP: "REWARD_XP",
  REWARD_SKILL_SCORE: "REWARD_SKILL_SCORE",
  REWARD_GEMS: "REWARD_GEMS",
  REWARD_COLLECTIBLES: "REWARD_COLLECTIBLES",
  REWARD_DISCORD_ROLE: "REWARD_DISCORD_ROLE",
  REWARD_TOKEN: "REWARD_TOKEN",
  REWARD_CREDIT: "REWARD_CREDIT",
  UNDEFINED_RECORD: "UNDEFINED_RECORD"
};
ir.EntityTokenRecordTypeConst = {
  DISCORD: "DISCORD",
  GOOGLE: "GOOGLE",
  INSTAGRAM: "INSTAGRAM",
  OPENAI: "OPENAI",
  RAPID_API: "RAPID_API",
  STRIPE: "STRIPE",
  TELEGRAM: "TELEGRAM",
  TWITTER: "TWITTER"
};
ir.EligibilityCriteriaFrequencyConst = {
  DAILY: "DAILY",
  MONTHLY: "MONTHLY",
  ONCE: "ONCE",
  WEEKLY: "WEEKLY"
};
var an = {};
Object.defineProperty(an, "__esModule", { value: !0 });
an.validateParams = void 0;
function Hz(t) {
  for (let e in t)
    if (typeof t[e] > "u" || t[e] === null || t[e] === "" || t[e] === void 0)
      throw e === "userId" || e === "token" ? new Error("Invalid action. Please set user or login again") : e === "apiSecret" ? new Error("Invalid action. Please set apiSecret in the base(QuestSdk) class") : new Error(`Invalid ${e}`);
}
an.validateParams = Hz;
var Io = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(lg, "__esModule", { value: !0 });
lg.Badge = void 0;
const So = ir, Po = an;
let Dz = class {
  constructor(e) {
    this.questSdk = e;
  }
  getAllBadgesForUser(e) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: r, token: n } = this.questSdk.getUser();
        (0, Po.validateParams)({ userId: r, token: n });
        const A = "/badges", i = Object.assign({ userId: r }, e == null ? void 0 : e._queryParams);
        return this.questSdk.makeRequest({ url: A, method: So.HTTP_METHOD.GET, headers: e == null ? void 0 : e._headers, queryParams: i });
      } catch (r) {
        throw this.questSdk.captureSentryException(r), r;
      }
    });
  }
  getUserCreatedBadges(e) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: r, token: n } = this.questSdk.getUser();
        (0, Po.validateParams)({ userId: r, token: n });
        const A = `/users/${r}/created-badges`;
        return this.questSdk.makeRequest({
          url: A,
          method: So.HTTP_METHOD.GET,
          headers: e == null ? void 0 : e._headers,
          queryParams: e == null ? void 0 : e._queryParams
        });
      } catch (r) {
        throw this.questSdk.captureSentryException(r), r;
      }
    });
  }
  getAllBadgesForEntity({ entityId: e } = {}, r) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: n } = this.questSdk.getUser(), A = e || this.questSdk.getEntityId();
        (0, Po.validateParams)({ entityId: A });
        const i = `/entities/${A}/badges`, o = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({ url: i, method: So.HTTP_METHOD.GET, headers: r == null ? void 0 : r._headers, queryParams: o });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  addBadgeForEntity({ name: e, imageIPFS: r, description: n, entityId: A, skills: i, userIds: o, endsAt: s, xp: a, airdropEnabled: c, typeData: l, type: u, totalCount: f, visibility: d, proofType: g }, m) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: p, token: v } = this.questSdk.getUser(), C = A || this.questSdk.getEntityId();
        (0, Po.validateParams)({ entityId: C, name: e, imageIPFS: r, description: n, userId: p, token: v });
        const w = `/entities/${C}/badges`, B = Object.assign({ userId: p }, m == null ? void 0 : m._queryParams), y = Object.assign({
          name: e,
          imageIPFS: r,
          description: n,
          skills: i,
          userIds: o,
          endsAt: s,
          xp: a,
          airdropEnabled: c,
          typeData: l,
          type: u,
          totalCount: f,
          visibility: d,
          proofType: g
        }, m == null ? void 0 : m._body);
        return this.questSdk.makeRequest({
          url: w,
          method: So.HTTP_METHOD.POST,
          body: y,
          headers: m == null ? void 0 : m._headers,
          queryParams: B
        });
      } catch (p) {
        throw this.questSdk.captureSentryException(p), p;
      }
    });
  }
  getBadgeInfoForEntity({ entityId: e, badgeId: r, prefixBadgeIpfs: n }, A) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, Po.validateParams)({ entityId: s, badgeId: r, userId: i, token: o });
        const a = `/entities/${s}/badges/${r}`, c = Object.assign(Object.assign({ userId: i }, n && { prefixBadgeIpfs: n }), A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({ url: a, method: So.HTTP_METHOD.GET, headers: A == null ? void 0 : A._headers, queryParams: c });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  updateBadgesForEntity({ badgeId: e, entityId: r, name: n, imageIPFS: A, description: i, skills: o, userIds: s, endsAt: a, xp: c, typeData: l, type: u }, f) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: d, token: g } = this.questSdk.getUser(), m = r || this.questSdk.getEntityId();
        (0, Po.validateParams)({ entityId: m, badgeId: e, userId: d, token: g });
        const p = `/entities/${m}/badges/${e}/update`, v = Object.assign({ userId: d }, f == null ? void 0 : f._queryParams), C = Object.assign({
          name: n,
          imageIPFS: A,
          description: i,
          skills: o,
          userIds: s,
          endsAt: a,
          xp: c,
          typeData: l,
          type: u
        }, f == null ? void 0 : f._body);
        return this.questSdk.makeRequest({
          url: p,
          method: So.HTTP_METHOD.POST,
          headers: f == null ? void 0 : f._headers,
          queryParams: v,
          body: C
        });
      } catch (d) {
        throw this.questSdk.captureSentryException(d), d;
      }
    });
  }
  claimBadgeForEntity({ badgeId: e, addToDynamicNFT: r = !1, entityId: n }, A) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, Po.validateParams)({ entityId: s, badgeId: e, addToDynamicNFT: r, userId: i, token: o });
        const a = `/entities/${s}/badges/${e}/claim`, c = Object.assign({ userId: i }, A == null ? void 0 : A._queryParams), l = Object.assign({ addToDynamicNFT: r }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: So.HTTP_METHOD.POST,
          queryParams: c,
          headers: A == null ? void 0 : A._headers,
          body: l
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  addUsersToBadge({ badgeId: e, userIds: r, entityId: n }, A) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, Po.validateParams)({ entityId: s, badgeId: e, userIds: r, userId: i, token: o });
        const a = `/entities/${s}/badges/${e}/users`, c = Object.assign({ userId: i }, A == null ? void 0 : A._queryParams), l = Object.assign({ userIds: r }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: So.HTTP_METHOD.POST,
          queryParams: c,
          headers: A == null ? void 0 : A._headers,
          body: l
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getNumberOfBadgesEarned({ entityId: e, forUserId: r } = {}, n) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        if ((0, Po.validateParams)({ entityId: o, userId: A, token: i }), !A && !r)
          throw new Error("Please pass the userId or login");
        const s = `/entities/${o}/users/${r || A}/badges-count`;
        return this.questSdk.makeRequest({
          url: s,
          method: So.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getUserEarnedBadgesForEntity({ entityId: e, forUserId: r, limit: n, page: A } = {}, i) {
    return Io(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = e || this.questSdk.getEntityId();
        if ((0, Po.validateParams)({ entityId: a, userId: o, token: s }), !o && !r)
          throw new Error("Please pass the userId or login");
        const c = `/entities/${a}/users/${r || o}/badges`, l = Object.assign(Object.assign(Object.assign({}, A && { page: A }), n && { limit: n }), i == null ? void 0 : i._queryParams);
        return this.questSdk.makeRequest({
          url: c,
          method: So.HTTP_METHOD.GET,
          queryParams: l,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
};
lg.Badge = Dz;
var ug = {}, _s = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(ug, "__esModule", { value: !0 });
ug.DappMetric = void 0;
const $s = ir, xi = an;
class Qz {
  constructor(e) {
    this.questSdk = e;
  }
  createDappMetrics({ metric: e, thresholdTime: r, name: n, description: A, type: i, entityId: o, platform: s, eventName: a }, c) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: l, token: u } = this.questSdk.getUser(), f = o || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: f, metric: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, xi.validateParams)({ userId: l, token: u });
        const d = `/entities/${f}/metrics`, g = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ metric: e }, r && { thresholdTime: r }), n && { name: n }), A && { description: A }), i && { type: i }), s && { platform: s }), a && { eventName: a }), c == null ? void 0 : c._body);
        return this.questSdk.makeRequest({
          url: d,
          method: $s.HTTP_METHOD.POST,
          queryParams: c == null ? void 0 : c._queryParams,
          body: g,
          headers: c == null ? void 0 : c._headers
        });
      } catch (l) {
        throw this.questSdk.captureSentryException(l), l;
      }
    });
  }
  deleteDappMetrics({ entityId: e, metric: r }, n) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: o, metric: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, xi.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/metrics/${r}/delete`;
        return this.questSdk.makeRequest({
          url: s,
          method: $s.HTTP_METHOD.POST,
          body: n == null ? void 0 : n._body,
          headers: n == null ? void 0 : n._headers,
          queryParams: n == null ? void 0 : n._queryParams
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  editDappMetrics({ entityId: e, metric: r, name: n, description: A, type: i, thresholdTime: o, platform: s, eventName: a }, c) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: l, token: u } = this.questSdk.getUser(), f = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: f, metric: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, xi.validateParams)({ userId: l, token: u });
        const d = `/entities/${f}/metrics/${r}/update`, g = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
          metric: r,
          thresholdTime: o
        }, n && { name: n }), A && { description: A }), i && { type: i }), s && { platform: s }), a && { eventName: a }), c == null ? void 0 : c._body);
        return this.questSdk.makeRequest({
          url: d,
          method: $s.HTTP_METHOD.POST,
          body: g,
          headers: c == null ? void 0 : c._headers,
          queryParams: c == null ? void 0 : c._queryParams
        });
      } catch (l) {
        throw this.questSdk.captureSentryException(l), l;
      }
    });
  }
  getAllDappMetrics({ entityId: e, type: r } = {}, n) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: o }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, xi.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/metrics`, a = Object.assign(Object.assign({}, r && { type: r }), n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: $s.HTTP_METHOD.GET,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getDappMetricForUser({ entityId: e, metric: r, forUserId: n }, A) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: s, userId: i, token: o, metric: r });
        const a = `/entities/${s}/users/${n || i}/metrics/${r}`;
        return this.questSdk.makeRequest({
          url: a,
          method: $s.HTTP_METHOD.GET,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  incrementDappMetricForUser({ entityId: e, metric: r, count: n, forUserId: A }, i) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: a, userId: o, token: s, metric: r, count: n });
        const c = `/entities/${a}/users/${A || o}/metrics/${r}`, l = Object.assign({ count: n }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: $s.HTTP_METHOD.POST,
          body: l,
          headers: i == null ? void 0 : i._headers,
          queryParams: i == null ? void 0 : i._queryParams
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  getAllDappMetricsForUser({ entityId: e, forUserId: r } = {}, n) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: o, userId: A, token: i });
        const s = `/entities/${o}/users/${r || A}/metrics`;
        return this.questSdk.makeRequest({
          url: s,
          method: $s.HTTP_METHOD.GET,
          headers: n == null ? void 0 : n._headers,
          queryParams: n == null ? void 0 : n._queryParams
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  incrementMultipleMetricsForUser({ entityId: e, metrics: r, forUserId: n }, A) {
    return _s(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, xi.validateParams)({ entityId: s, userId: i, token: o, metrics: r });
        const a = `/entities/${s}/users/${n || i}/metrics`, c = Object.assign({ metrics: r }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: $s.HTTP_METHOD.POST,
          body: c,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
}
ug.DappMetric = Qz;
var dg = {}, tA = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(dg, "__esModule", { value: !0 });
dg.DynamicNft = void 0;
const rA = ir, An = an;
class Uz {
  constructor(e) {
    this.questSdk = e;
  }
  mintDynamicNFT({ type: e, forUserId: r, entityId: n }, A) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: s, type: e, forUserId: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, An.validateParams)({ userId: i, token: o });
        const a = `/entities/${s}/mint`, c = Object.assign({ type: e, userId: i, forUserId: r }, A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: a,
          method: rA.HTTP_METHOD.POST,
          body: A == null ? void 0 : A._body,
          queryParams: c,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  addRunningXP({ xp: e, forUserId: r, entityId: n, title: A, isAccumulateXP: i, metadata: o }, s) {
    return tA(this, void 0, void 0, function* () {
      try {
        const a = this.questSdk.getUser(), c = n || this.questSdk.getEntityId(), l = r || a.userId;
        (0, An.validateParams)({ entityId: c, xp: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, An.validateParams)({ userId: l, token: a.token });
        const u = `/entities/${c}/add-xp`, f = Object.assign({ userId: l }, s == null ? void 0 : s._queryParams), d = Object.assign(Object.assign(Object.assign({ xp: e, forUserId: l }, A && { title: A }), s == null ? void 0 : s._body), {
          isAccumulateXP: i,
          metadata: o
        });
        return this.questSdk.makeRequest({
          url: u,
          method: rA.HTTP_METHOD.POST,
          body: d,
          queryParams: f,
          headers: s == null ? void 0 : s._headers
        });
      } catch (a) {
        throw this.questSdk.captureSentryException(a), a;
      }
    });
  }
  getMyDynamicNFTs(e) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: r, token: n } = this.questSdk.getUser();
        (0, An.validateParams)({ userId: r, token: n });
        const A = "/mynfts", i = Object.assign({ userId: r }, e == null ? void 0 : e._queryParams);
        return this.questSdk.makeRequest({ url: A, method: rA.HTTP_METHOD.GET, queryParams: i, headers: e == null ? void 0 : e._headers });
      } catch (r) {
        throw this.questSdk.captureSentryException(r), r;
      }
    });
  }
  getMyDynamicNFTDetailsForEntity({ entityId: e } = {}, r) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${e}/mynfts`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({ url: o, method: rA.HTTP_METHOD.GET, queryParams: s, headers: r == null ? void 0 : r._headers });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getXpForUser({ entityId: e, userId: r } = {}, n) {
    return tA(this, void 0, void 0, function* () {
      try {
        const A = this.questSdk.getUser(), i = e || this.questSdk.getEntityId(), o = r || A.userId;
        (0, An.validateParams)({ userId: o, token: A.token, entityId: i });
        const s = `/entities/${i}/users/${o}/xp`;
        return this.questSdk.makeRequest({
          url: s,
          method: rA.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getXpForUsers({ userIds: e, entityId: r }, n) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, An.validateParams)({ userId: A, token: i, entityId: o, userIds: e });
        const s = `/entities/${o}/users/xp`, a = Object.assign({ userIds: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: rA.HTTP_METHOD.POST,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers,
          body: a
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getXpForEntity({ entityId: e } = {}, r) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ userId: n, token: A, entityId: i });
        const o = `/entities/${i}/xp`;
        return this.questSdk.makeRequest({
          url: o,
          method: rA.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getXpForEntities({ entityIds: e }, r) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser();
        (0, An.validateParams)({ userId: n, token: A, entityIds: e });
        const i = "/entities/xp", o = Object.assign({ entityIds: e }, r == null ? void 0 : r._body);
        return this.questSdk.makeRequest({
          url: i,
          method: rA.HTTP_METHOD.POST,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers,
          body: o
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  recalculateUsersDynamicNFT({ entityId: e, userId: r } = {}, n) {
    return tA(this, void 0, void 0, function* () {
      try {
        const A = this.questSdk.getUser(), i = e || this.questSdk.getEntityId(), o = r || A.userId;
        (0, An.validateParams)({ entityId: i, userId: o, token: A.token });
        const s = `/hidden/entities/${i}/recalculate-mynft`, a = Object.assign({ userId: o }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({ url: s, method: rA.HTTP_METHOD.GET, queryParams: a, headers: n == null ? void 0 : n._headers });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getAllThemesForEntity({ entityId: e } = {}, r) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${i}/themes`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({ url: o, method: rA.HTTP_METHOD.GET, queryParams: s, headers: r == null ? void 0 : r._headers });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  addNewThemeForEntity({ membershipTier: e, title: r, price: n, entityId: A, backgroundImageIPFS: i, horizontalLogoImageIPFS: o, squareLogoImageIPFS: s, backgroundColor: a, accentColor1: c, accentColor2: l, metadataIPFS: u }, f) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: d, token: g } = this.questSdk.getUser(), m = A || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: m, membershipTier: e, title: r, price: n }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, An.validateParams)({ userId: d, token: g });
        const p = `/entities/${m}/themes`, v = Object.assign({ userId: d }, f == null ? void 0 : f._queryParams), C = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
          membershipTier: e,
          title: r,
          price: n
        }, i && { backgroundImageIPFS: i }), o && { horizontalLogoImageIPFS: o }), s && { squareLogoImageIPFS: s }), a && { backgroundColor: a }), c && { accentColor1: c }), l && { accentColor2: l }), u && { metadataIPFS: u }), f == null ? void 0 : f._body);
        return this.questSdk.makeRequest({
          url: p,
          method: rA.HTTP_METHOD.POST,
          body: C,
          queryParams: v,
          headers: f == null ? void 0 : f._headers
        });
      } catch (d) {
        throw this.questSdk.captureSentryException(d), d;
      }
    });
  }
  getThemeDetailsForEntity({ entityId: e, themeId: r }, n) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: o, themeId: r, userId: A, token: i });
        const s = `/entities/${o}/themes/${r}`;
        return this.questSdk.makeRequest({
          url: s,
          method: rA.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  updateThemeForEntity({ themeId: e, entityId: r, membershipTier: n, title: A, price: i, backgroundImageIPFS: o, horizontalLogoImageIPFS: s, squareLogoImageIPFS: a, backgroundColor: c, accentColor1: l, accentColor2: u, metadataIPFS: f }, d) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: g, token: m } = this.questSdk.getUser(), p = r || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: p, themeId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, An.validateParams)({ userId: g, token: m });
        const v = `/entities/${p}/themes/${e}/update`, C = Object.assign({ userId: g }, d == null ? void 0 : d._queryParams), w = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, n && { membershipTier: n }), i && { price: i }), A && { title: A }), o && { backgroundImageIPFS: o }), s && { horizontalLogoImageIPFS: s }), a && { squareLogoImageIPFS: a }), c && { backgroundColor: c }), l && { accentColor1: l }), u && { accentColor2: u }), f && { metadataIPFS: f }), d == null ? void 0 : d._body);
        if (Object.keys(w).length === 0)
          throw new Error("Invalid request. Atleast one field is required to update.");
        return this.questSdk.makeRequest({
          url: v,
          method: rA.HTTP_METHOD.POST,
          body: w,
          queryParams: C,
          headers: d == null ? void 0 : d._headers
        });
      } catch (g) {
        throw this.questSdk.captureSentryException(g), g;
      }
    });
  }
  deleteThemeForEntity({ entityId: e, themeId: r }, n) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: o, themeId: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, An.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/themes/${r}/delete`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: rA.HTTP_METHOD.POST,
          body: n == null ? void 0 : n._body,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  setDefaultThemeForEntity({ entityId: e, themeId: r }, n) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: o, themeId: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, An.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/themes/default`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams), c = Object.assign({ themeId: r }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: rA.HTTP_METHOD.POST,
          body: c,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getUserXpLeaderboardRank({ entityId: e, forUserId: r, threshold: n } = {}, A) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: s, userId: i, token: o });
        const a = `/entities/${s}/users/${r || i}/xp-leaderboard-rank`, c = Object.assign(Object.assign({ userId: r || i }, n && { threshold: n }), A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: a,
          method: rA.HTTP_METHOD.GET,
          queryParams: c,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getUserXpHistory({ entityId: e, forUserId: r, limit: n, page: A } = {}, i) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: a, userId: o, token: s });
        const c = `/entities/${a}/users/${r || o}/xp-history`, l = Object.assign(Object.assign(Object.assign({}, n && { limit: n }), A && { page: A }), i == null ? void 0 : i._queryParams);
        return this.questSdk.makeRequest({
          url: c,
          method: rA.HTTP_METHOD.GET,
          queryParams: l,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  getUserXpLeaderboard({ entityId: e, limit: r, page: n } = {}, A) {
    return tA(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, An.validateParams)({ entityId: s, userId: i, token: o });
        const a = `/entities/${s}/xp-leaderboard`, c = Object.assign(Object.assign(Object.assign({}, r && { limit: r }), n && { page: n }), A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: a,
          method: rA.HTTP_METHOD.GET,
          queryParams: c,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
}
dg.DynamicNft = Uz;
var fg = {}, Tn = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(fg, "__esModule", { value: !0 });
fg.Entity = void 0;
const Mn = ir, zr = an;
class Nz {
  constructor(e) {
    this.questSdk = e;
  }
  createNewEntity({ name: e, contracts: r, openseaSlug: n, description: A, chainSource: i = "OFF_CHAIN", isPrivate: o, decreaseCreditsAt: s, decreaseCreditsFrom: a, website: c, imageUrl: l, bannerUrl: u, entityURLAlias: f, parentEntityId: d, category: g, forUserId: m }, p) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: v, token: C } = this.questSdk.getUser(), w = this.questSdk.getEntityAuthenticationToken(), B = d || this.questSdk.getEntityId();
        if ((0, zr.validateParams)({ name: e }), !w && (!v || !C))
          throw new Error("Either the entityAuthenticationToken or the user needs to be set");
        if (w) {
          if (d = B, !d)
            throw new Error("Either parentEntityId needs to be passed or entityId needs to be added to base config for entityAuthenticationToken");
          this.questSdk.setEntityId({ entityId: d });
        }
        const y = "/entities", b = Object.assign({ userId: m || v }, p == null ? void 0 : p._queryParams), q = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
          name: e,
          chainSource: i
        }, r && { contracts: r }), n && { openseaSlug: n }), A && { description: A }), o && { isPrivate: o }), s && { decreaseCreditsAt: s }), a && { decreaseCreditsFrom: a }), c && { website: c }), l && { imageUrl: l }), u && { bannerUrl: u }), f && { entityURLAlias: f }), d && { parentEntityId: d }), g && { category: g }), p == null ? void 0 : p._body);
        return this.questSdk.makeRequest({
          url: y,
          method: Mn.HTTP_METHOD.POST,
          queryParams: b,
          body: q,
          headers: p == null ? void 0 : p._headers
        });
      } catch (v) {
        throw this.questSdk.captureSentryException(v), v;
      }
    });
  }
  addNewCustomEntityId({ customPlatformId: e, customPlatformName: r, entityId: n, accessToken: A, expiresIn: i, link: o, name: s, refreshToken: a, username: c }, l) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: u, token: f } = this.questSdk.getUser(), d = n || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: d, customPlatformName: r, customPlatformId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ userId: u, token: f });
        const g = `/entities/${d}/custom-ids`, m = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
          customPlatformId: e,
          customPlatformName: r
        }, A && { accessToken: A }), i && { expiresIn: i }), o && { link: o }), s && { name: s }), a && { refreshToken: a }), c && { username: c }), l == null ? void 0 : l._body);
        return this.questSdk.makeRequest({
          url: g,
          method: Mn.HTTP_METHOD.POST,
          queryParams: l == null ? void 0 : l._queryParams,
          body: m,
          headers: l == null ? void 0 : l._headers
        });
      } catch (u) {
        throw this.questSdk.captureSentryException(u), u;
      }
    });
  }
  getAllEntities({ page: e, limit: r, category: n } = {}, A) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const i = "/entities", o = Object.assign(Object.assign(Object.assign(Object.assign({}, e && { page: e }), r && { limit: r }), n && { category: n }), A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({ url: i, method: Mn.HTTP_METHOD.GET, queryParams: o, headers: A == null ? void 0 : A._headers });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getEntityInfo({ entityId: e } = {}, r) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const n = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: n });
        const A = `/entities/${n}`;
        return this.questSdk.makeRequest({
          url: A,
          method: Mn.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getEntityIdForAlias({ alias: e }, r) {
    return Tn(this, void 0, void 0, function* () {
      try {
        (0, zr.validateParams)({ alias: e });
        const n = `/entities/alias/${e}/id`;
        return this.questSdk.makeRequest({
          url: n,
          method: Mn.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getEntityIdForCustomEntityId({ customEntityId: e, platform: r, recordType: n }, A) {
    return Tn(this, void 0, void 0, function* () {
      try {
        (0, zr.validateParams)({ customEntityId: e, platform: r, recordType: n });
        const i = `/entities/custom-ids/${e}/id`, o = Object.assign({
          platform: r,
          recordType: n
        }, A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: i,
          method: Mn.HTTP_METHOD.GET,
          queryParams: o,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  updateEntity({ entityId: e, name: r, description: n, isPrivate: A, decreaseCreditsAt: i, decreaseCreditsFrom: o, website: s, imageUrl: a, bannerUrl: c, entityURLAlias: l }, u) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: f, token: d } = this.questSdk.getUser(), g = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: g }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ userId: f, token: d });
        const m = `/entities/${g}/update`, p = Object.assign({ userId: f }, u == null ? void 0 : u._queryParams), v = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, r && { name: r }), n && { description: n }), A && { isPrivate: A }), i && { decreaseCreditsAt: i }), o && { decreaseCreditsFrom: o }), s && { website: s }), a && { imageUrl: a }), c && { bannerUrl: c }), l && { entityURLAlias: l }), u == null ? void 0 : u._body);
        return this.questSdk.makeRequest({
          url: m,
          method: Mn.HTTP_METHOD.POST,
          queryParams: p,
          body: v,
          headers: u == null ? void 0 : u._headers
        });
      } catch (f) {
        throw this.questSdk.captureSentryException(f), f;
      }
    });
  }
  updateEntityTheme({ theme: e, entityId: r }, n) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: o, theme: e, userId: A, token: i });
        const s = `/entities/${o}/update-theme`, a = Object.assign({ theme: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: Mn.HTTP_METHOD.POST,
          queryParams: n == null ? void 0 : n._queryParams,
          body: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getEntityTheme({ entityId: e } = {}, r) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const n = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: n });
        const A = `/entities/${n}/get-theme`;
        return this.questSdk.makeRequest({
          url: A,
          method: Mn.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  updateEntityPlan({ entityId: e, product: r }, n) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: o, product: r, userId: A, token: i });
        const s = `/entities/${o}/update-plan`, a = Object.assign({ product: r }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: Mn.HTTP_METHOD.POST,
          queryParams: n == null ? void 0 : n._queryParams,
          body: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getUsersOfEntity({ entityId: e } = {}, r) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: i, userId: n }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ token: A });
        const o = `/entities/${i}/users`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({ url: o, method: Mn.HTTP_METHOD.GET, queryParams: s, headers: r == null ? void 0 : r._headers });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  manuallyAddUsersToEntity({ userIds: e, entityId: r }, n) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: o, userIds: e, userId: A, token: i });
        const s = `/entities/${o}/force-add`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams), c = Object.assign({ userIds: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: Mn.HTTP_METHOD.POST,
          queryParams: a,
          body: c,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getAllAdmins({ entityId: e, lessDetails: r } = {}, n) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: o, userId: A, token: i });
        const s = `/entities/${o}/admins`, a = Object.assign(Object.assign({}, r && { lessDetails: r }), n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: Mn.HTTP_METHOD.GET,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  removeAdmin({ userId: e, entityId: r }, n) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const A = this.questSdk.getUser(), i = r || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: i, userId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ userId: A.userId, token: A.token });
        const o = `/entities/${i}/remove-admin`, s = Object.assign({ userId: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: o,
          method: Mn.HTTP_METHOD.POST,
          body: s,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  addOrUpdateSocialTokens({ recordType: e, entityId: r, authClientId: n, authClientSecret: A, apiKey: i, apiSecret: o, authorizationToken: s, apiHost: a }, c) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: l, token: u } = this.questSdk.getUser(), f = r || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: f, recordType: e, userId: l }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ token: u });
        const d = `/entities/${f}/users/${l}/social-tokens`, g = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, n && { authClientId: n }), A && { authClientSecret: A }), i && { apiKey: i }), o && { apiSecret: o }), e && { recordType: e }), s && { authorizationToken: s }), a && { apiHost: a }), c == null ? void 0 : c._body);
        if (Object.keys(g).length === 0)
          throw new Error("Invalid request. Atleast one token needs to be passed");
        return this.questSdk.makeRequest({
          url: d,
          method: Mn.HTTP_METHOD.POST,
          body: g,
          queryParams: c == null ? void 0 : c._queryParams,
          headers: c == null ? void 0 : c._headers
        });
      } catch (l) {
        throw this.questSdk.captureSentryException(l), l;
      }
    });
  }
  getSocialTokens({ recordType: e, entityId: r }, n) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: o, recordType: e, userId: A }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ token: i });
        const s = `/entities/${o}/users/${A}/social-tokens`, a = Object.assign({ recordType: e }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({ url: s, method: Mn.HTTP_METHOD.GET, queryParams: a, headers: n == null ? void 0 : n._headers });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  approveEntityCreation({ baseName: e, baseSymbol: r, entityId: n }, A) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser();
        (0, zr.validateParams)({ entityId: n, userId: i, token: o });
        const s = "/admin/entities/approve", a = Object.assign(Object.assign(Object.assign({ entityId: n }, e && { baseName: e }), r && { baseSymbol: r }), A == null ? void 0 : A._body), c = Object.assign({ userId: i }, A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: Mn.HTTP_METHOD.POST,
          queryParams: c,
          body: a,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getAllPendingEntities(e) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: r, token: n } = this.questSdk.getUser();
        (0, zr.validateParams)({ userId: r, token: n });
        const A = "/admin/entities/pending", i = Object.assign({ userId: r }, e == null ? void 0 : e._queryParams);
        return this.questSdk.makeRequest({
          url: A,
          method: Mn.HTTP_METHOD.GET,
          queryParams: i,
          headers: e == null ? void 0 : e._headers
        });
      } catch (r) {
        throw this.questSdk.captureSentryException(r), r;
      }
    });
  }
  addAdminToEntity({ email: e, name: r, entityId: n, role: A }, i) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = n || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: a, email: e, name: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ userId: o, token: s });
        const c = `/entities/${a}/invite`, l = Object.assign({
          email: e,
          name: r
        }, A && { role: A });
        return this.questSdk.makeRequest({
          url: c,
          method: Mn.HTTP_METHOD.POST,
          queryParams: i == null ? void 0 : i._queryParams,
          body: l,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  getOrGenerateNewAPIKey({ entityId: e } = {}, r) {
    return Tn(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, zr.validateParams)({ entityId: i }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, zr.validateParams)({ userId: n, token: A });
        const o = `/entities/${i}/keys`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({
          url: o,
          method: Mn.HTTP_METHOD.GET,
          queryParams: s,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
}
fg.Entity = Nz;
var hg = {}, A0 = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(hg, "__esModule", { value: !0 });
hg.EntityAuthenticationToken = void 0;
const i0 = ir, o0 = an;
class jz {
  constructor(e) {
    this.questSdk = e;
  }
  createToken({ entityId: e } = {}, r) {
    return A0(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, o0.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${i}/users/${n}/authentication-token`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({
          url: o,
          method: i0.HTTP_METHOD.POST,
          headers: r == null ? void 0 : r._headers,
          queryParams: s
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  updateToken({ entityId: e, flags: r, expiry: n } = {}, A) {
    return A0(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, o0.validateParams)({ entityId: s, flags: r, expiry: n, userId: i, token: o });
        const a = `/entities/${s}/users/${i}/authentication-token`, c = Object.assign({ userId: i }, A == null ? void 0 : A._queryParams), l = Object.assign({ flags: r, expiry: n }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: i0.HTTP_METHOD.PATCH,
          headers: A == null ? void 0 : A._headers,
          queryParams: c,
          body: l
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  refreshToken({ entityId: e, authenticationToken: r } = {}, n) {
    return A0(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId(), s = this.questSdk.getEntityAuthenticationToken();
        (0, o0.validateParams)({
          entityId: o,
          userId: A,
          authenticationToken: r || s,
          token: i
        });
        const a = `/entities/${o}/users/${A}/authentication-token/refresh`, c = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams), l = Object.assign({ authenticationToken: r || s }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: a,
          method: i0.HTTP_METHOD.POST,
          headers: n == null ? void 0 : n._headers,
          queryParams: c,
          body: l
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  deleteToken({ entityId: e } = {}, r) {
    return A0(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, o0.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${i}/users/${n}/authentication-token`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({
          url: o,
          method: i0.HTTP_METHOD.DELETE,
          headers: r == null ? void 0 : r._headers,
          queryParams: s
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getToken({ entityId: e, requestOrigin: r } = {}, n) {
    return A0(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, o0.validateParams)({ entityId: o, requestOrigin: r, userId: A, token: i });
        const s = `/entities/${o}/users/${A}/authentication-token`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams), c = { Referer: r };
        return this.questSdk.makeRequest({ url: s, method: i0.HTTP_METHOD.GET, headers: c, queryParams: a });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
hg.EntityAuthenticationToken = jz;
var pg = {}, is = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(pg, "__esModule", { value: !0 });
pg.EntiyCreditTier = void 0;
const Zi = ir, bA = an;
class Lz {
  constructor(e) {
    this.questSdk = e;
  }
  addCreditTierForEntity({ creditsAmount: e, creditsTierId: r, creditsTierName: n, extraCreditsAmount: A = 0, price: i, recurringTimePeriod: o = "ONETIME", entityId: s }, a) {
    try {
      const { userId: c, token: l } = this.questSdk.getUser(), u = s || this.questSdk.getEntityId();
      (0, bA.validateParams)({ entityId: u, creditsAmount: e, price: i, creditsTierId: r, creditsTierName: n }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, bA.validateParams)({ userId: c, token: l });
      const f = `/entities/${u}/credits-tiers`, d = Object.assign({
        creditsAmount: e,
        extraCreditsAmount: A,
        price: i,
        creditsTierId: r,
        creditsTierName: n,
        recurringTimePeriod: o
      }, a == null ? void 0 : a._body);
      return this.questSdk.makeRequest({
        url: f,
        method: Zi.HTTP_METHOD.POST,
        body: d,
        queryParams: a == null ? void 0 : a._queryParams,
        headers: a == null ? void 0 : a._headers
      });
    } catch (c) {
      throw this.questSdk.captureSentryException(c), c;
    }
  }
  updateCreditTierForEntity({ creditsTierId: e, creditsAmount: r, creditsTierName: n, extraCreditsAmount: A, price: i, recurringTimePeriod: o, entityId: s }, a) {
    try {
      const { userId: c, token: l } = this.questSdk.getUser(), u = s || this.questSdk.getEntityId();
      (0, bA.validateParams)({ entityId: u, creditsTierId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, bA.validateParams)({ userId: c, token: l });
      const f = `/entities/${u}/credits-tiers`, d = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ creditsTierId: e }, r && { creditsAmount: r }), A && { extraCreditsAmount: A }), i && { price: i }), n && { creditsTierName: n }), o && { recurringTimePeriod: o }), a == null ? void 0 : a._body);
      if (Object.keys(d).length <= 1)
        throw new Error("Invalid request. Atleast one parameter is required to update");
      return this.questSdk.makeRequest({
        url: f,
        method: Zi.HTTP_METHOD.PATCH,
        body: d,
        queryParams: a == null ? void 0 : a._queryParams,
        headers: a == null ? void 0 : a._headers
      });
    } catch (c) {
      throw this.questSdk.captureSentryException(c), c;
    }
  }
  getCreditTiersForEntity({ entityId: e } = {}, r) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, bA.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${i}/credits-tiers`;
        return this.questSdk.makeRequest({
          url: o,
          method: Zi.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getCreditInfoForUser({ entityId: e, forUserId: r } = {}, n) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, bA.validateParams)({ entityId: o, userId: A, token: i });
        const s = `/users/${r || A}/credits`, a = Object.assign({ entityId: o }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: Zi.HTTP_METHOD.GET,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getCreditInfoForEntity({ entityId: e } = {}, r) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, bA.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${i}/credits`;
        return this.questSdk.makeRequest({
          url: o,
          method: Zi.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  buyCreditsForUser({ creditsTierId: e, intentId: r, forUserId: n, entityId: A }, i) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = A || this.questSdk.getEntityId();
        (0, bA.validateParams)({ creditsTierId: e, intentId: r, userId: o, token: s, entityId: a });
        const c = `/users/${n || o}/buy-credits`, l = Object.assign({ entityId: a }, i == null ? void 0 : i._body), u = Object.assign({
          creditsTierId: e,
          intentId: r
        }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: Zi.HTTP_METHOD.POST,
          queryParams: l,
          body: u,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  buyCreditsForEntity({ creditsTierId: e, intentId: r, entityId: n }, A) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, bA.validateParams)({ creditsTierId: e, intentId: r, entityId: s, userId: i }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, bA.validateParams)({ token: o });
        const a = `/entities/${s}/buy-credits`, c = Object.assign({ userId: i }, A == null ? void 0 : A._body), l = Object.assign({
          creditsTierId: e,
          intentId: r
        }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: Zi.HTTP_METHOD.POST,
          queryParams: c,
          body: l,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  decrementCreditsForUser({ entityId: e, creditsAmount: r, forUserId: n }, A) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        if ((0, bA.validateParams)({ entityId: s, creditsAmount: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, bA.validateParams)({ userId: i, token: o }), !n && !i)
          throw new Error("Invalid request. Either login or pass forUserId");
        const a = `/users/${n || i}/decrement-credits`, c = Object.assign({ entityId: s }, A == null ? void 0 : A._queryParams), l = Object.assign({ creditsAmount: r }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: Zi.HTTP_METHOD.POST,
          queryParams: c,
          body: l,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  decrementCreditsForEntity({ creditsAmount: e, entityId: r }, n) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, bA.validateParams)({ entityId: o, creditsAmount: e, userId: A }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, bA.validateParams)({ token: i });
        const s = `/entities/${o}/decrement-credits`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams), c = Object.assign({ creditsAmount: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: Zi.HTTP_METHOD.POST,
          queryParams: a,
          body: c,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  createPaymentIntentForEntity({ cardData: e, intentData: r, entityId: n }, A) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, bA.validateParams)({ entityId: s, userId: i, token: o, cardData: e, intentData: r });
        const a = `/entities/${s}/users/${i}/create-payment-intent`, c = Object.assign({
          cardData: e,
          intentData: r,
          forEntityId: s
        }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: Zi.HTTP_METHOD.POST,
          queryParams: A == null ? void 0 : A._queryParams,
          headers: A == null ? void 0 : A._headers,
          body: c
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  approvePaymentForEntity({ entityId: e, intentId: r }, n) {
    return is(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, bA.validateParams)({ userId: A, token: i, entityId: o, intentId: r });
        const s = `/entities/${o}/approve-payment`, a = Object.assign({ intentId: r }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: Zi.HTTP_METHOD.POST,
          queryParams: n == null ? void 0 : n._queryParams,
          body: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
pg.EntiyCreditTier = Lz;
var gg = {}, ea = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(gg, "__esModule", { value: !0 });
gg.EntityDataContract = void 0;
const ta = ir, ra = an;
class Gz {
  constructor(e) {
    this.questSdk = e;
  }
  addNewDataContractForEntity({ entityId: e, fields: r, source: n, name: A, tags: i, description: o } = {}, s) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: a, token: c } = this.questSdk.getUser(), l = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: l, fields: r, name: A, token: c });
        const u = `/entities/${l}/dataContracts`, f = Object.assign({ userId: a }, s == null ? void 0 : s._queryParams), d = Object.assign({ fields: r, name: A, tags: i, description: o, source: n }, s == null ? void 0 : s._body);
        return this.questSdk.makeRequest({
          url: u,
          method: ta.HTTP_METHOD.POST,
          headers: s == null ? void 0 : s._headers,
          queryParams: f,
          body: d
        });
      } catch (a) {
        throw this.questSdk.captureSentryException(a), a;
      }
    });
  }
  getDataContractByIdForAnEntity({ entityId: e, dataContractId: r } = {}, n) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: o, dataContractId: r, userId: A, token: i });
        const s = `/entities/${o}/dataContracts/${r}`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: ta.HTTP_METHOD.GET,
          headers: n == null ? void 0 : n._headers,
          queryParams: a
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getAllDataContractsForAnEntity({ entityId: e }, r) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: i, userId: n, token: A });
        const o = `/entities/${i}/dataContracts/`, s = Object.assign({ userId: n }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({
          url: o,
          method: ta.HTTP_METHOD.GET,
          headers: r == null ? void 0 : r._headers,
          queryParams: s
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  updateDataContractForEntity({ entityId: e, fields: r, source: n, name: A, tags: i, description: o } = {}, s) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: a, token: c } = this.questSdk.getUser(), l = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: l, fields: r, name: A, userId: a, token: c });
        const u = `/entities/${l}/dataContracts/update`, f = Object.assign({ userId: a }, s == null ? void 0 : s._queryParams), d = Object.assign({ fields: r, name: A, tags: i, description: o, source: n }, s == null ? void 0 : s._body);
        return this.questSdk.makeRequest({
          url: u,
          method: ta.HTTP_METHOD.POST,
          headers: s == null ? void 0 : s._headers,
          queryParams: f,
          body: d
        });
      } catch (a) {
        throw this.questSdk.captureSentryException(a), a;
      }
    });
  }
  deleteDataContractForEntity({ entityId: e, dataContractId: r } = {}, n) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: o, dataContractId: r, userId: A, token: i });
        const s = `/entities/${o}/dataContracts/${r}/delete`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: ta.HTTP_METHOD.POST,
          headers: n == null ? void 0 : n._headers,
          queryParams: a
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  chatWithDataContractForEntity({ entityId: e, dataContractId: r, userInput: n, isInternal: A } = {}, i) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: a, dataContractId: r, userInput: n, userId: o, token: s });
        const c = `/entities/${a}/dataContracts/${r}/chat`, l = Object.assign({ userId: o }, i == null ? void 0 : i._queryParams), u = Object.assign({ userInput: n, isInternal: A }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: ta.HTTP_METHOD.POST,
          headers: i == null ? void 0 : i._headers,
          queryParams: l,
          body: u
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  fetchFieldsFromGoogleSheets({ entityId: e, googleSheetLink: r } = {}, n) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: o, googleSheetLink: r, userId: A, token: i });
        const s = `/entities/${o}/googlesheet`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams), c = Object.assign({ googleSheetLink: r }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: ta.HTTP_METHOD.POST,
          headers: n == null ? void 0 : n._headers,
          queryParams: a,
          body: c
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  autoGenerateDescription({ fields: e, dataContractId: r, entityId: n } = {}, A) {
    return ea(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, ra.validateParams)({ entityId: s, fields: e, dataContractId: r, userId: i, token: o });
        const a = `/entities/${s}/dataContracts/${r}/autoGenerate`, c = Object.assign({ userId: i }, A == null ? void 0 : A._queryParams), l = Object.assign({ fields: e }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: ta.HTTP_METHOD.POST,
          headers: A == null ? void 0 : A._headers,
          queryParams: c,
          body: l
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
}
gg.EntityDataContract = Gz;
var mg = {}, X1 = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(mg, "__esModule", { value: !0 });
mg.EntityFeatureFlag = void 0;
const K1 = ir, os = an;
class Rz {
  constructor(e) {
    this.questSdk = e;
  }
  getAllFeatureFlagsForEntity({ entityId: e } = {}, r) {
    return X1(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, os.validateParams)({ entityId: i }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, os.validateParams)({ userId: n, token: A });
        const o = `/entities/${i}/featureFlags`, s = Object.assign(Object.assign({}, n && { userId: n }), r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({ url: o, method: K1.HTTP_METHOD.GET, headers: r == null ? void 0 : r._headers, queryParams: s });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  addNewFeatureFlagForEntity({ entityId: e, flagName: r, description: n, isEnabled: A }, i) {
    return X1(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = e || this.questSdk.getEntityId();
        (0, os.validateParams)({ entityId: a, flagName: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, os.validateParams)({ userId: o, token: s });
        const c = `/entities/${a}/featureFlags`, l = Object.assign(Object.assign(Object.assign({ flagName: r }, n && { description: n }), A && { isEnabled: A }), i == null ? void 0 : i._body), u = Object.assign({ userId: o }, i == null ? void 0 : i._queryParams);
        return this.questSdk.makeRequest({
          url: c,
          method: K1.HTTP_METHOD.POST,
          headers: i == null ? void 0 : i._headers,
          queryParams: u,
          body: l
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  toggleFeatureFlagForEntity({ entityId: e, flagName: r }, n) {
    return X1(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, os.validateParams)({ entityId: o, flagName: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, os.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/featureFlags/${r}/toggle`, a = Object.assign(Object.assign(Object.assign({}, A && { userId: A }), n == null ? void 0 : n._queryParams), { flagName: r });
        return this.questSdk.makeRequest({
          url: s,
          method: K1.HTTP_METHOD.POST,
          headers: n == null ? void 0 : n._headers,
          queryParams: a,
          body: n == null ? void 0 : n._body
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  terminateFeatureFlagForEntity({ entityId: e, flagName: r }, n) {
    return X1(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, os.validateParams)({ entityId: o, flagName: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, os.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/featureFlags/${r}/terminate`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: K1.HTTP_METHOD.POST,
          headers: n == null ? void 0 : n._headers,
          queryParams: a
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getAllFeatureFlagsStream({ entityId: e } = {}, r) {
    try {
      const n = e || this.questSdk.getEntityId(), { apiKey: A, apiSecret: i } = this.questSdk.getApiKeys();
      (0, os.validateParams)({ entityId: n });
      const o = `${this.questSdk.getBaseUrl()}/entities/${n}/featureFlags/stream?apiKey=${A}&apiSecret=${i}`;
      return new EventSource(o);
    } catch (n) {
      throw this.questSdk.captureSentryException(n), n;
    }
  }
}
mg.EntityFeatureFlag = Rz;
var vg = {}, C9 = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(vg, "__esModule", { value: !0 });
vg.EntityPrompt = void 0;
const w9 = ir, b9 = an;
class zz {
  constructor(e) {
    this.questSdk = e;
  }
  addEntityPrompt({ actualPrompt: e, entityId: r, usecase: n }, A) {
    return C9(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser();
        (0, b9.validateParams)({ actualPrompt: e, usecase: n, token: o, userId: i });
        const s = `/entities/${r}/prompt`, a = Object.assign({ actualPrompt: e, usecase: n }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: s,
          method: w9.HTTP_METHOD.POST,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams,
          body: a
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  generatePromptResponseByUsecase({ message: e, entityId: r, usecase: n }, A) {
    return C9(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser();
        (0, b9.validateParams)({ message: e, usecase: n, userId: i, token: o });
        const s = `/entities/${r}/prompt/request`, a = Object.assign({ message: e, usecase: n }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: s,
          method: w9.HTTP_METHOD.POST,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams,
          body: a
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  updateEntityPrompt({ actualPrompt: e, entityId: r, usecase: n }, A) {
    return C9(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser();
        (0, b9.validateParams)({ actualPrompt: e, usecase: n, userId: i, token: o });
        const s = `/entities/${r}/prompt`, a = Object.assign({ actualPrompt: e, usecase: n }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: s,
          method: w9.HTTP_METHOD.PATCH,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams,
          body: a
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
}
vg.EntityPrompt = zz;
var qg = {}, ac = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(qg, "__esModule", { value: !0 });
qg.EntityTag = void 0;
const cc = ir, $A = an;
class Yz {
  constructor(e) {
    this.questSdk = e;
  }
  getAllTagsForEntity({ entityId: e } = {}, r) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: i }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: n, token: A });
        const o = `/entities/${i}/tags`;
        return this.questSdk.makeRequest({
          url: o,
          method: cc.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  addTagForEntity({ tagName: e, description: r, entityId: n }, A) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: s, tagName: e, description: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: i, token: o });
        const a = `/entities/${s}/tags`, c = Object.assign({
          tagName: e,
          description: r
        }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: cc.HTTP_METHOD.POST,
          queryParams: A == null ? void 0 : A._queryParams,
          body: c,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  updateTagForEntity({ tagId: e, tagName: r, description: n, entityId: A }, i) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = A || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: a, tagId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: o, token: s });
        const c = `/entities/${a}/tags/${e}/update`, l = Object.assign({
          tagName: r,
          description: n
        }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: cc.HTTP_METHOD.POST,
          queryParams: i == null ? void 0 : i._queryParams,
          body: l,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  deleteTagForEntity({ tagId: e, entityId: r }, n) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: o, tagId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/tags/${e}/delete`;
        return this.questSdk.makeRequest({
          url: s,
          method: cc.HTTP_METHOD.POST,
          body: n == null ? void 0 : n._body,
          headers: n == null ? void 0 : n._headers,
          queryParams: n == null ? void 0 : n._queryParams
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getEntityTagsForUser({ entityId: e, forUserId: r } = {}, n) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: o }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/users/${r || A}/tags`;
        return this.questSdk.makeRequest({
          url: s,
          method: cc.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  addEntityTagForUser({ tagId: e, forUserId: r, entityId: n }, A) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: s, tagId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: i, token: o });
        const a = `/entities/${s}/users/${r || i}/tags/${e}/add`;
        return this.questSdk.makeRequest({
          url: a,
          method: cc.HTTP_METHOD.POST,
          queryParams: A == null ? void 0 : A._queryParams,
          body: A == null ? void 0 : A._body,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  removeEntityTagForUser({ tagId: e, forUserId: r, entityId: n }, A) {
    return ac(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, $A.validateParams)({ entityId: s, tagId: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, $A.validateParams)({ userId: i, token: o });
        const a = `/entities/${s}/users/${r || i}/tags/${e}/remove`;
        return this.questSdk.makeRequest({
          url: a,
          method: cc.HTTP_METHOD.POST,
          queryParams: A == null ? void 0 : A._queryParams,
          body: A == null ? void 0 : A._body,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
}
qg.EntityTag = Yz;
var yg = {}, SC = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(yg, "__esModule", { value: !0 });
yg.GPT = void 0;
const PC = ir, kC = an;
class Vz {
  constructor(e) {
    this.questSdk = e;
  }
  createTextEmbeddingForEntity({ embeddingText: e, entityId: r }, n) {
    return SC(this, void 0, void 0, function* () {
      try {
        const A = r || this.questSdk.getEntityId();
        (0, kC.validateParams)({ entityId: A, embeddingText: e });
        const i = `/ai/entities/${A}/embed-text`, o = Object.assign({ embeddingText: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: i,
          method: PC.HTTP_METHOD.POST,
          body: o,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  makePromptRequestWithEmbedding({ input: e, entityId: r }, n) {
    return SC(this, void 0, void 0, function* () {
      try {
        const A = r || this.questSdk.getEntityId();
        (0, kC.validateParams)({ entityId: A, input: e });
        const i = `/ai/entities/${A}/embed-query`, o = Object.assign({ input: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: i,
          method: PC.HTTP_METHOD.POST,
          body: o,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
yg.GPT = Vz;
var Cg = {}, s0 = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(Cg, "__esModule", { value: !0 });
Cg.MembershipTier = void 0;
const a0 = ir, ko = an;
class Wz {
  constructor(e) {
    this.questSdk = e;
  }
  addNewMembershipTierForEntity({ membershipTier: e, xpThreshold: r, description: n, entityId: A, imageIPFS: i }, o) {
    return s0(this, void 0, void 0, function* () {
      try {
        const { userId: s, token: a } = this.questSdk.getUser(), c = A || this.questSdk.getEntityId();
        (0, ko.validateParams)({ entityId: c, membershipTier: e, xpThreshold: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ko.validateParams)({ userId: s, token: a });
        const l = `/entities/${c}/membershipTiers`, u = Object.assign({ userId: s }, o == null ? void 0 : o._queryParams), f = Object.assign({
          membershipTier: e,
          xpThreshold: r,
          description: n,
          imageIPFS: i
        }, o == null ? void 0 : o._body);
        return this.questSdk.makeRequest({
          url: l,
          method: a0.HTTP_METHOD.POST,
          queryParams: u,
          body: f,
          headers: o == null ? void 0 : o._headers
        });
      } catch (s) {
        throw this.questSdk.captureSentryException(s), s;
      }
    });
  }
  getAllMembershipTiersForEntity({ entityId: e, limit: r, page: n } = {}, A) {
    return s0(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, ko.validateParams)({ entityId: s }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ko.validateParams)({ userId: i, token: o });
        const a = `/entities/${s}/membershipTiers`, c = Object.assign(Object.assign(Object.assign({}, r && { limit: r }), n && { page: n }), A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: a,
          method: a0.HTTP_METHOD.GET,
          queryParams: c,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  updateMembershipTierForEntity({ membershipTier: e, description: r, imageIPFS: n, xpThreshold: A, entityId: i }, o) {
    return s0(this, void 0, void 0, function* () {
      try {
        const { userId: s, token: a } = this.questSdk.getUser(), c = i || this.questSdk.getEntityId();
        (0, ko.validateParams)({ entityId: c, membershipTier: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ko.validateParams)({ userId: s, token: a });
        const l = `/entities/${c}/membershipTiers/${e}/update`, u = Object.assign({ userId: s }, o == null ? void 0 : o._queryParams), f = Object.assign(Object.assign(Object.assign(Object.assign({}, r && { description: r }), n && { imageIPFS: n }), A && { xpThreshold: A }), o == null ? void 0 : o._body);
        if (Object.keys(f).length === 0)
          throw new Error("Invalid reques. Atleast one field is necessary to update");
        return this.questSdk.makeRequest({
          url: l,
          method: a0.HTTP_METHOD.POST,
          queryParams: u,
          body: f,
          headers: o == null ? void 0 : o._headers
        });
      } catch (s) {
        throw this.questSdk.captureSentryException(s), s;
      }
    });
  }
  deleteMembershipTierForEntity({ membershipTier: e, entityId: r }, n) {
    return s0(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, ko.validateParams)({ entityId: o, membershipTier: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ko.validateParams)({ userId: A, token: i });
        const s = `/entities/${o}/membershipTiers/${e}/delete`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: a0.HTTP_METHOD.POST,
          queryParams: a,
          body: n == null ? void 0 : n._body,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getMembershipTierDetailsForEntity({ membershipTier: e, entityId: r }, n) {
    return s0(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, ko.validateParams)({ entityId: o, membershipTier: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ko.validateParams)({ userId: A, token: i });
        const s = `/entities/${r}/membershipTiers/${e}`, a = Object.assign(Object.assign({}, A && { userId: A }), n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: a0.HTTP_METHOD.GET,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
Cg.MembershipTier = Wz;
var wg = {}, lA = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(wg, "__esModule", { value: !0 });
wg.Quest = void 0;
const uA = ir, BA = an;
class Xz {
  constructor(e) {
    this.questSdk = e;
  }
  getAllQuests({ category: e, limit: r, page: n } = {}, A) {
    return lA(this, void 0, void 0, function* () {
      try {
        const i = "/quests", o = Object.assign(Object.assign(Object.assign(Object.assign({}, e && { category: e }), r && { limit: r }), n && { page: n }), A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: i,
          method: uA.HTTP_METHOD.GET,
          queryParams: o,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getAllQuestsForEntity({ category: e, limit: r, page: n, entityId: A } = {}, i) {
    return lA(this, void 0, void 0, function* () {
      try {
        const o = A || this.questSdk.getEntityId();
        (0, BA.validateParams)({ entityId: o });
        const s = `/entities/${o}/quests`, a = Object.assign(Object.assign(Object.assign(Object.assign({}, e && { category: e }), r && { limit: r }), n && { page: n }), i == null ? void 0 : i._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: uA.HTTP_METHOD.GET,
          queryParams: a,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  getQuestDetails({ questId: e, detailsPage: r, entityId: n, prefixBadgeIpfs: A }, i) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = n || this.questSdk.getEntityId();
        (0, BA.validateParams)({ entityId: a, userId: o, token: s, questId: e });
        const c = `/entities/${a}/quests/${e}`, l = Object.assign(Object.assign(Object.assign({ userId: o }, A && { prefixBadgeIpfs: A }), r && { detailsPage: r }), i == null ? void 0 : i._queryParams);
        return this.questSdk.makeRequest({
          url: c,
          method: uA.HTTP_METHOD.GET,
          queryParams: l,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  getQuestSummary({ questId: e, entityId: r }, n) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, BA.validateParams)({ entityId: o, userId: A, token: i, questId: e });
        const s = `/entities/${o}/quests/${e}/summary`;
        return this.questSdk.makeRequest({
          url: s,
          method: uA.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  createQuest({ title: e, eligibilityCriterias: r, rewards: n, description: A, endsAt: i, entityId: o, hasReferral: s, imageURL: a, isPrivate: c, referralXP: l, theme: u, dependentQuestIDs: f, isDependentCriterias: d, isMetricQuest: g }, m) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: p, token: v } = this.questSdk.getUser(), C = o || this.questSdk.getEntityId();
        (0, BA.validateParams)({ entityId: C, userId: p, token: v, title: e, eligibilityCriterias: r, rewards: n });
        const w = `/entities/${C}/quests`, B = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
          title: e,
          eligibilityCriterias: r,
          rewards: n
        }, A && { description: A }), a && { imageURL: a }), i && { endsAt: i }), s && { hasReferral: s }), l && { referralXP: l }), u && { theme: u }), c && { isPrivate: c }), f && { dependentQuestIDs: f }), d && { isDependentCriterias: d }), g && { isMetricQuest: g }), m == null ? void 0 : m._body), y = Object.assign({ userId: p }, m == null ? void 0 : m._queryParams);
        return this.questSdk.makeRequest({
          url: w,
          method: uA.HTTP_METHOD.POST,
          queryParams: y,
          body: B,
          headers: m == null ? void 0 : m._headers
        });
      } catch (p) {
        throw this.questSdk.captureSentryException(p), p;
      }
    });
  }
  updateQuest({ questId: e, title: r, description: n, eligibilityCriterias: A, endsAt: i, entityId: o, hasReferral: s, imageURL: a, isPrivate: c, referralXP: l, rewards: u, theme: f, rewardIdsToDelete: d, eligibilityCriteriaIdsToDelete: g, isMetricQuest: m }, p) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: v, token: C } = this.questSdk.getUser(), w = o || this.questSdk.getEntityId();
        (0, BA.validateParams)({ entityId: w, userId: v, token: C, questId: e });
        const B = `/entities/${w}/quests/${e}/update`, y = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, r && { title: r }), n && { description: n }), A && { eligibilityCriterias: A }), i && { endsAt: i }), o && { entityId: o }), s && { hasReferral: s }), a && { imageURL: a }), c && { isPrivate: c }), l && { referralXP: l }), u && { rewards: u }), f && { theme: f }), d && { rewardIdsToDelete: d }), g && { eligibilityCriteriaIdsToDelete: g }), m && { isMetricQuest: m }), p == null ? void 0 : p._body), b = Object.assign({ userId: v }, p == null ? void 0 : p._queryParams);
        if (Object.keys(y).length === 0)
          throw new Error("Invalid request. Update atleast one field");
        return this.questSdk.makeRequest({
          url: B,
          method: uA.HTTP_METHOD.POST,
          queryParams: b,
          body: y,
          headers: p == null ? void 0 : p._headers
        });
      } catch (v) {
        throw this.questSdk.captureSentryException(v), v;
      }
    });
  }
  deleteQuest({ questId: e, entityId: r }, n) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: A, token: i, questId: e, entityId: o });
        const s = `/entities/${o}/quests/${e}/delete`;
        return this.questSdk.makeRequest({
          url: s,
          method: uA.HTTP_METHOD.POST,
          queryParams: n == null ? void 0 : n._queryParams,
          body: n == null ? void 0 : n._body,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  verifyQuestCriteriaForAUser({ questId: e, criteriaId: r, entityId: n, answer: A }, i) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = n || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: o, token: s, questId: e, entityId: a, criteriaId: r });
        const c = `/entities/${a}/quests/${e}/verify`, l = Object.assign({ userId: o }, i == null ? void 0 : i._queryParams), u = Object.assign(Object.assign({ criteriaId: r }, A && { answer: A }), i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: uA.HTTP_METHOD.POST,
          queryParams: l,
          body: u,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  verifyMultipleQuestCriteriaForAUser({ questId: e, entityId: r, criterias: n, referralCode: A, session: i }, o) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: s, token: a } = this.questSdk.getUser(), c = r || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: s, token: a, questId: e, entityId: c, criterias: n });
        const l = `/entities/${c}/quests/${e}/verify-all`, u = Object.assign({ userId: s }, o == null ? void 0 : o._queryParams), f = Object.assign(Object.assign(Object.assign({ criterias: n }, A && { referralCode: A }), i && { session: i }), o == null ? void 0 : o._body);
        return this.questSdk.makeRequest({
          url: l,
          method: uA.HTTP_METHOD.POST,
          queryParams: u,
          body: f,
          headers: o == null ? void 0 : o._headers
        });
      } catch (s) {
        throw this.questSdk.captureSentryException(s), s;
      }
    });
  }
  claimQuestRewards({ questId: e, referralCode: r, userIds: n, entityId: A }, i) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = A || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: o, token: s, questId: e, entityId: a });
        const c = `/entities/${a}/quests/${e}/claim`, l = Object.assign({ userId: o }, i == null ? void 0 : i._queryParams), u = Object.assign(Object.assign(Object.assign({ userId: o }, r && { referralCode: r }), n && { userIds: n }), i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: uA.HTTP_METHOD.POST,
          queryParams: l,
          body: u,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  claimMultipleQuestRewards({ questIds: e, referralCode: r, entityId: n, addToDynamicNFT: A }, i) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = n || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: o, token: s, questIds: e, entityId: a });
        const c = `/entities/${a}/quests/claim-multiple`, l = Object.assign(Object.assign(Object.assign({
          questIds: e,
          userId: o
        }, r && { referralCode: r }), A && { addToDynamicNFT: A }), i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: c,
          method: uA.HTTP_METHOD.POST,
          body: l,
          queryParams: i == null ? void 0 : i._queryParams,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  getOrSetNewReferralCodeForQuestAndUser({ questId: e, entityId: r }, n) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: A, token: i, questId: e, entityId: o });
        const s = `/entities/${o}/quests/${e}/users/${A}/referralcode`;
        return this.questSdk.makeRequest({
          url: s,
          method: uA.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getReferralLeaderboard({ questId: e, entityId: r }, n) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: A, token: i, questId: e, entityId: o });
        const s = `/entities/${o}/quests/${e}/referraldashboard`;
        return this.questSdk.makeRequest({
          url: s,
          method: uA.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getQuestSubmissions({ questId: e, parentEntityId: r, entityId: n }, A) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: i, token: o, questId: e, entityId: s });
        const a = `/entities/${s}/quests/${e}/submissions`, c = Object.assign({ userId: i }, A == null ? void 0 : A._queryParams);
        return this.questSdk.makeRequest({
          url: a,
          method: uA.HTTP_METHOD.GET,
          queryParams: c,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getMultipleQuestDetails({ entityId: e, limit: r, detailsPage: n, page: A } = {}, i) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = e || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: o, token: s, entityId: a });
        const c = `/entities/${a}/multiple-quests`, l = Object.assign(Object.assign(Object.assign(Object.assign({ userId: o }, n && { detailsPage: n }), A && { page: A }), r && { limit: r }), i == null ? void 0 : i._queryParams);
        return this.questSdk.makeRequest({
          method: uA.HTTP_METHOD.GET,
          url: c,
          queryParams: l,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  createMetricQuest({ title: e, description: r, metric: n, rewards: A, autoClaimRewards: i, repeatRewardsBasedOnMetricCount: o, endsAt: s, entityId: a, metadata: c, priority: l }, u) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: f, token: d } = this.questSdk.getUser(), g = a || this.questSdk.getEntityId();
        (0, BA.validateParams)({
          userId: f,
          token: d,
          entityId: g,
          title: e,
          metric: n,
          rewards: A,
          autoClaimRewards: i,
          repeatRewardsBasedOnMetricCount: o
        });
        const m = `/entities/${g}/metric-quests`, p = Object.assign({ userId: f }, u == null ? void 0 : u._queryParams), v = Object.assign(Object.assign(Object.assign({
          title: e,
          description: r,
          metric: n,
          rewards: A,
          autoClaimRewards: i,
          repeatRewardsBasedOnMetricCount: o,
          endsAt: s
        }, c && { metadata: c }), l && { priority: l }), u == null ? void 0 : u._body);
        return this.questSdk.makeRequest({
          url: m,
          method: uA.HTTP_METHOD.POST,
          queryParams: p,
          body: v,
          headers: u == null ? void 0 : u._headers
        });
      } catch (f) {
        throw this.questSdk.captureSentryException(f), f;
      }
    });
  }
  getMetricQuestDetails({ questId: e, entityId: r }, n) {
    return lA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, BA.validateParams)({ userId: A, token: i, entityId: o, questId: e });
        const s = `/entities/${o}/metric-quests/${e}`, a = Object.assign({ userId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: uA.HTTP_METHOD.GET,
          queryParams: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
wg.Quest = Xz;
var bg = {}, Z1 = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(bg, "__esModule", { value: !0 });
bg.Skill = void 0;
const J1 = ir, ql = an;
class Kz {
  constructor(e) {
    this.questSdk = e;
  }
  getAllSkills({ entityId: e } = {}, r) {
    return Z1(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, ql.validateParams)({ userId: n, token: A, entityId: i });
        const o = "/skills", s = Object.assign({ userId: n, entityId: i }, r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({
          url: o,
          method: J1.HTTP_METHOD.GET,
          queryParams: s,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getSkillDetails({ skillId: e }, r) {
    return Z1(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser();
        (0, ql.validateParams)({ userId: n, token: A, skillId: e });
        const i = `/skills/${e}`;
        return this.questSdk.makeRequest({
          url: i,
          method: J1.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  addNewSkill({ name: e, description: r, entityId: n }, A) {
    return Z1(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, ql.validateParams)({ entityId: s, name: e, description: r }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ql.validateParams)({ token: o, userId: i });
        const a = "/skills", c = Object.assign(Object.assign({}, i && { userId: i }), A == null ? void 0 : A._queryParams), l = Object.assign({
          entityId: s,
          name: e,
          description: r
        }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: a,
          method: J1.HTTP_METHOD.POST,
          queryParams: c,
          body: l,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  addMultipleNewSkills({ skills: e, entityId: r }, n) {
    return Z1(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, ql.validateParams)({ entityId: o, skills: e }), this.questSdk.getEntityAuthenticationToken() === void 0 && (0, ql.validateParams)({ userId: A, token: i });
        const s = "/skills/multiple", a = Object.assign(Object.assign({}, A && { userId: A }), n == null ? void 0 : n._queryParams), c = Object.assign({ entityId: o, skills: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: J1.HTTP_METHOD.POST,
          queryParams: a,
          body: c,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
bg.Skill = Kz;
var Bg = {}, nA = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(Bg, "__esModule", { value: !0 });
Bg.User = void 0;
const dA = an, fA = ir;
class Zz {
  constructor(e) {
    this.questSdk = e;
  }
  createNewCustomUser({ customPlatform: e, customUserId: r, entityId: n }, A) {
    return nA(this, void 0, void 0, function* () {
      try {
        const i = n || this.questSdk.getEntityId();
        (0, dA.validateParams)({ customPlatform: e, customUserId: r, entityId: i });
        const o = "/users/custom-ids", s = Object.assign({
          customPlatform: e,
          customUserId: r,
          entityId: i
        }, A == null ? void 0 : A._body);
        return this.questSdk.makeRequest({
          url: o,
          method: fA.HTTP_METHOD.POST,
          body: s,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getUserDetailsForUserId({ forUserId: e } = {}, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser();
        (0, dA.validateParams)({ userId: n, token: A });
        const i = Object.assign({ userId: e || n }, r == null ? void 0 : r._queryParams), o = `/users/${e || n}`;
        return this.questSdk.makeRequest({
          url: o,
          method: fA.HTTP_METHOD.GET,
          headers: r == null ? void 0 : r._headers,
          queryParams: i
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getUserDetailsForEmail({ email: e }, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser();
        (0, dA.validateParams)({ email: e, userId: n, token: A });
        const i = `/users/email/${e}`;
        return this.questSdk.makeRequest({
          url: i,
          method: fA.HTTP_METHOD.GET,
          headers: r == null ? void 0 : r._headers,
          queryParams: r == null ? void 0 : r._queryParams
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getUserDetailsForWalletAddress({ walletAddress: e }, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser();
        (0, dA.validateParams)({ userId: n, token: A, walletAddress: e });
        const i = `/users/address/${e}`;
        return this.questSdk.makeRequest({
          url: i,
          method: fA.HTTP_METHOD.GET,
          headers: r == null ? void 0 : r._headers,
          queryParams: r == null ? void 0 : r._queryParams
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getConnectedUserSocials({ entityId: e }, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, dA.validateParams)({ userId: n, token: A, entityId: i });
        const o = `/entities/${i}/users/${n}/connected-socials`;
        return this.questSdk.makeRequest({
          url: o,
          method: fA.HTTP_METHOD.GET,
          headers: r == null ? void 0 : r._headers,
          queryParams: r == null ? void 0 : r._queryParams
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  entitesForUser({ page: e, limit: r } = {}, n) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser();
        (0, dA.validateParams)({ userId: A, token: i, page: e, limit: r });
        const o = `/users/${A}/entities`, s = Object.assign({ page: e, limit: r }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({ url: o, method: fA.HTTP_METHOD.GET, queryParams: s, headers: n == null ? void 0 : n._headers });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getAdminEntitiesForUser({ parentEntityId: e } = {}, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser();
        (0, dA.validateParams)({ userId: n, token: A });
        const i = `/users/${n}/admin-entities`, o = Object.assign(Object.assign({}, e && { parentEntityId: e }), r == null ? void 0 : r._queryParams);
        return this.questSdk.makeRequest({ url: i, method: fA.HTTP_METHOD.GET, queryParams: o, headers: r == null ? void 0 : r._headers });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  setSelectedAdminEntityId({ entityId: e }, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, dA.validateParams)({ userId: n, token: A, entityId: i });
        const o = `/users/${i}/admin-entities`, s = Object.assign({ entityId: e }, r == null ? void 0 : r._body);
        return this.questSdk.makeRequest({
          url: o,
          method: fA.HTTP_METHOD.POST,
          body: s,
          headers: r == null ? void 0 : r._headers,
          queryParams: r == null ? void 0 : r._queryParams
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  setUserInfo({ name: e, imageUrl: r, bannerUrl: n, location: A, expertise: i, goals: o, interests: s, about: a, currentWork: c, funFacts: l, role: u, sector: f }, d) {
    return nA(this, void 0, void 0, function* () {
      try {
        const { userId: g, token: m } = this.questSdk.getUser();
        (0, dA.validateParams)({ userId: g, token: m });
        const p = `/users/${g}`, v = Object.assign({
          name: e,
          imageUrl: r,
          bannerUrl: n,
          location: A,
          expertise: i,
          goals: o,
          interests: s,
          about: a,
          currentWork: c,
          funFacts: l,
          role: u,
          sector: f
        }, d == null ? void 0 : d._body);
        return this.questSdk.makeRequest({
          url: p,
          method: fA.HTTP_METHOD.POST,
          body: v,
          headers: d == null ? void 0 : d._headers,
          queryParams: d == null ? void 0 : d._queryParams
        });
      } catch (g) {
        throw this.questSdk.captureSentryException(g), g;
      }
    });
  }
  sendOtpEmail({ email: e, entityId: r }, n) {
    return nA(this, void 0, void 0, function* () {
      try {
        const A = r || this.questSdk.getEntityId();
        (0, dA.validateParams)({ email: e, entityId: A });
        const i = "/users/email-login/send-otp", o = Object.assign({ email: e, entityId: A }, n == null ? void 0 : n._body), s = Object.assign({ entityId: A }, n == null ? void 0 : n._queryParams);
        return this.questSdk.makeRequest({
          url: i,
          method: fA.HTTP_METHOD.POST,
          body: o,
          queryParams: s,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  verifyOtpEmail({ email: e, entityId: r, otp: n, name: A }, i) {
    return nA(this, void 0, void 0, function* () {
      try {
        const o = r || this.questSdk.getEntityId();
        (0, dA.validateParams)({ email: e, entityId: o, otp: n });
        const s = "/users/email-login/verify-otp", a = Object.assign(Object.assign({ email: e, entityId: o, otp: n }, A && { name: A }), i == null ? void 0 : i._body), c = yield this.questSdk.makeRequest({
          url: s,
          method: fA.HTTP_METHOD.POST,
          body: a,
          headers: i == null ? void 0 : i._headers,
          queryParams: i == null ? void 0 : i._queryParams
        });
        return c.success === !0 && c.userId && c.token && this.questSdk.setUser({
          userId: c.userId,
          token: c.token
        }), c;
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  loginWithGoogle({ code: e, redirectUri: r, entityId: n }, A) {
    return nA(this, void 0, void 0, function* () {
      try {
        (0, dA.validateParams)({ code: e, redirectUri: r, entityId: n });
        const i = "/users/google/login", o = Object.assign({ code: e, redirectUri: r, entityId: n }, A == null ? void 0 : A._body), s = yield this.questSdk.makeRequest({
          url: i,
          method: fA.HTTP_METHOD.POST,
          body: o,
          headers: A == null ? void 0 : A._headers,
          queryParams: A == null ? void 0 : A._queryParams
        });
        return s.success === !0 && s.userId && s.token && this.questSdk.setUser({
          userId: s.userId,
          token: s.token
        }), s;
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  loginWithWallet({ entityId: e, walletAddress: r, signature: n, token: A }, i) {
    return nA(this, void 0, void 0, function* () {
      try {
        (0, dA.validateParams)({ entityId: e, walletAddress: r, signature: n, token: A });
        const o = "/users/wallet/login", s = Object.assign({ entityId: e, walletAddress: r, signature: n, token: A }, i == null ? void 0 : i._body), a = yield this.questSdk.makeRequest({
          url: o,
          method: fA.HTTP_METHOD.POST,
          body: s,
          headers: i == null ? void 0 : i._headers,
          queryParams: i == null ? void 0 : i._queryParams
        });
        return a.success === !0 && a.userId && a.token && this.questSdk.setUser({
          userId: a.userId,
          token: a.token
        }), a;
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  connectWallet({ entityId: e, walletAddress: r, signature: n, token: A, userId: i }, o) {
    return nA(this, void 0, void 0, function* () {
      try {
        (0, dA.validateParams)({ entityId: e, walletAddress: r, signature: n, token: A, userId: i });
        const s = `/users/${i}/wallet-connect`, a = Object.assign({ entityId: e, walletAddress: r, signature: n, token: A }, o == null ? void 0 : o._body), c = Object.assign({}, o == null ? void 0 : o._queryParams);
        return this.questSdk.makeRequest({
          url: s,
          method: fA.HTTP_METHOD.POST,
          body: a,
          headers: o == null ? void 0 : o._headers,
          queryParams: c
        });
      } catch (s) {
        throw this.questSdk.captureSentryException(s), s;
      }
    });
  }
  loginWithExternalUserId({ externalUserId: e, entityId: r, email: n, walletAddress: A, name: i, imageUrl: o }, s) {
    return nA(this, void 0, void 0, function* () {
      try {
        const a = r || this.questSdk.getEntityId();
        (0, dA.validateParams)({ entityId: a, externalUserId: e });
        const c = "/users/external/login", l = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ externalUserId: e, entityId: a }, n && { email: n }), A && { walletAddress: A }), i && { name: i }), o && { imageUrl: o }), s == null ? void 0 : s._body);
        return this.questSdk.makeRequest({
          url: c,
          method: fA.HTTP_METHOD.POST,
          body: l,
          queryParams: s == null ? void 0 : s._queryParams,
          headers: s == null ? void 0 : s._headers
        });
      } catch (a) {
        throw this.questSdk.captureSentryException(a), a;
      }
    });
  }
  loginWithExternalUserIdEncrypted({ externalUserId: e, entityId: r, email: n, walletAddress: A }, i) {
    return nA(this, void 0, void 0, function* () {
      try {
        const o = r || this.questSdk.getEntityId(), { apiKey: s, apiSecret: a } = this.questSdk.getApiKeys();
        (0, dA.validateParams)({ entityId: o, externalUserId: e, apiSecret: a });
        const c = Object.assign(Object.assign(Object.assign({ externalUserId: e, entityId: o }, n && { email: n }), A && { walletAddress: A }), { apiKey: s }), l = yield this.encryptData(JSON.stringify(c), a);
        if (!l)
          throw new Error("Encryption failed");
        const u = "/users/external/login/encrypted", f = Object.assign({ entityId: o, encryptedData: l }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: u,
          method: fA.HTTP_METHOD.POST,
          body: f,
          queryParams: i == null ? void 0 : i._queryParams,
          headers: i == null ? void 0 : i._headers
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  refreshUserToken({ refreshToken: e, entityId: r }, n) {
    return nA(this, void 0, void 0, function* () {
      try {
        const A = r || this.questSdk.getEntityId(), { userId: i, token: o } = this.questSdk.getUser();
        (0, dA.validateParams)({ entityId: A, refreshToken: e, token: o, userId: i });
        const s = `/entities/${A}/users/${i}/refresh-token`, a = Object.assign({ refreshToken: e }, n == null ? void 0 : n._body);
        return this.questSdk.makeRequest({
          url: s,
          method: fA.HTTP_METHOD.POST,
          queryParams: n == null ? void 0 : n._queryParams,
          body: a,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  encryptData(e, r) {
    return nA(this, void 0, void 0, function* () {
      try {
        const n = new TextEncoder(), A = crypto.getRandomValues(new Uint8Array(16)), i = yield crypto.subtle.digest({ name: "SHA-256" }, n.encode(r)), o = yield crypto.subtle.importKey("raw", i, { name: "AES-CBC", length: 256 }, !1, [
          "encrypt"
        ]), s = yield crypto.subtle.encrypt({ name: "AES-CBC", iv: A }, o, n.encode(e));
        return {
          iv: Array.from(A).map((a) => a.toString(16).padStart(2, "0")).join(""),
          encryptedData: Array.from(new Uint8Array(s)).map((a) => a.toString(16).padStart(2, "0")).join("")
        };
      } catch (n) {
        throw new n();
      }
    });
  }
}
Bg.User = Zz;
var Eg = {}, na = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(Eg, "__esModule", { value: !0 });
Eg.EntityGem = void 0;
const Aa = ir, ia = an;
class Jz {
  constructor(e) {
    this.questSdk = e;
  }
  getAllEntityGemsContracts({ entityId: e }, r) {
    return na(this, void 0, void 0, function* () {
      try {
        const { userId: n, token: A } = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, ia.validateParams)({ userId: n, token: A, entityId: i });
        const o = `/entities/${i}/gem-contracts`;
        return this.questSdk.makeRequest({
          url: o,
          method: Aa.HTTP_METHOD.GET,
          queryParams: r == null ? void 0 : r._queryParams,
          headers: r == null ? void 0 : r._headers
        });
      } catch (n) {
        throw this.questSdk.captureSentryException(n), n;
      }
    });
  }
  getEntityGemContractById({ entityGemsContractId: e, entityId: r }, n) {
    return na(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, ia.validateParams)({ userId: A, token: i, entityGemsContractId: e, entityId: o });
        const s = `/entities/${o}/gem-contracts/${e}`;
        return this.questSdk.makeRequest({
          url: s,
          method: Aa.HTTP_METHOD.GET,
          headers: n._headers,
          queryParams: n._queryParams
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  addNewEntityGemsContractForEntity({ initialDefaultValue: e, name: r, source: n, desc: A, entityId: i, logo: o }, s) {
    return na(this, void 0, void 0, function* () {
      try {
        const { userId: a, token: c } = this.questSdk.getUser(), l = i || this.questSdk.getEntityId();
        (0, ia.validateParams)({ userId: a, token: c, entityId: l, name: r, source: n, initialDefaultValue: e });
        const u = `/entities/${l}/gem-contracts`, f = Object.assign(Object.assign(Object.assign({
          name: r,
          source: n,
          initialDefaultValue: e
        }, A && { desc: A }), o && { logo: o }), s._body);
        return this.questSdk.makeRequest({
          url: u,
          method: Aa.HTTP_METHOD.POST,
          queryParams: s._queryParams,
          body: f,
          headers: s._headers
        });
      } catch (a) {
        throw this.questSdk.captureSentryException(a), a;
      }
    });
  }
  updateEntityGemsContractForEntity({ entityId: e, entityGemsContractId: r, desc: n, initialDefaultValue: A, logo: i, name: o, source: s }, a) {
    return na(this, void 0, void 0, function* () {
      try {
        const { userId: c, token: l } = this.questSdk.getUser(), u = e || this.questSdk.getEntityId();
        (0, ia.validateParams)({ entityId: u, entityGemsContractId: r, userId: c, token: l });
        const f = `/entities/${u}/gem-contracts/${r}/update`, d = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, o && { name: o }), s && { source: s }), n && { desc: n }), i && { logo: i }), A && { initialDefaultValue: A }), a == null ? void 0 : a._body);
        return this.questSdk.makeRequest({
          url: f,
          method: Aa.HTTP_METHOD.POST,
          body: d,
          headers: a == null ? void 0 : a._headers,
          queryParams: a == null ? void 0 : a._queryParams
        });
      } catch (c) {
        throw this.questSdk.captureSentryException(c), c;
      }
    });
  }
  softDeleteEntityGemsContractForEntity({ entityGemsContractId: e, entityId: r }, n) {
    return na(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = r || this.questSdk.getEntityId();
        (0, ia.validateParams)({ userId: A, token: i, entityId: o, entityGemsContractId: e });
        const s = `/entities/${o}/gem-contracts/${e}/delete`;
        return this.questSdk.makeRequest({
          url: s,
          method: Aa.HTTP_METHOD.POST,
          body: n == null ? void 0 : n._body,
          headers: n == null ? void 0 : n._headers,
          queryParams: n == null ? void 0 : n._queryParams
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  getAllEntityGemsForAUser({ entityId: e, userId: r } = {}, n) {
    return na(this, void 0, void 0, function* () {
      try {
        const A = this.questSdk.getUser(), i = e || this.questSdk.getEntityId();
        (0, ia.validateParams)({ userId: r || A.userId, token: A.token, entityId: i });
        const o = `/entities/${i}/users/${r || A.userId}/gems`;
        return this.questSdk.makeRequest({
          url: o,
          method: Aa.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
  increaseEntityGemForAUser({ entityGemsContractId: e, value: r, entityId: n, userId: A }, i) {
    return na(this, void 0, void 0, function* () {
      try {
        const o = this.questSdk.getUser(), s = n || this.questSdk.getEntityId();
        (0, ia.validateParams)({ entityId: s, entityGemsContractId: e, value: r, userId: A || o.userId });
        const a = `/entities/${s}/users/${A || o.userId}/gemsContracts/${e}/increase`, c = Object.assign({ value: r }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: a,
          method: Aa.HTTP_METHOD.POST,
          body: c,
          headers: i == null ? void 0 : i._headers,
          queryParams: i == null ? void 0 : i._queryParams
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
  decreaseEntityGemForAUser({ entityGemsContractId: e, entityId: r, userId: n, value: A }, i) {
    return na(this, void 0, void 0, function* () {
      try {
        const o = this.questSdk.getUser(), s = r || this.questSdk.getEntityId();
        (0, ia.validateParams)({ entityGemsContractId: e, entityId: s, userId: n || o.userId, value: A });
        const a = `/entities/${s}/users/${n || o.userId}/gemsContracts/${e}/decrease`, c = Object.assign({ value: A }, i == null ? void 0 : i._body);
        return this.questSdk.makeRequest({
          url: a,
          method: Aa.HTTP_METHOD.POST,
          body: c,
          headers: i == null ? void 0 : i._headers,
          queryParams: i == null ? void 0 : i._queryParams
        });
      } catch (o) {
        throw this.questSdk.captureSentryException(o), o;
      }
    });
  }
}
Eg.EntityGem = Jz;
var xg = {}, OC = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(xg, "__esModule", { value: !0 });
xg.CustomReward = void 0;
const FC = ir, TC = an;
class _z {
  constructor(e) {
    this.questSdk = e;
  }
  addCustomRewardToUser({ entityId: e, rewardId: r, forUserId: n }, A) {
    return OC(this, void 0, void 0, function* () {
      try {
        const { userId: i, token: o } = this.questSdk.getUser(), s = e || this.questSdk.getEntityId();
        (0, TC.validateParams)({ userId: n || i, token: o, entityId: s, rewardId: r });
        const a = `/entities/${s}/users/${n || i}/${r}`;
        return this.questSdk.makeRequest({
          url: a,
          method: FC.HTTP_METHOD.POST,
          queryParams: A == null ? void 0 : A._queryParams,
          body: A == null ? void 0 : A._body,
          headers: A == null ? void 0 : A._headers
        });
      } catch (i) {
        throw this.questSdk.captureSentryException(i), i;
      }
    });
  }
  getCustomRewardByUser({ entityId: e, forUserId: r } = {}, n) {
    return OC(this, void 0, void 0, function* () {
      try {
        const { userId: A, token: i } = this.questSdk.getUser(), o = e || this.questSdk.getEntityId();
        (0, TC.validateParams)({ userId: r || A, token: i, entityId: o });
        const s = `/entities/${o}/users/${r || A}/custom-reward`;
        return this.questSdk.makeRequest({
          url: s,
          method: FC.HTTP_METHOD.GET,
          queryParams: n == null ? void 0 : n._queryParams,
          headers: n == null ? void 0 : n._headers
        });
      } catch (A) {
        throw this.questSdk.captureSentryException(A), A;
      }
    });
  }
}
xg.CustomReward = _z;
var Ig = {}, $z = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(Ig, "__esModule", { value: !0 });
Ig.QuestEvents = void 0;
const eY = DA, tY = ir, rY = an;
class nY {
  constructor(e) {
    this.questSdk = e;
  }
  track({ entityId: e, name: r, userId: n, properties: A, isIndependent: i, isQuestUser: o }, s) {
    return $z(this, void 0, void 0, function* () {
      try {
        const a = e || this.questSdk.getEntityId(), c = "/events/track";
        (0, rY.validateParams)({ entityId: a, name: r, userId: n });
        const l = yield this.questSdk.getUserInfo(), u = this.questSdk.getUrlInformation();
        let f = [];
        if (typeof window < "u" && (window != null && window.sessionStorage)) {
          const g = window.sessionStorage.getItem(eY.TEXT_CAMPAIGN_SESSION_ID);
          if (g !== null) {
            const m = JSON.parse(g || String([])) || [];
            Array.isArray(m) && (f = m);
          }
        }
        const d = {
          entityId: a,
          name: r,
          source: "sdk",
          properties: A,
          isIndependent: i,
          userId: n || this.questSdk.getDistinctId(),
          isQuestUser: o,
          // default ones
          metadata: {
            userAgent: typeof navigator < "u" && (navigator == null ? void 0 : navigator.userAgent) || "",
            ip: l == null ? void 0 : l.ip,
            city: l == null ? void 0 : l.city,
            region: l == null ? void 0 : l.region,
            country: l == null ? void 0 : l.country,
            url: u == null ? void 0 : u.href,
            host: u == null ? void 0 : u.host,
            hostname: u == null ? void 0 : u.hostname,
            origin: u == null ? void 0 : u.origin,
            pathname: u == null ? void 0 : u.pathname,
            textCampaigns: f
          }
        };
        return this.questSdk.makeRequest({
          url: c,
          method: tY.HTTP_METHOD.POST,
          queryParams: s == null ? void 0 : s._queryParams,
          body: d,
          headers: s == null ? void 0 : s._headers
        });
      } catch (a) {
        throw this.questSdk.captureSentryException(a), a;
      }
    });
  }
}
Ig.QuestEvents = nY;
var Sg = {}, AY = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(Sg, "__esModule", { value: !0 });
Sg.Campaign = void 0;
const MC = DA, iY = ir, oY = an;
class sY {
  constructor(e) {
    this.questSdk = e;
  }
  getTextCampaign({ campaignId: e, userId: r, entityId: n, isQuestUser: A, defaultText: i, timeout: o }, s) {
    var a, c, l;
    return AY(this, void 0, void 0, function* () {
      const u = {
        success: !0,
        data: { campaignVariationId: "default", title: i || "No response" }
      };
      try {
        const f = n || this.questSdk.getEntityId(), d = this.questSdk.getUser();
        (0, oY.validateParams)(Object.assign({ entityId: f, campaignId: e, userId: A ? d.userId : r }, A && { token: d.token }));
        const g = `/v2/entities/${f}/text-campaigns/${e}`, m = Object.assign(A ? { userId: d.userId, token: d.token } : { externalUserId: r }, s == null ? void 0 : s._queryParams), p = yield this.questSdk.makeRequest({
          url: g,
          method: iY.HTTP_METHOD.GET,
          queryParams: m,
          headers: s == null ? void 0 : s._headers,
          timeout: o || void 0
        });
        if (!((a = p == null ? void 0 : p.data) === null || a === void 0) && a.campaignVariationId && ((c = p == null ? void 0 : p.data) === null || c === void 0 ? void 0 : c.campaignVariationId) !== "default" && typeof window < "u" && window != null && window.sessionStorage) {
          const v = window.sessionStorage.getItem(MC.TEXT_CAMPAIGN_SESSION_ID);
          let C = [];
          if (v !== null) {
            const B = JSON.parse(v || String([])) || [];
            Array.isArray(B) && (C = B);
          }
          let w = !1;
          C.forEach((B) => {
            B.campaignId === e && (w = !0, B.campaignVariationId = p.data.campaignVariationId);
          }), w || C.push({
            campaignId: e,
            campaignVariationId: p.data.campaignVariationId
          }), window.sessionStorage.setItem(MC.TEXT_CAMPAIGN_SESSION_ID, JSON.stringify(C));
        }
        return p;
      } catch (f) {
        if (this.questSdk.captureSentryException(f), (f == null ? void 0 : f.code) === "ECONNABORTED" || !((l = f == null ? void 0 : f.message) === null || l === void 0) && l.includes("timeout"))
          return console.log("Request timed out, returning default response"), u;
        throw f;
      }
    });
  }
}
Sg.Campaign = sY;
(function(t) {
  var e = rt && rt.__createBinding || (Object.create ? function(n, A, i, o) {
    o === void 0 && (o = i);
    var s = Object.getOwnPropertyDescriptor(A, i);
    (!s || ("get" in s ? !A.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return A[i];
    } }), Object.defineProperty(n, o, s);
  } : function(n, A, i, o) {
    o === void 0 && (o = i), n[o] = A[i];
  }), r = rt && rt.__exportStar || function(n, A) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(A, i) && e(A, n, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(lg, t), r(ug, t), r(dg, t), r(fg, t), r(hg, t), r(pg, t), r(gg, t), r(mg, t), r(vg, t), r(qg, t), r(yg, t), r(Cg, t), r(wg, t), r(bg, t), r(Bg, t), r(Eg, t), r(xg, t), r(Ig, t), r(Sg, t);
})(Um);
var Lk = {}, Pg = {};
Object.defineProperty(Pg, "__esModule", { value: !0 });
Pg.EligibilityCriteria = void 0;
const Hn = ir;
class aY {
  createUserInputText({ title: e, xp: r, frequency: n, effort: A, importance: i }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.USER_INPUT_TEXT,
      source: Hn.EligibilityCriteriaSource.USER_INPUT,
      data: {
        title: e,
        effort: A,
        importance: i,
        xp: r,
        frequency: n
      }
    };
  }
  createUserInputSingleChoice({ title: e, options: r, effort: n, importance: A, xp: i, frequency: o }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.USER_INPUT_SINGLE_CHOICE,
      source: Hn.EligibilityCriteriaSource.USER_INPUT,
      data: {
        title: e,
        options: r,
        effort: n,
        importance: A,
        xp: i,
        frequency: o
      }
    };
  }
  createUserInputMultiChoice({ title: e, options: r, effort: n, importance: A, xp: i, frequency: o }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.USER_INPUT_MULTI_CHOICE,
      source: Hn.EligibilityCriteriaSource.USER_INPUT,
      data: {
        title: e,
        options: r,
        effort: n,
        importance: A,
        xp: i,
        frequency: o
      }
    };
  }
  createUserInputDate({ title: e, effort: r, importance: n, xp: A, frequency: i }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.USER_INPUT_DATE,
      source: Hn.EligibilityCriteriaSource.USER_INPUT,
      data: {
        title: e,
        effort: r,
        importance: n,
        xp: A,
        frequency: i
      }
    };
  }
  createUserEventMetric({ metric: e, metricName: r, metricCount: n, title: A, effort: i, importance: o, xp: s, frequency: a }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.DAPP_METRIC_THRESHOLD,
      source: Hn.EligibilityCriteriaSource.USER_EVENT,
      data: {
        metric: e,
        metricName: r,
        metricCount: n,
        title: A,
        effort: i,
        importance: o,
        xp: s,
        frequency: a
      },
      extraData: {
        metric: e,
        metricName: r
      }
    };
  }
  createUserEventStreak({ streak: e, streakCount: r, streakName: n, title: A, xp: i, frequency: o, effort: s, importance: a }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.DAPP_STREAK_THRESHOLD,
      source: Hn.EligibilityCriteriaSource.USER_EVENT,
      data: {
        streak: e,
        streakCount: r,
        streakName: n,
        title: A,
        xp: i,
        frequency: o,
        effort: s,
        importance: a
      },
      extraData: {
        streak: e,
        streakName: n
      }
    };
  }
  createLink({ linkActionName: e, linkActionUrl: r, effort: n, importance: A, xp: i, frequency: o }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.LINK_OPEN_READ,
      source: Hn.EligibilityCriteriaSource.LINK,
      data: {
        linkActionName: e,
        linkActionUrl: r,
        effort: n,
        importance: A,
        xp: i,
        frequency: o
      }
    };
  }
  createDiscordJoinServer({ discordInviteLink: e, serverId: r, serverName: n, effort: A, importance: i, xp: o, frequency: s }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.DISCORD_JOIN_GUILD,
      source: Hn.EligibilityCriteriaSource.DISCORD,
      data: {
        discordInviteLink: e,
        serverId: r,
        serverName: n,
        effort: A,
        importance: i,
        xp: o,
        frequency: s
      },
      extraData: {
        serverName: n,
        serverId: r
      }
    };
  }
  createTwitterFollow({ twitterUsername: e, effort: r, importance: n, frequency: A, xp: i }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.TWITTER_FOLLOW_ACCOUNT,
      source: Hn.EligibilityCriteriaSource.TWITTER,
      data: {
        twitterUsername: e,
        effort: r,
        importance: n,
        frequency: A,
        xp: i
      }
    };
  }
  createTwitterLike({ twitterPostURL: e, effort: r, importance: n, xp: A, frequency: i }) {
    return {
      type: Hn.EligibilityCriteriaTypeConst.TWITTER_LIKE_POST,
      source: Hn.EligibilityCriteriaSource.TWITTER,
      data: {
        twitterPostURL: e,
        effort: r,
        importance: n,
        frequency: i,
        xp: A
      }
    };
  }
  createCustomCriteria({ type: e, source: r, data: n }) {
    return Object.assign({
      type: e,
      data: n
    }, r && { source: r });
  }
  verifyUserInputText(e, r) {
    return {
      criteriaId: e,
      answer: [r]
    };
  }
  verifyUserInputSingleChoice(e, r) {
    return {
      criteriaId: e,
      answer: [r]
    };
  }
  verifyUserInputMultipleChoice(e, r) {
    return {
      criteriaId: e,
      answer: r
    };
  }
  verifyUserInputDate(e, r) {
    return {
      criteriaId: e,
      answer: [r]
    };
  }
  verifyLink(e) {
    return {
      criteriaId: e
    };
  }
  verifyTwitterFollowAccount(e) {
    return {
      criteriaId: e
    };
  }
  verifyTwitterLikePost(e) {
    return {
      criteriaId: e
    };
  }
  verifyDiscordJoinServer(e) {
    return {
      criteriaId: e
    };
  }
}
Pg.EligibilityCriteria = aY;
var kg = {};
Object.defineProperty(kg, "__esModule", { value: !0 });
kg.Reward = void 0;
const B9 = ir;
class cY {
  createXp(e) {
    return {
      type: B9.QuestRewardTypeConst.REWARD_XP,
      xp: e
    };
  }
  createSkillScores({ skillScores: e }) {
    return {
      type: B9.QuestRewardTypeConst.REWARD_SKILL_SCORE,
      skills: e
    };
  }
  createBadge({ title: e, description: r, imageIPFS: n }) {
    return {
      type: B9.QuestRewardTypeConst.REWARD_BADGE,
      title: e,
      imageIPFS: n,
      description: r
    };
  }
  createCustomReward({ type: e, label: r, metadata: n, skills: A, xp: i }) {
    return {
      type: e,
      label: r,
      metadata: n,
      skills: A,
      xp: i
    };
  }
}
kg.Reward = cY;
var Og = {};
Object.defineProperty(Og, "__esModule", { value: !0 });
Og.XP = void 0;
const lY = Um;
let uY = class {
  constructor(e) {
    this.addXpForUser = this.getDynamicNftFunctions().addRunningXP, this.getXpForUser = this.getDynamicNftFunctions().getXpForUser, this.getXpForUsers = this.getDynamicNftFunctions().getXpForUsers, this.getXpForEntity = this.getDynamicNftFunctions().getXpForEntity, this.getXpForEntities = this.getDynamicNftFunctions().getXpForEntities, this.questSdk = e;
  }
  getDynamicNftFunctions() {
    if (!this.questSdk)
      throw new Error("Invalid request. Please pass the base class in the constructor");
    return new lY.DynamicNft(this.questSdk);
  }
};
Og.XP = uY;
(function(t) {
  var e = rt && rt.__createBinding || (Object.create ? function(n, A, i, o) {
    o === void 0 && (o = i);
    var s = Object.getOwnPropertyDescriptor(A, i);
    (!s || ("get" in s ? !A.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return A[i];
    } }), Object.defineProperty(n, o, s);
  } : function(n, A, i, o) {
    o === void 0 && (o = i), n[o] = A[i];
  }), r = rt && rt.__exportStar || function(n, A) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(A, i) && e(A, n, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Pg, t), r(kg, t), r(Og, t);
})(Lk);
var Gk = {}, Nm = {};
const jm = /* @__PURE__ */ Mz(CG);
var dY = rt && rt.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var A = Object.getOwnPropertyDescriptor(e, r);
  (!A || ("get" in A ? !e.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, A);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), fY = rt && rt.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), hY = rt && rt.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var r in t) r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && dY(e, t, r);
  return fY(e, t), e;
}, c0 = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
}, pY = rt && rt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Nm, "__esModule", { value: !0 });
const l0 = pY(jm), HC = hY(DA);
class gY {
  constructor(e) {
    this.apiKey = e.apiKey, this.apiSecret = e.apiSecret, this.baseUrl = (e == null ? void 0 : e.testMode) == !0 ? HC.serverTestUrl : HC.serverUrl, this.config = {
      headers: { apiKey: this.apiKey, apiSecret: this.apiSecret, "User-Agent": e.userAgent }
    };
  }
  connect({ entityId: e, userId: r, token: n, discordRedirectCode: A, redirectUri: i }) {
    return c0(this, void 0, void 0, function* () {
      try {
        if (!A || A == "")
          throw new Error("Invalid discordRedirectCode");
        if (!i || i == "")
          throw new Error("Invalid redirectUri");
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        const o = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), s = {
          code: A,
          redirectUri: i,
          entityId: e,
          userId: r
        };
        return (yield l0.default.post(`${this.baseUrl}/discord/login`, s, {
          headers: o
        })).data;
      } catch (o) {
        throw new Error(o.message);
      }
    });
  }
  disconnect({ entityId: e, userId: r, token: n }) {
    return c0(this, void 0, void 0, function* () {
      try {
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        const A = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), i = { userId: r, entityId: e };
        return (yield l0.default.post(`${this.baseUrl}/discord/logout`, i, { headers: A })).data;
      } catch (A) {
        throw new Error(A.message);
      }
    });
  }
  fetchMyGuilds({ entityId: e, userId: r, token: n }) {
    return c0(this, void 0, void 0, function* () {
      try {
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        const A = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), i = { entityId: e, userId: r };
        return (yield l0.default.get(`${this.baseUrl}/discord/my/guilds`, {
          headers: A,
          params: i
        })).data;
      } catch (A) {
        throw new Error(A.message);
      }
    });
  }
  fetchMyGuildRoles({ entityId: e, userId: r, token: n, guildId: A }) {
    return c0(this, void 0, void 0, function* () {
      try {
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        if (!A || A == "")
          throw new Error("Invalid guildId");
        const i = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), o = { entityId: e, userId: r };
        return (yield l0.default.get(`${this.baseUrl}/discord/guilds/${A}/roles`, { headers: i, params: o })).data;
      } catch (i) {
        throw new Error(i.message);
      }
    });
  }
  fetchGuildSceduledEvents({ entityId: e, userId: r, token: n, guildId: A }) {
    return c0(this, void 0, void 0, function* () {
      try {
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        if (!A || A == "")
          throw new Error("Invalid guildId");
        const i = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), o = { entityId: e, userId: r };
        return (yield l0.default.get(`${this.baseUrl}/discord/guilds/${A}/events`, { headers: i, params: o })).data;
      } catch (i) {
        throw new Error(i.message);
      }
    });
  }
}
Nm.default = gY;
var Lm = {}, mY = rt && rt.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var A = Object.getOwnPropertyDescriptor(e, r);
  (!A || ("get" in A ? !e.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, A);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), vY = rt && rt.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), qY = rt && rt.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var r in t) r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && mY(e, t, r);
  return vY(e, t), e;
}, DC = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
}, yY = rt && rt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Lm, "__esModule", { value: !0 });
const QC = yY(jm), UC = qY(DA);
class CY {
  constructor(e) {
    this.apiKey = e.apiKey, this.apiSecret = e.apiSecret, this.baseUrl = (e == null ? void 0 : e.testMode) == !0 ? UC.serverTestUrl : UC.serverUrl, this.config = {
      headers: { apiKey: this.apiKey, apiSecret: this.apiSecret, "User-Agent": e.userAgent }
    };
  }
  connect({ entityId: e, userId: r, token: n, instagramRedirectCode: A }) {
    return DC(this, void 0, void 0, function* () {
      try {
        if (!A || A == "")
          throw new Error("Invalid instagramRedirectCode");
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        const i = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), o = {
          code: A,
          entityId: e,
          userId: r
        };
        return (yield QC.default.post(`${this.baseUrl}/instagram/login`, o, { headers: i })).data;
      } catch (i) {
        throw new Error(i.message);
      }
    });
  }
  disconnect({ entityId: e, userId: r, token: n }) {
    return DC(this, void 0, void 0, function* () {
      try {
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
        const A = Object.assign(Object.assign({}, this.config.headers), { userId: r, token: n }), i = {
          entityId: e,
          userId: r
        };
        return (yield QC.default.post(`${this.baseUrl}/instagram/logout`, i, { headers: A })).data;
      } catch (A) {
        throw new Error(A.message);
      }
    });
  }
}
Lm.default = CY;
var v1 = {}, NC = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
};
Object.defineProperty(v1, "__esModule", { value: !0 });
v1.Twitter = void 0;
const wY = ir, bY = an;
class Rk {
  constructor(e) {
    this.questSdk = e;
  }
  connect({ redirectUri: e, twitterRedirectCode: r, entityId: n, type: A }, i) {
    return NC(this, void 0, void 0, function* () {
      try {
        const { userId: o, token: s } = this.questSdk.getUser(), a = n || this.questSdk.getEntityId();
        (0, bY.validateParams)({ redirectUri: e, twitterRedirectCode: r, entityId: a, userId: o, token: s });
        const c = "/twitter/login", l = {
          code: r,
          redirectUri: e,
          entityId: a,
          userId: o,
          type: A
        };
        return this.questSdk.makeRequest({
          url: c,
          method: wY.HTTP_METHOD.POST,
          body: l,
          headers: i == null ? void 0 : i._body,
          queryParams: i == null ? void 0 : i._queryParams
        });
      } catch (o) {
        throw o;
      }
    });
  }
  disconnect(e, r, n) {
    return NC(this, void 0, void 0, function* () {
      try {
        if (!e || e == "")
          throw new Error("Invalid entityId");
        if (!r || r == "")
          throw new Error("Invalid userId");
        if (!n || n == "")
          throw new Error("Invalid token");
      } catch (A) {
        throw new Error(A.message);
      }
    });
  }
}
v1.Twitter = Rk;
v1.default = Rk;
(function(t) {
  var e = rt && rt.__createBinding || (Object.create ? function(n, A, i, o) {
    o === void 0 && (o = i);
    var s = Object.getOwnPropertyDescriptor(A, i);
    (!s || ("get" in s ? !A.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return A[i];
    } }), Object.defineProperty(n, o, s);
  } : function(n, A, i, o) {
    o === void 0 && (o = i), n[o] = A[i];
  }), r = rt && rt.__exportStar || function(n, A) {
    for (var i in n) i !== "default" && !Object.prototype.hasOwnProperty.call(A, i) && e(A, n, i);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Nm, t), r(Lm, t), r(v1, t);
})(Gk);
var BY = rt && rt.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var A = Object.getOwnPropertyDescriptor(e, r);
  (!A || ("get" in A ? !e.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, A);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), EY = rt && rt.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Gm = rt && rt.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var r in t) r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && BY(e, t, r);
  return EY(e, t), e;
}, jC = rt && rt.__awaiter || function(t, e, r, n) {
  function A(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (u) {
        o(u);
      }
    }
    function a(l) {
      try {
        c(n.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? i(l.value) : A(l.value).then(s, a);
    }
    c((n = n.apply(t, e || [])).next());
  });
}, xY = rt && rt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ia, "__esModule", { value: !0 });
Ia.Social = Ia.Abstract = zk = Ia.Core = void 0;
const _1 = DA, IY = Gm(Um);
var zk = Ia.Core = IY;
const SY = Gm(Lk);
Ia.Abstract = SY;
const PY = Gm(Gk);
Ia.Social = PY;
const kY = an, E9 = xY(jm), OY = ir;
class FY {
  constructor({ apiKey: e, apiSecret: r, entityAuthenticationToken: n, stagingEnvironment: A = !1, userAgent: i, entityId: o, platform: s }) {
    this.apiKey = e, this.apiSecret = r, this.userAgent = i || OY.USER_AGENT.BROWSER, this.entityAuthenticationToken = n, this.entityId = o, this.stagingEnvironment = A, this.baseUrl = A ? _1.STAGING_URL : _1.PRODUCTION_URL;
  }
  makeRequest({ url: e, method: r, headers: n, queryParams: A, body: i, timeout: o }) {
    var s, a;
    return jC(this, void 0, void 0, function* () {
      try {
        return (0, kY.validateParams)({ apiKey: this.apiKey }), (yield (0, E9.default)({
          method: r,
          url: this.baseUrl + e,
          params: A,
          headers: Object.assign(Object.assign(Object.assign(Object.assign({ apiKey: this.apiKey }, typeof this.userId == "string" && { userId: this.userId }), typeof this.token == "string" && { token: this.token }), { entityId: this.entityId, "User-Agent": this.userAgent, "entity-authentication-token": this.entityAuthenticationToken }), n),
          data: i,
          timeout: o || void 0
        })).data;
      } catch (c) {
        if (this.captureSentryException(c), E9.default.isAxiosError(c) && c.code === "ECONNABORTED")
          throw new Error("timeout");
        if (!((s = c == null ? void 0 : c.response) === null || s === void 0) && s.data)
          return (a = c == null ? void 0 : c.response) === null || a === void 0 ? void 0 : a.data;
        throw c;
      }
    });
  }
  setEntityId({ entityId: e }) {
    this.entityId = e;
  }
  getEntityId() {
    return this.entityId;
  }
  setUser({ userId: e, token: r }) {
    this.userId = e, this.token = r;
  }
  getUser() {
    return {
      userId: this.userId,
      token: this.token
    };
  }
  setEnvironment({ stagingEnvironment: e }) {
    this.stagingEnvironment = e, this.baseUrl = e ? _1.STAGING_URL : _1.PRODUCTION_URL;
  }
  getEnvironment() {
    return { stagingEnvironment: this.stagingEnvironment };
  }
  isStagingEnvironment() {
    return this.stagingEnvironment;
  }
  setUserAgent({ userAgent: e }) {
    this.userAgent = e;
  }
  getUserAgent() {
    return this.userAgent;
  }
  setEntityAuthenticationToken({ token: e }) {
    this.entityAuthenticationToken = e;
  }
  getEntityAuthenticationToken() {
    return this.entityAuthenticationToken;
  }
  setApiKeys({ apiKey: e, apiSecret: r }) {
    this.apiKey = e, this.apiSecret = r;
  }
  getApiKeys() {
    return {
      apiKey: this.apiKey,
      apiSecret: this.apiSecret
    };
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  captureSentryException(e) {
  }
  getDistinctId() {
    return typeof localStorage < "u" ? localStorage.getItem("distinctId") || this.generateDistinctId() : this.generateDistinctId();
  }
  generateDistinctId() {
    const e = "sdk-" + Math.random().toString(36).substring(2, 12);
    return typeof localStorage < "u" && localStorage.setItem("distinctId", e), e;
  }
  getUrlInformation() {
    if (typeof window < "u")
      return {
        href: window.location.href,
        host: window.location.host,
        hostname: window.location.hostname,
        origin: window.location.origin,
        pathname: window.location.pathname
      };
  }
  getUserInfo() {
    return jC(this, void 0, void 0, function* () {
      try {
        let e;
        return typeof window > "u" ? e = (yield E9.default.get("https://ipinfo.io/json")).data : e = yield (yield fetch("https://ipinfo.io/json")).json(), e;
      } catch (e) {
        return console.error("Error fetching IP address:", e), null;
      }
    });
  }
}
var TY = Ia.default = FY;
const rr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Hc = "8.53.0", qr = globalThis;
function Fg(t, e, r) {
  const n = qr, A = n.__SENTRY__ = n.__SENTRY__ || {}, i = A[Hc] = A[Hc] || {};
  return i[t] || (i[t] = e());
}
const Za = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, MY = "Sentry Logger ", h5 = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Kh = {};
function Ja(t) {
  if (!("console" in qr))
    return t();
  const e = qr.console, r = {}, n = Object.keys(Kh);
  n.forEach((A) => {
    const i = Kh[A];
    r[A] = e[A], e[A] = i;
  });
  try {
    return t();
  } finally {
    n.forEach((A) => {
      e[A] = r[A];
    });
  }
}
function HY() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t
  };
  return Za ? h5.forEach((r) => {
    e[r] = (...n) => {
      t && Ja(() => {
        qr.console[r](`${MY}[${r}]:`, ...n);
      });
    };
  }) : h5.forEach((r) => {
    e[r] = () => {
    };
  }), e;
}
const ft = Fg("logger", HY), Yk = 50, Xc = "?", LC = /\(error: (.*)\)/, GC = /captureMessage|captureException/;
function Vk(...t) {
  const e = t.sort((r, n) => r[0] - n[0]).map((r) => r[1]);
  return (r, n = 0, A = 0) => {
    const i = [], o = r.split(`
`);
    for (let s = n; s < o.length; s++) {
      const a = o[s];
      if (a.length > 1024)
        continue;
      const c = LC.test(a) ? a.replace(LC, "$1") : a;
      if (!c.match(/\S*Error: /)) {
        for (const l of e) {
          const u = l(c);
          if (u) {
            i.push(u);
            break;
          }
        }
        if (i.length >= Yk + A)
          break;
      }
    }
    return QY(i.slice(A));
  };
}
function DY(t) {
  return Array.isArray(t) ? Vk(...t) : t;
}
function QY(t) {
  if (!t.length)
    return [];
  const e = Array.from(t);
  return /sentryWrapped/.test($1(e).function || "") && e.pop(), e.reverse(), GC.test($1(e).function || "") && (e.pop(), GC.test($1(e).function || "") && e.pop()), e.slice(0, Yk).map((r) => ({
    ...r,
    filename: r.filename || $1(e).filename,
    function: r.function || Xc
  }));
}
function $1(t) {
  return t[t.length - 1] || {};
}
const x9 = "<anonymous>";
function Ps(t) {
  try {
    return !t || typeof t != "function" ? x9 : t.name || x9;
  } catch {
    return x9;
  }
}
function RC(t) {
  const e = t.exception;
  if (e) {
    const r = [];
    try {
      return e.values.forEach((n) => {
        n.stacktrace.frames && r.push(...n.stacktrace.frames);
      }), r;
    } catch {
      return;
    }
  }
}
const fh = {}, zC = {};
function _a(t, e) {
  fh[t] = fh[t] || [], fh[t].push(e);
}
function $a(t, e) {
  if (!zC[t]) {
    zC[t] = !0;
    try {
      e();
    } catch (r) {
      Za && ft.error(`Error while instrumenting ${t}`, r);
    }
  }
}
function ji(t, e) {
  const r = t && fh[t];
  if (r)
    for (const n of r)
      try {
        n(e);
      } catch (A) {
        Za && ft.error(
          `Error while triggering instrumentation handler.
Type: ${t}
Name: ${Ps(n)}
Error:`,
          A
        );
      }
}
let I9 = null;
function Wk(t) {
  const e = "error";
  _a(e, t), $a(e, UY);
}
function UY() {
  I9 = qr.onerror, qr.onerror = function(t, e, r, n, A) {
    return ji("error", {
      column: n,
      error: A,
      line: r,
      msg: t,
      url: e
    }), I9 ? I9.apply(this, arguments) : !1;
  }, qr.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let S9 = null;
function Xk(t) {
  const e = "unhandledrejection";
  _a(e, t), $a(e, NY);
}
function NY() {
  S9 = qr.onunhandledrejection, qr.onunhandledrejection = function(t) {
    return ji("unhandledrejection", t), S9 ? S9.apply(this, arguments) : !0;
  }, qr.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
function sl() {
  return Rm(qr), qr;
}
function Rm(t) {
  const e = t.__SENTRY__ = t.__SENTRY__ || {};
  return e.version = e.version || Hc, e[Hc] = e[Hc] || {};
}
const Kk = Object.prototype.toString;
function zm(t) {
  switch (Kk.call(t)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return ks(t, Error);
  }
}
function bd(t, e) {
  return Kk.call(t) === `[object ${e}]`;
}
function Zk(t) {
  return bd(t, "ErrorEvent");
}
function YC(t) {
  return bd(t, "DOMError");
}
function jY(t) {
  return bd(t, "DOMException");
}
function ys(t) {
  return bd(t, "String");
}
function Ym(t) {
  return typeof t == "object" && t !== null && "__sentry_template_string__" in t && "__sentry_template_values__" in t;
}
function Vm(t) {
  return t === null || Ym(t) || typeof t != "object" && typeof t != "function";
}
function wu(t) {
  return bd(t, "Object");
}
function Tg(t) {
  return typeof Event < "u" && ks(t, Event);
}
function LY(t) {
  return typeof Element < "u" && ks(t, Element);
}
function GY(t) {
  return bd(t, "RegExp");
}
function Mg(t) {
  return !!(t && t.then && typeof t.then == "function");
}
function RY(t) {
  return wu(t) && "nativeEvent" in t && "preventDefault" in t && "stopPropagation" in t;
}
function ks(t, e) {
  try {
    return t instanceof e;
  } catch {
    return !1;
  }
}
function Jk(t) {
  return !!(typeof t == "object" && t !== null && (t.__isVue || t._isVue));
}
const nu = qr, zY = 80;
function Os(t, e = {}) {
  if (!t)
    return "<unknown>";
  try {
    let r = t;
    const n = 5, A = [];
    let i = 0, o = 0;
    const s = " > ", a = s.length;
    let c;
    const l = Array.isArray(e) ? e : e.keyAttrs, u = !Array.isArray(e) && e.maxStringLength || zY;
    for (; r && i++ < n && (c = YY(r, l), !(c === "html" || i > 1 && o + A.length * a + c.length >= u)); )
      A.push(c), o += c.length, r = r.parentNode;
    return A.reverse().join(s);
  } catch {
    return "<unknown>";
  }
}
function YY(t, e) {
  const r = t, n = [];
  if (!r || !r.tagName)
    return "";
  if (nu.HTMLElement && r instanceof HTMLElement && r.dataset) {
    if (r.dataset.sentryComponent)
      return r.dataset.sentryComponent;
    if (r.dataset.sentryElement)
      return r.dataset.sentryElement;
  }
  n.push(r.tagName.toLowerCase());
  const A = e && e.length ? e.filter((o) => r.getAttribute(o)).map((o) => [o, r.getAttribute(o)]) : null;
  if (A && A.length)
    A.forEach((o) => {
      n.push(`[${o[0]}="${o[1]}"]`);
    });
  else {
    r.id && n.push(`#${r.id}`);
    const o = r.className;
    if (o && ys(o)) {
      const s = o.split(/\s+/);
      for (const a of s)
        n.push(`.${a}`);
    }
  }
  const i = ["aria-label", "type", "name", "title", "alt"];
  for (const o of i) {
    const s = r.getAttribute(o);
    s && n.push(`[${o}="${s}"]`);
  }
  return n.join("");
}
function _k() {
  try {
    return nu.document.location.href;
  } catch {
    return "";
  }
}
function VY(t) {
  return nu.document && nu.document.querySelector ? nu.document.querySelector(t) : null;
}
function $k(t) {
  if (!nu.HTMLElement)
    return null;
  let e = t;
  const r = 5;
  for (let n = 0; n < r; n++) {
    if (!e)
      return null;
    if (e instanceof HTMLElement) {
      if (e.dataset.sentryComponent)
        return e.dataset.sentryComponent;
      if (e.dataset.sentryElement)
        return e.dataset.sentryElement;
    }
    e = e.parentNode;
  }
  return null;
}
function Au(t, e = 0) {
  return typeof t != "string" || e === 0 || t.length <= e ? t : `${t.slice(0, e)}...`;
}
function VC(t, e) {
  if (!Array.isArray(t))
    return "";
  const r = [];
  for (let n = 0; n < t.length; n++) {
    const A = t[n];
    try {
      Jk(A) ? r.push("[VueViewModel]") : r.push(String(A));
    } catch {
      r.push("[value cannot be serialized]");
    }
  }
  return r.join(e);
}
function WY(t, e, r = !1) {
  return ys(t) ? GY(e) ? e.test(t) : ys(e) ? r ? t === e : t.includes(e) : !1 : !1;
}
function Sa(t, e = [], r = !1) {
  return e.some((n) => WY(t, n, r));
}
function Ai(t, e, r) {
  if (!(e in t))
    return;
  const n = t[e], A = r(n);
  typeof A == "function" && eO(A, n);
  try {
    t[e] = A;
  } catch {
    Za && ft.log(`Failed to replace method "${e}" in object`, t);
  }
}
function Yi(t, e, r) {
  try {
    Object.defineProperty(t, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Za && ft.log(`Failed to add non-enumerable property "${e}" to object`, t);
  }
}
function eO(t, e) {
  try {
    const r = e.prototype || {};
    t.prototype = e.prototype = r, Yi(t, "__sentry_original__", e);
  } catch {
  }
}
function Wm(t) {
  return t.__sentry_original__;
}
function tO(t) {
  if (zm(t))
    return {
      message: t.message,
      name: t.name,
      stack: t.stack,
      ...XC(t)
    };
  if (Tg(t)) {
    const e = {
      type: t.type,
      target: WC(t.target),
      currentTarget: WC(t.currentTarget),
      ...XC(t)
    };
    return typeof CustomEvent < "u" && ks(t, CustomEvent) && (e.detail = t.detail), e;
  } else
    return t;
}
function WC(t) {
  try {
    return LY(t) ? Os(t) : Object.prototype.toString.call(t);
  } catch {
    return "<unknown>";
  }
}
function XC(t) {
  if (typeof t == "object" && t !== null) {
    const e = {};
    for (const r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    return e;
  } else
    return {};
}
function XY(t, e = 40) {
  const r = Object.keys(tO(t));
  r.sort();
  const n = r[0];
  if (!n)
    return "[object has no keys]";
  if (n.length >= e)
    return Au(n, e);
  for (let A = r.length; A > 0; A--) {
    const i = r.slice(0, A).join(", ");
    if (!(i.length > e))
      return A === r.length ? i : Au(i, e);
  }
  return "";
}
function _n(t) {
  return p5(t, /* @__PURE__ */ new Map());
}
function p5(t, e) {
  if (KY(t)) {
    const r = e.get(t);
    if (r !== void 0)
      return r;
    const n = {};
    e.set(t, n);
    for (const A of Object.getOwnPropertyNames(t))
      typeof t[A] < "u" && (n[A] = p5(t[A], e));
    return n;
  }
  if (Array.isArray(t)) {
    const r = e.get(t);
    if (r !== void 0)
      return r;
    const n = [];
    return e.set(t, n), t.forEach((A) => {
      n.push(p5(A, e));
    }), n;
  }
  return t;
}
function KY(t) {
  if (!wu(t))
    return !1;
  try {
    const e = Object.getPrototypeOf(t).constructor.name;
    return !e || e === "Object";
  } catch {
    return !0;
  }
}
const rO = 1e3;
function q1() {
  return Date.now() / rO;
}
function ZY() {
  const { performance: t } = qr;
  if (!t || !t.now)
    return q1;
  const e = Date.now() - t.now(), r = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (r + t.now()) / rO;
}
const KA = ZY(), ZA = (() => {
  const { performance: t } = qr;
  if (!t || !t.now)
    return;
  const e = 3600 * 1e3, r = t.now(), n = Date.now(), A = t.timeOrigin ? Math.abs(t.timeOrigin + r - n) : e, i = A < e, o = t.timing && t.timing.navigationStart, a = typeof o == "number" ? Math.abs(o + r - n) : e, c = a < e;
  return i || c ? A <= a ? t.timeOrigin : o : n;
})();
function Ci() {
  const t = qr, e = t.crypto || t.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (r = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (r() & 15) >> n / 4).toString(16)
    )
  );
}
function nO(t) {
  return t.exception && t.exception.values ? t.exception.values[0] : void 0;
}
function ca(t) {
  const { message: e, event_id: r } = t;
  if (e)
    return e;
  const n = nO(t);
  return n ? n.type && n.value ? `${n.type}: ${n.value}` : n.type || n.value || r || "<unknown>" : r || "<unknown>";
}
function g5(t, e, r) {
  const n = t.exception = t.exception || {}, A = n.values = n.values || [], i = A[0] = A[0] || {};
  i.value || (i.value = e || ""), i.type || (i.type = "Error");
}
function bu(t, e) {
  const r = nO(t);
  if (!r)
    return;
  const n = { type: "generic", handled: !0 }, A = r.mechanism;
  if (r.mechanism = { ...n, ...A, ...e }, e && "data" in e) {
    const i = { ...A && A.data, ...e.data };
    r.mechanism.data = i;
  }
}
function KC(t) {
  if (JY(t))
    return !0;
  try {
    Yi(t, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function JY(t) {
  try {
    return t.__sentry_captured__;
  } catch {
  }
}
var ds;
(function(t) {
  t[t.PENDING = 0] = "PENDING";
  const r = 1;
  t[t.RESOLVED = r] = "RESOLVED";
  const n = 2;
  t[t.REJECTED = n] = "REJECTED";
})(ds || (ds = {}));
function Fs(t) {
  return new Mi((e) => {
    e(t);
  });
}
function Zh(t) {
  return new Mi((e, r) => {
    r(t);
  });
}
class Mi {
  constructor(e) {
    Mi.prototype.__init.call(this), Mi.prototype.__init2.call(this), Mi.prototype.__init3.call(this), Mi.prototype.__init4.call(this), this._state = ds.PENDING, this._handlers = [];
    try {
      e(this._resolve, this._reject);
    } catch (r) {
      this._reject(r);
    }
  }
  /** JSDoc */
  then(e, r) {
    return new Mi((n, A) => {
      this._handlers.push([
        !1,
        (i) => {
          if (!e)
            n(i);
          else
            try {
              n(e(i));
            } catch (o) {
              A(o);
            }
        },
        (i) => {
          if (!r)
            A(i);
          else
            try {
              n(r(i));
            } catch (o) {
              A(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(e) {
    return this.then((r) => r, e);
  }
  /** JSDoc */
  finally(e) {
    return new Mi((r, n) => {
      let A, i;
      return this.then(
        (o) => {
          i = !1, A = o, e && e();
        },
        (o) => {
          i = !0, A = o, e && e();
        }
      ).then(() => {
        if (i) {
          n(A);
          return;
        }
        r(A);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (e) => {
      this._setResult(ds.RESOLVED, e);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (e) => {
      this._setResult(ds.REJECTED, e);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (e, r) => {
      if (this._state === ds.PENDING) {
        if (Mg(r)) {
          r.then(this._resolve, this._reject);
          return;
        }
        this._state = e, this._value = r, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === ds.PENDING)
        return;
      const e = this._handlers.slice();
      this._handlers = [], e.forEach((r) => {
        r[0] || (this._state === ds.RESOLVED && r[1](this._value), this._state === ds.REJECTED && r[2](this._value), r[0] = !0);
      });
    };
  }
}
function _Y(t) {
  const e = KA(), r = {
    sid: Ci(),
    init: !0,
    timestamp: e,
    started: e,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => eV(r)
  };
  return Bu(r, t), r;
}
function Bu(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || KA(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : Ci()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const r = t.timestamp - t.started;
    t.duration = r >= 0 ? r : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
function $Y(t, e) {
  let r = {};
  t.status === "ok" && (r = { status: "exited" }), Bu(t, r);
}
function eV(t) {
  return _n({
    sid: `${t.sid}`,
    init: t.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(t.started * 1e3).toISOString(),
    timestamp: new Date(t.timestamp * 1e3).toISOString(),
    status: t.status,
    errors: t.errors,
    did: typeof t.did == "number" || typeof t.did == "string" ? `${t.did}` : void 0,
    duration: t.duration,
    abnormal_mechanism: t.abnormal_mechanism,
    attrs: {
      release: t.release,
      environment: t.environment,
      ip_address: t.ipAddress,
      user_agent: t.userAgent
    }
  });
}
function Qa() {
  return Ci();
}
function Ua() {
  return Ci().substring(16);
}
function Hg(t, e, r = 2) {
  if (!e || typeof e != "object" || r <= 0)
    return e;
  if (t && e && Object.keys(e).length === 0)
    return t;
  const n = { ...t };
  for (const A in e)
    Object.prototype.hasOwnProperty.call(e, A) && (n[A] = Hg(n[A], e[A], r - 1));
  return n;
}
const m5 = "_sentrySpan";
function m2(t, e) {
  e ? Yi(t, m5, e) : delete t[m5];
}
function Jh(t) {
  return t[m5];
}
const tV = 100;
class Xm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  // eslint-disable-next-line deprecation/deprecation
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: Qa(),
      spanId: Ua()
    };
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new Xm();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, this._contexts.flags && (e._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, m2(e, Jh(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Bu(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, r) {
    return this._tags = { ...this._tags, [e]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, r) {
    return this._extra = { ...this._extra, [e]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, r) {
    return r === null ? delete this._contexts[e] : this._contexts[e] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const r = typeof e == "function" ? e(this) : e, [n, A] = r instanceof Kc ? (
      // eslint-disable-next-line deprecation/deprecation
      [r.getScopeData(), r.getRequestSession()]
    ) : wu(r) ? [e, e.requestSession] : [], { tags: i, extra: o, user: s, contexts: a, level: c, fingerprint: l = [], propagationContext: u } = n || {};
    return this._tags = { ...this._tags, ...i }, this._extra = { ...this._extra, ...o }, this._contexts = { ...this._contexts, ...a }, s && Object.keys(s).length && (this._user = s), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), A && (this._requestSession = A), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, m2(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Qa() }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, r) {
    const n = typeof r == "number" ? r : tV;
    if (n <= 0)
      return this;
    const A = {
      timestamp: q1(),
      ...e
    };
    return this._breadcrumbs.push(A), this._breadcrumbs.length > n && (this._breadcrumbs = this._breadcrumbs.slice(-n), this._client && this._client.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Jh(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = Hg(this._sdkProcessingMetadata, e, 2), this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = {
      // eslint-disable-next-line deprecation/deprecation
      spanId: Ua(),
      ...e
    }, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, r) {
    const n = r && r.event_id ? r.event_id : Ci();
    if (!this._client)
      return ft.warn("No client configured on scope - will not capture exception!"), n;
    const A = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: A,
        ...r,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, r, n) {
    const A = n && n.event_id ? n.event_id : Ci();
    if (!this._client)
      return ft.warn("No client configured on scope - will not capture message!"), A;
    const i = new Error(e);
    return this._client.captureMessage(
      e,
      r,
      {
        originalException: e,
        syntheticException: i,
        ...n,
        event_id: A
      },
      this
    ), A;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, r) {
    const n = r && r.event_id ? r.event_id : Ci();
    return this._client ? (this._client.captureEvent(e, { ...r, event_id: n }, this), n) : (ft.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const Kc = Xm;
function rV() {
  return Fg("defaultCurrentScope", () => new Kc());
}
function nV() {
  return Fg("defaultIsolationScope", () => new Kc());
}
class AV {
  constructor(e, r) {
    let n;
    e ? n = e : n = new Kc();
    let A;
    r ? A = r : A = new Kc(), this._stack = [{ scope: n }], this._isolationScope = A;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const r = this._pushScope();
    let n;
    try {
      n = e(r);
    } catch (A) {
      throw this._popScope(), A;
    }
    return Mg(n) ? n.then(
      (A) => (this._popScope(), A),
      (A) => {
        throw this._popScope(), A;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Eu() {
  const t = sl(), e = Rm(t);
  return e.stack = e.stack || new AV(rV(), nV());
}
function iV(t) {
  return Eu().withScope(t);
}
function oV(t, e) {
  const r = Eu();
  return r.withScope(() => (r.getStackTop().scope = t, e(t)));
}
function ZC(t) {
  return Eu().withScope(() => t(Eu().getIsolationScope()));
}
function sV() {
  return {
    withIsolationScope: ZC,
    withScope: iV,
    withSetScope: oV,
    withSetIsolationScope: (t, e) => ZC(e),
    getCurrentScope: () => Eu().getScope(),
    getIsolationScope: () => Eu().getIsolationScope()
  };
}
function Bd(t) {
  const e = Rm(t);
  return e.acs ? e.acs : sV();
}
function $r() {
  const t = sl();
  return Bd(t).getCurrentScope();
}
function qo() {
  const t = sl();
  return Bd(t).getIsolationScope();
}
function aV() {
  return Fg("globalScope", () => new Kc());
}
function Km(...t) {
  const e = sl(), r = Bd(e);
  if (t.length === 2) {
    const [n, A] = t;
    return n ? r.withSetScope(n, A) : r.withScope(A);
  }
  return r.withScope(t[0]);
}
function mr() {
  return $r().getClient();
}
function cV(t) {
  const e = t.getPropagationContext(), { traceId: r, spanId: n, parentSpanId: A } = e;
  return _n({
    trace_id: r,
    span_id: n,
    parent_span_id: A
  });
}
const lV = "_sentryMetrics";
function v5(t) {
  const e = t[lV];
  if (!e)
    return;
  const r = {};
  for (const [, [n, A]] of e)
    (r[n] || (r[n] = [])).push(_n(A));
  return r;
}
const No = "sentry.source", AO = "sentry.sample_rate", Zc = "sentry.op", sA = "sentry.origin", q5 = "sentry.idle_span_finish_reason", Dg = "sentry.measurement_unit", Qg = "sentry.measurement_value", JC = "sentry.custom_span_name", uV = "sentry.profile_id", Zm = "sentry.exclusive_time", dV = 0, iO = 1, iA = 2;
function fV(t) {
  if (t < 400 && t >= 100)
    return { code: iO };
  if (t >= 400 && t < 500)
    switch (t) {
      case 401:
        return { code: iA, message: "unauthenticated" };
      case 403:
        return { code: iA, message: "permission_denied" };
      case 404:
        return { code: iA, message: "not_found" };
      case 409:
        return { code: iA, message: "already_exists" };
      case 413:
        return { code: iA, message: "failed_precondition" };
      case 429:
        return { code: iA, message: "resource_exhausted" };
      case 499:
        return { code: iA, message: "cancelled" };
      default:
        return { code: iA, message: "invalid_argument" };
    }
  if (t >= 500 && t < 600)
    switch (t) {
      case 501:
        return { code: iA, message: "unimplemented" };
      case 503:
        return { code: iA, message: "unavailable" };
      case 504:
        return { code: iA, message: "deadline_exceeded" };
      default:
        return { code: iA, message: "internal_error" };
    }
  return { code: iA, message: "unknown_error" };
}
function oO(t, e) {
  t.setAttribute("http.response.status_code", e);
  const r = fV(e);
  r.message !== "unknown_error" && t.setStatus(r);
}
const Jm = "sentry-", hV = /^sentry-/, pV = 8192;
function sO(t) {
  const e = mV(t);
  if (!e)
    return;
  const r = Object.entries(e).reduce((n, [A, i]) => {
    if (A.match(hV)) {
      const o = A.slice(Jm.length);
      n[o] = i;
    }
    return n;
  }, {});
  if (Object.keys(r).length > 0)
    return r;
}
function gV(t) {
  if (!t)
    return;
  const e = Object.entries(t).reduce(
    (r, [n, A]) => (A && (r[`${Jm}${n}`] = A), r),
    {}
  );
  return vV(e);
}
function mV(t) {
  if (!(!t || !ys(t) && !Array.isArray(t)))
    return Array.isArray(t) ? t.reduce((e, r) => {
      const n = _C(r);
      return Object.entries(n).forEach(([A, i]) => {
        e[A] = i;
      }), e;
    }, {}) : _C(t);
}
function _C(t) {
  return t.split(",").map((e) => e.split("=").map((r) => decodeURIComponent(r.trim()))).reduce((e, [r, n]) => (r && n && (e[r] = n), e), {});
}
function vV(t) {
  if (Object.keys(t).length !== 0)
    return Object.entries(t).reduce((e, [r, n], A) => {
      const i = `${encodeURIComponent(r)}=${encodeURIComponent(n)}`, o = A === 0 ? i : `${e},${i}`;
      return o.length > pV ? (Za && ft.warn(
        `Not adding key: ${r} with val: ${n} to baggage header due to exceeding baggage size limits.`
      ), e) : o;
    }, "");
}
const aO = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function qV(t) {
  if (!t)
    return;
  const e = t.match(aO);
  if (!e)
    return;
  let r;
  return e[3] === "1" ? r = !0 : e[3] === "0" && (r = !1), {
    traceId: e[1],
    parentSampled: r,
    parentSpanId: e[2]
  };
}
function yV(t, e) {
  const r = qV(t), n = sO(e);
  if (!r || !r.traceId)
    return { traceId: Qa(), spanId: Ua() };
  const { traceId: A, parentSpanId: i, parentSampled: o } = r, s = Ua();
  return {
    traceId: A,
    parentSpanId: i,
    spanId: s,
    sampled: o,
    dsc: n || {}
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
  };
}
function cO(t = Qa(), e = Ua(), r) {
  let n = "";
  return r !== void 0 && (n = r ? "-1" : "-0"), `${t}-${e}${n}`;
}
const lO = 0, uO = 1;
let $C = !1;
function CV(t) {
  const { spanId: e, traceId: r } = t.spanContext(), { data: n, op: A, parent_span_id: i, status: o, origin: s } = kr(t);
  return _n({
    parent_span_id: i,
    span_id: e,
    trace_id: r,
    data: n,
    op: A,
    status: o,
    origin: s
  });
}
function wV(t) {
  const { spanId: e, traceId: r, isRemote: n } = t.spanContext(), A = n ? e : kr(t).parent_span_id, i = n ? Ua() : e;
  return _n({
    parent_span_id: A,
    span_id: i,
    trace_id: r
  });
}
function bV(t) {
  const { traceId: e, spanId: r } = t.spanContext(), n = al(t);
  return cO(e, r, n);
}
function Dc(t) {
  return typeof t == "number" ? ew(t) : Array.isArray(t) ? t[0] + t[1] / 1e9 : t instanceof Date ? ew(t.getTime()) : KA();
}
function ew(t) {
  return t > 9999999999 ? t / 1e3 : t;
}
function kr(t) {
  if (EV(t))
    return t.getSpanJSON();
  try {
    const { spanId: e, traceId: r } = t.spanContext();
    if (BV(t)) {
      const { attributes: n, startTime: A, name: i, endTime: o, parentSpanId: s, status: a } = t;
      return _n({
        span_id: e,
        trace_id: r,
        data: n,
        description: i,
        parent_span_id: s,
        start_timestamp: Dc(A),
        // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
        timestamp: Dc(o) || void 0,
        status: dO(a),
        op: n[Zc],
        origin: n[sA],
        _metrics_summary: v5(t)
      });
    }
    return {
      span_id: e,
      trace_id: r
    };
  } catch {
    return {};
  }
}
function BV(t) {
  const e = t;
  return !!e.attributes && !!e.startTime && !!e.name && !!e.endTime && !!e.status;
}
function EV(t) {
  return typeof t.getSpanJSON == "function";
}
function al(t) {
  const { traceFlags: e } = t.spanContext();
  return e === uO;
}
function dO(t) {
  if (!(!t || t.code === dV))
    return t.code === iO ? "ok" : t.message || "unknown_error";
}
const Qc = "_sentryChildSpans", y5 = "_sentryRootSpan";
function fO(t, e) {
  const r = t[y5] || t;
  Yi(e, y5, r), t[Qc] ? t[Qc].add(e) : Yi(t, Qc, /* @__PURE__ */ new Set([e]));
}
function xV(t, e) {
  t[Qc] && t[Qc].delete(e);
}
function hh(t) {
  const e = /* @__PURE__ */ new Set();
  function r(n) {
    if (!e.has(n) && al(n)) {
      e.add(n);
      const A = n[Qc] ? Array.from(n[Qc]) : [];
      for (const i of A)
        r(i);
    }
  }
  return r(t), Array.from(e);
}
function wA(t) {
  return t[y5] || t;
}
function aA() {
  const t = sl(), e = Bd(t);
  return e.getActiveSpan ? e.getActiveSpan() : Jh($r());
}
function hO() {
  $C || (Ja(() => {
    console.warn(
      "[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly."
    );
  }), $C = !0);
}
let tw = !1;
function IV() {
  tw || (tw = !0, Wk(C5), Xk(C5));
}
function C5() {
  const t = aA(), e = t && wA(t);
  if (e) {
    const r = "internal_error";
    rr && ft.log(`[Tracing] Root span: ${r} -> Global error occurred`), e.setStatus({ code: iA, message: r });
  }
}
C5.tag = "sentry_tracingErrorCallback";
const pO = "_sentryScope", gO = "_sentryIsolationScope";
function SV(t, e, r) {
  t && (Yi(t, gO, r), Yi(t, pO, e));
}
function rw(t) {
  return {
    scope: t[pO],
    isolationScope: t[gO]
  };
}
function Na(t) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const e = mr(), r = t || e && e.getOptions();
  return !!r && (r.enableTracing || "tracesSampleRate" in r || "tracesSampler" in r);
}
class Ed {
  constructor(e = {}) {
    this._traceId = e.traceId || Qa(), this._spanId = e.spanId || Ua();
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: lO
    };
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  end(e) {
  }
  /** @inheritdoc */
  setAttribute(e, r) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(e) {
    return this;
  }
  /** @inheritdoc */
  setStatus(e) {
    return this;
  }
  /** @inheritdoc */
  updateName(e) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(e, r, n) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(e, r) {
  }
}
const _m = "production", mO = "_frozenDsc";
function nw(t, e) {
  Yi(t, mO, e);
}
function vO(t, e) {
  const r = e.getOptions(), { publicKey: n } = e.getDsn() || {}, A = _n({
    environment: r.environment || _m,
    release: r.release,
    public_key: n,
    trace_id: t
  });
  return e.emit("createDsc", A), A;
}
function qO(t, e) {
  const r = e.getPropagationContext();
  return r.dsc || vO(r.traceId, t);
}
function cl(t) {
  const e = mr();
  if (!e)
    return {};
  const r = wA(t), n = r[mO];
  if (n)
    return n;
  const A = r.spanContext().traceState, i = A && A.get("sentry.dsc"), o = i && sO(i);
  if (o)
    return o;
  const s = vO(t.spanContext().traceId, e), a = kr(r), c = a.data || {}, l = c[AO];
  l != null && (s.sample_rate = `${l}`);
  const u = c[No], f = a.description;
  return u !== "url" && f && (s.transaction = f), Na() && (s.sampled = String(al(r))), e.emit("createDsc", s, r), s;
}
function PV(t) {
  if (!rr) return;
  const { description: e = "< unknown name >", op: r = "< unknown op >", parent_span_id: n } = kr(t), { spanId: A } = t.spanContext(), i = al(t), o = wA(t), s = o === t, a = `[Tracing] Starting ${i ? "sampled" : "unsampled"} ${s ? "root " : ""}span`, c = [`op: ${r}`, `name: ${e}`, `ID: ${A}`];
  if (n && c.push(`parent ID: ${n}`), !s) {
    const { op: l, description: u } = kr(o);
    c.push(`root ID: ${o.spanContext().spanId}`), l && c.push(`root op: ${l}`), u && c.push(`root description: ${u}`);
  }
  ft.log(`${a}
  ${c.join(`
  `)}`);
}
function kV(t) {
  if (!rr) return;
  const { description: e = "< unknown name >", op: r = "< unknown op >" } = kr(t), { spanId: n } = t.spanContext(), i = wA(t) === t, o = `[Tracing] Finishing "${r}" ${i ? "root " : ""}span "${e}" with ID ${n}`;
  ft.log(o);
}
function _h(t) {
  if (typeof t == "boolean")
    return Number(t);
  const e = typeof t == "string" ? parseFloat(t) : t;
  if (typeof e != "number" || isNaN(e) || e < 0 || e > 1) {
    rr && ft.warn(
      `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        t
      )} of type ${JSON.stringify(typeof t)}.`
    );
    return;
  }
  return e;
}
function OV(t, e) {
  if (!Na(t))
    return [!1];
  const r = qo().getScopeData().sdkProcessingMetadata.normalizedRequest, n = {
    ...e,
    normalizedRequest: e.normalizedRequest || r
  };
  let A;
  typeof t.tracesSampler == "function" ? A = t.tracesSampler(n) : n.parentSampled !== void 0 ? A = n.parentSampled : typeof t.tracesSampleRate < "u" ? A = t.tracesSampleRate : A = 1;
  const i = _h(A);
  return i === void 0 ? (rr && ft.warn("[Tracing] Discarding transaction because of invalid sample rate."), [!1]) : i ? Math.random() < i ? [!0, i] : (rr && ft.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      A
    )})`
  ), [!1, i]) : (rr && ft.log(
    `[Tracing] Discarding transaction because ${typeof t.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
  ), [!1, i]);
}
const FV = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function TV(t) {
  return t === "http" || t === "https";
}
function y1(t, e = !1) {
  const { host: r, path: n, pass: A, port: i, projectId: o, protocol: s, publicKey: a } = t;
  return `${s}://${a}${e && A ? `:${A}` : ""}@${r}${i ? `:${i}` : ""}/${n && `${n}/`}${o}`;
}
function MV(t) {
  const e = FV.exec(t);
  if (!e) {
    Ja(() => {
      console.error(`Invalid Sentry Dsn: ${t}`);
    });
    return;
  }
  const [r, n, A = "", i = "", o = "", s = ""] = e.slice(1);
  let a = "", c = s;
  const l = c.split("/");
  if (l.length > 1 && (a = l.slice(0, -1).join("/"), c = l.pop()), c) {
    const u = c.match(/^\d+/);
    u && (c = u[0]);
  }
  return yO({ host: i, pass: A, path: a, projectId: c, port: o, protocol: r, publicKey: n });
}
function yO(t) {
  return {
    protocol: t.protocol,
    publicKey: t.publicKey || "",
    pass: t.pass || "",
    host: t.host,
    port: t.port || "",
    path: t.path || "",
    projectId: t.projectId
  };
}
function HV(t) {
  if (!Za)
    return !0;
  const { port: e, projectId: r, protocol: n } = t;
  return ["protocol", "publicKey", "host", "projectId"].find((o) => t[o] ? !1 : (ft.error(`Invalid Sentry Dsn: ${o} missing`), !0)) ? !1 : r.match(/^\d+$/) ? TV(n) ? e && isNaN(parseInt(e, 10)) ? (ft.error(`Invalid Sentry Dsn: Invalid port ${e}`), !1) : !0 : (ft.error(`Invalid Sentry Dsn: Invalid protocol ${n}`), !1) : (ft.error(`Invalid Sentry Dsn: Invalid projectId ${r}`), !1);
}
function DV(t) {
  const e = typeof t == "string" ? MV(t) : yO(t);
  if (!(!e || !HV(e)))
    return e;
}
function QV() {
  const t = typeof WeakSet == "function", e = t ? /* @__PURE__ */ new WeakSet() : [];
  function r(A) {
    if (t)
      return e.has(A) ? !0 : (e.add(A), !1);
    for (let i = 0; i < e.length; i++)
      if (e[i] === A)
        return !0;
    return e.push(A), !1;
  }
  function n(A) {
    if (t)
      e.delete(A);
    else
      for (let i = 0; i < e.length; i++)
        if (e[i] === A) {
          e.splice(i, 1);
          break;
        }
  }
  return [r, n];
}
function no(t, e = 100, r = 1 / 0) {
  try {
    return w5("", t, e, r);
  } catch (n) {
    return { ERROR: `**non-serializable** (${n})` };
  }
}
function CO(t, e = 3, r = 100 * 1024) {
  const n = no(t, e);
  return LV(n) > r ? CO(t, e - 1, r) : n;
}
function w5(t, e, r = 1 / 0, n = 1 / 0, A = QV()) {
  const [i, o] = A;
  if (e == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof e) || typeof e == "number" && Number.isFinite(e))
    return e;
  const s = UV(t, e);
  if (!s.startsWith("[object "))
    return s;
  if (e.__sentry_skip_normalization__)
    return e;
  const a = typeof e.__sentry_override_normalization_depth__ == "number" ? e.__sentry_override_normalization_depth__ : r;
  if (a === 0)
    return s.replace("object ", "");
  if (i(e))
    return "[Circular ~]";
  const c = e;
  if (c && typeof c.toJSON == "function")
    try {
      const d = c.toJSON();
      return w5("", d, a - 1, n, A);
    } catch {
    }
  const l = Array.isArray(e) ? [] : {};
  let u = 0;
  const f = tO(e);
  for (const d in f) {
    if (!Object.prototype.hasOwnProperty.call(f, d))
      continue;
    if (u >= n) {
      l[d] = "[MaxProperties ~]";
      break;
    }
    const g = f[d];
    l[d] = w5(d, g, a - 1, n, A), u++;
  }
  return o(e), l;
}
function UV(t, e) {
  try {
    if (t === "domain" && e && typeof e == "object" && e._events)
      return "[Domain]";
    if (t === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && e === global)
      return "[Global]";
    if (typeof window < "u" && e === window)
      return "[Window]";
    if (typeof document < "u" && e === document)
      return "[Document]";
    if (Jk(e))
      return "[VueViewModel]";
    if (RY(e))
      return "[SyntheticEvent]";
    if (typeof e == "number" && !Number.isFinite(e))
      return `[${e}]`;
    if (typeof e == "function")
      return `[Function: ${Ps(e)}]`;
    if (typeof e == "symbol")
      return `[${String(e)}]`;
    if (typeof e == "bigint")
      return `[BigInt: ${String(e)}]`;
    const r = NV(e);
    return /^HTML(\w*)Element$/.test(r) ? `[HTMLElement: ${r}]` : `[object ${r}]`;
  } catch (r) {
    return `**non-serializable** (${r})`;
  }
}
function NV(t) {
  const e = Object.getPrototypeOf(t);
  return e ? e.constructor.name : "null prototype";
}
function jV(t) {
  return ~-encodeURI(t).split(/%..|./).length;
}
function LV(t) {
  return jV(JSON.stringify(t));
}
function ll(t, e = []) {
  return [t, e];
}
function GV(t, e) {
  const [r, n] = t;
  return [r, [...n, e]];
}
function Aw(t, e) {
  const r = t[1];
  for (const n of r) {
    const A = n[0].type;
    if (e(n, A))
      return !0;
  }
  return !1;
}
function b5(t) {
  return qr.__SENTRY__ && qr.__SENTRY__.encodePolyfill ? qr.__SENTRY__.encodePolyfill(t) : new TextEncoder().encode(t);
}
function RV(t) {
  const [e, r] = t;
  let n = JSON.stringify(e);
  function A(i) {
    typeof n == "string" ? n = typeof i == "string" ? n + i : [b5(n), i] : n.push(typeof i == "string" ? b5(i) : i);
  }
  for (const i of r) {
    const [o, s] = i;
    if (A(`
${JSON.stringify(o)}
`), typeof s == "string" || s instanceof Uint8Array)
      A(s);
    else {
      let a;
      try {
        a = JSON.stringify(s);
      } catch {
        a = JSON.stringify(no(s));
      }
      A(a);
    }
  }
  return typeof n == "string" ? n : zV(n);
}
function zV(t) {
  const e = t.reduce((A, i) => A + i.length, 0), r = new Uint8Array(e);
  let n = 0;
  for (const A of t)
    r.set(A, n), n += A.length;
  return r;
}
function YV(t) {
  return [{
    type: "span"
  }, t];
}
function VV(t) {
  const e = typeof t.data == "string" ? b5(t.data) : t.data;
  return [
    _n({
      type: "attachment",
      length: e.length,
      filename: t.filename,
      content_type: t.contentType,
      attachment_type: t.attachmentType
    }),
    e
  ];
}
const WV = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  statsd: "metric_bucket",
  raw_security: "security"
};
function iw(t) {
  return WV[t];
}
function $m(t) {
  if (!t || !t.sdk)
    return;
  const { name: e, version: r } = t.sdk;
  return { name: e, version: r };
}
function wO(t, e, r, n) {
  const A = t.sdkProcessingMetadata && t.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...e && { sdk: e },
    ...!!r && n && { dsn: y1(n) },
    ...A && {
      trace: _n({ ...A })
    }
  };
}
function XV(t, e) {
  return e && (t.sdk = t.sdk || {}, t.sdk.name = t.sdk.name || e.name, t.sdk.version = t.sdk.version || e.version, t.sdk.integrations = [...t.sdk.integrations || [], ...e.integrations || []], t.sdk.packages = [...t.sdk.packages || [], ...e.packages || []]), t;
}
function KV(t, e, r, n) {
  const A = $m(r), i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...A && { sdk: A },
    ...!!n && e && { dsn: y1(e) }
  }, o = "aggregates" in t ? [{ type: "sessions" }, t] : [{ type: "session" }, t.toJSON()];
  return ll(i, [o]);
}
function ZV(t, e, r, n) {
  const A = $m(r), i = t.type && t.type !== "replay_event" ? t.type : "event";
  XV(t, r && r.sdk);
  const o = wO(t, A, n, e);
  return delete t.sdkProcessingMetadata, ll(o, [[{ type: i }, t]]);
}
function JV(t, e) {
  function r(l) {
    return !!l.trace_id && !!l.public_key;
  }
  const n = cl(t[0]), A = e && e.getDsn(), i = e && e.getOptions().tunnel, o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...r(n) && { trace: n },
    ...!!i && A && { dsn: y1(A) }
  }, s = e && e.getOptions().beforeSendSpan, a = s ? (l) => {
    const u = s(kr(l));
    return u || hO(), u;
  } : (l) => kr(l), c = [];
  for (const l of t) {
    const u = a(l);
    u && c.push(YV(u));
  }
  return ll(o, c);
}
function _V(t, e, r, n = aA()) {
  const A = n && wA(n);
  A && (rr && ft.log(`[Measurement] Setting measurement on root span: ${t} = ${e} ${r}`), A.addEvent(t, {
    [Qg]: e,
    [Dg]: r
  }));
}
function ow(t) {
  if (!t || t.length === 0)
    return;
  const e = {};
  return t.forEach((r) => {
    const n = r.attributes || {}, A = n[Dg], i = n[Qg];
    typeof A == "string" && typeof i == "number" && (e[r.name] = { value: i, unit: A });
  }), e;
}
const sw = 1e3;
class ev {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(e = {}) {
    this._traceId = e.traceId || Qa(), this._spanId = e.spanId || Ua(), this._startTime = e.startTimestamp || KA(), this._attributes = {}, this.setAttributes({
      [sA]: "manual",
      [Zc]: e.op,
      ...e.attributes
    }), this._name = e.name, e.parentSpanId && (this._parentSpanId = e.parentSpanId), "sampled" in e && (this._sampled = e.sampled), e.endTimestamp && (this._endTime = e.endTimestamp), this._events = [], this._isStandaloneSpan = e.isStandalone, this._endTime && this._onSpanEnded();
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(e, r) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: e, _traceId: r, _sampled: n } = this;
    return {
      spanId: e,
      traceId: r,
      traceFlags: n ? uO : lO
    };
  }
  /** @inheritdoc */
  setAttribute(e, r) {
    return r === void 0 ? delete this._attributes[e] : this._attributes[e] = r, this;
  }
  /** @inheritdoc */
  setAttributes(e) {
    return Object.keys(e).forEach((r) => this.setAttribute(r, e[r])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(e) {
    this._startTime = Dc(e);
  }
  /**
   * @inheritDoc
   */
  setStatus(e) {
    return this._status = e, this;
  }
  /**
   * @inheritDoc
   */
  updateName(e) {
    return this._name = e, this.setAttribute(No, "custom"), this;
  }
  /** @inheritdoc */
  end(e) {
    this._endTime || (this._endTime = Dc(e), kV(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return _n({
      data: this._attributes,
      description: this._name,
      op: this._attributes[Zc],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: dO(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[sA],
      _metrics_summary: v5(this),
      profile_id: this._attributes[uV],
      exclusive_time: this._attributes[Zm],
      measurements: ow(this._events),
      is_segment: this._isStandaloneSpan && wA(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? wA(this).spanContext().spanId : void 0
    });
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(e, r, n) {
    rr && ft.log("[Tracing] Adding an event to span:", e);
    const A = aw(r) ? r : n || KA(), i = aw(r) ? {} : r || {}, o = {
      name: e,
      time: Dc(A),
      attributes: i
    };
    return this._events.push(o), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const e = mr();
    if (e && e.emit("spanEnd", this), !(this._isStandaloneSpan || this === wA(this)))
      return;
    if (this._isStandaloneSpan) {
      this._sampled ? eW(JV([this], e)) : (rr && ft.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled."), e && e.recordDroppedEvent("sample_rate", "span"));
      return;
    }
    const n = this._convertSpanToTransaction();
    n && (rw(this).scope || $r()).captureEvent(n);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    if (!cw(kr(this)))
      return;
    this._name || (rr && ft.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>");
    const { scope: e, isolationScope: r } = rw(this), A = (e || $r()).getClient() || mr();
    if (this._sampled !== !0) {
      rr && ft.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled."), A && A.recordDroppedEvent("sample_rate", "transaction");
      return;
    }
    const o = hh(this).filter((u) => u !== this && !$V(u)).map((u) => kr(u)).filter(cw), s = this._attributes[No];
    delete this._attributes[JC], o.forEach((u) => {
      u.data && delete u.data[JC];
    });
    const a = {
      contexts: {
        trace: CV(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        o.length > sw ? o.sort((u, f) => u.start_timestamp - f.start_timestamp).slice(0, sw) : o
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope: e,
        capturedSpanIsolationScope: r,
        ..._n({
          dynamicSamplingContext: cl(this)
        })
      },
      _metrics_summary: v5(this),
      ...s && {
        transaction_info: {
          source: s
        }
      }
    }, c = ow(this._events);
    return c && Object.keys(c).length && (rr && ft.log(
      "[Measurements] Adding measurements to transaction event",
      JSON.stringify(c, void 0, 2)
    ), a.measurements = c), a;
  }
}
function aw(t) {
  return t && typeof t == "number" || t instanceof Date || Array.isArray(t);
}
function cw(t) {
  return !!t.start_timestamp && !!t.timestamp && !!t.span_id && !!t.trace_id;
}
function $V(t) {
  return t instanceof ev && t.isStandaloneSpan();
}
function eW(t) {
  const e = mr();
  if (!e)
    return;
  const r = t[1];
  if (!r || r.length === 0) {
    e.recordDroppedEvent("before_send", "span");
    return;
  }
  e.sendEnvelope(t);
}
const bO = "__SENTRY_SUPPRESS_TRACING__";
function C1(t) {
  const e = EO();
  if (e.startInactiveSpan)
    return e.startInactiveSpan(t);
  const r = rW(t), { forceTransaction: n, parentSpan: A } = t;
  return (t.scope ? (o) => Km(t.scope, o) : A !== void 0 ? (o) => BO(A, o) : (o) => o())(() => {
    const o = $r(), s = AW(o);
    return t.onlyIfParent && !s ? new Ed() : tW({
      parentSpan: s,
      spanArguments: r,
      forceTransaction: n,
      scope: o
    });
  });
}
function BO(t, e) {
  const r = EO();
  return r.withActiveSpan ? r.withActiveSpan(t, e) : Km((n) => (m2(n, t || void 0), e(n)));
}
function tW({
  parentSpan: t,
  spanArguments: e,
  forceTransaction: r,
  scope: n
}) {
  if (!Na())
    return new Ed();
  const A = qo();
  let i;
  if (t && !r)
    i = nW(t, n, e), fO(t, i);
  else if (t) {
    const o = cl(t), { traceId: s, spanId: a } = t.spanContext(), c = al(t);
    i = lw(
      {
        traceId: s,
        parentSpanId: a,
        ...e
      },
      n,
      c
    ), nw(i, o);
  } else {
    const {
      traceId: o,
      dsc: s,
      parentSpanId: a,
      sampled: c
    } = {
      ...A.getPropagationContext(),
      ...n.getPropagationContext()
    };
    i = lw(
      {
        traceId: o,
        parentSpanId: a,
        ...e
      },
      n,
      c
    ), s && nw(i, s);
  }
  return PV(i), SV(i, n, A), i;
}
function rW(t) {
  const r = {
    isStandalone: (t.experimental || {}).standalone,
    ...t
  };
  if (t.startTime) {
    const n = { ...r };
    return n.startTimestamp = Dc(t.startTime), delete n.startTime, n;
  }
  return r;
}
function EO() {
  const t = sl();
  return Bd(t);
}
function lw(t, e, r) {
  const n = mr(), A = n && n.getOptions() || {}, { name: i = "", attributes: o } = t, [s, a] = e.getScopeData().sdkProcessingMetadata[bO] ? [!1] : OV(A, {
    name: i,
    parentSampled: r,
    attributes: o,
    transactionContext: {
      name: i,
      parentSampled: r
    }
  }), c = new ev({
    ...t,
    attributes: {
      [No]: "custom",
      ...t.attributes
    },
    sampled: s
  });
  return a !== void 0 && c.setAttribute(AO, a), n && n.emit("spanStart", c), c;
}
function nW(t, e, r) {
  const { spanId: n, traceId: A } = t.spanContext(), i = e.getScopeData().sdkProcessingMetadata[bO] ? !1 : al(t), o = i ? new ev({
    ...r,
    parentSpanId: n,
    traceId: A,
    sampled: i
  }) : new Ed({ traceId: A });
  fO(t, o);
  const s = mr();
  return s && (s.emit("spanStart", o), r.endTimestamp && s.emit("spanEnd", o)), o;
}
function AW(t) {
  const e = Jh(t);
  if (!e)
    return;
  const r = mr();
  return (r ? r.getOptions() : {}).parentSpanIsAlwaysRootSpan ? wA(e) : e;
}
const ph = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
}, iW = "heartbeatFailed", oW = "idleTimeout", sW = "finalTimeout", aW = "externalFinish";
function xO(t, e = {}) {
  const r = /* @__PURE__ */ new Map();
  let n = !1, A, i = aW, o = !e.disableAutoFinish;
  const s = [], {
    idleTimeout: a = ph.idleTimeout,
    finalTimeout: c = ph.finalTimeout,
    childSpanTimeout: l = ph.childSpanTimeout,
    beforeSpanEnd: u
  } = e, f = mr();
  if (!f || !Na())
    return new Ed();
  const d = $r(), g = aA(), m = cW(t);
  m.end = new Proxy(m.end, {
    apply(b, q, E) {
      u && u(m);
      const [x, ...M] = E, O = x || KA(), I = Dc(O), S = hh(m).filter((U) => U !== m);
      if (!S.length)
        return y(I), Reflect.apply(b, q, [I, ...M]);
      const P = S.map((U) => kr(U).timestamp).filter((U) => !!U), H = P.length ? Math.max(...P) : void 0, F = kr(m).start_timestamp, T = Math.min(
        F ? F + c / 1e3 : 1 / 0,
        Math.max(F || -1 / 0, Math.min(I, H || 1 / 0))
      );
      return y(T), Reflect.apply(b, q, [T, ...M]);
    }
  });
  function p() {
    A && (clearTimeout(A), A = void 0);
  }
  function v(b) {
    p(), A = setTimeout(() => {
      !n && r.size === 0 && o && (i = oW, m.end(b));
    }, a);
  }
  function C(b) {
    A = setTimeout(() => {
      !n && o && (i = iW, m.end(b));
    }, l);
  }
  function w(b) {
    p(), r.set(b, !0);
    const q = KA();
    C(q + l / 1e3);
  }
  function B(b) {
    if (r.has(b) && r.delete(b), r.size === 0) {
      const q = KA();
      v(q + a / 1e3);
    }
  }
  function y(b) {
    n = !0, r.clear(), s.forEach((I) => I()), m2(d, g);
    const q = kr(m), { start_timestamp: E } = q;
    if (!E)
      return;
    (q.data || {})[q5] || m.setAttribute(q5, i), ft.log(`[Tracing] Idle span "${q.op}" finished`);
    const M = hh(m).filter((I) => I !== m);
    let O = 0;
    M.forEach((I) => {
      I.isRecording() && (I.setStatus({ code: iA, message: "cancelled" }), I.end(b), rr && ft.log("[Tracing] Cancelling span since span ended early", JSON.stringify(I, void 0, 2)));
      const S = kr(I), { timestamp: P = 0, start_timestamp: H = 0 } = S, F = H <= b, T = (c + a) / 1e3, U = P - H <= T;
      if (rr) {
        const D = JSON.stringify(I, void 0, 2);
        F ? U || ft.log("[Tracing] Discarding span since it finished after idle span final timeout", D) : ft.log("[Tracing] Discarding span since it happened after idle span was finished", D);
      }
      (!U || !F) && (xV(m, I), O++);
    }), O > 0 && m.setAttribute("sentry.idle_span_discarded_spans", O);
  }
  return s.push(
    f.on("spanStart", (b) => {
      if (n || b === m || kr(b).timestamp)
        return;
      hh(m).includes(b) && w(b.spanContext().spanId);
    })
  ), s.push(
    f.on("spanEnd", (b) => {
      n || B(b.spanContext().spanId);
    })
  ), s.push(
    f.on("idleSpanEnableAutoFinish", (b) => {
      b === m && (o = !0, v(), r.size && C());
    })
  ), e.disableAutoFinish || v(), setTimeout(() => {
    n || (m.setStatus({ code: iA, message: "deadline_exceeded" }), i = sW, m.end());
  }, c), m;
}
function cW(t) {
  const e = C1(t);
  return m2($r(), e), rr && ft.log("[Tracing] Started span is an idle span"), e;
}
function B5(t, e, r, n = 0) {
  return new Mi((A, i) => {
    const o = t[n];
    if (e === null || typeof o != "function")
      A(e);
    else {
      const s = o({ ...e }, r);
      rr && o.id && s === null && ft.log(`Event processor "${o.id}" dropped event`), Mg(s) ? s.then((a) => B5(t, a, r, n + 1).then(A)).then(null, i) : B5(t, s, r, n + 1).then(A).then(null, i);
    }
  });
}
let ef, uw, tf;
function lW(t) {
  const e = qr._sentryDebugIds;
  if (!e)
    return {};
  const r = Object.keys(e);
  return tf && r.length === uw || (uw = r.length, tf = r.reduce((n, A) => {
    ef || (ef = {});
    const i = ef[A];
    if (i)
      n[i[0]] = i[1];
    else {
      const o = t(A);
      for (let s = o.length - 1; s >= 0; s--) {
        const a = o[s], c = a && a.filename, l = e[A];
        if (c && l) {
          n[c] = l, ef[A] = [c, l];
          break;
        }
      }
    }
    return n;
  }, {})), tf;
}
function uW(t, e) {
  const { fingerprint: r, span: n, breadcrumbs: A, sdkProcessingMetadata: i } = e;
  dW(t, e), n && pW(t, n), gW(t, r), fW(t, A), hW(t, i);
}
function dw(t, e) {
  const {
    extra: r,
    tags: n,
    user: A,
    contexts: i,
    level: o,
    sdkProcessingMetadata: s,
    breadcrumbs: a,
    fingerprint: c,
    eventProcessors: l,
    attachments: u,
    propagationContext: f,
    transactionName: d,
    span: g
  } = e;
  rf(t, "extra", r), rf(t, "tags", n), rf(t, "user", A), rf(t, "contexts", i), t.sdkProcessingMetadata = Hg(t.sdkProcessingMetadata, s, 2), o && (t.level = o), d && (t.transactionName = d), g && (t.span = g), a.length && (t.breadcrumbs = [...t.breadcrumbs, ...a]), c.length && (t.fingerprint = [...t.fingerprint, ...c]), l.length && (t.eventProcessors = [...t.eventProcessors, ...l]), u.length && (t.attachments = [...t.attachments, ...u]), t.propagationContext = { ...t.propagationContext, ...f };
}
function rf(t, e, r) {
  t[e] = Hg(t[e], r, 1);
}
function dW(t, e) {
  const { extra: r, tags: n, user: A, contexts: i, level: o, transactionName: s } = e, a = _n(r);
  a && Object.keys(a).length && (t.extra = { ...a, ...t.extra });
  const c = _n(n);
  c && Object.keys(c).length && (t.tags = { ...c, ...t.tags });
  const l = _n(A);
  l && Object.keys(l).length && (t.user = { ...l, ...t.user });
  const u = _n(i);
  u && Object.keys(u).length && (t.contexts = { ...u, ...t.contexts }), o && (t.level = o), s && t.type !== "transaction" && (t.transaction = s);
}
function fW(t, e) {
  const r = [...t.breadcrumbs || [], ...e];
  t.breadcrumbs = r.length ? r : void 0;
}
function hW(t, e) {
  t.sdkProcessingMetadata = {
    ...t.sdkProcessingMetadata,
    ...e
  };
}
function pW(t, e) {
  t.contexts = {
    trace: wV(e),
    ...t.contexts
  }, t.sdkProcessingMetadata = {
    dynamicSamplingContext: cl(e),
    ...t.sdkProcessingMetadata
  };
  const r = wA(e), n = kr(r).description;
  n && !t.transaction && t.type === "transaction" && (t.transaction = n);
}
function gW(t, e) {
  t.fingerprint = t.fingerprint ? Array.isArray(t.fingerprint) ? t.fingerprint : [t.fingerprint] : [], e && (t.fingerprint = t.fingerprint.concat(e)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
}
function IO(t, e, r, n, A, i) {
  const { normalizeDepth: o = 3, normalizeMaxBreadth: s = 1e3 } = t, a = {
    ...e,
    event_id: e.event_id || r.event_id || Ci(),
    timestamp: e.timestamp || q1()
  }, c = r.integrations || t.integrations.map((p) => p.name);
  mW(a, t), yW(a, c), A && A.emit("applyFrameMetadata", e), e.type === void 0 && vW(a, t.stackParser);
  const l = wW(n, r.captureContext);
  r.mechanism && bu(a, r.mechanism);
  const u = A ? A.getEventProcessors() : [], f = aV().getScopeData();
  if (i) {
    const p = i.getScopeData();
    dw(f, p);
  }
  if (l) {
    const p = l.getScopeData();
    dw(f, p);
  }
  const d = [...r.attachments || [], ...f.attachments];
  d.length && (r.attachments = d), uW(a, f);
  const g = [
    ...u,
    // Run scope event processors _after_ all other processors
    ...f.eventProcessors
  ];
  return B5(g, a, r).then((p) => (p && qW(p), typeof o == "number" && o > 0 ? CW(p, o, s) : p));
}
function mW(t, e) {
  const { environment: r, release: n, dist: A, maxValueLength: i = 250 } = e;
  t.environment = t.environment || r || _m, !t.release && n && (t.release = n), !t.dist && A && (t.dist = A), t.message && (t.message = Au(t.message, i));
  const o = t.exception && t.exception.values && t.exception.values[0];
  o && o.value && (o.value = Au(o.value, i));
  const s = t.request;
  s && s.url && (s.url = Au(s.url, i));
}
function vW(t, e) {
  const r = lW(e);
  try {
    t.exception.values.forEach((n) => {
      n.stacktrace.frames.forEach((A) => {
        r && A.filename && (A.debug_id = r[A.filename]);
      });
    });
  } catch {
  }
}
function qW(t) {
  const e = {};
  try {
    t.exception.values.forEach((n) => {
      n.stacktrace.frames.forEach((A) => {
        A.debug_id && (A.abs_path ? e[A.abs_path] = A.debug_id : A.filename && (e[A.filename] = A.debug_id), delete A.debug_id);
      });
    });
  } catch {
  }
  if (Object.keys(e).length === 0)
    return;
  t.debug_meta = t.debug_meta || {}, t.debug_meta.images = t.debug_meta.images || [];
  const r = t.debug_meta.images;
  Object.entries(e).forEach(([n, A]) => {
    r.push({
      type: "sourcemap",
      code_file: n,
      debug_id: A
    });
  });
}
function yW(t, e) {
  e.length > 0 && (t.sdk = t.sdk || {}, t.sdk.integrations = [...t.sdk.integrations || [], ...e]);
}
function CW(t, e, r) {
  if (!t)
    return null;
  const n = {
    ...t,
    ...t.breadcrumbs && {
      breadcrumbs: t.breadcrumbs.map((A) => ({
        ...A,
        ...A.data && {
          data: no(A.data, e, r)
        }
      }))
    },
    ...t.user && {
      user: no(t.user, e, r)
    },
    ...t.contexts && {
      contexts: no(t.contexts, e, r)
    },
    ...t.extra && {
      extra: no(t.extra, e, r)
    }
  };
  return t.contexts && t.contexts.trace && n.contexts && (n.contexts.trace = t.contexts.trace, t.contexts.trace.data && (n.contexts.trace.data = no(t.contexts.trace.data, e, r))), t.spans && (n.spans = t.spans.map((A) => ({
    ...A,
    ...A.data && {
      data: no(A.data, e, r)
    }
  }))), t.contexts && t.contexts.flags && n.contexts && (n.contexts.flags = no(t.contexts.flags, 3, r)), n;
}
function wW(t, e) {
  if (!e)
    return t;
  const r = t ? t.clone() : new Kc();
  return r.update(e), r;
}
function tv(t, e) {
  return $r().captureException(t, void 0);
}
function SO(t, e) {
  return $r().captureEvent(t, e);
}
function PO(t, e) {
  qo().setContext(t, e);
}
function bW() {
  const t = mr();
  return !!t && t.getOptions().enabled !== !1 && !!t.getTransport();
}
function BW(t) {
  qo().addEventProcessor(t);
}
function fw(t) {
  const e = mr(), r = qo(), n = $r(), { release: A, environment: i = _m } = e && e.getOptions() || {}, { userAgent: o } = qr.navigator || {}, s = _Y({
    release: A,
    environment: i,
    user: n.getUser() || r.getUser(),
    ...o && { userAgent: o },
    ...t
  }), a = r.getSession();
  return a && a.status === "ok" && Bu(a, { status: "exited" }), kO(), r.setSession(s), n.setSession(s), s;
}
function kO() {
  const t = qo(), e = $r(), r = e.getSession() || t.getSession();
  r && $Y(r), OO(), t.setSession(), e.setSession();
}
function OO() {
  const t = qo(), e = $r(), r = mr(), n = e.getSession() || t.getSession();
  n && r && r.captureSession(n);
}
function hw(t = !1) {
  if (t) {
    kO();
    return;
  }
  OO();
}
const EW = "7";
function xW(t) {
  const e = t.protocol ? `${t.protocol}:` : "", r = t.port ? `:${t.port}` : "";
  return `${e}//${t.host}${r}${t.path ? `/${t.path}` : ""}/api/`;
}
function IW(t) {
  return `${xW(t)}${t.projectId}/envelope/`;
}
function SW(t, e) {
  const r = {
    sentry_version: EW
  };
  return t.publicKey && (r.sentry_key = t.publicKey), e && (r.sentry_client = `${e.name}/${e.version}`), new URLSearchParams(r).toString();
}
function PW(t, e, r) {
  return e || `${IW(t)}?${SW(t, r)}`;
}
const pw = [];
function kW(t) {
  const e = {};
  return t.forEach((r) => {
    const { name: n } = r, A = e[n];
    A && !A.isDefaultInstance && r.isDefaultInstance || (e[n] = r);
  }), Object.values(e);
}
function OW(t) {
  const e = t.defaultIntegrations || [], r = t.integrations;
  e.forEach((o) => {
    o.isDefaultInstance = !0;
  });
  let n;
  if (Array.isArray(r))
    n = [...e, ...r];
  else if (typeof r == "function") {
    const o = r(e);
    n = Array.isArray(o) ? o : [o];
  } else
    n = e;
  const A = kW(n), i = A.findIndex((o) => o.name === "Debug");
  if (i > -1) {
    const [o] = A.splice(i, 1);
    A.push(o);
  }
  return A;
}
function FW(t, e) {
  const r = {};
  return e.forEach((n) => {
    n && FO(t, n, r);
  }), r;
}
function gw(t, e) {
  for (const r of e)
    r && r.afterAllSetup && r.afterAllSetup(t);
}
function FO(t, e, r) {
  if (r[e.name]) {
    rr && ft.log(`Integration skipped because it was already installed: ${e.name}`);
    return;
  }
  if (r[e.name] = e, pw.indexOf(e.name) === -1 && typeof e.setupOnce == "function" && (e.setupOnce(), pw.push(e.name)), e.setup && typeof e.setup == "function" && e.setup(t), typeof e.preprocessEvent == "function") {
    const n = e.preprocessEvent.bind(e);
    t.on("preprocessEvent", (A, i) => n(A, i, t));
  }
  if (typeof e.processEvent == "function") {
    const n = e.processEvent.bind(e), A = Object.assign((i, o) => n(i, o, t), {
      id: e.name
    });
    t.addEventProcessor(A);
  }
  rr && ft.log(`Integration installed: ${e.name}`);
}
function TW(t, e, r) {
  const n = [
    { type: "client_report" },
    {
      timestamp: q1(),
      discarded_events: t
    }
  ];
  return ll(e ? { dsn: e } : {}, [n]);
}
class so extends Error {
  constructor(e, r = "warn") {
    super(e), this.message = e, this.logLevel = r;
  }
}
const mw = "Not capturing exception because it's already been captured.";
class MW {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(e) {
    if (this._options = e, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], e.dsn ? this._dsn = DV(e.dsn) : rr && ft.warn("No DSN provided, client will not send events."), this._dsn) {
      const A = PW(
        this._dsn,
        e.tunnel,
        e._metadata ? e._metadata.sdk : void 0
      );
      this._transport = e.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...e.transportOptions,
        url: A
      });
    }
    const n = ["enableTracing", "tracesSampleRate", "tracesSampler"].find((A) => A in e && e[A] == null);
    n && Ja(() => {
      console.warn(
        `[Sentry] Deprecation warning: \`${n}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`
      );
    });
  }
  /**
   * @inheritDoc
   */
  captureException(e, r, n) {
    const A = Ci();
    if (KC(e))
      return rr && ft.log(mw), A;
    const i = {
      event_id: A,
      ...r
    };
    return this._process(
      this.eventFromException(e, i).then(
        (o) => this._captureEvent(o, i, n)
      )
    ), i.event_id;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, r, n, A) {
    const i = {
      event_id: Ci(),
      ...n
    }, o = Ym(e) ? e : String(e), s = Vm(e) ? this.eventFromMessage(o, r, i) : this.eventFromException(e, i);
    return this._process(s.then((a) => this._captureEvent(a, i, A))), i.event_id;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, r, n) {
    const A = Ci();
    if (r && r.originalException && KC(r.originalException))
      return rr && ft.log(mw), A;
    const i = {
      event_id: A,
      ...r
    }, s = (e.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(this._captureEvent(e, i, s || n)), i.event_id;
  }
  /**
   * @inheritDoc
   */
  captureSession(e) {
    typeof e.release != "string" ? rr && ft.warn("Discarded session because of missing or non-string release") : (this.sendSession(e), Bu(e, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(e) {
    const r = this._transport;
    return r ? (this.emit("flush"), this._isClientDoneProcessing(e).then((n) => r.flush(e).then((A) => n && A))) : Fs(!0);
  }
  /**
   * @inheritDoc
   */
  close(e) {
    return this.flush(e).then((r) => (this.getOptions().enabled = !1, this.emit("close"), r));
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(e) {
    this._eventProcessors.push(e);
  }
  /** @inheritdoc */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: e }) => e.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(e) {
    return this._integrations[e];
  }
  /**
   * @inheritDoc
   */
  addIntegration(e) {
    const r = this._integrations[e.name];
    FO(this, e, this._integrations), r || gw(this, [e]);
  }
  /**
   * @inheritDoc
   */
  sendEvent(e, r = {}) {
    this.emit("beforeSendEvent", e, r);
    let n = ZV(e, this._dsn, this._options._metadata, this._options.tunnel);
    for (const i of r.attachments || [])
      n = GV(n, VV(i));
    const A = this.sendEnvelope(n);
    A && A.then((i) => this.emit("afterSendEvent", e, i), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(e) {
    const r = KV(e, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(r);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(e, r, n) {
    if (this._options.sendClientReports) {
      const A = typeof n == "number" ? n : 1, i = `${e}:${r}`;
      rr && ft.log(`Recording outcome: "${i}"${A > 1 ? ` (${A} times)` : ""}`), this._outcomes[i] = (this._outcomes[i] || 0) + A;
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(e, r) {
    const n = this._hooks[e] = this._hooks[e] || [];
    return n.push(r), () => {
      const A = n.indexOf(r);
      A > -1 && n.splice(A, 1);
    };
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(e, ...r) {
    const n = this._hooks[e];
    n && n.forEach((A) => A(...r));
  }
  /**
   * @inheritdoc
   */
  sendEnvelope(e) {
    return this.emit("beforeEnvelope", e), this._isEnabled() && this._transport ? this._transport.send(e).then(null, (r) => (rr && ft.error("Error while sending envelope:", r), r)) : (rr && ft.error("Transport disabled"), Fs({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: e } = this._options;
    this._integrations = FW(this, e), gw(this, e);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(e, r) {
    let n = r.level === "fatal", A = !1;
    const i = r.exception && r.exception.values;
    if (i) {
      A = !0;
      for (const a of i) {
        const c = a.mechanism;
        if (c && c.handled === !1) {
          n = !0;
          break;
        }
      }
    }
    const o = e.status === "ok";
    (o && e.errors === 0 || o && n) && (Bu(e, {
      ...n && { status: "crashed" },
      errors: e.errors || Number(A || n)
    }), this.captureSession(e));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(e) {
    return new Mi((r) => {
      let n = 0;
      const A = 1, i = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(i), r(!0)) : (n += A, e && n >= e && (clearInterval(i), r(!1)));
      }, A);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(e, r, n = $r(), A = qo()) {
    const i = this.getOptions(), o = Object.keys(this._integrations);
    return !r.integrations && o.length > 0 && (r.integrations = o), this.emit("preprocessEvent", e, r), e.type || A.setLastEventId(e.event_id || r.event_id), IO(i, e, r, n, this, A).then((s) => {
      if (s === null)
        return s;
      s.contexts = {
        trace: cV(n),
        ...s.contexts
      };
      const a = qO(this, n);
      return s.sdkProcessingMetadata = {
        dynamicSamplingContext: a,
        ...s.sdkProcessingMetadata
      }, s;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(e, r = {}, n) {
    return this._processEvent(e, r, n).then(
      (A) => A.event_id,
      (A) => {
        rr && (A instanceof so && A.logLevel === "log" ? ft.log(A.message) : ft.warn(A));
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(e, r, n) {
    const A = this.getOptions(), { sampleRate: i } = A, o = MO(e), s = TO(e), a = e.type || "error", c = `before send for type \`${a}\``, l = typeof i > "u" ? void 0 : _h(i);
    if (s && typeof l == "number" && Math.random() > l)
      return this.recordDroppedEvent("sample_rate", "error", e), Zh(
        new so(
          `Discarding event because it's not included in the random sample (sampling rate = ${i})`,
          "log"
        )
      );
    const u = a === "replay_event" ? "replay" : a, d = (e.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(e, r, n, d).then((g) => {
      if (g === null)
        throw this.recordDroppedEvent("event_processor", u, e), new so("An event processor returned `null`, will not send event.", "log");
      if (r.data && r.data.__sentry__ === !0)
        return g;
      const p = DW(this, A, g, r);
      return HW(p, c);
    }).then((g) => {
      if (g === null) {
        if (this.recordDroppedEvent("before_send", u, e), o) {
          const C = 1 + (e.spans || []).length;
          this.recordDroppedEvent("before_send", "span", C);
        }
        throw new so(`${c} returned \`null\`, will not send event.`, "log");
      }
      const m = n && n.getSession();
      if (!o && m && this._updateSessionFromEvent(m, g), o) {
        const v = g.sdkProcessingMetadata && g.sdkProcessingMetadata.spanCountBeforeProcessing || 0, C = g.spans ? g.spans.length : 0, w = v - C;
        w > 0 && this.recordDroppedEvent("before_send", "span", w);
      }
      const p = g.transaction_info;
      if (o && p && g.transaction !== e.transaction) {
        const v = "custom";
        g.transaction_info = {
          ...p,
          source: v
        };
      }
      return this.sendEvent(g, r), g;
    }).then(null, (g) => {
      throw g instanceof so ? g : (this.captureException(g, {
        data: {
          __sentry__: !0
        },
        originalException: g
      }), new so(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${g}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(e) {
    this._numProcessing++, e.then(
      (r) => (this._numProcessing--, r),
      (r) => (this._numProcessing--, r)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const e = this._outcomes;
    return this._outcomes = {}, Object.entries(e).map(([r, n]) => {
      const [A, i] = r.split(":");
      return {
        reason: A,
        category: i,
        quantity: n
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    rr && ft.log("Flushing outcomes...");
    const e = this._clearOutcomes();
    if (e.length === 0) {
      rr && ft.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      rr && ft.log("No dsn provided, will not send outcomes");
      return;
    }
    rr && ft.log("Sending outcomes:", e);
    const r = TW(e, this._options.tunnel && y1(this._dsn));
    this.sendEnvelope(r);
  }
  /**
   * @inheritDoc
   */
}
function HW(t, e) {
  const r = `${e} must return \`null\` or a valid event.`;
  if (Mg(t))
    return t.then(
      (n) => {
        if (!wu(n) && n !== null)
          throw new so(r);
        return n;
      },
      (n) => {
        throw new so(`${e} rejected with ${n}`);
      }
    );
  if (!wu(t) && t !== null)
    throw new so(r);
  return t;
}
function DW(t, e, r, n) {
  const { beforeSend: A, beforeSendTransaction: i, beforeSendSpan: o } = e;
  if (TO(r) && A)
    return A(r, n);
  if (MO(r)) {
    if (r.spans && o) {
      const s = [];
      for (const a of r.spans) {
        const c = o(a);
        c ? s.push(c) : (hO(), t.recordDroppedEvent("before_send", "span"));
      }
      r.spans = s;
    }
    if (i) {
      if (r.spans) {
        const s = r.spans.length;
        r.sdkProcessingMetadata = {
          ...r.sdkProcessingMetadata,
          spanCountBeforeProcessing: s
        };
      }
      return i(r, n);
    }
  }
  return r;
}
function TO(t) {
  return t.type === void 0;
}
function MO(t) {
  return t.type === "transaction";
}
function QW(t, e) {
  e.debug === !0 && (rr ? ft.enable() : Ja(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), $r().update(e.initialScope);
  const n = new t(e);
  return UW(n), n.init(), n;
}
function UW(t) {
  $r().setClient(t);
}
function NW(t) {
  const e = [];
  function r() {
    return t === void 0 || e.length < t;
  }
  function n(o) {
    return e.splice(e.indexOf(o), 1)[0] || Promise.resolve(void 0);
  }
  function A(o) {
    if (!r())
      return Zh(new so("Not adding Promise because buffer limit was reached."));
    const s = o();
    return e.indexOf(s) === -1 && e.push(s), s.then(() => n(s)).then(
      null,
      () => n(s).then(null, () => {
      })
    ), s;
  }
  function i(o) {
    return new Mi((s, a) => {
      let c = e.length;
      if (!c)
        return s(!0);
      const l = setTimeout(() => {
        o && o > 0 && s(!1);
      }, o);
      e.forEach((u) => {
        Fs(u).then(() => {
          --c || (clearTimeout(l), s(!0));
        }, a);
      });
    });
  }
  return {
    $: e,
    add: A,
    drain: i
  };
}
const jW = 60 * 1e3;
function LW(t, e = Date.now()) {
  const r = parseInt(`${t}`, 10);
  if (!isNaN(r))
    return r * 1e3;
  const n = Date.parse(`${t}`);
  return isNaN(n) ? jW : n - e;
}
function GW(t, e) {
  return t[e] || t.all || 0;
}
function HO(t, e, r = Date.now()) {
  return GW(t, e) > r;
}
function DO(t, { statusCode: e, headers: r }, n = Date.now()) {
  const A = {
    ...t
  }, i = r && r["x-sentry-rate-limits"], o = r && r["retry-after"];
  if (i)
    for (const s of i.trim().split(",")) {
      const [a, c, , , l] = s.split(":", 5), u = parseInt(a, 10), f = (isNaN(u) ? 60 : u) * 1e3;
      if (!c)
        A.all = n + f;
      else
        for (const d of c.split(";"))
          d === "metric_bucket" ? (!l || l.split(";").includes("custom")) && (A[d] = n + f) : A[d] = n + f;
    }
  else o ? A.all = n + LW(o, n) : e === 429 && (A.all = n + 60 * 1e3);
  return A;
}
const RW = 64;
function zW(t, e, r = NW(
  t.bufferSize || RW
)) {
  let n = {};
  const A = (o) => r.drain(o);
  function i(o) {
    const s = [];
    if (Aw(o, (u, f) => {
      const d = iw(f);
      if (HO(n, d)) {
        const g = vw(u, f);
        t.recordDroppedEvent("ratelimit_backoff", d, g);
      } else
        s.push(u);
    }), s.length === 0)
      return Fs({});
    const a = ll(o[0], s), c = (u) => {
      Aw(a, (f, d) => {
        const g = vw(f, d);
        t.recordDroppedEvent(u, iw(d), g);
      });
    }, l = () => e({ body: RV(a) }).then(
      (u) => (u.statusCode !== void 0 && (u.statusCode < 200 || u.statusCode >= 300) && rr && ft.warn(`Sentry responded with status code ${u.statusCode} to sent event.`), n = DO(n, u), u),
      (u) => {
        throw c("network_error"), u;
      }
    );
    return r.add(l).then(
      (u) => u,
      (u) => {
        if (u instanceof so)
          return rr && ft.error("Skipped sending event because buffer is full."), c("queue_overflow"), Fs({});
        throw u;
      }
    );
  }
  return {
    send: i,
    flush: A
  };
}
function vw(t, e) {
  if (!(e !== "event" && e !== "transaction"))
    return Array.isArray(t) ? t[1] : void 0;
}
function YW(t, e) {
  const r = e && e.getDsn(), n = e && e.getOptions().tunnel;
  return WW(t, r) || VW(t, n);
}
function VW(t, e) {
  return e ? qw(t) === qw(e) : !1;
}
function WW(t, e) {
  return e ? t.includes(e.host) : !1;
}
function qw(t) {
  return t[t.length - 1] === "/" ? t.slice(0, -1) : t;
}
function QO(t, e, r = [e], n = "npm") {
  const A = t._metadata || {};
  A.sdk || (A.sdk = {
    name: `sentry.javascript.${e}`,
    packages: r.map((i) => ({
      name: `${n}:@sentry/${i}`,
      version: Hc
    })),
    version: Hc
  }), t._metadata = A;
}
function UO(t = {}) {
  const e = mr();
  if (!bW() || !e)
    return {};
  const r = sl(), n = Bd(r);
  if (n.getTraceData)
    return n.getTraceData(t);
  const A = $r(), i = t.span || aA(), o = i ? bV(i) : XW(A), s = i ? cl(i) : qO(e, A), a = gV(s);
  return aO.test(o) ? {
    "sentry-trace": o,
    baggage: a
  } : (ft.warn("Invalid sentry-trace data. Cannot generate trace data"), {});
}
function XW(t) {
  const { traceId: e, sampled: r, spanId: n } = t.getPropagationContext();
  return cO(e, n, r);
}
const KW = 100;
function ja(t, e) {
  const r = mr(), n = qo();
  if (!r) return;
  const { beforeBreadcrumb: A = null, maxBreadcrumbs: i = KW } = r.getOptions();
  if (i <= 0) return;
  const s = { timestamp: q1(), ...t }, a = A ? Ja(() => A(s, e)) : s;
  a !== null && (r.emit && r.emit("beforeAddBreadcrumb", a, e), n.addBreadcrumb(a, i));
}
let yw;
const ZW = "FunctionToString", Cw = /* @__PURE__ */ new WeakMap(), JW = () => ({
  name: ZW,
  setupOnce() {
    yw = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...t) {
        const e = Wm(this), r = Cw.has(mr()) && e !== void 0 ? e : this;
        return yw.apply(r, t);
      };
    } catch {
    }
  },
  setup(t) {
    Cw.set(t, !0);
  }
}), _W = JW, $W = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  "undefined is not an object (evaluating 'a.L')",
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler",
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
], eX = "InboundFilters", tX = (t = {}) => ({
  name: eX,
  processEvent(e, r, n) {
    const A = n.getOptions(), i = nX(t, A);
    return AX(e, i) ? null : e;
  }
}), rX = tX;
function nX(t = {}, e = {}) {
  return {
    allowUrls: [...t.allowUrls || [], ...e.allowUrls || []],
    denyUrls: [...t.denyUrls || [], ...e.denyUrls || []],
    ignoreErrors: [
      ...t.ignoreErrors || [],
      ...e.ignoreErrors || [],
      ...t.disableErrorDefaults ? [] : $W
    ],
    ignoreTransactions: [...t.ignoreTransactions || [], ...e.ignoreTransactions || []],
    ignoreInternal: t.ignoreInternal !== void 0 ? t.ignoreInternal : !0
  };
}
function AX(t, e) {
  return e.ignoreInternal && lX(t) ? (rr && ft.warn(`Event dropped due to being internal Sentry Error.
Event: ${ca(t)}`), !0) : iX(t, e.ignoreErrors) ? (rr && ft.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${ca(t)}`
  ), !0) : dX(t) ? (rr && ft.warn(
    `Event dropped due to not having an error message, error type or stacktrace.
Event: ${ca(
      t
    )}`
  ), !0) : oX(t, e.ignoreTransactions) ? (rr && ft.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${ca(t)}`
  ), !0) : sX(t, e.denyUrls) ? (rr && ft.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${ca(
      t
    )}.
Url: ${$h(t)}`
  ), !0) : aX(t, e.allowUrls) ? !1 : (rr && ft.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${ca(
      t
    )}.
Url: ${$h(t)}`
  ), !0);
}
function iX(t, e) {
  return t.type || !e || !e.length ? !1 : cX(t).some((r) => Sa(r, e));
}
function oX(t, e) {
  if (t.type !== "transaction" || !e || !e.length)
    return !1;
  const r = t.transaction;
  return r ? Sa(r, e) : !1;
}
function sX(t, e) {
  if (!e || !e.length)
    return !1;
  const r = $h(t);
  return r ? Sa(r, e) : !1;
}
function aX(t, e) {
  if (!e || !e.length)
    return !0;
  const r = $h(t);
  return r ? Sa(r, e) : !0;
}
function cX(t) {
  const e = [];
  t.message && e.push(t.message);
  let r;
  try {
    r = t.exception.values[t.exception.values.length - 1];
  } catch {
  }
  return r && r.value && (e.push(r.value), r.type && e.push(`${r.type}: ${r.value}`)), e;
}
function lX(t) {
  try {
    return t.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function uX(t = []) {
  for (let e = t.length - 1; e >= 0; e--) {
    const r = t[e];
    if (r && r.filename !== "<anonymous>" && r.filename !== "[native code]")
      return r.filename || null;
  }
  return null;
}
function $h(t) {
  try {
    let e;
    try {
      e = t.exception.values[0].stacktrace.frames;
    } catch {
    }
    return e ? uX(e) : null;
  } catch {
    return rr && ft.error(`Cannot extract url for event ${ca(t)}`), null;
  }
}
function dX(t) {
  return t.type || !t.exception || !t.exception.values || t.exception.values.length === 0 ? !1 : (
    // No top-level message
    !t.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !t.exception.values.some((e) => e.stacktrace || e.type && e.type !== "Error" || e.value)
  );
}
function fX(t, e, r = 250, n, A, i, o) {
  if (!i.exception || !i.exception.values || !o || !ks(o.originalException, Error))
    return;
  const s = i.exception.values.length > 0 ? i.exception.values[i.exception.values.length - 1] : void 0;
  s && (i.exception.values = hX(
    E5(
      t,
      e,
      A,
      o.originalException,
      n,
      i.exception.values,
      s,
      0
    ),
    r
  ));
}
function E5(t, e, r, n, A, i, o, s) {
  if (i.length >= r + 1)
    return i;
  let a = [...i];
  if (ks(n[A], Error)) {
    ww(o, s);
    const c = t(e, n[A]), l = a.length;
    bw(c, A, l, s), a = E5(
      t,
      e,
      r,
      n[A],
      A,
      [c, ...a],
      c,
      l
    );
  }
  return Array.isArray(n.errors) && n.errors.forEach((c, l) => {
    if (ks(c, Error)) {
      ww(o, s);
      const u = t(e, c), f = a.length;
      bw(u, `errors[${l}]`, f, s), a = E5(
        t,
        e,
        r,
        c,
        A,
        [u, ...a],
        u,
        f
      );
    }
  }), a;
}
function ww(t, e) {
  t.mechanism = t.mechanism || { type: "generic", handled: !0 }, t.mechanism = {
    ...t.mechanism,
    ...t.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: e
  };
}
function bw(t, e, r, n) {
  t.mechanism = t.mechanism || { type: "generic", handled: !0 }, t.mechanism = {
    ...t.mechanism,
    type: "chained",
    source: e,
    exception_id: r,
    parent_id: n
  };
}
function hX(t, e) {
  return t.map((r) => (r.value && (r.value = Au(r.value, e)), r));
}
function Uc(t) {
  if (!t)
    return {};
  const e = t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!e)
    return {};
  const r = e[6] || "", n = e[8] || "";
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    search: r,
    hash: n,
    relative: e[5] + r + n
    // everything minus origin
  };
}
function pX(t) {
  const e = "console";
  _a(e, t), $a(e, gX);
}
function gX() {
  "console" in qr && h5.forEach(function(t) {
    t in qr.console && Ai(qr.console, t, function(e) {
      return Kh[t] = e, function(...r) {
        ji("console", { args: r, level: t });
        const A = Kh[t];
        A && A.apply(qr.console, r);
      };
    });
  });
}
function NO(t) {
  return t === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(t) ? t : "log";
}
const mX = "Dedupe", vX = () => {
  let t;
  return {
    name: mX,
    processEvent(e) {
      if (e.type)
        return e;
      try {
        if (yX(e, t))
          return rr && ft.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return t = e;
    }
  };
}, qX = vX;
function yX(t, e) {
  return e ? !!(CX(t, e) || wX(t, e)) : !1;
}
function CX(t, e) {
  const r = t.message, n = e.message;
  return !(!r && !n || r && !n || !r && n || r !== n || !LO(t, e) || !jO(t, e));
}
function wX(t, e) {
  const r = Bw(e), n = Bw(t);
  return !(!r || !n || r.type !== n.type || r.value !== n.value || !LO(t, e) || !jO(t, e));
}
function jO(t, e) {
  let r = RC(t), n = RC(e);
  if (!r && !n)
    return !0;
  if (r && !n || !r && n || (r = r, n = n, n.length !== r.length))
    return !1;
  for (let A = 0; A < n.length; A++) {
    const i = n[A], o = r[A];
    if (i.filename !== o.filename || i.lineno !== o.lineno || i.colno !== o.colno || i.function !== o.function)
      return !1;
  }
  return !0;
}
function LO(t, e) {
  let r = t.fingerprint, n = e.fingerprint;
  if (!r && !n)
    return !0;
  if (r && !n || !r && n)
    return !1;
  r = r, n = n;
  try {
    return r.join("") === n.join("");
  } catch {
    return !1;
  }
}
function Bw(t) {
  return t.exception && t.exception.values && t.exception.values[0];
}
function bX(t, e, r, n, A = "auto.http.browser") {
  if (!t.fetchData)
    return;
  const i = Na() && e(t.fetchData.url);
  if (t.endTimestamp && i) {
    const f = t.fetchData.__span;
    if (!f) return;
    const d = n[f];
    d && (xX(d, t), delete n[f]);
    return;
  }
  const { method: o, url: s } = t.fetchData, a = EX(s), c = a ? Uc(a).host : void 0, l = !!aA(), u = i && l ? C1({
    name: `${o} ${s}`,
    attributes: {
      url: s,
      type: "fetch",
      "http.method": o,
      "http.url": a,
      "server.address": c,
      [sA]: A,
      [Zc]: "http.client"
    }
  }) : new Ed();
  if (t.fetchData.__span = u.spanContext().spanId, n[u.spanContext().spanId] = u, r(t.fetchData.url)) {
    const f = t.args[0], d = t.args[1] || {}, g = BX(
      f,
      d,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      Na() && l ? u : void 0
    );
    g && (t.args[1] = d, d.headers = g);
  }
  return u;
}
function BX(t, e, r) {
  const n = UO({ span: r }), A = n["sentry-trace"], i = n.baggage;
  if (!A)
    return;
  const o = e.headers || (IX(t) ? t.headers : void 0);
  if (o)
    if (SX(o)) {
      const s = new Headers(o);
      if (s.set("sentry-trace", A), i) {
        const a = s.get("baggage");
        if (a) {
          const c = nf(a);
          s.set(
            "baggage",
            // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
            // otherwise just set the sentry baggage header
            c ? `${c},${i}` : i
          );
        } else
          s.set("baggage", i);
      }
      return s;
    } else if (Array.isArray(o)) {
      const s = [
        ...o.filter((a) => !(Array.isArray(a) && a[0] === "sentry-trace")).map((a) => {
          if (Array.isArray(a) && a[0] === "baggage" && typeof a[1] == "string") {
            const [c, l, ...u] = a;
            return [c, nf(l), ...u];
          } else
            return a;
        }),
        // Attach the new sentry-trace header
        ["sentry-trace", A]
      ];
      return i && s.push(["baggage", i]), s;
    } else {
      const s = "baggage" in o ? o.baggage : void 0;
      let a = [];
      return Array.isArray(s) ? a = s.map(
        (c) => typeof c == "string" ? nf(c) : c
      ).filter((c) => c === "") : s && a.push(nf(s)), i && a.push(i), {
        ...o,
        "sentry-trace": A,
        baggage: a.length > 0 ? a.join(",") : void 0
      };
    }
  else return { ...n };
}
function EX(t) {
  try {
    return new URL(t).href;
  } catch {
    return;
  }
}
function xX(t, e) {
  if (e.response) {
    oO(t, e.response.status);
    const r = e.response && e.response.headers && e.response.headers.get("content-length");
    if (r) {
      const n = parseInt(r);
      n > 0 && t.setAttribute("http.response_content_length", n);
    }
  } else e.error && t.setStatus({ code: iA, message: "internal_error" });
  t.end();
}
function nf(t) {
  return t.split(",").filter((e) => !e.split("=")[0].startsWith(Jm)).join(",");
}
function IX(t) {
  return typeof Request < "u" && ks(t, Request);
}
function SX(t) {
  return typeof Headers < "u" && ks(t, Headers);
}
function GO(t) {
  if (t !== void 0)
    return t >= 400 && t < 500 ? "warning" : t >= 500 ? "error" : void 0;
}
const x5 = qr;
function RO() {
  if (!("fetch" in x5))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function I5(t) {
  return t && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString());
}
function PX() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!RO())
    return !1;
  if (I5(x5.fetch))
    return !0;
  let t = !1;
  const e = x5.document;
  if (e && typeof e.createElement == "function")
    try {
      const r = e.createElement("iframe");
      r.hidden = !0, e.head.appendChild(r), r.contentWindow && r.contentWindow.fetch && (t = I5(r.contentWindow.fetch)), e.head.removeChild(r);
    } catch (r) {
      Za && ft.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", r);
    }
  return t;
}
function zO(t, e) {
  const r = "fetch";
  _a(r, t), $a(r, () => YO(void 0, e));
}
function kX(t) {
  const e = "fetch-body-resolved";
  _a(e, t), $a(e, () => YO(FX));
}
function YO(t, e = !1) {
  e && !PX() || Ai(qr, "fetch", function(r) {
    return function(...n) {
      const A = new Error(), { method: i, url: o } = TX(n), s = {
        args: n,
        fetchData: {
          method: i,
          url: o
        },
        startTimestamp: KA() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: A
      };
      return t || ji("fetch", {
        ...s
      }), r.apply(qr, n).then(
        async (a) => (t ? t(a) : ji("fetch", {
          ...s,
          endTimestamp: KA() * 1e3,
          response: a
        }), a),
        (a) => {
          throw ji("fetch", {
            ...s,
            endTimestamp: KA() * 1e3,
            error: a
          }), zm(a) && a.stack === void 0 && (a.stack = A.stack, Yi(a, "framesToPop", 1)), a;
        }
      );
    };
  });
}
async function OX(t, e) {
  if (t && t.body) {
    const r = t.body, n = r.getReader(), A = setTimeout(
      () => {
        r.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let i = !0;
    for (; i; ) {
      let o;
      try {
        o = setTimeout(() => {
          r.cancel().then(null, () => {
          });
        }, 5e3);
        const { done: s } = await n.read();
        clearTimeout(o), s && (e(), i = !1);
      } catch {
        i = !1;
      } finally {
        clearTimeout(o);
      }
    }
    clearTimeout(A), n.releaseLock(), r.cancel().then(null, () => {
    });
  }
}
function FX(t) {
  let e;
  try {
    e = t.clone();
  } catch {
    return;
  }
  OX(e, () => {
    ji("fetch-body-resolved", {
      endTimestamp: KA() * 1e3,
      response: t
    });
  });
}
function S5(t, e) {
  return !!t && typeof t == "object" && !!t[e];
}
function Ew(t) {
  return typeof t == "string" ? t : t ? S5(t, "url") ? t.url : t.toString ? t.toString() : "" : "";
}
function TX(t) {
  if (t.length === 0)
    return { method: "GET", url: "" };
  if (t.length === 2) {
    const [r, n] = t;
    return {
      url: Ew(r),
      method: S5(n, "method") ? String(n.method).toUpperCase() : "GET"
    };
  }
  const e = t[0];
  return {
    url: Ew(e),
    method: S5(e, "method") ? String(e.method).toUpperCase() : "GET"
  };
}
function MX() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function HX() {
  return "npm";
}
function DX() {
  return !MX() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function xw() {
  return typeof window < "u" && (!DX() || QX());
}
function QX() {
  const t = qr.process;
  return !!t && t.type === "renderer";
}
const Af = qr;
function UX() {
  const t = Af.chrome, e = t && t.app && t.app.runtime, r = "history" in Af && !!Af.history.pushState && !!Af.history.replaceState;
  return !e && r;
}
function NX(t, e) {
  return t ?? e();
}
function gh(t) {
  let e, r = t[0], n = 1;
  for (; n < t.length; ) {
    const A = t[n], i = t[n + 1];
    if (n += 2, (A === "optionalAccess" || A === "optionalCall") && r == null)
      return;
    A === "access" || A === "optionalAccess" ? (e = r, r = i(r)) : (A === "call" || A === "optionalCall") && (r = i((...o) => r.call(e, ...o)), e = void 0);
  }
  return r;
}
const $t = qr;
let P5 = 0;
function VO() {
  return P5 > 0;
}
function jX() {
  P5++, setTimeout(() => {
    P5--;
  });
}
function xu(t, e = {}) {
  function r(A) {
    return typeof A == "function";
  }
  if (!r(t))
    return t;
  try {
    const A = t.__sentry_wrapped__;
    if (A)
      return typeof A == "function" ? A : t;
    if (Wm(t))
      return t;
  } catch {
    return t;
  }
  const n = function(...A) {
    try {
      const i = A.map((o) => xu(o, e));
      return t.apply(this, i);
    } catch (i) {
      throw jX(), Km((o) => {
        o.addEventProcessor((s) => (e.mechanism && (g5(s, void 0), bu(s, e.mechanism)), s.extra = {
          ...s.extra,
          arguments: A
        }, s)), tv(i);
      }), i;
    }
  };
  try {
    for (const A in t)
      Object.prototype.hasOwnProperty.call(t, A) && (n[A] = t[A]);
  } catch {
  }
  eO(n, t), Yi(t, "__sentry_wrapped__", n);
  try {
    Object.getOwnPropertyDescriptor(n, "name").configurable && Object.defineProperty(n, "name", {
      get() {
        return t.name;
      }
    });
  } catch {
  }
  return n;
}
const Zo = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function rv(t, e) {
  const r = nv(t, e), n = {
    type: YX(e),
    value: VX(e)
  };
  return r.length && (n.stacktrace = { frames: r }), n.type === void 0 && n.value === "" && (n.value = "Unrecoverable error caught"), n;
}
function LX(t, e, r, n) {
  const A = mr(), i = A && A.getOptions().normalizeDepth, o = JX(e), s = {
    __serialized__: CO(e, i)
  };
  if (o)
    return {
      exception: {
        values: [rv(t, o)]
      },
      extra: s
    };
  const a = {
    exception: {
      values: [
        {
          type: Tg(e) ? e.constructor.name : n ? "UnhandledRejection" : "Error",
          value: KX(e, { isUnhandledRejection: n })
        }
      ]
    },
    extra: s
  };
  if (r) {
    const c = nv(t, r);
    c.length && (a.exception.values[0].stacktrace = { frames: c });
  }
  return a;
}
function P9(t, e) {
  return {
    exception: {
      values: [rv(t, e)]
    }
  };
}
function nv(t, e) {
  const r = e.stacktrace || e.stack || "", n = RX(e), A = zX(e);
  try {
    return t(r, n, A);
  } catch {
  }
  return [];
}
const GX = /Minified React error #\d+;/i;
function RX(t) {
  return t && GX.test(t.message) ? 1 : 0;
}
function zX(t) {
  return typeof t.framesToPop == "number" ? t.framesToPop : 0;
}
function WO(t) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? t instanceof WebAssembly.Exception : !1;
}
function YX(t) {
  const e = t && t.name;
  return !e && WO(t) ? t.message && Array.isArray(t.message) && t.message.length == 2 ? t.message[0] : "WebAssembly.Exception" : e;
}
function VX(t) {
  const e = t && t.message;
  return e ? e.error && typeof e.error.message == "string" ? e.error.message : WO(t) && Array.isArray(t.message) && t.message.length == 2 ? t.message[1] : e : "No error message";
}
function WX(t, e, r, n) {
  const A = r && r.syntheticException || void 0, i = Av(t, e, A, n);
  return bu(i), i.level = "error", r && r.event_id && (i.event_id = r.event_id), Fs(i);
}
function XX(t, e, r = "info", n, A) {
  const i = n && n.syntheticException || void 0, o = k5(t, e, i, A);
  return o.level = r, n && n.event_id && (o.event_id = n.event_id), Fs(o);
}
function Av(t, e, r, n, A) {
  let i;
  if (Zk(e) && e.error)
    return P9(t, e.error);
  if (YC(e) || jY(e)) {
    const o = e;
    if ("stack" in e)
      i = P9(t, e);
    else {
      const s = o.name || (YC(o) ? "DOMError" : "DOMException"), a = o.message ? `${s}: ${o.message}` : s;
      i = k5(t, a, r, n), g5(i, a);
    }
    return "code" in o && (i.tags = { ...i.tags, "DOMException.code": `${o.code}` }), i;
  }
  return zm(e) ? P9(t, e) : wu(e) || Tg(e) ? (i = LX(t, e, r, A), bu(i, {
    synthetic: !0
  }), i) : (i = k5(t, e, r, n), g5(i, `${e}`), bu(i, {
    synthetic: !0
  }), i);
}
function k5(t, e, r, n) {
  const A = {};
  if (n && r) {
    const i = nv(t, r);
    i.length && (A.exception = {
      values: [{ value: e, stacktrace: { frames: i } }]
    }), bu(A, { synthetic: !0 });
  }
  if (Ym(e)) {
    const { __sentry_template_string__: i, __sentry_template_values__: o } = e;
    return A.logentry = {
      message: i,
      params: o
    }, A;
  }
  return A.message = e, A;
}
function KX(t, { isUnhandledRejection: e }) {
  const r = XY(t), n = e ? "promise rejection" : "exception";
  return Zk(t) ? `Event \`ErrorEvent\` captured as ${n} with message \`${t.message}\`` : Tg(t) ? `Event \`${ZX(t)}\` (type=${t.type}) captured as ${n}` : `Object captured as ${n} with keys: ${r}`;
}
function ZX(t) {
  try {
    const e = Object.getPrototypeOf(t);
    return e ? e.constructor.name : void 0;
  } catch {
  }
}
function JX(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      const r = t[e];
      if (r instanceof Error)
        return r;
    }
}
function _X(t, {
  metadata: e,
  tunnel: r,
  dsn: n
}) {
  const A = {
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...e && e.sdk && {
      sdk: {
        name: e.sdk.name,
        version: e.sdk.version
      }
    },
    ...!!r && !!n && { dsn: y1(n) }
  }, i = $X(t);
  return ll(A, [i]);
}
function $X(t) {
  return [{
    type: "user_report"
  }, t];
}
class eK extends MW {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(e) {
    const r = {
      // We default this to true, as it is the safer scenario
      parentSpanIsAlwaysRootSpan: !0,
      ...e
    }, n = $t.SENTRY_SDK_SOURCE || HX();
    QO(r, "browser", ["browser"], n), super(r), r.sendClientReports && $t.document && $t.document.addEventListener("visibilitychange", () => {
      $t.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(e, r) {
    return WX(this._options.stackParser, e, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(e, r = "info", n) {
    return XX(this._options.stackParser, e, r, n, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */
  captureUserFeedback(e) {
    if (!this._isEnabled()) {
      Zo && ft.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const r = _X(e, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this.sendEnvelope(r);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(e, r, n) {
    return e.platform = e.platform || "javascript", super._prepareEvent(e, r, n);
  }
}
const iv = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, tK = (t, e) => t > e[1] ? "poor" : t > e[0] ? "needs-improvement" : "good", xd = (t, e, r, n) => {
  let A, i;
  return (o) => {
    e.value >= 0 && (o || n) && (i = e.value - (A || 0), (i || A === void 0) && (A = e.value, e.delta = i, e.rating = tK(e.value, r), t(e)));
  };
}, Rt = qr, rK = () => `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, w1 = (t = !0) => {
  const e = Rt.performance && Rt.performance.getEntriesByType && Rt.performance.getEntriesByType("navigation")[0];
  if (
    // sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !t || e && e.responseStart > 0 && e.responseStart < performance.now()
  )
    return e;
}, b1 = () => {
  const t = w1();
  return t && t.activationStart || 0;
}, Id = (t, e) => {
  const r = w1();
  let n = "navigate";
  return r && (Rt.document && Rt.document.prerendering || b1() > 0 ? n = "prerender" : Rt.document && Rt.document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), {
    name: t,
    value: typeof e > "u" ? -1 : e,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: [],
    id: rK(),
    navigationType: n
  };
}, ul = (t, e, r) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      const n = new PerformanceObserver((A) => {
        Promise.resolve().then(() => {
          e(A.getEntries());
        });
      });
      return n.observe(
        Object.assign(
          {
            type: t,
            buffered: !0
          },
          r || {}
        )
      ), n;
    }
  } catch {
  }
}, Sd = (t) => {
  const e = (r) => {
    (r.type === "pagehide" || Rt.document && Rt.document.visibilityState === "hidden") && t(r);
  };
  Rt.document && (addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0));
}, Ug = (t) => {
  let e = !1;
  return () => {
    e || (t(), e = !0);
  };
};
let V0 = -1;
const nK = () => Rt.document.visibilityState === "hidden" && !Rt.document.prerendering ? 0 : 1 / 0, e3 = (t) => {
  Rt.document.visibilityState === "hidden" && V0 > -1 && (V0 = t.type === "visibilitychange" ? t.timeStamp : 0, iK());
}, AK = () => {
  addEventListener("visibilitychange", e3, !0), addEventListener("prerenderingchange", e3, !0);
}, iK = () => {
  removeEventListener("visibilitychange", e3, !0), removeEventListener("prerenderingchange", e3, !0);
}, Ng = () => (Rt.document && V0 < 0 && (V0 = nK(), AK()), {
  get firstHiddenTime() {
    return V0;
  }
}), B1 = (t) => {
  Rt.document && Rt.document.prerendering ? addEventListener("prerenderingchange", () => t(), !0) : t();
}, oK = [1800, 3e3], sK = (t, e = {}) => {
  B1(() => {
    const r = Ng(), n = Id("FCP");
    let A;
    const o = ul("paint", (s) => {
      s.forEach((a) => {
        a.name === "first-contentful-paint" && (o.disconnect(), a.startTime < r.firstHiddenTime && (n.value = Math.max(a.startTime - b1(), 0), n.entries.push(a), A(!0)));
      });
    });
    o && (A = xd(t, n, oK, e.reportAllChanges));
  });
}, aK = [0.1, 0.25], cK = (t, e = {}) => {
  sK(
    Ug(() => {
      const r = Id("CLS", 0);
      let n, A = 0, i = [];
      const o = (a) => {
        a.forEach((c) => {
          if (!c.hadRecentInput) {
            const l = i[0], u = i[i.length - 1];
            A && l && u && c.startTime - u.startTime < 1e3 && c.startTime - l.startTime < 5e3 ? (A += c.value, i.push(c)) : (A = c.value, i = [c]);
          }
        }), A > r.value && (r.value = A, r.entries = i, n());
      }, s = ul("layout-shift", o);
      s && (n = xd(t, r, aK, e.reportAllChanges), Sd(() => {
        o(s.takeRecords()), n(!0);
      }), setTimeout(n, 0));
    })
  );
}, lK = [100, 300], uK = (t, e = {}) => {
  B1(() => {
    const r = Ng(), n = Id("FID");
    let A;
    const i = (a) => {
      a.startTime < r.firstHiddenTime && (n.value = a.processingStart - a.startTime, n.entries.push(a), A(!0));
    }, o = (a) => {
      a.forEach(i);
    }, s = ul("first-input", o);
    A = xd(t, n, lK, e.reportAllChanges), s && Sd(
      Ug(() => {
        o(s.takeRecords()), s.disconnect();
      })
    );
  });
};
let XO = 0, k9 = 1 / 0, of = 0;
const dK = (t) => {
  t.forEach((e) => {
    e.interactionId && (k9 = Math.min(k9, e.interactionId), of = Math.max(of, e.interactionId), XO = of ? (of - k9) / 7 + 1 : 0);
  });
};
let O5;
const fK = () => O5 ? XO : performance.interactionCount || 0, hK = () => {
  "interactionCount" in performance || O5 || (O5 = ul("event", dK, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, fs = [], O9 = /* @__PURE__ */ new Map(), pK = 40;
let gK = 0;
const mK = () => fK() - gK, vK = () => {
  const t = Math.min(
    fs.length - 1,
    Math.floor(mK() / 50)
  );
  return fs[t];
}, F9 = 10, qK = [], yK = (t) => {
  if (qK.forEach((n) => n(t)), !(t.interactionId || t.entryType === "first-input")) return;
  const e = fs[fs.length - 1], r = O9.get(t.interactionId);
  if (r || fs.length < F9 || e && t.duration > e.latency) {
    if (r)
      t.duration > r.latency ? (r.entries = [t], r.latency = t.duration) : t.duration === r.latency && t.startTime === (r.entries[0] && r.entries[0].startTime) && r.entries.push(t);
    else {
      const n = {
        id: t.interactionId,
        latency: t.duration,
        entries: [t]
      };
      O9.set(n.id, n), fs.push(n);
    }
    fs.sort((n, A) => A.latency - n.latency), fs.length > F9 && fs.splice(F9).forEach((n) => O9.delete(n.id));
  }
}, KO = (t) => {
  const e = Rt.requestIdleCallback || Rt.setTimeout;
  let r = -1;
  return t = Ug(t), Rt.document && Rt.document.visibilityState === "hidden" ? t() : (r = e(t), Sd(t)), r;
}, CK = [200, 500], wK = (t, e = {}) => {
  "PerformanceEventTiming" in Rt && "interactionId" in PerformanceEventTiming.prototype && B1(() => {
    hK();
    const r = Id("INP");
    let n;
    const A = (o) => {
      KO(() => {
        o.forEach(yK);
        const s = vK();
        s && s.latency !== r.value && (r.value = s.latency, r.entries = s.entries, n());
      });
    }, i = ul("event", A, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: e.durationThreshold != null ? e.durationThreshold : pK
    });
    n = xd(t, r, CK, e.reportAllChanges), i && (i.observe({ type: "first-input", buffered: !0 }), Sd(() => {
      A(i.takeRecords()), n(!0);
    }));
  });
}, bK = [2500, 4e3], Iw = {}, BK = (t, e = {}) => {
  B1(() => {
    const r = Ng(), n = Id("LCP");
    let A;
    const i = (s) => {
      e.reportAllChanges || (s = s.slice(-1)), s.forEach((a) => {
        a.startTime < r.firstHiddenTime && (n.value = Math.max(a.startTime - b1(), 0), n.entries = [a], A());
      });
    }, o = ul("largest-contentful-paint", i);
    if (o) {
      A = xd(t, n, bK, e.reportAllChanges);
      const s = Ug(() => {
        Iw[n.id] || (i(o.takeRecords()), o.disconnect(), Iw[n.id] = !0, A(!0));
      });
      ["keydown", "click"].forEach((a) => {
        Rt.document && addEventListener(a, () => KO(s), {
          once: !0,
          capture: !0
        });
      }), Sd(s);
    }
  });
}, EK = [800, 1800], F5 = (t) => {
  Rt.document && Rt.document.prerendering ? B1(() => F5(t)) : Rt.document && Rt.document.readyState !== "complete" ? addEventListener("load", () => F5(t), !0) : setTimeout(t, 0);
}, xK = (t, e = {}) => {
  const r = Id("TTFB"), n = xd(t, r, EK, e.reportAllChanges);
  F5(() => {
    const A = w1();
    A && (r.value = Math.max(A.responseStart - b1(), 0), r.entries = [A], n(!0));
  });
}, W0 = {}, t3 = {};
let ZO, JO, _O, $O, eF;
function ov(t, e = !1) {
  return E1("cls", t, SK, ZO, e);
}
function tF(t, e = !1) {
  return E1("lcp", t, kK, _O, e);
}
function rF(t) {
  return E1("fid", t, PK, JO);
}
function IK(t) {
  return E1("ttfb", t, OK, $O);
}
function nF(t) {
  return E1("inp", t, FK, eF);
}
function Iu(t, e) {
  return AF(t, e), t3[t] || (TK(t), t3[t] = !0), iF(t, e);
}
function Pd(t, e) {
  const r = W0[t];
  if (!(!r || !r.length))
    for (const n of r)
      try {
        n(e);
      } catch (A) {
        iv && ft.error(
          `Error while triggering instrumentation handler.
Type: ${t}
Name: ${Ps(n)}
Error:`,
          A
        );
      }
}
function SK() {
  return cK(
    (t) => {
      Pd("cls", {
        metric: t
      }), ZO = t;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function PK() {
  return uK((t) => {
    Pd("fid", {
      metric: t
    }), JO = t;
  });
}
function kK() {
  return BK(
    (t) => {
      Pd("lcp", {
        metric: t
      }), _O = t;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function OK() {
  return xK((t) => {
    Pd("ttfb", {
      metric: t
    }), $O = t;
  });
}
function FK() {
  return wK((t) => {
    Pd("inp", {
      metric: t
    }), eF = t;
  });
}
function E1(t, e, r, n, A = !1) {
  AF(t, e);
  let i;
  return t3[t] || (i = r(), t3[t] = !0), n && e({ metric: n }), iF(t, e, A ? i : void 0);
}
function TK(t) {
  const e = {};
  t === "event" && (e.durationThreshold = 0), ul(
    t,
    (r) => {
      Pd(t, { entries: r });
    },
    e
  );
}
function AF(t, e) {
  W0[t] = W0[t] || [], W0[t].push(e);
}
function iF(t, e, r) {
  return () => {
    r && r();
    const n = W0[t];
    if (!n)
      return;
    const A = n.indexOf(e);
    A !== -1 && n.splice(A, 1);
  };
}
function MK(t) {
  return "duration" in t;
}
function T9(t) {
  return typeof t == "number" && isFinite(t);
}
function Ts(t, e, r, { ...n }) {
  const A = kr(t).start_timestamp;
  return A && A > e && typeof t.updateStartTime == "function" && t.updateStartTime(e), BO(t, () => {
    const i = C1({
      startTime: e,
      ...n
    });
    return i && i.end(r), i;
  });
}
function oF(t) {
  const e = mr();
  if (!e)
    return;
  const { name: r, transaction: n, attributes: A, startTime: i } = t, { release: o, environment: s } = e.getOptions(), a = e.getIntegrationByName("Replay"), c = a && a.getReplayId(), l = $r(), u = l.getUser(), f = u !== void 0 ? u.email || u.id || u.ip_address : void 0;
  let d;
  try {
    d = l.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const g = {
    release: o,
    environment: s,
    user: f || void 0,
    profile_id: d || void 0,
    replay_id: c || void 0,
    transaction: n,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": Rt.navigator && Rt.navigator.userAgent,
    ...A
  };
  return C1({
    name: r,
    attributes: g,
    startTime: i,
    experimental: {
      standalone: !0
    }
  });
}
function sv() {
  return Rt && Rt.addEventListener && Rt.performance;
}
function Bn(t) {
  return t / 1e3;
}
function sF(t) {
  let e = "unknown", r = "unknown", n = "";
  for (const A of t) {
    if (A === "/") {
      [e, r] = t.split("/");
      break;
    }
    if (!isNaN(Number(A))) {
      e = n === "h" ? "http" : n, r = t.split(n)[1];
      break;
    }
    n += A;
  }
  return n === t && (e = n), { name: e, version: r };
}
function HK() {
  let t = 0, e, r;
  if (!QK())
    return;
  let n = !1;
  function A() {
    n || (n = !0, r && DK(t, e, r), i());
  }
  const i = ov(({ metric: o }) => {
    const s = o.entries[o.entries.length - 1];
    s && (t = o.value, e = s);
  }, !0);
  Sd(() => {
    A();
  }), setTimeout(() => {
    const o = mr();
    if (!o)
      return;
    const s = o.on("startNavigationSpan", () => {
      A(), s && s();
    }), a = aA(), c = a && wA(a), l = c && kr(c);
    l && l.op === "pageload" && (r = c.spanContext().spanId);
  }, 0);
}
function DK(t, e, r) {
  iv && ft.log(`Sending CLS span (${t})`);
  const n = Bn((ZA || 0) + (e && e.startTime || 0)), A = $r().getScopeData().transactionName, i = e ? Os(e.sources[0] && e.sources[0].node) : "Layout shift", o = _n({
    [sA]: "auto.http.browser.cls",
    [Zc]: "ui.webvital.cls",
    [Zm]: e && e.duration || 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": r
  }), s = oF({
    name: i,
    transaction: A,
    attributes: o,
    startTime: n
  });
  s && (s.addEvent("cls", {
    [Dg]: "",
    [Qg]: t
  }), s.end(n));
}
function QK() {
  try {
    return PerformanceObserver.supportedEntryTypes.includes("layout-shift");
  } catch {
    return !1;
  }
}
const UK = 2147483647;
let Sw = 0, gA = {}, ti, X0;
function NK({ recordClsStandaloneSpans: t }) {
  const e = sv();
  if (e && ZA) {
    e.mark && Rt.performance.mark("sentry-tracing-init");
    const r = YK(), n = zK(), A = VK(), i = t ? HK() : RK();
    return () => {
      r(), n(), A(), i && i();
    };
  }
  return () => {
  };
}
function jK() {
  Iu("longtask", ({ entries: t }) => {
    const e = aA();
    if (!e)
      return;
    const { op: r, start_timestamp: n } = kr(e);
    for (const A of t) {
      const i = Bn(ZA + A.startTime), o = Bn(A.duration);
      r === "navigation" && n && i < n || Ts(e, i, i + o, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [sA]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function LK() {
  new PerformanceObserver((e) => {
    const r = aA();
    if (r)
      for (const n of e.getEntries()) {
        if (!n.scripts[0])
          continue;
        const A = Bn(ZA + n.startTime), { start_timestamp: i, op: o } = kr(r);
        if (o === "navigation" && i && A < i)
          continue;
        const s = Bn(n.duration), a = {
          [sA]: "auto.ui.browser.metrics"
        }, c = n.scripts[0], { invoker: l, invokerType: u, sourceURL: f, sourceFunctionName: d, sourceCharPosition: g } = c;
        a["browser.script.invoker"] = l, a["browser.script.invoker_type"] = u, f && (a["code.filepath"] = f), d && (a["code.function"] = d), g !== -1 && (a["browser.script.source_char_position"] = g), Ts(r, A, A + s, {
          name: "Main UI thread blocked",
          op: "ui.long-animation-frame",
          attributes: a
        });
      }
  }).observe({ type: "long-animation-frame", buffered: !0 });
}
function GK() {
  Iu("event", ({ entries: t }) => {
    const e = aA();
    if (e) {
      for (const r of t)
        if (r.name === "click") {
          const n = Bn(ZA + r.startTime), A = Bn(r.duration), i = {
            name: Os(r.target),
            op: `ui.interaction.${r.name}`,
            startTime: n,
            attributes: {
              [sA]: "auto.ui.browser.metrics"
            }
          }, o = $k(r.target);
          o && (i.attributes["ui.component_name"] = o), Ts(e, n, n + A, i);
        }
    }
  });
}
function RK() {
  return ov(({ metric: t }) => {
    const e = t.entries[t.entries.length - 1];
    e && (gA.cls = { value: t.value, unit: "" }, X0 = e);
  }, !0);
}
function zK() {
  return tF(({ metric: t }) => {
    const e = t.entries[t.entries.length - 1];
    e && (gA.lcp = { value: t.value, unit: "millisecond" }, ti = e);
  }, !0);
}
function YK() {
  return rF(({ metric: t }) => {
    const e = t.entries[t.entries.length - 1];
    if (!e)
      return;
    const r = Bn(ZA), n = Bn(e.startTime);
    gA.fid = { value: t.value, unit: "millisecond" }, gA["mark.fid"] = { value: r + n, unit: "second" };
  });
}
function VK() {
  return IK(({ metric: t }) => {
    t.entries[t.entries.length - 1] && (gA.ttfb = { value: t.value, unit: "millisecond" });
  });
}
function WK(t, e) {
  const r = sv();
  if (!r || !r.getEntries || !ZA)
    return;
  const n = Bn(ZA), A = r.getEntries(), { op: i, start_timestamp: o } = kr(t);
  if (A.slice(Sw).forEach((s) => {
    const a = Bn(s.startTime), c = Bn(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, s.duration)
    );
    if (!(i === "navigation" && o && n + a < o))
      switch (s.entryType) {
        case "navigation": {
          KK(t, s, n);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          XK(t, s, a, c, n);
          const l = Ng(), u = s.startTime < l.firstHiddenTime;
          s.name === "first-paint" && u && (gA.fp = { value: s.startTime, unit: "millisecond" }), s.name === "first-contentful-paint" && u && (gA.fcp = { value: s.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          _K(t, s, s.name, a, c, n);
          break;
        }
      }
  }), Sw = Math.max(A.length - 1, 0), $K(t), i === "pageload") {
    tZ(gA);
    const s = gA["mark.fid"];
    s && gA.fid && (Ts(t, s.value, s.value + Bn(gA.fid.value), {
      name: "first input delay",
      op: "ui.action",
      attributes: {
        [sA]: "auto.ui.browser.metrics"
      }
    }), delete gA["mark.fid"]), (!("fcp" in gA) || !e.recordClsOnPageloadSpan) && delete gA.cls, Object.entries(gA).forEach(([a, c]) => {
      _V(a, c.value, c.unit);
    }), t.setAttribute("performance.timeOrigin", n), t.setAttribute("performance.activationStart", b1()), eZ(t);
  }
  ti = void 0, X0 = void 0, gA = {};
}
function XK(t, e, r, n, A) {
  const i = w1(!1), o = Bn(i ? i.requestStart : 0), s = A + Math.max(r, o), a = A + r, c = a + n, l = {
    [sA]: "auto.resource.browser.metrics"
  };
  return s !== a && (l["sentry.browser.measure_happened_before_request"] = !0, l["sentry.browser.measure_start_time"] = s), Ts(t, s, c, {
    name: e.name,
    op: e.entryType,
    attributes: l
  }), s;
}
function KK(t, e, r) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((n) => {
    sf(t, e, n, r);
  }), sf(t, e, "secureConnection", r, "TLS/SSL"), sf(t, e, "fetch", r, "cache"), sf(t, e, "domainLookup", r, "DNS"), JK(t, e, r);
}
function sf(t, e, r, n, A = r) {
  const i = ZK(r), o = e[i], s = e[`${r}Start`];
  !s || !o || Ts(t, n + Bn(s), n + Bn(o), {
    op: `browser.${A}`,
    name: e.name,
    attributes: {
      [sA]: "auto.ui.browser.metrics"
    }
  });
}
function ZK(t) {
  return t === "secureConnection" ? "connectEnd" : t === "fetch" ? "domainLookupStart" : `${t}End`;
}
function JK(t, e, r) {
  const n = r + Bn(e.requestStart), A = r + Bn(e.responseEnd), i = r + Bn(e.responseStart);
  e.responseEnd && (Ts(t, n, A, {
    op: "browser.request",
    name: e.name,
    attributes: {
      [sA]: "auto.ui.browser.metrics"
    }
  }), Ts(t, i, A, {
    op: "browser.response",
    name: e.name,
    attributes: {
      [sA]: "auto.ui.browser.metrics"
    }
  }));
}
function _K(t, e, r, n, A, i) {
  if (e.initiatorType === "xmlhttprequest" || e.initiatorType === "fetch")
    return;
  const o = Uc(r), s = {
    [sA]: "auto.resource.browser.metrics"
  };
  M9(s, e, "transferSize", "http.response_transfer_size"), M9(s, e, "encodedBodySize", "http.response_content_length"), M9(s, e, "decodedBodySize", "http.decoded_response_content_length");
  const a = e.deliveryType;
  a != null && (s["http.response_delivery_type"] = a);
  const c = e.renderBlockingStatus;
  c && (s["resource.render_blocking_status"] = c), o.protocol && (s["url.scheme"] = o.protocol.split(":").pop()), o.host && (s["server.address"] = o.host), s["url.same_origin"] = r.includes(Rt.location.origin);
  const { name: l, version: u } = sF(e.nextHopProtocol);
  s["network.protocol.name"] = l, s["network.protocol.version"] = u;
  const f = i + n, d = f + A;
  Ts(t, f, d, {
    name: r.replace(Rt.location.origin, ""),
    op: e.initiatorType ? `resource.${e.initiatorType}` : "resource.other",
    attributes: s
  });
}
function $K(t) {
  const e = Rt.navigator;
  if (!e)
    return;
  const r = e.connection;
  r && (r.effectiveType && t.setAttribute("effectiveConnectionType", r.effectiveType), r.type && t.setAttribute("connectionType", r.type), T9(r.rtt) && (gA["connection.rtt"] = { value: r.rtt, unit: "millisecond" })), T9(e.deviceMemory) && t.setAttribute("deviceMemory", `${e.deviceMemory} GB`), T9(e.hardwareConcurrency) && t.setAttribute("hardwareConcurrency", String(e.hardwareConcurrency));
}
function eZ(t) {
  ti && (ti.element && t.setAttribute("lcp.element", Os(ti.element)), ti.id && t.setAttribute("lcp.id", ti.id), ti.url && t.setAttribute("lcp.url", ti.url.trim().slice(0, 200)), ti.loadTime != null && t.setAttribute("lcp.loadTime", ti.loadTime), ti.renderTime != null && t.setAttribute("lcp.renderTime", ti.renderTime), t.setAttribute("lcp.size", ti.size)), X0 && X0.sources && X0.sources.forEach(
    (e, r) => t.setAttribute(`cls.source.${r + 1}`, Os(e.node))
  );
}
function M9(t, e, r, n) {
  const A = e[r];
  A != null && A < UK && (t[n] = A);
}
function tZ(t) {
  const e = w1(!1);
  if (!e)
    return;
  const { responseStart: r, requestStart: n } = e;
  n <= r && (t["ttfb.requestTime"] = {
    value: r - n,
    unit: "millisecond"
  });
}
const rZ = 1e3;
let Pw, T5, M5;
function aF(t) {
  const e = "dom";
  _a(e, t), $a(e, nZ);
}
function nZ() {
  if (!Rt.document)
    return;
  const t = ji.bind(null, "dom"), e = kw(t, !0);
  Rt.document.addEventListener("click", e, !1), Rt.document.addEventListener("keypress", e, !1), ["EventTarget", "Node"].forEach((r) => {
    const A = Rt[r], i = A && A.prototype;
    !i || !i.hasOwnProperty || !i.hasOwnProperty("addEventListener") || (Ai(i, "addEventListener", function(o) {
      return function(s, a, c) {
        if (s === "click" || s == "keypress")
          try {
            const l = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, u = l[s] = l[s] || { refCount: 0 };
            if (!u.handler) {
              const f = kw(t);
              u.handler = f, o.call(this, s, f, c);
            }
            u.refCount++;
          } catch {
          }
        return o.call(this, s, a, c);
      };
    }), Ai(
      i,
      "removeEventListener",
      function(o) {
        return function(s, a, c) {
          if (s === "click" || s == "keypress")
            try {
              const l = this.__sentry_instrumentation_handlers__ || {}, u = l[s];
              u && (u.refCount--, u.refCount <= 0 && (o.call(this, s, u.handler, c), u.handler = void 0, delete l[s]), Object.keys(l).length === 0 && delete this.__sentry_instrumentation_handlers__);
            } catch {
            }
          return o.call(this, s, a, c);
        };
      }
    ));
  });
}
function AZ(t) {
  if (t.type !== T5)
    return !1;
  try {
    if (!t.target || t.target._sentryId !== M5)
      return !1;
  } catch {
  }
  return !0;
}
function iZ(t, e) {
  return t !== "keypress" ? !1 : !e || !e.tagName ? !0 : !(e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable);
}
function kw(t, e = !1) {
  return (r) => {
    if (!r || r._sentryCaptured)
      return;
    const n = oZ(r);
    if (iZ(r.type, n))
      return;
    Yi(r, "_sentryCaptured", !0), n && !n._sentryId && Yi(n, "_sentryId", Ci());
    const A = r.type === "keypress" ? "input" : r.type;
    AZ(r) || (t({ event: r, name: A, global: e }), T5 = r.type, M5 = n ? n._sentryId : void 0), clearTimeout(Pw), Pw = Rt.setTimeout(() => {
      M5 = void 0, T5 = void 0;
    }, rZ);
  };
}
function oZ(t) {
  try {
    return t.target;
  } catch {
    return null;
  }
}
let af;
function jg(t) {
  const e = "history";
  _a(e, t), $a(e, sZ);
}
function sZ() {
  if (!UX())
    return;
  const t = Rt.onpopstate;
  Rt.onpopstate = function(...r) {
    const n = Rt.location.href, A = af;
    if (af = n, ji("history", { from: A, to: n }), t)
      try {
        return t.apply(this, r);
      } catch {
      }
  };
  function e(r) {
    return function(...n) {
      const A = n.length > 2 ? n[2] : void 0;
      if (A) {
        const i = af, o = String(A);
        af = o, ji("history", { from: i, to: o });
      }
      return r.apply(this, n);
    };
  }
  Ai(Rt.history, "pushState", e), Ai(Rt.history, "replaceState", e);
}
const mh = {};
function cF(t) {
  const e = mh[t];
  if (e)
    return e;
  let r = Rt[t];
  if (I5(r))
    return mh[t] = r.bind(Rt);
  const n = Rt.document;
  if (n && typeof n.createElement == "function")
    try {
      const A = n.createElement("iframe");
      A.hidden = !0, n.head.appendChild(A);
      const i = A.contentWindow;
      i && i[t] && (r = i[t]), n.head.removeChild(A);
    } catch (A) {
      iv && ft.warn(`Could not create sandbox iframe for ${t} check, bailing to window.${t}: `, A);
    }
  return r && (mh[t] = r.bind(Rt));
}
function Ow(t) {
  mh[t] = void 0;
}
function Su(...t) {
  return cF("setTimeout")(...t);
}
const yc = "__sentry_xhr_v3__";
function lF(t) {
  const e = "xhr";
  _a(e, t), $a(e, aZ);
}
function aZ() {
  if (!Rt.XMLHttpRequest)
    return;
  const t = XMLHttpRequest.prototype;
  t.open = new Proxy(t.open, {
    apply(e, r, n) {
      const A = new Error(), i = KA() * 1e3, o = ys(n[0]) ? n[0].toUpperCase() : void 0, s = cZ(n[1]);
      if (!o || !s)
        return e.apply(r, n);
      r[yc] = {
        method: o,
        url: s,
        request_headers: {}
      }, o === "POST" && s.match(/sentry_key/) && (r.__sentry_own_request__ = !0);
      const a = () => {
        const c = r[yc];
        if (c && r.readyState === 4) {
          try {
            c.status_code = r.status;
          } catch {
          }
          const l = {
            endTimestamp: KA() * 1e3,
            startTimestamp: i,
            xhr: r,
            virtualError: A
          };
          ji("xhr", l);
        }
      };
      return "onreadystatechange" in r && typeof r.onreadystatechange == "function" ? r.onreadystatechange = new Proxy(r.onreadystatechange, {
        apply(c, l, u) {
          return a(), c.apply(l, u);
        }
      }) : r.addEventListener("readystatechange", a), r.setRequestHeader = new Proxy(r.setRequestHeader, {
        apply(c, l, u) {
          const [f, d] = u, g = l[yc];
          return g && ys(f) && ys(d) && (g.request_headers[f.toLowerCase()] = d), c.apply(l, u);
        }
      }), e.apply(r, n);
    }
  }), t.send = new Proxy(t.send, {
    apply(e, r, n) {
      const A = r[yc];
      if (!A)
        return e.apply(r, n);
      n[0] !== void 0 && (A.body = n[0]);
      const i = {
        startTimestamp: KA() * 1e3,
        xhr: r
      };
      return ji("xhr", i), e.apply(r, n);
    }
  });
}
function cZ(t) {
  if (ys(t))
    return t;
  try {
    return t.toString();
  } catch {
  }
}
const H9 = [], vh = /* @__PURE__ */ new Map();
function lZ() {
  if (sv() && ZA) {
    const e = uZ();
    return () => {
      e();
    };
  }
  return () => {
  };
}
const Fw = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function uZ() {
  return nF(({ metric: t }) => {
    if (t.value == null)
      return;
    const e = t.entries.find((g) => g.duration === t.value && Fw[g.name]);
    if (!e)
      return;
    const { interactionId: r } = e, n = Fw[e.name], A = Bn(ZA + e.startTime), i = Bn(t.value), o = aA(), s = o ? wA(o) : void 0, c = (r != null ? vh.get(r) : void 0) || s, l = c ? kr(c).description : $r().getScopeData().transactionName, u = Os(e.target), f = _n({
      [sA]: "auto.http.browser.inp",
      [Zc]: `ui.interaction.${n}`,
      [Zm]: e.duration
    }), d = oF({
      name: u,
      transaction: l,
      attributes: f,
      startTime: A
    });
    d && (d.addEvent("inp", {
      [Dg]: "millisecond",
      [Qg]: t.value
    }), d.end(A + i));
  });
}
function dZ(t) {
  const e = ({ entries: r }) => {
    const n = aA(), A = n && wA(n);
    r.forEach((i) => {
      if (!MK(i) || !A)
        return;
      const o = i.interactionId;
      if (o != null && !vh.has(o)) {
        if (H9.length > 10) {
          const s = H9.shift();
          vh.delete(s);
        }
        H9.push(o), vh.set(o, A);
      }
    });
  };
  Iu("event", e), Iu("first-input", e);
}
function fZ(t, e = cF("fetch")) {
  let r = 0, n = 0;
  function A(i) {
    const o = i.body.length;
    r += o, n++;
    const s = {
      body: i.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: t.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: r <= 6e4 && n < 15,
      ...t.fetchOptions
    };
    if (!e)
      return Ow("fetch"), Zh("No fetch implementation available");
    try {
      return e(t.url, s).then((a) => (r -= o, n--, {
        statusCode: a.status,
        headers: {
          "x-sentry-rate-limits": a.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": a.headers.get("Retry-After")
        }
      }));
    } catch (a) {
      return Ow("fetch"), r -= o, n--, Zh(a);
    }
  }
  return zW(t, A);
}
const hZ = 30, pZ = 50;
function H5(t, e, r, n) {
  const A = {
    filename: t,
    function: e === "<anonymous>" ? Xc : e,
    in_app: !0
    // All browser frames are considered in_app
  };
  return r !== void 0 && (A.lineno = r), n !== void 0 && (A.colno = n), A;
}
const gZ = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, mZ = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, vZ = /\((\S*)(?::(\d+))(?::(\d+))\)/, qZ = (t) => {
  const e = gZ.exec(t);
  if (e) {
    const [, n, A, i] = e;
    return H5(n, Xc, +A, +i);
  }
  const r = mZ.exec(t);
  if (r) {
    if (r[2] && r[2].indexOf("eval") === 0) {
      const o = vZ.exec(r[2]);
      o && (r[2] = o[1], r[3] = o[2], r[4] = o[3]);
    }
    const [A, i] = uF(r[1] || Xc, r[2]);
    return H5(i, A, r[3] ? +r[3] : void 0, r[4] ? +r[4] : void 0);
  }
}, yZ = [hZ, qZ], CZ = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, wZ = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, bZ = (t) => {
  const e = CZ.exec(t);
  if (e) {
    if (e[3] && e[3].indexOf(" > eval") > -1) {
      const i = wZ.exec(e[3]);
      i && (e[1] = e[1] || "eval", e[3] = i[1], e[4] = i[2], e[5] = "");
    }
    let n = e[3], A = e[1] || Xc;
    return [A, n] = uF(A, n), H5(n, A, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
  }
}, BZ = [pZ, bZ], EZ = [yZ, BZ], xZ = Vk(...EZ), uF = (t, e) => {
  const r = t.indexOf("safari-extension") !== -1, n = t.indexOf("safari-web-extension") !== -1;
  return r || n ? [
    t.indexOf("@") !== -1 ? t.split("@")[0] : Xc,
    r ? `safari-extension:${e}` : `safari-web-extension:${e}`
  ] : [t, e];
}, cf = 1024, IZ = "Breadcrumbs", SZ = (t = {}) => {
  const e = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...t
  };
  return {
    name: IZ,
    setup(r) {
      e.console && pX(FZ(r)), e.dom && aF(OZ(r, e.dom)), e.xhr && lF(TZ(r)), e.fetch && zO(MZ(r)), e.history && jg(HZ(r)), e.sentry && r.on("beforeSendEvent", kZ(r));
    }
  };
}, PZ = SZ;
function kZ(t) {
  return function(r) {
    mr() === t && ja(
      {
        category: `sentry.${r.type === "transaction" ? "transaction" : "event"}`,
        event_id: r.event_id,
        level: r.level,
        message: ca(r)
      },
      {
        event: r
      }
    );
  };
}
function OZ(t, e) {
  return function(n) {
    if (mr() !== t)
      return;
    let A, i, o = typeof e == "object" ? e.serializeAttribute : void 0, s = typeof e == "object" && typeof e.maxStringLength == "number" ? e.maxStringLength : void 0;
    s && s > cf && (Zo && ft.warn(
      `\`dom.maxStringLength\` cannot exceed ${cf}, but a value of ${s} was configured. Sentry will use ${cf} instead.`
    ), s = cf), typeof o == "string" && (o = [o]);
    try {
      const c = n.event, l = DZ(c) ? c.target : c;
      A = Os(l, { keyAttrs: o, maxStringLength: s }), i = $k(l);
    } catch {
      A = "<unknown>";
    }
    if (A.length === 0)
      return;
    const a = {
      category: `ui.${n.name}`,
      message: A
    };
    i && (a.data = { "ui.component_name": i }), ja(a, {
      event: n.event,
      name: n.name,
      global: n.global
    });
  };
}
function FZ(t) {
  return function(r) {
    if (mr() !== t)
      return;
    const n = {
      category: "console",
      data: {
        arguments: r.args,
        logger: "console"
      },
      level: NO(r.level),
      message: VC(r.args, " ")
    };
    if (r.level === "assert")
      if (r.args[0] === !1)
        n.message = `Assertion failed: ${VC(r.args.slice(1), " ") || "console.assert"}`, n.data.arguments = r.args.slice(1);
      else
        return;
    ja(n, {
      input: r.args,
      level: r.level
    });
  };
}
function TZ(t) {
  return function(r) {
    if (mr() !== t)
      return;
    const { startTimestamp: n, endTimestamp: A } = r, i = r.xhr[yc];
    if (!n || !A || !i)
      return;
    const { method: o, url: s, status_code: a, body: c } = i, l = {
      method: o,
      url: s,
      status_code: a
    }, u = {
      xhr: r.xhr,
      input: c,
      startTimestamp: n,
      endTimestamp: A
    }, f = GO(a);
    ja(
      {
        category: "xhr",
        data: l,
        type: "http",
        level: f
      },
      u
    );
  };
}
function MZ(t) {
  return function(r) {
    if (mr() !== t)
      return;
    const { startTimestamp: n, endTimestamp: A } = r;
    if (A && !(r.fetchData.url.match(/sentry_key/) && r.fetchData.method === "POST"))
      if (r.error) {
        const i = r.fetchData, o = {
          data: r.error,
          input: r.args,
          startTimestamp: n,
          endTimestamp: A
        };
        ja(
          {
            category: "fetch",
            data: i,
            level: "error",
            type: "http"
          },
          o
        );
      } else {
        const i = r.response, o = {
          ...r.fetchData,
          status_code: i && i.status
        }, s = {
          input: r.args,
          response: i,
          startTimestamp: n,
          endTimestamp: A
        }, a = GO(o.status_code);
        ja(
          {
            category: "fetch",
            data: o,
            type: "http",
            level: a
          },
          s
        );
      }
  };
}
function HZ(t) {
  return function(r) {
    if (mr() !== t)
      return;
    let n = r.from, A = r.to;
    const i = Uc($t.location.href);
    let o = n ? Uc(n) : void 0;
    const s = Uc(A);
    (!o || !o.path) && (o = i), i.protocol === s.protocol && i.host === s.host && (A = s.relative), i.protocol === o.protocol && i.host === o.host && (n = o.relative), ja({
      category: "navigation",
      data: {
        from: n,
        to: A
      }
    });
  };
}
function DZ(t) {
  return !!t && !!t.target;
}
const QZ = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], UZ = "BrowserApiErrors", NZ = (t = {}) => {
  const e = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    ...t
  };
  return {
    name: UZ,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      e.setTimeout && Ai($t, "setTimeout", Tw), e.setInterval && Ai($t, "setInterval", Tw), e.requestAnimationFrame && Ai($t, "requestAnimationFrame", LZ), e.XMLHttpRequest && "XMLHttpRequest" in $t && Ai(XMLHttpRequest.prototype, "send", GZ);
      const r = e.eventTarget;
      r && (Array.isArray(r) ? r : QZ).forEach(RZ);
    }
  };
}, jZ = NZ;
function Tw(t) {
  return function(...e) {
    const r = e[0];
    return e[0] = xu(r, {
      mechanism: {
        data: { function: Ps(t) },
        handled: !1,
        type: "instrument"
      }
    }), t.apply(this, e);
  };
}
function LZ(t) {
  return function(e) {
    return t.apply(this, [
      xu(e, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: Ps(t)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function GZ(t) {
  return function(...e) {
    const r = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((A) => {
      A in r && typeof r[A] == "function" && Ai(r, A, function(i) {
        const o = {
          mechanism: {
            data: {
              function: A,
              handler: Ps(i)
            },
            handled: !1,
            type: "instrument"
          }
        }, s = Wm(i);
        return s && (o.mechanism.data.handler = Ps(s)), xu(i, o);
      });
    }), t.apply(this, e);
  };
}
function RZ(t) {
  const r = $t[t], n = r && r.prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (Ai(n, "addEventListener", function(A) {
    return function(i, o, s) {
      try {
        zZ(o) && (o.handleEvent = xu(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: Ps(o),
              target: t
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return A.apply(this, [
        i,
        xu(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: Ps(o),
              target: t
            },
            handled: !1,
            type: "instrument"
          }
        }),
        s
      ]);
    };
  }), Ai(n, "removeEventListener", function(A) {
    return function(i, o, s) {
      try {
        const a = o.__sentry_wrapped__;
        a && A.call(this, i, a, s);
      } catch {
      }
      return A.call(this, i, o, s);
    };
  }));
}
function zZ(t) {
  return typeof t.handleEvent == "function";
}
const YZ = () => ({
  name: "BrowserSession",
  setupOnce() {
    if (typeof $t.document > "u") {
      Zo && ft.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
      return;
    }
    fw({ ignoreDuration: !0 }), hw(), jg(({ from: t, to: e }) => {
      t !== void 0 && t !== e && (fw({ ignoreDuration: !0 }), hw());
    });
  }
}), VZ = "GlobalHandlers", WZ = (t = {}) => {
  const e = {
    onerror: !0,
    onunhandledrejection: !0,
    ...t
  };
  return {
    name: VZ,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(r) {
      e.onerror && (KZ(r), Mw("onerror")), e.onunhandledrejection && (ZZ(r), Mw("onunhandledrejection"));
    }
  };
}, XZ = WZ;
function KZ(t) {
  Wk((e) => {
    const { stackParser: r, attachStacktrace: n } = dF();
    if (mr() !== t || VO())
      return;
    const { msg: A, url: i, line: o, column: s, error: a } = e, c = $Z(
      Av(r, a || A, void 0, n, !1),
      i,
      o,
      s
    );
    c.level = "error", SO(c, {
      originalException: a,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function ZZ(t) {
  Xk((e) => {
    const { stackParser: r, attachStacktrace: n } = dF();
    if (mr() !== t || VO())
      return;
    const A = JZ(e), i = Vm(A) ? _Z(A) : Av(r, A, void 0, n, !0);
    i.level = "error", SO(i, {
      originalException: A,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function JZ(t) {
  if (Vm(t))
    return t;
  try {
    if ("reason" in t)
      return t.reason;
    if ("detail" in t && "reason" in t.detail)
      return t.detail.reason;
  } catch {
  }
  return t;
}
function _Z(t) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(t)}`
        }
      ]
    }
  };
}
function $Z(t, e, r, n) {
  const A = t.exception = t.exception || {}, i = A.values = A.values || [], o = i[0] = i[0] || {}, s = o.stacktrace = o.stacktrace || {}, a = s.frames = s.frames || [], c = n, l = r, u = ys(e) && e.length > 0 ? e : _k();
  return a.length === 0 && a.push({
    colno: c,
    filename: u,
    function: Xc,
    in_app: !0,
    lineno: l
  }), t;
}
function Mw(t) {
  Zo && ft.log(`Global Handler attached: ${t}`);
}
function dF() {
  const t = mr();
  return t && t.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const eJ = () => ({
  name: "HttpContext",
  preprocessEvent(t) {
    if (!$t.navigator && !$t.location && !$t.document)
      return;
    const e = t.request && t.request.url || $t.location && $t.location.href, { referrer: r } = $t.document || {}, { userAgent: n } = $t.navigator || {}, A = {
      ...t.request && t.request.headers,
      ...r && { Referer: r },
      ...n && { "User-Agent": n }
    }, i = { ...t.request, ...e && { url: e }, headers: A };
    t.request = i;
  }
}), tJ = "cause", rJ = 5, nJ = "LinkedErrors", AJ = (t = {}) => {
  const e = t.limit || rJ, r = t.key || tJ;
  return {
    name: nJ,
    preprocessEvent(n, A, i) {
      const o = i.getOptions();
      fX(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        rv,
        o.stackParser,
        o.maxValueLength,
        r,
        e,
        n,
        A
      );
    }
  };
}, iJ = AJ;
function oJ(t) {
  const e = [
    rX(),
    _W(),
    jZ(),
    PZ(),
    XZ(),
    iJ(),
    qX(),
    eJ()
  ];
  return t.autoSessionTracking !== !1 && e.push(YZ()), e;
}
function sJ(t = {}) {
  const e = {
    defaultIntegrations: oJ(t),
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : $t.SENTRY_RELEASE && $t.SENTRY_RELEASE.id ? $t.SENTRY_RELEASE.id : void 0,
    autoSessionTracking: !0,
    sendClientReports: !0
  };
  return t.defaultIntegrations == null && delete t.defaultIntegrations, { ...e, ...t };
}
function aJ() {
  const t = typeof $t.window < "u" && $t;
  if (!t)
    return !1;
  const e = t.chrome ? "chrome" : "browser", r = t[e], n = r && r.runtime && r.runtime.id, A = $t.location && $t.location.href || "", i = ["chrome-extension:", "moz-extension:", "ms-browser-extension:", "safari-web-extension:"], o = !!n && $t === $t.top && i.some((a) => A.startsWith(`${a}//`)), s = typeof t.nw < "u";
  return !!n && !o && !s;
}
function cJ(t = {}) {
  const e = sJ(t);
  if (!e.skipBrowserExtensionCheck && aJ()) {
    Ja(() => {
      console.error(
        "[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
      );
    });
    return;
  }
  Zo && (RO() || ft.warn(
    "No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill."
  ));
  const r = {
    ...e,
    stackParser: DY(e.stackParser || xZ),
    integrations: OW(e),
    transport: e.transport || fZ
  };
  return QW(eK, r);
}
const Kr = qr, av = "sentryReplaySession", lJ = "replay_event", cv = "Unable to send Replay", uJ = 3e5, dJ = 9e5, fJ = 5e3, hJ = 5500, pJ = 6e4, gJ = 5e3, mJ = 3, Hw = 15e4, lf = 5e3, vJ = 3e3, qJ = 300, lv = 2e7, yJ = 4999, CJ = 15e3, Dw = 36e5;
function D5(t, e) {
  return t ?? e();
}
function v2(t) {
  let e, r = t[0], n = 1;
  for (; n < t.length; ) {
    const A = t[n], i = t[n + 1];
    if (n += 2, (A === "optionalAccess" || A === "optionalCall") && r == null)
      return;
    A === "access" || A === "optionalAccess" ? (e = r, r = i(r)) : (A === "call" || A === "optionalCall") && (r = i((...o) => r.call(e, ...o)), e = void 0);
  }
  return r;
}
var Xn;
(function(t) {
  t[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
})(Xn || (Xn = {}));
function wJ(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function K0(t) {
  const e = v2([t, "optionalAccess", (r) => r.host]);
  return v2([e, "optionalAccess", (r) => r.shadowRoot]) === t;
}
function Z0(t) {
  return Object.prototype.toString.call(t) === "[object ShadowRoot]";
}
function bJ(t) {
  return t.includes(" background-clip: text;") && !t.includes(" -webkit-background-clip: text;") && (t = t.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;")), t;
}
function BJ(t) {
  const { cssText: e } = t;
  if (e.split('"').length < 3)
    return e;
  const r = ["@import", `url(${JSON.stringify(t.href)})`];
  return t.layerName === "" ? r.push("layer") : t.layerName && r.push(`layer(${t.layerName})`), t.supportsText && r.push(`supports(${t.supportsText})`), t.media.length && r.push(t.media.mediaText), r.join(" ") + ";";
}
function r3(t) {
  try {
    const e = t.rules || t.cssRules;
    return e ? bJ(Array.from(e, fF).join("")) : null;
  } catch {
    return null;
  }
}
function EJ(t) {
  let e = "";
  for (let r = 0; r < t.style.length; r++) {
    const n = t.style, A = n[r], i = n.getPropertyPriority(A);
    e += `${A}:${n.getPropertyValue(A)}${i ? " !important" : ""};`;
  }
  return `${t.selectorText} { ${e} }`;
}
function fF(t) {
  let e;
  if (IJ(t))
    try {
      e = r3(t.styleSheet) || BJ(t);
    } catch {
    }
  else if (SJ(t)) {
    let r = t.cssText;
    const n = t.selectorText.includes(":"), A = typeof t.style.all == "string" && t.style.all;
    if (A && (r = EJ(t)), n && (r = xJ(r)), n || A)
      return r;
  }
  return e || t.cssText;
}
function xJ(t) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return t.replace(e, "$1\\$2");
}
function IJ(t) {
  return "styleSheet" in t;
}
function SJ(t) {
  return "selectorText" in t;
}
class hF {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(e) {
    if (!e)
      return -1;
    const r = v2([this, "access", (n) => n.getMeta, "call", (n) => n(e), "optionalAccess", (n) => n.id]);
    return D5(r, () => -1);
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  removeNodeFromMap(e) {
    const r = this.getId(e);
    this.idNodeMap.delete(r), e.childNodes && e.childNodes.forEach((n) => this.removeNodeFromMap(n));
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, r) {
    const n = r.id;
    this.idNodeMap.set(n, e), this.nodeMetaMap.set(e, r);
  }
  replace(e, r) {
    const n = this.getNode(e);
    if (n) {
      const A = this.nodeMetaMap.get(n);
      A && this.nodeMetaMap.set(r, A);
    }
    this.idNodeMap.set(e, r);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function PJ() {
  return new hF();
}
function Lg({ maskInputOptions: t, tagName: e, type: r }) {
  return e === "OPTION" && (e = "SELECT"), !!(t[e.toLowerCase()] || r && t[r] || r === "password" || e === "INPUT" && !r && t.text);
}
function q2({ isMasked: t, element: e, value: r, maskInputFn: n }) {
  let A = r || "";
  return t ? (n && (A = n(A, e)), "*".repeat(A.length)) : A;
}
function Pu(t) {
  return t.toLowerCase();
}
function Q5(t) {
  return t.toUpperCase();
}
const Qw = "__rrweb_original__";
function kJ(t) {
  const e = t.getContext("2d");
  if (!e)
    return !0;
  const r = 50;
  for (let n = 0; n < t.width; n += r)
    for (let A = 0; A < t.height; A += r) {
      const i = e.getImageData, o = Qw in i ? i[Qw] : i;
      if (new Uint32Array(o.call(e, n, A, Math.min(r, t.width - n), Math.min(r, t.height - A)).data.buffer).some((a) => a !== 0))
        return !1;
    }
  return !0;
}
function uv(t) {
  const e = t.type;
  return t.hasAttribute("data-rr-is-password") ? "password" : e ? Pu(e) : null;
}
function n3(t, e, r) {
  return e === "INPUT" && (r === "radio" || r === "checkbox") ? t.getAttribute("value") || "" : t.value;
}
function pF(t, e) {
  let r;
  try {
    r = new URL(t, D5(e, () => window.location.href));
  } catch {
    return null;
  }
  const n = /\.([0-9a-z]+)(?:$)/i, A = r.pathname.match(n);
  return D5(v2([A, "optionalAccess", (i) => i[1]]), () => null);
}
const Uw = {};
function gF(t) {
  const e = Uw[t];
  if (e)
    return e;
  const r = window.document;
  let n = window[t];
  if (r && typeof r.createElement == "function")
    try {
      const A = r.createElement("iframe");
      A.hidden = !0, r.head.appendChild(A);
      const i = A.contentWindow;
      i && i[t] && (n = i[t]), r.head.removeChild(A);
    } catch {
    }
  return Uw[t] = n.bind(window);
}
function U5(...t) {
  return gF("setTimeout")(...t);
}
function mF(...t) {
  return gF("clearTimeout")(...t);
}
function vF(t) {
  try {
    return t.contentDocument;
  } catch {
  }
}
let OJ = 1;
const FJ = new RegExp("[^a-z0-9-_:]"), y2 = -2;
function dv() {
  return OJ++;
}
function TJ(t) {
  if (t instanceof HTMLFormElement)
    return "form";
  const e = Pu(t.tagName);
  return FJ.test(e) ? "div" : e;
}
function MJ(t) {
  let e = "";
  return t.indexOf("//") > -1 ? e = t.split("/").slice(0, 3).join("/") : e = t.split("/")[0], e = e.split("?")[0], e;
}
let yl, Nw;
const HJ = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, DJ = /^(?:[a-z+]+:)?\/\//i, QJ = /^www\..*/i, UJ = /^(data:)([^,]*),(.*)/i;
function A3(t, e) {
  return (t || "").replace(HJ, (r, n, A, i, o, s) => {
    const a = A || o || s, c = n || i || "";
    if (!a)
      return r;
    if (DJ.test(a) || QJ.test(a))
      return `url(${c}${a}${c})`;
    if (UJ.test(a))
      return `url(${c}${a}${c})`;
    if (a[0] === "/")
      return `url(${c}${MJ(e) + a}${c})`;
    const l = e.split("/"), u = a.split("/");
    l.pop();
    for (const f of u)
      f !== "." && (f === ".." ? l.pop() : l.push(f));
    return `url(${c}${l.join("/")}${c})`;
  });
}
const NJ = /^[^ \t\n\r\u000c]+/, jJ = /^[, \t\n\r\u000c]+/;
function LJ(t, e) {
  if (e.trim() === "")
    return e;
  let r = 0;
  function n(i) {
    let o;
    const s = i.exec(e.substring(r));
    return s ? (o = s[0], r += o.length, o) : "";
  }
  const A = [];
  for (; n(jJ), !(r >= e.length); ) {
    let i = n(NJ);
    if (i.slice(-1) === ",")
      i = Rl(t, i.substring(0, i.length - 1)), A.push(i);
    else {
      let o = "";
      i = Rl(t, i);
      let s = !1;
      for (; ; ) {
        const a = e.charAt(r);
        if (a === "") {
          A.push((i + o).trim());
          break;
        } else if (s)
          a === ")" && (s = !1);
        else if (a === ",") {
          r += 1, A.push((i + o).trim());
          break;
        } else a === "(" && (s = !0);
        o += a, r += 1;
      }
    }
  }
  return A.join(", ");
}
const jw = /* @__PURE__ */ new WeakMap();
function Rl(t, e) {
  return !e || e.trim() === "" ? e : Gg(t, e);
}
function GJ(t) {
  return !!(t.tagName === "svg" || t.ownerSVGElement);
}
function Gg(t, e) {
  let r = jw.get(t);
  if (r || (r = t.createElement("a"), jw.set(t, r)), !e)
    e = "";
  else if (e.startsWith("blob:") || e.startsWith("data:"))
    return e;
  return r.setAttribute("href", e), r.href;
}
function qF(t, e, r, n, A, i) {
  return n && (r === "src" || r === "href" && !(e === "use" && n[0] === "#") || r === "xlink:href" && n[0] !== "#" || r === "background" && (e === "table" || e === "td" || e === "th") ? Rl(t, n) : r === "srcset" ? LJ(t, n) : r === "style" ? A3(n, Gg(t)) : e === "object" && r === "data" ? Rl(t, n) : typeof i == "function" ? i(r, n, A) : n);
}
function yF(t, e, r) {
  return (t === "video" || t === "audio") && e === "autoplay";
}
function RJ(t, e, r, n) {
  try {
    if (n && t.matches(n))
      return !1;
    if (typeof e == "string") {
      if (t.classList.contains(e))
        return !0;
    } else
      for (let A = t.classList.length; A--; ) {
        const i = t.classList[A];
        if (e.test(i))
          return !0;
      }
    if (r)
      return t.matches(r);
  } catch {
  }
  return !1;
}
function zJ(t, e) {
  for (let r = t.classList.length; r--; ) {
    const n = t.classList[r];
    if (e.test(n))
      return !0;
  }
  return !1;
}
function Cc(t, e, r = 1 / 0, n = 0) {
  return !t || t.nodeType !== t.ELEMENT_NODE || n > r ? -1 : e(t) ? n : Cc(t.parentNode, e, r, n + 1);
}
function zl(t, e) {
  return (r) => {
    const n = r;
    if (n === null)
      return !1;
    try {
      if (t) {
        if (typeof t == "string") {
          if (n.matches(`.${t}`))
            return !0;
        } else if (zJ(n, t))
          return !0;
      }
      return !!(e && n.matches(e));
    } catch {
      return !1;
    }
  };
}
function ku(t, e, r, n, A, i) {
  try {
    const o = t.nodeType === t.ELEMENT_NODE ? t : t.parentElement;
    if (o === null)
      return !1;
    if (o.tagName === "INPUT") {
      const c = o.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(c))
        return !0;
    }
    let s = -1, a = -1;
    if (i) {
      if (a = Cc(o, zl(n, A)), a < 0)
        return !0;
      s = Cc(o, zl(e, r), a >= 0 ? a : 1 / 0);
    } else {
      if (s = Cc(o, zl(e, r)), s < 0)
        return !1;
      a = Cc(o, zl(n, A), s >= 0 ? s : 1 / 0);
    }
    return s >= 0 ? a >= 0 ? s <= a : !0 : a >= 0 ? !1 : !!i;
  } catch {
  }
  return !!i;
}
function YJ(t, e, r) {
  const n = t.contentWindow;
  if (!n)
    return;
  let A = !1, i;
  try {
    i = n.document.readyState;
  } catch {
    return;
  }
  if (i !== "complete") {
    const s = U5(() => {
      A || (e(), A = !0);
    }, r);
    t.addEventListener("load", () => {
      mF(s), A = !0, e();
    });
    return;
  }
  const o = "about:blank";
  if (n.location.href !== o || t.src === o || t.src === "")
    return U5(e, 0), t.addEventListener("load", e);
  t.addEventListener("load", e);
}
function VJ(t, e, r) {
  let n = !1, A;
  try {
    A = t.sheet;
  } catch {
    return;
  }
  if (A)
    return;
  const i = U5(() => {
    n || (e(), n = !0);
  }, r);
  t.addEventListener("load", () => {
    mF(i), n = !0, e();
  });
}
function WJ(t, e) {
  const { doc: r, mirror: n, blockClass: A, blockSelector: i, unblockSelector: o, maskAllText: s, maskAttributeFn: a, maskTextClass: c, unmaskTextClass: l, maskTextSelector: u, unmaskTextSelector: f, inlineStylesheet: d, maskInputOptions: g = {}, maskTextFn: m, maskInputFn: p, dataURLOptions: v = {}, inlineImages: C, recordCanvas: w, keepIframeSrcFn: B, newlyAddedElement: y = !1 } = e, b = XJ(r, n);
  switch (t.nodeType) {
    case t.DOCUMENT_NODE:
      return t.compatMode !== "CSS1Compat" ? {
        type: Xn.Document,
        childNodes: [],
        compatMode: t.compatMode
      } : {
        type: Xn.Document,
        childNodes: []
      };
    case t.DOCUMENT_TYPE_NODE:
      return {
        type: Xn.DocumentType,
        name: t.name,
        publicId: t.publicId,
        systemId: t.systemId,
        rootId: b
      };
    case t.ELEMENT_NODE:
      return ZJ(t, {
        doc: r,
        blockClass: A,
        blockSelector: i,
        unblockSelector: o,
        inlineStylesheet: d,
        maskAttributeFn: a,
        maskInputOptions: g,
        maskInputFn: p,
        dataURLOptions: v,
        inlineImages: C,
        recordCanvas: w,
        keepIframeSrcFn: B,
        newlyAddedElement: y,
        rootId: b,
        maskAllText: s,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: u,
        unmaskTextSelector: f
      });
    case t.TEXT_NODE:
      return KJ(t, {
        doc: r,
        maskAllText: s,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: u,
        unmaskTextSelector: f,
        maskTextFn: m,
        maskInputOptions: g,
        maskInputFn: p,
        rootId: b
      });
    case t.CDATA_SECTION_NODE:
      return {
        type: Xn.CDATA,
        textContent: "",
        rootId: b
      };
    case t.COMMENT_NODE:
      return {
        type: Xn.Comment,
        textContent: t.textContent || "",
        rootId: b
      };
    default:
      return !1;
  }
}
function XJ(t, e) {
  if (!e.hasNode(t))
    return;
  const r = e.getId(t);
  return r === 1 ? void 0 : r;
}
function KJ(t, e) {
  const { maskAllText: r, maskTextClass: n, unmaskTextClass: A, maskTextSelector: i, unmaskTextSelector: o, maskTextFn: s, maskInputOptions: a, maskInputFn: c, rootId: l } = e, u = t.parentNode && t.parentNode.tagName;
  let f = t.textContent;
  const d = u === "STYLE" ? !0 : void 0, g = u === "SCRIPT" ? !0 : void 0, m = u === "TEXTAREA" ? !0 : void 0;
  if (d && f) {
    try {
      t.nextSibling || t.previousSibling || v2([t, "access", (v) => v.parentNode, "access", (v) => v.sheet, "optionalAccess", (v) => v.cssRules]) && (f = r3(t.parentNode.sheet));
    } catch (v) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${v}`, t);
    }
    f = A3(f, Gg(e.doc));
  }
  g && (f = "SCRIPT_PLACEHOLDER");
  const p = ku(t, n, i, A, o, r);
  if (!d && !g && !m && f && p && (f = s ? s(f, t.parentElement) : f.replace(/[\S]/g, "*")), m && f && (a.textarea || p) && (f = c ? c(f, t.parentNode) : f.replace(/[\S]/g, "*")), u === "OPTION" && f) {
    const v = Lg({
      type: null,
      tagName: u,
      maskInputOptions: a
    });
    f = q2({
      isMasked: ku(t, n, i, A, o, v),
      element: t,
      value: f,
      maskInputFn: c
    });
  }
  return {
    type: Xn.Text,
    textContent: f || "",
    isStyle: d,
    rootId: l
  };
}
function ZJ(t, e) {
  const { doc: r, blockClass: n, blockSelector: A, unblockSelector: i, inlineStylesheet: o, maskInputOptions: s = {}, maskAttributeFn: a, maskInputFn: c, dataURLOptions: l = {}, inlineImages: u, recordCanvas: f, keepIframeSrcFn: d, newlyAddedElement: g = !1, rootId: m, maskAllText: p, maskTextClass: v, unmaskTextClass: C, maskTextSelector: w, unmaskTextSelector: B } = e, y = RJ(t, n, A, i), b = TJ(t);
  let q = {};
  const E = t.attributes.length;
  for (let M = 0; M < E; M++) {
    const O = t.attributes[M];
    O.name && !yF(b, O.name, O.value) && (q[O.name] = qF(r, b, Pu(O.name), O.value, t, a));
  }
  if (b === "link" && o) {
    const M = Array.from(r.styleSheets).find((I) => I.href === t.href);
    let O = null;
    M && (O = r3(M)), O && (q.rel = null, q.href = null, q.crossorigin = null, q._cssText = A3(O, M.href));
  }
  if (b === "style" && t.sheet && !(t.innerText || t.textContent || "").trim().length) {
    const M = r3(t.sheet);
    M && (q._cssText = A3(M, Gg(r)));
  }
  if (b === "input" || b === "textarea" || b === "select" || b === "option") {
    const M = t, O = uv(M), I = n3(M, Q5(b), O), S = M.checked;
    if (O !== "submit" && O !== "button" && I) {
      const P = ku(M, v, w, C, B, Lg({
        type: O,
        tagName: Q5(b),
        maskInputOptions: s
      }));
      q.value = q2({
        isMasked: P,
        element: M,
        value: I,
        maskInputFn: c
      });
    }
    S && (q.checked = S);
  }
  if (b === "option" && (t.selected && !s.select ? q.selected = !0 : delete q.selected), b === "canvas" && f) {
    if (t.__context === "2d")
      kJ(t) || (q.rr_dataURL = t.toDataURL(l.type, l.quality));
    else if (!("__context" in t)) {
      const M = t.toDataURL(l.type, l.quality), O = r.createElement("canvas");
      O.width = t.width, O.height = t.height;
      const I = O.toDataURL(l.type, l.quality);
      M !== I && (q.rr_dataURL = M);
    }
  }
  if (b === "img" && u) {
    yl || (yl = r.createElement("canvas"), Nw = yl.getContext("2d"));
    const M = t, O = M.currentSrc || M.getAttribute("src") || "<unknown-src>", I = M.crossOrigin, S = () => {
      M.removeEventListener("load", S);
      try {
        yl.width = M.naturalWidth, yl.height = M.naturalHeight, Nw.drawImage(M, 0, 0), q.rr_dataURL = yl.toDataURL(l.type, l.quality);
      } catch (P) {
        if (M.crossOrigin !== "anonymous") {
          M.crossOrigin = "anonymous", M.complete && M.naturalWidth !== 0 ? S() : M.addEventListener("load", S);
          return;
        } else
          console.warn(`Cannot inline img src=${O}! Error: ${P}`);
      }
      M.crossOrigin === "anonymous" && (I ? q.crossOrigin = I : M.removeAttribute("crossorigin"));
    };
    M.complete && M.naturalWidth !== 0 ? S() : M.addEventListener("load", S);
  }
  if ((b === "audio" || b === "video") && (q.rr_mediaState = t.paused ? "paused" : "played", q.rr_mediaCurrentTime = t.currentTime), g || (t.scrollLeft && (q.rr_scrollLeft = t.scrollLeft), t.scrollTop && (q.rr_scrollTop = t.scrollTop)), y) {
    const { width: M, height: O } = t.getBoundingClientRect();
    q = {
      class: q.class,
      rr_width: `${M}px`,
      rr_height: `${O}px`
    };
  }
  b === "iframe" && !d(q.src) && (!y && !vF(t) && (q.rr_src = q.src), delete q.src);
  let x;
  try {
    customElements.get(b) && (x = !0);
  } catch {
  }
  return {
    type: Xn.Element,
    tagName: b,
    attributes: q,
    childNodes: [],
    isSVG: GJ(t) || void 0,
    needBlock: y,
    rootId: m,
    isCustom: x
  };
}
function Xr(t) {
  return t == null ? "" : t.toLowerCase();
}
function JJ(t, e) {
  if (e.comment && t.type === Xn.Comment)
    return !0;
  if (t.type === Xn.Element) {
    if (e.script && (t.tagName === "script" || t.tagName === "link" && (t.attributes.rel === "preload" || t.attributes.rel === "modulepreload") || t.tagName === "link" && t.attributes.rel === "prefetch" && typeof t.attributes.href == "string" && pF(t.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (t.tagName === "link" && t.attributes.rel === "shortcut icon" || t.tagName === "meta" && (Xr(t.attributes.name).match(/^msapplication-tile(image|color)$/) || Xr(t.attributes.name) === "application-name" || Xr(t.attributes.rel) === "icon" || Xr(t.attributes.rel) === "apple-touch-icon" || Xr(t.attributes.rel) === "shortcut icon")))
      return !0;
    if (t.tagName === "meta") {
      if (e.headMetaDescKeywords && Xr(t.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (Xr(t.attributes.property).match(/^(og|twitter|fb):/) || Xr(t.attributes.name).match(/^(og|twitter):/) || Xr(t.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (Xr(t.attributes.name) === "robots" || Xr(t.attributes.name) === "googlebot" || Xr(t.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && t.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (Xr(t.attributes.name) === "author" || Xr(t.attributes.name) === "generator" || Xr(t.attributes.name) === "framework" || Xr(t.attributes.name) === "publisher" || Xr(t.attributes.name) === "progid" || Xr(t.attributes.property).match(/^article:/) || Xr(t.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (Xr(t.attributes.name) === "google-site-verification" || Xr(t.attributes.name) === "yandex-verification" || Xr(t.attributes.name) === "csrf-token" || Xr(t.attributes.name) === "p:domain_verify" || Xr(t.attributes.name) === "verify-v1" || Xr(t.attributes.name) === "verification" || Xr(t.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Yl(t, e) {
  const { doc: r, mirror: n, blockClass: A, blockSelector: i, unblockSelector: o, maskAllText: s, maskTextClass: a, unmaskTextClass: c, maskTextSelector: l, unmaskTextSelector: u, skipChild: f = !1, inlineStylesheet: d = !0, maskInputOptions: g = {}, maskAttributeFn: m, maskTextFn: p, maskInputFn: v, slimDOMOptions: C, dataURLOptions: w = {}, inlineImages: B = !1, recordCanvas: y = !1, onSerialize: b, onIframeLoad: q, iframeLoadTimeout: E = 5e3, onStylesheetLoad: x, stylesheetLoadTimeout: M = 5e3, keepIframeSrcFn: O = () => !1, newlyAddedElement: I = !1 } = e;
  let { preserveWhiteSpace: S = !0 } = e;
  const P = WJ(t, {
    doc: r,
    mirror: n,
    blockClass: A,
    blockSelector: i,
    maskAllText: s,
    unblockSelector: o,
    maskTextClass: a,
    unmaskTextClass: c,
    maskTextSelector: l,
    unmaskTextSelector: u,
    inlineStylesheet: d,
    maskInputOptions: g,
    maskAttributeFn: m,
    maskTextFn: p,
    maskInputFn: v,
    dataURLOptions: w,
    inlineImages: B,
    recordCanvas: y,
    keepIframeSrcFn: O,
    newlyAddedElement: I
  });
  if (!P)
    return console.warn(t, "not serialized"), null;
  let H;
  n.hasNode(t) ? H = n.getId(t) : JJ(P, C) || !S && P.type === Xn.Text && !P.isStyle && !P.textContent.replace(/^\s+|\s+$/gm, "").length ? H = y2 : H = dv();
  const F = Object.assign(P, { id: H });
  if (n.add(t, F), H === y2)
    return null;
  b && b(t);
  let T = !f;
  if (F.type === Xn.Element) {
    T = T && !F.needBlock, delete F.needBlock;
    const U = t.shadowRoot;
    U && Z0(U) && (F.isShadowHost = !0);
  }
  if ((F.type === Xn.Document || F.type === Xn.Element) && T) {
    C.headWhitespace && F.type === Xn.Element && F.tagName === "head" && (S = !1);
    const U = {
      doc: r,
      mirror: n,
      blockClass: A,
      blockSelector: i,
      maskAllText: s,
      unblockSelector: o,
      maskTextClass: a,
      unmaskTextClass: c,
      maskTextSelector: l,
      unmaskTextSelector: u,
      skipChild: f,
      inlineStylesheet: d,
      maskInputOptions: g,
      maskAttributeFn: m,
      maskTextFn: p,
      maskInputFn: v,
      slimDOMOptions: C,
      dataURLOptions: w,
      inlineImages: B,
      recordCanvas: y,
      preserveWhiteSpace: S,
      onSerialize: b,
      onIframeLoad: q,
      iframeLoadTimeout: E,
      onStylesheetLoad: x,
      stylesheetLoadTimeout: M,
      keepIframeSrcFn: O
    };
    for (const D of Array.from(t.childNodes)) {
      const Q = Yl(D, U);
      Q && F.childNodes.push(Q);
    }
    if (wJ(t) && t.shadowRoot)
      for (const D of Array.from(t.shadowRoot.childNodes)) {
        const Q = Yl(D, U);
        Q && (Z0(t.shadowRoot) && (Q.isShadow = !0), F.childNodes.push(Q));
      }
  }
  return t.parentNode && K0(t.parentNode) && Z0(t.parentNode) && (F.isShadow = !0), F.type === Xn.Element && F.tagName === "iframe" && YJ(t, () => {
    const U = vF(t);
    if (U && q) {
      const D = Yl(U, {
        doc: U,
        mirror: n,
        blockClass: A,
        blockSelector: i,
        unblockSelector: o,
        maskAllText: s,
        maskTextClass: a,
        unmaskTextClass: c,
        maskTextSelector: l,
        unmaskTextSelector: u,
        skipChild: !1,
        inlineStylesheet: d,
        maskInputOptions: g,
        maskAttributeFn: m,
        maskTextFn: p,
        maskInputFn: v,
        slimDOMOptions: C,
        dataURLOptions: w,
        inlineImages: B,
        recordCanvas: y,
        preserveWhiteSpace: S,
        onSerialize: b,
        onIframeLoad: q,
        iframeLoadTimeout: E,
        onStylesheetLoad: x,
        stylesheetLoadTimeout: M,
        keepIframeSrcFn: O
      });
      D && q(t, D);
    }
  }, E), F.type === Xn.Element && F.tagName === "link" && typeof F.attributes.rel == "string" && (F.attributes.rel === "stylesheet" || F.attributes.rel === "preload" && typeof F.attributes.href == "string" && pF(F.attributes.href) === "css") && VJ(t, () => {
    if (x) {
      const U = Yl(t, {
        doc: r,
        mirror: n,
        blockClass: A,
        blockSelector: i,
        unblockSelector: o,
        maskAllText: s,
        maskTextClass: a,
        unmaskTextClass: c,
        maskTextSelector: l,
        unmaskTextSelector: u,
        skipChild: !1,
        inlineStylesheet: d,
        maskInputOptions: g,
        maskAttributeFn: m,
        maskTextFn: p,
        maskInputFn: v,
        slimDOMOptions: C,
        dataURLOptions: w,
        inlineImages: B,
        recordCanvas: y,
        preserveWhiteSpace: S,
        onSerialize: b,
        onIframeLoad: q,
        iframeLoadTimeout: E,
        onStylesheetLoad: x,
        stylesheetLoadTimeout: M,
        keepIframeSrcFn: O
      });
      U && x(t, U);
    }
  }, M), F;
}
function _J(t, e) {
  const { mirror: r = new hF(), blockClass: n = "rr-block", blockSelector: A = null, unblockSelector: i = null, maskAllText: o = !1, maskTextClass: s = "rr-mask", unmaskTextClass: a = null, maskTextSelector: c = null, unmaskTextSelector: l = null, inlineStylesheet: u = !0, inlineImages: f = !1, recordCanvas: d = !1, maskAllInputs: g = !1, maskAttributeFn: m, maskTextFn: p, maskInputFn: v, slimDOM: C = !1, dataURLOptions: w, preserveWhiteSpace: B, onSerialize: y, onIframeLoad: b, iframeLoadTimeout: q, onStylesheetLoad: E, stylesheetLoadTimeout: x, keepIframeSrcFn: M = () => !1 } = e;
  return Yl(t, {
    doc: t,
    mirror: r,
    blockClass: n,
    blockSelector: A,
    unblockSelector: i,
    maskAllText: o,
    maskTextClass: s,
    unmaskTextClass: a,
    maskTextSelector: c,
    unmaskTextSelector: l,
    skipChild: !1,
    inlineStylesheet: u,
    maskInputOptions: g === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : g === !1 ? {} : g,
    maskAttributeFn: m,
    maskTextFn: p,
    maskInputFn: v,
    slimDOMOptions: C === !0 || C === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: C === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : C === !1 ? {} : C,
    dataURLOptions: w,
    inlineImages: f,
    recordCanvas: d,
    preserveWhiteSpace: B,
    onSerialize: y,
    onIframeLoad: b,
    iframeLoadTimeout: q,
    onStylesheetLoad: E,
    stylesheetLoadTimeout: x,
    keepIframeSrcFn: M,
    newlyAddedElement: !1
  });
}
function la(t) {
  let e, r = t[0], n = 1;
  for (; n < t.length; ) {
    const A = t[n], i = t[n + 1];
    if (n += 2, (A === "optionalAccess" || A === "optionalCall") && r == null)
      return;
    A === "access" || A === "optionalAccess" ? (e = r, r = i(r)) : (A === "call" || A === "optionalCall") && (r = i((...o) => r.call(e, ...o)), e = void 0);
  }
  return r;
}
function VA(t, e, r = document) {
  const n = { capture: !0, passive: !0 };
  return r.addEventListener(t, e, n), () => r.removeEventListener(t, e, n);
}
const Hl = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Lw = {
  map: {},
  getId() {
    return console.error(Hl), -1;
  },
  getNode() {
    return console.error(Hl), null;
  },
  removeNodeFromMap() {
    console.error(Hl);
  },
  has() {
    return console.error(Hl), !1;
  },
  reset() {
    console.error(Hl);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Lw = new Proxy(Lw, {
  get(t, e, r) {
    return e === "map" && console.error(Hl), Reflect.get(t, e, r);
  }
}));
function C2(t, e, r = {}) {
  let n = null, A = 0;
  return function(...i) {
    const o = Date.now();
    !A && r.leading === !1 && (A = o);
    const s = e - (o - A), a = this;
    s <= 0 || s > e ? (n && (i_(n), n = null), A = o, t.apply(a, i)) : !n && r.trailing !== !1 && (n = Rg(() => {
      A = r.leading === !1 ? 0 : Date.now(), n = null, t.apply(a, i);
    }, s));
  };
}
function CF(t, e, r, n, A = window) {
  const i = A.Object.getOwnPropertyDescriptor(t, e);
  return A.Object.defineProperty(t, e, n ? r : {
    set(o) {
      Rg(() => {
        r.set.call(this, o);
      }, 0), i && i.set && i.set.call(this, o);
    }
  }), () => CF(t, e, i || {}, !0);
}
function fv(t, e, r) {
  try {
    if (!(e in t))
      return () => {
      };
    const n = t[e], A = r(n);
    return typeof A == "function" && (A.prototype = A.prototype || {}, Object.defineProperties(A, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), t[e] = A, () => {
      t[e] = n;
    };
  } catch {
    return () => {
    };
  }
}
let i3 = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (i3 = () => (/* @__PURE__ */ new Date()).getTime());
function wF(t) {
  const e = t.document;
  return {
    left: e.scrollingElement ? e.scrollingElement.scrollLeft : t.pageXOffset !== void 0 ? t.pageXOffset : la([e, "optionalAccess", (r) => r.documentElement, "access", (r) => r.scrollLeft]) || la([e, "optionalAccess", (r) => r.body, "optionalAccess", (r) => r.parentElement, "optionalAccess", (r) => r.scrollLeft]) || la([e, "optionalAccess", (r) => r.body, "optionalAccess", (r) => r.scrollLeft]) || 0,
    top: e.scrollingElement ? e.scrollingElement.scrollTop : t.pageYOffset !== void 0 ? t.pageYOffset : la([e, "optionalAccess", (r) => r.documentElement, "access", (r) => r.scrollTop]) || la([e, "optionalAccess", (r) => r.body, "optionalAccess", (r) => r.parentElement, "optionalAccess", (r) => r.scrollTop]) || la([e, "optionalAccess", (r) => r.body, "optionalAccess", (r) => r.scrollTop]) || 0
  };
}
function bF() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function BF() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function EF(t) {
  return t ? t.nodeType === t.ELEMENT_NODE ? t : t.parentElement : null;
}
function vi(t, e, r, n, A) {
  if (!t)
    return !1;
  const i = EF(t);
  if (!i)
    return !1;
  const o = zl(e, r);
  if (!A) {
    const c = n && i.matches(n);
    return o(i) && !c;
  }
  const s = Cc(i, o);
  let a = -1;
  return s < 0 ? !1 : (n && (a = Cc(i, zl(null, n))), s > -1 && a < 0 ? !0 : s < a);
}
function $J(t, e) {
  return e.getId(t) !== -1;
}
function D9(t, e) {
  return e.getId(t) === y2;
}
function xF(t, e) {
  if (K0(t))
    return !1;
  const r = e.getId(t);
  return e.has(r) ? t.parentNode && t.parentNode.nodeType === t.DOCUMENT_NODE ? !1 : t.parentNode ? xF(t.parentNode, e) : !0 : !0;
}
function N5(t) {
  return !!t.changedTouches;
}
function e_(t = window) {
  "NodeList" in t && !t.NodeList.prototype.forEach && (t.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in t && !t.DOMTokenList.prototype.forEach && (t.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...e) => {
    let r = e[0];
    if (!(0 in e))
      throw new TypeError("1 argument is required");
    do
      if (this === r)
        return !0;
    while (r = r && r.parentNode);
    return !1;
  });
}
function IF(t, e) {
  return !!(t.nodeName === "IFRAME" && e.getMeta(t));
}
function SF(t, e) {
  return !!(t.nodeName === "LINK" && t.nodeType === t.ELEMENT_NODE && t.getAttribute && t.getAttribute("rel") === "stylesheet" && e.getMeta(t));
}
function j5(t) {
  return !!la([t, "optionalAccess", (e) => e.shadowRoot]);
}
class t_ {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(e) {
    return NX(this.styleIDMap.get(e), () => -1);
  }
  has(e) {
    return this.styleIDMap.has(e);
  }
  add(e, r) {
    if (this.has(e))
      return this.getId(e);
    let n;
    return r === void 0 ? n = this.id++ : n = r, this.styleIDMap.set(e, n), this.idStyleMap.set(n, e), n;
  }
  getStyle(e) {
    return this.idStyleMap.get(e) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function PF(t) {
  let e = null;
  return la([t, "access", (r) => r.getRootNode, "optionalCall", (r) => r(), "optionalAccess", (r) => r.nodeType]) === Node.DOCUMENT_FRAGMENT_NODE && t.getRootNode().host && (e = t.getRootNode().host), e;
}
function r_(t) {
  let e = t, r;
  for (; r = PF(e); )
    e = r;
  return e;
}
function n_(t) {
  const e = t.ownerDocument;
  if (!e)
    return !1;
  const r = r_(t);
  return e.contains(r);
}
function kF(t) {
  const e = t.ownerDocument;
  return e ? e.contains(t) || n_(t) : !1;
}
const Gw = {};
function hv(t) {
  const e = Gw[t];
  if (e)
    return e;
  const r = window.document;
  let n = window[t];
  if (r && typeof r.createElement == "function")
    try {
      const A = r.createElement("iframe");
      A.hidden = !0, r.head.appendChild(A);
      const i = A.contentWindow;
      i && i[t] && (n = i[t]), r.head.removeChild(A);
    } catch {
    }
  return Gw[t] = n.bind(window);
}
function A_(...t) {
  return hv("requestAnimationFrame")(...t);
}
function Rg(...t) {
  return hv("setTimeout")(...t);
}
function i_(...t) {
  return hv("clearTimeout")(...t);
}
var fr = /* @__PURE__ */ ((t) => (t[t.DomContentLoaded = 0] = "DomContentLoaded", t[t.Load = 1] = "Load", t[t.FullSnapshot = 2] = "FullSnapshot", t[t.IncrementalSnapshot = 3] = "IncrementalSnapshot", t[t.Meta = 4] = "Meta", t[t.Custom = 5] = "Custom", t[t.Plugin = 6] = "Plugin", t))(fr || {}), Zt = /* @__PURE__ */ ((t) => (t[t.Mutation = 0] = "Mutation", t[t.MouseMove = 1] = "MouseMove", t[t.MouseInteraction = 2] = "MouseInteraction", t[t.Scroll = 3] = "Scroll", t[t.ViewportResize = 4] = "ViewportResize", t[t.Input = 5] = "Input", t[t.TouchMove = 6] = "TouchMove", t[t.MediaInteraction = 7] = "MediaInteraction", t[t.StyleSheetRule = 8] = "StyleSheetRule", t[t.CanvasMutation = 9] = "CanvasMutation", t[t.Font = 10] = "Font", t[t.Log = 11] = "Log", t[t.Drag = 12] = "Drag", t[t.StyleDeclaration = 13] = "StyleDeclaration", t[t.Selection = 14] = "Selection", t[t.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", t[t.CustomElement = 16] = "CustomElement", t))(Zt || {}), LA = /* @__PURE__ */ ((t) => (t[t.MouseUp = 0] = "MouseUp", t[t.MouseDown = 1] = "MouseDown", t[t.Click = 2] = "Click", t[t.ContextMenu = 3] = "ContextMenu", t[t.DblClick = 4] = "DblClick", t[t.Focus = 5] = "Focus", t[t.Blur = 6] = "Blur", t[t.TouchStart = 7] = "TouchStart", t[t.TouchMove_Departed = 8] = "TouchMove_Departed", t[t.TouchEnd = 9] = "TouchEnd", t[t.TouchCancel = 10] = "TouchCancel", t))(LA || {}), us = /* @__PURE__ */ ((t) => (t[t.Mouse = 0] = "Mouse", t[t.Pen = 1] = "Pen", t[t.Touch = 2] = "Touch", t))(us || {}), Rw;
(function(t) {
  t[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
})(Rw || (Rw = {}));
var zw;
(function(t) {
  t[t.PLACEHOLDER = 0] = "PLACEHOLDER", t[t.ELEMENT_NODE = 1] = "ELEMENT_NODE", t[t.ATTRIBUTE_NODE = 2] = "ATTRIBUTE_NODE", t[t.TEXT_NODE = 3] = "TEXT_NODE", t[t.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", t[t.ENTITY_REFERENCE_NODE = 5] = "ENTITY_REFERENCE_NODE", t[t.ENTITY_NODE = 6] = "ENTITY_NODE", t[t.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", t[t.COMMENT_NODE = 8] = "COMMENT_NODE", t[t.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", t[t.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", t[t.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE";
})(zw || (zw = {}));
function pv(t) {
  try {
    return t.contentDocument;
  } catch {
  }
}
function o_(t) {
  try {
    return t.contentWindow;
  } catch {
  }
}
function s_(t) {
  let e, r = t[0], n = 1;
  for (; n < t.length; ) {
    const A = t[n], i = t[n + 1];
    if (n += 2, (A === "optionalAccess" || A === "optionalCall") && r == null)
      return;
    A === "access" || A === "optionalAccess" ? (e = r, r = i(r)) : (A === "call" || A === "optionalCall") && (r = i((...o) => r.call(e, ...o)), e = void 0);
  }
  return r;
}
function Yw(t) {
  return "__ln" in t;
}
class a_ {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(e) {
    if (e >= this.length)
      throw new Error("Position outside of list range");
    let r = this.head;
    for (let n = 0; n < e; n++)
      r = s_([r, "optionalAccess", (A) => A.next]) || null;
    return r;
  }
  addNode(e) {
    const r = {
      value: e,
      previous: null,
      next: null
    };
    if (e.__ln = r, e.previousSibling && Yw(e.previousSibling)) {
      const n = e.previousSibling.__ln.next;
      r.next = n, r.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = r, n && (n.previous = r);
    } else if (e.nextSibling && Yw(e.nextSibling) && e.nextSibling.__ln.previous) {
      const n = e.nextSibling.__ln.previous;
      r.previous = n, r.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = r, n && (n.next = r);
    } else
      this.head && (this.head.previous = r), r.next = this.head, this.head = r;
    r.next === null && (this.tail = r), this.length++;
  }
  removeNode(e) {
    const r = e.__ln;
    this.head && (r.previous ? (r.previous.next = r.next, r.next ? r.next.previous = r.previous : this.tail = r.previous) : (this.head = r.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
  }
}
const Vw = (t, e) => `${t}@${e}`;
class c_ {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (e) => {
      e.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const e = [], r = /* @__PURE__ */ new Set(), n = new a_(), A = (a) => {
        let c = a, l = y2;
        for (; l === y2; )
          c = c && c.nextSibling, l = c && this.mirror.getId(c);
        return l;
      }, i = (a) => {
        if (!a.parentNode || !kF(a))
          return;
        const c = K0(a.parentNode) ? this.mirror.getId(PF(a)) : this.mirror.getId(a.parentNode), l = A(a);
        if (c === -1 || l === -1)
          return n.addNode(a);
        const u = Yl(a, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (f) => {
            IF(f, this.mirror) && !vi(f, this.blockClass, this.blockSelector, this.unblockSelector, !1) && this.iframeManager.addIframe(f), SF(f, this.mirror) && this.stylesheetManager.trackLinkElement(f), j5(a) && this.shadowDomManager.addShadowRoot(a.shadowRoot, this.doc);
          },
          onIframeLoad: (f, d) => {
            vi(f, this.blockClass, this.blockSelector, this.unblockSelector, !1) || (this.iframeManager.attachIframe(f, d), f.contentWindow && this.canvasManager.addWindow(f.contentWindow), this.shadowDomManager.observeAttachShadow(f));
          },
          onStylesheetLoad: (f, d) => {
            this.stylesheetManager.attachLinkElement(f, d);
          }
        });
        u && (e.push({
          parentId: c,
          nextId: l,
          node: u
        }), r.add(u.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const a of this.movedSet)
        Ww(this.removes, a, this.mirror) && !this.movedSet.has(a.parentNode) || i(a);
      for (const a of this.addedSet)
        !Xw(this.droppedSet, a) && !Ww(this.removes, a, this.mirror) || Xw(this.movedSet, a) ? i(a) : this.droppedSet.add(a);
      let o = null;
      for (; n.length; ) {
        let a = null;
        if (o) {
          const c = this.mirror.getId(o.value.parentNode), l = A(o.value);
          c !== -1 && l !== -1 && (a = o);
        }
        if (!a) {
          let c = n.tail;
          for (; c; ) {
            const l = c;
            if (c = c.previous, l) {
              const u = this.mirror.getId(l.value.parentNode);
              if (A(l.value) === -1)
                continue;
              if (u !== -1) {
                a = l;
                break;
              } else {
                const d = l.value;
                if (d.parentNode && d.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const g = d.parentNode.host;
                  if (this.mirror.getId(g) !== -1) {
                    a = l;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!a) {
          for (; n.head; )
            n.removeNode(n.head.value);
          break;
        }
        o = a.previous, n.removeNode(a.value), i(a.value);
      }
      const s = {
        texts: this.texts.map((a) => ({
          id: this.mirror.getId(a.node),
          value: a.value
        })).filter((a) => !r.has(a.id)).filter((a) => this.mirror.has(a.id)),
        attributes: this.attributes.map((a) => {
          const { attributes: c } = a;
          if (typeof c.style == "string") {
            const l = JSON.stringify(a.styleDiff), u = JSON.stringify(a._unchangedStyles);
            l.length < c.style.length && (l + u).split("var(").length === c.style.split("var(").length && (c.style = a.styleDiff);
          }
          return {
            id: this.mirror.getId(a.node),
            attributes: c
          };
        }).filter((a) => !r.has(a.id)).filter((a) => this.mirror.has(a.id)),
        removes: this.removes,
        adds: e
      };
      !s.texts.length && !s.attributes.length && !s.removes.length && !s.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(s));
    }, this.processMutation = (e) => {
      if (!D9(e.target, this.mirror))
        switch (e.type) {
          case "characterData": {
            const r = e.target.textContent;
            !vi(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) && r !== e.oldValue && this.texts.push({
              value: ku(e.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && r ? this.maskTextFn ? this.maskTextFn(r, EF(e.target)) : r.replace(/[\S]/g, "*") : r,
              node: e.target
            });
            break;
          }
          case "attributes": {
            const r = e.target;
            let n = e.attributeName, A = e.target.getAttribute(n);
            if (n === "value") {
              const o = uv(r), s = r.tagName;
              A = n3(r, s, o);
              const a = Lg({
                maskInputOptions: this.maskInputOptions,
                tagName: s,
                type: o
              }), c = ku(e.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, a);
              A = q2({
                isMasked: c,
                element: r,
                value: A,
                maskInputFn: this.maskInputFn
              });
            }
            if (vi(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || A === e.oldValue)
              return;
            let i = this.attributeMap.get(e.target);
            if (r.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(A))
              if (!pv(r))
                n = "rr_src";
              else
                return;
            if (i || (i = {
              node: e.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(i), this.attributeMap.set(e.target, i)), n === "type" && r.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && r.setAttribute("data-rr-is-password", "true"), !yF(r.tagName, n) && (i.attributes[n] = qF(this.doc, Pu(r.tagName), Pu(n), A, r, this.maskAttributeFn), n === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              e.oldValue && o.setAttribute("style", e.oldValue);
              for (const s of Array.from(r.style)) {
                const a = r.style.getPropertyValue(s), c = r.style.getPropertyPriority(s);
                a !== o.style.getPropertyValue(s) || c !== o.style.getPropertyPriority(s) ? c === "" ? i.styleDiff[s] = a : i.styleDiff[s] = [a, c] : i._unchangedStyles[s] = [a, c];
              }
              for (const s of Array.from(o.style))
                r.style.getPropertyValue(s) === "" && (i.styleDiff[s] = !1);
            }
            break;
          }
          case "childList": {
            if (vi(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !0))
              return;
            e.addedNodes.forEach((r) => this.genAdds(r, e.target)), e.removedNodes.forEach((r) => {
              const n = this.mirror.getId(r), A = K0(e.target) ? this.mirror.getId(e.target.host) : this.mirror.getId(e.target);
              vi(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || D9(r, this.mirror) || !$J(r, this.mirror) || (this.addedSet.has(r) ? (L5(this.addedSet, r), this.droppedSet.add(r)) : this.addedSet.has(e.target) && n === -1 || xF(e.target, this.mirror) || (this.movedSet.has(r) && this.movedMap[Vw(n, A)] ? L5(this.movedSet, r) : this.removes.push({
                parentId: A,
                id: n,
                isShadow: K0(e.target) && Z0(e.target) ? !0 : void 0
              })), this.mapRemoves.push(r));
            });
            break;
          }
        }
    }, this.genAdds = (e, r) => {
      if (!this.processedNodeManager.inOtherBuffer(e, this) && !(this.addedSet.has(e) || this.movedSet.has(e))) {
        if (this.mirror.hasNode(e)) {
          if (D9(e, this.mirror))
            return;
          this.movedSet.add(e);
          let n = null;
          r && this.mirror.hasNode(r) && (n = this.mirror.getId(r)), n && n !== -1 && (this.movedMap[Vw(this.mirror.getId(e), n)] = !0);
        } else
          this.addedSet.add(e), this.droppedSet.delete(e);
        vi(e, this.blockClass, this.blockSelector, this.unblockSelector, !1) || (e.childNodes.forEach((n) => this.genAdds(n)), j5(e) && e.shadowRoot.childNodes.forEach((n) => {
          this.processedNodeManager.add(n, this), this.genAdds(n, e);
        }));
      }
    };
  }
  init(e) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((r) => {
      this[r] = e[r];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function L5(t, e) {
  t.delete(e), e.childNodes.forEach((r) => L5(t, r));
}
function Ww(t, e, r) {
  return t.length === 0 ? !1 : l_(t, e, r);
}
function l_(t, e, r) {
  let n = e.parentNode;
  for (; n; ) {
    const A = r.getId(n);
    if (t.some((i) => i.id === A))
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Xw(t, e) {
  return t.size === 0 ? !1 : OF(t, e);
}
function OF(t, e) {
  const { parentNode: r } = e;
  return r ? t.has(r) ? !0 : OF(t, r) : !1;
}
let J0;
function u_(t) {
  J0 = t;
}
function d_() {
  J0 = void 0;
}
const br = (t) => J0 ? (...r) => {
  try {
    return t(...r);
  } catch (n) {
    if (J0 && J0(n) === !0)
      return () => {
      };
    throw n;
  }
} : t;
function ao(t) {
  let e, r = t[0], n = 1;
  for (; n < t.length; ) {
    const A = t[n], i = t[n + 1];
    if (n += 2, (A === "optionalAccess" || A === "optionalCall") && r == null)
      return;
    A === "access" || A === "optionalAccess" ? (e = r, r = i(r)) : (A === "call" || A === "optionalCall") && (r = i((...o) => r.call(e, ...o)), e = void 0);
  }
  return r;
}
const Vl = [];
function x1(t) {
  try {
    if ("composedPath" in t) {
      const e = t.composedPath();
      if (e.length)
        return e[0];
    } else if ("path" in t && t.path.length)
      return t.path[0];
  } catch {
  }
  return t && t.target;
}
function FF(t, e) {
  const r = new c_();
  Vl.push(r), r.init(t);
  let n = window.MutationObserver || window.__rrMutationObserver;
  const A = ao([window, "optionalAccess", (o) => o.Zone, "optionalAccess", (o) => o.__symbol__, "optionalCall", (o) => o("MutationObserver")]);
  A && window[A] && (n = window[A]);
  const i = new n(br((o) => {
    t.onMutation && t.onMutation(o) === !1 || r.processMutations.bind(r)(o);
  }));
  return i.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function f_({ mousemoveCb: t, sampling: e, doc: r, mirror: n }) {
  if (e.mousemove === !1)
    return () => {
    };
  const A = typeof e.mousemove == "number" ? e.mousemove : 50, i = typeof e.mousemoveCallback == "number" ? e.mousemoveCallback : 500;
  let o = [], s;
  const a = C2(br((u) => {
    const f = Date.now() - s;
    t(o.map((d) => (d.timeOffset -= f, d)), u), o = [], s = null;
  }), i), c = br(C2(br((u) => {
    const f = x1(u), { clientX: d, clientY: g } = N5(u) ? u.changedTouches[0] : u;
    s || (s = i3()), o.push({
      x: d,
      y: g,
      id: n.getId(f),
      timeOffset: i3() - s
    }), a(typeof DragEvent < "u" && u instanceof DragEvent ? Zt.Drag : u instanceof MouseEvent ? Zt.MouseMove : Zt.TouchMove);
  }), A, {
    trailing: !1
  })), l = [
    VA("mousemove", c, r),
    VA("touchmove", c, r),
    VA("drag", c, r)
  ];
  return br(() => {
    l.forEach((u) => u());
  });
}
function h_({ mouseInteractionCb: t, doc: e, mirror: r, blockClass: n, blockSelector: A, unblockSelector: i, sampling: o }) {
  if (o.mouseInteraction === !1)
    return () => {
    };
  const s = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, a = [];
  let c = null;
  const l = (u) => (f) => {
    const d = x1(f);
    if (vi(d, n, A, i, !0))
      return;
    let g = null, m = u;
    if ("pointerType" in f) {
      switch (f.pointerType) {
        case "mouse":
          g = us.Mouse;
          break;
        case "touch":
          g = us.Touch;
          break;
        case "pen":
          g = us.Pen;
          break;
      }
      g === us.Touch ? LA[u] === LA.MouseDown ? m = "TouchStart" : LA[u] === LA.MouseUp && (m = "TouchEnd") : us.Pen;
    } else N5(f) && (g = us.Touch);
    g !== null ? (c = g, (m.startsWith("Touch") && g === us.Touch || m.startsWith("Mouse") && g === us.Mouse) && (g = null)) : LA[u] === LA.Click && (g = c, c = null);
    const p = N5(f) ? f.changedTouches[0] : f;
    if (!p)
      return;
    const v = r.getId(d), { clientX: C, clientY: w } = p;
    br(t)({
      type: LA[m],
      id: v,
      x: C,
      y: w,
      ...g !== null && { pointerType: g }
    });
  };
  return Object.keys(LA).filter((u) => Number.isNaN(Number(u)) && !u.endsWith("_Departed") && s[u] !== !1).forEach((u) => {
    let f = Pu(u);
    const d = l(u);
    if (window.PointerEvent)
      switch (LA[u]) {
        case LA.MouseDown:
        case LA.MouseUp:
          f = f.replace("mouse", "pointer");
          break;
        case LA.TouchStart:
        case LA.TouchEnd:
          return;
      }
    a.push(VA(f, d, e));
  }), br(() => {
    a.forEach((u) => u());
  });
}
function TF({ scrollCb: t, doc: e, mirror: r, blockClass: n, blockSelector: A, unblockSelector: i, sampling: o }) {
  const s = br(C2(br((a) => {
    const c = x1(a);
    if (!c || vi(c, n, A, i, !0))
      return;
    const l = r.getId(c);
    if (c === e && e.defaultView) {
      const u = wF(e.defaultView);
      t({
        id: l,
        x: u.left,
        y: u.top
      });
    } else
      t({
        id: l,
        x: c.scrollLeft,
        y: c.scrollTop
      });
  }), o.scroll || 100));
  return VA("scroll", s, e);
}
function p_({ viewportResizeCb: t }, { win: e }) {
  let r = -1, n = -1;
  const A = br(C2(br(() => {
    const i = bF(), o = BF();
    (r !== i || n !== o) && (t({
      width: Number(o),
      height: Number(i)
    }), r = i, n = o);
  }), 200));
  return VA("resize", A, e);
}
const g_ = ["INPUT", "TEXTAREA", "SELECT"], Kw = /* @__PURE__ */ new WeakMap();
function m_({ inputCb: t, doc: e, mirror: r, blockClass: n, blockSelector: A, unblockSelector: i, ignoreClass: o, ignoreSelector: s, maskInputOptions: a, maskInputFn: c, sampling: l, userTriggeredOnInput: u, maskTextClass: f, unmaskTextClass: d, maskTextSelector: g, unmaskTextSelector: m }) {
  function p(q) {
    let E = x1(q);
    const x = q.isTrusted, M = E && Q5(E.tagName);
    if (M === "OPTION" && (E = E.parentElement), !E || !M || g_.indexOf(M) < 0 || vi(E, n, A, i, !0))
      return;
    const O = E;
    if (O.classList.contains(o) || s && O.matches(s))
      return;
    const I = uv(E);
    let S = n3(O, M, I), P = !1;
    const H = Lg({
      maskInputOptions: a,
      tagName: M,
      type: I
    }), F = ku(E, f, g, d, m, H);
    (I === "radio" || I === "checkbox") && (P = E.checked), S = q2({
      isMasked: F,
      element: E,
      value: S,
      maskInputFn: c
    }), v(E, u ? { text: S, isChecked: P, userTriggered: x } : { text: S, isChecked: P });
    const T = E.name;
    I === "radio" && T && P && e.querySelectorAll(`input[type="radio"][name="${T}"]`).forEach((U) => {
      if (U !== E) {
        const D = q2({
          isMasked: F,
          element: U,
          value: n3(U, M, I),
          maskInputFn: c
        });
        v(U, u ? { text: D, isChecked: !P, userTriggered: !1 } : { text: D, isChecked: !P });
      }
    });
  }
  function v(q, E) {
    const x = Kw.get(q);
    if (!x || x.text !== E.text || x.isChecked !== E.isChecked) {
      Kw.set(q, E);
      const M = r.getId(q);
      br(t)({
        ...E,
        id: M
      });
    }
  }
  const w = (l.input === "last" ? ["change"] : ["input", "change"]).map((q) => VA(q, br(p), e)), B = e.defaultView;
  if (!B)
    return () => {
      w.forEach((q) => q());
    };
  const y = B.Object.getOwnPropertyDescriptor(B.HTMLInputElement.prototype, "value"), b = [
    [B.HTMLInputElement.prototype, "value"],
    [B.HTMLInputElement.prototype, "checked"],
    [B.HTMLSelectElement.prototype, "value"],
    [B.HTMLTextAreaElement.prototype, "value"],
    [B.HTMLSelectElement.prototype, "selectedIndex"],
    [B.HTMLOptionElement.prototype, "selected"]
  ];
  return y && y.set && w.push(...b.map((q) => CF(q[0], q[1], {
    set() {
      br(p)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, B))), br(() => {
    w.forEach((q) => q());
  });
}
function o3(t) {
  const e = [];
  function r(n, A) {
    if (uf("CSSGroupingRule") && n.parentRule instanceof CSSGroupingRule || uf("CSSMediaRule") && n.parentRule instanceof CSSMediaRule || uf("CSSSupportsRule") && n.parentRule instanceof CSSSupportsRule || uf("CSSConditionRule") && n.parentRule instanceof CSSConditionRule) {
      const o = Array.from(n.parentRule.cssRules).indexOf(n);
      A.unshift(o);
    } else if (n.parentStyleSheet) {
      const o = Array.from(n.parentStyleSheet.cssRules).indexOf(n);
      A.unshift(o);
    }
    return A;
  }
  return r(t, e);
}
function ua(t, e, r) {
  let n, A;
  return t ? (t.ownerNode ? n = e.getId(t.ownerNode) : A = r.getId(t), {
    styleId: A,
    id: n
  }) : {};
}
function v_({ styleSheetRuleCb: t, mirror: e, stylesheetManager: r }, { win: n }) {
  if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype)
    return () => {
    };
  const A = n.CSSStyleSheet.prototype.insertRule;
  n.CSSStyleSheet.prototype.insertRule = new Proxy(A, {
    apply: br((l, u, f) => {
      const [d, g] = f, { id: m, styleId: p } = ua(u, e, r.styleMirror);
      return (m && m !== -1 || p && p !== -1) && t({
        id: m,
        styleId: p,
        adds: [{ rule: d, index: g }]
      }), l.apply(u, f);
    })
  });
  const i = n.CSSStyleSheet.prototype.deleteRule;
  n.CSSStyleSheet.prototype.deleteRule = new Proxy(i, {
    apply: br((l, u, f) => {
      const [d] = f, { id: g, styleId: m } = ua(u, e, r.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        removes: [{ index: d }]
      }), l.apply(u, f);
    })
  });
  let o;
  n.CSSStyleSheet.prototype.replace && (o = n.CSSStyleSheet.prototype.replace, n.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: br((l, u, f) => {
      const [d] = f, { id: g, styleId: m } = ua(u, e, r.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        replace: d
      }), l.apply(u, f);
    })
  }));
  let s;
  n.CSSStyleSheet.prototype.replaceSync && (s = n.CSSStyleSheet.prototype.replaceSync, n.CSSStyleSheet.prototype.replaceSync = new Proxy(s, {
    apply: br((l, u, f) => {
      const [d] = f, { id: g, styleId: m } = ua(u, e, r.styleMirror);
      return (g && g !== -1 || m && m !== -1) && t({
        id: g,
        styleId: m,
        replaceSync: d
      }), l.apply(u, f);
    })
  }));
  const a = {};
  df("CSSGroupingRule") ? a.CSSGroupingRule = n.CSSGroupingRule : (df("CSSMediaRule") && (a.CSSMediaRule = n.CSSMediaRule), df("CSSConditionRule") && (a.CSSConditionRule = n.CSSConditionRule), df("CSSSupportsRule") && (a.CSSSupportsRule = n.CSSSupportsRule));
  const c = {};
  return Object.entries(a).forEach(([l, u]) => {
    c[l] = {
      insertRule: u.prototype.insertRule,
      deleteRule: u.prototype.deleteRule
    }, u.prototype.insertRule = new Proxy(c[l].insertRule, {
      apply: br((f, d, g) => {
        const [m, p] = g, { id: v, styleId: C } = ua(d.parentStyleSheet, e, r.styleMirror);
        return (v && v !== -1 || C && C !== -1) && t({
          id: v,
          styleId: C,
          adds: [
            {
              rule: m,
              index: [
                ...o3(d),
                p || 0
              ]
            }
          ]
        }), f.apply(d, g);
      })
    }), u.prototype.deleteRule = new Proxy(c[l].deleteRule, {
      apply: br((f, d, g) => {
        const [m] = g, { id: p, styleId: v } = ua(d.parentStyleSheet, e, r.styleMirror);
        return (p && p !== -1 || v && v !== -1) && t({
          id: p,
          styleId: v,
          removes: [
            { index: [...o3(d), m] }
          ]
        }), f.apply(d, g);
      })
    });
  }), br(() => {
    n.CSSStyleSheet.prototype.insertRule = A, n.CSSStyleSheet.prototype.deleteRule = i, o && (n.CSSStyleSheet.prototype.replace = o), s && (n.CSSStyleSheet.prototype.replaceSync = s), Object.entries(a).forEach(([l, u]) => {
      u.prototype.insertRule = c[l].insertRule, u.prototype.deleteRule = c[l].deleteRule;
    });
  });
}
function MF({ mirror: t, stylesheetManager: e }, r) {
  let n = null;
  r.nodeName === "#document" ? n = t.getId(r) : n = t.getId(r.host);
  const A = r.nodeName === "#document" ? ao([r, "access", (o) => o.defaultView, "optionalAccess", (o) => o.Document]) : ao([r, "access", (o) => o.ownerDocument, "optionalAccess", (o) => o.defaultView, "optionalAccess", (o) => o.ShadowRoot]), i = ao([A, "optionalAccess", (o) => o.prototype]) ? Object.getOwnPropertyDescriptor(ao([A, "optionalAccess", (o) => o.prototype]), "adoptedStyleSheets") : void 0;
  return n === null || n === -1 || !A || !i ? () => {
  } : (Object.defineProperty(r, "adoptedStyleSheets", {
    configurable: i.configurable,
    enumerable: i.enumerable,
    get() {
      return ao([i, "access", (o) => o.get, "optionalAccess", (o) => o.call, "call", (o) => o(this)]);
    },
    set(o) {
      const s = ao([i, "access", (a) => a.set, "optionalAccess", (a) => a.call, "call", (a) => a(this, o)]);
      if (n !== null && n !== -1)
        try {
          e.adoptStyleSheets(o, n);
        } catch {
        }
      return s;
    }
  }), br(() => {
    Object.defineProperty(r, "adoptedStyleSheets", {
      configurable: i.configurable,
      enumerable: i.enumerable,
      get: i.get,
      set: i.set
    });
  }));
}
function q_({ styleDeclarationCb: t, mirror: e, ignoreCSSAttributes: r, stylesheetManager: n }, { win: A }) {
  const i = A.CSSStyleDeclaration.prototype.setProperty;
  A.CSSStyleDeclaration.prototype.setProperty = new Proxy(i, {
    apply: br((s, a, c) => {
      const [l, u, f] = c;
      if (r.has(l))
        return i.apply(a, [l, u, f]);
      const { id: d, styleId: g } = ua(ao([a, "access", (m) => m.parentRule, "optionalAccess", (m) => m.parentStyleSheet]), e, n.styleMirror);
      return (d && d !== -1 || g && g !== -1) && t({
        id: d,
        styleId: g,
        set: {
          property: l,
          value: u,
          priority: f
        },
        index: o3(a.parentRule)
      }), s.apply(a, c);
    })
  });
  const o = A.CSSStyleDeclaration.prototype.removeProperty;
  return A.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: br((s, a, c) => {
      const [l] = c;
      if (r.has(l))
        return o.apply(a, [l]);
      const { id: u, styleId: f } = ua(ao([a, "access", (d) => d.parentRule, "optionalAccess", (d) => d.parentStyleSheet]), e, n.styleMirror);
      return (u && u !== -1 || f && f !== -1) && t({
        id: u,
        styleId: f,
        remove: {
          property: l
        },
        index: o3(a.parentRule)
      }), s.apply(a, c);
    })
  }), br(() => {
    A.CSSStyleDeclaration.prototype.setProperty = i, A.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function y_({ mediaInteractionCb: t, blockClass: e, blockSelector: r, unblockSelector: n, mirror: A, sampling: i, doc: o }) {
  const s = br((c) => C2(br((l) => {
    const u = x1(l);
    if (!u || vi(u, e, r, n, !0))
      return;
    const { currentTime: f, volume: d, muted: g, playbackRate: m } = u;
    t({
      type: c,
      id: A.getId(u),
      currentTime: f,
      volume: d,
      muted: g,
      playbackRate: m
    });
  }), i.media || 500)), a = [
    VA("play", s(0), o),
    VA("pause", s(1), o),
    VA("seeked", s(2), o),
    VA("volumechange", s(3), o),
    VA("ratechange", s(4), o)
  ];
  return br(() => {
    a.forEach((c) => c());
  });
}
function C_({ fontCb: t, doc: e }) {
  const r = e.defaultView;
  if (!r)
    return () => {
    };
  const n = [], A = /* @__PURE__ */ new WeakMap(), i = r.FontFace;
  r.FontFace = function(a, c, l) {
    const u = new i(a, c, l);
    return A.set(u, {
      family: a,
      buffer: typeof c != "string",
      descriptors: l,
      fontSource: typeof c == "string" ? c : JSON.stringify(Array.from(new Uint8Array(c)))
    }), u;
  };
  const o = fv(e.fonts, "add", function(s) {
    return function(a) {
      return Rg(br(() => {
        const c = A.get(a);
        c && (t(c), A.delete(a));
      }), 0), s.apply(this, [a]);
    };
  });
  return n.push(() => {
    r.FontFace = i;
  }), n.push(o), br(() => {
    n.forEach((s) => s());
  });
}
function w_(t) {
  const { doc: e, mirror: r, blockClass: n, blockSelector: A, unblockSelector: i, selectionCb: o } = t;
  let s = !0;
  const a = br(() => {
    const c = e.getSelection();
    if (!c || s && ao([c, "optionalAccess", (f) => f.isCollapsed]))
      return;
    s = c.isCollapsed || !1;
    const l = [], u = c.rangeCount || 0;
    for (let f = 0; f < u; f++) {
      const d = c.getRangeAt(f), { startContainer: g, startOffset: m, endContainer: p, endOffset: v } = d;
      vi(g, n, A, i, !0) || vi(p, n, A, i, !0) || l.push({
        start: r.getId(g),
        startOffset: m,
        end: r.getId(p),
        endOffset: v
      });
    }
    o({ ranges: l });
  });
  return a(), VA("selectionchange", a);
}
function b_({ doc: t, customElementCb: e }) {
  const r = t.defaultView;
  return !r || !r.customElements ? () => {
  } : fv(r.customElements, "define", function(A) {
    return function(i, o, s) {
      try {
        e({
          define: {
            name: i
          }
        });
      } catch {
      }
      return A.apply(this, [i, o, s]);
    };
  });
}
function B_(t, e = {}) {
  const r = t.doc.defaultView;
  if (!r)
    return () => {
    };
  let n;
  t.recordDOM && (n = FF(t, t.doc));
  const A = f_(t), i = h_(t), o = TF(t), s = p_(t, {
    win: r
  }), a = m_(t), c = y_(t);
  let l = () => {
  }, u = () => {
  }, f = () => {
  }, d = () => {
  };
  t.recordDOM && (l = v_(t, { win: r }), u = MF(t, t.doc), f = q_(t, {
    win: r
  }), t.collectFonts && (d = C_(t)));
  const g = w_(t), m = b_(t), p = [];
  for (const v of t.plugins)
    p.push(v.observer(v.callback, r, v.options));
  return br(() => {
    Vl.forEach((v) => v.reset()), ao([n, "optionalAccess", (v) => v.disconnect, "call", (v) => v()]), A(), i(), o(), s(), a(), c(), l(), u(), f(), d(), g(), m(), p.forEach((v) => v());
  });
}
function uf(t) {
  return typeof window[t] < "u";
}
function df(t) {
  return !!(typeof window[t] < "u" && window[t].prototype && "insertRule" in window[t].prototype && "deleteRule" in window[t].prototype);
}
class G5 {
  constructor(e) {
    this.generateIdFn = e, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(e, r, n, A) {
    const i = n || this.getIdToRemoteIdMap(e), o = A || this.getRemoteIdToIdMap(e);
    let s = i.get(r);
    return s || (s = this.generateIdFn(), i.set(r, s), o.set(s, r)), s;
  }
  getIds(e, r) {
    const n = this.getIdToRemoteIdMap(e), A = this.getRemoteIdToIdMap(e);
    return r.map((i) => this.getId(e, i, n, A));
  }
  getRemoteId(e, r, n) {
    const A = n || this.getRemoteIdToIdMap(e);
    if (typeof r != "number")
      return r;
    const i = A.get(r);
    return i || -1;
  }
  getRemoteIds(e, r) {
    const n = this.getRemoteIdToIdMap(e);
    return r.map((A) => this.getRemoteId(e, A, n));
  }
  reset(e) {
    if (!e) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
  }
  getIdToRemoteIdMap(e) {
    let r = this.iframeIdToRemoteIdMap.get(e);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, r)), r;
  }
  getRemoteIdToIdMap(e) {
    let r = this.iframeRemoteIdToIdMap.get(e);
    return r || (r = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, r)), r;
  }
}
function Zw(t) {
  let e, r = t[0], n = 1;
  for (; n < t.length; ) {
    const A = t[n], i = t[n + 1];
    if (n += 2, (A === "optionalAccess" || A === "optionalCall") && r == null)
      return;
    A === "access" || A === "optionalAccess" ? (e = r, r = i(r)) : (A === "call" || A === "optionalCall") && (r = i((...o) => r.call(e, ...o)), e = void 0);
  }
  return r;
}
class E_ {
  constructor() {
    this.crossOriginIframeMirror = new G5(dv), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class x_ {
  constructor(e) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new G5(dv), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new G5(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(e) {
    this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
  }
  addLoadListener(e) {
    this.loadListener = e;
  }
  attachIframe(e, r) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(e),
          nextId: null,
          node: r
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), Zw([this, "access", (A) => A.loadListener, "optionalCall", (A) => A(e)]);
    const n = pv(e);
    n && n.adoptedStyleSheets && n.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(n.adoptedStyleSheets, this.mirror.getId(n));
  }
  handleMessage(e) {
    const r = e;
    if (r.data.type !== "rrweb" || r.origin !== r.data.origin || !e.source)
      return;
    const A = this.crossOriginIframeMap.get(e.source);
    if (!A)
      return;
    const i = this.transformCrossOriginEvent(A, r.data.event);
    i && this.wrappedEmit(i, r.data.isCheckout);
  }
  transformCrossOriginEvent(e, r) {
    switch (r.type) {
      case fr.FullSnapshot: {
        this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(r.data.node, e);
        const n = r.data.node.id;
        return this.crossOriginIframeRootIdMap.set(e, n), this.patchRootIdOnNode(r.data.node, n), {
          timestamp: r.timestamp,
          type: fr.IncrementalSnapshot,
          data: {
            source: Zt.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(e),
                nextId: null,
                node: r.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case fr.Meta:
      case fr.Load:
      case fr.DomContentLoaded:
        return !1;
      case fr.Plugin:
        return r;
      case fr.Custom:
        return this.replaceIds(r.data.payload, e, ["id", "parentId", "previousId", "nextId"]), r;
      case fr.IncrementalSnapshot:
        switch (r.data.source) {
          case Zt.Mutation:
            return r.data.adds.forEach((n) => {
              this.replaceIds(n, e, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(n.node, e);
              const A = this.crossOriginIframeRootIdMap.get(e);
              A && this.patchRootIdOnNode(n.node, A);
            }), r.data.removes.forEach((n) => {
              this.replaceIds(n, e, ["parentId", "id"]);
            }), r.data.attributes.forEach((n) => {
              this.replaceIds(n, e, ["id"]);
            }), r.data.texts.forEach((n) => {
              this.replaceIds(n, e, ["id"]);
            }), r;
          case Zt.Drag:
          case Zt.TouchMove:
          case Zt.MouseMove:
            return r.data.positions.forEach((n) => {
              this.replaceIds(n, e, ["id"]);
            }), r;
          case Zt.ViewportResize:
            return !1;
          case Zt.MediaInteraction:
          case Zt.MouseInteraction:
          case Zt.Scroll:
          case Zt.CanvasMutation:
          case Zt.Input:
            return this.replaceIds(r.data, e, ["id"]), r;
          case Zt.StyleSheetRule:
          case Zt.StyleDeclaration:
            return this.replaceIds(r.data, e, ["id"]), this.replaceStyleIds(r.data, e, ["styleId"]), r;
          case Zt.Font:
            return r;
          case Zt.Selection:
            return r.data.ranges.forEach((n) => {
              this.replaceIds(n, e, ["start", "end"]);
            }), r;
          case Zt.AdoptedStyleSheet:
            return this.replaceIds(r.data, e, ["id"]), this.replaceStyleIds(r.data, e, ["styleIds"]), Zw([r, "access", (n) => n.data, "access", (n) => n.styles, "optionalAccess", (n) => n.forEach, "call", (n) => n((A) => {
              this.replaceStyleIds(A, e, ["styleId"]);
            })]), r;
        }
    }
    return !1;
  }
  replace(e, r, n, A) {
    for (const i of A)
      !Array.isArray(r[i]) && typeof r[i] != "number" || (Array.isArray(r[i]) ? r[i] = e.getIds(n, r[i]) : r[i] = e.getId(n, r[i]));
    return r;
  }
  replaceIds(e, r, n) {
    return this.replace(this.crossOriginIframeMirror, e, r, n);
  }
  replaceStyleIds(e, r, n) {
    return this.replace(this.crossOriginIframeStyleMirror, e, r, n);
  }
  replaceIdOnNode(e, r) {
    this.replaceIds(e, r, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((n) => {
      this.replaceIdOnNode(n, r);
    });
  }
  patchRootIdOnNode(e, r) {
    e.type !== Xn.Document && !e.rootId && (e.rootId = r), "childNodes" in e && e.childNodes.forEach((n) => {
      this.patchRootIdOnNode(n, r);
    });
  }
}
class I_ {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class S_ {
  constructor(e) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(e, r) {
    if (!Z0(e) || this.shadowDoms.has(e))
      return;
    this.shadowDoms.add(e), this.bypassOptions.canvasManager.addShadowRoot(e);
    const n = FF({
      ...this.bypassOptions,
      doc: r,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }, e);
    this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(TF({
      ...this.bypassOptions,
      scrollCb: this.scrollCb,
      doc: e,
      mirror: this.mirror
    })), Rg(() => {
      e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(e.adoptedStyleSheets, this.mirror.getId(e.host)), this.restoreHandlers.push(MF({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, e));
    }, 0);
  }
  observeAttachShadow(e) {
    const r = pv(e), n = o_(e);
    !r || !n || this.patchAttachShadow(n.Element, r);
  }
  patchAttachShadow(e, r) {
    const n = this;
    this.restoreHandlers.push(fv(e.prototype, "attachShadow", function(A) {
      return function(i) {
        const o = A.call(this, i);
        return this.shadowRoot && kF(this) && n.addShadowRoot(this.shadowRoot, r), o;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((e) => {
      try {
        e();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
class Jw {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
  addWindow() {
  }
  addShadowRoot() {
  }
  resetShadowRoots() {
  }
}
class P_ {
  constructor(e) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new t_(), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
  }
  attachLinkElement(e, r) {
    "_cssText" in r.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: r.id,
          attributes: r.attributes
        }
      ]
    }), this.trackLinkElement(e);
  }
  trackLinkElement(e) {
    this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
  }
  adoptStyleSheets(e, r) {
    if (e.length === 0)
      return;
    const n = {
      id: r,
      styleIds: []
    }, A = [];
    for (const i of e) {
      let o;
      this.styleMirror.has(i) ? o = this.styleMirror.getId(i) : (o = this.styleMirror.add(i), A.push({
        styleId: o,
        rules: Array.from(i.rules || CSSRule, (s, a) => ({
          rule: fF(s),
          index: a
        }))
      })), n.styleIds.push(o);
    }
    A.length > 0 && (n.styles = A), this.adoptedStyleSheetCb(n);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(e) {
  }
}
class k_ {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
  }
  inOtherBuffer(e, r) {
    const n = this.nodeMap.get(e);
    return n && Array.from(n).some((A) => A !== r);
  }
  add(e, r) {
    this.active || (this.active = !0, A_(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(r));
  }
  destroy() {
  }
}
let gn, s3;
try {
  if (Array.from([1], (t) => t * 2)[0] !== 2) {
    const t = document.createElement("iframe");
    document.body.appendChild(t), Array.from = gh([t, "access", (e) => e.contentWindow, "optionalAccess", (e) => e.Array, "access", (e) => e.from]) || Array.from, document.body.removeChild(t);
  }
} catch (t) {
  console.debug("Unable to override Array.from", t);
}
const eo = PJ();
function Cs(t = {}) {
  const { emit: e, checkoutEveryNms: r, checkoutEveryNth: n, blockClass: A = "rr-block", blockSelector: i = null, unblockSelector: o = null, ignoreClass: s = "rr-ignore", ignoreSelector: a = null, maskAllText: c = !1, maskTextClass: l = "rr-mask", unmaskTextClass: u = null, maskTextSelector: f = null, unmaskTextSelector: d = null, inlineStylesheet: g = !0, maskAllInputs: m, maskInputOptions: p, slimDOMOptions: v, maskAttributeFn: C, maskInputFn: w, maskTextFn: B, maxCanvasSize: y = null, packFn: b, sampling: q = {}, dataURLOptions: E = {}, mousemoveWait: x, recordDOM: M = !0, recordCanvas: O = !1, recordCrossOriginIframes: I = !1, recordAfter: S = t.recordAfter === "DOMContentLoaded" ? t.recordAfter : "load", userTriggeredOnInput: P = !1, collectFonts: H = !1, inlineImages: F = !1, plugins: T, keepIframeSrcFn: U = () => !1, ignoreCSSAttributes: D = /* @__PURE__ */ new Set([]), errorHandler: Q, onMutation: Y, getCanvasManager: j } = t;
  u_(Q);
  const Z = I ? window.parent === window : !0;
  let W = !1;
  if (!Z)
    try {
      window.parent.document && (W = !1);
    } catch {
      W = !0;
    }
  if (Z && !e)
    throw new Error("emit function is required");
  if (!Z && !W)
    return () => {
    };
  x !== void 0 && q.mousemove === void 0 && (q.mousemove = x), eo.reset();
  const R = m === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : p !== void 0 ? p : {}, K = v === !0 || v === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: v === "all",
    headMetaDescKeywords: v === "all"
  } : v || {};
  e_();
  let L, G = 0;
  const V = (fe) => {
    for (const ve of T || [])
      ve.eventProcessor && (fe = ve.eventProcessor(fe));
    return b && !W && (fe = b(fe)), fe;
  };
  gn = (fe, ve) => {
    const ge = fe;
    if (ge.timestamp = i3(), gh([Vl, "access", (oe) => oe[0], "optionalAccess", (oe) => oe.isFrozen, "call", (oe) => oe()]) && ge.type !== fr.FullSnapshot && !(ge.type === fr.IncrementalSnapshot && ge.data.source === Zt.Mutation) && Vl.forEach((oe) => oe.unfreeze()), Z)
      gh([e, "optionalCall", (oe) => oe(V(ge), ve)]);
    else if (W) {
      const oe = {
        type: "rrweb",
        event: V(ge),
        origin: window.location.origin,
        isCheckout: ve
      };
      window.parent.postMessage(oe, "*");
    }
    if (ge.type === fr.FullSnapshot)
      L = ge, G = 0;
    else if (ge.type === fr.IncrementalSnapshot) {
      if (ge.data.source === Zt.Mutation && ge.data.isAttachIframe)
        return;
      G++;
      const oe = n && G >= n, ce = r && L && ge.timestamp - L.timestamp > r;
      (oe || ce) && ue(!0);
    }
  };
  const _ = (fe) => {
    gn({
      type: fr.IncrementalSnapshot,
      data: {
        source: Zt.Mutation,
        ...fe
      }
    });
  }, J = (fe) => gn({
    type: fr.IncrementalSnapshot,
    data: {
      source: Zt.Scroll,
      ...fe
    }
  }), X = (fe) => gn({
    type: fr.IncrementalSnapshot,
    data: {
      source: Zt.CanvasMutation,
      ...fe
    }
  }), ne = (fe) => gn({
    type: fr.IncrementalSnapshot,
    data: {
      source: Zt.AdoptedStyleSheet,
      ...fe
    }
  }), ee = new P_({
    mutationCb: _,
    adoptedStyleSheetCb: ne
  }), $ = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new E_() : new x_({
    mirror: eo,
    mutationCb: _,
    stylesheetManager: ee,
    recordCrossOriginIframes: I,
    wrappedEmit: gn
  });
  for (const fe of T || [])
    fe.getMirror && fe.getMirror({
      nodeMirror: eo,
      crossOriginIframeMirror: $.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: $.crossOriginIframeStyleMirror
    });
  const te = new k_(), ae = F_(j, {
    mirror: eo,
    win: window,
    mutationCb: (fe) => gn({
      type: fr.IncrementalSnapshot,
      data: {
        source: Zt.CanvasMutation,
        ...fe
      }
    }),
    recordCanvas: O,
    blockClass: A,
    blockSelector: i,
    unblockSelector: o,
    maxCanvasSize: y,
    sampling: q.canvas,
    dataURLOptions: E,
    errorHandler: Q
  }), se = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new I_() : new S_({
    mutationCb: _,
    scrollCb: J,
    bypassOptions: {
      onMutation: Y,
      blockClass: A,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: c,
      maskTextClass: l,
      unmaskTextClass: u,
      maskTextSelector: f,
      unmaskTextSelector: d,
      inlineStylesheet: g,
      maskInputOptions: R,
      dataURLOptions: E,
      maskAttributeFn: C,
      maskTextFn: B,
      maskInputFn: w,
      recordCanvas: O,
      inlineImages: F,
      sampling: q,
      slimDOMOptions: K,
      iframeManager: $,
      stylesheetManager: ee,
      canvasManager: ae,
      keepIframeSrcFn: U,
      processedNodeManager: te
    },
    mirror: eo
  }), ue = (fe = !1) => {
    if (!M)
      return;
    gn({
      type: fr.Meta,
      data: {
        href: window.location.href,
        width: BF(),
        height: bF()
      }
    }, fe), ee.reset(), se.init(), Vl.forEach((ge) => ge.lock());
    const ve = _J(document, {
      mirror: eo,
      blockClass: A,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: c,
      maskTextClass: l,
      unmaskTextClass: u,
      maskTextSelector: f,
      unmaskTextSelector: d,
      inlineStylesheet: g,
      maskAllInputs: R,
      maskAttributeFn: C,
      maskInputFn: w,
      maskTextFn: B,
      slimDOM: K,
      dataURLOptions: E,
      recordCanvas: O,
      inlineImages: F,
      onSerialize: (ge) => {
        IF(ge, eo) && $.addIframe(ge), SF(ge, eo) && ee.trackLinkElement(ge), j5(ge) && se.addShadowRoot(ge.shadowRoot, document);
      },
      onIframeLoad: (ge, oe) => {
        $.attachIframe(ge, oe), ge.contentWindow && ae.addWindow(ge.contentWindow), se.observeAttachShadow(ge);
      },
      onStylesheetLoad: (ge, oe) => {
        ee.attachLinkElement(ge, oe);
      },
      keepIframeSrcFn: U
    });
    if (!ve)
      return console.warn("Failed to snapshot the document");
    gn({
      type: fr.FullSnapshot,
      data: {
        node: ve,
        initialOffset: wF(window)
      }
    }), Vl.forEach((ge) => ge.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && ee.adoptStyleSheets(document.adoptedStyleSheets, eo.getId(document));
  };
  s3 = ue;
  try {
    const fe = [], ve = (oe) => br(B_)({
      onMutation: Y,
      mutationCb: _,
      mousemoveCb: (ce, pe) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: pe,
          positions: ce
        }
      }),
      mouseInteractionCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.MouseInteraction,
          ...ce
        }
      }),
      scrollCb: J,
      viewportResizeCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.ViewportResize,
          ...ce
        }
      }),
      inputCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.Input,
          ...ce
        }
      }),
      mediaInteractionCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.MediaInteraction,
          ...ce
        }
      }),
      styleSheetRuleCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.StyleSheetRule,
          ...ce
        }
      }),
      styleDeclarationCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.StyleDeclaration,
          ...ce
        }
      }),
      canvasMutationCb: X,
      fontCb: (ce) => gn({
        type: fr.IncrementalSnapshot,
        data: {
          source: Zt.Font,
          ...ce
        }
      }),
      selectionCb: (ce) => {
        gn({
          type: fr.IncrementalSnapshot,
          data: {
            source: Zt.Selection,
            ...ce
          }
        });
      },
      customElementCb: (ce) => {
        gn({
          type: fr.IncrementalSnapshot,
          data: {
            source: Zt.CustomElement,
            ...ce
          }
        });
      },
      blockClass: A,
      ignoreClass: s,
      ignoreSelector: a,
      maskAllText: c,
      maskTextClass: l,
      unmaskTextClass: u,
      maskTextSelector: f,
      unmaskTextSelector: d,
      maskInputOptions: R,
      inlineStylesheet: g,
      sampling: q,
      recordDOM: M,
      recordCanvas: O,
      inlineImages: F,
      userTriggeredOnInput: P,
      collectFonts: H,
      doc: oe,
      maskAttributeFn: C,
      maskInputFn: w,
      maskTextFn: B,
      keepIframeSrcFn: U,
      blockSelector: i,
      unblockSelector: o,
      slimDOMOptions: K,
      dataURLOptions: E,
      mirror: eo,
      iframeManager: $,
      stylesheetManager: ee,
      shadowDomManager: se,
      processedNodeManager: te,
      canvasManager: ae,
      ignoreCSSAttributes: D,
      plugins: gh([
        T,
        "optionalAccess",
        (ce) => ce.filter,
        "call",
        (ce) => ce((pe) => pe.observer),
        "optionalAccess",
        (ce) => ce.map,
        "call",
        (ce) => ce((pe) => ({
          observer: pe.observer,
          options: pe.options,
          callback: (qe) => gn({
            type: fr.Plugin,
            data: {
              plugin: pe.name,
              payload: qe
            }
          })
        }))
      ]) || []
    }, {});
    $.addLoadListener((oe) => {
      try {
        fe.push(ve(oe.contentDocument));
      } catch (ce) {
        console.warn(ce);
      }
    });
    const ge = () => {
      ue(), fe.push(ve(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? ge() : (fe.push(VA("DOMContentLoaded", () => {
      gn({
        type: fr.DomContentLoaded,
        data: {}
      }), S === "DOMContentLoaded" && ge();
    })), fe.push(VA("load", () => {
      gn({
        type: fr.Load,
        data: {}
      }), S === "load" && ge();
    }, window))), () => {
      fe.forEach((oe) => oe()), te.destroy(), s3 = void 0, d_();
    };
  } catch (fe) {
    console.warn(fe);
  }
}
function O_(t) {
  if (!s3)
    throw new Error("please take full snapshot after start recording");
  s3(t);
}
Cs.mirror = eo;
Cs.takeFullSnapshot = O_;
function F_(t, e) {
  try {
    return t ? t(e) : new Jw();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new Jw();
  }
}
const T_ = 3, M_ = 5;
function gv(t) {
  return t > 9999999999 ? t : t * 1e3;
}
function Q9(t) {
  return t > 9999999999 ? t / 1e3 : t;
}
function I1(t, e) {
  e.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(e.category) ? t.triggerUserActivity() : t.checkAndHandleExpiredSession(), t.addUpdate(() => (t.throttledAddEvent({
    type: fr.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (e.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: no(e, 10, 1e3)
    }
  }), e.category === "console")));
}
const H_ = "button,a";
function HF(t) {
  return t.closest(H_) || t;
}
function DF(t) {
  const e = QF(t);
  return !e || !(e instanceof Element) ? e : HF(e);
}
function QF(t) {
  return D_(t) ? t.target : t;
}
function D_(t) {
  return typeof t == "object" && !!t && "target" in t;
}
let da;
function Q_(t) {
  return da || (da = [], U_()), da.push(t), () => {
    const e = da ? da.indexOf(t) : -1;
    e > -1 && da.splice(e, 1);
  };
}
function U_() {
  Ai(Kr, "open", function(t) {
    return function(...e) {
      if (da)
        try {
          da.forEach((r) => r());
        } catch {
        }
      return t.apply(Kr, e);
    };
  });
}
const N_ = /* @__PURE__ */ new Set([
  Zt.Mutation,
  Zt.StyleSheetRule,
  Zt.StyleDeclaration,
  Zt.AdoptedStyleSheet,
  Zt.CanvasMutation,
  Zt.Selection,
  Zt.MediaInteraction
]);
function j_(t, e, r) {
  t.handleClick(e, r);
}
class L_ {
  // protected for testing
  constructor(e, r, n = I1) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = r.timeout / 1e3, this._threshold = r.threshold / 1e3, this._scrollTimeout = r.scrollTimeout / 1e3, this._replay = e, this._ignoreSelector = r.ignoreSelector, this._addBreadcrumbEvent = n;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const e = Q_(() => {
      this._lastMutation = _w();
    });
    this._teardown = () => {
      e(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(e, r) {
    if (R_(r, this._ignoreSelector) || !z_(e))
      return;
    const n = {
      timestamp: Q9(e.timestamp),
      clickBreadcrumb: e,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: r
    };
    this._clicks.some((A) => A.node === n.node && Math.abs(A.timestamp - n.timestamp) < 1) || (this._clicks.push(n), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(e = Date.now()) {
    this._lastMutation = Q9(e);
  }
  /** @inheritDoc */
  registerScroll(e = Date.now()) {
    this._lastScroll = Q9(e);
  }
  /** @inheritDoc */
  registerClick(e) {
    const r = HF(e);
    this._handleMultiClick(r);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(e) {
    this._getClicks(e).forEach((r) => {
      r.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(e) {
    return this._clicks.filter((r) => r.node === e);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const e = [], r = _w();
    this._clicks.forEach((n) => {
      !n.mutationAfter && this._lastMutation && (n.mutationAfter = n.timestamp <= this._lastMutation ? this._lastMutation - n.timestamp : void 0), !n.scrollAfter && this._lastScroll && (n.scrollAfter = n.timestamp <= this._lastScroll ? this._lastScroll - n.timestamp : void 0), n.timestamp + this._timeout <= r && e.push(n);
    });
    for (const n of e) {
      const A = this._clicks.indexOf(n);
      A > -1 && (this._generateBreadcrumbs(n), this._clicks.splice(A, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(e) {
    const r = this._replay, n = e.scrollAfter && e.scrollAfter <= this._scrollTimeout, A = e.mutationAfter && e.mutationAfter <= this._threshold, i = !n && !A, { clickCount: o, clickBreadcrumb: s } = e;
    if (i) {
      const a = Math.min(e.mutationAfter || this._timeout, this._timeout) * 1e3, c = a < this._timeout * 1e3 ? "mutation" : "timeout", l = {
        type: "default",
        message: s.message,
        timestamp: s.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...s.data,
          url: Kr.location.href,
          route: r.getCurrentRoute(),
          timeAfterClickMs: a,
          endReason: c,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: o || 1
        }
      };
      this._addBreadcrumbEvent(r, l);
      return;
    }
    if (o > 1) {
      const a = {
        type: "default",
        message: s.message,
        timestamp: s.timestamp,
        category: "ui.multiClick",
        data: {
          ...s.data,
          url: Kr.location.href,
          route: r.getCurrentRoute(),
          clickCount: o,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(r, a);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = Su(() => this._checkClicks(), 1e3);
  }
}
const G_ = ["A", "BUTTON", "INPUT"];
function R_(t, e) {
  return !!(!G_.includes(t.tagName) || t.tagName === "INPUT" && !["submit", "button"].includes(t.getAttribute("type") || "") || t.tagName === "A" && (t.hasAttribute("download") || t.hasAttribute("target") && t.getAttribute("target") !== "_self") || e && t.matches(e));
}
function z_(t) {
  return !!(t.data && typeof t.data.nodeId == "number" && t.timestamp);
}
function _w() {
  return Date.now() / 1e3;
}
function Y_(t, e) {
  try {
    if (!V_(e))
      return;
    const { source: r } = e.data;
    if (N_.has(r) && t.registerMutation(e.timestamp), r === Zt.Scroll && t.registerScroll(e.timestamp), W_(e)) {
      const { type: n, id: A } = e.data, i = Cs.mirror.getNode(A);
      i instanceof HTMLElement && n === LA.Click && t.registerClick(i);
    }
  } catch {
  }
}
function V_(t) {
  return t.type === T_;
}
function W_(t) {
  return t.data.source === Zt.MouseInteraction;
}
function jo(t) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...t
  };
}
var a3;
(function(t) {
  t[t.Document = 0] = "Document", t[t.DocumentType = 1] = "DocumentType", t[t.Element = 2] = "Element", t[t.Text = 3] = "Text", t[t.CDATA = 4] = "CDATA", t[t.Comment = 5] = "Comment";
})(a3 || (a3 = {}));
const X_ = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function K_(t) {
  const e = {};
  !t["data-sentry-component"] && t["data-sentry-element"] && (t["data-sentry-component"] = t["data-sentry-element"]);
  for (const r in t)
    if (X_.has(r)) {
      let n = r;
      (r === "data-testid" || r === "data-test-id") && (n = "testId"), e[n] = t[r];
    }
  return e;
}
const Z_ = (t) => (e) => {
  if (!t.isEnabled())
    return;
  const r = J_(e), n = e.name === "click", A = n ? e.event : void 0;
  n && t.clickDetector && A && A.target && !A.altKey && !A.metaKey && !A.ctrlKey && !A.shiftKey && j_(
    t.clickDetector,
    r,
    DF(e.event)
  ), I1(t, r);
};
function UF(t, e) {
  const r = Cs.mirror.getId(t), n = r && Cs.mirror.getNode(r), A = n && Cs.mirror.getMeta(n), i = A && $_(A) ? A : null;
  return {
    message: e,
    data: i ? {
      nodeId: r,
      node: {
        id: r,
        tagName: i.tagName,
        textContent: Array.from(i.childNodes).map((o) => o.type === a3.Text && o.textContent).filter(Boolean).map((o) => o.trim()).join(""),
        attributes: K_(i.attributes)
      }
    } : {}
  };
}
function J_(t) {
  const { target: e, message: r } = __(t);
  return jo({
    category: `ui.${t.name}`,
    ...UF(e, r)
  });
}
function __(t) {
  const e = t.name === "click";
  let r, n = null;
  try {
    n = e ? DF(t.event) : QF(t.event), r = Os(n, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    r = "<unknown>";
  }
  return { target: n, message: r };
}
function $_(t) {
  return t.type === a3.Element;
}
function e$(t, e) {
  if (!t.isEnabled())
    return;
  t.updateUserActivity();
  const r = t$(e);
  r && I1(t, r);
}
function t$(t) {
  const { metaKey: e, shiftKey: r, ctrlKey: n, altKey: A, key: i, target: o } = t;
  if (!o || r$(o) || !i)
    return null;
  const s = e || n || A, a = i.length === 1;
  if (!s && a)
    return null;
  const c = Os(o, { maxStringLength: 200 }) || "<unknown>", l = UF(o, c);
  return jo({
    category: "ui.keyDown",
    message: c,
    data: {
      ...l.data,
      metaKey: e,
      shiftKey: r,
      ctrlKey: n,
      altKey: A,
      key: i
    }
  });
}
function r$(t) {
  return t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable;
}
const n$ = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: a$,
  paint: o$,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: s$
};
function ff(t, e) {
  return ({ metric: r }) => void e.replayPerformanceEntries.push(t(r));
}
function A$(t) {
  return t.map(i$).filter(Boolean);
}
function i$(t) {
  const e = n$[t.entryType];
  return e ? e(t) : null;
}
function Ou(t) {
  return ((ZA || Kr.performance.timeOrigin) + t) / 1e3;
}
function o$(t) {
  const { duration: e, entryType: r, name: n, startTime: A } = t, i = Ou(A);
  return {
    type: r,
    name: n,
    start: i,
    end: i + e,
    data: void 0
  };
}
function s$(t) {
  const {
    entryType: e,
    name: r,
    decodedBodySize: n,
    duration: A,
    domComplete: i,
    encodedBodySize: o,
    domContentLoadedEventStart: s,
    domContentLoadedEventEnd: a,
    domInteractive: c,
    loadEventStart: l,
    loadEventEnd: u,
    redirectCount: f,
    startTime: d,
    transferSize: g,
    type: m
  } = t;
  return A === 0 ? null : {
    type: `${e}.${m}`,
    start: Ou(d),
    end: Ou(i),
    name: r,
    data: {
      size: g,
      decodedBodySize: n,
      encodedBodySize: o,
      duration: A,
      domInteractive: c,
      domContentLoadedEventStart: s,
      domContentLoadedEventEnd: a,
      loadEventStart: l,
      loadEventEnd: u,
      domComplete: i,
      redirectCount: f
    }
  };
}
function a$(t) {
  const {
    entryType: e,
    initiatorType: r,
    name: n,
    responseEnd: A,
    startTime: i,
    decodedBodySize: o,
    encodedBodySize: s,
    responseStatus: a,
    transferSize: c
  } = t;
  return ["fetch", "xmlhttprequest"].includes(r) ? null : {
    type: `${e}.${r}`,
    start: Ou(i),
    end: Ou(A),
    name: n,
    data: {
      size: c,
      statusCode: a,
      decodedBodySize: o,
      encodedBodySize: s
    }
  };
}
function c$(t) {
  const e = t.entries[t.entries.length - 1], r = e && e.element ? [e.element] : void 0;
  return zg(t, "largest-contentful-paint", r);
}
function l$(t) {
  return t.sources !== void 0;
}
function u$(t) {
  const e = [], r = [];
  for (const n of t.entries)
    if (l$(n)) {
      const A = [];
      for (const i of n.sources)
        if (i.node) {
          r.push(i.node);
          const o = Cs.mirror.getId(i.node);
          o && A.push(o);
        }
      e.push({ value: n.value, nodeIds: A.length ? A : void 0 });
    }
  return zg(t, "cumulative-layout-shift", r, e);
}
function d$(t) {
  const e = t.entries[t.entries.length - 1], r = e && e.target ? [e.target] : void 0;
  return zg(t, "first-input-delay", r);
}
function f$(t) {
  const e = t.entries[t.entries.length - 1], r = e && e.target ? [e.target] : void 0;
  return zg(t, "interaction-to-next-paint", r);
}
function zg(t, e, r, n) {
  const A = t.value, i = t.rating, o = Ou(A);
  return {
    type: "web-vital",
    name: e,
    start: o,
    end: o,
    data: {
      value: A,
      size: A,
      rating: i,
      nodeIds: r ? r.map((s) => Cs.mirror.getId(s)) : void 0,
      attributions: n
    }
  };
}
function h$(t) {
  function e(A) {
    t.performanceEntries.includes(A) || t.performanceEntries.push(A);
  }
  function r({ entries: A }) {
    A.forEach(e);
  }
  const n = [];
  return ["navigation", "paint", "resource"].forEach((A) => {
    n.push(Iu(A, r));
  }), n.push(
    tF(ff(c$, t)),
    ov(ff(u$, t)),
    rF(ff(d$, t)),
    nF(ff(f$, t))
  ), () => {
    n.forEach((A) => A());
  };
}
const Yt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, p$ = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function g$() {
  const t = new Blob([p$]);
  return URL.createObjectURL(t);
}
const $w = ["info", "warn", "error", "log"], qh = "[Replay] ";
function U9(t, e = "info") {
  ja(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: e,
      message: `${qh}${t}`
    },
    { level: e }
  );
}
function m$() {
  let t = !1, e = !1;
  const r = {
    exception: () => {
    },
    infoTick: () => {
    },
    setConfig: (n) => {
      t = n.captureExceptions, e = n.traceInternals;
    }
  };
  return Yt ? ($w.forEach((n) => {
    r[n] = (...A) => {
      ft[n](qh, ...A), e && U9(A.join(""), NO(n));
    };
  }), r.exception = (n, ...A) => {
    A.length && r.error && r.error(...A), ft.error(qh, n), t ? tv(n) : e && U9(n, "error");
  }, r.infoTick = (...n) => {
    ft.info(qh, ...n), e && setTimeout(() => U9(n[0]), 0);
  }) : $w.forEach((n) => {
    r[n] = () => {
    };
  }), r;
}
const Wt = m$();
class mv extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${lv}.`);
  }
}
class NF {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(e) {
    const r = JSON.stringify(e).length;
    if (this._totalSize += r, this._totalSize > lv)
      throw new mv();
    this.events.push(e);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((e) => {
      const r = this.events;
      this.clear(), e(JSON.stringify(r));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const e = this.events.map((r) => r.timestamp).sort()[0];
    return e ? gv(e) : null;
  }
}
class v$ {
  constructor(e) {
    this._worker = e, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((e, r) => {
      this._worker.addEventListener(
        "message",
        ({ data: n }) => {
          n.success ? e() : r();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (n) => {
          r(n);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    Yt && Wt.info("Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(e, r) {
    const n = this._getAndIncrementId();
    return new Promise((A, i) => {
      const o = ({ data: s }) => {
        const a = s;
        if (a.method === e && a.id === n) {
          if (this._worker.removeEventListener("message", o), !a.success) {
            Yt && Wt.error("Error in compression worker: ", a.response), i(new Error("Error in compression worker"));
            return;
          }
          A(a.response);
        }
      };
      this._worker.addEventListener("message", o), this._worker.postMessage({ id: n, method: e, arg: r });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class q$ {
  /** @inheritdoc */
  /** @inheritdoc */
  constructor(e) {
    this._worker = new v$(e), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(e) {
    const r = gv(e.timestamp);
    (!this._earliestTimestamp || r < this._earliestTimestamp) && (this._earliestTimestamp = r);
    const n = JSON.stringify(e);
    return this._totalSize += n.length, this._totalSize > lv ? Promise.reject(new mv()) : this._sendEventToWorker(n);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (e) => {
      Yt && Wt.exception(e, 'Sending "clear" message to worker failed', e);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(e) {
    return this._worker.postMessage("addEvent", e);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const e = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, e;
  }
}
class y$ {
  constructor(e) {
    this._fallback = new NF(), this._compression = new q$(e), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get waitForCheckout() {
    return this._used.waitForCheckout;
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(e) {
    this._used.hasCheckout = e;
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  set waitForCheckout(e) {
    this._used.waitForCheckout = e;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(e) {
    return this._used.addEvent(e);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (e) {
      Yt && Wt.exception(e, "Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: e, hasCheckout: r, waitForCheckout: n } = this._fallback, A = [];
    for (const i of e)
      A.push(this._compression.addEvent(i));
    this._compression.hasCheckout = r, this._compression.waitForCheckout = n, this._used = this._compression;
    try {
      await Promise.all(A), this._fallback.clear();
    } catch (i) {
      Yt && Wt.exception(i, "Failed to add events when switching buffers.");
    }
  }
}
function C$({
  useCompression: t,
  workerUrl: e
}) {
  if (t && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const r = w$(e);
    if (r)
      return r;
  }
  return Yt && Wt.info("Using simple buffer"), new NF();
}
function w$(t) {
  try {
    const e = t || b$();
    if (!e)
      return;
    Yt && Wt.info(`Using compression worker${t ? ` from ${t}` : ""}`);
    const r = new Worker(e);
    return new y$(r);
  } catch (e) {
    Yt && Wt.exception(e, "Failed to create compression worker");
  }
}
function b$() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? g$() : "";
}
function vv() {
  try {
    return "sessionStorage" in Kr && !!Kr.sessionStorage;
  } catch {
    return !1;
  }
}
function B$(t) {
  E$(), t.session = void 0;
}
function E$() {
  if (vv())
    try {
      Kr.sessionStorage.removeItem(av);
    } catch {
    }
}
function jF(t) {
  return t === void 0 ? !1 : Math.random() < t;
}
function LF(t) {
  const e = Date.now(), r = t.id || Ci(), n = t.started || e, A = t.lastActivity || e, i = t.segmentId || 0, o = t.sampled, s = t.previousSessionId;
  return {
    id: r,
    started: n,
    lastActivity: A,
    segmentId: i,
    sampled: o,
    previousSessionId: s
  };
}
function qv(t) {
  if (vv())
    try {
      Kr.sessionStorage.setItem(av, JSON.stringify(t));
    } catch {
    }
}
function x$(t, e) {
  return jF(t) ? "session" : e ? "buffer" : !1;
}
function eb({ sessionSampleRate: t, allowBuffering: e, stickySession: r = !1 }, { previousSessionId: n } = {}) {
  const A = x$(t, e), i = LF({
    sampled: A,
    previousSessionId: n
  });
  return r && qv(i), i;
}
function I$() {
  if (!vv())
    return null;
  try {
    const t = Kr.sessionStorage.getItem(av);
    if (!t)
      return null;
    const e = JSON.parse(t);
    return Yt && Wt.infoTick("Loading existing session"), LF(e);
  } catch {
    return null;
  }
}
function R5(t, e, r = +/* @__PURE__ */ new Date()) {
  return t === null || e === void 0 || e < 0 ? !0 : e === 0 ? !1 : t + e <= r;
}
function GF(t, {
  maxReplayDuration: e,
  sessionIdleExpire: r,
  targetTime: n = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    R5(t.started, e, n) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    R5(t.lastActivity, r, n)
  );
}
function RF(t, { sessionIdleExpire: e, maxReplayDuration: r }) {
  return !(!GF(t, { sessionIdleExpire: e, maxReplayDuration: r }) || t.sampled === "buffer" && t.segmentId === 0);
}
function N9({
  sessionIdleExpire: t,
  maxReplayDuration: e,
  previousSessionId: r
}, n) {
  const A = n.stickySession && I$();
  return A ? RF(A, { sessionIdleExpire: t, maxReplayDuration: e }) ? (Yt && Wt.infoTick("Session in sessionStorage is expired, creating new one..."), eb(n, { previousSessionId: A.id })) : A : (Yt && Wt.infoTick("Creating new session"), eb(n, { previousSessionId: r }));
}
function S$(t) {
  return t.type === fr.Custom;
}
function yv(t, e, r) {
  return YF(t, e) ? (zF(t, e, r), !0) : !1;
}
function P$(t, e, r) {
  return YF(t, e) ? zF(t, e, r) : Promise.resolve(null);
}
async function zF(t, e, r) {
  const { eventBuffer: n } = t;
  if (!n || n.waitForCheckout && !r)
    return null;
  const A = t.recordingMode === "buffer";
  try {
    r && A && n.clear(), r && (n.hasCheckout = !0, n.waitForCheckout = !1);
    const i = t.getOptions(), o = k$(e, i.beforeAddRecordingEvent);
    return o ? await n.addEvent(o) : void 0;
  } catch (i) {
    const o = i && i instanceof mv, s = o ? "addEventSizeExceeded" : "addEvent";
    if (o && A)
      return n.clear(), n.waitForCheckout = !0, null;
    t.handleException(i), await t.stop({ reason: s });
    const a = mr();
    a && a.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function YF(t, e) {
  if (!t.eventBuffer || t.isPaused() || !t.isEnabled())
    return !1;
  const r = gv(e.timestamp);
  return r + t.timeouts.sessionIdlePause < Date.now() ? !1 : r > t.getContext().initialTimestamp + t.getOptions().maxReplayDuration ? (Yt && Wt.infoTick(`Skipping event with timestamp ${r} because it is after maxReplayDuration`), !1) : !0;
}
function k$(t, e) {
  try {
    if (typeof e == "function" && S$(t))
      return e(t);
  } catch (r) {
    return Yt && Wt.exception(r, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event..."), null;
  }
  return t;
}
function Cv(t) {
  return !t.type;
}
function z5(t) {
  return t.type === "transaction";
}
function O$(t) {
  return t.type === "replay_event";
}
function tb(t) {
  return t.type === "feedback";
}
function F$(t) {
  return (e, r) => {
    if (!t.isEnabled() || !Cv(e) && !z5(e))
      return;
    const n = r && r.statusCode;
    if (!(!n || n < 200 || n >= 300)) {
      if (z5(e)) {
        T$(t, e);
        return;
      }
      M$(t, e);
    }
  };
}
function T$(t, e) {
  const r = t.getContext();
  e.contexts && e.contexts.trace && e.contexts.trace.trace_id && r.traceIds.size < 100 && r.traceIds.add(e.contexts.trace.trace_id);
}
function M$(t, e) {
  const r = t.getContext();
  if (e.event_id && r.errorIds.size < 100 && r.errorIds.add(e.event_id), t.recordingMode !== "buffer" || !e.tags || !e.tags.replayId)
    return;
  const { beforeErrorSampling: n } = t.getOptions();
  typeof n == "function" && !n(e) || Su(async () => {
    try {
      await t.sendBufferedReplayOrFlush();
    } catch (A) {
      t.handleException(A);
    }
  });
}
function H$(t) {
  return (e) => {
    !t.isEnabled() || !Cv(e) || D$(t, e);
  };
}
function D$(t, e) {
  const r = e.exception && e.exception.values && e.exception.values[0] && e.exception.values[0].value;
  if (typeof r == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  (r.match(
    /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
  ) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  r.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const n = jo({
      category: "replay.hydrate-error",
      data: {
        url: _k()
      }
    });
    I1(t, n);
  }
}
function Q$(t) {
  const e = mr();
  e && e.on("beforeAddBreadcrumb", (r) => U$(t, r));
}
function U$(t, e) {
  if (!t.isEnabled() || !VF(e))
    return;
  const r = N$(e);
  r && I1(t, r);
}
function N$(t) {
  return !VF(t) || [
    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
    "fetch",
    "xhr",
    // These two are breadcrumbs for emitted sentry events, we don't care about them
    "sentry.event",
    "sentry.transaction"
  ].includes(t.category) || // We capture UI breadcrumbs separately
  t.category.startsWith("ui.") ? null : t.category === "console" ? j$(t) : jo(t);
}
function j$(t) {
  const e = t.data && t.data.arguments;
  if (!Array.isArray(e) || e.length === 0)
    return jo(t);
  let r = !1;
  const n = e.map((A) => {
    if (!A)
      return A;
    if (typeof A == "string")
      return A.length > lf ? (r = !0, `${A.slice(0, lf)}…`) : A;
    if (typeof A == "object")
      try {
        const i = no(A, 7);
        return JSON.stringify(i).length > lf ? (r = !0, `${JSON.stringify(i, null, 2).slice(0, lf)}…`) : i;
      } catch {
      }
    return A;
  });
  return jo({
    ...t,
    data: {
      ...t.data,
      arguments: n,
      ...r ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function VF(t) {
  return !!t.category;
}
function L$(t, e) {
  return t.type || !t.exception || !t.exception.values || !t.exception.values.length ? !1 : !!(e.originalException && e.originalException.__rrweb__);
}
function WF() {
  const t = $r().getPropagationContext().dsc;
  t && delete t.replay_id;
  const e = aA();
  if (e) {
    const r = cl(e);
    delete r.replay_id;
  }
}
function G$(t, e) {
  t.triggerUserActivity(), t.addUpdate(() => e.timestamp ? (t.throttledAddEvent({
    type: fr.Custom,
    timestamp: e.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: e.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: e.event_id
        }
      }
    }
  }), !1) : !0);
}
function R$(t, e) {
  return t.recordingMode !== "buffer" || e.message === cv || !e.exception || e.type ? !1 : jF(t.getOptions().errorSampleRate);
}
function z$(t) {
  return Object.assign(
    (e, r) => !t.isEnabled() || t.isPaused() ? e : O$(e) ? (delete e.breadcrumbs, e) : !Cv(e) && !z5(e) && !tb(e) ? e : t.checkAndHandleExpiredSession() ? tb(e) ? (t.flush(), e.contexts.feedback.replay_id = t.getSessionId(), G$(t, e), e) : L$(e, r) && !t.getOptions()._experiments.captureExceptions ? (Yt && Wt.log("Ignoring error from rrweb internals", e), null) : ((R$(t, e) || t.recordingMode === "session") && (e.tags = { ...e.tags, replayId: t.getSessionId() }), e) : (WF(), e),
    { id: "Replay" }
  );
}
function Yg(t, e) {
  return e.map(({ type: r, start: n, end: A, name: i, data: o }) => {
    const s = t.throttledAddEvent({
      type: fr.Custom,
      timestamp: n,
      data: {
        tag: "performanceSpan",
        payload: {
          op: r,
          description: i,
          startTimestamp: n,
          endTimestamp: A,
          data: o
        }
      }
    });
    return typeof s == "string" ? Promise.resolve(null) : s;
  });
}
function Y$(t) {
  const { from: e, to: r } = t, n = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: n,
    end: n,
    name: r,
    data: {
      previous: e
    }
  };
}
function V$(t) {
  return (e) => {
    if (!t.isEnabled())
      return;
    const r = Y$(e);
    r !== null && (t.getContext().urls.push(r.name), t.triggerUserActivity(), t.addUpdate(() => (Yg(t, [r]), !1)));
  };
}
function W$(t, e) {
  return Yt && t.getOptions()._experiments.traceInternals ? !1 : YW(e, mr());
}
function XF(t, e) {
  t.isEnabled() && e !== null && (W$(t, e.name) || t.addUpdate(() => (Yg(t, [e]), !0)));
}
function Vg(t) {
  if (!t)
    return;
  const e = new TextEncoder();
  try {
    if (typeof t == "string")
      return e.encode(t).length;
    if (t instanceof URLSearchParams)
      return e.encode(t.toString()).length;
    if (t instanceof FormData) {
      const r = _F(t);
      return e.encode(r).length;
    }
    if (t instanceof Blob)
      return t.size;
    if (t instanceof ArrayBuffer)
      return t.byteLength;
  } catch {
  }
}
function KF(t) {
  if (!t)
    return;
  const e = parseInt(t, 10);
  return isNaN(e) ? void 0 : e;
}
function ZF(t) {
  try {
    if (typeof t == "string")
      return [t];
    if (t instanceof URLSearchParams)
      return [t.toString()];
    if (t instanceof FormData)
      return [_F(t)];
    if (!t)
      return [void 0];
  } catch (e) {
    return Yt && Wt.exception(e, "Failed to serialize body", t), [void 0, "BODY_PARSE_ERROR"];
  }
  return Yt && Wt.info("Skipping network body because of body type", t), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function c3(t, e) {
  if (!t)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [e]
      }
    };
  const r = { ...t._meta }, n = r.warnings || [];
  return r.warnings = [...n, e], t._meta = r, t;
}
function JF(t, e) {
  if (!e)
    return null;
  const { startTimestamp: r, endTimestamp: n, url: A, method: i, statusCode: o, request: s, response: a } = e;
  return {
    type: t,
    start: r / 1e3,
    end: n / 1e3,
    name: A,
    data: _n({
      method: i,
      statusCode: o,
      request: s,
      response: a
    })
  };
}
function w2(t) {
  return {
    headers: {},
    size: t,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function Pa(t, e, r) {
  if (!e && Object.keys(t).length === 0)
    return;
  if (!e)
    return {
      headers: t
    };
  if (!r)
    return {
      headers: t,
      size: e
    };
  const n = {
    headers: t,
    size: e
  }, { body: A, warnings: i } = X$(r);
  return n.body = A, i && i.length > 0 && (n._meta = {
    warnings: i
  }), n;
}
function Y5(t, e) {
  return Object.entries(t).reduce((r, [n, A]) => {
    const i = n.toLowerCase();
    return e.includes(i) && t[n] && (r[i] = A), r;
  }, {});
}
function _F(t) {
  return new URLSearchParams(t).toString();
}
function X$(t) {
  if (!t || typeof t != "string")
    return {
      body: t
    };
  const e = t.length > Hw, r = K$(t);
  if (e) {
    const n = t.slice(0, Hw);
    return r ? {
      body: n,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${n}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (r)
    try {
      return {
        body: JSON.parse(t)
      };
    } catch {
    }
  return {
    body: t
  };
}
function K$(t) {
  const e = t[0], r = t[t.length - 1];
  return e === "[" && r === "]" || e === "{" && r === "}";
}
function l3(t, e) {
  const r = Z$(t);
  return Sa(r, e);
}
function Z$(t, e = Kr.document.baseURI) {
  if (t.startsWith("http://") || t.startsWith("https://") || t.startsWith(Kr.location.origin))
    return t;
  const r = new URL(t, e);
  if (r.origin !== new URL(e).origin)
    return t;
  const n = r.href;
  return !t.endsWith("/") && n.endsWith("/") ? n.slice(0, -1) : n;
}
async function J$(t, e, r) {
  try {
    const n = await $$(t, e, r), A = JF("resource.fetch", n);
    XF(r.replay, A);
  } catch (n) {
    Yt && Wt.exception(n, "Failed to capture fetch breadcrumb");
  }
}
function _$(t, e) {
  const { input: r, response: n } = e, A = r ? $F(r) : void 0, i = Vg(A), o = n ? KF(n.headers.get("content-length")) : void 0;
  i !== void 0 && (t.data.request_body_size = i), o !== void 0 && (t.data.response_body_size = o);
}
async function $$(t, e, r) {
  const n = Date.now(), { startTimestamp: A = n, endTimestamp: i = n } = e, {
    url: o,
    method: s,
    status_code: a = 0,
    request_body_size: c,
    response_body_size: l
  } = t.data, u = l3(o, r.networkDetailAllowUrls) && !l3(o, r.networkDetailDenyUrls), f = u ? eee(r, e.input, c) : w2(c), d = await tee(u, r, e.response, l);
  return {
    startTimestamp: A,
    endTimestamp: i,
    url: o,
    method: s,
    statusCode: a,
    request: f,
    response: d
  };
}
function eee({ networkCaptureBodies: t, networkRequestHeaders: e }, r, n) {
  const A = r ? Aee(r, e) : {};
  if (!t)
    return Pa(A, n, void 0);
  const i = $F(r), [o, s] = ZF(i), a = Pa(A, n, o);
  return s ? c3(a, s) : a;
}
async function tee(t, {
  networkCaptureBodies: e,
  networkResponseHeaders: r
}, n, A) {
  if (!t && A !== void 0)
    return w2(A);
  const i = n ? eT(n.headers, r) : {};
  if (!n || !e && A !== void 0)
    return Pa(i, A, void 0);
  const [o, s] = await nee(n), a = ree(o, {
    networkCaptureBodies: e,
    responseBodySize: A,
    captureDetails: t,
    headers: i
  });
  return s ? c3(a, s) : a;
}
function ree(t, {
  networkCaptureBodies: e,
  responseBodySize: r,
  captureDetails: n,
  headers: A
}) {
  try {
    const i = t && t.length && r === void 0 ? Vg(t) : r;
    return n ? e ? Pa(A, i, t) : Pa(A, i, void 0) : w2(i);
  } catch (i) {
    return Yt && Wt.exception(i, "Failed to serialize response body"), Pa(A, r, void 0);
  }
}
async function nee(t) {
  const e = iee(t);
  if (!e)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await oee(e)];
  } catch (r) {
    return r instanceof Error && r.message.indexOf("Timeout") > -1 ? (Yt && Wt.warn("Parsing text body from response timed out"), [void 0, "BODY_PARSE_TIMEOUT"]) : (Yt && Wt.exception(r, "Failed to get text body from response"), [void 0, "BODY_PARSE_ERROR"]);
  }
}
function $F(t = []) {
  if (!(t.length !== 2 || typeof t[1] != "object"))
    return t[1].body;
}
function eT(t, e) {
  const r = {};
  return e.forEach((n) => {
    t.get(n) && (r[n] = t.get(n));
  }), r;
}
function Aee(t, e) {
  return t.length === 1 && typeof t[0] != "string" ? rb(t[0], e) : t.length === 2 ? rb(t[1], e) : {};
}
function rb(t, e) {
  if (!t)
    return {};
  const r = t.headers;
  return r ? r instanceof Headers ? eT(r, e) : Array.isArray(r) ? {} : Y5(r, e) : {};
}
function iee(t) {
  try {
    return t.clone();
  } catch (e) {
    Yt && Wt.exception(e, "Failed to clone response body");
  }
}
function oee(t) {
  return new Promise((e, r) => {
    const n = Su(() => r(new Error("Timeout while trying to read response body")), 500);
    see(t).then(
      (A) => e(A),
      (A) => r(A)
    ).finally(() => clearTimeout(n));
  });
}
async function see(t) {
  return await t.text();
}
async function aee(t, e, r) {
  try {
    const n = lee(t, e, r), A = JF("resource.xhr", n);
    XF(r.replay, A);
  } catch (n) {
    Yt && Wt.exception(n, "Failed to capture xhr breadcrumb");
  }
}
function cee(t, e) {
  const { xhr: r, input: n } = e;
  if (!r)
    return;
  const A = Vg(n), i = r.getResponseHeader("content-length") ? KF(r.getResponseHeader("content-length")) : hee(r.response, r.responseType);
  A !== void 0 && (t.data.request_body_size = A), i !== void 0 && (t.data.response_body_size = i);
}
function lee(t, e, r) {
  const n = Date.now(), { startTimestamp: A = n, endTimestamp: i = n, input: o, xhr: s } = e, {
    url: a,
    method: c,
    status_code: l = 0,
    request_body_size: u,
    response_body_size: f
  } = t.data;
  if (!a)
    return null;
  if (!s || !l3(a, r.networkDetailAllowUrls) || l3(a, r.networkDetailDenyUrls)) {
    const b = w2(u), q = w2(f);
    return {
      startTimestamp: A,
      endTimestamp: i,
      url: a,
      method: c,
      statusCode: l,
      request: b,
      response: q
    };
  }
  const d = s[yc], g = d ? Y5(d.request_headers, r.networkRequestHeaders) : {}, m = Y5(uee(s), r.networkResponseHeaders), [p, v] = r.networkCaptureBodies ? ZF(o) : [void 0], [C, w] = r.networkCaptureBodies ? dee(s) : [void 0], B = Pa(g, u, p), y = Pa(m, f, C);
  return {
    startTimestamp: A,
    endTimestamp: i,
    url: a,
    method: c,
    statusCode: l,
    request: v ? c3(B, v) : B,
    response: w ? c3(y, w) : y
  };
}
function uee(t) {
  const e = t.getAllResponseHeaders();
  return e ? e.split(`\r
`).reduce((r, n) => {
    const [A, i] = n.split(": ");
    return i && (r[A.toLowerCase()] = i), r;
  }, {}) : {};
}
function dee(t) {
  const e = [];
  try {
    return [t.responseText];
  } catch (r) {
    e.push(r);
  }
  try {
    return fee(t.response, t.responseType);
  } catch (r) {
    e.push(r);
  }
  return Yt && Wt.warn("Failed to get xhr response body", ...e), [void 0];
}
function fee(t, e) {
  try {
    if (typeof t == "string")
      return [t];
    if (t instanceof Document)
      return [t.body.outerHTML];
    if (e === "json" && t && typeof t == "object")
      return [JSON.stringify(t)];
    if (!t)
      return [void 0];
  } catch (r) {
    return Yt && Wt.exception(r, "Failed to serialize body", t), [void 0, "BODY_PARSE_ERROR"];
  }
  return Yt && Wt.info("Skipping network body because of body type", t), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function hee(t, e) {
  try {
    const r = e === "json" && t && typeof t == "object" ? JSON.stringify(t) : t;
    return Vg(r);
  } catch {
    return;
  }
}
function pee(t) {
  const e = mr();
  try {
    const {
      networkDetailAllowUrls: r,
      networkDetailDenyUrls: n,
      networkCaptureBodies: A,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    } = t.getOptions(), s = {
      replay: t,
      networkDetailAllowUrls: r,
      networkDetailDenyUrls: n,
      networkCaptureBodies: A,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    };
    e && e.on("beforeAddBreadcrumb", (a, c) => gee(s, a, c));
  } catch {
  }
}
function gee(t, e, r) {
  if (e.data)
    try {
      mee(e) && qee(r) && (cee(e, r), aee(e, r, t)), vee(e) && yee(r) && (_$(e, r), J$(e, r, t));
    } catch (n) {
      Yt && Wt.exception(n, "Error when enriching network breadcrumb");
    }
}
function mee(t) {
  return t.category === "xhr";
}
function vee(t) {
  return t.category === "fetch";
}
function qee(t) {
  return t && t.xhr;
}
function yee(t) {
  return t && t.response;
}
function Cee(t) {
  const e = mr();
  aF(Z_(t)), jg(V$(t)), Q$(t), pee(t);
  const r = z$(t);
  BW(r), e && (e.on("beforeSendEvent", H$(t)), e.on("afterSendEvent", F$(t)), e.on("createDsc", (n) => {
    const A = t.getSessionId();
    A && t.isEnabled() && t.recordingMode === "session" && t.checkAndHandleExpiredSession() && (n.replay_id = A);
  }), e.on("spanStart", (n) => {
    t.lastActiveSpan = n;
  }), e.on("spanEnd", (n) => {
    t.lastActiveSpan = n;
  }), e.on("beforeSendFeedback", (n, A) => {
    const i = t.getSessionId();
    A && A.includeReplay && t.isEnabled() && i && n.contexts && n.contexts.feedback && (n.contexts.feedback.replay_id = i);
  }));
}
async function wee(t) {
  try {
    return Promise.all(
      Yg(t, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        bee(Kr.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function bee(t) {
  const { jsHeapSizeLimit: e, totalJSHeapSize: r, usedJSHeapSize: n } = t, A = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: A,
    end: A,
    data: {
      memory: {
        jsHeapSizeLimit: e,
        totalJSHeapSize: r,
        usedJSHeapSize: n
      }
    }
  };
}
function Bee(t, e, r) {
  let n, A, i;
  const o = r.maxWait ? Math.max(r.maxWait, e) : 0;
  function s() {
    return a(), n = t(), n;
  }
  function a() {
    A !== void 0 && clearTimeout(A), i !== void 0 && clearTimeout(i), A = i = void 0;
  }
  function c() {
    return A !== void 0 || i !== void 0 ? s() : n;
  }
  function l() {
    return A && clearTimeout(A), A = Su(s, e), o && i === void 0 && (i = Su(s, o)), n;
  }
  return l.cancel = a, l.flush = c, l;
}
const lc = qr.navigator;
function Eee() {
  return /iPhone|iPad|iPod/i.test(lc && lc.userAgent || "") || /Macintosh/i.test(lc && lc.userAgent || "") && lc && lc.maxTouchPoints && lc.maxTouchPoints > 1 ? {
    sampling: {
      mousemove: !1
    }
  } : {};
}
function xee(t) {
  let e = !1;
  return (r, n) => {
    if (!t.checkAndHandleExpiredSession()) {
      Yt && Wt.warn("Received replay event after session expired.");
      return;
    }
    const A = n || !e;
    e = !0, t.clickDetector && Y_(t.clickDetector, r), t.addUpdate(() => {
      if (t.recordingMode === "buffer" && A && t.setInitialState(), !yv(t, r, A))
        return !0;
      if (!A)
        return !1;
      const i = t.session;
      if (See(t, A), t.recordingMode === "buffer" && i && t.eventBuffer) {
        const o = t.eventBuffer.getEarliestTimestamp();
        o && (Yt && Wt.info(`Updating session start time to earliest event in buffer to ${new Date(o)}`), i.started = o, t.getOptions().stickySession && qv(i));
      }
      return i && i.previousSessionId || t.recordingMode === "session" && t.flush(), !0;
    });
  };
}
function Iee(t) {
  const e = t.getOptions();
  return {
    type: fr.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: t.isRecordingCanvas(),
        sessionSampleRate: e.sessionSampleRate,
        errorSampleRate: e.errorSampleRate,
        useCompressionOption: e.useCompression,
        blockAllMedia: e.blockAllMedia,
        maskAllText: e.maskAllText,
        maskAllInputs: e.maskAllInputs,
        useCompression: t.eventBuffer ? t.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: e.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: e.networkCaptureBodies,
        networkRequestHasHeaders: e.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: e.networkResponseHeaders.length > 0
      }
    }
  };
}
function See(t, e) {
  !e || !t.session || t.session.segmentId !== 0 || yv(t, Iee(t), !1);
}
function Pee(t, e, r, n) {
  return ll(
    wO(t, $m(t), n, r),
    [
      [{ type: "replay_event" }, t],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof e == "string" ? new TextEncoder().encode(e).length : e.length
        },
        e
      ]
    ]
  );
}
function kee({
  recordingData: t,
  headers: e
}) {
  let r;
  const n = `${JSON.stringify(e)}
`;
  if (typeof t == "string")
    r = `${n}${t}`;
  else {
    const i = new TextEncoder().encode(n);
    r = new Uint8Array(i.length + t.length), r.set(i), r.set(t, i.length);
  }
  return r;
}
async function Oee({
  client: t,
  scope: e,
  replayId: r,
  event: n
}) {
  const A = typeof t._integrations == "object" && t._integrations !== null && !Array.isArray(t._integrations) ? Object.keys(t._integrations) : void 0, i = { event_id: r, integrations: A };
  t.emit("preprocessEvent", n, i);
  const o = await IO(
    t.getOptions(),
    n,
    i,
    e,
    t,
    qo()
  );
  if (!o)
    return null;
  o.platform = o.platform || "javascript";
  const s = t.getSdkMetadata(), { name: a, version: c } = s && s.sdk || {};
  return o.sdk = {
    ...o.sdk,
    name: a || "sentry.javascript.unknown",
    version: c || "0.0.0"
  }, o;
}
async function Fee({
  recordingData: t,
  replayId: e,
  segmentId: r,
  eventContext: n,
  timestamp: A,
  session: i
}) {
  const o = kee({
    recordingData: t,
    headers: {
      segment_id: r
    }
  }), { urls: s, errorIds: a, traceIds: c, initialTimestamp: l } = n, u = mr(), f = $r(), d = u && u.getTransport(), g = u && u.getDsn();
  if (!u || !d || !g || !i.sampled)
    return Fs({});
  const m = {
    type: lJ,
    replay_start_timestamp: l / 1e3,
    timestamp: A / 1e3,
    error_ids: a,
    trace_ids: c,
    urls: s,
    replay_id: e,
    segment_id: r,
    replay_type: i.sampled
  }, p = await Oee({ scope: f, client: u, replayId: e, event: m });
  if (!p)
    return u.recordDroppedEvent("event_processor", "replay", m), Yt && Wt.info("An event processor returned `null`, will not send event."), Fs({});
  delete p.sdkProcessingMetadata;
  const v = Pee(p, o, g, u.getOptions().tunnel);
  let C;
  try {
    C = await d.send(v);
  } catch (B) {
    const y = new Error(cv);
    try {
      y.cause = B;
    } catch {
    }
    throw y;
  }
  if (typeof C.statusCode == "number" && (C.statusCode < 200 || C.statusCode >= 300))
    throw new tT(C.statusCode);
  const w = DO({}, C);
  if (HO(w, "replay"))
    throw new wv(w);
  return C;
}
class tT extends Error {
  constructor(e) {
    super(`Transport returned status code ${e}`);
  }
}
class wv extends Error {
  constructor(e) {
    super("Rate limit hit"), this.rateLimits = e;
  }
}
async function rT(t, e = {
  count: 0,
  interval: gJ
}) {
  const { recordingData: r, onError: n } = t;
  if (r.length)
    try {
      return await Fee(t), !0;
    } catch (A) {
      if (A instanceof tT || A instanceof wv)
        throw A;
      if (PO("Replays", {
        _retryCount: e.count
      }), n && n(A), e.count >= mJ) {
        const i = new Error(`${cv} - max retries exceeded`);
        try {
          i.cause = A;
        } catch {
        }
        throw i;
      }
      return e.interval *= ++e.count, new Promise((i, o) => {
        Su(async () => {
          try {
            await rT(t, e), i(!0);
          } catch (s) {
            o(s);
          }
        }, e.interval);
      });
    }
}
const nT = "__THROTTLED", Tee = "__SKIPPED";
function Mee(t, e, r) {
  const n = /* @__PURE__ */ new Map(), A = (s) => {
    const a = s - r;
    n.forEach((c, l) => {
      l < a && n.delete(l);
    });
  }, i = () => [...n.values()].reduce((s, a) => s + a, 0);
  let o = !1;
  return (...s) => {
    const a = Math.floor(Date.now() / 1e3);
    if (A(a), i() >= e) {
      const l = o;
      return o = !0, l ? Tee : nT;
    }
    o = !1;
    const c = n.get(a) || 0;
    return n.set(a, c + 1), t(...s);
  };
}
class fa {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  constructor({
    options: e,
    recordingOptions: r
  }) {
    fa.prototype.__init.call(this), fa.prototype.__init2.call(this), fa.prototype.__init3.call(this), fa.prototype.__init4.call(this), fa.prototype.__init5.call(this), fa.prototype.__init6.call(this), this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: uJ,
      sessionIdleExpire: dJ
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._requiresManualStart = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = r, this._options = e, this._debouncedFlush = Bee(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = Mee(
      (o, s) => P$(this, o, s),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: n, slowClickIgnoreSelectors: A } = this.getOptions(), i = n ? {
      threshold: Math.min(vJ, n),
      timeout: n,
      scrollTimeout: qJ,
      ignoreSelector: A ? A.join(",") : ""
    } : void 0;
    if (i && (this.clickDetector = new L_(this, i)), Yt) {
      const o = e._experiments;
      Wt.setConfig({
        captureExceptions: !!o.captureExceptions,
        traceInternals: !!o.traceInternals
      });
    }
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /** A wrapper to conditionally capture exceptions. */
  handleException(e) {
    Yt && Wt.exception(e), this._options.onError && this._options.onError(e);
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(e) {
    const { errorSampleRate: r, sessionSampleRate: n } = this._options, A = r <= 0 && n <= 0;
    if (this._requiresManualStart = A, !A) {
      if (this._initializeSessionForSampling(e), !this.session) {
        Yt && Wt.exception(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", Yt && Wt.infoTick(`Starting replay in ${this.recordingMode} mode`), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session") {
      Yt && Wt.info("Recording is already in progress");
      return;
    }
    if (this._isEnabled && this.recordingMode === "buffer") {
      Yt && Wt.info("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    Yt && Wt.infoTick("Starting replay in session mode"), this._updateUserActivity();
    const e = N9(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = e, this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      Yt && Wt.info("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    Yt && Wt.infoTick("Starting replay in buffer mode");
    const e = N9(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = e, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const e = this._canvas;
      this._stopRecording = Cs({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" ? { checkoutEveryNms: pJ } : (
          // Otherwise, use experimental option w/ min checkout time of 6 minutes
          // This is to improve playback seeking as there could potentially be
          // less mutations to process in the worse cases.
          //
          // checkout by "N" events is probably ideal, but means we have less
          // control about the number of checkouts we make (which generally
          // increases replay size)
          this._options._experiments.continuousCheckout && {
            // Minimum checkout time is 6 minutes
            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
          }
        ),
        emit: xee(this),
        ...Eee(),
        onMutation: this._onMutationHandler,
        ...e ? {
          recordCanvas: e.recordCanvas,
          getCanvasManager: e.getCanvasManager,
          sampling: e.sampling,
          dataURLOptions: e.dataURLOptions
        } : {}
      });
    } catch (e) {
      this.handleException(e);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (e) {
      return this.handleException(e), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: e = !1, reason: r } = {}) {
    if (this._isEnabled) {
      this._isEnabled = !1;
      try {
        Yt && Wt.info(`Stopping Replay${r ? ` triggered by ${r}` : ""}`), WF(), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), e && await this._flush({ force: !0 }), this.eventBuffer && this.eventBuffer.destroy(), this.eventBuffer = null, B$(this);
      } catch (n) {
        this.handleException(n);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), Yt && Wt.info("Pausing replay"));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), Yt && Wt.info("Resuming replay"));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: e = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const r = Date.now();
    Yt && Wt.info("Converting buffer to session"), await this.flushImmediate();
    const n = this.stopRecording();
    !e || !n || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(r), this._updateSessionActivity(r), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(e) {
    const r = e();
    this.recordingMode !== "buffer" && r !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current session (=replay) ID */
  getSessionId() {
    return this.session && this.session.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && R5(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const e = `${Kr.location.pathname}${Kr.location.hash}${Kr.location.search}`, r = `${Kr.location.origin}${e}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = r, this._context.initialTimestamp = Date.now(), this._context.urls.push(r);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(e, r) {
    const n = this._throttledAddEvent(e, r);
    if (n === nT) {
      const A = jo({
        category: "replay.throttled"
      });
      this.addUpdate(() => !yv(this, {
        type: M_,
        timestamp: A.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: A,
          metric: !0
        }
      }));
    }
    return n;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const e = this.lastActiveSpan || aA(), r = e && wA(e), A = (r && kr(r).data || {})[No];
    if (!(!r || !A || !["route", "custom"].includes(A)))
      return kr(r).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = C$({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(e) {
    const r = this._options.errorSampleRate > 0, n = N9(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId: e
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: r
      }
    );
    this.session = n;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const e = this.session;
    return RF(e, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(e), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(e) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(e.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      Kr.document.addEventListener("visibilitychange", this._handleVisibilityChange), Kr.addEventListener("blur", this._handleWindowBlur), Kr.addEventListener("focus", this._handleWindowFocus), Kr.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (Cee(this), this._hasInitializedCoreListeners = !0);
    } catch (e) {
      this.handleException(e);
    }
    this._performanceCleanupCallback = h$(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      Kr.document.removeEventListener("visibilitychange", this._handleVisibilityChange), Kr.removeEventListener("blur", this._handleWindowBlur), Kr.removeEventListener("focus", this._handleWindowFocus), Kr.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (e) {
      this.handleException(e);
    }
  }
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  __init() {
    this._handleVisibilityChange = () => {
      Kr.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    };
  }
  /**
   * Handle when page is blurred
   */
  __init2() {
    this._handleWindowBlur = () => {
      const e = jo({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(e);
    };
  }
  /**
   * Handle when page is focused
   */
  __init3() {
    this._handleWindowFocus = () => {
      const e = jo({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(e);
    };
  }
  /** Ensure page remains active when a key is pressed. */
  __init4() {
    this._handleKeyboardEvent = (e) => {
      e$(this, e);
    };
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(e) {
    !this.session || GF(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (e && this._createCustomBreadcrumb(e), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(e) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      Yt && Wt.info("Document has become active, but session has expired");
      return;
    }
    e && this._createCustomBreadcrumb(e);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(e = Date.now()) {
    this._lastActivity = e;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(e = Date.now()) {
    this.session && (this.session.lastActivity = e, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(e) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: fr.Custom,
        timestamp: e.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: e
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let e = A$(this.performanceEntries).concat(this.replayPerformanceEntries);
    if (this.performanceEntries = [], this.replayPerformanceEntries = [], this._requiresManualStart) {
      const r = this._context.initialTimestamp / 1e3;
      e = e.filter((n) => n.start >= r);
    }
    return Promise.all(Yg(this, e));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: e, eventBuffer: r } = this;
    if (!e || !r || this._requiresManualStart || e.segmentId)
      return;
    const n = r.getEarliestTimestamp();
    n && n < this._context.initialTimestamp && (this._context.initialTimestamp = n);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const e = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), e;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const e = this.getSessionId();
    if (!this.session || !this.eventBuffer || !e) {
      Yt && Wt.error("No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !(!this.eventBuffer || !this.eventBuffer.hasEvents) && (await wee(this), !!this.eventBuffer && e === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const r = Date.now();
        if (r - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const n = this._popEventContext(), A = this.session.segmentId++;
        this._maybeSaveSession();
        const i = await this.eventBuffer.finish();
        await rT({
          replayId: e,
          recordingData: i,
          segmentId: A,
          eventContext: n,
          session: this.session,
          timestamp: r,
          onError: (o) => this.handleException(o)
        });
      } catch (r) {
        this.handleException(r), this.stop({ reason: "sendReplay" });
        const n = mr();
        if (n) {
          const A = r instanceof wv ? "ratelimit_backoff" : "send_error";
          n.recordDroppedEvent(A, "replay");
        }
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  __init5() {
    this._flush = async ({
      force: e = !1
    } = {}) => {
      if (!this._isEnabled && !e)
        return;
      if (!this.checkAndHandleExpiredSession()) {
        Yt && Wt.error("Attempting to finish replay event after session expired.");
        return;
      }
      if (!this.session)
        return;
      const r = this.session.started, A = Date.now() - r;
      this._debouncedFlush.cancel();
      const i = A < this._options.minReplayDuration, o = A > this._options.maxReplayDuration + 5e3;
      if (i || o) {
        Yt && Wt.info(
          `Session duration (${Math.floor(A / 1e3)}s) is too ${i ? "short" : "long"}, not sending replay.`
        ), i && this._debouncedFlush();
        return;
      }
      const s = this.eventBuffer;
      s && this.session.segmentId === 0 && !s.hasCheckout && Yt && Wt.info("Flushing initial segment without checkout.");
      const a = !!this._flushLock;
      this._flushLock || (this._flushLock = this._runFlush());
      try {
        await this._flushLock;
      } catch (c) {
        this.handleException(c);
      } finally {
        this._flushLock = void 0, a && this._debouncedFlush();
      }
    };
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && qv(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  __init6() {
    this._onMutationHandler = (e) => {
      const r = e.length, n = this._options.mutationLimit, A = this._options.mutationBreadcrumbLimit, i = n && r > n;
      if (r > A || i) {
        const o = jo({
          category: "replay.mutations",
          data: {
            count: r,
            limit: i
          }
        });
        this._createCustomBreadcrumb(o);
      }
      return i ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
    };
  }
}
function u0(t, e) {
  return [
    ...t,
    // sentry defaults
    ...e
  ].join(",");
}
function Hee({ mask: t, unmask: e, block: r, unblock: n, ignore: A }) {
  const i = ["base", "iframe[srcdoc]:not([src])"], o = u0(t, [".sentry-mask", "[data-sentry-mask]"]), s = u0(e, []);
  return {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: o,
    unmaskTextSelector: s,
    blockSelector: u0(r, [".sentry-block", "[data-sentry-block]", ...i]),
    unblockSelector: u0(n, []),
    ignoreSelector: u0(A, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
  };
}
function Dee({
  el: t,
  key: e,
  maskAttributes: r,
  maskAllText: n,
  privacyOptions: A,
  value: i
}) {
  return !n || A.unmaskTextSelector && t.matches(A.unmaskTextSelector) ? i : r.includes(e) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  e === "value" && t.tagName === "INPUT" && ["submit", "button"].includes(t.getAttribute("type") || "") ? i.replace(/[\S]/g, "*") : i;
}
const nb = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', Qee = ["content-length", "content-type", "accept"];
let Ab = !1;
const Uee = (t) => new Wg(t);
class Wg {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Replay";
  }
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: e = fJ,
    flushMaxDelay: r = hJ,
    minReplayDuration: n = yJ,
    maxReplayDuration: A = Dw,
    stickySession: i = !0,
    useCompression: o = !0,
    workerUrl: s,
    _experiments: a = {},
    maskAllText: c = !0,
    maskAllInputs: l = !0,
    blockAllMedia: u = !0,
    mutationBreadcrumbLimit: f = 750,
    mutationLimit: d = 1e4,
    slowClickTimeout: g = 7e3,
    slowClickIgnoreSelectors: m = [],
    networkDetailAllowUrls: p = [],
    networkDetailDenyUrls: v = [],
    networkCaptureBodies: C = !0,
    networkRequestHeaders: w = [],
    networkResponseHeaders: B = [],
    mask: y = [],
    maskAttributes: b = ["title", "placeholder"],
    unmask: q = [],
    block: E = [],
    unblock: x = [],
    ignore: M = [],
    maskFn: O,
    beforeAddRecordingEvent: I,
    beforeErrorSampling: S,
    onError: P
  } = {}) {
    this.name = Wg.id;
    const H = Hee({
      mask: y,
      unmask: q,
      block: E,
      unblock: x,
      ignore: M
    });
    if (this._recordingOptions = {
      maskAllInputs: l,
      maskAllText: c,
      maskInputOptions: { password: !0 },
      maskTextFn: O,
      maskInputFn: O,
      maskAttributeFn: (F, T, U) => Dee({
        maskAttributes: b,
        maskAllText: c,
        privacyOptions: H,
        key: F,
        value: T,
        el: U
      }),
      ...H,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (F) => {
        try {
          F.__rrweb__ = !0;
        } catch {
        }
      }
    }, this._initialOptions = {
      flushMinDelay: e,
      flushMaxDelay: r,
      minReplayDuration: Math.min(n, CJ),
      maxReplayDuration: Math.min(A, Dw),
      stickySession: i,
      useCompression: o,
      workerUrl: s,
      blockAllMedia: u,
      maskAllInputs: l,
      maskAllText: c,
      mutationBreadcrumbLimit: f,
      mutationLimit: d,
      slowClickTimeout: g,
      slowClickIgnoreSelectors: m,
      networkDetailAllowUrls: p,
      networkDetailDenyUrls: v,
      networkCaptureBodies: C,
      networkRequestHeaders: ib(w),
      networkResponseHeaders: ib(B),
      beforeAddRecordingEvent: I,
      beforeErrorSampling: S,
      onError: P,
      _experiments: a
    }, this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${nb}` : nb), this._isInitialized && xw())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return Ab;
  }
  /** Update _isInitialized */
  set _isInitialized(e) {
    Ab = e;
  }
  /**
   * Setup and initialize replay container
   */
  afterAllSetup(e) {
    !xw() || this._replay || (this._setup(e), this._initialize(e));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(e) {
    return this._replay ? this._replay.isEnabled() ? this._replay.sendBufferedReplayOrFlush(e) : (this._replay.start(), Promise.resolve()) : Promise.resolve();
  }
  /**
   * Get the current session ID.
   */
  getReplayId() {
    if (!(!this._replay || !this._replay.isEnabled()))
      return this._replay.getSessionId();
  }
  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    if (!(!this._replay || !this._replay.isEnabled()))
      return this._replay.recordingMode;
  }
  /**
   * Initializes replay.
   */
  _initialize(e) {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(e), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup(e) {
    const r = Nee(this._initialOptions, e);
    this._replay = new fa({
      options: r,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(e) {
    try {
      const r = e.getIntegrationByName("ReplayCanvas");
      if (!r)
        return;
      this._replay._canvas = r.getOptions();
    } catch {
    }
  }
}
Wg.__initStatic();
function Nee(t, e) {
  const r = e.getOptions(), n = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ..._n(t)
  }, A = _h(r.replaysSessionSampleRate), i = _h(r.replaysOnErrorSampleRate);
  return A == null && i == null && Ja(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), A != null && (n.sessionSampleRate = A), i != null && (n.errorSampleRate = i), n;
}
function ib(t) {
  return [...Qee, ...t.map((e) => e.toLowerCase())];
}
const ob = /* @__PURE__ */ new WeakMap(), j9 = /* @__PURE__ */ new Map(), yh = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  trackFetchStreamPerformance: !1
};
function jee(t, e) {
  const {
    traceFetch: r,
    traceXHR: n,
    trackFetchStreamPerformance: A,
    shouldCreateSpanForRequest: i,
    enableHTTPTimings: o,
    tracePropagationTargets: s
  } = {
    traceFetch: yh.traceFetch,
    traceXHR: yh.traceXHR,
    trackFetchStreamPerformance: yh.trackFetchStreamPerformance,
    ...e
  }, a = typeof i == "function" ? i : (u) => !0, c = (u) => Ree(u, s), l = {};
  r && (t.addEventProcessor((u) => (u.type === "transaction" && u.spans && u.spans.forEach((f) => {
    if (f.op === "http.client") {
      const d = j9.get(f.span_id);
      d && (f.timestamp = d / 1e3, j9.delete(f.span_id));
    }
  }), u)), A && kX((u) => {
    if (u.response) {
      const f = ob.get(u.response);
      f && u.endTimestamp && j9.set(f, u.endTimestamp);
    }
  }), zO((u) => {
    const f = bX(u, a, c, l);
    if (u.response && u.fetchData.__span && ob.set(u.response, u.fetchData.__span), f) {
      const d = AT(u.fetchData.url), g = d ? Uc(d).host : void 0;
      f.setAttributes({
        "http.url": d,
        "server.address": g
      });
    }
    o && f && sb(f);
  })), n && lF((u) => {
    const f = zee(u, a, c, l);
    o && f && sb(f);
  });
}
function Lee(t) {
  return t.entryType === "resource" && "initiatorType" in t && typeof t.nextHopProtocol == "string" && (t.initiatorType === "fetch" || t.initiatorType === "xmlhttprequest");
}
function sb(t) {
  const { url: e } = kr(t).data || {};
  if (!e || typeof e != "string")
    return;
  const r = Iu("resource", ({ entries: n }) => {
    n.forEach((A) => {
      Lee(A) && A.name.endsWith(e) && (Gee(A).forEach((o) => t.setAttribute(...o)), setTimeout(r));
    });
  });
}
function Oo(t = 0) {
  return ((ZA || performance.timeOrigin) + t) / 1e3;
}
function Gee(t) {
  const { name: e, version: r } = sF(t.nextHopProtocol), n = [];
  return n.push(["network.protocol.version", r], ["network.protocol.name", e]), ZA ? [
    ...n,
    ["http.request.redirect_start", Oo(t.redirectStart)],
    ["http.request.fetch_start", Oo(t.fetchStart)],
    ["http.request.domain_lookup_start", Oo(t.domainLookupStart)],
    ["http.request.domain_lookup_end", Oo(t.domainLookupEnd)],
    ["http.request.connect_start", Oo(t.connectStart)],
    ["http.request.secure_connection_start", Oo(t.secureConnectionStart)],
    ["http.request.connection_end", Oo(t.connectEnd)],
    ["http.request.request_start", Oo(t.requestStart)],
    ["http.request.response_start", Oo(t.responseStart)],
    ["http.request.response_end", Oo(t.responseEnd)]
  ] : n;
}
function Ree(t, e) {
  const r = $t.location && $t.location.href;
  if (r) {
    let n, A;
    try {
      n = new URL(t, r), A = new URL(r).origin;
    } catch {
      return !1;
    }
    const i = n.origin === A;
    return e ? Sa(n.toString(), e) || i && Sa(n.pathname, e) : i;
  } else {
    const n = !!t.match(/^\/(?!\/)/);
    return e ? Sa(t, e) : n;
  }
}
function zee(t, e, r, n) {
  const A = t.xhr, i = A && A[yc];
  if (!A || A.__sentry_own_request__ || !i)
    return;
  const o = Na() && e(i.url);
  if (t.endTimestamp && o) {
    const u = A.__sentry_xhr_span_id__;
    if (!u) return;
    const f = n[u];
    f && i.status_code !== void 0 && (oO(f, i.status_code), f.end(), delete n[u]);
    return;
  }
  const s = AT(i.url), a = s ? Uc(s).host : void 0, c = !!aA(), l = o && c ? C1({
    name: `${i.method} ${i.url}`,
    attributes: {
      type: "xhr",
      "http.method": i.method,
      "http.url": s,
      url: i.url,
      "server.address": a,
      [sA]: "auto.http.browser",
      [Zc]: "http.client"
    }
  }) : new Ed();
  return A.__sentry_xhr_span_id__ = l.spanContext().spanId, n[A.__sentry_xhr_span_id__] = l, r(i.url) && Yee(
    A,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    Na() && c ? l : void 0
  ), l;
}
function Yee(t, e) {
  const { "sentry-trace": r, baggage: n } = UO({ span: e });
  r && Vee(t, r, n);
}
function Vee(t, e, r) {
  try {
    t.setRequestHeader("sentry-trace", e), r && t.setRequestHeader("baggage", r);
  } catch {
  }
}
function AT(t) {
  try {
    return new URL(t, $t.location.origin).href;
  } catch {
    return;
  }
}
function Wee() {
  $t && $t.document ? $t.document.addEventListener("visibilitychange", () => {
    const t = aA();
    if (!t)
      return;
    const e = wA(t);
    if ($t.document.hidden && e) {
      const r = "cancelled", { op: n, status: A } = kr(e);
      Zo && ft.log(`[Tracing] Transaction: ${r} -> since tab moved to the background, op: ${n}`), A || e.setStatus({ code: iA, message: r }), e.setAttribute("sentry.cancellation_reason", "document.hidden"), e.end();
    }
  }) : Zo && ft.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const Xee = "BrowserTracing", Kee = {
  ...ph,
  instrumentNavigation: !0,
  instrumentPageLoad: !0,
  markBackgroundSpan: !0,
  enableLongTask: !0,
  enableLongAnimationFrame: !0,
  enableInp: !0,
  _experiments: {},
  ...yh
}, Zee = (t = {}) => {
  IV();
  const {
    enableInp: e,
    enableLongTask: r,
    enableLongAnimationFrame: n,
    _experiments: { enableInteractions: A, enableStandaloneClsSpans: i },
    beforeStartSpan: o,
    idleTimeout: s,
    finalTimeout: a,
    childSpanTimeout: c,
    markBackgroundSpan: l,
    traceFetch: u,
    traceXHR: f,
    trackFetchStreamPerformance: d,
    shouldCreateSpanForRequest: g,
    enableHTTPTimings: m,
    instrumentPageLoad: p,
    instrumentNavigation: v
  } = {
    ...Kee,
    ...t
  }, C = NK({ recordClsStandaloneSpans: i || !1 });
  e && lZ(), n && qr.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") ? LK() : r && jK(), A && GK();
  const w = {
    name: void 0,
    source: void 0
  };
  function B(y, b) {
    const q = b.op === "pageload", E = o ? o(b) : b, x = E.attributes || {};
    b.name !== E.name && (x[No] = "custom", E.attributes = x), w.name = E.name, w.source = x[No];
    const M = xO(E, {
      idleTimeout: s,
      finalTimeout: a,
      childSpanTimeout: c,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: q,
      beforeSpanEnd: (I) => {
        C(), WK(I, { recordClsOnPageloadSpan: !i });
      }
    });
    function O() {
      ["interactive", "complete"].includes($t.document.readyState) && y.emit("idleSpanEnableAutoFinish", M);
    }
    return q && $t.document && ($t.document.addEventListener("readystatechange", () => {
      O();
    }), O()), M;
  }
  return {
    name: Xee,
    afterAllSetup(y) {
      let b, q = $t.location && $t.location.href;
      function E() {
        b && !kr(b).timestamp && (Zo && ft.log(`[Tracing] Finishing current active span with op: ${kr(b).op}`), b.end());
      }
      y.on("startNavigationSpan", (x) => {
        mr() === y && (E(), b = B(y, {
          op: "navigation",
          ...x
        }));
      }), y.on("startPageLoadSpan", (x, M = {}) => {
        if (mr() !== y)
          return;
        E();
        const O = M.sentryTrace || ab("sentry-trace"), I = M.baggage || ab("baggage"), S = yV(O, I);
        $r().setPropagationContext(S), b = B(y, {
          op: "pageload",
          ...x
        });
      }), y.on("spanEnd", (x) => {
        const M = kr(x).op;
        if (x !== wA(x) || M !== "navigation" && M !== "pageload")
          return;
        const O = $r(), I = O.getPropagationContext();
        O.setPropagationContext({
          ...I,
          sampled: I.sampled !== void 0 ? I.sampled : al(x),
          dsc: I.dsc || cl(x)
        });
      }), $t.location && (p && Jee(y, {
        name: $t.location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTime: ZA ? ZA / 1e3 : void 0,
        attributes: {
          [No]: "url",
          [sA]: "auto.pageload.browser"
        }
      }), v && jg(({ to: x, from: M }) => {
        if (M === void 0 && q && q.indexOf(x) !== -1) {
          q = void 0;
          return;
        }
        M !== x && (q = void 0, _ee(y, {
          name: $t.location.pathname,
          attributes: {
            [No]: "url",
            [sA]: "auto.navigation.browser"
          }
        }));
      })), l && Wee(), A && $ee(s, a, c, w), e && dZ(), jee(y, {
        traceFetch: u,
        traceXHR: f,
        trackFetchStreamPerformance: d,
        tracePropagationTargets: y.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: g,
        enableHTTPTimings: m
      });
    }
  };
};
function Jee(t, e, r) {
  t.emit("startPageLoadSpan", e, r), $r().setTransactionName(e.name);
  const n = aA();
  return (n && kr(n).op) === "pageload" ? n : void 0;
}
function _ee(t, e) {
  qo().setPropagationContext({ traceId: Qa() }), $r().setPropagationContext({ traceId: Qa() }), t.emit("startNavigationSpan", e), $r().setTransactionName(e.name);
  const r = aA();
  return (r && kr(r).op) === "navigation" ? r : void 0;
}
function ab(t) {
  const e = VY(`meta[name=${t}]`);
  return e ? e.getAttribute("content") : void 0;
}
function $ee(t, e, r, n) {
  let A;
  const i = () => {
    const o = "ui.action.click", s = aA(), a = s && wA(s);
    if (a) {
      const c = kr(a).op;
      if (["navigation", "pageload"].includes(c)) {
        Zo && ft.warn(`[Tracing] Did not create ${o} span because a pageload or navigation span is in progress.`);
        return;
      }
    }
    if (A && (A.setAttribute(q5, "interactionInterrupted"), A.end(), A = void 0), !n.name) {
      Zo && ft.warn(`[Tracing] Did not create ${o} transaction because _latestRouteName is missing.`);
      return;
    }
    A = xO(
      {
        name: n.name,
        op: o,
        attributes: {
          [No]: n.source || "url"
        }
      },
      {
        idleTimeout: t,
        finalTimeout: e,
        childSpanTimeout: r
      }
    );
  };
  $t.document && addEventListener("click", i, { once: !1, capture: !0 });
}
function ete(t) {
  const e = {
    ...t
  };
  return QO(e, "react"), PO("react", { version: bj }), cJ(e);
}
var hf = { exports: {} }, Mr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cb;
function tte() {
  if (cb) return Mr;
  cb = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, A = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, a = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, l = t ? Symbol.for("react.forward_ref") : 60112, u = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, d = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, p = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, C = t ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case e:
          switch (y = y.type, y) {
            case a:
            case c:
            case n:
            case i:
            case A:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case l:
                case g:
                case d:
                case o:
                  return y;
                default:
                  return b;
              }
          }
        case r:
          return b;
      }
    }
  }
  function B(y) {
    return w(y) === c;
  }
  return Mr.AsyncMode = a, Mr.ConcurrentMode = c, Mr.ContextConsumer = s, Mr.ContextProvider = o, Mr.Element = e, Mr.ForwardRef = l, Mr.Fragment = n, Mr.Lazy = g, Mr.Memo = d, Mr.Portal = r, Mr.Profiler = i, Mr.StrictMode = A, Mr.Suspense = u, Mr.isAsyncMode = function(y) {
    return B(y) || w(y) === a;
  }, Mr.isConcurrentMode = B, Mr.isContextConsumer = function(y) {
    return w(y) === s;
  }, Mr.isContextProvider = function(y) {
    return w(y) === o;
  }, Mr.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Mr.isForwardRef = function(y) {
    return w(y) === l;
  }, Mr.isFragment = function(y) {
    return w(y) === n;
  }, Mr.isLazy = function(y) {
    return w(y) === g;
  }, Mr.isMemo = function(y) {
    return w(y) === d;
  }, Mr.isPortal = function(y) {
    return w(y) === r;
  }, Mr.isProfiler = function(y) {
    return w(y) === i;
  }, Mr.isStrictMode = function(y) {
    return w(y) === A;
  }, Mr.isSuspense = function(y) {
    return w(y) === u;
  }, Mr.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === c || y === i || y === A || y === u || y === f || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === d || y.$$typeof === o || y.$$typeof === s || y.$$typeof === l || y.$$typeof === p || y.$$typeof === v || y.$$typeof === C || y.$$typeof === m);
  }, Mr.typeOf = w, Mr;
}
var Hr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lb;
function rte() {
  return lb || (lb = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, A = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, a = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, l = t ? Symbol.for("react.forward_ref") : 60112, u = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, d = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, p = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, C = t ? Symbol.for("react.scope") : 60119;
    function w(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === n || X === c || X === i || X === A || X === u || X === f || typeof X == "object" && X !== null && (X.$$typeof === g || X.$$typeof === d || X.$$typeof === o || X.$$typeof === s || X.$$typeof === l || X.$$typeof === p || X.$$typeof === v || X.$$typeof === C || X.$$typeof === m);
    }
    function B(X) {
      if (typeof X == "object" && X !== null) {
        var ne = X.$$typeof;
        switch (ne) {
          case e:
            var ee = X.type;
            switch (ee) {
              case a:
              case c:
              case n:
              case i:
              case A:
              case u:
                return ee;
              default:
                var $ = ee && ee.$$typeof;
                switch ($) {
                  case s:
                  case l:
                  case g:
                  case d:
                  case o:
                    return $;
                  default:
                    return ne;
                }
            }
          case r:
            return ne;
        }
      }
    }
    var y = a, b = c, q = s, E = o, x = e, M = l, O = n, I = g, S = d, P = r, H = i, F = A, T = u, U = !1;
    function D(X) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Q(X) || B(X) === a;
    }
    function Q(X) {
      return B(X) === c;
    }
    function Y(X) {
      return B(X) === s;
    }
    function j(X) {
      return B(X) === o;
    }
    function Z(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function W(X) {
      return B(X) === l;
    }
    function R(X) {
      return B(X) === n;
    }
    function K(X) {
      return B(X) === g;
    }
    function L(X) {
      return B(X) === d;
    }
    function G(X) {
      return B(X) === r;
    }
    function V(X) {
      return B(X) === i;
    }
    function _(X) {
      return B(X) === A;
    }
    function J(X) {
      return B(X) === u;
    }
    Hr.AsyncMode = y, Hr.ConcurrentMode = b, Hr.ContextConsumer = q, Hr.ContextProvider = E, Hr.Element = x, Hr.ForwardRef = M, Hr.Fragment = O, Hr.Lazy = I, Hr.Memo = S, Hr.Portal = P, Hr.Profiler = H, Hr.StrictMode = F, Hr.Suspense = T, Hr.isAsyncMode = D, Hr.isConcurrentMode = Q, Hr.isContextConsumer = Y, Hr.isContextProvider = j, Hr.isElement = Z, Hr.isForwardRef = W, Hr.isFragment = R, Hr.isLazy = K, Hr.isMemo = L, Hr.isPortal = G, Hr.isProfiler = V, Hr.isStrictMode = _, Hr.isSuspense = J, Hr.isValidElementType = w, Hr.typeOf = B;
  }()), Hr;
}
var ub;
function bv() {
  return ub || (ub = 1, process.env.NODE_ENV === "production" ? hf.exports = tte() : hf.exports = rte()), hf.exports;
}
var iT = bv(), nte = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ate = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, oT = {};
oT[iT.ForwardRef] = nte;
oT[iT.Memo] = Ate;
window.location.hostname !== "localhost" && ete({
  dsn: "https://33bf5f26eec50e6c2c556f707d4e459f@o1016721.ingest.us.sentry.io/4506992954245120",
  integrations: [
    Zee(),
    Uee({
      maskAllText: !1,
      blockAllMedia: !1
    })
  ],
  tracesSampleRate: 1,
  tracePropagationTargets: [Ve.BACKEND_URL, Ve.BACKEND_URL_STAGING],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1
});
let Bt = class {
  constructor(e, r, n, A) {
    ke(this, "serviceType");
    ke(this, "apiType");
    ke(this, "apiKey");
    ke(this, "entityId");
    ke(this, "questSdk");
    ke(this, "quest");
    this.serviceType = e || "mixpanel", this.apiType = r || "STAGING", this.apiKey = n || "", this.entityId = A || "", IC.init("52a91caf0a6518b8b8909977ab92c39a"), this.questSdk = new TY({
      apiKey: n,
      apiSecret: "",
      entityId: A,
      stagingEnvironment: this.apiType === "STAGING"
    }), this.quest = new zk.QuestEvents(this.questSdk);
  }
  fireTrackingEvent(e, r, n) {
    return this.apiType === "STAGING" ? { success: !0 } : (IC.track(e), { success: !0 });
  }
  async getKeys({
    entityId: e,
    apikey: r,
    token: n,
    userid: A
  }) {
    try {
      const i = await Oe.get(
        `${Ve.BACKEND_URL}api/entities/${e}/users/${A}/social-tokens`,
        {
          headers: { token: n, entityid: e, userid: A, apikey: r }
        }
      );
      console.log("Keys:", i.data);
    } catch (i) {
      console.log(i);
    }
  }
  async getExternalLogin({
    apiType: e,
    uniqueUserId: r,
    entityId: n,
    userId: A,
    apiKey: i,
    apiSecret: o,
    token: s,
    uniqueEmailId: a,
    entityAuthenticationToken: c,
    alert: l = !1
  }) {
    const u = new zn(), f = {
      apiKey: i,
      apisecret: o,
      ...!!c && {
        "entity-authentication-token": c
      },
      ...!!A && { userId: A },
      ...!!s && { token: s }
    }, d = {
      externalUserId: !!r && r,
      entityId: n,
      email: a
    };
    let g = u.get("questUserId"), m = u.get("questUserToken"), p = u.get("externalUserId");
    if (p && g && m && (p == r || p == a))
      return { userId: g, token: m };
    let v = e == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, C = await Oe.post(
      `${v}api/users/external/login?alert=${l}`,
      d,
      { headers: f }
    ), { userId: w, token: B } = C.data;
    const y = /* @__PURE__ */ new Date();
    return y.setHours(y.getHours() + 48), u.set("externalUserId", r, {
      path: "/",
      expires: y
    }), u.set("questUserId", w, { path: "/", expires: y }), u.set("questUserToken", B, { path: "/", expires: y }), u.set("externalUserId", r || a, {
      path: "/",
      expires: y
    }), { userId: w, token: B };
  }
  captureSentryException(e) {
    this.apiType === "PRODUCTION" && tv(e);
  }
  async trackEvent(e, r, n = {}, A) {
    try {
      const i = await this.quest.track({
        entityId: this.entityId,
        name: e,
        userId: r,
        properties: n,
        isIndependent: A
      });
      console.log("Event tracked successfully:", i);
    } catch (i) {
      this.captureSentryException(i), console.error("Error tracking event:", i);
    }
  }
};
const ite = (t, e, r, n, A) => ({
  url: `${e}${t}`,
  headers: {
    apiKey: r,
    userId: n,
    token: A
  }
}), ote = async (t, e, r, n, A) => {
  if (!t)
    return null;
  const { url: i, headers: o } = ite(
    "api/upload-img",
    e,
    r,
    n,
    A
  ), s = {
    ...o,
    "Content-Type": "form-data"
  }, a = new FormData();
  a.append("uploaded_file", t);
  try {
    return (await Oe.post(i, a, { headers: s })).data;
  } catch {
    return null;
  }
};
class Xg {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e);
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async sendOTP(e, r, n) {
    try {
      return (await Oe.post(
        `${this.BACKEND_URL}api/users/email-login/send-otp?entityId=${r}`,
        { email: e, entityId: r },
        { headers: n }
      )).data;
    } catch (A) {
      throw this.GeneralFunctions.captureSentryException(A), A;
    }
  }
  async verifyOTP(e, r, n, A) {
    try {
      return (await Oe.post(
        `${this.BACKEND_URL}api/users/email-login/verify-otp`,
        { email: e, otp: r, entityId: n },
        { headers: A }
      )).data;
    } catch (i) {
      throw this.GeneralFunctions.captureSentryException(i), i;
    }
  }
  async googleLogin(e, r, n, A) {
    try {
      return (await Oe.post(
        `${this.BACKEND_URL}api/users/google/login`,
        {
          code: e,
          redirectUri: r,
          entityId: n
        },
        { headers: A }
      )).data;
    } catch (i) {
      throw this.GeneralFunctions.captureSentryException(i), i;
    }
  }
  async getLoginCampaignResults(e, r, n, A) {
    var i, o, s, a, c, l, u, f, d, g;
    try {
      const m = new URLSearchParams();
      m.set("platform", "REACT"), A && m.set("variation", A);
      const p = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${m.toString()}`;
      console.log(p, n, this.getAxiosHeaders(n), "173");
      const v = await Oe.get(p, {
        headers: this.getAxiosHeaders(n)
      });
      return (o = (i = v.data) == null ? void 0 : i.data) != null && o.sdkConfig ? {
        questThemeData: (l = (c = (a = (s = v == null ? void 0 : v.data) == null ? void 0 : s.data) == null ? void 0 : a.sdkConfig) == null ? void 0 : c.uiProps) == null ? void 0 : l.questThemeData,
        brandTheme: (g = (d = (f = (u = v == null ? void 0 : v.data) == null ? void 0 : u.data) == null ? void 0 : f.sdkConfig) == null ? void 0 : d.uiProps) == null ? void 0 : g.BrandTheme
      } : {
        questThemeData: void 0,
        brandTheme: void 0
      };
    } catch (m) {
      return this.GeneralFunctions.captureSentryException(m), {
        questThemeData: void 0,
        brandTheme: void 0
      };
    }
  }
  initiateGoogleLogin(e, r) {
    if (!e)
      throw new Error(
        "This is preview of the saas app that we generated it for you. Google login will work once you add your Google Client ID in the code."
      );
    return `https://accounts.google.com/o/oauth2/auth?client_id=${e}&redirect_uri=${r}&scope=profile%20email&response_type=code`;
  }
  trackEvent(e, r) {
    this.GeneralFunctions.fireTrackingEvent(e, r);
  }
}
const Bv = () => /* @__PURE__ */ h("div", { className: "questLabs quest-loader", children: /* @__PURE__ */ k(
  "div",
  {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50
    },
    children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: { position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }
        }
      ),
      /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "inline-block",
            width: "3rem",
            height: "3rem",
            animation: "spin 1.5s linear infinite",
            border: "0.25rem solid currentColor",
            borderRight: "0.25rem solid transparent",
            borderRadius: "50%",
            transform: "translateZ(0)",
            position: "relative"
          },
          children: /* @__PURE__ */ h(
            "div",
            {
              style: {
                position: "absolute",
                width: "0",
                height: "0",
                overflow: "hidden",
                whiteSpace: "nowrap",
                border: "0",
                padding: "0",
                clip: "rect(0,0,0,0)",
                display: "inline"
              },
              children: "Loading..."
            }
          )
        }
      ) })
    ]
  }
) }), sT = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cg%20clipPath='url(%23clip0_12303_10092)'%3e%3cpath%20d='M12%200C13.1016%200%2014.1641%200.140625%2015.1875%200.421875C16.2109%200.703125%2017.1641%201.10938%2018.0469%201.64062C18.9297%202.17188%2019.7383%202.79688%2020.4727%203.51562C21.207%204.23438%2021.8359%205.04297%2022.3594%205.94141C22.8828%206.83984%2023.2852%207.79688%2023.5664%208.8125C23.8477%209.82812%2023.9922%2010.8906%2024%2012C24%2013.1016%2023.8594%2014.1641%2023.5781%2015.1875C23.2969%2016.2109%2022.8906%2017.1641%2022.3594%2018.0469C21.8281%2018.9297%2021.2031%2019.7383%2020.4844%2020.4727C19.7656%2021.207%2018.957%2021.8359%2018.0586%2022.3594C17.1602%2022.8828%2016.2031%2023.2852%2015.1875%2023.5664C14.1719%2023.8477%2013.1094%2023.9922%2012%2024C10.8984%2024%209.83594%2023.8594%208.8125%2023.5781C7.78906%2023.2969%206.83594%2022.8906%205.95312%2022.3594C5.07031%2021.8281%204.26172%2021.2031%203.52734%2020.4844C2.79297%2019.7656%202.16406%2018.957%201.64062%2018.0586C1.11719%2017.1602%200.714844%2016.2031%200.433594%2015.1875C0.152344%2014.1719%200.0078125%2013.1094%200%2012C0%2010.8984%200.140625%209.83594%200.421875%208.8125C0.703125%207.78906%201.10938%206.83594%201.64062%205.95312C2.17188%205.07031%202.79688%204.26172%203.51562%203.52734C4.23438%202.79297%205.04297%202.16406%205.94141%201.64062C6.83984%201.11719%207.79688%200.714844%208.8125%200.433594C9.82812%200.152344%2010.8906%200.0078125%2012%200ZM19.0664%208.02734L17.4727%206.43359L9.75%2014.1562L6.52734%2010.9336L4.93359%2012.5273L9.75%2017.3438L19.0664%208.02734Z'%20fill='%23046A46'%20/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_12303_10092'%3e%3crect%20width='24'%20height='24'%20fill='white'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", aT = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASkSURBVHgB7ZtPThsxFMYfgbAtPUHDCQg7hIQIu+6gJ2A4QVP+iR2wQ4BQeoKGEwAnIEgosCucoMOuu4ZdK1Do9yIPCjP2xB7bk0TkJ6EMM05m3uf3bD/bQzRixIj3zBh5plqtTk1MTJRxWH55eZkpFAp8PIW/UqxoiOvh2NhYC59X+P/u+Pi4QZ7xIoAwOsDhMgyKDM4ExGi02+1T/J3XarUWOcapADC8ND4+XkUtr5KF0QrY+POnp6d9CBGSI5wIwDU+OTm5i9qqUj7UXQkxTpZsbm5WUetnOKxQfpRxz5W5ubnHm5ubO7IgsweIOD9DjFeov1h5QyYBONaLxeIlJVvyfhFChKUsIhgLsLW1xa06G++6kbOFG8mlo6Mjo5AwEmCAjY8wFkFbAOH2P2lwjY9oIRxmdcOhoFOoK+YH3Xhmip+VG2mdwloCoLXfo8Fp8HTgCjvTKdhzHLC+vh5gZLdLw0dpfn7+sdls3qYVSm0DBrC7M4Xbg+m0HCI1BLK4PgZGp/hYI/esYah9avidzhA9rYDSA0Tt/yID2PjDw8OAj9Fl8ucPcsMaurY6H2DoXcd9Vk2+LLwglF1TeoCofW26jWfEA7vwhFfjGcwRBKaewBmq6ppUAO5CYNAymXEZP+FAhDfGR0CASzKA03NVt1hQfGGFDPt8PFR9e3s74ZoWIkiN39jYWMXz1cmMaIImgUoAoxiLcCiCS+M7qDy6oChcoYw4EMG58YKyLAwSAqCVrZAlFiL4Mp6JJmffIPOAMjkggwg+jY/QEqBCjjAQIQ/jObRn4udkAnwgh2iIkIvxgoQHJEaCaAN4ceITOQa/GWCgpDWA8WQ8E0Ls6e4TCQ/wYTyj8oQ4Ho1nSvETWvMBruglgmfjpeQqAAMRlAkYjPe+Vpm4J+WLtMGLcJhAaZMQADX0QH5INT7Cswhh/ISsEfxD7lF2dY4TqF4kKlfmAffkltR+3kMWqQT3SkyNydoAq8XGGFqDnBxFaMRP+BTAaISXkwgJ2xICPD8/cyHbnRiZhre+RZBtuUkIIKaQbbzAamzvUYQr2cmC4iEuKBtOEhtPItRlJ6UCIAy4sGkYOM3qHIvACyTnsgtSAUQYmC5CLMZP2I7tU3KHRTJDucNMORTGXHqNzAiwGPK6EOIqsYmLIO4RkAGwZV91LTX5wM1YhK9kRr3dbjdcZ3U8nwAxKmRoPD8PwkYZMqnJEOJmj8zbgsBHSsueQIbGQ7QwrfaZ1OXx29vbv1hi/ocf+kzDyTfMQjXSCmjl3wgFXoqq0HCR6voRWvMBCIUv7E40JOi4foSWANyFIK6XyH6InAedZz04OAh1CmvPCIkfHHQROtvkdI1n3v1GSeM5Qb4B4mt2kNoEEfOzpsYzmXaLX19ftxYWFi4w4PkoXojoJ1e8Txip7m/KgPU0NO8Fggj8rkCJ8oVfrdmH4aZD9jdYvy/QbDbv+uAN37lrPjk5aZAlThcidnZ2Skil98RuDOevzPC7Q8VisWbSyvfC20tTeFDeZxSQeeraDbfs93D1c56jGPiXplSIXSdlsfUmemUuvgj7IKat76I/np/0YfSIESNGRPwH/3N/jx2K5ycAAAAASUVORK5CYII=", Kg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAABuCAYAAAApmU3FAAAEW0lEQVR4Xu2d/VHjMBDFU8KVQAnBgpn8mRLo4CiBDo4OLh1AB0cH0EHowNdBSrjTu8icZyN/KNbHKnm/mQcDcSzFa63fSjasVoQQQgghhBBCCCGEEEIIIYQQQgghhISzXq+/rY9s8UW+ThSCYDVNs7M6GGP+dLI/t1aPcntSGIwyBMYG6b0fsAHt7fY3ch8kMy5oP+Qom6F3uS+SCaRGBMATlNmyAX+S+yWJcKPsaWnQetrLNkhk4BR9BiSGcELI9kgEYqTGKdG4RGSBATlLHHkRGKrNEusg+0FmElibRZdt+0P2iUyQOzUOCSNd9o0MkMOAhIh13gQJarNouru728r+klXa2iyW7u/vudLQR1tqHBGdJtBiQEJ09U6zUG0WS2/y81w8pWuzWLoqp1ljahzTVTjNigxIkC7WaWquzSLp8pymotrsYPvw6fl9FF2U09SUGu216Hm73f5bpsGJJF+PpLqdpkID0srrkO1b69lusex+n/vtVIPS2uxXN9o6cGJ5toulh35bqlFcmx1smjypt+zvv3u2jSY5wlWiMDX2dZImgXO5ctuokm2qQpMBGdCrTJMgcarspO92v0pqM2+aBJkCB+lxmopqs1HZoO03m82N7D/IGDgdTrOC1NjXzpcmQc7AOZVxmsoNiE/o5+DBKhC4/E5TaW02KtvXj6E0CezrP+V7ckj2Ixm4npl6UuOXhkxJhw3ci3xPJuVxmiZxoZpI7dQ6WcHAQemdph1wN56GtWvQlHQUDlwep2nqSpUHawIe5WeQlA6c06B5ikJNo27KlAA4ZLvtXr63hJI7TdvIg2xUo6ZMCdAUOEj2LzrNcfb/pGFF8k4oS7QFzuRwmkb3yJs0JUBh4KAsThMfXDZcWpMlQIfSwOVxmsA29iobL6iTVe4xjMLAOaV1mh3u7G09Hcip0XlJH0rKAa/mXKejAQtuCgVwTgkg0Rw4SPY3C859trIziRQ82kCpSeYApXeaY8AwmOO1MNXKwiwnKWkKLOucofROcy7mWE4gkK2no0FCipzrJCWVBC6f0wwFF2KXWt9MQDCXBA2YulY9gi8FRXBG5wFnm/3+Zr9/Wv2G8DNuJ18SNID516aiheGsTlMzLnCtPECaJT/D1XJ7e6tpAmGOyjpNLbg71uTB0S49TrMkTbpHrpJJrdPMjdE15zpXdTjN1DQZHgKJLTpNh5swr6ZEgORnuGoqG310mhJTybUPs0iy72SletH1S3DHst9kpfd2ByE6zTGM4hS6dA73KsBktzxwGoTsIPtKPLhlKU1lBJ1mCCXvu5Gi0zwTDWmUTnMBCkYhneZSSo1COs1IuFGIe2xODnIq0WlGxjnSVh7oBLq8P4aqATcKky7q0mkmBkHEQZYHPoaw8iHbIwlIkUpDn7MgC3GuNMYMzYvcN8mAux4umehuOeoKc2ZpwcBpIuB6GPT0LsmIcU9FNf//10L3fxd2nEkhhBBCCCGEEEIIIYSQYf4Cc1STEJO5fc0AAAAASUVORK5CYII=", ste = "data:image/png;base64,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", ate = "data:image/png;base64,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", cte = "data:image/png;base64,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", lte = "data:image/svg+xml,%3csvg%20width='154'%20height='120'%20viewBox='0%200%20154%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='154'%20height='120'%20rx='10'%20fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern%20id='pattern0'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_205_4783'%20transform='matrix(0.0028169%200%200%200.00361502%200%20-0.367606)'/%3e%3c/pattern%3e%3cimage%20id='image0_205_4783'%20width='355'%20height='480'%20xlink:href='data:image/jpeg;base64,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'/%3e%3c/defs%3e%3c/svg%3e", ute = "data:image/svg+xml,%3csvg%20width='154'%20height='120'%20viewBox='0%200%20154%20120'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='154'%20height='120'%20rx='10'%20fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern%20id='pattern0'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_205_4784'%20transform='matrix(0.00243506%200%200%200.003125%20-0.0844156%200)'/%3e%3c/pattern%3e%3cimage%20id='image0_205_4784'%20width='480'%20height='320'%20xlink:href='data:image/jpeg;base64,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'/%3e%3c/defs%3e%3c/svg%3e", cT = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.3332%2010.0003C18.3332%2014.6027%2014.6022%2018.3337%209.99984%2018.3337C5.39746%2018.3337%201.6665%2014.6027%201.6665%2010.0003C1.6665%205.39795%205.39746%201.66699%209.99984%201.66699C14.6022%201.66699%2018.3332%205.39795%2018.3332%2010.0003ZM9.99984%2014.792C10.345%2014.792%2010.6248%2014.5122%2010.6248%2014.167V9.16699C10.6248%208.82181%2010.345%208.54199%209.99984%208.54199C9.65466%208.54199%209.37484%208.82181%209.37484%209.16699V14.167C9.37484%2014.5122%209.65466%2014.792%209.99984%2014.792ZM9.99984%205.83366C10.4601%205.83366%2010.8332%206.20676%2010.8332%206.66699C10.8332%207.12723%2010.4601%207.50033%209.99984%207.50033C9.5396%207.50033%209.1665%207.12723%209.1665%206.66699C9.1665%206.20676%209.5396%205.83366%209.99984%205.83366Z'%20fill='%23EB4E2C'/%3e%3c/svg%3e", dte = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.3332%2010.0003C18.3332%2014.6027%2014.6022%2018.3337%209.99984%2018.3337C5.39746%2018.3337%201.6665%2014.6027%201.6665%2010.0003C1.6665%205.39795%205.39746%201.66699%209.99984%201.66699C14.6022%201.66699%2018.3332%205.39795%2018.3332%2010.0003ZM13.3584%207.47505C13.6025%207.71913%2013.6025%208.11486%2013.3584%208.35893L9.19178%2012.5256C8.9477%2012.7697%208.55197%2012.7697%208.3079%2012.5256L6.64123%2010.8589C6.39715%2010.6149%206.39715%2010.2191%206.64123%209.97505C6.88531%209.73097%207.28103%209.73097%207.52511%209.97505L8.74984%2011.1998L10.6122%209.33741L12.4746%207.47505C12.7186%207.23097%2013.1144%207.23097%2013.3584%207.47505Z'%20fill='%23008000'/%3e%3c/svg%3e", fte = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.3332%2010.0003C18.3332%2014.6027%2014.6022%2018.3337%209.99984%2018.3337C5.39746%2018.3337%201.6665%2014.6027%201.6665%2010.0003C1.6665%205.39795%205.39746%201.66699%209.99984%201.66699C14.6022%201.66699%2018.3332%205.39795%2018.3332%2010.0003ZM9.99984%206.45866C9.48207%206.45866%209.06234%206.87839%209.06234%207.39616C9.06234%207.74134%208.78252%208.02116%208.43734%208.02116C8.09216%208.02116%207.81234%207.74134%207.81234%207.39616C7.81234%206.18804%208.79171%205.20866%209.99984%205.20866C11.208%205.20866%2012.1873%206.18804%2012.1873%207.39616C12.1873%207.98852%2011.9511%208.52698%2011.569%208.92029C11.4921%208.99944%2011.4187%209.07272%2011.3488%209.14263C11.1689%209.32233%2011.0113%209.47977%2010.8731%209.65741C10.6906%209.89193%2010.6248%2010.0643%2010.6248%2010.2087V10.8337C10.6248%2011.1788%2010.345%2011.4587%209.99984%2011.4587C9.65466%2011.4587%209.37484%2011.1788%209.37484%2010.8337V10.2087C9.37484%209.66267%209.62901%209.22069%209.88664%208.88967C10.0773%208.64474%2010.3169%208.40561%2010.5113%208.21155C10.57%208.153%2010.6245%208.09856%2010.6724%208.0493C10.837%207.87985%2010.9373%207.65036%2010.9373%207.39616C10.9373%206.87839%2010.5176%206.45866%209.99984%206.45866ZM9.99984%2014.167C10.4601%2014.167%2010.8332%2013.7939%2010.8332%2013.3337C10.8332%2012.8734%2010.4601%2012.5003%209.99984%2012.5003C9.5396%2012.5003%209.1665%2012.8734%209.1665%2013.3337C9.1665%2013.7939%209.5396%2014.167%209.99984%2014.167Z'%20fill='%23EF9400'/%3e%3c/svg%3e", lT = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M18.3332%2010.0003C18.3332%2014.6027%2014.6022%2018.3337%209.99984%2018.3337C5.39746%2018.3337%201.6665%2014.6027%201.6665%2010.0003C1.6665%205.39795%205.39746%201.66699%209.99984%201.66699C14.6022%201.66699%2018.3332%205.39795%2018.3332%2010.0003ZM9.99984%2014.792C10.345%2014.792%2010.6248%2014.5122%2010.6248%2014.167V9.16699C10.6248%208.82181%2010.345%208.54199%209.99984%208.54199C9.65466%208.54199%209.37484%208.82181%209.37484%209.16699V14.167C9.37484%2014.5122%209.65466%2014.792%209.99984%2014.792ZM9.99984%205.83366C10.4601%205.83366%2010.8332%206.20676%2010.8332%206.66699C10.8332%207.12723%2010.4601%207.50033%209.99984%207.50033C9.5396%207.50033%209.1665%207.12723%209.1665%206.66699C9.1665%206.20676%209.5396%205.83366%209.99984%205.83366Z'%20fill='%230065FF'/%3e%3c/svg%3e", Zg = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20%3e%3cpath%20d='M12.0377%203.29004C7.09761%203.29004%203.07723%207.16236%203.07548%2011.9213C3.07432%2013.4432%203.48774%2014.9285%204.27161%2016.2367L3%2020.7094L7.75142%2019.5092C9.07309%2020.2006%2010.5427%2020.5612%2012.0343%2020.5602H12.0377C16.9779%2020.5602%2020.9983%2016.6873%2021%2011.9283C21.0012%209.62314%2020.0698%207.45327%2018.3772%205.82223C16.6852%204.19062%2014.4352%203.29062%2012.0377%203.29004ZM12.0377%2019.1022H12.0348C10.6982%2019.1022%209.3871%2018.7561%208.24323%2018.1023L7.97032%2017.9467L5.15187%2018.6586L5.90439%2016.0108L5.72729%2015.7397C4.98343%2014.6052%204.58745%2013.2779%204.58806%2011.9213C4.58981%207.96539%207.932%204.74804%2012.0406%204.74804C14.0299%204.74862%2015.9002%205.49591%2017.3071%206.85172C18.714%208.20752%2019.488%2010.0104%2019.4868%2011.9277C19.4851%2015.8837%2016.1435%2019.1022%2012.0372%2019.1022H12.0377ZM16.1237%2013.7283C15.8996%2013.6209%2014.7987%2013.0989%2014.5932%2013.0263C14.3882%2012.9549%2014.239%2012.9177%2014.0897%2013.1337C13.9411%2013.3497%2013.5114%2013.8357%2013.3814%2013.9791C13.2501%2014.1231%2013.1195%2014.1406%2012.8954%2014.0331C12.6712%2013.9251%2011.9495%2013.6975%2011.0948%2012.9624C10.4288%2012.3911%209.97935%2011.685%209.84871%2011.4684C9.71806%2011.253%209.83477%2011.1363%209.94684%2011.0289C10.0473%2010.9331%2010.171%2010.7775%2010.2825%2010.6515C10.3939%2010.5255%2010.4311%2010.4355%2010.5066%2010.2915C10.5809%2010.148%2010.5437%2010.0215%2010.4874%209.91404C10.4311%209.80546%209.984%208.74404%209.79645%208.31262C9.61529%207.89223%209.43064%207.94856%209.29303%207.94159C9.16239%207.93578%209.01374%207.93404%208.86335%207.93404C8.71529%207.93404%208.472%207.98804%208.26645%208.20404C8.06148%208.42004%207.48258%208.94146%207.48258%2010.0029C7.48258%2011.0649%208.28503%2012.0903%208.3971%2012.2343C8.50916%2012.3777%209.97645%2014.5569%2012.223%2015.4917C12.7572%2015.7129%2013.1741%2015.8459%2013.4998%2015.9458C14.0363%2016.1101%2014.5246%2016.0863%2014.9102%2016.0311C15.3399%2015.969%2016.2352%2015.5097%2016.421%2015.0063C16.608%2014.5029%2016.608%2014.0709%2016.5523%2013.9809C16.4977%2013.8909%2016.3479%2013.8369%2016.1237%2013.7283Z'%20fill='black'%20/%3e%3c/svg%3e", uT = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20%3e%3cpath%20d='M19.9525%207.91974C19.9647%208.09605%2019.9647%208.27237%2019.9647%208.45031C19.9647%2013.8722%2015.8371%2020.1253%208.28966%2020.1253V20.1221C6.06013%2020.1253%203.8769%2019.4867%202%2018.2825C2.32419%2018.3215%202.65001%2018.341%202.97664%2018.3418C4.82429%2018.3435%206.61913%2017.7235%208.07272%2016.5819C6.31688%2016.5486%204.77717%2015.4038%204.23928%2013.7325C4.85436%2013.8511%205.48812%2013.8267%206.09181%2013.6618C4.17753%2013.275%202.80033%2011.5931%202.80033%209.63983C2.80033%209.62195%202.80033%209.60489%202.80033%209.58783C3.37071%209.90552%204.00934%2010.0818%204.6626%2010.1013C2.85964%208.89638%202.30388%206.49784%203.39265%204.62256C5.47593%207.18604%208.54966%208.74444%2011.8493%208.90938C11.5186%207.48423%2011.9703%205.99083%2013.0364%204.989C14.689%203.43548%2017.2882%203.51511%2018.8418%205.16694C19.7607%204.98575%2020.6415%204.64856%2021.4475%204.1708C21.1412%205.12063%2020.5001%205.92746%2019.6437%206.44015C20.457%206.34428%2021.2517%206.12652%2022%205.7942C21.4491%206.61972%2020.7552%207.33879%2019.9525%207.91974Z'%20fill='black'%20/%3e%3c/svg%3e", hte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10%200.833008H7.29572C6.07055%200.832998%205.10013%200.832989%204.34065%200.935098C3.55904%201.04018%202.9264%201.26159%202.4275%201.7605C1.92859%202.25941%201.70718%202.89205%201.60209%203.67366C1.49998%204.43313%201.49999%205.40355%201.5%206.62872V10.6663C1.5%2011.9145%202.4147%2012.949%203.61034%2013.1362C3.70232%2013.6455%203.87835%2014.0802%204.23223%2014.4341C4.63351%2014.8354%205.13876%2015.008%205.73883%2015.0887C6.31681%2015.1664%207.05169%2015.1664%207.96342%2015.1663H10.0366C10.9483%2015.1664%2011.6832%2015.1664%2012.2612%2015.0887C12.8612%2015.008%2013.3665%2014.8354%2013.7678%2014.4341C14.169%2014.0328%2014.3416%2013.5276%2014.4223%2012.9275C14.5%2012.3495%2014.5%2011.6146%2014.5%2010.7029V7.29643C14.5%206.3847%2014.5%205.64982%2014.4223%205.07184C14.3416%204.47177%2014.169%203.96652%2013.7678%203.56524C13.4139%203.21136%2012.9791%203.03533%2012.4698%202.94335C12.2827%201.74771%2011.2482%200.833008%2010%200.833008ZM11.4196%202.84712C11.2177%202.25716%2010.6584%201.83301%2010%201.83301H7.33333C6.06212%201.83301%205.15901%201.83407%204.4739%201.92618C3.80317%202.01636%203.41674%202.18547%203.1346%202.46761C2.85246%202.74975%202.68335%203.13618%202.59317%203.80691C2.50106%204.49202%202.5%205.39513%202.5%206.66634V10.6663C2.5%2011.3247%202.92416%2011.884%203.51411%2012.0859C3.49999%2011.6793%203.49999%2011.2195%203.5%2010.7029V7.29642C3.49999%206.3847%203.49998%205.64982%203.57768%205.07184C3.65836%204.47177%203.83096%203.96652%204.23223%203.56524C4.63351%203.16396%205.13876%202.99137%205.73883%202.91069C6.31681%202.83298%207.05169%202.83299%207.96342%202.83301H10.0366C10.5531%202.833%2011.0129%202.83299%2011.4196%202.84712ZM4.93934%204.27235C5.12385%204.08784%205.3829%203.96754%205.87208%203.90177C6.37565%203.83407%207.04306%203.83301%208%203.83301H10C10.9569%203.83301%2011.6244%203.83407%2012.1279%203.90177C12.6171%203.96754%2012.8762%204.08784%2013.0607%204.27235C13.2452%204.45686%2013.3655%204.71591%2013.4312%205.20509C13.4989%205.70866%2013.5%206.37606%2013.5%207.33301V10.6663C13.5%2011.6233%2013.4989%2012.2907%2013.4312%2012.7943C13.3655%2013.2834%2013.2452%2013.5425%2013.0607%2013.727C12.8762%2013.9115%2012.6171%2014.0318%2012.1279%2014.0976C11.6244%2014.1653%2010.9569%2014.1663%2010%2014.1663H8C7.04306%2014.1663%206.37565%2014.1653%205.87208%2014.0976C5.3829%2014.0318%205.12385%2013.9115%204.93934%2013.727C4.75483%2013.5425%204.63453%2013.2834%204.56877%2012.7943C4.50106%2012.2907%204.5%2011.6233%204.5%2010.6663V7.33301C4.5%206.37606%204.50106%205.70866%204.56877%205.20509C4.63453%204.71591%204.75483%204.45686%204.93934%204.27235Z'%20fill='%238E8E8E'/%3e%3c/svg%3e", pte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15%201.25H10.9436C9.10583%201.24998%207.65019%201.24997%206.51098%201.40314C5.33856%201.56076%204.38961%201.89288%203.64124%202.64124C2.89288%203.38961%202.56076%204.33856%202.40314%205.51098C2.24997%206.65019%202.24998%208.10582%202.25%209.94357V16C2.25%2017.8722%203.62205%2019.424%205.41551%2019.7047C5.55348%2020.4687%205.81753%2021.1208%206.34835%2021.6517C6.95027%2022.2536%207.70814%2022.5125%208.60825%2022.6335C9.47522%2022.75%2010.5775%2022.75%2011.9451%2022.75H15.0549C16.4225%2022.75%2017.5248%2022.75%2018.3918%2022.6335C19.2919%2022.5125%2020.0497%2022.2536%2020.6517%2021.6517C21.2536%2021.0497%2021.5125%2020.2919%2021.6335%2019.3918C21.75%2018.5248%2021.75%2017.4225%2021.75%2016.0549V10.9451C21.75%209.57754%2021.75%208.47522%2021.6335%207.60825C21.5125%206.70814%2021.2536%205.95027%2020.6517%205.34835C20.1208%204.81753%2019.4687%204.55348%2018.7047%204.41551C18.424%202.62205%2016.8722%201.25%2015%201.25ZM17.1293%204.27117C16.8265%203.38623%2015.9876%202.75%2015%202.75H11C9.09318%202.75%207.73851%202.75159%206.71085%202.88976C5.70476%203.02502%205.12511%203.27869%204.7019%203.7019C4.27869%204.12511%204.02502%204.70476%203.88976%205.71085C3.75159%206.73851%203.75%208.09318%203.75%2010V16C3.75%2016.9876%204.38624%2017.8265%205.27117%2018.1293C5.24998%2017.5194%205.24999%2016.8297%205.25%2016.0549V10.9451C5.24998%209.57754%205.24996%208.47522%205.36652%207.60825C5.48754%206.70814%205.74643%205.95027%206.34835%205.34835C6.95027%204.74643%207.70814%204.48754%208.60825%204.36652C9.47522%204.24996%2010.5775%204.24998%2011.9451%204.25H15.0549C15.8297%204.24999%2016.5194%204.24998%2017.1293%204.27117ZM7.40901%206.40901C7.68577%206.13225%208.07435%205.9518%208.80812%205.85315C9.56347%205.75159%2010.5646%205.75%2012%205.75H15C16.4354%205.75%2017.4365%205.75159%2018.1919%205.85315C18.9257%205.9518%2019.3142%206.13225%2019.591%206.40901C19.8678%206.68577%2020.0482%207.07435%2020.1469%207.80812C20.2484%208.56347%2020.25%209.56458%2020.25%2011V16C20.25%2017.4354%2020.2484%2018.4365%2020.1469%2019.1919C20.0482%2019.9257%2019.8678%2020.3142%2019.591%2020.591C19.3142%2020.8678%2018.9257%2021.0482%2018.1919%2021.1469C17.4365%2021.2484%2016.4354%2021.25%2015%2021.25H12C10.5646%2021.25%209.56347%2021.2484%208.80812%2021.1469C8.07435%2021.0482%207.68577%2020.8678%207.40901%2020.591C7.13225%2020.3142%206.9518%2019.9257%206.85315%2019.1919C6.75159%2018.4365%206.75%2017.4354%206.75%2016V11C6.75%209.56458%206.75159%208.56347%206.85315%207.80812C6.9518%207.07435%207.13225%206.68577%207.40901%206.40901Z'%20fill='%231C274C'%20/%3e%3c/svg%3e", gte = "data:image/png;base64,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", db = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ccircle%20id='Ellipse%201231'%20cx='20'%20cy='20'%20r='20'%20fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern%20id='pattern0'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_205_4810'%20transform='scale(0.002)'/%3e%3c/pattern%3e%3cimage%20id='image0_205_4810'%20width='500'%20height='500'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", mte = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABZSURBVHgB5ZLRCcAgDEQvpQM4Qkdzk9rROoEjxRP88E9MEAQfHIFwdxAIcAaqGmGF4UBl6oWVpSV3Z4gcz6DnpxK9EJGvLi7YEMzSnZAwiyvcClzh4Hqk/SkWcE0CTkDzqAAAAABJRU5ErkJggg==", vte = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACsSURBVHgB5Y8xCsJAEEV/dpNSTGMhUbDSPYZpJaJHyE1MZ+0NbO2srHMDe222sbNYhEBIseMSG8Wom5TmwTAMzH/MAP9LIGaxP5r6aMJgHK1MHW12WVXYtKVbuCEscD6FpdyrWoIy7CCBxsb0r2EiLS/nwxYvL7CHjIzhFwz8/YLyChElpGmRFVmoZGr1An8ebtdT2u1N+h7z1rwT7HIl81qCppJKhmIeox3cAcDzN4IIobHcAAAAAElFTkSuQmCC", qte = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFFSURBVHgBlVNLTsMwELVTZU1+eyLloyy7ZEd7gqY3gRMAJ6DcgBtQlqzKDcoSJZEwF0jCDilS0jdVLFlRUreziMdjz/N7z86MKeEjLMtidV3/szOD0yeKojnn/I3mXdddYdw2TXMvhKh1AMYRBc1t275kWebneW5j/mua5o4I6QBYkiQ+GPwM63EcP6K+1wLQKdhYjZ0WhuFC1z8jwzzPuzEMY16W5Ye66LruwnGc1LZtq6qq7zEALlmQZhi4LYriqT99By/I1E8MK6rB2OWksb2UPRof5Fxdl56cNHYIotanQPgYCMmhHPTfMdxCAsP1LiUI6isph0+xCYIgRSM9MIHmV3UNLDYAuYZfa6aLsatUr97QAYDB89CTI3XO/5DqAUgrNqcqCPI7SOgAJDg7I3pjN0jpPch3sIY3X+ySICD65dXaAb+sixpADCrjAAAAAElFTkSuQmCC", fb = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.1249%2017.2411L13.4049%2012.5211C14.5391%2011.1595%2015.1047%209.41291%2014.9841%207.64483C14.8634%205.87675%2014.0657%204.22326%2012.7569%203.02834C11.4482%201.83341%209.7291%201.18906%207.95736%201.22932C6.18562%201.26958%204.49761%201.99134%203.24448%203.24448C1.99134%204.49761%201.26958%206.18562%201.22932%207.95736C1.18906%209.7291%201.83341%2011.4482%203.02834%2012.7569C4.22326%2014.0657%205.87675%2014.8634%207.64483%2014.9841C9.41291%2015.1047%2011.1595%2014.5391%2012.5211%2013.4049L17.2411%2018.1249L18.1249%2017.2411ZM2.49989%208.12489C2.49989%207.01237%202.82979%205.92483%203.44787%204.99981C4.06596%204.07478%204.94446%203.35381%205.97229%202.92807C7.00013%202.50232%208.13113%202.39093%209.22227%202.60797C10.3134%202.82501%2011.3157%203.36074%2012.1024%204.14741C12.889%204.93408%2013.4248%205.93636%2013.6418%207.02751C13.8588%208.11865%2013.7475%209.24965%2013.3217%2010.2775C12.896%2011.3053%2012.175%2012.1838%2011.25%2012.8019C10.3249%2013.42%209.23741%2013.7499%208.12489%2013.7499C6.63355%2013.7482%205.20377%2013.1551%204.14924%2012.1005C3.09471%2011.046%202.50154%209.61622%202.49989%208.12489Z'%20fill='%23939393'/%3e%3c/svg%3e", Jn = "data:image/png;base64,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", dT = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.5303%205.46967C11.8232%205.76256%2011.8232%206.23744%2011.5303%206.53033L7.53033%2010.5303C7.24166%2010.819%206.77511%2010.8238%206.4806%2010.541L4.4806%208.62104C4.18179%208.33418%204.1721%207.85941%204.45896%207.5606C4.74582%207.26179%205.22059%207.2521%205.5194%207.53896L6.98929%208.95005L10.4697%205.46967C10.7626%205.17678%2011.2374%205.17678%2011.5303%205.46967Z'%20fill='%23098849'/%3e%3c/svg%3e", fT = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_4646_119)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8%201.83334C11.4058%201.83334%2014.1667%204.59425%2014.1667%208.00001C14.1667%208.27615%2014.3905%208.50001%2014.6667%208.50001C14.9428%208.50001%2015.1667%208.27615%2015.1667%208.00001C15.1667%204.04197%2011.958%200.833344%208%200.833344C7.72386%200.833344%207.5%201.0572%207.5%201.33334C7.5%201.60949%207.72386%201.83334%208%201.83334Z'%20fill='%23B9B9B9'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8%205.50001C8.27614%205.50001%208.5%205.72387%208.5%206.00001V8.16668H10.6667C10.9428%208.16668%2011.1667%208.39054%2011.1667%208.66668C11.1667%208.94282%2010.9428%209.16668%2010.6667%209.16668H8C7.72386%209.16668%207.5%208.94282%207.5%208.66668V6.00001C7.5%205.72387%207.72386%205.50001%208%205.50001Z'%20fill='%23B9B9B9'/%3e%3cpath%20opacity='0.5'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.06639%201.59839C6.16584%201.85601%206.03762%202.14546%205.78%202.24491C5.68571%202.28131%205.59254%202.31996%205.50054%202.3608C5.24815%202.47284%204.95272%202.35907%204.84067%202.10668C4.72863%201.85429%204.8424%201.55886%205.09479%201.44682C5.20179%201.39931%205.31018%201.35435%205.41988%201.312C5.6775%201.21256%205.96695%201.34078%206.06639%201.59839ZM3.76515%202.82688C3.95559%203.02684%203.94787%203.34333%203.7479%203.53377C3.67479%203.6034%203.60338%203.67481%203.53375%203.74792C3.34331%203.94789%203.02682%203.95561%202.82685%203.76517C2.62689%203.57473%202.61916%203.25824%202.80961%203.05827C2.89045%202.97338%202.97336%202.89048%203.05825%202.80963C3.25822%202.61919%203.5747%202.62691%203.76515%202.82688ZM2.10666%204.8407C2.35905%204.95274%202.47282%205.24818%202.36077%205.50057C2.31993%205.59256%202.28128%205.68574%202.24488%205.78003C2.14544%206.03764%201.85598%206.16586%201.59837%206.06642C1.34075%205.96697%201.21253%205.67752%201.31198%205.41991C1.35432%205.31021%201.39929%205.20182%201.44679%205.09481C1.55884%204.84242%201.85427%204.72865%202.10666%204.8407ZM1.3474%207.33607C1.62346%207.34274%201.84185%207.57194%201.83518%207.848C1.83396%207.89852%201.83334%207.9492%201.83334%208.00003C1.83334%208.05087%201.83396%208.10155%201.83518%208.15207C1.84185%208.42813%201.62346%208.65733%201.3474%208.664C1.07134%208.67067%200.84214%208.45229%200.83547%208.17623C0.834055%208.11766%200.833344%208.05892%200.833344%208.00003C0.833344%207.94115%200.834055%207.88241%200.83547%207.82384C0.84214%207.54778%201.07134%207.3294%201.3474%207.33607ZM14.4017%209.93365C14.6593%2010.0331%2014.7875%2010.3225%2014.688%2010.5802C14.6457%2010.6899%2014.6007%2010.7983%2014.5532%2010.9053C14.4412%2011.1576%2014.1458%2011.2714%2013.8934%2011.1594C13.641%2011.0473%2013.5272%2010.7519%2013.6392%2010.4995C13.6801%2010.4075%2013.7187%2010.3143%2013.7551%2010.22C13.8546%209.96243%2014.144%209.83421%2014.4017%209.93365ZM1.59837%209.93365C1.85598%209.83421%202.14544%209.96243%202.24488%2010.22C2.28128%2010.3143%202.31993%2010.4075%202.36077%2010.4995C2.47282%2010.7519%202.35905%2011.0473%202.10666%2011.1594C1.85427%2011.2714%201.55884%2011.1576%201.44679%2010.9053C1.39929%2010.7983%201.35432%2010.6899%201.31198%2010.5802C1.21253%2010.3225%201.34076%2010.0331%201.59837%209.93365ZM13.1732%2012.2349C13.3731%2012.4253%2013.3809%2012.7418%2013.1904%2012.9418C13.1096%2013.0267%2013.0267%2013.1096%2012.9418%2013.1904C12.7418%2013.3809%2012.4253%2013.3732%2012.2349%2013.1732C12.0444%2012.9732%2012.0522%2012.6567%2012.2521%2012.4663C12.3252%2012.3967%2012.3966%2012.3253%2012.4663%2012.2521C12.6567%2012.0522%2012.9732%2012.0445%2013.1732%2012.2349ZM2.82685%2012.2349C3.02682%2012.0445%203.34331%2012.0522%203.53375%2012.2521C3.60338%2012.3253%203.67479%2012.3967%203.7479%2012.4663C3.94787%2012.6567%203.95559%2012.9732%203.76515%2013.1732C3.5747%2013.3732%203.25822%2013.3809%203.05825%2013.1904C2.97336%2013.1096%202.89045%2013.0267%202.80961%2012.9418C2.61917%2012.7418%202.62689%2012.4253%202.82685%2012.2349ZM4.84067%2013.8934C4.95272%2013.641%205.24815%2013.5272%205.50054%2013.6393C5.59254%2013.6801%205.68571%2013.7188%205.78%2013.7552C6.03762%2013.8546%206.16584%2014.1441%206.06639%2014.4017C5.96695%2014.6593%205.6775%2014.7875%205.41988%2014.6881C5.31018%2014.6457%205.20179%2014.6008%205.09479%2014.5533C4.8424%2014.4412%204.72863%2014.1458%204.84067%2013.8934ZM11.1593%2013.8934C11.2714%2014.1458%2011.1576%2014.4412%2010.9052%2014.5533C10.7982%2014.6008%2010.6898%2014.6457%2010.5801%2014.6881C10.3225%2014.7875%2010.0331%2014.6593%209.93363%2014.4017C9.83418%2014.1441%209.9624%2013.8546%2010.22%2013.7552C10.3143%2013.7188%2010.4075%2013.6801%2010.4995%2013.6393C10.7519%2013.5272%2011.0473%2013.641%2011.1593%2013.8934ZM7.33604%2014.6526C7.34271%2014.3766%207.57191%2014.1582%207.84797%2014.1649C7.89849%2014.1661%207.94917%2014.1667%208.00001%2014.1667C8.05085%2014.1667%208.10153%2014.1661%208.15205%2014.1649C8.42811%2014.1582%208.65731%2014.3766%208.66398%2014.6526C8.67065%2014.9287%208.45226%2015.1579%208.1762%2015.1646C8.11763%2015.166%208.0589%2015.1667%208.00001%2015.1667C7.94112%2015.1667%207.88239%2015.166%207.82382%2015.1646C7.54776%2015.1579%207.32937%2014.9287%207.33604%2014.6526Z'%20fill='%23B9B9B9'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4646_119'%3e%3crect%20width='16'%20height='16'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", hT = "data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M72.4749%2029.2978L42.2999%2052.2728C40.9499%2053.2978%2039.0499%2053.2978%2037.6999%2052.2728L7.5249%2029.2978C7.7499%2028.7728%208.1499%2028.2978%208.6499%2027.8978L37.7249%205.77282C38.3784%205.27407%2039.1778%205.00391%2039.9999%205.00391C40.822%205.00391%2041.6214%205.27407%2042.2749%205.77282L71.3499%2027.8978C71.8499%2028.2978%2072.2499%2028.7728%2072.4749%2029.2978Z'%20fill='%239035FF'/%3e%3cpath%20d='M63.4749%2016.4998V68.3498C63.4749%2071.0748%2061.2499%2073.2748%2058.5249%2073.2748H21.4749C18.7499%2073.2748%2016.5249%2071.0748%2016.5249%2068.3498V16.4998C16.5249%2013.7748%2018.7499%2011.5498%2021.4749%2011.5498H58.5249C61.2499%2011.5498%2063.4749%2013.7748%2063.4749%2016.4998Z'%20fill='white'/%3e%3cpath%20d='M63.4749%2016.4998V20.2498C63.4749%2017.5248%2061.2499%2015.2998%2058.5249%2015.2998H21.4749C18.7499%2015.2998%2016.5249%2017.5248%2016.5249%2020.2498V16.4998C16.5249%2013.7748%2018.7499%2011.5498%2021.4749%2011.5498H58.5249C61.2499%2011.5498%2063.4749%2013.7748%2063.4749%2016.4998ZM63.4749%2068.3498V72.0998C63.4749%2074.8248%2061.2499%2077.0248%2058.5249%2077.0248H21.4749C18.7499%2077.0248%2016.5249%2074.8248%2016.5249%2072.0998V68.3498C16.5249%2071.0748%2018.7499%2073.2748%2021.4749%2073.2748H58.5249C61.2499%2073.2748%2063.4749%2071.0748%2063.4749%2068.3498Z'%20fill='%23EAEAEA'/%3e%3cpath%20d='M63.4749%2031.4248V68.3498C63.4749%2071.0748%2061.2499%2073.2748%2058.5249%2073.2748H21.4749C18.7499%2073.2748%2016.5249%2071.0748%2016.5249%2068.3498V31.4248L39.9749%2049.2998L63.4749%2031.4248Z'%20fill='%23EFEFEF'/%3e%3cpath%20d='M72.8499%2030.8998V71.2248C72.8499%2073.2998%2071.1749%2074.9998%2069.0749%2074.9998H10.9249C8.8249%2074.9998%207.1499%2073.2998%207.1499%2071.2248V30.8998C7.1499%2030.3248%207.2749%2029.7748%207.5249%2029.2998L37.6999%2052.2748C39.0499%2053.2998%2040.9499%2053.2998%2042.2999%2052.2748L65.0499%2034.9498L72.4749%2029.2998C72.7249%2029.7748%2072.8499%2030.3248%2072.8499%2030.8998Z'%20fill='%23BF8AFF'/%3e%3cpath%20d='M72.8501%2030.8998V71.2248C72.8501%2073.2998%2071.1751%2074.9998%2069.0751%2074.9998H57.3501C64.8501%2059.4748%2065.7751%2044.9498%2065.0501%2034.9498L72.4751%2029.2998C72.7251%2029.7748%2072.8501%2030.3248%2072.8501%2030.8998Z'%20fill='%238634EA'/%3e%3cpath%20d='M39.9998%2039.9153C44.9123%2039.1278%2048.6173%2036.0953%2049.3048%2032.3728C50.1923%2027.5628%2045.6998%2021.7103%2039.9998%2026.4253C34.2998%2021.7078%2029.8073%2027.5628%2030.6948%2032.3728C31.3823%2036.0953%2035.0873%2039.1278%2039.9998%2039.9153Z'%20fill='%23FE4F60'/%3e%3cpath%20d='M49.2999%2032.3749C48.6249%2036.0999%2044.8999%2039.1249%2039.9999%2039.9249C38.8999%2039.7499%2037.8499%2039.4499%2036.8999%2039.0499C41.5249%2037.5499%2044.9249%2034.5499%2045.5249%2031.1999C45.8499%2029.3999%2045.2999%2027.1999%2044.1749%2025.8499C43.6749%2025.2249%2043.1749%2024.9249%2042.6749%2024.9249C42.6499%2024.9249%2042.5999%2024.9249%2042.5499%2024.9499C46.9749%2023.4999%2050.0499%2028.3249%2049.2999%2032.3749Z'%20fill='%23E54756'/%3e%3cpath%20d='M35.9%2030.3179C36.2446%2029.4149%2036.1098%2028.5249%2035.599%2028.33C35.0881%2028.135%2034.3947%2028.7091%2034.0501%2029.612C33.7056%2030.515%2033.8404%2031.4051%2034.3512%2031.6C34.8621%2031.7949%2035.5555%2031.2209%2035.9%2030.3179Z'%20fill='%23FF6D7A'/%3e%3c/svg%3e", yte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.77519%204.55806C9.01927%204.80214%209.01927%205.19786%208.77519%205.44194L4.84214%209.375H16.6666C17.0118%209.375%2017.2916%209.65482%2017.2916%2010C17.2916%2010.3452%2017.0118%2010.625%2016.6666%2010.625H4.84214L8.77519%2014.5581C9.01927%2014.8021%209.01927%2015.1979%208.77519%2015.4419C8.53112%2015.686%208.13539%2015.686%207.89131%2015.4419L2.89131%2010.4419C2.64723%2010.1979%202.64723%209.80214%202.89131%209.55806L7.89131%204.55806C8.13539%204.31398%208.53112%204.31398%208.77519%204.55806Z'%20fill='%23939393'/%3e%3c/svg%3e", Cte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='17'%20height='16'%20viewBox='0%200%2017%2016'%20fill='none'%3e%3cpath%20d='M8.5%207.33333H14.1886C14.2179%207.5898%2014.2333%207.8528%2014.2333%208.12247C14.2333%209.9456%2013.5803%2011.4803%2012.4483%2012.5225C11.4578%2013.4367%2010.1027%2013.9728%208.4864%2013.9728C6.14622%2013.9728%204.12177%2012.6313%203.13673%2010.6749C2.7313%209.86667%202.5%208.9524%202.5%207.9864C2.5%207.0204%202.7313%206.10613%203.13673%205.29799C4.12177%203.34151%206.14622%202%208.4864%202C10.1%202%2011.4551%202.59322%2012.4918%203.55919L11.517%204.53401C10.7455%203.78769%209.70187%203.33333%208.5%203.33333C5.92267%203.33333%203.83333%205.42267%203.83333%208C3.83333%2010.5773%205.92267%2012.6667%208.5%2012.6667C10.851%2012.6667%2012.5962%2010.9282%2012.8847%208.66667H8.5V7.33333Z'%20fill='%23AFAFAF'/%3e%3c/svg%3e", wte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='49'%20height='48'%20viewBox='0%200%2049%2048'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6214_835)'%3e%3cpath%20d='M24.5%2048C37.7548%2048%2048.5%2037.2548%2048.5%2024C48.5%2010.7452%2037.7548%200%2024.5%200C11.2452%200%200.5%2010.7452%200.5%2024C0.5%2037.2548%2011.2452%2048%2024.5%2048Z'%20fill='%236E6E6E'/%3e%3cpath%20d='M28.2716%2047.686C28.3739%2047.6744%2028.476%2047.6621%2028.5781%2047.6491C29.3667%2047.5129%2030.148%2047.3373%2030.919%2047.123C31.6905%2046.91%2032.4508%2046.6586%2033.1972%2046.3697C33.9423%2046.0796%2034.6724%2045.7524%2035.3849%2045.3894C36.0979%2045.0262%2036.7923%2044.6276%2037.4655%2044.195C38.1388%2043.7632%2038.7901%2043.298%2039.4169%2042.8011C40.0442%2042.3035%2040.6461%2041.7749%2041.2206%2041.2171C41.7947%2040.6595%2042.3406%2040.0736%2042.8563%2039.4614C43.3715%2038.8491%2043.8558%2038.2114%2044.3073%2037.5507C44.7597%2036.8902%2045.1786%2036.2075%2045.5627%2035.5051C45.9468%2034.803%2046.2956%2034.0821%2046.6077%2033.3451C46.8778%2032.6951%2047.1193%2032.0336%2047.3313%2031.3623L37.196%2021.227C37.039%2021.1716%2036.9061%2021.1162%2036.6661%2021.0571C35.9424%2020.8799%2034.9307%2020.7211%2033.8895%2020.5753L33.1141%2020.4645L24.5756%2011.9279C24.4741%2012.0571%2024.3781%2012.1697%2024.247%2012.3783C23.8538%2013.0097%2023.3904%2013.9217%2022.9307%2014.8633C22.4729%2015.8048%2022.015%2016.7777%2021.6015%2017.5808C21.4168%2017.9455%2021.2166%2018.3021%2021.0015%2018.6497C20.8095%2018.9543%2020.6729%2019.1999%2020.3203%2019.4491C19.9695%2019.7002%2019.6889%2019.7519%2019.3363%2019.8368C18.9855%2019.9162%2018.5793%2019.9863%2018.1326%2020.051C17.2353%2020.182%2016.1627%2020.2983%2015.1215%2020.4257C14.0784%2020.555%2013.063%2020.6971%2012.3375%2020.8633C12.0975%2020.9187%2011.9627%2020.9722%2011.804%2021.0257C11.8963%2021.1642%2011.9738%2021.2879%2012.1326%2021.4762C12.428%2021.8251%2012.8156%2022.2331%2013.2458%2022.6614L17.2556%2026.6713C17.4181%2026.8725%2017.564%2027.07%2017.6618%2027.3857C17.7929%2027.7956%2017.7578%2028.0762%2017.7283%2028.4343C17.6901%2028.8396%2017.6347%2029.2431%2017.5621%2029.6436C17.4089%2030.5334%2017.1855%2031.5857%2016.9861%2032.614C16.7949%2033.5321%2016.6471%2034.4587%2016.543%2035.3907C16.5209%2035.6362%2016.5283%2035.7783%2016.532%2035.9445L28.2716%2047.686Z'%20fill='%23B9B9B9'/%3e%3cpath%20d='M24.5723%2011.9211C24.6709%2012.0538%2024.7655%2012.1668%2024.8917%2012.3783C25.2762%2013.0148%2025.7257%2013.9346%2026.1693%2014.8831C26.6129%2015.8334%2027.0526%2016.814%2027.4548%2017.6262C27.6559%2018.0296%2027.8452%2018.3918%2028.0344%2018.7002C28.2217%2019.0086%2028.3578%2019.256%2028.7048%2019.5124C29.0518%2019.7688%2029.3298%2019.8244%2029.6807%2019.914C30.0317%2020.0019%2030.4339%2020.0753%2030.8814%2020.1488C31.7765%2020.2941%2032.8471%2020.4268%2033.8861%2020.5703C34.9271%2020.7155%2035.9386%2020.8751%2036.6622%2021.0508C36.9027%2021.1099%2037.0367%2021.1655%2037.1945%2021.2211C37.0979%2021.3573%2037.019%2021.481%2036.8593%2021.6657C36.3684%2022.2269%2035.631%2022.9386%2034.8621%2023.6504C34.0932%2024.3658%2033.2947%2025.0866%2032.646%2025.7177C32.3207%2026.0333%2032.0348%2026.3273%2031.7982%2026.5998C31.5636%2026.8724%2031.3684%2027.0785%2031.2324%2027.4873C31.0943%2027.8943%2031.1279%2028.1757%2031.1515%2028.5361C31.1752%2028.8947%2031.2284%2029.3%2031.2974%2029.7482C31.4354%2030.6411%2031.6405%2031.6971%2031.8238%2032.728C32.0072%2033.759%2032.1689%2034.7684%2032.2241%2035.5106C32.2418%2035.7545%2032.23%2035.8998%2032.2241%2036.0666C32.0664%2036.0182%2031.9224%2035.9804%2031.6957%2035.8853C31.0115%2035.5949%2030.1046%2035.1144%2029.1878%2034.607C28.2691%2034.0978%2027.3345%2033.5637%2026.5301%2033.1423C26.1717%2032.9505%2025.8039%2032.7734%2025.428%2032.6116C25.0948%2032.4735%2024.8385%2032.3517%2024.4067%2032.3481C23.9749%2032.3481%2023.7166%2032.4627%2023.3815%2032.5954C23.0463%2032.7299%2022.6756%2032.9056%2022.2714%2033.1082C21.4631%2033.5152%2020.5167%2034.0369%2019.5901%2034.5299C18.6634%2035.023%2017.7525%2035.4875%2017.0625%2035.7672C16.8338%2035.8604%2016.6918%2035.8943%2016.5301%2035.9409C16.5282%2035.7742%2016.5183%2035.6291%2016.54%2035.3852C16.607%2034.6448%2016.7845%2033.6372%2016.9856%2032.6098C17.1847%2031.5825%2017.4075%2030.5298%2017.5593%2029.6388C17.6318%2029.2375%2017.6871%2028.8339%2017.7249%2028.4287C17.7545%2028.0701%2017.792%2027.7885%2017.6618%2027.3779C17.5317%2026.9673%2017.3405%2026.7595%2017.1098%2026.4815C16.8458%2026.1728%2016.5675%2025.8742%2016.2758%2025.5868C15.639%2024.945%2014.8503%2024.2117%2014.0933%2023.4855C13.4053%2022.8412%2012.7506%2022.1681%2012.1315%2021.4685C11.9718%2021.2802%2011.8949%2021.1566%2011.8022%2021.0185C11.96%2020.9647%2012.096%2020.9109%2012.3346%2020.8553C13.0621%2020.6886%2014.0775%2020.5469%2015.1204%2020.4196C16.1615%2020.2923%2017.234%2020.1776%2018.1311%2020.0467C18.5806%2019.9822%2018.9848%2019.9122%2019.3357%2019.8297C19.6867%2019.7473%2019.9666%2019.6953%2020.3176%2019.4443C20.6685%2019.1933%2020.8105%2018.9476%2021.0017%2018.6428C21.1949%2018.338%2021.3901%2017.9795%2021.5972%2017.5779C22.0112%2016.7728%2022.4686%2015.7993%2022.928%2014.8562C23.3264%2014.0111%2023.7658%2013.1826%2024.245%2012.373C24.3751%2012.1632%2024.4698%2012.052%2024.5723%2011.9211Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6214_835'%3e%3crect%20width='48'%20height='48'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", bte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6214_846)'%3e%3cpath%20d='M40%2080C62.0914%2080%2080%2062.0914%2080%2040C80%2017.9086%2062.0914%200%2040%200C17.9086%200%200%2017.9086%200%2040C0%2062.0914%2017.9086%2080%2040%2080Z'%20fill='%23FFA40B'/%3e%3cpath%20d='M46.2862%2079.4767C46.4566%2079.4573%2046.6269%2079.4368%2046.797%2079.4152C48.1113%2079.1881%2049.4135%2078.8955%2050.6985%2078.5383C51.9843%2078.1834%2053.2516%2077.7644%2054.4955%2077.2829C55.7373%2076.7994%2056.9542%2076.2541%2058.1416%2075.649C59.33%2075.0437%2060.4873%2074.3793%2061.6093%2073.6583C62.7315%2072.9386%2063.8169%2072.1633%2064.8616%2071.3352C65.9071%2070.5059%2066.9104%2069.6248%2067.8678%2068.6952C68.8247%2067.7659%2069.7346%2066.7893%2070.5939%2065.769C71.4527%2064.7485%2072.2598%2063.6856%2073.0124%2062.5844C73.7663%2061.4836%2074.4646%2060.3458%2075.1047%2059.1752C75.7449%2058.005%2076.3261%2056.8035%2076.8462%2055.5752C77.2966%2054.4919%2077.699%2053.3893%2078.0524%2052.2706L61.1601%2035.3783C60.8986%2035.286%2060.677%2035.1937%2060.277%2035.0952C59.0709%2034.7998%2057.3847%2034.5352%2055.6493%2034.2921L54.357%2034.1075L40.1262%2019.8798C39.957%2020.0952%2039.797%2020.2829%2039.5785%2020.6306C38.9232%2021.6829%2038.1509%2023.2029%2037.3847%2024.7721C36.6216%2026.3414%2035.8586%2027.9629%2035.1693%2029.3014C34.8615%2029.9092%2034.5279%2030.5036%2034.1693%2031.0829C33.8493%2031.5906%2033.6216%2031.9998%2033.0339%2032.4152C32.4493%2032.8337%2031.9816%2032.9198%2031.3939%2033.0614C30.8093%2033.1937%2030.1324%2033.3106%2029.3878%2033.4183C27.8924%2033.6367%2026.1047%2033.8306%2024.3693%2034.0429C22.6309%2034.2583%2020.9385%2034.4952%2019.7293%2034.7721C19.3293%2034.8644%2019.1047%2034.9537%2018.8401%2035.0429C18.9939%2035.2737%2019.1232%2035.4798%2019.3878%2035.7937C19.8801%2036.3752%2020.5262%2037.0552%2021.2432%2037.7691L27.9262%2044.4521C28.197%2044.7875%2028.4401%2045.1167%2028.6032%2045.6429C28.8216%2046.326%2028.7632%2046.7937%2028.7139%2047.3906C28.6504%2048.066%2028.558%2048.7384%2028.437%2049.406C28.1816%2050.889%2027.8093%2052.6429%2027.477%2054.3567C27.1584%2055.8869%2026.912%2057.4311%2026.7385%2058.9844C26.7016%2059.3937%2026.7139%2059.6306%2026.7201%2059.9075L46.2862%2079.4767Z'%20fill='%23FF7712'/%3e%3cpath%20d='M40.1203%2019.8685C40.2846%2020.0897%2040.4424%2020.2779%2040.6527%2020.6305C41.2934%2021.6914%2042.0427%2023.2244%2042.782%2024.8052C43.5214%2026.3889%2044.2541%2028.0234%2044.9245%2029.3771C45.2596%2030.0494%2045.5751%2030.653%2045.8906%2031.167C46.2027%2031.681%2046.4294%2032.0933%2047.0078%2032.5207C47.5861%2032.948%2048.0495%2033.0406%2048.6344%2033.19C49.2193%2033.3364%2049.8896%2033.4589%2050.6355%2033.5814C52.1274%2033.8235%2053.9117%2034.0447%2055.6434%2034.2838C57.3784%2034.5258%2059.0641%2034.7918%2060.2701%2035.0846C60.671%2035.1833%2060.8944%2035.2758%2061.1573%2035.3684C60.9963%2035.5955%2060.8648%2035.8017%2060.5987%2036.1095C59.7805%2037.0448%2058.5515%2038.2311%2057.27%2039.4174C55.9884%2040.6097%2054.6576%2041.811%2053.5765%2042.8629C53.0343%2043.3888%2052.5578%2043.8789%2052.1635%2044.3331C51.7725%2044.7873%2051.4472%2045.1309%2051.2204%2045.8122C50.9904%2046.4906%2051.0463%2046.9596%2051.0857%2047.5602C51.1252%2048.1579%2051.2139%2048.8333%2051.3289%2049.5803C51.5589%2051.0685%2051.9006%2052.8285%2052.2062%2054.5467C52.5118%2056.2649%2052.7813%2057.9473%2052.8733%2059.1844C52.9029%2059.5908%2052.8832%2059.833%2052.8733%2060.1109C52.6104%2060.0303%2052.3705%2059.9673%2051.9926%2059.8089C50.8524%2059.3248%2049.3409%2058.5239%2047.8129%2057.6783C46.2816%2056.8296%2044.724%2055.9395%2043.3833%2055.2372C42.7859%2054.9175%2042.173%2054.6223%2041.5464%2054.3526C40.9911%2054.1226%2040.5639%2053.9194%2039.8443%2053.9135C39.1247%2053.9135%2038.6942%2054.1045%2038.1356%2054.3257C37.577%2054.5498%2036.9592%2054.8427%2036.2856%2055.1803C34.9383%2055.8586%2033.361%2056.7281%2031.8166%2057.5499C30.2722%2058.3716%2028.7541%2059.1458%2027.604%2059.6119C27.2228%2059.7673%2026.9862%2059.8239%2026.7168%2059.9016C26.7135%2059.6237%2026.697%2059.3818%2026.7332%2058.9754C26.8449%2057.7413%2027.1406%2056.062%2027.4758%2054.3497C27.8077%2052.6375%2028.179%2050.8831%2028.432%2049.3979C28.5528%2048.7291%2028.6449%2048.0565%2028.708%2047.3811C28.7573%2046.7835%2028.8198%2046.3141%2028.6029%2045.6298C28.386%2044.9455%2028.0673%2044.5991%2027.6828%2044.1359C27.2428%2043.6213%2026.7791%2043.1237%2026.2928%2042.6447C25.2315%2041.575%2023.9171%2040.3528%2022.6553%2039.1426C21.5086%2038.0687%2020.4176%2036.9469%2019.3857%2035.7808C19.1195%2035.4671%2018.9914%2035.2609%2018.8369%2035.0308C19.0998%2034.9412%2019.3265%2034.8515%2019.7241%2034.7589C20.9367%2034.481%2022.629%2034.2448%2024.3672%2034.0326C26.1023%2033.8205%2027.8898%2033.6294%2029.385%2033.4113C30.1342%2033.3037%2030.8078%2033.187%2031.3927%2033.0496C31.9776%2032.9121%2032.4442%2032.8256%2033.0291%2032.4072C33.6141%2031.9889%2033.8506%2031.5794%2034.1694%2031.0714C34.4914%2030.5634%2034.8167%2029.9658%2035.1618%2029.2964C35.8518%2027.9547%2036.6142%2026.3321%2037.3798%2024.7603C38.0438%2023.3519%2038.7762%2021.971%2039.5748%2020.6216C39.7917%2020.272%2039.9495%2020.0867%2040.1203%2019.8685Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6214_846'%3e%3crect%20width='80'%20height='80'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Bte = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='49'%20height='48'%20viewBox='0%200%2049%2048'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6214_857)'%3e%3cpath%20d='M24.5%2048C37.7548%2048%2048.5%2037.2548%2048.5%2024C48.5%2010.7452%2037.7548%200%2024.5%200C11.2452%200%200.5%2010.7452%200.5%2024C0.5%2037.2548%2011.2452%2048%2024.5%2048Z'%20fill='%23B35F30'/%3e%3cpath%20d='M28.2716%2047.686C28.3739%2047.6744%2028.476%2047.6621%2028.5781%2047.6491C29.3667%2047.5129%2030.148%2047.3373%2030.919%2047.123C31.6905%2046.91%2032.4508%2046.6586%2033.1972%2046.3697C33.9423%2046.0796%2034.6724%2045.7524%2035.3849%2045.3894C36.0979%2045.0262%2036.7923%2044.6276%2037.4655%2044.195C38.1388%2043.7632%2038.7901%2043.298%2039.4169%2042.8011C40.0442%2042.3035%2040.6461%2041.7749%2041.2206%2041.2171C41.7947%2040.6595%2042.3406%2040.0736%2042.8563%2039.4614C43.3715%2038.8491%2043.8558%2038.2114%2044.3073%2037.5507C44.7597%2036.8902%2045.1786%2036.2075%2045.5627%2035.5051C45.9468%2034.803%2046.2956%2034.0821%2046.6077%2033.3451C46.8778%2032.6951%2047.1193%2032.0336%2047.3313%2031.3623L37.196%2021.227C37.039%2021.1716%2036.9061%2021.1162%2036.6661%2021.0571C35.9424%2020.8799%2034.9307%2020.7211%2033.8895%2020.5753L33.1141%2020.4645L24.5756%2011.9279C24.4741%2012.0571%2024.3781%2012.1697%2024.247%2012.3783C23.8538%2013.0097%2023.3904%2013.9217%2022.9307%2014.8633C22.4729%2015.8048%2022.015%2016.7777%2021.6015%2017.5808C21.4168%2017.9455%2021.2166%2018.3021%2021.0015%2018.6497C20.8095%2018.9543%2020.6729%2019.1999%2020.3203%2019.4491C19.9695%2019.7002%2019.6889%2019.7519%2019.3363%2019.8368C18.9855%2019.9162%2018.5793%2019.9863%2018.1326%2020.051C17.2353%2020.182%2016.1627%2020.2983%2015.1215%2020.4257C14.0784%2020.555%2013.063%2020.6971%2012.3375%2020.8633C12.0975%2020.9187%2011.9627%2020.9722%2011.804%2021.0257C11.8963%2021.1642%2011.9738%2021.2879%2012.1326%2021.4762C12.428%2021.8251%2012.8156%2022.2331%2013.2458%2022.6614L17.2556%2026.6713C17.4181%2026.8725%2017.564%2027.07%2017.6618%2027.3857C17.7929%2027.7956%2017.7578%2028.0762%2017.7283%2028.4343C17.6901%2028.8396%2017.6347%2029.2431%2017.5621%2029.6436C17.4089%2030.5334%2017.1855%2031.5857%2016.9861%2032.614C16.7949%2033.5321%2016.6471%2034.4587%2016.543%2035.3907C16.5209%2035.6362%2016.5283%2035.7783%2016.532%2035.9445L28.2716%2047.686Z'%20fill='%23FF9B64'/%3e%3cpath%20d='M24.5723%2011.9211C24.6709%2012.0538%2024.7655%2012.1668%2024.8917%2012.3783C25.2762%2013.0148%2025.7257%2013.9346%2026.1693%2014.8831C26.6129%2015.8334%2027.0526%2016.814%2027.4548%2017.6262C27.6559%2018.0296%2027.8452%2018.3918%2028.0344%2018.7002C28.2217%2019.0086%2028.3578%2019.256%2028.7048%2019.5124C29.0518%2019.7688%2029.3298%2019.8244%2029.6807%2019.914C30.0317%2020.0019%2030.4339%2020.0753%2030.8814%2020.1488C31.7765%2020.2941%2032.8471%2020.4268%2033.8861%2020.5703C34.9271%2020.7155%2035.9386%2020.8751%2036.6622%2021.0508C36.9027%2021.1099%2037.0367%2021.1655%2037.1945%2021.2211C37.0979%2021.3573%2037.019%2021.481%2036.8593%2021.6657C36.3684%2022.2269%2035.631%2022.9386%2034.8621%2023.6504C34.0932%2024.3658%2033.2947%2025.0866%2032.646%2025.7177C32.3207%2026.0333%2032.0348%2026.3273%2031.7982%2026.5998C31.5636%2026.8724%2031.3684%2027.0785%2031.2324%2027.4873C31.0943%2027.8943%2031.1279%2028.1757%2031.1515%2028.5361C31.1752%2028.8947%2031.2284%2029.3%2031.2974%2029.7482C31.4354%2030.6411%2031.6405%2031.6971%2031.8238%2032.728C32.0072%2033.759%2032.1689%2034.7684%2032.2241%2035.5106C32.2418%2035.7545%2032.23%2035.8998%2032.2241%2036.0666C32.0664%2036.0182%2031.9224%2035.9804%2031.6957%2035.8853C31.0115%2035.5949%2030.1046%2035.1144%2029.1878%2034.607C28.2691%2034.0978%2027.3345%2033.5637%2026.5301%2033.1423C26.1717%2032.9505%2025.8039%2032.7734%2025.428%2032.6116C25.0948%2032.4735%2024.8385%2032.3517%2024.4067%2032.3481C23.9749%2032.3481%2023.7166%2032.4627%2023.3815%2032.5954C23.0463%2032.7299%2022.6756%2032.9056%2022.2714%2033.1082C21.4631%2033.5152%2020.5167%2034.0369%2019.5901%2034.5299C18.6634%2035.023%2017.7525%2035.4875%2017.0625%2035.7672C16.8338%2035.8604%2016.6918%2035.8943%2016.5301%2035.9409C16.5282%2035.7742%2016.5183%2035.6291%2016.54%2035.3852C16.607%2034.6448%2016.7845%2033.6372%2016.9856%2032.6098C17.1847%2031.5825%2017.4075%2030.5298%2017.5593%2029.6388C17.6318%2029.2375%2017.6871%2028.8339%2017.7249%2028.4287C17.7545%2028.0701%2017.792%2027.7885%2017.6618%2027.3779C17.5317%2026.9673%2017.3405%2026.7595%2017.1098%2026.4815C16.8458%2026.1728%2016.5675%2025.8742%2016.2758%2025.5868C15.639%2024.945%2014.8503%2024.2117%2014.0933%2023.4855C13.4053%2022.8412%2012.7506%2022.1681%2012.1315%2021.4685C11.9718%2021.2802%2011.8949%2021.1566%2011.8022%2021.0185C11.96%2020.9647%2012.096%2020.9109%2012.3346%2020.8553C13.0621%2020.6886%2014.0775%2020.5469%2015.1204%2020.4196C16.1615%2020.2923%2017.234%2020.1776%2018.1311%2020.0467C18.5806%2019.9822%2018.9848%2019.9122%2019.3357%2019.8297C19.6867%2019.7473%2019.9666%2019.6953%2020.3176%2019.4443C20.6685%2019.1933%2020.8105%2018.9476%2021.0017%2018.6428C21.1949%2018.338%2021.3901%2017.9795%2021.5972%2017.5779C22.0112%2016.7728%2022.4686%2015.7993%2022.928%2014.8562C23.3264%2014.0111%2023.7658%2013.1826%2024.245%2012.373C24.3751%2012.1632%2024.4698%2012.052%2024.5723%2011.9211Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6214_857'%3e%3crect%20width='48'%20height='48'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Ete = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='150'%20height='150'%20viewBox='0%200%20150%20150'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6970_3228)'%3e%3cpath%20d='M47.9323%2082.9725L22.1211%20137.093L42.1071%20130.014L49.1893%20150L74.9983%2095.8815L47.9323%2082.9725ZM102.064%2082.9725L127.875%20137.093L107.894%20130.014L100.809%20150L74.9983%2095.8815L102.064%2082.9725Z'%20fill='%236525B3'/%3e%3cpath%20d='M71.3738%204.21871C73.3711%205.54696%2076.6403%205.54696%2078.6361%204.21871L83.9108%200.715459C84.3836%200.400363%2084.9147%200.183035%2085.4728%200.0762664C86.0308%20-0.030502%2086.6046%20-0.0245529%2087.1603%200.0937637C87.7161%200.21208%2088.2425%200.440373%2088.7087%200.765205C89.1749%201.09004%2089.5714%201.50484%2089.8748%201.98521L93.2671%207.33796C94.5511%209.36296%2097.5353%2010.6912%2099.8993%2010.2915L106.145%209.23171C106.705%209.13592%20107.279%209.15315%20107.833%209.28239C108.386%209.41163%20108.908%209.65026%20109.368%209.98424C109.827%2010.3182%20110.216%2010.7408%20110.51%2011.2271C110.804%2011.7134%20110.997%2012.2536%20111.08%2012.816L112.004%2019.0717C112.355%2021.444%20114.54%2023.8755%20116.862%2024.4747L122.99%2026.055C123.541%2026.1963%20124.058%2026.4462%20124.511%2026.7901C124.964%2027.1339%20125.344%2027.5648%20125.628%2028.0574C125.912%2028.55%20126.095%2029.0944%20126.166%2029.6587C126.237%2030.2229%20126.194%2030.7956%20126.041%2031.3432L124.34%2037.425C123.698%2039.735%20124.704%2042.8437%20126.583%2044.334L131.559%2048.2805C132.005%2048.6333%20132.375%2049.0716%20132.649%2049.5696C132.922%2050.0677%20133.094%2050.6155%20133.153%2051.1807C133.212%2051.7459%20133.157%2052.3173%20132.992%2052.861C132.827%2053.4048%20132.555%2053.9101%20132.191%2054.3472L128.156%2059.2237C126.625%2061.0717%20126.283%2064.32%20127.394%2066.4455L130.327%2072.0532C130.591%2072.5565%20130.751%2073.1075%20130.799%2073.6737C130.847%2074.24%20130.781%2074.8101%20130.605%2075.3505C130.43%2075.891%20130.148%2076.3909%20129.777%2076.8209C129.405%2077.2509%20128.951%2077.6023%20128.442%2077.8545L122.77%2080.6707C120.624%2081.7387%20118.988%2084.5677%20119.139%2086.961L119.532%2093.2767C119.568%2093.8442%20119.49%2094.413%20119.303%2094.95C119.116%2095.487%20118.824%2095.9812%20118.444%2096.4038C118.063%2096.8263%20117.602%2097.1687%20117.088%2097.4108C116.573%2097.6528%20116.016%2097.7897%20115.448%2097.8135L109.124%2098.079C106.728%2098.1817%20104.085%20100.104%20103.25%20102.351L101.048%20108.28C100.85%20108.813%20100.548%20109.301%20100.16%20109.716C99.7707%20110.131%2099.3029%20110.464%2098.7835%20110.695C98.2642%20110.927%2097.7038%20111.052%2097.1354%20111.063C96.567%20111.075%2096.0019%20110.973%2095.4736%20110.763L89.5831%20108.433C87.3533%20107.551%2084.1583%20108.23%2082.4806%20109.945L78.0533%20114.463C77.6561%20114.87%2077.1817%20115.193%2076.6578%20115.414C76.134%20115.635%2075.5713%20115.749%2075.0028%20115.749C74.4343%20115.749%2073.8715%20115.636%2073.3475%20115.415C72.8235%20115.195%2072.3488%20114.872%2071.9513%20114.466L67.5188%20109.942C65.8403%20108.231%2062.6431%20107.551%2060.4156%20108.433L54.5258%20110.763C53.9976%20110.973%2053.4327%20111.075%2052.8644%20111.064C52.2961%20111.052%2051.7359%20110.927%2051.2167%20110.695C50.6975%20110.464%2050.2299%20110.131%2049.8413%20109.716C49.4527%20109.301%2049.1511%20108.813%2048.9541%20108.28L46.7498%20102.351C45.9128%20100.104%2043.2706%2098.181%2040.8751%2098.079L34.5526%2097.8135C33.9845%2097.7898%2033.4269%2097.653%2032.9125%2097.4109C32.398%2097.1689%2031.9371%2096.8265%2031.5568%2096.4039C31.1765%2095.9813%2030.8844%2095.487%2030.6977%2094.95C30.511%2094.413%2030.4334%2093.8441%2030.4696%2093.2767L30.8648%2086.961C31.0141%2084.5685%2029.3798%2081.7387%2027.2326%2080.6707L21.5603%2077.8545C21.051%2077.6024%2020.5972%2077.251%2020.2257%2076.821C19.8541%2076.391%2019.5722%2075.8911%2019.3966%2075.3506C19.221%2074.8102%2019.1552%2074.24%2019.2031%2073.6738C19.2511%2073.1075%2019.4117%2072.5565%2019.6756%2072.0532L22.6096%2066.4455C23.7196%2064.32%2023.3776%2061.0717%2021.8483%2059.226L17.8073%2054.3457C17.4443%2053.9085%2017.1723%2053.4031%2017.0075%2052.8593C16.8426%2052.3154%2016.7882%2051.7441%2016.8474%2051.1789C16.9066%2050.6137%2017.0782%2050.0661%2017.3521%2049.5682C17.6261%2049.0703%2017.9968%2048.6322%2018.4426%2048.2797L23.4181%2044.3332C25.2961%2042.843%2026.3056%2039.7357%2025.6606%2037.4265L23.9596%2031.3402C23.8059%2030.793%2023.7631%2030.2206%2023.8338%2029.6567C23.9045%2029.0928%2024.0871%2028.5486%2024.3711%2028.0563C24.6551%2027.564%2025.0346%2027.1334%2025.4873%2026.7898C25.9401%2026.4463%2026.457%2026.1967%2027.0076%2026.0557L33.1411%2024.4725C35.4616%2023.8747%2037.6478%2021.4425%2037.9988%2019.071L38.9228%2012.8152C39.0051%2012.2529%2039.199%2011.7127%2039.4931%2011.2265C39.7872%2010.7402%2040.1756%2010.3177%2040.6354%209.98371C41.0952%209.64975%2041.6172%209.41112%2042.1706%209.28185C42.724%209.15257%2043.2976%209.13527%2043.8578%209.23096L50.1046%2010.2907C52.4678%2010.6912%2055.4513%209.36296%2056.7346%207.33721L60.1268%201.98446C60.4304%201.50415%2060.827%201.0894%2061.2933%200.764622C61.7595%200.43984%2062.286%200.211581%2062.8418%200.0932726C63.3975%20-0.0250359%2063.9713%20-0.0310048%2064.5294%200.0757173C65.0875%200.182439%2065.6187%200.399697%2066.0916%200.714709L71.3738%204.21871Z'%20fill='%23BF8AFF'/%3e%3cpath%20d='M117.141%2057.9382C117.141%2081.2107%2098.2721%20100.078%2074.9996%20100.078C51.7256%20100.078%2032.8594%2081.2115%2032.8594%2057.9382C32.8594%2034.668%2051.7256%2015.8032%2074.9996%2015.8032C98.2721%2015.8032%20117.141%2034.668%20117.141%2057.9382Z'%20fill='%23A357FF'/%3e%3cpath%20d='M74.9995%2035.106L82.4207%2050.139L99.0107%2052.5495L87.0062%2064.2525L89.8397%2080.7765L74.9995%2072.9735L60.1607%2080.7765L62.9957%2064.2525L50.9912%2052.5495L67.5805%2050.139L74.9995%2035.106Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6970_3228'%3e%3crect%20width='150'%20height='150'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", yr = ({ disabled: t, children: e, style: r, onClick: n, className: A, type: i, attr: o = "" }) => {
  const { themeConfig: s } = Xe(ct.Context);
  return /* @__PURE__ */ h("button", { className: ` ${A} q_next_button_main_cont`, type: i, style: {
    background: s.buttonColor,
    ...r,
    fontFamily: s.fontFamily || "'Figtree', sans-serif"
  }, onClick: n, disabled: t, "data-primary-button": o, children: e });
}, xte = ({
  otpScreen: t,
  setOtpScreen: e,
  sendOTP: r,
  setSendOTP: n,
  email: A,
  redirectURL: i,
  entityId: o,
  apiKey: s,
  apiSecret: a,
  onSubmit: c,
  onError: l,
  themeManager: u
}) => {
  const [f, d] = N(""), [g, m] = N(300), [p, v] = N(!1), C = gt(), { setUser: w, apiType: B } = Xe(ct.Context), y = new Xg(B);
  le(() => (b(), () => {
    C.current && clearInterval(C.current);
  }), []);
  const b = () => {
    C.current = setInterval(() => {
      m((I) => I <= 1 ? (C.current && clearInterval(C.current), 0) : I - 1);
    }, 1e3);
  }, q = (I) => {
    const S = Math.floor(I / 60), P = I % 60;
    return `${S.toString().padStart(2, "0")}:${P.toString().padStart(2, "0")}`;
  }, E = (I) => {
    d(I);
  }, x = async () => {
    if (f.length === 6)
      try {
        v(!0);
        const I = await y.verifyOTP(A, f, o, {
          apiKey: s,
          apiSecret: a
        });
        I.success ? (c && c({
          userId: I.userId,
          token: I.token,
          newUser: I.newUser,
          userCredentials: { email: A }
        }), w({
          userId: I.userId,
          token: I.token,
          newUser: I.newUser,
          userCredentials: { email: A }
        }), i && (window.location.href = i)) : l == null || l({
          email: A,
          error: I.error || "OTP verification failed"
        });
      } catch (I) {
        console.error(I), l == null || l({
          email: A,
          error: "Failed to verify OTP"
        });
      } finally {
        v(!1);
      }
  }, M = async () => {
    try {
      v(!0), (await y.sendOTP(A, o, {
        apiKey: s,
        apiSecret: a
      })).success && (m(300), b());
    } catch (I) {
      console.error(I), l == null || l({
        email: A,
        error: "Failed to resend OTP"
      });
    } finally {
      v(!1);
    }
  }, O = () => /* @__PURE__ */ h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "52",
      height: "52",
      viewBox: "0 0 52 52",
      fill: "none",
      children: /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.4603 11.6605C5 14.1208 5 18.0806 5 26.0002C5 33.9198 5 37.8796 7.4603 40.3399C9.92061 42.8002 13.8804 42.8002 21.8 42.8002H30.2C38.1196 42.8002 42.0794 42.8002 44.5397 40.3399C47 37.8796 47 33.9198 47 26.0002C47 18.0806 47 14.1208 44.5397 11.6605C42.0794 9.2002 38.1196 9.2002 30.2 9.2002H21.8C13.8804 9.2002 9.92061 9.2002 7.4603 11.6605ZM39.8099 16.5919C40.3668 17.2601 40.2765 18.2533 39.6083 18.8101L34.9957 22.654C33.1343 24.2052 31.6257 25.4624 30.2941 26.3188C28.9071 27.2109 27.5563 27.7744 26 27.7744C24.4437 27.7744 23.0929 27.2109 21.7059 26.3188C20.3743 25.4624 18.8657 24.2052 17.0043 22.654L12.3917 18.8101C11.7235 18.2533 11.6332 17.2601 12.1901 16.5919C12.7469 15.9237 13.7401 15.8334 14.4083 16.3902L18.942 20.1683C20.9012 21.801 22.2614 22.9309 23.4098 23.6695C24.5215 24.3844 25.2753 24.6244 26 24.6244C26.7246 24.6244 27.4785 24.3844 28.5902 23.6695C29.7386 22.9309 31.0988 21.801 33.058 20.1683L37.5917 16.3902C38.2599 15.8334 39.2531 15.9237 39.8099 16.5919Z",
          fill: u.getIconStyles().color
        }
      )
    }
  );
  return /* @__PURE__ */ k("div", { className: "questLabs", children: [
    p && /* @__PURE__ */ h(Bv, {}),
    /* @__PURE__ */ k("div", { className: "embeded-otp", children: [
      /* @__PURE__ */ k("div", { className: "q_heading_cont", children: [
        /* @__PURE__ */ h(
          "img",
          {
            onClick: () => {
              n(!r), e(!t);
            },
            src: yte,
            alt: "back"
          }
        ),
        /* @__PURE__ */ h("div", { className: "q-login-head2", style: u.getHeadingStyles(), children: "Confirm verification code" })
      ] }),
      /* @__PURE__ */ h("div", { className: "q_outer_cont", children: /* @__PURE__ */ h(
        "div",
        {
          className: "q_otp_main_cont",
          style: { background: u.getIconStyles().borderColor },
          children: /* @__PURE__ */ h(
            "div",
            {
              className: "q_otp_cont",
              style: { background: u.getIconStyles().background },
              children: O()
            }
          )
        }
      ) }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ h("div", { className: "q-resend", style: u.getDescriptionStyles(), children: "We've sent a verification code to" }),
        /* @__PURE__ */ h("p", { className: "q_email_otp", style: u.getHeadingStyles(), children: A }),
        /* @__PURE__ */ k("div", { style: { marginTop: "20px" }, children: [
          /* @__PURE__ */ h(
            bG,
            {
              value: f,
              onChange: E,
              numInputs: 6,
              inputStyle: "q-inputStyle",
              containerStyle: "q-containerStyle",
              renderInput: (I) => /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", justifyContent: "center" }, children: /* @__PURE__ */ h("input", { ...I, placeholder: "-", style: u.getOtpInputStyles() }) })
            }
          ),
          f.length > 0 && f.length < 6 && /* @__PURE__ */ h("div", { className: "q-login-p", children: "Please enter a valid OTP" })
        ] }),
        /* @__PURE__ */ h("p", { className: "q_otp_resend", style: u.getDescriptionStyles(), children: g > 0 ? /* @__PURE__ */ k(Ze, { children: [
          "Time remaining: ",
          q(g)
        ] }) : /* @__PURE__ */ k(Ze, { children: [
          "Did not receive your code?",
          " ",
          /* @__PURE__ */ h(
            "span",
            {
              style: {
                color: u.getHeadingStyles().color,
                cursor: "pointer"
              },
              onClick: M,
              children: "Resend"
            }
          )
        ] }) })
      ] }),
      /* @__PURE__ */ h("div", { className: "q_otp_btn_continue", children: /* @__PURE__ */ h(
        yr,
        {
          style: u.getPrimaryButtonStyles(),
          onClick: x,
          children: "Continue"
        }
      ) })
    ] })
  ] });
}, WA = ({ htmlFor: t, style: e, children: r, className: n }) => {
  const { themeConfig: A } = Xe(ct.Context);
  return /* @__PURE__ */ h("label", { htmlFor: t, style: { color: A.primaryColor, ...e }, className: `q_module_lebels ${n || ""}`, children: r });
}, L9 = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    onClick: () => e(t),
    style: { cursor: "pointer" },
    children: [
      /* @__PURE__ */ k("g", { clipPath: "url(#clip0_415_396)", children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M6.68686 5.97981C6.4916 5.78455 6.17502 5.78455 5.97975 5.97981C5.78449 6.17507 5.78449 6.49165 5.97975 6.68692L7.29287 8.00004L5.97977 9.31314C5.78451 9.50841 5.78451 9.82499 5.97977 10.0203C6.17503 10.2155 6.49161 10.2155 6.68688 10.0203L7.99998 8.70714L9.31307 10.0202C9.50834 10.2155 9.82492 10.2155 10.0202 10.0202C10.2154 9.82498 10.2154 9.50839 10.0202 9.31313L8.70709 8.00004L10.0202 6.68693C10.2155 6.49167 10.2155 6.17509 10.0202 5.97982C9.82493 5.78456 9.50835 5.78456 9.31309 5.97982L7.99998 7.29293L6.68686 5.97981Z",
            fill: "#8E8E8E"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M8 0.833374C4.04195 0.833374 0.833328 4.042 0.833328 8.00004C0.833328 11.9581 4.04195 15.1667 8 15.1667C11.958 15.1667 15.1667 11.9581 15.1667 8.00004C15.1667 4.042 11.958 0.833374 8 0.833374ZM1.83333 8.00004C1.83333 4.59428 4.59424 1.83337 8 1.83337C11.4058 1.83337 14.1667 4.59428 14.1667 8.00004C14.1667 11.4058 11.4058 14.1667 8 14.1667C4.59424 14.1667 1.83333 11.4058 1.83333 8.00004Z",
            fill: "#8E8E8E"
          }
        )
      ] }),
      /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_396", children: /* @__PURE__ */ h("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), Ite = (t) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    onClick: () => t(""),
    style: { cursor: "pointer" },
    children: [
      /* @__PURE__ */ k("g", { clipPath: "url(#clip0_415_396)", children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M6.68686 5.97981C6.4916 5.78455 6.17502 5.78455 5.97975 5.97981C5.78449 6.17507 5.78449 6.49165 5.97975 6.68692L7.29287 8.00004L5.97977 9.31314C5.78451 9.50841 5.78451 9.82499 5.97977 10.0203C6.17503 10.2155 6.49161 10.2155 6.68688 10.0203L7.99998 8.70714L9.31307 10.0202C9.50834 10.2155 9.82492 10.2155 10.0202 10.0202C10.2154 9.82498 10.2154 9.50839 10.0202 9.31313L8.70709 8.00004L10.0202 6.68693C10.2155 6.49167 10.2155 6.17509 10.0202 5.97982C9.82493 5.78456 9.50835 5.78456 9.31309 5.97982L7.99998 7.29293L6.68686 5.97981Z",
            fill: "#8E8E8E"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M8 0.833374C4.04195 0.833374 0.833328 4.042 0.833328 8.00004C0.833328 11.9581 4.04195 15.1667 8 15.1667C11.958 15.1667 15.1667 11.9581 15.1667 8.00004C15.1667 4.042 11.958 0.833374 8 0.833374ZM1.83333 8.00004C1.83333 4.59428 4.59424 1.83337 8 1.83337C11.4058 1.83337 14.1667 4.59428 14.1667 8.00004C14.1667 11.4058 11.4058 14.1667 8 14.1667C4.59424 14.1667 1.83333 11.4058 1.83333 8.00004Z",
            fill: "#8E8E8E"
          }
        )
      ] }),
      /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_396", children: /* @__PURE__ */ h("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), S1 = (t) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.62905 2.16666H9.37094C10.5961 2.16665 11.5665 2.16665 12.326 2.26875C13.1076 2.37384 13.7403 2.59525 14.2392 3.09416C14.7381 3.59307 14.9595 4.2257 15.0646 5.00732C15.1667 5.76679 15.1667 6.73722 15.1667 7.96239V8.03761C15.1667 9.26278 15.1667 10.2332 15.0646 10.9927C14.9595 11.7743 14.7381 12.4069 14.2392 12.9058C13.7403 13.4047 13.1076 13.6262 12.326 13.7312C11.5665 13.8334 10.5961 13.8333 9.37094 13.8333H6.62906C5.40388 13.8333 4.43346 13.8334 3.67398 13.7312C2.89237 13.6262 2.25973 13.4047 1.76082 12.9058C1.26192 12.4069 1.0405 11.7743 0.935418 10.9927C0.833309 10.2332 0.833318 9.26278 0.833328 8.03761V7.96239C0.833318 6.73721 0.833309 5.76679 0.935418 5.00732C1.0405 4.2257 1.26192 3.59307 1.76082 3.09416C2.25973 2.59525 2.89237 2.37384 3.67398 2.26875C4.43346 2.16665 5.40388 2.16665 6.62905 2.16666ZM3.80723 3.25984C3.1365 3.35001 2.75007 3.51913 2.46793 3.80127C2.18579 4.08341 2.01668 4.46984 1.9265 5.14056C1.83439 5.82567 1.83333 6.72878 1.83333 8C1.83333 9.27121 1.83439 10.1743 1.9265 10.8594C2.01668 11.5302 2.18579 11.9166 2.46793 12.1987C2.75007 12.4809 3.1365 12.65 3.80723 12.7402C4.49234 12.8323 5.39545 12.8333 6.66666 12.8333H9.33333C10.6045 12.8333 11.5077 12.8323 12.1928 12.7402C12.8635 12.65 13.2499 12.4809 13.5321 12.1987C13.8142 11.9166 13.9833 11.5302 14.0735 10.8594C14.1656 10.1743 14.1667 9.27121 14.1667 8C14.1667 6.72878 14.1656 5.82567 14.0735 5.14056C13.9833 4.46984 13.8142 4.08341 13.5321 3.80127C13.2499 3.51913 12.8635 3.35001 12.1928 3.25984C11.5077 3.16773 10.6045 3.16666 9.33333 3.16666H6.66666C5.39545 3.16666 4.49234 3.16773 3.80723 3.25984ZM3.61588 5.01324C3.79267 4.8011 4.10795 4.77244 4.32009 4.94922L5.75935 6.14861C6.38132 6.66692 6.81315 7.02561 7.17772 7.26008C7.53062 7.48706 7.76995 7.56325 8 7.56325C8.23004 7.56325 8.46937 7.48706 8.82227 7.26008C9.18684 7.02561 9.61867 6.66692 10.2406 6.14861L11.6799 4.94922C11.892 4.77244 12.2073 4.8011 12.3841 5.01324C12.5609 5.22538 12.5322 5.54066 12.3201 5.71744L10.8558 6.93771C10.2649 7.43015 9.78592 7.82928 9.36321 8.10115C8.92288 8.38435 8.49405 8.56325 8 8.56325C7.50594 8.56325 7.07711 8.38435 6.63678 8.10115C6.21407 7.82928 5.73514 7.43015 5.14424 6.93772L3.6799 5.71744C3.46776 5.54066 3.4391 5.22538 3.61588 5.01324Z",
        fill: t
      }
    )
  }
), La = (t) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.00501 2.27124C5.12505 1.15119 7.01515 1.23634 7.79503 2.63375L8.2277 3.40904C8.73698 4.32159 8.51996 5.47297 7.77442 6.22762C7.76449 6.24122 7.71187 6.31785 7.70531 6.45172C7.69695 6.6226 7.75764 7.01779 8.36992 7.63007C8.98201 8.24216 9.37714 8.303 9.54809 8.29468C9.68208 8.28817 9.75876 8.23551 9.77238 8.22557C10.527 7.48004 11.6784 7.26302 12.591 7.77229L13.3662 8.20497C14.7637 8.98485 14.8488 10.8749 13.7288 11.995C13.1297 12.5941 12.333 13.1264 11.3969 13.1619C10.0096 13.2145 7.70613 12.8562 5.42494 10.5751C3.14375 8.29387 2.78549 5.99038 2.83808 4.60309C2.87357 3.66696 3.4059 2.87035 4.00501 2.27124ZM6.92181 3.12108C6.52246 2.40552 5.44933 2.24113 4.71211 2.97835C4.19522 3.49524 3.85917 4.06579 3.83737 4.64097C3.79351 5.79787 4.07913 7.81504 6.13205 9.86795C8.18496 11.9209 10.2021 12.2065 11.359 12.1626C11.9342 12.1408 12.5048 11.8048 13.0217 11.2879C13.7589 10.5507 13.5945 9.47753 12.8789 9.07819L12.1036 8.64551C11.6214 8.37636 10.9439 8.46817 10.4684 8.9437L10.4682 8.94385C10.4215 8.99053 10.1243 9.26784 9.59668 9.2935C9.05653 9.31978 8.40271 9.07708 7.66281 8.33718C6.92268 7.59704 6.68006 6.94304 6.70651 6.40282C6.73235 5.87514 7.00983 5.57807 7.05626 5.53164L7.05628 5.53162C7.53182 5.05607 7.62363 4.37865 7.35448 3.89637L6.92181 3.12108Z",
        fill: t || "#8E8E8E"
      }
    )
  }
), pT = () => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M2.70837 10C2.70837 9.65482 2.9882 9.375 3.33337 9.375L15.1578 9.375L11.2248 5.44194C10.9807 5.19786 10.9807 4.80214 11.2248 4.55806C11.4688 4.31398 11.8646 4.31398 12.1086 4.55806L17.1086 9.55806C17.2259 9.67527 17.2917 9.83424 17.2917 10C17.2917 10.1658 17.2259 10.3247 17.1086 10.4419L12.1086 15.4419C11.8646 15.686 11.4688 15.686 11.2248 15.4419C10.9807 15.1979 10.9807 14.8021 11.2248 14.5581L15.1578 10.625L3.33337 10.625C2.9882 10.625 2.70837 10.3452 2.70837 10Z",
        fill: "white"
      }
    )
  }
), gT = () => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M17.2916 10C17.2916 9.65482 17.0118 9.375 16.6666 9.375L4.84218 9.375L8.77523 5.44194C9.01931 5.19786 9.01931 4.80214 8.77523 4.55806C8.53116 4.31398 8.13543 4.31398 7.89135 4.55806L2.89135 9.55806C2.77414 9.67527 2.70829 9.83424 2.70829 10C2.70829 10.1658 2.77414 10.3247 2.89135 10.4419L7.89135 15.4419C8.13543 15.686 8.53116 15.686 8.77523 15.4419C9.01931 15.1979 9.01931 14.8021 8.77523 14.5581L4.84218 10.625L16.6666 10.625C17.0118 10.625 17.2916 10.3452 17.2916 10Z",
        fill: "#252525"
      }
    )
  }
), Jg = (t = "#8E8E8E") => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          d: "M11.3334 9.33329C11.7016 9.33329 12 9.03482 12 8.66663C12 8.29844 11.7016 7.99996 11.3334 7.99996C10.9652 7.99996 10.6667 8.29844 10.6667 8.66663C10.6667 9.03482 10.9652 9.33329 11.3334 9.33329Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M11.3334 12C11.7016 12 12 11.7015 12 11.3333C12 10.9651 11.7016 10.6666 11.3334 10.6666C10.9652 10.6666 10.6667 10.9651 10.6667 11.3333C10.6667 11.7015 10.9652 12 11.3334 12Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M8.66671 8.66663C8.66671 9.03482 8.36823 9.33329 8.00004 9.33329C7.63185 9.33329 7.33337 9.03482 7.33337 8.66663C7.33337 8.29844 7.63185 7.99996 8.00004 7.99996C8.36823 7.99996 8.66671 8.29844 8.66671 8.66663Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M8.66671 11.3333C8.66671 11.7015 8.36823 12 8.00004 12C7.63185 12 7.33337 11.7015 7.33337 11.3333C7.33337 10.9651 7.63185 10.6666 8.00004 10.6666C8.36823 10.6666 8.66671 10.9651 8.66671 11.3333Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M4.66671 9.33329C5.0349 9.33329 5.33337 9.03482 5.33337 8.66663C5.33337 8.29844 5.0349 7.99996 4.66671 7.99996C4.29852 7.99996 4.00004 8.29844 4.00004 8.66663C4.00004 9.03482 4.29852 9.33329 4.66671 9.33329Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M4.66671 12C5.0349 12 5.33337 11.7015 5.33337 11.3333C5.33337 10.9651 5.0349 10.6666 4.66671 10.6666C4.29852 10.6666 4.00004 10.9651 4.00004 11.3333C4.00004 11.7015 4.29852 12 4.66671 12Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66671 1.16663C4.94285 1.16663 5.16671 1.39048 5.16671 1.66663V2.17511C5.60804 2.16662 6.09426 2.16662 6.62901 2.16663H9.37098C9.90575 2.16662 10.392 2.16662 10.8334 2.17511V1.66663C10.8334 1.39048 11.0572 1.16663 11.3334 1.16663C11.6095 1.16663 11.8334 1.39048 11.8334 1.66663V2.21802C12.0067 2.23123 12.1708 2.24784 12.3261 2.26872C13.1077 2.3738 13.7403 2.59521 14.2392 3.09412C14.7381 3.59303 14.9595 4.22566 15.0646 5.00728C15.1667 5.76675 15.1667 6.73716 15.1667 7.96232V9.3709C15.1667 10.5961 15.1667 11.5665 15.0646 12.326C14.9595 13.1076 14.7381 13.7402 14.2392 14.2391C13.7403 14.738 13.1077 14.9595 12.3261 15.0645C11.5666 15.1666 10.5962 15.1666 9.37101 15.1666H6.6291C5.40394 15.1666 4.4335 15.1666 3.67403 15.0645C2.89241 14.9595 2.25978 14.738 1.76087 14.2391C1.26196 13.7402 1.04055 13.1076 0.935464 12.326C0.833355 11.5665 0.833364 10.5961 0.833374 9.3709V7.96235C0.833364 6.73717 0.833355 5.76675 0.935464 5.00728C1.04055 4.22566 1.26196 3.59303 1.76087 3.09412C2.25978 2.59521 2.89241 2.3738 3.67403 2.26872C3.82931 2.24784 3.99341 2.23123 4.16671 2.21802V1.66663C4.16671 1.39048 4.39057 1.16663 4.66671 1.16663ZM3.80727 3.2598C3.13655 3.34998 2.75012 3.51909 2.46798 3.80123C2.18584 4.08337 2.01672 4.4698 1.92655 5.14052C1.91128 5.25412 1.89851 5.3737 1.88783 5.49996H14.1123C14.1016 5.3737 14.0888 5.25412 14.0735 5.14053C13.9834 4.4698 13.8142 4.08337 13.5321 3.80123C13.25 3.51909 12.8635 3.34998 12.1928 3.2598C11.5077 3.16769 10.6046 3.16663 9.33337 3.16663H6.66671C5.39549 3.16663 4.49238 3.16769 3.80727 3.2598ZM1.83337 7.99996C1.83337 7.43062 1.83359 6.93511 1.8421 6.49996H14.158C14.1665 6.93511 14.1667 7.43062 14.1667 7.99996V9.33329C14.1667 10.6045 14.1656 11.5076 14.0735 12.1927C13.9834 12.8635 13.8142 13.2499 13.5321 13.532C13.25 13.8142 12.8635 13.9833 12.1928 14.0735C11.5077 14.1656 10.6046 14.1666 9.33337 14.1666H6.66671C5.39549 14.1666 4.49238 14.1656 3.80727 14.0735C3.13655 13.9833 2.75012 13.8142 2.46798 13.532C2.18584 13.2499 2.01672 12.8635 1.92655 12.1927C1.83444 11.5076 1.83337 10.6045 1.83337 9.33329V7.99996Z",
          fill: t
        }
      )
    ]
  }
), Ste = () => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.39946 1.5941C10.4138 0.579798 12.0583 0.579798 13.0726 1.5941C14.0869 2.60841 14.0869 4.25292 13.0726 5.26722L8.0099 10.3299C7.72457 10.6153 7.55032 10.7895 7.3561 10.941C7.12728 11.1195 6.8797 11.2725 6.61774 11.3974C6.39539 11.5033 6.16159 11.5812 5.77875 11.7088L3.99698 12.3028L3.5692 12.4453C3.1863 12.573 2.76415 12.4733 2.47876 12.1879C2.19336 11.9025 2.0937 11.4804 2.22134 11.0975L2.95785 8.88794C3.08544 8.50509 3.16336 8.27129 3.26933 8.04894C3.39417 7.78698 3.54719 7.5394 3.72566 7.31058C3.87715 7.11636 4.05142 6.94211 4.33679 6.65677L9.39946 1.5941ZM3.97391 11.2563L3.41033 10.6928L3.89595 9.23593C4.03734 8.81176 4.09573 8.6393 4.17205 8.47916C4.26565 8.28276 4.38037 8.09715 4.51417 7.9256C4.62327 7.78572 4.75141 7.65636 5.06757 7.34021L8.99488 3.41289C9.15699 3.81955 9.43127 4.31036 9.89379 4.77289C10.3563 5.23541 10.8471 5.50969 11.2538 5.6718L7.32647 9.59911C7.01032 9.91527 6.88096 10.0434 6.74108 10.1525C6.56953 10.2863 6.38392 10.401 6.18752 10.4946C6.02738 10.5709 5.85492 10.6293 5.43076 10.7707L3.97391 11.2563ZM12.0506 4.87498C11.9681 4.85685 11.8648 4.82959 11.7475 4.78887C11.4248 4.67692 11.0003 4.46523 10.6009 4.06578C10.2015 3.66633 9.98976 3.24188 9.87781 2.9192C9.83709 2.80184 9.80983 2.69862 9.7917 2.61607L10.1066 2.30121C10.7303 1.67743 11.7417 1.67743 12.3655 2.30121C12.9893 2.92499 12.9893 3.93634 12.3655 4.56012L12.0506 4.87498ZM2.16664 14.6667C2.16664 14.3906 2.3905 14.1667 2.66664 14.1667H13.3333V15.1667H2.66664C2.3905 15.1667 2.16664 14.9429 2.16664 14.6667Z",
        fill: "#8E8E8E"
      }
    )
  }
), _g = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M24.4003 7.61363C24.2769 7.49003 24.1304 7.39196 23.9691 7.32505C23.8078 7.25815 23.6349 7.22371 23.4603 7.22371C23.2857 7.22371 23.1128 7.25815 22.9515 7.32505C22.7902 7.39196 22.6436 7.49003 22.5203 7.61363L16.0003 14.1203L9.4803 7.6003C9.35686 7.47686 9.21031 7.37894 9.04902 7.31213C8.88774 7.24532 8.71487 7.21094 8.5403 7.21094C8.36572 7.21094 8.19286 7.24532 8.03157 7.31213C7.87029 7.37894 7.72374 7.47686 7.6003 7.6003C7.47686 7.72374 7.37894 7.87029 7.31213 8.03157C7.24532 8.19286 7.21094 8.36572 7.21094 8.5403C7.21094 8.71487 7.24532 8.88774 7.31213 9.04902C7.37894 9.21031 7.47686 9.35686 7.6003 9.4803L14.1203 16.0003L7.6003 22.5203C7.47686 22.6437 7.37894 22.7903 7.31213 22.9516C7.24532 23.1129 7.21094 23.2857 7.21094 23.4603C7.21094 23.6349 7.24532 23.8077 7.31213 23.969C7.37894 24.1303 7.47686 24.2769 7.6003 24.4003C7.72374 24.5237 7.87029 24.6217 8.03157 24.6885C8.19286 24.7553 8.36572 24.7897 8.5403 24.7897C8.71487 24.7897 8.88774 24.7553 9.04902 24.6885C9.21031 24.6217 9.35686 24.5237 9.4803 24.4003L16.0003 17.8803L22.5203 24.4003C22.6437 24.5237 22.7903 24.6217 22.9516 24.6885C23.1129 24.7553 23.2857 24.7897 23.4603 24.7897C23.6349 24.7897 23.8077 24.7553 23.969 24.6885C24.1303 24.6217 24.2769 24.5237 24.4003 24.4003C24.5237 24.2769 24.6217 24.1303 24.6885 23.969C24.7553 23.8077 24.7897 23.6349 24.7897 23.4603C24.7897 23.2857 24.7553 23.1129 24.6885 22.9516C24.6217 22.7903 24.5237 22.6437 24.4003 22.5203L17.8803 16.0003L24.4003 9.4803C24.907 8.97363 24.907 8.1203 24.4003 7.61363Z",
        fill: t || "#AFAFAF"
      }
    )
  }
), mT = (t) => /* @__PURE__ */ k(
  "svg",
  {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ k("g", { clipRule: "url(#clip0_4046_146)", children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
            fill: "url(#paint0_linear_4046_146)"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M48.4167 79.0566C49.1837 78.9078 49.9463 78.7367 50.7033 78.5432C51.987 78.1844 53.2519 77.7617 54.4933 77.2766C55.7363 76.7955 56.9545 76.2526 58.1433 75.6499C59.3325 75.0449 60.4906 74.3807 61.6133 73.6599C62.7348 72.939 63.8195 72.1625 64.8633 71.3332C65.9091 70.5029 66.9125 69.6207 67.87 68.6899C68.8259 67.7614 69.7348 66.7858 70.5933 65.7666C71.4526 64.7465 72.2603 63.684 73.0133 62.5832C73.7662 61.4843 74.4638 60.3484 75.1033 59.1799C75.743 58.0097 76.3237 56.8082 76.8433 55.5799C77.3635 54.3514 77.8218 53.0976 78.2167 51.8232C78.5548 50.7075 78.8439 49.5776 79.0833 48.4366L55.3167 24.6732C53.3096 22.6573 50.9236 21.0581 48.2961 19.9677C45.6686 18.8774 42.8514 18.3174 40.0067 18.3199C37.1594 18.3168 34.3395 18.8765 31.7092 19.9668C29.0789 21.0572 26.6901 22.6566 24.68 24.6732C22.6649 26.6839 21.0661 29.0724 19.9753 31.7018C18.8845 34.3312 18.323 37.1499 18.323 39.9966C18.323 42.8433 18.8845 45.662 19.9753 48.2914C21.0661 50.9208 22.6649 53.3092 24.68 55.3199L48.4167 79.0566Z",
            fill: "url(#paint0_linear_4046_146)"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M40.0033 18.3232C45.5433 18.3232 51.0833 20.4398 55.3233 24.6765C57.3384 26.6872 58.9372 29.0756 60.028 31.705C61.1188 34.3344 61.6803 37.1532 61.6803 39.9998C61.6803 42.8465 61.1188 45.6653 60.028 48.2947C58.9372 50.9241 57.3384 53.3125 55.3233 55.3232C53.3126 57.3383 50.9242 58.937 48.2948 60.0279C45.6654 61.1187 42.8467 61.6802 40 61.6802C37.1533 61.6802 34.3346 61.1187 31.7052 60.0279C29.0758 58.937 26.6873 57.3383 24.6767 55.3232C22.6615 53.3125 21.0628 50.9241 19.972 48.2947C18.8811 45.6653 18.3196 42.8465 18.3196 39.9998C18.3196 37.1532 18.8811 34.3344 19.972 31.705C21.0628 29.0756 22.6615 26.6872 24.6767 24.6765C26.6867 22.6599 29.0756 21.0604 31.7059 19.9701C34.3361 18.8798 37.156 18.3201 40.0033 18.3232ZM49.87 33.3298C49.5544 33.3601 49.2539 33.4791 49.0033 33.6732L36.8233 42.8065L31.18 37.1665C29.9566 35.8932 27.5467 38.2998 28.8233 39.5232L35.49 46.1898C35.779 46.4631 36.1536 46.6281 36.5504 46.6566C36.9471 46.6852 37.3415 46.5756 37.6667 46.3465L51 36.3465C52.12 35.5298 51.43 33.3532 50.0433 33.3332C49.9867 33.3303 49.9299 33.3303 49.8733 33.3332L49.87 33.3298Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ k("defs", { children: [
        /* @__PURE__ */ k(
          "linearGradient",
          {
            id: "paint0_linear_4046_146",
            x1: "0.320001",
            y1: "80",
            x2: "87.5968",
            y2: "71.0629",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ h("stop", { stopColor: "#9035FF" }),
              /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#0065FF" })
            ]
          }
        ),
        /* @__PURE__ */ k(
          "linearGradient",
          {
            id: "paint1_linear_4046_146",
            x1: "18.566",
            y1: "79.0566",
            x2: "84.8526",
            y2: "72.2662",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ h("stop", { stopColor: "#9035FF" }),
              /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#0065FF" })
            ]
          }
        ),
        /* @__PURE__ */ h("clipPath", { id: "clip0_4046_146", children: /* @__PURE__ */ h("rect", { width: "80", height: "80", fill: "white" }) })
      ] })
    ]
  }
), G9 = {
  email: S1,
  phone: La,
  text: () => /* @__PURE__ */ h(Ze, {}),
  number: La,
  date: Jg
}, Li = ({
  placeholder: t,
  type: e,
  style: r,
  onChange: n,
  iconColor: A,
  value: i,
  onKeyUp: o,
  onKeyDown: s,
  ref: a,
  logoPosition: c = "right",
  emailErrorStyle: l,
  emailtext: u,
  required: f,
  regexKey: d,
  regexMessage: g,
  name: m,
  preventFutureSelection: p,
  preventPastSelection: v
}) => {
  const { themeConfig: C } = Xe(ct.Context), w = gt(null), [B, y] = N(!0), q = e === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/ : /^.+$/, x = d && ((S) => {
    try {
      return new RegExp(S || ""), !0;
    } catch {
      return !1;
    }
  })(d) ? new RegExp(d) : q, M = (S) => {
    y(S ? x.test(S) : !0);
  }, O = (S) => {
    const P = S.target.value;
    (e === "email" || d) && M(P), n && n(S);
  }, I = (S) => {
    const P = S.target.value;
    (e === "email" || d) && M(P);
  };
  return /* @__PURE__ */ k(Ze, { children: [
    e === "date" ? /* @__PURE__ */ k(
      "div",
      {
        className: "q_input_cont",
        onClick: () => {
          var S;
          return (S = w.current) == null ? void 0 : S.showPicker();
        },
        style: {
          borderColor: C.borderColor,
          color: C.primaryColor,
          ...r
        },
        children: [
          /* @__PURE__ */ k(
            "label",
            {
              htmlFor: "dateInput",
              className: "q_input_custom_datePicker_label",
              children: [
                /* @__PURE__ */ h(
                  "input",
                  {
                    type: e,
                    name: "dateInput",
                    placeholder: t,
                    className: "q_input_main_cont q_input_custom_datePicker",
                    onChange: n,
                    value: i,
                    required: f,
                    ref: w,
                    max: p ? new Date((/* @__PURE__ */ new Date()).setDate((/* @__PURE__ */ new Date()).getDate() - 1)).toISOString().split("T")[0] : void 0,
                    min: v ? (/* @__PURE__ */ new Date()).toISOString().split("T")[0] : void 0
                  }
                ),
                i ? /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      display: "inline",
                      marginTop: "2px",
                      color: r == null ? void 0 : r.color,
                      fontSize: r == null ? void 0 : r.fontSize
                    },
                    children: i
                  }
                ) : /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      display: "inline",
                      color: "#8E8E8E",
                      marginTop: "2px",
                      fontSize: r == null ? void 0 : r.fontSize
                    },
                    children: t
                  }
                )
              ]
            }
          ),
          G9.date(A || "#B9B9B9")
        ]
      }
    ) : /* @__PURE__ */ k("div", { className: "q_input_cont", style: r, children: [
      (c == "left" || c == "both") && G9[e](A || "#B9B9B9"),
      /* @__PURE__ */ h(
        "input",
        {
          type: e,
          name: m,
          placeholder: t,
          className: "q_input_main_cont",
          onChange: O,
          onKeyUp: o,
          onKeyDown: s,
          defaultValue: i,
          ref: a,
          onBlur: I,
          onWheel: (S) => {
            S.currentTarget.blur();
          },
          style: {
            fontFamily: C.fontFamily || "'Figtree', sans-serif",
            color: (r == null ? void 0 : r.color) || C.primaryColor
          },
          required: f,
          pattern: e === "email" || d ? x.source : void 0
        }
      ),
      (c == "right" || c == "both") && G9[e](A || "#B9B9B9")
    ] }),
    (e === "email" || !!d) && !B && /* @__PURE__ */ h("span", { style: l, className: "q-input-error-message", children: g || u })
  ] });
}, Pte = ({
  otpScreen: t,
  setOtpScreen: e,
  redirectURL: r,
  handleOtp: n,
  entityId: A,
  apiKey: i,
  apiSecret: o,
  onSubmit: s,
  IconColor: a,
  onError: c,
  themeManager: l
}) => {
  const [u, f] = N(!1), [d, g] = N(""), [m, p] = N(!0), [v, C] = N(!0), [w, B] = N(!1), { apiType: y } = Xe(ct.Context), b = new Xg(y), q = (O) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(O.trim()), E = (O) => {
    const I = O.currentTarget.value;
    g(I), p(q(I));
  }, x = (O) => {
    O.key === "Enter" && O.currentTarget.value !== "" && (C(m), M());
  }, M = async () => {
    if (b.trackEvent("quest_login_continue_btn_clicked", "quest_login"), C(m), !(!m || d.length === 0)) {
      B(!0);
      try {
        (await b.sendOTP(d, A, {
          apiKey: i,
          apiSecret: o
        })).success && (f(!0), n(!0));
      } catch {
        c == null || c({ email: d, error: "Failed to send OTP" });
      } finally {
        B(!1);
      }
    }
  };
  return /* @__PURE__ */ k("div", { style: { width: "100%" }, children: [
    w && /* @__PURE__ */ h(Bv, {}),
    u ? /* @__PURE__ */ h(
      xte,
      {
        otpScreen: t,
        setOtpScreen: e,
        sendOTP: u,
        setSendOTP: f,
        apiKey: i,
        apiSecret: o,
        redirectURL: r,
        entityId: A,
        email: d,
        onSubmit: s,
        onError: c,
        themeManager: l
      }
    ) : /* @__PURE__ */ k("div", { className: "q-email-login-ctn", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ h(WA, { style: l.getLabelStyles(), children: "Email" }),
        /* @__PURE__ */ h(
          Li,
          {
            iconColor: a,
            style: l.getInputStyles(),
            logoPosition: "left",
            type: "email",
            placeholder: "Enter your email id",
            value: d,
            onChange: E,
            onKeyUp: x
          }
        ),
        !v && /* @__PURE__ */ h("div", { className: "q-login-p", children: "Please enter a valid email id" })
      ] }),
      /* @__PURE__ */ h(
        yr,
        {
          style: l.getPrimaryButtonStyles(),
          onClick: M,
          children: "Continue"
        }
      )
    ] })
  ] });
}, vT = "%[a-f0-9]{2}", hb = new RegExp("(" + vT + ")|([^%]+?)", "gi"), pb = new RegExp("(" + vT + ")+", "gi");
function V5(t, e) {
  try {
    return [decodeURIComponent(t.join(""))];
  } catch {
  }
  if (t.length === 1)
    return t;
  e = e || 1;
  const r = t.slice(0, e), n = t.slice(e);
  return Array.prototype.concat.call([], V5(r), V5(n));
}
function kte(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    let e = t.match(hb) || [];
    for (let r = 1; r < e.length; r++)
      t = V5(e, r).join(""), e = t.match(hb) || [];
    return t;
  }
}
function Ote(t) {
  const e = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = pb.exec(t);
  for (; r; ) {
    try {
      e[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const A = kte(r[0]);
      A !== r[0] && (e[r[0]] = A);
    }
    r = pb.exec(t);
  }
  e["%C2"] = "�";
  const n = Object.keys(e);
  for (const A of n)
    t = t.replace(new RegExp(A, "g"), e[A]);
  return t;
}
function Fte(t) {
  if (typeof t != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
  try {
    return decodeURIComponent(t);
  } catch {
    return Ote(t);
  }
}
function qT(t, e) {
  if (!(typeof t == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (t === "" || e === "")
    return [];
  const r = t.indexOf(e);
  return r === -1 ? [] : [
    t.slice(0, r),
    t.slice(r + e.length)
  ];
}
function Tte(t, e) {
  const r = {};
  if (Array.isArray(e))
    for (const n of e) {
      const A = Object.getOwnPropertyDescriptor(t, n);
      A != null && A.enumerable && Object.defineProperty(r, n, A);
    }
  else
    for (const n of Reflect.ownKeys(t)) {
      const A = Object.getOwnPropertyDescriptor(t, n);
      if (A.enumerable) {
        const i = t[n];
        e(n, i, t) && Object.defineProperty(r, n, A);
      }
    }
  return r;
}
const Mte = (t) => t == null, Hte = (t) => encodeURIComponent(t).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), W5 = Symbol("encodeFragmentIdentifier");
function Dte(t) {
  switch (t.arrayFormat) {
    case "index":
      return (e) => (r, n) => {
        const A = r.length;
        return n === void 0 || t.skipNull && n === null || t.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [Qn(e, t), "[", A, "]"].join("")
        ] : [
          ...r,
          [Qn(e, t), "[", Qn(A, t), "]=", Qn(n, t)].join("")
        ];
      };
    case "bracket":
      return (e) => (r, n) => n === void 0 || t.skipNull && n === null || t.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Qn(e, t), "[]"].join("")
      ] : [
        ...r,
        [Qn(e, t), "[]=", Qn(n, t)].join("")
      ];
    case "colon-list-separator":
      return (e) => (r, n) => n === void 0 || t.skipNull && n === null || t.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Qn(e, t), ":list="].join("")
      ] : [
        ...r,
        [Qn(e, t), ":list=", Qn(n, t)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const e = t.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, A) => A === void 0 || t.skipNull && A === null || t.skipEmptyString && A === "" ? n : (A = A === null ? "" : A, n.length === 0 ? [[Qn(r, t), e, Qn(A, t)].join("")] : [[n, Qn(A, t)].join(t.arrayFormatSeparator)]);
    }
    default:
      return (e) => (r, n) => n === void 0 || t.skipNull && n === null || t.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        Qn(e, t)
      ] : [
        ...r,
        [Qn(e, t), "=", Qn(n, t)].join("")
      ];
  }
}
function Qte(t) {
  let e;
  switch (t.arrayFormat) {
    case "index":
      return (r, n, A) => {
        if (e = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !e) {
          A[r] = n;
          return;
        }
        A[r] === void 0 && (A[r] = {}), A[r][e[1]] = n;
      };
    case "bracket":
      return (r, n, A) => {
        if (e = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !e) {
          A[r] = n;
          return;
        }
        if (A[r] === void 0) {
          A[r] = [n];
          return;
        }
        A[r] = [...A[r], n];
      };
    case "colon-list-separator":
      return (r, n, A) => {
        if (e = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !e) {
          A[r] = n;
          return;
        }
        if (A[r] === void 0) {
          A[r] = [n];
          return;
        }
        A[r] = [...A[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, A) => {
        const i = typeof n == "string" && n.includes(t.arrayFormatSeparator), o = typeof n == "string" && !i && hs(n, t).includes(t.arrayFormatSeparator);
        n = o ? hs(n, t) : n;
        const s = i || o ? n.split(t.arrayFormatSeparator).map((a) => hs(a, t)) : n === null ? n : hs(n, t);
        A[r] = s;
      };
    case "bracket-separator":
      return (r, n, A) => {
        const i = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !i) {
          A[r] = n && hs(n, t);
          return;
        }
        const o = n === null ? [] : n.split(t.arrayFormatSeparator).map((s) => hs(s, t));
        if (A[r] === void 0) {
          A[r] = o;
          return;
        }
        A[r] = [...A[r], ...o];
      };
    default:
      return (r, n, A) => {
        if (A[r] === void 0) {
          A[r] = n;
          return;
        }
        A[r] = [...[A[r]].flat(), n];
      };
  }
}
function yT(t) {
  if (typeof t != "string" || t.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function Qn(t, e) {
  return e.encode ? e.strict ? Hte(t) : encodeURIComponent(t) : t;
}
function hs(t, e) {
  return e.decode ? Fte(t) : t;
}
function CT(t) {
  return Array.isArray(t) ? t.sort() : typeof t == "object" ? CT(Object.keys(t)).sort((e, r) => Number(e) - Number(r)).map((e) => t[e]) : t;
}
function wT(t) {
  const e = t.indexOf("#");
  return e !== -1 && (t = t.slice(0, e)), t;
}
function Ute(t) {
  let e = "";
  const r = t.indexOf("#");
  return r !== -1 && (e = t.slice(r)), e;
}
function gb(t, e) {
  return e.parseNumbers && !Number.isNaN(Number(t)) && typeof t == "string" && t.trim() !== "" ? t = Number(t) : e.parseBooleans && t !== null && (t.toLowerCase() === "true" || t.toLowerCase() === "false") && (t = t.toLowerCase() === "true"), t;
}
function Ev(t) {
  t = wT(t);
  const e = t.indexOf("?");
  return e === -1 ? "" : t.slice(e + 1);
}
function xv(t, e) {
  e = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    ...e
  }, yT(e.arrayFormatSeparator);
  const r = Qte(e), n = /* @__PURE__ */ Object.create(null);
  if (typeof t != "string" || (t = t.trim().replace(/^[?#&]/, ""), !t))
    return n;
  for (const A of t.split("&")) {
    if (A === "")
      continue;
    const i = e.decode ? A.replace(/\+/g, " ") : A;
    let [o, s] = qT(i, "=");
    o === void 0 && (o = i), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(e.arrayFormat) ? s : hs(s, e), r(hs(o, e), s, n);
  }
  for (const [A, i] of Object.entries(n))
    if (typeof i == "object" && i !== null)
      for (const [o, s] of Object.entries(i))
        i[o] = gb(s, e);
    else
      n[A] = gb(i, e);
  return e.sort === !1 ? n : (e.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(e.sort)).reduce((A, i) => {
    const o = n[i];
    return A[i] = o && typeof o == "object" && !Array.isArray(o) ? CT(o) : o, A;
  }, /* @__PURE__ */ Object.create(null));
}
function bT(t, e) {
  if (!t)
    return "";
  e = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...e
  }, yT(e.arrayFormatSeparator);
  const r = (o) => e.skipNull && Mte(t[o]) || e.skipEmptyString && t[o] === "", n = Dte(e), A = {};
  for (const [o, s] of Object.entries(t))
    r(o) || (A[o] = s);
  const i = Object.keys(A);
  return e.sort !== !1 && i.sort(e.sort), i.map((o) => {
    const s = t[o];
    return s === void 0 ? "" : s === null ? Qn(o, e) : Array.isArray(s) ? s.length === 0 && e.arrayFormat === "bracket-separator" ? Qn(o, e) + "[]" : s.reduce(n(o), []).join("&") : Qn(o, e) + "=" + Qn(s, e);
  }).filter((o) => o.length > 0).join("&");
}
function BT(t, e) {
  var A;
  e = {
    decode: !0,
    ...e
  };
  let [r, n] = qT(t, "#");
  return r === void 0 && (r = t), {
    url: ((A = r == null ? void 0 : r.split("?")) == null ? void 0 : A[0]) ?? "",
    query: xv(Ev(t), e),
    ...e && e.parseFragmentIdentifier && n ? { fragmentIdentifier: hs(n, e) } : {}
  };
}
function ET(t, e) {
  e = {
    encode: !0,
    strict: !0,
    [W5]: !0,
    ...e
  };
  const r = wT(t.url).split("?")[0] || "", n = Ev(t.url), A = {
    ...xv(n, { sort: !1 }),
    ...t.query
  };
  let i = bT(A, e);
  i && (i = `?${i}`);
  let o = Ute(t.url);
  if (t.fragmentIdentifier) {
    const s = new URL(r);
    s.hash = t.fragmentIdentifier, o = e[W5] ? s.hash : `#${t.fragmentIdentifier}`;
  }
  return `${r}${i}${o}`;
}
function xT(t, e, r) {
  r = {
    parseFragmentIdentifier: !0,
    [W5]: !1,
    ...r
  };
  const { url: n, query: A, fragmentIdentifier: i } = BT(t, r);
  return ET({
    url: n,
    query: Tte(A, e),
    fragmentIdentifier: i
  }, r);
}
function Nte(t, e, r) {
  const n = Array.isArray(e) ? (A) => !e.includes(A) : (A, i) => !e(A, i);
  return xT(t, n, r);
}
const jte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: Nte,
  extract: Ev,
  parse: xv,
  parseUrl: BT,
  pick: xT,
  stringify: bT,
  stringifyUrl: ET
}, Symbol.toStringTag, { value: "Module" })), JA = ({
  children: t,
  style: e,
  onClick: r,
  disabled: n,
  className: A
}) => {
  const { themeConfig: i } = Xe(ct.Context);
  return /* @__PURE__ */ h("button", { className: `q_prev_button_main_cont ${A}`, style: { ...e, fontFamily: i.fontFamily || "'Figtree', sans-serif" }, onClick: r, disabled: n || !1, children: t });
}, mb = ({
  entityId: t,
  redirectUri: e,
  redirectURL: r,
  googleClientId: n,
  apiSecret: A,
  apiKey: i,
  onSubmit: o,
  googleButtonText: s,
  onError: a,
  themeManager: c
}) => {
  const [l, u] = N(!1), { setUser: f, apiType: d } = Xe(ct.Context);
  let g = new Bt("mixpanel", d);
  const m = new Xg(d), v = jte.parse(window.location.search).code;
  le(() => {
    v && C(v);
  }, [v]);
  const C = async (B) => {
    try {
      u(!0);
      const y = await m.googleLogin(B, e, t, {
        apiKey: i,
        apiSecret: A
      });
      y.success ? (o && o({
        userId: y.userId,
        token: y.token,
        userCredentials: y.credentials,
        refreshToken: y.refreshToken,
        newUser: y.newUser
      }), f({
        userId: y.userId,
        token: y.token,
        userCredentials: y.credentials,
        refreshToken: y.refreshToken
      }), r && (window.location.href = r)) : a == null || a({
        error: y.error || "Google login failed",
        isGoogle: !0
      });
    } catch (y) {
      console.error("Google login error:", y), g.captureSentryException(y), a == null || a({
        error: "Failed to complete Google login",
        isGoogle: !0
      });
    } finally {
      u(!1);
    }
  };
  return /* @__PURE__ */ h("div", { className: "q-google-login-btn", style: { width: "100%" }, children: /* @__PURE__ */ k("div", { style: { position: "relative" }, children: [
    l && /* @__PURE__ */ h(Bv, {}),
    /* @__PURE__ */ h(
      "a",
      {
        style: { textDecoration: "none", color: "red" },
        onClick: () => {
          m.trackEvent("quest_login_google_btn_clicked", "quest_login");
          try {
            const B = m.initiateGoogleLogin(
              n,
              e
            );
            window.location.href = B;
          } catch {
            a == null || a({
              error: "Google Client ID is required for Google login",
              isGoogle: !0
            });
          }
        },
        children: /* @__PURE__ */ k(JA, { style: c.getSecondaryButtonStyles(), children: [
          /* @__PURE__ */ h("p", { children: s || "Sign in with Google" }),
          /* @__PURE__ */ h("img", { className: "ml-auto", src: Cte, alt: "google-logo" })
        ] })
      }
    )
  ] }) });
}, Lte = (t = "#B9B9B9") => `data:image/svg+xml,${encodeURIComponent(t)}`, Gte = (t = "#B9B9B9") => Lte(`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z" fill="${t}"/>
<path d="M12 8L8 8L8 12H12V8Z" fill="${t}"/>
</svg>
`);
function Pr({
  style: t,
  textStyle: e,
  iconStyle: r,
  text: n,
  link: A,
  icon: i = !0
}) {
  const { themeConfig: o } = Xe(ct.Context);
  return /* @__PURE__ */ k(
    "div",
    {
      style: { color: o.secondaryColor, ...t },
      onClick: () => {
        window.open(A || "https://www.plgos.com/", "_blank");
      },
      className: "powered_by_quest",
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            style: {
              color: (e == null ? void 0 : e.color) || o.secondaryColor,
              ...e
            },
            children: n || "Powered by PLG OS"
          }
        ),
        i && /* @__PURE__ */ h(
          "div",
          {
            style: {
              width: (r == null ? void 0 : r.width) || "12px",
              height: (r == null ? void 0 : r.height) || "12px",
              boxSizing: "content-box"
            },
            children: /* @__PURE__ */ h(
              "img",
              {
                src: Gte((r == null ? void 0 : r.color) || "#B9B9B9"),
                style: { ...r },
                alt: ""
              }
            )
          }
        )
      ]
    }
  );
}
const Ms = {
  accentColor: "",
  theme: "",
  borderRadius: "",
  buttonColor: "",
  images: []
}, Hs = {
  accentColor: "",
  background: "",
  borderRadius: "",
  primaryButton: "",
  contentColor: "",
  fontFamily: "",
  logo: "",
  primaryColor: "",
  secondaryColor: "",
  tertiaryColor: "",
  titleColor: ""
};
class Rte {
  constructor(e = {}, r = {}, n, A, i) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    ke(this, "accent");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = n || {
      accentColor: "",
      theme: "",
      borderRadius: "",
      buttonColor: "",
      images: []
    }, this.brandTheme = A || {
      accentColor: "",
      background: "",
      borderRadius: "",
      primaryButton: "",
      contentColor: "",
      fontFamily: "",
      logo: "",
      primaryColor: "",
      secondaryColor: "",
      tertiaryColor: "",
      titleColor: ""
    }, this.accent = "";
  }
  // Main container styles
  getContainerStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.themeConfig) == null ? void 0 : n.backgroundColor),
      height: ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.height) || "auto",
      fontFamily: ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.fontFamily) || ((a = this.brandTheme) == null ? void 0 : a.fontFamily) || this.themeConfig.fontFamily || "'Figtree', sans-serif",
      borderRadius: ((l = (c = this.styleConfig) == null ? void 0 : c.Form) == null ? void 0 : l.borderRadius) || ((u = this.questThemeData) == null ? void 0 : u.borderRadius) || ((f = this.brandTheme) == null ? void 0 : f.borderRadius),
      ...(d = this.styleConfig) == null ? void 0 : d.Form
    };
  }
  // Heading styles
  getHeadingStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.titleColor) || ((A = this.brandTheme) == null ? void 0 : A.primaryColor) || ((i = this.themeConfig) == null ? void 0 : i.primaryColor),
      ...(o = this.styleConfig) == null ? void 0 : o.Heading
    };
  }
  // Description styles
  getDescriptionStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  // Label styles
  getLabelStyles() {
    var e, r, n, A, i, o, s;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Label) == null ? void 0 : r.color) || ((A = (n = this.styleConfig) == null ? void 0 : n.Heading) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.Label
    };
  }
  // Input styles
  getInputStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      color: ((i = (A = this.styleConfig) == null ? void 0 : A.Input) == null ? void 0 : i.color) || ((s = (o = this.styleConfig) == null ? void 0 : o.Heading) == null ? void 0 : s.color) || ((a = this.brandTheme) == null ? void 0 : a.primaryColor) || ((c = this.themeConfig) == null ? void 0 : c.primaryColor),
      borderRadius: "6px",
      borderWidth: "1.5px",
      padding: "8px 12px",
      ...(l = this.styleConfig) == null ? void 0 : l.Input
    };
  }
  // OTP Input styles
  getOtpInputStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      backgroundColor: ((r = (e = this.styleConfig) == null ? void 0 : e.OtpInput) == null ? void 0 : r.backgroundColor) || "transparent",
      borderColor: ((A = (n = this.styleConfig) == null ? void 0 : n.OtpInput) == null ? void 0 : A.borderColor) || this.themeConfig.borderColor,
      color: ((o = (i = this.styleConfig) == null ? void 0 : i.Heading) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor) || this.themeConfig.primaryColor,
      ...(a = this.styleConfig) == null ? void 0 : a.OtpInput
    };
  }
  getPrimaryButtonStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.PrimaryButton) == null ? void 0 : r.background) || ((n = this.questThemeData) == null ? void 0 : n.buttonColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || (this == null ? void 0 : this.accent) || ((i = this.brandTheme) == null ? void 0 : i.primaryButton) || ((o = this.themeConfig) == null ? void 0 : o.buttonColor),
      fontFamily: this.themeConfig.fontFamily || "'Figtree', sans-serif",
      borderColor: ((a = (s = this.styleConfig) == null ? void 0 : s.PrimaryButton) == null ? void 0 : a.background) || ((c = this.questThemeData) == null ? void 0 : c.buttonColor) || ((l = this.questThemeData) == null ? void 0 : l.accentColor) || this.accent || ((u = this.brandTheme) == null ? void 0 : u.primaryButton) || ((f = this.themeConfig) == null ? void 0 : f.buttonColor),
      ...(d = this.styleConfig) == null ? void 0 : d.PrimaryButton
    };
  }
  getSecondaryButtonStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.SecondaryButton) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      background: (i = (A = this.styleConfig) == null ? void 0 : A.SecondaryButton) == null ? void 0 : i.backgroundColor,
      color: ((s = (o = this.styleConfig) == null ? void 0 : o.SecondaryButton) == null ? void 0 : s.color) || ((a = this.brandTheme) == null ? void 0 : a.primaryColor) || ((c = this.themeConfig) == null ? void 0 : c.primaryColor) || "#2c2c2c",
      ...(l = this.styleConfig) == null ? void 0 : l.SecondaryButton
    };
  }
  getIconStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.IconStyle) == null ? void 0 : r.color) || "#F4EBFF",
      background: ((A = (n = this.styleConfig) == null ? void 0 : n.IconStyle) == null ? void 0 : A.Background) || this.questThemeData.accentColor || this.accent,
      borderColor: ((o = (i = this.styleConfig) == null ? void 0 : i.IconStyle) == null ? void 0 : o.BorderColor) || this.questThemeData.accentColor || this.accent
    };
  }
  // Footer styles
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p;
    return {
      container: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((o = this.themeConfig) == null ? void 0 : o.backgroundColor),
        ...(a = (s = this.styleConfig) == null ? void 0 : s.Footer) == null ? void 0 : a.FooterStyle
      },
      text: ((l = (c = this.styleConfig) == null ? void 0 : c.Footer) == null ? void 0 : l.FooterTextStyle) || {},
      icon: ((f = (u = this.styleConfig) == null ? void 0 : u.Footer) == null ? void 0 : f.FooterIcon) || {},
      content: {
        text: (g = (d = this.styleConfig) == null ? void 0 : d.Footer) == null ? void 0 : g.FooterText,
        link: (p = (m = this.styleConfig) == null ? void 0 : m.Footer) == null ? void 0 : p.FooterLink
      }
    };
  }
  getOrDividerStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      line: {
        backgroundColor: ((o = (i = this.styleConfig) == null ? void 0 : i.Description) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.secondaryColor) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor)
      }
    };
  }
  getORTextStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  // Update methods
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    this.styleConfig = { ...this.styleConfig, ...e };
  }
  updateQuestTheme(e) {
    this.questThemeData = { ...this.questThemeData, ...e };
  }
  updateBrandTheme(e) {
    this.brandTheme = { ...this.brandTheme, ...e };
  }
}
const lFe = ({
  googleClientId: t,
  redirectUri: e,
  redirectURL: r,
  email: n = !1,
  google: A = !1,
  onSubmit: i,
  styleConfig: o,
  IconColor: s,
  headingText: a,
  descriptionText: c,
  googleButtonText: l,
  showFooter: u = !0,
  campaignId: f,
  campaignToken: d,
  campaignUserId: g,
  variations: m,
  onError: p,
  BrandTheme: v,
  accent: C,
  QuestThemeData: w
}) => {
  const [B, y] = N(!1), [b, q] = N(!1), [E, x] = N(!1), [M, O] = N(
    v || Hs
  ), [I, S] = N(!0), [P, H] = N(
    w && {
      ...w,
      accentColor: w.accentColor ? w.accentColor : C
    } || Ms
  ), { apiKey: F, apiSecret: T, entityId: U, apiType: D, themeConfig: Q } = Xe(
    ct.Context
  ), Y = new Xg(D), j = MA(
    () => new Rte(
      Q,
      o,
      P,
      M,
      C
    ),
    [Q, o, P, M]
  );
  le(() => {
    v && O(v), w && H(w);
  }, [v, w]), le(() => {
    Y.trackEvent("quest_Login_loaded", "quest_login"), y(n), q(A), !A && !n && (q(!0), y(!0));
  }, [U, n, A]), le(() => {
    (async () => {
      var L;
      if (!f || !d || !g || !F) {
        C && (H({
          ...P,
          accentColor: P.accentColor ? P.accentColor : C
        }), j.updateQuestTheme({
          ...P,
          accentColor: P.accentColor ? P.accentColor : C
        })), S(!1);
        return;
      }
      const R = {
        apiKey: F,
        token: d,
        userId: g
      }, K = await Y.getLoginCampaignResults(
        U,
        f,
        R,
        m
      );
      (L = K == null ? void 0 : K.brandTheme) != null && L.properties && (O(K.brandTheme.properties), j.updateBrandTheme(K.brandTheme.properties)), K != null && K.questThemeData && (H({
        ...K.questThemeData,
        accentColor: K.questThemeData.accentColor ? K.questThemeData.accentColor : C
      }), j.updateQuestTheme({
        ...K.questThemeData,
        accentColor: K.questThemeData.accentColor ? K.questThemeData.accentColor : C
      })), S(!1);
    })();
  }, [f, d]);
  const Z = (W) => {
    x(W);
  };
  return I ? null : /* @__PURE__ */ k(
    "div",
    {
      className: "q-login-container",
      style: j.getContainerStyles(),
      children: [
        /* @__PURE__ */ k("div", { className: "q-login-body", children: [
          !E && /* @__PURE__ */ k("div", { className: "q-login-header", children: [
            /* @__PURE__ */ h("div", { className: "q-login-h1", style: j.getHeadingStyles(), children: a || "Log in or sign up" }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-login-h4",
                style: j.getDescriptionStyles(),
                children: c || "Welcome Back, Please enter your details"
              }
            )
          ] }),
          B && /* @__PURE__ */ k("div", { className: "q-login-mid-cont", children: [
            /* @__PURE__ */ h(
              Pte,
              {
                apiKey: F,
                apiSecret: T || "",
                redirectURL: r,
                entityId: U,
                handleOtp: Z,
                redirectUri: e,
                onSubmit: i,
                otpScreen: E,
                setOtpScreen: x,
                styleConfig: o,
                IconColor: s,
                onError: p,
                themeManager: j
              }
            ),
            !E && b && /* @__PURE__ */ k(Ze, { children: [
              /* @__PURE__ */ k(
                "div",
                {
                  className: "q-login-or-container",
                  style: j.getOrDividerStyles(),
                  children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "login-or-line",
                        style: j.getOrDividerStyles().line
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-or-continue",
                        style: j.getORTextStyles(),
                        children: "OR"
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "login-or-line",
                        style: j.getOrDividerStyles().line
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ h(
                mb,
                {
                  entityId: U,
                  redirectUri: e,
                  redirectURL: r,
                  googleClientId: t,
                  apiSecret: T || "",
                  apiKey: F,
                  onSubmit: i,
                  googleButtonText: l,
                  onError: p,
                  themeManager: j
                }
              )
            ] })
          ] }),
          !B && b && /* @__PURE__ */ h(
            mb,
            {
              entityId: U,
              redirectUri: e,
              redirectURL: r,
              googleClientId: t,
              apiSecret: T || "",
              apiKey: F,
              onSubmit: i,
              googleButtonText: l,
              onError: p,
              themeManager: j
            }
          )
        ] }),
        /* @__PURE__ */ h("div", { className: "quest_footer", children: u && /* @__PURE__ */ h(
          Pr,
          {
            style: j.getFooterStyles().container,
            textStyle: j.getFooterStyles().text,
            iconStyle: j.getFooterStyles().icon,
            text: j.getFooterStyles().content.text,
            link: j.getFooterStyles().content.link
          }
        ) })
      ]
    }
  );
}, Iv = UA({}), Gs = () => Xe(Iv), $g = ({}) => {
  var A, i, o, s, a, c;
  const {
    formdata: t,
    currentPage: e = 0,
    themeManager: r,
    onboardingGetPropsFunctions: n
  } = Gs();
  return /* @__PURE__ */ h(Ze, { children: t.length > 0 && !!n.getHeaders() && // ((Array.isArray(headersArray) && !!headersArray) ? (
  (Array.isArray(n.getHeaders()) && n.getHeaders() ? /* @__PURE__ */ k(
    "div",
    {
      className: "q-onb-main-heading",
      style: r.getTopBarStyles().topbarStyle,
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-main-h3",
            style: r.getTopBarStyles().headingStyle,
            children: Array.isArray(n.getHeaders()) && ((A = n.getHeaders()[e]) == null ? void 0 : A.heading)
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-main-h4",
            style: r.getTopBarStyles().subHeadingStyle,
            children: (i = n.getHeaders()[e]) == null ? void 0 : i.subHeading
          }
        )
      ]
    }
  ) : Array.isArray(n.getHeaders()) && n.getHeaders()[e] ? /* @__PURE__ */ k(
    "div",
    {
      className: "q-onb-main-heading",
      style: r.getTopBarStyles().topbarStyle,
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-main-h3",
            style: r.getTopBarStyles().headingStyle,
            children: (o = n.getHeaders()[e]) == null ? void 0 : o.heading
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-main-h4",
            style: r.getTopBarStyles().subHeadingStyle,
            children: (s = n.getHeaders()[e]) == null ? void 0 : s.subHeading
          }
        )
      ]
    }
  ) : /* @__PURE__ */ k(
    "div",
    {
      className: "q-onb-main-heading",
      style: r.getTopBarStyles().topbarStyle,
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-main-h3",
            style: r.getTopBarStyles().headingStyle,
            children: Array.isArray(n.getHeaders()) && ((a = n.getHeaders()[e]) == null ? void 0 : a.heading)
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-main-h4",
            style: r.getTopBarStyles().subHeadingStyle,
            children: Array.isArray(n.getHeaders()) && ((c = n.getHeaders()[e]) == null ? void 0 : c.subHeading)
          }
        )
      ]
    }
  )) });
}, Kt = ({
  htmlFor: t,
  style: e,
  children: r,
  className: n,
  id: A
}) => /* @__PURE__ */ h(
  "label",
  {
    htmlFor: t,
    style: { ...e },
    className: `q_modular_label ${n || ""}`,
    id: A,
    children: r
  }
), Hi = ({
  placeholder: t,
  type: e = "text",
  onChange: r,
  onKeyUp: n,
  onKeyDown: A,
  iconColor: i,
  value: o,
  ref: s,
  logoPosition: a = "right",
  textErrorStyle: c,
  errorText: l,
  required: u,
  regexKey: f = "",
  regexMessage: d = "",
  name: g,
  key: m,
  style: p,
  validateInputRegex: v = () => {
  }
}) => {
  const { themeManager: C } = Gs(), [w, B] = N(!0), y = /^.+$/, q = f && ((O) => {
    try {
      return new RegExp(O || ""), !0;
    } catch {
      return !1;
    }
  })(f) ? new RegExp(f) : y, E = (O) => {
    O ? (console.log(O), B(q.test(O)), v(q.test(O))) : (B(!0), v(!0));
  };
  return console.log("hello"), /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ h("div", { className: "q_input_cont", style: p, children: /* @__PURE__ */ h(
      "input",
      {
        type: "text",
        name: g,
        placeholder: t,
        className: "q_input_main_cont",
        onChange: (O) => {
          const I = O.target.value;
          f && E(I), r && r(O);
        },
        onKeyUp: n,
        onKeyDown: A,
        defaultValue: o,
        ref: s,
        onBlur: (O) => {
          const I = O.target.value;
          f && E(I);
        },
        onWheel: (O) => {
          O.currentTarget.blur();
        },
        style: {
          fontFamily: (C == null ? void 0 : C.getFontFamily()) || "'Figtree', sans-serif",
          color: p == null ? void 0 : p.color
        },
        required: u,
        pattern: f ? q.source : void 0
      },
      m
    ) }),
    !!f && !w && /* @__PURE__ */ h("span", { style: c, className: "q-input-error-message", children: d || l })
  ] });
}, vb = {
  email: S1,
  phone: La,
  text: () => /* @__PURE__ */ h(Ze, {}),
  number: La,
  date: Jg
}, Fu = ({
  placeholder: t,
  // type = "email",
  onChange: e,
  iconColor: r,
  value: n,
  onKeyUp: A,
  onKeyDown: i,
  ref: o,
  logoPosition: s = "right",
  emailErrorStyle: a,
  emailtext: c,
  required: l,
  regexKey: u,
  regexMessage: f,
  name: d,
  preventFutureSelection: g,
  preventPastSelection: m,
  key: p,
  style: v,
  validateInputRegex: C = () => {
  }
}) => {
  const { themeManager: w } = Gs(), [B, y] = N(!0), q = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, x = u && ((S) => {
    try {
      return new RegExp(S || ""), !0;
    } catch {
      return !1;
    }
  })(u) ? new RegExp(u) : q, M = (S) => {
    S ? (y(x.test(S)), C(x.test(S))) : (y(!0), C(!0));
  }, O = (S) => {
    const P = S.target.value;
    M(P), e && e(S);
  }, I = (S) => {
    const P = S.target.value;
    u && M(P);
  };
  return /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ k("div", { className: "q_input_cont", style: v, children: [
      (s == "left" || s == "both") && // LogoType[type](iconColor || "#B9B9B9")}
      vb.email(r || "#B9B9B9"),
      /* @__PURE__ */ h(
        "input",
        {
          type: "email",
          name: d,
          placeholder: t,
          className: "q_input_main_cont",
          onChange: O,
          onKeyUp: A,
          onKeyDown: i,
          defaultValue: n,
          ref: o,
          onBlur: I,
          onWheel: (S) => {
            S.currentTarget.blur();
          },
          style: {
            fontFamily: (w == null ? void 0 : w.getFontFamily()) || "'Figtree', sans-serif",
            color: v == null ? void 0 : v.color
          },
          required: l,
          pattern: u ? x.source : void 0
        },
        p
      ),
      (s == "right" || s == "both") && // LogoType[type](iconColor || "#B9B9B9")}
      vb.email(r || "#B9B9B9")
    ] }),
    !B && /* @__PURE__ */ h("span", { style: a, className: "q-input-error-message", children: f || c })
  ] });
}, qb = {
  email: S1,
  phone: La,
  text: () => /* @__PURE__ */ h(Ze, {}),
  number: La,
  date: Jg
}, Tu = ({
  placeholder: t,
  style: e,
  onChange: r,
  iconColor: n,
  value: A,
  onKeyUp: i,
  onKeyDown: o,
  ref: s,
  logoPosition: a = "right",
  numberErrorStyle: c,
  numbertext: l,
  required: u,
  regexKey: f = "",
  regexMessage: d,
  name: g,
  preventFutureSelection: m,
  preventPastSelection: p,
  key: v,
  validateInputRegex: C = () => {
  }
}) => {
  const { themeManager: w } = Gs(), B = /^.+$/, [y, b] = N(!0), E = f && ((I) => {
    try {
      return new RegExp(I || ""), !0;
    } catch {
      return !1;
    }
  })(f) ? new RegExp(f) : B, x = (I) => {
    I ? (b(E.test(I)), C(E.test(I))) : (b(!0), C(!0));
  }, M = (I) => {
    const S = I.target.value;
    f && x(S), r && r(I);
  }, O = (I) => {
    const S = I.target.value;
    f && x(S);
  };
  return /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ k("div", { className: "q_input_cont", style: e, children: [
      (a == "left" || a == "both") && qb.number(n || "#B9B9B9"),
      /* @__PURE__ */ h(
        "input",
        {
          type: "number",
          name: g,
          placeholder: t,
          className: "q_input_main_cont",
          onChange: M,
          onKeyUp: i,
          onKeyDown: o,
          defaultValue: A,
          ref: s,
          onBlur: O,
          onWheel: (I) => {
            I.currentTarget.blur();
          },
          style: {
            fontFamily: (w == null ? void 0 : w.getFontFamily()) || "'Figtree', sans-serif",
            color: e == null ? void 0 : e.color
          },
          required: u,
          pattern: f ? E.source : void 0
        },
        v
      ),
      (a == "right" || a == "both") && qb.number(n || "#B9B9B9")
    ] }),
    !!f && !y && /* @__PURE__ */ h("span", { style: c, className: "q-input-error-message", children: d || l })
  ] });
}, Mu = ({
  value: t,
  onChange: e,
  style: r,
  placeholder: n,
  regexKey: A,
  regexMessage: i,
  textareaErrorStyle: o,
  textareatext: s,
  maxLength: a,
  required: c,
  key: l,
  validateInputRegex: u = () => {
  }
}) => {
  const { themeManager: f } = Gs(), d = /^.+$/, [g, m] = N(!0), v = A && ((y) => {
    try {
      return new RegExp(y || ""), !0;
    } catch {
      return !1;
    }
  })(A) ? new RegExp(A) : d, C = (y) => {
    y ? (m(v.test(y)), u(v.test(y))) : (m(!0), u(!0));
  }, w = (y) => {
    const b = y.target.value;
    A && C(b), e && e(y);
  }, B = (y) => {
    const b = y.target.value;
    A && C(b);
  };
  return /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ h(
      "textarea",
      {
        className: "q_input_textArea",
        value: t,
        onChange: w,
        style: {
          ...r,
          fontFamily: (f == null ? void 0 : f.getFontFamily()) || "'Figtree', sans-serif"
        },
        placeholder: n,
        maxLength: a,
        required: c,
        onBlur: B
      },
      l
    ),
    !!A && !g && /* @__PURE__ */ h("span", { style: o, className: "q-input-error-message", children: i || s })
  ] });
}, zte = {
  email: S1,
  phone: La,
  text: () => /* @__PURE__ */ h(Ze, {}),
  number: La,
  date: Jg
}, Hu = ({
  placeholder: t,
  type: e,
  onChange: r,
  iconColor: n,
  value: A,
  onKeyUp: i,
  onKeyDown: o,
  ref: s,
  logoPosition: a = "right",
  dateErrorStyle: c,
  datetext: l,
  required: u,
  regexKey: f,
  regexMessage: d,
  name: g,
  preventFutureSelection: m,
  preventPastSelection: p,
  key: v,
  style: C,
  minDate: w = "",
  maxDate: B = ""
}) => {
  Xe(ct.Context);
  const y = gt(null), b = (x) => {
    const M = x.split("-");
    return `${M[2]}-${M[1]}-${M[0]}`;
  };
  let q, E;
  if (w || p) {
    let x = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
    q = w ? b(w) : x;
  }
  if (B || m) {
    let x = new Date((/* @__PURE__ */ new Date()).setDate((/* @__PURE__ */ new Date()).getDate())).toISOString().split("T")[0];
    E = B ? b(B) : x;
  }
  return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k(
    "div",
    {
      className: "q_input_cont",
      onClick: () => {
        var x;
        return (x = y.current) == null ? void 0 : x.showPicker();
      },
      style: {
        ...C
      },
      children: [
        /* @__PURE__ */ k(
          "label",
          {
            htmlFor: "dateInput",
            className: "q_input_custom_datePicker_label",
            children: [
              /* @__PURE__ */ h(
                "input",
                {
                  type: "date",
                  name: "dateInput",
                  placeholder: t,
                  className: "q_input_main_cont q_input_custom_datePicker",
                  onChange: r,
                  value: A,
                  required: u,
                  ref: y,
                  min: q || void 0,
                  max: E || void 0
                },
                v
              ),
              A ? /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    display: "inline",
                    marginTop: "2px",
                    color: C == null ? void 0 : C.color,
                    fontSize: C == null ? void 0 : C.fontSize
                  },
                  children: A
                }
              ) : /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    display: "inline",
                    color: "#8E8E8E",
                    marginTop: "2px",
                    fontSize: C == null ? void 0 : C.fontSize
                  },
                  children: t
                }
              )
            ]
          }
        ),
        zte.date(n || "#B9B9B9")
      ]
    }
  ) });
}, u3 = ({
  options: t,
  checked: e,
  onChange: r,
  style: n,
  selectedStyle: A = { accentColor: "#6525B3" },
  type: i,
  hoverBackground: o,
  key: s
}) => {
  console.log("checked-SingleChoiceModal1", e), Xe(ct.Context);
  const a = {
    ...n,
    flexDirection: i === "modal2" ? "column" : "row",
    gap: i === "modal2" ? "12px" : "8px"
  };
  return /* @__PURE__ */ h("div", { className: "q-singlechoice-input-cont", style: a, children: t.map((c, l) => {
    const u = {
      border: e === c ? `1px solid ${(A == null ? void 0 : A.borderColor) || (A == null ? void 0 : A.accentColor) || "#6525B3"}` : `1px solid ${(n == null ? void 0 : n.borderColor) || "#EFEFEF"}`,
      width: i === "modal2" ? "100%" : "fit-content",
      padding: i === "modal2" ? "10px 16px" : "8px 16px",
      gap: i === "modal2" ? "8px" : "4px",
      cursor: "pointer"
      // Add a pointer cursor for better UX
    };
    return /* @__PURE__ */ k(
      "div",
      {
        className: "q_singlehoice_label_cont",
        style: u,
        onClick: () => {
          var d;
          const f = new MouseEvent("click", { bubbles: !0 });
          (d = document.getElementById(c)) == null || d.dispatchEvent(f);
        },
        children: [
          /* @__PURE__ */ h(
            "input",
            {
              type: "radio",
              value: c,
              checked: e === c,
              onChange: r,
              className: "q-singlechoice-input",
              style: { accentColor: (A == null ? void 0 : A.accentColor) || "#6525B3" },
              id: c
            }
          ),
          /* @__PURE__ */ h(
            "label",
            {
              style: {
                color: e === c ? (A == null ? void 0 : A.color) || (A == null ? void 0 : A.accentColor) || "#6525B3" : (n == null ? void 0 : n.color) || "#939393"
              },
              htmlFor: c,
              children: c
            }
          )
        ]
      },
      l
    );
  }) }, s);
};
function Jc(t) {
  "@babel/helpers - typeof";
  return Jc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jc(t);
}
function Yte(t, e) {
  if (Jc(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Jc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function IT(t) {
  var e = Yte(t, "string");
  return Jc(e) == "symbol" ? e : e + "";
}
function k0(t, e, r) {
  return (e = IT(e)) in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function yb(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yb(Object(r), !0).forEach(function(n) {
      k0(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : yb(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Vte(t) {
  if (Array.isArray(t)) return t;
}
function Wte(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        a = !1;
      } else for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function X5(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function ST(t, e) {
  if (t) {
    if (typeof t == "string") return X5(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? X5(t, e) : void 0;
  }
}
function Xte() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ws(t, e) {
  return Vte(t) || Wte(t, e) || ST(t, e) || Xte();
}
function Kte(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
    if (e.indexOf(n) !== -1) continue;
    r[n] = t[n];
  }
  return r;
}
function Rs(t, e) {
  if (t == null) return {};
  var r, n, A = Kte(t, e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (n = 0; n < i.length; n++) r = i[n], e.indexOf(r) === -1 && {}.propertyIsEnumerable.call(t, r) && (A[r] = t[r]);
  }
  return A;
}
var Zte = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Jte(t) {
  var e = t.defaultInputValue, r = e === void 0 ? "" : e, n = t.defaultMenuIsOpen, A = n === void 0 ? !1 : n, i = t.defaultValue, o = i === void 0 ? null : i, s = t.inputValue, a = t.menuIsOpen, c = t.onChange, l = t.onInputChange, u = t.onMenuClose, f = t.onMenuOpen, d = t.value, g = Rs(t, Zte), m = N(s !== void 0 ? s : r), p = ws(m, 2), v = p[0], C = p[1], w = N(a !== void 0 ? a : A), B = ws(w, 2), y = B[0], b = B[1], q = N(d !== void 0 ? d : o), E = ws(q, 2), x = E[0], M = E[1], O = Kn(function(U, D) {
    typeof c == "function" && c(U, D), M(U);
  }, [c]), I = Kn(function(U, D) {
    var Q;
    typeof l == "function" && (Q = l(U, D)), C(Q !== void 0 ? Q : U);
  }, [l]), S = Kn(function() {
    typeof f == "function" && f(), b(!0);
  }, [f]), P = Kn(function() {
    typeof u == "function" && u(), b(!1);
  }, [u]), H = s !== void 0 ? s : v, F = a !== void 0 ? a : y, T = d !== void 0 ? d : x;
  return Nt(Nt({}, g), {}, {
    inputValue: H,
    menuIsOpen: F,
    onChange: O,
    onInputChange: I,
    onMenuClose: P,
    onMenuOpen: S,
    value: T
  });
}
function Gt() {
  return Gt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Gt.apply(null, arguments);
}
function _te(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Cb(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, IT(n.key), n);
  }
}
function $te(t, e, r) {
  return Cb(t.prototype, e), Cb(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function K5(t, e) {
  return K5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, K5(t, e);
}
function ere(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && K5(t, e);
}
function d3(t) {
  return d3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, d3(t);
}
function PT() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PT = function() {
    return !!t;
  })();
}
function tre(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function rre(t, e) {
  if (e && (Jc(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return tre(t);
}
function nre(t) {
  var e = PT();
  return function() {
    var r, n = d3(t);
    if (e) {
      var A = d3(this).constructor;
      r = Reflect.construct(n, arguments, A);
    } else r = n.apply(this, arguments);
    return rre(this, r);
  };
}
function Are(t) {
  if (Array.isArray(t)) return X5(t);
}
function ire(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function ore() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sv(t) {
  return Are(t) || ire(t) || ST(t) || ore();
}
function sre(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function are(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var cre = /* @__PURE__ */ function() {
  function t(r) {
    var n = this;
    this._insertTag = function(A) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(A, i), n.tags.push(A);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, e.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(are(this));
    var A = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = sre(A);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch {
      }
    } else
      A.appendChild(document.createTextNode(n));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(n) {
      var A;
      return (A = n.parentNode) == null ? void 0 : A.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), EA = "-ms-", f3 = "-moz-", Fr = "-webkit-", kT = "comm", Pv = "rule", kv = "decl", lre = "@import", OT = "@keyframes", ure = "@layer", dre = Math.abs, e4 = String.fromCharCode, fre = Object.assign;
function hre(t, e) {
  return vA(t, 0) ^ 45 ? (((e << 2 ^ vA(t, 0)) << 2 ^ vA(t, 1)) << 2 ^ vA(t, 2)) << 2 ^ vA(t, 3) : 0;
}
function FT(t) {
  return t.trim();
}
function pre(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function Tr(t, e, r) {
  return t.replace(e, r);
}
function Z5(t, e) {
  return t.indexOf(e);
}
function vA(t, e) {
  return t.charCodeAt(e) | 0;
}
function b2(t, e, r) {
  return t.slice(e, r);
}
function Ho(t) {
  return t.length;
}
function Ov(t) {
  return t.length;
}
function pf(t, e) {
  return e.push(t), t;
}
function gre(t, e) {
  return t.map(e).join("");
}
var t4 = 1, Du = 1, TT = 0, ci = 0, Ln = 0, kd = "";
function r4(t, e, r, n, A, i, o) {
  return { value: t, root: e, parent: r, type: n, props: A, children: i, line: t4, column: Du, length: o, return: "" };
}
function d0(t, e) {
  return fre(r4("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function mre() {
  return Ln;
}
function vre() {
  return Ln = ci > 0 ? vA(kd, --ci) : 0, Du--, Ln === 10 && (Du = 1, t4--), Ln;
}
function wi() {
  return Ln = ci < TT ? vA(kd, ci++) : 0, Du++, Ln === 10 && (Du = 1, t4++), Ln;
}
function zo() {
  return vA(kd, ci);
}
function Ch() {
  return ci;
}
function P1(t, e) {
  return b2(kd, t, e);
}
function B2(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function MT(t) {
  return t4 = Du = 1, TT = Ho(kd = t), ci = 0, [];
}
function HT(t) {
  return kd = "", t;
}
function wh(t) {
  return FT(P1(ci - 1, J5(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function qre(t) {
  for (; (Ln = zo()) && Ln < 33; )
    wi();
  return B2(t) > 2 || B2(Ln) > 3 ? "" : " ";
}
function yre(t, e) {
  for (; --e && wi() && !(Ln < 48 || Ln > 102 || Ln > 57 && Ln < 65 || Ln > 70 && Ln < 97); )
    ;
  return P1(t, Ch() + (e < 6 && zo() == 32 && wi() == 32));
}
function J5(t) {
  for (; wi(); )
    switch (Ln) {
      case t:
        return ci;
      case 34:
      case 39:
        t !== 34 && t !== 39 && J5(Ln);
        break;
      case 40:
        t === 41 && J5(t);
        break;
      case 92:
        wi();
        break;
    }
  return ci;
}
function Cre(t, e) {
  for (; wi() && t + Ln !== 57; )
    if (t + Ln === 84 && zo() === 47)
      break;
  return "/*" + P1(e, ci - 1) + "*" + e4(t === 47 ? t : wi());
}
function wre(t) {
  for (; !B2(zo()); )
    wi();
  return P1(t, ci);
}
function bre(t) {
  return HT(bh("", null, null, null, [""], t = MT(t), 0, [0], t));
}
function bh(t, e, r, n, A, i, o, s, a) {
  for (var c = 0, l = 0, u = o, f = 0, d = 0, g = 0, m = 1, p = 1, v = 1, C = 0, w = "", B = A, y = i, b = n, q = w; p; )
    switch (g = C, C = wi()) {
      case 40:
        if (g != 108 && vA(q, u - 1) == 58) {
          Z5(q += Tr(wh(C), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        q += wh(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        q += qre(g);
        break;
      case 92:
        q += yre(Ch() - 1, 7);
        continue;
      case 47:
        switch (zo()) {
          case 42:
          case 47:
            pf(Bre(Cre(wi(), Ch()), e, r), a);
            break;
          default:
            q += "/";
        }
        break;
      case 123 * m:
        s[c++] = Ho(q) * v;
      case 125 * m:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            p = 0;
          case 59 + l:
            v == -1 && (q = Tr(q, /\f/g, "")), d > 0 && Ho(q) - u && pf(d > 32 ? bb(q + ";", n, r, u - 1) : bb(Tr(q, " ", "") + ";", n, r, u - 2), a);
            break;
          case 59:
            q += ";";
          default:
            if (pf(b = wb(q, e, r, c, l, A, s, w, B = [], y = [], u), i), C === 123)
              if (l === 0)
                bh(q, e, b, b, B, i, u, s, y);
              else
                switch (f === 99 && vA(q, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    bh(t, b, b, n && pf(wb(t, b, b, 0, 0, A, s, w, A, B = [], u), y), A, y, u, s, n ? B : y);
                    break;
                  default:
                    bh(q, b, b, b, [""], y, 0, s, y);
                }
        }
        c = l = d = 0, m = v = 1, w = q = "", u = o;
        break;
      case 58:
        u = 1 + Ho(q), d = g;
      default:
        if (m < 1) {
          if (C == 123)
            --m;
          else if (C == 125 && m++ == 0 && vre() == 125)
            continue;
        }
        switch (q += e4(C), C * m) {
          case 38:
            v = l > 0 ? 1 : (q += "\f", -1);
            break;
          case 44:
            s[c++] = (Ho(q) - 1) * v, v = 1;
            break;
          case 64:
            zo() === 45 && (q += wh(wi())), f = zo(), l = u = Ho(w = q += wre(Ch())), C++;
            break;
          case 45:
            g === 45 && Ho(q) == 2 && (m = 0);
        }
    }
  return i;
}
function wb(t, e, r, n, A, i, o, s, a, c, l) {
  for (var u = A - 1, f = A === 0 ? i : [""], d = Ov(f), g = 0, m = 0, p = 0; g < n; ++g)
    for (var v = 0, C = b2(t, u + 1, u = dre(m = o[g])), w = t; v < d; ++v)
      (w = FT(m > 0 ? f[v] + " " + C : Tr(C, /&\f/g, f[v]))) && (a[p++] = w);
  return r4(t, e, r, A === 0 ? Pv : s, a, c, l);
}
function Bre(t, e, r) {
  return r4(t, e, r, kT, e4(mre()), b2(t, 2, -2), 0);
}
function bb(t, e, r, n) {
  return r4(t, e, r, kv, b2(t, 0, n), b2(t, n + 1, -1), n);
}
function iu(t, e) {
  for (var r = "", n = Ov(t), A = 0; A < n; A++)
    r += e(t[A], A, t, e) || "";
  return r;
}
function Ere(t, e, r, n) {
  switch (t.type) {
    case ure:
      if (t.children.length) break;
    case lre:
    case kv:
      return t.return = t.return || t.value;
    case kT:
      return "";
    case OT:
      return t.return = t.value + "{" + iu(t.children, n) + "}";
    case Pv:
      t.value = t.props.join(",");
  }
  return Ho(r = iu(t.children, n)) ? t.return = t.value + "{" + r + "}" : "";
}
function xre(t) {
  var e = Ov(t);
  return function(r, n, A, i) {
    for (var o = "", s = 0; s < e; s++)
      o += t[s](r, n, A, i) || "";
    return o;
  };
}
function Ire(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function Sre(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var Pre = function(e, r, n) {
  for (var A = 0, i = 0; A = i, i = zo(), A === 38 && i === 12 && (r[n] = 1), !B2(i); )
    wi();
  return P1(e, ci);
}, kre = function(e, r) {
  var n = -1, A = 44;
  do
    switch (B2(A)) {
      case 0:
        A === 38 && zo() === 12 && (r[n] = 1), e[n] += Pre(ci - 1, r, n);
        break;
      case 2:
        e[n] += wh(A);
        break;
      case 4:
        if (A === 44) {
          e[++n] = zo() === 58 ? "&\f" : "", r[n] = e[n].length;
          break;
        }
      default:
        e[n] += e4(A);
    }
  while (A = wi());
  return e;
}, Ore = function(e, r) {
  return HT(kre(MT(e), r));
}, Bb = /* @__PURE__ */ new WeakMap(), Fre = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var r = e.value, n = e.parent, A = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(e.props.length === 1 && r.charCodeAt(0) !== 58 && !Bb.get(n)) && !A) {
      Bb.set(e, !0);
      for (var i = [], o = Ore(r, i), s = n.props, a = 0, c = 0; a < o.length; a++)
        for (var l = 0; l < s.length; l++, c++)
          e.props[c] = i[a] ? o[a].replace(/&\f/g, s[l]) : s[l] + " " + o[a];
    }
  }
}, Tre = function(e) {
  if (e.type === "decl") {
    var r = e.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function DT(t, e) {
  switch (hre(t, e)) {
    case 5103:
      return Fr + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Fr + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Fr + t + f3 + t + EA + t + t;
    case 6828:
    case 4268:
      return Fr + t + EA + t + t;
    case 6165:
      return Fr + t + EA + "flex-" + t + t;
    case 5187:
      return Fr + t + Tr(t, /(\w+).+(:[^]+)/, Fr + "box-$1$2" + EA + "flex-$1$2") + t;
    case 5443:
      return Fr + t + EA + "flex-item-" + Tr(t, /flex-|-self/, "") + t;
    case 4675:
      return Fr + t + EA + "flex-line-pack" + Tr(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return Fr + t + EA + Tr(t, "shrink", "negative") + t;
    case 5292:
      return Fr + t + EA + Tr(t, "basis", "preferred-size") + t;
    case 6060:
      return Fr + "box-" + Tr(t, "-grow", "") + Fr + t + EA + Tr(t, "grow", "positive") + t;
    case 4554:
      return Fr + Tr(t, /([^-])(transform)/g, "$1" + Fr + "$2") + t;
    case 6187:
      return Tr(Tr(Tr(t, /(zoom-|grab)/, Fr + "$1"), /(image-set)/, Fr + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return Tr(t, /(image-set\([^]*)/, Fr + "$1$`$1");
    case 4968:
      return Tr(Tr(t, /(.+:)(flex-)?(.*)/, Fr + "box-pack:$3" + EA + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Fr + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Tr(t, /(.+)-inline(.+)/, Fr + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ho(t) - 1 - e > 6) switch (vA(t, e + 1)) {
        case 109:
          if (vA(t, e + 4) !== 45) break;
        case 102:
          return Tr(t, /(.+:)(.+)-([^]+)/, "$1" + Fr + "$2-$3$1" + f3 + (vA(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
        case 115:
          return ~Z5(t, "stretch") ? DT(Tr(t, "stretch", "fill-available"), e) + t : t;
      }
      break;
    case 4949:
      if (vA(t, e + 1) !== 115) break;
    case 6444:
      switch (vA(t, Ho(t) - 3 - (~Z5(t, "!important") && 10))) {
        case 107:
          return Tr(t, ":", ":" + Fr) + t;
        case 101:
          return Tr(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Fr + (vA(t, 14) === 45 ? "inline-" : "") + "box$3$1" + Fr + "$2$3$1" + EA + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (vA(t, e + 11)) {
        case 114:
          return Fr + t + EA + Tr(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return Fr + t + EA + Tr(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return Fr + t + EA + Tr(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return Fr + t + EA + t + t;
  }
  return t;
}
var Mre = function(e, r, n, A) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case kv:
      e.return = DT(e.value, e.length);
      break;
    case OT:
      return iu([d0(e, {
        value: Tr(e.value, "@", "@" + Fr)
      })], A);
    case Pv:
      if (e.length) return gre(e.props, function(i) {
        switch (pre(i, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return iu([d0(e, {
              props: [Tr(i, /:(read-\w+)/, ":" + f3 + "$1")]
            })], A);
          case "::placeholder":
            return iu([d0(e, {
              props: [Tr(i, /:(plac\w+)/, ":" + Fr + "input-$1")]
            }), d0(e, {
              props: [Tr(i, /:(plac\w+)/, ":" + f3 + "$1")]
            }), d0(e, {
              props: [Tr(i, /:(plac\w+)/, EA + "input-$1")]
            })], A);
        }
        return "";
      });
  }
}, Hre = [Mre], Dre = function(e) {
  var r = e.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(m) {
      var p = m.getAttribute("data-emotion");
      p.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var A = e.stylisPlugins || Hre, i = {}, o, s = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(m) {
      for (var p = m.getAttribute("data-emotion").split(" "), v = 1; v < p.length; v++)
        i[p[v]] = !0;
      s.push(m);
    }
  );
  var a, c = [Fre, Tre];
  {
    var l, u = [Ere, Ire(function(m) {
      l.insert(m);
    })], f = xre(c.concat(A, u)), d = function(p) {
      return iu(bre(p), f);
    };
    a = function(p, v, C, w) {
      l = C, d(p ? p + "{" + v.styles + "}" : v.styles), w && (g.inserted[v.name] = !0);
    };
  }
  var g = {
    key: r,
    sheet: new cre({
      key: r,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: i,
    registered: {},
    insert: a
  };
  return g.sheet.hydrate(s), g;
}, Qre = !0;
function Ure(t, e, r) {
  var n = "";
  return r.split(" ").forEach(function(A) {
    t[A] !== void 0 ? e.push(t[A] + ";") : A && (n += A + " ");
  }), n;
}
var QT = function(e, r, n) {
  var A = e.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Qre === !1) && e.registered[A] === void 0 && (e.registered[A] = r.styles);
}, Nre = function(e, r, n) {
  QT(e, r, n);
  var A = e.key + "-" + r.name;
  if (e.inserted[r.name] === void 0) {
    var i = r;
    do
      e.insert(r === i ? "." + A : "", i, e.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function jre(t) {
  for (var e = 0, r, n = 0, A = t.length; A >= 4; ++n, A -= 4)
    r = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, e = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (A) {
    case 3:
      e ^= (t.charCodeAt(n + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(n + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(n) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Lre = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Gre = /[A-Z]|^ms/g, Rre = /_EMO_([^_]+?)_([^]*?)_EMO_/g, UT = function(e) {
  return e.charCodeAt(1) === 45;
}, Eb = function(e) {
  return e != null && typeof e != "boolean";
}, R9 = /* @__PURE__ */ Sre(function(t) {
  return UT(t) ? t : t.replace(Gre, "-$&").toLowerCase();
}), xb = function(e, r) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(Rre, function(n, A, i) {
          return Do = {
            name: A,
            styles: i,
            next: Do
          }, A;
        });
  }
  return Lre[e] !== 1 && !UT(e) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function E2(t, e, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var A = r;
      if (A.anim === 1)
        return Do = {
          name: A.name,
          styles: A.styles,
          next: Do
        }, A.name;
      var i = r;
      if (i.styles !== void 0) {
        var o = i.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Do = {
              name: o.name,
              styles: o.styles,
              next: Do
            }, o = o.next;
        var s = i.styles + ";";
        return s;
      }
      return zre(t, e, r);
    }
    case "function": {
      if (t !== void 0) {
        var a = Do, c = r(t);
        return Do = a, E2(t, e, c);
      }
      break;
    }
  }
  var l = r;
  return l;
}
function zre(t, e, r) {
  var n = "";
  if (Array.isArray(r))
    for (var A = 0; A < r.length; A++)
      n += E2(t, e, r[A]) + ";";
  else
    for (var i in r) {
      var o = r[i];
      if (typeof o != "object") {
        var s = o;
        Eb(s) && (n += R9(i) + ":" + xb(i, s) + ";");
      } else if (Array.isArray(o) && typeof o[0] == "string" && e == null)
        for (var a = 0; a < o.length; a++)
          Eb(o[a]) && (n += R9(i) + ":" + xb(i, o[a]) + ";");
      else {
        var c = E2(t, e, o);
        switch (i) {
          case "animation":
          case "animationName": {
            n += R9(i) + ":" + c + ";";
            break;
          }
          default:
            n += i + "{" + c + "}";
        }
      }
    }
  return n;
}
var Ib = /label:\s*([^\s;{]+)\s*(;|$)/g, Do;
function NT(t, e, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var n = !0, A = "";
  Do = void 0;
  var i = t[0];
  if (i == null || i.raw === void 0)
    n = !1, A += E2(r, e, i);
  else {
    var o = i;
    A += o[0];
  }
  for (var s = 1; s < t.length; s++)
    if (A += E2(r, e, t[s]), n) {
      var a = i;
      A += a[s];
    }
  Ib.lastIndex = 0;
  for (var c = "", l; (l = Ib.exec(A)) !== null; )
    c += "-" + l[1];
  var u = jre(A) + c;
  return {
    name: u,
    styles: A,
    next: Do
  };
}
var Yre = function(e) {
  return e();
}, Vre = ar.useInsertionEffect ? ar.useInsertionEffect : !1, Wre = Vre || Yre, jT = /* @__PURE__ */ ar.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Dre({
    key: "css"
  }) : null
);
jT.Provider;
var Xre = function(e) {
  return /* @__PURE__ */ ol(function(r, n) {
    var A = Xe(jT);
    return e(r, A, n);
  });
}, Kre = /* @__PURE__ */ ar.createContext({}), Fv = {}.hasOwnProperty, _5 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Zre = function(e, r) {
  var n = {};
  for (var A in r)
    Fv.call(r, A) && (n[A] = r[A]);
  return n[_5] = e, n;
}, Jre = function(e) {
  var r = e.cache, n = e.serialized, A = e.isStringTag;
  return QT(r, n, A), Wre(function() {
    return Nre(r, n, A);
  }), null;
}, _re = /* @__PURE__ */ Xre(function(t, e, r) {
  var n = t.css;
  typeof n == "string" && e.registered[n] !== void 0 && (n = e.registered[n]);
  var A = t[_5], i = [n], o = "";
  typeof t.className == "string" ? o = Ure(e.registered, i, t.className) : t.className != null && (o = t.className + " ");
  var s = NT(i, void 0, ar.useContext(Kre));
  o += e.key + "-" + s.name;
  var a = {};
  for (var c in t)
    Fv.call(t, c) && c !== "css" && c !== _5 && (a[c] = t[c]);
  return a.className = o, r && (a.ref = r), /* @__PURE__ */ ar.createElement(ar.Fragment, null, /* @__PURE__ */ ar.createElement(Jre, {
    cache: e,
    serialized: s,
    isStringTag: typeof A == "string"
  }), /* @__PURE__ */ ar.createElement(A, a));
}), $re = _re, Tt = function(e, r) {
  var n = arguments;
  if (r == null || !Fv.call(r, "css"))
    return ar.createElement.apply(void 0, n);
  var A = n.length, i = new Array(A);
  i[0] = $re, i[1] = Zre(e, r);
  for (var o = 2; o < A; o++)
    i[o] = n[o];
  return ar.createElement.apply(null, i);
};
(function(t) {
  var e;
  e || (e = t.JSX || (t.JSX = {}));
})(Tt);
function Tv() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return NT(e);
}
function ene() {
  var t = Tv.apply(void 0, arguments), e = "animation-" + t.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function tne(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
const Qu = Math.min, Nc = Math.max, h3 = Math.round, gf = Math.floor, Yo = (t) => ({
  x: t,
  y: t
}), rne = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, nne = {
  start: "end",
  end: "start"
};
function $5(t, e, r) {
  return Nc(t, Qu(e, r));
}
function k1(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function _c(t) {
  return t.split("-")[0];
}
function O1(t) {
  return t.split("-")[1];
}
function LT(t) {
  return t === "x" ? "y" : "x";
}
function Mv(t) {
  return t === "y" ? "height" : "width";
}
function Uu(t) {
  return ["top", "bottom"].includes(_c(t)) ? "y" : "x";
}
function Hv(t) {
  return LT(Uu(t));
}
function Ane(t, e, r) {
  r === void 0 && (r = !1);
  const n = O1(t), A = Hv(t), i = Mv(A);
  let o = A === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (o = p3(o)), [o, p3(o)];
}
function ine(t) {
  const e = p3(t);
  return [e7(t), e, e7(e)];
}
function e7(t) {
  return t.replace(/start|end/g, (e) => nne[e]);
}
function one(t, e, r) {
  const n = ["left", "right"], A = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return r ? e ? A : n : e ? n : A;
    case "left":
    case "right":
      return e ? i : o;
    default:
      return [];
  }
}
function sne(t, e, r, n) {
  const A = O1(t);
  let i = one(_c(t), r === "start", n);
  return A && (i = i.map((o) => o + "-" + A), e && (i = i.concat(i.map(e7)))), i;
}
function p3(t) {
  return t.replace(/left|right|bottom|top/g, (e) => rne[e]);
}
function ane(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function GT(t) {
  return typeof t != "number" ? ane(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function g3(t) {
  const {
    x: e,
    y: r,
    width: n,
    height: A
  } = t;
  return {
    width: n,
    height: A,
    top: r,
    left: e,
    right: e + n,
    bottom: r + A,
    x: e,
    y: r
  };
}
function Sb(t, e, r) {
  let {
    reference: n,
    floating: A
  } = t;
  const i = Uu(e), o = Hv(e), s = Mv(o), a = _c(e), c = i === "y", l = n.x + n.width / 2 - A.width / 2, u = n.y + n.height / 2 - A.height / 2, f = n[s] / 2 - A[s] / 2;
  let d;
  switch (a) {
    case "top":
      d = {
        x: l,
        y: n.y - A.height
      };
      break;
    case "bottom":
      d = {
        x: l,
        y: n.y + n.height
      };
      break;
    case "right":
      d = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: n.x - A.width,
        y: u
      };
      break;
    default:
      d = {
        x: n.x,
        y: n.y
      };
  }
  switch (O1(e)) {
    case "start":
      d[o] -= f * (r && c ? -1 : 1);
      break;
    case "end":
      d[o] += f * (r && c ? -1 : 1);
      break;
  }
  return d;
}
const cne = async (t, e, r) => {
  const {
    placement: n = "bottom",
    strategy: A = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), a = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: A
  }), {
    x: l,
    y: u
  } = Sb(c, n, a), f = n, d = {}, g = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: p,
      fn: v
    } = s[m], {
      x: C,
      y: w,
      data: B,
      reset: y
    } = await v({
      x: l,
      y: u,
      initialPlacement: n,
      placement: f,
      strategy: A,
      middlewareData: d,
      rects: c,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    l = C ?? l, u = w ?? u, d = {
      ...d,
      [p]: {
        ...d[p],
        ...B
      }
    }, y && g <= 50 && (g++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (c = y.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: e,
      strategy: A
    }) : y.rects), {
      x: l,
      y: u
    } = Sb(c, f, a)), m = -1);
  }
  return {
    x: l,
    y: u,
    placement: f,
    strategy: A,
    middlewareData: d
  };
};
async function RT(t, e) {
  var r;
  e === void 0 && (e = {});
  const {
    x: n,
    y: A,
    platform: i,
    rects: o,
    elements: s,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: d = 0
  } = k1(e, t), g = GT(d), p = s[f ? u === "floating" ? "reference" : "floating" : u], v = g3(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(p))) == null || r ? p : p.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: l,
    strategy: a
  })), C = u === "floating" ? {
    x: n,
    y: A,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), B = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = g3(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: w,
    strategy: a
  }) : C);
  return {
    top: (v.top - y.top + g.top) / B.y,
    bottom: (y.bottom - v.bottom + g.bottom) / B.y,
    left: (v.left - y.left + g.left) / B.x,
    right: (y.right - v.right + g.right) / B.x
  };
}
const lne = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: r,
      y: n,
      placement: A,
      rects: i,
      platform: o,
      elements: s,
      middlewareData: a
    } = e, {
      element: c,
      padding: l = 0
    } = k1(t, e) || {};
    if (c == null)
      return {};
    const u = GT(l), f = {
      x: r,
      y: n
    }, d = Hv(A), g = Mv(d), m = await o.getDimensions(c), p = d === "y", v = p ? "top" : "left", C = p ? "bottom" : "right", w = p ? "clientHeight" : "clientWidth", B = i.reference[g] + i.reference[d] - f[d] - i.floating[g], y = f[d] - i.reference[d], b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let q = b ? b[w] : 0;
    (!q || !await (o.isElement == null ? void 0 : o.isElement(b))) && (q = s.floating[w] || i.floating[g]);
    const E = B / 2 - y / 2, x = q / 2 - m[g] / 2 - 1, M = Qu(u[v], x), O = Qu(u[C], x), I = M, S = q - m[g] - O, P = q / 2 - m[g] / 2 + E, H = $5(I, P, S), F = !a.arrow && O1(A) != null && P !== H && i.reference[g] / 2 - (P < I ? M : O) - m[g] / 2 < 0, T = F ? P < I ? P - I : P - S : 0;
    return {
      [d]: f[d] + T,
      data: {
        [d]: H,
        centerOffset: P - H - T,
        ...F && {
          alignmentOffset: T
        }
      },
      reset: F
    };
  }
}), une = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var r, n;
      const {
        placement: A,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: a,
        elements: c
      } = e, {
        mainAxis: l = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...p
      } = k1(t, e);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const v = _c(A), C = Uu(s), w = _c(s) === s, B = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), y = f || (w || !m ? [p3(s)] : ine(s)), b = g !== "none";
      !f && b && y.push(...sne(s, m, g, B));
      const q = [s, ...y], E = await RT(e, p), x = [];
      let M = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (l && x.push(E[v]), u) {
        const P = Ane(A, o, B);
        x.push(E[P[0]], E[P[1]]);
      }
      if (M = [...M, {
        placement: A,
        overflows: x
      }], !x.every((P) => P <= 0)) {
        var O, I;
        const P = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, H = q[P];
        if (H)
          return {
            data: {
              index: P,
              overflows: M
            },
            reset: {
              placement: H
            }
          };
        let F = (I = M.filter((T) => T.overflows[0] <= 0).sort((T, U) => T.overflows[1] - U.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!F)
          switch (d) {
            case "bestFit": {
              var S;
              const T = (S = M.filter((U) => {
                if (b) {
                  const D = Uu(U.placement);
                  return D === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((U) => [U.placement, U.overflows.filter((D) => D > 0).reduce((D, Q) => D + Q, 0)]).sort((U, D) => U[1] - D[1])[0]) == null ? void 0 : S[0];
              T && (F = T);
              break;
            }
            case "initialPlacement":
              F = s;
              break;
          }
        if (A !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
async function dne(t, e) {
  const {
    placement: r,
    platform: n,
    elements: A
  } = t, i = await (n.isRTL == null ? void 0 : n.isRTL(A.floating)), o = _c(r), s = O1(r), a = Uu(r) === "y", c = ["left", "top"].includes(o) ? -1 : 1, l = i && a ? -1 : 1, u = k1(e, t);
  let {
    mainAxis: f,
    crossAxis: d,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof g == "number" && (d = s === "end" ? g * -1 : g), a ? {
    x: d * l,
    y: f * c
  } : {
    x: f * c,
    y: d * l
  };
}
const fne = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var r, n;
      const {
        x: A,
        y: i,
        placement: o,
        middlewareData: s
      } = e, a = await dne(e, t);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: A + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: o
        }
      };
    }
  };
}, hne = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: r,
        y: n,
        placement: A
      } = e, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (p) => {
            let {
              x: v,
              y: C
            } = p;
            return {
              x: v,
              y: C
            };
          }
        },
        ...a
      } = k1(t, e), c = {
        x: r,
        y: n
      }, l = await RT(e, a), u = Uu(_c(A)), f = LT(u);
      let d = c[f], g = c[u];
      if (i) {
        const p = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", C = d + l[p], w = d - l[v];
        d = $5(C, d, w);
      }
      if (o) {
        const p = u === "y" ? "top" : "left", v = u === "y" ? "bottom" : "right", C = g + l[p], w = g - l[v];
        g = $5(C, g, w);
      }
      const m = s.fn({
        ...e,
        [f]: d,
        [u]: g
      });
      return {
        ...m,
        data: {
          x: m.x - r,
          y: m.y - n,
          enabled: {
            [f]: i,
            [u]: o
          }
        }
      };
    }
  };
};
function n4() {
  return typeof window < "u";
}
function Od(t) {
  return zT(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function bi(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ts(t) {
  var e;
  return (e = (zT(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function zT(t) {
  return n4() ? t instanceof Node || t instanceof bi(t).Node : !1;
}
function po(t) {
  return n4() ? t instanceof Element || t instanceof bi(t).Element : !1;
}
function Jo(t) {
  return n4() ? t instanceof HTMLElement || t instanceof bi(t).HTMLElement : !1;
}
function Pb(t) {
  return !n4() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof bi(t).ShadowRoot;
}
function F1(t) {
  const {
    overflow: e,
    overflowX: r,
    overflowY: n,
    display: A
  } = go(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + r) && !["inline", "contents"].includes(A);
}
function pne(t) {
  return ["table", "td", "th"].includes(Od(t));
}
function A4(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Dv(t) {
  const e = Qv(), r = po(t) ? go(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !e && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !e && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function gne(t) {
  let e = Ga(t);
  for (; Jo(e) && !Nu(e); ) {
    if (Dv(e))
      return e;
    if (A4(e))
      return null;
    e = Ga(e);
  }
  return null;
}
function Qv() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Nu(t) {
  return ["html", "body", "#document"].includes(Od(t));
}
function go(t) {
  return bi(t).getComputedStyle(t);
}
function i4(t) {
  return po(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Ga(t) {
  if (Od(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Pb(t) && t.host || // Fallback.
    ts(t)
  );
  return Pb(e) ? e.host : e;
}
function YT(t) {
  const e = Ga(t);
  return Nu(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Jo(e) && F1(e) ? e : YT(e);
}
function x2(t, e, r) {
  var n;
  e === void 0 && (e = []), r === void 0 && (r = !0);
  const A = YT(t), i = A === ((n = t.ownerDocument) == null ? void 0 : n.body), o = bi(A);
  if (i) {
    const s = t7(o);
    return e.concat(o, o.visualViewport || [], F1(A) ? A : [], s && r ? x2(s) : []);
  }
  return e.concat(A, x2(A, [], r));
}
function t7(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function VT(t) {
  const e = go(t);
  let r = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const A = Jo(t), i = A ? t.offsetWidth : r, o = A ? t.offsetHeight : n, s = h3(r) !== i || h3(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function Uv(t) {
  return po(t) ? t : t.contextElement;
}
function ou(t) {
  const e = Uv(t);
  if (!Jo(e))
    return Yo(1);
  const r = e.getBoundingClientRect(), {
    width: n,
    height: A,
    $: i
  } = VT(e);
  let o = (i ? h3(r.width) : r.width) / n, s = (i ? h3(r.height) : r.height) / A;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const mne = /* @__PURE__ */ Yo(0);
function WT(t) {
  const e = bi(t);
  return !Qv() || !e.visualViewport ? mne : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function vne(t, e, r) {
  return e === void 0 && (e = !1), !r || e && r !== bi(t) ? !1 : e;
}
function $c(t, e, r, n) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  const A = t.getBoundingClientRect(), i = Uv(t);
  let o = Yo(1);
  e && (n ? po(n) && (o = ou(n)) : o = ou(t));
  const s = vne(i, r, n) ? WT(i) : Yo(0);
  let a = (A.left + s.x) / o.x, c = (A.top + s.y) / o.y, l = A.width / o.x, u = A.height / o.y;
  if (i) {
    const f = bi(i), d = n && po(n) ? bi(n) : n;
    let g = f, m = t7(g);
    for (; m && n && d !== g; ) {
      const p = ou(m), v = m.getBoundingClientRect(), C = go(m), w = v.left + (m.clientLeft + parseFloat(C.paddingLeft)) * p.x, B = v.top + (m.clientTop + parseFloat(C.paddingTop)) * p.y;
      a *= p.x, c *= p.y, l *= p.x, u *= p.y, a += w, c += B, g = bi(m), m = t7(g);
    }
  }
  return g3({
    width: l,
    height: u,
    x: a,
    y: c
  });
}
function Nv(t, e) {
  const r = i4(t).scrollLeft;
  return e ? e.left + r : $c(ts(t)).left + r;
}
function XT(t, e, r) {
  r === void 0 && (r = !1);
  const n = t.getBoundingClientRect(), A = n.left + e.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Nv(t, n)
  )), i = n.top + e.scrollTop;
  return {
    x: A,
    y: i
  };
}
function qne(t) {
  let {
    elements: e,
    rect: r,
    offsetParent: n,
    strategy: A
  } = t;
  const i = A === "fixed", o = ts(n), s = e ? A4(e.floating) : !1;
  if (n === o || s && i)
    return r;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Yo(1);
  const l = Yo(0), u = Jo(n);
  if ((u || !u && !i) && ((Od(n) !== "body" || F1(o)) && (a = i4(n)), Jo(n))) {
    const d = $c(n);
    c = ou(n), l.x = d.x + n.clientLeft, l.y = d.y + n.clientTop;
  }
  const f = o && !u && !i ? XT(o, a, !0) : Yo(0);
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - a.scrollLeft * c.x + l.x + f.x,
    y: r.y * c.y - a.scrollTop * c.y + l.y + f.y
  };
}
function yne(t) {
  return Array.from(t.getClientRects());
}
function Cne(t) {
  const e = ts(t), r = i4(t), n = t.ownerDocument.body, A = Nc(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = Nc(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Nv(t);
  const s = -r.scrollTop;
  return go(n).direction === "rtl" && (o += Nc(e.clientWidth, n.clientWidth) - A), {
    width: A,
    height: i,
    x: o,
    y: s
  };
}
function wne(t, e) {
  const r = bi(t), n = ts(t), A = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, a = 0;
  if (A) {
    i = A.width, o = A.height;
    const c = Qv();
    (!c || c && e === "fixed") && (s = A.offsetLeft, a = A.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function bne(t, e) {
  const r = $c(t, !0, e === "fixed"), n = r.top + t.clientTop, A = r.left + t.clientLeft, i = Jo(t) ? ou(t) : Yo(1), o = t.clientWidth * i.x, s = t.clientHeight * i.y, a = A * i.x, c = n * i.y;
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function kb(t, e, r) {
  let n;
  if (e === "viewport")
    n = wne(t, r);
  else if (e === "document")
    n = Cne(ts(t));
  else if (po(e))
    n = bne(e, r);
  else {
    const A = WT(t);
    n = {
      x: e.x - A.x,
      y: e.y - A.y,
      width: e.width,
      height: e.height
    };
  }
  return g3(n);
}
function KT(t, e) {
  const r = Ga(t);
  return r === e || !po(r) || Nu(r) ? !1 : go(r).position === "fixed" || KT(r, e);
}
function Bne(t, e) {
  const r = e.get(t);
  if (r)
    return r;
  let n = x2(t, [], !1).filter((s) => po(s) && Od(s) !== "body"), A = null;
  const i = go(t).position === "fixed";
  let o = i ? Ga(t) : t;
  for (; po(o) && !Nu(o); ) {
    const s = go(o), a = Dv(o);
    !a && s.position === "fixed" && (A = null), (i ? !a && !A : !a && s.position === "static" && !!A && ["absolute", "fixed"].includes(A.position) || F1(o) && !a && KT(t, o)) ? n = n.filter((l) => l !== o) : A = s, o = Ga(o);
  }
  return e.set(t, n), n;
}
function Ene(t) {
  let {
    element: e,
    boundary: r,
    rootBoundary: n,
    strategy: A
  } = t;
  const o = [...r === "clippingAncestors" ? A4(e) ? [] : Bne(e, this._c) : [].concat(r), n], s = o[0], a = o.reduce((c, l) => {
    const u = kb(e, l, A);
    return c.top = Nc(u.top, c.top), c.right = Qu(u.right, c.right), c.bottom = Qu(u.bottom, c.bottom), c.left = Nc(u.left, c.left), c;
  }, kb(e, s, A));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function xne(t) {
  const {
    width: e,
    height: r
  } = VT(t);
  return {
    width: e,
    height: r
  };
}
function Ine(t, e, r) {
  const n = Jo(e), A = ts(e), i = r === "fixed", o = $c(t, !0, i, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = Yo(0);
  if (n || !n && !i)
    if ((Od(e) !== "body" || F1(A)) && (s = i4(e)), n) {
      const f = $c(e, !0, i, e);
      a.x = f.x + e.clientLeft, a.y = f.y + e.clientTop;
    } else A && (a.x = Nv(A));
  const c = A && !n && !i ? XT(A, s) : Yo(0), l = o.left + s.scrollLeft - a.x - c.x, u = o.top + s.scrollTop - a.y - c.y;
  return {
    x: l,
    y: u,
    width: o.width,
    height: o.height
  };
}
function z9(t) {
  return go(t).position === "static";
}
function Ob(t, e) {
  if (!Jo(t) || go(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let r = t.offsetParent;
  return ts(t) === r && (r = r.ownerDocument.body), r;
}
function ZT(t, e) {
  const r = bi(t);
  if (A4(t))
    return r;
  if (!Jo(t)) {
    let A = Ga(t);
    for (; A && !Nu(A); ) {
      if (po(A) && !z9(A))
        return A;
      A = Ga(A);
    }
    return r;
  }
  let n = Ob(t, e);
  for (; n && pne(n) && z9(n); )
    n = Ob(n, e);
  return n && Nu(n) && z9(n) && !Dv(n) ? r : n || gne(t) || r;
}
const Sne = async function(t) {
  const e = this.getOffsetParent || ZT, r = this.getDimensions, n = await r(t.floating);
  return {
    reference: Ine(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Pne(t) {
  return go(t).direction === "rtl";
}
const kne = {
  convertOffsetParentRelativeRectToViewportRelativeRect: qne,
  getDocumentElement: ts,
  getClippingRect: Ene,
  getOffsetParent: ZT,
  getElementRects: Sne,
  getClientRects: yne,
  getDimensions: xne,
  getScale: ou,
  isElement: po,
  isRTL: Pne
};
function JT(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function One(t, e) {
  let r = null, n;
  const A = ts(t);
  function i() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, a) {
    s === void 0 && (s = !1), a === void 0 && (a = 1), i();
    const c = t.getBoundingClientRect(), {
      left: l,
      top: u,
      width: f,
      height: d
    } = c;
    if (s || e(), !f || !d)
      return;
    const g = gf(u), m = gf(A.clientWidth - (l + f)), p = gf(A.clientHeight - (u + d)), v = gf(l), w = {
      rootMargin: -g + "px " + -m + "px " + -p + "px " + -v + "px",
      threshold: Nc(0, Qu(1, a)) || 1
    };
    let B = !0;
    function y(b) {
      const q = b[0].intersectionRatio;
      if (q !== a) {
        if (!B)
          return o();
        q ? o(!1, q) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      q === 1 && !JT(c, t.getBoundingClientRect()) && o(), B = !1;
    }
    try {
      r = new IntersectionObserver(y, {
        ...w,
        // Handle <iframe>s
        root: A.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(y, w);
    }
    r.observe(t);
  }
  return o(!0), i;
}
function _T(t, e, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: A = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = n, c = Uv(t), l = A || i ? [...c ? x2(c) : [], ...x2(e)] : [];
  l.forEach((v) => {
    A && v.addEventListener("scroll", r, {
      passive: !0
    }), i && v.addEventListener("resize", r);
  });
  const u = c && s ? One(c, r) : null;
  let f = -1, d = null;
  o && (d = new ResizeObserver((v) => {
    let [C] = v;
    C && C.target === c && d && (d.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = d) == null || w.observe(e);
    })), r();
  }), c && !a && d.observe(c), d.observe(e));
  let g, m = a ? $c(t) : null;
  a && p();
  function p() {
    const v = $c(t);
    m && !JT(m, v) && r(), m = v, g = requestAnimationFrame(p);
  }
  return r(), () => {
    var v;
    l.forEach((C) => {
      A && C.removeEventListener("scroll", r), i && C.removeEventListener("resize", r);
    }), u == null || u(), (v = d) == null || v.disconnect(), d = null, a && cancelAnimationFrame(g);
  };
}
const Fne = fne, Tne = hne, Mne = une, Hne = lne, Fb = (t, e, r) => {
  const n = /* @__PURE__ */ new Map(), A = {
    platform: kne,
    ...r
  }, i = {
    ...A.platform,
    _c: n
  };
  return cne(t, e, {
    ...A,
    platform: i
  });
};
var r7 = _p, Dne = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], m3 = function() {
};
function Qne(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function Une(t, e) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), A = 2; A < r; A++)
    n[A - 2] = arguments[A];
  var i = [].concat(n);
  if (e && t)
    for (var o in e)
      e.hasOwnProperty(o) && e[o] && i.push("".concat(Qne(t, o)));
  return i.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Tb = function(e) {
  return Wne(e) ? e.filter(Boolean) : Jc(e) === "object" && e !== null ? [e] : [];
}, $T = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var r = Rs(e, Dne);
  return Nt({}, r);
}, yn = function(e, r, n) {
  var A = e.cx, i = e.getStyles, o = e.getClassNames, s = e.className;
  return {
    css: i(r, e),
    className: A(n ?? {}, o(r, e), s)
  };
};
function o4(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function Nne(t) {
  return o4(t) ? window.innerHeight : t.clientHeight;
}
function eM(t) {
  return o4(t) ? window.pageYOffset : t.scrollTop;
}
function v3(t, e) {
  if (o4(t)) {
    window.scrollTo(0, e);
    return;
  }
  t.scrollTop = e;
}
function jne(t) {
  var e = getComputedStyle(t), r = e.position === "absolute", n = /(auto|scroll)/;
  if (e.position === "fixed") return document.documentElement;
  for (var A = t; A = A.parentElement; )
    if (e = getComputedStyle(A), !(r && e.position === "static") && n.test(e.overflow + e.overflowY + e.overflowX))
      return A;
  return document.documentElement;
}
function Lne(t, e, r, n) {
  return r * ((t = t / n - 1) * t * t + 1) + e;
}
function mf(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : m3, A = eM(t), i = e - A, o = 10, s = 0;
  function a() {
    s += o;
    var c = Lne(s, A, i, r);
    v3(t, c), s < r ? window.requestAnimationFrame(a) : n(t);
  }
  a();
}
function Mb(t, e) {
  var r = t.getBoundingClientRect(), n = e.getBoundingClientRect(), A = e.offsetHeight / 3;
  n.bottom + A > r.bottom ? v3(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + A, t.scrollHeight)) : n.top - A < r.top && v3(t, Math.max(e.offsetTop - A, 0));
}
function Gne(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function Hb() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function Rne() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var tM = !1, zne = {
  get passive() {
    return tM = !0;
  }
}, vf = typeof window < "u" ? window : {};
vf.addEventListener && vf.removeEventListener && (vf.addEventListener("p", m3, zne), vf.removeEventListener("p", m3, !1));
var Yne = tM;
function Vne(t) {
  return t != null;
}
function Wne(t) {
  return Array.isArray(t);
}
function qf(t, e, r) {
  return t ? e : r;
}
var Xne = function(e) {
  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), A = 1; A < r; A++)
    n[A - 1] = arguments[A];
  var i = Object.entries(e).filter(function(o) {
    var s = ws(o, 1), a = s[0];
    return !n.includes(a);
  });
  return i.reduce(function(o, s) {
    var a = ws(s, 2), c = a[0], l = a[1];
    return o[c] = l, o;
  }, {});
}, Kne = ["children", "innerProps"], Zne = ["children", "innerProps"];
function Jne(t) {
  var e = t.maxHeight, r = t.menuEl, n = t.minHeight, A = t.placement, i = t.shouldScroll, o = t.isFixedPosition, s = t.controlHeight, a = jne(r), c = {
    placement: "bottom",
    maxHeight: e
  };
  if (!r || !r.offsetParent) return c;
  var l = a.getBoundingClientRect(), u = l.height, f = r.getBoundingClientRect(), d = f.bottom, g = f.height, m = f.top, p = r.offsetParent.getBoundingClientRect(), v = p.top, C = o ? window.innerHeight : Nne(a), w = eM(a), B = parseInt(getComputedStyle(r).marginBottom, 10), y = parseInt(getComputedStyle(r).marginTop, 10), b = v - y, q = C - m, E = b + w, x = u - w - m, M = d - C + w + B, O = w + m - y, I = 160;
  switch (A) {
    case "auto":
    case "bottom":
      if (q >= g)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (x >= g && !o)
        return i && mf(a, M, I), {
          placement: "bottom",
          maxHeight: e
        };
      if (!o && x >= n || o && q >= n) {
        i && mf(a, M, I);
        var S = o ? q - B : x - B;
        return {
          placement: "bottom",
          maxHeight: S
        };
      }
      if (A === "auto" || o) {
        var P = e, H = o ? b : E;
        return H >= n && (P = Math.min(H - B - s, e)), {
          placement: "top",
          maxHeight: P
        };
      }
      if (A === "bottom")
        return i && v3(a, M), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (b >= g)
        return {
          placement: "top",
          maxHeight: e
        };
      if (E >= g && !o)
        return i && mf(a, O, I), {
          placement: "top",
          maxHeight: e
        };
      if (!o && E >= n || o && b >= n) {
        var F = e;
        return (!o && E >= n || o && b >= n) && (F = o ? b - y : E - y), i && mf(a, O, I), {
          placement: "top",
          maxHeight: F
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(A, '".'));
  }
  return c;
}
function _ne(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}
var rM = function(e) {
  return e === "auto" ? "bottom" : e;
}, $ne = function(e, r) {
  var n, A = e.placement, i = e.theme, o = i.borderRadius, s = i.spacing, a = i.colors;
  return Nt((n = {
    label: "menu"
  }, k0(n, _ne(A), "100%"), k0(n, "position", "absolute"), k0(n, "width", "100%"), k0(n, "zIndex", 1), n), r ? {} : {
    backgroundColor: a.neutral0,
    borderRadius: o,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, nM = /* @__PURE__ */ UA(null), eAe = function(e) {
  var r = e.children, n = e.minMenuHeight, A = e.maxMenuHeight, i = e.menuPlacement, o = e.menuPosition, s = e.menuShouldScrollIntoView, a = e.theme, c = Xe(nM) || {}, l = c.setPortalPlacement, u = gt(null), f = N(A), d = ws(f, 2), g = d[0], m = d[1], p = N(null), v = ws(p, 2), C = v[0], w = v[1], B = a.spacing.controlHeight;
  return r7(function() {
    var y = u.current;
    if (y) {
      var b = o === "fixed", q = s && !b, E = Jne({
        maxHeight: A,
        menuEl: y,
        minHeight: n,
        placement: i,
        shouldScroll: q,
        isFixedPosition: b,
        controlHeight: B
      });
      m(E.maxHeight), w(E.placement), l == null || l(E.placement);
    }
  }, [A, i, o, s, n, l, B]), r({
    ref: u,
    placerProps: Nt(Nt({}, e), {}, {
      placement: C || rM(i),
      maxHeight: g
    })
  });
}, tAe = function(e) {
  var r = e.children, n = e.innerRef, A = e.innerProps;
  return Tt("div", Gt({}, yn(e, "menu", {
    menu: !0
  }), {
    ref: n
  }, A), r);
}, rAe = tAe, nAe = function(e, r) {
  var n = e.maxHeight, A = e.theme.spacing.baseUnit;
  return Nt({
    maxHeight: n,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, r ? {} : {
    paddingBottom: A,
    paddingTop: A
  });
}, AAe = function(e) {
  var r = e.children, n = e.innerProps, A = e.innerRef, i = e.isMulti;
  return Tt("div", Gt({}, yn(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: A
  }, n), r);
}, AM = function(e, r) {
  var n = e.theme, A = n.spacing.baseUnit, i = n.colors;
  return Nt({
    textAlign: "center"
  }, r ? {} : {
    color: i.neutral40,
    padding: "".concat(A * 2, "px ").concat(A * 3, "px")
  });
}, iAe = AM, oAe = AM, sAe = function(e) {
  var r = e.children, n = r === void 0 ? "No options" : r, A = e.innerProps, i = Rs(e, Kne);
  return Tt("div", Gt({}, yn(Nt(Nt({}, i), {}, {
    children: n,
    innerProps: A
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), A), n);
}, aAe = function(e) {
  var r = e.children, n = r === void 0 ? "Loading..." : r, A = e.innerProps, i = Rs(e, Zne);
  return Tt("div", Gt({}, yn(Nt(Nt({}, i), {}, {
    children: n,
    innerProps: A
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), A), n);
}, cAe = function(e) {
  var r = e.rect, n = e.offset, A = e.position;
  return {
    left: r.left,
    position: A,
    top: n,
    width: r.width,
    zIndex: 1
  };
}, lAe = function(e) {
  var r = e.appendTo, n = e.children, A = e.controlElement, i = e.innerProps, o = e.menuPlacement, s = e.menuPosition, a = gt(null), c = gt(null), l = N(rM(o)), u = ws(l, 2), f = u[0], d = u[1], g = MA(function() {
    return {
      setPortalPlacement: d
    };
  }, []), m = N(null), p = ws(m, 2), v = p[0], C = p[1], w = Kn(function() {
    if (A) {
      var q = Gne(A), E = s === "fixed" ? 0 : window.pageYOffset, x = q[f] + E;
      (x !== (v == null ? void 0 : v.offset) || q.left !== (v == null ? void 0 : v.rect.left) || q.width !== (v == null ? void 0 : v.rect.width)) && C({
        offset: x,
        rect: q
      });
    }
  }, [A, s, f, v == null ? void 0 : v.offset, v == null ? void 0 : v.rect.left, v == null ? void 0 : v.rect.width]);
  r7(function() {
    w();
  }, [w]);
  var B = Kn(function() {
    typeof c.current == "function" && (c.current(), c.current = null), A && a.current && (c.current = _T(A, a.current, w, {
      elementResize: "ResizeObserver" in window
    }));
  }, [A, w]);
  r7(function() {
    B();
  }, [B]);
  var y = Kn(function(q) {
    a.current = q, B();
  }, [B]);
  if (!r && s !== "fixed" || !v) return null;
  var b = Tt("div", Gt({
    ref: y
  }, yn(Nt(Nt({}, e), {}, {
    offset: v.offset,
    position: s,
    rect: v.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), n);
  return Tt(nM.Provider, {
    value: g
  }, r ? /* @__PURE__ */ Ej(b, r) : b);
}, uAe = function(e) {
  var r = e.isDisabled, n = e.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : void 0,
    pointerEvents: r ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, dAe = function(e) {
  var r = e.children, n = e.innerProps, A = e.isDisabled, i = e.isRtl;
  return Tt("div", Gt({}, yn(e, "container", {
    "--is-disabled": A,
    "--is-rtl": i
  }), n), r);
}, fAe = function(e, r) {
  var n = e.theme.spacing, A = e.isMulti, i = e.hasValue, o = e.selectProps.controlShouldRenderValue;
  return Nt({
    alignItems: "center",
    display: A && i && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, r ? {} : {
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px")
  });
}, hAe = function(e) {
  var r = e.children, n = e.innerProps, A = e.isMulti, i = e.hasValue;
  return Tt("div", Gt({}, yn(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": A,
    "value-container--has-value": i
  }), n), r);
}, pAe = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, gAe = function(e) {
  var r = e.children, n = e.innerProps;
  return Tt("div", Gt({}, yn(e, "indicatorsContainer", {
    indicators: !0
  }), n), r);
}, Db, mAe = ["size"], vAe = ["innerProps", "isRtl", "size"];
function qAe() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var yAe = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: qAe
}, iM = function(e) {
  var r = e.size, n = Rs(e, mAe);
  return Tt("svg", Gt({
    height: r,
    width: r,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: yAe
  }, n));
}, jv = function(e) {
  return Tt(iM, Gt({
    size: 20
  }, e), Tt("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, oM = function(e) {
  return Tt(iM, Gt({
    size: 20
  }, e), Tt("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, sM = function(e, r) {
  var n = e.isFocused, A = e.theme, i = A.spacing.baseUnit, o = A.colors;
  return Nt({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, r ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: i * 2,
    ":hover": {
      color: n ? o.neutral80 : o.neutral40
    }
  });
}, CAe = sM, wAe = function(e) {
  var r = e.children, n = e.innerProps;
  return Tt("div", Gt({}, yn(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), n), r || Tt(oM, null));
}, bAe = sM, BAe = function(e) {
  var r = e.children, n = e.innerProps;
  return Tt("div", Gt({}, yn(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), n), r || Tt(jv, null));
}, EAe = function(e, r) {
  var n = e.isDisabled, A = e.theme, i = A.spacing.baseUnit, o = A.colors;
  return Nt({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, r ? {} : {
    backgroundColor: n ? o.neutral10 : o.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, xAe = function(e) {
  var r = e.innerProps;
  return Tt("span", Gt({}, r, yn(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, IAe = ene(Db || (Db = tne([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), SAe = function(e, r) {
  var n = e.isFocused, A = e.size, i = e.theme, o = i.colors, s = i.spacing.baseUnit;
  return Nt({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: A,
    lineHeight: 1,
    marginRight: A,
    textAlign: "center",
    verticalAlign: "middle"
  }, r ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: s * 2
  });
}, Y9 = function(e) {
  var r = e.delay, n = e.offset;
  return Tt("span", {
    css: /* @__PURE__ */ Tv({
      animation: "".concat(IAe, " 1s ease-in-out ").concat(r, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, PAe = function(e) {
  var r = e.innerProps, n = e.isRtl, A = e.size, i = A === void 0 ? 4 : A, o = Rs(e, vAe);
  return Tt("div", Gt({}, yn(Nt(Nt({}, o), {}, {
    innerProps: r,
    isRtl: n,
    size: i
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), r), Tt(Y9, {
    delay: 0,
    offset: n
  }), Tt(Y9, {
    delay: 160,
    offset: !0
  }), Tt(Y9, {
    delay: 320,
    offset: !n
  }));
}, kAe = function(e, r) {
  var n = e.isDisabled, A = e.isFocused, i = e.theme, o = i.colors, s = i.borderRadius, a = i.spacing;
  return Nt({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: a.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, r ? {} : {
    backgroundColor: n ? o.neutral5 : o.neutral0,
    borderColor: n ? o.neutral10 : A ? o.primary : o.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: A ? "0 0 0 1px ".concat(o.primary) : void 0,
    "&:hover": {
      borderColor: A ? o.primary : o.neutral30
    }
  });
}, OAe = function(e) {
  var r = e.children, n = e.isDisabled, A = e.isFocused, i = e.innerRef, o = e.innerProps, s = e.menuIsOpen;
  return Tt("div", Gt({
    ref: i
  }, yn(e, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": A,
    "control--menu-is-open": s
  }), o, {
    "aria-disabled": n || void 0
  }), r);
}, FAe = OAe, TAe = ["data"], MAe = function(e, r) {
  var n = e.theme.spacing;
  return r ? {} : {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, HAe = function(e) {
  var r = e.children, n = e.cx, A = e.getStyles, i = e.getClassNames, o = e.Heading, s = e.headingProps, a = e.innerProps, c = e.label, l = e.theme, u = e.selectProps;
  return Tt("div", Gt({}, yn(e, "group", {
    group: !0
  }), a), Tt(o, Gt({}, s, {
    selectProps: u,
    theme: l,
    getStyles: A,
    getClassNames: i,
    cx: n
  }), c), Tt("div", null, r));
}, DAe = function(e, r) {
  var n = e.theme, A = n.colors, i = n.spacing;
  return Nt({
    label: "group",
    cursor: "default",
    display: "block"
  }, r ? {} : {
    color: A.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, QAe = function(e) {
  var r = $T(e);
  r.data;
  var n = Rs(r, TAe);
  return Tt("div", Gt({}, yn(e, "groupHeading", {
    "group-heading": !0
  }), n));
}, UAe = HAe, NAe = ["innerRef", "isDisabled", "isHidden", "inputClassName"], jAe = function(e, r) {
  var n = e.isDisabled, A = e.value, i = e.theme, o = i.spacing, s = i.colors;
  return Nt(Nt({
    visibility: n ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: A ? "translateZ(0)" : ""
  }, LAe), r ? {} : {
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    color: s.neutral80
  });
}, aM = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, LAe = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": Nt({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, aM)
}, GAe = function(e) {
  return Nt({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, aM);
}, RAe = function(e) {
  var r = e.cx, n = e.value, A = $T(e), i = A.innerRef, o = A.isDisabled, s = A.isHidden, a = A.inputClassName, c = Rs(A, NAe);
  return Tt("div", Gt({}, yn(e, "input", {
    "input-container": !0
  }), {
    "data-value": n || ""
  }), Tt("input", Gt({
    className: r({
      input: !0
    }, a),
    ref: i,
    style: GAe(s),
    disabled: o
  }, c)));
}, zAe = RAe, YAe = function(e, r) {
  var n = e.theme, A = n.spacing, i = n.borderRadius, o = n.colors;
  return Nt({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, r ? {} : {
    backgroundColor: o.neutral10,
    borderRadius: i / 2,
    margin: A.baseUnit / 2
  });
}, VAe = function(e, r) {
  var n = e.theme, A = n.borderRadius, i = n.colors, o = e.cropWithEllipsis;
  return Nt({
    overflow: "hidden",
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, r ? {} : {
    borderRadius: A / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, WAe = function(e, r) {
  var n = e.theme, A = n.spacing, i = n.borderRadius, o = n.colors, s = e.isFocused;
  return Nt({
    alignItems: "center",
    display: "flex"
  }, r ? {} : {
    borderRadius: i / 2,
    backgroundColor: s ? o.dangerLight : void 0,
    paddingLeft: A.baseUnit,
    paddingRight: A.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  });
}, cM = function(e) {
  var r = e.children, n = e.innerProps;
  return Tt("div", n, r);
}, XAe = cM, KAe = cM;
function ZAe(t) {
  var e = t.children, r = t.innerProps;
  return Tt("div", Gt({
    role: "button"
  }, r), e || Tt(jv, {
    size: 14
  }));
}
var JAe = function(e) {
  var r = e.children, n = e.components, A = e.data, i = e.innerProps, o = e.isDisabled, s = e.removeProps, a = e.selectProps, c = n.Container, l = n.Label, u = n.Remove;
  return Tt(c, {
    data: A,
    innerProps: Nt(Nt({}, yn(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": o
    })), i),
    selectProps: a
  }, Tt(l, {
    data: A,
    innerProps: Nt({}, yn(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: a
  }, r), Tt(u, {
    data: A,
    innerProps: Nt(Nt({}, yn(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(r || "option")
    }, s),
    selectProps: a
  }));
}, _Ae = JAe, $Ae = function(e, r) {
  var n = e.isDisabled, A = e.isFocused, i = e.isSelected, o = e.theme, s = o.spacing, a = o.colors;
  return Nt({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, r ? {} : {
    backgroundColor: i ? a.primary : A ? a.primary25 : "transparent",
    color: n ? a.neutral20 : i ? a.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : i ? a.primary : a.primary50
    }
  });
}, eie = function(e) {
  var r = e.children, n = e.isDisabled, A = e.isFocused, i = e.isSelected, o = e.innerRef, s = e.innerProps;
  return Tt("div", Gt({}, yn(e, "option", {
    option: !0,
    "option--is-disabled": n,
    "option--is-focused": A,
    "option--is-selected": i
  }), {
    ref: o,
    "aria-disabled": n
  }, s), r);
}, tie = eie, rie = function(e, r) {
  var n = e.theme, A = n.spacing, i = n.colors;
  return Nt({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, r ? {} : {
    color: i.neutral50,
    marginLeft: A.baseUnit / 2,
    marginRight: A.baseUnit / 2
  });
}, nie = function(e) {
  var r = e.children, n = e.innerProps;
  return Tt("div", Gt({}, yn(e, "placeholder", {
    placeholder: !0
  }), n), r);
}, Aie = nie, iie = function(e, r) {
  var n = e.isDisabled, A = e.theme, i = A.spacing, o = A.colors;
  return Nt({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, r ? {} : {
    color: n ? o.neutral40 : o.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, oie = function(e) {
  var r = e.children, n = e.isDisabled, A = e.innerProps;
  return Tt("div", Gt({}, yn(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": n
  }), A), r);
}, sie = oie, aie = {
  ClearIndicator: BAe,
  Control: FAe,
  DropdownIndicator: wAe,
  DownChevron: oM,
  CrossIcon: jv,
  Group: UAe,
  GroupHeading: QAe,
  IndicatorsContainer: gAe,
  IndicatorSeparator: xAe,
  Input: zAe,
  LoadingIndicator: PAe,
  Menu: rAe,
  MenuList: AAe,
  MenuPortal: lAe,
  LoadingMessage: aAe,
  NoOptionsMessage: sAe,
  MultiValue: _Ae,
  MultiValueContainer: XAe,
  MultiValueLabel: KAe,
  MultiValueRemove: ZAe,
  Option: tie,
  Placeholder: Aie,
  SelectContainer: dAe,
  SingleValue: sie,
  ValueContainer: hAe
}, cie = function(e) {
  return Nt(Nt({}, aie), e.components);
}, Qb = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function lie(t, e) {
  return !!(t === e || Qb(t) && Qb(e));
}
function uie(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var r = 0; r < t.length; r++)
    if (!lie(t[r], e[r]))
      return !1;
  return !0;
}
function die(t, e) {
  e === void 0 && (e = uie);
  var r = null;
  function n() {
    for (var A = [], i = 0; i < arguments.length; i++)
      A[i] = arguments[i];
    if (r && r.lastThis === this && e(A, r.lastArgs))
      return r.lastResult;
    var o = t.apply(this, A);
    return r = {
      lastResult: o,
      lastArgs: A,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
function fie() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var hie = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: fie
}, pie = function(e) {
  return Tt("span", Gt({
    css: hie
  }, e));
}, Ub = pie, gie = {
  guidance: function(e) {
    var r = e.isSearchable, n = e.isMulti, A = e.tabSelectsValue, i = e.context, o = e.isInitialFocus;
    switch (i) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(A ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return o ? "".concat(e["aria-label"] || "Select", " is focused ").concat(r ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var r = e.action, n = e.label, A = n === void 0 ? "" : n, i = e.labels, o = e.isDisabled;
    switch (r) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(A, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return o ? "option ".concat(A, " is disabled. Select another option.") : "option ".concat(A, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var r = e.context, n = e.focused, A = e.options, i = e.label, o = i === void 0 ? "" : i, s = e.selectValue, a = e.isDisabled, c = e.isSelected, l = e.isAppleDevice, u = function(m, p) {
      return m && m.length ? "".concat(m.indexOf(p) + 1, " of ").concat(m.length) : "";
    };
    if (r === "value" && s)
      return "value ".concat(o, " focused, ").concat(u(s, n), ".");
    if (r === "menu" && l) {
      var f = a ? " disabled" : "", d = "".concat(c ? " selected" : "").concat(f);
      return "".concat(o).concat(d, ", ").concat(u(A, n), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var r = e.inputValue, n = e.resultsMessage;
    return "".concat(n).concat(r ? " for search term " + r : "", ".");
  }
}, mie = function(e) {
  var r = e.ariaSelection, n = e.focusedOption, A = e.focusedValue, i = e.focusableOptions, o = e.isFocused, s = e.selectValue, a = e.selectProps, c = e.id, l = e.isAppleDevice, u = a.ariaLiveMessages, f = a.getOptionLabel, d = a.inputValue, g = a.isMulti, m = a.isOptionDisabled, p = a.isSearchable, v = a.menuIsOpen, C = a.options, w = a.screenReaderStatus, B = a.tabSelectsValue, y = a.isLoading, b = a["aria-label"], q = a["aria-live"], E = MA(function() {
    return Nt(Nt({}, gie), u || {});
  }, [u]), x = MA(function() {
    var H = "";
    if (r && E.onChange) {
      var F = r.option, T = r.options, U = r.removedValue, D = r.removedValues, Q = r.value, Y = function(G) {
        return Array.isArray(G) ? null : G;
      }, j = U || F || Y(Q), Z = j ? f(j) : "", W = T || D || void 0, R = W ? W.map(f) : [], K = Nt({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: j && m(j, s),
        label: Z,
        labels: R
      }, r);
      H = E.onChange(K);
    }
    return H;
  }, [r, E, m, s, f]), M = MA(function() {
    var H = "", F = n || A, T = !!(n && s && s.includes(n));
    if (F && E.onFocus) {
      var U = {
        focused: F,
        label: f(F),
        isDisabled: m(F, s),
        isSelected: T,
        options: i,
        context: F === n ? "menu" : "value",
        selectValue: s,
        isAppleDevice: l
      };
      H = E.onFocus(U);
    }
    return H;
  }, [n, A, f, m, E, i, s, l]), O = MA(function() {
    var H = "";
    if (v && C.length && !y && E.onFilter) {
      var F = w({
        count: i.length
      });
      H = E.onFilter({
        inputValue: d,
        resultsMessage: F
      });
    }
    return H;
  }, [i, d, v, E, C, w, y]), I = (r == null ? void 0 : r.action) === "initial-input-focus", S = MA(function() {
    var H = "";
    if (E.guidance) {
      var F = A ? "value" : v ? "menu" : "input";
      H = E.guidance({
        "aria-label": b,
        context: F,
        isDisabled: n && m(n, s),
        isMulti: g,
        isSearchable: p,
        tabSelectsValue: B,
        isInitialFocus: I
      });
    }
    return H;
  }, [b, n, A, g, m, p, v, E, s, B, I]), P = Tt(X6, null, Tt("span", {
    id: "aria-selection"
  }, x), Tt("span", {
    id: "aria-focused"
  }, M), Tt("span", {
    id: "aria-results"
  }, O), Tt("span", {
    id: "aria-guidance"
  }, S));
  return Tt(X6, null, Tt(Ub, {
    id: c
  }, I && P), Tt(Ub, {
    "aria-live": q,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, o && !I && P));
}, vie = mie, n7 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], qie = new RegExp("[" + n7.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), lM = {};
for (var V9 = 0; V9 < n7.length; V9++)
  for (var W9 = n7[V9], X9 = 0; X9 < W9.letters.length; X9++)
    lM[W9.letters[X9]] = W9.base;
var uM = function(e) {
  return e.replace(qie, function(r) {
    return lM[r];
  });
}, yie = die(uM), Nb = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, Cie = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, wie = function(e) {
  return function(r, n) {
    if (r.data.__isNew__) return !0;
    var A = Nt({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Cie,
      trim: !0,
      matchFrom: "any"
    }, e), i = A.ignoreCase, o = A.ignoreAccents, s = A.stringify, a = A.trim, c = A.matchFrom, l = a ? Nb(n) : n, u = a ? Nb(s(r)) : s(r);
    return i && (l = l.toLowerCase(), u = u.toLowerCase()), o && (l = yie(l), u = uM(u)), c === "start" ? u.substr(0, l.length) === l : u.indexOf(l) > -1;
  };
}, bie = ["innerRef"];
function Bie(t) {
  var e = t.innerRef, r = Rs(t, bie), n = Xne(r, "onExited", "in", "enter", "exit", "appear");
  return Tt("input", Gt({
    ref: e
  }, n, {
    css: /* @__PURE__ */ Tv({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var Eie = function(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};
function xie(t) {
  var e = t.isEnabled, r = t.onBottomArrive, n = t.onBottomLeave, A = t.onTopArrive, i = t.onTopLeave, o = gt(!1), s = gt(!1), a = gt(0), c = gt(null), l = Kn(function(p, v) {
    if (c.current !== null) {
      var C = c.current, w = C.scrollTop, B = C.scrollHeight, y = C.clientHeight, b = c.current, q = v > 0, E = B - y - w, x = !1;
      E > v && o.current && (n && n(p), o.current = !1), q && s.current && (i && i(p), s.current = !1), q && v > E ? (r && !o.current && r(p), b.scrollTop = B, x = !0, o.current = !0) : !q && -v > w && (A && !s.current && A(p), b.scrollTop = 0, x = !0, s.current = !0), x && Eie(p);
    }
  }, [r, n, A, i]), u = Kn(function(p) {
    l(p, p.deltaY);
  }, [l]), f = Kn(function(p) {
    a.current = p.changedTouches[0].clientY;
  }, []), d = Kn(function(p) {
    var v = a.current - p.changedTouches[0].clientY;
    l(p, v);
  }, [l]), g = Kn(function(p) {
    if (p) {
      var v = Yne ? {
        passive: !1
      } : !1;
      p.addEventListener("wheel", u, v), p.addEventListener("touchstart", f, v), p.addEventListener("touchmove", d, v);
    }
  }, [d, f, u]), m = Kn(function(p) {
    p && (p.removeEventListener("wheel", u, !1), p.removeEventListener("touchstart", f, !1), p.removeEventListener("touchmove", d, !1));
  }, [d, f, u]);
  return le(function() {
    if (e) {
      var p = c.current;
      return g(p), function() {
        m(p);
      };
    }
  }, [e, g, m]), function(p) {
    c.current = p;
  };
}
var jb = ["boxSizing", "height", "overflow", "paddingRight", "position"], Lb = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Gb(t) {
  t.cancelable && t.preventDefault();
}
function Rb(t) {
  t.stopPropagation();
}
function zb() {
  var t = this.scrollTop, e = this.scrollHeight, r = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : r === e && (this.scrollTop = t - 1);
}
function Yb() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Vb = !!(typeof window < "u" && window.document && window.document.createElement), f0 = 0, Cl = {
  capture: !1,
  passive: !1
};
function Iie(t) {
  var e = t.isEnabled, r = t.accountForScrollbars, n = r === void 0 ? !0 : r, A = gt({}), i = gt(null), o = Kn(function(a) {
    if (Vb) {
      var c = document.body, l = c && c.style;
      if (n && jb.forEach(function(g) {
        var m = l && l[g];
        A.current[g] = m;
      }), n && f0 < 1) {
        var u = parseInt(A.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, d = window.innerWidth - f + u || 0;
        Object.keys(Lb).forEach(function(g) {
          var m = Lb[g];
          l && (l[g] = m);
        }), l && (l.paddingRight = "".concat(d, "px"));
      }
      c && Yb() && (c.addEventListener("touchmove", Gb, Cl), a && (a.addEventListener("touchstart", zb, Cl), a.addEventListener("touchmove", Rb, Cl))), f0 += 1;
    }
  }, [n]), s = Kn(function(a) {
    if (Vb) {
      var c = document.body, l = c && c.style;
      f0 = Math.max(f0 - 1, 0), n && f0 < 1 && jb.forEach(function(u) {
        var f = A.current[u];
        l && (l[u] = f);
      }), c && Yb() && (c.removeEventListener("touchmove", Gb, Cl), a && (a.removeEventListener("touchstart", zb, Cl), a.removeEventListener("touchmove", Rb, Cl)));
    }
  }, [n]);
  return le(function() {
    if (e) {
      var a = i.current;
      return o(a), function() {
        s(a);
      };
    }
  }, [e, o, s]), function(a) {
    i.current = a;
  };
}
function Sie() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Pie = function(e) {
  var r = e.target;
  return r.ownerDocument.activeElement && r.ownerDocument.activeElement.blur();
}, kie = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Sie
};
function Oie(t) {
  var e = t.children, r = t.lockEnabled, n = t.captureEnabled, A = n === void 0 ? !0 : n, i = t.onBottomArrive, o = t.onBottomLeave, s = t.onTopArrive, a = t.onTopLeave, c = xie({
    isEnabled: A,
    onBottomArrive: i,
    onBottomLeave: o,
    onTopArrive: s,
    onTopLeave: a
  }), l = Iie({
    isEnabled: r
  }), u = function(d) {
    c(d), l(d);
  };
  return Tt(X6, null, r && Tt("div", {
    onClick: Pie,
    css: kie
  }), e(u));
}
function Fie() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Tie = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Fie
}, Mie = function(e) {
  var r = e.name, n = e.onFocus;
  return Tt("input", {
    required: !0,
    name: r,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: Tie,
    value: "",
    onChange: function() {
    }
  });
}, Hie = Mie;
function Lv(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function Die() {
  return Lv(/^iPhone/i);
}
function dM() {
  return Lv(/^Mac/i);
}
function Qie() {
  return Lv(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  dM() && navigator.maxTouchPoints > 1;
}
function Uie() {
  return Die() || Qie();
}
function Nie() {
  return dM() || Uie();
}
var jie = function(e) {
  return e.label;
}, Lie = function(e) {
  return e.label;
}, Gie = function(e) {
  return e.value;
}, Rie = function(e) {
  return !!e.isDisabled;
}, zie = {
  clearIndicator: bAe,
  container: uAe,
  control: kAe,
  dropdownIndicator: CAe,
  group: MAe,
  groupHeading: DAe,
  indicatorsContainer: pAe,
  indicatorSeparator: EAe,
  input: jAe,
  loadingIndicator: SAe,
  loadingMessage: oAe,
  menu: $ne,
  menuList: nAe,
  menuPortal: cAe,
  multiValue: YAe,
  multiValueLabel: VAe,
  multiValueRemove: WAe,
  noOptionsMessage: iAe,
  option: $Ae,
  placeholder: rie,
  singleValue: iie,
  valueContainer: fAe
}, Yie = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, Vie = 4, fM = 4, Wie = 38, Xie = fM * 2, Kie = {
  baseUnit: fM,
  controlHeight: Wie,
  menuGutter: Xie
}, K9 = {
  borderRadius: Vie,
  colors: Yie,
  spacing: Kie
}, Zie = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Hb(),
  captureMenuScroll: !Hb(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: wie(),
  formatGroupLabel: jie,
  getOptionLabel: Lie,
  getOptionValue: Gie,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Rie,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Rne(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var r = e.count;
    return "".concat(r, " result").concat(r !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Wb(t, e, r, n) {
  var A = gM(t, e, r), i = mM(t, e, r), o = pM(t, e), s = q3(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: A,
    isSelected: i,
    label: o,
    value: s,
    index: n
  };
}
function Bh(t, e) {
  return t.options.map(function(r, n) {
    if ("options" in r) {
      var A = r.options.map(function(o, s) {
        return Wb(t, o, e, s);
      }).filter(function(o) {
        return Kb(t, o);
      });
      return A.length > 0 ? {
        type: "group",
        data: r,
        options: A,
        index: n
      } : void 0;
    }
    var i = Wb(t, r, e, n);
    return Kb(t, i) ? i : void 0;
  }).filter(Vne);
}
function hM(t) {
  return t.reduce(function(e, r) {
    return r.type === "group" ? e.push.apply(e, Sv(r.options.map(function(n) {
      return n.data;
    }))) : e.push(r.data), e;
  }, []);
}
function Xb(t, e) {
  return t.reduce(function(r, n) {
    return n.type === "group" ? r.push.apply(r, Sv(n.options.map(function(A) {
      return {
        data: A.data,
        id: "".concat(e, "-").concat(n.index, "-").concat(A.index)
      };
    }))) : r.push({
      data: n.data,
      id: "".concat(e, "-").concat(n.index)
    }), r;
  }, []);
}
function Jie(t, e) {
  return hM(Bh(t, e));
}
function Kb(t, e) {
  var r = t.inputValue, n = r === void 0 ? "" : r, A = e.data, i = e.isSelected, o = e.label, s = e.value;
  return (!qM(t) || !i) && vM(t, {
    label: o,
    value: s,
    data: A
  }, n);
}
function _ie(t, e) {
  var r = t.focusedValue, n = t.selectValue, A = n.indexOf(r);
  if (A > -1) {
    var i = e.indexOf(r);
    if (i > -1)
      return r;
    if (A < e.length)
      return e[A];
  }
  return null;
}
function $ie(t, e) {
  var r = t.focusedOption;
  return r && e.indexOf(r) > -1 ? r : e[0];
}
var Z9 = function(e, r) {
  var n, A = (n = e.find(function(i) {
    return i.data === r;
  })) === null || n === void 0 ? void 0 : n.id;
  return A || null;
}, pM = function(e, r) {
  return e.getOptionLabel(r);
}, q3 = function(e, r) {
  return e.getOptionValue(r);
};
function gM(t, e, r) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, r) : !1;
}
function mM(t, e, r) {
  if (r.indexOf(e) > -1) return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, r);
  var n = q3(t, e);
  return r.some(function(A) {
    return q3(t, A) === n;
  });
}
function vM(t, e, r) {
  return t.filterOption ? t.filterOption(e, r) : !0;
}
var qM = function(e) {
  var r = e.hideSelectedOptions, n = e.isMulti;
  return r === void 0 ? n : r;
}, eoe = 1, yM = /* @__PURE__ */ function(t) {
  ere(r, t);
  var e = nre(r);
  function r(n) {
    var A;
    if (_te(this, r), A = e.call(this, n), A.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, A.blockOptionHover = !1, A.isComposing = !1, A.commonProps = void 0, A.initialTouchX = 0, A.initialTouchY = 0, A.openAfterFocus = !1, A.scrollToFocusedOptionOnUpdate = !1, A.userIsDragging = void 0, A.isAppleDevice = Nie(), A.controlRef = null, A.getControlRef = function(a) {
      A.controlRef = a;
    }, A.focusedOptionRef = null, A.getFocusedOptionRef = function(a) {
      A.focusedOptionRef = a;
    }, A.menuListRef = null, A.getMenuListRef = function(a) {
      A.menuListRef = a;
    }, A.inputRef = null, A.getInputRef = function(a) {
      A.inputRef = a;
    }, A.focus = A.focusInput, A.blur = A.blurInput, A.onChange = function(a, c) {
      var l = A.props, u = l.onChange, f = l.name;
      c.name = f, A.ariaOnChange(a, c), u(a, c);
    }, A.setValue = function(a, c, l) {
      var u = A.props, f = u.closeMenuOnSelect, d = u.isMulti, g = u.inputValue;
      A.onInputChange("", {
        action: "set-value",
        prevInputValue: g
      }), f && (A.setState({
        inputIsHiddenAfterUpdate: !d
      }), A.onMenuClose()), A.setState({
        clearFocusValueOnUpdate: !0
      }), A.onChange(a, {
        action: c,
        option: l
      });
    }, A.selectOption = function(a) {
      var c = A.props, l = c.blurInputOnSelect, u = c.isMulti, f = c.name, d = A.state.selectValue, g = u && A.isOptionSelected(a, d), m = A.isOptionDisabled(a, d);
      if (g) {
        var p = A.getOptionValue(a);
        A.setValue(d.filter(function(v) {
          return A.getOptionValue(v) !== p;
        }), "deselect-option", a);
      } else if (!m)
        u ? A.setValue([].concat(Sv(d), [a]), "select-option", a) : A.setValue(a, "select-option");
      else {
        A.ariaOnChange(a, {
          action: "select-option",
          option: a,
          name: f
        });
        return;
      }
      l && A.blurInput();
    }, A.removeValue = function(a) {
      var c = A.props.isMulti, l = A.state.selectValue, u = A.getOptionValue(a), f = l.filter(function(g) {
        return A.getOptionValue(g) !== u;
      }), d = qf(c, f, f[0] || null);
      A.onChange(d, {
        action: "remove-value",
        removedValue: a
      }), A.focusInput();
    }, A.clearValue = function() {
      var a = A.state.selectValue;
      A.onChange(qf(A.props.isMulti, [], null), {
        action: "clear",
        removedValues: a
      });
    }, A.popValue = function() {
      var a = A.props.isMulti, c = A.state.selectValue, l = c[c.length - 1], u = c.slice(0, c.length - 1), f = qf(a, u, u[0] || null);
      l && A.onChange(f, {
        action: "pop-value",
        removedValue: l
      });
    }, A.getFocusedOptionId = function(a) {
      return Z9(A.state.focusableOptionsWithIds, a);
    }, A.getFocusableOptionsWithIds = function() {
      return Xb(Bh(A.props, A.state.selectValue), A.getElementId("option"));
    }, A.getValue = function() {
      return A.state.selectValue;
    }, A.cx = function() {
      for (var a = arguments.length, c = new Array(a), l = 0; l < a; l++)
        c[l] = arguments[l];
      return Une.apply(void 0, [A.props.classNamePrefix].concat(c));
    }, A.getOptionLabel = function(a) {
      return pM(A.props, a);
    }, A.getOptionValue = function(a) {
      return q3(A.props, a);
    }, A.getStyles = function(a, c) {
      var l = A.props.unstyled, u = zie[a](c, l);
      u.boxSizing = "border-box";
      var f = A.props.styles[a];
      return f ? f(u, c) : u;
    }, A.getClassNames = function(a, c) {
      var l, u;
      return (l = (u = A.props.classNames)[a]) === null || l === void 0 ? void 0 : l.call(u, c);
    }, A.getElementId = function(a) {
      return "".concat(A.state.instancePrefix, "-").concat(a);
    }, A.getComponents = function() {
      return cie(A.props);
    }, A.buildCategorizedOptions = function() {
      return Bh(A.props, A.state.selectValue);
    }, A.getCategorizedOptions = function() {
      return A.props.menuIsOpen ? A.buildCategorizedOptions() : [];
    }, A.buildFocusableOptions = function() {
      return hM(A.buildCategorizedOptions());
    }, A.getFocusableOptions = function() {
      return A.props.menuIsOpen ? A.buildFocusableOptions() : [];
    }, A.ariaOnChange = function(a, c) {
      A.setState({
        ariaSelection: Nt({
          value: a
        }, c)
      });
    }, A.onMenuMouseDown = function(a) {
      a.button === 0 && (a.stopPropagation(), a.preventDefault(), A.focusInput());
    }, A.onMenuMouseMove = function(a) {
      A.blockOptionHover = !1;
    }, A.onControlMouseDown = function(a) {
      if (!a.defaultPrevented) {
        var c = A.props.openMenuOnClick;
        A.state.isFocused ? A.props.menuIsOpen ? a.target.tagName !== "INPUT" && a.target.tagName !== "TEXTAREA" && A.onMenuClose() : c && A.openMenu("first") : (c && (A.openAfterFocus = !0), A.focusInput()), a.target.tagName !== "INPUT" && a.target.tagName !== "TEXTAREA" && a.preventDefault();
      }
    }, A.onDropdownIndicatorMouseDown = function(a) {
      if (!(a && a.type === "mousedown" && a.button !== 0) && !A.props.isDisabled) {
        var c = A.props, l = c.isMulti, u = c.menuIsOpen;
        A.focusInput(), u ? (A.setState({
          inputIsHiddenAfterUpdate: !l
        }), A.onMenuClose()) : A.openMenu("first"), a.preventDefault();
      }
    }, A.onClearIndicatorMouseDown = function(a) {
      a && a.type === "mousedown" && a.button !== 0 || (A.clearValue(), a.preventDefault(), A.openAfterFocus = !1, a.type === "touchend" ? A.focusInput() : setTimeout(function() {
        return A.focusInput();
      }));
    }, A.onScroll = function(a) {
      typeof A.props.closeMenuOnScroll == "boolean" ? a.target instanceof HTMLElement && o4(a.target) && A.props.onMenuClose() : typeof A.props.closeMenuOnScroll == "function" && A.props.closeMenuOnScroll(a) && A.props.onMenuClose();
    }, A.onCompositionStart = function() {
      A.isComposing = !0;
    }, A.onCompositionEnd = function() {
      A.isComposing = !1;
    }, A.onTouchStart = function(a) {
      var c = a.touches, l = c && c.item(0);
      l && (A.initialTouchX = l.clientX, A.initialTouchY = l.clientY, A.userIsDragging = !1);
    }, A.onTouchMove = function(a) {
      var c = a.touches, l = c && c.item(0);
      if (l) {
        var u = Math.abs(l.clientX - A.initialTouchX), f = Math.abs(l.clientY - A.initialTouchY), d = 5;
        A.userIsDragging = u > d || f > d;
      }
    }, A.onTouchEnd = function(a) {
      A.userIsDragging || (A.controlRef && !A.controlRef.contains(a.target) && A.menuListRef && !A.menuListRef.contains(a.target) && A.blurInput(), A.initialTouchX = 0, A.initialTouchY = 0);
    }, A.onControlTouchEnd = function(a) {
      A.userIsDragging || A.onControlMouseDown(a);
    }, A.onClearIndicatorTouchEnd = function(a) {
      A.userIsDragging || A.onClearIndicatorMouseDown(a);
    }, A.onDropdownIndicatorTouchEnd = function(a) {
      A.userIsDragging || A.onDropdownIndicatorMouseDown(a);
    }, A.handleInputChange = function(a) {
      var c = A.props.inputValue, l = a.currentTarget.value;
      A.setState({
        inputIsHiddenAfterUpdate: !1
      }), A.onInputChange(l, {
        action: "input-change",
        prevInputValue: c
      }), A.props.menuIsOpen || A.onMenuOpen();
    }, A.onInputFocus = function(a) {
      A.props.onFocus && A.props.onFocus(a), A.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (A.openAfterFocus || A.props.openMenuOnFocus) && A.openMenu("first"), A.openAfterFocus = !1;
    }, A.onInputBlur = function(a) {
      var c = A.props.inputValue;
      if (A.menuListRef && A.menuListRef.contains(document.activeElement)) {
        A.inputRef.focus();
        return;
      }
      A.props.onBlur && A.props.onBlur(a), A.onInputChange("", {
        action: "input-blur",
        prevInputValue: c
      }), A.onMenuClose(), A.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, A.onOptionHover = function(a) {
      if (!(A.blockOptionHover || A.state.focusedOption === a)) {
        var c = A.getFocusableOptions(), l = c.indexOf(a);
        A.setState({
          focusedOption: a,
          focusedOptionId: l > -1 ? A.getFocusedOptionId(a) : null
        });
      }
    }, A.shouldHideSelectedOptions = function() {
      return qM(A.props);
    }, A.onValueInputFocus = function(a) {
      a.preventDefault(), a.stopPropagation(), A.focus();
    }, A.onKeyDown = function(a) {
      var c = A.props, l = c.isMulti, u = c.backspaceRemovesValue, f = c.escapeClearsValue, d = c.inputValue, g = c.isClearable, m = c.isDisabled, p = c.menuIsOpen, v = c.onKeyDown, C = c.tabSelectsValue, w = c.openMenuOnFocus, B = A.state, y = B.focusedOption, b = B.focusedValue, q = B.selectValue;
      if (!m && !(typeof v == "function" && (v(a), a.defaultPrevented))) {
        switch (A.blockOptionHover = !0, a.key) {
          case "ArrowLeft":
            if (!l || d) return;
            A.focusValue("previous");
            break;
          case "ArrowRight":
            if (!l || d) return;
            A.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (d) return;
            if (b)
              A.removeValue(b);
            else {
              if (!u) return;
              l ? A.popValue() : g && A.clearValue();
            }
            break;
          case "Tab":
            if (A.isComposing || a.shiftKey || !p || !C || !y || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            w && A.isOptionSelected(y, q))
              return;
            A.selectOption(y);
            break;
          case "Enter":
            if (a.keyCode === 229)
              break;
            if (p) {
              if (!y || A.isComposing) return;
              A.selectOption(y);
              break;
            }
            return;
          case "Escape":
            p ? (A.setState({
              inputIsHiddenAfterUpdate: !1
            }), A.onInputChange("", {
              action: "menu-close",
              prevInputValue: d
            }), A.onMenuClose()) : g && f && A.clearValue();
            break;
          case " ":
            if (d)
              return;
            if (!p) {
              A.openMenu("first");
              break;
            }
            if (!y) return;
            A.selectOption(y);
            break;
          case "ArrowUp":
            p ? A.focusOption("up") : A.openMenu("last");
            break;
          case "ArrowDown":
            p ? A.focusOption("down") : A.openMenu("first");
            break;
          case "PageUp":
            if (!p) return;
            A.focusOption("pageup");
            break;
          case "PageDown":
            if (!p) return;
            A.focusOption("pagedown");
            break;
          case "Home":
            if (!p) return;
            A.focusOption("first");
            break;
          case "End":
            if (!p) return;
            A.focusOption("last");
            break;
          default:
            return;
        }
        a.preventDefault();
      }
    }, A.state.instancePrefix = "react-select-" + (A.props.instanceId || ++eoe), A.state.selectValue = Tb(n.value), n.menuIsOpen && A.state.selectValue.length) {
      var i = A.getFocusableOptionsWithIds(), o = A.buildFocusableOptions(), s = o.indexOf(A.state.selectValue[0]);
      A.state.focusableOptionsWithIds = i, A.state.focusedOption = o[s], A.state.focusedOptionId = Z9(i, o[s]);
    }
    return A;
  }
  return $te(r, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Mb(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(A) {
      var i = this.props, o = i.isDisabled, s = i.menuIsOpen, a = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (a && !o && A.isDisabled || // ensure focus is on the Input when the menu opens
      a && s && !A.menuIsOpen) && this.focusInput(), a && o && !A.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !a && !o && A.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Mb(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(A, i) {
      this.props.onInputChange(A, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(A) {
      var i = this, o = this.state, s = o.selectValue, a = o.isFocused, c = this.buildFocusableOptions(), l = A === "first" ? 0 : c.length - 1;
      if (!this.props.isMulti) {
        var u = c.indexOf(s[0]);
        u > -1 && (l = u);
      }
      this.scrollToFocusedOptionOnUpdate = !(a && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: c[l],
        focusedOptionId: this.getFocusedOptionId(c[l])
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(A) {
      var i = this.state, o = i.selectValue, s = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var a = o.indexOf(s);
        s || (a = -1);
        var c = o.length - 1, l = -1;
        if (o.length) {
          switch (A) {
            case "previous":
              a === 0 ? l = 0 : a === -1 ? l = c : l = a - 1;
              break;
            case "next":
              a > -1 && a < c && (l = a + 1);
              break;
          }
          this.setState({
            inputIsHidden: l !== -1,
            focusedValue: o[l]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, o = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var a = 0, c = s.indexOf(o);
        o || (c = -1), A === "up" ? a = c > 0 ? c - 1 : s.length - 1 : A === "down" ? a = (c + 1) % s.length : A === "pageup" ? (a = c - i, a < 0 && (a = 0)) : A === "pagedown" ? (a = c + i, a > s.length - 1 && (a = s.length - 1)) : A === "last" && (a = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[a],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[a])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(K9) : Nt(Nt({}, K9), this.props.theme) : K9;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var A = this.clearValue, i = this.cx, o = this.getStyles, s = this.getClassNames, a = this.getValue, c = this.selectOption, l = this.setValue, u = this.props, f = u.isMulti, d = u.isRtl, g = u.options, m = this.hasValue();
      return {
        clearValue: A,
        cx: i,
        getStyles: o,
        getClassNames: s,
        getValue: a,
        hasValue: m,
        isMulti: f,
        isRtl: d,
        options: g,
        selectOption: c,
        selectProps: u,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var A = this.state.selectValue;
      return A.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var A = this.props, i = A.isClearable, o = A.isMulti;
      return i === void 0 ? o : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(A, i) {
      return gM(this.props, A, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(A, i) {
      return mM(this.props, A, i);
    }
  }, {
    key: "filterOption",
    value: function(A, i) {
      return vM(this.props, A, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(A, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(A, {
          context: i,
          inputValue: o,
          selectValue: s
        });
      } else
        return this.getOptionLabel(A);
    }
  }, {
    key: "formatGroupLabel",
    value: function(A) {
      return this.props.formatGroupLabel(A);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var A = this.props, i = A.isDisabled, o = A.isSearchable, s = A.inputId, a = A.inputValue, c = A.tabIndex, l = A.form, u = A.menuIsOpen, f = A.required, d = this.getComponents(), g = d.Input, m = this.state, p = m.inputIsHidden, v = m.ariaSelection, C = this.commonProps, w = s || this.getElementId("input"), B = Nt(Nt(Nt({
          "aria-autocomplete": "list",
          "aria-expanded": u,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": f,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, u && {
          "aria-controls": this.getElementId("listbox")
        }), !o && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return o ? /* @__PURE__ */ ar.createElement(g, Gt({}, C, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: w,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: p,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: c,
          form: l,
          type: "text",
          value: a
        }, B)) : /* @__PURE__ */ ar.createElement(Bie, Gt({
          id: w,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: m3,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: c,
          inputMode: "none",
          form: l,
          value: ""
        }, B));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var A = this, i = this.getComponents(), o = i.MultiValue, s = i.MultiValueContainer, a = i.MultiValueLabel, c = i.MultiValueRemove, l = i.SingleValue, u = i.Placeholder, f = this.commonProps, d = this.props, g = d.controlShouldRenderValue, m = d.isDisabled, p = d.isMulti, v = d.inputValue, C = d.placeholder, w = this.state, B = w.selectValue, y = w.focusedValue, b = w.isFocused;
      if (!this.hasValue() || !g)
        return v ? null : /* @__PURE__ */ ar.createElement(u, Gt({}, f, {
          key: "placeholder",
          isDisabled: m,
          isFocused: b,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), C);
      if (p)
        return B.map(function(E, x) {
          var M = E === y, O = "".concat(A.getOptionLabel(E), "-").concat(A.getOptionValue(E));
          return /* @__PURE__ */ ar.createElement(o, Gt({}, f, {
            components: {
              Container: s,
              Label: a,
              Remove: c
            },
            isFocused: M,
            isDisabled: m,
            key: O,
            index: x,
            removeProps: {
              onClick: function() {
                return A.removeValue(E);
              },
              onTouchEnd: function() {
                return A.removeValue(E);
              },
              onMouseDown: function(S) {
                S.preventDefault();
              }
            },
            data: E
          }), A.formatOptionLabel(E, "value"));
        });
      if (v)
        return null;
      var q = B[0];
      return /* @__PURE__ */ ar.createElement(l, Gt({}, f, {
        data: q,
        isDisabled: m
      }), this.formatOptionLabel(q, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var A = this.getComponents(), i = A.ClearIndicator, o = this.commonProps, s = this.props, a = s.isDisabled, c = s.isLoading, l = this.state.isFocused;
      if (!this.isClearable() || !i || a || !this.hasValue() || c)
        return null;
      var u = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ ar.createElement(i, Gt({}, o, {
        innerProps: u,
        isFocused: l
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var A = this.getComponents(), i = A.LoadingIndicator, o = this.commonProps, s = this.props, a = s.isDisabled, c = s.isLoading, l = this.state.isFocused;
      if (!i || !c) return null;
      var u = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ ar.createElement(i, Gt({}, o, {
        innerProps: u,
        isDisabled: a,
        isFocused: l
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var A = this.getComponents(), i = A.DropdownIndicator, o = A.IndicatorSeparator;
      if (!i || !o) return null;
      var s = this.commonProps, a = this.props.isDisabled, c = this.state.isFocused;
      return /* @__PURE__ */ ar.createElement(o, Gt({}, s, {
        isDisabled: a,
        isFocused: c
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var A = this.getComponents(), i = A.DropdownIndicator;
      if (!i) return null;
      var o = this.commonProps, s = this.props.isDisabled, a = this.state.isFocused, c = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ ar.createElement(i, Gt({}, o, {
        innerProps: c,
        isDisabled: s,
        isFocused: a
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var A = this, i = this.getComponents(), o = i.Group, s = i.GroupHeading, a = i.Menu, c = i.MenuList, l = i.MenuPortal, u = i.LoadingMessage, f = i.NoOptionsMessage, d = i.Option, g = this.commonProps, m = this.state.focusedOption, p = this.props, v = p.captureMenuScroll, C = p.inputValue, w = p.isLoading, B = p.loadingMessage, y = p.minMenuHeight, b = p.maxMenuHeight, q = p.menuIsOpen, E = p.menuPlacement, x = p.menuPosition, M = p.menuPortalTarget, O = p.menuShouldBlockScroll, I = p.menuShouldScrollIntoView, S = p.noOptionsMessage, P = p.onMenuScrollToTop, H = p.onMenuScrollToBottom;
      if (!q) return null;
      var F = function(Z, W) {
        var R = Z.type, K = Z.data, L = Z.isDisabled, G = Z.isSelected, V = Z.label, _ = Z.value, J = m === K, X = L ? void 0 : function() {
          return A.onOptionHover(K);
        }, ne = L ? void 0 : function() {
          return A.selectOption(K);
        }, ee = "".concat(A.getElementId("option"), "-").concat(W), $ = {
          id: ee,
          onClick: ne,
          onMouseMove: X,
          onMouseOver: X,
          tabIndex: -1,
          role: "option",
          "aria-selected": A.isAppleDevice ? void 0 : G
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ ar.createElement(d, Gt({}, g, {
          innerProps: $,
          data: K,
          isDisabled: L,
          isSelected: G,
          key: ee,
          label: V,
          type: R,
          value: _,
          isFocused: J,
          innerRef: J ? A.getFocusedOptionRef : void 0
        }), A.formatOptionLabel(Z.data, "menu"));
      }, T;
      if (this.hasOptions())
        T = this.getCategorizedOptions().map(function(j) {
          if (j.type === "group") {
            var Z = j.data, W = j.options, R = j.index, K = "".concat(A.getElementId("group"), "-").concat(R), L = "".concat(K, "-heading");
            return /* @__PURE__ */ ar.createElement(o, Gt({}, g, {
              key: K,
              data: Z,
              options: W,
              Heading: s,
              headingProps: {
                id: L,
                data: j.data
              },
              label: A.formatGroupLabel(j.data)
            }), j.options.map(function(G) {
              return F(G, "".concat(R, "-").concat(G.index));
            }));
          } else if (j.type === "option")
            return F(j, "".concat(j.index));
        });
      else if (w) {
        var U = B({
          inputValue: C
        });
        if (U === null) return null;
        T = /* @__PURE__ */ ar.createElement(u, g, U);
      } else {
        var D = S({
          inputValue: C
        });
        if (D === null) return null;
        T = /* @__PURE__ */ ar.createElement(f, g, D);
      }
      var Q = {
        minMenuHeight: y,
        maxMenuHeight: b,
        menuPlacement: E,
        menuPosition: x,
        menuShouldScrollIntoView: I
      }, Y = /* @__PURE__ */ ar.createElement(eAe, Gt({}, g, Q), function(j) {
        var Z = j.ref, W = j.placerProps, R = W.placement, K = W.maxHeight;
        return /* @__PURE__ */ ar.createElement(a, Gt({}, g, Q, {
          innerRef: Z,
          innerProps: {
            onMouseDown: A.onMenuMouseDown,
            onMouseMove: A.onMenuMouseMove
          },
          isLoading: w,
          placement: R
        }), /* @__PURE__ */ ar.createElement(Oie, {
          captureEnabled: v,
          onTopArrive: P,
          onBottomArrive: H,
          lockEnabled: O
        }, function(L) {
          return /* @__PURE__ */ ar.createElement(c, Gt({}, g, {
            innerRef: function(V) {
              A.getMenuListRef(V), L(V);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": g.isMulti,
              id: A.getElementId("listbox")
            },
            isLoading: w,
            maxHeight: K,
            focusedOption: m
          }), T);
        }));
      });
      return M || x === "fixed" ? /* @__PURE__ */ ar.createElement(l, Gt({}, g, {
        appendTo: M,
        controlElement: this.controlRef,
        menuPlacement: E,
        menuPosition: x
      }), Y) : Y;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var A = this, i = this.props, o = i.delimiter, s = i.isDisabled, a = i.isMulti, c = i.name, l = i.required, u = this.state.selectValue;
      if (l && !this.hasValue() && !s)
        return /* @__PURE__ */ ar.createElement(Hie, {
          name: c,
          onFocus: this.onValueInputFocus
        });
      if (!(!c || s))
        if (a)
          if (o) {
            var f = u.map(function(m) {
              return A.getOptionValue(m);
            }).join(o);
            return /* @__PURE__ */ ar.createElement("input", {
              name: c,
              type: "hidden",
              value: f
            });
          } else {
            var d = u.length > 0 ? u.map(function(m, p) {
              return /* @__PURE__ */ ar.createElement("input", {
                key: "i-".concat(p),
                name: c,
                type: "hidden",
                value: A.getOptionValue(m)
              });
            }) : /* @__PURE__ */ ar.createElement("input", {
              name: c,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ ar.createElement("div", null, d);
          }
        else {
          var g = u[0] ? this.getOptionValue(u[0]) : "";
          return /* @__PURE__ */ ar.createElement("input", {
            name: c,
            type: "hidden",
            value: g
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var A = this.commonProps, i = this.state, o = i.ariaSelection, s = i.focusedOption, a = i.focusedValue, c = i.isFocused, l = i.selectValue, u = this.getFocusableOptions();
      return /* @__PURE__ */ ar.createElement(vie, Gt({}, A, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: s,
        focusedValue: a,
        isFocused: c,
        selectValue: l,
        focusableOptions: u,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var A = this.getComponents(), i = A.Control, o = A.IndicatorsContainer, s = A.SelectContainer, a = A.ValueContainer, c = this.props, l = c.className, u = c.id, f = c.isDisabled, d = c.menuIsOpen, g = this.state.isFocused, m = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ ar.createElement(s, Gt({}, m, {
        className: l,
        innerProps: {
          id: u,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: g
      }), this.renderLiveRegion(), /* @__PURE__ */ ar.createElement(i, Gt({}, m, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: f,
        isFocused: g,
        menuIsOpen: d
      }), /* @__PURE__ */ ar.createElement(a, Gt({}, m, {
        isDisabled: f
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ ar.createElement(o, Gt({}, m, {
        isDisabled: f
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(A, i) {
      var o = i.prevProps, s = i.clearFocusValueOnUpdate, a = i.inputIsHiddenAfterUpdate, c = i.ariaSelection, l = i.isFocused, u = i.prevWasFocused, f = i.instancePrefix, d = A.options, g = A.value, m = A.menuIsOpen, p = A.inputValue, v = A.isMulti, C = Tb(g), w = {};
      if (o && (g !== o.value || d !== o.options || m !== o.menuIsOpen || p !== o.inputValue)) {
        var B = m ? Jie(A, C) : [], y = m ? Xb(Bh(A, C), "".concat(f, "-option")) : [], b = s ? _ie(i, C) : null, q = $ie(i, B), E = Z9(y, q);
        w = {
          selectValue: C,
          focusedOption: q,
          focusedOptionId: E,
          focusableOptionsWithIds: y,
          focusedValue: b,
          clearFocusValueOnUpdate: !1
        };
      }
      var x = a != null && A !== o ? {
        inputIsHidden: a,
        inputIsHiddenAfterUpdate: void 0
      } : {}, M = c, O = l && u;
      return l && !O && (M = {
        value: qf(v, C, C[0] || null),
        options: C,
        action: "initial-input-focus"
      }, O = !u), (c == null ? void 0 : c.action) === "initial-input-focus" && (M = null), Nt(Nt(Nt({}, w), x), {}, {
        prevProps: A,
        ariaSelection: M,
        prevWasFocused: O
      });
    }
  }]), r;
}($p);
yM.defaultProps = Zie;
var toe = /* @__PURE__ */ ol(function(t, e) {
  var r = Jte(t);
  return /* @__PURE__ */ ar.createElement(yM, Gt({
    ref: e
  }, r));
}), Gv = toe;
const y3 = ({
  options: t,
  checked: e,
  onChange: r,
  style: n,
  selectedStyle: A = { accentColor: "#6525B3" },
  type: i,
  hoverBackground: o,
  key: s
}) => {
  Xe(ct.Context);
  const { themeManager: a } = Gs(), c = {
    ...n,
    flexDirection: i === "modal2" ? "column" : "row",
    gap: i === "modal2" ? "12px" : "8px"
  }, l = {
    control: (u) => ({
      ...u,
      background: (c == null ? void 0 : c.background) || (c == null ? void 0 : c.backgroundColor) || "transparent",
      fontSize: (c == null ? void 0 : c.fontSize) || "14px",
      border: `${(c == null ? void 0 : c.borderWidth) || "1px"} solid ${(c == null ? void 0 : c.borderColor) || (n == null ? void 0 : n.borderColor) || "var(--neutral-grey-100, #ECECEC)"}`,
      borderRadius: "10px",
      color: (c == null ? void 0 : c.color) || (n == null ? void 0 : n.color) || "black",
      fontFamily: (c == null ? void 0 : c.fontFamily) || (a == null ? void 0 : a.getFontFamily()) || "'Figtree', sans-serif",
      ...c
    }),
    option: (u, { isFocused: f }) => ({
      ...u,
      backgroundColor: f ? o || "#ADD8E6" : (c == null ? void 0 : c.background) || (c == null ? void 0 : c.backgroundColor) || "#f9fafb",
      color: (c == null ? void 0 : c.color) || "black",
      fontSize: (c == null ? void 0 : c.fontSize) || "14px",
      fontFamily: (c == null ? void 0 : c.fontFamily) || (a == null ? void 0 : a.getFontFamily()) || "'Figtree', sans-serif"
    }),
    menu: (u) => ({
      ...u,
      backgroundColor: (c == null ? void 0 : c.background) || (c == null ? void 0 : c.backgroundColor) || "#f9fafb"
    }),
    singleValue: (u) => ({
      ...u,
      color: (c == null ? void 0 : c.color) || (n == null ? void 0 : n.color) || "black",
      fontSize: (c == null ? void 0 : c.fontSize) || "14px",
      fontFamily: (c == null ? void 0 : c.fontFamily) || (a == null ? void 0 : a.getFontFamily()) || "'Figtree', sans-serif"
    })
  };
  return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
    Gv,
    {
      isSearchable: !0,
      name: "selectbox",
      options: t.map((u) => ({ value: u, label: u })),
      onChange: r,
      styles: l,
      value: e ? { value: e, label: e } : ""
    },
    s
  ) });
}, roe = ({ backgroundColor: t = "#6525B3", accentColor: e = "#6525B3" }) => /* @__PURE__ */ k("svg", { height: "18px", width: "18px", viewBox: "0 0 453 453", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", fill: "#000000", children: [
  /* @__PURE__ */ h("g", { id: "SVGRepo_bgCarrier", "stroke-width": "0" }),
  /* @__PURE__ */ h("g", { id: "SVGRepo_tracerCarrier", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ k("g", { id: "SVGRepo_iconCarrier", children: [
    " ",
    /* @__PURE__ */ k("g", { children: [
      " ",
      /* @__PURE__ */ k("g", { children: [
        " ",
        /* @__PURE__ */ k("g", { children: [
          " ",
          /* @__PURE__ */ h("path", { fill: t || e, d: "M0,0v452.986h452.986V0H0z M156.669,361.354L56.019,209.495l27.222-13.59l71.356,92.905 l224.315-197.2l18.874,22.649L156.669,361.354z" }),
          " "
        ] }),
        " "
      ] }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " "
    ] }),
    " "
  ] })
] }), C3 = ({
  options: t,
  checked: e,
  selectedStyle: r = { color: "#6525B3" },
  style: n,
  onChange: A = () => {
  },
  modalType: i = "",
  key: o
}) => {
  const s = (l) => {
    c(
      (u) => u.includes(t[l]) ? u.filter((d) => d !== t[l]) : [...u, t[l]]
    );
  }, [a, c] = N(e || []);
  return /* @__PURE__ */ h("div", { className: "q_multi_choice_box", children: t.map((l, u) => /* @__PURE__ */ k("div", { style: { ...n, borderColor: (a == null ? void 0 : a.includes(l)) && (r == null ? void 0 : r.borderColor) || (n == null ? void 0 : n.borderColor) }, className: "q_mult_choice_option", onClick: () => {
    s(u), A({ target: { value: l, checked: !a.includes(l) } });
  }, children: [
    a != null && a.includes(l) ? /* @__PURE__ */ h(roe, { backgroundColor: r == null ? void 0 : r.accentColor, accentColor: r == null ? void 0 : r.accentColor }) : /* @__PURE__ */ h("div", { className: "q_check_box_off" }),
    /* @__PURE__ */ h("p", { className: "q_mult_choice_option_selected", style: a != null && a.includes(l) ? r : n, children: l })
  ] }, u)) });
}, w3 = ({
  options: t,
  checked: e,
  selectedStyle: r = { color: "#6525B3" },
  style: n,
  onChange: A = () => {
  },
  modalType: i = "",
  key: o
}) => {
  const s = (l) => {
    c(
      (u) => u.includes(t[l]) ? u.filter((d) => d !== t[l]) : [...u, t[l]]
    );
  }, [a, c] = N(e || []);
  return /* @__PURE__ */ h("div", { className: "q_multi_choice_box_2", children: t.map((l, u) => /* @__PURE__ */ h(
    "div",
    {
      style: { ...a != null && a.includes(l) ? r : n },
      className: a != null && a.includes(l) ? "q_mult_choice_option_2_select" : "q_mult_choice_option_2",
      onClick: () => {
        s(u), A({ target: { value: l, checked: !a.includes(l) } });
      },
      children: l
    },
    u
  )) }, o);
}, CM = () => {
  const {
    design: t,
    // designState,
    formdata: e,
    progress: r,
    progressBarMultiLine: n,
    template: A,
    controlBtnType: i,
    uiProps: o,
    nextBtnText: s,
    // btnFlag,
    returnAnswers: a,
    answer: c,
    checkValidationValues: l,
    // handleUpdate,
    validateInputRegex: u,
    themeManager: f,
    // validationData,
    currentPage: d = 0,
    setCurrentPage: g,
    handleUpdate: m,
    ProgressBar: p,
    questionTemplate: v,
    btnFlag: C,
    designState: w,
    onboardingGetPropsFunctions: B
  } = Gs(), { apiType: y } = Xe(ct.Context);
  let b = new Bt("mixpanel", y);
  return le(() => {
    w && d >= w.length && w.length > 0 && g && g(w.length - 1);
  }, [w, d, g]), /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "q-onb-main-first", children: [
    v === "multi-question" && e.length > 0 && w.length > 1 && !!(r != null && r.length) && /* @__PURE__ */ h(p, {}),
    w && w.length > 0 ? w[d].map(
      (q, E) => {
        var x, M, O, I, S, P, H, F, T, U, D, Q, Y, j, Z, W, R, K, L, G, V, _, J, X, ne, ee, $, te, ae, se, ue, fe, ve, ge, oe, ce, pe, qe, Se, Te, be, He, Ge, Le, Ae, Pe, it, de, xe, he, Qe, Re, pt, ze, lt, st;
        return ((x = e[q - 1]) == null ? void 0 : x.type) == "USER_INPUT_TEXT" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((M = e[q - 1]) == null ? void 0 : M.question) || ""} ${(O = e[q - 1]) != null && O.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Hi,
            {
              placeholder: ((I = e[q - 1]) == null ? void 0 : I.placeholder) || ((S = e[q - 1]) == null ? void 0 : S.question) || "",
              value: c[e[q - 1].actionId || ""],
              validateInputRegex: (We) => u(We, e[q - 1].actionId),
              errorText: f.getTextInputErrorText(),
              textErrorStyle: f.getTextInputErrorStyles(),
              regexKey: (P = e[q - 1]) == null ? void 0 : P.regexKey,
              regexMessage: (H = e[q - 1]) == null ? void 0 : H.regexMessage,
              onChange: (We) => m(We, e[q - 1].actionId || "", ""),
              style: f.getTextInputStyles(),
              name: `input-${(F = w == null ? void 0 : w[d]) == null ? void 0 : F[E]}`
            },
            e[q - 1].actionId
          )
        ] }, E) : ((T = e[q - 1]) == null ? void 0 : T.type) == "USER_INPUT_EMAIL" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((U = e[q - 1]) == null ? void 0 : U.question) || ""} ${(D = e[q - 1]) != null && D.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Fu,
            {
              placeholder: ((Q = e[q - 1]) == null ? void 0 : Q.placeholder) || ((Y = e[q - 1]) == null ? void 0 : Y.question) || "",
              value: c[e[q - 1].actionId || ""],
              iconColor: f.getEmailIconColor(),
              validateInputRegex: (We) => u(We, e[q - 1].actionId),
              regexKey: (j = e[q - 1]) == null ? void 0 : j.regexKey,
              regexMessage: (Z = e[q - 1]) == null ? void 0 : Z.regexMessage,
              onChange: (We) => m(We, e[q - 1].actionId || "", ""),
              style: f.getTextInputStyles(),
              emailtext: f.getEmailInputErrorText(),
              emailErrorStyle: f.getEMailInputErrorStyles(),
              name: `input-${(W = w == null ? void 0 : w[d]) == null ? void 0 : W[E]}`
            },
            e[q - 1].actionId
          )
        ] }, E) : ((R = e[q - 1]) == null ? void 0 : R.type) == "USER_INPUT_PHONE" || ((K = e[q - 1]) == null ? void 0 : K.type) == "USER_INPUT_NUMBER" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((L = e[q - 1]) == null ? void 0 : L.question) || ""} ${(G = e[q - 1]) != null && G.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Tu,
            {
              placeholder: ((V = e[q - 1]) == null ? void 0 : V.placeholder) || ((_ = e[q - 1]) == null ? void 0 : _.question) || "",
              value: c[e[q - 1].actionId || ""],
              iconColor: f.getEmailIconColor(),
              validateInputRegex: (We) => u(We, e[q - 1].actionId),
              numbertext: f.getNumberInputErrorText(),
              numberErrorStyle: f.getNumberInputErrorStyles(),
              regexKey: (J = e[q - 1]) == null ? void 0 : J.regexKey,
              regexMessage: (X = e[q - 1]) == null ? void 0 : X.regexMessage,
              onChange: (We) => m(We, e[q - 1].actionId || "", ""),
              style: f.getTextInputStyles(),
              name: `input-${(ne = w == null ? void 0 : w[d]) == null ? void 0 : ne[E]}`
            },
            (ee = e[q - 1]) == null ? void 0 : ee.actionId
          )
        ] }, E) : (($ = e[q - 1]) == null ? void 0 : $.type) == "USER_INPUT_TEXTAREA" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((te = e[q - 1]) == null ? void 0 : te.question) || ""} ${(ae = e[q - 1]) != null && ae.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Mu,
            {
              value: c[e[q - 1].actionId || ""],
              onChange: (We) => m(We, e[q - 1].actionId || "", ""),
              style: f.getTextAreaInputStyles(),
              validateInputRegex: (We) => u(We, e[q - 1].actionId),
              textareatext: f.getTextAreaInputErrorText(),
              textareaErrorStyle: f.getTextAreaInputErrorStyles(),
              placeholder: ((se = e[q - 1]) == null ? void 0 : se.placeholder) || ((ue = e[q - 1]) == null ? void 0 : ue.question) || ""
            },
            (fe = e[q - 1]) == null ? void 0 : fe.actionId
          )
        ] }, E) : ((ve = e[q - 1]) == null ? void 0 : ve.type) == "USER_INPUT_DATE" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((ge = e[q - 1]) == null ? void 0 : ge.question) || ""} ${(oe = e[q - 1]) != null && oe.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Hu,
            {
              placeholder: ((ce = e[q - 1]) == null ? void 0 : ce.placeholder) || ((pe = e[q - 1]) == null ? void 0 : pe.question) || "",
              value: c[e[q - 1].actionId || ""],
              onChange: (We) => m(We, e[q - 1].actionId || "", ""),
              iconColor: f.getEmailIconColor(),
              style: f.getTextInputStyles(),
              preventFutureSelection: !1,
              preventPastSelection: !1,
              minDate: "",
              maxDate: ""
            },
            e[q - 1].actionId
          )
        ] }, E) : ((qe = e[q - 1]) == null ? void 0 : qe.type) == "USER_INPUT_SINGLE_CHOICE" ? B.getSingleChoose() && (B.getSingleChoose() === "modal1" || B.getSingleChoose() === "modal2") ? (
          // for modal 1 or 2
          /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${((Se = e[q - 1]) == null ? void 0 : Se.question) || ""} ${(Te = e[q - 1]) != null && Te.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              u3,
              {
                options: e[q - 1].options || [],
                type: B.getSingleChoose(),
                onChange: (We) => m(
                  We,
                  e[q - 1].actionId || "",
                  "radio"
                ),
                checked: c[e[q - 1].actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              (be = e[q - 1]) == null ? void 0 : be.actionId
            ),
            ((He = e[q - 1]) == null ? void 0 : He.manualInput) != !1 && c[e[q - 1].actionId || ""] == ((Ge = e[q - 1]) == null ? void 0 : Ge.manualInput) && /* @__PURE__ */ h(
              Hi,
              {
                type: "text",
                onChange: (We) => m(
                  We,
                  e[q - 1].actionId || "/manual",
                  ""
                ),
                value: c[e[q - 1].actionId || "/manual"],
                placeholder: "Please fill manually",
                style: f.getTextInputStyles()
              },
              (Le = e[q - 1]) == null ? void 0 : Le.actionId
            )
          ] }, E)
        ) : (
          // for modal 3
          /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${((Ae = e[q - 1]) == null ? void 0 : Ae.question) || ""} ${(Pe = e[q - 1]) != null && Pe.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              y3,
              {
                options: e[q - 1].options || [],
                type: B.getSingleChoose(),
                onChange: (We) => m(
                  { target: We },
                  e[q - 1].actionId || "",
                  ""
                ),
                checked: c[e[q - 1].actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              (it = e[q - 1]) == null ? void 0 : it.actionId
            ),
            ((de = e[q - 1]) == null ? void 0 : de.manualInput) != !1 && c[e[q - 1].actionId || ""] == ((xe = e[q - 1]) == null ? void 0 : xe.manualInput) && /* @__PURE__ */ h(
              Hi,
              {
                type: "text",
                onChange: (We) => m(
                  We,
                  e[q - 1].actionId || "/manual",
                  ""
                ),
                value: c[e[q - 1].actionId || "/manual"],
                placeholder: "Please fill manually",
                style: f.getTextInputStyles()
              }
            )
          ] }, E)
        ) : ((he = e[q - 1]) == null ? void 0 : he.type) == "USER_INPUT_MULTI_CHOICE" ? B.getMultiChoice() && B.getMultiChoice() == "modal2" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((Qe = e[q - 1]) == null ? void 0 : Qe.question) || ""} ${(Re = e[q - 1]) != null && Re.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            w3,
            {
              options: e[q - 1].options || [],
              checked: !!c[e[q - 1].actionId || ""] && c[e[q - 1].actionId || ""],
              onChange: (We) => m(
                We,
                e[q - 1].actionId || "",
                "check"
              ),
              modalType: B.getMultiChoice(),
              style: f.getMultiChoiceStyles(),
              selectedStyle: f.getMultiChoiceSelectedStyles("modal2")
            },
            (pt = e[q - 1]) == null ? void 0 : pt.actionId
          )
        ] }, E) : /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${((ze = e[q - 1]) == null ? void 0 : ze.question) || ""} ${(lt = e[q - 1]) != null && lt.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            C3,
            {
              options: e[q - 1].options || [],
              checked: !!c[e[q - 1].actionId || ""] && c[e[q - 1].actionId || ""],
              onChange: (We) => m(
                We,
                e[q - 1].actionId || "",
                "check"
              ),
              modalType: B.getMultiChoice(),
              style: f.getMultiChoiceStyles(),
              selectedStyle: f.getMultiChoiceSelectedStyles("modal1")
            },
            (st = e[q - 1]) == null ? void 0 : st.actionId
          )
        ] }, E) : null;
      }
    ) : e == null ? void 0 : e.map(
      (q, E) => {
        var x, M, O;
        return q.type == "USER_INPUT_TEXT" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Hi,
            {
              placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
              value: c[(q == null ? void 0 : q.actionId) || ""],
              regexKey: q == null ? void 0 : q.regexKey,
              regexMessage: q == null ? void 0 : q.regexMessage,
              validateInputRegex: (I) => u(I, q.actionId),
              errorText: f.getTextInputErrorText(),
              textErrorStyle: f.getTextInputErrorStyles(),
              onChange: (I) => m(I, q.actionId || "", ""),
              style: f.getTextInputStyles(),
              name: `input-${(x = w == null ? void 0 : w[d]) == null ? void 0 : x[E]}`
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : q.type == "USER_INPUT_EMAIL" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Fu,
            {
              placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
              value: c[(q == null ? void 0 : q.actionId) || ""],
              iconColor: f.getEmailIconColor(),
              validateInputRegex: (I) => u(I, q.actionId),
              regexKey: q == null ? void 0 : q.regexKey,
              regexMessage: q == null ? void 0 : q.regexMessage,
              onChange: (I) => m(I, q.actionId || "", ""),
              style: f.getTextInputStyles(),
              emailtext: f.getEmailInputErrorText(),
              emailErrorStyle: f.getEMailInputErrorStyles(),
              name: `input-${(M = w == null ? void 0 : w[d]) == null ? void 0 : M[E]}`
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : q.type == "USER_INPUT_PHONE" || q.type == "USER_INPUT_NUMBER" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Tu,
            {
              placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
              value: c[q.actionId || ""],
              iconColor: f.getEmailIconColor(),
              validateInputRegex: (I) => u(I, q.actionId),
              regexKey: q == null ? void 0 : q.regexKey,
              regexMessage: q == null ? void 0 : q.regexMessage,
              onChange: (I) => m(I, q.actionId || "", ""),
              style: f.getTextInputStyles(),
              numbertext: f.getNumberInputErrorText(),
              numberErrorStyle: f.getNumberInputErrorStyles(),
              name: `input-${(O = w == null ? void 0 : w[d]) == null ? void 0 : O[E]}`
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : q.type == "USER_INPUT_TEXTAREA" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${(q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || ""}`
            }
          ),
          /* @__PURE__ */ h(
            Mu,
            {
              value: c[q.actionId || ""],
              onChange: (I) => m(I, q.actionId || "", ""),
              style: f.getTextAreaInputStyles(),
              textareatext: f.getTextAreaInputErrorText(),
              textareaErrorStyle: f.getTextAreaInputErrorStyles(),
              validateInputRegex: (I) => u(I, q.actionId),
              placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || ""
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : q.type == "USER_INPUT_DATE" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            Hu,
            {
              type: "date",
              placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
              value: c[q.actionId || ""],
              onChange: (I) => m(I, q.actionId || "", ""),
              iconColor: f.getEmailIconColor(),
              style: f.getTextInputStyles(),
              preventFutureSelection: !0,
              preventPastSelection: !0,
              minDate: "",
              maxDate: ""
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : q.type == "USER_INPUT_SINGLE_CHOICE" ? B.getSingleChoose() && (B.getSingleChoose() === "modal1" || B.getSingleChoose() === "modal2") ? (
          // for modal 1 or 2
          /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              u3,
              {
                options: q.options || [],
                type: B.getSingleChoose(),
                onChange: (I) => m(I, q.actionId || "", "radio"),
                checked: c[q.actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              q == null ? void 0 : q.actionId
            ),
            (q == null ? void 0 : q.manualInput) != !1 && c[q.actionId || ""] == (q == null ? void 0 : q.manualInput) && /* @__PURE__ */ h(
              Hi,
              {
                type: "text",
                onChange: (I) => m(I, q.actionId || "/manual", ""),
                value: c[q.actionId || "/manual"],
                placeholder: "Please fill manually",
                style: f.getTextInputStyles()
              },
              q == null ? void 0 : q.actionId
            )
          ] })
        ) : /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            y3,
            {
              options: q.options || [],
              type: B.getSingleChoose(),
              onChange: (I) => m({ target: I }, q.actionId || "", ""),
              checked: c[q.actionId || ""],
              style: f.getSingleChoiceStyles(),
              hoverBackground: f.getSingleChoiceHoverBackground(),
              selectedStyle: f.getSingleChoiceSelectedStyles()
            },
            q == null ? void 0 : q.actionId
          ),
          (q == null ? void 0 : q.manualInput) != !1 && c[q.actionId || ""] == (q == null ? void 0 : q.manualInput) && /* @__PURE__ */ h(
            Hi,
            {
              type: "text",
              onChange: (I) => m(I, q.actionId || "/manual", ""),
              value: c[q.actionId || "/manual"],
              placeholder: "Please fill manually",
              style: f.getTextInputStyles()
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : q.type == "USER_INPUT_MULTI_CHOICE" ? B.getMultiChoice() && B.getMultiChoice() == "modal2" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            w3,
            {
              options: q.options || [],
              checked: !!c[q.actionId || ""] && c[q.actionId || ""],
              onChange: (I) => m(I, q.actionId || "", "check"),
              modalType: B.getMultiChoice(),
              style: f.getMultiChoiceStyles(),
              selectedStyle: f.getMultiChoiceSelectedStyles("modal2")
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
          /* @__PURE__ */ h(
            Kt,
            {
              htmlFor: "",
              style: f.getLabelStyles(),
              children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
            }
          ),
          /* @__PURE__ */ h(
            C3,
            {
              options: q.options || [],
              checked: !!c[q.actionId || ""] && c[q.actionId || ""],
              onChange: (I) => m(I, q.actionId || "", "check"),
              modalType: B.getMultiChoice(),
              style: f.getMultiChoiceStyles(),
              selectedStyle: f.getMultiChoiceSelectedStyles("modal1")
            },
            q == null ? void 0 : q.actionId
          )
        ] }) : null;
      }
    ),
    e && e.length > 0 && (w && w.length > 1 ? i == "Buttons" || (o == null ? void 0 : o.controlBtnType) === "Buttons" ? /* @__PURE__ */ k("div", { className: "q-onb-main-criteria", children: [
      d > 0 && /* @__PURE__ */ h(
        JA,
        {
          style: {
            opacity: d == 0 ? "0" : "1",
            cursor: d == 0 ? "context-menu" : "pointer",
            // borderColor:
            //     styleConfig?.SecondaryButton?.borderColor ||
            //     themeConfig?.borderColor,
            // background:
            //     styleConfig?.SecondaryButton?.backgroundColor || BrandTheme?.secondaryButton ||
            //     themeConfig?.backgroundColor,
            // color:
            //     styleConfig?.SecondaryButton?.color ||
            //     themeConfig?.primaryColor,
            // ...styleConfig?.SecondaryButton,
            borderColor: f.getSecondaryButtonStyles().borderColor,
            background: f.getSecondaryButtonStyles().background,
            color: f.getSecondaryButtonStyles().color,
            ...f.getSecondaryButtonStyles()
          },
          className: "q-onb-main-btn",
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_secondary_btn_clicked",
              "onboarding"
            ), d > 0 && g && g(d - 1);
          },
          children: "Previous"
        }
      ),
      /* @__PURE__ */ h(
        yr,
        {
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), l && l() && (b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), d !== w.length - 1 ? g && g(d + 1) : a && a());
          },
          type: "submit",
          disabled: !C || !(l && l()),
          className: "q-onb-main-btn2",
          style: {
            // background:
            //     styleConfig?.PrimaryButton?.background ||
            //     questThemeData?.buttonColor ||
            //     BrandTheme?.primaryButton ||
            //     themeConfig?.buttonColor,
            // ...styleConfig?.PrimaryButton,
            background: f.getPrimaryButtonStyles().background,
            ...f.getPrimaryButtonStyles()
          },
          children: d == w.length - 1 ? s || "Submit" : "Continue"
        }
      )
    ] }) : /* @__PURE__ */ k("div", { className: "q-onb-main-arrow-div", children: [
      /* @__PURE__ */ h(
        JA,
        {
          className: "q-onb-main-arrow",
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_secondary_btn_clicked",
              "onboarding"
            ), d > 0 && g && g(d - 1);
          },
          style: {
            opacity: d == 0 ? "0" : "1",
            cursor: d == 0 ? "context-menu" : "pointer",
            height: f.getSecondaryButtonAeroStyles().height,
            width: f.getSecondaryButtonAeroStyles().width,
            borderRadius: f.getSecondaryButtonAeroStyles().borderRadius,
            padding: f.getSecondaryButtonAeroStyles().padding,
            border: f.getSecondaryButtonAeroStyles().border || "1.5px solid #afafaf",
            borderColor: f.getSecondaryButtonAeroStyles().borderColor,
            backgroundColor: f.getSecondaryButtonAeroStyles().backgroundColor,
            color: f.getSecondaryButtonAeroStyles().color,
            ...f.getSecondaryButtonAeroStyles()
          },
          children: gT()
        }
      ),
      /* @__PURE__ */ h(
        yr,
        {
          className: "q-onb-main-arrow2",
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), l && l() && (b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), d !== w.length - 1 ? g && g(d + 1) : a && a());
          },
          type: "submit",
          disabled: !C || !(l && l()),
          style: {
            // height: styleConfig?.PrimaryButton?.height || "44px",
            // width: styleConfig?.PrimaryButton?.width || "44px",
            // borderRadius:
            //     styleConfig?.PrimaryButton?.borderRadius || "50%",
            // padding: styleConfig?.PrimaryButton?.padding || "10px",
            // border:
            //     styleConfig?.PrimaryButton?.border ||
            //     "1.5px solid #D1ACFF",
            // background:
            //     styleConfig?.PrimaryButton?.background ||
            //     questThemeData?.buttonColor ||
            //     BrandTheme?.primaryButton ||
            //     themeConfig?.buttonColor,
            // ...styleConfig?.PrimaryButton,
            height: f.getPrimaryButtonAeroStyles().height,
            width: f.getPrimaryButtonAeroStyles().width,
            borderRadius: f.getPrimaryButtonAeroStyles().borderRadius,
            padding: f.getPrimaryButtonAeroStyles().padding,
            border: f.getPrimaryButtonAeroStyles().border || "1.5px solid #D1ACFF",
            borderColor: f.getSecondaryButtonAeroStyles().borderColor,
            background: f.getPrimaryButtonAeroStyles().background,
            ...f.getPrimaryButtonAeroStyles()
          },
          children: pT()
        }
      )
    ] }) : /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
      yr,
      {
        className: "q-onb-main-btn3",
        onClick: () => {
          b.fireTrackingEvent(
            "quest_onboarding_single_page_submit_button_clicked",
            "onboarding"
          ), l && l() && (b.fireTrackingEvent(
            "quest_onboarding_primary_btn_clicked",
            "onboarding"
          ), d !== w.length - 1 ? g && g(d + 1) : a && a());
        },
        type: "submit",
        disabled: !C || !(l && l()),
        style: {
          // border:
          //     styleConfig?.SecondaryButton?.border ||
          //     "1.5px solid #afafaf",
          // background:
          //     styleConfig?.PrimaryButton?.background ||
          //     questThemeData?.buttonColor ||
          //     BrandTheme?.primaryButton ||
          //     themeConfig?.buttonColor,
          // ...styleConfig?.PrimaryButton,
          border: f.getNormalButtonStyles().border,
          background: f.getNormalButtonStyles().background,
          ...f.getNormalButtonStyles()
        },
        children: s || "Continue"
      }
    ) }))
  ] }) });
}, s4 = ({
  formdata: t,
  showFooter: e,
  showPoweredBy: r = !0,
  ...n
}) => {
  var i, o, s, a, c;
  const { themeManager: A } = Gs();
  return /* @__PURE__ */ h(Ze, { children: t && e && /* @__PURE__ */ h(
    Pr,
    {
      style: (i = A == null ? void 0 : A.getOnboardingFooterStyles()) == null ? void 0 : i.FooterStyle,
      textStyle: (o = A == null ? void 0 : A.getOnboardingFooterStyles()) == null ? void 0 : o.FooterTextStyle,
      iconStyle: (s = A == null ? void 0 : A.getOnboardingFooterStyles()) == null ? void 0 : s.FooterIcon,
      text: (a = A == null ? void 0 : A.getOnboardingFooterStyles()) == null ? void 0 : a.FooterText,
      link: (c = A == null ? void 0 : A.getOnboardingFooterStyles()) == null ? void 0 : c.FooterLink
    }
  ) });
}, I2 = {
  accentColor: "",
  theme: "",
  borderRadius: "",
  buttonColor: "",
  images: []
}, b3 = {
  accentColor: "",
  background: "",
  borderRadius: "",
  primaryButton: "",
  contentColor: "",
  fontFamily: "",
  logo: "",
  primaryColor: "",
  secondaryColor: "",
  tertiaryColor: "",
  titleColor: ""
};
let noe = class {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    ke(this, "metricApi", (e, r, n, A, i, o) => {
      const s = async (a) => {
        try {
          const c = `${r}api/entities/${n}/metrics/${a}/campaign`, l = await Oe.post(c, { campaignId: A, campaignVariationId: i, ...o }, { headers: e });
          if (l.status === 200 && l.data.success)
            return l;
        } catch (c) {
          c.response && c.response.data && c.response.data.error ? console.error("API request failed:", c.response.data.error) : console.error("API request failed:", c.message);
        }
      };
      return {
        async view() {
          return s("onboarding-view");
        },
        async page(a) {
          return s(`onboarding-complete-page-${a}`);
        },
        async complete() {
          return s("onboarding-complete");
        }
      };
    });
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a == n || a == A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosHeaders({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          { headers: u }
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, { path: "/", expires: p }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), null;
    }
  }
  async fetchCampaignData(e, r, n, A) {
    var i;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const o = new URLSearchParams();
      o.set("platform", "REACT"), A && o.set("variation", A);
      const s = this.getAxiosHeaders(n), a = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${o.toString()}`, c = await Oe.get(a, {
        headers: s
      });
      if (!((i = c.data) != null && i.data))
        throw new Error("No data received from API");
      return c.data.data;
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
  async verifyAction(e, r, n, A, i) {
    var o;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const s = {
        actions: [
          {
            answers: [],
            actionId: A
          }
        ],
        campaignVariationId: i
      }, a = this.getAxiosHeaders(n), c = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/verify`, l = await Oe.post(
        c,
        s,
        { headers: a }
      );
      if (!((o = l.data) != null && o.data))
        throw new Error("Invalid response from verify action");
      return l.data.data;
    } catch (s) {
      throw this.GeneralFunctions.captureSentryException(s), s;
    }
  }
  processActionsData(e) {
    return e.map((r) => {
      var n, A, i, o, s, a, c, l;
      return {
        type: r.actionType,
        question: r.title,
        options: r.options || [],
        actionId: r.actionId,
        required: r.isRequired,
        placeholder: (n = r.metadata) == null ? void 0 : n.placeholder,
        linkTitle: r.title || "",
        linkUrl: ((A = r.metadata) == null ? void 0 : A.link) || "",
        manualInput: !!((i = r.metadata) != null && i.manualInput),
        ...((o = r.metadata) == null ? void 0 : o.regexKey) && { regexKey: (s = r.metadata) == null ? void 0 : s.regexKey },
        ...((a = r.metadata) == null ? void 0 : a.regexErrorMessage) && { regexMessage: (c = r.metadata) == null ? void 0 : c.regexErrorMessage },
        ...r.metadata.modelType && { modelType: (l = r == null ? void 0 : r.metadata) == null ? void 0 : l.modelType }
      };
    });
  }
  clearCookies() {
    this.cookies.remove("externalUserId", { path: "/" }), this.cookies.remove("questUserId", { path: "/" }), this.cookies.remove("questUserToken", { path: "/" });
  }
  isValidUserAuth(e) {
    return !!e && typeof e.userId == "string" && typeof e.token == "string";
  }
  // verifyCampaigns = (BACKEND_URL: string, entityId: string, campaignId: string, campaignVariationId: string, headers: any, body?: { [key: string]: any },) => {
  //     try {
  //         const url = `${BACKEND_URL}api/entities/${entityId}/metrics/${page}/campaign`;
  //         const response = await axios.post(url, { campaignId, campaignVariationId, ...body }, { headers });
  //         if (response.status === 200 && response.data.success) {
  //             return response;
  //         }
  //         // else {
  //         //   throw new Error(response.statusText);
  //         // }
  //     } catch (error: any) {
  //         if (error.response && error.response.data && error.response.data.error) {
  //             console.error('API request failed:', error.response.data.error);
  //         } else {
  //             console.error('API request failed:', error.message);
  //         }
  //         // throw error;
  //     }
  // };
};
class wM {
  constructor(e = {}, r = {}, n = I2, A = b3) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = { ...I2, ...n }, this.brandTheme = { ...b3, ...A };
  }
  // done
  getStyleValueAsString(e, r = "") {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "string" ? A : r;
  }
  // done
  getStyleValueAsObject(e, r) {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "object" ? A : r;
  }
  // done
  getContainerStyles() {
    var e;
    return {
      background: this.getBackgroundColor(),
      height: this.getStyleValueAsString("Form.height", "auto"),
      borderRadius: this.getBorderRadius(),
      fontFamily: this.getFontFamily(),
      ...(e = this.styleConfig) == null ? void 0 : e.Form
    };
  }
  // done
  getTopBarStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      headingStyle: {
        color: this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.titleColor) || ((r = this.brandTheme) == null ? void 0 : r.primaryColor) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor) || "#000000",
        ...(A = this.styleConfig) == null ? void 0 : A.Heading
      },
      subHeadingStyle: {
        color: this.getStyleValueAsString("Description.color") || ((i = this.brandTheme) == null ? void 0 : i.secondaryColor) || ((o = this.themeConfig) == null ? void 0 : o.secondaryColor) || "#666666",
        ...(s = this.styleConfig) == null ? void 0 : s.Description
      },
      topbarStyle: {
        ...(a = this.styleConfig) == null ? void 0 : a.Topbar
      }
    };
  }
  // done
  getLabelStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Label) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Label
    };
  }
  // done
  getTextInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.TextError) == null ? void 0 : r.text) || "Invalid text format";
  }
  // done
  getTextInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.TextError) == null ? void 0 : r.errorStyle
    };
  }
  // done
  getTextInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.borderColor,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.Input) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.Input
    };
  }
  // done
  getEmailIconColor() {
    var e, r, n, A;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.color) || ((n = this == null ? void 0 : this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this == null ? void 0 : this.themeConfig) == null ? void 0 : A.primaryColor) || "#B9B9B9";
  }
  // done
  getEmailInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) || "Invalid text format";
  }
  // done
  getEMailInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.errorStyle
    };
  }
  // done
  getNumberInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.NumberError) == null ? void 0 : r.text) || "Invalid text format";
  }
  // done
  getNumberInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.NumberError) == null ? void 0 : r.errorStyle
    };
  }
  // done
  getTextAreaInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.TextArea) == null ? void 0 : r.borderColor,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.TextArea) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.TextArea
    };
  }
  // done
  getTextAreaInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.TextAreaError) == null ? void 0 : r.text) || "Invalid text format";
  }
  // done
  getTextAreaInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.TextAreaError) == null ? void 0 : r.errorStyle
    };
  }
  // for single choice 
  // done
  getSingleChoiceStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      borderColor: (n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.style) == null ? void 0 : n.borderColor,
      color: ((o = (i = (A = this.styleConfig) == null ? void 0 : A.SingleChoice) == null ? void 0 : i.style) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor) || ((a = this.themeConfig) == null ? void 0 : a.primaryColor),
      ...(l = (c = this.styleConfig) == null ? void 0 : c.SingleChoice) == null ? void 0 : l.style
    };
  }
  // done
  getSingleChoiceHoverBackground() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.hoverBackground;
  }
  // done
  getSingleChoiceSelectedStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      accentColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.accentColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || ((i = this.brandTheme) == null ? void 0 : i.accentColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(a = (s = this.styleConfig) == null ? void 0 : s.SingleChoice) == null ? void 0 : a.selectedStyle
    };
  }
  // for muli chice 
  // done
  getMultiChoiceStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      borderColor: (n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.style) == null ? void 0 : n.borderColor,
      color: ((o = (i = (A = this.styleConfig) == null ? void 0 : A.MultiChoice) == null ? void 0 : i.style) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor) || ((a = this.themeConfig) == null ? void 0 : a.primaryColor),
      ...(l = (c = this.styleConfig) == null ? void 0 : c.MultiChoice) == null ? void 0 : l.style
    };
  }
  // done
  getMultiChoiceSelectedStyles(e) {
    var r, n, A, i, o, s, a, c, l, u;
    return {
      color: ((A = (n = (r = this.styleConfig) == null ? void 0 : r.MultiChoice) == null ? void 0 : n.selectedStyle) == null ? void 0 : A.accentColor) || e == "modal1" && ((i = this.questThemeData) == null ? void 0 : i.accentColor) || e == "modal1" && ((o = this.brandTheme) == null ? void 0 : o.accentColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor),
      backgroundColor: e == "model1" && ((a = this.questThemeData) == null ? void 0 : a.accentColor),
      background: e == "modal2" && ((c = this.questThemeData) == null ? void 0 : c.accentColor),
      ...(u = (l = this.styleConfig) == null ? void 0 : l.MultiChoice) == null ? void 0 : u.selectedStyle
    };
  }
  // done
  getFontFamily() {
    var e, r;
    return ((e = this.brandTheme) == null ? void 0 : e.fontFamily) || ((r = this.themeConfig) == null ? void 0 : r.fontFamily) || "'Arial', sans-serif";
  }
  // npt in use
  getBackgroundColor() {
    var e, r;
    return this.getStyleValueAsString("Form.backgroundColor", "") || ((e = this.brandTheme) == null ? void 0 : e.background) || ((r = this.themeConfig) == null ? void 0 : r.backgroundColor) || "#FFFFFF";
  }
  // done
  getSecondaryButtonStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.SecondaryButton) == null ? void 0 : r.borderColor,
      background: ((A = (n = this.styleConfig) == null ? void 0 : n.SecondaryButton) == null ? void 0 : A.backgroundColor) || ((i = this.brandTheme) == null ? void 0 : i.secondaryButton) || ((o = this.themeConfig) == null ? void 0 : o.backgroundColor),
      color: ((a = (s = this.styleConfig) == null ? void 0 : s.SecondaryButton) == null ? void 0 : a.color) || ((c = this.themeConfig) == null ? void 0 : c.primaryColor),
      ...(l = this.styleConfig) == null ? void 0 : l.SecondaryButton
    };
  }
  // done
  getPrimaryButtonStyles() {
    var e, r, n, A, i, o, s;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.PrimaryButton) == null ? void 0 : r.background) || ((n = this.questThemeData) == null ? void 0 : n.buttonColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || ((i = this.brandTheme) == null ? void 0 : i.primaryButton) || ((o = this.themeConfig) == null ? void 0 : o.buttonColor),
      ...(s = this.styleConfig) == null ? void 0 : s.PrimaryButton
    };
  }
  // done
  getSecondaryButtonAeroStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w, B;
    return {
      height: ((r = (e = this.styleConfig) == null ? void 0 : e.SecondaryButton) == null ? void 0 : r.width) || "44px",
      width: ((A = (n = this.styleConfig) == null ? void 0 : n.SecondaryButton) == null ? void 0 : A.width) || "44px",
      borderRadius: ((o = (i = this.styleConfig) == null ? void 0 : i.SecondaryButton) == null ? void 0 : o.borderRadius) || "50%",
      padding: ((a = (s = this.styleConfig) == null ? void 0 : s.SecondaryButton) == null ? void 0 : a.padding) || "10px",
      border: ((l = (c = this.styleConfig) == null ? void 0 : c.SecondaryButton) == null ? void 0 : l.border) || "1.5px solid #afafaf",
      borderColor: (f = (u = this.styleConfig) == null ? void 0 : u.SecondaryButton) == null ? void 0 : f.borderColor,
      backgroundColor: ((g = (d = this.styleConfig) == null ? void 0 : d.SecondaryButton) == null ? void 0 : g.backgroundColor) || ((m = this.brandTheme) == null ? void 0 : m.secondaryButton) || ((p = this.themeConfig) == null ? void 0 : p.backgroundColor),
      color: ((C = (v = this.styleConfig) == null ? void 0 : v.SecondaryButton) == null ? void 0 : C.color) || ((w = this.themeConfig) == null ? void 0 : w.primaryColor),
      ...(B = this.styleConfig) == null ? void 0 : B.SecondaryButton
    };
  }
  // done
  getPrimaryButtonAeroStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v;
    return {
      height: ((r = (e = this.styleConfig) == null ? void 0 : e.PrimaryButton) == null ? void 0 : r.width) || "44px",
      width: ((A = (n = this.styleConfig) == null ? void 0 : n.PrimaryButton) == null ? void 0 : A.width) || "44px",
      borderRadius: ((o = (i = this.styleConfig) == null ? void 0 : i.PrimaryButton) == null ? void 0 : o.borderRadius) || "50%",
      padding: ((a = (s = this.styleConfig) == null ? void 0 : s.PrimaryButton) == null ? void 0 : a.padding) || "10px",
      border: ((l = (c = this.styleConfig) == null ? void 0 : c.PrimaryButton) == null ? void 0 : l.border) || "1.5px solid #afafaf",
      borderColor: (f = (u = this.styleConfig) == null ? void 0 : u.PrimaryButton) == null ? void 0 : f.borderColor,
      background: ((g = (d = this.styleConfig) == null ? void 0 : d.PrimaryButton) == null ? void 0 : g.background) || ((m = this.brandTheme) == null ? void 0 : m.primaryButton) || ((p = this.themeConfig) == null ? void 0 : p.backgroundColor),
      ...(v = this.styleConfig) == null ? void 0 : v.PrimaryButton
    };
  }
  // done
  getNormalButtonStyles() {
    var e, r, n, A, i, o, s;
    return {
      border: ((r = (e = this.styleConfig) == null ? void 0 : e.SecondaryButton) == null ? void 0 : r.border) || "1.5px solid #afafaf",
      background: ((A = (n = this.styleConfig) == null ? void 0 : n.PrimaryButton) == null ? void 0 : A.background) || ((i = this.questThemeData) == null ? void 0 : i.buttonColor) || ((o = this.brandTheme) == null ? void 0 : o.primaryButton),
      ...(s = this.styleConfig) == null ? void 0 : s.PrimaryButton
    };
  }
  // done
  getProgressBarStyles() {
    var e, r, n;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.ProgressBar) == null ? void 0 : r.completeTabColor) || ((n = this == null ? void 0 : this.questThemeData) == null ? void 0 : n.accentColor) || "#098849";
  }
  // done
  getProgressBarCurrentTabColor() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.ProgressBar) == null ? void 0 : r.currentTabColor) || "#2C2C2C";
  }
  // done
  getProgressBarPendingTabColor() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.ProgressBar) == null ? void 0 : r.currentTabColor) || "#ECECEC";
  }
  getBorderRadius() {
    var e, r;
    return ((e = this.questThemeData) == null ? void 0 : e.borderRadius) || ((r = this.brandTheme) == null ? void 0 : r.borderRadius) || this.getStyleValueAsString("Form.borderRadius", "8px");
  }
  // Heading and Description styles
  getHeadingStyles() {
    var e, r, n;
    return {
      color: this.getStyleValueAsString("Heading.color", "") || ((e = this.brandTheme) == null ? void 0 : e.primaryColor) || ((r = this.themeConfig) == null ? void 0 : r.primaryColor) || "#000000",
      ...(n = this.styleConfig) == null ? void 0 : n.Heading
    };
  }
  getDescriptionStyles() {
    var e, r, n;
    return {
      color: this.getStyleValueAsString("Description.color", "") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666",
      ...(n = this.styleConfig) == null ? void 0 : n.Description
    };
  }
  // Footer styles
  getFooterStyles() {
    var r;
    const e = ((r = this.styleConfig) == null ? void 0 : r.Footer) || {};
    return {
      container: {
        background: this.getBackgroundColor(),
        ...e.FooterStyle
      },
      text: e.FooterTextStyle || {},
      icon: e.FooterIcon || {},
      content: {
        text: e.FooterText || "",
        link: e.FooterLink || ""
      }
    };
  }
  getOnboardingFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p;
    return {
      FooterStyle: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.background) || ((o = (i = (A = this.styleConfig) == null ? void 0 : A.Footer) == null ? void 0 : i.FooterStyle) == null ? void 0 : o.backgroundColor) || this.getBackgroundColor(),
        ...(a = (s = this.styleConfig) == null ? void 0 : s.Footer) == null ? void 0 : a.FooterStyle
      },
      FooterTextStyle: {
        ...(l = (c = this.styleConfig) == null ? void 0 : c.Footer) == null ? void 0 : l.FooterTextStyle
      },
      FooterIcon: {
        ...(f = (u = this.styleConfig) == null ? void 0 : u.Footer) == null ? void 0 : f.FooterIcon
      },
      FooterText: (g = (d = this.styleConfig) == null ? void 0 : d.Footer) == null ? void 0 : g.FooterText,
      FooterLink: (p = (m = this.styleConfig) == null ? void 0 : m.Footer) == null ? void 0 : p.FooterLink
    };
  }
  // Update methods for dynamic configuration changes
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    var r;
    this.styleConfig = {
      ...this.styleConfig,
      ...e,
      Footer: {
        ...(r = this.styleConfig) == null ? void 0 : r.Footer,
        ...e == null ? void 0 : e.Footer
      }
    };
  }
  updateQuestTheme(e) {
    this.questThemeData = { ...this.questThemeData, ...e };
  }
  updateBrandTheme(e) {
    this.brandTheme = { ...this.brandTheme, ...e };
  }
  // Merging and computing dynamic styles
  mergeStyles(e, r) {
    return {
      ...e,
      ...r || {}
    };
  }
  getComputedStyle(e, r = {}) {
    return this.mergeStyles(
      r,
      this.getStyleValueAsObject(e, {})
    );
  }
}
const Zb = (t, e, r, n, A, i) => {
  const o = async (s) => {
    try {
      const a = `${e}api/entities/${r}/metrics/${s}/campaign`, c = await Oe.post(a, { campaignId: n, campaignVariationId: A, ...i }, { headers: t });
      if (c.status === 200 && c.data.success)
        return c;
    } catch (a) {
      a.response && a.response.data && a.response.data.error ? console.error("API request failed:", a.response.data.error) : console.error("API request failed:", a.message);
    }
  };
  return {
    async view() {
      return o("onboarding-view");
    },
    async page(s) {
      return o(`onboarding-complete-page-${s}`);
    },
    async complete() {
      return o("onboarding-complete");
    }
  };
}, bM = ({ template: t, design: e, setDesign: r, formdata: n }) => {
  switch (t) {
    case "multi-question": {
      e.length > 0 && r([...e]);
      break;
    }
    case "single-question": {
      let A = [];
      for (let i = 1; i <= n.length; i++) {
        let o = [i];
        A.push(o);
      }
      r(A);
      break;
    }
    case "single-page": {
      let A = [];
      for (let i = 1; i <= n.length; i++)
        A.push(i);
      r([A]);
      break;
    }
    default: {
      let A = [];
      for (let i = 1; i <= n.length; i++)
        A.push(i);
      r([A]);
      break;
    }
  }
};
class BM {
  constructor(e, r, n, A, i, o, s, a, c, l, u) {
    ke(this, "controlBtnType");
    ke(this, "design");
    ke(this, "Headers");
    ke(this, "loadingTracker");
    ke(this, "multiChoice");
    ke(this, "nextBtnText");
    ke(this, "progress");
    ke(this, "progressBarMultiLine");
    ke(this, "showFooter");
    ke(this, "singleChoose");
    ke(this, "template");
    this.controlBtnType = e, this.design = r, this.Headers = n, this.loadingTracker = A, this.multiChoice = i, this.nextBtnText = o, this.progress = s, this.progressBarMultiLine = a, this.showFooter = c, this.singleChoose = l, this.template = u;
  }
  getControlBtnType() {
    return this.controlBtnType;
  }
  getDesign() {
    return this.design;
  }
  getHeaders() {
    return this.Headers;
  }
  getLoadingTracker() {
    return this.loadingTracker;
  }
  getMultiChoice() {
    return this.multiChoice;
  }
  getNextBtnText() {
    return this.nextBtnText;
  }
  getProgress() {
    return this.progress;
  }
  getProgressBarMultiLine() {
    return this.progressBarMultiLine;
  }
  getShowFooter() {
    return this.showFooter;
  }
  getSingleChoose() {
    return this.singleChoose;
  }
  getTemplate() {
    return this.template;
  }
}
const Rv = ({
  answer: t,
  getAnswers: e,
  questId: r,
  setAnswer: n,
  controlBtnType: A,
  design: i = [],
  Headers: o = [],
  loadingTracker: s,
  multiChoice: a = "modal1",
  nextBtnText: c,
  onPageChange: l,
  progress: u,
  progressBarMultiLine: f,
  setLoading: d = () => {
  },
  showFooter: g = !0,
  singleChoose: m,
  styleConfig: p,
  template: v,
  token: C,
  uniqueEmailId: w,
  uniqueUserId: B,
  userId: y,
  variation: b,
  children: q,
  ...E
}) => {
  var it;
  const { apiKey: x, apiSecret: M, entityId: O, featureFlags: I, apiType: S, themeConfig: P } = Xe(ct.Context);
  let H = S == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const F = new noe(S), T = gt(null);
  let U = new Bt("mixpanel", S);
  const D = new zn(), [Q, Y] = N(
    null
  ), [j, Z] = N([]), [W, R] = N(0), [K, L] = N(!1), [G, V] = N([]), [_, J] = N((Q == null ? void 0 : Q.design) || []), [X, ne] = N(b3), [ee, $] = N(""), [te, ae] = N({
    ...I2,
    accentColor: E.accent ? E.accent : I2.accentColor
  }), [se, ue] = N(
    {}
  ), [fe, ve] = N(o), [ge, oe] = N(v || "single-page"), ce = async (de) => {
    var xe, he, Qe, Re, pt;
    try {
      const ze = await F.fetchCampaignData(
        O,
        r,
        de,
        b
      );
      if ((he = (xe = ze.sdkConfig) == null ? void 0 : xe.uiProps) != null && he.questThemeData ? ae({
        ...ze.sdkConfig.uiProps.questThemeData,
        accentColor: ze.sdkConfig.uiProps.questThemeData.accentColor ? ze.sdkConfig.uiProps.questThemeData.accentColor : E.accent
      }) : E.accent && ae({ ...te, accentColor: E.accent }), (Re = (Qe = ze == null ? void 0 : ze.sdkConfig) == null ? void 0 : Qe.uiProps) != null && Re.BrandTheme && ne(ze.sdkConfig.uiProps.BrandTheme.properties), Y((pt = ze == null ? void 0 : ze.sdkConfig) == null ? void 0 : pt.uiProps), ze.actions) {
        const lt = F.processActionsData(
          ze.actions
        );
        V(lt), $(ze.campaignVariationId);
      }
    } catch (ze) {
      U.captureSentryException(ze);
    }
  };
  le(() => {
    U.fireTrackingEvent("quest_onboarding_loaded", "onboarding"), O && (async () => {
      if (O)
        try {
          const xe = await F.getUserAuth({
            apiKey: x,
            entityId: O,
            uniqueUserId: B,
            uniqueEmailId: w,
            userId: y,
            token: C
          });
          if (!xe) return;
          const he = {
            apiKey: x,
            apiSecret: M,
            userId: xe.userId,
            token: xe.token
          }, Qe = new URLSearchParams();
          Qe.set("platform", "REACT"), b && Qe.set("variation", b), await ce(he), F.metricApi(
            he,
            H,
            O,
            r,
            ee,
            { campaignVariationId: ee }
          ).view();
        } catch (xe) {
          U.captureSentryException(xe);
        }
    })();
  }, []), le(() => {
    if (!G.length) return;
    let de;
    ge === "multi-question" ? (de = G.map((Re, pt) => pt + 1), de = G.map((Re, pt) => {
      if (_[W].includes(pt + 1)) return pt + 1;
    }).filter((Re, pt) => {
      if (_[W].includes(pt + 1)) return !0;
    })) : ge === "single-question" ? de = [W + 1] : de = [...G.map((Qe, Re) => Re + 1)];
    let xe = 0;
    for (let he = 0; he < de.length; he++)
      (G[de[he] - 1].required == !1 || G[de[he] - 1].type == "LINK_OPEN_READ" || t[G[de[he] - 1].actionId] && t[G[de[he] - 1].actionId].length > 0) && xe++;
    de.length > 0 && xe == de.length ? L(!0) : L(!1);
  }, [t, G, W]), le(() => {
    let de = D.get("questUserId"), xe = D.get("questUserToken"), he = {
      apikey: x,
      apisecret: M,
      userId: de || y,
      token: xe || C
    };
    W > 0 && W < (_ == null ? void 0 : _.length) && Zb(
      he,
      H,
      O,
      r,
      ee
    ).page(W), l == null || l(W);
  }, [W]), le(() => {
    if (K == !0)
      Z([...j, W]);
    else if (j.includes(W)) {
      const de = j.filter((xe) => xe !== W);
      Z(de);
    }
  }, [K, W]);
  const pe = (de, xe, he) => {
    if (de.target.checked == !0 && he == "check") {
      let Qe = t[xe] || [];
      Qe.push(de.target.value), n({
        ...t,
        [xe]: Qe
      });
    } else if (de.target.checked == !1 && typeof t[xe] == "object" && he == "check") {
      let Re = t[xe].filter((pt) => pt != de.target.value);
      n({
        ...t,
        [xe]: Re
      });
    } else
      n({
        ...t,
        [xe]: de.target.value
      });
  }, [qe, Se] = N(0), Te = () => {
    var de;
    return le(() => {
      var xe;
      T.current && T.current.clientWidth != qe && Se((xe = T == null ? void 0 : T.current) == null ? void 0 : xe.clientWidth);
    }, []), /* @__PURE__ */ h("div", { className: "q-onb-progress", children: /* @__PURE__ */ h(
      "div",
      {
        style: {
          gridTemplateColumns: u ? `repeat(${u.length}, 1fr)` : ""
        },
        ref: T,
        children: !!u && (!!i || !!(Q != null && Q.design)) && (u.length == (i == null ? void 0 : i.length) || u.length == ((de = Q == null ? void 0 : Q.design) == null ? void 0 : de.length)) && u.map((xe, he) => /* @__PURE__ */ h("div", { children: j.includes(he) == !0 ? /* @__PURE__ */ k(
          "div",
          {
            className: "q-onb-progress-comp",
            style: {
              borderColor: Le.getProgressBarStyles()
            },
            children: [
              /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    maxWidth: `${(qe - (u.length - 1) * 15) / u.length - 32}px`,
                    whiteSpace: f ? "normal" : "nowrap",
                    overflow: f ? "" : "hidden",
                    textOverflow: f ? "" : "ellipsis",
                    color: Le.getProgressBarStyles()
                  },
                  children: xe
                }
              ),
              /* @__PURE__ */ k(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 21 20",
                  fill: "none",
                  children: [
                    /* @__PURE__ */ h(
                      "path",
                      {
                        opacity: "0.3",
                        d: "M10.8333 18.3333C15.4357 18.3333 19.1667 14.6023 19.1667 9.99996C19.1667 5.39759 15.4357 1.66663 10.8333 1.66663C6.23095 1.66663 2.49999 5.39759 2.49999 9.99996C2.49999 14.6023 6.23095 18.3333 10.8333 18.3333Z",
                        fill: (te == null ? void 0 : te.accentColor) || (E == null ? void 0 : E.accent) || (X == null ? void 0 : X.accentColor) || "#098849"
                      }
                    ),
                    /* @__PURE__ */ h(
                      "path",
                      {
                        d: "M14.8074 6.51474C15.1215 6.17828 15.6488 6.1601 15.9853 6.47412C16.3217 6.78815 16.3399 7.31548 16.0259 7.65193L10.1925 13.9019C9.88787 14.2284 9.38003 14.2566 9.041 13.9661L6.12434 11.4661C5.7749 11.1665 5.73443 10.6404 6.03395 10.291C6.33347 9.94157 6.85955 9.9011 7.20899 10.2006L9.51916 12.1808L14.8074 6.51474Z",
                        fill: Le.getProgressBarStyles()
                      }
                    )
                  ]
                }
              )
            ]
          }
        ) : he == W ? /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-progress-comp",
            style: {
              borderColor: Le.getProgressBarCurrentTabColor()
            },
            children: /* @__PURE__ */ h(
              "div",
              {
                style: {
                  maxWidth: `${(qe - (u.length - 1) * 15) / u.length - 32}px`,
                  whiteSpace: f ? "normal" : "nowrap",
                  overflow: f ? "" : "hidden",
                  textOverflow: f ? "" : "ellipsis",
                  color: Le.getProgressBarCurrentTabColor()
                },
                children: xe
              }
            )
          }
        ) : /* @__PURE__ */ h(
          "div",
          {
            className: "q-onb-progress-comp",
            style: {
              borderColor: Le.getProgressBarPendingTabColor()
            },
            children: /* @__PURE__ */ h(
              "div",
              {
                style: {
                  maxWidth: `${(qe - (u.length - 1) * 15) / u.length - 32}px`,
                  whiteSpace: f ? "normal" : "nowrap",
                  overflow: f ? "" : "hidden",
                  textOverflow: f ? "" : "ellipsis",
                  color: Le.getProgressBarPendingTabColor()
                },
                children: xe
              }
            )
          }
        ) }, he))
      }
    ) });
  }, be = (de, xe) => {
    ue((he) => ({
      ...he,
      [xe]: de
    }));
  }, He = () => {
    let de = 0;
    return Object.keys(se).map((xe) => {
      if (se[xe])
        de = de + 1;
      else
        return !0;
    }), de === Object.keys(se).length;
  };
  le(() => {
    var de;
    Q != null && Q.BrandTheme && Object.keys(Q == null ? void 0 : Q.BrandTheme).length > 0 && ne(((de = Q == null ? void 0 : Q.BrandTheme) == null ? void 0 : de.properties) || X), Q != null && Q.questThemeData && Object.keys(Q == null ? void 0 : Q.questThemeData).length > 0, (fe == null ? void 0 : fe.length) === 0 && ve((o == null ? void 0 : o.length) == 0 ? Q == null ? void 0 : Q.Headers : o), oe(v || (Q == null ? void 0 : Q.template) || "single-page");
  }, [Q]);
  function Ge() {
    if (U.fireTrackingEvent(
      "quest_onboarding_submit_btn_clicked",
      "onboarding"
    ), W < _.length - 1)
      R((de) => de + 1);
    else {
      let de = { ...t };
      for (let ze of Object.keys(de))
        if (ze.includes("/manual") && de[ze] != "") {
          let lt = ze.split("/manual")[0];
          G.filter(
            (We) => We.actionId == lt
          )[0].manualInput == de[lt] && (de[lt] = de[ze]);
        }
      let xe = Object.keys(de).filter((ze) => !ze.includes("/manual")).map((ze) => ({
        actionId: ze,
        answers: typeof de[ze] == "object" ? de[ze] : [de[ze]]
      })), he = D.get("questUserId"), Qe = D.get("questUserToken"), Re = D.get("externalUserId"), pt = {
        apikey: x,
        apisecret: M,
        userId: Re && he && Qe && Re == B ? he : y,
        token: Re && he && Qe && Re == B ? Qe : C
      };
      e && e(de);
      try {
        Oe.post(
          `${H}api/v2/entities/${O}/campaigns/${r}/verify`,
          { actions: xe, campaignVariationId: ee },
          { headers: pt }
        );
      } catch (ze) {
        U.captureSentryException(ze);
      }
      try {
        Zb(
          pt,
          H,
          O,
          r,
          ee
        ).complete();
      } catch (ze) {
        U.captureSentryException(ze);
      }
    }
  }
  if (((it = I[Ve.FLAG_CONSTRAINTS.OnboardingFlag]) == null ? void 0 : it.isEnabled) == !1)
    return /* @__PURE__ */ h("div", {});
  const Le = new wM(
    P,
    p || (Q == null ? void 0 : Q.styleConfig),
    te,
    X
  );
  let Ae;
  Ae = new BM(
    A || (Q == null ? void 0 : Q.controlBtnType),
    i.length == 0 ? Q == null ? void 0 : Q.design : i,
    o.length == 0 ? Q == null ? void 0 : Q.Headers : o,
    s || (Q == null ? void 0 : Q.loadingTracker),
    a || (Q == null ? void 0 : Q.multiChoice),
    c || (Q == null ? void 0 : Q.nextBtnText),
    u || (Q == null ? void 0 : Q.progress),
    f || (Q == null ? void 0 : Q.progressBarMultiLine),
    g || (Q == null ? void 0 : Q.showFooter),
    m || (Q == null ? void 0 : Q.singleChoose),
    v || (Q == null ? void 0 : Q.template)
  ), le(() => {
    bM({
      template: Ae.getTemplate(),
      design: Ae == null ? void 0 : Ae.getDesign(),
      setDesign: J,
      formdata: G
    });
  }, [Q, G]);
  const Pe = {
    formdata: G,
    headersArray: fe,
    currentPage: W,
    setCurrentPage: R,
    design: i,
    designState: _,
    progress: u,
    progressBarMultiLine: f,
    ProgressBar: Te,
    template: v,
    singleChoose: m,
    multiChoice: a,
    answer: t,
    controlBtnType: A,
    uiProps: Q,
    nextBtnText: c,
    campaignId: r,
    btnFlag: K,
    returnAnswers: Ge,
    handleUpdate: pe,
    validateInputRegex: be,
    checkValidationValues: He,
    themeManager: Le,
    validationData: se,
    campaignVariationId: ee,
    apiSecret: M,
    uniqueUserId: B,
    userId: y,
    token: C,
    getAnswers: e,
    BACKEND_URL: H,
    onPageChange: l,
    questionTemplate: ge,
    setAnswer: n,
    onboardingGetPropsFunctions: Ae
  };
  return /* @__PURE__ */ h(Iv.Provider, { value: Pe, children: G.length > 0 && /* @__PURE__ */ h(
    "div",
    {
      className: "q-onb-home",
      style: Le.getContainerStyles(),
      ...E,
      children: /* @__PURE__ */ h("div", { className: "q-onb-ch", children: q || /* @__PURE__ */ k(Ze, { children: [
        /* @__PURE__ */ h($g, {}),
        /* @__PURE__ */ h(CM, {}),
        g && /* @__PURE__ */ h(s4, {})
      ] }) })
    }
  ) });
};
Rv.Header = $g;
Rv.Content = CM;
Rv.Footer = s4;
function EM(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (r = EM(t[e])) && (n && (n += " "), n += r);
  else for (e in t) t[e] && (n && (n += " "), n += e);
  return n;
}
function ya() {
  for (var t, e, r = 0, n = ""; r < arguments.length; ) (t = arguments[r++]) && (e = EM(t)) && (n && (n += " "), n += e);
  return n;
}
const _0 = (t) => typeof t == "number" && !isNaN(t), el = (t) => typeof t == "string", ii = (t) => typeof t == "function", Eh = (t) => el(t) || ii(t) ? t : null, J9 = (t) => QA(t) || el(t) || ii(t) || _0(t);
function Aoe(t, e, r) {
  r === void 0 && (r = 300);
  const { scrollHeight: n, style: A } = t;
  requestAnimationFrame(() => {
    A.minHeight = "initial", A.height = n + "px", A.transition = `all ${r}ms`, requestAnimationFrame(() => {
      A.height = "0", A.padding = "0", A.margin = "0", setTimeout(e, r);
    });
  });
}
function a4(t) {
  let { enter: e, exit: r, appendPosition: n = !1, collapse: A = !0, collapseDuration: i = 300 } = t;
  return function(o) {
    let { children: s, position: a, preventExitTransition: c, done: l, nodeRef: u, isIn: f } = o;
    const d = n ? `${e}--${a}` : e, g = n ? `${r}--${a}` : r, m = gt(0);
    return _p(() => {
      const p = u.current, v = d.split(" "), C = (w) => {
        w.target === u.current && (p.dispatchEvent(new Event("d")), p.removeEventListener("animationend", C), p.removeEventListener("animationcancel", C), m.current === 0 && w.type !== "animationcancel" && p.classList.remove(...v));
      };
      p.classList.add(...v), p.addEventListener("animationend", C), p.addEventListener("animationcancel", C);
    }, []), le(() => {
      const p = u.current, v = () => {
        p.removeEventListener("animationend", v), A ? Aoe(p, l, i) : l();
      };
      f || (c ? v() : (m.current = 1, p.className += ` ${g}`, p.addEventListener("animationend", v)));
    }, [f]), re.createElement(re.Fragment, null, s);
  };
}
function Jb(t, e) {
  return t != null ? { content: t.content, containerId: t.props.containerId, id: t.props.toastId, theme: t.props.theme, type: t.props.type, data: t.props.data || {}, isLoading: t.props.isLoading, icon: t.props.icon, status: e } : {};
}
const Fi = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(t, e) {
  return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
}, off(t, e) {
  if (e) {
    const r = this.list.get(t).filter((n) => n !== e);
    return this.list.set(t, r), this;
  }
  return this.list.delete(t), this;
}, cancelEmit(t) {
  const e = this.emitQueue.get(t);
  return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
}, emit(t) {
  this.list.has(t) && this.list.get(t).forEach((e) => {
    const r = setTimeout(() => {
      e(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(r);
  });
} }, yf = (t) => {
  let { theme: e, type: r, ...n } = t;
  return re.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: e === "colored" ? "currentColor" : `var(--toastify-icon-color-${r})`, ...n });
}, _9 = { info: function(t) {
  return re.createElement(yf, { ...t }, re.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(t) {
  return re.createElement(yf, { ...t }, re.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(t) {
  return re.createElement(yf, { ...t }, re.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(t) {
  return re.createElement(yf, { ...t }, re.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return re.createElement("div", { className: "Toastify__spinner" });
} };
function ioe(t) {
  const [, e] = Bj((d) => d + 1, 0), [r, n] = N([]), A = gt(null), i = gt(/* @__PURE__ */ new Map()).current, o = (d) => r.indexOf(d) !== -1, s = gt({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: t, containerId: null, isToastActive: o, getToast: (d) => i.get(d) }).current;
  function a(d) {
    let { containerId: g } = d;
    const { limit: m } = s.props;
    !m || g && s.containerId !== g || (s.count -= s.queue.length, s.queue = []);
  }
  function c(d) {
    n((g) => d == null ? [] : g.filter((m) => m !== d));
  }
  function l() {
    const { toastContent: d, toastProps: g, staleId: m } = s.queue.shift();
    f(d, g, m);
  }
  function u(d, g) {
    let { delay: m, staleId: p, ...v } = g;
    if (!J9(d) || function(I) {
      return !A.current || s.props.enableMultiContainer && I.containerId !== s.props.containerId || i.has(I.toastId) && I.updateId == null;
    }(v)) return;
    const { toastId: C, updateId: w, data: B } = v, { props: y } = s, b = () => c(C), q = w == null;
    q && s.count++;
    const E = { ...y, style: y.toastStyle, key: s.toastKey++, ...Object.fromEntries(Object.entries(v).filter((I) => {
      let [S, P] = I;
      return P != null;
    })), toastId: C, updateId: w, data: B, closeToast: b, isIn: !1, className: Eh(v.className || y.toastClassName), bodyClassName: Eh(v.bodyClassName || y.bodyClassName), progressClassName: Eh(v.progressClassName || y.progressClassName), autoClose: !v.isLoading && (x = v.autoClose, M = y.autoClose, x === !1 || _0(x) && x > 0 ? x : M), deleteToast() {
      const I = Jb(i.get(C), "removed");
      i.delete(C), Fi.emit(4, I);
      const S = s.queue.length;
      if (s.count = C == null ? s.count - s.displayedToast : s.count - 1, s.count < 0 && (s.count = 0), S > 0) {
        const P = C == null ? s.props.limit : 1;
        if (S === 1 || P === 1) s.displayedToast++, l();
        else {
          const H = P > S ? S : P;
          s.displayedToast = H;
          for (let F = 0; F < H; F++) l();
        }
      } else e();
    } };
    var x, M;
    E.iconOut = function(I) {
      let { theme: S, type: P, isLoading: H, icon: F } = I, T = null;
      const U = { theme: S, type: P };
      return F === !1 || (ii(F) ? T = F(U) : QA(F) ? T = vn(F, U) : el(F) || _0(F) ? T = F : H ? T = _9.spinner() : ((D) => D in _9)(P) && (T = _9[P](U))), T;
    }(E), ii(v.onOpen) && (E.onOpen = v.onOpen), ii(v.onClose) && (E.onClose = v.onClose), E.closeButton = y.closeButton, v.closeButton === !1 || J9(v.closeButton) ? E.closeButton = v.closeButton : v.closeButton === !0 && (E.closeButton = !J9(y.closeButton) || y.closeButton);
    let O = d;
    QA(d) && !el(d.type) ? O = vn(d, { closeToast: b, toastProps: E, data: B }) : ii(d) && (O = d({ closeToast: b, toastProps: E, data: B })), y.limit && y.limit > 0 && s.count > y.limit && q ? s.queue.push({ toastContent: O, toastProps: E, staleId: p }) : _0(m) ? setTimeout(() => {
      f(O, E, p);
    }, m) : f(O, E, p);
  }
  function f(d, g, m) {
    const { toastId: p } = g;
    m && i.delete(m);
    const v = { content: d, props: g };
    i.set(p, v), n((C) => [...C, p].filter((w) => w !== m)), Fi.emit(4, Jb(v, v.props.updateId == null ? "added" : "updated"));
  }
  return le(() => (s.containerId = t.containerId, Fi.cancelEmit(3).on(0, u).on(1, (d) => A.current && c(d)).on(5, a).emit(2, s), () => {
    i.clear(), Fi.emit(3, s);
  }), []), le(() => {
    s.props = t, s.isToastActive = o, s.displayedToast = r.length;
  }), { getToastToRender: function(d) {
    const g = /* @__PURE__ */ new Map(), m = Array.from(i.values());
    return t.newestOnTop && m.reverse(), m.forEach((p) => {
      const { position: v } = p.props;
      g.has(v) || g.set(v, []), g.get(v).push(p);
    }), Array.from(g, (p) => d(p[0], p[1]));
  }, containerRef: A, isToastActive: o };
}
function _b(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $b(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function ooe(t) {
  const [e, r] = N(!1), [n, A] = N(!1), i = gt(null), o = gt({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, s = gt(t), { autoClose: a, pauseOnHover: c, closeToast: l, onClick: u, closeOnClick: f } = t;
  function d(B) {
    if (t.draggable) {
      B.nativeEvent.type === "touchstart" && B.nativeEvent.preventDefault(), o.didMove = !1, document.addEventListener("mousemove", v), document.addEventListener("mouseup", C), document.addEventListener("touchmove", v), document.addEventListener("touchend", C);
      const y = i.current;
      o.canCloseOnClick = !0, o.canDrag = !0, o.boundingRect = y.getBoundingClientRect(), y.style.transition = "", o.x = _b(B.nativeEvent), o.y = $b(B.nativeEvent), t.draggableDirection === "x" ? (o.start = o.x, o.removalDistance = y.offsetWidth * (t.draggablePercent / 100)) : (o.start = o.y, o.removalDistance = y.offsetHeight * (t.draggablePercent === 80 ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
    }
  }
  function g(B) {
    if (o.boundingRect) {
      const { top: y, bottom: b, left: q, right: E } = o.boundingRect;
      B.nativeEvent.type !== "touchend" && t.pauseOnHover && o.x >= q && o.x <= E && o.y >= y && o.y <= b ? p() : m();
    }
  }
  function m() {
    r(!0);
  }
  function p() {
    r(!1);
  }
  function v(B) {
    const y = i.current;
    o.canDrag && y && (o.didMove = !0, e && p(), o.x = _b(B), o.y = $b(B), o.delta = t.draggableDirection === "x" ? o.x - o.start : o.y - o.start, o.start !== o.x && (o.canCloseOnClick = !1), y.style.transform = `translate${t.draggableDirection}(${o.delta}px)`, y.style.opacity = "" + (1 - Math.abs(o.delta / o.removalDistance)));
  }
  function C() {
    document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", C), document.removeEventListener("touchmove", v), document.removeEventListener("touchend", C);
    const B = i.current;
    if (o.canDrag && o.didMove && B) {
      if (o.canDrag = !1, Math.abs(o.delta) > o.removalDistance) return A(!0), void t.closeToast();
      B.style.transition = "transform 0.2s, opacity 0.2s", B.style.transform = `translate${t.draggableDirection}(0)`, B.style.opacity = "1";
    }
  }
  le(() => {
    s.current = t;
  }), le(() => (i.current && i.current.addEventListener("d", m, { once: !0 }), ii(t.onOpen) && t.onOpen(QA(t.children) && t.children.props), () => {
    const B = s.current;
    ii(B.onClose) && B.onClose(QA(B.children) && B.children.props);
  }), []), le(() => (t.pauseOnFocusLoss && (document.hasFocus() || p(), window.addEventListener("focus", m), window.addEventListener("blur", p)), () => {
    t.pauseOnFocusLoss && (window.removeEventListener("focus", m), window.removeEventListener("blur", p));
  }), [t.pauseOnFocusLoss]);
  const w = { onMouseDown: d, onTouchStart: d, onMouseUp: g, onTouchEnd: g };
  return a && c && (w.onMouseEnter = p, w.onMouseLeave = m), f && (w.onClick = (B) => {
    u && u(B), o.canCloseOnClick && l();
  }), { playToast: m, pauseToast: p, isRunning: e, preventExitTransition: n, toastRef: i, eventHandlers: w };
}
function xM(t) {
  let { closeToast: e, theme: r, ariaLabel: n = "close" } = t;
  return re.createElement("button", { className: `Toastify__close-button Toastify__close-button--${r}`, type: "button", onClick: (A) => {
    A.stopPropagation(), e(A);
  }, "aria-label": n }, re.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, re.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function soe(t) {
  let { delay: e, isRunning: r, closeToast: n, type: A = "default", hide: i, className: o, style: s, controlledProgress: a, progress: c, rtl: l, isIn: u, theme: f } = t;
  const d = i || a && c === 0, g = { ...s, animationDuration: `${e}ms`, animationPlayState: r ? "running" : "paused", opacity: d ? 0 : 1 };
  a && (g.transform = `scaleX(${c})`);
  const m = ya("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${f}`, `Toastify__progress-bar--${A}`, { "Toastify__progress-bar--rtl": l }), p = ii(o) ? o({ rtl: l, type: A, defaultClassName: m }) : ya(m, o);
  return re.createElement("div", { role: "progressbar", "aria-hidden": d ? "true" : "false", "aria-label": "notification timer", className: p, style: g, [a && c >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && c < 1 ? null : () => {
    u && n();
  } });
}
const aoe = (t) => {
  const { isRunning: e, preventExitTransition: r, toastRef: n, eventHandlers: A } = ooe(t), { closeButton: i, children: o, autoClose: s, onClick: a, type: c, hideProgressBar: l, closeToast: u, transition: f, position: d, className: g, style: m, bodyClassName: p, bodyStyle: v, progressClassName: C, progressStyle: w, updateId: B, role: y, progress: b, rtl: q, toastId: E, deleteToast: x, isIn: M, isLoading: O, iconOut: I, closeOnClick: S, theme: P } = t, H = ya("Toastify__toast", `Toastify__toast-theme--${P}`, `Toastify__toast--${c}`, { "Toastify__toast--rtl": q }, { "Toastify__toast--close-on-click": S }), F = ii(g) ? g({ rtl: q, position: d, type: c, defaultClassName: H }) : ya(H, g), T = !!b || !s, U = { closeToast: u, type: c, theme: P };
  let D = null;
  return i === !1 || (D = ii(i) ? i(U) : QA(i) ? vn(i, U) : xM(U)), re.createElement(f, { isIn: M, done: x, position: d, preventExitTransition: r, nodeRef: n }, re.createElement("div", { id: E, onClick: a, className: F, ...A, style: m, ref: n }, re.createElement("div", { ...M && { role: y }, className: ii(p) ? p({ type: c }) : ya("Toastify__toast-body", p), style: v }, I != null && re.createElement("div", { className: ya("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !O }) }, I), re.createElement("div", null, o)), D, re.createElement(soe, { ...B && !T ? { key: `pb-${B}` } : {}, rtl: q, theme: P, delay: s, isRunning: e, isIn: M, closeToast: u, hide: l, type: c, style: w, className: C, controlledProgress: T, progress: b || 0 })));
}, c4 = function(t, e) {
  return e === void 0 && (e = !1), { enter: `Toastify--animate Toastify__${t}-enter`, exit: `Toastify--animate Toastify__${t}-exit`, appendPosition: e };
}, coe = a4(c4("bounce", !0));
a4(c4("slide", !0));
a4(c4("zoom"));
a4(c4("flip"));
const eB = ol((t, e) => {
  const { getToastToRender: r, containerRef: n, isToastActive: A } = ioe(t), { className: i, style: o, rtl: s, containerId: a } = t;
  function c(l) {
    const u = ya("Toastify__toast-container", `Toastify__toast-container--${l}`, { "Toastify__toast-container--rtl": s });
    return ii(i) ? i({ position: l, rtl: s, defaultClassName: u }) : ya(u, Eh(i));
  }
  return le(() => {
    e && (e.current = n.current);
  }, []), re.createElement("div", { ref: n, className: "Toastify", id: a }, r((l, u) => {
    const f = u.length ? { ...o } : { ...o, pointerEvents: "none" };
    return re.createElement("div", { className: c(l), style: f, key: `container-${l}` }, u.map((d, g) => {
      let { content: m, props: p } = d;
      return re.createElement(aoe, { ...p, isIn: A(p.toastId), style: { ...p.style, "--nth": g + 1, "--len": u.length }, key: `toast-${p.key}` }, m);
    }));
  }));
});
eB.displayName = "ToastContainer", eB.defaultProps = { position: "top-right", transition: coe, autoClose: 5e3, closeButton: xM, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let $9, hc = /* @__PURE__ */ new Map(), O0 = [], loe = 1;
function IM() {
  return "" + loe++;
}
function uoe(t) {
  return t && (el(t.toastId) || _0(t.toastId)) ? t.toastId : IM();
}
function $0(t, e) {
  return hc.size > 0 ? Fi.emit(0, t, e) : O0.push({ content: t, options: e }), e.toastId;
}
function B3(t, e) {
  return { ...e, type: e && e.type || t, toastId: uoe(e) };
}
function Cf(t) {
  return (e, r) => $0(e, B3(t, r));
}
function Ir(t, e) {
  return $0(t, B3("default", e));
}
Ir.loading = (t, e) => $0(t, B3("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...e })), Ir.promise = function(t, e, r) {
  let n, { pending: A, error: i, success: o } = e;
  A && (n = el(A) ? Ir.loading(A, r) : Ir.loading(A.render, { ...r, ...A }));
  const s = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, a = (l, u, f) => {
    if (u == null) return void Ir.dismiss(n);
    const d = { type: l, ...s, ...r, data: f }, g = el(u) ? { render: u } : u;
    return n ? Ir.update(n, { ...d, ...g }) : Ir(g.render, { ...d, ...g }), f;
  }, c = ii(t) ? t() : t;
  return c.then((l) => a("success", o, l)).catch((l) => a("error", i, l)), c;
}, Ir.success = Cf("success"), Ir.info = Cf("info"), Ir.error = Cf("error"), Ir.warning = Cf("warning"), Ir.warn = Ir.warning, Ir.dark = (t, e) => $0(t, B3("default", { theme: "dark", ...e })), Ir.dismiss = (t) => {
  hc.size > 0 ? Fi.emit(1, t) : O0 = O0.filter((e) => t != null && e.options.toastId !== t);
}, Ir.clearWaitingQueue = function(t) {
  return t === void 0 && (t = {}), Fi.emit(5, t);
}, Ir.isActive = (t) => {
  let e = !1;
  return hc.forEach((r) => {
    r.isToastActive && r.isToastActive(t) && (e = !0);
  }), e;
}, Ir.update = function(t, e) {
  e === void 0 && (e = {}), setTimeout(() => {
    const r = function(n, A) {
      let { containerId: i } = A;
      const o = hc.get(i || $9);
      return o && o.getToast(n);
    }(t, e);
    if (r) {
      const { props: n, content: A } = r, i = { delay: 100, ...n, ...e, toastId: e.toastId || t, updateId: IM() };
      i.toastId !== t && (i.staleId = t);
      const o = i.render || A;
      delete i.render, $0(o, i);
    }
  }, 0);
}, Ir.done = (t) => {
  Ir.update(t, { progress: 1 });
}, Ir.onChange = (t) => (Fi.on(4, t), () => {
  Fi.off(4, t);
}), Ir.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, Ir.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, Fi.on(2, (t) => {
  $9 = t.containerId || t, hc.set($9, t), O0.forEach((e) => {
    Fi.emit(0, e.content, e.options);
  }), O0 = [];
}).on(3, (t) => {
  hc.delete(t.containerId || t), hc.size === 0 && Fi.off(0).off(1).off(5);
});
var E3, wf = gd;
if (process.env.NODE_ENV === "production")
  E3 = wf.createRoot, wf.hydrateRoot;
else {
  var tB = wf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  E3 = function(t, e) {
    tB.usingClientEntryPoint = !0;
    try {
      return wf.createRoot(t, e);
    } finally {
      tB.usingClientEntryPoint = !1;
    }
  };
}
const doe = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`, Fd = (t = "#2C2C2C") => doe(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.35845 7.47505C8.11437 7.23097 7.71864 7.23097 7.47456 7.47505C7.23048 7.71913 7.23048 8.11486 7.47456 8.35893L9.11596 10.0003L7.47458 11.6417C7.2305 11.8858 7.2305 12.2815 7.47458 12.5256C7.71866 12.7697 8.11439 12.7697 8.35846 12.5256L9.99985 10.8842L11.6412 12.5256C11.8853 12.7697 12.281 12.7697 12.5251 12.5256C12.7692 12.2815 12.7692 11.8858 12.5251 11.6417L10.8837 10.0003L12.5251 8.35895C12.7692 8.11487 12.7692 7.71915 12.5251 7.47507C12.281 7.23099 11.8853 7.23099 11.6412 7.47507L9.99985 9.11645L8.35845 7.47505Z" fill="${t}"/>
</svg>`), foe = ({
  message: t = /* @__PURE__ */ h(Ze, {}),
  duration: e = 3e4,
  position: r = "center",
  remove: n
}) => {
  const [A, i] = N(!0);
  le(() => {
    const l = setTimeout(() => {
      i(!1);
    }, e);
    return () => {
      clearTimeout(l);
    };
  }, [e]);
  const o = () => {
    i(!1), n();
  };
  let s = "0";
  return r === "center" ? s = `-${lo * 53}px` : s = `${lo * 53}px`, /* @__PURE__ */ h("div", { className: "q-toast", onClick: o, children: /* @__PURE__ */ h("div", { className: "q-toast-msg", style: {
    transform: A ? "translateX(0)" : "translateX(100%)",
    top: s
  }, children: t || /* @__PURE__ */ h("div", { className: "q-toast-msg-div", style: {
    transform: A ? "translateX(0)" : "translateX(-100%)"
  }, children: "You maintained a streak for 25 days" }) }) });
};
let lo = 0, OA;
typeof document < "u" && (OA = document.getElementById("root"));
const x3 = [], A7 = () => {
  x3.length > 0 && (x3.pop()(), setTimeout(A7, 300));
}, rs = (t, e, r = "center") => {
  const n = document.createElement("div");
  n.className = "q-toast", OA == null || OA.appendChild(n);
  const A = E3(n), i = () => {
    OA == null || OA.removeChild(n), lo--;
  };
  lo++;
  const o = r === "center" ? `-${lo * 53}px` : `${lo * 53}px`;
  n.style.top = o, A.render(
    /* @__PURE__ */ h(foe, { remove: i, message: t, duration: e, position: r })
  ), x3.unshift(i), x3.length === 1 && A7(), setTimeout(() => {
    A7();
  }, e || 2e3);
}, Td = (t, e = 2e3, r = "right", n) => {
  const A = document.createElement("div");
  A.className = "q-toast " + n, OA == null || OA.appendChild(A);
  const i = E3(A), o = () => {
    OA == null || OA.removeChild(A), lo--;
  };
  lo++;
  let s = "0";
  return r === "center" ? s = `${lo * 83}px` : s = `${lo * 83}px`, r === "center" ? (A.style.top = s, A.style.left = "50%", A.style.transform = "translate(-50%, -16%)") : A.style.top = s, typeof t == "string" && (t = /* @__PURE__ */ h("div", { children: t })), i.render(t), e !== void 0 && setTimeout(() => {
    o();
  }, e), A;
}, Md = (t) => {
  OA == null || OA.removeChild(t), lo--;
};
rs.success = (t) => {
  let e = "Completed successfully", r = 2e3, n = "right";
  typeof t == "string" ? e = t : (r = (t == null ? void 0 : t.duration) || r, e = (t == null ? void 0 : t.text) || e, n = (t == null ? void 0 : t.position) || "right");
  const A = Td(
    /* @__PURE__ */ k(Ze, { children: [
      /* @__PURE__ */ h("img", { src: dte, alt: "" }),
      /* @__PURE__ */ h("div", { style: { marginRight: "30px" }, children: e }),
      /* @__PURE__ */ h(
        "img",
        {
          src: Fd(),
          className: "q_toast_cross",
          alt: "",
          onClick: () => {
            Md(A);
          }
        }
      )
    ] }),
    r,
    n,
    "q_toast_success"
  );
};
rs.warn = (t) => {
  let e = "warning", r = 2e3, n = "right";
  typeof t == "string" ? e = t : (r = (t == null ? void 0 : t.duration) || r, e = (t == null ? void 0 : t.text) || e, n = (t == null ? void 0 : t.position) || "right");
  const A = Td(
    /* @__PURE__ */ k(Ze, { children: [
      /* @__PURE__ */ h("img", { src: fte, alt: "" }),
      /* @__PURE__ */ h("div", { style: { marginRight: "30px" }, children: e }),
      /* @__PURE__ */ h(
        "img",
        {
          src: Fd(),
          className: "q_toast_cross",
          alt: "",
          width: "30px",
          onClick: () => {
            Md(A);
          }
        }
      )
    ] }),
    r,
    n,
    "q_toast_warn"
  );
};
rs.info = (t) => {
  let e = "Alert ", r = 2e3, n = "right";
  typeof t == "string" ? e = t : (r = (t == null ? void 0 : t.duration) || r, e = (t == null ? void 0 : t.text) || e, n = (t == null ? void 0 : t.position) || "right"), console.log(n);
  const A = Td(
    /* @__PURE__ */ k(Ze, { children: [
      /* @__PURE__ */ h("img", { src: lT, alt: "" }),
      /* @__PURE__ */ h("div", { style: { marginRight: "30px" }, children: e }),
      /* @__PURE__ */ h(
        "img",
        {
          src: Fd(),
          className: "q_toast_cross",
          alt: "",
          onClick: () => {
            Md(A);
          }
        }
      )
    ] }),
    r,
    n,
    "q_toast_primary"
  );
};
rs.primary = (t) => {
  let e = "Alert ", r = 2e3, n = "right";
  typeof t == "string" ? e = t : (r = (t == null ? void 0 : t.duration) || r, e = (t == null ? void 0 : t.text) || e, n = (t == null ? void 0 : t.position) || "right");
  const A = Td(
    /* @__PURE__ */ k(Ze, { children: [
      /* @__PURE__ */ h("img", { src: lT, alt: "" }),
      /* @__PURE__ */ h("div", { style: { marginRight: "30px" }, children: e }),
      /* @__PURE__ */ h(
        "img",
        {
          src: Fd(),
          className: "q_toast_cross",
          alt: "",
          onClick: () => {
            Md(A);
          }
        }
      )
    ] }),
    r,
    n,
    "q_toast_primary"
  );
};
rs.error = (t) => {
  let e = "Something went wrong", r = 2e3, n = "right";
  typeof t == "string" ? e = t : (r = (t == null ? void 0 : t.duration) || r, e = (t == null ? void 0 : t.text) || e, n = (t == null ? void 0 : t.position) || "right");
  const A = Td(
    /* @__PURE__ */ k(Ze, { children: [
      /* @__PURE__ */ h("img", { src: cT, alt: "" }),
      /* @__PURE__ */ h("div", { style: { marginRight: "30px" }, children: e }),
      /* @__PURE__ */ h(
        "img",
        {
          src: Fd(),
          className: "q_toast_cross",
          alt: "",
          onClick: () => {
            Md(A);
          }
        }
      )
    ] }),
    r,
    n,
    "q_toast_error"
  );
};
rs.custom = (t) => {
  let e = "This is a toast", r = 2e3, n = "right";
  typeof t == "string" ? e = t : (r = (t == null ? void 0 : t.duration) || r, e = (t == null ? void 0 : t.text) || e, n = (t == null ? void 0 : t.position) || "right");
  const A = Td(
    /* @__PURE__ */ k(Ze, { children: [
      /* @__PURE__ */ h("img", { src: cT, alt: "" }),
      /* @__PURE__ */ h("div", { style: { marginRight: "30px" }, children: e }),
      /* @__PURE__ */ h(
        "img",
        {
          src: Fd(),
          className: "q_toast_cross",
          alt: "",
          onClick: () => {
            Md(A);
          }
        }
      )
    ] }),
    r,
    n,
    "q_toast_error"
  );
};
const SM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_4720_4218)'%3e%3cpath%20d='M10%2019.5833C15.2927%2019.5833%2019.5834%2015.2927%2019.5834%2010C19.5834%204.70727%2015.2927%200.416664%2010%200.416664C4.70729%200.416664%200.416687%204.70727%200.416687%2010C0.416687%2015.2927%204.70729%2019.5833%2010%2019.5833Z'%20fill='%23FFCE52'/%3e%3cpath%20d='M8.75002%2015.0058L7.91669%2015C7.91669%2013.6842%2010.7979%2013.3333%2012.5%2013.3333V14.1667C10.0588%2014.1667%208.81127%2014.7746%208.75002%2015.0058Z'%20fill='%23273941'/%3e%3cpath%20d='M16.3084%206.63333C16.2909%206.6025%2016.2692%206.57417%2016.25%206.54417V7.08333C16.25%207.30435%2016.1622%207.51631%2016.0059%207.67259C15.8497%207.82887%2015.6377%207.91667%2015.4167%207.91667C15.1957%207.91667%2014.9837%207.82887%2014.8274%207.67259C14.6712%207.51631%2014.5834%207.30435%2014.5834%207.08333V6.25H12.3084C11.8942%206.70614%2011.6653%207.30055%2011.6667%207.91667C11.6667%208.57971%2011.9301%209.21559%2012.3989%209.68443C12.8678%2010.1533%2013.5037%2010.4167%2014.1667%2010.4167C14.8297%2010.4167%2015.4656%2010.1533%2015.9345%209.68443C16.4033%209.21559%2016.6667%208.57971%2016.6667%207.91667C16.6683%207.46397%2016.5442%207.01971%2016.3084%206.63333Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M15.4167%207.91667C15.6377%207.91667%2015.8497%207.82887%2016.006%207.67259C16.1622%207.51631%2016.25%207.30435%2016.25%207.08333V6.54417C16.1837%206.43979%2016.1084%206.34137%2016.025%206.25H14.5834V7.08333C14.5834%207.30435%2014.6712%207.51631%2014.8275%207.67259C14.9837%207.82887%2015.1957%207.91667%2015.4167%207.91667Z'%20fill='%23141E21'/%3e%3cpath%20d='M7.97505%206.63333C7.95755%206.6025%207.93588%206.57417%207.91671%206.54417V7.08333C7.91671%207.30435%207.82892%207.51631%207.67264%207.67259C7.51636%207.82887%207.30439%207.91667%207.08338%207.91667C6.86237%207.91667%206.6504%207.82887%206.49412%207.67259C6.33784%207.51631%206.25005%207.30435%206.25005%207.08333V6.25H3.97505C3.56087%206.70614%203.33203%207.30055%203.33338%207.91667C3.33338%208.57971%203.59677%209.21559%204.06561%209.68443C4.53445%2010.1533%205.17034%2010.4167%205.83338%2010.4167C6.49642%2010.4167%207.13231%2010.1533%207.60115%209.68443C8.06999%209.21559%208.33338%208.57971%208.33338%207.91667C8.33498%207.46397%208.21093%207.01971%207.97505%206.63333Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M7.08333%207.91667C7.30435%207.91667%207.51631%207.82887%207.67259%207.67259C7.82887%207.51631%207.91667%207.30435%207.91667%207.08333V6.54417C7.85031%206.43979%207.77503%206.34137%207.69167%206.25H6.25V7.08333C6.25%207.30435%206.3378%207.51631%206.49408%207.67259C6.65036%207.82887%206.86232%207.91667%207.08333%207.91667Z'%20fill='%23141E21'/%3e%3cpath%20d='M10%201.66666C15.0625%201.66666%2019.1667%205.21125%2019.1667%209.58333H19.573C19.4581%207.12169%2018.3993%204.7989%2016.6167%203.09746C14.834%201.39602%2012.4644%200.446701%2010%200.446701C7.53572%200.446701%205.16611%201.39602%203.38342%203.09746C1.60073%204.7989%200.541992%207.12169%200.427124%209.58333H0.833374C0.833374%205.21125%204.93754%201.66666%2010%201.66666Z'%20fill='%23FFE369'/%3e%3cpath%20d='M19.1667%209.58333C19.1667%2013.9554%2015.0625%2017.5%2010%2017.5C4.93752%2017.5%200.833354%2013.9554%200.833354%209.58333H0.427104C0.42127%209.72166%200.416687%209.86041%200.416687%209.99999C0.416687%2012.5417%201.42636%2014.9792%203.22358%2016.7764C5.0208%2018.5737%207.45836%2019.5833%2010%2019.5833C12.5417%2019.5833%2014.9792%2018.5737%2016.7765%2016.7764C18.5737%2014.9792%2019.5834%2012.5417%2019.5834%209.99999C19.5834%209.86041%2019.5788%209.72166%2019.5729%209.58333H19.1667Z'%20fill='%23FFB32B'/%3e%3cpath%20d='M15.5467%203.87978C15.6809%203.74549%2015.6382%203.48525%2015.4513%203.29851C15.2645%203.11177%2015.0042%203.06926%2014.87%203.20355C14.7358%203.33784%2014.7785%203.59808%2014.9654%203.78482C15.1522%203.97155%2015.4125%204.01407%2015.5467%203.87978Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M12.7717%201.83572C12.8389%201.7685%2012.8176%201.63831%2012.7242%201.54494C12.6307%201.45157%2012.5005%201.43038%2012.4333%201.49761C12.3662%201.56483%2012.3874%201.69502%2012.4809%201.78839C12.5743%201.88176%2012.7045%201.90295%2012.7717%201.83572Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M14.6354%203.38485C14.9038%203.11628%2014.8182%202.59566%2014.4443%202.22202C14.0704%201.84839%2013.5498%201.76323%2013.2814%202.03181C13.013%202.30039%2013.0985%202.821%2013.4724%203.19464C13.8463%203.56827%2014.367%203.65343%2014.6354%203.38485Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M14.1667%2010.4167C13.5774%2010.4161%2013.0072%2010.2074%2012.5568%209.82737C12.1064%209.44733%2011.8047%208.9204%2011.705%208.33958C11.6418%208.69919%2011.6581%209.06829%2011.7528%209.42093C11.8475%209.77356%2012.0182%2010.1012%2012.2531%2010.3807C12.488%2010.6603%2012.7812%2010.885%2013.1122%2011.0391C13.4433%2011.1932%2013.804%2011.2729%2014.1692%2011.2726C14.5343%2011.2724%2014.8949%2011.1921%2015.2257%2011.0375C15.5565%2010.8829%2015.8494%2010.6578%2016.0839%2010.3778C16.3183%2010.0979%2016.4886%209.77003%2016.5827%209.41725C16.6769%209.06446%2016.6926%208.69534%2016.6288%208.33583C16.5299%208.91741%2016.2285%209.44527%2015.7779%209.82607C15.3274%2010.2069%2014.7566%2010.4161%2014.1667%2010.4167ZM5.83338%2010.4167C5.24406%2010.4161%204.67389%2010.2074%204.22348%209.82737C3.77308%209.44733%203.47141%208.9204%203.37171%208.33958C3.30846%208.69919%203.32475%209.06829%203.41944%209.42093C3.51412%209.77356%203.6849%2010.1012%203.91977%2010.3807C4.15463%2010.6603%204.44789%2010.885%204.77891%2011.0391C5.10994%2011.1932%205.47069%2011.2729%205.83582%2011.2726C6.20095%2011.2724%206.56159%2011.1921%206.89238%2011.0375C7.22317%2010.8829%207.51608%2010.6578%207.75052%2010.3778C7.98496%2010.0979%208.15524%209.77003%208.24939%209.41725C8.34353%209.06446%208.35926%208.69534%208.29546%208.33583C8.19655%208.91741%207.89516%209.44527%207.44459%209.82607C6.99403%2010.2069%206.42331%2010.4161%205.83338%2010.4167ZM14.5834%206.24999H16.025C16.1084%206.34136%2016.1837%206.43978%2016.25%206.54416C16.2692%206.57416%2016.2917%206.60249%2016.3084%206.63333C16.5111%206.96888%2016.6298%207.34835%2016.6546%207.73958C16.6621%207.66083%2016.6667%207.58083%2016.6667%207.49999C16.6683%207.0473%2016.5443%206.60304%2016.3084%206.21666C16.2909%206.18583%2016.2692%206.1575%2016.25%206.1275C16.1837%206.02312%2016.1084%205.92469%2016.025%205.83333H12.3084C11.8942%206.28947%2011.6654%206.88388%2011.6667%207.49999C11.6668%207.58824%2011.6715%207.67642%2011.6809%207.76416C11.7116%207.20272%2011.9329%206.66856%2012.3084%206.24999H14.5834ZM6.25005%206.24999H7.69171C7.77508%206.34136%207.85036%206.43978%207.91671%206.54416C7.93588%206.57416%207.95838%206.60249%207.97505%206.63333C8.17773%206.96888%208.2965%207.34835%208.3213%207.73958C8.3288%207.66083%208.33338%207.58083%208.33338%207.49999C8.33498%207.0473%208.21093%206.60304%207.97505%206.21666C7.95755%206.18583%207.93588%206.1575%207.91671%206.1275C7.85036%206.02312%207.77508%205.92469%207.69171%205.83333H3.97505C3.56087%206.28947%203.33203%206.88388%203.33338%207.49999C3.33346%207.58824%203.33819%207.67642%203.34755%207.76416C3.37824%207.20272%203.59961%206.66856%203.97505%206.24999H6.25005Z'%20fill='%23FBB40A'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4720_4218'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", PM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='41'%20height='40'%20viewBox='0%200%2041%2040'%20fill='none'%3e%3cpath%20d='M20.2%2039.1667C30.7854%2039.1667%2039.3667%2030.5855%2039.3667%2020C39.3667%209.41458%2030.7854%200.833374%2020.2%200.833374C9.61453%200.833374%201.03333%209.41458%201.03333%2020C1.03333%2030.5855%209.61453%2039.1667%2020.2%2039.1667Z'%20fill='%23FFCE52'/%3e%3cpath%20d='M17.7%2030.0117L16.0333%2030.0001C16.0333%2027.3684%2021.7958%2026.6667%2025.2%2026.6667V28.3334C20.3175%2028.3334%2017.8225%2029.5492%2017.7%2030.0117Z'%20fill='%23273941'/%3e%3cpath%20d='M32.8167%2013.2667C32.7817%2013.205%2032.7383%2013.1483%2032.7%2013.0883V14.1667C32.7%2014.6087%2032.5244%2015.0326%2032.2118%2015.3452C31.8993%2015.6577%2031.4754%2015.8333%2031.0333%2015.8333C30.5913%2015.8333%2030.1674%2015.6577%2029.8548%2015.3452C29.5423%2015.0326%2029.3667%2014.6087%2029.3667%2014.1667V12.5H24.8167C23.9883%2013.4123%2023.5306%2014.6011%2023.5333%2015.8333C23.5333%2017.1594%2024.0601%2018.4312%2024.9978%2019.3689C25.9355%2020.3065%2027.2073%2020.8333%2028.5333%2020.8333C29.8594%2020.8333%2031.1312%2020.3065%2032.0689%2019.3689C33.0066%2018.4312%2033.5333%2017.1594%2033.5333%2015.8333C33.5365%2014.9279%2033.2884%2014.0394%2032.8167%2013.2667Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M31.0333%2015.8333C31.4753%2015.8333%2031.8993%2015.6577%2032.2118%2015.3452C32.5244%2015.0326%2032.7%2014.6087%2032.7%2014.1667V13.0883C32.5673%2012.8796%2032.4167%2012.6827%2032.25%2012.5H29.3666V14.1667C29.3666%2014.6087%2029.5422%2015.0326%2029.8548%2015.3452C30.1674%2015.6577%2030.5913%2015.8333%2031.0333%2015.8333Z'%20fill='%23141E21'/%3e%3cpath%20d='M16.15%2013.2667C16.115%2013.205%2016.0716%2013.1483%2016.0333%2013.0883V14.1667C16.0333%2014.6087%2015.8577%2015.0326%2015.5452%2015.3452C15.2326%2015.6577%2014.8087%2015.8333%2014.3667%2015.8333C13.9246%2015.8333%2013.5007%2015.6577%2013.1881%2015.3452C12.8756%2015.0326%2012.7%2014.6087%2012.7%2014.1667V12.5H8.14998C7.32164%2013.4123%206.86394%2014.6011%206.86665%2015.8333C6.86665%2017.1594%207.39343%2018.4312%208.33112%2019.3689C9.2688%2020.3065%2010.5406%2020.8333%2011.8667%2020.8333C13.1927%2020.8333%2014.4645%2020.3065%2015.4022%2019.3689C16.3399%2018.4312%2016.8666%2017.1594%2016.8666%2015.8333C16.8699%2014.9279%2016.6218%2014.0394%2016.15%2013.2667Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M14.3667%2015.8333C14.8087%2015.8333%2015.2326%2015.6577%2015.5452%2015.3452C15.8578%2015.0326%2016.0333%2014.6087%2016.0333%2014.1667V13.0883C15.9006%2012.8796%2015.7501%2012.6827%2015.5833%2012.5H12.7V14.1667C12.7%2014.6087%2012.8756%2015.0326%2013.1882%2015.3452C13.5007%2015.6577%2013.9247%2015.8333%2014.3667%2015.8333Z'%20fill='%23141E21'/%3e%3cpath%20d='M20.2%203.33336C30.325%203.33336%2038.5333%2010.4225%2038.5333%2019.1667H39.3458C39.1161%2014.2434%2036.9986%209.59783%2033.4332%206.19495C29.8678%202.79206%2025.1286%200.893433%2020.2%200.893433C15.2713%200.893433%2010.5321%202.79206%206.96673%206.19495C3.40135%209.59783%201.28387%2014.2434%201.05414%2019.1667H1.86664C1.86664%2010.4225%2010.075%203.33336%2020.2%203.33336Z'%20fill='%23FFE369'/%3e%3cpath%20d='M38.5333%2019.1667C38.5333%2027.9109%2030.325%2035.0001%2020.2%2035.0001C10.075%2035.0001%201.86666%2027.9109%201.86666%2019.1667H1.05416C1.04249%2019.4434%201.03333%2019.7209%201.03333%2020.0001C1.03333%2025.0834%203.05266%2029.9585%206.64711%2033.553C10.2416%2037.1474%2015.1167%2039.1667%2020.2%2039.1667C25.2833%2039.1667%2030.1584%2037.1474%2033.7529%2033.553C37.3473%2029.9585%2039.3667%2025.0834%2039.3667%2020.0001C39.3667%2019.7209%2039.3575%2019.4434%2039.3458%2019.1667H38.5333Z'%20fill='%23FFB32B'/%3e%3cpath%20d='M31.2933%207.75958C31.5617%207.49101%2031.4763%206.97052%2031.1026%206.59705C30.7289%206.22358%2030.2083%206.13855%2029.9399%206.40713C29.6716%206.67571%2029.7569%207.19619%2030.1307%207.56966C30.5044%207.94313%2031.025%208.02816%2031.2933%207.75958Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M25.7433%203.67143C25.8777%203.53698%2025.8351%203.2766%2025.6483%203.08987C25.4614%202.90313%2025.201%202.86075%2025.0666%202.9952C24.9323%203.12965%2024.9748%203.39003%2025.1617%203.57676C25.3486%203.7635%2025.609%203.80588%2025.7433%203.67143Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M29.4706%206.76974C30.0074%206.23258%2029.8364%205.19135%2029.0886%204.44408C28.3408%203.69681%2027.2994%203.52649%2026.7626%204.06364C26.2259%204.6008%2026.3969%205.64203%2027.1447%206.3893C27.8925%207.13657%2028.9338%207.3069%2029.4706%206.76974Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M28.5333%2020.8334C27.3547%2020.8323%2026.2143%2020.4149%2025.3135%2019.6548C24.4127%2018.8948%2023.8094%2017.8409%2023.61%2016.6792C23.4835%2017.3985%2023.5161%2018.1367%2023.7054%2018.8419C23.8948%2019.5472%2024.2364%2020.2025%2024.7061%2020.7616C25.1758%2021.3207%2025.7623%2021.7702%2026.4244%2022.0783C27.0864%2022.3865%2027.8079%2022.5459%2028.5382%2022.5454C29.2685%2022.5448%2029.9897%2022.3843%2030.6513%2022.0751C31.3129%2021.7659%2031.8987%2021.3156%2032.3676%2020.7558C32.8365%2020.1959%2033.177%2019.5402%2033.3653%2018.8346C33.5536%2018.129%2033.5851%2017.3908%2033.4575%2016.6717C33.2597%2017.8349%2032.6569%2018.8906%2031.7557%2019.6522C30.8546%2020.4138%2029.7132%2020.8322%2028.5333%2020.8334ZM11.8667%2020.8334C10.688%2020.8323%209.54766%2020.4149%208.64685%2019.6548C7.74604%2018.8948%207.1427%2017.8409%206.94332%2016.6792C6.81682%2017.3985%206.8494%2018.1367%207.03877%2018.8419C7.22813%2019.5472%207.56969%2020.2025%208.03942%2020.7616C8.50916%2021.3207%209.09567%2021.7702%209.75772%2022.0783C10.4198%2022.3865%2011.1413%2022.5459%2011.8715%2022.5454C12.6018%2022.5448%2013.3231%2022.3843%2013.9846%2022.0751C14.6462%2021.7659%2015.232%2021.3156%2015.7009%2020.7558C16.1698%2020.1959%2016.5104%2019.5402%2016.6987%2018.8346C16.887%2018.129%2016.9184%2017.3908%2016.7908%2016.6717C16.593%2017.8349%2015.9902%2018.8906%2015.0891%2019.6522C14.1879%2020.4138%2013.0465%2020.8322%2011.8667%2020.8334ZM29.3666%2012.5001H32.25C32.4167%2012.6828%2032.5673%2012.8797%2032.7%2013.0884C32.7383%2013.1484%2032.7833%2013.2051%2032.8167%2013.2667C33.222%2013.9378%2033.4596%2014.6968%2033.5092%2015.4792C33.5242%2015.3217%2033.5333%2015.1617%2033.5333%2015.0001C33.5365%2014.0947%2033.2884%2013.2062%2032.8167%2012.4334C32.7817%2012.3717%2032.7383%2012.3151%2032.7%2012.2551C32.5673%2012.0463%2032.4167%2011.8495%2032.25%2011.6667H24.8167C23.9883%2012.579%2023.5306%2013.7678%2023.5333%2015.0001C23.5335%2015.1766%2023.5429%2015.3529%2023.5617%2015.5284C23.623%2014.4055%2024.0658%2013.3372%2024.8167%2012.5001H29.3666ZM12.7%2012.5001H15.5833C15.75%2012.6828%2015.9006%2012.8797%2016.0333%2013.0884C16.0716%2013.1484%2016.1166%2013.2051%2016.15%2013.2667C16.5553%2013.9378%2016.7929%2014.6968%2016.8425%2015.4792C16.8575%2015.3217%2016.8666%2015.1617%2016.8666%2015.0001C16.8699%2014.0947%2016.6218%2013.2062%2016.15%2012.4334C16.115%2012.3717%2016.0716%2012.3151%2016.0333%2012.2551C15.9006%2012.0463%2015.75%2011.8495%2015.5833%2011.6667H8.14998C7.32164%2012.579%206.86394%2013.7678%206.86665%2015.0001C6.86681%2015.1766%206.87627%2015.3529%206.89498%2015.5284C6.95637%2014.4055%207.3991%2013.3372%208.14998%2012.5001H12.7Z'%20fill='%23FBB40A'/%3e%3c/svg%3e", kM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_4720_4251)'%3e%3cpath%20d='M10%2019.5833C15.2927%2019.5833%2019.5834%2015.2927%2019.5834%2010C19.5834%204.70727%2015.2927%200.416664%2010%200.416664C4.70729%200.416664%200.416687%204.70727%200.416687%2010C0.416687%2015.2927%204.70729%2019.5833%2010%2019.5833Z'%20fill='%23FFCE52'/%3e%3cpath%20d='M13.75%209.16666C14.4404%209.16666%2015%208.42047%2015%207.49999C15%206.57952%2014.4404%205.83333%2013.75%205.83333C13.0596%205.83333%2012.5%206.57952%2012.5%207.49999C12.5%208.42047%2013.0596%209.16666%2013.75%209.16666Z'%20fill='%23273941'/%3e%3cpath%20d='M6.25%209.16666C6.94036%209.16666%207.5%208.42047%207.5%207.49999C7.5%206.57952%206.94036%205.83333%206.25%205.83333C5.55964%205.83333%205%206.57952%205%207.49999C5%208.42047%205.55964%209.16666%206.25%209.16666Z'%20fill='%23273941'/%3e%3cpath%20d='M13.75%208.75C14.2103%208.75%2014.5834%208.19036%2014.5834%207.5C14.5834%206.80964%2014.2103%206.25%2013.75%206.25C13.2898%206.25%2012.9167%206.80964%2012.9167%207.5C12.9167%208.19036%2013.2898%208.75%2013.75%208.75Z'%20fill='%23141E21'/%3e%3cpath%20d='M6.25002%208.75C6.71026%208.75%207.08335%208.19036%207.08335%207.5C7.08335%206.80964%206.71026%206.25%206.25002%206.25C5.78978%206.25%205.41669%206.80964%205.41669%207.5C5.41669%208.19036%205.78978%208.75%206.25002%208.75Z'%20fill='%23141E21'/%3e%3cpath%20d='M14.1667%207.5C14.3968%207.5%2014.5833%207.31345%2014.5833%207.08333C14.5833%206.85321%2014.3968%206.66666%2014.1667%206.66666C13.9365%206.66666%2013.75%206.85321%2013.75%207.08333C13.75%207.31345%2013.9365%207.5%2014.1667%207.5Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M6.66667%207.5C6.89679%207.5%207.08333%207.31345%207.08333%207.08333C7.08333%206.85321%206.89679%206.66666%206.66667%206.66666C6.43655%206.66666%206.25%206.85321%206.25%207.08333C6.25%207.31345%206.43655%207.5%206.66667%207.5Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M10%2016.25C6.78335%2016.25%204.16669%2013.82%204.16669%2010.8333H5.00002C5.00002%2013.3604%207.24294%2015.4167%2010%2015.4167C12.7571%2015.4167%2015%2013.3604%2015%2010.8333H15.8334C15.8334%2013.82%2013.2167%2016.25%2010%2016.25Z'%20fill='%23273941'/%3e%3cpath%20d='M10%201.66666C15.0625%201.66666%2019.1667%205.21125%2019.1667%209.58333H19.573C19.4581%207.12169%2018.3993%204.7989%2016.6167%203.09746C14.834%201.39602%2012.4644%200.446701%2010%200.446701C7.53572%200.446701%205.16611%201.39602%203.38342%203.09746C1.60073%204.7989%200.541992%207.12169%200.427124%209.58333H0.833374C0.833374%205.21125%204.93754%201.66666%2010%201.66666Z'%20fill='%23FFE369'/%3e%3cpath%20d='M19.1667%209.58333C19.1667%2013.9554%2015.0625%2017.5%2010%2017.5C4.93752%2017.5%200.833354%2013.9554%200.833354%209.58333H0.427104C0.42127%209.72166%200.416687%209.86041%200.416687%209.99999C0.416687%2012.5417%201.42636%2014.9792%203.22358%2016.7764C5.0208%2018.5737%207.45836%2019.5833%2010%2019.5833C12.5417%2019.5833%2014.9792%2018.5737%2016.7765%2016.7764C18.5737%2014.9792%2019.5834%2012.5417%2019.5834%209.99999C19.5834%209.86041%2019.5788%209.72166%2019.5729%209.58333H19.1667Z'%20fill='%23FFB32B'/%3e%3cpath%20d='M15.755%204.08811C15.8892%203.95382%2015.8465%203.69358%2015.6596%203.50685C15.4728%203.32011%2015.2125%203.27759%2015.0783%203.41188C14.9441%203.54617%2014.9868%203.80642%2015.1737%203.99315C15.3605%204.17989%2015.6208%204.2224%2015.755%204.08811Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M12.9799%202.04376C13.0471%201.97653%2013.0258%201.84635%2012.9324%201.75298C12.8389%201.65961%2012.7087%201.63842%2012.6415%201.70565C12.5744%201.77287%2012.5956%201.90306%2012.6891%201.99643C12.7825%202.08979%2012.9127%202.11099%2012.9799%202.04376Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M14.8437%203.59319C15.1121%203.32461%2015.0265%202.80399%2014.6527%202.43036C14.2788%202.05673%2013.7581%201.97156%2013.4897%202.24014C13.2213%202.50872%2013.3068%203.02934%2013.6807%203.40297C14.0546%203.77661%2014.5753%203.86177%2014.8437%203.59319Z'%20fill='%23F6FAFD'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4720_4251'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", OM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_4720_4268)'%3e%3cpath%20d='M10%2019.5833C15.2927%2019.5833%2019.5834%2015.2927%2019.5834%2010C19.5834%204.70727%2015.2927%200.416664%2010%200.416664C4.70729%200.416664%200.416687%204.70727%200.416687%2010C0.416687%2015.2927%204.70729%2019.5833%2010%2019.5833Z'%20fill='%23FFCE52'/%3e%3cpath%20d='M2.91669%2010.8333C2.91669%2012.2167%206.08335%2013.75%2010%2013.75C13.9167%2013.75%2017.0834%2012.2167%2017.0834%2010.8333C17.0755%2011.6896%2016.8588%2012.5311%2016.4522%2013.2848C16.0456%2014.0384%2015.4614%2014.6815%2014.75%2015.1583C13.3605%2016.1398%2011.7012%2016.6667%2010%2016.6667C8.29888%2016.6667%206.63951%2016.1398%205.25002%2015.1583C4.53869%2014.6815%203.95439%2014.0384%203.54779%2013.2848C3.14119%2012.5311%202.92456%2011.6896%202.91669%2010.8333Z'%20fill='%23AE2D4C'/%3e%3cpath%20d='M17.0834%2010.8333C17.0834%2012.2167%2013.9167%2013.75%2010%2013.75C6.08335%2013.75%202.91669%2012.2167%202.91669%2010.8333C3.33335%2011.25%206.25002%2011.6667%2010%2011.6667C13.75%2011.6667%2016.6667%2011.25%2017.0834%2010.8333Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M13.75%209.16667C14.4404%209.16667%2015%208.42048%2015%207.5C15%206.57953%2014.4404%205.83334%2013.75%205.83334C13.0596%205.83334%2012.5%206.57953%2012.5%207.5C12.5%208.42048%2013.0596%209.16667%2013.75%209.16667Z'%20fill='%23273941'/%3e%3cpath%20d='M6.25%209.16667C6.94036%209.16667%207.5%208.42048%207.5%207.5C7.5%206.57953%206.94036%205.83334%206.25%205.83334C5.55964%205.83334%205%206.57953%205%207.5C5%208.42048%205.55964%209.16667%206.25%209.16667Z'%20fill='%23273941'/%3e%3cpath%20d='M13.75%208.75C14.2103%208.75%2014.5834%208.19036%2014.5834%207.5C14.5834%206.80964%2014.2103%206.25%2013.75%206.25C13.2898%206.25%2012.9167%206.80964%2012.9167%207.5C12.9167%208.19036%2013.2898%208.75%2013.75%208.75Z'%20fill='%23141E21'/%3e%3cpath%20d='M6.25002%208.75C6.71026%208.75%207.08335%208.19036%207.08335%207.5C7.08335%206.80964%206.71026%206.25%206.25002%206.25C5.78978%206.25%205.41669%206.80964%205.41669%207.5C5.41669%208.19036%205.78978%208.75%206.25002%208.75Z'%20fill='%23141E21'/%3e%3cpath%20d='M14.1667%207.5C14.3968%207.5%2014.5833%207.31345%2014.5833%207.08333C14.5833%206.85321%2014.3968%206.66666%2014.1667%206.66666C13.9365%206.66666%2013.75%206.85321%2013.75%207.08333C13.75%207.31345%2013.9365%207.5%2014.1667%207.5Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M6.66667%207.5C6.89679%207.5%207.08333%207.31345%207.08333%207.08333C7.08333%206.85321%206.89679%206.66666%206.66667%206.66666C6.43655%206.66666%206.25%206.85321%206.25%207.08333C6.25%207.31345%206.43655%207.5%206.66667%207.5Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M10%2014.5833C13.3175%2014.5833%2016.0888%2013.4829%2016.8617%2012.3058C17.0081%2011.8287%2017.0828%2011.3324%2017.0834%2010.8333C17.0834%2012.2167%2013.9167%2013.75%2010%2013.75C6.08335%2013.75%202.91669%2012.2167%202.91669%2010.8333C2.91722%2011.3324%202.99192%2011.8287%203.13835%2012.3058C3.91127%2013.4829%206.68252%2014.5833%2010%2014.5833Z'%20fill='%238A293D'/%3e%3cpath%20d='M16.4479%2011.9396C16.6252%2011.8098%2016.7734%2011.6443%2016.8828%2011.4538C16.9923%2011.2632%2017.0606%2011.0519%2017.0834%2010.8333C16.6667%2011.25%2013.75%2011.6667%2010%2011.6667C6.25002%2011.6667%203.33335%2011.25%202.91669%2010.8333C2.93946%2011.0519%203.00776%2011.2632%203.1172%2011.4538C3.22665%2011.6443%203.3748%2011.8098%203.5521%2011.9396C4.67627%2012.2475%207.08335%2012.5%2010%2012.5C12.9167%2012.5%2015.3238%2012.2475%2016.4479%2011.9396Z'%20fill='%23EDEDED'/%3e%3cpath%20d='M9.99998%201.66666C15.0625%201.66666%2019.1666%205.21125%2019.1666%209.58333H19.5729C19.458%207.12169%2018.3993%204.7989%2016.6166%203.09746C14.8339%201.39602%2012.4643%200.446701%209.99998%200.446701C7.53566%200.446701%205.16605%201.39602%203.38336%203.09746C1.60067%204.7989%200.541931%207.12169%200.427063%209.58333H0.833313C0.833313%205.21125%204.93748%201.66666%209.99998%201.66666Z'%20fill='%23FFE369'/%3e%3cpath%20d='M19.1667%209.58334C19.1667%2013.9554%2015.0625%2017.5%2010%2017.5C4.93752%2017.5%200.833354%2013.9554%200.833354%209.58334H0.427104C0.42127%209.72167%200.416687%209.86042%200.416687%2010C0.416687%2012.5417%201.42636%2014.9792%203.22358%2016.7764C5.0208%2018.5737%207.45836%2019.5833%2010%2019.5833C12.5417%2019.5833%2014.9792%2018.5737%2016.7765%2016.7764C18.5737%2014.9792%2019.5834%2012.5417%2019.5834%2010C19.5834%209.86042%2019.5788%209.72167%2019.5729%209.58334H19.1667Z'%20fill='%23FFB32B'/%3e%3cpath%20d='M15.755%204.08811C15.8892%203.95382%2015.8465%203.69358%2015.6596%203.50685C15.4728%203.32011%2015.2125%203.27759%2015.0783%203.41188C14.9441%203.54617%2014.9868%203.80642%2015.1737%203.99315C15.3605%204.17989%2015.6208%204.2224%2015.755%204.08811Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M12.9799%202.04376C13.0471%201.97653%2013.0258%201.84635%2012.9324%201.75298C12.8389%201.65961%2012.7087%201.63842%2012.6415%201.70565C12.5744%201.77287%2012.5956%201.90306%2012.6891%201.99643C12.7825%202.08979%2012.9127%202.11099%2012.9799%202.04376Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M14.8437%203.59319C15.1121%203.32461%2015.0265%202.80399%2014.6527%202.43036C14.2788%202.05673%2013.7581%201.97156%2013.4897%202.24014C13.2213%202.50872%2013.3068%203.02934%2013.6807%203.40297C14.0546%203.77661%2014.5753%203.86177%2014.8437%203.59319Z'%20fill='%23F6FAFD'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4720_4268'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", FM = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_4720_4287)'%3e%3cpath%20d='M10%2019.5833C15.2927%2019.5833%2019.5834%2015.2927%2019.5834%2010C19.5834%204.70727%2015.2927%200.416664%2010%200.416664C4.70729%200.416664%200.416687%204.70727%200.416687%2010C0.416687%2015.2927%204.70729%2019.5833%2010%2019.5833Z'%20fill='%23FFCE52'/%3e%3cpath%20d='M10%201.66666C15.0625%201.66666%2019.1667%205.21125%2019.1667%209.58333H19.573C19.4581%207.12169%2018.3993%204.7989%2016.6167%203.09746C14.834%201.39602%2012.4644%200.446701%2010%200.446701C7.53572%200.446701%205.16611%201.39602%203.38342%203.09746C1.60073%204.7989%200.541992%207.12169%200.427124%209.58333H0.833374C0.833374%205.21125%204.93754%201.66666%2010%201.66666Z'%20fill='%23FFE369'/%3e%3cpath%20d='M19.1667%209.58333C19.1667%2013.9554%2015.0625%2017.5%2010%2017.5C4.93752%2017.5%200.833354%2013.9554%200.833354%209.58333H0.427104C0.42127%209.72166%200.416687%209.86041%200.416687%209.99999C0.416687%2012.5417%201.42636%2014.9792%203.22358%2016.7764C5.0208%2018.5737%207.45836%2019.5833%2010%2019.5833C12.5417%2019.5833%2014.9792%2018.5737%2016.7765%2016.7764C18.5737%2014.9792%2019.5834%2012.5417%2019.5834%209.99999C19.5834%209.86041%2019.5788%209.72166%2019.5729%209.58333H19.1667Z'%20fill='%23FFB32B'/%3e%3cpath%20d='M15.5467%203.46311C15.6809%203.32882%2015.6382%203.06858%2015.4513%202.88185C15.2645%202.69511%2015.0042%202.65259%2014.87%202.78688C14.7358%202.92117%2014.7785%203.18142%2014.9654%203.36815C15.1522%203.55489%2015.4125%203.5974%2015.5467%203.46311Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M12.7717%201.83572C12.8389%201.7685%2012.8176%201.63831%2012.7242%201.54494C12.6307%201.45157%2012.5005%201.43038%2012.4333%201.49761C12.3662%201.56483%2012.3874%201.69502%2012.4809%201.78839C12.5743%201.88176%2012.7045%201.90295%2012.7717%201.83572Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M14.6354%202.96819C14.9038%202.69961%2014.8182%202.17899%2014.4443%201.80536C14.0704%201.43173%2013.5498%201.34656%2013.2814%201.61514C13.013%201.88372%2013.0985%202.40434%2013.4724%202.77797C13.8463%203.15161%2014.367%203.23677%2014.6354%202.96819Z'%20fill='%23F6FAFD'/%3e%3cpath%20d='M15%2010C16.3807%2010%2017.5%208.88071%2017.5%207.5C17.5%206.11929%2016.3807%205%2015%205C13.6193%205%2012.5%206.11929%2012.5%207.5C12.5%208.88071%2013.6193%2010%2015%2010Z'%20fill='url(%23paint0_radial_4720_4287)'/%3e%3cpath%20d='M5%2010C6.38071%2010%207.5%208.88071%207.5%207.5C7.5%206.11929%206.38071%205%205%205C3.61929%205%202.5%206.11929%202.5%207.5C2.5%208.88071%203.61929%2010%205%2010Z'%20fill='url(%23paint1_radial_4720_4287)'/%3e%3cpath%20d='M10%2011.6667C8.1621%2011.6667%206.66669%2010.3583%206.66669%208.74999H7.50002C7.50002%209.89874%208.62127%2010.8333%2010%2010.8333C11.3788%2010.8333%2012.5%209.89874%2012.5%208.74999H13.3334C13.3334%2010.3583%2011.8379%2011.6667%2010%2011.6667ZM15.8334%205.41666H15C15%205.08514%2014.8683%204.7672%2014.6339%204.53278C14.3995%204.29836%2014.0815%204.16666%2013.75%204.16666C13.4185%204.16666%2013.1006%204.29836%2012.8661%204.53278C12.6317%204.7672%2012.5%205.08514%2012.5%205.41666H11.6667C11.6667%204.86413%2011.8862%204.33422%2012.2769%203.94352C12.6676%203.55282%2013.1975%203.33333%2013.75%203.33333C14.3026%203.33333%2014.8325%203.55282%2015.2232%203.94352C15.6139%204.33422%2015.8334%204.86413%2015.8334%205.41666ZM8.33335%205.41666H7.50002C7.50002%205.08514%207.36832%204.7672%207.1339%204.53278C6.89948%204.29836%206.58154%204.16666%206.25002%204.16666C5.9185%204.16666%205.60056%204.29836%205.36614%204.53278C5.13172%204.7672%205.00002%205.08514%205.00002%205.41666H4.16669C4.16669%204.86413%204.38618%204.33422%204.77688%203.94352C5.16758%203.55282%205.69749%203.33333%206.25002%203.33333C6.80256%203.33333%207.33246%203.55282%207.72316%203.94352C8.11386%204.33422%208.33335%204.86413%208.33335%205.41666Z'%20fill='%23273941'/%3e%3c/g%3e%3cdefs%3e%3cradialGradient%20id='paint0_radial_4720_4287'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(15%207.5)%20scale(2.5)'%3e%3cstop%20stop-color='%23FF568D'/%3e%3cstop%20offset='0.454'%20stop-color='%23FF9678'/%3e%3cstop%20offset='0.817'%20stop-color='%23FFC26A'/%3e%3cstop%20offset='1'%20stop-color='%23FFD364'/%3e%3c/radialGradient%3e%3cradialGradient%20id='paint1_radial_4720_4287'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(5%200.208333)%20scale(0.208333)'%3e%3cstop%20stop-color='%23FF568D'/%3e%3cstop%20offset='0.454'%20stop-color='%23FF9678'/%3e%3cstop%20offset='0.817'%20stop-color='%23FFC26A'/%3e%3cstop%20offset='1'%20stop-color='%23FFD364'/%3e%3c/radialGradient%3e%3cclipPath%20id='clip0_4720_4287'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", hoe = [SM, PM, kM, OM, FM], zv = (t) => {
  var s, a, c, l, u, f, d, g;
  const [e, r] = N(t.defaultRating || 0), n = [
    "#FF426F",
    "#FF8744",
    "#FF9E00",
    "#FFDA45",
    "#8AB22D",
    "#0DC268",
    "#249C6A"
  ], A = (m) => {
    e !== m && (r(m), t.getCurrentRating && t.getCurrentRating(m));
  }, i = /* @__PURE__ */ k(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 45 45",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h("g", { clipPath: "url(#clip0_415_158)", children: /* @__PURE__ */ h(
          "path",
          {
            d: "M15.455 13.7626L3.4925 15.497L3.28063 15.5401C2.95989 15.6252 2.66749 15.794 2.4333 16.0291C2.19911 16.2642 2.03151 16.5573 1.94762 16.8783C1.86373 17.1994 1.86655 17.537 1.9558 17.8566C2.04506 18.1762 2.21753 18.4664 2.45563 18.6976L11.1219 27.1332L9.07813 39.0489L9.05375 39.2551C9.03412 39.5868 9.103 39.9178 9.25335 40.2142C9.40369 40.5105 9.6301 40.7616 9.90938 40.9417C10.1887 41.1218 10.5108 41.2244 10.8428 41.2391C11.1748 41.2537 11.5047 41.1799 11.7988 41.0251L22.4975 35.4001L33.1719 41.0251L33.3594 41.1114C33.6689 41.2333 34.0052 41.2706 34.3339 41.2196C34.6626 41.1687 34.9718 41.0312 35.2299 40.8212C35.4879 40.6113 35.6854 40.3365 35.8022 40.025C35.919 39.7136 35.9508 39.3767 35.8944 39.0489L33.8488 27.1332L42.5188 18.6957L42.665 18.5364C42.8739 18.279 43.0109 17.9709 43.062 17.6435C43.1131 17.316 43.0764 16.9808 42.9558 16.6721C42.8352 16.3634 42.6349 16.0922 42.3753 15.8861C42.1157 15.68 41.8062 15.5464 41.4781 15.4988L29.5156 13.7626L24.1681 2.9251C24.0134 2.6111 23.7738 2.34669 23.4766 2.16179C23.1794 1.9769 22.8363 1.87891 22.4863 1.87891C22.1362 1.87891 21.7931 1.9769 21.4959 2.16179C21.1987 2.34669 20.9591 2.6111 20.8044 2.9251L15.455 13.7626Z",
            fill: "#E2E2E2"
          }
        ) }),
        /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_158", children: /* @__PURE__ */ h("rect", { width: "45", height: "45", fill: "white" }) }) })
      ]
    }
  ), o = /* @__PURE__ */ k(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 45 45",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h("g", { clipPath: "url(#clip0_415_239)", children: /* @__PURE__ */ h(
          "path",
          {
            d: "M15.455 13.7626L3.4925 15.497L3.28063 15.5401C2.95989 15.6252 2.66749 15.794 2.4333 16.0291C2.19911 16.2642 2.03151 16.5573 1.94762 16.8783C1.86373 17.1994 1.86655 17.537 1.9558 17.8566C2.04506 18.1762 2.21753 18.4664 2.45563 18.6976L11.1219 27.1332L9.07813 39.0489L9.05375 39.2551C9.03412 39.5868 9.103 39.9178 9.25335 40.2142C9.40369 40.5105 9.6301 40.7616 9.90938 40.9417C10.1887 41.1218 10.5108 41.2244 10.8428 41.2391C11.1748 41.2537 11.5047 41.1799 11.7988 41.0251L22.4975 35.4001L33.1719 41.0251L33.3594 41.1114C33.6689 41.2333 34.0052 41.2706 34.3339 41.2196C34.6626 41.1687 34.9718 41.0312 35.2299 40.8212C35.4879 40.6113 35.6854 40.3365 35.8022 40.025C35.919 39.7136 35.9508 39.3767 35.8944 39.0489L33.8488 27.1332L42.5188 18.6957L42.665 18.5364C42.8739 18.279 43.0109 17.9709 43.062 17.6435C43.1131 17.316 43.0764 16.9808 42.9558 16.6721C42.8352 16.3634 42.6349 16.0922 42.3753 15.8861C42.1157 15.68 41.8062 15.5464 41.4781 15.4988L29.5156 13.7626L24.1681 2.9251C24.0134 2.6111 23.7738 2.34669 23.4766 2.16179C23.1794 1.9769 22.8363 1.87891 22.4863 1.87891C22.1362 1.87891 21.7931 1.9769 21.4959 2.16179C21.1987 2.34669 20.9591 2.6111 20.8044 2.9251L15.455 13.7626Z",
            fill: "#F9C23C"
          }
        ) }),
        /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_239", children: /* @__PURE__ */ h("rect", { width: "45", height: "45", fill: "white" }) }) })
      ]
    }
  );
  return /* @__PURE__ */ k("div", { style: { width: "100%" }, children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: t.type == "emoji" ? "emojiRatingContainer" : t.type == "star" ? "starContainer" : "ratingContainer",
        style: { ...(s = t.RatingStyle) == null ? void 0 : s.RatingContainer },
        children: Array(t.type === "star" && !t.count ? 5 : t.count).fill(0).map((m, p) => {
          var w, B;
          const v = e - 1 === p && t.type !== "star", C = [
            t.type === "emoji" ? "emojiStyle" : "",
            t.type === "colored" ? `coloredButtons coloredBackground-${p}` : "",
            t.type === "number" ? "numberButtons" : "",
            v ? `${t.type}Active` : ""
          ].filter(Boolean).join(" ");
          return /* @__PURE__ */ h(
            "div",
            {
              onClick: () => A(p + 1),
              className: C,
              style: {
                background: t.type == "colored" ? n[p] : "",
                ...(w = t == null ? void 0 : t.RatingStyle) == null ? void 0 : w.SingleRating,
                ...v ? (B = t == null ? void 0 : t.RatingStyle) == null ? void 0 : B.Hover : {}
              },
              children: t.type === "emoji" ? /* @__PURE__ */ h("div", { className: "singleEmojiCont", children: /* @__PURE__ */ h(
                "img",
                {
                  src: hoe[p],
                  alt: `Emoji ${p}`,
                  style: { width: "24px", height: "24px" }
                }
              ) }) : t.type === "star" ? /* @__PURE__ */ h("div", { children: p < e ? o : i }) : /* @__PURE__ */ h(
                "div",
                {
                  className: t.type == "colored" ? "singleColoredCont" : "singleNumberCont",
                  children: p + 1
                }
              )
            },
            p
          );
        })
      }
    ),
    (t.type === "number" || t.type === "colored" || t.type === "emoji") && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
      /* @__PURE__ */ h("div", { className: "ratingText", style: { ...(a = t.RatingStyle) == null ? void 0 : a.RatingText }, children: ((c = t.RatingStyle) == null ? void 0 : c.LeftRatingText) || t.leftText || "Not likely" }),
      /* @__PURE__ */ h("div", { className: "ratingText", style: { ...(l = t.RatingStyle) == null ? void 0 : l.RatingText }, children: ((u = t.RatingStyle) == null ? void 0 : u.RightRatingText) || t.rightText || "Very Likely" })
    ] }),
    t.type == "star" && /* @__PURE__ */ h("div", { style: { ...(f = t.RatingStyle) == null ? void 0 : f.RatingText }, className: "q-star-text-Cont", children: t.centerRatingText || ((d = t.RatingStyle) == null ? void 0 : d.RightRatingText) || ((g = t.RatingStyle) == null ? void 0 : g.LeftRatingText) || "Click to Rate" })
  ] });
}, dFe = ({
  heading: t,
  subHeading: e,
  userId: r,
  token: n,
  questId: A,
  btnColor: i,
  btnTextColor: o,
  textColor: s,
  font: a,
  bgColor: c,
  supportUrl: l,
  onSubmit: u,
  delay: f = 1e3,
  isInline: d = !1,
  crossLogoForInput: g = !1,
  onCancel: m = () => {
  },
  uniqueEmailId: p,
  uniqueUserId: v,
  enableVariation: C = !1
}) => {
  const [w, B] = N(0), [y, b] = N(""), [q, E] = N(!1), [x, M] = N(!1), [O, I] = N([]), [S, P] = N(!1), { apiKey: H, apiSecret: F, entityId: T, apiType: U } = Xe(ct.Context), [D, Q] = N({}), [Y, j] = N(!1), [Z, W] = N("");
  N(!0);
  let R = U == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const K = /* @__PURE__ */ k("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.6348 27.6848C19.7557 27.7237 19.8879 27.7142 20.0002 27.6601C20.1231 27.6009 20.2044 27.4975 20.2336 27.385L20.63 25.8568C20.7686 25.3223 20.9705 24.8068 21.2304 24.3202C21.634 23.5646 22.2447 22.9835 22.8113 22.4953L24.0102 21.4621C24.196 21.302 24.2938 21.062 24.2727 20.817L23.5958 12.9898C23.5617 12.5944 23.2313 12.2918 22.8364 12.2918L18.9625 12.2918C16.3489 12.2918 14.1468 14.1104 13.7245 16.5525L13.1366 19.9523C13.0556 20.4202 13.4155 20.8467 13.8877 20.8467L18.2053 20.8467C19.0195 20.8467 19.638 21.5772 19.5065 22.3796L18.9543 25.75C18.8787 26.2117 18.9003 26.6841 19.0177 27.137C19.0774 27.3668 19.2587 27.564 19.514 27.646L19.6348 27.6848L19.4437 28.2799L19.6348 27.6848ZM20.5428 28.7862C20.1407 28.98 19.6773 29.0114 19.2525 28.8749L19.1317 28.8361L19.3229 28.2411L19.1317 28.8361C18.4842 28.6281 17.979 28.1108 17.8078 27.4508C17.6466 26.8295 17.617 26.1814 17.7208 25.5479L18.273 22.1775C18.2801 22.1343 18.2468 22.0967 18.2053 22.0967L13.8877 22.0967C12.6383 22.0967 11.6921 20.9697 11.9048 19.7393L12.4928 16.3395C13.0243 13.266 15.774 11.0418 18.9625 11.0418L22.8364 11.0418C23.8811 11.0418 24.7512 11.8416 24.8412 12.8821L25.518 20.7093C25.5738 21.3541 25.3165 21.9866 24.8262 22.4091L23.6273 23.4422C23.0812 23.9127 22.6216 24.3688 22.333 24.9091C22.1192 25.3094 21.9536 25.7326 21.8399 26.1706L21.4435 27.6989C21.3191 28.1783 20.9861 28.5726 20.5428 28.7862ZM27.5269 22.0961C27.1926 22.1105 26.9062 21.859 26.8773 21.5255L26.0677 12.1617C26.0156 11.5602 26.4894 11.0418 27.0944 11.0418C27.6643 11.0418 28.125 11.5041 28.125 12.0729L28.125 21.4717C28.125 21.8064 27.8613 22.0817 27.5269 22.0961Z", fill: "#5E5E5E" }),
    /* @__PURE__ */ h("rect", { x: "-0.75", y: "0.75", width: "38.5", height: "38.5", rx: "19.25", transform: "matrix(-1 8.74228e-08 8.74228e-08 1 38.5 6.55671e-08)", stroke: "#AFAFAF", "stroke-width": "1.5" })
  ] }), L = /* @__PURE__ */ k("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ h("rect", { width: "40", height: "40", rx: "20", fill: "#252525" }),
    /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.3652 12.3152C20.2443 12.2763 20.1121 12.2858 19.9998 12.3399C19.8769 12.3991 19.7956 12.5025 19.7664 12.615L19.37 14.1432C19.2314 14.6777 19.0295 15.1932 18.7696 15.6798C18.366 16.4354 17.7553 17.0165 17.1887 17.5047L15.9898 18.5379C15.804 18.698 15.7062 18.938 15.7273 19.183L16.4042 27.0102C16.4383 27.4056 16.7687 27.7082 17.1636 27.7082H21.0375C23.6511 27.7082 25.8532 25.8896 26.2755 23.4475L26.8634 20.0477C26.9444 19.5798 26.5845 19.1533 26.1123 19.1533H21.7947C20.9805 19.1533 20.362 18.4228 20.4935 17.6204L21.0457 14.25C21.1213 13.7883 21.0997 13.3159 20.9823 12.863C20.9226 12.6332 20.7413 12.436 20.486 12.354L20.3652 12.3152L20.5563 11.7201L20.3652 12.3152ZM19.4572 11.2138C19.8593 11.02 20.3227 10.9886 20.7475 11.1251L20.8683 11.1639L20.6771 11.7589L20.8683 11.1639C21.5158 11.3719 22.021 11.8892 22.1922 12.5492C22.3534 13.1705 22.383 13.8186 22.2792 14.4521L21.727 17.8225C21.7199 17.8657 21.7532 17.9033 21.7947 17.9033L26.1123 17.9033C27.3617 17.9033 28.3079 19.0303 28.0952 20.2607L27.5072 23.6605C26.9757 26.734 24.226 28.9582 21.0375 28.9582H17.1636C16.1189 28.9582 15.2488 28.1584 15.1588 27.1179L14.482 19.2907C14.4262 18.6459 14.6835 18.0134 15.1738 17.5909L16.3727 16.5578C16.9188 16.0873 17.3784 15.6312 17.667 15.0909C17.8808 14.6906 18.0464 14.2674 18.1601 13.8294L18.5565 12.3011C18.6809 11.8217 19.0139 11.4274 19.4572 11.2138ZM12.4731 17.9039C12.8074 17.8895 13.0938 18.141 13.1227 18.4745L13.9323 27.8383C13.9844 28.4398 13.5106 28.9582 12.9056 28.9582C12.3357 28.9582 11.875 28.4959 11.875 27.9271L11.875 18.5283C11.875 18.1936 12.1387 17.9183 12.4731 17.9039Z", fill: "white" })
  ] }), G = /* @__PURE__ */ h(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ h(
        "path",
        {
          d: "M12 0C13.1016 0 14.1641 0.140625 15.1875 0.421875C16.2109 0.703125 17.1641 1.10938 18.0469 1.64062C18.9297 2.17188 19.7383 2.79688 20.4727 3.51562C21.207 4.23438 21.8359 5.04297 22.3594 5.94141C22.8828 6.83984 23.2852 7.79688 23.5664 8.8125C23.8477 9.82812 23.9922 10.8906 24 12C24 13.1016 23.8594 14.1641 23.5781 15.1875C23.2969 16.2109 22.8906 17.1641 22.3594 18.0469C21.8281 18.9297 21.2031 19.7383 20.4844 20.4727C19.7656 21.207 18.957 21.8359 18.0586 22.3594C17.1602 22.8828 16.2031 23.2852 15.1875 23.5664C14.1719 23.8477 13.1094 23.9922 12 24C10.8984 24 9.83594 23.8594 8.8125 23.5781C7.78906 23.2969 6.83594 22.8906 5.95312 22.3594C5.07031 21.8281 4.26172 21.2031 3.52734 20.4844C2.79297 19.7656 2.16406 18.957 1.64062 18.0586C1.11719 17.1602 0.714844 16.2031 0.433594 15.1875C0.152344 14.1719 0.0078125 13.1094 0 12C0 10.8984 0.140625 9.83594 0.421875 8.8125C0.703125 7.78906 1.10938 6.83594 1.64062 5.95312C2.17188 5.07031 2.79688 4.26172 3.51562 3.52734C4.23438 2.79297 5.04297 2.16406 5.94141 1.64062C6.83984 1.11719 7.79688 0.714844 8.8125 0.433594C9.82812 0.152344 10.8906 0.0078125 12 0ZM19.0664 8.02734L17.4727 6.43359L9.75 14.1562L6.52734 10.9336L4.93359 12.5273L9.75 17.3438L19.0664 8.02734Z",
          fill: "#046A46"
        }
      )
    }
  ), V = (oe, ce) => {
    B(ce), Q({
      ...D,
      [oe]: ce
    });
  }, _ = (oe, ce) => {
    ce.length > 0 ? Q({
      ...D,
      [oe]: ce
    }) : Q({
      ...D,
      [oe]: "none"
    }), ee();
  }, J = (oe) => {
    B(oe), E(!0);
  };
  le(() => {
    if (c && P(
      (c == null ? void 0 : c.includes("linear-gradient")) || (c == null ? void 0 : c.includes("radial-gradient"))
    ), T) {
      const oe = {
        apiKey: H,
        apisecret: F,
        userId: r,
        token: n
      }, ce = `${R}api/entities/${T}/quests/${A}?userId=${r}&getVariation=${C}`;
      Oe.get(ce, { headers: oe }).then((pe) => {
        var Te;
        let qe = pe.data;
        W(qe.session);
        let Se = (Te = qe == null ? void 0 : qe.eligibilityData) == null ? void 0 : Te.map((be) => {
          var He, Ge, Le, Ae, Pe, it, de, xe, he, Qe;
          return {
            type: (He = be == null ? void 0 : be.data) == null ? void 0 : He.criteriaType,
            question: (Le = (Ge = be == null ? void 0 : be.data) == null ? void 0 : Ge.metadata) == null ? void 0 : Le.title,
            options: ((Pe = (Ae = be == null ? void 0 : be.data) == null ? void 0 : Ae.metadata) == null ? void 0 : Pe.options) || [],
            criteriaId: (it = be == null ? void 0 : be.data) == null ? void 0 : it.criteriaId,
            required: !((xe = (de = be == null ? void 0 : be.data) == null ? void 0 : de.metadata) != null && xe.isOptional),
            placeholder: (Qe = (he = be == null ? void 0 : be.data) == null ? void 0 : he.metadata) == null ? void 0 : Qe.placeholder
          };
        });
        Se = Array.isArray(Se) ? Se : [], I([...Se]);
      });
    }
    T && v && new Bt("").getExternalLogin({ apiType: U, uniqueUserId: v, entityId: T, userId: r, apiKey: H, apiSecret: F, token: n, uniqueEmailId: p });
  }, []);
  const X = (oe, ce, pe, qe) => {
    if (oe.target.checked === !0 && pe === "check") {
      let Se = D[ce] || [];
      Se.push(oe.target.value), Q({
        ...D,
        [ce]: Se
      });
    } else if (oe.target.checked === !1 && typeof D[ce] == "object" && pe === "check") {
      let Te = D[ce].filter((be) => be !== oe.target.value);
      Q({
        ...D,
        [ce]: Te
      });
    } else
      Q({
        ...D,
        [ce]: oe.target.value
      });
  }, ne = (oe) => {
    Q({
      ...D,
      [oe]: ""
    });
  };
  function ee() {
    const oe = {
      apiKey: H,
      apisecret: F,
      userId: r,
      token: n
    };
    if (D.length !== 0) {
      const ce = O.map((Se) => ({
        question: (Se == null ? void 0 : Se.question) || "",
        answer: [D[Se == null ? void 0 : Se.criteriaId] || ""],
        criteriaId: (Se == null ? void 0 : Se.criteriaId) || ""
      })), pe = `${R}api/entities/${T}/quests/${A}/verify-all?userId=${r}&getVariation=${C}`, qe = {
        criterias: ce,
        userId: r,
        session: Z
      };
      j(!0), Oe.post(pe, qe, { headers: oe }).then((Se) => {
        Se.data.success ? (rs.success("Thank you for your feedback"), M(!0), u && u()) : Ir.error(Se.data.error);
      }).catch((Se) => {
        console.error("Error:", Se);
      }).finally(() => {
        j(!1);
      });
    } else
      Ir.error("Please fill in all required fields.");
  }
  const $ = /* @__PURE__ */ k("svg", { width: "32", height: "32", viewBox: "0 0 45 45", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ h("g", { clipPath: "url(#clip0_415_158)", children: /* @__PURE__ */ h("path", { d: "M15.455 13.7626L3.4925 15.497L3.28063 15.5401C2.95989 15.6252 2.66749 15.794 2.4333 16.0291C2.19911 16.2642 2.03151 16.5573 1.94762 16.8783C1.86373 17.1994 1.86655 17.537 1.9558 17.8566C2.04506 18.1762 2.21753 18.4664 2.45563 18.6976L11.1219 27.1332L9.07813 39.0489L9.05375 39.2551C9.03412 39.5868 9.103 39.9178 9.25335 40.2142C9.40369 40.5105 9.6301 40.7616 9.90938 40.9417C10.1887 41.1218 10.5108 41.2244 10.8428 41.2391C11.1748 41.2537 11.5047 41.1799 11.7988 41.0251L22.4975 35.4001L33.1719 41.0251L33.3594 41.1114C33.6689 41.2333 34.0052 41.2706 34.3339 41.2196C34.6626 41.1687 34.9718 41.0312 35.2299 40.8212C35.4879 40.6113 35.6854 40.3365 35.8022 40.025C35.919 39.7136 35.9508 39.3767 35.8944 39.0489L33.8488 27.1332L42.5188 18.6957L42.665 18.5364C42.8739 18.279 43.0109 17.9709 43.062 17.6435C43.1131 17.316 43.0764 16.9808 42.9558 16.6721C42.8352 16.3634 42.6349 16.0922 42.3753 15.8861C42.1157 15.68 41.8062 15.5464 41.4781 15.4988L29.5156 13.7626L24.1681 2.9251C24.0134 2.6111 23.7738 2.34669 23.4766 2.16179C23.1794 1.9769 22.8363 1.87891 22.4863 1.87891C22.1362 1.87891 21.7931 1.9769 21.4959 2.16179C21.1987 2.34669 20.9591 2.6111 20.8044 2.9251L15.455 13.7626Z", fill: "#E2E2E2" }) }),
    /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_158", children: /* @__PURE__ */ h("rect", { width: "45", height: "45", fill: "white" }) }) })
  ] }), te = /* @__PURE__ */ k("svg", { width: "32", height: "32", viewBox: "0 0 45 45", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ h("g", { clipPath: "url(#clip0_415_239)", children: /* @__PURE__ */ h("path", { d: "M15.455 13.7626L3.4925 15.497L3.28063 15.5401C2.95989 15.6252 2.66749 15.794 2.4333 16.0291C2.19911 16.2642 2.03151 16.5573 1.94762 16.8783C1.86373 17.1994 1.86655 17.537 1.9558 17.8566C2.04506 18.1762 2.21753 18.4664 2.45563 18.6976L11.1219 27.1332L9.07813 39.0489L9.05375 39.2551C9.03412 39.5868 9.103 39.9178 9.25335 40.2142C9.40369 40.5105 9.6301 40.7616 9.90938 40.9417C10.1887 41.1218 10.5108 41.2244 10.8428 41.2391C11.1748 41.2537 11.5047 41.1799 11.7988 41.0251L22.4975 35.4001L33.1719 41.0251L33.3594 41.1114C33.6689 41.2333 34.0052 41.2706 34.3339 41.2196C34.6626 41.1687 34.9718 41.0312 35.2299 40.8212C35.4879 40.6113 35.6854 40.3365 35.8022 40.025C35.919 39.7136 35.9508 39.3767 35.8944 39.0489L33.8488 27.1332L42.5188 18.6957L42.665 18.5364C42.8739 18.279 43.0109 17.9709 43.062 17.6435C43.1131 17.316 43.0764 16.9808 42.9558 16.6721C42.8352 16.3634 42.6349 16.0922 42.3753 15.8861C42.1157 15.68 41.8062 15.5464 41.4781 15.4988L29.5156 13.7626L24.1681 2.9251C24.0134 2.6111 23.7738 2.34669 23.4766 2.16179C23.1794 1.9769 22.8363 1.87891 22.4863 1.87891C22.1362 1.87891 21.7931 1.9769 21.4959 2.16179C21.1987 2.34669 20.9591 2.6111 20.8044 2.9251L15.455 13.7626Z", fill: "#F9C23C" }) }),
    /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_239", children: /* @__PURE__ */ h("rect", { width: "45", height: "45", fill: "white" }) }) })
  ] });
  function ae(oe) {
    return oe ? !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(oe) : !1;
  }
  const se = (oe, ce, pe) => /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ h(
      "label",
      {
        className: "q-fdov-levels",
        htmlFor: "normalInput",
        style: {
          fontFamily: a,
          color: s
        },
        children: oe
      }
    ),
    /* @__PURE__ */ k("div", { className: "q-fdov-input", children: [
      /* @__PURE__ */ h(
        "input",
        {
          className: "q_sdk_input q_fw_input",
          type: "text",
          id: "normalInput",
          name: "normalInput",
          onChange: (qe) => X(qe, ce, ""),
          value: D[ce],
          placeholder: pe
        }
      ),
      g && L9(ce, ne)
    ] })
  ] }, ce), ue = (oe, ce, pe) => /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ h(
      "label",
      {
        className: "q-fdov-levels",
        htmlFor: "normalInput",
        style: {
          fontFamily: a,
          color: s
        },
        children: oe
      }
    ),
    /* @__PURE__ */ k("div", { className: "q-fdov-input", children: [
      /* @__PURE__ */ h(
        "input",
        {
          className: "q_sdk_input q_fw_input",
          type: "email",
          id: "normalInput",
          name: "normalInput",
          onChange: (qe) => X(qe, ce, ""),
          value: D[ce],
          placeholder: pe
        }
      ),
      g ? L9(ce, ne) : S1()
    ] }),
    ae(D[ce]) && /* @__PURE__ */ h("div", { className: "q-input-email-checks", children: "This is not a valid email" })
  ] }, ce), fe = (oe, ce, pe) => /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ h(
      "label",
      {
        className: "q-fdov-levels",
        children: oe
      }
    ),
    /* @__PURE__ */ k("div", { className: "q_feedback_input", style: { alignItems: "flex-start" }, children: [
      /* @__PURE__ */ h(
        "textarea",
        {
          className: "q_fw_textarea",
          id: "normalInput2",
          name: "normalInput",
          onChange: (qe) => X(qe, ce, ""),
          value: D[ce],
          placeholder: pe
        }
      ),
      g && L9(ce, ne)
    ] })
  ] }, ce), ve = (oe, ce) => /* @__PURE__ */ h("div", { className: "", children: /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "like-dislike-cont", children: [
      /* @__PURE__ */ h("div", { className: "icon-inside-like-dislike", children: G }),
      /* @__PURE__ */ h("div", { className: "p-2", style: { color: "#00A96D" }, children: "Thanks again for your feedback." })
    ] }),
    /* @__PURE__ */ h(
      "div",
      {
        style: {
          margin: "5% 0% 1% 0%",
          fontSize: "18px",
          fontFamily: a,
          color: s
        },
        children: "Tell us more"
      }
    ),
    /* @__PURE__ */ k("div", { className: "q-fd-input", children: [
      Ste(),
      /* @__PURE__ */ h(
        "input",
        {
          placeholder: "Comments",
          type: "text",
          className: "q_sdk_input",
          value: ce,
          maxLength: 200,
          onChange: (pe) => b(pe.target.value)
        }
      ),
      Ite(b)
    ] }),
    /* @__PURE__ */ k("div", { className: "q-cmts", children: [
      ce.length,
      "/200"
    ] }),
    /* @__PURE__ */ k("div", { className: "q-feed-desc", children: [
      "We’re unable to respond directly to your feedback. If you have a customer support inquiry, please",
      " ",
      /* @__PURE__ */ h(
        "div",
        {
          onClick: () => window.location.href = `${l}`,
          style: {
            fontWeight: "600",
            textDecoration: "underline",
            display: "inline"
          },
          children: "contact customer support."
        }
      )
    ] }),
    /* @__PURE__ */ k("div", { className: "q-feed-btns-div", children: [
      /* @__PURE__ */ h(
        "button",
        {
          onClick: () => _(oe, ce),
          className: "q-btn-feed",
          children: "Skip"
        }
      ),
      /* @__PURE__ */ h(
        "button",
        {
          onClick: () => _(oe, ce),
          className: "q-btn-feed",
          style: {
            backgroundColor: i || "#333333",
            color: o || "white"
          },
          children: "Submit"
        }
      )
    ] })
  ] }) }), ge = (oe, ce, pe, qe) => /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: "q-onb-singleChoiceOne-lebel",
        children: [
          ce,
          " ",
          pe && "*"
        ]
      }
    ),
    /* @__PURE__ */ h("div", { className: "q-onb-singleChoiceOne-optDiv", children: oe.map((Se, Te) => /* @__PURE__ */ k("div", { className: "q_onb_singlehoiceOne_lebel", children: [
      /* @__PURE__ */ h(
        "input",
        {
          id: `sct${qe + Te}`,
          type: "radio",
          value: Se,
          checked: D[qe] == Se,
          onChange: (be) => X(be, qe, "radio"),
          name: `default-radio${qe}`,
          className: "q-onb-singleChoiceOne-inp"
        }
      ),
      /* @__PURE__ */ h(
        "label",
        {
          htmlFor: `sct${qe + Te}`,
          className: "q-onb-singleChoiceOne-lebel3",
          children: Se
        }
      )
    ] }, Te)) })
  ] }, qe);
  return /* @__PURE__ */ h(
    "div",
    {
      style: {
        ...S ? { backgroundImage: c } : { backgroundColor: c }
      },
      className: "q-feedback-cont",
      children: O.length > 0 ? O[0].type !== "LIKE_DISLIKE" && O[0].type !== "RATING" ? /* @__PURE__ */ k(Ze, { children: [
        !x && /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h("div", { className: "q-fd-topbar", children: /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-fd-heading",
                style: {
                  fontFamily: a,
                  color: s,
                  fontSize: "24px"
                },
                children: t
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-fd-sub",
                style: {
                  fontFamily: a,
                  color: s
                },
                children: e
              }
            )
          ] }) }),
          /* @__PURE__ */ k("form", { style: { padding: "20px", boxSizing: "content-box", display: "flex", flexDirection: "column", gap: "12px" }, children: [
            O.map((oe) => {
              if (oe.type === "USER_INPUT_TEXT")
                return se(
                  oe.question || "",
                  oe.criteriaId || "",
                  oe.placeholder || void 0
                );
              if (oe.type === "USER_INPUT_EMAIL")
                return ue(
                  oe.question || "",
                  oe.criteriaId || "",
                  oe.placeholder || void 0
                );
              if (oe.type === "USER_INPUT_SINGLE_CHOICE")
                return ge(
                  oe.options || [],
                  (oe == null ? void 0 : oe.question) || "",
                  (oe == null ? void 0 : oe.required) || !1,
                  oe.criteriaId || ""
                );
              if (oe.type === "USER_INPUT_TEXTAREA")
                return fe(
                  oe.question || "",
                  oe.criteriaId || "",
                  oe.placeholder || void 0
                );
              if (oe.type === "RATING")
                return /* @__PURE__ */ k("div", { className: "mb-4", children: [
                  /* @__PURE__ */ h(
                    "label",
                    {
                      className: "q-fd-lebels",
                      children: oe.question || "Rating Scale"
                    }
                  ),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      style: {
                        display: "flex",
                        marginTop: "5px"
                      },
                      children: /* @__PURE__ */ h(
                        zv,
                        {
                          count: 5,
                          getCurrentRating: (ce) => V(oe.criteriaId, ce),
                          type: "number"
                        }
                      )
                    }
                  )
                ] });
            }),
            /* @__PURE__ */ k("div", { className: "q_feedback_buttons", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  onClick: () => m(),
                  className: "q-fdov-btn-cancel",
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    backgroundColor: i,
                    color: o,
                    fontFamily: a
                  },
                  onClick: ee,
                  className: "q-fdov-btn-continue",
                  children: "Submit"
                }
              )
            ] })
          ] })
        ] }),
        x && /* @__PURE__ */ k("div", { className: "like-dislike-cont", children: [
          /* @__PURE__ */ h("div", { className: "icon-inside-like-dislike", children: G }),
          /* @__PURE__ */ h("div", { className: "p-2", style: { color: "#00A96D" }, children: "Thanks again for your feedback." })
        ] })
      ] }) : O[0].type === "LIKE_DISLIKE" ? /* @__PURE__ */ k("div", { className: "", children: [
        !q && /* @__PURE__ */ k(
          "div",
          {
            className: "q-fd-like-dislike",
            children: [
              /* @__PURE__ */ k("div", { className: "q-fd-like-dislike-txt", children: [
                /* @__PURE__ */ h("div", { children: "Are these results helpful?" }),
                /* @__PURE__ */ h("div", { children: "Your feedback helps us improve search results" })
              ] }),
              /* @__PURE__ */ k("div", { className: "like-dislike-cont", children: [
                /* @__PURE__ */ h("div", { style: { display: "inline" }, onClick: () => E(!0), children: K }),
                /* @__PURE__ */ h("div", { style: { display: "inline" }, onClick: () => E(!0), children: L })
              ] })
            ]
          }
        ),
        q && ve(O[0].criteriaId, y)
      ] }) : O[0].type === "RATING" ? /* @__PURE__ */ k("div", { className: "", children: [
        /* @__PURE__ */ k("div", { className: "mb-4", children: [
          /* @__PURE__ */ h(
            "label",
            {
              className: "q-fd-lebels",
              children: "Rating Scale"
            }
          ),
          /* @__PURE__ */ h("div", { style: { display: "flex", padding: "2% 0% 2%" }, children: [1, 2, 3, 4, 5].map((oe) => /* @__PURE__ */ h(
            "div",
            {
              className: "q-star-div",
              onClick: () => J(oe),
              children: oe <= w ? te : $
            },
            oe
          )) })
        ] }),
        q && ve(O[0].criteriaId, y)
      ] }) : null : /* @__PURE__ */ h("div", { className: "", children: /* @__PURE__ */ h("div", { className: "q-center", children: "Form data is empty" }) })
    }
  );
};
var TM = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = A(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        e.call(i, s) && i[s] && (o = A(o, s));
      return o;
    }
    function A(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(TM);
var poe = TM.exports;
const i7 = /* @__PURE__ */ Vr(poe);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const goe = "react-tooltip-core-styles", moe = "react-tooltip-base-styles", rB = { core: !1, base: !1 };
function nB({ css: t, id: e = moe, type: r = "base", ref: n }) {
  var A, i;
  if (!t || typeof document > "u" || rB[r] || r === "core" && typeof process < "u" && (!((A = process == null ? void 0 : process.env) === null || A === void 0) && A.REACT_TOOLTIP_DISABLE_CORE_STYLES) || r !== "base" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  r === "core" && (e = goe), n || (n = {});
  const { insertAt: o } = n;
  if (document.getElementById(e)) return;
  const s = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
  a.id = e, a.type = "text/css", o === "top" && s.firstChild ? s.insertBefore(a, s.firstChild) : s.appendChild(a), a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(document.createTextNode(t)), rB[r] = !0;
}
const AB = async ({ elementReference: t = null, tooltipReference: e = null, tooltipArrowReference: r = null, place: n = "top", offset: A = 10, strategy: i = "absolute", middlewares: o = [Fne(Number(A)), Mne({ fallbackAxisSideDirection: "start" }), Tne({ padding: 5 })], border: s }) => {
  if (!t) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  if (e === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  const a = o;
  return r ? (a.push(Hne({ element: r, padding: 5 })), Fb(t, e, { placement: n, strategy: i, middleware: a }).then(({ x: c, y: l, placement: u, middlewareData: f }) => {
    var d, g;
    const m = { left: `${c}px`, top: `${l}px`, border: s }, { x: p, y: v } = (d = f.arrow) !== null && d !== void 0 ? d : { x: 0, y: 0 }, C = (g = { top: "bottom", right: "left", bottom: "top", left: "right" }[u.split("-")[0]]) !== null && g !== void 0 ? g : "bottom", w = s && { borderBottom: s, borderRight: s };
    let B = 0;
    if (s) {
      const y = `${s}`.match(/(\d+)px/);
      B = y != null && y[1] ? Number(y[1]) : 1;
    }
    return { tooltipStyles: m, tooltipArrowStyles: { left: p != null ? `${p}px` : "", top: v != null ? `${v}px` : "", right: "", bottom: "", ...w, [C]: `-${4 + B}px` }, place: u };
  })) : Fb(t, e, { placement: "bottom", strategy: i, middleware: a }).then(({ x: c, y: l, placement: u }) => ({ tooltipStyles: { left: `${c}px`, top: `${l}px` }, tooltipArrowStyles: {}, place: u }));
}, iB = (t, e) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(t, e), oB = (t, e, r) => {
  let n = null;
  const A = function(...i) {
    const o = () => {
      n = null;
    };
    !n && (t.apply(this, i), n = setTimeout(o, e));
  };
  return A.cancel = () => {
    n && (clearTimeout(n), n = null);
  }, A;
}, sB = (t) => t !== null && !Array.isArray(t) && typeof t == "object", o7 = (t, e) => {
  if (t === e) return !0;
  if (Array.isArray(t) && Array.isArray(e)) return t.length === e.length && t.every((A, i) => o7(A, e[i]));
  if (Array.isArray(t) !== Array.isArray(e)) return !1;
  if (!sB(t) || !sB(e)) return t === e;
  const r = Object.keys(t), n = Object.keys(e);
  return r.length === n.length && r.every((A) => o7(t[A], e[A]));
}, voe = (t) => {
  if (!(t instanceof HTMLElement || t instanceof SVGElement)) return !1;
  const e = getComputedStyle(t);
  return ["overflow", "overflow-x", "overflow-y"].some((r) => {
    const n = e.getPropertyValue(r);
    return n === "auto" || n === "scroll";
  });
}, aB = (t) => {
  if (!t) return null;
  let e = t.parentElement;
  for (; e; ) {
    if (voe(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, qoe = typeof window < "u" ? _p : le, Ii = (t) => {
  t.current && (clearTimeout(t.current), t.current = null);
}, yoe = "DEFAULT_TOOLTIP_ID", Coe = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, woe = UA({ getTooltipData: () => Coe });
function MM(t = yoe) {
  return Xe(woe).getTooltipData(t);
}
var wl = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, e6 = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const boe = ({ forwardRef: t, id: e, className: r, classNameArrow: n, variant: A = "dark", anchorId: i, anchorSelect: o, place: s = "top", offset: a = 10, events: c = ["hover"], openOnClick: l = !1, positionStrategy: u = "absolute", middlewares: f, wrapper: d, delayShow: g = 0, delayHide: m = 0, float: p = !1, hidden: v = !1, noArrow: C = !1, clickable: w = !1, closeOnEsc: B = !1, closeOnScroll: y = !1, closeOnResize: b = !1, openEvents: q, closeEvents: E, globalCloseEvents: x, imperativeModeOnly: M, style: O, position: I, afterShow: S, afterHide: P, disableTooltip: H, content: F, contentWrapperRef: T, isOpen: U, defaultIsOpen: D = !1, setIsOpen: Q, activeAnchor: Y, setActiveAnchor: j, border: Z, opacity: W, arrowColor: R, role: K = "tooltip" }) => {
  var L;
  const G = gt(null), V = gt(null), _ = gt(null), J = gt(null), X = gt(null), [ne, ee] = N({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [$, te] = N(!1), [ae, se] = N(!1), [ue, fe] = N(null), ve = gt(!1), ge = gt(null), { anchorRefs: oe, setActiveAnchor: ce } = MM(e), pe = gt(!1), [qe, Se] = N([]), Te = gt(!1), be = l || c.includes("click"), He = be || (q == null ? void 0 : q.click) || (q == null ? void 0 : q.dblclick) || (q == null ? void 0 : q.mousedown), Ge = q ? { ...q } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !q && be && Object.assign(Ge, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Le = E ? { ...E } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !E && be && Object.assign(Le, { mouseleave: !1, blur: !1, mouseout: !1 });
  const Ae = x ? { ...x } : { escape: B || !1, scroll: y || !1, resize: b || !1, clickOutsideAnchor: He || !1 };
  M && (Object.assign(Ge, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Le, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(Ae, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), qoe(() => (Te.current = !0, () => {
    Te.current = !1;
  }), []);
  const Pe = (Ye) => {
    Te.current && (Ye && se(!0), setTimeout(() => {
      Te.current && (Q == null || Q(Ye), U === void 0 && te(Ye));
    }, 10));
  };
  le(() => {
    if (U === void 0) return () => null;
    U && se(!0);
    const Ye = setTimeout(() => {
      te(U);
    }, 10);
    return () => {
      clearTimeout(Ye);
    };
  }, [U]), le(() => {
    if ($ !== ve.current) if (Ii(X), ve.current = $, $) S == null || S();
    else {
      const Ye = (($e) => {
        const nt = $e.match(/^([\d.]+)(ms|s)$/);
        if (!nt) return 0;
        const [, mt, me] = nt;
        return Number(mt) * (me === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      X.current = setTimeout(() => {
        se(!1), fe(null), P == null || P();
      }, Ye + 25);
    }
  }, [$]);
  const it = (Ye) => {
    ee(($e) => o7($e, Ye) ? $e : Ye);
  }, de = (Ye = g) => {
    Ii(_), ae ? Pe(!0) : _.current = setTimeout(() => {
      Pe(!0);
    }, Ye);
  }, xe = (Ye = m) => {
    Ii(J), J.current = setTimeout(() => {
      pe.current || Pe(!1);
    }, Ye);
  }, he = (Ye) => {
    var $e;
    if (!Ye) return;
    const nt = ($e = Ye.currentTarget) !== null && $e !== void 0 ? $e : Ye.target;
    if (!(nt != null && nt.isConnected)) return j(null), void ce({ current: null });
    g ? de() : Pe(!0), j(nt), ce({ current: nt }), Ii(J);
  }, Qe = () => {
    w ? xe(m || 100) : m ? xe() : Pe(!1), Ii(_);
  }, Re = ({ x: Ye, y: $e }) => {
    var nt;
    const mt = { getBoundingClientRect: () => ({ x: Ye, y: $e, width: 0, height: 0, top: $e, left: Ye, right: Ye, bottom: $e }) };
    AB({ place: (nt = ue == null ? void 0 : ue.place) !== null && nt !== void 0 ? nt : s, offset: a, elementReference: mt, tooltipReference: G.current, tooltipArrowReference: V.current, strategy: u, middlewares: f, border: Z }).then((me) => {
      it(me);
    });
  }, pt = (Ye) => {
    if (!Ye) return;
    const $e = Ye, nt = { x: $e.clientX, y: $e.clientY };
    Re(nt), ge.current = nt;
  }, ze = (Ye) => {
    var $e;
    if (!$) return;
    const nt = Ye.target;
    nt.isConnected && (!(($e = G.current) === null || $e === void 0) && $e.contains(nt) || [document.querySelector(`[id='${i}']`), ...qe].some((mt) => mt == null ? void 0 : mt.contains(nt)) || (Pe(!1), Ii(_)));
  }, lt = oB(he, 50), st = oB(Qe, 50), We = (Ye) => {
    st.cancel(), lt(Ye);
  }, Je = () => {
    lt.cancel(), st();
  }, ut = Kn(() => {
    var Ye, $e;
    const nt = (Ye = ue == null ? void 0 : ue.position) !== null && Ye !== void 0 ? Ye : I;
    nt ? Re(nt) : p ? ge.current && Re(ge.current) : Y != null && Y.isConnected && AB({ place: ($e = ue == null ? void 0 : ue.place) !== null && $e !== void 0 ? $e : s, offset: a, elementReference: Y, tooltipReference: G.current, tooltipArrowReference: V.current, strategy: u, middlewares: f, border: Z }).then((mt) => {
      Te.current && it(mt);
    });
  }, [$, Y, F, O, s, ue == null ? void 0 : ue.place, a, u, I, ue == null ? void 0 : ue.position, p]);
  le(() => {
    var Ye, $e;
    const nt = new Set(oe);
    qe.forEach((Et) => {
      H != null && H(Et) || nt.add({ current: Et });
    });
    const mt = document.querySelector(`[id='${i}']`);
    mt && !(H != null && H(mt)) && nt.add({ current: mt });
    const me = () => {
      Pe(!1);
    }, yt = aB(Y), Ue = aB(G.current);
    Ae.scroll && (window.addEventListener("scroll", me), yt == null || yt.addEventListener("scroll", me), Ue == null || Ue.addEventListener("scroll", me));
    let Ie = null;
    Ae.resize ? window.addEventListener("resize", me) : Y && G.current && (Ie = _T(Y, G.current, ut, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const ot = (Et) => {
      Et.key === "Escape" && Pe(!1);
    };
    Ae.escape && window.addEventListener("keydown", ot), Ae.clickOutsideAnchor && window.addEventListener("click", ze);
    const Ke = [], tt = (Et) => {
      $ && (Et == null ? void 0 : Et.target) === Y || he(Et);
    }, Ot = (Et) => {
      $ && (Et == null ? void 0 : Et.target) === Y && Qe();
    }, Vt = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Mt = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Ge).forEach(([Et, Qt]) => {
      Qt && (Vt.includes(Et) ? Ke.push({ event: Et, listener: We }) : Mt.includes(Et) && Ke.push({ event: Et, listener: tt }));
    }), Object.entries(Le).forEach(([Et, Qt]) => {
      Qt && (Vt.includes(Et) ? Ke.push({ event: Et, listener: Je }) : Mt.includes(Et) && Ke.push({ event: Et, listener: Ot }));
    }), p && Ke.push({ event: "pointermove", listener: pt });
    const lr = () => {
      pe.current = !0;
    }, Lr = () => {
      pe.current = !1, Qe();
    };
    return w && !He && ((Ye = G.current) === null || Ye === void 0 || Ye.addEventListener("mouseenter", lr), ($e = G.current) === null || $e === void 0 || $e.addEventListener("mouseleave", Lr)), Ke.forEach(({ event: Et, listener: Qt }) => {
      nt.forEach((Er) => {
        var kt;
        (kt = Er.current) === null || kt === void 0 || kt.addEventListener(Et, Qt);
      });
    }), () => {
      var Et, Qt;
      Ae.scroll && (window.removeEventListener("scroll", me), yt == null || yt.removeEventListener("scroll", me), Ue == null || Ue.removeEventListener("scroll", me)), Ae.resize ? window.removeEventListener("resize", me) : Ie == null || Ie(), Ae.clickOutsideAnchor && window.removeEventListener("click", ze), Ae.escape && window.removeEventListener("keydown", ot), w && !He && ((Et = G.current) === null || Et === void 0 || Et.removeEventListener("mouseenter", lr), (Qt = G.current) === null || Qt === void 0 || Qt.removeEventListener("mouseleave", Lr)), Ke.forEach(({ event: Er, listener: kt }) => {
        nt.forEach((en) => {
          var St;
          (St = en.current) === null || St === void 0 || St.removeEventListener(Er, kt);
        });
      });
    };
  }, [Y, ut, ae, oe, qe, q, E, x, be, g, m]), le(() => {
    var Ye, $e;
    let nt = ($e = (Ye = ue == null ? void 0 : ue.anchorSelect) !== null && Ye !== void 0 ? Ye : o) !== null && $e !== void 0 ? $e : "";
    !nt && e && (nt = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`);
    const mt = new MutationObserver((me) => {
      const yt = [], Ue = [];
      me.forEach((Ie) => {
        if (Ie.type === "attributes" && Ie.attributeName === "data-tooltip-id" && (Ie.target.getAttribute("data-tooltip-id") === e ? yt.push(Ie.target) : Ie.oldValue === e && Ue.push(Ie.target)), Ie.type === "childList") {
          if (Y) {
            const ot = [...Ie.removedNodes].filter((Ke) => Ke.nodeType === 1);
            if (nt) try {
              Ue.push(...ot.filter((Ke) => Ke.matches(nt))), Ue.push(...ot.flatMap((Ke) => [...Ke.querySelectorAll(nt)]));
            } catch {
            }
            ot.some((Ke) => {
              var tt;
              return !!(!((tt = Ke == null ? void 0 : Ke.contains) === null || tt === void 0) && tt.call(Ke, Y)) && (se(!1), Pe(!1), j(null), Ii(_), Ii(J), !0);
            });
          }
          if (nt) try {
            const ot = [...Ie.addedNodes].filter((Ke) => Ke.nodeType === 1);
            yt.push(...ot.filter((Ke) => Ke.matches(nt))), yt.push(...ot.flatMap((Ke) => [...Ke.querySelectorAll(nt)]));
          } catch {
          }
        }
      }), (yt.length || Ue.length) && Se((Ie) => [...Ie.filter((ot) => !Ue.includes(ot)), ...yt]);
    });
    return mt.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      mt.disconnect();
    };
  }, [e, o, ue == null ? void 0 : ue.anchorSelect, Y]), le(() => {
    ut();
  }, [ut]), le(() => {
    if (!(T != null && T.current)) return () => null;
    const Ye = new ResizeObserver(() => {
      setTimeout(() => ut());
    });
    return Ye.observe(T.current), () => {
      Ye.disconnect();
    };
  }, [F, T == null ? void 0 : T.current]), le(() => {
    var Ye;
    const $e = document.querySelector(`[id='${i}']`), nt = [...qe, $e];
    Y && nt.includes(Y) || j((Ye = qe[0]) !== null && Ye !== void 0 ? Ye : $e);
  }, [i, qe, Y]), le(() => (D && Pe(!0), () => {
    Ii(_), Ii(J);
  }), []), le(() => {
    var Ye;
    let $e = (Ye = ue == null ? void 0 : ue.anchorSelect) !== null && Ye !== void 0 ? Ye : o;
    if (!$e && e && ($e = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), $e) try {
      const nt = Array.from(document.querySelectorAll($e));
      Se(nt);
    } catch {
      Se([]);
    }
  }, [e, o, ue == null ? void 0 : ue.anchorSelect]), le(() => {
    _.current && (Ii(_), de(g));
  }, [g]);
  const Be = (L = ue == null ? void 0 : ue.content) !== null && L !== void 0 ? L : F, Ct = $ && Object.keys(ne.tooltipStyles).length > 0;
  return fm(t, () => ({ open: (Ye) => {
    if (Ye != null && Ye.anchorSelect) try {
      document.querySelector(Ye.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${Ye.anchorSelect}" is not a valid CSS selector`);
    }
    fe(Ye ?? null), Ye != null && Ye.delay ? de(Ye.delay) : Pe(!0);
  }, close: (Ye) => {
    Ye != null && Ye.delay ? xe(Ye.delay) : Pe(!1);
  }, activeAnchor: Y, place: ne.place, isOpen: !!(ae && !v && Be && Ct) })), ae && !v && Be ? re.createElement(d, { id: e, role: K, className: i7("react-tooltip", wl.tooltip, e6.tooltip, e6[A], r, `react-tooltip__place-${ne.place}`, wl[Ct ? "show" : "closing"], Ct ? "react-tooltip__show" : "react-tooltip__closing", u === "fixed" && wl.fixed, w && wl.clickable), onTransitionEnd: (Ye) => {
    Ii(X), $ || Ye.propertyName !== "opacity" || (se(!1), fe(null), P == null || P());
  }, style: { ...O, ...ne.tooltipStyles, opacity: W !== void 0 && Ct ? W : void 0 }, ref: G }, Be, re.createElement(d, { className: i7("react-tooltip-arrow", wl.arrow, e6.arrow, n, C && wl.noArrow), style: { ...ne.tooltipArrowStyles, background: R ? `linear-gradient(to right bottom, transparent 50%, ${R} 50%)` : void 0 }, ref: V })) : null;
}, Boe = ({ content: t }) => re.createElement("span", { dangerouslySetInnerHTML: { __html: t } }), Eoe = re.forwardRef(({ id: t, anchorId: e, anchorSelect: r, content: n, html: A, render: i, className: o, classNameArrow: s, variant: a = "dark", place: c = "top", offset: l = 10, wrapper: u = "div", children: f = null, events: d = ["hover"], openOnClick: g = !1, positionStrategy: m = "absolute", middlewares: p, delayShow: v = 0, delayHide: C = 0, float: w = !1, hidden: B = !1, noArrow: y = !1, clickable: b = !1, closeOnEsc: q = !1, closeOnScroll: E = !1, closeOnResize: x = !1, openEvents: M, closeEvents: O, globalCloseEvents: I, imperativeModeOnly: S = !1, style: P, position: H, isOpen: F, defaultIsOpen: T = !1, disableStyleInjection: U = !1, border: D, opacity: Q, arrowColor: Y, setIsOpen: j, afterShow: Z, afterHide: W, disableTooltip: R, role: K = "tooltip" }, L) => {
  const [G, V] = N(n), [_, J] = N(A), [X, ne] = N(c), [ee, $] = N(a), [te, ae] = N(l), [se, ue] = N(v), [fe, ve] = N(C), [ge, oe] = N(w), [ce, pe] = N(B), [qe, Se] = N(u), [Te, be] = N(d), [He, Ge] = N(m), [Le, Ae] = N(null), [Pe, it] = N(null), de = gt(U), { anchorRefs: xe, activeAnchor: he } = MM(t), Qe = (st) => st == null ? void 0 : st.getAttributeNames().reduce((We, Je) => {
    var ut;
    return Je.startsWith("data-tooltip-") && (We[Je.replace(/^data-tooltip-/, "")] = (ut = st == null ? void 0 : st.getAttribute(Je)) !== null && ut !== void 0 ? ut : null), We;
  }, {}), Re = (st) => {
    const We = { place: (Je) => {
      var ut;
      ne((ut = Je) !== null && ut !== void 0 ? ut : c);
    }, content: (Je) => {
      V(Je ?? n);
    }, html: (Je) => {
      J(Je ?? A);
    }, variant: (Je) => {
      var ut;
      $((ut = Je) !== null && ut !== void 0 ? ut : a);
    }, offset: (Je) => {
      ae(Je === null ? l : Number(Je));
    }, wrapper: (Je) => {
      var ut;
      Se((ut = Je) !== null && ut !== void 0 ? ut : u);
    }, events: (Je) => {
      const ut = Je == null ? void 0 : Je.split(" ");
      be(ut ?? d);
    }, "position-strategy": (Je) => {
      var ut;
      Ge((ut = Je) !== null && ut !== void 0 ? ut : m);
    }, "delay-show": (Je) => {
      ue(Je === null ? v : Number(Je));
    }, "delay-hide": (Je) => {
      ve(Je === null ? C : Number(Je));
    }, float: (Je) => {
      oe(Je === null ? w : Je === "true");
    }, hidden: (Je) => {
      pe(Je === null ? B : Je === "true");
    }, "class-name": (Je) => {
      Ae(Je);
    } };
    Object.values(We).forEach((Je) => Je(null)), Object.entries(st).forEach(([Je, ut]) => {
      var Be;
      (Be = We[Je]) === null || Be === void 0 || Be.call(We, ut);
    });
  };
  le(() => {
    V(n);
  }, [n]), le(() => {
    J(A);
  }, [A]), le(() => {
    ne(c);
  }, [c]), le(() => {
    $(a);
  }, [a]), le(() => {
    ae(l);
  }, [l]), le(() => {
    ue(v);
  }, [v]), le(() => {
    ve(C);
  }, [C]), le(() => {
    oe(w);
  }, [w]), le(() => {
    pe(B);
  }, [B]), le(() => {
    Ge(m);
  }, [m]), le(() => {
    de.current !== U && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [U]), le(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: U === "core", disableBase: U } }));
  }, []), le(() => {
    var st;
    const We = new Set(xe);
    let Je = r;
    if (!Je && t && (Je = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), Je) try {
      document.querySelectorAll(Je).forEach(($e) => {
        We.add({ current: $e });
      });
    } catch {
      console.warn(`[react-tooltip] "${Je}" is not a valid CSS selector`);
    }
    const ut = document.querySelector(`[id='${e}']`);
    if (ut && We.add({ current: ut }), !We.size) return () => null;
    const Be = (st = Pe ?? ut) !== null && st !== void 0 ? st : he.current, Ct = new MutationObserver(($e) => {
      $e.forEach((nt) => {
        var mt;
        if (!Be || nt.type !== "attributes" || !(!((mt = nt.attributeName) === null || mt === void 0) && mt.startsWith("data-tooltip-"))) return;
        const me = Qe(Be);
        Re(me);
      });
    }), Ye = { attributes: !0, childList: !1, subtree: !1 };
    if (Be) {
      const $e = Qe(Be);
      Re($e), Ct.observe(Be, Ye);
    }
    return () => {
      Ct.disconnect();
    };
  }, [xe, he, Pe, e, r]), le(() => {
    P != null && P.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), D && !iB("border", `${D}`) && console.warn(`[react-tooltip] "${D}" is not a valid \`border\`.`), P != null && P.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), Q && !iB("opacity", `${Q}`) && console.warn(`[react-tooltip] "${Q}" is not a valid \`opacity\`.`);
  }, []);
  let pt = f;
  const ze = gt(null);
  if (i) {
    const st = i({ content: (Pe == null ? void 0 : Pe.getAttribute("data-tooltip-content")) || G || null, activeAnchor: Pe });
    pt = st ? re.createElement("div", { ref: ze, className: "react-tooltip-content-wrapper" }, st) : null;
  } else G && (pt = G);
  _ && (pt = re.createElement(Boe, { content: _ }));
  const lt = { forwardRef: L, id: t, anchorId: e, anchorSelect: r, className: i7(o, Le), classNameArrow: s, content: pt, contentWrapperRef: ze, place: X, variant: ee, offset: te, wrapper: qe, events: Te, openOnClick: g, positionStrategy: He, middlewares: p, delayShow: se, delayHide: fe, float: ge, hidden: ce, noArrow: y, clickable: b, closeOnEsc: q, closeOnScroll: E, closeOnResize: x, openEvents: M, closeEvents: O, globalCloseEvents: I, imperativeModeOnly: S, style: P, position: H, isOpen: F, defaultIsOpen: T, border: D, opacity: Q, arrowColor: Y, setIsOpen: j, afterShow: Z, afterHide: W, disableTooltip: R, activeAnchor: Pe, setActiveAnchor: (st) => it(st), role: K };
  return re.createElement(boe, { ...lt });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (t) => {
  t.detail.disableCore || nB({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), t.detail.disableBase || nB({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const fFe = ({ userId: t, token: e }) => {
  const [r, n] = N([]), { apiKey: A, apiSecret: i } = Xe(ct.Context), o = /* @__PURE__ */ k(
    "svg",
    {
      width: "110",
      height: "110",
      viewBox: "0 0 103 103",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M47 2.59808C49.7846 0.99038 53.2154 0.990381 56 2.59808L91.6003 23.1519C94.3849 24.7596 96.1003 27.7308 96.1003 30.9462V72.0538C96.1003 75.2692 94.3849 78.2404 91.6003 79.8481L56 100.402C53.2154 102.01 49.7846 102.01 47 100.402L11.3997 79.8481C8.61508 78.2404 6.89969 75.2692 6.89969 72.0538V30.9461C6.89969 27.7308 8.61508 24.7596 11.3997 23.1519L47 2.59808Z",
            fill: "#2E0E4E"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M47 11.5981C49.7846 9.99038 53.2154 9.99038 56 11.5981L83.8061 27.6519C86.5907 29.2596 88.3061 32.2308 88.3061 35.4462V67.5538C88.3061 70.7692 86.5907 73.7404 83.8061 75.3481L56 91.4019C53.2154 93.0096 49.7846 93.0096 47 91.4019L19.1939 75.3481C16.4093 73.7404 14.6939 70.7692 14.6939 67.5538V35.4462C14.6939 32.2308 16.4093 29.2596 19.1939 27.6519L47 11.5981Z",
            fill: "#4C2277"
          }
        )
      ]
    }
  ), s = () => {
    const a = {
      apiKey: A,
      apisecret: i,
      userId: t,
      token: e
    };
    Oe.get(`${Ve.BACKEND_URL}api/badges?userId=${t}`, {
      headers: a
    }).then((c) => {
      c.data.success && n(c.data.data);
    }).catch((c) => {
      console.log(c);
    }).finally(() => {
    });
  };
  return le(() => {
    s();
  }, []), /* @__PURE__ */ h("div", { className: "q-parent-container", children: r.length === 0 ? /* @__PURE__ */ h("div", { className: "no-badge-q", style: { textAlign: "center" }, children: "No badges found" }) : /* @__PURE__ */ h(
    "div",
    {
      style: { width: "460px", height: "355px" },
      className: "q-badge-container",
      children: r.map((a, c) => /* @__PURE__ */ k("div", { style: { height: "110px" }, children: [
        /* @__PURE__ */ h(
          Eoe,
          {
            id: `${a.data.name}`,
            place: "top",
            variant: "info",
            content: `${a.data.description}`
          }
        ),
        /* @__PURE__ */ k(
          "div",
          {
            style: { cursor: "pointer" },
            "data-tooltip-id": `${a.data.name}`,
            className: "container-q-badge",
            children: [
              o,
              /* @__PURE__ */ h("div", { className: "hexagon", children: /* @__PURE__ */ h("div", { className: "hex-shape", children: /* @__PURE__ */ h(
                "img",
                {
                  src: `https://pin.questprotocol.xyz/ipfs/${a.data.imageIPFS}`,
                  alt: "img",
                  className: "image-inside-hexagon"
                }
              ) }) })
            ]
          },
          c
        )
      ] }, c))
    }
  ) });
}, hFe = ({
  isOpen: t,
  onClose: e,
  headingText: r,
  descText: n,
  isCloseble: A,
  continueButton: i,
  buttonText: o,
  buttonFunction: s,
  color: a = "black",
  backgroundColor: c = "white"
}) => {
  const l = { backgroundColor: c, color: a };
  return t ? gd.createPortal(
    /* @__PURE__ */ h("div", { className: "q-credit-home", style: l, children: /* @__PURE__ */ h("div", { className: "popup-overlay", style: l, children: /* @__PURE__ */ h("div", { className: "q-creditp-main", children: /* @__PURE__ */ k("div", { className: "q-creditp-child", style: { boxShadow: "rgba(0, 0, 0, 0.50) 0px 0px 6px 0px", ...l }, children: [
      /* @__PURE__ */ h("img", { src: cte, className: "q-creditp-banner" }),
      !!A && /* @__PURE__ */ h(
        "img",
        {
          src: aT,
          alt: "",
          onClick: () => e(),
          className: "q-creditp-img"
        }
      ),
      /* @__PURE__ */ h("div", { className: "q-creditp-p1", style: l, children: r }),
      /* @__PURE__ */ h("div", { className: "q-creditp-p2", style: l, children: n }),
      !!i && /* @__PURE__ */ h(
        "button",
        {
          className: "q-creditp-btn",
          onClick: () => s(),
          style: l,
          children: o
        }
      )
    ] }) }) }) }),
    document.getElementById("root")
  ) : /* @__PURE__ */ h(Ze, {});
}, xoe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAB1CAYAAACmoXTZAAADsUlEQVR4Xu2c0XHiQBBECYEq5Cp/EoJDUAgXgkMgA/j1l8kAh+AM5Awcwl4GhDA3c9L50FgLGO2yM1K/qq5ySYuAabfclmUWCwAAAAAkhYiWrJq1ZzWsQN8J1O6TNbU+BsiIDLwb/PG/H1cTWAfWWh8XJEKGS206UnEgGJYWHuiGbkvQJQLrWT8f+CGUPkUxDoR03QYPbkt5UhRDnmujXweIwMN6Yn2qId6ThpCuONTW7W1vZOVAuoagtnKH/qxM0BDS9ZWi1/5szDHvdJHdFMUINKd0kY8UnWOr39PkIH8pihFoiuki/ymKMZ100XRSFCOQ53TRdFMUw1+6aPopihHIQ7pofimKYTddNN8UxQhkKV2EFF2ifLoIKbqWQCXSRUjRrdwvXYQUjSVQznQRUpSa9OkipCgXgVKki5Cie3F7uqi9A6jkvQtzQ2a91j6cRR5AONWVINC1ZsnC7gGgDIG11L58g3C6s0CjfelBdm7XArEbaqg95QFbrLVPYtSbXgWK0z8FEtJkmfrUKKTJLvtTo+RuUGAT8WYpJtV6DzBHLUbJ/8MC2+zFqEZvBeZ4F6N+663AHEGMAvY5wignwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnwCgnLF5eXgiyr0VVVQTZF4xyIhjlRDDKiWCUE8EoJ4JRTgSjnAhGORGMciIY5URi1FFvhOxJjPrUGyFbenh4+FysVqu93gHZEht1kETVegdkTu3H7PAXzcBOyIA4TeHrI3YqpMqy2jSdmLUbWASV1a5n0j9kx8BiqIx22p8esmDgQdD9JL/XDn9Mqebx8XHNi98HDgLl1YfMXvtxEW4cz9I6Bg4IpdVRZq3n/yPEYT7I28DBoQSSCw5LRs/9ZvigNdKVTt0saz3nZFQoGym0S5qiGN3pMAy8AOi8PnhuT3qe2eEn3sCwq3R95c4FysZF3Va5c4Eq31f2sjAG+c7B37cyVO5czLhsyF/Laz0P81TzqfJSFnb6/buiu27YDLy5qchWWRjLBMtG+cqdi6lUeX4PBxdlYSzcin55TJfpyp2TylHZcFO5c+Ggype5PmcVHsimsnV79XTLwlgMlY1pVe5clKry8pxSdPTrAWe4d7pmXxbGIj/Ic6ZrtpU7F1X6Ku//+pxVTk6HY9rhX4NwmrsDMmQpHFV7k+g1psmaD9YGBhVEfo51l6XEPDlF7uRr2ca+rPV6AAAAAKTjDyCtHxBlWvcnAAAAAElFTkSuQmCC", Ioe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABZUlEQVR4Xs2TAVHEMBBFvwQkRAISIgEHRAIOrhJwwDngHPQcICESkAD9NNtudhPaG3ozvJk/bdO/2SS7Af4hD5OCHbwHYVKeFOvh44mTvopO9a9jecGa6K7JXlEnop4rx0F8wCf6xMENEuCTiMbi4dGyM//EAJ9AKxbP+4/7BuzKMvzkWqyf1PBUYnZxVu8JfmIr1m9U3xE74G7EHLC9G4pNob+ZdJOE2czinsu71bUxZhWxQcZstKu0kwyNca0RvxDhA1qij7QusZZtqoULvFmkdxiKnxPlhlcUi69CmqAn1ozJKE2E94rS4lJEeKNWwNzG3LWlV8+kPAsJ3ihiLchYfJZerZ60SUjwRipjrcm5PC2c0MZRQXkWIryRSqulS4CP4zE3YTPYs86Vo0+rkZI2WNhZ2twqfIuAOu6t+ttBF3ZXwMQj1hgeWfeiWgbMQaMZ75Ew+6+4IYmQsH91PGK5Ak2+AbPn7xPNpzghAAAAAElFTkSuQmCC", pFe = ({ days: t = 0, color: e = "black", backgroundColor: r = "white" }) => /* @__PURE__ */ h("div", { className: "m-5", children: /* @__PURE__ */ k("div", { className: "q-streak-main", style: { color: e, backgroundColor: r }, children: [
  /* @__PURE__ */ k("div", { className: "q-streak-div", children: [
    /* @__PURE__ */ h("div", { className: "q-streak-badge", style: { color: e, backgroundColor: r }, children: "You have earned a new badge Daily Streaking" }),
    /* @__PURE__ */ k("div", { className: "q-streak-text", style: { color: e, backgroundColor: r }, children: [
      "You maintained a streak for ",
      t,
      " days"
    ] })
  ] }),
  /* @__PURE__ */ k("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ h("img", { src: xoe, alt: "", className: "q-streak-img" }),
    /* @__PURE__ */ h("img", { src: Ioe, alt: "", className: "q-streak-simg" }),
    /* @__PURE__ */ h("div", { style: { display: "inline" }, className: "q-streak-count", children: t })
  ] })
] }) }), gFe = ({
  isOpen: t,
  onClose: e,
  headingText: r,
  descText: n,
  isCloseble: A,
  continueButton: i,
  buttonText: o,
  buttonFunction: s
}) => t ? gd.createPortal(
  /* @__PURE__ */ h("div", { className: "q-crd-home", children: /* @__PURE__ */ h("div", { className: "popup-overlay", children: /* @__PURE__ */ h("div", { className: "q-crdp-main", children: /* @__PURE__ */ k("div", { className: "q-crdp-child", style: { boxShadow: "rgba(0, 0, 0, 0.50) 0px 0px 6px 0px" }, children: [
    /* @__PURE__ */ h("img", { src: ate, className: "q-crdp-banner" }),
    !!A && /* @__PURE__ */ h(
      "img",
      {
        src: aT,
        alt: "",
        onClick: () => e(),
        className: "q-crdp-img"
      }
    ),
    /* @__PURE__ */ h("div", { className: "q-crdp-p1", children: r }),
    /* @__PURE__ */ h("div", { className: "q-crdp-p2", children: n }),
    !!i && /* @__PURE__ */ h(
      "button",
      {
        className: "q-crdp-btn",
        onClick: () => s(),
        children: o
      }
    )
  ] }) }) }) }),
  document.getElementById("root")
) : null, HM = UA({}), l4 = () => Xe(HM), Soe = ({
  heading: t = "Your Application Progress",
  subHeading: e = "Welcome back, Please complete your application",
  iconColor: r,
  style: n,
  headingStyle: A,
  descriptionStyle: i,
  ...o
}) => {
  const { themeManager: s } = l4(), a = s.getTopBarStyles(), c = (u = "") => `data:image/svg+xml,${encodeURIComponent(u)}`, l = (u = "#AFAFAF", f) => /* @__PURE__ */ h(
    "img",
    {
      onClick: () => f == null ? void 0 : f(),
      style: {
        cursor: "pointer",
        background: "inherit",
        backgroundColor: "inherit"
      },
      src: c(`
        <svg
            width="20"
            height="20"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.4003 7.61363C24.2769 7.49003 24.1304 7.39196 23.9691 7.32505C23.8078 7.25815 23.6349 7.22371 23.4603 7.22371C23.2857 7.22371 23.1128 7.25815 22.9515 7.32505C22.7902 7.39196 22.6436 7.49003 22.5203 7.61363L16.0003 14.1203L9.4803 7.6003C9.35686 7.47686 9.21031 7.37894 9.04902 7.31213C8.88774 7.24532 8.71487 7.21094 8.5403 7.21094C8.36572 7.21094 8.19286 7.24532 8.03157 7.31213C7.87029 7.37894 7.72374 7.47686 7.6003 7.6003C7.47686 7.72374 7.37894 7.87029 7.31213 8.03157C7.24532 8.19286 7.21094 8.36572 7.21094 8.5403C7.21094 8.71487 7.24532 8.88774 7.31213 9.04902C7.37894 9.21031 7.47686 9.35686 7.6003 9.4803L14.1203 16.0003L7.6003 22.5203C7.47686 22.6437 7.37894 22.7903 7.31213 22.9516C7.24532 23.1129 7.21094 23.2857 7.21094 23.4603C7.21094 23.6349 7.24532 23.8077 7.31213 23.969C7.37894 24.1303 7.47686 24.2769 7.6003 24.4003C7.72374 24.5237 7.87029 24.6217 8.03157 24.6885C8.19286 24.7553 8.36572 24.7897 8.5403 24.7897C8.71487 24.7897 8.88774 24.7553 9.04902 24.6885C9.21031 24.6217 9.35686 24.5237 9.4803 24.4003L16.0003 17.8803L22.5203 24.4003C22.6437 24.5237 22.7903 24.6217 22.9516 24.6885C23.1129 24.7553 23.2857 24.7897 23.4603 24.7897C23.6349 24.7897 23.8077 24.7553 23.969 24.6885C24.1303 24.6217 24.2769 24.5237 24.4003 24.4003C24.5237 24.2769 24.6217 24.1303 24.6885 23.969C24.7553 23.8077 24.7897 23.6349 24.7897 23.4603C24.7897 23.2857 24.7553 23.1129 24.6885 22.9516C24.6217 22.7903 24.5237 22.6437 24.4003 22.5203L17.8803 16.0003L24.4003 9.4803C24.907 8.97363 24.907 8.1203 24.4003 7.61363Z"
              fill="${u}"
            />
          </svg>
        `)
    }
  );
  return /* @__PURE__ */ k(
    "div",
    {
      className: "q_top_bar",
      style: { ...a.topbarStyle, ...n },
      children: [
        /* @__PURE__ */ k("div", { className: "q_top_bar_cont", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_top_bar_heading",
              style: { ...a.headingStyle, ...A },
              children: t
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_top_bar_desc",
              style: { ...a.descriptionStyle, ...i },
              children: e
            }
          )
        ] }),
        l(r, o.onClose)
      ]
    }
  );
}, DM = ({
  title: t,
  subheading: e,
  status: r,
  url: n,
  id: A,
  index: i,
  isLast: o,
  ...s
}) => {
  const { themeManager: a, handleNextStep: c, handleStepLoad: l } = l4(), u = gt(null);
  return le(() => {
    u.current && l(i, u.current.offsetHeight);
  }, [i, l]), /* @__PURE__ */ k(
    "div",
    {
      className: "q_tutorial_box",
      id: `q_tutorial_box_${i}`,
      onClick: () => n && c(A, n),
      ...s,
      children: [
        /* @__PURE__ */ k("div", { className: "q_tutorial_progress", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_tutorial_progress_img_cont",
              style: a.getProgressStyles(!!r).imageCont,
              children: /* @__PURE__ */ h(
                "img",
                {
                  className: "q_tutorial_progress_icon",
                  style: { width: "16px", height: "16px" },
                  src: r ? dT : fT,
                  alt: ""
                }
              )
            }
          ),
          !o && /* @__PURE__ */ h(
            "div",
            {
              id: `q_tutorial_progress_connector_${i}`,
              className: "q_tutorial_progress_connector",
              style: a.getProgressStyles(!!r).connector
            }
          )
        ] }),
        /* @__PURE__ */ k(
          "div",
          {
            id: `q_tutorial_box_content_${i}`,
            className: "q_tutorial_box_content",
            ref: u,
            children: [
              /* @__PURE__ */ k("div", { className: "q_tut_step", style: a.getStepStyles().step, children: [
                "STEP ",
                i + 1
              ] }),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_tut_box_head",
                  style: a.getStepStyles().title,
                  children: t
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_tut_box_desc",
                  style: a.getStepStyles().description,
                  children: e
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Poe = ({ onStepLoad: t, ...e }) => {
  const { formdata: r } = l4();
  return /* @__PURE__ */ h("div", { className: "q-tut-card-cont", ...e, children: r.map((n, A) => /* @__PURE__ */ h(
    DM,
    {
      ...n,
      index: A,
      isLast: A === r.length - 1
    },
    A
  )) });
}, koe = ({ showPoweredBy: t = !0, ...e }) => {
  const { themeManager: r } = l4();
  return t ? /* @__PURE__ */ k(
    "div",
    {
      className: "powered_by_quest",
      style: r.getFooterStyles().container,
      ...e,
      onClick: () => {
        window.open(
          e.link ? e.link : "https://www.plgos.com/",
          "_blank"
        );
      },
      children: [
        /* @__PURE__ */ h("div", { style: r.getFooterStyles().text, children: e.text ? e.text : "Powered by PLG OS" }),
        /* @__PURE__ */ k(
          "svg",
          {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: r.getFooterStyles().icon,
            children: [
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z",
                  fill: "currentColor"
                }
              ),
              /* @__PURE__ */ h("path", { d: "M12 8L8 8L8 12H12V8Z", fill: "currentColor" })
            ]
          }
        )
      ]
    }
  ) : null;
};
class Ooe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a == n || a == A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosHeaders({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          { headers: u }
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, { path: "/", expires: p }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), null;
    }
  }
  async fetchCampaignData(e, r, n, A) {
    var i;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const o = new URLSearchParams();
      o.set("platform", "REACT"), A && o.set("variation", A);
      const s = this.getAxiosHeaders(n), a = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${o.toString()}`, c = await Oe.get(a, {
        headers: s
      });
      if (!((i = c.data) != null && i.data))
        throw new Error("No data received from API");
      return c.data.data;
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
  async verifyAction(e, r, n, A, i) {
    var o;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const s = {
        actions: [
          {
            answers: [],
            actionId: A
          }
        ],
        campaignVariationId: i
      }, a = this.getAxiosHeaders(n), c = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/verify`, l = await Oe.post(
        c,
        s,
        { headers: a }
      );
      if (!((o = l.data) != null && o.data))
        throw new Error("Invalid response from verify action");
      return l.data.data;
    } catch (s) {
      throw this.GeneralFunctions.captureSentryException(s), s;
    }
  }
  processActionsData(e) {
    return e.map((r) => {
      var n;
      return {
        type: r.actionType,
        title: r.title,
        url: (n = r.metadata) == null ? void 0 : n.link,
        subheading: r.description || "this is the description",
        id: r.actionId,
        status: r.isCompleted
      };
    });
  }
  clearCookies() {
    this.cookies.remove("externalUserId", { path: "/" }), this.cookies.remove("questUserId", { path: "/" }), this.cookies.remove("questUserToken", { path: "/" });
  }
  isValidUserAuth(e) {
    return !!e && typeof e.userId == "string" && typeof e.token == "string";
  }
}
class Foe {
  constructor(e = {}, r = {}, n = Ms, A = Hs) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = { ...Ms, ...n }, this.brandTheme = { ...Hs, ...A };
  }
  getStyleValueAsString(e, r = "") {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "string" ? A : r;
  }
  getStyleValueAsObject(e, r) {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "object" ? A : r;
  }
  getContainerStyles() {
    var e;
    return {
      background: this.getBackgroundColor(),
      height: this.getStyleValueAsString("Form.height", "auto"),
      borderRadius: this.getBorderRadius(),
      fontFamily: this.getFontFamily(),
      ...(e = this.styleConfig) == null ? void 0 : e.Form
    };
  }
  getTopBarStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      headingStyle: {
        color: this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.titleColor) || ((r = this.brandTheme) == null ? void 0 : r.primaryColor) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor) || "#000000",
        ...(A = this.styleConfig) == null ? void 0 : A.Heading
      },
      descriptionStyle: {
        color: this.getStyleValueAsString("Description.color") || ((i = this.brandTheme) == null ? void 0 : i.secondaryColor) || ((o = this.themeConfig) == null ? void 0 : o.secondaryColor) || "#666666",
        ...(s = this.styleConfig) == null ? void 0 : s.Description
      },
      topbarStyle: {
        ...(a = this.styleConfig) == null ? void 0 : a.TopBar
      }
    };
  }
  getStepStyles() {
    var e, r, n, A, i, o;
    return {
      step: {
        color: this.getStyleValueAsString("Description.color") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666"
      },
      title: {
        color: this.getStyleValueAsString("Heading.color") || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor) || "#000000"
      },
      description: {
        color: this.getStyleValueAsString("Description.color") || ((i = this.brandTheme) == null ? void 0 : i.secondaryColor) || ((o = this.themeConfig) == null ? void 0 : o.secondaryColor) || "#666666"
      }
    };
  }
  ensureBoolean(e) {
    return !!e;
  }
  getProgressStyles(e) {
    const r = this.ensureBoolean(e);
    return {
      imageCont: {
        background: r ? "#01ff0111" : "#FBFBFB"
      },
      connector: {
        background: r ? "#73DCA7" : "#EFEFEF"
      }
    };
  }
  getFooterStyles() {
    var r;
    const e = ((r = this.styleConfig) == null ? void 0 : r.Footer) || {};
    return {
      container: {
        background: this.getBackgroundColor(),
        ...e == null ? void 0 : e.FooterStyle
      },
      text: (e == null ? void 0 : e.FooterTextStyle) || {},
      icon: (e == null ? void 0 : e.FooterIcon) || {},
      content: {
        text: (e == null ? void 0 : e.FooterText) || "",
        link: (e == null ? void 0 : e.FooterLink) || ""
      }
    };
  }
  getBackgroundColor() {
    var e, r;
    return this.getStyleValueAsString("Form.backgroundColor") || this.getStyleValueAsString("Form.background") || ((e = this.brandTheme) == null ? void 0 : e.background) || ((r = this.themeConfig) == null ? void 0 : r.backgroundColor);
  }
  getFontFamily() {
    var e, r;
    return ((e = this.brandTheme) == null ? void 0 : e.fontFamily) || ((r = this.themeConfig) == null ? void 0 : r.fontFamily) || "'Figtree', sans-serif";
  }
  getBorderRadius() {
    var e, r;
    return this.getStyleValueAsString("Form.borderRadius") || ((e = this.questThemeData) == null ? void 0 : e.borderRadius) || ((r = this.brandTheme) == null ? void 0 : r.borderRadius) || "8px";
  }
  // Common style getters
  getPrimaryColor() {
    var e, r;
    return this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.primaryColor) || ((r = this.themeConfig) == null ? void 0 : r.primaryColor) || "#000000";
  }
  getSecondaryColor() {
    var e, r;
    return this.getStyleValueAsString("Description.color") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666";
  }
  // Update methods
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    var r;
    this.styleConfig = {
      ...this.styleConfig,
      ...e,
      Footer: {
        ...(r = this.styleConfig) == null ? void 0 : r.Footer,
        ...e == null ? void 0 : e.Footer
      }
    };
  }
  updateQuestTheme(e) {
    this.questThemeData = {
      ...this.questThemeData,
      ...e
    };
  }
  updateBrandTheme(e) {
    this.brandTheme = {
      ...this.brandTheme,
      ...e
    };
  }
  mergeStyles(e, r) {
    return {
      ...e,
      ...r || {}
    };
  }
  getComputedStyle(e, r = {}) {
    return this.mergeStyles(
      r,
      this.getStyleValueAsObject(e, {})
    );
  }
}
const u4 = ({
  userId: t,
  token: e,
  questId: r,
  isOpen: n = !0,
  uniqueUserId: A,
  uniqueEmailId: i,
  iconColor: o = "#939393",
  onLinkTrigger: s = (d) => {
    window.open(d, "smallWindow", "width=500,height=500");
  },
  styleConfig: a,
  showFooter: c = !0,
  variation: l,
  children: u,
  ...f
}) => {
  const { apiKey: d, apiSecret: g, entityId: m, apiType: p, themeConfig: v } = Xe(
    ct.Context
  ), [C, w] = N([]), [B, y] = N(!1), [b, q] = N(""), [E, x] = N(Ms), [M, O] = N(Hs), I = new Bt("mixpanel", p), S = new Ooe(p), P = new Foe(
    v,
    a,
    E,
    M
  ), H = async (D, Q) => {
    I.fireTrackingEvent(
      "quest_tutorial_step_link_clicked",
      "tutorial"
    );
    try {
      y(!0);
      const Y = await S.getUserAuth({
        apiKey: d,
        entityId: m,
        uniqueUserId: A,
        uniqueEmailId: i,
        userId: t,
        token: e
      });
      if (!Y) return;
      const j = {
        apiKey: d,
        apiSecret: g,
        userId: Y.userId,
        token: Y.token
      };
      await S.verifyAction(
        m,
        r,
        j,
        D,
        b
      ), s(Q);
      const Z = C.map((W) => !W.status && W.id === D ? { ...W, status: !0 } : W);
      w(Z);
    } catch (Y) {
      I.captureSentryException(Y);
    } finally {
      y(!1);
    }
  }, F = async (D) => {
    var Q, Y;
    try {
      const j = await S.fetchCampaignData(
        m,
        r,
        D,
        l
      );
      if ((Y = (Q = j.sdkConfig) == null ? void 0 : Q.uiProps) != null && Y.questThemeData && (x(j.sdkConfig.uiProps.questThemeData), j.sdkConfig.uiProps.BrandTheme && O(j.sdkConfig.uiProps.BrandTheme.properties)), j.actions) {
        const Z = S.processActionsData(
          j.actions
        );
        w(Z), q(j.campaignVariationId);
      }
    } catch (j) {
      I.captureSentryException(j);
    }
  };
  le(() => {
    I.fireTrackingEvent("quest_tutorial_loaded", "tutorial"), (async () => {
      if (m)
        try {
          const Q = await S.getUserAuth({
            apiKey: d,
            entityId: m,
            uniqueUserId: A,
            uniqueEmailId: i,
            userId: t,
            token: e
          });
          if (!Q) return;
          const Y = {
            apiKey: d,
            apiSecret: g,
            userId: Q.userId,
            token: Q.token
          };
          await F(Y);
        } catch (Q) {
          I.captureSentryException(Q);
        }
    })();
  }, []);
  const T = (D, Q) => {
    const Y = document.querySelector(
      `#q_tutorial_progress_connector_${D}`
    ), j = document.querySelector(
      `#q_tutorial_box_content_${D + 1}`
    );
    if (Y && j) {
      let Z = (Q - 32) / 2 + (j.offsetHeight - 32) / 2 + 32;
      Y.style.height = `${Z}px`, D === C.length - 1 && (Y.style.display = "none");
    }
  };
  if (!n) return null;
  const U = {
    formdata: C,
    handleNextStep: H,
    themeManager: P,
    iconColor: o,
    showLoader: B,
    handleStepLoad: T
  };
  return /* @__PURE__ */ h(HM.Provider, { value: U, children: /* @__PURE__ */ h(
    "div",
    {
      className: "q-tutorial-cont",
      style: P.getContainerStyles(),
      ...f,
      children: u
    }
  ) });
};
u4.Header = Soe;
u4.Content = Poe;
u4.Footer = koe;
u4.Step = DM;
const QM = UA({}), tl = () => Xe(QM), UM = (t = "#939393", e = "16px") => /* @__PURE__ */ k(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          opacity: "0.5",
          d: "M2 6.66671C2 4.15255 2 2.89547 2.78105 2.11442C3.5621 1.33337 4.81918 1.33337 7.33333 1.33337H8.66667C11.1808 1.33337 12.4379 1.33337 13.219 2.11442C14 2.89547 14 4.15255 14 6.66671V9.33337C14 11.8475 14 13.1046 13.219 13.8857C12.4379 14.6667 11.1808 14.6667 8.66667 14.6667H7.33333C4.81918 14.6667 3.5621 14.6667 2.78105 13.8857C2 13.1046 2 11.8475 2 9.33337V6.66671Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.83334 6.66663C4.83334 6.39048 5.0572 6.16663 5.33334 6.16663H10.6667C10.9428 6.16663 11.1667 6.39048 11.1667 6.66663C11.1667 6.94277 10.9428 7.16663 10.6667 7.16663H5.33334C5.0572 7.16663 4.83334 6.94277 4.83334 6.66663Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.83334 9.33337C4.83334 9.05723 5.0572 8.83337 5.33334 8.83337H8.66668C8.94282 8.83337 9.16668 9.05723 9.16668 9.33337C9.16668 9.60952 8.94282 9.83337 8.66668 9.83337H5.33334C5.0572 9.83337 4.83334 9.60952 4.83334 9.33337Z",
          fill: t
        }
      )
    ]
  }
), NM = (t = "#939393", e = "16px") => /* @__PURE__ */ k(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          opacity: "0.5",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6667 7.95837V10C12.6667 12.4085 10.8422 14.3907 8.50001 14.6402V10C8.50001 9.7239 8.27615 9.50004 8.00001 9.50004C7.72387 9.50004 7.50001 9.7239 7.50001 10V14.6402C5.15779 14.3907 3.33334 12.4085 3.33334 10V7.95837C3.33334 6.84682 4.02423 5.89663 5.00001 5.51381C5.29689 5.39733 5.62015 5.33337 5.95834 5.33337H10.0417C10.3799 5.33337 10.7031 5.39733 11 5.51381C11.9758 5.89663 12.6667 6.84682 12.6667 7.95837Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M12.6667 9.83337V8.83337H14.6667C14.9428 8.83337 15.1667 9.05723 15.1667 9.33337C15.1667 9.60951 14.9428 9.83337 14.6667 9.83337H12.6667Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M11.6637 12.8909C11.8709 12.6286 12.0506 12.3436 12.1983 12.0402L13.8903 12.8863C14.1373 13.0098 14.2374 13.3101 14.1139 13.5571C13.9904 13.8041 13.69 13.9042 13.443 13.7807L11.6637 12.8909Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M3.80173 12.0402C3.94946 12.3436 4.12912 12.6286 4.33634 12.8909L2.55697 13.7807C2.30999 13.9042 2.00965 13.8041 1.88614 13.5571C1.76263 13.3101 1.86273 13.0098 2.10971 12.8863L3.80173 12.0402Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M3.33334 8.83337H1.33334C1.0572 8.83337 0.833344 9.05723 0.833344 9.33337C0.833344 9.60951 1.0572 9.83337 1.33334 9.83337H3.33334V8.83337Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M11.569 5.82319L13.443 4.88604C13.69 4.76253 13.9904 4.86263 14.1139 5.10961C14.2374 5.35659 14.1373 5.65693 13.8903 5.78044L12.2797 6.58585C12.0958 6.28667 11.8536 6.02717 11.569 5.82319Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M4.43103 5.82319C4.14637 6.02717 3.90419 6.28667 3.72032 6.58585L2.10971 5.78044C1.86273 5.65693 1.76263 5.35659 1.88614 5.10961C2.00965 4.86263 2.30999 4.76253 2.55697 4.88604L4.43103 5.82319Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M11 5.51376V5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5V5.51376C5.29688 5.39729 5.62014 5.33333 5.95833 5.33333H10.0417C10.3799 5.33333 10.7031 5.39729 11 5.51376Z",
          fill: t
        }
      ),
      /* @__PURE__ */ k("g", { opacity: "0.5", children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M4.25068 1.05595C4.09751 1.28572 4.1596 1.59615 4.38936 1.74933L5.96243 2.79804C6.23013 2.5502 6.54312 2.35058 6.88758 2.21296L4.94406 0.91728C4.7143 0.764104 4.40386 0.826191 4.25068 1.05595Z",
            fill: t
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M10.0376 2.79808C9.7699 2.55024 9.45692 2.35061 9.11246 2.21299L11.056 0.91728C11.2858 0.764104 11.5962 0.826191 11.7494 1.05595C11.9026 1.28572 11.8405 1.59615 11.6107 1.74933L10.0376 2.79808Z",
            fill: t
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 9.5C8.27614 9.5 8.5 9.72386 8.5 10V14.6667H7.5V10C7.5 9.72386 7.72386 9.5 8 9.5Z",
          fill: t
        }
      )
    ]
  }
), jM = (t = "#939393", e = "16") => /* @__PURE__ */ k(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          opacity: "0.5",
          d: "M2.30965 13.6904C3.28596 14.6667 4.85731 14.6667 8.00001 14.6667C11.1427 14.6667 12.7141 14.6667 13.6904 13.6904C14.6667 12.7141 14.6667 11.1427 14.6667 8.00004C14.6667 4.85734 14.6667 3.286 13.6904 2.30968C12.7141 1.33337 11.1427 1.33337 8.00001 1.33337C4.85731 1.33337 3.28596 1.33337 2.30965 2.30968C1.33334 3.286 1.33334 4.85734 1.33334 8.00004C1.33334 11.1427 1.33334 12.7141 2.30965 13.6904Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M11.3333 8.44437C11.3333 11.2888 8.96295 11.9999 7.77777 11.9999C6.74073 11.9999 4.66666 11.2888 4.66666 8.44437C4.66666 7.20719 5.37527 6.42176 5.97061 6.02642C6.2428 5.84568 6.58133 5.9612 6.59893 6.28746C6.63743 7.00132 7.1876 7.57473 7.61366 7.00066C8.00362 6.47524 8.19607 5.76174 8.19607 5.33326C8.19607 4.70207 8.83499 4.30098 9.33384 4.68769C10.3062 5.44146 11.3333 6.70382 11.3333 8.44437Z",
          fill: t
        }
      )
    ]
  }
), I3 = (t = "#AFAFAF", e) => /* @__PURE__ */ h(
  "div",
  {
    onClick: () => e == null ? void 0 : e(),
    style: {
      cursor: "pointer",
      padding: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "4px"
    },
    children: /* @__PURE__ */ h(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ h(
          "path",
          {
            d: "M24.4003 7.61363C24.2769 7.49003 24.1304 7.39196 23.9691 7.32505C23.8078 7.25815 23.6349 7.22371 23.4603 7.22371C23.2857 7.22371 23.1128 7.25815 22.9515 7.32505C22.7902 7.39196 22.6436 7.49003 22.5203 7.61363L16.0003 14.1203L9.4803 7.6003C9.35686 7.47686 9.21031 7.37894 9.04902 7.31213C8.88774 7.24532 8.71487 7.21094 8.5403 7.21094C8.36572 7.21094 8.19286 7.24532 8.03157 7.31213C7.87029 7.37894 7.72374 7.47686 7.6003 7.6003C7.47686 7.72374 7.37894 7.87029 7.31213 8.03157C7.24532 8.19286 7.21094 8.36572 7.21094 8.5403C7.21094 8.71487 7.24532 8.88774 7.31213 9.04902C7.37894 9.21031 7.47686 9.35686 7.6003 9.4803L14.1203 16.0003L7.6003 22.5203C7.47686 22.6437 7.37894 22.7903 7.31213 22.9516C7.24532 23.1129 7.21094 23.2857 7.21094 23.4603C7.21094 23.6349 7.24532 23.8077 7.31213 23.969C7.37894 24.1303 7.47686 24.2769 7.6003 24.4003C7.72374 24.5237 7.87029 24.6217 8.03157 24.6885C8.19286 24.7553 8.36572 24.7897 8.5403 24.7897C8.71487 24.7897 8.88774 24.7553 9.04902 24.6885C9.21031 24.6217 9.35686 24.5237 9.4803 24.4003L16.0003 17.8803L22.5203 24.4003C22.6437 24.5237 22.7903 24.6217 22.9516 24.6885C23.1129 24.7553 23.2857 24.7897 23.4603 24.7897C23.6349 24.7897 23.8077 24.7553 23.969 24.6885C24.1303 24.6217 24.2769 24.5237 24.4003 24.4003C24.5237 24.2769 24.6217 24.1303 24.6885 23.969C24.7553 23.8077 24.7897 23.6349 24.7897 23.4603C24.7897 23.2857 24.7553 23.1129 24.6885 22.9516C24.6217 22.7903 24.5237 22.6437 24.4003 22.5203L17.8803 16.0003L24.4003 9.4803C24.907 8.97363 24.907 8.1203 24.4003 7.61363Z",
            fill: t
          }
        )
      }
    )
  }
), LM = (t = "#939393", e = "16px") => /* @__PURE__ */ k(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          opacity: "0.5",
          d: "M14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00004C1.33334 4.31814 4.31811 1.33337 8.00001 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M8 5.16663C7.58579 5.16663 7.25 5.50241 7.25 5.91663C7.25 6.19277 7.02614 6.41663 6.75 6.41663C6.47386 6.41663 6.25 6.19277 6.25 5.91663C6.25 4.95013 7.0335 4.16663 8 4.16663C8.9665 4.16663 9.75 4.95013 9.75 5.91663C9.75 6.39052 9.56098 6.82128 9.25531 7.13593C9.1938 7.19925 9.13512 7.25787 9.07915 7.3138L9.07915 7.3138C8.93526 7.45757 8.8092 7.58352 8.6986 7.72562C8.55258 7.91324 8.5 8.05113 8.5 8.16663V8.66663C8.5 8.94277 8.27614 9.16663 8 9.16663C7.72386 9.16663 7.5 8.94277 7.5 8.66663V8.16663C7.5 7.72983 7.70334 7.37625 7.90945 7.11143C8.06195 6.91549 8.25363 6.72419 8.40918 6.56894L8.40918 6.56894C8.45611 6.5221 8.49975 6.47855 8.53803 6.43914C8.66972 6.30358 8.75 6.11999 8.75 5.91663C8.75 5.50241 8.41421 5.16663 8 5.16663Z",
          fill: t
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "M8 11.3333C8.36819 11.3333 8.66667 11.0348 8.66667 10.6666C8.66667 10.2984 8.36819 9.99996 8 9.99996C7.63181 9.99996 7.33333 10.2984 7.33333 10.6666C7.33333 11.0348 7.63181 11.3333 8 11.3333Z",
          fill: t
        }
      )
    ]
  }
), GM = (t, e = "16px") => /* @__PURE__ */ k(
  "svg",
  {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ k("g", { clipRule: "url(#clip0_4046_146)", children: [
        /* @__PURE__ */ h(
          "path",
          {
            d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
            fill: t || "url(#paint0_linear_4046_146)"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M48.4167 79.0566C49.1837 78.9078 49.9463 78.7367 50.7033 78.5432C51.987 78.1844 53.2519 77.7617 54.4933 77.2766C55.7363 76.7955 56.9545 76.2526 58.1433 75.6499C59.3325 75.0449 60.4906 74.3807 61.6133 73.6599C62.7348 72.939 63.8195 72.1625 64.8633 71.3332C65.9091 70.5029 66.9125 69.6207 67.87 68.6899C68.8259 67.7614 69.7348 66.7858 70.5933 65.7666C71.4526 64.7465 72.2603 63.684 73.0133 62.5832C73.7662 61.4843 74.4638 60.3484 75.1033 59.1799C75.743 58.0097 76.3237 56.8082 76.8433 55.5799C77.3635 54.3514 77.8218 53.0976 78.2167 51.8232C78.5548 50.7075 78.8439 49.5776 79.0833 48.4366L55.3167 24.6732C53.3096 22.6573 50.9236 21.0581 48.2961 19.9677C45.6686 18.8774 42.8514 18.3174 40.0067 18.3199C37.1594 18.3168 34.3395 18.8765 31.7092 19.9668C29.0789 21.0572 26.6901 22.6566 24.68 24.6732C22.6649 26.6839 21.0661 29.0724 19.9753 31.7018C18.8845 34.3312 18.323 37.1499 18.323 39.9966C18.323 42.8433 18.8845 45.662 19.9753 48.2914C21.0661 50.9208 22.6649 53.3092 24.68 55.3199L48.4167 79.0566Z",
            fill: t || "url(#paint0_linear_4046_146)"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            d: "M40.0033 18.3232C45.5433 18.3232 51.0833 20.4398 55.3233 24.6765C57.3384 26.6872 58.9372 29.0756 60.028 31.705C61.1188 34.3344 61.6803 37.1532 61.6803 39.9998C61.6803 42.8465 61.1188 45.6653 60.028 48.2947C58.9372 50.9241 57.3384 53.3125 55.3233 55.3232C53.3126 57.3383 50.9242 58.937 48.2948 60.0279C45.6654 61.1187 42.8467 61.6802 40 61.6802C37.1533 61.6802 34.3346 61.1187 31.7052 60.0279C29.0758 58.937 26.6873 57.3383 24.6767 55.3232C22.6615 53.3125 21.0628 50.9241 19.972 48.2947C18.8811 45.6653 18.3196 42.8465 18.3196 39.9998C18.3196 37.1532 18.8811 34.3344 19.972 31.705C21.0628 29.0756 22.6615 26.6872 24.6767 24.6765C26.6867 22.6599 29.0756 21.0604 31.7059 19.9701C34.3361 18.8798 37.156 18.3201 40.0033 18.3232ZM49.87 33.3298C49.5544 33.3601 49.2539 33.4791 49.0033 33.6732L36.8233 42.8065L31.18 37.1665C29.9566 35.8932 27.5467 38.2998 28.8233 39.5232L35.49 46.1898C35.779 46.4631 36.1536 46.6281 36.5504 46.6566C36.9471 46.6852 37.3415 46.5756 37.6667 46.3465L51 36.3465C52.12 35.5298 51.43 33.3532 50.0433 33.3332C49.9867 33.3303 49.9299 33.3303 49.8733 33.3332L49.87 33.3298Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ k("defs", { children: [
        /* @__PURE__ */ k(
          "linearGradient",
          {
            id: "paint0_linear_4046_146",
            x1: "0.320001",
            y1: "80",
            x2: "87.5968",
            y2: "71.0629",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ h("stop", { "stop-color": "#9035FF" }),
              /* @__PURE__ */ h("stop", { offset: "1", "stop-color": "#0065FF" })
            ]
          }
        ),
        /* @__PURE__ */ k(
          "linearGradient",
          {
            id: "paint1_linear_4046_146",
            x1: "18.566",
            y1: "79.0566",
            x2: "84.8526",
            y2: "72.2662",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ h("stop", { "stop-color": "#9035FF" }),
              /* @__PURE__ */ h("stop", { offset: "1", "stop-color": "#0065FF" })
            ]
          }
        ),
        /* @__PURE__ */ h("clipPath", { id: "clip0_4046_146", children: /* @__PURE__ */ h("rect", { width: "80", height: "80", fill: "white" }) })
      ] })
    ]
  }
), d4 = (t = 32, e = "#E2E2E2", r) => /* @__PURE__ */ k(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h("g", { clipPath: "url(#clip0_415_158)", children: /* @__PURE__ */ h(
        "path",
        {
          d: "M15.455 13.7626L3.4925 15.497L3.28063 15.5401C2.95989 15.6252 2.66749 15.794 2.4333 16.0291C2.19911 16.2642 2.03151 16.5573 1.94762 16.8783C1.86373 17.1994 1.86655 17.537 1.9558 17.8566C2.04506 18.1762 2.21753 18.4664 2.45563 18.6976L11.1219 27.1332L9.07813 39.0489L9.05375 39.2551C9.03412 39.5868 9.103 39.9178 9.25335 40.2142C9.40369 40.5105 9.6301 40.7616 9.90938 40.9417C10.1887 41.1218 10.5108 41.2244 10.8428 41.2391C11.1748 41.2537 11.5047 41.1799 11.7988 41.0251L22.4975 35.4001L33.1719 41.0251L33.3594 41.1114C33.6689 41.2333 34.0052 41.2706 34.3339 41.2196C34.6626 41.1687 34.9718 41.0312 35.2299 40.8212C35.4879 40.6113 35.6854 40.3365 35.8022 40.025C35.919 39.7136 35.9508 39.3767 35.8944 39.0489L33.8488 27.1332L42.5188 18.6957L42.665 18.5364C42.8739 18.279 43.0109 17.9709 43.062 17.6435C43.1131 17.316 43.0764 16.9808 42.9558 16.6721C42.8352 16.3634 42.6349 16.0922 42.3753 15.8861C42.1157 15.68 41.8062 15.5464 41.4781 15.4988L29.5156 13.7626L24.1681 2.9251C24.0134 2.6111 23.7738 2.34669 23.4766 2.16179C23.1794 1.9769 22.8363 1.87891 22.4863 1.87891C22.1362 1.87891 21.7931 1.9769 21.4959 2.16179C21.1987 2.34669 20.9591 2.6111 20.8044 2.9251L15.455 13.7626Z",
          fill: e,
          stroke: r,
          strokeWidth: r ? 1 : 0
        }
      ) }),
      /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_158", children: /* @__PURE__ */ h("rect", { width: "45", height: "45", fill: "white" }) }) })
    ]
  }
), f4 = (t = 32, e = "#F9C23C", r) => /* @__PURE__ */ k(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ h("g", { clipPath: "url(#clip0_415_239)", children: /* @__PURE__ */ h(
        "path",
        {
          d: "M15.455 13.7626L3.4925 15.497L3.28063 15.5401C2.95989 15.6252 2.66749 15.794 2.4333 16.0291C2.19911 16.2642 2.03151 16.5573 1.94762 16.8783C1.86373 17.1994 1.86655 17.537 1.9558 17.8566C2.04506 18.1762 2.21753 18.4664 2.45563 18.6976L11.1219 27.1332L9.07813 39.0489L9.05375 39.2551C9.03412 39.5868 9.103 39.9178 9.25335 40.2142C9.40369 40.5105 9.6301 40.7616 9.90938 40.9417C10.1887 41.1218 10.5108 41.2244 10.8428 41.2391C11.1748 41.2537 11.5047 41.1799 11.7988 41.0251L22.4975 35.4001L33.1719 41.0251L33.3594 41.1114C33.6689 41.2333 34.0052 41.2706 34.3339 41.2196C34.6626 41.1687 34.9718 41.0312 35.2299 40.8212C35.4879 40.6113 35.6854 40.3365 35.8022 40.025C35.919 39.7136 35.9508 39.3767 35.8944 39.0489L33.8488 27.1332L42.5188 18.6957L42.665 18.5364C42.8739 18.279 43.0109 17.9709 43.062 17.6435C43.1131 17.316 43.0764 16.9808 42.9558 16.6721C42.8352 16.3634 42.6349 16.0922 42.3753 15.8861C42.1157 15.68 41.8062 15.5464 41.4781 15.4988L29.5156 13.7626L24.1681 2.9251C24.0134 2.6111 23.7738 2.34669 23.4766 2.16179C23.1794 1.9769 22.8363 1.87891 22.4863 1.87891C22.1362 1.87891 21.7931 1.9769 21.4959 2.16179C21.1987 2.34669 20.9591 2.6111 20.8044 2.9251L15.455 13.7626Z",
          fill: e
        }
      ) }),
      /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_415_239", children: /* @__PURE__ */ h("rect", { width: "45", height: "45", fill: "white" }) }) })
    ]
  }
), RM = (t = 20, e = "black") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Layer_1",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ h("path", { fill: e, d: "M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z" })
  }
), Ra = (t) => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 8.67499C2.53832 8.32753 1.25 6.81422 1.25 5C1.25 2.92893 2.92893 1.25 5 1.25C6.81422 1.25 8.32753 2.53832 8.67499 4.25H15.325C15.6725 2.53832 17.1858 1.25 19 1.25C21.0711 1.25 22.75 2.92893 22.75 5C22.75 6.81422 21.4617 8.32753 19.75 8.67499V15.325C21.4617 15.6725 22.75 17.1858 22.75 19C22.75 21.0711 21.0711 22.75 19 22.75C17.1858 22.75 15.6725 21.4617 15.325 19.75H8.67499C8.32753 21.4617 6.81422 22.75 5 22.75C2.92893 22.75 1.25 21.0711 1.25 19C1.25 17.1858 2.53832 15.6725 4.25 15.325L4.25 8.67499ZM2.75 5C2.75 3.75736 3.75736 2.75 5 2.75C6.24264 2.75 7.25 3.75736 7.25 5C7.25 6.24264 6.24264 7.25 5 7.25C3.75736 7.25 2.75 6.24264 2.75 5ZM5.75 15.325L5.75 8.67499C7.21935 8.37673 8.37672 7.21935 8.67499 5.75H15.325C15.6233 7.21935 16.7807 8.37673 18.25 8.67499V15.325C16.7807 15.6233 15.6233 16.7807 15.325 18.25H8.67499C8.37672 16.7807 7.21935 15.6233 5.75 15.325ZM5 16.75C3.75736 16.75 2.75 17.7574 2.75 19C2.75 20.2426 3.75736 21.25 5 21.25C6.24264 21.25 7.25 20.2426 7.25 19C7.25 17.7574 6.24264 16.75 5 16.75ZM21.25 5C21.25 6.24264 20.2426 7.25 19 7.25C17.7574 7.25 16.75 6.24264 16.75 5C16.75 3.75736 17.7574 2.75 19 2.75C20.2426 2.75 21.25 3.75736 21.25 5ZM16.75 19C16.75 17.7574 17.7574 16.75 19 16.75C20.2426 16.75 21.25 17.7574 21.25 19C21.25 20.2426 20.2426 21.25 19 21.25C17.7574 21.25 16.75 20.2426 16.75 19Z", fill: t || "#8E8E8E" }) }), za = (t) => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.95526 2.25C3.97013 2.25001 3.98505 2.25001 4.00001 2.25001L20.0448 2.25C20.4776 2.24995 20.8744 2.24991 21.1972 2.29331C21.5527 2.3411 21.9284 2.45355 22.2374 2.76257C22.5465 3.07159 22.6589 3.44732 22.7067 3.8028C22.7501 4.12561 22.7501 4.52245 22.75 4.95526V5.04475C22.7501 5.47757 22.7501 5.8744 22.7067 6.19721C22.6589 6.55269 22.5465 6.92842 22.2374 7.23744C21.9437 7.53121 21.5896 7.64733 21.25 7.69914V13.0564C21.25 14.8942 21.25 16.3498 21.0969 17.489C20.9392 18.6615 20.6071 19.6104 19.8588 20.3588C19.1104 21.1071 18.1615 21.4392 16.989 21.5969C15.8498 21.75 14.3942 21.75 12.5564 21.75H11.4436C9.60583 21.75 8.1502 21.75 7.01098 21.5969C5.83856 21.4392 4.88961 21.1071 4.14125 20.3588C3.39289 19.6104 3.06077 18.6615 2.90314 17.489C2.74998 16.3498 2.74999 14.8942 2.75001 13.0564L2.75001 7.69914C2.41038 7.64733 2.05634 7.53121 1.76257 7.23744C1.45355 6.92842 1.3411 6.55269 1.29331 6.19721C1.24991 5.8744 1.24995 5.47757 1.25 5.04476C1.25001 5.02988 1.25001 5.01496 1.25001 5.00001C1.25001 4.98505 1.25001 4.97013 1.25 4.95526C1.24995 4.52244 1.24991 4.12561 1.29331 3.8028C1.3411 3.44732 1.45355 3.07159 1.76257 2.76257C2.07159 2.45355 2.44732 2.3411 2.8028 2.29331C3.12561 2.24991 3.52244 2.24995 3.95526 2.25ZM4.25001 7.75001V13C4.25001 14.9068 4.2516 16.2615 4.38977 17.2892C4.52503 18.2952 4.7787 18.8749 5.20191 19.2981C5.62512 19.7213 6.20477 19.975 7.21086 20.1102C8.19303 20.2423 9.47389 20.2496 11.25 20.25V13.9545L9.55748 15.8351C9.28038 16.1429 8.80617 16.1679 8.49828 15.8908C8.1904 15.6137 8.16544 15.1395 8.44254 14.8316L11.4425 11.4983C11.5848 11.3402 11.7874 11.25 12 11.25C12.2126 11.25 12.4152 11.3402 12.5575 11.4983L15.5575 14.8316C15.8346 15.1395 15.8096 15.6137 15.5017 15.8908C15.1938 16.1679 14.7196 16.1429 14.4425 15.8351L12.75 13.9545V20.25C14.5261 20.2496 15.807 20.2423 16.7892 20.1102C17.7952 19.975 18.3749 19.7213 18.7981 19.2981C19.2213 18.8749 19.475 18.2952 19.6102 17.2892C19.7484 16.2615 19.75 14.9068 19.75 13V7.75001H4.25001ZM2.82324 3.82324L2.82568 3.82187C2.82761 3.82086 2.83093 3.81924 2.83597 3.81717C2.85775 3.80821 2.90611 3.79291 3.00267 3.77993C3.21339 3.7516 3.5074 3.75001 4.00001 3.75001H20C20.4926 3.75001 20.7866 3.7516 20.9973 3.77993C21.0939 3.79291 21.1423 3.80821 21.164 3.81717C21.1691 3.81924 21.1724 3.82086 21.1743 3.82187L21.1768 3.82323L21.1781 3.82568C21.1792 3.82761 21.1808 3.83093 21.1828 3.83597C21.1918 3.85775 21.2071 3.90611 21.2201 4.00267C21.2484 4.21339 21.25 4.5074 21.25 5.00001C21.25 5.49261 21.2484 5.78662 21.2201 5.99734C21.2071 6.0939 21.1918 6.14226 21.1828 6.16404C21.1808 6.16909 21.1792 6.1724 21.1781 6.17434L21.1768 6.17678L21.1743 6.17815C21.1724 6.17916 21.1691 6.18077 21.164 6.18285C21.1423 6.19181 21.0939 6.2071 20.9973 6.22008C20.7866 6.24841 20.4926 6.25001 20 6.25001H4.00001C3.5074 6.25001 3.21339 6.24841 3.00267 6.22008C2.90611 6.2071 2.85775 6.19181 2.83597 6.18285C2.83093 6.18077 2.82761 6.17916 2.82568 6.17815L2.82324 6.17677L2.82187 6.17434C2.82086 6.1724 2.81924 6.16909 2.81717 6.16404C2.80821 6.14226 2.79291 6.0939 2.77993 5.99734C2.7516 5.78662 2.75001 5.49261 2.75001 5.00001C2.75001 4.5074 2.7516 4.21339 2.77993 4.00267C2.79291 3.90611 2.80821 3.85775 2.81717 3.83597C2.81924 3.83093 2.82086 3.82761 2.82187 3.82568L2.82324 3.82324ZM2.82324 6.17677C2.82284 6.17636 2.82297 6.17644 2.82324 6.17677V6.17677Z", fill: t || "#8E8E8E" }) }), Ya = (t) => /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", children: [
  /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3094 2.25002H13.6908C13.9072 2.24988 14.0957 2.24976 14.2737 2.27819C14.977 2.39049 15.5856 2.82915 15.9146 3.46084C15.9978 3.62073 16.0573 3.79961 16.1256 4.00494L16.2373 4.33984C16.2562 4.39653 16.2616 4.41258 16.2661 4.42522C16.4413 4.90933 16.8953 5.23659 17.4099 5.24964C17.4235 5.24998 17.44 5.25004 17.5001 5.25004H20.5001C20.9143 5.25004 21.2501 5.58582 21.2501 6.00004C21.2501 6.41425 20.9143 6.75004 20.5001 6.75004H3.5C3.08579 6.75004 2.75 6.41425 2.75 6.00004C2.75 5.58582 3.08579 5.25004 3.5 5.25004H6.50008C6.56013 5.25004 6.5767 5.24998 6.59023 5.24964C7.10488 5.23659 7.55891 4.90936 7.73402 4.42524C7.73863 4.41251 7.74392 4.39681 7.76291 4.33984L7.87452 4.00496C7.94281 3.79964 8.00233 3.62073 8.08559 3.46084C8.41453 2.82915 9.02313 2.39049 9.72643 2.27819C9.90445 2.24976 10.093 2.24988 10.3094 2.25002ZM9.00815 5.25004C9.05966 5.14902 9.10531 5.04404 9.14458 4.93548C9.1565 4.90251 9.1682 4.86742 9.18322 4.82234L9.28302 4.52292C9.37419 4.24941 9.39519 4.19363 9.41601 4.15364C9.52566 3.94307 9.72853 3.79686 9.96296 3.75942C10.0075 3.75231 10.067 3.75004 10.3553 3.75004H13.6448C13.9331 3.75004 13.9927 3.75231 14.0372 3.75942C14.2716 3.79686 14.4745 3.94307 14.5842 4.15364C14.605 4.19363 14.626 4.2494 14.7171 4.52292L14.8169 4.82216L14.8556 4.9355C14.8949 5.04405 14.9405 5.14902 14.992 5.25004H9.00815Z", fill: t || "#939393" }),
  /* @__PURE__ */ h("path", { d: "M5.91509 8.45015C5.88754 8.03685 5.53016 7.72415 5.11686 7.7517C4.70357 7.77925 4.39086 8.13663 4.41841 8.54993L4.88186 15.5017C4.96736 16.7844 5.03642 17.8205 5.19839 18.6336C5.36679 19.4789 5.65321 20.185 6.2448 20.7385C6.8364 21.2919 7.55995 21.5308 8.4146 21.6425C9.23662 21.7501 10.275 21.7501 11.5606 21.75H12.4395C13.7251 21.7501 14.7635 21.7501 15.5856 21.6425C16.4402 21.5308 17.1638 21.2919 17.7554 20.7385C18.347 20.185 18.6334 19.4789 18.8018 18.6336C18.9638 17.8206 19.0328 16.7844 19.1183 15.5017L19.5818 8.54993C19.6093 8.13663 19.2966 7.77925 18.8833 7.7517C18.47 7.72415 18.1126 8.03685 18.0851 8.45015L17.6251 15.3493C17.5353 16.6971 17.4713 17.6349 17.3307 18.3406C17.1943 19.025 17.004 19.3873 16.7306 19.6431C16.4572 19.8989 16.083 20.0647 15.391 20.1552C14.6776 20.2485 13.7376 20.25 12.3868 20.25H11.6134C10.2626 20.25 9.32255 20.2485 8.60915 20.1552C7.91715 20.0647 7.54299 19.8989 7.26958 19.6431C6.99617 19.3873 6.80583 19.025 6.66948 18.3406C6.52892 17.6349 6.46489 16.6971 6.37503 15.3493L5.91509 8.45015Z", fill: t || "#939393" }),
  /* @__PURE__ */ h("path", { d: "M9.42546 10.2538C9.83762 10.2125 10.2052 10.5133 10.2464 10.9254L10.7464 15.9254C10.7876 16.3376 10.4869 16.7051 10.0747 16.7463C9.66256 16.7875 9.29503 16.4868 9.25381 16.0747L8.75381 11.0747C8.7126 10.6625 9.01331 10.295 9.42546 10.2538Z", fill: t || "#939393" }),
  /* @__PURE__ */ h("path", { d: "M14.5747 10.2538C14.9869 10.295 15.2876 10.6625 15.2464 11.0747L14.7464 16.0747C14.7052 16.4868 14.3376 16.7875 13.9255 16.7463C13.5133 16.7051 13.2126 16.3376 13.2538 15.9254L13.7538 10.9254C13.795 10.5133 14.1626 10.2125 14.5747 10.2538Z", fill: t || "#939393" })
] }), Toe = () => {
  var i, o, s, a, c;
  const {
    submit: t,
    handleBackClick: e,
    handleThanks: r
  } = tl(), { themeManager: n, feedbackWorkflowFunctions: A } = tl();
  return /* @__PURE__ */ h(Ze, { children: t && /* @__PURE__ */ k(
    "div",
    {
      className: "q-fw-div",
      style: {
        ...n == null ? void 0 : n.getThanksPopUpBackgroundStyles()
      },
      id: "disabledClick",
      children: [
        /* @__PURE__ */ h("div", { className: "q_submit_cross_icon", onClick: r, children: I3(A.geticonColor(), e) }),
        /* @__PURE__ */ h("div", { className: "q-fw-thanks", children: /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h("div", { className: "q-svg-thanks", children: GM(
            n.getThanksPopUbIconBackgroundStyle()
          ) }),
          /* @__PURE__ */ k("div", { className: "q_fw_submit_box", children: [
            /* @__PURE__ */ k("div", { className: "q_feedback_text_submitted", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_feedback_text_cont",
                  style: {
                    ...n.getThanksPopUpHeadingStyle()
                  },
                  children: "Feedback Submitted"
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_fw_submit_desc",
                  style: {
                    ...n.getThanksPopUpDescriptionStyle()
                  },
                  children: "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them"
                }
              )
            ] }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_fw_submit_back",
                style: {
                  ...n.getThanksPopUpSecondaryBtnBackground()
                },
                children: A.getSecondaryButtonText()
              }
            )
          ] })
        ] }) }),
        (n.getThanksPopUpFooter() || A.getshowFooter()) && /* @__PURE__ */ h(
          Pr,
          {
            style: (i = n == null ? void 0 : n.getFooterStyles()) == null ? void 0 : i.FooterStyle,
            textStyle: (o = n == null ? void 0 : n.getFooterStyles()) == null ? void 0 : o.FooterTextStyle,
            iconStyle: (s = n == null ? void 0 : n.getFooterStyles()) == null ? void 0 : s.FooterIcon,
            text: (a = n == null ? void 0 : n.getFooterStyles()) == null ? void 0 : a.FooterText,
            link: (c = n == null ? void 0 : n.getFooterStyles()) == null ? void 0 : c.FooterLink
          }
        )
      ]
    }
  ) });
}, e2 = {
  accentColor: "",
  theme: "",
  borderRadius: "",
  buttonColor: "",
  images: []
}, s7 = {
  accentColor: "",
  background: "",
  borderRadius: "",
  primaryButton: "",
  contentColor: "",
  fontFamily: "",
  logo: "",
  primaryColor: "",
  secondaryColor: "",
  tertiaryColor: "",
  titleColor: ""
};
class Moe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    ke(this, "metricApi", (e, r, n, A, i, o) => {
      const s = async (a) => {
        try {
          const c = `${r}api/entities/${n}/metrics/${a}/campaign`, l = await Oe.post(c, { campaignId: A, campaignVariationId: i, ...o }, { headers: e });
          if (l.status === 200 && l.data.success)
            return l;
        } catch (c) {
          c.response && c.response.data && c.response.data.error ? console.error("API request failed:", c.response.data.error) : console.error("API request failed:", c.message);
        }
      };
      return {
        async view() {
          return s("onboarding-view");
        },
        async page(a) {
          return s(`onboarding-complete-page-${a}`);
        },
        async complete() {
          return s("onboarding-complete");
        }
      };
    });
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a == n || a == A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosHeaders({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          { headers: u }
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, { path: "/", expires: p }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), null;
    }
  }
  async fetchCampaignData(e, r, n, A) {
    var i;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const o = new URLSearchParams();
      o.set("platform", "REACT"), A && o.set("variation", A);
      const s = this.getAxiosHeaders(n), a = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/parent?${o.toString()}`, c = await Oe.get(a, {
        headers: s
      });
      if (!((i = c.data) != null && i.data))
        throw new Error("No data received from API");
      return c.data.data;
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
  async verifyAction(e, r, n, A, i) {
    var o;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const s = {
        actions: [
          {
            answers: [],
            actionId: A
          }
        ],
        campaignVariationId: i
      }, a = this.getAxiosHeaders(n), c = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/verify`, l = await Oe.post(
        c,
        s,
        { headers: a }
      );
      if (!((o = l.data) != null && o.data))
        throw new Error("Invalid response from verify action");
      return l.data.data;
    } catch (s) {
      throw this.GeneralFunctions.captureSentryException(s), s;
    }
  }
  clearCookies() {
    this.cookies.remove("externalUserId", { path: "/" }), this.cookies.remove("questUserId", { path: "/" }), this.cookies.remove("questUserToken", { path: "/" });
  }
  isValidUserAuth(e) {
    return !!e && typeof e.userId == "string" && typeof e.token == "string";
  }
}
function Hoe(t, e = 0.05) {
  t = t == null ? void 0 : t.replace("#", ""), t && t.length === 3 && (t = t == null ? void 0 : t.split("").map((i) => i + i).join(""));
  const r = parseInt(t == null ? void 0 : t.substring(0, 2), 16), n = parseInt(t == null ? void 0 : t.substring(2, 4), 16), A = parseInt(t == null ? void 0 : t.substring(4, 6), 16);
  return `rgba(${r}, ${n}, ${A}, ${e})`;
}
const Doe = (t) => Math.min(255, Math.max(0, Math.round(t))), Qoe = (t) => (t = t.replace(/[#\s]/g, ""), t.length === 3 && (t = t.split("").map((e) => e + e).join("")), /^[0-9A-Fa-f]{6}$/.test(t) ? [
  parseInt(t.slice(0, 2), 16),
  parseInt(t.slice(2, 4), 16),
  parseInt(t.slice(4, 6), 16)
] : null), Uoe = (t) => {
  const e = t.match(/rgb\(?\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)?/);
  return e ? [+e[1], +e[2], +e[3]] : null;
}, cB = (t) => t ? (t = t.trim(), t.startsWith("#") ? Qoe(t) : Uoe(t)) : null, lB = (t, e) => {
  const r = 1 + e / 100;
  return t.map((n) => Doe(n * r));
}, Noe = (t) => {
  const e = /(linear|radial)-gradient\s*\((([^()]*|\([^()]*\))*)\)/i, r = t.match(e);
  if (!r) return null;
  const [n, A, i] = r, o = i.split(/,(?![^(]*\))/);
  let s = null, a = [];
  return o.forEach((c, l) => {
    if (c = c.trim(), l === 0 && /deg|turn|rad|grad/.test(c)) {
      s = c;
      return;
    }
    const u = c.match(/((#[0-9A-Fa-f]{3,6}|rgb\s*\([^)]+\))\s*)([\d.]+%)?/);
    u && a.push({
      color: u[1].trim(),
      stop: u[3] ? u[3].trim() : null
    });
  }), {
    type: A,
    angle: s,
    colors: a
  };
}, F0 = (t, e) => {
  if (!t || typeof t != "string") return null;
  try {
    if (t.includes("gradient")) {
      const A = Noe(t);
      if (!A) return null;
      const i = A.colors.map(({ color: s, stop: a }) => {
        const c = cB(s);
        return c ? `rgb(${lB(c, e).join(", ")})${a ? " " + a : ""}` : null;
      });
      if (i.includes(null)) return null;
      const o = A.angle ? A.angle + ", " : "";
      return `${A.type}-gradient(${o}${i.join(", ")})`;
    }
    const r = cB(t);
    return r ? `rgb(${lB(r, e).join(", ")})` : null;
  } catch {
    return null;
  }
};
class joe {
  constructor(e = {}, r = {}, n = e2, A = s7, i) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    ke(this, "UiProps");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = { ...e2, ...n }, this.brandTheme = { ...s7, ...A }, this.UiProps = i;
  }
  getStyleValueAsString(e, r = "") {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "string" ? A : r;
  }
  getStyleValueAsObject(e, r) {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "object" ? A : r;
  }
  // Modal
  getModalStyles() {
    var e;
    return {
      borderRadius: this.getBorderRadius(),
      ...(e = this.styleConfig) == null ? void 0 : e.Modal
    };
  }
  // Form
  getFormStyles() {
    var e, r, n;
    return {
      background: this.getBackgroundColor(),
      height: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.height) || "auto",
      borderRadius: this.getBorderRadius(),
      fontFamily: this.getFontFamily(),
      ...(n = this.styleConfig) == null ? void 0 : n.Form
    };
  }
  // Heading Style
  getHeadingStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.titleColor) || ((A = this.brandTheme) == null ? void 0 : A.primaryColor) || ((i = this.themeConfig) == null ? void 0 : i.primaryColor) || "#000000",
      ...(o = this.styleConfig) == null ? void 0 : o.Heading
    };
  }
  // description Style
  getDescriptionStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor) || "#666666",
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  // done
  getTopBarStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      headingStyle: {
        color: this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.titleColor) || ((r = this.brandTheme) == null ? void 0 : r.primaryColor) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor) || "#000000",
        ...(A = this.styleConfig) == null ? void 0 : A.Heading
      },
      descriptionStyle: {
        color: this.getStyleValueAsString("Description.color") || ((i = this.brandTheme) == null ? void 0 : i.secondaryColor) || ((o = this.themeConfig) == null ? void 0 : o.secondaryColor) || "#666666",
        ...(s = this.styleConfig) == null ? void 0 : s.Description
      },
      topbarStyle: {
        ...(a = this.styleConfig) == null ? void 0 : a.TopBar
      }
    };
  }
  // done
  getPrimaryButtonStyles() {
    var e, r, n, A, i, o, s, a, c;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.PrimaryButton) == null ? void 0 : r.background) || ((A = (n = this.styleConfig) == null ? void 0 : n.PrimaryButton) == null ? void 0 : A.backgroundColor) || ((i = this.questThemeData) == null ? void 0 : i.buttonColor) || ((o = this.questThemeData) == null ? void 0 : o.accentColor) || ((s = this.brandTheme) == null ? void 0 : s.primaryButton),
      borderColor: ((a = this.styleConfig) == null ? void 0 : a.PrimaryButton) || ((c = this.questThemeData) == null ? void 0 : c.accentColor),
      ...this.styleConfig.PrimaryButton
    };
  }
  // done
  getStarStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      Style: (r = (e = this.styleConfig) == null ? void 0 : e.Star) == null ? void 0 : r.Style,
      PrimaryColor: (A = (n = this.styleConfig) == null ? void 0 : n.Star) == null ? void 0 : A.PrimaryColor,
      SecondaryColor: (o = (i = this.styleConfig) == null ? void 0 : i.Star) == null ? void 0 : o.SecondaryColor,
      Size: (a = (s = this.styleConfig) == null ? void 0 : s.Star) == null ? void 0 : a.Size
    };
  }
  // done
  getLabelStyles() {
    var e, r, n, A, i, o, s;
    return {
      ...(e = this.styleConfig) == null ? void 0 : e.Label,
      color: ((n = (r = this.styleConfig) == null ? void 0 : r.Label) == null ? void 0 : n.color) || ((i = (A = this.styleConfig) == null ? void 0 : A.Heading) == null ? void 0 : i.color) || ((o = this.brandTheme) == null ? void 0 : o.primaryColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor)
    };
  }
  getInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.color) || ((A = (n = this.styleConfig) == null ? void 0 : n.Heading) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.Input
    };
  }
  getEmailText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) || "This is not a valid email";
  }
  getGeneralFeedbackEmailText(e) {
    var r, n, A, i, o, s, a, c, l, u, f, d;
    if (e === "ReportBug")
      return ((i = (A = (n = (r = this.UiProps) == null ? void 0 : r.ReportBug) == null ? void 0 : n.styleConfig) == null ? void 0 : A.EmailError) == null ? void 0 : i.text) || "This is not a valid email";
    if (e === "RequestFeature")
      return ((c = (a = (s = (o = this.UiProps) == null ? void 0 : o.RequestFeature) == null ? void 0 : s.styleConfig) == null ? void 0 : a.EmailError) == null ? void 0 : c.text) || "This is not a valid email";
    if (e === "GeneralFeedback")
      return ((d = (f = (u = (l = this.UiProps) == null ? void 0 : l.GeneralFeedback) == null ? void 0 : u.styleConfig) == null ? void 0 : f.EmailError) == null ? void 0 : d.text) || "This is not a valid email";
  }
  getGeneralFeedbackEmailErrorStyles(e) {
    var r, n, A, i, o, s, a, c, l, u, f, d;
    if (e === "ReportBug")
      return {
        ...(i = (A = (n = (r = this.UiProps) == null ? void 0 : r.ReportBug) == null ? void 0 : n.styleConfig) == null ? void 0 : A.EmailError) == null ? void 0 : i.errorStyle
      };
    if (e === "RequestFeature")
      return {
        ...(c = (a = (s = (o = this.UiProps) == null ? void 0 : o.RequestFeature) == null ? void 0 : s.styleConfig) == null ? void 0 : a.EmailError) == null ? void 0 : c.errorStyle
      };
    if (e === "GeneralFeedback")
      return {
        ...(d = (f = (u = (l = this.UiProps) == null ? void 0 : l.GeneralFeedback) == null ? void 0 : u.styleConfig) == null ? void 0 : f.EmailError) == null ? void 0 : d.errorStyle
      };
  }
  // done
  getGeneralFeedbackTextAreaStylesd(e) {
    var r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w, B, y, b, q, E, x, M, O, I, S, P, H, F, T, U, D, Q, Y;
    if (e === "ReportBug")
      return {
        borderColor: (i = (A = (n = (r = this.UiProps) == null ? void 0 : r.ReportBug) == null ? void 0 : n.styleConfig) == null ? void 0 : A.TextArea) == null ? void 0 : i.borderColor,
        color: (c = (a = (s = (o = this.UiProps) == null ? void 0 : o.ReportBug) == null ? void 0 : s.styleConfig) == null ? void 0 : a.TextArea) == null ? void 0 : c.color,
        ...(f = (u = (l = this.UiProps) == null ? void 0 : l.ReportBug) == null ? void 0 : u.styleConfig) == null ? void 0 : f.TextArea,
        ...(d = this.styleConfig) == null ? void 0 : d.TextArea
      };
    if (e === "RequestFeature")
      return {
        borderColor: (v = (p = (m = (g = this.UiProps) == null ? void 0 : g.RequestFeature) == null ? void 0 : m.styleConfig) == null ? void 0 : p.TextArea) == null ? void 0 : v.borderColor,
        color: (y = (B = (w = (C = this.UiProps) == null ? void 0 : C.RequestFeature) == null ? void 0 : w.styleConfig) == null ? void 0 : B.TextArea) == null ? void 0 : y.color,
        ...(E = (q = (b = this.UiProps) == null ? void 0 : b.RequestFeature) == null ? void 0 : q.styleConfig) == null ? void 0 : E.TextArea,
        ...(x = this.styleConfig) == null ? void 0 : x.TextArea
      };
    if (e === "GeneralFeedback")
      return {
        borderColor: (S = (I = (O = (M = this.UiProps) == null ? void 0 : M.GeneralFeedback) == null ? void 0 : O.styleConfig) == null ? void 0 : I.TextArea) == null ? void 0 : S.borderColor,
        color: (T = (F = (H = (P = this.UiProps) == null ? void 0 : P.GeneralFeedback) == null ? void 0 : H.styleConfig) == null ? void 0 : F.TextArea) == null ? void 0 : T.color,
        ...(Q = (D = (U = this.UiProps) == null ? void 0 : U.GeneralFeedback) == null ? void 0 : D.styleConfig) == null ? void 0 : Q.TextArea,
        ...(Y = this.styleConfig) == null ? void 0 : Y.TextArea
      };
  }
  getStepStyles() {
    var e, r, n, A, i, o;
    return {
      step: {
        color: this.getStyleValueAsString("Description.color") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666"
      },
      title: {
        color: this.getStyleValueAsString("Heading.color") || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor) || "#000000"
      },
      description: {
        color: this.getStyleValueAsString("Description.color") || ((i = this.brandTheme) == null ? void 0 : i.secondaryColor) || ((o = this.themeConfig) == null ? void 0 : o.secondaryColor) || "#666666"
      }
    };
  }
  ensureBoolean(e) {
    return !!e;
  }
  getProgressStyles(e) {
    const r = this.ensureBoolean(e);
    return {
      imageCont: {
        background: r ? "#01ff0111" : "#FBFBFB"
      },
      connector: {
        background: r ? "#73DCA7" : "#EFEFEF"
      }
    };
  }
  // done
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p;
    return {
      FooterStyle: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.background) || ((o = (i = (A = this.styleConfig) == null ? void 0 : A.Footer) == null ? void 0 : i.FooterStyle) == null ? void 0 : o.backgroundColor) || this.getBackgroundColor(),
        ...(a = (s = this.styleConfig) == null ? void 0 : s.Footer) == null ? void 0 : a.FooterStyle
      },
      FooterTextStyle: {
        ...(l = (c = this.styleConfig) == null ? void 0 : c.Footer) == null ? void 0 : l.FooterTextStyle
      },
      FooterIcon: {
        ...(f = (u = this.styleConfig) == null ? void 0 : u.Footer) == null ? void 0 : f.FooterIcon
      },
      FooterText: (g = (d = this.styleConfig) == null ? void 0 : d.Footer) == null ? void 0 : g.FooterText,
      FooterLink: (p = (m = this.styleConfig) == null ? void 0 : m.Footer) == null ? void 0 : p.FooterLink
    };
  }
  // done
  getListHoverCardStyle() {
    var e, r, n;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.background) || "#FBFBFB",
      ...(n = this.styleConfig) == null ? void 0 : n.Card
    };
  }
  // done
  getListHoverIconStyle() {
    var e, r;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.iconBackground) || Hoe(this.questThemeData.accentColor, 0.1) || "#F4EBFF"
    };
  }
  getListHoverIcon() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.Icon
    };
  }
  getListHoverSvg() {
    var e, r, n;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.iconColor) || F0((n = this.questThemeData) == null ? void 0 : n.accentColor, -40)
    };
  }
  // done
  getListHoverIconDetailStyle() {
    var e, r, n, A, i, o, s;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.iconColor) || ((i = (A = (n = this.styleConfig) == null ? void 0 : n.listHover) == null ? void 0 : A.Icon) == null ? void 0 : i.color) || "#9035FF",
      size: (s = (o = this.styleConfig) == null ? void 0 : o.listHover) == null ? void 0 : s.Icon
    };
  }
  // done
  getListHoverHeadingStyle1() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.Heading) || ((A = (n = this.styleConfig) == null ? void 0 : n.listHeading) == null ? void 0 : A.color) || ((o = (i = this.styleConfig) == null ? void 0 : i.Heading) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor) || ((a = this.themeConfig) == null ? void 0 : a.primaryColor)
    };
  }
  // done
  getListHoverHeadingStyle2() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.listHeading) == null ? void 0 : r.color) || ((A = (n = this.styleConfig) == null ? void 0 : n.Heading) == null ? void 0 : A.color) || ((o = (i = this.styleConfig) == null ? void 0 : i.Heading) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor) || ((a = this.themeConfig) == null ? void 0 : a.primaryColor)
    };
  }
  // done
  getListHeadingStyle() {
    var e;
    return {
      ...(e = this.styleConfig) == null ? void 0 : e.listHeading
    };
  }
  // done
  getListHoverDescriptionStyle1() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.listHover) == null ? void 0 : r.Description) || ((A = (n = this.styleConfig) == null ? void 0 : n.listDescription) == null ? void 0 : A.color) || ((o = (i = this.styleConfig) == null ? void 0 : i.Description) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.secondaryColor) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor)
    };
  }
  // done
  getListHoverDescriptionStyle2() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.listDescription) == null ? void 0 : r.color) || ((A = (n = this.styleConfig) == null ? void 0 : n.Description) == null ? void 0 : A.color) || ((o = (i = this.styleConfig) == null ? void 0 : i.Heading) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.secondaryColor) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor)
    };
  }
  // done
  getListDescriptionStyle() {
    var e;
    return {
      ...(e = this.styleConfig) == null ? void 0 : e.listDescription
    };
  }
  // done
  getGeneralFeedbackInputStyle(e) {
    var r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v;
    return e === "ReportBug" ? {
      ...(A = (n = (r = this.UiProps) == null ? void 0 : r.ReportBug) == null ? void 0 : n.styleConfig) == null ? void 0 : A.Input,
      ...(i = this.styleConfig) == null ? void 0 : i.Input
    } : e === "RequestFeature" ? {
      ...(a = (s = (o = this.UiProps) == null ? void 0 : o.RequestFeature) == null ? void 0 : s.styleConfig) == null ? void 0 : a.Input,
      ...(c = this.styleConfig) == null ? void 0 : c.Input
    } : e === "GeneralFeedback" ? {
      ...(f = (u = (l = this.UiProps) == null ? void 0 : l.GeneralFeedback) == null ? void 0 : u.styleConfig) == null ? void 0 : f.Input,
      ...(d = this.styleConfig) == null ? void 0 : d.Input
    } : {
      ...(p = (m = (g = this.UiProps) == null ? void 0 : g.GeneralFeedback) == null ? void 0 : m.styleConfig) == null ? void 0 : p.Input,
      ...(v = this.styleConfig) == null ? void 0 : v.Input
    };
  }
  // done
  getGeneralFeedbackPrimaryButtonStyle(e) {
    var r, n, A, i, o, s, a, c, l;
    if (e === "ReportBug")
      return {
        ...(A = (n = (r = this.UiProps) == null ? void 0 : r.ReportBug) == null ? void 0 : n.styleConfig) == null ? void 0 : A.PrimaryButton
      };
    if (e === "RequestFeature")
      return {
        ...(s = (o = (i = this.UiProps) == null ? void 0 : i.RequestFeature) == null ? void 0 : o.styleConfig) == null ? void 0 : s.PrimaryButton
      };
    if (e === "GeneralFeedback")
      return {
        ...(l = (c = (a = this.UiProps) == null ? void 0 : a.GeneralFeedback) == null ? void 0 : c.styleConfig) == null ? void 0 : l.PrimaryButton
      };
  }
  // done
  getGeneralFeedbackInputFormColor() {
    var e, r, n, A, i, o, s, a, c, l;
    return ((A = (n = (r = (e = this.UiProps) == null ? void 0 : e.GeneralFeedback) == null ? void 0 : r.styleConfig) == null ? void 0 : n.Input) == null ? void 0 : A.color) || ((a = (s = (o = (i = this.UiProps) == null ? void 0 : i.GeneralFeedback) == null ? void 0 : o.styleConfig) == null ? void 0 : s.Form) == null ? void 0 : a.color) || ((c = this.brandTheme) == null ? void 0 : c.primaryColor) || ((l = this.themeConfig) == null ? void 0 : l.primaryColor) || "#666666";
  }
  // donme
  getThanksPopUpBackgroundStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d;
    return {
      background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopup) == null ? void 0 : r.Style) == null ? void 0 : n.background) || ((o = (i = (A = this.styleConfig) == null ? void 0 : A.ThanksPopup) == null ? void 0 : i.Style) == null ? void 0 : o.backgroundColor) || this.getBackgroundColor(),
      height: ((c = (a = (s = this.styleConfig) == null ? void 0 : s.ThanksPopup) == null ? void 0 : a.Style) == null ? void 0 : c.height) || ((u = (l = this.styleConfig) == null ? void 0 : l.Form) == null ? void 0 : u.height) || "auto",
      borderRadius: this.getBorderRadius(),
      fontFamily: this.getFontFamily(),
      ...(d = (f = this.styleConfig) == null ? void 0 : f.ThanksPopup) == null ? void 0 : d.Style
    };
  }
  getThanksPopUbIconBackgroundStyle() {
    var e, r, n;
    return ((n = (r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopup) == null ? void 0 : r.Icon) == null ? void 0 : n.backgroundColor) || this.questThemeData.accentColor;
  }
  getThanksPopUpHeadingStyle() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(o = (i = this.styleConfig) == null ? void 0 : i.ThanksPopup) == null ? void 0 : o.Heading
    };
  }
  getThanksPopUpDescriptionStyle() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(o = (i = this.styleConfig) == null ? void 0 : i.ThanksPopup) == null ? void 0 : o.Description
    };
  }
  getThanksPopUpSecondaryBtnBackground() {
    var e, r, n, A;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.SecondaryButton) == null ? void 0 : r.background) || ((n = this.brandTheme) == null ? void 0 : n.secondaryButton),
      ...(A = this.styleConfig) == null ? void 0 : A.SecondaryButton
    };
  }
  getThanksPopUpFooter() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopup) == null ? void 0 : r.ShowFooter;
  }
  getBackgroundColor() {
    var e, r;
    return this.getStyleValueAsString("Form.backgroundColor") || this.getStyleValueAsString("Form.background") || ((e = this.brandTheme) == null ? void 0 : e.background) || ((r = this.themeConfig) == null ? void 0 : r.backgroundColor);
  }
  getFontFamily() {
    var e, r;
    return ((e = this.brandTheme) == null ? void 0 : e.fontFamily) || ((r = this.themeConfig) == null ? void 0 : r.fontFamily) || "'Figtree', sans-serif";
  }
  getBorderRadius() {
    var e, r;
    return this.getStyleValueAsString("Form.borderRadius") || ((e = this.questThemeData) == null ? void 0 : e.borderRadius) || ((r = this.brandTheme) == null ? void 0 : r.borderRadius) || "8px";
  }
  // Common style getters
  getPrimaryColor() {
    var e, r;
    return this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.primaryColor) || ((r = this.themeConfig) == null ? void 0 : r.primaryColor) || "#000000";
  }
  getSecondaryColor() {
    var e, r;
    return this.getStyleValueAsString("Description.color") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666";
  }
  // Update methods
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    var r;
    this.styleConfig = {
      ...this.styleConfig,
      ...e,
      Footer: {
        ...(r = this.styleConfig) == null ? void 0 : r.Footer,
        ...e == null ? void 0 : e.Footer
      }
    };
  }
  updateQuestTheme(e) {
    this.questThemeData = {
      ...this.questThemeData,
      ...e
    };
  }
  updateBrandTheme(e) {
    this.brandTheme = {
      ...this.brandTheme,
      ...e
    };
  }
  mergeStyles(e, r) {
    return {
      ...e,
      ...r || {}
    };
  }
  getComputedStyle(e, r = {}) {
    return this.mergeStyles(
      r,
      this.getStyleValueAsObject(e, {})
    );
  }
}
const rl = () => /* @__PURE__ */ h("div", { className: "questLabs quest-loader", children: /* @__PURE__ */ k(
  "div",
  {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50
    },
    children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: { position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }
        }
      ),
      /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "inline-block",
            width: "3rem",
            height: "3rem",
            animation: "spin 1.5s linear infinite",
            border: "0.25rem solid currentColor",
            borderRight: "0.25rem solid transparent",
            borderRadius: "50%",
            transform: "translateZ(0)",
            position: "relative"
          },
          children: /* @__PURE__ */ h(
            "div",
            {
              style: {
                position: "absolute",
                width: "0",
                height: "0",
                overflow: "hidden",
                whiteSpace: "nowrap",
                border: "0",
                padding: "0",
                clip: "rect(0,0,0,0)",
                display: "inline"
              },
              children: "Loading..."
            }
          )
        }
      ) })
    ]
  }
) }), zM = ({ isOpen: t, onClose: e, children: r, style: n }) => {
  const A = (o) => {
    var a;
    let s = o.target;
    (a = i.current) != null && a.contains(s) || e && e();
  }, i = re.useRef(null);
  return /* @__PURE__ */ h(Ze, { children: t && /* @__PURE__ */ h("div", { className: "q_modal_overlay", style: { zIndex: (n == null ? void 0 : n.zIndex) || 1 }, onClick: (o) => A(o), children: /* @__PURE__ */ h("div", { className: "q_modal", ref: i, id: "modal_box", style: n, children: r }) }) });
}, Loe = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`;
function T1({
  heading: t,
  description: e,
  iconColor: r,
  onClose: n,
  style: A
}) {
  const { themeConfig: i } = Xe(ct.Context), o = (s = "#AFAFAF", a) => {
    var c;
    return /* @__PURE__ */ h(
      "img",
      {
        onClick: () => a == null ? void 0 : a(),
        style: {
          cursor: "pointer",
          ...A == null ? void 0 : A.iconStyle,
          background: "inherit",
          backgroundColor: "inherit"
        },
        src: Loe(`
        <svg
            width="20"
            height="20"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.4003 7.61363C24.2769 7.49003 24.1304 7.39196 23.9691 7.32505C23.8078 7.25815 23.6349 7.22371 23.4603 7.22371C23.2857 7.22371 23.1128 7.25815 22.9515 7.32505C22.7902 7.39196 22.6436 7.49003 22.5203 7.61363L16.0003 14.1203L9.4803 7.6003C9.35686 7.47686 9.21031 7.37894 9.04902 7.31213C8.88774 7.24532 8.71487 7.21094 8.5403 7.21094C8.36572 7.21094 8.19286 7.24532 8.03157 7.31213C7.87029 7.37894 7.72374 7.47686 7.6003 7.6003C7.47686 7.72374 7.37894 7.87029 7.31213 8.03157C7.24532 8.19286 7.21094 8.36572 7.21094 8.5403C7.21094 8.71487 7.24532 8.88774 7.31213 9.04902C7.37894 9.21031 7.47686 9.35686 7.6003 9.4803L14.1203 16.0003L7.6003 22.5203C7.47686 22.6437 7.37894 22.7903 7.31213 22.9516C7.24532 23.1129 7.21094 23.2857 7.21094 23.4603C7.21094 23.6349 7.24532 23.8077 7.31213 23.969C7.37894 24.1303 7.47686 24.2769 7.6003 24.4003C7.72374 24.5237 7.87029 24.6217 8.03157 24.6885C8.19286 24.7553 8.36572 24.7897 8.5403 24.7897C8.71487 24.7897 8.88774 24.7553 9.04902 24.6885C9.21031 24.6217 9.35686 24.5237 9.4803 24.4003L16.0003 17.8803L22.5203 24.4003C22.6437 24.5237 22.7903 24.6217 22.9516 24.6885C23.1129 24.7553 23.2857 24.7897 23.4603 24.7897C23.6349 24.7897 23.8077 24.7553 23.969 24.6885C24.1303 24.6217 24.2769 24.5237 24.4003 24.4003C24.5237 24.2769 24.6217 24.1303 24.6885 23.969C24.7553 23.8077 24.7897 23.6349 24.7897 23.4603C24.7897 23.2857 24.7553 23.1129 24.6885 22.9516C24.6217 22.7903 24.5237 22.6437 24.4003 22.5203L17.8803 16.0003L24.4003 9.4803C24.907 8.97363 24.907 8.1203 24.4003 7.61363Z"
              fill="${((c = A == null ? void 0 : A.iconStyle) == null ? void 0 : c.backgroundColor) || s}"
            />
          </svg>
        `)
      }
    );
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: "q_top_bar",
      style: { background: i.backgroundColor, ...A == null ? void 0 : A.topbarStyle },
      children: [
        /* @__PURE__ */ k("div", { className: "q_top_bar_cont", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_top_bar_heading",
              style: { color: i.primaryColor, ...A == null ? void 0 : A.headingStyle },
              children: t
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              style: {
                color: i.secondaryColor,
                ...A == null ? void 0 : A.descriptionStyle
              },
              className: "q_top_bar_desc",
              children: e
            }
          )
        ] }),
        o(r, n)
      ]
    }
  );
}
var a7 = function(t, e) {
  return a7 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var A in n) Object.prototype.hasOwnProperty.call(n, A) && (r[A] = n[A]);
  }, a7(t, e);
};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var c7 = function(t, e) {
  return c7 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var A in n) Object.prototype.hasOwnProperty.call(n, A) && (r[A] = n[A]);
  }, c7(t, e);
};
function yo(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function r() {
    this.constructor = t;
  }
  c7(t, e), t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var l7 = function() {
  return l7 = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) for (var A in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, A) && (t[A] = e[A]);
    return t;
  }, l7.apply(this, arguments);
};
function GA(t, e, r, n) {
  return new (r || (r = Promise))(function(A, i) {
    function o(c) {
      try {
        a(n.next(c));
      } catch (l) {
        i(l);
      }
    }
    function s(c) {
      try {
        a(n.throw(c));
      } catch (l) {
        i(l);
      }
    }
    function a(c) {
      var l;
      c.done ? A(c.value) : (l = c.value, l instanceof r ? l : new r(function(u) {
        u(l);
      })).then(o, s);
    }
    a((n = n.apply(t, [])).next());
  });
}
function IA(t, e) {
  var r, n, A, i, o = { label: 0, sent: function() {
    if (1 & A[0]) throw A[1];
    return A[1];
  }, trys: [], ops: [] };
  return i = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(a) {
    return function(c) {
      return function(l) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; o; ) try {
          if (r = 1, n && (A = 2 & l[0] ? n.return : l[0] ? n.throw || ((A = n.return) && A.call(n), 0) : n.next) && !(A = A.call(n, l[1])).done) return A;
          switch (n = 0, A && (l = [2 & l[0], A.value]), l[0]) {
            case 0:
            case 1:
              A = l;
              break;
            case 4:
              return o.label++, { value: l[1], done: !1 };
            case 5:
              o.label++, n = l[1], l = [0];
              continue;
            case 7:
              l = o.ops.pop(), o.trys.pop();
              continue;
            default:
              if (A = o.trys, !((A = A.length > 0 && A[A.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                o = 0;
                continue;
              }
              if (l[0] === 3 && (!A || l[1] > A[0] && l[1] < A[3])) {
                o.label = l[1];
                break;
              }
              if (l[0] === 6 && o.label < A[1]) {
                o.label = A[1], A = l;
                break;
              }
              if (A && o.label < A[2]) {
                o.label = A[2], o.ops.push(l);
                break;
              }
              A[2] && o.ops.pop(), o.trys.pop();
              continue;
          }
          l = e.call(t, o);
        } catch (u) {
          l = [6, u], n = 0;
        } finally {
          r = A = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([a, c]);
    };
  }
}
function bf(t, e, r) {
  if (arguments.length === 2) for (var n, A = 0, i = e.length; A < i; A++) !n && A in e || (n || (n = Array.prototype.slice.call(e, 0, A)), n[A] = e[A]);
  return t.concat(n || e);
}
for (var Ds = function() {
  function t(e, r, n, A) {
    this.left = e, this.top = r, this.width = n, this.height = A;
  }
  return t.prototype.add = function(e, r, n, A) {
    return new t(this.left + e, this.top + r, this.width + n, this.height + A);
  }, t.fromClientRect = function(e, r) {
    return new t(r.left + e.windowBounds.left, r.top + e.windowBounds.top, r.width, r.height);
  }, t.fromDOMRectList = function(e, r) {
    var n = Array.from(r).find(function(A) {
      return A.width !== 0;
    });
    return n ? new t(n.left + e.windowBounds.left, n.top + e.windowBounds.top, n.width, n.height) : t.EMPTY;
  }, t.EMPTY = new t(0, 0, 0, 0), t;
}(), h4 = function(t, e) {
  return Ds.fromClientRect(t, e.getBoundingClientRect());
}, S3 = function(t) {
  for (var e = [], r = 0, n = t.length; r < n; ) {
    var A = t.charCodeAt(r++);
    if (A >= 55296 && A <= 56319 && r < n) {
      var i = t.charCodeAt(r++);
      (64512 & i) == 56320 ? e.push(((1023 & A) << 10) + (1023 & i) + 65536) : (e.push(A), r--);
    } else e.push(A);
  }
  return e;
}, wn = function() {
  for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
  if (String.fromCodePoint) return String.fromCodePoint.apply(String, t);
  var r = t.length;
  if (!r) return "";
  for (var n = [], A = -1, i = ""; ++A < r; ) {
    var o = t[A];
    o <= 65535 ? n.push(o) : (o -= 65536, n.push(55296 + (o >> 10), o % 1024 + 56320)), (A + 1 === r || n.length > 16384) && (i += String.fromCharCode.apply(String, n), n.length = 0);
  }
  return i;
}, Goe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Roe = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Bf = 0; Bf < 64; Bf++) Roe[Goe.charCodeAt(Bf)] = Bf;
for (var zoe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", T0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Ef = 0; Ef < 64; Ef++) T0[zoe.charCodeAt(Ef)] = Ef;
for (var uB = function(t, e, r) {
  return t.slice ? t.slice(e, r) : new Uint16Array(Array.prototype.slice.call(t, e, r));
}, Yoe = function() {
  function t(e, r, n, A, i, o) {
    this.initialValue = e, this.errorValue = r, this.highStart = n, this.highValueIndex = A, this.index = i, this.data = o;
  }
  return t.prototype.get = function(e) {
    var r;
    if (e >= 0) {
      if (e < 55296 || e > 56319 && e <= 65535) return r = ((r = this.index[e >> 5]) << 2) + (31 & e), this.data[r];
      if (e <= 65535) return r = ((r = this.index[2048 + (e - 55296 >> 5)]) << 2) + (31 & e), this.data[r];
      if (e < this.highStart) return r = 2080 + (e >> 11), r = this.index[r], r += e >> 5 & 63, r = ((r = this.index[r]) << 2) + (31 & e), this.data[r];
      if (e <= 1114111) return this.data[this.highValueIndex];
    }
    return this.errorValue;
  }, t;
}(), Voe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Woe = typeof Uint8Array > "u" ? [] : new Uint8Array(256), xf = 0; xf < 64; xf++) Woe[Voe.charCodeAt(xf)] = xf;
var Ca = 10, u7 = 13, M0 = 15, If = 17, h0 = 18, Xoe = 19, dB = 20, d7 = 21, p0 = 22, bl = 24, hi = 25, H0 = 26, D0 = 27, Bl = 28, Dl = 30, Sf = 32, Pf = 33, f7 = 34, h7 = 35, t2 = 37, p7 = 38, xh = 39, Ih = 40, fB = 42, Koe = [9001, 65288], gr = "×", kf = "÷", g7 = function(t, e) {
  var r, n, A, i = function(l) {
    var u, f, d, g, m, p = 0.75 * l.length, v = l.length, C = 0;
    l[l.length - 1] === "=" && (p--, l[l.length - 2] === "=" && p--);
    var w = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(p) : new Array(p), B = Array.isArray(w) ? w : new Uint8Array(w);
    for (u = 0; u < v; u += 4) f = T0[l.charCodeAt(u)], d = T0[l.charCodeAt(u + 1)], g = T0[l.charCodeAt(u + 2)], m = T0[l.charCodeAt(u + 3)], B[C++] = f << 2 | d >> 4, B[C++] = (15 & d) << 4 | g >> 2, B[C++] = (3 & g) << 6 | 63 & m;
    return w;
  }(t), o = Array.isArray(i) ? function(l) {
    for (var u = l.length, f = [], d = 0; d < u; d += 4) f.push(l[d + 3] << 24 | l[d + 2] << 16 | l[d + 1] << 8 | l[d]);
    return f;
  }(i) : new Uint32Array(i), s = Array.isArray(i) ? function(l) {
    for (var u = l.length, f = [], d = 0; d < u; d += 2) f.push(l[d + 1] << 8 | l[d]);
    return f;
  }(i) : new Uint16Array(i), a = uB(s, 12, o[4] / 2), c = o[5] === 2 ? uB(s, (24 + o[4]) / 2) : (r = o, n = Math.ceil((24 + o[4]) / 4), r.slice ? r.slice(n, A) : new Uint32Array(Array.prototype.slice.call(r, n, A)));
  return new Yoe(o[0], o[1], o[2], o[3], a, c);
}("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"), ss = [Dl, 36], m7 = [1, 2, 3, 5], YM = [Ca, 8], hB = [D0, H0], Zoe = m7.concat(YM), pB = [p7, xh, Ih, f7, h7], Joe = [M0, u7], t6 = function(t, e, r, n) {
  var A = n[r];
  if (Array.isArray(t) ? t.indexOf(A) !== -1 : t === A) for (var i = r; i <= n.length; ) {
    if ((a = n[++i]) === e) return !0;
    if (a !== Ca) break;
  }
  if (A === Ca) for (i = r; i > 0; ) {
    var o = n[--i];
    if (Array.isArray(t) ? t.indexOf(o) !== -1 : t === o) for (var s = r; s <= n.length; ) {
      var a;
      if ((a = n[++s]) === e) return !0;
      if (a !== Ca) break;
    }
    if (o !== Ca) break;
  }
  return !1;
}, gB = function(t, e) {
  for (var r = t; r >= 0; ) {
    var n = e[r];
    if (n !== Ca) return n;
    r--;
  }
  return 0;
}, _oe = function(t, e, r, n, A) {
  if (r[n] === 0) return gr;
  var i = n - 1;
  if (Array.isArray(A) && A[i] === !0) return gr;
  var o = i - 1, s = i + 1, a = e[i], c = o >= 0 ? e[o] : 0, l = e[s];
  if (a === 2 && l === 3) return gr;
  if (m7.indexOf(a) !== -1) return "!";
  if (m7.indexOf(l) !== -1 || YM.indexOf(l) !== -1) return gr;
  if (gB(i, e) === 8) return kf;
  if (g7.get(t[i]) === 11 || (a === Sf || a === Pf) && g7.get(t[s]) === 11 || a === 7 || l === 7 || a === 9 || [Ca, u7, M0].indexOf(a) === -1 && l === 9 || [If, h0, Xoe, bl, Bl].indexOf(l) !== -1 || gB(i, e) === p0 || t6(23, p0, i, e) || t6([If, h0], d7, i, e) || t6(12, 12, i, e)) return gr;
  if (a === Ca) return kf;
  if (a === 23 || l === 23) return gr;
  if (l === 16 || a === 16) return kf;
  if ([u7, M0, d7].indexOf(l) !== -1 || a === 14 || c === 36 && Joe.indexOf(a) !== -1 || a === Bl && l === 36 || l === dB || ss.indexOf(l) !== -1 && a === hi || ss.indexOf(a) !== -1 && l === hi || a === D0 && [t2, Sf, Pf].indexOf(l) !== -1 || [t2, Sf, Pf].indexOf(a) !== -1 && l === H0 || ss.indexOf(a) !== -1 && hB.indexOf(l) !== -1 || hB.indexOf(a) !== -1 && ss.indexOf(l) !== -1 || [D0, H0].indexOf(a) !== -1 && (l === hi || [p0, M0].indexOf(l) !== -1 && e[s + 1] === hi) || [p0, M0].indexOf(a) !== -1 && l === hi || a === hi && [hi, Bl, bl].indexOf(l) !== -1) return gr;
  if ([hi, Bl, bl, If, h0].indexOf(l) !== -1) for (var u = i; u >= 0; ) {
    if ((f = e[u]) === hi) return gr;
    if ([Bl, bl].indexOf(f) === -1) break;
    u--;
  }
  if ([D0, H0].indexOf(l) !== -1) for (u = [If, h0].indexOf(a) !== -1 ? o : i; u >= 0; ) {
    var f;
    if ((f = e[u]) === hi) return gr;
    if ([Bl, bl].indexOf(f) === -1) break;
    u--;
  }
  if (p7 === a && [p7, xh, f7, h7].indexOf(l) !== -1 || [xh, f7].indexOf(a) !== -1 && [xh, Ih].indexOf(l) !== -1 || [Ih, h7].indexOf(a) !== -1 && l === Ih || pB.indexOf(a) !== -1 && [dB, H0].indexOf(l) !== -1 || pB.indexOf(l) !== -1 && a === D0 || ss.indexOf(a) !== -1 && ss.indexOf(l) !== -1 || a === bl && ss.indexOf(l) !== -1 || ss.concat(hi).indexOf(a) !== -1 && l === p0 && Koe.indexOf(t[s]) === -1 || ss.concat(hi).indexOf(l) !== -1 && a === h0) return gr;
  if (a === 41 && l === 41) {
    for (var d = r[i], g = 1; d > 0 && e[--d] === 41; ) g++;
    if (g % 2 != 0) return gr;
  }
  return a === Sf && l === Pf ? gr : kf;
}, $oe = function(t, e) {
  var r = function(s, a) {
    a === void 0 && (a = "strict");
    var c = [], l = [], u = [];
    return s.forEach(function(f, d) {
      var g = g7.get(f);
      if (g > 50 ? (u.push(!0), g -= 50) : u.push(!1), ["normal", "auto", "loose"].indexOf(a) !== -1 && [8208, 8211, 12316, 12448].indexOf(f) !== -1) return l.push(d), c.push(16);
      if (g === 4 || g === 11) {
        if (d === 0) return l.push(d), c.push(Dl);
        var m = c[d - 1];
        return Zoe.indexOf(m) === -1 ? (l.push(l[d - 1]), c.push(m)) : (l.push(d), c.push(Dl));
      }
      return l.push(d), g === 31 ? c.push(a === "strict" ? d7 : t2) : g === fB || g === 29 ? c.push(Dl) : g === 43 ? f >= 131072 && f <= 196605 || f >= 196608 && f <= 262141 ? c.push(t2) : c.push(Dl) : void c.push(g);
    }), [l, c, u];
  }(t, e.lineBreak), n = r[0], A = r[1], i = r[2];
  e.wordBreak !== "break-all" && e.wordBreak !== "break-word" || (A = A.map(function(s) {
    return [hi, Dl, fB].indexOf(s) !== -1 ? t2 : s;
  }));
  var o = e.wordBreak === "keep-all" ? i.map(function(s, a) {
    return s && t[a] >= 19968 && t[a] <= 40959;
  }) : void 0;
  return [n, A, o];
}, ese = function() {
  function t(e, r, n, A) {
    this.codePoints = e, this.required = r === "!", this.start = n, this.end = A;
  }
  return t.prototype.slice = function() {
    return wn.apply(void 0, this.codePoints.slice(this.start, this.end));
  }, t;
}(), ri = 45, wc = 43, Fo = -1, RA = function(t) {
  return t >= 48 && t <= 57;
}, El = function(t) {
  return RA(t) || t >= 65 && t <= 70 || t >= 97 && t <= 102;
}, Of = function(t) {
  return t === 10 || t === 9 || t === 32;
}, P3 = function(t) {
  return function(e) {
    return function(r) {
      return r >= 97 && r <= 122;
    }(e) || function(r) {
      return r >= 65 && r <= 90;
    }(e);
  }(t) || function(e) {
    return e >= 128;
  }(t) || t === 95;
}, mB = function(t) {
  return P3(t) || RA(t) || t === ri;
}, tse = function(t) {
  return t >= 0 && t <= 8 || t === 11 || t >= 14 && t <= 31 || t === 127;
}, ha = function(t, e) {
  return t === 92 && e !== 10;
}, Ff = function(t, e, r) {
  return t === ri ? P3(e) || ha(e, r) : !!P3(t) || !(t !== 92 || !ha(t, e));
}, r6 = function(t, e, r) {
  return t === wc || t === ri ? !!RA(e) || e === 46 && RA(r) : RA(t === 46 ? e : t);
}, rse = function(t) {
  var e = 0, r = 1;
  t[e] !== wc && t[e] !== ri || (t[e] === ri && (r = -1), e++);
  for (var n = []; RA(t[e]); ) n.push(t[e++]);
  var A = n.length ? parseInt(wn.apply(void 0, n), 10) : 0;
  t[e] === 46 && e++;
  for (var i = []; RA(t[e]); ) i.push(t[e++]);
  var o = i.length, s = o ? parseInt(wn.apply(void 0, i), 10) : 0;
  t[e] !== 69 && t[e] !== 101 || e++;
  var a = 1;
  t[e] !== wc && t[e] !== ri || (t[e] === ri && (a = -1), e++);
  for (var c = []; RA(t[e]); ) c.push(t[e++]);
  var l = c.length ? parseInt(wn.apply(void 0, c), 10) : 0;
  return r * (A + s * Math.pow(10, -o)) * Math.pow(10, a * l);
}, nse = { type: 2 }, Ase = { type: 3 }, ise = { type: 4 }, ose = { type: 13 }, sse = { type: 8 }, ase = { type: 21 }, cse = { type: 9 }, lse = { type: 10 }, use = { type: 11 }, dse = { type: 12 }, fse = { type: 14 }, Tf = { type: 23 }, hse = { type: 1 }, pse = { type: 25 }, gse = { type: 24 }, mse = { type: 26 }, vse = { type: 27 }, qse = { type: 28 }, yse = { type: 29 }, Cse = { type: 31 }, v7 = { type: 32 }, VM = function() {
  function t() {
    this._value = [];
  }
  return t.prototype.write = function(e) {
    this._value = this._value.concat(S3(e));
  }, t.prototype.read = function() {
    for (var e = [], r = this.consumeToken(); r !== v7; ) e.push(r), r = this.consumeToken();
    return e;
  }, t.prototype.consumeToken = function() {
    var e = this.consumeCodePoint();
    switch (e) {
      case 34:
        return this.consumeStringToken(34);
      case 35:
        var r = this.peekCodePoint(0), n = this.peekCodePoint(1), A = this.peekCodePoint(2);
        if (mB(r) || ha(n, A)) {
          var i = Ff(r, n, A) ? 2 : 1;
          return { type: 5, value: this.consumeName(), flags: i };
        }
        break;
      case 36:
        if (this.peekCodePoint(0) === 61) return this.consumeCodePoint(), ose;
        break;
      case 39:
        return this.consumeStringToken(39);
      case 40:
        return nse;
      case 41:
        return Ase;
      case 42:
        if (this.peekCodePoint(0) === 61) return this.consumeCodePoint(), fse;
        break;
      case wc:
        if (r6(e, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(e), this.consumeNumericToken();
        break;
      case 44:
        return ise;
      case ri:
        var o = e, s = this.peekCodePoint(0), a = this.peekCodePoint(1);
        if (r6(o, s, a)) return this.reconsumeCodePoint(e), this.consumeNumericToken();
        if (Ff(o, s, a)) return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
        if (s === ri && a === 62) return this.consumeCodePoint(), this.consumeCodePoint(), gse;
        break;
      case 46:
        if (r6(e, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(e), this.consumeNumericToken();
        break;
      case 47:
        if (this.peekCodePoint(0) === 42) for (this.consumeCodePoint(); ; ) {
          var c = this.consumeCodePoint();
          if (c === 42 && (c = this.consumeCodePoint()) === 47) return this.consumeToken();
          if (c === Fo) return this.consumeToken();
        }
        break;
      case 58:
        return mse;
      case 59:
        return vse;
      case 60:
        if (this.peekCodePoint(0) === 33 && this.peekCodePoint(1) === ri && this.peekCodePoint(2) === ri) return this.consumeCodePoint(), this.consumeCodePoint(), pse;
        break;
      case 64:
        var l = this.peekCodePoint(0), u = this.peekCodePoint(1), f = this.peekCodePoint(2);
        if (Ff(l, u, f)) return { type: 7, value: this.consumeName() };
        break;
      case 91:
        return qse;
      case 92:
        if (ha(e, this.peekCodePoint(0))) return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
        break;
      case 93:
        return yse;
      case 61:
        if (this.peekCodePoint(0) === 61) return this.consumeCodePoint(), sse;
        break;
      case 123:
        return use;
      case 125:
        return dse;
      case 117:
      case 85:
        var d = this.peekCodePoint(0), g = this.peekCodePoint(1);
        return d !== wc || !El(g) && g !== 63 || (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
      case 124:
        if (this.peekCodePoint(0) === 61) return this.consumeCodePoint(), cse;
        if (this.peekCodePoint(0) === 124) return this.consumeCodePoint(), ase;
        break;
      case 126:
        if (this.peekCodePoint(0) === 61) return this.consumeCodePoint(), lse;
        break;
      case Fo:
        return v7;
    }
    return Of(e) ? (this.consumeWhiteSpace(), Cse) : RA(e) ? (this.reconsumeCodePoint(e), this.consumeNumericToken()) : P3(e) ? (this.reconsumeCodePoint(e), this.consumeIdentLikeToken()) : { type: 6, value: wn(e) };
  }, t.prototype.consumeCodePoint = function() {
    var e = this._value.shift();
    return e === void 0 ? -1 : e;
  }, t.prototype.reconsumeCodePoint = function(e) {
    this._value.unshift(e);
  }, t.prototype.peekCodePoint = function(e) {
    return e >= this._value.length ? -1 : this._value[e];
  }, t.prototype.consumeUnicodeRangeToken = function() {
    for (var e = [], r = this.consumeCodePoint(); El(r) && e.length < 6; ) e.push(r), r = this.consumeCodePoint();
    for (var n = !1; r === 63 && e.length < 6; ) e.push(r), r = this.consumeCodePoint(), n = !0;
    if (n) return { type: 30, start: parseInt(wn.apply(void 0, e.map(function(o) {
      return o === 63 ? 48 : o;
    })), 16), end: parseInt(wn.apply(void 0, e.map(function(o) {
      return o === 63 ? 70 : o;
    })), 16) };
    var A = parseInt(wn.apply(void 0, e), 16);
    if (this.peekCodePoint(0) === ri && El(this.peekCodePoint(1))) {
      this.consumeCodePoint(), r = this.consumeCodePoint();
      for (var i = []; El(r) && i.length < 6; ) i.push(r), r = this.consumeCodePoint();
      return { type: 30, start: A, end: parseInt(wn.apply(void 0, i), 16) };
    }
    return { type: 30, start: A, end: A };
  }, t.prototype.consumeIdentLikeToken = function() {
    var e = this.consumeName();
    return e.toLowerCase() === "url" && this.peekCodePoint(0) === 40 ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === 40 ? (this.consumeCodePoint(), { type: 19, value: e }) : { type: 20, value: e };
  }, t.prototype.consumeUrlToken = function() {
    var e = [];
    if (this.consumeWhiteSpace(), this.peekCodePoint(0) === Fo) return { type: 22, value: "" };
    var r = this.peekCodePoint(0);
    if (r === 39 || r === 34) {
      var n = this.consumeStringToken(this.consumeCodePoint());
      return n.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === Fo || this.peekCodePoint(0) === 41) ? (this.consumeCodePoint(), { type: 22, value: n.value }) : (this.consumeBadUrlRemnants(), Tf);
    }
    for (; ; ) {
      var A = this.consumeCodePoint();
      if (A === Fo || A === 41) return { type: 22, value: wn.apply(void 0, e) };
      if (Of(A)) return this.consumeWhiteSpace(), this.peekCodePoint(0) === Fo || this.peekCodePoint(0) === 41 ? (this.consumeCodePoint(), { type: 22, value: wn.apply(void 0, e) }) : (this.consumeBadUrlRemnants(), Tf);
      if (A === 34 || A === 39 || A === 40 || tse(A)) return this.consumeBadUrlRemnants(), Tf;
      if (A === 92) {
        if (!ha(A, this.peekCodePoint(0))) return this.consumeBadUrlRemnants(), Tf;
        e.push(this.consumeEscapedCodePoint());
      } else e.push(A);
    }
  }, t.prototype.consumeWhiteSpace = function() {
    for (; Of(this.peekCodePoint(0)); ) this.consumeCodePoint();
  }, t.prototype.consumeBadUrlRemnants = function() {
    for (; ; ) {
      var e = this.consumeCodePoint();
      if (e === 41 || e === Fo) return;
      ha(e, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
    }
  }, t.prototype.consumeStringSlice = function(e) {
    for (var r = ""; e > 0; ) {
      var n = Math.min(5e4, e);
      r += wn.apply(void 0, this._value.splice(0, n)), e -= n;
    }
    return this._value.shift(), r;
  }, t.prototype.consumeStringToken = function(e) {
    for (var r = "", n = 0; ; ) {
      var A = this._value[n];
      if (A === Fo || A === void 0 || A === e) return { type: 0, value: r += this.consumeStringSlice(n) };
      if (A === 10) return this._value.splice(0, n), hse;
      if (A === 92) {
        var i = this._value[n + 1];
        i !== Fo && i !== void 0 && (i === 10 ? (r += this.consumeStringSlice(n), n = -1, this._value.shift()) : ha(A, i) && (r += this.consumeStringSlice(n), r += wn(this.consumeEscapedCodePoint()), n = -1));
      }
      n++;
    }
  }, t.prototype.consumeNumber = function() {
    var e = [], r = 4, n = this.peekCodePoint(0);
    for (n !== wc && n !== ri || e.push(this.consumeCodePoint()); RA(this.peekCodePoint(0)); ) e.push(this.consumeCodePoint());
    n = this.peekCodePoint(0);
    var A = this.peekCodePoint(1);
    if (n === 46 && RA(A)) for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), r = 8; RA(this.peekCodePoint(0)); ) e.push(this.consumeCodePoint());
    n = this.peekCodePoint(0), A = this.peekCodePoint(1);
    var i = this.peekCodePoint(2);
    if ((n === 69 || n === 101) && ((A === wc || A === ri) && RA(i) || RA(A))) for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), r = 8; RA(this.peekCodePoint(0)); ) e.push(this.consumeCodePoint());
    return [rse(e), r];
  }, t.prototype.consumeNumericToken = function() {
    var e = this.consumeNumber(), r = e[0], n = e[1], A = this.peekCodePoint(0), i = this.peekCodePoint(1), o = this.peekCodePoint(2);
    return Ff(A, i, o) ? { type: 15, number: r, flags: n, unit: this.consumeName() } : A === 37 ? (this.consumeCodePoint(), { type: 16, number: r, flags: n }) : { type: 17, number: r, flags: n };
  }, t.prototype.consumeEscapedCodePoint = function() {
    var e = this.consumeCodePoint();
    if (El(e)) {
      for (var r = wn(e); El(this.peekCodePoint(0)) && r.length < 6; ) r += wn(this.consumeCodePoint());
      Of(this.peekCodePoint(0)) && this.consumeCodePoint();
      var n = parseInt(r, 16);
      return n === 0 || function(A) {
        return A >= 55296 && A <= 57343;
      }(n) || n > 1114111 ? 65533 : n;
    }
    return e === Fo ? 65533 : e;
  }, t.prototype.consumeName = function() {
    for (var e = ""; ; ) {
      var r = this.consumeCodePoint();
      if (mB(r)) e += wn(r);
      else {
        if (!ha(r, this.peekCodePoint(0))) return this.reconsumeCodePoint(r), e;
        e += wn(this.consumeEscapedCodePoint());
      }
    }
  }, t;
}(), WM = function() {
  function t(e) {
    this._tokens = e;
  }
  return t.create = function(e) {
    var r = new VM();
    return r.write(e), new t(r.read());
  }, t.parseValue = function(e) {
    return t.create(e).parseComponentValue();
  }, t.parseValues = function(e) {
    return t.create(e).parseComponentValues();
  }, t.prototype.parseComponentValue = function() {
    for (var e = this.consumeToken(); e.type === 31; ) e = this.consumeToken();
    if (e.type === 32) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
    this.reconsumeToken(e);
    var r = this.consumeComponentValue();
    do
      e = this.consumeToken();
    while (e.type === 31);
    if (e.type === 32) return r;
    throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
  }, t.prototype.parseComponentValues = function() {
    for (var e = []; ; ) {
      var r = this.consumeComponentValue();
      if (r.type === 32) return e;
      e.push(r), e.push();
    }
  }, t.prototype.consumeComponentValue = function() {
    var e = this.consumeToken();
    switch (e.type) {
      case 11:
      case 28:
      case 2:
        return this.consumeSimpleBlock(e.type);
      case 19:
        return this.consumeFunction(e);
    }
    return e;
  }, t.prototype.consumeSimpleBlock = function(e) {
    for (var r = { type: e, values: [] }, n = this.consumeToken(); ; ) {
      if (n.type === 32 || bse(n, e)) return r;
      this.reconsumeToken(n), r.values.push(this.consumeComponentValue()), n = this.consumeToken();
    }
  }, t.prototype.consumeFunction = function(e) {
    for (var r = { name: e.value, values: [], type: 18 }; ; ) {
      var n = this.consumeToken();
      if (n.type === 32 || n.type === 3) return r;
      this.reconsumeToken(n), r.values.push(this.consumeComponentValue());
    }
  }, t.prototype.consumeToken = function() {
    var e = this._tokens.shift();
    return e === void 0 ? v7 : e;
  }, t.prototype.reconsumeToken = function(e) {
    this._tokens.unshift(e);
  }, t;
}(), S2 = function(t) {
  return t.type === 15;
}, Ql = function(t) {
  return t.type === 17;
}, Rr = function(t) {
  return t.type === 20;
}, wse = function(t) {
  return t.type === 0;
}, q7 = function(t, e) {
  return Rr(t) && t.value === e;
}, vB = function(t) {
  return t.type !== 31;
}, ju = function(t) {
  return t.type !== 31 && t.type !== 4;
}, Vo = function(t) {
  var e = [], r = [];
  return t.forEach(function(n) {
    if (n.type === 4) {
      if (r.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
      return e.push(r), void (r = []);
    }
    n.type !== 31 && r.push(n);
  }), r.length && e.push(r), e;
}, bse = function(t, e) {
  return e === 11 && t.type === 12 || e === 28 && t.type === 29 || e === 2 && t.type === 3;
}, Va = function(t) {
  return t.type === 17 || t.type === 15;
}, Gn = function(t) {
  return t.type === 16 || Va(t);
}, XM = function(t) {
  return t.length > 1 ? [t[0], t[1]] : [t[0]];
}, qA = { type: 17, number: 0, flags: 4 }, Yv = { type: 16, number: 50, flags: 4 }, wa = { type: 16, number: 100, flags: 4 }, Q0 = function(t, e, r) {
  var n = t[0], A = t[1];
  return [Jr(n, e), Jr(A !== void 0 ? A : n, r)];
}, Jr = function(t, e) {
  if (t.type === 16) return t.number / 100 * e;
  if (S2(t)) switch (t.unit) {
    case "rem":
    case "em":
      return 16 * t.number;
    default:
      return t.number;
  }
  return t.number;
}, KM = "grad", ZM = "turn", p4 = function(t, e) {
  if (e.type === 15) switch (e.unit) {
    case "deg":
      return Math.PI * e.number / 180;
    case KM:
      return Math.PI / 200 * e.number;
    case "rad":
      return e.number;
    case ZM:
      return 2 * Math.PI * e.number;
  }
  throw new Error("Unsupported angle type");
}, JM = function(t) {
  return t.type === 15 && (t.unit === "deg" || t.unit === KM || t.unit === "rad" || t.unit === ZM);
}, _M = function(t) {
  switch (t.filter(Rr).map(function(e) {
    return e.value;
  }).join(" ")) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [qA, qA];
    case "to top":
    case "bottom":
      return Ui(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [qA, wa];
    case "to right":
    case "left":
      return Ui(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [wa, wa];
    case "to bottom":
    case "top":
      return Ui(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [wa, qA];
    case "to left":
    case "right":
      return Ui(270);
  }
  return 0;
}, Ui = function(t) {
  return Math.PI * t / 180;
}, ka = function(t, e) {
  if (e.type === 18) {
    var r = Bse[e.name];
    if (r === void 0) throw new Error('Attempting to parse an unsupported color function "' + e.name + '"');
    return r(t, e.values);
  }
  if (e.type === 5) {
    if (e.value.length === 3) {
      var n = e.value.substring(0, 1), A = e.value.substring(1, 2), i = e.value.substring(2, 3);
      return ba(parseInt(n + n, 16), parseInt(A + A, 16), parseInt(i + i, 16), 1);
    }
    if (e.value.length === 4) {
      n = e.value.substring(0, 1), A = e.value.substring(1, 2), i = e.value.substring(2, 3);
      var o = e.value.substring(3, 4);
      return ba(parseInt(n + n, 16), parseInt(A + A, 16), parseInt(i + i, 16), parseInt(o + o, 16) / 255);
    }
    if (e.value.length === 6)
      return n = e.value.substring(0, 2), A = e.value.substring(2, 4), i = e.value.substring(4, 6), ba(parseInt(n, 16), parseInt(A, 16), parseInt(i, 16), 1);
    if (e.value.length === 8)
      return n = e.value.substring(0, 2), A = e.value.substring(2, 4), i = e.value.substring(4, 6), o = e.value.substring(6, 8), ba(parseInt(n, 16), parseInt(A, 16), parseInt(i, 16), parseInt(o, 16) / 255);
  }
  if (e.type === 20) {
    var s = bs[e.value.toUpperCase()];
    if (s !== void 0) return s;
  }
  return bs.TRANSPARENT;
}, Oa = function(t) {
  return (255 & t) == 0;
}, AA = function(t) {
  var e = 255 & t, r = 255 & t >> 8, n = 255 & t >> 16, A = 255 & t >> 24;
  return e < 255 ? "rgba(" + A + "," + n + "," + r + "," + e / 255 + ")" : "rgb(" + A + "," + n + "," + r + ")";
}, ba = function(t, e, r, n) {
  return (t << 24 | e << 16 | r << 8 | Math.round(255 * n) << 0) >>> 0;
}, qB = function(t, e) {
  if (t.type === 17) return t.number;
  if (t.type === 16) {
    var r = e === 3 ? 1 : 255;
    return e === 3 ? t.number / 100 * r : Math.round(t.number / 100 * r);
  }
  return 0;
}, yB = function(t, e) {
  var r = e.filter(ju);
  if (r.length === 3) {
    var n = r.map(qB), A = n[0], i = n[1], o = n[2];
    return ba(A, i, o, 1);
  }
  if (r.length === 4) {
    var s = r.map(qB), a = (A = s[0], i = s[1], o = s[2], s[3]);
    return ba(A, i, o, a);
  }
  return 0;
};
function n6(t, e, r) {
  return r < 0 && (r += 1), r >= 1 && (r -= 1), r < 1 / 6 ? (e - t) * r * 6 + t : r < 0.5 ? e : r < 2 / 3 ? 6 * (e - t) * (2 / 3 - r) + t : t;
}
var CB = function(t, e) {
  var r = e.filter(ju), n = r[0], A = r[1], i = r[2], o = r[3], s = (n.type === 17 ? Ui(n.number) : p4(t, n)) / (2 * Math.PI), a = Gn(A) ? A.number / 100 : 0, c = Gn(i) ? i.number / 100 : 0, l = o !== void 0 && Gn(o) ? Jr(o, 1) : 1;
  if (a === 0) return ba(255 * c, 255 * c, 255 * c, 1);
  var u = c <= 0.5 ? c * (a + 1) : c + a - c * a, f = 2 * c - u, d = n6(f, u, s + 1 / 3), g = n6(f, u, s), m = n6(f, u, s - 1 / 3);
  return ba(255 * d, 255 * g, 255 * m, l);
}, Bse = { hsl: CB, hsla: CB, rgb: yB, rgba: yB }, r2 = function(t, e) {
  return ka(t, WM.create(e).parseComponentValue());
}, bs = { ALICEBLUE: 4042850303, ANTIQUEWHITE: 4209760255, AQUA: 16777215, AQUAMARINE: 2147472639, AZURE: 4043309055, BEIGE: 4126530815, BISQUE: 4293182719, BLACK: 255, BLANCHEDALMOND: 4293643775, BLUE: 65535, BLUEVIOLET: 2318131967, BROWN: 2771004159, BURLYWOOD: 3736635391, CADETBLUE: 1604231423, CHARTREUSE: 2147418367, CHOCOLATE: 3530104575, CORAL: 4286533887, CORNFLOWERBLUE: 1687547391, CORNSILK: 4294499583, CRIMSON: 3692313855, CYAN: 16777215, DARKBLUE: 35839, DARKCYAN: 9145343, DARKGOLDENROD: 3095837695, DARKGRAY: 2846468607, DARKGREEN: 6553855, DARKGREY: 2846468607, DARKKHAKI: 3182914559, DARKMAGENTA: 2332068863, DARKOLIVEGREEN: 1433087999, DARKORANGE: 4287365375, DARKORCHID: 2570243327, DARKRED: 2332033279, DARKSALMON: 3918953215, DARKSEAGREEN: 2411499519, DARKSLATEBLUE: 1211993087, DARKSLATEGRAY: 793726975, DARKSLATEGREY: 793726975, DARKTURQUOISE: 13554175, DARKVIOLET: 2483082239, DEEPPINK: 4279538687, DEEPSKYBLUE: 12582911, DIMGRAY: 1768516095, DIMGREY: 1768516095, DODGERBLUE: 512819199, FIREBRICK: 2988581631, FLORALWHITE: 4294635775, FORESTGREEN: 579543807, FUCHSIA: 4278255615, GAINSBORO: 3705462015, GHOSTWHITE: 4177068031, GOLD: 4292280575, GOLDENROD: 3668254975, GRAY: 2155905279, GREEN: 8388863, GREENYELLOW: 2919182335, GREY: 2155905279, HONEYDEW: 4043305215, HOTPINK: 4285117695, INDIANRED: 3445382399, INDIGO: 1258324735, IVORY: 4294963455, KHAKI: 4041641215, LAVENDER: 3873897215, LAVENDERBLUSH: 4293981695, LAWNGREEN: 2096890111, LEMONCHIFFON: 4294626815, LIGHTBLUE: 2916673279, LIGHTCORAL: 4034953471, LIGHTCYAN: 3774873599, LIGHTGOLDENRODYELLOW: 4210742015, LIGHTGRAY: 3553874943, LIGHTGREEN: 2431553791, LIGHTGREY: 3553874943, LIGHTPINK: 4290167295, LIGHTSALMON: 4288707327, LIGHTSEAGREEN: 548580095, LIGHTSKYBLUE: 2278488831, LIGHTSLATEGRAY: 2005441023, LIGHTSLATEGREY: 2005441023, LIGHTSTEELBLUE: 2965692159, LIGHTYELLOW: 4294959359, LIME: 16711935, LIMEGREEN: 852308735, LINEN: 4210091775, MAGENTA: 4278255615, MAROON: 2147483903, MEDIUMAQUAMARINE: 1724754687, MEDIUMBLUE: 52735, MEDIUMORCHID: 3126187007, MEDIUMPURPLE: 2473647103, MEDIUMSEAGREEN: 1018393087, MEDIUMSLATEBLUE: 2070474495, MEDIUMSPRINGGREEN: 16423679, MEDIUMTURQUOISE: 1221709055, MEDIUMVIOLETRED: 3340076543, MIDNIGHTBLUE: 421097727, MINTCREAM: 4127193855, MISTYROSE: 4293190143, MOCCASIN: 4293178879, NAVAJOWHITE: 4292783615, NAVY: 33023, OLDLACE: 4260751103, OLIVE: 2155872511, OLIVEDRAB: 1804477439, ORANGE: 4289003775, ORANGERED: 4282712319, ORCHID: 3664828159, PALEGOLDENROD: 4008225535, PALEGREEN: 2566625535, PALETURQUOISE: 2951671551, PALEVIOLETRED: 3681588223, PAPAYAWHIP: 4293907967, PEACHPUFF: 4292524543, PERU: 3448061951, PINK: 4290825215, PLUM: 3718307327, POWDERBLUE: 2967529215, PURPLE: 2147516671, REBECCAPURPLE: 1714657791, RED: 4278190335, ROSYBROWN: 3163525119, ROYALBLUE: 1097458175, SADDLEBROWN: 2336560127, SALMON: 4202722047, SANDYBROWN: 4104413439, SEAGREEN: 780883967, SEASHELL: 4294307583, SIENNA: 2689740287, SILVER: 3233857791, SKYBLUE: 2278484991, SLATEBLUE: 1784335871, SLATEGRAY: 1887473919, SLATEGREY: 1887473919, SNOW: 4294638335, SPRINGGREEN: 16744447, STEELBLUE: 1182971135, TAN: 3535047935, TEAL: 8421631, THISTLE: 3636451583, TOMATO: 4284696575, TRANSPARENT: 0, TURQUOISE: 1088475391, VIOLET: 4001558271, WHEAT: 4125012991, WHITE: 4294967295, WHITESMOKE: 4126537215, YELLOW: 4294902015, YELLOWGREEN: 2597139199 }, Ese = { name: "background-clip", initialValue: "border-box", prefix: !1, type: 1, parse: function(t, e) {
  return e.map(function(r) {
    if (Rr(r)) switch (r.value) {
      case "padding-box":
        return 1;
      case "content-box":
        return 2;
    }
    return 0;
  });
} }, xse = { name: "background-color", initialValue: "transparent", prefix: !1, type: 3, format: "color" }, k3 = function(t, e) {
  var r = ka(t, e[0]), n = e[1];
  return n && Gn(n) ? { color: r, stop: n } : { color: r, stop: null };
}, wB = function(t, e) {
  var r = t[0], n = t[t.length - 1];
  r.stop === null && (r.stop = qA), n.stop === null && (n.stop = wa);
  for (var A = [], i = 0, o = 0; o < t.length; o++) {
    var s = t[o].stop;
    if (s !== null) {
      var a = Jr(s, e);
      a > i ? A.push(a) : A.push(i), i = a;
    } else A.push(null);
  }
  var c = null;
  for (o = 0; o < A.length; o++) {
    var l = A[o];
    if (l === null) c === null && (c = o);
    else if (c !== null) {
      for (var u = o - c, f = (l - A[c - 1]) / (u + 1), d = 1; d <= u; d++) A[c + d - 1] = f * d;
      c = null;
    }
  }
  return t.map(function(g, m) {
    return { color: g.color, stop: Math.max(Math.min(1, A[m] / e), 0) };
  });
}, Ise = function(t, e, r) {
  var n = typeof t == "number" ? t : function(l, u, f) {
    var d = u / 2, g = f / 2, m = Jr(l[0], u) - d, p = g - Jr(l[1], f);
    return (Math.atan2(p, m) + 2 * Math.PI) % (2 * Math.PI);
  }(t, e, r), A = Math.abs(e * Math.sin(n)) + Math.abs(r * Math.cos(n)), i = e / 2, o = r / 2, s = A / 2, a = Math.sin(n - Math.PI / 2) * s, c = Math.cos(n - Math.PI / 2) * s;
  return [A, i - c, i + c, o - a, o + a];
}, to = function(t, e) {
  return Math.sqrt(t * t + e * e);
}, bB = function(t, e, r, n, A) {
  return [[0, 0], [0, e], [t, 0], [t, e]].reduce(function(i, o) {
    var s = o[0], a = o[1], c = to(r - s, n - a);
    return (A ? c < i.optimumDistance : c > i.optimumDistance) ? { optimumCorner: o, optimumDistance: c } : i;
  }, { optimumDistance: A ? 1 / 0 : -1 / 0, optimumCorner: null }).optimumCorner;
}, Mf = function(t, e) {
  var r = Ui(180), n = [];
  return Vo(e).forEach(function(A, i) {
    if (i === 0) {
      var o = A[0];
      if (o.type === 20 && ["top", "left", "right", "bottom"].indexOf(o.value) !== -1) return void (r = _M(A));
      if (JM(o)) return void (r = (p4(t, o) + Ui(270)) % Ui(360));
    }
    var s = k3(t, A);
    n.push(s);
  }), { angle: r, stops: n, type: 1 };
}, $M = "closest-side", eH = "farthest-side", tH = "closest-corner", rH = "farthest-corner", nH = "circle", AH = "ellipse", iH = "cover", oH = "contain", Hf = function(t, e) {
  var r = 0, n = 3, A = [], i = [];
  return Vo(e).forEach(function(o, s) {
    var a = !0;
    if (s === 0 ? a = o.reduce(function(l, u) {
      if (Rr(u)) switch (u.value) {
        case "center":
          return i.push(Yv), !1;
        case "top":
        case "left":
          return i.push(qA), !1;
        case "right":
        case "bottom":
          return i.push(wa), !1;
      }
      else if (Gn(u) || Va(u)) return i.push(u), !1;
      return l;
    }, a) : s === 1 && (a = o.reduce(function(l, u) {
      if (Rr(u)) switch (u.value) {
        case nH:
          return r = 0, !1;
        case AH:
          return r = 1, !1;
        case oH:
        case $M:
          return n = 0, !1;
        case eH:
          return n = 1, !1;
        case tH:
          return n = 2, !1;
        case iH:
        case rH:
          return n = 3, !1;
      }
      else if (Va(u) || Gn(u)) return Array.isArray(n) || (n = []), n.push(u), !1;
      return l;
    }, a)), a) {
      var c = k3(t, o);
      A.push(c);
    }
  }), { size: n, shape: r, stops: A, position: i, type: 2 };
}, Vv = function(t, e) {
  if (e.type === 22) {
    var r = { url: e.value, type: 0 };
    return t.cache.addImage(e.value), r;
  }
  if (e.type === 18) {
    var n = sH[e.name];
    if (n === void 0) throw new Error('Attempting to parse an unsupported image function "' + e.name + '"');
    return n(t, e.values);
  }
  throw new Error("Unsupported image type " + e.type);
}, su, sH = { "linear-gradient": function(t, e) {
  var r = Ui(180), n = [];
  return Vo(e).forEach(function(A, i) {
    if (i === 0) {
      var o = A[0];
      if (o.type === 20 && o.value === "to") return void (r = _M(A));
      if (JM(o)) return void (r = p4(t, o));
    }
    var s = k3(t, A);
    n.push(s);
  }), { angle: r, stops: n, type: 1 };
}, "-moz-linear-gradient": Mf, "-ms-linear-gradient": Mf, "-o-linear-gradient": Mf, "-webkit-linear-gradient": Mf, "radial-gradient": function(t, e) {
  var r = 0, n = 3, A = [], i = [];
  return Vo(e).forEach(function(o, s) {
    var a = !0;
    if (s === 0) {
      var c = !1;
      a = o.reduce(function(u, f) {
        if (c) if (Rr(f)) switch (f.value) {
          case "center":
            return i.push(Yv), u;
          case "top":
          case "left":
            return i.push(qA), u;
          case "right":
          case "bottom":
            return i.push(wa), u;
        }
        else (Gn(f) || Va(f)) && i.push(f);
        else if (Rr(f)) switch (f.value) {
          case nH:
            return r = 0, !1;
          case AH:
            return r = 1, !1;
          case "at":
            return c = !0, !1;
          case $M:
            return n = 0, !1;
          case iH:
          case eH:
            return n = 1, !1;
          case oH:
          case tH:
            return n = 2, !1;
          case rH:
            return n = 3, !1;
        }
        else if (Va(f) || Gn(f)) return Array.isArray(n) || (n = []), n.push(f), !1;
        return u;
      }, a);
    }
    if (a) {
      var l = k3(t, o);
      A.push(l);
    }
  }), { size: n, shape: r, stops: A, position: i, type: 2 };
}, "-moz-radial-gradient": Hf, "-ms-radial-gradient": Hf, "-o-radial-gradient": Hf, "-webkit-radial-gradient": Hf, "-webkit-gradient": function(t, e) {
  var r = Ui(180), n = [], A = 1;
  return Vo(e).forEach(function(i, o) {
    var s = i[0];
    if (o === 0) {
      if (Rr(s) && s.value === "linear") return void (A = 1);
      if (Rr(s) && s.value === "radial") return void (A = 2);
    }
    if (s.type === 18) {
      if (s.name === "from") {
        var a = ka(t, s.values[0]);
        n.push({ stop: qA, color: a });
      } else if (s.name === "to")
        a = ka(t, s.values[0]), n.push({ stop: wa, color: a });
      else if (s.name === "color-stop") {
        var c = s.values.filter(ju);
        if (c.length === 2) {
          a = ka(t, c[1]);
          var l = c[0];
          Ql(l) && n.push({ stop: { type: 16, number: 100 * l.number, flags: l.flags }, color: a });
        }
      }
    }
  }), A === 1 ? { angle: (r + Ui(180)) % Ui(360), stops: n, type: A } : { size: 3, shape: 0, stops: n, position: [], type: A };
} }, Sse = { name: "background-image", initialValue: "none", type: 1, prefix: !1, parse: function(t, e) {
  if (e.length === 0) return [];
  var r = e[0];
  return r.type === 20 && r.value === "none" ? [] : e.filter(function(n) {
    return ju(n) && function(A) {
      return !(A.type === 20 && A.value === "none" || A.type === 18 && !sH[A.name]);
    }(n);
  }).map(function(n) {
    return Vv(t, n);
  });
} }, Pse = { name: "background-origin", initialValue: "border-box", prefix: !1, type: 1, parse: function(t, e) {
  return e.map(function(r) {
    if (Rr(r)) switch (r.value) {
      case "padding-box":
        return 1;
      case "content-box":
        return 2;
    }
    return 0;
  });
} }, kse = { name: "background-position", initialValue: "0% 0%", type: 1, prefix: !1, parse: function(t, e) {
  return Vo(e).map(function(r) {
    return r.filter(Gn);
  }).map(XM);
} }, Ose = { name: "background-repeat", initialValue: "repeat", prefix: !1, type: 1, parse: function(t, e) {
  return Vo(e).map(function(r) {
    return r.filter(Rr).map(function(n) {
      return n.value;
    }).join(" ");
  }).map(Fse);
} }, Fse = function(t) {
  switch (t) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    default:
      return 0;
  }
};
(function(t) {
  t.AUTO = "auto", t.CONTAIN = "contain", t.COVER = "cover";
})(su || (su = {}));
var O3, Tse = { name: "background-size", initialValue: "0", prefix: !1, type: 1, parse: function(t, e) {
  return Vo(e).map(function(r) {
    return r.filter(Mse);
  });
} }, Mse = function(t) {
  return Rr(t) || Gn(t);
}, g4 = function(t) {
  return { name: "border-" + t + "-color", initialValue: "transparent", prefix: !1, type: 3, format: "color" };
}, Hse = g4("top"), Dse = g4("right"), Qse = g4("bottom"), Use = g4("left"), m4 = function(t) {
  return { name: "border-radius-" + t, initialValue: "0 0", prefix: !1, type: 1, parse: function(e, r) {
    return XM(r.filter(Gn));
  } };
}, Nse = m4("top-left"), jse = m4("top-right"), Lse = m4("bottom-right"), Gse = m4("bottom-left"), v4 = function(t) {
  return { name: "border-" + t + "-style", initialValue: "solid", prefix: !1, type: 2, parse: function(e, r) {
    switch (r) {
      case "none":
        return 0;
      case "dashed":
        return 2;
      case "dotted":
        return 3;
      case "double":
        return 4;
    }
    return 1;
  } };
}, Rse = v4("top"), zse = v4("right"), Yse = v4("bottom"), Vse = v4("left"), q4 = function(t) {
  return { name: "border-" + t + "-width", initialValue: "0", type: 0, prefix: !1, parse: function(e, r) {
    return S2(r) ? r.number : 0;
  } };
}, Wse = q4("top"), Xse = q4("right"), Kse = q4("bottom"), Zse = q4("left"), Jse = { name: "color", initialValue: "transparent", prefix: !1, type: 3, format: "color" }, _se = { name: "direction", initialValue: "ltr", prefix: !1, type: 2, parse: function(t, e) {
  return e === "rtl" ? 1 : 0;
} }, $se = { name: "display", initialValue: "inline-block", prefix: !1, type: 1, parse: function(t, e) {
  return e.filter(Rr).reduce(function(r, n) {
    return r | eae(n.value);
  }, 0);
} }, eae = function(t) {
  switch (t) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, tae = { name: "float", initialValue: "none", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "left":
      return 1;
    case "right":
      return 2;
    case "inline-start":
      return 3;
    case "inline-end":
      return 4;
  }
  return 0;
} }, rae = { name: "letter-spacing", initialValue: "0", prefix: !1, type: 0, parse: function(t, e) {
  return e.type === 20 && e.value === "normal" ? 0 : e.type === 17 || e.type === 15 ? e.number : 0;
} };
(function(t) {
  t.NORMAL = "normal", t.STRICT = "strict";
})(O3 || (O3 = {}));
var n2, nae = { name: "line-break", initialValue: "normal", prefix: !1, type: 2, parse: function(t, e) {
  return e === "strict" ? O3.STRICT : O3.NORMAL;
} }, Aae = { name: "line-height", initialValue: "normal", prefix: !1, type: 4 }, BB = function(t, e) {
  return Rr(t) && t.value === "normal" ? 1.2 * e : t.type === 17 ? e * t.number : Gn(t) ? Jr(t, e) : e;
}, iae = { name: "list-style-image", initialValue: "none", type: 0, prefix: !1, parse: function(t, e) {
  return e.type === 20 && e.value === "none" ? null : Vv(t, e);
} }, oae = { name: "list-style-position", initialValue: "outside", prefix: !1, type: 2, parse: function(t, e) {
  return e === "inside" ? 0 : 1;
} }, y7 = { name: "list-style-type", initialValue: "none", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "disc":
      return 0;
    case "circle":
      return 1;
    case "square":
      return 2;
    case "decimal":
      return 3;
    case "cjk-decimal":
      return 4;
    case "decimal-leading-zero":
      return 5;
    case "lower-roman":
      return 6;
    case "upper-roman":
      return 7;
    case "lower-greek":
      return 8;
    case "lower-alpha":
      return 9;
    case "upper-alpha":
      return 10;
    case "arabic-indic":
      return 11;
    case "armenian":
      return 12;
    case "bengali":
      return 13;
    case "cambodian":
      return 14;
    case "cjk-earthly-branch":
      return 15;
    case "cjk-heavenly-stem":
      return 16;
    case "cjk-ideographic":
      return 17;
    case "devanagari":
      return 18;
    case "ethiopic-numeric":
      return 19;
    case "georgian":
      return 20;
    case "gujarati":
      return 21;
    case "gurmukhi":
    case "hebrew":
      return 22;
    case "hiragana":
      return 23;
    case "hiragana-iroha":
      return 24;
    case "japanese-formal":
      return 25;
    case "japanese-informal":
      return 26;
    case "kannada":
      return 27;
    case "katakana":
      return 28;
    case "katakana-iroha":
      return 29;
    case "khmer":
      return 30;
    case "korean-hangul-formal":
      return 31;
    case "korean-hanja-formal":
      return 32;
    case "korean-hanja-informal":
      return 33;
    case "lao":
      return 34;
    case "lower-armenian":
      return 35;
    case "malayalam":
      return 36;
    case "mongolian":
      return 37;
    case "myanmar":
      return 38;
    case "oriya":
      return 39;
    case "persian":
      return 40;
    case "simp-chinese-formal":
      return 41;
    case "simp-chinese-informal":
      return 42;
    case "tamil":
      return 43;
    case "telugu":
      return 44;
    case "thai":
      return 45;
    case "tibetan":
      return 46;
    case "trad-chinese-formal":
      return 47;
    case "trad-chinese-informal":
      return 48;
    case "upper-armenian":
      return 49;
    case "disclosure-open":
      return 50;
    case "disclosure-closed":
      return 51;
    default:
      return -1;
  }
} }, y4 = function(t) {
  return { name: "margin-" + t, initialValue: "0", prefix: !1, type: 4 };
}, sae = y4("top"), aae = y4("right"), cae = y4("bottom"), lae = y4("left"), uae = { name: "overflow", initialValue: "visible", prefix: !1, type: 1, parse: function(t, e) {
  return e.filter(Rr).map(function(r) {
    switch (r.value) {
      case "hidden":
        return 1;
      case "scroll":
        return 2;
      case "clip":
        return 3;
      case "auto":
        return 4;
      default:
        return 0;
    }
  });
} }, dae = { name: "overflow-wrap", initialValue: "normal", prefix: !1, type: 2, parse: function(t, e) {
  return e === "break-word" ? "break-word" : "normal";
} }, C4 = function(t) {
  return { name: "padding-" + t, initialValue: "0", prefix: !1, type: 3, format: "length-percentage" };
}, fae = C4("top"), hae = C4("right"), pae = C4("bottom"), gae = C4("left"), mae = { name: "text-align", initialValue: "left", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "right":
      return 2;
    case "center":
    case "justify":
      return 1;
    default:
      return 0;
  }
} }, vae = { name: "position", initialValue: "static", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "relative":
      return 1;
    case "absolute":
      return 2;
    case "fixed":
      return 3;
    case "sticky":
      return 4;
  }
  return 0;
} }, qae = { name: "text-shadow", initialValue: "none", type: 1, prefix: !1, parse: function(t, e) {
  return e.length === 1 && q7(e[0], "none") ? [] : Vo(e).map(function(r) {
    for (var n = { color: bs.TRANSPARENT, offsetX: qA, offsetY: qA, blur: qA }, A = 0, i = 0; i < r.length; i++) {
      var o = r[i];
      Va(o) ? (A === 0 ? n.offsetX = o : A === 1 ? n.offsetY = o : n.blur = o, A++) : n.color = ka(t, o);
    }
    return n;
  });
} }, yae = { name: "text-transform", initialValue: "none", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "uppercase":
      return 2;
    case "lowercase":
      return 1;
    case "capitalize":
      return 3;
  }
  return 0;
} }, Cae = { name: "transform", initialValue: "none", prefix: !0, type: 0, parse: function(t, e) {
  if (e.type === 20 && e.value === "none") return null;
  if (e.type === 18) {
    var r = wae[e.name];
    if (r === void 0) throw new Error('Attempting to parse an unsupported transform function "' + e.name + '"');
    return r(e.values);
  }
  return null;
} }, wae = { matrix: function(t) {
  var e = t.filter(function(r) {
    return r.type === 17;
  }).map(function(r) {
    return r.number;
  });
  return e.length === 6 ? e : null;
}, matrix3d: function(t) {
  var e = t.filter(function(a) {
    return a.type === 17;
  }).map(function(a) {
    return a.number;
  }), r = e[0], n = e[1];
  e[2], e[3];
  var A = e[4], i = e[5];
  e[6], e[7], e[8], e[9], e[10], e[11];
  var o = e[12], s = e[13];
  return e[14], e[15], e.length === 16 ? [r, n, A, i, o, s] : null;
} }, EB = { type: 16, number: 50, flags: 4 }, bae = [EB, EB], Bae = { name: "transform-origin", initialValue: "50% 50%", prefix: !0, type: 1, parse: function(t, e) {
  var r = e.filter(Gn);
  return r.length !== 2 ? bae : [r[0], r[1]];
} }, Eae = { name: "visible", initialValue: "none", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "hidden":
      return 1;
    case "collapse":
      return 2;
    default:
      return 0;
  }
} };
(function(t) {
  t.NORMAL = "normal", t.BREAK_ALL = "break-all", t.KEEP_ALL = "keep-all";
})(n2 || (n2 = {}));
for (var xae = { name: "word-break", initialValue: "normal", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "break-all":
      return n2.BREAK_ALL;
    case "keep-all":
      return n2.KEEP_ALL;
    default:
      return n2.NORMAL;
  }
} }, Iae = { name: "z-index", initialValue: "auto", prefix: !1, type: 0, parse: function(t, e) {
  if (e.type === 20) return { auto: !0, order: 0 };
  if (Ql(e)) return { auto: !1, order: e.number };
  throw new Error("Invalid z-index number parsed");
} }, xB = function(t, e) {
  if (e.type === 15) switch (e.unit.toLowerCase()) {
    case "s":
      return 1e3 * e.number;
    case "ms":
      return e.number;
  }
  throw new Error("Unsupported time type");
}, Sae = { name: "opacity", initialValue: "1", type: 0, prefix: !1, parse: function(t, e) {
  return Ql(e) ? e.number : 1;
} }, Pae = { name: "text-decoration-color", initialValue: "transparent", prefix: !1, type: 3, format: "color" }, kae = { name: "text-decoration-line", initialValue: "none", prefix: !1, type: 1, parse: function(t, e) {
  return e.filter(Rr).map(function(r) {
    switch (r.value) {
      case "underline":
        return 1;
      case "overline":
        return 2;
      case "line-through":
        return 3;
      case "none":
        return 4;
    }
    return 0;
  }).filter(function(r) {
    return r !== 0;
  });
} }, Oae = { name: "font-family", initialValue: "", prefix: !1, type: 1, parse: function(t, e) {
  var r = [], n = [];
  return e.forEach(function(A) {
    switch (A.type) {
      case 20:
      case 0:
        r.push(A.value);
        break;
      case 17:
        r.push(A.number.toString());
        break;
      case 4:
        n.push(r.join(" ")), r.length = 0;
    }
  }), r.length && n.push(r.join(" ")), n.map(function(A) {
    return A.indexOf(" ") === -1 ? A : "'" + A + "'";
  });
} }, Fae = { name: "font-size", initialValue: "0", prefix: !1, type: 3, format: "length" }, Tae = { name: "font-weight", initialValue: "normal", type: 0, prefix: !1, parse: function(t, e) {
  return Ql(e) ? e.number : Rr(e) && e.value === "bold" ? 700 : 400;
} }, Mae = { name: "font-variant", initialValue: "none", type: 1, prefix: !1, parse: function(t, e) {
  return e.filter(Rr).map(function(r) {
    return r.value;
  });
} }, Hae = { name: "font-style", initialValue: "normal", prefix: !1, type: 2, parse: function(t, e) {
  switch (e) {
    case "oblique":
      return "oblique";
    case "italic":
      return "italic";
    default:
      return "normal";
  }
} }, Zn = function(t, e) {
  return (t & e) != 0;
}, Dae = { name: "content", initialValue: "none", type: 1, prefix: !1, parse: function(t, e) {
  if (e.length === 0) return [];
  var r = e[0];
  return r.type === 20 && r.value === "none" ? [] : e;
} }, Qae = { name: "counter-increment", initialValue: "none", prefix: !0, type: 1, parse: function(t, e) {
  if (e.length === 0) return null;
  var r = e[0];
  if (r.type === 20 && r.value === "none") return null;
  for (var n = [], A = e.filter(vB), i = 0; i < A.length; i++) {
    var o = A[i], s = A[i + 1];
    if (o.type === 20) {
      var a = s && Ql(s) ? s.number : 1;
      n.push({ counter: o.value, increment: a });
    }
  }
  return n;
} }, Uae = { name: "counter-reset", initialValue: "none", prefix: !0, type: 1, parse: function(t, e) {
  if (e.length === 0) return [];
  for (var r = [], n = e.filter(vB), A = 0; A < n.length; A++) {
    var i = n[A], o = n[A + 1];
    if (Rr(i) && i.value !== "none") {
      var s = o && Ql(o) ? o.number : 0;
      r.push({ counter: i.value, reset: s });
    }
  }
  return r;
} }, Nae = { name: "duration", initialValue: "0s", prefix: !1, type: 1, parse: function(t, e) {
  return e.filter(S2).map(function(r) {
    return xB(t, r);
  });
} }, jae = { name: "quotes", initialValue: "none", prefix: !0, type: 1, parse: function(t, e) {
  if (e.length === 0) return null;
  var r = e[0];
  if (r.type === 20 && r.value === "none") return null;
  var n = [], A = e.filter(wse);
  if (A.length % 2 != 0) return null;
  for (var i = 0; i < A.length; i += 2) {
    var o = A[i].value, s = A[i + 1].value;
    n.push({ open: o, close: s });
  }
  return n;
} }, IB = function(t, e, r) {
  if (!t) return "";
  var n = t[Math.min(e, t.length - 1)];
  return n ? r ? n.open : n.close : "";
}, Lae = { name: "box-shadow", initialValue: "none", type: 1, prefix: !1, parse: function(t, e) {
  return e.length === 1 && q7(e[0], "none") ? [] : Vo(e).map(function(r) {
    for (var n = { color: 255, offsetX: qA, offsetY: qA, blur: qA, spread: qA, inset: !1 }, A = 0, i = 0; i < r.length; i++) {
      var o = r[i];
      q7(o, "inset") ? n.inset = !0 : Va(o) ? (A === 0 ? n.offsetX = o : A === 1 ? n.offsetY = o : A === 2 ? n.blur = o : n.spread = o, A++) : n.color = ka(t, o);
    }
    return n;
  });
} }, Gae = { name: "paint-order", initialValue: "normal", prefix: !1, type: 1, parse: function(t, e) {
  var r = [];
  return e.filter(Rr).forEach(function(n) {
    switch (n.value) {
      case "stroke":
        r.push(1);
        break;
      case "fill":
        r.push(0);
        break;
      case "markers":
        r.push(2);
    }
  }), [0, 1, 2].forEach(function(n) {
    r.indexOf(n) === -1 && r.push(n);
  }), r;
} }, Rae = { name: "-webkit-text-stroke-color", initialValue: "currentcolor", prefix: !1, type: 3, format: "color" }, zae = { name: "-webkit-text-stroke-width", initialValue: "0", type: 0, prefix: !1, parse: function(t, e) {
  return S2(e) ? e.number : 0;
} }, Yae = function() {
  function t(e, r) {
    var n, A;
    this.animationDuration = qt(e, Nae, r.animationDuration), this.backgroundClip = qt(e, Ese, r.backgroundClip), this.backgroundColor = qt(e, xse, r.backgroundColor), this.backgroundImage = qt(e, Sse, r.backgroundImage), this.backgroundOrigin = qt(e, Pse, r.backgroundOrigin), this.backgroundPosition = qt(e, kse, r.backgroundPosition), this.backgroundRepeat = qt(e, Ose, r.backgroundRepeat), this.backgroundSize = qt(e, Tse, r.backgroundSize), this.borderTopColor = qt(e, Hse, r.borderTopColor), this.borderRightColor = qt(e, Dse, r.borderRightColor), this.borderBottomColor = qt(e, Qse, r.borderBottomColor), this.borderLeftColor = qt(e, Use, r.borderLeftColor), this.borderTopLeftRadius = qt(e, Nse, r.borderTopLeftRadius), this.borderTopRightRadius = qt(e, jse, r.borderTopRightRadius), this.borderBottomRightRadius = qt(e, Lse, r.borderBottomRightRadius), this.borderBottomLeftRadius = qt(e, Gse, r.borderBottomLeftRadius), this.borderTopStyle = qt(e, Rse, r.borderTopStyle), this.borderRightStyle = qt(e, zse, r.borderRightStyle), this.borderBottomStyle = qt(e, Yse, r.borderBottomStyle), this.borderLeftStyle = qt(e, Vse, r.borderLeftStyle), this.borderTopWidth = qt(e, Wse, r.borderTopWidth), this.borderRightWidth = qt(e, Xse, r.borderRightWidth), this.borderBottomWidth = qt(e, Kse, r.borderBottomWidth), this.borderLeftWidth = qt(e, Zse, r.borderLeftWidth), this.boxShadow = qt(e, Lae, r.boxShadow), this.color = qt(e, Jse, r.color), this.direction = qt(e, _se, r.direction), this.display = qt(e, $se, r.display), this.float = qt(e, tae, r.cssFloat), this.fontFamily = qt(e, Oae, r.fontFamily), this.fontSize = qt(e, Fae, r.fontSize), this.fontStyle = qt(e, Hae, r.fontStyle), this.fontVariant = qt(e, Mae, r.fontVariant), this.fontWeight = qt(e, Tae, r.fontWeight), this.letterSpacing = qt(e, rae, r.letterSpacing), this.lineBreak = qt(e, nae, r.lineBreak), this.lineHeight = qt(e, Aae, r.lineHeight), this.listStyleImage = qt(e, iae, r.listStyleImage), this.listStylePosition = qt(e, oae, r.listStylePosition), this.listStyleType = qt(e, y7, r.listStyleType), this.marginTop = qt(e, sae, r.marginTop), this.marginRight = qt(e, aae, r.marginRight), this.marginBottom = qt(e, cae, r.marginBottom), this.marginLeft = qt(e, lae, r.marginLeft), this.opacity = qt(e, Sae, r.opacity);
    var i = qt(e, uae, r.overflow);
    this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = qt(e, dae, r.overflowWrap), this.paddingTop = qt(e, fae, r.paddingTop), this.paddingRight = qt(e, hae, r.paddingRight), this.paddingBottom = qt(e, pae, r.paddingBottom), this.paddingLeft = qt(e, gae, r.paddingLeft), this.paintOrder = qt(e, Gae, r.paintOrder), this.position = qt(e, vae, r.position), this.textAlign = qt(e, mae, r.textAlign), this.textDecorationColor = qt(e, Pae, (n = r.textDecorationColor) !== null && n !== void 0 ? n : r.color), this.textDecorationLine = qt(e, kae, (A = r.textDecorationLine) !== null && A !== void 0 ? A : r.textDecoration), this.textShadow = qt(e, qae, r.textShadow), this.textTransform = qt(e, yae, r.textTransform), this.transform = qt(e, Cae, r.transform), this.transformOrigin = qt(e, Bae, r.transformOrigin), this.visibility = qt(e, Eae, r.visibility), this.webkitTextStrokeColor = qt(e, Rae, r.webkitTextStrokeColor), this.webkitTextStrokeWidth = qt(e, zae, r.webkitTextStrokeWidth), this.wordBreak = qt(e, xae, r.wordBreak), this.zIndex = qt(e, Iae, r.zIndex);
  }
  return t.prototype.isVisible = function() {
    return this.display > 0 && this.opacity > 0 && this.visibility === 0;
  }, t.prototype.isTransparent = function() {
    return Oa(this.backgroundColor);
  }, t.prototype.isTransformed = function() {
    return this.transform !== null;
  }, t.prototype.isPositioned = function() {
    return this.position !== 0;
  }, t.prototype.isPositionedWithZIndex = function() {
    return this.isPositioned() && !this.zIndex.auto;
  }, t.prototype.isFloating = function() {
    return this.float !== 0;
  }, t.prototype.isInlineLevel = function() {
    return Zn(this.display, 4) || Zn(this.display, 33554432) || Zn(this.display, 268435456) || Zn(this.display, 536870912) || Zn(this.display, 67108864) || Zn(this.display, 134217728);
  }, t;
}(), Vae = function(t, e) {
  this.content = qt(t, Dae, e.content), this.quotes = qt(t, jae, e.quotes);
}, SB = function(t, e) {
  this.counterIncrement = qt(t, Qae, e.counterIncrement), this.counterReset = qt(t, Uae, e.counterReset);
}, qt = function(t, e, r) {
  var n = new VM(), A = r != null ? r.toString() : e.initialValue;
  n.write(A);
  var i = new WM(n.read());
  switch (e.type) {
    case 2:
      var o = i.parseComponentValue();
      return e.parse(t, Rr(o) ? o.value : e.initialValue);
    case 0:
      return e.parse(t, i.parseComponentValue());
    case 1:
      return e.parse(t, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (e.format) {
        case "angle":
          return p4(t, i.parseComponentValue());
        case "color":
          return ka(t, i.parseComponentValue());
        case "image":
          return Vv(t, i.parseComponentValue());
        case "length":
          var s = i.parseComponentValue();
          return Va(s) ? s : qA;
        case "length-percentage":
          var a = i.parseComponentValue();
          return Gn(a) ? a : qA;
        case "time":
          return xB(t, i.parseComponentValue());
      }
  }
}, C7 = function(t, e) {
  var r = function(n) {
    switch (n.getAttribute("data-html2canvas-debug")) {
      case "all":
        return 1;
      case "clone":
        return 2;
      case "parse":
        return 3;
      case "render":
        return 4;
      default:
        return 0;
    }
  }(t);
  return r === 1 || e === r;
}, ns = function(t, e) {
  this.context = t, this.textNodes = [], this.elements = [], this.flags = 0, C7(e, 3), this.styles = new Yae(t, window.getComputedStyle(e, null)), B7(e) && (this.styles.animationDuration.some(function(r) {
    return r > 0;
  }) && (e.style.animationDuration = "0s"), this.styles.transform !== null && (e.style.transform = "none")), this.bounds = h4(this.context, e), C7(e, 4) && (this.flags |= 16);
}, Wae = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", U0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Df = 0; Df < 64; Df++) U0[Wae.charCodeAt(Df)] = Df;
for (var PB = function(t, e, r) {
  return t.slice ? t.slice(e, r) : new Uint16Array(Array.prototype.slice.call(t, e, r));
}, Xae = function() {
  function t(e, r, n, A, i, o) {
    this.initialValue = e, this.errorValue = r, this.highStart = n, this.highValueIndex = A, this.index = i, this.data = o;
  }
  return t.prototype.get = function(e) {
    var r;
    if (e >= 0) {
      if (e < 55296 || e > 56319 && e <= 65535) return r = ((r = this.index[e >> 5]) << 2) + (31 & e), this.data[r];
      if (e <= 65535) return r = ((r = this.index[2048 + (e - 55296 >> 5)]) << 2) + (31 & e), this.data[r];
      if (e < this.highStart) return r = 2080 + (e >> 11), r = this.index[r], r += e >> 5 & 63, r = ((r = this.index[r]) << 2) + (31 & e), this.data[r];
      if (e <= 1114111) return this.data[this.highValueIndex];
    }
    return this.errorValue;
  }, t;
}(), Kae = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Zae = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Qf = 0; Qf < 64; Qf++) Zae[Kae.charCodeAt(Qf)] = Qf;
var A2, kB = 8, A6 = 9, OB = 11, FB = 12, Jae = function() {
  for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
  if (String.fromCodePoint) return String.fromCodePoint.apply(String, t);
  var r = t.length;
  if (!r) return "";
  for (var n = [], A = -1, i = ""; ++A < r; ) {
    var o = t[A];
    o <= 65535 ? n.push(o) : (o -= 65536, n.push(55296 + (o >> 10), o % 1024 + 56320)), (A + 1 === r || n.length > 16384) && (i += String.fromCharCode.apply(String, n), n.length = 0);
  }
  return i;
}, _ae = function(t, e) {
  var r, n, A, i = function(l) {
    var u, f, d, g, m, p = 0.75 * l.length, v = l.length, C = 0;
    l[l.length - 1] === "=" && (p--, l[l.length - 2] === "=" && p--);
    var w = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(p) : new Array(p), B = Array.isArray(w) ? w : new Uint8Array(w);
    for (u = 0; u < v; u += 4) f = U0[l.charCodeAt(u)], d = U0[l.charCodeAt(u + 1)], g = U0[l.charCodeAt(u + 2)], m = U0[l.charCodeAt(u + 3)], B[C++] = f << 2 | d >> 4, B[C++] = (15 & d) << 4 | g >> 2, B[C++] = (3 & g) << 6 | 63 & m;
    return w;
  }(t), o = Array.isArray(i) ? function(l) {
    for (var u = l.length, f = [], d = 0; d < u; d += 4) f.push(l[d + 3] << 24 | l[d + 2] << 16 | l[d + 1] << 8 | l[d]);
    return f;
  }(i) : new Uint32Array(i), s = Array.isArray(i) ? function(l) {
    for (var u = l.length, f = [], d = 0; d < u; d += 2) f.push(l[d + 1] << 8 | l[d]);
    return f;
  }(i) : new Uint16Array(i), a = PB(s, 12, o[4] / 2), c = o[5] === 2 ? PB(s, (24 + o[4]) / 2) : (r = o, n = Math.ceil((24 + o[4]) / 4), r.slice ? r.slice(n, A) : new Uint32Array(Array.prototype.slice.call(r, n, A)));
  return new Xae(o[0], o[1], o[2], o[3], a, c);
}("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"), ki = "×", $ae = function(t) {
  return _ae.get(t);
}, ece = function(t, e, r) {
  var n = r - 2, A = e[n], i = e[r - 1], o = e[r];
  if (i === 2 && o === 3) return ki;
  if (i === 2 || i === 3 || i === 4 || o === 2 || o === 3 || o === 4) return "÷";
  if (i === kB && [kB, A6, OB, FB].indexOf(o) !== -1 || !(i !== OB && i !== A6 || o !== A6 && o !== 10) || (i === FB || i === 10) && o === 10 || o === 13 || o === 5 || o === 7 || i === 1) return ki;
  if (i === 13 && o === 14) {
    for (; A === 5; ) A = e[--n];
    if (A === 14) return ki;
  }
  if (i === 15 && o === 15) {
    for (var s = 0; A === 15; ) s++, A = e[--n];
    if (s % 2 == 0) return ki;
  }
  return "÷";
}, tce = function(t) {
  var e = function(o) {
    for (var s = [], a = 0, c = o.length; a < c; ) {
      var l = o.charCodeAt(a++);
      if (l >= 55296 && l <= 56319 && a < c) {
        var u = o.charCodeAt(a++);
        (64512 & u) == 56320 ? s.push(((1023 & l) << 10) + (1023 & u) + 65536) : (s.push(l), a--);
      } else s.push(l);
    }
    return s;
  }(t), r = e.length, n = 0, A = 0, i = e.map($ae);
  return { next: function() {
    if (n >= r) return { done: !0, value: null };
    for (var o = ki; n < r && (o = ece(0, i, ++n)) === ki; ) ;
    if (o !== ki || n === r) {
      var s = Jae.apply(null, e.slice(A, n));
      return A = n, { value: s, done: !1 };
    }
    return { done: !0, value: null };
  } };
}, TB = function(t) {
  return t[0] === 0 && t[1] === 255 && t[2] === 0 && t[3] === 255;
}, w7 = function(t, e, r, n, A) {
  var i = "http://www.w3.org/2000/svg", o = document.createElementNS(i, "svg"), s = document.createElementNS(i, "foreignObject");
  return o.setAttributeNS(null, "width", t.toString()), o.setAttributeNS(null, "height", e.toString()), s.setAttributeNS(null, "width", "100%"), s.setAttributeNS(null, "height", "100%"), s.setAttributeNS(null, "x", r.toString()), s.setAttributeNS(null, "y", n.toString()), s.setAttributeNS(null, "externalResourcesRequired", "true"), o.appendChild(s), s.appendChild(A), o;
}, MB = function(t) {
  return new Promise(function(e, r) {
    var n = new Image();
    n.onload = function() {
      return e(n);
    }, n.onerror = r, n.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(t));
  });
}, mA = { get SUPPORT_RANGE_BOUNDS() {
  var t = function(e) {
    if (e.createRange) {
      var r = e.createRange();
      if (r.getBoundingClientRect) {
        var n = e.createElement("boundtest");
        n.style.height = "123px", n.style.display = "block", e.body.appendChild(n), r.selectNode(n);
        var A = r.getBoundingClientRect(), i = Math.round(A.height);
        if (e.body.removeChild(n), i === 123) return !0;
      }
    }
    return !1;
  }(document);
  return Object.defineProperty(mA, "SUPPORT_RANGE_BOUNDS", { value: t }), t;
}, get SUPPORT_WORD_BREAKING() {
  var t = mA.SUPPORT_RANGE_BOUNDS && function(e) {
    var r = e.createElement("boundtest");
    r.style.width = "50px", r.style.display = "block", r.style.fontSize = "12px", r.style.letterSpacing = "0px", r.style.wordSpacing = "0px", e.body.appendChild(r);
    var n = e.createRange();
    r.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
    var A = r.firstChild, i = S3(A.data).map(function(c) {
      return wn(c);
    }), o = 0, s = {}, a = i.every(function(c, l) {
      n.setStart(A, o), n.setEnd(A, o + c.length);
      var u = n.getBoundingClientRect();
      o += c.length;
      var f = u.x > s.x || u.y > s.y;
      return s = u, l === 0 || f;
    });
    return e.body.removeChild(r), a;
  }(document);
  return Object.defineProperty(mA, "SUPPORT_WORD_BREAKING", { value: t }), t;
}, get SUPPORT_SVG_DRAWING() {
  var t = function(e) {
    var r = new Image(), n = e.createElement("canvas"), A = n.getContext("2d");
    if (!A) return !1;
    r.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
    try {
      A.drawImage(r, 0, 0), n.toDataURL();
    } catch {
      return !1;
    }
    return !0;
  }(document);
  return Object.defineProperty(mA, "SUPPORT_SVG_DRAWING", { value: t }), t;
}, get SUPPORT_FOREIGNOBJECT_DRAWING() {
  var t = typeof Array.from == "function" && typeof window.fetch == "function" ? function(e) {
    var r = e.createElement("canvas"), n = 100;
    r.width = n, r.height = n;
    var A = r.getContext("2d");
    if (!A) return Promise.reject(!1);
    A.fillStyle = "rgb(0, 255, 0)", A.fillRect(0, 0, n, n);
    var i = new Image(), o = r.toDataURL();
    i.src = o;
    var s = w7(n, n, 0, 0, i);
    return A.fillStyle = "red", A.fillRect(0, 0, n, n), MB(s).then(function(a) {
      A.drawImage(a, 0, 0);
      var c = A.getImageData(0, 0, n, n).data;
      A.fillStyle = "red", A.fillRect(0, 0, n, n);
      var l = e.createElement("div");
      return l.style.backgroundImage = "url(" + o + ")", l.style.height = n + "px", TB(c) ? MB(w7(n, n, 0, 0, l)) : Promise.reject(!1);
    }).then(function(a) {
      return A.drawImage(a, 0, 0), TB(A.getImageData(0, 0, n, n).data);
    }).catch(function() {
      return !1;
    });
  }(document) : Promise.resolve(!1);
  return Object.defineProperty(mA, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: t }), t;
}, get SUPPORT_CORS_IMAGES() {
  var t = new Image().crossOrigin !== void 0;
  return Object.defineProperty(mA, "SUPPORT_CORS_IMAGES", { value: t }), t;
}, get SUPPORT_RESPONSE_TYPE() {
  var t = typeof new XMLHttpRequest().responseType == "string";
  return Object.defineProperty(mA, "SUPPORT_RESPONSE_TYPE", { value: t }), t;
}, get SUPPORT_CORS_XHR() {
  var t = "withCredentials" in new XMLHttpRequest();
  return Object.defineProperty(mA, "SUPPORT_CORS_XHR", { value: t }), t;
}, get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
  var t = !(typeof Intl > "u" || !Intl.Segmenter);
  return Object.defineProperty(mA, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: t }), t;
} }, i2 = function(t, e) {
  this.text = t, this.bounds = e;
}, rce = function(t, e) {
  var r = e.ownerDocument;
  if (r) {
    var n = r.createElement("html2canvaswrapper");
    n.appendChild(e.cloneNode(!0));
    var A = e.parentNode;
    if (A) {
      A.replaceChild(n, e);
      var i = h4(t, n);
      return n.firstChild && A.replaceChild(n.firstChild, n), i;
    }
  }
  return Ds.EMPTY;
}, HB = function(t, e, r) {
  var n = t.ownerDocument;
  if (!n) throw new Error("Node has no owner document");
  var A = n.createRange();
  return A.setStart(t, e), A.setEnd(t, e + r), A;
}, Wv = function(t) {
  if (mA.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var e = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(e.segment(t)).map(function(r) {
      return r.segment;
    });
  }
  return function(r) {
    for (var n, A = tce(r), i = []; !(n = A.next()).done; ) n.value && i.push(n.value.slice());
    return i;
  }(t);
}, nce = function(t, e) {
  return e.letterSpacing !== 0 ? Wv(t) : function(r, n) {
    if (mA.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
      var A = new Intl.Segmenter(void 0, { granularity: "word" });
      return Array.from(A.segment(r)).map(function(i) {
        return i.segment;
      });
    }
    return ice(r, n);
  }(t, e);
}, Ace = [32, 160, 4961, 65792, 65793, 4153, 4241], ice = function(t, e) {
  for (var r, n = function(o, s) {
    var a = S3(o), c = $oe(a, s), l = c[0], u = c[1], f = c[2], d = a.length, g = 0, m = 0;
    return { next: function() {
      if (m >= d) return { done: !0, value: null };
      for (var p = gr; m < d && (p = _oe(a, u, l, ++m, f)) === gr; ) ;
      if (p !== gr || m === d) {
        var v = new ese(a, p, g, m);
        return g = m, { value: v, done: !1 };
      }
      return { done: !0, value: null };
    } };
  }(t, { lineBreak: e.lineBreak, wordBreak: e.overflowWrap === "break-word" ? "break-word" : e.wordBreak }), A = [], i = function() {
    if (r.value) {
      var o = r.value.slice(), s = S3(o), a = "";
      s.forEach(function(c) {
        Ace.indexOf(c) === -1 ? a += wn(c) : (a.length && A.push(a), A.push(wn(c)), a = "");
      }), a.length && A.push(a);
    }
  }; !(r = n.next()).done; ) i();
  return A;
}, oce = function(t, e, r) {
  this.text = sce(e.data, r.textTransform), this.textBounds = function(n, A, i, o) {
    var s = nce(A, i), a = [], c = 0;
    return s.forEach(function(l) {
      if (i.textDecorationLine.length || l.trim().length > 0) if (mA.SUPPORT_RANGE_BOUNDS) {
        var u = HB(o, c, l.length).getClientRects();
        if (u.length > 1) {
          var f = Wv(l), d = 0;
          f.forEach(function(m) {
            a.push(new i2(m, Ds.fromDOMRectList(n, HB(o, d + c, m.length).getClientRects()))), d += m.length;
          });
        } else a.push(new i2(l, Ds.fromDOMRectList(n, u)));
      } else {
        var g = o.splitText(l.length);
        a.push(new i2(l, rce(n, o))), o = g;
      }
      else mA.SUPPORT_RANGE_BOUNDS || (o = o.splitText(l.length));
      c += l.length;
    }), a;
  }(t, this.text, r, e);
}, sce = function(t, e) {
  switch (e) {
    case 1:
      return t.toLowerCase();
    case 3:
      return t.replace(ace, cce);
    case 2:
      return t.toUpperCase();
    default:
      return t;
  }
}, ace = /(^|\s|:|-|\(|\))([a-z])/g, cce = function(t, e, r) {
  return t.length > 0 ? e + r.toUpperCase() : t;
}, aH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A.src = n.currentSrc || n.src, A.intrinsicWidth = n.naturalWidth, A.intrinsicHeight = n.naturalHeight, A.context.cache.addImage(A.src), A;
  }
  return yo(e, t), e;
}(ns), cH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A.canvas = n, A.intrinsicWidth = n.width, A.intrinsicHeight = n.height, A;
  }
  return yo(e, t), e;
}(ns), lH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this, i = new XMLSerializer(), o = h4(r, n);
    return n.setAttribute("width", o.width + "px"), n.setAttribute("height", o.height + "px"), A.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(n)), A.intrinsicWidth = n.width.baseVal.value, A.intrinsicHeight = n.height.baseVal.value, A.context.cache.addImage(A.svg), A;
  }
  return yo(e, t), e;
}(ns), uH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A.value = n.value, A;
  }
  return yo(e, t), e;
}(ns), b7 = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A.start = n.start, A.reversed = typeof n.reversed == "boolean" && n.reversed === !0, A;
  }
  return yo(e, t), e;
}(ns), lce = [{ type: 15, flags: 0, unit: "px", number: 3 }], uce = [{ type: 16, flags: 0, number: 50 }], F3 = "checkbox", T3 = "radio", dce = "password", DB = 707406591, Xv = function(t) {
  function e(r, n) {
    var A, i, o, s = t.call(this, r, n) || this;
    switch (s.type = n.type.toLowerCase(), s.checked = n.checked, s.value = (i = (A = n).type === dce ? new Array(A.value.length + 1).join("•") : A.value).length === 0 ? A.placeholder || "" : i, s.type !== F3 && s.type !== T3 || (s.styles.backgroundColor = 3739148031, s.styles.borderTopColor = s.styles.borderRightColor = s.styles.borderBottomColor = s.styles.borderLeftColor = 2779096575, s.styles.borderTopWidth = s.styles.borderRightWidth = s.styles.borderBottomWidth = s.styles.borderLeftWidth = 1, s.styles.borderTopStyle = s.styles.borderRightStyle = s.styles.borderBottomStyle = s.styles.borderLeftStyle = 1, s.styles.backgroundClip = [0], s.styles.backgroundOrigin = [0], s.bounds = (o = s.bounds).width > o.height ? new Ds(o.left + (o.width - o.height) / 2, o.top, o.height, o.height) : o.width < o.height ? new Ds(o.left, o.top + (o.height - o.width) / 2, o.width, o.width) : o), s.type) {
      case F3:
        s.styles.borderTopRightRadius = s.styles.borderTopLeftRadius = s.styles.borderBottomRightRadius = s.styles.borderBottomLeftRadius = lce;
        break;
      case T3:
        s.styles.borderTopRightRadius = s.styles.borderTopLeftRadius = s.styles.borderBottomRightRadius = s.styles.borderBottomLeftRadius = uce;
    }
    return s;
  }
  return yo(e, t), e;
}(ns), dH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this, i = n.options[n.selectedIndex || 0];
    return A.value = i && i.text || "", A;
  }
  return yo(e, t), e;
}(ns), fH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A.value = n.value, A;
  }
  return yo(e, t), e;
}(ns), hH = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    A.src = n.src, A.width = parseInt(n.width, 10) || 0, A.height = parseInt(n.height, 10) || 0, A.backgroundColor = A.styles.backgroundColor;
    try {
      if (n.contentWindow && n.contentWindow.document && n.contentWindow.document.documentElement) {
        A.tree = gH(r, n.contentWindow.document.documentElement);
        var i = n.contentWindow.document.documentElement ? r2(r, getComputedStyle(n.contentWindow.document.documentElement).backgroundColor) : bs.TRANSPARENT, o = n.contentWindow.document.body ? r2(r, getComputedStyle(n.contentWindow.document.body).backgroundColor) : bs.TRANSPARENT;
        A.backgroundColor = Oa(i) ? Oa(o) ? A.styles.backgroundColor : o : i;
      }
    } catch {
    }
    return A;
  }
  return yo(e, t), e;
}(ns), fce = ["OL", "UL", "MENU"], Sh = function(t, e, r, n) {
  for (var A = e.firstChild, i = void 0; A; A = i) if (i = A.nextSibling, mH(A) && A.data.trim().length > 0) r.textNodes.push(new oce(t, A, r.styles));
  else if (Wl(A)) if (CH(A) && A.assignedNodes) A.assignedNodes().forEach(function(s) {
    return Sh(t, s, r, n);
  });
  else {
    var o = pH(t, A);
    o.styles.isVisible() && (hce(A, o, n) ? o.flags |= 4 : pce(o.styles) && (o.flags |= 2), fce.indexOf(A.tagName) !== -1 && (o.flags |= 8), r.elements.push(o), A.slot, A.shadowRoot ? Sh(t, A.shadowRoot, o, n) : M3(A) || vH(A) || H3(A) || Sh(t, A, o, n));
  }
}, pH = function(t, e) {
  return E7(e) ? new aH(t, e) : qH(e) ? new cH(t, e) : vH(e) ? new lH(t, e) : gce(e) ? new uH(t, e) : mce(e) ? new b7(t, e) : vce(e) ? new Xv(t, e) : H3(e) ? new dH(t, e) : M3(e) ? new fH(t, e) : yH(e) ? new hH(t, e) : new ns(t, e);
}, gH = function(t, e) {
  var r = pH(t, e);
  return r.flags |= 4, Sh(t, e, r, r), r;
}, hce = function(t, e, r) {
  return e.styles.isPositionedWithZIndex() || e.styles.opacity < 1 || e.styles.isTransformed() || Kv(t) && r.styles.isTransparent();
}, pce = function(t) {
  return t.isPositioned() || t.isFloating();
}, mH = function(t) {
  return t.nodeType === Node.TEXT_NODE;
}, Wl = function(t) {
  return t.nodeType === Node.ELEMENT_NODE;
}, B7 = function(t) {
  return Wl(t) && t.style !== void 0 && !Ph(t);
}, Ph = function(t) {
  return typeof t.className == "object";
}, gce = function(t) {
  return t.tagName === "LI";
}, mce = function(t) {
  return t.tagName === "OL";
}, vce = function(t) {
  return t.tagName === "INPUT";
}, vH = function(t) {
  return t.tagName === "svg";
}, Kv = function(t) {
  return t.tagName === "BODY";
}, qH = function(t) {
  return t.tagName === "CANVAS";
}, QB = function(t) {
  return t.tagName === "VIDEO";
}, E7 = function(t) {
  return t.tagName === "IMG";
}, yH = function(t) {
  return t.tagName === "IFRAME";
}, UB = function(t) {
  return t.tagName === "STYLE";
}, M3 = function(t) {
  return t.tagName === "TEXTAREA";
}, H3 = function(t) {
  return t.tagName === "SELECT";
}, CH = function(t) {
  return t.tagName === "SLOT";
}, NB = function(t) {
  return t.tagName.indexOf("-") > 0;
}, qce = function() {
  function t() {
    this.counters = {};
  }
  return t.prototype.getCounterValue = function(e) {
    var r = this.counters[e];
    return r && r.length ? r[r.length - 1] : 1;
  }, t.prototype.getCounterValues = function(e) {
    var r = this.counters[e];
    return r || [];
  }, t.prototype.pop = function(e) {
    var r = this;
    e.forEach(function(n) {
      return r.counters[n].pop();
    });
  }, t.prototype.parse = function(e) {
    var r = this, n = e.counterIncrement, A = e.counterReset, i = !0;
    n !== null && n.forEach(function(s) {
      var a = r.counters[s.counter];
      a && s.increment !== 0 && (i = !1, a.length || a.push(1), a[Math.max(0, a.length - 1)] += s.increment);
    });
    var o = [];
    return i && A.forEach(function(s) {
      var a = r.counters[s.counter];
      o.push(s.counter), a || (a = r.counters[s.counter] = []), a.push(s.reset);
    }), o;
  }, t;
}(), jB = { integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1], values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"] }, LB = { integers: [9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1], values: ["Ք", "Փ", "Ւ", "Ց", "Ր", "Տ", "Վ", "Ս", "Ռ", "Ջ", "Պ", "Չ", "Ո", "Շ", "Ն", "Յ", "Մ", "Ճ", "Ղ", "Ձ", "Հ", "Կ", "Ծ", "Խ", "Լ", "Ի", "Ժ", "Թ", "Ը", "Է", "Զ", "Ե", "Դ", "Գ", "Բ", "Ա"] }, yce = { integers: [1e4, 9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1], values: ["י׳", "ט׳", "ח׳", "ז׳", "ו׳", "ה׳", "ד׳", "ג׳", "ב׳", "א׳", "ת", "ש", "ר", "ק", "צ", "פ", "ע", "ס", "נ", "מ", "ל", "כ", "יט", "יח", "יז", "טז", "טו", "י", "ט", "ח", "ז", "ו", "ה", "ד", "ג", "ב", "א"] }, Cce = { integers: [1e4, 9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1], values: ["ჵ", "ჰ", "ჯ", "ჴ", "ხ", "ჭ", "წ", "ძ", "ც", "ჩ", "შ", "ყ", "ღ", "ქ", "ფ", "ჳ", "ტ", "ს", "რ", "ჟ", "პ", "ო", "ჲ", "ნ", "მ", "ლ", "კ", "ი", "თ", "ჱ", "ზ", "ვ", "ე", "დ", "გ", "ბ", "ა"] }, xl = function(t, e, r, n, A, i) {
  return t < e || t > r ? P2(t, A, i.length > 0) : n.integers.reduce(function(o, s, a) {
    for (; t >= s; ) t -= s, o += n.values[a];
    return o;
  }, "") + i;
}, wH = function(t, e, r, n) {
  var A = "";
  do
    r || t--, A = n(t) + A, t /= e;
  while (t * e >= e);
  return A;
}, Cn = function(t, e, r, n, A) {
  var i = r - e + 1;
  return (t < 0 ? "-" : "") + (wH(Math.abs(t), i, n, function(o) {
    return wn(Math.floor(o % i) + e);
  }) + A);
}, uc = function(t, e, r) {
  r === void 0 && (r = ". ");
  var n = e.length;
  return wH(Math.abs(t), n, !1, function(A) {
    return e[Math.floor(A % n)];
  }) + r;
}, as = function(t, e, r, n, A, i) {
  if (t < -9999 || t > 9999) return P2(t, 4, A.length > 0);
  var o = Math.abs(t), s = A;
  if (o === 0) return e[0] + s;
  for (var a = 0; o > 0 && a <= 4; a++) {
    var c = o % 10;
    c === 0 && Zn(i, 1) && s !== "" ? s = e[c] + s : c > 1 || c === 1 && a === 0 || c === 1 && a === 1 && Zn(i, 2) || c === 1 && a === 1 && Zn(i, 4) && t > 100 || c === 1 && a > 1 && Zn(i, 8) ? s = e[c] + (a > 0 ? r[a - 1] : "") + s : c === 1 && a > 0 && (s = r[a - 1] + s), o = Math.floor(o / 10);
  }
  return (t < 0 ? n : "") + s;
}, GB = "十百千萬", RB = "拾佰仟萬", zB = "マイナス", i6 = "마이너스", P2 = function(t, e, r) {
  var n = r ? ". " : "", A = r ? "、" : "", i = r ? ", " : "", o = r ? " " : "";
  switch (e) {
    case 0:
      return "•" + o;
    case 1:
      return "◦" + o;
    case 2:
      return "◾" + o;
    case 5:
      var s = Cn(t, 48, 57, !0, n);
      return s.length < 4 ? "0" + s : s;
    case 4:
      return uc(t, "〇一二三四五六七八九", A);
    case 6:
      return xl(t, 1, 3999, jB, 3, n).toLowerCase();
    case 7:
      return xl(t, 1, 3999, jB, 3, n);
    case 8:
      return Cn(t, 945, 969, !1, n);
    case 9:
      return Cn(t, 97, 122, !1, n);
    case 10:
      return Cn(t, 65, 90, !1, n);
    case 11:
      return Cn(t, 1632, 1641, !0, n);
    case 12:
    case 49:
      return xl(t, 1, 9999, LB, 3, n);
    case 35:
      return xl(t, 1, 9999, LB, 3, n).toLowerCase();
    case 13:
      return Cn(t, 2534, 2543, !0, n);
    case 14:
    case 30:
      return Cn(t, 6112, 6121, !0, n);
    case 15:
      return uc(t, "子丑寅卯辰巳午未申酉戌亥", A);
    case 16:
      return uc(t, "甲乙丙丁戊己庚辛壬癸", A);
    case 17:
    case 48:
      return as(t, "零一二三四五六七八九", GB, "負", A, 14);
    case 47:
      return as(t, "零壹貳參肆伍陸柒捌玖", RB, "負", A, 15);
    case 42:
      return as(t, "零一二三四五六七八九", GB, "负", A, 14);
    case 41:
      return as(t, "零壹贰叁肆伍陆柒捌玖", RB, "负", A, 15);
    case 26:
      return as(t, "〇一二三四五六七八九", "十百千万", zB, A, 0);
    case 25:
      return as(t, "零壱弐参四伍六七八九", "拾百千万", zB, A, 7);
    case 31:
      return as(t, "영일이삼사오육칠팔구", "십백천만", i6, i, 7);
    case 33:
      return as(t, "零一二三四五六七八九", "十百千萬", i6, i, 0);
    case 32:
      return as(t, "零壹貳參四五六七八九", "拾百千", i6, i, 7);
    case 18:
      return Cn(t, 2406, 2415, !0, n);
    case 20:
      return xl(t, 1, 19999, Cce, 3, n);
    case 21:
      return Cn(t, 2790, 2799, !0, n);
    case 22:
      return Cn(t, 2662, 2671, !0, n);
    case 22:
      return xl(t, 1, 10999, yce, 3, n);
    case 23:
      return uc(t, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return uc(t, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return Cn(t, 3302, 3311, !0, n);
    case 28:
      return uc(t, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", A);
    case 29:
      return uc(t, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", A);
    case 34:
      return Cn(t, 3792, 3801, !0, n);
    case 37:
      return Cn(t, 6160, 6169, !0, n);
    case 38:
      return Cn(t, 4160, 4169, !0, n);
    case 39:
      return Cn(t, 2918, 2927, !0, n);
    case 40:
      return Cn(t, 1776, 1785, !0, n);
    case 43:
      return Cn(t, 3046, 3055, !0, n);
    case 44:
      return Cn(t, 3174, 3183, !0, n);
    case 45:
      return Cn(t, 3664, 3673, !0, n);
    case 46:
      return Cn(t, 3872, 3881, !0, n);
    default:
      return Cn(t, 48, 57, !0, n);
  }
}, bH = "data-html2canvas-ignore", YB = function() {
  function t(e, r, n) {
    if (this.context = e, this.options = n, this.scrolledElements = [], this.referenceElement = r, this.counters = new qce(), this.quoteDepth = 0, !r.ownerDocument) throw new Error("Cloned element does not have an owner document");
    this.documentElement = this.cloneNode(r.ownerDocument.documentElement, !1);
  }
  return t.prototype.toIFrame = function(e, r) {
    var n = this, A = wce(e, r);
    if (!A.contentWindow) return Promise.reject("Unable to find iframe window");
    var i = e.defaultView.pageXOffset, o = e.defaultView.pageYOffset, s = A.contentWindow, a = s.document, c = Ece(A).then(function() {
      return GA(n, void 0, void 0, function() {
        var l, u;
        return IA(this, function(f) {
          switch (f.label) {
            case 0:
              return this.scrolledElements.forEach(Pce), s && (s.scrollTo(r.left, r.top), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || s.scrollY === r.top && s.scrollX === r.left || (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(s.scrollX - r.left, s.scrollY - r.top, 0, 0))), l = this.options.onclone, (u = this.clonedReferenceElement) === void 0 ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : a.fonts && a.fonts.ready ? [4, a.fonts.ready] : [3, 2];
            case 1:
              f.sent(), f.label = 2;
            case 2:
              return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, Bce(a)] : [3, 4];
            case 3:
              f.sent(), f.label = 4;
            case 4:
              return typeof l == "function" ? [2, Promise.resolve().then(function() {
                return l(a, u);
              }).then(function() {
                return A;
              })] : [2, A];
          }
        });
      });
    });
    return a.open(), a.write(Ice(document.doctype) + "<html></html>"), Sce(this.referenceElement.ownerDocument, i, o), a.replaceChild(a.adoptNode(this.documentElement), a.documentElement), a.close(), c;
  }, t.prototype.createElementClone = function(e) {
    if (C7(e, 2), qH(e)) return this.createCanvasClone(e);
    if (QB(e)) return this.createVideoClone(e);
    if (UB(e)) return this.createStyleClone(e);
    var r = e.cloneNode(!1);
    return E7(r) && (E7(e) && e.currentSrc && e.currentSrc !== e.src && (r.src = e.currentSrc, r.srcset = ""), r.loading === "lazy" && (r.loading = "eager")), NB(r) ? this.createCustomElementClone(r) : r;
  }, t.prototype.createCustomElementClone = function(e) {
    var r = document.createElement("html2canvascustomelement");
    return o6(e.style, r), r;
  }, t.prototype.createStyleClone = function(e) {
    try {
      var r = e.sheet;
      if (r && r.cssRules) {
        var n = [].slice.call(r.cssRules, 0).reduce(function(i, o) {
          return o && typeof o.cssText == "string" ? i + o.cssText : i;
        }, ""), A = e.cloneNode(!1);
        return A.textContent = n, A;
      }
    } catch (i) {
      if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError") throw i;
    }
    return e.cloneNode(!1);
  }, t.prototype.createCanvasClone = function(e) {
    var r;
    if (this.options.inlineImages && e.ownerDocument) {
      var n = e.ownerDocument.createElement("img");
      try {
        return n.src = e.toDataURL(), n;
      } catch {
        this.context.logger.info("Unable to inline canvas contents, canvas is tainted", e);
      }
    }
    var A = e.cloneNode(!1);
    try {
      A.width = e.width, A.height = e.height;
      var i = e.getContext("2d"), o = A.getContext("2d");
      if (o) if (!this.options.allowTaint && i) o.putImageData(i.getImageData(0, 0, e.width, e.height), 0, 0);
      else {
        var s = (r = e.getContext("webgl2")) !== null && r !== void 0 ? r : e.getContext("webgl");
        if (s) {
          var a = s.getContextAttributes();
          (a == null ? void 0 : a.preserveDrawingBuffer) === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", e);
        }
        o.drawImage(e, 0, 0);
      }
      return A;
    } catch {
      this.context.logger.info("Unable to clone canvas as it is tainted", e);
    }
    return A;
  }, t.prototype.createVideoClone = function(e) {
    var r = e.ownerDocument.createElement("canvas");
    r.width = e.offsetWidth, r.height = e.offsetHeight;
    var n = r.getContext("2d");
    try {
      return n && (n.drawImage(e, 0, 0, r.width, r.height), this.options.allowTaint || n.getImageData(0, 0, r.width, r.height)), r;
    } catch {
      this.context.logger.info("Unable to clone video as it is tainted", e);
    }
    var A = e.ownerDocument.createElement("canvas");
    return A.width = e.offsetWidth, A.height = e.offsetHeight, A;
  }, t.prototype.appendChildNode = function(e, r, n) {
    Wl(r) && (r.tagName === "SCRIPT" || r.hasAttribute(bH) || typeof this.options.ignoreElements == "function" && this.options.ignoreElements(r)) || this.options.copyStyles && Wl(r) && UB(r) || e.appendChild(this.cloneNode(r, n));
  }, t.prototype.cloneChildNodes = function(e, r, n) {
    for (var A = this, i = e.shadowRoot ? e.shadowRoot.firstChild : e.firstChild; i; i = i.nextSibling) if (Wl(i) && CH(i) && typeof i.assignedNodes == "function") {
      var o = i.assignedNodes();
      o.length && o.forEach(function(s) {
        return A.appendChildNode(r, s, n);
      });
    } else this.appendChildNode(r, i, n);
  }, t.prototype.cloneNode = function(e, r) {
    if (mH(e)) return document.createTextNode(e.data);
    if (!e.ownerDocument) return e.cloneNode(!1);
    var n = e.ownerDocument.defaultView;
    if (n && Wl(e) && (B7(e) || Ph(e))) {
      var A = this.createElementClone(e);
      A.style.transitionProperty = "none";
      var i = n.getComputedStyle(e), o = n.getComputedStyle(e, ":before"), s = n.getComputedStyle(e, ":after");
      this.referenceElement === e && B7(A) && (this.clonedReferenceElement = A), Kv(A) && kce(A);
      var a = this.counters.parse(new SB(this.context, i)), c = this.resolvePseudoContent(e, A, o, A2.BEFORE);
      NB(e) && (r = !0), QB(e) || this.cloneChildNodes(e, A, r), c && A.insertBefore(c, A.firstChild);
      var l = this.resolvePseudoContent(e, A, s, A2.AFTER);
      return l && A.appendChild(l), this.counters.pop(a), (i && (this.options.copyStyles || Ph(e)) && !yH(e) || r) && o6(i, A), e.scrollTop === 0 && e.scrollLeft === 0 || this.scrolledElements.push([A, e.scrollLeft, e.scrollTop]), (M3(e) || H3(e)) && (M3(A) || H3(A)) && (A.value = e.value), A;
    }
    return e.cloneNode(!1);
  }, t.prototype.resolvePseudoContent = function(e, r, n, A) {
    var i = this;
    if (n) {
      var o = n.content, s = r.ownerDocument;
      if (s && o && o !== "none" && o !== "-moz-alt-content" && n.display !== "none") {
        this.counters.parse(new SB(this.context, n));
        var a = new Vae(this.context, n), c = s.createElement("html2canvaspseudoelement");
        o6(n, c), a.content.forEach(function(u) {
          if (u.type === 0) c.appendChild(s.createTextNode(u.value));
          else if (u.type === 22) {
            var f = s.createElement("img");
            f.src = u.value, f.style.opacity = "1", c.appendChild(f);
          } else if (u.type === 18) {
            if (u.name === "attr") {
              var d = u.values.filter(Rr);
              d.length && c.appendChild(s.createTextNode(e.getAttribute(d[0].value) || ""));
            } else if (u.name === "counter") {
              var g = u.values.filter(ju), m = g[0], p = g[1];
              if (m && Rr(m)) {
                var v = i.counters.getCounterValue(m.value), C = p && Rr(p) ? y7.parse(i.context, p.value) : 3;
                c.appendChild(s.createTextNode(P2(v, C, !1)));
              }
            } else if (u.name === "counters") {
              var w = u.values.filter(ju), B = (m = w[0], w[1]);
              if (p = w[2], m && Rr(m)) {
                var y = i.counters.getCounterValues(m.value), b = p && Rr(p) ? y7.parse(i.context, p.value) : 3, q = B && B.type === 0 ? B.value : "", E = y.map(function(x) {
                  return P2(x, b, !1);
                }).join(q);
                c.appendChild(s.createTextNode(E));
              }
            }
          } else if (u.type === 20) switch (u.value) {
            case "open-quote":
              c.appendChild(s.createTextNode(IB(a.quotes, i.quoteDepth++, !0)));
              break;
            case "close-quote":
              c.appendChild(s.createTextNode(IB(a.quotes, --i.quoteDepth, !1)));
              break;
            default:
              c.appendChild(s.createTextNode(u.value));
          }
        }), c.className = x7 + " " + I7;
        var l = A === A2.BEFORE ? " " + x7 : " " + I7;
        return Ph(r) ? r.className.baseValue += l : r.className += l, c;
      }
    }
  }, t.destroy = function(e) {
    return !!e.parentNode && (e.parentNode.removeChild(e), !0);
  }, t;
}();
(function(t) {
  t[t.BEFORE = 0] = "BEFORE", t[t.AFTER = 1] = "AFTER";
})(A2 || (A2 = {}));
var Ur, wce = function(t, e) {
  var r = t.createElement("iframe");
  return r.className = "html2canvas-container", r.style.visibility = "hidden", r.style.position = "fixed", r.style.left = "-10000px", r.style.top = "0px", r.style.border = "0", r.width = e.width.toString(), r.height = e.height.toString(), r.scrolling = "no", r.setAttribute(bH, "true"), t.body.appendChild(r), r;
}, bce = function(t) {
  return new Promise(function(e) {
    t.complete ? e() : t.src ? (t.onload = e, t.onerror = e) : e();
  });
}, Bce = function(t) {
  return Promise.all([].slice.call(t.images, 0).map(bce));
}, Ece = function(t) {
  return new Promise(function(e, r) {
    var n = t.contentWindow;
    if (!n) return r("No window assigned for iframe");
    var A = n.document;
    n.onload = t.onload = function() {
      n.onload = t.onload = null;
      var i = setInterval(function() {
        A.body.childNodes.length > 0 && A.readyState === "complete" && (clearInterval(i), e(t));
      }, 50);
    };
  });
}, xce = ["all", "d", "content"], o6 = function(t, e) {
  for (var r = t.length - 1; r >= 0; r--) {
    var n = t.item(r);
    xce.indexOf(n) === -1 && e.style.setProperty(n, t.getPropertyValue(n));
  }
  return e;
}, Ice = function(t) {
  var e = "";
  return t && (e += "<!DOCTYPE ", t.name && (e += t.name), t.internalSubset && (e += t.internalSubset), t.publicId && (e += '"' + t.publicId + '"'), t.systemId && (e += '"' + t.systemId + '"'), e += ">"), e;
}, Sce = function(t, e, r) {
  t && t.defaultView && (e !== t.defaultView.pageXOffset || r !== t.defaultView.pageYOffset) && t.defaultView.scrollTo(e, r);
}, Pce = function(t) {
  var e = t[0], r = t[1], n = t[2];
  e.scrollLeft = r, e.scrollTop = n;
}, x7 = "___html2canvas___pseudoelement_before", I7 = "___html2canvas___pseudoelement_after", VB = `{
    content: "" !important;
    display: none !important;
}`, kce = function(t) {
  Oce(t, "." + x7 + ":before" + VB + `
         .` + I7 + ":after" + VB);
}, Oce = function(t, e) {
  var r = t.ownerDocument;
  if (r) {
    var n = r.createElement("style");
    n.textContent = e, t.appendChild(n);
  }
}, BH = function() {
  function t() {
  }
  return t.getOrigin = function(e) {
    var r = t._link;
    return r ? (r.href = e, r.href = r.href, r.protocol + r.hostname + r.port) : "about:blank";
  }, t.isSameOrigin = function(e) {
    return t.getOrigin(e) === t._origin;
  }, t.setContext = function(e) {
    t._link = e.document.createElement("a"), t._origin = t.getOrigin(e.location.href);
  }, t._origin = "about:blank", t;
}(), Fce = function() {
  function t(e, r) {
    this.context = e, this._options = r, this._cache = {};
  }
  return t.prototype.addImage = function(e) {
    var r = Promise.resolve();
    return this.has(e) || (a6(e) || Dce(e)) && (this._cache[e] = this.loadImage(e)).catch(function() {
    }), r;
  }, t.prototype.match = function(e) {
    return this._cache[e];
  }, t.prototype.loadImage = function(e) {
    return GA(this, void 0, void 0, function() {
      var r, n, A, i, o = this;
      return IA(this, function(s) {
        switch (s.label) {
          case 0:
            return r = BH.isSameOrigin(e), n = !s6(e) && this._options.useCORS === !0 && mA.SUPPORT_CORS_IMAGES && !r, A = !s6(e) && !r && !a6(e) && typeof this._options.proxy == "string" && mA.SUPPORT_CORS_XHR && !n, r || this._options.allowTaint !== !1 || s6(e) || a6(e) || A || n ? (i = e, A ? [4, this.proxy(i)] : [3, 2]) : [2];
          case 1:
            i = s.sent(), s.label = 2;
          case 2:
            return this.context.logger.debug("Added image " + e.substring(0, 256)), [4, new Promise(function(a, c) {
              var l = new Image();
              l.onload = function() {
                return a(l);
              }, l.onerror = c, (Qce(i) || n) && (l.crossOrigin = "anonymous"), l.src = i, l.complete === !0 && setTimeout(function() {
                return a(l);
              }, 500), o._options.imageTimeout > 0 && setTimeout(function() {
                return c("Timed out (" + o._options.imageTimeout + "ms) loading image");
              }, o._options.imageTimeout);
            })];
          case 3:
            return [2, s.sent()];
        }
      });
    });
  }, t.prototype.has = function(e) {
    return this._cache[e] !== void 0;
  }, t.prototype.keys = function() {
    return Promise.resolve(Object.keys(this._cache));
  }, t.prototype.proxy = function(e) {
    var r = this, n = this._options.proxy;
    if (!n) throw new Error("No proxy defined");
    var A = e.substring(0, 256);
    return new Promise(function(i, o) {
      var s = mA.SUPPORT_RESPONSE_TYPE ? "blob" : "text", a = new XMLHttpRequest();
      a.onload = function() {
        if (a.status === 200) if (s === "text") i(a.response);
        else {
          var u = new FileReader();
          u.addEventListener("load", function() {
            return i(u.result);
          }, !1), u.addEventListener("error", function(f) {
            return o(f);
          }, !1), u.readAsDataURL(a.response);
        }
        else o("Failed to proxy resource " + A + " with status code " + a.status);
      }, a.onerror = o;
      var c = n.indexOf("?") > -1 ? "&" : "?";
      if (a.open("GET", "" + n + c + "url=" + encodeURIComponent(e) + "&responseType=" + s), s !== "text" && a instanceof XMLHttpRequest && (a.responseType = s), r._options.imageTimeout) {
        var l = r._options.imageTimeout;
        a.timeout = l, a.ontimeout = function() {
          return o("Timed out (" + l + "ms) proxying " + A);
        };
      }
      a.send();
    });
  }, t;
}(), Tce = /^data:image\/svg\+xml/i, Mce = /^data:image\/.*;base64,/i, Hce = /^data:image\/.*/i, Dce = function(t) {
  return mA.SUPPORT_SVG_DRAWING || !Uce(t);
}, s6 = function(t) {
  return Hce.test(t);
}, Qce = function(t) {
  return Mce.test(t);
}, a6 = function(t) {
  return t.substr(0, 4) === "blob";
}, Uce = function(t) {
  return t.substr(-3).toLowerCase() === "svg" || Tce.test(t);
}, ht = function() {
  function t(e, r) {
    this.type = 0, this.x = e, this.y = r;
  }
  return t.prototype.add = function(e, r) {
    return new t(this.x + e, this.y + r);
  }, t;
}(), Il = function(t, e, r) {
  return new ht(t.x + (e.x - t.x) * r, t.y + (e.y - t.y) * r);
}, Uf = function() {
  function t(e, r, n, A) {
    this.type = 1, this.start = e, this.startControl = r, this.endControl = n, this.end = A;
  }
  return t.prototype.subdivide = function(e, r) {
    var n = Il(this.start, this.startControl, e), A = Il(this.startControl, this.endControl, e), i = Il(this.endControl, this.end, e), o = Il(n, A, e), s = Il(A, i, e), a = Il(o, s, e);
    return r ? new t(this.start, n, o, a) : new t(a, s, i, this.end);
  }, t.prototype.add = function(e, r) {
    return new t(this.start.add(e, r), this.startControl.add(e, r), this.endControl.add(e, r), this.end.add(e, r));
  }, t.prototype.reverse = function() {
    return new t(this.end, this.endControl, this.startControl, this.start);
  }, t;
}(), Di = function(t) {
  return t.type === 1;
}, Nce = function(t) {
  var e = t.styles, r = t.bounds, n = Q0(e.borderTopLeftRadius, r.width, r.height), A = n[0], i = n[1], o = Q0(e.borderTopRightRadius, r.width, r.height), s = o[0], a = o[1], c = Q0(e.borderBottomRightRadius, r.width, r.height), l = c[0], u = c[1], f = Q0(e.borderBottomLeftRadius, r.width, r.height), d = f[0], g = f[1], m = [];
  m.push((A + s) / r.width), m.push((d + l) / r.width), m.push((i + g) / r.height), m.push((a + u) / r.height);
  var p = Math.max.apply(Math, m);
  p > 1 && (A /= p, i /= p, s /= p, a /= p, l /= p, u /= p, d /= p, g /= p);
  var v = r.width - s, C = r.height - u, w = r.width - l, B = r.height - g, y = e.borderTopWidth, b = e.borderRightWidth, q = e.borderBottomWidth, E = e.borderLeftWidth, x = Jr(e.paddingTop, t.bounds.width), M = Jr(e.paddingRight, t.bounds.width), O = Jr(e.paddingBottom, t.bounds.width), I = Jr(e.paddingLeft, t.bounds.width);
  this.topLeftBorderDoubleOuterBox = A > 0 || i > 0 ? on(r.left + E / 3, r.top + y / 3, A - E / 3, i - y / 3, Ur.TOP_LEFT) : new ht(r.left + E / 3, r.top + y / 3), this.topRightBorderDoubleOuterBox = A > 0 || i > 0 ? on(r.left + v, r.top + y / 3, s - b / 3, a - y / 3, Ur.TOP_RIGHT) : new ht(r.left + r.width - b / 3, r.top + y / 3), this.bottomRightBorderDoubleOuterBox = l > 0 || u > 0 ? on(r.left + w, r.top + C, l - b / 3, u - q / 3, Ur.BOTTOM_RIGHT) : new ht(r.left + r.width - b / 3, r.top + r.height - q / 3), this.bottomLeftBorderDoubleOuterBox = d > 0 || g > 0 ? on(r.left + E / 3, r.top + B, d - E / 3, g - q / 3, Ur.BOTTOM_LEFT) : new ht(r.left + E / 3, r.top + r.height - q / 3), this.topLeftBorderDoubleInnerBox = A > 0 || i > 0 ? on(r.left + 2 * E / 3, r.top + 2 * y / 3, A - 2 * E / 3, i - 2 * y / 3, Ur.TOP_LEFT) : new ht(r.left + 2 * E / 3, r.top + 2 * y / 3), this.topRightBorderDoubleInnerBox = A > 0 || i > 0 ? on(r.left + v, r.top + 2 * y / 3, s - 2 * b / 3, a - 2 * y / 3, Ur.TOP_RIGHT) : new ht(r.left + r.width - 2 * b / 3, r.top + 2 * y / 3), this.bottomRightBorderDoubleInnerBox = l > 0 || u > 0 ? on(r.left + w, r.top + C, l - 2 * b / 3, u - 2 * q / 3, Ur.BOTTOM_RIGHT) : new ht(r.left + r.width - 2 * b / 3, r.top + r.height - 2 * q / 3), this.bottomLeftBorderDoubleInnerBox = d > 0 || g > 0 ? on(r.left + 2 * E / 3, r.top + B, d - 2 * E / 3, g - 2 * q / 3, Ur.BOTTOM_LEFT) : new ht(r.left + 2 * E / 3, r.top + r.height - 2 * q / 3), this.topLeftBorderStroke = A > 0 || i > 0 ? on(r.left + E / 2, r.top + y / 2, A - E / 2, i - y / 2, Ur.TOP_LEFT) : new ht(r.left + E / 2, r.top + y / 2), this.topRightBorderStroke = A > 0 || i > 0 ? on(r.left + v, r.top + y / 2, s - b / 2, a - y / 2, Ur.TOP_RIGHT) : new ht(r.left + r.width - b / 2, r.top + y / 2), this.bottomRightBorderStroke = l > 0 || u > 0 ? on(r.left + w, r.top + C, l - b / 2, u - q / 2, Ur.BOTTOM_RIGHT) : new ht(r.left + r.width - b / 2, r.top + r.height - q / 2), this.bottomLeftBorderStroke = d > 0 || g > 0 ? on(r.left + E / 2, r.top + B, d - E / 2, g - q / 2, Ur.BOTTOM_LEFT) : new ht(r.left + E / 2, r.top + r.height - q / 2), this.topLeftBorderBox = A > 0 || i > 0 ? on(r.left, r.top, A, i, Ur.TOP_LEFT) : new ht(r.left, r.top), this.topRightBorderBox = s > 0 || a > 0 ? on(r.left + v, r.top, s, a, Ur.TOP_RIGHT) : new ht(r.left + r.width, r.top), this.bottomRightBorderBox = l > 0 || u > 0 ? on(r.left + w, r.top + C, l, u, Ur.BOTTOM_RIGHT) : new ht(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = d > 0 || g > 0 ? on(r.left, r.top + B, d, g, Ur.BOTTOM_LEFT) : new ht(r.left, r.top + r.height), this.topLeftPaddingBox = A > 0 || i > 0 ? on(r.left + E, r.top + y, Math.max(0, A - E), Math.max(0, i - y), Ur.TOP_LEFT) : new ht(r.left + E, r.top + y), this.topRightPaddingBox = s > 0 || a > 0 ? on(r.left + Math.min(v, r.width - b), r.top + y, v > r.width + b ? 0 : Math.max(0, s - b), Math.max(0, a - y), Ur.TOP_RIGHT) : new ht(r.left + r.width - b, r.top + y), this.bottomRightPaddingBox = l > 0 || u > 0 ? on(r.left + Math.min(w, r.width - E), r.top + Math.min(C, r.height - q), Math.max(0, l - b), Math.max(0, u - q), Ur.BOTTOM_RIGHT) : new ht(r.left + r.width - b, r.top + r.height - q), this.bottomLeftPaddingBox = d > 0 || g > 0 ? on(r.left + E, r.top + Math.min(B, r.height - q), Math.max(0, d - E), Math.max(0, g - q), Ur.BOTTOM_LEFT) : new ht(r.left + E, r.top + r.height - q), this.topLeftContentBox = A > 0 || i > 0 ? on(r.left + E + I, r.top + y + x, Math.max(0, A - (E + I)), Math.max(0, i - (y + x)), Ur.TOP_LEFT) : new ht(r.left + E + I, r.top + y + x), this.topRightContentBox = s > 0 || a > 0 ? on(r.left + Math.min(v, r.width + E + I), r.top + y + x, v > r.width + E + I ? 0 : s - E + I, a - (y + x), Ur.TOP_RIGHT) : new ht(r.left + r.width - (b + M), r.top + y + x), this.bottomRightContentBox = l > 0 || u > 0 ? on(r.left + Math.min(w, r.width - (E + I)), r.top + Math.min(C, r.height + y + x), Math.max(0, l - (b + M)), u - (q + O), Ur.BOTTOM_RIGHT) : new ht(r.left + r.width - (b + M), r.top + r.height - (q + O)), this.bottomLeftContentBox = d > 0 || g > 0 ? on(r.left + E + I, r.top + B, Math.max(0, d - (E + I)), g - (q + O), Ur.BOTTOM_LEFT) : new ht(r.left + E + I, r.top + r.height - (q + O));
};
(function(t) {
  t[t.TOP_LEFT = 0] = "TOP_LEFT", t[t.TOP_RIGHT = 1] = "TOP_RIGHT", t[t.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", t[t.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(Ur || (Ur = {}));
var on = function(t, e, r, n, A) {
  var i = (Math.sqrt(2) - 1) / 3 * 4, o = r * i, s = n * i, a = t + r, c = e + n;
  switch (A) {
    case Ur.TOP_LEFT:
      return new Uf(new ht(t, c), new ht(t, c - s), new ht(a - o, e), new ht(a, e));
    case Ur.TOP_RIGHT:
      return new Uf(new ht(t, e), new ht(t + o, e), new ht(a, c - s), new ht(a, c));
    case Ur.BOTTOM_RIGHT:
      return new Uf(new ht(a, e), new ht(a, e + s), new ht(t + o, c), new ht(t, c));
    case Ur.BOTTOM_LEFT:
    default:
      return new Uf(new ht(a, c), new ht(a - o, c), new ht(t, e + s), new ht(t, e));
  }
}, D3 = function(t) {
  return [t.topLeftBorderBox, t.topRightBorderBox, t.bottomRightBorderBox, t.bottomLeftBorderBox];
}, Q3 = function(t) {
  return [t.topLeftPaddingBox, t.topRightPaddingBox, t.bottomRightPaddingBox, t.bottomLeftPaddingBox];
}, jce = function(t, e, r) {
  this.offsetX = t, this.offsetY = e, this.matrix = r, this.type = 0, this.target = 6;
}, Nf = function(t, e) {
  this.path = t, this.target = e, this.type = 1;
}, Lce = function(t) {
  this.opacity = t, this.type = 2, this.target = 6;
}, EH = function(t) {
  return t.type === 1;
}, WB = function(t, e) {
  return t.length === e.length && t.some(function(r, n) {
    return r === e[n];
  });
}, xH = function(t) {
  this.element = t, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
}, IH = function() {
  function t(e, r) {
    if (this.container = e, this.parent = r, this.effects = [], this.curves = new Nce(this.container), this.container.styles.opacity < 1 && this.effects.push(new Lce(this.container.styles.opacity)), this.container.styles.transform !== null) {
      var n = this.container.bounds.left + this.container.styles.transformOrigin[0].number, A = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
      this.effects.push(new jce(n, A, i));
    }
    if (this.container.styles.overflowX !== 0) {
      var o = D3(this.curves), s = Q3(this.curves);
      WB(o, s) ? this.effects.push(new Nf(o, 6)) : (this.effects.push(new Nf(o, 2)), this.effects.push(new Nf(s, 4)));
    }
  }
  return t.prototype.getEffects = function(e) {
    for (var r = [2, 3].indexOf(this.container.styles.position) === -1, n = this.parent, A = this.effects.slice(0); n; ) {
      var i = n.effects.filter(function(a) {
        return !EH(a);
      });
      if (r || n.container.styles.position !== 0 || !n.parent) {
        if (A.unshift.apply(A, i), r = [2, 3].indexOf(n.container.styles.position) === -1, n.container.styles.overflowX !== 0) {
          var o = D3(n.curves), s = Q3(n.curves);
          WB(o, s) || A.unshift(new Nf(s, 6));
        }
      } else A.unshift.apply(A, i);
      n = n.parent;
    }
    return A.filter(function(a) {
      return Zn(a.target, e);
    });
  }, t;
}(), S7 = function(t, e, r, n) {
  t.container.elements.forEach(function(A) {
    var i = Zn(A.flags, 4), o = Zn(A.flags, 2), s = new IH(A, t);
    Zn(A.styles.display, 2048) && n.push(s);
    var a = Zn(A.flags, 8) ? [] : n;
    if (i || o) {
      var c = i || A.styles.isPositioned() ? r : e, l = new xH(s);
      if (A.styles.isPositioned() || A.styles.opacity < 1 || A.styles.isTransformed()) {
        var u = A.styles.zIndex.order;
        if (u < 0) {
          var f = 0;
          c.negativeZIndex.some(function(g, m) {
            return u > g.element.container.styles.zIndex.order ? (f = m, !1) : f > 0;
          }), c.negativeZIndex.splice(f, 0, l);
        } else if (u > 0) {
          var d = 0;
          c.positiveZIndex.some(function(g, m) {
            return u >= g.element.container.styles.zIndex.order ? (d = m + 1, !1) : d > 0;
          }), c.positiveZIndex.splice(d, 0, l);
        } else c.zeroOrAutoZIndexOrTransformedOrOpacity.push(l);
      } else A.styles.isFloating() ? c.nonPositionedFloats.push(l) : c.nonPositionedInlineLevel.push(l);
      S7(s, l, i ? l : r, a);
    } else A.styles.isInlineLevel() ? e.inlineLevel.push(s) : e.nonInlineLevel.push(s), S7(s, e, r, a);
    Zn(A.flags, 8) && SH(A, a);
  });
}, SH = function(t, e) {
  for (var r = t instanceof b7 ? t.start : 1, n = t instanceof b7 && t.reversed, A = 0; A < e.length; A++) {
    var i = e[A];
    i.container instanceof uH && typeof i.container.value == "number" && i.container.value !== 0 && (r = i.container.value), i.listValue = P2(r, i.container.styles.listStyleType, !0), r += n ? -1 : 1;
  }
}, XB = function(t, e) {
  switch (e) {
    case 0:
      return Oi(t.topLeftBorderBox, t.topLeftPaddingBox, t.topRightBorderBox, t.topRightPaddingBox);
    case 1:
      return Oi(t.topRightBorderBox, t.topRightPaddingBox, t.bottomRightBorderBox, t.bottomRightPaddingBox);
    case 2:
      return Oi(t.bottomRightBorderBox, t.bottomRightPaddingBox, t.bottomLeftBorderBox, t.bottomLeftPaddingBox);
    default:
      return Oi(t.bottomLeftBorderBox, t.bottomLeftPaddingBox, t.topLeftBorderBox, t.topLeftPaddingBox);
  }
}, jf = function(t, e) {
  var r = [];
  return Di(t) ? r.push(t.subdivide(0.5, !1)) : r.push(t), Di(e) ? r.push(e.subdivide(0.5, !0)) : r.push(e), r;
}, Oi = function(t, e, r, n) {
  var A = [];
  return Di(t) ? A.push(t.subdivide(0.5, !1)) : A.push(t), Di(r) ? A.push(r.subdivide(0.5, !0)) : A.push(r), Di(n) ? A.push(n.subdivide(0.5, !0).reverse()) : A.push(n), Di(e) ? A.push(e.subdivide(0.5, !1).reverse()) : A.push(e), A;
}, KB = function(t) {
  var e = t.bounds, r = t.styles;
  return e.add(r.borderLeftWidth, r.borderTopWidth, -(r.borderRightWidth + r.borderLeftWidth), -(r.borderTopWidth + r.borderBottomWidth));
}, U3 = function(t) {
  var e = t.styles, r = t.bounds, n = Jr(e.paddingLeft, r.width), A = Jr(e.paddingRight, r.width), i = Jr(e.paddingTop, r.width), o = Jr(e.paddingBottom, r.width);
  return r.add(n + e.borderLeftWidth, i + e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth + n + A), -(e.borderTopWidth + e.borderBottomWidth + i + o));
}, c6 = function(t, e, r) {
  var n = function(c, l) {
    return c === 0 ? l.bounds : c === 2 ? U3(l) : KB(l);
  }(Ul(t.styles.backgroundOrigin, e), t), A = function(c, l) {
    return c === 0 ? l.bounds : c === 2 ? U3(l) : KB(l);
  }(Ul(t.styles.backgroundClip, e), t), i = Gce(Ul(t.styles.backgroundSize, e), r, n), o = i[0], s = i[1], a = Q0(Ul(t.styles.backgroundPosition, e), n.width - o, n.height - s);
  return [Rce(Ul(t.styles.backgroundRepeat, e), a, i, n, A), Math.round(n.left + a[0]), Math.round(n.top + a[1]), o, s];
}, Sl = function(t) {
  return Rr(t) && t.value === su.AUTO;
}, Lf = function(t) {
  return typeof t == "number";
}, Gce = function(t, e, r) {
  var n = e[0], A = e[1], i = e[2], o = t[0], s = t[1];
  if (!o) return [0, 0];
  if (Gn(o) && s && Gn(s)) return [Jr(o, r.width), Jr(s, r.height)];
  var a = Lf(i);
  if (Rr(o) && (o.value === su.CONTAIN || o.value === su.COVER)) return Lf(i) ? r.width / r.height < i != (o.value === su.COVER) ? [r.width, r.width / i] : [r.height * i, r.height] : [r.width, r.height];
  var c = Lf(n), l = Lf(A), u = c || l;
  if (Sl(o) && (!s || Sl(s))) return c && l ? [n, A] : a || u ? u && a ? [c ? n : A * i, l ? A : n / i] : [c ? n : r.width, l ? A : r.height] : [r.width, r.height];
  if (a) {
    var f = 0, d = 0;
    return Gn(o) ? f = Jr(o, r.width) : Gn(s) && (d = Jr(s, r.height)), Sl(o) ? f = d * i : s && !Sl(s) || (d = f / i), [f, d];
  }
  var g = null, m = null;
  if (Gn(o) ? g = Jr(o, r.width) : s && Gn(s) && (m = Jr(s, r.height)), g === null || s && !Sl(s) || (m = c && l ? g / n * A : r.height), m !== null && Sl(o) && (g = c && l ? m / A * n : r.width), g !== null && m !== null) return [g, m];
  throw new Error("Unable to calculate background-size for element");
}, Ul = function(t, e) {
  var r = t[e];
  return r === void 0 ? t[0] : r;
}, Rce = function(t, e, r, n, A) {
  var i = e[0], o = e[1], s = r[0], a = r[1];
  switch (t) {
    case 2:
      return [new ht(Math.round(n.left), Math.round(n.top + o)), new ht(Math.round(n.left + n.width), Math.round(n.top + o)), new ht(Math.round(n.left + n.width), Math.round(a + n.top + o)), new ht(Math.round(n.left), Math.round(a + n.top + o))];
    case 3:
      return [new ht(Math.round(n.left + i), Math.round(n.top)), new ht(Math.round(n.left + i + s), Math.round(n.top)), new ht(Math.round(n.left + i + s), Math.round(n.height + n.top)), new ht(Math.round(n.left + i), Math.round(n.height + n.top))];
    case 1:
      return [new ht(Math.round(n.left + i), Math.round(n.top + o)), new ht(Math.round(n.left + i + s), Math.round(n.top + o)), new ht(Math.round(n.left + i + s), Math.round(n.top + o + a)), new ht(Math.round(n.left + i), Math.round(n.top + o + a))];
    default:
      return [new ht(Math.round(A.left), Math.round(A.top)), new ht(Math.round(A.left + A.width), Math.round(A.top)), new ht(Math.round(A.left + A.width), Math.round(A.height + A.top)), new ht(Math.round(A.left), Math.round(A.height + A.top))];
  }
}, ZB = "Hidden Text", zce = function() {
  function t(e) {
    this._data = {}, this._document = e;
  }
  return t.prototype.parseMetrics = function(e, r) {
    var n = this._document.createElement("div"), A = this._document.createElement("img"), i = this._document.createElement("span"), o = this._document.body;
    n.style.visibility = "hidden", n.style.fontFamily = e, n.style.fontSize = r, n.style.margin = "0", n.style.padding = "0", n.style.whiteSpace = "nowrap", o.appendChild(n), A.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", A.width = 1, A.height = 1, A.style.margin = "0", A.style.padding = "0", A.style.verticalAlign = "baseline", i.style.fontFamily = e, i.style.fontSize = r, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(ZB)), n.appendChild(i), n.appendChild(A);
    var s = A.offsetTop - i.offsetTop + 2;
    n.removeChild(i), n.appendChild(this._document.createTextNode(ZB)), n.style.lineHeight = "normal", A.style.verticalAlign = "super";
    var a = A.offsetTop - n.offsetTop + 2;
    return o.removeChild(n), { baseline: s, middle: a };
  }, t.prototype.getMetrics = function(e, r) {
    var n = e + " " + r;
    return this._data[n] === void 0 && (this._data[n] = this.parseMetrics(e, r)), this._data[n];
  }, t;
}(), PH = function(t, e) {
  this.context = t, this.options = e;
}, Yce = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A._activeEffects = [], A.canvas = n.canvas ? n.canvas : document.createElement("canvas"), A.ctx = A.canvas.getContext("2d"), n.canvas || (A.canvas.width = Math.floor(n.width * n.scale), A.canvas.height = Math.floor(n.height * n.scale), A.canvas.style.width = n.width + "px", A.canvas.style.height = n.height + "px"), A.fontMetrics = new zce(document), A.ctx.scale(A.options.scale, A.options.scale), A.ctx.translate(-n.x, -n.y), A.ctx.textBaseline = "bottom", A._activeEffects = [], A.context.logger.debug("Canvas renderer initialized (" + n.width + "x" + n.height + ") with scale " + n.scale), A;
  }
  return yo(e, t), e.prototype.applyEffects = function(r) {
    for (var n = this; this._activeEffects.length; ) this.popEffect();
    r.forEach(function(A) {
      return n.applyEffect(A);
    });
  }, e.prototype.applyEffect = function(r) {
    this.ctx.save(), function(n) {
      return n.type === 2;
    }(r) && (this.ctx.globalAlpha = r.opacity), function(n) {
      return n.type === 0;
    }(r) && (this.ctx.translate(r.offsetX, r.offsetY), this.ctx.transform(r.matrix[0], r.matrix[1], r.matrix[2], r.matrix[3], r.matrix[4], r.matrix[5]), this.ctx.translate(-r.offsetX, -r.offsetY)), EH(r) && (this.path(r.path), this.ctx.clip()), this._activeEffects.push(r);
  }, e.prototype.popEffect = function() {
    this._activeEffects.pop(), this.ctx.restore();
  }, e.prototype.renderStack = function(r) {
    return GA(this, void 0, void 0, function() {
      return IA(this, function(n) {
        switch (n.label) {
          case 0:
            return r.element.container.styles.isVisible() ? [4, this.renderStackContent(r)] : [3, 2];
          case 1:
            n.sent(), n.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, e.prototype.renderNode = function(r) {
    return GA(this, void 0, void 0, function() {
      return IA(this, function(n) {
        switch (n.label) {
          case 0:
            return Zn(r.container.flags, 16), r.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(r)] : [3, 3];
          case 1:
            return n.sent(), [4, this.renderNodeContent(r)];
          case 2:
            n.sent(), n.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.renderTextWithLetterSpacing = function(r, n, A) {
    var i = this;
    n === 0 ? this.ctx.fillText(r.text, r.bounds.left, r.bounds.top + A) : Wv(r.text).reduce(function(o, s) {
      return i.ctx.fillText(s, o, r.bounds.top + A), o + i.ctx.measureText(s).width;
    }, r.bounds.left);
  }, e.prototype.createFontStyle = function(r) {
    var n = r.fontVariant.filter(function(o) {
      return o === "normal" || o === "small-caps";
    }).join(""), A = Zce(r.fontFamily).join(", "), i = S2(r.fontSize) ? "" + r.fontSize.number + r.fontSize.unit : r.fontSize.number + "px";
    return [[r.fontStyle, n, r.fontWeight, i, A].join(" "), A, i];
  }, e.prototype.renderTextNode = function(r, n) {
    return GA(this, void 0, void 0, function() {
      var A, i, o, s, a, c, l, u, f = this;
      return IA(this, function(d) {
        return A = this.createFontStyle(n), i = A[0], o = A[1], s = A[2], this.ctx.font = i, this.ctx.direction = n.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", a = this.fontMetrics.getMetrics(o, s), c = a.baseline, l = a.middle, u = n.paintOrder, r.textBounds.forEach(function(g) {
          u.forEach(function(m) {
            switch (m) {
              case 0:
                f.ctx.fillStyle = AA(n.color), f.renderTextWithLetterSpacing(g, n.letterSpacing, c);
                var p = n.textShadow;
                p.length && g.text.trim().length && (p.slice(0).reverse().forEach(function(v) {
                  f.ctx.shadowColor = AA(v.color), f.ctx.shadowOffsetX = v.offsetX.number * f.options.scale, f.ctx.shadowOffsetY = v.offsetY.number * f.options.scale, f.ctx.shadowBlur = v.blur.number, f.renderTextWithLetterSpacing(g, n.letterSpacing, c);
                }), f.ctx.shadowColor = "", f.ctx.shadowOffsetX = 0, f.ctx.shadowOffsetY = 0, f.ctx.shadowBlur = 0), n.textDecorationLine.length && (f.ctx.fillStyle = AA(n.textDecorationColor || n.color), n.textDecorationLine.forEach(function(v) {
                  switch (v) {
                    case 1:
                      f.ctx.fillRect(g.bounds.left, Math.round(g.bounds.top + c), g.bounds.width, 1);
                      break;
                    case 2:
                      f.ctx.fillRect(g.bounds.left, Math.round(g.bounds.top), g.bounds.width, 1);
                      break;
                    case 3:
                      f.ctx.fillRect(g.bounds.left, Math.ceil(g.bounds.top + l), g.bounds.width, 1);
                  }
                }));
                break;
              case 1:
                n.webkitTextStrokeWidth && g.text.trim().length && (f.ctx.strokeStyle = AA(n.webkitTextStrokeColor), f.ctx.lineWidth = n.webkitTextStrokeWidth, f.ctx.lineJoin = window.chrome ? "miter" : "round", f.ctx.strokeText(g.text, g.bounds.left, g.bounds.top + c)), f.ctx.strokeStyle = "", f.ctx.lineWidth = 0, f.ctx.lineJoin = "miter";
            }
          });
        }), [2];
      });
    });
  }, e.prototype.renderReplacedElement = function(r, n, A) {
    if (A && r.intrinsicWidth > 0 && r.intrinsicHeight > 0) {
      var i = U3(r), o = Q3(n);
      this.path(o), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(A, 0, 0, r.intrinsicWidth, r.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
    }
  }, e.prototype.renderNodeContent = function(r) {
    return GA(this, void 0, void 0, function() {
      var n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w, B;
      return IA(this, function(y) {
        switch (y.label) {
          case 0:
            this.applyEffects(r.getEffects(4)), n = r.container, A = r.curves, i = n.styles, o = 0, s = n.textNodes, y.label = 1;
          case 1:
            return o < s.length ? (a = s[o], [4, this.renderTextNode(a, i)]) : [3, 4];
          case 2:
            y.sent(), y.label = 3;
          case 3:
            return o++, [3, 1];
          case 4:
            if (!(n instanceof aH)) return [3, 8];
            y.label = 5;
          case 5:
            return y.trys.push([5, 7, , 8]), [4, this.context.cache.match(n.src)];
          case 6:
            return v = y.sent(), this.renderReplacedElement(n, A, v), [3, 8];
          case 7:
            return y.sent(), this.context.logger.error("Error loading image " + n.src), [3, 8];
          case 8:
            if (n instanceof cH && this.renderReplacedElement(n, A, n.canvas), !(n instanceof lH)) return [3, 12];
            y.label = 9;
          case 9:
            return y.trys.push([9, 11, , 12]), [4, this.context.cache.match(n.svg)];
          case 10:
            return v = y.sent(), this.renderReplacedElement(n, A, v), [3, 12];
          case 11:
            return y.sent(), this.context.logger.error("Error loading svg " + n.svg.substring(0, 255)), [3, 12];
          case 12:
            return n instanceof hH && n.tree ? [4, new e(this.context, { scale: this.options.scale, backgroundColor: n.backgroundColor, x: 0, y: 0, width: n.width, height: n.height }).render(n.tree)] : [3, 14];
          case 13:
            c = y.sent(), n.width && n.height && this.ctx.drawImage(c, 0, 0, n.width, n.height, n.bounds.left, n.bounds.top, n.bounds.width, n.bounds.height), y.label = 14;
          case 14:
            if (n instanceof Xv && (l = Math.min(n.bounds.width, n.bounds.height), n.type === F3 ? n.checked && (this.ctx.save(), this.path([new ht(n.bounds.left + 0.39363 * l, n.bounds.top + 0.79 * l), new ht(n.bounds.left + 0.16 * l, n.bounds.top + 0.5549 * l), new ht(n.bounds.left + 0.27347 * l, n.bounds.top + 0.44071 * l), new ht(n.bounds.left + 0.39694 * l, n.bounds.top + 0.5649 * l), new ht(n.bounds.left + 0.72983 * l, n.bounds.top + 0.23 * l), new ht(n.bounds.left + 0.84 * l, n.bounds.top + 0.34085 * l), new ht(n.bounds.left + 0.39363 * l, n.bounds.top + 0.79 * l)]), this.ctx.fillStyle = AA(DB), this.ctx.fill(), this.ctx.restore()) : n.type === T3 && n.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(n.bounds.left + l / 2, n.bounds.top + l / 2, l / 4, 0, 2 * Math.PI, !0), this.ctx.fillStyle = AA(DB), this.ctx.fill(), this.ctx.restore())), Vce(n) && n.value.length) {
              switch (u = this.createFontStyle(i), w = u[0], f = u[1], d = this.fontMetrics.getMetrics(w, f).baseline, this.ctx.font = w, this.ctx.fillStyle = AA(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = Xce(n.styles.textAlign), B = U3(n), g = 0, n.styles.textAlign) {
                case 1:
                  g += B.width / 2;
                  break;
                case 2:
                  g += B.width;
              }
              m = B.add(g, 0, 0, -B.height / 2 + 1), this.ctx.save(), this.path([new ht(B.left, B.top), new ht(B.left + B.width, B.top), new ht(B.left + B.width, B.top + B.height), new ht(B.left, B.top + B.height)]), this.ctx.clip(), this.renderTextWithLetterSpacing(new i2(n.value, m), i.letterSpacing, d), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
            }
            if (!Zn(n.styles.display, 2048)) return [3, 20];
            if (n.styles.listStyleImage === null) return [3, 19];
            if ((p = n.styles.listStyleImage).type !== 0) return [3, 18];
            v = void 0, C = p.url, y.label = 15;
          case 15:
            return y.trys.push([15, 17, , 18]), [4, this.context.cache.match(C)];
          case 16:
            return v = y.sent(), this.ctx.drawImage(v, n.bounds.left - (v.width + 10), n.bounds.top), [3, 18];
          case 17:
            return y.sent(), this.context.logger.error("Error loading list-style-image " + C), [3, 18];
          case 18:
            return [3, 20];
          case 19:
            r.listValue && n.styles.listStyleType !== -1 && (w = this.createFontStyle(i)[0], this.ctx.font = w, this.ctx.fillStyle = AA(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", B = new Ds(n.bounds.left, n.bounds.top + Jr(n.styles.paddingTop, n.bounds.width), n.bounds.width, BB(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new i2(r.listValue, B), i.letterSpacing, BB(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), y.label = 20;
          case 20:
            return [2];
        }
      });
    });
  }, e.prototype.renderStackContent = function(r) {
    return GA(this, void 0, void 0, function() {
      var n, A, i, o, s, a, c, l, u, f, d, g, m, p, v;
      return IA(this, function(C) {
        switch (C.label) {
          case 0:
            return Zn(r.element.container.flags, 16), [4, this.renderNodeBackgroundAndBorders(r.element)];
          case 1:
            C.sent(), n = 0, A = r.negativeZIndex, C.label = 2;
          case 2:
            return n < A.length ? (v = A[n], [4, this.renderStack(v)]) : [3, 5];
          case 3:
            C.sent(), C.label = 4;
          case 4:
            return n++, [3, 2];
          case 5:
            return [4, this.renderNodeContent(r.element)];
          case 6:
            C.sent(), i = 0, o = r.nonInlineLevel, C.label = 7;
          case 7:
            return i < o.length ? (v = o[i], [4, this.renderNode(v)]) : [3, 10];
          case 8:
            C.sent(), C.label = 9;
          case 9:
            return i++, [3, 7];
          case 10:
            s = 0, a = r.nonPositionedFloats, C.label = 11;
          case 11:
            return s < a.length ? (v = a[s], [4, this.renderStack(v)]) : [3, 14];
          case 12:
            C.sent(), C.label = 13;
          case 13:
            return s++, [3, 11];
          case 14:
            c = 0, l = r.nonPositionedInlineLevel, C.label = 15;
          case 15:
            return c < l.length ? (v = l[c], [4, this.renderStack(v)]) : [3, 18];
          case 16:
            C.sent(), C.label = 17;
          case 17:
            return c++, [3, 15];
          case 18:
            u = 0, f = r.inlineLevel, C.label = 19;
          case 19:
            return u < f.length ? (v = f[u], [4, this.renderNode(v)]) : [3, 22];
          case 20:
            C.sent(), C.label = 21;
          case 21:
            return u++, [3, 19];
          case 22:
            d = 0, g = r.zeroOrAutoZIndexOrTransformedOrOpacity, C.label = 23;
          case 23:
            return d < g.length ? (v = g[d], [4, this.renderStack(v)]) : [3, 26];
          case 24:
            C.sent(), C.label = 25;
          case 25:
            return d++, [3, 23];
          case 26:
            m = 0, p = r.positiveZIndex, C.label = 27;
          case 27:
            return m < p.length ? (v = p[m], [4, this.renderStack(v)]) : [3, 30];
          case 28:
            C.sent(), C.label = 29;
          case 29:
            return m++, [3, 27];
          case 30:
            return [2];
        }
      });
    });
  }, e.prototype.mask = function(r) {
    this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(r.slice(0).reverse()), this.ctx.closePath();
  }, e.prototype.path = function(r) {
    this.ctx.beginPath(), this.formatPath(r), this.ctx.closePath();
  }, e.prototype.formatPath = function(r) {
    var n = this;
    r.forEach(function(A, i) {
      var o = Di(A) ? A.start : A;
      i === 0 ? n.ctx.moveTo(o.x, o.y) : n.ctx.lineTo(o.x, o.y), Di(A) && n.ctx.bezierCurveTo(A.startControl.x, A.startControl.y, A.endControl.x, A.endControl.y, A.end.x, A.end.y);
    });
  }, e.prototype.renderRepeat = function(r, n, A, i) {
    this.path(r), this.ctx.fillStyle = n, this.ctx.translate(A, i), this.ctx.fill(), this.ctx.translate(-A, -i);
  }, e.prototype.resizeImage = function(r, n, A) {
    var i;
    if (r.width === n && r.height === A) return r;
    var o = ((i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document).createElement("canvas");
    return o.width = Math.max(1, n), o.height = Math.max(1, A), o.getContext("2d").drawImage(r, 0, 0, r.width, r.height, 0, 0, n, A), o;
  }, e.prototype.renderBackgroundImage = function(r) {
    return GA(this, void 0, void 0, function() {
      var n, A, i, o, s, a;
      return IA(this, function(c) {
        switch (c.label) {
          case 0:
            n = r.styles.backgroundImage.length - 1, A = function(l) {
              var u, f, d, g, m, p, v, C, w, B, y, b, q, E, x, M, O, I, S, P, H, F, T, U, D, Q, Y, j, Z, W, R;
              return IA(this, function(K) {
                switch (K.label) {
                  case 0:
                    if (l.type !== 0) return [3, 5];
                    u = void 0, f = l.url, K.label = 1;
                  case 1:
                    return K.trys.push([1, 3, , 4]), [4, i.context.cache.match(f)];
                  case 2:
                    return u = K.sent(), [3, 4];
                  case 3:
                    return K.sent(), i.context.logger.error("Error loading background-image " + f), [3, 4];
                  case 4:
                    return u && (d = c6(r, n, [u.width, u.height, u.width / u.height]), M = d[0], F = d[1], T = d[2], S = d[3], P = d[4], E = i.ctx.createPattern(i.resizeImage(u, S, P), "repeat"), i.renderRepeat(M, E, F, T)), [3, 6];
                  case 5:
                    l.type === 1 ? (g = c6(r, n, [null, null, null]), M = g[0], F = g[1], T = g[2], S = g[3], P = g[4], m = Ise(l.angle, S, P), p = m[0], v = m[1], C = m[2], w = m[3], B = m[4], (y = document.createElement("canvas")).width = S, y.height = P, b = y.getContext("2d"), q = b.createLinearGradient(v, w, C, B), wB(l.stops, p).forEach(function(L) {
                      return q.addColorStop(L.stop, AA(L.color));
                    }), b.fillStyle = q, b.fillRect(0, 0, S, P), S > 0 && P > 0 && (E = i.ctx.createPattern(y, "repeat"), i.renderRepeat(M, E, F, T))) : function(L) {
                      return L.type === 2;
                    }(l) && (x = c6(r, n, [null, null, null]), M = x[0], O = x[1], I = x[2], S = x[3], P = x[4], H = l.position.length === 0 ? [Yv] : l.position, F = Jr(H[0], S), T = Jr(H[H.length - 1], P), U = function(L, G, V, _, J) {
                      var X = 0, ne = 0;
                      switch (L.size) {
                        case 0:
                          L.shape === 0 ? X = ne = Math.min(Math.abs(G), Math.abs(G - _), Math.abs(V), Math.abs(V - J)) : L.shape === 1 && (X = Math.min(Math.abs(G), Math.abs(G - _)), ne = Math.min(Math.abs(V), Math.abs(V - J)));
                          break;
                        case 2:
                          if (L.shape === 0) X = ne = Math.min(to(G, V), to(G, V - J), to(G - _, V), to(G - _, V - J));
                          else if (L.shape === 1) {
                            var ee = Math.min(Math.abs(V), Math.abs(V - J)) / Math.min(Math.abs(G), Math.abs(G - _)), $ = bB(_, J, G, V, !0), te = $[0], ae = $[1];
                            ne = ee * (X = to(te - G, (ae - V) / ee));
                          }
                          break;
                        case 1:
                          L.shape === 0 ? X = ne = Math.max(Math.abs(G), Math.abs(G - _), Math.abs(V), Math.abs(V - J)) : L.shape === 1 && (X = Math.max(Math.abs(G), Math.abs(G - _)), ne = Math.max(Math.abs(V), Math.abs(V - J)));
                          break;
                        case 3:
                          if (L.shape === 0) X = ne = Math.max(to(G, V), to(G, V - J), to(G - _, V), to(G - _, V - J));
                          else if (L.shape === 1) {
                            ee = Math.max(Math.abs(V), Math.abs(V - J)) / Math.max(Math.abs(G), Math.abs(G - _));
                            var se = bB(_, J, G, V, !1);
                            te = se[0], ae = se[1], ne = ee * (X = to(te - G, (ae - V) / ee));
                          }
                      }
                      return Array.isArray(L.size) && (X = Jr(L.size[0], _), ne = L.size.length === 2 ? Jr(L.size[1], J) : X), [X, ne];
                    }(l, F, T, S, P), D = U[0], Q = U[1], D > 0 && Q > 0 && (Y = i.ctx.createRadialGradient(O + F, I + T, 0, O + F, I + T, D), wB(l.stops, 2 * D).forEach(function(L) {
                      return Y.addColorStop(L.stop, AA(L.color));
                    }), i.path(M), i.ctx.fillStyle = Y, D !== Q ? (j = r.bounds.left + 0.5 * r.bounds.width, Z = r.bounds.top + 0.5 * r.bounds.height, R = 1 / (W = Q / D), i.ctx.save(), i.ctx.translate(j, Z), i.ctx.transform(1, 0, 0, W, 0, 0), i.ctx.translate(-j, -Z), i.ctx.fillRect(O, R * (I - Z) + Z, S, P * R), i.ctx.restore()) : i.ctx.fill())), K.label = 6;
                  case 6:
                    return n--, [2];
                }
              });
            }, i = this, o = 0, s = r.styles.backgroundImage.slice(0).reverse(), c.label = 1;
          case 1:
            return o < s.length ? (a = s[o], [5, A(a)]) : [3, 4];
          case 2:
            c.sent(), c.label = 3;
          case 3:
            return o++, [3, 1];
          case 4:
            return [2];
        }
      });
    });
  }, e.prototype.renderSolidBorder = function(r, n, A) {
    return GA(this, void 0, void 0, function() {
      return IA(this, function(i) {
        return this.path(XB(A, n)), this.ctx.fillStyle = AA(r), this.ctx.fill(), [2];
      });
    });
  }, e.prototype.renderDoubleBorder = function(r, n, A, i) {
    return GA(this, void 0, void 0, function() {
      var o, s;
      return IA(this, function(a) {
        switch (a.label) {
          case 0:
            return n < 3 ? [4, this.renderSolidBorder(r, A, i)] : [3, 2];
          case 1:
            return a.sent(), [2];
          case 2:
            return o = function(c, l) {
              switch (l) {
                case 0:
                  return Oi(c.topLeftBorderBox, c.topLeftBorderDoubleOuterBox, c.topRightBorderBox, c.topRightBorderDoubleOuterBox);
                case 1:
                  return Oi(c.topRightBorderBox, c.topRightBorderDoubleOuterBox, c.bottomRightBorderBox, c.bottomRightBorderDoubleOuterBox);
                case 2:
                  return Oi(c.bottomRightBorderBox, c.bottomRightBorderDoubleOuterBox, c.bottomLeftBorderBox, c.bottomLeftBorderDoubleOuterBox);
                default:
                  return Oi(c.bottomLeftBorderBox, c.bottomLeftBorderDoubleOuterBox, c.topLeftBorderBox, c.topLeftBorderDoubleOuterBox);
              }
            }(i, A), this.path(o), this.ctx.fillStyle = AA(r), this.ctx.fill(), s = function(c, l) {
              switch (l) {
                case 0:
                  return Oi(c.topLeftBorderDoubleInnerBox, c.topLeftPaddingBox, c.topRightBorderDoubleInnerBox, c.topRightPaddingBox);
                case 1:
                  return Oi(c.topRightBorderDoubleInnerBox, c.topRightPaddingBox, c.bottomRightBorderDoubleInnerBox, c.bottomRightPaddingBox);
                case 2:
                  return Oi(c.bottomRightBorderDoubleInnerBox, c.bottomRightPaddingBox, c.bottomLeftBorderDoubleInnerBox, c.bottomLeftPaddingBox);
                default:
                  return Oi(c.bottomLeftBorderDoubleInnerBox, c.bottomLeftPaddingBox, c.topLeftBorderDoubleInnerBox, c.topLeftPaddingBox);
              }
            }(i, A), this.path(s), this.ctx.fill(), [2];
        }
      });
    });
  }, e.prototype.renderNodeBackgroundAndBorders = function(r) {
    return GA(this, void 0, void 0, function() {
      var n, A, i, o, s, a, c, l, u = this;
      return IA(this, function(f) {
        switch (f.label) {
          case 0:
            return this.applyEffects(r.getEffects(2)), n = r.container.styles, A = !Oa(n.backgroundColor) || n.backgroundImage.length, i = [{ style: n.borderTopStyle, color: n.borderTopColor, width: n.borderTopWidth }, { style: n.borderRightStyle, color: n.borderRightColor, width: n.borderRightWidth }, { style: n.borderBottomStyle, color: n.borderBottomColor, width: n.borderBottomWidth }, { style: n.borderLeftStyle, color: n.borderLeftColor, width: n.borderLeftWidth }], o = Wce(Ul(n.backgroundClip, 0), r.curves), A || n.boxShadow.length ? (this.ctx.save(), this.path(o), this.ctx.clip(), Oa(n.backgroundColor) || (this.ctx.fillStyle = AA(n.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(r.container)]) : [3, 2];
          case 1:
            f.sent(), this.ctx.restore(), n.boxShadow.slice(0).reverse().forEach(function(d) {
              u.ctx.save();
              var g, m, p, v, C, w = D3(r.curves), B = d.inset ? 0 : 1e4, y = (g = w, m = -B + (d.inset ? 1 : -1) * d.spread.number, p = (d.inset ? 1 : -1) * d.spread.number, v = d.spread.number * (d.inset ? -2 : 2), C = d.spread.number * (d.inset ? -2 : 2), g.map(function(b, q) {
                switch (q) {
                  case 0:
                    return b.add(m, p);
                  case 1:
                    return b.add(m + v, p);
                  case 2:
                    return b.add(m + v, p + C);
                  case 3:
                    return b.add(m, p + C);
                }
                return b;
              }));
              d.inset ? (u.path(w), u.ctx.clip(), u.mask(y)) : (u.mask(w), u.ctx.clip(), u.path(y)), u.ctx.shadowOffsetX = d.offsetX.number + B, u.ctx.shadowOffsetY = d.offsetY.number, u.ctx.shadowColor = AA(d.color), u.ctx.shadowBlur = d.blur.number, u.ctx.fillStyle = d.inset ? AA(d.color) : "rgba(0,0,0,1)", u.ctx.fill(), u.ctx.restore();
            }), f.label = 2;
          case 2:
            s = 0, a = 0, c = i, f.label = 3;
          case 3:
            return a < c.length ? (l = c[a]).style !== 0 && !Oa(l.color) && l.width > 0 ? l.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(l.color, l.width, s, r.curves, 2)] : [3, 11] : [3, 13];
          case 4:
            return f.sent(), [3, 11];
          case 5:
            return l.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(l.color, l.width, s, r.curves, 3)];
          case 6:
            return f.sent(), [3, 11];
          case 7:
            return l.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(l.color, l.width, s, r.curves)];
          case 8:
            return f.sent(), [3, 11];
          case 9:
            return [4, this.renderSolidBorder(l.color, s, r.curves)];
          case 10:
            f.sent(), f.label = 11;
          case 11:
            s++, f.label = 12;
          case 12:
            return a++, [3, 3];
          case 13:
            return [2];
        }
      });
    });
  }, e.prototype.renderDashedDottedBorder = function(r, n, A, i, o) {
    return GA(this, void 0, void 0, function() {
      var s, a, c, l, u, f, d, g, m, p, v, C, w, B, y, b;
      return IA(this, function(q) {
        return this.ctx.save(), s = function(E, x) {
          switch (x) {
            case 0:
              return jf(E.topLeftBorderStroke, E.topRightBorderStroke);
            case 1:
              return jf(E.topRightBorderStroke, E.bottomRightBorderStroke);
            case 2:
              return jf(E.bottomRightBorderStroke, E.bottomLeftBorderStroke);
            default:
              return jf(E.bottomLeftBorderStroke, E.topLeftBorderStroke);
          }
        }(i, A), a = XB(i, A), o === 2 && (this.path(a), this.ctx.clip()), Di(a[0]) ? (c = a[0].start.x, l = a[0].start.y) : (c = a[0].x, l = a[0].y), Di(a[1]) ? (u = a[1].end.x, f = a[1].end.y) : (u = a[1].x, f = a[1].y), d = Math.abs(A === 0 || A === 2 ? c - u : l - f), this.ctx.beginPath(), o === 3 ? this.formatPath(s) : this.formatPath(a.slice(0, 2)), g = n < 3 ? 3 * n : 2 * n, m = n < 3 ? 2 * n : n, o === 3 && (g = n, m = n), p = !0, d <= 2 * g ? p = !1 : d <= 2 * g + m ? (g *= v = d / (2 * g + m), m *= v) : (C = Math.floor((d + m) / (g + m)), w = (d - C * g) / (C - 1), m = (B = (d - (C + 1) * g) / C) <= 0 || Math.abs(m - w) < Math.abs(m - B) ? w : B), p && (o === 3 ? this.ctx.setLineDash([0, g + m]) : this.ctx.setLineDash([g, m])), o === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = n) : this.ctx.lineWidth = 2 * n + 1.1, this.ctx.strokeStyle = AA(r), this.ctx.stroke(), this.ctx.setLineDash([]), o === 2 && (Di(a[0]) && (y = a[3], b = a[0], this.ctx.beginPath(), this.formatPath([new ht(y.end.x, y.end.y), new ht(b.start.x, b.start.y)]), this.ctx.stroke()), Di(a[1]) && (y = a[1], b = a[2], this.ctx.beginPath(), this.formatPath([new ht(y.end.x, y.end.y), new ht(b.start.x, b.start.y)]), this.ctx.stroke())), this.ctx.restore(), [2];
      });
    });
  }, e.prototype.render = function(r) {
    return GA(this, void 0, void 0, function() {
      var n;
      return IA(this, function(A) {
        switch (A.label) {
          case 0:
            return this.options.backgroundColor && (this.ctx.fillStyle = AA(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), i = new IH(r, null), o = new xH(i), S7(i, o, o, s = []), SH(i.container, s), n = o, [4, this.renderStack(n)];
          case 1:
            return A.sent(), this.applyEffects([]), [2, this.canvas];
        }
        var i, o, s;
      });
    });
  }, e;
}(PH), Vce = function(t) {
  return t instanceof fH || t instanceof dH || t instanceof Xv && t.type !== T3 && t.type !== F3;
}, Wce = function(t, e) {
  switch (t) {
    case 0:
      return D3(e);
    case 2:
      return function(r) {
        return [r.topLeftContentBox, r.topRightContentBox, r.bottomRightContentBox, r.bottomLeftContentBox];
      }(e);
    default:
      return Q3(e);
  }
}, Xce = function(t) {
  switch (t) {
    case 1:
      return "center";
    case 2:
      return "right";
    default:
      return "left";
  }
}, Kce = ["-apple-system", "system-ui"], Zce = function(t) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? t.filter(function(e) {
    return Kce.indexOf(e) === -1;
  }) : t;
}, Jce = function(t) {
  function e(r, n) {
    var A = t.call(this, r, n) || this;
    return A.canvas = n.canvas ? n.canvas : document.createElement("canvas"), A.ctx = A.canvas.getContext("2d"), A.options = n, A.canvas.width = Math.floor(n.width * n.scale), A.canvas.height = Math.floor(n.height * n.scale), A.canvas.style.width = n.width + "px", A.canvas.style.height = n.height + "px", A.ctx.scale(A.options.scale, A.options.scale), A.ctx.translate(-n.x, -n.y), A.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + n.width + "x" + n.height + " at " + n.x + "," + n.y + ") with scale " + n.scale), A;
  }
  return yo(e, t), e.prototype.render = function(r) {
    return GA(this, void 0, void 0, function() {
      var n, A;
      return IA(this, function(i) {
        switch (i.label) {
          case 0:
            return n = w7(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, r), [4, _ce(n)];
          case 1:
            return A = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = AA(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(A, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
        }
      });
    });
  }, e;
}(PH), _ce = function(t) {
  return new Promise(function(e, r) {
    var n = new Image();
    n.onload = function() {
      e(n);
    }, n.onerror = r, n.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(t));
  });
}, $ce = function() {
  function t(e) {
    var r = e.id, n = e.enabled;
    this.id = r, this.enabled = n, this.start = Date.now();
  }
  return t.prototype.debug = function() {
    for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
    this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, bf([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
  }, t.prototype.getTime = function() {
    return Date.now() - this.start;
  }, t.prototype.info = function() {
    for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
    this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, bf([this.id, this.getTime() + "ms"], e));
  }, t.prototype.warn = function() {
    for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
    this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, bf([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
  }, t.prototype.error = function() {
    for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
    this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, bf([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
  }, t.instances = {}, t;
}(), ele = function() {
  function t(e, r) {
    var n;
    this.windowBounds = r, this.instanceName = "#" + t.instanceCount++, this.logger = new $ce({ id: this.instanceName, enabled: e.logging }), this.cache = (n = e.cache) !== null && n !== void 0 ? n : new Fce(this, e);
  }
  return t.instanceCount = 1, t;
}();
typeof window < "u" && BH.setContext(window);
var tle = function(t, e) {
  return GA(void 0, void 0, void 0, function() {
    var r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w, B, y, b, q, E, x, M, O, I, S, P, H, F, T, U, D, Q, Y, j, Z;
    return IA(this, function(W) {
      switch (W.label) {
        case 0:
          if (!t || typeof t != "object") return [2, Promise.reject("Invalid element provided as first argument")];
          if (!(r = t.ownerDocument)) throw new Error("Element is not attached to a Document");
          if (!(n = r.defaultView)) throw new Error("Document is not attached to a Window");
          return A = { allowTaint: (q = e.allowTaint) !== null && q !== void 0 && q, imageTimeout: (E = e.imageTimeout) !== null && E !== void 0 ? E : 15e3, proxy: e.proxy, useCORS: (x = e.useCORS) !== null && x !== void 0 && x }, i = l7({ logging: (M = e.logging) === null || M === void 0 || M, cache: e.cache }, A), o = { windowWidth: (O = e.windowWidth) !== null && O !== void 0 ? O : n.innerWidth, windowHeight: (I = e.windowHeight) !== null && I !== void 0 ? I : n.innerHeight, scrollX: (S = e.scrollX) !== null && S !== void 0 ? S : n.pageXOffset, scrollY: (P = e.scrollY) !== null && P !== void 0 ? P : n.pageYOffset }, s = new Ds(o.scrollX, o.scrollY, o.windowWidth, o.windowHeight), a = new ele(i, s), c = (H = e.foreignObjectRendering) !== null && H !== void 0 && H, l = { allowTaint: (F = e.allowTaint) !== null && F !== void 0 && F, onclone: e.onclone, ignoreElements: e.ignoreElements, inlineImages: c, copyStyles: c }, a.logger.debug("Starting document clone with size " + s.width + "x" + s.height + " scrolled to " + -s.left + "," + -s.top), u = new YB(a, t, l), (f = u.clonedReferenceElement) ? [4, u.toIFrame(r, s)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return d = W.sent(), g = Kv(f) || f.tagName === "HTML" ? function(R) {
            var K = R.body, L = R.documentElement;
            if (!K || !L) throw new Error("Unable to get document size");
            var G = Math.max(Math.max(K.scrollWidth, L.scrollWidth), Math.max(K.offsetWidth, L.offsetWidth), Math.max(K.clientWidth, L.clientWidth)), V = Math.max(Math.max(K.scrollHeight, L.scrollHeight), Math.max(K.offsetHeight, L.offsetHeight), Math.max(K.clientHeight, L.clientHeight));
            return new Ds(0, 0, G, V);
          }(f.ownerDocument) : h4(a, f), m = g.width, p = g.height, v = g.left, C = g.top, w = rle(a, f, e.backgroundColor), B = { canvas: e.canvas, backgroundColor: w, scale: (U = (T = e.scale) !== null && T !== void 0 ? T : n.devicePixelRatio) !== null && U !== void 0 ? U : 1, x: ((D = e.x) !== null && D !== void 0 ? D : 0) + v, y: ((Q = e.y) !== null && Q !== void 0 ? Q : 0) + C, width: (Y = e.width) !== null && Y !== void 0 ? Y : Math.ceil(m), height: (j = e.height) !== null && j !== void 0 ? j : Math.ceil(p) }, c ? (a.logger.debug("Document cloned, using foreign object rendering"), [4, new Jce(a, B).render(f)]) : [3, 3];
        case 2:
          return y = W.sent(), [3, 5];
        case 3:
          return a.logger.debug("Document cloned, element located at " + v + "," + C + " with size " + m + "x" + p + " using computed rendering"), a.logger.debug("Starting DOM parsing"), b = gH(a, f), w === b.styles.backgroundColor && (b.styles.backgroundColor = bs.TRANSPARENT), a.logger.debug("Starting renderer for element at " + B.x + "," + B.y + " with size " + B.width + "x" + B.height), [4, new Yce(a, B).render(b)];
        case 4:
          y = W.sent(), W.label = 5;
        case 5:
          return ((Z = e.removeContainer) === null || Z === void 0 || Z) && (YB.destroy(d) || a.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), a.logger.debug("Finished rendering"), [2, y];
      }
    });
  });
}, rle = function(t, e, r) {
  var n = e.ownerDocument, A = n.documentElement ? r2(t, getComputedStyle(n.documentElement).backgroundColor) : bs.TRANSPARENT, i = n.body ? r2(t, getComputedStyle(n.body).backgroundColor) : bs.TRANSPARENT, o = typeof r == "string" ? r2(t, r) : r === null ? bs.TRANSPARENT : 4294967295;
  return e === n.documentElement ? Oa(A) ? Oa(i) ? o : i : A : o;
};
(function(t, e) {
  e === void 0 && (e = {});
  var r = e.insertAt;
  if (typeof document < "u") {
    var n = document.head || document.getElementsByTagName("head")[0], A = document.createElement("style");
    A.type = "text/css", r === "top" && n.firstChild ? n.insertBefore(A, n.firstChild) : n.appendChild(A), A.styleSheet ? A.styleSheet.cssText = t : A.appendChild(document.createTextNode(t));
  }
})(`body {
  padding: 0;
  overflow-x: hidden; }

.crosshairs {
  position: fixed;
  width: 100%;
  z-index: 2147483645; }

.crosshairs.hidden {
  display: none; }

.crosshairs::before,
.crosshairs::after {
  content: "";
  position: absolute; }

.crosshairs::before {
  height: 24px;
  width: 2px;
  background: #000;
  top: -11px; }

.crosshairs::after {
  width: 24px;
  height: 2px;
  background: #000;
  left: -11px; }

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); }

.overlay.highlighting {
  background: none;
  border-color: rgba(0, 0, 0, 0.5);
  border-style: solid; }

.crosshairs,
.crosshairs:before,
.crosshairs:after,
.overlay,
.overlay:before,
.overlay:after {
  box-sizing: border-box; }
`);
var kH = function(t) {
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r.state = { on: !1, startX: 0, startY: 0, endX: 0, endY: 0, crossHairsTop: 0, crossHairsLeft: 0, isMouseDown: !1, windowWidth: 0, windowHeight: 0, borderWidth: 0, cropPositionTop: 0, cropPositionLeft: 0, cropWidth: 0, cropHeigth: 0, imageURL: "" }, r.handleWindowResize = function() {
      var n = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, A = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      r.setState({ windowWidth: n, windowHeight: A });
    }, r.componentDidMount = function() {
      r.handleWindowResize(), window.addEventListener("resize", r.handleWindowResize);
    }, r.componentWillUnmount = function() {
      window.removeEventListener("resize", r.handleWindowResize);
    }, r.handStartCapture = function() {
      return r.setState({ on: !0 });
    }, r.handleMouseMove = function(n) {
      var A = r.state, i = A.isMouseDown, o = A.windowWidth, s = A.windowHeight, a = A.startX, c = A.startY, l = A.borderWidth, u = c, f = a, d = n.clientX, g = n.clientY, m = g >= c, p = g <= c, v = d >= a, C = d <= a, w = m && C, B = p && v, y = p && C, b = l, q = 0, E = 0;
      i && (m && v && (b = "".concat(c, "px ").concat(o - d, "px ").concat(s - g, "px ").concat(a, "px"), q = d - a, E = g - c), w && (b = "".concat(c, "px ").concat(o - a, "px ").concat(s - g, "px ").concat(d, "px"), q = a - d, E = g - c, f = d), B && (b = "".concat(g, "px ").concat(o - d, "px ").concat(s - c, "px ").concat(a, "px"), q = d - a, E = c - g, u = g), y && (b = "".concat(g, "px ").concat(o - a, "px ").concat(s - c, "px ").concat(d, "px"), q = a - d, E = c - g, f = d, u = g)), q *= window.devicePixelRatio, E *= window.devicePixelRatio, f *= window.devicePixelRatio, u *= window.devicePixelRatio, r.setState({ crossHairsTop: n.clientY, crossHairsLeft: n.clientX, borderWidth: b, cropWidth: q, cropHeigth: E, cropPositionTop: u, cropPositionLeft: f });
    }, r.handleMouseDown = function(n) {
      var A = n.clientX, i = n.clientY;
      r.setState(function(o) {
        return { startX: A, startY: i, cropPositionTop: i, cropPositionLeft: A, isMouseDown: !0, borderWidth: "".concat(o.windowWidth, "px ").concat(o.windowHeight, "px") };
      });
    }, r.handleMouseUp = function() {
      r.handleClickTakeScreenShot(), r.setState({ on: !1, isMouseDown: !1, borderWidth: 0 });
    }, r.handleClickTakeScreenShot = function() {
      var n, A, i = r.state, o = i.cropPositionTop, s = i.cropPositionLeft, a = i.cropWidth, c = i.cropHeigth, l = document.querySelector("body");
      l && (n = l, A === void 0 && (A = {}), tle(n, A)).then(function(u) {
        var f = document.createElement("canvas"), d = f.getContext("2d");
        f.width = a, f.height = c, d && d.drawImage(u, s, o, a, c, 0, 0, a, c), f && r.props.onEndCapture(f.toDataURL());
      }), r.setState({ crossHairsTop: 0, crossHairsLeft: 0 });
    }, r.renderChild = function() {
      var n = r.props.children, A = { onStartCapture: r.handStartCapture };
      return typeof n == "function" ? n(A) : n;
    }, r;
  }
  return function(r, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function A() {
      this.constructor = r;
    }
    a7(r, n), r.prototype = n === null ? Object.create(n) : (A.prototype = n.prototype, new A());
  }(e, t), e.prototype.render = function() {
    var r = this.state, n = r.on, A = r.crossHairsTop, i = r.crossHairsLeft, o = r.borderWidth, s = r.isMouseDown;
    return n ? re.createElement("div", { onMouseMove: this.handleMouseMove, onMouseDown: this.handleMouseDown, onMouseUp: this.handleMouseUp }, this.renderChild(), re.createElement("div", { className: "overlay ".concat(s && "highlighting"), style: { borderWidth: "".concat(o) } }), re.createElement("div", { className: "crosshairs", style: { left: i + "px", top: A + "px" } })) : this.renderChild();
  }, e;
}($p);
function nle(t, e) {
  return e.forEach(function(r) {
    r && typeof r != "string" && !Array.isArray(r) && Object.keys(r).forEach(function(n) {
      if (n !== "default" && !(n in t)) {
        var A = Object.getOwnPropertyDescriptor(r, n);
        Object.defineProperty(t, n, A.get ? A : { enumerable: !0, get: function() {
          return r[n];
        } });
      }
    });
  }), Object.freeze(t);
}
function OH(t, e) {
  return new Promise(function(r, n) {
    let A;
    return Ale(t).then(function(i) {
      try {
        return A = i, r(new Blob([e.slice(0, 2), A, e.slice(2)], { type: "image/jpeg" }));
      } catch (o) {
        return n(o);
      }
    }, n);
  });
}
const Ale = (t) => new Promise((e, r) => {
  const n = new FileReader();
  n.addEventListener("load", ({ target: { result: A } }) => {
    const i = new DataView(A);
    let o = 0;
    if (i.getUint16(o) !== 65496) return r("not a valid JPEG");
    for (o += 2; ; ) {
      const s = i.getUint16(o);
      if (s === 65498) break;
      const a = i.getUint16(o + 2);
      if (s === 65505 && i.getUint32(o + 4) === 1165519206) {
        const c = o + 10;
        let l;
        switch (i.getUint16(c)) {
          case 18761:
            l = !0;
            break;
          case 19789:
            l = !1;
            break;
          default:
            return r("TIFF header contains invalid endian");
        }
        if (i.getUint16(c + 2, l) !== 42) return r("TIFF header contains invalid version");
        const u = i.getUint32(c + 4, l), f = c + u + 2 + 12 * i.getUint16(c + u, l);
        for (let d = c + u + 2; d < f; d += 12)
          if (i.getUint16(d, l) == 274) {
            if (i.getUint16(d + 2, l) !== 3) return r("Orientation data type is invalid");
            if (i.getUint32(d + 4, l) !== 1) return r("Orientation data count is invalid");
            i.setUint16(d + 8, 1, l);
            break;
          }
        return e(A.slice(o, o + 2 + a));
      }
      o += 2 + a;
    }
    return e(new Blob());
  }), n.readAsArrayBuffer(t);
});
var N3 = {}, ile = { get exports() {
  return N3;
}, set exports(t) {
  N3 = t;
} };
(function(t) {
  var e, r, n = {};
  ile.exports = n, n.parse = function(A, i) {
    for (var o = n.bin.readUshort, s = n.bin.readUint, a = 0, c = {}, l = new Uint8Array(A), u = l.length - 4; s(l, u) != 101010256; ) u--;
    a = u, a += 4;
    var f = o(l, a += 4);
    o(l, a += 2);
    var d = s(l, a += 2), g = s(l, a += 4);
    a += 4, a = g;
    for (var m = 0; m < f; m++) {
      s(l, a), a += 4, a += 4, a += 4, s(l, a += 4), d = s(l, a += 4);
      var p = s(l, a += 4), v = o(l, a += 4), C = o(l, a + 2), w = o(l, a + 4);
      a += 6;
      var B = s(l, a += 8);
      a += 4, a += v + C + w, n._readLocal(l, B, c, d, p, i);
    }
    return c;
  }, n._readLocal = function(A, i, o, s, a, c) {
    var l = n.bin.readUshort, u = n.bin.readUint;
    u(A, i), l(A, i += 4), l(A, i += 2);
    var f = l(A, i += 2);
    u(A, i += 2), u(A, i += 4), i += 4;
    var d = l(A, i += 8), g = l(A, i += 2);
    i += 2;
    var m = n.bin.readUTF8(A, i, d);
    if (i += d, i += g, c) o[m] = { size: a, csize: s };
    else {
      var p = new Uint8Array(A.buffer, i);
      if (f == 0) o[m] = new Uint8Array(p.buffer.slice(i, i + s));
      else {
        if (f != 8) throw "unknown compression method: " + f;
        var v = new Uint8Array(a);
        n.inflateRaw(p, v), o[m] = v;
      }
    }
  }, n.inflateRaw = function(A, i) {
    return n.F.inflate(A, i);
  }, n.inflate = function(A, i) {
    return A[0], A[1], n.inflateRaw(new Uint8Array(A.buffer, A.byteOffset + 2, A.length - 6), i);
  }, n.deflate = function(A, i) {
    i == null && (i = { level: 6 });
    var o = 0, s = new Uint8Array(50 + Math.floor(1.1 * A.length));
    s[o] = 120, s[o + 1] = 156, o += 2, o = n.F.deflateRaw(A, s, o, i.level);
    var a = n.adler(A, 0, A.length);
    return s[o + 0] = a >>> 24 & 255, s[o + 1] = a >>> 16 & 255, s[o + 2] = a >>> 8 & 255, s[o + 3] = a >>> 0 & 255, new Uint8Array(s.buffer, 0, o + 4);
  }, n.deflateRaw = function(A, i) {
    i == null && (i = { level: 6 });
    var o = new Uint8Array(50 + Math.floor(1.1 * A.length)), s = n.F.deflateRaw(A, o, s, i.level);
    return new Uint8Array(o.buffer, 0, s);
  }, n.encode = function(A, i) {
    i == null && (i = !1);
    var o = 0, s = n.bin.writeUint, a = n.bin.writeUshort, c = {};
    for (var l in A) {
      var u = !n._noNeed(l) && !i, f = A[l], d = n.crc.crc(f, 0, f.length);
      c[l] = { cpr: u, usize: f.length, crc: d, file: u ? n.deflateRaw(f) : f };
    }
    for (var l in c) o += c[l].file.length + 30 + 46 + 2 * n.bin.sizeUTF8(l);
    o += 22;
    var g = new Uint8Array(o), m = 0, p = [];
    for (var l in c) {
      var v = c[l];
      p.push(m), m = n._writeHeader(g, m, l, v, 0);
    }
    var C = 0, w = m;
    for (var l in c)
      v = c[l], p.push(m), m = n._writeHeader(g, m, l, v, 1, p[C++]);
    var B = m - w;
    return s(g, m, 101010256), m += 4, a(g, m += 4, C), a(g, m += 2, C), s(g, m += 2, B), s(g, m += 4, w), m += 4, m += 2, g.buffer;
  }, n._noNeed = function(A) {
    var i = A.split(".").pop().toLowerCase();
    return "png,jpg,jpeg,zip".indexOf(i) != -1;
  }, n._writeHeader = function(A, i, o, s, a, c) {
    var l = n.bin.writeUint, u = n.bin.writeUshort, f = s.file;
    return l(A, i, a == 0 ? 67324752 : 33639248), i += 4, a == 1 && (i += 2), u(A, i, 20), u(A, i += 2, 0), u(A, i += 2, s.cpr ? 8 : 0), l(A, i += 2, 0), l(A, i += 4, s.crc), l(A, i += 4, f.length), l(A, i += 4, s.usize), u(A, i += 4, n.bin.sizeUTF8(o)), u(A, i += 2, 0), i += 2, a == 1 && (i += 2, i += 2, l(A, i += 6, c), i += 4), i += n.bin.writeUTF8(A, i, o), a == 0 && (A.set(f, i), i += f.length), i;
  }, n.crc = { table: function() {
    for (var A = new Uint32Array(256), i = 0; i < 256; i++) {
      for (var o = i, s = 0; s < 8; s++) 1 & o ? o = 3988292384 ^ o >>> 1 : o >>>= 1;
      A[i] = o;
    }
    return A;
  }(), update: function(A, i, o, s) {
    for (var a = 0; a < s; a++) A = n.crc.table[255 & (A ^ i[o + a])] ^ A >>> 8;
    return A;
  }, crc: function(A, i, o) {
    return 4294967295 ^ n.crc.update(4294967295, A, i, o);
  } }, n.adler = function(A, i, o) {
    for (var s = 1, a = 0, c = i, l = i + o; c < l; ) {
      for (var u = Math.min(c + 5552, l); c < u; ) a += s += A[c++];
      s %= 65521, a %= 65521;
    }
    return a << 16 | s;
  }, n.bin = { readUshort: function(A, i) {
    return A[i] | A[i + 1] << 8;
  }, writeUshort: function(A, i, o) {
    A[i] = 255 & o, A[i + 1] = o >> 8 & 255;
  }, readUint: function(A, i) {
    return 16777216 * A[i + 3] + (A[i + 2] << 16 | A[i + 1] << 8 | A[i]);
  }, writeUint: function(A, i, o) {
    A[i] = 255 & o, A[i + 1] = o >> 8 & 255, A[i + 2] = o >> 16 & 255, A[i + 3] = o >> 24 & 255;
  }, readASCII: function(A, i, o) {
    for (var s = "", a = 0; a < o; a++) s += String.fromCharCode(A[i + a]);
    return s;
  }, writeASCII: function(A, i, o) {
    for (var s = 0; s < o.length; s++) A[i + s] = o.charCodeAt(s);
  }, pad: function(A) {
    return A.length < 2 ? "0" + A : A;
  }, readUTF8: function(A, i, o) {
    for (var s, a = "", c = 0; c < o; c++) a += "%" + n.bin.pad(A[i + c].toString(16));
    try {
      s = decodeURIComponent(a);
    } catch {
      return n.bin.readASCII(A, i, o);
    }
    return s;
  }, writeUTF8: function(A, i, o) {
    for (var s = o.length, a = 0, c = 0; c < s; c++) {
      var l = o.charCodeAt(c);
      if (!(4294967168 & l)) A[i + a] = l, a++;
      else if (!(4294965248 & l)) A[i + a] = 192 | l >> 6, A[i + a + 1] = 128 | l >> 0 & 63, a += 2;
      else if (!(4294901760 & l)) A[i + a] = 224 | l >> 12, A[i + a + 1] = 128 | l >> 6 & 63, A[i + a + 2] = 128 | l >> 0 & 63, a += 3;
      else {
        if (4292870144 & l) throw "e";
        A[i + a] = 240 | l >> 18, A[i + a + 1] = 128 | l >> 12 & 63, A[i + a + 2] = 128 | l >> 6 & 63, A[i + a + 3] = 128 | l >> 0 & 63, a += 4;
      }
    }
    return a;
  }, sizeUTF8: function(A) {
    for (var i = A.length, o = 0, s = 0; s < i; s++) {
      var a = A.charCodeAt(s);
      if (!(4294967168 & a)) o++;
      else if (!(4294965248 & a)) o += 2;
      else if (!(4294901760 & a)) o += 3;
      else {
        if (4292870144 & a) throw "e";
        o += 4;
      }
    }
    return o;
  } }, n.F = {}, n.F.deflateRaw = function(A, i, o, s) {
    var a = [[0, 0, 0, 0, 0], [4, 4, 8, 4, 0], [4, 5, 16, 8, 0], [4, 6, 16, 16, 0], [4, 10, 16, 32, 0], [8, 16, 32, 32, 0], [8, 16, 128, 128, 0], [8, 32, 128, 256, 0], [32, 128, 258, 1024, 1], [32, 258, 258, 4096, 1]][s], c = n.F.U, l = n.F._goodIndex;
    n.F._hash;
    var u = n.F._putsE, f = 0, d = o << 3, g = 0, m = A.length;
    if (s == 0) {
      for (; f < m; )
        u(i, d, f + (O = Math.min(65535, m - f)) == m ? 1 : 0), d = n.F._copyExact(A, f, O, i, d + 8), f += O;
      return d >>> 3;
    }
    var p = c.lits, v = c.strt, C = c.prev, w = 0, B = 0, y = 0, b = 0, q = 0, E = 0;
    for (m > 2 && (v[E = n.F._hash(A, 0)] = 0), f = 0; f < m; f++) {
      if (q = E, f + 1 < m - 2) {
        E = n.F._hash(A, f + 1);
        var x = f + 1 & 32767;
        C[x] = v[E], v[E] = x;
      }
      if (g <= f) {
        (w > 14e3 || B > 26697) && m - f > 100 && (g < f && (p[w] = f - g, w += 2, g = f), d = n.F._writeBlock(f == m - 1 || g == m ? 1 : 0, p, w, b, A, y, f - y, i, d), w = B = b = 0, y = f);
        var M = 0;
        f < m - 2 && (M = n.F._bestMatch(A, f, C, q, Math.min(a[2], m - f), a[3]));
        var O = M >>> 16, I = 65535 & M;
        if (M != 0) {
          I = 65535 & M;
          var S = l(O = M >>> 16, c.of0);
          c.lhst[257 + S]++;
          var P = l(I, c.df0);
          c.dhst[P]++, b += c.exb[S] + c.dxb[P], p[w] = O << 23 | f - g, p[w + 1] = I << 16 | S << 8 | P, w += 2, g = f + O;
        } else c.lhst[A[f]]++;
        B++;
      }
    }
    for (y == f && A.length != 0 || (g < f && (p[w] = f - g, w += 2, g = f), d = n.F._writeBlock(1, p, w, b, A, y, f - y, i, d), w = 0, B = 0, w = B = b = 0, y = f); 7 & d; ) d++;
    return d >>> 3;
  }, n.F._bestMatch = function(A, i, o, s, a, c) {
    var l = 32767 & i, u = o[l], f = l - u + 32768 & 32767;
    if (u == l || s != n.F._hash(A, i - f)) return 0;
    for (var d = 0, g = 0, m = Math.min(32767, i); f <= m && --c != 0 && u != l; ) {
      if (d == 0 || A[i + d] == A[i + d - f]) {
        var p = n.F._howLong(A, i, f);
        if (p > d) {
          if (g = f, (d = p) >= a) break;
          f + 2 < p && (p = f + 2);
          for (var v = 0, C = 0; C < p - 2; C++) {
            var w = i - f + C + 32768 & 32767, B = w - o[w] + 32768 & 32767;
            B > v && (v = B, u = w);
          }
        }
      }
      f += (l = u) - (u = o[l]) + 32768 & 32767;
    }
    return d << 16 | g;
  }, n.F._howLong = function(A, i, o) {
    if (A[i] != A[i - o] || A[i + 1] != A[i + 1 - o] || A[i + 2] != A[i + 2 - o]) return 0;
    var s = i, a = Math.min(A.length, i + 258);
    for (i += 3; i < a && A[i] == A[i - o]; ) i++;
    return i - s;
  }, n.F._hash = function(A, i) {
    return (A[i] << 8 | A[i + 1]) + (A[i + 2] << 4) & 65535;
  }, n.saved = 0, n.F._writeBlock = function(A, i, o, s, a, c, l, u, f) {
    var d, g, m, p, v, C, w, B, y, b = n.F.U, q = n.F._putsF, E = n.F._putsE;
    b.lhst[256]++, g = (d = n.F.getTrees())[0], m = d[1], p = d[2], v = d[3], C = d[4], w = d[5], B = d[6], y = d[7];
    var x = 32 + (f + 3 & 7 ? 8 - (f + 3 & 7) : 0) + (l << 3), M = s + n.F.contSize(b.fltree, b.lhst) + n.F.contSize(b.fdtree, b.dhst), O = s + n.F.contSize(b.ltree, b.lhst) + n.F.contSize(b.dtree, b.dhst);
    O += 14 + 3 * w + n.F.contSize(b.itree, b.ihst) + (2 * b.ihst[16] + 3 * b.ihst[17] + 7 * b.ihst[18]);
    for (var I = 0; I < 286; I++) b.lhst[I] = 0;
    for (I = 0; I < 30; I++) b.dhst[I] = 0;
    for (I = 0; I < 19; I++) b.ihst[I] = 0;
    var S = x < M && x < O ? 0 : M < O ? 1 : 2;
    if (q(u, f, A), q(u, f + 1, S), f += 3, S == 0) {
      for (; 7 & f; ) f++;
      f = n.F._copyExact(a, c, l, u, f);
    } else {
      var P, H;
      if (S == 1 && (P = b.fltree, H = b.fdtree), S == 2) {
        n.F.makeCodes(b.ltree, g), n.F.revCodes(b.ltree, g), n.F.makeCodes(b.dtree, m), n.F.revCodes(b.dtree, m), n.F.makeCodes(b.itree, p), n.F.revCodes(b.itree, p), P = b.ltree, H = b.dtree, E(u, f, v - 257), E(u, f += 5, C - 1), E(u, f += 5, w - 4), f += 4;
        for (var F = 0; F < w; F++) E(u, f + 3 * F, b.itree[1 + (b.ordr[F] << 1)]);
        f += 3 * w, f = n.F._codeTiny(B, b.itree, u, f), f = n.F._codeTiny(y, b.itree, u, f);
      }
      for (var T = c, U = 0; U < o; U += 2) {
        for (var D = i[U], Q = D >>> 23, Y = T + (8388607 & D); T < Y; ) f = n.F._writeLit(a[T++], P, u, f);
        if (Q != 0) {
          var j = i[U + 1], Z = j >> 16, W = j >> 8 & 255, R = 255 & j;
          E(u, f = n.F._writeLit(257 + W, P, u, f), Q - b.of0[W]), f += b.exb[W], q(u, f = n.F._writeLit(R, H, u, f), Z - b.df0[R]), f += b.dxb[R], T += Q;
        }
      }
      f = n.F._writeLit(256, P, u, f);
    }
    return f;
  }, n.F._copyExact = function(A, i, o, s, a) {
    var c = a >>> 3;
    return s[c] = o, s[c + 1] = o >>> 8, s[c + 2] = 255 - s[c], s[c + 3] = 255 - s[c + 1], c += 4, s.set(new Uint8Array(A.buffer, i, o), c), a + (o + 4 << 3);
  }, n.F.getTrees = function() {
    for (var A = n.F.U, i = n.F._hufTree(A.lhst, A.ltree, 15), o = n.F._hufTree(A.dhst, A.dtree, 15), s = [], a = n.F._lenCodes(A.ltree, s), c = [], l = n.F._lenCodes(A.dtree, c), u = 0; u < s.length; u += 2) A.ihst[s[u]]++;
    for (u = 0; u < c.length; u += 2) A.ihst[c[u]]++;
    for (var f = n.F._hufTree(A.ihst, A.itree, 7), d = 19; d > 4 && A.itree[1 + (A.ordr[d - 1] << 1)] == 0; ) d--;
    return [i, o, f, a, l, d, s, c];
  }, n.F.getSecond = function(A) {
    for (var i = [], o = 0; o < A.length; o += 2) i.push(A[o + 1]);
    return i;
  }, n.F.nonZero = function(A) {
    for (var i = "", o = 0; o < A.length; o += 2) A[o + 1] != 0 && (i += (o >> 1) + ",");
    return i;
  }, n.F.contSize = function(A, i) {
    for (var o = 0, s = 0; s < i.length; s++) o += i[s] * A[1 + (s << 1)];
    return o;
  }, n.F._codeTiny = function(A, i, o, s) {
    for (var a = 0; a < A.length; a += 2) {
      var c = A[a], l = A[a + 1];
      s = n.F._writeLit(c, i, o, s);
      var u = c == 16 ? 2 : c == 17 ? 3 : 7;
      c > 15 && (n.F._putsE(o, s, l, u), s += u);
    }
    return s;
  }, n.F._lenCodes = function(A, i) {
    for (var o = A.length; o != 2 && A[o - 1] == 0; ) o -= 2;
    for (var s = 0; s < o; s += 2) {
      var a = A[s + 1], c = s + 3 < o ? A[s + 3] : -1, l = s + 5 < o ? A[s + 5] : -1, u = s == 0 ? -1 : A[s - 1];
      if (a == 0 && c == a && l == a) {
        for (var f = s + 5; f + 2 < o && A[f + 2] == a; ) f += 2;
        (d = Math.min(f + 1 - s >>> 1, 138)) < 11 ? i.push(17, d - 3) : i.push(18, d - 11), s += 2 * d - 2;
      } else if (a == u && c == a && l == a) {
        for (f = s + 5; f + 2 < o && A[f + 2] == a; ) f += 2;
        var d = Math.min(f + 1 - s >>> 1, 6);
        i.push(16, d - 3), s += 2 * d - 2;
      } else i.push(a, 0);
    }
    return o >>> 1;
  }, n.F._hufTree = function(A, i, o) {
    var s = [], a = A.length, c = i.length, l = 0;
    for (l = 0; l < c; l += 2) i[l] = 0, i[l + 1] = 0;
    for (l = 0; l < a; l++) A[l] != 0 && s.push({ lit: l, f: A[l] });
    var u = s.length, f = s.slice(0);
    if (u == 0) return 0;
    if (u == 1) {
      var d = s[0].lit;
      return f = d == 0 ? 1 : 0, i[1 + (d << 1)] = 1, i[1 + (f << 1)] = 1, 1;
    }
    s.sort(function(B, y) {
      return B.f - y.f;
    });
    var g = s[0], m = s[1], p = 0, v = 1, C = 2;
    for (s[0] = { lit: -1, f: g.f + m.f, l: g, r: m, d: 0 }; v != u - 1; ) g = p != v && (C == u || s[p].f < s[C].f) ? s[p++] : s[C++], m = p != v && (C == u || s[p].f < s[C].f) ? s[p++] : s[C++], s[v++] = { lit: -1, f: g.f + m.f, l: g, r: m };
    var w = n.F.setDepth(s[v - 1], 0);
    for (w > o && (n.F.restrictDepth(f, o, w), w = o), l = 0; l < u; l++) i[1 + (f[l].lit << 1)] = f[l].d;
    return w;
  }, n.F.setDepth = function(A, i) {
    return A.lit != -1 ? (A.d = i, i) : Math.max(n.F.setDepth(A.l, i + 1), n.F.setDepth(A.r, i + 1));
  }, n.F.restrictDepth = function(A, i, o) {
    var s = 0, a = 1 << o - i, c = 0;
    for (A.sort(function(u, f) {
      return f.d == u.d ? u.f - f.f : f.d - u.d;
    }), s = 0; s < A.length && A[s].d > i; s++) {
      var l = A[s].d;
      A[s].d = i, c += a - (1 << o - l);
    }
    for (c >>>= o - i; c > 0; )
      (l = A[s].d) < i ? (A[s].d++, c -= 1 << i - l - 1) : s++;
    for (; s >= 0; s--) A[s].d == i && c < 0 && (A[s].d--, c++);
    c != 0 && console.log("debt left");
  }, n.F._goodIndex = function(A, i) {
    var o = 0;
    return i[16 | o] <= A && (o |= 16), i[8 | o] <= A && (o |= 8), i[4 | o] <= A && (o |= 4), i[2 | o] <= A && (o |= 2), i[1 | o] <= A && (o |= 1), o;
  }, n.F._writeLit = function(A, i, o, s) {
    return n.F._putsF(o, s, i[A << 1]), s + i[1 + (A << 1)];
  }, n.F.inflate = function(A, i) {
    var o = Uint8Array;
    if (A[0] == 3 && A[1] == 0) return i || new o(0);
    var s = n.F, a = s._bitsF, c = s._bitsE, l = s._decodeTiny, u = s.makeCodes, f = s.codes2map, d = s._get17, g = s.U, m = i == null;
    m && (i = new o(A.length >>> 2 << 3));
    for (var p, v, C = 0, w = 0, B = 0, y = 0, b = 0, q = 0, E = 0, x = 0, M = 0; C == 0; ) if (C = a(A, M, 1), w = a(A, M + 1, 2), M += 3, w != 0) {
      if (m && (i = n.F._check(i, x + (1 << 17))), w == 1 && (p = g.flmap, v = g.fdmap, q = 511, E = 31), w == 2) {
        B = c(A, M, 5) + 257, y = c(A, M + 5, 5) + 1, b = c(A, M + 10, 4) + 4, M += 14;
        for (var O = 0; O < 38; O += 2) g.itree[O] = 0, g.itree[O + 1] = 0;
        var I = 1;
        for (O = 0; O < b; O++) {
          var S = c(A, M + 3 * O, 3);
          g.itree[1 + (g.ordr[O] << 1)] = S, S > I && (I = S);
        }
        M += 3 * b, u(g.itree, I), f(g.itree, I, g.imap), p = g.lmap, v = g.dmap, M = l(g.imap, (1 << I) - 1, B + y, A, M, g.ttree);
        var P = s._copyOut(g.ttree, 0, B, g.ltree);
        q = (1 << P) - 1;
        var H = s._copyOut(g.ttree, B, y, g.dtree);
        E = (1 << H) - 1, u(g.ltree, P), f(g.ltree, P, p), u(g.dtree, H), f(g.dtree, H, v);
      }
      for (; ; ) {
        var F = p[d(A, M) & q];
        M += 15 & F;
        var T = F >>> 4;
        if (!(T >>> 8)) i[x++] = T;
        else {
          if (T == 256) break;
          var U = x + T - 254;
          if (T > 264) {
            var D = g.ldef[T - 257];
            U = x + (D >>> 3) + c(A, M, 7 & D), M += 7 & D;
          }
          var Q = v[d(A, M) & E];
          M += 15 & Q;
          var Y = Q >>> 4, j = g.ddef[Y], Z = (j >>> 4) + a(A, M, 15 & j);
          for (M += 15 & j, m && (i = n.F._check(i, x + (1 << 17))); x < U; ) i[x] = i[x++ - Z], i[x] = i[x++ - Z], i[x] = i[x++ - Z], i[x] = i[x++ - Z];
          x = U;
        }
      }
    } else {
      7 & M && (M += 8 - (7 & M));
      var W = 4 + (M >>> 3), R = A[W - 4] | A[W - 3] << 8;
      m && (i = n.F._check(i, x + R)), i.set(new o(A.buffer, A.byteOffset + W, R), x), M = W + R << 3, x += R;
    }
    return i.length == x ? i : i.slice(0, x);
  }, n.F._check = function(A, i) {
    var o = A.length;
    if (i <= o) return A;
    var s = new Uint8Array(Math.max(o << 1, i));
    return s.set(A, 0), s;
  }, n.F._decodeTiny = function(A, i, o, s, a, c) {
    for (var l = n.F._bitsE, u = n.F._get17, f = 0; f < o; ) {
      var d = A[u(s, a) & i];
      a += 15 & d;
      var g = d >>> 4;
      if (g <= 15) c[f] = g, f++;
      else {
        var m = 0, p = 0;
        g == 16 ? (p = 3 + l(s, a, 2), a += 2, m = c[f - 1]) : g == 17 ? (p = 3 + l(s, a, 3), a += 3) : g == 18 && (p = 11 + l(s, a, 7), a += 7);
        for (var v = f + p; f < v; ) c[f] = m, f++;
      }
    }
    return a;
  }, n.F._copyOut = function(A, i, o, s) {
    for (var a = 0, c = 0, l = s.length >>> 1; c < o; ) {
      var u = A[c + i];
      s[c << 1] = 0, s[1 + (c << 1)] = u, u > a && (a = u), c++;
    }
    for (; c < l; ) s[c << 1] = 0, s[1 + (c << 1)] = 0, c++;
    return a;
  }, n.F.makeCodes = function(A, i) {
    for (var o, s, a, c, l = n.F.U, u = A.length, f = l.bl_count, d = 0; d <= i; d++) f[d] = 0;
    for (d = 1; d < u; d += 2) f[A[d]]++;
    var g = l.next_code;
    for (o = 0, f[0] = 0, s = 1; s <= i; s++) o = o + f[s - 1] << 1, g[s] = o;
    for (a = 0; a < u; a += 2) (c = A[a + 1]) != 0 && (A[a] = g[c], g[c]++);
  }, n.F.codes2map = function(A, i, o) {
    for (var s = A.length, a = n.F.U.rev15, c = 0; c < s; c += 2) if (A[c + 1] != 0) for (var l = c >> 1, u = A[c + 1], f = l << 4 | u, d = i - u, g = A[c] << d, m = g + (1 << d); g != m; )
      o[a[g] >>> 15 - i] = f, g++;
  }, n.F.revCodes = function(A, i) {
    for (var o = n.F.U.rev15, s = 15 - i, a = 0; a < A.length; a += 2) {
      var c = A[a] << i - A[a + 1];
      A[a] = o[c] >>> s;
    }
  }, n.F._putsE = function(A, i, o) {
    o <<= 7 & i;
    var s = i >>> 3;
    A[s] |= o, A[s + 1] |= o >>> 8;
  }, n.F._putsF = function(A, i, o) {
    o <<= 7 & i;
    var s = i >>> 3;
    A[s] |= o, A[s + 1] |= o >>> 8, A[s + 2] |= o >>> 16;
  }, n.F._bitsE = function(A, i, o) {
    return (A[i >>> 3] | A[1 + (i >>> 3)] << 8) >>> (7 & i) & (1 << o) - 1;
  }, n.F._bitsF = function(A, i, o) {
    return (A[i >>> 3] | A[1 + (i >>> 3)] << 8 | A[2 + (i >>> 3)] << 16) >>> (7 & i) & (1 << o) - 1;
  }, n.F._get17 = function(A, i) {
    return (A[i >>> 3] | A[1 + (i >>> 3)] << 8 | A[2 + (i >>> 3)] << 16) >>> (7 & i);
  }, n.F._get25 = function(A, i) {
    return (A[i >>> 3] | A[1 + (i >>> 3)] << 8 | A[2 + (i >>> 3)] << 16 | A[3 + (i >>> 3)] << 24) >>> (7 & i);
  }, n.F.U = (e = Uint16Array, r = Uint32Array, { next_code: new e(16), bl_count: new e(16), ordr: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], of0: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], exb: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], ldef: new e(32), df0: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], dxb: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], ddef: new r(32), flmap: new e(512), fltree: [], fdmap: new e(32), fdtree: [], lmap: new e(32768), ltree: [], ttree: [], dmap: new e(32768), dtree: [], imap: new e(512), itree: [], rev15: new e(32768), lhst: new r(286), dhst: new r(30), ihst: new r(19), lits: new r(15e3), strt: new e(65536), prev: new e(32768) }), function() {
    for (var A = n.F.U, i = 0; i < 32768; i++) {
      var o = i;
      o = (4278255360 & (o = (4042322160 & (o = (3435973836 & (o = (2863311530 & o) >>> 1 | (1431655765 & o) << 1)) >>> 2 | (858993459 & o) << 2)) >>> 4 | (252645135 & o) << 4)) >>> 8 | (16711935 & o) << 8, A.rev15[i] = (o >>> 16 | o << 16) >>> 17;
    }
    function s(a, c, l) {
      for (; c-- != 0; ) a.push(0, l);
    }
    for (i = 0; i < 32; i++) A.ldef[i] = A.of0[i] << 3 | A.exb[i], A.ddef[i] = A.df0[i] << 4 | A.dxb[i];
    s(A.fltree, 144, 8), s(A.fltree, 112, 9), s(A.fltree, 24, 7), s(A.fltree, 8, 8), n.F.makeCodes(A.fltree, 9), n.F.codes2map(A.fltree, 9, A.flmap), n.F.revCodes(A.fltree, 9), s(A.fdtree, 32, 5), n.F.makeCodes(A.fdtree, 5), n.F.codes2map(A.fdtree, 5, A.fdmap), n.F.revCodes(A.fdtree, 5), s(A.itree, 19, 0), s(A.ltree, 286, 0), s(A.dtree, 30, 0), s(A.ttree, 320, 0);
  }();
})();
var ole = nle({ __proto__: null, default: N3 }, [N3]);
const ro = function() {
  var t = { nextZero(l, u) {
    for (; l[u] != 0; ) u++;
    return u;
  }, readUshort: (l, u) => l[u] << 8 | l[u + 1], writeUshort(l, u, f) {
    l[u] = f >> 8 & 255, l[u + 1] = 255 & f;
  }, readUint: (l, u) => 16777216 * l[u] + (l[u + 1] << 16 | l[u + 2] << 8 | l[u + 3]), writeUint(l, u, f) {
    l[u] = f >> 24 & 255, l[u + 1] = f >> 16 & 255, l[u + 2] = f >> 8 & 255, l[u + 3] = 255 & f;
  }, readASCII(l, u, f) {
    let d = "";
    for (let g = 0; g < f; g++) d += String.fromCharCode(l[u + g]);
    return d;
  }, writeASCII(l, u, f) {
    for (let d = 0; d < f.length; d++) l[u + d] = f.charCodeAt(d);
  }, readBytes(l, u, f) {
    const d = [];
    for (let g = 0; g < f; g++) d.push(l[u + g]);
    return d;
  }, pad: (l) => l.length < 2 ? `0${l}` : l, readUTF8(l, u, f) {
    let d, g = "";
    for (let m = 0; m < f; m++) g += `%${t.pad(l[u + m].toString(16))}`;
    try {
      d = decodeURIComponent(g);
    } catch {
      return t.readASCII(l, u, f);
    }
    return d;
  } };
  function e(l, u, f, d) {
    const g = u * f, m = i(d), p = Math.ceil(u * m / 8), v = new Uint8Array(4 * g), C = new Uint32Array(v.buffer), { ctype: w } = d, { depth: B } = d, y = t.readUshort;
    if (w == 6) {
      const D = g << 2;
      if (B == 8) for (var b = 0; b < D; b += 4) v[b] = l[b], v[b + 1] = l[b + 1], v[b + 2] = l[b + 2], v[b + 3] = l[b + 3];
      if (B == 16) for (b = 0; b < D; b++) v[b] = l[b << 1];
    } else if (w == 2) {
      const D = d.tabs.tRNS;
      if (D == null) {
        if (B == 8) for (b = 0; b < g; b++) {
          var q = 3 * b;
          C[b] = 255 << 24 | l[q + 2] << 16 | l[q + 1] << 8 | l[q];
        }
        if (B == 16) for (b = 0; b < g; b++)
          q = 6 * b, C[b] = 255 << 24 | l[q + 4] << 16 | l[q + 2] << 8 | l[q];
      } else {
        var E = D[0];
        const Q = D[1], Y = D[2];
        if (B == 8) for (b = 0; b < g; b++) {
          var x = b << 2;
          q = 3 * b, C[b] = 255 << 24 | l[q + 2] << 16 | l[q + 1] << 8 | l[q], l[q] == E && l[q + 1] == Q && l[q + 2] == Y && (v[x + 3] = 0);
        }
        if (B == 16) for (b = 0; b < g; b++)
          x = b << 2, q = 6 * b, C[b] = 255 << 24 | l[q + 4] << 16 | l[q + 2] << 8 | l[q], y(l, q) == E && y(l, q + 2) == Q && y(l, q + 4) == Y && (v[x + 3] = 0);
      }
    } else if (w == 3) {
      const D = d.tabs.PLTE, Q = d.tabs.tRNS, Y = Q ? Q.length : 0;
      if (B == 1) for (var M = 0; M < f; M++) {
        var O = M * p, I = M * u;
        for (b = 0; b < u; b++) {
          x = I + b << 2;
          var S = 3 * (P = l[O + (b >> 3)] >> 7 - ((7 & b) << 0) & 1);
          v[x] = D[S], v[x + 1] = D[S + 1], v[x + 2] = D[S + 2], v[x + 3] = P < Y ? Q[P] : 255;
        }
      }
      if (B == 2) for (M = 0; M < f; M++) for (O = M * p, I = M * u, b = 0; b < u; b++)
        x = I + b << 2, S = 3 * (P = l[O + (b >> 2)] >> 6 - ((3 & b) << 1) & 3), v[x] = D[S], v[x + 1] = D[S + 1], v[x + 2] = D[S + 2], v[x + 3] = P < Y ? Q[P] : 255;
      if (B == 4) for (M = 0; M < f; M++) for (O = M * p, I = M * u, b = 0; b < u; b++)
        x = I + b << 2, S = 3 * (P = l[O + (b >> 1)] >> 4 - ((1 & b) << 2) & 15), v[x] = D[S], v[x + 1] = D[S + 1], v[x + 2] = D[S + 2], v[x + 3] = P < Y ? Q[P] : 255;
      if (B == 8) for (b = 0; b < g; b++) {
        var P;
        x = b << 2, S = 3 * (P = l[b]), v[x] = D[S], v[x + 1] = D[S + 1], v[x + 2] = D[S + 2], v[x + 3] = P < Y ? Q[P] : 255;
      }
    } else if (w == 4) {
      if (B == 8) for (b = 0; b < g; b++) {
        x = b << 2;
        var H = l[F = b << 1];
        v[x] = H, v[x + 1] = H, v[x + 2] = H, v[x + 3] = l[F + 1];
      }
      if (B == 16) for (b = 0; b < g; b++) {
        var F;
        x = b << 2, H = l[F = b << 2], v[x] = H, v[x + 1] = H, v[x + 2] = H, v[x + 3] = l[F + 2];
      }
    } else if (w == 0) for (E = d.tabs.tRNS ? d.tabs.tRNS : -1, M = 0; M < f; M++) {
      const D = M * p, Q = M * u;
      if (B == 1) for (var T = 0; T < u; T++) {
        var U = (H = 255 * (l[D + (T >>> 3)] >>> 7 - (7 & T) & 1)) == 255 * E ? 0 : 255;
        C[Q + T] = U << 24 | H << 16 | H << 8 | H;
      }
      else if (B == 2) for (T = 0; T < u; T++)
        U = (H = 85 * (l[D + (T >>> 2)] >>> 6 - ((3 & T) << 1) & 3)) == 85 * E ? 0 : 255, C[Q + T] = U << 24 | H << 16 | H << 8 | H;
      else if (B == 4) for (T = 0; T < u; T++)
        U = (H = 17 * (l[D + (T >>> 1)] >>> 4 - ((1 & T) << 2) & 15)) == 17 * E ? 0 : 255, C[Q + T] = U << 24 | H << 16 | H << 8 | H;
      else if (B == 8) for (T = 0; T < u; T++)
        U = (H = l[D + T]) == E ? 0 : 255, C[Q + T] = U << 24 | H << 16 | H << 8 | H;
      else if (B == 16) for (T = 0; T < u; T++)
        H = l[D + (T << 1)], U = y(l, D + (T << 1)) == E ? 0 : 255, C[Q + T] = U << 24 | H << 16 | H << 8 | H;
    }
    return v;
  }
  function r(l, u, f, d) {
    const g = i(l), m = Math.ceil(f * g / 8), p = new Uint8Array((m + 1 + l.interlace) * d);
    return u = l.tabs.CgBI ? A(u, p) : n(u, p), l.interlace == 0 ? u = o(u, l, 0, f, d) : l.interlace == 1 && (u = function(C, w) {
      const B = w.width, y = w.height, b = i(w), q = b >> 3, E = Math.ceil(B * b / 8), x = new Uint8Array(y * E);
      let M = 0;
      const O = [0, 0, 4, 0, 2, 0, 1], I = [0, 4, 0, 2, 0, 1, 0], S = [8, 8, 8, 4, 4, 2, 2], P = [8, 8, 4, 4, 2, 2, 1];
      let H = 0;
      for (; H < 7; ) {
        const T = S[H], U = P[H];
        let D = 0, Q = 0, Y = O[H];
        for (; Y < y; ) Y += T, Q++;
        let j = I[H];
        for (; j < B; ) j += U, D++;
        const Z = Math.ceil(D * b / 8);
        o(C, w, M, D, Q);
        let W = 0, R = O[H];
        for (; R < y; ) {
          let K = I[H], L = M + W * Z << 3;
          for (; K < B; ) {
            var F;
            if (b == 1 && (F = (F = C[L >> 3]) >> 7 - (7 & L) & 1, x[R * E + (K >> 3)] |= F << 7 - ((7 & K) << 0)), b == 2 && (F = (F = C[L >> 3]) >> 6 - (7 & L) & 3, x[R * E + (K >> 2)] |= F << 6 - ((3 & K) << 1)), b == 4 && (F = (F = C[L >> 3]) >> 4 - (7 & L) & 15, x[R * E + (K >> 1)] |= F << 4 - ((1 & K) << 2)), b >= 8) {
              const G = R * E + K * q;
              for (let V = 0; V < q; V++) x[G + V] = C[(L >> 3) + V];
            }
            L += b, K += U;
          }
          W++, R += T;
        }
        D * Q != 0 && (M += Q * (1 + Z)), H += 1;
      }
      return x;
    }(u, l)), u;
  }
  function n(l, u) {
    return A(new Uint8Array(l.buffer, 2, l.length - 6), u);
  }
  var A = function() {
    const l = { H: {} };
    return l.H.N = function(u, f) {
      const d = Uint8Array;
      let g, m, p = 0, v = 0, C = 0, w = 0, B = 0, y = 0, b = 0, q = 0, E = 0;
      if (u[0] == 3 && u[1] == 0) return f || new d(0);
      const x = l.H, M = x.b, O = x.e, I = x.R, S = x.n, P = x.A, H = x.Z, F = x.m, T = f == null;
      for (T && (f = new d(u.length >>> 2 << 5)); p == 0; ) if (p = M(u, E, 1), v = M(u, E + 1, 2), E += 3, v != 0) {
        if (T && (f = l.H.W(f, q + (1 << 17))), v == 1 && (g = F.J, m = F.h, y = 511, b = 31), v == 2) {
          C = O(u, E, 5) + 257, w = O(u, E + 5, 5) + 1, B = O(u, E + 10, 4) + 4, E += 14;
          let D = 1;
          for (var U = 0; U < 38; U += 2) F.Q[U] = 0, F.Q[U + 1] = 0;
          for (U = 0; U < B; U++) {
            const j = O(u, E + 3 * U, 3);
            F.Q[1 + (F.X[U] << 1)] = j, j > D && (D = j);
          }
          E += 3 * B, S(F.Q, D), P(F.Q, D, F.u), g = F.w, m = F.d, E = I(F.u, (1 << D) - 1, C + w, u, E, F.v);
          const Q = x.V(F.v, 0, C, F.C);
          y = (1 << Q) - 1;
          const Y = x.V(F.v, C, w, F.D);
          b = (1 << Y) - 1, S(F.C, Q), P(F.C, Q, g), S(F.D, Y), P(F.D, Y, m);
        }
        for (; ; ) {
          const D = g[H(u, E) & y];
          E += 15 & D;
          const Q = D >>> 4;
          if (!(Q >>> 8)) f[q++] = Q;
          else {
            if (Q == 256) break;
            {
              let Y = q + Q - 254;
              if (Q > 264) {
                const K = F.q[Q - 257];
                Y = q + (K >>> 3) + O(u, E, 7 & K), E += 7 & K;
              }
              const j = m[H(u, E) & b];
              E += 15 & j;
              const Z = j >>> 4, W = F.c[Z], R = (W >>> 4) + M(u, E, 15 & W);
              for (E += 15 & W; q < Y; ) f[q] = f[q++ - R], f[q] = f[q++ - R], f[q] = f[q++ - R], f[q] = f[q++ - R];
              q = Y;
            }
          }
        }
      } else {
        7 & E && (E += 8 - (7 & E));
        const D = 4 + (E >>> 3), Q = u[D - 4] | u[D - 3] << 8;
        T && (f = l.H.W(f, q + Q)), f.set(new d(u.buffer, u.byteOffset + D, Q), q), E = D + Q << 3, q += Q;
      }
      return f.length == q ? f : f.slice(0, q);
    }, l.H.W = function(u, f) {
      const d = u.length;
      if (f <= d) return u;
      const g = new Uint8Array(d << 1);
      return g.set(u, 0), g;
    }, l.H.R = function(u, f, d, g, m, p) {
      const v = l.H.e, C = l.H.Z;
      let w = 0;
      for (; w < d; ) {
        const B = u[C(g, m) & f];
        m += 15 & B;
        const y = B >>> 4;
        if (y <= 15) p[w] = y, w++;
        else {
          let b = 0, q = 0;
          y == 16 ? (q = 3 + v(g, m, 2), m += 2, b = p[w - 1]) : y == 17 ? (q = 3 + v(g, m, 3), m += 3) : y == 18 && (q = 11 + v(g, m, 7), m += 7);
          const E = w + q;
          for (; w < E; ) p[w] = b, w++;
        }
      }
      return m;
    }, l.H.V = function(u, f, d, g) {
      let m = 0, p = 0;
      const v = g.length >>> 1;
      for (; p < d; ) {
        const C = u[p + f];
        g[p << 1] = 0, g[1 + (p << 1)] = C, C > m && (m = C), p++;
      }
      for (; p < v; ) g[p << 1] = 0, g[1 + (p << 1)] = 0, p++;
      return m;
    }, l.H.n = function(u, f) {
      const d = l.H.m, g = u.length;
      let m, p, v, C;
      const w = d.j;
      for (var B = 0; B <= f; B++) w[B] = 0;
      for (B = 1; B < g; B += 2) w[u[B]]++;
      const y = d.K;
      for (m = 0, w[0] = 0, p = 1; p <= f; p++) m = m + w[p - 1] << 1, y[p] = m;
      for (v = 0; v < g; v += 2) C = u[v + 1], C != 0 && (u[v] = y[C], y[C]++);
    }, l.H.A = function(u, f, d) {
      const g = u.length, m = l.H.m.r;
      for (let p = 0; p < g; p += 2) if (u[p + 1] != 0) {
        const v = p >> 1, C = u[p + 1], w = v << 4 | C, B = f - C;
        let y = u[p] << B;
        const b = y + (1 << B);
        for (; y != b; )
          d[m[y] >>> 15 - f] = w, y++;
      }
    }, l.H.l = function(u, f) {
      const d = l.H.m.r, g = 15 - f;
      for (let m = 0; m < u.length; m += 2) {
        const p = u[m] << f - u[m + 1];
        u[m] = d[p] >>> g;
      }
    }, l.H.M = function(u, f, d) {
      d <<= 7 & f;
      const g = f >>> 3;
      u[g] |= d, u[g + 1] |= d >>> 8;
    }, l.H.I = function(u, f, d) {
      d <<= 7 & f;
      const g = f >>> 3;
      u[g] |= d, u[g + 1] |= d >>> 8, u[g + 2] |= d >>> 16;
    }, l.H.e = function(u, f, d) {
      return (u[f >>> 3] | u[1 + (f >>> 3)] << 8) >>> (7 & f) & (1 << d) - 1;
    }, l.H.b = function(u, f, d) {
      return (u[f >>> 3] | u[1 + (f >>> 3)] << 8 | u[2 + (f >>> 3)] << 16) >>> (7 & f) & (1 << d) - 1;
    }, l.H.Z = function(u, f) {
      return (u[f >>> 3] | u[1 + (f >>> 3)] << 8 | u[2 + (f >>> 3)] << 16) >>> (7 & f);
    }, l.H.i = function(u, f) {
      return (u[f >>> 3] | u[1 + (f >>> 3)] << 8 | u[2 + (f >>> 3)] << 16 | u[3 + (f >>> 3)] << 24) >>> (7 & f);
    }, l.H.m = function() {
      const u = Uint16Array, f = Uint32Array;
      return { K: new u(16), j: new u(16), X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], q: new u(32), p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], c: new f(32), J: new u(512), _: [], h: new u(32), $: [], w: new u(32768), C: [], v: [], d: new u(32768), D: [], u: new u(512), Q: [], r: new u(32768), s: new f(286), Y: new f(30), a: new f(19), t: new f(15e3), k: new u(65536), g: new u(32768) };
    }(), function() {
      const u = l.H.m;
      for (var f = 0; f < 32768; f++) {
        let g = f;
        g = (2863311530 & g) >>> 1 | (1431655765 & g) << 1, g = (3435973836 & g) >>> 2 | (858993459 & g) << 2, g = (4042322160 & g) >>> 4 | (252645135 & g) << 4, g = (4278255360 & g) >>> 8 | (16711935 & g) << 8, u.r[f] = (g >>> 16 | g << 16) >>> 17;
      }
      function d(g, m, p) {
        for (; m-- != 0; ) g.push(0, p);
      }
      for (f = 0; f < 32; f++) u.q[f] = u.S[f] << 3 | u.T[f], u.c[f] = u.p[f] << 4 | u.z[f];
      d(u._, 144, 8), d(u._, 112, 9), d(u._, 24, 7), d(u._, 8, 8), l.H.n(u._, 9), l.H.A(u._, 9, u.J), l.H.l(u._, 9), d(u.$, 32, 5), l.H.n(u.$, 5), l.H.A(u.$, 5, u.h), l.H.l(u.$, 5), d(u.Q, 19, 0), d(u.C, 286, 0), d(u.D, 30, 0), d(u.v, 320, 0);
    }(), l.H.N;
  }();
  function i(l) {
    return [1, null, 3, 1, 2, null, 4][l.ctype] * l.depth;
  }
  function o(l, u, f, d, g) {
    let m = i(u);
    const p = Math.ceil(d * m / 8);
    let v, C;
    m = Math.ceil(m / 8);
    let w = l[f], B = 0;
    if (w > 1 && (l[f] = [0, 0, 1][w - 2]), w == 3) for (B = m; B < p; B++) l[B + 1] = l[B + 1] + (l[B + 1 - m] >>> 1) & 255;
    for (let y = 0; y < g; y++) if (v = f + y * p, C = v + y + 1, w = l[C - 1], B = 0, w == 0) for (; B < p; B++) l[v + B] = l[C + B];
    else if (w == 1) {
      for (; B < m; B++) l[v + B] = l[C + B];
      for (; B < p; B++) l[v + B] = l[C + B] + l[v + B - m];
    } else if (w == 2) for (; B < p; B++) l[v + B] = l[C + B] + l[v + B - p];
    else if (w == 3) {
      for (; B < m; B++) l[v + B] = l[C + B] + (l[v + B - p] >>> 1);
      for (; B < p; B++) l[v + B] = l[C + B] + (l[v + B - p] + l[v + B - m] >>> 1);
    } else {
      for (; B < m; B++) l[v + B] = l[C + B] + s(0, l[v + B - p], 0);
      for (; B < p; B++) l[v + B] = l[C + B] + s(l[v + B - m], l[v + B - p], l[v + B - m - p]);
    }
    return l;
  }
  function s(l, u, f) {
    const d = l + u - f, g = d - l, m = d - u, p = d - f;
    return g * g <= m * m && g * g <= p * p ? l : m * m <= p * p ? u : f;
  }
  function a(l, u, f) {
    f.width = t.readUint(l, u), u += 4, f.height = t.readUint(l, u), u += 4, f.depth = l[u], u++, f.ctype = l[u], u++, f.compress = l[u], u++, f.filter = l[u], u++, f.interlace = l[u], u++;
  }
  function c(l, u, f, d, g, m, p, v, C) {
    const w = Math.min(u, g), B = Math.min(f, m);
    let y = 0, b = 0;
    for (let H = 0; H < B; H++) for (let F = 0; F < w; F++) if (p >= 0 && v >= 0 ? (y = H * u + F << 2, b = (v + H) * g + p + F << 2) : (y = (-v + H) * u - p + F << 2, b = H * g + F << 2), C == 0) d[b] = l[y], d[b + 1] = l[y + 1], d[b + 2] = l[y + 2], d[b + 3] = l[y + 3];
    else if (C == 1) {
      var q = l[y + 3] * 0.00392156862745098, E = l[y] * q, x = l[y + 1] * q, M = l[y + 2] * q, O = d[b + 3] * (1 / 255), I = d[b] * O, S = d[b + 1] * O, P = d[b + 2] * O;
      const T = 1 - q, U = q + O * T, D = U == 0 ? 0 : 1 / U;
      d[b + 3] = 255 * U, d[b + 0] = (E + I * T) * D, d[b + 1] = (x + S * T) * D, d[b + 2] = (M + P * T) * D;
    } else if (C == 2)
      q = l[y + 3], E = l[y], x = l[y + 1], M = l[y + 2], O = d[b + 3], I = d[b], S = d[b + 1], P = d[b + 2], q == O && E == I && x == S && M == P ? (d[b] = 0, d[b + 1] = 0, d[b + 2] = 0, d[b + 3] = 0) : (d[b] = E, d[b + 1] = x, d[b + 2] = M, d[b + 3] = q);
    else if (C == 3) {
      if (q = l[y + 3], E = l[y], x = l[y + 1], M = l[y + 2], O = d[b + 3], I = d[b], S = d[b + 1], P = d[b + 2], q == O && E == I && x == S && M == P) continue;
      if (q < 220 && O > 20) return !1;
    }
    return !0;
  }
  return { decode: function(u) {
    const f = new Uint8Array(u);
    let d = 8;
    const g = t, m = g.readUshort, p = g.readUint, v = { tabs: {}, frames: [] }, C = new Uint8Array(f.length);
    let w, B = 0, y = 0;
    const b = [137, 80, 78, 71, 13, 10, 26, 10];
    for (var q = 0; q < 8; q++) if (f[q] != b[q]) throw "The input is not a PNG file!";
    for (; d < f.length; ) {
      const H = g.readUint(f, d);
      d += 4;
      const F = g.readASCII(f, d, 4);
      if (d += 4, F == "IHDR") a(f, d, v);
      else if (F == "iCCP") {
        for (var E = d; f[E] != 0; ) E++;
        g.readASCII(f, d, E - d), f[E + 1];
        const T = f.slice(E + 2, d + H);
        let U = null;
        try {
          U = n(T);
        } catch {
          U = A(T);
        }
        v.tabs[F] = U;
      } else if (F == "CgBI") v.tabs[F] = f.slice(d, d + 4);
      else if (F == "IDAT") {
        for (q = 0; q < H; q++) C[B + q] = f[d + q];
        B += H;
      } else if (F == "acTL") v.tabs[F] = { num_frames: p(f, d), num_plays: p(f, d + 4) }, w = new Uint8Array(f.length);
      else if (F == "fcTL") {
        y != 0 && ((P = v.frames[v.frames.length - 1]).data = r(v, w.slice(0, y), P.rect.width, P.rect.height), y = 0);
        const T = { x: p(f, d + 12), y: p(f, d + 16), width: p(f, d + 4), height: p(f, d + 8) };
        let U = m(f, d + 22);
        U = m(f, d + 20) / (U == 0 ? 100 : U);
        const D = { rect: T, delay: Math.round(1e3 * U), dispose: f[d + 24], blend: f[d + 25] };
        v.frames.push(D);
      } else if (F == "fdAT") {
        for (q = 0; q < H - 4; q++) w[y + q] = f[d + q + 4];
        y += H - 4;
      } else if (F == "pHYs") v.tabs[F] = [g.readUint(f, d), g.readUint(f, d + 4), f[d + 8]];
      else if (F == "cHRM")
        for (v.tabs[F] = [], q = 0; q < 8; q++) v.tabs[F].push(g.readUint(f, d + 4 * q));
      else if (F == "tEXt" || F == "zTXt") {
        v.tabs[F] == null && (v.tabs[F] = {});
        var x = g.nextZero(f, d), M = g.readASCII(f, d, x - d), O = d + H - x - 1;
        if (F == "tEXt") S = g.readASCII(f, x + 1, O);
        else {
          var I = n(f.slice(x + 2, x + 2 + O));
          S = g.readUTF8(I, 0, I.length);
        }
        v.tabs[F][M] = S;
      } else if (F == "iTXt") {
        v.tabs[F] == null && (v.tabs[F] = {}), x = 0, E = d, x = g.nextZero(f, E), M = g.readASCII(f, E, x - E);
        const T = f[E = x + 1];
        var S;
        f[E + 1], E += 2, x = g.nextZero(f, E), g.readASCII(f, E, x - E), E = x + 1, x = g.nextZero(f, E), g.readUTF8(f, E, x - E), O = H - ((E = x + 1) - d), T == 0 ? S = g.readUTF8(f, E, O) : (I = n(f.slice(E, E + O)), S = g.readUTF8(I, 0, I.length)), v.tabs[F][M] = S;
      } else if (F == "PLTE") v.tabs[F] = g.readBytes(f, d, H);
      else if (F == "hIST") {
        const T = v.tabs.PLTE.length / 3;
        for (v.tabs[F] = [], q = 0; q < T; q++) v.tabs[F].push(m(f, d + 2 * q));
      } else if (F == "tRNS") v.ctype == 3 ? v.tabs[F] = g.readBytes(f, d, H) : v.ctype == 0 ? v.tabs[F] = m(f, d) : v.ctype == 2 && (v.tabs[F] = [m(f, d), m(f, d + 2), m(f, d + 4)]);
      else if (F == "gAMA") v.tabs[F] = g.readUint(f, d) / 1e5;
      else if (F == "sRGB") v.tabs[F] = f[d];
      else if (F == "bKGD") v.ctype == 0 || v.ctype == 4 ? v.tabs[F] = [m(f, d)] : v.ctype == 2 || v.ctype == 6 ? v.tabs[F] = [m(f, d), m(f, d + 2), m(f, d + 4)] : v.ctype == 3 && (v.tabs[F] = f[d]);
      else if (F == "IEND") break;
      d += H, g.readUint(f, d), d += 4;
    }
    var P;
    return y != 0 && ((P = v.frames[v.frames.length - 1]).data = r(v, w.slice(0, y), P.rect.width, P.rect.height)), v.data = r(v, C, v.width, v.height), delete v.compress, delete v.interlace, delete v.filter, v;
  }, toRGBA8: function(u) {
    const f = u.width, d = u.height;
    if (u.tabs.acTL == null) return [e(u.data, f, d, u).buffer];
    const g = [];
    u.frames[0].data == null && (u.frames[0].data = u.data);
    const m = f * d * 4, p = new Uint8Array(m), v = new Uint8Array(m), C = new Uint8Array(m);
    for (let B = 0; B < u.frames.length; B++) {
      const y = u.frames[B], b = y.rect.x, q = y.rect.y, E = y.rect.width, x = y.rect.height, M = e(y.data, E, x, u);
      if (B != 0) for (var w = 0; w < m; w++) C[w] = p[w];
      if (y.blend == 0 ? c(M, E, x, p, f, d, b, q, 0) : y.blend == 1 && c(M, E, x, p, f, d, b, q, 1), g.push(p.buffer.slice(0)), y.dispose != 0) {
        if (y.dispose == 1) c(v, E, x, p, f, d, b, q, 0);
        else if (y.dispose == 2) for (w = 0; w < m; w++) p[w] = C[w];
      }
    }
    return g;
  }, _paeth: s, _copyTile: c, _bin: t };
}();
(function() {
  const { _copyTile: t } = ro, { _bin: e } = ro, r = ro._paeth;
  var n = { table: function() {
    const E = new Uint32Array(256);
    for (let x = 0; x < 256; x++) {
      let M = x;
      for (let O = 0; O < 8; O++) 1 & M ? M = 3988292384 ^ M >>> 1 : M >>>= 1;
      E[x] = M;
    }
    return E;
  }(), update(E, x, M, O) {
    for (let I = 0; I < O; I++) E = n.table[255 & (E ^ x[M + I])] ^ E >>> 8;
    return E;
  }, crc: (E, x, M) => 4294967295 ^ n.update(4294967295, E, x, M) };
  function A(E, x, M, O) {
    x[M] += E[0] * O >> 4, x[M + 1] += E[1] * O >> 4, x[M + 2] += E[2] * O >> 4, x[M + 3] += E[3] * O >> 4;
  }
  function i(E) {
    return Math.max(0, Math.min(255, E));
  }
  function o(E, x) {
    const M = E[0] - x[0], O = E[1] - x[1], I = E[2] - x[2], S = E[3] - x[3];
    return M * M + O * O + I * I + S * S;
  }
  function s(E, x, M, O, I, S, P) {
    P == null && (P = 1);
    const H = O.length, F = [];
    for (var T = 0; T < H; T++) {
      const R = O[T];
      F.push([R >>> 0 & 255, R >>> 8 & 255, R >>> 16 & 255, R >>> 24 & 255]);
    }
    for (T = 0; T < H; T++) {
      let R = 4294967295;
      for (var U = 0, D = 0; D < H; D++) {
        var Q = o(F[T], F[D]);
        D != T && Q < R && (R = Q, U = D);
      }
    }
    const Y = new Uint32Array(I.buffer), j = new Int16Array(x * M * 4), Z = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
    for (T = 0; T < Z.length; T++) Z[T] = 255 * ((Z[T] + 0.5) / 16 - 0.5);
    for (let R = 0; R < M; R++) for (let K = 0; K < x; K++) {
      var W;
      T = 4 * (R * x + K), P != 2 ? W = [i(E[T] + j[T]), i(E[T + 1] + j[T + 1]), i(E[T + 2] + j[T + 2]), i(E[T + 3] + j[T + 3])] : (Q = Z[4 * (3 & R) + (3 & K)], W = [i(E[T] + Q), i(E[T + 1] + Q), i(E[T + 2] + Q), i(E[T + 3] + Q)]), U = 0;
      let L = 16777215;
      for (D = 0; D < H; D++) {
        const _ = o(W, F[D]);
        _ < L && (L = _, U = D);
      }
      const G = F[U], V = [W[0] - G[0], W[1] - G[1], W[2] - G[2], W[3] - G[3]];
      P == 1 && (K != x - 1 && A(V, j, T + 4, 7), R != M - 1 && (K != 0 && A(V, j, T + 4 * x - 4, 3), A(V, j, T + 4 * x, 5), K != x - 1 && A(V, j, T + 4 * x + 4, 1))), S[T >> 2] = U, Y[T >> 2] = O[U];
    }
  }
  function a(E, x, M, O, I) {
    I == null && (I = {});
    const { crc: S } = n, P = e.writeUint, H = e.writeUshort, F = e.writeASCII;
    let T = 8;
    const U = E.frames.length > 1;
    let D, Q = !1, Y = 33 + (U ? 20 : 0);
    if (I.sRGB != null && (Y += 13), I.pHYs != null && (Y += 21), I.iCCP != null && (D = pako.deflate(I.iCCP), Y += 21 + D.length + 4), E.ctype == 3) {
      for (var j = E.plte.length, Z = 0; Z < j; Z++) E.plte[Z] >>> 24 != 255 && (Q = !0);
      Y += 8 + 3 * j + 4 + (Q ? 8 + 1 * j + 4 : 0);
    }
    for (var W = 0; W < E.frames.length; W++)
      U && (Y += 38), Y += (G = E.frames[W]).cimg.length + 12, W != 0 && (Y += 4);
    Y += 12;
    const R = new Uint8Array(Y), K = [137, 80, 78, 71, 13, 10, 26, 10];
    for (Z = 0; Z < 8; Z++) R[Z] = K[Z];
    if (P(R, T, 13), T += 4, F(R, T, "IHDR"), T += 4, P(R, T, x), T += 4, P(R, T, M), T += 4, R[T] = E.depth, T++, R[T] = E.ctype, T++, R[T] = 0, T++, R[T] = 0, T++, R[T] = 0, T++, P(R, T, S(R, T - 17, 17)), T += 4, I.sRGB != null && (P(R, T, 1), T += 4, F(R, T, "sRGB"), T += 4, R[T] = I.sRGB, T++, P(R, T, S(R, T - 5, 5)), T += 4), I.iCCP != null) {
      const V = 13 + D.length;
      P(R, T, V), T += 4, F(R, T, "iCCP"), T += 4, F(R, T, "ICC profile"), T += 11, T += 2, R.set(D, T), T += D.length, P(R, T, S(R, T - (V + 4), V + 4)), T += 4;
    }
    if (I.pHYs != null && (P(R, T, 9), T += 4, F(R, T, "pHYs"), T += 4, P(R, T, I.pHYs[0]), T += 4, P(R, T, I.pHYs[1]), T += 4, R[T] = I.pHYs[2], T++, P(R, T, S(R, T - 13, 13)), T += 4), U && (P(R, T, 8), T += 4, F(R, T, "acTL"), T += 4, P(R, T, E.frames.length), T += 4, P(R, T, I.loop != null ? I.loop : 0), T += 4, P(R, T, S(R, T - 12, 12)), T += 4), E.ctype == 3) {
      for (P(R, T, 3 * (j = E.plte.length)), T += 4, F(R, T, "PLTE"), T += 4, Z = 0; Z < j; Z++) {
        const V = 3 * Z, _ = E.plte[Z], J = 255 & _, X = _ >>> 8 & 255, ne = _ >>> 16 & 255;
        R[T + V + 0] = J, R[T + V + 1] = X, R[T + V + 2] = ne;
      }
      if (T += 3 * j, P(R, T, S(R, T - 3 * j - 4, 3 * j + 4)), T += 4, Q) {
        for (P(R, T, j), T += 4, F(R, T, "tRNS"), T += 4, Z = 0; Z < j; Z++) R[T + Z] = E.plte[Z] >>> 24 & 255;
        T += j, P(R, T, S(R, T - j - 4, j + 4)), T += 4;
      }
    }
    let L = 0;
    for (W = 0; W < E.frames.length; W++) {
      var G = E.frames[W];
      U && (P(R, T, 26), T += 4, F(R, T, "fcTL"), T += 4, P(R, T, L++), T += 4, P(R, T, G.rect.width), T += 4, P(R, T, G.rect.height), T += 4, P(R, T, G.rect.x), T += 4, P(R, T, G.rect.y), T += 4, H(R, T, O[W]), T += 2, H(R, T, 1e3), T += 2, R[T] = G.dispose, T++, R[T] = G.blend, T++, P(R, T, S(R, T - 30, 30)), T += 4);
      const V = G.cimg;
      P(R, T, (j = V.length) + (W == 0 ? 0 : 4)), T += 4;
      const _ = T;
      F(R, T, W == 0 ? "IDAT" : "fdAT"), T += 4, W != 0 && (P(R, T, L++), T += 4), R.set(V, T), T += j, P(R, T, S(R, _, T - _)), T += 4;
    }
    return P(R, T, 0), T += 4, F(R, T, "IEND"), T += 4, P(R, T, S(R, T - 4, 4)), T += 4, R.buffer;
  }
  function c(E, x, M) {
    for (let O = 0; O < E.frames.length; O++) {
      const I = E.frames[O];
      I.rect.width;
      const S = I.rect.height, P = new Uint8Array(S * I.bpl + S);
      I.cimg = d(I.img, S, I.bpp, I.bpl, P, x, M);
    }
  }
  function l(E, x, M, O, I) {
    const S = I[0], P = I[1], H = I[2], F = I[3], T = I[4], U = I[5];
    let D = 6, Q = 8, Y = 255;
    for (var j = 0; j < E.length; j++) {
      const te = new Uint8Array(E[j]);
      for (var Z = te.length, W = 0; W < Z; W += 4) Y &= te[W + 3];
    }
    const R = Y != 255, K = function(ae, se, ue, fe, ve, ge) {
      const oe = [];
      for (var ce = 0; ce < ae.length; ce++) {
        const He = new Uint8Array(ae[ce]), Ge = new Uint32Array(He.buffer);
        var pe;
        let Le = 0, Ae = 0, Pe = se, it = ue, de = fe ? 1 : 0;
        if (ce != 0) {
          const xe = ge || fe || ce == 1 || oe[ce - 2].dispose != 0 ? 1 : 2;
          let he = 0, Qe = 1e9;
          for (let Re = 0; Re < xe; Re++) {
            var qe = new Uint8Array(ae[ce - 1 - Re]);
            const pt = new Uint32Array(ae[ce - 1 - Re]);
            let ze = se, lt = ue, st = -1, We = -1;
            for (let ut = 0; ut < ue; ut++) for (let Be = 0; Be < se; Be++)
              Ge[Te = ut * se + Be] != pt[Te] && (Be < ze && (ze = Be), Be > st && (st = Be), ut < lt && (lt = ut), ut > We && (We = ut));
            st == -1 && (ze = lt = st = We = 0), ve && ((1 & ze) == 1 && ze--, (1 & lt) == 1 && lt--);
            const Je = (st - ze + 1) * (We - lt + 1);
            Je < Qe && (Qe = Je, he = Re, Le = ze, Ae = lt, Pe = st - ze + 1, it = We - lt + 1);
          }
          qe = new Uint8Array(ae[ce - 1 - he]), he == 1 && (oe[ce - 1].dispose = 2), pe = new Uint8Array(Pe * it * 4), t(qe, se, ue, pe, Pe, it, -Le, -Ae, 0), de = t(He, se, ue, pe, Pe, it, -Le, -Ae, 3) ? 1 : 0, de == 1 ? f(He, se, ue, pe, { x: Le, y: Ae, width: Pe, height: it }) : t(He, se, ue, pe, Pe, it, -Le, -Ae, 0);
        } else pe = He.slice(0);
        oe.push({ rect: { x: Le, y: Ae, width: Pe, height: it }, img: pe, blend: de, dispose: 0 });
      }
      if (fe) for (ce = 0; ce < oe.length; ce++) {
        if ((be = oe[ce]).blend == 1) continue;
        const He = be.rect, Ge = oe[ce - 1].rect, Le = Math.min(He.x, Ge.x), Ae = Math.min(He.y, Ge.y), Pe = { x: Le, y: Ae, width: Math.max(He.x + He.width, Ge.x + Ge.width) - Le, height: Math.max(He.y + He.height, Ge.y + Ge.height) - Ae };
        oe[ce - 1].dispose = 1, ce - 1 != 0 && u(ae, se, ue, oe, ce - 1, Pe, ve), u(ae, se, ue, oe, ce, Pe, ve);
      }
      let Se = 0;
      if (ae.length != 1) for (var Te = 0; Te < oe.length; Te++) {
        var be;
        Se += (be = oe[Te]).rect.width * be.rect.height;
      }
      return oe;
    }(E, x, M, S, P, H), L = {}, G = [], V = [];
    if (O != 0) {
      const te = [];
      for (W = 0; W < K.length; W++) te.push(K[W].img.buffer);
      const ae = function(ve) {
        let ge = 0;
        for (var oe = 0; oe < ve.length; oe++) ge += ve[oe].byteLength;
        const ce = new Uint8Array(ge);
        let pe = 0;
        for (oe = 0; oe < ve.length; oe++) {
          const qe = new Uint8Array(ve[oe]), Se = qe.length;
          for (let Te = 0; Te < Se; Te += 4) {
            let be = qe[Te], He = qe[Te + 1], Ge = qe[Te + 2];
            const Le = qe[Te + 3];
            Le == 0 && (be = He = Ge = 0), ce[pe + Te] = be, ce[pe + Te + 1] = He, ce[pe + Te + 2] = Ge, ce[pe + Te + 3] = Le;
          }
          pe += Se;
        }
        return ce.buffer;
      }(te), se = m(ae, O);
      for (W = 0; W < se.plte.length; W++) G.push(se.plte[W].est.rgba);
      let ue = 0;
      for (W = 0; W < K.length; W++) {
        const fe = (J = K[W]).img.length;
        var _ = new Uint8Array(se.inds.buffer, ue >> 2, fe >> 2);
        V.push(_);
        const ve = new Uint8Array(se.abuf, ue, fe);
        U && s(J.img, J.rect.width, J.rect.height, G, ve, _), J.img.set(ve), ue += fe;
      }
    } else for (j = 0; j < K.length; j++) {
      var J = K[j];
      const te = new Uint32Array(J.img.buffer);
      var X = J.rect.width;
      for (Z = te.length, _ = new Uint8Array(Z), V.push(_), W = 0; W < Z; W++) {
        const ae = te[W];
        if (W != 0 && ae == te[W - 1]) _[W] = _[W - 1];
        else if (W > X && ae == te[W - X]) _[W] = _[W - X];
        else {
          let se = L[ae];
          if (se == null && (L[ae] = se = G.length, G.push(ae), G.length >= 300)) break;
          _[W] = se;
        }
      }
    }
    const ne = G.length;
    for (ne <= 256 && T == 0 && (Q = ne <= 2 ? 1 : ne <= 4 ? 2 : ne <= 16 ? 4 : 8, Q = Math.max(Q, F)), j = 0; j < K.length; j++) {
      (J = K[j]).rect.x, J.rect.y, X = J.rect.width;
      const te = J.rect.height;
      let ae = J.img;
      new Uint32Array(ae.buffer);
      let se = 4 * X, ue = 4;
      if (ne <= 256 && T == 0) {
        se = Math.ceil(Q * X / 8);
        var ee = new Uint8Array(se * te);
        const fe = V[j];
        for (let ve = 0; ve < te; ve++) {
          W = ve * se;
          const ge = ve * X;
          if (Q == 8) for (var $ = 0; $ < X; $++) ee[W + $] = fe[ge + $];
          else if (Q == 4) for ($ = 0; $ < X; $++) ee[W + ($ >> 1)] |= fe[ge + $] << 4 - 4 * (1 & $);
          else if (Q == 2) for ($ = 0; $ < X; $++) ee[W + ($ >> 2)] |= fe[ge + $] << 6 - 2 * (3 & $);
          else if (Q == 1) for ($ = 0; $ < X; $++) ee[W + ($ >> 3)] |= fe[ge + $] << 7 - 1 * (7 & $);
        }
        ae = ee, D = 3, ue = 1;
      } else if (R == 0 && K.length == 1) {
        ee = new Uint8Array(X * te * 3);
        const fe = X * te;
        for (W = 0; W < fe; W++) {
          const ve = 3 * W, ge = 4 * W;
          ee[ve] = ae[ge], ee[ve + 1] = ae[ge + 1], ee[ve + 2] = ae[ge + 2];
        }
        ae = ee, D = 2, ue = 3, se = 3 * X;
      }
      J.img = ae, J.bpl = se, J.bpp = ue;
    }
    return { ctype: D, depth: Q, plte: G, frames: K };
  }
  function u(E, x, M, O, I, S, P) {
    const H = Uint8Array, F = Uint32Array, T = new H(E[I - 1]), U = new F(E[I - 1]), D = I + 1 < E.length ? new H(E[I + 1]) : null, Q = new H(E[I]), Y = new F(Q.buffer);
    let j = x, Z = M, W = -1, R = -1;
    for (let L = 0; L < S.height; L++) for (let G = 0; G < S.width; G++) {
      const V = S.x + G, _ = S.y + L, J = _ * x + V, X = Y[J];
      X == 0 || O[I - 1].dispose == 0 && U[J] == X && (D == null || D[4 * J + 3] != 0) || (V < j && (j = V), V > W && (W = V), _ < Z && (Z = _), _ > R && (R = _));
    }
    W == -1 && (j = Z = W = R = 0), P && ((1 & j) == 1 && j--, (1 & Z) == 1 && Z--), S = { x: j, y: Z, width: W - j + 1, height: R - Z + 1 };
    const K = O[I];
    K.rect = S, K.blend = 1, K.img = new Uint8Array(S.width * S.height * 4), O[I - 1].dispose == 0 ? (t(T, x, M, K.img, S.width, S.height, -S.x, -S.y, 0), f(Q, x, M, K.img, S)) : t(Q, x, M, K.img, S.width, S.height, -S.x, -S.y, 0);
  }
  function f(E, x, M, O, I) {
    t(E, x, M, O, I.width, I.height, -I.x, -I.y, 2);
  }
  function d(E, x, M, O, I, S, P) {
    const H = [];
    let F, T = [0, 1, 2, 3, 4];
    S != -1 ? T = [S] : (x * O > 5e5 || M == 1) && (T = [0]), P && (F = { level: 0 });
    const U = ole;
    for (var D = 0; D < T.length; D++) {
      for (let j = 0; j < x; j++) g(I, E, j, O, M, T[D]);
      H.push(U.deflate(I, F));
    }
    let Q, Y = 1e9;
    for (D = 0; D < H.length; D++) H[D].length < Y && (Q = D, Y = H[D].length);
    return H[Q];
  }
  function g(E, x, M, O, I, S) {
    const P = M * O;
    let H = P + M;
    if (E[H] = S, H++, S == 0) if (O < 500) for (var F = 0; F < O; F++) E[H + F] = x[P + F];
    else E.set(new Uint8Array(x.buffer, P, O), H);
    else if (S == 1) {
      for (F = 0; F < I; F++) E[H + F] = x[P + F];
      for (F = I; F < O; F++) E[H + F] = x[P + F] - x[P + F - I] + 256 & 255;
    } else if (M == 0) {
      for (F = 0; F < I; F++) E[H + F] = x[P + F];
      if (S == 2) for (F = I; F < O; F++) E[H + F] = x[P + F];
      if (S == 3) for (F = I; F < O; F++) E[H + F] = x[P + F] - (x[P + F - I] >> 1) + 256 & 255;
      if (S == 4) for (F = I; F < O; F++) E[H + F] = x[P + F] - r(x[P + F - I], 0, 0) + 256 & 255;
    } else {
      if (S == 2) for (F = 0; F < O; F++) E[H + F] = x[P + F] + 256 - x[P + F - O] & 255;
      if (S == 3) {
        for (F = 0; F < I; F++) E[H + F] = x[P + F] + 256 - (x[P + F - O] >> 1) & 255;
        for (F = I; F < O; F++) E[H + F] = x[P + F] + 256 - (x[P + F - O] + x[P + F - I] >> 1) & 255;
      }
      if (S == 4) {
        for (F = 0; F < I; F++) E[H + F] = x[P + F] + 256 - r(0, x[P + F - O], 0) & 255;
        for (F = I; F < O; F++) E[H + F] = x[P + F] + 256 - r(x[P + F - I], x[P + F - O], x[P + F - I - O]) & 255;
      }
    }
  }
  function m(E, x) {
    const M = new Uint8Array(E), O = M.slice(0), I = new Uint32Array(O.buffer), S = p(O, x), P = S[0], H = S[1], F = M.length, T = new Uint8Array(F >> 2);
    let U;
    if (M.length < 2e7) for (var D = 0; D < F; D += 4)
      U = v(P, Q = M[D] * (1 / 255), Y = M[D + 1] * (1 / 255), j = M[D + 2] * (1 / 255), Z = M[D + 3] * (1 / 255)), T[D >> 2] = U.ind, I[D >> 2] = U.est.rgba;
    else for (D = 0; D < F; D += 4) {
      var Q = M[D] * 0.00392156862745098, Y = M[D + 1] * (1 / 255), j = M[D + 2] * (1 / 255), Z = M[D + 3] * (1 / 255);
      for (U = P; U.left; ) U = C(U.est, Q, Y, j, Z) <= 0 ? U.left : U.right;
      T[D >> 2] = U.ind, I[D >> 2] = U.est.rgba;
    }
    return { abuf: O.buffer, inds: T, plte: H };
  }
  function p(E, x, M) {
    M == null && (M = 1e-4);
    const O = new Uint32Array(E.buffer), I = { i0: 0, i1: E.length, bst: null, est: null, tdst: 0, left: null, right: null };
    I.bst = y(E, I.i0, I.i1), I.est = b(I.bst);
    const S = [I];
    for (; S.length < x; ) {
      let H = 0, F = 0;
      for (var P = 0; P < S.length; P++) S[P].est.L > H && (H = S[P].est.L, F = P);
      if (H < M) break;
      const T = S[F], U = w(E, O, T.i0, T.i1, T.est.e, T.est.eMq255);
      if (T.i0 >= U || T.i1 <= U) {
        T.est.L = 0;
        continue;
      }
      const D = { i0: T.i0, i1: U, bst: null, est: null, tdst: 0, left: null, right: null };
      D.bst = y(E, D.i0, D.i1), D.est = b(D.bst);
      const Q = { i0: U, i1: T.i1, bst: null, est: null, tdst: 0, left: null, right: null };
      for (Q.bst = { R: [], m: [], N: T.bst.N - D.bst.N }, P = 0; P < 16; P++) Q.bst.R[P] = T.bst.R[P] - D.bst.R[P];
      for (P = 0; P < 4; P++) Q.bst.m[P] = T.bst.m[P] - D.bst.m[P];
      Q.est = b(Q.bst), T.left = D, T.right = Q, S[F] = D, S.push(Q);
    }
    for (S.sort((H, F) => F.bst.N - H.bst.N), P = 0; P < S.length; P++) S[P].ind = P;
    return [I, S];
  }
  function v(E, x, M, O, I) {
    if (E.left == null) return E.tdst = function(D, Q, Y, j, Z) {
      const W = Q - D[0], R = Y - D[1], K = j - D[2], L = Z - D[3];
      return W * W + R * R + K * K + L * L;
    }(E.est.q, x, M, O, I), E;
    const S = C(E.est, x, M, O, I);
    let P = E.left, H = E.right;
    S > 0 && (P = E.right, H = E.left);
    const F = v(P, x, M, O, I);
    if (F.tdst <= S * S) return F;
    const T = v(H, x, M, O, I);
    return T.tdst < F.tdst ? T : F;
  }
  function C(E, x, M, O, I) {
    const { e: S } = E;
    return S[0] * x + S[1] * M + S[2] * O + S[3] * I - E.eMq;
  }
  function w(E, x, M, O, I, S) {
    for (O -= 4; M < O; ) {
      for (; B(E, M, I) <= S; ) M += 4;
      for (; B(E, O, I) > S; ) O -= 4;
      if (M >= O) break;
      const P = x[M >> 2];
      x[M >> 2] = x[O >> 2], x[O >> 2] = P, M += 4, O -= 4;
    }
    for (; B(E, M, I) > S; ) M -= 4;
    return M + 4;
  }
  function B(E, x, M) {
    return E[x] * M[0] + E[x + 1] * M[1] + E[x + 2] * M[2] + E[x + 3] * M[3];
  }
  function y(E, x, M) {
    const O = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], I = [0, 0, 0, 0], S = M - x >> 2;
    for (let P = x; P < M; P += 4) {
      const H = E[P] * 0.00392156862745098, F = E[P + 1] * (1 / 255), T = E[P + 2] * (1 / 255), U = E[P + 3] * (1 / 255);
      I[0] += H, I[1] += F, I[2] += T, I[3] += U, O[0] += H * H, O[1] += H * F, O[2] += H * T, O[3] += H * U, O[5] += F * F, O[6] += F * T, O[7] += F * U, O[10] += T * T, O[11] += T * U, O[15] += U * U;
    }
    return O[4] = O[1], O[8] = O[2], O[9] = O[6], O[12] = O[3], O[13] = O[7], O[14] = O[11], { R: O, m: I, N: S };
  }
  function b(E) {
    const { R: x } = E, { m: M } = E, { N: O } = E, I = M[0], S = M[1], P = M[2], H = M[3], F = O == 0 ? 0 : 1 / O, T = [x[0] - I * I * F, x[1] - I * S * F, x[2] - I * P * F, x[3] - I * H * F, x[4] - S * I * F, x[5] - S * S * F, x[6] - S * P * F, x[7] - S * H * F, x[8] - P * I * F, x[9] - P * S * F, x[10] - P * P * F, x[11] - P * H * F, x[12] - H * I * F, x[13] - H * S * F, x[14] - H * P * F, x[15] - H * H * F], U = T, D = q;
    let Q = [Math.random(), Math.random(), Math.random(), Math.random()], Y = 0, j = 0;
    if (O != 0) for (let W = 0; W < 16 && (Q = D.multVec(U, Q), j = Math.sqrt(D.dot(Q, Q)), Q = D.sml(1 / j, Q), !(W != 0 && Math.abs(j - Y) < 1e-9)); W++) Y = j;
    const Z = [I * F, S * F, P * F, H * F];
    return { Cov: T, q: Z, e: Q, L: Y, eMq255: D.dot(D.sml(255, Z), Q), eMq: D.dot(Q, Z), rgba: (Math.round(255 * Z[3]) << 24 | Math.round(255 * Z[2]) << 16 | Math.round(255 * Z[1]) << 8 | Math.round(255 * Z[0]) << 0) >>> 0 };
  }
  var q = { multVec: (E, x) => [E[0] * x[0] + E[1] * x[1] + E[2] * x[2] + E[3] * x[3], E[4] * x[0] + E[5] * x[1] + E[6] * x[2] + E[7] * x[3], E[8] * x[0] + E[9] * x[1] + E[10] * x[2] + E[11] * x[3], E[12] * x[0] + E[13] * x[1] + E[14] * x[2] + E[15] * x[3]], dot: (E, x) => E[0] * x[0] + E[1] * x[1] + E[2] * x[2] + E[3] * x[3], sml: (E, x) => [E * x[0], E * x[1], E * x[2], E * x[3]] };
  ro.encode = function(x, M, O, I, S, P, H) {
    I == null && (I = 0), H == null && (H = !1);
    const F = l(x, M, O, I, [!1, !1, !1, 0, H, !1]);
    return c(F, -1), a(F, M, O, S, P);
  }, ro.encodeLL = function(x, M, O, I, S, P, H, F) {
    const T = { ctype: 0 + (I == 1 ? 0 : 2) + (S == 0 ? 0 : 4), depth: P, frames: [] }, U = (I + S) * P, D = U * M;
    for (let Q = 0; Q < x.length; Q++) T.frames.push({ rect: { x: 0, y: 0, width: M, height: O }, img: new Uint8Array(x[Q]), blend: 0, dispose: 1, bpp: Math.ceil(U / 8), bpl: Math.ceil(D / 8) });
    return c(T, 0, !0), a(T, M, O, H, F);
  }, ro.encode.compress = l, ro.encode.dither = s, ro.quantize = m, ro.quantize.getKDtree = p, ro.quantize.getNearest = v;
})();
const FH = { toArrayBuffer(t, e) {
  const r = t.width, n = t.height, A = r << 2, i = t.getContext("2d").getImageData(0, 0, r, n), o = new Uint32Array(i.data.buffer), s = (32 * r + 31) / 32 << 2, a = s * n, c = 122 + a, l = new ArrayBuffer(c), u = new DataView(l), f = 1 << 20;
  let d, g, m, p, v = f, C = 0, w = 0, B = 0;
  function y(E) {
    u.setUint16(w, E, !0), w += 2;
  }
  function b(E) {
    u.setUint32(w, E, !0), w += 4;
  }
  function q(E) {
    w += E;
  }
  y(19778), b(c), q(4), b(122), b(108), b(r), b(-n >>> 0), y(1), y(32), b(3), b(a), b(2835), b(2835), q(8), b(16711680), b(65280), b(255), b(4278190080), b(1466527264), function E() {
    for (; C < n && v > 0; ) {
      for (p = 122 + C * s, d = 0; d < A; ) v--, g = o[B++], m = g >>> 24, u.setUint32(p + d, g << 8 | m), d += 4;
      C++;
    }
    B < o.length ? (v = f, setTimeout(E, FH._dly)) : e(l);
  }();
}, toBlob(t, e) {
  this.toArrayBuffer(t, (r) => {
    e(new Blob([r], { type: "image/bmp" }));
  });
}, _dly: 9 };
var ni = { CHROME: "CHROME", FIREFOX: "FIREFOX", DESKTOP_SAFARI: "DESKTOP_SAFARI", IE: "IE", IOS: "IOS", ETC: "ETC" }, sle = { [ni.CHROME]: 16384, [ni.FIREFOX]: 11180, [ni.DESKTOP_SAFARI]: 16384, [ni.IE]: 8192, [ni.IOS]: 4096, [ni.ETC]: 8192 };
const Zv = typeof window < "u", TH = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, j3 = Zv && window.cordova && window.cordova.require && window.cordova.require("cordova/modulemapper"), ale = (Zv || TH) && (j3 && j3.getOriginalSymbol(window, "File") || typeof File < "u" && File), MH = (Zv || TH) && (j3 && j3.getOriginalSymbol(window, "FileReader") || typeof FileReader < "u" && FileReader);
function Jv(t, e, r = Date.now()) {
  return new Promise((n) => {
    const A = t.split(","), i = A[0].match(/:(.*?);/)[1], o = globalThis.atob(A[1]);
    let s = o.length;
    const a = new Uint8Array(s);
    for (; s--; ) a[s] = o.charCodeAt(s);
    const c = new Blob([a], { type: i });
    c.name = e, c.lastModified = r, n(c);
  });
}
function HH(t) {
  return new Promise((e, r) => {
    const n = new MH();
    n.onload = () => e(n.result), n.onerror = (A) => r(A), n.readAsDataURL(t);
  });
}
function DH(t) {
  return new Promise((e, r) => {
    const n = new Image();
    n.onload = () => e(n), n.onerror = (A) => r(A), n.src = t;
  });
}
function bc() {
  if (bc.cachedResult !== void 0) return bc.cachedResult;
  let t = ni.ETC;
  const { userAgent: e } = navigator;
  return /Chrom(e|ium)/i.test(e) ? t = ni.CHROME : /iP(ad|od|hone)/i.test(e) && /WebKit/i.test(e) ? t = ni.IOS : /Safari/i.test(e) ? t = ni.DESKTOP_SAFARI : /Firefox/i.test(e) ? t = ni.FIREFOX : (/MSIE/i.test(e) || document.documentMode) && (t = ni.IE), bc.cachedResult = t, bc.cachedResult;
}
function QH(t, e) {
  const r = bc(), n = sle[r];
  let A = t, i = e, o = A * i;
  const s = A > i ? i / A : A / i;
  for (; o > n * n; ) {
    const a = (n + A) / 2, c = (n + i) / 2;
    a < c ? (i = c, A = c * s) : (i = a * s, A = a), o = A * i;
  }
  return { width: A, height: i };
}
function w4(t, e) {
  let r, n;
  try {
    if (r = new OffscreenCanvas(t, e), n = r.getContext("2d"), n === null) throw new Error("getContext of OffscreenCanvas returns null");
  } catch {
    r = document.createElement("canvas"), n = r.getContext("2d");
  }
  return r.width = t, r.height = e, [r, n];
}
function UH(t, e) {
  const { width: r, height: n } = QH(t.width, t.height), [A, i] = w4(r, n);
  return e && /jpe?g/.test(e) && (i.fillStyle = "white", i.fillRect(0, 0, A.width, A.height)), i.drawImage(t, 0, 0, A.width, A.height), A;
}
function kh() {
  return kh.cachedResult !== void 0 || (kh.cachedResult = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && typeof document < "u" && "ontouchend" in document), kh.cachedResult;
}
function L3(t, e = {}) {
  return new Promise(function(r, n) {
    let A, i;
    var o = function() {
      try {
        return i = UH(A, e.fileType || t.type), r([A, i]);
      } catch (a) {
        return n(a);
      }
    }, s = function(a) {
      try {
        var c = function(l) {
          try {
            throw l;
          } catch (u) {
            return n(u);
          }
        };
        try {
          let l;
          return HH(t).then(function(u) {
            try {
              return l = u, DH(l).then(function(f) {
                try {
                  return A = f, function() {
                    try {
                      return o();
                    } catch (d) {
                      return n(d);
                    }
                  }();
                } catch (d) {
                  return c(d);
                }
              }, c);
            } catch (f) {
              return c(f);
            }
          }, c);
        } catch (l) {
          c(l);
        }
      } catch (l) {
        return n(l);
      }
    };
    try {
      if (kh() || [ni.DESKTOP_SAFARI, ni.MOBILE_SAFARI].includes(bc())) throw new Error("Skip createImageBitmap on IOS and Safari");
      return createImageBitmap(t).then(function(a) {
        try {
          return A = a, o();
        } catch {
          return s();
        }
      }, s);
    } catch {
      s();
    }
  });
}
function G3(t, e, r, n, A = 1) {
  return new Promise(function(i, o) {
    let s;
    if (e === "image/png") {
      let c, l, u;
      return c = t.getContext("2d"), { data: l } = c.getImageData(0, 0, t.width, t.height), u = ro.encode([l.buffer], t.width, t.height, 4096 * A), s = new Blob([u], { type: e }), s.name = r, s.lastModified = n, a.call(this);
    }
    {
      let c = function() {
        return a.call(this);
      };
      if (e === "image/bmp") return new Promise((l) => FH.toBlob(t, l)).then((function(l) {
        try {
          return s = l, s.name = r, s.lastModified = n, c.call(this);
        } catch (u) {
          return o(u);
        }
      }).bind(this), o);
      {
        let l = function() {
          return c.call(this);
        };
        if (typeof OffscreenCanvas == "function" && t instanceof OffscreenCanvas) return t.convertToBlob({ type: e, quality: A }).then((function(u) {
          try {
            return s = u, s.name = r, s.lastModified = n, l.call(this);
          } catch (f) {
            return o(f);
          }
        }).bind(this), o);
        {
          let u;
          return u = t.toDataURL(e, A), Jv(u, r, n).then((function(f) {
            try {
              return s = f, l.call(this);
            } catch (d) {
              return o(d);
            }
          }).bind(this), o);
        }
      }
    }
    function a() {
      return i(s);
    }
  });
}
function Qo(t) {
  t.width = 0, t.height = 0;
}
function Xl() {
  return new Promise(function(t, e) {
    let r, n, A, i;
    return Xl.cachedResult !== void 0 ? t(Xl.cachedResult) : Jv("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", "test.jpg", Date.now()).then(function(o) {
      try {
        return r = o, L3(r).then(function(s) {
          try {
            return n = s[1], G3(n, r.type, r.name, r.lastModified).then(function(a) {
              try {
                return A = a, Qo(n), L3(A).then(function(c) {
                  try {
                    return i = c[0], Xl.cachedResult = i.width === 1 && i.height === 2, t(Xl.cachedResult);
                  } catch (l) {
                    return e(l);
                  }
                }, e);
              } catch (c) {
                return e(c);
              }
            }, e);
          } catch (a) {
            return e(a);
          }
        }, e);
      } catch (s) {
        return e(s);
      }
    }, e);
  });
}
function NH(t) {
  return new Promise((e, r) => {
    const n = new MH();
    n.onload = (A) => {
      const i = new DataView(A.target.result);
      if (i.getUint16(0, !1) != 65496) return e(-2);
      const o = i.byteLength;
      let s = 2;
      for (; s < o; ) {
        if (i.getUint16(s + 2, !1) <= 8) return e(-1);
        const a = i.getUint16(s, !1);
        if (s += 2, a == 65505) {
          if (i.getUint32(s += 2, !1) != 1165519206) return e(-1);
          const c = i.getUint16(s += 6, !1) == 18761;
          s += i.getUint32(s + 4, c);
          const l = i.getUint16(s, c);
          s += 2;
          for (let u = 0; u < l; u++) if (i.getUint16(s + 12 * u, c) == 274) return e(i.getUint16(s + 12 * u + 8, c));
        } else {
          if ((65280 & a) != 65280) break;
          s += i.getUint16(s, !1);
        }
      }
      return e(-1);
    }, n.onerror = (A) => r(A), n.readAsArrayBuffer(t);
  });
}
function jH(t, e) {
  const { width: r } = t, { height: n } = t, { maxWidthOrHeight: A } = e;
  let i, o = t;
  return isFinite(A) && (r > A || n > A) && ([o, i] = w4(r, n), r > n ? (o.width = A, o.height = n / r * A) : (o.width = r / n * A, o.height = A), i.drawImage(t, 0, 0, o.width, o.height), Qo(t)), o;
}
function LH(t, e) {
  const { width: r } = t, { height: n } = t, [A, i] = w4(r, n);
  switch (e > 4 && e < 9 ? (A.width = n, A.height = r) : (A.width = r, A.height = n), e) {
    case 2:
      i.transform(-1, 0, 0, 1, r, 0);
      break;
    case 3:
      i.transform(-1, 0, 0, -1, r, n);
      break;
    case 4:
      i.transform(1, 0, 0, -1, 0, n);
      break;
    case 5:
      i.transform(0, 1, 1, 0, 0, 0);
      break;
    case 6:
      i.transform(0, 1, -1, 0, n, 0);
      break;
    case 7:
      i.transform(0, -1, -1, 0, n, r);
      break;
    case 8:
      i.transform(0, -1, 1, 0, 0, r);
  }
  return i.drawImage(t, 0, 0, r, n), Qo(t), A;
}
function JB(t, e, r = 0) {
  return new Promise(function(n, A) {
    let i, o, s, a, c, l, u, f, d, g, m, p, v, C, w, B, y, b, q, E;
    function x(O = 5) {
      if (e.signal && e.signal.aborted) throw e.signal.reason;
      i += O, e.onProgress(Math.min(i, 100));
    }
    function M(O) {
      if (e.signal && e.signal.aborted) throw e.signal.reason;
      i = Math.min(Math.max(O, i), 100), e.onProgress(i);
    }
    return i = r, o = e.maxIteration || 10, s = 1024 * e.maxSizeMB * 1024, x(), L3(t, e).then((function(O) {
      try {
        return [, a] = O, x(), c = jH(a, e), x(), new Promise(function(I, S) {
          var P;
          if (!(P = e.exifOrientation)) return NH(t).then((function(F) {
            try {
              return P = F, H.call(this);
            } catch (T) {
              return S(T);
            }
          }).bind(this), S);
          function H() {
            return I(P);
          }
          return H.call(this);
        }).then((function(I) {
          try {
            return l = I, x(), Xl().then((function(S) {
              try {
                return u = S ? c : LH(c, l), x(), f = e.initialQuality || 1, d = e.fileType || t.type, G3(u, d, t.name, t.lastModified, f).then((function(P) {
                  try {
                    {
                      let F = function() {
                        if (o-- && (w > s || w > v)) {
                          let U, D;
                          return U = E ? 0.95 * q.width : q.width, D = E ? 0.95 * q.height : q.height, [y, b] = w4(U, D), b.drawImage(q, 0, 0, U, D), f *= d === "image/png" ? 0.85 : 0.95, G3(y, d, t.name, t.lastModified, f).then(function(Q) {
                            try {
                              return B = Q, Qo(q), q = y, w = B.size, M(Math.min(99, Math.floor((C - w) / (C - s) * 100))), F;
                            } catch (Y) {
                              return A(Y);
                            }
                          }, A);
                        }
                        return [1];
                      }, T = function() {
                        return Qo(q), Qo(y), Qo(c), Qo(u), Qo(a), M(100), n(B);
                      };
                      if (g = P, x(), m = g.size > s, p = g.size > t.size, !m && !p) return M(100), n(g);
                      var H;
                      return v = t.size, C = g.size, w = C, q = u, E = !e.alwaysKeepResolution && m, (H = (function(U) {
                        for (; U; ) {
                          if (U.then) return void U.then(H, A);
                          try {
                            if (U.pop) {
                              if (U.length) return U.pop() ? T.call(this) : U;
                              U = F;
                            } else U = U.call(this);
                          } catch (D) {
                            return A(D);
                          }
                        }
                      }).bind(this))(F);
                    }
                  } catch (F) {
                    return A(F);
                  }
                }).bind(this), A);
              } catch (P) {
                return A(P);
              }
            }).bind(this), A);
          } catch (S) {
            return A(S);
          }
        }).bind(this), A);
      } catch (I) {
        return A(I);
      }
    }).bind(this), A);
  });
}
const cle = `
let scriptImported = false
self.addEventListener('message', async (e) => {
  const { file, id, imageCompressionLibUrl, options } = e.data
  options.onProgress = (progress) => self.postMessage({ progress, id })
  try {
    if (!scriptImported) {
      // console.log('[worker] importScripts', imageCompressionLibUrl)
      self.importScripts(imageCompressionLibUrl)
      scriptImported = true
    }
    // console.log('[worker] self', self)
    const compressedFile = await imageCompression(file, options)
    self.postMessage({ file: compressedFile, id })
  } catch (e) {
    // console.error('[worker] error', e)
    self.postMessage({ error: e.message + '\\n' + e.stack, id })
  }
})
`;
let l6;
function lle(t, e) {
  return new Promise((r, n) => {
    l6 || (l6 = function(o) {
      const s = [];
      return s.push(o), URL.createObjectURL(new Blob(s));
    }(cle));
    const A = new Worker(l6);
    A.addEventListener("message", function(o) {
      if (e.signal && e.signal.aborted) A.terminate();
      else if (o.data.progress === void 0) {
        if (o.data.error) return n(new Error(o.data.error)), void A.terminate();
        r(o.data.file), A.terminate();
      } else e.onProgress(o.data.progress);
    }), A.addEventListener("error", n), e.signal && e.signal.addEventListener("abort", () => {
      n(e.signal.reason), A.terminate();
    }), A.postMessage({ file: t, imageCompressionLibUrl: e.libURL, options: { ...e, onProgress: void 0, signal: void 0 } });
  });
}
function xA(t, e) {
  return new Promise(function(r, n) {
    let A, i, o, s, a, c;
    if (A = { ...e }, o = 0, { onProgress: s } = A, A.maxSizeMB = A.maxSizeMB || Number.POSITIVE_INFINITY, a = typeof A.useWebWorker != "boolean" || A.useWebWorker, delete A.useWebWorker, A.onProgress = (d) => {
      o = d, typeof s == "function" && s(o);
    }, !(t instanceof Blob || t instanceof ale)) return n(new Error("The file given is not an instance of Blob or File"));
    if (!/^image/.test(t.type)) return n(new Error("The file given is not an image"));
    if (c = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, !a || typeof Worker != "function" || c) return JB(t, A).then((function(d) {
      try {
        return i = d, f.call(this);
      } catch (g) {
        return n(g);
      }
    }).bind(this), n);
    var l = (function() {
      try {
        return f.call(this);
      } catch (d) {
        return n(d);
      }
    }).bind(this), u = function(d) {
      try {
        return JB(t, A).then(function(g) {
          try {
            return i = g, l();
          } catch (m) {
            return n(m);
          }
        }, n);
      } catch (g) {
        return n(g);
      }
    };
    try {
      return A.libURL = A.libURL || "https://cdn.jsdelivr.net/npm/browser-image-compression@2.0.2/dist/browser-image-compression.js", lle(t, A).then(function(d) {
        try {
          return i = d, l();
        } catch {
          return u();
        }
      }, u);
    } catch {
      u();
    }
    function f() {
      try {
        i.name = t.name, i.lastModified = t.lastModified;
      } catch {
      }
      try {
        A.preserveExif && t.type === "image/jpeg" && (!A.fileType || A.fileType && A.fileType === t.type) && (i = OH(t, i));
      } catch {
      }
      return r(i);
    }
  });
}
xA.getDataUrlFromFile = HH, xA.getFilefromDataUrl = Jv, xA.loadImage = DH, xA.drawImageInCanvas = UH, xA.drawFileInCanvas = L3, xA.canvasToFile = G3, xA.getExifOrientation = NH, xA.handleMaxWidthOrHeight = jH, xA.followExifOrientation = LH, xA.cleanupCanvasMemory = Qo, xA.isAutoOrientationInBrowser = Xl, xA.approximateBelowMaximumCanvasSizeOfBrowser = QH, xA.copyExifWithoutOrientation = OH, xA.getBrowserName = bc, xA.version = "2.0.2";
class ule {
  constructor(e = {}, r = {}, n = [], A = "", i = {}, o = {}, s, a, c, l, u, f, d) {
    ke(this, "ContactUs");
    ke(this, "GeneralFeedback");
    ke(this, "Headers");
    ke(this, "PrimaryButtonText");
    ke(this, "ReportBug");
    ke(this, "RequestFeature");
    ke(this, "SecondaryButtonText");
    ke(this, "contactUrl");
    ke(this, "iconColor");
    ke(this, "ratingStyle");
    ke(this, "showFooter");
    ke(this, "starBorderColor");
    ke(this, "starColor");
    this.ContactUs = e, this.GeneralFeedback = r, this.Headers = n, this.PrimaryButtonText = A, this.ReportBug = i, this.RequestFeature = o, this.SecondaryButtonText = s, this.contactUrl = a, this.iconColor = c, this.ratingStyle = l, this.showFooter = u, this.starBorderColor = f, this.starColor = d;
  }
  getContactUs() {
    return this.ContactUs;
  }
  getGeneralFeedback() {
    return this.GeneralFeedback;
  }
  getHeaders() {
    return this.Headers;
  }
  getPrimaryButtonText() {
    return this.PrimaryButtonText;
  }
  getReportBug() {
    return this.ReportBug;
  }
  getRequestFeature() {
    return this.RequestFeature;
  }
  getSecondaryButtonText() {
    return this.SecondaryButtonText;
  }
  getcontactUrl() {
    return this.contactUrl;
  }
  geticonColor() {
    return this.iconColor;
  }
  getratingStyle() {
    return this.ratingStyle;
  }
  getshowFooter() {
    return this.showFooter;
  }
  getstarBorderColor() {
    return this.starBorderColor;
  }
  getstarColor() {
    return this.starColor;
  }
}
const dle = ({
  onClose: t,
  GeneralFunctions: e,
  handleOptionClick: r,
  setCardHovered: n,
  cardHovered: A,
  questIds: i,
  title: o
}) => {
  var d, g, m, p, v;
  const { feedbackWorkflowFunctions: s, themeManager: a } = tl(), c = {}, l = "#939393", u = [
    {
      id: "GeneralFeedback",
      trackingEvent: "quest_feedback_workflow_general_feedback_clicked",
      trackingCategory: "feedback_workflow_general_feedback",
      icon: UM,
      defaultHeading: "General Feedback",
      defaultDescription: "Give general feedback on this page",
      getOptionData: () => s.getGeneralFeedback() || {}
    },
    {
      id: "ReportBug",
      trackingEvent: "quest_feedback_workflow_report_bug_clicked",
      trackingCategory: "feedback_workflow_report_bug",
      icon: NM,
      defaultHeading: "Report a Bug",
      defaultDescription: "Let us know what's broken",
      getOptionData: () => s.getReportBug() || {}
    },
    {
      id: "RequestFeature",
      trackingEvent: "quest_feedback_workflow_request_feature_clicked",
      trackingCategory: "feedback_workflow_request_feature",
      icon: jM,
      defaultHeading: "Request a Feature",
      defaultDescription: "Tell us how we can improve",
      getOptionData: () => s.getRequestFeature() || {}
    },
    {
      id: "ContactUs",
      trackingEvent: "quest_feedback_workflow_contactus_clicked",
      trackingCategory: "feedback_workflow_contactus",
      icon: LM,
      defaultHeading: "Contact us",
      defaultDescription: "Tell us how we can help",
      getOptionData: () => s.getContactUs() || {}
    }
  ], f = (C, w) => {
    var b;
    const B = (A == null ? void 0 : A[w]) ?? !1, y = C.getOptionData();
    return /* @__PURE__ */ k(
      "div",
      {
        onClick: () => {
          e.fireTrackingEvent(
            C.trackingEvent,
            C.trackingCategory
          ), r == null || r(C.id, i == null ? void 0 : i[w]);
        },
        className: "q-hover q-fw-cards",
        onMouseEnter: () => {
          const q = Array(4).fill(!1);
          q[w] = !0, n == null || n(q);
        },
        onMouseLeave: () => n == null ? void 0 : n(Array(4).fill(!1)),
        style: {
          background: B ? a.getListHoverCardStyle().background : "transparent",
          borderRadius: "8px"
        },
        children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_feedback_icon",
              style: {
                background: B ? a == null ? void 0 : a.getListHoverIconStyle().background : "#FBFBFB",
                ...a == null ? void 0 : a.getListHoverIcon()
              },
              children: y != null && y.iconUrl ? /* @__PURE__ */ h(
                "img",
                {
                  className: "q_feedback_icon_imgurl",
                  src: y.iconUrl,
                  alt: C.defaultHeading
                }
              ) : C.icon(
                B ? (a == null ? void 0 : a.getListHoverSvg().color) || "#9035FF" : l,
                (b = c.listHover) == null ? void 0 : b.IconSize
              )
            }
          ),
          /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-fw-tab-heading",
                style: {
                  color: B ? a.getListHoverHeadingStyle1().color : a.getListHoverHeadingStyle2().color,
                  ...a == null ? void 0 : a.getListHeadingStyle()
                },
                children: (y == null ? void 0 : y.heading) || C.defaultHeading
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-fw-tab-description",
                style: {
                  color: B ? a == null ? void 0 : a.getListHoverDescriptionStyle1().color : a.getListHoverDescriptionStyle2().color,
                  ...a.getListDescriptionStyle()
                },
                children: (y == null ? void 0 : y.description) || C.defaultDescription
              }
            )
          ] })
        ]
      },
      C.id
    );
  };
  return /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "q-fw-crossBtn", children: [
      /* @__PURE__ */ h("p", { className: "q-fw-tab-heading", children: o || "" }),
      /* @__PURE__ */ h("div", { onClick: t, children: I3(s.geticonColor()) })
    ] }),
    /* @__PURE__ */ h("div", { className: "q-fw-content-box", children: u.map((C, w) => f(C, w)) }),
    /* @__PURE__ */ h("div", { children: s.getshowFooter() && /* @__PURE__ */ h(
      Pr,
      {
        style: (d = a == null ? void 0 : a.getFooterStyles()) == null ? void 0 : d.FooterStyle,
        textStyle: (g = a == null ? void 0 : a.getFooterStyles()) == null ? void 0 : g.FooterTextStyle,
        iconStyle: (m = a == null ? void 0 : a.getFooterStyles()) == null ? void 0 : m.FooterIcon,
        text: (p = a == null ? void 0 : a.getFooterStyles()) == null ? void 0 : p.FooterText,
        link: (v = a == null ? void 0 : a.getFooterStyles()) == null ? void 0 : v.FooterLink
      }
    ) })
  ] });
}, ho = ({
  htmlFor: t,
  style: e,
  children: r,
  className: n,
  id: A
}) => {
  const { themeConfig: i } = Xe(ct.Context);
  return /* @__PURE__ */ h(
    "label",
    {
      htmlFor: t,
      style: { color: i.primaryColor, ...e },
      className: `q_modular_label ${n || ""}`,
      id: A,
      children: r
    }
  );
}, _v = ({ question: t, criteriaId: e, placeholder: r, required: n, answer: A, handleUpdate: i }) => {
  const { themeManager: o } = tl(), s = o == null ? void 0 : o.getLabelStyles(), a = o == null ? void 0 : o.getInputStyles();
  return /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ h(
      ho,
      {
        htmlFor: "normalInput",
        children: `${t}${n === !0 ? "*" : ""}`,
        style: (
          //     {
          //     ...themeManager?.getLabelStyles(),
          //     color:
          //         themeManager?.getLabelStyles().color,
          // }
          s
        )
      }
    ),
    /* @__PURE__ */ h(
      Li,
      {
        type: "text",
        style: (
          //     {
          //     ...themeManager.getInputStyles(),
          //     color:
          //         themeManager.getInputStyles().color,
          // }
          a
        ),
        placeholder: r || t,
        value: A[e],
        onChange: (c) => i(c, e, ""),
        required: n
      }
    )
  ] }, e);
}, $v = ({
  question: t,
  criteriaId: e,
  placeholder: r,
  required: n,
  answer: A,
  handleUpdate: i,
  feedbackType: o
}) => {
  var f, d;
  const { themeManager: s } = tl(), a = s == null ? void 0 : s.getLabelStyles(), c = s == null ? void 0 : s.getInputStyles(), l = (f = s == null ? void 0 : s.getGeneralFeedbackEmailText) == null ? void 0 : f.call(s, o), u = (d = s == null ? void 0 : s.getGeneralFeedbackEmailErrorStyles) == null ? void 0 : d.call(s, o);
  return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ h(
      ho,
      {
        htmlFor: "normalInput",
        children: `${t}${n === !0 ? "*" : ""}`,
        style: (
          // {
          // ...themeManager?.getLabelStyles(),
          // color:
          //     themeManager?.getLabelStyles().color,
          // }
          a
        )
      }
    ),
    /* @__PURE__ */ h(
      Li,
      {
        type: "email",
        style: (
          // {
          // ...themeManager.getInputStyles(),
          // color:
          //     themeManager.getInputStyles().color,
          // }
          c
        ),
        placeholder: r || t,
        value: A[e],
        onChange: (g) => i(g, e, ""),
        emailtext: (
          // themeManager.getGeneralFeedbackEmailText(feedbackType)
          l
        ),
        emailErrorStyle: (
          // themeManager?.getGeneralFeedbackEmailErrorStyles(feedbackType)
          u
        ),
        required: n
      }
    )
  ] }, e) });
}, b4 = ({ value: t, onChange: e, style: r, placeholder: n, maxLength: A, required: i }) => {
  const { themeConfig: o } = Xe(ct.Context);
  return /* @__PURE__ */ h(
    "textarea",
    {
      className: "q_input_textArea",
      value: t,
      onChange: e,
      style: { ...r, fontFamily: o.fontFamily || "'Figtree', sans-serif" },
      placeholder: n,
      maxLength: A,
      required: i
    }
  );
}, eq = ({ question: t, criteriaId: e, placeholder: r, required: n, answer: A, handleUpdate: i, feedbackType: o }) => {
  const { themeManager: s } = tl();
  return /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ h(
      ho,
      {
        htmlFor: "normalInput",
        children: `${t}${n === !0 ? "*" : ""}`,
        style: {
          ...s == null ? void 0 : s.getLabelStyles(),
          color: s == null ? void 0 : s.getLabelStyles().color
        }
      }
    ),
    /* @__PURE__ */ h(
      b4,
      {
        onChange: (a) => i(a, e, ""),
        value: A[e],
        placeholder: r || t,
        style: {
          borderColor: s.getGeneralFeedbackTextAreaStylesd(o).borderColor,
          color: s.getGeneralFeedbackTextAreaStylesd(o).color,
          ...s.getGeneralFeedbackTextAreaStylesd(o)
        },
        required: n
      }
    )
  ] }, e);
}, tq = ({
  data: t,
  labelStyle: e,
  ratingStyle: r,
  rating: n,
  handleRatingChange2: A,
  StarStyle: i,
  starBorderColor: o
}) => /* @__PURE__ */ k("div", { children: [
  /* @__PURE__ */ h(
    ho,
    {
      htmlFor: "normalInput",
      children: t.question ? t.question : "How would you rate your experience ?",
      style: e
    }
  ),
  /* @__PURE__ */ k("div", { children: [
    r == "Numbers" || t.ratingType == "Numbers" ? /* @__PURE__ */ h(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          gap: "4px"
        },
        children: Array(t.scale || 5).fill(1).map((s, a) => /* @__PURE__ */ h(
          "div",
          {
            style: {
              fontSize: "14px",
              fontWeight: "400",
              minWidth: "35px",
              color: s + a <= n ? "#FFF" : "#8E8E8E",
              borderRadius: "10px",
              border: s + a <= n ? "2px solid var(--neutral-grey-100, #000)" : "2px solid var(--neutral-grey-100, #ECECEC)",
              background: s + a <= n ? "#000" : "#fff",
              padding: "10px 12px",
              textAlign: "center",
              cursor: "pointer",
              boxSizing: "content-box"
            },
            onClick: (c) => A(c, t.criteriaId, s + a),
            children: s + a
          },
          a
        ))
      }
    ) : /* @__PURE__ */ h(
      "div",
      {
        style: {
          display: "flex",
          gap: "8px",
          ...i == null ? void 0 : i.Style
        },
        children: [1, 2, 3, 4, 5].map((s) => /* @__PURE__ */ h(
          "div",
          {
            style: {
              width: `${i == null ? void 0 : i.Size}px` || "32px",
              height: `${i == null ? void 0 : i.Size}px` || "32px",
              lineHeight: `${i == null ? void 0 : i.Size}px` || "32px",
              cursor: "pointer"
            },
            onClick: (a) => A(a, t.criteriaId, s),
            children: s <= n ? f4(
              i == null ? void 0 : i.Size,
              i == null ? void 0 : i.PrimaryColor
            ) : d4(
              i == null ? void 0 : i.Size,
              i == null ? void 0 : i.SecondaryColor,
              o
            )
          },
          s
        ))
      }
    ),
    r && r !== "Star" && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
      /* @__PURE__ */ h("div", { className: "ratingText", children: (t == null ? void 0 : t.leftText) || "Not likely" }),
      /* @__PURE__ */ h("div", { className: "ratingText", children: (t == null ? void 0 : t.rightText) || "Very Likely" })
    ] }),
    t.ratingType && t.ratingType !== "Star" && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
      /* @__PURE__ */ h("div", { className: "ratingText", children: (t == null ? void 0 : t.leftText) || "Not likely" }),
      /* @__PURE__ */ h("div", { className: "ratingText", children: (t == null ? void 0 : t.rightText) || "Very Likely" })
    ] })
  ] })
] }, t.criteriaId), rq = ({
  screenshot: t,
  setIsVisible: e,
  isVisible: r,
  onStartCapture: n,
  file: A,
  inputRef: i,
  setFile: o,
  setScreenshot: s,
  feedbackType: a
}) => {
  const { themeManager: c } = tl();
  return /* @__PURE__ */ k("div", { className: "q-fdov-image-input q-gen-img-upl", children: [
    /* @__PURE__ */ k("div", { className: "q-gen-img-upl-btns", children: [
      /* @__PURE__ */ h("div", { className: "gen-upl-btn-1", children: /* @__PURE__ */ h(
        "button",
        {
          style: {
            border: c.getGeneralFeedbackInputStyle(a).border || "1px solid #ECECEC",
            opacity: t === null ? 1 : 0.5
          },
          disabled: t !== null,
          onClick: () => {
            e && e(!r), n();
          },
          children: Ra(c.getGeneralFeedbackPrimaryButtonStyle(a).color)
        }
      ) }),
      /* @__PURE__ */ h("div", { className: "gen-upl-btn-2", children: /* @__PURE__ */ k(
        "div",
        {
          style: {
            border: c.getGeneralFeedbackInputStyle(a).border || "1px solid #ECECEC",
            opacity: A === null ? 1 : 0.5
          },
          children: [
            /* @__PURE__ */ h("label", { className: "q-button-sm q-fw-normal ", htmlFor: "feed-back-up-img", style: {
              cursor: A === null ? "pointer" : "no-drop"
            }, children: za(c.getGeneralFeedbackPrimaryButtonStyle(a).color) }),
            /* @__PURE__ */ h("input", { type: "file", style: {
              display: "none"
            }, ref: i, onChange: (l) => {
              if (l.target.files && l.target.files.length > 0) {
                const u = l.target.files[0];
                o(u);
              }
            }, disabled: A !== null, accept: "image/*", id: "feed-back-up-img" })
          ]
        }
      ) })
    ] }),
    t !== null && /* @__PURE__ */ k(
      "div",
      {
        className: "q-fdov-file-name q-gen-screen-shot-name",
        style: {
          border: c.getGeneralFeedbackInputStyle(a).border || "1px solid #ECECEC"
        },
        children: [
          /* @__PURE__ */ h("div", { children: Ra(c.getGeneralFeedbackPrimaryButtonStyle(a).color) }),
          /* @__PURE__ */ h("p", { style: {
            color: c.getGeneralFeedbackInputFormColor()
          }, children: t && t.name }),
          /* @__PURE__ */ h("button", { onClick: () => {
            s && s(null);
          }, children: Ya(c.getGeneralFeedbackPrimaryButtonStyle(a).color) })
        ]
      }
    ),
    A && /* @__PURE__ */ k(
      "div",
      {
        className: "q-fdov-file-name q-gen-file-name",
        style: {
          border: c.getGeneralFeedbackInputStyle(a).border || "1px solid #ECECEC"
        },
        children: [
          /* @__PURE__ */ h("div", { children: za(c.getGeneralFeedbackPrimaryButtonStyle(a).color) }),
          /* @__PURE__ */ h("p", { style: {
            color: c.getGeneralFeedbackInputFormColor()
          }, children: A.name }),
          /* @__PURE__ */ h(
            "button",
            {
              onClick: () => {
                o(null), i.current && (i.current.value = "");
              },
              children: Ya(c.getGeneralFeedbackPrimaryButtonStyle(a).color)
            }
          )
        ]
      }
    )
  ] });
}, fle = ({
  formdata: t,
  handleUpdate: e,
  handleSubmit: r,
  ratingStyle: n,
  answer: A,
  buttonStyle: i = {},
  labelStyle: o = {},
  PrimaryButtonText: s = "Submit",
  StarStyle: a,
  isVisible: c,
  setIsVisible: l,
  screenshot: u,
  setScreenshot: f,
  onStartCapture: d,
  uploadFileToBackend: g,
  inputRef: m,
  file: p,
  setFile: v,
  starBorderColor: C,
  rating: w,
  setRating: B
}) => {
  const y = (q, E, x) => {
    B(x), e(q, E, "", x);
  };
  return /* @__PURE__ */ h("form", { className: "q-fdov-ch-boxes", onSubmit: async (q) => {
    q.preventDefault();
    let E = [];
    if (p !== null) {
      let x = await g(p);
      E.push(x);
    }
    if (u !== null) {
      let x = await g(u);
      E.push(x);
    }
    for (let x = 0; x < t.length; x++)
      if (t[x].type === "USER_INPUT_IMAGE") {
        A[t[x].criteriaId] = E;
        break;
      }
    r(), v(null), f && f(null);
  }, children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k(Ze, { children: [
    t.map((q) => {
      if (q.type === "USER_INPUT_TEXT")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          _v,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: A,
            handleUpdate: e
          }
        ) });
      if (q.type === "USER_INPUT_EMAIL")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          $v,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: A,
            handleUpdate: e,
            feedbackType: "GeneralFeedback"
          }
        ) });
      if (q.type === "USER_INPUT_TEXTAREA")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          eq,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: A,
            handleUpdate: e,
            feedbackType: "GeneralFeedback"
          }
        ) });
      if (q.type === "RATING")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          tq,
          {
            data: q,
            labelStyle: o,
            StarStyle: a,
            ratingStyle: n,
            rating: w,
            handleRatingChange2: y,
            starBorderColor: C
          }
        ) });
      if (q.type === "USER_INPUT_IMAGE")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          rq,
          {
            screenshot: u,
            setIsVisible: l,
            isVisible: c,
            onStartCapture: d,
            file: p,
            inputRef: m,
            setFile: v,
            setScreenshot: f,
            feedbackType: "GeneralFeedback"
          }
        ) });
    }),
    /* @__PURE__ */ h(
      yr,
      {
        children: s,
        style: i,
        className: "q-fdov-btn-continue",
        type: "submit"
      }
    )
  ] }) : /* @__PURE__ */ h("div", { className: "q-center", children: "No data Found" }) });
}, hle = ({
  formdata: t,
  handleSubmit: e,
  buttonStyle: r = {},
  PrimaryButtonText: n = "Submit",
  labelStyle: A,
  ratingStyle: i,
  handleUpdate: o,
  StarStyle: s,
  isVisible: a,
  setIsVisible: c,
  screenshot: l,
  setScreenshot: u,
  onStartCapture: f,
  uploadFileToBackend: d,
  inputRef: g,
  file: m,
  setFile: p,
  answer: v,
  rating: C,
  setRating: w,
  starBorderColor: B
}) => {
  const y = (q, E, x) => {
    w(x), o(q, E, "", x);
  };
  return /* @__PURE__ */ h("form", { className: "q-fdov-ch-boxes", onSubmit: async (q) => {
    q.preventDefault();
    let E = [];
    if (m !== null) {
      let x = await d(m);
      E.push(x);
    }
    if (l !== null) {
      let x = await d(l);
      E.push(x);
    }
    for (let x = 0; x < t.length; x++)
      if (t[x].type === "USER_INPUT_IMAGE") {
        v[t[x].criteriaId] = E;
        break;
      }
    e(), p(null), u && u(null);
  }, children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k(Ze, { children: [
    t.map((q) => {
      if (q.type === "USER_INPUT_TEXT")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          _v,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: v,
            handleUpdate: o
          }
        ) });
      if (q.type === "USER_INPUT_EMAIL")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          $v,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: v,
            handleUpdate: o,
            feedbackType: "ReportBug"
          }
        ) });
      if (q.type === "USER_INPUT_TEXTAREA")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          eq,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: v,
            handleUpdate: o,
            feedbackType: "ReportBug"
          }
        ) });
      if (q.type === "RATING")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          tq,
          {
            data: q,
            labelStyle: A,
            StarStyle: s,
            ratingStyle: i,
            rating: C,
            handleRatingChange2: y,
            starBorderColor: B
          }
        ) });
      if (q.type === "USER_INPUT_IMAGE")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          rq,
          {
            screenshot: l,
            setIsVisible: c,
            isVisible: a,
            onStartCapture: f,
            file: m,
            inputRef: g,
            setFile: p,
            setScreenshot: u,
            feedbackType: "ReportBug"
          }
        ) });
    }),
    /* @__PURE__ */ h(yr, { children: n || "Submit", className: "q-fdov-btn-continue", type: "submit", style: r })
  ] }) : /* @__PURE__ */ h("div", { className: "q-center", children: "No data Found" }) });
}, ple = ({
  formdata: t,
  handleSubmit: e,
  buttonStyle: r = {},
  PrimaryButtonText: n = "Submit",
  ratingStyle: A,
  labelStyle: i,
  handleUpdate: o,
  StarStyle: s,
  isVisible: a,
  setIsVisible: c,
  screenshot: l,
  setScreenshot: u,
  onStartCapture: f,
  uploadFileToBackend: d,
  inputRef: g,
  file: m,
  setFile: p,
  answer: v,
  rating: C,
  setRating: w,
  starBorderColor: B
}) => {
  const y = (q, E, x) => {
    w(x), o(q, E, "", x);
  };
  return /* @__PURE__ */ h("form", { className: "q-fdov-ch-boxes", onSubmit: async (q) => {
    q.preventDefault();
    let E = [];
    if (m !== null) {
      let x = await d(m);
      E.push(x);
    }
    if (l !== null) {
      let x = await d(l);
      E.push(x);
    }
    for (let x = 0; x < t.length; x++)
      if (t[x].type === "USER_INPUT_IMAGE") {
        v[t[x].criteriaId] = E;
        break;
      }
    e(), p(null), u && u(null);
  }, children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k(Ze, { children: [
    t.map((q) => {
      if (q.type === "USER_INPUT_TEXT")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          _v,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: v,
            handleUpdate: o
          }
        ) });
      if (q.type === "USER_INPUT_EMAIL")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          $v,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: v,
            handleUpdate: o,
            feedbackType: "RequestFeature"
          }
        ) });
      if (q.type === "USER_INPUT_TEXTAREA")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          eq,
          {
            question: q.question || "",
            criteriaId: q.criteriaId || "",
            placeholder: q.placeholder || "",
            required: q.required || !1,
            answer: v,
            handleUpdate: o,
            feedbackType: "RequestFeature"
          }
        ) });
      if (q.type === "RATING")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          tq,
          {
            data: q,
            labelStyle: i,
            StarStyle: s,
            ratingStyle: A,
            rating: C,
            handleRatingChange2: y,
            starBorderColor: B
          }
        ) });
      if (q.type === "USER_INPUT_IMAGE")
        return /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ h(
          rq,
          {
            screenshot: l,
            setIsVisible: c,
            isVisible: a,
            onStartCapture: f,
            file: m,
            inputRef: g,
            setFile: p,
            setScreenshot: u,
            feedbackType: "RequestFeature"
          }
        ) });
    }),
    /* @__PURE__ */ h(yr, { className: "q-fdov-btn-continue", children: n || "Submit", type: "submit", style: r })
  ] }) : /* @__PURE__ */ h("div", { className: "q-center", children: "No data Found" }) });
}, gle = ({
  userId: t,
  token: e,
  questId: r,
  ContactUs: n,
  GeneralFeedback: A,
  Headers: i,
  PrimaryButtonText: o = "Submit",
  ReportBug: s,
  RequestFeature: a,
  SecondaryButtonText: c = "Go to home!",
  contactUrl: l,
  iconColor: u,
  ratingStyle: f,
  showFooter: d,
  starBorderColor: g,
  starColor: m,
  styleConfig: p,
  // questIds,
  isOpen: v,
  onClose: C,
  uniqueUserId: w,
  uniqueEmailId: B,
  variation: y,
  entityAuthenticationToken: b,
  children: q,
  isLoader: E = !1,
  accent: x,
  title: M
}) => {
  var nt;
  const { apiKey: O, apiSecret: I, entityId: S, featureFlags: P, apiType: H, themeConfig: F } = Xe(ct.Context), [T, U] = N(null), [D, Q] = N(null), [Y, j] = N({}), [Z, W] = N(
    {}
  ), [R, K] = N([]), [L, G] = N(!1), [V, _] = N(!1), [J, X] = N({}), [ne, ee] = N([!1, !1, !1, !1]), [$, te] = N(0), [ae, se] = N(t || ""), [ue, fe] = N(e || ""), [ve, ge] = N({ ...e2, accentColor: e2.accentColor ? e2.accentColor : x }), [oe, ce] = N(s7);
  let pe = H == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const [qe, Se] = N(!0), [Te, be] = N(null), He = gt(null), [Ge, Le] = N(null), [Ae, Pe] = N(null), [it, de] = N(!1);
  le(() => (qe == !0 ? document.body.classList.remove("q-feeback-noselect") : document.body.classList.add("q-feeback-noselect"), () => {
    document.body.classList.remove("q-feeback-noselect");
  }), [qe]);
  const xe = (mt) => {
    var yt;
    let me = mt.target;
    (yt = Qe.current) != null && yt.contains(me) || C && C();
  }, he = async (mt) => {
    var yt;
    if (G(!0), (mt == null ? void 0 : mt.size) > 1e6)
      try {
        const Ue = await xA(mt, {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: !0,
          initialQuality: 1
        });
        return await he(Ue);
      } catch {
        return null;
      }
    const me = new FormData();
    me.append("uploaded_file", mt);
    try {
      let Ue = await Oe.post(`${pe}api/upload-img`, me, {
        headers: {
          userId: t || ae,
          token: e || ue,
          apiKey: O,
          apiSecret: I,
          "Content-Type": "form-data"
        }
      });
      if (Ue == null || !(Ue != null && Ue.data) || (Ue == null ? void 0 : Ue.data.success) == !1 || !((yt = Ue == null ? void 0 : Ue.data) != null && yt.imageUrl))
        console.log(null);
      else
        return G(!1), Ue.data.imageUrl;
      G(!1);
    } catch (Ue) {
      console.log(Ue), G(!1);
    }
  }, Qe = re.useRef(null);
  let Re = new Bt("mixpanel", H, O, S);
  le(() => {
    Re.trackEvent(
      "quest-feedback-workflow-loaded",
      w || "quest-sdk-user",
      {},
      !0
    );
  }, []), le(() => {
    R.length > 0 && Q(
      T == "GeneralFeedback" ? R[0] : T == "ReportBug" ? R[1] : R[2]
    );
  }, [R, T]);
  const pt = async (mt, me) => {
    if (!me) {
      mt === "ContactUs" && l ? window.open(l, "_blank") : U(null), U(mt);
      return;
    }
    if (w || B) {
      let Ie = await new Bt("", H).getExternalLogin({
        apiType: H,
        uniqueUserId: w,
        entityId: S,
        userId: t,
        apiKey: O,
        apiSecret: "",
        token: e,
        uniqueEmailId: B,
        entityAuthenticationToken: b
      });
      Ie != null && Ie.userId && (t = Ie == null ? void 0 : Ie.userId, e = Ie == null ? void 0 : Ie.token, se(Ie == null ? void 0 : Ie.userId), fe(Ie == null ? void 0 : Ie.token));
    }
    let yt = {
      apiKey: O,
      apisecret: I,
      userId: t,
      token: e
    };
    try {
      Oe.post(
        `${pe}api/entities/${S}/users/${t}/metrics/feedback-${me}?userId=${t}&questId=${me}`,
        { count: 1 },
        { headers: yt }
      );
    } catch (Ue) {
      Re.captureSentryException(Ue);
    }
    mt === "ContactUs" && (l || Ae != null && Ae.contactUrl) ? window.open(l || (Ae == null ? void 0 : Ae.contactUrl), "_blank") : (U(mt), Q(me), X({}));
  };
  async function ze(mt) {
    if (Re.trackEvent(
      "quest-feedback-workflow-submit-btn-click",
      w || "quest-sdk-user",
      {},
      !0
    ), Re.fireTrackingEvent(
      `quest_feedback_workflow_${T}_form_submitted`,
      `feedback_workflow_${T}_form`
    ), B || w) {
      let yt = await new Bt("", H).getExternalLogin({
        apiType: H,
        uniqueUserId: w,
        entityId: S,
        userId: t,
        apiKey: O,
        apiSecret: "",
        token: e,
        uniqueEmailId: B,
        entityAuthenticationToken: b
      });
      yt != null && yt.userId && (t = yt == null ? void 0 : yt.userId, e = yt == null ? void 0 : yt.token, se(yt == null ? void 0 : yt.userId), fe(yt == null ? void 0 : yt.token));
    }
    if (Re.fireTrackingEvent(
      `quest_feedback_workflow-${S}`,
      "feedback_workflow"
    ), Object.keys(J).length !== 0) {
      let me = function(Ie, ot) {
        const Ke = `${pe}api/v2/entities/${S}/campaigns/${D}/verify`, tt = {
          actions: yt,
          campaignVariationId: Y[D || ""]
        };
        G(!0), Oe.post(Ke, tt, { headers: Ie }).then((Ot) => {
          Ot.data.success ? (_(!0), setTimeout(() => {
            _(!1), U(null);
          }, 4e3), Oe.post(
            `${pe}api/entities/${S}/users/${ot}/metrics/feedback-${D}-com?userId=${ot}&questId=${D}`,
            { count: 1 },
            { headers: Ie }
          )) : console.log(Ot.data.error);
        }).catch((Ot) => {
          console.error("Error:", Ot), Re.captureSentryException(Ot);
        }).finally(() => {
          G(!1), te(0);
        });
      };
      const yt = Z[mt].map((Ie) => ({
        answers: Array.isArray(J[Ie == null ? void 0 : Ie.criteriaId]) ? J[Ie == null ? void 0 : Ie.criteriaId] : [String(J[Ie == null ? void 0 : Ie.criteriaId]) || ""],
        actionId: (Ie == null ? void 0 : Ie.criteriaId) || ""
      }));
      let Ue = {
        apiKey: O,
        apisecret: I,
        userId: t,
        token: e
      };
      me(Ue, Ue.userId || ae);
    } else
      rs.error("Please fill in all required fields.");
  }
  const lt = () => {
    Re.fireTrackingEvent(
      `quest_feedback_workflow_${T}_form_closed`,
      `feedback_workflow_${T}_form`
    ), U(null), te(0), Le(null), be(null);
  }, st = new Moe(H);
  le(() => {
    (async () => {
      var me, yt, Ue, Ie, ot, Ke;
      if (S)
        try {
          const tt = await st.getUserAuth({
            apiKey: O,
            entityId: S,
            uniqueUserId: w,
            uniqueEmailId: B,
            userId: t,
            token: e
          });
          if (!tt) return;
          const Ot = {
            apiKey: O,
            apiSecret: I,
            userId: tt.userId,
            token: tt.token
          }, Vt = new URLSearchParams();
          Vt.set("platform", "REACT"), y && Vt.set("variation", y);
          const Mt = await st.fetchCampaignData(
            S,
            r,
            Ot,
            y
          );
          (yt = (me = Mt.sdkConfig) == null ? void 0 : me.uiProps) != null && yt.questThemeData && (ge({ ...Mt.sdkConfig.uiProps.questThemeData, accentColor: Mt.sdkConfig.uiProps.questThemeData.accentColor ? Mt.sdkConfig.uiProps.questThemeData.accentColor : x }), Mt.sdkConfig.uiProps.BrandTheme && ce(Mt.sdkConfig.uiProps.BrandTheme.properties)), Pe(
            (Mt == null ? void 0 : Mt.sdkConfig) && (Mt == null ? void 0 : Mt.sdkConfig.uiProps) || null
          ), l || (l = (Ie = (Ue = Mt == null ? void 0 : Mt.sdkConfig) == null ? void 0 : Ue.uiProps) == null ? void 0 : Ie.contactUrl);
          let lr = Mt;
          j(
            (ot = lr == null ? void 0 : lr.childCampaignActions) == null ? void 0 : ot.reduce((Et, Qt) => (Et[Qt.campaignId] = Qt.campaignVariationId, Et), {})
          );
          let Lr = (Ke = lr == null ? void 0 : lr.childCampaignActions) == null ? void 0 : Ke.map(
            (Et) => (R.push(Et == null ? void 0 : Et.campaignId), Et.actions.map((Qt) => {
              var Er;
              return {
                type: Qt.actionType,
                question: Qt.title,
                options: Qt.options,
                criteriaId: Qt.actionId,
                required: Qt.isRequired,
                placeholder: (Er = Qt == null ? void 0 : Qt.metadata) == null ? void 0 : Er.placeholder
              };
            }))
          );
          W(Lr), K((Et) => [...Et, ...R]);
        } catch (tt) {
          Re.captureSentryException(tt);
        }
    })();
  }, [r]);
  const We = (mt, me, yt, Ue) => {
    X({
      ...J,
      [me]: mt.target.value || Ue
    });
  }, Je = () => {
    _(!1), U(null);
  }, ut = (mt) => {
    X({
      ...J,
      [mt]: ""
    });
  };
  le(() => {
    if (qe) {
      const mt = document.querySelector(
        ".overlay.highlighting"
      );
      mt ? mt.style.borderColor = "blue" : console.error("Overlay element not found");
    }
  }, [qe]);
  let Be;
  Be = new ule(
    n || (Ae == null ? void 0 : Ae.ContactUs),
    A || (Ae == null ? void 0 : Ae.generalFeedback),
    i || (Ae == null ? void 0 : Ae.Headers),
    o || (Ae == null ? void 0 : Ae.PrimaryButtonText),
    s || (Ae == null ? void 0 : Ae.bugReport),
    a || (Ae == null ? void 0 : Ae.featureRequest),
    c || (Ae == null ? void 0 : Ae.SecondaryButtonText),
    l || (Ae == null ? void 0 : Ae.contactUrl),
    u || (Ae == null ? void 0 : Ae.iconColor),
    // questThemeData || uiProps?.questThemeData,
    f || (Ae == null ? void 0 : Ae.ratingStyle),
    d || (Ae == null ? void 0 : Ae.showFooter),
    g || (Ae == null ? void 0 : Ae.starBorderColor),
    m || (Ae == null ? void 0 : Ae.starColor)
  );
  const Ct = new joe(
    F,
    p || (Ae == null ? void 0 : Ae.styleConfig),
    ve,
    oe,
    Ae
  );
  if (((nt = P[Ve.FLAG_CONSTRAINTS.FeedbackWorkflowFlag]) == null ? void 0 : nt.isEnabled) == !1)
    return /* @__PURE__ */ h("div", {});
  const Ye = async (mt) => {
    try {
      E && de(!0), Se(!0);
      const me = /* @__PURE__ */ new Date(), yt = me.getHours(), Ue = me.getMinutes(), Ie = me.getSeconds();
      let Ke = "screenshot" + (yt + ":" + Ue + ":" + Ie) + ".jpg";
      const tt = await Oe.get(mt, { responseType: "blob" }), Ot = new Blob([tt.data], { type: "image/jpeg" }), Vt = new File([Ot], Ke, { type: "image/jpeg" });
      be(Vt);
    } catch (me) {
      console.error("An error occurred while fetching the image:", me);
    } finally {
      E && de(!1);
    }
  };
  le(() => {
    var mt, me, yt, Ue, Ie, ot, Ke, tt, Ot, Vt;
    (mt = p == null ? void 0 : p.ScreenShot) != null && mt.BorderColor && document.documentElement.style.setProperty(
      "--q-screenshot-border-color",
      (me = p == null ? void 0 : p.ScreenShot) == null ? void 0 : me.BorderColor
    ), (yt = p == null ? void 0 : p.ScreenShot) != null && yt.BorderWidth && document.documentElement.style.setProperty(
      "--q-screenshot-border-width",
      (Ue = p == null ? void 0 : p.ScreenShot) == null ? void 0 : Ue.BorderWidth
    ), (Ie = p == null ? void 0 : p.ScreenShot) != null && Ie.Background && document.documentElement.style.setProperty(
      "--q-screenshot-container-background",
      (ot = p == null ? void 0 : p.ScreenShot) == null ? void 0 : ot.Background
    ), (Ke = p == null ? void 0 : p.ScreenShot) != null && Ke.ScreenShotBackground && document.documentElement.style.setProperty(
      "--q-screenshot-inner-container-background",
      (tt = p == null ? void 0 : p.ScreenShot) == null ? void 0 : tt.ScreenShotBackground
    ), (Ot = p == null ? void 0 : p.ScreenShot) != null && Ot.CrosshairColor && document.documentElement.style.setProperty(
      "--q-screenshot-crosshair-color",
      (Vt = p == null ? void 0 : p.ScreenShot) == null ? void 0 : Vt.CrosshairColor
    );
  }, [p == null ? void 0 : p.ScreenShot]);
  const $e = {
    ContactUs: n,
    handleThanks: Je,
    submit: V,
    ref: Qe,
    isVisible: qe,
    showLoader: L,
    selectedOption: T,
    handleBackClick: lt,
    onClose: C,
    apiType: H,
    apiKey: O,
    entityId: S,
    handleOptionClick: pt,
    questIds: R,
    setCardHovered: ee,
    cardHovered: ne,
    setIsVisible: Se,
    screenshot: Te,
    handleUpdate: We,
    returnAnswers: ze,
    formdata: Z,
    handleRemove: ut,
    setScreenshot: be,
    uploadFileToBackend: he,
    inputRef: He,
    file: Ge,
    setFile: Le,
    rating: $,
    setRating: te,
    feedbackWorkflowFunctions: Be,
    themeManager: Ct
  };
  return it ? /* @__PURE__ */ h(rl, {}) : /* @__PURE__ */ h(QM.Provider, { value: $e, children: /* @__PURE__ */ h(
    zM,
    {
      isOpen: v,
      onClose: C || (() => {
      }),
      style: {
        padding: 0,
        background: "transparent",
        ...Ct.getModalStyles()
      },
      children: /* @__PURE__ */ h(kH, { onEndCapture: Ye, children: ({ onStartCapture: mt }) => {
        var me, yt, Ue, Ie, ot, Ke, tt, Ot, Vt, Mt, lr, Lr, Et, Qt, Er, kt, en, St;
        return /* @__PURE__ */ k(
          "div",
          {
            className: "q_modal_overlay",
            onClick: (jr) => xe(jr),
            style: {
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "transparent",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: qe ? 1 : 0
            },
            children: [
              !V && /* @__PURE__ */ k(
                "div",
                {
                  className: "q_modal",
                  ref: Qe,
                  id: "modal_box",
                  style: {
                    padding: 0,
                    background: "transparent",
                    opacity: qe ? 1 : 0,
                    ...Ct.getModalStyles()
                  },
                  children: [
                    L && /* @__PURE__ */ h(rl, {}),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-fw-div",
                        style: {
                          ...Ct == null ? void 0 : Ct.getFormStyles()
                        },
                        id: "disabledClick",
                        children: T && !V ? /* @__PURE__ */ k("div", { children: [
                          /* @__PURE__ */ h(
                            T1,
                            {
                              style: {
                                topbarStyle: Ct.getTopBarStyles().topbarStyle,
                                headingStyle: Ct.getTopBarStyles().headingStyle,
                                descriptionStyle: Ct.getTopBarStyles().descriptionStyle
                              },
                              description: T == "ContactUs" ? Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (me = Be == null ? void 0 : Be.getHeaders()[3]) == null ? void 0 : me.subHeading : ((yt = Be == null ? void 0 : Be.getContactUs()) == null ? void 0 : yt.description) || "Invite other admins and moderators" : T == "RequestFeature" ? Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (Ue = Be == null ? void 0 : Be.getHeaders()[2]) == null ? void 0 : Ue.subHeading : ((Ie = Be.getRequestFeature()) == null ? void 0 : Ie.formDescription) || "How can we make it better" : T == "ReportBug" ? Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (ot = Be == null ? void 0 : Be.getHeaders()[1]) == null ? void 0 : ot.subHeading : (Be == null ? void 0 : Be.getReportBug().formDescription) || "Describe your issue" : Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (Ke = Be == null ? void 0 : Be.getHeaders()[0]) == null ? void 0 : Ke.subHeading : (Be == null ? void 0 : Be.getGeneralFeedback().formDescription) || "Give general feedback on this page",
                              heading: T == "ContactUs" ? Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (tt = Be == null ? void 0 : Be.getHeaders()[3]) == null ? void 0 : tt.heading : ((Ot = Be == null ? void 0 : Be.getContactUs()) == null ? void 0 : Ot.heading) || "Contact us" : T == "RequestFeature" ? Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (Vt = Be == null ? void 0 : Be.getHeaders()[2]) == null ? void 0 : Vt.heading : Be.getRequestFeature().formHeading || "Request a Feature" : T == "ReportBug" ? Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (Mt = Be == null ? void 0 : Be.getHeaders()[1]) == null ? void 0 : Mt.heading : ((lr = Be == null ? void 0 : Be.getReportBug()) == null ? void 0 : lr.formHeading) || "Report a Bug" : Array.isArray(
                                Be == null ? void 0 : Be.getHeaders()
                              ) ? (Lr = Be == null ? void 0 : Be.getHeaders()[0]) == null ? void 0 : Lr.heading : ((Et = Be == null ? void 0 : Be.getGeneralFeedback()) == null ? void 0 : Et.formHeading) || "General Feedback",
                              iconColor: Be.geticonColor(),
                              onClose: lt
                            }
                          ),
                          /* @__PURE__ */ k("div", { style: { padding: "20px" }, children: [
                            T === "GeneralFeedback" && /* @__PURE__ */ h(
                              fle,
                              {
                                starColor: Be.getstarColor(),
                                handleSubmit: () => ze(0),
                                handleUpdate: We,
                                formdata: Z[0],
                                starBorderColor: Be.getstarBorderColor(),
                                answer: J,
                                handleRemove: ut,
                                ratingStyle: Be.getratingStyle(),
                                iconColor: Be.geticonColor(),
                                buttonStyle: {
                                  ...Ct.getPrimaryButtonStyles()
                                },
                                PrimaryButtonText: Be.getPrimaryButtonText(),
                                StarStyle: Ct.getStarStyles(),
                                labelStyle: Ct.getLabelStyles(),
                                isVisible: qe,
                                setIsVisible: Se,
                                screenshot: Te,
                                setScreenshot: be,
                                onStartCapture: mt,
                                uploadFileToBackend: he,
                                inputRef: He,
                                file: Ge,
                                setFile: Le,
                                rating: $,
                                setRating: te
                              }
                            ),
                            T === "ReportBug" && /* @__PURE__ */ h(
                              hle,
                              {
                                ratingStyle: Be.getratingStyle(),
                                handleSubmit: () => ze(1),
                                handleUpdate: We,
                                formdata: Z[1],
                                answer: J,
                                handleRemove: ut,
                                PrimaryButtonText: Be.getPrimaryButtonText(),
                                buttonStyle: Ct.getPrimaryButtonStyles(),
                                isVisible: qe,
                                setIsVisible: Se,
                                screenshot: Te,
                                setScreenshot: be,
                                onStartCapture: mt,
                                uploadFileToBackend: he,
                                inputRef: He,
                                file: Ge,
                                setFile: Le,
                                BrandTheme: oe,
                                rating: $,
                                setRating: te,
                                starBorderColor: Be.getstarBorderColor()
                              }
                            ),
                            T === "RequestFeature" && /* @__PURE__ */ h(
                              ple,
                              {
                                handleSubmit: () => ze(2),
                                handleUpdate: We,
                                formdata: Z[2],
                                answer: J,
                                handleRemove: ut,
                                PrimaryButtonText: Be.getPrimaryButtonText(),
                                buttonStyle: Ct.getPrimaryButtonStyles(),
                                isVisible: qe,
                                setIsVisible: Se,
                                screenshot: Te,
                                setScreenshot: be,
                                onStartCapture: mt,
                                uploadFileToBackend: he,
                                inputRef: He,
                                file: Ge,
                                setFile: Le,
                                BrandTheme: oe,
                                rating: $,
                                setRating: te
                              }
                            ),
                            T === "ContactUs" && /* @__PURE__ */ h("div", {})
                          ] }),
                          Be.getshowFooter() && /* @__PURE__ */ h(
                            Pr,
                            {
                              style: (Qt = Ct == null ? void 0 : Ct.getFooterStyles()) == null ? void 0 : Qt.FooterStyle,
                              textStyle: (Er = Ct == null ? void 0 : Ct.getFooterStyles()) == null ? void 0 : Er.FooterTextStyle,
                              iconStyle: (kt = Ct == null ? void 0 : Ct.getFooterStyles()) == null ? void 0 : kt.FooterIcon,
                              text: (en = Ct == null ? void 0 : Ct.getFooterStyles()) == null ? void 0 : en.FooterText,
                              link: (St = Ct == null ? void 0 : Ct.getFooterStyles()) == null ? void 0 : St.FooterLink
                            }
                          )
                        ] }) : V ? "" : /* @__PURE__ */ h(
                          dle,
                          {
                            onClose: C,
                            GeneralFunctions: Re,
                            handleOptionClick: pt,
                            setCardHovered: ee,
                            cardHovered: ne,
                            questIds: R,
                            title: M
                          }
                        )
                      }
                    )
                  ]
                }
              ),
              q
            ]
          }
        );
      } })
    }
  ) });
};
gle.ThankYou = Toe;
const GH = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASTSURBVHgB7VnBbttGEH27jJ1DgdZ/UAppzlVuRWE7UoUceqr7BU2/IPIXSP6COF9Q9QvingLUUE3XOeQW5ZwEZP5AOeQQ2+RmhqJscrlLUeTmpgcIAsnl7ryZndmZIbDBBhvkIeAQp293e1KKLiQeCtA/sJP9GHP6RQoqQiLeJEkSPLr/MoADtCbxPOztfIvrJwJyiFuB64JJBZe4Ovq18ypCQzQmsRA+HpHGh3AAIjNpSqYRidNwb+hBjLC+5lchUrE6GvxwMVnnpbVJTMO9pxXan5NK/xGJDOBhxkL1OwH7As7IcvTnJ4i7QokerfwbLEogqxwPOheHqInaJHj7fIf4Ob3SMzzmvX0k4Z0sha4DUshjsbCob3g8Iz/r15mvNon/wv3X9NfVbs9ZeNLaMVpgGu6PSZBR+YkKfulc9Fe9X4uEZQtFApekqeZRJQ/abr5CcgbNKnW21koS03dkck/8pd2ubep1YCWSqMPBPbu1K0m8oEnvlid1agEdFiJzUlrHpjSJCmypZFye7OsRYJCgEVsZixN+iR2KaiPbO1YSbAUp8Ef+Hjvx1yDwb/hzdxru3gjJRBTwLD+GfTIL0yVYSWRWyCNqG4VMYAJ3cOeMtD/OExl0/h/zmvmxlG8ZzycrCbLCw/w1WwGOsSSA7NDTidCaRWtIPDHNYyRxGu72oDkzWWECh9AJ3CCR4lY4bwLNNzhT1ucykpCJLAwUdOjAIWwEVIKjwb10G6VIoxGlMfkxaaqvwUhCieLJnADncIS6BG5lUbP8tRDltMdsCYHvi4O8GRxgXQKMGF5QuCHwoz7G5ti+dh2hJZoQYGwVfQIwZL42EoWBtpOS6woWDivQlEC2doQK2RiVJ3YVph92R1QYPWXhqoi0IVAXNhIFzesnJROgwmecXe7YiLggYDilS7vCHJ2U+Kjd8gtXuVieoUTElQWuca0rJ9LHmEmgGNaSOC5MxCkB5Tb6CX5DxOUWkrHwNeE+lMaYXhSieLhJr5iCMKqIuPQBJcVB4VqhFO6NJBLNEgriwJRB2ojAoRPrOZzkJoQ+xvTio07amSvm83F8YBprIXKDNgS4qkRRIVH/fhDo46whtpTPe8JalNiItA2j+pq2HM6eikMea7f86fu9oW28TqQtAQ7jKGUOV0aLV9bY0/f7x1oOP/+MywdVrUZuv3DG2IZAVtuHKAiqJv3OxZ+m8ZUk2JnVYrLCvqTi5YHrTscSTZoTlWkHC2qo6NJuxIvwJx+OYSGwsrZfmTtxXU37+5l2u3sX206JWAnQ2quqyloJIO3vIcqRgRbdfl3l7HXB2TAR4Dapn79PfnCyWLsatXuxmX+wpkwZ69ot+fT7RhI/FlJw4PBLAxTOhZAHThvKSxgiVh7sQydUjp3HSTz7tLUd/Z4JwUJ/c3Xpe9LrUtufP4fx4Wlu7fMWqmGBxiQYK1rybcBKOFy3s9KoKOJF0lajwt9wBNY+91ubtIZaf3hMG8DcLVwkaj7Ww5zTG84O2pw7Tj8BE6EetRp7Im35CB9Ccdfk9hNwWmypGbVhAu6gkOABNthgA+f4AqZsVIn4CCL/AAAAAElFTkSuQmCC", RH = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARuSURBVHgB7VlNdts2EJ4BVVtL9QRRT1DdIPSyC/tFB2hs7ex24eQEtk8QeVMpKyryAZTKfS9LsyeocoKyN3B3+SEwHVB1AoIARUmU9fKevvdsidBwgMH8YGYAsMMOO5hAqBGDaBJSEHQE4FNm3SGgFk/Q0r8RwL0gSAj5j9R7UCo+63VjqAFrCxFFk9Yn0ThXCC8eFlwZRAmvICYpr1igBFbEykJki8fgggS+gFpAo1WFWUmI38ZT3nW8WHrnF4E1QwpYkKPRMq8tLcTr0fRV+e7Te15MTIgzQEwgTRMFey3RUC3BPkKKQh4PeeofS3j0T58fvYSKqCyENp+PQWPCX8PClOy0/O8aVDqqag6D6F0bxOdLRMFBgNr270gw21PpQa/XvV/EqwEVwc57xx+dwg+8+KZKL6tMZuKs91PCHydfhcHjHFuEzv+bdrCIVyVNuEwo232E7tnPhzHUgMF4esLLeVX0s8WmtVCIQTQ9wQAji3HCkeRgnbDonutdGwN5Z5uXkvTyl95R3/ceLmQqmCmaTDcjgDknBOlfpka01psy/cFnsqKUI9tqXgBtq9jblAAama+wmZpjWqCPQXDhe8eriblq07/NMZI6hh9ewiNg+Oa2z6s7N8f2Zfq9Sxt+TWgt5EBJE1KvXdaNfY54WfAw8AGE83zyCoGg4/dXMMOrZcPoOsjmInWdGwzEuYvWKcTgZhLavgBSxvDIaCrVN7WhfWMQ3YY2nVsTSuQIiej3TTqzD1obiDAzxyigwoHrFIKTuxwhn54xbAmKN9B85nQktGl8QjzJPUucwZbQkEFsPrNmComjM3fiAqdtxl6OSk4hhuNbghpx+vywEPIlfLpHY5kEWEj/PZrI5y+PGZVs2L7oqmHKT+xvBE4h7ENG1xKwJdhz22vT8NUT/4Khtg/z74WXXTZcNz7DXpu99MszO3Zi07h9gijvyEEQwpZAINu5Z0X/2DROIZR1LrBQHdgSlIBn+REqREq3JjB/LhCKY9gS7ByOpYptGqcQuuSskrNsGrqqtAsyLgVim84fYq0MEgPwFiWbghBoZ62xkw480BmkNRS+jqbP4JGgtaA7HuaY7hC6aL1CzPN5yGlDccOAm8Zt2DDmtb2wNE/enlbpiW1XV9o3hMh6QRuFEOnE0Zy48tJDCbQ2uE2fe1mreDj+I4INQfMumBFAaaO50onrKtoZ3JJPa+t8eNukbNKnx4elnffKacPw5vYO7IKEu9hKSW5sdd/CGtCXMyi+iwolMcBbTm26i96v3IvdT9Ou7sfmVI3YFrx7w/F0JKW8/rXXXap4yhYfNLQDh5nRGOBbpj+bUvaq8Fk6gfOY1pwZd7Il0huUcua6ytImw8lkh4PDU96MEBwd9gwVTCg3L6wA3fzldODC1ZK32Cf553L6LBJy33XjlywP8LXkVwbv/v4KVwQaa9cDiy5LyvBwOcP3G/11SuB6r4BvOElUKtTXv1y8tLmof2JeAYMutrhW0S0gnSnXdbexww475PEfzrD4nDeyFpwAAAAASUVORK5CYII=";
var P7 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var u6, _B;
function mle() {
  if (_B) return u6;
  _B = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function A() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var a = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (a.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return u6 = A() ? Object.assign : function(i, o) {
    for (var s, a = n(i), c, l = 1; l < arguments.length; l++) {
      s = Object(arguments[l]);
      for (var u in s)
        e.call(s, u) && (a[u] = s[u]);
      if (t) {
        c = t(s);
        for (var f = 0; f < c.length; f++)
          r.call(s, c[f]) && (a[c[f]] = s[c[f]]);
      }
    }
    return a;
  }, u6;
}
var d6, $B;
function nq() {
  if ($B) return d6;
  $B = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return d6 = t, d6;
}
var f6, eE;
function zH() {
  return eE || (eE = 1, f6 = Function.call.bind(Object.prototype.hasOwnProperty)), f6;
}
var h6, tE;
function vle() {
  if (tE) return h6;
  tE = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = nq(), r = {}, n = zH();
    t = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function A(i, o, s, a, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in i)
        if (n(i, l)) {
          var u;
          try {
            if (typeof i[l] != "function") {
              var f = Error(
                (a || "React class") + ": " + s + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            u = i[l](o, l, a, s, null, e);
          } catch (g) {
            u = g;
          }
          if (u && !(u instanceof Error) && t(
            (a || "React class") + ": type specification of " + s + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in r)) {
            r[u.message] = !0;
            var d = c ? c() : "";
            t(
              "Failed " + s + " type: " + u.message + (d ?? "")
            );
          }
        }
    }
  }
  return A.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, h6 = A, h6;
}
var p6, rE;
function qle() {
  if (rE) return p6;
  rE = 1;
  var t = bv(), e = mle(), r = nq(), n = zH(), A = vle(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var a = "Warning: " + s;
    typeof console < "u" && console.error(a);
    try {
      throw new Error(a);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return p6 = function(s, a) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function u(Q) {
      var Y = Q && (c && Q[c] || Q[l]);
      if (typeof Y == "function")
        return Y;
    }
    var f = "<<anonymous>>", d = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: C(),
      arrayOf: w,
      element: B(),
      elementType: y(),
      instanceOf: b,
      node: M(),
      objectOf: E,
      oneOf: q,
      oneOfType: x,
      shape: I,
      exact: S
    };
    function g(Q, Y) {
      return Q === Y ? Q !== 0 || 1 / Q === 1 / Y : Q !== Q && Y !== Y;
    }
    function m(Q, Y) {
      this.message = Q, this.data = Y && typeof Y == "object" ? Y : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function p(Q) {
      if (process.env.NODE_ENV !== "production")
        var Y = {}, j = 0;
      function Z(R, K, L, G, V, _, J) {
        if (G = G || f, _ = _ || L, J !== r) {
          if (a) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ne = G + ":" + L;
            !Y[ne] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + _ + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Y[ne] = !0, j++);
          }
        }
        return K[L] == null ? R ? K[L] === null ? new m("The " + V + " `" + _ + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new m("The " + V + " `" + _ + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : Q(K, L, G, V, _);
      }
      var W = Z.bind(null, !1);
      return W.isRequired = Z.bind(null, !0), W;
    }
    function v(Q) {
      function Y(j, Z, W, R, K, L) {
        var G = j[Z], V = F(G);
        if (V !== Q) {
          var _ = T(G);
          return new m(
            "Invalid " + R + " `" + K + "` of type " + ("`" + _ + "` supplied to `" + W + "`, expected ") + ("`" + Q + "`."),
            { expectedType: Q }
          );
        }
        return null;
      }
      return p(Y);
    }
    function C() {
      return p(o);
    }
    function w(Q) {
      function Y(j, Z, W, R, K) {
        if (typeof Q != "function")
          return new m("Property `" + K + "` of component `" + W + "` has invalid PropType notation inside arrayOf.");
        var L = j[Z];
        if (!Array.isArray(L)) {
          var G = F(L);
          return new m("Invalid " + R + " `" + K + "` of type " + ("`" + G + "` supplied to `" + W + "`, expected an array."));
        }
        for (var V = 0; V < L.length; V++) {
          var _ = Q(L, V, W, R, K + "[" + V + "]", r);
          if (_ instanceof Error)
            return _;
        }
        return null;
      }
      return p(Y);
    }
    function B() {
      function Q(Y, j, Z, W, R) {
        var K = Y[j];
        if (!s(K)) {
          var L = F(K);
          return new m("Invalid " + W + " `" + R + "` of type " + ("`" + L + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return p(Q);
    }
    function y() {
      function Q(Y, j, Z, W, R) {
        var K = Y[j];
        if (!t.isValidElementType(K)) {
          var L = F(K);
          return new m("Invalid " + W + " `" + R + "` of type " + ("`" + L + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return p(Q);
    }
    function b(Q) {
      function Y(j, Z, W, R, K) {
        if (!(j[Z] instanceof Q)) {
          var L = Q.name || f, G = D(j[Z]);
          return new m("Invalid " + R + " `" + K + "` of type " + ("`" + G + "` supplied to `" + W + "`, expected ") + ("instance of `" + L + "`."));
        }
        return null;
      }
      return p(Y);
    }
    function q(Q) {
      if (!Array.isArray(Q))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function Y(j, Z, W, R, K) {
        for (var L = j[Z], G = 0; G < Q.length; G++)
          if (g(L, Q[G]))
            return null;
        var V = JSON.stringify(Q, function(J, X) {
          var ne = T(X);
          return ne === "symbol" ? String(X) : X;
        });
        return new m("Invalid " + R + " `" + K + "` of value `" + String(L) + "` " + ("supplied to `" + W + "`, expected one of " + V + "."));
      }
      return p(Y);
    }
    function E(Q) {
      function Y(j, Z, W, R, K) {
        if (typeof Q != "function")
          return new m("Property `" + K + "` of component `" + W + "` has invalid PropType notation inside objectOf.");
        var L = j[Z], G = F(L);
        if (G !== "object")
          return new m("Invalid " + R + " `" + K + "` of type " + ("`" + G + "` supplied to `" + W + "`, expected an object."));
        for (var V in L)
          if (n(L, V)) {
            var _ = Q(L, V, W, R, K + "." + V, r);
            if (_ instanceof Error)
              return _;
          }
        return null;
      }
      return p(Y);
    }
    function x(Q) {
      if (!Array.isArray(Q))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var Y = 0; Y < Q.length; Y++) {
        var j = Q[Y];
        if (typeof j != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + U(j) + " at index " + Y + "."
          ), o;
      }
      function Z(W, R, K, L, G) {
        for (var V = [], _ = 0; _ < Q.length; _++) {
          var J = Q[_], X = J(W, R, K, L, G, r);
          if (X == null)
            return null;
          X.data && n(X.data, "expectedType") && V.push(X.data.expectedType);
        }
        var ne = V.length > 0 ? ", expected one of type [" + V.join(", ") + "]" : "";
        return new m("Invalid " + L + " `" + G + "` supplied to " + ("`" + K + "`" + ne + "."));
      }
      return p(Z);
    }
    function M() {
      function Q(Y, j, Z, W, R) {
        return P(Y[j]) ? null : new m("Invalid " + W + " `" + R + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return p(Q);
    }
    function O(Q, Y, j, Z, W) {
      return new m(
        (Q || "React class") + ": " + Y + " type `" + j + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + W + "`."
      );
    }
    function I(Q) {
      function Y(j, Z, W, R, K) {
        var L = j[Z], G = F(L);
        if (G !== "object")
          return new m("Invalid " + R + " `" + K + "` of type `" + G + "` " + ("supplied to `" + W + "`, expected `object`."));
        for (var V in Q) {
          var _ = Q[V];
          if (typeof _ != "function")
            return O(W, R, K, V, T(_));
          var J = _(L, V, W, R, K + "." + V, r);
          if (J)
            return J;
        }
        return null;
      }
      return p(Y);
    }
    function S(Q) {
      function Y(j, Z, W, R, K) {
        var L = j[Z], G = F(L);
        if (G !== "object")
          return new m("Invalid " + R + " `" + K + "` of type `" + G + "` " + ("supplied to `" + W + "`, expected `object`."));
        var V = e({}, j[Z], Q);
        for (var _ in V) {
          var J = Q[_];
          if (n(Q, _) && typeof J != "function")
            return O(W, R, K, _, T(J));
          if (!J)
            return new m(
              "Invalid " + R + " `" + K + "` key `" + _ + "` supplied to `" + W + "`.\nBad object: " + JSON.stringify(j[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Q), null, "  ")
            );
          var X = J(L, _, W, R, K + "." + _, r);
          if (X)
            return X;
        }
        return null;
      }
      return p(Y);
    }
    function P(Q) {
      switch (typeof Q) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Q;
        case "object":
          if (Array.isArray(Q))
            return Q.every(P);
          if (Q === null || s(Q))
            return !0;
          var Y = u(Q);
          if (Y) {
            var j = Y.call(Q), Z;
            if (Y !== Q.entries) {
              for (; !(Z = j.next()).done; )
                if (!P(Z.value))
                  return !1;
            } else
              for (; !(Z = j.next()).done; ) {
                var W = Z.value;
                if (W && !P(W[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(Q, Y) {
      return Q === "symbol" ? !0 : Y ? Y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Y instanceof Symbol : !1;
    }
    function F(Q) {
      var Y = typeof Q;
      return Array.isArray(Q) ? "array" : Q instanceof RegExp ? "object" : H(Y, Q) ? "symbol" : Y;
    }
    function T(Q) {
      if (typeof Q > "u" || Q === null)
        return "" + Q;
      var Y = F(Q);
      if (Y === "object") {
        if (Q instanceof Date)
          return "date";
        if (Q instanceof RegExp)
          return "regexp";
      }
      return Y;
    }
    function U(Q) {
      var Y = T(Q);
      switch (Y) {
        case "array":
        case "object":
          return "an " + Y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Y;
        default:
          return Y;
      }
    }
    function D(Q) {
      return !Q.constructor || !Q.constructor.name ? f : Q.constructor.name;
    }
    return d.checkPropTypes = A, d.resetWarningCache = A.resetWarningCache, d.PropTypes = d, d;
  }, p6;
}
var g6, nE;
function yle() {
  if (nE) return g6;
  nE = 1;
  var t = nq();
  function e() {
  }
  function r() {
  }
  return r.resetWarningCache = e, g6 = function() {
    function n(o, s, a, c, l, u) {
      if (u !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function A() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: A,
      element: n,
      elementType: n,
      instanceOf: A,
      node: n,
      objectOf: A,
      oneOf: A,
      oneOfType: A,
      shape: A,
      exact: A,
      checkPropTypes: r,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, g6;
}
if (process.env.NODE_ENV !== "production") {
  var Cle = bv(), wle = !0;
  P7.exports = qle()(Cle.isElement, wle);
} else
  P7.exports = yle()();
var ble = P7.exports;
const Dt = /* @__PURE__ */ Vr(ble);
function AE(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function iE(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? AE(Object(r), !0).forEach(function(n) {
      YH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : AE(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Oh(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Oh = function(e) {
    return typeof e;
  } : Oh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Oh(t);
}
function YH(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function VH(t, e) {
  return Ble(t) || Ele(t, e) || xle(t, e) || Ile();
}
function Ble(t) {
  if (Array.isArray(t)) return t;
}
function Ele(t, e) {
  var r = t && (typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"]);
  if (r != null) {
    var n = [], A = !0, i = !1, o, s;
    try {
      for (r = r.call(t); !(A = (o = r.next()).done) && (n.push(o.value), !(e && n.length === e)); A = !0)
        ;
    } catch (a) {
      i = !0, s = a;
    } finally {
      try {
        !A && r.return != null && r.return();
      } finally {
        if (i) throw s;
      }
    }
    return n;
  }
}
function xle(t, e) {
  if (t) {
    if (typeof t == "string") return oE(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return oE(t, e);
  }
}
function oE(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Ile() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var fi = function(e, r, n) {
  var A = !!n, i = re.useRef(n);
  re.useEffect(function() {
    i.current = n;
  }, [n]), re.useEffect(function() {
    if (!A || !e)
      return function() {
      };
    var o = function() {
      i.current && i.current.apply(i, arguments);
    };
    return e.on(r, o), function() {
      e.off(r, o);
    };
  }, [A, r, e, i]);
}, k7 = function(e) {
  var r = re.useRef(e);
  return re.useEffect(function() {
    r.current = e;
  }, [e]), r.current;
}, Lu = function(e) {
  return e !== null && Oh(e) === "object";
}, Sle = function(e) {
  return Lu(e) && typeof e.then == "function";
}, Ple = function(e) {
  return Lu(e) && typeof e.elements == "function" && typeof e.createToken == "function" && typeof e.createPaymentMethod == "function" && typeof e.confirmCardPayment == "function";
}, sE = "[object Object]", kle = function t(e, r) {
  if (!Lu(e) || !Lu(r))
    return e === r;
  var n = Array.isArray(e), A = Array.isArray(r);
  if (n !== A) return !1;
  var i = Object.prototype.toString.call(e) === sE, o = Object.prototype.toString.call(r) === sE;
  if (i !== o) return !1;
  if (!i && !n) return e === r;
  var s = Object.keys(e), a = Object.keys(r);
  if (s.length !== a.length) return !1;
  for (var c = {}, l = 0; l < s.length; l += 1)
    c[s[l]] = !0;
  for (var u = 0; u < a.length; u += 1)
    c[a[u]] = !0;
  var f = Object.keys(c);
  if (f.length !== s.length)
    return !1;
  var d = e, g = r, m = function(v) {
    return t(d[v], g[v]);
  };
  return f.every(m);
}, WH = function(e, r, n) {
  return Lu(e) ? Object.keys(e).reduce(function(A, i) {
    var o = !Lu(r) || !kle(e[i], r[i]);
    return n.includes(i) ? (o && console.warn("Unsupported prop change: options.".concat(i, " is not a mutable property.")), A) : o ? iE(iE({}, A || {}), {}, YH({}, i, e[i])) : A;
  }, null) : null;
}, XH = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", aE = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : XH;
  if (e === null || Ple(e))
    return e;
  throw new Error(r);
}, Ole = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : XH;
  if (Sle(e))
    return {
      tag: "async",
      stripePromise: Promise.resolve(e).then(function(A) {
        return aE(A, r);
      })
    };
  var n = aE(e, r);
  return n === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: n
  };
}, Fle = function(e) {
  !e || !e._registerWrapper || !e.registerAppInfo || (e._registerWrapper({
    name: "react-stripe-js",
    version: "2.8.1"
  }), e.registerAppInfo({
    name: "react-stripe-js",
    version: "2.8.1",
    url: "https://stripe.com/docs/stripe-js/react"
  }));
}, B4 = /* @__PURE__ */ re.createContext(null);
B4.displayName = "ElementsContext";
var KH = function(e, r) {
  if (!e)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(r, " in an <Elements> provider."));
  return e;
}, ZH = function(e) {
  var r = e.stripe, n = e.options, A = e.children, i = re.useMemo(function() {
    return Ole(r);
  }, [r]), o = re.useState(function() {
    return {
      stripe: i.tag === "sync" ? i.stripe : null,
      elements: i.tag === "sync" ? i.stripe.elements(n) : null
    };
  }), s = VH(o, 2), a = s[0], c = s[1];
  re.useEffect(function() {
    var f = !0, d = function(m) {
      c(function(p) {
        return p.stripe ? p : {
          stripe: m,
          elements: m.elements(n)
        };
      });
    };
    return i.tag === "async" && !a.stripe ? i.stripePromise.then(function(g) {
      g && f && d(g);
    }) : i.tag === "sync" && !a.stripe && d(i.stripe), function() {
      f = !1;
    };
  }, [i, a, n]);
  var l = k7(r);
  re.useEffect(function() {
    l !== null && l !== r && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [l, r]);
  var u = k7(n);
  return re.useEffect(function() {
    if (a.elements) {
      var f = WH(n, u, ["clientSecret", "fonts"]);
      f && a.elements.update(f);
    }
  }, [n, u, a.elements]), re.useEffect(function() {
    Fle(a.stripe);
  }, [a.stripe]), /* @__PURE__ */ re.createElement(B4.Provider, {
    value: a
  }, A);
};
ZH.propTypes = {
  stripe: Dt.any,
  options: Dt.object
};
var Tle = function(e) {
  var r = re.useContext(B4);
  return KH(r, e);
}, Mle = function() {
  var e = Tle("calls useElements()"), r = e.elements;
  return r;
};
Dt.func.isRequired;
var JH = /* @__PURE__ */ re.createContext(null);
JH.displayName = "CustomCheckoutSdkContext";
var Hle = function(e, r) {
  if (!e)
    throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(r, " in an <CustomCheckoutProvider> provider."));
  return e;
}, Dle = /* @__PURE__ */ re.createContext(null);
Dle.displayName = "CustomCheckoutContext";
Dt.any, Dt.shape({
  clientSecret: Dt.string.isRequired,
  elementsOptions: Dt.object
}).isRequired;
var O7 = function(e) {
  var r = re.useContext(JH), n = re.useContext(B4);
  if (r && n)
    throw new Error("You cannot wrap the part of your app that ".concat(e, " in both <CustomCheckoutProvider> and <Elements> providers."));
  return r ? Hle(r, e) : KH(n, e);
}, Qle = function(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}, Yn = function(e, r) {
  var n = "".concat(Qle(e), "Element"), A = function(a) {
    var c = a.id, l = a.className, u = a.options, f = u === void 0 ? {} : u, d = a.onBlur, g = a.onFocus, m = a.onReady, p = a.onChange, v = a.onEscape, C = a.onClick, w = a.onLoadError, B = a.onLoaderStart, y = a.onNetworksChange, b = a.onConfirm, q = a.onCancel, E = a.onShippingAddressChange, x = a.onShippingRateChange, M = O7("mounts <".concat(n, ">")), O = "elements" in M ? M.elements : null, I = "customCheckoutSdk" in M ? M.customCheckoutSdk : null, S = re.useState(null), P = VH(S, 2), H = P[0], F = P[1], T = re.useRef(null), U = re.useRef(null);
    fi(H, "blur", d), fi(H, "focus", g), fi(H, "escape", v), fi(H, "click", C), fi(H, "loaderror", w), fi(H, "loaderstart", B), fi(H, "networkschange", y), fi(H, "confirm", b), fi(H, "cancel", q), fi(H, "shippingaddresschange", E), fi(H, "shippingratechange", x), fi(H, "change", p);
    var D;
    m && (e === "expressCheckout" ? D = m : D = function() {
      m(H);
    }), fi(H, "ready", D), re.useLayoutEffect(function() {
      if (T.current === null && U.current !== null && (O || I)) {
        var Y = null;
        I ? Y = I.createElement(e, f) : O && (Y = O.create(e, f)), T.current = Y, F(Y), Y && Y.mount(U.current);
      }
    }, [O, I, f]);
    var Q = k7(f);
    return re.useEffect(function() {
      if (T.current) {
        var Y = WH(f, Q, ["paymentRequest"]);
        Y && "update" in T.current && T.current.update(Y);
      }
    }, [f, Q]), re.useLayoutEffect(function() {
      return function() {
        if (T.current && typeof T.current.destroy == "function")
          try {
            T.current.destroy(), T.current = null;
          } catch {
          }
      };
    }, []), /* @__PURE__ */ re.createElement("div", {
      id: c,
      className: l,
      ref: U
    });
  }, i = function(a) {
    O7("mounts <".concat(n, ">"));
    var c = a.id, l = a.className;
    return /* @__PURE__ */ re.createElement("div", {
      id: c,
      className: l
    });
  }, o = r ? i : A;
  return o.propTypes = {
    id: Dt.string,
    className: Dt.string,
    onChange: Dt.func,
    onBlur: Dt.func,
    onFocus: Dt.func,
    onReady: Dt.func,
    onEscape: Dt.func,
    onClick: Dt.func,
    onLoadError: Dt.func,
    onLoaderStart: Dt.func,
    onNetworksChange: Dt.func,
    onConfirm: Dt.func,
    onCancel: Dt.func,
    onShippingAddressChange: Dt.func,
    onShippingRateChange: Dt.func,
    options: Dt.object
  }, o.displayName = n, o.__elementType = e, o;
}, Vn = typeof window > "u", Ule = /* @__PURE__ */ re.createContext(null);
Ule.displayName = "EmbeddedCheckoutProviderContext";
var Nle = function() {
  var e = O7("calls useStripe()"), r = e.stripe;
  return r;
};
Yn("auBankAccount", Vn);
Yn("card", Vn);
var cE = Yn("cardNumber", Vn), jle = Yn("cardExpiry", Vn), Lle = Yn("cardCvc", Vn);
Yn("fpxBank", Vn);
Yn("iban", Vn);
Yn("idealBank", Vn);
Yn("p24Bank", Vn);
Yn("epsBank", Vn);
Yn("payment", Vn);
Yn("expressCheckout", Vn);
Yn("currencySelector", Vn);
Yn("paymentRequestButton", Vn);
Yn("linkAuthentication", Vn);
Yn("address", Vn);
Yn("shippingAddress", Vn);
Yn("paymentMethodMessaging", Vn);
Yn("affirmMessage", Vn);
Yn("afterpayClearpayMessage", Vn);
var _H = "https://js.stripe.com/v3", Gle = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var Rle = function() {
  for (var e = document.querySelectorAll('script[src^="'.concat(_H, '"]')), r = 0; r < e.length; r++) {
    var n = e[r];
    if (Gle.test(n.src))
      return n;
  }
  return null;
}, lE = function(e) {
  var r = "", n = document.createElement("script");
  n.src = "".concat(_H).concat(r);
  var A = document.head || document.body;
  if (!A)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return A.appendChild(n), n;
}, zle = function(e, r) {
  !e || !e._registerWrapper || e._registerWrapper({
    name: "stripe-js",
    version: "2.4.0",
    startTime: r
  });
}, g0 = null, Gf = null, Rf = null, Yle = function(e) {
  return function() {
    e(new Error("Failed to load Stripe.js"));
  };
}, Vle = function(e, r) {
  return function() {
    window.Stripe ? e(window.Stripe) : r(new Error("Stripe.js not available"));
  };
}, Wle = function(e) {
  return g0 !== null ? g0 : (g0 = new Promise(function(r, n) {
    if (typeof window > "u" || typeof document > "u") {
      r(null);
      return;
    }
    if (window.Stripe) {
      r(window.Stripe);
      return;
    }
    try {
      var A = Rle();
      if (!(A && e)) {
        if (!A)
          A = lE(e);
        else if (A && Rf !== null && Gf !== null) {
          var i;
          A.removeEventListener("load", Rf), A.removeEventListener("error", Gf), (i = A.parentNode) === null || i === void 0 || i.removeChild(A), A = lE(e);
        }
      }
      Rf = Vle(r, n), Gf = Yle(n), A.addEventListener("load", Rf), A.addEventListener("error", Gf);
    } catch (o) {
      n(o);
      return;
    }
  }), g0.catch(function(r) {
    return g0 = null, Promise.reject(r);
  }));
}, Xle = function(e, r, n) {
  if (e === null)
    return null;
  var A = e.apply(void 0, r);
  return zle(A, n), A;
}, m0, $H = !1, eD = function() {
  return m0 || (m0 = Wle(null).catch(function(e) {
    return m0 = null, Promise.reject(e);
  }), m0);
};
Promise.resolve().then(function() {
  return eD();
}).catch(function(t) {
  $H || console.warn(t);
});
var Kle = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  $H = !0;
  var A = Date.now();
  return eD().then(function(i) {
    return Xle(i, r, A);
  });
};
const m6 = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "gray",
      fontWeight: 400,
      fontFamily: "Hanken Grotesk, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "black" }
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "gray"
    }
  }
}, Zle = {
  name: "",
  email: "",
  address: {
    city: "",
    country: "",
    postal_code: "",
    state: ""
  },
  cardNumber: !1,
  cvv: !1,
  expiration: !1
}, Jle = ({
  tier: t,
  desc: e,
  paymentBanefits: r,
  bgColor: n,
  fontColor: A,
  buttonBgColor: i,
  btnTextColor: o,
  inputBgColor: s,
  pymentGatewayLayout: a,
  userId: c,
  token: l,
  forEntityId: u
}) => {
  const [f, d] = N(t || {}), [g, m] = N(e || ""), [p, v] = N(r || []), [C, w] = N({
    bgColor: n || "",
    fontColor: A || "",
    buttonBgColor: i || "",
    btnTextColor: o || "",
    inputBgColor: s || "",
    pymentGatewayLayout: a || ""
  }), [B, y] = N(Zle), [b, q] = N(!1), { apiKey: E, apiSecret: x, entityId: M, featureFlags: O } = Xe(
    ct.Context
  ), I = Nle(), S = Mle(), P = (D) => new Promise((Q) => {
    setTimeout(Q, D);
  }), H = async (D, Q) => {
    if (!I)
      throw new Error("Stripe initialization failed");
    const Y = await I.confirmCardPayment(D, {
      payment_method: {
        card: {
          token: Q
        }
      }
    });
    if (Y.error || Y.paymentIntent.status === "canceled")
      throw Y.error || new Error("Payment was cancelled");
    return Y.paymentIntent.status === "processing" ? (Ir.info("Payment processing"), await P(5e3), H(D, Q)) : Y.paymentIntent.status === "succeeded";
  }, F = async (D) => {
    try {
      if (D.preventDefault(), q(!0), !I || !S)
        throw new Error("stripe and elements not yet initialized");
      const Q = S.getElement(cE);
      if (!Q)
        throw new Error("Unable to create stripe element");
      const { error: Y, token: j } = await I.createToken(Q);
      if (Y)
        throw Y;
      const { error: Z, paymentMethod: W } = await I.createPaymentMethod({
        type: "card",
        card: { token: j.id }
      });
      if (Z)
        throw Z;
      const { name: R, email: K, address: L } = B, G = {
        cardData: {
          name: R,
          email: K,
          address: L
        },
        intentData: {
          amount: Number(f.creditsAmount) || 0,
          currency: "usd",
          name: f.creditsTierName,
          paymentMethodId: W.id
        },
        forEntityId: u
      }, { data: V } = await Oe.post(
        `${Ve.BACKEND_URL}api/entities/${M}/users/${c}/create-payment-intent`,
        G,
        {
          headers: {
            apiKey: E,
            apiSecret: x,
            entityId: M,
            userId: c,
            token: l
          }
        }
      );
      if (V.success === !1)
        throw new Error(V.error);
      await P(1e3);
      const _ = await I.createToken(Q);
      if (_.error)
        throw _.error;
      if (!await H(
        V.data.clientSecret,
        _.token.id
      ))
        throw new Error("Payment failed");
      const { data: X } = await Oe.post(
        `${Ve.BACKEND_URL}api/entities/${M}/approve-payment`,
        {
          intentId: V.data.intentId
        },
        {
          headers: {
            apiKey: E,
            apiSecret: x,
            entityId: M,
            userId: c,
            token: l
          }
        }
      );
      if (X.success === !1)
        throw new Error(X.error);
      Ir.success("Payment successfull");
    } catch (Q) {
      Ir.error((Q == null ? void 0 : Q.message) || "Something went wrong"), console.log(Q);
    } finally {
      q(!1);
    }
  }, U = MA(() => {
    let D = !0;
    return (B.name === "" || B.email === "" || !B.cardNumber || !B.cvv || !B.expiration) && (D = !1), (B.address.city === "" || B.address.country === "" || B.address.postal_code === "" || B.address.state === "") && (D = !1), D;
  }, [B]);
  return /* @__PURE__ */ k(
    "div",
    {
      className: "q-pyntg-main",
      style: C.pymentGatewayLayout ? C.pymentGatewayLayout == 2 ? { flexDirection: "row" } : { flexDirection: "column" } : {},
      children: [
        /* @__PURE__ */ k(
          "form",
          {
            onSubmit: F,
            className: "q-pyntg-ch",
            style: {
              boxShadow: "rgba(0, 0, 0, 0.50) 0px 0px 6px 0px",
              backgroundColor: `${C.bgColor}`,
              width: `${C.pymentGatewayLayout == 1 ? "100%" : ""}`,
              padding: `${C.pymentGatewayLayout == 1 ? "28px 24px" : ""}`
            },
            children: [
              /* @__PURE__ */ h(
                "p",
                {
                  className: "q-pyntg-ch-div",
                  style: { color: `${C.fontColor}` },
                  children: "Payment"
                }
              ),
              /* @__PURE__ */ k("div", { style: { marginBottom: "1.25rem" }, children: [
                /* @__PURE__ */ h(
                  "p",
                  {
                    style: {
                      color: `${C.fontColor}`,
                      marginBottom: ".75rem"
                    },
                    children: "Card holder name"
                  }
                ),
                /* @__PURE__ */ h(
                  "input",
                  {
                    type: "text",
                    className: "q-pyntg-ch-div-inp",
                    placeholder: "name",
                    name: "name",
                    value: B.name,
                    onChange: (D) => {
                      y(
                        (Q) => ({ ...Q, name: D.target.value })
                      );
                    },
                    required: !0,
                    style: {
                      backgroundColor: `${C.inputBgColor}`
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ k("div", { style: { marginBottom: "1.25rem" }, children: [
                /* @__PURE__ */ h(
                  "p",
                  {
                    style: {
                      color: `${C.fontColor}`,
                      marginBottom: ".75rem"
                    },
                    children: "Billing email"
                  }
                ),
                /* @__PURE__ */ h(
                  "input",
                  {
                    type: "email",
                    value: B.email,
                    onChange: (D) => {
                      y(
                        (Q) => ({ ...Q, email: D.target.value })
                      );
                    },
                    className: "q-pyntg-ch-div-inp",
                    placeholder: "Billing email",
                    name: "email",
                    required: !0,
                    style: {
                      backgroundColor: `${C.inputBgColor}`
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ k("div", { style: { marginBottom: "1.25rem" }, children: [
                /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "Card Number" }),
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q-pyntg-ch-div-inp",
                    style: {
                      backgroundColor: `${C.inputBgColor}`
                    },
                    children: /* @__PURE__ */ h(
                      cE,
                      {
                        options: m6,
                        onChange: (D) => {
                          y(
                            (Q) => ({ ...Q, cardNumber: D.complete })
                          );
                        }
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ k("div", { className: "q-pyntg-ch-div2", children: [
                /* @__PURE__ */ k("div", { children: [
                  /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "Expiration Date" }),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-pyntg-ch-div-inp",
                      style: {
                        backgroundColor: `${C.inputBgColor}`
                      },
                      children: /* @__PURE__ */ h(
                        jle,
                        {
                          options: m6,
                          onChange: (D) => {
                            y(
                              (Q) => ({ ...Q, expiration: D.complete })
                            );
                          }
                        }
                      )
                    }
                  )
                ] }),
                /* @__PURE__ */ k("div", { children: [
                  /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "CVV" }),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-pyntg-ch-div-inp",
                      style: {
                        backgroundColor: `${C.inputBgColor}`
                      },
                      children: /* @__PURE__ */ h(
                        Lle,
                        {
                          options: m6,
                          onChange: (D) => {
                            y(
                              (Q) => ({ ...Q, cvv: D.complete })
                            );
                          }
                        }
                      )
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ k("div", { className: "q-pyntg-ch-div2", children: [
                /* @__PURE__ */ k("div", { children: [
                  /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "Country" }),
                  /* @__PURE__ */ h(
                    "input",
                    {
                      type: "text",
                      className: "q-pyntg-ch-div-inp",
                      placeholder: "Country",
                      name: "country",
                      value: B.address.country,
                      onChange: (D) => {
                        y((Q) => ({
                          ...Q,
                          address: { ...Q.address, country: D.target.value }
                        }));
                      },
                      required: !0,
                      style: {
                        backgroundColor: `${C.inputBgColor}`
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ k("div", { children: [
                  /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "Postal Code" }),
                  /* @__PURE__ */ h(
                    "input",
                    {
                      type: "number",
                      className: "q-pyntg-ch-div-inp",
                      placeholder: "Postal code",
                      name: "postal_code",
                      value: B.address.postal_code,
                      onChange: (D) => {
                        y((Q) => ({
                          ...Q,
                          address: { ...Q.address, postal_code: D.target.value }
                        }));
                      },
                      required: !0,
                      style: {
                        backgroundColor: `${C.inputBgColor}`
                      }
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ k("div", { className: "q-pyntg-ch-div3", children: [
                /* @__PURE__ */ k("div", { children: [
                  /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "City" }),
                  /* @__PURE__ */ h(
                    "input",
                    {
                      type: "text",
                      className: "q-pyntg-ch-div-inp",
                      placeholder: "city",
                      name: "city",
                      value: B.address.city,
                      onChange: (D) => {
                        y((Q) => ({
                          ...Q,
                          address: { ...Q.address, city: D.target.value }
                        }));
                      },
                      required: !0,
                      style: {
                        backgroundColor: `${C.inputBgColor}`
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ k("div", { children: [
                  /* @__PURE__ */ h("p", { style: { color: `${C.fontColor}` }, children: "State" }),
                  /* @__PURE__ */ h(
                    "input",
                    {
                      type: "text",
                      className: "q-pyntg-ch-div-inp",
                      placeholder: "state",
                      name: "state",
                      value: B.address.state,
                      onChange: (D) => {
                        y((Q) => ({
                          ...Q,
                          address: { ...Q.address, state: D.target.value }
                        }));
                      },
                      required: !0,
                      style: {
                        backgroundColor: `${C.inputBgColor}`
                      }
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ h(
                "button",
                {
                  type: "submit",
                  className: "q-pyntg-ch-div-btn",
                  style: {
                    backgroundColor: `${C.buttonBgColor}`,
                    color: `${C.btnTextColor}`
                  },
                  disabled: !U || b,
                  children: b ? "Processing payment" : "Pay now"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-pyntg-rg",
            style: {
              backgroundColor: `${C.bgColor}`,
              width: `${C.pymentGatewayLayout == 1 ? "100%" : ""}`
            },
            children: /* @__PURE__ */ k(
              "div",
              {
                className: "q-pyntg-rg-div",
                style: {
                  boxShadow: "rgba(0, 0, 0, 0.50) 0px 0px 6px 0px",
                  padding: `${C.pymentGatewayLayout == 1 ? "28px 24px" : ""}`
                },
                children: [
                  /* @__PURE__ */ h(
                    "p",
                    {
                      className: "q-pyntg-rg-div-p",
                      style: { color: `${C.fontColor}` },
                      children: f != null && f.creditsTierName && f.creditsTierName.toLowerCase().includes(" plan") ? f.creditsTierName : f.creditsTierName + " Plan"
                    }
                  ),
                  /* @__PURE__ */ h(
                    "p",
                    {
                      className: "q-pyntg-rg-div-p2",
                      style: { color: `${C.fontColor}` },
                      children: g
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q-pyntg-rg-div-p3", children: [
                    /* @__PURE__ */ k(
                      "p",
                      {
                        className: "q-pyntg-rg-div-p3-p",
                        style: { color: `${C.fontColor}` },
                        children: [
                          "$",
                          f.creditsAmount
                        ]
                      }
                    ),
                    /* @__PURE__ */ h(
                      "p",
                      {
                        className: "q-pyntg-rg-div-p4",
                        style: { color: `${C.fontColor}` },
                        children: f.recurringTimePeriod == "ONETIME" ? "/one-time" : f.recurringTimePeriod == "MONTHLY" ? "/months" : "/years"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ h("div", { className: "q-pyntg-rg-div-br" }),
                  /* @__PURE__ */ h("p", { className: "q-pyntg-rg-div-fea", children: "FEATURES" }),
                  /* @__PURE__ */ k("div", { className: " q-pyntg-rg-div2", children: [
                    !!p && !!p.included && p.included.map((D, Q) => /* @__PURE__ */ k(
                      "div",
                      {
                        className: "q-pyntg-rg-div2-ben",
                        style: {
                          color: `${C.fontColor}`
                        },
                        children: [
                          /* @__PURE__ */ h("img", { src: GH, className: "q-pyntg-rg-div2-img" }),
                          /* @__PURE__ */ h("p", { children: D })
                        ]
                      },
                      Q
                    )),
                    !!p && !!p.notIncluded && p.notIncluded.map((D, Q) => /* @__PURE__ */ k("div", { className: "q-pyntg-rg-div2-ben2", children: [
                      /* @__PURE__ */ h("img", { src: RH, className: "q-pyntg-rg-div2-img" }),
                      /* @__PURE__ */ h("p", { color: "#9CA3AF", children: D })
                    ] }, Q))
                  ] })
                ]
              }
            )
          }
        )
      ]
    }
  );
}, mFe = ({
  userId: t,
  token: e,
  stripePublishableKey: r,
  description: n,
  paymentBanefits: A,
  bgColor: i,
  fontColor: o,
  mainLayout: s,
  pymentGatewayLayout: a,
  buttonBgColor: c,
  btnTextColor: l,
  inputBgColor: u,
  width: f,
  forEntityId: d,
  uniqueEmailId: g,
  uniqueUserId: m
}) => {
  var T;
  const [p, v] = N([]), [C, w] = N(n || []), { apiKey: B, apiSecret: y, apiType: b, entityId: q, featureFlags: E } = Xe(
    ct.Context
  ), x = Kle(r), [M, O] = N(0), [I, S] = N(!1), [P, H] = N({
    bgColor: i || "",
    fontColor: o || "",
    mainLayout: s || "",
    buttonBgColor: c || "",
    btnTextColor: l || "",
    inputBgColor: u || "",
    width: f || ""
  });
  le(() => {
    if (q) {
      const U = {
        apiKey: B,
        apisecret: y,
        userId: t,
        token: e
        // Replace with your actual token
      }, D = `${Ve.BACKEND_URL}api/entities/${q}/credits-tiers?userId=${t}`;
      Oe.get(D, { headers: U }).then((Q) => {
        let Y = Q.data;
        Y.success && v([...Y.data]);
      });
    }
    q && m && new Bt("").getExternalLogin({ apiType: b, uniqueUserId: m, entityId: q, userId: t, apiKey: B, apiSecret: y, token: e, uniqueEmailId: g });
  }, []);
  const F = (U) => {
    O(U), S(!0);
  };
  return ((T = E[Ve.FLAG_CONSTRAINTS.PaymentFlag]) == null ? void 0 : T.isEnabled) == !1 ? /* @__PURE__ */ h("div", {}) : /* @__PURE__ */ k(
    "div",
    {
      className: "q-pynt-home q-pynt-main",
      style: {
        fontFamily: "'Hanken Grotesk', sans-serif",
        width: `${P.width}`
      },
      children: [
        I == !1 && /* @__PURE__ */ h(
          "div",
          {
            className: "q-pynt-main-div",
            style: {
              gridTemplateColumns: `repeat(${P.mainLayout},1fr)`
            },
            children: p.map((U, D) => /* @__PURE__ */ k(
              "div",
              {
                className: "q-pynt-main-div-tier",
                style: {
                  boxShadow: "rgba(0, 0, 0, 0.50) 0px 0px 6px 0px",
                  backgroundColor: `${P.bgColor}`
                },
                children: [
                  /* @__PURE__ */ h(
                    "p",
                    {
                      className: "q-pynt-main-div-p",
                      style: { color: `${P.fontColor}` },
                      children: U.creditsTierName.toLowerCase().includes(" plan") ? U.creditsTierName : U.creditsTierName + " Plan"
                    }
                  ),
                  /* @__PURE__ */ h(
                    "p",
                    {
                      className: "q-pynt-main-div-p2",
                      style: { color: `${P.fontColor}` },
                      children: C[D]
                    }
                  ),
                  /* @__PURE__ */ k(
                    "div",
                    {
                      className: "q-pynt-main-div-div",
                      style: { color: `${P.fontColor}` },
                      children: [
                        /* @__PURE__ */ k("p", { className: "q-pynt-main-div-div-p", children: [
                          "$",
                          U.creditsAmount
                        ] }),
                        /* @__PURE__ */ h("p", { className: "q-pynt-main-div-div-p2", children: U.recurringTimePeriod == "ONETIME" ? "/one-time" : U.recurringTimePeriod == "MONTHLY" ? "/months" : "/years" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ h(
                    "button",
                    {
                      className: "q-pynt-main-div-div-btn",
                      onClick: () => F(D),
                      style: {
                        backgroundColor: P.buttonBgColor,
                        color: `${P.btnTextColor}`
                      },
                      children: "Continue"
                    }
                  ),
                  /* @__PURE__ */ h("div", { className: "q-pynt-main-div-div-ch" }),
                  /* @__PURE__ */ h("p", { className: "q-pynt-main-div-div-p3", children: "FEATURES" }),
                  /* @__PURE__ */ k("div", { className: " q-pynt-main-div-div-chDiv", children: [
                    !!A[D] && !!A[D].included && A[D].included.map(
                      (Q, Y) => /* @__PURE__ */ k(
                        "div",
                        {
                          className: "q-pynt-main-div-div-chDiv-ben",
                          style: {
                            color: `${P.fontColor}`
                          },
                          children: [
                            /* @__PURE__ */ h(
                              "img",
                              {
                                src: GH,
                                style: { width: "1.25rem", height: "1.25rem" }
                              }
                            ),
                            /* @__PURE__ */ h("p", { children: Q })
                          ]
                        },
                        Y
                      )
                    ),
                    !!A[D] && !!A[D].notIncluded && A[D].notIncluded.map(
                      (Q, Y) => /* @__PURE__ */ k("div", { className: "q-pynt-main-div-div-chDiv-ben2", children: [
                        /* @__PURE__ */ h(
                          "img",
                          {
                            src: RH,
                            style: { width: "1.25rem", height: "1.25rem" }
                          }
                        ),
                        /* @__PURE__ */ h("p", { style: { color: "#9CA3AF" }, children: Q })
                      ] }, Y)
                    )
                  ] })
                ]
              },
              D
            ))
          }
        ),
        I == !0 && /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(ZH, { stripe: x, children: /* @__PURE__ */ h(
          Jle,
          {
            tier: p[M],
            desc: C[M],
            paymentBanefits: A[M],
            bgColor: i,
            fontColor: o,
            buttonBgColor: c,
            btnTextColor: l,
            inputBgColor: u,
            pymentGatewayLayout: a,
            userId: t,
            token: e,
            forEntityId: d
          }
        ) }) })
      ]
    }
  );
}, tD = "data:image/png;base64,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", _le = "data:image/png;base64,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", $le = "data:image/png;base64,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", eue = "data:image/png;base64,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", tue = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADYSURBVHgB7dXNDYJAEIbhYaEASsAKbMEWCAVICVqB0oF2QAOE0IF2YAdSAgXw4xg9eZq9LfF9EgKHIQzf/okAAAAAAAAAAAAA+AeReGqapnTO7fVxJ2F5zPN8LYqi9nnJK4Cu6076kbMETPs7aggXa705gLZtM709JXyDXps8zwdLsRO7TNYhFY/laQ5gmqZUVmIcR9Pov5kDiOP4Jp/pFbwkSXprrTmA75qqJHC6CVbaa2+t9z4GdTMsl2U5RFG0lYBoT3ftqdafrwUAAAAAAAAAAAAAfrwAPqA3v38+QLAAAAAASUVORK5CYII=", rue = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIeSURBVHgB7ZrrTcMwFIWdTBA26AgwAhNUnYB0A9iEDQgTVJ2AFdiAjsAEDfcUp0KoaZz7yo/eT6pcJZHs89VJ40dKQRAEQRAEQRAEwe1RJQG73W5FxVPf93dVVb1uNptDcgD1Ho/HFt/ruu4k9bIF5PAf9FkNx6gx7Xq9fk+GUL33ud4mHzrQ54EkfCcGdWKSf4HVv2Pdfr9/SkZcCA/OvYEDWwB1+ebScSsJI+EHmsREIqCj4mK305YwEf70HEhM2ALonvuk4mXsvJaEqfDEdpGH4AA1sKXibey85MFYGL5LAsQCgIUEj/BARQDQlOAV/tSupERu0HbsfOkzIV/jEh6o9YABSU9AeIhK46iGB+oCAEfCEuGBiQAwR8JS4YGZAFAiAeVS4YGpADAlYQLT8MBcAGBKMA8PXASAmRJcwgM3AaBQglt4oPYiVFRZXfca12ji1gMK/urOeMwsDbgImBN+wEuCuQBO+AEPCaYCSt7wcmkyn1CCmYA5r7eWkypTmAjgvNsvJUFdgGRgs4QEVQEaozpvCWoCNIe0nhJUBFiM570kiAVYTmZ4SBAJ8JjJsZYgXR3+unKJ2qhuQgKW5x7zStVs2KPBvu+fr5xWHdJOTLk31JY2MZEsjo6tx5uM569JIAGsvQFAMh/Qpd/NCX8xncwYkXCQrA6Lt8hgcwL2CmC5nHsfcurFLZh7oWiLTBAEQRAEQRAEQXCL/ADqNn4Mw6A/7QAAAABJRU5ErkJggg==", nue = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABoCAYAAAAdHLWhAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANtSURBVHgB7dvNbRpBGMbx4cMHhESQ4JBbtoNwzNElpASX4A6SDmwqMO7AqSBxBck1J5M7KOsLUgSCvLNZOWNr/c5+zc7X85MQCbKUwN/zGLAtBAAAAAAAAAAAAACIge4D5vP5+Wg0+jQejx93u91aQKf6ZT6o1+td0NVXivV9NptdCOhMqUCKBcW6oUgPFOtqOp0mAoyqGihDkRK6uhwOhw8U60bOoAAjagVSYf7MahxIgfkzoM1AGcxfu1oPpML8NWc0kALzV1NXgTKYv+o6DaTC/JVjLZAC88dwIVAG81fMmUAqzN9/TgZSRD9/2kCn02kqLIt5/rSB+v2+9UCq2ObP9YnjRDF/PgfKhD5/3gdShTh/QQVSBDN/oQbKhDB/QQdS+Tp/0QRSeDV/MQbK+DJ/0QZSuTx/CPScc/OHQAVcmj8E0rA9fwhUnpX50/52w2QySY/H4y/6tsNP+g/+oZse6fJWRIoeA/nu/gd6l/9yNBolpn/roydqkp9BtNGJ3GuKl9BNC3kzXd7n1zH5QY/BcrvdrkTLagfiULzp2dlZQifvKSBdqwGDRPdzTffz7nA4LNM0XYsWGAmkE8Ppo/u1ovt3u9lsvokGrATiBHj6Gs2fc4F0fD19defPu0AcX05flfkLKpCOg6dPO39RBeLYPH35/K1o/m5fzh/eSVDs9/v0xU2/6YF7Q9epMCh/8dsr+neimzg6JfLBWMgTQpd38pTIByifvK7dy5NDnxh3dHIKPwmCe5IgrwaDwUKZqSxC/hOyrjzL+0KX6yCfJDh4CsqSJ2RJX2euXzstRZx8oSr8OAVlaWeMY+2tHk9PQRWlZ4xj7M1SEdYpKKvWjHEafbshglNQVqMZ42gD5a++P0Z0CqpoZcY4Q90H0Ck5pyBXFCb7O/1ZRK71GeNoA8ETYzPGQSA94zPGQaBinc4YB4GeszJjHAT6x+qMcWIO5MyMcWIM5NyMcWIK5OyMcUIP5MWMcUIN5NWMcUIL5OWMcUII5P2McXwOFMyMcXwMFNyMcbSB5A/VCfuCnjGO6ycoihnjuBooqhnjuBQo2hnjuBAo+hnj2AyEGSuh60CYsYq6CoQZq8l0IMxYQyYCYcZa1GYgzJgBbQTCjBlUNxBmrCNVA2HGOlY20D1dPmPGAAAAAAAAAAAAAMCKvx/cVoqZdxZLAAAAAElFTkSuQmCC", vFe = ({ logoType: t, bgColor: e }) => {
  var v;
  const [r, n] = N(!1), [A, i] = N(!1), [o, s] = N([]), [a, c] = N(""), l = gt(null), { featureFlags: u } = Xe(ct.Context);
  le(() => {
    l.current.scrollTop = l.current.scrollHeight;
  }, [o]);
  const f = (C, w) => /* @__PURE__ */ h("div", { className: "q-cht-comp-div", children: /* @__PURE__ */ h("div", { className: "q-cht-comp-msg", children: C }) }, w), d = (C, w) => /* @__PURE__ */ h("div", { className: "q-cht-user-div", children: /* @__PURE__ */ h("div", { className: "q-cht-user-msg", children: C }) }, w), g = async () => {
    let C = a;
    s([
      ...o,
      {
        sender: "user",
        message: C
      }
    ]), c(""), i(!0), await m().then(() => {
      i(!1), s([
        ...o,
        {
          sender: "user",
          message: C
        },
        {
          sender: "computer",
          message: "I am fine!"
        }
      ]);
    });
  }, m = () => new Promise((C) => setTimeout(C, 2e3)), p = (C) => {
    C.key == "Enter" && g();
  };
  return ((v = u[Ve.FLAG_CONSTRAINTS.ChatFlag]) == null ? void 0 : v.isEnabled) == !1 ? /* @__PURE__ */ h("div", {}) : gd.createPortal(
    /* @__PURE__ */ h(
      "div",
      {
        className: "q-cht-home",
        style: { fontFamily: "'Hanken Grotesk', sans-serif" },
        children: /* @__PURE__ */ k("div", { className: "popup-overlay", children: [
          /* @__PURE__ */ k("div", { className: "q-cht-main", onClick: () => n(!r), children: [
            t == 2 ? /* @__PURE__ */ h("img", { src: _le, alt: "", className: "q-cht-logo1" }) : t == 3 ? /* @__PURE__ */ h("img", { src: $le, alt: "", className: "q-cht-logo1" }) : t == 4 ? /* @__PURE__ */ h("img", { src: eue, alt: "", className: "q-cht-logo1" }) : /* @__PURE__ */ h("img", { src: tD, alt: "", className: "q-cht-logo2" }),
            /* @__PURE__ */ h("img", { src: "", alt: "" })
          ] }),
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-cht-ch",
              style: {
                boxShadow: "rgba(0, 0, 0, 0.50) 0px 0px 6px 0px",
                transition: "all 0.4s",
                opacity: `${r ? "1" : "0"}`,
                visibility: `${r ? "visible" : "hidden"}`,
                width: `${r ? "" : "0px"}`,
                height: `${r ? "" : "0px"}`,
                backgroundColor: `${e}`
              },
              children: [
                /* @__PURE__ */ k("div", { className: "q-cht-ch-div", children: [
                  /* @__PURE__ */ h("div", { className: "q-cht-ch-div-p", children: "Chat Support" }),
                  /* @__PURE__ */ k("div", { style: { display: "flex", gap: "1rem" }, children: [
                    /* @__PURE__ */ h(
                      "img",
                      {
                        src: tue,
                        className: "q-cht-ch-div-imgCon",
                        alt: "",
                        onClick: () => n(!1)
                      }
                    ),
                    /* @__PURE__ */ h(
                      "img",
                      {
                        src: rue,
                        className: "q-cht-ch-div-imgCon",
                        alt: "",
                        onClick: () => n(!1)
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ k(
                  "div",
                  {
                    className: "q-cht-ch-div2 chatBox",
                    ref: l,
                    children: [
                      !!o && o.map(
                        (C, w) => C.sender == "user" ? d(C.message, w) : f(C.message, w)
                      ),
                      A && /* @__PURE__ */ h("div", { className: "q-cht-ch-loading", children: /* @__PURE__ */ k("div", { className: "msgTyping q-cht-ch-loading-div", children: [
                        /* @__PURE__ */ h("div", { className: "dot" }),
                        /* @__PURE__ */ h("div", { className: "dot" }),
                        /* @__PURE__ */ h("div", { className: "dot" })
                      ] }) })
                    ]
                  }
                ),
                /* @__PURE__ */ k(
                  "div",
                  {
                    className: "q-cht-ch-footer",
                    style: { backgroundColor: `${e}` },
                    children: [
                      /* @__PURE__ */ h(
                        "input",
                        {
                          className: "q-cht-ch-footer-inp",
                          value: a,
                          onChange: (C) => c(C.target.value),
                          onKeyUp: p
                        }
                      ),
                      /* @__PURE__ */ h("div", { className: "q-cht-ch-footer-options", children: /* @__PURE__ */ h(
                        "img",
                        {
                          src: nue,
                          alt: "",
                          className: "q-cht-ch-footer-options-logo",
                          onClick: g
                        }
                      ) })
                    ]
                  }
                )
              ]
            }
          )
        ] })
      }
    ),
    document.getElementById("root")
  );
};
async function Aue({
  apiKey: t = "",
  apiSecret: e = "",
  userId: r = "",
  token: n = "",
  entityId: A = "e-cbd250cc-3fcb-4085-a95e-712742ffa7ac",
  questId: i = "",
  enableVariation: o = !1
}) {
  const s = { apiKey: t, apiSecret: e, userId: r, token: n }, a = `${Ve.BACKEND_URL}api/entities/${A}/quests/${i}?userId=${r}&getVariation=${o}`;
  try {
    return (await Oe.get(a, { headers: s })).data;
  } catch (c) {
    return c instanceof GP ? console.log(c.message) : console.log(c), null;
  }
}
async function iue(t) {
  const { entityId: e, questId: r, questUserId: n, criterias: A, headers: i } = t;
  await Oe.post(
    `${Ve.BACKEND_URL}api/entities/${e}/quests/${r}/verify-all?userId=${n}`,
    { criterias: A },
    { headers: i }
  ), await Oe.post(
    `${Ve.BACKEND_URL}api/entities/${e}/users/${n}/metrics/onboarding-complete?userId=${n}&questId=${r}`,
    { count: 1 },
    { headers: i }
  );
}
const uE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAA0ElEQVR4Xu3W6wnDMAwE4BuhI3Qza5Ru0lW6QUfwCB2htXACfrR/GlmJyX1wEIiRpYBNACIiIiI6kpDySonL83S08fcSHWQ6a/NrpsMB9uY2QMCY28JlAG243MTythg+QNu8JlYrtmlrm/rWvEaKNVu1tc14NH9FX9+ER/OXlDvq+s9qxZ9+Ne8RgYGIvrBHIozoFdkWH52IfB5MCPoNRuWRckM+D6YE/WaaUKw5PEE/AIfYg6AfwPJfyIWgHiBWbychyI3r19dnIiIiIqKT+QCR89/8Yty7PwAAAABJRU5ErkJggg==", qFe = (t) => {
  const {
    userId: e = "",
    questId: r = "",
    shadowColor: n = "rgba(0, 0, 0, 0.25)",
    token: A = "",
    setAnswer: i = () => {
    },
    onSubmit: o = () => {
    },
    enableVariation: s = !1
  } = t, a = Xe(ct.Context) || null, { apiKey: c, apiSecret: l, entityId: u, featureFlags: f } = Xe(ct.Context), [d, g] = N([]), [m, p] = N(), [v, C] = N(-1), [w, B] = N([]);
  let y = Date.now();
  const {
    color: b = "",
    bgColor: q = "",
    progressBar: E,
    alignment: x = "start",
    inputBorderColor: M = "transparent",
    headingSize: O = "24px",
    descSize: I = "24px",
    inputBgColor: S = "#F6F6F6"
  } = t, P = async () => {
    const R = await Aue({ ...a, userId: e, questId: r, token: A, enableVariation: s });
    if (!(R != null && R.success)) return;
    p(R);
    let K = R == null ? void 0 : R.eligibilityData.map((L) => ({
      ...L.data.metadata,
      ...L.data
    }));
    g(K), i(K.map(({ title: L, options: G, criteriaId: V }) => ({ question: L, answer: G ? [] : "", criteriaId: V })));
  }, [H, F] = N(""), T = ({ setFill: R, title: K = "" }) => /* @__PURE__ */ h(
    "textarea",
    {
      cols: 60,
      placeholder: "enter the " + K,
      className: "q-form-text-area",
      onChange: (L) => {
        R(L.target.value), i((G) => (G[v].answer = L.target.value, G));
      },
      style: { color: b, border: `1px solid ${M}`, backgroundColor: q },
      rows: 5
    }
  ), U = ({ setFill: R, options: K = ["option1", "option2", "option3"] }) => /* @__PURE__ */ h("div", { className: "q-form-radio", children: K.map((L, G) => {
    var V;
    return /* @__PURE__ */ k("div", { className: "q-form-radio-flex", children: [
      /* @__PURE__ */ h(
        "input",
        {
          id: `sct${G}`,
          type: "radio",
          value: L,
          defaultChecked: !!((V = w[v]) != null && V.length) && w[v] == L,
          onChange: (_) => {
            R(_.target.value), B((J) => (J[v] = _.target.value, J)), i((J) => (J[v].answer = _.target.value, J));
          },
          name: "default-radio",
          className: "q-form-radio-input"
        }
      ),
      /* @__PURE__ */ h(
        "label",
        {
          htmlFor: `sct${G}`,
          className: "q-form-radio-label",
          children: L
        }
      )
    ] }, G);
  }) }), D = ({ setFill: R, options: K = ["option1", "option2", "option3"] }) => {
    let L = [];
    return le(() => {
      Array.isArray(w[v]) && (L = w[v], R(L[0]));
    }, []), /* @__PURE__ */ h("div", { className: "q-form-multi", children: /* @__PURE__ */ h("ul", { className: "q-form-multi-ul", children: K.map((G, V) => {
      var _;
      return /* @__PURE__ */ k("li", { children: [
        /* @__PURE__ */ h(
          "input",
          {
            type: "checkbox",
            id: `mct${V}`,
            value: G,
            defaultChecked: !!((_ = w[v]) != null && _.length) && w[v].includes(G),
            className: "q-form-multi-li",
            onChange: (J) => {
              R(J.target.value), B((X) => {
                if (Array.isArray(X[v]))
                  if (J.target.checked)
                    X[v].push(J.target.value);
                  else
                    for (let ne = X[v].length - 1; ne >= 0; ne--)
                      X[v][ne] === J.target.value && X[v].splice(ne, 1);
                else
                  X[v] = [J.target.value];
                return X;
              }), i((X) => {
                var ne;
                if (Array.isArray(X[v].answer))
                  if (J.target.checked)
                    X[v].answer.push(J.target.value);
                  else
                    for (let ee = X[v].answer.length - 1; ee >= 0; ee--)
                      ((ne = X[v]) == null ? void 0 : ne.answer[ee]) === J.target.value && X[v].answer.splice(ee, 1);
                else
                  X[v].answer = [J.target.value];
                return X;
              });
            }
          }
        ),
        /* @__PURE__ */ h(
          "label",
          {
            htmlFor: `mct${V}`,
            className: "q-form-multi-for",
            children: /* @__PURE__ */ h("div", { className: "q-form-multi-block", children: /* @__PURE__ */ h("div", { className: "q-form-text-sm", children: G }) })
          }
        )
      ] }, V);
    }) }) });
  }, Q = ({ title: R = "", setFill: K }) => {
    const L = gt(null);
    return le(() => {
      L.current && (typeof w[v] == "string" && (L.current.value = w[v], K(w[v])), L.current.focus());
    }, []), /* @__PURE__ */ h(
      "input",
      {
        placeholder: R,
        style: { color: b, border: `1px solid ${M}`, backgroundColor: S },
        ref: L,
        onChange: (G) => {
          K(G.target.value), B((V) => (V[v] = G.target.value, V)), i((V) => (V[v].answer = G.target.value, V));
        },
        className: "q-form-normal-input"
      }
    );
  }, Y = ({ setFill: R }) => {
    const K = gt(null);
    return le(() => {
      K.current && typeof w[v] == "string" && (K.current.value = w[v], R(w[v]));
    }, []), /* @__PURE__ */ k("div", { className: "py-3", children: [
      /* @__PURE__ */ h("label", { className: "q-form-date-label", htmlFor: "dateInput", style: { color: b } }),
      /* @__PURE__ */ h(
        "input",
        {
          type: "date",
          id: "dateInput",
          name: "dateInput",
          ref: K,
          style: { color: b, border: `1px solid ${M}`, backgroundColor: S },
          className: "q-form-date-input",
          onChange: (L) => {
            R(L.target.value), B((G) => (G[v] = L.target.value, G)), i((G) => (G[v].answer = L.target.value, G));
          }
        }
      )
    ] });
  }, j = () => {
    const R = d.map((K, L) => ({ criteriaId: K.criteriaId, answer: w[L] }));
    iue({ entityId: u, criterias: R, headers: { apikey: c, apisecret: l, token: A, userId: e }, questId: r, questUserId: e });
  }, Z = () => {
    v > d.length - 1 && C(() => d.length - 1);
    const R = d[v], [K, L] = N(!0), [G, V] = N("");
    return window.onkeydown = (_) => {
      _.key === "Enter" && (R.isOptional || G ? (F("scroll-animation"), v == d.length - 1 ? (o(), j()) : (C((J) => J + 1), V(""))) : L(!1));
    }, window.onwheel = (_) => {
      Date.now() - y < 1e3 || (y = Date.now(), _.deltaY > 0 && v < d.length - 1 ? R.isOptional || G ? (F("scroll-animation"), C((J) => J + 1), V("")) : L(!1) : _.deltaY < 0 && v > -1 && (F("scroll-animation-rev"), C((J) => J - 1)));
    }, /* @__PURE__ */ h(Ze, { children: !!d.length && /* @__PURE__ */ k("div", { style: { boxShadow: `0 0 5px ${n}` }, className: `${H} q-form-survey`, children: [
      /* @__PURE__ */ h("div", { className: "q-form-survey-h4", style: { fontSize: I }, children: R == null ? void 0 : R.title }),
      /* @__PURE__ */ k("div", { className: "q-form-survey-input-div", children: [
        (() => {
          switch (R.criteriaType) {
            case "":
              return /* @__PURE__ */ h(Q, { setFill: V, title: R == null ? void 0 : R.title });
            case "USER_INPUT_TEXT":
              return /* @__PURE__ */ h(Q, { setFill: V, title: R == null ? void 0 : R.title });
            case "USER_INPUT_MULTI_CHOICE":
              return /* @__PURE__ */ h(D, { options: R.options, setFill: V });
            case "USER_INPUT_SINGLE_CHOICE":
              return /* @__PURE__ */ h(U, { options: R.options, setFill: V });
            case "USER_INPUT_DATE":
              return /* @__PURE__ */ h(Y, { setFill: V });
            case "USER_INPUT_TEXT_AREA":
              return /* @__PURE__ */ h(T, { setFill: V, title: R.title });
            default:
              return /* @__PURE__ */ h(Q, { setFill: V, title: R == null ? void 0 : R.title });
          }
        })(),
        !K && /* @__PURE__ */ k("div", { className: "q-input-alert", children: [
          /* @__PURE__ */ h(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              children: /* @__PURE__ */ h(
                "path",
                {
                  d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
                  fill: "#C53434"
                }
              )
            }
          ),
          /* @__PURE__ */ h("div", { style: { color: "red" }, children: "please fill the above field" })
        ] })
      ] }),
      /* @__PURE__ */ k("div", { className: "q-form-survey-div", children: [
        v > 0 && v < d.length - 1 && /* @__PURE__ */ h(
          "div",
          {
            onClick: () => {
              F("scroll-animation-rev"), C((_) => _ - 1);
            },
            className: "q-form-survey-prev",
            children: "Previous"
          }
        ),
        v < d.length && /* @__PURE__ */ h(
          "div",
          {
            onClick: () => {
              R.isOptional || G ? (F("scroll-animation"), v == d.length - 1 ? (o(), j()) : (C((_) => _ + 1), V(""))) : L(!1);
            },
            className: "q-form-first-next",
            children: d.length - 1 == v ? "Submit" : "Next"
          }
        ),
        v < 1 && /* @__PURE__ */ k("div", { className: "q-form-survey-enter", children: [
          "Press Enter",
          /* @__PURE__ */ h("img", { className: "w-8", src: uE, alt: "" })
        ] })
      ] })
    ] }) });
  }, W = () => (window.onkeydown = (R) => {
    R.key === "Enter" && (F("scroll-animation"), C((K) => K + 1));
  }, window.onwheel = (R) => {
    Date.now() - y < 1e3 || (y = Date.now(), R.deltaY > 0 && v < d.length - 1 && (F("scroll-animation"), C((K) => K + 1)));
  }, /* @__PURE__ */ h(Ze, { children: !!m && /* @__PURE__ */ k("div", { style: { boxShadow: `0 0 5px ${n}` }, className: "q-form-first " + H, children: [
    /* @__PURE__ */ h("div", { className: "q-form-first-h2", style: { color: b }, children: m == null ? void 0 : m.data.title }),
    /* @__PURE__ */ h(
      "div",
      {
        style: { color: b, fontSize: O },
        className: "q-form-font-normal",
        children: m.data.description
      }
    ),
    /* @__PURE__ */ k("div", { className: "q-form-first-div", children: [
      /* @__PURE__ */ h(
        "div",
        {
          onClick: () => C((R) => R + 1),
          className: "q-form-first-next",
          children: "Next"
        }
      ),
      /* @__PURE__ */ k("div", { className: "q-form-first-enter", children: [
        "Press Enter",
        /* @__PURE__ */ h("img", { width: "35px", src: uE, alt: "" })
      ] })
    ] })
  ] }) }));
  return le(() => {
    P();
  }, []), /* @__PURE__ */ k("div", { className: "q-form", style: { width: t.width || "99vw" }, children: [
    E && /* @__PURE__ */ h(
      "div",
      {
        style: { width: `${String((v + 1) / (d.length - 1) * 100)}vw` },
        className: "q-form-progress"
      }
    ),
    /* @__PURE__ */ h("div", { style: {
      backgroundColor: q,
      color: b,
      justifyContent: x
    }, className: "q-form-div", children: v < 0 ? /* @__PURE__ */ h(W, {}) : /* @__PURE__ */ h(Z, {}) })
  ] });
}, Gi = (t, e) => {
  const n = {
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(t)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(t)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(t)}`
  }[e];
  n ? window.open(n, "_blank") : console.error("Invalid platform");
}, rD = async (t = "", e) => {
  let r = new Bt("mixpanel", e.apiType);
  try {
    const n = `${Ve.BACKEND_URL}api/entities/${e.entityId}/quests/${t}/users/${e.userid}/referralcode`;
    console.log(n);
    const { data: A } = await Oe.get(n, { headers: e });
    return A;
  } catch (n) {
    return r.captureSentryException(n), { success: !1 };
  }
}, oue = ({ isOpen: t, onClose: e, children: r }) => {
  const n = gt(null);
  return le(() => {
    const A = (i) => {
      t && n.current && !n.current.contains(i.target) && e();
    };
    return t && document.addEventListener("mousedown", A), () => {
      document.removeEventListener("mousedown", A);
    };
  }, [t, e]), /* @__PURE__ */ h("div", { className: `q-refer-popup ${t ? "q-refer-open" : ""}`, children: /* @__PURE__ */ k("div", { className: "q-refer-popup-content", ref: n, children: [
    /* @__PURE__ */ h("button", { className: "q-refer-close-button", onClick: e, children: "X" }),
    r
  ] }) });
};
async function sue(t, e, r, n, A, i) {
  let o = new URLSearchParams();
  o.set("platform", "REACT"), A && o.set("variation", A);
  const s = `${i}api/v2/entities/${e}/campaigns/${r}?${o.toString()}`;
  let a = new Bt("mixpanel", n);
  try {
    return (await Oe.get(s, { headers: t })).data.data;
  } catch (c) {
    return a.captureSentryException(c), {};
  }
}
const aue = ({
  description: t = "If you like this article share it with your friends",
  heading: e = "Share this article",
  questId: r = "",
  token: n = "",
  userId: A = "",
  variation: i,
  styleConfig: o,
  Headers: s
}) => {
  var C, w, B, y, b, q;
  const { apiKey: a, apiSecret: c, entityId: l, featureFlags: u, apiType: f, themeConfig: d } = Xe(ct.Context), [g, m] = N("");
  let p = f == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, v = new Bt("mixpanel", f);
  return le(() => {
    v.fireTrackingEvent(
      "quest_share_article_loaded",
      "share_article"
    ), sue(
      { apiKey: a, apisecret: c, token: n, userId: A },
      l,
      r,
      f,
      i,
      p
    ).then((E) => {
      var M;
      let [x] = E.actions;
      m((M = x == null ? void 0 : x.metadata) == null ? void 0 : M.link);
    });
  }, []), /* @__PURE__ */ h(
    "div",
    {
      className: "q_share_article",
      style: {
        background: ((C = o == null ? void 0 : o.Form) == null ? void 0 : C.background) || (d == null ? void 0 : d.backgroundColor),
        ...o
      },
      children: /* @__PURE__ */ k("div", { className: "q_article_div", children: [
        /* @__PURE__ */ k("div", { className: "q_article_up", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_article_head",
              style: {
                color: ((w = o == null ? void 0 : o.Heading) == null ? void 0 : w.color) || (d == null ? void 0 : d.primaryColor),
                fontFamily: d == null ? void 0 : d.fontFamily,
                ...o == null ? void 0 : o.Heading
              },
              children: s && ((B = s[0]) == null ? void 0 : B.heading) || e
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_article_desc",
              style: {
                color: ((y = o == null ? void 0 : o.Description) == null ? void 0 : y.color) || (d == null ? void 0 : d.secondaryColor),
                fontFamily: d == null ? void 0 : d.fontFamily,
                ...o == null ? void 0 : o.Description
              },
              children: s && ((b = s[0]) == null ? void 0 : b.subHeading) || t
            }
          )
        ] }),
        /* @__PURE__ */ k("div", { className: "q_article_dn", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_article_wit",
              style: { color: (q = o == null ? void 0 : o.Description) == null ? void 0 : q.color, fontFamily: d == null ? void 0 : d.fontFamily },
              children: "Share with"
            }
          ),
          /* @__PURE__ */ k("div", { className: "q_article_img", children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-referShare-content-social-img-x",
                onClick: () => {
                  v.fireTrackingEvent(
                    "quest_share_article_twitter_clicked",
                    "share_article"
                  ), Gi(g, "twitter");
                },
                children: RM()
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q-referShare-content-social-img",
                src: Zg,
                onClick: () => {
                  v.fireTrackingEvent(
                    "quest_share_article_whatsapp_clicked",
                    "share_article"
                  ), Gi(g, "whatsapp");
                },
                alt: "Whatsapp"
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q-referShare-content-social-img",
                onClick: () => {
                  v.fireTrackingEvent(
                    "quest_share_article_telegram_clicked",
                    "share_article"
                  ), Gi(g, "telegram");
                },
                src: Kg,
                width: "24px",
                alt: "telegramPng"
              }
            )
          ] })
        ] })
      ] })
    }
  );
}, yFe = ({
  isOpen: t = !0,
  questId: e = "",
  userId: r = "",
  token: n = "",
  color: A,
  bgColor: i,
  isArticle: o = !1,
  description: s,
  heading: a,
  headingColor: c,
  uniqueEmailId: l,
  uniqueUserId: u
}) => {
  const [f, d] = N(""), [g, m] = N(!1), { apiKey: p, apiSecret: v, entityId: C, apiType: w } = Xe(ct.Context), B = A && i ? { color: A, backgroundColor: i } : {};
  let y = new Bt("mixpanel", w);
  return le(() => {
    y.fireTrackingEvent("quest_refer_share_loaded", "refer_share"), rD(e, {
      apiKey: p,
      userid: r,
      entityId: C,
      apisecret: v,
      token: n,
      apiType: w
    }).then((b) => d(b.referralCode || ""));
  }, []), le(() => {
    C && u && new Bt("").getExternalLogin({ apiType: w, uniqueUserId: u, entityId: C, userId: r, apiKey: p, apiSecret: v, token: n, uniqueEmailId: l });
  }, []), o ? /* @__PURE__ */ h(
    aue,
    {
      questId: e,
      description: s,
      heading: a,
      headingColor: c,
      token: n,
      userId: r,
      bgColor: i,
      textColor: A
    }
  ) : t ? /* @__PURE__ */ h("div", { className: "q-referShare", style: B, children: /* @__PURE__ */ h("div", { className: "q-referShare-content", children: /* @__PURE__ */ k("div", { className: "q-referShare-content-text", children: [
    /* @__PURE__ */ h("div", { className: "q-referShare-content-head", style: B, children: "Invite your friends" }),
    /* @__PURE__ */ h("div", { className: "q-referShare-content-para", style: B, children: "Share your unique referral code with friends and receive 10 coins in credits each time a friend signs up!" }),
    /* @__PURE__ */ k("div", { className: "q-referShare-referralCode", children: [
      /* @__PURE__ */ h("div", { children: "Referral code" }),
      /* @__PURE__ */ k("div", { className: "q-referShare-content-rect", style: B, children: [
        /* @__PURE__ */ h("div", { style: { display: "inline", ...B }, className: "q-referShare-content-code", children: f }),
        /* @__PURE__ */ h(
          "img",
          {
            className: "q-referEarn-copy-img",
            onClick: () => {
              y.fireTrackingEvent("quest_refer_share_referral_code_copy_button_clicked", "refer_share"), navigator.clipboard.writeText(f).then(() => m(!0));
            },
            src: g ? sT : hte,
            style: { cursor: "pointer" },
            width: "16px",
            alt: "tick"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ h("div", { className: "q-referShare-content-msg", children: /* @__PURE__ */ h("div", { style: B, children: "Share with your community" }) }),
    /* @__PURE__ */ k("div", { className: "q-referShare-content-social", children: [
      /* @__PURE__ */ h(
        "img",
        {
          className: "q-referShare-content-social-img",
          onClick: () => {
            y.fireTrackingEvent("quest_refer_share_twitter_button_clicked", "refer_share"), Gi(f, "twitter");
          },
          src: uT,
          alt: "Twitter"
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q-referShare-content-social-img",
          src: Zg,
          onClick: () => {
            y.fireTrackingEvent("quest_refer_share_whatsapp_button_clicked", "refer_share"), Gi(f, "whatsapp");
          },
          alt: "Whatsapp"
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q-referShare-content-social-img",
          onClick: () => {
            y.fireTrackingEvent("quest_refer_share_telegram_button_clicked", "refer_share"), Gi(f, "telegram");
          },
          src: Kg,
          alt: "telegramPng"
        }
      )
    ] })
  ] }) }) }) : /* @__PURE__ */ h(Ze, {});
}, CFe = ({
  questId: t = "",
  userId: e = "",
  token: r = "",
  color: n = "black",
  bgColor: A = "white",
  uniqueEmailId: i,
  uniqueUserId: o
}) => {
  const [s, a] = N(""), [c, l] = N(!1), { apiKey: u, apiSecret: f, entityId: d, apiType: g } = Xe(ct.Context), [m, p] = N(!1), v = n && A ? { color: n, backgroundColor: A } : {};
  return le(() => {
    rD(t, {
      apiKey: u,
      userid: e,
      entityId: d,
      apisecret: f,
      token: r
    }).then((C) => a(C.referralCode || ""));
  }, []), le(() => {
    d && o && new Bt("").getExternalLogin({ apiType: g, uniqueUserId: o, entityId: d, userId: e, apiKey: u, apiSecret: f, token: r, uniqueEmailId: i });
  }, []), /* @__PURE__ */ k("div", { className: "q-referEarn", style: v, children: [
    /* @__PURE__ */ h(oue, { onClose: () => p(!1), isOpen: m, children: /* @__PURE__ */ k("div", { className: "q-referShare-content-social", children: [
      /* @__PURE__ */ k("div", { className: "q-referEarn-pop-div", children: [
        /* @__PURE__ */ h(
          "img",
          {
            className: "q-referShare-content-social-img",
            onClick: () => Gi(s, "twitter"),
            src: uT,
            alt: "Twitter"
          }
        ),
        "Twitter"
      ] }),
      /* @__PURE__ */ k("div", { className: "q-referEarn-pop-div", style: v, children: [
        /* @__PURE__ */ h(
          "img",
          {
            className: "q-referShare-content-social-img",
            onClick: () => Gi(s, "telegram"),
            src: Kg,
            alt: "telegramPng"
          }
        ),
        "Telegram"
      ] }),
      /* @__PURE__ */ k("div", { className: "q-referEarn-pop-div", style: v, children: [
        /* @__PURE__ */ h(
          "img",
          {
            className: "q-referShare-content-social-img",
            src: Zg,
            onClick: () => Gi(s, "whatsapp"),
            alt: "Whatsapp"
          }
        ),
        "Whatsapp"
      ] })
    ] }) }),
    /* @__PURE__ */ h("img", { src: ste, className: "q-referEarn-gift-img", alt: "giftPng" }),
    /* @__PURE__ */ h("div", { className: "q-referEarn-head", style: v, children: "Your referral code:" }),
    /* @__PURE__ */ h("div", { className: "q-referEarn-para", style: v, children: "Share your referral code with your friends and get benefits." }),
    /* @__PURE__ */ k("div", { className: "q-referEarn-rect", children: [
      /* @__PURE__ */ h("div", { style: { display: "inline" }, children: s }),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q-referEarn-copy-img",
          style: { cursor: "pointer" },
          onClick: () => {
            navigator.clipboard.writeText(s).then(() => l(!0));
          },
          src: c ? sT : pte,
          width: "20px",
          alt: "tick"
        }
      )
    ] }),
    /* @__PURE__ */ h("button", { onClick: () => p(!0), className: "q-referEarn-invite", children: "Invite Friends" })
  ] });
}, wFe = ({
  userId: t,
  token: e,
  questId: r,
  headingBgColor: n,
  headingTextColor: A,
  horizontalBorder: i,
  bodyBgColor: o,
  bodyTextColor: s,
  headingTooltip: a,
  bodyTooltip: c,
  hideQuestion: l,
  showAvatar: u,
  tableWidth: f,
  hideAnswers: d
}) => {
  const [g, m] = N([]), [p, v] = N({}), { apiKey: C, apiSecret: w, entityId: B } = Xe(ct.Context), [y, b] = N({ x: 0, y: 0 }), [q, E] = N(""), [x, M] = N(!1), [O, I] = N(!1);
  le(() => {
    I(!0);
    const H = {
      apiKey: C,
      apisecret: w,
      userId: t,
      token: e
    };
    Oe(
      `${Ve.BACKEND_URL}api/entities/${B}/quests/${r}/summary?userId=${t}`,
      { headers: H }
    ).then((F) => {
      var Q, Y, j;
      let T = (Y = (Q = F == null ? void 0 : F.data) == null ? void 0 : Q.summary) == null ? void 0 : Y.answers, U = [], D = {};
      for (let Z = 0; Z < T.length; Z++) {
        U.push(T[Z].question);
        let W = (j = T[Z]) == null ? void 0 : j.answers;
        for (let R = 0; R < (W == null ? void 0 : W.length); R++)
          if (D[W[R].userId]) {
            let K = D[W[R].userId];
            K.userAnswers[`q${Z}`] = W[R].userAnswer;
          } else
            D[W[R].userId] = {
              userName: W[R].name,
              avatar: W[R].imageUrl,
              userAnswers: {
                [`q${Z}`]: W[R].userAnswer
              }
            };
      }
      m([...U]), v({ ...D }), I(!1);
    });
  }, []);
  const S = Kn(
    (H, F) => {
      b({
        ...y,
        x: H.clientX,
        y: H.clientY
      }), E(F);
    },
    [y]
  ), P = Kn(
    (H) => {
      b({
        ...y,
        x: H.clientX,
        y: H.clientY
      }), E("");
    },
    [y]
  );
  return O == !1 ? /* @__PURE__ */ k(
    "div",
    {
      className: "q-ana-home q-tab-main",
      style: { width: f || "100%" },
      children: [
        /* @__PURE__ */ k("table", { className: "q-tab-table", children: [
          /* @__PURE__ */ h(
            "thead",
            {
              className: "q-tab-thead",
              style: {
                backgroundColor: n,
                color: A
              },
              children: /* @__PURE__ */ k("tr", { children: [
                /* @__PURE__ */ h(
                  "th",
                  {
                    scope: "col",
                    style: {
                      borderColor: o || "white",
                      padding: "0.5rem",
                      borderLeft: i ? "2px solid" : "0px",
                      borderRight: i ? "2px solid" : "0px",
                      boxSizing: "content-box"
                    },
                    children: "Users"
                  }
                ),
                g.map((H, F) => /* @__PURE__ */ h(
                  "th",
                  {
                    scope: "col",
                    className: "q-tab-thead-th",
                    style: {
                      borderColor: o || "white",
                      borderRight: i ? "2px solid" : "0px"
                    },
                    onMouseEnter: (T) => !!a && S(T, H),
                    onMouseLeave: P,
                    children: l ? `q${F + 1}` : H
                  },
                  F
                ))
              ] })
            }
          ),
          /* @__PURE__ */ h("tbody", { children: Object.keys(p).map(
            (H, F) => (x == !1 ? F < 10 : !0) && /* @__PURE__ */ k(
              "tr",
              {
                style: {
                  borderBottom: "2px solid",
                  borderColor: n || "#D1D5DB",
                  backgroundColor: o
                },
                children: [
                  /* @__PURE__ */ k(
                    "td",
                    {
                      scope: "row",
                      className: "q-tab-tbody-th",
                      style: {
                        borderColor: n || "",
                        borderLeft: i ? "2px solid" : "0px",
                        borderRight: i ? "2px solid" : "0px"
                      },
                      onMouseEnter: (T) => !!c && S(
                        T,
                        p[H].userName
                      ),
                      onMouseLeave: P,
                      children: [
                        !!u && /* @__PURE__ */ h(
                          "img",
                          {
                            src: "https://pin.questprotocol.xyz/ipfs/" + p[H].avatar,
                            className: "q-tab-tbody-img",
                            alt: ""
                          }
                        ),
                        /* @__PURE__ */ h("div", { className: "", children: p[H].userName })
                      ]
                    }
                  ),
                  g.map(
                    (T, U) => p[H].userAnswers[`q${U}`] ? /* @__PURE__ */ h(
                      "td",
                      {
                        className: "q-tab-tbody-td",
                        style: {
                          borderColor: n || "",
                          color: s,
                          borderRight: i ? `2px solid ${n || ""}` : "0px",
                          whiteSpace: d ? "nowrap" : "normal",
                          textOverflow: d ? "ellipsis" : ""
                        },
                        onMouseEnter: (D) => !!c && S(
                          D,
                          p[H].userAnswers[`q${U}`]
                        ),
                        onMouseLeave: P,
                        children: p[H].userAnswers[`q${U}`]
                      }
                    ) : /* @__PURE__ */ h(
                      "td",
                      {
                        className: "q-tab-tbody-td",
                        style: {
                          borderColor: n || "",
                          color: s,
                          borderRight: i ? `2px solid ${n || ""}` : "0px"
                        }
                      }
                    )
                  )
                ]
              }
            )
          ) })
        ] }),
        Object.keys(p).length > 10 && /* @__PURE__ */ h(
          "div",
          {
            className: "q-ana-tab-btn",
            style: {
              borderColor: n || "#D1D5DB"
            },
            onClick: () => M(!x),
            children: x ? "Hide" : "Show More"
          }
        ),
        !!q && /* @__PURE__ */ h(
          "div",
          {
            className: "q-tab-toolTip",
            style: { left: y.x, top: y.y },
            children: q
          }
        )
      ]
    }
  ) : /* @__PURE__ */ h("div", { className: "q-tab-loader-div", children: /* @__PURE__ */ h("div", { className: "q-tab-loader" }) });
};
function nD(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var A = t.length;
    for (e = 0; e < A; e++) t[e] && (r = nD(t[e])) && (n && (n += " "), n += r);
  } else for (r in t) t[r] && (n && (n += " "), n += r);
  return n;
}
function Br() {
  for (var t, e, r = 0, n = "", A = arguments.length; r < A; r++) (t = arguments[r]) && (e = nD(t)) && (n && (n += " "), n += e);
  return n;
}
var cue = Array.isArray, li = cue, lue = typeof rt == "object" && rt && rt.Object === Object && rt, AD = lue, uue = AD, due = typeof self == "object" && self && self.Object === Object && self, fue = uue || due || Function("return this")(), As = fue, hue = As, pue = hue.Symbol, M1 = pue, dE = M1, iD = Object.prototype, gue = iD.hasOwnProperty, mue = iD.toString, v0 = dE ? dE.toStringTag : void 0;
function vue(t) {
  var e = gue.call(t, v0), r = t[v0];
  try {
    t[v0] = void 0;
    var n = !0;
  } catch {
  }
  var A = mue.call(t);
  return n && (e ? t[v0] = r : delete t[v0]), A;
}
var que = vue, yue = Object.prototype, Cue = yue.toString;
function wue(t) {
  return Cue.call(t);
}
var bue = wue, fE = M1, Bue = que, Eue = bue, xue = "[object Null]", Iue = "[object Undefined]", hE = fE ? fE.toStringTag : void 0;
function Sue(t) {
  return t == null ? t === void 0 ? Iue : xue : hE && hE in Object(t) ? Bue(t) : Eue(t);
}
var zs = Sue;
function Pue(t) {
  return t != null && typeof t == "object";
}
var Ys = Pue, kue = zs, Oue = Ys, Fue = "[object Symbol]";
function Tue(t) {
  return typeof t == "symbol" || Oue(t) && kue(t) == Fue;
}
var Hd = Tue, Mue = li, Hue = Hd, Due = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Que = /^\w*$/;
function Uue(t, e) {
  if (Mue(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || Hue(t) ? !0 : Que.test(t) || !Due.test(t) || e != null && t in Object(e);
}
var Aq = Uue;
function Nue(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var ec = Nue;
const Dd = /* @__PURE__ */ Vr(ec);
var jue = zs, Lue = ec, Gue = "[object AsyncFunction]", Rue = "[object Function]", zue = "[object GeneratorFunction]", Yue = "[object Proxy]";
function Vue(t) {
  if (!Lue(t))
    return !1;
  var e = jue(t);
  return e == Rue || e == zue || e == Gue || e == Yue;
}
var iq = Vue;
const nr = /* @__PURE__ */ Vr(iq);
var Wue = As, Xue = Wue["__core-js_shared__"], Kue = Xue, v6 = Kue, pE = function() {
  var t = /[^.]+$/.exec(v6 && v6.keys && v6.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Zue(t) {
  return !!pE && pE in t;
}
var Jue = Zue, _ue = Function.prototype, $ue = _ue.toString;
function ede(t) {
  if (t != null) {
    try {
      return $ue.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var oD = ede, tde = iq, rde = Jue, nde = ec, Ade = oD, ide = /[\\^$.*+?()[\]{}|]/g, ode = /^\[object .+?Constructor\]$/, sde = Function.prototype, ade = Object.prototype, cde = sde.toString, lde = ade.hasOwnProperty, ude = RegExp(
  "^" + cde.call(lde).replace(ide, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function dde(t) {
  if (!nde(t) || rde(t))
    return !1;
  var e = tde(t) ? ude : ode;
  return e.test(Ade(t));
}
var fde = dde;
function hde(t, e) {
  return t == null ? void 0 : t[e];
}
var pde = hde, gde = fde, mde = pde;
function vde(t, e) {
  var r = mde(t, e);
  return gde(r) ? r : void 0;
}
var dl = vde, qde = dl, yde = qde(Object, "create"), E4 = yde, gE = E4;
function Cde() {
  this.__data__ = gE ? gE(null) : {}, this.size = 0;
}
var wde = Cde;
function bde(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Bde = bde, Ede = E4, xde = "__lodash_hash_undefined__", Ide = Object.prototype, Sde = Ide.hasOwnProperty;
function Pde(t) {
  var e = this.__data__;
  if (Ede) {
    var r = e[t];
    return r === xde ? void 0 : r;
  }
  return Sde.call(e, t) ? e[t] : void 0;
}
var kde = Pde, Ode = E4, Fde = Object.prototype, Tde = Fde.hasOwnProperty;
function Mde(t) {
  var e = this.__data__;
  return Ode ? e[t] !== void 0 : Tde.call(e, t);
}
var Hde = Mde, Dde = E4, Qde = "__lodash_hash_undefined__";
function Ude(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = Dde && e === void 0 ? Qde : e, this;
}
var Nde = Ude, jde = wde, Lde = Bde, Gde = kde, Rde = Hde, zde = Nde;
function Qd(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Qd.prototype.clear = jde;
Qd.prototype.delete = Lde;
Qd.prototype.get = Gde;
Qd.prototype.has = Rde;
Qd.prototype.set = zde;
var Yde = Qd;
function Vde() {
  this.__data__ = [], this.size = 0;
}
var Wde = Vde;
function Xde(t, e) {
  return t === e || t !== t && e !== e;
}
var oq = Xde, Kde = oq;
function Zde(t, e) {
  for (var r = t.length; r--; )
    if (Kde(t[r][0], e))
      return r;
  return -1;
}
var x4 = Zde, Jde = x4, _de = Array.prototype, $de = _de.splice;
function e0e(t) {
  var e = this.__data__, r = Jde(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : $de.call(e, r, 1), --this.size, !0;
}
var t0e = e0e, r0e = x4;
function n0e(t) {
  var e = this.__data__, r = r0e(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var A0e = n0e, i0e = x4;
function o0e(t) {
  return i0e(this.__data__, t) > -1;
}
var s0e = o0e, a0e = x4;
function c0e(t, e) {
  var r = this.__data__, n = a0e(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
var l0e = c0e, u0e = Wde, d0e = t0e, f0e = A0e, h0e = s0e, p0e = l0e;
function Ud(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Ud.prototype.clear = u0e;
Ud.prototype.delete = d0e;
Ud.prototype.get = f0e;
Ud.prototype.has = h0e;
Ud.prototype.set = p0e;
var I4 = Ud, g0e = dl, m0e = As, v0e = g0e(m0e, "Map"), sq = v0e, mE = Yde, q0e = I4, y0e = sq;
function C0e() {
  this.size = 0, this.__data__ = {
    hash: new mE(),
    map: new (y0e || q0e)(),
    string: new mE()
  };
}
var w0e = C0e;
function b0e(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var B0e = b0e, E0e = B0e;
function x0e(t, e) {
  var r = t.__data__;
  return E0e(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var S4 = x0e, I0e = S4;
function S0e(t) {
  var e = I0e(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var P0e = S0e, k0e = S4;
function O0e(t) {
  return k0e(this, t).get(t);
}
var F0e = O0e, T0e = S4;
function M0e(t) {
  return T0e(this, t).has(t);
}
var H0e = M0e, D0e = S4;
function Q0e(t, e) {
  var r = D0e(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
var U0e = Q0e, N0e = w0e, j0e = P0e, L0e = F0e, G0e = H0e, R0e = U0e;
function Nd(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Nd.prototype.clear = N0e;
Nd.prototype.delete = j0e;
Nd.prototype.get = L0e;
Nd.prototype.has = G0e;
Nd.prototype.set = R0e;
var aq = Nd, sD = aq, z0e = "Expected a function";
function cq(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(z0e);
  var r = function() {
    var n = arguments, A = e ? e.apply(this, n) : n[0], i = r.cache;
    if (i.has(A))
      return i.get(A);
    var o = t.apply(this, n);
    return r.cache = i.set(A, o) || i, o;
  };
  return r.cache = new (cq.Cache || sD)(), r;
}
cq.Cache = sD;
var aD = cq;
const Y0e = /* @__PURE__ */ Vr(aD);
var V0e = aD, W0e = 500;
function X0e(t) {
  var e = V0e(t, function(n) {
    return r.size === W0e && r.clear(), n;
  }), r = e.cache;
  return e;
}
var K0e = X0e, Z0e = K0e, J0e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, _0e = /\\(\\)?/g, $0e = Z0e(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(J0e, function(r, n, A, i) {
    e.push(A ? i.replace(_0e, "$1") : n || r);
  }), e;
}), e2e = $0e;
function t2e(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, A = Array(n); ++r < n; )
    A[r] = e(t[r], r, t);
  return A;
}
var lq = t2e, vE = M1, r2e = lq, n2e = li, A2e = Hd, qE = vE ? vE.prototype : void 0, yE = qE ? qE.toString : void 0;
function cD(t) {
  if (typeof t == "string")
    return t;
  if (n2e(t))
    return r2e(t, cD) + "";
  if (A2e(t))
    return yE ? yE.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var i2e = cD, o2e = i2e;
function s2e(t) {
  return t == null ? "" : o2e(t);
}
var lD = s2e, a2e = li, c2e = Aq, l2e = e2e, u2e = lD;
function d2e(t, e) {
  return a2e(t) ? t : c2e(t, e) ? [t] : l2e(u2e(t));
}
var uD = d2e, f2e = Hd;
function h2e(t) {
  if (typeof t == "string" || f2e(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var P4 = h2e, p2e = uD, g2e = P4;
function m2e(t, e) {
  e = p2e(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[g2e(e[r++])];
  return r && r == n ? t : void 0;
}
var uq = m2e, v2e = uq;
function q2e(t, e, r) {
  var n = t == null ? void 0 : v2e(t, e);
  return n === void 0 ? r : n;
}
var dD = q2e;
const Ri = /* @__PURE__ */ Vr(dD);
function y2e(t) {
  return t == null;
}
var C2e = y2e;
const hr = /* @__PURE__ */ Vr(C2e);
var w2e = zs, b2e = li, B2e = Ys, E2e = "[object String]";
function x2e(t) {
  return typeof t == "string" || !b2e(t) && B2e(t) && w2e(t) == E2e;
}
var I2e = x2e;
const H1 = /* @__PURE__ */ Vr(I2e);
var F7 = { exports: {} }, Dr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CE;
function S2e() {
  if (CE) return Dr;
  CE = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), A = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), a = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function m(p) {
    if (typeof p == "object" && p !== null) {
      var v = p.$$typeof;
      switch (v) {
        case t:
          switch (p = p.type, p) {
            case r:
            case A:
            case n:
            case c:
            case l:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case o:
                case a:
                case f:
                case u:
                case i:
                  return p;
                default:
                  return v;
              }
          }
        case e:
          return v;
      }
    }
  }
  return Dr.ContextConsumer = o, Dr.ContextProvider = i, Dr.Element = t, Dr.ForwardRef = a, Dr.Fragment = r, Dr.Lazy = f, Dr.Memo = u, Dr.Portal = e, Dr.Profiler = A, Dr.StrictMode = n, Dr.Suspense = c, Dr.SuspenseList = l, Dr.isAsyncMode = function() {
    return !1;
  }, Dr.isConcurrentMode = function() {
    return !1;
  }, Dr.isContextConsumer = function(p) {
    return m(p) === o;
  }, Dr.isContextProvider = function(p) {
    return m(p) === i;
  }, Dr.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, Dr.isForwardRef = function(p) {
    return m(p) === a;
  }, Dr.isFragment = function(p) {
    return m(p) === r;
  }, Dr.isLazy = function(p) {
    return m(p) === f;
  }, Dr.isMemo = function(p) {
    return m(p) === u;
  }, Dr.isPortal = function(p) {
    return m(p) === e;
  }, Dr.isProfiler = function(p) {
    return m(p) === A;
  }, Dr.isStrictMode = function(p) {
    return m(p) === n;
  }, Dr.isSuspense = function(p) {
    return m(p) === c;
  }, Dr.isSuspenseList = function(p) {
    return m(p) === l;
  }, Dr.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === A || p === n || p === c || p === l || p === d || typeof p == "object" && p !== null && (p.$$typeof === f || p.$$typeof === u || p.$$typeof === i || p.$$typeof === o || p.$$typeof === a || p.$$typeof === g || p.getModuleId !== void 0);
  }, Dr.typeOf = m, Dr;
}
var Qr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wE;
function P2e() {
  return wE || (wE = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), A = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), a = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g = !1, m = !1, p = !1, v = !1, C = !1, w;
    w = Symbol.for("react.module.reference");
    function B(ee) {
      return !!(typeof ee == "string" || typeof ee == "function" || ee === r || ee === A || C || ee === n || ee === c || ee === l || v || ee === d || g || m || p || typeof ee == "object" && ee !== null && (ee.$$typeof === f || ee.$$typeof === u || ee.$$typeof === i || ee.$$typeof === o || ee.$$typeof === a || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ee.$$typeof === w || ee.getModuleId !== void 0));
    }
    function y(ee) {
      if (typeof ee == "object" && ee !== null) {
        var $ = ee.$$typeof;
        switch ($) {
          case t:
            var te = ee.type;
            switch (te) {
              case r:
              case A:
              case n:
              case c:
              case l:
                return te;
              default:
                var ae = te && te.$$typeof;
                switch (ae) {
                  case s:
                  case o:
                  case a:
                  case f:
                  case u:
                  case i:
                    return ae;
                  default:
                    return $;
                }
            }
          case e:
            return $;
        }
      }
    }
    var b = o, q = i, E = t, x = a, M = r, O = f, I = u, S = e, P = A, H = n, F = c, T = l, U = !1, D = !1;
    function Q(ee) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(ee) {
      return D || (D = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(ee) {
      return y(ee) === o;
    }
    function Z(ee) {
      return y(ee) === i;
    }
    function W(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === t;
    }
    function R(ee) {
      return y(ee) === a;
    }
    function K(ee) {
      return y(ee) === r;
    }
    function L(ee) {
      return y(ee) === f;
    }
    function G(ee) {
      return y(ee) === u;
    }
    function V(ee) {
      return y(ee) === e;
    }
    function _(ee) {
      return y(ee) === A;
    }
    function J(ee) {
      return y(ee) === n;
    }
    function X(ee) {
      return y(ee) === c;
    }
    function ne(ee) {
      return y(ee) === l;
    }
    Qr.ContextConsumer = b, Qr.ContextProvider = q, Qr.Element = E, Qr.ForwardRef = x, Qr.Fragment = M, Qr.Lazy = O, Qr.Memo = I, Qr.Portal = S, Qr.Profiler = P, Qr.StrictMode = H, Qr.Suspense = F, Qr.SuspenseList = T, Qr.isAsyncMode = Q, Qr.isConcurrentMode = Y, Qr.isContextConsumer = j, Qr.isContextProvider = Z, Qr.isElement = W, Qr.isForwardRef = R, Qr.isFragment = K, Qr.isLazy = L, Qr.isMemo = G, Qr.isPortal = V, Qr.isProfiler = _, Qr.isStrictMode = J, Qr.isSuspense = X, Qr.isSuspenseList = ne, Qr.isValidElementType = B, Qr.typeOf = y;
  }()), Qr;
}
process.env.NODE_ENV === "production" ? F7.exports = S2e() : F7.exports = P2e();
var k2e = F7.exports, O2e = zs, F2e = Ys, T2e = "[object Number]";
function M2e(t) {
  return typeof t == "number" || F2e(t) && O2e(t) == T2e;
}
var fD = M2e;
const H2e = /* @__PURE__ */ Vr(fD);
var D2e = fD;
function Q2e(t) {
  return D2e(t) && t != +t;
}
var U2e = Q2e;
const jd = /* @__PURE__ */ Vr(U2e);
var uo = function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}, Bc = function(e) {
  return H1(e) && e.indexOf("%") === e.length - 1;
}, At = function(e) {
  return H2e(e) && !jd(e);
}, $n = function(e) {
  return At(e) || H1(e);
}, N2e = 0, Ld = function(e) {
  var r = ++N2e;
  return "".concat(e || "").concat(r);
}, nl = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!At(e) && !H1(e))
    return n;
  var i;
  if (Bc(e)) {
    var o = e.indexOf("%");
    i = r * parseFloat(e.slice(0, o)) / 100;
  } else
    i = +e;
  return jd(i) && (i = n), A && i > r && (i = r), i;
}, ga = function(e) {
  if (!e)
    return null;
  var r = Object.keys(e);
  return r && r.length ? e[r[0]] : null;
}, j2e = function(e) {
  if (!Array.isArray(e))
    return !1;
  for (var r = e.length, n = {}, A = 0; A < r; A++)
    if (!n[e[A]])
      n[e[A]] = !0;
    else
      return !0;
  return !1;
}, yA = function(e, r) {
  return At(e) && At(r) ? function(n) {
    return e + n * (r - e);
  } : function() {
    return r;
  };
};
function R3(t, e, r) {
  return !t || !t.length ? null : t.find(function(n) {
    return n && (typeof e == "function" ? e(n) : Ri(n, e)) === r;
  });
}
function au(t, e) {
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && (!{}.hasOwnProperty.call(e, r) || t[r] !== e[r]))
      return !1;
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && !{}.hasOwnProperty.call(t, n))
      return !1;
  return !0;
}
function T7(t) {
  "@babel/helpers - typeof";
  return T7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, T7(t);
}
var L2e = ["viewBox", "children"], G2e = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], bE = ["points", "pathLength"], q6 = {
  svg: L2e,
  polygon: bE,
  polyline: bE
}, dq = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], z3 = function(e, r) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var n = e;
  if (/* @__PURE__ */ QA(e) && (n = e.props), !Dd(n))
    return null;
  var A = {};
  return Object.keys(n).forEach(function(i) {
    dq.includes(i) && (A[i] = r || function(o) {
      return n[i](n, o);
    });
  }), A;
}, R2e = function(e, r, n) {
  return function(A) {
    return e(r, n, A), null;
  };
}, Y3 = function(e, r, n) {
  if (!Dd(e) || T7(e) !== "object")
    return null;
  var A = null;
  return Object.keys(e).forEach(function(i) {
    var o = e[i];
    dq.includes(i) && typeof o == "function" && (A || (A = {}), A[i] = R2e(o, r, n));
  }), A;
}, z2e = ["children"], Y2e = ["children"];
function BE(t, e) {
  if (t == null) return {};
  var r = V2e(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function V2e(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function M7(t) {
  "@babel/helpers - typeof";
  return M7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, M7(t);
}
var EE = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Bs = function(e) {
  return typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "";
}, xE = null, y6 = null, fq = function t(e) {
  if (e === xE && Array.isArray(y6))
    return y6;
  var r = [];
  return xa.forEach(e, function(n) {
    hr(n) || (k2e.isFragment(n) ? r = r.concat(t(n.props.children)) : r.push(n));
  }), y6 = r, xE = e, r;
};
function zi(t, e) {
  var r = [], n = [];
  return Array.isArray(e) ? n = e.map(function(A) {
    return Bs(A);
  }) : n = [Bs(e)], fq(t).forEach(function(A) {
    var i = Ri(A, "type.displayName") || Ri(A, "type.name");
    n.indexOf(i) !== -1 && r.push(A);
  }), r;
}
function mi(t, e) {
  var r = zi(t, e);
  return r[0];
}
var IE = function(e) {
  if (!e || !e.props)
    return !1;
  var r = e.props, n = r.width, A = r.height;
  return !(!At(n) || n <= 0 || !At(A) || A <= 0);
}, W2e = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], X2e = function(e) {
  return e && e.type && H1(e.type) && W2e.indexOf(e.type) >= 0;
}, hD = function(e) {
  return e && M7(e) === "object" && "clipDot" in e;
}, K2e = function(e, r, n, A) {
  var i, o = (i = q6 == null ? void 0 : q6[A]) !== null && i !== void 0 ? i : [];
  return !nr(e) && (A && o.includes(r) || G2e.includes(r)) || n && dq.includes(r);
}, cr = function(e, r, n) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var A = e;
  if (/* @__PURE__ */ QA(e) && (A = e.props), !Dd(A))
    return null;
  var i = {};
  return Object.keys(A).forEach(function(o) {
    var s;
    K2e((s = A) === null || s === void 0 ? void 0 : s[o], o, r, n) && (i[o] = A[o]);
  }), i;
}, H7 = function t(e, r) {
  if (e === r)
    return !0;
  var n = xa.count(e);
  if (n !== xa.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return SE(Array.isArray(e) ? e[0] : e, Array.isArray(r) ? r[0] : r);
  for (var A = 0; A < n; A++) {
    var i = e[A], o = r[A];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!t(i, o))
        return !1;
    } else if (!SE(i, o))
      return !1;
  }
  return !0;
}, SE = function(e, r) {
  if (hr(e) && hr(r))
    return !0;
  if (!hr(e) && !hr(r)) {
    var n = e.props || {}, A = n.children, i = BE(n, z2e), o = r.props || {}, s = o.children, a = BE(o, Y2e);
    return A && s ? au(i, a) && H7(A, s) : !A && !s ? au(i, a) : !1;
  }
  return !1;
}, PE = function(e, r) {
  var n = [], A = {};
  return fq(e).forEach(function(i, o) {
    if (X2e(i))
      n.push(i);
    else if (i) {
      var s = Bs(i.type), a = r[s] || {}, c = a.handler, l = a.once;
      if (c && (!l || !A[s])) {
        var u = c(i, s, o);
        n.push(u), A[s] = !0;
      }
    }
  }), n;
}, Z2e = function(e) {
  var r = e && e.type;
  return r && EE[r] ? EE[r] : null;
}, J2e = function(e, r) {
  return fq(r).indexOf(e);
}, _2e = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function D7() {
  return D7 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, D7.apply(this, arguments);
}
function $2e(t, e) {
  if (t == null) return {};
  var r = e1e(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function e1e(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Q7(t) {
  var e = t.children, r = t.width, n = t.height, A = t.viewBox, i = t.className, o = t.style, s = t.title, a = t.desc, c = $2e(t, _2e), l = A || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, u = Br("recharts-surface", i);
  return /* @__PURE__ */ re.createElement("svg", D7({}, cr(c, !0, "svg"), {
    className: u,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(l.x, " ").concat(l.y, " ").concat(l.width, " ").concat(l.height)
  }), /* @__PURE__ */ re.createElement("title", null, s), /* @__PURE__ */ re.createElement("desc", null, a), e);
}
var t1e = ["children", "className"];
function U7() {
  return U7 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, U7.apply(this, arguments);
}
function r1e(t, e) {
  if (t == null) return {};
  var r = n1e(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function n1e(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var _r = /* @__PURE__ */ re.forwardRef(function(t, e) {
  var r = t.children, n = t.className, A = r1e(t, t1e), i = Br("recharts-layer", n);
  return /* @__PURE__ */ re.createElement("g", U7({
    className: i
  }, cr(A, !0), {
    ref: e
  }), r);
}), A1e = process.env.NODE_ENV !== "production", Es = function(e, r) {
  for (var n = arguments.length, A = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    A[i - 2] = arguments[i];
  if (A1e && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return A[o++];
      }));
    }
};
function i1e(t, e, r) {
  var n = -1, A = t.length;
  e < 0 && (e = -e > A ? 0 : A + e), r = r > A ? A : r, r < 0 && (r += A), A = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var i = Array(A); ++n < A; )
    i[n] = t[n + e];
  return i;
}
var o1e = i1e, s1e = o1e;
function a1e(t, e, r) {
  var n = t.length;
  return r = r === void 0 ? n : r, !e && r >= n ? t : s1e(t, e, r);
}
var c1e = a1e, l1e = "\\ud800-\\udfff", u1e = "\\u0300-\\u036f", d1e = "\\ufe20-\\ufe2f", f1e = "\\u20d0-\\u20ff", h1e = u1e + d1e + f1e, p1e = "\\ufe0e\\ufe0f", g1e = "\\u200d", m1e = RegExp("[" + g1e + l1e + h1e + p1e + "]");
function v1e(t) {
  return m1e.test(t);
}
var pD = v1e;
function q1e(t) {
  return t.split("");
}
var y1e = q1e, gD = "\\ud800-\\udfff", C1e = "\\u0300-\\u036f", w1e = "\\ufe20-\\ufe2f", b1e = "\\u20d0-\\u20ff", B1e = C1e + w1e + b1e, E1e = "\\ufe0e\\ufe0f", x1e = "[" + gD + "]", N7 = "[" + B1e + "]", j7 = "\\ud83c[\\udffb-\\udfff]", I1e = "(?:" + N7 + "|" + j7 + ")", mD = "[^" + gD + "]", vD = "(?:\\ud83c[\\udde6-\\uddff]){2}", qD = "[\\ud800-\\udbff][\\udc00-\\udfff]", S1e = "\\u200d", yD = I1e + "?", CD = "[" + E1e + "]?", P1e = "(?:" + S1e + "(?:" + [mD, vD, qD].join("|") + ")" + CD + yD + ")*", k1e = CD + yD + P1e, O1e = "(?:" + [mD + N7 + "?", N7, vD, qD, x1e].join("|") + ")", F1e = RegExp(j7 + "(?=" + j7 + ")|" + O1e + k1e, "g");
function T1e(t) {
  return t.match(F1e) || [];
}
var M1e = T1e, H1e = y1e, D1e = pD, Q1e = M1e;
function U1e(t) {
  return D1e(t) ? Q1e(t) : H1e(t);
}
var N1e = U1e, j1e = c1e, L1e = pD, G1e = N1e, R1e = lD;
function z1e(t) {
  return function(e) {
    e = R1e(e);
    var r = L1e(e) ? G1e(e) : void 0, n = r ? r[0] : e.charAt(0), A = r ? j1e(r, 1).join("") : e.slice(1);
    return n[t]() + A;
  };
}
var Y1e = z1e, V1e = Y1e, W1e = V1e("toUpperCase"), X1e = W1e;
const k4 = /* @__PURE__ */ Vr(X1e);
function Zr(t) {
  return function() {
    return t;
  };
}
const wD = Math.cos, V3 = Math.sin, Co = Math.sqrt, W3 = Math.PI, O4 = 2 * W3, L7 = Math.PI, G7 = 2 * L7, pc = 1e-6, K1e = G7 - pc;
function bD(t) {
  this._ += t[0];
  for (let e = 1, r = t.length; e < r; ++e)
    this._ += arguments[e] + t[e];
}
function Z1e(t) {
  let e = Math.floor(t);
  if (!(e >= 0)) throw new Error(`invalid digits: ${t}`);
  if (e > 15) return bD;
  const r = 10 ** e;
  return function(n) {
    this._ += n[0];
    for (let A = 1, i = n.length; A < i; ++A)
      this._ += Math.round(arguments[A] * r) / r + n[A];
  };
}
class J1e {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? bD : Z1e(e);
  }
  moveTo(e, r) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, r) {
    this._append`L${this._x1 = +e},${this._y1 = +r}`;
  }
  quadraticCurveTo(e, r, n, A) {
    this._append`Q${+e},${+r},${this._x1 = +n},${this._y1 = +A}`;
  }
  bezierCurveTo(e, r, n, A, i, o) {
    this._append`C${+e},${+r},${+n},${+A},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(e, r, n, A, i) {
    if (e = +e, r = +r, n = +n, A = +A, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let o = this._x1, s = this._y1, a = n - e, c = A - r, l = o - e, u = s - r, f = l * l + u * u;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = r}`;
    else if (f > pc) if (!(Math.abs(u * a - c * l) > pc) || !i)
      this._append`L${this._x1 = e},${this._y1 = r}`;
    else {
      let d = n - o, g = A - s, m = a * a + c * c, p = d * d + g * g, v = Math.sqrt(m), C = Math.sqrt(f), w = i * Math.tan((L7 - Math.acos((m + f - p) / (2 * v * C))) / 2), B = w / C, y = w / v;
      Math.abs(B - 1) > pc && this._append`L${e + B * l},${r + B * u}`, this._append`A${i},${i},0,0,${+(u * d > l * g)},${this._x1 = e + y * a},${this._y1 = r + y * c}`;
    }
  }
  arc(e, r, n, A, i, o) {
    if (e = +e, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(A), a = n * Math.sin(A), c = e + s, l = r + a, u = 1 ^ o, f = o ? A - i : i - A;
    this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > pc || Math.abs(this._y1 - l) > pc) && this._append`L${c},${l}`, n && (f < 0 && (f = f % G7 + G7), f > K1e ? this._append`A${n},${n},0,1,${u},${e - s},${r - a}A${n},${n},0,1,${u},${this._x1 = c},${this._y1 = l}` : f > pc && this._append`A${n},${n},0,${+(f >= L7)},${u},${this._x1 = e + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(e, r, n, A) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}h${n = +n}v${+A}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function hq(t) {
  let e = 3;
  return t.digits = function(r) {
    if (!arguments.length) return e;
    if (r == null)
      e = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      e = n;
    }
    return t;
  }, () => new J1e(e);
}
function pq(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function BD(t) {
  this._context = t;
}
BD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function F4(t) {
  return new BD(t);
}
function ED(t) {
  return t[0];
}
function xD(t) {
  return t[1];
}
function ID(t, e) {
  var r = Zr(!0), n = null, A = F4, i = null, o = hq(s);
  t = typeof t == "function" ? t : t === void 0 ? ED : Zr(t), e = typeof e == "function" ? e : e === void 0 ? xD : Zr(e);
  function s(a) {
    var c, l = (a = pq(a)).length, u, f = !1, d;
    for (n == null && (i = A(d = o())), c = 0; c <= l; ++c)
      !(c < l && r(u = a[c], c, a)) === f && ((f = !f) ? i.lineStart() : i.lineEnd()), f && i.point(+t(u, c, a), +e(u, c, a));
    if (d) return i = null, d + "" || null;
  }
  return s.x = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Zr(+a), s) : t;
  }, s.y = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Zr(+a), s) : e;
  }, s.defined = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Zr(!!a), s) : r;
  }, s.curve = function(a) {
    return arguments.length ? (A = a, n != null && (i = A(n)), s) : A;
  }, s.context = function(a) {
    return arguments.length ? (a == null ? n = i = null : i = A(n = a), s) : n;
  }, s;
}
function zf(t, e, r) {
  var n = null, A = Zr(!0), i = null, o = F4, s = null, a = hq(c);
  t = typeof t == "function" ? t : t === void 0 ? ED : Zr(+t), e = typeof e == "function" ? e : Zr(e === void 0 ? 0 : +e), r = typeof r == "function" ? r : r === void 0 ? xD : Zr(+r);
  function c(u) {
    var f, d, g, m = (u = pq(u)).length, p, v = !1, C, w = new Array(m), B = new Array(m);
    for (i == null && (s = o(C = a())), f = 0; f <= m; ++f) {
      if (!(f < m && A(p = u[f], f, u)) === v)
        if (v = !v)
          d = f, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = f - 1; g >= d; --g)
            s.point(w[g], B[g]);
          s.lineEnd(), s.areaEnd();
        }
      v && (w[f] = +t(p, f, u), B[f] = +e(p, f, u), s.point(n ? +n(p, f, u) : w[f], r ? +r(p, f, u) : B[f]));
    }
    if (C) return s = null, C + "" || null;
  }
  function l() {
    return ID().defined(A).curve(o).context(i);
  }
  return c.x = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Zr(+u), n = null, c) : t;
  }, c.x0 = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Zr(+u), c) : t;
  }, c.x1 = function(u) {
    return arguments.length ? (n = u == null ? null : typeof u == "function" ? u : Zr(+u), c) : n;
  }, c.y = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Zr(+u), r = null, c) : e;
  }, c.y0 = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Zr(+u), c) : e;
  }, c.y1 = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : Zr(+u), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(t).y(e);
  }, c.lineY1 = function() {
    return l().x(t).y(r);
  }, c.lineX1 = function() {
    return l().x(n).y(e);
  }, c.defined = function(u) {
    return arguments.length ? (A = typeof u == "function" ? u : Zr(!!u), c) : A;
  }, c.curve = function(u) {
    return arguments.length ? (o = u, i != null && (s = o(i)), c) : o;
  }, c.context = function(u) {
    return arguments.length ? (u == null ? i = s = null : s = o(i = u), c) : i;
  }, c;
}
class SD {
  constructor(e, r) {
    this._context = e, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, r, e, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, e, this._y0, e, r);
        break;
      }
    }
    this._x0 = e, this._y0 = r;
  }
}
function _1e(t) {
  return new SD(t, !0);
}
function $1e(t) {
  return new SD(t, !1);
}
const gq = {
  draw(t, e) {
    const r = Co(e / W3);
    t.moveTo(r, 0), t.arc(0, 0, r, 0, O4);
  }
}, efe = {
  draw(t, e) {
    const r = Co(e / 5) / 2;
    t.moveTo(-3 * r, -r), t.lineTo(-r, -r), t.lineTo(-r, -3 * r), t.lineTo(r, -3 * r), t.lineTo(r, -r), t.lineTo(3 * r, -r), t.lineTo(3 * r, r), t.lineTo(r, r), t.lineTo(r, 3 * r), t.lineTo(-r, 3 * r), t.lineTo(-r, r), t.lineTo(-3 * r, r), t.closePath();
  }
}, PD = Co(1 / 3), tfe = PD * 2, rfe = {
  draw(t, e) {
    const r = Co(e / tfe), n = r * PD;
    t.moveTo(0, -r), t.lineTo(n, 0), t.lineTo(0, r), t.lineTo(-n, 0), t.closePath();
  }
}, nfe = {
  draw(t, e) {
    const r = Co(e), n = -r / 2;
    t.rect(n, n, r, r);
  }
}, Afe = 0.8908130915292852, kD = V3(W3 / 10) / V3(7 * W3 / 10), ife = V3(O4 / 10) * kD, ofe = -wD(O4 / 10) * kD, sfe = {
  draw(t, e) {
    const r = Co(e * Afe), n = ife * r, A = ofe * r;
    t.moveTo(0, -r), t.lineTo(n, A);
    for (let i = 1; i < 5; ++i) {
      const o = O4 * i / 5, s = wD(o), a = V3(o);
      t.lineTo(a * r, -s * r), t.lineTo(s * n - a * A, a * n + s * A);
    }
    t.closePath();
  }
}, C6 = Co(3), afe = {
  draw(t, e) {
    const r = -Co(e / (C6 * 3));
    t.moveTo(0, r * 2), t.lineTo(-C6 * r, -r), t.lineTo(C6 * r, -r), t.closePath();
  }
}, Si = -0.5, Pi = Co(3) / 2, R7 = 1 / Co(12), cfe = (R7 / 2 + 1) * 3, lfe = {
  draw(t, e) {
    const r = Co(e / cfe), n = r / 2, A = r * R7, i = n, o = r * R7 + r, s = -i, a = o;
    t.moveTo(n, A), t.lineTo(i, o), t.lineTo(s, a), t.lineTo(Si * n - Pi * A, Pi * n + Si * A), t.lineTo(Si * i - Pi * o, Pi * i + Si * o), t.lineTo(Si * s - Pi * a, Pi * s + Si * a), t.lineTo(Si * n + Pi * A, Si * A - Pi * n), t.lineTo(Si * i + Pi * o, Si * o - Pi * i), t.lineTo(Si * s + Pi * a, Si * a - Pi * s), t.closePath();
  }
};
function ufe(t, e) {
  let r = null, n = hq(A);
  t = typeof t == "function" ? t : Zr(t || gq), e = typeof e == "function" ? e : Zr(e === void 0 ? 64 : +e);
  function A() {
    let i;
    if (r || (r = i = n()), t.apply(this, arguments).draw(r, +e.apply(this, arguments)), i) return r = null, i + "" || null;
  }
  return A.type = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Zr(i), A) : t;
  }, A.size = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Zr(+i), A) : e;
  }, A.context = function(i) {
    return arguments.length ? (r = i ?? null, A) : r;
  }, A;
}
function X3() {
}
function K3(t, e, r) {
  t._context.bezierCurveTo(
    (2 * t._x0 + t._x1) / 3,
    (2 * t._y0 + t._y1) / 3,
    (t._x0 + 2 * t._x1) / 3,
    (t._y0 + 2 * t._y1) / 3,
    (t._x0 + 4 * t._x1 + e) / 6,
    (t._y0 + 4 * t._y1 + r) / 6
  );
}
function OD(t) {
  this._context = t;
}
OD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        K3(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        K3(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function dfe(t) {
  return new OD(t);
}
function FD(t) {
  this._context = t;
}
FD.prototype = {
  areaStart: X3,
  areaEnd: X3,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        K3(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function ffe(t) {
  return new FD(t);
}
function TD(t) {
  this._context = t;
}
TD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + t) / 6, n = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        K3(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function hfe(t) {
  return new TD(t);
}
function MD(t) {
  this._context = t;
}
MD.prototype = {
  areaStart: X3,
  areaEnd: X3,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function pfe(t) {
  return new MD(t);
}
function kE(t) {
  return t < 0 ? -1 : 1;
}
function OE(t, e, r) {
  var n = t._x1 - t._x0, A = e - t._x1, i = (t._y1 - t._y0) / (n || A < 0 && -0), o = (r - t._y1) / (A || n < 0 && -0), s = (i * A + o * n) / (n + A);
  return (kE(i) + kE(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function FE(t, e) {
  var r = t._x1 - t._x0;
  return r ? (3 * (t._y1 - t._y0) / r - e) / 2 : e;
}
function w6(t, e, r) {
  var n = t._x0, A = t._y0, i = t._x1, o = t._y1, s = (i - n) / 3;
  t._context.bezierCurveTo(n + s, A + s * e, i - s, o - s * r, i, o);
}
function Z3(t) {
  this._context = t;
}
Z3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        w6(this, this._t0, FE(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    var r = NaN;
    if (t = +t, e = +e, !(t === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, w6(this, FE(this, r = OE(this, t, e)), r);
          break;
        default:
          w6(this, this._t0, r = OE(this, t, e));
          break;
      }
      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = r;
    }
  }
};
function HD(t) {
  this._context = new DD(t);
}
(HD.prototype = Object.create(Z3.prototype)).point = function(t, e) {
  Z3.prototype.point.call(this, e, t);
};
function DD(t) {
  this._context = t;
}
DD.prototype = {
  moveTo: function(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function(t, e, r, n, A, i) {
    this._context.bezierCurveTo(e, t, n, r, i, A);
  }
};
function gfe(t) {
  return new Z3(t);
}
function mfe(t) {
  return new HD(t);
}
function QD(t) {
  this._context = t;
}
QD.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var t = this._x, e = this._y, r = t.length;
    if (r)
      if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), r === 2)
        this._context.lineTo(t[1], e[1]);
      else
        for (var n = TE(t), A = TE(e), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], A[0][i], n[1][i], A[1][i], t[o], e[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
function TE(t) {
  var e, r = t.length - 1, n, A = new Array(r), i = new Array(r), o = new Array(r);
  for (A[0] = 0, i[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) A[e] = 1, i[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
  for (A[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) n = A[e] / i[e - 1], i[e] -= n, o[e] -= n * o[e - 1];
  for (A[r - 1] = o[r - 1] / i[r - 1], e = r - 2; e >= 0; --e) A[e] = (o[e] - A[e + 1]) / i[e];
  for (i[r - 1] = (t[r] + A[r - 1]) / 2, e = 0; e < r - 1; ++e) i[e] = 2 * t[e + 1] - A[e + 1];
  return [A, i];
}
function vfe(t) {
  return new QD(t);
}
function T4(t, e) {
  this._context = t, this._t = e;
}
T4.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(t, e);
        else {
          var r = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, e);
        }
        break;
      }
    }
    this._x = t, this._y = e;
  }
};
function qfe(t) {
  return new T4(t, 0.5);
}
function yfe(t) {
  return new T4(t, 0);
}
function Cfe(t) {
  return new T4(t, 1);
}
function Gu(t, e) {
  if ((o = t.length) > 1)
    for (var r = 1, n, A, i = t[e[0]], o, s = i.length; r < o; ++r)
      for (A = i, i = t[e[r]], n = 0; n < s; ++n)
        i[n][1] += i[n][0] = isNaN(A[n][1]) ? A[n][0] : A[n][1];
}
function z7(t) {
  for (var e = t.length, r = new Array(e); --e >= 0; ) r[e] = e;
  return r;
}
function wfe(t, e) {
  return t[e];
}
function bfe(t) {
  const e = [];
  return e.key = t, e;
}
function Bfe() {
  var t = Zr([]), e = z7, r = Gu, n = wfe;
  function A(i) {
    var o = Array.from(t.apply(this, arguments), bfe), s, a = o.length, c = -1, l;
    for (const u of i)
      for (s = 0, ++c; s < a; ++s)
        (o[s][c] = [0, +n(u, o[s].key, c, i)]).data = u;
    for (s = 0, l = pq(e(o)); s < a; ++s)
      o[l[s]].index = s;
    return r(o, l), o;
  }
  return A.keys = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Zr(Array.from(i)), A) : t;
  }, A.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Zr(+i), A) : n;
  }, A.order = function(i) {
    return arguments.length ? (e = i == null ? z7 : typeof i == "function" ? i : Zr(Array.from(i)), A) : e;
  }, A.offset = function(i) {
    return arguments.length ? (r = i ?? Gu, A) : r;
  }, A;
}
function Efe(t, e) {
  if ((n = t.length) > 0) {
    for (var r, n, A = 0, i = t[0].length, o; A < i; ++A) {
      for (o = r = 0; r < n; ++r) o += t[r][A][1] || 0;
      if (o) for (r = 0; r < n; ++r) t[r][A][1] /= o;
    }
    Gu(t, e);
  }
}
function xfe(t, e) {
  if ((A = t.length) > 0) {
    for (var r = 0, n = t[e[0]], A, i = n.length; r < i; ++r) {
      for (var o = 0, s = 0; o < A; ++o) s += t[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Gu(t, e);
  }
}
function Ife(t, e) {
  if (!(!((o = t.length) > 0) || !((i = (A = t[e[0]]).length) > 0))) {
    for (var r = 0, n = 1, A, i, o; n < i; ++n) {
      for (var s = 0, a = 0, c = 0; s < o; ++s) {
        for (var l = t[e[s]], u = l[n][1] || 0, f = l[n - 1][1] || 0, d = (u - f) / 2, g = 0; g < s; ++g) {
          var m = t[e[g]], p = m[n][1] || 0, v = m[n - 1][1] || 0;
          d += p - v;
        }
        a += u, c += d * u;
      }
      A[n - 1][1] += A[n - 1][0] = r, a && (r -= c / a);
    }
    A[n - 1][1] += A[n - 1][0] = r, Gu(t, e);
  }
}
function k2(t) {
  "@babel/helpers - typeof";
  return k2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, k2(t);
}
var Sfe = ["type", "size", "sizeType"];
function Y7() {
  return Y7 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Y7.apply(this, arguments);
}
function ME(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function HE(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ME(Object(r), !0).forEach(function(n) {
      Pfe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ME(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Pfe(t, e, r) {
  return e = kfe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function kfe(t) {
  var e = Ofe(t, "string");
  return k2(e) == "symbol" ? e : e + "";
}
function Ofe(t, e) {
  if (k2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (k2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Ffe(t, e) {
  if (t == null) return {};
  var r = Tfe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Tfe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var UD = {
  symbolCircle: gq,
  symbolCross: efe,
  symbolDiamond: rfe,
  symbolSquare: nfe,
  symbolStar: sfe,
  symbolTriangle: afe,
  symbolWye: lfe
}, Mfe = Math.PI / 180, Hfe = function(e) {
  var r = "symbol".concat(k4(e));
  return UD[r] || gq;
}, Dfe = function(e, r, n) {
  if (r === "area")
    return e;
  switch (n) {
    case "cross":
      return 5 * e * e / 9;
    case "diamond":
      return 0.5 * e * e / Math.sqrt(3);
    case "square":
      return e * e;
    case "star": {
      var A = 18 * Mfe;
      return 1.25 * e * e * (Math.tan(A) - Math.tan(A * 2) * Math.pow(Math.tan(A), 2));
    }
    case "triangle":
      return Math.sqrt(3) * e * e / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * e * e / 8;
    default:
      return Math.PI * e * e / 4;
  }
}, Qfe = function(e, r) {
  UD["symbol".concat(k4(e))] = r;
}, mq = function(e) {
  var r = e.type, n = r === void 0 ? "circle" : r, A = e.size, i = A === void 0 ? 64 : A, o = e.sizeType, s = o === void 0 ? "area" : o, a = Ffe(e, Sfe), c = HE(HE({}, a), {}, {
    type: n,
    size: i,
    sizeType: s
  }), l = function() {
    var p = Hfe(n), v = ufe().type(p).size(Dfe(i, s, n));
    return v();
  }, u = c.className, f = c.cx, d = c.cy, g = cr(c, !0);
  return f === +f && d === +d && i === +i ? /* @__PURE__ */ re.createElement("path", Y7({}, g, {
    className: Br("recharts-symbols", u),
    transform: "translate(".concat(f, ", ").concat(d, ")"),
    d: l()
  })) : null;
};
mq.registerSymbol = Qfe;
function Ru(t) {
  "@babel/helpers - typeof";
  return Ru = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ru(t);
}
function V7() {
  return V7 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, V7.apply(this, arguments);
}
function DE(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ufe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? DE(Object(r), !0).forEach(function(n) {
      O2(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : DE(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Nfe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function jfe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, jD(n.key), n);
  }
}
function Lfe(t, e, r) {
  return jfe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Gfe(t, e, r) {
  return e = J3(e), Rfe(t, ND() ? Reflect.construct(e, r || [], J3(t).constructor) : e.apply(t, r));
}
function Rfe(t, e) {
  if (e && (Ru(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zfe(t);
}
function zfe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ND() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ND = function() {
    return !!t;
  })();
}
function J3(t) {
  return J3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, J3(t);
}
function Yfe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && W7(t, e);
}
function W7(t, e) {
  return W7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, W7(t, e);
}
function O2(t, e, r) {
  return e = jD(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function jD(t) {
  var e = Vfe(t, "string");
  return Ru(e) == "symbol" ? e : e + "";
}
function Vfe(t, e) {
  if (Ru(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Ru(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Ji = 32, vq = /* @__PURE__ */ function(t) {
  function e() {
    return Nfe(this, e), Gfe(this, e, arguments);
  }
  return Yfe(e, t), Lfe(e, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var A = this.props.inactiveColor, i = Ji / 2, o = Ji / 6, s = Ji / 3, a = n.inactive ? A : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ re.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: a,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: Ji,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ re.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: a,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(Ji, "M").concat(2 * s, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ re.createElement("path", {
            stroke: "none",
            fill: a,
            d: "M0,".concat(Ji / 8, "h").concat(Ji, "v").concat(Ji * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ re.isValidElement(n.legendIcon)) {
          var c = Ufe({}, n);
          return delete c.legendIcon, /* @__PURE__ */ re.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ re.createElement(mq, {
          fill: a,
          cx: i,
          cy: i,
          size: Ji,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, A = this.props, i = A.payload, o = A.iconSize, s = A.layout, a = A.formatter, c = A.inactiveColor, l = {
        x: 0,
        y: 0,
        width: Ji,
        height: Ji
      }, u = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, f = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(d, g) {
        var m = d.formatter || a, p = Br(O2(O2({
          "recharts-legend-item": !0
        }, "legend-item-".concat(g), !0), "inactive", d.inactive));
        if (d.type === "none")
          return null;
        var v = nr(d.value) ? null : d.value;
        Es(
          !nr(d.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var C = d.inactive ? c : d.color;
        return /* @__PURE__ */ re.createElement("li", V7({
          className: p,
          style: u,
          key: "legend-item-".concat(g)
        }, Y3(n.props, d, g)), /* @__PURE__ */ re.createElement(Q7, {
          width: o,
          height: o,
          viewBox: l,
          style: f
        }, n.renderIcon(d)), /* @__PURE__ */ re.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: C
          }
        }, m ? m(v, d, g) : v));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, A = n.payload, i = n.layout, o = n.align;
      if (!A || !A.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ re.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(es);
O2(vq, "displayName", "Legend");
O2(vq, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Wfe = I4;
function Xfe() {
  this.__data__ = new Wfe(), this.size = 0;
}
var Kfe = Xfe;
function Zfe(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var Jfe = Zfe;
function _fe(t) {
  return this.__data__.get(t);
}
var $fe = _fe;
function ehe(t) {
  return this.__data__.has(t);
}
var the = ehe, rhe = I4, nhe = sq, Ahe = aq, ihe = 200;
function ohe(t, e) {
  var r = this.__data__;
  if (r instanceof rhe) {
    var n = r.__data__;
    if (!nhe || n.length < ihe - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Ahe(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
var she = ohe, ahe = I4, che = Kfe, lhe = Jfe, uhe = $fe, dhe = the, fhe = she;
function Gd(t) {
  var e = this.__data__ = new ahe(t);
  this.size = e.size;
}
Gd.prototype.clear = che;
Gd.prototype.delete = lhe;
Gd.prototype.get = uhe;
Gd.prototype.has = dhe;
Gd.prototype.set = fhe;
var LD = Gd, hhe = "__lodash_hash_undefined__";
function phe(t) {
  return this.__data__.set(t, hhe), this;
}
var ghe = phe;
function mhe(t) {
  return this.__data__.has(t);
}
var vhe = mhe, qhe = aq, yhe = ghe, Che = vhe;
function _3(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new qhe(); ++e < r; )
    this.add(t[e]);
}
_3.prototype.add = _3.prototype.push = yhe;
_3.prototype.has = Che;
var GD = _3;
function whe(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var RD = whe;
function bhe(t, e) {
  return t.has(e);
}
var zD = bhe, Bhe = GD, Ehe = RD, xhe = zD, Ihe = 1, She = 2;
function Phe(t, e, r, n, A, i) {
  var o = r & Ihe, s = t.length, a = e.length;
  if (s != a && !(o && a > s))
    return !1;
  var c = i.get(t), l = i.get(e);
  if (c && l)
    return c == e && l == t;
  var u = -1, f = !0, d = r & She ? new Bhe() : void 0;
  for (i.set(t, e), i.set(e, t); ++u < s; ) {
    var g = t[u], m = e[u];
    if (n)
      var p = o ? n(m, g, u, e, t, i) : n(g, m, u, t, e, i);
    if (p !== void 0) {
      if (p)
        continue;
      f = !1;
      break;
    }
    if (d) {
      if (!Ehe(e, function(v, C) {
        if (!xhe(d, C) && (g === v || A(g, v, r, n, i)))
          return d.push(C);
      })) {
        f = !1;
        break;
      }
    } else if (!(g === m || A(g, m, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), f;
}
var YD = Phe, khe = As, Ohe = khe.Uint8Array, Fhe = Ohe;
function The(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, A) {
    r[++e] = [A, n];
  }), r;
}
var Mhe = The;
function Hhe(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var qq = Hhe, QE = M1, UE = Fhe, Dhe = oq, Qhe = YD, Uhe = Mhe, Nhe = qq, jhe = 1, Lhe = 2, Ghe = "[object Boolean]", Rhe = "[object Date]", zhe = "[object Error]", Yhe = "[object Map]", Vhe = "[object Number]", Whe = "[object RegExp]", Xhe = "[object Set]", Khe = "[object String]", Zhe = "[object Symbol]", Jhe = "[object ArrayBuffer]", _he = "[object DataView]", NE = QE ? QE.prototype : void 0, b6 = NE ? NE.valueOf : void 0;
function $he(t, e, r, n, A, i, o) {
  switch (r) {
    case _he:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case Jhe:
      return !(t.byteLength != e.byteLength || !i(new UE(t), new UE(e)));
    case Ghe:
    case Rhe:
    case Vhe:
      return Dhe(+t, +e);
    case zhe:
      return t.name == e.name && t.message == e.message;
    case Whe:
    case Khe:
      return t == e + "";
    case Yhe:
      var s = Uhe;
    case Xhe:
      var a = n & jhe;
      if (s || (s = Nhe), t.size != e.size && !a)
        return !1;
      var c = o.get(t);
      if (c)
        return c == e;
      n |= Lhe, o.set(t, e);
      var l = Qhe(s(t), s(e), n, A, i, o);
      return o.delete(t), l;
    case Zhe:
      if (b6)
        return b6.call(t) == b6.call(e);
  }
  return !1;
}
var e3e = $he;
function t3e(t, e) {
  for (var r = -1, n = e.length, A = t.length; ++r < n; )
    t[A + r] = e[r];
  return t;
}
var VD = t3e, r3e = VD, n3e = li;
function A3e(t, e, r) {
  var n = e(t);
  return n3e(t) ? n : r3e(n, r(t));
}
var i3e = A3e;
function o3e(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, A = 0, i = []; ++r < n; ) {
    var o = t[r];
    e(o, r, t) && (i[A++] = o);
  }
  return i;
}
var s3e = o3e;
function a3e() {
  return [];
}
var c3e = a3e, l3e = s3e, u3e = c3e, d3e = Object.prototype, f3e = d3e.propertyIsEnumerable, jE = Object.getOwnPropertySymbols, h3e = jE ? function(t) {
  return t == null ? [] : (t = Object(t), l3e(jE(t), function(e) {
    return f3e.call(t, e);
  }));
} : u3e, p3e = h3e;
function g3e(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var m3e = g3e, v3e = zs, q3e = Ys, y3e = "[object Arguments]";
function C3e(t) {
  return q3e(t) && v3e(t) == y3e;
}
var w3e = C3e, LE = w3e, b3e = Ys, WD = Object.prototype, B3e = WD.hasOwnProperty, E3e = WD.propertyIsEnumerable, x3e = LE(/* @__PURE__ */ function() {
  return arguments;
}()) ? LE : function(t) {
  return b3e(t) && B3e.call(t, "callee") && !E3e.call(t, "callee");
}, yq = x3e, $3 = { exports: {} };
function I3e() {
  return !1;
}
var S3e = I3e;
$3.exports;
(function(t, e) {
  var r = As, n = S3e, A = e && !e.nodeType && e, i = A && !0 && t && !t.nodeType && t, o = i && i.exports === A, s = o ? r.Buffer : void 0, a = s ? s.isBuffer : void 0, c = a || n;
  t.exports = c;
})($3, $3.exports);
var XD = $3.exports, P3e = 9007199254740991, k3e = /^(?:0|[1-9]\d*)$/;
function O3e(t, e) {
  var r = typeof t;
  return e = e ?? P3e, !!e && (r == "number" || r != "symbol" && k3e.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Cq = O3e, F3e = 9007199254740991;
function T3e(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= F3e;
}
var wq = T3e, M3e = zs, H3e = wq, D3e = Ys, Q3e = "[object Arguments]", U3e = "[object Array]", N3e = "[object Boolean]", j3e = "[object Date]", L3e = "[object Error]", G3e = "[object Function]", R3e = "[object Map]", z3e = "[object Number]", Y3e = "[object Object]", V3e = "[object RegExp]", W3e = "[object Set]", X3e = "[object String]", K3e = "[object WeakMap]", Z3e = "[object ArrayBuffer]", J3e = "[object DataView]", _3e = "[object Float32Array]", $3e = "[object Float64Array]", epe = "[object Int8Array]", tpe = "[object Int16Array]", rpe = "[object Int32Array]", npe = "[object Uint8Array]", Ape = "[object Uint8ClampedArray]", ipe = "[object Uint16Array]", ope = "[object Uint32Array]", tn = {};
tn[_3e] = tn[$3e] = tn[epe] = tn[tpe] = tn[rpe] = tn[npe] = tn[Ape] = tn[ipe] = tn[ope] = !0;
tn[Q3e] = tn[U3e] = tn[Z3e] = tn[N3e] = tn[J3e] = tn[j3e] = tn[L3e] = tn[G3e] = tn[R3e] = tn[z3e] = tn[Y3e] = tn[V3e] = tn[W3e] = tn[X3e] = tn[K3e] = !1;
function spe(t) {
  return D3e(t) && H3e(t.length) && !!tn[M3e(t)];
}
var ape = spe;
function cpe(t) {
  return function(e) {
    return t(e);
  };
}
var KD = cpe, ep = { exports: {} };
ep.exports;
(function(t, e) {
  var r = AD, n = e && !e.nodeType && e, A = n && !0 && t && !t.nodeType && t, i = A && A.exports === n, o = i && r.process, s = function() {
    try {
      var a = A && A.require && A.require("util").types;
      return a || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(ep, ep.exports);
var lpe = ep.exports, upe = ape, dpe = KD, GE = lpe, RE = GE && GE.isTypedArray, fpe = RE ? dpe(RE) : upe, ZD = fpe, hpe = m3e, ppe = yq, gpe = li, mpe = XD, vpe = Cq, qpe = ZD, ype = Object.prototype, Cpe = ype.hasOwnProperty;
function wpe(t, e) {
  var r = gpe(t), n = !r && ppe(t), A = !r && !n && mpe(t), i = !r && !n && !A && qpe(t), o = r || n || A || i, s = o ? hpe(t.length, String) : [], a = s.length;
  for (var c in t)
    (e || Cpe.call(t, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    A && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    vpe(c, a))) && s.push(c);
  return s;
}
var bpe = wpe, Bpe = Object.prototype;
function Epe(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || Bpe;
  return t === r;
}
var xpe = Epe;
function Ipe(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var JD = Ipe, Spe = JD, Ppe = Spe(Object.keys, Object), kpe = Ppe, Ope = xpe, Fpe = kpe, Tpe = Object.prototype, Mpe = Tpe.hasOwnProperty;
function Hpe(t) {
  if (!Ope(t))
    return Fpe(t);
  var e = [];
  for (var r in Object(t))
    Mpe.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var Dpe = Hpe, Qpe = iq, Upe = wq;
function Npe(t) {
  return t != null && Upe(t.length) && !Qpe(t);
}
var D1 = Npe, jpe = bpe, Lpe = Dpe, Gpe = D1;
function Rpe(t) {
  return Gpe(t) ? jpe(t) : Lpe(t);
}
var M4 = Rpe, zpe = i3e, Ype = p3e, Vpe = M4;
function Wpe(t) {
  return zpe(t, Vpe, Ype);
}
var Xpe = Wpe, zE = Xpe, Kpe = 1, Zpe = Object.prototype, Jpe = Zpe.hasOwnProperty;
function _pe(t, e, r, n, A, i) {
  var o = r & Kpe, s = zE(t), a = s.length, c = zE(e), l = c.length;
  if (a != l && !o)
    return !1;
  for (var u = a; u--; ) {
    var f = s[u];
    if (!(o ? f in e : Jpe.call(e, f)))
      return !1;
  }
  var d = i.get(t), g = i.get(e);
  if (d && g)
    return d == e && g == t;
  var m = !0;
  i.set(t, e), i.set(e, t);
  for (var p = o; ++u < a; ) {
    f = s[u];
    var v = t[f], C = e[f];
    if (n)
      var w = o ? n(C, v, f, e, t, i) : n(v, C, f, t, e, i);
    if (!(w === void 0 ? v === C || A(v, C, r, n, i) : w)) {
      m = !1;
      break;
    }
    p || (p = f == "constructor");
  }
  if (m && !p) {
    var B = t.constructor, y = e.constructor;
    B != y && "constructor" in t && "constructor" in e && !(typeof B == "function" && B instanceof B && typeof y == "function" && y instanceof y) && (m = !1);
  }
  return i.delete(t), i.delete(e), m;
}
var $pe = _pe, ege = dl, tge = As, rge = ege(tge, "DataView"), nge = rge, Age = dl, ige = As, oge = Age(ige, "Promise"), sge = oge, age = dl, cge = As, lge = age(cge, "Set"), _D = lge, uge = dl, dge = As, fge = uge(dge, "WeakMap"), hge = fge, X7 = nge, K7 = sq, Z7 = sge, J7 = _D, _7 = hge, $D = zs, Rd = oD, YE = "[object Map]", pge = "[object Object]", VE = "[object Promise]", WE = "[object Set]", XE = "[object WeakMap]", KE = "[object DataView]", gge = Rd(X7), mge = Rd(K7), vge = Rd(Z7), qge = Rd(J7), yge = Rd(_7), gc = $D;
(X7 && gc(new X7(new ArrayBuffer(1))) != KE || K7 && gc(new K7()) != YE || Z7 && gc(Z7.resolve()) != VE || J7 && gc(new J7()) != WE || _7 && gc(new _7()) != XE) && (gc = function(t) {
  var e = $D(t), r = e == pge ? t.constructor : void 0, n = r ? Rd(r) : "";
  if (n)
    switch (n) {
      case gge:
        return KE;
      case mge:
        return YE;
      case vge:
        return VE;
      case qge:
        return WE;
      case yge:
        return XE;
    }
  return e;
});
var Cge = gc, B6 = LD, wge = YD, bge = e3e, Bge = $pe, ZE = Cge, JE = li, _E = XD, Ege = ZD, xge = 1, $E = "[object Arguments]", ex = "[object Array]", Yf = "[object Object]", Ige = Object.prototype, tx = Ige.hasOwnProperty;
function Sge(t, e, r, n, A, i) {
  var o = JE(t), s = JE(e), a = o ? ex : ZE(t), c = s ? ex : ZE(e);
  a = a == $E ? Yf : a, c = c == $E ? Yf : c;
  var l = a == Yf, u = c == Yf, f = a == c;
  if (f && _E(t)) {
    if (!_E(e))
      return !1;
    o = !0, l = !1;
  }
  if (f && !l)
    return i || (i = new B6()), o || Ege(t) ? wge(t, e, r, n, A, i) : bge(t, e, a, r, n, A, i);
  if (!(r & xge)) {
    var d = l && tx.call(t, "__wrapped__"), g = u && tx.call(e, "__wrapped__");
    if (d || g) {
      var m = d ? t.value() : t, p = g ? e.value() : e;
      return i || (i = new B6()), A(m, p, r, n, i);
    }
  }
  return f ? (i || (i = new B6()), Bge(t, e, r, n, A, i)) : !1;
}
var Pge = Sge, kge = Pge, rx = Ys;
function eQ(t, e, r, n, A) {
  return t === e ? !0 : t == null || e == null || !rx(t) && !rx(e) ? t !== t && e !== e : kge(t, e, r, n, eQ, A);
}
var bq = eQ, Oge = LD, Fge = bq, Tge = 1, Mge = 2;
function Hge(t, e, r, n) {
  var A = r.length, i = A, o = !n;
  if (t == null)
    return !i;
  for (t = Object(t); A--; ) {
    var s = r[A];
    if (o && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++A < i; ) {
    s = r[A];
    var a = s[0], c = t[a], l = s[1];
    if (o && s[2]) {
      if (c === void 0 && !(a in t))
        return !1;
    } else {
      var u = new Oge();
      if (n)
        var f = n(c, l, a, t, e, u);
      if (!(f === void 0 ? Fge(l, c, Tge | Mge, n, u) : f))
        return !1;
    }
  }
  return !0;
}
var Dge = Hge, Qge = ec;
function Uge(t) {
  return t === t && !Qge(t);
}
var tQ = Uge, Nge = tQ, jge = M4;
function Lge(t) {
  for (var e = jge(t), r = e.length; r--; ) {
    var n = e[r], A = t[n];
    e[r] = [n, A, Nge(A)];
  }
  return e;
}
var Gge = Lge;
function Rge(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
var rQ = Rge, zge = Dge, Yge = Gge, Vge = rQ;
function Wge(t) {
  var e = Yge(t);
  return e.length == 1 && e[0][2] ? Vge(e[0][0], e[0][1]) : function(r) {
    return r === t || zge(r, t, e);
  };
}
var Xge = Wge;
function Kge(t, e) {
  return t != null && e in Object(t);
}
var Zge = Kge, Jge = uD, _ge = yq, $ge = li, e4e = Cq, t4e = wq, r4e = P4;
function n4e(t, e, r) {
  e = Jge(e, t);
  for (var n = -1, A = e.length, i = !1; ++n < A; ) {
    var o = r4e(e[n]);
    if (!(i = t != null && r(t, o)))
      break;
    t = t[o];
  }
  return i || ++n != A ? i : (A = t == null ? 0 : t.length, !!A && t4e(A) && e4e(o, A) && ($ge(t) || _ge(t)));
}
var A4e = n4e, i4e = Zge, o4e = A4e;
function s4e(t, e) {
  return t != null && o4e(t, e, i4e);
}
var a4e = s4e, c4e = bq, l4e = dD, u4e = a4e, d4e = Aq, f4e = tQ, h4e = rQ, p4e = P4, g4e = 1, m4e = 2;
function v4e(t, e) {
  return d4e(t) && f4e(e) ? h4e(p4e(t), e) : function(r) {
    var n = l4e(r, t);
    return n === void 0 && n === e ? u4e(r, t) : c4e(e, n, g4e | m4e);
  };
}
var q4e = v4e;
function y4e(t) {
  return t;
}
var zd = y4e;
function C4e(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var w4e = C4e, b4e = uq;
function B4e(t) {
  return function(e) {
    return b4e(e, t);
  };
}
var E4e = B4e, x4e = w4e, I4e = E4e, S4e = Aq, P4e = P4;
function k4e(t) {
  return S4e(t) ? x4e(P4e(t)) : I4e(t);
}
var O4e = k4e, F4e = Xge, T4e = q4e, M4e = zd, H4e = li, D4e = O4e;
function Q4e(t) {
  return typeof t == "function" ? t : t == null ? M4e : typeof t == "object" ? H4e(t) ? T4e(t[0], t[1]) : F4e(t) : D4e(t);
}
var tc = Q4e;
function U4e(t, e, r, n) {
  for (var A = t.length, i = r + (n ? 1 : -1); n ? i-- : ++i < A; )
    if (e(t[i], i, t))
      return i;
  return -1;
}
var nQ = U4e;
function N4e(t) {
  return t !== t;
}
var j4e = N4e;
function L4e(t, e, r) {
  for (var n = r - 1, A = t.length; ++n < A; )
    if (t[n] === e)
      return n;
  return -1;
}
var G4e = L4e, R4e = nQ, z4e = j4e, Y4e = G4e;
function V4e(t, e, r) {
  return e === e ? Y4e(t, e, r) : R4e(t, z4e, r);
}
var W4e = V4e, X4e = W4e;
function K4e(t, e) {
  var r = t == null ? 0 : t.length;
  return !!r && X4e(t, e, 0) > -1;
}
var Z4e = K4e;
function J4e(t, e, r) {
  for (var n = -1, A = t == null ? 0 : t.length; ++n < A; )
    if (r(e, t[n]))
      return !0;
  return !1;
}
var _4e = J4e;
function $4e() {
}
var e9e = $4e, E6 = _D, t9e = e9e, r9e = qq, n9e = 1 / 0, A9e = E6 && 1 / r9e(new E6([, -0]))[1] == n9e ? function(t) {
  return new E6(t);
} : t9e, i9e = A9e, o9e = GD, s9e = Z4e, a9e = _4e, c9e = zD, l9e = i9e, u9e = qq, d9e = 200;
function f9e(t, e, r) {
  var n = -1, A = s9e, i = t.length, o = !0, s = [], a = s;
  if (r)
    o = !1, A = a9e;
  else if (i >= d9e) {
    var c = e ? null : l9e(t);
    if (c)
      return u9e(c);
    o = !1, A = c9e, a = new o9e();
  } else
    a = e ? [] : s;
  e:
    for (; ++n < i; ) {
      var l = t[n], u = e ? e(l) : l;
      if (l = r || l !== 0 ? l : 0, o && u === u) {
        for (var f = a.length; f--; )
          if (a[f] === u)
            continue e;
        e && a.push(u), s.push(l);
      } else A(a, u, r) || (a !== s && a.push(u), s.push(l));
    }
  return s;
}
var h9e = f9e, p9e = tc, g9e = h9e;
function m9e(t, e) {
  return t && t.length ? g9e(t, p9e(e)) : [];
}
var v9e = m9e;
const nx = /* @__PURE__ */ Vr(v9e);
function AQ(t, e, r) {
  return e === !0 ? nx(t, r) : nr(e) ? nx(t, e) : t;
}
function zu(t) {
  "@babel/helpers - typeof";
  return zu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zu(t);
}
var q9e = ["ref"];
function Ax(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cs(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ax(Object(r), !0).forEach(function(n) {
      H4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ax(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function y9e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ix(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, oQ(n.key), n);
  }
}
function C9e(t, e, r) {
  return ix(t.prototype, e), ix(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function w9e(t, e, r) {
  return e = tp(e), b9e(t, iQ() ? Reflect.construct(e, r, tp(t).constructor) : e.apply(t, r));
}
function b9e(t, e) {
  if (e && (zu(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return B9e(t);
}
function B9e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function iQ() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (iQ = function() {
    return !!t;
  })();
}
function tp(t) {
  return tp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, tp(t);
}
function E9e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && $7(t, e);
}
function $7(t, e) {
  return $7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, $7(t, e);
}
function H4(t, e, r) {
  return e = oQ(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function oQ(t) {
  var e = x9e(t, "string");
  return zu(e) == "symbol" ? e : e + "";
}
function x9e(t, e) {
  if (zu(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (zu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function I9e(t, e) {
  if (t == null) return {};
  var r = S9e(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function S9e(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function P9e(t) {
  return t.value;
}
function k9e(t, e) {
  if (/* @__PURE__ */ re.isValidElement(t))
    return /* @__PURE__ */ re.cloneElement(t, e);
  if (typeof t == "function")
    return /* @__PURE__ */ re.createElement(t, e);
  e.ref;
  var r = I9e(e, q9e);
  return /* @__PURE__ */ re.createElement(vq, r);
}
var ox = 1, cu = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    y9e(this, e);
    for (var n = arguments.length, A = new Array(n), i = 0; i < n; i++)
      A[i] = arguments[i];
    return r = w9e(this, e, [].concat(A)), H4(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return E9e(e, t), C9e(e, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, A = this.getBBox();
      A ? (Math.abs(A.width - this.lastBoundingBox.width) > ox || Math.abs(A.height - this.lastBoundingBox.height) > ox) && (this.lastBoundingBox.width = A.width, this.lastBoundingBox.height = A.height, n && n(A)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? cs({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var A = this.props, i = A.layout, o = A.align, s = A.verticalAlign, a = A.margin, c = A.chartWidth, l = A.chartHeight, u, f;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var d = this.getBBoxSnapshot();
          u = {
            left: ((c || 0) - d.width) / 2
          };
        } else
          u = o === "right" ? {
            right: a && a.right || 0
          } : {
            left: a && a.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var g = this.getBBoxSnapshot();
          f = {
            top: ((l || 0) - g.height) / 2
          };
        } else
          f = s === "bottom" ? {
            bottom: a && a.bottom || 0
          } : {
            top: a && a.top || 0
          };
      return cs(cs({}, u), f);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, A = this.props, i = A.content, o = A.width, s = A.height, a = A.wrapperStyle, c = A.payloadUniqBy, l = A.payload, u = cs(cs({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(a)), a);
      return /* @__PURE__ */ re.createElement("div", {
        className: "recharts-legend-wrapper",
        style: u,
        ref: function(d) {
          n.wrapperNode = d;
        }
      }, k9e(i, cs(cs({}, this.props), {}, {
        payload: AQ(l, c, P9e)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, A) {
      var i = cs(cs({}, this.defaultProps), n.props), o = i.layout;
      return o === "vertical" && At(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || A
      } : null;
    }
  }]);
}(es);
H4(cu, "displayName", "Legend");
H4(cu, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var sx = M1, O9e = yq, F9e = li, ax = sx ? sx.isConcatSpreadable : void 0;
function T9e(t) {
  return F9e(t) || O9e(t) || !!(ax && t && t[ax]);
}
var M9e = T9e, H9e = VD, D9e = M9e;
function sQ(t, e, r, n, A) {
  var i = -1, o = t.length;
  for (r || (r = D9e), A || (A = []); ++i < o; ) {
    var s = t[i];
    e > 0 && r(s) ? e > 1 ? sQ(s, e - 1, r, n, A) : H9e(A, s) : n || (A[A.length] = s);
  }
  return A;
}
var aQ = sQ;
function Q9e(t) {
  return function(e, r, n) {
    for (var A = -1, i = Object(e), o = n(e), s = o.length; s--; ) {
      var a = o[t ? s : ++A];
      if (r(i[a], a, i) === !1)
        break;
    }
    return e;
  };
}
var U9e = Q9e, N9e = U9e, j9e = N9e(), L9e = j9e, G9e = L9e, R9e = M4;
function z9e(t, e) {
  return t && G9e(t, e, R9e);
}
var cQ = z9e, Y9e = D1;
function V9e(t, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Y9e(r))
      return t(r, n);
    for (var A = r.length, i = e ? A : -1, o = Object(r); (e ? i-- : ++i < A) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var W9e = V9e, X9e = cQ, K9e = W9e, Z9e = K9e(X9e), Bq = Z9e, J9e = Bq, _9e = D1;
function $9e(t, e) {
  var r = -1, n = _9e(t) ? Array(t.length) : [];
  return J9e(t, function(A, i, o) {
    n[++r] = e(A, i, o);
  }), n;
}
var lQ = $9e;
function e6e(t, e) {
  var r = t.length;
  for (t.sort(e); r--; )
    t[r] = t[r].value;
  return t;
}
var t6e = e6e, cx = Hd;
function r6e(t, e) {
  if (t !== e) {
    var r = t !== void 0, n = t === null, A = t === t, i = cx(t), o = e !== void 0, s = e === null, a = e === e, c = cx(e);
    if (!s && !c && !i && t > e || i && o && a && !s && !c || n && o && a || !r && a || !A)
      return 1;
    if (!n && !i && !c && t < e || c && r && A && !n && !i || s && r && A || !o && A || !a)
      return -1;
  }
  return 0;
}
var n6e = r6e, A6e = n6e;
function i6e(t, e, r) {
  for (var n = -1, A = t.criteria, i = e.criteria, o = A.length, s = r.length; ++n < o; ) {
    var a = A6e(A[n], i[n]);
    if (a) {
      if (n >= s)
        return a;
      var c = r[n];
      return a * (c == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
var o6e = i6e, x6 = lq, s6e = uq, a6e = tc, c6e = lQ, l6e = t6e, u6e = KD, d6e = o6e, f6e = zd, h6e = li;
function p6e(t, e, r) {
  e.length ? e = x6(e, function(i) {
    return h6e(i) ? function(o) {
      return s6e(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : e = [f6e];
  var n = -1;
  e = x6(e, u6e(a6e));
  var A = c6e(t, function(i, o, s) {
    var a = x6(e, function(c) {
      return c(i);
    });
    return { criteria: a, index: ++n, value: i };
  });
  return l6e(A, function(i, o) {
    return d6e(i, o, r);
  });
}
var g6e = p6e;
function m6e(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
var v6e = m6e, q6e = v6e, lx = Math.max;
function y6e(t, e, r) {
  return e = lx(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, A = -1, i = lx(n.length - e, 0), o = Array(i); ++A < i; )
      o[A] = n[e + A];
    A = -1;
    for (var s = Array(e + 1); ++A < e; )
      s[A] = n[A];
    return s[e] = r(o), q6e(t, this, s);
  };
}
var C6e = y6e;
function w6e(t) {
  return function() {
    return t;
  };
}
var b6e = w6e, B6e = dl, E6e = function() {
  try {
    var t = B6e(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), uQ = E6e, x6e = b6e, ux = uQ, I6e = zd, S6e = ux ? function(t, e) {
  return ux(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: x6e(e),
    writable: !0
  });
} : I6e, P6e = S6e, k6e = 800, O6e = 16, F6e = Date.now;
function T6e(t) {
  var e = 0, r = 0;
  return function() {
    var n = F6e(), A = O6e - (n - r);
    if (r = n, A > 0) {
      if (++e >= k6e)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var M6e = T6e, H6e = P6e, D6e = M6e, Q6e = D6e(H6e), U6e = Q6e, N6e = zd, j6e = C6e, L6e = U6e;
function G6e(t, e) {
  return L6e(j6e(t, e, N6e), t + "");
}
var R6e = G6e, z6e = oq, Y6e = D1, V6e = Cq, W6e = ec;
function X6e(t, e, r) {
  if (!W6e(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? Y6e(r) && V6e(e, r.length) : n == "string" && e in r) ? z6e(r[e], t) : !1;
}
var D4 = X6e, K6e = aQ, Z6e = g6e, J6e = R6e, dx = D4, _6e = J6e(function(t, e) {
  if (t == null)
    return [];
  var r = e.length;
  return r > 1 && dx(t, e[0], e[1]) ? e = [] : r > 2 && dx(e[0], e[1], e[2]) && (e = [e[0]]), Z6e(t, K6e(e, 1), []);
}), $6e = _6e;
const Eq = /* @__PURE__ */ Vr($6e);
function F2(t) {
  "@babel/helpers - typeof";
  return F2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, F2(t);
}
function e8() {
  return e8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, e8.apply(this, arguments);
}
function e5e(t, e) {
  return A5e(t) || n5e(t, e) || r5e(t, e) || t5e();
}
function t5e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function r5e(t, e) {
  if (t) {
    if (typeof t == "string") return fx(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return fx(t, e);
  }
}
function fx(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function n5e(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function A5e(t) {
  if (Array.isArray(t)) return t;
}
function hx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function I6(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hx(Object(r), !0).forEach(function(n) {
      i5e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : hx(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function i5e(t, e, r) {
  return e = o5e(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function o5e(t) {
  var e = s5e(t, "string");
  return F2(e) == "symbol" ? e : e + "";
}
function s5e(t, e) {
  if (F2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (F2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function a5e(t) {
  return Array.isArray(t) && $n(t[0]) && $n(t[1]) ? t.join(" ~ ") : t;
}
var c5e = function(e) {
  var r = e.separator, n = r === void 0 ? " : " : r, A = e.contentStyle, i = A === void 0 ? {} : A, o = e.itemStyle, s = o === void 0 ? {} : o, a = e.labelStyle, c = a === void 0 ? {} : a, l = e.payload, u = e.formatter, f = e.itemSorter, d = e.wrapperClassName, g = e.labelClassName, m = e.label, p = e.labelFormatter, v = e.accessibilityLayer, C = v === void 0 ? !1 : v, w = function() {
    if (l && l.length) {
      var I = {
        padding: 0,
        margin: 0
      }, S = (f ? Eq(l, f) : l).map(function(P, H) {
        if (P.type === "none")
          return null;
        var F = I6({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: P.color || "#000"
        }, s), T = P.formatter || u || a5e, U = P.value, D = P.name, Q = U, Y = D;
        if (Q != null && Y != null) {
          var j = T(U, D, P, H, l);
          if (Array.isArray(j)) {
            var Z = e5e(j, 2);
            Q = Z[0], Y = Z[1];
          } else
            Q = j;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ re.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(H),
            style: F
          }, $n(Y) ? /* @__PURE__ */ re.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, Y) : null, $n(Y) ? /* @__PURE__ */ re.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ re.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, Q), /* @__PURE__ */ re.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, P.unit || ""))
        );
      });
      return /* @__PURE__ */ re.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: I
      }, S);
    }
    return null;
  }, B = I6({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), y = I6({
    margin: 0
  }, c), b = !hr(m), q = b ? m : "", E = Br("recharts-default-tooltip", d), x = Br("recharts-tooltip-label", g);
  b && p && l !== void 0 && l !== null && (q = p(m, l));
  var M = C ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ re.createElement("div", e8({
    className: E,
    style: B
  }, M), /* @__PURE__ */ re.createElement("p", {
    className: x,
    style: y
  }, /* @__PURE__ */ re.isValidElement(q) ? q : "".concat(q)), w());
};
function T2(t) {
  "@babel/helpers - typeof";
  return T2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, T2(t);
}
function Vf(t, e, r) {
  return e = l5e(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function l5e(t) {
  var e = u5e(t, "string");
  return T2(e) == "symbol" ? e : e + "";
}
function u5e(t, e) {
  if (T2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (T2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var q0 = "recharts-tooltip-wrapper", d5e = {
  visibility: "hidden"
};
function f5e(t) {
  var e = t.coordinate, r = t.translateX, n = t.translateY;
  return Br(q0, Vf(Vf(Vf(Vf({}, "".concat(q0, "-right"), At(r) && e && At(e.x) && r >= e.x), "".concat(q0, "-left"), At(r) && e && At(e.x) && r < e.x), "".concat(q0, "-bottom"), At(n) && e && At(e.y) && n >= e.y), "".concat(q0, "-top"), At(n) && e && At(e.y) && n < e.y));
}
function px(t) {
  var e = t.allowEscapeViewBox, r = t.coordinate, n = t.key, A = t.offsetTopLeft, i = t.position, o = t.reverseDirection, s = t.tooltipDimension, a = t.viewBox, c = t.viewBoxDimension;
  if (i && At(i[n]))
    return i[n];
  var l = r[n] - s - A, u = r[n] + A;
  if (e[n])
    return o[n] ? l : u;
  if (o[n]) {
    var f = l, d = a[n];
    return f < d ? Math.max(u, a[n]) : Math.max(l, a[n]);
  }
  var g = u + s, m = a[n] + c;
  return g > m ? Math.max(l, a[n]) : Math.max(u, a[n]);
}
function h5e(t) {
  var e = t.translateX, r = t.translateY, n = t.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(e, "px, ").concat(r, "px, 0)") : "translate(".concat(e, "px, ").concat(r, "px)")
  };
}
function p5e(t) {
  var e = t.allowEscapeViewBox, r = t.coordinate, n = t.offsetTopLeft, A = t.position, i = t.reverseDirection, o = t.tooltipBox, s = t.useTranslate3d, a = t.viewBox, c, l, u;
  return o.height > 0 && o.width > 0 && r ? (l = px({
    allowEscapeViewBox: e,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: A,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: a,
    viewBoxDimension: a.width
  }), u = px({
    allowEscapeViewBox: e,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: A,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: a,
    viewBoxDimension: a.height
  }), c = h5e({
    translateX: l,
    translateY: u,
    useTranslate3d: s
  })) : c = d5e, {
    cssProperties: c,
    cssClasses: f5e({
      translateX: l,
      translateY: u,
      coordinate: r
    })
  };
}
function Yu(t) {
  "@babel/helpers - typeof";
  return Yu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yu(t);
}
function gx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mx(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gx(Object(r), !0).forEach(function(n) {
      r8(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : gx(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function g5e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function m5e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, fQ(n.key), n);
  }
}
function v5e(t, e, r) {
  return m5e(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function q5e(t, e, r) {
  return e = rp(e), y5e(t, dQ() ? Reflect.construct(e, r, rp(t).constructor) : e.apply(t, r));
}
function y5e(t, e) {
  if (e && (Yu(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return C5e(t);
}
function C5e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function dQ() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (dQ = function() {
    return !!t;
  })();
}
function rp(t) {
  return rp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, rp(t);
}
function w5e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && t8(t, e);
}
function t8(t, e) {
  return t8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, t8(t, e);
}
function r8(t, e, r) {
  return e = fQ(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function fQ(t) {
  var e = b5e(t, "string");
  return Yu(e) == "symbol" ? e : e + "";
}
function b5e(t, e) {
  if (Yu(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Yu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var vx = 1, B5e = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    g5e(this, e);
    for (var n = arguments.length, A = new Array(n), i = 0; i < n; i++)
      A[i] = arguments[i];
    return r = q5e(this, e, [].concat(A)), r8(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), r8(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, a, c, l;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (a = r.props.coordinate) === null || a === void 0 ? void 0 : a.x) !== null && s !== void 0 ? s : 0,
            y: (c = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return w5e(e, t), v5e(e, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > vx || Math.abs(n.height - this.state.lastBoundingBox.height) > vx) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, A;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((A = this.props.coordinate) === null || A === void 0 ? void 0 : A.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, A = this.props, i = A.active, o = A.allowEscapeViewBox, s = A.animationDuration, a = A.animationEasing, c = A.children, l = A.coordinate, u = A.hasPayload, f = A.isAnimationActive, d = A.offset, g = A.position, m = A.reverseDirection, p = A.useTranslate3d, v = A.viewBox, C = A.wrapperStyle, w = p5e({
        allowEscapeViewBox: o,
        coordinate: l,
        offsetTopLeft: d,
        position: g,
        reverseDirection: m,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: p,
        viewBox: v
      }), B = w.cssClasses, y = w.cssProperties, b = mx(mx({
        transition: f && i ? "transform ".concat(s, "ms ").concat(a) : void 0
      }, y), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && u ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, C);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ re.createElement("div", {
          tabIndex: -1,
          className: B,
          style: b,
          ref: function(E) {
            n.wrapperNode = E;
          }
        }, c)
      );
    }
  }]);
}(es), E5e = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Wo = {
  isSsr: E5e(),
  get: function(e) {
    return Wo[e];
  },
  set: function(e, r) {
    if (typeof e == "string")
      Wo[e] = r;
    else {
      var n = Object.keys(e);
      n && n.length && n.forEach(function(A) {
        Wo[A] = e[A];
      });
    }
  }
};
function Vu(t) {
  "@babel/helpers - typeof";
  return Vu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vu(t);
}
function qx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yx(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qx(Object(r), !0).forEach(function(n) {
      xq(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qx(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function x5e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function I5e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, pQ(n.key), n);
  }
}
function S5e(t, e, r) {
  return I5e(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function P5e(t, e, r) {
  return e = np(e), k5e(t, hQ() ? Reflect.construct(e, r || [], np(t).constructor) : e.apply(t, r));
}
function k5e(t, e) {
  if (e && (Vu(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return O5e(t);
}
function O5e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function hQ() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hQ = function() {
    return !!t;
  })();
}
function np(t) {
  return np = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, np(t);
}
function F5e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && n8(t, e);
}
function n8(t, e) {
  return n8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, n8(t, e);
}
function xq(t, e, r) {
  return e = pQ(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function pQ(t) {
  var e = T5e(t, "string");
  return Vu(e) == "symbol" ? e : e + "";
}
function T5e(t, e) {
  if (Vu(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Vu(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function M5e(t) {
  return t.dataKey;
}
function H5e(t, e) {
  return /* @__PURE__ */ re.isValidElement(t) ? /* @__PURE__ */ re.cloneElement(t, e) : typeof t == "function" ? /* @__PURE__ */ re.createElement(t, e) : /* @__PURE__ */ re.createElement(c5e, e);
}
var Ti = /* @__PURE__ */ function(t) {
  function e() {
    return x5e(this, e), P5e(this, e, arguments);
  }
  return F5e(e, t), S5e(e, [{
    key: "render",
    value: function() {
      var n = this, A = this.props, i = A.active, o = A.allowEscapeViewBox, s = A.animationDuration, a = A.animationEasing, c = A.content, l = A.coordinate, u = A.filterNull, f = A.isAnimationActive, d = A.offset, g = A.payload, m = A.payloadUniqBy, p = A.position, v = A.reverseDirection, C = A.useTranslate3d, w = A.viewBox, B = A.wrapperStyle, y = g ?? [];
      u && y.length && (y = AQ(g.filter(function(q) {
        return q.value != null && (q.hide !== !0 || n.props.includeHidden);
      }), m, M5e));
      var b = y.length > 0;
      return /* @__PURE__ */ re.createElement(B5e, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: a,
        isAnimationActive: f,
        active: i,
        coordinate: l,
        hasPayload: b,
        offset: d,
        position: p,
        reverseDirection: v,
        useTranslate3d: C,
        viewBox: w,
        wrapperStyle: B
      }, H5e(c, yx(yx({}, this.props), {}, {
        payload: y
      })));
    }
  }]);
}(es);
xq(Ti, "displayName", "Tooltip");
xq(Ti, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Wo.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var D5e = As, Q5e = function() {
  return D5e.Date.now();
}, U5e = Q5e, N5e = /\s/;
function j5e(t) {
  for (var e = t.length; e-- && N5e.test(t.charAt(e)); )
    ;
  return e;
}
var L5e = j5e, G5e = L5e, R5e = /^\s+/;
function z5e(t) {
  return t && t.slice(0, G5e(t) + 1).replace(R5e, "");
}
var Y5e = z5e, V5e = Y5e, Cx = ec, W5e = Hd, wx = NaN, X5e = /^[-+]0x[0-9a-f]+$/i, K5e = /^0b[01]+$/i, Z5e = /^0o[0-7]+$/i, J5e = parseInt;
function _5e(t) {
  if (typeof t == "number")
    return t;
  if (W5e(t))
    return wx;
  if (Cx(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Cx(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = V5e(t);
  var r = K5e.test(t);
  return r || Z5e.test(t) ? J5e(t.slice(2), r ? 2 : 8) : X5e.test(t) ? wx : +t;
}
var gQ = _5e, $5e = ec, S6 = U5e, bx = gQ, e7e = "Expected a function", t7e = Math.max, r7e = Math.min;
function n7e(t, e, r) {
  var n, A, i, o, s, a, c = 0, l = !1, u = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(e7e);
  e = bx(e) || 0, $5e(r) && (l = !!r.leading, u = "maxWait" in r, i = u ? t7e(bx(r.maxWait) || 0, e) : i, f = "trailing" in r ? !!r.trailing : f);
  function d(b) {
    var q = n, E = A;
    return n = A = void 0, c = b, o = t.apply(E, q), o;
  }
  function g(b) {
    return c = b, s = setTimeout(v, e), l ? d(b) : o;
  }
  function m(b) {
    var q = b - a, E = b - c, x = e - q;
    return u ? r7e(x, i - E) : x;
  }
  function p(b) {
    var q = b - a, E = b - c;
    return a === void 0 || q >= e || q < 0 || u && E >= i;
  }
  function v() {
    var b = S6();
    if (p(b))
      return C(b);
    s = setTimeout(v, m(b));
  }
  function C(b) {
    return s = void 0, f && n ? d(b) : (n = A = void 0, o);
  }
  function w() {
    s !== void 0 && clearTimeout(s), c = 0, n = a = A = s = void 0;
  }
  function B() {
    return s === void 0 ? o : C(S6());
  }
  function y() {
    var b = S6(), q = p(b);
    if (n = arguments, A = this, a = b, q) {
      if (s === void 0)
        return g(a);
      if (u)
        return clearTimeout(s), s = setTimeout(v, e), d(a);
    }
    return s === void 0 && (s = setTimeout(v, e)), o;
  }
  return y.cancel = w, y.flush = B, y;
}
var A7e = n7e, i7e = A7e, o7e = ec, s7e = "Expected a function";
function a7e(t, e, r) {
  var n = !0, A = !0;
  if (typeof t != "function")
    throw new TypeError(s7e);
  return o7e(r) && (n = "leading" in r ? !!r.leading : n, A = "trailing" in r ? !!r.trailing : A), i7e(t, e, {
    leading: n,
    maxWait: e,
    trailing: A
  });
}
var c7e = a7e;
const mQ = /* @__PURE__ */ Vr(c7e);
function M2(t) {
  "@babel/helpers - typeof";
  return M2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, M2(t);
}
function Bx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Wf(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bx(Object(r), !0).forEach(function(n) {
      l7e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Bx(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function l7e(t, e, r) {
  return e = u7e(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function u7e(t) {
  var e = d7e(t, "string");
  return M2(e) == "symbol" ? e : e + "";
}
function d7e(t, e) {
  if (M2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (M2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function f7e(t, e) {
  return m7e(t) || g7e(t, e) || p7e(t, e) || h7e();
}
function h7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p7e(t, e) {
  if (t) {
    if (typeof t == "string") return Ex(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ex(t, e);
  }
}
function Ex(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function g7e(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function m7e(t) {
  if (Array.isArray(t)) return t;
}
var Iq = /* @__PURE__ */ ol(function(t, e) {
  var r = t.aspect, n = t.initialDimension, A = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = t.width, o = i === void 0 ? "100%" : i, s = t.height, a = s === void 0 ? "100%" : s, c = t.minWidth, l = c === void 0 ? 0 : c, u = t.minHeight, f = t.maxHeight, d = t.children, g = t.debounce, m = g === void 0 ? 0 : g, p = t.id, v = t.className, C = t.onResize, w = t.style, B = w === void 0 ? {} : w, y = gt(null), b = gt();
  b.current = C, fm(e, function() {
    return Object.defineProperty(y.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), y.current;
      },
      configurable: !0
    });
  });
  var q = N({
    containerWidth: A.width,
    containerHeight: A.height
  }), E = f7e(q, 2), x = E[0], M = E[1], O = Kn(function(S, P) {
    M(function(H) {
      var F = Math.round(S), T = Math.round(P);
      return H.containerWidth === F && H.containerHeight === T ? H : {
        containerWidth: F,
        containerHeight: T
      };
    });
  }, []);
  le(function() {
    var S = function(D) {
      var Q, Y = D[0].contentRect, j = Y.width, Z = Y.height;
      O(j, Z), (Q = b.current) === null || Q === void 0 || Q.call(b, j, Z);
    };
    m > 0 && (S = mQ(S, m, {
      trailing: !0,
      leading: !1
    }));
    var P = new ResizeObserver(S), H = y.current.getBoundingClientRect(), F = H.width, T = H.height;
    return O(F, T), P.observe(y.current), function() {
      P.disconnect();
    };
  }, [O, m]);
  var I = MA(function() {
    var S = x.containerWidth, P = x.containerHeight;
    if (S < 0 || P < 0)
      return null;
    Es(Bc(o) || Bc(a), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, a), Es(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var H = Bc(o) ? S : o, F = Bc(a) ? P : a;
    r && r > 0 && (H ? F = H / r : F && (H = F * r), f && F > f && (F = f)), Es(H > 0 || F > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, H, F, o, a, l, u, r);
    var T = !Array.isArray(d) && Bs(d.type).endsWith("Chart");
    return re.Children.map(d, function(U) {
      return /* @__PURE__ */ re.isValidElement(U) ? /* @__PURE__ */ vn(U, Wf({
        width: H,
        height: F
      }, T ? {
        style: Wf({
          height: "100%",
          width: "100%",
          maxHeight: F,
          maxWidth: H
        }, U.props.style)
      } : {})) : U;
    });
  }, [r, d, a, f, u, l, x, o]);
  return /* @__PURE__ */ re.createElement("div", {
    id: p ? "".concat(p) : void 0,
    className: Br("recharts-responsive-container", v),
    style: Wf(Wf({}, B), {}, {
      width: o,
      height: a,
      minWidth: l,
      minHeight: u,
      maxHeight: f
    }),
    ref: y
  }, I);
}), vQ = function(e) {
  return null;
};
vQ.displayName = "Cell";
function H2(t) {
  "@babel/helpers - typeof";
  return H2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, H2(t);
}
function xx(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function A8(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xx(Object(r), !0).forEach(function(n) {
      v7e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xx(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function v7e(t, e, r) {
  return e = q7e(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function q7e(t) {
  var e = y7e(t, "string");
  return H2(e) == "symbol" ? e : e + "";
}
function y7e(t, e) {
  if (H2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (H2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Pl = {
  widthCache: {},
  cacheCount: 0
}, C7e = 2e3, w7e = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, Ix = "recharts_measurement_span";
function b7e(t) {
  var e = A8({}, t);
  return Object.keys(e).forEach(function(r) {
    e[r] || delete e[r];
  }), e;
}
var o2 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (e == null || Wo.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = b7e(r), A = JSON.stringify({
    text: e,
    copyStyle: n
  });
  if (Pl.widthCache[A])
    return Pl.widthCache[A];
  try {
    var i = document.getElementById(Ix);
    i || (i = document.createElement("span"), i.setAttribute("id", Ix), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = A8(A8({}, w7e), n);
    Object.assign(i.style, o), i.textContent = "".concat(e);
    var s = i.getBoundingClientRect(), a = {
      width: s.width,
      height: s.height
    };
    return Pl.widthCache[A] = a, ++Pl.cacheCount > C7e && (Pl.cacheCount = 0, Pl.widthCache = {}), a;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, B7e = function(e) {
  return {
    top: e.top + window.scrollY - document.documentElement.clientTop,
    left: e.left + window.scrollX - document.documentElement.clientLeft
  };
};
function D2(t) {
  "@babel/helpers - typeof";
  return D2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, D2(t);
}
function Ap(t, e) {
  return S7e(t) || I7e(t, e) || x7e(t, e) || E7e();
}
function E7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x7e(t, e) {
  if (t) {
    if (typeof t == "string") return Sx(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Sx(t, e);
  }
}
function Sx(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function I7e(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        a = !1;
      } else for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function S7e(t) {
  if (Array.isArray(t)) return t;
}
function P7e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Px(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, O7e(n.key), n);
  }
}
function k7e(t, e, r) {
  return Px(t.prototype, e), Px(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function O7e(t) {
  var e = F7e(t, "string");
  return D2(e) == "symbol" ? e : e + "";
}
function F7e(t, e) {
  if (D2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (D2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var kx = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Ox = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, T7e = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, M7e = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, qQ = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, H7e = Object.keys(qQ), Kl = "NaN";
function D7e(t, e) {
  return t * qQ[e];
}
var Xf = /* @__PURE__ */ function() {
  function t(e, r) {
    P7e(this, t), this.num = e, this.unit = r, this.num = e, this.unit = r, Number.isNaN(e) && (this.unit = ""), r !== "" && !T7e.test(r) && (this.num = NaN, this.unit = ""), H7e.includes(r) && (this.num = D7e(e, r), this.unit = "px");
  }
  return k7e(t, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new t(NaN, "") : new t(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new t(NaN, "") : new t(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new t(NaN, "") : new t(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new t(NaN, "") : new t(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, A = (n = M7e.exec(r)) !== null && n !== void 0 ? n : [], i = Ap(A, 3), o = i[1], s = i[2];
      return new t(parseFloat(o), s ?? "");
    }
  }]);
}();
function yQ(t) {
  if (t.includes(Kl))
    return Kl;
  for (var e = t; e.includes("*") || e.includes("/"); ) {
    var r, n = (r = kx.exec(e)) !== null && r !== void 0 ? r : [], A = Ap(n, 4), i = A[1], o = A[2], s = A[3], a = Xf.parse(i ?? ""), c = Xf.parse(s ?? ""), l = o === "*" ? a.multiply(c) : a.divide(c);
    if (l.isNaN())
      return Kl;
    e = e.replace(kx, l.toString());
  }
  for (; e.includes("+") || /.-\d+(?:\.\d+)?/.test(e); ) {
    var u, f = (u = Ox.exec(e)) !== null && u !== void 0 ? u : [], d = Ap(f, 4), g = d[1], m = d[2], p = d[3], v = Xf.parse(g ?? ""), C = Xf.parse(p ?? ""), w = m === "+" ? v.add(C) : v.subtract(C);
    if (w.isNaN())
      return Kl;
    e = e.replace(Ox, w.toString());
  }
  return e;
}
var Fx = /\(([^()]*)\)/;
function Q7e(t) {
  for (var e = t; e.includes("("); ) {
    var r = Fx.exec(e), n = Ap(r, 2), A = n[1];
    e = e.replace(Fx, yQ(A));
  }
  return e;
}
function U7e(t) {
  var e = t.replace(/\s+/g, "");
  return e = Q7e(e), e = yQ(e), e;
}
function N7e(t) {
  try {
    return U7e(t);
  } catch {
    return Kl;
  }
}
function P6(t) {
  var e = N7e(t.slice(5, -1));
  return e === Kl ? "" : e;
}
var j7e = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], L7e = ["dx", "dy", "angle", "className", "breakAll"];
function i8() {
  return i8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, i8.apply(this, arguments);
}
function Tx(t, e) {
  if (t == null) return {};
  var r = G7e(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function G7e(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Mx(t, e) {
  return V7e(t) || Y7e(t, e) || z7e(t, e) || R7e();
}
function R7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function z7e(t, e) {
  if (t) {
    if (typeof t == "string") return Hx(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hx(t, e);
  }
}
function Hx(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Y7e(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        a = !1;
      } else for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function V7e(t) {
  if (Array.isArray(t)) return t;
}
var CQ = /[ \f\n\r\t\v\u2028\u2029]+/, wQ = function(e) {
  var r = e.children, n = e.breakAll, A = e.style;
  try {
    var i = [];
    hr(r) || (n ? i = r.toString().split("") : i = r.toString().split(CQ));
    var o = i.map(function(a) {
      return {
        word: a,
        width: o2(a, A).width
      };
    }), s = n ? 0 : o2(" ", A).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, W7e = function(e, r, n, A, i) {
  var o = e.maxLines, s = e.children, a = e.style, c = e.breakAll, l = At(o), u = s, f = function() {
    var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return H.reduce(function(F, T) {
      var U = T.word, D = T.width, Q = F[F.length - 1];
      if (Q && (A == null || i || Q.width + D + n < Number(A)))
        Q.words.push(U), Q.width += D + n;
      else {
        var Y = {
          words: [U],
          width: D
        };
        F.push(Y);
      }
      return F;
    }, []);
  }, d = f(r), g = function(H) {
    return H.reduce(function(F, T) {
      return F.width > T.width ? F : T;
    });
  };
  if (!l)
    return d;
  for (var m = "…", p = function(H) {
    var F = u.slice(0, H), T = wQ({
      breakAll: c,
      style: a,
      children: F + m
    }).wordsWithComputedWidth, U = f(T), D = U.length > o || g(U).width > Number(A);
    return [D, U];
  }, v = 0, C = u.length - 1, w = 0, B; v <= C && w <= u.length - 1; ) {
    var y = Math.floor((v + C) / 2), b = y - 1, q = p(b), E = Mx(q, 2), x = E[0], M = E[1], O = p(y), I = Mx(O, 1), S = I[0];
    if (!x && !S && (v = y + 1), x && S && (C = y - 1), !x && S) {
      B = M;
      break;
    }
    w++;
  }
  return B || d;
}, Dx = function(e) {
  var r = hr(e) ? [] : e.toString().split(CQ);
  return [{
    words: r
  }];
}, X7e = function(e) {
  var r = e.width, n = e.scaleToFit, A = e.children, i = e.style, o = e.breakAll, s = e.maxLines;
  if ((r || n) && !Wo.isSsr) {
    var a, c, l = wQ({
      breakAll: o,
      children: A,
      style: i
    });
    if (l) {
      var u = l.wordsWithComputedWidth, f = l.spaceWidth;
      a = u, c = f;
    } else
      return Dx(A);
    return W7e({
      breakAll: o,
      children: A,
      maxLines: s,
      style: i
    }, a, c, r, n);
  }
  return Dx(A);
}, Qx = "#808080", ip = function(e) {
  var r = e.x, n = r === void 0 ? 0 : r, A = e.y, i = A === void 0 ? 0 : A, o = e.lineHeight, s = o === void 0 ? "1em" : o, a = e.capHeight, c = a === void 0 ? "0.71em" : a, l = e.scaleToFit, u = l === void 0 ? !1 : l, f = e.textAnchor, d = f === void 0 ? "start" : f, g = e.verticalAnchor, m = g === void 0 ? "end" : g, p = e.fill, v = p === void 0 ? Qx : p, C = Tx(e, j7e), w = MA(function() {
    return X7e({
      breakAll: C.breakAll,
      children: C.children,
      maxLines: C.maxLines,
      scaleToFit: u,
      style: C.style,
      width: C.width
    });
  }, [C.breakAll, C.children, C.maxLines, u, C.style, C.width]), B = C.dx, y = C.dy, b = C.angle, q = C.className, E = C.breakAll, x = Tx(C, L7e);
  if (!$n(n) || !$n(i))
    return null;
  var M = n + (At(B) ? B : 0), O = i + (At(y) ? y : 0), I;
  switch (m) {
    case "start":
      I = P6("calc(".concat(c, ")"));
      break;
    case "middle":
      I = P6("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      I = P6("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var S = [];
  if (u) {
    var P = w[0].width, H = C.width;
    S.push("scale(".concat((At(H) ? H / P : 1) / P, ")"));
  }
  return b && S.push("rotate(".concat(b, ", ").concat(M, ", ").concat(O, ")")), S.length && (x.transform = S.join(" ")), /* @__PURE__ */ re.createElement("text", i8({}, cr(x, !0), {
    x: M,
    y: O,
    className: Br("recharts-text", q),
    textAnchor: d,
    fill: v.includes("url") ? Qx : v
  }), w.map(function(F, T) {
    var U = F.words.join(E ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ re.createElement("tspan", {
        x: M,
        dy: T === 0 ? I : s,
        key: "".concat(U, "-").concat(T)
      }, U)
    );
  }));
};
function Fa(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function K7e(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Sq(t) {
  let e, r, n;
  t.length !== 2 ? (e = Fa, r = (s, a) => Fa(t(s), a), n = (s, a) => t(s) - a) : (e = t === Fa || t === K7e ? t : Z7e, r = t, n = t);
  function A(s, a, c = 0, l = s.length) {
    if (c < l) {
      if (e(a, a) !== 0) return l;
      do {
        const u = c + l >>> 1;
        r(s[u], a) < 0 ? c = u + 1 : l = u;
      } while (c < l);
    }
    return c;
  }
  function i(s, a, c = 0, l = s.length) {
    if (c < l) {
      if (e(a, a) !== 0) return l;
      do {
        const u = c + l >>> 1;
        r(s[u], a) <= 0 ? c = u + 1 : l = u;
      } while (c < l);
    }
    return c;
  }
  function o(s, a, c = 0, l = s.length) {
    const u = A(s, a, c, l - 1);
    return u > c && n(s[u - 1], a) > -n(s[u], a) ? u - 1 : u;
  }
  return { left: A, center: o, right: i };
}
function Z7e() {
  return 0;
}
function bQ(t) {
  return t === null ? NaN : +t;
}
function* J7e(t, e) {
  for (let r of t)
    r != null && (r = +r) >= r && (yield r);
}
const _7e = Sq(Fa), Q1 = _7e.right;
Sq(bQ).center;
class Ux extends Map {
  constructor(e, r = t8e) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), e != null) for (const [n, A] of e) this.set(n, A);
  }
  get(e) {
    return super.get(Nx(this, e));
  }
  has(e) {
    return super.has(Nx(this, e));
  }
  set(e, r) {
    return super.set($7e(this, e), r);
  }
  delete(e) {
    return super.delete(e8e(this, e));
  }
}
function Nx({ _intern: t, _key: e }, r) {
  const n = e(r);
  return t.has(n) ? t.get(n) : r;
}
function $7e({ _intern: t, _key: e }, r) {
  const n = e(r);
  return t.has(n) ? t.get(n) : (t.set(n, r), r);
}
function e8e({ _intern: t, _key: e }, r) {
  const n = e(r);
  return t.has(n) && (r = t.get(n), t.delete(n)), r;
}
function t8e(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function r8e(t = Fa) {
  if (t === Fa) return BQ;
  if (typeof t != "function") throw new TypeError("compare is not a function");
  return (e, r) => {
    const n = t(e, r);
    return n || n === 0 ? n : (t(r, r) === 0) - (t(e, e) === 0);
  };
}
function BQ(t, e) {
  return (t == null || !(t >= t)) - (e == null || !(e >= e)) || (t < e ? -1 : t > e ? 1 : 0);
}
const n8e = Math.sqrt(50), A8e = Math.sqrt(10), i8e = Math.sqrt(2);
function op(t, e, r) {
  const n = (e - t) / Math.max(0, r), A = Math.floor(Math.log10(n)), i = n / Math.pow(10, A), o = i >= n8e ? 10 : i >= A8e ? 5 : i >= i8e ? 2 : 1;
  let s, a, c;
  return A < 0 ? (c = Math.pow(10, -A) / o, s = Math.round(t * c), a = Math.round(e * c), s / c < t && ++s, a / c > e && --a, c = -c) : (c = Math.pow(10, A) * o, s = Math.round(t / c), a = Math.round(e / c), s * c < t && ++s, a * c > e && --a), a < s && 0.5 <= r && r < 2 ? op(t, e, r * 2) : [s, a, c];
}
function o8(t, e, r) {
  if (e = +e, t = +t, r = +r, !(r > 0)) return [];
  if (t === e) return [t];
  const n = e < t, [A, i, o] = n ? op(e, t, r) : op(t, e, r);
  if (!(i >= A)) return [];
  const s = i - A + 1, a = new Array(s);
  if (n)
    if (o < 0) for (let c = 0; c < s; ++c) a[c] = (i - c) / -o;
    else for (let c = 0; c < s; ++c) a[c] = (i - c) * o;
  else if (o < 0) for (let c = 0; c < s; ++c) a[c] = (A + c) / -o;
  else for (let c = 0; c < s; ++c) a[c] = (A + c) * o;
  return a;
}
function s8(t, e, r) {
  return e = +e, t = +t, r = +r, op(t, e, r)[2];
}
function a8(t, e, r) {
  e = +e, t = +t, r = +r;
  const n = e < t, A = n ? s8(e, t, r) : s8(t, e, r);
  return (n ? -1 : 1) * (A < 0 ? 1 / -A : A);
}
function jx(t, e) {
  let r;
  for (const n of t)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Lx(t, e) {
  let r;
  for (const n of t)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function EQ(t, e, r = 0, n = 1 / 0, A) {
  if (e = Math.floor(e), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(t.length - 1, n)), !(r <= e && e <= n)) return t;
  for (A = A === void 0 ? BQ : r8e(A); n > r; ) {
    if (n - r > 600) {
      const a = n - r + 1, c = e - r + 1, l = Math.log(a), u = 0.5 * Math.exp(2 * l / 3), f = 0.5 * Math.sqrt(l * u * (a - u) / a) * (c - a / 2 < 0 ? -1 : 1), d = Math.max(r, Math.floor(e - c * u / a + f)), g = Math.min(n, Math.floor(e + (a - c) * u / a + f));
      EQ(t, e, d, g, A);
    }
    const i = t[e];
    let o = r, s = n;
    for (y0(t, r, e), A(t[n], i) > 0 && y0(t, r, n); o < s; ) {
      for (y0(t, o, s), ++o, --s; A(t[o], i) < 0; ) ++o;
      for (; A(t[s], i) > 0; ) --s;
    }
    A(t[r], i) === 0 ? y0(t, r, s) : (++s, y0(t, s, n)), s <= e && (r = s + 1), e <= s && (n = s - 1);
  }
  return t;
}
function y0(t, e, r) {
  const n = t[e];
  t[e] = t[r], t[r] = n;
}
function o8e(t, e, r) {
  if (t = Float64Array.from(J7e(t)), !(!(n = t.length) || isNaN(e = +e))) {
    if (e <= 0 || n < 2) return Lx(t);
    if (e >= 1) return jx(t);
    var n, A = (n - 1) * e, i = Math.floor(A), o = jx(EQ(t, i).subarray(0, i + 1)), s = Lx(t.subarray(i + 1));
    return o + (s - o) * (A - i);
  }
}
function s8e(t, e, r = bQ) {
  if (!(!(n = t.length) || isNaN(e = +e))) {
    if (e <= 0 || n < 2) return +r(t[0], 0, t);
    if (e >= 1) return +r(t[n - 1], n - 1, t);
    var n, A = (n - 1) * e, i = Math.floor(A), o = +r(t[i], i, t), s = +r(t[i + 1], i + 1, t);
    return o + (s - o) * (A - i);
  }
}
function a8e(t, e, r) {
  t = +t, e = +e, r = (A = arguments.length) < 2 ? (e = t, t = 0, 1) : A < 3 ? 1 : +r;
  for (var n = -1, A = Math.max(0, Math.ceil((e - t) / r)) | 0, i = new Array(A); ++n < A; )
    i[n] = t + n * r;
  return i;
}
function Xi(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function Vs(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const c8 = Symbol("implicit");
function Pq() {
  var t = new Ux(), e = [], r = [], n = c8;
  function A(i) {
    let o = t.get(i);
    if (o === void 0) {
      if (n !== c8) return n;
      t.set(i, o = e.push(i) - 1);
    }
    return r[o % r.length];
  }
  return A.domain = function(i) {
    if (!arguments.length) return e.slice();
    e = [], t = new Ux();
    for (const o of i)
      t.has(o) || t.set(o, e.push(o) - 1);
    return A;
  }, A.range = function(i) {
    return arguments.length ? (r = Array.from(i), A) : r.slice();
  }, A.unknown = function(i) {
    return arguments.length ? (n = i, A) : n;
  }, A.copy = function() {
    return Pq(e, r).unknown(n);
  }, Xi.apply(A, arguments), A;
}
function Q2() {
  var t = Pq().unknown(void 0), e = t.domain, r = t.range, n = 0, A = 1, i, o, s = !1, a = 0, c = 0, l = 0.5;
  delete t.unknown;
  function u() {
    var f = e().length, d = A < n, g = d ? A : n, m = d ? n : A;
    i = (m - g) / Math.max(1, f - a + c * 2), s && (i = Math.floor(i)), g += (m - g - i * (f - a)) * l, o = i * (1 - a), s && (g = Math.round(g), o = Math.round(o));
    var p = a8e(f).map(function(v) {
      return g + i * v;
    });
    return r(d ? p.reverse() : p);
  }
  return t.domain = function(f) {
    return arguments.length ? (e(f), u()) : e();
  }, t.range = function(f) {
    return arguments.length ? ([n, A] = f, n = +n, A = +A, u()) : [n, A];
  }, t.rangeRound = function(f) {
    return [n, A] = f, n = +n, A = +A, s = !0, u();
  }, t.bandwidth = function() {
    return o;
  }, t.step = function() {
    return i;
  }, t.round = function(f) {
    return arguments.length ? (s = !!f, u()) : s;
  }, t.padding = function(f) {
    return arguments.length ? (a = Math.min(1, c = +f), u()) : a;
  }, t.paddingInner = function(f) {
    return arguments.length ? (a = Math.min(1, f), u()) : a;
  }, t.paddingOuter = function(f) {
    return arguments.length ? (c = +f, u()) : c;
  }, t.align = function(f) {
    return arguments.length ? (l = Math.max(0, Math.min(1, f)), u()) : l;
  }, t.copy = function() {
    return Q2(e(), [n, A]).round(s).paddingInner(a).paddingOuter(c).align(l);
  }, Xi.apply(u(), arguments);
}
function xQ(t) {
  var e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function() {
    return xQ(e());
  }, t;
}
function s2() {
  return xQ(Q2.apply(null, arguments).paddingInner(1));
}
function kq(t, e, r) {
  t.prototype = e.prototype = r, r.constructor = t;
}
function IQ(t, e) {
  var r = Object.create(t.prototype);
  for (var n in e) r[n] = e[n];
  return r;
}
function U1() {
}
var U2 = 0.7, sp = 1 / U2, lu = "\\s*([+-]?\\d+)\\s*", N2 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Xo = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", c8e = /^#([0-9a-f]{3,8})$/, l8e = new RegExp(`^rgb\\(${lu},${lu},${lu}\\)$`), u8e = new RegExp(`^rgb\\(${Xo},${Xo},${Xo}\\)$`), d8e = new RegExp(`^rgba\\(${lu},${lu},${lu},${N2}\\)$`), f8e = new RegExp(`^rgba\\(${Xo},${Xo},${Xo},${N2}\\)$`), h8e = new RegExp(`^hsl\\(${N2},${Xo},${Xo}\\)$`), p8e = new RegExp(`^hsla\\(${N2},${Xo},${Xo},${N2}\\)$`), Gx = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
kq(U1, j2, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Rx,
  // Deprecated! Use color.formatHex.
  formatHex: Rx,
  formatHex8: g8e,
  formatHsl: m8e,
  formatRgb: zx,
  toString: zx
});
function Rx() {
  return this.rgb().formatHex();
}
function g8e() {
  return this.rgb().formatHex8();
}
function m8e() {
  return SQ(this).formatHsl();
}
function zx() {
  return this.rgb().formatRgb();
}
function j2(t) {
  var e, r;
  return t = (t + "").trim().toLowerCase(), (e = c8e.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), r === 6 ? Yx(e) : r === 3 ? new oi(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : r === 8 ? Kf(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : r === 4 ? Kf(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = l8e.exec(t)) ? new oi(e[1], e[2], e[3], 1) : (e = u8e.exec(t)) ? new oi(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = d8e.exec(t)) ? Kf(e[1], e[2], e[3], e[4]) : (e = f8e.exec(t)) ? Kf(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = h8e.exec(t)) ? Xx(e[1], e[2] / 100, e[3] / 100, 1) : (e = p8e.exec(t)) ? Xx(e[1], e[2] / 100, e[3] / 100, e[4]) : Gx.hasOwnProperty(t) ? Yx(Gx[t]) : t === "transparent" ? new oi(NaN, NaN, NaN, 0) : null;
}
function Yx(t) {
  return new oi(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Kf(t, e, r, n) {
  return n <= 0 && (t = e = r = NaN), new oi(t, e, r, n);
}
function v8e(t) {
  return t instanceof U1 || (t = j2(t)), t ? (t = t.rgb(), new oi(t.r, t.g, t.b, t.opacity)) : new oi();
}
function l8(t, e, r, n) {
  return arguments.length === 1 ? v8e(t) : new oi(t, e, r, n ?? 1);
}
function oi(t, e, r, n) {
  this.r = +t, this.g = +e, this.b = +r, this.opacity = +n;
}
kq(oi, l8, IQ(U1, {
  brighter(t) {
    return t = t == null ? sp : Math.pow(sp, t), new oi(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? U2 : Math.pow(U2, t), new oi(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new oi(jc(this.r), jc(this.g), jc(this.b), ap(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Vx,
  // Deprecated! Use color.formatHex.
  formatHex: Vx,
  formatHex8: q8e,
  formatRgb: Wx,
  toString: Wx
}));
function Vx() {
  return `#${Ec(this.r)}${Ec(this.g)}${Ec(this.b)}`;
}
function q8e() {
  return `#${Ec(this.r)}${Ec(this.g)}${Ec(this.b)}${Ec((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Wx() {
  const t = ap(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${jc(this.r)}, ${jc(this.g)}, ${jc(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function ap(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function jc(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function Ec(t) {
  return t = jc(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Xx(t, e, r, n) {
  return n <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new co(t, e, r, n);
}
function SQ(t) {
  if (t instanceof co) return new co(t.h, t.s, t.l, t.opacity);
  if (t instanceof U1 || (t = j2(t)), !t) return new co();
  if (t instanceof co) return t;
  t = t.rgb();
  var e = t.r / 255, r = t.g / 255, n = t.b / 255, A = Math.min(e, r, n), i = Math.max(e, r, n), o = NaN, s = i - A, a = (i + A) / 2;
  return s ? (e === i ? o = (r - n) / s + (r < n) * 6 : r === i ? o = (n - e) / s + 2 : o = (e - r) / s + 4, s /= a < 0.5 ? i + A : 2 - i - A, o *= 60) : s = a > 0 && a < 1 ? 0 : o, new co(o, s, a, t.opacity);
}
function y8e(t, e, r, n) {
  return arguments.length === 1 ? SQ(t) : new co(t, e, r, n ?? 1);
}
function co(t, e, r, n) {
  this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
}
kq(co, y8e, IQ(U1, {
  brighter(t) {
    return t = t == null ? sp : Math.pow(sp, t), new co(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? U2 : Math.pow(U2, t), new co(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * e, A = 2 * r - n;
    return new oi(
      k6(t >= 240 ? t - 240 : t + 120, A, n),
      k6(t, A, n),
      k6(t < 120 ? t + 240 : t - 120, A, n),
      this.opacity
    );
  },
  clamp() {
    return new co(Kx(this.h), Zf(this.s), Zf(this.l), ap(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = ap(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Kx(this.h)}, ${Zf(this.s) * 100}%, ${Zf(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Kx(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Zf(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function k6(t, e, r) {
  return (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e) * 255;
}
const Oq = (t) => () => t;
function C8e(t, e) {
  return function(r) {
    return t + r * e;
  };
}
function w8e(t, e, r) {
  return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function(n) {
    return Math.pow(t + n * e, r);
  };
}
function b8e(t) {
  return (t = +t) == 1 ? PQ : function(e, r) {
    return r - e ? w8e(e, r, t) : Oq(isNaN(e) ? r : e);
  };
}
function PQ(t, e) {
  var r = e - t;
  return r ? C8e(t, r) : Oq(isNaN(t) ? e : t);
}
const Zx = function t(e) {
  var r = b8e(e);
  function n(A, i) {
    var o = r((A = l8(A)).r, (i = l8(i)).r), s = r(A.g, i.g), a = r(A.b, i.b), c = PQ(A.opacity, i.opacity);
    return function(l) {
      return A.r = o(l), A.g = s(l), A.b = a(l), A.opacity = c(l), A + "";
    };
  }
  return n.gamma = t, n;
}(1);
function B8e(t, e) {
  e || (e = []);
  var r = t ? Math.min(e.length, t.length) : 0, n = e.slice(), A;
  return function(i) {
    for (A = 0; A < r; ++A) n[A] = t[A] * (1 - i) + e[A] * i;
    return n;
  };
}
function E8e(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function x8e(t, e) {
  var r = e ? e.length : 0, n = t ? Math.min(r, t.length) : 0, A = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o) A[o] = Yd(t[o], e[o]);
  for (; o < r; ++o) i[o] = e[o];
  return function(s) {
    for (o = 0; o < n; ++o) i[o] = A[o](s);
    return i;
  };
}
function I8e(t, e) {
  var r = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(n) {
    return r.setTime(t * (1 - n) + e * n), r;
  };
}
function cp(t, e) {
  return t = +t, e = +e, function(r) {
    return t * (1 - r) + e * r;
  };
}
function S8e(t, e) {
  var r = {}, n = {}, A;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (A in e)
    A in t ? r[A] = Yd(t[A], e[A]) : n[A] = e[A];
  return function(i) {
    for (A in r) n[A] = r[A](i);
    return n;
  };
}
var u8 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, O6 = new RegExp(u8.source, "g");
function P8e(t) {
  return function() {
    return t;
  };
}
function k8e(t) {
  return function(e) {
    return t(e) + "";
  };
}
function O8e(t, e) {
  var r = u8.lastIndex = O6.lastIndex = 0, n, A, i, o = -1, s = [], a = [];
  for (t = t + "", e = e + ""; (n = u8.exec(t)) && (A = O6.exec(e)); )
    (i = A.index) > r && (i = e.slice(r, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (A = A[0]) ? s[o] ? s[o] += A : s[++o] = A : (s[++o] = null, a.push({ i: o, x: cp(n, A) })), r = O6.lastIndex;
  return r < e.length && (i = e.slice(r), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? a[0] ? k8e(a[0].x) : P8e(e) : (e = a.length, function(c) {
    for (var l = 0, u; l < e; ++l) s[(u = a[l]).i] = u.x(c);
    return s.join("");
  });
}
function Yd(t, e) {
  var r = typeof e, n;
  return e == null || r === "boolean" ? Oq(e) : (r === "number" ? cp : r === "string" ? (n = j2(e)) ? (e = n, Zx) : O8e : e instanceof j2 ? Zx : e instanceof Date ? I8e : E8e(e) ? B8e : Array.isArray(e) ? x8e : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? S8e : cp)(t, e);
}
function Fq(t, e) {
  return t = +t, e = +e, function(r) {
    return Math.round(t * (1 - r) + e * r);
  };
}
function F8e(t, e) {
  e === void 0 && (e = t, t = Yd);
  for (var r = 0, n = e.length - 1, A = e[0], i = new Array(n < 0 ? 0 : n); r < n; ) i[r] = t(A, A = e[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[s](o - s);
  };
}
function T8e(t) {
  return function() {
    return t;
  };
}
function lp(t) {
  return +t;
}
var Jx = [0, 1];
function XA(t) {
  return t;
}
function d8(t, e) {
  return (e -= t = +t) ? function(r) {
    return (r - t) / e;
  } : T8e(isNaN(e) ? NaN : 0.5);
}
function M8e(t, e) {
  var r;
  return t > e && (r = t, t = e, e = r), function(n) {
    return Math.max(t, Math.min(e, n));
  };
}
function H8e(t, e, r) {
  var n = t[0], A = t[1], i = e[0], o = e[1];
  return A < n ? (n = d8(A, n), i = r(o, i)) : (n = d8(n, A), i = r(i, o)), function(s) {
    return i(n(s));
  };
}
function D8e(t, e, r) {
  var n = Math.min(t.length, e.length) - 1, A = new Array(n), i = new Array(n), o = -1;
  for (t[n] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < n; )
    A[o] = d8(t[o], t[o + 1]), i[o] = r(e[o], e[o + 1]);
  return function(s) {
    var a = Q1(t, s, 1, n) - 1;
    return i[a](A[a](s));
  };
}
function N1(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function Q4() {
  var t = Jx, e = Jx, r = Yd, n, A, i, o = XA, s, a, c;
  function l() {
    var f = Math.min(t.length, e.length);
    return o !== XA && (o = M8e(t[0], t[f - 1])), s = f > 2 ? D8e : H8e, a = c = null, u;
  }
  function u(f) {
    return f == null || isNaN(f = +f) ? i : (a || (a = s(t.map(n), e, r)))(n(o(f)));
  }
  return u.invert = function(f) {
    return o(A((c || (c = s(e, t.map(n), cp)))(f)));
  }, u.domain = function(f) {
    return arguments.length ? (t = Array.from(f, lp), l()) : t.slice();
  }, u.range = function(f) {
    return arguments.length ? (e = Array.from(f), l()) : e.slice();
  }, u.rangeRound = function(f) {
    return e = Array.from(f), r = Fq, l();
  }, u.clamp = function(f) {
    return arguments.length ? (o = f ? !0 : XA, l()) : o !== XA;
  }, u.interpolate = function(f) {
    return arguments.length ? (r = f, l()) : r;
  }, u.unknown = function(f) {
    return arguments.length ? (i = f, u) : i;
  }, function(f, d) {
    return n = f, A = d, l();
  };
}
function Tq() {
  return Q4()(XA, XA);
}
function Q8e(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function up(t, e) {
  if ((r = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var r, n = t.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +t.slice(r + 1)
  ];
}
function Wu(t) {
  return t = up(Math.abs(t)), t ? t[1] : NaN;
}
function U8e(t, e) {
  return function(r, n) {
    for (var A = r.length, i = [], o = 0, s = t[0], a = 0; A > 0 && s > 0 && (a + s + 1 > n && (s = Math.max(1, n - a)), i.push(r.substring(A -= s, A + s)), !((a += s + 1) > n)); )
      s = t[o = (o + 1) % t.length];
    return i.reverse().join(e);
  };
}
function N8e(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(r) {
      return t[+r];
    });
  };
}
var j8e = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function L2(t) {
  if (!(e = j8e.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new Mq({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
L2.prototype = Mq.prototype;
function Mq(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Mq.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function L8e(t) {
  e: for (var e = t.length, r = 1, n = -1, A; r < e; ++r)
    switch (t[r]) {
      case ".":
        n = A = r;
        break;
      case "0":
        n === 0 && (n = r), A = r;
        break;
      default:
        if (!+t[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? t.slice(0, n) + t.slice(A + 1) : t;
}
var kQ;
function G8e(t, e) {
  var r = up(t, e);
  if (!r) return t + "";
  var n = r[0], A = r[1], i = A - (kQ = Math.max(-8, Math.min(8, Math.floor(A / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + up(t, Math.max(0, e + i - 1))[0];
}
function _x(t, e) {
  var r = up(t, e);
  if (!r) return t + "";
  var n = r[0], A = r[1];
  return A < 0 ? "0." + new Array(-A).join("0") + n : n.length > A + 1 ? n.slice(0, A + 1) + "." + n.slice(A + 1) : n + new Array(A - n.length + 2).join("0");
}
const $x = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: Q8e,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => _x(t * 100, e),
  r: _x,
  s: G8e,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function eI(t) {
  return t;
}
var tI = Array.prototype.map, rI = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function R8e(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? eI : U8e(tI.call(t.grouping, Number), t.thousands + ""), r = t.currency === void 0 ? "" : t.currency[0] + "", n = t.currency === void 0 ? "" : t.currency[1] + "", A = t.decimal === void 0 ? "." : t.decimal + "", i = t.numerals === void 0 ? eI : N8e(tI.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "−" : t.minus + "", a = t.nan === void 0 ? "NaN" : t.nan + "";
  function c(u) {
    u = L2(u);
    var f = u.fill, d = u.align, g = u.sign, m = u.symbol, p = u.zero, v = u.width, C = u.comma, w = u.precision, B = u.trim, y = u.type;
    y === "n" ? (C = !0, y = "g") : $x[y] || (w === void 0 && (w = 12), B = !0, y = "g"), (p || f === "0" && d === "=") && (p = !0, f = "0", d = "=");
    var b = m === "$" ? r : m === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "", q = m === "$" ? n : /[%p]/.test(y) ? o : "", E = $x[y], x = /[defgprs%]/.test(y);
    w = w === void 0 ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function M(O) {
      var I = b, S = q, P, H, F;
      if (y === "c")
        S = E(O) + S, O = "";
      else {
        O = +O;
        var T = O < 0 || 1 / O < 0;
        if (O = isNaN(O) ? a : E(Math.abs(O), w), B && (O = L8e(O)), T && +O == 0 && g !== "+" && (T = !1), I = (T ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + I, S = (y === "s" ? rI[8 + kQ / 3] : "") + S + (T && g === "(" ? ")" : ""), x) {
          for (P = -1, H = O.length; ++P < H; )
            if (F = O.charCodeAt(P), 48 > F || F > 57) {
              S = (F === 46 ? A + O.slice(P + 1) : O.slice(P)) + S, O = O.slice(0, P);
              break;
            }
        }
      }
      C && !p && (O = e(O, 1 / 0));
      var U = I.length + O.length + S.length, D = U < v ? new Array(v - U + 1).join(f) : "";
      switch (C && p && (O = e(D + O, D.length ? v - S.length : 1 / 0), D = ""), d) {
        case "<":
          O = I + O + S + D;
          break;
        case "=":
          O = I + D + O + S;
          break;
        case "^":
          O = D.slice(0, U = D.length >> 1) + I + O + S + D.slice(U);
          break;
        default:
          O = D + I + O + S;
          break;
      }
      return i(O);
    }
    return M.toString = function() {
      return u + "";
    }, M;
  }
  function l(u, f) {
    var d = c((u = L2(u), u.type = "f", u)), g = Math.max(-8, Math.min(8, Math.floor(Wu(f) / 3))) * 3, m = Math.pow(10, -g), p = rI[8 + g / 3];
    return function(v) {
      return d(m * v) + p;
    };
  }
  return {
    format: c,
    formatPrefix: l
  };
}
var Jf, Hq, OQ;
z8e({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function z8e(t) {
  return Jf = R8e(t), Hq = Jf.format, OQ = Jf.formatPrefix, Jf;
}
function Y8e(t) {
  return Math.max(0, -Wu(Math.abs(t)));
}
function V8e(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Wu(e) / 3))) * 3 - Wu(Math.abs(t)));
}
function W8e(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Wu(e) - Wu(t)) + 1;
}
function FQ(t, e, r, n) {
  var A = a8(t, e, r), i;
  switch (n = L2(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return n.precision == null && !isNaN(i = V8e(A, o)) && (n.precision = i), OQ(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = W8e(A, Math.max(Math.abs(t), Math.abs(e)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = Y8e(A)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return Hq(n);
}
function rc(t) {
  var e = t.domain;
  return t.ticks = function(r) {
    var n = e();
    return o8(n[0], n[n.length - 1], r ?? 10);
  }, t.tickFormat = function(r, n) {
    var A = e();
    return FQ(A[0], A[A.length - 1], r ?? 10, n);
  }, t.nice = function(r) {
    r == null && (r = 10);
    var n = e(), A = 0, i = n.length - 1, o = n[A], s = n[i], a, c, l = 10;
    for (s < o && (c = o, o = s, s = c, c = A, A = i, i = c); l-- > 0; ) {
      if (c = s8(o, s, r), c === a)
        return n[A] = o, n[i] = s, e(n);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      a = c;
    }
    return t;
  }, t;
}
function dp() {
  var t = Tq();
  return t.copy = function() {
    return N1(t, dp());
  }, Xi.apply(t, arguments), rc(t);
}
function TQ(t) {
  var e;
  function r(n) {
    return n == null || isNaN(n = +n) ? e : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (t = Array.from(n, lp), r) : t.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (e = n, r) : e;
  }, r.copy = function() {
    return TQ(t).unknown(e);
  }, t = arguments.length ? Array.from(t, lp) : [0, 1], rc(r);
}
function MQ(t, e) {
  t = t.slice();
  var r = 0, n = t.length - 1, A = t[r], i = t[n], o;
  return i < A && (o = r, r = n, n = o, o = A, A = i, i = o), t[r] = e.floor(A), t[n] = e.ceil(i), t;
}
function nI(t) {
  return Math.log(t);
}
function AI(t) {
  return Math.exp(t);
}
function X8e(t) {
  return -Math.log(-t);
}
function K8e(t) {
  return -Math.exp(-t);
}
function Z8e(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function J8e(t) {
  return t === 10 ? Z8e : t === Math.E ? Math.exp : (e) => Math.pow(t, e);
}
function _8e(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), (e) => Math.log(e) / t);
}
function iI(t) {
  return (e, r) => -t(-e, r);
}
function Dq(t) {
  const e = t(nI, AI), r = e.domain;
  let n = 10, A, i;
  function o() {
    return A = _8e(n), i = J8e(n), r()[0] < 0 ? (A = iI(A), i = iI(i), t(X8e, K8e)) : t(nI, AI), e;
  }
  return e.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, e.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, e.ticks = (s) => {
    const a = r();
    let c = a[0], l = a[a.length - 1];
    const u = l < c;
    u && ([c, l] = [l, c]);
    let f = A(c), d = A(l), g, m;
    const p = s == null ? 10 : +s;
    let v = [];
    if (!(n % 1) && d - f < p) {
      if (f = Math.floor(f), d = Math.ceil(d), c > 0) {
        for (; f <= d; ++f)
          for (g = 1; g < n; ++g)
            if (m = f < 0 ? g / i(-f) : g * i(f), !(m < c)) {
              if (m > l) break;
              v.push(m);
            }
      } else for (; f <= d; ++f)
        for (g = n - 1; g >= 1; --g)
          if (m = f > 0 ? g / i(-f) : g * i(f), !(m < c)) {
            if (m > l) break;
            v.push(m);
          }
      v.length * 2 < p && (v = o8(c, l, p));
    } else
      v = o8(f, d, Math.min(d - f, p)).map(i);
    return u ? v.reverse() : v;
  }, e.tickFormat = (s, a) => {
    if (s == null && (s = 10), a == null && (a = n === 10 ? "s" : ","), typeof a != "function" && (!(n % 1) && (a = L2(a)).precision == null && (a.trim = !0), a = Hq(a)), s === 1 / 0) return a;
    const c = Math.max(1, n * s / e.ticks().length);
    return (l) => {
      let u = l / i(Math.round(A(l)));
      return u * n < n - 0.5 && (u *= n), u <= c ? a(l) : "";
    };
  }, e.nice = () => r(MQ(r(), {
    floor: (s) => i(Math.floor(A(s))),
    ceil: (s) => i(Math.ceil(A(s)))
  })), e;
}
function HQ() {
  const t = Dq(Q4()).domain([1, 10]);
  return t.copy = () => N1(t, HQ()).base(t.base()), Xi.apply(t, arguments), t;
}
function oI(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function sI(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function Qq(t) {
  var e = 1, r = t(oI(e), sI(e));
  return r.constant = function(n) {
    return arguments.length ? t(oI(e = +n), sI(e)) : e;
  }, rc(r);
}
function DQ() {
  var t = Qq(Q4());
  return t.copy = function() {
    return N1(t, DQ()).constant(t.constant());
  }, Xi.apply(t, arguments);
}
function aI(t) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
  };
}
function $8e(t) {
  return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
}
function eme(t) {
  return t < 0 ? -t * t : t * t;
}
function Uq(t) {
  var e = t(XA, XA), r = 1;
  function n() {
    return r === 1 ? t(XA, XA) : r === 0.5 ? t($8e, eme) : t(aI(r), aI(1 / r));
  }
  return e.exponent = function(A) {
    return arguments.length ? (r = +A, n()) : r;
  }, rc(e);
}
function Nq() {
  var t = Uq(Q4());
  return t.copy = function() {
    return N1(t, Nq()).exponent(t.exponent());
  }, Xi.apply(t, arguments), t;
}
function tme() {
  return Nq.apply(null, arguments).exponent(0.5);
}
function cI(t) {
  return Math.sign(t) * t * t;
}
function rme(t) {
  return Math.sign(t) * Math.sqrt(Math.abs(t));
}
function QQ() {
  var t = Tq(), e = [0, 1], r = !1, n;
  function A(i) {
    var o = rme(t(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return A.invert = function(i) {
    return t.invert(cI(i));
  }, A.domain = function(i) {
    return arguments.length ? (t.domain(i), A) : t.domain();
  }, A.range = function(i) {
    return arguments.length ? (t.range((e = Array.from(i, lp)).map(cI)), A) : e.slice();
  }, A.rangeRound = function(i) {
    return A.range(i).round(!0);
  }, A.round = function(i) {
    return arguments.length ? (r = !!i, A) : r;
  }, A.clamp = function(i) {
    return arguments.length ? (t.clamp(i), A) : t.clamp();
  }, A.unknown = function(i) {
    return arguments.length ? (n = i, A) : n;
  }, A.copy = function() {
    return QQ(t.domain(), e).round(r).clamp(t.clamp()).unknown(n);
  }, Xi.apply(A, arguments), rc(A);
}
function UQ() {
  var t = [], e = [], r = [], n;
  function A() {
    var o = 0, s = Math.max(1, e.length);
    for (r = new Array(s - 1); ++o < s; ) r[o - 1] = s8e(t, o / s);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : e[Q1(r, o)];
  }
  return i.invertExtent = function(o) {
    var s = e.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : t[0],
      s < r.length ? r[s] : t[t.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let s of o) s != null && !isNaN(s = +s) && t.push(s);
    return t.sort(Fa), A();
  }, i.range = function(o) {
    return arguments.length ? (e = Array.from(o), A()) : e.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return UQ().domain(t).range(e).unknown(n);
  }, Xi.apply(i, arguments);
}
function NQ() {
  var t = 0, e = 1, r = 1, n = [0.5], A = [0, 1], i;
  function o(a) {
    return a != null && a <= a ? A[Q1(n, a, 0, r)] : i;
  }
  function s() {
    var a = -1;
    for (n = new Array(r); ++a < r; ) n[a] = ((a + 1) * e - (a - r) * t) / (r + 1);
    return o;
  }
  return o.domain = function(a) {
    return arguments.length ? ([t, e] = a, t = +t, e = +e, s()) : [t, e];
  }, o.range = function(a) {
    return arguments.length ? (r = (A = Array.from(a)).length - 1, s()) : A.slice();
  }, o.invertExtent = function(a) {
    var c = A.indexOf(a);
    return c < 0 ? [NaN, NaN] : c < 1 ? [t, n[0]] : c >= r ? [n[r - 1], e] : [n[c - 1], n[c]];
  }, o.unknown = function(a) {
    return arguments.length && (i = a), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return NQ().domain([t, e]).range(A).unknown(i);
  }, Xi.apply(rc(o), arguments);
}
function jQ() {
  var t = [0.5], e = [0, 1], r, n = 1;
  function A(i) {
    return i != null && i <= i ? e[Q1(t, i, 0, n)] : r;
  }
  return A.domain = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(t.length, e.length - 1), A) : t.slice();
  }, A.range = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(t.length, e.length - 1), A) : e.slice();
  }, A.invertExtent = function(i) {
    var o = e.indexOf(i);
    return [t[o - 1], t[o]];
  }, A.unknown = function(i) {
    return arguments.length ? (r = i, A) : r;
  }, A.copy = function() {
    return jQ().domain(t).range(e).unknown(r);
  }, Xi.apply(A, arguments);
}
const F6 = /* @__PURE__ */ new Date(), T6 = /* @__PURE__ */ new Date();
function eA(t, e, r, n) {
  function A(i) {
    return t(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return A.floor = (i) => (t(i = /* @__PURE__ */ new Date(+i)), i), A.ceil = (i) => (t(i = new Date(i - 1)), e(i, 1), t(i), i), A.round = (i) => {
    const o = A(i), s = A.ceil(i);
    return i - o < s - i ? o : s;
  }, A.offset = (i, o) => (e(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), A.range = (i, o, s) => {
    const a = [];
    if (i = A.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < o) || !(s > 0)) return a;
    let c;
    do
      a.push(c = /* @__PURE__ */ new Date(+i)), e(i, s), t(i);
    while (c < i && i < o);
    return a;
  }, A.filter = (i) => eA((o) => {
    if (o >= o) for (; t(o), !i(o); ) o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0) for (; ++s <= 0; )
        for (; e(o, -1), !i(o); )
          ;
      else for (; --s >= 0; )
        for (; e(o, 1), !i(o); )
          ;
  }), r && (A.count = (i, o) => (F6.setTime(+i), T6.setTime(+o), t(F6), t(T6), Math.floor(r(F6, T6))), A.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? A.filter(n ? (o) => n(o) % i === 0 : (o) => A.count(0, o) % i === 0) : A)), A;
}
const fp = eA(() => {
}, (t, e) => {
  t.setTime(+t + e);
}, (t, e) => e - t);
fp.every = (t) => (t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? eA((e) => {
  e.setTime(Math.floor(e / t) * t);
}, (e, r) => {
  e.setTime(+e + r * t);
}, (e, r) => (r - e) / t) : fp);
fp.range;
const gs = 1e3, Ni = gs * 60, ms = Ni * 60, Qs = ms * 24, jq = Qs * 7, lI = Qs * 30, M6 = Qs * 365, xc = eA((t) => {
  t.setTime(t - t.getMilliseconds());
}, (t, e) => {
  t.setTime(+t + e * gs);
}, (t, e) => (e - t) / gs, (t) => t.getUTCSeconds());
xc.range;
const Lq = eA((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * gs);
}, (t, e) => {
  t.setTime(+t + e * Ni);
}, (t, e) => (e - t) / Ni, (t) => t.getMinutes());
Lq.range;
const Gq = eA((t) => {
  t.setUTCSeconds(0, 0);
}, (t, e) => {
  t.setTime(+t + e * Ni);
}, (t, e) => (e - t) / Ni, (t) => t.getUTCMinutes());
Gq.range;
const Rq = eA((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * gs - t.getMinutes() * Ni);
}, (t, e) => {
  t.setTime(+t + e * ms);
}, (t, e) => (e - t) / ms, (t) => t.getHours());
Rq.range;
const zq = eA((t) => {
  t.setUTCMinutes(0, 0, 0);
}, (t, e) => {
  t.setTime(+t + e * ms);
}, (t, e) => (e - t) / ms, (t) => t.getUTCHours());
zq.range;
const j1 = eA(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Ni) / Qs,
  (t) => t.getDate() - 1
);
j1.range;
const U4 = eA((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / Qs, (t) => t.getUTCDate() - 1);
U4.range;
const LQ = eA((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / Qs, (t) => Math.floor(t / Qs));
LQ.range;
function fl(t) {
  return eA((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, (e, r) => {
    e.setDate(e.getDate() + r * 7);
  }, (e, r) => (r - e - (r.getTimezoneOffset() - e.getTimezoneOffset()) * Ni) / jq);
}
const N4 = fl(0), hp = fl(1), nme = fl(2), Ame = fl(3), Xu = fl(4), ime = fl(5), ome = fl(6);
N4.range;
hp.range;
nme.range;
Ame.range;
Xu.range;
ime.range;
ome.range;
function hl(t) {
  return eA((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, r) => {
    e.setUTCDate(e.getUTCDate() + r * 7);
  }, (e, r) => (r - e) / jq);
}
const j4 = hl(0), pp = hl(1), sme = hl(2), ame = hl(3), Ku = hl(4), cme = hl(5), lme = hl(6);
j4.range;
pp.range;
sme.range;
ame.range;
Ku.range;
cme.range;
lme.range;
const Yq = eA((t) => {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setMonth(t.getMonth() + e);
}, (t, e) => e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12, (t) => t.getMonth());
Yq.range;
const Vq = eA((t) => {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCMonth(t.getUTCMonth() + e);
}, (t, e) => e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12, (t) => t.getUTCMonth());
Vq.range;
const Us = eA((t) => {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setFullYear(t.getFullYear() + e);
}, (t, e) => e.getFullYear() - t.getFullYear(), (t) => t.getFullYear());
Us.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : eA((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, r) => {
  e.setFullYear(e.getFullYear() + r * t);
});
Us.range;
const Ns = eA((t) => {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, (t, e) => e.getUTCFullYear() - t.getUTCFullYear(), (t) => t.getUTCFullYear());
Ns.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : eA((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCFullYear(e.getUTCFullYear() + r * t);
});
Ns.range;
function GQ(t, e, r, n, A, i) {
  const o = [
    [xc, 1, gs],
    [xc, 5, 5 * gs],
    [xc, 15, 15 * gs],
    [xc, 30, 30 * gs],
    [i, 1, Ni],
    [i, 5, 5 * Ni],
    [i, 15, 15 * Ni],
    [i, 30, 30 * Ni],
    [A, 1, ms],
    [A, 3, 3 * ms],
    [A, 6, 6 * ms],
    [A, 12, 12 * ms],
    [n, 1, Qs],
    [n, 2, 2 * Qs],
    [r, 1, jq],
    [e, 1, lI],
    [e, 3, 3 * lI],
    [t, 1, M6]
  ];
  function s(c, l, u) {
    const f = l < c;
    f && ([c, l] = [l, c]);
    const d = u && typeof u.range == "function" ? u : a(c, l, u), g = d ? d.range(c, +l + 1) : [];
    return f ? g.reverse() : g;
  }
  function a(c, l, u) {
    const f = Math.abs(l - c) / u, d = Sq(([, , p]) => p).right(o, f);
    if (d === o.length) return t.every(a8(c / M6, l / M6, u));
    if (d === 0) return fp.every(Math.max(a8(c, l, u), 1));
    const [g, m] = o[f / o[d - 1][2] < o[d][2] / f ? d - 1 : d];
    return g.every(m);
  }
  return [s, a];
}
const [ume, dme] = GQ(Ns, Vq, j4, LQ, zq, Gq), [fme, hme] = GQ(Us, Yq, N4, j1, Rq, Lq);
function H6(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function D6(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function C0(t, e, r) {
  return { y: t, m: e, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function pme(t) {
  var e = t.dateTime, r = t.date, n = t.time, A = t.periods, i = t.days, o = t.shortDays, s = t.months, a = t.shortMonths, c = w0(A), l = b0(A), u = w0(i), f = b0(i), d = w0(o), g = b0(o), m = w0(s), p = b0(s), v = w0(a), C = b0(a), w = {
    a: T,
    A: U,
    b: D,
    B: Q,
    c: null,
    d: gI,
    e: gI,
    f: Ume,
    g: Xme,
    G: Zme,
    H: Hme,
    I: Dme,
    j: Qme,
    L: RQ,
    m: Nme,
    M: jme,
    p: Y,
    q: j,
    Q: qI,
    s: yI,
    S: Lme,
    u: Gme,
    U: Rme,
    V: zme,
    w: Yme,
    W: Vme,
    x: null,
    X: null,
    y: Wme,
    Y: Kme,
    Z: Jme,
    "%": vI
  }, B = {
    a: Z,
    A: W,
    b: R,
    B: K,
    c: null,
    d: mI,
    e: mI,
    f: tve,
    g: uve,
    G: fve,
    H: _me,
    I: $me,
    j: eve,
    L: YQ,
    m: rve,
    M: nve,
    p: L,
    q: G,
    Q: qI,
    s: yI,
    S: Ave,
    u: ive,
    U: ove,
    V: sve,
    w: ave,
    W: cve,
    x: null,
    X: null,
    y: lve,
    Y: dve,
    Z: hve,
    "%": vI
  }, y = {
    a: M,
    A: O,
    b: I,
    B: S,
    c: P,
    d: hI,
    e: hI,
    f: Ome,
    g: fI,
    G: dI,
    H: pI,
    I: pI,
    j: Ime,
    L: kme,
    m: xme,
    M: Sme,
    p: x,
    q: Eme,
    Q: Tme,
    s: Mme,
    S: Pme,
    u: yme,
    U: Cme,
    V: wme,
    w: qme,
    W: bme,
    x: H,
    X: F,
    y: fI,
    Y: dI,
    Z: Bme,
    "%": Fme
  };
  w.x = b(r, w), w.X = b(n, w), w.c = b(e, w), B.x = b(r, B), B.X = b(n, B), B.c = b(e, B);
  function b(V, _) {
    return function(J) {
      var X = [], ne = -1, ee = 0, $ = V.length, te, ae, se;
      for (J instanceof Date || (J = /* @__PURE__ */ new Date(+J)); ++ne < $; )
        V.charCodeAt(ne) === 37 && (X.push(V.slice(ee, ne)), (ae = uI[te = V.charAt(++ne)]) != null ? te = V.charAt(++ne) : ae = te === "e" ? " " : "0", (se = _[te]) && (te = se(J, ae)), X.push(te), ee = ne + 1);
      return X.push(V.slice(ee, ne)), X.join("");
    };
  }
  function q(V, _) {
    return function(J) {
      var X = C0(1900, void 0, 1), ne = E(X, V, J += "", 0), ee, $;
      if (ne != J.length) return null;
      if ("Q" in X) return new Date(X.Q);
      if ("s" in X) return new Date(X.s * 1e3 + ("L" in X ? X.L : 0));
      if (_ && !("Z" in X) && (X.Z = 0), "p" in X && (X.H = X.H % 12 + X.p * 12), X.m === void 0 && (X.m = "q" in X ? X.q : 0), "V" in X) {
        if (X.V < 1 || X.V > 53) return null;
        "w" in X || (X.w = 1), "Z" in X ? (ee = D6(C0(X.y, 0, 1)), $ = ee.getUTCDay(), ee = $ > 4 || $ === 0 ? pp.ceil(ee) : pp(ee), ee = U4.offset(ee, (X.V - 1) * 7), X.y = ee.getUTCFullYear(), X.m = ee.getUTCMonth(), X.d = ee.getUTCDate() + (X.w + 6) % 7) : (ee = H6(C0(X.y, 0, 1)), $ = ee.getDay(), ee = $ > 4 || $ === 0 ? hp.ceil(ee) : hp(ee), ee = j1.offset(ee, (X.V - 1) * 7), X.y = ee.getFullYear(), X.m = ee.getMonth(), X.d = ee.getDate() + (X.w + 6) % 7);
      } else ("W" in X || "U" in X) && ("w" in X || (X.w = "u" in X ? X.u % 7 : "W" in X ? 1 : 0), $ = "Z" in X ? D6(C0(X.y, 0, 1)).getUTCDay() : H6(C0(X.y, 0, 1)).getDay(), X.m = 0, X.d = "W" in X ? (X.w + 6) % 7 + X.W * 7 - ($ + 5) % 7 : X.w + X.U * 7 - ($ + 6) % 7);
      return "Z" in X ? (X.H += X.Z / 100 | 0, X.M += X.Z % 100, D6(X)) : H6(X);
    };
  }
  function E(V, _, J, X) {
    for (var ne = 0, ee = _.length, $ = J.length, te, ae; ne < ee; ) {
      if (X >= $) return -1;
      if (te = _.charCodeAt(ne++), te === 37) {
        if (te = _.charAt(ne++), ae = y[te in uI ? _.charAt(ne++) : te], !ae || (X = ae(V, J, X)) < 0) return -1;
      } else if (te != J.charCodeAt(X++))
        return -1;
    }
    return X;
  }
  function x(V, _, J) {
    var X = c.exec(_.slice(J));
    return X ? (V.p = l.get(X[0].toLowerCase()), J + X[0].length) : -1;
  }
  function M(V, _, J) {
    var X = d.exec(_.slice(J));
    return X ? (V.w = g.get(X[0].toLowerCase()), J + X[0].length) : -1;
  }
  function O(V, _, J) {
    var X = u.exec(_.slice(J));
    return X ? (V.w = f.get(X[0].toLowerCase()), J + X[0].length) : -1;
  }
  function I(V, _, J) {
    var X = v.exec(_.slice(J));
    return X ? (V.m = C.get(X[0].toLowerCase()), J + X[0].length) : -1;
  }
  function S(V, _, J) {
    var X = m.exec(_.slice(J));
    return X ? (V.m = p.get(X[0].toLowerCase()), J + X[0].length) : -1;
  }
  function P(V, _, J) {
    return E(V, e, _, J);
  }
  function H(V, _, J) {
    return E(V, r, _, J);
  }
  function F(V, _, J) {
    return E(V, n, _, J);
  }
  function T(V) {
    return o[V.getDay()];
  }
  function U(V) {
    return i[V.getDay()];
  }
  function D(V) {
    return a[V.getMonth()];
  }
  function Q(V) {
    return s[V.getMonth()];
  }
  function Y(V) {
    return A[+(V.getHours() >= 12)];
  }
  function j(V) {
    return 1 + ~~(V.getMonth() / 3);
  }
  function Z(V) {
    return o[V.getUTCDay()];
  }
  function W(V) {
    return i[V.getUTCDay()];
  }
  function R(V) {
    return a[V.getUTCMonth()];
  }
  function K(V) {
    return s[V.getUTCMonth()];
  }
  function L(V) {
    return A[+(V.getUTCHours() >= 12)];
  }
  function G(V) {
    return 1 + ~~(V.getUTCMonth() / 3);
  }
  return {
    format: function(V) {
      var _ = b(V += "", w);
      return _.toString = function() {
        return V;
      }, _;
    },
    parse: function(V) {
      var _ = q(V += "", !1);
      return _.toString = function() {
        return V;
      }, _;
    },
    utcFormat: function(V) {
      var _ = b(V += "", B);
      return _.toString = function() {
        return V;
      }, _;
    },
    utcParse: function(V) {
      var _ = q(V += "", !0);
      return _.toString = function() {
        return V;
      }, _;
    }
  };
}
var uI = { "-": "", _: " ", 0: "0" }, cA = /^\s*\d+/, gme = /^%/, mme = /[\\^$*+?|[\]().{}]/g;
function Or(t, e, r) {
  var n = t < 0 ? "-" : "", A = (n ? -t : t) + "", i = A.length;
  return n + (i < r ? new Array(r - i + 1).join(e) + A : A);
}
function vme(t) {
  return t.replace(mme, "\\$&");
}
function w0(t) {
  return new RegExp("^(?:" + t.map(vme).join("|") + ")", "i");
}
function b0(t) {
  return new Map(t.map((e, r) => [e.toLowerCase(), r]));
}
function qme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 1));
  return n ? (t.w = +n[0], r + n[0].length) : -1;
}
function yme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 1));
  return n ? (t.u = +n[0], r + n[0].length) : -1;
}
function Cme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.U = +n[0], r + n[0].length) : -1;
}
function wme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.V = +n[0], r + n[0].length) : -1;
}
function bme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.W = +n[0], r + n[0].length) : -1;
}
function dI(t, e, r) {
  var n = cA.exec(e.slice(r, r + 4));
  return n ? (t.y = +n[0], r + n[0].length) : -1;
}
function fI(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function Bme(t, e, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(r, r + 6));
  return n ? (t.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function Eme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 1));
  return n ? (t.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function xme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.m = n[0] - 1, r + n[0].length) : -1;
}
function hI(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.d = +n[0], r + n[0].length) : -1;
}
function Ime(t, e, r) {
  var n = cA.exec(e.slice(r, r + 3));
  return n ? (t.m = 0, t.d = +n[0], r + n[0].length) : -1;
}
function pI(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.H = +n[0], r + n[0].length) : -1;
}
function Sme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.M = +n[0], r + n[0].length) : -1;
}
function Pme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 2));
  return n ? (t.S = +n[0], r + n[0].length) : -1;
}
function kme(t, e, r) {
  var n = cA.exec(e.slice(r, r + 3));
  return n ? (t.L = +n[0], r + n[0].length) : -1;
}
function Ome(t, e, r) {
  var n = cA.exec(e.slice(r, r + 6));
  return n ? (t.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function Fme(t, e, r) {
  var n = gme.exec(e.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function Tme(t, e, r) {
  var n = cA.exec(e.slice(r));
  return n ? (t.Q = +n[0], r + n[0].length) : -1;
}
function Mme(t, e, r) {
  var n = cA.exec(e.slice(r));
  return n ? (t.s = +n[0], r + n[0].length) : -1;
}
function gI(t, e) {
  return Or(t.getDate(), e, 2);
}
function Hme(t, e) {
  return Or(t.getHours(), e, 2);
}
function Dme(t, e) {
  return Or(t.getHours() % 12 || 12, e, 2);
}
function Qme(t, e) {
  return Or(1 + j1.count(Us(t), t), e, 3);
}
function RQ(t, e) {
  return Or(t.getMilliseconds(), e, 3);
}
function Ume(t, e) {
  return RQ(t, e) + "000";
}
function Nme(t, e) {
  return Or(t.getMonth() + 1, e, 2);
}
function jme(t, e) {
  return Or(t.getMinutes(), e, 2);
}
function Lme(t, e) {
  return Or(t.getSeconds(), e, 2);
}
function Gme(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function Rme(t, e) {
  return Or(N4.count(Us(t) - 1, t), e, 2);
}
function zQ(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? Xu(t) : Xu.ceil(t);
}
function zme(t, e) {
  return t = zQ(t), Or(Xu.count(Us(t), t) + (Us(t).getDay() === 4), e, 2);
}
function Yme(t) {
  return t.getDay();
}
function Vme(t, e) {
  return Or(hp.count(Us(t) - 1, t), e, 2);
}
function Wme(t, e) {
  return Or(t.getFullYear() % 100, e, 2);
}
function Xme(t, e) {
  return t = zQ(t), Or(t.getFullYear() % 100, e, 2);
}
function Kme(t, e) {
  return Or(t.getFullYear() % 1e4, e, 4);
}
function Zme(t, e) {
  var r = t.getDay();
  return t = r >= 4 || r === 0 ? Xu(t) : Xu.ceil(t), Or(t.getFullYear() % 1e4, e, 4);
}
function Jme(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + Or(e / 60 | 0, "0", 2) + Or(e % 60, "0", 2);
}
function mI(t, e) {
  return Or(t.getUTCDate(), e, 2);
}
function _me(t, e) {
  return Or(t.getUTCHours(), e, 2);
}
function $me(t, e) {
  return Or(t.getUTCHours() % 12 || 12, e, 2);
}
function eve(t, e) {
  return Or(1 + U4.count(Ns(t), t), e, 3);
}
function YQ(t, e) {
  return Or(t.getUTCMilliseconds(), e, 3);
}
function tve(t, e) {
  return YQ(t, e) + "000";
}
function rve(t, e) {
  return Or(t.getUTCMonth() + 1, e, 2);
}
function nve(t, e) {
  return Or(t.getUTCMinutes(), e, 2);
}
function Ave(t, e) {
  return Or(t.getUTCSeconds(), e, 2);
}
function ive(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function ove(t, e) {
  return Or(j4.count(Ns(t) - 1, t), e, 2);
}
function VQ(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? Ku(t) : Ku.ceil(t);
}
function sve(t, e) {
  return t = VQ(t), Or(Ku.count(Ns(t), t) + (Ns(t).getUTCDay() === 4), e, 2);
}
function ave(t) {
  return t.getUTCDay();
}
function cve(t, e) {
  return Or(pp.count(Ns(t) - 1, t), e, 2);
}
function lve(t, e) {
  return Or(t.getUTCFullYear() % 100, e, 2);
}
function uve(t, e) {
  return t = VQ(t), Or(t.getUTCFullYear() % 100, e, 2);
}
function dve(t, e) {
  return Or(t.getUTCFullYear() % 1e4, e, 4);
}
function fve(t, e) {
  var r = t.getUTCDay();
  return t = r >= 4 || r === 0 ? Ku(t) : Ku.ceil(t), Or(t.getUTCFullYear() % 1e4, e, 4);
}
function hve() {
  return "+0000";
}
function vI() {
  return "%";
}
function qI(t) {
  return +t;
}
function yI(t) {
  return Math.floor(+t / 1e3);
}
var kl, WQ, XQ;
pve({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function pve(t) {
  return kl = pme(t), WQ = kl.format, kl.parse, XQ = kl.utcFormat, kl.utcParse, kl;
}
function gve(t) {
  return new Date(t);
}
function mve(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function Wq(t, e, r, n, A, i, o, s, a, c) {
  var l = Tq(), u = l.invert, f = l.domain, d = c(".%L"), g = c(":%S"), m = c("%I:%M"), p = c("%I %p"), v = c("%a %d"), C = c("%b %d"), w = c("%B"), B = c("%Y");
  function y(b) {
    return (a(b) < b ? d : s(b) < b ? g : o(b) < b ? m : i(b) < b ? p : n(b) < b ? A(b) < b ? v : C : r(b) < b ? w : B)(b);
  }
  return l.invert = function(b) {
    return new Date(u(b));
  }, l.domain = function(b) {
    return arguments.length ? f(Array.from(b, mve)) : f().map(gve);
  }, l.ticks = function(b) {
    var q = f();
    return t(q[0], q[q.length - 1], b ?? 10);
  }, l.tickFormat = function(b, q) {
    return q == null ? y : c(q);
  }, l.nice = function(b) {
    var q = f();
    return (!b || typeof b.range != "function") && (b = e(q[0], q[q.length - 1], b ?? 10)), b ? f(MQ(q, b)) : l;
  }, l.copy = function() {
    return N1(l, Wq(t, e, r, n, A, i, o, s, a, c));
  }, l;
}
function vve() {
  return Xi.apply(Wq(fme, hme, Us, Yq, N4, j1, Rq, Lq, xc, WQ).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function qve() {
  return Xi.apply(Wq(ume, dme, Ns, Vq, j4, U4, zq, Gq, xc, XQ).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function L4() {
  var t = 0, e = 1, r, n, A, i, o = XA, s = !1, a;
  function c(u) {
    return u == null || isNaN(u = +u) ? a : o(A === 0 ? 0.5 : (u = (i(u) - r) * A, s ? Math.max(0, Math.min(1, u)) : u));
  }
  c.domain = function(u) {
    return arguments.length ? ([t, e] = u, r = i(t = +t), n = i(e = +e), A = r === n ? 0 : 1 / (n - r), c) : [t, e];
  }, c.clamp = function(u) {
    return arguments.length ? (s = !!u, c) : s;
  }, c.interpolator = function(u) {
    return arguments.length ? (o = u, c) : o;
  };
  function l(u) {
    return function(f) {
      var d, g;
      return arguments.length ? ([d, g] = f, o = u(d, g), c) : [o(0), o(1)];
    };
  }
  return c.range = l(Yd), c.rangeRound = l(Fq), c.unknown = function(u) {
    return arguments.length ? (a = u, c) : a;
  }, function(u) {
    return i = u, r = u(t), n = u(e), A = r === n ? 0 : 1 / (n - r), c;
  };
}
function nc(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function KQ() {
  var t = rc(L4()(XA));
  return t.copy = function() {
    return nc(t, KQ());
  }, Vs.apply(t, arguments);
}
function ZQ() {
  var t = Dq(L4()).domain([1, 10]);
  return t.copy = function() {
    return nc(t, ZQ()).base(t.base());
  }, Vs.apply(t, arguments);
}
function JQ() {
  var t = Qq(L4());
  return t.copy = function() {
    return nc(t, JQ()).constant(t.constant());
  }, Vs.apply(t, arguments);
}
function Xq() {
  var t = Uq(L4());
  return t.copy = function() {
    return nc(t, Xq()).exponent(t.exponent());
  }, Vs.apply(t, arguments);
}
function yve() {
  return Xq.apply(null, arguments).exponent(0.5);
}
function _Q() {
  var t = [], e = XA;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return e((Q1(t, n, 1) - 1) / (t.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let A of n) A != null && !isNaN(A = +A) && t.push(A);
    return t.sort(Fa), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (e = n, r) : e;
  }, r.range = function() {
    return t.map((n, A) => e(A / (t.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (A, i) => o8e(t, i / n));
  }, r.copy = function() {
    return _Q(e).domain(t);
  }, Vs.apply(r, arguments);
}
function G4() {
  var t = 0, e = 0.5, r = 1, n = 1, A, i, o, s, a, c = XA, l, u = !1, f;
  function d(m) {
    return isNaN(m = +m) ? f : (m = 0.5 + ((m = +l(m)) - i) * (n * m < n * i ? s : a), c(u ? Math.max(0, Math.min(1, m)) : m));
  }
  d.domain = function(m) {
    return arguments.length ? ([t, e, r] = m, A = l(t = +t), i = l(e = +e), o = l(r = +r), s = A === i ? 0 : 0.5 / (i - A), a = i === o ? 0 : 0.5 / (o - i), n = i < A ? -1 : 1, d) : [t, e, r];
  }, d.clamp = function(m) {
    return arguments.length ? (u = !!m, d) : u;
  }, d.interpolator = function(m) {
    return arguments.length ? (c = m, d) : c;
  };
  function g(m) {
    return function(p) {
      var v, C, w;
      return arguments.length ? ([v, C, w] = p, c = F8e(m, [v, C, w]), d) : [c(0), c(0.5), c(1)];
    };
  }
  return d.range = g(Yd), d.rangeRound = g(Fq), d.unknown = function(m) {
    return arguments.length ? (f = m, d) : f;
  }, function(m) {
    return l = m, A = m(t), i = m(e), o = m(r), s = A === i ? 0 : 0.5 / (i - A), a = i === o ? 0 : 0.5 / (o - i), n = i < A ? -1 : 1, d;
  };
}
function $Q() {
  var t = rc(G4()(XA));
  return t.copy = function() {
    return nc(t, $Q());
  }, Vs.apply(t, arguments);
}
function eU() {
  var t = Dq(G4()).domain([0.1, 1, 10]);
  return t.copy = function() {
    return nc(t, eU()).base(t.base());
  }, Vs.apply(t, arguments);
}
function tU() {
  var t = Qq(G4());
  return t.copy = function() {
    return nc(t, tU()).constant(t.constant());
  }, Vs.apply(t, arguments);
}
function Kq() {
  var t = Uq(G4());
  return t.copy = function() {
    return nc(t, Kq()).exponent(t.exponent());
  }, Vs.apply(t, arguments);
}
function Cve() {
  return Kq.apply(null, arguments).exponent(0.5);
}
const CI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Q2,
  scaleDiverging: $Q,
  scaleDivergingLog: eU,
  scaleDivergingPow: Kq,
  scaleDivergingSqrt: Cve,
  scaleDivergingSymlog: tU,
  scaleIdentity: TQ,
  scaleImplicit: c8,
  scaleLinear: dp,
  scaleLog: HQ,
  scaleOrdinal: Pq,
  scalePoint: s2,
  scalePow: Nq,
  scaleQuantile: UQ,
  scaleQuantize: NQ,
  scaleRadial: QQ,
  scaleSequential: KQ,
  scaleSequentialLog: ZQ,
  scaleSequentialPow: Xq,
  scaleSequentialQuantile: _Q,
  scaleSequentialSqrt: yve,
  scaleSequentialSymlog: JQ,
  scaleSqrt: tme,
  scaleSymlog: DQ,
  scaleThreshold: jQ,
  scaleTime: vve,
  scaleUtc: qve,
  tickFormat: FQ
}, Symbol.toStringTag, { value: "Module" }));
var wve = Hd;
function bve(t, e, r) {
  for (var n = -1, A = t.length; ++n < A; ) {
    var i = t[n], o = e(i);
    if (o != null && (s === void 0 ? o === o && !wve(o) : r(o, s)))
      var s = o, a = i;
  }
  return a;
}
var rU = bve;
function Bve(t, e) {
  return t > e;
}
var Eve = Bve, xve = rU, Ive = Eve, Sve = zd;
function Pve(t) {
  return t && t.length ? xve(t, Sve, Ive) : void 0;
}
var kve = Pve;
const Ba = /* @__PURE__ */ Vr(kve);
function Ove(t, e) {
  return t < e;
}
var Fve = Ove, Tve = rU, Mve = Fve, Hve = zd;
function Dve(t) {
  return t && t.length ? Tve(t, Hve, Mve) : void 0;
}
var Qve = Dve;
const R4 = /* @__PURE__ */ Vr(Qve);
var Uve = lq, Nve = tc, jve = lQ, Lve = li;
function Gve(t, e) {
  var r = Lve(t) ? Uve : jve;
  return r(t, Nve(e));
}
var Rve = Gve, zve = aQ, Yve = Rve;
function Vve(t, e) {
  return zve(Yve(t, e), 1);
}
var Wve = Vve;
const Xve = /* @__PURE__ */ Vr(Wve);
var Kve = bq;
function Zve(t, e) {
  return Kve(t, e);
}
var Jve = Zve;
const Zu = /* @__PURE__ */ Vr(Jve);
var Vd = 1e9, _ve = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Jq, sn = !0, Vi = "[DecimalError] ", Lc = Vi + "Invalid argument: ", Zq = Vi + "Exponent out of range: ", Wd = Math.floor, mc = Math.pow, $ve = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, qi, oA = 1e7, rn = 7, nU = 9007199254740991, gp = Wd(nU / rn), bt = {};
bt.absoluteValue = bt.abs = function() {
  var t = new this.constructor(this);
  return t.s && (t.s = 1), t;
};
bt.comparedTo = bt.cmp = function(t) {
  var e, r, n, A, i = this;
  if (t = new i.constructor(t), i.s !== t.s) return i.s || -t.s;
  if (i.e !== t.e) return i.e > t.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, A = t.d.length, e = 0, r = n < A ? n : A; e < r; ++e)
    if (i.d[e] !== t.d[e]) return i.d[e] > t.d[e] ^ i.s < 0 ? 1 : -1;
  return n === A ? 0 : n > A ^ i.s < 0 ? 1 : -1;
};
bt.decimalPlaces = bt.dp = function() {
  var t = this, e = t.d.length - 1, r = (e - t.e) * rn;
  if (e = t.d[e], e) for (; e % 10 == 0; e /= 10) r--;
  return r < 0 ? 0 : r;
};
bt.dividedBy = bt.div = function(t) {
  return xs(this, new this.constructor(t));
};
bt.dividedToIntegerBy = bt.idiv = function(t) {
  var e = this, r = e.constructor;
  return Yr(xs(e, new r(t), 0, 1), r.precision);
};
bt.equals = bt.eq = function(t) {
  return !this.cmp(t);
};
bt.exponent = function() {
  return Rn(this);
};
bt.greaterThan = bt.gt = function(t) {
  return this.cmp(t) > 0;
};
bt.greaterThanOrEqualTo = bt.gte = function(t) {
  return this.cmp(t) >= 0;
};
bt.isInteger = bt.isint = function() {
  return this.e > this.d.length - 2;
};
bt.isNegative = bt.isneg = function() {
  return this.s < 0;
};
bt.isPositive = bt.ispos = function() {
  return this.s > 0;
};
bt.isZero = function() {
  return this.s === 0;
};
bt.lessThan = bt.lt = function(t) {
  return this.cmp(t) < 0;
};
bt.lessThanOrEqualTo = bt.lte = function(t) {
  return this.cmp(t) < 1;
};
bt.logarithm = bt.log = function(t) {
  var e, r = this, n = r.constructor, A = n.precision, i = A + 5;
  if (t === void 0)
    t = new n(10);
  else if (t = new n(t), t.s < 1 || t.eq(qi)) throw Error(Vi + "NaN");
  if (r.s < 1) throw Error(Vi + (r.s ? "NaN" : "-Infinity"));
  return r.eq(qi) ? new n(0) : (sn = !1, e = xs(G2(r, i), G2(t, i), i), sn = !0, Yr(e, A));
};
bt.minus = bt.sub = function(t) {
  var e = this;
  return t = new e.constructor(t), e.s == t.s ? oU(e, t) : AU(e, (t.s = -t.s, t));
};
bt.modulo = bt.mod = function(t) {
  var e, r = this, n = r.constructor, A = n.precision;
  if (t = new n(t), !t.s) throw Error(Vi + "NaN");
  return r.s ? (sn = !1, e = xs(r, t, 0, 1).times(t), sn = !0, r.minus(e)) : Yr(new n(r), A);
};
bt.naturalExponential = bt.exp = function() {
  return iU(this);
};
bt.naturalLogarithm = bt.ln = function() {
  return G2(this);
};
bt.negated = bt.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s || 0, t;
};
bt.plus = bt.add = function(t) {
  var e = this;
  return t = new e.constructor(t), e.s == t.s ? AU(e, t) : oU(e, (t.s = -t.s, t));
};
bt.precision = bt.sd = function(t) {
  var e, r, n, A = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0) throw Error(Lc + t);
  if (e = Rn(A) + 1, n = A.d.length - 1, r = n * rn + 1, n = A.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = A.d[0]; n >= 10; n /= 10) r++;
  }
  return t && e > r ? e : r;
};
bt.squareRoot = bt.sqrt = function() {
  var t, e, r, n, A, i, o, s = this, a = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new a(0);
    throw Error(Vi + "NaN");
  }
  for (t = Rn(s), sn = !1, A = Math.sqrt(+s), A == 0 || A == 1 / 0 ? (e = Lo(s.d), (e.length + t) % 2 == 0 && (e += "0"), A = Math.sqrt(e), t = Wd((t + 1) / 2) - (t < 0 || t % 2), A == 1 / 0 ? e = "5e" + t : (e = A.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + t), n = new a(e)) : n = new a(A.toString()), r = a.precision, A = o = r + 3; ; )
    if (i = n, n = i.plus(xs(s, i, o + 2)).times(0.5), Lo(i.d).slice(0, o) === (e = Lo(n.d)).slice(0, o)) {
      if (e = e.slice(o - 3, o + 1), A == o && e == "4999") {
        if (Yr(i, r + 1, 0), i.times(i).eq(s)) {
          n = i;
          break;
        }
      } else if (e != "9999")
        break;
      o += 4;
    }
  return sn = !0, Yr(n, r);
};
bt.times = bt.mul = function(t) {
  var e, r, n, A, i, o, s, a, c, l = this, u = l.constructor, f = l.d, d = (t = new u(t)).d;
  if (!l.s || !t.s) return new u(0);
  for (t.s *= l.s, r = l.e + t.e, a = f.length, c = d.length, a < c && (i = f, f = d, d = i, o = a, a = c, c = o), i = [], o = a + c, n = o; n--; ) i.push(0);
  for (n = c; --n >= 0; ) {
    for (e = 0, A = a + n; A > n; )
      s = i[A] + d[n] * f[A - n - 1] + e, i[A--] = s % oA | 0, e = s / oA | 0;
    i[A] = (i[A] + e) % oA | 0;
  }
  for (; !i[--o]; ) i.pop();
  return e ? ++r : i.shift(), t.d = i, t.e = r, sn ? Yr(t, u.precision) : t;
};
bt.toDecimalPlaces = bt.todp = function(t, e) {
  var r = this, n = r.constructor;
  return r = new n(r), t === void 0 ? r : (_o(t, 0, Vd), e === void 0 ? e = n.rounding : _o(e, 0, 8), Yr(r, t + Rn(r) + 1, e));
};
bt.toExponential = function(t, e) {
  var r, n = this, A = n.constructor;
  return t === void 0 ? r = Al(n, !0) : (_o(t, 0, Vd), e === void 0 ? e = A.rounding : _o(e, 0, 8), n = Yr(new A(n), t + 1, e), r = Al(n, !0, t + 1)), r;
};
bt.toFixed = function(t, e) {
  var r, n, A = this, i = A.constructor;
  return t === void 0 ? Al(A) : (_o(t, 0, Vd), e === void 0 ? e = i.rounding : _o(e, 0, 8), n = Yr(new i(A), t + Rn(A) + 1, e), r = Al(n.abs(), !1, t + Rn(n) + 1), A.isneg() && !A.isZero() ? "-" + r : r);
};
bt.toInteger = bt.toint = function() {
  var t = this, e = t.constructor;
  return Yr(new e(t), Rn(t) + 1, e.rounding);
};
bt.toNumber = function() {
  return +this;
};
bt.toPower = bt.pow = function(t) {
  var e, r, n, A, i, o, s = this, a = s.constructor, c = 12, l = +(t = new a(t));
  if (!t.s) return new a(qi);
  if (s = new a(s), !s.s) {
    if (t.s < 1) throw Error(Vi + "Infinity");
    return s;
  }
  if (s.eq(qi)) return s;
  if (n = a.precision, t.eq(qi)) return Yr(s, n);
  if (e = t.e, r = t.d.length - 1, o = e >= r, i = s.s, o) {
    if ((r = l < 0 ? -l : l) <= nU) {
      for (A = new a(qi), e = Math.ceil(n / rn + 4), sn = !1; r % 2 && (A = A.times(s), bI(A.d, e)), r = Wd(r / 2), r !== 0; )
        s = s.times(s), bI(s.d, e);
      return sn = !0, t.s < 0 ? new a(qi).div(A) : Yr(A, n);
    }
  } else if (i < 0) throw Error(Vi + "NaN");
  return i = i < 0 && t.d[Math.max(e, r)] & 1 ? -1 : 1, s.s = 1, sn = !1, A = t.times(G2(s, n + c)), sn = !0, A = iU(A), A.s = i, A;
};
bt.toPrecision = function(t, e) {
  var r, n, A = this, i = A.constructor;
  return t === void 0 ? (r = Rn(A), n = Al(A, r <= i.toExpNeg || r >= i.toExpPos)) : (_o(t, 1, Vd), e === void 0 ? e = i.rounding : _o(e, 0, 8), A = Yr(new i(A), t, e), r = Rn(A), n = Al(A, t <= r || r <= i.toExpNeg, t)), n;
};
bt.toSignificantDigits = bt.tosd = function(t, e) {
  var r = this, n = r.constructor;
  return t === void 0 ? (t = n.precision, e = n.rounding) : (_o(t, 1, Vd), e === void 0 ? e = n.rounding : _o(e, 0, 8)), Yr(new n(r), t, e);
};
bt.toString = bt.valueOf = bt.val = bt.toJSON = bt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var t = this, e = Rn(t), r = t.constructor;
  return Al(t, e <= r.toExpNeg || e >= r.toExpPos);
};
function AU(t, e) {
  var r, n, A, i, o, s, a, c, l = t.constructor, u = l.precision;
  if (!t.s || !e.s)
    return e.s || (e = new l(t)), sn ? Yr(e, u) : e;
  if (a = t.d, c = e.d, o = t.e, A = e.e, a = a.slice(), i = o - A, i) {
    for (i < 0 ? (n = a, i = -i, s = c.length) : (n = c, A = o, s = a.length), o = Math.ceil(u / rn), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; ) n.push(0);
    n.reverse();
  }
  for (s = a.length, i = c.length, s - i < 0 && (i = s, n = c, c = a, a = n), r = 0; i; )
    r = (a[--i] = a[i] + c[i] + r) / oA | 0, a[i] %= oA;
  for (r && (a.unshift(r), ++A), s = a.length; a[--s] == 0; ) a.pop();
  return e.d = a, e.e = A, sn ? Yr(e, u) : e;
}
function _o(t, e, r) {
  if (t !== ~~t || t < e || t > r)
    throw Error(Lc + t);
}
function Lo(t) {
  var e, r, n, A = t.length - 1, i = "", o = t[0];
  if (A > 0) {
    for (i += o, e = 1; e < A; e++)
      n = t[e] + "", r = rn - n.length, r && (i += pa(r)), i += n;
    o = t[e], n = o + "", r = rn - n.length, r && (i += pa(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return i + o;
}
var xs = /* @__PURE__ */ function() {
  function t(n, A) {
    var i, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      i = n[s] * A + o, n[s] = i % oA | 0, o = i / oA | 0;
    return o && n.unshift(o), n;
  }
  function e(n, A, i, o) {
    var s, a;
    if (i != o)
      a = i > o ? 1 : -1;
    else
      for (s = a = 0; s < i; s++)
        if (n[s] != A[s]) {
          a = n[s] > A[s] ? 1 : -1;
          break;
        }
    return a;
  }
  function r(n, A, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < A[i] ? 1 : 0, n[i] = o * oA + n[i] - A[i];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, A, i, o) {
    var s, a, c, l, u, f, d, g, m, p, v, C, w, B, y, b, q, E, x = n.constructor, M = n.s == A.s ? 1 : -1, O = n.d, I = A.d;
    if (!n.s) return new x(n);
    if (!A.s) throw Error(Vi + "Division by zero");
    for (a = n.e - A.e, q = I.length, y = O.length, d = new x(M), g = d.d = [], c = 0; I[c] == (O[c] || 0); ) ++c;
    if (I[c] > (O[c] || 0) && --a, i == null ? C = i = x.precision : o ? C = i + (Rn(n) - Rn(A)) + 1 : C = i, C < 0) return new x(0);
    if (C = C / rn + 2 | 0, c = 0, q == 1)
      for (l = 0, I = I[0], C++; (c < y || l) && C--; c++)
        w = l * oA + (O[c] || 0), g[c] = w / I | 0, l = w % I | 0;
    else {
      for (l = oA / (I[0] + 1) | 0, l > 1 && (I = t(I, l), O = t(O, l), q = I.length, y = O.length), B = q, m = O.slice(0, q), p = m.length; p < q; ) m[p++] = 0;
      E = I.slice(), E.unshift(0), b = I[0], I[1] >= oA / 2 && ++b;
      do
        l = 0, s = e(I, m, q, p), s < 0 ? (v = m[0], q != p && (v = v * oA + (m[1] || 0)), l = v / b | 0, l > 1 ? (l >= oA && (l = oA - 1), u = t(I, l), f = u.length, p = m.length, s = e(u, m, f, p), s == 1 && (l--, r(u, q < f ? E : I, f))) : (l == 0 && (s = l = 1), u = I.slice()), f = u.length, f < p && u.unshift(0), r(m, u, p), s == -1 && (p = m.length, s = e(I, m, q, p), s < 1 && (l++, r(m, q < p ? E : I, p))), p = m.length) : s === 0 && (l++, m = [0]), g[c++] = l, s && m[0] ? m[p++] = O[B] || 0 : (m = [O[B]], p = 1);
      while ((B++ < y || m[0] !== void 0) && C--);
    }
    return g[0] || g.shift(), d.e = a, Yr(d, o ? i + Rn(d) + 1 : i);
  };
}();
function iU(t, e) {
  var r, n, A, i, o, s, a = 0, c = 0, l = t.constructor, u = l.precision;
  if (Rn(t) > 16) throw Error(Zq + Rn(t));
  if (!t.s) return new l(qi);
  for (e == null ? (sn = !1, s = u) : s = e, o = new l(0.03125); t.abs().gte(0.1); )
    t = t.times(o), c += 5;
  for (n = Math.log(mc(2, c)) / Math.LN10 * 2 + 5 | 0, s += n, r = A = i = new l(qi), l.precision = s; ; ) {
    if (A = Yr(A.times(t), s), r = r.times(++a), o = i.plus(xs(A, r, s)), Lo(o.d).slice(0, s) === Lo(i.d).slice(0, s)) {
      for (; c--; ) i = Yr(i.times(i), s);
      return l.precision = u, e == null ? (sn = !0, Yr(i, u)) : i;
    }
    i = o;
  }
}
function Rn(t) {
  for (var e = t.e * rn, r = t.d[0]; r >= 10; r /= 10) e++;
  return e;
}
function Q6(t, e, r) {
  if (e > t.LN10.sd())
    throw sn = !0, r && (t.precision = r), Error(Vi + "LN10 precision limit exceeded");
  return Yr(new t(t.LN10), e);
}
function pa(t) {
  for (var e = ""; t--; ) e += "0";
  return e;
}
function G2(t, e) {
  var r, n, A, i, o, s, a, c, l, u = 1, f = 10, d = t, g = d.d, m = d.constructor, p = m.precision;
  if (d.s < 1) throw Error(Vi + (d.s ? "NaN" : "-Infinity"));
  if (d.eq(qi)) return new m(0);
  if (e == null ? (sn = !1, c = p) : c = e, d.eq(10))
    return e == null && (sn = !0), Q6(m, c);
  if (c += f, m.precision = c, r = Lo(g), n = r.charAt(0), i = Rn(d), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      d = d.times(t), r = Lo(d.d), n = r.charAt(0), u++;
    i = Rn(d), n > 1 ? (d = new m("0." + r), i++) : d = new m(n + "." + r.slice(1));
  } else
    return a = Q6(m, c + 2, p).times(i + ""), d = G2(new m(n + "." + r.slice(1)), c - f).plus(a), m.precision = p, e == null ? (sn = !0, Yr(d, p)) : d;
  for (s = o = d = xs(d.minus(qi), d.plus(qi), c), l = Yr(d.times(d), c), A = 3; ; ) {
    if (o = Yr(o.times(l), c), a = s.plus(xs(o, new m(A), c)), Lo(a.d).slice(0, c) === Lo(s.d).slice(0, c))
      return s = s.times(2), i !== 0 && (s = s.plus(Q6(m, c + 2, p).times(i + ""))), s = xs(s, new m(u), c), m.precision = p, e == null ? (sn = !0, Yr(s, p)) : s;
    s = a, A += 2;
  }
}
function wI(t, e) {
  var r, n, A;
  for ((r = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (n = e.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +e.slice(n + 1), e = e.substring(0, n)) : r < 0 && (r = e.length), n = 0; e.charCodeAt(n) === 48; ) ++n;
  for (A = e.length; e.charCodeAt(A - 1) === 48; ) --A;
  if (e = e.slice(n, A), e) {
    if (A -= n, r = r - n - 1, t.e = Wd(r / rn), t.d = [], n = (r + 1) % rn, r < 0 && (n += rn), n < A) {
      for (n && t.d.push(+e.slice(0, n)), A -= rn; n < A; ) t.d.push(+e.slice(n, n += rn));
      e = e.slice(n), n = rn - e.length;
    } else
      n -= A;
    for (; n--; ) e += "0";
    if (t.d.push(+e), sn && (t.e > gp || t.e < -gp)) throw Error(Zq + r);
  } else
    t.s = 0, t.e = 0, t.d = [0];
  return t;
}
function Yr(t, e, r) {
  var n, A, i, o, s, a, c, l, u = t.d;
  for (o = 1, i = u[0]; i >= 10; i /= 10) o++;
  if (n = e - o, n < 0)
    n += rn, A = e, c = u[l = 0];
  else {
    if (l = Math.ceil((n + 1) / rn), i = u.length, l >= i) return t;
    for (c = i = u[l], o = 1; i >= 10; i /= 10) o++;
    n %= rn, A = n - rn + o;
  }
  if (r !== void 0 && (i = mc(10, o - A - 1), s = c / i % 10 | 0, a = e < 0 || u[l + 1] !== void 0 || c % i, a = r < 4 ? (s || a) && (r == 0 || r == (t.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || a || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? A > 0 ? c / mc(10, o - A) : 0 : u[l - 1]) % 10 & 1 || r == (t.s < 0 ? 8 : 7))), e < 1 || !u[0])
    return a ? (i = Rn(t), u.length = 1, e = e - i - 1, u[0] = mc(10, (rn - e % rn) % rn), t.e = Wd(-e / rn) || 0) : (u.length = 1, u[0] = t.e = t.s = 0), t;
  if (n == 0 ? (u.length = l, i = 1, l--) : (u.length = l + 1, i = mc(10, rn - n), u[l] = A > 0 ? (c / mc(10, o - A) % mc(10, A) | 0) * i : 0), a)
    for (; ; )
      if (l == 0) {
        (u[0] += i) == oA && (u[0] = 1, ++t.e);
        break;
      } else {
        if (u[l] += i, u[l] != oA) break;
        u[l--] = 0, i = 1;
      }
  for (n = u.length; u[--n] === 0; ) u.pop();
  if (sn && (t.e > gp || t.e < -gp))
    throw Error(Zq + Rn(t));
  return t;
}
function oU(t, e) {
  var r, n, A, i, o, s, a, c, l, u, f = t.constructor, d = f.precision;
  if (!t.s || !e.s)
    return e.s ? e.s = -e.s : e = new f(t), sn ? Yr(e, d) : e;
  if (a = t.d, u = e.d, n = e.e, c = t.e, a = a.slice(), o = c - n, o) {
    for (l = o < 0, l ? (r = a, o = -o, s = u.length) : (r = u, n = c, s = a.length), A = Math.max(Math.ceil(d / rn), s) + 2, o > A && (o = A, r.length = 1), r.reverse(), A = o; A--; ) r.push(0);
    r.reverse();
  } else {
    for (A = a.length, s = u.length, l = A < s, l && (s = A), A = 0; A < s; A++)
      if (a[A] != u[A]) {
        l = a[A] < u[A];
        break;
      }
    o = 0;
  }
  for (l && (r = a, a = u, u = r, e.s = -e.s), s = a.length, A = u.length - s; A > 0; --A) a[s++] = 0;
  for (A = u.length; A > o; ) {
    if (a[--A] < u[A]) {
      for (i = A; i && a[--i] === 0; ) a[i] = oA - 1;
      --a[i], a[A] += oA;
    }
    a[A] -= u[A];
  }
  for (; a[--s] === 0; ) a.pop();
  for (; a[0] === 0; a.shift()) --n;
  return a[0] ? (e.d = a, e.e = n, sn ? Yr(e, d) : e) : new f(0);
}
function Al(t, e, r) {
  var n, A = Rn(t), i = Lo(t.d), o = i.length;
  return e ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + pa(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (A < 0 ? "e" : "e+") + A) : A < 0 ? (i = "0." + pa(-A - 1) + i, r && (n = r - o) > 0 && (i += pa(n))) : A >= o ? (i += pa(A + 1 - o), r && (n = r - A - 1) > 0 && (i = i + "." + pa(n))) : ((n = A + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (A + 1 === o && (i += "."), i += pa(n))), t.s < 0 ? "-" + i : i;
}
function bI(t, e) {
  if (t.length > e)
    return t.length = e, !0;
}
function sU(t) {
  var e, r, n;
  function A(i) {
    var o = this;
    if (!(o instanceof A)) return new A(i);
    if (o.constructor = A, i instanceof A) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(Lc + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return wI(o, i.toString());
    } else if (typeof i != "string")
      throw Error(Lc + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, $ve.test(i)) wI(o, i);
    else throw Error(Lc + i);
  }
  if (A.prototype = bt, A.ROUND_UP = 0, A.ROUND_DOWN = 1, A.ROUND_CEIL = 2, A.ROUND_FLOOR = 3, A.ROUND_HALF_UP = 4, A.ROUND_HALF_DOWN = 5, A.ROUND_HALF_EVEN = 6, A.ROUND_HALF_CEIL = 7, A.ROUND_HALF_FLOOR = 8, A.clone = sU, A.config = A.set = eqe, t === void 0 && (t = {}), t)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], e = 0; e < n.length; ) t.hasOwnProperty(r = n[e++]) || (t[r] = this[r]);
  return A.config(t), A;
}
function eqe(t) {
  if (!t || typeof t != "object")
    throw Error(Vi + "Object expected");
  var e, r, n, A = [
    "precision",
    1,
    Vd,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (e = 0; e < A.length; e += 3)
    if ((n = t[r = A[e]]) !== void 0)
      if (Wd(n) === n && n >= A[e + 1] && n <= A[e + 2]) this[r] = n;
      else throw Error(Lc + r + ": " + n);
  if ((n = t[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Lc + r + ": " + n);
  return this;
}
var Jq = sU(_ve);
qi = new Jq(1);
const Gr = Jq;
function tqe(t) {
  return iqe(t) || Aqe(t) || nqe(t) || rqe();
}
function rqe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nqe(t, e) {
  if (t) {
    if (typeof t == "string") return f8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return f8(t, e);
  }
}
function Aqe(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t)) return Array.from(t);
}
function iqe(t) {
  if (Array.isArray(t)) return f8(t);
}
function f8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var oqe = function(e) {
  return e;
}, aU = {
  "@@functional/placeholder": !0
}, cU = function(e) {
  return e === aU;
}, BI = function(e) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && cU(arguments.length <= 0 ? void 0 : arguments[0]) ? r : e.apply(void 0, arguments);
  };
}, sqe = function t(e, r) {
  return e === 1 ? r : BI(function() {
    for (var n = arguments.length, A = new Array(n), i = 0; i < n; i++)
      A[i] = arguments[i];
    var o = A.filter(function(s) {
      return s !== aU;
    }).length;
    return o >= e ? r.apply(void 0, A) : t(e - o, BI(function() {
      for (var s = arguments.length, a = new Array(s), c = 0; c < s; c++)
        a[c] = arguments[c];
      var l = A.map(function(u) {
        return cU(u) ? a.shift() : u;
      });
      return r.apply(void 0, tqe(l).concat(a));
    }));
  });
}, z4 = function(e) {
  return sqe(e.length, e);
}, h8 = function(e, r) {
  for (var n = [], A = e; A < r; ++A)
    n[A - e] = A;
  return n;
}, aqe = z4(function(t, e) {
  return Array.isArray(e) ? e.map(t) : Object.keys(e).map(function(r) {
    return e[r];
  }).map(t);
}), cqe = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  if (!r.length)
    return oqe;
  var A = r.reverse(), i = A[0], o = A.slice(1);
  return function() {
    return o.reduce(function(s, a) {
      return a(s);
    }, i.apply(void 0, arguments));
  };
}, p8 = function(e) {
  return Array.isArray(e) ? e.reverse() : e.split("").reverse.join("");
}, lU = function(e) {
  var r = null, n = null;
  return function() {
    for (var A = arguments.length, i = new Array(A), o = 0; o < A; o++)
      i[o] = arguments[o];
    return r && i.every(function(s, a) {
      return s === r[a];
    }) || (r = i, n = e.apply(void 0, i)), n;
  };
};
function lqe(t) {
  var e;
  return t === 0 ? e = 1 : e = Math.floor(new Gr(t).abs().log(10).toNumber()) + 1, e;
}
function uqe(t, e, r) {
  for (var n = new Gr(t), A = 0, i = []; n.lt(e) && A < 1e5; )
    i.push(n.toNumber()), n = n.add(r), A++;
  return i;
}
var dqe = z4(function(t, e, r) {
  var n = +t, A = +e;
  return n + r * (A - n);
}), fqe = z4(function(t, e, r) {
  var n = e - +t;
  return n = n || 1 / 0, (r - t) / n;
}), hqe = z4(function(t, e, r) {
  var n = e - +t;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - t) / n));
});
const Y4 = {
  rangeStep: uqe,
  getDigitCount: lqe,
  interpolateNumber: dqe,
  uninterpolateNumber: fqe,
  uninterpolateTruncation: hqe
};
function g8(t) {
  return mqe(t) || gqe(t) || uU(t) || pqe();
}
function pqe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gqe(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t)) return Array.from(t);
}
function mqe(t) {
  if (Array.isArray(t)) return m8(t);
}
function R2(t, e) {
  return yqe(t) || qqe(t, e) || uU(t, e) || vqe();
}
function vqe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uU(t, e) {
  if (t) {
    if (typeof t == "string") return m8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return m8(t, e);
  }
}
function m8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function qqe(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var r = [], n = !0, A = !1, i = void 0;
    try {
      for (var o = t[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(e && r.length === e)); n = !0)
        ;
    } catch (a) {
      A = !0, i = a;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (A) throw i;
      }
    }
    return r;
  }
}
function yqe(t) {
  if (Array.isArray(t)) return t;
}
function dU(t) {
  var e = R2(t, 2), r = e[0], n = e[1], A = r, i = n;
  return r > n && (A = n, i = r), [A, i];
}
function fU(t, e, r) {
  if (t.lte(0))
    return new Gr(0);
  var n = Y4.getDigitCount(t.toNumber()), A = new Gr(10).pow(n), i = t.div(A), o = n !== 1 ? 0.05 : 0.1, s = new Gr(Math.ceil(i.div(o).toNumber())).add(r).mul(o), a = s.mul(A);
  return e ? a : new Gr(Math.ceil(a));
}
function Cqe(t, e, r) {
  var n = 1, A = new Gr(t);
  if (!A.isint() && r) {
    var i = Math.abs(t);
    i < 1 ? (n = new Gr(10).pow(Y4.getDigitCount(t) - 1), A = new Gr(Math.floor(A.div(n).toNumber())).mul(n)) : i > 1 && (A = new Gr(Math.floor(t)));
  } else t === 0 ? A = new Gr(Math.floor((e - 1) / 2)) : r || (A = new Gr(Math.floor(t)));
  var o = Math.floor((e - 1) / 2), s = cqe(aqe(function(a) {
    return A.add(new Gr(a - o).mul(n)).toNumber();
  }), h8);
  return s(0, e);
}
function hU(t, e, r, n) {
  var A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((e - t) / (r - 1)))
    return {
      step: new Gr(0),
      tickMin: new Gr(0),
      tickMax: new Gr(0)
    };
  var i = fU(new Gr(e).sub(t).div(r - 1), n, A), o;
  t <= 0 && e >= 0 ? o = new Gr(0) : (o = new Gr(t).add(e).div(2), o = o.sub(new Gr(o).mod(i)));
  var s = Math.ceil(o.sub(t).div(i).toNumber()), a = Math.ceil(new Gr(e).sub(o).div(i).toNumber()), c = s + a + 1;
  return c > r ? hU(t, e, r, n, A + 1) : (c < r && (a = e > 0 ? a + (r - c) : a, s = e > 0 ? s : s + (r - c)), {
    step: i,
    tickMin: o.sub(new Gr(s).mul(i)),
    tickMax: o.add(new Gr(a).mul(i))
  });
}
function wqe(t) {
  var e = R2(t, 2), r = e[0], n = e[1], A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(A, 2), s = dU([r, n]), a = R2(s, 2), c = a[0], l = a[1];
  if (c === -1 / 0 || l === 1 / 0) {
    var u = l === 1 / 0 ? [c].concat(g8(h8(0, A - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(g8(h8(0, A - 1).map(function() {
      return -1 / 0;
    })), [l]);
    return r > n ? p8(u) : u;
  }
  if (c === l)
    return Cqe(c, A, i);
  var f = hU(c, l, o, i), d = f.step, g = f.tickMin, m = f.tickMax, p = Y4.rangeStep(g, m.add(new Gr(0.1).mul(d)), d);
  return r > n ? p8(p) : p;
}
function bqe(t, e) {
  var r = R2(t, 2), n = r[0], A = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = dU([n, A]), s = R2(o, 2), a = s[0], c = s[1];
  if (a === -1 / 0 || c === 1 / 0)
    return [n, A];
  if (a === c)
    return [a];
  var l = Math.max(e, 2), u = fU(new Gr(c).sub(a).div(l - 1), i, 0), f = [].concat(g8(Y4.rangeStep(new Gr(a), new Gr(c).sub(new Gr(0.99).mul(u)), u)), [c]);
  return n > A ? p8(f) : f;
}
var Bqe = lU(wqe), Eqe = lU(bqe), xqe = process.env.NODE_ENV === "production", U6 = "Invariant failed";
function si(t, e) {
  if (xqe)
    throw new Error(U6);
  var r = typeof e == "function" ? e() : e, n = r ? "".concat(U6, ": ").concat(r) : U6;
  throw new Error(n);
}
var Iqe = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Ju(t) {
  "@babel/helpers - typeof";
  return Ju = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ju(t);
}
function mp() {
  return mp = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, mp.apply(this, arguments);
}
function Sqe(t, e) {
  return Fqe(t) || Oqe(t, e) || kqe(t, e) || Pqe();
}
function Pqe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kqe(t, e) {
  if (t) {
    if (typeof t == "string") return EI(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return EI(t, e);
  }
}
function EI(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Oqe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function Fqe(t) {
  if (Array.isArray(t)) return t;
}
function Tqe(t, e) {
  if (t == null) return {};
  var r = Mqe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Mqe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Hqe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Dqe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, mU(n.key), n);
  }
}
function Qqe(t, e, r) {
  return Dqe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Uqe(t, e, r) {
  return e = vp(e), Nqe(t, pU() ? Reflect.construct(e, r || [], vp(t).constructor) : e.apply(t, r));
}
function Nqe(t, e) {
  if (e && (Ju(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jqe(t);
}
function jqe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function pU() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pU = function() {
    return !!t;
  })();
}
function vp(t) {
  return vp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vp(t);
}
function Lqe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && v8(t, e);
}
function v8(t, e) {
  return v8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, v8(t, e);
}
function gU(t, e, r) {
  return e = mU(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function mU(t) {
  var e = Gqe(t, "string");
  return Ju(e) == "symbol" ? e : e + "";
}
function Gqe(t, e) {
  if (Ju(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Ju(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var L1 = /* @__PURE__ */ function(t) {
  function e() {
    return Hqe(this, e), Uqe(this, e, arguments);
  }
  return Lqe(e, t), Qqe(e, [{
    key: "render",
    value: function() {
      var n = this.props, A = n.offset, i = n.layout, o = n.width, s = n.dataKey, a = n.data, c = n.dataPointFormatter, l = n.xAxis, u = n.yAxis, f = Tqe(n, Iqe), d = cr(f, !1);
      this.props.direction === "x" && l.type !== "number" && (process.env.NODE_ENV !== "production" ? si(!1, 'ErrorBar requires Axis type property to be "number".') : si());
      var g = a.map(function(m) {
        var p = c(m, s), v = p.x, C = p.y, w = p.value, B = p.errorVal;
        if (!B)
          return null;
        var y = [], b, q;
        if (Array.isArray(B)) {
          var E = Sqe(B, 2);
          b = E[0], q = E[1];
        } else
          b = q = B;
        if (i === "vertical") {
          var x = l.scale, M = C + A, O = M + o, I = M - o, S = x(w - b), P = x(w + q);
          y.push({
            x1: P,
            y1: O,
            x2: P,
            y2: I
          }), y.push({
            x1: S,
            y1: M,
            x2: P,
            y2: M
          }), y.push({
            x1: S,
            y1: O,
            x2: S,
            y2: I
          });
        } else if (i === "horizontal") {
          var H = u.scale, F = v + A, T = F - o, U = F + o, D = H(w - b), Q = H(w + q);
          y.push({
            x1: T,
            y1: Q,
            x2: U,
            y2: Q
          }), y.push({
            x1: F,
            y1: D,
            x2: F,
            y2: Q
          }), y.push({
            x1: T,
            y1: D,
            x2: U,
            y2: D
          });
        }
        return /* @__PURE__ */ re.createElement(_r, mp({
          className: "recharts-errorBar",
          key: "bar-".concat(y.map(function(Y) {
            return "".concat(Y.x1, "-").concat(Y.x2, "-").concat(Y.y1, "-").concat(Y.y2);
          }))
        }, d), y.map(function(Y) {
          return /* @__PURE__ */ re.createElement("line", mp({}, Y, {
            key: "line-".concat(Y.x1, "-").concat(Y.x2, "-").concat(Y.y1, "-").concat(Y.y2)
          }));
        }));
      });
      return /* @__PURE__ */ re.createElement(_r, {
        className: "recharts-errorBars"
      }, g);
    }
  }]);
}(re.Component);
gU(L1, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
gU(L1, "displayName", "ErrorBar");
function z2(t) {
  "@babel/helpers - typeof";
  return z2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, z2(t);
}
function xI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xI(Object(r), !0).forEach(function(n) {
      Rqe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Rqe(t, e, r) {
  return e = zqe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zqe(t) {
  var e = Yqe(t, "string");
  return z2(e) == "symbol" ? e : e + "";
}
function Yqe(t, e) {
  if (z2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (z2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var vU = function(e) {
  var r = e.children, n = e.formattedGraphicalItems, A = e.legendWidth, i = e.legendContent, o = mi(r, cu);
  if (!o)
    return null;
  var s = cu.defaultProps, a = s !== void 0 ? dc(dc({}, s), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : i === "children" ? c = (n || []).reduce(function(l, u) {
    var f = u.item, d = u.props, g = d.sectors || d.data || [];
    return l.concat(g.map(function(m) {
      return {
        type: o.props.iconType || f.props.legendType,
        value: m.name,
        color: m.fill,
        payload: m
      };
    }));
  }, []) : c = (n || []).map(function(l) {
    var u = l.item, f = u.type.defaultProps, d = f !== void 0 ? dc(dc({}, f), u.props) : {}, g = d.dataKey, m = d.name, p = d.legendType, v = d.hide;
    return {
      inactive: v,
      dataKey: g,
      type: a.iconType || p || "square",
      color: _q(u),
      value: m || g,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: d
    };
  }), dc(dc(dc({}, a), cu.getWithHeight(o, A)), {}, {
    payload: c,
    item: o
  });
};
function Y2(t) {
  "@babel/helpers - typeof";
  return Y2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Y2(t);
}
function II(t) {
  return Kqe(t) || Xqe(t) || Wqe(t) || Vqe();
}
function Vqe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wqe(t, e) {
  if (t) {
    if (typeof t == "string") return q8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return q8(t, e);
  }
}
function Xqe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Kqe(t) {
  if (Array.isArray(t)) return q8(t);
}
function q8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function SI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? SI(Object(r), !0).forEach(function(n) {
      uu(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : SI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function uu(t, e, r) {
  return e = Zqe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Zqe(t) {
  var e = Jqe(t, "string");
  return Y2(e) == "symbol" ? e : e + "";
}
function Jqe(t, e) {
  if (Y2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Y2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function _A(t, e, r) {
  return hr(t) || hr(e) ? r : $n(e) ? Ri(t, e, r) : nr(e) ? e(t) : r;
}
function a2(t, e, r, n) {
  var A = Xve(t, function(s) {
    return _A(s, e);
  });
  if (r === "number") {
    var i = A.filter(function(s) {
      return At(s) || parseFloat(s);
    });
    return i.length ? [R4(i), Ba(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? A.filter(function(s) {
    return !hr(s);
  }) : A;
  return o.map(function(s) {
    return $n(s) || s instanceof Date ? s : "";
  });
}
var _qe = function(e) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], A = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var a = i.range, c = 0; c < s; c++) {
      var l = c > 0 ? A[c - 1].coordinate : A[s - 1].coordinate, u = A[c].coordinate, f = c >= s - 1 ? A[0].coordinate : A[c + 1].coordinate, d = void 0;
      if (uo(u - l) !== uo(f - u)) {
        var g = [];
        if (uo(f - u) === uo(a[1] - a[0])) {
          d = f;
          var m = u + a[1] - a[0];
          g[0] = Math.min(m, (m + l) / 2), g[1] = Math.max(m, (m + l) / 2);
        } else {
          d = l;
          var p = f + a[1] - a[0];
          g[0] = Math.min(u, (p + u) / 2), g[1] = Math.max(u, (p + u) / 2);
        }
        var v = [Math.min(u, (d + u) / 2), Math.max(u, (d + u) / 2)];
        if (e > v[0] && e <= v[1] || e >= g[0] && e <= g[1]) {
          o = A[c].index;
          break;
        }
      } else {
        var C = Math.min(l, f), w = Math.max(l, f);
        if (e > (C + u) / 2 && e <= (w + u) / 2) {
          o = A[c].index;
          break;
        }
      }
    }
  else
    for (var B = 0; B < s; B++)
      if (B === 0 && e <= (n[B].coordinate + n[B + 1].coordinate) / 2 || B > 0 && B < s - 1 && e > (n[B].coordinate + n[B - 1].coordinate) / 2 && e <= (n[B].coordinate + n[B + 1].coordinate) / 2 || B === s - 1 && e > (n[B].coordinate + n[B - 1].coordinate) / 2) {
        o = n[B].index;
        break;
      }
  return o;
}, _q = function(e) {
  var r, n = e, A = n.type.displayName, i = (r = e.type) !== null && r !== void 0 && r.defaultProps ? qn(qn({}, e.type.defaultProps), e.props) : e.props, o = i.stroke, s = i.fill, a;
  switch (A) {
    case "Line":
      a = o;
      break;
    case "Area":
    case "Radar":
      a = o && o !== "none" ? o : s;
      break;
    default:
      a = s;
      break;
  }
  return a;
}, $qe = function(e) {
  var r = e.barSize, n = e.totalSize, A = e.stackGroups, i = A === void 0 ? {} : A;
  if (!i)
    return {};
  for (var o = {}, s = Object.keys(i), a = 0, c = s.length; a < c; a++)
    for (var l = i[s[a]].stackGroups, u = Object.keys(l), f = 0, d = u.length; f < d; f++) {
      var g = l[u[f]], m = g.items, p = g.cateAxisId, v = m.filter(function(q) {
        return Bs(q.type).indexOf("Bar") >= 0;
      });
      if (v && v.length) {
        var C = v[0].type.defaultProps, w = C !== void 0 ? qn(qn({}, C), v[0].props) : v[0].props, B = w.barSize, y = w[p];
        o[y] || (o[y] = []);
        var b = hr(B) ? r : B;
        o[y].push({
          item: v[0],
          stackList: v.slice(1),
          barSize: hr(b) ? void 0 : nl(b, n, 0)
        });
      }
    }
  return o;
}, eye = function(e) {
  var r = e.barGap, n = e.barCategoryGap, A = e.bandSize, i = e.sizeList, o = i === void 0 ? [] : i, s = e.maxBarSize, a = o.length;
  if (a < 1) return null;
  var c = nl(r, A, 0, !0), l, u = [];
  if (o[0].barSize === +o[0].barSize) {
    var f = !1, d = A / a, g = o.reduce(function(B, y) {
      return B + y.barSize || 0;
    }, 0);
    g += (a - 1) * c, g >= A && (g -= (a - 1) * c, c = 0), g >= A && d > 0 && (f = !0, d *= 0.9, g = a * d);
    var m = (A - g) / 2 >> 0, p = {
      offset: m - c,
      size: 0
    };
    l = o.reduce(function(B, y) {
      var b = {
        item: y.item,
        position: {
          offset: p.offset + p.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: f ? d : y.barSize
        }
      }, q = [].concat(II(B), [b]);
      return p = q[q.length - 1].position, y.stackList && y.stackList.length && y.stackList.forEach(function(E) {
        q.push({
          item: E,
          position: p
        });
      }), q;
    }, u);
  } else {
    var v = nl(n, A, 0, !0);
    A - 2 * v - (a - 1) * c <= 0 && (c = 0);
    var C = (A - 2 * v - (a - 1) * c) / a;
    C > 1 && (C >>= 0);
    var w = s === +s ? Math.min(C, s) : C;
    l = o.reduce(function(B, y, b) {
      var q = [].concat(II(B), [{
        item: y.item,
        position: {
          offset: v + (C + c) * b + (C - w) / 2,
          size: w
        }
      }]);
      return y.stackList && y.stackList.length && y.stackList.forEach(function(E) {
        q.push({
          item: E,
          position: q[q.length - 1].position
        });
      }), q;
    }, u);
  }
  return l;
}, tye = function(e, r, n, A) {
  var i = n.children, o = n.width, s = n.margin, a = o - (s.left || 0) - (s.right || 0), c = vU({
    children: i,
    legendWidth: a
  });
  if (c) {
    var l = A || {}, u = l.width, f = l.height, d = c.align, g = c.verticalAlign, m = c.layout;
    if ((m === "vertical" || m === "horizontal" && g === "middle") && d !== "center" && At(e[d]))
      return qn(qn({}, e), {}, uu({}, d, e[d] + (u || 0)));
    if ((m === "horizontal" || m === "vertical" && d === "center") && g !== "middle" && At(e[g]))
      return qn(qn({}, e), {}, uu({}, g, e[g] + (f || 0)));
  }
  return e;
}, rye = function(e, r, n) {
  return hr(r) ? !0 : e === "horizontal" ? r === "yAxis" : e === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, qU = function(e, r, n, A, i) {
  var o = r.props.children, s = zi(o, L1).filter(function(c) {
    return rye(A, i, c.props.direction);
  });
  if (s && s.length) {
    var a = s.map(function(c) {
      return c.props.dataKey;
    });
    return e.reduce(function(c, l) {
      var u = _A(l, n);
      if (hr(u)) return c;
      var f = Array.isArray(u) ? [R4(u), Ba(u)] : [u, u], d = a.reduce(function(g, m) {
        var p = _A(l, m, 0), v = f[0] - Math.abs(Array.isArray(p) ? p[0] : p), C = f[1] + Math.abs(Array.isArray(p) ? p[1] : p);
        return [Math.min(v, g[0]), Math.max(C, g[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(d[0], c[0]), Math.max(d[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, nye = function(e, r, n, A, i) {
  var o = r.map(function(s) {
    return qU(e, s, n, i, A);
  }).filter(function(s) {
    return !hr(s);
  });
  return o && o.length ? o.reduce(function(s, a) {
    return [Math.min(s[0], a[0]), Math.max(s[1], a[1])];
  }, [1 / 0, -1 / 0]) : null;
}, yU = function(e, r, n, A, i) {
  var o = r.map(function(a) {
    var c = a.props.dataKey;
    return n === "number" && c && qU(e, a, c, A) || a2(e, c, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(a, c) {
        return [Math.min(a[0], c[0]), Math.max(a[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(a, c) {
    for (var l = 0, u = c.length; l < u; l++)
      s[c[l]] || (s[c[l]] = !0, a.push(c[l]));
    return a;
  }, []);
}, CU = function(e, r) {
  return e === "horizontal" && r === "xAxis" || e === "vertical" && r === "yAxis" || e === "centric" && r === "angleAxis" || e === "radial" && r === "radiusAxis";
}, wU = function(e, r, n, A) {
  if (A)
    return e.map(function(a) {
      return a.coordinate;
    });
  var i, o, s = e.map(function(a) {
    return a.coordinate === r && (i = !0), a.coordinate === n && (o = !0), a.coordinate;
  });
  return i || s.push(r), o || s.push(n), s;
}, vs = function(e, r, n) {
  if (!e) return null;
  var A = e.scale, i = e.duplicateDomain, o = e.type, s = e.range, a = e.realScaleType === "scaleBand" ? A.bandwidth() / 2 : 2, c = (r || n) && o === "category" && A.bandwidth ? A.bandwidth() / a : 0;
  if (c = e.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? uo(s[0] - s[1]) * 2 * c : c, r && (e.ticks || e.niceTicks)) {
    var l = (e.ticks || e.niceTicks).map(function(u) {
      var f = i ? i.indexOf(u) : u;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: A(f) + c,
        value: u,
        offset: c
      };
    });
    return l.filter(function(u) {
      return !jd(u.coordinate);
    });
  }
  return e.isCategorical && e.categoricalDomain ? e.categoricalDomain.map(function(u, f) {
    return {
      coordinate: A(u) + c,
      value: u,
      index: f,
      offset: c
    };
  }) : A.ticks && !n ? A.ticks(e.tickCount).map(function(u) {
    return {
      coordinate: A(u) + c,
      value: u,
      offset: c
    };
  }) : A.domain().map(function(u, f) {
    return {
      coordinate: A(u) + c,
      value: i ? i[u] : u,
      index: f,
      offset: c
    };
  });
}, N6 = /* @__PURE__ */ new WeakMap(), _f = function(e, r) {
  if (typeof r != "function")
    return e;
  N6.has(e) || N6.set(e, /* @__PURE__ */ new WeakMap());
  var n = N6.get(e);
  if (n.has(r))
    return n.get(r);
  var A = function() {
    e.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, A), A;
}, Aye = function(e, r, n) {
  var A = e.scale, i = e.type, o = e.layout, s = e.axisType;
  if (A === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: Q2(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: dp(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: s2(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: Q2(),
      realScaleType: "band"
    } : {
      scale: dp(),
      realScaleType: "linear"
    };
  if (H1(A)) {
    var a = "scale".concat(k4(A));
    return {
      scale: (CI[a] || s2)(),
      realScaleType: CI[a] ? a : "point"
    };
  }
  return nr(A) ? {
    scale: A
  } : {
    scale: s2(),
    realScaleType: "point"
  };
}, PI = 1e-4, iye = function(e) {
  var r = e.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, A = e.range(), i = Math.min(A[0], A[1]) - PI, o = Math.max(A[0], A[1]) + PI, s = e(r[0]), a = e(r[n - 1]);
    (s < i || s > o || a < i || a > o) && e.domain([r[0], r[n - 1]]);
  }
}, oye = function(e, r) {
  if (!e)
    return null;
  for (var n = 0, A = e.length; n < A; n++)
    if (e[n].item === r)
      return e[n].position;
  return null;
}, sye = function(e, r) {
  if (!r || r.length !== 2 || !At(r[0]) || !At(r[1]))
    return e;
  var n = Math.min(r[0], r[1]), A = Math.max(r[0], r[1]), i = [e[0], e[1]];
  return (!At(e[0]) || e[0] < n) && (i[0] = n), (!At(e[1]) || e[1] > A) && (i[1] = A), i[0] > A && (i[0] = A), i[1] < n && (i[1] = n), i;
}, aye = function(e) {
  var r = e.length;
  if (!(r <= 0))
    for (var n = 0, A = e[0].length; n < A; ++n)
      for (var i = 0, o = 0, s = 0; s < r; ++s) {
        var a = jd(e[s][n][1]) ? e[s][n][0] : e[s][n][1];
        a >= 0 ? (e[s][n][0] = i, e[s][n][1] = i + a, i = e[s][n][1]) : (e[s][n][0] = o, e[s][n][1] = o + a, o = e[s][n][1]);
      }
}, cye = function(e) {
  var r = e.length;
  if (!(r <= 0))
    for (var n = 0, A = e[0].length; n < A; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var s = jd(e[o][n][1]) ? e[o][n][0] : e[o][n][1];
        s >= 0 ? (e[o][n][0] = i, e[o][n][1] = i + s, i = e[o][n][1]) : (e[o][n][0] = 0, e[o][n][1] = 0);
      }
}, lye = {
  sign: aye,
  // @ts-expect-error definitelytyped types are incorrect
  expand: Efe,
  // @ts-expect-error definitelytyped types are incorrect
  none: Gu,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: xfe,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: Ife,
  positive: cye
}, uye = function(e, r, n) {
  var A = r.map(function(s) {
    return s.props.dataKey;
  }), i = lye[n], o = Bfe().keys(A).value(function(s, a) {
    return +_A(s, a, 0);
  }).order(z7).offset(i);
  return o(e);
}, dye = function(e, r, n, A, i, o) {
  if (!e)
    return null;
  var s = o ? r.reverse() : r, a = {}, c = s.reduce(function(u, f) {
    var d, g = (d = f.type) !== null && d !== void 0 && d.defaultProps ? qn(qn({}, f.type.defaultProps), f.props) : f.props, m = g.stackId, p = g.hide;
    if (p)
      return u;
    var v = g[n], C = u[v] || {
      hasStack: !1,
      stackGroups: {}
    };
    if ($n(m)) {
      var w = C.stackGroups[m] || {
        numericAxisId: n,
        cateAxisId: A,
        items: []
      };
      w.items.push(f), C.hasStack = !0, C.stackGroups[m] = w;
    } else
      C.stackGroups[Ld("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: A,
        items: [f]
      };
    return qn(qn({}, u), {}, uu({}, v, C));
  }, a), l = {};
  return Object.keys(c).reduce(function(u, f) {
    var d = c[f];
    if (d.hasStack) {
      var g = {};
      d.stackGroups = Object.keys(d.stackGroups).reduce(function(m, p) {
        var v = d.stackGroups[p];
        return qn(qn({}, m), {}, uu({}, p, {
          numericAxisId: n,
          cateAxisId: A,
          items: v.items,
          stackedData: uye(e, v.items, i)
        }));
      }, g);
    }
    return qn(qn({}, u), {}, uu({}, f, d));
  }, l);
}, fye = function(e, r) {
  var n = r.realScaleType, A = r.type, i = r.tickCount, o = r.originalDomain, s = r.allowDecimals, a = n || r.scale;
  if (a !== "auto" && a !== "linear")
    return null;
  if (i && A === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = e.domain();
    if (!c.length)
      return null;
    var l = Bqe(c, i, s);
    return e.domain([R4(l), Ba(l)]), {
      niceTicks: l
    };
  }
  if (i && A === "number") {
    var u = e.domain(), f = Eqe(u, i, s);
    return {
      niceTicks: f
    };
  }
  return null;
};
function qp(t) {
  var e = t.axis, r = t.ticks, n = t.bandSize, A = t.entry, i = t.index, o = t.dataKey;
  if (e.type === "category") {
    if (!e.allowDuplicatedCategory && e.dataKey && !hr(A[e.dataKey])) {
      var s = R3(r, "value", A[e.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var a = _A(A, hr(o) ? e.dataKey : o);
  return hr(a) ? null : e.scale(a);
}
var kI = function(e) {
  var r = e.axis, n = e.ticks, A = e.offset, i = e.bandSize, o = e.entry, s = e.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + A : null;
  var a = _A(o, r.dataKey, r.domain[s]);
  return hr(a) ? null : r.scale(a) - i / 2 + A;
}, hye = function(e) {
  var r = e.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var A = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return A <= 0 && i >= 0 ? 0 : i < 0 ? i : A;
  }
  return n[0];
}, pye = function(e, r) {
  var n, A = (n = e.type) !== null && n !== void 0 && n.defaultProps ? qn(qn({}, e.type.defaultProps), e.props) : e.props, i = A.stackId;
  if ($n(i)) {
    var o = r[i];
    if (o) {
      var s = o.items.indexOf(e);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, gye = function(e) {
  return e.reduce(function(r, n) {
    return [R4(n.concat([r[0]]).filter(At)), Ba(n.concat([r[1]]).filter(At))];
  }, [1 / 0, -1 / 0]);
}, bU = function(e, r, n) {
  return Object.keys(e).reduce(function(A, i) {
    var o = e[i], s = o.stackedData, a = s.reduce(function(c, l) {
      var u = gye(l.slice(r, n + 1));
      return [Math.min(c[0], u[0]), Math.max(c[1], u[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(a[0], A[0]), Math.max(a[1], A[1])];
  }, [1 / 0, -1 / 0]).map(function(A) {
    return A === 1 / 0 || A === -1 / 0 ? 0 : A;
  });
}, OI = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, FI = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, y8 = function(e, r, n) {
  if (nr(e))
    return e(r, n);
  if (!Array.isArray(e))
    return r;
  var A = [];
  if (At(e[0]))
    A[0] = n ? e[0] : Math.min(e[0], r[0]);
  else if (OI.test(e[0])) {
    var i = +OI.exec(e[0])[1];
    A[0] = r[0] - i;
  } else nr(e[0]) ? A[0] = e[0](r[0]) : A[0] = r[0];
  if (At(e[1]))
    A[1] = n ? e[1] : Math.max(e[1], r[1]);
  else if (FI.test(e[1])) {
    var o = +FI.exec(e[1])[1];
    A[1] = r[1] + o;
  } else nr(e[1]) ? A[1] = e[1](r[1]) : A[1] = r[1];
  return A;
}, yp = function(e, r, n) {
  if (e && e.scale && e.scale.bandwidth) {
    var A = e.scale.bandwidth();
    if (!n || A > 0)
      return A;
  }
  if (e && r && r.length >= 2) {
    for (var i = Eq(r, function(u) {
      return u.coordinate;
    }), o = 1 / 0, s = 1, a = i.length; s < a; s++) {
      var c = i[s], l = i[s - 1];
      o = Math.min((c.coordinate || 0) - (l.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, TI = function(e, r, n) {
  return !e || !e.length || Zu(e, Ri(n, "type.defaultProps.domain")) ? r : e;
}, BU = function(e, r) {
  var n = e.type.defaultProps ? qn(qn({}, e.type.defaultProps), e.props) : e.props, A = n.dataKey, i = n.name, o = n.unit, s = n.formatter, a = n.tooltipType, c = n.chartType, l = n.hide;
  return qn(qn({}, cr(e, !1)), {}, {
    dataKey: A,
    unit: o,
    formatter: s,
    name: i || A,
    color: _q(e),
    value: _A(r, A),
    type: a,
    payload: r,
    chartType: c,
    hide: l
  });
};
function V2(t) {
  "@babel/helpers - typeof";
  return V2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, V2(t);
}
function MI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function HI(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? MI(Object(r), !0).forEach(function(n) {
      mye(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : MI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function mye(t, e, r) {
  return e = vye(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function vye(t) {
  var e = qye(t, "string");
  return V2(e) == "symbol" ? e : e + "";
}
function qye(t, e) {
  if (V2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (V2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Cp = Math.PI / 180, yye = function(e) {
  return e * 180 / Math.PI;
}, CA = function(e, r, n, A) {
  return {
    x: e + Math.cos(-Cp * A) * n,
    y: r + Math.sin(-Cp * A) * n
  };
}, Cye = function(e, r) {
  var n = e.x, A = e.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(A - o, 2));
}, wye = function(e, r) {
  var n = e.x, A = e.y, i = r.cx, o = r.cy, s = Cye({
    x: n,
    y: A
  }, {
    x: i,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var a = (n - i) / s, c = Math.acos(a);
  return A > o && (c = 2 * Math.PI - c), {
    radius: s,
    angle: yye(c),
    angleInRadian: c
  };
}, bye = function(e) {
  var r = e.startAngle, n = e.endAngle, A = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(A, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, Bye = function(e, r) {
  var n = r.startAngle, A = r.endAngle, i = Math.floor(n / 360), o = Math.floor(A / 360), s = Math.min(i, o);
  return e + s * 360;
}, DI = function(e, r) {
  var n = e.x, A = e.y, i = wye({
    x: n,
    y: A
  }, r), o = i.radius, s = i.angle, a = r.innerRadius, c = r.outerRadius;
  if (o < a || o > c)
    return !1;
  if (o === 0)
    return !0;
  var l = bye(r), u = l.startAngle, f = l.endAngle, d = s, g;
  if (u <= f) {
    for (; d > f; )
      d -= 360;
    for (; d < u; )
      d += 360;
    g = d >= u && d <= f;
  } else {
    for (; d > u; )
      d -= 360;
    for (; d < f; )
      d += 360;
    g = d >= f && d <= u;
  }
  return g ? HI(HI({}, r), {}, {
    radius: o,
    angle: Bye(d, r)
  }) : null;
};
function W2(t) {
  "@babel/helpers - typeof";
  return W2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, W2(t);
}
var Eye = ["offset"];
function xye(t) {
  return kye(t) || Pye(t) || Sye(t) || Iye();
}
function Iye() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sye(t, e) {
  if (t) {
    if (typeof t == "string") return C8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C8(t, e);
  }
}
function Pye(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function kye(t) {
  if (Array.isArray(t)) return C8(t);
}
function C8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Oye(t, e) {
  if (t == null) return {};
  var r = Fye(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Fye(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function QI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Wn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? QI(Object(r), !0).forEach(function(n) {
      Tye(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : QI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Tye(t, e, r) {
  return e = Mye(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Mye(t) {
  var e = Hye(t, "string");
  return W2(e) == "symbol" ? e : e + "";
}
function Hye(t, e) {
  if (W2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (W2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function X2() {
  return X2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, X2.apply(this, arguments);
}
var Dye = function(e) {
  var r = e.value, n = e.formatter, A = hr(e.children) ? r : e.children;
  return nr(n) ? n(A) : A;
}, Qye = function(e, r) {
  var n = uo(r - e), A = Math.min(Math.abs(r - e), 360);
  return n * A;
}, Uye = function(e, r, n) {
  var A = e.position, i = e.viewBox, o = e.offset, s = e.className, a = i, c = a.cx, l = a.cy, u = a.innerRadius, f = a.outerRadius, d = a.startAngle, g = a.endAngle, m = a.clockWise, p = (u + f) / 2, v = Qye(d, g), C = v >= 0 ? 1 : -1, w, B;
  A === "insideStart" ? (w = d + C * o, B = m) : A === "insideEnd" ? (w = g - C * o, B = !m) : A === "end" && (w = g + C * o, B = m), B = v <= 0 ? B : !B;
  var y = CA(c, l, p, w), b = CA(c, l, p, w + (B ? 1 : -1) * 359), q = "M".concat(y.x, ",").concat(y.y, `
    A`).concat(p, ",").concat(p, ",0,1,").concat(B ? 0 : 1, `,
    `).concat(b.x, ",").concat(b.y), E = hr(e.id) ? Ld("recharts-radial-line-") : e.id;
  return /* @__PURE__ */ re.createElement("text", X2({}, n, {
    dominantBaseline: "central",
    className: Br("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("path", {
    id: E,
    d: q
  })), /* @__PURE__ */ re.createElement("textPath", {
    xlinkHref: "#".concat(E)
  }, r));
}, Nye = function(e) {
  var r = e.viewBox, n = e.offset, A = e.position, i = r, o = i.cx, s = i.cy, a = i.innerRadius, c = i.outerRadius, l = i.startAngle, u = i.endAngle, f = (l + u) / 2;
  if (A === "outside") {
    var d = CA(o, s, c + n, f), g = d.x, m = d.y;
    return {
      x: g,
      y: m,
      textAnchor: g >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (A === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (A === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (A === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var p = (a + c) / 2, v = CA(o, s, p, f), C = v.x, w = v.y;
  return {
    x: C,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, jye = function(e) {
  var r = e.viewBox, n = e.parentViewBox, A = e.offset, i = e.position, o = r, s = o.x, a = o.y, c = o.width, l = o.height, u = l >= 0 ? 1 : -1, f = u * A, d = u > 0 ? "end" : "start", g = u > 0 ? "start" : "end", m = c >= 0 ? 1 : -1, p = m * A, v = m > 0 ? "end" : "start", C = m > 0 ? "start" : "end";
  if (i === "top") {
    var w = {
      x: s + c / 2,
      y: a - u * A,
      textAnchor: "middle",
      verticalAnchor: d
    };
    return Wn(Wn({}, w), n ? {
      height: Math.max(a - n.y, 0),
      width: c
    } : {});
  }
  if (i === "bottom") {
    var B = {
      x: s + c / 2,
      y: a + l + f,
      textAnchor: "middle",
      verticalAnchor: g
    };
    return Wn(Wn({}, B), n ? {
      height: Math.max(n.y + n.height - (a + l), 0),
      width: c
    } : {});
  }
  if (i === "left") {
    var y = {
      x: s - p,
      y: a + l / 2,
      textAnchor: v,
      verticalAnchor: "middle"
    };
    return Wn(Wn({}, y), n ? {
      width: Math.max(y.x - n.x, 0),
      height: l
    } : {});
  }
  if (i === "right") {
    var b = {
      x: s + c + p,
      y: a + l / 2,
      textAnchor: C,
      verticalAnchor: "middle"
    };
    return Wn(Wn({}, b), n ? {
      width: Math.max(n.x + n.width - b.x, 0),
      height: l
    } : {});
  }
  var q = n ? {
    width: c,
    height: l
  } : {};
  return i === "insideLeft" ? Wn({
    x: s + p,
    y: a + l / 2,
    textAnchor: C,
    verticalAnchor: "middle"
  }, q) : i === "insideRight" ? Wn({
    x: s + c - p,
    y: a + l / 2,
    textAnchor: v,
    verticalAnchor: "middle"
  }, q) : i === "insideTop" ? Wn({
    x: s + c / 2,
    y: a + f,
    textAnchor: "middle",
    verticalAnchor: g
  }, q) : i === "insideBottom" ? Wn({
    x: s + c / 2,
    y: a + l - f,
    textAnchor: "middle",
    verticalAnchor: d
  }, q) : i === "insideTopLeft" ? Wn({
    x: s + p,
    y: a + f,
    textAnchor: C,
    verticalAnchor: g
  }, q) : i === "insideTopRight" ? Wn({
    x: s + c - p,
    y: a + f,
    textAnchor: v,
    verticalAnchor: g
  }, q) : i === "insideBottomLeft" ? Wn({
    x: s + p,
    y: a + l - f,
    textAnchor: C,
    verticalAnchor: d
  }, q) : i === "insideBottomRight" ? Wn({
    x: s + c - p,
    y: a + l - f,
    textAnchor: v,
    verticalAnchor: d
  }, q) : Dd(i) && (At(i.x) || Bc(i.x)) && (At(i.y) || Bc(i.y)) ? Wn({
    x: s + nl(i.x, c),
    y: a + nl(i.y, l),
    textAnchor: "end",
    verticalAnchor: "end"
  }, q) : Wn({
    x: s + c / 2,
    y: a + l / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, q);
}, Lye = function(e) {
  return "cx" in e && At(e.cx);
};
function FA(t) {
  var e = t.offset, r = e === void 0 ? 5 : e, n = Oye(t, Eye), A = Wn({
    offset: r
  }, n), i = A.viewBox, o = A.position, s = A.value, a = A.children, c = A.content, l = A.className, u = l === void 0 ? "" : l, f = A.textBreakAll;
  if (!i || hr(s) && hr(a) && !/* @__PURE__ */ QA(c) && !nr(c))
    return null;
  if (/* @__PURE__ */ QA(c))
    return /* @__PURE__ */ vn(c, A);
  var d;
  if (nr(c)) {
    if (d = /* @__PURE__ */ gP(c, A), /* @__PURE__ */ QA(d))
      return d;
  } else
    d = Dye(A);
  var g = Lye(i), m = cr(A, !0);
  if (g && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return Uye(A, d, m);
  var p = g ? Nye(A) : jye(A);
  return /* @__PURE__ */ re.createElement(ip, X2({
    className: Br("recharts-label", u)
  }, m, p, {
    breakAll: f
  }), d);
}
FA.displayName = "Label";
var EU = function(e) {
  var r = e.cx, n = e.cy, A = e.angle, i = e.startAngle, o = e.endAngle, s = e.r, a = e.radius, c = e.innerRadius, l = e.outerRadius, u = e.x, f = e.y, d = e.top, g = e.left, m = e.width, p = e.height, v = e.clockWise, C = e.labelViewBox;
  if (C)
    return C;
  if (At(m) && At(p)) {
    if (At(u) && At(f))
      return {
        x: u,
        y: f,
        width: m,
        height: p
      };
    if (At(d) && At(g))
      return {
        x: d,
        y: g,
        width: m,
        height: p
      };
  }
  return At(u) && At(f) ? {
    x: u,
    y: f,
    width: 0,
    height: 0
  } : At(r) && At(n) ? {
    cx: r,
    cy: n,
    startAngle: i || A || 0,
    endAngle: o || A || 0,
    innerRadius: c || 0,
    outerRadius: l || a || s || 0,
    clockWise: v
  } : e.viewBox ? e.viewBox : {};
}, Gye = function(e, r) {
  return e ? e === !0 ? /* @__PURE__ */ re.createElement(FA, {
    key: "label-implicit",
    viewBox: r
  }) : $n(e) ? /* @__PURE__ */ re.createElement(FA, {
    key: "label-implicit",
    viewBox: r,
    value: e
  }) : /* @__PURE__ */ QA(e) ? e.type === FA ? /* @__PURE__ */ vn(e, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ re.createElement(FA, {
    key: "label-implicit",
    content: e,
    viewBox: r
  }) : nr(e) ? /* @__PURE__ */ re.createElement(FA, {
    key: "label-implicit",
    content: e,
    viewBox: r
  }) : Dd(e) ? /* @__PURE__ */ re.createElement(FA, X2({
    viewBox: r
  }, e, {
    key: "label-implicit"
  })) : null : null;
}, Rye = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var A = e.children, i = EU(e), o = zi(A, FA).map(function(a, c) {
    return /* @__PURE__ */ vn(a, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var s = Gye(e.label, r || i);
  return [s].concat(xye(o));
};
FA.parseViewBox = EU;
FA.renderCallByParent = Rye;
function zye(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var Yye = zye;
const Vye = /* @__PURE__ */ Vr(Yye);
function K2(t) {
  "@babel/helpers - typeof";
  return K2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, K2(t);
}
var Wye = ["valueAccessor"], Xye = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function Kye(t) {
  return $ye(t) || _ye(t) || Jye(t) || Zye();
}
function Zye() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Jye(t, e) {
  if (t) {
    if (typeof t == "string") return w8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return w8(t, e);
  }
}
function _ye(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function $ye(t) {
  if (Array.isArray(t)) return w8(t);
}
function w8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function wp() {
  return wp = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, wp.apply(this, arguments);
}
function UI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function NI(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? UI(Object(r), !0).forEach(function(n) {
      eCe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : UI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function eCe(t, e, r) {
  return e = tCe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function tCe(t) {
  var e = rCe(t, "string");
  return K2(e) == "symbol" ? e : e + "";
}
function rCe(t, e) {
  if (K2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (K2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function jI(t, e) {
  if (t == null) return {};
  var r = nCe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function nCe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var ACe = function(e) {
  return Array.isArray(e.value) ? Vye(e.value) : e.value;
};
function Is(t) {
  var e = t.valueAccessor, r = e === void 0 ? ACe : e, n = jI(t, Wye), A = n.data, i = n.dataKey, o = n.clockWise, s = n.id, a = n.textBreakAll, c = jI(n, Xye);
  return !A || !A.length ? null : /* @__PURE__ */ re.createElement(_r, {
    className: "recharts-label-list"
  }, A.map(function(l, u) {
    var f = hr(i) ? r(l, u) : _A(l && l.payload, i), d = hr(s) ? {} : {
      id: "".concat(s, "-").concat(u)
    };
    return /* @__PURE__ */ re.createElement(FA, wp({}, cr(l, !0), c, d, {
      parentViewBox: l.parentViewBox,
      value: f,
      textBreakAll: a,
      viewBox: FA.parseViewBox(hr(o) ? l : NI(NI({}, l), {}, {
        clockWise: o
      })),
      key: "label-".concat(u),
      index: u
    }));
  }));
}
Is.displayName = "LabelList";
function iCe(t, e) {
  return t ? t === !0 ? /* @__PURE__ */ re.createElement(Is, {
    key: "labelList-implicit",
    data: e
  }) : /* @__PURE__ */ re.isValidElement(t) || nr(t) ? /* @__PURE__ */ re.createElement(Is, {
    key: "labelList-implicit",
    data: e,
    content: t
  }) : Dd(t) ? /* @__PURE__ */ re.createElement(Is, wp({
    data: e
  }, t, {
    key: "labelList-implicit"
  })) : null : null;
}
function oCe(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var n = t.children, A = zi(n, Is).map(function(o, s) {
    return /* @__PURE__ */ vn(o, {
      data: e,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return A;
  var i = iCe(t.label, e);
  return [i].concat(Kye(A));
}
Is.renderCallByParent = oCe;
function Z2(t) {
  "@babel/helpers - typeof";
  return Z2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Z2(t);
}
function b8() {
  return b8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, b8.apply(this, arguments);
}
function LI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function GI(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? LI(Object(r), !0).forEach(function(n) {
      sCe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : LI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function sCe(t, e, r) {
  return e = aCe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function aCe(t) {
  var e = cCe(t, "string");
  return Z2(e) == "symbol" ? e : e + "";
}
function cCe(t, e) {
  if (Z2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Z2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var lCe = function(e, r) {
  var n = uo(r - e), A = Math.min(Math.abs(r - e), 359.999);
  return n * A;
}, $f = function(e) {
  var r = e.cx, n = e.cy, A = e.radius, i = e.angle, o = e.sign, s = e.isExternal, a = e.cornerRadius, c = e.cornerIsExternal, l = a * (s ? 1 : -1) + A, u = Math.asin(a / l) / Cp, f = c ? i : i + o * u, d = CA(r, n, l, f), g = CA(r, n, A, f), m = c ? i - o * u : i, p = CA(r, n, l * Math.cos(u * Cp), m);
  return {
    center: d,
    circleTangency: g,
    lineTangency: p,
    theta: u
  };
}, xU = function(e) {
  var r = e.cx, n = e.cy, A = e.innerRadius, i = e.outerRadius, o = e.startAngle, s = e.endAngle, a = lCe(o, s), c = o + a, l = CA(r, n, i, o), u = CA(r, n, i, c), f = "M ".concat(l.x, ",").concat(l.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(a) > 180), ",").concat(+(o > c), `,
    `).concat(u.x, ",").concat(u.y, `
  `);
  if (A > 0) {
    var d = CA(r, n, A, o), g = CA(r, n, A, c);
    f += "L ".concat(g.x, ",").concat(g.y, `
            A `).concat(A, ",").concat(A, `,0,
            `).concat(+(Math.abs(a) > 180), ",").concat(+(o <= c), `,
            `).concat(d.x, ",").concat(d.y, " Z");
  } else
    f += "L ".concat(r, ",").concat(n, " Z");
  return f;
}, uCe = function(e) {
  var r = e.cx, n = e.cy, A = e.innerRadius, i = e.outerRadius, o = e.cornerRadius, s = e.forceCornerRadius, a = e.cornerIsExternal, c = e.startAngle, l = e.endAngle, u = uo(l - c), f = $f({
    cx: r,
    cy: n,
    radius: i,
    angle: c,
    sign: u,
    cornerRadius: o,
    cornerIsExternal: a
  }), d = f.circleTangency, g = f.lineTangency, m = f.theta, p = $f({
    cx: r,
    cy: n,
    radius: i,
    angle: l,
    sign: -u,
    cornerRadius: o,
    cornerIsExternal: a
  }), v = p.circleTangency, C = p.lineTangency, w = p.theta, B = a ? Math.abs(c - l) : Math.abs(c - l) - m - w;
  if (B < 0)
    return s ? "M ".concat(g.x, ",").concat(g.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : xU({
      cx: r,
      cy: n,
      innerRadius: A,
      outerRadius: i,
      startAngle: c,
      endAngle: l
    });
  var y = "M ".concat(g.x, ",").concat(g.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(u < 0), ",").concat(d.x, ",").concat(d.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(B > 180), ",").concat(+(u < 0), ",").concat(v.x, ",").concat(v.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(u < 0), ",").concat(C.x, ",").concat(C.y, `
  `);
  if (A > 0) {
    var b = $f({
      cx: r,
      cy: n,
      radius: A,
      angle: c,
      sign: u,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: a
    }), q = b.circleTangency, E = b.lineTangency, x = b.theta, M = $f({
      cx: r,
      cy: n,
      radius: A,
      angle: l,
      sign: -u,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: a
    }), O = M.circleTangency, I = M.lineTangency, S = M.theta, P = a ? Math.abs(c - l) : Math.abs(c - l) - x - S;
    if (P < 0 && o === 0)
      return "".concat(y, "L").concat(r, ",").concat(n, "Z");
    y += "L".concat(I.x, ",").concat(I.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(u < 0), ",").concat(O.x, ",").concat(O.y, `
      A`).concat(A, ",").concat(A, ",0,").concat(+(P > 180), ",").concat(+(u > 0), ",").concat(q.x, ",").concat(q.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(u < 0), ",").concat(E.x, ",").concat(E.y, "Z");
  } else
    y += "L".concat(r, ",").concat(n, "Z");
  return y;
}, dCe = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, IU = function(e) {
  var r = GI(GI({}, dCe), e), n = r.cx, A = r.cy, i = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, a = r.forceCornerRadius, c = r.cornerIsExternal, l = r.startAngle, u = r.endAngle, f = r.className;
  if (o < i || l === u)
    return null;
  var d = Br("recharts-sector", f), g = o - i, m = nl(s, g, 0, !0), p;
  return m > 0 && Math.abs(l - u) < 360 ? p = uCe({
    cx: n,
    cy: A,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(m, g / 2),
    forceCornerRadius: a,
    cornerIsExternal: c,
    startAngle: l,
    endAngle: u
  }) : p = xU({
    cx: n,
    cy: A,
    innerRadius: i,
    outerRadius: o,
    startAngle: l,
    endAngle: u
  }), /* @__PURE__ */ re.createElement("path", b8({}, cr(r, !0), {
    className: d,
    d: p,
    role: "img"
  }));
};
function J2(t) {
  "@babel/helpers - typeof";
  return J2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, J2(t);
}
function B8() {
  return B8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, B8.apply(this, arguments);
}
function RI(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zI(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? RI(Object(r), !0).forEach(function(n) {
      fCe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : RI(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function fCe(t, e, r) {
  return e = hCe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function hCe(t) {
  var e = pCe(t, "string");
  return J2(e) == "symbol" ? e : e + "";
}
function pCe(t, e) {
  if (J2(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (J2(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var YI = {
  curveBasisClosed: ffe,
  curveBasisOpen: hfe,
  curveBasis: dfe,
  curveBumpX: _1e,
  curveBumpY: $1e,
  curveLinearClosed: pfe,
  curveLinear: F4,
  curveMonotoneX: gfe,
  curveMonotoneY: mfe,
  curveNatural: vfe,
  curveStep: qfe,
  curveStepAfter: Cfe,
  curveStepBefore: yfe
}, eh = function(e) {
  return e.x === +e.x && e.y === +e.y;
}, B0 = function(e) {
  return e.x;
}, E0 = function(e) {
  return e.y;
}, gCe = function(e, r) {
  if (nr(e))
    return e;
  var n = "curve".concat(k4(e));
  return (n === "curveMonotone" || n === "curveBump") && r ? YI["".concat(n).concat(r === "vertical" ? "Y" : "X")] : YI[n] || F4;
}, mCe = function(e) {
  var r = e.type, n = r === void 0 ? "linear" : r, A = e.points, i = A === void 0 ? [] : A, o = e.baseLine, s = e.layout, a = e.connectNulls, c = a === void 0 ? !1 : a, l = gCe(n, s), u = c ? i.filter(function(m) {
    return eh(m);
  }) : i, f;
  if (Array.isArray(o)) {
    var d = c ? o.filter(function(m) {
      return eh(m);
    }) : o, g = u.map(function(m, p) {
      return zI(zI({}, m), {}, {
        base: d[p]
      });
    });
    return s === "vertical" ? f = zf().y(E0).x1(B0).x0(function(m) {
      return m.base.x;
    }) : f = zf().x(B0).y1(E0).y0(function(m) {
      return m.base.y;
    }), f.defined(eh).curve(l), f(g);
  }
  return s === "vertical" && At(o) ? f = zf().y(E0).x1(B0).x0(o) : At(o) ? f = zf().x(B0).y1(E0).y0(o) : f = ID().x(B0).y(E0), f.defined(eh).curve(l), f(u);
}, du = function(e) {
  var r = e.className, n = e.points, A = e.path, i = e.pathRef;
  if ((!n || !n.length) && !A)
    return null;
  var o = n && n.length ? mCe(e) : A;
  return /* @__PURE__ */ re.createElement("path", B8({}, cr(e, !1), z3(e), {
    className: Br("recharts-curve", r),
    d: o,
    ref: i
  }));
}, vCe = Object.getOwnPropertyNames, qCe = Object.getOwnPropertySymbols, yCe = Object.prototype.hasOwnProperty;
function VI(t, e) {
  return function(n, A, i) {
    return t(n, A, i) && e(n, A, i);
  };
}
function th(t) {
  return function(r, n, A) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return t(r, n, A);
    var i = A.cache, o = i.get(r), s = i.get(n);
    if (o && s)
      return o === n && s === r;
    i.set(r, n), i.set(n, r);
    var a = t(r, n, A);
    return i.delete(r), i.delete(n), a;
  };
}
function WI(t) {
  return vCe(t).concat(qCe(t));
}
var CCe = Object.hasOwn || function(t, e) {
  return yCe.call(t, e);
};
function pl(t, e) {
  return t === e || !t && !e && t !== t && e !== e;
}
var wCe = "__v", bCe = "__o", BCe = "_owner", XI = Object.getOwnPropertyDescriptor, KI = Object.keys;
function ECe(t, e, r) {
  var n = t.length;
  if (e.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(t[n], e[n], n, n, t, e, r))
      return !1;
  return !0;
}
function xCe(t, e) {
  return pl(t.getTime(), e.getTime());
}
function ICe(t, e) {
  return t.name === e.name && t.message === e.message && t.cause === e.cause && t.stack === e.stack;
}
function SCe(t, e) {
  return t === e;
}
function ZI(t, e, r) {
  var n = t.size;
  if (n !== e.size)
    return !1;
  if (!n)
    return !0;
  for (var A = new Array(n), i = t.entries(), o, s, a = 0; (o = i.next()) && !o.done; ) {
    for (var c = e.entries(), l = !1, u = 0; (s = c.next()) && !s.done; ) {
      if (A[u]) {
        u++;
        continue;
      }
      var f = o.value, d = s.value;
      if (r.equals(f[0], d[0], a, u, t, e, r) && r.equals(f[1], d[1], f[0], d[0], t, e, r)) {
        l = A[u] = !0;
        break;
      }
      u++;
    }
    if (!l)
      return !1;
    a++;
  }
  return !0;
}
var PCe = pl;
function kCe(t, e, r) {
  var n = KI(t), A = n.length;
  if (KI(e).length !== A)
    return !1;
  for (; A-- > 0; )
    if (!SU(t, e, r, n[A]))
      return !1;
  return !0;
}
function x0(t, e, r) {
  var n = WI(t), A = n.length;
  if (WI(e).length !== A)
    return !1;
  for (var i, o, s; A-- > 0; )
    if (i = n[A], !SU(t, e, r, i) || (o = XI(t, i), s = XI(e, i), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function OCe(t, e) {
  return pl(t.valueOf(), e.valueOf());
}
function FCe(t, e) {
  return t.source === e.source && t.flags === e.flags;
}
function JI(t, e, r) {
  var n = t.size;
  if (n !== e.size)
    return !1;
  if (!n)
    return !0;
  for (var A = new Array(n), i = t.values(), o, s; (o = i.next()) && !o.done; ) {
    for (var a = e.values(), c = !1, l = 0; (s = a.next()) && !s.done; ) {
      if (!A[l] && r.equals(o.value, s.value, o.value, s.value, t, e, r)) {
        c = A[l] = !0;
        break;
      }
      l++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function TCe(t, e) {
  var r = t.length;
  if (e.length !== r)
    return !1;
  for (; r-- > 0; )
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function MCe(t, e) {
  return t.hostname === e.hostname && t.pathname === e.pathname && t.protocol === e.protocol && t.port === e.port && t.hash === e.hash && t.username === e.username && t.password === e.password;
}
function SU(t, e, r, n) {
  return (n === BCe || n === bCe || n === wCe) && (t.$$typeof || e.$$typeof) ? !0 : CCe(e, n) && r.equals(t[n], e[n], n, n, t, e, r);
}
var HCe = "[object Arguments]", DCe = "[object Boolean]", QCe = "[object Date]", UCe = "[object Error]", NCe = "[object Map]", jCe = "[object Number]", LCe = "[object Object]", GCe = "[object RegExp]", RCe = "[object Set]", zCe = "[object String]", YCe = "[object URL]", VCe = Array.isArray, _I = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, $I = Object.assign, WCe = Object.prototype.toString.call.bind(Object.prototype.toString);
function XCe(t) {
  var e = t.areArraysEqual, r = t.areDatesEqual, n = t.areErrorsEqual, A = t.areFunctionsEqual, i = t.areMapsEqual, o = t.areNumbersEqual, s = t.areObjectsEqual, a = t.arePrimitiveWrappersEqual, c = t.areRegExpsEqual, l = t.areSetsEqual, u = t.areTypedArraysEqual, f = t.areUrlsEqual;
  return function(g, m, p) {
    if (g === m)
      return !0;
    if (g == null || m == null)
      return !1;
    var v = typeof g;
    if (v !== typeof m)
      return !1;
    if (v !== "object")
      return v === "number" ? o(g, m, p) : v === "function" ? A(g, m, p) : !1;
    var C = g.constructor;
    if (C !== m.constructor)
      return !1;
    if (C === Object)
      return s(g, m, p);
    if (VCe(g))
      return e(g, m, p);
    if (_I != null && _I(g))
      return u(g, m, p);
    if (C === Date)
      return r(g, m, p);
    if (C === RegExp)
      return c(g, m, p);
    if (C === Map)
      return i(g, m, p);
    if (C === Set)
      return l(g, m, p);
    var w = WCe(g);
    return w === QCe ? r(g, m, p) : w === GCe ? c(g, m, p) : w === NCe ? i(g, m, p) : w === RCe ? l(g, m, p) : w === LCe ? typeof g.then != "function" && typeof m.then != "function" && s(g, m, p) : w === YCe ? f(g, m, p) : w === UCe ? n(g, m, p) : w === HCe ? s(g, m, p) : w === DCe || w === jCe || w === zCe ? a(g, m, p) : !1;
  };
}
function KCe(t) {
  var e = t.circular, r = t.createCustomConfig, n = t.strict, A = {
    areArraysEqual: n ? x0 : ECe,
    areDatesEqual: xCe,
    areErrorsEqual: ICe,
    areFunctionsEqual: SCe,
    areMapsEqual: n ? VI(ZI, x0) : ZI,
    areNumbersEqual: PCe,
    areObjectsEqual: n ? x0 : kCe,
    arePrimitiveWrappersEqual: OCe,
    areRegExpsEqual: FCe,
    areSetsEqual: n ? VI(JI, x0) : JI,
    areTypedArraysEqual: n ? x0 : TCe,
    areUrlsEqual: MCe
  };
  if (r && (A = $I({}, A, r(A))), e) {
    var i = th(A.areArraysEqual), o = th(A.areMapsEqual), s = th(A.areObjectsEqual), a = th(A.areSetsEqual);
    A = $I({}, A, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: s,
      areSetsEqual: a
    });
  }
  return A;
}
function ZCe(t) {
  return function(e, r, n, A, i, o, s) {
    return t(e, r, s);
  };
}
function JCe(t) {
  var e = t.circular, r = t.comparator, n = t.createState, A = t.equals, i = t.strict;
  if (n)
    return function(a, c) {
      var l = n(), u = l.cache, f = u === void 0 ? e ? /* @__PURE__ */ new WeakMap() : void 0 : u, d = l.meta;
      return r(a, c, {
        cache: f,
        equals: A,
        meta: d,
        strict: i
      });
    };
  if (e)
    return function(a, c) {
      return r(a, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: A,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: A,
    meta: void 0,
    strict: i
  };
  return function(a, c) {
    return r(a, c, o);
  };
}
var _Ce = Ac();
Ac({ strict: !0 });
Ac({ circular: !0 });
Ac({
  circular: !0,
  strict: !0
});
Ac({
  createInternalComparator: function() {
    return pl;
  }
});
Ac({
  strict: !0,
  createInternalComparator: function() {
    return pl;
  }
});
Ac({
  circular: !0,
  createInternalComparator: function() {
    return pl;
  }
});
Ac({
  circular: !0,
  createInternalComparator: function() {
    return pl;
  },
  strict: !0
});
function Ac(t) {
  t === void 0 && (t = {});
  var e = t.circular, r = e === void 0 ? !1 : e, n = t.createInternalComparator, A = t.createState, i = t.strict, o = i === void 0 ? !1 : i, s = KCe(t), a = XCe(s), c = n ? n(a) : ZCe(a);
  return JCe({ circular: r, comparator: a, createState: A, equals: c, strict: o });
}
function $Ce(t) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(t);
}
function eS(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function A(i) {
    r < 0 && (r = i), i - r > e ? (t(i), r = -1) : $Ce(A);
  };
  requestAnimationFrame(n);
}
function E8(t) {
  "@babel/helpers - typeof";
  return E8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, E8(t);
}
function ewe(t) {
  return Awe(t) || nwe(t) || rwe(t) || twe();
}
function twe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rwe(t, e) {
  if (t) {
    if (typeof t == "string") return tS(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return tS(t, e);
  }
}
function tS(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function nwe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Awe(t) {
  if (Array.isArray(t)) return t;
}
function iwe() {
  var t = {}, e = function() {
    return null;
  }, r = !1, n = function A(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, s = ewe(o), a = s[0], c = s.slice(1);
        if (typeof a == "number") {
          eS(A.bind(null, c), a);
          return;
        }
        A(a), eS(A.bind(null, c));
        return;
      }
      E8(i) === "object" && (t = i, e(t)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return e = i, function() {
        e = function() {
          return null;
        };
      };
    }
  };
}
function _2(t) {
  "@babel/helpers - typeof";
  return _2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _2(t);
}
function rS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rS(Object(r), !0).forEach(function(n) {
      PU(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : rS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function PU(t, e, r) {
  return e = owe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function owe(t) {
  var e = swe(t, "string");
  return _2(e) === "symbol" ? e : String(e);
}
function swe(t, e) {
  if (_2(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (_2(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var awe = function(e, r) {
  return [Object.keys(e), Object.keys(r)].reduce(function(n, A) {
    return n.filter(function(i) {
      return A.includes(i);
    });
  });
}, cwe = function(e) {
  return e;
}, lwe = function(e) {
  return e.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, c2 = function(e, r) {
  return Object.keys(r).reduce(function(n, A) {
    return nS(nS({}, n), {}, PU({}, A, e(A, r[A])));
  }, {});
}, AS = function(e, r, n) {
  return e.map(function(A) {
    return "".concat(lwe(A), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, uwe = process.env.NODE_ENV !== "production", bp = function(e, r, n, A, i, o, s, a) {
  if (uwe && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, A, i, o, s, a], l = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[l++];
      }));
    }
};
function dwe(t, e) {
  return pwe(t) || hwe(t, e) || kU(t, e) || fwe();
}
function fwe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hwe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function pwe(t) {
  if (Array.isArray(t)) return t;
}
function gwe(t) {
  return qwe(t) || vwe(t) || kU(t) || mwe();
}
function mwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kU(t, e) {
  if (t) {
    if (typeof t == "string") return x8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return x8(t, e);
  }
}
function vwe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function qwe(t) {
  if (Array.isArray(t)) return x8(t);
}
function x8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var Bp = 1e-4, OU = function(e, r) {
  return [0, 3 * e, 3 * r - 6 * e, 3 * e - 3 * r + 1];
}, FU = function(e, r) {
  return e.map(function(n, A) {
    return n * Math.pow(r, A);
  }).reduce(function(n, A) {
    return n + A;
  });
}, iS = function(e, r) {
  return function(n) {
    var A = OU(e, r);
    return FU(A, n);
  };
}, ywe = function(e, r) {
  return function(n) {
    var A = OU(e, r), i = [].concat(gwe(A.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return FU(i, n);
  };
}, oS = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  var A = r[0], i = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        A = 0, i = 0, o = 1, s = 1;
        break;
      case "ease":
        A = 0.25, i = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        A = 0.42, i = 0, o = 1, s = 1;
        break;
      case "ease-out":
        A = 0.42, i = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        A = 0, i = 0, o = 0.58, s = 1;
        break;
      default: {
        var a = r[0].split("(");
        if (a[0] === "cubic-bezier" && a[1].split(")")[0].split(",").length === 4) {
          var c = a[1].split(")")[0].split(",").map(function(p) {
            return parseFloat(p);
          }), l = dwe(c, 4);
          A = l[0], i = l[1], o = l[2], s = l[3];
        } else
          bp(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  bp([A, o, i, s].every(function(p) {
    return typeof p == "number" && p >= 0 && p <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var u = iS(A, o), f = iS(i, s), d = ywe(A, o), g = function(v) {
    return v > 1 ? 1 : v < 0 ? 0 : v;
  }, m = function(v) {
    for (var C = v > 1 ? 1 : v, w = C, B = 0; B < 8; ++B) {
      var y = u(w) - C, b = d(w);
      if (Math.abs(y - C) < Bp || b < Bp)
        return f(w);
      w = g(w - y / b);
    }
    return f(w);
  };
  return m.isStepper = !1, m;
}, Cwe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.stiff, n = r === void 0 ? 100 : r, A = e.damping, i = A === void 0 ? 8 : A, o = e.dt, s = o === void 0 ? 17 : o, a = function(l, u, f) {
    var d = -(l - u) * n, g = f * i, m = f + (d - g) * s / 1e3, p = f * s / 1e3 + l;
    return Math.abs(p - u) < Bp && Math.abs(m) < Bp ? [u, 0] : [p, m];
  };
  return a.isStepper = !0, a.dt = s, a;
}, wwe = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  var A = r[0];
  if (typeof A == "string")
    switch (A) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return oS(A);
      case "spring":
        return Cwe();
      default:
        if (A.split("(")[0] === "cubic-bezier")
          return oS(A);
        bp(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof A == "function" ? A : (bp(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function $2(t) {
  "@babel/helpers - typeof";
  return $2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $2(t);
}
function sS(t) {
  return Ewe(t) || Bwe(t) || TU(t) || bwe();
}
function bwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bwe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Ewe(t) {
  if (Array.isArray(t)) return S8(t);
}
function aS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hA(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? aS(Object(r), !0).forEach(function(n) {
      I8(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : aS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function I8(t, e, r) {
  return e = xwe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function xwe(t) {
  var e = Iwe(t, "string");
  return $2(e) === "symbol" ? e : String(e);
}
function Iwe(t, e) {
  if ($2(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if ($2(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Swe(t, e) {
  return Owe(t) || kwe(t, e) || TU(t, e) || Pwe();
}
function Pwe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TU(t, e) {
  if (t) {
    if (typeof t == "string") return S8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return S8(t, e);
  }
}
function S8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function kwe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function Owe(t) {
  if (Array.isArray(t)) return t;
}
var Ep = function(e, r, n) {
  return e + (r - e) * n;
}, P8 = function(e) {
  var r = e.from, n = e.to;
  return r !== n;
}, Fwe = function t(e, r, n) {
  var A = c2(function(i, o) {
    if (P8(o)) {
      var s = e(o.from, o.to, o.velocity), a = Swe(s, 2), c = a[0], l = a[1];
      return hA(hA({}, o), {}, {
        from: c,
        velocity: l
      });
    }
    return o;
  }, r);
  return n < 1 ? c2(function(i, o) {
    return P8(o) ? hA(hA({}, o), {}, {
      velocity: Ep(o.velocity, A[i].velocity, n),
      from: Ep(o.from, A[i].from, n)
    }) : o;
  }, r) : t(e, A, n - 1);
};
const Twe = function(t, e, r, n, A) {
  var i = awe(t, e), o = i.reduce(function(p, v) {
    return hA(hA({}, p), {}, I8({}, v, [t[v], e[v]]));
  }, {}), s = i.reduce(function(p, v) {
    return hA(hA({}, p), {}, I8({}, v, {
      from: t[v],
      velocity: 0,
      to: e[v]
    }));
  }, {}), a = -1, c, l, u = function() {
    return null;
  }, f = function() {
    return c2(function(v, C) {
      return C.from;
    }, s);
  }, d = function() {
    return !Object.values(s).filter(P8).length;
  }, g = function(v) {
    c || (c = v);
    var C = v - c, w = C / r.dt;
    s = Fwe(r, s, w), A(hA(hA(hA({}, t), e), f())), c = v, d() || (a = requestAnimationFrame(u));
  }, m = function(v) {
    l || (l = v);
    var C = (v - l) / n, w = c2(function(y, b) {
      return Ep.apply(void 0, sS(b).concat([r(C)]));
    }, o);
    if (A(hA(hA(hA({}, t), e), w)), C < 1)
      a = requestAnimationFrame(u);
    else {
      var B = c2(function(y, b) {
        return Ep.apply(void 0, sS(b).concat([r(1)]));
      }, o);
      A(hA(hA(hA({}, t), e), B));
    }
  };
  return u = r.isStepper ? g : m, function() {
    return requestAnimationFrame(u), function() {
      cancelAnimationFrame(a);
    };
  };
};
function _u(t) {
  "@babel/helpers - typeof";
  return _u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _u(t);
}
var Mwe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function Hwe(t, e) {
  if (t == null) return {};
  var r = Dwe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Dwe(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), A, i;
  for (i = 0; i < n.length; i++)
    A = n[i], !(e.indexOf(A) >= 0) && (r[A] = t[A]);
  return r;
}
function j6(t) {
  return jwe(t) || Nwe(t) || Uwe(t) || Qwe();
}
function Qwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Uwe(t, e) {
  if (t) {
    if (typeof t == "string") return k8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return k8(t, e);
  }
}
function Nwe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function jwe(t) {
  if (Array.isArray(t)) return k8(t);
}
function k8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function cS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _i(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cS(Object(r), !0).forEach(function(n) {
      N0(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : cS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function N0(t, e, r) {
  return e = MU(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Lwe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Gwe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, MU(n.key), n);
  }
}
function Rwe(t, e, r) {
  return Gwe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function MU(t) {
  var e = zwe(t, "string");
  return _u(e) === "symbol" ? e : String(e);
}
function zwe(t, e) {
  if (_u(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (_u(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Ywe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && O8(t, e);
}
function O8(t, e) {
  return O8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, O8(t, e);
}
function Vwe(t) {
  var e = Wwe();
  return function() {
    var n = xp(t), A;
    if (e) {
      var i = xp(this).constructor;
      A = Reflect.construct(n, arguments, i);
    } else
      A = n.apply(this, arguments);
    return F8(this, A);
  };
}
function F8(t, e) {
  if (e && (_u(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return T8(t);
}
function T8(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Wwe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function xp(t) {
  return xp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, xp(t);
}
var $o = /* @__PURE__ */ function(t) {
  Ywe(r, t);
  var e = Vwe(r);
  function r(n, A) {
    var i;
    Lwe(this, r), i = e.call(this, n, A);
    var o = i.props, s = o.isActive, a = o.attributeName, c = o.from, l = o.to, u = o.steps, f = o.children, d = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(T8(i)), i.changeStyle = i.changeStyle.bind(T8(i)), !s || d <= 0)
      return i.state = {
        style: {}
      }, typeof f == "function" && (i.state = {
        style: l
      }), F8(i);
    if (u && u.length)
      i.state = {
        style: u[0].style
      };
    else if (c) {
      if (typeof f == "function")
        return i.state = {
          style: c
        }, F8(i);
      i.state = {
        style: a ? N0({}, a, c) : c
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return Rwe(r, [{
    key: "componentDidMount",
    value: function() {
      var A = this.props, i = A.isActive, o = A.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(A) {
      var i = this.props, o = i.isActive, s = i.canBegin, a = i.attributeName, c = i.shouldReAnimate, l = i.to, u = i.from, f = this.state.style;
      if (s) {
        if (!o) {
          var d = {
            style: a ? N0({}, a, l) : l
          };
          this.state && f && (a && f[a] !== l || !a && f !== l) && this.setState(d);
          return;
        }
        if (!(_Ce(A.to, l) && A.canBegin && A.isActive)) {
          var g = !A.canBegin || !A.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var m = g || c ? u : A.to;
          if (this.state && f) {
            var p = {
              style: a ? N0({}, a, m) : m
            };
            (a && f[a] !== m || !a && f !== m) && this.setState(p);
          }
          this.runAnimation(_i(_i({}, this.props), {}, {
            from: m,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var A = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), A && A();
    }
  }, {
    key: "handleStyleChange",
    value: function(A) {
      this.changeStyle(A);
    }
  }, {
    key: "changeStyle",
    value: function(A) {
      this.mounted && this.setState({
        style: A
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(A) {
      var i = this, o = A.from, s = A.to, a = A.duration, c = A.easing, l = A.begin, u = A.onAnimationEnd, f = A.onAnimationStart, d = Twe(o, s, wwe(c), a, this.changeStyle), g = function() {
        i.stopJSAnimation = d();
      };
      this.manager.start([f, l, g, a, u]);
    }
  }, {
    key: "runStepAnimation",
    value: function(A) {
      var i = this, o = A.steps, s = A.begin, a = A.onAnimationStart, c = o[0], l = c.style, u = c.duration, f = u === void 0 ? 0 : u, d = function(m, p, v) {
        if (v === 0)
          return m;
        var C = p.duration, w = p.easing, B = w === void 0 ? "ease" : w, y = p.style, b = p.properties, q = p.onAnimationEnd, E = v > 0 ? o[v - 1] : p, x = b || Object.keys(y);
        if (typeof B == "function" || B === "spring")
          return [].concat(j6(m), [i.runJSAnimation.bind(i, {
            from: E.style,
            to: y,
            duration: C,
            easing: B
          }), C]);
        var M = AS(x, C, B), O = _i(_i(_i({}, E.style), y), {}, {
          transition: M
        });
        return [].concat(j6(m), [O, C, q]).filter(cwe);
      };
      return this.manager.start([a].concat(j6(o.reduce(d, [l, Math.max(f, s)])), [A.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(A) {
      this.manager || (this.manager = iwe());
      var i = A.begin, o = A.duration, s = A.attributeName, a = A.to, c = A.easing, l = A.onAnimationStart, u = A.onAnimationEnd, f = A.steps, d = A.children, g = this.manager;
      if (this.unSubscribe = g.subscribe(this.handleStyleChange), typeof c == "function" || typeof d == "function" || c === "spring") {
        this.runJSAnimation(A);
        return;
      }
      if (f.length > 1) {
        this.runStepAnimation(A);
        return;
      }
      var m = s ? N0({}, s, a) : a, p = AS(Object.keys(m), o, c);
      g.start([l, i, _i(_i({}, m), {}, {
        transition: p
      }), o, u]);
    }
  }, {
    key: "render",
    value: function() {
      var A = this.props, i = A.children;
      A.begin;
      var o = A.duration;
      A.attributeName, A.easing;
      var s = A.isActive;
      A.steps, A.from, A.to, A.canBegin, A.onAnimationEnd, A.shouldReAnimate, A.onAnimationReStart;
      var a = Hwe(A, Mwe), c = xa.count(i), l = this.state.style;
      if (typeof i == "function")
        return i(l);
      if (!s || c === 0 || o <= 0)
        return i;
      var u = function(d) {
        var g = d.props, m = g.style, p = m === void 0 ? {} : m, v = g.className, C = /* @__PURE__ */ vn(d, _i(_i({}, a), {}, {
          style: _i(_i({}, p), l),
          className: v
        }));
        return C;
      };
      return c === 1 ? u(xa.only(i)) : /* @__PURE__ */ re.createElement("div", null, xa.map(i, function(f) {
        return u(f);
      }));
    }
  }]), r;
}(es);
$o.displayName = "Animate";
$o.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
$o.propTypes = {
  from: Dt.oneOfType([Dt.object, Dt.string]),
  to: Dt.oneOfType([Dt.object, Dt.string]),
  attributeName: Dt.string,
  // animation duration
  duration: Dt.number,
  begin: Dt.number,
  easing: Dt.oneOfType([Dt.string, Dt.func]),
  steps: Dt.arrayOf(Dt.shape({
    duration: Dt.number.isRequired,
    style: Dt.object.isRequired,
    easing: Dt.oneOfType([Dt.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Dt.func]),
    // transition css properties(dash case), optional
    properties: Dt.arrayOf("string"),
    onAnimationEnd: Dt.func
  })),
  children: Dt.oneOfType([Dt.node, Dt.func]),
  isActive: Dt.bool,
  canBegin: Dt.bool,
  onAnimationEnd: Dt.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Dt.bool,
  onAnimationStart: Dt.func,
  onAnimationReStart: Dt.func
};
function e1(t) {
  "@babel/helpers - typeof";
  return e1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, e1(t);
}
function Ip() {
  return Ip = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ip.apply(this, arguments);
}
function Xwe(t, e) {
  return _we(t) || Jwe(t, e) || Zwe(t, e) || Kwe();
}
function Kwe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zwe(t, e) {
  if (t) {
    if (typeof t == "string") return lS(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return lS(t, e);
  }
}
function lS(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Jwe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function _we(t) {
  if (Array.isArray(t)) return t;
}
function uS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? uS(Object(r), !0).forEach(function(n) {
      $we(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : uS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function $we(t, e, r) {
  return e = ebe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ebe(t) {
  var e = tbe(t, "string");
  return e1(e) == "symbol" ? e : e + "";
}
function tbe(t, e) {
  if (e1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (e1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var fS = function(e, r, n, A, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(A) / 2), s = A >= 0 ? 1 : -1, a = n >= 0 ? 1 : -1, c = A >= 0 && n >= 0 || A < 0 && n < 0 ? 1 : 0, l;
  if (o > 0 && i instanceof Array) {
    for (var u = [0, 0, 0, 0], f = 0, d = 4; f < d; f++)
      u[f] = i[f] > o ? o : i[f];
    l = "M".concat(e, ",").concat(r + s * u[0]), u[0] > 0 && (l += "A ".concat(u[0], ",").concat(u[0], ",0,0,").concat(c, ",").concat(e + a * u[0], ",").concat(r)), l += "L ".concat(e + n - a * u[1], ",").concat(r), u[1] > 0 && (l += "A ".concat(u[1], ",").concat(u[1], ",0,0,").concat(c, `,
        `).concat(e + n, ",").concat(r + s * u[1])), l += "L ".concat(e + n, ",").concat(r + A - s * u[2]), u[2] > 0 && (l += "A ".concat(u[2], ",").concat(u[2], ",0,0,").concat(c, `,
        `).concat(e + n - a * u[2], ",").concat(r + A)), l += "L ".concat(e + a * u[3], ",").concat(r + A), u[3] > 0 && (l += "A ".concat(u[3], ",").concat(u[3], ",0,0,").concat(c, `,
        `).concat(e, ",").concat(r + A - s * u[3])), l += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var g = Math.min(o, i);
    l = "M ".concat(e, ",").concat(r + s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e + a * g, ",").concat(r, `
            L `).concat(e + n - a * g, ",").concat(r, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e + n, ",").concat(r + s * g, `
            L `).concat(e + n, ",").concat(r + A - s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e + n - a * g, ",").concat(r + A, `
            L `).concat(e + a * g, ",").concat(r + A, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e, ",").concat(r + A - s * g, " Z");
  } else
    l = "M ".concat(e, ",").concat(r, " h ").concat(n, " v ").concat(A, " h ").concat(-n, " Z");
  return l;
}, rbe = function(e, r) {
  if (!e || !r)
    return !1;
  var n = e.x, A = e.y, i = r.x, o = r.y, s = r.width, a = r.height;
  if (Math.abs(s) > 0 && Math.abs(a) > 0) {
    var c = Math.min(i, i + s), l = Math.max(i, i + s), u = Math.min(o, o + a), f = Math.max(o, o + a);
    return n >= c && n <= l && A >= u && A <= f;
  }
  return !1;
}, nbe = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, $q = function(e) {
  var r = dS(dS({}, nbe), e), n = gt(), A = N(-1), i = Xwe(A, 2), o = i[0], s = i[1];
  le(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var B = n.current.getTotalLength();
        B && s(B);
      } catch {
      }
  }, []);
  var a = r.x, c = r.y, l = r.width, u = r.height, f = r.radius, d = r.className, g = r.animationEasing, m = r.animationDuration, p = r.animationBegin, v = r.isAnimationActive, C = r.isUpdateAnimationActive;
  if (a !== +a || c !== +c || l !== +l || u !== +u || l === 0 || u === 0)
    return null;
  var w = Br("recharts-rectangle", d);
  return C ? /* @__PURE__ */ re.createElement($o, {
    canBegin: o > 0,
    from: {
      width: l,
      height: u,
      x: a,
      y: c
    },
    to: {
      width: l,
      height: u,
      x: a,
      y: c
    },
    duration: m,
    animationEasing: g,
    isActive: C
  }, function(B) {
    var y = B.width, b = B.height, q = B.x, E = B.y;
    return /* @__PURE__ */ re.createElement($o, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: p,
      duration: m,
      isActive: v,
      easing: g
    }, /* @__PURE__ */ re.createElement("path", Ip({}, cr(r, !0), {
      className: w,
      d: fS(q, E, y, b, f),
      ref: n
    })));
  }) : /* @__PURE__ */ re.createElement("path", Ip({}, cr(r, !0), {
    className: w,
    d: fS(a, c, l, u, f)
  }));
};
function M8() {
  return M8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, M8.apply(this, arguments);
}
var V4 = function(e) {
  var r = e.cx, n = e.cy, A = e.r, i = e.className, o = Br("recharts-dot", i);
  return r === +r && n === +n && A === +A ? /* @__PURE__ */ re.createElement("circle", M8({}, cr(e, !1), z3(e), {
    className: o,
    cx: r,
    cy: n,
    r: A
  })) : null;
};
function t1(t) {
  "@babel/helpers - typeof";
  return t1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, t1(t);
}
var Abe = ["x", "y", "top", "left", "width", "height", "className"];
function H8() {
  return H8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, H8.apply(this, arguments);
}
function hS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ibe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hS(Object(r), !0).forEach(function(n) {
      obe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : hS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function obe(t, e, r) {
  return e = sbe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function sbe(t) {
  var e = abe(t, "string");
  return t1(e) == "symbol" ? e : e + "";
}
function abe(t, e) {
  if (t1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (t1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function cbe(t, e) {
  if (t == null) return {};
  var r = lbe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function lbe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var ube = function(e, r, n, A, i, o) {
  return "M".concat(e, ",").concat(i, "v").concat(A, "M").concat(o, ",").concat(r, "h").concat(n);
}, dbe = function(e) {
  var r = e.x, n = r === void 0 ? 0 : r, A = e.y, i = A === void 0 ? 0 : A, o = e.top, s = o === void 0 ? 0 : o, a = e.left, c = a === void 0 ? 0 : a, l = e.width, u = l === void 0 ? 0 : l, f = e.height, d = f === void 0 ? 0 : f, g = e.className, m = cbe(e, Abe), p = ibe({
    x: n,
    y: i,
    top: s,
    left: c,
    width: u,
    height: d
  }, m);
  return !At(n) || !At(i) || !At(u) || !At(d) || !At(s) || !At(c) ? null : /* @__PURE__ */ re.createElement("path", H8({}, cr(p, !0), {
    className: Br("recharts-cross", g),
    d: ube(n, i, u, d, s, c)
  }));
}, fbe = JD, hbe = fbe(Object.getPrototypeOf, Object), pbe = hbe, gbe = zs, mbe = pbe, vbe = Ys, qbe = "[object Object]", ybe = Function.prototype, Cbe = Object.prototype, HU = ybe.toString, wbe = Cbe.hasOwnProperty, bbe = HU.call(Object);
function Bbe(t) {
  if (!vbe(t) || gbe(t) != qbe)
    return !1;
  var e = mbe(t);
  if (e === null)
    return !0;
  var r = wbe.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && HU.call(r) == bbe;
}
var Ebe = Bbe;
const xbe = /* @__PURE__ */ Vr(Ebe);
var Ibe = zs, Sbe = Ys, Pbe = "[object Boolean]";
function kbe(t) {
  return t === !0 || t === !1 || Sbe(t) && Ibe(t) == Pbe;
}
var Obe = kbe;
const Fbe = /* @__PURE__ */ Vr(Obe);
function r1(t) {
  "@babel/helpers - typeof";
  return r1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, r1(t);
}
function Sp() {
  return Sp = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Sp.apply(this, arguments);
}
function Tbe(t, e) {
  return Qbe(t) || Dbe(t, e) || Hbe(t, e) || Mbe();
}
function Mbe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hbe(t, e) {
  if (t) {
    if (typeof t == "string") return pS(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return pS(t, e);
  }
}
function pS(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Dbe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function Qbe(t) {
  if (Array.isArray(t)) return t;
}
function gS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gS(Object(r), !0).forEach(function(n) {
      Ube(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : gS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Ube(t, e, r) {
  return e = Nbe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Nbe(t) {
  var e = jbe(t, "string");
  return r1(e) == "symbol" ? e : e + "";
}
function jbe(t, e) {
  if (r1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (r1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var vS = function(e, r, n, A, i) {
  var o = n - A, s;
  return s = "M ".concat(e, ",").concat(r), s += "L ".concat(e + n, ",").concat(r), s += "L ".concat(e + n - o / 2, ",").concat(r + i), s += "L ".concat(e + n - o / 2 - A, ",").concat(r + i), s += "L ".concat(e, ",").concat(r, " Z"), s;
}, Lbe = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Gbe = function(e) {
  var r = mS(mS({}, Lbe), e), n = gt(), A = N(-1), i = Tbe(A, 2), o = i[0], s = i[1];
  le(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var a = r.x, c = r.y, l = r.upperWidth, u = r.lowerWidth, f = r.height, d = r.className, g = r.animationEasing, m = r.animationDuration, p = r.animationBegin, v = r.isUpdateAnimationActive;
  if (a !== +a || c !== +c || l !== +l || u !== +u || f !== +f || l === 0 && u === 0 || f === 0)
    return null;
  var C = Br("recharts-trapezoid", d);
  return v ? /* @__PURE__ */ re.createElement($o, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: f,
      x: a,
      y: c
    },
    to: {
      upperWidth: l,
      lowerWidth: u,
      height: f,
      x: a,
      y: c
    },
    duration: m,
    animationEasing: g,
    isActive: v
  }, function(w) {
    var B = w.upperWidth, y = w.lowerWidth, b = w.height, q = w.x, E = w.y;
    return /* @__PURE__ */ re.createElement($o, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: p,
      duration: m,
      easing: g
    }, /* @__PURE__ */ re.createElement("path", Sp({}, cr(r, !0), {
      className: C,
      d: vS(q, E, B, y, b),
      ref: n
    })));
  }) : /* @__PURE__ */ re.createElement("g", null, /* @__PURE__ */ re.createElement("path", Sp({}, cr(r, !0), {
    className: C,
    d: vS(a, c, l, u, f)
  })));
}, Rbe = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function n1(t) {
  "@babel/helpers - typeof";
  return n1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, n1(t);
}
function zbe(t, e) {
  if (t == null) return {};
  var r = Ybe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Ybe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function qS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pp(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qS(Object(r), !0).forEach(function(n) {
      Vbe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Vbe(t, e, r) {
  return e = Wbe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Wbe(t) {
  var e = Xbe(t, "string");
  return n1(e) == "symbol" ? e : e + "";
}
function Xbe(t, e) {
  if (n1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (n1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Kbe(t, e) {
  return Pp(Pp({}, e), t);
}
function Zbe(t, e) {
  return t === "symbols";
}
function yS(t) {
  var e = t.shapeType, r = t.elementProps;
  switch (e) {
    case "rectangle":
      return /* @__PURE__ */ re.createElement($q, r);
    case "trapezoid":
      return /* @__PURE__ */ re.createElement(Gbe, r);
    case "sector":
      return /* @__PURE__ */ re.createElement(IU, r);
    case "symbols":
      if (Zbe(e))
        return /* @__PURE__ */ re.createElement(mq, r);
      break;
    default:
      return null;
  }
}
function Jbe(t) {
  return /* @__PURE__ */ QA(t) ? t.props : t;
}
function _be(t) {
  var e = t.option, r = t.shapeType, n = t.propTransformer, A = n === void 0 ? Kbe : n, i = t.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, s = t.isActive, a = zbe(t, Rbe), c;
  if (/* @__PURE__ */ QA(e))
    c = /* @__PURE__ */ vn(e, Pp(Pp({}, a), Jbe(e)));
  else if (nr(e))
    c = e(a);
  else if (xbe(e) && !Fbe(e)) {
    var l = A(e, a);
    c = /* @__PURE__ */ re.createElement(yS, {
      shapeType: r,
      elementProps: l
    });
  } else {
    var u = a;
    c = /* @__PURE__ */ re.createElement(yS, {
      shapeType: r,
      elementProps: u
    });
  }
  return s ? /* @__PURE__ */ re.createElement(_r, {
    className: o
  }, c) : c;
}
function W4(t, e) {
  return e != null && "trapezoids" in t.props;
}
function X4(t, e) {
  return e != null && "sectors" in t.props;
}
function A1(t, e) {
  return e != null && "points" in t.props;
}
function $be(t, e) {
  var r, n, A = t.x === (e == null || (r = e.labelViewBox) === null || r === void 0 ? void 0 : r.x) || t.x === e.x, i = t.y === (e == null || (n = e.labelViewBox) === null || n === void 0 ? void 0 : n.y) || t.y === e.y;
  return A && i;
}
function eBe(t, e) {
  var r = t.endAngle === e.endAngle, n = t.startAngle === e.startAngle;
  return r && n;
}
function tBe(t, e) {
  var r = t.x === e.x, n = t.y === e.y, A = t.z === e.z;
  return r && n && A;
}
function rBe(t, e) {
  var r;
  return W4(t, e) ? r = $be : X4(t, e) ? r = eBe : A1(t, e) && (r = tBe), r;
}
function nBe(t, e) {
  var r;
  return W4(t, e) ? r = "trapezoids" : X4(t, e) ? r = "sectors" : A1(t, e) && (r = "points"), r;
}
function ABe(t, e) {
  if (W4(t, e)) {
    var r;
    return (r = e.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (X4(t, e)) {
    var n;
    return (n = e.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return A1(t, e) ? e.payload : {};
}
function iBe(t) {
  var e = t.activeTooltipItem, r = t.graphicalItem, n = t.itemData, A = nBe(r, e), i = ABe(r, e), o = n.filter(function(a, c) {
    var l = Zu(i, a), u = r.props[A].filter(function(g) {
      var m = rBe(r, e);
      return m(g, e);
    }), f = r.props[A].indexOf(u[u.length - 1]), d = c === f;
    return l && d;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var oBe = Math.ceil, sBe = Math.max;
function aBe(t, e, r, n) {
  for (var A = -1, i = sBe(oBe((e - t) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++A] = t, t += r;
  return o;
}
var cBe = aBe, lBe = gQ, uBe = 1 / 0, dBe = 17976931348623157e292;
function fBe(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = lBe(t), t === uBe || t === -1 / 0) {
    var e = t < 0 ? -1 : 1;
    return e * dBe;
  }
  return t === t ? t : 0;
}
var DU = fBe, hBe = cBe, pBe = D4, L6 = DU;
function gBe(t) {
  return function(e, r, n) {
    return n && typeof n != "number" && pBe(e, r, n) && (r = n = void 0), e = L6(e), r === void 0 ? (r = e, e = 0) : r = L6(r), n = n === void 0 ? e < r ? 1 : -1 : L6(n), hBe(e, r, n, t);
  };
}
var mBe = gBe, vBe = mBe, qBe = vBe(), yBe = qBe;
const kp = /* @__PURE__ */ Vr(yBe);
function i1(t) {
  "@babel/helpers - typeof";
  return i1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, i1(t);
}
function CS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? CS(Object(r), !0).forEach(function(n) {
      QU(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : CS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function QU(t, e, r) {
  return e = CBe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function CBe(t) {
  var e = wBe(t, "string");
  return i1(e) == "symbol" ? e : e + "";
}
function wBe(t, e) {
  if (i1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (i1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var bBe = ["Webkit", "Moz", "O", "ms"], BBe = function(e, r) {
  var n = e.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), A = bBe.reduce(function(i, o) {
    return wS(wS({}, i), {}, QU({}, o + n, r));
  }, {});
  return A[e] = r, A;
};
function $u(t) {
  "@babel/helpers - typeof";
  return $u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $u(t);
}
function Op() {
  return Op = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Op.apply(this, arguments);
}
function bS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function G6(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bS(Object(r), !0).forEach(function(n) {
      gi(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : bS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function EBe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function BS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, NU(n.key), n);
  }
}
function xBe(t, e, r) {
  return BS(t.prototype, e), BS(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function IBe(t, e, r) {
  return e = Fp(e), SBe(t, UU() ? Reflect.construct(e, r, Fp(t).constructor) : e.apply(t, r));
}
function SBe(t, e) {
  if (e && ($u(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return PBe(t);
}
function PBe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function UU() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (UU = function() {
    return !!t;
  })();
}
function Fp(t) {
  return Fp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fp(t);
}
function kBe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && D8(t, e);
}
function D8(t, e) {
  return D8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, D8(t, e);
}
function gi(t, e, r) {
  return e = NU(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function NU(t) {
  var e = OBe(t, "string");
  return $u(e) == "symbol" ? e : e + "";
}
function OBe(t, e) {
  if ($u(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if ($u(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var FBe = function(e) {
  var r = e.data, n = e.startIndex, A = e.endIndex, i = e.x, o = e.width, s = e.travellerWidth;
  if (!r || !r.length)
    return {};
  var a = r.length, c = s2().domain(kp(0, a)).range([i, i + o - s]), l = c.domain().map(function(u) {
    return c(u);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(A),
    scale: c,
    scaleValues: l
  };
}, ES = function(e) {
  return e.changedTouches && !!e.changedTouches.length;
}, ed = /* @__PURE__ */ function(t) {
  function e(r) {
    var n;
    return EBe(this, e), n = IBe(this, e, [r]), gi(n, "handleDrag", function(A) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(A) : n.state.isSlideMoving && n.handleSlideDrag(A);
    }), gi(n, "handleTouchMove", function(A) {
      A.changedTouches != null && A.changedTouches.length > 0 && n.handleDrag(A.changedTouches[0]);
    }), gi(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var A = n.props, i = A.endIndex, o = A.onDragEnd, s = A.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), gi(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), gi(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), gi(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), gi(n, "handleSlideDragStart", function(A) {
      var i = ES(A) ? A.changedTouches[0] : A;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return kBe(e, t), xBe(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var A = n.startX, i = n.endX, o = this.state.scaleValues, s = this.props, a = s.gap, c = s.data, l = c.length - 1, u = Math.min(A, i), f = Math.max(A, i), d = e.getIndexInRange(o, u), g = e.getIndexInRange(o, f);
      return {
        startIndex: d - d % a,
        endIndex: g === l ? l : g - g % a
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var A = this.props, i = A.data, o = A.tickFormatter, s = A.dataKey, a = _A(i[n], s, n);
      return nr(o) ? o(a, n) : a;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var A = this.state, i = A.slideMoveStartX, o = A.startX, s = A.endX, a = this.props, c = a.x, l = a.width, u = a.travellerWidth, f = a.startIndex, d = a.endIndex, g = a.onChange, m = n.pageX - i;
      m > 0 ? m = Math.min(m, c + l - u - s, c + l - u - o) : m < 0 && (m = Math.max(m, c - o, c - s));
      var p = this.getIndex({
        startX: o + m,
        endX: s + m
      });
      (p.startIndex !== f || p.endIndex !== d) && g && g(p), this.setState({
        startX: o + m,
        endX: s + m,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, A) {
      var i = ES(A) ? A.changedTouches[0] : A;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var A = this.state, i = A.brushMoveStartX, o = A.movingTravellerId, s = A.endX, a = A.startX, c = this.state[o], l = this.props, u = l.x, f = l.width, d = l.travellerWidth, g = l.onChange, m = l.gap, p = l.data, v = {
        startX: this.state.startX,
        endX: this.state.endX
      }, C = n.pageX - i;
      C > 0 ? C = Math.min(C, u + f - d - c) : C < 0 && (C = Math.max(C, u - c)), v[o] = c + C;
      var w = this.getIndex(v), B = w.startIndex, y = w.endIndex, b = function() {
        var E = p.length - 1;
        return o === "startX" && (s > a ? B % m === 0 : y % m === 0) || s < a && y === E || o === "endX" && (s > a ? y % m === 0 : B % m === 0) || s > a && y === E;
      };
      this.setState(gi(gi({}, o, c + C), "brushMoveStartX", n.pageX), function() {
        g && b() && g(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, A) {
      var i = this, o = this.state, s = o.scaleValues, a = o.startX, c = o.endX, l = this.state[A], u = s.indexOf(l);
      if (u !== -1) {
        var f = u + n;
        if (!(f === -1 || f >= s.length)) {
          var d = s[f];
          A === "startX" && d >= c || A === "endX" && d <= a || this.setState(gi({}, A, d), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, A = n.x, i = n.y, o = n.width, s = n.height, a = n.fill, c = n.stroke;
      return /* @__PURE__ */ re.createElement("rect", {
        stroke: c,
        fill: a,
        x: A,
        y: i,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, A = n.x, i = n.y, o = n.width, s = n.height, a = n.data, c = n.children, l = n.padding, u = xa.only(c);
      return u ? /* @__PURE__ */ re.cloneElement(u, {
        x: A,
        y: i,
        width: o,
        height: s,
        margin: l,
        compact: !0,
        data: a
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, A) {
      var i, o, s = this, a = this.props, c = a.y, l = a.travellerWidth, u = a.height, f = a.traveller, d = a.ariaLabel, g = a.data, m = a.startIndex, p = a.endIndex, v = Math.max(n, this.props.x), C = G6(G6({}, cr(this.props, !1)), {}, {
        x: v,
        y: c,
        width: l,
        height: u
      }), w = d || "Min value: ".concat((i = g[m]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = g[p]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ re.createElement(_r, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[A],
        onTouchStart: this.travellerDragStartHandlers[A],
        onKeyDown: function(y) {
          ["ArrowLeft", "ArrowRight"].includes(y.key) && (y.preventDefault(), y.stopPropagation(), s.handleTravellerMoveKeyboard(y.key === "ArrowRight" ? 1 : -1, A));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, e.renderTraveller(f, C));
    }
  }, {
    key: "renderSlide",
    value: function(n, A) {
      var i = this.props, o = i.y, s = i.height, a = i.stroke, c = i.travellerWidth, l = Math.min(n, A) + c, u = Math.max(Math.abs(A - n) - c, 0);
      return /* @__PURE__ */ re.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: a,
        fillOpacity: 0.2,
        x: l,
        y: o,
        width: u,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, A = n.startIndex, i = n.endIndex, o = n.y, s = n.height, a = n.travellerWidth, c = n.stroke, l = this.state, u = l.startX, f = l.endX, d = 5, g = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ re.createElement(_r, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ re.createElement(ip, Op({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(u, f) - d,
        y: o + s / 2
      }, g), this.getTextOfTick(A)), /* @__PURE__ */ re.createElement(ip, Op({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(u, f) + a + d,
        y: o + s / 2
      }, g), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, A = n.data, i = n.className, o = n.children, s = n.x, a = n.y, c = n.width, l = n.height, u = n.alwaysShowText, f = this.state, d = f.startX, g = f.endX, m = f.isTextActive, p = f.isSlideMoving, v = f.isTravellerMoving, C = f.isTravellerFocused;
      if (!A || !A.length || !At(s) || !At(a) || !At(c) || !At(l) || c <= 0 || l <= 0)
        return null;
      var w = Br("recharts-brush", i), B = re.Children.count(o) === 1, y = BBe("userSelect", "none");
      return /* @__PURE__ */ re.createElement(_r, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: y
      }, this.renderBackground(), B && this.renderPanorama(), this.renderSlide(d, g), this.renderTravellerLayer(d, "startX"), this.renderTravellerLayer(g, "endX"), (m || p || v || C || u) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var A = n.x, i = n.y, o = n.width, s = n.height, a = n.stroke, c = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ re.createElement(re.Fragment, null, /* @__PURE__ */ re.createElement("rect", {
        x: A,
        y: i,
        width: o,
        height: s,
        fill: a,
        stroke: "none"
      }), /* @__PURE__ */ re.createElement("line", {
        x1: A + 1,
        y1: c,
        x2: A + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ re.createElement("line", {
        x1: A + 1,
        y1: c + 2,
        x2: A + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, A) {
      var i;
      return /* @__PURE__ */ re.isValidElement(n) ? i = /* @__PURE__ */ re.cloneElement(n, A) : nr(n) ? i = n(A) : i = e.renderDefaultTraveller(A), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, A) {
      var i = n.data, o = n.width, s = n.x, a = n.travellerWidth, c = n.updateId, l = n.startIndex, u = n.endIndex;
      if (i !== A.prevData || c !== A.prevUpdateId)
        return G6({
          prevData: i,
          prevTravellerWidth: a,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o
        }, i && i.length ? FBe({
          data: i,
          width: o,
          x: s,
          travellerWidth: a,
          startIndex: l,
          endIndex: u
        }) : {
          scale: null,
          scaleValues: null
        });
      if (A.scale && (o !== A.prevWidth || s !== A.prevX || a !== A.prevTravellerWidth)) {
        A.scale.range([s, s + o - a]);
        var f = A.scale.domain().map(function(d) {
          return A.scale(d);
        });
        return {
          prevData: i,
          prevTravellerWidth: a,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o,
          startX: A.scale(n.startIndex),
          endX: A.scale(n.endIndex),
          scaleValues: f
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, A) {
      for (var i = n.length, o = 0, s = i - 1; s - o > 1; ) {
        var a = Math.floor((o + s) / 2);
        n[a] > A ? s = a : o = a;
      }
      return A >= n[s] ? s : o;
    }
  }]);
}(es);
gi(ed, "displayName", "Brush");
gi(ed, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var TBe = Bq;
function MBe(t, e) {
  var r;
  return TBe(t, function(n, A, i) {
    return r = e(n, A, i), !r;
  }), !!r;
}
var HBe = MBe, DBe = RD, QBe = tc, UBe = HBe, NBe = li, jBe = D4;
function LBe(t, e, r) {
  var n = NBe(t) ? DBe : UBe;
  return r && jBe(t, e, r) && (e = void 0), n(t, QBe(e));
}
var GBe = LBe;
const RBe = /* @__PURE__ */ Vr(GBe);
var Ko = function(e, r) {
  var n = e.alwaysShow, A = e.ifOverflow;
  return n && (A = "extendDomain"), A === r;
}, xS = uQ;
function zBe(t, e, r) {
  e == "__proto__" && xS ? xS(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var YBe = zBe, VBe = YBe, WBe = cQ, XBe = tc;
function KBe(t, e) {
  var r = {};
  return e = XBe(e), WBe(t, function(n, A, i) {
    VBe(r, A, e(n, A, i));
  }), r;
}
var ZBe = KBe;
const JBe = /* @__PURE__ */ Vr(ZBe);
function _Be(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (!e(t[r], r, t))
      return !1;
  return !0;
}
var $Be = _Be, eEe = Bq;
function tEe(t, e) {
  var r = !0;
  return eEe(t, function(n, A, i) {
    return r = !!e(n, A, i), r;
  }), r;
}
var rEe = tEe, nEe = $Be, AEe = rEe, iEe = tc, oEe = li, sEe = D4;
function aEe(t, e, r) {
  var n = oEe(t) ? nEe : AEe;
  return r && sEe(t, e, r) && (e = void 0), n(t, iEe(e));
}
var cEe = aEe;
const jU = /* @__PURE__ */ Vr(cEe);
var lEe = ["x", "y"];
function td(t) {
  "@babel/helpers - typeof";
  return td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, td(t);
}
function Q8() {
  return Q8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Q8.apply(this, arguments);
}
function IS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function I0(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? IS(Object(r), !0).forEach(function(n) {
      uEe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : IS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function uEe(t, e, r) {
  return e = dEe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function dEe(t) {
  var e = fEe(t, "string");
  return td(e) == "symbol" ? e : e + "";
}
function fEe(t, e) {
  if (td(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (td(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function hEe(t, e) {
  if (t == null) return {};
  var r = pEe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function pEe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function gEe(t, e) {
  var r = t.x, n = t.y, A = hEe(t, lEe), i = "".concat(r), o = parseInt(i, 10), s = "".concat(n), a = parseInt(s, 10), c = "".concat(e.height || A.height), l = parseInt(c, 10), u = "".concat(e.width || A.width), f = parseInt(u, 10);
  return I0(I0(I0(I0(I0({}, e), A), o ? {
    x: o
  } : {}), a ? {
    y: a
  } : {}), {}, {
    height: l,
    width: f,
    name: e.name,
    radius: e.radius
  });
}
function SS(t) {
  return /* @__PURE__ */ re.createElement(_be, Q8({
    shapeType: "rectangle",
    propTransformer: gEe,
    activeClassName: "recharts-active-bar"
  }, t));
}
var mEe = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, A) {
    if (typeof e == "number") return e;
    var i = typeof n == "number";
    return i ? e(n, A) : (i || (process.env.NODE_ENV !== "production" ? si(!1, "minPointSize callback function received a value with type of ".concat(td(n), ". Currently only numbers are supported.")) : si()), r);
  };
}, vEe = ["value", "background"], LU;
function rd(t) {
  "@babel/helpers - typeof";
  return rd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rd(t);
}
function qEe(t, e) {
  if (t == null) return {};
  var r = yEe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function yEe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Tp() {
  return Tp = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Tp.apply(this, arguments);
}
function PS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Un(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? PS(Object(r), !0).forEach(function(n) {
      Ea(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : PS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function CEe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function kS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, RU(n.key), n);
  }
}
function wEe(t, e, r) {
  return kS(t.prototype, e), kS(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function bEe(t, e, r) {
  return e = Mp(e), BEe(t, GU() ? Reflect.construct(e, r, Mp(t).constructor) : e.apply(t, r));
}
function BEe(t, e) {
  if (e && (rd(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return EEe(t);
}
function EEe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function GU() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (GU = function() {
    return !!t;
  })();
}
function Mp(t) {
  return Mp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Mp(t);
}
function xEe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && U8(t, e);
}
function U8(t, e) {
  return U8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, U8(t, e);
}
function Ea(t, e, r) {
  return e = RU(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function RU(t) {
  var e = IEe(t, "string");
  return rd(e) == "symbol" ? e : e + "";
}
function IEe(t, e) {
  if (rd(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (rd(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var gl = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    CEe(this, e);
    for (var n = arguments.length, A = new Array(n), i = 0; i < n; i++)
      A[i] = arguments[i];
    return r = bEe(this, e, [].concat(A)), Ea(r, "state", {
      isAnimationFinished: !1
    }), Ea(r, "id", Ld("recharts-bar-")), Ea(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Ea(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return xEe(e, t), wEe(e, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var A = this, i = this.props, o = i.shape, s = i.dataKey, a = i.activeIndex, c = i.activeBar, l = cr(this.props, !1);
      return n && n.map(function(u, f) {
        var d = f === a, g = d ? c : o, m = Un(Un(Un({}, l), u), {}, {
          isActive: d,
          option: g,
          index: f,
          dataKey: s,
          onAnimationStart: A.handleAnimationStart,
          onAnimationEnd: A.handleAnimationEnd
        });
        return /* @__PURE__ */ re.createElement(_r, Tp({
          className: "recharts-bar-rectangle"
        }, Y3(A.props, u, f), {
          key: "rectangle-".concat(u == null ? void 0 : u.x, "-").concat(u == null ? void 0 : u.y, "-").concat(u == null ? void 0 : u.value)
        }), /* @__PURE__ */ re.createElement(SS, m));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, A = this.props, i = A.data, o = A.layout, s = A.isAnimationActive, a = A.animationBegin, c = A.animationDuration, l = A.animationEasing, u = A.animationId, f = this.state.prevData;
      return /* @__PURE__ */ re.createElement($o, {
        begin: a,
        duration: c,
        isActive: s,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(d) {
        var g = d.t, m = i.map(function(p, v) {
          var C = f && f[v];
          if (C) {
            var w = yA(C.x, p.x), B = yA(C.y, p.y), y = yA(C.width, p.width), b = yA(C.height, p.height);
            return Un(Un({}, p), {}, {
              x: w(g),
              y: B(g),
              width: y(g),
              height: b(g)
            });
          }
          if (o === "horizontal") {
            var q = yA(0, p.height), E = q(g);
            return Un(Un({}, p), {}, {
              y: p.y + p.height - E,
              height: E
            });
          }
          var x = yA(0, p.width), M = x(g);
          return Un(Un({}, p), {}, {
            width: M
          });
        });
        return /* @__PURE__ */ re.createElement(_r, null, n.renderRectanglesStatically(m));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, A = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && A && A.length && (!o || !Zu(o, A)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(A);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, A = this.props, i = A.data, o = A.dataKey, s = A.activeIndex, a = cr(this.props.background, !1);
      return i.map(function(c, l) {
        c.value;
        var u = c.background, f = qEe(c, vEe);
        if (!u)
          return null;
        var d = Un(Un(Un(Un(Un({}, f), {}, {
          fill: "#eee"
        }, u), a), Y3(n.props, c, l)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: l,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ re.createElement(SS, Tp({
          key: "background-bar-".concat(l),
          option: n.props.background,
          isActive: l === s
        }, d));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, A) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, s = i.xAxis, a = i.yAxis, c = i.layout, l = i.children, u = zi(l, L1), f = c === "vertical" ? o[0].height / 2 : o[0].width / 2, d = function(p, v) {
        var C = Array.isArray(p.value) ? p.value[1] : p.value;
        return {
          x: p.x,
          y: p.y,
          value: C,
          errorVal: _A(p, v)
        };
      }, g = {
        clipPath: n ? "url(#clipPath-".concat(A, ")") : null
      };
      return /* @__PURE__ */ re.createElement(_r, g, u.map(function(m) {
        return /* @__PURE__ */ re.cloneElement(m, {
          key: "error-bar-".concat(A, "-").concat(m.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: a,
          layout: c,
          offset: f,
          dataPointFormatter: d
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, A = n.hide, i = n.data, o = n.className, s = n.xAxis, a = n.yAxis, c = n.left, l = n.top, u = n.width, f = n.height, d = n.isAnimationActive, g = n.background, m = n.id;
      if (A || !i || !i.length)
        return null;
      var p = this.state.isAnimationFinished, v = Br("recharts-bar", o), C = s && s.allowDataOverflow, w = a && a.allowDataOverflow, B = C || w, y = hr(m) ? this.id : m;
      return /* @__PURE__ */ re.createElement(_r, {
        className: v
      }, C || w ? /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", {
        id: "clipPath-".concat(y)
      }, /* @__PURE__ */ re.createElement("rect", {
        x: C ? c : c - u / 2,
        y: w ? l : l - f / 2,
        width: C ? u : u * 2,
        height: w ? f : f * 2
      }))) : null, /* @__PURE__ */ re.createElement(_r, {
        className: "recharts-bar-rectangles",
        clipPath: B ? "url(#clipPath-".concat(y, ")") : null
      }, g ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(B, y), (!d || p) && Is.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, A) {
      return n.animationId !== A.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: A.curData
      } : n.data !== A.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(es);
LU = gl;
Ea(gl, "displayName", "Bar");
Ea(gl, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Wo.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Ea(gl, "getComposedData", function(t) {
  var e = t.props, r = t.item, n = t.barPosition, A = t.bandSize, i = t.xAxis, o = t.yAxis, s = t.xAxisTicks, a = t.yAxisTicks, c = t.stackedData, l = t.dataStartIndex, u = t.displayedData, f = t.offset, d = oye(n, r);
  if (!d)
    return null;
  var g = e.layout, m = r.type.defaultProps, p = m !== void 0 ? Un(Un({}, m), r.props) : r.props, v = p.dataKey, C = p.children, w = p.minPointSize, B = g === "horizontal" ? o : i, y = c ? B.scale.domain() : null, b = hye({
    numericAxis: B
  }), q = zi(C, vQ), E = u.map(function(x, M) {
    var O, I, S, P, H, F;
    c ? O = sye(c[l + M], y) : (O = _A(x, v), Array.isArray(O) || (O = [b, O]));
    var T = mEe(w, LU.defaultProps.minPointSize)(O[1], M);
    if (g === "horizontal") {
      var U, D = [o.scale(O[0]), o.scale(O[1])], Q = D[0], Y = D[1];
      I = kI({
        axis: i,
        ticks: s,
        bandSize: A,
        offset: d.offset,
        entry: x,
        index: M
      }), S = (U = Y ?? Q) !== null && U !== void 0 ? U : void 0, P = d.size;
      var j = Q - Y;
      if (H = Number.isNaN(j) ? 0 : j, F = {
        x: I,
        y: o.y,
        width: P,
        height: o.height
      }, Math.abs(T) > 0 && Math.abs(H) < Math.abs(T)) {
        var Z = uo(H || T) * (Math.abs(T) - Math.abs(H));
        S -= Z, H += Z;
      }
    } else {
      var W = [i.scale(O[0]), i.scale(O[1])], R = W[0], K = W[1];
      if (I = R, S = kI({
        axis: o,
        ticks: a,
        bandSize: A,
        offset: d.offset,
        entry: x,
        index: M
      }), P = K - R, H = d.size, F = {
        x: i.x,
        y: S,
        width: i.width,
        height: H
      }, Math.abs(T) > 0 && Math.abs(P) < Math.abs(T)) {
        var L = uo(P || T) * (Math.abs(T) - Math.abs(P));
        P += L;
      }
    }
    return Un(Un(Un({}, x), {}, {
      x: I,
      y: S,
      width: P,
      height: H,
      value: c ? O : O[1],
      payload: x,
      background: F
    }, q[M] && q[M].props), {}, {
      tooltipPayload: [BU(r, x)],
      tooltipPosition: {
        x: I + P / 2,
        y: S + H / 2
      }
    });
  });
  return Un({
    data: E,
    layout: g
  }, f);
});
function o1(t) {
  "@babel/helpers - typeof";
  return o1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, o1(t);
}
function SEe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function OS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, zU(n.key), n);
  }
}
function PEe(t, e, r) {
  return OS(t.prototype, e), OS(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function FS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ao(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? FS(Object(r), !0).forEach(function(n) {
      K4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : FS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function K4(t, e, r) {
  return e = zU(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zU(t) {
  var e = kEe(t, "string");
  return o1(e) == "symbol" ? e : e + "";
}
function kEe(t, e) {
  if (o1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (o1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ey = function(e, r, n, A, i) {
  var o = e.width, s = e.height, a = e.layout, c = e.children, l = Object.keys(r), u = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, f = !!mi(c, gl);
  return l.reduce(function(d, g) {
    var m = r[g], p = m.orientation, v = m.domain, C = m.padding, w = C === void 0 ? {} : C, B = m.mirror, y = m.reversed, b = "".concat(p).concat(B ? "Mirror" : ""), q, E, x, M, O;
    if (m.type === "number" && (m.padding === "gap" || m.padding === "no-gap")) {
      var I = v[1] - v[0], S = 1 / 0, P = m.categoricalDomain.sort();
      if (P.forEach(function(W, R) {
        R > 0 && (S = Math.min((W || 0) - (P[R - 1] || 0), S));
      }), Number.isFinite(S)) {
        var H = S / I, F = m.layout === "vertical" ? n.height : n.width;
        if (m.padding === "gap" && (q = H * F / 2), m.padding === "no-gap") {
          var T = nl(e.barCategoryGap, H * F), U = H * F / 2;
          q = U - T - (U - T) / F * T;
        }
      }
    }
    A === "xAxis" ? E = [n.left + (w.left || 0) + (q || 0), n.left + n.width - (w.right || 0) - (q || 0)] : A === "yAxis" ? E = a === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (q || 0), n.top + n.height - (w.bottom || 0) - (q || 0)] : E = m.range, y && (E = [E[1], E[0]]);
    var D = Aye(m, i, f), Q = D.scale, Y = D.realScaleType;
    Q.domain(v).range(E), iye(Q);
    var j = fye(Q, Ao(Ao({}, m), {}, {
      realScaleType: Y
    }));
    A === "xAxis" ? (O = p === "top" && !B || p === "bottom" && B, x = n.left, M = u[b] - O * m.height) : A === "yAxis" && (O = p === "left" && !B || p === "right" && B, x = u[b] - O * m.width, M = n.top);
    var Z = Ao(Ao(Ao({}, m), j), {}, {
      realScaleType: Y,
      x,
      y: M,
      scale: Q,
      width: A === "xAxis" ? n.width : m.width,
      height: A === "yAxis" ? n.height : m.height
    });
    return Z.bandSize = yp(Z, j), !m.hide && A === "xAxis" ? u[b] += (O ? -1 : 1) * Z.height : m.hide || (u[b] += (O ? -1 : 1) * Z.width), Ao(Ao({}, d), {}, K4({}, g, Z));
  }, {});
}, YU = function(e, r) {
  var n = e.x, A = e.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(A, o),
    width: Math.abs(i - n),
    height: Math.abs(o - A)
  };
}, OEe = function(e) {
  var r = e.x1, n = e.y1, A = e.x2, i = e.y2;
  return YU({
    x: r,
    y: n
  }, {
    x: A,
    y: i
  });
}, VU = /* @__PURE__ */ function() {
  function t(e) {
    SEe(this, t), this.scale = e;
  }
  return PEe(t, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (A) {
          var a = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + a;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), A = n[0], i = n[n.length - 1];
      return A <= i ? r >= A && r <= i : r >= i && r <= A;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new t(r);
    }
  }]);
}();
K4(VU, "EPS", 1e-4);
var ty = function(e) {
  var r = Object.keys(e).reduce(function(n, A) {
    return Ao(Ao({}, n), {}, K4({}, A, VU.create(e[A])));
  }, {});
  return Ao(Ao({}, r), {}, {
    apply: function(A) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, s = i.position;
      return JBe(A, function(a, c) {
        return r[c].apply(a, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(A) {
      return jU(A, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function FEe(t) {
  return (t % 180 + 180) % 180;
}
var TEe = function(e) {
  var r = e.width, n = e.height, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = FEe(A), o = i * Math.PI / 180, s = Math.atan(n / r), a = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(a);
}, MEe = tc, HEe = D1, DEe = M4;
function QEe(t) {
  return function(e, r, n) {
    var A = Object(e);
    if (!HEe(e)) {
      var i = MEe(r);
      e = DEe(e), r = function(s) {
        return i(A[s], s, A);
      };
    }
    var o = t(e, r, n);
    return o > -1 ? A[i ? e[o] : o] : void 0;
  };
}
var UEe = QEe, NEe = DU;
function jEe(t) {
  var e = NEe(t), r = e % 1;
  return e === e ? r ? e - r : e : 0;
}
var LEe = jEe, GEe = nQ, REe = tc, zEe = LEe, YEe = Math.max;
function VEe(t, e, r) {
  var n = t == null ? 0 : t.length;
  if (!n)
    return -1;
  var A = r == null ? 0 : zEe(r);
  return A < 0 && (A = YEe(n + A, 0)), GEe(t, REe(e), A);
}
var WEe = VEe, XEe = UEe, KEe = WEe, ZEe = XEe(KEe), JEe = ZEe;
const _Ee = /* @__PURE__ */ Vr(JEe);
var $Ee = Y0e(function(t) {
  return {
    x: t.left,
    y: t.top,
    width: t.width,
    height: t.height
  };
}, function(t) {
  return ["l", t.left, "t", t.top, "w", t.width, "h", t.height].join("");
});
function Hp(t) {
  "@babel/helpers - typeof";
  return Hp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hp(t);
}
var ry = /* @__PURE__ */ UA(void 0), ny = /* @__PURE__ */ UA(void 0), WU = /* @__PURE__ */ UA(void 0), XU = /* @__PURE__ */ UA({}), KU = /* @__PURE__ */ UA(void 0), ZU = /* @__PURE__ */ UA(0), JU = /* @__PURE__ */ UA(0), TS = function(e) {
  var r = e.state, n = r.xAxisMap, A = r.yAxisMap, i = r.offset, o = e.clipPathId, s = e.children, a = e.width, c = e.height, l = $Ee(i);
  return /* @__PURE__ */ re.createElement(ry.Provider, {
    value: n
  }, /* @__PURE__ */ re.createElement(ny.Provider, {
    value: A
  }, /* @__PURE__ */ re.createElement(XU.Provider, {
    value: i
  }, /* @__PURE__ */ re.createElement(WU.Provider, {
    value: l
  }, /* @__PURE__ */ re.createElement(KU.Provider, {
    value: o
  }, /* @__PURE__ */ re.createElement(ZU.Provider, {
    value: c
  }, /* @__PURE__ */ re.createElement(JU.Provider, {
    value: a
  }, s)))))));
}, exe = function() {
  return Xe(KU);
};
function _U(t) {
  var e = Object.keys(t);
  return e.length === 0 ? "There are no available ids." : "Available ids are: ".concat(e, ".");
}
var $U = function(e) {
  var r = Xe(ry);
  r == null && (process.env.NODE_ENV !== "production" ? si(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : si());
  var n = r[e];
  return n == null && (process.env.NODE_ENV !== "production" ? si(!1, 'Could not find xAxis by id "'.concat(e, '" [').concat(Hp(e), "]. ").concat(_U(r))) : si()), n;
}, txe = function() {
  var e = Xe(ry);
  return ga(e);
}, rxe = function() {
  var e = Xe(ny), r = _Ee(e, function(n) {
    return jU(n.domain, Number.isFinite);
  });
  return r || ga(e);
}, eN = function(e) {
  var r = Xe(ny);
  r == null && (process.env.NODE_ENV !== "production" ? si(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : si());
  var n = r[e];
  return n == null && (process.env.NODE_ENV !== "production" ? si(!1, 'Could not find yAxis by id "'.concat(e, '" [').concat(Hp(e), "]. ").concat(_U(r))) : si()), n;
}, nxe = function() {
  var e = Xe(WU);
  return e;
}, Axe = function() {
  return Xe(XU);
}, Ay = function() {
  return Xe(JU);
}, iy = function() {
  return Xe(ZU);
};
function nd(t) {
  "@babel/helpers - typeof";
  return nd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, nd(t);
}
function ixe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function oxe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, rN(n.key), n);
  }
}
function sxe(t, e, r) {
  return oxe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function axe(t, e, r) {
  return e = Dp(e), cxe(t, tN() ? Reflect.construct(e, r || [], Dp(t).constructor) : e.apply(t, r));
}
function cxe(t, e) {
  if (e && (nd(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lxe(t);
}
function lxe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function tN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tN = function() {
    return !!t;
  })();
}
function Dp(t) {
  return Dp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Dp(t);
}
function uxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && N8(t, e);
}
function N8(t, e) {
  return N8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, N8(t, e);
}
function MS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function HS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? MS(Object(r), !0).forEach(function(n) {
      oy(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : MS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function oy(t, e, r) {
  return e = rN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function rN(t) {
  var e = dxe(t, "string");
  return nd(e) == "symbol" ? e : e + "";
}
function dxe(t, e) {
  if (nd(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (nd(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function fxe(t, e) {
  return mxe(t) || gxe(t, e) || pxe(t, e) || hxe();
}
function hxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pxe(t, e) {
  if (t) {
    if (typeof t == "string") return DS(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return DS(t, e);
  }
}
function DS(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function gxe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function mxe(t) {
  if (Array.isArray(t)) return t;
}
function j8() {
  return j8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, j8.apply(this, arguments);
}
var vxe = function(e, r) {
  var n;
  return /* @__PURE__ */ re.isValidElement(e) ? n = /* @__PURE__ */ re.cloneElement(e, r) : nr(e) ? n = e(r) : n = /* @__PURE__ */ re.createElement("line", j8({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, qxe = function(e, r, n, A, i, o, s, a, c) {
  var l = i.x, u = i.y, f = i.width, d = i.height;
  if (n) {
    var g = c.y, m = e.y.apply(g, {
      position: o
    });
    if (Ko(c, "discard") && !e.y.isInRange(m))
      return null;
    var p = [{
      x: l + f,
      y: m
    }, {
      x: l,
      y: m
    }];
    return a === "left" ? p.reverse() : p;
  }
  if (r) {
    var v = c.x, C = e.x.apply(v, {
      position: o
    });
    if (Ko(c, "discard") && !e.x.isInRange(C))
      return null;
    var w = [{
      x: C,
      y: u + d
    }, {
      x: C,
      y: u
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (A) {
    var B = c.segment, y = B.map(function(b) {
      return e.apply(b, {
        position: o
      });
    });
    return Ko(c, "discard") && RBe(y, function(b) {
      return !e.isInRange(b);
    }) ? null : y;
  }
  return null;
};
function yxe(t) {
  var e = t.x, r = t.y, n = t.segment, A = t.xAxisId, i = t.yAxisId, o = t.shape, s = t.className, a = t.alwaysShow, c = exe(), l = $U(A), u = eN(i), f = nxe();
  if (!c || !f)
    return null;
  Es(a === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var d = ty({
    x: l.scale,
    y: u.scale
  }), g = $n(e), m = $n(r), p = n && n.length === 2, v = qxe(d, g, m, p, f, t.position, l.orientation, u.orientation, t);
  if (!v)
    return null;
  var C = fxe(v, 2), w = C[0], B = w.x, y = w.y, b = C[1], q = b.x, E = b.y, x = Ko(t, "hidden") ? "url(#".concat(c, ")") : void 0, M = HS(HS({
    clipPath: x
  }, cr(t, !0)), {}, {
    x1: B,
    y1: y,
    x2: q,
    y2: E
  });
  return /* @__PURE__ */ re.createElement(_r, {
    className: Br("recharts-reference-line", s)
  }, vxe(o, M), FA.renderCallByParent(t, OEe({
    x1: B,
    y1: y,
    x2: q,
    y2: E
  })));
}
var sy = /* @__PURE__ */ function(t) {
  function e() {
    return ixe(this, e), axe(this, e, arguments);
  }
  return uxe(e, t), sxe(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ re.createElement(yxe, this.props);
    }
  }]);
}(re.Component);
oy(sy, "displayName", "ReferenceLine");
oy(sy, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function L8() {
  return L8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, L8.apply(this, arguments);
}
function Ad(t) {
  "@babel/helpers - typeof";
  return Ad = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ad(t);
}
function QS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function US(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? QS(Object(r), !0).forEach(function(n) {
      Z4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : QS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Cxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function wxe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, AN(n.key), n);
  }
}
function bxe(t, e, r) {
  return wxe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Bxe(t, e, r) {
  return e = Qp(e), Exe(t, nN() ? Reflect.construct(e, r || [], Qp(t).constructor) : e.apply(t, r));
}
function Exe(t, e) {
  if (e && (Ad(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xxe(t);
}
function xxe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function nN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nN = function() {
    return !!t;
  })();
}
function Qp(t) {
  return Qp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qp(t);
}
function Ixe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && G8(t, e);
}
function G8(t, e) {
  return G8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, G8(t, e);
}
function Z4(t, e, r) {
  return e = AN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function AN(t) {
  var e = Sxe(t, "string");
  return Ad(e) == "symbol" ? e : e + "";
}
function Sxe(t, e) {
  if (Ad(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (Ad(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Pxe = function(e) {
  var r = e.x, n = e.y, A = e.xAxis, i = e.yAxis, o = ty({
    x: A.scale,
    y: i.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Ko(e, "discard") && !o.isInRange(s) ? null : s;
}, J4 = /* @__PURE__ */ function(t) {
  function e() {
    return Cxe(this, e), Bxe(this, e, arguments);
  }
  return Ixe(e, t), bxe(e, [{
    key: "render",
    value: function() {
      var n = this.props, A = n.x, i = n.y, o = n.r, s = n.alwaysShow, a = n.clipPathId, c = $n(A), l = $n(i);
      if (Es(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !l)
        return null;
      var u = Pxe(this.props);
      if (!u)
        return null;
      var f = u.x, d = u.y, g = this.props, m = g.shape, p = g.className, v = Ko(this.props, "hidden") ? "url(#".concat(a, ")") : void 0, C = US(US({
        clipPath: v
      }, cr(this.props, !0)), {}, {
        cx: f,
        cy: d
      });
      return /* @__PURE__ */ re.createElement(_r, {
        className: Br("recharts-reference-dot", p)
      }, e.renderDot(m, C), FA.renderCallByParent(this.props, {
        x: f - o,
        y: d - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(re.Component);
Z4(J4, "displayName", "ReferenceDot");
Z4(J4, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
Z4(J4, "renderDot", function(t, e) {
  var r;
  return /* @__PURE__ */ re.isValidElement(t) ? r = /* @__PURE__ */ re.cloneElement(t, e) : nr(t) ? r = t(e) : r = /* @__PURE__ */ re.createElement(V4, L8({}, e, {
    cx: e.cx,
    cy: e.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function R8() {
  return R8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, R8.apply(this, arguments);
}
function id(t) {
  "@babel/helpers - typeof";
  return id = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, id(t);
}
function NS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? NS(Object(r), !0).forEach(function(n) {
      _4(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : NS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function kxe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Oxe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, oN(n.key), n);
  }
}
function Fxe(t, e, r) {
  return Oxe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Txe(t, e, r) {
  return e = Up(e), Mxe(t, iN() ? Reflect.construct(e, r || [], Up(t).constructor) : e.apply(t, r));
}
function Mxe(t, e) {
  if (e && (id(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Hxe(t);
}
function Hxe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function iN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (iN = function() {
    return !!t;
  })();
}
function Up(t) {
  return Up = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Up(t);
}
function Dxe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && z8(t, e);
}
function z8(t, e) {
  return z8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, z8(t, e);
}
function _4(t, e, r) {
  return e = oN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function oN(t) {
  var e = Qxe(t, "string");
  return id(e) == "symbol" ? e : e + "";
}
function Qxe(t, e) {
  if (id(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (id(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Uxe = function(e, r, n, A, i) {
  var o = i.x1, s = i.x2, a = i.y1, c = i.y2, l = i.xAxis, u = i.yAxis;
  if (!l || !u) return null;
  var f = ty({
    x: l.scale,
    y: u.scale
  }), d = {
    x: e ? f.x.apply(o, {
      position: "start"
    }) : f.x.rangeMin,
    y: n ? f.y.apply(a, {
      position: "start"
    }) : f.y.rangeMin
  }, g = {
    x: r ? f.x.apply(s, {
      position: "end"
    }) : f.x.rangeMax,
    y: A ? f.y.apply(c, {
      position: "end"
    }) : f.y.rangeMax
  };
  return Ko(i, "discard") && (!f.isInRange(d) || !f.isInRange(g)) ? null : YU(d, g);
}, $4 = /* @__PURE__ */ function(t) {
  function e() {
    return kxe(this, e), Txe(this, e, arguments);
  }
  return Dxe(e, t), Fxe(e, [{
    key: "render",
    value: function() {
      var n = this.props, A = n.x1, i = n.x2, o = n.y1, s = n.y2, a = n.className, c = n.alwaysShow, l = n.clipPathId;
      Es(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var u = $n(A), f = $n(i), d = $n(o), g = $n(s), m = this.props.shape;
      if (!u && !f && !d && !g && !m)
        return null;
      var p = Uxe(u, f, d, g, this.props);
      if (!p && !m)
        return null;
      var v = Ko(this.props, "hidden") ? "url(#".concat(l, ")") : void 0;
      return /* @__PURE__ */ re.createElement(_r, {
        className: Br("recharts-reference-area", a)
      }, e.renderRect(m, jS(jS({
        clipPath: v
      }, cr(this.props, !0)), p)), FA.renderCallByParent(this.props, p));
    }
  }]);
}(re.Component);
_4($4, "displayName", "ReferenceArea");
_4($4, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
_4($4, "renderRect", function(t, e) {
  var r;
  return /* @__PURE__ */ re.isValidElement(t) ? r = /* @__PURE__ */ re.cloneElement(t, e) : nr(t) ? r = t(e) : r = /* @__PURE__ */ re.createElement($q, R8({}, e, {
    className: "recharts-reference-area-rect"
  })), r;
});
function sN(t, e, r) {
  if (e < 1)
    return [];
  if (e === 1 && r === void 0)
    return t;
  for (var n = [], A = 0; A < t.length; A += e)
    n.push(t[A]);
  return n;
}
function Nxe(t, e, r) {
  var n = {
    width: t.width + e.width,
    height: t.height + e.height
  };
  return TEe(n, r);
}
function jxe(t, e, r) {
  var n = r === "width", A = t.x, i = t.y, o = t.width, s = t.height;
  return e === 1 ? {
    start: n ? A : i,
    end: n ? A + o : i + s
  } : {
    start: n ? A + o : i + s,
    end: n ? A : i
  };
}
function Np(t, e, r, n, A) {
  if (t * e < t * n || t * e > t * A)
    return !1;
  var i = r();
  return t * (e - t * i / 2 - n) >= 0 && t * (e + t * i / 2 - A) <= 0;
}
function Lxe(t, e) {
  return sN(t, e + 1);
}
function Gxe(t, e, r, n, A) {
  for (var i = (n || []).slice(), o = e.start, s = e.end, a = 0, c = 1, l = o, u = function() {
    var g = n == null ? void 0 : n[a];
    if (g === void 0)
      return {
        v: sN(n, c)
      };
    var m = a, p, v = function() {
      return p === void 0 && (p = r(g, m)), p;
    }, C = g.coordinate, w = a === 0 || Np(t, C, v, l, s);
    w || (a = 0, l = o, c += 1), w && (l = C + t * (v() / 2 + A), a += c);
  }, f; c <= i.length; )
    if (f = u(), f) return f.v;
  return [];
}
function s1(t) {
  "@babel/helpers - typeof";
  return s1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, s1(t);
}
function LS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function SA(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? LS(Object(r), !0).forEach(function(n) {
      Rxe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : LS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Rxe(t, e, r) {
  return e = zxe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zxe(t) {
  var e = Yxe(t, "string");
  return s1(e) == "symbol" ? e : e + "";
}
function Yxe(t, e) {
  if (s1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (s1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Vxe(t, e, r, n, A) {
  for (var i = (n || []).slice(), o = i.length, s = e.start, a = e.end, c = function(f) {
    var d = i[f], g, m = function() {
      return g === void 0 && (g = r(d, f)), g;
    };
    if (f === o - 1) {
      var p = t * (d.coordinate + t * m() / 2 - a);
      i[f] = d = SA(SA({}, d), {}, {
        tickCoord: p > 0 ? d.coordinate - p * t : d.coordinate
      });
    } else
      i[f] = d = SA(SA({}, d), {}, {
        tickCoord: d.coordinate
      });
    var v = Np(t, d.tickCoord, m, s, a);
    v && (a = d.tickCoord - t * (m() / 2 + A), i[f] = SA(SA({}, d), {}, {
      isShow: !0
    }));
  }, l = o - 1; l >= 0; l--)
    c(l);
  return i;
}
function Wxe(t, e, r, n, A, i) {
  var o = (n || []).slice(), s = o.length, a = e.start, c = e.end;
  if (i) {
    var l = n[s - 1], u = r(l, s - 1), f = t * (l.coordinate + t * u / 2 - c);
    o[s - 1] = l = SA(SA({}, l), {}, {
      tickCoord: f > 0 ? l.coordinate - f * t : l.coordinate
    });
    var d = Np(t, l.tickCoord, function() {
      return u;
    }, a, c);
    d && (c = l.tickCoord - t * (u / 2 + A), o[s - 1] = SA(SA({}, l), {}, {
      isShow: !0
    }));
  }
  for (var g = i ? s - 1 : s, m = function(C) {
    var w = o[C], B, y = function() {
      return B === void 0 && (B = r(w, C)), B;
    };
    if (C === 0) {
      var b = t * (w.coordinate - t * y() / 2 - a);
      o[C] = w = SA(SA({}, w), {}, {
        tickCoord: b < 0 ? w.coordinate - b * t : w.coordinate
      });
    } else
      o[C] = w = SA(SA({}, w), {}, {
        tickCoord: w.coordinate
      });
    var q = Np(t, w.tickCoord, y, a, c);
    q && (a = w.tickCoord + t * (y() / 2 + A), o[C] = SA(SA({}, w), {}, {
      isShow: !0
    }));
  }, p = 0; p < g; p++)
    m(p);
  return o;
}
function ay(t, e, r) {
  var n = t.tick, A = t.ticks, i = t.viewBox, o = t.minTickGap, s = t.orientation, a = t.interval, c = t.tickFormatter, l = t.unit, u = t.angle;
  if (!A || !A.length || !n)
    return [];
  if (At(a) || Wo.isSsr)
    return Lxe(A, typeof a == "number" && At(a) ? a : 0);
  var f = [], d = s === "top" || s === "bottom" ? "width" : "height", g = l && d === "width" ? o2(l, {
    fontSize: e,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, m = function(w, B) {
    var y = nr(c) ? c(w.value, B) : w.value;
    return d === "width" ? Nxe(o2(y, {
      fontSize: e,
      letterSpacing: r
    }), g, u) : o2(y, {
      fontSize: e,
      letterSpacing: r
    })[d];
  }, p = A.length >= 2 ? uo(A[1].coordinate - A[0].coordinate) : 1, v = jxe(i, p, d);
  return a === "equidistantPreserveStart" ? Gxe(p, v, m, A, o) : (a === "preserveStart" || a === "preserveStartEnd" ? f = Wxe(p, v, m, A, o, a === "preserveStartEnd") : f = Vxe(p, v, m, A, o), f.filter(function(C) {
    return C.isShow;
  }));
}
var Xxe = ["viewBox"], Kxe = ["viewBox"], Zxe = ["ticks"];
function od(t) {
  "@babel/helpers - typeof";
  return od = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, od(t);
}
function Zl() {
  return Zl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Zl.apply(this, arguments);
}
function GS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jA(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? GS(Object(r), !0).forEach(function(n) {
      cy(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : GS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function R6(t, e) {
  if (t == null) return {};
  var r = Jxe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function Jxe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function _xe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function RS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, cN(n.key), n);
  }
}
function $xe(t, e, r) {
  return RS(t.prototype, e), RS(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function eIe(t, e, r) {
  return e = jp(e), tIe(t, aN() ? Reflect.construct(e, r, jp(t).constructor) : e.apply(t, r));
}
function tIe(t, e) {
  if (e && (od(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rIe(t);
}
function rIe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function aN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aN = function() {
    return !!t;
  })();
}
function jp(t) {
  return jp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, jp(t);
}
function nIe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Y8(t, e);
}
function Y8(t, e) {
  return Y8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, Y8(t, e);
}
function cy(t, e, r) {
  return e = cN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function cN(t) {
  var e = AIe(t, "string");
  return od(e) == "symbol" ? e : e + "";
}
function AIe(t, e) {
  if (od(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (od(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Xd = /* @__PURE__ */ function(t) {
  function e(r) {
    var n;
    return _xe(this, e), n = eIe(this, e, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return nIe(e, t), $xe(e, [{
    key: "shouldComponentUpdate",
    value: function(n, A) {
      var i = n.viewBox, o = R6(n, Xxe), s = this.props, a = s.viewBox, c = R6(s, Kxe);
      return !au(i, a) || !au(o, c) || !au(A, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var A = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        A && this.setState({
          fontSize: window.getComputedStyle(A).fontSize,
          letterSpacing: window.getComputedStyle(A).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var A = this.props, i = A.x, o = A.y, s = A.width, a = A.height, c = A.orientation, l = A.tickSize, u = A.mirror, f = A.tickMargin, d, g, m, p, v, C, w = u ? -1 : 1, B = n.tickSize || l, y = At(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          d = g = n.coordinate, p = o + +!u * a, m = p - w * B, C = m - w * f, v = y;
          break;
        case "left":
          m = p = n.coordinate, g = i + +!u * s, d = g - w * B, v = d - w * f, C = y;
          break;
        case "right":
          m = p = n.coordinate, g = i + +u * s, d = g + w * B, v = d + w * f, C = y;
          break;
        default:
          d = g = n.coordinate, p = o + +u * a, m = p + w * B, C = m + w * f, v = y;
          break;
      }
      return {
        line: {
          x1: d,
          y1: m,
          x2: g,
          y2: p
        },
        tick: {
          x: v,
          y: C
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, A = n.orientation, i = n.mirror, o;
      switch (A) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, A = n.orientation, i = n.mirror, o = "end";
      switch (A) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, A = n.x, i = n.y, o = n.width, s = n.height, a = n.orientation, c = n.mirror, l = n.axisLine, u = jA(jA(jA({}, cr(this.props, !1)), cr(l, !1)), {}, {
        fill: "none"
      });
      if (a === "top" || a === "bottom") {
        var f = +(a === "top" && !c || a === "bottom" && c);
        u = jA(jA({}, u), {}, {
          x1: A,
          y1: i + f * s,
          x2: A + o,
          y2: i + f * s
        });
      } else {
        var d = +(a === "left" && !c || a === "right" && c);
        u = jA(jA({}, u), {}, {
          x1: A + d * o,
          y1: i,
          x2: A + d * o,
          y2: i + s
        });
      }
      return /* @__PURE__ */ re.createElement("line", Zl({}, u, {
        className: Br("recharts-cartesian-axis-line", Ri(l, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, A, i) {
        var o = this, s = this.props, a = s.tickLine, c = s.stroke, l = s.tick, u = s.tickFormatter, f = s.unit, d = ay(jA(jA({}, this.props), {}, {
          ticks: n
        }), A, i), g = this.getTickTextAnchor(), m = this.getTickVerticalAnchor(), p = cr(this.props, !1), v = cr(l, !1), C = jA(jA({}, p), {}, {
          fill: "none"
        }, cr(a, !1)), w = d.map(function(B, y) {
          var b = o.getTickLineCoord(B), q = b.line, E = b.tick, x = jA(jA(jA(jA({
            textAnchor: g,
            verticalAnchor: m
          }, p), {}, {
            stroke: "none",
            fill: c
          }, v), E), {}, {
            index: y,
            payload: B,
            visibleTicksCount: d.length,
            tickFormatter: u
          });
          return /* @__PURE__ */ re.createElement(_r, Zl({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(B.value, "-").concat(B.coordinate, "-").concat(B.tickCoord)
          }, Y3(o.props, B, y)), a && /* @__PURE__ */ re.createElement("line", Zl({}, C, q, {
            className: Br("recharts-cartesian-axis-tick-line", Ri(a, "className"))
          })), l && e.renderTickItem(l, x, "".concat(nr(u) ? u(B.value, y) : B.value).concat(f || "")));
        });
        return /* @__PURE__ */ re.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, A = this.props, i = A.axisLine, o = A.width, s = A.height, a = A.ticksGenerator, c = A.className, l = A.hide;
      if (l)
        return null;
      var u = this.props, f = u.ticks, d = R6(u, Zxe), g = f;
      return nr(a) && (g = f && f.length > 0 ? a(this.props) : a(d)), o <= 0 || s <= 0 || !g || !g.length ? null : /* @__PURE__ */ re.createElement(_r, {
        className: Br("recharts-cartesian-axis", c),
        ref: function(p) {
          n.layerReference = p;
        }
      }, i && this.renderAxisLine(), this.renderTicks(g, this.state.fontSize, this.state.letterSpacing), FA.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, A, i) {
      var o;
      return /* @__PURE__ */ re.isValidElement(n) ? o = /* @__PURE__ */ re.cloneElement(n, A) : nr(n) ? o = n(A) : o = /* @__PURE__ */ re.createElement(ip, Zl({}, A, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]);
}($p);
cy(Xd, "displayName", "CartesianAxis");
cy(Xd, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var iIe = ["x1", "y1", "x2", "y2", "key"], oIe = ["offset"];
function il(t) {
  "@babel/helpers - typeof";
  return il = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, il(t);
}
function zS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function TA(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zS(Object(r), !0).forEach(function(n) {
      sIe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : zS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function sIe(t, e, r) {
  return e = aIe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function aIe(t) {
  var e = cIe(t, "string");
  return il(e) == "symbol" ? e : e + "";
}
function cIe(t, e) {
  if (il(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (il(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Ic() {
  return Ic = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ic.apply(this, arguments);
}
function YS(t, e) {
  if (t == null) return {};
  var r = lIe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function lIe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var uIe = function(e) {
  var r = e.fill;
  if (!r || r === "none")
    return null;
  var n = e.fillOpacity, A = e.x, i = e.y, o = e.width, s = e.height, a = e.ry;
  return /* @__PURE__ */ re.createElement("rect", {
    x: A,
    y: i,
    ry: a,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function lN(t, e) {
  var r;
  if (/* @__PURE__ */ re.isValidElement(t))
    r = /* @__PURE__ */ re.cloneElement(t, e);
  else if (nr(t))
    r = t(e);
  else {
    var n = e.x1, A = e.y1, i = e.x2, o = e.y2, s = e.key, a = YS(e, iIe), c = cr(a, !1);
    c.offset;
    var l = YS(c, oIe);
    r = /* @__PURE__ */ re.createElement("line", Ic({}, l, {
      x1: n,
      y1: A,
      x2: i,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function dIe(t) {
  var e = t.x, r = t.width, n = t.horizontal, A = n === void 0 ? !0 : n, i = t.horizontalPoints;
  if (!A || !i || !i.length)
    return null;
  var o = i.map(function(s, a) {
    var c = TA(TA({}, t), {}, {
      x1: e,
      y1: s,
      x2: e + r,
      y2: s,
      key: "line-".concat(a),
      index: a
    });
    return lN(A, c);
  });
  return /* @__PURE__ */ re.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function fIe(t) {
  var e = t.y, r = t.height, n = t.vertical, A = n === void 0 ? !0 : n, i = t.verticalPoints;
  if (!A || !i || !i.length)
    return null;
  var o = i.map(function(s, a) {
    var c = TA(TA({}, t), {}, {
      x1: s,
      y1: e,
      x2: s,
      y2: e + r,
      key: "line-".concat(a),
      index: a
    });
    return lN(A, c);
  });
  return /* @__PURE__ */ re.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function hIe(t) {
  var e = t.horizontalFill, r = t.fillOpacity, n = t.x, A = t.y, i = t.width, o = t.height, s = t.horizontalPoints, a = t.horizontal, c = a === void 0 ? !0 : a;
  if (!c || !e || !e.length)
    return null;
  var l = s.map(function(f) {
    return Math.round(f + A - A);
  }).sort(function(f, d) {
    return f - d;
  });
  A !== l[0] && l.unshift(0);
  var u = l.map(function(f, d) {
    var g = !l[d + 1], m = g ? A + o - f : l[d + 1] - f;
    if (m <= 0)
      return null;
    var p = d % e.length;
    return /* @__PURE__ */ re.createElement("rect", {
      key: "react-".concat(d),
      y: f,
      x: n,
      height: m,
      width: i,
      stroke: "none",
      fill: e[p],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ re.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, u);
}
function pIe(t) {
  var e = t.vertical, r = e === void 0 ? !0 : e, n = t.verticalFill, A = t.fillOpacity, i = t.x, o = t.y, s = t.width, a = t.height, c = t.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var l = c.map(function(f) {
    return Math.round(f + i - i);
  }).sort(function(f, d) {
    return f - d;
  });
  i !== l[0] && l.unshift(0);
  var u = l.map(function(f, d) {
    var g = !l[d + 1], m = g ? i + s - f : l[d + 1] - f;
    if (m <= 0)
      return null;
    var p = d % n.length;
    return /* @__PURE__ */ re.createElement("rect", {
      key: "react-".concat(d),
      x: f,
      y: o,
      width: m,
      height: a,
      stroke: "none",
      fill: n[p],
      fillOpacity: A,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ re.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, u);
}
var gIe = function(e, r) {
  var n = e.xAxis, A = e.width, i = e.height, o = e.offset;
  return wU(ay(TA(TA(TA({}, Xd.defaultProps), n), {}, {
    ticks: vs(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: A,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, mIe = function(e, r) {
  var n = e.yAxis, A = e.width, i = e.height, o = e.offset;
  return wU(ay(TA(TA(TA({}, Xd.defaultProps), n), {}, {
    ticks: vs(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: A,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, Ol = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function e9(t) {
  var e, r, n, A, i, o, s = Ay(), a = iy(), c = Axe(), l = TA(TA({}, t), {}, {
    stroke: (e = t.stroke) !== null && e !== void 0 ? e : Ol.stroke,
    fill: (r = t.fill) !== null && r !== void 0 ? r : Ol.fill,
    horizontal: (n = t.horizontal) !== null && n !== void 0 ? n : Ol.horizontal,
    horizontalFill: (A = t.horizontalFill) !== null && A !== void 0 ? A : Ol.horizontalFill,
    vertical: (i = t.vertical) !== null && i !== void 0 ? i : Ol.vertical,
    verticalFill: (o = t.verticalFill) !== null && o !== void 0 ? o : Ol.verticalFill,
    x: At(t.x) ? t.x : c.left,
    y: At(t.y) ? t.y : c.top,
    width: At(t.width) ? t.width : c.width,
    height: At(t.height) ? t.height : c.height
  }), u = l.x, f = l.y, d = l.width, g = l.height, m = l.syncWithTicks, p = l.horizontalValues, v = l.verticalValues, C = txe(), w = rxe();
  if (!At(d) || d <= 0 || !At(g) || g <= 0 || !At(u) || u !== +u || !At(f) || f !== +f)
    return null;
  var B = l.verticalCoordinatesGenerator || gIe, y = l.horizontalCoordinatesGenerator || mIe, b = l.horizontalPoints, q = l.verticalPoints;
  if ((!b || !b.length) && nr(y)) {
    var E = p && p.length, x = y({
      yAxis: w ? TA(TA({}, w), {}, {
        ticks: E ? p : w.ticks
      }) : void 0,
      width: s,
      height: a,
      offset: c
    }, E ? !0 : m);
    Es(Array.isArray(x), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(il(x), "]")), Array.isArray(x) && (b = x);
  }
  if ((!q || !q.length) && nr(B)) {
    var M = v && v.length, O = B({
      xAxis: C ? TA(TA({}, C), {}, {
        ticks: M ? v : C.ticks
      }) : void 0,
      width: s,
      height: a,
      offset: c
    }, M ? !0 : m);
    Es(Array.isArray(O), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(il(O), "]")), Array.isArray(O) && (q = O);
  }
  return /* @__PURE__ */ re.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ re.createElement(uIe, {
    fill: l.fill,
    fillOpacity: l.fillOpacity,
    x: l.x,
    y: l.y,
    width: l.width,
    height: l.height,
    ry: l.ry
  }), /* @__PURE__ */ re.createElement(dIe, Ic({}, l, {
    offset: c,
    horizontalPoints: b,
    xAxis: C,
    yAxis: w
  })), /* @__PURE__ */ re.createElement(fIe, Ic({}, l, {
    offset: c,
    verticalPoints: q,
    xAxis: C,
    yAxis: w
  })), /* @__PURE__ */ re.createElement(hIe, Ic({}, l, {
    horizontalPoints: b
  })), /* @__PURE__ */ re.createElement(pIe, Ic({}, l, {
    verticalPoints: q
  })));
}
e9.displayName = "CartesianGrid";
var vIe = ["type", "layout", "connectNulls", "ref"], qIe = ["key"];
function sd(t) {
  "@babel/helpers - typeof";
  return sd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sd(t);
}
function VS(t, e) {
  if (t == null) return {};
  var r = yIe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function yIe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function l2() {
  return l2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, l2.apply(this, arguments);
}
function WS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? WS(Object(r), !0).forEach(function(n) {
      io(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : WS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Fl(t) {
  return BIe(t) || bIe(t) || wIe(t) || CIe();
}
function CIe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wIe(t, e) {
  if (t) {
    if (typeof t == "string") return V8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return V8(t, e);
  }
}
function bIe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function BIe(t) {
  if (Array.isArray(t)) return V8(t);
}
function V8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function EIe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function XS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, dN(n.key), n);
  }
}
function xIe(t, e, r) {
  return XS(t.prototype, e), XS(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function IIe(t, e, r) {
  return e = Lp(e), SIe(t, uN() ? Reflect.construct(e, r, Lp(t).constructor) : e.apply(t, r));
}
function SIe(t, e) {
  if (e && (sd(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return PIe(t);
}
function PIe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function uN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (uN = function() {
    return !!t;
  })();
}
function Lp(t) {
  return Lp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Lp(t);
}
function kIe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && W8(t, e);
}
function W8(t, e) {
  return W8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, W8(t, e);
}
function io(t, e, r) {
  return e = dN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function dN(t) {
  var e = OIe(t, "string");
  return sd(e) == "symbol" ? e : e + "";
}
function OIe(t, e) {
  if (sd(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (sd(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ad = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    EIe(this, e);
    for (var n = arguments.length, A = new Array(n), i = 0; i < n; i++)
      A[i] = arguments[i];
    return r = IIe(this, e, [].concat(A)), io(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), io(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), io(r, "getStrokeDasharray", function(o, s, a) {
      var c = a.reduce(function(v, C) {
        return v + C;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var l = Math.floor(o / c), u = o % c, f = s - o, d = [], g = 0, m = 0; g < a.length; m += a[g], ++g)
        if (m + a[g] > u) {
          d = [].concat(Fl(a.slice(0, g)), [u - m]);
          break;
        }
      var p = d.length % 2 === 0 ? [0, f] : [f];
      return [].concat(Fl(e.repeat(a, l)), Fl(d), p).map(function(v) {
        return "".concat(v, "px");
      }).join(", ");
    }), io(r, "id", Ld("recharts-line-")), io(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), io(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), io(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return kIe(e, t), xIe(e, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, A) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.points, s = i.xAxis, a = i.yAxis, c = i.layout, l = i.children, u = zi(l, L1), f = function(m, p) {
        return {
          x: m.x,
          y: m.y,
          value: m.value,
          errorVal: _A(m.payload, p)
        };
      }, d = {
        clipPath: n ? "url(#clipPath-".concat(A, ")") : null
      };
      return /* @__PURE__ */ re.createElement(_r, d, u.map(function(g) {
        return /* @__PURE__ */ re.cloneElement(g, {
          key: "bar-".concat(g.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: a,
          layout: c,
          dataPointFormatter: f
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, A, i) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, a = s.dot, c = s.points, l = s.dataKey, u = cr(this.props, !1), f = cr(a, !0), d = c.map(function(m, p) {
        var v = pi(pi(pi({
          key: "dot-".concat(p),
          r: 3
        }, u), f), {}, {
          value: m.value,
          dataKey: l,
          cx: m.x,
          cy: m.y,
          index: p,
          payload: m.payload
        });
        return e.renderDotItem(a, v);
      }), g = {
        clipPath: n ? "url(#clipPath-".concat(A ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ re.createElement(_r, l2({
        className: "recharts-line-dots",
        key: "dots"
      }, g), d);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, A, i, o) {
      var s = this.props, a = s.type, c = s.layout, l = s.connectNulls;
      s.ref;
      var u = VS(s, vIe), f = pi(pi(pi({}, cr(u, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: A ? "url(#clipPath-".concat(i, ")") : null,
        points: n
      }, o), {}, {
        type: a,
        layout: c,
        connectNulls: l
      });
      return /* @__PURE__ */ re.createElement(du, l2({}, f, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, A) {
      var i = this, o = this.props, s = o.points, a = o.strokeDasharray, c = o.isAnimationActive, l = o.animationBegin, u = o.animationDuration, f = o.animationEasing, d = o.animationId, g = o.animateNewValues, m = o.width, p = o.height, v = this.state, C = v.prevPoints, w = v.totalLength;
      return /* @__PURE__ */ re.createElement($o, {
        begin: l,
        duration: u,
        isActive: c,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(B) {
        var y = B.t;
        if (C) {
          var b = C.length / s.length, q = s.map(function(I, S) {
            var P = Math.floor(S * b);
            if (C[P]) {
              var H = C[P], F = yA(H.x, I.x), T = yA(H.y, I.y);
              return pi(pi({}, I), {}, {
                x: F(y),
                y: T(y)
              });
            }
            if (g) {
              var U = yA(m * 2, I.x), D = yA(p / 2, I.y);
              return pi(pi({}, I), {}, {
                x: U(y),
                y: D(y)
              });
            }
            return pi(pi({}, I), {}, {
              x: I.x,
              y: I.y
            });
          });
          return i.renderCurveStatically(q, n, A);
        }
        var E = yA(0, w), x = E(y), M;
        if (a) {
          var O = "".concat(a).split(/[,\s]+/gim).map(function(I) {
            return parseFloat(I);
          });
          M = i.getStrokeDasharray(x, w, O);
        } else
          M = i.generateSimpleStrokeDasharray(w, x);
        return i.renderCurveStatically(s, n, A, {
          strokeDasharray: M
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, A) {
      var i = this.props, o = i.points, s = i.isAnimationActive, a = this.state, c = a.prevPoints, l = a.totalLength;
      return s && o && o.length && (!c && l > 0 || !Zu(c, o)) ? this.renderCurveWithAnimation(n, A) : this.renderCurveStatically(o, n, A);
    }
  }, {
    key: "render",
    value: function() {
      var n, A = this.props, i = A.hide, o = A.dot, s = A.points, a = A.className, c = A.xAxis, l = A.yAxis, u = A.top, f = A.left, d = A.width, g = A.height, m = A.isAnimationActive, p = A.id;
      if (i || !s || !s.length)
        return null;
      var v = this.state.isAnimationFinished, C = s.length === 1, w = Br("recharts-line", a), B = c && c.allowDataOverflow, y = l && l.allowDataOverflow, b = B || y, q = hr(p) ? this.id : p, E = (n = cr(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, x = E.r, M = x === void 0 ? 3 : x, O = E.strokeWidth, I = O === void 0 ? 2 : O, S = hD(o) ? o : {}, P = S.clipDot, H = P === void 0 ? !0 : P, F = M * 2 + I;
      return /* @__PURE__ */ re.createElement(_r, {
        className: w
      }, B || y ? /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", {
        id: "clipPath-".concat(q)
      }, /* @__PURE__ */ re.createElement("rect", {
        x: B ? f : f - d / 2,
        y: y ? u : u - g / 2,
        width: B ? d : d * 2,
        height: y ? g : g * 2
      })), !H && /* @__PURE__ */ re.createElement("clipPath", {
        id: "clipPath-dots-".concat(q)
      }, /* @__PURE__ */ re.createElement("rect", {
        x: f - F / 2,
        y: u - F / 2,
        width: d + F,
        height: g + F
      }))) : null, !C && this.renderCurve(b, q), this.renderErrorBar(b, q), (C || o) && this.renderDots(b, H, q), (!m || v) && Is.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, A) {
      return n.animationId !== A.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: A.curPoints
      } : n.points !== A.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, A) {
      for (var i = n.length % 2 !== 0 ? [].concat(Fl(n), [0]) : n, o = [], s = 0; s < A; ++s)
        o = [].concat(Fl(o), Fl(i));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, A) {
      var i;
      if (/* @__PURE__ */ re.isValidElement(n))
        i = /* @__PURE__ */ re.cloneElement(n, A);
      else if (nr(n))
        i = n(A);
      else {
        var o = A.key, s = VS(A, qIe), a = Br("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        i = /* @__PURE__ */ re.createElement(V4, l2({
          key: o
        }, s, {
          className: a
        }));
      }
      return i;
    }
  }]);
}(es);
io(ad, "displayName", "Line");
io(ad, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Wo.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
io(ad, "getComposedData", function(t) {
  var e = t.props, r = t.xAxis, n = t.yAxis, A = t.xAxisTicks, i = t.yAxisTicks, o = t.dataKey, s = t.bandSize, a = t.displayedData, c = t.offset, l = e.layout, u = a.map(function(f, d) {
    var g = _A(f, o);
    return l === "horizontal" ? {
      x: qp({
        axis: r,
        ticks: A,
        bandSize: s,
        entry: f,
        index: d
      }),
      y: hr(g) ? null : n.scale(g),
      value: g,
      payload: f
    } : {
      x: hr(g) ? null : r.scale(g),
      y: qp({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: f,
        index: d
      }),
      value: g,
      payload: f
    };
  });
  return pi({
    points: u,
    layout: l
  }, c);
});
var FIe = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], TIe = ["key"], fN;
function cd(t) {
  "@babel/helpers - typeof";
  return cd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, cd(t);
}
function hN(t, e) {
  if (t == null) return {};
  var r = MIe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function MIe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Sc() {
  return Sc = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Sc.apply(this, arguments);
}
function KS(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sa(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? KS(Object(r), !0).forEach(function(n) {
      Go(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : KS(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function HIe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ZS(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, gN(n.key), n);
  }
}
function DIe(t, e, r) {
  return ZS(t.prototype, e), ZS(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function QIe(t, e, r) {
  return e = Gp(e), UIe(t, pN() ? Reflect.construct(e, r, Gp(t).constructor) : e.apply(t, r));
}
function UIe(t, e) {
  if (e && (cd(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return NIe(t);
}
function NIe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function pN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pN = function() {
    return !!t;
  })();
}
function Gp(t) {
  return Gp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Gp(t);
}
function jIe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && X8(t, e);
}
function X8(t, e) {
  return X8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, X8(t, e);
}
function Go(t, e, r) {
  return e = gN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function gN(t) {
  var e = LIe(t, "string");
  return cd(e) == "symbol" ? e : e + "";
}
function LIe(t, e) {
  if (cd(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (cd(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ic = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    HIe(this, e);
    for (var n = arguments.length, A = new Array(n), i = 0; i < n; i++)
      A[i] = arguments[i];
    return r = QIe(this, e, [].concat(A)), Go(r, "state", {
      isAnimationFinished: !0
    }), Go(r, "id", Ld("recharts-area-")), Go(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), nr(o) && o();
    }), Go(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), nr(o) && o();
    }), r;
  }
  return jIe(e, t), DIe(e, [{
    key: "renderDots",
    value: function(n, A, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var a = this.props, c = a.dot, l = a.points, u = a.dataKey, f = cr(this.props, !1), d = cr(c, !0), g = l.map(function(p, v) {
        var C = sa(sa(sa({
          key: "dot-".concat(v),
          r: 3
        }, f), d), {}, {
          index: v,
          cx: p.x,
          cy: p.y,
          dataKey: u,
          value: p.value,
          payload: p.payload,
          points: l
        });
        return e.renderDotItem(c, C);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(A ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ re.createElement(_r, Sc({
        className: "recharts-area-dots"
      }, m), g);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var A = this.props, i = A.baseLine, o = A.points, s = A.strokeWidth, a = o[0].x, c = o[o.length - 1].x, l = n * Math.abs(a - c), u = Ba(o.map(function(f) {
        return f.y || 0;
      }));
      return At(i) && typeof i == "number" ? u = Math.max(i, u) : i && Array.isArray(i) && i.length && (u = Math.max(Ba(i.map(function(f) {
        return f.y || 0;
      })), u)), At(u) ? /* @__PURE__ */ re.createElement("rect", {
        x: a < c ? a : a - l,
        y: 0,
        width: l,
        height: Math.floor(u + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var A = this.props, i = A.baseLine, o = A.points, s = A.strokeWidth, a = o[0].y, c = o[o.length - 1].y, l = n * Math.abs(a - c), u = Ba(o.map(function(f) {
        return f.x || 0;
      }));
      return At(i) && typeof i == "number" ? u = Math.max(i, u) : i && Array.isArray(i) && i.length && (u = Math.max(Ba(i.map(function(f) {
        return f.x || 0;
      })), u)), At(u) ? /* @__PURE__ */ re.createElement("rect", {
        x: 0,
        y: a < c ? a : a - l,
        width: u + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(l)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var A = this.props.layout;
      return A === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, A, i, o) {
      var s = this.props, a = s.layout, c = s.type, l = s.stroke, u = s.connectNulls, f = s.isRange;
      s.ref;
      var d = hN(s, FIe);
      return /* @__PURE__ */ re.createElement(_r, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ re.createElement(du, Sc({}, cr(d, !0), {
        points: n,
        connectNulls: u,
        type: c,
        baseLine: A,
        layout: a,
        stroke: "none",
        className: "recharts-area-area"
      })), l !== "none" && /* @__PURE__ */ re.createElement(du, Sc({}, cr(this.props, !1), {
        className: "recharts-area-curve",
        layout: a,
        type: c,
        connectNulls: u,
        fill: "none",
        points: n
      })), l !== "none" && f && /* @__PURE__ */ re.createElement(du, Sc({}, cr(this.props, !1), {
        className: "recharts-area-curve",
        layout: a,
        type: c,
        connectNulls: u,
        fill: "none",
        points: A
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, A) {
      var i = this, o = this.props, s = o.points, a = o.baseLine, c = o.isAnimationActive, l = o.animationBegin, u = o.animationDuration, f = o.animationEasing, d = o.animationId, g = this.state, m = g.prevPoints, p = g.prevBaseLine;
      return /* @__PURE__ */ re.createElement($o, {
        begin: l,
        duration: u,
        isActive: c,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(v) {
        var C = v.t;
        if (m) {
          var w = m.length / s.length, B = s.map(function(E, x) {
            var M = Math.floor(x * w);
            if (m[M]) {
              var O = m[M], I = yA(O.x, E.x), S = yA(O.y, E.y);
              return sa(sa({}, E), {}, {
                x: I(C),
                y: S(C)
              });
            }
            return E;
          }), y;
          if (At(a) && typeof a == "number") {
            var b = yA(p, a);
            y = b(C);
          } else if (hr(a) || jd(a)) {
            var q = yA(p, 0);
            y = q(C);
          } else
            y = a.map(function(E, x) {
              var M = Math.floor(x * w);
              if (p[M]) {
                var O = p[M], I = yA(O.x, E.x), S = yA(O.y, E.y);
                return sa(sa({}, E), {}, {
                  x: I(C),
                  y: S(C)
                });
              }
              return E;
            });
          return i.renderAreaStatically(B, y, n, A);
        }
        return /* @__PURE__ */ re.createElement(_r, null, /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", {
          id: "animationClipPath-".concat(A)
        }, i.renderClipRect(C))), /* @__PURE__ */ re.createElement(_r, {
          clipPath: "url(#animationClipPath-".concat(A, ")")
        }, i.renderAreaStatically(s, a, n, A)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, A) {
      var i = this.props, o = i.points, s = i.baseLine, a = i.isAnimationActive, c = this.state, l = c.prevPoints, u = c.prevBaseLine, f = c.totalLength;
      return a && o && o.length && (!l && f > 0 || !Zu(l, o) || !Zu(u, s)) ? this.renderAreaWithAnimation(n, A) : this.renderAreaStatically(o, s, n, A);
    }
  }, {
    key: "render",
    value: function() {
      var n, A = this.props, i = A.hide, o = A.dot, s = A.points, a = A.className, c = A.top, l = A.left, u = A.xAxis, f = A.yAxis, d = A.width, g = A.height, m = A.isAnimationActive, p = A.id;
      if (i || !s || !s.length)
        return null;
      var v = this.state.isAnimationFinished, C = s.length === 1, w = Br("recharts-area", a), B = u && u.allowDataOverflow, y = f && f.allowDataOverflow, b = B || y, q = hr(p) ? this.id : p, E = (n = cr(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, x = E.r, M = x === void 0 ? 3 : x, O = E.strokeWidth, I = O === void 0 ? 2 : O, S = hD(o) ? o : {}, P = S.clipDot, H = P === void 0 ? !0 : P, F = M * 2 + I;
      return /* @__PURE__ */ re.createElement(_r, {
        className: w
      }, B || y ? /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", {
        id: "clipPath-".concat(q)
      }, /* @__PURE__ */ re.createElement("rect", {
        x: B ? l : l - d / 2,
        y: y ? c : c - g / 2,
        width: B ? d : d * 2,
        height: y ? g : g * 2
      })), !H && /* @__PURE__ */ re.createElement("clipPath", {
        id: "clipPath-dots-".concat(q)
      }, /* @__PURE__ */ re.createElement("rect", {
        x: l - F / 2,
        y: c - F / 2,
        width: d + F,
        height: g + F
      }))) : null, C ? null : this.renderArea(b, q), (o || C) && this.renderDots(b, H, q), (!m || v) && Is.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, A) {
      return n.animationId !== A.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: A.curPoints,
        prevBaseLine: A.curBaseLine
      } : n.points !== A.curPoints || n.baseLine !== A.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(es);
fN = ic;
Go(ic, "displayName", "Area");
Go(ic, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Wo.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Go(ic, "getBaseValue", function(t, e, r, n) {
  var A = t.layout, i = t.baseValue, o = e.props.baseValue, s = o ?? i;
  if (At(s) && typeof s == "number")
    return s;
  var a = A === "horizontal" ? n : r, c = a.scale.domain();
  if (a.type === "number") {
    var l = Math.max(c[0], c[1]), u = Math.min(c[0], c[1]);
    return s === "dataMin" ? u : s === "dataMax" || l < 0 ? l : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
Go(ic, "getComposedData", function(t) {
  var e = t.props, r = t.item, n = t.xAxis, A = t.yAxis, i = t.xAxisTicks, o = t.yAxisTicks, s = t.bandSize, a = t.dataKey, c = t.stackedData, l = t.dataStartIndex, u = t.displayedData, f = t.offset, d = e.layout, g = c && c.length, m = fN.getBaseValue(e, r, n, A), p = d === "horizontal", v = !1, C = u.map(function(B, y) {
    var b;
    g ? b = c[l + y] : (b = _A(B, a), Array.isArray(b) ? v = !0 : b = [m, b]);
    var q = b[1] == null || g && _A(B, a) == null;
    return p ? {
      x: qp({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: B,
        index: y
      }),
      y: q ? null : A.scale(b[1]),
      value: b,
      payload: B
    } : {
      x: q ? null : n.scale(b[1]),
      y: qp({
        axis: A,
        ticks: o,
        bandSize: s,
        entry: B,
        index: y
      }),
      value: b,
      payload: B
    };
  }), w;
  return g || v ? w = C.map(function(B) {
    var y = Array.isArray(B.value) ? B.value[0] : null;
    return p ? {
      x: B.x,
      y: y != null && B.y != null ? A.scale(y) : null
    } : {
      x: y != null ? n.scale(y) : null,
      y: B.y
    };
  }) : w = p ? A.scale(m) : n.scale(m), sa({
    points: C,
    baseLine: w,
    layout: d,
    isRange: v
  }, f);
});
Go(ic, "renderDotItem", function(t, e) {
  var r;
  if (/* @__PURE__ */ re.isValidElement(t))
    r = /* @__PURE__ */ re.cloneElement(t, e);
  else if (nr(t))
    r = t(e);
  else {
    var n = Br("recharts-area-dot", typeof t != "boolean" ? t.className : ""), A = e.key, i = hN(e, TIe);
    r = /* @__PURE__ */ re.createElement(V4, Sc({}, i, {
      key: A,
      className: n
    }));
  }
  return r;
});
function ld(t) {
  "@babel/helpers - typeof";
  return ld = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ld(t);
}
function GIe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function RIe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, qN(n.key), n);
  }
}
function zIe(t, e, r) {
  return RIe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function YIe(t, e, r) {
  return e = Rp(e), VIe(t, mN() ? Reflect.construct(e, r || [], Rp(t).constructor) : e.apply(t, r));
}
function VIe(t, e) {
  if (e && (ld(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return WIe(t);
}
function WIe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function mN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mN = function() {
    return !!t;
  })();
}
function Rp(t) {
  return Rp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Rp(t);
}
function XIe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && K8(t, e);
}
function K8(t, e) {
  return K8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, K8(t, e);
}
function vN(t, e, r) {
  return e = qN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function qN(t) {
  var e = KIe(t, "string");
  return ld(e) == "symbol" ? e : e + "";
}
function KIe(t, e) {
  if (ld(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (ld(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Z8() {
  return Z8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Z8.apply(this, arguments);
}
function ZIe(t) {
  var e = t.xAxisId, r = Ay(), n = iy(), A = $U(e);
  return A == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ re.createElement(Xd, Z8({}, A, {
      className: Br("recharts-".concat(A.axisType, " ").concat(A.axisType), A.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return vs(o, !0);
      }
    }))
  );
}
var oc = /* @__PURE__ */ function(t) {
  function e() {
    return GIe(this, e), YIe(this, e, arguments);
  }
  return XIe(e, t), zIe(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ re.createElement(ZIe, this.props);
    }
  }]);
}(re.Component);
vN(oc, "displayName", "XAxis");
vN(oc, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function ud(t) {
  "@babel/helpers - typeof";
  return ud = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ud(t);
}
function JIe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _Ie(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, wN(n.key), n);
  }
}
function $Ie(t, e, r) {
  return _Ie(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function eSe(t, e, r) {
  return e = zp(e), tSe(t, yN() ? Reflect.construct(e, r || [], zp(t).constructor) : e.apply(t, r));
}
function tSe(t, e) {
  if (e && (ud(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rSe(t);
}
function rSe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function yN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yN = function() {
    return !!t;
  })();
}
function zp(t) {
  return zp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zp(t);
}
function nSe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && J8(t, e);
}
function J8(t, e) {
  return J8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, J8(t, e);
}
function CN(t, e, r) {
  return e = wN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function wN(t) {
  var e = ASe(t, "string");
  return ud(e) == "symbol" ? e : e + "";
}
function ASe(t, e) {
  if (ud(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (ud(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function _8() {
  return _8 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, _8.apply(this, arguments);
}
var iSe = function(e) {
  var r = e.yAxisId, n = Ay(), A = iy(), i = eN(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ re.createElement(Xd, _8({}, i, {
      className: Br("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: A
      },
      ticksGenerator: function(s) {
        return vs(s, !0);
      }
    }))
  );
}, sc = /* @__PURE__ */ function(t) {
  function e() {
    return JIe(this, e), eSe(this, e, arguments);
  }
  return nSe(e, t), $Ie(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ re.createElement(iSe, this.props);
    }
  }]);
}(re.Component);
CN(sc, "displayName", "YAxis");
CN(sc, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function JS(t) {
  return cSe(t) || aSe(t) || sSe(t) || oSe();
}
function oSe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sSe(t, e) {
  if (t) {
    if (typeof t == "string") return $8(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $8(t, e);
  }
}
function aSe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function cSe(t) {
  if (Array.isArray(t)) return $8(t);
}
function $8(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var em = function(e, r, n, A, i) {
  var o = zi(e, sy), s = zi(e, J4), a = [].concat(JS(o), JS(s)), c = zi(e, $4), l = "".concat(A, "Id"), u = A[0], f = r;
  if (a.length && (f = a.reduce(function(m, p) {
    if (p.props[l] === n && Ko(p.props, "extendDomain") && At(p.props[u])) {
      var v = p.props[u];
      return [Math.min(m[0], v), Math.max(m[1], v)];
    }
    return m;
  }, f)), c.length) {
    var d = "".concat(u, "1"), g = "".concat(u, "2");
    f = c.reduce(function(m, p) {
      if (p.props[l] === n && Ko(p.props, "extendDomain") && At(p.props[d]) && At(p.props[g])) {
        var v = p.props[d], C = p.props[g];
        return [Math.min(m[0], v, C), Math.max(m[1], v, C)];
      }
      return m;
    }, f);
  }
  return i && i.length && (f = i.reduce(function(m, p) {
    return At(p) ? [Math.min(m[0], p), Math.max(m[1], p)] : m;
  }, f)), f;
}, bN = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function A(a, c, l) {
    this.fn = a, this.context = c, this.once = l || !1;
  }
  function i(a, c, l, u, f) {
    if (typeof l != "function")
      throw new TypeError("The listener must be a function");
    var d = new A(l, u || a, f), g = r ? r + c : c;
    return a._events[g] ? a._events[g].fn ? a._events[g] = [a._events[g], d] : a._events[g].push(d) : (a._events[g] = d, a._eventsCount++), a;
  }
  function o(a, c) {
    --a._eventsCount === 0 ? a._events = new n() : delete a._events[c];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], l, u;
    if (this._eventsCount === 0) return c;
    for (u in l = this._events)
      e.call(l, u) && c.push(r ? u.slice(1) : u);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
  }, s.prototype.listeners = function(c) {
    var l = r ? r + c : c, u = this._events[l];
    if (!u) return [];
    if (u.fn) return [u.fn];
    for (var f = 0, d = u.length, g = new Array(d); f < d; f++)
      g[f] = u[f].fn;
    return g;
  }, s.prototype.listenerCount = function(c) {
    var l = r ? r + c : c, u = this._events[l];
    return u ? u.fn ? 1 : u.length : 0;
  }, s.prototype.emit = function(c, l, u, f, d, g) {
    var m = r ? r + c : c;
    if (!this._events[m]) return !1;
    var p = this._events[m], v = arguments.length, C, w;
    if (p.fn) {
      switch (p.once && this.removeListener(c, p.fn, void 0, !0), v) {
        case 1:
          return p.fn.call(p.context), !0;
        case 2:
          return p.fn.call(p.context, l), !0;
        case 3:
          return p.fn.call(p.context, l, u), !0;
        case 4:
          return p.fn.call(p.context, l, u, f), !0;
        case 5:
          return p.fn.call(p.context, l, u, f, d), !0;
        case 6:
          return p.fn.call(p.context, l, u, f, d, g), !0;
      }
      for (w = 1, C = new Array(v - 1); w < v; w++)
        C[w - 1] = arguments[w];
      p.fn.apply(p.context, C);
    } else {
      var B = p.length, y;
      for (w = 0; w < B; w++)
        switch (p[w].once && this.removeListener(c, p[w].fn, void 0, !0), v) {
          case 1:
            p[w].fn.call(p[w].context);
            break;
          case 2:
            p[w].fn.call(p[w].context, l);
            break;
          case 3:
            p[w].fn.call(p[w].context, l, u);
            break;
          case 4:
            p[w].fn.call(p[w].context, l, u, f);
            break;
          default:
            if (!C) for (y = 1, C = new Array(v - 1); y < v; y++)
              C[y - 1] = arguments[y];
            p[w].fn.apply(p[w].context, C);
        }
    }
    return !0;
  }, s.prototype.on = function(c, l, u) {
    return i(this, c, l, u, !1);
  }, s.prototype.once = function(c, l, u) {
    return i(this, c, l, u, !0);
  }, s.prototype.removeListener = function(c, l, u, f) {
    var d = r ? r + c : c;
    if (!this._events[d]) return this;
    if (!l)
      return o(this, d), this;
    var g = this._events[d];
    if (g.fn)
      g.fn === l && (!f || g.once) && (!u || g.context === u) && o(this, d);
    else {
      for (var m = 0, p = [], v = g.length; m < v; m++)
        (g[m].fn !== l || f && !g[m].once || u && g[m].context !== u) && p.push(g[m]);
      p.length ? this._events[d] = p.length === 1 ? p[0] : p : o(this, d);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var l;
    return c ? (l = r ? r + c : c, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, t.exports = s;
})(bN);
var lSe = bN.exports;
const uSe = /* @__PURE__ */ Vr(lSe);
var z6 = new uSe(), Y6 = "recharts.syncMouseEvents";
function a1(t) {
  "@babel/helpers - typeof";
  return a1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, a1(t);
}
function dSe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fSe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, BN(n.key), n);
  }
}
function hSe(t, e, r) {
  return fSe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function V6(t, e, r) {
  return e = BN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function BN(t) {
  var e = pSe(t, "string");
  return a1(e) == "symbol" ? e : e + "";
}
function pSe(t, e) {
  if (a1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (a1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var gSe = /* @__PURE__ */ function() {
  function t() {
    dSe(this, t), V6(this, "activeIndex", 0), V6(this, "coordinateList", []), V6(this, "layout", "horizontal");
  }
  return hSe(t, [{
    key: "setDetails",
    value: function(r) {
      var n, A = r.coordinateList, i = A === void 0 ? null : A, o = r.container, s = o === void 0 ? null : o, a = r.layout, c = a === void 0 ? null : a, l = r.offset, u = l === void 0 ? null : l, f = r.mouseHandlerCallback, d = f === void 0 ? null : f;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = u ?? this.offset, this.mouseHandlerCallback = d ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var A = this.container.getBoundingClientRect(), i = A.x, o = A.y, s = A.height, a = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, u = i + a + c, f = o + this.offset.top + s / 2 + l;
        this.mouseHandlerCallback({
          pageX: u,
          pageY: f
        });
      }
    }
  }]);
}();
function mSe(t, e, r) {
  if (r === "number" && e === !0 && Array.isArray(t)) {
    var n = t == null ? void 0 : t[0], A = t == null ? void 0 : t[1];
    if (n && A && At(n) && At(A))
      return !0;
  }
  return !1;
}
function vSe(t, e, r, n) {
  var A = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: t === "horizontal" ? e.x - A : r.left + 0.5,
    y: t === "horizontal" ? r.top + 0.5 : e.y - A,
    width: t === "horizontal" ? n : r.width - 1,
    height: t === "horizontal" ? r.height - 1 : n
  };
}
function EN(t) {
  var e = t.cx, r = t.cy, n = t.radius, A = t.startAngle, i = t.endAngle, o = CA(e, r, n, A), s = CA(e, r, n, i);
  return {
    points: [o, s],
    cx: e,
    cy: r,
    radius: n,
    startAngle: A,
    endAngle: i
  };
}
function qSe(t, e, r) {
  var n, A, i, o;
  if (t === "horizontal")
    n = e.x, i = n, A = r.top, o = r.top + r.height;
  else if (t === "vertical")
    A = e.y, o = A, n = r.left, i = r.left + r.width;
  else if (e.cx != null && e.cy != null)
    if (t === "centric") {
      var s = e.cx, a = e.cy, c = e.innerRadius, l = e.outerRadius, u = e.angle, f = CA(s, a, c, u), d = CA(s, a, l, u);
      n = f.x, A = f.y, i = d.x, o = d.y;
    } else
      return EN(e);
  return [{
    x: n,
    y: A
  }, {
    x: i,
    y: o
  }];
}
function c1(t) {
  "@babel/helpers - typeof";
  return c1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, c1(t);
}
function _S(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rh(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _S(Object(r), !0).forEach(function(n) {
      ySe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _S(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function ySe(t, e, r) {
  return e = CSe(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function CSe(t) {
  var e = wSe(t, "string");
  return c1(e) == "symbol" ? e : e + "";
}
function wSe(t, e) {
  if (c1(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (c1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function bSe(t) {
  var e, r, n = t.element, A = t.tooltipEventType, i = t.isActive, o = t.activeCoordinate, s = t.activePayload, a = t.offset, c = t.activeTooltipIndex, l = t.tooltipAxisBandSize, u = t.layout, f = t.chartName, d = (e = n.props.cursor) !== null && e !== void 0 ? e : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !d || !i || !o || f !== "ScatterChart" && A !== "axis")
    return null;
  var g, m = du;
  if (f === "ScatterChart")
    g = o, m = dbe;
  else if (f === "BarChart")
    g = vSe(u, o, a, l), m = $q;
  else if (u === "radial") {
    var p = EN(o), v = p.cx, C = p.cy, w = p.radius, B = p.startAngle, y = p.endAngle;
    g = {
      cx: v,
      cy: C,
      startAngle: B,
      endAngle: y,
      innerRadius: w,
      outerRadius: w
    }, m = IU;
  } else
    g = {
      points: qSe(u, o, a)
    }, m = du;
  var b = rh(rh(rh(rh({
    stroke: "#ccc",
    pointerEvents: "none"
  }, a), g), cr(d, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: Br("recharts-tooltip-cursor", d.className)
  });
  return /* @__PURE__ */ QA(d) ? /* @__PURE__ */ vn(d, b) : /* @__PURE__ */ gP(m, b);
}
var BSe = ["item"], ESe = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function dd(t) {
  "@babel/helpers - typeof";
  return dd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, dd(t);
}
function Jl() {
  return Jl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Jl.apply(this, arguments);
}
function $S(t, e) {
  return SSe(t) || ISe(t, e) || IN(t, e) || xSe();
}
function xSe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ISe(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, A, i, o, s = [], a = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(a = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); a = !0) ;
    } catch (l) {
      c = !0, A = l;
    } finally {
      try {
        if (!a && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw A;
      }
    }
    return s;
  }
}
function SSe(t) {
  if (Array.isArray(t)) return t;
}
function eP(t, e) {
  if (t == null) return {};
  var r = PSe(t, e), n, A;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (A = 0; A < i.length; A++)
      n = i[A], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function PSe(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function kSe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function OSe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, SN(n.key), n);
  }
}
function FSe(t, e, r) {
  return OSe(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function TSe(t, e, r) {
  return e = Yp(e), MSe(t, xN() ? Reflect.construct(e, r, Yp(t).constructor) : e.apply(t, r));
}
function MSe(t, e) {
  if (e && (dd(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return HSe(t);
}
function HSe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function xN() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (xN = function() {
    return !!t;
  })();
}
function Yp(t) {
  return Yp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Yp(t);
}
function DSe(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && tm(t, e);
}
function tm(t, e) {
  return tm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, A) {
    return n.__proto__ = A, n;
  }, tm(t, e);
}
function fd(t) {
  return NSe(t) || USe(t) || IN(t) || QSe();
}
function QSe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IN(t, e) {
  if (t) {
    if (typeof t == "string") return rm(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return rm(t, e);
  }
}
function USe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function NSe(t) {
  if (Array.isArray(t)) return rm(t);
}
function rm(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function tP(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(A) {
      return Object.getOwnPropertyDescriptor(t, A).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tP(Object(r), !0).forEach(function(n) {
      Lt(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : tP(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Lt(t, e, r) {
  return e = SN(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function SN(t) {
  var e = jSe(t, "string");
  return dd(e) == "symbol" ? e : e + "";
}
function jSe(t, e) {
  if (dd(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (dd(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var LSe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, GSe = {
  width: "100%",
  height: "100%"
}, PN = {
  x: 0,
  y: 0
};
function nh(t) {
  return t;
}
var RSe = function(e, r) {
  return r === "horizontal" ? e.x : r === "vertical" ? e.y : r === "centric" ? e.angle : e.radius;
}, zSe = function(e, r, n, A) {
  var i = r.find(function(l) {
    return l && l.index === n;
  });
  if (i) {
    if (e === "horizontal")
      return {
        x: i.coordinate,
        y: A.y
      };
    if (e === "vertical")
      return {
        x: A.x,
        y: i.coordinate
      };
    if (e === "centric") {
      var o = i.coordinate, s = A.radius;
      return Fe(Fe(Fe({}, A), CA(A.cx, A.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var a = i.coordinate, c = A.angle;
    return Fe(Fe(Fe({}, A), CA(A.cx, A.cy, a, c)), {}, {
      angle: c,
      radius: a
    });
  }
  return PN;
}, t9 = function(e, r) {
  var n = r.graphicalItems, A = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(s, a) {
    var c = a.props.data;
    return c && c.length ? [].concat(fd(s), fd(c)) : s;
  }, []);
  return o.length > 0 ? o : e && e.length && At(A) && At(i) ? e.slice(A, i + 1) : [];
};
function kN(t) {
  return t === "number" ? [0, "auto"] : void 0;
}
var nm = function(e, r, n, A) {
  var i = e.graphicalItems, o = e.tooltipAxis, s = t9(r, e);
  return n < 0 || !i || !i.length || n >= s.length ? null : i.reduce(function(a, c) {
    var l, u = (l = c.props.data) !== null && l !== void 0 ? l : r;
    u && e.dataStartIndex + e.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    e.dataEndIndex - e.dataStartIndex >= n && (u = u.slice(e.dataStartIndex, e.dataEndIndex + 1));
    var f;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var d = u === void 0 ? s : u;
      f = R3(d, o.dataKey, A);
    } else
      f = u && u[n] || s[n];
    return f ? [].concat(fd(a), [BU(c, f)]) : a;
  }, []);
}, rP = function(e, r, n, A) {
  var i = A || {
    x: e.chartX,
    y: e.chartY
  }, o = RSe(i, n), s = e.orderedTooltipTicks, a = e.tooltipAxis, c = e.tooltipTicks, l = _qe(o, s, c, a);
  if (l >= 0 && c) {
    var u = c[l] && c[l].value, f = nm(e, r, l, u), d = zSe(n, s, l, i);
    return {
      activeTooltipIndex: l,
      activeLabel: u,
      activePayload: f,
      activeCoordinate: d
    };
  }
  return null;
}, YSe = function(e, r) {
  var n = r.axes, A = r.graphicalItems, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, a = r.dataStartIndex, c = r.dataEndIndex, l = e.layout, u = e.children, f = e.stackOffset, d = CU(l, i);
  return n.reduce(function(g, m) {
    var p, v = m.type.defaultProps !== void 0 ? Fe(Fe({}, m.type.defaultProps), m.props) : m.props, C = v.type, w = v.dataKey, B = v.allowDataOverflow, y = v.allowDuplicatedCategory, b = v.scale, q = v.ticks, E = v.includeHidden, x = v[o];
    if (g[x])
      return g;
    var M = t9(e.data, {
      graphicalItems: A.filter(function(j) {
        var Z, W = o in j.props ? j.props[o] : (Z = j.type.defaultProps) === null || Z === void 0 ? void 0 : Z[o];
        return W === x;
      }),
      dataStartIndex: a,
      dataEndIndex: c
    }), O = M.length, I, S, P;
    mSe(v.domain, B, C) && (I = y8(v.domain, null, B), d && (C === "number" || b !== "auto") && (P = a2(M, w, "category")));
    var H = kN(C);
    if (!I || I.length === 0) {
      var F, T = (F = v.domain) !== null && F !== void 0 ? F : H;
      if (w) {
        if (I = a2(M, w, C), C === "category" && d) {
          var U = j2e(I);
          y && U ? (S = I, I = kp(0, O)) : y || (I = TI(T, I, m).reduce(function(j, Z) {
            return j.indexOf(Z) >= 0 ? j : [].concat(fd(j), [Z]);
          }, []));
        } else if (C === "category")
          y ? I = I.filter(function(j) {
            return j !== "" && !hr(j);
          }) : I = TI(T, I, m).reduce(function(j, Z) {
            return j.indexOf(Z) >= 0 || Z === "" || hr(Z) ? j : [].concat(fd(j), [Z]);
          }, []);
        else if (C === "number") {
          var D = nye(M, A.filter(function(j) {
            var Z, W, R = o in j.props ? j.props[o] : (Z = j.type.defaultProps) === null || Z === void 0 ? void 0 : Z[o], K = "hide" in j.props ? j.props.hide : (W = j.type.defaultProps) === null || W === void 0 ? void 0 : W.hide;
            return R === x && (E || !K);
          }), w, i, l);
          D && (I = D);
        }
        d && (C === "number" || b !== "auto") && (P = a2(M, w, "category"));
      } else d ? I = kp(0, O) : s && s[x] && s[x].hasStack && C === "number" ? I = f === "expand" ? [0, 1] : bU(s[x].stackGroups, a, c) : I = yU(M, A.filter(function(j) {
        var Z = o in j.props ? j.props[o] : j.type.defaultProps[o], W = "hide" in j.props ? j.props.hide : j.type.defaultProps.hide;
        return Z === x && (E || !W);
      }), C, l, !0);
      if (C === "number")
        I = em(u, I, x, i, q), T && (I = y8(T, I, B));
      else if (C === "category" && T) {
        var Q = T, Y = I.every(function(j) {
          return Q.indexOf(j) >= 0;
        });
        Y && (I = Q);
      }
    }
    return Fe(Fe({}, g), {}, Lt({}, x, Fe(Fe({}, v), {}, {
      axisType: i,
      domain: I,
      categoricalDomain: P,
      duplicateDomain: S,
      originalDomain: (p = v.domain) !== null && p !== void 0 ? p : H,
      isCategorical: d,
      layout: l
    })));
  }, {});
}, VSe = function(e, r) {
  var n = r.graphicalItems, A = r.Axis, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, a = r.dataStartIndex, c = r.dataEndIndex, l = e.layout, u = e.children, f = t9(e.data, {
    graphicalItems: n,
    dataStartIndex: a,
    dataEndIndex: c
  }), d = f.length, g = CU(l, i), m = -1;
  return n.reduce(function(p, v) {
    var C = v.type.defaultProps !== void 0 ? Fe(Fe({}, v.type.defaultProps), v.props) : v.props, w = C[o], B = kN("number");
    if (!p[w]) {
      m++;
      var y;
      return g ? y = kp(0, d) : s && s[w] && s[w].hasStack ? (y = bU(s[w].stackGroups, a, c), y = em(u, y, w, i)) : (y = y8(B, yU(f, n.filter(function(b) {
        var q, E, x = o in b.props ? b.props[o] : (q = b.type.defaultProps) === null || q === void 0 ? void 0 : q[o], M = "hide" in b.props ? b.props.hide : (E = b.type.defaultProps) === null || E === void 0 ? void 0 : E.hide;
        return x === w && !M;
      }), "number", l), A.defaultProps.allowDataOverflow), y = em(u, y, w, i)), Fe(Fe({}, p), {}, Lt({}, w, Fe(Fe({
        axisType: i
      }, A.defaultProps), {}, {
        hide: !0,
        orientation: Ri(LSe, "".concat(i, ".").concat(m % 2), null),
        domain: y,
        originalDomain: B,
        isCategorical: g,
        layout: l
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return p;
  }, {});
}, WSe = function(e, r) {
  var n = r.axisType, A = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, a = r.dataStartIndex, c = r.dataEndIndex, l = e.children, u = "".concat(A, "Id"), f = zi(l, i), d = {};
  return f.length ? d = YSe(e, {
    axes: f,
    graphicalItems: o,
    axisType: A,
    axisIdKey: u,
    stackGroups: s,
    dataStartIndex: a,
    dataEndIndex: c
  }) : o && o.length && (d = VSe(e, {
    Axis: i,
    graphicalItems: o,
    axisType: A,
    axisIdKey: u,
    stackGroups: s,
    dataStartIndex: a,
    dataEndIndex: c
  })), d;
}, XSe = function(e) {
  var r = ga(e), n = vs(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: Eq(n, function(A) {
      return A.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: yp(r, n)
  };
}, nP = function(e) {
  var r = e.children, n = e.defaultShowTooltip, A = mi(r, ed), i = 0, o = 0;
  return e.data && e.data.length !== 0 && (o = e.data.length - 1), A && A.props && (A.props.startIndex >= 0 && (i = A.props.startIndex), A.props.endIndex >= 0 && (o = A.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, KSe = function(e) {
  return !e || !e.length ? !1 : e.some(function(r) {
    var n = Bs(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, AP = function(e) {
  return e === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : e === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : e === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, ZSe = function(e, r) {
  var n = e.props, A = e.graphicalItems, i = e.xAxisMap, o = i === void 0 ? {} : i, s = e.yAxisMap, a = s === void 0 ? {} : s, c = n.width, l = n.height, u = n.children, f = n.margin || {}, d = mi(u, ed), g = mi(u, cu), m = Object.keys(a).reduce(function(y, b) {
    var q = a[b], E = q.orientation;
    return !q.mirror && !q.hide ? Fe(Fe({}, y), {}, Lt({}, E, y[E] + q.width)) : y;
  }, {
    left: f.left || 0,
    right: f.right || 0
  }), p = Object.keys(o).reduce(function(y, b) {
    var q = o[b], E = q.orientation;
    return !q.mirror && !q.hide ? Fe(Fe({}, y), {}, Lt({}, E, Ri(y, "".concat(E)) + q.height)) : y;
  }, {
    top: f.top || 0,
    bottom: f.bottom || 0
  }), v = Fe(Fe({}, p), m), C = v.bottom;
  d && (v.bottom += d.props.height || ed.defaultProps.height), g && r && (v = tye(v, A, n, r));
  var w = c - v.left - v.right, B = l - v.top - v.bottom;
  return Fe(Fe({
    brushBottom: C
  }, v), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(B, 0)
  });
}, JSe = function(e, r) {
  if (r === "xAxis")
    return e[r].width;
  if (r === "yAxis")
    return e[r].height;
}, ly = function(e) {
  var r = e.chartName, n = e.GraphicalChild, A = e.defaultTooltipEventType, i = A === void 0 ? "axis" : A, o = e.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, a = e.axisComponents, c = e.legendContent, l = e.formatAxisMap, u = e.defaultProps, f = function(v, C) {
    var w = C.graphicalItems, B = C.stackGroups, y = C.offset, b = C.updateId, q = C.dataStartIndex, E = C.dataEndIndex, x = v.barSize, M = v.layout, O = v.barGap, I = v.barCategoryGap, S = v.maxBarSize, P = AP(M), H = P.numericAxisName, F = P.cateAxisName, T = KSe(w), U = [];
    return w.forEach(function(D, Q) {
      var Y = t9(v.data, {
        graphicalItems: [D],
        dataStartIndex: q,
        dataEndIndex: E
      }), j = D.type.defaultProps !== void 0 ? Fe(Fe({}, D.type.defaultProps), D.props) : D.props, Z = j.dataKey, W = j.maxBarSize, R = j["".concat(H, "Id")], K = j["".concat(F, "Id")], L = {}, G = a.reduce(function(ve, ge) {
        var oe, ce, pe = C["".concat(ge.axisType, "Map")], qe = j["".concat(ge.axisType, "Id")];
        pe && pe[qe] || ge.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? si(!1, "Specifying a(n) ".concat(ge.axisType, "Id requires a corresponding ").concat(
          ge.axisType,
          "Id on the targeted graphical component "
        ).concat((oe = D == null || (ce = D.type) === null || ce === void 0 ? void 0 : ce.displayName) !== null && oe !== void 0 ? oe : "")) : si());
        var Se = pe[qe];
        return Fe(Fe({}, ve), {}, Lt(Lt({}, ge.axisType, Se), "".concat(ge.axisType, "Ticks"), vs(Se)));
      }, L), V = G[F], _ = G["".concat(F, "Ticks")], J = B && B[R] && B[R].hasStack && pye(D, B[R].stackGroups), X = Bs(D.type).indexOf("Bar") >= 0, ne = yp(V, _), ee = [], $ = T && $qe({
        barSize: x,
        stackGroups: B,
        totalSize: JSe(G, F)
      });
      if (X) {
        var te, ae, se = hr(W) ? S : W, ue = (te = (ae = yp(V, _, !0)) !== null && ae !== void 0 ? ae : se) !== null && te !== void 0 ? te : 0;
        ee = eye({
          barGap: O,
          barCategoryGap: I,
          bandSize: ue !== ne ? ue : ne,
          sizeList: $[K],
          maxBarSize: se
        }), ue !== ne && (ee = ee.map(function(ve) {
          return Fe(Fe({}, ve), {}, {
            position: Fe(Fe({}, ve.position), {}, {
              offset: ve.position.offset - ue / 2
            })
          });
        }));
      }
      var fe = D && D.type && D.type.getComposedData;
      fe && U.push({
        props: Fe(Fe({}, fe(Fe(Fe({}, G), {}, {
          displayedData: Y,
          props: v,
          dataKey: Z,
          item: D,
          bandSize: ne,
          barPosition: ee,
          offset: y,
          stackedData: J,
          layout: M,
          dataStartIndex: q,
          dataEndIndex: E
        }))), {}, Lt(Lt(Lt({
          key: D.key || "item-".concat(Q)
        }, H, G[H]), F, G[F]), "animationId", b)),
        childIndex: J2e(D, v.children),
        item: D
      });
    }), U;
  }, d = function(v, C) {
    var w = v.props, B = v.dataStartIndex, y = v.dataEndIndex, b = v.updateId;
    if (!IE({
      props: w
    }))
      return null;
    var q = w.children, E = w.layout, x = w.stackOffset, M = w.data, O = w.reverseStackOrder, I = AP(E), S = I.numericAxisName, P = I.cateAxisName, H = zi(q, n), F = dye(M, H, "".concat(S, "Id"), "".concat(P, "Id"), x, O), T = a.reduce(function(j, Z) {
      var W = "".concat(Z.axisType, "Map");
      return Fe(Fe({}, j), {}, Lt({}, W, WSe(w, Fe(Fe({}, Z), {}, {
        graphicalItems: H,
        stackGroups: Z.axisType === S && F,
        dataStartIndex: B,
        dataEndIndex: y
      }))));
    }, {}), U = ZSe(Fe(Fe({}, T), {}, {
      props: w,
      graphicalItems: H
    }), C == null ? void 0 : C.legendBBox);
    Object.keys(T).forEach(function(j) {
      T[j] = l(w, T[j], U, j.replace("Map", ""), r);
    });
    var D = T["".concat(P, "Map")], Q = XSe(D), Y = f(w, Fe(Fe({}, T), {}, {
      dataStartIndex: B,
      dataEndIndex: y,
      updateId: b,
      graphicalItems: H,
      stackGroups: F,
      offset: U
    }));
    return Fe(Fe({
      formattedGraphicalItems: Y,
      graphicalItems: H,
      offset: U,
      stackGroups: F
    }, Q), T);
  }, g = /* @__PURE__ */ function(p) {
    function v(C) {
      var w, B, y;
      return kSe(this, v), y = TSe(this, v, [C]), Lt(y, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Lt(y, "accessibilityManager", new gSe()), Lt(y, "handleLegendBBoxUpdate", function(b) {
        if (b) {
          var q = y.state, E = q.dataStartIndex, x = q.dataEndIndex, M = q.updateId;
          y.setState(Fe({
            legendBBox: b
          }, d({
            props: y.props,
            dataStartIndex: E,
            dataEndIndex: x,
            updateId: M
          }, Fe(Fe({}, y.state), {}, {
            legendBBox: b
          }))));
        }
      }), Lt(y, "handleReceiveSyncEvent", function(b, q, E) {
        if (y.props.syncId === b) {
          if (E === y.eventEmitterSymbol && typeof y.props.syncMethod != "function")
            return;
          y.applySyncEvent(q);
        }
      }), Lt(y, "handleBrushChange", function(b) {
        var q = b.startIndex, E = b.endIndex;
        if (q !== y.state.dataStartIndex || E !== y.state.dataEndIndex) {
          var x = y.state.updateId;
          y.setState(function() {
            return Fe({
              dataStartIndex: q,
              dataEndIndex: E
            }, d({
              props: y.props,
              dataStartIndex: q,
              dataEndIndex: E,
              updateId: x
            }, y.state));
          }), y.triggerSyncEvent({
            dataStartIndex: q,
            dataEndIndex: E
          });
        }
      }), Lt(y, "handleMouseEnter", function(b) {
        var q = y.getMouseInfo(b);
        if (q) {
          var E = Fe(Fe({}, q), {}, {
            isTooltipActive: !0
          });
          y.setState(E), y.triggerSyncEvent(E);
          var x = y.props.onMouseEnter;
          nr(x) && x(E, b);
        }
      }), Lt(y, "triggeredAfterMouseMove", function(b) {
        var q = y.getMouseInfo(b), E = q ? Fe(Fe({}, q), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        y.setState(E), y.triggerSyncEvent(E);
        var x = y.props.onMouseMove;
        nr(x) && x(E, b);
      }), Lt(y, "handleItemMouseEnter", function(b) {
        y.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: b,
            activePayload: b.tooltipPayload,
            activeCoordinate: b.tooltipPosition || {
              x: b.cx,
              y: b.cy
            }
          };
        });
      }), Lt(y, "handleItemMouseLeave", function() {
        y.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Lt(y, "handleMouseMove", function(b) {
        b.persist(), y.throttleTriggeredAfterMouseMove(b);
      }), Lt(y, "handleMouseLeave", function(b) {
        y.throttleTriggeredAfterMouseMove.cancel();
        var q = {
          isTooltipActive: !1
        };
        y.setState(q), y.triggerSyncEvent(q);
        var E = y.props.onMouseLeave;
        nr(E) && E(q, b);
      }), Lt(y, "handleOuterEvent", function(b) {
        var q = Z2e(b), E = Ri(y.props, "".concat(q));
        if (q && nr(E)) {
          var x, M;
          /.*touch.*/i.test(q) ? M = y.getMouseInfo(b.changedTouches[0]) : M = y.getMouseInfo(b), E((x = M) !== null && x !== void 0 ? x : {}, b);
        }
      }), Lt(y, "handleClick", function(b) {
        var q = y.getMouseInfo(b);
        if (q) {
          var E = Fe(Fe({}, q), {}, {
            isTooltipActive: !0
          });
          y.setState(E), y.triggerSyncEvent(E);
          var x = y.props.onClick;
          nr(x) && x(E, b);
        }
      }), Lt(y, "handleMouseDown", function(b) {
        var q = y.props.onMouseDown;
        if (nr(q)) {
          var E = y.getMouseInfo(b);
          q(E, b);
        }
      }), Lt(y, "handleMouseUp", function(b) {
        var q = y.props.onMouseUp;
        if (nr(q)) {
          var E = y.getMouseInfo(b);
          q(E, b);
        }
      }), Lt(y, "handleTouchMove", function(b) {
        b.changedTouches != null && b.changedTouches.length > 0 && y.throttleTriggeredAfterMouseMove(b.changedTouches[0]);
      }), Lt(y, "handleTouchStart", function(b) {
        b.changedTouches != null && b.changedTouches.length > 0 && y.handleMouseDown(b.changedTouches[0]);
      }), Lt(y, "handleTouchEnd", function(b) {
        b.changedTouches != null && b.changedTouches.length > 0 && y.handleMouseUp(b.changedTouches[0]);
      }), Lt(y, "handleDoubleClick", function(b) {
        var q = y.props.onDoubleClick;
        if (nr(q)) {
          var E = y.getMouseInfo(b);
          q(E, b);
        }
      }), Lt(y, "handleContextMenu", function(b) {
        var q = y.props.onContextMenu;
        if (nr(q)) {
          var E = y.getMouseInfo(b);
          q(E, b);
        }
      }), Lt(y, "triggerSyncEvent", function(b) {
        y.props.syncId !== void 0 && z6.emit(Y6, y.props.syncId, b, y.eventEmitterSymbol);
      }), Lt(y, "applySyncEvent", function(b) {
        var q = y.props, E = q.layout, x = q.syncMethod, M = y.state.updateId, O = b.dataStartIndex, I = b.dataEndIndex;
        if (b.dataStartIndex !== void 0 || b.dataEndIndex !== void 0)
          y.setState(Fe({
            dataStartIndex: O,
            dataEndIndex: I
          }, d({
            props: y.props,
            dataStartIndex: O,
            dataEndIndex: I,
            updateId: M
          }, y.state)));
        else if (b.activeTooltipIndex !== void 0) {
          var S = b.chartX, P = b.chartY, H = b.activeTooltipIndex, F = y.state, T = F.offset, U = F.tooltipTicks;
          if (!T)
            return;
          if (typeof x == "function")
            H = x(U, b);
          else if (x === "value") {
            H = -1;
            for (var D = 0; D < U.length; D++)
              if (U[D].value === b.activeLabel) {
                H = D;
                break;
              }
          }
          var Q = Fe(Fe({}, T), {}, {
            x: T.left,
            y: T.top
          }), Y = Math.min(S, Q.x + Q.width), j = Math.min(P, Q.y + Q.height), Z = U[H] && U[H].value, W = nm(y.state, y.props.data, H), R = U[H] ? {
            x: E === "horizontal" ? U[H].coordinate : Y,
            y: E === "horizontal" ? j : U[H].coordinate
          } : PN;
          y.setState(Fe(Fe({}, b), {}, {
            activeLabel: Z,
            activeCoordinate: R,
            activePayload: W,
            activeTooltipIndex: H
          }));
        } else
          y.setState(b);
      }), Lt(y, "renderCursor", function(b) {
        var q, E = y.state, x = E.isTooltipActive, M = E.activeCoordinate, O = E.activePayload, I = E.offset, S = E.activeTooltipIndex, P = E.tooltipAxisBandSize, H = y.getTooltipEventType(), F = (q = b.props.active) !== null && q !== void 0 ? q : x, T = y.props.layout, U = b.key || "_recharts-cursor";
        return /* @__PURE__ */ re.createElement(bSe, {
          key: U,
          activeCoordinate: M,
          activePayload: O,
          activeTooltipIndex: S,
          chartName: r,
          element: b,
          isActive: F,
          layout: T,
          offset: I,
          tooltipAxisBandSize: P,
          tooltipEventType: H
        });
      }), Lt(y, "renderPolarAxis", function(b, q, E) {
        var x = Ri(b, "type.axisType"), M = Ri(y.state, "".concat(x, "Map")), O = b.type.defaultProps, I = O !== void 0 ? Fe(Fe({}, O), b.props) : b.props, S = M && M[I["".concat(x, "Id")]];
        return /* @__PURE__ */ vn(b, Fe(Fe({}, S), {}, {
          className: Br(x, S.className),
          key: b.key || "".concat(q, "-").concat(E),
          ticks: vs(S, !0)
        }));
      }), Lt(y, "renderPolarGrid", function(b) {
        var q = b.props, E = q.radialLines, x = q.polarAngles, M = q.polarRadius, O = y.state, I = O.radiusAxisMap, S = O.angleAxisMap, P = ga(I), H = ga(S), F = H.cx, T = H.cy, U = H.innerRadius, D = H.outerRadius;
        return /* @__PURE__ */ vn(b, {
          polarAngles: Array.isArray(x) ? x : vs(H, !0).map(function(Q) {
            return Q.coordinate;
          }),
          polarRadius: Array.isArray(M) ? M : vs(P, !0).map(function(Q) {
            return Q.coordinate;
          }),
          cx: F,
          cy: T,
          innerRadius: U,
          outerRadius: D,
          key: b.key || "polar-grid",
          radialLines: E
        });
      }), Lt(y, "renderLegend", function() {
        var b = y.state.formattedGraphicalItems, q = y.props, E = q.children, x = q.width, M = q.height, O = y.props.margin || {}, I = x - (O.left || 0) - (O.right || 0), S = vU({
          children: E,
          formattedGraphicalItems: b,
          legendWidth: I,
          legendContent: c
        });
        if (!S)
          return null;
        var P = S.item, H = eP(S, BSe);
        return /* @__PURE__ */ vn(P, Fe(Fe({}, H), {}, {
          chartWidth: x,
          chartHeight: M,
          margin: O,
          onBBoxUpdate: y.handleLegendBBoxUpdate
        }));
      }), Lt(y, "renderTooltip", function() {
        var b, q = y.props, E = q.children, x = q.accessibilityLayer, M = mi(E, Ti);
        if (!M)
          return null;
        var O = y.state, I = O.isTooltipActive, S = O.activeCoordinate, P = O.activePayload, H = O.activeLabel, F = O.offset, T = (b = M.props.active) !== null && b !== void 0 ? b : I;
        return /* @__PURE__ */ vn(M, {
          viewBox: Fe(Fe({}, F), {}, {
            x: F.left,
            y: F.top
          }),
          active: T,
          label: H,
          payload: T ? P : [],
          coordinate: S,
          accessibilityLayer: x
        });
      }), Lt(y, "renderBrush", function(b) {
        var q = y.props, E = q.margin, x = q.data, M = y.state, O = M.offset, I = M.dataStartIndex, S = M.dataEndIndex, P = M.updateId;
        return /* @__PURE__ */ vn(b, {
          key: b.key || "_recharts-brush",
          onChange: _f(y.handleBrushChange, b.props.onChange),
          data: x,
          x: At(b.props.x) ? b.props.x : O.left,
          y: At(b.props.y) ? b.props.y : O.top + O.height + O.brushBottom - (E.bottom || 0),
          width: At(b.props.width) ? b.props.width : O.width,
          startIndex: I,
          endIndex: S,
          updateId: "brush-".concat(P)
        });
      }), Lt(y, "renderReferenceElement", function(b, q, E) {
        if (!b)
          return null;
        var x = y, M = x.clipPathId, O = y.state, I = O.xAxisMap, S = O.yAxisMap, P = O.offset, H = b.type.defaultProps || {}, F = b.props, T = F.xAxisId, U = T === void 0 ? H.xAxisId : T, D = F.yAxisId, Q = D === void 0 ? H.yAxisId : D;
        return /* @__PURE__ */ vn(b, {
          key: b.key || "".concat(q, "-").concat(E),
          xAxis: I[U],
          yAxis: S[Q],
          viewBox: {
            x: P.left,
            y: P.top,
            width: P.width,
            height: P.height
          },
          clipPathId: M
        });
      }), Lt(y, "renderActivePoints", function(b) {
        var q = b.item, E = b.activePoint, x = b.basePoint, M = b.childIndex, O = b.isRange, I = [], S = q.props.key, P = q.item.type.defaultProps !== void 0 ? Fe(Fe({}, q.item.type.defaultProps), q.item.props) : q.item.props, H = P.activeDot, F = P.dataKey, T = Fe(Fe({
          index: M,
          dataKey: F,
          cx: E.x,
          cy: E.y,
          r: 4,
          fill: _q(q.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: E.payload,
          value: E.value
        }, cr(H, !1)), z3(H));
        return I.push(v.renderActiveDot(H, T, "".concat(S, "-activePoint-").concat(M))), x ? I.push(v.renderActiveDot(H, Fe(Fe({}, T), {}, {
          cx: x.x,
          cy: x.y
        }), "".concat(S, "-basePoint-").concat(M))) : O && I.push(null), I;
      }), Lt(y, "renderGraphicChild", function(b, q, E) {
        var x = y.filterFormatItem(b, q, E);
        if (!x)
          return null;
        var M = y.getTooltipEventType(), O = y.state, I = O.isTooltipActive, S = O.tooltipAxis, P = O.activeTooltipIndex, H = O.activeLabel, F = y.props.children, T = mi(F, Ti), U = x.props, D = U.points, Q = U.isRange, Y = U.baseLine, j = x.item.type.defaultProps !== void 0 ? Fe(Fe({}, x.item.type.defaultProps), x.item.props) : x.item.props, Z = j.activeDot, W = j.hide, R = j.activeBar, K = j.activeShape, L = !!(!W && I && T && (Z || R || K)), G = {};
        M !== "axis" && T && T.props.trigger === "click" ? G = {
          onClick: _f(y.handleItemMouseEnter, b.props.onClick)
        } : M !== "axis" && (G = {
          onMouseLeave: _f(y.handleItemMouseLeave, b.props.onMouseLeave),
          onMouseEnter: _f(y.handleItemMouseEnter, b.props.onMouseEnter)
        });
        var V = /* @__PURE__ */ vn(b, Fe(Fe({}, x.props), G));
        function _(ge) {
          return typeof S.dataKey == "function" ? S.dataKey(ge.payload) : null;
        }
        if (L)
          if (P >= 0) {
            var J, X;
            if (S.dataKey && !S.allowDuplicatedCategory) {
              var ne = typeof S.dataKey == "function" ? _ : "payload.".concat(S.dataKey.toString());
              J = R3(D, ne, H), X = Q && Y && R3(Y, ne, H);
            } else
              J = D == null ? void 0 : D[P], X = Q && Y && Y[P];
            if (K || R) {
              var ee = b.props.activeIndex !== void 0 ? b.props.activeIndex : P;
              return [/* @__PURE__ */ vn(b, Fe(Fe(Fe({}, x.props), G), {}, {
                activeIndex: ee
              })), null, null];
            }
            if (!hr(J))
              return [V].concat(fd(y.renderActivePoints({
                item: x,
                activePoint: J,
                basePoint: X,
                childIndex: P,
                isRange: Q
              })));
          } else {
            var $, te = ($ = y.getItemByXY(y.state.activeCoordinate)) !== null && $ !== void 0 ? $ : {
              graphicalItem: V
            }, ae = te.graphicalItem, se = ae.item, ue = se === void 0 ? b : se, fe = ae.childIndex, ve = Fe(Fe(Fe({}, x.props), G), {}, {
              activeIndex: fe
            });
            return [/* @__PURE__ */ vn(ue, ve), null, null];
          }
        return Q ? [V, null, null] : [V, null];
      }), Lt(y, "renderCustomized", function(b, q, E) {
        return /* @__PURE__ */ vn(b, Fe(Fe({
          key: "recharts-customized-".concat(E)
        }, y.props), y.state));
      }), Lt(y, "renderMap", {
        CartesianGrid: {
          handler: nh,
          once: !0
        },
        ReferenceArea: {
          handler: y.renderReferenceElement
        },
        ReferenceLine: {
          handler: nh
        },
        ReferenceDot: {
          handler: y.renderReferenceElement
        },
        XAxis: {
          handler: nh
        },
        YAxis: {
          handler: nh
        },
        Brush: {
          handler: y.renderBrush,
          once: !0
        },
        Bar: {
          handler: y.renderGraphicChild
        },
        Line: {
          handler: y.renderGraphicChild
        },
        Area: {
          handler: y.renderGraphicChild
        },
        Radar: {
          handler: y.renderGraphicChild
        },
        RadialBar: {
          handler: y.renderGraphicChild
        },
        Scatter: {
          handler: y.renderGraphicChild
        },
        Pie: {
          handler: y.renderGraphicChild
        },
        Funnel: {
          handler: y.renderGraphicChild
        },
        Tooltip: {
          handler: y.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: y.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: y.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: y.renderPolarAxis
        },
        Customized: {
          handler: y.renderCustomized
        }
      }), y.clipPathId = "".concat((w = C.id) !== null && w !== void 0 ? w : Ld("recharts"), "-clip"), y.throttleTriggeredAfterMouseMove = mQ(y.triggeredAfterMouseMove, (B = C.throttleDelay) !== null && B !== void 0 ? B : 1e3 / 60), y.state = {}, y;
    }
    return DSe(v, p), FSe(v, [{
      key: "componentDidMount",
      value: function() {
        var w, B;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (B = this.props.margin.top) !== null && B !== void 0 ? B : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, B = w.children, y = w.data, b = w.height, q = w.layout, E = mi(B, Ti);
        if (E) {
          var x = E.props.defaultIndex;
          if (!(typeof x != "number" || x < 0 || x > this.state.tooltipTicks.length - 1)) {
            var M = this.state.tooltipTicks[x] && this.state.tooltipTicks[x].value, O = nm(this.state, y, x, M), I = this.state.tooltipTicks[x].coordinate, S = (this.state.offset.top + b) / 2, P = q === "horizontal", H = P ? {
              x: I,
              y: S
            } : {
              y: I,
              x: S
            }, F = this.state.formattedGraphicalItems.find(function(U) {
              var D = U.item;
              return D.type.name === "Scatter";
            });
            F && (H = Fe(Fe({}, H), F.props.points[x].tooltipPosition), O = F.props.points[x].tooltipPayload);
            var T = {
              activeTooltipIndex: x,
              isTooltipActive: !0,
              activeLabel: M,
              activePayload: O,
              activeCoordinate: H
            };
            this.setState(T), this.renderCursor(E), this.accessibilityManager.setIndex(x);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, B) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== B.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var y, b;
          this.accessibilityManager.setDetails({
            offset: {
              left: (y = this.props.margin.left) !== null && y !== void 0 ? y : 0,
              top: (b = this.props.margin.top) !== null && b !== void 0 ? b : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        H7([mi(w.children, Ti)], [mi(this.props.children, Ti)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = mi(this.props.children, Ti);
        if (w && typeof w.props.shared == "boolean") {
          var B = w.props.shared ? "axis" : "item";
          return s.indexOf(B) >= 0 ? B : i;
        }
        return i;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var B = this.container, y = B.getBoundingClientRect(), b = B7e(y), q = {
          chartX: Math.round(w.pageX - b.left),
          chartY: Math.round(w.pageY - b.top)
        }, E = y.width / B.offsetWidth || 1, x = this.inRange(q.chartX, q.chartY, E);
        if (!x)
          return null;
        var M = this.state, O = M.xAxisMap, I = M.yAxisMap, S = this.getTooltipEventType();
        if (S !== "axis" && O && I) {
          var P = ga(O).scale, H = ga(I).scale, F = P && P.invert ? P.invert(q.chartX) : null, T = H && H.invert ? H.invert(q.chartY) : null;
          return Fe(Fe({}, q), {}, {
            xValue: F,
            yValue: T
          });
        }
        var U = rP(this.state, this.props.data, this.props.layout, x);
        return U ? Fe(Fe({}, q), U) : null;
      }
    }, {
      key: "inRange",
      value: function(w, B) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, b = this.props.layout, q = w / y, E = B / y;
        if (b === "horizontal" || b === "vertical") {
          var x = this.state.offset, M = q >= x.left && q <= x.left + x.width && E >= x.top && E <= x.top + x.height;
          return M ? {
            x: q,
            y: E
          } : null;
        }
        var O = this.state, I = O.angleAxisMap, S = O.radiusAxisMap;
        if (I && S) {
          var P = ga(I);
          return DI({
            x: q,
            y: E
          }, P);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, B = this.getTooltipEventType(), y = mi(w, Ti), b = {};
        y && B === "axis" && (y.props.trigger === "click" ? b = {
          onClick: this.handleClick
        } : b = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var q = z3(this.props, this.handleOuterEvent);
        return Fe(Fe({}, q), b);
      }
    }, {
      key: "addListener",
      value: function() {
        z6.on(Y6, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        z6.removeListener(Y6, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, B, y) {
        for (var b = this.state.formattedGraphicalItems, q = 0, E = b.length; q < E; q++) {
          var x = b[q];
          if (x.item === w || x.props.key === w.key || B === Bs(x.item.type) && y === x.childIndex)
            return x;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, B = this.state.offset, y = B.left, b = B.top, q = B.height, E = B.width;
        return /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ re.createElement("rect", {
          x: y,
          y: b,
          height: q,
          width: E
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(B, y) {
          var b = $S(y, 2), q = b[0], E = b[1];
          return Fe(Fe({}, B), {}, Lt({}, q, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(B, y) {
          var b = $S(y, 2), q = b[0], E = b[1];
          return Fe(Fe({}, B), {}, Lt({}, q, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var B;
        return (B = this.state.xAxisMap) === null || B === void 0 || (B = B[w]) === null || B === void 0 ? void 0 : B.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var B;
        return (B = this.state.yAxisMap) === null || B === void 0 || (B = B[w]) === null || B === void 0 ? void 0 : B.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var B = this.state, y = B.formattedGraphicalItems, b = B.activeItem;
        if (y && y.length)
          for (var q = 0, E = y.length; q < E; q++) {
            var x = y[q], M = x.props, O = x.item, I = O.type.defaultProps !== void 0 ? Fe(Fe({}, O.type.defaultProps), O.props) : O.props, S = Bs(O.type);
            if (S === "Bar") {
              var P = (M.data || []).find(function(U) {
                return rbe(w, U);
              });
              if (P)
                return {
                  graphicalItem: x,
                  payload: P
                };
            } else if (S === "RadialBar") {
              var H = (M.data || []).find(function(U) {
                return DI(w, U);
              });
              if (H)
                return {
                  graphicalItem: x,
                  payload: H
                };
            } else if (W4(x, b) || X4(x, b) || A1(x, b)) {
              var F = iBe({
                graphicalItem: x,
                activeTooltipItem: b,
                itemData: I.data
              }), T = I.activeIndex === void 0 ? F : I.activeIndex;
              return {
                graphicalItem: Fe(Fe({}, x), {}, {
                  childIndex: T
                }),
                payload: A1(x, b) ? I.data[F] : x.props.data[F]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!IE(this))
          return null;
        var B = this.props, y = B.children, b = B.className, q = B.width, E = B.height, x = B.style, M = B.compact, O = B.title, I = B.desc, S = eP(B, ESe), P = cr(S, !1);
        if (M)
          return /* @__PURE__ */ re.createElement(TS, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ re.createElement(Q7, Jl({}, P, {
            width: q,
            height: E,
            title: O,
            desc: I
          }), this.renderClipPath(), PE(y, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var H, F;
          P.tabIndex = (H = this.props.tabIndex) !== null && H !== void 0 ? H : 0, P.role = (F = this.props.role) !== null && F !== void 0 ? F : "application", P.onKeyDown = function(U) {
            w.accessibilityManager.keyboardEvent(U);
          }, P.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var T = this.parseEventsOfWrapper();
        return /* @__PURE__ */ re.createElement(TS, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ re.createElement("div", Jl({
          className: Br("recharts-wrapper", b),
          style: Fe({
            position: "relative",
            cursor: "default",
            width: q,
            height: E
          }, x)
        }, T, {
          ref: function(D) {
            w.container = D;
          }
        }), /* @__PURE__ */ re.createElement(Q7, Jl({}, P, {
          width: q,
          height: E,
          title: O,
          desc: I,
          style: GSe
        }), this.renderClipPath(), PE(y, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }($p);
  Lt(g, "displayName", r), Lt(g, "defaultProps", Fe({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, u)), Lt(g, "getDerivedStateFromProps", function(p, v) {
    var C = p.dataKey, w = p.data, B = p.children, y = p.width, b = p.height, q = p.layout, E = p.stackOffset, x = p.margin, M = v.dataStartIndex, O = v.dataEndIndex;
    if (v.updateId === void 0) {
      var I = nP(p);
      return Fe(Fe(Fe({}, I), {}, {
        updateId: 0
      }, d(Fe(Fe({
        props: p
      }, I), {}, {
        updateId: 0
      }), v)), {}, {
        prevDataKey: C,
        prevData: w,
        prevWidth: y,
        prevHeight: b,
        prevLayout: q,
        prevStackOffset: E,
        prevMargin: x,
        prevChildren: B
      });
    }
    if (C !== v.prevDataKey || w !== v.prevData || y !== v.prevWidth || b !== v.prevHeight || q !== v.prevLayout || E !== v.prevStackOffset || !au(x, v.prevMargin)) {
      var S = nP(p), P = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: v.chartX,
        chartY: v.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: v.isTooltipActive
      }, H = Fe(Fe({}, rP(v, w, q)), {}, {
        updateId: v.updateId + 1
      }), F = Fe(Fe(Fe({}, S), P), H);
      return Fe(Fe(Fe({}, F), d(Fe({
        props: p
      }, F), v)), {}, {
        prevDataKey: C,
        prevData: w,
        prevWidth: y,
        prevHeight: b,
        prevLayout: q,
        prevStackOffset: E,
        prevMargin: x,
        prevChildren: B
      });
    }
    if (!H7(B, v.prevChildren)) {
      var T, U, D, Q, Y = mi(B, ed), j = Y && (T = (U = Y.props) === null || U === void 0 ? void 0 : U.startIndex) !== null && T !== void 0 ? T : M, Z = Y && (D = (Q = Y.props) === null || Q === void 0 ? void 0 : Q.endIndex) !== null && D !== void 0 ? D : O, W = j !== M || Z !== O, R = !hr(w), K = R && !W ? v.updateId : v.updateId + 1;
      return Fe(Fe({
        updateId: K
      }, d(Fe(Fe({
        props: p
      }, v), {}, {
        updateId: K,
        dataStartIndex: j,
        dataEndIndex: Z
      }), v)), {}, {
        prevChildren: B,
        dataStartIndex: j,
        dataEndIndex: Z
      });
    }
    return null;
  }), Lt(g, "renderActiveDot", function(p, v, C) {
    var w;
    return /* @__PURE__ */ QA(p) ? w = /* @__PURE__ */ vn(p, v) : nr(p) ? w = p(v) : w = /* @__PURE__ */ re.createElement(V4, v), /* @__PURE__ */ re.createElement(_r, {
      className: "recharts-active-dot",
      key: C
    }, w);
  });
  var m = /* @__PURE__ */ ol(function(v, C) {
    return /* @__PURE__ */ re.createElement(g, Jl({}, v, {
      ref: C
    }));
  });
  return m.displayName = g.displayName, m;
}, _Se = ly({
  chartName: "LineChart",
  GraphicalChild: ad,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: oc
  }, {
    axisType: "yAxis",
    AxisComp: sc
  }],
  formatAxisMap: ey
}), $Se = ly({
  chartName: "BarChart",
  GraphicalChild: gl,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: oc
  }, {
    axisType: "yAxis",
    AxisComp: sc
  }],
  formatAxisMap: ey
}), ePe = ly({
  chartName: "AreaChart",
  GraphicalChild: ic,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: oc
  }, {
    axisType: "yAxis",
    AxisComp: sc
  }],
  formatAxisMap: ey
});
let tPe = [
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#008000"
];
function rPe(t) {
  const { data: e, type: r, textColor: n, gridLine: A } = t, i = ({ active: o, payload: s, label: a }) => o && s && s.length ? r == "Metric" ? /* @__PURE__ */ h("div", { className: "custom-tooltip", style: { color: n }, children: !!s[0].payload && Object.keys(s[0].payload).map((c, l) => /* @__PURE__ */ h(
    "div",
    {
      className: "label",
      style: {
        fontSize: "10px",
        padding: 0,
        margin: 0,
        boxSizing: "content-box"
      },
      children: `${c} : ${s[0].payload[c]}`
    },
    l
  )) }) : /* @__PURE__ */ h("div", { className: "custom-tooltip", style: { color: n }, children: /* @__PURE__ */ h("div", { style: { display: "inline" }, children: `${r} : ${s[0].value}` }) }) : null;
  return /* @__PURE__ */ h(Iq, { width: "100%", height: 210, children: /* @__PURE__ */ k(_Se, { data: e, margin: { right: 20, top: 20 }, children: [
    /* @__PURE__ */ h(
      oc,
      {
        dataKey: "date",
        interval: 0,
        domain: [0, (o) => o + 5],
        style: { fontSize: "10px" }
      }
    ),
    /* @__PURE__ */ h(
      sc,
      {
        tickCount: 5,
        interval: 0,
        domain: [0, (o) => o + 5],
        style: { fontSize: "10px" }
      }
    ),
    r == "Metric" && e.length ? Object.keys(e[0]).map(
      (o, s) => o != "date" && /* @__PURE__ */ h(
        ad,
        {
          type: "monotone",
          dataKey: o,
          stroke: tPe[s],
          dot: !1
        },
        s
      )
    ) : /* @__PURE__ */ h(
      ad,
      {
        type: "monotone",
        dataKey: "count",
        stroke: "#8884d8",
        dot: !1
      }
    ),
    (!A || A == !1) && /* @__PURE__ */ h(e9, { strokeDasharray: "3 3" }),
    /* @__PURE__ */ h(Ti, { content: /* @__PURE__ */ h(i, {}) })
  ] }) });
}
function nPe(t) {
  var s, a;
  const { data: e, type: r, lineColor: n, textColor: A, gridLine: i } = t, o = ({ active: c, payload: l, label: u }) => {
    var f;
    return c && l && l.length ? /* @__PURE__ */ k("div", { className: "custom-tooltip", style: { color: A }, children: [
      !!((f = e[0]) != null && f.metric) && /* @__PURE__ */ k("div", { children: [
        "Metric: ",
        l[0].payload.metric
      ] }),
      /* @__PURE__ */ h("div", { style: { display: "inline" }, className: "label", children: `${r} : ${l[0].value}` })
    ] }) : null;
  };
  return /* @__PURE__ */ h(Iq, { width: "100%", height: 210, children: /* @__PURE__ */ k(ePe, { data: e, margin: { right: 20, top: 20, left: -30, bottom: 10 }, children: [
    /* @__PURE__ */ h(
      oc,
      {
        dataKey: (s = e[0]) != null && s.metric ? "" : "date",
        interval: 0,
        domain: [0, (c) => c >= 50 ? c : 50],
        style: { fontSize: "12px" },
        angle: (a = e[0]) != null && a.metric ? 0 : -45,
        textAnchor: "end"
      }
    ),
    /* @__PURE__ */ h(
      sc,
      {
        tickCount: 5,
        interval: 0,
        domain: [0, (c) => c >= 50 ? c : 50],
        style: { fontSize: "12px" }
      }
    ),
    /* @__PURE__ */ h(
      ic,
      {
        type: "monotone",
        dataKey: "count",
        stroke: n || "#8884d8",
        fill: n || "#8884d8",
        dot: !0
      }
    ),
    (!i || i == !1) && /* @__PURE__ */ h(e9, { strokeDasharray: "3 3" }),
    /* @__PURE__ */ h(Ti, { content: /* @__PURE__ */ h(o, {}) })
  ] }) });
}
function APe(t) {
  var s, a;
  const { data: e, type: r, lineColor: n, textColor: A, gridLine: i } = t, o = ({ active: c, payload: l, label: u }) => {
    var f;
    return c && l && l.length ? /* @__PURE__ */ k("div", { className: "custom-tooltip", style: { color: A }, children: [
      !!((f = e[0]) != null && f.metric) && /* @__PURE__ */ k("div", { children: [
        "Metric: ",
        l[0].payload.metric
      ] }),
      /* @__PURE__ */ h("div", { style: { display: "inline" }, className: "label", children: `${r} : ${l[0].value}` })
    ] }) : null;
  };
  return /* @__PURE__ */ h(Iq, { width: "100%", height: 210, children: /* @__PURE__ */ k($Se, { data: e, margin: { right: 20, top: 20, left: -30, bottom: 10 }, children: [
    /* @__PURE__ */ h(
      oc,
      {
        dataKey: (s = e[0]) != null && s.metric ? "" : "date",
        interval: 0,
        domain: [0, (c) => c >= 50 ? c : 50],
        style: { fontSize: "12px" },
        angle: (a = e[0]) != null && a.metric ? 0 : -45,
        textAnchor: "end"
      }
    ),
    /* @__PURE__ */ h(
      sc,
      {
        tickCount: 5,
        interval: 0,
        domain: [0, (c) => c >= 50 ? c : 50],
        style: { fontSize: "12px" }
      }
    ),
    (!i || i == !1) && /* @__PURE__ */ h(e9, { strokeDasharray: "3 3" }),
    /* @__PURE__ */ h(gl, { dataKey: "count", fill: n || "#8884d8" }),
    /* @__PURE__ */ h(Ti, { content: /* @__PURE__ */ h(o, {}) })
  ] }) });
}
const bFe = ({
  userId: t,
  token: e,
  questId: r,
  headingText: n,
  headingTextColor: A,
  chartType: i,
  dataType: o,
  boxWidth: s,
  bgColor: a,
  disabledGrid: c,
  metricIds: l
}) => {
  const [u, f] = N([]), [d, g] = N([]), [m, p] = N([]), [v, C] = N({}), [w, B] = N([]), [y, b] = N(3), { apiKey: q, apiSecret: E, entityId: x } = Xe(ct.Context);
  async function M() {
    let S = {
      "onboarding-view": "Onboarding Started",
      "onboarding-complete-page-1": "Onboarding 1st Step",
      "onboarding-complete-page-2": "Onboarding 2nd Step",
      "onboarding-complete-page-3": "Onboarding 3rd Step",
      "onboarding-complete-page-4": "Onboarding 4th Step",
      "onboarding-complete-page-5": "Onboarding 5th Step",
      "onboarding-complete-page-6": "Onboarding 6th Step",
      "onboarding-complete-page-7": "Onboarding 7th Step",
      "onboarding-complete-page-8": "Onboarding 8th Step",
      "onboarding-complete-page-9": "Onboarding 9th Step",
      "onboarding-complete-page-10": "Onboarding 10th Step",
      "onboarding-complete": "Onboarding Completed",
      "feedback-q-request-a-feature": "Feature Request Form Viewed",
      "feedback-q-request-a-feature-com": "Feature Request Form Submitted",
      "feedback-q-report-a-bug": "Bug Report Form Viewed",
      "feedback-q-report-a-bug-com": "Bug Report Form Submitted",
      "feedback-q-general-feedback": "General Feedback Form Viewed",
      "feedback-q-general-feedback-com": "General Feedback Form Submitted",
      "feedback-q-contact-us": "Contact Us Form Viewed",
      "feedback-q-contact-us-com": "Contact Us Form Submitted"
    };
    const P = {
      apiKey: q,
      apisecret: E,
      userId: t,
      token: e
    };
    o == "Metric" ? Oe(
      `${Ve.BACKEND_URL}api/entities/${x}/quests/${r}/metric-summary?userId=${t}`,
      { headers: P }
    ).then((H) => {
      let F = H.data.data, T = [];
      for (let j = 0; j < F.length; j++)
        l.includes(F[j].metric) && T.push(F[j]);
      const U = Q(), D = Y(U, l, T);
      p(D);
      function Q() {
        const j = /* @__PURE__ */ new Date(), Z = [], W = new Date(j);
        for (; Z.length <= 29; )
          Z.unshift(W.toISOString().split("T")[0]), W.setDate(W.getDate() - 1);
        return Z;
      }
      function Y(j = [], Z = [], W = []) {
        let R = [], K = [];
        for (let L = 0; L < Z.length; L++)
          K[S[Z[L]]] = 0;
        for (let L = 0; L < j.length; L++) {
          let G = {
            date: j[L].slice(5, 10),
            ...K
          };
          for (let V = 0; V < W.length; V++)
            W[V].date == j[L] && (G[W[V].metricDetails[0].name] = W[V].count);
          R.push(G);
        }
        return R;
      }
    }) : Oe(
      `${Ve.BACKEND_URL}api/entities/${x}/quests/${r}/summary?userId=${t}`,
      { headers: P }
    ).then((H) => {
      var F, T, U, D;
      if ((T = (F = H == null ? void 0 : H.data) == null ? void 0 : F.summary) != null && T.questStats) {
        let Q = function() {
          const K = /* @__PURE__ */ new Date(), L = [], G = new Date(K);
          for (; L.length <= 29; )
            L.unshift(
              G.toISOString().split("T")[0]
            ), G.setDate(G.getDate() - 1);
          return L;
        };
        const Y = [
          ...(D = (U = H == null ? void 0 : H.data) == null ? void 0 : U.summary) == null ? void 0 : D.questStats
        ].sort((K, L) => {
          const G = new Date(K.date), V = new Date(L.date);
          return G - V;
        });
        let j = Q(), Z = [];
        for (let K = 0; K < j.length; K++) {
          let L = !1;
          for (let G = 0; G < Y.length; G++)
            if (Y[G].date == j[K]) {
              Z.push(Y[G]), L = !0;
              break;
            }
          if (L == !1) {
            let G = {
              claimCount: 0,
              viewCount: 0,
              date: j[K]
            };
            Z.push(G);
          }
        }
        const W = [], R = [];
        for (const K of Z) {
          const L = {
            count: K.claimCount,
            date: K.date.slice(5, 10)
          };
          W.push(L);
          const G = {
            count: K.viewCount,
            date: K.date.slice(5, 10)
          };
          R.push(G);
        }
        f(W), g(R), C(H.data.summary.quest);
      }
    });
  }
  function O(S) {
    o == "Claim" ? I(u, S) : o == "View" ? I(d, S) : I(m, S);
  }
  function I(S, P) {
    let F = [...S].slice(
      30 - P,
      30
    );
    B(F);
  }
  return le(() => {
    O(y);
  }, [u, d, m, y]), le(() => {
    M();
  }, []), /* @__PURE__ */ k(
    "div",
    {
      className: "q-ana-home q-ana-ch-main",
      style: {
        width: s || "100%",
        backgroundColor: a
      },
      children: [
        /* @__PURE__ */ k("div", { className: "q-ana-tab-div", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q-ana-ch-p",
              style: { color: A || "" },
              children: n || `${i ? i.split("chart")[0] : "Line"} Chart of ${o == "Metric" ? "Metrics" : v.title}`
            }
          ),
          /* @__PURE__ */ k("select", { onChange: (S) => b(Number(S.target.value)), children: [
            /* @__PURE__ */ h("option", { value: "3", children: "3 days" }),
            /* @__PURE__ */ h("option", { value: "7", children: "7 days" }),
            /* @__PURE__ */ h("option", { value: "15", children: "15 days" }),
            /* @__PURE__ */ h("option", { value: "30", children: "30 days" })
          ] })
        ] }),
        i == "BarChart" ? /* @__PURE__ */ h(
          APe,
          {
            data: w,
            type: o,
            textColor: A,
            gridLine: c
          }
        ) : i == "AreaChart" ? /* @__PURE__ */ h(
          nPe,
          {
            data: w,
            type: o,
            textColor: A,
            gridLine: c
          }
        ) : /* @__PURE__ */ h(
          rPe,
          {
            data: w,
            type: o,
            textColor: A,
            gridLine: c
          }
        )
      ]
    }
  );
}, ON = UA({}), G1 = () => {
  const t = Xe(ON);
  if (!t)
    throw new Error("useGetStarted must be used within a GetStartedProvider");
  return t;
};
class iPe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    try {
      const s = this.cookies.get("externalUserId"), a = this.cookies.get("questUserId"), c = this.cookies.get("questUserToken");
      if (s && a && c && (s === n || s === A))
        return {
          userId: a,
          token: c
        };
      if (n) {
        const l = {
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }, u = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, f = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          u,
          { headers: l }
        ), { userId: d, token: g } = f.data, m = /* @__PURE__ */ new Date();
        return m.setHours(m.getHours() + 12), this.cookies.set("externalUserId", n, {
          path: "/",
          expires: m
        }), this.cookies.set("questUserId", d, { path: "/", expires: m }), this.cookies.set("questUserToken", g, { path: "/", expires: m }), {
          userId: d,
          token: g
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (s) {
      return this.GeneralFunctions.captureSentryException(s), null;
    }
  }
  async fetchCampaignData(e, r, n, A, i) {
    try {
      const o = new URLSearchParams();
      o.set("platform", "REACT"), i && o.set("variation", i);
      const s = {
        apiKey: n,
        userId: A.userId,
        token: A.token
      }, a = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${o.toString()}`, c = await Oe.get(a, { headers: s });
      if (!c.data.success)
        throw new Error(
          c.data.message || "Failed to fetch campaign data"
        );
      return c.data;
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
  async verifyAction(e, r, n, A, i, o) {
    try {
      const s = {
        apiKey: n,
        userId: A.userId,
        token: A.token
      }, a = {
        actions: [i],
        campaignVariationId: o
      }, c = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/verify`, l = await Oe.post(c, a, { headers: s });
      if (!l.data.success)
        throw Ir.error(l.data.error), new Error(l.data.error);
      return l.data;
    } catch (s) {
      throw this.GeneralFunctions.captureSentryException(s), s;
    }
  }
  async claimReward(e, r, n, A, i) {
    try {
      const o = {
        apiKey: n,
        userId: A.userId,
        token: A.token
      }, s = {
        userId: A.userId,
        campaignVariationId: i
      }, a = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/claim`, c = await Oe.post(a, s, { headers: o });
      if (c.data.success)
        return this.cookies.set("getStartedScreenComplete", !0, { path: "/" }), c.data;
      throw Ir.error(c.data.error), new Error(c.data.error);
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
}
let iP = class {
  constructor(e = {}, r = {}, n = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }, A = {
    accentColor: "",
    background: "",
    borderRadius: "",
    buttonColor: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = n, this.brandTheme = A;
  }
  getStyleValueAsString(e, r = "") {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "string" ? A : r;
  }
  getStyleValueAsObject(e, r) {
    const n = e.split(".");
    let A = this.styleConfig;
    for (const i of n)
      if (A && typeof A == "object")
        A = A[i];
      else
        return r;
    return typeof A == "object" ? A : r;
  }
  getFormStyles() {
    var n;
    const e = {
      background: this.getBackgroundColor(),
      fontFamily: this.getFontFamily(),
      borderRadius: this.getBorderRadius(),
      height: this.getStyleValueAsString("Form.height", "auto")
    }, r = ((n = this.styleConfig) == null ? void 0 : n.Form) || {};
    return { ...e, ...r };
  }
  getCardStyles(e = 1) {
    var A, i, o, s, a, c, l;
    const r = e === 2 ? "0px" : "16px", n = e === 2 ? "0px 20px 20px" : "20px";
    return {
      container: {
        padding: this.getStyleValueAsString(
          "CardContainer.padding",
          n
        ),
        gap: this.getStyleValueAsString("CardContainer.gap", r),
        ...((A = this.styleConfig) == null ? void 0 : A.CardContainer) || {}
      },
      card: ((i = this.styleConfig) == null ? void 0 : i.Card) || {},
      icon: { ...(o = this.styleConfig) == null ? void 0 : o.Icon, background: ((a = (s = this == null ? void 0 : this.styleConfig) == null ? void 0 : s.Icon) == null ? void 0 : a.background) || ((c = this == null ? void 0 : this.questThemeData) == null ? void 0 : c.accentColor), opacity: (l = this.questThemeData) != null && l.accentColor ? 0.7 : 1 }
    };
  }
  getHeadingStyles() {
    var e, r, n;
    return {
      color: this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.primaryColor) || ((r = this.themeConfig) == null ? void 0 : r.primaryColor) || "#000000",
      ...((n = this.styleConfig) == null ? void 0 : n.Heading) || {}
    };
  }
  getHeadingTitleStyles() {
    var e, r, n, A;
    return {
      color: this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.titleColor) || ((r = this.brandTheme) == null ? void 0 : r.primaryColor) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor),
      ...((A = this.styleConfig) == null ? void 0 : A.Heading) || {}
    };
  }
  getDescriptionStyles() {
    var e, r, n;
    return {
      color: this.getStyleValueAsString("Description.color") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666",
      ...((n = this.styleConfig) == null ? void 0 : n.Description) || {}
    };
  }
  getTopbarStyles() {
    return this.getStyleValueAsObject("Topbar", {});
  }
  getFooterStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      container: {
        background: this.getBackgroundColor(),
        ...((r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) || {}
      },
      text: ((A = (n = this.styleConfig) == null ? void 0 : n.Footer) == null ? void 0 : A.FooterText) || {},
      icon: ((o = (i = this.styleConfig) == null ? void 0 : i.Footer) == null ? void 0 : o.FooterIcon) || {},
      link: ((a = (s = this.styleConfig) == null ? void 0 : s.Footer) == null ? void 0 : a.FooterLink) || "https://www.plgos.com/"
    };
  }
  getProgressBarStyles() {
    var e, r, n, A;
    return {
      text: {
        color: this.getStyleValueAsString(
          "ProgressBar.ProgressText.color",
          ((e = this.questThemeData) == null ? void 0 : e.accentColor) || "#9035ff"
        ),
        ...(n = (r = this.styleConfig) == null ? void 0 : r.ProgressBar) == null ? void 0 : n.ProgressText
      },
      bar: {
        background: this.getStyleValueAsString(
          "ProgressBar.barParentColor",
          "#f0f0f0"
        ),
        fill: this.getStyleValueAsString("ProgressBar.barColor", ((A = this.questThemeData) == null ? void 0 : A.accentColor) || "#9035ff")
      }
    };
  }
  getButtonStyles() {
    var e, r, n, A, i, o;
    return {
      primary: {
        background: this.getStyleValueAsString("PrimaryButton.background") || ((e = this.questThemeData) == null ? void 0 : e.buttonColor) || ((r = this.questThemeData) == null ? void 0 : r.accentColor) || ((n = this.brandTheme) == null ? void 0 : n.buttonColor) || ((A = this.themeConfig) == null ? void 0 : A.buttonColor),
        ...((i = this.styleConfig) == null ? void 0 : i.PrimaryButton) || {}
      },
      secondary: ((o = this.styleConfig) == null ? void 0 : o.SecondaryButton) || {}
    };
  }
  getArrowStyles(e) {
    var n;
    const r = ((n = this.styleConfig) == null ? void 0 : n.Arrow) || {};
    return {
      background: e ? r.CompletedBackground || "" : r.Background || "",
      iconColor: e ? r.CompletedIconColor || "#098849" : r.IconColor || ""
    };
  }
  getBackgroundColor() {
    var e, r;
    return this.getStyleValueAsString("Form.backgroundColor") || this.getStyleValueAsString("Form.background") || ((e = this.brandTheme) == null ? void 0 : e.background) || ((r = this.themeConfig) == null ? void 0 : r.backgroundColor);
  }
  getFontFamily() {
    var e, r;
    return ((e = this.themeConfig) == null ? void 0 : e.fontFamily) || ((r = this.brandTheme) == null ? void 0 : r.fontFamily) || "Figtree";
  }
  getBorderRadius() {
    var e, r;
    return this.getStyleValueAsString("Form.borderRadius") || ((e = this.questThemeData) == null ? void 0 : e.borderRadius) || ((r = this.brandTheme) == null ? void 0 : r.borderRadius) || "8px";
  }
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    this.styleConfig = { ...this.styleConfig, ...e };
  }
  updateQuestTheme(e) {
    this.questThemeData = { ...this.questThemeData, ...e };
  }
  updateBrandTheme(e) {
    this.brandTheme = { ...this.brandTheme, ...e };
  }
};
const Am = ({ heading: t, subHeading: e, Headers: r }) => {
  var A, i;
  const { themeManager: n } = G1();
  return /* @__PURE__ */ h("div", { className: "gs-heading-div", style: n.getTopbarStyles(), children: /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ h("div", { style: n.getHeadingTitleStyles(), className: "gs-heading", children: Array.isArray(r) && ((A = r[0]) == null ? void 0 : A.heading) || t || "Quickstart Guide" }),
    /* @__PURE__ */ h("div", { style: n.getDescriptionStyles(), className: "gs-subheading", children: Array.isArray(r) && ((i = r[0]) == null ? void 0 : i.subHeading) || e || "Get started with Quest and explore how Quest can take your customer engagement to the next level" })
  ] }) });
}, FN = ({ isProgressNumber: t = !1 }) => {
  const { completedPercentage: e, themeManager: r, formdata: n } = G1();
  return /* @__PURE__ */ k("div", { className: "q_gt_progress", children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_progress_percentage",
        style: r.getProgressBarStyles().text,
        children: t ? e + "/" + n.length : Math.floor(e) + "% Completed"
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_gt_progress_bar",
        style: {
          background: r.getProgressBarStyles().bar.background
        },
        children: /* @__PURE__ */ h(
          "div",
          {
            className: "q_progress_bar_completed",
            style: {
              width: t ? `${e * 100 / n.length}%` : `${e}%`,
              background: r.getProgressBarStyles().bar.fill
            }
          }
        )
      }
    )
  ] });
}, S0 = ({ type: t, color: e = "#939393" }) => /* @__PURE__ */ h(Ze, { children: ((n, A) => {
  switch (n) {
    case "arrowRight":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.67461 2.95369C5.88428 2.77398 6.19993 2.79826 6.37964 3.00793L10.3796 7.67459C10.5401 7.86184 10.5401 8.13814 10.3796 8.32538L6.37964 12.9921C6.19993 13.2017 5.88428 13.226 5.67461 13.0463C5.46495 12.8666 5.44067 12.5509 5.62038 12.3413L9.34147 7.99999L5.62038 3.65872C5.44067 3.44905 5.46495 3.1334 5.67461 2.95369Z", fill: A || "#939393" }) });
    case "downArrowIcon":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.95369 5.6746C3.1334 5.46494 3.44905 5.44065 3.65872 5.62037L7.99999 9.34146L12.3413 5.62037C12.5509 5.44065 12.8666 5.46494 13.0463 5.6746C13.226 5.88426 13.2017 6.19991 12.9921 6.37962L8.32538 10.3796C8.13814 10.5401 7.86184 10.5401 7.67459 10.3796L3.00793 6.37962C2.79826 6.19991 2.77398 5.88426 2.95369 5.6746Z", fill: A || "#939393" }) });
    case "greenCheck":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { d: "M11.5303 5.46967C11.8232 5.76256 11.8232 6.23744 11.5303 6.53033L7.53033 10.5303C7.24166 10.819 6.77511 10.8238 6.4806 10.541L4.4806 8.62104C4.18179 8.33418 4.1721 7.85941 4.45896 7.5606C4.74582 7.26179 5.22059 7.2521 5.5194 7.53896L6.98929 8.95005L10.4697 5.46967C10.7626 5.17678 11.2374 5.17678 11.5303 5.46967Z", fill: A }) });
    case "upArrow":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.67459 5.62037C7.86184 5.45988 8.13814 5.45988 8.32538 5.62037L12.9921 9.62037C13.2017 9.80008 13.226 10.1157 13.0463 10.3254C12.8666 10.5351 12.5509 10.5593 12.3413 10.3796L7.99999 6.65854L3.65872 10.3796C3.44905 10.5593 3.1334 10.5351 2.95369 10.3254C2.77398 10.1157 2.79826 9.80008 3.00793 9.62037L7.67459 5.62037Z", fill: A || "#939393" }) });
    default:
      return null;
  }
})(t, e) }), oPe = ({ data: t, index: e, isLast: r }) => {
  const {
    template: n,
    themeManager: A,
    handleCriteriaClick: i,
    dropdowns: o,
    setDropdown: s,
    isImageOpen: a,
    iconUrls: c,
    ButtonType: l,
    allowMultiClick: u
  } = G1(), f = new Bt("mixpanel", "production"), d = (g) => {
    g.stopPropagation(), s((m) => m.map((p, v) => v === e ? !p : p));
  };
  return n === 2 ? /* @__PURE__ */ k(
    "div",
    {
      className: "gs-single-card-dropDown",
      style: A.getCardStyles().card,
      onClick: d,
      children: [
        /* @__PURE__ */ k("div", { className: "gs_card_body_dropDown", children: [
          (!o[e] || !a) && /* @__PURE__ */ h(
            "div",
            {
              className: "gs_card_body_image",
              style: A.getCardStyles().icon,
              children: /* @__PURE__ */ h(
                "img",
                {
                  className: "gs-card-icon",
                  src: t.imageUrl || (c == null ? void 0 : c[e]) || Jn,
                  alt: ""
                }
              )
            }
          ),
          /* @__PURE__ */ k("div", { className: "gs-card-text", children: [
            /* @__PURE__ */ h("div", { style: A.getHeadingStyles(), className: "gs-card-head", children: t.title }),
            /* @__PURE__ */ h("div", { style: A.getDescriptionStyles(), className: "gs-card-desc", children: t.description })
          ] }),
          /* @__PURE__ */ h("div", { className: "gs-card-img-button", children: t.completed ? /* @__PURE__ */ h(
            "div",
            {
              className: "q_gt_arrow-completed",
              style: {
                background: A.getArrowStyles(!0).background
              },
              children: /* @__PURE__ */ h(
                S0,
                {
                  type: "greenCheck",
                  color: A.getArrowStyles(!0).iconColor
                }
              )
            }
          ) : /* @__PURE__ */ h(
            "div",
            {
              className: "q_gt_arrow",
              style: {
                background: A.getArrowStyles(!1).background
              },
              children: /* @__PURE__ */ h(
                S0,
                {
                  type: o[e] ? "upArrow" : "downArrowIcon",
                  color: A.getArrowStyles(!1).iconColor
                }
              )
            }
          ) })
        ] }),
        o[e] && /* @__PURE__ */ k("div", { className: "gs_card_dropdown", children: [
          a && /* @__PURE__ */ h(
            "div",
            {
              className: "card-drop-down-cont",
              style: A.getStyleValueAsObject(
                "IsImageOpen.ContainerDiv",
                {}
              ),
              children: /* @__PURE__ */ h(
                "div",
                {
                  style: A.getStyleValueAsObject(
                    "IsImageOpen.ImageContainer.ImageContainerProperties",
                    {}
                  ),
                  children: /* @__PURE__ */ h(
                    "img",
                    {
                      src: t.imageUrl || (c == null ? void 0 : c[e]) || Jn,
                      alt: "",
                      style: {
                        borderRadius: A.getStyleValueAsString(
                          "IsImageOpen.ImageContainer.Image.borderRadius",
                          "50%"
                        ),
                        ...A.getStyleValueAsObject(
                          "IsImageOpen.ImageContainer.Image",
                          {}
                        )
                      }
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "gs_drop_desc",
              style: A.getDescriptionStyles(),
              children: t.longDescription
            }
          ),
          /* @__PURE__ */ k("div", { className: "gs_drop_btns", children: [
            /* @__PURE__ */ h(
              yr,
              {
                attr: t.url,
                className: "gs_start_btn",
                onClick: (g) => {
                  g.stopPropagation(), f.fireTrackingEvent(
                    "quest_get_started_primary_button_clicked",
                    "get_started"
                  ), !u && t.completed || i(t, t.url);
                },
                disabled: !u && t.completed,
                style: {
                  ...A.getButtonStyles().primary,
                  width: "fit-content"
                },
                children: t.btn2 || "Start Now"
              }
            ),
            /* @__PURE__ */ h(
              JA,
              {
                style: {
                  ...A.getButtonStyles().secondary,
                  width: "fit-content"
                },
                onClick: (g) => {
                  g.stopPropagation(), f.fireTrackingEvent(
                    "quest_get_started_secondary_button_clicked",
                    "get_started"
                  ), window.open(t.btn1Link);
                },
                className: "gs_visit_btn",
                children: t.btn1 || "Visit Website"
              }
            )
          ] })
        ] })
      ]
    }
  ) : /* @__PURE__ */ h(
    "div",
    {
      className: "gs-single-card",
      onClick: () => {
        !u && t.completed || i(t, t.url);
      },
      children: /* @__PURE__ */ k("div", { className: "gs_card_body", style: A.getCardStyles().card, children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "gs_card_body_image",
            style: A.getCardStyles().icon,
            children: /* @__PURE__ */ h(
              "img",
              {
                className: "gs-card-icon",
                src: t.imageUrl || (c == null ? void 0 : c[e]) || Jn,
                alt: ""
              }
            )
          }
        ),
        /* @__PURE__ */ k("div", { className: "gs-card-text", children: [
          /* @__PURE__ */ h("div", { style: A.getHeadingStyles(), className: "gs-card-head", children: t.title }),
          /* @__PURE__ */ h("div", { style: A.getDescriptionStyles(), className: "gs-card-desc", children: t.description })
        ] }),
        l === "Buttons" ? t.completed ? /* @__PURE__ */ h("div", { className: "gs-card-img-button", children: /* @__PURE__ */ h(
          "div",
          {
            className: "q_gt_arrow-completed",
            style: {
              background: A.getArrowStyles(!0).background
            },
            children: /* @__PURE__ */ h(
              S0,
              {
                type: "greenCheck",
                color: A.getArrowStyles(!0).iconColor
              }
            )
          }
        ) }) : /* @__PURE__ */ k("div", { className: "gs_drop_btns", children: [
          /* @__PURE__ */ h(
            JA,
            {
              style: {
                ...A.getButtonStyles().secondary,
                border: "none",
                width: "fit-content"
              },
              onClick: (g) => {
                g.stopPropagation(), f.fireTrackingEvent(
                  "quest_get_started_secondary_button_clicked",
                  "get_started"
                ), window.open(t.btn1Link);
              },
              className: "gs_visit_btn gs_tempalate1_btn",
              children: t.btn1 || "Visit Website"
            }
          ),
          /* @__PURE__ */ h(
            yr,
            {
              attr: t.url,
              className: "gs_start_btn",
              onClick: (g) => {
                g.stopPropagation(), f.fireTrackingEvent(
                  "quest_get_started_primary_button_clicked",
                  "get_started"
                ), !u && t.completed || i(t, t.url);
              },
              disabled: !u && t.completed,
              style: {
                ...A.getButtonStyles().primary,
                width: "fit-content"
              },
              children: t.btn2 || "Start Now"
            }
          )
        ] }) : /* @__PURE__ */ h("div", { className: "gs-card-img-button", children: t.completed ? /* @__PURE__ */ h(
          "div",
          {
            className: "q_gt_arrow-completed",
            style: {
              background: A.getArrowStyles(!0).background
            },
            children: /* @__PURE__ */ h(
              S0,
              {
                type: "greenCheck",
                color: A.getArrowStyles(!0).iconColor
              }
            )
          }
        ) : /* @__PURE__ */ h(
          "div",
          {
            className: "q_gt_arrow",
            style: {
              background: A.getArrowStyles(!1).background
            },
            children: /* @__PURE__ */ h(
              S0,
              {
                type: "arrowRight",
                color: A.getArrowStyles(!1).iconColor
              }
            )
          }
        ) })
      ] })
    }
  );
}, TN = () => {
  const { formdata: t, template: e, themeManager: r } = G1();
  return /* @__PURE__ */ h(
    "div",
    {
      className: "gs-cards-container",
      style: r.getCardStyles(e).container,
      children: t.map((n, A) => /* @__PURE__ */ h(
        oPe,
        {
          data: n,
          index: A,
          isLast: A === t.length - 1
        },
        A
      ))
    }
  );
}, MN = () => {
  const { themeManager: t } = G1();
  return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
    Pr,
    {
      style: t.getFooterStyles().container,
      textStyle: t.getFooterStyles().text,
      iconStyle: t.getFooterStyles().icon
    }
  ) });
}, r9 = ({
  children: t,
  userId: e,
  token: r,
  questId: n,
  onCompleteAllStatus: A,
  iconUrls: i = [],
  uniqueUserId: o,
  headingText: s,
  descriptionText: a,
  uniqueEmailId: c,
  autoHide: l = !0,
  template: u = 1,
  showLoadingIndicator: f = !0,
  showAnnouncement: d = !1,
  ButtonType: g = "Arrow",
  allowMultiClick: m = !1,
  onLinkTrigger: p = (x) => {
    window.location.href = x;
  },
  showFooter: v = !0,
  styleConfig: C,
  isImageOpen: w = !1,
  onLoad: B,
  variation: y,
  Headers: b,
  isProgressNumber: q,
  accent: E
}) => {
  const [x, M] = N([]), [O, I] = N(!1), [S, P] = N(!1), [H, F] = N([]), [T, U] = N([]), [D, Q] = N(""), [Y, j] = N([]), { apiKey: Z, entityId: W, apiType: R, themeConfig: K } = Xe(
    ct.Context
  ), L = new iPe(R), G = new Bt("mixpanel", R), [V, _] = N(
    () => new iP(K, C)
  ), J = q ? x.filter(($) => $.completed).length : (x == null ? void 0 : x.reduce(($, te) => $ + (te.completed ? 1 : 0), 0)) * 100 / x.length;
  le(() => {
    _(new iP(K, C));
  }, [K, C]);
  const X = async ($, te) => {
    if (!O) {
      if (te.indexOf("walkthrough:") === 0) {
        const ae = p(te, $.actionId);
        return ae || void 0;
      }
      if (d) {
        p(te, $.actionId);
        return;
      }
      try {
        I(!0);
        const ae = await L.getUserAuth({
          apiKey: Z,
          entityId: W,
          uniqueUserId: o,
          uniqueEmailId: c,
          userId: e,
          token: r
        });
        if (!ae) return;
        await L.verifyAction(
          W,
          n,
          Z,
          ae,
          $,
          D
        ), F([...H, $.actionId]), p(te, $.actionId);
      } catch (ae) {
        G.captureSentryException(ae);
      } finally {
        I(!1);
      }
    }
  };
  le(() => {
    G.fireTrackingEvent(
      "quest_get_started_loaded",
      "get_started"
    ), (async () => {
      var te, ae, se, ue, fe, ve, ge, oe, ce, pe, qe, Se, Te, be, He, Ge;
      if (!(!W || !Z))
        try {
          const Le = await L.getUserAuth({
            apiKey: Z,
            entityId: W,
            uniqueUserId: o,
            uniqueEmailId: c,
            userId: e,
            token: r
          });
          if (!Le) return;
          const Ae = await L.fetchCampaignData(
            W,
            n,
            Z,
            Le,
            y
          );
          (se = (ae = (te = Ae.data) == null ? void 0 : te.sdkConfig) == null ? void 0 : ae.uiProps) != null && se.questThemeData && _((de) => (de.updateQuestTheme(
            Ae.data.sdkConfig.uiProps.questThemeData
          ), Ae.data.sdkConfig.uiProps.BrandTheme && de.updateBrandTheme(
            Ae.data.sdkConfig.uiProps.BrandTheme.properties
          ), de)), E && !((ge = (ve = (fe = (ue = Ae == null ? void 0 : Ae.data) == null ? void 0 : ue.sdkConfig) == null ? void 0 : fe.uiProps) == null ? void 0 : ve.questThemeData) != null && ge.accentColor) && _((de) => {
            var xe, he;
            return de.updateQuestTheme({
              ...de.questThemeData,
              accentColor: (xe = de == null ? void 0 : de.questThemeData) != null && xe.accentColor ? (he = de == null ? void 0 : de.questThemeData) == null ? void 0 : he.accentColor : E
            }), de;
          }), (pe = (ce = (oe = Ae == null ? void 0 : Ae.data) == null ? void 0 : oe.sdkConfig) == null ? void 0 : ce.uiProps) != null && pe.Headers && ((Te = (Se = (qe = Ae == null ? void 0 : Ae.data) == null ? void 0 : qe.sdkConfig) == null ? void 0 : Se.uiProps) == null ? void 0 : Te.Headers.length) > 0 && j((Ge = (He = (be = Ae == null ? void 0 : Ae.data) == null ? void 0 : be.sdkConfig) == null ? void 0 : He.uiProps) == null ? void 0 : Ge.Headers), Q(Ae.data.campaignVariationId);
          const Pe = Ae.data.actions.filter((de) => {
            var xe;
            return ((xe = de.metadata) == null ? void 0 : xe.link) != "walkthrough:flow";
          }).map((de) => {
            var xe, he, Qe, Re, pt;
            return {
              type: de.actionType,
              title: de.title,
              url: (xe = de.metadata) == null ? void 0 : xe.link,
              description: de.description,
              btn1: ((he = de.metadata) == null ? void 0 : he.secondaryTitle) || "",
              btn2: (Qe = de.metadata) == null ? void 0 : Qe.buttonTitle,
              btn1Link: (Re = de.metadata) == null ? void 0 : Re.secondaryLink,
              actionId: de.actionId,
              completed: de.isCompleted,
              longDescription: de.description || "Default description",
              imageUrl: (pt = de.metadata) == null ? void 0 : pt.imageUrl
            };
          });
          M(Pe);
          const it = Pe.every(
            (de) => de.completed
          );
          P(it), T.length || U(new Array(Pe.length).fill(!1));
        } catch (Le) {
          G.captureSentryException(Le);
        }
    })();
  }, [H, o]), le(() => {
    S && (async () => {
      try {
        I(!0);
        const te = await L.getUserAuth({
          apiKey: Z,
          entityId: W,
          uniqueUserId: o,
          uniqueEmailId: c,
          userId: e,
          token: r
        });
        if (!te) return;
        await L.claimReward(
          W,
          n,
          Z,
          te,
          D
        ), A == null || A();
      } catch (te) {
        G.captureSentryException(te);
      } finally {
        I(!1);
      }
    })();
  }, [S, o]), le(() => {
    x.length > 0 && (B == null || B());
  }, [x]);
  const ne = () => t ? xa.map(t, ($) => re.isValidElement($) ? $.type === Am ? re.cloneElement($, {
    heading: s,
    subHeading: a,
    Headers: b || Y,
    ...$.props
  }) : $ : null) : /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ h(
      Am,
      {
        heading: s,
        subHeading: a,
        Headers: b || Y
      }
    ),
    /* @__PURE__ */ h(FN, { isProgressNumber: q }),
    /* @__PURE__ */ h(TN, {}),
    /* @__PURE__ */ h(MN, {})
  ] });
  console.log(Y);
  const ee = {
    formdata: x,
    showLoader: O,
    allActionCompleted: S,
    completedPercentage: J,
    themeManager: V,
    handleCriteriaClick: X,
    dropdowns: T,
    setDropdown: U,
    template: u,
    isImageOpen: w,
    iconUrls: i,
    ButtonType: g,
    allowMultiClick: m
  };
  return f && O ? /* @__PURE__ */ h(rl, {}) : /* @__PURE__ */ h(ON.Provider, { value: ee, children: x.length > 0 && /* @__PURE__ */ h("div", { className: "get_started_box", style: V.getFormStyles(), children: (l ? !!x.length && !S : !0) && ne() }) });
};
r9.Header = Am;
r9.Progress = FN;
r9.Content = TN;
r9.Footer = MN;
const sPe = () => /* @__PURE__ */ h("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
  "path",
  {
    d: "M19 1L17.74 3.75L15 5L17.74 6.26L19 9L20.25 6.26L23 5L20.25 3.75M9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5M19 15L17.74 17.74L15 19L17.74 20.25L19 23L20.25 20.25L23 19L20.25 17.74",
    fill: "#AFAFAF"
  }
) }), aPe = () => /* @__PURE__ */ k("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ k("g", { clipPath: "url(#clip0_205_4776)", children: [
    /* @__PURE__ */ h("circle", { cx: "7.66667", cy: "7.66659", r: "6.33333", stroke: "#AFAFAF", "stroke-width": "1.5" }),
    /* @__PURE__ */ h("path", { d: "M13.3333 13.3333L14.6667 14.6666", stroke: "#AFAFAF", "stroke-width": "1.5", "stroke-linecap": "round" })
  ] }),
  /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_205_4776", children: /* @__PURE__ */ h("rect", { width: "16", height: "16", fill: "white" }) }) })
] }), cPe = () => /* @__PURE__ */ k("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h("path", { d: "M8.35859 7.47479C8.11451 7.23072 7.71878 7.23072 7.4747 7.47479C7.23063 7.71887 7.23063 8.1146 7.4747 8.35868L9.11611 10.0001L7.47472 11.6415C7.23064 11.8855 7.23064 12.2813 7.47472 12.5253C7.7188 12.7694 8.11453 12.7694 8.35861 12.5253L9.99999 10.884L11.6414 12.5253C11.8854 12.7694 12.2812 12.7694 12.5252 12.5253C12.7693 12.2812 12.7693 11.8855 12.5252 11.6414L10.8839 10.0001L12.5253 8.35869C12.7693 8.11462 12.7693 7.71889 12.5253 7.47481C12.2812 7.23073 11.8855 7.23073 11.6414 7.47481L9.99999 9.11619L8.35859 7.47479Z", fill: "#8E8E8E" }),
  /* @__PURE__ */ h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10 1.04175C5.05245 1.04175 1.04167 5.05253 1.04167 10.0001C1.04167 14.9476 5.05245 18.9584 10 18.9584C14.9476 18.9584 18.9583 14.9476 18.9583 10.0001C18.9583 5.05253 14.9476 1.04175 10 1.04175ZM2.29167 10.0001C2.29167 5.74289 5.74281 2.29175 10 2.29175C14.2572 2.29175 17.7083 5.74289 17.7083 10.0001C17.7083 14.2573 14.2572 17.7084 10 17.7084C5.74281 17.7084 2.29167 14.2573 2.29167 10.0001Z", fill: "#8E8E8E" })
] }), lPe = ({ back: t }) => {
  const [e, r] = N([]), n = gt(null), [A, i] = N(!1), o = async () => {
    var a;
    const s = (a = n.current) == null ? void 0 : a.value;
    s && (r((c) => [...c, { text: s, type: "user" }]), i(!0), n.current.value = "", await new Promise((c) => setTimeout(() => c(""), 2e3)), r((c) => [...c, { text: "I am fine, how are you doing?", type: "ai" }]), i(!1));
  };
  return /* @__PURE__ */ k("div", { className: "q-help-chat", children: [
    /* @__PURE__ */ k("div", { className: "q-help-chat-nav", children: [
      /* @__PURE__ */ h("img", { src: vte, alt: "", onClick: () => {
        t();
      } }),
      /* @__PURE__ */ h("img", { src: qte, alt: "" })
    ] }),
    /* @__PURE__ */ k("div", { className: "q-help-chat-container", children: [
      /* @__PURE__ */ k("div", { className: "q-help-first-chat", children: [
        /* @__PURE__ */ h("img", { src: db, alt: "" }),
        /* @__PURE__ */ h("div", { className: "q-help-chat-ai", children: "Hi Shanta, I’m support assistant." })
      ] }),
      e.map((s, a) => /* @__PURE__ */ k("div", { className: "q-help-chat-div", children: [
        s.type == "ai" && /* @__PURE__ */ h("img", { src: db, alt: "" }),
        /* @__PURE__ */ h("div", { className: `q-help-chat-${s.type}`, children: s.text }, a),
        s.type == "user" && /* @__PURE__ */ h("img", { className: "", src: gte })
      ] })),
      A && /* @__PURE__ */ h("div", { className: "q-cht-ch-loading", children: /* @__PURE__ */ k("div", { className: "msgTyping q-cht-ch-loading-div", children: [
        /* @__PURE__ */ h("div", { className: "dot" }),
        /* @__PURE__ */ h("div", { className: "dot" }),
        /* @__PURE__ */ h("div", { className: "dot" })
      ] }) })
    ] }),
    /* @__PURE__ */ k("div", { className: "q-help-input-box", children: [
      /* @__PURE__ */ h(
        "input",
        {
          className: "q-help-chat-input",
          placeholder: "Ask a question....",
          onKeyDown: (s) => s.key === "Enter" ? o() : "",
          ref: n
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q-help-send-chat-png",
          src: mte,
          alt: "",
          width: 24,
          height: 24,
          onClick: o
        }
      )
    ] })
  ] });
};
let Ah = [];
function uPe(t, e, r, n) {
  const A = `${Ve.BACKEND_URL}api/entities/${e}/quests/${r}?userId=${t.userId}&getVariation=${n}`;
  return Oe.get(A, { headers: t }).then((i) => i.data.eligibilityData ? i.data.eligibilityData.map((s) => ({
    title: s.data.metadata.linkActionName,
    link: s.data.metadata.linkActionUrl,
    description: s.data.metadata.linkActionDescription,
    icon: s.data.metadata.icon
  })) : []).catch((i) => (console.log(i), []));
}
const EFe = ({
  userId: t = "",
  token: e = "",
  questId: r = "",
  color: n = "",
  backgroundColor: A = "",
  headColor: i = "white",
  headBgColor: o = "black",
  descriptioin: s = "Discover our key features",
  onClose: a = () => {
  },
  uniqueEmailId: c,
  uniqueUserId: l,
  enableVariation: u = !1
}) => {
  const [f, d] = N(!0), [g, m] = N([]), { apiKey: p, apiSecret: v, entityId: C, apiType: w } = Xe(ct.Context), [B, y] = N(!1), b = (E) => {
    m(Ah.filter((x) => x.title.includes(E))), E == "" && m(Ah);
  };
  le(() => {
    uPe({ apiKey: p, apisecret: v, token: e, userId: t }, C, r, u).then((E) => {
      m(E), Ah = E;
    }), C && l && new Bt("").getExternalLogin({ apiType: w, uniqueUserId: l, entityId: C, userId: t, apiKey: p, apiSecret: v, token: e, uniqueEmailId: c });
  }, []);
  const q = gt(null);
  return le(() => {
    q.current && (q.current.scrollHeight == q.current.clientHeight ? q.current.classList.add("scrollable") : q.current.classList.remove("scrollable"));
  }, [g]), /* @__PURE__ */ k("div", { className: "q-help-parent", children: [
    /* @__PURE__ */ h("div", { className: "q-cht-main", onClick: () => d(!f), children: /* @__PURE__ */ h("img", { src: tD, alt: "", className: "q-cht-logo2" }) }),
    /* @__PURE__ */ h("div", { className: "q-help", style: {
      transition: "all ease 0.5s",
      right: `${f ? "100px" : "-100px"}`,
      top: `${f ? "20px" : "250px"}`,
      transform: `scale(${f ? 1 : 0})`
    }, children: /* @__PURE__ */ k("div", { className: "q-help-child", style: { backgroundColor: A, color: n }, children: [
      /* @__PURE__ */ k(
        "div",
        {
          onClick: () => y(!1),
          className: "q-help-ch-div",
          style: { backgroundColor: o },
          children: [
            /* @__PURE__ */ k("div", { children: [
              /* @__PURE__ */ h("div", { className: "q-cht-ch-div-head", style: { color: i }, children: "Help Center" }),
              /* @__PURE__ */ h("div", { className: "q-cht-ch-div-desc", style: { color: n }, children: s })
            ] }),
            /* @__PURE__ */ h(
              "div",
              {
                style: { display: "flex", cursor: "pointer" },
                onClick: () => {
                  d(!1), a();
                },
                children: /* @__PURE__ */ h(cPe, {})
              }
            )
          ]
        }
      ),
      B ? /* @__PURE__ */ h(lPe, { back: () => {
        y(!1);
      } }) : /* @__PURE__ */ k("div", { className: "q-help-section", children: [
        /* @__PURE__ */ k("div", { className: "q-help-ask", children: [
          /* @__PURE__ */ h(
            "input",
            {
              className: "q-help-ask-input",
              onChange: (E) => b(E.target.value),
              placeholder: "Ask a question"
            }
          ),
          /* @__PURE__ */ h("div", { style: { display: "inline" }, className: "q-help-search-icon", children: /* @__PURE__ */ h(aPe, {}) }),
          /* @__PURE__ */ k("div", { className: "q-help-ask-ai", style: { color: n }, onClick: () => {
            m(Ah), y(!0);
          }, children: [
            "Ask AI ",
            /* @__PURE__ */ h(sPe, {})
          ] })
        ] }),
        /* @__PURE__ */ k("div", { className: "q-help-rect", children: [
          /* @__PURE__ */ h("img", { src: lte, alt: "" }),
          /* @__PURE__ */ h("img", { src: ute, alt: "" })
        ] }),
        /* @__PURE__ */ h("div", { className: "q-help-links", ref: q, children: g.map((E, x) => /* @__PURE__ */ k(
          "div",
          {
            className: "q-help-links-child",
            onClick: () => {
              window.open(E.link, "_blank");
            },
            children: [
              /* @__PURE__ */ h("div", { className: "q-help-link-icon", children: /* @__PURE__ */ h("img", { src: E.icon || "", alt: "" }) }),
              /* @__PURE__ */ k("div", { className: "q-help-links-div", children: [
                /* @__PURE__ */ h("div", { className: "q-help-links-name", style: { color: n }, children: E.title }),
                /* @__PURE__ */ h("div", { className: "q-help-links-desc", style: { color: n }, children: E.description })
              ] })
            ]
          },
          x
        )) })
      ] })
    ] }) })
  ] });
};
function dPe(t = 2e3, e = 0.1) {
  const r = document.createElement("canvas");
  r.setAttribute("id", "canvas");
  const n = document.body;
  r.style.position = "absolute", r.style.top = "0", n.appendChild(r), setTimeout(() => {
    const g = setInterval(() => {
      s = s / (1 + e), s < 10 && (clearInterval(g), n.removeChild(r));
    }, 100);
  }, t);
  let A = window.innerWidth, i = window.innerHeight;
  const o = r.getContext("2d");
  let s = t / 10;
  const a = [], c = [
    "DodgerBlue",
    "OliveDrab",
    "Gold",
    "Pink",
    "SlateBlue",
    "LightBlue",
    "Gold",
    "Violet",
    "PaleGreen",
    "SteelBlue",
    "SandyBrown",
    "Chocolate",
    "Crimson"
  ];
  function l(g, m) {
    return Math.floor(Math.random() * (m - g + 1) + g);
  }
  function u() {
    this.x = Math.random() * A, this.y = Math.random() * i - i, this.r = l(11, 33), this.d = Math.random() * s + 11, this.color = c[Math.floor(Math.random() * c.length)], this.tilt = Math.floor(Math.random() * 33) - 11, this.tiltAngleIncremental = Math.random() * 0.07 + 0.05, this.tiltAngle = 0, this.draw = function() {
      return o.beginPath(), o.lineWidth = this.r / 2, o.strokeStyle = this.color, o.moveTo(this.x + this.tilt + this.r / 3, this.y), o.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5), o.stroke();
    };
  }
  function f() {
    const g = [];
    requestAnimationFrame(f), o.clearRect(0, 0, A, window.innerHeight);
    for (var m = 0; m < s; m++)
      g.push(a[m].draw());
    let p = { tiltAngle: 0, tiltAngleIncremental: 0, y: 0, r: 0, d: 0, tilt: 0, x: 0 };
    for (var m = 0; m < s; m++)
      p = a[m], p.tiltAngle += p.tiltAngleIncremental, p.y += (Math.cos(p.d) + 3 + p.r / 2) / 2, p.tilt = Math.sin(p.tiltAngle - m / 3) * 15, p.y <= i, (p.x > A + 30 || p.x < -30 || p.y > i) && (p.x = Math.random() * A, p.y = -30, p.tilt = Math.floor(Math.random() * 10) - 20);
    return g;
  }
  window.addEventListener(
    "resize",
    function() {
      A = window.innerWidth, i = window.innerHeight, r.width = window.innerWidth, r.height = window.innerHeight;
    },
    !1
  );
  for (var d = 0; d < s; d++)
    a.push(new u());
  r.width = A, r.height = i, f();
}
const HN = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`, Vp = (t = "#B9B9B9") => HN(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.58332 2.29169C5.55625 2.29169 2.29166 5.55628 2.29166 9.58335C2.29166 13.6104 5.55625 16.875 9.58332 16.875C13.6104 16.875 16.875 13.6104 16.875 9.58335C16.875 5.55628 13.6104 2.29169 9.58332 2.29169ZM1.04166 9.58335C1.04166 4.86592 4.86589 1.04169 9.58332 1.04169C14.3008 1.04169 18.125 4.86592 18.125 9.58335C18.125 11.7171 17.3426 13.6681 16.049 15.1652L18.7753 17.8914C19.0193 18.1355 19.0193 18.5312 18.7753 18.7753C18.5312 19.0194 18.1355 19.0194 17.8914 18.7753L15.1652 16.0491C13.6681 17.3426 11.7171 18.125 9.58332 18.125C4.86589 18.125 1.04166 14.3008 1.04166 9.58335Z" fill="${t}"/>
</svg>`), Wp = (t = "black") => HN(`<svg width="29" height="10" viewBox="0 0 29 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.70898 3.76758H1.84766C0.921875 3.76758 0.171875 3.04102 0.171875 2.10938C0.171875 1.17773 0.921875 0.427734 1.84766 0.427734C2.77344 0.427734 3.52344 1.17773 3.52344 2.10938V2.96484H5.50391V2.10938C5.50391 1.17773 6.25391 0.427734 7.17969 0.427734C8.10547 0.427734 8.85547 1.17773 8.85547 2.10938C8.85547 3.04102 8.10547 3.76758 7.17969 3.76758H6.32422V5.77734H7.17969C8.10547 5.77734 8.85547 6.50391 8.85547 7.43555C8.85547 8.36719 8.10547 9.11719 7.17969 9.11719C6.25391 9.11719 5.50391 8.36719 5.50391 7.43555V6.58008H3.52344V7.43555C3.52344 8.36719 2.77344 9.11719 1.84766 9.11719C0.921875 9.11719 0.171875 8.36719 0.171875 7.43555C0.171875 6.50391 0.921875 5.77734 1.84766 5.77734H2.70898V3.76758ZM1.84766 2.97656H2.70898V2.10938C2.70898 1.63477 2.31641 1.24805 1.84766 1.24805C1.37891 1.24805 0.986328 1.63477 0.986328 2.10938C0.986328 2.58398 1.37891 2.97656 1.84766 2.97656ZM7.17969 2.97656C7.64844 2.97656 8.04102 2.58398 8.04102 2.10938C8.04102 1.63477 7.64844 1.24805 7.17969 1.24805C6.71094 1.24805 6.32422 1.63477 6.32422 2.10938V2.97656H7.17969ZM3.52344 5.78906H5.50391V3.75586H3.52344V5.78906ZM1.84766 6.5625C1.37891 6.5625 0.986328 6.95508 0.986328 7.42969C0.986328 7.9043 1.37891 8.29102 1.84766 8.29102C2.31641 8.29102 2.70898 7.9043 2.70898 7.42969V6.5625H1.84766ZM7.17969 6.5625H6.32422V7.42969C6.32422 7.9043 6.71094 8.29102 7.17969 8.29102C7.64844 8.29102 8.04102 7.9043 8.04102 7.42969C8.04102 6.95508 7.64844 6.5625 7.17969 6.5625ZM15.6352 8.70117C15.3481 8.70117 15.1606 8.48438 15.1606 8.19727V6.14062H13.2153C12.9282 6.14062 12.7114 5.95312 12.7114 5.66602C12.7114 5.37891 12.9282 5.19141 13.2153 5.19141H15.1606V3.12891C15.1606 2.8418 15.3481 2.625 15.6352 2.625C15.9223 2.625 16.1098 2.8418 16.1098 3.12891V5.19141H18.0493C18.3364 5.19141 18.5532 5.37891 18.5532 5.66602C18.5532 5.95312 18.3364 6.14062 18.0493 6.14062H16.1098V8.19727C16.1098 8.48438 15.9223 8.70117 15.6352 8.70117ZM22.5908 9.08203C22.2685 9.08203 22.0634 8.87109 22.0634 8.53711V1.00781C22.0634 0.673828 22.2685 0.462891 22.5908 0.462891C22.913 0.462891 23.1181 0.673828 23.1181 1.00781V4.66992H23.1767L26.9443 0.662109C27.0791 0.515625 27.1963 0.457031 27.3603 0.457031C27.6474 0.457031 27.8466 0.667969 27.8466 0.9375C27.8466 1.06055 27.7998 1.17188 27.706 1.27148L24.7939 4.28906L28.0341 8.19141C28.1396 8.32031 28.1865 8.45508 28.1865 8.58398C28.1865 8.86523 27.9638 9.08789 27.6767 9.08789C27.4834 9.08789 27.3545 9.01758 27.2021 8.83008L24.0615 5.03906L23.1181 6.04688V8.53711C23.1181 8.87109 22.913 9.08203 22.5908 9.08203Z" fill="${t}"/>
</svg>
`);
async function fPe(t, e, r, n, A) {
  const i = new URLSearchParams();
  i.set("platform", "REACT"), A && i.set("variation", A);
  const o = `${n}api/v2/entities/${e}/campaigns/${r}?${i.toString()}`;
  return Oe.get(o, { headers: { ...t } }).then((s) => {
    var a, c, l;
    return s.data.data.actions ? { formatData: s.data.data.actions.map((d) => {
      var g;
      return {
        text: d.title || "",
        link: (d == null ? void 0 : d.metadata.link) || "",
        description: d.discription || "Provide the required information",
        icon: (d == null ? void 0 : d.metadata.imageUrl) || "",
        resultType: (g = d == null ? void 0 : d.metadata) == null ? void 0 : g.resultType,
        longDescription: d.discription || "No more digging through Dropbox and Google Drive. Always know where to find “the latest,” so you can stay in your design flow."
      };
    }), questThemeData: (l = (c = (a = s == null ? void 0 : s.data) == null ? void 0 : a.data) == null ? void 0 : c.uiProps) == null ? void 0 : l.questThemeData } : [];
  }).catch((s) => (console.log(s), []));
}
function xFe(t) {
  var L, G, V, _, J, X, ne, ee, $, te, ae, se, ue, fe, ve, ge, oe, ce, pe, qe, Se, Te, be, He, Ge, Le, Ae, Pe, it, de, xe;
  const {
    wholerScreen: e = !0,
    defaultResult: r = [],
    defulatResultLength: n = 10,
    onSearch: A = (he) => {
    },
    questId: i = "",
    token: o = "",
    userId: s = "",
    onResultClick: a = (he) => window.open(he, "_blank"),
    uniqueUserId: c,
    uniqueEmailId: l,
    styleConfig: u,
    showFooter: f = !0,
    iconColor: d,
    footerText: g = "Powered by PLG OS",
    footerLink: m,
    variation: p
  } = t, v = gt(null), [C, w] = N(r), [B, y] = N(!1), [b, q] = N(0), { apiKey: E, entityId: x, apiType: M, apiSecret: O, themeConfig: I } = Xe(
    ct.Context
  ), [S, P] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }), [H, F] = N({
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  });
  let T = new Bt("mixpanel", M);
  const [U, D] = N([]);
  let Q = M == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const Y = (he) => {
    B && C.length > 0 && (he.key === "ArrowDown" ? (he.preventDefault(), q(
      (Qe) => Qe === null ? 0 : Math.min(Qe + 1, C.length - 1)
    )) : he.key === "ArrowUp" ? (he.preventDefault(), q(
      (Qe) => Qe === null ? 0 : Math.max(Qe - 1, 0)
    )) : he.key === "Enter" && b !== null && a(C[b].link));
  };
  le(() => {
    T.fireTrackingEvent(
      "quest_spotlight_search_loaded",
      "spotlight_search"
    ), x && c && new Bt("").getExternalLogin({
      apiType: M,
      uniqueUserId: c,
      entityId: x,
      userId: s,
      apiKey: E,
      apiSecret: O,
      token: o,
      uniqueEmailId: l
    });
  }, []);
  const j = (he) => {
    (he.ctrlKey || he.metaKey) && !he.altKey && he.key === "k" ? (T.fireTrackingEvent(
      "quest_spotlight_search_ctrl_k_pressed",
      "spotlight_search"
    ), he.preventDefault(), y((Re) => !Re)) : he.key == "Escape" && y(!1);
  };
  le(() => {
    var he;
    B && ((he = v.current) == null || he.focus());
  }, [B]), le(() => {
    var he;
    return fPe({ apiKey: E, token: o, userId: s }, x, i, Q, p).then(
      (Qe) => {
        var Re;
        P(Qe.questThemeData), D([...Qe.formatData].splice(0, n)), w([...Qe.formatData].splice(0, n)), (Re = Qe.questThemeData) != null && Re.theme;
      }
    ), t.open === !0 && y(!0), (he = v.current) == null || he.focus(), window.addEventListener("keydown", j), () => {
      window.removeEventListener("keydown", j);
    };
  }, []);
  const Z = (he) => {
    if (!U.length) return;
    const Qe = U.filter(
      (Re) => Re.text.toLocaleLowerCase().includes(he.toLocaleLowerCase())
    );
    w(Qe);
  }, W = /* @__PURE__ */ k(
    "div",
    {
      className: "q_search_bar",
      style: {
        background: ((L = u == null ? void 0 : u.Form) == null ? void 0 : L.backgroundColor) || (H == null ? void 0 : H.background) || (I == null ? void 0 : I.backgroundColor),
        height: ((G = u == null ? void 0 : u.Form) == null ? void 0 : G.height) || "auto",
        borderRadius: ((V = u == null ? void 0 : u.Form) == null ? void 0 : V.borderRadius) || (H == null ? void 0 : H.borderRadius) || (S == null ? void 0 : S.borderRadius),
        fontFamily: (H == null ? void 0 : H.fontFamily) || I.fontFamily || "'Figtree', sans-serif",
        ...u == null ? void 0 : u.Form
      },
      children: [
        /* @__PURE__ */ k("div", { className: "q_search_box", style: { ...u == null ? void 0 : u.Topbar }, children: [
          /* @__PURE__ */ h(
            "img",
            {
              className: "q_search_bar_icon",
              src: Vp(t.iconColor),
              alt: ""
            }
          ),
          /* @__PURE__ */ h("div", { className: "q_searchBox_input_cont", children: /* @__PURE__ */ h(
            "div",
            {
              className: "q_input_cont",
              style: {
                borderColor: ((_ = u == null ? void 0 : u.Input) == null ? void 0 : _.borderColor) || (I == null ? void 0 : I.borderColor),
                padding: "0px"
              },
              children: /* @__PURE__ */ h(
                "input",
                {
                  type: "text",
                  placeholder: t.placeholder,
                  ref: v,
                  onKeyDown: Y,
                  onChange: (he) => {
                    A(he.target.value), Z(he.target.value);
                  },
                  style: {
                    fontFamily: (H == null ? void 0 : H.fontFamily) || I.fontFamily || "'Figtree', sans-serif",
                    color: ((J = u == null ? void 0 : u.Input) == null ? void 0 : J.color) || (H == null ? void 0 : H.primaryColor) || I.primaryColor,
                    ...u == null ? void 0 : u.Input
                  },
                  className: "q_input_main_cont"
                }
              )
            }
          ) }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_search_command_key",
              style: { ...u == null ? void 0 : u.CommandButton },
              children: /* @__PURE__ */ h(
                "img",
                {
                  src: Wp(((X = u == null ? void 0 : u.CommandButton) == null ? void 0 : X.color) || d),
                  alt: ""
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ k("div", { className: "q_flex_box", children: [
          /* @__PURE__ */ h("div", { className: "q_search_results", children: C.map(({ icon: he, text: Qe, link: Re, description: pt }, ze) => {
            var lt, st, We, Je, ut, Be, Ct, Ye, $e;
            return /* @__PURE__ */ k(
              "div",
              {
                className: "q_search_res_box " + (ze === b && "q_heilight_search"),
                onClick: () => {
                  T.fireTrackingEvent(
                    "quest_spotlight_search_link_clicked",
                    "spotlight_search"
                  ), a(Re);
                },
                onMouseEnter: () => q(ze),
                onMouseLeave: () => q(0),
                style: {
                  background: ze === b ? (lt = u == null ? void 0 : u.listHover) == null ? void 0 : lt.background : "transparent"
                },
                children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-search-img-cont",
                      style: {
                        background: ze === b ? (st = u == null ? void 0 : u.listHover) == null ? void 0 : st.iconBackground : "#f4ebff"
                      },
                      children: /* @__PURE__ */ h(
                        "img",
                        {
                          src: ((We = t.icons) == null ? void 0 : We.length) && t.icons[ze] || he || Jn,
                          className: "q_search_result_icon",
                          alt: ""
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q_search_result_box", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: ze === b ? ((Je = u == null ? void 0 : u.listHover) == null ? void 0 : Je.Heading) || (H == null ? void 0 : H.primaryColor) || ((ut = u == null ? void 0 : u.Heading) == null ? void 0 : ut.color) || (I == null ? void 0 : I.primaryColor) : ((Be = u == null ? void 0 : u.Heading) == null ? void 0 : Be.color) || (H == null ? void 0 : H.primaryColor) || (I == null ? void 0 : I.primaryColor),
                          ...u == null ? void 0 : u.Heading
                        },
                        className: "q_search_result_head",
                        children: Qe
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: ze === b ? ((Ct = u == null ? void 0 : u.listHover) == null ? void 0 : Ct.Description) || ((Ye = u == null ? void 0 : u.Description) == null ? void 0 : Ye.color) || (H == null ? void 0 : H.secondaryColor) || (I == null ? void 0 : I.secondaryColor) : (($e = u == null ? void 0 : u.Description) == null ? void 0 : $e.color) || (H == null ? void 0 : H.secondaryColor) || (I == null ? void 0 : I.secondaryColor),
                          ...u == null ? void 0 : u.Description
                        },
                        className: "q_search_result_desc",
                        children: pt || "Provide the required information"
                      }
                    )
                  ] })
                ]
              },
              ze
            );
          }) }),
          t.searchDetails && /* @__PURE__ */ k("div", { className: "q_search_result_details", children: [
            /* @__PURE__ */ h(
              "img",
              {
                src: ((ne = C[b]) == null ? void 0 : ne.icon) || Jn,
                alt: ""
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                style: {
                  color: (H == null ? void 0 : H.primaryColor) || I.primaryColor,
                  ...u == null ? void 0 : u.Heading
                },
                className: "q_search_details_head",
                children: (ee = C[b]) == null ? void 0 : ee.text
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                style: {
                  color: (H == null ? void 0 : H.secondaryColor) || I.secondaryColor,
                  ...u == null ? void 0 : u.Description
                },
                className: "q_search_result_desc",
                children: (($ = C[b]) == null ? void 0 : $.longDescription) || ((te = C[b]) == null ? void 0 : te.description)
              }
            ),
            t.buttonText && /* @__PURE__ */ h("div", { className: "q_search_result_button1", children: t.buttonText }),
            /* @__PURE__ */ h("div", { className: "q_search_result_button2", children: "Learn more" })
          ] })
        ] }),
        f && /* @__PURE__ */ h(
          Pr,
          {
            style: {
              background: ((se = (ae = u == null ? void 0 : u.Footer) == null ? void 0 : ae.FooterStyle) == null ? void 0 : se.backgroundColor) || ((ue = u == null ? void 0 : u.Form) == null ? void 0 : ue.backgroundColor) || ((fe = u == null ? void 0 : u.Form) == null ? void 0 : fe.background) || (H == null ? void 0 : H.background) || (I == null ? void 0 : I.backgroundColor),
              ...(ve = u == null ? void 0 : u.Footer) == null ? void 0 : ve.FooterStyle
            },
            textStyle: (ge = u == null ? void 0 : u.Footer) == null ? void 0 : ge.FooterText,
            iconStyle: (oe = u == null ? void 0 : u.Footer) == null ? void 0 : oe.FooterIcon,
            text: g,
            link: m
          }
        )
      ]
    }
  ), R = /* @__PURE__ */ k("div", { className: "q_search_bar", children: [
    /* @__PURE__ */ k("div", { className: "q_search_box", style: { ...u == null ? void 0 : u.Topbar }, children: [
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_search_bar_icon",
          src: Vp(
            (H == null ? void 0 : H.secondaryColor) || I.secondaryColor
          ),
          alt: ""
        }
      ),
      /* @__PURE__ */ h("div", { className: "q_searchBox_input_cont", children: /* @__PURE__ */ h(
        "div",
        {
          className: "q_input_cont",
          style: {
            borderColor: ((ce = u == null ? void 0 : u.Input) == null ? void 0 : ce.borderColor) || (I == null ? void 0 : I.borderColor),
            padding: "0px"
          },
          children: /* @__PURE__ */ h(
            "input",
            {
              type: "text",
              placeholder: t.placeholder,
              ref: v,
              onKeyDown: Y,
              onChange: (he) => {
                A(he.target.value), Z(he.target.value);
              },
              style: {
                fontFamily: (H == null ? void 0 : H.fontFamily) || I.fontFamily || "'Figtree', sans-serif",
                color: ((pe = u == null ? void 0 : u.Input) == null ? void 0 : pe.color) || (H == null ? void 0 : H.primaryColor) || I.primaryColor,
                ...u == null ? void 0 : u.Input
              },
              className: "q_input_main_cont"
            }
          )
        }
      ) }),
      /* @__PURE__ */ h(
        "div",
        {
          className: "q_search_command_key",
          style: { ...u == null ? void 0 : u.CommandButton },
          children: /* @__PURE__ */ h(
            "img",
            {
              src: Wp(((qe = u == null ? void 0 : u.CommandButton) == null ? void 0 : qe.color) || d),
              alt: ""
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ k("div", { className: "q_flex_box", children: [
      /* @__PURE__ */ k("div", { className: "q_search_result_sections", children: [
        /* @__PURE__ */ h("div", { className: "q_search_result_section_name", children: "Commands" }),
        /* @__PURE__ */ h("div", { className: "", children: C.map(
          ({ icon: he, text: Qe, link: Re, resultType: pt, description: ze }, lt) => {
            var st, We, Je, ut, Be, Ct, Ye, $e;
            return pt == "action" && /* @__PURE__ */ k(
              "div",
              {
                className: "q_search_res_box " + (lt === b && "q_heilight_search"),
                onClick: () => {
                  window.open(Re, "_blank");
                },
                onMouseEnter: () => q(lt),
                onMouseLeave: () => q(0),
                style: {
                  background: lt === b ? (st = u == null ? void 0 : u.listHover) == null ? void 0 : st.background : "transparent"
                },
                children: [
                  /* @__PURE__ */ h(
                    "img",
                    {
                      className: "q_search_result_icon",
                      src: ((We = t.icons) == null ? void 0 : We.length) && t.icons[lt] || he || Jn,
                      alt: ""
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q_search_result_box", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: lt === b ? ((Je = u == null ? void 0 : u.listHover) == null ? void 0 : Je.Heading) || (H == null ? void 0 : H.primaryColor) || ((ut = u == null ? void 0 : u.Heading) == null ? void 0 : ut.color) || (I == null ? void 0 : I.primaryColor) : ((Be = u == null ? void 0 : u.Heading) == null ? void 0 : Be.color) || (H == null ? void 0 : H.primaryColor) || (I == null ? void 0 : I.primaryColor),
                          ...u == null ? void 0 : u.Heading
                        },
                        className: "q_search_result_head",
                        children: Qe
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: lt === b ? ((Ct = u == null ? void 0 : u.listHover) == null ? void 0 : Ct.Description) || (H == null ? void 0 : H.secondaryColor) || ((Ye = u == null ? void 0 : u.Description) == null ? void 0 : Ye.color) || (I == null ? void 0 : I.secondaryColor) : (($e = u == null ? void 0 : u.Description) == null ? void 0 : $e.color) || (H == null ? void 0 : H.secondaryColor) || (I == null ? void 0 : I.secondaryColor),
                          ...u == null ? void 0 : u.Description
                        },
                        className: "q_search_result_desc",
                        children: ze
                      }
                    )
                  ] })
                ]
              },
              lt
            );
          }
        ) }),
        /* @__PURE__ */ h("div", { className: "q_search_result_section_name", children: "Actions" }),
        /* @__PURE__ */ h("div", { className: "", children: C.map(
          ({ icon: he, text: Qe, link: Re, resultType: pt, description: ze }, lt) => {
            var st, We, Je, ut, Be, Ct, Ye, $e;
            return pt == "command" && /* @__PURE__ */ k(
              "div",
              {
                className: "q_search_res_box " + (lt === b && "q_heilight_search"),
                onClick: () => {
                  window.open(Re, "_blank");
                },
                onMouseEnter: () => q(lt),
                onMouseLeave: () => q(0),
                style: {
                  background: lt === b ? (st = u == null ? void 0 : u.listHover) == null ? void 0 : st.background : "transparent"
                },
                children: [
                  /* @__PURE__ */ h(
                    "img",
                    {
                      src: ((We = t.icons) == null ? void 0 : We.length) && t.icons[lt] || he || Jn,
                      alt: "",
                      className: "q_search_result_icon"
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q_search_result_box", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: lt === b ? ((Je = u == null ? void 0 : u.listHover) == null ? void 0 : Je.Heading) || (H == null ? void 0 : H.primaryColor) || ((ut = u == null ? void 0 : u.Heading) == null ? void 0 : ut.color) || (I == null ? void 0 : I.primaryColor) : ((Be = u == null ? void 0 : u.Heading) == null ? void 0 : Be.color) || (H == null ? void 0 : H.primaryColor) || (I == null ? void 0 : I.primaryColor),
                          ...u == null ? void 0 : u.Heading
                        },
                        className: "q_search_result_head",
                        children: Qe
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: lt === b ? ((Ct = u == null ? void 0 : u.listHover) == null ? void 0 : Ct.Description) || (H == null ? void 0 : H.secondaryColor) || ((Ye = u == null ? void 0 : u.Description) == null ? void 0 : Ye.color) || (I == null ? void 0 : I.secondaryColor) : (($e = u == null ? void 0 : u.Description) == null ? void 0 : $e.color) || (H == null ? void 0 : H.secondaryColor) || (I == null ? void 0 : I.secondaryColor),
                          ...u == null ? void 0 : u.Description
                        },
                        className: "q_search_result_desc",
                        children: ze
                      }
                    )
                  ] })
                ]
              },
              lt
            );
          }
        ) })
      ] }),
      t.searchDetails && /* @__PURE__ */ k("div", { className: "q_search_result_details", children: [
        /* @__PURE__ */ h(
          "img",
          {
            src: ((Se = C[b]) == null ? void 0 : Se.icon) || Jn,
            alt: ""
          }
        ),
        /* @__PURE__ */ h("div", { className: "q_search_details_head", children: (Te = C[b]) == null ? void 0 : Te.text }),
        /* @__PURE__ */ h("div", { className: "q_search_result_desc", children: ((be = C[b]) == null ? void 0 : be.longDescription) || ((He = C[b]) == null ? void 0 : He.description) }),
        t.buttonText && /* @__PURE__ */ h("div", { className: "q_search_result_button1", children: t.buttonText }),
        /* @__PURE__ */ h("div", { className: "q_search_result_button2", children: "Learn more" })
      ] })
    ] }),
    f && /* @__PURE__ */ h(
      Pr,
      {
        style: {
          background: ((Le = (Ge = u == null ? void 0 : u.Footer) == null ? void 0 : Ge.FooterStyle) == null ? void 0 : Le.backgroundColor) || ((Ae = u == null ? void 0 : u.Form) == null ? void 0 : Ae.backgroundColor) || ((Pe = u == null ? void 0 : u.Form) == null ? void 0 : Pe.background) || (H == null ? void 0 : H.background) || (I == null ? void 0 : I.backgroundColor),
          ...(it = u == null ? void 0 : u.Footer) == null ? void 0 : it.FooterStyle
        },
        textStyle: (de = u == null ? void 0 : u.Footer) == null ? void 0 : de.FooterText,
        iconStyle: (xe = u == null ? void 0 : u.Footer) == null ? void 0 : xe.FooterIcon,
        text: g,
        link: m
      }
    )
  ] }), K = t.sections ? R : W;
  return t.open === "ON_CTRL_K_KEY" && B ? e ? /* @__PURE__ */ h(
    "div",
    {
      className: "q_search_bar_screen",
      onClick: (he) => {
        he.target.classList.contains("q_search_bar_screen") && y(!1);
      },
      children: K
    }
  ) : K : t.open !== !0 ? /* @__PURE__ */ h(Ze, {}) : e ? /* @__PURE__ */ h(
    "div",
    {
      onClick: (he) => {
        he.target.classList.contains("q_search_bar_screen") && y(!1);
      },
      className: "q_search_bar_screen",
      children: K
    }
  ) : K;
}
var im;
(function(t) {
  t.START = "start", t.CENTER = "center", t.END = "end";
})(im || (im = {}));
var pA;
(function(t) {
  t.LEFT = "left", t.TOP = "top", t.RIGHT = "right", t.BOTTOM = "bottom";
})(pA || (pA = {}));
var hPe = /* @__PURE__ */ function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, A) {
      n.__proto__ = A;
    } || function(n, A) {
      for (var i in A) Object.prototype.hasOwnProperty.call(A, i) && (n[i] = A[i]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), _l = function() {
  return _l = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var A in e) Object.prototype.hasOwnProperty.call(e, A) && (t[A] = e[A]);
    }
    return t;
  }, _l.apply(this, arguments);
}, pPe = {
  left: [pA.RIGHT, pA.BOTTOM, pA.TOP],
  right: [pA.LEFT, pA.BOTTOM, pA.TOP],
  top: [pA.BOTTOM, pA.LEFT, pA.RIGHT],
  bottom: [pA.TOP, pA.LEFT, pA.RIGHT]
};
function gPe(t) {
  var e = t.children, r = t.onAfterOpen, n = t.onBeforeClose;
  return le(function() {
    return r == null || r(), function() {
      n == null || n();
    };
  }, []), e;
}
var ih = (
  /** @class */
  function(t) {
    hPe(e, t);
    function e(r) {
      var n, A = t.call(this, r) || this;
      return A.renderElement = document.body, A.scrollingElement = document, A.helper = null, A.lastAvailableStepIndex = 0, A.subscribe = /* @__PURE__ */ new Map(), A.state = {
        currentStepIndex: (n = r.startAt) !== null && n !== void 0 ? n : 0,
        previousStepIndex: -1,
        x: 0,
        y: 0,
        height: 0,
        width: 0,
        isScrollingIntoView: !1,
        elementsMap: {}
      }, A.lastAvailableStepIndex = A.state.currentStepIndex, r.renderElement && r.renderElement instanceof HTMLElement && (A.renderElement = r.renderElement), r.scrollingElement && r.scrollingElement instanceof HTMLElement && (A.scrollingElement = r.scrollingElement), A;
    }
    return Object.defineProperty(e.prototype, "currentStepIndex", {
      get: function() {
        var r, n, A = this.state, i = A.elementsMap, o = A.currentStepIndex, s = i[((n = (r = this.props.steps) === null || r === void 0 ? void 0 : r[o]) === null || n === void 0 ? void 0 : n.selector) || ""] || this.props.waitForElementRendered == !1;
        return s ? this.lastAvailableStepIndex = o : this.lastAvailableStepIndex;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "currentStep", {
      get: function() {
        return this.props.steps.length == 0 ? null : this.props.steps[this.currentStepIndex];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "currentElement", {
      get: function() {
        return this.currentStep == null ? null : this.state.elementsMap[this.currentStep.selector] || document.querySelector(this.currentStep.selector);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.componentDidMount = function() {
      this.mount();
    }, e.prototype.componentWillUnmount = function() {
      this.unmount();
    }, e.prototype.componentDidUpdate = function(r, n, A) {
      r.isOpen && this.props.isOpen === !1 && this.unmount(), r.isOpen == !1 && this.props.isOpen && this.mount();
    }, e.prototype.mount = function() {
      var r = this;
      typeof this.props.renderElement == "string" && (this.renderElement = document.querySelector(this.props.renderElement) || document.body), typeof this.props.scrollingElement == "string" && (this.scrollingElement = document.querySelector(this.props.scrollingElement) || document.scrollingElement || document.documentElement), this.props.resizeListener && this.addListener(window, ["resize", this.updateBoundingClientRect.bind(this, void 0)]), this.props.scrollListener && this.addListener(this.scrollingElement, ["scroll", this.updateBoundingClientRect.bind(this, { behavior: "auto" })]), this.mapElements(function() {
        r.updateBoundingClientRect();
      }), this.initMutationObserver();
    }, e.prototype.unmount = function() {
      this.subscribe.forEach(function(r) {
        return r();
      }), this.mutationObserver && this.mutationObserver.disconnect();
    }, e.prototype.addListener = function(r, n) {
      var A = this;
      if (typeof r == "string") {
        var i = document.querySelector(r);
        if (i)
          r = i;
        else
          return;
      }
      var o = r;
      if (this.subscribe.has(o)) {
        var s = this.subscribe.get(o);
        s == null || s();
      }
      var a = function() {
        return o.addEventListener.apply(o, n), A.subscribe.set(o, c), c;
      }, c = function() {
        return o.removeEventListener.apply(o, n), A.subscribe.delete(o), a;
      };
      a();
    }, e.prototype.initMutationObserver = function() {
      var r = this;
      if (this.props.mutationObserve) {
        this.mutationObserver = new MutationObserver(function(i) {
          r.mapElements(function() {
            r.updateBoundingClientRect();
          });
        });
        var n = function(i, o) {
          var s, a = null;
          o = _l({ childList: !0 }, o), typeof i == "string" ? a = document.querySelector(i) : i instanceof HTMLElement && (a = i), a && ((s = r.mutationObserver) === null || s === void 0 || s.observe(a, o));
        }, A = this.props.mutationObserve;
        typeof A == "string" || A instanceof HTMLElement ? n(A) : Array.isArray(A) && A.forEach(function(i) {
          if (typeof i == "string" || i instanceof HTMLElement)
            n(i);
          else if (Array.isArray(i)) {
            var o = i, s = o[0], a = o[1];
            n(s, a);
          }
        });
      }
    }, e.prototype.mapElements = function(r) {
      this.setState({
        elementsMap: this.props.steps.reduce(function(n, A) {
          return n[A.selector] = document.querySelector(A.selector), n;
        }, {})
      }, r);
    }, e.prototype.updateBoundingClientRect = function(r) {
      var n = this, A;
      if (this.currentElement != null) {
        var i = [];
        if (this.props.scrollListener && this.subscribe.has(this.scrollingElement)) {
          var o = this.subscribe.get(this.scrollingElement);
          o && i.push(o);
        }
        var s = function() {
          if (n.currentElement != null) {
            var l = n.currentElement.getBoundingClientRect(), u = l.x, f = l.y, d = l.height, g = l.width;
            n.setState({ x: u, y: f, height: d, width: g, isScrollingIntoView: !1 });
          }
        };
        if (((A = this.currentStep) === null || A === void 0 ? void 0 : A.scrollIntoView) === !1)
          return s();
        var a = function(l, u) {
          l[0].isIntersecting && (n.stopCurrentScrollIntoView(), s(), i.forEach(function(f) {
            return f();
          }), u.disconnect());
        }, c = new IntersectionObserver(a, this.getDynamicIntersectionOption());
        c.observe(this.currentElement), i.forEach(function(l, u) {
          var f = l();
          i[u] = f;
        }), this.setState({ isScrollingIntoView: !0 }), this.currentElement.scrollIntoView({
          behavior: (r == null ? void 0 : r.behavior) || this.props.scrollBehavior,
          block: "nearest",
          inline: "nearest"
        });
      }
    }, e.prototype.stopCurrentScrollIntoView = function() {
      for (var r, n = (r = this.currentElement) === null || r === void 0 ? void 0 : r.parentElement; n; ) {
        var A = n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth;
        A && n.scrollTo({
          top: n.scrollTop,
          left: n.scrollLeft
        }), n = n.parentElement;
      }
    }, e.prototype.getDynamicIntersectionOption = function() {
      var r, n, A;
      if (this.currentElement != null) {
        var i = window.getComputedStyle(this.currentElement), o = parseInt(i.borderTopWidth, 10) || 1, s = parseInt(i.borderRightWidth, 10) || 1, a = parseInt(i.borderBottomWidth, 10) || 1, c = parseInt(i.borderLeftWidth, 10) || 1, l = 1;
        this.currentElement.offsetHeight > window.innerHeight && (l = Math.min(l, window.innerHeight / this.currentElement.offsetHeight)), this.currentElement.offsetWidth > window.innerWidth && (l = Math.min(l, window.innerWidth / this.currentElement.offsetWidth));
        var u = {
          threshold: Math.floor(l),
          rootMargin: "".concat(o, "px ").concat(s, "px ").concat(a, "px ").concat(c, "px")
        }, f;
        return typeof ((r = this.currentStep) === null || r === void 0 ? void 0 : r.intersectionOption) == "function" ? f = (n = this.currentStep) === null || n === void 0 ? void 0 : n.intersectionOption(_l({}, u)) : f = (A = this.currentStep) === null || A === void 0 ? void 0 : A.intersectionOption, f != null && f.rootMargin && (u.rootMargin = f.rootMargin), f != null && f.threshold && (u.threshold = f.threshold), typeof (f == null ? void 0 : f.root) == "string" ? u.root = document.querySelector(f == null ? void 0 : f.root) : f != null && f.root && (u.root = f == null ? void 0 : f.root), u;
      }
    }, e.prototype.getMaskBoundingClientRect = function() {
      var r = this.state, n = r.x, A = r.y, i = r.height, o = r.width, s = this.props.maskPadding, a = s === void 0 ? 0 : s;
      return {
        x: n - a,
        y: A - a,
        height: i + a + a,
        width: o + a + a
      };
    }, e.prototype.getHelperBoundingClientRect = function() {
      var r = this.helper && this.helper.getBoundingClientRect() || { x: 0, y: 0, height: 0, width: 0 };
      return {
        x: r.x,
        y: r.y,
        height: r.height,
        width: r.width
      };
    }, e.prototype.focus = function(r) {
      r === void 0 && (r = "auto"), this.updateBoundingClientRect(r && { behavior: r });
    }, e.prototype.goto = function(r) {
      var n = this, A = Math.max(0, Math.min(r, this.props.steps.length - 1));
      this.setState({ currentStepIndex: A, previousStepIndex: this.state.currentStepIndex }, function() {
        n.updateBoundingClientRect();
        var i = {
          id: n.props.id,
          currentStep: n.currentStep,
          currentStepIndex: n.currentStepIndex,
          previousStepIndex: n.state.previousStepIndex,
          steps: n.props.steps,
          target: n.currentElement,
          focus: n.focus.bind(n),
          goto: n.goto.bind(n),
          next: n.next.bind(n),
          prev: n.prev.bind(n),
          isScrollingIntoView: n.state.isScrollingIntoView,
          onRequestClose: n.props.onRequestClose || null
        };
        n.props.onMove && n.props.onMove(i);
      });
    }, e.prototype.next = function() {
      var r = this, n = Math.min(this.state.currentStepIndex + 1, this.props.steps.length - 1);
      this.setState({ currentStepIndex: n, previousStepIndex: this.state.currentStepIndex }, function() {
        r.updateBoundingClientRect();
        var A = {
          id: r.props.id,
          currentStep: r.currentStep,
          currentStepIndex: r.currentStepIndex,
          previousStepIndex: r.state.previousStepIndex,
          steps: r.props.steps,
          target: r.currentElement,
          focus: r.focus.bind(r),
          goto: r.goto.bind(r),
          next: r.next.bind(r),
          prev: r.prev.bind(r),
          isScrollingIntoView: r.state.isScrollingIntoView,
          onRequestClose: r.props.onRequestClose || null
        };
        r.props.onNext && r.props.onNext(A), r.props.onMove && r.props.onMove(A);
      });
    }, e.prototype.prev = function() {
      var r = this, n = Math.max(this.state.currentStepIndex - 1, 0);
      this.setState({ currentStepIndex: n, previousStepIndex: this.state.currentStepIndex }, function() {
        r.updateBoundingClientRect();
        var A = {
          id: r.props.id,
          currentStep: r.currentStep,
          currentStepIndex: r.currentStepIndex,
          previousStepIndex: r.state.previousStepIndex,
          steps: r.props.steps,
          target: r.currentElement,
          focus: r.focus.bind(r),
          goto: r.goto.bind(r),
          next: r.next.bind(r),
          prev: r.prev.bind(r),
          isScrollingIntoView: r.state.isScrollingIntoView,
          onRequestClose: r.props.onRequestClose || null
        };
        r.props.onPrev && r.props.onPrev(A), r.props.onMove && r.props.onMove(A);
      });
    }, e.prototype.renderOverLay = function() {
      var r = this, n = this.getMaskBoundingClientRect(), A = n.x, i = n.y, o = n.height, s = n.width, a = function(c) {
        c != null && (c.onclick = function(l) {
          var u, f, d = l.x >= A && l.x <= A + s && l.y >= i && l.y <= i + o;
          (f = (u = r.props).onRequestClose) === null || f === void 0 || f.call(u, { event: l, isMask: d, isOverlay: !0 });
        });
      };
      return h("div", { className: "__tourNavigator-overlay", ref: a, children: this.props.overlay ? this.props.overlay({ x: A, y: i, height: o, width: s, isScrollingIntoView: this.state.isScrollingIntoView }) : k("svg", { height: "100%", width: "100%", children: [h("defs", { children: k("mask", { id: "__tourNavigator-mask-".concat(this.props.id), children: [h("rect", { x: 0, y: 0, height: "100%", width: "100%", fill: "white" }), h("rect", { x: A, y: i, height: o, width: s, fill: "black", rx: this.props.maskRadius, opacity: this.props.maskOpacity, style: _l(_l({}, this.props.maskStyle), this.state.isScrollingIntoView ? this.props.maskStyleDuringScroll : void 0) })] }) }), h("rect", { x: 0, y: 0, height: "100%", width: "100%", fill: this.props.overlayFill, opacity: this.props.overlayOpacity, mask: "url(#__tourNavigator-mask-".concat(this.props.id, ")") })] }) });
    }, e.prototype.renderHelper = function() {
      var r = this, n = this.currentStepIndex, A = this.props.helper;
      if (!A)
        return null;
      var i = function(o) {
        if (!((r.helper = o) == null || r.currentStep == null)) {
          var s = r.getMaskBoundingClientRect(), a = r.getHelperBoundingClientRect(), c = r.props, l = c.maskHelperDistance, u = l === void 0 ? 0 : l, f = c.screenHelperDistance, d = f === void 0 ? 0 : f, g = u + d, m = {
            left: s.x >= a.width + g,
            right: window.innerWidth - (s.x + s.width) >= a.width + g,
            top: s.y >= a.height + g,
            bottom: window.innerHeight - (s.y + s.height) >= a.height + g
          }, p = r.currentStep.position || pA.LEFT, v = r.currentStep.align || im.START;
          Array.isArray(p) ? p = p.find(function(B) {
            return m[B];
          }) || pA.LEFT : p = (m[p] ? p : pPe[p].find(function(B) {
            return m[B];
          })) || pA.LEFT;
          var C = 0, w = 0;
          p == "top" && (C = s.x, w = s.y - a.height - u), p == "bottom" && (C = s.x, w = s.y + s.height + u), p == "left" && (C = s.x - a.width - u, w = s.y), p == "right" && (C = s.x + s.width + u, w = s.y), (p == "left" || p == "right") && (v == "end" && (w = w + s.height - a.height), v == "center" && (w = w + s.height / 2 - a.height / 2)), (p == "top" || p == "bottom") && (v == "end" && (C = C + s.width - a.width), v == "center" && (C = C + s.width / 2 - a.width / 2)), C = Math.max(d, Math.min(window.innerWidth - a.width - d, C)), w = Math.max(d, Math.min(window.innerHeight - a.height - d, w)), r.helper.dataset.position = p.toLowerCase(), r.helper.dataset.align = v.toString().toLowerCase(), r.helper.style.setProperty("--x", String(C)), r.helper.style.setProperty("--y", String(w));
        }
      };
      return h("div", { className: "__tourNavigator-helper", ref: i, children: A({
        id: this.props.id,
        currentStep: this.currentStep,
        currentStepIndex: n,
        previousStepIndex: this.state.previousStepIndex,
        steps: this.props.steps,
        target: this.currentElement,
        focus: this.focus.bind(this),
        goto: this.goto.bind(this),
        next: this.next.bind(this),
        prev: this.prev.bind(this),
        isScrollingIntoView: this.state.isScrollingIntoView,
        onRequestClose: this.props.onRequestClose || null
      }) });
    }, e.prototype.render = function() {
      return this.props.isOpen ? gd.createPortal(h(gPe, { onAfterOpen: this.props.onAfterOpen, onBeforeClose: this.props.onBeforeClose, children: k("div", { className: "__tourNavigator ".concat(this.props.className), style: this.props.style, children: [this.props.renderOverlay && this.renderOverLay(), this.props.renderHelper && this.renderHelper()] }) }), this.renderElement) : null;
    }, e.defaultProps = {
      id: "___tournavigator-".concat(Date.now()),
      steps: [],
      maskRadius: 5,
      maskPadding: 5,
      startAt: 0,
      maskHelperDistance: 10,
      screenHelperDistance: 10,
      onAfterOpen: null,
      onBeforeClose: null,
      helper: null,
      isOpen: !0,
      onRequestClose: null,
      onNext: null,
      onPrev: null,
      scrollBehavior: "smooth",
      resizeListener: !0,
      scrollListener: !0,
      overlayFill: "black",
      overlayOpacity: 0.5,
      maskOpacity: 1,
      overlay: null,
      className: "",
      renderHelper: !0,
      renderOverlay: !0,
      renderElement: document.body,
      scrollingElement: document,
      waitForElementRendered: !1
    }, e;
  }(es)
), om = function() {
  return om = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var A in e) Object.prototype.hasOwnProperty.call(e, A) && (t[A] = e[A]);
    }
    return t;
  }, om.apply(this, arguments);
}, mPe = function(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var A = 0, n = Object.getOwnPropertySymbols(t); A < n.length; A++)
      e.indexOf(n[A]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[A]) && (r[n[A]] = t[n[A]]);
  return r;
}, oh = function(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, A = e.length, i; n < A; n++)
    (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return t.concat(i || Array.prototype.slice.call(e));
}, vPe = ol(function(t, e) {
  var r = t.id, n = r === void 0 ? ih.defaultProps.id : r, A = t.steps, i = t.startAt, o = i === void 0 ? ih.defaultProps.startAt || 0 : i, s = t.nextStepCount, a = s === void 0 ? 0 : s, c = t.nextStepRoute, l = t.number, u = t.state, f = t.onNavigate, d = mPe(t, ["id", "steps", "startAt", "nextStepCount", "nextStepRoute", "number", "state", "onNavigate"]), g = gt(null), m = window.location.pathname, p = window.location.search, v = u || [], C = v[v.length - 1], w = l == null ? v.length - ((C == null ? void 0 : C.id) == n ? 1 : 0) : l - 1, B = w - 1, y = v == null ? void 0 : v[B], b = v == null ? void 0 : v[w];
  (b == null ? void 0 : b.id) != n && (b = {
    id: n,
    focusAt: ((y == null ? void 0 : y.previousStepCount) + (y == null ? void 0 : y.stepCount) || 0) + o,
    stepRoute: m + p,
    stepCount: A.length,
    previousStepCount: (y == null ? void 0 : y.previousStepCount) + (y == null ? void 0 : y.stepCount) || 0,
    previousStepRoute: (y == null ? void 0 : y.stepRoute) || null
  });
  var q = MA(function() {
    return oh(oh(oh([], Array(b.previousStepCount).fill(A[0]), !0), A, !0), Array(a).fill(A[A.length - 1]), !0);
  }, [A]), E = function(M) {
    var O, I = b.previousStepCount + b.stepCount, S = M.currentStepIndex == I;
    if (c && S) {
      var P = oh([], v, !0);
      (C == null ? void 0 : C.id) != n && P.push(b), f == null || f(c, P);
    } else
      b.focusAt = M.currentStepIndex, (O = d.onNext) === null || O === void 0 || O.call(d, M);
  }, x = function(M) {
    var O, I = M.currentStepIndex == b.previousStepCount - 1;
    y && I ? f == null || f(b.previousStepRoute, v.filter(function(S) {
      return S.id != n;
    })) : (b.focusAt = M.currentStepIndex, (O = d.onPrev) === null || O === void 0 || O.call(d, M));
  };
  return fm(e, function() {
    return {
      get id() {
        var M, O;
        return (O = (M = g.current) === null || M === void 0 ? void 0 : M.props.id) !== null && O !== void 0 ? O : "";
      },
      get currentStep() {
        var M, O;
        return (O = (M = g.current) === null || M === void 0 ? void 0 : M.currentStep) !== null && O !== void 0 ? O : null;
      },
      get target() {
        var M, O;
        return (O = (M = g.current) === null || M === void 0 ? void 0 : M.currentElement) !== null && O !== void 0 ? O : null;
      },
      get currentStepIndex() {
        var M, O;
        return (O = (M = g.current) === null || M === void 0 ? void 0 : M.currentStepIndex) !== null && O !== void 0 ? O : 0;
      },
      get previousStepIndex() {
        var M, O;
        return (O = (M = g.current) === null || M === void 0 ? void 0 : M.state.previousStepIndex) !== null && O !== void 0 ? O : -1;
      },
      get steps() {
        var M, O, I;
        return (I = (O = (M = g.current) === null || M === void 0 ? void 0 : M.props.steps) !== null && O !== void 0 ? O : ih.defaultProps.steps) !== null && I !== void 0 ? I : null;
      },
      get isScrollingIntoView() {
        var M, O;
        return (O = (M = g.current) === null || M === void 0 ? void 0 : M.state.isScrollingIntoView) !== null && O !== void 0 ? O : !1;
      },
      focus: function(M) {
        var O;
        return M === void 0 && (M = "auto"), (O = g.current) === null || O === void 0 ? void 0 : O.focus(M);
      },
      goto: function(M) {
        var O;
        return (O = g.current) === null || O === void 0 ? void 0 : O.goto(M);
      },
      next: function() {
        var M;
        return (M = g.current) === null || M === void 0 ? void 0 : M.next();
      },
      prev: function() {
        var M;
        return (M = g.current) === null || M === void 0 ? void 0 : M.prev();
      },
      onRequestClose: function(M) {
        var O, I, S;
        return (S = (O = g.current) === null || O === void 0 ? void 0 : (I = O.props).onRequestClose) === null || S === void 0 ? void 0 : S.call(I, M);
      }
    };
  }, [g]), w != 0 && !y ? null : h(ih, om({}, d, { id: n, steps: q, startAt: b.focusAt, onNext: E, onPrev: x, ref: g }));
});
function qPe({
  hideArrow: t,
  arrowStyle: e,
  helperStyle: r,
  helperBackgroundStyle: n,
  firstButtonStyle: A,
  lastButtonStyle: i,
  headerStyle: o,
  descriptionStyle: s,
  footerStyle: a,
  imgStyle: c,
  onComplete: l,
  firstButtonText: u,
  lastButtonText: f,
  handleFirstButtonClick: d,
  handleLastButtonClick: g,
  currentStep: m,
  onRequestClose: p,
  prev: v,
  next: C,
  currentStepIndex: w,
  steps: B,
  finalButtonText: y,
  footerText: b,
  footerLink: q,
  ...E
}) {
  var F, T;
  const x = {
    currentStep: m,
    onRequestClose: p,
    next: C,
    prev: v,
    currentStepIndex: w,
    steps: B,
    ...E
  }, M = w === 0;
  let O = !1;
  B && B.length > 0 && (O = w === B.length - 1);
  const I = () => {
    if (O) return l == null ? void 0 : l();
    C();
  }, S = u && typeof u == "function" ? u(w) : u, P = f && typeof f == "function" ? f(w) : f, H = y && typeof y == "function" ? y(w) : y;
  return /* @__PURE__ */ k(
    "div",
    {
      className: "tour-helper",
      style: {
        ...r
      },
      children: [
        t ? null : /* @__PURE__ */ h("div", { className: "tour-helper-pointer", style: e }),
        /* @__PURE__ */ k("div", { className: "tour-image", children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: "tour-background",
              style: {
                ...n
              },
              children: [
                /* @__PURE__ */ h("div", {}),
                /* @__PURE__ */ h("div", {}),
                /* @__PURE__ */ h("div", {})
              ]
            }
          ),
          (F = m == null ? void 0 : m.data) != null && F.image ? /* @__PURE__ */ h("img", { src: (T = m.data) == null ? void 0 : T.image, style: c }) : null,
          /* @__PURE__ */ h("div", { className: "tour-back-btn", onClick: v, children: /* @__PURE__ */ h(
            "svg",
            {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ h(
                "path",
                {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M7.02018 3.64645C7.21544 3.84171 7.21544 4.15829 7.02018 4.35355L3.87373 7.5H13.3333C13.6094 7.5 13.8333 7.72386 13.8333 8C13.8333 8.27614 13.6094 8.5 13.3333 8.5H3.87373L7.02018 11.6464C7.21544 11.8417 7.21544 12.1583 7.02018 12.3536C6.82492 12.5488 6.50833 12.5488 6.31307 12.3536L2.31307 8.35355C2.11781 8.15829 2.11781 7.84171 2.31307 7.64645L6.31307 3.64645C6.50833 3.45118 6.82492 3.45118 7.02018 3.64645Z",
                  fill: "#939393"
                }
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ k("div", { className: "tour-content", children: [
          /* @__PURE__ */ h("div", { className: "tour-content-info", children: /* @__PURE__ */ k("small", { children: [
            w + 1,
            "/",
            B == null ? void 0 : B.length
          ] }) }),
          /* @__PURE__ */ h(
            "h3",
            {
              className: "tour-content-title",
              style: {
                ...o
              },
              children: m == null ? void 0 : m.data.title
            }
          ),
          /* @__PURE__ */ h(
            "p",
            {
              className: "tour-content-description",
              style: {
                ...s
              },
              children: m == null ? void 0 : m.data.description
            }
          ),
          /* @__PURE__ */ k("div", { className: "tour-content-actions", children: [
            M ? null : /* @__PURE__ */ h(
              "button",
              {
                onClick: () => d ? d(x) : v(),
                style: { ...A },
                children: /* @__PURE__ */ h("span", { children: S || "Back" })
              }
            ),
            /* @__PURE__ */ h(
              "button",
              {
                onClick: () => g ? g(x) : I(),
                className: "tour-helper-button",
                style: { ...i },
                children: /* @__PURE__ */ h("span", { children: O ? H || "Get Started" : P || "Next" })
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ k("div", { className: "tour-watermark", style: a, onClick: () => window.open(q || "https://www.plgos.com/", "_blank"), children: [
          /* @__PURE__ */ h("small", { children: b || "Powered by PLG OS" }),
          /* @__PURE__ */ k(
            "svg",
            {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ h(
                  "path",
                  {
                    d: "M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z",
                    fill: "#B9B9B9"
                  }
                ),
                /* @__PURE__ */ h("path", { d: "M12 8L8 8L8 12H12V8Z", fill: "#B9B9B9" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function yPe({
  hideArrow: t,
  arrowStyle: e,
  helperStyle: r,
  helperBackgroundStyle: n,
  firstButtonStyle: A,
  lastButtonStyle: i,
  headerStyle: o,
  descriptionStyle: s,
  onComplete: a,
  firstButtonText: c,
  lastButtonText: l,
  handleFirstButtonClick: u,
  handleLastButtonClick: f,
  currentStep: d,
  onRequestClose: g,
  next: m,
  currentStepIndex: p,
  steps: v,
  finalButtonText: C,
  footerText: w,
  footerLink: B,
  ...y
}) {
  var I, S;
  const b = {
    currentStep: d,
    onRequestClose: g,
    next: m,
    currentStepIndex: p,
    steps: v,
    ...y
  };
  let q = !1;
  v && v.length > 0 && (q = p === v.length - 1);
  const E = () => {
    if (q) return a == null ? void 0 : a();
    m();
  }, x = c && typeof c == "function" ? c(p) : c, M = l && typeof l == "function" ? l(p) : l, O = C && typeof C == "function" ? C(p) : C;
  return /* @__PURE__ */ k("div", { className: "tour-helper-tooltip", children: [
    t ? null : /* @__PURE__ */ h("div", { className: "tour-helper-pointer", style: e }),
    /* @__PURE__ */ k(
      "div",
      {
        className: "tour-helper-content",
        style: { ...n, ...r },
        children: [
          /* @__PURE__ */ k("div", { className: "tour-helper-tooltip-details", children: [
            /* @__PURE__ */ h("h1", { style: o, children: (I = d == null ? void 0 : d.data) == null ? void 0 : I.title }),
            /* @__PURE__ */ h("p", { style: s, children: (S = d == null ? void 0 : d.data) == null ? void 0 : S.description })
          ] }),
          /* @__PURE__ */ k("div", { className: "tour-helper-tooltip-button", children: [
            !q && /* @__PURE__ */ h(
              "button",
              {
                className: "tour-helper-button transparent",
                style: A,
                onClick: (P) => u ? u(b) : g == null ? void 0 : g({
                  event: P,
                  isMask: !1,
                  isOverlay: !1
                }),
                children: /* @__PURE__ */ h("span", { children: x || "Skip" })
              }
            ),
            /* @__PURE__ */ h(
              "button",
              {
                className: "tour-helper-button outline",
                style: i,
                onClick: () => f ? f(b) : E(),
                children: /* @__PURE__ */ h("span", { children: q ? O || "Get Started" : M || "Next" })
              }
            )
          ] })
        ]
      }
    )
  ] });
}
function CPe({
  id: t,
  x: e,
  y: r,
  height: n,
  width: A,
  style: i,
  maskRadius: o = 5,
  maskOpacity: s = 1,
  maskStyle: a,
  overlayFill: c = "black",
  overlayOpacity: l = 0.5,
  highlightStyle: u,
  highlightOpacity: f = 1,
  highlightStroke: d = "var(--borderColor, #9035FF)",
  highlightStrokeWidth: g = 1,
  highlightStrokeDasharray: m
}) {
  return /* @__PURE__ */ k("svg", { height: "100%", width: "100%", children: [
    /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ k("mask", { id: t, children: [
      /* @__PURE__ */ h("rect", { x: 0, y: 0, height: "100%", width: "100%", fill: "white" }),
      /* @__PURE__ */ h(
        "rect",
        {
          x: e,
          y: r,
          height: n,
          width: A,
          fill: "black",
          rx: o,
          opacity: s,
          style: a
        }
      )
    ] }) }),
    /* @__PURE__ */ h(
      "rect",
      {
        x: e,
        y: r,
        height: n,
        width: A,
        stroke: d,
        strokeWidth: g,
        strokeDasharray: m,
        fill: "none",
        rx: o,
        opacity: f,
        style: u
      }
    ),
    /* @__PURE__ */ h(
      "rect",
      {
        x: 0,
        y: 0,
        height: "100%",
        width: "100%",
        fill: c,
        opacity: l,
        mask: `url(#${t})`,
        style: i
      }
    )
  ] });
}
const wPe = async ({
  userId: t,
  token: e,
  entityId: r,
  apiKey: n,
  campaignId: A,
  variation: i = "",
  BACKEND_URL: o
}) => {
  const s = {
    apiKey: n,
    userId: t,
    token: e
  }, a = new URLSearchParams({
    platform: "REACT",
    variation: i
  }), c = `${o}api/v2/entities/${r}/campaigns/${A}?${a.toString()}`;
  try {
    const l = await Oe.get(c, {
      headers: s
    });
    return l.data.success ? l.data : (console.error(
      "API returned an error:",
      l.data.message || "Unknown error"
    ), null);
  } catch (l) {
    return console.error("Error fetching quest data:", l), null;
  }
}, bPe = async ({
  entityId: t,
  apiKey: e,
  uniqueUserId: r,
  uniqueEmailId: n,
  userId: A,
  token: i,
  apiType: o
}) => {
  const s = new zn(), a = s.get("externalUserId"), c = s.get("questUserId"), l = s.get("questUserToken");
  let u = o == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  if (!t)
    return console.error("Entity ID is required."), null;
  const f = {
    apiKey: e,
    ...i && { token: i },
    ...A && { userId: A }
  }, d = {
    externalUserId: r || null,
    entityId: t,
    email: n || null
  };
  if (a && c && l && (a == r || a == n))
    return { userId: c, token: l };
  if (r)
    try {
      const g = await Oe.post(
        `${u}api/users/external/login`,
        d,
        { headers: f }
      ), { userId: m, token: p } = g.data, v = /* @__PURE__ */ new Date();
      return v.setHours(v.getHours() + 12), s.set("externalUserId", r, { path: "/", expires: v }), s.set("questUserId", m, { path: "/", expires: v }), s.set("questUserToken", p, { path: "/", expires: v }), { token: p, userId: m };
    } catch (g) {
      return console.error("Error during external login:", g), null;
    }
  return null;
}, BPe = async ({
  userId: t,
  token: e,
  entityId: r,
  apiKey: n,
  campaignId: A,
  BACKEND_URL: i,
  data: o
}) => {
  const s = {
    apiKey: n,
    userId: t,
    token: e
  }, a = `${i}api/v2/entities/${r}/campaigns/${A}/verify`;
  try {
    const c = await Oe.post(a, o, {
      headers: s
    });
    return c.data.success ? c.data : (console.error(
      "API returned an error:",
      c.data.message || "Unknown error"
    ), null);
  } catch (c) {
    return console.error("Error claiming campaign:", c), null;
  }
}, IFe = ol(
  ({
    tooltip: t,
    onComplete: e,
    hideArrow: r,
    styleConfig: n,
    firstButtonText: A,
    lastButtonText: i,
    handleFirstButtonClick: o,
    handleLastButtonClick: s,
    maskRadius: a = 5,
    maskOpacity: c = 1,
    maskStyle: l,
    overlayFill: u,
    overlayOpacity: f,
    maskStyleDuringScroll: d,
    highlightStyle: g,
    highlightOpacity: m,
    highlightStroke: p,
    highlightStrokeWidth: v,
    highlightStrokeDasharray: C,
    steps: w,
    isOnline: B = !1,
    variation: y = "DEFAULT",
    campaignId: b,
    userId: q,
    token: E,
    uniqueEmailId: x,
    uniqueUserId: M,
    finalButtonText: O,
    footerText: I,
    footerLink: S,
    ...P
  }, H) => {
    var te, ae;
    const { themeConfig: F, entityId: T, apiType: U, apiKey: D } = Xe(
      ct.Context
    ), [Q, Y] = N(!!(B && b)), [j, Z] = N(null), [W, R] = N(q || ""), [K, L] = N(E || ""), G = MA(() => {
      var se;
      return j ? (se = j.actions) == null ? void 0 : se.map((ue) => {
        var fe, ve, ge, oe;
        return {
          selector: (fe = ue == null ? void 0 : ue.metadata) == null ? void 0 : fe.link,
          data: {
            title: ue == null ? void 0 : ue.title,
            description: ue == null ? void 0 : ue.description,
            image: (ve = ue == null ? void 0 : ue.metadata) == null ? void 0 : ve.imageUrl,
            actionId: ue == null ? void 0 : ue.actionId
          },
          position: (ge = ue == null ? void 0 : ue.metadata) == null ? void 0 : ge.position,
          align: (oe = ue == null ? void 0 : ue.metadata) == null ? void 0 : oe.align
        };
      }) : w || [];
    }, [w, j]), V = t ?? (((ae = (te = j == null ? void 0 : j.sdkConfig) == null ? void 0 : te.uiProps) == null ? void 0 : ae.tooltip) || !1), _ = {
      "--background": F == null ? void 0 : F.backgroundColor,
      "--primaryColor": F == null ? void 0 : F.primaryColor,
      "--borderColor": F == null ? void 0 : F.borderColor,
      "--buttonColor": F == null ? void 0 : F.buttonColor,
      "--fontFamily": F == null ? void 0 : F.fontFamily,
      "--secondaryColor": F == null ? void 0 : F.secondaryColor
    };
    let J = U == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
    async function X() {
      let se = W, ue = K;
      if (b) {
        if (x || M) {
          const ve = await bPe({
            uniqueEmailId: x,
            uniqueUserId: M,
            entityId: T,
            apiKey: D,
            token: E,
            userId: q,
            apiType: U
          });
          ve != null && ve.userId && (se = ve.userId, ue = ve.token, R(() => se), L(() => ue));
        }
        const fe = await wPe({
          userId: se,
          token: ue,
          entityId: T,
          apiKey: D,
          campaignId: b,
          variation: y,
          BACKEND_URL: J
        });
        fe != null && fe.success && Z(fe.data);
      }
    }
    le(() => {
      B && b && X().finally(() => Y(!1));
    }, [B]);
    const ne = async () => {
      e == null || e(), Z(j && { ...j, isClaimed: !0 });
      try {
        if (B && b && K && W) {
          const se = {
            actions: G.map((ue) => {
              var fe;
              return {
                actionId: (fe = ue.data) == null ? void 0 : fe.actionId,
                answers: [!0]
              };
            }),
            campaignVariationId: j == null ? void 0 : j.campaignVariationId
          };
          await BPe({
            apiKey: D,
            BACKEND_URL: J,
            campaignId: b,
            entityId: T,
            token: K,
            userId: W,
            data: se
          });
        }
      } catch (se) {
        console.error(se);
      }
    }, ee = (se) => /* @__PURE__ */ h(
      CPe,
      {
        id: P.id || "",
        maskOpacity: c,
        maskRadius: a,
        maskStyle: d || l,
        overlayFill: u,
        overlayOpacity: f,
        highlightOpacity: m,
        highlightStroke: p,
        highlightStrokeWidth: v,
        highlightStrokeDasharray: C,
        style: n == null ? void 0 : n.Overlay,
        ...se
      }
    ), $ = (se) => /* @__PURE__ */ h(
      V ? yPe : qPe,
      {
        ...se,
        helperStyle: {
          ..._,
          ...n == null ? void 0 : n.Form
        },
        hideArrow: r,
        arrowStyle: n == null ? void 0 : n.Arrow,
        headerStyle: n == null ? void 0 : n.Heading,
        descriptionStyle: n == null ? void 0 : n.Description,
        helperBackgroundStyle: n == null ? void 0 : n.Background,
        footerStyle: n == null ? void 0 : n.Footer,
        footerText: I,
        footerLink: S,
        firstButtonStyle: n == null ? void 0 : n.FirstButton,
        lastButtonStyle: n == null ? void 0 : n.LastButton,
        imgStyle: n == null ? void 0 : n.Image,
        onComplete: ne,
        finalButtonText: O,
        firstButtonText: A,
        lastButtonText: i,
        handleFirstButtonClick: o,
        handleLastButtonClick: s
      }
    );
    return Q || j != null && j.isClaimed ? null : /* @__PURE__ */ h(
      vPe,
      {
        ...P,
        ref: H,
        helper: $,
        overlay: ee,
        steps: G
      }
    );
  }
), DN = "data:image/svg+xml,%3csvg%20width='15'%20height='12'%20viewBox='0%200%2015%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.15079%200.623706C7.81253%200.0950405%207.03949%200.0972083%206.70421%200.627764L0.0474338%2011.1614L3.75672%209.88906L7.41495%209.42633L11.0689%209.88906L14.9526%2011.2544L8.15079%200.623706Z'%20fill='white'/%3e%3c/svg%3e", Gc = "data:image/svg+xml,%3csvg%20width='19'%20height='16'%20viewBox='0%200%2021%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.2725%209.216H14.2145V12.8H12.2615V3H16.2585C18.5965%203%2019.8425%204.218%2019.8425%206.115C19.8425%207.998%2018.5965%209.216%2016.2725%209.216ZM16.2235%204.799H14.2145V7.431H16.2235C17.2875%207.431%2017.8405%206.997%2017.8405%206.115C17.8405%205.24%2017.2875%204.799%2016.2235%204.799Z'%20fill='%23050505'/%3e%3cpath%20d='M10.8442%203L7.5822%207.823L10.9352%2012.8H8.6462L6.3922%209.307L4.1312%2012.8H1.8772L5.2232%207.823L1.9682%203H4.2642L6.4202%206.36L8.5902%203H10.8442Z'%20fill='%23050505'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.2145%2013.8H11.2615V2H16.2585C17.5925%202%2018.755%202.34821%2019.595%203.10176C20.4488%203.86773%2020.8425%204.93888%2020.8425%206.115C20.8425%207.2861%2020.4476%208.35297%2019.5966%209.1161C18.7593%209.86705%2017.6009%2010.216%2016.2725%2010.216H15.2145V13.8ZM14.2145%209.216H16.2725C18.5965%209.216%2019.8425%207.998%2019.8425%206.115C19.8425%204.218%2018.5965%203%2016.2585%203H12.2615V12.8H14.2145V9.216ZM14.2145%204.799H16.2235C17.2875%204.799%2017.8405%205.24%2017.8405%206.115C17.8405%206.997%2017.2875%207.431%2016.2235%207.431H14.2145V4.799ZM15.2145%206.431H16.2235C16.6448%206.431%2016.7837%206.34106%2016.8032%206.32534C16.8036%206.32506%2016.8039%206.3248%2016.8042%206.32455C16.8071%206.32229%2016.8091%206.32076%2016.814%206.30889C16.8219%206.28989%2016.8405%206.2326%2016.8405%206.115C16.8405%206.00015%2016.8223%205.94379%2016.8143%205.92472C16.809%205.91191%2016.8065%205.90995%2016.8024%205.90664C16.7818%205.88991%2016.6414%205.799%2016.2235%205.799H15.2145V6.431Z'%20fill='%2310F48B'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.7279%202L8.78878%207.8241L12.8147%2013.8H8.10144L6.39097%2011.1493L4.67519%2013.8H0L4.01757%207.82408L0.0869497%202H4.81077L6.42299%204.51256L8.04569%202H12.7279ZM6.42027%206.36L4.26427%203H1.96827L5.22327%207.823L1.87727%2012.8H4.13127L6.39227%209.307L8.64627%2012.8H10.9353L7.58227%207.823L10.8443%203H8.59027L6.42027%206.36Z'%20fill='%2310F48B'/%3e%3c/svg%3e", QN = "data:image/png;base64,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", UN = () => /* @__PURE__ */ h("div", { className: "questLabs quest-loader", children: /* @__PURE__ */ k(
  "div",
  {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50
    },
    children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: { position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }
        }
      ),
      /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "inline-block",
            width: "3rem",
            height: "3rem",
            animation: "spin 1.5s linear infinite",
            border: "0.25rem solid currentColor",
            borderRight: "0.25rem solid transparent",
            borderRadius: "50%",
            transform: "translateZ(0)",
            position: "relative"
          },
          children: /* @__PURE__ */ h(
            "div",
            {
              style: {
                position: "absolute",
                width: "0",
                height: "0",
                overflow: "hidden",
                whiteSpace: "nowrap",
                border: "0",
                padding: "0",
                clip: "rect(0,0,0,0)",
                display: "inline"
              },
              children: "Loading..."
            }
          )
        }
      ) })
    ]
  }
) }), Ta = "data:image/svg+xml,%3csvg%20width='15'%20height='15'%20viewBox='0%200%2015%2015'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20x='0.54541'%20y='0.227539'%20width='14'%20height='14'%20fill='url(%23pattern0_5137_488)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_5137_488'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_5137_488'%20transform='scale(0.00195312)'/%3e%3c/pattern%3e%3cimage%20id='image0_5137_488'%20width='512'%20height='512'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", SFe = ({
  maxSpins: t,
  rewards: e,
  wheelColors: r,
  wheelImage: n,
  winningIndex: A,
  userId: i,
  token: o,
  uniqueEmailId: s,
  uniqueUserId: a,
  questId: c,
  criteriaId: l,
  campaignId: u,
  campaignVariationId: f,
  actionId: d,
  onSpinComplete: g,
  successCall: m,
  isAccumulateXP: p = !1,
  isImgShow: v,
  styleConfig: C,
  claimButtonText: w,
  wheelTextColor: B,
  winningSegmentColor: y,
  spinText: b,
  spinCenteredText: q,
  isSecondaryImage: E,
  onGuestUserClick: x,
  onCompletedCriteriaUserClick: M,
  isClaimTitle: O,
  isLoader: I,
  isPoint: S,
  loaderComponent: P,
  isV1API: H
}) => {
  var Je, ut, Be, Ct, Ye, $e, nt, mt, me, yt, Ue;
  const { apiKey: F, apiSecret: T, entityId: U, apiType: D } = Xe(ct.Context), [Q, Y] = N(0), j = gt(null), [Z, W] = N(0), [R, K] = N(!1), [L, G] = N(S ? Ta : Gc), [V, _] = N("1"), [J, X] = N(""), [ne, ee] = N(
    null
  );
  let $ = D == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, te = new Bt("");
  const [ae, se] = N(!1), [ue, fe] = N(!0), [ve, ge] = N(e || Array(10).fill({ title: "" })), [oe, ce] = N(!1), [pe, qe] = N(i), [Se, Te] = N(o), [be, He] = N(!1), [Ge, Le] = N([]), [Ae, Pe] = N(null), [it, de] = N(f), [xe, he] = N(d), Qe = async () => {
    var Ie, ot, Ke, tt, Ot, Vt, Mt, lr, Lr;
    try {
      const Et = {
        apiKey: F,
        apisecret: T,
        userId: pe,
        token: Se,
        userid: pe
      }, Qt = H === !1 ? `${$}api/v2/entities/${U}/campaigns/${u}?platform=REACT` : `${$}api/entities/${U}/quests/${c}`, Er = await Oe.get(Qt, { headers: Et });
      let kt = H == !1 ? Er.data.data : Er.data;
      Pe(kt), H === !1 && (Le((St) => St = kt.actions), it === void 0 && de((St) => St = kt == null ? void 0 : kt.campaignVariationId), xe === void 0 && he((St) => {
        var jr;
        return St = (jr = kt == null ? void 0 : kt.actions[0]) == null ? void 0 : jr.actionId;
      })), (H === !1 && (((Ie = kt.actions[0]) == null ? void 0 : Ie.actionType) !== "SPIN_THE_WHEEL" || // questDetails?.actions[0]?.actionId !== actionId ||
      (ot = kt == null ? void 0 : kt.actions[0]) != null && ot.hasOwnProperty("completed") && ((Ke = kt == null ? void 0 : kt.actions[0]) == null ? void 0 : Ke.completed) !== !1) || H != !1 && (((tt = kt.eligibilityData) == null ? void 0 : tt.length) !== 1 || ((Vt = (Ot = kt.eligibilityData[0]) == null ? void 0 : Ot.data) == null ? void 0 : Vt.criteriaType) !== "SPIN_THE_WHEEL" || ((lr = (Mt = kt == null ? void 0 : kt.eligibilityData[0]) == null ? void 0 : Mt.data) == null ? void 0 : lr.criteriaId) !== l || ((Lr = kt == null ? void 0 : kt.eligibilityData[0]) == null ? void 0 : Lr.completed) !== !1)) && ce(!0);
      let en = kt.rewards.map((St) => {
        var cn, ln, un, dn, fn, hn;
        const jr = (St == null ? void 0 : St.rewardType) === "REWARD_XP";
        return {
          title: jr ? S ? "Points" : "XP" : ((cn = St == null ? void 0 : St.metadata) == null ? void 0 : cn.name) || ((ln = St == null ? void 0 : St.metadata) == null ? void 0 : ln.title),
          value: jr ? ((un = St == null ? void 0 : St.metadata) == null ? void 0 : un.xp) || (St == null ? void 0 : St.xp) : (dn = St == null ? void 0 : St.metadata) == null ? void 0 : dn.gemsData,
          image: jr ? S ? Ta : Gc : ((fn = St == null ? void 0 : St.metadata) == null ? void 0 : fn.logo) || ((hn = St == null ? void 0 : St.metadata) == null ? void 0 : hn.imageURL),
          rewardType: St == null ? void 0 : St.rewardType
        };
      });
      ge(en);
    } catch (Et) {
      te.captureSentryException(Et), console.log("API call failed", Et);
    } finally {
      He(!0);
    }
  }, Re = () => {
    const Ie = {
      apiKey: F,
      apisecret: T,
      userId: pe,
      token: Se,
      userid: pe
    };
    let ot = H === !1 ? `${$}api/v2/entities/${U}/actions/${xe}/check-action-status?campaignVariationId=${it}&isSpinTheWheel=true` : `${$}api/entities/${U}/quests/${c}/get-verify-status?userId=${pe}&criteriaId=${l}`;
    Oe.get(ot, { headers: Ie }).then((Ke) => {
      var tt = Ke.data;
      (H === !1 && (!(tt != null && tt.success) || (tt == null ? void 0 : tt.proceed) == !1) || tt == !1) && ce(!0);
    }).catch((Ke) => {
      te.captureSentryException(Ke), console.log("Error:", Ke);
    });
  };
  le(() => {
    var Ie;
    (i || pe) && (((Ie = ve[0]) == null ? void 0 : Ie.title) === "" && Qe(), (H === !1 && it && xe || H != !1) && Re()), (s || a) && pt();
  }, [i, pe, s, a, it, xe]);
  const pt = async () => {
    let Ie = pe, ot = Se;
    try {
      const Ke = await te.getExternalLogin({
        uniqueEmailId: s || "",
        uniqueUserId: a || "",
        entityId: U,
        apiKey: F,
        apiSecret: "",
        token: Se || "",
        userId: pe || "",
        entityAuthenticationToken: "",
        apiType: D
      });
      Ke != null && Ke.userId && (Ie = Ke.userId, ot = Ke.token, qe(Ie), Te(ot));
    } catch (Ke) {
      te.captureSentryException(Ke), console.log(Ke);
    }
  }, ze = async () => {
    var Ie, ot, Ke, tt, Ot, Vt, Mt, lr, Lr, Et, Qt, Er, kt, en, St, jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn, dt;
    if (pe === "u-0000000000") {
      x && x();
      return;
    }
    if (oe) {
      M && M();
      return;
    }
    if (j.current && !R && t && Q < t && !ae && ((Ie = ve[0]) == null ? void 0 : Ie.title) !== "") {
      K(!0), fe(!1), j.current.style.transition = "transform 0s", j.current.style.transform = "rotate(0deg)", j.current.offsetHeight, j.current.style.transition = "transform 3s ease-out", j.current.style.transform = "rotate(2160deg)";
      try {
        const ie = await lt(), _e = ie.winningIndex, Ne = ie.reward;
        if ((Ne == null ? void 0 : Ne.length) > 0) {
          const Ft = ((Ke = (ot = Ne[0]) == null ? void 0 : ot.metadata) == null ? void 0 : Ke.logo) || ((Ot = (tt = Ne[0]) == null ? void 0 : tt.metadata) == null ? void 0 : Ot.imageURL) || (S ? Ta : Gc);
          G(Ft);
          const je = (Mt = (Vt = Ne[0]) == null ? void 0 : Vt.metadata) != null && Mt.xp || (lr = Ne[0]) != null && lr.xp ? `+${((Et = (Lr = Ne[0]) == null ? void 0 : Lr.metadata) == null ? void 0 : Et.xp) || ((Qt = Ne[0]) == null ? void 0 : Qt.xp)} ${S ? "Points" : "XP"}` : (kt = (Er = Ne[0]) == null ? void 0 : Er.metadata) != null && kt.gemsData ? `+${(St = (en = Ne[0]) == null ? void 0 : en.metadata) == null ? void 0 : St.gemsData} ${O ? ((cn = (jr = Ne[0]) == null ? void 0 : jr.metadata) == null ? void 0 : cn.claimTitle) || ((un = (ln = Ne[0]) == null ? void 0 : ln.metadata) == null ? void 0 : un.name) : (fn = (dn = Ne[0]) == null ? void 0 : dn.metadata) == null ? void 0 : fn.name}` : `${O ? ((En = (hn = Ne[0]) == null ? void 0 : hn.metadata) == null ? void 0 : En.claimTitle) || ((In = (xn = Ne[0]) == null ? void 0 : xn.metadata) == null ? void 0 : In.title) : (Pn = (Sn = Ne[0]) == null ? void 0 : Sn.metadata) == null ? void 0 : Pn.title}`;
          _(je);
          const ur = ((dt = (kn = Ne[0]) == null ? void 0 : kn.metadata) == null ? void 0 : dt.secondaryImageURL) || "";
          X(ur);
        }
        if (_e == null || _e == null) {
          console.error(
            "API response issue - winningIndex is null or already claimed reward"
          ), K(!1), W(0), g && g(), Y((Ft) => Ft + 1), fe(!0);
          return;
        }
        const Ee = 360 / ve.length, et = 360 * 4 + Ee * (_e + 1) + 3;
        W(et), j.current.style.transition = "transform 1s ease-out", j.current.style.transform = `rotate(${et}deg)`, setTimeout(() => {
          j.current && (j.current.style.transition = "", K(!1), Y((Ft) => Ft + 1), W(0), ee(_e), setTimeout(() => {
            se(!0);
          }, 1e3));
        }, 1e3);
      } catch (ie) {
        console.error("API call failed", ie), te.captureSentryException(ie), K(!1), W(0);
      }
    }
  }, lt = async () => {
    try {
      const Ie = {
        apiKey: F,
        apisecret: T,
        userId: pe,
        token: Se,
        userid: pe
      };
      let ot = H === !1 ? {
        actionId: xe,
        campaignVariationId: it,
        actions: Ge
      } : {
        criteriaId: l,
        isAccumulateAndSelf: p
      }, Ke = H === !1 ? `${$}api/v2/entities/${U}/campaigns/${u}/verify?autoClaim=true` : `${$}api/entities/${U}/quests/${c}/verify?userId=${pe}`;
      const tt = await Oe.post(Ke, ot, { headers: Ie });
      return tt.data.success ? {
        winningIndex: tt.data.winningIndex,
        reward: tt.data.reward
      } : { winningIndex: null, reward: "" };
    } catch (Ie) {
      return te.captureSentryException(Ie), console.error("Error:", Ie), { winningIndex: null, reward: "" };
    }
  };
  le(() => () => {
    K(!1), W(0);
  }, []);
  const st = ve.length, We = Array.from(
    { length: st },
    (Ie, ot) => {
      var Ot, Vt, Mt, lr, Lr, Et, Qt, Er, kt, en, St, jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn, dt, ie, _e, Ne;
      const Ke = ot * (360 / st) % 360, tt = Math.abs(Math.sin(360 / st / 2 * (Math.PI / 180))) * 100 + 1 + "%";
      return {
        // ...spinDivStyle,
        background: ot % 2 === 0 ? (r == null ? void 0 : r.primary) || ((Mt = (Vt = (Ot = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : Ot.uiProps) == null ? void 0 : Vt.wheelColors) == null ? void 0 : Mt.primary) || ((Qt = (Et = (Lr = (lr = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : lr.uiProps) == null ? void 0 : Lr.BrandTheme) == null ? void 0 : Et.properties) == null ? void 0 : Qt.primaryColor) : (r == null ? void 0 : r.secondary) || ((en = (kt = (Er = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : Er.uiProps) == null ? void 0 : kt.wheelColors) == null ? void 0 : en.secondary) || ((ln = (cn = (jr = (St = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : St.uiProps) == null ? void 0 : jr.BrandTheme) == null ? void 0 : cn.properties) == null ? void 0 : ln.secondaryColor),
        color: ot % 2 === 0 ? (B == null ? void 0 : B.primary) || ((fn = (dn = (un = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : un.uiProps) == null ? void 0 : dn.wheelTextColor) == null ? void 0 : fn.primary) || ((In = (xn = (En = (hn = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : hn.uiProps) == null ? void 0 : En.BrandTheme) == null ? void 0 : xn.properties) == null ? void 0 : In.primaryButton) : (B == null ? void 0 : B.secondary) || ((kn = (Pn = (Sn = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : Sn.uiProps) == null ? void 0 : Pn.wheelTextColor) == null ? void 0 : kn.secondary) || ((Ne = (_e = (ie = (dt = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : dt.uiProps) == null ? void 0 : ie.BrandTheme) == null ? void 0 : _e.properties) == null ? void 0 : Ne.secondaryButton),
        transform: `rotate(${Ke}deg)`,
        width: tt
      };
    }
  );
  return /* @__PURE__ */ k(Ze, { children: [
    be ? /* @__PURE__ */ k("div", { className: "mainContSpinWheel", children: [
      /* @__PURE__ */ h("div", { className: "spinMainContainerStyle", style: { background: ((Je = C == null ? void 0 : C.wheelContainerStyle) == null ? void 0 : Je.background) || "#969696", ...C == null ? void 0 : C.wheelContainerStyle }, children: /* @__PURE__ */ k(
        "div",
        {
          style: {
            filter: ae ? ((ut = C == null ? void 0 : C.successModalStyle) == null ? void 0 : ut.filter) || "blur(8.571428298950195px)" : "none"
          },
          onClick: ze,
          children: [
            /* @__PURE__ */ k("div", { className: "spinContainerStyle", ref: j, style: { cursor: R ? "no-drop" : "" }, children: [
              /* @__PURE__ */ h("img", { src: QN, alt: "", className: "shadowImg" }),
              We.map((Ie, ot) => {
                var Ke, tt;
                return /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      //  ...spinDivStyle,
                      ...Ie,
                      background: (ne !== null && ve.length - 1 - ne) === ot ? y || "#FFDD7CBF" : Ie.background,
                      clipPath: ne !== null && ve.length - 1 - ne === ot ? "polygon(100% 0, 50% 100%, 0 0)" : "polygon(-2.5% 0, 102.5% 0, 52% 100%, 48% 100%)",
                      ...C == null ? void 0 : C.segmentContentStyle
                    },
                    className: `segment-${ot + 1}`,
                    id: "spinDivStyle",
                    children: /* @__PURE__ */ k("div", { className: "spinSegmentContent", children: [
                      /* @__PURE__ */ k("p", { children: [
                        ve[ve.length - ot - 1].value,
                        " ",
                        ve[ve.length - ot - 1].title
                      ] }),
                      (v || ((tt = (Ke = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : Ke.uiProps) == null ? void 0 : tt.isImgShow)) && /* @__PURE__ */ h("img", { src: ve[ve.length - ot - 1].image, alt: "", style: { transform: "rotate(180deg)" } })
                    ] })
                  },
                  ot
                );
              })
            ] }),
            /* @__PURE__ */ k("div", { className: "spinCenteredImgContainerStyle", style: { cursor: R ? "no-drop" : "" }, children: [
              /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h("img", { src: DN, alt: "Pointer", className: "spinPointerStyle" }) }),
              /* @__PURE__ */ h("div", { className: "spinCenteredImgDivStyle", style: C == null ? void 0 : C.wheelImageStyle, children: n || (Ct = (Be = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : Be.uiProps) != null && Ct.wheelImage ? /* @__PURE__ */ h("img", { src: n, alt: "Mystic", className: "spinCenteredImgStyle" }) : /* @__PURE__ */ h("p", { className: "spinCenteredTextStyle", children: q || (($e = (Ye = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : Ye.uiProps) == null ? void 0 : $e.spinCenteredText) || "Spin" }) })
            ] })
          ]
        }
      ) }),
      ae && /* @__PURE__ */ k("div", { className: "spinSuccessModal", style: C == null ? void 0 : C.successModalStyle, children: [
        /* @__PURE__ */ h("h5", { className: "spinH5Style", children: "Congratulations" }),
        /* @__PURE__ */ h("p", { className: "spinH2Style", children: "You have won:" }),
        /* @__PURE__ */ k("div", { className: "rewardImgContainer", children: [
          /* @__PURE__ */ h(
            "img",
            {
              src: L,
              alt: "Reward",
              style: { width: "60px", height: "60px", marginBottom: "0px" }
            }
          ),
          E === !0 && J && ne !== null && ve[ne].rewardType === "REWARD_CUSTOM_REWARD" && /* @__PURE__ */ h(
            "img",
            {
              src: J,
              alt: "RewardSecondary",
              style: { width: "60px", height: "60px", marginBottom: "0px" }
            }
          )
        ] }),
        V && /* @__PURE__ */ h("p", { style: { textAlign: "center", marginLeft: "-6px" }, children: V }),
        /* @__PURE__ */ h(
          "div",
          {
            style: C == null ? void 0 : C.claimButtonStyle,
            className: "spinAmazingButtonStyle",
            onClick: () => {
              se(!1), ee(null), fe(!0), m && m();
            },
            children: /* @__PURE__ */ h("p", { children: w || ((mt = (nt = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : nt.uiProps) == null ? void 0 : mt.claimButtonText) || "Claim" })
          }
        )
      ] })
    ] }) : I && (P || /* @__PURE__ */ h(UN, {})),
    be && /* @__PURE__ */ h("p", { className: "spinText", style: b == null ? void 0 : b.style, children: ue ? (b == null ? void 0 : b.text) || ((Ue = (yt = (me = Ae == null ? void 0 : Ae.sdkConfig) == null ? void 0 : me.uiProps) == null ? void 0 : yt.spinText) == null ? void 0 : Ue.text) || "Tap the wheel to spin!" : "" })
  ] });
};
class EPe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosConfig(e) {
    return {
      headers: {
        "Content-Type": "application/json",
        ...e
      }
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a === n || a === A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosConfig({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          u
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, {
          path: "/",
          expires: p
        }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), null;
    }
  }
  async fetchCampaignData(e, r, n, A) {
    var i;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const o = new URLSearchParams();
      o.set("platform", "REACT"), A && o.set("variation", A);
      const s = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${o.toString()}`, a = await Oe.get(
        s,
        this.getAxiosConfig(n)
      );
      if (!((i = a.data) != null && i.data))
        throw new Error("No data received from API");
      return a.data.data;
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
  async getDailyStreakCount(e, r, n, A) {
    var i, o, s;
    try {
      const a = `${this.BACKEND_URL}api/entities/${e}/counters/${n}/user?userId=${r}`, c = await Oe.get(
        a,
        this.getAxiosConfig(A)
      );
      return ((s = (o = (i = c == null ? void 0 : c.data) == null ? void 0 : i.data) == null ? void 0 : o[0]) == null ? void 0 : s.counter) || 0;
    } catch (a) {
      return console.error(a), this.GeneralFunctions.captureSentryException(a), 0;
    }
  }
  trackEvent(e, r) {
    this.GeneralFunctions.fireTrackingEvent(e, r);
  }
  clearCookies() {
    this.cookies.remove("externalUserId", { path: "/" }), this.cookies.remove("questUserId", { path: "/" }), this.cookies.remove("questUserToken", { path: "/" });
  }
  isValidUserAuth(e) {
    return !!e && typeof e.userId == "string" && typeof e.token == "string";
  }
}
const oP = Ms, sP = Hs;
class xPe {
  constructor(e = {}, r = {}, n = oP, A = sP) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = { ...oP, ...n }, this.brandTheme = { ...sP, ...A };
  }
  getStyleValueAsString(e, r = "", n = this.styleConfig) {
    const A = e.split(".");
    let i = n;
    for (const o of A)
      if (i && typeof i == "object")
        i = i[o];
      else
        return r;
    return typeof i == "string" ? i : r;
  }
  getStyleValueAsObject(e, r, n = this.styleConfig) {
    const A = e.split(".");
    let i = n;
    for (const o of A)
      if (i && typeof i == "object")
        i = i[o];
      else
        return r;
    return typeof i == "object" ? { ...r, ...i } : r;
  }
  mergeStyles(e, r) {
    return {
      ...e,
      ...r || {}
    };
  }
  getBackgroundColor() {
    var e, r;
    return this.getStyleValueAsString("Form.backgroundColor") || ((e = this.brandTheme) == null ? void 0 : e.background) || ((r = this.themeConfig) == null ? void 0 : r.backgroundColor) || "#FFFFFF";
  }
  getFontFamily() {
    var e, r;
    return ((e = this.brandTheme) == null ? void 0 : e.fontFamily) || ((r = this.themeConfig) == null ? void 0 : r.fontFamily) || "'Figtree', sans-serif";
  }
  getBorderRadius() {
    var e, r;
    return this.getStyleValueAsString("Form.borderRadius") || ((e = this.questThemeData) == null ? void 0 : e.borderRadius) || ((r = this.brandTheme) == null ? void 0 : r.borderRadius) || "8px";
  }
  getContainerStyles() {
    const e = this.getStyleValueAsObject("Form", {});
    return this.mergeStyles(
      {
        background: this.getBackgroundColor(),
        height: this.getStyleValueAsString("Form.height", "auto"),
        borderRadius: this.getBorderRadius(),
        fontFamily: this.getFontFamily()
      },
      e
    );
  }
  getStreakCountStyles() {
    var r, n;
    const e = this.getStyleValueAsObject("Count", {});
    return this.mergeStyles(
      {
        color: this.getStyleValueAsString("Count.color") || ((r = this.brandTheme) == null ? void 0 : r.accentColor) || ((n = this.questThemeData) == null ? void 0 : n.accentColor) || "#9035ff"
      },
      e
    );
  }
  getStreakHeadingStyles() {
    var r, n;
    const e = this.getStyleValueAsObject("Heading", {});
    return this.mergeStyles(
      {
        color: this.getStyleValueAsString("Heading.color") || ((r = this.brandTheme) == null ? void 0 : r.titleColor) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || "#000000"
      },
      e
    );
  }
  getStreakDescriptionStyles() {
    var r, n;
    const e = this.getStyleValueAsObject("Description", {});
    return this.mergeStyles(
      {
        color: this.getStyleValueAsString("Description.color") || ((r = this.brandTheme) == null ? void 0 : r.contentColor) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || "#666666"
      },
      e
    );
  }
  getIconStyles(e) {
    var n, A, i;
    const r = this.getStyleValueAsObject("Icon", {});
    return {
      background: e ? r.ActiveBackGround || ((n = this.brandTheme) == null ? void 0 : n.secondaryButton) || "#f4ebff" : r.InactiveBackGround || "#fbfbfb",
      iconColor: e ? r.ActiveColor || ((A = this.brandTheme) == null ? void 0 : A.accentColor) || ((i = this.questThemeData) == null ? void 0 : i.accentColor) || "#9035ff" : r.InactiveColor || "#b9b9b9"
    };
  }
  getFooterStyles() {
    var r, n;
    const e = this.getStyleValueAsObject("Footer", {});
    return this.mergeStyles(
      {
        background: this.getBackgroundColor(),
        color: ((r = this.brandTheme) == null ? void 0 : r.contentColor) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || "#666666"
      },
      e
    );
  }
  // Common style getters
  getPrimaryColor() {
    var e, r;
    return this.getStyleValueAsString("Heading.color") || ((e = this.brandTheme) == null ? void 0 : e.primaryColor) || ((r = this.themeConfig) == null ? void 0 : r.primaryColor) || "#000000";
  }
  getSecondaryColor() {
    var e, r;
    return this.getStyleValueAsString("Description.color") || ((e = this.brandTheme) == null ? void 0 : e.secondaryColor) || ((r = this.themeConfig) == null ? void 0 : r.secondaryColor) || "#666666";
  }
  getAccentColor() {
    var e, r;
    return ((e = this.brandTheme) == null ? void 0 : e.accentColor) || ((r = this.questThemeData) == null ? void 0 : r.accentColor) || "#9035ff";
  }
  // Update methods
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    this.styleConfig = {
      ...this.styleConfig,
      ...e,
      Footer: this.mergeStyles(
        this.getStyleValueAsObject("Footer", {}),
        e.Footer || {}
      )
    };
  }
  updateQuestTheme(e) {
    this.questThemeData = {
      ...this.questThemeData,
      ...e
    };
  }
  updateBrandTheme(e) {
    this.brandTheme = {
      ...this.brandTheme,
      ...e
    };
  }
  getTimestampStyles() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.TimeStamp) == null ? void 0 : r.styles;
  }
  getProgressBarBg() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.TimeStamp) == null ? void 0 : r.ProgressBarBg;
  }
  getProgressBarFill() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.TimeStamp) == null ? void 0 : r.ProgressBarFill;
  }
}
const NN = UA(void 0), n9 = () => {
  const t = Xe(NN);
  if (!t)
    throw new Error("Streak compound components must be used within Streak component");
  return t;
}, IPe = ({ className: t, style: e }) => {
  const { days: r, themeManager: n } = n9();
  return /* @__PURE__ */ k("div", { className: `q_steak_days_box ${t || ""}`, style: e, children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_streak_days",
        style: n.getStreakCountStyles(),
        children: r
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_steak_days_text",
        style: n.getStreakHeadingStyles(),
        children: "Streak days"
      }
    )
  ] });
}, SPe = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`, aP = (t, e) => SPe(`<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6324 19.8013C13.7584 19.1747 17.8 16.926 17.8 11.1112C17.8 5.8196 13.9267 2.29593 11.1416 0.676845C10.5236 0.317575 9.80005 0.79006 9.80005 1.50492V3.3334C9.80005 4.77526 9.19382 7.40711 7.50937 8.5018C6.64937 9.0607 5.72057 8.22419 5.61605 7.20388L5.53022 6.36604C5.43045 5.39203 4.43846 4.80075 3.66 5.3946C2.26152 6.46144 0.800049 8.3296 0.800049 11.1112C0.800049 18.2223 6.08894 20.0001 8.73338 20.0001C8.8872 20.0001 9.04884 19.9955 9.21711 19.9858C7.91136 19.8742 5.80005 19.064 5.80005 16.4442C5.80005 14.3949 7.29512 13.0085 8.43107 12.3346C8.73659 12.1533 9.09417 12.3887 9.09417 12.7439V13.3331C9.09417 13.784 9.26855 14.4889 9.68368 14.9714C10.1534 15.5174 10.843 14.9454 10.8986 14.2273C10.9161 14.0008 11.1439 13.8564 11.3401 13.9711C11.9814 14.3459 12.8 15.1465 12.8 16.4442C12.8 18.4922 11.6711 19.4343 10.6324 19.8013Z" fill="${t ? e || "#9035FF" : e || "#B9B9B9"}"/>
</svg>`), PPe = ({
  step: t,
  index: e,
  isActive: r,
  themeManager: n,
  pendingStreakImg: A,
  filledStreakImg: i,
  checkedUponCompletion: o,
  isComingSoon: s
}) => {
  const a = n.getIconStyles(r), c = r ? i || aP(!0, a.iconColor) : A || aP(!1, a.iconColor);
  return /* @__PURE__ */ k("div", { className: `q_streak_step ${s ? "q_streak_step_disable" : r ? "q_streak_step_completed" : "q_streak_step_current"}`, children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: "q_img_cont",
        style: { background: a.background },
        children: [
          /* @__PURE__ */ h("img", { src: c, alt: `Day ${e + 1}` }),
          o && r && /* @__PURE__ */ h("div", { className: "q_streak_check", style: { background: a.iconColor }, children: /* @__PURE__ */ h("svg", { height: "9", width: "9", viewBox: "0 0 24 24", children: /* @__PURE__ */ h("path", { d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z", fill: "#EBFFF7" }) }) })
        ]
      }
    ),
    /* @__PURE__ */ h(
      "p",
      {
        className: `q_streak_step_title ${r ? "q_streak_step_active" : "q_streak_step_disable"}`,
        children: t.title
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_streak_dot",
        style: { background: a.iconColor }
      }
    )
  ] }, e);
}, kPe = () => {
  var c;
  const {
    days: t,
    stepDetails: e,
    currentStep: r,
    themeManager: n,
    pendingStreakImg: A,
    filledStreakImg: i,
    checkedUponCompletion: o
  } = n9(), s = (l) => {
    var u;
    return t >= ((u = e[l]) == null ? void 0 : u.range);
  }, a = (l) => !s(l - 1) && e[l - 1] !== void 0;
  return /* @__PURE__ */ k("div", { className: "q_daily_streak", children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_streak_desc",
        style: n.getStreakDescriptionStyles(),
        children: (c = e[r]) == null ? void 0 : c.description
      }
    ),
    /* @__PURE__ */ h("div", { className: "q_streak_steps", children: e.map((l, u) => /* @__PURE__ */ h(
      PPe,
      {
        step: l,
        index: u,
        isActive: s(u),
        themeManager: n,
        pendingStreakImg: A,
        filledStreakImg: i,
        checkedUponCompletion: o,
        isComingSoon: a(u)
      },
      u
    )) })
  ] });
}, OPe = ({
  footerText: t,
  footerLink: e
}) => {
  const { themeManager: r } = n9();
  return /* @__PURE__ */ h(
    Pr,
    {
      style: r.getFooterStyles(),
      text: t,
      link: e
    }
  );
}, FPe = () => {
  const { days: t, stepDetails: e, themeManager: r } = n9(), [n, A] = N(""), [i, o] = N(0);
  return le(() => {
    if (!e) return;
    const s = e.find((f) => f.range > t);
    if (!s) return;
    const a = /* @__PURE__ */ new Date(), c = new Date(Date.UTC(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()));
    c.setUTCDate(a.getUTCDate() + (s.range - t)), c.setUTCHours(0, 0, 0, 0);
    const l = () => {
      const f = /* @__PURE__ */ new Date(), g = c.getTime() - f.getTime();
      if (g <= 0) {
        A("Completed"), o(100);
        return;
      }
      const m = new Date(Date.UTC(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate())), p = 24 * 60 * 60 * 1e3, v = f.getTime() - m.getTime();
      o(v / p * 100);
      const C = Math.floor(g / (1e3 * 60));
      C < 60 ? A(`${C} mins`) : C < 1440 ? A(`${Math.floor(C / 60)} hr ${C % 60} mins`) : A(`${Math.floor(C / 1440)} day ${Math.floor(C % 1440 / 60)} hr`);
    };
    l();
    const u = setInterval(l, 1e3);
    return () => clearInterval(u);
  }, [t, e]), t >= e[e.length - 1].range ? null : /* @__PURE__ */ k("div", { className: "q_streak_timer", style: r.getTimestampStyles(), children: [
    /* @__PURE__ */ k("p", { children: [
      "Time Remaining: ",
      n
    ] }),
    /* @__PURE__ */ h("div", { className: "q_streak_progress_bar", style: { background: r.getProgressBarBg() }, children: /* @__PURE__ */ h(
      "div",
      {
        style: {
          width: `${i}%`,
          background: r.getProgressBarFill()
        },
        className: "q_streak_progress_bar_inner"
      }
    ) })
  ] });
}, TPe = [
  { range: 1, title: "Day 1", description: "" },
  { range: 2, title: "Day 2", description: "" },
  { range: 3, title: "Day 3", description: "" },
  { range: 4, title: "Day 4", description: "" },
  { range: 5, title: "Day 5", description: "" }
], A9 = ({
  pendingStreakImg: t = "",
  filledStreakImg: e = "",
  counterId: r = "",
  userId: n = "",
  token: A = "",
  counter: i = 0,
  stepDetails: o = TPe,
  uniqueEmailId: s,
  uniqueUserId: a,
  styleConfig: c,
  footerText: l,
  footerLink: u,
  questId: f,
  variation: d,
  brandTheme: g,
  QuestThemeData: m,
  children: p,
  checkedUponCompletion: v,
  confettiOnCompletion: C,
  confettiDuration: w,
  ...B
}) => {
  const [y, b] = N(!0), [q, E] = N(i), { apiKey: x, entityId: M, apiType: O, themeConfig: I } = Xe(
    ct.Context
  ), S = new EPe(O), [P, H] = N(
    m || Ms
  ), [F, T] = N(
    g || Hs
  ), U = MA(
    () => new xPe(
      I,
      c,
      P,
      F
    ),
    [I, c, P, F]
  );
  le(() => {
    g && T(g), m && H(m);
  }, [g, m]), le(() => {
    (async () => {
      var W, R, K, L;
      b(!0), S.trackEvent("quest_daily_streak_loaded", "daily_streak");
      try {
        const G = await S.getUserAuth({
          apiKey: x,
          entityId: M,
          uniqueUserId: a,
          uniqueEmailId: s,
          userId: n,
          token: A
        });
        if (!G) {
          b(!1);
          return;
        }
        const V = {
          apiKey: x,
          userId: G.userId,
          token: G.token
        };
        if (f) {
          const J = await S.fetchCampaignData(
            M,
            f,
            V,
            d
          );
          (R = (W = J.sdkConfig) == null ? void 0 : W.uiProps) != null && R.questThemeData && H(J.sdkConfig.uiProps.questThemeData), (L = (K = J.sdkConfig) == null ? void 0 : K.uiProps) != null && L.BrandTheme && T(J.sdkConfig.uiProps.BrandTheme.properties);
        }
        const _ = await S.getDailyStreakCount(
          M,
          G.userId,
          r,
          V
        );
        E(_), _ >= o[o.length - 1].range && C && dPe(w || 500);
      } catch (G) {
        console.error("Failed to initialize streak:", G);
      } finally {
        b(!1);
      }
    })();
  }, [
    x,
    M,
    a,
    s,
    n,
    A,
    f,
    r,
    d
  ]);
  const D = (Z) => {
    for (let W = 0; W < o.length; W++)
      if (Z < o[W].range)
        return Math.max(0, W - 1);
    return o.length - 1;
  }, Q = (Z) => q >= o[Z].range;
  if (y) return null;
  const Y = D(q), j = {
    days: q,
    currentStep: Y,
    themeManager: U,
    stepDetails: o,
    isStepActive: Q,
    pendingStreakImg: t,
    filledStreakImg: e,
    footerText: l,
    footerLink: u,
    checkedUponCompletion: v
  };
  return /* @__PURE__ */ h(NN.Provider, { value: j, children: /* @__PURE__ */ h(
    "div",
    {
      className: "q_daily_streak_cont",
      style: U.getContainerStyles(),
      ...B,
      children: p
    }
  ) });
};
A9.Counter = IPe;
A9.Content = kPe;
A9.Timer = FPe;
A9.Footer = OPe;
const wo = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`, hd = (t = "#B9B9B9") => wo(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.833008H7.29572C6.07055 0.832998 5.10013 0.832989 4.34065 0.935098C3.55904 1.04018 2.9264 1.26159 2.4275 1.7605C1.92859 2.25941 1.70718 2.89205 1.60209 3.67366C1.49998 4.43313 1.49999 5.40355 1.5 6.62872V10.6663C1.5 11.9145 2.4147 12.949 3.61034 13.1362C3.70232 13.6455 3.87835 14.0802 4.23223 14.4341C4.63351 14.8354 5.13876 15.008 5.73883 15.0887C6.31681 15.1664 7.05169 15.1664 7.96342 15.1663H10.0366C10.9483 15.1664 11.6832 15.1664 12.2612 15.0887C12.8612 15.008 13.3665 14.8354 13.7678 14.4341C14.169 14.0328 14.3416 13.5276 14.4223 12.9275C14.5 12.3495 14.5 11.6146 14.5 10.7029V7.29643C14.5 6.3847 14.5 5.64982 14.4223 5.07184C14.3416 4.47177 14.169 3.96652 13.7678 3.56524C13.4139 3.21136 12.9791 3.03533 12.4698 2.94335C12.2827 1.74771 11.2482 0.833008 10 0.833008ZM11.4196 2.84712C11.2177 2.25716 10.6584 1.83301 10 1.83301H7.33333C6.06212 1.83301 5.15901 1.83407 4.4739 1.92618C3.80317 2.01636 3.41674 2.18547 3.1346 2.46761C2.85246 2.74975 2.68335 3.13618 2.59317 3.80691C2.50106 4.49202 2.5 5.39513 2.5 6.66634V10.6663C2.5 11.3247 2.92416 11.884 3.51411 12.0859C3.49999 11.6793 3.49999 11.2195 3.5 10.7029V7.29642C3.49999 6.3847 3.49998 5.64982 3.57768 5.07184C3.65836 4.47177 3.83096 3.96652 4.23223 3.56524C4.63351 3.16396 5.13876 2.99137 5.73883 2.91069C6.31681 2.83298 7.05169 2.83299 7.96342 2.83301H10.0366C10.5531 2.833 11.0129 2.83299 11.4196 2.84712ZM4.93934 4.27235C5.12385 4.08784 5.3829 3.96754 5.87208 3.90177C6.37565 3.83407 7.04306 3.83301 8 3.83301H10C10.9569 3.83301 11.6244 3.83407 12.1279 3.90177C12.6171 3.96754 12.8762 4.08784 13.0607 4.27235C13.2452 4.45686 13.3655 4.71591 13.4312 5.20509C13.4989 5.70866 13.5 6.37606 13.5 7.33301V10.6663C13.5 11.6233 13.4989 12.2907 13.4312 12.7943C13.3655 13.2834 13.2452 13.5425 13.0607 13.727C12.8762 13.9115 12.6171 14.0318 12.1279 14.0976C11.6244 14.1653 10.9569 14.1663 10 14.1663H8C7.04306 14.1663 6.37565 14.1653 5.87208 14.0976C5.3829 14.0318 5.12385 13.9115 4.93934 13.727C4.75483 13.5425 4.63453 13.2834 4.56877 12.7943C4.50106 12.2907 4.5 11.6233 4.5 10.6663V7.33301C4.5 6.37606 4.50106 5.70866 4.56877 5.20509C4.63453 4.71591 4.75483 4.45686 4.93934 4.27235Z" fill="${t}"/>
</svg>
`), jN = (t = "#0065FF") => wo(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.78353 4.16652C5.78331 4.60855 5.6075 5.03239 5.29478 5.34479C4.98207 5.6572 4.55806 5.83258 4.11603 5.83236C3.674 5.83214 3.25017 5.65633 2.93776 5.34361C2.62536 5.0309 2.44997 4.60688 2.4502 4.16486C2.45042 3.72283 2.62622 3.29899 2.93894 2.98659C3.25166 2.67419 3.67567 2.4988 4.1177 2.49902C4.55972 2.49924 4.98356 2.67505 5.29596 2.98777C5.60837 3.30049 5.78375 3.7245 5.78353 4.16652ZM5.83353 7.06652H2.5002V17.4999H5.83353V7.06652ZM11.1002 7.06652H7.78353V17.4999H11.0669V12.0249C11.0669 8.97486 15.0419 8.69152 15.0419 12.0249V17.4999H18.3335V10.8915C18.3335 5.74986 12.4502 5.94152 11.0669 8.46652L11.1002 7.06652Z" fill="${t}"/>
</svg>`), LN = (t = "#0065FF") => wo(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8332 2.39551C10.811 2.39551 9.83066 2.80157 9.10786 3.52437C8.38507 4.24716 7.979 5.22749 7.979 6.24967V8.39551H5.9165C5.81317 8.39551 5.729 8.47884 5.729 8.58301V11.4163C5.729 11.5197 5.81234 11.6038 5.9165 11.6038H7.979V17.4163C7.979 17.5197 8.06234 17.6038 8.1665 17.6038H10.9998C11.1032 17.6038 11.1873 17.5205 11.1873 17.4163V11.6038H13.2682C13.354 11.6038 13.429 11.5455 13.4498 11.4622L14.1582 8.62884C14.1651 8.60119 14.1657 8.57232 14.1598 8.54442C14.154 8.51651 14.1418 8.49032 14.1243 8.46782C14.1068 8.44532 14.0844 8.42712 14.0588 8.41459C14.0332 8.40205 14.005 8.39553 13.9765 8.39551H11.1873V6.24967C11.1873 6.16486 11.204 6.08088 11.2365 6.00252C11.269 5.92417 11.3165 5.85297 11.3765 5.793C11.4365 5.73303 11.5077 5.68546 11.586 5.653C11.6644 5.62055 11.7484 5.60384 11.8332 5.60384H13.9998C14.1032 5.60384 14.1873 5.52051 14.1873 5.41634V2.58301C14.1873 2.47967 14.104 2.39551 13.9998 2.39551H11.8332Z" fill="${t}"/>
</svg>`), GN = (t = "#0065FF") => wo(`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.7165 4.99967C18.0749 5.29134 17.3832 5.48301 16.6665 5.57467C17.3999 5.13301 17.9665 4.43301 18.2332 3.59134C17.5415 4.00801 16.7749 4.29967 15.9665 4.46634C15.3082 3.74967 14.3832 3.33301 13.3332 3.33301C11.3749 3.33301 9.77487 4.93301 9.77487 6.90801C9.77487 7.19134 9.8082 7.46634 9.86654 7.72468C6.89987 7.57468 4.2582 6.14967 2.49987 3.99134C2.19154 4.51634 2.01654 5.13301 2.01654 5.78301C2.01654 7.02467 2.64154 8.12467 3.6082 8.74967C3.01654 8.74967 2.46654 8.58301 1.9832 8.33301V8.35801C1.9832 10.0913 3.21654 11.5413 4.84987 11.8663C4.32548 12.0098 3.77495 12.0298 3.24154 11.9247C3.46788 12.6351 3.91115 13.2567 4.50905 13.7021C5.10695 14.1476 5.82941 14.3944 6.57487 14.408C5.31123 15.4084 3.74487 15.9491 2.1332 15.9413C1.84987 15.9413 1.56654 15.9247 1.2832 15.8913C2.86654 16.908 4.74987 17.4997 6.76654 17.4997C13.3332 17.4997 16.9415 12.0497 16.9415 7.32467C16.9415 7.16634 16.9415 7.01634 16.9332 6.85801C17.6332 6.35801 18.2332 5.72467 18.7165 4.99967Z" fill="${t}"/>
</svg>`), pd = (t = "#0065FF") => wo(`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z" fill="${t}"/>
</svg>`), RN = (t = "#0065FF") => wo(`<svg width="336" height="12" viewBox="0 0 336 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 6H149" stroke="#E0E0E0"/>
<path d="M164.91 10.12C164.237 10.12 163.64 9.96667 163.12 9.66C162.6 9.35333 162.193 8.92667 161.9 8.38C161.607 7.83333 161.46 7.20667 161.46 6.5C161.46 5.78667 161.603 5.16 161.89 4.62C162.183 4.07333 162.587 3.64667 163.1 3.34C163.613 3.03333 164.207 2.88 164.88 2.88C165.553 2.88 166.147 3.03667 166.66 3.35C167.18 3.65667 167.583 4.08333 167.87 4.63C168.157 5.17 168.3 5.79333 168.3 6.5C168.3 7.20667 168.157 7.83333 167.87 8.38C167.583 8.92667 167.183 9.35333 166.67 9.66C166.163 9.96667 165.577 10.12 164.91 10.12ZM164.91 9.35C165.41 9.35 165.85 9.23 166.23 8.99C166.61 8.74333 166.907 8.40667 167.12 7.98C167.34 7.55333 167.45 7.06 167.45 6.5C167.45 5.94667 167.34 5.45667 167.12 5.03C166.9 4.59667 166.597 4.26 166.21 4.02C165.83 3.77333 165.387 3.65 164.88 3.65C164.38 3.65 163.937 3.77333 163.55 4.02C163.163 4.26 162.86 4.59667 162.64 5.03C162.42 5.45667 162.31 5.94667 162.31 6.5C162.31 7.06 162.42 7.55333 162.64 7.98C162.86 8.40667 163.167 8.74333 163.56 8.99C163.953 9.23 164.403 9.35 164.91 9.35ZM170.394 7.25V6.47H171.994C172.247 6.47 172.474 6.41333 172.674 6.3C172.874 6.18 173.034 6.02 173.154 5.82C173.28 5.61333 173.344 5.38 173.344 5.12C173.344 4.72 173.204 4.39667 172.924 4.15C172.65 3.89667 172.294 3.77 171.854 3.77H170.394V3L171.874 2.99C172.327 2.98333 172.727 3.07333 173.074 3.26C173.427 3.44 173.7 3.69333 173.894 4.02C174.094 4.34 174.194 4.70667 174.194 5.12C174.194 5.53333 174.087 5.9 173.874 6.22C173.66 6.54 173.37 6.79333 173.004 6.98C172.637 7.16 172.224 7.25 171.764 7.25H170.394ZM169.594 10V3H170.444V10H169.594ZM173.544 10L171.864 7.13L172.534 6.69L174.474 10H173.544Z" fill="#B9B9B9"/>
<path d="M187 6H336" stroke="#E0E0E0"/>
</svg>
`), zN = (t = "#0065FF") => wo(`<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="64" rx="32" fill="#F4EBFF"/>
<path d="M38.1785 20.822L33.1785 15.822C32.866 15.5095 32.4421 15.334 32.0002 15.334C31.5582 15.334 31.1344 15.5095 30.8219 15.822L25.8219 20.822C25.5183 21.1363 25.3503 21.5573 25.3541 21.9943C25.3579 22.4313 25.5331 22.8493 25.8422 23.1583C26.1512 23.4673 26.5692 23.6426 27.0062 23.6464C27.4432 23.6502 27.8642 23.4822 28.1785 23.1786L30.3335 21.0236V40.3336C30.3335 40.7757 30.5091 41.1996 30.8217 41.5121C31.1342 41.8247 31.5582 42.0003 32.0002 42.0003C32.4422 42.0003 32.8661 41.8247 33.1787 41.5121C33.4913 41.1996 33.6669 40.7757 33.6669 40.3336V21.0236L35.8219 23.1786C36.1362 23.4822 36.5572 23.6502 36.9942 23.6464C37.4312 23.6426 37.8492 23.4673 38.1582 23.1583C38.4672 22.8493 38.6425 22.4313 38.6463 21.9943C38.6501 21.5573 38.4821 21.1363 38.1785 20.822Z" fill="#9035FF"/>
<path d="M42 27H33.6667V40.3333C33.6667 40.7754 33.4911 41.1993 33.1785 41.5118C32.8659 41.8244 32.442 42 32 42C31.558 42 31.134 41.8244 30.8215 41.5118C30.5089 41.1993 30.3333 40.7754 30.3333 40.3333V27H22C20.6743 27.0013 19.4033 27.5285 18.4659 28.4659C17.5285 29.4033 17.0013 30.6743 17 32V43.6667C17.0013 44.9923 17.5285 46.2633 18.4659 47.2007C19.4033 48.1381 20.6743 48.6653 22 48.6667H42C43.3257 48.6653 44.5967 48.1381 45.5341 47.2007C46.4715 46.2633 46.9987 44.9923 47 43.6667V32C46.9987 30.6743 46.4715 29.4033 45.5341 28.4659C44.5967 27.5285 43.3257 27.0013 42 27Z" fill="#D1ACFF"/>
</svg>`), YN = (t = "#0065FF") => wo(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.50537 11.4955L8.0007 8.00022L11.496 11.4955M11.496 4.50488L8.00004 8.00022L4.50537 4.50488" stroke="#939393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`), VN = (t = "#0065FF") => wo(`<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4478_372)">
<path d="M61.4325 7.54758C59.0498 3.09211 56.1936 0.833984 52.9464 0.833984C49.2087 0.833984 45.327 3.88805 41.4064 9.9157C40.9197 10.667 40.4509 11.4298 40.0001 12.2032C39.5512 11.4292 39.0831 10.6665 38.5964 9.9157C34.6756 3.88805 30.7939 0.833984 27.0539 0.833984C23.807 0.833984 20.9531 3.09211 18.5728 7.54758C16.7906 10.8824 17.4326 13.2774 18.2847 14.6984C19.8203 17.2593 23.2528 18.9854 28.7775 19.9715C33.0205 20.7307 37.5101 20.843 39.8098 20.843H40.1931C42.4903 20.843 46.9801 20.7307 51.2253 19.9715C56.7501 18.9852 60.1825 17.2593 61.7181 14.6984C62.5701 13.2774 63.2123 10.8823 61.4325 7.54758Z" fill="#EFEFEF"/>
<path d="M74.9991 29.7025C74.9991 27.8593 73.5074 26.3701 71.6666 26.3701H8.33631C6.49553 26.3701 5.00146 27.8593 5.00146 29.7025V75.8337C5.00146 77.6745 6.49553 79.1661 8.33631 79.1661H71.6666C73.5074 79.1661 74.9991 77.6745 74.9991 75.8337V29.7025Z" fill="#9035FF"/>
<path d="M79.9986 32.5025C79.9986 34.3432 78.5069 35.8325 76.6663 35.8325H3.33631C1.49553 35.8325 0.00146484 34.3433 0.00146484 32.5025V19.168C0.00146484 17.3272 1.49553 15.833 3.33631 15.833H76.6663C78.5069 15.833 79.9986 17.3271 79.9986 19.168V32.5025Z" fill="#BF8AFF"/>
<path d="M31.668 15.833H48.335V35.8324H31.668V15.833Z" fill="white"/>
<path opacity="0.1" d="M5.00146 39.1312L74.9991 45.4956V35.9404H5.00146V39.1312Z" fill="#2C2C2C"/>
<path d="M46.9454 41.8047C44.2233 41.8047 41.765 42.9227 39.9998 44.7245C38.2348 42.9228 35.7764 41.8047 33.0567 41.8047C27.6883 41.8047 23.3354 46.1573 23.3354 51.5259C23.3354 62.6364 39.9998 72.3602 39.9998 72.3602C39.9998 72.3602 56.6669 62.6366 56.6669 51.5259C56.6669 46.1573 52.3139 41.8047 46.9454 41.8047Z" fill="white"/>
<path opacity="0.1" d="M46.9456 41.8047C46.3866 41.8042 45.8287 41.8524 45.2781 41.9488C49.8531 42.7372 53.3345 46.7263 53.3345 51.5259C53.3345 60.4614 42.5536 68.4981 38.335 71.3031C39.3628 71.9867 40 72.3602 40 72.3602C40 72.3602 56.667 62.6366 56.667 51.5259C56.667 46.1573 52.314 41.8047 46.9456 41.8047Z" fill="#2C2C2C"/>
</g>
<defs>
<clipPath id="clip0_4478_372">
<rect width="80" height="80" fill="white"/>
</clipPath>
</defs>
</svg>`), WN = () => wo(`<svg xmlns="http://www.w3.org/2000/svg" width="102" height="103" viewBox="0 0 102 103" fill="none">
<g clip-path="url(#clip0_2167_19515)">
<path d="M51 102.5C79.1665 102.5 102 79.6668 102 51.5002C102 23.3337 79.1665 0.500244 51 0.500244C22.8335 0.500244 0 23.3337 0 51.5002C0 79.6668 22.8335 102.5 51 102.5Z" fill="#F4EBFF"/>
<path d="M0.0350556 50.8434C0.0219572 51.0622 0.0102765 51.2813 1.77698e-07 51.5002C-0.000100323 52.7041 0.0424292 53.9075 0.127503 55.1084C0.247511 56.8048 0.452289 58.4942 0.741088 60.1702C1.03039 61.8452 1.40327 63.5048 1.85831 65.1426C2.31281 66.7813 2.84897 68.3962 3.46481 69.9813C4.08112 71.5663 4.77634 73.1196 5.54784 74.6351C6.31941 76.1496 7.16622 77.6245 8.08509 79.0545C9.00347 80.4854 9.99284 81.8695 11.0495 83.2015C12.1069 84.534 13.2303 85.8126 14.4155 87.0328C15.5999 88.2523 16.8446 89.412 18.1448 90.5072C19.4457 91.6022 20.8005 92.6314 22.2041 93.591C23.607 94.5511 25.057 95.4405 26.5487 96.2558C28.0412 97.0719 29.5737 97.813 31.1403 98.476C32.706 99.1377 34.3039 99.7206 35.9279 100.223C37.5528 100.724 39.2017 101.145 40.8685 101.482C42.5346 101.82 44.2165 102.075 45.908 102.245C47.6 102.415 49.2995 102.5 51 102.5C52.2039 102.5 53.4074 102.458 54.6083 102.373C56.3047 102.253 57.994 102.049 59.67 101.761C61.3451 101.471 63.0047 101.097 64.6425 100.642C66.2811 100.188 67.896 99.6522 69.4811 99.0369C71.0661 98.4206 72.6193 97.7253 74.1349 96.9538C75.6494 96.1823 77.1244 95.3356 78.5543 94.4167C79.9852 93.4978 81.3693 92.5078 82.7013 91.4506C84.0337 90.3932 85.3125 89.2699 86.5327 88.0847C87.7522 86.9003 88.9118 85.6556 90.007 84.3554C91.102 83.0551 92.1312 81.7008 93.0909 80.2977C94.0511 78.8943 94.9404 77.4437 95.7557 75.9514C96.5718 74.4594 97.3127 72.9275 97.9758 71.3614C98.6375 69.7951 99.2205 68.1967 99.7225 66.5722C100.224 64.9473 100.645 63.2984 100.982 61.6316C101.32 59.9661 101.575 58.2847 101.745 56.5937C101.821 55.6301 101.87 54.6644 101.892 53.6979L78.3185 30.1264L53.0257 20.2483L0.0350556 50.8434Z" fill="#9035FF"/>
<path d="M53.0272 20.2483L0.0350554 50.8434C0.021957 51.0622 0.0102763 51.2813 0 51.5002C0.0078633 58.7513 1.56183 65.9172 4.55825 72.5202C7.55466 79.1231 11.9246 85.011 17.3767 89.7915L74.2257 56.9698L78.3185 30.1248L53.0272 20.2483Z" fill="#58209C"/>
<path d="M65.7495 42.2887C67.778 41.1176 68.473 38.524 67.3019 36.4956C66.1308 34.4672 63.5372 33.7724 61.5087 34.9435C59.4803 36.1146 58.7852 38.7082 59.9563 40.7366C61.1274 42.765 63.7211 43.4598 65.7495 42.2887Z" fill="white" stroke="#58209C" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M39.5414 39.6553L37.7531 40.6912L41.2816 64.3648L43.0715 63.3321L39.5414 39.6553ZM32.0905 44.3808C31.461 44.3473 30.7835 44.5322 30.0695 44.945C28.1698 46.0415 27.7857 47.7293 28.93 49.7135L32.5878 56.0502C33.7337 58.0344 35.3911 58.5492 37.2908 57.4527C39.1922 56.353 39.5731 54.6636 38.4272 52.6794L34.7696 46.3426C34.054 45.1027 33.1392 44.4366 32.0905 44.3808ZM45.7218 45.9155C45.0907 45.882 44.415 46.0638 43.701 46.4766C41.7997 47.5731 41.417 49.2656 42.5614 51.2482L46.2191 57.585C47.365 59.5692 49.0226 60.0808 50.9223 58.9827C52.8237 57.8862 53.2044 56.1936 52.0585 54.211L48.401 47.8774C47.6854 46.6375 46.7705 45.9729 45.7218 45.9171V45.9155ZM31.5214 46.51C31.9661 46.4415 32.3933 46.679 32.7631 47.3197L36.5786 53.9305C37.0726 54.7848 36.8957 55.3649 36.2885 55.7155C35.6558 56.0821 35.0884 55.9307 34.5959 55.078L30.7788 48.4639C30.2864 47.6112 30.4377 47.0455 31.072 46.6789C31.2096 46.5954 31.363 46.5382 31.5214 46.51ZM45.1512 48.0447C45.5974 47.9746 46.023 48.2106 46.3944 48.8512L50.2099 55.4621C50.7039 56.3164 50.527 56.8997 49.9198 57.2487C49.2871 57.6152 48.7197 57.4623 48.2272 56.608L44.4102 49.9971C43.9161 49.1429 44.069 48.5787 44.7033 48.2121C44.841 48.1292 44.9929 48.0724 45.1512 48.0447ZM23.8747 49.3708C22.8802 49.315 21.8123 49.6019 20.6967 50.2458C17.7212 51.9638 17.1139 54.6652 18.8958 57.7507L24.6844 67.7754C26.4662 70.8625 29.1085 71.6865 32.0841 69.9684C35.0596 68.2504 35.6668 65.5489 33.885 62.4618L28.0966 52.4372C26.9826 50.5087 25.5322 49.4648 23.8747 49.3708ZM23.3455 52.7049C23.9177 52.7399 24.458 53.1321 24.9552 53.9927L30.967 64.4063C31.7623 65.7833 31.4579 66.6566 30.4936 67.2128C29.5294 67.7706 28.6209 67.5985 27.8256 66.2199L21.814 55.8079C21.0187 54.4309 21.3231 53.5575 22.2873 52.9997C22.6491 52.7925 23.0044 52.6826 23.3455 52.7049ZM13.9521 54.4326L5.96094 59.0449L11.869 70.5469L14.733 68.8942L14.3999 68.3157C13.6046 66.9371 13.909 66.0637 14.8733 65.5075C15.8375 64.9497 16.7458 65.125 17.5411 66.5036L19.9876 70.7461C20.7829 72.1231 20.4625 72.9695 19.4983 73.5257C18.5341 74.0835 17.6448 73.9353 16.8495 72.5583L15.8135 70.7685L12.9495 72.4212L13.8707 74.0213C15.6526 77.1068 18.2138 77.977 21.1893 76.2589C24.1648 74.5408 24.6892 71.8889 22.9074 68.8034L20.4259 64.505C18.7875 61.6681 16.7522 60.7486 14.5209 62.0364C13.3097 62.7376 12.7138 63.7416 12.6883 64.9688L10.2784 60.2258L15.5425 57.1865L13.9521 54.4326Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2167_19515">
<rect width="102" height="102" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>`), XN = () => wo(`<svg width="376" height="200" viewBox="0 0 376 200" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4463_1495)">
<rect width="376" height="200" fill="url(#paint0_linear_4463_1495)"/>
<rect x="98" y="56" width="180" height="180" rx="90" fill="white" fill-opacity="0.2"/>
<path d="M220.149 97.3214C216.575 90.6382 212.29 87.251 207.42 87.251C201.813 87.251 195.991 91.8321 190.11 100.874C189.38 102.001 188.676 103.145 188 104.305C187.327 103.144 186.625 102 185.895 100.874C180.013 91.8321 174.191 87.251 168.581 87.251C163.711 87.251 159.43 90.6382 155.859 97.3214C153.186 102.324 154.149 105.916 155.427 108.048C157.73 111.889 162.879 114.478 171.166 115.957C177.531 117.096 184.265 117.265 187.715 117.265H188.29C191.735 117.265 198.47 117.096 204.838 115.957C213.125 114.478 218.274 111.889 220.577 108.048C221.855 105.916 222.818 102.323 220.149 97.3214Z" fill="#EFEFEF"/>
<path d="M240.498 130.554C240.498 127.789 238.261 125.556 235.5 125.556H140.504C137.743 125.556 135.502 127.789 135.502 130.554V199.751C135.502 202.512 137.743 204.75 140.504 204.75H235.5C238.261 204.75 240.498 202.512 240.498 199.751V130.554Z" fill="#9035FF"/>
<path d="M247.998 134.754C247.998 137.515 245.76 139.749 242.999 139.749H133.004C130.243 139.749 128.002 137.515 128.002 134.754V114.753C128.002 111.991 130.243 109.75 133.004 109.75H242.999C245.76 109.75 247.998 111.991 247.998 114.753V134.754Z" fill="#BF8AFF"/>
<path d="M175.502 109.75H200.502V139.749H175.502V109.75Z" fill="white"/>
<path opacity="0.1" d="M135.502 144.696L240.498 154.243V139.91H135.502V144.696Z" fill="#2C2C2C"/>
<path d="M198.418 148.706C194.335 148.706 190.648 150.383 188 153.086C185.352 150.383 181.665 148.706 177.585 148.706C169.533 148.706 163.003 155.235 163.003 163.288C163.003 179.954 188 194.539 188 194.539C188 194.539 213.001 179.954 213.001 163.288C213.001 155.235 206.471 148.706 198.418 148.706Z" fill="white"/>
<path opacity="0.1" d="M198.418 148.706C197.58 148.705 196.743 148.778 195.917 148.922C202.78 150.105 208.002 156.088 208.002 163.288C208.002 176.691 191.83 188.746 185.502 192.954C187.044 193.979 188 194.539 188 194.539C188 194.539 213 179.954 213 163.288C213 155.235 206.471 148.706 198.418 148.706Z" fill="#2C2C2C"/>
</g>
<defs>
<linearGradient id="paint0_linear_4463_1495" x1="1.504" y1="200" x2="401.194" y2="123.055" gradientUnits="userSpaceOnUse">
<stop stop-color="#9035FF"/>
<stop offset="1" stop-color="#0065FF"/>
</linearGradient>
<clipPath id="clip0_4463_1495">
<rect width="376" height="200" fill="white"/>
</clipPath>
</defs>
</svg>`);
class MPe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a === n || a === A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosHeaders({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          { headers: u }
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, {
          path: "/",
          expires: p
        }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), console.error(a), null;
    }
  }
  async getCrossSellData(e, r, n, A) {
    var i;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const o = new URLSearchParams();
      o.set("platform", "REACT"), A && o.set("variation", A);
      const s = this.getAxiosHeaders(n), a = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${o.toString()}`, c = await Oe.get(a, {
        headers: s
      });
      if (!((i = c.data) != null && i.success))
        throw new Error("No data received from API");
      return c.data.data;
    } catch (o) {
      return this.GeneralFunctions.captureSentryException(o), null;
    }
  }
  calculateTimeLeft(e) {
    const r = Date.now(), n = e - r;
    return n <= 0 ? {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    } : {
      days: Math.floor(n / (1e3 * 60 * 60 * 24)),
      hours: Math.floor(
        n % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
      ),
      minutes: Math.floor(n % (1e3 * 60 * 60) / (1e3 * 60)),
      seconds: Math.floor(n % (1e3 * 60) / 1e3)
    };
  }
  validateEmail(e) {
    return e ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim()) : !1;
  }
}
class KN {
  constructor(e = {}, r = {}, n = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }, A = {
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = n, this.brandTheme = A;
  }
  getMainContentStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.brandTheme) == null ? void 0 : n.background) || ((A = this.themeConfig) == null ? void 0 : A.backgroundColor),
      height: ((o = (i = this.styleConfig) == null ? void 0 : i.Form) == null ? void 0 : o.height) || "auto",
      fontFamily: this.themeConfig.fontFamily || "'Figtree', sans-serif",
      borderRadius: ((a = (s = this.styleConfig) == null ? void 0 : s.Form) == null ? void 0 : a.borderRadius) || ((c = this.questThemeData) == null ? void 0 : c.borderRadius) || ((l = this.brandTheme) == null ? void 0 : l.borderRadius),
      ...(u = this.styleConfig) == null ? void 0 : u.Form
    };
  }
  getHeadingStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Heading
    };
  }
  getDescriptionStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  getGradientStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v;
    return {
      wrapper: {
        background: "white",
        borderRadius: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.borderRadius) || ((n = this.questThemeData) == null ? void 0 : n.borderRadius) || ((A = this.brandTheme) == null ? void 0 : A.borderRadius) || "10px"
      },
      background: {
        fontFamily: this.themeConfig.fontFamily || "'Figtree', sans-serif",
        borderRadius: ((o = (i = this.styleConfig) == null ? void 0 : i.BackgroundWrapper) == null ? void 0 : o.borderRadius) || ((s = this.questThemeData) == null ? void 0 : s.borderRadius) || ((a = this.brandTheme) == null ? void 0 : a.borderRadius),
        ...(c = this.styleConfig) == null ? void 0 : c.BackgroundWrapper
      },
      heading: {
        color: ((l = this.brandTheme) == null ? void 0 : l.primaryColor) || ((f = (u = this.styleConfig) == null ? void 0 : u.Heading) == null ? void 0 : f.color)
      },
      description: {
        color: ((g = (d = this.styleConfig) == null ? void 0 : d.Description) == null ? void 0 : g.color) || ((m = this.brandTheme) == null ? void 0 : m.secondaryColor) || ((p = this.themeConfig) == null ? void 0 : p.secondaryColor),
        ...(v = this.styleConfig) == null ? void 0 : v.Description
      }
    };
  }
  getTimerStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      card: {
        background: (r = (e = this.styleConfig) == null ? void 0 : e.Timer) == null ? void 0 : r.backgroundColor,
        ...(A = (n = this.styleConfig) == null ? void 0 : n.Timer) == null ? void 0 : A.TimerCard
      },
      primaryText: {
        color: ((o = (i = this.styleConfig) == null ? void 0 : i.Timer) == null ? void 0 : o.primaryColor) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor)
      },
      secondaryText: {
        color: ((c = (a = this.styleConfig) == null ? void 0 : a.Timer) == null ? void 0 : c.secondaryColor) || ((l = this.brandTheme) == null ? void 0 : l.secondaryColor)
      }
    };
  }
  getInputStyles() {
    var e, r, n, A, i, o;
    return {
      label: ((e = this.styleConfig) == null ? void 0 : e.Label) || {},
      input: ((r = this.styleConfig) == null ? void 0 : r.Input) || {},
      error: {
        text: ((A = (n = this.styleConfig) == null ? void 0 : n.EmailError) == null ? void 0 : A.text) || "This is not a valid email",
        style: ((o = (i = this.styleConfig) == null ? void 0 : i.EmailError) == null ? void 0 : o.errorStyle) || {}
      }
    };
  }
  getPrimaryButtonStyles() {
    var e, r, n, A, i, o;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.PrimaryButton) == null ? void 0 : r.background) || ((n = this.questThemeData) == null ? void 0 : n.buttonColor) || ((A = this.brandTheme) == null ? void 0 : A.primaryButton) || ((i = this.themeConfig) == null ? void 0 : i.buttonColor),
      ...(o = this.styleConfig) == null ? void 0 : o.PrimaryButton
    };
  }
  getSecondaryButtonStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.SecondaryButton) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      backgroundColor: ((i = (A = this.styleConfig) == null ? void 0 : A.SecondaryButton) == null ? void 0 : i.backgroundColor) || ((o = this.brandTheme) == null ? void 0 : o.secondaryButton) || ((s = this.themeConfig) == null ? void 0 : s.backgroundColor),
      color: ((c = (a = this.styleConfig) == null ? void 0 : a.SecondaryButton) == null ? void 0 : c.color) || ((l = this.themeConfig) == null ? void 0 : l.primaryColor),
      ...(u = this.styleConfig) == null ? void 0 : u.SecondaryButton
    };
  }
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m;
    return {
      container: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.background) || ((a = this.brandTheme) == null ? void 0 : a.background) || ((c = this.themeConfig) == null ? void 0 : c.backgroundColor),
        ...(u = (l = this.styleConfig) == null ? void 0 : l.Footer) == null ? void 0 : u.FooterStyle
      },
      text: ((d = (f = this.styleConfig) == null ? void 0 : f.Footer) == null ? void 0 : d.FooterTextStyle) || {},
      icon: ((m = (g = this.styleConfig) == null ? void 0 : g.Footer) == null ? void 0 : m.FooterIcon) || {}
    };
  }
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    var r, n;
    this.styleConfig = {
      ...this.styleConfig,
      ...e,
      Footer: {
        ...(r = this.styleConfig) == null ? void 0 : r.Footer,
        ...e == null ? void 0 : e.Footer
      },
      Timer: {
        ...(n = this.styleConfig) == null ? void 0 : n.Timer,
        ...e == null ? void 0 : e.Timer
      }
    };
  }
  updateQuestTheme(e) {
    this.questThemeData = {
      ...this.questThemeData,
      ...e
    };
  }
  updateBrandTheme(e) {
    this.brandTheme = {
      ...this.brandTheme,
      ...e
    };
  }
}
const PFe = ({
  questId: t = "",
  userId: e = "",
  token: r = "",
  heading: n = "50% off on limited products",
  description: A = "Grab deals before they go off!!!",
  shareButtonText: i = "Avail now",
  gradientBackground: o = !1,
  primaryHeading: s = "Grab your deal",
  primaryDescription: a = "Welcome back, Please complete your details",
  showDays: c = !1,
  expiryDate: l = 0,
  isEmail: u = !1,
  claimRewardHandler: f = (b) => {
  },
  backButtonTrigger: d = () => {
  },
  uniqueEmailId: g,
  uniqueUserId: m,
  styleConfig: p,
  showFooter: v = !0,
  footerText: C = "Powered by PLG OS",
  variation: w,
  Icon: B = "gift",
  footerLink: y
}) => {
  const [b, q] = N(""), [E, x] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }), [M, O] = N({
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }), [I, S] = N({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }), { apiKey: P, entityId: H, apiType: F, themeConfig: T } = Xe(
    ct.Context
  ), U = gt(l), D = gt(), Q = new MPe(F), Y = new Bt("mixpanel", F), j = new KN(
    T,
    p,
    E,
    M
  ), Z = () => {
    if (!U.current) return;
    const G = Q.calculateTimeLeft(U.current);
    S(G), Object.values(G).some((V) => V > 0) && (D.current = requestAnimationFrame(Z));
  }, W = (G) => {
    (!u || Q.validateEmail(G)) && (Y.fireTrackingEvent(
      "quest_crossselling_claimed",
      "crossselling"
    ), f(G));
  };
  le(() => {
    T && j.updateThemeConfig(T), p && j.updateStyleConfig(p), E && j.updateQuestTheme(E), M && j.updateBrandTheme(M);
  }, [T, p, E, M]), le(() => ((async () => {
    var V, _, J, X, ne, ee, $;
    if (Y.fireTrackingEvent(
      "quest_cross_selling_loaded",
      "cross_selling"
    ), !(!H || !t || !P))
      try {
        const te = await Q.getUserAuth({
          apiKey: P,
          entityId: H,
          uniqueUserId: m,
          uniqueEmailId: g,
          userId: e,
          token: r
        });
        if (!te) return;
        const ae = {
          apiKey: P,
          userId: te.userId,
          token: te.token
        }, se = await Q.getCrossSellData(
          H,
          t,
          ae,
          w
        );
        if (!se) return;
        (_ = (V = se.sdkConfig) == null ? void 0 : V.uiProps) != null && _.questThemeData && (x(se.sdkConfig.uiProps.questThemeData), (X = (J = se == null ? void 0 : se.sdkConfig) == null ? void 0 : J.uiProps) != null && X.BrandTheme && O(($ = (ee = (ne = se == null ? void 0 : se.sdkConfig) == null ? void 0 : ne.uiProps) == null ? void 0 : ee.BrandTheme) == null ? void 0 : $.properties));
        const ue = +(Date.parse(se.endsAt) || se.endsAt);
        U.current = ue || l, Z();
      } catch (te) {
        Y.captureSentryException(te), U.current = l, Z();
      }
  })(), () => {
    D.current && cancelAnimationFrame(D.current);
  }), [H, P, t, m, g]);
  const R = () => /* @__PURE__ */ k("div", { className: "q_time_left", children: [
    c && I.days > 0 && /* @__PURE__ */ k(
      "div",
      {
        className: "q_hours_left",
        style: j.getTimerStyles().card,
        children: [
          /* @__PURE__ */ h("div", { style: j.getTimerStyles().primaryText, children: I.days }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_time_left_text",
              style: j.getTimerStyles().secondaryText,
              children: "Days"
            }
          )
        ]
      }
    ),
    ["hours", "minutes", "seconds"].map((G) => /* @__PURE__ */ k(
      "div",
      {
        className: `q_${G}_left`,
        style: j.getTimerStyles().card,
        children: [
          /* @__PURE__ */ k("div", { style: j.getTimerStyles().primaryText, children: [
            I[G] < 10 ? "0" : "",
            I[G]
          ] }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_time_left_text",
              style: j.getTimerStyles().secondaryText,
              children: G.charAt(0).toUpperCase() + G.slice(1)
            }
          )
        ]
      },
      G
    ))
  ] }), K = () => u && /* @__PURE__ */ k("div", { style: { width: "100%" }, children: [
    /* @__PURE__ */ h(
      WA,
      {
        htmlFor: "normalInput",
        children: "Email Address",
        style: j.getInputStyles().label
      }
    ),
    /* @__PURE__ */ h(
      Li,
      {
        type: "email",
        style: j.getInputStyles().input,
        placeholder: "Enter your email address",
        value: b,
        onChange: (G) => q(G.target.value),
        emailtext: j.getInputStyles().error.text,
        emailErrorStyle: j.getInputStyles().error.style
      }
    )
  ] }), L = () => {
    var G;
    return /* @__PURE__ */ k(
      "div",
      {
        className: "q_refer_and_earn",
        style: j.getMainContentStyles(),
        children: [
          /* @__PURE__ */ h("div", { className: "q_refer_head", children: /* @__PURE__ */ h(
            "img",
            {
              src: ((G = E == null ? void 0 : E.images) == null ? void 0 : G[0]) || (B === "gift" ? VN() : WN()),
              className: "refer_head_img",
              alt: ""
            }
          ) }),
          /* @__PURE__ */ k("div", { className: "q_refer_content", children: [
            /* @__PURE__ */ k("div", { className: "refer_content_box", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_refer_heading",
                  style: j.getHeadingStyles(),
                  children: n
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_refer_desc",
                  style: j.getDescriptionStyles(),
                  children: A
                }
              )
            ] }),
            R(),
            K(),
            /* @__PURE__ */ h(
              yr,
              {
                style: j.getPrimaryButtonStyles(),
                onClick: () => W(b),
                className: "q_share_link_button",
                disabled: u && !Q.validateEmail(b),
                children: i
              }
            ),
            /* @__PURE__ */ h(
              JA,
              {
                style: j.getSecondaryButtonStyles(),
                onClick: () => {
                  Y.fireTrackingEvent(
                    "quest_challenges_secondary_btn_clicked",
                    "challenges"
                  ), d();
                },
                className: "q_share_link_button_2",
                children: "Go to home"
              }
            )
          ] }),
          !o && v && /* @__PURE__ */ h(
            Pr,
            {
              style: j.getFooterStyles().container,
              textStyle: j.getFooterStyles().text,
              iconStyle: j.getFooterStyles().icon,
              text: C,
              link: y
            }
          )
        ]
      }
    );
  };
  if (o) {
    const G = j.getGradientStyles();
    return /* @__PURE__ */ h("div", { style: G.wrapper, children: /* @__PURE__ */ k(
      "div",
      {
        className: "q_gradient_background",
        style: G.background,
        children: [
          /* @__PURE__ */ k("div", { className: "q_gradient_head", children: [
            /* @__PURE__ */ h("div", { className: "q_gradient_heading", style: G.heading, children: s }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_gradient_description",
                style: G.description,
                children: a
              }
            )
          ] }),
          L(),
          /* @__PURE__ */ h("div", { className: "q_gradient_quest_powered", children: v && /* @__PURE__ */ h(
            Pr,
            {
              style: j.getFooterStyles().container,
              textStyle: j.getFooterStyles().text,
              iconStyle: j.getFooterStyles().icon,
              text: C,
              link: y
            }
          ) })
        ]
      }
    ) });
  }
  return L();
}, kFe = ({
  heading: t = "50% off on limited products",
  description: e = "Grab deals before they go off!!!",
  shareButtonText: r = "Avail now",
  gradientBackground: n = !1,
  primaryHeading: A = "Grab your deal",
  primaryDescription: i = "Welcome back, Please complete your details",
  showDays: o = !1,
  expiryDate: s = 0,
  claimRewardHandler: a = (C) => {
  },
  backButtonTrigger: c = () => {
  },
  styleConfig: l,
  BrandTheme: u,
  QuestThemeData: f,
  showFooter: d = !0,
  isEmail: g = !1,
  footerText: m = "Powered by PLG OS",
  footerLink: p,
  Icon: v = "gift"
}) => {
  const { apiType: C, themeConfig: w } = Xe(ct.Context), [B, y] = N(""), [b, q] = N({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }), E = gt(s), x = new Bt("mixpanel", C), M = new KN(
    w,
    l,
    f,
    u
  ), O = () => {
    const F = Date.now(), T = E.current - F;
    if (T <= 0) {
      q({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }
    const U = Math.floor(T / (1e3 * 60 * 60 * 24)), D = Math.floor(
      T % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
    ), Q = Math.floor(
      T % (1e3 * 60 * 60) / (1e3 * 60)
    ), Y = Math.floor(T % (1e3 * 60) / 1e3);
    q({ days: U, hours: D, minutes: Q, seconds: Y }), requestAnimationFrame(O);
  };
  le(() => (E.current = s, O(), () => cancelAnimationFrame(E.current)), [s]);
  const I = (F) => F ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(F.trim()) : !1, S = () => /* @__PURE__ */ k("div", { className: "q_time_left", children: [
    o && !!b.days && /* @__PURE__ */ k(
      "div",
      {
        className: "q_hours_left",
        style: M.getTimerStyles().card,
        children: [
          /* @__PURE__ */ h("div", { style: M.getTimerStyles().primaryText, children: b.days }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_time_left_text",
              style: M.getTimerStyles().secondaryText,
              children: "Days"
            }
          )
        ]
      }
    ),
    ["hours", "minutes", "seconds"].map((F) => /* @__PURE__ */ k(
      "div",
      {
        className: `q_${F}_left`,
        style: M.getTimerStyles().card,
        children: [
          /* @__PURE__ */ k("div", { style: M.getTimerStyles().primaryText, children: [
            b[F] < 10 ? "0" : "",
            b[F]
          ] }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_time_left_text",
              style: M.getTimerStyles().secondaryText,
              children: F.charAt(0).toUpperCase() + F.slice(1)
            }
          )
        ]
      },
      F
    ))
  ] }), P = () => g && /* @__PURE__ */ k("div", { style: { width: "100%" }, children: [
    /* @__PURE__ */ h(
      WA,
      {
        htmlFor: "normalInput",
        children: "Email Address",
        style: M.getInputStyles().label
      }
    ),
    /* @__PURE__ */ h(
      Li,
      {
        type: "email",
        style: M.getInputStyles().input,
        placeholder: "Enter your email address",
        value: B,
        onChange: (F) => y(F.target.value),
        emailtext: M.getInputStyles().error.text,
        emailErrorStyle: M.getInputStyles().error.style
      }
    )
  ] }), H = () => {
    var F;
    return /* @__PURE__ */ k(
      "div",
      {
        className: "q_refer_and_earn",
        style: M.getMainContentStyles(),
        children: [
          /* @__PURE__ */ h("div", { className: "q_refer_head", children: /* @__PURE__ */ h(
            "img",
            {
              src: ((F = f == null ? void 0 : f.images) == null ? void 0 : F[0]) || (v === "gift" ? VN() : WN()),
              className: "refer_head_img",
              alt: ""
            }
          ) }),
          /* @__PURE__ */ k("div", { className: "q_refer_content", children: [
            /* @__PURE__ */ k("div", { className: "refer_content_box", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_refer_heading",
                  style: M.getHeadingStyles(),
                  children: t
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_refer_desc",
                  style: M.getDescriptionStyles(),
                  children: e
                }
              )
            ] }),
            S(),
            P(),
            /* @__PURE__ */ h(
              yr,
              {
                style: M.getPrimaryButtonStyles(),
                onClick: () => {
                  x.fireTrackingEvent(
                    "quest_challenges_primary_btn_clicked",
                    "challenges"
                  ), a(B);
                },
                className: "q_share_link_button",
                disabled: g && !I(B),
                children: r
              }
            ),
            /* @__PURE__ */ h(
              JA,
              {
                style: M.getSecondaryButtonStyles(),
                onClick: () => {
                  x.fireTrackingEvent(
                    "quest_challenges_secondary_btn_clicked",
                    "challenges"
                  ), c();
                },
                className: "q_share_link_button_2",
                children: "Go to home"
              }
            )
          ] }),
          !n && d && /* @__PURE__ */ h(
            Pr,
            {
              style: M.getFooterStyles().container,
              textStyle: M.getFooterStyles().text,
              iconStyle: M.getFooterStyles().icon,
              text: m,
              link: p
            }
          )
        ]
      }
    );
  };
  if (n) {
    const F = M.getGradientStyles();
    return /* @__PURE__ */ h("div", { style: F.wrapper, children: /* @__PURE__ */ k(
      "div",
      {
        className: "q_gradient_background",
        style: F.background,
        children: [
          /* @__PURE__ */ k("div", { className: "q_gradient_head", children: [
            /* @__PURE__ */ h("div", { className: "q_gradient_heading", style: F.heading, children: A }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_gradient_description",
                style: F.description,
                children: i
              }
            )
          ] }),
          H(),
          /* @__PURE__ */ h("div", { className: "q_gradient_quest_powered", children: d && /* @__PURE__ */ h(
            Pr,
            {
              style: M.getFooterStyles().container,
              textStyle: M.getFooterStyles().text,
              iconStyle: M.getFooterStyles().icon,
              text: m,
              link: p
            }
          ) })
        ]
      }
    ) });
  }
  return H();
}, HPe = async (t, e = "", r, n, A) => {
  try {
    const i = A || e, o = new FormData();
    return o.append("uploaded_file", t), (await Oe.post(
      i,
      o,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          ...n
        },
        onUploadProgress: (a) => {
          const c = Math.round(a.loaded * 100 / a.total);
          r(c);
        }
      }
    )).data;
  } catch (i) {
    return console.error("Error:", i), { success: !1 };
  }
};
function OFe({
  heading: t = "Submit Feedback",
  description: e = "Welcome back, Please complete your details",
  iconColor: r = "#939393",
  isOpen: n = !0,
  reward: A = !1,
  rewardHeading: i = "Reward Unlocked",
  onUpload: o = (v) => {
  },
  invitationLink: s = "",
  onProgressUpdate: a = () => {
  },
  headers: c = {},
  onRewardClaim: l = () => {
  },
  url: u,
  rewardDescription: f = "You have unlocked a new reward for your last transaction. Avail the reward now and enjoy!",
  footerBackground: d,
  footerText: g,
  footerLink: m,
  styleConfig: p
}) {
  var U, D, Q, Y, j, Z, W, R, K, L, G, V, _, J, X, ne, ee, $;
  const [v, C] = N([!1, !1]), { apiType: w, themeConfig: B } = Xe(ct.Context);
  let y = w == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const b = gt(null), [q, E] = N(!1), [x, M] = N(0), [O, I] = N(n), [S, P] = N(null);
  le(() => {
    I(n);
  }, [n]);
  const H = (te) => {
    navigator == null || navigator.clipboard.writeText(s), C((ae) => ae.map((se, ue) => ue == te ? !0 : se));
  };
  le(() => a(x), [x]);
  const F = async (te) => {
    E(!0);
    const ae = await HPe(te, y, M, c, u);
    P(ae);
  }, T = () => {
    var te, ae;
    S && u && c ? o(S) : (te = b.current) != null && te.files && ((ae = b.current) != null && ae.files[0]) && o(b.current.files[0]);
  };
  if (O)
    return A ? /* @__PURE__ */ k(
      "div",
      {
        className: "q_feed_back_modal",
        style: {
          background: ((U = p == null ? void 0 : p.Form) == null ? void 0 : U.backgroundColor) || (B == null ? void 0 : B.backgroundColor),
          height: ((D = p == null ? void 0 : p.Form) == null ? void 0 : D.height) || "auto",
          fontFamily: B.fontFamily || "'Figtree', sans-serif",
          ...p == null ? void 0 : p.Form
        },
        children: [
          /* @__PURE__ */ h("img", { src: XN(), alt: "", className: "q_modal_reward_img" }),
          /* @__PURE__ */ k("div", { className: "q_modal_reward_content", children: [
            /* @__PURE__ */ k("div", { children: [
              /* @__PURE__ */ h("div", { className: "q_modal_heading", style: { color: ((Q = p == null ? void 0 : p.Heading) == null ? void 0 : Q.color) || (B == null ? void 0 : B.primaryColor), ...p == null ? void 0 : p.Heading }, children: i }),
              /* @__PURE__ */ h("div", { className: "q_modal_desc", style: { color: ((Y = p == null ? void 0 : p.Description) == null ? void 0 : Y.color) || (B == null ? void 0 : B.secondaryColor), ...p == null ? void 0 : p.Description }, children: f })
            ] }),
            /* @__PURE__ */ k("div", { className: "q_modal_buttons", children: [
              /* @__PURE__ */ h(JA, { className: "q_modal_cancel", children: "Go to home", onClick: () => {
                I(!1);
              }, style: { ...p == null ? void 0 : p.SecondaryButton } }),
              /* @__PURE__ */ h(
                yr,
                {
                  className: "q_modal_upload_button",
                  children: "Avail now",
                  onClick: () => {
                    l();
                  },
                  style: {
                    background: ((j = p == null ? void 0 : p.PrimaryButton) == null ? void 0 : j.background) || (B == null ? void 0 : B.buttonColor),
                    ...p == null ? void 0 : p.PrimaryButton
                  }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ h(Pr, { style: p == null ? void 0 : p.Footer })
        ]
      }
    ) : /* @__PURE__ */ k(
      "div",
      {
        className: "q_feed_back_modal",
        style: {
          background: ((Z = p == null ? void 0 : p.Form) == null ? void 0 : Z.backgroundColor) || (B == null ? void 0 : B.backgroundColor),
          height: ((W = p == null ? void 0 : p.Form) == null ? void 0 : W.height) || "auto",
          fontFamily: B.fontFamily || "'Figtree', sans-serif",
          ...p == null ? void 0 : p.Form
        },
        children: [
          /* @__PURE__ */ k("div", { className: "q_feed_back_modal_head", children: [
            /* @__PURE__ */ k("div", { children: [
              /* @__PURE__ */ h("div", { className: "q_modal_heading", style: { color: ((R = p == null ? void 0 : p.Heading) == null ? void 0 : R.color) || (B == null ? void 0 : B.primaryColor), ...p == null ? void 0 : p.Heading }, children: t }),
              /* @__PURE__ */ h("div", { className: "q_modal_desc", style: { color: ((K = p == null ? void 0 : p.Description) == null ? void 0 : K.color) || (B == null ? void 0 : B.secondaryColor), ...p == null ? void 0 : p.Description }, children: e })
            ] }),
            /* @__PURE__ */ h("img", { src: YN(r), alt: "", className: "q_modal_cross_img", onClick: () => I(!1) })
          ] }),
          /* @__PURE__ */ k("div", { className: "q_modal_content", children: [
            /* @__PURE__ */ k("div", { className: "q_modal_upload_box", onClick: () => {
              var te;
              return (te = b.current) == null ? void 0 : te.click();
            }, onDragOver: (te) => te.preventDefault(), onDrop: (te) => {
              te.preventDefault();
              const ae = te.dataTransfer.files[0];
              ae && F(ae);
            }, children: [
              q ? /* @__PURE__ */ k("div", { className: "q_modal_progress-wrapper", style: { color: ((L = p == null ? void 0 : p.Heading) == null ? void 0 : L.color) || (B == null ? void 0 : B.primaryColor) }, children: [
                x,
                "%"
              ] }) : /* @__PURE__ */ h("img", { src: zN(), alt: "", className: "q_modal_upload_img" }),
              /* @__PURE__ */ k("div", { className: "q_modal_upload_text_box", children: [
                /* @__PURE__ */ h("div", { className: "q_modal_upload_text", style: { color: ((G = p == null ? void 0 : p.Heading) == null ? void 0 : G.color) || (B == null ? void 0 : B.primaryColor) }, children: "Drag and drop your file here" }),
                /* @__PURE__ */ h("div", { className: "q_modal_upload_mini_text", style: { color: ((V = p == null ? void 0 : p.Description) == null ? void 0 : V.color) || (B == null ? void 0 : B.secondaryColor) }, children: "or, click to Browse (1MB max)" }),
                /* @__PURE__ */ h("input", { ref: b, onChange: (te) => te.target.files && F(te.target.files[0]), type: "file", style: { display: "none" } })
              ] })
            ] }),
            /* @__PURE__ */ h("div", { style: { color: ((_ = p == null ? void 0 : p.Description) == null ? void 0 : _.color) || (B == null ? void 0 : B.secondaryColor) }, className: "q_modal_desc", children: "Some data formats, such as dates, numbers, and colours, may not be recognised." }),
            /* @__PURE__ */ h("img", { src: RN(), alt: "" }),
            s && /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "q_refer_code_content", children: [
              /* @__PURE__ */ h("div", { className: "q_refer_text", style: { color: ((J = p == null ? void 0 : p.Heading) == null ? void 0 : J.color) || (B == null ? void 0 : B.primaryColor) }, children: "Invitation Link" }),
              /* @__PURE__ */ k("div", { className: "q_refer_code_box", children: [
                /* @__PURE__ */ h("div", { className: "q_refer_code", style: { color: ((X = p == null ? void 0 : p.Description) == null ? void 0 : X.color) || (B == null ? void 0 : B.secondaryColor) }, children: s }),
                /* @__PURE__ */ h("img", { className: "q_refer_copy_icon", src: v[1] ? pd() : hd(r), onClick: () => H(1), alt: "" })
              ] })
            ] }) }),
            /* @__PURE__ */ k("div", { className: "q_modal_buttons", children: [
              /* @__PURE__ */ h(JA, { children: "Cancel", style: { ...p == null ? void 0 : p.SecondaryButton }, className: "q_modal_cancel" }),
              /* @__PURE__ */ h(
                yr,
                {
                  children: "Upload",
                  className: "q_modal_upload_button",
                  onClick: () => {
                    var te, ae;
                    return ((te = b.current) == null ? void 0 : te.files) && ((ae = b.current) == null ? void 0 : ae.files[0]) && T();
                  },
                  disabled: !((ne = b.current) != null && ne.files && ((ee = b.current) != null && ee.files[0])),
                  style: {
                    background: (($ = p == null ? void 0 : p.PrimaryButton) == null ? void 0 : $.background) || (B == null ? void 0 : B.buttonColor),
                    ...p == null ? void 0 : p.PrimaryButton
                  }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ h(Pr, { style: p == null ? void 0 : p.Footer, text: g, link: m })
        ]
      }
    );
}
class DPe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a === n || a === A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosHeaders({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          { headers: u }
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, { path: "/", expires: p }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), null;
    }
  }
  async getReferralCode(e, r, n, A) {
    var i;
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const o = new URLSearchParams();
      o.set("platform", "REACT"), A && o.set("variation", A);
      const s = this.getAxiosHeaders(n), a = `${this.BACKEND_URL}api/v2/entities/${r}/campaigns/${e}?${o.toString()}`, c = await Oe.get(a, {
        headers: s
      });
      if (!((i = c.data) != null && i.data))
        throw new Error("No data received from API");
      return c.data.data;
    } catch (o) {
      return this.GeneralFunctions.captureSentryException(o), "";
    }
  }
  shareOnPlatform(e, r) {
  }
  clearCookies() {
    this.cookies.remove("externalUserId", { path: "/" }), this.cookies.remove("questUserId", { path: "/" }), this.cookies.remove("questUserToken", { path: "/" });
  }
  isValidUserAuth(e) {
    return !!e && typeof e.userId == "string" && typeof e.token == "string";
  }
}
class ZN {
  constructor(e = {}, r = {}, n, A) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = n, this.brandTheme = A;
  }
  // Main container styles
  getMainContentStyles() {
    var e, r, n, A, i, o, s;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.themeConfig) == null ? void 0 : n.backgroundColor),
      height: ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.height) || "auto",
      fontFamily: ((o = this.brandTheme) == null ? void 0 : o.fontFamily) || this.themeConfig.fontFamily || "'Figtree', sans-serif",
      ...(s = this.styleConfig) == null ? void 0 : s.Form
    };
  }
  // Heading styles
  getHeadingStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Heading
    };
  }
  // Description styles
  getDescriptionStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  // Input/Code box styles
  getReferralCodeStyles() {
    var e, r, n, A, i, o, s, a, c;
    return {
      container: {
        borderColor: (e = this.themeConfig) == null ? void 0 : e.borderColor,
        ...(r = this.styleConfig) == null ? void 0 : r.Input
      },
      text: {
        color: ((A = (n = this.styleConfig) == null ? void 0 : n.Input) == null ? void 0 : A.color) || ((o = (i = this.styleConfig) == null ? void 0 : i.Description) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.secondaryColor) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor),
        ...(c = this.styleConfig) == null ? void 0 : c.Input
      }
    };
  }
  // Label styles
  getLabelStyles() {
    var e;
    return ((e = this.styleConfig) == null ? void 0 : e.Label) || {};
  }
  // Button styles
  getPrimaryButtonStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      border: ((r = (e = this.styleConfig) == null ? void 0 : e.PrimaryButton) == null ? void 0 : r.border) || "1.5px solid #D1ACFF",
      background: ((A = (n = this.styleConfig) == null ? void 0 : n.PrimaryButton) == null ? void 0 : A.background) || ((i = this.questThemeData) == null ? void 0 : i.buttonColor) || ((o = this.brandTheme) == null ? void 0 : o.primaryButton) || ((s = this.themeConfig) == null ? void 0 : s.buttonColor),
      ...(a = this.styleConfig) == null ? void 0 : a.PrimaryButton
    };
  }
  // Icon styles
  getIconStyles() {
    var e;
    return ((e = this.styleConfig) == null ? void 0 : e.Icon) || {};
  }
  // Footer styles
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p;
    return {
      container: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.background) || ((a = this.themeConfig) == null ? void 0 : a.backgroundColor),
        ...(l = (c = this.styleConfig) == null ? void 0 : c.Footer) == null ? void 0 : l.FooterStyle
      },
      text: ((f = (u = this.styleConfig) == null ? void 0 : u.Footer) == null ? void 0 : f.FooterTextStyle) || {},
      icon: ((g = (d = this.styleConfig) == null ? void 0 : d.Footer) == null ? void 0 : g.FooterIcon) || {},
      content: {
        text: ((p = (m = this.styleConfig) == null ? void 0 : m.Footer) == null ? void 0 : p.FooterText) || ""
      }
    };
  }
  getGradientWrapperStyles() {
    var e, r, n, A;
    return {
      background: "white",
      width: "fit-content",
      borderRadius: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.borderRadius) || ((n = this.questThemeData) == null ? void 0 : n.borderRadius) || ((A = this.brandTheme) == null ? void 0 : A.borderRadius) || "10px"
    };
  }
  getGradientContainerStyles(e) {
    var r, n, A, i, o;
    return {
      fontFamily: ((r = this.brandTheme) == null ? void 0 : r.fontFamily) || this.themeConfig.fontFamily || "'Figtree', sans-serif",
      background: e,
      borderRadius: ((A = (n = this.styleConfig) == null ? void 0 : n.Form) == null ? void 0 : A.borderRadius) || ((i = this.questThemeData) == null ? void 0 : i.borderRadius) || ((o = this.brandTheme) == null ? void 0 : o.borderRadius) || "10px"
    };
  }
  getGradientHeadingStyles() {
    var e, r;
    return {
      color: (e = this.brandTheme) == null ? void 0 : e.titleColor,
      ...(r = this.styleConfig) == null ? void 0 : r.Heading
    };
  }
  getGradientDescriptionStyles() {
    var e;
    return {
      ...(e = this.styleConfig) == null ? void 0 : e.Description
    };
  }
  updateThemeConfig(e) {
    this.themeConfig = {
      ...this.themeConfig,
      ...e
    };
  }
  updateStyleConfig(e) {
    var r;
    this.styleConfig = {
      ...this.styleConfig,
      ...e,
      // Special handling for nested Footer object
      Footer: {
        ...(r = this.styleConfig) == null ? void 0 : r.Footer,
        ...e == null ? void 0 : e.Footer
      }
    };
  }
  updateQuestTheme(e) {
    this.questThemeData = e;
  }
  updateBrandTheme(e) {
    this.brandTheme = e;
  }
  // Helper function to merge styles
  mergeStyles(e, r) {
    return {
      ...e,
      ...r || {}
    };
  }
  updateAllThemes(e) {
    e.themeConfig && this.updateThemeConfig(e.themeConfig), e.styleConfig && this.updateStyleConfig(e.styleConfig), e.questTheme && this.updateQuestTheme(e.questTheme), e.brandTheme && this.updateBrandTheme(e.brandTheme);
  }
}
const FFe = ({
  questId: t = "",
  userId: e = "",
  token: r = "",
  heading: n = "Referral link and code",
  description: A = "Share your unique referral code with friends and receive 10 coins in credits each time a friend signs up!",
  referralLink: i = "",
  shareButtonText: o = "Copy Referral Link",
  secondaryIconColor: s = "#939393",
  gradientBackground: a = !1,
  primaryHeading: c = "Refer and earn!",
  primaryDescription: l = "Welcome back, Please complete your details",
  onCopy: u = (q) => {
  },
  showReferralCode: f = !0,
  showFooter: d = !0,
  gradientBackgroundColor: g,
  uniqueEmailId: m,
  uniqueUserId: p,
  styleConfig: v,
  footerLink: C,
  brandTheme: w,
  variation: B,
  QuestThemedata: y,
  showRefferalLogo: b = !0
}) => {
  const [q, E] = N(""), [x, M] = N([!1, !1]), { apiKey: O, entityId: I, themeConfig: S, apiType: P } = Xe(
    ct.Context
  ), [H, F] = N(y), [T, U] = N(
    w
  ), D = re.useMemo(
    () => new ZN(
      S,
      v,
      H,
      w
    ),
    [S, v, H, w]
  ), Q = new DPe(P), Y = new Bt("mixpanel", P);
  le(() => {
    (async () => {
      var V;
      if (Y.fireTrackingEvent("quest_referral_loaded", "referral"), !(!I || !O || !t))
        try {
          const _ = await Q.getUserAuth({
            apiKey: O,
            entityId: I,
            uniqueUserId: p,
            uniqueEmailId: m,
            userId: e,
            token: r
          });
          if (!_) return;
          const J = {
            apiKey: O,
            userId: _.userId,
            token: _.token
          }, X = await Q.getReferralCode(
            t,
            I,
            J,
            B
          );
          (V = X == null ? void 0 : X.sdkConfig) != null && V.uiProps && (X.sdkConfig.uiProps.questThemeData && F(X.sdkConfig.uiProps.questThemeData), X.sdkConfig.uiProps.BrandTheme && U(X.sdkConfig.uiProps.BrandTheme.properties)), E(X.referralCode);
        } catch (_) {
          Y.captureSentryException(_);
        }
    })();
  }, [I, O, t, p, m]), le(() => {
    S && D.updateThemeConfig(S), v && D.updateStyleConfig(v), H && D.updateQuestTheme(H), T && D.updateBrandTheme(T);
  }, [S, v, H, T]);
  const j = (G) => {
    const V = G ? i + q : q;
    navigator == null || navigator.clipboard.writeText(V), M((_) => _.map((J, X) => X === G ? !0 : J)), setTimeout(() => {
      M((_) => _.map((J, X) => X === G ? !1 : J));
    }, 3e3), u(V), Y.fireTrackingEvent(
      `quest_referral_${G ? "link" : "code"}_copy_clicked`,
      "referral"
    );
  }, Z = (G) => {
    Y.fireTrackingEvent(
      `quest_referral_${G}_btn_clicked`,
      "referral"
    ), Q.shareOnPlatform(i + q, G);
  }, W = () => {
    var G;
    return /* @__PURE__ */ k("div", { className: "q_refer_code_content", children: [
      /* @__PURE__ */ h(WA, { children: "Referral Code", style: D.getLabelStyles() }),
      /* @__PURE__ */ k(
        "div",
        {
          className: "q_refer_code_box",
          style: D.getReferralCodeStyles().container,
          children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_refer_code",
                style: D.getReferralCodeStyles().text,
                children: q
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q_refer_copy_icon",
                src: x[0] ? pd((G = v == null ? void 0 : v.Icon) == null ? void 0 : G.color) : hd(s),
                onClick: () => j(0),
                alt: "",
                style: D.getIconStyles()
              }
            )
          ]
        }
      )
    ] });
  }, R = () => {
    var G;
    return /* @__PURE__ */ k("div", { className: "q_refer_code_content", children: [
      /* @__PURE__ */ h(WA, { children: "Invitation Link", style: D.getLabelStyles() }),
      /* @__PURE__ */ k(
        "div",
        {
          className: "q_refer_code_box",
          style: D.getReferralCodeStyles().container,
          children: [
            /* @__PURE__ */ k(
              "div",
              {
                className: "q_refer_code",
                style: D.getReferralCodeStyles().text,
                children: [
                  i,
                  q
                ]
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q_refer_copy_icon",
                src: x[1] ? pd((G = v == null ? void 0 : v.Icon) == null ? void 0 : G.color) : hd(s),
                onClick: () => j(1),
                alt: "",
                style: D.getIconStyles()
              }
            )
          ]
        }
      )
    ] });
  }, K = () => {
    var G, V, _;
    return /* @__PURE__ */ k("div", { className: "q_social_links", children: [
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_social_link_icon",
          style: D.getIconStyles(),
          onClick: () => Z("linkedin"),
          src: jN((G = v == null ? void 0 : v.Icon) == null ? void 0 : G.color),
          alt: ""
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_social_link_icon",
          style: D.getIconStyles(),
          onClick: () => Z("facebook"),
          src: LN((V = v == null ? void 0 : v.Icon) == null ? void 0 : V.color),
          alt: ""
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_social_link_icon",
          style: D.getIconStyles(),
          onClick: () => Z("twitter"),
          src: GN((_ = v == null ? void 0 : v.Icon) == null ? void 0 : _.color),
          alt: ""
        }
      )
    ] });
  }, L = () => /* @__PURE__ */ k(
    "div",
    {
      className: "q_refer_and_earn",
      style: D.getMainContentStyles(),
      children: [
        b && /* @__PURE__ */ h("div", { className: "q_refer_head", children: /* @__PURE__ */ h(
          "img",
          {
            src: H != null && H.images && H.images.length > 0 ? H.images[0] : hT,
            className: "refer_head_img",
            alt: ""
          }
        ) }),
        /* @__PURE__ */ k("div", { className: "q_refer_content", children: [
          /* @__PURE__ */ k("div", { className: "refer_content_box", children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_refer_heading",
                style: D.getHeadingStyles(),
                children: n
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_refer_desc",
                style: D.getDescriptionStyles(),
                children: A
              }
            )
          ] }),
          f && W(),
          i && R(),
          /* @__PURE__ */ h(
            yr,
            {
              children: o,
              style: D.getPrimaryButtonStyles(),
              onClick: () => {
                j(1), Y.fireTrackingEvent(
                  "quest_referral_copy_referral_primary_btn_clicked",
                  "referral"
                );
              },
              type: "button"
            }
          ),
          K()
        ] }),
        !a && d && /* @__PURE__ */ h(
          Pr,
          {
            style: D.getFooterStyles().container,
            textStyle: D.getFooterStyles().text,
            iconStyle: D.getFooterStyles().icon,
            text: D.getFooterStyles().content.text,
            link: C
          }
        )
      ]
    }
  );
  return a ? /* @__PURE__ */ h("div", { style: D.getGradientWrapperStyles(), children: /* @__PURE__ */ k(
    "div",
    {
      className: "q_gradient_background",
      style: D.getGradientContainerStyles(
        g
      ),
      children: [
        /* @__PURE__ */ k("div", { className: "q_gradient_head", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_gradient_heading",
              style: D.getGradientHeadingStyles(),
              children: c
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_gradient_description",
              style: D.getGradientDescriptionStyles(),
              children: l
            }
          )
        ] }),
        L(),
        /* @__PURE__ */ h("div", { className: "q_gradient_quest_powered", children: d && /* @__PURE__ */ h(
          Pr,
          {
            style: D.getFooterStyles().container,
            textStyle: D.getFooterStyles().text,
            iconStyle: D.getFooterStyles().icon,
            text: D.getFooterStyles().content.text,
            link: C
          }
        ) })
      ]
    }
  ) }) : L();
}, TFe = ({
  referralCode: t,
  heading: e = "Referral link and code",
  description: r = "Share your unique referral code with friends and receive 10 coins in credits each time a friend signs up!",
  referralLink: n = "",
  shareButtonText: A = "Copy Referral Link",
  secondaryIconColor: i = "#939393",
  gradientBackground: o = !1,
  primaryHeading: s = "Refer and earn!",
  primaryDescription: a = "Welcome back, Please complete your details",
  onCopy: c = (w) => {
  },
  showReferralCode: l = !0,
  showFooter: u = !0,
  gradientBackgroundColor: f,
  styleConfig: d,
  footerLink: g,
  brandTheme: m,
  QuestThemeData: p,
  showReferralLogo: v = !0,
  themeConfig: C
}) => {
  const [w, B] = N([!1, !1]), y = re.useMemo(
    () => new ZN(
      C,
      d,
      p,
      m
    ),
    [C, d, p, m]
  ), b = (I) => {
    const S = I ? n + t : t;
    navigator == null || navigator.clipboard.writeText(S), B((P) => P.map((H, F) => F === I ? !0 : H)), setTimeout(() => {
      B((P) => P.map((H, F) => F === I ? !1 : H));
    }, 3e3), c(S);
  }, q = (I) => {
    const S = n + t, P = {
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(S)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(S)}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(S)}`
    };
    window.open(P[I], "_blank");
  }, E = () => {
    var I;
    return /* @__PURE__ */ k("div", { className: "q_refer_code_content", children: [
      /* @__PURE__ */ h(WA, { children: "Referral Code", style: y.getLabelStyles() }),
      /* @__PURE__ */ k(
        "div",
        {
          className: "q_refer_code_box",
          style: y.getReferralCodeStyles().container,
          children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_refer_code",
                style: y.getReferralCodeStyles().text,
                children: t
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q_refer_copy_icon",
                src: w[0] ? pd((I = d == null ? void 0 : d.Icon) == null ? void 0 : I.color) : hd(i),
                onClick: () => b(0),
                alt: "",
                style: y.getIconStyles()
              }
            )
          ]
        }
      )
    ] });
  }, x = () => {
    var I;
    return /* @__PURE__ */ k("div", { className: "q_refer_code_content", children: [
      /* @__PURE__ */ h(WA, { children: "Invitation Link", style: y.getLabelStyles() }),
      /* @__PURE__ */ k(
        "div",
        {
          className: "q_refer_code_box",
          style: y.getReferralCodeStyles().container,
          children: [
            /* @__PURE__ */ k(
              "div",
              {
                className: "q_refer_code",
                style: y.getReferralCodeStyles().text,
                children: [
                  n,
                  t
                ]
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q_refer_copy_icon",
                src: w[1] ? pd((I = d == null ? void 0 : d.Icon) == null ? void 0 : I.color) : hd(i),
                onClick: () => b(1),
                alt: "",
                style: y.getIconStyles()
              }
            )
          ]
        }
      )
    ] });
  }, M = () => {
    var I, S, P;
    return /* @__PURE__ */ k("div", { className: "q_social_links", children: [
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_social_link_icon",
          style: y.getIconStyles(),
          onClick: () => q("linkedin"),
          src: jN((I = d == null ? void 0 : d.Icon) == null ? void 0 : I.color),
          alt: ""
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_social_link_icon",
          style: y.getIconStyles(),
          onClick: () => q("facebook"),
          src: LN((S = d == null ? void 0 : d.Icon) == null ? void 0 : S.color),
          alt: ""
        }
      ),
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_social_link_icon",
          style: y.getIconStyles(),
          onClick: () => q("twitter"),
          src: GN((P = d == null ? void 0 : d.Icon) == null ? void 0 : P.color),
          alt: ""
        }
      )
    ] });
  }, O = () => /* @__PURE__ */ k(
    "div",
    {
      className: "q_refer_and_earn",
      style: y.getMainContentStyles(),
      children: [
        v && /* @__PURE__ */ h("div", { className: "q_refer_head", children: /* @__PURE__ */ h(
          "img",
          {
            src: p != null && p.images && p.images.length > 0 ? p.images[0] : hT,
            className: "refer_head_img",
            alt: ""
          }
        ) }),
        /* @__PURE__ */ k("div", { className: "q_refer_content", children: [
          /* @__PURE__ */ k("div", { className: "refer_content_box", children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_refer_heading",
                style: y.getHeadingStyles(),
                children: e
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_refer_desc",
                style: y.getDescriptionStyles(),
                children: r
              }
            )
          ] }),
          l && E(),
          n && x(),
          /* @__PURE__ */ h(
            yr,
            {
              children: A,
              style: y.getPrimaryButtonStyles(),
              onClick: () => b(1),
              type: "button"
            }
          ),
          M()
        ] }),
        !o && u && /* @__PURE__ */ h(
          Pr,
          {
            style: y.getFooterStyles().container,
            textStyle: y.getFooterStyles().text,
            iconStyle: y.getFooterStyles().icon,
            text: y.getFooterStyles().content.text,
            link: g
          }
        )
      ]
    }
  );
  return o ? /* @__PURE__ */ h("div", { style: y.getGradientWrapperStyles(), children: /* @__PURE__ */ k(
    "div",
    {
      className: "q_gradient_background",
      style: y.getGradientContainerStyles(f),
      children: [
        /* @__PURE__ */ k("div", { className: "q_gradient_head", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_gradient_heading",
              style: y.getGradientHeadingStyles(),
              children: s
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_gradient_description",
              style: y.getGradientDescriptionStyles(),
              children: a
            }
          )
        ] }),
        O(),
        /* @__PURE__ */ h("div", { className: "q_gradient_quest_powered", children: u && /* @__PURE__ */ h(
          Pr,
          {
            style: y.getFooterStyles().container,
            textStyle: y.getFooterStyles().text,
            iconStyle: y.getFooterStyles().icon,
            text: y.getFooterStyles().content.text,
            link: g
          }
        ) })
      ]
    }
  ) }) : O();
}, MFe = ({
  heading: t,
  subheading: e,
  // userId,
  // token,
  // questId,
  bgColor: r,
  font: n,
  textColor: A,
  isOpen: i = !0,
  // uniqueUserId,
  // uniqueEmailId,
  iconColor: o = "#939393",
  onClose: s = () => {
  },
  onLinkTrigger: a = (m) => {
    window.open(m, "smallWindow", "width=500,height=500");
  },
  styleConfig: c,
  offlineFormatData: l = [],
  QuestThemeData: u,
  BrandTheme: f,
  Headers: d,
  showFooter: g = !0
}) => {
  var M, O, I, S, P, H, F, T, U, D, Q, Y, j, Z, W, R;
  const [m, p] = N(0), [v, C] = N([]), { themeConfig: w, apiType: B } = Xe(ct.Context), [y, b] = N([]);
  N(!1), N(!1), N(
    Array(y.length).fill(!0)
  );
  let q = new Bt("mixpanel", B);
  const E = (K, L) => {
    q.fireTrackingEvent(
      "quest_tutorial_offline_step_link_clicked",
      "tutorial_offline"
    ), a(L);
    const G = y.map((V) => (!V.status && V.id == K && (V.status = !0, C((_) => [..._, m])), V));
    b(G), rs.success("Task completed");
  };
  le(() => {
    q.fireTrackingEvent(
      "quest_tutorial_offline_loaded",
      "tutorial_offline"
    ), b(l);
  }, [l]);
  const x = (K, L) => {
    const G = document.querySelector(
      `#q_tutorial_progress_connector_${K}`
    ), V = document.querySelector(
      `#q_tutorial_box_content_${K + 1}`
    );
    if (G && V) {
      let _ = (L - 32) / 2 + (V.offsetHeight - 32) / 2 + 32;
      G.style.height = `${_}px`, K === y.length - 1 && (G.style.display = "none");
    }
  };
  return i ? /* @__PURE__ */ k(
    "div",
    {
      className: "q-tutorial-cont",
      style: {
        background: ((M = c == null ? void 0 : c.Form) == null ? void 0 : M.backgroundColor) || (f == null ? void 0 : f.background) || (w == null ? void 0 : w.backgroundColor),
        height: ((O = c == null ? void 0 : c.Form) == null ? void 0 : O.height) || "auto",
        fontFamily: (f == null ? void 0 : f.fontFamily) || w.fontFamily || "'Figtree', sans-serif",
        borderRadius: ((I = c == null ? void 0 : c.Form) == null ? void 0 : I.borderRadius) || (u == null ? void 0 : u.borderRadius) || (f == null ? void 0 : f.borderRadius),
        ...c == null ? void 0 : c.Form
      },
      children: [
        /* @__PURE__ */ h(
          T1,
          {
            heading: Array.isArray(d) ? (S = d[0]) == null ? void 0 : S.heading : "Your Application Progress",
            iconColor: o,
            onClose: () => {
            },
            description: Array.isArray(d) ? (P = d[0]) == null ? void 0 : P.subHeading : "Welcome back, Please complete your application",
            style: {
              headingStyle: {
                color: ((H = c == null ? void 0 : c.Heading) == null ? void 0 : H.color) || (f == null ? void 0 : f.titleColor) || (f == null ? void 0 : f.primaryColor) || (w == null ? void 0 : w.primaryColor),
                ...c == null ? void 0 : c.Heading
              },
              descriptionStyle: {
                color: ((F = c == null ? void 0 : c.Description) == null ? void 0 : F.color) || (f == null ? void 0 : f.secondaryColor) || (w == null ? void 0 : w.secondaryColor),
                ...c == null ? void 0 : c.Description
              },
              topbarStyle: c == null ? void 0 : c.TopBar
            }
          }
        ),
        /* @__PURE__ */ h("div", { className: "q-tut-card-cont", children: y.map((K, L) => {
          var G, V, _;
          return /* @__PURE__ */ k(
            "div",
            {
              className: "q_tutorial_box",
              id: `q_tutorial_box_${L}`,
              onClick: () => E(K.id, K.url),
              children: [
                /* @__PURE__ */ k("div", { className: "q_tutorial_progress", children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q_tutorial_progress_img_cont",
                      style: {
                        background: K.status ? "#01ff0111" : "#FBFBFB"
                      },
                      children: /* @__PURE__ */ h(
                        "img",
                        {
                          className: "q_tutorial_progress_icon",
                          style: {
                            width: "16px",
                            height: "16px"
                          },
                          src: K.status ? dT : fT,
                          alt: ""
                        }
                      )
                    }
                  ),
                  L < y.length - 1 && /* @__PURE__ */ h(
                    "div",
                    {
                      id: `q_tutorial_progress_connector_${L}`,
                      style: { background: K.status ? "#73DCA7" : "#EFEFEF" },
                      className: "q_tutorial_progress_connector"
                    }
                  )
                ] }),
                /* @__PURE__ */ k(
                  "div",
                  {
                    id: `q_tutorial_box_content_${L}`,
                    className: "q_tutorial_box_content",
                    ref: (J) => J && x(L, J.offsetHeight),
                    children: [
                      /* @__PURE__ */ k(
                        "div",
                        {
                          className: "q_tut_step",
                          style: {
                            color: ((G = c == null ? void 0 : c.Description) == null ? void 0 : G.color) || (f == null ? void 0 : f.secondaryColor) || (w == null ? void 0 : w.secondaryColor)
                          },
                          children: [
                            "STEP ",
                            L + 1
                          ]
                        }
                      ),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "q_tut_box_head",
                          style: {
                            color: ((V = c == null ? void 0 : c.Heading) == null ? void 0 : V.color) || (f == null ? void 0 : f.primaryColor) || (w == null ? void 0 : w.primaryColor)
                          },
                          children: K.title
                        }
                      ),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "q_tut_box_desc",
                          style: {
                            color: ((_ = c == null ? void 0 : c.Description) == null ? void 0 : _.color) || (f == null ? void 0 : f.secondaryColor) || (w == null ? void 0 : w.secondaryColor)
                          },
                          children: K.subheading
                        }
                      )
                    ]
                  }
                )
              ]
            },
            L
          );
        }) }),
        g && /* @__PURE__ */ h(
          Pr,
          {
            style: {
              background: ((U = (T = c == null ? void 0 : c.Footer) == null ? void 0 : T.FooterStyle) == null ? void 0 : U.backgroundColor) || ((D = c == null ? void 0 : c.Form) == null ? void 0 : D.backgroundColor) || ((Q = c == null ? void 0 : c.Form) == null ? void 0 : Q.background) || (f == null ? void 0 : f.background) || (w == null ? void 0 : w.backgroundColor),
              ...(Y = c == null ? void 0 : c.Footer) == null ? void 0 : Y.FooterStyle
            },
            textStyle: (j = c == null ? void 0 : c.Footer) == null ? void 0 : j.FooterTextStyle,
            iconStyle: (Z = c == null ? void 0 : c.Footer) == null ? void 0 : Z.FooterIcon,
            text: (W = c == null ? void 0 : c.Footer) == null ? void 0 : W.FooterText,
            link: (R = c == null ? void 0 : c.Footer) == null ? void 0 : R.FooterLink
          }
        )
      ]
    }
  ) : /* @__PURE__ */ h(Ze, {});
}, QPe = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`, UPe = (t = "#0065FF") => QPe(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.50537 11.4955L8.0007 8.00022L11.496 11.4955M11.496 4.50488L8.00004 8.00022L4.50537 4.50488" stroke="#939393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`), HFe = ({
  onFinish: t,
  isOpen: e = !0,
  onClose: r,
  backgroundColor: n,
  btnBackGroundColor: A,
  btnColor: i,
  color: o,
  actions: s,
  offlineFormData: a,
  autoScroll: c = !1,
  image: l = !1,
  disableScrollSelector: u,
  animation: f,
  tooltip: d,
  iconColor: g = "#939393"
}) => {
  var E, x, M, O, I;
  const [m, p] = N(0), [v, C] = N({ top: 350, left: 376 }), w = gt(null), [B, y] = N(!1), b = (S, P) => {
    var H;
    if (S) {
      const F = S.getBoundingClientRect(), T = (H = w.current) == null ? void 0 : H.getBoundingClientRect();
      if (!S || !T) return P;
      let U = 0, D = 0;
      switch (P) {
        case "top":
          U = F.top + window.scrollY - (T == null ? void 0 : T.height) - 20, D = F.left + window.scrollX + F.width / 2 - T.width / 2;
          break;
        case "bottom":
          U = F.bottom + window.scrollY + 20, D = F.left + window.scrollX + F.width / 2 - T.width / 2;
          break;
        case "left":
          U = F.top + window.scrollY + F.height / 2 - T.height / 2, D = F.left + window.scrollX + F.width + 20;
          break;
        case "right":
          U = F.top + window.scrollY + F.height / 2 - T.height / 2, D = F.right + window.scrollX - (T == null ? void 0 : T.width) - F.width - 20;
          break;
        case "right-top":
          U = F.top + window.scrollY + F.height / 2 - T.height / 2 - 50, D = F.right + window.scrollX - (T == null ? void 0 : T.width) - F.width - 20;
          break;
        case "right-bottom":
          U = F.bottom + window.scrollY - (T == null ? void 0 : T.height) + 50, D = F.right + window.scrollX - (T == null ? void 0 : T.width) - F.width - 20;
          break;
        case "top-left":
          U = F.top + window.scrollY - (T == null ? void 0 : T.height) - 20, D = F.right + window.scrollX - F.width / 2 - T.width;
          break;
        case "top-right":
          U = F.top + window.scrollY - (T == null ? void 0 : T.height) - 20, D = F.right + window.scrollX - F.width / 2.5 - 20;
          break;
        case "bottom-left":
          U = F.bottom + window.scrollY + 20, D = F.right + window.scrollX - F.width / 2.5 - 20;
          break;
        case "bottom-right":
          U = F.bottom + window.scrollY + 20, D = F.left + window.scrollX - F.width / 2 + T.width / 2;
          break;
      }
      C({ top: U, left: D });
    }
  };
  le(() => {
    s && s[0] && s[0]();
  }, []), le(() => {
    if (a.length) {
      if (s && s[m]) {
        let S = s[m + 1];
        typeof S == "function" && S();
      }
      try {
        const S = document.querySelector(a[m].selector || "");
        if (S) {
          b(S || "", a[m].position);
          const P = S.getBoundingClientRect();
          if (f && S.classList.add("q_walk_highlighted"), c) {
            const H = a[m].position == "top" ? 300 : 100;
            window.scrollTo({
              top: window.scrollY + P.top - H,
              behavior: "smooth"
            });
            const F = document.querySelector(u || "");
            F ? F.style.overflowY = "hidden" : document.body.style.overflowY = "hidden";
          }
        }
      } catch (S) {
        console.log(S);
      }
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [m, a]);
  const q = (S) => {
    var F;
    if (!S) return {};
    const P = (F = w.current) == null ? void 0 : F.getBoundingClientRect();
    if (!P) return;
    let H = {};
    switch (S) {
      case "top":
        H = {
          bottom: "-12px",
          left: (P == null ? void 0 : P.width) / 2,
          clipPath: "polygon(50% 100%, 0% 0%, 100% 0%)"
        };
        break;
      case "bottom":
        H = {
          top: "-12px",
          left: (P == null ? void 0 : P.width) / 2,
          clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)"
        };
        break;
      case "left":
        H = {
          top: (P == null ? void 0 : P.height) / 2 - 5,
          left: "-12px",
          clipPath: "polygon(52% 46%, 100% 0, 100% 100%)"
        };
        break;
      case "right":
        H = {
          top: (P == null ? void 0 : P.height) / 2 - 5,
          right: "-36px",
          clipPath: "polygon(66% 48%, 0 0, 0 100%)"
        };
        break;
      case "right-top":
        H = {
          top: "50px",
          right: "-36px",
          clipPath: "polygon(66% 48%, 0 0, 0 100%)"
        };
        break;
      case "right-bottom":
        H = {
          top: "50px",
          right: "-36px",
          clipPath: "polygon(66% 48%, 0 0, 0 100%)"
        };
        break;
      case "bottom-left":
        H = {
          top: "-12px",
          left: (P == null ? void 0 : P.width) / 6,
          clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)"
        };
        break;
      case "bottom-right":
        H = {
          top: "-12px",
          left: (P == null ? void 0 : P.width) / 6,
          clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)"
        };
        break;
      case "top-right":
        H = {
          bottom: "-12px",
          left: (P == null ? void 0 : P.width) / 6,
          clipPath: "polygon(50% 100%, 0% 0%, 100% 0%)"
        };
        break;
      case "top-left":
        H = {
          bottom: "-12px",
          left: (P == null ? void 0 : P.width) / 1.15,
          clipPath: "polygon(50% 100%, 0% 0%, 100% 0%)"
        };
        break;
      default:
        H = {
          top: "-12px",
          left: "50%",
          clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)"
        };
        break;
    }
    return H;
  };
  return le(() => {
    y(!e);
  }, [e]), B || !a.length ? /* @__PURE__ */ h(Ze, {}) : gd.createPortal(/* @__PURE__ */ h("div", { children: /* @__PURE__ */ k("div", { className: "q_walk_trhough", ref: w, style: {
    position: "absolute",
    top: `${v.top}px`,
    left: `${v.left}px`,
    backgroundColor: n,
    color: o
  }, children: [
    /* @__PURE__ */ h("div", { className: "q_walk_tooltip", style: q((E = a[m]) == null ? void 0 : E.position) }),
    l && ((x = a[m]) == null ? void 0 : x.icon) && /* @__PURE__ */ h("img", { src: (M = a[m]) == null ? void 0 : M.icon, alt: "" }),
    /* @__PURE__ */ k("div", { className: "q_walk_top", children: [
      /* @__PURE__ */ k("div", { className: "q_walk_count", children: [
        m + 1,
        "/",
        a == null ? void 0 : a.length
      ] }),
      /* @__PURE__ */ h("div", { className: "q_walk_close" }),
      /* @__PURE__ */ h(
        "img",
        {
          src: UPe(g),
          alt: "",
          className: "q_walk_close_img",
          onClick: () => {
            document.body.style.overflow = "", r ? r() : y(!0);
          }
        }
      )
    ] }),
    /* @__PURE__ */ h("div", { className: "q_walk_head", style: { color: o }, children: (O = a[m]) == null ? void 0 : O.text }),
    /* @__PURE__ */ h("div", { className: "q_walk_desc", style: { color: o }, children: (I = a[m]) == null ? void 0 : I.description }),
    /* @__PURE__ */ h("div", { className: "q_walk_foot", children: /* @__PURE__ */ k("div", { className: "q_walk_btns", children: [
      m > 0 && /* @__PURE__ */ h("div", { className: "q_walk_back", onClick: () => {
        0 < m && p((S) => S - 1);
      }, children: "Back" }),
      /* @__PURE__ */ h(
        "div",
        {
          className: "q_walk_next",
          style: { color: i, background: A },
          onClick: () => {
            a.length - 1 > m ? p((S) => S + 1) : (document.body.style.overflow = "", t ? t() : y(!0));
          },
          children: a.length - 1 > m ? "Continue" : "Finish"
        }
      )
    ] }) }),
    /* @__PURE__ */ h(Pr, { color: g })
  ] }) }), document.body);
}, JN = () => {
  const {
    design: t,
    formdata: e,
    progress: r,
    progressBarMultiLine: n,
    template: A,
    controlBtnType: i,
    uiProps: o,
    nextBtnText: s,
    returnAnswers: a,
    answer: c,
    checkValidationValues: l,
    validateInputRegex: u,
    themeManager: f,
    currentPage: d = 0,
    setCurrentPage: g,
    handleUpdate: m,
    ProgressBar: p,
    questionTemplate: v,
    btnFlag: C,
    designState: w,
    onboardingGetPropsFunctions: B
  } = Gs(), { apiType: y } = Xe(ct.Context);
  let b = new Bt("mixpanel", y);
  return le(() => {
    w && d >= w.length && w.length > 0 && g && g(w.length - 1);
  }, [w, d, g]), /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "q-onb-main-first", children: [
    v === "multi-question" && e.length > 0 && w.length > 1 && !!(r != null && r.length) && /* @__PURE__ */ h(p, {}),
    w && w.length > 0 ? w[d].map((q, E) => {
      var M, O, I;
      const x = e[q - 1];
      if (!x) return null;
      switch (x.type) {
        case "USER_INPUT_TEXT":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Hi,
              {
                placeholder: (x == null ? void 0 : x.placeholder) || (x == null ? void 0 : x.question) || "",
                value: c[x.actionId || ""],
                validateInputRegex: (S) => u(
                  S,
                  x.actionId
                ),
                errorText: f.getTextInputErrorText(),
                textErrorStyle: f.getTextInputErrorStyles(),
                regexKey: x == null ? void 0 : x.regexKey,
                regexMessage: x == null ? void 0 : x.regexMessage,
                onChange: (S) => m(S, x.actionId || "", ""),
                style: f.getTextInputStyles(),
                name: `input-${(M = w == null ? void 0 : w[d]) == null ? void 0 : M[E]}`
              },
              x.actionId
            )
          ] }, E);
        case "USER_INPUT_EMAIL":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Fu,
              {
                placeholder: (x == null ? void 0 : x.placeholder) || (x == null ? void 0 : x.question) || "",
                value: c[x.actionId || ""],
                iconColor: f.getEmailIconColor(),
                validateInputRegex: (S) => u(
                  S,
                  x.actionId
                ),
                regexKey: x == null ? void 0 : x.regexKey,
                regexMessage: x == null ? void 0 : x.regexMessage,
                onChange: (S) => m(S, x.actionId || "", ""),
                style: f.getTextInputStyles(),
                emailtext: f.getEmailInputErrorText(),
                emailErrorStyle: f.getEMailInputErrorStyles(),
                name: `input-${(O = w == null ? void 0 : w[d]) == null ? void 0 : O[E]}`
              },
              x.actionId
            )
          ] }, E);
        case "USER_INPUT_PHONE":
        case "USER_INPUT_NUMBER":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Tu,
              {
                placeholder: (x == null ? void 0 : x.placeholder) || (x == null ? void 0 : x.question) || "",
                value: c[x.actionId || ""],
                iconColor: f.getEmailIconColor(),
                validateInputRegex: (S) => u(
                  S,
                  x.actionId
                ),
                numbertext: f.getNumberInputErrorText(),
                numberErrorStyle: f.getNumberInputErrorStyles(),
                regexKey: x == null ? void 0 : x.regexKey,
                regexMessage: x == null ? void 0 : x.regexMessage,
                onChange: (S) => m(S, x.actionId || "", ""),
                style: f.getTextInputStyles(),
                name: `input-${(I = w == null ? void 0 : w[d]) == null ? void 0 : I[E]}`
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E);
        case "USER_INPUT_TEXTAREA":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Mu,
              {
                value: c[x.actionId || ""],
                onChange: (S) => m(S, x.actionId || "", ""),
                style: f.getTextAreaInputStyles(),
                validateInputRegex: (S) => u(
                  S,
                  x.actionId
                ),
                textareatext: f.getTextAreaInputErrorText(),
                textareaErrorStyle: f.getTextAreaInputErrorStyles(),
                placeholder: (x == null ? void 0 : x.placeholder) || (x == null ? void 0 : x.question) || ""
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E);
        case "USER_INPUT_DATE":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Hu,
              {
                placeholder: (x == null ? void 0 : x.placeholder) || (x == null ? void 0 : x.question) || "",
                value: c[x.actionId || ""],
                onChange: (S) => m(S, x.actionId || "", ""),
                iconColor: f.getEmailIconColor(),
                style: f.getTextInputStyles(),
                preventFutureSelection: !1,
                preventPastSelection: !1,
                minDate: "",
                maxDate: ""
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E);
        case "USER_INPUT_SINGLE_CHOICE":
          return B.getSingleChoose() && (B.getSingleChoose() === "modal1" || B.getSingleChoose() === "modal2") ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              u3,
              {
                options: x.options || [],
                type: B.getSingleChoose(),
                onChange: (S) => m(
                  S,
                  x.actionId || "",
                  "radio"
                ),
                checked: c[x.actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              x == null ? void 0 : x.actionId
            ),
            (x == null ? void 0 : x.manualInput) !== !1 && c[x.actionId || ""] === (x == null ? void 0 : x.manualInput) && /* @__PURE__ */ h(
              Hi,
              {
                type: "text",
                onChange: (S) => m(
                  S,
                  x.actionId + "/manual",
                  ""
                ),
                value: c[x.actionId + "/manual"],
                placeholder: "Please fill manually",
                style: f.getTextInputStyles()
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E) : /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              y3,
              {
                options: x.options || [],
                type: B.getSingleChoose(),
                onChange: (S) => m(
                  { target: S },
                  x.actionId || "",
                  ""
                ),
                checked: c[x.actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E);
        case "USER_INPUT_MULTI_CHOICE":
          return B.getMultiChoice() && B.getMultiChoice() === "modal2" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              w3,
              {
                options: x.options || [],
                checked: !!c[x.actionId] && c[x.actionId],
                onChange: (S) => m(
                  S,
                  x.actionId || "",
                  "check"
                ),
                modalType: B.getMultiChoice(),
                style: f.getMultiChoiceStyles(),
                selectedStyle: f.getMultiChoiceSelectedStyles("modal2")
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E) : /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(x == null ? void 0 : x.question) || ""} ${x != null && x.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              C3,
              {
                options: x.options || [],
                checked: !!c[x.actionId] && c[x.actionId],
                onChange: (S) => m(
                  S,
                  x.actionId || "",
                  "check"
                ),
                modalType: B.getMultiChoice(),
                style: f.getMultiChoiceStyles(),
                selectedStyle: f.getMultiChoiceSelectedStyles("modal1")
              },
              x == null ? void 0 : x.actionId
            )
          ] }, E);
        default:
          return null;
      }
    }) : e == null ? void 0 : e.map((q, E) => {
      var x, M, O;
      switch (q.type) {
        case "USER_INPUT_TEXT":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Hi,
              {
                placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
                value: c[(q == null ? void 0 : q.actionId) || ""],
                regexKey: q == null ? void 0 : q.regexKey,
                regexMessage: q == null ? void 0 : q.regexMessage,
                validateInputRegex: (I) => u(I, q.actionId),
                errorText: f.getTextInputErrorText(),
                textErrorStyle: f.getTextInputErrorStyles(),
                onChange: (I) => m(I, q.actionId || "", ""),
                style: f.getTextInputStyles(),
                name: `input-${(x = w == null ? void 0 : w[d]) == null ? void 0 : x[E]}`
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        case "USER_INPUT_EMAIL":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Fu,
              {
                placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
                value: c[(q == null ? void 0 : q.actionId) || ""],
                iconColor: f.getEmailIconColor(),
                validateInputRegex: (I) => u(I, q.actionId),
                regexKey: q == null ? void 0 : q.regexKey,
                regexMessage: q == null ? void 0 : q.regexMessage,
                onChange: (I) => m(I, q.actionId || "", ""),
                style: f.getTextInputStyles(),
                emailtext: f.getEmailInputErrorText(),
                emailErrorStyle: f.getEMailInputErrorStyles(),
                name: `input-${(M = w == null ? void 0 : w[d]) == null ? void 0 : M[E]}`
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        case "USER_INPUT_PHONE":
        case "USER_INPUT_NUMBER":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Tu,
              {
                placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
                value: c[q.actionId || ""],
                iconColor: f.getEmailIconColor(),
                validateInputRegex: (I) => u(I, q.actionId),
                numbertext: f.getNumberInputErrorText(),
                numberErrorStyle: f.getNumberInputErrorStyles(),
                regexKey: q == null ? void 0 : q.regexKey,
                regexMessage: q == null ? void 0 : q.regexMessage,
                onChange: (I) => m(I, q.actionId || "", ""),
                style: f.getTextInputStyles(),
                name: `input-${(O = w == null ? void 0 : w[d]) == null ? void 0 : O[E]}`
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        case "USER_INPUT_TEXTAREA":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Mu,
              {
                value: c[q.actionId || ""],
                onChange: (I) => m(I, q.actionId || "", ""),
                style: f.getTextAreaInputStyles(),
                validateInputRegex: (I) => u(I, q.actionId),
                textareatext: f.getTextAreaInputErrorText(),
                textareaErrorStyle: f.getTextAreaInputErrorStyles(),
                placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || ""
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        case "USER_INPUT_DATE":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              Hu,
              {
                type: "date",
                placeholder: (q == null ? void 0 : q.placeholder) || (q == null ? void 0 : q.question) || "",
                value: c[q.actionId || ""],
                onChange: (I) => m(I, q.actionId || "", ""),
                iconColor: f.getEmailIconColor(),
                style: f.getTextInputStyles(),
                preventFutureSelection: !0,
                preventPastSelection: !0,
                minDate: "",
                maxDate: ""
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        case "USER_INPUT_SINGLE_CHOICE":
          return B.getSingleChoose() === "modal1" || B.getSingleChoose() === "modal2" ? /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              u3,
              {
                options: q.options || [],
                type: B.getSingleChoose(),
                onChange: (I) => m(I, q.actionId || "", "radio"),
                checked: c[q.actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              q == null ? void 0 : q.actionId
            ),
            (q == null ? void 0 : q.manualInput) != !1 && c[q.actionId || ""] == (q == null ? void 0 : q.manualInput) && /* @__PURE__ */ h(
              Hi,
              {
                type: "text",
                onChange: (I) => m(I, q.actionId + "/manual", ""),
                value: c[q.actionId + "/manual"],
                placeholder: "Please fill manually",
                style: f.getTextInputStyles()
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E) : /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            /* @__PURE__ */ h(
              y3,
              {
                options: q.options || [],
                type: B.getSingleChoose(),
                onChange: (I) => m({ target: I }, q.actionId || "", ""),
                checked: c[q.actionId || ""],
                style: f.getSingleChoiceStyles(),
                hoverBackground: f.getSingleChoiceHoverBackground(),
                selectedStyle: f.getSingleChoiceSelectedStyles()
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        case "USER_INPUT_MULTI_CHOICE":
          return /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
            /* @__PURE__ */ h(
              Kt,
              {
                htmlFor: "",
                style: f.getLabelStyles(),
                children: `${(q == null ? void 0 : q.question) || ""} ${q != null && q.required ? "*" : ""}`
              }
            ),
            B.getMultiChoice() === "modal2" ? /* @__PURE__ */ h(
              w3,
              {
                options: q.options || [],
                checked: !!c[q.actionId] && c[q.actionId],
                onChange: (I) => m(I, q.actionId || "", "check"),
                modalType: B.getMultiChoice(),
                style: f.getMultiChoiceStyles(),
                selectedStyle: f.getMultiChoiceSelectedStyles("modal2")
              },
              q == null ? void 0 : q.actionId
            ) : /* @__PURE__ */ h(
              C3,
              {
                options: q.options || [],
                checked: !!c[q.actionId] && c[q.actionId],
                onChange: (I) => m(I, q.actionId || "", "check"),
                modalType: B.getMultiChoice(),
                style: f.getMultiChoiceStyles(),
                selectedStyle: f.getMultiChoiceSelectedStyles("modal1")
              },
              q == null ? void 0 : q.actionId
            )
          ] }, E);
        default:
          return null;
      }
    }),
    e && e.length > 0 && (w && w.length > 1 ? i === "Buttons" || (o == null ? void 0 : o.controlBtnType) === "Buttons" ? /* @__PURE__ */ k("div", { className: "q-onb-main-criteria", children: [
      d > 0 && /* @__PURE__ */ h(
        JA,
        {
          style: {
            opacity: d === 0 ? "0" : "1",
            cursor: d === 0 ? "context-menu" : "pointer",
            borderColor: f.getSecondaryButtonStyles().borderColor,
            background: f.getSecondaryButtonStyles().background,
            color: f.getSecondaryButtonStyles().color,
            ...f.getSecondaryButtonStyles()
          },
          className: "q-onb-main-btn",
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_secondary_btn_clicked",
              "onboarding"
            ), d > 0 && g && g(d - 1);
          },
          children: "Previous"
        }
      ),
      /* @__PURE__ */ h(
        yr,
        {
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), l && l() && (b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), d !== w.length - 1 ? g && g(d + 1) : a && a());
          },
          type: "submit",
          disabled: !C || !(l && l()),
          className: "q-onb-main-btn2",
          style: {
            background: f.getPrimaryButtonStyles().background,
            ...f.getPrimaryButtonStyles()
          },
          children: d == w.length - 1 ? s || "Submit" : "Continue"
        }
      )
    ] }) : /* @__PURE__ */ k("div", { className: "q-onb-main-arrow-div", children: [
      /* @__PURE__ */ h(
        JA,
        {
          className: "q-onb-main-arrow",
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_secondary_btn_clicked",
              "onboarding"
            ), d > 0 && g && g(d - 1);
          },
          style: {
            opacity: d == 0 ? "0" : "1",
            cursor: d == 0 ? "context-menu" : "pointer",
            height: f.getSecondaryButtonAeroStyles().height,
            width: f.getSecondaryButtonAeroStyles().width,
            borderRadius: f.getSecondaryButtonAeroStyles().borderRadius,
            padding: f.getSecondaryButtonAeroStyles().padding,
            border: f.getSecondaryButtonAeroStyles().border || "1.5px solid #afafaf",
            borderColor: f.getSecondaryButtonAeroStyles().borderColor,
            backgroundColor: f.getSecondaryButtonAeroStyles().backgroundColor,
            color: f.getSecondaryButtonAeroStyles().color,
            ...f.getSecondaryButtonAeroStyles()
          },
          children: gT()
        }
      ),
      /* @__PURE__ */ h(
        yr,
        {
          className: "q-onb-main-arrow2",
          onClick: () => {
            b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), l && l() && (b.fireTrackingEvent(
              "quest_onboarding_primary_btn_clicked",
              "onboarding"
            ), d !== w.length - 1 ? g && g(d + 1) : a && a());
          },
          type: "submit",
          disabled: !C || !(l && l()),
          style: {
            height: f.getPrimaryButtonAeroStyles().height,
            width: f.getPrimaryButtonAeroStyles().width,
            borderRadius: f.getPrimaryButtonAeroStyles().borderRadius,
            padding: f.getPrimaryButtonAeroStyles().padding,
            border: f.getPrimaryButtonAeroStyles().border || "1.5px solid #D1ACFF",
            borderColor: f.getSecondaryButtonAeroStyles().borderColor,
            background: f.getPrimaryButtonAeroStyles().background,
            ...f.getPrimaryButtonAeroStyles()
          },
          children: pT()
        }
      )
    ] }) : /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
      yr,
      {
        className: "q-onb-main-btn3",
        onClick: () => {
          b.fireTrackingEvent(
            "quest_onboarding_single_page_submit_button_clicked",
            "onboarding"
          ), l && l() && (b.fireTrackingEvent(
            "quest_onboarding_primary_btn_clicked",
            "onboarding"
          ), d !== w.length - 1 ? g && g(d + 1) : a && a());
        },
        type: "submit",
        disabled: !C || !(l && l()),
        style: {
          border: f.getNormalButtonStyles().border,
          background: f.getNormalButtonStyles().background,
          ...f.getNormalButtonStyles()
        },
        children: s || "Continue"
      }
    ) }))
  ] }) });
}, uy = ({
  answer: t,
  getAnswers: e,
  questId: r,
  setAnswer: n,
  formdata: A = [],
  BrandTheme: i = b3,
  questThemeData: o = I2,
  controlBtnType: s,
  design: a = [],
  Headers: c = [],
  loadingTracker: l,
  multiChoice: u = "modal1",
  nextBtnText: f,
  onPageChange: d,
  progress: g,
  progressBarMultiLine: m,
  setLoading: p = () => {
  },
  showFooter: v = !0,
  singleChoose: C,
  styleConfig: w,
  template: B,
  children: y,
  ...b
}) => {
  const { themeConfig: q } = Xe(ct.Context), E = gt(null), [x, M] = N([]), [O, I] = N(0), [S, P] = N(!1), [H, F] = N([]), [T, U] = N(
    {}
  ), D = "1", Q = "", [Y, j] = N(
    c
  ), [Z, W] = N(B || "single-page"), [R, K] = N(0);
  le(() => {
    if (!A.length) return;
    let $;
    Z === "multi-question" ? ($ = A.map((ae, se) => se + 1), $ = $.filter(
      (ae) => H[O] && Array.isArray(H[O]) && H[O].includes(ae)
    )) : Z === "single-question" ? $ = [O + 1] : $ = A.map((ae, se) => se + 1);
    let te = $.reduce(
      (ae, se) => {
        const ue = A[se - 1];
        return !ue.required || ue.type === "LINK_OPEN_READ" || t[ue.actionId] && t[ue.actionId].length > 0 ? ae + 1 : ae;
      },
      0
    );
    P(
      $.length > 0 && te === $.length
    );
  }, [t, A, O]), le(() => {
    S ? M([...x, O]) : x.includes(O) && M(x.filter(($) => $ !== O));
  }, [S, O]), le(() => {
    d == null || d(O);
  }, [O]);
  const L = ($, te, ae) => {
    if (ae === "check") {
      const se = $.target.checked ? [...t[te] || [], $.target.value] : t[te].filter((ue) => ue !== $.target.value);
      n({ ...t, [te]: se });
    } else
      n({ ...t, [te]: $.target.value });
  }, G = () => (le(() => {
    E.current && E.current.clientWidth !== R && K(E.current.clientWidth);
  }, []), console.log(g, "lassan"), /* @__PURE__ */ h("div", { className: "q-onb-progress", children: /* @__PURE__ */ h(
    "div",
    {
      style: {
        gridTemplateColumns: g ? `repeat(${g.length}, 1fr)` : ""
      },
      ref: E,
      children: g == null ? void 0 : g.map(($, te) => /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k(
        "div",
        {
          className: "q-onb-progress-comp",
          style: {
            borderColor: x.includes(te) ? X.getProgressBarStyles() : te === O ? X.getProgressBarCurrentTabColor() : X.getProgressBarPendingTabColor()
          },
          children: [
            /* @__PURE__ */ h(
              "div",
              {
                style: {
                  maxWidth: `${(R - (g.length - 1) * 15) / g.length - 32}px`,
                  whiteSpace: m ? "normal" : "nowrap",
                  overflow: m ? "" : "hidden",
                  textOverflow: m ? "" : "ellipsis",
                  color: x.includes(te) ? X.getProgressBarStyles() : te === O ? X.getProgressBarCurrentTabColor() : X.getProgressBarPendingTabColor()
                },
                children: $
              }
            ),
            x.includes(te) && /* @__PURE__ */ k(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 21 20",
                fill: "none",
                children: [
                  /* @__PURE__ */ h(
                    "path",
                    {
                      opacity: "0.3",
                      d: "M10.8333 18.3333C15.4357 18.3333 19.1667 14.6023 19.1667 9.99996C19.1667 5.39759 15.4357 1.66663 10.8333 1.66663C6.23095 1.66663 2.49999 5.39759 2.49999 9.99996C2.49999 14.6023 6.23095 18.3333 10.8333 18.3333Z",
                      fill: "#098849"
                    }
                  ),
                  /* @__PURE__ */ h(
                    "path",
                    {
                      d: "M14.8074 6.51474C15.1215 6.17828 15.6488 6.1601 15.9853 6.47412C16.3217 6.78815 16.3399 7.31548 16.0259 7.65193L10.1925 13.9019C9.88787 14.2284 9.38003 14.2566 9.041 13.9661L6.12434 11.4661C5.7749 11.1665 5.73443 10.6404 6.03395 10.291C6.33347 9.94157 6.85955 9.9011 7.20899 10.2006L9.51916 12.1808L14.8074 6.51474Z",
                      fill: X.getProgressBarStyles()
                    }
                  )
                ]
              }
            )
          ]
        }
      ) }, te))
    }
  ) })), V = ($, te) => {
    U((ae) => ({ ...ae, [te]: $ }));
  }, _ = () => Object.values(T).filter(Boolean).length === Object.keys(T).length;
  function J() {
    if (O < H.length - 1) {
      I((te) => te + 1);
      return;
    }
    const $ = { ...t };
    for (const te of Object.keys($))
      if (te.includes("/manual") && $[te]) {
        const ae = te.split("/manual")[0], se = A.find((ue) => ue.actionId === ae);
        (se == null ? void 0 : se.manualInput) === $[ae] && ($[ae] = $[te]);
      }
    e == null || e($);
  }
  const X = new wM(
    q,
    w,
    o,
    i
  ), ne = new BM(
    s,
    a,
    c,
    l,
    u,
    f,
    g,
    m,
    v,
    C,
    B
  );
  le(() => {
    bM({
      template: ne.getTemplate(),
      design: ne == null ? void 0 : ne.getDesign(),
      setDesign: F,
      formdata: A
    });
  }, [A]);
  const ee = {
    formdata: A,
    headersArray: Y,
    currentPage: O,
    setCurrentPage: I,
    design: a,
    designState: H,
    progress: g,
    progressBarMultiLine: m,
    ProgressBar: G,
    template: B,
    singleChoose: C,
    multiChoice: u,
    answer: t,
    controlBtnType: s,
    nextBtnText: f,
    campaignId: r,
    btnFlag: S,
    returnAnswers: J,
    handleUpdate: L,
    validateInputRegex: V,
    checkValidationValues: _,
    themeManager: X,
    validationData: T,
    setAnswer: n,
    onboardingGetPropsFunctions: ne,
    campaignVariationId: D,
    apiSecret: Q,
    questionTemplate: Z
  };
  if (A.length != 0)
    return /* @__PURE__ */ h(Iv.Provider, { value: ee, children: A.length > 0 && /* @__PURE__ */ h(
      "div",
      {
        className: "q-onb-home",
        style: X.getContainerStyles(),
        ...b,
        children: /* @__PURE__ */ h("div", { className: "q-onb-ch", children: y || /* @__PURE__ */ k(Ze, { children: [
          /* @__PURE__ */ h($g, {}),
          /* @__PURE__ */ h(JN, {}),
          /* @__PURE__ */ h(s4, {})
        ] }) })
      }
    ) });
};
uy.Header = $g;
uy.Content = JN;
uy.Footer = s4;
const fc = ({ type: t, color: e = "#939393" }) => /* @__PURE__ */ h(Ze, { children: ((n, A) => {
  switch (n) {
    case "arrowRight":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.67461 2.95369C5.88428 2.77398 6.19993 2.79826 6.37964 3.00793L10.3796 7.67459C10.5401 7.86184 10.5401 8.13814 10.3796 8.32538L6.37964 12.9921C6.19993 13.2017 5.88428 13.226 5.67461 13.0463C5.46495 12.8666 5.44067 12.5509 5.62038 12.3413L9.34147 7.99999L5.62038 3.65872C5.44067 3.44905 5.46495 3.1334 5.67461 2.95369Z", fill: A }) });
    case "downArrowIcon":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.95369 5.6746C3.1334 5.46494 3.44905 5.44065 3.65872 5.62037L7.99999 9.34146L12.3413 5.62037C12.5509 5.44065 12.8666 5.46494 13.0463 5.6746C13.226 5.88426 13.2017 6.19991 12.9921 6.37962L8.32538 10.3796C8.13814 10.5401 7.86184 10.5401 7.67459 10.3796L3.00793 6.37962C2.79826 6.19991 2.77398 5.88426 2.95369 5.6746Z", fill: A }) });
    case "greenCheck":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { d: "M11.5303 5.46967C11.8232 5.76256 11.8232 6.23744 11.5303 6.53033L7.53033 10.5303C7.24166 10.819 6.77511 10.8238 6.4806 10.541L4.4806 8.62104C4.18179 8.33418 4.1721 7.85941 4.45896 7.5606C4.74582 7.26179 5.22059 7.2521 5.5194 7.53896L6.98929 8.95005L10.4697 5.46967C10.7626 5.17678 11.2374 5.17678 11.5303 5.46967Z", fill: A }) });
    case "upArrow":
      return /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.67459 5.62037C7.86184 5.45988 8.13814 5.45988 8.32538 5.62037L12.9921 9.62037C13.2017 9.80008 13.226 10.1157 13.0463 10.3254C12.8666 10.5351 12.5509 10.5593 12.3413 10.3796L7.99999 6.65854L3.65872 10.3796C3.44905 10.5593 3.1334 10.5351 2.95369 10.3254C2.77398 10.1157 2.79826 9.80008 3.00793 9.62037L7.67459 5.62037Z", fill: A }) });
    default:
      return null;
  }
})(t, e) });
function DFe({
  iconUrls: t = [],
  headingText: e,
  descriptionText: r,
  autoHide: n,
  Headers: A,
  showProgressBar: i = !1,
  template: o = 1,
  arrowColor: s,
  showLoadingIndicator: a = !0,
  allowMultiClick: c = !1,
  showFooter: l = !0,
  styleConfig: u,
  offlineData: f = [],
  ButtonType: d = "Arrow",
  BrandTheme: g,
  QuestThemeData: m,
  onLinkTrigger: p = (C, w) => {
    window.location.href = C;
  },
  isImageOpen: v = !1
}) {
  var H, F, T, U, D, Q, Y, j, Z, W, R, K, L, G, V, _, J, X;
  const [C, w] = N(!1), [B, y] = N(!1), { themeConfig: b, apiType: q } = Xe(ct.Context), [E, x] = N([]), [M, O] = N(f), I = M != null && M.length ? (M == null ? void 0 : M.reduce((ne, ee) => ne + (ee.completed ? 1 : 0), 0)) * 100 / (M == null ? void 0 : M.length) : 0;
  le(() => {
    f != null && f.length && O(f);
  }, [f]);
  let S = new Bt("mixpanel", q);
  const P = (ne, ee) => {
    const $ = M.map((te, ae) => ((te == null ? void 0 : te.criteriaId) == ne && (te.completed = !0, p(ee, ae)), te));
    O($);
  };
  return le(() => {
    S.fireTrackingEvent(
      "quest_get_started_offline_loaded",
      "get_started_offline"
    ), x(new Array(f.length).fill(!1));
  }, []), /* @__PURE__ */ k(
    "div",
    {
      style: {
        background: ((H = u == null ? void 0 : u.Form) == null ? void 0 : H.backgroundColor) || (g == null ? void 0 : g.background) || (b == null ? void 0 : b.backgroundColor),
        height: ((F = u == null ? void 0 : u.Form) == null ? void 0 : F.height) || "auto",
        borderRadius: ((T = u == null ? void 0 : u.Form) == null ? void 0 : T.borderRadius) || (m == null ? void 0 : m.borderRadius) || (g == null ? void 0 : g.borderRadius),
        fontFamily: (g == null ? void 0 : g.fontFamily) || b.fontFamily || "'Figtree', sans-serif",
        ...u == null ? void 0 : u.Form
      },
      className: "get_started_box",
      children: [
        a && C && /* @__PURE__ */ h(rl, {}),
        (n === !0 ? !!M.length && !B : !0) && /* @__PURE__ */ h("div", { className: "gs-heading-div", style: { ...u == null ? void 0 : u.Topbar }, children: /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h(
            "div",
            {
              style: {
                color: ((U = u == null ? void 0 : u.Heading) == null ? void 0 : U.color) || (g == null ? void 0 : g.titleColor) || (g == null ? void 0 : g.primaryColor) || (b == null ? void 0 : b.primaryColor),
                ...u == null ? void 0 : u.Heading
              },
              className: "gs-heading",
              children: Array.isArray(A) && ((D = A[0]) == null ? void 0 : D.heading) || "Quickstart Guide"
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              style: {
                color: ((Q = u == null ? void 0 : u.Description) == null ? void 0 : Q.color) || (g == null ? void 0 : g.secondaryColor) || (b == null ? void 0 : b.secondaryColor),
                ...u == null ? void 0 : u.Description
              },
              className: "gs-subheading",
              children: Array.isArray(A) && ((Y = A[0]) == null ? void 0 : Y.subHeading) || "Get started with Quest and explore how Quest can take your customer engagement to the next level"
            }
          )
        ] }) }),
        (n === !0 ? !!M.length && !B : !0) && i && /* @__PURE__ */ k("div", { className: "q_gt_progress", children: [
          /* @__PURE__ */ k("div", { className: "q_progress_percentage", children: [
            Math.floor(I) || 0,
            "% Completed"
          ] }),
          /* @__PURE__ */ h("div", { className: "q_gt_progress_bar", children: /* @__PURE__ */ h(
            "div",
            {
              className: "q_progress_bar_completed",
              style: { width: `${I}%` }
            }
          ) })
        ] }),
        /* @__PURE__ */ h(
          "div",
          {
            className: "gs-cards-container",
            style: {
              padding: i ? "0px 20px 20px 20px" : "20px",
              gap: o == 2 ? ((j = u == null ? void 0 : u.CardContainer) == null ? void 0 : j.gap) || "0px" : ((Z = u == null ? void 0 : u.CardContainer) == null ? void 0 : Z.gap) || "16px",
              ...u == null ? void 0 : u.CardContainer
            },
            children: (n === !0 ? !B : !0) && (M == null ? void 0 : M.length) && M.map(
              (ne, ee) => {
                var $, te, ae, se, ue, fe, ve, ge, oe, ce, pe, qe, Se, Te, be, He, Ge, Le, Ae, Pe, it, de, xe, he, Qe, Re;
                return o == 2 ? /* @__PURE__ */ k(
                  "div",
                  {
                    style: {
                      ...u == null ? void 0 : u.Card
                    },
                    onClick: () => {
                      S.fireTrackingEvent(
                        "quest_get_started_offline_link_clicked",
                        "get_started_offline"
                      ), x(
                        (pt) => pt.map((ze, lt) => ee === lt ? !ze : ze)
                      );
                    },
                    className: "gs-single-card-dropDown",
                    children: [
                      /* @__PURE__ */ k("div", { className: "gs_card_body_dropDown", children: [
                        E[ee] ? v ? "" : /* @__PURE__ */ h(
                          "div",
                          {
                            className: "gs_card_body_image",
                            style: { ...u == null ? void 0 : u.Icon },
                            children: /* @__PURE__ */ h(
                              "img",
                              {
                                className: "gs-card-icon",
                                src: ne.imageUrl || (t.length ? t == null ? void 0 : t[ee] : "") || Jn,
                                alt: ""
                              }
                            )
                          }
                        ) : /* @__PURE__ */ h(
                          "div",
                          {
                            className: "gs_card_body_image",
                            style: { ...u == null ? void 0 : u.Icon },
                            children: /* @__PURE__ */ h(
                              "img",
                              {
                                className: "gs-card-icon",
                                src: ne.imageUrl || (t.length ? t == null ? void 0 : t[ee] : "") || Jn,
                                alt: ""
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ k("div", { className: "gs-card-text", children: [
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: (($ = u == null ? void 0 : u.Heading) == null ? void 0 : $.color) || (g == null ? void 0 : g.primaryColor) || (b == null ? void 0 : b.primaryColor)
                              },
                              className: "gs-card-head",
                              children: ne.title
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: ((te = u == null ? void 0 : u.Description) == null ? void 0 : te.color) || (g == null ? void 0 : g.secondaryColor) || (b == null ? void 0 : b.secondaryColor)
                              },
                              className: "gs-card-desc",
                              children: ne.description
                            }
                          )
                        ] }),
                        /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h("div", { className: "gs-card-img-button", children: ne.completed ? /* @__PURE__ */ h(
                          "div",
                          {
                            className: "q_gt_arrow-completed",
                            style: {
                              background: (ae = u == null ? void 0 : u.Arrow) == null ? void 0 : ae.CompletedBackground
                            },
                            children: /* @__PURE__ */ h(
                              fc,
                              {
                                type: "greenCheck",
                                color: ((se = u == null ? void 0 : u.Arrow) == null ? void 0 : se.CompletedIconColor) || "#098849"
                              }
                            )
                          }
                        ) : /* @__PURE__ */ h(
                          "div",
                          {
                            className: "q_gt_arrow",
                            style: {
                              background: (ue = u == null ? void 0 : u.Arrow) == null ? void 0 : ue.Background
                            },
                            children: E[ee] ? /* @__PURE__ */ h(
                              fc,
                              {
                                type: "upArrow",
                                color: ((fe = u == null ? void 0 : u.Arrow) == null ? void 0 : fe.IconColor) || s
                              }
                            ) : ne.completed ? /* @__PURE__ */ h(
                              fc,
                              {
                                type: "greenCheck",
                                color: ((ve = u == null ? void 0 : u.Arrow) == null ? void 0 : ve.CompletedIconColor) || "#098849"
                              }
                            ) : /* @__PURE__ */ h(
                              fc,
                              {
                                type: "downArrowIcon",
                                color: ((ge = u == null ? void 0 : u.Arrow) == null ? void 0 : ge.IconColor) || s
                              }
                            )
                          }
                        ) }) })
                      ] }),
                      E[ee] && /* @__PURE__ */ k("div", { className: "gs_card_dropdown", children: [
                        v && /* @__PURE__ */ h(
                          "div",
                          {
                            className: "card-drop-down-cont",
                            style: {
                              ...(oe = u == null ? void 0 : u.IsImageOpen) == null ? void 0 : oe.ContainerDiv
                            },
                            children: /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  ...(pe = (ce = u == null ? void 0 : u.IsImageOpen) == null ? void 0 : ce.ImageContainer) == null ? void 0 : pe.ImageContainerProperties
                                },
                                children: /* @__PURE__ */ h(
                                  "img",
                                  {
                                    src: ne.imageUrl || (t.length ? t == null ? void 0 : t[ee] : "") || Jn,
                                    alt: "",
                                    style: {
                                      ...(Se = (qe = u == null ? void 0 : u.IsImageOpen) == null ? void 0 : qe.ImageContainer) == null ? void 0 : Se.Image
                                    }
                                  }
                                )
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ h(
                          "div",
                          {
                            className: "gs_drop_desc",
                            style: {
                              color: ((Te = u == null ? void 0 : u.Description) == null ? void 0 : Te.color) || (g == null ? void 0 : g.secondaryColor) || (b == null ? void 0 : b.secondaryColor)
                            },
                            children: ne.longDescription
                          }
                        ),
                        /* @__PURE__ */ k("div", { className: "gs_drop_btns", children: [
                          /* @__PURE__ */ h(
                            yr,
                            {
                              className: "gs_start_btn",
                              children: ne.btn2 || "Start Now",
                              onClick: (pt) => {
                                S.fireTrackingEvent(
                                  "quest_get_started_offline_primary_button_clicked",
                                  "get_started_offline"
                                ), pt.stopPropagation(), !(!c && ne.completed) && P(ne.criteriaId, ne.url);
                              },
                              disabled: !c && ne.completed,
                              style: {
                                flex: "inherit",
                                width: "fit-content",
                                background: ((be = u == null ? void 0 : u.PrimaryButton) == null ? void 0 : be.background) || (m == null ? void 0 : m.buttonColor) || (g == null ? void 0 : g.primaryButton) || (b == null ? void 0 : b.buttonColor),
                                ...u == null ? void 0 : u.PrimaryButton
                              }
                            }
                          ),
                          /* @__PURE__ */ h(
                            JA,
                            {
                              style: {
                                background: ((He = u == null ? void 0 : u.SecondaryButton) == null ? void 0 : He.background) || (g == null ? void 0 : g.secondaryButton),
                                ...u == null ? void 0 : u.SecondaryButton,
                                flex: "inherit",
                                width: "fit-content"
                              },
                              onClick: () => {
                                S.fireTrackingEvent(
                                  "quest_get_started_offline_secondary_button_clicked",
                                  "get_started_offline"
                                ), window.open(ne.btn1Link);
                              },
                              className: "gs_visit_btn",
                              children: ne.btn1 || "Visit Website"
                            }
                          )
                        ] })
                      ] })
                    ]
                  },
                  ee
                ) : /* @__PURE__ */ h(
                  "div",
                  {
                    className: "gs-single-card",
                    onClick: () => {
                      S.fireTrackingEvent(
                        "quest_get_started_offline_link_clicked",
                        "get_started_offline"
                      ), !(!c && ne.completed) && P(ne.criteriaId, ne.url);
                    },
                    children: /* @__PURE__ */ k(
                      "div",
                      {
                        className: "gs_card_body",
                        style: {
                          ...u == null ? void 0 : u.Card
                        },
                        children: [
                          /* @__PURE__ */ h(
                            "div",
                            {
                              className: "gs_card_body_image",
                              style: { ...u == null ? void 0 : u.Icon },
                              children: /* @__PURE__ */ h(
                                "img",
                                {
                                  className: "gs-card-icon",
                                  width: "24px",
                                  src: ne.imageUrl || (t.length ? t == null ? void 0 : t[ee] : "") || Jn,
                                  alt: ""
                                }
                              )
                            }
                          ),
                          /* @__PURE__ */ k("div", { className: "gs-card-text", children: [
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: ((Ge = u == null ? void 0 : u.Heading) == null ? void 0 : Ge.color) || (g == null ? void 0 : g.primaryColor) || (b == null ? void 0 : b.primaryColor)
                                },
                                className: "gs-card-head",
                                children: ne.title
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: ((Le = u == null ? void 0 : u.Description) == null ? void 0 : Le.color) || (g == null ? void 0 : g.secondaryColor) || (b == null ? void 0 : b.secondaryColor)
                                },
                                className: "gs-card-desc",
                                children: ne.description
                              }
                            )
                          ] }),
                          d === "Buttons" && (ne.completed ? /* @__PURE__ */ h("div", { className: "gs-card-img-button", children: /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q_gt_arrow-completed",
                              style: {
                                background: (it = u == null ? void 0 : u.Arrow) == null ? void 0 : it.CompletedBackground
                              },
                              children: /* @__PURE__ */ h(
                                fc,
                                {
                                  type: "greenCheck",
                                  color: ((de = u == null ? void 0 : u.Arrow) == null ? void 0 : de.CompletedIconColor) || "#098849"
                                }
                              )
                            }
                          ) }) : /* @__PURE__ */ k("div", { className: "gs_drop_btns", children: [
                            /* @__PURE__ */ h(
                              JA,
                              {
                                style: {
                                  background: ((Ae = u == null ? void 0 : u.SecondaryButton) == null ? void 0 : Ae.background) || (g == null ? void 0 : g.secondaryButton),
                                  flex: "inherit",
                                  width: "fit-content",
                                  border: "none",
                                  ...u == null ? void 0 : u.SecondaryButton
                                },
                                onClick: (pt) => {
                                  S.fireTrackingEvent(
                                    "quest_get_started_offline_secondary_button_clicked",
                                    "get_started_offline"
                                  ), pt.stopPropagation(), window.open(ne.btn1Link);
                                },
                                className: "gs_visit_btn gs_tempalate1_btn",
                                children: ne.btn1 || "Visit Website"
                              }
                            ),
                            /* @__PURE__ */ h(
                              yr,
                              {
                                className: "gs_start_btn",
                                children: ne.btn2 || "Start Now",
                                onClick: (pt) => {
                                  S.fireTrackingEvent(
                                    "quest_get_started_offline_primary_button_clicked",
                                    "get_started_offline"
                                  ), pt.stopPropagation(), !(!c && ne.completed) && P(ne.criteriaId, ne.url);
                                },
                                disabled: !c && ne.completed,
                                style: {
                                  flex: "inherit",
                                  width: "fit-content",
                                  background: ((Pe = u == null ? void 0 : u.PrimaryButton) == null ? void 0 : Pe.background) || (m == null ? void 0 : m.buttonColor) || (g == null ? void 0 : g.primaryButton) || (b == null ? void 0 : b.buttonColor),
                                  ...u == null ? void 0 : u.PrimaryButton
                                }
                              }
                            )
                          ] })),
                          d === "Arrow" && /* @__PURE__ */ h("div", { className: "gs-card-img-button", children: ne.completed ? /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q_gt_arrow-completed",
                              style: {
                                background: (xe = u == null ? void 0 : u.Arrow) == null ? void 0 : xe.CompletedBackground
                              },
                              children: /* @__PURE__ */ h(
                                fc,
                                {
                                  type: "greenCheck",
                                  color: ((he = u == null ? void 0 : u.Arrow) == null ? void 0 : he.CompletedIconColor) || "#098849"
                                }
                              )
                            }
                          ) : /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q_gt_arrow",
                              style: { background: (Qe = u == null ? void 0 : u.Arrow) == null ? void 0 : Qe.Background },
                              children: /* @__PURE__ */ h(
                                fc,
                                {
                                  type: "arrowRight",
                                  color: ((Re = u == null ? void 0 : u.Arrow) == null ? void 0 : Re.IconColor) || s
                                }
                              )
                            }
                          ) })
                        ]
                      }
                    )
                  },
                  ee
                );
              }
            )
          }
        ),
        l && (n === !0 ? !!M.length && !B : !0) && /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
          Pr,
          {
            style: {
              background: ((R = (W = u == null ? void 0 : u.Footer) == null ? void 0 : W.FooterStyle) == null ? void 0 : R.backgroundColor) || ((K = u == null ? void 0 : u.Form) == null ? void 0 : K.backgroundColor) || ((L = u == null ? void 0 : u.Form) == null ? void 0 : L.background) || (g == null ? void 0 : g.background) || (b == null ? void 0 : b.backgroundColor),
              ...(G = u == null ? void 0 : u.Footer) == null ? void 0 : G.FooterStyle
            },
            textStyle: (V = u == null ? void 0 : u.Footer) == null ? void 0 : V.FooterTextStyle,
            iconStyle: (_ = u == null ? void 0 : u.Footer) == null ? void 0 : _.FooterIcon,
            text: (J = u == null ? void 0 : u.Footer) == null ? void 0 : J.FooterText,
            link: (X = u == null ? void 0 : u.Footer) == null ? void 0 : X.FooterLink
          }
        ) })
      ]
    }
  );
}
function QFe(t) {
  var Q, Y, j, Z, W, R, K, L, G, V, _, J, X, ne, ee, $, te, ae, se, ue, fe, ve, ge, oe, ce, pe, qe, Se, Te, be, He, Ge, Le;
  const {
    wholerScreen: e = !0,
    defaultResult: r = [],
    defulatResultLength: n = 10,
    onSearch: A = (Ae) => {
    },
    questId: i = "",
    token: o = "",
    userId: s = "",
    onResultClick: a = (Ae) => window.open(Ae, "_blank"),
    styleConfig: c,
    showFooter: l = !0,
    iconColor: u,
    offlineFormatData: f = [],
    BrandTheme: d,
    QuestThemeData: g,
    autoFocus: m = !1,
    footerText: p = "Powered by PLG OS",
    footerLink: v
  } = t, C = gt(null), [w, B] = N(r), [y, b] = N(!1), [q, E] = N(0), { themeConfig: x, apiType: M } = Xe(ct.Context), [O, I] = N([]);
  let S = new Bt("mixpanel", M);
  const P = (Ae) => {
    y && w.length > 0 && (Ae.key === "ArrowDown" ? (Ae.preventDefault(), E(
      (Pe) => Pe === null ? 0 : Math.min(Pe + 1, w.length - 1)
    )) : Ae.key === "ArrowUp" ? (Ae.preventDefault(), E(
      (Pe) => Pe === null ? 0 : Math.max(Pe - 1, 0)
    )) : Ae.key === "Enter" && q !== null && a(w[q].link));
  }, H = (Ae) => {
    (Ae.ctrlKey || Ae.metaKey) && !Ae.altKey && Ae.key === "k" ? (S.fireTrackingEvent(
      "quest_spotlight_search_offline_ctrl_k_pressed",
      "spotlight_search_offline"
    ), Ae.preventDefault(), b((it) => !it)) : Ae.key == "Escape" && b(!1);
  };
  le(() => {
    var Ae;
    y && ((Ae = C.current) == null || Ae.focus());
  }, [y]), le(() => {
    var Ae;
    return I([...f].splice(0, n)), B([...f].splice(0, n)), t.open === !0 && b(!0), m && ((Ae = C.current) == null || Ae.focus()), window.addEventListener("keydown", H), () => {
      window.removeEventListener("keydown", H);
    };
  }, [f]);
  const F = (Ae) => {
    if (!O.length) return;
    const Pe = O.filter(
      (it) => it.text.toLocaleLowerCase().includes(Ae.toLocaleLowerCase())
    );
    B(Pe);
  };
  le(() => {
    S.fireTrackingEvent(
      "quest_spotlight_search_offline_loaded",
      "spotlight_search_offline"
    );
  }, []);
  const T = /* @__PURE__ */ k(
    "div",
    {
      className: "q_search_bar",
      style: {
        background: ((Q = c == null ? void 0 : c.Form) == null ? void 0 : Q.backgroundColor) || (d == null ? void 0 : d.background) || (x == null ? void 0 : x.backgroundColor),
        height: ((Y = c == null ? void 0 : c.Form) == null ? void 0 : Y.height) || "auto",
        fontFamily: x.fontFamily || (d == null ? void 0 : d.fontFamily) || "'Figtree', sans-serif",
        borderRadius: ((j = c == null ? void 0 : c.Form) == null ? void 0 : j.borderRadius) || (g == null ? void 0 : g.borderRadius) || (d == null ? void 0 : d.borderRadius),
        ...c == null ? void 0 : c.Form
      },
      children: [
        /* @__PURE__ */ k("div", { className: "q_search_box", style: { ...c == null ? void 0 : c.Topbar }, children: [
          /* @__PURE__ */ h(
            "img",
            {
              className: "q_search_bar_icon",
              src: Vp(t.iconColor),
              alt: ""
            }
          ),
          /* @__PURE__ */ h("div", { className: "q_searchBox_input_cont", children: /* @__PURE__ */ h(
            "div",
            {
              className: "q_input_cont",
              style: {
                borderColor: ((Z = c == null ? void 0 : c.Input) == null ? void 0 : Z.borderColor) || (x == null ? void 0 : x.borderColor),
                padding: "0px"
              },
              children: /* @__PURE__ */ h(
                "input",
                {
                  type: "text",
                  placeholder: t.placeholder,
                  ref: C,
                  onKeyDown: P,
                  onChange: (Ae) => {
                    A(Ae.target.value), F(Ae.target.value);
                  },
                  style: {
                    color: ((W = c == null ? void 0 : c.Input) == null ? void 0 : W.color) || (d == null ? void 0 : d.primaryColor) || x.primaryColor,
                    ...c == null ? void 0 : c.Input
                  },
                  className: "q_input_main_cont"
                }
              )
            }
          ) }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_search_command_key",
              style: { ...c == null ? void 0 : c.CommandButton },
              children: /* @__PURE__ */ h(
                "img",
                {
                  src: Wp(((R = c == null ? void 0 : c.CommandButton) == null ? void 0 : R.color) || u),
                  alt: ""
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ k("div", { className: "q_flex_box", children: [
          /* @__PURE__ */ h("div", { className: "q_search_results", children: w.map(({ icon: Ae, text: Pe, link: it, description: de }, xe) => {
            var he, Qe, Re, pt, ze, lt, st, We, Je;
            return /* @__PURE__ */ k(
              "div",
              {
                className: "q_search_res_box " + (xe === q && "q_heilight_search"),
                style: {
                  background: xe === q ? (he = c == null ? void 0 : c.listHover) == null ? void 0 : he.background : "transparent"
                },
                onClick: () => {
                  S.fireTrackingEvent(
                    "quest_spotlight_search_offline_link_clicked",
                    "spotlight_search_offline"
                  ), a(it);
                },
                onMouseEnter: () => E(xe),
                onMouseLeave: () => E(0),
                children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-search-img-cont",
                      style: {
                        background: xe === q ? (Qe = c == null ? void 0 : c.listHover) == null ? void 0 : Qe.iconBackground : "#f4ebff"
                      },
                      children: /* @__PURE__ */ h(
                        "img",
                        {
                          src: ((Re = t.icons) == null ? void 0 : Re.length) && t.icons[xe] || Ae || Jn,
                          className: "q_search_result_icon",
                          alt: ""
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q_search_result_box", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: xe === q ? ((pt = c == null ? void 0 : c.listHover) == null ? void 0 : pt.Heading) || (d == null ? void 0 : d.primaryColor) || (x == null ? void 0 : x.primaryColor) || ((ze = c == null ? void 0 : c.Heading) == null ? void 0 : ze.color) : ((lt = c == null ? void 0 : c.Heading) == null ? void 0 : lt.color) || (d == null ? void 0 : d.primaryColor) || (x == null ? void 0 : x.primaryColor),
                          ...c == null ? void 0 : c.Heading
                        },
                        className: "q_search_result_head",
                        children: Pe
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: xe === q ? ((st = c == null ? void 0 : c.listHover) == null ? void 0 : st.Description) || ((We = c == null ? void 0 : c.Description) == null ? void 0 : We.color) || (d == null ? void 0 : d.secondaryColor) || (x == null ? void 0 : x.secondaryColor) : ((Je = c == null ? void 0 : c.Description) == null ? void 0 : Je.color) || (d == null ? void 0 : d.secondaryColor) || (x == null ? void 0 : x.secondaryColor),
                          ...c == null ? void 0 : c.Description
                        },
                        className: "q_search_result_desc",
                        children: de || "Provide the required information"
                      }
                    )
                  ] })
                ]
              },
              xe
            );
          }) }),
          t.searchDetails && /* @__PURE__ */ k("div", { className: "q_search_result_details", children: [
            /* @__PURE__ */ h(
              "img",
              {
                src: ((K = w[q]) == null ? void 0 : K.icon) || Jn,
                alt: ""
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                style: {
                  color: ((L = c == null ? void 0 : c.Heading) == null ? void 0 : L.color) || (d == null ? void 0 : d.primaryColor) || x.primaryColor,
                  ...c == null ? void 0 : c.Heading
                },
                className: "q_search_details_head",
                children: (G = w[q]) == null ? void 0 : G.text
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                style: {
                  color: ((V = c == null ? void 0 : c.Description) == null ? void 0 : V.color) || (d == null ? void 0 : d.secondaryColor) || x.secondaryColor,
                  ...c == null ? void 0 : c.Description
                },
                className: "q_search_result_desc",
                children: ((_ = w[q]) == null ? void 0 : _.longDescription) || ((J = w[q]) == null ? void 0 : J.description)
              }
            ),
            t.buttonText && /* @__PURE__ */ h("div", { className: "q_search_result_button1", children: t.buttonText }),
            /* @__PURE__ */ h("div", { className: "q_search_result_button2", children: "Learn more" })
          ] })
        ] }),
        l && /* @__PURE__ */ h(
          Pr,
          {
            style: {
              background: ((ne = (X = c == null ? void 0 : c.Footer) == null ? void 0 : X.FooterStyle) == null ? void 0 : ne.backgroundColor) || ((ee = c == null ? void 0 : c.Form) == null ? void 0 : ee.backgroundColor) || (($ = c == null ? void 0 : c.Form) == null ? void 0 : $.background) || (d == null ? void 0 : d.background) || (x == null ? void 0 : x.backgroundColor),
              ...(te = c == null ? void 0 : c.Footer) == null ? void 0 : te.FooterStyle
            },
            textStyle: (ae = c == null ? void 0 : c.Footer) == null ? void 0 : ae.FooterText,
            iconStyle: (se = c == null ? void 0 : c.Footer) == null ? void 0 : se.FooterIcon,
            text: p,
            link: v
          }
        )
      ]
    }
  ), U = /* @__PURE__ */ k("div", { className: "q_search_bar", children: [
    /* @__PURE__ */ k("div", { className: "q_search_box", style: { ...c == null ? void 0 : c.Topbar }, children: [
      /* @__PURE__ */ h(
        "img",
        {
          className: "q_search_bar_icon",
          src: Vp(x.secondaryColor),
          alt: ""
        }
      ),
      /* @__PURE__ */ h("div", { className: "q_searchBox_input_cont", children: /* @__PURE__ */ h(
        "div",
        {
          className: "q_input_cont",
          style: {
            borderColor: ((ue = c == null ? void 0 : c.Input) == null ? void 0 : ue.borderColor) || (x == null ? void 0 : x.borderColor),
            padding: "0px"
          },
          children: /* @__PURE__ */ h(
            "input",
            {
              type: "text",
              placeholder: t.placeholder,
              ref: C,
              onKeyDown: P,
              onChange: (Ae) => {
                A(Ae.target.value), F(Ae.target.value);
              },
              style: {
                color: ((fe = c == null ? void 0 : c.Input) == null ? void 0 : fe.color) || (d == null ? void 0 : d.primaryColor) || x.primaryColor,
                ...c == null ? void 0 : c.Input
              },
              className: "q_input_main_cont"
            }
          )
        }
      ) }),
      /* @__PURE__ */ h(
        "div",
        {
          className: "q_search_command_key",
          style: { ...c == null ? void 0 : c.CommandButton },
          children: /* @__PURE__ */ h(
            "img",
            {
              src: Wp(((ve = c == null ? void 0 : c.CommandButton) == null ? void 0 : ve.color) || u),
              alt: ""
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ k("div", { className: "q_flex_box", children: [
      /* @__PURE__ */ k("div", { className: "q_search_result_sections", children: [
        /* @__PURE__ */ h("div", { className: "q_search_result_section_name", children: "Commands" }),
        /* @__PURE__ */ h("div", { className: "", children: w.map(
          ({ icon: Ae, text: Pe, link: it, resultType: de, description: xe }, he) => {
            var Qe, Re, pt, ze, lt, st, We, Je;
            return de == "action" && /* @__PURE__ */ k(
              "div",
              {
                className: "q_search_res_box " + (he === q && "q_heilight_search"),
                onClick: () => {
                  window.open(it, "_blank");
                },
                style: {
                  background: he === q ? (Qe = c == null ? void 0 : c.listHover) == null ? void 0 : Qe.background : "transparent"
                },
                onMouseEnter: () => E(he),
                onMouseLeave: () => E(0),
                children: [
                  /* @__PURE__ */ h(
                    "img",
                    {
                      className: "q_search_result_icon",
                      src: ((Re = t.icons) == null ? void 0 : Re.length) && t.icons[he] || Ae || Jn,
                      alt: ""
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q_search_result_box", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: he === q ? ((pt = c == null ? void 0 : c.listHover) == null ? void 0 : pt.Heading) || ((ze = c == null ? void 0 : c.Heading) == null ? void 0 : ze.color) || (d == null ? void 0 : d.primaryColor) || (x == null ? void 0 : x.primaryColor) : ((lt = c == null ? void 0 : c.Heading) == null ? void 0 : lt.color) || (d == null ? void 0 : d.primaryColor) || (x == null ? void 0 : x.primaryColor),
                          ...c == null ? void 0 : c.Heading
                        },
                        className: "q_search_result_head",
                        children: Pe
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: he === q ? ((st = c == null ? void 0 : c.listHover) == null ? void 0 : st.Description) || ((We = c == null ? void 0 : c.Description) == null ? void 0 : We.color) || (d == null ? void 0 : d.secondaryColor) || (x == null ? void 0 : x.secondaryColor) : ((Je = c == null ? void 0 : c.Description) == null ? void 0 : Je.color) || (d == null ? void 0 : d.secondaryColor) || (x == null ? void 0 : x.secondaryColor),
                          ...c == null ? void 0 : c.Description
                        },
                        className: "q_search_result_desc",
                        children: xe
                      }
                    )
                  ] })
                ]
              },
              he
            );
          }
        ) }),
        /* @__PURE__ */ h("div", { className: "q_search_result_section_name", children: "Actions" }),
        /* @__PURE__ */ h("div", { className: "", children: w.map(
          ({ icon: Ae, text: Pe, link: it, resultType: de, description: xe }, he) => {
            var Qe, Re, pt, ze, lt, st, We, Je;
            return de == "command" && /* @__PURE__ */ k(
              "div",
              {
                className: "q_search_res_box " + (he === q && "q_heilight_search"),
                onClick: () => {
                  window.open(it, "_blank");
                },
                onMouseEnter: () => E(he),
                onMouseLeave: () => E(0),
                style: {
                  background: he === q ? (Qe = c == null ? void 0 : c.listHover) == null ? void 0 : Qe.background : "transparent"
                },
                children: [
                  /* @__PURE__ */ h(
                    "img",
                    {
                      src: ((Re = t.icons) == null ? void 0 : Re.length) && t.icons[he] || Ae || Jn,
                      alt: "",
                      className: "q_search_result_icon"
                    }
                  ),
                  /* @__PURE__ */ k("div", { className: "q_search_result_box", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: he === q ? ((pt = c == null ? void 0 : c.listHover) == null ? void 0 : pt.Heading) || ((ze = c == null ? void 0 : c.Heading) == null ? void 0 : ze.color) || (d == null ? void 0 : d.primaryColor) || (x == null ? void 0 : x.primaryColor) : ((lt = c == null ? void 0 : c.Heading) == null ? void 0 : lt.color) || (d == null ? void 0 : d.primaryColor) || (x == null ? void 0 : x.primaryColor),
                          ...c == null ? void 0 : c.Heading
                        },
                        className: "q_search_result_head",
                        children: Pe
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          color: he === q ? ((st = c == null ? void 0 : c.listHover) == null ? void 0 : st.Description) || ((We = c == null ? void 0 : c.Description) == null ? void 0 : We.color) || (d == null ? void 0 : d.secondaryColor) || (x == null ? void 0 : x.secondaryColor) : ((Je = c == null ? void 0 : c.Description) == null ? void 0 : Je.color) || (x == null ? void 0 : x.secondaryColor),
                          ...c == null ? void 0 : c.Description
                        },
                        className: "q_search_result_desc",
                        children: xe
                      }
                    )
                  ] })
                ]
              },
              he
            );
          }
        ) })
      ] }),
      t.searchDetails && /* @__PURE__ */ k("div", { className: "q_search_result_details", children: [
        /* @__PURE__ */ h(
          "img",
          {
            src: ((ge = w[q]) == null ? void 0 : ge.icon) || Jn,
            alt: ""
          }
        ),
        /* @__PURE__ */ h("div", { className: "q_search_details_head", children: (oe = w[q]) == null ? void 0 : oe.text }),
        /* @__PURE__ */ h("div", { className: "q_search_result_desc", children: ((ce = w[q]) == null ? void 0 : ce.longDescription) || ((pe = w[q]) == null ? void 0 : pe.description) }),
        t.buttonText && /* @__PURE__ */ h("div", { className: "q_search_result_button1", children: t.buttonText }),
        /* @__PURE__ */ h("div", { className: "q_search_result_button2", children: "Learn more" })
      ] })
    ] }),
    l && /* @__PURE__ */ h(
      Pr,
      {
        style: {
          background: ((Se = (qe = c == null ? void 0 : c.Footer) == null ? void 0 : qe.FooterStyle) == null ? void 0 : Se.backgroundColor) || ((Te = c == null ? void 0 : c.Form) == null ? void 0 : Te.backgroundColor) || ((be = c == null ? void 0 : c.Form) == null ? void 0 : be.background) || (d == null ? void 0 : d.background) || (x == null ? void 0 : x.backgroundColor),
          ...(He = c == null ? void 0 : c.Footer) == null ? void 0 : He.FooterStyle
        },
        textStyle: (Ge = c == null ? void 0 : c.Footer) == null ? void 0 : Ge.FooterText,
        iconStyle: (Le = c == null ? void 0 : c.Footer) == null ? void 0 : Le.FooterIcon,
        text: p,
        link: v
      }
    )
  ] }), D = t.sections ? U : T;
  return t.open === "ON_CTRL_K_KEY" && y ? e ? /* @__PURE__ */ h(
    "div",
    {
      className: "q_search_bar_screen",
      onClick: (Ae) => {
        Ae.target.classList.contains("q_search_bar_screen") && b(!1);
      },
      children: D
    }
  ) : D : t.open !== !0 ? /* @__PURE__ */ h(Ze, {}) : e ? /* @__PURE__ */ h(
    "div",
    {
      onClick: (Ae) => {
        Ae.target.classList.contains("q_search_bar_screen") && b(!1);
      },
      className: "q_search_bar_screen",
      children: D
    }
  ) : D;
}
function UFe({
  // questId = "",
  // userId = "",
  // token = "",
  heading: t = "Submit Feedback",
  description: e = "Welcome back, Please complete your details",
  iconColor: r = "#939393",
  isOpen: n = !0,
  reward: A = !1,
  footerText: i,
  footerLink: o,
  rewardHeading: s = "Reward Unlocked",
  rewqrdDescription: a = "You have unlocked a new reward for your last transaction. Avail the reward now and enjoy!"
}) {
  const [c, l] = N([!1, !1]), u = gt(null), [f, d] = N(!1), [g, m] = N(0), [p, v] = N(n);
  le(() => {
    v(n);
  }, [n]);
  const C = (B) => {
    navigator == null || navigator.clipboard.writeText(""), l((y) => y.map((b, q) => q == B ? !0 : b));
  };
  le(() => {
  }, []);
  const w = (B) => {
    d(!0);
  };
  if (p)
    return A ? /* @__PURE__ */ k("div", { className: "q_feed_back_modal", children: [
      /* @__PURE__ */ h("img", { src: XN(), alt: "", className: "q_modal_reward_img" }),
      /* @__PURE__ */ k("div", { className: "q_modal_reward_content", children: [
        /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h("div", { className: "q_modal_heading", children: s }),
          /* @__PURE__ */ h("div", { className: "q_modal_desc", children: a })
        ] }),
        /* @__PURE__ */ k("div", { className: "q_modal_buttons", children: [
          /* @__PURE__ */ h("div", { className: "q_modal_cancel", children: "Go to home" }),
          /* @__PURE__ */ h("div", { className: "q_modal_upload_button", children: "Avail now" })
        ] })
      ] })
    ] }) : /* @__PURE__ */ k("div", { className: "q_feed_back_modal", children: [
      /* @__PURE__ */ k("div", { className: "q_feed_back_modal_head", children: [
        /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h("div", { className: "q_modal_heading", children: t }),
          /* @__PURE__ */ h("div", { className: "q_modal_desc", children: e })
        ] }),
        /* @__PURE__ */ h("img", { src: YN(r), alt: "", className: "q_modal_cross_img", onClick: () => v(!1) })
      ] }),
      /* @__PURE__ */ k("div", { className: "q_modal_content", children: [
        /* @__PURE__ */ k("div", { className: "q_modal_upload_box", onClick: () => {
          var B;
          return (B = u.current) == null ? void 0 : B.click();
        }, onDragOver: (B) => B.preventDefault(), onDrop: (B) => {
          B.preventDefault(), B.dataTransfer.files[0] && w();
        }, children: [
          f ? /* @__PURE__ */ k("div", { className: "q_modal_progress-wrapper", children: [
            g,
            "%"
          ] }) : /* @__PURE__ */ h("img", { src: zN(), alt: "", className: "q_modal_upload_img" }),
          /* @__PURE__ */ k("div", { className: "q_modal_upload_text_box", children: [
            /* @__PURE__ */ h("div", { className: "q_modal_upload_text", children: "Drag and drop your file here" }),
            /* @__PURE__ */ h("div", { className: "q_modal_upload_mini_text", children: "or, click to Browse (1MB max)" }),
            /* @__PURE__ */ h("input", { ref: u, onChange: (B) => B.target.files && w(B.target.files[0]), type: "file", style: { display: "none" } })
          ] })
        ] }),
        /* @__PURE__ */ h("div", { className: "q_modal_desc", children: "Some data formats, such as dates, numbers, and colours, may not be recognised." }),
        /* @__PURE__ */ h("img", { src: RN(), alt: "" }),
        /* @__PURE__ */ k("div", { className: "q_refer_code_content", children: [
          /* @__PURE__ */ h("div", { className: "q_refer_text", children: "Invitation Link" }),
          /* @__PURE__ */ k("div", { className: "q_refer_code_box", children: [
            /* @__PURE__ */ h("div", { className: "q_refer_code", children: "https://dribbble.com/shots/22712701" }),
            /* @__PURE__ */ h("img", { className: "q_refer_copy_icon", src: c[1] ? pd() : hd(r), onClick: () => C(1), alt: "" })
          ] })
        ] }),
        /* @__PURE__ */ k("div", { className: "q_modal_buttons", children: [
          /* @__PURE__ */ h("div", { className: "q_modal_cancel", children: "Cancel" }),
          /* @__PURE__ */ h("div", { className: "q_modal_upload_button", children: "Upload" })
        ] })
      ] }),
      /* @__PURE__ */ h(Pr, { style: { color: r }, text: i, link: o })
    ] });
}
const NPe = ({
  handleThanks: t,
  showFooter: e,
  iconColor: r,
  themeManager: n
}) => /* @__PURE__ */ k("div", { children: [
  /* @__PURE__ */ h(
    "div",
    {
      className: "q_submit_cross_icon",
      onClick: t,
      style: { cursor: "pointer" },
      children: _g(r)
    }
  ),
  /* @__PURE__ */ h("div", { className: "q-fw-thanks", children: /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ h("div", { className: "q-svg-thanks", children: mT() }),
    /* @__PURE__ */ k("div", { className: "q_fw_submit_box", children: [
      /* @__PURE__ */ k("div", { className: "q_feedback_text_submitted", children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "q_feedback_text_cont",
            style: n.getHeaderStyles().heading,
            children: "Feedback Submitted"
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "q_fw_submit_desc",
            style: n.getHeaderStyles().description,
            children: "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them."
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          onClick: () => t(),
          className: "q_fw_submit_back",
          style: n.getButtonStyles().secondary,
          children: "Go to home!"
        }
      )
    ] })
  ] }) }),
  e && /* @__PURE__ */ h(Pr, { style: n.getFooterStyles() })
] }), jPe = ({
  currentSection: t,
  setCurrentSection: e,
  design: r,
  returnAnswers: n,
  goToNextSection: A,
  GeneralFunctions: i,
  themeManager: o
}) => /* @__PURE__ */ k("div", { className: "q_feedback_buttons", children: [
  /* @__PURE__ */ h(
    JA,
    {
      children: t > 0 ? "Previous" : "Cancel",
      onClick: (s) => {
        i.fireTrackingEvent(
          "quest_survey_secondary_button_clicked",
          "survey"
        ), s.preventDefault(), s.stopPropagation(), t > 0 && e(t - 1);
      },
      style: o.getButtonStyles().secondary
    }
  ),
  /* @__PURE__ */ h(
    yr,
    {
      type: "button",
      style: o.getButtonStyles().primary,
      onClick: () => {
        i.fireTrackingEvent(
          "quest_survey_primary_button_clicked",
          "survey"
        );
        const s = Object.keys(r);
        t < s.length - 1 ? (i.fireTrackingEvent(
          "quest_gamifiedquiz_next_section_button_clicked",
          "gamifiedquiz"
        ), e(t + 1)) : t >= s.length - 1 && n();
      },
      children: t >= r.length - 1 ? "Submit" : "Next",
      disabled: !A
    }
  )
] }), _N = ({
  options: t,
  checked: e,
  onChange: r,
  style: n,
  selectedStyle: A = { accentColor: "#6525B3" },
  type: i,
  hoverBackground: o
}) => {
  const { themeConfig: s } = Xe(ct.Context);
  console.log("onboarding", t, e, r, n, i, A, o);
  const a = {
    ...n,
    flexDirection: i === "modal2" ? "column" : "row",
    gap: i === "modal2" ? "12px" : "8px"
  }, c = {
    control: (l) => ({
      ...l,
      background: (a == null ? void 0 : a.background) || (a == null ? void 0 : a.backgroundColor) || "transparent",
      fontSize: (a == null ? void 0 : a.fontSize) || "14px",
      border: `${(a == null ? void 0 : a.borderWidth) || "1px"} solid ${(a == null ? void 0 : a.borderColor) || (s == null ? void 0 : s.borderColor) || "var(--neutral-grey-100, #ECECEC)"}`,
      borderRadius: "10px",
      color: (a == null ? void 0 : a.color) || (s == null ? void 0 : s.primaryColor) || "black",
      fontFamily: (a == null ? void 0 : a.fontFamily) || (s == null ? void 0 : s.fontFamily) || "'Figtree', sans-serif",
      ...a
    }),
    option: (l, { isFocused: u }) => ({
      ...l,
      backgroundColor: u ? o || "#ADD8E6" : (a == null ? void 0 : a.background) || (a == null ? void 0 : a.backgroundColor) || "#f9fafb",
      color: (a == null ? void 0 : a.color) || "black",
      fontSize: (a == null ? void 0 : a.fontSize) || "14px",
      fontFamily: (a == null ? void 0 : a.fontFamily) || (s == null ? void 0 : s.fontFamily) || "'Figtree', sans-serif"
    }),
    menu: (l) => ({
      ...l,
      backgroundColor: (a == null ? void 0 : a.background) || (a == null ? void 0 : a.backgroundColor) || "#f9fafb"
    }),
    singleValue: (l) => ({
      ...l,
      color: (a == null ? void 0 : a.color) || (s == null ? void 0 : s.primaryColor) || "black",
      fontSize: (a == null ? void 0 : a.fontSize) || "14px",
      fontFamily: (a == null ? void 0 : a.fontFamily) || (s == null ? void 0 : s.fontFamily) || "'Figtree', sans-serif"
    })
  };
  return i === "modal3" ? /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
    Gv,
    {
      isSearchable: !0,
      name: "selectbox",
      options: t.map((l) => ({ value: l, label: l })),
      onChange: r,
      styles: c,
      value: e ? { value: e, label: e } : ""
    }
  ) }) : /* @__PURE__ */ h("div", { className: "q-singlechoice-input-cont", style: a, children: t.map((l, u) => {
    const f = {
      border: e === l ? `1px solid ${(A == null ? void 0 : A.borderColor) || (A == null ? void 0 : A.accentColor) || "#6525B3"}` : `1px solid ${(n == null ? void 0 : n.borderColor) || "#EFEFEF"}`,
      width: i === "modal2" ? "100%" : "fit-content",
      padding: i === "modal2" ? "10px 16px" : "8px 16px",
      gap: i === "modal2" ? "8px" : "4px"
    };
    return /* @__PURE__ */ k("div", { className: "q_singlehoice_label_cont", style: f, children: [
      /* @__PURE__ */ h(
        "input",
        {
          type: "radio",
          value: l,
          checked: e === l,
          onChange: r,
          className: "q-singlechoice-input",
          style: { accentColor: (A == null ? void 0 : A.accentColor) || "#6525B3" },
          id: l
        }
      ),
      /* @__PURE__ */ h("label", { style: { color: e === l ? (A == null ? void 0 : A.color) || (A == null ? void 0 : A.accentColor) || "#6525B3" : (n == null ? void 0 : n.color) || "#939393" }, htmlFor: l, children: l })
    ] }, u);
  }) });
}, LPe = ({
  options: t,
  question: e,
  required: r,
  actionId: n,
  answer: A,
  handleRadioChange: i,
  themeManager: o,
  singleChoiceModal: s
}) => {
  const a = () => {
    var c;
    return s === "modal3" ? A[n] || "" : ((c = A[n]) == null ? void 0 : c[0]) || "";
  };
  return /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ h(
      ho,
      {
        className: "q-onb-singleChoiceOne-lebel",
        children: `${e}${r ? "*" : ""}`,
        style: o.getLabelStyles()
      }
    ),
    /* @__PURE__ */ h("div", { style: { width: s === "modal2" ? "91%" : "100%" }, children: /* @__PURE__ */ h(
      _N,
      {
        options: t,
        type: s,
        checked: a(),
        onChange: (c) => s === "modal3" ? i(c.value, n, "") : i(c.target.value, n, "radio"),
        style: o.getSingleChoiceStyles(),
        hoverBackground: o.getSingleChoiceHoverStyles(),
        selectedStyle: o.getSingleChoiceSelectedStyles()
      }
    ) })
  ] });
}, GPe = ({ backgroundColor: t = "#6525B3", color: e = "white" }) => /* @__PURE__ */ k("svg", { height: "18px", width: "18px", viewBox: "0 0 453 453", version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", fill: "#000000", children: [
  /* @__PURE__ */ h("g", { id: "SVGRepo_bgCarrier", strokeWidth: "0" }),
  /* @__PURE__ */ h("g", { id: "SVGRepo_tracerCarrier", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ k("g", { id: "SVGRepo_iconCarrier", children: [
    " ",
    /* @__PURE__ */ k("g", { children: [
      " ",
      /* @__PURE__ */ k("g", { children: [
        " ",
        /* @__PURE__ */ k("g", { children: [
          " ",
          /* @__PURE__ */ h("path", { fill: t, d: "M0,0v452.986h452.986V0H0z M156.669,361.354L56.019,209.495l27.222-13.59l71.356,92.905 l224.315-197.2l18.874,22.649L156.669,361.354z" }),
          " "
        ] }),
        " "
      ] }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " ",
      /* @__PURE__ */ h("g", { children: " " }),
      " "
    ] }),
    " "
  ] })
] }), RPe = ({
  options: t,
  checked: e,
  selectedStyle: r = { color: "#6525B3" },
  style: n,
  onChange: A = () => {
  }
}) => {
  const i = (a) => {
    s(
      (c) => c.includes(t[a]) ? c.filter((u) => u !== t[a]) : [...c, t[a]]
    );
  }, [o, s] = N(e || []);
  return console.log(r), /* @__PURE__ */ h("div", { className: "q_multi_choice_box", children: t.map((a, c) => /* @__PURE__ */ k("div", { style: { ...n, borderColor: (o == null ? void 0 : o.includes(a)) && (r == null ? void 0 : r.borderColor) || (n == null ? void 0 : n.borderColor) }, className: "q_mult_choice_option", onClick: () => {
    i(c), A({ target: { value: a, checked: !o.includes(a) } });
  }, children: [
    o != null && o.includes(a) ? /* @__PURE__ */ h(GPe, { backgroundColor: r == null ? void 0 : r.accentColor }) : /* @__PURE__ */ h("div", { className: "q_check_box_off" }),
    /* @__PURE__ */ h("p", { className: "q_mult_choice_option_selected", style: o != null && o.includes(a) ? r : n, children: a })
  ] }, c)) });
}, $N = ({
  options: t,
  checked: e,
  style: r,
  selectedStyle: n,
  onChange: A = () => {
  }
}) => {
  const i = (a) => {
    s(
      (c) => c.includes(t[a]) ? c.filter((u) => u !== t[a]) : [...c, t[a]]
    );
  }, [o, s] = N(e || []);
  return /* @__PURE__ */ h("div", { className: "q_multi_choice_box_2", children: t.map((a, c) => /* @__PURE__ */ h(
    "div",
    {
      style: { ...o != null && o.includes(a) ? n : r },
      className: o != null && o.includes(a) ? "q_mult_choice_option_2_select" : "q_mult_choice_option_2",
      onClick: () => {
        i(c), A({ target: { value: a, checked: !o.includes(a) } });
      },
      children: a
    },
    c
  )) });
}, zPe = ({
  options: t,
  question: e,
  required: r,
  actionId: n,
  selectedOptions: A,
  handleCheckboxChange: i,
  themeManager: o,
  multiChoiceModal: s
}) => /* @__PURE__ */ k("div", { children: [
  /* @__PURE__ */ h(WA, { htmlFor: "textAreaInput", style: o.getLabelStyles(), children: `${e}${r === !0 ? "*" : ""}` }),
  s === "modal1" ? /* @__PURE__ */ h(
    $N,
    {
      options: t,
      checked: A && Array.isArray(A[n]) ? A[n] : void 0,
      onChange: (a) => {
        i(a.target.value, n);
      },
      style: o.getMultiChoiceBorderStyle(),
      selectedStyle: o.getMultiChoiceSelectedColorStyles()
    }
  ) : /* @__PURE__ */ h("div", { style: { width: "90%" }, children: /* @__PURE__ */ h(
    RPe,
    {
      options: t,
      checked: A[n],
      onChange: (a) => i(a.target.value, n),
      style: o.getMultiChoiceStyles(),
      selectedStyle: o.getMultiChoiceSelectedStyles()
    }
  ) })
] }), ej = ({
  data: t,
  answer: e,
  handleUpdate: r,
  handleRatingChange: n,
  handleRadioChange: A,
  selectedOptions: i,
  handleCheckboxChange: o,
  ratingType: s,
  sections: a,
  // page,
  themeManager: c,
  singleChoiceModal: l = "modal3",
  multiChoiceModal: u = "modal1",
  validateInputRegex: f
  // onboardingGetPropsFunctions,
}) => {
  switch (t.type) {
    case "USER_INPUT_TEXT":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
        /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(t == null ? void 0 : t.question) || ""} ${t != null && t.required ? "*" : ""}` }),
        /* @__PURE__ */ h(
          Hi,
          {
            placeholder: (t == null ? void 0 : t.placeholder) || (t == null ? void 0 : t.question) || "",
            value: e[t.actionId || ""],
            validateInputRegex: (d) => console.log(d),
            errorText: c.getTextInputErrorText(),
            textErrorStyle: c.getTextInputErrorStyles(),
            regexKey: t == null ? void 0 : t.regexKey,
            regexMessage: t == null ? void 0 : t.regexMessage,
            onChange: (d) => r(d, t.actionId || "", ""),
            style: c.getTextInputStyles()
          },
          t.actionId
        )
      ] }, t.actionId) });
    case "USER_INPUT_EMAIL":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
        /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(t == null ? void 0 : t.question) || ""} ${t != null && t.required ? "*" : ""}` }),
        /* @__PURE__ */ h(
          Fu,
          {
            placeholder: (t == null ? void 0 : t.placeholder) || (t == null ? void 0 : t.question) || "",
            value: e[(t == null ? void 0 : t.actionId) || ""],
            iconColor: c.getEmailIconColor(),
            validateInputRegex: (d) => f(d, t.actionId),
            regexKey: t == null ? void 0 : t.regexKey,
            regexMessage: t == null ? void 0 : t.regexMessage,
            onChange: (d) => r(d, t.actionId || "", ""),
            style: c.getTextInputStyles(),
            emailtext: c.getEmailInputErrorText(),
            emailErrorStyle: c.getEMailInputErrorStyles()
          }
        )
      ] }, t == null ? void 0 : t.actionId) });
    case "USER_INPUT_SINGLE_CHOICE":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
        LPe,
        {
          options: t.options || [],
          question: (t == null ? void 0 : t.question) || "",
          required: t.required || !1,
          actionId: t.actionId || "",
          answer: e,
          handleRadioChange: A,
          themeManager: c,
          singleChoiceModal: l
        }
      ) });
    case "USER_INPUT_TEXTAREA":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
        /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(t == null ? void 0 : t.question) || ""} ${(t == null ? void 0 : t.placeholder) || (t == null ? void 0 : t.question) || ""}` }),
        /* @__PURE__ */ h(
          Mu,
          {
            value: e[t.actionId || ""],
            onChange: (d) => r(d, t.actionId || "", ""),
            style: c.getTextAreaInputStyles(),
            textareatext: c.getTextAreaInputErrorText(),
            textareaErrorStyle: c.getTextAreaInputErrorStyles(),
            validateInputRegex: (d) => f(d, t.actionId),
            placeholder: (t == null ? void 0 : t.placeholder) || (t == null ? void 0 : t.question) || ""
          },
          t == null ? void 0 : t.actionId
        )
      ] }) });
    case "RATING":
      return /* @__PURE__ */ k("div", { className: "mb-4", children: [
        /* @__PURE__ */ h(WA, { className: "q-fd-lebels", style: c.getLabelStyles(), children: `${t.question ? t.question : "Rating Scale"}${t.required === !0 ? "*" : ""}` }),
        /* @__PURE__ */ h(
          "div",
          {
            style: {
              display: "flex",
              marginTop: "6px"
            },
            children: /* @__PURE__ */ h(
              zv,
              {
                count: 5,
                getCurrentRating: (d) => n(t.actionId, d),
                defaultRating: Number(e[t == null ? void 0 : t.actionId]),
                RatingStyle: c.getRatingStyles(),
                type: (t == null ? void 0 : t.ratingType) || s,
                leftText: t == null ? void 0 : t.leftRatingText,
                rightText: t == null ? void 0 : t.rightRatingText,
                centerRatingText: t == null ? void 0 : t.centerRatingText
              }
            )
          }
        )
      ] });
    case "USER_INPUT_MULTI_CHOICE":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
        zPe,
        {
          options: t.options || [],
          question: (t == null ? void 0 : t.question) || "",
          required: t.required || !1,
          actionId: t.actionId || "",
          selectedOptions: i,
          handleCheckboxChange: o,
          themeManager: c,
          multiChoiceModal: u
        }
      ) });
    case "USER_INPUT_DATE":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
        /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(t == null ? void 0 : t.question) || ""} ${t != null && t.required ? "*" : ""}` }),
        /* @__PURE__ */ h(
          Hu,
          {
            placeholder: (t == null ? void 0 : t.placeholder) || (t == null ? void 0 : t.question) || "",
            value: e[t.actionId || ""],
            onChange: (d) => r(d, t.actionId || "", ""),
            iconColor: c.getEmailIconColor(),
            style: c.getTextInputStyles(),
            preventFutureSelection: !1,
            preventPastSelection: !1,
            minDate: "",
            maxDate: ""
          },
          t.actionId
        )
      ] }, t.actionId) });
    case "USER_INPUT_PHONE":
    case "USER_INPUT_NUMBER":
      return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
        /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(t == null ? void 0 : t.question) || ""} ${t != null && t.required ? "*" : ""}` }),
        /* @__PURE__ */ h(
          Tu,
          {
            placeholder: (t == null ? void 0 : t.placeholder) || (t == null ? void 0 : t.question) || "",
            value: e[t.actionId || ""],
            iconColor: c.getEmailIconColor(),
            validateInputRegex: (d) => (
              // validateInputRegex(validation, data.actionId)
              console.log(d)
            ),
            regexKey: t == null ? void 0 : t.regexKey,
            regexMessage: t == null ? void 0 : t.regexMessage,
            onChange: (d) => r(d, t.actionId || "", ""),
            style: c.getTextInputStyles(),
            numbertext: c.getNumberInputErrorText(),
            numberErrorStyle: c.getNumberInputErrorStyles()
          },
          t == null ? void 0 : t.actionId
        )
      ] }) });
    default:
      return null;
  }
}, YPe = ({
  Headers: t,
  sections: e,
  // page,
  themeManager: r,
  onClose: n
}) => {
  var A, i;
  return /* @__PURE__ */ h(
    T1,
    {
      heading: Array.isArray(t) && ((A = t[0]) == null ? void 0 : A.heading) || "",
      description: Array.isArray(t) && ((i = t[0]) == null ? void 0 : i.subHeading) || "",
      style: r.getTopBarStyles(e, 0),
      onClose: n
    }
  );
};
let VPe = class {
  constructor(e = {}, r = {}, n = {}, A = {}) {
    ke(this, "brandTheme");
    ke(this, "styleConfig");
    ke(this, "themeConfig");
    ke(this, "questThemeData");
    this.brandTheme = e, this.styleConfig = r, this.themeConfig = n, this.questThemeData = A;
  }
  getTextInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.TextError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getTextInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.TextError) == null ? void 0 : r.errorStyle
    };
  }
  getEmailIconColor() {
    var e, r, n, A;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.color) || ((n = this == null ? void 0 : this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this == null ? void 0 : this.themeConfig) == null ? void 0 : A.primaryColor) || "#B9B9B9";
  }
  getEmailInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getEMailInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.errorStyle
    };
  }
  getTextInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.borderColor,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.Input) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.Input
    };
  }
  getSingleChoiceHoverBackground() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.hoverBackground;
  }
  getTextAreaInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.TextArea) == null ? void 0 : r.borderColor,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.TextArea) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.TextArea
    };
  }
  getTextAreaInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.TextAreaError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getTextAreaInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.TextAreaError) == null ? void 0 : r.errorStyle
    };
  }
  getNumberInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.NumberError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getNumberInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.NumberError) == null ? void 0 : r.errorStyle
    };
  }
  getFormStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.brandTheme) == null ? void 0 : n.background) || ((A = this.themeConfig) == null ? void 0 : A.backgroundColor),
      borderRadius: ((o = (i = this.styleConfig) == null ? void 0 : i.Form) == null ? void 0 : o.borderRadius) || ((s = this.questThemeData) == null ? void 0 : s.borderRadius) || ((a = this.brandTheme) == null ? void 0 : a.borderRadius),
      height: ((l = (c = this.styleConfig) == null ? void 0 : c.Form) == null ? void 0 : l.height) || "auto",
      fontFamily: ((u = this.brandTheme) == null ? void 0 : u.fontFamily) || this.themeConfig.fontFamily || "'Figtree', sans-serif",
      ...(f = this.styleConfig) == null ? void 0 : f.Form
    };
  }
  getLabelStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Label) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Label
    };
  }
  getRatingStyles() {
    var e;
    return ((e = this.styleConfig) == null ? void 0 : e.Rating) || {};
  }
  getInputStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      color: ((i = (A = this.styleConfig) == null ? void 0 : A.Input) == null ? void 0 : i.color) || ((o = this.brandTheme) == null ? void 0 : o.primaryColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor),
      ...(a = this.styleConfig) == null ? void 0 : a.Input
    };
  }
  getTextAreaStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.TextArea) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      color: ((i = (A = this.styleConfig) == null ? void 0 : A.TextArea) == null ? void 0 : i.color) || ((o = this.brandTheme) == null ? void 0 : o.primaryColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor),
      ...(a = this.styleConfig) == null ? void 0 : a.TextArea
    };
  }
  getSingleChoiceStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      borderColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.style) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor),
      color: ((s = (o = (i = this.styleConfig) == null ? void 0 : i.SingleChoice) == null ? void 0 : o.style) == null ? void 0 : s.color) || ((a = this.brandTheme) == null ? void 0 : a.primaryColor) || ((c = this.themeConfig) == null ? void 0 : c.primaryColor),
      ...(u = (l = this.styleConfig) == null ? void 0 : l.SingleChoice) == null ? void 0 : u.style
    };
  }
  getSingleChoiceSelectedStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      accentColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.accentColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || ((i = this.brandTheme) == null ? void 0 : i.accentColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(a = (s = this.styleConfig) == null ? void 0 : s.SingleChoice) == null ? void 0 : a.selectedStyle
    };
  }
  getSingleChoiceHoverStyles() {
    var e, r;
    return {
      background: (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.hoverBackground
    };
  }
  getMultiChoiceStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      borderColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.style) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor),
      color: ((s = (o = (i = this.styleConfig) == null ? void 0 : i.MultiChoice) == null ? void 0 : o.style) == null ? void 0 : s.color) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor) || ((c = this.brandTheme) == null ? void 0 : c.primaryColor),
      ...(u = (l = this.styleConfig) == null ? void 0 : l.MultiChoice) == null ? void 0 : u.style
    };
  }
  getMultiChoiceSelectedStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p;
    return {
      borderColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.borderColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor),
      color: ((s = (o = (i = this.styleConfig) == null ? void 0 : i.MultiChoice) == null ? void 0 : o.selectedStyle) == null ? void 0 : s.color) || ((a = this.questThemeData) == null ? void 0 : a.accentColor) || ((c = this.brandTheme) == null ? void 0 : c.primaryColor) || ((l = this.themeConfig) == null ? void 0 : l.primaryColor),
      accentColor: ((d = (f = (u = this.styleConfig) == null ? void 0 : u.MultiChoice) == null ? void 0 : f.selectedStyle) == null ? void 0 : d.accentColor) || ((g = this.questThemeData) == null ? void 0 : g.accentColor),
      ...(p = (m = this.styleConfig) == null ? void 0 : m.SingleChoice) == null ? void 0 : p.selectedStyle
    };
  }
  getMultiChoiceSelectedColorStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.color) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || ((i = this.brandTheme) == null ? void 0 : i.accentColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(a = (s = this.styleConfig) == null ? void 0 : s.MultiChoice) == null ? void 0 : a.selectedStyle
    };
  }
  getMultiChoiceBorderStyle() {
    var e, r, n, A;
    return {
      border: ((e = this.themeConfig) == null ? void 0 : e.borderColor) || ((r = this.brandTheme) == null ? void 0 : r.borderColor) || ((n = this.styleConfig) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor)
    };
  }
  getHeaderStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      heading: {
        color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
        ...(i = this.styleConfig) == null ? void 0 : i.Heading
      },
      description: {
        color: ((s = (o = this.styleConfig) == null ? void 0 : o.Description) == null ? void 0 : s.color) || ((a = this.brandTheme) == null ? void 0 : a.secondaryColor) || ((c = this.themeConfig) == null ? void 0 : c.secondaryColor),
        ...(l = this.styleConfig) == null ? void 0 : l.Description
      }
    };
  }
  getButtonStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v;
    return {
      primary: {
        backgroundColor: ((e = this.questThemeData) == null ? void 0 : e.buttonColor) || ((r = this.brandTheme) == null ? void 0 : r.buttonColor) || ((n = this.themeConfig) == null ? void 0 : n.buttonColor),
        ...(A = this.styleConfig) == null ? void 0 : A.PrimaryButton,
        border: ((o = (i = this.styleConfig) == null ? void 0 : i.PrimaryButton) == null ? void 0 : o.border) || "1.5px solid #afafaf",
        background: ((a = (s = this.styleConfig) == null ? void 0 : s.PrimaryButton) == null ? void 0 : a.background) || ((c = this.questThemeData) == null ? void 0 : c.buttonColor) || ((l = this.brandTheme) == null ? void 0 : l.buttonColor) || ((u = this.themeConfig) == null ? void 0 : u.buttonColor),
        ...(f = this.styleConfig) == null ? void 0 : f.PrimaryButton
      },
      secondary: {
        color: ((g = (d = this.styleConfig) == null ? void 0 : d.SecondaryButton) == null ? void 0 : g.color) || ((m = this.brandTheme) == null ? void 0 : m.secondaryColor) || ((p = this.themeConfig) == null ? void 0 : p.secondaryColor),
        ...(v = this.styleConfig) == null ? void 0 : v.SecondaryButton
      }
    };
  }
  getEmailTextStyles() {
    var e, r, n, A;
    return {
      text: ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) === void 0 ? "This is not a valid email" : ((A = (n = this.styleConfig) == null ? void 0 : n.EmailError) == null ? void 0 : A.errorStyle) || {}
    };
  }
  getEmailErrorStyles() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.errorStyle) || {};
  }
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w;
    return {
      style: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.background) || ((a = this.brandTheme) == null ? void 0 : a.background) || ((c = this.themeConfig) == null ? void 0 : c.backgroundColor),
        ...(u = (l = this.styleConfig) == null ? void 0 : l.Footer) == null ? void 0 : u.FooterStyle
      },
      textStyle: ((d = (f = this.styleConfig) == null ? void 0 : f.Footer) == null ? void 0 : d.FooterTextStyle) || {},
      iconStyle: ((m = (g = this.styleConfig) == null ? void 0 : g.Footer) == null ? void 0 : m.FooterIcon) || {},
      text: (v = (p = this.styleConfig) == null ? void 0 : p.Footer) == null ? void 0 : v.FooterText,
      link: (w = (C = this.styleConfig) == null ? void 0 : C.Footer) == null ? void 0 : w.FooterLink
    };
  }
  getTopBarStyles() {
    var e;
    return {
      headingStyle: this.getHeaderStyles().heading,
      descriptionStyle: this.getHeaderStyles().description,
      topbarStyle: {
        ...(e = this.styleConfig) == null ? void 0 : e.TopBar
      }
    };
  }
};
const tj = (t = {}, e = {}, r = {}, n = {}) => MA(
  () => new VPe(t, e, r, n),
  [t, e, r, n]
), jFe = ({
  sections: t,
  ratingType: e = "number",
  iconColor: r = "#939393",
  showFooter: n = !0,
  styleConfig: A = {},
  singleChoiceModal: i,
  multiChoiceModal: o,
  formdata: s,
  design: a = [],
  brandTheme: c,
  questThemeData: l,
  Headers: u,
  onSubmit: f
}) => {
  const [d, g] = N(!1), [m, p] = N({}), [v, C] = N({}), [w, B] = N({}), [y, b] = N(!1), [q, E] = N(0), [x, M] = N([]), O = new Bt("mixpanel", "Offline"), { themeConfig: I } = Xe(
    ct.Context
  ), S = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, P = tj(
    c,
    A,
    I,
    l
  ), H = (W, R, K) => {
    var V;
    let L = !0, G = !0;
    if (K.required)
      switch (K.type) {
        case "USER_INPUT_MULTI_CHOICE":
          L = ((V = v[W]) == null ? void 0 : V.length) > 0;
          break;
        case "USER_INPUT_SINGLE_CHOICE":
          L = !!m[W];
          break;
        case "RATING":
          L = m[W] !== void 0 && m[W] !== "";
          break;
        case "USER_INPUT_TEXT":
        case "USER_INPUT_EMAIL":
        case "USER_INPUT_TEXTAREA":
        case "USER_INPUT_DATE":
        case "USER_INPUT_PHONE":
        case "USER_INPUT_NUMBER":
          L = R !== void 0 && R !== "";
          break;
        default:
          L = !!R;
      }
    if (K.type === "USER_INPUT_EMAIL" && R)
      if (K.regexKey)
        try {
          G = new RegExp(K.regexKey).test(R.toString());
        } catch {
          G = S.test(R.toString());
        }
      else
        G = S.test(R.toString());
    else if (K.regexKey && R)
      try {
        G = new RegExp(K.regexKey).test(R.toString());
      } catch {
        G = !0;
      }
    return { isValid: L, regexValid: G };
  }, F = () => {
    if (x) {
      const W = {};
      x.forEach((K) => {
        const L = m[K.actionId], G = H(K.actionId, L, K);
        W[K.actionId] = G;
      }), B(W);
      const R = Object.values(W).every(
        (K) => K.isValid && K.regexValid
      );
      b(R);
    }
  }, T = (W, R) => {
    if (!w[R]) return;
    B((L) => ({
      ...L,
      [R]: {
        ...L[R],
        regexValid: W
      }
    }));
    const K = Object.values({
      ...w,
      [R]: {
        ...w[R],
        regexValid: W
      }
    }).every((L) => L.isValid && L.regexValid);
    b(K);
  }, U = (W, R) => {
    p({
      ...m,
      [W]: String(R)
    });
  }, D = (W, R) => {
    C((K) => {
      const L = K[R] || [];
      return L.includes(W) ? {
        ...K,
        [R]: L.filter((G) => G !== W)
      } : {
        ...K,
        [R]: [...L, W]
      };
    });
  }, Q = (W, R, K) => {
    if (W.target.checked === !0 && K === "check") {
      let L = Array.isArray(m[R]) ? [...m[R]] : [];
      L.push(W.target.value), p({
        ...m,
        [R]: L
      });
    } else if (W.target.checked === !1 && Array.isArray(m[R]) && K === "check") {
      let G = m[R].filter((V) => V !== W.target.value);
      p({
        ...m,
        [R]: G
      });
    } else
      p({
        ...m,
        [R]: W.target.value
      });
  }, Y = (W, R, K) => {
    p(K === "radio" ? (L) => {
      var G;
      return {
        ...L,
        [R]: (G = L[R]) != null && G.includes(W) ? [] : [W]
      };
    } : (L) => ({
      ...L,
      [R]: W
    }));
  }, j = () => {
    f && f({ answer: m, selectedOptions: v }), g(!0);
  }, Z = (W) => {
    let R = [];
    return a[q] && a[q].forEach((K) => {
      const L = W[K - 1];
      L && R.push(L);
    }), R;
  };
  return re.useEffect(() => {
    var W;
    if ((a == null ? void 0 : a.length) > 0 && s.length > 0 && q >= 0 && ((W = a[q]) == null ? void 0 : W.length) > 0) {
      const R = Z(s);
      M(R);
    }
  }, [a, s, q]), re.useEffect(() => {
    F();
  }, [m, v, q, x]), s.length == 0 ? null : /* @__PURE__ */ h("div", { style: P.getFormStyles(), className: "q-feedback-cont", children: s.length > 0 && /* @__PURE__ */ k(Ze, { children: [
    !d && /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ h(
        YPe,
        {
          Headers: u,
          sections: t,
          themeManager: P
        }
      ),
      /* @__PURE__ */ k(
        "form",
        {
          style: {
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "16px"
          },
          children: [
            x == null ? void 0 : x.map((W, R) => /* @__PURE__ */ h(
              ej,
              {
                data: W,
                answer: m,
                handleUpdate: Q,
                handleRadioChange: Y,
                handleRatingChange: U,
                selectedOptions: v,
                handleCheckboxChange: D,
                ratingType: e,
                sections: t,
                themeManager: P,
                singleChoiceModal: i,
                multiChoiceModal: o,
                validateInputRegex: T
              },
              (W == null ? void 0 : W.criteriaId) || R
            )),
            /* @__PURE__ */ h(
              jPe,
              {
                currentSection: q,
                setCurrentSection: E,
                design: a,
                returnAnswers: j,
                goToNextSection: y,
                themeManager: P,
                GeneralFunctions: O
              }
            )
          ]
        }
      ),
      n && /* @__PURE__ */ h(Pr, { style: P.getFooterStyles() })
    ] }),
    d && /* @__PURE__ */ h(
      NPe,
      {
        handleThanks: () => g(!1),
        showFooter: n,
        iconColor: r,
        themeManager: P
      }
    )
  ] }) });
}, rj = UA(null), i9 = () => {
  const t = Xe(rj);
  if (!t)
    throw new Error("Survey components must be used within a Survey component");
  return t;
}, WPe = ({ headers: t, style: e = {} }) => {
  const {
    Headers: r,
    themeManager: n,
    currentSection: A = 0,
    onCancel: i
  } = i9(), o = () => t && Array.isArray(t) ? t[A] || {} : r ? Array.isArray(r) ? r[A] || {} : r : {}, { heading: s = "", subHeading: a = "" } = o(), c = n.getTopBarStyles();
  return /* @__PURE__ */ h(
    T1,
    {
      heading: s,
      description: a,
      onClose: i,
      style: {
        ...c,
        ...e,
        headingStyle: {
          ...c.headingStyle,
          ...e.headingStyle
        },
        descriptionStyle: {
          ...c.descriptionStyle,
          ...e.descriptionStyle
        },
        topbarStyle: {
          ...c.topbarStyle,
          ...e.containerStyle
        }
      }
    }
  );
}, XPe = ({
  singleChoiceModal: t,
  multiChoiceModal: e,
  ratingType: r = "number",
  className: n
}) => {
  const {
    sectionQuestions: A,
    answer: i,
    handleUpdate: o,
    handleRadioChange: s,
    handleRatingChange: a,
    selectedOptions: c,
    handleCheckboxChange: l,
    sections: u,
    themeManager: f,
    currentSection: d,
    setCurrentSection: g,
    design: m,
    handleReturnAnswers: p,
    goToNextSection: v,
    GeneralFunctions: C,
    onCancel: w,
    showCancelButton: B = !0,
    submitButtonText: y
  } = i9(), [b, q] = N({}), E = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, x = (I, S, P) => {
    var T;
    let H = !0, F = !0;
    if (P.required)
      switch (P.type) {
        case "USER_INPUT_MULTI_CHOICE":
          H = ((T = c[I]) == null ? void 0 : T.length) > 0;
          break;
        case "USER_INPUT_SINGLE_CHOICE":
          H = !!i[I];
          break;
        case "RATING":
          H = i[I] !== void 0 && i[I] !== "";
          break;
        case "USER_INPUT_TEXT":
        case "USER_INPUT_EMAIL":
        case "USER_INPUT_TEXTAREA":
        case "USER_INPUT_DATE":
        case "USER_INPUT_PHONE":
        case "USER_INPUT_NUMBER":
          H = S !== void 0 && S !== "";
          break;
        default:
          H = !!S;
      }
    if (P.type === "USER_INPUT_EMAIL" && S)
      if (P.regexKey)
        try {
          F = new RegExp(P.regexKey).test(S.toString());
        } catch (U) {
          console.error("Invalid regex pattern:", U), F = E.test(S.toString());
        }
      else
        F = E.test(S.toString());
    else if (P.regexKey && S)
      try {
        F = new RegExp(P.regexKey).test(S.toString());
      } catch (U) {
        console.error("Invalid regex pattern:", U), F = !0;
      }
    return { isValid: H, regexValid: F };
  };
  le(() => {
    if (A) {
      const I = {};
      A.forEach((S) => {
        const P = i[S.actionId], H = x(S.actionId, P, S);
        I[S.actionId] = {
          isValid: H.isValid,
          regexValid: H.regexValid
        };
      }), q(I);
    }
  }, [A, d]), le(() => {
    if (A) {
      const I = { ...b };
      A.forEach((S) => {
        const P = i[S.actionId], H = x(S.actionId, P, S);
        I[S.actionId] = {
          isValid: H.isValid,
          regexValid: H.regexValid
        };
      }), q(I);
    }
  }, [i, c]);
  const M = (I, S) => {
    b[S] && q((P) => ({
      ...P,
      [S]: {
        ...P[S],
        regexValid: I
      }
    }));
  }, O = re.useMemo(() => !A || A.length === 0 ? !0 : A.every((I) => {
    const S = b[I.actionId];
    if (!S) return !1;
    const P = i[I.actionId];
    return I.type === "USER_INPUT_EMAIL" ? I.required ? S.isValid && S.regexValid : !P || S.regexValid : I.required && I.regexKey ? S.isValid && (P ? S.regexValid : !1) : I.required ? S.isValid : I.regexKey && P ? S.regexValid : !0;
  }), [b, A, i]);
  return /* @__PURE__ */ h("div", { className: `q-survey-content ${n || ""}`, children: /* @__PURE__ */ k(
    "form",
    {
      style: {
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "16px"
      },
      children: [
        A == null ? void 0 : A.map((I, S) => {
          const P = (I == null ? void 0 : I.criteriaId) || S;
          return /* @__PURE__ */ h(
            ej,
            {
              data: I,
              answer: i,
              handleUpdate: o,
              handleRadioChange: s,
              handleRatingChange: a,
              selectedOptions: c,
              handleCheckboxChange: l,
              sections: u,
              themeManager: f,
              singleChoiceModal: t,
              multiChoiceModal: e,
              ratingType: r,
              validateInputRegex: (H) => M(H, I.actionId)
            },
            P
          );
        }),
        /* @__PURE__ */ k("div", { className: "q_feedback_buttons", children: [
          B && /* @__PURE__ */ h(
            JA,
            {
              onClick: (I) => {
                C.fireTrackingEvent(
                  "quest_survey_secondary_button_clicked",
                  "survey"
                ), I.preventDefault(), I.stopPropagation(), d == 0 && w && w(), d > 0 && g(d - 1);
              },
              style: f.getButtonStyles().secondary,
              children: d > 0 ? "Previous" : "Cancel"
            }
          ),
          /* @__PURE__ */ h(
            yr,
            {
              type: "button",
              style: f.getButtonStyles().primary,
              onClick: () => {
                C.fireTrackingEvent(
                  "quest_survey_primary_button_clicked",
                  "survey"
                );
                const I = Object.keys(m);
                d < I.length - 1 ? (C.fireTrackingEvent(
                  "quest_gamifiedquiz_next_section_button_clicked",
                  "gamifiedquiz"
                ), g(d + 1)) : d >= I.length - 1 && p();
              },
              disabled: !O,
              children: d >= m.length - 1 ? y || "Submit" : "Next"
            }
          )
        ] })
      ]
    }
  ) });
}, KPe = ({
  showFooter: t = !0,
  className: e
}) => {
  const { themeManager: r } = i9();
  return t ? /* @__PURE__ */ h("div", { className: `q-survey-footer ${e || ""}`, children: /* @__PURE__ */ h(Pr, { style: r.getFooterStyles() }) }) : null;
}, ZPe = ({
  className: t,
  children: e
}) => {
  const {
    handleThanks: r,
    iconColor: n,
    themeManager: A,
    thankYouHeading: i = "Feedback Submitted",
    thankYouDescription: o = "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them."
  } = i9();
  return /* @__PURE__ */ k("div", { className: `q-survey-thank-you ${t || ""}`, children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "q_submit_cross_icon",
        onClick: r,
        style: { cursor: "pointer" },
        children: _g(n)
      }
    ),
    /* @__PURE__ */ h("div", { className: "q-fw-thanks", children: /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ h("div", { className: "q-svg-thanks", children: mT() }),
      /* @__PURE__ */ k("div", { className: "q_fw_submit_box", children: [
        /* @__PURE__ */ k("div", { className: "q_feedback_text_submitted", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_feedback_text_cont",
              style: A.getHeaderStyles().heading,
              children: i
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_fw_submit_desc",
              style: A.getHeaderStyles().description,
              children: o
            }
          )
        ] }),
        /* @__PURE__ */ h(
          "div",
          {
            onClick: r,
            className: "q_fw_submit_back",
            style: A.getButtonStyles().secondary,
            children: "Go to home!"
          }
        )
      ] })
    ] }) }),
    e
  ] });
}, ps = new zn(), JPe = (t) => ({
  "Content-Type": "application/json",
  ...t
}), _Pe = async ({
  BACKEND_URL: t,
  apiKey: e,
  entityId: r,
  uniqueUserId: n,
  uniqueEmailId: A,
  userId: i,
  token: o,
  GeneralFunctions: s
}) => {
  var a;
  try {
    const c = ps.get("externalUserId"), l = ps.get("questUserId"), u = ps.get("questUserToken");
    if (c && l && u && (c === n || c === A))
      return {
        userId: l,
        token: u
      };
    if (n) {
      const f = JPe({
        apiKey: e,
        ...o && { token: o },
        ...i && { userId: i }
      }), d = {
        externalUserId: n,
        entityId: r,
        email: A || null
      }, g = await Oe.post(
        `${t}api/users/external/login`,
        d,
        { headers: f }
      );
      if (!((a = g.data) != null && a.success))
        throw new Error("Invalid response from external login");
      const { userId: m, token: p } = g.data, v = /* @__PURE__ */ new Date();
      return v.setHours(v.getHours() + 12), ps.set("externalUserId", n, { path: "/", expires: v }), ps.set("questUserId", m, { path: "/", expires: v }), ps.set("questUserToken", p, { path: "/", expires: v }), {
        userId: m,
        token: p
      };
    }
    return i && o ? { userId: i, token: o } : null;
  } catch (c) {
    return s.captureSentryException(c), null;
  }
}, $Pe = async ({
  BACKEND_URL: t,
  entityId: e,
  campaignId: r,
  variation: n,
  apiKey: A,
  apiSecret: i,
  userId: o,
  token: s,
  apiType: a,
  setQuestData: c,
  setUiProps: l,
  setBrandTheme: u,
  setQuestThemeData: f,
  setFormdata: d,
  // setData,
  bgColor: g,
  uniqueUserId: m,
  uniqueEmailId: p,
  entityAuthenticationToken: v,
  GeneralFunctions: C
}) => {
  var w, B, y, b, q, E, x, M, O;
  try {
    C.fireTrackingEvent("quest_survey_loaded", "survey");
    const I = await _Pe({
      BACKEND_URL: t,
      apiKey: A,
      entityId: e,
      uniqueUserId: m,
      uniqueEmailId: p,
      userId: o,
      token: s,
      GeneralFunctions: C
    });
    if (!I) {
      Ir.error("Authentication failed");
      return;
    }
    const S = new URLSearchParams();
    S.set("platform", "REACT"), n && S.set("variation", n);
    const P = {
      apiKey: A,
      apisecret: i,
      userId: I.userId,
      token: I.token
    }, H = await Oe.get(
      `${t}api/v2/entities/${e}/campaigns/${r}?${S.toString()}`,
      { headers: P }
    );
    if (!((w = H.data) != null && w.success))
      throw new Error("Failed to fetch campaign data");
    c(H.data.data), l((y = (B = H.data.data) == null ? void 0 : B.sdkConfig) == null ? void 0 : y.uiProps), (q = (b = H.data.data.sdkConfig) == null ? void 0 : b.uiProps) != null && q.questThemeData && f(H.data.data.sdkConfig.uiProps.questThemeData), (x = (E = H.data.data.sdkConfig) == null ? void 0 : E.uiProps) != null && x.brandTheme && u(H.data.data.sdkConfig.uiProps.brandTheme);
    const F = ((O = (M = H.data.data) == null ? void 0 : M.actions) == null ? void 0 : O.map((T) => {
      var U, D, Q, Y, j, Z, W, R, K, L, G, V, _;
      return {
        type: T == null ? void 0 : T.actionType,
        question: T == null ? void 0 : T.title,
        options: (T == null ? void 0 : T.options) || [],
        actionId: T == null ? void 0 : T.actionId,
        required: T == null ? void 0 : T.isRequired,
        placeholder: (U = T == null ? void 0 : T.metadata) == null ? void 0 : U.placeholder,
        ...(D = T == null ? void 0 : T.metadata) != null && D.regexKey ? { regexKey: (Q = T == null ? void 0 : T.metadata) == null ? void 0 : Q.regexKey } : null,
        ...(Y = T == null ? void 0 : T.metadata) != null && Y.regexErrorMessage ? { regexMessage: (j = T == null ? void 0 : T.metadata) == null ? void 0 : j.regexErrorMessage } : null,
        ...(Z = T == null ? void 0 : T.metadata) != null && Z.leftRatingText ? { leftRatingText: (W = T == null ? void 0 : T.metadata) == null ? void 0 : W.leftRatingText } : null,
        ...(R = T == null ? void 0 : T.metadata) != null && R.rightRatingText ? { rightRatingText: (K = T == null ? void 0 : T.metadata) == null ? void 0 : K.rightRatingText } : null,
        ...(L = T == null ? void 0 : T.metadata) != null && L.centerRatingText ? { centerRatingText: (G = T == null ? void 0 : T.metadata) == null ? void 0 : G.centerRatingText } : null,
        ...(V = T == null ? void 0 : T.metadata) != null && V.ratingType ? { ratingType: (_ = T == null ? void 0 : T.metadata) == null ? void 0 : _.ratingType } : null
      };
    })) || [];
    d([...F]);
  } catch (I) {
    C.captureSentryException(I), Ir.error("An error occurred while fetching data.");
  }
}, eke = async ({
  BACKEND_URL: t,
  entityId: e,
  campaignId: r,
  formdata: n,
  answer: A,
  selectedOptions: i,
  questData: o,
  // setShowLoader,
  setThanksPopup: s,
  onSubmit: a,
  GeneralFunctions: c,
  apiKey: l,
  apiSecret: u,
  userId: f,
  token: d,
  uniqueUserId: g,
  toast: m
}) => {
  c.fireTrackingEvent("quest_survey_form_submitted", "survey"), c.fireTrackingEvent(`quest_survey-${e}`, "survey");
  const p = ps.get("questUserId"), v = ps.get("questUserToken"), C = ps.get("externalUserId"), w = {
    apikey: l,
    apisecret: u,
    userId: C && p && v && C == g ? p : f,
    token: C && p && v && C == g ? v : d
  };
  {
    const b = {
      actions: n.map((q) => ({
        answers: [A[q == null ? void 0 : q.actionId] || ""].map((E) => String(E)),
        actionId: (q == null ? void 0 : q.actionId) || ""
      })).map((q) => i[q.actionId] !== void 0 ? {
        ...q,
        answers: i[q.actionId]
      } : q),
      campaignVariationId: o.campaignVariationId
    };
    try {
      const q = await Oe.post(
        `${t}api/v2/entities/${e}/campaigns/${r}/verify`,
        b,
        { headers: w }
      );
      q.data.success ? (s(!0), a && a()) : m.error(q.data.error);
    } catch {
      m.error("Error submitting survey answers");
    }
  }
}, tke = (t, e, r, n, A, i) => {
  var o, s, a, c, l;
  if ((e == null ? void 0 : e.length) > 0)
    for (let u = 0; u < ((o = e[t]) == null ? void 0 : o.length); u++) {
      const f = r[e[t][u] - 1];
      if (!(f != null && f.required)) {
        i(!0);
        continue;
      }
      if ((f == null ? void 0 : f.type) === "USER_INPUT_MULTI_CHOICE")
        if (((s = A[f == null ? void 0 : f.actionId]) == null ? void 0 : s.length) > 0)
          i(!0);
        else {
          i(!1);
          break;
        }
      else if ((f == null ? void 0 : f.type) === "USER_INPUT_SINGLE_CHOICE")
        if (((a = n[f == null ? void 0 : f.actionId]) == null ? void 0 : a.length) > 0)
          i(!0);
        else {
          i(!1);
          break;
        }
      else if ((f == null ? void 0 : f.type) === "RATING")
        if (((c = n[f == null ? void 0 : f.actionId]) == null ? void 0 : c.length) > 0)
          i(!0);
        else {
          i(!1);
          break;
        }
      else if (((l = n[f == null ? void 0 : f.actionId]) == null ? void 0 : l.length) > 0)
        i(!0);
      else {
        i(!1);
        break;
      }
    }
}, Rc = ({
  userId: t,
  token: e,
  questId: r,
  bgColor: n,
  onSubmit: A,
  ratingType: i = "number",
  iconColor: o = "#939393",
  uniqueEmailId: s,
  uniqueUserId: a,
  showFooter: c = !0,
  styleConfig: l = {},
  sections: u,
  variation: f,
  design: d = [],
  entityAuthenticationToken: g,
  Headers: m,
  singleChoiceModal: p,
  multiChoiceModal: v,
  className: C,
  onCancel: w,
  children: B,
  customThanksPopup: y,
  showCancelButton: b,
  submitButtonText: q,
  thankYouHeading: E,
  thankYouDescription: x
}) => {
  const [M, O] = N(!1), [I, S] = N(), [P, H] = N([]), [F, T] = N({}), [U, D] = N({}), [Q, Y] = N(0), [j, Z] = N(!1), [W, R] = N([]), [K, L] = N(Ms), [G, V] = N(Hs), [_, J] = N({}), { apiKey: X, apiSecret: ne, entityId: ee, apiType: $, themeConfig: te } = Xe(
    ct.Context
  ), ae = new Bt("mixpanel", $), se = tj(
    te,
    l,
    K,
    G
  ), ue = (be, He) => {
    T((Ge) => ({
      ...Ge,
      [be]: String(He)
    }));
  }, fe = (be, He, Ge) => {
    T(Ge ? (Le) => ({
      ...Le,
      [He]: Ge
    }) : (Le) => ({
      ...Le,
      [He]: be.target.value
    }));
  }, ve = (be, He) => {
    D((Ge) => {
      const Le = Ge[He] || [];
      return Le.includes(be) ? {
        ...Ge,
        [He]: Le.filter((Ae) => Ae !== be)
      } : {
        ...Ge,
        [He]: [...Le, be]
      };
    });
  }, ge = (be, He, Ge) => {
    T(Ge === "radio" ? (Le) => {
      var Ae;
      return {
        ...Le,
        [He]: (Ae = Le[He]) != null && Ae.includes(be) ? [] : [be]
      };
    } : (Le) => ({
      ...Le,
      [He]: be
    }));
  }, oe = () => {
    eke({
      BACKEND_URL: $ == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL,
      entityId: ee,
      campaignId: r || "",
      formdata: P,
      answer: F,
      selectedOptions: U,
      questData: I,
      setThanksPopup: O,
      onSubmit: A,
      GeneralFunctions: new Bt("mixpanel", $),
      apiKey: X,
      apiSecret: ne || "",
      userId: t || "",
      token: e || "",
      uniqueUserId: a || "",
      toast: Ir
    });
  }, ce = () => {
    O(!1);
  }, pe = (be) => {
    let He = [];
    return d[Q] && d[Q].forEach((Ge) => {
      const Le = be[Ge - 1];
      Le && He.push(Le);
    }), He;
  };
  le(() => {
    $Pe({
      BACKEND_URL: $ == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL,
      entityId: ee,
      campaignId: r || "",
      variation: f || "",
      apiKey: X,
      apiSecret: ne || "",
      userId: t || "",
      token: e || "",
      setQuestData: S,
      setUiProps: J,
      setBrandTheme: V,
      setQuestThemeData: L,
      setFormdata: H,
      // setData,
      bgColor: n || "",
      uniqueUserId: a || "",
      uniqueEmailId: s || "",
      entityAuthenticationToken: g || "",
      apiType: $,
      GeneralFunctions: new Bt("mixpanel", $)
      // setGradient,
    });
  }, []), le(() => {
    var be;
    if ((d == null ? void 0 : d.length) > 0 && P.length > 0 && Q >= 0 && ((be = d[Q]) == null ? void 0 : be.length) > 0) {
      const He = pe(P);
      R(He);
    }
  }, [d, P, Q]), le(() => {
    tke(
      Q,
      d,
      P,
      F,
      U,
      Z
    );
  }, [F, Q, U, P]);
  const qe = {
    answer: F,
    setAnswer: T,
    selectedOptions: U,
    setSelectedOptions: D,
    currentSection: Q,
    setCurrentSection: Y,
    goToNextSection: j,
    setGoToNextSection: Z,
    thanksPopup: M,
    setThanksPopup: O,
    formdata: P,
    design: d,
    sectionQuestions: W,
    themeManager: se,
    GeneralFunctions: ae,
    handleReturnAnswers: oe,
    handleThanks: ce,
    handleUpdate: fe,
    handleRadioChange: ge,
    handleRatingChange: ue,
    handleCheckboxChange: ve,
    ratingType: i,
    sections: u,
    iconColor: o,
    showFooter: c,
    Headers: m,
    questThemeData: K,
    onCancel: w,
    showCancelButton: b,
    submitButtonText: q,
    thankYouHeading: E,
    thankYouDescription: x
  };
  if (!P.length) return null;
  const Se = re.Children.toArray(B).find(
    (be) => re.isValidElement(be) && be.type === Rc.Footer
  ), Te = re.Children.toArray(B).filter(
    (be) => re.isValidElement(be) && be.type !== Rc.Footer
  );
  return /* @__PURE__ */ h(rj.Provider, { value: qe, children: /* @__PURE__ */ h(
    "div",
    {
      className: `q-feedback-cont ${C || ""}`,
      style: se.getFormStyles(),
      children: M ? y || /* @__PURE__ */ h(Rc.ThankYou, { children: Se }) : /* @__PURE__ */ k(Ze, { children: [
        Te,
        Se
      ] })
    }
  ) });
};
Rc.Header = WPe;
Rc.Content = XPe;
Rc.Footer = KPe;
Rc.ThankYou = ZPe;
const rke = ({
  formdata: t,
  handleUpdate: e,
  handleSubmit: r,
  ratingStyle: n,
  normalInput: A,
  emailInput: i,
  normalInput2: o,
  answer: s,
  buttonStyle: a = {},
  labelStyle: c = {},
  PrimaryButtonText: l = "Submit",
  StarStyle: u,
  isVisible: f,
  setIsVisible: d,
  screenshot: g,
  setScreenshot: m,
  onStartCapture: p,
  uploadFileToBackend: v,
  inputRef: C,
  file: w,
  setFile: B,
  styleConfig: y,
  BrandTheme: b,
  QuestThemeData: q,
  starBorderColor: E,
  rating: x,
  setRating: M
}) => {
  const O = (P, H, F) => {
    M(F), e(P, H, "", F);
  }, { themeConfig: I } = Xe(ct.Context);
  return /* @__PURE__ */ h("form", { className: "q-fdov-ch-boxes", onSubmit: async (P) => {
    P.preventDefault();
    let H = [];
    if (w !== null) {
      let F = await v(w);
      H.push(F);
    }
    if (g !== null) {
      let F = await v(g);
      H.push(F);
    }
    for (let F = 0; F < t.length; F++)
      if (t[F].type === "USER_INPUT_IMAGE") {
        s[t[F].criteriaId] = H;
        break;
      }
    r(), B(null), m(null);
  }, children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k(Ze, { children: [
    t.map((P) => {
      var H, F, T, U, D, Q, Y, j, Z, W, R, K, L, G;
      if (P.type === "USER_INPUT_TEXT")
        return A(
          P.question || "",
          P.criteriaId || "",
          P.placeholder || "",
          P.required || !1
        );
      if (P.type === "USER_INPUT_EMAIL")
        return i(
          P.question || "",
          P.criteriaId || "",
          P.placeholder || "",
          P.required || !1
        );
      if (P.type === "USER_INPUT_TEXTAREA")
        return o(
          P.question || "",
          P.criteriaId || "",
          P.placeholder || "",
          P.required || !1
        );
      if (P.type === "RATING")
        return /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h(
            ho,
            {
              htmlFor: "normalInput",
              children: P.question ? P.question : "How would you rate your experience ?",
              style: c
            }
          ),
          /* @__PURE__ */ k("div", { children: [
            n == "Numbers" || P.ratingType == "Numbers" ? /* @__PURE__ */ h(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "4px"
                },
                children: Array(P.scale || 5).fill(1).map((V, _) => /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      fontSize: "14px",
                      fontWeight: "400",
                      minWidth: "35px",
                      color: V + _ <= x ? "#FFF" : "#8E8E8E",
                      borderRadius: "10px",
                      border: V + _ <= x ? "2px solid var(--neutral-grey-100, #000)" : "2px solid var(--neutral-grey-100, #ECECEC)",
                      background: V + _ <= x ? "#000" : "#fff",
                      padding: "10px 12px",
                      textAlign: "center",
                      cursor: "pointer",
                      boxSizing: "content-box"
                    },
                    onClick: (J) => O(J, P.criteriaId, V + _),
                    children: V + _
                  },
                  _
                ))
              }
            ) : /* @__PURE__ */ h(
              "div",
              {
                style: {
                  display: "flex",
                  gap: "8px",
                  ...u == null ? void 0 : u.Style
                },
                children: [1, 2, 3, 4, 5].map((V) => /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      width: `${u == null ? void 0 : u.Size}px` || "32px",
                      height: `${u == null ? void 0 : u.Size}px` || "32px",
                      lineHeight: `${u == null ? void 0 : u.Size}px` || "32px",
                      cursor: "pointer"
                    },
                    onClick: (_) => O(_, P.criteriaId, V),
                    children: V <= x ? f4(
                      u == null ? void 0 : u.Size,
                      u == null ? void 0 : u.PrimaryColor
                    ) : d4(
                      u == null ? void 0 : u.Size,
                      u == null ? void 0 : u.SecondaryColor,
                      E
                    )
                  },
                  V
                ))
              }
            ),
            n && n !== "Star" && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
              /* @__PURE__ */ h("div", { className: "ratingText", children: (P == null ? void 0 : P.leftText) || "Not likely" }),
              /* @__PURE__ */ h("div", { className: "ratingText", children: (P == null ? void 0 : P.rightText) || "Very Likely" })
            ] }),
            P.ratingType && P.ratingType !== "Star" && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
              /* @__PURE__ */ h("div", { className: "ratingText", children: (P == null ? void 0 : P.leftText) || "Not likely" }),
              /* @__PURE__ */ h("div", { className: "ratingText", children: (P == null ? void 0 : P.rightText) || "Very Likely" })
            ] })
          ] })
        ] }, P.criteriaId);
      if (P.type === "USER_INPUT_IMAGE")
        return /* @__PURE__ */ k("div", { className: "q-fdov-image-input q-gen-img-upl", children: [
          /* @__PURE__ */ k("div", { className: "q-gen-img-upl-btns", children: [
            /* @__PURE__ */ h("div", { className: "gen-upl-btn-1", children: /* @__PURE__ */ h(
              "button",
              {
                style: {
                  borderColor: I.borderColor,
                  border: ((H = y == null ? void 0 : y.Input) == null ? void 0 : H.border) || "1px solid #ECECEC",
                  ...y == null ? void 0 : y.Input,
                  opacity: g === null ? 1 : 0.5
                },
                disabled: g !== null,
                onClick: () => {
                  d(!f), p();
                },
                children: Ra((F = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : F.color)
              }
            ) }),
            /* @__PURE__ */ h("div", { className: "gen-upl-btn-2", children: /* @__PURE__ */ k(
              "div",
              {
                style: {
                  borderColor: I.borderColor,
                  border: ((T = y == null ? void 0 : y.Input) == null ? void 0 : T.border) || "1px solid #ECECEC",
                  ...y == null ? void 0 : y.Input,
                  opacity: w === null ? 1 : 0.5
                },
                children: [
                  /* @__PURE__ */ h("label", { className: "q-button-sm q-fw-normal ", htmlFor: "feed-back-up-img", style: {
                    cursor: w === null ? "pointer" : "no-drop"
                  }, children: za((U = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : U.color) }),
                  /* @__PURE__ */ h("input", { type: "file", style: {
                    display: "none"
                  }, ref: C, onChange: (V) => {
                    if (V.target.files && V.target.files.length > 0) {
                      const _ = V.target.files[0];
                      B(_);
                    }
                  }, disabled: w !== null, accept: "image/*", id: "feed-back-up-img" })
                ]
              }
            ) })
          ] }),
          g !== null && /* @__PURE__ */ k(
            "div",
            {
              className: "q-fdov-file-name q-gen-screen-shot-name",
              style: {
                border: ((D = y == null ? void 0 : y.Input) == null ? void 0 : D.border) || "1px solid #ECECEC"
              },
              children: [
                /* @__PURE__ */ h("div", { children: Ra((Q = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : Q.color) }),
                /* @__PURE__ */ h("p", { style: {
                  color: ((Y = y == null ? void 0 : y.Input) == null ? void 0 : Y.color) || ((j = y == null ? void 0 : y.Form) == null ? void 0 : j.color) || (b == null ? void 0 : b.primaryColor) || I.primaryColor
                }, children: g.name }),
                /* @__PURE__ */ h("button", { onClick: () => {
                  m(null);
                }, children: Ya((Z = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : Z.color) })
              ]
            }
          ),
          w && /* @__PURE__ */ k(
            "div",
            {
              className: "q-fdov-file-name q-gen-file-name",
              style: {
                border: ((W = y == null ? void 0 : y.Input) == null ? void 0 : W.border) || "1px solid #ECECEC"
              },
              children: [
                /* @__PURE__ */ h("div", { children: za((R = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : R.color) }),
                /* @__PURE__ */ h("p", { style: {
                  color: ((K = y == null ? void 0 : y.Input) == null ? void 0 : K.color) || ((L = y == null ? void 0 : y.Form) == null ? void 0 : L.color) || (b == null ? void 0 : b.primaryColor) || I.primaryColor
                }, children: w.name }),
                /* @__PURE__ */ h(
                  "button",
                  {
                    onClick: () => {
                      B(null), C.current && (C.current.value = "");
                    },
                    children: Ya((G = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : G.color)
                  }
                )
              ]
            }
          )
        ] });
    }),
    /* @__PURE__ */ h(
      yr,
      {
        children: l,
        style: a,
        className: "q-fdov-btn-continue",
        type: "submit"
      }
    )
  ] }) : /* @__PURE__ */ h("div", { className: "q-center", children: "No data Found" }) });
}, nke = ({
  formdata: t,
  handleSubmit: e,
  normalInput: r,
  emailInput: n,
  normalInput2: A,
  buttonStyle: i = {},
  PrimaryButtonText: o = "Submit",
  labelStyle: s,
  ratingStyle: a,
  handleUpdate: c,
  StarStyle: l,
  isVisible: u,
  setIsVisible: f,
  screenshot: d,
  setScreenshot: g,
  onStartCapture: m,
  uploadFileToBackend: p,
  inputRef: v,
  file: C,
  setFile: w,
  answer: B,
  styleConfig: y,
  BrandTheme: b,
  rating: q,
  setRating: E
}) => {
  const x = (I, S, P) => {
    E(P), c(I, S, "", P);
  }, { themeConfig: M } = Xe(ct.Context);
  return /* @__PURE__ */ h("form", { className: "q-fdov-ch-boxes", onSubmit: async (I) => {
    I.preventDefault();
    let S = [];
    if (C !== null) {
      let P = await p(C);
      S.push(P);
    }
    if (d !== null) {
      let P = await p(d);
      S.push(P);
    }
    for (let P = 0; P < t.length; P++)
      if (t[P].type === "USER_INPUT_IMAGE") {
        B[t[P].criteriaId] = S;
        break;
      }
    e(), w(null), g(null);
  }, children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k(Ze, { children: [
    t.map((I) => {
      var S, P, H, F, T, U, D, Q, Y, j, Z, W, R, K;
      if (I.type === "USER_INPUT_TEXT")
        return r(
          I.question || "",
          I.criteriaId || "",
          I.placeholder || "",
          I.required || !1
        );
      if (I.type === "USER_INPUT_EMAIL")
        return n(I.question || "", I.criteriaId || "", I.placeholder || "", I.required || !1);
      if (I.type === "USER_INPUT_TEXTAREA")
        return A(
          I.question || "",
          I.criteriaId || "",
          I.placeholder || "",
          I.required || !1
        );
      if (I.type === "RATING")
        return /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h(
            ho,
            {
              htmlFor: "normalInput",
              children: I.question ? I.question : "How would you rate your experience ?",
              style: s
            }
          ),
          /* @__PURE__ */ k("div", { children: [
            a == "Numbers" || I.ratingType == "Numbers" ? /* @__PURE__ */ h(
              "div",
              {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(5, 1fr)",
                  gap: "4px"
                },
                children: Array(I.scale || 5).fill(1).map((L, G) => /* @__PURE__ */ h(
                  "div",
                  {
                    style: {
                      fontSize: "14px",
                      fontWeight: "400",
                      color: L + G <= q ? "#FFF" : "#8E8E8E",
                      borderRadius: "10px",
                      border: L + G <= q ? "2px solid var(--neutral-grey-100, #000)" : "2px solid var(--neutral-grey-100, #ECECEC)",
                      background: L + G <= q ? "#000" : "#fff",
                      padding: "10px 12px",
                      textAlign: "center",
                      cursor: "pointer",
                      boxSizing: "content-box"
                    },
                    onClick: (V) => x(V, I.criteriaId, L + G),
                    children: L + G
                  },
                  G
                ))
              }
            ) : /* @__PURE__ */ h("div", { style: { display: "flex", gap: "8px", ...l == null ? void 0 : l.Style }, children: [1, 2, 3, 4, 5].map((L) => /* @__PURE__ */ h(
              "div",
              {
                style: {
                  width: `${l == null ? void 0 : l.Size}px` || "32px",
                  height: `${l == null ? void 0 : l.Size}px` || "32px",
                  lineHeight: `${l == null ? void 0 : l.Size}px` || "32px",
                  cursor: "pointer"
                },
                onClick: (G) => x(G, I.criteriaId, L),
                children: L <= q ? f4(l == null ? void 0 : l.Size, l == null ? void 0 : l.PrimaryColor) : d4(l == null ? void 0 : l.Size, l == null ? void 0 : l.SecondaryColor)
              },
              L
            )) }),
            a && a !== "Star" && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
              /* @__PURE__ */ h("div", { className: "ratingText", children: (I == null ? void 0 : I.leftText) || "Not likely" }),
              /* @__PURE__ */ h("div", { className: "ratingText", children: (I == null ? void 0 : I.rightText) || "Very Likely" })
            ] }),
            I.ratingType && I.ratingType !== "Star" && /* @__PURE__ */ k("div", { className: "ratingTextView", children: [
              /* @__PURE__ */ h("div", { className: "ratingText", children: (I == null ? void 0 : I.leftText) || "Not likely" }),
              /* @__PURE__ */ h("div", { className: "ratingText", children: (I == null ? void 0 : I.rightText) || "Very Likely" })
            ] })
          ] })
        ] }, I.criteriaId);
      if (I.type === "USER_INPUT_IMAGE")
        return /* @__PURE__ */ k("div", { style: { position: "relative" }, className: "q-fdov-image-input", children: [
          /* @__PURE__ */ k("div", { style: { display: "flex", justifyContent: "center", borderRadius: "10px", overflow: "hidden" }, children: [
            /* @__PURE__ */ h("button", { style: {
              width: "100%",
              borderRadius: "10px 0px 0px 10px",
              border: ((S = y == null ? void 0 : y.Input) == null ? void 0 : S.border) || "1px solid #ECECEC",
              background: "transparent",
              position: "relative",
              cursor: "pointer",
              padding: "10px",
              opacity: d === null ? 1 : 0.5
            }, disabled: d !== null, onClick: () => {
              f(!u), m();
            }, children: Ra((P = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : P.color) }),
            /* @__PURE__ */ k("button", { style: {
              width: "100%",
              height: "100%",
              borderRadius: "0px 10px 10px 0px",
              border: ((H = y == null ? void 0 : y.Input) == null ? void 0 : H.border) || "1px solid #ECECEC",
              position: "relative",
              background: "transparent",
              padding: "10px",
              opacity: C === null ? 1 : 0.5
            }, disabled: C !== null, children: [
              za((F = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : F.color),
              /* @__PURE__ */ h("input", { type: "file", style: {
                opacity: 0,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                cursor: C === null ? "pointer" : "no-drop",
                display: "block"
              }, ref: v, onChange: (L) => {
                if (L.target.files && L.target.files.length > 0) {
                  const G = L.target.files[0];
                  w(G);
                }
              }, disabled: C !== null, accept: "image/*" })
            ] })
          ] }),
          d !== null && /* @__PURE__ */ k("div", { className: "q-fdov-file-name", style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: ((T = y == null ? void 0 : y.Input) == null ? void 0 : T.border) || "1px solid #ECECEC",
            borderRadius: "10px",
            padding: "10px 10px",
            marginTop: "10px",
            gap: "5px"
          }, children: [
            /* @__PURE__ */ h("div", { style: {
              display: "flex",
              alignItems: "center"
            }, children: Ra((U = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : U.color) }),
            /* @__PURE__ */ h("p", { style: {
              fontSize: "14px",
              width: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
              color: ((D = y == null ? void 0 : y.Input) == null ? void 0 : D.color) || ((Q = y == null ? void 0 : y.Form) == null ? void 0 : Q.color) || (b == null ? void 0 : b.primaryColor) || M.primaryColor
            }, children: d == null ? void 0 : d.name }),
            /* @__PURE__ */ h("button", { style: {
              width: "fit-content",
              border: "none",
              background: "transparent",
              cursor: "pointer"
            }, onClick: () => {
              g(null);
            }, children: Ya((Y = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : Y.color) })
          ] }),
          C && /* @__PURE__ */ k("div", { className: "q-fdov-file-name", style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: ((j = y == null ? void 0 : y.Input) == null ? void 0 : j.border) || "1px solid #ECECEC",
            borderRadius: "10px",
            padding: "10px 10px",
            marginTop: "10px",
            gap: "5px"
          }, children: [
            /* @__PURE__ */ h("div", { style: {
              display: "flex",
              alignItems: "center"
            }, children: za((Z = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : Z.color) }),
            /* @__PURE__ */ h("p", { style: {
              fontSize: "14px",
              width: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              color: ((W = y == null ? void 0 : y.Input) == null ? void 0 : W.color) || ((R = y == null ? void 0 : y.Form) == null ? void 0 : R.color) || (b == null ? void 0 : b.primaryColor) || M.primaryColor
            }, children: C == null ? void 0 : C.name }),
            /* @__PURE__ */ h(
              "button",
              {
                style: {
                  width: "fit-content",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer"
                },
                onClick: () => {
                  w(null), v.current && (v.current.value = "");
                },
                children: Ya((K = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : K.color)
              }
            )
          ] })
        ] });
    }),
    /* @__PURE__ */ h(yr, { children: o || "Submit", className: "q-fdov-btn-continue", type: "submit", style: i })
  ] }) : /* @__PURE__ */ h("div", { className: "q-center", children: "No data Found" }) });
}, Ake = ({
  formdata: t,
  handleSubmit: e,
  normalInput: r,
  emailInput: n,
  normalInput2: A,
  buttonStyle: i = {},
  PrimaryButtonText: o = "Submit",
  ratingStyle: s,
  labelStyle: a,
  handleUpdate: c,
  StarStyle: l,
  isVisible: u,
  setIsVisible: f,
  screenshot: d,
  setScreenshot: g,
  onStartCapture: m,
  uploadFileToBackend: p,
  inputRef: v,
  file: C,
  setFile: w,
  answer: B,
  styleConfig: y,
  BrandTheme: b,
  rating: q,
  setRating: E
}) => {
  const x = (I, S, P) => {
    E(P), c(I, S, "", P);
  }, { themeConfig: M } = Xe(ct.Context);
  return /* @__PURE__ */ h("form", { className: "q-fdov-ch-boxes", onSubmit: async (I) => {
    I.preventDefault();
    let S = [];
    if (C !== null) {
      let P = await p(C);
      S.push(P);
    }
    if (d !== null) {
      let P = await p(d);
      S.push(P);
    }
    for (let P = 0; P < t.length; P++)
      if (t[P].type === "USER_INPUT_IMAGE") {
        B[t[P].criteriaId] = S;
        break;
      }
    e(), w(null), g(null);
  }, children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k(Ze, { children: [
    t.map((I) => {
      var S, P, H, F, T, U, D, Q, Y, j, Z, W, R, K;
      if (I.type === "USER_INPUT_TEXT")
        return r(
          I.question || "",
          I.criteriaId || "",
          I.placeholder || "",
          I.required || !1
        );
      if (I.type === "USER_INPUT_EMAIL")
        return n(I.question || "", I.criteriaId || "", I.placeholder || "", I.required || !1);
      if (I.type === "USER_INPUT_TEXTAREA")
        return A(
          I.question || "",
          I.criteriaId || "",
          I.placeholder || "",
          I.required || !1
        );
      if (I.type === "RATING")
        return /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ h(
            ho,
            {
              htmlFor: "normalInput",
              children: I.question ? I.question : "How would you rate your experience ?",
              style: a
            }
          ),
          /* @__PURE__ */ h("div", { children: s == "Numbers" ? /* @__PURE__ */ h(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "4px"
              },
              children: [1, 2, 3, 4, 5].map((L) => /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    fontSize: "14px",
                    fontWeight: "400",
                    color: L <= q ? "#FFF" : "#8E8E8E",
                    borderRadius: "10px",
                    border: L <= q ? "2px solid var(--neutral-grey-100, #000)" : "2px solid var(--neutral-grey-100, #ECECEC)",
                    background: L <= q ? "#000" : "#fff",
                    padding: "10px 12px",
                    textAlign: "center",
                    cursor: "pointer",
                    boxSizing: "content-box"
                  },
                  onClick: (G) => x(G, I.criteriaId, L),
                  children: L
                },
                L
              ))
            }
          ) : /* @__PURE__ */ h("div", { style: { display: "flex", gap: "8px", ...l == null ? void 0 : l.Style }, children: [1, 2, 3, 4, 5].map((L) => /* @__PURE__ */ h(
            "div",
            {
              style: {
                width: `${l == null ? void 0 : l.Size}px` || "32px",
                height: `${l == null ? void 0 : l.Size}px` || "32px",
                lineHeight: `${l == null ? void 0 : l.Size}px` || "32px",
                cursor: "pointer"
              },
              onClick: (G) => x(G, I.criteriaId, L),
              children: L <= q ? f4(l == null ? void 0 : l.Size, l == null ? void 0 : l.PrimaryColor) : d4(l == null ? void 0 : l.Size, l == null ? void 0 : l.SecondaryColor)
            },
            L
          )) }) })
        ] }, I.criteriaId);
      if (I.type === "USER_INPUT_IMAGE")
        return /* @__PURE__ */ k("div", { style: { position: "relative" }, className: "q-fdov-image-input", children: [
          /* @__PURE__ */ k("div", { style: { display: "flex", justifyContent: "center", borderRadius: "10px", overflow: "hidden" }, children: [
            /* @__PURE__ */ h("button", { style: {
              width: "100%",
              borderRadius: "10px 0px 0px 10px",
              border: ((S = y == null ? void 0 : y.Input) == null ? void 0 : S.border) || "1px solid #ECECEC",
              background: "transparent",
              position: "relative",
              cursor: "pointer",
              padding: "10px",
              opacity: d === null ? 1 : 0.5
            }, disabled: d !== null, onClick: () => {
              f(!u), m();
            }, children: Ra((P = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : P.color) }),
            /* @__PURE__ */ k("button", { style: {
              width: "100%",
              height: "100%",
              borderRadius: "0px 10px 10px 0px",
              border: ((H = y == null ? void 0 : y.Input) == null ? void 0 : H.border) || "1px solid #ECECEC",
              position: "relative",
              background: "transparent",
              padding: "10px",
              opacity: C === null ? 1 : 0.5
            }, disabled: C !== null, children: [
              za((F = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : F.color),
              /* @__PURE__ */ h("input", { type: "file", style: {
                opacity: 0,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                cursor: C === null ? "pointer" : "no-drop",
                display: "block"
              }, ref: v, onChange: (L) => {
                if (L.target.files && L.target.files.length > 0) {
                  const G = L.target.files[0];
                  w(G);
                }
              }, disabled: C !== null, accept: "image/*" })
            ] })
          ] }),
          d !== null && /* @__PURE__ */ k("div", { className: "q-fdov-file-name", style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: ((T = y == null ? void 0 : y.Input) == null ? void 0 : T.border) || "1px solid #ECECEC",
            borderRadius: "10px",
            padding: "10px 10px",
            marginTop: "10px",
            gap: "5px"
          }, children: [
            /* @__PURE__ */ h("div", { style: {
              display: "flex",
              alignItems: "center"
            }, children: Ra((U = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : U.color) }),
            /* @__PURE__ */ h("p", { style: {
              fontSize: "14px",
              width: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
              color: ((D = y == null ? void 0 : y.Input) == null ? void 0 : D.color) || ((Q = y == null ? void 0 : y.Form) == null ? void 0 : Q.color) || (b == null ? void 0 : b.primaryColor) || M.primaryColor
            }, children: d.name }),
            /* @__PURE__ */ h("button", { style: {
              width: "fit-content",
              border: "none",
              background: "transparent",
              cursor: "pointer"
            }, onClick: () => {
              g(null);
            }, children: Ya((Y = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : Y.color) })
          ] }),
          C && /* @__PURE__ */ k("div", { className: "q-fdov-file-name", style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: ((j = y == null ? void 0 : y.Input) == null ? void 0 : j.border) || "1px solid #ECECEC",
            borderRadius: "10px",
            padding: "10px 10px",
            marginTop: "10px",
            gap: "5px"
          }, children: [
            /* @__PURE__ */ h("div", { style: {
              display: "flex",
              alignItems: "center"
            }, children: za((Z = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : Z.color) }),
            /* @__PURE__ */ h("p", { style: {
              fontSize: "14px",
              width: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              color: ((W = y == null ? void 0 : y.Input) == null ? void 0 : W.color) || ((R = y == null ? void 0 : y.Form) == null ? void 0 : R.color) || (b == null ? void 0 : b.primaryColor) || M.primaryColor
            }, children: C.name }),
            /* @__PURE__ */ h(
              "button",
              {
                style: {
                  width: "fit-content",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer"
                },
                onClick: () => {
                  w(null), v.current && (v.current.value = "");
                },
                children: Ya((K = y == null ? void 0 : y.PrimaryButton) == null ? void 0 : K.color)
              }
            )
          ] })
        ] });
    }),
    /* @__PURE__ */ h(yr, { className: "q-fdov-btn-continue", children: o || "Submit", type: "submit", style: i })
  ] }) : /* @__PURE__ */ h("div", { className: "q-center", children: "No data Found" }) });
};
function nj(t) {
  const e = {
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  return new Date(t).toLocaleDateString("en-US", e);
}
function Pc(t) {
  const e = t.includes("[CLOSE_CHAT]"), r = t.replace("[CLOSE_CHAT]", "");
  return e ? {
    value: t,
    closeChatTag: "CLOSE_CHAT",
    isCloseChat: !0,
    regularString: r
  } : {
    value: t,
    closeChatTag: "",
    isCloseChat: !1,
    regularString: r
  };
}
function cP(t, e) {
  var o, s;
  let r = parseInt(t == null ? void 0 : t.slice(1, 3), 16), n = parseInt(t == null ? void 0 : t.slice(3, 5), 16), A = parseInt(t == null ? void 0 : t.slice(5, 7), 16);
  return r = Math.min(255, Math.max(0, Math.floor(r * (1 + e)))), n = Math.min(255, Math.max(0, Math.floor(n * (1 + e)))), A = Math.min(255, Math.max(0, Math.floor(A * (1 + e)))), `#${(s = (o = ((1 << 24) + (r << 16) + (n << 8) + A).toString(16)) == null ? void 0 : o.slice(1)) == null ? void 0 : s.toUpperCase()}`;
}
function PA(t, e) {
  const r = cP(t, e || 0.2), n = cP(t, e || -0.5);
  return { lighter: r, darker: n };
}
const ike = (t) => {
  const e = parseInt(t == null ? void 0 : t.slice(1), 16), r = e >> 16 & 255, n = e >> 8 & 255, A = e & 255;
  return `${r}, ${n}, ${A}`;
};
function kc(t, e = 0.05) {
  t = t == null ? void 0 : t.replace("#", ""), t && t.length === 3 && (t = t == null ? void 0 : t.split("").map((i) => i + i).join(""));
  const r = parseInt(t == null ? void 0 : t.substring(0, 2), 16), n = parseInt(t == null ? void 0 : t.substring(2, 4), 16), A = parseInt(t == null ? void 0 : t.substring(4, 6), 16);
  return `rgba(${r}, ${n}, ${A}, ${e})`;
}
const LFe = ({
  // userId,
  // token,
  // questIds,
  contactUrl: t,
  isOpen: e,
  onClose: r,
  starColor: n,
  starBorderColor: A,
  ratingStyle: i,
  GeneralFeedback: o,
  ReportBug: s,
  ContactUs: a,
  RequestFeature: c,
  SecondaryButtonText: l = "Go to home!",
  PrimaryButtonText: u = "Submit",
  iconColor: f = "#939393",
  styleConfig: d = {},
  offlineFormData: g,
  showFooter: m = !0,
  BrandTheme: p,
  QuestThemeData: v,
  Headers: C
}) => {
  var ge;
  const [w, B] = N(null), [y, b] = N(!1), [q, E] = N(!1), { apiKey: x, apiSecret: M, entityId: O, featureFlags: I, apiType: S, themeConfig: P } = Xe(ct.Context), [H, F] = N([!1, !1, !1, !1]), [T, U] = N({}), [D, Q] = N(!0), [Y, j] = N(null), Z = gt(null), [W, R] = N(null), [K, L] = N(0), G = (oe) => {
    var pe;
    let ce = oe.target;
    (pe = _.current) != null && pe.contains(ce) || r && r();
  }, V = async (oe) => {
  }, _ = re.useRef(null);
  le(() => (D == !0 ? document.body.classList.remove("q-feeback-noselect") : document.body.classList.add("q-feeback-noselect"), () => {
    document.body.classList.remove("q-feeback-noselect");
  }), [D]);
  let J = new Bt("mixpanel", S);
  le(() => {
    J.fireTrackingEvent(
      "quest_feedback_workflow_offline_loaded",
      "feedback_workflow_offline"
    );
  }, []);
  const X = (oe) => {
    oe === "ContactUs" && t ? window.open(t, "_blank") : (B(oe), U({}));
  };
  function ne(oe) {
    var ce;
    J.fireTrackingEvent(
      `quest_feedback_workflow_offline${w}_form_submitted`,
      `feedback_workflow_offline${w}_form`
    ), Object.keys(T).length !== 0 && ((ce = g[oe]) == null || ce.map((pe) => ({
      question: (pe == null ? void 0 : pe.question) || "",
      answer: [T[pe == null ? void 0 : pe.criteriaId] || ""],
      criteriaId: (pe == null ? void 0 : pe.criteriaId) || ""
    })), rs.success({ text: "Thank you for your feedback" }), E(!0), L(0), setTimeout(() => {
      E(!1), B(null);
    }, 4e3));
  }
  const ee = () => {
    J.fireTrackingEvent(
      `quest_feedback_workflow_offline_${w}_form_closed`,
      `feedback_workflow_${w}_form`
    ), B(null);
  }, $ = (oe, ce, pe, qe) => {
    var Se;
    U({
      ...T,
      [ce]: ((Se = oe.target) == null ? void 0 : Se.value) || qe
    });
  }, te = () => {
    E(!1), B(null);
  }, ae = (oe) => {
    U({
      ...T,
      [oe]: ""
    });
  }, se = (oe, ce, pe, qe) => {
    var Se, Te, be, He;
    return /* @__PURE__ */ k("div", { className: "", children: [
      /* @__PURE__ */ h(
        ho,
        {
          htmlFor: "normalInput",
          children: `${oe}${qe === !0 ? "*" : ""}`,
          style: {
            borderColor: P.borderColor,
            color: ((Se = d == null ? void 0 : d.Label) == null ? void 0 : Se.color) || ((Te = d == null ? void 0 : d.Heading) == null ? void 0 : Te.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor,
            ...d.Label
          }
        }
      ),
      /* @__PURE__ */ h(
        Li,
        {
          type: "text",
          style: {
            color: ((be = d == null ? void 0 : d.Input) == null ? void 0 : be.color) || ((He = d == null ? void 0 : d.Heading) == null ? void 0 : He.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor,
            ...d.Input
          },
          placeholder: pe,
          value: T[ce],
          onChange: (Ge) => $(Ge, ce),
          required: qe
        }
      )
    ] }, ce);
  }, ue = (oe, ce, pe, qe) => {
    var Se, Te, be, He, Ge, Le, Ae;
    return /* @__PURE__ */ k("div", { className: "", children: [
      /* @__PURE__ */ h(
        ho,
        {
          htmlFor: "normalInput",
          children: `${oe}${qe === !0 ? "*" : ""}`,
          style: {
            color: ((Se = d == null ? void 0 : d.Label) == null ? void 0 : Se.color) || ((Te = d == null ? void 0 : d.Heading) == null ? void 0 : Te.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor,
            ...d.Label
          }
        }
      ),
      /* @__PURE__ */ h(
        Li,
        {
          type: "email",
          style: {
            borderColor: P.borderColor,
            color: ((be = d == null ? void 0 : d.Input) == null ? void 0 : be.color) || ((He = d == null ? void 0 : d.Heading) == null ? void 0 : He.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor,
            ...d.Input
          },
          placeholder: pe,
          value: T[ce],
          onChange: (Pe) => $(Pe, ce),
          emailtext: ((Ge = d == null ? void 0 : d.EmailError) == null ? void 0 : Ge.text) == null ? "This is not a valid email" : (Le = d == null ? void 0 : d.EmailError) == null ? void 0 : Le.text,
          emailErrorStyle: (Ae = d == null ? void 0 : d.EmailError) == null ? void 0 : Ae.errorStyle,
          required: qe
        }
      )
    ] }, ce);
  }, fe = (oe, ce, pe, qe) => {
    var Se, Te, be, He;
    return /* @__PURE__ */ k("div", { className: "", children: [
      /* @__PURE__ */ h(
        ho,
        {
          htmlFor: "normalInput",
          children: `${oe}${qe === !0 ? "*" : ""}`,
          style: {
            color: ((Se = d == null ? void 0 : d.Label) == null ? void 0 : Se.color) || ((Te = d == null ? void 0 : d.Heading) == null ? void 0 : Te.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor,
            ...d.Label
          }
        }
      ),
      /* @__PURE__ */ h(
        b4,
        {
          onChange: (Ge) => $(Ge, ce),
          value: T[ce],
          placeholder: pe,
          style: {
            borderColor: P.borderColor,
            color: ((be = d == null ? void 0 : d.TextArea) == null ? void 0 : be.color) || ((He = d == null ? void 0 : d.Heading) == null ? void 0 : He.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor,
            ...d.TextArea
          },
          required: qe
        }
      )
    ] }, ce);
  };
  if (((ge = I[Ve.FLAG_CONSTRAINTS.FeedbackWorkflowFlag]) == null ? void 0 : ge.isEnabled) == !1)
    return /* @__PURE__ */ h("div", {});
  const ve = async (oe) => {
    Q(!0);
    const ce = /* @__PURE__ */ new Date(), pe = ce.getHours(), qe = ce.getMinutes(), Se = ce.getSeconds();
    let be = "screenshot" + (pe + ":" + qe + ":" + Se) + ".jpg";
    try {
      const He = await Oe.get(oe, { responseType: "blob" }), Ge = new Blob([He.data], { type: "image/jpeg" }), Le = new File([Ge], be, { type: "image/jpeg" });
      j(Le);
    } catch (He) {
      console.error("An error occurred while fetching the image:", He);
    }
  };
  return le(() => {
    var oe, ce, pe, qe, Se, Te, be, He, Ge, Le;
    (oe = d == null ? void 0 : d.ScreenShot) != null && oe.BorderColor && document.documentElement.style.setProperty(
      "--q-screenshot-border-color",
      (ce = d == null ? void 0 : d.ScreenShot) == null ? void 0 : ce.BorderColor
    ), (pe = d == null ? void 0 : d.ScreenShot) != null && pe.BorderWidth && document.documentElement.style.setProperty(
      "--q-screenshot-border-width",
      (qe = d == null ? void 0 : d.ScreenShot) == null ? void 0 : qe.BorderWidth
    ), (Se = d == null ? void 0 : d.ScreenShot) != null && Se.Background && document.documentElement.style.setProperty(
      "--q-screenshot-container-background",
      (Te = d == null ? void 0 : d.ScreenShot) == null ? void 0 : Te.Background
    ), (be = d == null ? void 0 : d.ScreenShot) != null && be.ScreenShotBackground && document.documentElement.style.setProperty(
      "--q-screenshot-inner-container-background",
      (He = d == null ? void 0 : d.ScreenShot) == null ? void 0 : He.ScreenShotBackground
    ), (Ge = d == null ? void 0 : d.ScreenShot) != null && Ge.CrosshairColor && document.documentElement.style.setProperty(
      "--q-screenshot-crosshair-color",
      (Le = d == null ? void 0 : d.ScreenShot) == null ? void 0 : Le.CrosshairColor
    );
  }, [d == null ? void 0 : d.ScreenShot]), /* @__PURE__ */ h(
    zM,
    {
      isOpen: e,
      onClose: r || (() => {
      }),
      style: { padding: 0, background: "transparent", ...d.Modal },
      children: /* @__PURE__ */ h(kH, { onEndCapture: ve, children: ({ onStartCapture: oe }) => {
        var ce, pe, qe, Se, Te, be, He, Ge, Le, Ae, Pe, it, de, xe, he, Qe, Re, pt, ze, lt, st, We, Je, ut, Be, Ct, Ye, $e, nt, mt, me, yt, Ue, Ie, ot, Ke, tt, Ot, Vt, Mt, lr, Lr, Et, Qt, Er, kt, en, St, jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn, dt, ie, _e, Ne, Ee, et, Ft, je, ur, Me, De, Ce, Pt, Ut, It, at, vt, zt, Ht, _t, or, tr, Cr, jt, dr, Xt, ui, sr, di, bo, Bo, Ws, Xs, Ks, Zs, Js, Kd, Zd, Jd, _d, $d, Eo, Ei, pn, Ki, e0, t0, r0, py, gy, my, vy, qy, yy, Cy, wy, by, By, Ey, xy, Iy, Sy, Py, ky;
        return /* @__PURE__ */ k(
          "div",
          {
            className: "q_modal_overlay",
            onClick: (yj) => G(yj),
            style: {
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: D ? "rgba(0,0,0,0.5)" : "transparent",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: D ? 1 : 0
            },
            children: [
              y && /* @__PURE__ */ h(rl, {}),
              !q && /* @__PURE__ */ h(
                "div",
                {
                  className: "q_modal",
                  ref: _,
                  id: "modal_box",
                  style: {
                    padding: 0,
                    background: "transparent",
                    opacity: D ? 1 : 0,
                    ...d.Modal,
                    borderRadius: ((ce = d == null ? void 0 : d.Form) == null ? void 0 : ce.borderRadius) || (v == null ? void 0 : v.borderRadius) || (p == null ? void 0 : p.borderRadius)
                  },
                  children: /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-fw-div",
                      style: {
                        background: ((pe = d == null ? void 0 : d.Form) == null ? void 0 : pe.backgroundColor) || (p == null ? void 0 : p.background) || (P == null ? void 0 : P.backgroundColor),
                        height: ((qe = d == null ? void 0 : d.Form) == null ? void 0 : qe.height) || "auto",
                        borderRadius: ((Se = d == null ? void 0 : d.Form) == null ? void 0 : Se.borderRadius) || (v == null ? void 0 : v.borderRadius) || (p == null ? void 0 : p.borderRadius),
                        fontFamily: (p == null ? void 0 : p.fontFamily) || P.fontFamily || "'Figtree', sans-serif",
                        ...d == null ? void 0 : d.Form
                      },
                      id: "disabledClick",
                      children: w && !q ? /* @__PURE__ */ k("div", { children: [
                        /* @__PURE__ */ h(
                          T1,
                          {
                            style: {
                              topbarStyle: d == null ? void 0 : d.TopBar,
                              headingStyle: {
                                color: ((Te = d == null ? void 0 : d.Heading) == null ? void 0 : Te.color) || (p == null ? void 0 : p.titleColor) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                ...d == null ? void 0 : d.Heading
                              },
                              descriptionStyle: {
                                color: ((be = d == null ? void 0 : d.Description) == null ? void 0 : be.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                                ...d == null ? void 0 : d.Description
                              }
                            },
                            description: w == "ContactUs" ? Array.isArray(C) ? (He = C[3]) == null ? void 0 : He.subHeading : (a == null ? void 0 : a.description) || "Invite other admins and moderators" : w == "RequestFeature" ? Array.isArray(C) ? (Ge = C[2]) == null ? void 0 : Ge.subHeading : (c == null ? void 0 : c.formDescription) || "How can we make it better" : w == "ReportBug" ? Array.isArray(C) ? (Le = C[1]) == null ? void 0 : Le.subHeading : (s == null ? void 0 : s.formDescription) || "Describe your issue" : Array.isArray(C) ? (Ae = C[0]) == null ? void 0 : Ae.subHeading : (o == null ? void 0 : o.formDescription) || "Give general feedback on this page",
                            heading: w == "ContactUs" ? Array.isArray(C) ? (Pe = C[3]) == null ? void 0 : Pe.heading : (a == null ? void 0 : a.heading) || "Contact us" : w == "RequestFeature" ? Array.isArray(C) ? (it = C[2]) == null ? void 0 : it.heading : (c == null ? void 0 : c.formHeading) || "Request a Feature" : w == "ReportBug" ? Array.isArray(C) ? (de = C[1]) == null ? void 0 : de.heading : (s == null ? void 0 : s.formHeading) || "Report a Bug" : Array.isArray(C) ? (xe = C[0]) == null ? void 0 : xe.heading : (o == null ? void 0 : o.formHeading) || "General Feedback",
                            iconColor: f,
                            onClose: ee
                          }
                        ),
                        /* @__PURE__ */ k("div", { style: { padding: "20px" }, children: [
                          w === "GeneralFeedback" && /* @__PURE__ */ h(
                            rke,
                            {
                              starColor: n,
                              handleSubmit: () => ne(0),
                              handleUpdate: $,
                              formdata: g[0],
                              normalInput: se,
                              emailInput: ue,
                              normalInput2: fe,
                              starBorderColor: A,
                              answer: T,
                              handleRemove: ae,
                              ratingStyle: i,
                              iconColor: f,
                              buttonStyle: {
                                background: ((he = d.PrimaryButton) == null ? void 0 : he.background) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.primaryButton) || P.buttonColor,
                                borderColor: ((Qe = d == null ? void 0 : d.PrimaryButton) == null ? void 0 : Qe.borderColor) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor),
                                ...d.PrimaryButton
                              },
                              PrimaryButtonText: u,
                              StarStyle: d == null ? void 0 : d.Star,
                              labelStyle: {
                                ...d == null ? void 0 : d.Label,
                                color: ((Re = d == null ? void 0 : d.Label) == null ? void 0 : Re.color) || ((pt = d == null ? void 0 : d.Heading) == null ? void 0 : pt.color) || (p == null ? void 0 : p.primaryColor) || P.primaryColor
                              },
                              isVisible: D,
                              setIsVisible: Q,
                              screenshot: Y,
                              setScreenshot: j,
                              onStartCapture: oe,
                              uploadFileToBackend: V,
                              inputRef: Z,
                              file: W,
                              setFile: R,
                              styleConfig: o == null ? void 0 : o.styleConfig,
                              rating: K,
                              setRating: L
                            }
                          ),
                          w === "ReportBug" && /* @__PURE__ */ h(
                            nke,
                            {
                              handleSubmit: () => ne(1),
                              handleUpdate: $,
                              formdata: g[1],
                              answer: T,
                              normalInput: se,
                              normalInput2: fe,
                              emailInput: ue,
                              handleRemove: ae,
                              PrimaryButtonText: u,
                              buttonStyle: {
                                background: ((ze = d.PrimaryButton) == null ? void 0 : ze.background) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.primaryButton) || P.buttonColor,
                                borderColor: ((lt = d == null ? void 0 : d.PrimaryButton) == null ? void 0 : lt.borderColor) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor),
                                ...d.PrimaryButton
                              },
                              isVisible: D,
                              setIsVisible: Q,
                              screenshot: Y,
                              setScreenshot: j,
                              onStartCapture: oe,
                              uploadFileToBackend: V,
                              inputRef: Z,
                              file: W,
                              setFile: R,
                              styleConfig: s == null ? void 0 : s.styleConfig,
                              BrandTheme: p,
                              rating: K,
                              setRating: L
                            }
                          ),
                          w === "RequestFeature" && /* @__PURE__ */ h(
                            Ake,
                            {
                              handleSubmit: () => ne(2),
                              handleUpdate: $,
                              formdata: g[2],
                              normalInput: se,
                              normalInput2: fe,
                              emailInput: ue,
                              answer: T,
                              handleRemove: ae,
                              PrimaryButtonText: u,
                              buttonStyle: {
                                background: ((st = d.PrimaryButton) == null ? void 0 : st.background) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.primaryButton) || P.buttonColor,
                                borderColor: ((We = d == null ? void 0 : d.PrimaryButton) == null ? void 0 : We.borderColor) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor),
                                ...d.PrimaryButton
                              },
                              isVisible: D,
                              setIsVisible: Q,
                              screenshot: Y,
                              setScreenshot: j,
                              onStartCapture: oe,
                              uploadFileToBackend: V,
                              inputRef: Z,
                              file: W,
                              setFile: R,
                              styleConfig: c == null ? void 0 : c.styleConfig,
                              BrandTheme: p,
                              rating: K,
                              setRating: L
                            }
                          ),
                          w === "ContactUs" && /* @__PURE__ */ h("div", {})
                        ] }),
                        m && /* @__PURE__ */ h(
                          Pr,
                          {
                            style: {
                              background: ((ut = (Je = d == null ? void 0 : d.Footer) == null ? void 0 : Je.FooterStyle) == null ? void 0 : ut.backgroundColor) || ((Be = d == null ? void 0 : d.Form) == null ? void 0 : Be.backgroundColor) || ((Ct = d == null ? void 0 : d.Form) == null ? void 0 : Ct.background) || (p == null ? void 0 : p.background) || (P == null ? void 0 : P.backgroundColor),
                              ...(Ye = d == null ? void 0 : d.Footer) == null ? void 0 : Ye.FooterStyle
                            },
                            textStyle: ($e = d == null ? void 0 : d.Footer) == null ? void 0 : $e.FooterTextStyle,
                            iconStyle: (nt = d == null ? void 0 : d.Footer) == null ? void 0 : nt.FooterIcon,
                            text: (mt = d == null ? void 0 : d.Footer) == null ? void 0 : mt.FooterText,
                            link: (me = d == null ? void 0 : d.Footer) == null ? void 0 : me.FooterLink
                          }
                        )
                      ] }) : q ? "" : /* @__PURE__ */ k("div", { children: [
                        /* @__PURE__ */ h("div", { className: "q-fw-crossBtn", children: /* @__PURE__ */ h("div", { onClick: () => r == null ? void 0 : r(), children: I3(f) }) }),
                        /* @__PURE__ */ k("div", { className: "q-fw-content-box", children: [
                          /* @__PURE__ */ k(
                            "div",
                            {
                              onClick: () => {
                                J.fireTrackingEvent(
                                  "quest_feedback_workflow_general_feedback_clicked",
                                  "feedback_workflow_general_feedback"
                                ), X("GeneralFeedback");
                              },
                              className: "q-hover q-fw-cards",
                              onMouseEnter: () => F([!0, !1, !1, !1]),
                              onMouseLeave: () => F([!1, !1, !1, !1]),
                              style: {
                                background: H[0] ? ((yt = d.listHover) == null ? void 0 : yt.background) || // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                                "#FBFBFB" : "transparent",
                                borderRadius: "8px",
                                ...d == null ? void 0 : d.Card
                              },
                              children: [
                                /* @__PURE__ */ h(
                                  "div",
                                  {
                                    className: "q_feedback_icon",
                                    style: {
                                      background: H[0] ? ((Ue = d.listHover) == null ? void 0 : Ue.iconBackground) || kc(
                                        v == null ? void 0 : v.accentColor,
                                        0.1
                                      ) || "#F4EBFF" : "#FBFBFB",
                                      ...(Ie = d == null ? void 0 : d.listHover) == null ? void 0 : Ie.Icon
                                    },
                                    children: o != null && o.iconUrl ? /* @__PURE__ */ h(
                                      "img",
                                      {
                                        className: "q_feedback_icon_imgurl",
                                        src: o == null ? void 0 : o.iconUrl
                                      }
                                    ) : UM(
                                      H[0] ? ((ot = d.listHover) == null ? void 0 : ot.iconColor) || F0(
                                        v == null ? void 0 : v.accentColor,
                                        -40
                                      ) || "#9035FF" : f,
                                      (Ke = d.listHover) == null ? void 0 : Ke.IconSize
                                    )
                                  }
                                ),
                                /* @__PURE__ */ k("div", { children: [
                                  /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-heading",
                                      style: {
                                        color: H[0] ? ((tt = d == null ? void 0 : d.listHover) == null ? void 0 : tt.Heading) || ((Ot = d.listHeading) == null ? void 0 : Ot.color) || ((Vt = d == null ? void 0 : d.Heading) == null ? void 0 : Vt.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor) : ((Mt = d.listHeading) == null ? void 0 : Mt.color) || ((lr = d == null ? void 0 : d.Heading) == null ? void 0 : lr.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                        ...d == null ? void 0 : d.listHeading
                                      },
                                      children: (o == null ? void 0 : o.heading) || "General Feedback"
                                    }
                                  ),
                                  /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-description",
                                      style: {
                                        color: H[0] ? ((Lr = d == null ? void 0 : d.listHover) == null ? void 0 : Lr.Description) || ((Et = d == null ? void 0 : d.listDescription) == null ? void 0 : Et.color) || ((Qt = d == null ? void 0 : d.Description) == null ? void 0 : Qt.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor) : ((Er = d == null ? void 0 : d.listDescription) == null ? void 0 : Er.color) || ((kt = d == null ? void 0 : d.Description) == null ? void 0 : kt.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                                        ...d == null ? void 0 : d.listDescription
                                      },
                                      children: (o == null ? void 0 : o.description) || "Give general feedback on this page"
                                    }
                                  )
                                ] })
                              ]
                            }
                          ),
                          /* @__PURE__ */ k(
                            "div",
                            {
                              onClick: () => {
                                J.fireTrackingEvent(
                                  "quest_feedback_workflow_report_bug_clicked",
                                  "feedback_workflow_report_bug"
                                ), X("ReportBug");
                              },
                              className: "q-hover q-fw-cards",
                              onMouseEnter: () => F([!1, !0, !1, !1]),
                              onMouseLeave: () => F([!1, !1, !1, !1]),
                              style: {
                                background: H[1] ? ((en = d.listHover) == null ? void 0 : en.background) || // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                                "#FBFBFB" : "transparent",
                                borderRadius: "8px",
                                ...d == null ? void 0 : d.Card
                              },
                              children: [
                                /* @__PURE__ */ h(
                                  "div",
                                  {
                                    className: "q_feedback_icon",
                                    style: {
                                      background: H[1] ? ((St = d.listHover) == null ? void 0 : St.iconBackground) || kc(
                                        v == null ? void 0 : v.accentColor,
                                        0.1
                                      ) || "#F4EBFF" : "#FBFBFB",
                                      ...(jr = d == null ? void 0 : d.listHover) == null ? void 0 : jr.Icon
                                    },
                                    children: s != null && s.iconUrl ? /* @__PURE__ */ h(
                                      "img",
                                      {
                                        className: "q_feedback_icon_imgurl",
                                        src: s == null ? void 0 : s.iconUrl
                                      }
                                    ) : NM(
                                      H[1] ? ((cn = d.listHover) == null ? void 0 : cn.iconColor) || F0(
                                        v == null ? void 0 : v.accentColor,
                                        -40
                                      ) || ((un = (ln = d == null ? void 0 : d.listHover) == null ? void 0 : ln.Icon) == null ? void 0 : un.color) || "#9035FF" : f,
                                      (dn = d.listHover) == null ? void 0 : dn.IconSize
                                    )
                                  }
                                ),
                                /* @__PURE__ */ k("div", { children: [
                                  /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-heading",
                                      style: {
                                        color: H[1] ? ((fn = d == null ? void 0 : d.listHover) == null ? void 0 : fn.Heading) || ((hn = d.listHeading) == null ? void 0 : hn.color) || ((En = d == null ? void 0 : d.Heading) == null ? void 0 : En.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor) : ((xn = d.listHeading) == null ? void 0 : xn.color) || ((In = d == null ? void 0 : d.Heading) == null ? void 0 : In.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                        ...d == null ? void 0 : d.listHeading
                                      },
                                      children: (s == null ? void 0 : s.heading) || "Report a Bug"
                                    }
                                  ) }),
                                  /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-description",
                                      style: {
                                        color: H[1] ? ((Sn = d == null ? void 0 : d.listHover) == null ? void 0 : Sn.Description) || ((Pn = d == null ? void 0 : d.listDescription) == null ? void 0 : Pn.color) || ((kn = d == null ? void 0 : d.Description) == null ? void 0 : kn.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor) : ((dt = d == null ? void 0 : d.listDescription) == null ? void 0 : dt.color) || ((ie = d == null ? void 0 : d.Description) == null ? void 0 : ie.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                                        ...d == null ? void 0 : d.listDescription
                                      },
                                      children: (s == null ? void 0 : s.description) || "Let us know what's broken"
                                    }
                                  ) })
                                ] })
                              ]
                            }
                          ),
                          /* @__PURE__ */ k(
                            "div",
                            {
                              onClick: () => {
                                J.fireTrackingEvent(
                                  "quest_feedback_workflow_request_feature_clicked",
                                  "feedback_workflow_request_feature"
                                ), X("RequestFeature");
                              },
                              className: "q-hover q-fw-cards",
                              onMouseEnter: () => F([!1, !1, !0, !1]),
                              onMouseLeave: () => F([!1, !1, !1, !1]),
                              style: {
                                background: H[2] ? ((_e = d.listHover) == null ? void 0 : _e.background) || // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                                "#FBFBFB" : "transparent",
                                borderRadius: "8px",
                                ...d == null ? void 0 : d.Card
                              },
                              children: [
                                /* @__PURE__ */ h(
                                  "div",
                                  {
                                    className: "q_feedback_icon",
                                    style: {
                                      background: H[2] ? ((Ne = d.listHover) == null ? void 0 : Ne.iconBackground) || kc(
                                        v == null ? void 0 : v.accentColor,
                                        0.1
                                      ) || "#F4EBFF" : "#FBFBFB",
                                      ...(Ee = d == null ? void 0 : d.listHover) == null ? void 0 : Ee.Icon
                                    },
                                    children: c != null && c.iconUrl ? /* @__PURE__ */ h(
                                      "img",
                                      {
                                        className: "q_feedback_icon_imgurl",
                                        src: c == null ? void 0 : c.iconUrl
                                      }
                                    ) : jM(
                                      H[2] ? ((et = d.listHover) == null ? void 0 : et.iconColor) || F0(
                                        v == null ? void 0 : v.accentColor,
                                        -40
                                      ) || "#9035FF" : f,
                                      (Ft = d.listHover) == null ? void 0 : Ft.IconSize
                                    )
                                  }
                                ),
                                /* @__PURE__ */ k("div", { children: [
                                  /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-heading",
                                      style: {
                                        color: H[2] ? ((je = d == null ? void 0 : d.listHover) == null ? void 0 : je.Heading) || ((ur = d.listHeading) == null ? void 0 : ur.color) || ((Me = d == null ? void 0 : d.Heading) == null ? void 0 : Me.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor) : ((De = d.listHeading) == null ? void 0 : De.color) || ((Ce = d == null ? void 0 : d.Heading) == null ? void 0 : Ce.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                        ...d == null ? void 0 : d.listHeading
                                      },
                                      children: (c == null ? void 0 : c.heading) || "Request a Feature"
                                    }
                                  ) }),
                                  /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-description",
                                      style: {
                                        color: H[2] ? ((Pt = d == null ? void 0 : d.listHover) == null ? void 0 : Pt.Description) || ((Ut = d == null ? void 0 : d.listDescription) == null ? void 0 : Ut.color) || ((It = d == null ? void 0 : d.Description) == null ? void 0 : It.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor) : ((at = d == null ? void 0 : d.listDescription) == null ? void 0 : at.color) || ((vt = d == null ? void 0 : d.Description) == null ? void 0 : vt.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                                        ...d == null ? void 0 : d.listDescription
                                      },
                                      children: (c == null ? void 0 : c.description) || "Tell us how we can improve"
                                    }
                                  ) })
                                ] })
                              ]
                            }
                          ),
                          /* @__PURE__ */ k(
                            "div",
                            {
                              onClick: () => {
                                J.fireTrackingEvent(
                                  "quest_feedback_workflow_contactus_clicked",
                                  "feedback_workflow_contactus"
                                ), X("ContactUs");
                              },
                              className: "q-hover q-fw-cards",
                              onMouseEnter: () => F([!1, !1, !1, !0]),
                              onMouseLeave: () => F([!1, !1, !1, !1]),
                              style: {
                                background: H[3] ? ((zt = d.listHover) == null ? void 0 : zt.background) || // hexToGlassColor(QuestThemeData?.accentColor, 0.05) ||
                                "#FBFBFB" : "transparent",
                                borderRadius: "8px",
                                ...d == null ? void 0 : d.Card
                              },
                              children: [
                                /* @__PURE__ */ h(
                                  "div",
                                  {
                                    className: "q_feedback_icon",
                                    style: {
                                      background: H[3] ? ((Ht = d.listHover) == null ? void 0 : Ht.iconBackground) || kc(
                                        v == null ? void 0 : v.accentColor,
                                        0.1
                                      ) || "#F4EBFF" : "#FBFBFB",
                                      ...(_t = d == null ? void 0 : d.listHover) == null ? void 0 : _t.Icon
                                    },
                                    children: a != null && a.iconUrl ? /* @__PURE__ */ h(
                                      "img",
                                      {
                                        className: "q_feedback_icon_imgurl",
                                        src: a == null ? void 0 : a.iconUrl
                                      }
                                    ) : LM(
                                      H[3] ? ((or = d.listHover) == null ? void 0 : or.iconColor) || F0(
                                        v == null ? void 0 : v.accentColor,
                                        -40
                                      ) || "#9035FF" : f,
                                      (tr = d.listHover) == null ? void 0 : tr.IconSize
                                    )
                                  }
                                ),
                                /* @__PURE__ */ k("div", { children: [
                                  /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                                    "div",
                                    {
                                      className: "q-fw-tab-heading",
                                      style: {
                                        color: H[3] ? ((Cr = d == null ? void 0 : d.listHover) == null ? void 0 : Cr.Heading) || ((jt = d.listHeading) == null ? void 0 : jt.color) || ((dr = d == null ? void 0 : d.Heading) == null ? void 0 : dr.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor) : ((Xt = d.listHeading) == null ? void 0 : Xt.color) || ((ui = d == null ? void 0 : d.Heading) == null ? void 0 : ui.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                        ...d == null ? void 0 : d.listHeading
                                      },
                                      children: (a == null ? void 0 : a.heading) || "Contact us"
                                    }
                                  ) }),
                                  /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                                    "div",
                                    {
                                      style: {
                                        color: H[3] ? ((sr = d == null ? void 0 : d.listHover) == null ? void 0 : sr.Description) || ((di = d == null ? void 0 : d.listDescription) == null ? void 0 : di.color) || ((bo = d == null ? void 0 : d.Description) == null ? void 0 : bo.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor) : ((Bo = d == null ? void 0 : d.listDescription) == null ? void 0 : Bo.color) || ((Ws = d == null ? void 0 : d.Description) == null ? void 0 : Ws.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                                        ...d == null ? void 0 : d.listDescription
                                      },
                                      className: "q-fw-tab-description",
                                      children: (a == null ? void 0 : a.description) || "Tell us how we can help"
                                    }
                                  ) })
                                ] })
                              ]
                            }
                          )
                        ] }),
                        /* @__PURE__ */ h("div", { children: m && /* @__PURE__ */ h(
                          Pr,
                          {
                            style: {
                              background: ((Ks = (Xs = d == null ? void 0 : d.Footer) == null ? void 0 : Xs.FooterStyle) == null ? void 0 : Ks.backgroundColor) || ((Zs = d == null ? void 0 : d.Form) == null ? void 0 : Zs.backgroundColor) || ((Js = d == null ? void 0 : d.Form) == null ? void 0 : Js.background) || (p == null ? void 0 : p.background) || (P == null ? void 0 : P.backgroundColor),
                              ...(Kd = d == null ? void 0 : d.Footer) == null ? void 0 : Kd.FooterStyle
                            },
                            textStyle: (Zd = d == null ? void 0 : d.Footer) == null ? void 0 : Zd.FooterTextStyle,
                            iconStyle: (Jd = d == null ? void 0 : d.Footer) == null ? void 0 : Jd.FooterIcon,
                            text: (_d = d == null ? void 0 : d.Footer) == null ? void 0 : _d.FooterText,
                            link: ($d = d == null ? void 0 : d.Footer) == null ? void 0 : $d.FooterLink
                          }
                        ) })
                      ] })
                    }
                  )
                }
              ),
              q && /* @__PURE__ */ k(
                "div",
                {
                  className: "q-fw-div",
                  style: {
                    background: ((Ei = (Eo = d == null ? void 0 : d.ThanksPopup) == null ? void 0 : Eo.Style) == null ? void 0 : Ei.background) || ((pn = d == null ? void 0 : d.Form) == null ? void 0 : pn.backgroundColor) || (p == null ? void 0 : p.background) || (P == null ? void 0 : P.backgroundColor),
                    height: ((e0 = (Ki = d == null ? void 0 : d.ThanksPopup) == null ? void 0 : Ki.Style) == null ? void 0 : e0.height) || ((t0 = d == null ? void 0 : d.Form) == null ? void 0 : t0.height) || "auto",
                    fontFamily: P.fontFamily || "'Figtree', sans-serif",
                    borderRadius: ((r0 = d == null ? void 0 : d.Form) == null ? void 0 : r0.borderRadius) || (v == null ? void 0 : v.borderRadius) || (p == null ? void 0 : p.borderRadius),
                    ...(py = d == null ? void 0 : d.ThanksPopup) == null ? void 0 : py.Style
                  },
                  id: "disabledClick",
                  children: [
                    /* @__PURE__ */ h("div", { className: "q_submit_cross_icon", onClick: te, children: I3(f, ee) }),
                    /* @__PURE__ */ h("div", { className: "q-fw-thanks", children: /* @__PURE__ */ k("div", { children: [
                      /* @__PURE__ */ h("div", { className: "q-svg-thanks", children: GM() }),
                      /* @__PURE__ */ k("div", { className: "q_fw_submit_box", children: [
                        /* @__PURE__ */ k("div", { className: "q_feedback_text_submitted", children: [
                          /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q_feedback_text_cont",
                              style: {
                                color: ((gy = d == null ? void 0 : d.Heading) == null ? void 0 : gy.color) || (p == null ? void 0 : p.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                ...(my = d == null ? void 0 : d.ThanksPopup) == null ? void 0 : my.Heading
                              },
                              children: "Feedback Submitted"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q_fw_submit_desc",
                              style: {
                                color: ((vy = d == null ? void 0 : d.Description) == null ? void 0 : vy.color) || (p == null ? void 0 : p.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                                ...(qy = d == null ? void 0 : d.ThanksPopup) == null ? void 0 : qy.Description
                              },
                              children: "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ h(
                          "div",
                          {
                            className: "q_fw_submit_back",
                            style: {
                              background: ((yy = d == null ? void 0 : d.SecondaryButton) == null ? void 0 : yy.background) || (p == null ? void 0 : p.secondaryButton),
                              ...d == null ? void 0 : d.SecondaryButton
                            },
                            children: l
                          }
                        )
                      ] })
                    ] }) }),
                    (((Cy = d == null ? void 0 : d.ThanksPopup) == null ? void 0 : Cy.ShowFooter) || m) && /* @__PURE__ */ h(
                      Pr,
                      {
                        style: {
                          background: ((by = (wy = d == null ? void 0 : d.Footer) == null ? void 0 : wy.FooterStyle) == null ? void 0 : by.backgroundColor) || ((By = d == null ? void 0 : d.Form) == null ? void 0 : By.backgroundColor) || ((Ey = d == null ? void 0 : d.Form) == null ? void 0 : Ey.background) || (p == null ? void 0 : p.background) || (P == null ? void 0 : P.backgroundColor),
                          ...(xy = d == null ? void 0 : d.Footer) == null ? void 0 : xy.FooterStyle
                        },
                        textStyle: (Iy = d == null ? void 0 : d.Footer) == null ? void 0 : Iy.FooterTextStyle,
                        iconStyle: (Sy = d == null ? void 0 : d.Footer) == null ? void 0 : Sy.FooterIcon,
                        text: (Py = d == null ? void 0 : d.Footer) == null ? void 0 : Py.FooterText,
                        link: (ky = d == null ? void 0 : d.Footer) == null ? void 0 : ky.FooterLink
                      }
                    )
                  ]
                }
              )
            ]
          }
        );
      } })
    }
  );
}, oke = (t) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: [
      /* @__PURE__ */ k("g", { clipPath: "url(#clip0_6173_885)", children: [
        /* @__PURE__ */ h(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.34225 3.19973C7.45703 3.04985 7.66545 2.83331 7.99992 2.83331C8.33438 2.83331 8.54281 3.04985 8.65759 3.19973C8.76714 3.34279 8.87746 3.54081 8.99057 3.74383L9.07155 3.88911C9.08675 3.91638 9.09872 3.93783 9.10919 3.95618C9.12741 3.96045 9.1486 3.96526 9.17508 3.97125L9.33362 4.00711C9.55216 4.0565 9.76935 4.10558 9.93608 4.17128C10.1202 4.24383 10.3697 4.38512 10.4659 4.69439C10.5604 4.99821 10.4411 5.25555 10.337 5.42096C10.2406 5.57404 10.0942 5.74522 9.94424 5.92048L9.83714 6.04572C9.81414 6.07261 9.79682 6.09288 9.78222 6.11042C9.78421 6.13465 9.78693 6.16286 9.79059 6.2006L9.80671 6.36691C9.8295 6.60153 9.85151 6.82826 9.84344 7.00963C9.83496 7.19979 9.78932 7.48766 9.53121 7.6836C9.26494 7.88574 8.97087 7.84168 8.78439 7.78825C8.61256 7.73902 8.40953 7.64547 8.20505 7.55125L8.05651 7.48285C8.03421 7.47258 8.01589 7.46415 7.99992 7.45693C7.98395 7.46415 7.96563 7.47258 7.94333 7.48285L7.7948 7.55125C7.59031 7.64547 7.38728 7.73902 7.21545 7.78825C7.02897 7.84168 6.7349 7.88574 6.46863 7.6836C6.21051 7.48766 6.16487 7.19979 6.1564 7.00963C6.14832 6.82826 6.17034 6.60154 6.19312 6.36693L6.20925 6.2006C6.2129 6.16286 6.21563 6.13465 6.21762 6.11042C6.20302 6.09288 6.18569 6.07261 6.1627 6.04572L6.05559 5.92048C5.90565 5.74522 5.75919 5.57404 5.66282 5.42096C5.5587 5.25555 5.43948 4.99821 5.53396 4.69439C5.63013 4.38512 5.87967 4.24383 6.06376 4.17128C6.23048 4.10558 6.44767 4.0565 6.66621 4.00712L6.82476 3.97125C6.85124 3.96526 6.87243 3.96046 6.89065 3.95618C6.90112 3.93783 6.91308 3.91638 6.92828 3.88911L7.00927 3.74382C7.12238 3.54081 7.2327 3.34278 7.34225 3.19973ZM7.99992 4.02297C7.96116 4.09007 7.91807 4.16733 7.86728 4.25844L7.80174 4.37601L7.78685 4.40308C7.73449 4.49883 7.6478 4.65738 7.50323 4.76712C7.35565 4.87916 7.17812 4.9177 7.07432 4.94025L7.04544 4.9466L6.91817 4.97539C6.80139 5.00181 6.70626 5.02337 6.62492 5.04382C6.67783 5.10894 6.74655 5.18981 6.83594 5.29434L6.9227 5.3958L6.94268 5.41892C7.01464 5.5018 7.13081 5.63562 7.18454 5.80838C7.23763 5.97911 7.21932 6.15493 7.20776 6.26586L7.20459 6.29705L7.19147 6.43242C7.17931 6.55793 7.16985 6.6581 7.16355 6.73956C7.23302 6.70896 7.31205 6.67261 7.40594 6.62938L7.5251 6.57451L7.55201 6.56191C7.64768 6.51679 7.81414 6.43828 7.99992 6.43828C8.1857 6.43828 8.35215 6.51679 8.44782 6.56191L8.47474 6.57451L8.5939 6.62938C8.68779 6.67261 8.76681 6.70896 8.83628 6.73956C8.82999 6.6581 8.82053 6.55793 8.80837 6.43242L8.79525 6.29705L8.79208 6.26586C8.78052 6.15493 8.76221 5.97911 8.8153 5.80838C8.86902 5.63562 8.9852 5.5018 9.05716 5.41892L9.07714 5.3958L9.1639 5.29434C9.25329 5.18981 9.32201 5.10894 9.37492 5.04382C9.29358 5.02337 9.19845 5.00181 9.08167 4.97539L8.9544 4.9466L8.92553 4.94025C8.82172 4.91771 8.64419 4.87916 8.49661 4.76712C8.35204 4.65738 8.26534 4.49883 8.21299 4.40308L8.1981 4.37601L8.13256 4.25844C8.08177 4.16733 8.03868 4.09007 7.99992 4.02297ZM7.15948 7.00766C7.15946 7.00769 7.15929 7.00701 7.15904 7.00556L7.15948 7.00766ZM8.84036 7.00766L8.8408 7.00556C8.84054 7.00701 8.84038 7.00769 8.84036 7.00766Z",
            fill: t || "#9035FF"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.99885 1.07144C5.77411 0.940639 6.78154 0.833313 8.00002 0.833313C9.2185 0.833313 10.2259 0.940639 11.0012 1.07144L11.0911 1.08653C11.7646 1.19927 12.3244 1.29297 12.762 1.83203C13.0428 2.17776 13.1333 2.5514 13.1542 2.9688L13.482 3.07806C13.7907 3.18096 14.0614 3.27114 14.276 3.37102C14.5081 3.47899 14.7208 3.61807 14.8834 3.84368C15.0461 4.06929 15.1107 4.31506 15.1398 4.56939C15.1666 4.80465 15.1666 5.0899 15.1666 5.41535L15.1666 5.51217C15.1666 5.78003 15.1666 6.01664 15.1468 6.21451C15.1254 6.42896 15.0779 6.63745 14.9593 6.83894C14.8408 7.04043 14.6816 7.18317 14.5045 7.30605C14.3411 7.41943 14.1343 7.53432 13.9001 7.6644L12.1397 8.64245C11.7801 9.35 11.2861 9.98083 10.6067 10.4365C10.0235 10.8276 9.32532 11.0752 8.49992 11.1458V12.5H9.45339C10.0095 12.5 10.4883 12.8925 10.5974 13.4378L10.7432 14.1666H11.9999C12.2761 14.1666 12.4999 14.3905 12.4999 14.6666C12.4999 14.9428 12.2761 15.1666 11.9999 15.1666H3.99992C3.72378 15.1666 3.49992 14.9428 3.49992 14.6666C3.49992 14.3905 3.72378 14.1666 3.99992 14.1666H5.25669L5.40245 13.4378C5.51151 12.8925 5.99033 12.5 6.54646 12.5H7.49992V11.1458C6.67461 11.0751 5.97645 10.8276 5.39337 10.4365C4.71402 9.98087 4.22004 9.35011 3.86044 8.64263L2.09966 7.6644C1.86549 7.53432 1.65867 7.41943 1.4953 7.30605C1.31824 7.18317 1.15903 7.04043 1.04047 6.83894C0.921914 6.63745 0.874451 6.42896 0.853019 6.21451C0.833242 6.01663 0.833249 5.78004 0.833257 5.51216L0.833254 5.41534C0.833226 5.0899 0.833201 4.80465 0.860055 4.56939C0.889085 4.31506 0.953756 4.06929 1.11636 3.84368C1.27897 3.61807 1.49167 3.47899 1.72376 3.37102C1.93846 3.27114 2.20907 3.18096 2.51782 3.07806L2.84586 2.96872C2.86674 2.55135 2.9573 2.17774 3.238 1.83203C3.67569 1.29297 4.23547 1.19927 4.90895 1.08653L4.99885 1.07144ZM6.27649 14.1666H9.72335L9.61682 13.634C9.60124 13.5561 9.53283 13.5 9.45339 13.5H6.54646C6.46701 13.5 6.39861 13.5561 6.38303 13.634L6.27649 14.1666ZM2.86799 4.01543L2.85891 4.01846C2.51797 4.1321 2.30233 4.20478 2.14556 4.27771C2.00045 4.34522 1.95376 4.39209 1.92761 4.42838C1.90146 4.46467 1.87175 4.52378 1.8536 4.68279C1.834 4.85458 1.83325 5.08214 1.83326 5.44152L1.83326 5.48987C1.83326 5.78666 1.83384 5.97281 1.84806 6.11507C1.86117 6.24621 1.88277 6.29855 1.90234 6.33181C1.92191 6.36506 1.95717 6.40936 2.06545 6.48451C2.1829 6.56602 2.34534 6.65693 2.60478 6.80106L3.31524 7.19577C3.03018 6.14915 2.9157 5.02897 2.86799 4.01543ZM12.6848 7.19562C12.9699 6.14907 13.0843 5.02897 13.1321 4.01551L13.1409 4.01846C13.4818 4.1321 13.6975 4.20478 13.8542 4.27771C13.9994 4.34522 14.046 4.39209 14.0722 4.42838C14.0984 4.46467 14.1281 4.52378 14.1462 4.68279C14.1658 4.85458 14.1666 5.08214 14.1666 5.44152L14.1666 5.48987C14.1665 5.78666 14.166 5.97281 14.1517 6.11507C14.1386 6.24621 14.117 6.29855 14.0975 6.33181C14.0779 6.36506 14.0426 6.40936 13.9344 6.48451C13.8169 6.56602 13.6545 6.65693 13.395 6.80106L12.6848 7.19562ZM8.00002 1.83331C6.84044 1.83331 5.88871 1.93544 5.16522 2.05751C4.36061 2.19326 4.19159 2.24405 4.01433 2.46237C3.83963 2.67753 3.82304 2.88102 3.85891 3.78446C3.91869 5.29022 4.11732 6.91513 4.73248 8.15093C5.03613 8.76094 5.43314 9.25909 5.95038 9.606C6.46429 9.95068 7.12731 10.1666 8.00002 10.1666C8.87273 10.1666 9.53575 9.95068 10.0497 9.606C10.5669 9.25909 10.9639 8.76094 11.2676 8.15093C11.8827 6.91513 12.0814 5.29022 12.1411 3.78446C12.177 2.88102 12.1604 2.67753 11.9857 2.46237C11.8085 2.24405 11.6394 2.19326 10.8348 2.05751C10.1113 1.93544 9.1596 1.83331 8.00002 1.83331Z",
            fill: t || "#9035FF"
          }
        )
      ] }),
      /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_6173_885", children: /* @__PURE__ */ h("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
);
class o9 {
  constructor(e = {}, r = {}, n = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }, A = {
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = n, this.brandTheme = A;
  }
  getContainerStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.themeConfig) == null ? void 0 : n.backgroundColor),
      color: ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.color) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      fontFamily: ((a = (s = this.styleConfig) == null ? void 0 : s.Form) == null ? void 0 : a.fontFamily) || ((c = this.brandTheme) == null ? void 0 : c.borderRadius) || ((l = this.themeConfig) == null ? void 0 : l.fontFamily),
      borderRadius: ((f = (u = this.styleConfig) == null ? void 0 : u.Form) == null ? void 0 : f.borderRadius) || ((d = this.questThemeData) == null ? void 0 : d.borderRadius) || ((g = this.brandTheme) == null ? void 0 : g.borderRadius),
      ...(m = this.styleConfig) == null ? void 0 : m.Form
    };
  }
  // Main heading styles
  getMainHeadingStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.MainHeading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.titleColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.MainHeading
    };
  }
  // Section heading styles
  getHeadingStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Heading
    };
  }
  // Description styles
  getDescriptionStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  // Top rank styles
  getTopRankStyles() {
    var e, r, n, A, i, o, s, a, c;
    return {
      name: {
        color: ((r = (e = this.styleConfig) == null ? void 0 : e.MainHeading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor)
      },
      points: {
        ...(A = this.styleConfig) == null ? void 0 : A.PointsBackground,
        color: ((o = (i = this.styleConfig) == null ? void 0 : i.PointsColor) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.tertiaryColor)
      },
      indexNumber: {
        ...(a = this.styleConfig) == null ? void 0 : a.IndexColor,
        ...(c = this.styleConfig) == null ? void 0 : c.IndexBackground
      }
    };
  }
  // Leaderboard card styles
  getLeaderboardCardStyles(e) {
    var r, n, A, i, o, s, a, c, l, u, f;
    return {
      container: {
        ...e ? (r = this.styleConfig) == null ? void 0 : r.PresentUser : {}
      },
      index: {
        ...(n = this.styleConfig) == null ? void 0 : n.IndexColor,
        ...(A = this.styleConfig) == null ? void 0 : A.IndexBackground
      },
      name: {
        color: ((o = (i = this.styleConfig) == null ? void 0 : i.Heading) == null ? void 0 : o.color) || ((s = this.brandTheme) == null ? void 0 : s.primaryColor) || ((a = this.themeConfig) == null ? void 0 : a.primaryColor)
      },
      points: {
        ...(c = this.styleConfig) == null ? void 0 : c.PointsColor
      },
      progressBar: {
        ...(l = this.styleConfig) == null ? void 0 : l.ProgressBarColor
      },
      icon: {
        color: ((f = (u = this.styleConfig) == null ? void 0 : u.IconStyle) == null ? void 0 : f.color) || "#9035FF"
      }
    };
  }
  // Inner section background
  getInnerSectionStyles() {
    var e;
    return {
      ...(e = this.styleConfig) == null ? void 0 : e.InnerBackground
    };
  }
  // Footer styles
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C;
    return {
      container: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.background) || ((a = this.themeConfig) == null ? void 0 : a.backgroundColor),
        ...(l = (c = this.styleConfig) == null ? void 0 : c.Footer) == null ? void 0 : l.FooterStyle
      },
      text: ((f = (u = this.styleConfig) == null ? void 0 : u.Footer) == null ? void 0 : f.FooterTextStyle) || {},
      icon: ((g = (d = this.styleConfig) == null ? void 0 : d.Footer) == null ? void 0 : g.FooterIcon) || {},
      content: {
        text: (p = (m = this.styleConfig) == null ? void 0 : m.Footer) == null ? void 0 : p.FooterText,
        link: (C = (v = this.styleConfig) == null ? void 0 : v.Footer) == null ? void 0 : C.FooterLink
      }
    };
  }
  // Update methods
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    this.styleConfig = { ...this.styleConfig, ...e };
  }
  updateQuestTheme(e) {
    this.questThemeData = { ...this.questThemeData, ...e };
  }
  updateBrandTheme(e) {
    this.brandTheme = { ...this.brandTheme, ...e };
  }
}
const ske = (t) => {
  if (t < 1)
    return {
      currentLevel: 1,
      previousLevelthreshold: 0,
      currentLevelthreshold: 0
    };
  const e = Math.max(1, Math.ceil(Math.log2(t / 250) + 1)), r = (e - 1) * 250;
  return {
    currentLevel: e,
    previousLevelthreshold: r,
    currentLevelthreshold: 0
  };
}, ake = (t, e) => {
  let r = -1;
  const n = t == null ? void 0 : t.find((s, a) => s != null && s.xpThreshold && (e != null && e.runningXP) && s.xpThreshold >= e.runningXP ? (r = a, !0) : !1);
  let A = 0, i = 0, o = 0;
  return (n || r === -1 && t.length > 0) && (n ? (A = n.membershipTier, r > 0 && (i = t[r - 1].xpThreshold), o = t[r].xpThreshold) : (A = t[0].membershipTier, o = t[0].xpThreshold)), {
    currentLevel: A,
    previousLevelthreshold: i,
    currentLevelthreshold: o
  };
}, cke = ({
  index: t,
  item: e,
  memberShip: r,
  styleConfig: n,
  isXpImage: A,
  presentUserRank: i,
  DefaultImage: o,
  brandTheme: s
}) => {
  const [a, c] = N(e), { themeConfig: l } = Xe(ct.Context), u = new o9(
    l,
    n,
    void 0,
    s
  );
  le(() => {
    if (a != null && a.imageUrl && !a.imageUrl.includes("http")) {
      const g = {
        ...a,
        imageUrl: `${Ve.BASE_IPFS_URL}${a.imageUrl}`
      };
      c(g);
    }
  }, [a]);
  let f = 0;
  if (r.length > 0) {
    const { previousLevelthreshold: g, currentLevelthreshold: m } = ake(r, e);
    f = (e.runningXP - g) / m * 100;
  } else {
    const { previousLevelthreshold: g } = ske(e.runningXP);
    f = (e.runningXP - g) / (g === 0 ? 250 : g) * 100;
  }
  const d = u.getLeaderboardCardStyles(i == t + 4);
  return /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: `q_leaderboardcard_main_cont ${i === t + 4 ? "q_present_user_cont" : ""}`,
        style: d.container,
        children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_count_base",
              style: d.index,
              children: t + 4
            }
          ),
          /* @__PURE__ */ h(
            "img",
            {
              className: "q_profile_cont",
              src: e.imageUrl ? e.imageUrl : o || Jn,
              alt: "logo"
            }
          ),
          /* @__PURE__ */ k("div", { className: "q_name_cont", children: [
            /* @__PURE__ */ k("div", { className: "q_name_small_cont", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q_leaderboardcard_name_head",
                  style: d.name,
                  children: e.name ?? "Quest User"
                }
              ),
              oke(d.icon.color)
            ] }),
            /* @__PURE__ */ h("div", { className: "q_leaderboardcard_progressbar", children: /* @__PURE__ */ h(
              "div",
              {
                className: "LeaderBoardCardProgressBarinner",
                style: {
                  width: `${f}%`,
                  ...d.progressBar
                }
              }
            ) }),
            /* @__PURE__ */ k(
              "div",
              {
                className: "q_leaderboardcard_points",
                style: d.points,
                children: [
                  e.runningXP || 0,
                  " ",
                  A ? "XP" : "points"
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ h("div", { className: "q_leaderboardcard_divider" })
  ] });
}, lke = ({
  first: t,
  second: e,
  third: r,
  rest: n,
  memberShip: A,
  styleConfig: i,
  FirstRankIconImage: o,
  SecondRankIconImage: s,
  ThirdRankIconImage: a,
  IsTopRank: c,
  isXpImage: l,
  rewardHead: u,
  presentUserRank: f,
  DefaultImage: d,
  brandTheme: g
}) => {
  const { themeConfig: m } = Xe(ct.Context), p = new o9(
    m,
    i,
    void 0,
    g
  ), v = (w) => w && !w.includes("http") ? `${Ve.BASE_IPFS_URL}${w}` : w, C = (w, B, y, b) => {
    if (!w) return null;
    const q = p.getTopRankStyles();
    return /* @__PURE__ */ h(
      "div",
      {
        className: `q_topleaderboard_${B === 1 ? "first" : B === 2 ? "second" : "third"}`,
        children: /* @__PURE__ */ k("div", { className: "q_topleaderboard_innercard", children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: "q_top_leaderboard_inner_image_cont",
              style: {
                transform: c ? "translate(-50%, -60%)" : "translate(-50%, -50%)"
              },
              children: [
                c && /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q_count_base_top",
                    style: q.indexNumber,
                    children: B
                  }
                ),
                /* @__PURE__ */ h(
                  "img",
                  {
                    className: `q_topleaderboard_inner_image${B === 1 ? "_first" : ""}`,
                    src: w.imageUrl ? v(w.imageUrl) : d || Jn,
                    alt: "logo"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ h("div", { className: "q_topleaderboard_name", style: q.name, children: w.name || "Quest User" }),
          /* @__PURE__ */ k("div", { className: "q_topleaderboard_point_cont", children: [
            u && /* @__PURE__ */ h("p", { children: u }),
            /* @__PURE__ */ k(
              "div",
              {
                className: "q_topleaderboard_point",
                style: q.points,
                children: [
                  w.runningXP,
                  " ",
                  l ? /* @__PURE__ */ h("img", { src: Gc, alt: "xp" }) : "points"
                ]
              }
            )
          ] }),
          /* @__PURE__ */ h("img", { src: y || b, alt: `rank-${B}` })
        ] })
      }
    );
  };
  return /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ h("div", { className: "q_topleaderboard_main_cont", children: /* @__PURE__ */ k("div", { className: "q_topleaderboard_container", children: [
      C(e, 2, s, wte),
      C(t, 1, o, bte),
      C(r, 3, a, Bte)
    ] }) }),
    /* @__PURE__ */ k(
      "div",
      {
        style: p.getInnerSectionStyles(),
        className: "q_position_cont",
        children: [
          /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_position_heading",
                style: p.getHeadingStyles(),
                children: "Leaderboard"
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q_description",
                style: p.getDescriptionStyles(),
                children: "Your leaderboard gives you instant reference"
              }
            )
          ] }),
          /* @__PURE__ */ h("div", { className: "q_position_leaderboardcard_cont", children: n.length > 0 && n.map((w, B) => /* @__PURE__ */ h(
            cke,
            {
              index: B,
              memberShip: A,
              item: w,
              styleConfig: i,
              isXpImage: l,
              presentUserRank: f,
              DefaultImage: d,
              brandTheme: g
            },
            B
          )) })
        ]
      }
    )
  ] });
}, Aj = ({
  leaderboardUserData: t,
  memberShip: e,
  styleConfig: r,
  FirstRankIconImage: n,
  SecondRankIconImage: A,
  ThirdRankIconImage: i,
  IsTopRank: o,
  isXpImage: s,
  rewardHead: a,
  presentUserRank: c,
  DefaultImage: l,
  brandTheme: u,
  questThemeData: f
}) => {
  const [d, g] = N(null), [m, p] = N(null), [v, C] = N(null), [w, B] = N([]), { themeConfig: y } = Xe(ct.Context), b = new o9(
    y,
    r,
    f,
    u
  );
  le(() => {
    t && t.data && t.data.length > 0 ? (g(t.data[0]), t.data.length > 1 && p(t.data[1]), t.data.length > 2 && (C(t.data[2]), B(t.data.slice(3)))) : (g(null), p(null), C(null), B([]));
  }, [t]);
  const q = () => /* @__PURE__ */ h(
    "div",
    {
      style: {
        color: "white",
        textAlign: "center",
        height: "140vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      children: "It seems your leaderboard is empty at the moment."
    }
  );
  return /* @__PURE__ */ k(
    "div",
    {
      className: "q_leaderboard_main_cont",
      style: b.getContainerStyles(),
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "q_leaderboard_main_heading",
            style: b.getMainHeadingStyles(),
            children: "Leaderboard"
          }
        ),
        /* @__PURE__ */ h("div", { className: "q_position_main_container", children: d ? /* @__PURE__ */ h(
          lke,
          {
            first: d,
            second: m,
            third: v,
            rest: w,
            memberShip: e,
            styleConfig: r,
            FirstRankIconImage: n,
            SecondRankIconImage: A,
            ThirdRankIconImage: i,
            IsTopRank: o,
            isXpImage: s,
            rewardHead: a,
            presentUserRank: c,
            DefaultImage: l,
            brandTheme: u
          }
        ) : q() }),
        /* @__PURE__ */ h("div", { className: "q_footer_leaderboard", children: /* @__PURE__ */ h(
          Pr,
          {
            style: b.getFooterStyles().container,
            textStyle: b.getFooterStyles().text,
            iconStyle: b.getFooterStyles().icon,
            text: b.getFooterStyles().content.text,
            link: b.getFooterStyles().content.link
          }
        ) })
      ]
    }
  );
};
class uke {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth(e) {
    try {
      const r = this.cookies.get("externalUserId"), n = this.cookies.get("questUserId"), A = this.cookies.get("questUserToken");
      if (r && n && A && (r === e.uniqueUserId || r === e.uniqueEmailId))
        return {
          userId: n,
          token: A
        };
      if (e.uniqueUserId || e.uniqueEmailId) {
        const i = {
          apiKey: e.apiKey
        }, o = {
          externalUserId: e.uniqueUserId,
          entityId: e.entityId,
          email: e.uniqueEmailId,
          name: e.userName,
          imageUrl: e.userImageUrl
        }, s = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          o,
          { headers: i }
        ), { userId: a, token: c } = s.data, l = /* @__PURE__ */ new Date();
        return l.setHours(l.getHours() + 12), this.cookies.set(
          "externalUserId",
          e.uniqueUserId || e.uniqueEmailId,
          { path: "/", expires: l }
        ), this.cookies.set("questUserId", a, { path: "/", expires: l }), this.cookies.set("questUserToken", c, { path: "/", expires: l }), { userId: a, token: c };
      }
      return e.userId && e.token ? { userId: e.userId, token: e.token } : null;
    } catch (r) {
      return this.GeneralFunctions.captureSentryException(r), null;
    }
  }
  async getXp(e, r, n) {
    var A;
    try {
      const i = `${this.BACKEND_URL}api/entities/${n}/users/${e}/xp`, o = await Oe.get(i, {
        headers: this.getAxiosHeaders(r)
      });
      return ((A = o == null ? void 0 : o.data) == null ? void 0 : A.data) || null;
    } catch (i) {
      return this.GeneralFunctions.captureSentryException(i), null;
    }
  }
  async getUserDetails(e, r) {
    var n, A, i, o;
    try {
      const s = `${this.BACKEND_URL}api/users/${e}`, a = await Oe.get(s, {
        headers: this.getAxiosHeaders(r)
      });
      return {
        userName: (A = (n = a == null ? void 0 : a.data) == null ? void 0 : n.data) == null ? void 0 : A.name,
        userImage: (o = (i = a == null ? void 0 : a.data) == null ? void 0 : i.data) == null ? void 0 : o.imageUrl
      };
    } catch (s) {
      return this.GeneralFunctions.captureSentryException(s), null;
    }
  }
  async getLeaderboard(e, r, n) {
    try {
      return (await Oe.get(
        `${this.BACKEND_URL}api/entities/${e}/xp-leaderboard?streak=default_metric&limit=${n}`,
        {
          headers: this.getAxiosHeaders(r)
        }
      )).data;
    } catch (A) {
      return this.GeneralFunctions.captureSentryException(A), null;
    }
  }
  async getLeaderBoardCampaignResults(e, r, n, A) {
    var i, o, s, a, c, l, u, f, d, g;
    try {
      const m = new URLSearchParams();
      m.set("platform", "REACT"), A && m.set("variation", A);
      const p = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${m.toString()}`, v = await Oe.get(p, {
        headers: this.getAxiosHeaders(n)
      });
      return (o = (i = v.data) == null ? void 0 : i.data) != null && o.sdkConfig ? {
        questThemeData: (l = (c = (a = (s = v == null ? void 0 : v.data) == null ? void 0 : s.data) == null ? void 0 : a.sdkConfig) == null ? void 0 : c.uiProps) == null ? void 0 : l.questThemeData,
        brandTheme: (g = (d = (f = (u = v == null ? void 0 : v.data) == null ? void 0 : u.data) == null ? void 0 : f.sdkConfig) == null ? void 0 : d.uiProps) == null ? void 0 : g.BrandTheme
      } : {
        questThemeData: void 0,
        brandTheme: void 0
      };
    } catch (m) {
      return this.GeneralFunctions.captureSentryException(m), {
        questThemeData: void 0,
        brandTheme: void 0
      };
    }
  }
}
const GFe = ({
  userId: t,
  token: e,
  styleConfig: r,
  uniqueEmailId: n,
  uniqueUserId: A,
  userLimit: i,
  userName: o,
  userImageUrl: s,
  FirstRankIconImage: a,
  SecondRankIconImage: c,
  ThirdRankIconImage: l,
  DefaultName: u = "Anonymous",
  DefaultImage: f,
  IsTopRank: d,
  isXpImage: g,
  rewardHead: m,
  setPresentUserData: p,
  presentUserRank: v,
  setPresentUserRank: C,
  campaignId: w,
  variation: B,
  isLoader: y,
  loaderComponent: b
}) => {
  const [q, E] = N(null), [x, M] = N(t || ""), [O, I] = N(e || ""), { apiKey: S, apiSecret: P, entityId: H, apiType: F, themeConfig: T } = Xe(ct.Context), [U, D] = N(Hs), [Q, Y] = N(Ms), j = new uke(F), Z = new Bt("mixpanel", F), W = new o9(
    T,
    r,
    Q,
    U
  );
  return le(() => {
    (async () => {
      var K;
      Z.fireTrackingEvent("quest_leaderboard_loaded", "leaderboard");
      try {
        const L = await j.getUserAuth({
          apiKey: S,
          entityId: H,
          uniqueUserId: A,
          uniqueEmailId: n,
          userId: x,
          token: O,
          userName: o,
          userImageUrl: s
        });
        if (!L) return;
        const { userId: G, token: V } = L;
        M(G), I(V);
        const _ = {
          apiKey: S,
          apiSecret: P,
          userId: G,
          token: V
        }, J = await j.getLeaderboard(H, _, i);
        if (!J) return;
        if (w) {
          const $ = await j.getLeaderBoardCampaignResults(
            H,
            w,
            _,
            B
          );
          if ((K = $ == null ? void 0 : $.brandTheme) != null && K.properties) {
            const te = $.brandTheme.properties;
            D(te), W.updateBrandTheme(te);
          }
          $ != null && $.questThemeData && (Y($.questThemeData), W.updateQuestTheme($.questThemeData));
        }
        let X = J.data, ne = null, ee = null;
        if (J.data = X.map(($, te) => ($.name = $.name || u, $.userId === G && (ee = te + 1, ne = $), $)), E(J), p)
          if (ne)
            p(ne);
          else {
            const [$, te] = await Promise.all([
              j.getXp(G, _, H),
              j.getUserDetails(G, _)
            ]);
            te && p({
              userId: G,
              name: te.userName || u,
              imageUrl: te.userImage || "",
              runningXP: $ || 0
            });
          }
        C && C(ee);
      } catch (L) {
        console.error("Error initializing leaderboard:", L), Z.captureSentryException(L);
      }
    })();
  }, []), q ? /* @__PURE__ */ h("div", { style: W.getContainerStyles(), children: q && /* @__PURE__ */ h(
    Aj,
    {
      leaderboardUserData: q,
      memberShip: q.membershipsTiers,
      styleConfig: r,
      FirstRankIconImage: a,
      SecondRankIconImage: c,
      ThirdRankIconImage: l,
      IsTopRank: d,
      isXpImage: g,
      rewardHead: m,
      presentUserRank: v,
      DefaultImage: f,
      brandTheme: U,
      questThemeData: Q
    }
  ) }) : y ? b || /* @__PURE__ */ h("div", { children: "Loading..." }) : null;
}, RFe = ({
  styleConfig: t,
  offlineFormData: e = [],
  BrandTheme: r,
  QuestThemeData: n,
  FirstRankIconImage: A,
  SecondRankIconImage: i,
  ThirdRankIconImage: o,
  IsTopRank: s,
  isXpImage: a,
  rewardHead: c,
  presentUserRank: l
}) => {
  const [u, f] = N({
    data: e
  }), { apiType: d } = Xe(ct.Context);
  let g = new Bt("mixpanel", d);
  return le(() => {
    g.fireTrackingEvent(
      "quest_leaderboard_offline_loaded",
      "leaderboard_offline"
    ), f({
      data: e
    });
  }, [e]), /* @__PURE__ */ h("div", { children: u && /* @__PURE__ */ h(
    Aj,
    {
      leaderboardUserData: u,
      memberShip: [],
      styleConfig: t,
      brandTheme: r,
      questThemeData: n,
      FirstRankIconImage: A,
      SecondRankIconImage: i,
      ThirdRankIconImage: o,
      IsTopRank: s,
      isXpImage: a,
      rewardHead: c,
      presentUserRank: l
    }
  ) });
}, s9 = (t = "") => `data:image/svg+xml,${encodeURIComponent(t)}`, dke = (t = "#EB4E2C") => s9(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.3333 10C18.3333 14.6024 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10C1.66667 5.39765 5.39763 1.66669 10 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10ZM10 14.7917C10.3452 14.7917 10.625 14.5119 10.625 14.1667V9.16669C10.625 8.82151 10.3452 8.54169 10 8.54169C9.65482 8.54169 9.375 8.82151 9.375 9.16669V14.1667C9.375 14.5119 9.65482 14.7917 10 14.7917ZM10 5.83335C10.4602 5.83335 10.8333 6.20645 10.8333 6.66669C10.8333 7.12692 10.4602 7.50002 10 7.50002C9.53976 7.50002 9.16667 7.12692 9.16667 6.66669C9.16667 6.20645 9.53976 5.83335 10 5.83335Z" fill='${t}'/>
</svg>`), fke = (t = "#0065FF") => s9(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.3333 10C18.3333 14.6024 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10C1.66667 5.39765 5.39763 1.66669 10 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10ZM10 14.7917C10.3452 14.7917 10.625 14.5119 10.625 14.1667V9.16669C10.625 8.82151 10.3452 8.54169 10 8.54169C9.65482 8.54169 9.375 8.82151 9.375 9.16669V14.1667C9.375 14.5119 9.65482 14.7917 10 14.7917ZM10 5.83335C10.4602 5.83335 10.8333 6.20645 10.8333 6.66669C10.8333 7.12692 10.4602 7.50002 10 7.50002C9.53976 7.50002 9.16667 7.12692 9.16667 6.66669C9.16667 6.20645 9.53976 5.83335 10 5.83335Z" fill='${t}'/>
</svg>
`), hke = (t = "#008000") => s9(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
   <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3333 10C18.3333 14.6024 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10C1.66667 5.39765 5.39763 1.66669 10 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10ZM13.3586 7.47475C13.6027 7.71882 13.6027 8.11455 13.3586 8.35863L9.19194 12.5253C8.94786 12.7694 8.55214 12.7694 8.30806 12.5253L6.64139 10.8586C6.39731 10.6146 6.39731 10.2188 6.64139 9.97474C6.88547 9.73067 7.2812 9.73067 7.52528 9.97474L8.75 11.1995L10.6124 9.33711L12.4747 7.47475C12.7188 7.23067 13.1145 7.23067 13.3586 7.47475Z" fill="${t}"/>
 </svg>
`), pke = (t = "#EF9400") => s9(`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
   <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3333 10C18.3333 14.6024 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10C1.66667 5.39765 5.39763 1.66669 10 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10ZM10 6.45835C9.48223 6.45835 9.0625 6.87809 9.0625 7.39585C9.0625 7.74103 8.78268 8.02085 8.4375 8.02085C8.09232 8.02085 7.8125 7.74103 7.8125 7.39585C7.8125 6.18773 8.79188 5.20835 10 5.20835C11.2081 5.20835 12.1875 6.18773 12.1875 7.39585C12.1875 7.98822 11.9512 8.52667 11.5691 8.91999C11.4922 8.99914 11.4189 9.07241 11.3489 9.14232C11.1691 9.32203 11.0115 9.47947 10.8733 9.6571C10.6907 9.89162 10.625 10.064 10.625 10.2084V10.8334C10.625 11.1785 10.3452 11.4584 10 11.4584C9.65482 11.4584 9.375 11.1785 9.375 10.8334V10.2084C9.375 9.66236 9.62917 9.22039 9.88681 8.88936C10.0774 8.64443 10.317 8.4053 10.5115 8.21124C10.5701 8.1527 10.6247 8.09826 10.6725 8.049C10.8372 7.87955 10.9375 7.65006 10.9375 7.39585C10.9375 6.87809 10.5178 6.45835 10 6.45835ZM10 14.1667C10.4602 14.1667 10.8333 13.7936 10.8333 13.3334C10.8333 12.8731 10.4602 12.5 10 12.5C9.53976 12.5 9.16667 12.8731 9.16667 13.3334C9.16667 13.7936 9.53976 14.1667 10 14.1667Z" fill='${t}'/>
 </svg>
`), P0 = {
  autoClose: 5e3,
  position: "top-right",
  onClose: () => {
  },
  canClose: !0,
  // showProgress: true,
  defaultImages: {
    success: hke(),
    warning: pke(),
    error: dke(),
    info: fke()
  },
  template: 1
};
var Jt, Oc, fu, hu, Fc, ma, Tc, pu, gu, mu, vu, Zp, Jp, u1;
const eu = class eu {
  constructor(e) {
    NA(this, Jt);
    NA(this, Oc);
    NA(this, fu);
    NA(this, hu);
    NA(this, Fc, 0);
    NA(this, ma);
    NA(this, Tc, !1);
    NA(this, pu);
    NA(this, gu);
    NA(this, mu);
    NA(this, vu);
    ke(this, "onClose");
    NA(this, Zp);
    NA(this, Jp);
    NA(this, u1);
    if (On(this, Jt, document.createElement("div")), xt(this, Jt).classList.add("qt_toast"), (e == null ? void 0 : e.template) === 2) {
      let r = document.createElement("div");
      r.className = "qt_toast-text", r.style.width = "320px", r.style.overflow = "hidden", xt(this, Jt).append(r), xt(this, Jt).style.gap = "12px", xt(this, Jt).style.fontSize = "12px", xt(this, Jt).style.fontWeight = "600", xt(this, Jt).style.lineHeight = "16px", xt(this, Jt).style.fontStyle = "normal", xt(this, Jt).style.color = "#2C2C2C", xt(this, Jt).style.padding = "12px";
    }
    if (requestAnimationFrame(() => {
      xt(this, Jt).classList.add("qt_show");
    }), On(this, hu, this.remove.bind(this)), On(this, pu, () => On(this, Tc, !1)), On(this, gu, () => On(this, Tc, !0)), On(this, mu, () => {
      On(this, vu, document.visibilityState === "visible");
    }), this.update({ ...P0, ...e }), this.image = e.image, !(e != null && e.template) || (e == null ? void 0 : e.template) === 1) {
      const r = document.createElement("style");
      r.textContent = `
        .qt_toast::after {
          content: "\\00D7";
          position: absolute;
          right: 12px;
          font-size: 16px;
          margin-bottom: 2px;
          font-weight: 600;
          margin-left: 15px;
        }
      `, document.head.appendChild(r);
    }
  }
  static success(e) {
    return new eu({ ...e, className: "success" });
  }
  static error(e) {
    return new eu({ ...e, className: "error" });
  }
  static info(e) {
    return new eu({ ...e, className: "info" });
  }
  static warning(e) {
    return new eu({ ...e, className: "warning" });
  }
  set autoClose(e) {
    if (On(this, ma, e), On(this, Fc, 0), e === !1) return;
    let r = null;
    const n = (A) => {
      if (xt(this, vu) && (r = null, On(this, vu, !1)), r == null) {
        r = A, On(this, Oc, requestAnimationFrame(n));
        return;
      }
      if (!xt(this, Tc) && (On(this, Fc, xt(this, Fc) + (A - r)), typeof xt(this, ma) == "number" && xt(this, Fc) >= xt(this, ma))) {
        this.remove();
        return;
      }
      r = A, On(this, Oc, requestAnimationFrame(n));
    };
    On(this, Oc, requestAnimationFrame(n));
  }
  set position(e) {
    const r = xt(this, Jt).parentElement, n = `.qt_toast-container[data-position="${e}"]`;
    (document.querySelector(n) || this.createContainer(e)).append(xt(this, Jt)), !(r == null || r.hasChildNodes()) && r.remove();
  }
  set image(e) {
    if (e == null) {
      const r = document.createElement("img"), n = xt(this, Jt).className.replace(
        "qt_toast ",
        ""
      );
      r.src = P0.defaultImages[n] || P0.defaultImages.info, xt(this, Jt).insertBefore(r, xt(this, Jt).firstChild);
    } else {
      const r = xt(this, Jt).querySelector("img");
      r && r.remove();
      const n = document.createElement("img");
      n.src = e, n.style.borderRadius = "50%", xt(this, Jt).insertBefore(n, xt(this, Jt).firstChild);
    }
  }
  set text(e) {
    let r = xt(this, Jt).querySelector(".qt_toast-text");
    if (r) {
      let n = document.createElement("p");
      n.innerText = e, r == null || r.appendChild(n);
    } else
      xt(this, Jt).textContent = e;
  }
  set description(e) {
    let r = xt(this, Jt).querySelector(".qt_toast-text");
    if (r) {
      let n = document.createElement("p");
      n.innerText = e, n.style.color = "#939393", n.style.width = "100%", n.style.fontSize = "10px", n.style.letterSpacing = "-0.1px", n.style.fontWeight = "400", n.style.lineHeight = "12px", n.style.fontStyle = "normal", n.style.lineHeight = "12px", n.style.overflowWrap = "break-word", r == null || r.appendChild(n);
    }
  }
  set canClose(e) {
    xt(this, Jt).classList.toggle("can-close", e), e ? xt(this, Jt).addEventListener("click", xt(this, hu)) : xt(this, Jt).removeEventListener("click", xt(this, hu));
  }
  set showProgress(e) {
    if (xt(this, Jt).classList.toggle("progress", e), xt(this, Jt).style.setProperty("--progress", "1"), e && typeof xt(this, ma) == "number") {
      const r = () => {
        xt(this, Tc) || (xt(this, Jt).style.setProperty(
          "--progress",
          (1 - xt(this, Fc) / xt(this, ma)).toString()
        ), xt(this, u1) && xt(this, Jt).style.setProperty(
          "--progress-color",
          xt(this, u1)
        )), On(this, fu, requestAnimationFrame(r));
      };
      On(this, fu, requestAnimationFrame(r));
    }
  }
  set pauseOnHover(e) {
    e ? (xt(this, Jt).addEventListener("mouseover", xt(this, gu)), xt(this, Jt).addEventListener("mouseleave", xt(this, pu))) : (xt(this, Jt).removeEventListener("mouseover", xt(this, gu)), xt(this, Jt).removeEventListener("mouseleave", xt(this, pu)));
  }
  set pauseOnFocusLoss(e) {
    e ? document.addEventListener("visibilitychange", xt(this, mu)) : document.removeEventListener("visibilitychange", xt(this, mu));
  }
  update(e) {
    var r, n;
    if (Object.entries(e).forEach(([A, i]) => {
      A !== "className" && (this[A] = i);
    }), e.image && e.className) {
      const A = ((r = P0.defaultImages) == null ? void 0 : r[e.className]) || ((n = P0.defaultImages) == null ? void 0 : n.info);
      this.image = A || null;
    }
    e.className ? xt(this, Jt).className = `qt_toast ${e.className}` : xt(this, Jt).className = "qt_toast";
  }
  set background(e) {
    On(this, Zp, e), xt(this, Jt).style.background = e;
  }
  set borderColor(e) {
    On(this, Jp, e), xt(this, Jt).style.borderColor = e;
  }
  remove() {
    cancelAnimationFrame(xt(this, Oc)), cancelAnimationFrame(xt(this, fu));
    const e = xt(this, Jt).parentElement;
    xt(this, Jt).classList.remove("qt_show"), xt(this, Jt).addEventListener("transitionend", () => {
      xt(this, Jt).remove(), !e.hasChildNodes() && e.remove();
    }), this.onClose();
  }
  createContainer(e, r) {
    const n = document.createElement("div");
    return n.classList.add("qt_toast-container"), n.classList.add(r), n.dataset.position = e, document.body.append(n), n;
  }
};
Jt = new WeakMap(), Oc = new WeakMap(), fu = new WeakMap(), hu = new WeakMap(), Fc = new WeakMap(), ma = new WeakMap(), Tc = new WeakMap(), pu = new WeakMap(), gu = new WeakMap(), mu = new WeakMap(), vu = new WeakMap(), Zp = new WeakMap(), Jp = new WeakMap(), u1 = new WeakMap();
let lP = eu;
const Nn = (t) => /* @__PURE__ */ h(Ze, { children: ((r) => {
  switch (r) {
    case "home":
      return t.primaryColor == "#B9B9B9" ? /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "path",
              {
                d: "M11.25 18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V15C12.75 14.5858 12.4142 14.25 12 14.25C11.5858 14.25 11.25 14.5858 11.25 15V18Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 1.25C11.2919 1.25 10.6485 1.45282 9.95055 1.79224C9.27585 2.12035 8.49642 2.60409 7.52286 3.20832L5.45628 4.4909C4.53509 5.06261 3.79744 5.5204 3.2289 5.95581C2.64015 6.40669 2.18795 6.86589 1.86131 7.46263C1.53535 8.05812 1.38857 8.69174 1.31819 9.4407C1.24999 10.1665 1.24999 11.0541 1.25 12.1672V13.7799C1.24999 15.6837 1.24998 17.1866 1.4027 18.3616C1.55937 19.567 1.88856 20.5401 2.63236 21.3094C3.37958 22.0824 4.33046 22.4277 5.50761 22.5914C6.64849 22.75 8.10556 22.75 9.94185 22.75H14.0581C15.8944 22.75 17.3515 22.75 18.4924 22.5914C19.6695 22.4277 20.6204 22.0824 21.3676 21.3094C22.1114 20.5401 22.4406 19.567 22.5973 18.3616C22.75 17.1866 22.75 15.6838 22.75 13.7799V12.1672C22.75 11.0541 22.75 10.1665 22.6818 9.4407C22.6114 8.69174 22.4646 8.05812 22.1387 7.46263C21.8121 6.86589 21.3599 6.40669 20.7711 5.95581C20.2026 5.5204 19.4649 5.06262 18.5437 4.49091L16.4771 3.20831C15.5036 2.60409 14.7241 2.12034 14.0494 1.79224C13.3515 1.45282 12.7081 1.25 12 1.25ZM8.27953 4.50412C9.29529 3.87371 10.0095 3.43153 10.6065 3.1412C11.1882 2.85833 11.6002 2.75 12 2.75C12.3998 2.75 12.8118 2.85833 13.3935 3.14119C13.9905 3.43153 14.7047 3.87371 15.7205 4.50412L17.7205 5.74537C18.6813 6.34169 19.3559 6.76135 19.8591 7.1467C20.3487 7.52164 20.6303 7.83106 20.8229 8.18285C21.0162 8.53589 21.129 8.94865 21.1884 9.58104C21.2492 10.2286 21.25 11.0458 21.25 12.2039V13.725C21.25 15.6959 21.2485 17.1012 21.1098 18.1683C20.9736 19.2163 20.717 19.8244 20.2892 20.2669C19.8649 20.7058 19.2871 20.9664 18.2858 21.1057C17.2602 21.2483 15.9075 21.25 14 21.25H10C8.09247 21.25 6.73983 21.2483 5.71422 21.1057C4.71286 20.9664 4.13514 20.7058 3.71079 20.2669C3.28301 19.8244 3.02642 19.2163 2.89019 18.1683C2.75149 17.1012 2.75 15.6959 2.75 13.725V12.2039C2.75 11.0458 2.75076 10.2286 2.81161 9.58104C2.87103 8.94865 2.98385 8.53589 3.17709 8.18285C3.36965 7.83106 3.65133 7.52164 4.14092 7.1467C4.6441 6.76135 5.31869 6.34169 6.27953 5.74537L8.27953 4.50412Z",
                fill: "#B9B9B9"
              }
            )
          ]
        }
      ) : /* @__PURE__ */ h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M2.33537 7.87495C1.79491 9.00229 1.98463 10.3208 2.36407 12.9579L2.64284 14.8952C3.13025 18.2827 3.37396 19.9764 4.54903 20.9882C5.72409 22 7.44737 22 10.8939 22H13.1061C16.5526 22 18.2759 22 19.451 20.9882C20.626 19.9764 20.8697 18.2827 21.3572 14.8952L21.6359 12.9579C22.0154 10.3208 22.2051 9.00229 21.6646 7.87495C21.1242 6.7476 19.9738 6.06234 17.6731 4.69181L16.2882 3.86687C14.199 2.62229 13.1543 2 12 2C10.8457 2 9.80104 2.62229 7.71175 3.86687L6.32691 4.69181C4.02619 6.06234 2.87583 6.7476 2.33537 7.87495ZM12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15C11.25 14.5858 11.5858 14.25 12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V18C12.75 18.4142 12.4142 18.75 12 18.75Z",
              fill: t.primaryColor || "#9035FF"
            }
          )
        }
      );
    case "Chat":
      return t.primaryColor == "#B9B9B9" ? /* @__PURE__ */ h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.4606 1.25H13.5394C15.1427 1.24999 16.3997 1.24999 17.4039 1.34547C18.4274 1.44279 19.2655 1.64457 20.0044 2.09732C20.7781 2.57144 21.4286 3.22194 21.9027 3.99563C22.3554 4.73445 22.5572 5.57256 22.6545 6.59611C22.75 7.60029 22.75 8.85725 22.75 10.4606V11.5278C22.75 12.6691 22.75 13.564 22.7007 14.2868C22.6505 15.0223 22.5468 15.6344 22.3123 16.2004C21.7287 17.6093 20.6093 18.7287 19.2004 19.3123C18.3955 19.6457 17.4786 19.7197 16.2233 19.7413C15.7842 19.7489 15.5061 19.7545 15.2941 19.7779C15.096 19.7999 15.0192 19.832 14.9742 19.8582C14.9268 19.8857 14.8622 19.936 14.7501 20.0898C14.6287 20.2564 14.4916 20.4865 14.2742 20.8539L13.7321 21.7697C12.9585 23.0767 11.0415 23.0767 10.2679 21.7697L9.72579 20.8539C9.50835 20.4865 9.37122 20.2564 9.24985 20.0898C9.13772 19.936 9.07313 19.8857 9.02572 19.8582C8.98078 19.832 8.90399 19.7999 8.70588 19.7779C8.49387 19.7545 8.21575 19.7489 7.77666 19.7413C6.52138 19.7197 5.60454 19.6457 4.79957 19.3123C3.39066 18.7287 2.27128 17.6093 1.68769 16.2004C1.45323 15.6344 1.3495 15.0223 1.29932 14.2868C1.24999 13.564 1.25 12.6691 1.25 11.5278L1.25 10.4606C1.24999 8.85726 1.24999 7.60029 1.34547 6.59611C1.44279 5.57256 1.64457 4.73445 2.09732 3.99563C2.57144 3.22194 3.22194 2.57144 3.99563 2.09732C4.73445 1.64457 5.57256 1.44279 6.59611 1.34547C7.60029 1.24999 8.85726 1.24999 10.4606 1.25ZM6.73809 2.83873C5.82434 2.92561 5.24291 3.09223 4.77938 3.37628C4.20752 3.72672 3.72672 4.20752 3.37628 4.77938C3.09223 5.24291 2.92561 5.82434 2.83873 6.73809C2.75079 7.663 2.75 8.84876 2.75 10.5V11.5C2.75 12.6751 2.75041 13.5189 2.79584 14.1847C2.84081 14.8438 2.92737 15.2736 3.07351 15.6264C3.50486 16.6678 4.33223 17.4951 5.3736 17.9265C5.88923 18.1401 6.54706 18.2199 7.8025 18.2416L7.83432 18.2421C8.23232 18.249 8.58109 18.2549 8.87097 18.287C9.18246 18.3215 9.4871 18.3912 9.77986 18.5615C10.0702 18.7304 10.2795 18.9559 10.4621 19.2063C10.6307 19.4378 10.804 19.7306 11.0004 20.0623L11.5587 21.0057C11.7515 21.3313 12.2485 21.3313 12.4412 21.0057L12.9996 20.0623C13.1959 19.7306 13.3692 19.4378 13.5379 19.2063C13.7204 18.9559 13.9298 18.7304 14.2201 18.5615C14.5129 18.3912 14.8175 18.3215 15.129 18.287C15.4189 18.2549 15.7676 18.249 16.1656 18.2421L16.1975 18.2416C17.4529 18.2199 18.1108 18.1401 18.6264 17.9265C19.6678 17.4951 20.4951 16.6678 20.9265 15.6264C21.0726 15.2736 21.1592 14.8438 21.2042 14.1847C21.2496 13.5189 21.25 12.6751 21.25 11.5V10.5C21.25 8.84876 21.2492 7.663 21.1613 6.73809C21.0744 5.82434 20.9078 5.24291 20.6237 4.77938C20.2733 4.20752 19.7925 3.72672 19.2206 3.37628C18.7571 3.09223 18.1757 2.92561 17.2619 2.83873C16.337 2.75079 15.1512 2.75 13.5 2.75H10.5C8.84876 2.75 7.663 2.75079 6.73809 2.83873ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H16C16.4142 8.25 16.75 8.58579 16.75 9C16.75 9.41421 16.4142 9.75 16 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 12.5C7.25 12.0858 7.58579 11.75 8 11.75H13.5C13.9142 11.75 14.25 12.0858 14.25 12.5C14.25 12.9142 13.9142 13.25 13.5 13.25H8C7.58579 13.25 7.25 12.9142 7.25 12.5Z",
              fill: "#B9B9B9"
            }
          )
        }
      ) : /* @__PURE__ */ h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M13.6288 20.4718L13.0867 21.3877C12.6035 22.204 11.3965 22.204 10.9133 21.3877L10.3712 20.4718C9.95073 19.7614 9.74049 19.4063 9.40279 19.2098C9.06509 19.0134 8.63992 19.0061 7.78958 18.9915C6.53422 18.9698 5.74689 18.8929 5.08658 18.6194C3.86144 18.1119 2.88807 17.1386 2.3806 15.9134C2 14.9946 2 13.8297 2 11.5V10.5C2 7.22657 2 5.58985 2.7368 4.38751C3.14908 3.71473 3.71473 3.14908 4.38751 2.7368C5.58985 2 7.22657 2 10.5 2H13.5C16.7734 2 18.4101 2 19.6125 2.7368C20.2853 3.14908 20.8509 3.71473 21.2632 4.38751C22 5.58985 22 7.22657 22 10.5V11.5C22 13.8297 22 14.9946 21.6194 15.9134C21.1119 17.1386 20.1386 18.1119 18.9134 18.6194C18.2531 18.8929 17.4658 18.9698 16.2104 18.9915C15.36 19.0061 14.9349 19.0134 14.5972 19.2098C14.2595 19.4062 14.0492 19.7614 13.6288 20.4718ZM8 11.75C7.58579 11.75 7.25 12.0858 7.25 12.5C7.25 12.9142 7.58579 13.25 8 13.25H13.5C13.9142 13.25 14.25 12.9142 14.25 12.5C14.25 12.0858 13.9142 11.75 13.5 11.75H8ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H16C16.4142 8.25 16.75 8.58579 16.75 9C16.75 9.41421 16.4142 9.75 16 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9Z",
              fill: t.primaryColor || "#9035FF"
            }
          )
        }
      );
    case "BackButton":
      return /* @__PURE__ */ h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.9067 3.6921C13.1688 3.91674 13.1992 4.3113 12.9745 4.57338L8.32317 9.99997L12.9745 15.4266C13.1992 15.6886 13.1688 16.0832 12.9067 16.3078C12.6447 16.5325 12.2501 16.5021 12.0255 16.24L7.02546 10.4067C6.82485 10.1727 6.82485 9.82728 7.02546 9.59323L12.0255 3.75989C12.2501 3.49781 12.6447 3.46746 12.9067 3.6921Z",
              fill: "#B9B9B9"
            }
          )
        }
      );
    case "Help":
      return t.primaryColor == "#B9B9B9" ? /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "black",
          children: [
            /* @__PURE__ */ h(
              "path",
              {
                d: "M12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.83834 14.1056 10.6796 13.3353 11.1354C13.1385 11.2518 12.9761 11.3789 12.8703 11.5036C12.7675 11.6246 12.75 11.7036 12.75 11.75V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V11.75C11.25 11.2441 11.4715 10.8336 11.7266 10.533C11.9786 10.236 12.2929 10.0092 12.5715 9.84439C12.9044 9.64739 13.125 9.28655 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.9426 1.25H12.0574C14.3658 1.24999 16.1748 1.24998 17.5863 1.43975C19.031 1.63399 20.1711 2.03933 21.0659 2.93414C21.9607 3.82895 22.366 4.96897 22.5603 6.41371C22.75 7.82519 22.75 9.63423 22.75 11.9426V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574V11.9426C1.24999 9.63424 1.24998 7.82519 1.43975 6.41371C1.63399 4.96897 2.03933 3.82895 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63424 1.24999 11.9426 1.25ZM6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.42514 4.56445 3.09825 5.33517 2.92637 6.61358C2.75159 7.91356 2.75 9.62177 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12C21.25 9.62177 21.2484 7.91356 21.0736 6.61358C20.9018 5.33517 20.5749 4.56445 20.0052 3.9948C19.4355 3.42514 18.6648 3.09825 17.3864 2.92637C16.0864 2.75159 14.3782 2.75 12 2.75C9.62177 2.75 7.91356 2.75159 6.61358 2.92637Z",
                fill: "#B9B9B9"
              }
            )
          ]
        }
      ) : /* @__PURE__ */ h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.58584 14.3415 10.232 13.883 10.704C13.7907 10.7989 13.7027 10.8869 13.6187 10.9708C13.4029 11.1864 13.2138 11.3753 13.0479 11.5885C12.8289 11.8699 12.75 12.0768 12.75 12.25V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V12.25C11.25 11.5948 11.555 11.0644 11.8642 10.6672C12.0929 10.3733 12.3804 10.0863 12.6138 9.85346C12.6842 9.78321 12.7496 9.71789 12.807 9.65877C13.0046 9.45543 13.125 9.18004 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
              fill: t.primaryColor || "#9035FF"
            }
          )
        }
      );
    case "Updates":
      return t.primaryColor == "#B9B9B9" ? /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "path",
              {
                d: "M11.9426 1.25C9.63423 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63423 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V10.5C22.75 10.0858 22.4142 9.75 22 9.75C21.5858 9.75 21.25 10.0858 21.25 10.5V12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62178 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62178 2.75 12 2.75H13.5C13.9142 2.75 14.25 2.41421 14.25 2C14.25 1.58579 13.9142 1.25 13.5 1.25H11.9426Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 1.25C16.9289 1.25 15.25 2.92893 15.25 5C15.25 7.07107 16.9289 8.75 19 8.75C21.0711 8.75 22.75 7.07107 22.75 5C22.75 2.92893 21.0711 1.25 19 1.25ZM16.75 5C16.75 3.75736 17.7574 2.75 19 2.75C20.2426 2.75 21.25 3.75736 21.25 5C21.25 6.24264 20.2426 7.25 19 7.25C17.7574 7.25 16.75 6.24264 16.75 5Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                d: "M6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H16C16.4142 13.25 16.75 13.5858 16.75 14C16.75 14.4142 16.4142 14.75 16 14.75H7C6.58579 14.75 6.25 14.4142 6.25 14Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                d: "M7 16.75C6.58579 16.75 6.25 17.0858 6.25 17.5C6.25 17.9142 6.58579 18.25 7 18.25H13C13.4142 18.25 13.75 17.9142 13.75 17.5C13.75 17.0858 13.4142 16.75 13 16.75H7Z",
                fill: "#B9B9B9"
              }
            )
          ]
        }
      ) : /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "path",
              {
                d: "M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z",
                fill: t.primaryColor || "#1C274C"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H16C16.4142 13.25 16.75 13.5858 16.75 14C16.75 14.4142 16.4142 14.75 16 14.75H7C6.58579 14.75 6.25 14.4142 6.25 14Z",
                fill: t.primaryColor || "#9035FF"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.46447 20.5355C4.92893 22 7.28595 22 12 22C16.714 22 19.0711 22 20.5355 20.5355C22 19.0711 22 16.714 22 12C22 10.6012 22 9.40999 21.9617 8.38802C21.1703 9.08042 20.1342 9.5 19 9.5C16.5147 9.5 14.5 7.48528 14.5 5C14.5 3.86584 14.9196 2.82967 15.612 2.03826C14.59 2 13.3988 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 16.714 2 19.0711 3.46447 20.5355ZM6.25 17.5C6.25 17.0858 6.58579 16.75 7 16.75H13C13.4142 16.75 13.75 17.0858 13.75 17.5C13.75 17.9142 13.4142 18.25 13 18.25H7C6.58579 18.25 6.25 17.9142 6.25 17.5Z",
                fill: t.primaryColor || "#9035FF"
              }
            )
          ]
        }
      );
    case "Tasks":
      return t.primaryColor == "#B9B9B9" ? /* @__PURE__ */ h(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.26279 3.25871C7.38317 2.12953 8.33887 1.25 9.5 1.25H14.5C15.6611 1.25 16.6168 2.12953 16.7372 3.25871C17.5004 3.27425 18.1602 3.31372 18.7236 3.41721C19.4816 3.55644 20.1267 3.82168 20.6517 4.34661C21.2536 4.94853 21.5125 5.7064 21.6335 6.60651C21.75 7.47348 21.75 8.5758 21.75 9.94339V16.0531C21.75 17.4207 21.75 18.523 21.6335 19.39C21.5125 20.2901 21.2536 21.048 20.6517 21.6499C20.0497 22.2518 19.2919 22.5107 18.3918 22.6317C17.5248 22.7483 16.4225 22.7483 15.0549 22.7483H8.94513C7.57754 22.7483 6.47522 22.7483 5.60825 22.6317C4.70814 22.5107 3.95027 22.2518 3.34835 21.6499C2.74643 21.048 2.48754 20.2901 2.36652 19.39C2.24996 18.523 2.24998 17.4207 2.25 16.0531V9.94339C2.24998 8.5758 2.24996 7.47348 2.36652 6.60651C2.48754 5.7064 2.74643 4.94853 3.34835 4.34661C3.87328 3.82168 4.51835 3.55644 5.27635 3.41721C5.83977 3.31372 6.49963 3.27425 7.26279 3.25871ZM7.26476 4.75913C6.54668 4.77447 5.99332 4.81061 5.54735 4.89253C4.98054 4.99664 4.65246 5.16382 4.40901 5.40727C4.13225 5.68403 3.9518 6.07261 3.85315 6.80638C3.75159 7.56173 3.75 8.56285 3.75 9.99826V15.9983C3.75 17.4337 3.75159 18.4348 3.85315 19.1901C3.9518 19.9239 4.13225 20.3125 4.40901 20.5893C4.68577 20.866 5.07435 21.0465 5.80812 21.1451C6.56347 21.2467 7.56458 21.2483 9 21.2483H15C16.4354 21.2483 17.4365 21.2467 18.1919 21.1451C18.9257 21.0465 19.3142 20.866 19.591 20.5893C19.8678 20.3125 20.0482 19.9239 20.1469 19.1901C20.2484 18.4348 20.25 17.4337 20.25 15.9983V9.99826C20.25 8.56285 20.2484 7.56173 20.1469 6.80638C20.0482 6.07261 19.8678 5.68403 19.591 5.40727C19.3475 5.16382 19.0195 4.99664 18.4527 4.89253C18.0067 4.81061 17.4533 4.77447 16.7352 4.75913C16.6067 5.87972 15.655 6.75 14.5 6.75H9.5C8.345 6.75 7.39326 5.87972 7.26476 4.75913ZM9.5 2.75C9.08579 2.75 8.75 3.08579 8.75 3.5V4.5C8.75 4.91421 9.08579 5.25 9.5 5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5V3.5C15.25 3.08579 14.9142 2.75 14.5 2.75H9.5ZM15.5483 10.4883C15.8309 10.7911 15.8146 11.2657 15.5117 11.5483L11.226 15.5483C10.9379 15.8172 10.4907 15.8172 10.2025 15.5483L8.48826 13.9483C8.18545 13.6657 8.16908 13.1911 8.45171 12.8883C8.73433 12.5854 9.20893 12.5691 9.51174 12.8517L10.7143 13.9741L14.4883 10.4517C14.7911 10.1691 15.2657 10.1854 15.5483 10.4883Z",
              fill: "#B9B9B9"
            }
          )
        }
      ) : /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "path",
              {
                d: "M9.5 2C8.67157 2 8 2.67157 8 3.5V4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5V3.5C16 2.67157 15.3284 2 14.5 2H9.5Z",
                fill: t.primaryColor || "#9035FF"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 4.03662C5.24209 4.10719 4.44798 4.30764 3.87868 4.87694C3 5.75562 3 7.16983 3 9.99826V15.9983C3 18.8267 3 20.2409 3.87868 21.1196C4.75736 21.9983 6.17157 21.9983 9 21.9983H15C17.8284 21.9983 19.2426 21.9983 20.1213 21.1196C21 20.2409 21 18.8267 21 15.9983V9.99826C21 7.16983 21 5.75562 20.1213 4.87694C19.552 4.30764 18.7579 4.10719 17.5 4.03662V4.5C17.5 6.15685 16.1569 7.5 14.5 7.5H9.5C7.84315 7.5 6.5 6.15685 6.5 4.5V4.03662ZM15.5117 12.5483C15.8146 12.2657 15.8309 11.7911 15.5483 11.4883C15.2657 11.1855 14.7911 11.1691 14.4883 11.4517L10.7143 14.9741L9.51174 13.8517C9.20893 13.5691 8.73434 13.5855 8.45171 13.8883C8.16909 14.1911 8.18545 14.6657 8.48826 14.9483L10.2025 16.5483C10.4907 16.8172 10.9379 16.8172 11.226 16.5483L15.5117 12.5483Z",
                fill: t.primaryColor || "#9035FF"
              }
            )
          ]
        }
      );
    case "footerLogo":
      return /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "path",
              {
                d: "M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z",
                fill: "#B9B9B9"
              }
            ),
            /* @__PURE__ */ h("path", { d: "M12 8L8 8L8 12H12V8Z", fill: "#B9B9B9" })
          ]
        }
      );
  }
})(t.type) }), sm = "data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='vuesax/bold/send'%3e%3cg%20id='send'%3e%3cpath%20id='Vector'%20d='M16.5656%207.80059L8.71896%203.87726C3.44813%201.23726%201.2848%203.40059%203.9248%208.67142L4.7223%2010.2664C4.95146%2010.7339%204.95146%2011.2748%204.7223%2011.7423L3.9248%2013.3281C1.2848%2018.5989%203.43896%2020.7623%208.71896%2018.1223L16.5656%2014.1989C20.0856%2012.4389%2020.0856%209.56059%2016.5656%207.80059ZM13.6048%2011.6873H8.65479C8.27896%2011.6873%207.96729%2011.3756%207.96729%2010.9998C7.96729%2010.6239%208.27896%2010.3123%208.65479%2010.3123H13.6048C13.9806%2010.3123%2014.2923%2010.6239%2014.2923%2010.9998C14.2923%2011.3756%2013.9806%2011.6873%2013.6048%2011.6873Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", gke = "data:image/png;base64,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", mke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='41'%20height='40'%20viewBox='0%200%2041%2040'%20fill='none'%3e%3cpath%20d='M20.2%2039.1667C30.7854%2039.1667%2039.3667%2030.5855%2039.3667%2020C39.3667%209.41458%2030.7854%200.833374%2020.2%200.833374C9.61453%200.833374%201.03333%209.41458%201.03333%2020C1.03333%2030.5855%209.61453%2039.1667%2020.2%2039.1667Z'%20fill='%23FFCE52'%20/%3e%3cpath%20d='M17.7%2030.0117L16.0333%2030.0001C16.0333%2027.3684%2021.7958%2026.6667%2025.2%2026.6667V28.3334C20.3175%2028.3334%2017.8225%2029.5492%2017.7%2030.0117Z'%20fill='%23273941'%20/%3e%3cpath%20d='M32.8167%2013.2667C32.7817%2013.205%2032.7383%2013.1483%2032.7%2013.0883V14.1667C32.7%2014.6087%2032.5244%2015.0326%2032.2118%2015.3452C31.8993%2015.6577%2031.4754%2015.8333%2031.0333%2015.8333C30.5913%2015.8333%2030.1674%2015.6577%2029.8548%2015.3452C29.5423%2015.0326%2029.3667%2014.6087%2029.3667%2014.1667V12.5H24.8167C23.9883%2013.4123%2023.5306%2014.6011%2023.5333%2015.8333C23.5333%2017.1594%2024.0601%2018.4312%2024.9978%2019.3689C25.9355%2020.3065%2027.2073%2020.8333%2028.5333%2020.8333C29.8594%2020.8333%2031.1312%2020.3065%2032.0689%2019.3689C33.0066%2018.4312%2033.5333%2017.1594%2033.5333%2015.8333C33.5365%2014.9279%2033.2884%2014.0394%2032.8167%2013.2667Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M31.0333%2015.8333C31.4753%2015.8333%2031.8993%2015.6577%2032.2118%2015.3452C32.5244%2015.0326%2032.7%2014.6087%2032.7%2014.1667V13.0883C32.5673%2012.8796%2032.4167%2012.6827%2032.25%2012.5H29.3666V14.1667C29.3666%2014.6087%2029.5422%2015.0326%2029.8548%2015.3452C30.1674%2015.6577%2030.5913%2015.8333%2031.0333%2015.8333Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M16.15%2013.2667C16.115%2013.205%2016.0716%2013.1483%2016.0333%2013.0883V14.1667C16.0333%2014.6087%2015.8577%2015.0326%2015.5452%2015.3452C15.2326%2015.6577%2014.8087%2015.8333%2014.3667%2015.8333C13.9246%2015.8333%2013.5007%2015.6577%2013.1881%2015.3452C12.8756%2015.0326%2012.7%2014.6087%2012.7%2014.1667V12.5H8.14998C7.32164%2013.4123%206.86394%2014.6011%206.86665%2015.8333C6.86665%2017.1594%207.39343%2018.4312%208.33112%2019.3689C9.2688%2020.3065%2010.5406%2020.8333%2011.8667%2020.8333C13.1927%2020.8333%2014.4645%2020.3065%2015.4022%2019.3689C16.3399%2018.4312%2016.8666%2017.1594%2016.8666%2015.8333C16.8699%2014.9279%2016.6218%2014.0394%2016.15%2013.2667Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M14.3667%2015.8333C14.8087%2015.8333%2015.2326%2015.6577%2015.5452%2015.3452C15.8578%2015.0326%2016.0333%2014.6087%2016.0333%2014.1667V13.0883C15.9006%2012.8796%2015.7501%2012.6827%2015.5833%2012.5H12.7V14.1667C12.7%2014.6087%2012.8756%2015.0326%2013.1882%2015.3452C13.5007%2015.6577%2013.9247%2015.8333%2014.3667%2015.8333Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M20.2%203.33336C30.325%203.33336%2038.5333%2010.4225%2038.5333%2019.1667H39.3458C39.1161%2014.2434%2036.9986%209.59783%2033.4332%206.19495C29.8678%202.79206%2025.1286%200.893433%2020.2%200.893433C15.2713%200.893433%2010.5321%202.79206%206.96673%206.19495C3.40135%209.59783%201.28387%2014.2434%201.05414%2019.1667H1.86664C1.86664%2010.4225%2010.075%203.33336%2020.2%203.33336Z'%20fill='%23FFE369'%20/%3e%3cpath%20d='M38.5333%2019.1667C38.5333%2027.9109%2030.325%2035.0001%2020.2%2035.0001C10.075%2035.0001%201.86666%2027.9109%201.86666%2019.1667H1.05416C1.04249%2019.4434%201.03333%2019.7209%201.03333%2020.0001C1.03333%2025.0834%203.05266%2029.9585%206.64711%2033.553C10.2416%2037.1474%2015.1167%2039.1667%2020.2%2039.1667C25.2833%2039.1667%2030.1584%2037.1474%2033.7529%2033.553C37.3473%2029.9585%2039.3667%2025.0834%2039.3667%2020.0001C39.3667%2019.7209%2039.3575%2019.4434%2039.3458%2019.1667H38.5333Z'%20fill='%23FFB32B'%20/%3e%3cpath%20d='M31.2933%207.75958C31.5617%207.49101%2031.4763%206.97052%2031.1026%206.59705C30.7289%206.22358%2030.2083%206.13855%2029.9399%206.40713C29.6716%206.67571%2029.7569%207.19619%2030.1307%207.56966C30.5044%207.94313%2031.025%208.02816%2031.2933%207.75958Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M25.7433%203.67143C25.8777%203.53698%2025.8351%203.2766%2025.6483%203.08987C25.4614%202.90313%2025.201%202.86075%2025.0666%202.9952C24.9323%203.12965%2024.9748%203.39003%2025.1617%203.57676C25.3486%203.7635%2025.609%203.80588%2025.7433%203.67143Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M29.4706%206.76974C30.0074%206.23258%2029.8364%205.19135%2029.0886%204.44408C28.3408%203.69681%2027.2994%203.52649%2026.7626%204.06364C26.2259%204.6008%2026.3969%205.64203%2027.1447%206.3893C27.8925%207.13657%2028.9338%207.3069%2029.4706%206.76974Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M28.5333%2020.8334C27.3547%2020.8323%2026.2143%2020.4149%2025.3135%2019.6548C24.4127%2018.8948%2023.8094%2017.8409%2023.61%2016.6792C23.4835%2017.3985%2023.5161%2018.1367%2023.7054%2018.8419C23.8948%2019.5472%2024.2364%2020.2025%2024.7061%2020.7616C25.1758%2021.3207%2025.7623%2021.7702%2026.4244%2022.0783C27.0864%2022.3865%2027.8079%2022.5459%2028.5382%2022.5454C29.2685%2022.5448%2029.9897%2022.3843%2030.6513%2022.0751C31.3129%2021.7659%2031.8987%2021.3156%2032.3676%2020.7558C32.8365%2020.1959%2033.177%2019.5402%2033.3653%2018.8346C33.5536%2018.129%2033.5851%2017.3908%2033.4575%2016.6717C33.2597%2017.8349%2032.6569%2018.8906%2031.7557%2019.6522C30.8546%2020.4138%2029.7132%2020.8322%2028.5333%2020.8334ZM11.8667%2020.8334C10.688%2020.8323%209.54766%2020.4149%208.64685%2019.6548C7.74604%2018.8948%207.1427%2017.8409%206.94332%2016.6792C6.81682%2017.3985%206.8494%2018.1367%207.03877%2018.8419C7.22813%2019.5472%207.56969%2020.2025%208.03942%2020.7616C8.50916%2021.3207%209.09567%2021.7702%209.75772%2022.0783C10.4198%2022.3865%2011.1413%2022.5459%2011.8715%2022.5454C12.6018%2022.5448%2013.3231%2022.3843%2013.9846%2022.0751C14.6462%2021.7659%2015.232%2021.3156%2015.7009%2020.7558C16.1698%2020.1959%2016.5104%2019.5402%2016.6987%2018.8346C16.887%2018.129%2016.9184%2017.3908%2016.7908%2016.6717C16.593%2017.8349%2015.9902%2018.8906%2015.0891%2019.6522C14.1879%2020.4138%2013.0465%2020.8322%2011.8667%2020.8334ZM29.3666%2012.5001H32.25C32.4167%2012.6828%2032.5673%2012.8797%2032.7%2013.0884C32.7383%2013.1484%2032.7833%2013.2051%2032.8167%2013.2667C33.222%2013.9378%2033.4596%2014.6968%2033.5092%2015.4792C33.5242%2015.3217%2033.5333%2015.1617%2033.5333%2015.0001C33.5365%2014.0947%2033.2884%2013.2062%2032.8167%2012.4334C32.7817%2012.3717%2032.7383%2012.3151%2032.7%2012.2551C32.5673%2012.0463%2032.4167%2011.8495%2032.25%2011.6667H24.8167C23.9883%2012.579%2023.5306%2013.7678%2023.5333%2015.0001C23.5335%2015.1766%2023.5429%2015.3529%2023.5617%2015.5284C23.623%2014.4055%2024.0658%2013.3372%2024.8167%2012.5001H29.3666ZM12.7%2012.5001H15.5833C15.75%2012.6828%2015.9006%2012.8797%2016.0333%2013.0884C16.0716%2013.1484%2016.1166%2013.2051%2016.15%2013.2667C16.5553%2013.9378%2016.7929%2014.6968%2016.8425%2015.4792C16.8575%2015.3217%2016.8666%2015.1617%2016.8666%2015.0001C16.8699%2014.0947%2016.6218%2013.2062%2016.15%2012.4334C16.115%2012.3717%2016.0716%2012.3151%2016.0333%2012.2551C15.9006%2012.0463%2015.75%2011.8495%2015.5833%2011.6667H8.14998C7.32164%2012.579%206.86394%2013.7678%206.86665%2015.0001C6.86681%2015.1766%206.87627%2015.3529%206.89498%2015.5284C6.95637%2014.4055%207.3991%2013.3372%208.14998%2012.5001H12.7Z'%20fill='%23FBB40A'%20/%3e%3c/svg%3e", vke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='41'%20height='40'%20viewBox='0%200%2041%2040'%20fill='none'%3e%3cpath%20d='M20.6%2039.1667C31.1855%2039.1667%2039.7667%2030.5855%2039.7667%2020C39.7667%209.41458%2031.1855%200.833374%2020.6%200.833374C10.0146%200.833374%201.43335%209.41458%201.43335%2020C1.43335%2030.5855%2010.0146%2039.1667%2020.6%2039.1667Z'%20fill='%23FFCE52'%20/%3e%3cpath%20d='M28.1%2018.3334C29.4807%2018.3334%2030.6%2016.841%2030.6%2015.0001C30.6%2013.1591%2029.4807%2011.6667%2028.1%2011.6667C26.7193%2011.6667%2025.6%2013.1591%2025.6%2015.0001C25.6%2016.841%2026.7193%2018.3334%2028.1%2018.3334Z'%20fill='%23273941'%20/%3e%3cpath%20d='M13.1%2018.3334C14.4807%2018.3334%2015.6%2016.841%2015.6%2015.0001C15.6%2013.1591%2014.4807%2011.6667%2013.1%2011.6667C11.7193%2011.6667%2010.6%2013.1591%2010.6%2015.0001C10.6%2016.841%2011.7193%2018.3334%2013.1%2018.3334Z'%20fill='%23273941'%20/%3e%3cpath%20d='M28.1%2017.5C29.0205%2017.5%2029.7667%2016.3807%2029.7667%2015C29.7667%2013.6193%2029.0205%2012.5%2028.1%2012.5C27.1795%2012.5%2026.4333%2013.6193%2026.4333%2015C26.4333%2016.3807%2027.1795%2017.5%2028.1%2017.5Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M13.1%2017.5C14.0205%2017.5%2014.7667%2016.3807%2014.7667%2015C14.7667%2013.6193%2014.0205%2012.5%2013.1%2012.5C12.1795%2012.5%2011.4333%2013.6193%2011.4333%2015C11.4333%2016.3807%2012.1795%2017.5%2013.1%2017.5Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M28.9334%2015C29.3936%2015%2029.7667%2014.6269%2029.7667%2014.1667C29.7667%2013.7065%2029.3936%2013.3334%2028.9334%2013.3334C28.4731%2013.3334%2028.1%2013.7065%2028.1%2014.1667C28.1%2014.6269%2028.4731%2015%2028.9334%2015Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M13.9334%2015C14.3936%2015%2014.7667%2014.6269%2014.7667%2014.1667C14.7667%2013.7065%2014.3936%2013.3334%2013.9334%2013.3334C13.4731%2013.3334%2013.1%2013.7065%2013.1%2014.1667C13.1%2014.6269%2013.4731%2015%2013.9334%2015Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M20.6%203.33336C30.725%203.33336%2038.9333%2010.4225%2038.9333%2019.1667H39.7458C39.5161%2014.2434%2037.3986%209.59783%2033.8332%206.19495C30.2679%202.79206%2025.5286%200.893433%2020.6%200.893433C15.6714%200.893433%2010.9321%202.79206%207.36675%206.19495C3.80137%209.59783%201.6839%2014.2434%201.45416%2019.1667H2.26666C2.26666%2010.4225%2010.475%203.33336%2020.6%203.33336Z'%20fill='%23FFE369'%20/%3e%3cpath%20d='M38.9333%2019.1667C38.9333%2027.9109%2030.725%2035.0001%2020.6%2035.0001C10.475%2035.0001%202.26668%2027.9109%202.26668%2019.1667H1.45418C1.44252%2019.4434%201.43335%2019.7209%201.43335%2020.0001C1.43335%2025.0834%203.45269%2029.9585%207.04714%2033.553C10.6416%2037.1474%2015.5167%2039.1667%2020.6%2039.1667C25.6833%2039.1667%2030.5584%2037.1474%2034.1529%2033.553C37.7473%2029.9585%2039.7667%2025.0834%2039.7667%2020.0001C39.7667%2019.7209%2039.7575%2019.4434%2039.7458%2019.1667H38.9333Z'%20fill='%23FFB32B'%20/%3e%3cpath%20d='M27.2667%2026.6667H13.9333V28.3334H27.2667V26.6667Z'%20fill='%23273941'%20/%3e%3cpath%20d='M32.1101%208.17621C32.3785%207.90763%2032.2931%207.38715%2031.9193%207.01368C31.5456%206.6402%2031.025%206.55517%2030.7567%206.82375C30.4883%207.09233%2030.5737%207.61282%2030.9474%207.98629C31.3211%208.35976%2031.8417%208.44479%2032.1101%208.17621Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M26.5598%204.08757C26.6942%203.95311%2026.6516%203.69274%2026.4647%203.506C26.2779%203.31927%2026.0175%203.27689%2025.8831%203.41134C25.7488%203.54579%2025.7913%203.80616%2025.9782%203.9929C26.165%204.17964%2026.4255%204.22202%2026.5598%204.08757Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M30.2873%207.18636C30.8241%206.64921%2030.6531%205.60797%2029.9053%204.8607C29.1575%204.11344%2028.1161%203.94311%2027.5794%204.48027C27.0426%205.01743%2027.2136%206.05866%2027.9614%206.80593C28.7092%207.5532%2029.7506%207.72352%2030.2873%207.18636Z'%20fill='%23F6FAFD'%20/%3e%3c/svg%3e", qke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6207_1290)'%3e%3cpath%20d='M20%2039.1667C30.5854%2039.1667%2039.1666%2030.5855%2039.1666%2020C39.1666%209.41458%2030.5854%200.833374%2020%200.833374C9.41452%200.833374%200.833313%209.41458%200.833313%2020C0.833313%2030.5855%209.41452%2039.1667%2020%2039.1667Z'%20fill='%23FFCE52'%20/%3e%3cpath%20d='M27.5%2018.3334C28.8807%2018.3334%2030%2016.841%2030%2015.0001C30%2013.1591%2028.8807%2011.6667%2027.5%2011.6667C26.1193%2011.6667%2025%2013.1591%2025%2015.0001C25%2016.841%2026.1193%2018.3334%2027.5%2018.3334Z'%20fill='%23273941'%20/%3e%3cpath%20d='M12.5%2018.3334C13.8807%2018.3334%2015%2016.841%2015%2015.0001C15%2013.1591%2013.8807%2011.6667%2012.5%2011.6667C11.1193%2011.6667%2010%2013.1591%2010%2015.0001C10%2016.841%2011.1193%2018.3334%2012.5%2018.3334Z'%20fill='%23273941'%20/%3e%3cpath%20d='M27.5%2017.5C28.4205%2017.5%2029.1666%2016.3807%2029.1666%2015C29.1666%2013.6193%2028.4205%2012.5%2027.5%2012.5C26.5795%2012.5%2025.8333%2013.6193%2025.8333%2015C25.8333%2016.3807%2026.5795%2017.5%2027.5%2017.5Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M12.5%2017.5C13.4205%2017.5%2014.1666%2016.3807%2014.1666%2015C14.1666%2013.6193%2013.4205%2012.5%2012.5%2012.5C11.5795%2012.5%2010.8333%2013.6193%2010.8333%2015C10.8333%2016.3807%2011.5795%2017.5%2012.5%2017.5Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M28.3333%2015C28.7936%2015%2029.1667%2014.6269%2029.1667%2014.1667C29.1667%2013.7065%2028.7936%2013.3334%2028.3333%2013.3334C27.8731%2013.3334%2027.5%2013.7065%2027.5%2014.1667C27.5%2014.6269%2027.8731%2015%2028.3333%2015Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M13.3333%2015C13.7936%2015%2014.1667%2014.6269%2014.1667%2014.1667C14.1667%2013.7065%2013.7936%2013.3334%2013.3333%2013.3334C12.8731%2013.3334%2012.5%2013.7065%2012.5%2014.1667C12.5%2014.6269%2012.8731%2015%2013.3333%2015Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M20%2032.5001C13.5666%2032.5001%208.33331%2027.6401%208.33331%2021.6667H9.99998C9.99998%2026.7209%2014.4858%2030.8334%2020%2030.8334C25.5141%2030.8334%2030%2026.7209%2030%2021.6667H31.6666C31.6666%2027.6401%2026.4333%2032.5001%2020%2032.5001Z'%20fill='%23273941'%20/%3e%3cpath%20d='M20%203.33336C30.125%203.33336%2038.3333%2010.4225%2038.3333%2019.1667H39.1458C38.9161%2014.2434%2036.7986%209.59783%2033.2332%206.19495C29.6678%202.79206%2024.9286%200.893433%2020%200.893433C15.0713%200.893433%2010.3321%202.79206%206.76672%206.19495C3.20134%209.59783%201.08386%2014.2434%200.854126%2019.1667H1.66663C1.66663%2010.4225%209.87496%203.33336%2020%203.33336Z'%20fill='%23FFE369'%20/%3e%3cpath%20d='M38.3333%2019.1667C38.3333%2027.9109%2030.125%2035.0001%2020%2035.0001C9.87498%2035.0001%201.66665%2027.9109%201.66665%2019.1667H0.854146C0.84248%2019.4434%200.833313%2019.7209%200.833313%2020.0001C0.833313%2025.0834%202.85265%2029.9585%206.4471%2033.553C10.0415%2037.1474%2014.9167%2039.1667%2020%2039.1667C25.0833%2039.1667%2029.9584%2037.1474%2033.5529%2033.553C37.1473%2029.9585%2039.1666%2025.0834%2039.1666%2020.0001C39.1666%2019.7209%2039.1575%2019.4434%2039.1458%2019.1667H38.3333Z'%20fill='%23FFB32B'%20/%3e%3cpath%20d='M31.51%208.17621C31.7784%207.90763%2031.693%207.38715%2031.3193%207.01368C30.9456%206.6402%2030.425%206.55517%2030.1566%206.82375C29.8882%207.09233%2029.9736%207.61282%2030.3474%207.98629C30.7211%208.35976%2031.2416%208.44479%2031.51%208.17621Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M25.9598%204.08757C26.0941%203.95311%2026.0516%203.69274%2025.8647%203.506C25.6778%203.31927%2025.4174%203.27689%2025.2831%203.41134C25.1487%203.54579%2025.1913%203.80616%2025.3781%203.9929C25.565%204.17964%2025.8254%204.22202%2025.9598%204.08757Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M29.6873%207.18636C30.2241%206.64921%2030.053%205.60797%2029.3052%204.8607C28.5575%204.11344%2027.5161%203.94311%2026.9793%204.48027C26.4425%205.01743%2026.6136%206.05866%2027.3614%206.80593C28.1092%207.5532%2029.1505%207.72352%2029.6873%207.18636Z'%20fill='%23F6FAFD'%20/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6207_1290'%3e%3crect%20width='40'%20height='40'%20fill='white'%20/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", yke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='41'%20height='40'%20viewBox='0%200%2041%2040'%20fill='none'%3e%3cpath%20d='M20.3999%2039.1667C30.9854%2039.1667%2039.5666%2030.5855%2039.5666%2020C39.5666%209.41458%2030.9854%200.833374%2020.3999%200.833374C9.81449%200.833374%201.23328%209.41458%201.23328%2020C1.23328%2030.5855%209.81449%2039.1667%2020.3999%2039.1667Z'%20fill='%23FFCE52'%20/%3e%3cpath%20d='M6.23328%2021.6666C6.23328%2024.4333%2012.5666%2027.5%2020.3999%2027.5C28.2333%2027.5%2034.5666%2024.4333%2034.5666%2021.6666C34.5509%2023.3792%2034.1176%2025.0622%2033.3044%2026.5695C32.4912%2028.0768%2031.3226%2029.363%2029.8999%2030.3166C27.121%2032.2795%2023.8022%2033.3333%2020.3999%2033.3333C16.9977%2033.3333%2013.6789%2032.2795%2010.8999%2030.3166C9.47728%2029.363%208.30869%2028.0768%207.49549%2026.5695C6.68229%2025.0622%206.24903%2023.3792%206.23328%2021.6666Z'%20fill='%23AE2D4C'%20/%3e%3cpath%20d='M34.5666%2021.6666C34.5666%2024.4333%2028.2333%2027.5%2020.3999%2027.5C12.5666%2027.5%206.23328%2024.4333%206.23328%2021.6666C7.06661%2022.5%2012.8999%2023.3333%2020.3999%2023.3333C27.8999%2023.3333%2033.7333%2022.5%2034.5666%2021.6666Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M27.8999%2018.3333C29.2806%2018.3333%2030.3999%2016.8409%2030.3999%2015C30.3999%2013.159%2029.2806%2011.6666%2027.8999%2011.6666C26.5192%2011.6666%2025.3999%2013.159%2025.3999%2015C25.3999%2016.8409%2026.5192%2018.3333%2027.8999%2018.3333Z'%20fill='%23273941'%20/%3e%3cpath%20d='M12.8999%2018.3333C14.2806%2018.3333%2015.3999%2016.8409%2015.3999%2015C15.3999%2013.159%2014.2806%2011.6666%2012.8999%2011.6666C11.5192%2011.6666%2010.3999%2013.159%2010.3999%2015C10.3999%2016.8409%2011.5192%2018.3333%2012.8999%2018.3333Z'%20fill='%23273941'%20/%3e%3cpath%20d='M27.8999%2017.5C28.8204%2017.5%2029.5666%2016.3807%2029.5666%2015C29.5666%2013.6193%2028.8204%2012.5%2027.8999%2012.5C26.9795%2012.5%2026.2333%2013.6193%2026.2333%2015C26.2333%2016.3807%2026.9795%2017.5%2027.8999%2017.5Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M12.8999%2017.5C13.8204%2017.5%2014.5666%2016.3807%2014.5666%2015C14.5666%2013.6193%2013.8204%2012.5%2012.8999%2012.5C11.9795%2012.5%2011.2333%2013.6193%2011.2333%2015C11.2333%2016.3807%2011.9795%2017.5%2012.8999%2017.5Z'%20fill='%23141E21'%20/%3e%3cpath%20d='M28.7332%2015C29.1935%2015%2029.5666%2014.6269%2029.5666%2014.1667C29.5666%2013.7065%2029.1935%2013.3334%2028.7332%2013.3334C28.273%2013.3334%2027.8999%2013.7065%2027.8999%2014.1667C27.8999%2014.6269%2028.273%2015%2028.7332%2015Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M13.7332%2015C14.1935%2015%2014.5666%2014.6269%2014.5666%2014.1667C14.5666%2013.7065%2014.1935%2013.3334%2013.7332%2013.3334C13.273%2013.3334%2012.8999%2013.7065%2012.8999%2014.1667C12.8999%2014.6269%2013.273%2015%2013.7332%2015Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M20.3999%2029.1666C27.0349%2029.1666%2032.5774%2026.9658%2034.1233%2024.6116C34.4161%2023.6573%2034.5656%2022.6648%2034.5666%2021.6666C34.5666%2024.4333%2028.2333%2027.5%2020.3999%2027.5C12.5666%2027.5%206.23328%2024.4333%206.23328%2021.6666C6.23433%2022.6648%206.38374%2023.6573%206.67661%2024.6116C8.22244%2026.9658%2013.7649%2029.1666%2020.3999%2029.1666Z'%20fill='%238A293D'%20/%3e%3cpath%20d='M33.2958%2023.8791C33.6504%2023.6196%2033.9467%2023.2886%2034.1656%2022.9075C34.3845%2022.5264%2034.5211%2022.1037%2034.5666%2021.6666C33.7333%2022.5%2027.8999%2023.3333%2020.3999%2023.3333C12.8999%2023.3333%207.06661%2022.5%206.23328%2021.6666C6.27881%2022.1037%206.41543%2022.5264%206.63431%2022.9075C6.8532%2023.2886%207.14949%2023.6196%207.50411%2023.8791C9.75244%2024.495%2014.5666%2025%2020.3999%2025C26.2333%2025%2031.0474%2024.495%2033.2958%2023.8791Z'%20fill='%23EDEDED'%20/%3e%3cpath%20d='M20.3999%203.33336C30.5249%203.33336%2038.7332%2010.4225%2038.7332%2019.1667H39.5457C39.316%2014.2434%2037.1985%209.59783%2033.6331%206.19495C30.0677%202.79206%2025.3285%200.893433%2020.3999%200.893433C15.4712%200.893433%2010.732%202.79206%207.16662%206.19495C3.60124%209.59783%201.48377%2014.2434%201.25403%2019.1667H2.06653C2.06653%2010.4225%2010.2749%203.33336%2020.3999%203.33336Z'%20fill='%23FFE369'%20/%3e%3cpath%20d='M38.7333%2019.1666C38.7333%2027.9108%2030.5249%2035%2020.3999%2035C10.2749%2035%202.06661%2027.9108%202.06661%2019.1666H1.25411C1.24244%2019.4433%201.23328%2019.7208%201.23328%2020C1.23328%2025.0833%203.25262%2029.9584%206.84706%2033.5528C10.4415%2037.1473%2015.3166%2039.1666%2020.3999%2039.1666C25.4833%2039.1666%2030.3584%2037.1473%2033.9528%2033.5528C37.5473%2029.9584%2039.5666%2025.0833%2039.5666%2020C39.5666%2019.7208%2039.5574%2019.4433%2039.5458%2019.1666H38.7333Z'%20fill='%23FFB32B'%20/%3e%3cpath%20d='M31.9099%208.17621C32.1783%207.90763%2032.0929%207.38715%2031.7192%207.01368C31.3455%206.6402%2030.8249%206.55517%2030.5565%206.82375C30.2881%207.09233%2030.3735%207.61282%2030.7473%207.98629C31.121%208.35976%2031.6415%208.44479%2031.9099%208.17621Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M26.3597%204.08757C26.494%203.95311%2026.4515%203.69274%2026.2646%203.506C26.0777%203.31927%2025.8173%203.27689%2025.683%203.41134C25.5486%203.54579%2025.5912%203.80616%2025.778%203.9929C25.9649%204.17964%2026.2253%204.22202%2026.3597%204.08757Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M30.0873%207.18636C30.6241%206.64921%2030.453%205.60797%2029.7052%204.8607C28.9574%204.11344%2027.9161%203.94311%2027.3793%204.48027C26.8425%205.01743%2027.0136%206.05866%2027.7613%206.80593C28.5091%207.5532%2029.5505%207.72352%2030.0873%207.18636Z'%20fill='%23F6FAFD'%20/%3e%3c/svg%3e", Cke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='41'%20height='40'%20viewBox='0%200%2041%2040'%20fill='none'%3e%3cpath%20d='M20.8%2039.1667C31.3854%2039.1667%2039.9666%2030.5855%2039.9666%2020C39.9666%209.41458%2031.3854%200.833374%2020.8%200.833374C10.2145%200.833374%201.6333%209.41458%201.6333%2020C1.6333%2030.5855%2010.2145%2039.1667%2020.8%2039.1667Z'%20fill='%23FFCE52'%20/%3e%3cpath%20d='M20.8%203.33336C30.925%203.33336%2039.1333%2010.4225%2039.1333%2019.1667H39.9458C39.7161%2014.2434%2037.5986%209.59783%2034.0332%206.19495C30.4679%202.79206%2025.7287%200.893433%2020.8%200.893433C15.8714%200.893433%2011.1321%202.79206%207.56676%206.19495C4.00139%209.59783%201.88391%2014.2434%201.65417%2019.1667H2.46667C2.46667%2010.4225%2010.675%203.33336%2020.8%203.33336Z'%20fill='%23FFE369'%20/%3e%3cpath%20d='M39.1333%2019.1667C39.1333%2027.9109%2030.925%2035.0001%2020.8%2035.0001C10.675%2035.0001%202.46663%2027.9109%202.46663%2019.1667H1.65413C1.64247%2019.4434%201.6333%2019.7209%201.6333%2020.0001C1.6333%2025.0834%203.65264%2029.9585%207.24709%2033.553C10.8415%2037.1474%2015.7167%2039.1667%2020.8%2039.1667C25.8833%2039.1667%2030.7584%2037.1474%2034.3528%2033.553C37.9473%2029.9585%2039.9666%2025.0834%2039.9666%2020.0001C39.9666%2019.7209%2039.9575%2019.4434%2039.9458%2019.1667H39.1333Z'%20fill='%23FFB32B'%20/%3e%3cpath%20d='M31.8933%206.92621C32.1617%206.65763%2032.0763%206.13715%2031.7026%205.76368C31.3289%205.3902%2030.8083%205.30517%2030.5399%205.57375C30.2715%205.84233%2030.3569%206.36282%2030.7307%206.73629C31.1044%207.10976%2031.6249%207.19479%2031.8933%206.92621Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M26.3433%203.67143C26.4777%203.53698%2026.4351%203.2766%2026.2482%203.08987C26.0614%202.90313%2025.801%202.86075%2025.6666%202.9952C25.5323%203.12965%2025.5748%203.39003%2025.7617%203.57676C25.9486%203.7635%2026.209%203.80588%2026.3433%203.67143Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M30.0707%205.93637C30.6074%205.39921%2030.4364%204.35797%2029.6886%203.61071C28.9408%202.86344%2027.8995%202.69311%2027.3627%203.23027C26.8259%203.76743%2026.997%204.80866%2027.7447%205.55593C28.4925%206.3032%2029.5339%206.47352%2030.0707%205.93637Z'%20fill='%23F6FAFD'%20/%3e%3cpath%20d='M30.7999%2020C33.5614%2020%2035.7999%2017.7614%2035.7999%2015C35.7999%2012.2386%2033.5614%2010%2030.7999%2010C28.0385%2010%2025.7999%2012.2386%2025.7999%2015C25.7999%2017.7614%2028.0385%2020%2030.7999%2020Z'%20fill='url(%23paint0_radial_6207_1324)'%20/%3e%3cpath%20d='M10.7999%2020C13.5614%2020%2015.7999%2017.7614%2015.7999%2015C15.7999%2012.2386%2013.5614%2010%2010.7999%2010C8.0385%2010%205.79993%2012.2386%205.79993%2015C5.79993%2017.7614%208.0385%2020%2010.7999%2020Z'%20fill='url(%23paint1_radial_6207_1324)'%20/%3e%3cpath%20d='M20.8%2023.3334C17.1241%2023.3334%2014.1333%2020.7167%2014.1333%2017.5001H15.8C15.8%2019.7976%2018.0425%2021.6667%2020.8%2021.6667C23.5575%2021.6667%2025.8%2019.7976%2025.8%2017.5001H27.4666C27.4666%2020.7167%2024.4758%2023.3334%2020.8%2023.3334ZM32.4666%2010.8334H30.8C30.8%2010.1704%2030.5366%209.53449%2030.0677%209.06565C29.5989%208.59681%2028.963%208.33341%2028.3%208.33341C27.6369%208.33341%2027.001%208.59681%2026.5322%209.06565C26.0634%209.53449%2025.8%2010.1704%2025.8%2010.8334H24.1333C24.1333%209.72835%2024.5723%208.66854%2025.3537%207.88714C26.1351%207.10573%2027.1949%206.66675%2028.3%206.66675C29.405%206.66675%2030.4648%207.10573%2031.2462%207.88714C32.0276%208.66854%2032.4666%209.72835%2032.4666%2010.8334ZM17.4666%2010.8334H15.8C15.8%2010.1704%2015.5366%209.53449%2015.0677%209.06565C14.5989%208.59681%2013.963%208.33341%2013.3%208.33341C12.6369%208.33341%2012.001%208.59681%2011.5322%209.06565C11.0634%209.53449%2010.8%2010.1704%2010.8%2010.8334H9.1333C9.1333%209.72835%209.57229%208.66854%2010.3537%207.88714C11.1351%207.10573%2012.1949%206.66675%2013.3%206.66675C14.405%206.66675%2015.4648%207.10573%2016.2462%207.88714C17.0276%208.66854%2017.4666%209.72835%2017.4666%2010.8334Z'%20fill='%23273941'%20/%3e%3cdefs%3e%3cradialGradient%20id='paint0_radial_6207_1324'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(30.7999%2015)%20scale(5)'%3e%3cstop%20stop-color='%23FF568D'%20/%3e%3cstop%20offset='0.454'%20stop-color='%23FF9678'%20/%3e%3cstop%20offset='0.817'%20stop-color='%23FFC26A'%20/%3e%3cstop%20offset='1'%20stop-color='%23FFD364'%20/%3e%3c/radialGradient%3e%3cradialGradient%20id='paint1_radial_6207_1324'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(10.7999%200.416667)%20scale(0.416667)'%3e%3cstop%20stop-color='%23FF568D'%20/%3e%3cstop%20offset='0.454'%20stop-color='%23FF9678'%20/%3e%3cstop%20offset='0.817'%20stop-color='%23FFC26A'%20/%3e%3cstop%20offset='1'%20stop-color='%23FFD364'%20/%3e%3c/radialGradient%3e%3c/defs%3e%3c/svg%3e", l1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.0462%205.67461C13.226%205.88428%2013.2017%206.19993%2012.992%206.37964L8.32535%2010.3796C8.1381%2010.5401%207.8618%2010.5401%207.67456%2010.3796L3.00789%206.37964C2.79823%206.19993%202.77394%205.88428%202.95366%205.67461C3.13337%205.46495%203.44902%205.44067%203.65868%205.62038L7.99995%209.34147L12.3412%205.62038C12.5509%205.44067%2012.8665%205.46495%2013.0462%205.67461Z'%20fill='%23B9B9B9'/%3e%3c/svg%3e", wke = async (t, e, r, n, A, i, o, s, a, c, l) => {
  var u;
  try {
    if (o || s) {
      let v = await new Bt("", a).getExternalLogin({
        apiType: a,
        uniqueUserId: o,
        entityId: e,
        userId: n,
        apiKey: i,
        apiSecret: "",
        token: A,
        uniqueEmailId: s,
        entityAuthenticationToken: l,
        alert: !1
      });
      v != null && v.userId && (n = v == null ? void 0 : v.userId, A = v == null ? void 0 : v.token);
    }
    let f = {
      userId: n,
      token: A,
      entityId: e,
      apikey: i
    };
    const d = new URLSearchParams();
    c && d.set("variation", c);
    let g = `${t}api/v2/entities/${e}/campaigns/${r}/parent?${d.toString()}`, m = await Oe(g, { headers: f });
    return m == null ? void 0 : m.data;
  } catch (f) {
    return (u = f == null ? void 0 : f.response) == null ? void 0 : u.data;
  }
}, ij = async (t, e, r, n, A, i, o, s, a, c) => {
  var l;
  try {
    if (o || s) {
      let m = await new Bt("", a).getExternalLogin({
        apiType: a,
        uniqueUserId: o,
        entityId: e,
        userId: n,
        apiKey: i,
        apiSecret: "",
        token: A,
        uniqueEmailId: s,
        entityAuthenticationToken: c,
        alert: !1
      });
      m != null && m.userId && (n = m == null ? void 0 : m.userId, A = m == null ? void 0 : m.token);
    }
    let u = {
      userId: n,
      token: A,
      entityId: e,
      apikey: i
    }, f = `${t}api/entities/${e}`, d = await Oe(f, { headers: u });
    return d == null ? void 0 : d.data;
  } catch (u) {
    return (l = u == null ? void 0 : u.response) == null ? void 0 : l.data;
  }
}, dy = async (t, e, r, n, A, i, o, s, a, c, l, u, f) => {
  try {
    if (c || l) {
      let v = await new Bt("", u).getExternalLogin({
        apiType: u,
        uniqueUserId: c,
        entityId: e,
        userId: n,
        apiKey: i,
        apiSecret: "",
        token: A,
        uniqueEmailId: l,
        entityAuthenticationToken: f,
        alert: !1
      });
      v != null && v.userId && (n = v == null ? void 0 : v.userId, A = v == null ? void 0 : v.token);
    }
    let d = {
      userId: n,
      token: A,
      entityId: e,
      apikey: i
    }, g = `${t}api/v2/entities/${e}/campaigns/${r}/verify`;
    return (await Oe.post(
      g,
      {
        campaignVariationId: s,
        actions: [
          {
            actionId: o,
            answers: a.map((p) => String(p))
          }
        ]
      },
      { headers: d }
    )).data;
  } catch (d) {
    return d == null ? void 0 : d.response.data;
  }
}, fy = async (t, e, r, n, A, i, o, s, a, c) => {
  var l;
  try {
    if (o || s) {
      let m = await new Bt("", a).getExternalLogin({
        apiType: a,
        uniqueUserId: o,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: s,
        entityAuthenticationToken: c,
        alert: !1
      });
      m != null && m.userId && (r = m == null ? void 0 : m.userId, n = m == null ? void 0 : m.token);
    }
    let u = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    }, f = i ? `${t}api/entities/${e}/users/${r}/conversation/user?conversationId=${i}` : `${t}api/entities/${e}/users/${r}/conversation/user`;
    return (await Oe.get(f, { headers: u })).data;
  } catch (u) {
    return ((l = u == null ? void 0 : u.response) == null ? void 0 : l.data) || { message: "An error occurred", error: u };
  }
}, bke = async (t, e, r, n, A, i, o, s, a, c, l) => {
  try {
    if (s || a) {
      let p = await new Bt("", c).getExternalLogin({
        apiType: c,
        uniqueUserId: s,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: a,
        entityAuthenticationToken: l,
        alert: !1
      });
      p != null && p.userId && (r = p == null ? void 0 : p.userId, n = p == null ? void 0 : p.token);
    }
    let u = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    }, f = {
      message: i
    }, d = o ? `${t}api/entities/${e}/users/${r}/conversation/user?conversationId=${o}` : `${t}api/entities/${e}/users/${r}/conversation/user?new_conversation=true`;
    return (await Oe.post(d, f, { headers: u })).data;
  } catch (u) {
    return u == null ? void 0 : u.response.data;
  }
}, Bke = async (t, e, r, n, A, i, o, s, a, c, l) => {
  try {
    if (s || a) {
      let p = await new Bt("", c).getExternalLogin({
        apiType: c,
        uniqueUserId: s,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: a,
        entityAuthenticationToken: l,
        alert: !1
      });
      p != null && p.userId && (r = p == null ? void 0 : p.userId, n = p == null ? void 0 : p.token);
    }
    let u = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    }, f = {
      isSatisfied: i
    }, d = `${t}api/entities/${e}/users/${r}/user/satisfied?conversationId=${o}`;
    return (await Oe.post(d, f, { headers: u })).data;
  } catch (u) {
    return u == null ? void 0 : u.response.data;
  }
}, Eke = async (t, e, r, n, A, i, o, s, a, c) => {
  try {
    if (o || s) {
      let g = await new Bt("", a).getExternalLogin({
        apiType: a,
        uniqueUserId: o,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: s,
        entityAuthenticationToken: c,
        alert: !1
      });
      g != null && g.userId && (r = g == null ? void 0 : g.userId, n = g == null ? void 0 : g.token);
    }
    let l = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    }, u = `${t}api/entities/${e}/users/${r}/conversation/user/close?conversationId=${i}`;
    return (await Oe.post(u, {}, { headers: l })).data;
  } catch (l) {
    return l == null ? void 0 : l.response.data;
  }
}, xke = async (t, e, r, n, A, i, o, s, a) => {
  try {
    if (i || o) {
      let d = await new Bt("", s).getExternalLogin({
        apiType: s,
        uniqueUserId: i,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: o,
        entityAuthenticationToken: a,
        alert: !1
      });
      d != null && d.userId && (r = d == null ? void 0 : d.userId, n = d == null ? void 0 : d.token);
    }
    let c = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    }, l = `${t}api/entities/${e}/users/${r}/connected-socials`;
    return (await Oe(l, { headers: c })).data;
  } catch (c) {
    return c == null ? void 0 : c.response.data;
  }
}, Ike = async (t, e, r, n, A, i, o, s, a, c) => {
  try {
    let l = {
      ...!!r && { userId: r },
      ...!!n && { token: n },
      ...!!c && {
        "entity-authentication-token": c
      },
      entityId: e,
      apikey: A
    };
    const u = {
      externalUserId: !!i && i,
      entityId: e,
      email: a
    };
    let f = `${t}api/users/external/login`;
    return (await Oe.post(f, u, { headers: l })).data;
  } catch (l) {
    return l == null ? void 0 : l.response.data;
  }
}, Ske = async ({
  backend_url: t,
  entityId: e,
  userId: r,
  token: n,
  apikey: A,
  conversationId: i,
  feedbackRate: o,
  uniqueUserId: s,
  uniqueEmailId: a,
  apiType: c,
  entityAuthenticationToken: l
}) => {
  try {
    if (s || a) {
      let m = await new Bt("", c).getExternalLogin({
        apiType: c,
        uniqueUserId: s,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: a,
        entityAuthenticationToken: l
      });
      m != null && m.userId && (r = m == null ? void 0 : m.userId, n = m == null ? void 0 : m.token);
    }
    let u = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    };
    const f = `${t}api/entities/${e}/users/${r}/conversation/user/feedback?conversationId=${i}`;
    let d = await Oe.post(f, { feedbackRate: o }, { headers: u });
    return console.log(d), d.data;
  } catch (u) {
    return u == null ? void 0 : u.response.data;
  }
}, Pke = async (t, e, r, n, A, i, o, s, a) => {
  try {
    if (i || o) {
      let g = await new Bt("", s).getExternalLogin({
        apiType: s,
        uniqueUserId: i,
        entityId: e,
        userId: r,
        apiKey: A,
        apiSecret: "",
        token: n,
        uniqueEmailId: o,
        entityAuthenticationToken: a
      });
      g != null && g.userId && (r = g == null ? void 0 : g.userId, n = g == null ? void 0 : g.token);
    }
    let c = {
      userId: r,
      token: n,
      entityId: e,
      apikey: A
    };
    const l = window.location.href, u = `${t}api/entities/${e}/users/${r}/conversation/admin/getUserQuestion?websiteUrl=${l}`;
    let f = await Oe(u, { headers: c });
    return console.log(f), f.data;
  } catch (c) {
    return c == null ? void 0 : c.response.data;
  }
}, kke = async ({
  entityId: t,
  userId: e,
  token: r,
  apiKey: n,
  uniqueUserId: A,
  uniqueEmailId: i,
  apiType: o,
  entityAuthenticationToken: s
}) => {
  var a, c;
  try {
    if (A || i) {
      let u = await new Bt("", o).getExternalLogin({
        apiType: o,
        uniqueUserId: A,
        entityId: t,
        userId: e,
        apiKey: n,
        apiSecret: "",
        token: r,
        uniqueEmailId: i,
        entityAuthenticationToken: s
      });
      u != null && u.userId && (e = u == null ? void 0 : u.userId, r = u == null ? void 0 : u.token);
    }
    return { success: !0, data: { userId: e, token: r } };
  } catch (l) {
    return console.log(l), {
      success: !1,
      error: ((c = (a = l == null ? void 0 : l.response) == null ? void 0 : a.data) == null ? void 0 : c.error) || "Internal Server Error. Please contact Help Center in Discord."
    };
  }
}, am = (t) => {
  var S, P, H, F, T, U, D, Q, Y, j, Z, W, R, K, L, G, V, _, J, X, ne, ee, $, te, ae, se, ue, fe, ve, ge, oe, ce, pe, qe, Se, Te, be, He, Ge, Le, Ae, Pe, it, de;
  const {
    questsData: e,
    setSelectedSection: r,
    parentQuest: n,
    userId: A,
    token: i,
    styleConfig: o,
    contentConfig: s,
    taskStatus: a,
    onlineComponent: c,
    showFeedback: l = !0,
    setShowFeedback: u,
    entityImage: f,
    uniqueUserId: d,
    uniqueEmailId: g,
    entityAuthenticationToken: m,
    BrandTheme: p,
    QuestThemeData: v,
    contentData: C
  } = t, [w, B] = N([]), { apiKey: y, entityId: b, apiType: q, themeConfig: E } = Xe(
    ct.Context
  );
  let x = q == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, [M, O] = N(!1);
  le(() => {
    var xe, he;
    B(e), e != null && e.length && ((xe = e[3]) != null && xe.filter((Qe) => Qe.completed === !0).map((Qe) => Qe.criteriaId)), c ? u && u(
      !!(e != null && e.length) && !!e[0][0] && ((he = e[0][0]) == null ? void 0 : he.completed) == !1
    ) : u && u(l);
  }, [e]);
  const I = async (xe) => {
    var he;
    if (O(!0), c) {
      let Qe = await dy(
        x,
        b,
        (n == null ? void 0 : n.childCampaignActions[0].campaignId) || "",
        A || "",
        i || "",
        y,
        (he = w[0][0]) == null ? void 0 : he.criteriaId,
        n == null ? void 0 : n.childCampaignActions[0].campaignVariationId,
        [xe],
        d,
        g,
        q,
        m
      );
      O(!1), Qe != null && Qe.success && u && u(!1);
    } else
      u && u(!1);
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: "helpHubMainInnerCont animatedDissolve",
      style: (S = o == null ? void 0 : o.Home) == null ? void 0 : S.Form,
      children: [
        /* @__PURE__ */ k(
          "div",
          {
            className: "MainImgCont",
            style: {
              background: (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.accentColor) || ((H = (P = o == null ? void 0 : o.Home) == null ? void 0 : P.Banner) == null ? void 0 : H.background),
              ...(F = o == null ? void 0 : o.Home) == null ? void 0 : F.Banner
            },
            children: [
              /* @__PURE__ */ h("div", { className: "QuestWhiteLogoCont", children: f && /* @__PURE__ */ h("img", { src: f }) }),
              /* @__PURE__ */ k("div", { className: "helpHubTextCont", children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "helpHubHelloHead",
                    style: {
                      fontFamily: (p == null ? void 0 : p.fontFamily) || (E == null ? void 0 : E.fontFamily),
                      color: p == null ? void 0 : p.titleColor,
                      ...(T = o == null ? void 0 : o.Home) == null ? void 0 : T.BannerText
                    },
                    children: "Hello there 👋🏻"
                  }
                ),
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "helpHubHelpHead",
                    style: {
                      fontFamily: (p == null ? void 0 : p.fontFamily) || (E == null ? void 0 : E.fontFamily),
                      color: p == null ? void 0 : p.titleColor,
                      ...(U = o == null ? void 0 : o.Home) == null ? void 0 : U.BannerText
                    },
                    children: "How can we help?"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ k("div", { style: { width: "100%" }, className: "q-helphub-InnerCont", children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: "SendMessageCont",
              style: {
                background: E == null ? void 0 : E.backgroundColor,
                ...(D = o == null ? void 0 : o.Home) == null ? void 0 : D.Card,
                borderColor: E == null ? void 0 : E.borderColor
              },
              children: [
                /* @__PURE__ */ h("div", { className: "CustomerServiceCont", children: /* @__PURE__ */ k(
                  "div",
                  {
                    className: "CustomerServiceInnerCont",
                    style: {
                      background: kc(v == null ? void 0 : v.accentColor)
                    },
                    children: [
                      /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          children: [
                            /* @__PURE__ */ h(
                              "path",
                              {
                                opacity: "0.4",
                                d: "M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z",
                                fill: v != null && v.accentColor ? PA(v.accentColor, -0.5).darker : "#9035FF"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "path",
                              {
                                d: "M22.0003 12.8603C22.0003 15.1503 20.8203 17.1803 19.0003 18.4603L17.6603 21.4103C17.3503 22.0803 16.4503 22.2103 15.9803 21.6403L14.5003 19.8603C12.0803 19.8603 9.92031 18.7903 8.57031 17.1203L9.50031 16.0003C13.6403 16.0003 17.0003 12.8703 17.0003 9.00031C17.0003 7.95031 16.7503 6.96031 16.3003 6.07031C19.5703 6.82031 22.0003 9.58029 22.0003 12.8603Z",
                                fill: v != null && v.accentColor ? PA(v.accentColor, -0.5).darker : "#9035FF"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "path",
                              {
                                d: "M12 9.75H7C6.59 9.75 6.25 9.41 6.25 9C6.25 8.59 6.59 8.25 7 8.25H12C12.41 8.25 12.75 8.59 12.75 9C12.75 9.41 12.41 9.75 12 9.75Z",
                                fill: v != null && v.accentColor ? PA(v.accentColor, -0.5).darker : "#9035FF"
                              }
                            )
                          ]
                        }
                      ) }),
                      /* @__PURE__ */ h(
                        "p",
                        {
                          style: {
                            fontFamily: E == null ? void 0 : E.fontFamily,
                            color: v != null && v.accentColor ? PA(v.accentColor, -0.5).darker : ""
                          },
                          children: "Customer Service"
                        }
                      )
                    ]
                  }
                ) }),
                /* @__PURE__ */ k("div", { className: "CustomerServiceSendMessageTextCont", children: [
                  /* @__PURE__ */ h(
                    "p",
                    {
                      className: "CustomerServiceHead",
                      style: {
                        color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                        fontFamily: (p == null ? void 0 : p.fontFamily) || (E == null ? void 0 : E.fontFamily),
                        ...(Q = o == null ? void 0 : o.Home) == null ? void 0 : Q.Heading
                      },
                      children: ((Y = s == null ? void 0 : s.chatButton) == null ? void 0 : Y.heading) || "Send us a message"
                    }
                  ),
                  /* @__PURE__ */ h(
                    "p",
                    {
                      className: "CustomerServiceDesc",
                      style: {
                        color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                        ...(j = o == null ? void 0 : o.Home) == null ? void 0 : j.SubHeading,
                        fontFamily: (p == null ? void 0 : p.fontFamily) || (E == null ? void 0 : E.fontFamily)
                      },
                      children: ((Z = s == null ? void 0 : s.chatButton) == null ? void 0 : Z.subHeading) || "Let us help with all your questions"
                    }
                  )
                ] }),
                /* @__PURE__ */ h("div", { className: "SendMessageButtonCont", children: /* @__PURE__ */ k(
                  "div",
                  {
                    className: "SendMessageButton",
                    onClick: () => r("Chat"),
                    style: {
                      background: ((R = (W = o == null ? void 0 : o.Home) == null ? void 0 : W.Button) == null ? void 0 : R.background) || (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.primaryButton) || (E == null ? void 0 : E.buttonColor)
                    },
                    children: [
                      /* @__PURE__ */ h(
                        "p",
                        {
                          style: {
                            fontFamily: (p == null ? void 0 : p.fontFamily) || (E == null ? void 0 : E.fontFamily),
                            color: (L = (K = o == null ? void 0 : o.Home) == null ? void 0 : K.Button) == null ? void 0 : L.color
                          },
                          children: "Message Now"
                        }
                      ),
                      /* @__PURE__ */ h("img", { src: sm, alt: "" })
                    ]
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-helphub-quest-community-cont",
              style: {
                background: E == null ? void 0 : E.backgroundColor,
                ...(G = o == null ? void 0 : o.Home) == null ? void 0 : G.Card,
                borderColor: E == null ? void 0 : E.borderColor
              },
              onClick: () => {
                var xe, he, Qe, Re;
                ((xe = s == null ? void 0 : s.box1) != null && xe.link || (he = C == null ? void 0 : C.Home) != null && he.link) && window.open(((Qe = s == null ? void 0 : s.box1) == null ? void 0 : Qe.link) || ((Re = C == null ? void 0 : C.Home) == null ? void 0 : Re.link), "_blank");
              },
              children: [
                /* @__PURE__ */ h("div", { className: "q-helphub-quest-community-imageCont", children: /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q-helphub-quest-community-quest-image",
                    style: { background: v == null ? void 0 : v.accentColor },
                    children: /* @__PURE__ */ h("img", { src: ((V = s == null ? void 0 : s.box1) == null ? void 0 : V.image) || ((_ = C == null ? void 0 : C.Home) == null ? void 0 : _.image) || gke })
                  }
                ) }),
                /* @__PURE__ */ k("div", { className: "q-helphub-quest-community-descCont", children: [
                  /* @__PURE__ */ k(
                    "div",
                    {
                      className: "q-helphub-quest-community-desc",
                      style: {
                        color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                        ...(J = o == null ? void 0 : o.Home) == null ? void 0 : J.Heading
                      },
                      children: [
                        /* @__PURE__ */ h(
                          "p",
                          {
                            style: {
                              color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                              ...(X = o == null ? void 0 : o.Home) == null ? void 0 : X.Heading
                            },
                            children: ((ne = s == null ? void 0 : s.box1) == null ? void 0 : ne.heading) || ((ee = C == null ? void 0 : C.Home) == null ? void 0 : ee.title) || "The Questlabs community"
                          }
                        ),
                        /* @__PURE__ */ h("img", { src: l1, alt: "" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-helphub-quest-community-full-desc",
                      style: {
                        color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                        ...($ = o == null ? void 0 : o.Home) == null ? void 0 : $.SubHeading
                      },
                      children: ((te = s == null ? void 0 : s.box1) == null ? void 0 : te.subHeading) || ((ae = C == null ? void 0 : C.Home) == null ? void 0 : ae.description) || "Be sure to check out the Quest labs community for support, plus tips & tricks from Quest users and much more coming soon"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-helhub-search-community",
              style: {
                background: E == null ? void 0 : E.backgroundColor,
                ...(se = o == null ? void 0 : o.Home) == null ? void 0 : se.Card,
                borderColor: E == null ? void 0 : E.borderColor
              },
              children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "search-input",
                    onClick: () => r("Help"),
                    children: /* @__PURE__ */ k("div", { className: "q-helphub-search-input-cont", children: [
                      /* @__PURE__ */ h(
                        "input",
                        {
                          className: "q-helphub-search-input",
                          placeholder: "Search for help..."
                        }
                      ),
                      /* @__PURE__ */ h("div", { children: /* @__PURE__ */ k(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                          children: [
                            /* @__PURE__ */ k("g", { clipPath: "url(#clip0_4762_1863)", children: [
                              /* @__PURE__ */ h(
                                "circle",
                                {
                                  cx: "7.66671",
                                  cy: "7.66659",
                                  r: "6.33333",
                                  stroke: "#B9B9B9",
                                  strokeWidth: "1.5"
                                }
                              ),
                              /* @__PURE__ */ h(
                                "path",
                                {
                                  d: "M13.3334 13.3333L14.6667 14.6666",
                                  stroke: "#B9B9B9",
                                  strokeWidth: "1.5",
                                  strokeLinecap: "round"
                                }
                              )
                            ] }),
                            /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_4762_1863", children: /* @__PURE__ */ h("rect", { width: "16", height: "16", fill: "white" }) }) })
                          ]
                        }
                      ) })
                    ] })
                  }
                ),
                /* @__PURE__ */ h("div", { className: "q-helphub-search-messege", children: !!(w != null && w.length) && ((ue = w[1]) == null ? void 0 : ue.map(
                  (xe, he) => {
                    var Qe, Re;
                    return /* @__PURE__ */ k(
                      "div",
                      {
                        className: "q-helphub-search-messege-cont",
                        onClick: () => r("Help"),
                        style: {
                          borderBottom: ((Qe = w[1]) == null ? void 0 : Qe.length) - 1 == he ? "none" : "1px solid var(--Neutral-White-300, #efefef)"
                        },
                        children: [
                          /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q-helphub-search-messege-title",
                              style: {
                                color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                                ...(Re = o == null ? void 0 : o.Home) == null ? void 0 : Re.SubHeading
                              },
                              children: xe == null ? void 0 : xe.question
                            }
                          ),
                          /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
                            "svg",
                            {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 16 16",
                              fill: "none",
                              children: /* @__PURE__ */ h(
                                "path",
                                {
                                  fillRule: "evenodd",
                                  clipRule: "evenodd",
                                  d: "M5.67461 2.95363C5.88428 2.77392 6.19993 2.7982 6.37964 3.00787L10.3796 7.67453C10.5401 7.86178 10.5401 8.13808 10.3796 8.32532L6.37964 12.992C6.19993 13.2017 5.88428 13.2259 5.67461 13.0462C5.46495 12.8665 5.44067 12.5509 5.62038 12.3412L9.34147 7.99993L5.62038 3.65866C5.44067 3.44899 5.46495 3.13334 5.67461 2.95363Z",
                                  fill: "#B9B9B9"
                                }
                              )
                            }
                          ) })
                        ]
                      },
                      he
                    );
                  }
                )) })
              ]
            }
          ),
          /* @__PURE__ */ h("div", { className: "q-helphub-update-mainCont", children: /* @__PURE__ */ k(
            "div",
            {
              className: "q-helphub-search-updates",
              style: {
                background: E == null ? void 0 : E.backgroundColor,
                ...(fe = o == null ? void 0 : o.Home) == null ? void 0 : fe.Card,
                borderColor: E == null ? void 0 : E.borderColor
              },
              children: [
                /* @__PURE__ */ k(
                  "div",
                  {
                    className: "q-helphub-updates-innercont",
                    onClick: () => r("Updates"),
                    children: [
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "q-helphub-quest-community-desc",
                          style: {
                            color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                            ...(ve = o == null ? void 0 : o.Home) == null ? void 0 : ve.Heading,
                            fontSize: "18px"
                          },
                          children: /* @__PURE__ */ h(
                            "p",
                            {
                              style: {
                                color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor)
                              },
                              children: "Get Updates"
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ h("div", { className: "q-helphub-updates-desc", children: !!(w != null && w.length) && ((ge = w[2]) == null ? void 0 : ge.map(
                        (xe, he) => {
                          var Qe, Re;
                          return he < 2 && /* @__PURE__ */ k(
                            "div",
                            {
                              className: `q-helphub-updates-innerCont${he + 1}`,
                              children: [
                                /* @__PURE__ */ h(
                                  "div",
                                  {
                                    style: {
                                      color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                                      ...(Qe = o == null ? void 0 : o.Home) == null ? void 0 : Qe.Heading
                                    },
                                    children: xe == null ? void 0 : xe.linkTitle
                                  }
                                ),
                                /* @__PURE__ */ h(
                                  "div",
                                  {
                                    style: {
                                      color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                                      ...(Re = o == null ? void 0 : o.Home) == null ? void 0 : Re.SubHeading
                                    },
                                    children: xe == null ? void 0 : xe.description
                                  }
                                )
                              ]
                            },
                            he
                          );
                        }
                      )) })
                    ]
                  }
                ),
                /* @__PURE__ */ h(
                  "button",
                  {
                    className: "q-helphub-updates-button",
                    onClick: () => r("Updates"),
                    style: {
                      background: (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.primaryButton) || (E == null ? void 0 : E.buttonColor),
                      fontFamily: (p == null ? void 0 : p.fontFamily) || (E == null ? void 0 : E.fontFamily),
                      ...(oe = o == null ? void 0 : o.Home) == null ? void 0 : oe.Button
                    },
                    children: "See all updates"
                  }
                )
              ]
            }
          ) }),
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-helphub-compProfile",
              style: {
                background: E == null ? void 0 : E.backgroundColor,
                ...(ce = o == null ? void 0 : o.Home) == null ? void 0 : ce.Card,
                borderColor: E == null ? void 0 : E.borderColor
              },
              onClick: () => r("Tasks"),
              children: [
                /* @__PURE__ */ k("div", { className: "q-helphub-compProfile-heading-cont", children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-helphub-compProfile-heading-text",
                      style: {
                        color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                        ...(pe = o == null ? void 0 : o.Home) == null ? void 0 : pe.Heading
                      },
                      children: ((qe = s == null ? void 0 : s.box4) == null ? void 0 : qe.heading) || "Complete your profile"
                    }
                  ),
                  /* @__PURE__ */ h(
                    "svg",
                    {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      children: /* @__PURE__ */ h(
                        "path",
                        {
                          fillRule: "evenodd",
                          clipRule: "evenodd",
                          d: "M5.67461 2.95363C5.88428 2.77392 6.19993 2.7982 6.37964 3.00787L10.3796 7.67453C10.5401 7.86178 10.5401 8.13808 10.3796 8.32532L6.37964 12.992C6.19993 13.2017 5.88428 13.2259 5.67461 13.0462C5.46495 12.8665 5.44067 12.5509 5.62038 12.3412L9.34147 7.99993L5.62038 3.65866C5.44067 3.44899 5.46495 3.13334 5.67461 2.95363Z",
                          fill: "#B9B9B9"
                        }
                      )
                    }
                  )
                ] }),
                /* @__PURE__ */ k("div", { className: "q-helphub-compProfile-progress-con", children: [
                  /* @__PURE__ */ k(
                    "div",
                    {
                      className: "q-helphub-compProfile-progress-per",
                      style: {
                        color: (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.tertiaryColor)
                      },
                      children: [
                        a || 0,
                        "% Completed"
                      ]
                    }
                  ),
                  /* @__PURE__ */ h("div", { className: "q-helphub-compProfile-progress-bar-con", children: /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-helphub-compProfile-progress-bar",
                      style: {
                        width: `${a || 0}%`,
                        background: (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.secondaryColor)
                      }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q-helphub-compProfile-para-text",
                    style: {
                      color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                      ...(Se = o == null ? void 0 : o.Home) == null ? void 0 : Se.SubHeading
                    },
                    children: ((Te = s == null ? void 0 : s.box4) == null ? void 0 : Te.subHeading) || ((be = C == null ? void 0 : C.Home) == null ? void 0 : be.completeDescription) || "Be sure to check out the Quest labs community for support, plus tips & tricks from Quest users"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ k(
            "div",
            {
              className: `q-helphub-review ${l && "q-show-feedback"}`,
              style: {
                background: E == null ? void 0 : E.backgroundColor,
                ...(He = o == null ? void 0 : o.Home) == null ? void 0 : He.Card,
                borderColor: E == null ? void 0 : E.borderColor
              },
              children: [
                /* @__PURE__ */ k("div", { className: "q-helphub-review-text-emoji-cont", children: [
                  /* @__PURE__ */ k("div", { className: "q-helphub-review-text-con", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-helphub-review-text-head",
                        style: {
                          color: (p == null ? void 0 : p.primaryColor) || (E == null ? void 0 : E.primaryColor),
                          ...(Ge = o == null ? void 0 : o.Home) == null ? void 0 : Ge.Heading
                        },
                        children: ((Le = s == null ? void 0 : s.box5) == null ? void 0 : Le.heading) || "How satisfied are you?"
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-helphub-review-text-para",
                        style: {
                          color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                          ...(Ae = o == null ? void 0 : o.Home) == null ? void 0 : Ae.SubHeading
                        },
                        children: ((Pe = s == null ? void 0 : s.box5) == null ? void 0 : Pe.subHeading) || "How would you rate this journey after using the product after so long?"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ k("div", { className: "q-helphub-review-emoji-caption-con", children: [
                    /* @__PURE__ */ h("div", { className: "q-helphub-review-emoji-cont", children: [
                      mke,
                      vke,
                      qke,
                      yke,
                      Cke
                    ].map((xe, he) => /* @__PURE__ */ h(
                      "img",
                      {
                        src: xe,
                        alt: "",
                        onClick: () => I(he + 1)
                      },
                      he
                    )) }),
                    /* @__PURE__ */ k("div", { className: "q-helphub-review-emoji-caption", children: [
                      /* @__PURE__ */ h(
                        "div",
                        {
                          style: {
                            color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                            ...(it = o == null ? void 0 : o.Home) == null ? void 0 : it.SubHeading
                          },
                          children: "Not satisfied"
                        }
                      ),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          style: {
                            color: (p == null ? void 0 : p.secondaryColor) || (E == null ? void 0 : E.secondaryColor),
                            ...(de = o == null ? void 0 : o.Home) == null ? void 0 : de.SubHeading
                          },
                          children: "Very satisfied"
                        }
                      )
                    ] })
                  ] })
                ] }),
                M && /* @__PURE__ */ h("div", { className: "q-helphub-review-loader-con", children: /* @__PURE__ */ h("div", { className: "q-helphub-review-loader" }) })
              ]
            }
          )
        ] })
      ]
    }
  );
}, Oke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M7.40465%202.80218C9.85691%200.454834%2013.822%200.454834%2016.2742%202.80218C18.7419%205.16429%2018.7419%209.00582%2016.2742%2011.3679L9.65086%2017.7079C7.90914%2019.3751%205.0961%2019.3751%203.35438%2017.7079C1.59724%2016.026%201.59724%2013.2872%203.35438%2011.6052L9.88246%205.35643C10.9136%204.36937%2012.5747%204.36938%2013.6058%205.35643C14.6524%206.35825%2014.6524%207.99431%2013.6058%208.99612L7.0301%2015.2905C6.78074%2015.5292%206.38511%2015.5206%206.14643%2015.2712C5.90774%2015.0219%205.91639%2014.6262%206.16574%2014.3875L12.7415%208.09313C13.2739%207.58351%2013.2739%206.76904%2012.7415%206.25942C12.1937%205.73505%2011.2946%205.73505%2010.7468%206.25942L4.21873%2012.5082C2.97579%2013.698%202.97579%2015.6152%204.21873%2016.8049C5.47709%2018.0095%207.52814%2018.0095%208.7865%2016.8049L15.4099%2010.4649C17.3634%208.59502%2017.3634%205.57509%2015.4099%203.70517C13.441%201.8205%2010.2379%201.8205%208.269%203.70517L2.93218%208.81367C2.68283%209.05236%202.28719%209.04371%202.04851%208.79436C1.80982%208.545%201.81847%208.14937%202.06782%207.91068L7.40465%202.80218Z'%20fill='%23939393'/%3e%3c/svg%3e", a9 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%3e%3cpath%20d='M4.50513%2011.4957L8.00046%208.00034L11.4958%2011.4957M11.4958%204.505L7.99979%208.00034L4.50513%204.505'%20stroke='%23939393'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", oj = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6279_183)'%3e%3ccircle%20cx='7.66671'%20cy='7.66671'%20r='6.33333'%20stroke='%23B9B9B9'%20stroke-width='1.5'/%3e%3cpath%20d='M13.3334%2013.3334L14.6667%2014.6667'%20stroke='%23B9B9B9'%20stroke-width='1.5'%20stroke-linecap='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6279_183'%3e%3crect%20width='16'%20height='16'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Fke = "data:image/svg+xml,%3csvg%20width='18'%20height='18'%20viewBox='0%200%2018%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='vuesax/bold/trash'%3e%3cg%20id='trash'%3e%3cpath%20id='Vector'%20d='M15.8027%203.9225C14.5952%203.8025%2013.3877%203.7125%2012.1727%203.645V3.6375L12.0077%202.6625C11.8952%201.9725%2011.7302%200.9375%209.97524%200.9375H8.01024C6.26274%200.9375%206.09774%201.9275%205.97774%202.655L5.82024%203.615C5.12274%203.66%204.42524%203.705%203.72774%203.7725L2.19774%203.9225C1.88274%203.9525%201.65774%204.23%201.68774%204.5375C1.71774%204.845%201.98774%205.07%202.30274%205.04L3.83274%204.89C7.76274%204.5%2011.7227%204.65%2015.6977%205.0475C15.7202%205.0475%2015.7352%205.0475%2015.7577%205.0475C16.0427%205.0475%2016.2902%204.83%2016.3202%204.5375C16.3427%204.23%2016.1177%203.9525%2015.8027%203.9225Z'%20fill='%23ED0A34'/%3e%3cpath%20id='Vector_2'%20d='M14.4228%206.105C14.2428%205.9175%2013.9953%205.8125%2013.7403%205.8125H4.2603C4.0053%205.8125%203.7503%205.9175%203.5778%206.105C3.4053%206.2925%203.3078%206.5475%203.3228%206.81L3.7878%2014.505C3.8703%2015.645%203.9753%2017.07%206.5928%2017.07H11.4078C14.0253%2017.07%2014.1303%2015.6525%2014.2128%2014.505L14.6778%206.8175C14.6928%206.5475%2014.5953%206.2925%2014.4228%206.105ZM10.2453%2013.3125H7.7478C7.4403%2013.3125%207.1853%2013.0575%207.1853%2012.75C7.1853%2012.4425%207.4403%2012.1875%207.7478%2012.1875H10.2453C10.5528%2012.1875%2010.8078%2012.4425%2010.8078%2012.75C10.8078%2013.0575%2010.5528%2013.3125%2010.2453%2013.3125ZM10.8753%2010.3125H7.1253C6.8178%2010.3125%206.5628%2010.0575%206.5628%209.75C6.5628%209.4425%206.8178%209.1875%207.1253%209.1875H10.8753C11.1828%209.1875%2011.4378%209.4425%2011.4378%209.75C11.4378%2010.0575%2011.1828%2010.3125%2010.8753%2010.3125Z'%20fill='%23ED0A34'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", Tke = "data:image/svg+xml,%3csvg%20width='18'%20height='18'%20viewBox='0%200%2018%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='vuesax/bold/image'%3e%3cg%20id='image'%3e%3cpath%20id='Vector'%20d='M16.515%2012.615L14.1675%207.12495C13.74%206.11995%2013.1025%205.54995%2012.375%205.51245C11.655%205.47495%2010.9575%205.97745%2010.425%206.93745L8.99998%209.49495C8.69998%2010.035%208.27248%2010.3575%207.80748%2010.395C7.33498%2010.44%206.86248%2010.1925%206.47998%209.70495L6.31498%209.49495C5.78248%208.82745%205.12248%208.50495%204.44748%208.57245C3.77248%208.63995%203.19498%209.10495%202.81248%209.86245L1.51498%2012.45C1.04998%2013.3875%201.09498%2014.475%201.64248%2015.36C2.18998%2016.245%203.14248%2016.7775%204.18498%2016.7775H13.755C14.76%2016.7775%2015.6975%2016.275%2016.2525%2015.435C16.8225%2014.595%2016.9125%2013.5375%2016.515%2012.615Z'%20fill='%234C4C4C'/%3e%3cpath%20id='Vector_2'%20d='M5.22738%206.28497C6.62742%206.28497%207.76238%205.15001%207.76238%203.74997C7.76238%202.34992%206.62742%201.21497%205.22738%201.21497C3.82734%201.21497%202.69238%202.34992%202.69238%203.74997C2.69238%205.15001%203.82734%206.28497%205.22738%206.28497Z'%20fill='%234C4C4C'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", $l = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%3e%3cpath%20d='M26.25%201.75V9.91667L18.0833%2018.0833V9.91667H9.91667V15.3084C9.91667%2016.8413%2011.1587%2018.0833%2012.6916%2018.0833H18.0833L9.91667%2026.25C5.40629%2026.25%201.75%2022.5937%201.75%2018.0833V1.75H26.25Z'%20fill='white'/%3e%3cpath%20d='M26.25%2018.0833H18.0833V26.25H26.25V18.0833Z'%20fill='white'/%3e%3c/svg%3e", Mke = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='vuesax/bold/like'%3e%3cg%20id='like'%3e%3cpath%20id='Vector'%20d='M6.9917%2015.4084V6.94169C6.9917%206.60835%207.0917%206.28335%207.27503%206.00835L9.55003%202.62502C9.90837%202.08335%2010.8%201.70002%2011.5584%201.98335C12.375%202.25835%2012.9167%203.17502%2012.7417%203.99169L12.3084%206.71669C12.275%206.96669%2012.3417%207.19169%2012.4834%207.36669C12.625%207.52502%2012.8334%207.62502%2013.0584%207.62502H16.4834C17.1417%207.62502%2017.7084%207.89169%2018.0417%208.35835C18.3584%208.80835%2018.4167%209.39169%2018.2084%209.98335L16.1584%2016.225C15.9%2017.2584%2014.775%2018.1%2013.6584%2018.1H10.4084C9.85003%2018.1%209.0667%2017.9084%208.70837%2017.55L7.6417%2016.725C7.23337%2016.4167%206.9917%2015.925%206.9917%2015.4084Z'%20fill='%230DC268'/%3e%3cpath%20id='Vector_2'%20d='M4.3415%205.31665H3.48317C2.1915%205.31665%201.6665%205.81665%201.6665%207.04998V15.4333C1.6665%2016.6667%202.1915%2017.1667%203.48317%2017.1667H4.3415C5.63317%2017.1667%206.15817%2016.6667%206.15817%2015.4333V7.04998C6.15817%205.81665%205.63317%205.31665%204.3415%205.31665Z'%20fill='%230DC268'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", Hke = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='vuesax/bold/dislike'%3e%3cg%20id='dislike'%3e%3cpath%20id='Vector'%20d='M13.0082%204.58327V13.0499C13.0082%2013.3833%2012.9082%2013.7083%2012.7249%2013.9833L10.4499%2017.3666C10.0915%2017.9083%209.19985%2018.2916%208.44152%2018.0083C7.62485%2017.7333%207.08318%2016.8166%207.25818%2015.9999L7.69152%2013.2749C7.72485%2013.0249%207.65818%2012.7999%207.51652%2012.6249C7.37485%2012.4666%207.16652%2012.3666%206.94152%2012.3666H3.51652C2.85818%2012.3666%202.29152%2012.0999%201.95818%2011.6333C1.64152%2011.1833%201.58318%2010.5999%201.79152%2010.0083L3.84152%203.7666C4.09985%202.73327%205.22485%201.8916%206.34152%201.8916H9.59152C10.1499%201.8916%2010.9332%202.08327%2011.2915%202.4416L12.3582%203.2666C12.7665%203.58327%2013.0082%204.0666%2013.0082%204.58327Z'%20fill='%23ED0A34'/%3e%3cpath%20id='Vector_2'%20d='M15.6585%2014.6749H16.5168C17.8085%2014.6749%2018.3335%2014.1749%2018.3335%2012.9416V4.56659C18.3335%203.33325%2017.8085%202.83325%2016.5168%202.83325H15.6585C14.3668%202.83325%2013.8418%203.33325%2013.8418%204.56659V12.9499C13.8418%2014.1749%2014.3668%2014.6749%2015.6585%2014.6749Z'%20fill='%23ED0A34'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", uP = "data:image/svg+xml,%3csvg%20width='14'%20height='14'%20viewBox='0%200%2014%2014'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Frame%201000001790'%3e%3crect%20x='0.5'%20y='0.5'%20width='13'%20height='13'%20rx='6.5'%20fill='%239035FF'/%3e%3crect%20x='0.5'%20y='0.5'%20width='13'%20height='13'%20rx='6.5'%20stroke='white'/%3e%3cpath%20id='Vector'%20d='M9.82478%205.41875H9.33746L9.82478%204.4731L9.33746%204.23655L8.36224%205.41818H7.26534V4.70909L7.87436%204.47254V4L5.9245%204.00055V4.47309L6.53409%204.70964V5.41873H5.43719L4.46254%204.23711L3.97465%204.47311L4.46254%205.41875H3.97465C3.43648%205.41875%203%205.84143%203%206.36439V7.30948C3%208.61464%204.09004%209.67273%205.43717%209.67273H8.36224C9.70994%209.67273%2010.8%208.61464%2010.8%207.30948V6.36439C10.8%205.84143%2010.363%205.41875%209.82478%205.41875ZM5.55885%207.782C5.22178%207.782%204.94984%207.51775%204.94984%207.1909C4.94984%206.86405%205.22178%206.5998%205.55885%206.5998C5.89593%206.5998%206.16844%206.86405%206.16844%207.1909C6.16844%207.5183%205.8965%207.782%205.55885%207.782ZM8.24056%207.782C7.90349%207.782%207.63155%207.51775%207.63155%207.1909C7.63155%206.86405%207.90349%206.5998%208.24056%206.5998C8.57763%206.5998%208.85015%206.86405%208.85015%207.1909C8.85015%207.5183%208.57763%207.782%208.24056%207.782Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", Dke = "data:audio/mpeg;base64,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", Qke = "data:audio/wav;base64,UklGRspyAwBXQVZFZm10IBAAAAABAAIARKwAABCxAgAEABAAYmV4dFwCAABUaGlzIGlzIGEgc291bmQgZWZmZWN0IGZyb20gdGhlIEVwaWMgU3RvY2sgTWVkaWEgRXhwbGFpbmVyIFZpZGVvIFNGWCBzb3VuZCBsaWJyYXJ5LgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZGF0YdxJAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQACAAIAAwADAAQABQAFAAUABwAHAAcABwAHAAcABwAHAAcABwAEAAQABAAEAAAAAAD9//3/+f/5//T/9P/t/+3/5//n/9//3//W/9b/zP/M/8H/wf+2/7b/q/+r/57/nv+U/5T/h/+H/33/ff9x/3H/af9p/2H/Yf9Z/1n/Uv9S/1D/UP9M/0z/S/9L/0v/S/9O/07/UP9Q/1j/WP9k/2T/cv9y/4T/hP+b/5v/t/+3/8n/yf/t/+3/AQABACQAJAA/AD8AZABkAH0AfQCUAJMAsgCyAMQAwwDkAOQA/wD/ABMBEgEuAS0BQwFDAVEBUQFWAVYBbAFrAW4BbQF1AXUBegF6AW0BbAFdAV0BTwFPATQBMwEgAR8B/wD/AOYA5gDOAM0AowCjAHkAeQBOAE0AFwAWAOr/6f/B/8D/m/+a/3T/c/8+/z7/Dv8O/8/+zv6n/qf+c/5y/lP+Uv46/jr+Ef4R/vj99/3h/eD9w/3C/a/9rv2z/bP9qf2p/Z/9n/25/bj9sf2w/cD9wP3N/c395P3j/Rj+GP4n/if+Xf5d/pD+kP7C/sL++v76/jb/Nf92/3b/y//L//X/9f9LAEoAkwCTAMAAvwAFAQUBQAFAAX4BfQHQAdABBgIFAj4CPQJsAmwCmAKYArsCuwLkAuQCAQMAAxMDEgNGA0UDVwNXA1kDWgNHA0cDJgMmA/gC9wLHAsYCswKyApMCkwJ6AnkCTgJOAi0CLQLXAdcBogGiAUIBQgH6APoAvQC9AIgAiAAdAB0Aq/+r/2f/Z//9/v3+tv62/mz+bP4q/ir+7f3t/cT9xP2C/YL9a/1r/UP9Q/0j/SP98fzx/AT9BP3a/Nr81PzU/Or86vwD/QT9Ev0S/Uz9TP1e/V79qP2o/eP94/0o/ij+Z/5m/r7+vv4a/xr/XP9c/8D/wP8WABcAawBsAL0AvgAAAQABbAFsAagBqAHwAfABQAJAAo0CjQLOAs8CGAMZAykDKQNtA20DlAOUA4oDiwOzA7QDnQOdA68DsAOeA58DiwOMA4EDggNSA1IDTgNPAwcDCAPUAtUCmgKbAlECUQIoAikCnwGfAX0BfgEBAQEBpQCmAEsATADi/+P/g/+D/yj/KP/W/tb+kP6Q/j7+P/7z/fP9uP24/aP9o/1A/T/9Lf0t/eD83/zf/N/8pfyk/KP8o/y1/LX8ovyh/K78rvzX/Nb8Jv0m/Sz9K/14/Xj9nv2d/Q3+Df5Q/k/+jP6L/vn++P5N/03/kP+P//T/9P9FAEQAlACTAPoA+gArASoBnwGfAckByAEmAiYCRQJEAnUCdQKEAoMC1wLXAusC6gINAw0D8ALvAuQC5AK7AroCmwKaAo8CjgJSAlACaQJoAj0CPAI8AjwC1AHSAdwB3AGPAY8BZAFjASQBJAHJAMgAnACbAEcARgDN/8v/qP+o/zf/Nv/t/uz+l/6W/mH+YP4z/jP+/P38/bP9sv2m/ab9e/17/Wn9af1Q/VD9Z/1n/SD9Hv0y/TH9Lv0t/VH9UP0l/ST9Wv1Z/aD9oP3j/eP9vv28/ez96/0L/gr+Sv5J/mf+Zv6D/oH+tv60/r/+vP4Y/xb/2/7Y/uT+4f4R/w7/Kf8m/0T/QP+d/5r/cP9t/7r/uP/W/9T/IQAfAAwACADK/8X/qf+j/4z/hv9I/0H/mP+S//v/9/9RAE4AowCiAL0AvACsAKwAzwDPAMAAwQDbANwAtgC3ALUAtgB6AHsAjQCOACgAJwA0ADUA5f/l/83/zv+//7//e/97/4v/jP8w/zH/Qv9D/8b+xv7Q/tD+lv6V/pL+kf7S/tP+Uv5S/kL+Q/5I/kn+Rv5H/jf+N/4D/gP+x/3H/f39/v3h/eH91P3V/dP91P0B/gL+Nv44/lP+Vv4o/ir+ff6A/oP+hv5i/mT+/f4A/+L+5f7y/vT+Bf8I/1b/Wf9e/2D/jv+S/3T/eP+M/4//8v/2//z///8KAA4A/P///wcACgDm/+j/BwAKAAUABwBgAGQACAALAAkADAAmACoAIgAlAPX/+P/r/+//6f/s/7H/s//3//r/uf+8/7z/v/+W/5n/m/+d/6n/rP+O/5H/GP8Z/5v/oP///gL/Bv8K/93+4P6y/rT+wP7E/mb+af6A/oP+Z/5q/lX+WP5H/kr+ef59/jv+Pv5S/lX+SP5M/ib+Kf5P/lP+Sf5N/kX+Sf4Z/hz+Kv4t/j7+Qv5S/lb+TP5P/qD+pP68/sH+W/5e/qb+qf7h/uT+0P7S/jL/Nv/t/u7+f/+D/yr/K/8Z/xr/e/99/5T/lv+x/7L/DgAQANP/0/9LAE0A+//7/08AUACcAJ0AdgB1AOgA6QDEAMQA5ADlADQBNQFeAWABjwGSAU8BUgH/AP8A0wHWAZYBmAHNAdABhwGJAYIBhQEcAR0BUQFTAScBJwFJAUsBAgEEAWgAZwB2AHYAKwAqAAMAAgDk/+P/d/91/2D/X//y/vD+wv7A/n3+ev6S/pD+Y/5g/ln+Vv7D/cD9wv2//Z39mv1a/Vb9fv18/T39Of0f/Rv9E/0P/V39Wv34/PT88/zv/Ef9Rf05/TX9gf1+/Xj9df2a/Zj92f3Y/cL9wP3U/dL9N/41/nn+d/7S/tH+0/7S/rH+r/4Z/xn/8P7u/jX/M/+d/5v/uP+1//3/+v8ZABYAcQBvAGoAZwClAKMA6wDpAFgBWAEQAQ4BPQE8AaoBqgGcAZoBtQG0AZ8BnQHJAcgBqgGoAaABnwEcARgBWAFVASMBHwH4APQApgChAKoApQBUAE4AUgBNAEsARgAyAC4AdwB1AIsAigBiAGEArQCuAJkAmgBrAGwAVgBYADkAPAAyADQAAQADAL7/wP9x/3L/LP8t/wH/AP8O/w3/xf7F/lP+Uf46/jj+Kf4m/jr+N/4j/h/+C/4H/uj94/2N/Yb93v3Y/a79p/2l/Z39v/24/dn90v2F/oH+sP6t/vX+8/6Z/5r/7f/v/3oAfQCaAJ0A9AD5AC0BMwEkASkBkQGXAfIB+QHDAcgBygHPAZ0BoQEHAgwCtQG4AdsB3gHqAe0BwwHEAbwBvgGtAa4B4AHhAX0BfAGYAZgBYwFiAZIBkQGFAYMBmgGYAWIBXwGeAZwBSwFHAa4BrAFvAWwByAHIAb4BvgEGAgcCbAJuAlYCWQJ+AoICsAK0AggDDgPmAusC/QICAyoDMQPXAt0CsgK2ArcCvAK7Ar8CkwKXAjMCNQJ3AnwCGwIcAiYCKALKAcsBlwGYAWIBYgE0ATIBJAEjAdcA1ACAAHsA1gDTAJAAjABNAEkAIAAcADUAMQAjAB8ABAABAAAA/f8iACAARQBFACMAIwBAAEEAngChAKkArQCpAK0AvgDEAGQAaQCNAJIAXgBjACAAJQAGAAoAJwAsAPv////a/93/w//H/1L/U/9b/13/V/9Y/yP/I/8N/w3/CP8H/wr/Cf/o/ub+If8g//H+7v6v/qv++/75/sL+v/7y/u7+6/7n/kz/Sf/u/un+ev94/3//e/8dABsA+P/1/1gAWACdAJ0ACwEMAXMBdQF7AX0BnAGfAQ0CEAILAg0CNQI5Ak8CUwIjAiYCLwIyAhECEwIGAggC/QH/AT4CQALlAeQBSQJJAkACQAJAAj8CEAIOAgwCCwKiAZ8B6wHpAYUBgQGYAZUBJwEjATUBMQFcAVgBLAEnAQMB/gD9APkAsgCtANYA0gAHAQUBqwCnAK0AqgDCAMAAqgCoAN4A3QClAKQAswCzAJUAlQCzALMAgwCEAIgAigBHAEcAXwBhAC4ALgB3AHkANwA3AEcASABSAFQAPAA9AGwAbQBIAEkATABNAFIAUwAfAB8AMwAzAHsAfAAQAA8AOQA6AO//7f9QAE8AiwCLAE4ATACPAI8AjwCOAKUApAAxATIBvQC8AO4A7wDUANQAMwE0AU0BTgFxAXIBgwGEAZMBlAHNAc8BigGLAcYByAHYAdoBqQGrAdkB3QGpAasBsgG1AdwB4AGnAakB7QHxARUCGQJSAlcC+AH7AeEB5QHMAc8B9wH7AfYB+wFeAWEBcwF3ATwBQAFhAWYBDgERAT8BQwFhAWYB4QDkACYBKwEhASUB9gD6AOQA6AAMAREBpQCpAPYA+wD8AAEBlQCYAOgA7gBzAHYAnwCjAIcAjACiAKcAegB+AGMAZwCdAKIAigCOAK4AsgCkAKgAkwCWAOsA8ABrAG4A8AD1AMkAzQC5AL0AzQDSALYAugCpAK0AwQDFAMoAzwAGAQsB1QDZAK8AsgCDAIUAjwCRAK4AsQAmASsBsQCyACYEOgQmB0sHLgVHBWkEfgT8Aw4EvQXZBbEI3QjdDSUOwg8TEO8OPA8CDEAMqwvnC7MQChFbFcoVMxzHHJEeMR+6Im8j2SeoKMMpnCqCLnMvyjLQM9s3+jjWNes2UzZrN0U2XDcXNCQ1fTF+MmgtVS6dKnwrfyZKJ6cjYyTNHnAflRoiG7UXMhhBFK0UsxYsF5cdNB4uHckdWRrmGu4ZeBphG/MbrhxHHZ8eQR/KHm0fGB2yHb4cVh0sGrcaehj9GCYXoxeGFfoV5hFHEm8OvQ42C3QLBQgxCNQMGg1bDaIN0Qb2Bm4BdgGo/qL+3P3R/T38KvwW+/365va39o/zTfPy7pjuhegJ6K3jGOMQ4W7gedzA28bW8tUQ0yzScc10zBrHA8YBwtbA1r2cvMG5eri9tWm0Z7EHsLitTqwpqrioUKfZpfejeqL4oHifBKCCnmSf4p0NnomcZZ3hm6qcJpsFnICaBZyAmjyduJu/nTycB5+FnSehqJ/tonChHaWkoxCnmqXUqWSoWa3xq26xEbAQtsC0/bq9ubXAib8Jx/XFCc0PzAfTKNKb2t/Zo+EK4RLpnuj/8r7yIfsM+3kCiwJxCq4KqhMYFOobghxFIwIkAivjK0QyRDMnOUQ68j4lQD1EhEVzSclKlU32TmxQ1VHAUzJVb1foWK1aK1y5XDpeUV7VX4JfCGE8YMNh2GBgYv1ghWJVYN1hzF9UYbVeO2B+XAJelVkTWyZWnldqUtlTKk6PT51J9Up7RcZGW0CUQSM6RTuYMpsz+SnVKsghfCJPGt0aTBKyEroJ8gnwAPoABfjf9wbvsO4g5pzlpN323HTWpNVP0WbQQ8xEy+PGz8WtwYTAYLwju4+3QrYKtLKyYbIEsTSx06/pr4SuOq/UrbGuSa0Qr6itp69Brvywmq/Os3Sygrcztku7CLqAv0y+5MPAwobIdsfNzdLM5dMF0zbbedrL4zjjwuxc7C319PSD/Xf9sQXQBd8NKQ4uF6kXRiDvIAEp1Sk2MS8yOThPOeE9Dj8nQ2dERUiWSfRMU050UeBSlVULV79YPFqFWwddK12wXrtdQV9GXs1fjV4VYNdeX2CUXhxgTF3RXkZbyFxiWN5Z6VReVgBRa1IxTZJO5Eg4SgRESEU3PmY/hDeYOPwv8DAmJ/Mneh4cH3QW7RY8DooOTAVpBVH8PvyP807zLOu/6rHiGOLy2jTaS9Rt02jOb83IyLfHosN8wt6+pr1duhW5ebYktYKzJbJDsd+vGbCxrl2v863krnmt5K55rd2vdK4pscOvRLPksYu1NLSUuEe3VbwUu5PAYb8HxebDr8mhyFTPX8481WLU3Nsi20HjrOIZ66zq6fKm8jz6IPr+AQsCGAlLCTgQkBDwFm0XRh3iHdgjlCSXKW4qii54L+gy6zOuNsE3KDpJO0A9bT7uPyVB6kEpQx1DYUQIRE5F1EMaRS5DcESrQelC/D80Qcs9+j5oO408jTimOWw0dDX/L/Qw8CrNK0YlCCayH1kgjBkTGqQTDBSnDOsMTgVrBUX9N/0D9s314e6F7g3ojuc64pvh9Nw63APXMNZg0XTQmcyXy5bIg8dQxS7EwcKTwYjAUb9Ivgu9wryAu+W7oLqBuzm6Prv3uSG83Lo9vv68Z8Axv63CgcFpxUjE3MjJx4rMh8uW0KTPVtV61M7aC9pa4LPf7eVj5bXrSOsH8rvxKvgA+I7+hv4vBUoF0gsQDFcSuBLnF2UY4R1+HsYieyOdJ2ko9yvXLA0wADHQM9Q0Yjd1OOQ5ATtqPJE9XT6MP3Y/qUA2QGxBqUDhQWtAo0HaPxBBHD9PQIk9tT4XOzk8NzhNOSE1Kzb9Mfkydy5kL8QqoCuGJk0n+SGqIp0cNB1CF70XCBJoEp4M4QyVB74H3wHqAZ/8jfyM9133WvIQ8obtJO0e6aXogeX15CTihuEO32HeHdxi20nZgdi81ufVAdUj1LrT1dLk0vzRX9J00TfSTdEb0jHRF9Mv0i/UTNN/1aTUu9fp1iHaW9nR3Bncgt/X3tLiN+IB5nXlHumk6PTsjez48KXwAPXD9Nz4tfjn/NX8wgDEALIEygRhCI0I2QsYDKMP9w+0EhcTzhVCFpwYHhkCG5AbwxxbHe0ejx92ICAh9SGmIusioiNHIwAkciMrJAIjuiNlIhkjjyE/Ij8g6SDSHnYfohw7HeMachthGOMYnhUSFggTbxMuEIYQTA2VDRcKTwoOBzYHZwN7AxIAFADY/Mn8kflw+ZD2X/aH80XzrvBd8L/tXe0l67bqnugi6LHmK+bk5FTkUeO44jvineHc4DfgW+C038PfF9+R3+Xeyt8f3zPgit8Y4XLgK+KL4Ybj7eI55ajkBud+5hfpmuik6zTrAO6c7ZLwPPBi8xzz9/W+9a74g/g1+xn7SP48/gUBBwGdA64DcgaSBsAI7QgxC2sLiQ3QDYsP3A+FEeERRxOsE6EUDRXZFUwWxBY8Fy4XqRe9FzoYFBiTGB8YnhjIF0YYLheoF5sWExd6FewVFBR/FMgSLRNaEbcRgQ/UD44N1w1aC5cLPwlxCaUGyQbXBPAEegKHAmMAYwAb/hD+2/vE+6L5fvl690r3vvWG9abzYvMD8rfxfPAn8OHug+7L7Wjtu+xS7LjrSutR6+Dq4upv6v/qjOro6nXqb+v+6uTrdeub7DDsWe3z7C/uze25717v8/Ce8J3yUfJV9BL03vWj9df3qPep+YT53/vF+xH+BP4qACcA9QH9ATMERwQoBkYG+AcfCPIJJAqZC9QLdA25DdsOKA9QEKUQkRHuEZQS9hK9EyUUYxTPFN4UTRUnFZYVUhXDFToVqhWiFA8VJBSOFGATxRO1EhYTghHdEfgPTRCwDv0OEA1UDUgLhAt0CacJjQe2B6MFwAWrA74DpgGuAZb/k/+J/Xv9r/uW+8T5ovnG95n3VfYg9sj0i/RA8/ry2vGM8Y7wOvCA7ybvhO4k7p7tOe3b7HPsdewM7B3ssesr7L/r0+tn61Ls6Otq7ADsCu2j7HztGO097t3tF++77sPvbO+58Gfw8vGl8SHz2/Jn9Cf0A/bM9TX3BPfs+MT4bvpP+gL86/uf/ZH9Vv9R/9cA2gCoArMCLQRBBEUFYAWJBqsGIghMCEEJcAkkClgKZQugC0sMigwADUMNpQ3sDQ0OVw5HDpEOnw7sDrgOBQ+BDswOXg6oDtkNIA5cDaENswz0DPELLQwlC1wL7AkdCvIIHgnIB+4HWQZ4BuEE+ARfA28DpAGrAVQAVACM/oP+Sf05/cv7s/tx+lH6HPn1+CD48/fn9rT2//XH9Sv17/Q29PXziPND85XyTfLr8aDxQfHz8Dzx7vAW8cfwDvG/8ATxtfC98XLxxvF78WPyG/Kp8mTyl/NW84T0R/QP9dX09fXB9ez2vfbK95/3C/nn+Ob5x/kb+wL7l/yG/Kz9of3M/sj+NgA6AEMBSwGqArkC2QPvA4UEnwTRBfMFpgbMBksHdQc1CGMIsgjjCC0JYQnCCfkJRAp9Ck8KiAq8CvgKdwqxCnoKtAqICsIK9wktCsAJ9gkQCUIJkQjACKgH0gfDBugGowXDBdIE7gQKBCAEIQMzAxgCJQLvAPYAo/+j//v+9/6n/Zz9gPxw/M77ufuE+mn6tvmX+aT4gPi/95b3OvcM9/H2wvYf9uz16vW29ff1wvWE9Uz1O/UC9QL1yfQn9e/0Z/Uv9fH1vPUv9vz1r/Z+9j/3Eff39833evhS+Ib5ZPmd+oD6m/uD+2n8VvxB/TP9M/4q/jv/N/90AHYARwFOAYACjgKbA68DiQSiBH0FmwWGBqkGlAe8B3UIoggpCVsJ/gk0CmgKoAonC2MLUAuNC2sLqQvdCx4MLwxxDI4M0QxxDLQMXwyiDPcLNwzTCxMMIgteC8IK/QoOCkYKTgmBCZoIygiFB68HgAalBksFagU5BFIEUQNlAxcCJAJRAVkBAAABAKX+n/6N/YH9dPxi/Er7Mftg+kL6GPn0+Bf47fcb9+z2G/bn9XP1O/WW9Fn0GfTa86bzZfMk8+DypvJe8ljyD/Ie8tTxE/LJ8XDyJvK58m/y3PKU8gHzuvJN8wfzCfTH81n0GfQ39fz00vWb9br2iPbW96r3hPhb+Jr5d/lx+lP6S/sy+7P8ofx4/Wr9xv6//rj/t/+3ALwAoAGrAeUC9gIOBCMENQVRBe8FDwa1BtkGmAfBB/EHHAj2CCYJNwlpCbgJ7QlhCpkKaQqhCokKwgqgCtoKigrDCoUKvgqzCuwKawqjCgcKPQrLCQEKAwk0CbsI6ggGCDEIiAexB6oGzgYyBlMGmgW4BbMEywT0AwgEKgM6AzcCQgJ4AX8BmwCdALH/r//c/tb+Ef4G/lj9Sf2a/Ij8JvwR/Iv7c/vq+s76Uvo0+uX5xflE+SD5bPlJ+eT4vvjc+Lb4APna+Pz41viV+G74evhU+GX4P/ij+H34Avne+Bb59PiZ+Xn5KfoM+oL6Z/r6+uL6ZftQ+x/8Dfx//G/8K/0e/ef93v1j/l3+Vf9U/6j/qf9fAGQAJgEuAbUBwQEaAigCqQK6Ah8DMwNtA4IDIwQ8BH8EmgS9BNkEFwU2BTEFUAVnBYcFrgXPBbMF0wXaBfsFEwY1BgIGIwYQBjIG6wULBr4F3QVSBW8F9QQQBWcEgAQiBDkE7gMCBKQDtwMRAyEDqQK4AlQCYALjAewBeAF/AfwAAAFjAGUA6P/n/5H/j/8u/yn/9f7v/u/+6P5y/mr+lP6M/if+Hf4r/iH+Df4C/pv9jv2T/Yf99P3q/X/9cv0S/gj+kP6J/jj+L/7C/rv+yv7E/i//LP/d/93/MQAyAKkArQBdAWUBjQGVARcCIgKLApgC4gLxAlUDaAOmA7oDMARHBJoEswT+BBoFYwWBBZ4FvQUaBjwGOQZbBoEGpQasBtEGwAbmBq8G1QbzBhsHmQa+Bu4GFQeUBrkGdgaaBowGsAYcBj0G2AX4BakFyAU0BVAFvwTZBJMErATlA/sDagN+A+4C/gJLAlgC+AECAl0BZAGTAJcAQQBDAH//ff8c/xj/lP6M/g3+A/5n/Vr9vPys/I38e/xD/C788fvb+2f7Tvvv+tT6Avvn+on6a/pZ+jr6Xvo/+gP64/lN+i/6/fnc+Y36bvpY+jj6gvpj+qT6hvrT+rX6OPsc+2H7RvuB+2j7z/u4+yP8Dfx//Gv8//zu/CD9Ef2R/YP9D/4E/lr+UP6//rj+Wv9W/7T/sP9RAFEAKgArAL8AwwDjAOgAVwFdAYoBkgGsAbUB4gHtASUCMQJ/AowChAKRAnsCiQKGApQCXQJqAlgCZQJZAmYCBAIQAvYBAgLZAeQB8AH7AZ4BpwFUAVwBFgEdAdoA3wDAAMUAQABCAAwADgACAAMArv+s/4P/gP9E/0D/1f7P/u3+6P6P/of+PP4z/lD+R/5O/kT+E/4H/if+HP7q/d793P3P/Rz+EP7t/eH9GP4N/iL+Fv5P/kT+kv6J/tr+0v4n/yD/pv+h/6D/m/////3/KgAoAHUAdgD2APkA8QD0AIgBjwGtAbUBQgJMAo8CmwLVAuMCSwNbA5ADoQMyBEYEIQQ1BJQEqgSvBMYE7AQFBRAFKgU9BVcFIgU9BUsFZgVdBXgFVwVzBUUFYQVcBXgFcQWNBWUFgQUWBTEFtwTQBHIEigRBBFgEEgQoBIEDlANWA2kD0ALgApICoQJPAlwC2gHkAYoBkgEeASQBygDOAGkAawCo/6b/k/+R/xj/FP+G/n7+Xv5W/uD91f2h/ZX9bf1e/UT9NP3d/Mv8q/yY/I/8e/xf/Er8d/xj/BT8/vvh+8v7wfuq+9D7uvu7+6X76vvU+/776Ptr/Ff8pPyR/L/8rPz3/OX8P/0v/XX9Zv27/a797/3j/ST+Gv6Z/pH+5f7e/kP/Pv+Z/5b/1v/V/y4ALwCRAJQA0QDVADwBQwF4AX8BkgGbAesB9gH2AQICXgJsApICoAKaAqkC0ALhAhIDJAMlAzcDQQNUAz8DUgM6A0wDWwNtAykDOgMWAycD6AL5AusC+wLeAu4CugLJAlkCZwJUAmECEQIdAtQB3gFhAWoBFAEcAe4A9QDdAOIAnACgAFMAVgAMAA4ABQAFANH/0P+r/6n/cP9t/0v/R/9H/0P/I/8e//P+7f7F/r/+zv7H/rj+sf64/rH+mv6S/rr+sv7u/uf+DP8F/xD/Cf8k/x7/Hv8Y/4T/gP9x/23/dv9z/6r/pv/l/+P/HgAcAF8AXgBtAG0AtwC4ANcA2gDxAPQAHgEiAU8BVAFlAWoBuAG/AaUBrAHxAfgB7gH1ARcCIAIvAjgCOQJCAjgCQQIeAigC5QHuAQ8CGAKgAacBZQFrAX4BhQFSAVcBKAEsAasArQDYANoAVgBWAEYARgC9/7r/qf+n/13/WP8f/xr/sf6q/qT+nf4j/hn+/f3y/cX9uf2g/ZL9Sf06/ST9Ff3j/NL83fzM/ID8bvw8/Cn8U/xA/DP8IPwh/A38HvwK/PX74Psm/BL8Mfwd/En8NfxF/DL8avxY/HX8Y/yu/J384PzQ/C/9IP1Z/Uv9iv1+/eb92/0P/gX+Yv5a/ov+hP7l/uD+Mf8t/5H/jv+//77/AgADAH8AgQDhAOUAIAEmAXgBgAF6AYEBLQI3AgUCDwJ3AoQCaAJ1ArwCygLuAvwCGgMpAxIDIgNJA1oDagN7A2wDfQOrA7wDfwOQA5cDqQNXA2gDVwNoAycDNwP6AgkD4wLxAtgC5gKaAqYCigKXAkICTQLvAfkB+AECAqoBsgGlAa0BRQFLARgBHQELAQ8BxgDJAJgAmwA/AEAAIgAiAA8ADwC4/7b/gf9//2f/Zf9n/2P/P/87/0X/Qf8P/wz/FP8Q/y3/Kf/4/vT+zf7I/hT/EP/2/vL+Mv8u/zr/N/9K/0f/qf+n/6L/oP/C/8H/7f/u/xIAEwA/AEAAZQBnAEAAQgBeAGEAfgCDAJ4AogDpAO8AEgEYASwBMwFYAWABcAF4AbMBvAGcAaUB3wHpAcUBzgEHAhIC7gH4Af8BCQLaAeQB/gEIAtsB4wEAAgkC8QH6AbsBwwGqAbEBgQGHAU4BVAEhASYBHQEhAf4AAQH7AP4ApAClAHUAdgBHAEcALQAsAO//7f+z/7D/cf9t/4P/gP8w/yv/Ov81/yL/HP8E//7+Kf8j/+L+2/7G/r/+v/64/p7+lv6p/qL+gP55/tr+1P7i/tz+IP8a/yf/If8c/xf/Ov82/1r/V/+a/5j/s/+x/7v/uf8KAAoA8//z/yQAJgBEAEcAJQAoAMkAzwDmAOwAJwEuAWEBaQFgAWgBvgHJAZYBoAHCAc0BMQI+AvUBAAJfAmwCHQIqAjUCQQJvAnwCfQKLAlECXgJuAnsCNgJCAgoCFgLmAfEBfAGGAY0BlwFeAWYBQQFJAd4A5ACwALUAmACcAHcAegAGAAcA5P/k/3r/eP9O/0r/Bv8B/7T+rv5+/nb+Hf4S/u394v3A/bT9Jv0X/Rb9Bv3o/Nb8v/ys/Hf8Y/z8++f7/vvo+wD86fvL+7P7iftw+2D7R/to+077Svsv+0L7KPsD++j6Bvvr+iX7C/sW+/v6e/ti+1v7QfvK+7L7v/un+yH8C/wc/AX8jvx5/KL8jvzf/Mz87fzc/Pj85/xF/Tb9nP2P/dD9xP3d/dL9N/4u/mr+Yf6w/qn+DP8H/1P/Tv9v/2v/zv/M//7//v/j/+P/QgBDAHEAcwBcAF8AZgBqAJoAnwDKAM8ARgFNAUMBSgE4AT8BdgF+AXcBfwF6AYIBsQG6AVkBYQFYAWABcAF5AT8BRwFcAWQBKgEwAVgBXwFXAV4BFQEaAQ8BFQH4AP4AygDOALUAuQBlAGgAiwCOACkAKwAjACUA2f/Z/6z/rP+4/7j/mv+Z/5P/kf+E/4L/cv9w/0D/Pf83/zP/c/9w/27/av82/zL/Zf9i/wD/+/7y/u3+H/8a/+v+5v7w/uz+qP6j/tz+2P7D/r3+9v7y/vH+7f7q/ub+Lv8q/1D/Tf9f/1z/Zv9j/7D/rf/A/7//kv+R/2T/Yv+S/5L/5v/m/9L/0v+9/73/4v/j/8D/wf8YABkASgBMACUAJgAeACAANwA6AIYAigA8AD8AagBtAE8AUwBqAG4AUgBVAJIAlwBMAE8AigCOAKoArgDzAPgAqgCuANMA2ADJAM0ApgCpALYAuwBqAG4AigCOAHMAdgBuAHIANQA4AGgAbAD4//n/YABjACsALAD+////EAARALP/sf8VABUAyv/J/0H/Pv+U/5P/P/87/yH/Hv/p/uX+zf7I/gn/Bf/W/tD+nv6X/m3+Zv5N/kX+N/4u/hX+DP7r/eH95f3a/bv9sP2a/Y79jv2C/Rz9D/1m/Vr9cv1k/Wj9Wv0//TH9PP0u/R/9EP0b/Qz9+/zs/M/8wPwE/fb86PzZ/O783/zp/Nr8zvy//CP9Ff09/S/9Y/1W/U39Qf1x/WX9vf2y/e394/3Q/cX99v3t/RX+DP4k/hz+c/5t/lP+TP6t/qj+lP6P/kr/R/9o/2X/b/9t/83/zP/e/97/JwApAB0AHwBXAFkAcABzAKcAqwCtALIAsQC2AAcBDQEcASIB9wD9AGYBbwFZAWEBOwFCAaMBrAFvAXcBbwF3AXYBfgFIAVABawF0ARYBHQE4AUABSgFRASsBMQEyATgBMgE5AbYAugDcAOEArgCyAJ8AowBkAGcANwA5ACAAIQA6ADsAPgA+ABYAFgDM/8r/tf+0/8j/x/8w/yz/Vv9T/2L/X/8d/xn/Gv8W/9T+z/4C//3+3/7a/tj+0v4L/wX/Df8I/xT/D/8A//r+G/8W/yD/G/80/zD/S/9I/xf/E/8z/zD/e/95/6X/o/+i/6D/yP/H//v/+//X/9b/PQA/ADIANQBAAEIAngCiAPQA+gCtALEAFAEbAQMBCQFfAWcBTwFWAYQBjAGCAYoBpwGwAYIBiwGSAZsBKwI2Aq4BuAH4AQMCHAIoAgICDQL+AQgCBAIPAiQCLwIQAhoCJwIyAssB1QHaAeQBEgIcAvAB+QHuAfcBtQG9AZoBogGDAYoBWAFfARMBGAETARgBDQESAXoAfADkAOgAoQCkAFcAWQBzAHUAJgAnANb/1f/1//X/9f/1/87/zf+s/6r/3f/c/+P/4f+8/7n/kP+O/5T/kf+j/6D/h/+E/2r/Z/9k/2H/Zv9j/3T/cv+S/5D/PP85/8z/y/+x/6//xP/D/9H/0P/C/8H/2P/X/67/rf/Q/9D/z//P//f/+f/8//3/KAApAGQAZgBqAGwAkgCVAEcASABgAGIAgQCEAH4AgABrAG0AOQA7ACoAKwCCAIQAQwBEADgAOgA6ADsA6//r/+7/7f8HAAcAzf/M/2v/aP+X/5b/N/80/zT/Mf8P/wv/+/72/hj/Ev/A/rn+xv7A/nb+bv5a/lH+dv5u/h3+Ev4L/gD+6/3f/cz9wf3R/cT9y/2+/Xb9af1m/Vj9jP1//UT9Nf2c/Y79U/1F/Tv9Lf1b/U39Qf0z/Yv9fv0u/SD9Tf1A/Yr9fv2U/Yj93v3U/Z79kv1R/kj+Sv5A/kz+Q/58/nb+qv6k/rn+s/4o/yT/Y/9f/5j/lv/Q/9D/BQAEACEAIQAxADMASABLAGAAZACxALYA2gDgAAQBCwFoAXABcAF4AcEBywHqAfUBAgINAlICXwL0Af8BRwJUAjECPgJNAloCbAJ5AoUCkwJmAnQCoAKuAqwCuwKhAq8CigKXAvUCAwO1AsICiAKUAq8CvQKEApACZwJyAlQCXwIWAiAC2QHiAekB8gH3Af8BmgGiAYoBkgFQAVYBcAF1AToBPgHnAOoAqwCvAFYAWABBAEIARQBHAAkACQDO/87/HgAfAIr/h//+//3/4v/h/43/iv+//7z/xv/D/1b/Uv9d/1r/I/8e/27/a/9Y/1T//f74/iL/Hv8h/xz/WP9U/0n/RP9v/2v/KP8j/xL/Dv8K/wb/uP6y/ij/Jf+2/rH+kv6N/tD+zP6d/pf+G/8W//r+9f5F/0H/Ev8N/zj/NP9U/1D/CP8D/0f/Q/88/zn/6P7j/ir/J//u/uv+2/7X/vz++f4l/yL/Sv9H/17/W/9Q/0z/eP91/4D/fP94/3b/ef92/1f/VP+Z/5j/kP+N/2D/Xf+a/5n/O/85/7z/u/+F/4P/0f/R/6//rv+P/43/9P/0/5//nv/Y/9j/4v/h/ycAJwApACkA2//Z/xAAEQDi/+L/xf/E/9n/2f/A/7//8v/x/xAAEAAMAAsADQAMAEkASQAdABwAcwB0AFUAVABhAGEA///+/04ATwC3/7X/TgBPACAAHwAcABwAQABAAOr/6f8hACEABQAEAO7/7f8NAAwADgANABUAFAD7//r/5//m//r/+f/3//b/DAAMABgAGAACAAEAJAAkAEkASAAHAAYA8//z//T/9P8eAB4AEgASAPX/9f8iACMAIgAhAH0AfgAqACkAZABlADAAMAA/AD8AUgBSAFoAWwBsAG4AWwBcAGYAaAA0ADUAvAC/AHcAeAC4ALwAXgBgALgAuwAEAQgBKQEtAd4A4QDhAOYApwCrAAUBCgHwAPQABgEKARwBIQElASoBSwFRASABJQH0APkATAFTARABFQFUAVoB7ADxAN4A4wA3AT0BVwFdAWMBaAEuATQBiQGQAX8BhAGhAagBLgE0AeAA5wDVANsAHgElAfkA/wAOARUBBAEKAVoBYQFQAVYBSQFPAVcBXQFaAWABeQF/AXwBgwEaASABLQEzAYYBjQFDAUgBEAEVAUEBSAGjAKcABAEIAQ8BFAHOANIAsgC2AKcAqwChAKUA3ADgAHYAdwD2APoAmQCbAFsAXQBWAFkAAQACAGIAZQDk/+T/+v/7/9b/1v/N/83/0f/P/xwAGwD+//z/CAAHAJH/j/9f/1z/Q/9A/27/a//2/vH+9/7z/gP///7j/t7+0P7L/qH+mv7h/tv+0f7L/pn+kv6k/p3+0f7K/rH+qf6E/nz+nf6W/nT+bP6N/oX+SP4//ln+Uv6F/n7+Zv5e/m7+Zv6H/oD+dP5s/q/+qP7L/sX+s/6s/gv/Bv/R/sr+5f7f/qb+oP6C/nz+1/7S/v/++v5W/1L/TP9I/3L/b/9E/0D/yf/H/8j/xf/V/9T/wf+//5P/kf/F/8X/g/+C/3//fv8oACoA3f/c/wcABwAnACkAGgAbADEAMgBkAGQAiACKABkAGQB0AHYAcABxADsAOwBqAGwACwALABUAFQD9//7/uf+4/+z/7P+T/5H/xP/E/7f/tf+o/6X/wv/A/8L/v/9l/2H/jf+J/2L/Xf9a/1X/JP8f/wf/Af8L/wX/5v7g/q7+p/62/rD+k/6M/gP//f6b/pP+5P7e/s3+xf77/vP+Hf8X/7n+sP4j/x7/0f7K/rD+qf4A//v+zP7G/sP+vf4I/wP/GP8U/zb/Mv9V/1L/n/+c/7H/rv8AAP//DAAMAPL/8f+fAKAARgBGAEgASQBYAFsAVQBXAA4BEwETARcB7QDyANcA3QARARcBigGRAZ4BpgFqAXEBpwGvAfYB/wHWAd8B1wHhAXUBfwGuAbgBxgHQAeAB6wGWAaABNgE/AboBxgHYAeEB+AEAArEBugGMAZUB0gHaAcsB0wGWAZ0BRQFMAdcA3AC8AMEAzADSAIAAhABYAFsAkQCUAE0ATwB7AH4AJQAlAHAAcgBoAGgASgBLACwAKwDZ/9n/tP+z/9L/0f+e/5z/g/+B/3b/dP8b/xj/hv+E/6H/nf8WABQA5//j/8v/yP/K/8f/0P/N/y0ALACn/6P/HAAcAJD/jv+1/7T/t/+2/8v/y//7//v/LAAtADMANABRAFIAqQCsAJQAlwDZANwArQCwAMcAywDFAMkA3QDiAL4AwwDDAMgA+gAAAe4A8wAqAS8BWQFfARoBHwFfAWUB7wDzACMBKQHiAOcA3wDkALwAwACvALMArQCxAGIAZACJAIwAbABuAHMAdABMAE0ACQAKALj/uP+y/7H/7f/s/6j/pv+s/6r/bv9q/0//S/88/zj/5f7f/iH/G/+g/pj+qv6j/nj+cf59/nX+Sv5B/lL+Sv5a/lH+Hv4U/mf+Xf5V/kv+LP4i/kb+Pf41/ir+SP4+/nT+av5h/lf+Xf5V/ij+Hv4//jb+fv52/l/+V/5c/lT+n/6Z/p/+mf7Y/tP+BP8A/8b+wf4O/wr/gv+A/5v/mf9u/2z/m/+a/8H/wf/V/9X/3v/f/8T/xf8bAB4AnACeAAIBBgG5AL0A1gDbAMkAzgAcASEBBQEKATUBOwHIAM0A1QDcAPQA+wDwAPYASQFRAQYBDAFIAVABCgEQATUBOwEwATcBRgFMASYBLQHFAMoAowCoAMEAxgAiAScBuQC8AOIA5QDWANkAxADGAKYAqQAeAB8AbgBwAEUARQB3AHkAzP/M/6v/qv8XABcAPwA+AAMAAwCO/4z/4//j/6r/p/8DAAEAlP+R/6X/o/+U/5L/nP+Z/+n/5//S/9H/dv90/8D/vv8JAAgAAwABAC0ALAA7ADoAZgBlACIAIQANAA0Axf/F/xAAEQAwADAAOwA8ACYAJwBDAEYAagBsAK0AsQDXANoA4QDjAMMAxgACAQYB7wDyADoBPwE2ATsBAAEFAeIA5wAxATcBNQE7ARQBGQGbAaIBXgFjAUABRgGWAZ0BjQGUAVEBWAEpATABcgF6AWkBbwFSAVkBZwFwASsBMgFOAVUBsgG6AWwBdAFSAVgBvwHGAZ4BpQGgAacBfgGFAVIBWAGMAZMBmQGgAWQBagEhASYB/QADAQsBEAFHAU0BAAEFAQUBCgGxALYArACvABUBGwG2ALkAsAC0ALYAugChAKMAqQCsAKsArgBmAGgAtwC5AM4A0QBLAEwARABFAA0ADAA0ADYA0//S/5n/mf++/77/bf9r/5f/lv/I/8b/p/+k/8r/yP+T/5L/Ef8N/07/S/8X/xP/KP8l/7X+sf6t/qn+zf7I/iT/IP9Y/1P//v74/iz/J//5/vT+5/7h/tT+z/6O/oj+ff53/tL+zf7Q/sr+k/6N/uL+3f6y/qz+8f7t/gb/AP8i/x3/2v7V/g3/Cf8c/xj/Kf8l/1L/T/8p/yb/Dv8L/5T/kv9T/1D/v/++/7b/tf+V/5P//////5L/kv+i/6L/j/+O/xMAFAAsAC4A+v/6/3QAdwBCAEQAcABxAG8AcQAyADUAfACAAG8AcgC7AL4A8AD0AKAAowDDAMcAzQDRALkAvgCZAJ0AdwB7AMQAyACSAJcAowCmAKEApQDCAMYAcABzAGAAYwB5AHwAoACjAHgAegB2AHgAfAB+AAQABgAKAAsA4f/i/0QARQBIAEgABQAFADcAOADh/+H/xv/F/wcABwAzADMA1v/V/8z/zP+T/5P/r/+v/37/fv/q/+v/1P/T/xAAEAAWABUAJgAnADsAOwDm/+b/LQAuACQAJQDX/9f/v//A/5T/lP8bABwAAQACAPr//P/z//T/BQAFAFUAVgD//wAAAQABAFIAUwAmACYAGQAaABYAFwDE/8P/HwAgAEkASgD5//j/JQAmANr/2f8sACwAZgBmAOb/4/8NAA0Aa/9p/7j/t/+F/4L/3f/c/1X/Uv8s/yn/sP+u/3D/bf8w/yz/Df8K/xn/Ff9o/2T/Vf9P/yP/Hv8A//z+8P7r/lr/Vv8Q/wv/vf65/vv+9v4R/wv/mv+W/0r/Rf8a/xX/rP+p/7f/s/+b/5f/Y/9g/2T/Yf+s/6n/7P/q/wIAAQDc/9v/qv+o/xQAFAAKAAsAvP+9/yMAJABSAFQAsACzAJgAnAB+AIEACQEOAfwAAQFEAUoB9gD7AC8BNgFiAWkBQQFHAakBsQGSAZoBoAGoAYIBigEEAg0C7QH1AQwCFALSAdsB8AH6AeEB6gH/AQgCHgInAr8BxwHHAdABkAGZATwBRAHrAPIAmgGjAUsBUgE4AT4BawFyAVoBXwFjAWcBYQFnARABFAELAQ8BAwEGAeoA7QBoAGoAZgBoADwAPQD//////P/9/8D/v//M/8v/IAAeAA4ADADH/8X/of+f/6j/pf/D/8D/lf+R/y7/Kv/I/sP+NP8x/0T/QP81/zH/H/8a/x7/Gv9b/1f/uv+3/2j/Y/+G/4L/UP9M/3D/bP9r/2f/Sv9G/+T+4P4L/wf/sv+w/1b/U/92/3T/sv+x/7f/tf/7//r/5P/k/5z/mv8tAC0AIQAgABsAGwDg/+H/4//j//f/+f+2/7b/KAAqAFEAUwD3//j/nACfAMkAywD9AP8AwwDGAJ8AogBwAHMAdAB3AG4AcQAhACQAbwByAJoAngAuADAAYQBlAHEAcwC5ALsAXQBfAH4AgQBJAEsAOAA6ADwAPgAbAB0AFwAYAF8AYQCGAIgA4//j/3YAeACDAIQAAAAAAKH/of8GAAcACgAKACYAJgDW/9X/k/+S/+b/5f/y//L/AAAAAJz/m/+L/4n/6f/o/8//zv/h/+D/rv+t/8j/yP++/73/+P/3/6z/qv+D/4L/Yf9h/3X/c//r/+r/wv/B/6T/o//P/87/FwAVAPH/8P96/3j/iP+H/4D/f/+i/6D/wv/B/5n/l/9g/17/cv9x/6r/qP/w/+7/jf+K/3f/dv9j/2H/vP+6/9T/0f8LAAkAq/+q/3P/cf+C/3//t/+1/8v/yf+n/6X/cv9v/43/iv/P/83/ev93/6P/of9c/1n/dv9z/4D/fv+1/7P/eP91/9f/1v+s/6r/0P/P//r/+P/s/+v/uP+3/5f/lv/V/9P/kP+O/6P/ov89/zz/bP9s/7L/sf8zADMAQgBBAFEAUABJAEkAZwBnAIYAhgB0AHQAQQBBAOX/5v/N/87/1//Y/wcABwAZABoA4P/h//L/8/+KAIwA4wDkALQAtABfAGAARABEAIsAjAC9AL4ASABKALv/vP+u/6////8AABoAGwAzADMADwAPAIQAhgBCAEIAzgDPAI8AkAA1ADUALAAsANP/1P+l/6T/1v/W/4//jv+v/67/0P/Q/4n/h//T/9P/v/++/8b/xf8cABwAGAAWABUAFQABAAAA3//e/8f/xv+Z/5j/y//L/6r/qP+9/7z/4v/i/8b/xf+s/6v/GgAaAAMAAwDV/9X/7//u/4EAggA7ADsABAADAA0ADQDS/9H/DgAOAC4ALwDa/9n/BwAJAM7/zv/k/+X/5P/l/8v/y/9HAEkAJgAnABgAGgANAA0ASQBKADwAPAC0ALYAZQBlAHsAfAAGAAcAGgAbAOz/7v/t/+3/CAAJACMAJABwAHIAXgBeAHAAcQBsAG0AcgByANsA3QBXAFcARgBIABEAEgC+/77/9v/3/9L/0v/y//P/oP+g/wwADABGAEYAMwA0AO3/7P/m/+f/yP/H/xcAFwBCAEMAIgAiAIH/gf+M/4v//P/8/7r/uv/j/+L/8v/y/xEAEQAkACMAJQAkADUANQCT/5L/9//2/5T/k//A/7//rP+r/5P/kv+x/6//4P/e/xoAGQD6//n/qv+o/wIAAQABAAAA/P/7/+7/7f/s/+v/0v/R/8T/w/+6/7n/q/+r/7T/sv/p/+j/8v/y//b/9f8KAAoAVABTAJMAlAD///7/VABVAJz/m/8IAAkADQAMAAgACQDd/97/1f/U/1AAUQAOAA4AVABUAKwArgAdAB0AeQB6AJUAlwAJAAkAGQAaADsAPQDm/+b/RwBIAAMABADR/9P/6f/q/x0AHgCjAKQAkACRACYAJwAwADIAJgAnAHkAewCDAIQAYABiAA0ADQDi/+P/UQBUAO7/7v9GAEgAPQA+ACUAJgAaABsAGAAZAC0ALgBGAEcARgBHAKUApgBcAFwAOwA7ADQANABqAGwAOgA7AD8AQQAgACIA8v/z/w8AEQBhAGMARQBGAKwArQDfAOEAUABRAEwATgAyADQAGwAcACoALABNAE8AlQCYAGEAYwBjAGQAQQBDAEkASgCQAJMAHgAgAO//8P9jAGUAcgBzAHgAegAyADQA5P/k/4UAiABNAE4AtwC5AFQAVQBrAG0AkwCWAMr/y//x//P/lf+W/w0ADwBiAGMA3P/c/yQAJQCe/57/OAA5AIIAgwAdAB0AJgAnAKr/qv/Y/9n/j/+O/87/zv+r/6r/lP+T//D/8P+6/7j/1v/W/6n/p/8tAC0A4//h/6j/pv/A/77/O/85/x7/HP9R/0//iP+G/5z/mv9S/0//ZP9i/3H/b/90/3H/u/+6/57/nP+j/6D/y//K/4//jf97/3r/Wv9Y/8//zv/U/9P//P/6/7r/uf+s/6v/BAAEAOz/6v8zADIAOgA7AA8ADgAuAC8AOgA6ANr/2f/x//L/AAABAC8AMAAlACYANQA3ANj/2f9CAEMAJgAoAPv//P/l/+f/CAAKAHoAfACoAKoAsACxAHsAfQBpAGsAowClAGwAbQAQABEAy//M/+D/4f///wEALwAwAIUAhgAsAC0AdQB2AEQARQCbAJ0A7v/v/6X/pv/K/8v/1f/W/0MAQwAzADQAif+J/6T/pf8CAAIAHwAfAPj/9//P/87/yv/K//7//v9iAGAAHAAbAAwACwBv/27/df9z/xIAEgDy//H/e/95/2v/av+P/43/3f/b/xQAEwC3/7T/jv+N/8n/x//s/+r/6f/n/8v/yv9v/27/fv98/1X/U//u/+z/kP+O/33/e/+P/47/sP+u/83/zP/7//n/OQA4ANP/0f8YABcAwv/A/y8ALwC7/7j/IAAgAFL/T//f/97/xP/D/xYAFQADAAIArP+q/xQAEwABAAAAdwB3ACcAJgAQAA8A4//i/9L/0f/K/8n/uv+7/+f/5v/f/9//7//u/wIAAgD6//r/2//a/wIAAgA9AD0AGwAaAPj/+P/p/+n/q/+q/9v/2/8vAC8A3v/d/3D/b//Z/9j/0//S/7D/rv/0//P/L/8t/67/rf+y/6//AgACAPP/8f9a/1j/c/9y/7j/tv+h/5//j/+O///+/f5P/03/of+g/9X/0v/4//b/Vv9U/xT/Ef+3/7X/mv+W/7v/uv86/zf/Yf9f/5T/kv+Q/43/nP+a/yf/I/9O/0z/If8d/4r/h/9j/1//cv9u/1r/V/83/zL/e/93/4D/ff8i/x3/Mv8u/2H/Xf+//7v/nP+Y/xf/E/+v/qv+9P7x/jL/Lv/W/9T/m/+W/17/Wv9//3z/bv9p//b/9P/u/+v/if+G/+7+6v6E/4H/Xv9b/6T/of9N/0r/lP+S/7L/sP+8/7n/FQATAPD/7/+T/5H//v/7/2YAZQCD/4H/yP/H/4P/gv+Z/5n/4//i/xsAHAAGAAYAsP+v/wIAAgAFAAQAawBsANUA1gBiAGIAWQBaAJEAkwA3ADgAQQBBAEgASQDy//P/+v/6/9P/0/8fACAA1f/W/wgACAArACsAhgCIAEEAQQAvADAAcQBxAJMAlADZANoAcgByAHMAdQAWABYAHwAfAHQAdQAjACMAKQApAEEAQQBeAGAAQQBCAFwAXACUAJQARQBFAKEAoQBWAFYAUQBRALAAsQDK/8r/3f/d/6X/pv+d/53/FgAXAPz//P8/AEAAQgBDAHQAdADWANcAvwC/AKsArACZAJkAhwCHAMwAzgBxAHEA0P/R/8P/xP8vADAAOwA8AIIAgwAnACgAdAB1AFcAWACvALEArwCwAGYAaABUAFUAEgATAPz//v/A/8H/4v/k/7j/uv9CAEQAjwCRAIUAhwDlAOcAewB9AHwAfgCvALEAtQC3AAQBBwFZAFsAXABeABIAFQACAAQAHQAfAP7/AQDC/8P/agBtADkAOwBLAE0AOQA6AF4AYQC0ALcAaABqAFIAVADv//H/FQAXAPz//P///wIAx//I/ycAKQCo/6n/+f/6/3AAcQB5AHsAiQCJAGQAZQCNAI4AWwBcADoAOgAgACEAo/+k/57/nv/M/83/r/+v/3j/ef84/zj/l/+Y/9//3/+g/6H/xf/F/8X/xv+V/5X/8P/x/97/3f+t/67/cv9x/1L/Uv9L/0r/av9q/4b/hv+g/6D/yf/I//T/9P/h/+H/1f/U/wMAAgDA/7//6P/n/+P/4/+n/6X/zP/M/2r/aP93/3b/Mf8v/6L/of96/3n/Jf8j/3f/dv8X/xT/vv+9/5b/lP96/3n/pv+k/2r/aP+o/6b/Nv80/y7/Lf8d/xz/8/7w/kL/QP9Z/1f/h/+E/2T/Yv+e/5z/sv+v/6L/oP9//3z/YP9d/6P/oP+9/7r/df9y/03/S//U/tH+Bf8B/3f/dP9O/0v/6f7l/hn/Fv9c/1n/OP81/5L/j/8a/xf/Af/9/mH/Xv8v/yz/Kf8l/4j/hv8P/wv/UP9O/zj/Nf9//33/sv+w/4X/gv+r/6n//v/8/wkABwDx/+//7//u/z//PP/N/8z/xf/D/4T/gv94/3b/I/8h/+b/5v8wAC8AEQAQACMAIQD2//X/2//a/4T/g//T/9P/rf+s/7j/uP8pACkACwALAC0ALQA7ADoAFgAWAEcASAAZABkAyQDKAFEAUQAHAAgADQANAE0ATwBoAGgAPAA9ADYAOAAXABcAWABaALkAugCuALAAkwCTAMQAxgBTAFUAzwDQAFUAVwBZAFsAAgAEAKf/qP9iAGQAVABVAGMAZQCOAJAAkgCUABUBFgHlAOcAXABdACoALAD5//r/qQCrAKMApQBrAGwANAA2AGsAbQDKAM0ApwCpAAMBBgF3AHkAqwCtAMgAygBPAVEB8gD0AMcAyQBHAEkA1P/V/5EAlABzAHUAcgBzACsALQDo/+v/awBuALAAsgB+AIAACgANADoAPABtAHAAdgB3ALkAvABOAFAAZwBpAMAAwgDJAMsA8f/z//P/9f8hACMAowCmAI8AkQCmAKgAhACFAHoAewCmAKkAqwCtAHsAfQCEAIUAKAAoAC4AMADW/9j/v/+///v/+/8DAAQAx//I/9X/1f84ADkACwEMAYUAhQD0//P/NwA5AE8ATgC8AL0A/f/9/9//4P+O/47/hwCIAFsAWgBsAG0Ap/+m/wkACgAsACsAWABYABAADwC7/7r/7P/t/+r/6P9aAFsAFgAUAMj/x//n/+f/0f/Q/0IAQADp/+j/Wv9Z/6//rf+2/7X/wv/A/73/u/+j/6L/Uf9P/9H/0P/N/8v/y//K/zr/Of+v/67/Vf9T/6b/pP/c/9r/iv+J/0v/Sv9k/2L/7v/t/7r/uP+o/6b/pP+j/7z/u//q/+j/PgA9AM3/zP96/3n/dv91/5//nf8tACwAjP+J/5r/mf+t/63/rf+r/5r/mf+0/7P/IP8f/zr/OP++/73/3P/c/yf/Jf+E/4L/FwAXAA8ADgA5ADgA5v/l/7//vf8jACMA6P/n/7f/tv/N/83/pv+k/+f/5/+x/6//PgA+ABoAGQBIAEgArv+t/9j/2P95/3j/Hf8c/6L/ov+5/7j/BwAIAEkASABOAE4AVgBWACYAJQD/////jACNABgAGAANAA4ARQBGAOD/4f/m/+f/6f/q//v//P/4//j/bgBwADYANgCiAKQANwA3AKcAqQBLAEsAOgA7AF4AYADK/8r/tf+2/8n/yv/4//n/EgATAO//8P9VAFYANwA3AIYAiABHAEcAEAAQAC0ALgDZ/9r/lP+U/7D/sf/J/8n/1v/W/x0AHgB3/3b/RgBIAGEAYACkAKQAwgDEALX/tf+7/7z//P/8//n/+f+C/4L/XP9d/8T/xf+8/7z/8P/w/+X/5P+w/7H/2v/a/3IAcwACAAIAaABpAM7/z//e/9//kf+S/7b/t//m/+j/ff99/7H/sv/a/9z/RwBIADMANABZAFsAVABWANr/2v9jAGQAKAAoAJsAnABgAGIAvP+8/yoALQACAAQA3P/d/7//wP+4/7r/xv/G/0wATQB9AH4AcgBzACIAIgAcABwAlACVAPP/8v+r/6z/Rv9G/5r/mf+1/7X/kf+Q/2T/ZP9L/0r/yf/J/zYANAAAAf8AdgB2ACcAJQAbABsAv/+9/wsACwCO/43/b/9u/4//jv9X/1X/4f/g/7f/tf/Z/9f/1v/U/zAALgB1AHMAqf+n/1j/Vf+Y/5f/Zf9i/8P/wv95/3f/8P7t/hz/G/9d/1v/YP9d/4f/hf+J/4f/ov+f/08ATgCEAIEAGQAXAMX/w/+f/57/ef93/9j/1//B/7//iv+J/6b/pP9q/2j/uf+4/0oASQAuACwAZQBkAFkAWABQAFAAegB5ACgAJwC5/7j/hP+C/wQAAwDy//H/IgAhAOL/4f+N/43/7//v/+D/3//s/+z/KgArAGIAYwB3/3T/EgARAM0AzwAXABUACwAKAEQARQCi/6L/rP+r/0MARACY/5X/AQABADEAMgAkACQAKwAqAMT/w/8IAAcAIQAiAOb/5f/j/+P/9P/0/zUANQD6//n/r/+u/5P/k/8nACkAqf+o/4D/f/+p/6n/qv+q/8b/xf8NAAwA+P/3/7z/vf8x/zD/vf+8/0EAQQADAAMAx//H/1L/Uv9c/1v/GQAZAEgASACl/6T/4v/i/3j/d//x//H/4f/h/6//r/+i/6H/5f/l/4kAiQBGAEUAdwB3ABYAFQC+/77/LAAsALL/sv8KAAoAz//P/0H/QP8JAAkA2//b/zsAOwA4ADgAEgASACcAJwB5AHkAnQCdAC4ALQDW/9f/Jv8m/1T/VP/z//P/gv+B/6P/pP+c/53/BwAHAIcAiAAiACEARABFAAkACQB+AH0AhwCHAGcAZwCr/6v/hP+E/+T/5P8ZABkAbQBuAD8AQAC4/7b/fwB/AFsAWgBeAF0AJwAoAJz/m/+n/6b/dQB1ACwAKwA0ADQAAQAAALT/tP/8//z/zf/N/+r/6v8cABwABgAGAOoA6wCCAIIAqgCrACAAIQDd/93/pwCoAFIAUwAXABgA+//9/xIAEwBaAFoAnACdAM0AzgB2AHcAPQA+AK8AsACTAJQAygDMANL/0/9BAEMAq/+s/1AAUgBhAGIATwBRAFgAWgCyALMAzQDPADEAMgCSAJUADAANAFwAXwBzAHUACwAOABcAGQA7AD0AYABjAFcAWQBjAGUApACmAJ0AngCRAJMArQCvACQAJAB8AH8AVABVACUAJgD0//T/SgBMAAcABgCiAKQAVABVAHgAeQBrAG0ALAAuABQAFQAhACEAkwCVADgAOQCx/7H/2f/a/wIAAwDm/+X/NQA2AOb/5//0//T/HwAgAFkAWQD+//7///8AAP/////q/+v/TwBPABQAFADt/+7/1P/V/xgAGQAoACgAy//M/xoAGwCo/6j/CAAJAAgACQC7/7v/kv+T/8v/zP8ZABoAWQBZAHAAcQDz//T/yP/J/9D/0P9RAFIAwADBACAAIADc/93/GQAbAH8AgABgAGEA3f/f/0n/Sv/t/+7/oAChAFIAUgDR/9L/2P/Z/ycAJwCPAJAALwAvAGH/Yf8t/y3/9//4/1YAVQBWAFYAFQAVAKj/qP9AAEEAogCiAEAAPwDn/+b/Wf9Y/+T/5f9mAGUAVwBWANT/0/+X/5f/lv+U/2cAZwDX/9b/nv+e/zL/Mv+//7//HgAeANr/2f8kACQAe/97//3//f8XABcAlP+T/3j/ef9p/2n/Of84/wsADAAKAAoAFwAYAJD/kP+v/6//TQBOAG8AcAB8AH0Avv+//9D/0f/0//T/sP+w/yUAJwCG/4X/HwAgAF0AXgBWAFYAQQBCANH/0f8IAAkADQAOAJoAmwClAKUA5//o/6z/rf+1/7X/OwA9APv/+//6//v/xv/H/zMAMwCrAKsAqwCsAA8AEAC5/7n/+//9/+7/7v/k/+X/a/9r/0X/RP/X/9j/bABtAGMAYwA3ADgASABIACkAKQAvADAA/P/8/0MARADN/87/xv/H/ykAKgCQ/4//PAA+AAAAAAAwADAAggCDAMwAzACBAIEAbABsAHsAfACTAJMAhQCGAB0AHgDD/8T/CgAMADEAMQBDAEQAVABWALMAtQCwALEAqgCrAJkAmwCIAIkAtQC3ACwALQByAHMA7v/w/9f/2P9XAFoAEgAUAC8AMADHAMkArgCvAKoArAAZARsByADJADoAOgBGAEcAoQCiAHMAdQBuAG4A1//Z/wUABgAYABgAEgAUAKb/pv+B/4L/0v/S/z4APwBbAFsAr/+u/wgACQDh/+L/z//O//b/9v+t/63/cP9v/8j/yP/W/9X/qP+n/8b/xf/H/8b/rf+s/z4APQAKAAgAqgCpAEIAQADi/+H/PP86/wz/Cv9q/2r/Ev8Q/0j/Rv9t/2z/Xv9c/+n/5//S/9D/MQAwAHsAeQALAAoA9P/y/7//v/9b/1r/Rv9F/3H/cf9y/3D/6f/n/8b/xf/7//v/2v/Z/9D/zv9HAEYAYQBgAMz/y/+1/7T/jf+M/4X/g/9+/33/d/92/2L/YP8Y/xf/cf9w/wIAAgCR/5D/1v/U/ysAKwD///7/iQCIAPX/9P/L/8r/h/+H/4b/hP+h/6H/Af8A/xn/GP9K/0n/8v/w/9z/2/8FAAQAuf+4/2v/af8vAC8Aqv+n/+H/4P8//z7/7P7r/mD/X/+3/7X/JAAjAJL/j//w//D/5P/i/////v8vAC4AWgBZAKT/of8SABIAm/+Z/5T/k/9Y/1f/nP+a/9b/1v+2/7X/cQBxAIX/g/8UABQAlf+T/+X/5P8mACUAoP+e/6P/o/9V/1X/pf+k/yoAKQA7ADsASwBKANr/2f/s/+z/ogCjAGAAXwChAKEAOgA7AH0AfgBmAGYAhACFAG4AbwCv/6//JwApAMD/wP8MAA0ASQBKAGUAZwCRAJIAvAC9AKsArACGAIYAPwA/AEkASgBIAEkAbgBvAFYAVwAmACcAPQA+AOH/4/95AHkAgwCEANcA2QCwALEAeQB6AIIAgwC7AL0AcwB0AEIAQwBbAF0A/f///zQANABqAGsAbABuAOz/7P8tAC4ATQBOAIMAhAC7AL0AKwAsAJ0AnwBFAEUAhgCHAJUAlwDH/8f/OwA9ALH/sf/t/+7/3f/e/67/rv9NAE4AOQA5AFcAVgDGAMcAFgAWAG4AbgAeAB0ALgAvAJ7/nv8z/zL/Tv9O/2H/Yf+w/7D/rf+t/xEAEABfAF8AlACVAD8APwCWAJYAYgBiAGEAYQDK/8r/0//S/7D/sf/p/+n/EQASALv/uv8pACkASwBMABAAEABTAFMAXABcAG0AbQCgAKAAMQAxAJH/j/+u/67/k/+T/3z/e//R/9H/3//e/8j/yf9w/2//MAAxAGwAbACsAK0ACgAKAKP/o/8CAAEANwA4APj/9//Z/9n/k/+S/9P/0//6//j/9v/2/9H/0P+M/4r/2//a/9T/0v8uAC0AkP+P/4z/i//F/sP+BP8C/8//z/8T/xH/Of84/0P/Qv+6/7n/4P/f/zMAMgC5/7f/Ov84/7j/t/+o/6f/aP9l/xX/E//h/t/+pv+k/9T/0v84ADYAxf/E/2v/aP/B/8D/lf+S/7//vf+e/53/Mf8u/4D/ff9VAFUAg/9//3//fv9G/0P/u/+6/wgABwCX/5X/kv+R/0P/Qf+K/4n/bf9r/yv/Kv81/zT/P/89/wsACgDS/9H/Uv9R/8D/wP+x/7D/IgAiABMAEgBV/1X/Nf80/1b/Vv/a/9r/EgARAAMAAwDv/+7/5//m/08ATwB2AHYAlv+U/zz/PP9r/2v/Wv9Z/7X/tP/E/8T/YP9f/6L/ov/9//z/WwBbANT/1P9x/3H/H/8e/0T/Qv9kAGUA6f/o/6j/qP9j/2P/+//6/3UAdQDN/8z/oP+h/4n/if+b/5v/KAApAO3/7f8c/x3/Hv8e/3f/d/9UAFQA5f/l/ysALADs/+z/8v/z/xwAGwA+AD8A0f/R/9T/1f9VAFYACQAJACQAJQBQAFAAJwAoAI0AjgBCAEMA8v/z//3//P8WABgAPgA+AJ4AngCEAIUAOQA4AOv/7P9I/0f/5//o/5f/mP/H/8b/BwAIABYAFgBBAEEAVQBVABYAFQBtAG0AJAAjAFsAWgAmACUAmP+Y/6j/qP+j/6P/2v/Y/9//4P/v/+7/5f/k/wAAAABeAFwA+//7/0UARADqAOoALAArANL/0P8mACUAwv/C/6r/qP8BAAEAV/9W/5H/kP8NAAsAMQAvAFgAVwD9//3/8f/w/zoAOQCNAI0A2//Z/7r/uf9L/0n/rf+t/+T/4v81ADUAkv+Q/yz/Kv9Z/1j/yf/I/0UARAB0AHIAZQBkAKX/o/8KAAoAFgAVAJQAkgCXAJcAXf9c/zf/Nf+B/4D/bgBsAHAAcAC8/7v/Rf9E/6P/of/iAOEAggCBABUAFAA2/zX/MP8v/08ATgC6ALoAAQAAAJL/kv85/zn/ov+h/2IAYQCGAIUADwAPAJL/kv8uAC0APwA/AGAAYABoAGgAY/9j/4D/gP/L/8z/LAArANQA1QAtAC0ACAAIACkAKQDg/+D/mACYAGkAagC//7//nP+c/2r/af8jACQAZQBlADMAMwCp/6n/mf+Z/6gAqQDcAN0AawBrAHEAcgAbABwAu/+7/8IAwwBOAE4A8//0/0j/Sf+Z/5r/cABxAJ0AnQCFAIYAIAAhAEQARQA4ADkAtgC3APgA+QB9AH4AGgAbAH4AfwCKAIwAAQABANb/2f+D/4L/CgAMAFEAUgC6ALwAAAABAF0AXgAxADIA+AD5ADEBMwHLAMwAYwBkAJr/mv8DAAUA1//Y/5X/l/9w/3H/4f/j/6n/qf9uAHAAtgC3AIcAiQAIAAkA3ADeABQBFAHWANcAnACdANX/1v+9/77//P/9/9z/3f9+AIAAbv9u/6z/rv8+AEAAfQB+AFQBVQH3APgAawBsADIAMwC1/7b/CgALACoAKwC8/73/dP91/33/fv8lACcASQBKAGkAawAHAAkA5P/l/8MAxQAVARcBgwCFABMAFAAMAA4A0v/S/8EAwwDNAM8AxADFAB8AIQCm/6f/1P/V/zsAPgD7//v/r/+x/67/r/+w/7D/BAAFAGEAYgBSAFMAvP+8/+7/7/+QAJEAeQB6AE0ATQDS/9P/h/+H/0EAQwCg/6H/oP+g/7z/vf9LAEwAtgC2AH0AfgB1AHYAYgBiAHYAdgCjAKQA1v/V/3v/fP+m/6b/aABpALz/uv9gAGEAJP8k/0n/Sf/K/8n/uP+4/97/3f/I/8j/0v/T/xAAEACAAIEALAArAHUAdQDH/8f/b/9v/6n/qf8JAAoAhv+F/wQABQDW/9b/P/8+/4cAhwAnACcAMAAvAGIAYgBJAEoASQBIAKcAqADq/+n/Kv8r/4r+if5q/2v/2f/Z/63/rf/h/+L//////4P/g/8DAAIAcABxALX/tP/H/8b/fP96/w0ADQDO/83/2P/Y/wj/Bf/P/87/AQABABIAEwDT/9L/xv/G/wwADQCZAJsAbwBwANQA1gD8AP8AxADIACUAJgBTAFUA/v8BAKMApgCbAJ4A9//5/+IA5gA/AEEAwQDDAEAAQADsAO4ARQFHAfn/+f8bABwAVABUABwAHQD7//v/g/+B/wr/B//Z/9j/l/+V/5j/lv++/7z/eP90//D/7v8AAP7/2f/X/33/ff/X/tX+cP9u/1sAWwCGAIcA4//i/5X/lP+o/6j/MgAyAIwAjAA6ADoAy//O/6P/pf96AHwAmACZACUBKQFtAHAABwAJAN0A4QAVARcBGwEeAf4AAwE8AD8A9P/2/6AApAATARgBjACPADgAOwCAAIMAygDPAAYBCgF8AH0AlQCYAOcA7ACIAIoAdwB3AHYAeADBAMMAAwAFACT/JP/N/87/IgAkAIUAhQC5ALkA3//e/3QAdwD2//b/HgAcACsAKgCm/6b/k/+T/wz/Cv+F/4P/hwCHAEQARAA6/zj/L/8t/6X/o//f/97/sv+w/0D/P/8T/xH/e/97/+H/3/9rAGkAKQAoALr/uv/1/vT+2//b/2QAZACt/6z/RP9D/wv/C/+v/6//YABhAHgAeACPAJAA/f/9/wgACQAAAQEBygDJAIwAjAARABIAjf+N/6n/qf9XAFcAhgCGACgAKACi/6L/ZP9k/0MAQwDLAMoAXwBdACcAJwDA/8D/6P/m/5gAlwCX/5T/O/86/7z+uv7y/u/+xP/C/wIAAAC5/7b/Of83/6//rf/v/+z/MgAvADkANwCZ/5b/j/+M/9b/1P96/3b/pv+k/6L/n/9X/1X/t/+1/wcABQAFAAMADAAKACQAIwAfAB0AUABPAHwAewAdABsATABNAI7/jP/m/+b/5f/m/3T/c/91AHUAOgA6AL8AwAB7AHwA6v/q/wcBCAFUAFUAhgCHAOYA6QCo/6n/AQADAEoASwBtAHAArwCxAAUABwBVAFcA5QDnAMUAxwCSAJQAPQA/ABAAEQAxADMATABNAA8AEAAYABoAFQAWAE4ATwBCAEMAzP/M/3UAdgBTAFMA9//3/8P/w//t/+3/8v/y/wwADABUAFQA+v/6/7n/uP9QAFEA7f/s/x4AHwDd/93/Yf9g/8j/yv9i/2H/kwCUAFwAXAAJAAsA1f/W/z8APwB4AHkA3wDhAGYAZwBZ/1v/Zv9p/0QARQC2ALkAHQAdAAgACwDX/9r/GQAbAPgA/ABbAV4BtAC2AJkAnACjAKYAYgBkAHoAfQAoACoAgQCEAFMAVQCgAKIAqQCrAI0AjwBvAHEAMgAzAKkAqwAiACMA+f/6/9//4f9S/1P/zv/P/1wAXABPAE8APAA9AGH/YP+h/6H/GgAbAFD/T/+k/6P/Xv9e/xr/Gf+c/5z/bf9s/xgAGAD4//f/3f/c//L/8/+i/6D/EgASAKz/rP+Q/4//o/+j//X/9f+3ALgAcgBxAGsAbACY/5f/j/+Q/5z/m//n/+f/6//s/7v/u/9u/27/4//k/0UARgCPAI8A/v/+/4z/jP/j/+T/FwAXADcAOAB3/3f/6f7q/kn/Sf8nACgAPQA+APn/+f/a/9r/3f/d/04ATgAkACMAgP+A/6D/oP+p/6n/nv+c/xYAFgBE/0L/lP+U/wYABAAPAA0ANgA2AIz/if91/3T//P/6//n/9v9z/3H/Kv8o/7H+r/7//vz+nf+b/8n/x//l/+P/f/98/wsACQBqAGcAJgAlAMD/v/+W/pP+Wv9Y/9D/zv/P/87/W/9Z/13/XP+m/6T/FQAUAAUABAD9//z//v/9/xwAHACy/7H/GgAaAI3/i//e/9z/AwEDAZYAlQDP/87/w//C/18AXgBQAE8AcwBxABoAGgCG/4X/lACTAKoAqgBtAGwAFwAXAI//jv8YABcAgwCDAOf/5f/n/+X/EQARAK3/rP9WAFMA/f/8/2z/av8m/yT/zf7L/gT/Av82/zP/v/++/4n/hv+o/6b/hv+E/3z/ev/j/+H/wP++/3X/c/8k/yL/N/82/5L/kP9NAEsAz//N/9j/1/+v/6z/WgBZACcAJQDm/+b/hP+C/3P/cf/I/8f/qP+n/6X/pf8Z/xn/Nv81/yEAIQBVAFUAoACgAFQAVAD4//j/DQAOABwAHABOAE8A0P/Q/xb/Fv9I/0j/VABVABYAFgBmAGUALAArACoAKgBuAG4AegB6ALIAsgCkAKMA4//j/5v/mv+j/6L//P/7/xkAGACh/6D/3f/c/6v/qf/j/+L/TwBOAGAAXgB8/3r/sf+x/1j/Vf9BAEAANQA0ANX/1P9r/2n/hv+F/zcANwDb/9r/0f/Q/z3/PP/W/9b/fwB9AJoAmQBaAFoAXf9c/5T/k/8sAC0A+v/5/9H/0f+d/53/ev97/4P/g//J/8n/8v/y//3//f+P/47/xwDIAHEAcAAQABAAFgAVAGz/bP8G/wX/0v/T/4v/iv8N/w3/Zv9m/4z/jP9s/2v/HAAcAHwAfACKAIoAAgACAC0ALQAKAAsAhf+D/zoAOgDS/9L/5f/k/9D/z/+R/5H/NgA2AM7/zv+E/4L/o/+j/3P/cv8MAAsAkf+Q/7L/sf+u/63/kf+P/+T/4v8XABYArP+r/83/zP9c/1r/hP+D/7n/t/+8/7z/HwAdALb/tf/H/8b/JgAlADsAOwBVAFQAFQAUAEYARwBuAG4AhQCEAEkASQCy/7H/ov+j/0L/Qv+P/4//if+J/77/vv8YABgAGgAbABsAGwAmACYAbABuACEAIQBnAGkAFwAXAA8AEADY/9n/AQACACoAKwBsAG4A0gDTAGAAYQC8AL4AlQCVAFoAWwCTAJUAOQA5AAoACwDV/9b/of+h/xj/GP9e/1//u/+7/wwADADt/+3/GwAbABkAGACbAJsAbABrAE4ATQAWABYASf9H/wMAAwDH/8b/U/9R/w7/Df/o/ub+PP87/0AAQACKAIoADQAMAM//z/+9/73/eAB3AI8AkACQ/5D/JP8k/8T+w/61/7f/UABPAPf/9/8bABsANAA1ANr/2f/rAOwAmgCaAGcAaAAGAAcA5f/m/3P/c/8XABcAjwCQAC8ALwDq/+v/VQBWAMcAyACEAYUBZgBmAJ3/nf/E/8T/+//7/58AnwCm/6f/vv69/rX+tP6z/7P/ogChAAYBBwHd/9z/1//W/3cAeACFAIUATgBNAJX/lP+1/7X/1//X/wUABAB1AHUA9f/0/0H/QP8X/xb/7P/s//z/+/80ADMAJAAjAIv/if8+/z3/LgAtANj/1/8uAC4Akv+R/0z/S//p/+j/x//G/2UAZQBeAF0Ayv/I/7H/sP9PAFAAQgBBAKMAowB7AHsAdQB1AOv/6v9Z/1j/5f/l/2P/Y/8k/yP/Of85/5T/lP8wAC8AcwBzANwA3AC+AL4Azf/M/2sAbAC6ALoAjgCNAD0APgAx/zD/Zf9m/+L/4v/9//z/FAAWAE//T/+s/63/TABMAKgAqQCiAKMAVgBWAD4APwB0AHQA2QDaAP3//v8YABgATf9N/z3/Pv/y//H/mwCbAI4AjgASABIAHgAeALv/uv+8AL0AjQCNAN3/3f+c/53/PQA9AB0BHgGnAKcA9//3/zT/Nf/Q/9D/EwAUABwAHQCd/57/fv9+/+j/6f94AHkAMQEwAQQBBgFAAEIA5//n/1QAVgBqAGsA6wDsANUA1wAUABcAwf/C/63/rf96AHwAUwFVAbQAtQDy//T/LwAxAMr/y//lAOcASQFLAdn/2v+j/6X/vf++/+QA5gAJAQsBZwBpAK3/rv+C/4X/0//W/1gBWQGGAYkBnf+e/6H/o/+LAI0AIwEkAeYB6AH9AP8A9P/2/14AYAA5ATsBaQFrAbsAvAAlACcAX/9h/2AAYwDIAMkAowClAMYAygBAAEEAdgB5AC8BMgE+AUEBfQB/AAYACQBi/2b/FQAXAIAAggAAAAIAnv+g/+v/7v8TABUAyADKAEYBSAHQANQAAQADAAMABgDhAOQAyADKAEsATgDQ/9L/FgAZAAUABwCzALUAngCgAPf/+f81ADcAdgB4AKwArQD4APsAIgAkADgAOgCEAIYAowClAG4AcADJ/8n/vP++/1v/W//A/8L/yv/M/97/3v8bAB0ADAANACoAKwD6//r/RwBHAC0ALgBzAHMAVf9V/27/bv/F/8b/Vf9V/7n/uf/e/t7+MP8w/zkAOgCpAKkA2gDZADIAMwCT/5P/BQAFAJQAlAA3ADcA1v/X/4H+gf7x/vL+EQASANX/1f+B/4L/I/8j/5D/kf+YAJgA1gDXAAgACAAJAAsAl/+X/7gAuQAUABUAK/8r/0P/RP8z/zP/O/87//f/9/9eAF8ACAAHACoAKwCT/5P/g/+C/xgAGACLAIwAGwAaABIAEwA6/zr/v/6+/rP/tP8WABYAsf+x/57/nv/7//v/EwATAAcABgCv/67/Xf9d/4X/hf8iACIA4P/f/+z/7P+p/6n/Wv9a/0AAQQB5AHkAVQBWAM//0P+J/4n/sv+y/6YApwCDAIMA5v/n/+b/5v/U/9X/HAAcAGYAZQAjACQA2v/a/zYANwBxAHIAHwAeAK//sP9//3////8AACEAIgD1APYAaABpAFUAVwAaARsB9QD2AP0A/wClAKYAt/+6/+z+7P4AAAIAJwAoANIA1ABGAEYAmf+Z/64ArwChAKIAoQCjAFwAXABPAFEAzv/P/xwAHABQAFAAgf+B/xP/FP/P/s/+av9p/6oAqgCbAJwAIwAiACsAKgA2ADUAhgCFAHUAdQBrAGsAwf/A/8z/zP/R/9D/7v/t/xUAFAArACsACgAJAGb/Zv8mACUAFwEYATcANQAEAAMAzP/L/4L/gv9JAEkADQEOAQn/CP/+/v7+j/+Q/14AXQAZARoBLwAvAIT/hP+l/6f/OwA7AE8BUAHXANcAxgDHAKkAqgB9AH0AJgEoAUUARQDa/9v/yP/H/7EAsgBfAGAAOwA8AJYAlgA6ADsA/AD8AJcAlwDq/+r///////v/+v9gAGAAgAB/AE0ATQDr/+v/2f/X/wEAAgDr/+r/+//7/xQAFABbAFoASABIANf/1/8SABIAZf9l/+D/4P8fAB8AKQAoAPL/8v/w//D/BgAHABQAEwCkAKUAsv+x/9j/2P/r/+v/5//n/93/3P8nACcAGgAaAGUAZAAWARYBdABzAI0AjQDH/8b/0//U//T/9P8bABwA6P/n/00ATgB4/3f/eP94/9n/2v9o/2f/GwAbACIAIgADAAMAjACMAHAAbwBjAGMAzP/L/wMABAAJ/wj/kv+R/6j/qf9p/2j/t/+2/6z/rP+BAIEADgAOAH0AfQAtACwAgwCDANIA0gCUAJMAvf+8/0z/S/9h/2D/mP+Y/xgAFwDT/9H/lQCUAOT/4v+z/7L/hACDAOH/4P/e/97/xP/E/xb/FP/n/+b/iACGACQAJADb/9r/V/9W/zL/MP9QAFAAdwB3AEH/P//p/uj+W/9a/2oAaQCBAH8AtP+z/0b/Rv8E/wL/7P/q/8AAwACY/5f/3v7d/jL/Mf++/73/bQBsAJEAkQCD/4H/TgBOAHsAegAVABQAcv9x/6H/of8j/yL/iv+K/5P/kv8OAA8ADgANAFkAWQCJAIkAQwBCAMT/w/9B/0H/0P/Q/zX/NP9d/13/Rf9F/7D/r//3//j/sv+w/83/zP/m/+b/CwAJAGsAagDcANwADAALADj/N//y//H/5f/k//b/9f8j/yL/0f7P/nz/e/9MAEoA3wDeAPH/8P9o/2j/q/+p/90A3ABLAEoApv+k/y3/Lv8A//7+OQA4AD4APABBAEEAFP8T/3b+dP43/zX//f/8/8P/wf9OAE0ABv8E/5r/mP+FAIUA/P/6/w8ADgAq/yj/xP7D/lf/Vf/Y/9j/5//m/3z/e//9/vz+AwACAPT/8//GAMUA5v/l/xP/Ev/C/8H/2v/Y/+X/5P/B/7//y//K/8L/wf8X/xb/lf6T/vH/7v94AHcApf+i/zT/Mv/U/tL+of+g/3YAdABI/0X/iv6I/t/+3f6g/5//7P/q/+j/5v90/3D/bP9r/3j/df+CAH8AaABmANj/1f9q/2j/EP8N/6H/n//b/9n/0v/Q/37+e/6E/oL+Jf8j/wwACwDo/+X/o/+g/5X/lP/B/7//kQCPAHkAeAD///7/OP83/w7/Df9y/3H/8/7z/kT/Q/+W/5b/Cv8J/+X/5P+RAJIAogChACIBIgEvAC4ACgAKAOH/4v/h/+H/tv+1/6T/pf/x/vD+Jv8n/zX/Nf/A/8D/swCzABYAFQB2AHYAegB5AHsAewBsAGwAYQBhAM3/zP+X/5f/Jf8k/5//n/87ADsA2P/Y/8n/x/9qAGsA8QDxAGQBZAF2AHYACwALAM//z/99/3z/t/+3//v/+/8c/xz/ff58/lL/Uv8fAB8AuQC5AM4AzwBMAEsAegB6AKwArADRANIAFQAVAPT/9P/U/9P/tf+2/8j/yP+4/7j/Z/9o/6P+ov4XABgAaABoADUANgC6ALoATQBNALsAuwCIAIgASwBKADIAMgCR/pD+o/6j/ir/Kf+t/63/Wf9Z/0L/Qf+h/6H/JwAmAPAA7gC4ALcAFAATAAIAAQAx/y//P/8//3n/d//r/ur+G/8a/0H/QP+0/7T/rf+s/yUAJACNAI0AUgBSAJsAmgC8AL0AyQDJAAMBAwFYAFgAsP+w/3UAdgAeAB0APQA+ALv/vP98/3z/wv/D/8b/xv+/AL8AKAAoABcAFwBTAFMAaQBqAPP/8v/g/+D/Hv8e/3r/e/+j/qL+rP6s/lP/Uv+6/rr+9f72/tT/1P+7ALsAFgEWAaIAogB//33/eQB6AKYApQDsAOsABQAFAF3/Xf8a/xj/uwC8APcA9wAbABsAIQAiANX/0//0APUAkQCRAHAAcABk/2X/wv7D/l7/Xv+fAKAASQBKAGb/Zf8kACYA0v/R/5oAnAAYABkAvv++//f/+P/z//X/SgBLAIsAiwAnACkAUgBSAOgA6gAtAC4ApwCoAOQA5QBcAVwBFwEYAZoAmgAqACoAsv+z/+wA7QCzALMAJAAlAOv/7P+aAJoA6ADoAG0BbgFXAFYARgBGAKIAowCXAJcAVgBWAPf+9/4+/z//2/7a/hoAGwDF/8b/gv+C/2L/Yv9Q/1H/LAAtAMIAwwDiAOMArQCtABMAFAAyADMA+f/5//T/9f8rACwAA/8D/xQAFgCpAKoAmgCaAMMAxACIAIkAcABxALIAswCzALQAyADKAEUARQDD/8T/r/+w/+r/6/9FAEUAjQCQAKH/of9T/1T/x//J/58AnwDRANQAr/+w/9X/1v/N/87/sACyANEA0gCt/67/h/+J/5j/mP9yAHIA+AD6AKT/o/8PABEAXQBdAGgBagHSANIA8f/x/zP/NP8bABwAyQDJAL8AvwDn/+j/k/+T/7H/sv8sACwAFgEXAVv/XP8//0D/MAAwAD4APwCLAIsAYQBiANL/0/+CAIQAVgBWADkAOgDu//D/T/9Q/4kAigDjAOQA6QDqAJsAnAAXABgAJwApANgA2AAqACsAMv8y/yL/I/9F/0b/WwBdAAAAAADc/97/vP+8/0IAQwD8AP0AcgByAFT/VP9p/mr+Rv9G/5kAmgCtAK4Aaf9p/27+bv7E/8X/CwALAPIA8gBSAFMAvP+8/7f/t//z//P/DAAMALz/vf9N/0z/nv+f/2D/X//r/+v/lv+W/wf/B/8NAA0Ayv/J/zUANQAsACsA6v/r/yUAJgCo/6j/igCLAL//v/8BAAIAlv+W/yr/Kv+y/7L/n/+f/wwADQAYABgAYwBkAPz//P80ADQAFgAWAO7/8P9XAFYAoQCjAPj/9/9JAEoA7//w/8T/xP89AD4AowCkAOH/4f+r/6v/Zv9m/08AUAAVABUAWgBbACsAKQDHAMgAcwBzAOgA6QCL/4v/lP6U/qT/pf+H/4b/SwBMAD7/Pf8//0D/g/+C/3QBdgFcAFsAjACMAE8ATwDDAMMA4gDjAEH/Qv+g/6H/aP9o//3//v8wADAAk/+T/zUANwByAHEArACtAOEA4gBIAEgAsf+y/7//wP+l/6X/xv/H/3z/e/9p/2n/kQCSALIAswDQANEA7v/u/xEAEwDbANwAtgC3APX/9v/M/8z/tQC3APUA9gBWAFcABQAHAD0APgDlAOYATQFPAT0APwD1//X/3QDgAAkBCwFKAEsAEQAUAOT/5v+ZAJwAWABZAOX/5/9dAF8A5QDnAKkBqwFPAFEAawBtACIAIwCwALIAywDMAKkAqwDtAPAAvQC9AJkAmgBMAE4AKwArALX/t/9dAF4AOwE8AfX/9v9PAFAAnACeAO0A7wA7ATsBCAAJAOv/7P80ADYAIAAhAPT/9f89/z//BAAEAG0BbwH6APsAYQBiAGr/a/8/AEEANQA1ALkAugCp/6r/JP8l/0MARABVAFYAKgArAOH/4v9/AIEATABNAAcACQCBAIEARABEAHcAeQCWAJcANgA2AIsAjQBAAEEA6v/r/7j/uf9DAUQB5gHnAakAqgBh/2P/gv6C/qgAqQArAS0B4v/i/3P/df96/3r/UAFSAUYBRwEFAAYAdv53/m//b/+HAIgA6//r/w4ADQA5/zr/9P/0/7MAswCu/6//MP8u/z7/P//J/8n/bgBuACkAKgBq/2n/kv+S/9b/1v+g/5//iP+J/+D+3v5rAGwA0P/O/0oASQADAAMAegB5AC0ALQAXABgAtP6z/tL+0v5r/2z/nv+e/9n/2f8Y/xj/QQBCABIBEgFXAVgBqgCqAB4AHQB/AIAAQwFFAeT/4/85/zr/ev57/kr/Sf/S/9P/GAAZAKH/of/5//r/BQAEAHcAeAATABMAkv+R/wUABQBbAFsABwAGAGj/af/h/uD+0v/R/wwACwCPAI4AQv9B/7L/sP+IAIgAvgG8AR0AHABd/lv+kf+Q/58AngAMAAoArf+s/33+fP7q/un+DQALAOn/5/+R/5D/BP8D/6v/qv/v/+3/TABLACP/Iv+M/ov+f/59/sj/yP83ADYAEQARAPL+8v73/vb+/v/+/+MA4gAIAAkAhP+D/6P/o/+pAKkAIgEiAcwAywAzADMAvv++/3//fv8kACQADAANACgAKADz//L/0f/R/wAAAACWAJUA2ADXAOr/6f9T/1T/gP+A/7n/uP9OAE0Al/+Y/zr/OP/RANEA8gDyAAwBDAFn/2X/W/9b/7AArwCsAKsAUv9T/3f+df6T/5T/l/+V//8A/wD8//z/Yf9f/+UA5ACIAYcB8QDwABgAFwBR/1H/0P/P/4sAigDG/8X/B/8G/xf/F/99/3z/5QDlANkA2AA2ADYA/P/7/1H/T/++/73/pf+k/07/TP9J/0n/mP+W/+z/6/9k/2P/3//e/z//Pf/V/9X/bQBsAOH/4f9z/3H/af9o/zMAMgBTAFIACgAJAD//P//z/vP+Dv8M/wMAAgBGAEUABwAHADAALwC6ALsApv+k/0X/RP9F/0T/xf/E/xEAEQCvALAA7//s/w3/DP/r/+n/WwBbAKsAqgDJ/8f/b/5u/uj+5f6C/4D//P/6/9T/0v9OAE0At/+1/6X/ov8IAAYA+f/3/w//D/8R/w//Ov85/w3/C//8//r/LgAsAMH/v/8lACQAr/+u//7//f9HAEYA9f/z/0IAQAAEAAQAc/9x/7//vv9w/3D/B/8G/1T/U/+t/63/fwB/ABcAFgC6/7r/kv+S/5kAmAAcARsBIgAiAAj/CP8x/jD+Rv9G/+QA5ABh/2D/lv6U/lH/Uf+wALAA8wDyAO//7v9C/0L/yP/H/7EAsQAGAAUANv82/03/Tf9sAGwA8ADvAL3/vP/P/s/+dP9z//4A/QAFAQUBHgAeAML/wf+bAJsAyQDHAAAAAADV/tX+jv6N/nsAewBmAGQA4f/h/2D/YP8zADIATgFNAcEAwAA1/zX/3f7c/vr/+/9LAEoAS/9J/4T/hP/j/uL+HQAdACcBJwGO/4z/1P/U/ycAJwCNAIwANwA3AFz/W/8e/x3/DQANAAgBBgGUAZQBKgApAK3/rf8sACsAMwAzAOj/6P9W/1X/xf/F/4L/gv8yADIAigCJAGf/Z/99AHwA/AD8AHoAegCU/5P/pv+m//j+9/70//T/h/6F/mz/bP9w/3D/3P/b/6oAqQBdAFwAqgCqAIgAiAB//37/VwBXAE//UP+3/rb+6v/p//j/+f+mAKYAl/+W/24AbgCWAJYAnACbAI4AjQCy/7L/mP+X/1QAUwABAAEAd/93/97+3P5NAE0AXgBdAOz/6/+y/7L/hP+D/4n/iP9G/0b/1/7X/kj+R/7+/v7+XgBdABwAGgDU/9P/KgArANX/1P8hACEALgAtAG0AbQCQ/5D/7f/t/3kAegBbAFwA2gDbAJL/kP/A/8H/r/+u/xQAFACn/6j/DAAMAGP/Y/8MAAwADwAQAPD/8P8tAC4AYP9g/6v/q/9+AH8Aaf9p/4P/hP/o/uj+Zv9m//n++f66ALsA1v/W/+H/4v9oAGgAQAA/AFIAUgCc/5z/3//f/4r/if9H/0f/Vv9W/1r/Wf97AHsAwP/A/0f/Rv/9AP0AKwArAJoBmwH///7/WP9Z/2H/Yf8vAC4A3wDfAF//X//Z/tr+ov+h/0YARwBfAF4AJv8m///+/v5kAGUAOQE6AUAAPgCw/7H/5P7k/vr/+/+7ALoAIwAjAC7/L/++/73/DAANAKj/qP+9/73/VQBVADYBNwEZARkB4gDiAPYA9wCQAJAAfQB+AP3+/f6//8D/5//n/30AfgCQ/5D/HAAdAGQAZQAJAQgBOgE6AZcAlwDp/+j/1v/W/5L/k/8j/yH/6v7q/rD/sP87/zj/v/+//9z/2//V/9P/fwB/AIMAggDp/+j/xv7F/hX/FP/t/u3+4P/g/5T/kv9WAFcA4v/h/wsACwCcAJwASwBKAC0ALQByAHIAy//K/4r/iv8+AD8ARQBFANgA2QCsAK4ApP+k/+j/6f9z/3T/4//k/x3/Hv9eAF4AQgJDApQBlQErACsASP9K//D+8P7O/8//2/7b/m7/b/+s/6z/ngCfAL4BvwHpAOkAMwA0AEgASQCxALIAVwFXATAAMQB8/37/7v7u/vn/+v86ATsBnACdADYANgDpAOoAnwGfAbgAuACW/5f/bP9s/8X/xv8HAAcAjP+N/xD/Ef/W/9X/RwBIAOcA5wAnACgAFQAWAJEAkQBRAFEA2//b/1oAWwBwAG8ADAANANIA0wCr/6v/kv+S/10AXgD5//r/CQAKALgAuQALAAwA0QDRAJQAlQDR/9L/XgBeAPL/9P/d/97/IP8h/zH/M/9G/0b/pACmADQANQCAAIEAjgCRAI0AjwBMAU0BQAFCAd7/4P8jACUATAFNAdAA0gD2//f/gP+C/0IARACLAIsAGQAbAOL/5P/I/8j/PgFAAYcBiAH8//3/8//1/5j/mv/z//P/Of86/+H94v1l/mT+8gDzAOIB4wG4ALkAXABeACgAKQCGAIcAKAEqAZH/kv/9//3/BQEGARYBFwH6//n/PwBAAA4ADgDMAMwAvgC/AA8ADwCLAIsAWwBcAOT/5P/+/v7+8/7z/tP/1P8QABAAvf+9/7//wf+7/7v/SQFJAfP/8/+a/5v/9f71/oz/jP+v/7D/GgAbALcAtwCpAasBPAE9AZsAnABCAEIA8gD1ADAAMAAsAC4AxP7F/m7/cP/t/+//hQCGAH4AfwDO/8//4P/h/7wAvQCOAJAAAwAEAIn/i/8k/yX/0P/R/zcAOQDH/8j//v7//qz/rP99AH4AowCjADEAMQCS/5L/Hf8d/97/3/8b/xr/m/+b/8P+wv6ZAJkAdv90/2cAZwDm/+X/0f/R/+n/6P84ADcAFAATABkAGADT/9L/u/+7/ysAKgDN/8z//v/9//L/8f/s/+z/uf+3/2wAbABs/2v/r/+u/8D/wP//////a/9q//D/8f+cAJoAewB9ANcA1wAuAC4AW/9b/2b/Z/90/3T/CgAKAF7/Xv+n/qj+QQBCAP8A/wA1ATcBtAC0AJL/k/+Y/5n/zwDQAI//kP+N/43/HP8c/zoAOwCFAYYBxQDFAAkBCgHqAOsAo/+j/0QARgBk/2X/K/8r/3H/cf9l/2X/uf+6/9f/2f/MAMwA+P/6/4b/hv/Q/9H/HAEcAREBEwG//r7+2/7c/ub+5/5NAE0ATAFMAbr/uv8n/yb/XQBdAKcBpgENAQ4BFAATAJf/lv+CAIIAvwG/AXsBewFV/1T/B/8H//D/7/+oAKgA/P/8/7z+vP4L/wv/OwA6AKsBqgH9AP0ADgAOAIb+hf5K/0r/wgDCABb/Fv+d/pz+Ff8V/zIBMgHUAdMBgACAAJb/lv/sAOsAZAJkAkYBRQFT/lP+of6h/kYARgDfAd4BEgASAAf/Bv8AAAAAagFpAeAB4AHF/8X/Sv5K/l0AXQCqAKoAzv/N/3j+eP5v/2//SgBKAD4BPgE7/zv/3P7c/oMAgwDhAOEAlQCVANj/2P9GAEYAIwEjAZ0AnAC5/7n/Kv8q/+D/4P81ATUBOwA7AA8ADwCEAIQANwE3Aa4ArgCqAKoABAAEAJcAlgA7ADoALv8u/1//Xv8w/zD/BAAEANr/2v/G/sX+mP+Y/6v/q//CAMIAyADIANv/2//8//z/af9p/3kAeQBN/03/zP/M/y7/Lv86ADoAQQFBAR4BHQF4AHgAIv8i/0EAQQDiAOIATgBOAPv++v5//n/+o/6i/twA3ABCAEEA+//7/+v/6/9PAE8A+v/6/2MAYwAc/xz/bv9u/y8ALwBf/1//pf+l/87/zv/j/+P/YQBhAGr/av/q/+r/9v72/kMBQwFpAGkAEQARAAsACwDw//D/kQCRAGcAZwB1/3T/Y/9j/6T/pP/iAOIAtgC1AFn/Wf+t/63/GwEbAesB6gGM/4z/Z/5m/hb/Fv8rACsANQA1AP3+/P5z/nP+KP8o/1wAXACaAJoAVQBVAFcAVwCXAJcAugC6ALD/sP/n/uf+qv6p/k7/Tv/o/+f/RABEANr+2v6p/6n/wAC/AG8CbwLpAOkA+f/5/zD/L/8hACEANv82/779vv0s/iz+zf/M/8sAywDe/97/av9q/zcANwCCAYIB3wDfALP/sv/d/t3+PP88/0X/Rf93/nf+Pv4+/v3//f9RAFEA6P/o/7v/u/9V/1T/fgB+AJYAlgBYAFcA+P74/jT+NP5Z/1n/vf+8/6H/of+R/5H/t/+3/1QBVAHnAecBnwCfAIT/g/8UABQAAAEAAfwA/ADu/u7+6P3o/V7/Xv/xAPEApP+k/33/ff8I/wj/8f/x/1QBVAHmAOUAbf9t/+f+5/66/rr+WABYANj/2P8u/y7/wP/A/7D/sP99AH0A7//v/8P/w/92/3X/8P/w/zgAOAApACkAgwCDAMn/yf+WAJYArwCvAOX/5f+s/6z/Af8B/zT/NP8d/x3/RgBGAPz+/P7o/+j/OwE7AXMBcwFGAEYAU/9T/93+3f4G/wb/4v7i/jb/Nv9+/n7+w//D/60ArQAgACAAfAB8AMIAwgDVANUAjgCOAD0APQDY/9j/Uv9S/+L/4v+nAKcAgACAAAQABAA9AD0ATwBPAHwAfAC+AL4A7v/u/1kAWQDZANkA6P/o/07/Tv8DAAMAYQBhAOT/5P/e/t7+oP6g/nz/fP9MAEsAyADIAMP/w/+S/5L/mQCZAGwAbACiAKIAf/9//2T/ZP9b/1v/rQCtAEEBQQHW/9b/6P/o/xoBGgHNAM0A4gDiAKQApABn/2f/sACwAFAAUAAQABAASgBKABn/Gf8xADEAF/8X/2//b/+D/4P/4//j/yEAIQCM/oz+8wDzAAMAAwAqACoA4QDhADcANwBpAGkA/wD+APH/8f/9//3/iQCJAMcAxwAHAQcBZv9m/18AXwCeAJ4AhgCGAMgAyADy//L/pP+k/2oAagA1ADUAo/+j/+7+7v4k/yP/KAAoAMD/wP+OAI4AcQBxAA4ADgDx//H/vP+8/+n/6f/3//f/Qf9B/9L/0v8JAAkAhACEAGQAYwBn/2f/NAA0AEsBSwHXANcAx//H/3L/cv82ADYANAI0ArQAtACV/5X/kP+Q/yUBJQHbANsAe/97/xX/Ff8PAA8AoQGhAeUA5QCx/rH+hP6E/oAAgAD+Af4B5wDnACsAKwDO/87/g/+D//3//f8w/zD/p/6n/t3+3f7nAOcAIQAhAL7+vv50AHQA3v/e/w//D//9/v3+7/7v/uUA5QCRAZEBBAAEAEv/S/+p/6n/CgAKAIH/gf///v/+cf9x/xcAFwB6AXoBswCzAJH/kf/J/8n/VABUAMr/yv8q/yr/hv+G/3wAfACyALIABgAGACEAIQDH/8f/Jv8m/3n/ef8P/w//PQA9ACQAJACMAIwAmACYAJH/kf/m/+b/5P/k/wgACABLAUsBDAAMAC3/Lf+8ALwA6gDqAPAA8ABT/1P/mf+Z/9IA0gBTAVMBjgCOAKj+qP4y/zL/QwFCAZf/l/8P/g/+kv6S/tT/1P97AXsB9v/1/xb/Fv/O/87/ZABkAJAAkAD7/vv+zf7N/j4APgAYABgAcP9w/5D/kP+gAKAA6gDqAIcAhwCi/6L/OgA6AJkAmQC7/7v/UP9Q/83+zf4aABoAkwCTAOj+6P63/7f/bABsABMAEwB7AHsAMgAyABYAFgDY/9f/df91/yn+Kf6+/r7+Pv8+/x8AHwDb/9v/8//y/xQBFAFJAUkB7gDuAB0AHQCx/7H/LwAvAHD/cP/x//H/SQBJAAoBCgE0ATQB2v/a/xABEAHX/9f/pf+l/5n+mf5k/2T/NAA0AGwAbACA/4D/Hf8d//UA9QBbAVsBx//H/+L+4v7H/8f/jQGNAQQBBAGi/6L/cv9y/y4BLgH2AfYBMgAyAAj/CP9X/1f/4wDjAFoBWgEJ/wn/0P7Q/pgAmABJAEkASABIAGP/Y/+h/6H/tf+1/9H/0f/q/ur+Rf9F/+P+4/7dAN0AbABsAD8APwCL/4v/+P74/p0AnQByAXIB0v/S/9P90/2g/p/+DAAMAA0CDQLV/9X/tf61/mj/aP+KAYoBhAGEAeL+4v7v/e/9bv9u/yUBJQG7/7v/gf+B/1z+XP7+//7/TQFNAej/6P+e/p7+Df8N/yUBJQFuAW4BDwAPANj/2P9UAFQAHgEeAWQAZABY/1j/D/4P/qj/qP8VABUARv9G/9H+0f6g/6D/5gHmAW0BbQEdAB0A5//n/4EAgQDgAOAA8P/w/6X+pf5dAF0AsAGwAe0A7QDI/cj9x/7H/v8A/wDJAckBgwCDAKj/qP9D/0P/lACUAEABQAF+AH4AGv8a/xoAGgCg/6D/f/9//73+vf7Y/tj++wD7AKsBqwFPAE8AGgAaAD//P//OAM4AwQDBAOf+5/4w/jD+gv+C/z8APwBv/2//Yv9i/6UApQDzAPMAZQJlAlcAVwBC/kL+Mv8y/0IAQgC1ALUAVABUAKP/o/+e/57/3QHdAbABsAHeAN4A/v7+/gH/Af8qACoArf+t/7T9tP1o/mj+k/+T/zYCNgJmAmYCcf9x/yAAIAAEAQQBSAFIAT3/Pf8h/CH8a/5r/p7/nv9WAVYBBgAGAAoACgDiAOEAGwIbAmQBZAF6AHoAPgA+AG7/bv9x/3H/g/+D/8b+xv7L/sv+9f71/qgAqABjAGMAIv8i/5b/lv+9/73/sQCxAMv/y/9F/0X/i/+L/1z/XP/g/uD+hv+G/6r/qv9xAHEAoQChAIj/iP+B/4H/6wHrAbUBtQFqAGoA4P7g/uf/5//FAMUABAAEAKL/ov9Q/1D/4QDhAEoBSgFhAGEAFP8U/zoAOgBgAGAAJAEkAZj/mP9b/Vv9IAAgALgAuABy/3L/wv/C/+n96f27ALsAqQCpAF7/Xv/4//j/GwAbAM8BzwELAQsBsQGxAbP/s/+7/rv+2f/Z/4//j//AAMAAnwCfAKn/qf+OAI4AKAEoAX4AfgCu/67/9P30/Wf/Z//3//f/tQC1AE7+Tv67/rv+AAEAAWwAbABC/0L/l/6X/gb/Bv9CAEIAzgDOADL/Mv+r/6v/OQA5AEkBSQFy/3L/hv6G/ln/Wf+BAIEAAQEBAXH/cf+8/7z/gwCDAGYAZgCcAZwBBgAGAGP+Y/7C/8L/fwF/AQQBBAFGAEYAHP4c/rL/sv9CAUIB8QDxAL7+vv5K/0r/qwKrAhsCGwLs/+z/Ov86/3v+e/5tAG0ABwEHAc39zf2D/oP+rP+s/24BbgGWAJYAiv6K/gwADABuAm4C+QD5AHUAdQA+AD4A2//b/7MBswENAA0ApP6k/oL/gv+rAKsARgFGASQBJAHi/+L/TgBOAPIA8gC5AbkBEQARAM/+z/49/j3+KAAoALcAtwBr/2v/2v7a/rr/uv89AT0BLgEuAdn+2f5A/kD+ev96/+oA6gAjACMAiv+K/7b/tv/IAMgA0QDRADn+Of7G/sb+OP84/9cA1wC1ALUAM/8z/4kAiQDCAMIAmACYACEBIQH/////D/8P/0b/Rv/u/+7/7ADsABMAEwDd/93/Lf8t/0QARADUAdQB8ADwABP/E/8KAAoAAgECAQ//D/87/jv+ff59/jkAOQATARMBkACQAAb/Bv/AAMAAwAHAAQ4BDgGE/oT+rf6t/jMAMwB4AHgAd/53/jf+N/4t/y3/rQCtAAkACQCB/4H/JwAnAG0BbQH4APgAjQCNAGb/Zv8x/zH/AgACAF0AXQCT/pP+7v/u/48AjwCGAIYAzADMAEQARABOAE4AfAB8AAn/Cf86/zr/AP4A/lj+WP66ALoAYwBjAAP/A/8pACkAUwBTAL8AvwBnAGcAPv4+/ur+6v5//3//eQB5AEv/S/8nACcAdgB2AEABQAH4AfgBWwBbAGv/a//Y/tj+4f7h/hIAEgDM/sz+2//b/wr/Cv/I/8j/LAIsApsCmwJn/2f/qv6q/qv/q/+pAKkAFwAXACD9IP3I/cj9fgF+Af8C/wIAAgACNv42/nb+dv46AToB9wH3AUX/Rf8f/B/8+vz6/H8CfwJ2AnYC8//z/1/9X/3iAOIA9gP1AzADMAOOAI4AFfwV/Bb/Fv+5AbkBigCKAAX+Bf45/jn+ZgBmADsCOwIbAhsCa/9r/9L+0v4RABEAzwDPAHIAcgAK/gr+bv9u/0UARQC2AbYBUwFSAT7/Pv9E/0T/UgBSAKcApwADAQMBn/+f/5D+kP5J/0n/QAFAAW4AbgAp/yn/j/6P/lj/WP+jAKMA6P/o/8X/xf+u/67/MAEwAdAB0AHX/9f/Uv9S/xv/G/8q/yr/YQBhAAsACwDs/+z/qQCpAPQA9ABOAU4BagBqANb+1v58/nz+pv6m/jwBPAFy/3L/eP94/6n/qf8OAA4AGQIZAjQANABsAGwAQgBCABkBGQFAAUAB5f/l/xH/Ef89/z3/KwErAYgBiAHtAO0ATwBPAGUBZQHoAegBdP90/2j9aP2G/Yb95P7k/m7/bv9G/0b/p/6n/jEBMQH+Af4BDAEMAWT/ZP8c/hz+3/7f/jcANwAsACwA6v7q/jwAPAC7AbsBIAIgAg4BDgHC/8L/UQFRAUQBRAFL/kv+uP64/j7+Pv7U/9T/hACEAP7+/v5UAFQA2v/a//QA9AB6/3r/4f7h/hX+Ff49/j3+DwAPACr/Kv+a/5r/Jv8m/yYBJgEpASkB8ADwAIUAhQDI/sj+YP9g/4n/if/1//T/rf+t/8b/xv+pAakB/QH9ASABIAHd/93/Pv8+/9H/0f91/3X/af9p/6L9ov3e/t7+JAAkAOv/6/9F/0X/wv/C/yQBJAE4ATgBFwAXAAf+B/56/nr+qgCqAEMAQwDY/tj+mP+Y/wYCBgItAy0Dcf9x/6/+r/4NAA0AwwHDAfv/+/8a/hr+Gf4Z/uAA4AAaAxoDVf9V/2/+b/6oAKgA2ADYALsAuwAG/wb/n/+f/0IAQgDHAMcAKQApAGgAaAABAQEBeAB4AOL/4v+A/4D/sf+x/xEBEQFWAFYAn/+f/1oAWgBP/0//ZgFmATUANQBKAEoAuP+4/wv/C//Y/tj+7v7u/hr/Gv/o/+j/UABQAHoAegBMAUwBBAIEApUAlQBJ/0n/tv62/mD+YP66/7r/pQClACsAKwDqAOoAPgE+Aa4BrgEnAScBEf4R/gAAAABuAG4AEAAQAFT9VP0v/i/+mQCZAJUAlQBN/03//f39/fUA9QBXAlcCbQBtAHv/e/9mAGYARwBHAJ//n//6/vr+Kf8p/5wAnABO/07/bAJsArABsAGk/6T/+QD5AM7/zv+DAYMBfQB9ABj/GP/m/eb9kf+R/x4BHgGuAK4A6v/q/4cAhwAbAhsCBwEHAZQAlAAp/yn/BP4E/sH/wf+9/r3+5//n/yoAKgBUAVQBrAGsAR0AHQDz/vP+7f7t/kcARwCa/pr+F/4X/tr+2v7JAMkAwQDBAAP/A/8zATMBYgFiAXcBdwGV/5X/r/+v/+L/4v9mAGYAnP+c/zsAOwAbABsAev96//b/9v/k/+T/gwGDAbP/s/8P/g/+5f7l/kwBTAHWAdYBJAAkAPj9+P2FAIUAzADMAEz/TP+N/o3+IgEiAScAJwCnAKcAsf6x/tP/0/86ADoAeP94/2sAawDx//H/TgFOAT0APQDa/tr+fv9+/w4ADgCbAZsBv/+//zb/Nv/7APsApACkAMEAwQDp/un+mf6Z/qcApwD4APgABgAGAK8ArwAhACEA2wDbAGsAawDH/sf+S/5L/pAAkABTAFMA5P/k/4D+gP5TAFMAFQIVAkUBRQEnACcAoQChAIIAggB5/3n/g/2D/an+qf4hACEAXv9e/97+3v5R/lH+awJrAoUBhQGq/6r/k/6T/tUA1QBRAVEBgf6B/vD+8P7oAOgAegF6AaP+o/5X/lf+ZQFlAR8CHwIPAQ8Bwf/B/xz/HP/P/s/+7/7v/nD9cP0//T/9UwBTAMYAxgDKAMoADQANAO//7/9nAWcB0f/R/wb+Bv7x/vH+Xf9d/6UApQCDAIMA0v/S/0v/S/98AHwA2P/Y/9f/1/+9/73/Wv9a/z0APQBpAGkASQBJACYAJgBQAVABTQFNAR0AHQB9/X39+v36/bb/tv80ADQAM/8z/9QB1AH6AfoB7gHuAe//7/87/jv+G/8b/9n+2f72/fb9Ef4R/vUA9QA7ATsB3f/d/zH/Mf8OAQ4BkAGQATD/MP/w/fD9k/+T/78BvwHXANcA4v/i/10AXQD4AfgBlQCVAFYAVgAPAA8AMAAwAB4CHgJO/07/FP8U/zn+Of7FAMUARQBFAIr/iv/p/en9OQA5ABoAGgAsACwAzf/N/0D/QP/cANwADwAPAO//7/+I/4j/HQEcAU0ATQBfAV8BZP9k/98A3wARAREBhf+F/9n/2f+DAIMAEgISAt8A3wDd/93//P78/qH+of7A/8D/qf+p/14AXgCP/4//FwEXAeAB4AHjAOMA4f7h/tf+1/71//X/g/+D/+b/5v/0/fT9XgBeAEMDQwN9AX0BLAAsAIz/jP9aAFoAlgCWACf+J/5O/U79uQC5AJoBmgHP/8//6v7q/pcAlwAQARAB2v/a//n9+f14AHgAbgFuAYwAjABV/1X/EgASABkCGQIkASQBTf9N/zv/O//GAcYBbwFvAcH+wf4S/hL+7ADsAMABwAE8/zz/5P3k/QABAAFBAUEBd/93/x78Hvys/az9uQK5AkcBRwEi/iL++f75/pIBkgEfAh8CaP9o/7H9sf3C/8L/agFqAX0AfQBJ/Un9SP5I/mQDZAPUAtQCtwC3AC//L/+PAY8BRAFEAST/JP8j/yP/d/53/qEAoQBiAGIAuv26/YT/hP+t/63/oACgALMAswA//j/+7P/s/0j+SP61/rX+2f7Z/vD/8P8sASwBtv62/jIBMgFTAVMBtAK0AqQBpAFf/1//0QDRAE0BTQHQ/tD+S/5L/q39rf0SABIAKQEpAYr/iv+PAI8ABgEGARwCHAIKAAoAhv2G/bv/u/8CAgICTABMAFv9W/2q/ar9Uv9S/ygBKAFe/17/df11/Y4BjgHKAsoC9AH0AaT+pP5I/0j/WQFZAWkAaQBc/lz+Df4N/v0A/QAGAwYD8QHxAX//f///AP8AqACoACcAJwAt/i7+/Pz8/AT/BP8VABUA2//b//v9+/2R/5H/hgGGARABEAHx//H/1v/W/y4BLgHi/+L/sP6w/jL9Mv3M/sz+4v/i/0UBRQF1AHUA/AH8AUQCRAKeAJ4AY/5j/hT9FP3n/uf+gP6A/nIAcgDeAN4ADwIPAuf/5/8SABIAq/+r/zMBMwHd/93/0v7S/qj/qP8aARoBJgEmASsAKwBX/Vf9gP+A/5QBlAHOAM4AHf8d/0f/R/9+AH4A8AHwAb/+v/6r/qv+dP90//0B/QGqAKoAXP1c/Ub+Rv6GAIYAJwEnAUn+Sf4W/Rb9DgEOAbcDtwOvAa8Bg/6D/jX+Nf4fAh8CAAH/AEX+Rf7Y/dj98wHyAR4DHgPbANsAif6J/iQCJALXANcAp/+n/4v+i/7j/eP9KgAqAMT/xP8c/xz/1wDXAGj/aP9cAFwAgQCBADEBMQFz/3P/G/8b/xcBFwFHAUcBZABkAJ/+n/6VAZUBbAJsApcAlwDm/eb9B/8H/9YC1gLcANwAJf4l/qf/p//qAeoBVgBWAIT9hP3g/OD8LgEuAfz//P8d/h3+K/8r/2kCaQI3AzcD+P/4/zYANgDJAckB/P/8/zD+MP7V+9X7VP9U/7wCvAJsAWwBGAAYAM8BzwE9Az0DWQBZAFX9Vf38/fz96v/q/6f/p/+8/rz+Jv4m/lABUAFAAUABowGjAYIAggD7APsAmP+Y/8sAywCb/5v//P78/sn/yf/j/+P/tQC1AJv/m/9ZAFkA7//v/58AnwCS/pL+Tv9O/3cBdwFSAFIAFAAUAPz//P+xALEArv+u/xb/Fv+h/6H/nwCfAO4A7gB3/3f/hP+E/6QApABGAEYAcf9x/6j+qP6b/5v/+/77/kz9TP3A/MD8DP8M/00BTQFHAkcCVwFXAbj/uP8hACEACQIJAggACABR/lH+JP4k/s7/zv/5APkAz/7P/jIBMgFYAVgB2wDbAN3+3f4+/T79MP4w/mr/av/L/sv+Jv4m/ucA5wCSApICHAEcAU//T/8uAC4AFAIUAvP/8/+z/rP+ff59/s/+z/5zAXMBygDKAKX/pf/IAMgAvwC/AOAA4AA1ADUAZv5m/tL90v3f/9//7//v/3n+ef5c/lz+awBrAKsCqwJPAU8Bj/+P//D/8P96AHoA3ADcAPj++P4Q/hD+Bf8F/+cA5wA2ATYBAf8B/xUBFQGTApMCZwJnAhIAEgBM/Uz9BAAEAAkACQAR/hH+uf65/rv/u//lAeUB7QHtAbcAtwAr/iv+LAAsAJoAmgDB/8H/kf6R/tP+0/6AAYAB6wDrAIT/hP+y/rL+AwADAE0CTQK+/r7+k/+T/0oASgAvAC8AFQAVADH/Mf8rAisCSwBLAKf+p/5//3//QAFAAXkCeQJSAFIANP80/2ABYAF8/3z/Jf8l/0D9QP1+AH4AAwMDAzf+N/6W/Zb94f/h/4sBiwG1ALUAM/4z/h4AHgDFAMUAVwBXAFb/Vv/S/9L/pQKlAiYBJgGSAJIAOP84//MA8wCqAKoAg/+D/wgACAC7/7v/cP9w/3v/e/9l/2X/Vv9W/+QA5ABDAUMBUwBTALv/u/91/nX+uwG7ASkAKQBM/kz+4v7i/uX/5f8hAyEDwQHAAZf/l/80ADQA4gHiAfQA9ACn/Kf8nvue+60ArQDG/sb++//7/3L+cv45AjkC0QLRAigAKACC/oL+qP2o/ckAyQAa/xr/O/47/qf+p/5hAWEBnAOcAw8BDwGd/p3+VQBVAJsAmwDnAOcA/v/+/2f/Z/9tAG0ADAEMAWX/Zf89/j3+Wf9Z/5sAmwAWABYA5P/k/+cA5wDEAMQA/AD8AHoAegBl/2X/6P/o/8oAygDFAMUA2v7a/ugA6AD+//7/x//H/yoAKgBF/0X/B/8H/+7+7v6H/of+KP8o/9cB1wGVAZUBdQB1ADkAOQCTAJMA4f7h/sT9xP0K/wr/HgEeAeoC6gISAxIDpQKkAukC6QLCAcIBff99/3P9c/0N/A387fzt/Fz/XP9U/1T/5wDnAJQAlADiAOIAAgECAd8B3wE9/z3/1/3X/cf/x/+aAJoAMAEwAQ3/Df+HAYcBcQJxArEAsQAuAC4A8P3w/df/1/8MAAwAQ/9D/zv/O//x/fH9pACkACoAKgDU/9T/UP5Q/m0AbQBHAEcALQAtAJr/mv8S/hL+NgA2AEkBSQF7AHsAlf6V/iEAIQCDAoMCcQFxAeH/4f+O/o7+1ADUAD4BPgHr/uv+1f7V/jYANgBXAVcBif+J/6H/of+ZAJkAJwMnA/kA+QAC/wL/Uv9S/yL/Iv9d/13/9v72/q3/rf9aAFoADAEMARIBEgEKAQoBugC6AA4ADgAv/i/+HAAcAAsACwCy/rL+fP58/mH/Yf+LAosCxwHHAQr/Cv///v/+UgBSAOYA5gAE/wT/e/17/ZQAlAABAgECRP9E/xn9Gf2BAIEAHAIcAioAKgDm/ub+Vf1V/dMB0wFIAUgB0v7S/iD/IP8IAQgBKgEqAXL+cv6O/Y79sv+y/4oBigFr/2v/uv+6/8H/wf++/77/Jv8m/yb/Jv9z/XP9+wD7ABACEAIEAQQBqQCpANj92P1c/1z/fwF/AUn+Sf5D/UP9s/+z/28BbwGUApQCZ/5n/gT/BP8bAhsCGQAZAEz/TP/U/dT9KwArAOz/7P/r/+v/cv5y/vH/8f8AAAAAjv+O/5b+lv4l/iX+RgFGATcANwBq/2r/RgBGAKH/of+K/or+Jv8m/yIAIgAQARABTv9O/10AXQAXAxcDzwDPAKX9pf1c/1z/wwDDAPEC8QJp/2n/Df8N/5L/kv9ZAFkAZP5k/jD7MPtr/2v/UwJTAlQBVAFQAFAAEwATAB8AHwCrAKsA2P7Y/jz/PP+4/7j/bQBtAJ4BngHZAdkBKgIqAmgBaAEsACwAXf9d/3z+fP59/33/ogCiANL/0v8j/yP/WABYAMgAyAApASkBKgAqAP3+/f6zALMAcwBzAF0BXQEgACAASAFIATYBNgFoAGgAif+J/+3+7f4M/wz/yf7J/sIAwgCKAIoAUP9Q/1wAXACmAKYAQQJAAh3/Hf+Z/pn+i/+L/6ABoAFsAmwCBwAHAM8AzwBFAUUB3ADcAJf+l/7O/s7+qv+q/xYCFgL+//7/ov+i/8L/wv+H/4f/owGjAfn/+f8D/wP/6P7o/mAAYACjAaMB6//r/7L+sv4H/wf/ZAFkAe0A7QAn/yf/L/4v/h0BHQFFBEUEYgBiALT9tP1E/0T/+QL5AtYB1gHh/OH8uf25/UoASgDGAsYCXQFdAZ3+nf6+/77/SQJJArQAtAAm/Sb9i/6L/ucA5wCvAK8AP/4//mP8Y/xzAXMBngGeAVUBVQF8/3z/p/2n/ZUClQKJ/4n/Yfxh/ML+wv5fAF8AgACAABz/Hf+YAZgB/wL/AsEBwQGz/7P/zv3O/dL/0v/3APcAS/5L/pj9mP3rAOsAyAHIAZj/mP/Z/dn9ev96//4A/gDm/+b/k/2T/dP+0/5yAXIBJAAkAJn+mf4p/yn/j/+P/1gBWAFJAEkAyv7K/kb/Rv/NAM0AVgFWAY//j//iAOIAaQFpAdEA0QCs/qz+SP1I/YL9gv1y/3L/FwEXAWQAZADr/+v/1QDVAKgDqAOzALMAW/5b/o7+jv5F/kX+4QDhAOH+4f7w/vD+WgFaAe4C7gLGAMYA4P/g/3IAcgD4//j/zwDPAIX9hf2+/77/jQCNAIz+jP4MAQwBuwG7AVoAWgCvAK8Anf+d/4UBhQGZAJkAn/+f/4n+if6VAJUAFAEUAUf/R/9u/m7+6//r/+YB5gFyAXIBrP+s/1gAWABJAEkAyf/J/+j/6P+X/pf+h/6H/ikBKQGYAJgARQBFAE4ATgBG/0b/dAF0AZ0AnQCn/qf+4P3g/SUAJQCzALMAIgEiARz+HP68ALwASQJJAvIA8gBW/1b/GQAZAPoA+gBKAEoAIv4i/gH/Af+PAY8BawJrAlMAUwDs/uz+cwFzAfQA9ADG/cb9df51/rAAsADjAeMBAgACAE7/Tv9S/VL9vQG9AR8BHwGy/bL9RwBHAJv9m/3G/8b/b/9v/2P/Y/8IAAgAvf+9/xsAGwAkACQA0AHQAdgB2AEj/iP+tv+2/0P/Q/+H/of+iP2I/fX/9f9AAkACOgA6AMoAygCCAIIA/P78/hv/G/9J/kn+P/8//xkAGQDT/dP9Of85/wsBCwE+Aj4CxP/E/5n+mf7v/u/+iQGJAbH/sf/0//T/xQHFAfUA9QDHAMcAYf9h/+D/4P+7AbsB8v3y/Vb9Vv15AHkAb/9v/+QA5ACX/5f/gv+C/83/zf+T/pP+RABEACYAJgAXABcAIAIgAhcBFwGiAaIBTwBPAAL9Av1H/0f/nwCfAEr/Sv9u/m7+7wDvAEwBTAHw//D/DAEMAfn++f63ALcAUgFSAUwATACu/a79FgAWAKcBpwGE/4T/FwEXAf0A/QAqASoB3QLdApL8kvw1/jX+C/8L/8sAywAsASwBQv9C/57/nv8AAwAD5gHmAZ39nf1K/Er8XQBdAIUBhQHC/8L/kf2R/QYABgDhAuECHAIcAu4A7gCw/bD9bgBuAJj/mP/bANsAdP90/0sBSwE4ADgAtv+2//0A/QDBAcEBK/8r/yMAIwDy//L/D/8P/yj/KP9Z/1n/RgFGAWoDagM/AD8AXPxc/NP90/0AAAAAiP+I/xcCFwLg/uD+pACkAEEAQQAtAS0B7f/t/1D+UP7j/uP+7P/s/2//b/8nACcAagFqAV4CXgK1ArUCVP9U/5X/lf8O/w7/ov+i/2H/Yf+p/qn+CAIIAj8CPwIiACIAvP+8/1D+UP4L/wv/Gf8Z/97/3v9r/2v/ZABkAK3/rf8CAQIBBQAFAOgA6ACY/5j/Wv5a/oj/iP90/nT+YwBjAEgBSAEIAAgA4AHgAd3/3f/f/t/+g/+D/zb/Nv8v/y//7v/u/xX/Ff85ADkACgEKAR4BHgGg/6D/OP84//H98f0A/wD/6v/q/wkACQBPAE8A6wHrAXMAcwAGAQYBCv8K/6r+qv7B/8H/e/97/6D+oP4O/w7/aAJnAuMB4wFDAEMAO/47/t793v2tAK0AGv4a/qb9pv24/rj+gAGAASwDLAM8/jz+rv6u/sYBxgFXAlcCZv9m/1b+Vv6a/Zr9SQJJAoIAgwB+/37/JQAlABUBFQHiAuICSABIAP7+/v6K/4r/BwAHAHH/cf+G/Yb9hf+F/zMBMwGdAp0Co/+j/23/bf/VANUAHgAeADr/Ov9P/k/+XQBdANIB0gHH/8f/1P7U/nUAdQAxAjACGQEZAeT95P1m/2b/MwIzAicBJwEC/wL/U/5T/pQBlAEqACoAUf5R/tD/0P8QAhAClAKUAp7+nv7w/vD+yQDJADYBNgGZ/pn+O/47/oACgAJAAEAAhf2F/Tz+PP7KAMoAzQPNA6f+p/7V/dX9eQF5AfUB9QG3ALcATP5M/nUBdQFJAUkBrgCuAHn/ef+y/rL+MwAzAP3//f/t/+3/qwCrAEUARQBp/2n/egF6AfL+8v51AXUBnf6d/t793v1nAWcB7gHuAR8BHwFA/0H/kf+R/xsAGwCjAaMBWv5a/mr+av5gAWABJwMnAy8BLwGa/pr+8f3x/V8CXwI2ADYAtvu3+77+vv6cApwCeQN5A4f+h/6P/o/+tgC2AAYCBgKf/p/+Lvwu/ET+RP7rA+sDgv+C/07/Tv+5/7n/nACcANEA0QDs/ez9zf/N/8YBxgHhAeEBZ/9n/7X+tf5R/1H/gwCDAMAAwABw/nD+Z/9n/23/bf9z/nP+m/+b/yQAJACA/4D/s/+z//b/9v/e/97/+wD7ALr9uv0AAAAAngCeADUCNQK5ALkA3v/e/3YBdgFF/kb+0P3Q/VX+Vf52/3b/EAAQAGcAZwBvAW8BBAIEAigCKALb/tv+CwALAFb/Vv/A/8D/h/yH/J/+n/70APQAEQARAH8CfwJeAV4BfQF9AQQABACI/4j/Dv8P/4H+gf5U/lT+Kf4p/mUCZQJPAE8AEwATALQAtAA1AjUCkwKTAqD+oP6h/qH+9f/1/5sCmwJL/kv+jfyN/CwBLAHYAdgB6P/o/zv/O//t/e39owGjAYYChgJx/nH+EP0Q/UoASgCzArMCgf6B/uv86/zi/uL+vQK9AgMDAwOH/4f/UwBTAHEDcQOIAYgBj/6P/m39bf2//7//AAEAAUv/S/+G/ob+3f7d/hQBFAHE/8T/fP98/xD+EP79/f39uv+6//MA8wDZANkA9f/1/4v/i/8XABcAGgIaAjb/Nv/r/uv+8v7y/hoCGgK1AbUBdv52/pz/nP+zALMABgMGA4v/i/9y/nL+8//z/+UA5QCdAZ0BPf89/9v92/2gAKAAHgMeAw4CDgLp/un+MP4w/ib/Jv+Y/pj+Y/1j/S7+Lv64/7j/YQFhAdsB2wGEAoQCn/2f/UMAQwAd/x3/P/4//kT/RP9D/kP+HgEeAZMBkwFUAlQCyQDJAAMAAwA2AzYD2ADYAIX/hf/P/c/9+v36/fkB+QFpAWkBBv4G/r//v/8GAgYCKAEoAaP+o/6+/L78lQCVAHMCcwKiAKIAu/27/c78zvxtAG0AFgIWAg4ADgAM/gz+VP5U/m8CbwIrAisCov2i/cn8yfyEA4QDeAN4A8L9wv28/bz9cgFyAU4ETgQI/wj/0/zT/MEAwQBfAl8CGP8Y/7z8vPzSAdIBJAIkAmb/Zv9F/kX+fQB9AB8CHwIU/xT/lf2V/QAAAABcAFwAoACgAM8BzwHg/+D/igCKAC4ALgAM/Qz9xADEAMQAxACaApoCyP/I/xz/HP8x/jH+u/+7/9L/0v/v/+//eQF5AbUCtQINBA0EHP8c/y7+Lv7R/tH+tP+0/w8CDwKt/63/7gHuAdgC2AITARMBkgCSAPb99v1j/WP9xPzE/Ij9iP3F/8X/8P/w/zz/PP+qAqoCVQBVAHH/cf8m/yb/pf+l//b/9v+8/bz9Fv8W/0ICQgK8AbwBvgC+ANv/2/9gAWABXgJeAtP/0/84/zj/o/+j/xUAFQBi/mL+AP8A/1IAUgCB/4H/Qv5C/ur/6v9NAE0AYAFgAXoAegDi/uL+S/9L/wT/BP9HAEcA0P/Q/5n+mf6g/6D/4ADgAKUApQDM/sz+7/7v/kkBSQFtAG0AEf4R/sn+yf7WAdYBPAA8AJb+lv5Y/lj+pgGmAaQApABc/lz+K/4r/mABYAHLAcsBUP5Q/nr9ev0V/xX/bgJuAlYBVgHMAMwABQAFABIAEgBj/2P/sP2w/fr/+v+3ALcAoAGgASkAKQDVANQA4ADgAHoAegBN/U39z/3P/U3/Tf93/3f/5QDlAJf+l/6vAK8Amv+a/0gASABIA0cDHgMeA+EA4QBA/kD+uf25/RIAEgB0AnQCG/8b/zwBPAGnAqcCA/8D/2j/aP/n/ef9ygDKANkA2QCx/rH+Mv8y/w3/Df/cANwAFf8V/wr/Cv8RAREBhgCGAPP/8/9Y/1j/B/4H/kwATAAWABYAWgBaAJkBmQFFAEUAVv9W/7j+uP4GAQYBcgByAFEAUQBg/2D/jgGOAWQBZAHmAOYA2gDaAM3+zf6jAKMAzv/O/6QApAAnACcALAAsAH3/ff9I/0j/CP8I/0cARwBOAE4A0P/Q/37/fv/U/tT+vgC+AK7/rv9G/0b/DP8M/1sBWwFTAVMBcAFwAa8ArwDK/8r/D/8P/0/+T/7//f/94ADgAIsCiwKq/6r/YAJgAtcB1wGj/qP+6v3q/QD/AP+C/4L/4P7g/ov9jP3OAM4AvAO8A1oAWgBIAEgA9//3/7IAsgBT/1P/Hf4d/r7/vv+G/4b/ZwFnAZ0AnQDm/ub+YAJgAmkAaQBsAGwAOf45/vr9+v1WAFYAiv6K/rj/uP/SAdIBnQSdBFYAVgAq/Sv9EgASAJMBkwF9/33/T/5P/oAAgABZA1kDRQBFAED/QP9E/0T/C/8L/1n/Wf9s/2z/EwATAPwA/ADDAMMARQBFAEwATAAo/yj/KgAqAJAAkADS/dL9bf9t/wAAAACwALAAFAAUAED/QP9eAF4Ai/+L/zMBMwEfAR8BDgIOAob/hv90/3T/rf+t/0ECQQLL/8v/Ov46/hD/EP+WAZYB+f75/nb/dv8TARMB7QDtAL3+vf6T/ZP9uwC7AMj+yP7D/sP+df51/jUCNQIkASQBmgCaAD4BPgHWAdYBnACcAHX9df10/nT+FQAVACEBIQHCAMIASABIABoBGgGdAJ0ATv9O/2L+Yv6P/4//Ov46/hQAFAA3/jf+of+h/4ADgAOwALAAwP/A/xT+FP64/7j/LAEsART/FP8c/xz/5v/m/4cAhwDfAN8AhAGEARQAFAD2//b/NgA2AHACcAKqAKoATQFNAeIA4gDm/ef9Qf5B/hT+FP7NAM0AYwJjAq7/rv/tAO0AugK6An3/ff++/L78o/yj/BkBGQF+AH4Axv7G/nYAdgA4AzgDOgE6ASH/If9E/0T/sv+y/3IAcgDy/PL8bf5t/gsDCwMJAgkCRgBGAJMAkwBYAlgCOQA5ACn9Kf2n/af9OP84/43/jf+T/JP85/7n/nADcAM5AzkDtv63/qz+rP64/7j/TP5M/qT+pP7O/c79LwIvAtkB2QHGAMYApQGlATEBMQHC/8L/6P3o/bj+uP4E/wT/RABEACgAKAB+AH4AUAFQAZAAkAAS/hL+i/yL/FD9UP2D/4P/uQC5AFECUQLpAekBPAI8AhQAFACZ/pn+l/yX/IP9g/2PAY8BAgICAl0AXQDVANUAUgJSAocBhwHP/c/9GfwZ/FEAUQAkASQB/f/9/zj/Of8uAy4DVgFWAeX/5f/o/ej9MAIwAnIAcgDH/8f/ff99/xj/GP/u/+7/HP8c/3UBdQEVARUBBwIHAs//z//q/+r/sACwAMH9wf2R/5H/mv+a/7D/sP9BAEEAtAC0AM3/zf+VAZUB1QLVAuD+4P4//j/+1/zX/JP+k/6A/4D/Af8B//f/9/+BA4EDAQIBAp3/nf8g/yD/WP9Y//QB9AGF/oX+6P7o/nQBdAENAA0AOgA6AOr+6v7hAOEAbQFtAWcCZwIl/yX/0f7R/l7/Xv+Q/5D/KP4o/mn/af//////XQBdAGIBYgHl/+X/oP+g/1L+Uv4nACcABQAFAOX+5f47/jv+NQE1ASQBJAEh/yH/RP9E/wECAQIeAR4B+f/5/1n/Wf+T/5P/pQGlAfz8/Pz8/vz+PQA9AFwBXAFS/lL+t/63/h7/Hv/E/sT+/fz9/MX/xf+nAqcCQAFAAV7+Xv7B/8H/QAFAAS7/Lv/Q/dD95f7l/qEAoQDz//P/gQKBAtoA2gBFAUUBz//P/5n/mf+H/of+qP6o/ov/jP93AXcBMAIwAq8BrwF9/33/Zv9m/8UAxQDC/sL+LgAuAKL+ov4d/x3/OAA4AF8CXwKRApECrP+s/8UAxQCcAJwAH/8f/1T9VP0jACMAwP/A/2r/av9V/lX+FwIXArgCuAI9AD0A6v7q/hwAHAAL/wv/Pf89/1f+V/4KAgoCmQGZAS8BLwE6ADoAPgE+AXUAdQC//b/95f/l/5IBkgFcAFwAXf1d/cL/wv/UAdQBSQFJAXL/cv/u/u7+jQKNAsICwgK4/rj+5Pzk/KwBrAGwAbABSP5I/n0AfQC0AbQBnAGcAaP7o/vb/tv+DQENASsCKgLQ/dD9wv3C/W8BbwEI/gj+Ev4S/ggACAAMAgwCVgFWAWIAYgBwAXABCgEKAVr+Wv76/vr+wgLCAvL/8v+B/4H/WwBbAOMC4wIj/iP+OPo4+uP/4//HAscCMwEzAbz/vP+jAKMAAQMBA3/+f/7/+//75v/m/2UBZQE0/jT+JgAmAJYClgKbApsCUgBSAFr+W/7V/tX+4//j//v9+/3s/+z/WgFaAeMA4wCx/7H/4ADgALsDuwMC/QL9yv3K/V8AXwAZAhkCfv9+/97+3v5wAXABIAMgA23+bf7b+9v7jgGOAUMDQwNX/1f/rPqs+lcBVwHzA/MDW/5b/iT6JPoPAQ8BOQU5BaT/pP/X/df9bgNuAzkDOQPg/eD9SftJ+6X/pf8qAyoDh/6H/q79r/3kAeQBdQJ1Ak//T/+PAI8APQE9AeD+4P5j/GP8FP8U/1sDWwP7APsA1f7V/sn/yf8iASIBOv86/5X/lf+a/5r/Uf9R/0EAQQBS/1L/IgAiAIMBgwE+AD4AswCzAAcCBwJ4AHgA+QL5Arz/vP+K/or+xf/F/8cAxgBE/UT9tP+0/+n/6f8lAiUCmP6Y/tP90/2c/pz+NQI1Au7+7v76/fr9DwEPAe0A7QCG/ob+Lf0t/YgEiASKA4oDDv8O/7T9tP2oAqgCJQIlAlT8VPyw+7D7egB6ADYDNgNvAG8AJ/8n/0MDQwNTAlMCgfyB/KL6ovoOAQ4B9QL1AsMAwwBh/WH9pwGnAeAD4APk/eT9v/u/+0j/SP+OAY4B1/7X/v/8//z7AfsBCgcKB+z97P2s+6z7R/9H/0sBSwEOAA4Ae/t7+0cCRwJdA10DYQBhALP8s/w7/zv/RgNGA7v9u/0/+z/78P/w/4cChwLn/+f/y//L/yMBIwHXANcAZwBnAFb8Vvx2/3b/7P/s/5v/m/9mAGYA+AD4AO8A7wBu/27/XAFcATcANwBrAGsAO/47/hv/G//mAOYAi/+L//UA9QBmAmYCLgMuA3YCdgLy/vL+o/2j/X3/ff/+//7/Uv5S/rH+sf6dAJ0AugC6AF3/Xf8YABgAXgFeAU4BTgFGAUYB+wD7ALD/sP97/Xv9a/1r/cIAwgCfAp8C9f/1/4oAigAeAR4BuAG4Aan/qf8Z/Rn91/7X/ikCKQJI/0j/7vzu/Mj+yP7YANgAxwLHAgn+Cf6cAJwAXwFfAdMB0wH4/fj9Sv5K/hYBFgEOAA4A7v3u/TEAMQBLA0sDEQERAYX+hf46/zr/nP+c/yoAKgDw/fD9OQA5APoB+gEk/ST9GP4Y/tr92v23ALcAZ/9n/8IAwgDDAcMB7wDvAK4BrgGUAJQAr/6v/v3+/f7s/uz+vQC9AAgBCAGL/4v/vgG+ARYCFgKhAKEAVf9V/zr8OvyfAJ8ADf8N/17+Xv5cAFwAjAGMAcv/y/94/Xj9hf+F/ysBKwEmASYBnf6d/ikAKQAgAiACJf8l/+397f0+AT4BhQOFAzP/M/8p/Sn9Bv8G/xkBGQHoAOgA3v7e/iIAIgAxAjECMwEzAYD8gPw+/j7+v/6//koBSgFG/Ub9rf6t/g4EDgRbA1sDVf9V/xH+Ef43ATcByv/K/xf9F/1u/G78SgBKAL8CvwKWAJYAFwIXAs0CzQJgAGAAA/0D/SH9If0uAC4AX/5f/g3/Df9YAFgAhAOEAxUAFQBP/0//wwDDAPsA+wAZABkArP2s/WkBaQFbAlsCGgAaAAj+CP5GAUYBNwI3AggACAAU/BT89P70/lUDVQMLAQsBvPy8/B7/Hv82ADYAKAEoAUv+S/7eAd4BBQQFBNYB1gE8ADwA/P39/QQABADZ/dn9if+J/2MAYwABAQEBCwALAJkAmQC4/7j/Cf8J/zX/Nf+aAZoB3wDfAGgAaABn/2f/oQChAB4BHgE2ADYAw//D/2YBZgE5AjkCVgJWAov/i/+B/oH+SABIAEUARQD7//v/Qv5C/ksASwCKAYoB+wH7AYX+hf6U/5T/lwCXAM7/zv+4/7j/eQB5ADUCNQJO/07/2P7Y/sH/wf+SAJIAHQAdAB0BHQGy/7L/nQCdAKn+qf6Y/pj+3QLdAl4AXgAE/wT/CP8I/30AfQCvAa8B7v/u/w8ADwDo/+j/of+h/zT/NP8k/yT/SAFIARIBEgE/Aj8CPAA8ALj/uP96/nr+MQExAa7+rv6o/qj+Vv1W/WsAawANAQ0B7v7u/iAAIADq/ur+zAHMAS7+Lv6z/LP8gv+C/xsCGwK1ALUAGv8a/64BrgH8AfwB2P7Y/hP9E/2y/7L/EgESAWf/Z/+8/rz+3f/d/woCCgJC/0L/x/7H/t3+3f4jASMB1QHVASn+Kf5b/lv+oQChAOgC6ALD/sP+nP6c/hYBFgHGAcYBSv5K/qn7qvtQAlACjgGOAbX9tf2n/qj+XANcA/sD+wPP/c/9Hf0d/d4B3gGcAJwAhv6G/gj9CP1JAkkCkgGSAV39Xf1GAEYAnv+e/7QAtABp/Wn93P7c/pIBkgFKA0oDRgBGAEX9Rf0xADEA9AD0AKwBrAHl/OX8sf6x/iICIgLIA8gDHAAcALr+uv6EAYQBkACQAB39Hf1G/Ub9PwM/AxQCFAJ4/Xj9qfyp/EMBQwEyAjICa/5r/k7+Tv4wATABGQEZAfn9+f3+/v7+AQMBA1kAWQBD/kP+IQEhASIBIgE8/zz/vf69/o4AjgACAgIC/f/9/3D/cP/yAvICsgGyAVH9Uf1x/XH9MgIyAiUAJQCv/6//nP+c/xEBEQHK/8r/Ev8S/7wAvABkAGQAbwBvAJL9kv2L/4v/PAA8ALgAuAA1/jX+xv7G/kQBRAEiACIAKf8p/xYAFgC8/7z/nf6d/nH/cf9DAEMA0wHTAdL+0v7E/sT+BgEGAToAOgBRAFEAjACMABgBGAEZ/xn/Wf1Z/a//r//UANQAQv9C/5D+kP7O/s7+3v/e/9f/1/9hAGEAn/6f/qwBrAGRAZEBBf4F/s3/zf/lAOUAmQCZADABLwFl/mX+OAA4AAMAAwBv/m/+GP8Y/wADAAO9Ab0B4f/h/yMAIwDyAPIAjwCPAN793v1kAWQBFAEUARkBGQFl/2X/bgFuATn+Of4g/iD+z//P/4oBigEfAB8AB/4H/rcAtwD5//n/igCKADr/Ov82ATYBnf+d/9P+0/4iAiECNgI2Ao4AjgBc/1z/xQDFABMAEwAY/xj/5f3l/QUCBQI6AjoChgCGAIX+hf7S/9L/fAF8Aaf+p/4c/xz/OwA7APgC+AIwATABZf5l/hn/Gf/m/+b/W/9b/9r+2v6NAI0A+AP4A9QB1AHY/9j/uP24/R//H/+vAK8A5P/k/3MAcwCe/p7+aABoADcDNwNT/1P/zf/N/+kA6QDi/+L/PQA9AFv8W/yA/YD9KwArAMz/zP9bAFsA0wLTAq3/rf+7ALsAUv9S/x4CHgLTANMA0f7R/u7/7v+WAZYB6//r/6P+o/7H/8f/SQFJAWAAYACs/az9Bf8F/1UBVQGuAK4AOv06/YD/gP+iAaIBbgFuAaH9of1e/17/iAGIAQMBAwGp/qn+MgIyAowBjAEc/xz/6P7o/g0CDQLt/e39eP54/v/+//6EA4QDUQBRAEL8QvyU/5T/hgKGAsP9w/3F/MX8oQGhAe8B7wHX/tf+bP1s/RoCGgKlA6UDRP9E/+387fxsAWwB3f7d/uz/7P/O/s7+BAEEAQQBBAFY/1j/h/2H/ZUBlQHiAOIA8f3x/Vf/V/90AXQB8v/y/8r+yv7NAM0A9P70/u7/7v/Z/9n/1ALUAgABAAE9/D388P7w/p0BnQEO/g7+Af0B/QYABgAzBDME9QP1A4b+hv42/jb+R/9H/0T/RP8K/Qr9/v/+/7v+u/6B/oH+kQCRAAMCAwJ1/3X/U/5T/ngBeAFoAWgB/P38/Tn+Of7VANUAqAGoAcX+xf4r/yv/iAKIAjADMAP1/vX+hvyG/CcCJwK6AboBPv8+/478jvyB/4H/ZwFnAdr/2v/a/dr9fv9+/2ICYgL+//7/P/0//YIAggArBCsEaQFpARv8G/yH/Yf9uAO3A2QBZAH1+/X7Cf8J/2IEYgTBA8EDYfxh/Jb8lvxnAmcCsgCyAIr9iv1u/27/EwQTBDMCMwIZ/Rn9Lf4t/jwCPAKmAaYBWvxa/L3+vf54AHgAkACQANr/2v/c/9z/bAJsAiYBJgGt/q3+AQABANQA1ACu/67/Pf49/gf/B/9v/2//UQJRAgQABAA8ADwAggKCAlYAVgDZAdkBVP5U/oYAhgBx/3H/dwB3ADUANQBPAE8A6//r/34BfgFWAFYAqQGpATkBOQFj/2P/Sv5K/hX9Ff1N/k3+3P7c/vsB+wEQAhACsAGwAVYAVgD5AfkBpQGlAdn+2f45/Tn9ev96/zYANgDQ/9D/GQAZABgCGALPAc8Bj/+P/zP/M/+T/5P/3gDeAOj+6P4j/SP94gDiAMD/wP+NAY0BZgNmAyQBJAHZAdgB1gDWAPUA9QCBAIEA3/zf/C3/Lf9kAmQCCQEJAf7+/v6Z/5n/tP+0/7gAuABs/Wz9Mf0x/V0BXQEsAiwCpv6m/h//H/8DAAMAgwKDAsgAyABb/lv+OgE6AZ0BnQF+AH4Ar/2v/bsAuwBSA1IDFAAUADX+Nf70/fT97f7t/sv+y/56/nr+HAAcADsAOwCLAosCGv8a/0wATABT/lP+//7//jEAMQAZ/xr/qf+p/88BzwEzATMBagBqAFUAVQBeAV4BBQEFAWb+Zv5b/Vv9TABMAJkBmAGOAI4A3//f/3v/e/8+AD4ANv42/iMAIwDIAcgBRf9F/2z+bP6+/77/lv+W/5D+kP63/7f/kgGSAXABcAHG/8b/0wDTAEIBQgEfAR8B2v7a/hj+GP5I/0j/BP4E/kz+TP7g/+D/KwErAZIAkgD0AfQBYgBiAKr9qv25/rn+Tv5O/lj/WP9JAUkBNwA3AMf/x//+AP4AAwADAOH+4f5l/2X/Hv8e/7IDsgPoAOgA9/73/jAAMABhAWEBAQABAMb8xvxK/Er8cAJwAgsACwCb/pv+ZgBmAHUAdQC0/rT+9f71/tb+1v5BAUEBlQOVA2sBawGrAKsA0v/S/4cAhwBU/lT+AgACAOMA4wD0//T/9AD0AC0ALQBO/07/JAEkAbEAsQBmAGYARP5E/nv8e/w6/jr+egF6Af7//v/X/tf+Xv9e/8kAyQD4//j/XgBeAFABUAEoAigCDgMOA5f/l/95/Hn8TP5M/ooAigAl/yX/kv6T/pwDnAPHAccBwADAACf9J/0i/iL+MAEwAXr/ev9//n/+e/17/ZwBnAGKAIoAXf5d/v7//v8FBAUEZP9k/+j+6P5s/Wz9BAIEAisBKwG7/bv9Sv9K/xICEgItAi0CU/1T/dP80/zx/vH+ngKeAlr/Wv91/nX+LwAvABoDGgOeAJ4AJvwm/GYAZgBxAHEAc/9z/0n+Sf6yALIAAwIDArT/tP/GA8YDMf8x/wb/Bv8M/gz+sf2x/TAAMADI/sj+P/4//soBygFKA0oD5wDnAGX/Zf+RAJEADQINAj3+Pf5i+mL6Pf49/hUEFQSNA40DGv8a/1ABUAGhA6EDLQEtAfL68vq2/bb9OgI6AjMBMwFr/2v/2v/a/5oBmgGnAKcAxv3G/b39vf1rAmsC+gD6AK39rf1oAGgAxwHHAfD/8P98AHwA5wDnAKb9pv24/rj+AAAAAPb/9v+kAaQBuQG5ATkBOQGd/p3+4QDhAAsACwCm/Kb8Tv1O/Sj/KP+UAZQBnwCfAFMDUwPZAdkBdwF3AZT/lP8q/Cr8PwA/AJD/kP/f/9//vv2+/QgCCAJ+AH4Ar/6v/jgAOACOAI0ATgFOAZf+l/6z/bP9oAGgAf4B/gFQ/lD+4P3h/YoDigMgAyADpP+k//L+8v6lAqUCpgKmAoT+hP6v/a/9LwEvAWUCZQKm/qb+Zv5m/iUBJQESARIBaf5p/gz+DP5MAEwA1wHXAfb/9v/M/8z/9v/2/1oAWgBbAVsBAQEBAZD/kP8bABsAS/9L/6wBrAGfAZ8BPAA8AAcBBwH9/v3+AgACAL7+vv7n/+f/yQLJArf/t/+3ALcAef95/wMCAwIq/ir+Af0B/b0AvQCaAZkB7gDuAP38/fx5A3kDFAIUApv9m/2m+6b7AgICApsDmwO4/Lj88/3z/ZwAnAAYAhgCzv3P/Zn/mf+TApMCNAI0Atf91/3l/OX8XwJfApIAkgAe/h7+aP1o/bkBuQGbAJsAYf9h/7f9t/2/AL8A5P/k/8D+wP5wAXABxwDHAOcB5wFh/WH9RABEAD4BPgGi/6L/Pf89/2sAawBZAlkCyPzI/Kv7q/uAAYABMAMwA4f+h/7M/Mz8tAK0AjsCOwI5+jn6YPxg/IoDigMmAiUCJ/4n/goCCgJmBGYEiP6I/lT6VPo+/z7/mACYAOP94/28ALwAZgNmAxICEgL+/v7+c/5z/rb8tvzw/fD9SgFKAdYC1gL2/fb9Yv9i/3sDewPIAcgBdP50/qT9pP3T/9P/mP+Y/+P84/yZApkCOwI6AqH/of8n/if+jQKNAmMBYwFO/U79XP1c/TMBMwGqAKoAhP+E/x4BHgFgAWABMf8x/5v9m/36APoAQgJCArn/uf/A/cD9fwF/AZD9kP2j/aP9SAFIASUDJQNXAVcBVP5U/i0ALQDG/8b/i/2L/R//H/9iAWIBxQDFAPv/+/9PAE8AGwEaAXH+cf7l/OX8tQC1AOP/4/95/3n/2ALYAr0CvQK4/7j/v/6//rUBtQEVARUByP7I/gn+Cf6UAZQBFQEVATP/M//AAcAB+AD4AOcA5wDQ/tD+WwBbAPT+9P51/nX+5f7l/hoBGgG0ArQC0QLRArcBtwFbAFsArv6u/mv+a/6J/In8ZgBlAAoACgAwATAB8AHwAeYC5gIvAi8CSf5J/sn8yfzGAMYAFv4W/l4CXgJ4AHgAHwEfAfX/9f9y/3L/oQGhAVD+UP4yADIAsf6x/l3/Xf+M/oz+9f/1/0sASwATARMBBwEHAXH/cf/DAMMAZwFnAZIAkgAEAAQAvP68/kIBQgFT/lP++/77/iYDJgNeAl4Cev96/yb/Jv/7APsA0gDSAJb8lvyM/4z/xf/F/zUANQDM/8z/8v/y/8T/xP/eAN4AWgFaAQv/C/+G/Yb9hP2E/bv/u/+H/4f/BQEFAR4DHgPnAucCh/+H/7L+sv66/7r/nvye/OL84vyn/6f/HwMfAwECAQJfAF8ArgCuAEIBQgH+/P786P7o/pf+l/7E/sT+Jv4m/iMCIwJ3A3cDcAFwAaf+p/7TANMANwA3AO/97/3b+tv6tf+1/48BjwFFAUUB6QDpANUB1QEOAQ4BGf0Z/ST+JP4gACAAxP3E/Qz+DP5GA0YD6gHqAeUA5QCB/4H/9wL3Aob/hv8i/CL8IAAgAGgDaAN9/X39Af8B/zcENwRSAlICYPpg+ij9KP2b/5v/WAJYAmr9av1A/0D/zgXOBVYCVgKn/qf+i/6L/poBmgHY/Nj87fvt+4cAhwCNA40DqQCpADH/Mf8IAwgD4AHgAZv/m/+i/aL9cfxx/NX91f3YANgAzwDPAKgBqAHrAusCnAGcAbb/tv/C/sL+jv6O/hH+Ef6z/bP9WQFZARcCFwKtAK0Arv+u/xcCFwK2ALYA+f/5/+j+6P5z/nP+Af8B/2b+Zv4BAgECdAF0AfsA+wAB/gH+PQA9AEIBQgEU/xT/l/2X/QsACwAg/yD/H/4f/j8APwAbAxsDBQIFAmz9bP3WAtYCQP9A/xP9E/3d/d39kgKSAksCSwKoAKgAYQFhAZwDmwPI/cj9mfyZ/CIBIgE2AzYDnfyd/Oz/7P8SAhICPwE/AfD98P0mACYACAQIBBH/Ef/1/fX97wHvAcQAxAAd/R390P7Q/pcBlwHBAMEA8f7x/pYAlgCJAIkAYP9g/1j8WPzb/9v/zwDPAH0AfQDiAuICSQFJAe3/7f9s/Gz85P7k/osAiwCP/4//QwFDAa8BrwF/AX8BX/1f/bj/uP8MAAwAWQFZAXv9e/2lAKUAtQG1AYz/jP/Q/dD9IgMiA0kASQDc/tz+u/y7/LcBtwED/wP/lP2U/WgDaAPgCOAICv8K/5D7kPvxAPEAbQJtAmj6aPrI/Mj8sgKyAoIAggAf/R/9YwFjAYoFigU6AToB1/zX/Mj+yP7Y/9j/G/wb/C39Lf1gAGAA5QHlAbIAsgCKAYoBdAV0BdYA1gBw+3D74v3i/TsBOwGf/Z/9UPpQ+qkEqQTUAtQCq/2r/Tn+Of50BHQE+AD4AAv9C/3XANcARAJEAnn+ef6l/aX91QDVALIBsgEt/y3/Iv8i/x//H/9U/lT+JP4k/mcBZwGwAbAB0P7Q/jn+Of7vAe8BMgEyAXn9ef32/vb+OQA5AAUABQCA/4D/cAJwAgQDBAPk/+T/1/vX+9z+3P5UAFQAPf49/hIAEgAZAhkCHQIdArP9s/32APYA9P/0/z0APQBk/WT97/7v/uIA4gCL/4v/uv66/g8DDwN7/3v/gwCDAPb+9v7c/9z/2/3b/dj/2P/AAcABhACEAJL+kv6GAIYA8ADwAAD9AP0+/z7/KwMrA7f/t/8Q/xD/EAMQA1gCWAJP/k/+PP88/4QBhAHu/O78pf+l//gC+ALT/9P/wvrC+vcA9wADAwMDsP6w/kX+Rf70AvQCJgMmA3b7dvs1ADUAsgOyAxAAEABI/Ej8VgBWAOsE6wQ1ADUAoP6h/vAB8AGDAoMCT/5P/pL+kv5U/1T/hAKEAnr+ev5k/2T/gACAAGUCZQJ2AHYAOgE6AUL/Qv/i/uL+Pf49/rr9uv1vAG8AvgS+BCwCLAJs/2z/NQA1AHL+cv6q/qr+Mv8y/44AjgBU/1T/LQQtBKUDpQPp/+n/CwELARz/HP/e/97/BP0E/d7/3v81ADUAWABYADD+MP4HAgcCNwE3AXT/dP+4/bj9tf21/UkCSQJ3AXcBh/+H/+D/4P94AXgBrP2s/en+6f6G/4b/uwO7A/sB+wG7/7v/qACoAJQAlADc/9z/G/wb/Ov96/0+AT4BoACgABP/E/+tAK0AeAN4A0wATADy//L/2v/a/3oAegAX/Bf8JQElAewC7AL6APoAIf4h/pj/mP9c/lz+Q/9D//T/9P8gAiACqQGpAX7+fv7FAMUA9v32/cP9w/2W/pb+KAAoANgA2AAlACUAgwGDAUABQAFbAFsAEAAQAGn9af1c/lz+U/9T/1z/XP8AAAAAPgM+A/wA/ABBAEEAtvy2/GIAYgDz+/P7kf2R/fkA+QDvAe8BiQGJAa8CrwJpAWkB1//X/2z+bP4w/jD+Cv8K/6UApQDrAOsAOgE6ASIBIgGc/5z/VwFXAYL8gvxe/l7+cv5y/vsA+wCMAIwA+AP4A54AngBq/2r/Hv4e/gMAAwBM/kz+G/4b/g8EDwQYARgBR/9H/6X/pf9PAE8ACv4K/qH7oftuAW4BBgMGA8P/w//qAOoAcgFyAeT/5P8e/B78pf6l/n4CfgLw/vD+2//b//0B/QENAA0AdgB2AH8AfwDLAMsAOf05/W79b/15/3n/sACwACkBKQETAhMCfQJ9AtYA1gA2/jb+JwAnAEX/Rf/S+tL6d/93/48CjwITAxMDE/8T/z8BPwHQAdABm/yc/Hb6dvrB/8H/fAN8A8QAxAAGAgYCEAEQAYgBiAEZ/Rn97vru+vz+/P4L/wv/ngGeATICMgJ8AnwC2wDbADL/Mv/L/cv97P7s/u7+7v64+7j7LP8s/w0ADQBvA28DOwI7At8B3wFWAFYAwP7A/rL8svxU/1T/tf+1/wT/BP8OAw0DVgNWA6MCowI4/jj+3QDdAH7+fv7N+837hfyF/EkCSQIOBQ4FfwB/APsD+wN8AnwCeft5+8z6zPqK/4r//wD/ADb/Nv9SAlICCgUKBRABEAE8/jz+7P7s/m//b//N+837kP2Q/fEC8QK7AbsBHwAfAMABwAFlAWUBb/9v/2f8Z/x6/3r/ef95//P+8/7VANUA7wLvAvD/8P+h/aH9mQCZAHoAegARABEA+gD6ACv/K/82/Tb9Z/9n/3oAegC0AbQBw//D/5cClgKEAYQBSv9K/4f/h/8/AD8AT/9P//j9+P2O/47/hQOFA1oBWgFeAF4AZf5l/kcARwA0ADQAGP8Y/wwBDAE4AjgC7//v/3T9dP1a/lr+DgEOAfn/+f9F/kX+VwJXAk4BTgF5AHkAKf8p//sA+wA//z//N/43/rv+u/7q/+r/vAC8ABYCFgLAA8AD2P/Y/1v+W/7r/+v/JQAlACf+J/5o/mj+9QD1AFwBXAH7APsA1gDWADoCOgIu/C78tv22/WYAZgB6AXkBNgA2AID9gP0QAhACNgE2AbT+tP6p/an9TQJNAvoA+gBqAGoAJ/4n/jEAMQANAA0Arvyu/Jb+lv6fAp8COAI4AvcA9wCV/ZX94wDjAM/9z/1F/UX9jgCOAIUBhQGCBIIEDgEOAfn++f5g/mD+Kv8q/5j9mP1jAWMBWgJaAjQENAQu/i/+wf3B/SD+IP43AzcDiv6K/uT95P0nAycDeQB5AGH9Yf2B/4H/iQGJAZL+kv5U/1T/df91/70CvQJdAF0Ac/9z/5ABkAG8/rz+4v7i/hj9GP3c/tz+cwNzA+0B7QFBAEEA8v7y/pkBmQGs/qz+d/t3+4wAjAAJAwkDfQJ9AmcAZwCK/4r/bgBuAEL9Qv2l/qX+gv+C/zAAMACKAYoBHgIeAu8A7wBZ/1n/OP44/u/+7/6b/pv+hP6E/gIDAgON/43/ygDKAJL/kv/6APoAmf+Z/3v9e/3dA90DDwAPAPD+8P4eAB4AVwNXA6X9pf0A/gD+3//f/5kBmQHw//D/qgCqAGMBYwF3AHcAqf6p/oT+hP4r/yv/UABQAKIAogCXAJcAzQHNAXP+c/5sAGwAfwB/AHz/fP+E/YT9mACYAKQBpAFUAFQAKP0o/ZcClwI+AT4Bvvy+/J/+n/4rAyoD+wD7AEj9SP1zAnMCQgJCAvz+/P4q/Cr8yADIAIcBhwEa/Br8R/5H/owAjAA9AT0Bjf+N/77/vv9MAUwBGwAbAA3/Df8UAhQCvAG8AQL/Av96/nr+A/4D/un96f0PAA8AqAKoArgBuAGoAKgAIwEjAY8BjwEx+zH7oP2g/aoCqgLbANsABAAEAHABcAHjA+MDCf4J/p79nv0CAQIBhAGEAZ7+nv4HAAcAbABsAGQAZABx/nH+WABYAJH/kf+L/4v/P/8//1P+U/5hAWABwf/B/5IAkgD4//j/agBqAJUAlQAA/gD+Yf1h/X0BfQGSApICKgEqAXYAdgDDAMMAG/4b/hL+Ev49/z3/yQDJAAL/Av8GAgYCfv9+//H98f2nAKcAgQCBALoAugD0/vT+gwCDADz/PP8e/h7+cf9x/zkDOQON/43/lP6U/q8ArwBTAlMCmP+Y/+//7/9/An8CDwAPAMUAxQAO/g7+5f3l/Wf8Z/zzAPMA1QLVApIAkgAHAwcD8APwA4X+hf4n+yf7aQBpAPcA9wCo/aj9xwDHAB4DHgNeAV4BY/xj/BMBEwGbAZsBJf4l/sb9xv3oAegB9//3/+z97P32//b/twC3APH+8f6N/43/SQFJAZUAlQAxATEBpwCnAJv+m/55/Hn8k/+T/2b/Zv/r/+v/qQGpATEFMQUIAAgAcP5w/lz/XP/l/+X/i/2L/Q7/Dv8iACIAx//H/6MAowDOAM4AWgJaAu0C7QIV/xX/bf5t/kH+Qf6JAokCZQBlAMf9x/3UANQA4ADgAHz9fP0Q/RD9RgJGAl8AXwAhASEB0AHQASoCKgJf/V/9Vf1V/Tv+O/6R/pH+d/53/kEDQQNVBFUE1//X/6L/ov/IAMgAm/+b/9D90P3D/8P/Kf8p/3r+ev6ZAZkBLAEsAUYCRgIIAggCMQAxAO377ftS/lL+W/9b/+r+6v5S/1L/rAGsAcIEwgSs/6z/bABsACsBKwH0/fT9jv2O/SMBIwGs/6z/Wf9Z/5z+nP4CAwIDawBrALD8sPy1AbUBvAG8AcD/wP+bAJsAt/+3/1UAVQDx/PH8W/5b/iMAIwDfAt8ClgKWAl//X/8NAA0A2gLaAkj+SP6t+q36TAFMASQCJAJh/mH+tfu1+zUDNQOjBKMEgwCDANn82fwaAhoC1/7X/tD80Pwv/y//tAG0Aa4ArgBgAGAAGAEYAb8AvwBi/mP+6P7o/i3/Lf+1/rX+iAGIAWf+Z/7FAcUB9wD3AL8BvwGJ/on+RfxF/BQAFABRAlECSv9K/9T91P1hAmECKwMrAyf/J/+E/oT+/gH+AcD/wP9Y/Vj9z//P//UB9AEa/hr+i/2L/XABcAEbBRsFKQApALn8ufxt/27/Av8C/8b+xv4iASIBQAFAAbH/sf8P/w//tP+0/wQABABHAUcBRQBFAGz+bP7pAOkAWv9a/y3+Lf6Y/5j//AH8ARUAFQDl/+X/KAAoALgBuAEz/zP/9gH2Ac7/zv+//7//+/77/hD+EP67/rv+6gDqAJMBkwE5AjkCK/0r/dr+2v7t/+3/C/8L/9f/1/+lAqUC2wLbAsH9wf28/7z/UABQAI/+j/6j/KP8JAMkA4oEigR5AXkBJv4m/qoBqgEb/Bv83/rf+gkACQD9Bv0GPgE+Ae/+7/6PAY8B+wP7A0L7Qvvx+/H7DAIMAi8ALwCB/4H/CQIJAuYD5gNn/mf+bP1s/QYABgAXARcB3P3c/av/q/8gAiACLQEtAUn+Sf6NAI0A8wHzARP+E/6L/ov+KgMqA2EAYQA0/jT+PP48/vMA8wBLAEsAWP9Y/8kByQF6AHoAkv6S/k8ATwCyAbIBkwGTAZT+lP6O/Y79QABAAIAAgAB+/37/zQHNAX0BfQG6/7r/PAA8AN/+3/5uAG4AOgA6AHv/e//JAckB0QDRAOL/4v9X/lf+qgGqAZ8AnwAz/jP+Hf8d/3UBdQGeAJ4Ai/6L/r8AvwDUAdQBov2i/Rz8HPwD/wP/bgBuAKEBoQGE/4T/igKKAmwAbADg/eD9Wv5a/rH/sf8PAQ8BlPyU/IAAgABGAUYBqv+q/1f+V/7lAOUAeAJ4Aur+6v4B/gH+vAG8ARQBFAF2/Xb9jf+N/4n/if/u/u7+2f7Z/qQBpAF3AncCZQFlAfgA+ACSAJIAqf6p/sD9wP1K/0r/0v3S/XD/cP8FAwUDLgQuBAkACQBH/0f/6QDpAEj9SP2C/YL9WAJYAnYBdgGQ/ZD9AQABALcEtwS7AbsBUP1Q/dT/1P+j/qP+9fv1+yr+Kv4oBCgEtAOzAycBJwEh/yH/6v/q/4T9hP1c/Vz9Jf4l/oABgAGcA5wDnwGfARoAGgD9Af0B3v7f/jr9Ov0W/Rb9cQFxAXz/fP+K/4r/rgCuANIC0gKIAogCJf8l//D+8P63ALcAJ/8n/1j7WPuuAK4AMQIxAjz/PP/k/uT+5gLmAuAA4AAi/iL+5//n//YC9gIQ/RD9wvzC/AADAANvA28DSf9J/6f/p/+iAqICq/2r/aj6qPpHAkcCjQKNArf+t/62AbYBmwGbAY79jv2i/KL8nACcALEAsQDNAM0AMQExAWUAZQBw/nD+y/7L/t7/3v/o/uj+nP6c/q0BrQGZAZkBfgB+AOcC5wLqAOoA+P74/tT91P1x/3H/L/0v/Yz/jP+EAYQBqAKoAosBiwHLAMsAx/7H/nf8d/w4/jj+UQFRAQT9BP1IAUgBggKCAtsA2wCU/5T/Jv8m/3YAdgDt/u3+hv+G/58BnwGHAocCEP8Q/5H+kf4g/SD9S/5L/ggACADR/9H/8QHxAeQB5AGx/7H/R/9H//MA8wC+/b79Hv0e/WQBZAFOAk4CPwE/AcUAxQD3APcAMP4w/iT9JP1n/2f/oAGgATQANADR/tH+wwHDAUQBRAEM/wz/Kv8q/8EAwQBS/VL9Nv82/5kBmQHDAcMBf/9//7QAtACaAJoAEv4S/pL+kv7FAsUClwGXARz/HP8D/wP/tv+2/3UAdQDu/O78hgCGAOwA7ADN/83/4v/i/4j/iP+cAJwA+AD4AI3+jf7r/+v/gwODA64ArgCs/Kz8n/6g/un/6f9zAHMApP6k/qgEqARbAVsBQABAAMX8xfybAJsAtP20/f/8//zwAPAAMwMzA/AD8AOJAIkA+f/5/00ATQAP/w//vP28/Vz+XP4//z//ywDLAJQClAKR/5H/QQFBAaH/of8t/i3+nf2d/R3/Hf9zAXMBYgFiAdEC0QKVAJUAtf+1/+L+4v72/Pb8wP3A/WwBbAFHAkcCYv9i/3j/eP9vAm8CrgGuAUb+Rv5n/2f/cAJwAs39zf3z/PP8eAB4AK8ErwT5/vn+7/3w/fcB9wGoAacBf/1//fj++P6jAqMC4//j/+P+4/5UAlQCDAEMAcj+yP6p/qn+B/4H/kAAQAAYAhgCDgAOAFwAXABcAFwA5P/k/+P+4/6P/o/+DAEMAdr/2v8F/gX+XQFdAegA6ABxAHEAmP6Z/sQBxAHlAOUANP80/zH/Mf8YABgAkP+Q/wP/A/+0/7T/FQMVA6cBpwFT/1P/agFqAR8AHwB5/Xn9Kf8p/y8BLwE3ADcApv6m/qoAqgBMAUwBmP+Y/1b/Vv+mAaYB0wDTANP80/w9AD0AQANAA+j86Pwn/if+HgMeAxIBEgFs/Gz8wQHBAb0CvQLV/9X/k/2T/T0BPQFVAVUBQv9C/7r/uv8yADIAsP6w/mAAYAA4/zj/u/+7/4kBiQFHAkcCAv8C/xr8Gvxr/2v/gACAAOr+6v7DAMMAywPLA6v/q/+o/qj+Pv4+/hYCFgJK/0r/MwAzAD4APgAvAS8BO/87/5UAlQCE/YT9CwALAAUABQDuAe4Brv+u/xMBEwE3ATcBif6J/ov8i/y7ALsA+v76/v4B/gHV/9X/mQGZAdgC2AI0/jT+Dv0O/Rn/Gf+EAIQA8P7w/ob/hv9ZA1kDLQEtAWr+av54AHgA1wDXALv+u/5a/Fr86ADoALICsgJ6AHoADAAMALgCuAIYABgAQf1B/ST+JP5kAWQB7f7t/jT+NP4E/wT/5ALkAmsBawFGAEYA/f/9/z//P//h/eH9kP2Q/X0AfQDzAPMANv82/yMCIwLlAOUAvgC+AOX95f2F/4X/WwBbAOb/5v+0/7T/SgJKAkv/S//X/tf+ZP9k/0sBSwFt/23/uP64/voC+gLlAOUAcP5w/in9Kf3OAc4BkQCRADL8MvyeAZ4BTwFPAc/+z/6Y/5j/DAMMA0UBRQFp/Gn85P/k/zgCOAJu/W79OPw4/AgDCANYAVgBQ/9D/+kB6QGzA7MDEP0Q/Q79Dv15AHkAev56/n/7f/vJAMkA6wXrBRkBGQETABMAKwErAbT/tP/H/Mf87f3t/QoACgDSANIAvgC+AL4AvgCYAZgBrv6u/pkBmQHAAMAAv/+//4z/jP91/nX+Ff0V/Zb/lv+1ArQCJAMkA28AbwB4/Xj96v7q/n3+fv7h/uH+2QDZALQDtAOSAJIAqv2q/R4AHgCp/qn+bf9t/3r/ev9dAl0C5QPlA9H/0f+//b/91v7W/lj/WP9b/1v/if+J/7ABsAGzA7MDLgAuAAb/Bv9qAGoAyf7J/nj8efxi/2L/2wDbAEECQQLmAeYBiwOLA2z+bP4r/iv+xf3F/R4AHgDF/cX9vf69/pQDlANRAlECT/9P/5H/kf9j/2P/yv7K/gD+AP56AXoBqAKoApX+lf51AHUAawBrAAH/Af/7/fv9OwI6Au8D7wMRABEA4f/h/wwBDAH3/ff9xvvG+8P/w//kA+QD9AH0AXr/ev+zAbMBdwB3AOn76fts/mz+YQBhAFMBUwFw/3D/kwKTAqUBpQHw/vD+/////3T/dP9R/VH9z/7P/psBmwHqAeoBp/+n/+cA5wDp/un+kv2S/S7/Lv+oAqgC3P/c/279bv2UApQCnP+c/1L+Uv6S/5L/WwBbAIr+iv4cABwALgAuAMoBygEJAQkB6/7r/isAKwDx//H/Yf9h/wH+Af5XA1cDhwCHADv9O/0UARQBSgJKArX8tfyQ/pD+AwIDAo3/jf/y/vL+0gTSBJ4AngBJ+0n78gDyAPoA+gDR/tH+tf+1/6AAoADt/+3/rwCvAEACQALB/sH+yf/J//L+8v7o/+j/SQFJAVwBXAGNAI0AxP/E/yIAIgAD/QP9Lv4u/mcAZwByAnICwAHAAXb/dv9B/0H/+f75/u387fyT/5P/7wLvAgMCAwJz/XP90QHRAUcBRwHC/ML81P7U/tsC2wKv/6//FP0U/e0C7QIJAAkAa/1r/e4A7gChAaEBCf8J/3z+fP5WAVYBf/9///8A/wALAgsCCP8I/zv/O//y/vL+lgGWAToAOgAi/yL/lgCWAHb/dv/9//3/Yv9i/0//T/8JAQkBM/8z/xj+GP4UABQAIAIgAqAAoAAh/iH+kAKQAvH/8f+3/bf9fgB+AFYDVgOk/qT+jP6M/sQAxAA2ATYBU/1T/RIAEgDeAd4Bdf91/0f+SP7n/+f/lP+U/8X/xf+/AL8AHP4c/swCzALQAtAC1wDXAEMAQwCd/Z39TvxO/ND90P0WAhYCvAO8A68CrwKWAJYAnPyc/Nv92/25/7n/TABMAEwBTAF/An8Cuv+6/5b+lv5hAGEAcP9w/5D+kP4AAAAAtQS1BAn+Cf6o/aj9zQHNAWP+Y/6k/6T/lQCVAIMCgwIy/TL9Ef8R/54DngOqAKoAr/yv/GIBYgEgASABPP08/W0CbQKkAqQCjf2N/XT+dP5zAXMBsgCyACf9J/07ATsBhgKGAsn9yf0HAAcAFQEVAdv+2/5D/kP+jwCPAAwADAAIAAgAuAO4A9r+2v6c/5z/bgBuAM//z/8M/gz+bQBtAK8ArwCI/4j/0gHSAR0BHQFy/nL+qf+p/ysBKwGq/6r/0P/Q/1EAUQCj/6P/R/9H/0gBSAHSANIAvwC/AG/+b/7h/uH+6P/o/1f+V/66/7r/YAJgApMAkwBu/m7+fQF9AfoB+gEx/TH9JP8k/8z/zP8UABQA/v7+/noBegFkAWQBDv8O/9/+3/7f/t/+xf7F/kb/Rv/hAOEAuAK4AiL/Iv9h/mH+NgA2APD/8P+I/4j/lgGWAVcCVwIz/jP+Zv9m/1kAWQBN/U39vv2+/WgCaALXAtcCZgBmAJoAmgDj/+P/mPqY+gz+DP4dAh0ChwGHAfwC/AIeBB4ENf82/5b7lvvr/uv+bf9t/1D+UP7BAcEBPQQ9BJv9m/1V/1X/tgG2AcH+wf6f/Z/9mQCZAA4BDgGFAIUA2P7Y/qz+rP6EAIQANgE1ARgAGADGAcYBMAEwAQf8B/wE/gT+y/7L/qYBpgG7/7v/ZgJmAiUDJQOk/qX+R/5H/hn/Gf/W/tb+yf3J/az/rP+7AbsB5wPmAwkCCQLPAM8AlP2U/aD9oP0M/wz/Uv9T/48BjwFQAVAB3gHeAZ0AnQAe/h7+P/0//bn/uf8nACcABgIGAu3/7f9kAGQA3/7f/pn+mf6yALIAlQGVAdMA0wCn/6f/af9p/+f+5/63ALcAGgIaAg4BDgHQ/dD9lf+V/0IAQgCD/4P/nv+e/x0CHQJV/1X/yv/K/1EBUQEGAAYAbf9t/8X/xf+5/7n/3f7d/mj/aP+tAK0AvQC9AFABUAG7ALsAIf4h/g8ADwCBAYEBiQCJAKT+pP7t/u3+bwBvAD3+Pf5l/2X/cwJzAkICQgIx/jH+1P/U/0cCRwIR/RH92v3a/ZoBmgGcAZwBGAAYAPcB9wGaAZoBfP18/er+6v7ZANkA2v3a/ZEAkQCbAZsBYQBhAMH+wf5nAmcCXwFfAWL/Yv+E/4T/xgDGAFv9W/16/nr+UQNRA7v/u/9y/XL9AQEBAf////+t/a399AH0AR4DHgMh/SH9/P38/bIBsgFD/kP+ev96/9IC0gK+Ar4CK/4r/g8ADwCG/4b/ef15/ST9JP1lAGUAVwFXAWwBbAFDAUMBzQDNAAwADACX/Jf8pf6l/r//v/9yAXIBgwGDAfkB+QGOAI4AHv8e/wP/A/8FAAUAi/+L/6QApAD+//7/8/7z/kgBSAEzADMAgP6A/iD/IP9WAVYBkf+R/7r+uv6OAI4AwwDDAMT+xP6NAI0AfwB/AFkBWQGK/4r/2wDbAEj+SP7d/93/9gD2AGEAYQBo/2j/0//T/6wArABs/2z/df91/+//7//V/9X/yADIAG4AbgB3/3f/nP6c/nYBdgHQ/9H/Vv9W/5gBmAES/xL/Nv82/wL/Av/F/8X/Y/9j/1f/V/9MAkwChgKGAoj/iP/R/tH+Of85/7/+v/73//f/NAA0AL0AvQB/AH8AQQBBAP3//f8k/yT/0v/S/6r/qv+HAYcBBAAEAAr/Cv9u/27/Ov86/7T/tP+WAJYAWQBZANkA2QBDAUMBcv9y/4r9iv2C/4L/WP9Y/7L/sv8UABQA9AH0AZn/mf88AjwCjACMAK79rv0NAA0A4wDjAKz9rP33/vf+kAOQA5QAlAD2//b/FgEWAVD+UP6k/KT8lv+W//oB+gGjAKMAGgAaACkBKQGyALIAZf9l/53+nf5sAWwBnAKcAvT89PwJ/gn+OAM4A3n/ef+W/Jb8MAMwAz0CPQJZ/1n/JAEkAeP/4/9h/GH8Av0C/bABsAGiAaEBBAIEArcCtwJjAWMBbPxs/F3+Xf4j/yP/1ADUAFoAWgCJAYkBoQGhAez/7P/o/uj+bv5u/rf/t/9q/2r/XQJdAigBKAH0AfQBgP6A/nz9fP0e/x7/Pv4+/k8BTwGXApcCmwGbAd0C3QLbANsA8vvy+yP+I/62ALYAzf3N/SsBKwFyBHIEdwJ3Apf8l/xFAEUAQABAALb8tvyDAIMA2QDZALb/tv+IAIgASwFLAfr++v5N/03/aQBpAMr/yv9U/1T/JAEkAWIBYgFX/1f/2v7a/j0APQAb/xv/4wDjAHQBdAFzAHMAeQB5APMA8wC4/rj+XP5c/vgA+AAz/zP/lP6U/h4DHgOoAqgC+P34/fX/9f+hAKEA+/z7/JX+lf6uAq4C/v7+/jn/Of9WAlYCUgBSAJP+k/6c/5z/YQBhAIj+iP5bAFsAX/9f/9j/2P8NAQ0BLP8s/2D+YP4TABMASQFJAd8A3wBlAGUAOP84/738vfwIAQgBm/+b/9cA1wAvAS8BUwBTAKn/qf8s/iz+qv6q/mv9a/1a/1r/3AHcAXQCdAKnAacBAAEAAZf+l/4F/gX+Ov46/rH/sf+ZApkCOgE6Abf/t/9MAUwBmP+Y/9783vxM/Uz9FQEVAfAA8AB+AX4BEwETAZkAmQAx/TH9Ff8V/7L/sv/a/tr+EQERAdoB2gFCAEIA5f/l/6wArABX/1f/N/43/vr9+v1jAWMBCAIIAioBKgFGAEYANAA0AEj/SP8w/DD8OP44/m0CbQJkAWQBdQB1AP4B/gH0//T/JP4k/gMAAwCS/5L/s/yz/NT+1P6ZA5kDNgI2AtT+1P4wATABbgFuAZv8m/x8/Hz8TAFMARQCFAKLAYsBlQKVArsBuwGQ/JD8EPwQ/PQA9AA2ATYBDv4O/gcBBwGcA5wDSP9I/6T9pP01ATUBL/8v/3r+ev7sAOwAdAJ0AsX/xf/i/uL+ywHLAXAAcAD0/fT9DgEOAW0CbQLT/NP8uP+4/xYDFgPEAMQAqvyq/EMBQwFX/1f/Bv8G/44AjgBEA0MDRgBGAM7+zv4EAgQC/P78/m39bv2n/qf+/AH8AZEBkQGF/4X/ugC6ALkAuQDn/ef9If8h/8D+wP5kAGQATv9O/yoBKgFoAWgBqQGpATz/PP+b/pv+Xf9d/9X/1f+I/oj+TABMAF8CXwKR/pH+Z/9n/1oCWgIj/yP/q/2r/Z8CnwLK/8r/hP6E/ikAKQBvAm8CX/1f/VD/UP8PAw8Dw/7D/i79Lv0DAQMB+AH3ATT9NP0r/yv/KQIpAmT/ZP9I/kj+4gDiALD/sP+k/6T/ygHKAa8BrwFF/kX+pv2m/RwAHAAEAAQARP9E/w8DDwPWAdYB3f3d/ZP/k//fAN8AgP2A/cn/yf9LA0sDEwATAO7+7v5hAWEBLAEsARH+Ef4MAAwAwgHCAUH/Qv8pACkA/wD/ANb91v1K/0r/UQBRALUAtQBEAUQBVQJVAs3+zf5G/Ub9mwGbATT/NP9e/F78bwFvATYDNgN4/3j/T/9P/58CnwKY/Zj9//v/+6gAqABmAWYBnACcAEYCRgJBAkECef55/n/9f/0V/xX/Xf9d/1wAXADWANYAYAJgAiwCLAJ2/3b/vP28/c7/zv8CAAIAFP4U/iYCJgLCAMIA/v7+/qoAqgDhAeEBh/yH/Jz+nP5gAmAC6/7r/sf/x//7AvsCT/9P//r8+vwiAiIC7ADsAPX99f0wADAADgIOAsb+xv4uAC4AmAKYAkT/RP/4/fj9BQEFAaD/oP81/zX/YwFjAU7/Tv/w//D/IQEhAeT+5P7a/tr+WgFaAfsB+wF5/3n/nwCfACUBJQGb/5v/1/7X/ur/6v+m/6b/Mf4x/ugC6ALZAdkBPf89/yf/J/8UAhQCO/47/ob9hv29Ab0BygHKAWn9af2k/6T/zwTPBIr+iv4R/hH+8ADwAA4BDgFv/m/+TP5M/oUBhQGC/4L/z//P/44CjgKZAZkBmP+Y/83/zf/N/c39oP2g/TT/NP9ZAVkBBwEHAR4BHgFAAkACuAC4AOH84fyt/a39rv6u/u8A7wB6AXoBIgEiAboBugG6/7r/k/6T/oz/jP+MAYwBEP4Q/kP/Q//tAe0BJgAmAMn/yf+BAYEBSgBKACz+LP4O/w7/ygDKANP+0/7Y/9j/0ADQALz+vP5WAFYAjf+N/6n/qf/uAO4A7QHsAX3+ff4G/wb/LAAsAN/+3/5vAG8AlwGXATgBOAG//b/9vP68/i0ALQABAAEAr/6v/mwAbADLAcsBMQAxAMj+yP64ALgAQ/9D/w3+Df5s/2z/ywHLAdUA1QAk/yT/hwGHAcr/yv8N/Q39Df8N/5f/l/9f/1//cAFwAUIDQgPN/83/g/6D/gIAAgCL/ov+kP2Q/VoAWgBwAXABbAFsAcEAwQA2ADYA1v3W/Sn/Kf9fAF8Aav5q/sEAwQDPAs8CAAEAAQn+Cf43/zf/9f/1/yD/IP/HAMcAugG6AV0BXQH8/vz+/P78/pEAkQCv/6//cf9x/1wBXAE1ATUBMf0x/f3//f8xAjEC7f7t/gL/Av9IAUgB/P78/oD/gP8CAAIAoP+g/7H/sf8yATIBYQJhAkn+Sf40/jT+QQBBAMD/wP/V/9X/XAFcAfIA8gCEAIQA5/7n/qX+pf4b/xv/rgCuACMBIwFYAVgBywHLAQwBDAGa/Zr9uf25/dv/2//Z/9n/iP+I/zQBNAGSAJIAaABoACMCIwLQ/9D/VPxU/Lj+uP5kAmQC4P7g/rj/uP8mAiYCagFqATH/Mf/c/tz+ywDLAMP/w/+ZAJkAz//P//L/8v/4/vn+d/93/4gCiALY/9j/JQAlABEBEQHL/sv+Cv0K/TEBMQHZANkANP80/04ATgCIAogCJQAlABb+Fv7s/+z/AgECAbb8tvyVAJUAVAFUAeMB4wFgAGAAjAGMAb0AvQDs/Oz8AAAAAEwATAAA/wD/3QDdAEACQALU/tT+Sv9K/30CfQLi/+L/fP58/ioAKgBIAEgAFP4U/rsBuwFXAVcBGf4Z/sj+yP67/7v/1P7U/j3/Pf/iA+IDkQCRAEcARwAgACAAWv9a/1H7Ufvp/+n/rAOsA8T/xP/QANAA+gH6AXL+cv4y/TL9VQBVAC4ALgBv/m/+kwGTAc8CzwJc/1z/Bf8F/xT/FP87ADsAH/4f/nAAcAASAhICXP5c/mj+aP7iAOIACQIJAjf+N/5v/2//Cf8J/xP+E/5PAE8A7wLvAlgBWAFp/2n/HwEfAV79Xv05/Tn9NAI0AsABwAES/xL/7v/u/5YDlgNw/3D/TP9M/wsCCwIm/Sb91/vY+6UApQDs/+z/ZwFnAX0CfAKLAYsBtP60/mf9Z/1GAEYA+f35/aD/oP8HAwcDaf9p/4H/gf/LAcsBSQJJApX8lfx9/33/AgICAlX+Vf7g/uD+3wDfABIAEgAT/hP+rQGtAdoB2gGF/4X/4/7j/hkBGQHD/sP+Gv0a/XT/dP/WANYAsgCyAKQBpAF8AHwArQCtAOwA7ACK/or+M/0z/RUAFQARAREBOv46/l8BXwEWAxYDhv+H/1L9Uv3pAekBYQBhAEj9SP1XAVcBZAFkAQj+CP6k/6T/HgMeAyD/IP+y/7L/oAKgAoUAhQAL/gv+ff99/7D+sP4n/if+5v/m/6gAqABjAGMAXgBeAOsB6wF5AHkAvP68/ln/Wf84ADgAGAAYAJz/nP8vAC8ApgCmAFsBWwG5/7n/awBrAMkAyQAaARoBuv26/RkAGQBQAFAACv0K/Sj/KP+0ArQCfQF9AaIAogApAikCVQBVAAr9Cv0H/gf+e/57/sD/wP+SApICHQMdA7MCswJi/2L/Bv8G/5v+m/6f/Z/9d/93/+gA6AD1APUAPwI/Atj/2P+J/4n/iP2I/cr/yv+N/43/0P/Q/+YA5gABAAEAXv9e/4cAhwBlAGUAdf51/pz/nP+2AbYBPP88/ycAJwAUARQBEf8R/4n/if+oAagBdgF2AbX/tf8v/y//EgASAIz+jP5/AH8AVgBWAOv+6/4yATIBIwAjALMAswDFAMUAYgBiANH/0f/V/tX+IAAgAEYARgALAQsBQwFDAdb/1v+p/6n/Ev8S/0AAQABK/0v/tgC2ADr/Ov+q/6r/dP90//wA/ACn/6f/MQAxAJYAlgB9AH0AD/4P/j4APgAfAR8B/v/+//7+/v66ALoApv+m/wkBCQGbAZsBvP68/tL+0v61ALUAOAA4AIb9hv2XAZcBzwHPAS/+L/5MAUwBbANsA7v+u/5F/0X/XgFeARP+E/64+rj6QgFCAfsB+wGk/6T/KgMqA2EFYAWL/Yv9QPtA+4H+gf5u/W79vfy9/IcDhwM0BTQF2wHbAc7/zv8AAAAAd/x3/H77fvs//z//eAB4ACUDJQP9A/0DMwMzA43+jf6E/YT9zf7N/u787vzC/8L/6QHpAZUDlQMpAikCBv8G/7n9uf0c/hz+Tv5O/v7+/v76APoAuQG4Ad0A3QDZ/9n/vAC8ABX+Ff4B/gH+xALEAvoA+gBP/k/+5f/l/+UC5QK9/b391/3X/SgCJwJpAGkATP5M/qMBowGNAI0Ac/5z/jUANQB9/33/mf2Z/d7/3v93AXcBxP/E/+f/5//0APQARQBFAHT/dP+CAYIBJv8m/0n+Sf7r/uv+Qv9C/27+bv4dAx0DPwI/Ah3/Hf/4/vj+SABIAIH+gf7X/9f/AQIBArf/t/8f/h/+pQGlAfAA8ADl/+X/6f7p/ukA6QDKAMoASv9K/54BngF5AXkBfQB9ABj+GP7i/uL+of+h/3v+e/7K/8r/ZAFkARMBEwHN/s3+OwA7AIMAgwBG/0b/xgDGAMb/xv97/nv+P/4//vP/8/8LAAsAxwHHAQgACAAtAC0APf89//r++v6K/or+If8h/y0ALQCf/5//qAGoAS0CLQJ1/nX+r/6v/uAA4ACC/4L/B/4H/lAAUAAZAhkCcQFxAY4BjgHVANUA0vzS/GT9ZP22ALYAtgC2ADgAOACcApwCMwAzAFL/Uv8K/gr+U/9T/yQAJAC2/7b/0v/S/4X/hf8jASMB5ADkAEIAQgC1/rX+CwALAMP/w//w/fD9WgFaAdIC0gLZ/tn+FAEUAesB6wEoACgA5fzl/LX/tf9g/2D/iv+K/zwBPAHmAeYBSv9K//wA/ADy//L/s/6z/tj+2P4R/xH/1v/W/0cBRwHaAdoBYgBiAF//X/9aAFoAl/+X/37/fv/eAN4AIAAgAPH/8f8z/jP+NQE1AaIAogBtAG0AxgDGAEECQQJBAEEA2fzZ/E//T//Z/9n/qv6q/iIDIgORApECqf+p/0//UP+7ALsA6P3o/QP9A/2SAJIA5ADkALMBswFoAGgAhQGFAW7/bv+X/pf+pf+l/5r+mv6C/oL+swGzAXkCeQJ6AXoB8P/w/3H/cf9h/mH+Cf8J/y4ALgCg/6D/wwDDAMcBxwHc/9z/YP5g/ikBKQGh/qH+Df8N/98A3wD9AP0Aof6h/mYAZgBOAE4Ahf6F/m7/bv8sAiwCxgDGAIT+hP7e/97/IwAjAJL+kv73//f/3wHfAfkA+QCF/4X/DQANABkAGQCK/or+TQBNAM//z/9y/nL+gP+A/1IBUgHBAcEBCwILAhP/E/8F/wX/Yv5i/gUABQCIAIgAVABUAJQAlABLAEsAQABAAD7/Pv+4/7j/YAFgAdn/2f8+/j7+aP5o/rP/s/8OAQ4BPgI+AnICcgJc/1z/L/4v/uz87Pyo/6j/F/8X/1ACUALiAeIBhgGGAZP/k/+R/pH+Sf5J/qj/qP9xAHEAnwCfAGwBbAHjAOMAjgCOAET+RP4RABEAqgCqALz/vP9VAFUAugC6ABr+Gv6T/ZP9GQEZASECIQLJ/8n/LwEvAaIBogHo/ej9gP+A/zkBOQEU/xT/Av4C/pIAkgBhAWEBbP9s/7gAuABLAksCmQCZAAv/C//x//H/l/6X/pn/mf+QAJAArwCuAP7+/v73//f/OgA6ABgAGAAaABoAGgAaADL/Mv8rACsA8QDxAFMAUwCY/5j/sgGyAWH/Yf+u/67/OAA4AAQABACf/5//mQCZABoAGgCZ/5n/fgB+AOn/6f8b/xv/3wDfABT/FP8T/xP/1//X//X/9f9d/13/ZQFlAWACYAJI/kj+9P70/pYAlgBaAFoASf9J/1YBVgF1AHUAg/+D/xEAEQBfAF8AYgBiALn/uf8H/wf/ZwBnAJ7/nv9f/1//DQANAIYAhgBl/2X/ef95/48AjwAZABkAeP94/5kAmQATARMBn/2f/YH+gf5KAkoC1QDVAF7/Xv8sASwB8gDyAE/8T/wu/y7/9//3/4QAhABN/03/xwLHAqUApQBz/nP+LP8s/zEBMQHD/8P/Af8B/3j/eP++/77/3/7f/kwATAA/AT8BNgI2AuP/4/8D/gP+WP9Y/zL/M/+0/rT+Zf5l/hACEALp/+n/kf+R/6wCrAJUAVQB9f31/av+q/41ADUA0/7T/uz97P0CAQIBgQCBAD4APgDk/+T/TwFPAd7+3v5j/mP+4f/h/5wAnACQAZABNQE1AeL+4v6c/5z/+P/4/8D9wP3t/u3+lgKWAvr/+v+C/oL+wgDCADYANgDi/OL87f/t/6QBpAHn/+f/cwBzAGABYAFV/lX+k/6T/r4AvgDQANAAqP+o/wAAAADR/9H/Wv9a/3MBcwHvAO8AlP+U/z3/Pf8hACEAGgAaAAoACgAFAgUCaQFpAdr+2v6F/oX+3//f//b+9v7B/8H/kQKRAo4BjgHv/u/+5//n/5P/k/8//T/97ADsAFwCXALm/ub+zP/M/zsBOwF6/Xr9If8h/ykCKQJv/2//eAB4AN8B3wEW/xb/2v/a/0sBSwEW/hb+l/6X/vAC8AIUABQAMgEyATECMQJ5/nn+8/zz/HYCdgKh/6H/Iv8i//IC8gKWAJYAzP/M/2oAagAoACgAyv7K/pAAkACzAbMBmf+Z/4UBhQEqAioC1f7V/sD9wP0oACgA8f/x/9z/3P+EAYQB8P/w/9T+1P5ZAFkAQgBCAAf+B/6+AL4AGQAZAL/9v/1EAEQAjwGPAS4ALgDeAN4AE/8T/9T+1P6j/6P/7//v/+z/7P92AXYBOAA4ACv/K/9cAVwBY/5j/gH/Af8+AD4ALv4u/pwAnADtA+0Dr/+v/2z/bP/NAM0AEv4S/qH9of2lAaUBPAE8Aen/6f/qAeoBiwCLAEH+Qf45/zn/OQA5APr9+v1Q/1D/LgEuAY4AjgBRAFEAdQF1AfX+9f7B/MH8I/8j/5UAlQA4AjgCUQJRApkAmQCgAKAAiP6I/vb69vrl/+X/1ADUAIUAhQArAysDcgJyAsD8wPy2/rb+ZQJlAgz9DP1f/1//3wLeAqj+qP6T/5P/gAKAAr7+vv6G/ob+QQFBAbf/t/9d/13/dAF0AZ7/nv95/3n/XP9c/yAAIAC0/bT9AAEAAboCugIF/wX/Wv9a/9wB3AHz/vP+9P70/iIAIgCj/6P/y//L/0MCQwIi/yL/c/9z/+UA5QAi/yL/CQAJAJH+kf5D/0P/OgI6ApABkAG0/rT+YP5g/l7/Xv+F/4X/WP9Y/4IAggB8AHwAogCiAEgBSAGFAIUAP/8//7f/t/93AHcAwf/B/ywBLAEZARkBKv8q/5j/mP9vAG8AOgA6AH//f/+wALAA8f7x/lP/U/+i/6L/cP9w//EA8QAKAwoD5gDmAHH/cf9EAEQA6v7q/hj+GP4UARQBAAAAAL3/vf8+Aj4CVQBVAOf+5/7dAN0AWgBaANb91v35//n/wgDCAA3/Df/1AfUB7P/s/1X+Vf4L/wv/VQJVAr/+v/5Y/lj+/gD+AGcBZwET/xP/YABgAG8BbwF9/H38jwCPAFUBVQGo/6j/SABIAFYBVgHQ/tD+yP/I/14AXgAU/xT/7P/s/24AbgDE/8T/BwAHAAwADABf/1//WgBaAOf+5/5lAGUA7wDvALAAsADfAN8ABwAHAIP+g/7X/9f/nv+e/7P/s/8PAQ8BdAF0AXb/dv8T/hP+DQANAOf/5/9//3//tAG0Ab4AvgDs/ez93wDfAIf/h//B/cH97//v/0wCTAIh/yH/hgGGAT8BPwFn/mf+gP2A/Zb/lv9hAGEAVwBXAPIB8gEeAR4BRv9G/+z+7P5M/0z/sP6w/kD/QP92AHYAOgA6ALgAuADn/+f/wADAADz/PP91/nX+ov+i/63/rf+aAJoA0QHRAfUB9QF0/3T/PgA+AFn/Wf+v/q/+OQA5ANcA1wAnACcA+//7/zkBOQHv/+//wP7A/usA6wCS/pL+Pf09/VMBUwGgAaABRQBFAFUCVQLz//P/Yf1h/UwATADg/+D/g/2D/eYA5gBBAkECpP+k/7P/s//0//T//P/8/7gAuADw//D/SwBLADr/Ov87/zv/GAEYAT4APgCo/6j/4wDjAEkASQDe/t7+wwDDAKL/ov9J/kn+fwF/AU0BTQGu/67/awBrANoA2gDy/fL9nf+d/0gBSAGDAIMAEP8Q/58BnwGG/4b/zf3N/YIAggCIAIgA9f71/tUB1QEqAioC/v7+/hYAFgDIAMgAdP50/iP+I/7iAOIA5//n/6UApQDcAdwB5wHnATL/Mv/J/8n/6/7r/sn+yf7a/dr9/P/8/zgCOAJZAVkBqAGoAYkCiQK//7//A/sD+yr+Kv6A/4D/yv7K/lUCVQKxA7EDEAAQAEz+TP7N/83/mP6Y/rn+uf5PAU8B2gDaAHAAcAAvAC8A8wDzAHX+df4j/yP/QwJDAhb/Fv+2/rb+lgCWAL4AvgCJ/on+VQFVAfsA+wCU/pT+rP6s/ngAeACS/5L/vf+9/7P/s//9//3/NgA2APr/+v/yAPIAEAAQACz/LP/d/93/8//z/0b/Rv/aANoATv9O/17/Xv/nAOcAoQChAHD/cP8bARsBo/2j/Sb+Jv5yAHIAg/+D/7YBtgHJAskCBAEEAXX9df0JAAkAWf9Z/+n96f2E/4T/AQIBAnQAdAATARMBegF6AcP9w/0W/xb/4/7j/jr/Ov/k/uT+OQE5AeAA4AAHAQcBKgAqAMX/xf8aABoAjf6N/kz+TP4sASwB6P/o/6v/q/+aApoCRQBFAGT+ZP7yAPIAdf91//f99/16AXoBGAEYAfr9+v3QAdABOgE6Ab3+vf4oASgBMgAyAAf/B/9oAGgA9v72/u3/7f8MAQwB2P7Y/lAAUACuAK4Asv2y/Wn/af+RAZEBFP8U/wgBCAGtAa0Bwv7C/vz+/P7FAMUAP/4//lf/V/8HAQcBTgBOAOIA4gCQAZAB4//j/x0AHQBd/13/k/+T/6n/qf+GAIYAoQChAFABUAHf/9//hv+G/wMBAwEK/wr/agBqAK8ArwDU/tT+If8h/7UBtQHo/+j/pgCmAKIBogHg/uD+1/7X/ksASwAzADMAMgAyAOkB6QHD/sP+NP40/hwAHAAUABQASQBJAA4ADgBHAEcAVAFUAfwA/ADw//D/if+J/6H+of60/bT9HgEeAeYA5gCnAKcAJgEmAXwAfADX/tf+bv9u/2QAZAAlACUAdQF1AaEAoQDY/9j/pP+k/07/Tv82ADYAwQHBAUv/S//h/uH+x//H/6cApwCDAIMAOgE6Ad3+3f67/rv+jgCOAMr+yv7/////wwHDAdH/0f8d/x3/EQERAbr+uv7q/ur+WABYAHv/e//3//f/vwG/AZwBnAGu/q7+ff59/q7/rv8r/yv/yv/K/9kA2QCPAI8AAgACAD8APwDe/97/Qf9B/7n/uf/h/+H/av9q/7v/u//t/+3/WQBZAKwBrAHd/93/Jv8m/8b/xv9i/mP+uv66/icCJwLDAMMASwBLAAMBAwGH/of+e/17/XX/df/c/9z/hQCFAIEAgQByAXIBygDKAAv/C//i/uL+7v/u/xP/E/8YABgA9wH3AbP/s//s/+z/ugG6Af/+//66/rr+mwGbARUAFQA+/j7+ugC6ABIBEgF9/33/bAFsATABMAEA/gD+xf7F/pwAnACW/pb+AgECASMCIwIpACkAPgA+ADsAOwCS/ZL9BQAFAF4AXgA0ADQA/gL+AmYAZgDS/dL96//r/43+jf4V/hX+cwFzAa8BrwE5/zn/8gHyAcEAwQDC/cL9WQBZAPr/+v9E/kT++wD7AD8APwBz/nP+NgE2AVgBWAEo/yj/fAB7AMgByAE8/jz+O/87/2X/Zf89/j3++QD5AMcBxwGI/4j/rQCtANf/1/9L/kv+X/9f/4EAgQAc/xz/YgBiAMQAxAAUABQA0v/S/0wATACH/4f/Jf8l/ygAKAD2//b/rgCuAEYBRgF5/3n/jP6M/s7/zv8aABoAAgICAh4BHgHn/uf+Af4B/s3+zf4YABgAPQA9AJcAlwCrAasBmf+Z/+3/7f/KAMoALv4u/oH/gf9OAE4ADv8O/0QARAD+Av4CUv9S/zIAMgBhAmECaf5p/iT/JP81ADUA2P7Y/skAyQDvAe8B1f/V/wYBBgFJAUkBpP2k/Wr+av5fAV8Biv6K/lgAWACUAZQBBwAHAPz//P+AAYABTABMALb+tv55/3n/MQAxAH3+ff6PAI8AiwGLAToAOgDJAMkAL/8v/2D9YP34APgA6QDpABT+FP7tAe0BqwCrACX/Jf/l/+X/EwETAQP+A/7d/93/sQGxAY/+j/5l/2X/UwFTAWIAYgB0/nT+cgByALn/uf/n/uf+if+J/1QBVAH4//j/2v7a/h0CHQLx//H/ff59/i8ALwBDAEMAbP5s/g0ADQDzAfMBiv+K/4//j/8yADIAcv9y/7f+t/7kAOQAHQAdAKX/pf+RAJEAaQBpAKX/pf9O/07/LAAsAGr/av82ADYA4QDhAPb/9v9qAGoA3QDdACj/KP/v/+//KAAoADj+OP76APoAJwInAjT/NP8EAAQAPAA8ADf+N/6tAK0A0gHSAbv+u/7MAMwAFAEUAbD+sP53/3f/GwEbAWf/Z//w//D/HAAcABcAFwDBAMEAyf/J/38AfwB2/3b/hv+G/08ATwCmAKYALf8t/2YAZgAM/wz/Sf9J/5H/kf8AAQABPAA8AJABkAGWAJYA4P3g/av+q/5nAGcA8//z/3EAcQDPAc8BAwADAK//r/9d/13/l/+X/0//T//ZANkA7ADsAM8AzwBL/0v/MAAwAIz/jP/C/8L//v/+/30AfQD1//X/DQENAfn/+f8qACoAMwAzAFYAVgDn/uf+1/7X/goACgBz/3P/FQAVAKYBpgHWANYApv6m/igAKADvAO8ACP4I/lcBVwGYApgC5f3l/dL/0v9NAk0CK/4r/q/+r/4vADAAxP7E/rX/tf9ZAlkCMwEzAXX/df+5/7n/wf/B/3z+fP7s/+z/BAEEAY3/jf+RAJEAV/9X/wIAAgAVABUA0P/Q/3z+fP4KAQoBFAAUABEAEQBJAEkAUv5S/i7+Lv6IAIgAKQApAKj/qP/jAeMBDgAOAH/+f/5BAEEAvv6+/tf+1/5yAXIBHAEcAb//v/8mASYBQgBCALD+sP4fAB8A8//z/8n+yf5bAFsAjgGOAeX/5f8/AT8B7wDvAB/9H/05/zn/SgBKACwALADcAdwBvgK+Asr+yv4S/xL/IQAhAGz8bPwa/xr/GAIYArMAswA/AT8BqQKpAvv++/77/fv9fP58/rH+sf7p/un+OwI7AkABQAF4AHgASgFKAX3/ff8G/gb+nP6c/oMAgwB8AHwAzADMAKQApAAHAQcB2v/a/+T/5P9bAFsAD/8P/xUAFQDv/+//mP+Y/ywALADKAMoABgEGAf0B/QEEAAQAlP+U/8v+y/4E/QT94f/h/8kByAH5//n/6QHpAU4CTgLH/cf9T/9P/y8ALwD5/vn+Qf9B/4oAigBNAE0A9P/0/wwBDAEdAB0Avv++/yr/Kv/6APoAmgCaAC3+Lf6lAKUA9wD3ADH+Mf5AAEAAqwGrASAAIAAjACMA4v/i/2b+Zv5n/2f/PgE+AXEAcQAD/wP/Kv8q/7AAsADRANEAgP+A/0YARgBu/27/3P3c/WgAaABgAGAAawBrAFIAUgBTAVMBAAAAAJ4AngBZ/1n/J/4n/gz/DP/L/sv+YQBhAEoCSgLj/+P/bQBtAD0BPQGa/pr+aP5o/sT/xP9H/kf+BwAHAFQDVAOmAKYA0v/S/y8BLwEA/gD++/37/YsAiwDP/8//k/+T/94B3gFBAUEBLP8s/yL/Iv9//3//o/+j/yUAJQD5APkA8v/y/0L/Qv/M/8z/JgAmAO3/7f8dAR0B4//j/5L/kv80/zT/uv+6/6MAowAHAAcAy//L/wgACABz/3P/t/+3/6UApQCmAKYAqP6o/v4A/gAp/yn/O/47/m0AbQADAQMBMAAwAAn/Cf+fAJ8AfAB8AEQARACqAKoA8P/w/zj+OP5L/0v/VAFUAXv/e//U/9T/hwKHAnf/d//G/sb+4wDjADr/Ov9w/nD+LQAtAJEAkQBSAFIAtwC3AAEBAQF3/3f/+f75/h0AHQAPAA8A2P/Y/83/zf8lACUAi/+L/xQBFAG5ALkAWP9Y/5EAkQD8//z/av5q/s/+z/6oAKgARgFGAfsA+wBBAEEAyADIAFP/U/8S/xL/NQA1AKv/q/8Z/xn/xQDFAFABUAHQ/9D/qgCqAGoBagEv/y//jf+N/2cBZwFS/1L/9v72/i8ALwDvAO8Adv92/+EB4QHzAfMBbP5s/s3+zf7cANwAGv4a/hr/Gv9QA1ADRgFGAfL+8v58AXwB3P/c/039Tf3DAMMAhwCHAJH+kf6pAKkAvwG/ART/FP89AD0AZQFlAZj+mP7//v/+BAAEAFn/Wf+iAKIAKQIpAvr/+v/3//f/dP90/6z9rP2A/4D/TgFOAQQABACVAZUBvgG+AZD+kP5a/1r/5P/k/xL+Ev5ZAFkALwAvAEUARQBTAVMBQQBBAB3/Hf8a/xr//P/8//T+9P6yALIAbQBtAF8BXwFNAE0Au/+7/x0AHQAx/jH+yP3I/dz/3P+tAK0AlACUAAYBBgE5ATkBd/93/3z/fP8j/iP+Tv5O/hP/E/9iAWIB/gD+AKgBqAHWANYA8P/w/4r/iv8H/gf+W/5b/q//r/8iACIArf+t/+EC4QLRANEAAgACALX/tf/n/ef9Z/5n/nIAcgAXABcA/AD8AKMCowKY/5j/0P/Q/zv/O/81/jX+GP8Y/yAAIACkAKQA+wH7AbYAtgA5ADkASQBJAP3+/f70/fT9awBrAN7/3v/l/+X/1wHXAdsA2wDE/8T/DwAPAMz/zP+s/qz+lv+W/0kASQC7/7v/LQAtAGUBZQFGAEYAp/+n/w8ADwAO/w7/S/9L/5//n/+5/7n/igGKARkBGQEaABoARP9E/3T/dP/l/eX9bABsAGL/Yv+sAKwAMgIyAigAKADu/u7+6//r/xr/Gv8k/yT/8gDyANQA1ABc/1z/UQFRAcD/wP/N/s3+gP+A/34AfgD9//3/ZABkAHsAewDL/8v/kQCRALb/tv/PAM8AFwAXAFb/Vv96/3r/XQBdAA3/Df+5ALkAxADEAMT/xP9SAVIBPQA9ACT/JP/7//v/OAA4ALT/tP8rACsADAAMABn/Gf/RANEAxf/F//n/+f9PAU8Bx//H/6L/ov/t/+3/K/8r/0P/Q/8xATEBEAAQAFUAVQBPAU8BXP9c/7f+t/6n/6f/2/7b/mUAZQDCAcIB3QDdABQBFAE7ATsBy/7L/rH+sf7I/8j/w//D/0MBQwEiASIB/f/9/77/vv+l/6X/nP+c/70AvQBx/3H/2ADYAGb/Zv98/3z/twC3AG4AbgCp/6n/KgEqAWv/a/9x/3H/uAC4AP/+//6l/qX+vAC8AAgACABPAE8AuAG4Ab0AvQAx/zH/V/5X/vP+8/5P/0//D/8P/7kAuQDBAcEB6//r/+wA7AAaARoBA/4D/r39vf2H/4f/Mv8y/+gA6ACqAaoBtQG1Afn/+f9e/17/dP50/jj+OP7T/tP+dQB1AEgBSAHRANEA/f/9//4A/gA8/zz/Bf4F/mP/Y/+R/5H/N/83/xIBEgHkAOQAdv92/4YAhgC3/7f/m/6b/kb/Rv+x/7H/w/7D/n8AfwCdAJ0AAQABAHcAdwBgAGAAhQCFAPf+9/6+/r7+if+J/wYABgB/AH8APgE+AbgAuADb/9v/Uf9R/7P+s/6h/6H/DAAMAEQARADJAMkASQBJAEUARQDA/8D/awBrAJX/lf9l/2X/gwCDAPH/8f9sAGwAeQF5AWP/Y/89AD0AHAAcAC3/Lf/S/9L/NQE1Ac3/zf/k/+T/nQCdADj/OP/T/9P/9//3/2//b/8WABYAZAFkAZf/l//Q/9D/6v/q/3EAcQAlACUAGwEbAVb/Vv/w//D/cwBzAML/wv87ADsAhgCGAPH/8f+Y/5j/BwEHAcj/yP+w/7D/cAFwASn/Kf/N/83/3gDeAFsAWwCE/4T/zwDPANn/2f+r/qv+hQCFALgAuADG/8b/AQEBAQMBAwG+/r7++//7/wQBBAFe/17/bwBvAGkAaQA2/zb/WQBZAHUAdQAH/wf/FQAVAN0A3QAuAC4ApACkANT/1P94/3j/WP9Y/5D/kP/C/8L/yADIAH8AfwC3ALcAKQApAN3/3f/x//H/JP8k/43/jf9kAGQA0ADQADUANQBAAEAAhv+G/24AbgBXAFcAG/4b/jYANgDkAOQAIP8g/2QBZAHrAOsAZ/5n/tL/0v91AHUA3/7f/tv/2/8YARgBDf8N/yEAIQAhASEB9v72/q//r/9UAVQB5v7m/nH/cf+YAJgADf8N/woACgAfAR8BLP4s/ob/hv8lASUBwP/A/w4BDgG/Ab8BHv4f/v7+//4FAAUAKP8o/xIAEgAsAiwCoACgAPv/+/83ADcAfv5+/hX/Ff/o/+j/m/+b/3wAfACSAZIBy//L/0cARwBSAFIAhf6F/hz/HP/XANcAPv8+/5cAlwBUAVQBqf6p/ogAiAAjACMALv4u/p8AnwC7ALsAJv8m/wcBBwHd/93/5v7m/g8BDwFnAGcAcv5y/hYAFgC0ALQAkf+R/7AAsADE/8T/Cv8K/1YAVgCy/7L//////8IAwgDlAOUAUgBSALf/t/8F/wX/4P7g/gIAAgAcABwApgCmAEwATACHAIcA0P/Q//7+/v41/zX/z//P/7L/sv8MAAwASQBJACYBJgHYANgAef95/wUABQDn/uf+Fv4W/gkACQBwAHAAy//L/wEBAQG6ALoAVP9U/1YAVgCl/6X/Vf9V/2YAZgANAA0A3f/d/+kA6QAWABYAigCKAJsAmwCO/o7+KP8o/0UARQDD/8P/lwCXAIYAhgBeAF4AGQAZAPT/9P9r/2v/mP+Y/z//P//5//n/bgBuAEMAQwAwATAB2wDbABz/HP+L/4v/9//3/zj/OP8HAAcA2QDZAI//j/+ZAJkAkwGTAUv/S/+L/4v/sv+y/zT/NP9Z/1n/qAGoAfUA9QBEAEQAswCzALL/sv9X/lf+MgAyADwAPACO/47/FAEUAekA6QAnACcAiwCLAK3/rf9m/mb+i/+L/zIAMgDsAOwAVQFVAUoASgDo/+j/t/+3/7z+vf6T/pP+FgEWAWsAawBrAGsAOwE7AT4APgD7/vv+AgACAMj/yP+k/qT+DAAMAM//z/8AAAAAPQE9AbEAsQAzADMAhf+F/1b/Vv8V/xX/g/+D/1kAWQCoAKgAmQCZACsAKwBVAFUASv9K/1D/UP9k/2T/9P/0/zMAMwD9AP0AtgC2AOX/5f+8/7z/4P/g/87/zv8KAAoAXQBdAKL/ov/q/+r/agBqAAMAAwDF/8X/VABUAIf/h/9h/2H/LAAsAHn/ef9zAHMAiACIAF7/Xv/i/+L/cABwACf+J/7C/8L/agFqAe/+7/66ALoA/AD8AGr+av7+/v7+jgCOACf/J/98AHwA8wHzAQT/BP8S/xL/rgCuAJj/mP83/zf/lQCVAHv/e/9S/1L/0gDSAM8AzwAsACwAVwBXAIkAiQAy/zL/Qv9C/48AjwAYABgAgP+A/8QBxAHIAMgA9/73/oAAgADQ/9D/QP9A/+QA5AByAHIADf8N/9UA1QDEAMQA6P7o/lwAXAA+AD4A2v/a/xABEAFOAE4Ac/9z/30AfQDg/+D/8P7w/rAAsADZ/9n/m/+b//wA/AC0ALQA4v/i/6MAowAd/x3/3P7c/oAAgACD/4P/WP9Y/y4BLgEsACwAwv/C/5EAkQB1/3X/XP9c/wkACQDz//P/kP+Q/87/zv84ADgANgA2AHsAewC0ALQA8//z/zX/Nf/i/+L/l/+X/6f/p/+uAK4AmACYACAAIACzALMAPP88//D+8P5VAFUAKwArAGABXwGJAIkAd/93/zL/Mv+w/7D/bP9s/1oAWgAPAQ8BvP+8/yIAIgBXAFcARP9F//X/9f8IAAgA5v7m/vb/9v+XAJcA4P/g/4UAhQAWABYARP5E/oMAgwCUAJQAhv+G/zkBOQEpACkANP80//b/9v9g/2D/6f7p/okBiQEQARABugC6ANQA1AAX/xf/N/44/rn+uf50/3T/ggGCAYIBggFiAWIB1wDXAAz/DP/o/ej9Qf9B/8b+xv6ZAJkAjAKMAlsAWwDm/+b/twC3AKT+pP62/rb+ygDKAEb+Rv4oACgA6wHrAe3/7f+8ALwAnACcAOP94/0YABgABwAHAJ7+nv4WARYBjwCPANL/0v+PAY8BCAAIAAH/Af+f/5//1f7V/m7/bv/7APsA8P/w/9wA3AD9AP0Aav9q/8X/xf+W/5b/pP6k/icAJwCCAIIAPgA+ANwA3AABAAEAe/97/yYAJgBD/0P/BP8E/8MAwwAfAB8AWgBaABoAGgAe/x7/OAA4AD0APQDt/+3/KgAqAO3/7f+d/53/UQBRAD0APQAvAC8AOAA4AHn/ef/Y/9j/xv/G/1IAUgDd/93/fgB+AAsACwCV/5X/2P/Y/yYAJgAR/xH/4P/g/4YAhgCT/5P/eAB4AKcApwDP/8//yP/I/7D/sP9h/2H/2v/a/6AAoAAPAQ8BlgCWAIP/g/+H/4f/1v7W/mn/af/YANgARgBGAOwA7AA7ATsB6//r/+v+6/5L/0v/xf7F/u3/7f+RAJEAuwC7AEUARQCbAJsA3v/e/4D/gP9X/1f/+P/4/0L/Qv8UABQA1gDWAE4ATgB7AHsAswCzADD/MP8M/wz/kv+S/5r/mv8FAQUBegF6AdUA1QA4ADgAV/9X/2/+b/59/33/UQBRAKkAqQDjAeMBvgC+ADD/MP+M/4z/Av8C/8H+wf7BAMEA7wDvADsAOwCzAbMBJAAkAA7/Dv9v/2//g/6D/i//L//SAdIBrwCvANUA1QBVAFUAq/6r/jL/Mv9w/3D/Iv8i/zcBNwEaARoBBAAEAAQBBAEF/wX/sP6w/tL/0v9a/1r/UABQAHgBeAGy/7L/SABIAPcA9wDh/uH+Yv9i/8j/yP8b/xv/XQBdAN8B3wFCAEIA6f/p/4cAhwD6/vr+kf+R/4YAhgB1/3X/q/+r/z4BPgFdAF0AAwADAIQAhABL/0v/HP8c/4L/gv8cABwA9AD0AAoBCgEhACEAgv+C/4T/hP9q/2r/h/+H/7//v/8QABAAMgAyAC8ALwAzADMAmv+a/ygAKACg/6D/5P7k/qL/ov9+AH4AFQAVAIEAgQCCAIIAYv9i/3b/dv/H/8f/XP9c/0wATAB5AHkAwf/B/z4APgCMAIwAo/+j/y0ALQDa/9r/6P7o/ikAKQDc/9z/0//T/4wBjAEeAB4ACQAJAGkAaQAu/y7/j/+P/+YA5gDF/8X/BQAFADgBNwFU/1T/IwAjAH4AfgA+/z7/b/9v/3QAdAAGAAYAFgAWAPz//P8B/wH/nv+e/+EA4QDn/+f/WgBaAJkAmQCX/5f/sP+w//v/+/8I/wj/IgAiAO8A7wCy/7L/DwEPAVEAUQBO/07/dP90/zH/Mf/b/9v/nACcAD0BPQFqAGoAnACcAPD/8P/O/s7+V/9X/+v/6/8BAAEABQEFAdkA2QAgACAA1f/V/+H+4f4F/wX/kf+R/6j/qP/2APYABwEHAZX/lf+IAIgABgAGACz+LP5PAE8APQA9AAv/C//AAMAArQCtAOT/5P/AAMAA9v/2/+/+7/54/3j/CQAJAHgAeACMAIwA7gDuAL4AvgDB/8H/a/9r//f+9/7y/vL+VwBXAPQA9AA2ATYBhACEAI3/jf9c/1z/Rf9F/xQAFAD3//f/Xf9d/8YAxgBrAGsAO/87/xYAFgAQABAAKP8o/7cAtwDtAO0ARv9G/z4APgDb/9v/A/8D/9v/2//PAM8AoQChAEwATABIAEgAYf9h/w3/Df/p/+n/NAA0AGcAZwAiASIB3ADcAIn/if8//z//m/+b/z7/Pv8RABEAwQDBAB0AHQCmAKYA7wDvAOf/5/9O/07/u/+7/0r/Sv/G/8b/9AD0AEIAQgCvAK8AQgBCAHz/fP/U/9T/SP9I/7r/uv9sAGwA5P/k/34AfgCFAIUAyP/H/xQAFAAeAB4Awf7B/tL/0v8XABcAMAAwAOEA4QCaAJoAiv+K//L/8v9N/03/TP9M//7//v8GAAYAkQCRADsBOwEIAAgADv8O/5L/kv/h/uH++//7/54AngDKAMoANAE0AVwAXACh/qH+rf+t/2D/YP9c/1z/6wDrAK8ArwCSAJIAtQC1AE3/Tf+M/4z/qP+o/8X+xf7d/93/cQBxAEYARgBSAVIBYQBhADYANgBRAFEAP/8//43+jf7F/8X/eP94//P/8/+fAZ8BzQDNAIkAiQD1//X/Yf9h/2P+Y/6W/5b/4//j/5IAkgD8APwApgCmAEkASQDx//H/e/97/yX/Jf+o/6j/yP/I/2sAawCzALMAiACIADkAOQC7/7v/ev96/5X/lf/J/8n/CgAKAGcAZwApACkABAAEAHUAdQA6ADoAl/+X/2r/av95/3n/hv+G/wUABQCrAKsA9v/2/xEAEQBJAEkAiP+I/4L/gv8RABEAlf+V/7T/tP9TAFMABgAGAD8APwB/AH8Akf+R/3z/fP8HAAcAqP+o/zEAMQD3APcABwAHAK//r/9BAEEAZv9m/3j/eP9OAE4ACAAIAGoAagDjAOMA5P/k/+D/4P/f/9//w//D/wUABQA7ADsAy//L/9T/1P+FAIUAo/+j/4n/if++AL4AxP/E/8H/wf/0//T/e/97/xgAGADTANMADgAOAAYABgB/AH8Abf9t/4L/gv9pAGkALf8t/0oASgDaANoAawBrALsAuwDD/8P/0f7R/qn/qf+U/5T/sv+y/x8BHwEaABoASwBLANcA1wDv/u/+pv+m/1cAVwC1/rX+IQAhAO4A7gB8/3z/ygDKAPIA8gDc/tz+bP9s/9T/1P89/z3/ogCiAPgA+ACp/6n/tAC1AMQAxACf/5//Af8B//j/+P8j/yP/5v/m/x8BHwGQAJAAnACcAMcAxwAR/xH/0v7S/n7/fv+Q/5D/LwAvAHIBcgHqAOoAEAAQANX/1f/I/sj+HP8c/0f/R/8cABwA6wDrAMYAxgBUAFQA8P/w/5f+l/5l/2X/PwA/AJL/kv+LAIsAEwETASv/K/9U/1T/3ADcAGT/ZP9EAEQAlwCXAAb/Bv/E/8T/fgB+ALL/sv9rAGsAxADEAHr/ev8RABEANwA3AHH/cf9RAFEADgAOAIf/h/+UAJQA8f/x/04ATgDTANMAZv9m/7T/tP+BAIEAR/9H/xYAFgDqAOoA0//T/4cAhwBpAGkAWv9a/wsACwBIAEgAbv9u/6cApwBqAGoAjP+M/xMBEwEMAAwAAwADAFwAXAC8/7z/eP94/zgAOACY/5j/5f/l/3UAdQB2AHYAnwCfAFIAUgBm/2b/fv9+/0n/Sf9Q/1D/2ADYAC4ALgCzALMA7QDtALn/uf/B/8H/c/9z//P+8/6u/67/rwCvAPr/+v95AHkABAEEAez/7P/L/8v/gf+B/7L/sv/y//L/ggCCAGoAagCYAJgAw//D//T/9P9g/2D/+f75/jsAOwB5AHkAJAAkAA0BDQFKAEoAyP/I/8P/w//X/tf+Jv8m/wkACQCFAIUAzQDNAAUBBQHt/+3/Xf9d/1//X/9i/2L/Yf9h/+f/5/8wADAAnACcAN8A3wCIAIgAZv9m/0H/Qf9Z/1n/oP+g//X/9f9EAEQAcwBzAKUApQB7AHsAiP+I/2f/Z/+b/5v/B/8H/+j/6P/pAOkARQBFANIA0gCTAJMA9P70/hz/HP/M/8z/Gv8a/w0ADQBcAVwB4gDiAK0ArQAUABQAzf7N/uz+7P6Y/5j/AAAAAE4ATgC7ALsAawBrAA8ADwDJ/8j/r/+v/0v/S/+F/4X/DwAPAB8AHwAwADAAiQCJAI8AjwBmAGYA0P/Q/1f/V/85/zn/pf+l/wwADAB5AHkAEwETAVcAVwDy//L/pf+l/9T+1P5M/0z/kACQAGkAaQDZANkAjACMABT/FP+M/4z/1P/U/xj/GP+YAJgAzgDOAAwADAC3ALcAwP/A/zn/Of9kAGQA9P/0/9j/2P8BAAEA9//3/x4AHgA5ADkAdf91/6cApwACAAIAa/9r/yMAIwDk/+T/Zf9l/wsBCwE6ADoAhf+F/6wArAAP/w//Zf9l/xMBEwHD/8P//////woBCgEX/xf/LQAtAKsAqwAK/wr/PgA+AAoBCgFU/1T/gACAAPH/8f+4/rj+FwAXAMgAyABJAEkA1wDXAHUAdQAx/zH/A/8D/5P/k/9A/0D/PwA/AP8A/wCeAJ4ANQA1AP7//v8g/yD/2f/Z/53/nf9h/2H/vgC+AHYAdgBNAE0AEwETAXP/c/8A/wD/8v/y/1L/Uv9VAFUAzwDPAO7/7v8uAC4ANQA1AFj/WP8DAAMAvP+8/+P/4/9uAG4AgwCDADoAOgAtAC0A7f/t/3H/cf/c/9z/SQBJAN7/3v8FAAUAYwBjAMj/yP87ADsA0P/Q/73/vf/1//X/6f/p/wAAAADz//P/PwA/ABgAGADT/9P/iv+K/xwAHAA8ADwABQAFAGwAbAADAAMA+P/4/2QAZACT/5P/h/+H/3H/cf8aABoAvQC9AKMAowDAAMAAtv+2/y3/Lf9W/1b/ff99/38AfwCkAKQAwwDDAJ8AnwCh/6H/2f7Z/rf/t/92/3b/wf/B/2IBYgHp/+n/4//j/5UAlQAT/xP/e/97/ysAKwCl/6X/jQCNAJUAlQB8/3z/LAAsAB0AHQB//3//6v/q/+f/5/+x/7H/igCKAEoASgDS/9L/kgCSAB8AHwDU/9T/lf+V/5X/lf+z/7P/LgAuALcAtwBNAE0A7f/t/0MAQwDt/+3/7P/s/8v/y//3//f/wv/C/zoAOgAwADAAKAAoAB8AHwAgACAAz//P/7L/sv//////mv+a/1YAVgCj/6P/DwAPAGYAZgANAAwA2f/Z/8//z/+d/53/m/+b/1gAWAAZABkAzf/N/47/jv8gACAARQBFAAAAAABCAEIA6f/p/+T/5P9d/13/3//f/08ATwDIAMgAWgBaACUAJQD5//n/AP8A/3n/ef+8/7z/+v/6/xQBFAG6ALoAmf+Z/1sAWwCi/6L/9f71/gkACQDk/+T/r/+v/70AvQBLAEsAz//P/3gAeAAEAAQAO/87/4P/g//a/9r/i/+L/8wAzACnAKcABAAEALQAtADn/+f/Pv8+/zIAMgB4/3j/+v/6/2sBawHf/9//jv+O/xIAEgBC/0L/PgA+AL8AvwDI/8j/NwA3ANn/2f+R/5H/eAB4APb/9v/m/+b/9f/1/7P/s//4//j/gQCBADUANQA0ADQA/f/9/2j/aP/d/93/XABcABAAEABBAEEAJQAlAJf/l/8MAAwAr/+v/6b/pv+kAKQA+//7/8r/yv+BAIEAxv/G/9P/0/+zALMAev96/0T/RP9yAHIAT/9P/3IAcgAwATAB6P/o/0cARwA/AD8Alf6V/uL/4v8lACUApf+l/2QBZAGKAIoAov+i/6MAowAR/xH/nv6e/noAegDq/+r/gACAAE0BTQHb/9v/qf+p/4L/gv8C/wL/AAAAAE8ATwAIAAgALAEsAcf/x/+D/4P/2f/Z/5n/mf+d/53/ggCCAFYAVgBIAEgAKAAoAMf/x/99/33/Sf9J/+z/7P9EAEQAhgCGAHYAdgASABIAUP9Q/7X/tf+6/7r/DAAMAFQAVAA8ADwAMAAwAJj/mP/J/8n/h/+H/yYAJgB0AHQAQgBCACgAKABdAF0ATf9N/zz/PP9rAGsAqf+p/3wAfAAFAQUBhP+E/5H/kf9iAGIAAf8B/8j/yP+7ALsAof+h/y0ALQBPAE8Abv9u/+b/5v+y/7L/3//f/xMBEwEFAAUA7v/u/z0APQCu/q7+w//D/1kAWQDP/8//ugC6AK4ArgBk/2T/ZwBnAH//f/9U/1T/WQBZACkAKQCEAIQAnACcACP/I/+9/73/7f/t/93/3f9FAEUAlwCXAJr/mv9QAFAA4v/i/2n/af8NAA0AMAAwAEAAQACIAIgAqACoALj/uP/B/8H/nv+e/xP/E/9VAFUA3gDeAFoAWgB6AHoAbABsAGP/Y/92/3b/oP+g/z3/Pf9dAF0ArwCvAO4A7gBLAEsA9P/0/y//L/8x/zH/s/+z/xgAGAB1AHUA0wDTAIcAhwD8//z/FQAVAGf/Z/8z/zP/2//b/7H/sf9cAFwA0ADQAG8AbwD+//7/iP+I/1P/U/8HAAcAtP+0/14AXgBMAEwAwv/C/5kAmQBsAGwAFf8V//X/9f/8//z/f/9//2kAaQAnACcAFgAWAKMAowDR/9H/df91/9f/1/+t/63/9P/0/+UA5QBVAFUAVABUAA4ADgBm/2b/av9q/xgAGAAqACoAlQCVAJEAkQC1/7X/pP+k/4r/iv/K/8r/EAAQAIgAiAAPAA8A+f/5/xUAFQDe/97/iP+I/8z/zP8xADEASwBLAC8ALwBdAF0A4f/h/0H/Qf9p/2n/EAAQABEAEQCRAJEA2wDbAEwATAD0//T/tv+2/y//L/+4/7j/AAAAANz/3P/4APgAnQCdALL/sv+GAIYA5P7k/gv/C/8EAAQAbv9u/7oAugDuAO4A7//v/zkAOQARABEAov6i/i0ALQDw//D/Sf9J/+AA4ABpAGkA9//3/6oAqgDX/9f/B/8H/7//v/81ADUA3f/d/zoAOgCtAK0A6//r//7//v/a/9r/hP+E/8b/xv/f/9//XgBeADkAOQB3AHcAWgBaAOz/7P/F/8X/mf+Z/27/bv8MAAwAYgBiABAAEABxAHEASQBJAIX/hf+8/7z/o/+j/2P/Y/9GAEYANgA2AMr/yv9MAEwAMAAwAPf/9/8nACcA+P/4/8D/wP/T/9P/2v/a/6n/qf+eAJ4APgA+AEIAQgB8AHwAtv+2/2//b/8xADEA7f/t/63/rf+tAK0ADQANAGsAawCIAIgAZv9m/8D/wP+n/6f/nv+e/xoAGgBxAHEAEgASAKEAoQDl/+X/qv+q/ywALACp/6n/wP/A/yAAIADm/+b/EgASAC8ALwDp/+n/OwA7AEsASwCS/5L/BAAEANT/1P9W/1b/agBqAE0ATQASABIAwADAAAEAAQBh/2H/AwADAF//X/8XABcArgCuAAIAAgAKAAoAhQCFADT/NP87ADsAUgBSAGb/Zv9iAGIAHAAcAPP/8/+XAJcAZf9l/5f/l/93AHcABwAHAB0AHQCKAIoAm/+b/8f/x/+QAJAAvP+8/y8ALwBCAEIAc/9z/6P/o/8TABMAn/+f/2AAYACbAJsAcv9y/+v/6//X/9f/kP+Q/2gAaADO/87/m/+b/4sAiwAPAA8AFQAVALn/uf+V/5X/AwADABoAGgAuAC4ABAAEAEUARQAhACEAzf/N/+b/5v8lACUA+f/5/2kAaQBrAGsA1//X/zIAMgDl/+X/kf+R/zsAOwDG/8b/9f/1/3UAdQAHAAcA9P/0/xAAEAA0/zT/yf/J//n/+f8hACEA2QDZAE4ATgD0//P/p/+n/xf/F//X/9f//f/9/yUAJQDjAOMAaABoAKf/p/8dAB0AS/9L/1D/UP+0ALQA3//f/ygAKAB2AHYAq/+r//T/9P8/AD8Ajv+O/9T/1P9YAFgAwP/A/93/3f9vAG8Axv/G/wQABAAJAAkAAwADAPD/8P/I/8j/rP+s/3v/e/9QAFAA/f/9/yUAJQCbAJsAPAA8AJf/l//k/+T/h/+H/+j/6P8aABoAUQBRALAAsAAxADEAGwAbALj/uP+h/6H/jv+O/+P/4//1//X/ewB7AK8ArwAiACIAvf+9/0r/Sv+6/7r/uf+5/+f/5//DAMMARgBGAGkAaQB4AHgAev96/4//j/+l/6X/hv+G//H/8f+TAJMASwBLAJIAkgCHAIcAh/+H/2b/Zv+Y/5j/qP+o/zUANQCwALAAUwBTAEkASQDr/+v/2v/a/8f/x/8SABIA+v/6/8z/zP+3/7f/WwBbAFAAUABTAFMAZwBnAP3//f88/zz/l/+X/27/bv81ADUA0ADQAJIAkgBxAHEA2v/a/1n/Wf9T/1P/TP9M/7b/tv/CAMIAiQCJAI0AjQA9AD0AkP+Q/2n/af83/zf/e/97/3IAcgCcAJwAcgByAH4AfgD4//j/zf/N/97/3v+I/4j/hP+E/4z/jP9zAHMArQCtALIAsgByAHIA8P/w/2X/Zf/N/83/Xf9d/2X/Zf/ZANkA3gDeAOMA4wCoAKgAWP9Y/+P+4/5m/2b/Sf9J/2oAagA/AT8B4wDjAL8AvwCc/5z/5P7k/jf/N/9S/1L/GAAYAAsBCwFjAGMAsgCyAGQAZAD6/vr+l/+X/6z/rP9n/2f/igCKAKQApAA6ADoAYABgALH/sf8b/xv/pv+m/07/Tv86ADoAEQERAYUAhQBoAGgAEgASAAL/Av99/33/r/+v/6z/rP/IAMgA8gDyAKIAogCUAJQAPf89/8H+wf5u/27/6//r/5wAnAAHAQcBbgBuAB0AHQCv/6//M/8z/4n/if+8/7z/RgBGAJIAkgCqAKoAjgCOAIP/g/8u/y7/qv+q/5v/m/9UAFQAmQCZAB8AHwBcAFwAGQAZAFf/V/8JAAkAl/+X/+H/4f94AHgAjACMAOv/6/8oACgAsv+y/7L/sv/F/8X/JgAmAPf/9//7//v/FgAWAPr/+v+r/6v/AQABABIAEgDQ/9D/JgAmAPX/9f8NAA0A6v/q/7P/s//E/8T/EAAQAO//7/80ADQAIgAiAB8AHwCk/6T/IgAiAP3//f/Q/9D/MgAyAEsASwDn/+f/lACUACMAIwCX/5f/3//f/5j/mP+v/6//WABYADkAOQBRAFEAhQCFAPH/8f+z/7P/lf+V/5L/kv8YABgAMQAxAGsAawCgAKAAMgAyANf/1/+p/6n/VP9U//3//f9OAE4AUwBTAHsAewAGAAYAuf+5/6b/pv/P/8//6v/q/9H/0f9FAEUAOAA4AAMAAwBIAEgAkf+R/7D/sP/5//n/T/9Q/zUANQB3AHcAFwAXAGYAZgD6//r/o/+j/8T/xP+j/6P/xf/F/2AAYABjAGMAkgCSACgAKACX/5f/Y/9j/7P/s/8wADAAagBqAKoAqgBPAE8A0v/S/57/nv9t/23/1//X/z0APQCkAKQAUwBTAOn/6f+7/7v/dP90/wQABABCAEIA5f/l/zYANgAcABwAyf/J/0oASgASABIAe/97/yIAIgC//7//EQARAEgASAAPAA8ACgAKAP3//f/T/9P/6//r/9n/2f+Y/5j/IAAgAIIAggApACkAWwBbAPv/+/9v/2//2f/Z/+r/6v/S/9L/mQCZAFsAWwASABIARwBHAGn/af96/3r/KAAoAOr/6v89AD0AaQBpANj/2P8CAAIAvf+9/6v/q/8KAAoACQAJADcANwAyADIAMQAxABsAGwDU/9T/7//v/87/zv/6//r/kACQAFsAWwDe/97/LgAuAJL/kv/y//L/SgBJALz/vP8KAAoAQQBBAIv/i/+EAIQA7v/u/wkACQAvAC8Ab/9v//D/8P/z//P/4//j/6kAqQA5ADkAOgA6AP////8t/y3/9//3//X/9f9FAEUAyQDJAOr/6v/5//n/4v/i/3D/cP9YAFgA7f/t/wkACQBxAHEAn/+f/9H/0f8NAA0Aqv+q/ywALAAXABcAaf9p/xEAEQAUABQA/f/9/zYANgDI/8j/v/+//+v/6//M/8z/IAAgAEMAQwABAAEAEgASAMD/wP/x//H/7P/s/8f/x/8qACoAIQAhACoAKgBhAGEA4f/h//X/9f+u/67/o/+j/yoAKgAbABsAQABAAJoAmgDR/9H/FQAVANr/2v+P/4//OwA7AAYABgDT/9P/UwBTAIn/if8PAA8ANgA2AN3/3f8yADIArf+t/57/nv8HAAcA3//f/x0AHQAbABsA1v/W//3//f/j/+P/9v/2/8b/xv8oACgATABMANP/0//b/9v/2v/a/6X/pf82ADYAKAAoACQAJAA1ADUA6v/q/+T/5P++/77/yP/I/yoAKgAYABgAVgBWAFYAVgAUABQAGwAbALf/t/+N/43/2v/a/yUAJQBtAG0AgQCBABAAEAC9/73/8P/w/5D/kP+//7//cQBxABgAGACDAIMARgBGAJT/lP+q/6r/rv+u/7L/sv+DAIMAoQChAPH/8f9bAFsAif+J/zT/NP/Q/9D/sf+x/zAAMADhAOEA+P/4/zUANQDA/8D/Qv9C/8P/w//Y/9j/BwAHAJEAkQBMAEwASABIAOf/5/+U/5T/kP+Q/+n/6f9LAEsAcgByAHMAcwA4ADgArf+t/7X/tf/j/+P/wP/A/04ATgCTAJMAGQAZAAIAAgDH/8f/fv9+//z//P8CAAIAMwAzAEAAQABeAF4A9//3/9H/0f+d/53/uP+4/xAAEAA4ADgANQA1ADgAOADc/9z/1//X/+7/7v/K/8r/LwAvACwALAD0//T/7v/u/6P/o/8XABcAIQAhAAwADAAyADIAFwAXAPj/+P/e/97/vv++/yIAIgAuAC4AJAAkAEIAQgDN/83/6v/q/+z/7P/T/9P/eAB4ACoAKgDm/+b/PQA9ALL/sv/A/8D/QQBBANv/2/9pAGkAPgA+AMz/zP/8//z/0//T/+D/4P8dAB0ANAA0ABIAEgApACkAHQAdAMD/wP/C/8L/5v/m/wMAAwBoAGgAJQAlAAoACgD8//z/uP+4/8r/yv/a/9r/FAAUAB0AHQAwADAADQANAN7/3v/n/+f/0v/S/7//v/8JAAkABwAHABgAGABnAGcA/f/9/x8AHwDB/8H/j/+P/wwADAACAAIAVABUAFcAVwDt/+3/AwADAJT/lP/S/9L/AgACABIAEgBSAFIAAAAAAOf/5/8eAB4AnP+c/wIAAgAnACcA3v/e/zoAOgAMAAwAqv+q/+7/7v/f/9//AgACABgAGAAWABYABgAGAPj/+P8QABAA0//T/x4AHgD6//r/1f/V/zMAMwAEAAQA9v/2/zIAMgADAAMA6v/q/x0AHQDr/+v/0v/S/xMAEwAWABYAIwAjAD8APwD2//b/3v/e//j/+P/Z/9n/8v/y/wgACAARABEADwAPACkAKQD5//n/0//T/9P/0//b/9v/3v/e/x0AHgASABIACAAIABAAEADo/+j/3//f/xIAEgDG/8b/FQAVADUANQDk/+T/DwAPAOD/4P/d/93/KwArAOL/4v/y//L/KQApAAkACQAdAB0A3//f/7P/s//6//r/9v/2/y8ALwBGAEYAKgAqABkAGQDb/9v/s/+z//P/8//0//T/BAAEAFkAWQBOAE4AEQARAPv/+//C/8L/lv+W/wcABwAPAA8ANwA3AD0APQALAAsA+v/6/9b/1v+z/7P/AgACABUAFQA4ADgAJQAlABYAFgD5//n/uP+4/9//4P/8//z/CAAIADEAMQALAAsA4f/h/wcABwDf/9//9//3/zAAMAATABMACgAKAPT/9P+8/7z/BwAHACEAIQATABMAMgAyAAoACgDi/+L/5v/m/8j/yP8SABIAHQAdADEAMQAwADAA7P/s/+X/5f/N/83/4f/h/x0AHQD7//v/FQAVABUAFQAFAAUAEQARAM3/zf8IAAgA9f/1//X/9f8mACYA/v/+//v/+/8mACYA5v/m//P/8//+//7/6v/q/x0AHQAHAAcA7f/t//z//P8HAAcACQAJACMAIwDr/+v/yf/J//v/+//0//T/BQAFAB4AHgAdAB0AFQAVAPP/8//k/+T/z//P/9f/1/8gACAAIgAiACsAKwA8ADwA1v/W/73/vf/4//j/2P/Y//P/8/8oACgAAgACACoAKgAeAB4A1//X/+T/5P/Y/9j//P/8/xMAEwAaABoACQAJAAwADADx//H/8P/w//f/9/8VABUAEwATABsAGwAnACcA8f/x/+j/6P/q/+r/9//3/xUAFQAeAB4AMwAzABUAFQDs/+z/8P/w/9T/1P/E/8T/JwAnACUAJQApACkAKgAqANT/1P/X/9f/+f/5/93/3v8SABIAHgAeAAoACgAqACoAEgASAPz//P/h/+H/8//z//P/8/8BAAEAIgAiABYAFgAbABsAAgACANv/2/8BAAEA3//f//H/8f8FAAUAGAAYACsAKwD4//j/6v/q/+v/6//G/8b/BQAFABAAEAD/////IAAgAO//7//u/+7/9P/0/83/zf8LAAsA9//3/wMAAwAzADMA8//z/+P/4//6//r/0f/R//f/9/8HAAcA9//3/w8ADwAMAAwAAgACAP////8CAAIA7v/t/+P/4///////BgAGABoAGgAhACEABgAGAPr/+v/+//7/9P/0//f/9/8DAAMAEQARABwAHAAKAAoA9P/0//b/9v/2//b/7//v/wcABwAEAAQAAgACACMAIwDw//D/+P/4//n/+f/t/+3/FAAUAPz//P/3//f/GgAaAOr/6v/+//7/DgAOAOD/4P8GAAYAAAAAAPb/9v8EAAMADQANAAEAAQAFAAUA8//z/+v/6//8//z/HAAcAAYABgAHAAcAEQARAPL/8v/8//z/BAAEAAwADAAKAAoAFAAUABQAFADz//P/AAAAAA4ADgAMAAwAFgAWAPj/+P/3//f/CgAKAO7/7v8LAAsACgAKAPb/9v8fAB8ABAAEAPD/8P/x//H/0//T/w0ADQAQABAACAAIABoAGgD5//n/8f/x//f/9//t/+3/DQANABIAEgAHAAcABQAFAO7/7v/n/+f/AwADAAUABQAEAAQAEQARAAMAAwD+//7/+P/4/97/3v/5//n/AgACAPf/9/8JAAkABAAEABEAEQD1//X/7P/s//r/+v/x//H/EgASAAoACgD+//7/FwAXAOL/4v//////CAAIAPb/9v8gACAA/v/+/wUABQAHAAcA1P/U//P/8/8IAAgABAAEACIAIgD+//7/9P/0//P/8//b/9v/+f/5/wEAAQAJAAkAJQAlAAgACAACAAIA6//r/8v/y//w//D/+v/6/xQAFAAyADIAFwAXAPz//P/m/+b/yv/K//D/8P/+//7/CQAJADMAMwASABIA//////f/9//g/+D/8f/x//3//f8SABIAJQAlAAkACQAMAAwA9P/0//P/8/8EAAQA+P/4/xIAEgASABIA8//z/xQAFAD3//f/8v/y/woACgDx//H/AwADAAkACQD2//b/BwAHAAQABADo/+j/9P/0/wgACAAFAAUACQAJAAoACgDk/+T/AgACAPz//P/4//j/FQAVAAsACwD7//v/DQANAPX/9f/2//b//v/+//D/8P8IAAgACwALAAMAAwAJAAkACQAJAPf/9//8//z/+//7//T/9P8OAA4AFgAWABcAFwAEAAQA9f/1/+z/7P/o/+j/CQAJAA4ADgAZABkAIQAhAPr/+v/t/+3/9//3/+H/4f/3//f/DgAOAAkACQAZABkACAAIAPf/9//6//r/7//v/+v/6//+//7/AAAAAA4ADgATABMAAwADAPf/9//j/+P/5f/l//v/+/8QABAAFAAUABcAFwAHAAcA7//v/+r/6v/y//L/+f/5/xQAFAARABEACQAJABIAEgD2//b/8P/w//X/9f/0//T/CQAJABAAEAAJAAkACQAJAPf/9/8DAAMA+f/5//7//v8KAAoA+//7/w8ADwAQABAAAQABAAsACwABAAEA9//3/wIAAgD7//v/AwADAAEAAQAEAAQACAAIAP7//v8GAAYA+v/6//b/9v/8//z/9P/0/wUABQANAA0AAgACAAgACAD+//7/9v/2//X/9f/x//H//////wUABQAOAA4ACAAIAP3//f/8//z/8f/x//n/+f//////BQAFAAgACAAFAAUAAAAAAPz//P/2//b//////wIAAgADAAMABAAEAAYABgABAAEAAgACAAAAAAD/////BAAEAP3//f8EAAQABwAHAP7//v8AAAAA+P/4//b/9v8AAAAA9P/0/wIAAgAEAAQA+//7/wgACAD9//3/9P/0//v/+//t/+3/BQAFAAkACQABAAEABwAHAPX/9f/u/+7/AgACAPr/+v8IAAgABAAEAP7//v8IAAgA+P/4//v/+///////+v/6/wQABAAEAAQAAAAAAAkACQAAAAAAAwADAAsACwABAAEA/P/8/wAAAAD8//z/AQABAAgACAAEAAQABgAGAAUABQD7//v//P/8//z//P/+//7/AgACAPz//P8BAAEABAAEAAQABAD+//7//f/9//////8DAAMA//////r/+v//////CAAIAAIAAgACAAIAAAAAAP3//f/+//7//////wEAAQAHAAcAAgACAAEAAQAAAAAA/v/+/wEAAQAEAAQABwAHAAIAAgAEAAQA/v/+/wEAAQACAAIAAAAAAAIAAgAHAAcA/v/+/wcABwD/////+//7/wQABAD/////AgACAAYABgD/////AQABAP/////6//r/+P/4//7//v8BAAEABgAGAAYABgD/////+//7//n/+f/4//j/+//7/wIAAgD/////BAAEAAEAAQAAAAAAAgACAPr/+v/5//n/AAAAAPr/+v8AAAAABQAFAAAAAAAIAAgA+//7//L/8v/7//v/9v/2/wAAAAAJAAkA/////wUABQAAAAAA9v/2//r/+v/4//j/AwADAAgACAD/////BAAEAP7//v/9//3/AgACAPr/+v/9//3/AgACAAAAAAAKAAoAAwADAP//////////+P/4//3//f/+//7/BgAGAAkACQACAAIAAwADAPv/+//2//b//v/+//z//P8GAAYADgAOAAMAAwADAAMA+//7//b/9v8AAAAAAAAAAAMAAwAIAAgAAgACAAMAAwD/////+P/4//7//v/9//3/AwADAAYABgBJRDMgAJAAAElEMwMAAAACH3ZUQ09OAAAACAAAAENhcnRvb25BUElDAACKMAAAAGltYWdlL2pwZWcAAwD/2P/gABBKRklGAAEBAQBIAEgAAP/bAEMACAYGBwYFCAcHBwkJCAoMFA0MCwsMGRITDxQdGh8eHRocHCAkLicgIiwjHBwoNyksMDE0NDQfJzk9ODI8LjM0Mv/bAEMBCQkJDAsMGA0NGDIhHCEyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMv/AABEIAfQB9AMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APn+iiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKtWun3N5KkcSfM/3QTjd9B1P4ZoAq0V6Hofwo1fU1SSW1uljYZ3MnkKPxf5v/Ha7/TPgzpUADX/lsccqhaQ/mSB/47TUWyXJLc+fcUV9Xab8PPBsLKjaBaTNkDM6bs/lxTNU+EPga/ZiukPauf4rWdkx+ByP0qlBsTqRR8qUV73qP7PunyZOma7cwnstzCsg/NSP5VyuofAjxVbFjZy2F6o6COYox/BgP50nCSBVIvqeXUV0uo/D3xdpQJu/D9+FHVo4vMX81yK52WGSGQxyxtG46q4wR+BqbFJp7DKKKKBhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVZ0+0N/qVrZhwhnmSIMRnbuIGf1qtWn4d/5GbSv+vyH/wBDFAM970b4G+HNOIfUZrnUpl67m8qPI9FXn8ya77TdC0rR4vL03TrW0X/pjEFJ/HrW1Bb+fcOucAEkn8a0EsbdP4Nx/wBo5rduMTnSnPW5h7Cx4BY+3NOawuWQsIWwBnmt8vDBgEont0p4IIyOQal1H2KVJdzkIuLqP/eFaPeqLAC/AH/PSr1axMZbBS0UVRI5XZeh/Oq99p+n6pEY9QsILhf9tA3/AKEDU9LSaQ02cbefCfwRqZy+lxW5/wCmW6L/ANBOP0rndQ/Z20ScM+n6pfW5PQNsmUfop/WvUtozT1Z0OVOPoahwuaKbR8+al+z14gtwTY6nY3QHaVXiJ/Qj9a5DUvhX4z0zcZdEmmQfx2zrKD+CnP6V9Ua34kGgaLcajPH5wiACxqcM7E4VR9SaemLu2iubr9zO4B8uQA7CR90kcVDp+Rop36nxZd6dfWDbbyzuLdvSaJkP6iquK+6YobW+ttskSleVKH5lz9DkVg6l8NfCeqbjc6FYFm6ukPlt+aYqOVFcz7HxpRX0zqnwC8NTsWsze2g7CKcOB+Dgn9a4LxN8EJdCsJL2LWfMUcJDJaPvY+2zd+ZwKOR9B86PI6K6yL4b+KbiWeG207zp4FV5IVlUSBW+620kEg1z93pV/YXMlvdWc8UsbFWVkOQR1FJxa3Q00ynRRRSGFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVp+HP+Rm0r/r8h/8AQxWZWn4c/wCRm0r/AK/If/QxQgZ9uWH+vm/z3q3JI+/y4gC2MknoBVKyYJLOx6AEn86txlkWSZ1+9g7RyQK0nuZQ+GwQxoQ2SryZ+c9abbFUeWEH7rZUegNQ2MhMsgVcqTuJ9KsTKPtEDD72SPwx/wDqpNWdhxd0mjmn/wCP8f8AXSr1UX/4/wAf9dKvVujnlsFLSU6mIKO+KPwqm2qWqavHpTOwu5IGuFTacFFIBOemckcUAXMcYrD8Va1Po2lxmyjWW/u5lt7WNhkFz3I74GTW5kVyXjNhb6p4ZvnIEEGoNvc9ELRMqk/jx+NOO4zNvPCvi28S0N9rUN9GLqGaa0KhFUK4YkNjnGOnGa7m+t3urSWGOQxs4O1x1U+tLHdRMgYtg45GKjk1CFOAcntk4obbHY4ZtP17wPu1C01GbULcHzby3deXH8Tr15r0az1e3vLaG4jkR4pkWRHU9VIyDXP6nq9tDavLeTQxwgHILDnjp6k1X8CB/wDhCdPjMahVRjGr9PL3Hb+mKJJSV2NNo7UOHGVw1VzaKblpyCWPPJzj6VSCfxLDgjvHJira3LICDltgzz1IrFwtsaKfcgvrEPKs8SRicKU3kDJU9RmsSfwLozaettbwfZWSYXEc1u21ll/vf0PtxXUrIj8KQSPmA9qccHnZkeopJtFaM4S9+H9j4k1iG91e3he3txg2/wBmVfNf1Zhgke1UtR+CPgy9DNHp81ox72tww/8AHWyK9HyBxllpScY7kfqKG77it2PnTxZ8ELHSIY203Wbl5pJ4olt54Axw7hSxZewByeOgrH1L4EeLLIO9q+n3yLyPKn2MfwcD+dfR2m29vcWxuZwryySkkk/dIPA/StK5gjuraWF/uyKVJHXBoaj2HdnxBeaDqlhcNBcWUgkU7SEw4z9VyKoyRSQyFJEZHHVWGCPwNfZdz4I8Nrpi2aaVbxRL0MS7W+u4c5pNM0K0l0+TS9RWPVFtW8tJL2JJWZCMqGJHJA4z14ocI9GHM+x8ZUV9b6l8JPBmo5L6DBC3961kaHH4A4/SuR1L9n3RJdzWOp6haE9BKqzKP/QTU8jHzrqfO1Feuah8ANegybDVNPuwO0m6Fj+YI/WuU1H4WeM9MJMuhTyr2a2KzA/98kn9KnlY1JPqcdRVm7069sH2XlpPbP8A3ZomQ/qKrYpFBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWn4c/5GbSv+vyH/ANDFZlafhz/kZtK/6/If/QxQgZ9r2yFzcKvUjj86vC6UjiOQt3AXpVKzlSK4k3nAOefxq219AvQlvoK1mm3sYwaS3BPMXPlwBNxydzVIkbBjJIwLYxx0Aqq+pAfdj/M1Vm1KVlKjAB9KXLJj54ozH/4/x/10q93rPU5uoyeu6tGtkYy2CmzOY4mYdRT6huf+PdvXIpklG+1aWy064ultHuWhjLiKL7z47DPevP7jxp/xWGnaxc6Lf26w2s1s0W0FpNxUgrnHTbz9a9HKeWBuyY5F5rn9c0iebX9FuLdFaK2mdpSTg7GQjj15xVRaQzd0nW7XWNNivoUmiSTOEmTawwccj8Kk1G0stWsJrK6jSWGReVY4yc5HPUH3p8VrDBAFcqrHnOe9KLXd9yZW/D/CpGcVJ8PUQf6LrWqJbYyESbO0elIvw60w589r6Z+Mu82D/Ku1+ySKchUJ9QcGkEMijB3qAuDk8Y+tVzPuFjmLP4daDBKJprZ5grYKSylh+I7iuuVREgULgRfLgD+D/P8AKo8yQ481gcrg5/ip6TD5ehKjGQeoqW29xj/LG4ExR4z1HBpxbDlu6dfdTUaMqn7h3DIU549s/wAqPNQEMD23AEdu4/rSGPwY+nWP5h7qamSZlJU5YfeXBwcVw94uq+E72XUbS6l1LSHlaSa0kbdJCrHJMZPUD07Y/Gursb621Cyiu7OZZYHXzImX+JT1H1HpQ4gmaiPuxjePY4pxJyfUc/hVOMBWJQPwOMk4Nc9F41Q+KDpT2MotRObVbzPBm2bymPp39RUcjexXN3Ne5024jmlm0+5ERc7nicZVj6j0NVjJrcJ5jtpfYHaa3MgcjoOfwoPTGTx6c8UrlGCbzVpvkXTVVjxuaTIFaGm2MlpA/myh55H3yEevpV4fd5J5OM4xig8+xPH0IoAbtcdGzSeY46rUgOQPekpCIjID1QGo/sySSCRlwR0xVmimIgltI54zHKFkQ/wyKGH5Gub1H4c+FNT3G58PaezN1eKPym/NMV1ef0pM0xW7Hk+o/Abwrcgm1fUbFuwSUSL+TDP61yN/+z7eKWOm69by+iXMDRn81LV9DZppAPUClaL6D5pLqfKWofBnxrY5KadFeKO9rOrfoSD+lcpqHhvW9JJGoaRfWwHUy27KPzxivtVokPamGLjAYgenalyIPaSPhnFFfZuo+EtC1XJv9F065J/ie3Xd+YAP618/fGXwvo3hnWNNTR7IWqXFu7yIrswLB8cbiccVMoWVy41Lu1jzOiiioNAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACtPw7/yM2lf9fkP/oYrMrS8O/8AIy6V/wBfkP8A6GKEDPs5j+8b/eP86M0xm/eN/vH+dG6uq5xik1C5p5aonPFAyFP+PmP/AHhWnWWh/wBJj/3hWpSQMOnNQ3Q/cn6ip/Y1Dcf6gj3FUIeEDwKp7qKjgba3lvjK/dNYGleNtO1PW/7KhinX7yRXDgBJmT7yr39fy+ldDdJ8gkA5Xr9KGmtGCJMksy4GcZXPQimlCfvQRt9D/jTIXLpgf6yPkD1H+eKpT61YQa5baV505u7iNpgqAsEUd29M84+lFhl4eWH24ljbGcAk8fTmsvSfFej6xf3FjY3b3E0AJkDRlQAG2nnHPNQ6N4btNI1S71FL+e5vbosGluOSFLbgo6cCt4QxQ5eOONef3gVQM56k/wA6HYZyV949s9v2LQ0Gp6p9pNstuQUwVzuJyO20j6+1bGh63a6/aSSJZtFcQN5dzbyAB4n9D6j0NZHiyF9LvtL121sxI1lMwufKQb2idSN3uQf61D4XvBrfivVNbggmisXtorcylSpmkUsc4HoDjNVZWug6nYeXAOsckf0z/SoLyO5On3J0ySKS8EbeQs/3N+ON2OcVaDr/AA3P4NiqusXV7ZaXJcWVqL66QgpCrbNwyN3PsCTUDMHSfES6jc/2Pqll/Z2qYO2J2+SXHeNu/wBPr1qnZJ/winiYWW0jS9Uc+Ug6QXOMlR6K4BP1HvTZbiw8aW09pNbzadqtt+88uTiSBuzoe4zioJHufE3ha8tZwI9ZsG2SN2FxHh45B7NgH9KuwjuE4jdR5ifLwGXgGuaj8KrN4pXVhdTlVn+1NbZHlmbbs3/lW3oeqLq2kWWoJMF+0wLIUkUZUkcjt3zWmcsoG5dx5Vl6ZFRdodriqroBt/hPHuvp/n0qC61K2s5LaKWTbJPL5MS9SxxnH4YqSQKV8wRuSR/Cen615tquo6lZfEMyvpU179ntybGFZtpVDjfIM5y2cg+nHrSUeYd7Hp4lDDBJ6c8dR/8AWpeSSM8nj8RXDx/EOJCFv9H1W0bON0lvvH5rUtxq8XiTUYoLG8ubaCGAyExjYxkzhevUCpkuRXloil7zsjs8k9Op5H1HasXV7ye8uk0bT5WWaVd88w/5YR/X1NT6DqEt/pSS3Cfv0do5Sg4LIdpP6VQ1yK6sbv8AtbTEZ5inlzwYx5q9vxB5+maEDNDRtTe6SW0ugFvrUhZgOjDs49jWpWD4d06SzhkuJm827n+aeT1PoPYVuKwYZByKHuIU0hpCVzjPNV76+tdNs5Lu8nWGCMfM7H8h7n2oEWM0V5N4j+J1y++PTWFlbdBM6gyv9B0X9T9K46LxvqUMhnXVNRRmP3jKWz77TkfpTdo/E7BGM5q8Yto+ic03NeQaT8UtSUqs7W18g6hh5cn5jj9K9B0HxbpviD93A7Q3QGWt5cBseo7MPpTt1RLdnZ6M3Sa+e/2gv+Q1ov8A16yf+jK+gzXz5+0H/wAhvRP+vR//AEZUz+EcPiR43RRRWB0hRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFaXh7/AJGXS/8Ar8h/9DFZtaXh/wD5GTS/+vuL/wBDFAH2KzfO3+8f50b6hZv3jf7xpN9bKRztExao3NN3U1mqkybCRn/SYv8AeFa3BrHjP+kxn/aFbAIIBxyaaCQvX61FcgNAal/mKjn/ANSfemSeeab4a1az1XT4pri3Om6Zcy3NttH7ws+eD/31/nPHoob7pP3T8rD0NLHGjKjFAWAGDim7Tn5wSD8re47Gm5X3GiCQG3JlH/LLlvdf8/yqppdvpN1dSa9p7CR9QhTbcIxIZF7KDwPf1/Crt9bS3WnTwq+yV43iD4z1GM/1qnoulvomi2WmqwkFrCiK4GASBg8fn+BovoM00YlwPNc/7Lp/9aq9jqljqayTWVwk8aSGCXb/AAsD/n6g1geNNZuoLS10qwkAu9VJjR8Y8qMfeOc9ecVz6rH4N1XTZdPBa2ugllc2mctN2Eij+8M89qzc4KSg3q9ilCTTktkekMo24YZ2cEHuv+f5U5E8sGNDsUfMuB2oyV+Y8tH8re49f6/nS4KjaOSnzL7r6f59qoBnmZ4Msf0aMiuP8TaprcniYaZotxFb/YbZLp1dcrMzlgqH2wp/Ou1U5cATg552kDpXHeKNL1SLXI9a0dIZ5JIPs88MrY3qCSpB9QSfzqZ83K+TfpcqPLdc2xnefJq8mja5Z2ckd9Bd/ZbqFRkqpOyRD6qDg59K0ntJbHxwk0UbfZ76zaOdtpIDxEGPPYZDOM+wq94S0y6stNlN+yPfXE73LlR8oc4+UfQAV0YPPykhZBkex71bl0Jscv4K8yDTbyxLIRbahcIqucHaX3gD2w1dQ68hRgA/dPo1RwoisFRlxnODHg1JgNkA4D8r7MP8/wA6lu7uOww4ZT1CvzwehHX/AD7VheINH/tM2F1aXKR31lcLJG0xwChOJFPGcFc8eoFb+N4x038j2YU0u20HeAD/AAshOPyoTtqBTFhkErMpWsfVNKuLgwSQXRtrmHcI5VXcCjdQfbjNdIhAVpFEbEd0XBoVfLHsvP1U/wCFL1DYp6Np40vS4rbfM7As7yY+8zHJOPxq4+yRdrSqR6MMGlyUBG/bs9s5Hajzd3Akib2PFMCA5iXy0C/Nyu08fSnuZI7ST7LGHm2Fow5wpbHAJ7CkeMyE4wOy+zCnRnKZbcP4hjr70AcZFr+rw+IXmudELym1RHjt5gdq7z8/PvkY9q4nx/4vbUr1xE3+hW7FLdM48xu7n9ce31rsPGV8NFurieOVWnvbX7PFHyGX5iS59gDx6mvHtW0/UHWO4Fjcmy24jlWIsjepyM46Y5x0oqVFTjfq9iqNL2tTl6Lczbt3mvH3HLEhR7dKjmIMrAfdX5R9BTkbzZlcFW2ldxU56etSLFslkdhxHluemc8frXA5dz2lGysiM/uRgf60jk/3fYe/rWlpWrTQXEQaZldWBimBwyN25qjb2k962LWGa5Yn/ljG0nP/AAEGtSbwlrltp01/c6XNBbQrud5CoIHrjOcURrqm73M6tFVY8sj3bwl4jHiDTCZdq3sGFnUcA+jAeh/Q5FePftB/8hvRf+vST/0ZVvwX4g/sbU4bqUs0YUw3CjqUP8XuRgH86pfH+RJdW0KSNw6PZuyspyCC/BFd02pQ5lszxoxcKnLLdHjtFFFYHQFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVo+H/8AkY9M/wCvuL/0MVnVo+H/APkY9M/6+4v/AEMUAfXjn943+8aTNDffb6mkxSTIaFzSE0YoIrZMzaEh/wCPqL/eFbOT6VjxDFxGf9oVqyTLb2zzzEJHGhdyT0AGTVxIkRX+o2el2rXN9cR28I4LucZPoPU+1cwfiV4alYxC4nVWOBI0DBT/AF/SsvTof+Enuj4k1mEy2pcpp1i/3AgPLsO/9T6gCuyzp97p8kUttD5ar80Txgrj8qTrUoz9m3qNU5uPMloWrO7tb7T4p7aVbmBxw8R3A/lU4xGoZc7R94E5IFeduieEblda0vfDpckgTULNWyEUnAlXPTHf/Dp6GJEOJUbcuAGPqD0NVGUZxUoO6YOLi7PcyfFmqJo3h68uWvTbyvG0duQAT5hB244/HPbGaTwxrMWu6JbzQ38U8yRqtwCvzLJjnP8Aj3rM8YiO21fwvcXChrOK+dX3/dDGNthb2zVW28lPiagtIov3unSG8SMAAsGXYT2zyauysI2/EuiDWdKNtPtVkbzIZ0B3ROOjD+tYfhvw9qE2pvq2ulXuYR5UIXlUUcFx7t/Xt0HaBFPWCRf90/4GpYzsTIDkA8h+uKgod8ke0ksTjGcE5H4UB4VC/Njb0zkVxUt5rPizU7mx0W+On6RZyGKW8QZeZx1VPYfhUq+B9Wh/49/GWqp/v/N/M0+VdWK52ClCCqSpjnGDyKRoS4+ZB83zY7Bh/jXIHwv4wT/V+MhIOwms1NKui+PITmPxBpr/AO9bFf6UWXcd/I7BU+TCLtH3k9j6f59acUY5wMZ+Yf7LVx5tPiMOmo6M3/bMj+lAi+JC/wDLfQm+qt/hS5fNBc7AScFmcbSM4A5Wm85Kn7xP5MP8a5LZ8Rz/ABeH/wAmpDB8RW6y6AvAHCv2o5fMdzsPvdON/I9mFZmv6xFoejz6g6ux4WKJPvSSk4VB7k4rD+y/ERs5vdBXJzxEx5qfUIbi517wlY6i8b3CGW9uPJBEckkcYXgHtufI+goSVwuVIvB+s6ui3mveIr+C6cbhb2L+XHD/ALPuf881J/wguoxf8e3jLWUxwA5VwPzFdfeXltYWzXN5cR28CkBpJW2qMnA5+pqGLVdOnXdFqFo49VmU/wBaOeQuVHLf8I14ugObfxmXwMD7RZq38qPsfxBtvmXVdGvAP4JLdo93tkdK68XVs3S4hP0kH+NPDBhlSGHqDmjnYcpz2ieIG1K5n02/tG0/VoVDSWzNkN6OjfxKa2855A6/MB79xXNeNrZ4ILfXbVf9N0w+cpA5eMf6xPcFc/iAa6KORZ4kliOUlUSR/l0/Kh2tdAeCeOL++l1zUHlLNN9oMK5P3UBO0D8MfnXocN1pvhzRbSC9vbe1SGFU/eyBc4Fct47t4YvG0jBNyO1vclffI/T5f51reIIP7MSPVr+x0ydp3MQlFnvfKgnBy3QAGvLzKnKpUjFa6HpZfVhTpSctNdy5FZeGfF9n9tjtLa8i3tGJxHtbIODhuD+NNGieEdEuYFnt9PhuZs+U10wZ3xjOCx5xkVJ5t9pthZ3CpB5M7xYtoLUIxWQjkfORnHNMugmvR3rXGnWc1pZvsMd9aszDCqzHjOAM+nbNeVaSly3dj0OdNXOlhEaxjyQgTt5eMfpTpIo54nilQPG6lXU9CDwRXCaVp2k3BMmkWbQmM9NK1J4h6/6ttqn9a6bStQgi820ur+Y3MbDKXzxLIoIyB8uAR71jOm47E8yZ4/dadJpGuXNjk/uJWjGe6dV/8dIrD+ITTNp+g+axKCOdYs9lEvT6ZzXoPjYRnxbLJHtP+jxE7Tncef6Yrkfi3FFBZeEo4ZEkUacxLocgsZCW/XNfQ4NyeG5n1Z5WLaeIVux5jRRRWpAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWj4f8A+Rj0z/r7i/8AQxWdWl4f/wCRk0v/AK+4v/QxQB9eMPnb6mjbUrL87fU0baSRLI9tBWpihBwRg+hpCtVKcaceabsiVFydkRRL/pEf+8KoeP5pIPA2qmNsM8Yjz6bmA/rWoi4uEH+0Kg8V6ZJrHhXU7CI/vZoGEfH8Q5H6iuim1e5lNGcUisraG3UqkFrAsYJOAAq8n+dY9j4m07U7t7O3aQOQShdcCTHXbT4xD4p8LwuzyRpcIqzBDhkkXG5T+I/EGmar4fhvNOhgs2W1mtebeRQfk9RxzzXhzjT9rJVrqTb+Xn5/5HoRcuROG1i1Yajpery3WkCdJS8bwzIRwQeDj1wcZx0rS8CXUk/hCy89i8toXspmb+IxuUyfyrD0nwrbQTaX9nkaOe1dsyAD99uHIb2zz7YxWj8PXzp1+Tkxy6hc49P9YRn8a9HBOHJKNO7jfr31/wCAzmxCd05bnSappdrq+mTadexiSI4OD145BB7EetZfh/wxY6AJJLdZd0vWXJdiOwzjge1buTnuWi6+6/5/lUigAlASFYblK/rXZd2sYDQ3IAmk/wCBR/8A1qr61ctZaLfXcZy9vbyPj6Kf/wBdW0JLgb5h7Mv/ANasrxW3/FKay4BBFnKrD22nBpLcY3wXYLpvgzSYOC32ZZJG/vOw3MfxJrTWe5nGYYwF9TVTTW8vwrYY6/ZYh/46K1YUCQoo7Ck3rcaK3l3p/wCWij/P0pdt8v8AEjflVylqbjKYlvF+9AG+lL9skX71u4qLVdc0vQ4RLqd9DbKegdvmb6Dqa5xviZpLn/Q9P1e8X+/DZttP501FvZCuludP/aCd43FL/aMf9xvzFc1B8StCaVY76K/04scBry2ZVz9a6yCS2u4EngeKaJxlXQhlYexpNNboaaexX/tFO0bfmKw7ycT+OdAfZtxDdJ19VQ/0rpZLaOSMrtC57gdK5TWI5LHxR4dlJU7pp0B9cxE/0px3Bmt4nvLWy0ZmvdLn1K2kdY5LeGHzTg9yvoMVwMS/D7UL2G3/AOERvopZpFjH+gyIFJOMnB4HNeia5qV5pVilzZaVPqTeYFeKBgHVSD8wz15x+dUn8TXEfh6PVX0DVPMaXy2s1QGZRkjcRn7vGfxqotpafmS1dmFceDPh9a3LW08NpBOoBMbXZVgD04zVrR/DvhTSdVhvNMvGWZcqsY1AujZGMFSeayNR1rw/qtybjVPAeqTTkBTJJYbmIHTnNX/Deh+EdYd7q18KPYy2sqFTdWxjO77wK884Iqne2rYrK+h0uslHsHRxkFWB+hU1l+FbydvA2jzCMSy/YI2A3YLnZ/WtLW5lFrMBj5InY/Xaaq+FbZU8IaLE0UbNHZQj5hjjYKlfCV1PK9I83xF4mkk1F2leeKR5uCu3IxtA7bd2B9K7VotRjtvLmlsrmJOd0yMucdyBkZ+mK5/wp/pPiLV7vaAu5tuOnzSMf5AV10xQQsJAShGDgV4eZ1H9YsuiX+Z62W006F31b/yKEK3eo30Nxe3CPHA2+KONCMtggFiSScAnA4qcW95aSX4gigu7S+z50MjbGG5QrAHBBBwOuCOealtYBGw8qVJE/X9KuFlUZZgo9zivNVSSfN1O2dODVuhmaYX0mwksrPQrhEkk8x2aaMlmxjJYv6ADpVjT9OKRTyX0UD3FzM00igblXgBVBI5woAz35qylzG0wjXJyMhhyD7ZqyKVSrObvLcyjSjTXLFWRzN1odis2qvcWVulrJHu3hAuwKnUEdDnNeB+N3mZdNV87FjcqOwJYFv1r2fU7jVvFGuXOhWBjjt4nO9s4BVcZZj3Gf4R1rgPjZpMGiT+HrG3JZUtJCzt1djJksfqa+gwdGdKg+d7207Hk4irGrWXKttPU8pooorYQUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWhoJ2+ItMI6i7i/8AQxWfWhoP/Iw6b/19Rf8AoYoA+zdNkguHkWXgPx9DmrsdklqWmuCCqn5QO9Y2mfZUuZWunKr/AA4zyc+1b5u7KWJRzIg6ZBq2rEJ3RmTN5szuRjcc0zbgHFTyhGkYouEJ4HtUZXHT9a4a1Gop+0a5kndd0vJbP13NYzja2xCg/fJ/vVdyo5Jx7k1WAxMv1qxIcqY+hYEKSMgGvSgcszgr+yayurzXPC0sV7avKy6hYI/BdT8zJ6MDnOPfr0qxb65pVzYRXi6hbxxyD7k0qo6nuCM/qOD2rb8M6I+gaFBYzIlxOGZ5plwA7sckjPNc1aaBpM3xD1az1GwhkSa3S6hV+ArbiHwBx6H8amvhaVf4t11RVOtOnsLqGv2drpMsmn31rd30hEVvDBKHbe3AJA7DOfyrovDGl/2PolvZE7tibJG7lzyT+ZrmtY0rRdM8UeHBptvbQs904lWEgnhCVyM+td1ZkrAH/g3Hd/jVU6MKMOWHXUUqkqjvIsqrhVYj514b/aH+ead5bAFV7Hch9Pb/AD60NkNkzhAegIFZOs6zNpVxpKR+VMl7erbOx42AqxyMdeQB+NVuI2Ffq2/IIzsA5FYni0lPB2tnOcWEvPqu04P4VuATDvGfwIrD8ZBh4H13dGoC6fNgq3+yaI/EgexatBjw1pw/6YRf+githeg+lZNuMeHNP/64Rf8AoArWTlF+gqGUOrmPFPiS4sZ4dH0dFm1i6Xcu7lYE/vt/T/IPSTTJbwSTSHEcal2PsBk1wfhGKS9guPEV0M3WquZRn+CH+BR6cAU4rqxeRLpfhS0tJvtt+zajqT8yXNx83P8Asg8AV0SySKMLIwHoDiqmoXiafpt1eyY2W8TStk44AzXPw6x4vuIY5YvCBKSKGVjdLggjPenZy1HojqZQJ0ZJ1WZGGGSUbwR9DXMSWd14PuG1TQo2fTSd15pgJK7e7xZ6MPTv/J4u/HD/AHfC1un+/dj/ABqK81DxhpVo+panpWnxadb4e58uYu4jz8xA9hz+FUk9gbTO90+/ttUsIb2zlEtvMoZHHcVzvjcfZzoepscRWeor5px/DIjRf+hOtReGo20PxFdaMg3adfRHUbFl5VOQJEz0AyysP94+ldNqenW+r6Xc6fdput7mMxuB1we496j4ZeQ90Ur46pdaOyaPcW8F+rLhrhCybQeeB6jvWFv+I8P/ACy0C59wzpVC212+8LTR6b4hiuNyERwajFGXjuFzhS2Put0yP/11197rtnp1ktxeTxQAsE3SNtXPbn3p6rpcW5T0S48VyTzjW7LToYhHmI207MWfPQ56DHeqen6v4wnv7dNQ8N2lraM2Jphfbygx1Axzzipj4x0ojI1XTwP+uo/xqnd+NNEVD52tWe0c7VcH9BRZ9g+Ynim7Nj4e1OZCrymJo4hn77t8qj8SRWwyf2V4cKYLfY7Pbx1ICcfqK5fTzL4w1i2uxDJHodhIJ081dpu5R904/ur1+uK7lguCGAZQMEHoUNN6KwtzyrwDHt026dmBdpVBweeEH9Sa68VyOu+HL3wleNq+jZaxDbZY+vlr2DDunoeq/St7R9YttYtfNgyrrxJG3VD/AFHvXh5lh5qo6y1T/A9XLsRFwVF6NfidVaS6ddxKl7BB5yjG90Hzfj61LK2kWYJgtrd5OwRAfzNYYp4rlWNmo2sr9zolh4817u3YlkkaaQyOcsT+VG4KpY9AMmmj1rmPEvib7GP7OsYmmu50wGAyFB44A5ZvauelSnXqckdWwqzjShzPZEXw1T7Tf6xqJOfMZQD/ALzM5/QiuD/aF/5Deif9ekn/AKMr1rwPoc+h6CY7pBHcTyea0eclBgBQT64HNeS/tDf8hvRP+vST/wBGV9bVtbQ+fo3urnjNFFFc51BRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFaOgf8AIxaZ/wBfcX/oYrOrR0D/AJGLTP8Ar7i/9DFCBn2PpkEbTXEsqB0iRjtPfrS6XMEvUVlBVzgD0NJptzHBdSpN/qpQVYntzV9LWy09/tLT+Zt+4uR/k1vLqjFdGMnjCTOoJCg8VDhD0JP/AAKmxXBuZHL/AHs7sU9+mfSvMq01LmqcqaV73u723t0X9bHRGTVo33GD/Wr9ara/PPBoWovbsY547Z5IZFwSrAHBGe4q1jEqj3qZxvOwfeAyue/+f616dO3Q5Zmdod5/aPh3Tb6eVi81tGzuDjLEcniuP+IGnWr6lpV/PLJ9jL/Z7mRH+ZVblST6ZH612elarZ6nFJPZFhFFM1tKrJtKOpx09P6YqTU7KLUbOS0vBA8TjBViRkVqnZk2POL7QNJ0O70d9ORvtU1/GAxkLFk5yfp716ZaKI4FbseHH8jXK6P4F07TtTF3EJXePIjMsoYR59MfzNdiCuFcDCkbHU9u36UpO40OCkK0XG4D5CfT/wCtXl/ijwxqel2dpc3viG7vN15FENwxsLNt3j0IzXqABxgcvH0/2h/n+VU9V0qx1i0WC7SaSHzEmGxjwysGHT3FKMrMdrlXw7pI0nS/szS3N6fMZ/OmfLcnp16Cm+MUP/CCa7tVl/0GbIY542GqnifUtQtH0zTNGmMF1fzMnnTLlYkVSxOCPpVFtWutb8AeIob9YxqNhFPa3Pl/dc7Mhh9VINNJ3UmD2sdLb8+HNPP/AEwi/wDQRWrDzCh/2RWRYnd4W01vW3i/9BFa1vzbR/7orJlIwfHkskPgPW2iYrI1qyKR2Lcf1pbOFbayggQYWONUA+gFQ/ESaGHwJqqSTJFJLCUg3fxS9VA/EVnX3iKffDp2jaJd3Wpy28chMqlIYd65yxPp6cVSTcQvZkHidjqstp4Xtzum1Fx9oxz5dsDlyfqBj8a7PU9Ss9D05bm53LAJI4FCLk5dgijH1IrL8LeGW0VZ72+n+16vd83E/YDsi+w/X2GBVf4h4/4Ry2B+7/alln/v+tGjaiPzOrXDKD6jNMngjubeSCVQ0cqlHU9wRg0ls2+BT6cH8KmxWRRy/gOZx4bGnTkmfS55LFixyxVGIQk+67TXT1yWgFbXx14jsx0mMN3j3ZSp/wDRdddiqnvcS2OV8dETaZp2n79rXupW6D3CN5jf+OoaxLtIvEXisWbosun6WpecMMq87jCqfXapJI9xUfjjVLuXxlpmm6ZGJry2gkkjUj5Y5ZBtVyfRU3E/7w/HpPDnh6PTNMW2V2Y5LyzMPmmkPLMa0+GKJ3Zz2v8AhvRoPD2pTwaXaRzx2sjI6RAFWCnBHvWrpfhvTvsdtNFpVqC0asXEK5JwOa0dbt0Oh63EFBxZybc84+Q1a0lt2jWLZnGbaM8cj7opczaHbUsxQpGgVNy4xjcuOf8A9VOLRIQC4+XIwfT0rE1rxfo2iZgurtpLgDPkxLukU9sgcL+OK4+7+JWr6gxj0XTFiXs8gMjD8BhR+ZpKL3Jc1sXPFvifULV760sIbNLWALDLcXD7nkd1yEjTuQp6npzWH4QtzHpXnRkgvK2CD2X5f6UaX4fvNf8AEUdxr9xuWRt0oB+ZwBwvGAvQDjsPxr1C80S2mhUW0aQsihUCDCkDoMVx5hF1aHJS1Z04KXs63PU2OXS5nHXa31FSfapj0VR+FTvaPE5R1KsOoNKIK+XfMtGe7zxepTfzZvvuSPTtXKX+2Px9pYdxGoMWWJxjJavRrTR3nw0mY4/pyfpVLxj4RstU0R3gSOG9t1LRSH/lp6o59D69q9jKqE4VPaz0VjzcwqqdP2cdzXjkdZPKl6/wt614N+0N/wAhzRP+vST/ANGV1tr4x1nSIIrXU7IzxR4CSsSrgD/a5DfjiuH+MF//AMJZdaVe6ZbXDrBbukylOVYtnt1GO4r3Zq8brU8mDSlqeSUUrKyMVZSrDqCMEUlc50hRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFaOgf8AIxaZ/wBfcX/oYrOrQ0H/AJGLTP8Ar7i/9DFCEz7DsbX7ZeMrNtjXLO3oM1oRppN25t4VKSH7r4Iz/jVTSR5xvrcMBJLGdufqf8aNO066F/G8sTRpG25mb29PWuiW71MY7LQq/Pb3DKR8yHacexrQDeYmQOCPWs28mWW7llX7rOSKltZcExk+4rzJQjyySqOz5nay6P3und9zoTd17q6d+2hcPMo+tI3mRYzkleVoHEyj3qw6bgMevNejT2Oee5jW2nWGh3eq6s135VnflZZhKQscTAYLZ7Z9/SthCzJgFGYd2Gcjsaq3GnwX1rc6fdp5ltOpDJ0/L09frXJR67Y+EbCPRIruXXL9HdIoYlyVQnKoxGfu8dPyArX4iNjuWAiieSQxR7Rkv0AHvmudt/HHh+51ptOiui28YE2P3Tv/AHQfUjv0PrWXF4Z1zxQyy+Jrk2ljncmm2zY/76P/AOs+mK6K98JaNeaH/ZP2OOG3HzRmJQGjf+8D6+uevej3VuGppxuGjDqSTHwfUr/n+VSgYJQE7W+ZSp/Mf1riNG1e98Oaumh+IHyW4tb3+GdewJ/vDjr9D2J7gIdpC4wPmQ+nt/n1qZKxSOa8VaNdamtpPZzvb3lnL5tvJKMrkghlPsQaq2Whz6X4N1s3cwnvrxJprl1XAOUwMfQAfrXYK/8AFuLZGdmBmqmoqW0y7Vfmzbvj/aUqf1FHM9h2KeiP5vgnSJP71pCf/HRW1ac2sf0rm/CD+Z8NdAYnJ+wwZP8AwEV0ln/x6J/nvUy0bRS2OW8TiM+NPC5vNv2TNx5Yf7v2jaPLz26bse9dLZSyyM4kJIAHJHeo9Z0Wx17TmstQi8yIkMCDhkYdGU9jXK6fp1z4R8YaZaHVry80/UopoVW6k3bJVAdQPqof8qNJK3YWzO7rF8WaTLrXhi9s7fb9q2rLb7unmowdP1AraFKSACScAVmnZ3Ksct4W8TWusIkcbiO56T2snEkTjqCPrXVV5v44m8M3elT6rYXEH9vJxYzWr4kknBwqnH3hu4Oaf4o8Z65b62mh6PDEtysaGWRlDMXK5IGSAAB3OauUVvsLmtpuaVoQvxOvmH8dhDn8JJB/WuzxXk3g/VrpvGtxFrMub+SJLdSQBkoxbHHGSGyPWvWWYIpZugBJ+lKfQIu6KcelWEV9dXyWsYuroKJpcfM4UYAz6VbwAMAcCuB8I63qt1rtpLfXrT2uuWc97bQkALbrHIoUL35R1J9xXf0Si07Ma1MjUk32mrJ/etXH/jprl9T8QyaN8N9NubeaRLm5tYYoWYDAJQEsOOygmuuuV3NfL/egYf8AjteN+a/iBPB2igny1sbfzF6j5lBb8kU/nV01fVkVG0tDf0PwXar4ebU9Rjaa8mjMypIxIQHkEj+Jj1JOetSqqooVVCqOgAwK7a7UfYJ1AwvlMAPbFcV2rhrzcndnTSgoqyJrab7PcQzj+BwT9P8A9Wa9AtpQyhc5GMqfavOh0IrrtGuTPp0TZ+eP5D+HT9MUqT6FTRpamLVLR57qRYkjGfMPb29/pVXRvsV7ardwSCbnByMbD6EdjWT4yjFzpSzs5UwuNq54bPH51U8FQeXHcXokJYt5WzPGBzk+/NavDUZfvWtTP2017ieh27MEUsTwK5vxHelbQRA4aU4x6KOv9K15ZTIc9FHQVxmo3X2y9klHMa/Kn0H+PWpqSsioLUpMoOVIBHcGs9/Dmn39wiCIwvIwXdFx1PXHStAnJzVvS13apbD/AG81jCUovRlyipLVHnvjf4btaRGWbFxbE4S7jXDxk9A4/wAg+1eL6hYTabevbTj5l6EdGHYivti4t4rq2kt541khlUo6MMhgeor55+I3gySzuZLZQWeMGW0kPWWPup9x0+uPWu9P2i8zk/hvyPI6KCMHBorI2CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArQ0H/AJGHTf8Ar6i/9DFZ9aGhf8jDpv8A19Rf+himtwZ9eWcLu1zPHMYnt1MgIHXrSz61eXMJieRQp4OwYzVnRJRAdQlK7wke4r64JqX/AISRB92xUf8AA/8A61bu99rmCtbcxwQUA3Y608HDBgwBFJK63M8k+CpdixUHpUf7v1NeJUVOdSUYzndcyaUVpzO73j16O/odcbqKbS6bt9PmbCSB5EcHgmn6pfQabpV1fTrI0NvGZHEQyxA9KzrCUeb5WcjORTPGF9daf4K1O8spTFcRW5ZZAASvIyecjpXt049Djm+pzFvNrvjtWaC5XStGDlGEUm+aT2J//UP94V2eh+GtK8PwbNPtlVyMNM3MjfU+nsOK5STwvcRKmteGZ1s79gDJbniGcEZxjoOv0+nWtrw54yttXmOn3sf2HVYyUe3kPDMOu09/p1+o5rSV2tNiUdSKWkFMlmSFNzfgPWsiilrui2WvaXJZ3yAp95X7xt/eBrlND12+0DUYdA1ybdFKdtlfEZD84Ct6HkDPqcHsTe8R+KF0xEjCG4vZuLe0j6sfU+3v+VUtA8MXNxqC6trbi51E/Mkf/LO3HoB0z/L3PNWtFqHod0PN7Sxn/gP/ANemzpIbaUMqH92wAXI6g0eX62qH6EU7YViOxAh/ug53CsyjmPBH/JM9FU/wWqJ+RxXUWX/Hqn4/zrmPBDBvAFuo6RvNH/3zKwrp7H/j1X6n+dOe7GtizXLePkaDQItXjA8zSLqK9zjoinEn/jhauqFRXVtFe2k1rOoaKZGjcHuCMGoTs7jHGZPsxnU7k2bxjuMZrlvBPia48V6NP9siSG6QK4KDCvFINyMBk+4/DNSeBbt30WXQ71y17pDmzm3HJdB/q399y4/HNO8IeEG8Lz3zNeC4SVY4bdQm3y4ULFFPPJG4jNU0kmnuGt0WNN8IaPYai2orptsl2WLK4XO1j1YdgeT0rgrkl/i9qO7jaWx/36j/AMTXrU06QLljz2UdTXkni+RtM8e2mryKwhmQM+1c52gqwHrwVqJqU4Tj1aYXUJxl0TRN4l0K4u5oNS03i9gIyAdpcA5Ug+oP8652ay1m50681y7u7tZo5fmV3dWI4DHqMAZ6AY4r0S1uYL23Se2lWWJujKaZqVq95pd1bRsqySxMilugJHevGoZhVpJUpdH+HVHpV8FTqt1F1X49Gc1HcX19Y+Do9AlW2vxYXdn5mARCE2ByAf8AcGOD1FaNv8UdQmjtZf7EUQON7ytNjKJtWYgAY3KzDAz0/TldF1afw/qaRXFswuLSC7ihjH3nmmMe1T7ZXg+hq5pNpDdw+HNAmlAuLW8vZLtAecJIPkPpuK/kDX0VotX3X/Ds8iMnt1/4Y9ecA3dwM8GH+leS/DKwM+ry3j5ZbS2WND23Nx+ir+td94y1M6ZoOpXCNtlltxDF/vvhR+Wc/hWV8PNPFl4Wjm2gNduZv+A/dT/x0D86xvam33LetRLsdLd/8eU//XNv5VxA6Cu1vzt0+5P/AEyb+VcVXDV3OqAA4Oa2fD9wI7t7cn5ZV3L9R/8AW/lWNUkUrQypMn342BHvioi7O5TVzR8Z3OILW2B+8xkP0HA/U03wXLmK8h9GV/zBH9KyPEl6t7qxaM5jSNVX8sn+f6VY8KXSW1/cGRtqGAsT/ukf416fL+5OO/vnS63e/Z7XyUP72bjjsvc/0rlz0AHap7u5e8uXuH4z90eg7Cq9ebOV2dkVZBV3SP8AkLW3+9/Q1Sqzpz7NStm/6aD/AApLcHsdpWD4s0Aa/ozxRgC7h/eW7Hj5v7p9j0/Kt6iupNp3Rg0mrM+PfF2kGyvTdxxlY5mIkXGNkg6g+nf8c1zdfRnxR8Kxs73ipi1vvllwP9XL2b8cfmPevnm6tpLO6lt5hiSNiprWaXxLqRTb+F7ohooorM0CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACtDQf+Rh03/r6i/8AQxWfWhoP/IxaZ/19xf8AoYpoGfXtjbCcXrPK8cccZJKHqcnGfUdau2GmWJs4GvM+ddHEYyRj6VBps9vFJcwXRxDOCpPpyf8AGrLX1lJq9t+8221shCHHBat5XuYxtYw54Wt7qSHOWRyuR3pWAKZfAanzXCzXEspBBkct09TURMR6lq8qvKpUrJum0ovRq13876J9uvkdEFGMNJLX7l/wQtWIvIcf3gKd4z+bwJrkRHP2OT+VMtsfbYcdPMH860/E8CzeFtWQjJa0lH/jpr14vW5yS2IPDzifTLUuoMbQx9eedtclbeHrPXdU8WLcIUkg1QeVLGcPF+6Q8H0zzj1rqfCMiT+GbAE/6y2jIx/u1lG9Twt45u5b/Eena0EPnH7qToMEH0BXB/8A1GrV1ewiO08Sat4VZLXxGj3mnk7Y9SiXJX0Dj/J+tW9b8VwQW8Lafsv7694s4IzuBH95sdh6d/YAmt+a1SWFmiCT28gwQMOCPQ9iKwtP8PaL4fnudRCx2aOPnkmfCxjuFz0z/hU3i9R2OesNLudN8aaVLf3Jub68guJJ3PQMNoAX2AOP5YFek2sarArbZctnJQmuK06ceJfFp1a1jddNsIHtrV2BBldiC7foP88DvI1EaiLJKkZUg/mP60pscRQM9Bcj3zUrcnC/fTBGe9c/qni3QdCvorTUL54bhwG8v5n2g9C2M4zW5FOk6pcRMrrgMrIch0PIIPf/AOtUNMpM5bwEc+C7hf7l/er9P3711dj/AMeo+prlvA67PD+rx/3dVvf1lJ/rXRWt1FFBtbO4EngUVPiY1saNNmfy4Xf0HH1rG1LxHbaTZyXd4yRQr3JJJPoB3PtXLf8ACU+INR/0jTvCd9cW55WWZxHuHsDUqDY7pFvV9L1CLUY9b0KRE1KNPKlic4S5j67T7jsahX4jW1uTBrEN/ptyn345YS2PcEdveom1zxU6MsXg26STH3pJRtH+P0rn4biADRfE19qC3F9c6ijzFl27E2tH5QU9FTcCfcZq20rKXohav4Tbu/iNpghZ9Ot7q+kGBuZDFEpJwNzHkAn2qzZeGZNUMuoeJCl5dXEexIYyfKtk64THf/arJ17VLCw8YaqmoRCS2m0+KGVduV3rvYKcdyG/lUej+D2OlW0sup6jZzSIHeG3nKomeQoHsKwq4mFH49FpZ730/T/I1hSlU21Kc0D+CPFcUQmlfTbkAln4yDwSR6qcc+hruwK4XxL4cFjphnm125mVD+7hvG372x0U9ckV0PgW6n1rRhEQxktW8lpWBwR2Oe5xwfcV52OpxxMFXo69HodGFm6E3RqadUN8R+G01u33w4S+QYjfs4/un29D2rll/tjwtrNlqWtaY6hiWaTau+QlduGccFgMcHr717NbWcVqN33n7uf88VT1i2i1bTbjT3Z0inQozJjP4ZrrwKqUafJUd1+RhiVGpPnho/zPM/GGsReIxpFhpsjOtw248YZWJ2AEdiMsfwr0u2t47S1it4gBHEgRQPQDFcJoHge60jxTHdXUsEtpAGaGQHDO5GBle2AT39K9ArpqyWiiY007uUtynqzbdKuT/sYrjq6zXG26VKP7xUfrXJ1x1NzphsFKDwR2pKKzLKN9F0lH0apbO38td7cMR+QqyQDwelKTxgdP51s68nT5DP2a5uYCc0lFFYmgUqsUdXHVSCPwpKKAO8Rg6K46MARS1naJcCfTUXOWi+Rv6fpWjXUndXMGU9U06HVtMuLG4H7uZNue6nsR7g4NfLnj3Q5rO4aaRNs9u/kXAA7jo30/oRX1fXlvxV0COZ0vNv7q8Q282OzgZVvy/wDQRWtN3vB9TKpo1NdD5roqSeF7eeSGQYeNirD3FR1BqFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFaOgf8AIxaZ/wBfcX/oYrOrR8P/APIx6X/19xf+hihAz638vfcBOm58fmajubd7ad4ZBhlOPr71et03ajEP+mo/nV3xGi74GCjeQwJ9uK6eb3rHOlpc5wikxU6xNI6ooyzHAHqa07vRRZaY00jbptw6dFHpTbSElcyLbi8h/wB8Vs6mRNpV5Eozvgdf/HTWPbj/AEuH/fFQ+NZ5pIdP0GyYx3OqziJnXqsQ5c/lxQldgxPh6fO8HaZk4b7KmD6EcV0moadbanaG3vrdZoZMCRD69iD1BB71xenK/g7xR/YzSO2n3g82xeQ/db+JD/n09a7lJFZQftJBIzg7cinLe6EtjjJfh4ls/wDxKtZ1S0hbP7pJTge3b9abbfD2yadZL+e9v3VsD7VKdoP8/wBa7kH0uh/47T9xQKWYOpPJxjHpSc5dx2RBZ2cdlbokEQQR/LsUYAHoBVnyyFZRwo+ZD6e1D7wc+aqDtlf/AK9ND/8AT0n5CoKPPE1XR9L1/wAVprnliW8nWSAzRbt8HlqNo49Q3+RXQ+ABNH4PsA6MpUyNCrdTEXJVf++SK0LvSLa7kUyw21wFOVMgU7fzrVgiaGPajIwA4AGOfrVSkmgSOd8GBfs+vxJ91dVuMfjg/wBaviuY0u612GfxGNBsba5k/txw63EmwIhhQ5Hvu4qQxfEKRmIsdFiyc8yk4olHUadiJjH4i8V3F5Iivp2lSfZ7SJhlHlABeQjvg/KM9xW+8skjZd2Y+5rmtM8M+ONOtVt4G0SNA7ufMLSEs7FmJ455JrQXQPHT9dW0aL/ctSf5ivMxWDq15350o9FqddGvCnH4Xc1A5HRiPxri9b8N2sV0/kfvLnV7lLaCIj5Yt5BlZffCk57c10f/AAivjOQ/P4rtU/652C1Gfh/rc1zDc3Hi6UzwsWikS1UGMkYJHPGRxSw2CnQqKXtFbrv/AF/wB1sRGpG3L+RlSaHZaDrcWnzI1xpeqr5ZFyd+LhOVyfdc4/3a6zHoP0rMm+G91eBReeLdTnAYOAUThh0Iz0NSD4ZQt/rvEetyev78D+lXi8Gq81JTt/X9fcKhiHTVuUwvHunzXOlQ3cWSLViZBjopGN34cZ9s11eheJ9HTwXDqTmCxtrdfKlhjGBHIOqqo5OeoA5ORVQfC3Rj/rtQ1eX2a7OP5Vky/CMm8k8rWStnktHG0OXU4wMnOPbOM4row1KNKkqcpXt5HPWnKVR1Irc7kXaXkMcsLhoZFDIVPDA8g0lcD4E1aexup/DGpjy7iB2EIJ6Ecsn/ALMPY131OcXF2HCXMriMobGexzQBgYFLRUFGR4ifFjGv96QfoDXM1veJH5to/wDeb+QrBrCp8RrHYKKKKgoKKKKACiiigAooooAsaBqBt/FX2Fidl1a7l9N6N/UE/lXa15TeXX2HxbolznG2QA/Rm2n/ANCr1bpxXXb3Is5r+9JBWN4q03+1fDV7bKuZQnmRf768j+WK2aOO/ShOzuNq6sfHPi61EWri4QfJcxhx9eh/p+dc/XovxL0z7HcTxgf8et48Y9lbkfpivOq0qL3iKTvHUKKKKg0CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK0vD3/ACMml/8AX3D/AOhis2tLw9/yMul/9fkP/oYoQM+x7bamoxsxwok5NXdbt5p2iMcbOFBztGcVQdf3jf7xrWs9RjEKpO+114yR1reV07owi1azMG2iKX8AZSp8xeCMd639bGdLk+o/nV1WimAIKPjkd6q6uM6bJ+H86hyvJF8tos5GBcXcP++Km8R6JPqsUM2nzpaalCdkd2UyyRsRvUHtnApIlxdRf74rdyfStU7O5kzjtO+H8MN/Fe6lqN3fzxMHXzpCVDDnp/8AXrsWDZG1EI9zj+lKDTZmRIXklfYiAszbtuAPem229QQuHI/1MX4n/wCtSkgHnBRvlYdga4NvH+zUxdQWE8nh+N/IlvDuLbz0YDPTtjvnscA9RquvafpWkHVZpVktZUBQIQTKSPl2/X9OvahxaBM1VHWNgrMo+Ut3FLtk/wCecP5//WriNA8XagdRjsvEMC2st0POsXxtBU/8smP97pycc9QOMyeItXu9Q1mPQNBmdbpiGuLlTn7OnU9f4vb/ABo5Xew0ztdr94Ivz/8ArU4KQuFVEfOQqng1CqdB5c57El8f1qZvmJVeHTDLnv8A56VmyzltAnTT/HPiHTZTtbUJI9RtieN4KBGUe4KV2Arntf8ADln4hSBnkltrmJi9tdQnEkTdx9Djp6j1rBk0DxZD8v8Awm1xkcBfswJ/OqaUtbiu0egg04GvOhoXjBunjG6/C1FOHh/xgTj/AITG7z1/49lqeRd/zHd9j0TNGa87/sPxeOf+Ezuvxtlqi6eL4NftdKPi2bNxbS3CytaoQPLZAVxjP8Y5z2o9nfr+Y+Z9j1QUteeC18cRcx+KrWXHaWyAz+VPD/EFBxquhyf79uyn9KXJ5ofN5HoNFeZX+s+PdOjhea60XbLOkClIWPzMcDOT0q3v+IL8Nq2jx/7lsT/Ol7PzQc3kM+JHh6TEfiXTiUurTBnKddo+7J9V7+q59K1/DeuxeINJS6Xas6/JPGD9x/8AA9R7Vktp3jS6Vlm8VxopGCILJen41zL2eo/DvV7e7Xdc2M6hJCE2Bx3XHQMOq/iKtxUo8t9TNtwlzW06nqlFUoNWsLjT475LuEW0i7ld3C/nnofasq78c+HrQH/iYCdh2tkMn6jisFGT2Rq5RW7IfEEm7UVX+5GB+eTWVUtxerqMxvEVlSYBlVuoGOM1FXJL4mdEdgooopDCiiigAooooAKKKKAOb8SA/wBpabjqXAH13rivYe9cFp+lQan4t0v7TJGI7cPMI3YAysCu1QO/PP4V6PJbhuUOD6dq7E704o5rWnJlWinMjIcMMU2pKPBfjDagahq+ByyQz/yH/steJ17D8V9ciu7vUpoyCrlbSI/3gvU/nu/SvHq2qdPQypdfUKKKKzNQooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACtLw7/AMjLpX/X5D/6GKza0vDv/Iy6V/1+Q/8AoYoQH2PMHJfZjdk9frRp0jQXW2dMxvwdwyKtW1ubm4Zc4UElj+NajWNuyBfLAwOo61jiMKp14VlNpx6dPPT9RUptQcbLX7yN9NgY7o90beqGq9xZ3pgaJZRKh7Hg1Z8i5h/1Mu9R/DJ/jQL3yyFuI2iPr1H5103fTUmy66HMeW0d4iMMMrgEVr5PpVK+IbVtykEFwQat8+taoxkPBrM17RU1/TfsMtxLDCZFd/KOC4BztPsa0h0pQad7MRjyaNbW+nfY0gjNoE8sxbfl2/Sub0rwQkWsRvNdvPp1uxe0t5MkROTk57Hpx+vSu6YF1ODg9qjXBG3G1WOMD+B/8/55pqTKMrW/DttrOnPbTgkochh95G7Mp/pTfC/h2LQrVldmmuZ8vJO3DSN+eRx059a2y5CiU8FeHHbH+eaxpfF3hyCR7d9bslZT8v7zO0+hI4patWQabm6iDeD5TrjuXz/WlLMWJ6unIx/EpqvZ31rfRmayvIrpSM/u5Qy/pUoyCuwf7Sf1WpKRLwTgH5ZPmU+jf55/Ol3dJCMfwSD0/wA/1pigOpUZCN8yn+6f/wBdUdW17TdCWCTVLlbcXLeUFwWyfU46Adz70rX0GaQjG/8A1IxnrvpzM28/31+ZcfxDuP8APtUURDosiNvBGUcNlWGODTsNkFARn5lB7HuPxpFEnU4U8P8AOh9D/n+tc3qGD8SPD0oGC9jeqwP1i/wqLUvHuh6beS2Qa6upomy4tITIIj3BI465rn7zx5oc3i7SdUzdRW9tBcRzeZbsGDPs24Hf7pz+FXGEt7EuSPSHs4X5AKn/AGagbT3H3HB+vFc5/wALS8KY/wCP2f6fZn/wph+KXh0/6oajN/1zs3NR7OfYfPHuHja2lg0KCdgMRahaMSD/ANNlH9a6u1TfAT5cZIY4LCuD1zxjF4h0efTrXw/rzebtKyi0xtKsGB59xVlfGet2MAmufCN5BYq4M1xPMq7FJAJx3xnNVyStYOZXud1/q04VAc5KoOoqnqFha6pp8tldxCaBl+7nkr7HsR2PsKskcYXaABlcdj/9ehVYEHgAcj2B6isymeer8KNPE5aTU7qSNfmRRGgYjvzjr9AKxvHnhvS/D1hYpp6N5s8r7neVnYqF9zgDJHQCvWwoABzwpyD6D0rzD4luJte0e1RlZQrEgf7TqB/I1tCbb1ZhUpxUdESwp5cEaf3VA/Sn0d6K8o9AKKKKACiiigAooooAKKKVVZ2woJPtSAsafp6T6hDfSDJtgwj9mOOfwGfzrrrXU2TCT5Zf73cfX1rGgjEMKxjsOfc1JJKkMTSSOqRoNzMxwAPU15ssVU9rzQZ2rDx5LSR1QZJUBBDKe9c/4vnbTPDN9dQTxwyiPahkbHzHj5fVvQetedan8Sbmy1OE6bNFDah9oWccXJ9MHoPTHP8AKuW+IPxCm1F0mmCpsGLazV9wU45dvU+/pwO9fQ0YTcVKorHj1KkbuMNTz3xpMx1KG33Dy44gQvoT6/kK5qpJ55bmd5pnLyOcsx71HRKXM7lQjyxSCiiipKCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK0vD3/Iy6X/ANfkP/oYrNrS8Pf8jJpf/X3D/wChihAz7a0nl7g/7WP50ya8lhvJArZXd908il0mRA0yFgHL8A96uT2MM5LEbX/vCtG0pamSTcVYZbagkziNlKuencGk1UZsH+oqpHbtbalCjMDnkEfjVvVf+Qe/4UNJSVhptxdzmlP+kR/7wrTBFZan/SY/94VotKE69fStEZMlzWNqvizRNEvY7TUL1YpnG7btLbB2LY+6OvX0NaIeR+g4rza6v9N0bWfE8Ov2plurt/MtmaPd5ke0BVU9sHv/AIVcY3JuepRyLIiujBkYZVgcgj1pruI+X27M8seMe5rE8H21zYeENJtLwEXEVsquD1U+n4VW8c3c0egLp9q2261OdLKMjqAx+Y/goNK2tirmLe3T+MBeXt3dyWfhOxLZ8s4a7K9T9Ow+vr05y98Oj/hGzrz2/wBhiubq3htLROscLyBd7E9WIOf19qs+I9PTw3qUWkefcTaFcMl7cWqDcyLGQG/4CTg/n7V0Hi7XdK1jwejadewy7b20by1OGUCZDyp5GBWi0atsJb6mJaeEv7P8RvpEt3LY6k6mXTtRgYhZwOqOvqPY+vtntPDWu31xd3Oi6zti1i1XdwBsnTs6/wBfr26Cl4+ubMaPFeRXtuuo2FwlzbKJV3MQfmUD3XIrB1zxJLql5a+ItK02aO00dt819L8gkQ4DoB3Xk/TFTrNaj2PUC+6MP5hjA69OtcV4x8u217S9VurCTU9OjtZ7WeFE3EGQqQ2P+AkZ967COZWCTIf3cgGfY9j/AEpJoBKwZ5gCOOgFZJ2dyzn/AANBdWnhu3huhNEoLskRzmNC5KKfopArobpmFhctbySeaIX2bifvbTjrSxgQptW4QD6D/GpDyoBkLFjlWwODSbu7jWx5z4V8a6Rovhqxs7bS9SuboQqbhorbmSUjLEsevNa58fXM3+r8Hao4/wCmiqK6drcO3mbyoLYYAfdNKbaFWw8z5HbFU3Fu9gSfc5I+MtWLkp4Lucdg23P8qePGHiduLfwcV95JwtdYILX/AKaH8D/hT2toQdqxjJGVJPUjtU3XYdn3OIPinxrdX7WEWn6da3CxCYrJKWwhJAOR7jpUN9pPi/W7Oa01HVtPigmQo6xQsxwfeuzXTbEayNQx++lt/JCFuMBs9PXJ61b8uH/n1b8v/r0+e2yC19x8CEwxhrdCdoBPA/HFY3iLXZdOW3sdNt0utT1AlLaB/urj7zv6IvGffA71sqi5/wBSVI6Fjn+tcWdR+x3vifxRND5stqy6dZRbvvEAcD0LSPg+u0Uoq7BsWTwbDJsl8QeKb976TkGO6EEan0RPSuS1ewnsfGtrp82oz6gsKxtHLPjcEO5gpI64x1966q38FafcqZddtxq+qzDdczzE4Vj/AAoAflUdK5FLCCx8c3NlavK9vaMyxmRtxACjjPoCxA+lW5e7LXoZtax9TpKKKK8o7wooooAKKKKACiiigArYtD/oyHYEz2FZAwWG44Gea14pEdf3Zyo4rjxfwpHXhF7zZJLPHbwvNM4SONSzMegA6mvJ/G3jlZIjuLR2gP7m3zhpiP4m9vbt9enW+Nr6QWEVrE2EkkxLjuAMgfnXzprN5LfarPLLwQxRV/ugcAV14DDRpw9tJavbyOXG1nUn7KL0W/mM1HUrjVLoz3DZPRVHRR6CqZJPWiiu5u+5zJW0QUUUUhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWl4e/5GTS/wDr7h/9DFZtaXh7/kZNL/6+4f8A0MUITPseGCSe4KxDJ3Ek+nNa++6sh+9Bni/vD7wp2lqBaE45Lt/OrENxFcAmNskHBHcVpKV2ZxjZGNql2jSxTRPwAOfQ5rSUpqdhgkjdw2OxrJ11EjnARQu4AnHc5qPSb77LJiTPlPwT6Hsa8xY1/X3hX/Kmv1/r/M6fZfufaedmJc6Vc2syyAeZGGyWXt9RTIwXO9uc10kjpLayMjBlKHkfSuadtsfH0r1oNvc5KiS2J91MeKCVkeWKN2Q5QsoJU+3pVO6ubXT7fz726jgj/vSHHPp71mnxh4fX/mJKf92Nj/SrszO6Ok3A965bXXWXxv4Xgk+7GZ7gf7wUKP8A0Knnxx4eX/l8kP0gf/CuS8W6zpeualpk1td3cccIkSaSONkdVbBBXPXkYxTjF3DmR1llmf4n6uXGRb6ZbooI6bmcn88Cs3x34a0e20STUrfT4obr7RCpeMFQQ8iq3A46E1xirpS6q5Or6z9laFf36HExkBPyn1XHSjUBpDWbLaalrlxPlcLdsPLIyM55646e9XazTFzKx6Bc+BvDOm6VeSxWEfmiByrzSFip2nBGT1rPOt6ZJ8NrLT7u/t1muNMEckJcbslMYI7c1yN4vhp7KcW8OsS3ZjPkvczKUV8cEgHJGama+0KLSngtNEZbxoDH9pl2t+8IwX6+tK3cfMj1Lw1ObjwxpU0nPnWke8Hs20CtQcggqjOvBLdx615tpnjyDTdLgsRpk7rFEsefNUcgYzVhvidyrDSvmAwd0+Mj8qhwdylUj3PQBKM8Nbr9OamY5YxngEZUjsRXkV18SdaaZ2gksLeIn5EMW4qPTcWGfyqnJ8QNdk4/teBP9yOMfzzR7KTF7aB7QGyckcP8rj0P+f6Uu5whG8gp1O3OR2NeHP4q8Q3HXXbxgeyFB/6CtU5ZdTu2zNcalceoLysD+Ao9l3Y/bI97im8xuJZGwcHAGB9aeSWJXPP3kP8An/PNeLaFq2t6BFcRaVp0ipPIJHDWUr/NgL7dgOta6eJ/G0mPL0+UYORjTJBg/jSdJh7aJ3Nzpk0/i/TtWRkW3isriBwT8wd2jYYH/ADn6VPrWuWeiWIvLwzkM4iEcOSzOeyr37n6CuC/tbx/K3y2V0CfmwtiB+PNQXUXj28uba6n0+9MtrIZYW8mNdjlSucZ64JHNHJ3Y3V7JnpGkatp+t6et5p82+F22gnIZWHUMD0I9K4tpEj8OFLn+HxQDIpPrdAr+HK1l2mlePopLmW1tL2E3UnmzMpgUO4AGSM8HAHTFDeFfG1x50UsMuLiQTSq88YDvx8xx3+UdPSmopPcXO30Z6lZnEbH+Iuc/nXkmhObjXNUuJT++aRzg9Rl2z/ICtRfD3xAbI+2snOSGvwvP4CqQ+H3iZpWmZrRZGYsX+1nJJ6nIWpcE4tX3DnfMnZ6G3g+lGPaswfD/wASP9+/gH/bzIf6U8fDfWm+9qtuP+BSNXL9Wj/MdHt5fymhSblHVh+dUh8MdRY/PrNv/wB+XP8A7NUi/C2U/wCs1iP322x/q1P6vD+b8Be2n/L+JOZYx1kQf8CFNNzbjrPEP+BihfhZD/Hqz/8AAbdf6mpV+Fdj/Fqt3/wGKMf0o+r0/wCb8A9tU/l/Erm+tF63UA/7aCmHVLAdb23/AO/grRT4X6Uv3r+/b/v2P/ZanX4a6GPvTX7f9tVH8lo9hT7sPa1OxlwXtrdMVguIpWHJCNkirAJHQkfSs7xX4cs/CkVjqemNPkTFHSaXduG0nrjjpj8a5pvHNwfu6fCPrKT/AErOpRtbl2NKdRu6lua3iph9ltVzyZSf0r58vGDXs7DoZGI/M16h4k1+7n0ie/k2CRE2xqowqZOK8ore3LCMWZJ805SCiiipLCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArS8Pf8jJpf/X3D/6GKza0vD//ACMml/8AX3F/6GKEJn3FpxH2Jcf3mz+ZrHtdy6jGDlW34I6Vc0i4UPLAzAEuWUHv61oTWqSusoAWVOVfH8/WtL8raM0uZJozNTgN1qccK4yUHXp3p19YxWulS7Rl+MsevWmW0FxDrCefkltxD9m4q5rP/ILm/D+dQqcIz5ktXa7Ku3F3OZt7yaCUIjkI52svbFSyNuZIx3NUVbFwh/2hVu3yzeYe54roRgzz5re78ceNHtI5vLhjLhWYZEUSHBIHqT+efaupX4R2P8Ws3x+kcY/pWR8NP+Rz1D/rjL/6NFetZoqTcXZBTpqSuzgk+E+kL9/UdRf8Yx/7LU3/AAqzQgp/fXzHtmYD+Qrt80oB9D+VZ+0l3NfZx7HCf8K38O7eIr1iPvZum/pVgfDnw3HFv+zTucd7mQ/1rrZImDFk4J6g9DVclo0IbAU+pAFHPLuHs4djAPgDw0hULpwYn+/K5/rUkXgnw0zgf2JacdcgnP61sfaIXkVWuoFZsKFEq5PsOavIgRcAYpc0u4+SPYxU8GeGU+7oGn/jADVlPDWhR/c0bT1+luv+FWr/AFCz0yza7vrmO3t0IDSSHABJwB+dZMPjXw5c3MVtb6nFNNM4SNI1ZizHoOBR7zFaCNCDSdNR5Aun2i4btAv+FTPbW6EJFbQKx7iNeB+VYmqeNND0PU57O+nmWdQpKpbu/UZHIGKy3+Jnh4s+GvTuON32VuBRySetg54LS51ywW33QF3ewFTwMcFD1XvWdpmr6ZrFvHcaZcxzRhtrY4ZTjowPIP1rN8TeLYfC7QPJZy3IuCyr5bquNuOufrS5W3YpySVzofOEcsmdxyR0qYNuAIJwa5rwr4mXxPb3lwlq1sIZBHtZwxPyg54+tb0LSFUG0bcdc0mrOzGmmrolV95bAOAcZpSM9qAAowBj6Vn65qI0jQr7UCMm3hZ1B7tjgfnijcG7amhwo6AAVWLGRy44YfdB9K8itfiPr739sL2e1Nt5yCZY7cLlMgNzk44ya9fkxK4Ve3UjsKqUHHcmE1LYPOibBdefcVA5yeB1Ncz8R9RvtM0G0lsLuW1droIzREAldjHHI9hXNadquoXPw51u6mvriS4jlwkpkO5RhOhHTqaahdXE6iUrHpOD6GivEdG8RXmm65a3lxeXMsKPiVZJmYFDw3BOOOv4V7aCGXIOQRkEd6U4OAU6imNaWNDhpEU+hYCo5r20t22z3UETejyBT+pryDxMqn4h3JKqT9ug5I/651L8RFU+NLglVJ8iLkgf7VWqV7a7kOta+mx6fJ4h0WL/AFmrWK/Wdf8AGhPEGkS2Vxex6jbyW1vjzpUfcqZ9cV4jHp97IcRWF23+7bP/AIV1emWV3ZfD/wASC7tp4C7IUEqFSRhRxmm6SXUUazfQ7RvHHhxD/wAhNW/3Y3P9K2bK+tdRtVubOeOeBujxnI9x9a8P0/RdT1ZZX0+ykuFiOHKFflOM45I7V0Hw71KWz8RNp7EiK7VgyHjEijIOPXAYH6D0olSSV0wjWbaTR0XxP/5F61/6+v8A2Rq8Xr2j4n/8i9a/9fX/ALI1eL1jL4UdEPiZW8Rnb4WkHqyD/wAerz+u88VNt8ORr/ekQfoTXB1VTdehFPr6hRRRWZoFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABWj4f/5GPTP+vuL/ANDFZ1aOgf8AIxaZ/wBfcX/oYoQmfXpYiQkHB3Hp9a2NP1gMRFckA9BJ6/WsFm+dvqaaWrpcUzmjJx2O54PNZ2tso0yUEgE4wPXmsa01ma1hMRAdcfJu/h/+tVC6vJbly0jkk1mqbTNHUTRXU5njH+1U8UphfY/TNVY2/wBIj/3hUoYzyDHCg1qjJnN/DT/kcr//AK4S/wDowV6P4luJrTwxqlxbytFNFayPHIvVWA4Irzf4af8AI43/AP1wl/8ARgr0Lxb/AMifrP8A15y/+g1NT4y6f8M8YfxT4gkzv1u+P/bXH8gKqyazqsv+s1W/b/t6kH8jVRV3yqucbmC5+pxXqUfwl08cyavfN7KkY/oa2bjHcwUZS2PMTd3Tn57u6f8A3rhz/M16xpOhp4i+FVpYSYMjwl4nfnbIGJU/nx9DTo/hZoSffuL+T6yqv8hXWaXptvpGmwafaBxBCNqb23HGc8nv1rGdRPY2p0mr3PnMQ/Zp+IhBcRP2UBo3U/zBH6V774c14a/oFreJgXDjZMo/gkXhvw7j2NedfEzQvsGtJqkK4gvvv46LKBz/AN9AZ/A+tU/AviiPw7eXaXWTaTxF8DtKo+X/AL6HH4CrmueN0Z0/3crM1PifrrXN7b6PG2Ftv3s+D1kI+UfgCT+IpPhdoputUn1eZSYrQeXDnvIw5P4Kf/Hq4e5uLnUr+W5lBkurqXcVH8TseFH6AfhXvnhzR00HQbTT1wXjXMrD+KQ8sfzpT9yHKVD358x5L8RP+R3vf+ucX/oNc6tlePAZ0s7loQM+asLFMeu7GK6L4if8jvef7kX/AKDXpHgRQ/gbTQx4Cvz6fO1Vz8sExcnNNo8j8N6w+h65b3isfJLCO4UHh4yec/TO4fT3rt/izsEWkKnQNKf0WvOtYEBvtRFng2/my+TjoVycY9vT2xXf/E6Py9O0JT9/a+4n12rRJe8mTF+7JFv4Ubv7L1TaAf8ASl6/9c1r0SMFUCmvPPhP/wAgzU/+vlf/AEWteijgVhV+JnRS+BC1w3xTv/s/hqGzBO67uFBx/dT5j+GQB+NdwSAMngV498T9RF54kgtUJ2WtuM/7znJ/QL+dOkryCq7QOIIDAqehGDXv3hO9/tPwtp12cb3hCyf76/K36ivJ9X0QWngnQNQCnzJTIZTjtId6Z+gXH411/wAK9SL6TeaccFoJ/NQeiOOf/Hg1a1fejdGNL3ZWfUsfFb/kXLL/AK/B/wCgNXLaP/yS/Xv+u39ErqPit/yLtl/1+D/0Bq5fR/8Akl+vf9dv6JUx+BepUvjfocae/HFev+A9WOp+G44pG3T2Z8h89SAPlP5Y/EGuB8OaQdZ0vXreMZnjhhmh/wB9Wc4/EcfjUngPVxpviOKN2xb3q+S+eMN1Q/nkf8Cq6i5k12Ipvlkn3GeJv+ShXP8A1/Qf+06l+In/ACOVz/17xfyaovE3/JQrn/r+g/8AadS/EP8A5HO4/wCuEX/s1OP2fT/ImX2vX/M9hUbYFdmAG0dWx2rnfGkscng7VdkiPiMZ2sDj5hXiz3CSHbJOHPo8mf5mut0JAnw88TYQKC6EYXGeFrN0uWzNVW5ro0fh/rOm6TY6l/aF9BbF51ZFkbBYBAOB35rN8NSf2n8RorqFNqNcTXG30TDf/FD865jy5PLaUI3lhthcDgNjOM+uO1ek/DTSoUsZ9WLh55WaALj/AFaqefxPB+mKqaUU5dyINyaj2Jfif/yLtr/19D/0Bq8Y7V7R8T/+Retf+vr/ANkavFxzgVzS+FHZD4mZvjJtuj2qesufyX/69cRXY+OHwljH/vt/IVx1VV+Iil8NwooorM0CiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArQ0H/kYdN/6+ov/AEMVn1oaF/yMGm/9fUX/AKGKEJn1izfO31NJuqJm+dvqaTdXWchKWqNmpC1MZqAEU/vk+tW4vkRR+dUoz/pEf+8KtBulJAznPhr/AMjjf/8AXCX/ANGCvQfFp/4o/WP+vOX/ANBrz74a/wDI4X3/AFwl/wDRgr0Dxb/yKGsf9ecv/oNTP4y4fwzwaMhZ4yTgB1JP4ivcX8eeGEH/ACGIH/65hn/kK8MPWms4UfM4H1OK2lBS3MYzcNj2qT4l+GYzgXFzIf8AYtH/AKiuh0rU4NY0yDULXeIJgWTeu1sZxyPwr50jdZGAjYOfRTn+Ve6+BVZfBWlqyspEZyGBB+8exrGpTUVobUqjk9S94j0aPX9CudPcgO67onP8Eg5U/nXz/JHJFI8UqFJEYo6HqrA4I/A19HXd3DY2c93cOEhhQyOx7ADJr541G+k1PU7q/lXbJcymUr/dz0H4DA/CqoN6k17XR1Xw20X+0fEJvpVzb2A3jPQynhR+Ayfyr2TNeOfDbXP7N11tOmbFvf4C56LKB8p/EcfgK9izUVr8xdG3LoeJfET/AJHa8/65xf8AoNYi61qiaeLBdRuVswCogV9q4PJHHP61t/EP/kdrz/ci/wDQa3PC3w/0zWNCtNSu7m7LTAlokZVUYYjrjPb1rZSUYpsxcXKbSOX8I6G+t69AhQm1gdZbhh0Cg5C/UkAY9M11vxWffHpXykfNL1+i13+m6VZaRZraWFukEKnO1epPqT1J9zXBfFkfutJ/3pf5LWanzTRq4clNk/wmGdM1M9hdKP8AyGteh5rz34Tf8gjVP+vxf/Ra16Dms6vxMul8CI2BkfDcIP1r59129/tTXdRvM/LPO5XB/hHyrj8AK9v8UagdK8MajeKf3iQMI/dz8q/qa8X8NeH5fEOqLp0EwgCxF2lZCwULgdMjk5rSjonJmdfVqKJtR8WapqmlLpdwLQWa7NqxwbWG3GPm3H0rS+G9/wDY/F8cLMAl5E0J92HzL/JvzroIvhNb8efrU/v5UCj+ea4KTzfDviRsk79Ou8k9yqtn9V/nWicZJxiZtSi1KR6T8Vj/AMU/Y/8AX2P/AEBq5jR/+SX69/12/oldH8UpFl8P2Locq1yGU+xRjXOaP/yS/Xv+u39ErOPwL1NJfG/Qt/C7/j/1X/rlF/6E9c/4y0ltH8SXCRZSKf8A0iBh/Dk849w2fzFdB8Lv+P8A1b/rlF/6E9bfxD0n7doH22NczWJ8zjvGeGH4cH8KfNaqLl5qR5zc37ap4ljv3G157m3Zh/tAop/UZ/GtT4if8jjc/wDXvF/Jq5+z/wCQjZ/9fMX/AKMWui+In/I53A/6YRfyatLWkv67GW6f9dz2GCxtIoVEVpAnyj7kSjt9K5/xuMeDdSGMfuh2/wBoV5TL4j12dcS6vfsPaYr/AOg4ra0i4lm+H3idp7iSUq6DdLKWI4XuTWPsmtWzf2qlpYboGnnUfA/iKNF3SxTJPGB3ZEBx+IyK0/hhqAW4v9OLfLIq3EfPUj5W/TbVv4XqDp+qhhlWnXtwRsFY2iaLq2ieNY2h065e1guWiaRY/lMLcZyeoAKn8KqTT5osmKa5ZI6H4n/8i9a/9fX/ALI1eMxjMiD1Ir2b4n/8i9a/9fX/ALI1eOWwzOntzWNr8qOhO3MzmPG0u7U7eP8AuQ5/Mn/CuYrb8WS+Z4gmH9xVX9P/AK9YlKo7yYU1aCCiiioLCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAq/of8AyH9O/wCvqL/0MVQq/on/ACHtP/6+Yv8A0IUIT2PqUt87fU0bqhLfO31NG6us4ybdTS1R7qQtQA+M/wCkR/71WA/IqnG3+kR/71S7+lCGzI+Gn/I333/XvJ/6MFeg+LP+RQ1j/rzl/wDQa89+Gn/I3Xv/AF7yf+jBXoXiz/kUNY/685f/AEGon8ZcP4Z4NGAZ4wRkF1BH4ivoGDQtHtgPJ0uyjx/dgX/Cvn1W2Sq2M7WDY+hzXoM3xYu84g0a3A9ZLhj+gWtKkZStYzpyjG9z09IYoxiOKNP91QKfXj83xP16T/VQ2EP/AGyZ/wCbCvRfDWqzah4UtNTv5E8x42kldV2qACecduBWEqbirs3jUUnZHM/FHWvIsINGhb57k+bNjtGp4H4t+gNcP4W8OSeJdSmtlcxxxQtI8nox4Qfif0BqnrurtretXepSHCyt+7B/gjHCj8ufqTXrfgHRTo/hqOSZCt1eHz5Qeqgj5V/BcfiTWz/dw8zFfvJ36Hi7pPaztG4aG4hfBx1R1Pb6EV714Y1tdf0C2vuBKRsmUfwyDhv8R7GvPfiZoX2TVY9WgT9zefJLgdJQOv4qP/Hfeq/w410aZrp06eQLb3+FXJxiUD5fzHH4Cia54XQQfJOzKnxD/wCR2vP9yL/0GvSfAX/Ik6b/ALr/APobV5x8QEeTxveBEd22RcIpY/d9BXpHgVHi8GackkbxuFbKupUj5z2PNTP4EVT/AIjOjzXm3xZ/1ek/70v8lr0fNcj448MX/iUWC2TwIIC5cysR1AxjAOelZ02lJNmtRXjZHmuieK9U8PWs8GnG3VZpBI5liLnO0LxyOwqe7+IHieSGRhqflEKSPKhRe3uDW/D8KL0nM+r2yj0jgZj+ZYVci+FmmSNJFLrdzIwGHSJY1Iz68Eit3One7ObkqWsh3xH1Jh4X0qzZ90l2ySyZ6kIoOf8AvorTPhRYbYtS1FlILMluhPoBuP6sB+FdB4j8P6BLaxX+ttceRYwiIFZWUBcjqF5JJxUfhnXvCq7NI0WYw5ZmSKVHUyMeTgv941lf3LJGvL+8u2dZXj3xH0uSHxYZ4YJJEvIVkIjjZiWHyt0HoFr1/NcVrfi/WrXxFc6TpOjJePAiOXDMWwwzyAMAfjSptp6FVUmtTE1S31PWfh3okUdjdS3cMojkQxFXwisu4g44PH51Jo/h7Vh4C1bTZbNobu4lzFHKyjIwnOQTjoa7bSbjULvSYJ9Utxb3rgmSIDG3k47ntjvWL4q1a/hms9G0fA1K+LESH/llGOrf/X+tPmbfKhciS5mU/A/hnUtBuL6W/ECidEVBHJvPBYnPA9RXYOiyxtG6hkYFWB7g9a4azk17wvr9hbarqH2+w1B/KDkk+XJ1GM8j+RHpjnsrzUbLT1DXt3Bbg9DLIFz+dRO7d+5dOyjbscja/DLT4LmOVtRvGEciuqAIANrAgZxnsBXQah4N0XWNRbUL6CaSdlVSBOyrgdOAfeq8vjjw3CCf7Ujk/wCuKtJ/IVSm+J+hRL+5ivp8ekOz/wBCIq/3j1I/dLTQ2IvBXhqEgrotoxHeRN5/Wr0VhZ2kbRW1rBDGTykcYUH6iuHn+LCEH7No7k9vOnA/9BBrKuvifq7AmO0sbf8A3tz4/Mih05vcFUprY9SAAGAAB7UvX3rxWf4h69KMf2kkX/XCFR/MGsu48V6rcjE2q38mfSUp/wCg4qeRLdovnb2iz0T4ozRpolnEzASNcFgvfARsn6cj868jsxmb6CnXN9JcA7mkYngtI5Y4+potCI0llPRRn8uacbOaS6CldQk31POtam8/WryT1mYD6A4/pVGnSOZJGc9WJJptZN3dzVKysFFFFIYUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFXtF/wCQ5p//AF8x/wDoQqjV3Rv+Q3Yf9fMf/oQprcT2Ppov87fU0b6gZvnb6mjdXWcVyxvpC1Q76QtQMmib9+n1pxnRcZYVXibMyD3pgjUYySaEDIvhof8Airbw/wDTvJ/6GK9C8VAt4S1cKCSbOQAAZJ+WvPfhn/yNl5/17P8A+hivWayqO07mtNXhY+eodI1O6bEGmX0n0tnx+ZFaEHgvxLOfl0a4QesjIo/Vs17rk+pop+3fRCVBdWeNw/DbxHIw3x2cK/7dxk/kFNd2PDF8fAkPh4XsMMu3y5pghdSm4kgDjqOPzrqaKl1JMqNOKPP7T4V2cU8Ut1qk8yo4Zo1iVVfBzg5ycGvQeBSfhVea/s7YEz3cEQH9+VR/WpcnLcqMVHYL6wtNTtWtb62juIGIYxyLkEg5B/Oq9toWkWRBttLsoSOQUgUEfpVKfxn4bgJV9ZtGYfwxvvP5DNZs/wASvDsRIjku5iP7luwH5timozE5Q3udfgAkgDJ70Zrz2f4rWYJFvpN03oZJEUfoSan8PfEX+2Nah06409bcTkrFIkxf5sE4IIHXB5o9nK17B7WN7XNC51u/sfiLa6ZPMp028gJhXYARJg9+v8P/AI8Kh8UXdzc+LPD+i2txNEskhuLjynK5RegOOxwar/EiF7ez03W4B++sLpTkdSrEcfiwUfjTfDkya98QNX1lPmt7aFLe3bsQQCf5H86pJW5iW3fl8zuya4rwsFHj3xeQACZYskDrwa7MmuM8L/8AI+eLv+usX8jUx2f9dSpbx/roy/8AEBiPAuqkcERgj/voVzXifw9p1j4It9asLaK0vrWOGbzIht3njr6nJyD610vj/B8DaoCQoMajJPA+YVySald+Oraw0Kys5IdOh8v7ZcOQQwTHAI45xwM5zjsKuF7J+ZnUtdrrbQ9NtpTPaQzMMGSNXI9yAa861GTXk+ImrDw/HE9w1vCJjIAQqY4PJHf616QoCqFUYAGAPQVwes6D4pbxXfajo08NpDcRxxtM8oBIUehU96mm1dl1L2R1GjjURpNuNWZDfYPmlCMZycYxx0xXNavdRaT8RdOvrxhHaz2LwLK33UbcDye3b862LC/i0jSIIda1m0e7QHzZXnX5jkn27e1ZGu+IfB2qWX2a+vFukDblNursyt6qyjikk+bYcmuXfXzG69f2+ueI9D0mwmSdoLr7XcPGQwjVB0yO/I/MetcL4/vJD4vv2bDGN1iTP8KhAcfmT+ddFp3irwt4cjkXSNMvZXk4aSTAZgOgJY5A9gK4DWr+XVtWmuZcebPKXcL0GeAB9AAKvWK0IVpPX1LOmRfapoxMMrgswHpW2tpaJ923jz7jNZ2lqER39cKPwq+ZK3MCcbEGFVV+gxXOa0MzTn1wf5VtGT3rE1JvM8xvVaUl7rHB+8jGooorzz0govZPs/h+9lzg+WwH48f1oqp4nk8nw1s7yuq/1/pWtLq/IyrbJeZwNFFFQUFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVd0f/kNWH/XxH/6EKpVc0j/AJDNj/18R/8AoQprcT2Po4t85+po3VCW+Y/U0bq7TgJt9G6od1G6kxonhb9/H/vU7I4qCFv9Ij+tG7ikhyM/wnrMHhzxTLNfBhA6vC7KpJTLAg47jj9a7+f4j+G4Thbi4mP/AEztnx+ZAFcDe6bBePvYsknTcvf61WXQ7ZfvSSt+IFEoRk7sIzlFWR2k/wAVdPU4g0u8k93ZEH8yazJ/itekkQaTbIPWSdmP5ACsRdLsk/5Y7v8AeYmplt7eM/JBGv0UUckOw/aT7kkvxH8SXBPktaxD0jtix/Mk/wAqpyeI/Ft2TnUb4KeyKsY/QCrm4L04HtTXkwpPWqsuxN2+pjyxazdN/pF3cuT2lumP6ZxUaaCzMWd4VbuQuT+da6sQdx6mm+btY+lFxWRUXRIx9+4c/wC6AKlXSbNeodvq3+FTeeTwBTi9AWGrZWidLeP8RmmWEkNp400iZ9sUKTIWOMAZyP5kU8vVO+thdICCA69M9CPSgD2XXtM/tfQb3TyQhniKo7dFbqp/A4rE8M2Vj4P0iWC/1OxE8sxlkcShR0AA5OeAK8qeO+kUJNeSFAMBZLlmGPYE1LZ+Hbi6d/s0Dysoy3kQFiPris/Z2VmzT2l3e2p6zP478NQAn+1Y5cdoFaT+QrnI/HHhnTL++v7Cx1Ca5vWDTMflDEdMB24/AVyCaE5sJr4rI1vBIIpGLAEMegx1rdj8CXJ02a8UQN5dulwIxuZmVgT+eAaOSC6j55y6Fq8+KTSqUh0WFkPa4mz+gXFZ0vxE8RSjbbRWdunpHblsfiTj9K1NN8MaV/Y0eq395NHbG1W4YQRgkAsVwOCT2rK1zS49L1C2SC4+02d0qSwS/wB9CQDnHf8AxppQvZITc7XbKE/iXxRdEmTVblFP8KlIx+gzWdJHqF4T5t1cXLt0QyvKWPoFyc/hXbwWdvb/ABC1SzigjW2ign8uLblVxEp4H1J/Ouv1C2eS706R1t3FvqEJh8oYeFGjwd31Yn8CPSk5qOyBU3LdnhFza3dlfxWTWEkV1MUVI5IijMXO1eCB1PetTT/C+s6jr97ozyWtlc2UfmXDXD/Ii8cgjOfvD2rutUjW4+Jnhm3u7szx6bZXOpTXsyhVeMtlRkcbUO38h71ZK6TL4huPEFxcW+o6Tf6AUupkA8mXypVWRvoQ3I9FrGVWTe50xpQS2ONT4f3scV1canqqQ21kZxfGBQTb+WgdTknDb1KkcDAPc1xdiGd1d12sFyVznBPavQdbmvooPiTb3cmGkurQ7QNqsjMFGAeoMQQH6GuHsUyuT/E36UU05TVwqtRg7G1ARHAi98ZNOMlQGSmlzXZY4CwZDWdeLw3upqcv71WlcybvQZFDWg09TIooorzT1QxnisfxvLthsrcdyzn8MAf1rbhXdMg9657xx/x92f8A1zb/ANCraC9xswqP95FHKUUUVmWFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVc0n/kMWX/AF8R/wDoQqnVzSv+QxZf9d4//QhTW4nsfQRb5j9TRuqNj8x+ppM4ruPPJd1G6ot1JupMaLMLfv0+tJvyBg1FC2Z0+tAO1APQUkUyQtTS1M3UzzFLbQwz6A80ySQtSbu1Tw6bqNz/AKiwupPdYWx+eMUy/wBOv9MRHvbOaFXOFZgME+mQSM+1F0OzId1RyN8hq1ZWYuraS7nuY7O0jYRmaUFtzkZ2qo5Y459hUjpoMSHfe6jccf8ALC3SIf8Aj5NK4WMwyYQY6mk3BVyetXhfaJEQY9GuJsd7m+YfogAp91Y215c6ZJp4eK31BvL8t23mGQOEYZPUcgjNIdjPjyz4GWc/wqMn8hV+HR9VuRmHTLxh6mEqPzbAqW98QXcE8ttpk72VjEzJHHDhSQDjczdSxxknPesqS5u71sSTXNySQMPI8mSenBJqtRaGjc6HqlrayXM1riKPmTbKjlB6sFJIHvWXvrR8PRy2+t2T+SUhuHltmO3AcbG3of0yPpWJHITDGSckqP5UITsejaPbXo8GQyaJY2V3NOJfthmI3qwOFCg8HA7H29aztT1e+8L6XpFhpcnkF7RbuWQICZpG7HPbjGPcVS0DWdB0a1S9eC+fWIS5QK5ETkggZwcYAPcZ+vFNsfG8ltYQQ3ml2d/PbEm2nm4MefbB6fUdvrWfK77GvMrb2Ok8VQF9D1lre3YzyTWs1xFEhYhyozwOegFXrnVX0DSRcMvzWsVjHcR9wDkOPrg5/KvOrXxXrFlqV1qEF5i4ujmYsgKt6cH07elZ9xrF7cfaVnu5XFzIJZwSMSOOhP0wMfShU3swdVbo9c1HSIptHn0uwnhiieyUQySnCKvmFh+AFee+Ir6zOoadZWU3nWmmwpAJx0kIYF2Htx/OubklaUASMZABgB23AD0GegppeqjT5d2ROpzbI9Bv9e8MQa7c6tZzX1zdXCyI48sqgDR7eMgdwvr3qnqPj6ITrc6ZpCQytLFJcySv81x5YwikrnAH4/TmuIL0x2yMU/ZoXtGWNS8X6rc20lifsyxNby2jSCI+b5MjbmQPngZAA46D15rIGq6gNPOni+nFkQ6m3DYQhzlwR3DHqDxUE5zO/wBajril8TPQh8KFdmlk3yu8sn9+Ri7fmcmtWBfLUD0GKzrdd86jsOTV8tg10YeOjZzYmWqiTl896aXHrUJek310nITb6YMZJHeoy9JExaVvoMUAZ56milbh2+ppK809ZE9ouZs+grmfG5zd2n/XNv8A0KuqsxhXb8K5Lxkc3Vqf+mZ/nXQlaicsnescxRRRWBuFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAVb0r/kL2X/AF3j/wDQhVSrelf8hey/67x/+hCmtxPY+kvDywPr8QuYllhCyMyMu4EBSen4V0r6d4X1B4kih8iWaNJUWMshIcFl46Zwrce1cpopI1hdoySkoA9SUan6dDqWlXljbpfXbyvBbJvu1DBSIZvkbaBuUMAcZzk9ela1W1LQxopOOpry+E7OYM1jqZYKSpDBXAPoSuKx77w/e2MMkzPDJEgyzK2Dj6Gsq0vbvTp7mW2tra2kuJWjWa2iMzzKbmQszphcsvIHJ++T7VpR+IL3U7W6iuYIrfFqr+W25ZTkD5tpH3c5GOoxz1qY1JXKlSjYz4WxOn1pFfKA+1RwN+/T607PArpRyvY1dPW3gsrjUrmFJ/LdYYIZPuNIQWJb1CqM475qWPW9dmjka0Z44oxl/slsqqg9yF4/OqZP/FM/9xH/ANo123hOO9/sjRjp5j+yNNMdQzjJ6gD19OntUyaSuy4Jt2Rx6WviLW7Oa7ia8ubaLO92uDg46gAnnHtUGlSH+z9WtCd0D2Tz7SeA6MpVgOx5PNd1daTbNY2WlQarPaTm3m+z28RwsnJLF/UY4/OvPNNkJXUwo5/suc/j8lEXzIJLlZYv0D6XotuHWNCkrZY4UM0pBY/gB+ArYv8AQPD40PVDp97cTXelRrJPMTmOTIyQvbsenQ+tYOo+a9hokSKWkkhkVVHUkzMABXZT+H7vQvDttax2yy2sbre6tKJApkCEN5ajuOPoce5pN2tqNK99DD1zRl0rw1p6fYAbp8TXd1sz5e77ke7t16e3vVTTiAPDQHe/l/8ARkddNqvirT9W8H6rcw2ASSWZYdk7ruJIUCQAZ+6D+lctpzf8iz/2EJf/AEbHTi3bUUrJ6f1qaXhG1tr69vBNFGzW15FPuZQSE3SBh9OAa6B7RdOsLyMLhoLdGjAH8aySXB/QLXIaZeRaVput3Yu0F1dW13BHASAd6kFPzLNj6VtX/j20hvlW3k860uZW+2gREsY/KVFCk45zk/h71Mk29C4NKOo3U4FsPFmh2SHKm5vLv/v67sv6CvPIXzbRf7i/yrorfVm1nxvolyVdfLijtyG7lIpMtx2JNctbvm0hOesa/wAhWsVZa/1uYSd3p/WxYLU0uM4zUTybR71CSQN2eaokslqjcgjn86Zv3DNRM5c4HSmA5W+cYqQtUG795j0FKWoBkpakDZOKh3U+I5JoEZ8hzK/+8abStyxPuaSvNe56y2LdmuFeQ/Snl+c0n+ptFB4J61Rm1OygOJbqFT6bgTXfTSjBXPNqtym7F3dRurCn8UafGP3bSSn/AGUx/OqEvi89IrQfV3/oKHUguolSm+h1ZanwH5z9K4GbxPqMgwjxxf7if45rS8K391d604nuJJAYG4Y8ZyO1Sq0W7Ip0ZJXZ0En+tf8A3jTafN/rn/3jTK4pbs9COyH3l4NN0WW6K7iOi5xkk4FcHquqyapKjvGiBAQAufWuo8YzeTpNtbg8vJkj2Uf4muHrapJpKJz04ptzCiiisjYKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAq3pX/IXsv+u6f+hCqlW9L/AOQtZ/8AXdP/AEIU1uJ7Hteu3MtrouozwSNHNHBIyOhwVIHBBqrofxVBCWniBXjlHC3MaHD+7L1B9xx34p+v7H0PUFkfYjQuGfGdo7nHesKa70nXdQzbvFJ5ghQw3G1SI4p8nrxgxnp1IU+laVviMqPwnoZu9C1m1JjubOaIqQHimCleQeCCCp3AHI5BGayr7UdFj1FU/tcz3rxNBDb+aJNu4AseBnnYOpxx71w3/CP6ZqEdjKLTyFlWI+eucT7/ADCVAPGRtU8c44NU9I0iOC6026huGeRPKkuIvLCqnmxsVKnPPofes1uavY9Bgb9/H9akzxVe3b9/H9amzxXYjhZok/8AFMf9xL/2hWr4e1HRtLs1vLm8vDfQyM62SFhFKcYQkdDj1P8AQVkhS3hZmAyE1IbvbMOB+tZayCK5jkbhVYMecdDmk1dWGnZ3Osg8Xww6XE01gZNXgikiguiflVXPJ65/T8RzXO6T8kGqkckaZP1/4BVjUbiXXtTe6s7KchwAI4kMgXHpgcD29c05bOXQ9LvZNRjMFzdwm2t4HPzlWILyFf4QAABnqTQkkNtsg1B3h07RJkYrKkMjKw6qROxBrT0wTa/YXc+ra1e7YmVdrXG1WBGTkHj2rOjuNN1LSYLO9u5LK4tGfyphbtMkkbncVIXkEHOD05qKSPw5AAXm1W9I/wCeUMcC/wDj5LUW0C+pV1BbQXhFjGFhCJj94ZCSVBb5j7kjHtWjFOtjb+GZp/lUXEl0faIzJhvoQrEewqAanpUIItvD0DejXtzJP+a/KtZ99fXGoXb3VzJvlbA4GAoHAUAdAOwqtyC9f+H9Yj1W4t4tMu5z5jMkkULMjoWJVg+NuCMHrULeGNThXzL77FYD/p+vY4/0BY/pVBrq58oQ/a7nyQMCLz32D6LnH6VVVEjJKIqk9SqgZp6iujdiaw0MSXUWpQX+o+WyW62qMYoWYFTIzsBuIBOAB1PPtzqkRKEAwqjCj2p7HNRsN34U0guJkk7j+FBaoZru3txmaeKMD+84FZs/iTS4iR9p8w/9M1LfrQ2luwUW9kaRLAlR0NKMAYrmZ/GNuoPk2sjn/bYL/jWfN4uvX4iihjH0LH9ah1YItUZvodp/GTTXlSMZd1UerHFeeza5qU4Ie7kAPZTt/lVF5Xkbc7sx9WOf51DxC6ItYd9Wegza5p0H3ryMkdkO4/pVjSdUt9SM5t95EeMllxnOa8zya7TwSMWl63+0o/Q0QrOUrDnRUY3NXvTo13yKvqabVmzXMjMeiiuaC5pJHXUlyxbOW8aXhe8htFJ2xpuYe5/+sP1rlsmreqXZvtTuLnPDuSv06D9KqU5yvJszhHlikFFFFSWFdB4OONc+sL/0rn63vCB/4nyf9c3/AJVdP4kRU+FnXz/69/rTY13SqvqadP8A69/rT7Rd04PoM0rXnbzKvanfyOV8az79SggHSOLP4k/4AVzNafiC4+067duDkB9g+i8f0rMom7ybJpq0UgoooqSwooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACrel/8hW0/67p/6EKqUqOyOHRirA5BBwQaEDPdpGDbgQCDnINZF5oOlXmTNZRFj/Eo2n8xXA2njTWLbh51uF9Jlz+owa3rTx/bSYW8s3jOfvRNuH5HBrp54S3OX2c47F2Twv5Lo9jqN3A0ZLRgtvVSe4BplrZ6tazWVvNNbSWkDDLKu2QqqsFUn+IDccDtmtSz13RtQIEOpRo5/gmBU1qiwnkXdEqzr6xMG/8Ar0ezg9UHtJrRi2vNxH9asZqXS7CZpS8kbpggAMuKdc2ssUxGxiDyCBWiepm1oTadqk2nGZVihngnULNbzruSQDkZHqOxp7eIJYH3Wen6Xaf7UVoGcf8AAnJrPMbjqpH1qGZ0jQmR1QerMBRZAm0aVx4g1e6XbNqd2V/upJsH5LisxzvYs2WY9WJyT9TWTP4k0i0yJNQhJHaM7z+lZdz480uI4hiuJj67Qo/WlzRQ+WTOmPHSon5YLXDXHxBuHBFvZQx+hdy38sVkz+LtZmJxdeUD2jQL/ial1YopUZM9QY4GTwPWqFzq2n2pxNewIfQuM/lXlU9/d3WfPuZpc/35Car5P/6ql1+yLVDuz0e48Y6TEDseWYj+5GR+pxWVceOVzi3svxkk/oK4yiodaTLVGKN+fxfqkoIRoov9xOfzOazZ9Wv7k5lvJm9t5A/IVSoqHOT3ZahFbIUkk5PWkzmiipKCiiigAooooA6rS/CUVxYx3N7cPF5g3KiYGAemSa3rO2stGtGgtSzs5yxLZJPv6VTt/EmkXFnCtzIYnVQChVsAgY4I7VL/AGx4f/5+h+T/AOFdFkvhsc12371yQS+1O1K5+w+HbiYHDuu1fq3A/TNQ/wDCQaFLmMzbQvQ+Wwz9MCsbxNrdne2cNnZOXVX3M20gDAwBz9alRULu5cpOdlY5eiiisTYKKKKACt7wh/yHk/65v/KsGug8HSpHrm1sZkiZV+vB/pV0/iRFT4WdbcEfaH5HWprTKxySKNxA4A7kDOKgms5mmdlUEE5BzRDBdQvlVxnrkjFXFNTu0RKSlT5UzzefzPPfzVKybjuDDBBqOur8b+R9ptdoX7RsO8jrt7Z/WuUrOceV2NIS5o3CiiipKCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigBcmrlnq1/YMGtbuaLHTa/H5dKpUUXsJq52+mfFDXbEqJ3S5Rez8H8+ade/FHW7k4iEEK+wLH+lcNRVc7FyRNq68V63d5EuozAHshCfyrKluJZ33yyPI3q7Fj+tRUUm29xpJbC5PrSUUUhhRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFOR2jdXRirKchgcEGm0UAaw8S6wowL5z9VU/0p/wDwlOsYx9r/APIa/wCFY1FVzy7k8kexJcXEt1O008jSSMcszHk1HRRUlBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAf//ZVFJDSwAAAAIAAAAwVFBFMgAAABQAAABFeHBsYWluZXIgVmlkZW8gU0ZYVFlFUgAAAAUAAAAyMDE5VE9BTAAAABEAAABFcGljIFN0b2NrIE1lZGlhVE9SWQAAAAUAAAAyMDE5VElUMwAAAFcAAABBbGwgZmlsZXMgYXJlIENvcHlyaWdodCBFcGljIFN0b2NrIE1lZGlhIC0gQWxsIFJpZ2h0cyBSZXNlcnZlZCCpIDIwMTkgRXBpYyBTdG9jayBNZWRpYUNPTU0AAABYAAAAAAAAAFRoaXMgaXMgYSBzb3VuZCBlZmZlY3QgZnJvbSB0aGUgRXBpYyBTdG9jayBNZWRpYSBFeHBsYWluZXIgVmlkZW8gU0ZYIHNvdW5kIGxpYnJhcnkuVE9XTgAAABQAAABFeHBsYWluZXIgVmlkZW8gU0ZYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFNNRUT8gwEAAAGD9OP9dfxvFEjyt/1n7OpsSnBaWNNCSf1B4eLU+2J4iKOgfn5jjMsuNHXFzbtQhTdUivnijcDAiaRTqv7NjIi4rbnQ6MG2Qna1t1XEHdFKxp3TDPSh/Jvmm3JvPiY+QvoafSdDK64krlcYXtMyCv6r6vfOUJtYKCKYCcjaelORmAzy0hWIAa25O1Y2LaLM/k506LizO9Y1h7ShOXBYiaIfEjWICQKoUZ4WgCZlv8TCX9tMfn5jjMsuNHWETaKt92itu+3c6VYlVYIpMdBRm6WVAp8qWSuok86tXn5+Y4zLLjR1DybJ76jyyipZD60ULwop5DlwWImiHxI173VkH8UlQOj3yBBmekO7/XX29PxX8Qbvjc6L1PfOdVYTuEoxESFJP/2bP1SzonPj/UVxsPlOx6XjlOUndl/3m0RdnPHE95D22GAyLCiRKJDVjX4nJvKlbRCiMtKbmhNbfn5jjMsuNHXFzbtQhTdUisRqx0nhVMyARajsPvcSmQsur/2wunba6g4NIdqWJ4b4vY7uz6uRA6sLfWeHtjsTsF43shUx4QNYX6Fpe4yDtEuwdyMbO+7rlr3IRMr/GSN5jsjctZVwC1Su44Ng3JvPV/m5A13hiElVUGdT7ds4C2SUgzqpGR15Ef/GXgogNw8X5/W2ViIXKZQZjBvWOL3ZZDOMVquRDrwysRb/AAMH8cDdtBZ62RDk+MHQHz1aVWkzzbvNFx2shU1bnEHANdjcYVFdmgB2gPPn+MUVmsPahBSL6xsAGtF3wfj2qQpmh6EeB4gQ7cK+wALRTDmEEzfNT9isW46t83OgtYHhLDZb9W1WbgJiprg17nwnvFapoHbXHopOyKhXSDbd2J8TRhWggMa6GJAE7PW9XcFf087CY9BQZp6A9rt0KrQoQYu66qzXp50A8EujZ4GJLO+4oumdpE8ZQW3uoj5I3bQWetkQ5PhKcvied3C6Yu1cbTthps3yf9CRSh0sndyGcR5Vi+KBVVmjijx0MAC9Um7XIpfttS5eYSj58zC8Ql5hKPnzMLxCXmEo+fMwvEJeYSj58zC8Ql5hKPnzMLxCXmEo+fMwvEJeYSj58zC8Ql5hKPnzMLxCXmEo+fMwvEJeYSj58zC8Ql5hKPnzMLxCXmEo+fMwvEJeYSj58zC8Ql5hKPnzMLxCXmEo+fMwvEJqdpiwIinc5eBDMH6hz/erph2PeK14GEeiXhsviT6GHWnc6oYpXhfkn/Kz+V88WeZnQ2j6DpVjPE9hRv9MY6GeEBqju2br5ffWzwR/FifoUxmMG9Y4vdlkGYwb1ji92WT97QDCfYL60P3tAMJ9gvrQu7MvqPLIiId6SfnkurOYyZhd8NeU/EqSaksWU7ELMdS/4EhKSNfuCmdg7krvHR4OrJiIsfouDKVobi8HmjT23PzZagFXS6qwLefood/8OKR5kf0V7R9mcmV/SRvUgw7VEZCc0l6jUDaD9SRtUqQbzFOYq3BFMaHef82qmZ1SGL9S9FcP8KQmiA17cDdvfP3sDH5FsGLwo5mZkow+7EgwJcYEno3XrCp8/Y8jtfYZibt3SxjsWOXY77b3TfZBGcs6k/znSTMlNqLkEK/Sxy1p0yL4PeQaAqCPy6kyFu8gmIBUx5F2j+KCwUJkqUkMXtn6IV7NayaCPNo+TL9yD8raD//Bv+2x/BpFIJPoVqpf8TaWyx81yH7W55GutwOEJQXfUtW/emjNy8S1vsHmmEXN2KFQn+CAotImBVAXbUkwjwCgRytfyI2VG59Clf2FUKGwEudfUdw0Wi/bNWek7LlIFBxo0S7OLuY7OUkftW4RkiFfXvbBz+9ew5l3Xuu8m15L9Yt5bnM/qw/O71l3Ssn0zZ1iAWhBjbMLqILCvPGjponCwY9qjFI6oY5Een3cLUc3Y05n1Bx8pvDIElCmaPBPMM9slPVBpKvBQoPafRuorCT9HSbg5N10G3STkR8goZozCbFH0FU8vJ7Slcpu8VsWK/5JefPcWe/ZfNG2v5wR0rnmgAXACAO7ArCMVtFo3du9kNFKjYFSZhENhssJs3jfixmMG9Y4vdlkGYwb1ji92WR6TArq4uaRev3tAMJ9gvrQu7MvqPLIiId6SfnkurOYyZhd8NeU/EqSaksWU7ELMdS/4EhKSNfuCn+C7nCdx68GrJiIsfouDKXP8ioVA05W4n6wvZTUhtAqLefood/8OKQX4FZqdnzClqgTiyUfva8zoCdLKVi5RWo68dYuZsSeTnwfjBogLpbNy5Qw7lLA67bIewff1LZFZk5YnU7h9atFYR3c4JnCqSN1jlpfMMGRIV2DR+ww+N4aL01/L4XenEyyX1UauhiDZnCfgpTFOdEUSXpBZDeerTCFpmZCcPg1cuQQr9LHLWnTEj2NGibKLyF19g5xbxUTefneWGPZE1Oavdn5+OkZT/MZfl7XGptHI/IKrOFMzgQa7+bT61zMvmNTOX4owilaS5luh7Lgt54pGV6RNCCGWRbF9c6zo5uW4ARQvSJ8NMkp/ndfFVTorYvjy0DrksLm9mayGAYsjv9iaQETIxagowGahpcwNDjOP4WAA+rTMcGkEsRG02bVDsLC23+7PkBRP633ZInAxmaHKFc16tqsCOfhOM7knWSiC7agTqSzYpM/lnUqRDK7UejkNNO4TQVLlrpNpCTk5iNY2Tx9etH03UeoatLd+mCESKw+Vsz8wab7mB254Qz4egua6dhH8Jg9ZBG7aLxcnSBw5iWU3DbbWT/ENDfVV/KQi28228FFPuRbfNG2v5wR0rnmgAXACAO7Ajtco2gcOJqU4au2Ese2pzVPnxwN3oa4qpRGkC2DgEyKlqnTZpM/KvmGeGyxy4HCnbdkzQM/zMXYpz/ZPTAB8cv/97bn0xNLG1wrGYG8Ratat2TNAz/MxdinP9k9MAHxy//3tufTE0sbXCsZgbxFq1q3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYpz/ZPTAB8cv/97bn0xNLG1wrGYG8Ratat2TNAz/MxdinP9k9MAHxy//3tufTE0sbXCsZgbxFq1q3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYpz/ZPTAB8cv/97bn0xNLG1wrGYG8Ratat2TNAz/MxdinP9k9MAHxy//3tufTE0sbXCsZgbxFq1q3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYpz/ZPTAB8cv/97bn0xNLG1wrGYG8Ratat2TNAz/MxdinP9k9MAHxy//3tufTE0sbXCsZgbxFq1q3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYpz/ZPTAB8cvuAKwBlbKLFfLoTtceD79/9konMYRkcnoccKoPEy0QL+HlKE6qY3Y8mHKVly45Qs7ouai4xx1la2T2N6gPYjeGKzlIidcVhGJQrOleLWEdbAVztg42yC8VPxJ72r+kDPP3CcU0rXWAWnVqrAaZ3x5/Ss+giRAoz77Sl7tWBjywcIcf2uvUuSrvximVbTh/dSDbHYDEwPod9DRgrnVbpbsvNNyaDg9PS/u2t4ABH18kwQqqyxi4lBHntE5YUHWr2l0GscQ31lwZHCNCF79qMqR0EBdNz2x9nM8/TE9EfhSw23vkyOMv/EXDYsI4dWv9466u0KQ3z/ZAejZARgQHPplnttimYTfOv8DYojreh9vwCn7NH2zbWJtPgBTSyZAAIlKPmeJgJ4ofzj/NuiguKmN97+R0M6S0H4Vf7nuISDDikJR0wOsYwatYXsy439Md34CfqeJd2XmBEpeNF05lofPb9JyU7qdlDwgQNnsR8SRZIqG5E25oEuP6dN9qixtjnAHIRpSeQSYt0UQYqVJpMLDrMod6VeZ0whgygF4GhlsvtTRhIRMeeu+PYBABH5Xl8g+1oVOYCjk+HDpC7DSoaby1E0yWzEYbI/6MahK89aqy1A34LyNiAK6PKXbNJuy6QhHhWnlGZ5wm1FP4/fHtwucvguZfS3tC18DUk7r6xkzIT2R5yL9BPxZGSKeJTCdi1olJv83+6/kZzOlJSI49cGSV0XReSrH84hbI9vRugvNQpyOtkUrU81S8vxLRec+aR+f2AfIutVcioa+WA5580IoJbw9e4CjXMd1UowsnLAWE91VR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe1/sIYK80K2PBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe1/sIYK80K2PBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe/GqRuM8+e+CusRt14/775cRCnKjVB3PC6jV2tYUCqd579yHwmGnMXz+iEsYBsXXeqHH2/rB8W4GLVZ75oA5qOGBL2oe97JqUgjTj7bolhb6v2b0LhBzAwvr11wvjt5dHrQcnLFlx6oGomejaaDNKgKG0PJwkB6vtrEW4dseBAr14RcPXd64lyt3b9i/WH0cPBIiEmVnS+QV2vfxHDQqBoEOvGEZpW4gTgOqCdhUB55hSGnWKnY8X9pSGxkYtoGZsjJKX5VauFkjfDWGaEJiJvjZ74Z5EUVQPtl4aQ7TB4Kz1Umja8NIVLawQuipnqDdulZ8slGIS5ZepcUUL5qgulyL5E216o4DU3onkNjOsLP3VAE6+/29C0cHJLN8ePewm3cLdsCaNkwu1A89iwrZQ4DskfCZlHreYQ4ezT2ouG/CWeNRuNMJ2rm2pOmkOosVkv2jpPI4tzvXB2/dXW5ISJDMC6beyz17ZRHz+OxnBI3OX6vItHSVwwl4HIvHIDnKBJWHNa3124f2IqQBYzdHzYmVWBHePY4zbYXR1m9AGAuPmsNNF1b5E5GKV+UdGGwJ3hNuYh4XYckAj4IQAW/KgZN4LyHr3aQWksEdmXPRMfe7KZ2KIVzAu2qyU8dqVyWOrHk0rkRNirDsXqZ/5kTDT9wIT1uyFRFUw62RVIpGyCAwW7HGbELPx5YOF2pr15HTIepWrO4BV4VZ0C/Hed5uDoGogZb1Ib/jG7asnDvWBnU1/31NHKHpc0a2L4kREQRDaAMS1o8wmttdwFZE4mhiTExwEMHrBR6hbcZR5ftMRA+z7F337lexs2kX7umfL3wt644mA16RslJ4vRFr487gQPHfSitv+Ec9qw6qbhBeLynaientj61ndkzI+l0gW+DDaHi1js0HKiZ1PK8sujLldPdBVWPewvm0a6dVsEpn8pOODRCdJfWoOh3AnxsK5kiWvHW0BXlRDxBNO3+hlcbf+//oD4Z2cjhj8bjVc1Ze1jIQy4Fd+XFGjhe71fKjP4QFGXijFAx+5JBO4uJGXCpZW/ZocNWZViyiqsU96iq13hs1qZL5loFSlO+mDLo1P4GxoOqZ68tF786CnMPcDmeo3lOsx4cYx8sKGnMekhXifT25m2dwsEbzhIbqoesyF4Wo68kSqTJFXr3x47U6CHif1Rs/CDXn6dwSTQveAb0mYEpzGS6Len3S1pMmk+1Y69+i9DHJPb+DvghbaLloZSBfS+thIxHAEZ0Fl8Pu+UKOjtw8NpDRQrRRnsrsueIPhrXStwM24Q6GJSRJowWJmJcxmNkMLCKontmNKS8QdHcSmEjztFqNoM0tgnUILw7wzxbkllOlHD63Wc4A82OI7X4EdkT2ZDphNYz1OJtY7J+T+FkrY+iTtO9rj2RsIAmhu5GYFOjuycfttjtIe72pserFz5NSYGC6bXuOIBuwUazTeHdVnsyjXjx0O6M/i91Qkhvp6MSIgXqyvmNjWTcuKJWxDaLRSr6+vEvuGFMqoaCE4wveXRxM6g3lOsFgNeETTtwgiau05YXvHPVCsqo0dwOZ0mWlpA8hCSiV0CJKHJhueZzAsdBFDUOcw8e0+84fS4iefpUkf4haeg7DZRSc9MUOMESskxV+egD5++YSeTcvwhXg7YeLhFyLhL0Q11F8oCMeWJuUFwRRja2lSySvr8rp+Mw2WgBT9uMSg7bX5ZmNGIHye6zo2du2AUPiOjDXjPfn6Qcjg2BpK3fQfmymfhDL5WnkRbN9X9JJqtEwbVf7hzHcDMptLpTWh3R6fcQKKAqBfeUAYpFZQeDz2gdaX1CTY3PWfYpYp1W/2TRjlHA8lA3JJp4j2e0gx5XahrMEcDXhvqXUhOMEMcuzM/FuVZkeskdLrwarlaUOrbkKKIJusMHsCdzqJh2rccGTOg/BBaTi88Zi25W+qQw+Jbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wiswff+bpEHKX8i/f4TvRDBsH1+AOlcBH1AwrlfH1Tirt98htPpmoxPTsDkV1ZduCi1bOg8+bqYl47LG8gjqK6z96Ux5l+PPFsFqaCWM4yKZ6gA7HbGfTjVg3aaAlP7/nHRsH20fWRs00UZL3UqVSeN7boZJWnHo70/HALic/PJASHx7rPexfvAwG0JpjKfb3/loFUvQo4y2CISjVCX3fG/PLTx71go9aU5iUUj2yziZWCN9G8hNOtA+cb++W+2ZVSQ3+jWuon30cAYdHJHSxPatu1xyGnrKmZAZuDLSZePW7ysVSJ/J5WJJLmDTIUyFjlYGD20y2PbrzPS81plNlnkz+ovQJBzZxeZcNDVA3VY1sVLRr5pqh15VIzc15HkgovDFxQxdzbPV5XmR2EbBVHl86jh7dt8F1ZIJbMUrLpc0colWuSAybUMsl1XG4IhVq+Rf0K/yllb2DcZe1bf9zmQ9CLAMhRosUEOIZV7K4h5jRIo827C0Qsl2IicfOCAvr+s5KMlGO9Ytdg215Z/cNBaAtEL0I1MBPlq3mHNSjQBEzrS5wF/z+ULVNJRzzrP7vqGgI+PKT7zP8FyKQUeGfgn91f8aSfaGENJGL7+DVAhJ8C6Nz7AassX2AK79N34izPKKydn5rVZ4Y4y3SpfWo5hP2jL9VLFwvyeedRfUFZCw0vquNo5aeB7DBALiFrBqsbTxOgCZjDzutw1dlKW3jgyJFRzGkWfjHgAAFgJcjD8LVck7H1Ut0lrpZBPbYdLnLU64X0k1X7ozNwZBkconcKbf88qUT0DNZ0xg/riW4V3n81E8Ts9CiPsVAKY8XfV2BM5HFSQDVYziR8XBQxf+Z5SHHoxzDXfjnoxwtvm8KSegHmQr05JL7GgoHSRa2IFM9Jl84Nmtc07znAc0LqTVUctChYs0snMnxepHv8HTtlA7nViBGRGJdmg1B8xyf8KvUihofaEzMi1YOlmivTwoLyyTogXWb2e1su7/2k5fv/sAv37Y+E+KqvpYFJjjeFr9kALgxxdHf+yGhFObqdQH1B+m9RXAELbHdoP4vC9znKvFTLUDdBZz3hcnIIn/zYpFzcR0Izur1TXG+nWe6gMY3kKJf1JtHzsexo3+vEvgEYbs+45FF3ZPDiJ/Y8VZdYvIVlWU9Wad3GZkcvF+59bDQeG0z+qg+rRv5EWYxNTm8A2EJZGrGY9z8M8fBnSUaxRqxuIpf1hvp8QYodXdl4cNP4u02rvazdB6wOSKvUP8uDgecGtC5z13EC450WwXdc4W05P6DrK1gAyhbGM6XnOboLUQTI/ictBblnEhfhH2wBRa7s/ukq/tI2566ODMqse00sZ+QhLH+QHjWKmBVogQoTuf1kevId/P9V/qAQrLa9jPg+BJSYwPbU+552r/b9Ac1VRmZLOyRqTAOVywehgvmGgYuHio6+PbQnKKhEtYMeGpVPZgS80/eL3+bh0ZLIZOxJ7cjakETGPyQGvxQSiQklRwXrHWyjaXXnaZawhixNP6FIaGZLZ/0vSdgLYgwm6SOEx38H7FjKLm7W9EkAszU8sZAHmQ8qCNDkG5XC8OD5zmEQkAoft2qv0/6RGVZh7JIlT7BlOtJmWXcMxtoZcULU2NVgOvnUeF5dPdI/yQUPBIQRRKLPrgcagyj5Ler3kbZjsRKtvTZJcbEaD8lz2Kw+jnhRW3whpQ9T5G798IVTDe/kS3e9aVDuHwDfgSnKKtPPYYAm0qca2MWkV+li6s25kGWftnGeTD+rqiV9FmCwpvDhGNCXYLxxDxaCfLVdaGh3jBokTfHFnO3jB4jVV3/qBZXIffYzyB7jvjj959sJLOdTbQWN2dqTwOL7iMeIVt7GARXVq0CFnEBkzw4OdcBboN5iKbg7PO8lC4fMAF5ZymdsyQ/6zcH6qoi/lpAZAJCHpW1s4ySiyDdOYhDuVhWMYuELv1tyni4dyCJxPDAr9EtD4dJMkJc7MRyGsOp5C8Zjs3ZlXoT45eMYT3jifUsP6TnuXaYJ9lI2D/DF40oF0khzU6NOsMN1B6VjIhdJ8yJ/SmS8SyoVUYW8hGJXvDX10g/TFDAphG/5pRPN3aVnCgKV3yTRUnIP3CLguPQKFzjdWKnFJjO4ViwX/hA4FcRG1zfOiS9i3DwAGUEFKTNJbbpMRRq2NeKlFsuz8uom86tZs82gqCWenR6aWpZCAmkpstwYdHonMU4FlhjR57Mmt+duG/4R2JTFULeJdLnWFZnNaLLkSzQ5rIESpZvoBselJ6q82rI7YbVq9XOx4TntsDqjr72JEs3Dn6uVtNfppQu5clVPBPPlYp4LNyk0vMUPkN+LLtEBb1SKbuEZXD5sD1wjMXfmEKg5gpU77ajM0QAJEuw3ST8p7et4vf2g06KY4C7RaKxNdGw3WDJj45EMUWqh9yV7RMLg///CjFzB9f4gUx8zwtNMUJGK2t8ED7wi1lqx2Bm/g9zWWKYk8rSZo8PVX1UZBJ4M9DFj9jsZUYtRULA31eQYKlBtnx8Uq5Ps4pix1tfZLK9HbCklNYJWs/7zT0gQ+CGWo2nSL5JH6l0TJrLSoOwDxTawbIVBlwu8PJ6K6GZCYC/nQbgQmV3k5PqMTwgauyYkeSi0IWlIH/JDFmgNm+P9koIczvv3HTsV9QDjQP+wYHnRq21HxG56WelyPfW+hjVWDySXT8tTc8tNHkpYvoSU8XbsbVUJBtmBMbcus5uD0ZFPciMqIg/U7S1MjhnHxRSATUdaBZNphv8S0pmlT+917t4TNWaYtZ93QBSI1go5ccjbWaSJttw3zaoAJb+9RVzvVGC9N/WCjizUU1JC0BcdelJCmWqeRVGAG5ZEzz0tSv/SpaAe27qkDLj+7zfe3dB7a1V1FmBmDNMNJ65rSyPQk/V2Ic2ojTaJ1KZZjdUMM6tI9I6SSvg0Xaq0z8AP1tBFokSwD/+7J0vZY3NlNRlpsfmIFFFftxIOWh+/WHdLHASoxK6d/CtfyJc1e6P/sTzQ4+McSlxl5iSSOj+r+ebwILkBZ41WfVT2LRXTW++JQgo/5MJrH+D9OBecV5+PX0UdQXrnoZ75gaHRDvRXISNScLQ0gb9m2Tg8g7RCotyVxR5FN+aiMDOYiIU7FCahyjTNKgMUdBjFrBLWNDV84ePQ+bO6ZrayhrOwa/le8IAp33Edh3ZPVZbpr5S/tl0nfdkhWtdEpyYjKY6k2XYGlB4PaX1itpC6TI7+x/sq/j8z5YW+dsITCRrnf1aw7TOCOdC6rSK2kLpMjv7H+yr+PzPlhb52whMJGud/VrDtM4I50LqtIraQukyO/sf7Kv4/M+WFvnbCEwka539WsO0zgjnQuq0itpC6TI7+x/sq/j8z5YW+dsITCRrnf1aw7TOCOdC6rSK2kLpMjv7H+yr+PzPlhb52whMJGud/Vrhshh2oxiiQQvqR1WGRySSYWA0M7mlKUjHg2uR+t3WsCvO0C4/NKoioY4GG5PfWwd7iIeqFyEDMCVKyTWQksy8ofGWXzzXIqZFaEKrn2W/S+5Bg251PEuSlz6xhFDTaH1oJTG4zsH1+AhvKaLBJ6FEk7a9QWqMe7TCzdPW9QW6Wop9JBqCBnGJYB1iAa8AgZzQPGzLbENso7ptbPUjQGJXYa6yTfDVPtKfRGquzBTSGWK81m6Mu12tIx5y4zxEB6MafdHu+wEmGdrOHk14ovNjI9Q3Z1XuwoKWgjw2uHzZ5F9BA6pW+1pn7DBp8NoGkcB6mJtb2SPhLpyi9Ak3/o6b9a15qPTVq9/ObCX3z2H51/j7htq8P7e/pcrdFJlfVKyyLf7dXP4apWmp7MdEyMJSETbi3gt/ETqFusEeDuvpU59A0e9MzZ6f9cECuuaGOOWJCXxsOXMOrbLUICEmyUpfqFLrmkZfcO7PeIueOS2sZOZqeUGRwq31zvrY32yQBBwXkqQ6FdYg/wCYx/fE5RbU1PQGB38HeiDByK9mD21Joc0/PqYeGokvdfel1goBgdGjhc4RPjj0fKTRPjuMEpCWpq2yN7rBGxh+soiKmMwdk8P0RGviuGdERP4MyHhcWrTeXcYr9oGLYJ2aQzWLoeFYc4HP9oqJyCJhu3HVpeZWZ1uu9cJDCChXUDMQou0s+HljmjsYCrhNttWhwmcuvAY6uK40otK5GJnblCI2lwBq6B7Fw95T/4Eb/q+q1dYthpewUAfbu49y4HTsGt2tp5QjdAGGjOEmvkeGKcRpGHiJECoRVIxy3KBPKkhx6vmqFbQFvTL9RkqqLxgFvrpVIzy4x13qOTTkc1cl3crO267pO61/LmWmrzT7tWgpqSybkkTYwhmZbzd+aCioYxZK99cG8ucuJOsS6vrFe56o9A4c0HWKZcttiJddvBFRNo0dV+X6QuFnQKCbgjuuC9vt3p0ihauj17WrfyaSnMHfXOWkRVRh6pRt6EY9d2DziKS4J0p2A62+McaFQLL3XXxVBwvA8rXBW/DT+s1NDnxZxOGeZwfaBTjbTNFKmO4bCNI2/VC+A7DBuPcEeI076/5fmQCHH/tstFefWp15C0SFJO+7sgQOU7L6r8WbSnR2TOGbdEPoZE6aA4e4cKMdwVWT0078OhooTSe0T+ingg9xnOwCEV7NWeYS9H8iDjVm2sC28rsBL7T/hAJUq1+5YUYt2W1pfBOySpeQ5KM3n8hg4NcsQ73tt1mFmdyYduMNVx7qUZJcPYc3yk/uI8oVZ+4Yb7ttFfk47hoci111rXtFOtVPfKXiQwu3B81K7Uq6hOGwJduBvPcFhJ06pMKLXq59OyQcx4j//7N6lVbWBB3iKkpD8ngafHCdfKSLXHNzINKT0mBCDdpWccQeVNe/WXuz/aN/UTnWTSKpZCh/cAaZuoZFAMKf7YqA4xV+Z5lLDAi0H1N9Dgl3U/pfOacaLLhNtOAAoFrZxBn8usP2BeiZThzPOW9gFu9LgHPi+1Ryjw2jsz1VIsJcVpgQ2YBwIrG3+OiLLDCYj/G8mQEXFcKjDrTUDPvynRLHmPPh21vWgWtUn8CcJS9vGXr48qe4+JSo2SYI2xBpujbZXuIGXlGLtv4fBtfzasNWh+IXGNpuV0cDuiBTBTfc2AYvHx6zxG3z/37edWygOnO7H3Cs+bAPIuazEZW4wBWAadaBzn9sJk489azMOFRjJD5RNwu9zSONoY7o7ojsPfFgJGkfkGSp3cDCRRWWJmJDO7xTqj5EPwecAksqAkzZrwKAF1OxXcy8btJ/L3Zo9Fny+gAJ0xx3iRKLCZWy1TC+rFlDbZ4V2CDE9YY2dSNk2F627/UEyisX4b7mdp12iQAjvIr0hxu8ONMJk4URY8/MT797MwxDfwrrqgk301QSSIGG+9r06ymRY5LiIyNWcpAI4MT59TrcQ3roJbD4e7RwhTnKr2Z8virezFhrB83woBsOGiis1uhUWoC0f/T5R2CH+uPDcqNmW5Tzpz0JhWupMedYhX0hlIoPwk+8gBihBgUONNFboyZ5x+SYaw+tqeaBI3sFDra9owo9e5MiWdCCz+UsGiZzGkzGxl9imyTv+6BrDwSiFWX9EDeSD3ChCJ89Ju+MRkC1kwnhTeM+IQI4x1Amgr9frI3TrS0RbvDNXecsuIvk+lOW2ZGB3K2CFpRAeM/+djINcwjteFbLi7INFnkR7F5gn4oq2EgSZCAjySMcGocA75jidbSIWO7RZ+xQ7vkIZme5/Y8u5dJfFV2Qqjxc/Am6DkiV4qbEEcswZ3awJgS1Dr+ovIpr6kRacSxMxmy93eJqcjOzYqHhglBDVhkT3PBV1PbOAngTbLR3Y680o+rrcAyTt+r20RgMZZ+XEJON2H1EVdGC/2Kky9fByFpBQl/kOPBwdCyNEI+91wYNFlClO8vYKeRBaZpfpQVmuJwyyUIoFCpPXNNzHGQg/yUBOtw7/U7U90+YeV0qmaQMfrHmlURRnX90/Y2CaFIzG1/OgzwHTvUtc0ilGxjMUaZlsmBncCbH+e33Cfca7cZgmABCfLggBo4X7GTan6ojJOXcGn9QXFm1nXEKn5zAcavOpY7LyxiertE5hx2+/PyiFwCEA6lKjyj2mjdsqN6ng2/Va08BPVHY6VjYJgytEK+owNS6FLtLmYGsisybq5LuMTMhW+/9JtUvgWRcR/oHr5oHdvWbGYa7XYUqDnqfKpUOreAjz3D9K7caIg89nLK70m0DsUYny5fUWVHVoS1r7TRvOzWZvOKr+iUkADBLVLOufP/03ybX/WZWYBIFx5vW7Hf256vObrxbcf6uftBcqIbY3w/Vj7L5sGB88czWmFfPh84RYZPBmKAo2vZSA52yoAr+gboMr+Q1Yt0yK35rKdpAwfd7kkstnTQsBvwAgeCiWrw6BmMwGuooeMEnzuP+N6Py4thFsc5OpC2qV40yOQKXwK6rd5n/T7EBVxaRjDc5mh8oT879/RSMZDeI1X3IYgjxamUFQoQiSgNrHHWVh9qzKH56SPtTTVKOcGjKUnM5kQeUyuLIWF3HCQgIzH16m2MDZVx/ZLqFfqH9L2ICOyNLOveuu4Cp8rCpuaFzYhkoziK1gxo+1KV6cxNKilU2ce2CupjbJTfp9l9hyfVU3NdpNJn7bDB6Nlo3f6oK+/O1tF1ZoiW/Ki2hfxZKUSLyi49TngGXt8bGqPM7DPpb+X9V7gdljBd1aZB6Hy5zUZwuUDz7KL/VGxpy4KZqYOOAYWf+yWhlajXvUwklbXD+NLmu7AbQJzAxd1fKCpq19LFCoVpnbNRPAE1fxBuZXlzNbnq6Mmnz07G5IoWIfQ9UuUXC62g5RVhlW9mSILQezD+TyG08yhx8npJRxq1mb7RkJwaqf2yNLEDE+WQv6EA9uPcTrd7Op6W5kmssWsGqizgx8mIxZClri7aCpV4aCgxtYr1UzT8q101oguxMz3BY0P0eyWG9Y6nRLoKlXhoKDG1ivVTNPyrXTWiC7EzPcFjQ/R7JYb1jqdEugqVeGgoMbWK9VM0/KtdNaILsTM9wWND9HslhvWOp0S6CpV4aCgxtYr1UzT8q101oXcqk0+5z43gSmhLkogel6605NIcs0KH+ba9z4LTD3R+53Z5949oL32Tx2oQCjOGC/9ZRH9AGd7L8Q+NJWLrAO/R1THivxgzz164K5LA13YXFWECNvYXaVOEzuWjAC8WX+K7gBRAGLhDXN2BkI5tUEvRSIcgNHN8+7CIM7rckrnoNXJigQ7lsPPUq6+bkIRqC49pcxErDEXUlqe1lXyPxyFY4yqiJtVBM+OM7vmBpFGNOUviE7sFMCQuuF5cvc4ZveHfm74QTGV5tSkjp8tm3X7zR72AAYXSf5IHJkQ8Alk5zRhOkuVuxE2xz45U4cuVpRWrY2SyAMkw24/As68NZ9mt5DQgetjyqy7uLpuMaV9/nKVui9HoxzSqwV5Q4PSxYIh1nI2diTrlQylNg+7oZhVExYTmdLpoBwYgDwxXolRc5nrhnjz+U3h1NP8PwedaJfDTH/53kL5h+VZG0N9Zhdmz1EkF+QefYsU/bSuciTKas/c+O7DCsBv9Y39vLhodLxodG0H3kgDa8QianxmNBW04QLpqX1hvNqqJXSVDiC1xFGjhjz7W4OQXiQL4gxoo4+czFm1go1CUdWaXeXAX2BitDG2/7KlJRmommy0StRsJvp//0zG+Qo5csst3soIDw7ltHTheQIy8kIcOaQ9OgWq4rudPACf8jD8tgjiiWkCCjXl6w/2SJMAgPxuSMEUiLkIBVuxUBU8/1NphcpxL8IBPDwbBYSL0+Iq2Rn71r/yHsmRDfIMnLUXVq5fDFoqfiyO40Zhf7dqceaTOV88mOOfBJS7oBXkaMCUfXJBx9wdccybjTMmd6C3Yc6JgrzrCZRSdZQNMOxixZNXATRhAphgIuaVKtso9l+BGhPudlzNaAX8aJY72aaY89UaQOwy/+BKnCWwgRkf4knq6g6U0UMLT//91HDrNR7GLRfO/L9RThj0zVgBFdDdzotj55zdp5GbGY8SXOx009/zNbQSGXpZIklT/rp3hdAS7LRw9yogefPMiqaxLuNiHpDEomxrBYmHZxwnAJ6Fy4dw3cUP24tRhHcCZWSl6ufC4sTfvdBd1Auz5o0DGpc9uVepdzTbUQnAhuwZCH9Q4KVwr23aoWXo11qPTkcp/5GcSJJDbYTQ+D5sErD0Xd0hm7SFFvu/omINQoTap/h8nvawvUr9pWOiKr2EpolTVKz9fmYNEn9viB3KmggvQu7Jrt8DvLm4Jg5odzvitF0RlT4Xbr5DeMQR0OhN4ZSqR+vvxngbv6+jQsAXU5F0kwPjvdbrVwgdKBW2O1FWG4+m07+adRc7uZ6ucUtqtJ0Qz1DB/pXIuy3zGlK/CX9CMi5dDUufBwecX9fZKMy9l08lwSdzmWc1vnuaF9PjHEl+jHgkNgJ1+BmsP76ca1AWUeTKT6DKko22DHYNGl+GWuE9LkRjUFovJxww1tzSKRDhabngj4wnVSU+5IMEANYZVNvGWR7alIpMLlIh3rxF6ta7F/aWN0PyHaCAoYAqj98czuvqL9BFkr1+GxX1WpM3Y5T+N2UCimcTz2r+0phgeIEygCLCSBO+/Q6oT/KKDVmPD4l6QNZDZsueSHN3/dyWEMeIa+LMdyGuJscHbOdFJcl/q6zoVv2rhnj/kCzPxo7a/s9PAq6i2akinK5snHq4Rn71h2RKmVUwUiQcinyCt6n5f4wBOUelWFpDqwkt2Ag6XXiLLwNaD/jUaddkiEmfIY5u2RZKMBjSly14NCenYKZ2KLAVSCLZuNa/1do5nBHZt8MMpNyoaygKwmfgXubEy/Gty7tnVEiB2OGCr7vkglE69W6mMJZ8dSqCkDeKbIFTIxAjMadNFk0xo4R6r545TKvjizO+0jATGrHnerVwsW+bm0jgG6cA3KGaCHGHZ170TkfPjyX2+ZpOZQBMhsjrNe6S2UAHtxarJD4Oy8wuDPo/lUC+C6MVzN339in61lVQzztt6eR/pKiLQxCtVKwnI7oQ7Ept/X1W86RIrRilpOhKlNfN4yYMpGYPYRJ5r9nEpq8U/O0V3KaCLDy90jtoqWZ/UyrSqD3/TrDOCQC/Gk/5QVvTqVZvv4lfglzJVmILSOyR5srWluEO+/Hw2XUEltWXVriprN0cnejPa/nwFFBt9DXMZLOHXkrJm1mwyOt7rwUiul5twF8gNgp8YditLwJrfLUp0FhWKPamZOHu2ndBtR5ODiF3PomK3RVrJEbVm444faG7JCX4aH1Jdfm29qDlV+jCTH4WYOmX7ALzGwqEDbHXl44Os7iju/N0INHsODLJy7RXrIxnNzBiV/HNXTzvv3kXKRotyAPwDZNZxiFFcspNg7WK//W4JuCrtSGlIdsIeU9FL4hMQx87juuGZq2wouBFSZx5MQ2osY5aeSUNAyj0v9OZHDpIUpLfVSMlalb5+v7hk+LeGKzg/xgYu29OF3EZagQqGzY1itNpgYKUML1NUWc3qY/6R4jIWoWg45hIbe7v4Ol79QIqu7rBkviebdUosLVnJU7USKOI6ge6wtzz0Wp5Ms2umvVr+eGbglcqCDvl9QhN0On4SC8iKFpNrmB1/CLwheXulPEJdzksTcP6/3mQg1Mmc7ECbwKDQDmrcDhBzaWUsvgLWX/vMJ7hqjp7yaxHYbpuc4bo15u7SjMcHibAenhlO9X+B1sNY7224DyieHt697elPSCM0zJvs6I0rencMROAztx83pgZXbExlXIkOt2mx7pMAMaXLgN/+K4rWmtfkRPD9E5aNjb47JXcWj8ddus3J6MTzj5gbIX1msCTywCiFOGsTpS64vD7BshTrSFdfoM3aIMiDnXza4q4pQSChoPdJDIUOqdIepS0e3vYDd8Hgx9ZrK0H0ZDxYKx0LYwKSN+lHwy9+ljnbaEL5Oj7gzdb3KDp3tpYIFUxVknuKVsOaE5mOOvaR2t+sNhLGWA+9EcxkceDkaotE7vKsIo7yEphceJ0y80bdRAWVBgKccL+o+Fs2KhztuZBDYWDVzpiT6QXV68AIbTjgz2Wo7HS7LBlkFG1YgxZ0+1KAcF0sTTP1dvtlFGzVVrORMcduxRdkuyUd8GD4n656rUgJw+yPG5WIZQJwhksXes1o6jqb98ginMWSd1UbZBvecXYeM+UoFxW/7ufBpbtGwqitoamItnpx1mB6BJ3niyhW6Q0KUSUnum8eObUaWIbX4fXCuVzQVEOHaj1U36PHGPW/AqVdJfc918M5WD4jdN3W58Z084y/4vQkdTXXAvF5N8R/STdy8cmkN0/6MST4nPk59ZBh7GKLnu6tlEo4w1hVu1yuj4QZdt5Q2hoFsM6EgWH6t+/RIXAcpxNbPMmTz5lV0wQU7svsoZTRzQL0lHUIfbsv1aLDi2KZFNOLF1eDFA6BjRLiMlTVf7XGtlJvuXtngRuSGlkjbUK8BMbVyUQ5LLxxQQGK/oI+o3a5mtrCLJgVjeDCpkLjaoW4VssVYf2h9hVa2H4Gsiciimdv/Nx01a3RCvoSahhfsMlqIYNUccQlt+OBpjcdW8zIoA3SYzefxbywMmFhK+bfcoC2A2kIpDKTUYNbGOhYqrMgCSpx3AdI7f4CwoSz8echcgzIOZEHo8pOWamfAKUcp/DCPQyaKuZvN2w0bvaOLw0mYet+pw6DlFKcazwQQt8zrZW3KtMd6oIdpbJFhY+6hITHnLksx5T78GE6zpHa9D9VPkKk19v4zpQRgDviKt7XcapvZ1tUGsVGvCldJXcmHyaZMwkUWnRA62J7pdBuhrbqybEVEABj1IAqi1eh9oQl+4+ixa0V0eH6NlNMYsSlrZNro6wYkuWgor+rhqT1hGnxBeORd/j0XW52XmHtjLiLshiQ4mYEuNTXzTiq0lNBio1E/mal2bFKT6aIsdBz/nws7fhNZ2K0HIV8KRxr51e2owM1JX4zJKCdyuMRPJ8ANSQyhY6KZC/UlaiJKS6WHjjSNLAmXQxYys0n3oTKWI8ggbjHTEIeCOWydUaJ3vYghbpkW4exetWYVNp9NNQsflDl6RhlDdnu3ijcE5PEyB9krBlJZR0mWjgqL/0xFmetHV9lVUe51ehYYe1/sIYK80K2PBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe1/sIYK80K2PEGN55Git9unlEguPquUytXsyKb1RMw3vEyLGH1sSY0T0HgpYKKph5nl0GPiqfLPLIx246r3Dq+InVp7Ej7JnoupqVz7ihCM6STyBqBlIY3br11wvjt5dHhzzQ6p8Z77wA6k6CMoBeQ62HAYoODs7eJz05VBMS4NscGXdG8xnYTJLSyLhCsvYu38PgPHx6PhfejXqZoL8rlfQlO4T7SalW+RBU/qCd9cs6h8O+fSRYm2v1cmBfiiriUbYfAb+qQ9T6FZshy4fjOhEs3sbWOGV6zE75mAtKBjljRzofPC4E+QUwux873yT+MtJhyZvLtt0yD3O+25gZG7VPdU7wAbooCRSc1xPv+Mdpe1KlPAYTbITMKFkgMQiVFdoKmQ8IrRdY7crHvjw2ax4izwkWyU/fox0bRq9r/xK9Hji92qbPaIGN9DAqze2+zz5XVKq5WVl0SpsInAkYq9P0M6O0/dCp3s6VmpM1CkWjxYsI6sek2Ze6CHSEEWYRGWpOtZ0IfC/ORRMMRfDByYzspSFfLHklTsDjXu9A9g5YbZPN4lwZfodmxl7h1dfNA11ikGkFYBVABewfvek7t9E4/NonTgQ9lp5BR07aNgH4qWnBM+7kQB/9Vb6n0ltf4cgBNC+LJMXqBgqXlt7NhNV26sQmpKb9BKD6yfgoYzcj079d6orfsZOBpMDHIxzPjgrMrvQRP+J9MYgr5S8+a9x1uNso8loq1v+I4ZbpDuLCZobo1MxbvxDtlizMBvoE9gTUEiv0GdUkV1OD5yC+ZNKFfMQfFBBAh7uXJXgo9cc1QGs6wcvnfQzvb98eh9eQg9IC7QrGWDWoNs64BR0AR+ccRZLR1zHYcm8AsiiemamHxtovsfZGns4dG6OYiGEqhaUS5G2Ut4l/+wya92KgoC0+LRHt9HRYCHqw9jrdIfwGdJ60RKoOYfThANkpOQom1z8HhgTzF4HFC7UzqeVUV9JYLl/9ZCJG2wXNYXcYoo+AolRV+kCYxlMgL2Vribio/OSIxD38nZX3AHS57bnBFHl19BpX7oEVt3sYi9mVTUP147VqtqtVRpZy94xIkK+9SU5kIURSUvqScnIgeyvyalAl2jIBJymd36coLcSRibiV+z5Q3WeItkhwJGnL2kPwLNdGLdt84aeD9/OCzQKVduGXczBDMHBilbOwx420/uUXex2GFfSSxzvKfNViM+cX1O3mN9B3fj0+swCagYeinlhNtaRaLRgcSntfDDRrL+49iTrVWJHAqAG4SPuS67UfOG5lB8uHhBqe0f6QDhjg5HMA8/ZKfWYN6NNeGnQuNFNOR5Xa/jo51j+vWjua4AFGvJmP8Z7re3uRAJ6FVCST0nDc9tbV/V/PXjOPwMDGf/TBXri6CiJ5Moq7w0JOTxR+fOFi0meGiHJfy0Z73VF+vrmI6zo6QHTOcaGS46tkJ0xQ5uQZ0VYXLoZU71W3c0PSIqvlOti+QWoCeMtzymnKD4P2F+YCys0nAAAhvzzecnWQfCeMVtPWU3ONBiqrs3KKlHoTf8Nz+b6qi/gx5p/3X0ppDMsTU118OZpSReytJs5gif3YKvelJHntay2R3G4du1LFIO9CeCZd+bxohRXrr6dtRcQxJUKF7E3YwcoOA06vayPY3QQ4RIV1aPmCAkBk7Bn0KnWyZekwEgnH2QJmXy1yrExjnp11MjdjC904KLO+Ds5Hr5C3p8LN+GpCn4E9sXkSbpSTea5CmsxezpiGs8FRkHnvcQMpkn71WvVWRmLr8fIyx0YbXSZrJr+AR2810yJBzDLZ+vQ8p84LdxA/gjpBNQ49P5A0c5lyFiuGj+r1bVWXC3+cBNIu5qvyHWhb33Fny5uwh7qHbVw7J9hjEhha3nTYsJedn9HUTwC8YBthGdg5JvX19suGxsiVL8wMeBlKtt/21dL4pZn02RfOOd27NnV1KT3iZOQo3xQ4aZ2UTv5N2ed7DdTZEBcsiTLSAQiZXzG+Nfu8arndxlSJYHpauXdyjRBiHerQpvI6DHhNNHk8hm8k//TYY0YR5KWkL0Aeif1Uejd9OEoPsSM89TIYbz7aviidj1CRy5sAtC4+8EBv8x7eiW5JwwSeIkrvVN6p/wG8pK0uWtlALt6a0EZ33IMKBl9+yKvD02tQMlQ3pc7EDz5pV1w7J4DlCvEGjIAvQN6UnMzkgHYfusdw5gcVzVOczWtR7wcTFuiF5D8JW0/4YdWlGKI9GeDfLncp56zJxnzWP8rBRZPfyAMgxr7nkIDPwvsSv2pTxsXimJY9hUVcAdr8wYL8CJYAS7v9SSzT9jA4r7i3aw4QzTFLIhIkIP3Lhj4kMxCY1jrnb8mrK4xOIrJQ0gwIxxKMUqYgfv0SOL2CGgiCUqMZ75y1TR4WP/iUiwuWxO0wP0EoiMHQY/xKkq8SRrQRLZVOZU3lmXwB8uHtvHFKXEy0BFdigcS+ir6/fr3jsZNBo611IiZ4q8egq1b8+f2V8fAXlF3sHbTkbtppZhuNoHV0tRNO9e7iWY9+vZpX33sE7jQdfKag1pl5FjnyqAsALSITpHLR3y0HHo3FNoACBWbsruH24caWxIEcepmHniL2XX/WItTH+4RHMVXbRG5M0Bc1DUVpv/2jdjXEK1C4P+WZSkfgNPnXII93FsdSxO6Ivo8MoYMtemu5ZWnzKI32j2k63hFTY/vHVKaBinXbC79qGPqOz9Pv4gRFY4AsgzOHrtBhS7x5+te4m87DrUg3Xud91dGIN3eKlfJy2ynG6d2LGguCD5gdOZuiDrIBB05FcLUwROONydEIPTXgNdgGS85jfOJOFMdDnjo/CJtsvWQF/nmfDaSe3cBNOIwgs+ox3QyuWk6cCnvZZE9E3bXTjOmkMJwq3uW5dyG1/PQtINXqtJg3l40a4Y67pUANj+rEa70JuAhLA6gnZGEDkjf5iJAZHNgyRvFdVOtzvKbkPOXH0QJK3tGVR9hepDEMLntY73ZSw3N37Iaq9x62qBHQ9lBvhlWGKwFnL7HEMRSav+cBZX4HSHoUA8/UZv3GzrtXt0WqaVmNhXAybrVNP4MmLf9vViQM7IE4eaE7HVZ3USOy2Kchr6e+6I1wH4cbfbtbv4iU/Vpnh3RxOsievXTPiI7w8+pGmLvl1p6jCBUXicKcYYhpI9siPSpyxh7cbfwgXEUvP980xbcfS+VZ2L9hai9dqRUhzUy133tSaFXN19kz/uK7O1goik0SnbD8G5Tw5jfKK+J6ymbDZcdn2NfsQRgrnnL06Ei+OnM3Q5fUyBi0QQrxBYr7pw0WsJwGf/q53v06rGN9T36wnZsY5qSuEJjgfYJ3JubBjsoedvmsFmbzOprhHS1i8X4/jh5JWvCA9Z9VahVUqUamKLsBoDLEPMeQ7Mlyn879vWkUTUU8JNYi2QCblXQbbaSzOjfR9wTqudRZ0CSN5RS0fpKAKkCg3OFTKaFiNm8tvdCDCra3OyUtb/9qPD0LEAmN51iSuc8Ph4N65QGc6k72CUZ797dti7MUC2h0V57V5LHdamLxYE3Gsq87AIcfJ1PZ92bhyxziFc9ZjTAGtax+ildNFx7lsEsy7gN+xpZgeCvyx4DrtWGeVpUAj6nRz2tjChunX5oX/smEbpQ6OLsfaherD2nWc/OaTgNSWu8Kt4tBwmUCbaYqlZR8btArpUM7BexI3My/u8iLwVITIPOORJzT/qdpZOpDYY5b3a822+0k7+IlH+5SfStvSzU2Qz0RBTxMSOeDZad9Ib3jJlylvU6B59nsZWdrxTuBqDt5p5qf+wFhzjheuPaWrjlhqt0g5MT/NiQg6NotgAK2fbcTGo+a2iD4GP8n4RrrWjpH/lRm82XBWASpisZV34yZ7lePjga1/xfexLpcTOqLXDt+2YkoaJbD5b4/X78deFebhm37G2nW/HvC0N0WcscHn1wuSUqI2YwtiqVGtueRwqkKXFawjfyRW5u38/o1myhckYb+mDpPzuQ759B3AHLsqkntQWG+019hjcIE8orvg/rSR2FyH/0zWT5j3hzolrxqTRLoMctB0Eb9f49OZ4x84/QJ1yB/0pKTrxXyd3ohQ0ih7UVw1uyiJc6LYQtTQDWfAiMwLOqVnlPApUnIQ7gMtRGiGg6u+/icgR2gfFmG6y0PvzV6ahl7Q+6MIkgkz3hnSriSjjFBhTiG6elmJYVWtA0zS9nKZSkqIYXYhn1Am2ME08Z1Kpuy4Y93cOSJLwMOa3sdp1UxSmibeUg6S+p9WFkNmeyTe7k5aWA7AW4FYl5i5bpFmxVyVrQjiW08cWbV6ChyaL2dO4GROGUzmgnSdEYkzTxZkNS1COc+q8DW+NCfK3rBLxos6ffwxSd4Tt+y/jEeEJkZkW2LaqkskM1nEb+KKFePeKAho03RkvjxclCIiiDHhzo/YyyBZORApR5F/5MJYgHBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe1/sIYK80K2PBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7LZux4Uxamud9qWdvMzol64Ip2PAWN+sob/pTMawK+55fscHEgivuQoiLHgamJiJWK87QLj80qiI3ZUC2sCW26/QZkYnh6V7b5suy4xi1xJX0aHvyPGPMM/2w2dEmWuAVG+nmAnVwttZ0U7gjAy6J4SJifepXASfeg3QOkvDbwnoD0JvL2/04DuQDZPSB/oPRm3sFaGk0HMcOZhFf0PPcEU+F8Y6PLO2JK7opqhREQUAnyCMG03PxzgHXd9Rdq7yxm3MwyICwHvNitdJjpeq0BAWuJozm79bIew5IW8ARSHljXMQwkpJCDR6f7C25kKTE8zgKDZdj4HqJqkaEqPs/8uKwRsyOuz2mHP0xZIxWEyQ3nz3pfV0K2PnGY/03TVwbtsfhXblriQI9L1dixuvQDerCr43WyYciiDSak+Ppb9zbLLvxdQG/M8MiQVHT3SVFRPobC+Bxjbl+j58q+PZs1SIPIYDh4aiCGz878WDBz1ysIeP0hpOtZYcyUlfKRFHtyJm2wDQCNteBngrEkNCmZ946HKawfsdQlJiWB9WhMZ1zIr/QX2dPJCzka7Ot0ppAh2hPCcL7O2+TlmxuXjkowEVlWmgnbbUfORPhJNcNXaxz7oD2FuPc5LYCbjy4qmFSKRTSnfWYD4k+aCyaxlMyHyGiukGydGl34b8VK61nMx0wX0lo1uLl8j1Bwae77CNGO3eGAYjS9gqpavhmIP/4wHsC9KLWDAvPSwfkn2EZcLH3z6htgeM+rh7f1H1oChscAJeY2cvHmIrzilpqA/cBD7oQN98x6Avo16ub3C667230+TuFyW+bhe3oLzPdQES2ZgNCIEu0Dm0BOa/ZrfHeQdMrhjD2r86fLOQGqMzpyZGoBOs8gpHK/yI3Vtlmq6QciDbzz58RPbB9YOB0rm2kutsztCdouabeAMG2zgNgv6171/rGRxSccY4/U/bvIA7+Q4WLL543WKU26qYazKxir9/q8RkHKxfhwazSlVyjmav3C9HpHUzCjjvysTpSPe5OD9C/ew9V4EaIMt+YXBlITO3v6AvyyPRyLv6R/9SWCF/xeaB+/ISizD11Obp9r+n74SfpKv8O6fqvcsvNiSBLlEfwfn+B5sNcYFG2RekgQ7ZZ6YUh45apQPRvN+nazuf6NEwU+3XAcSimo5hDmhUEeGlEFaSzGJW2EKvOk2Korh7owEtfnMR0Wz3VgbJMV7qDGNHBY/xP/hYOLToLxp9cf/oR7iKNPib7qCjZ4o+Ia/1iHOHRbImgMiveO+7SYRib5OEQ/jISoa8wR6P4Lk2Hg0dbJDwSVLfqRRNRqCZalUKvggpcyge9DDOpNfSFhw/PndRO2nUviyHQczEOKmwEMNRLFvLayt7x24AP+qYtKq6wiyvT+BVI0x3uEyaHW7l1359h7PZSCz9d/rv2frSdW4cXSZCFz12IEGwh2gmGNkh6nk26ShF3AhWq8RXSAJZZdC8Ik7CRJ/64SAofT9O2X1szGGGfIs9piYxF5GI2vWxNovAjOFSsoZkvN9W49nMybzGhiScbByz+Dokyg3VuCl7AF2fqOxZBF0BIel5vQ+0PJmf2H2Dn6uEOiB71TmbryhfbHl9Ddq34sQcmmkS/T/uEhv4ih40c2D2rWsQvTD3grbdlqwRbTdcOqYbiCrzCNcnZ+6whUp2mtTzps8GpD+Tnb/h6xAGfE5KWK+gNygvOqOK5MXy/jqk+pWDi4H/HELGpRM/9Z4nMah3isFKVmm1dgcT9LbLeiiDG4oIT7tWG4fd6PVGmpC0ypsbMMGIdxSIxChGYfIybWGZWN2xbRyonhf/iqkWTQs/o0YZUdn/GVF85HmlUmgwdSeHKCj10oQMivSA1TIREuZ4nA8jqo0AeXFqek8dLLez96rOzEeEaV82D2xR0j2ZxAoBwV5qwQMq9BwVyjPurHBCWA3Zst5d6/iOZHWjaUWShsB/rwrvxL18Ep8ZLddIqPQ8bI9GJqjf/vFftwiLSYf3uepcYYZ1u8/eFt4TRpD9rr5K1+hUCmDf1ETPWoYbSm1ZVSo4uQbbb/sqixZgcIMtAfcxs/f0EJV/4/Phw+nqV9Gl3uZ+30J/snAw4PDKI4mDGSGkykB2rFyu+2w7vXM8C2P1N5NCDTlIsR/mF84sGlQ8D+KI/nGCAHWRDBpnVabobAJklpT/29hIntahtOVSDBdNkIPTtfYmR6AjfXCCsy2g8hvXq1q2KsicRir2bm+5QEExepCun0usrpZQ8+iCLaDmkBlyBj9DIQsJNc0Sn4yhV53qUR5zlrLrPK2hrWzL7ysCB8wWtk2yKKljHdhn7snQ2m+yvvcPKFDiIG0miUQH4fflxyAE2a1XFceGcY2+Vt1xB3CnaCxNBb5yve68DjzWQVGD41T1PIhXTAXRxoS0wbDYtE72si5+XndUupI8tj4ndcCMafJQpzETaNx3f0WJWoeAMrFk4F4fcv/DBt4QuuQc42lPMjNo1iP2nr0gG93ZPQ8QZsKCD4VzNX5JhOMWnhDcFt/ysktQYBhUPwHpXmDjQZfsySH37LKViXWTt6ZbpHb7eMWTeWnJDJ4HQe8Y9WnwsRZJFdxFeQqsnq6b6st93AExbMtgBBvZm2/CS4Pro6GC+sFH3pZ/3goT9casZ0SJtYYU8zVviu+stW6ywljGdlUMV9W6X/Sp7+toU3WWYqbva+y//xbMbgF743MR5ww6u7sZSFyctNQnRejPZKE7dTXwbz1xbCyqC2CD65f6mHMoo2gry7H+hQOXJE27If6vgqS3xm8sEy9nBsp3gGfkKjPd0sd5nXoF2duf0enCandDGpxDf9NGxij8+ntlfo5VqO+jonaq/ksj2yRJwUS2cBrEhPf8TgK9UFkcw2ce2PQXVKXznLkHNBhtkvdbxpECnuZFaT2jtzyWlLm9RfCduZc08kKWed1rPm4BCgeBuch79GkaKhjG0HupKDTmO0XlcsXmo2ZrS2kjeZvOuLNzQp1+j4ZCK3m7PjjLI3Dhn77e1MrZVr/BCCseyvfQtVeSxR/l5nUKdzMVGOO7qkRdBFBgQteSV2HsKpjX26rbF1HbbIOFavlexzDFyASp1Twno0UMUAy9PREUu6na+YzuPe0FrfeuQ//HEZcCU0NnL/i+C44kWi4o67vIW+mFbcvxQi4d+jSHRRhPKj9ee2TSZzI2ro0kuXRAGKocsZG/8wHaVAc9c4cH435mmaP0hJMU+2gx/OqASeVY/ZvUiUx42npRNt+4960OeH0DIYqSyrDbfjEOYJ3DGfraak6VuYrYFYlyPhoDPIhPNFkilipK2echR9ryQ9uIozo6czU+JqoXj2XR7s9LTqR0tY6rINZ77Oq1vt35y/7oC6bb0PAAUdYghyNFi8Zy/Ei6nLEb/ShDm6co+w/B5cfKJK5nElrgd4O3Tcq1KZJ1bGkvFL2jQFtRtMLIKkXssfcP3hiaPC7rC7cr0CkyXuDb8yGmoMY9vCTRrwYHJYrpqT1tO2Gbg1PyoIKwqSWZAOdARCOygIcV4sDG3xqPv+WsCH4TE4mTrdrvnknOkry2/aGd2KSW7ftkWULV78bnlRaD1UyKLw/N+CMYRtVoVeHHQAksVbEA5AO2bsSYxYFY/TNChv3fi3H2GdFI4KUBSdFoV17RAm9zAkMPygtAu1nL/9h/EtUz6hKWcvenINSOh3KuYTSU3awAoELHveb6RRF5KACETC2GULOtEf3Aw05wsxLjyWrQF7TqIQ7xIKwUPdl+zydPGb966Zn6fMpaI44gsxFiVt/BC78OatLOFCZadC6wyqrUXGUcqJMFNSudQxIDNOvoT9FbUjEQRIJI4U3++nX52gTNBJgxLzRKWP4zAcDEYNVCRV8UCTW6VLJGEY1erJPNKwwDiIRz5tzIwnowPURZbUYJ9RJmDk+6dTrH1bXKGaXzWLKqaupQeN8hRUj3VkaxYOe5wm/DbPtsHVWXrHmMSGFFzFjKdiG9qRegBdV2Po8vYsndN6kfgWaYbvmsKSvP/rhyyhy64yHYp/381SJoyhKTUKaBYCMVMQEgDDlN6BMgQfnqttMvEkOpYBEf71VRW9AacIU+HJU7Qe6G3TNkUp2e/cNSg6tEHsw9NENKYuinXYUVccAyUiUmt/6GSmglhLYGJzK9e/mGIA+RG/ffglwh28el1n6ZX+3+Vno0bCJ0DJR4hcOiCaYmWmp1Z1LRffgd4C5hPWOAUi5I1cbHy/IM7e+qx0ngxDqBtii1CljOFoyIeUmgAAhI/Mu65Ox/yXlj5kzYAjYDBZa0igPCv5Kw5nrvu2e9vN6Josty7w2antXSZqxjzOzHuqkKHoxBdzrvIPDEMpboz7hEMZ+5WR/JGr0tYtqm75egOqOwZeS+2hfz6elFX3DWyAr7mNQbqpqTjcflvhoAWmsg9/Q+nOZIyEquZ1qjvOF9LyeC/AxAwKexMSma0b70p6TqWl/y/sa/AxksPwbBLGaqlvg2W8ChQ8ClXKLY83+jtGG05/W2z5jDEvLUrb3dfCEUY3bKK3gqnSw8XGxogosTobKYp+EweKUFbS5sUHT1+mG6aNk8kw+WHY8071vN5ELTeHiqXU+zEF8YWt1GpEji+B99iHFQ9BYMPcWG0rA31CU4eZidYyNDUUcycAjpgc408f7Geh25kZnYktexBUfsAOhS81BvIHmONzcOkWcGHgug3VrQMqgcYzKcYy3WxlDgZ/1h++Y8Pqv93NUGEkoRSJsMO1eTN2+TN13vq6ccQykqr07Km2Epstbm29xnrS1ts7TLpn2BguiiFMxHF8eZhbjGH3Dwk+AdLTNGIIyNylHUkPV26dmpDTDYzp6zT66QHsldNUPTrWskdql07sKUY2402NJXEF3RqBVC6UGCIPNeFN5ixNUjF4sMe2KXfiw73+m4UUUNHbP28x89/S9YbK5ddh6cT4XYr+p7MPSB8FLnMUM1Akt7ZrsgNt34sdDRHoEXGkXUxj7rdOboWt/hYxJRKOtpsoxhqd8z7/FQHLw8gmo52RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swq+vypFCAfVKhViFohBsqD8YSYVARtYlunvw0Zo27wcAffIbT6ZqMT0f9rhKFNPCSb6/dHKJnBli4HVZrzu9c6mDr8xPJwHlEt4qCxhhPJLC5u/1G/KwmhOdhc1I654fy/YSTaGIUYX4RTdqzjXmAw2eOBgwT5TvND6qLNdNtBDHzcVpe5TVmA5n7dOGvX3wh2IOKULXmRY0ccR3MQd/ntDiq1M/M5d6EK0HncS/K2ISIN/Tois2ytj1d09KpdZLg5ooDGU+o0QeWffxYy2B5JxeOxbE/0lpN256QHYCCXOVIpsIjX4Zq2cI+cII894+BmeC7lAJGiPgus4sYBNk0CT9XN2BQgNX7tLFNpwe9jP+Biwwhx4yvB6t73ITEQfwjb2mJ18EmSZzmDUy8tn6r33nFigK5DSTuXHSdQLDWHkdvblSc6e8cWI/rkU56FkLjx0lCMAWnQ10wj6ho/+P00isV2WVZoJGa/O/nSMUEYlQRPPJ5p4aQ2CeoEuLhAwiJCMhVGrYH7Tct3oOPKkUcUWh13Dvzi7D6ufGenpW4aI62RpErYmgijpnHYsg98hEEyDzMuN8HYb7hq170CQZZwdk7uQlwZ2joU4ZFC4a2CTiUM/TTd59o6/i8w3hKfdBg96tPNLoSU2dShw+SbHPertt/ZUx0mxzA9mvp6DV+XrJOaL20gZv8cTBYdZpVqT7o2lb4uYlsUi+brffSszuyN02egsm+H/H+QluAkj/Qs6hS81Flqd4+wei3/f+13rVlckky8d9SMiyi8xUkQwCLRi7IQ2cxUK1w48mFSoN6HmaiTyXHs6LNCeKkZ44VP52nrltQ3S1FnJ32dkpcepKRgPuLTTDt8N0lwiVGURIpH7Xw6hlXB1/hrZFZbBbxym02kCtM8Wgy1uc36FbvOagsURbAA0Hu2r/xDzQE1CPU/49PGboh8E2HLqNAgay0nEdViv9k90xQmOU1bMAN3q17jKxCZ4lbk2Q2HzG3q/bVcj4gnpRYlfbBBIkQpSJs7xwcl25xQh7EuV1OnqvT0OnZsUJ9/lJ6bhSYol9kUugnORfuJA379B3ga6ihnl04G2aDPBUtg4Rnu9EccAJG4v7RiU7RcTcg/Lgya8Xu6KRqYOy2U5ivYhskHphOmsssV5FcXTh1pxNhZriCKHnJZi/yz18KgFqp7pWAQQde/ueK+PpqeVEyagkIfIEP/ZNhgbO7Z9c0XiPuL8tQVZQUA/NrvfReZyP6IN09BPcQ9gVM8y6/HrggJWI62UPqtTooBY0fmQG9pF2IAU4gyopFulBWRjXury/jRSpkZpQAqAyNeCiPv14UiyJFlATWWRR3E/xBIoNlsqwGzjAVUUMQylLD41JLWsD629GdbFFvkBLTtYCEpnSIZT/RRnnPafSKSHECf639J62CO64XjsO8Qv1ytsJAtB71ilr1ALZ8NUFvXURECe5xRR4JctamothGyq+JD1m5cj3Dul39gRi21pDHpcC+FoW6cyjppPaR5cynN7ebqqEsXbRw6h8CWLx4VHzjsEvz8jV2M2rgA7xdF2XLZLMavRtKiQ0VTx6CBwloacg9F9YcHcspa/Y7NRlr+jT34AueZcaDrcCff4/6//0kLE+LKd6wbNJJTQwtaYmIh0iZSoLpfGNsgI1FKFoECa51VTHIPO5wAsBKgA0kOgGGH1csRGDS/TQLLz8dC3TPr/eM3oWP5kVz/7Emtd8T14CGe2AwvzmcLfblqtsL8uiZ/9B9eUmn1L5YHnDtMFT6OyJWAExmanAlFgl9wM2FzJaR2cxUf80llBW8pu0erpPHnaIjooT8COH4e2QRh4gx9n8yEd0lPPRmjbUEVxulMYm8OUe7fUAZxatolC5vbV9d9jsmUJZfvfgX0Ri98SSHfEDMEVl/4PmPIh86gVbMW69A0KCr35JBTJk57Fr6aIzWMuibedH/lDBxlP+hUD9aWRJscBS8M1MaGiu8EHilrfqO/vf4opaE8Vmu4Ho0k06gIU8qTx2bzzdWDYgu6TZoazeORaF5MzxUQfNrjrr5OEWVyHTbg3GNS3qEszZN+mgLxCmyLoJ7TGd5QYRCozG3+gilgJ82OzSnE/20iTjB5On9OrPjUtS8PvAfHeWTklcHp+9PajLGsAXjgdm7AJxGcNzja2o4DXTXwoyYbxqgib5H3vQdo1YEQABXeEOb2ZVtuRhFE3k/DsD0R2u+b42ZZnOxEvU9qjYT/O1zipXNpb4l6H4rV725Oc3KlmIQee4I7J81HpoY8m0aZ4JwedQ+MLlTddJOjIrmemG8qpXEnonJIpcoffu5NSad/Z4fZpsr56gCyAZBX8J/kBEqLYwaoSmjXtQpqCDA4eFRgjli6rZkiQ2JhwIB1IGYi1cYytT5OdE/IM5M84dgMRfc2cI+zXLbTzt2xDTyGgMIXBYcls7/ofsZn32OKzeGLCZnR872FadDA8mmja5FOZMXQsAr7lWDAEtUQ59clGF1VFffwgCYBnUQ6yxQFM9Ch661GJJz/jxLb+gVpHB9PXQsqOFUfFlNY735J5jw3p4BWiimBCkKkoXAmJDgIkAoLcU/PVxQHroyb78IVadoVPIcaKEmsyyGLGkeSC/Q/EbzZ7MYYrEMprQ07q/9pWsNHiM/jrqIVT7IZU3kZnTvGbntv0CT1yv5HuGNEijLaxAptWu5xYw8QI9dPZgocTiO4HWJ2FHnl+eU0D548pSe2FL2AnLM00aP/O1ShEbcJF3D/ActaZsyHR0jVB5tqiThSchQcx769wuIKSZyypkxJ6BRPRTklGilZFelCszT0X2EvW5cEZ+un51nFOO/IDJe06jimmsMZ6H3se6+Pp/ZWa9glZDJ89QXCiWNfvofTMNfd+056IVqQXThZAn/oSBEjBh0YT1bQuWLrRfoDL6TrSMLFJZUd2qtJZYz6WqglNyi7PzRPvXCYd2TpCM/Y26KBEIJQ2KkF9CkuV+BblUggF/Io6+OK+W6A4KXqdtRD4rTjReAcrJMeybKQK3B+wC54unKBNCuXm3YDfYE9jsHN6fM825zYCvh2NSmMoFNhXdD0JbLfHeUsNy5P1nPDtYcsUJ9lHkFwRO63rQhHWRolLxGR+Go2slH4JQpH0c5f1frLw+8NlwQVnhnFazIHcUu2ryl4yT6WMEiHQDzul/xACxy+o83UOVJ+Eh8VfxVUtC8m/IWaNWTNrwhn7rZIeDoibR0DZhWGGN0P3D2YAK0fvaIBggk3wLSfUGKBXrCxsYCFGfokUn0sjBCaTQN6x1tKXf8stdC1xYyZ18AwvMYq88HGvomqCqJwIan2OoMtMfmnfJ5BOP7jY7fgtPPMNZH+vRTaQmAe45zArZ7+VnnXlVp82Ut+SyCKqqrsaRY/uzDmSckv9dB15TJroo/rH2xB1vNvuqc3gyfaf8pgZi84uDsu341D5wjJcLCMA4oQhwElDXu/mdp8Hy7gy+7NSZF6uR7ih02uDrwFgh28U5IkR5lJqdiVerkmVQq43A30tQm5Io/8LIflxXCN/KJVKpg4knMguXAkVf3MBIgQqosh4Fkq9sEaRdJethN5zy95XT1BSC9Rx0DKJrMYxyywEFW3hs5doaIdzb2kS38T54pgL8RLnz8S//tS/VaFeG4hEPeR/mQSYvl6SGNj7p4EvWaK8bMZrIJNzl5PfeMlz0Zmioe97Z7x3ObolHpxMrzjIMxFROLmeZ/vpSnaU5m4+1zxahNq2IOuPmZxynW6xTVyO99RZtJRFE6V7GoOOxL/oG9IaLfVIrXMYsYkGHLz1vpva5IBWqO8LSB1zTyCsaeE/aQPWLCVsn8jzecVh+FucKNbEYQiKlKX+SemTx8hJi/aT621f6SLmguZzMAiRBjuFg1OEU4VLB9UScEpMe5mYESJEFfvymv5DaDz0jIsR4ci8F7x5R69Z3Kocak2LSKCN7nxhFoF6fJ2+iXYQkaCcR0dntMssMwAyRTCAec+OysM0x4ezcY3ylQ5jScwmzHNOB1VUrLyaZ63zCRYJBpLzKkbBsVgM2U5q7kU8VQP+A3UUqWi9mZO+N7hEpi4CQ9p1/lAjeXWj3iB1nSruRpEW1SKae4GxOmYLo5K85f2xt6eo4yIRuEe7E/10N/WOi+UyVBtv7S01wXDOYKcmZ1P9/jwrgi5ITc05TiHWMA3IKJCIJW1bDyz/lvoJtXHgeuNpBS9go2CN5hfOJ32JlYhW4Z7XxpprbZCumaMzk3/m/TZN+12qspN/m/3X6is0iNqbhcmKeFpk0RfooSyaF9ytONB1r6m3ul+lOU4vzQXy5nkS4aWNDZfFoL7Uic+hkGhd1391woSrf7uEkTHnx0aY9yqQ8IdA0llyvvCxrIzikOp7x40xDijhNPlktPQYJL4Rcgg/ApZIgHk+EMW0a12Y7cx9ZF3xxJNKROgNHp2CWZ1tJl5/CX8nO0/8hiBXm38aoUvx2oe3pmqvmW/HKFr1Zg0gr1xXBTSetI2DStToP76hWrsJn/ALtjLTN7zzYMgflHUAimlvTh4Kqq8wMUy5whs8h60I/ijlqCOqgYb7WBQcgcZ52dwZrdbPobhbQZYSefexI1Gn/SDt+85R7WSQAwZENZE2OfJheMGH26sAJ9J10O7L88z4kiDugcoKkqlUgfy2KimXU/Jpsp5SiSZfxH0TdTwL/j5rR/apTfzmqSkgN0kNfiaehlcvyVcES3cVu5sHzBbd2+qvAdyVDe7Eubw+ZCgoU7nc/P/BjjEDsnKG7wpDUCKspFWOfu1IKkFadoA4kdEO9/DM6C/jHVR87yrlmATc+FmaB/8bYFo2nHWXH93GmCnsa3ddeYxwahDfzUuxUxF4qltcNWM1V0bxnqHKm8Sjg809ThAs1H54OrcM0nAyJ8m55KpvLWiVcMMxECoEsagLbYq7t2twwU9du/MJUKvANvQNVGG2h2J2tWuXxG0KqsvyF5YJql7I6eUjYDI6EjPVeI0qgjMiltVzJo8X+uaml5oonF63Z7tn2NTMyjUTBVFhDh5h9bZTJQx6mvkpH5LfcbN7PBnBtZx0NqM/7qlpQjZan6M/nUvC2duMbIaS6fhLKXFpFHsniU6AQYYRgIdy5Fqfoz+dS8LZ24xshpLp+EspcWkUeyeJToBBhhGAh3LkWp+jP51LwtnbjGyGkun4SylxaRR7J4lOgEGGEYCHcuRan6M/nUvC2duMbIaS6fhLW6/fzlmp9WAH1hpHMWXvKKyWrvLlttBlyw1oN7KoMnX3yG0+majE9PwQpUr3WTrk14OFTHVsp0ZGyRGzTlAvC6j8fgtb1jZDOzXoBqvJt13OYYZXSaQaNbV/+Ij/ZAKJPWddxsuRQLWyQLEyOA9CRR143rEajn9diPge+ttqk9b4KsuO+SP6jgB/E3U53asN0L4N4Kxp3lkUUYgHU/zl+hJC24U8ldo9RXQfVF0ALLQnltYPtL/52nEBYumZhzrBVYh9jLwOtq9Wrpl4OS6w2vVuAFKVjfRullbrsIhwDO7LJCHDNAqLtazxQT1a/8ZGMkMbWHVT+6xKsmpnTCodVeKq/pEexovQ0/MVruDr7X/XmNaRHoEcn8mYOQvcZOBlmyiDiJ/x/VFIls3i+MQGZduwfnZ2CsmfjyJQG63tU4tUMoMC+w4ra6r28QISzyV+S5TpZEVRgmf5OOn1Q0ctNUBGkzfbxCSt9pQK7WwHv3cmAKmnqviYn54sIVfSgDiu3AWXtJgHLengQF+hJSbl8mQu0WP5zhwXV/Dme+BmYk1LM+hgG3IKr+AKsn5JyEOeb59WMl37bYE3Q+dBnr0e7HOXMOEBiPZd1y1Z0xCjJF2Easli7UFmrETe46lJmlMXYpjFpIzmgBfjLzMXrPM7MLfQoUM8q+f7df/LYz0nqg+/8SwCO326+0LFkGcyBMV+LHAvq0nshbDXTfjUn5VYo/G2nKhtsH42RCr3scYbiba+21o4nVOJ3jT+Dsq000nH0mnmuqyr9SJxuvb2WrCl9lWZ3gDpQyLxTOu41vdk3qwTKvXlyn1J0Qv2ojIbWYH97GMnCNOI/PA5OPf5saOX3S+k0bgHYmzmNi0C1U2JIiP87MBimhp6SFOzT1+xhtuKGyL4JONpRpREVmzeT8O6pw3Yze0cVgA05Ke0QuOG6fNqP+BOZhdqLV+Swc8eflEwsG+/GzH+bhajdR4rFvTYaDvHBcQ3gIVLVnpLvQ3qWN8ReJYBwoLEaJT1f50eRR8TyZa1PH0WoHjvj+xex79VwjAhLce4X0Z4aMkGL7j4VFiT+apDN8QQpl6tv3Rp+2kWWD/BGgW2D8OW7GlPXJB4IgBI6NtFn1dK573pjRJV8GPJsNDBvpdHyQ7/m1XWIdlpQqkBScS4TbHoxcMT5PRdRPKtNneSo7c2Uzown/9cLNhgz+H3h/P7t0L8WkgzTDJWeHNNMPUzw7s6hw/4RqD5+S/K3rL/4/Vn31uHDAIcpS0Yee5nZO8f7kidU1Kmoh8pHyeGz/bvUx+6rj6m3b4oP8TxsjGPfVrj6BIL+JSulWQP8QV4aw2MubpYL5Zq9idEdN2qXqZIPqpJ4fZQLLSvCwYRKisygsV4qtoID0QXbn6hWzFPcjnIg04E5aDJWHXfyfp1FSWjH/ls+x807WpWB0tIMy5sEKAtJRFsumD1fHP5k30lYBupy9wB0ue25wRRTXt4+ZSPqkCzYsjr5Z+OJ7qMcB5XIMql4xxW8WiV8XAV+IuKth76q8QDJcjiuvz/IxDPhS4S0IYC3r6ZOPNJNemqFw7hhaaTpw2pxAbnQpCyi/vN5AhOV/tcLkEkuUWPxo85yjmkuUW+GoAp1pab7JU3Uk7/xeQmZPkm5PHIT3spBiadGnelV1TfSsRcLa07DDf7PTqlGbOEojG1IOeMUtIOFiXz6jlWM+C+Zzkl1JRHgSTpxP6Doqwz6oFf7rBR/XNHbZDAh68uANa8X0PjapwBSiDm/I9whKvDQXDVljh2KUdeG+TU5gydRAABLb8VaLVBDj/H70MSFVJ2qswQ1zgopVhfjUXQiGkyYOB9bcrhDMj6bPAJoyehLY5uGRDRGI0i+KBA3uttsqwnCErpsTd6s1J5BMQHkxa30KOvZTO3c5ew/P/8VEzHkZ5w8VZN8fnM1ITsELb5MSHUfFy9Qum1DMa3PIuk3srb0b8wH2dFc6jcoWL5PgRJk9QEErNjXqQ7rJ9X2CLgNGCeee39TynipNxWFWf5e7vhfS4apas8qaWSxy6EKQXB4YXsgXj43CpkicFLcmFTj12jJqSntnP4ebp2G8QzlYPNM8jwOs+kTwd2q3r/ICOWUOGXe8GaTRzSR84ac1cgNUxhHmHqMY04PdRG6R4E4H5vHGZyVOMeI8Qr6Gh70q4ZfmUw1dcwBW9XzZQun+8w9mfhTSjSdtmkxVOgDk9kM/O15qn8HZHZnOLhahZn/YUx0p7Zhx6UfqGg5pQQbe8L0tFJQicwkGEFcdHNfQupNYCbngOLAU7AghBCeqOyHiqDf3i0hYuOa5NMbMr/zzgoq90D3NBbUM9m65QOT87dx3Ht12sAXvJ22d+s9OuHz5Ke6Wq0AL0dXYmh7wkeYdMW2rJdc/22R1LjWnTQiCuORb4LU9Y5T9oq+EpS+vlAGapNG0gUtpLtfLY7MhCMgOizkAtT/6/NXJ8BKeha/bBSHL10nQWMz123SaKjbSndj+MedEXCd8KpJSr7F16zxTCjnOmjzMr2/IgTsKmo4aGKxTgj7ixyvSOuaFBsRIb5+mIhiUKGL4yqAJJPAeIFVCT+oROYe5Z2n9zhoOP1q31xlva63vEzE/Xt0Nx7CifdleOdzP8r3y5MMTDPQXVxcNQihVe/VPg37wHkXfzqKYo4EYL4KpKELRXblo+Q5YPY90pmH6pwZFaqmYF2uaQQ4EM76jUkE92SiwNxrbKRqqQFSSiLtZC+4SpWDTzMhQ3bNtF6ZW0td8/16oE3iBEjEYQkKC8OMBt3B4T3bC9i84sl1alxGJPDwZmBZlFBjnB1eClGLIlbH6vND48PRMmAjDGDHY1d01boRDIQVvAGNOay60iWf/IEo0VdAsP9W1iL3uqnbUuRdrBZUrazYjHiMArveNFi/t/vIQeYEL5qju4ZQ23hiONCxC0LfK4ywNTgGC6NNclTtlKxvKkWotafPmMxldFnwf92I/mfsrj3bKqJkHVeLMHGnlZc1975gvmWZZTGsWW+YQKWZ2NZCXJcoLAXGmw4MJFPVsl9KvwiDlbveSrqi2sPc7JrLiNV3GMgbmNlhLrbL7WhdeWMG0D6p7z3kDMCq7iSakTy75YOy0nmrrKd9W24CjVkKao9aqy6i5ApIpVMnPp4Xq7G540UVHDu7wsPGpcwOqTTIoIHy+m5daguxD1N6xkfYE4Wgg/JX4GYzjK+0Qg1tIJFIIftNnQHtTMOBZ3UWXlB24vkfvCLFJDz0msGi1hHh7Q9TL+tp/7q6OEUdgRxFvw3EZWS1uSIK+EK87HWV9OkCTUnOa9xDycLX17itCLBYQk2yO1ApQV+WqRaslxXDlMZ6Ne3uJNWkZBeu4feeNu06xF826V1yQGCsm9SaZYLMw7k6GIp64mdTcnqg/4o/pih0JW++rdNLbRkSP720OxyfSXcFGgWyBduwUMLpkY4tx/+xpquJ6l8s5uA8xQW0sdiMo4hAlrDP/L3SZrkblE2CMLdHOMQOiuojOyjK/v14neakYkrfKVDlcfVJ5IjEZD8oFH1EU36r2C+jx4U6VAcswegN6TUMQA8upLflDA+SItHiudX9eu4xPoFzOLuPP6M4YsJCKrZJtkr8OBiLqav+oXGq44GEAfrdzghi8WyyDuKrZTpBR8Npey/9UCfoDoYYUR//iMt7AVKKz4TyrU+HUdotwUEPNhwIh2gdjOWckfUJWU6J9HHsP0Ho/x4PUsvQgkN4HuZai9tuCu9iMI0Mo/e7DeXe+X8SClsQdGt3s+sNpylcB+MD1sNLm0fk5RBHaqAnPkoqbwoAtSQIaCWvZc1b0mp9p9bKRsN/46H1nQ1w+Jn4aoEUI2gaYDzghEvMuem1wRkZVimaJ6f1Oz0D/maj5/VD2+hmHzvBJQA8QA+hxzgL/jTdFgbDnS170ncuiurBwj/a7GJH7pUfB6rKj3TblIJQWjUYqH6+pO65jewDz9pPZyXIoei541BaAABUMtl41EPW9UV1WGoD7hQWTQCvS8nfxP2i37q0wuP54dNv9TY0Zg80YgkbWMChlgApbrJUZBhl7rLWPaohKkE5TiEJGLOsgUsLW451W9Q6Y9Z10mmv87GSxN9YvQ3F3npJBh5ogeXoQA8qrusVPfYxe1sXJ0gM/QTNYglfOlbxKoOJOGFG5KSnXtJQvpUEb2jnsDumtW/xhzZ+Uf3S44ZkadlriKNbpvVGI1gDZctpgxMb38fLxY5u9sjuUednKadwzej2d4blgQnH7B6PAQx4yD4nejHQRSYtGYS16Iv3MQ+lGoPi5Nvu3lP47IhBBN/qXA9E8LAF16hSFBCJKuVnrcQAqiDWTxAHtmk9E8d6vOXdt5DL3aieimML8MpT3nFVujTw1YR+RTfBRNniZ3896QV0U2/8n1pgfsfgIBT/DpyE8RQIu756V8jWGTi5YjVKJ1847OUT3hw2+HJN90XEBVfTjfRStZD+L7XFIQ+uUrn1DUKFgESUioiqFDTaX5gEZ/XHBvR/bmcQE0r2j6gp55s93cckE1p76u/t2on4jrBdJNjWPCv/jOZ3mbTC7PHmKr/9JsWkjAWmMuxnA8Vkvy9Zj58TysrVTj0HNaoy7lm3+Jgl45YSJHnU1fvV5mDp2ynavPO/RLuaXPXWqZDgA4hx621vfoP/T+yeZi0vzoXM8tK76hztNrxNAZFvPsHBFF+93oJ84xXSzfBjaSCO1ZZozI/qu+1OcimVrAE+EtfdvWSLbNuTytChz5tR63266/t1SMPpfPEFZyl/Z6nNiNd9oUHjjV5+7ngxajXunSrTwv6YFqmFtUqJzHshvnZ5vXb/q/pIfYb7ouH8wszjyb6PlJYpdHvm4qAuk3uHOr57OK63m6lDG0p6XR4OjywBMDaaZReYAEaODCXkTz5e0CrzZHBWCRL8Nd2zhQSFTnBpq9iYWxK19kDFfXju+2GMTKO3ctv/R1QqlX4ANzJMQ8IVWYOnNYz4euPe1qanjJjrim5fT+WDDzfLrzXb0/L+H0iKRN1jeuCPiHmox5sSXmUpTVu0Oaoo5W7Q2EVyD98LXL/8uVUgN7DtUfRwSLzfT3zXX1DI36eKEdtuN1jXhj15tmglvpQjr2LAxyAQYYRgIdy5Fqfoz+dS8LZ24xshpLp+EspcWkUeyeJToBBhhGAh3LkWp+jP51LwtnbjGyGkun4SylxaRR7J4lOgEGGEYCHcuRan6M/nUvC2duMbIaS6fhLKXFpFHsniU6AQYYRgIdy5Fqfoz+dS8LZVY0sXUB1yQj/1lEf0AZ3spAvHy6ZJ2RH7ITJF9UH3uxp1b3Ev6EY6ruHdpC4ZuwA6SH2G+6Lh/Nt19WWHpt0722s2YGsB3WX5EqYbhEfz8SG1z+zgSDfV/BX+76ThFALBC1xAC172DC/swqeIhtMfB4pSnaiArneEsmWAhvd0/6OD08XgNNovOKiOZPyN148ATdfT56gGG58zTrNaySwDDUPkHGvKybzWckvqPFqvu1rHM61qYvwXHRxk8cjSIuHeWfqBsFZEf4d1srGCO/kteXz/q5OdnzhEsNRXVZeNisxV4yI+gwJ9XjkrZ5uyFFQfxBXLg54VCoGoWVrel2Dqj/hJ0A0o6kqzZ/AvDAcLgXRmul/4lEhq4dTZx5nW59mwjN9l9VY6ClbQ40q9F4RmGweIvWYmBqbmRb6476HzWGx4xlgWMtDDieHokTFM4xV/dUcNjWtrU4yKq4NHjUFHgQ4hNaP2FgDpr5z8wdFIu7kWvF7fMRK4xKsmS4PasjZYJMr9bdmRmpbYpcljmPhp8qCl+HIoDq8qV0l64GmhD9DIavTxOBnxsiPdf4XyRQNPoMlGsbGnWfMmrKh1Oj59PDZyxVamDw16QtX3o8jvWRBTNRPM/KZyhLKpku93+zV1OzYTJvSyBorsi3qOqR2ZWfPcrax9D8rUVP+fnb8Z114Wc6HvicZCJPpMTvdgN3Harww1iUxqrHeZ0PgjpNmwT9rhIZLdLMD5bd0OT6/YLyIm98wKDCap7W+epwL/KNXGSap9I3FxiG/yFUNkZOhw+yr6+SptQYVrMTtO5g6clD0/nr/SsJ9hrbnOHNO5gfbMmVNVZS2xy/FlTKtKogqOWpluNB69+U1K9B+tJBRk8SxyKNvkKIBgBC/iNPbV5l1M0ei0+7g7RrcUO4qFORms44uIyHBSP2EdpUkUFVj42XmobL2GiVcUW0unCeELa7q9Wy3Yz7ox7eSuD+kTHAg79WP+IuYAbCbGTmTUDUgAQB42+dhQsKUhNVYnE6qycoWXNJxYxJHdAh9O/RnG1Dt8DZNqnBBHxgZVM2ftz9x8RGdGoPoZSEij4HzKuSeU9FWfxC/ZUsDjdaSXTSo8yp7EPBUSF49TA/60NjQHLHERJpHsc/eIOa4ClXrleN+rEb3uwdtVbl8H64slID87q7Hw9rbIkL46iilCgJ0/Ad+kD7WyiYa2IK75PEiy5c3Jkv5i64yH4A1Lns51KZv2JRMbNTCAoVEstS8ueQTN2cAy1osGXV6jH0Sz7eGYAW/eDBr32hzN07AUskyd8Zu8B35KSTbBe4ISlTl7VBytp96ebeHYnr4dN+KoW4EQxvNeKXot07+bTSdKtVOX46pYJ2eG6uoO5Nb08PChHvpB99uFuy8pBsR3q3XT6xEEZNUJHP6KhlijRgAUEHB7a2pn1+o3ByjKNSIIDQDMFV6JMD2bCYPqbUYvENd5iH6ErSZinJtkpBy266Z+mUKGJDH0qWFS6ocmULfRrLZS2P7P38JahDepeHjGI354FuxD4CyGLV66chgj+546glOFFYTc+WELgAzoTiNM4I+0OuiCdzdU/ub4TgSDWaE5gypq6E3LlOMn9er58QTcU+JrM67/uuwl4+iXdmy43nsAPgu9WkEE42EDtze2rgJ5SpJCDPOuJxTQPSvryhSF34zD3CWSVv6Y1xxrJlJmD4WctP4h1HCgs/qwdehkMkN4QlQJfBftlDucYwgM1ffsaelaoYe9p1Ug7CAz8ZZTejNPzRb4smNlXfEUMBaj5Zqx8rmt6CTTA3L7EZSAaK19irdVbuDkVqGTgRVb+JIZgpMha7kdncbFqFqs/H4HwoP2vp/jbOXNUHYnsURaTg89tX3eMfeSo2yWOe1zchy/W+e0+cUhRo26sKBZONXVDjM4K+OOmSmSIDHnDoJOOTWMLMCnUSVQ2y1D5Uvgb4oUd5XacIg5a5nkif97TyMqcw45+inzdn6vtEarRDzrLFnREGMK4MSe3BIBcB48zyOVTlc7GQc0juFJ9+YY1q70KlfjW3grBhX0TfXdis4iEWu+KLkSphuER/PxOQVrFdBlsVDQ98rRZ2nvYQnvqxRlkDrkrXeCXWjJqWna/zgWNwoMQyUNiBPiIcnoGA9q3SB4uUJ2Qrsv0WUmInIXbQ/0NS5mMTBSkg79mkIy5If9VrVA3UKPTlpm1mTypFimbyg+hcUts4pXqjxAjRwc+1iwqJgUK4oHTg8xqma5XSwL/PsHWyyRZUKtLFqF2M5ZA5dLF6qO7VzEmxdN2hgZwe9XHic0ZgUp71gMvR8D78Pg6Fw67HqIPD24Oq3dCpsk2Uzih43wAqHqkRMXpalVMQJtC6aXj0XZMkBV4fLCNT/Tzbcaz3h8JtbdAEOJQKfG9l7CCS2zi6RuVvkcsfw7cr8qPMF3F8oISFWIXcI1RG56xtzayT0zQxQzq4HM6d0crb0ikDSQBXR6gXtTHQMAiJ93bx5bEBK7odugbdLgt/7DSCm2Da7gYyHuF4TmZbV3I4rsJL6vB6CIOqoFNKKOCup6CPDbipaIdbwcNpPCm6bD8U2QxyeImvaOuJwz0L82c2nVXdG7Bcxf1AabcyU0PGGOffYLWvzcGF0sG6Hqe+/odFnNNysiTWZ1bmcuHdhAEMw1TWPjuwl/8gCjGhkvB6QSkCOxepXWxkc8FVFwNtMRgM33NY4vfdW2tdWg+jUhCE0hHJnCk/mIzWxcoFXi4K2pQOa9A4tFWejNHVChYHNIdWPGjM8KcsxleGl1ad9SS0itjy7LDZ82HHIjvTGpWwPm8of2ZZv1QGIynfg+26EywBnxPJtYglHvAFlYw5ydk98tIZmz5GENB/xqREVaVpfestzRBosfCpq9hQMfh49BZrFBQP5gH2whjoAbHksv/ILmTBUHlgMXFD4tfE972iPcqeSRVR+cNPG0SU8SQyGIWNlagoNPTi75bc66xlzPzoBOWOJ7Efqkqjq9cAV2x1MlV4Oh3PClpFGUIyW0xyN/GEvFLm0Ku9iLIqx3AI8hjTB4yLDyPYa8sXFiVkltTopAoymcghuCOsNrX9At05PkgxxPnLxbHSD+eOHn4nokwzHnNW5mtznwEyjWtvcGs7WWwzoJYhDuLh3VO4KzpS6c+1+qcgvKjDuY0s4hf2jE5/BauTPLNVYbSiRhrsrvjOWN8uoz8LdNOvAAXsn077VJjaCpgCoN2YmPtfMsbIuPkh8TInPSds4EincKH7VpsgGy0hoGMntH1A8QIVOCS8NsNXWJGwt/TvB8vvPnwt7ByLfuq7FzbHz/7t2UtMJgnGcnJsjSnOSVSB2uUrcUh+S4JkiebYmlNM18Sgk8IGu5mOL5Qqhrz6gD2Cb03mf1qY2L+HQvfL7rBSob5DTWfFLwKHeiiY//OmwijJdVbFV4WAy4R/kYWU6wi3UUE96BRzcYcLQkgEk1JIiZID3mD4VMWR7dN9X5OC8CEMiqL8U8Qy8U+3J4Is8wzjWsqVP83be1SPR2bSMvyHpURTDf/qXKZWtV2lYiKyvVW4VWh36HaPTIAcbMf5hbLqtCFVMjqWoPzNDVK3HVvRMX8ewOCghwSQPbXcWGIakPQED7mdGoIJRrUBotV45M2GHafRdUpZdkqh+V40IyIqds/sDQU/UYNQh1Vq57+uNWEXPCr77YnZj11OhrQC/HICz4liDYrQcWikAEnQfgOYkUEg0HX3fyFHFCoZKC/EQjItaMTW6HV2b3lTMjsdbe/A9WYBiCqShLG0E5SOp7bY27283KAcacpgq+MeIFypuBRSnOTiQkE0RqRK/5lA4uJYyoM7BFeDl+ocDVpSl69UcSnUb3tzZv+iNYDRIoiLkZpm2PpZRvF3hOmd9kvbAAsVKudfB6s5+WRja+o2y24bOVBhUBpQ05QCxBnD5YXnApP19lYb2tanIPJ4d+9lcM7ILVxaFCOHlzFSNG7cuXno/8gUg1ErTgideq/aO02gQJ79GuD6ruyQPJCX5sKpdgZsIrvR2zOZY/GAqrhJNiK39XrhU0owCH9VUZE/6KHcGQSqydFNTSJITJvHjVzayoUvCz9NFzsrwgXZwFajazA0drqXJeoDePMsZGOtzyhmRD71VlxL7/x7bQ7xtCT5Zksg3PH0LnSyiQZwW3cUzmFu19B+0NZliJlzVmoI6L6jcCN+DJkgI2PNd/zyIWFmCmN8QSkGnRvCs4b7UWFnJXK0MaUOoYDFaR/McAQMLW+1H3dUjUwaslaM4g4766rzLu+iikNaABMLgUdLZFkZwMuFu3JuCLWN7/Kz9FIV/HpNdRA167WnUo+s9j+k7tjFQgkXZEL8wxgjFw1xnz66ghO2fuDg4lhs07r8qPtAWMLTz7M1wUIpD/kf0l9Lcujtz82x8MvVlgICkbdQlp6IpsfhYPj0zJzApVFs9vj6ZKyCSjFPf1Gg5EZ/GzXrHszTQbVjSvgnrJ+VlkPxDep55jJZHu6bYNS6JpmCfBDOBo5TEEJAZLCkVl15kpbz4oeIwNJe7cv10cXhheeV/WjEM3BXWOn2LzM8epJBrD/nkLUN8732OSy0WGIPHZM10YG1LjU3jEQvhuFci6aRiOO9WxTmfnFa7CVmzL01lsZUtPvnwdmwn6zwiGkBqdgNpbK3AwFFKsBwI8ee6v6HzyKcC2sLcUAuNWlmHMktiy77afIVfyrIdD+ur7Xe0gNteFIAEE5mBt1r6Kh6mlxCE1OV5waIIZbXZMMqwIJWyJRkcOoxuCKGD4FjJZ5wfe46RltfPKQBQw6sPGLcYS03ERvTVfC9nHapatPCl68t+7Q9i/V0mpa8QqvD3U8cgBm2/i6LO/XaMyuRwMJSSLS1m7l4HjaDp75JW5H4Eo97WsHzbavA+ovfWh1padk6d9SwZPvLRGf6NNTFbGvKx4BS6vFGid72IIW6ZKL7OXunXN8QtnblgcHyNn6sqYozXQ4TGDz67joKLBEtQiCBusijQjPqlliGqnURKiGkzk21y+DjnoAMp64JDAL091pvqAyHGEuayrTu5KvJFPOjEqwnhb3IgSFBIfTX3+/hnY/gjvB8dxAGrcx79dzSb28XcNEHvaSyr4F/mbpoJHSJAnZkHv5AG2fhKNvm7+BKL9jKk/dacbOYILxNeOa/l03t6YWlZpY5u9A67d56DWLY2gI6GRd45Dn8PmpPf1UZZDD8RgNwTRePLMCOjLJgXS33DD+8SPEUtzKocxCuAVnupj0OOuIBBhhGAh3LkWp+jP51LwtnbjGyGkun4SylxaRR7J4lOgEGGEYCHcuRan6M/nUvC2duMbIaS6fhLKXFpFHsniU6AQYYRgIdy5Fqfoz+dS8LZ24xshpLp+EspcWkUeyeJToBBhhGAh3LkWp+jP51LwtlVjSxdQHXJCP/WUR/QBneykC8fLpknZEfshMkX1Qfe7GnVvcS/oRjqcVwjXJKoCXwmj1UdviEzeG3X1ZYem3TvbazZgawHdZfkSphuER/PxO9ksPL40UNxKoHyxRd2bnXSb9f5S1b4R/R2sw1hKcR01XYmNkONmRv+tEkMISvbsH+k3zESRk3YnqWOMV0GFfyDynWrMDcBMTMt3xxNjhSPzbB75WnjuzTll8z+q4RlKqJ0ddcNo4dwT6t4M7UzjVaPhjv/I+ZfYk2IQBKWAfimdkoe4ImbFvZRNcZ9UumnCWLwib5Yx9DF3IGsADDh5/r2JLLNwY2e6Ioce/0rsdOEXNZUbVNm62izL5cOHLlhk71Rd2WbAHZBHPPa6FKPgI8MDANJy5X5uv2Ae/17ARZVx7WTiq8z2DA7KP2PCcXheXEv5lTR+fEE/D6Eg1xr/WmOmtW7LpU59m/mHaqCFmQ5s1WSmAbpCUMgaKmxuTcKpM8bEkbjYpWhReDGGeNLyvuhnS/SXCzjsNTjEJ6G+GN9JVaCg8En1gi5yL2fGwC0qx/xQeENAKOiOFYMXxQ+7aseJX+p0TEdetIQaR2zGHjJpfWt1Q+N0nfjRGQzwZF9qZXSSMJVi7gjrLcVZK5mUGAo+CC+5E8mmD5oObut531hbuqUOj0TCeMRZjnKrjBNI3b83E1TqJgEgzjBI61TsDkNs7advM+Qkl74/TK4AGwsbgpLUtcHFfh8DEbOmjORcMTTxHOQsc7jhj4wr44sTs/jzL0q3uf/ybDrMFiGdXGHwZUh+Rz4oOXkmCrYRfN5+P88D0GsD6eTaK8EILmaKCl57yhLNgNGFYNoXQ2/ztltuP5zBi/OfPImO5+rXxWX6VNJyZA/DDGSzkt8W0bAkoXLfYz/Wyl8e2tpri7UHLjQguchRYhjQcw0SL01DgxMz+jIpSkKAb6kqoL2OgTUNc/OF3MUqRNGomB9I4iN6+jqRIIST6i2zLIxceYwXHXFJcWSPa978wR0qJyhqoTz4nH7r3JcBBfegoOBXU0d65/GSZY5X+/yWfFo2yV4F5swHuKzWlUX5CylXHtdAvLgBT78uGgdZK0nsKHIWmRcGeh/jbH5zwhvEgosMWorKz/s51G22wKPGbWavy2/BMQHMhfJ/x9N9QczpNNJwS1mHlrEUcKATaNFbwjlGmFDDtHoUxxqMQWLbMBo747WmugDAyLoBuvn2lIG1c9vs33w2EWH4BC1LwKNHfE9+el/EUqfSVoAcQiSiE9xwUf/n3tzZzBpuxxdc0EUMiM6akiWCTh0ogEFHUdWXEs2Nex+WWoDbGWxz5lMJgJUvOTlm6lXB4JCuDddcXOZ6m3ECmmMeX/X+o5lbkJrQJTsfw+J2/WeYhPiIKOIcnW9htzKaf5Kzw2CJxHbV7SN0T8uxlKmv7yfNN1ef3W9YF1J9TAqypw8jlCxgw0+rWCn90tgXRtoii97Uy02Cp4zaz7kUDk2a+6Hv07C/deRZAGw/PFsgwUIo94IYU1PpSslXbpz1qJaO4pVLOoUXLbPTA8SPQ4rqeRGnxDZk1yPD+SHEV/cGTctYLqhJBBvw4yuQZ3yOyJrw1SBGPUjUpYdrP3W5ZeWjbqn4ldyxDb28qESDktrazojgkBNJshCoT9z+5IgqtrpiIoMzaCJDispgYdi0MbJyU+Sr/lrfqKKVILFnTv4P6LUd98gz7+vjUB1kJCgXD4r8dZ66Zrz5aX2rejHRrb4+ahHJnjo99dlqd+AACPV7gk1IfvUbpar6zvM78SsHtZqPC6Nw5AaZJAtT1drKVtGawxdYKgclCmS67yrV0MnsOE9Y9WidoeWT5VYGBQ/QvTnMNF77oqtQyFc8mzoeOClWl9xsNKiny3SbgcHrCWBOjLW7aaquq/ZXQes2FA18hTtQGcFWFmo8pQnYB1iLQucvm9iwQs4POMleZwvniS435Csz4uRXc6GE3dKGV1MfUxTnC0Nw+Mr0VMAWKQ5JBZXIY5DAndNJOVB5tm0cAFlECevblHA9uSYrP4OdXB2wSC2cWa5Fj0rVUQO6CcJ1eysQ2+NIV8Cz2oLPMVV2HhrpF4E2l5DnMN0rWchQQM0Nv7mxUdHnmNT7p2t6D06wKQ+0WeAMN1mRZArcTD6KjzoK3iITAsOlYQi7J6cvjp+R80IVSdMlHz3fi/CImRsUb/GOSJrEJfHYNZB7Zn0OkMFkuLd//bD58ZwU94VbawGDyWteAH/OWRZmf7CvBErPejeuFl773kRFgXrAyyRyunsOH5aCjfCSmV0P9OQgnNBkgjQfVRuOwQeKN4qa7NNrBjLtskkw6A7AAPHMvY7FCZfVjk4j3WwRQDOgtct1xHfz5w0SNkvJ5PINpeQJLQjOJR80154gkuahYQoxDt5KhGnKb5Z10tYeDbPkh7TLDGZ+XrCa2WFcFXzhEYQoDNUXfWjV3GO0NG+0DRJ2rmxTnGIYcqsOK28p3nL3MP411af5SQeJXl+3kRCDxrXTj05H3zz8BQ5OGSbzB+r+HaLxu0J0usXj3ZO1wXsgkliXoxrWwDCCnqTYl3NKLN18tae97z5f29bk5nzWLNFcJKmC1gYNsK+O8oMMdIDN6jRByHVnwBeFKObOvQXvXGoWZzDtAm/maasiWBLHnAVV3EZLRz+sRt0/JW+G7zOxy5Yc6Gh7VZBrrZ3dZ67dWqNPhJJAWzMjv+FB24tKd34wa4Of/T+TRvUhOjQ8DKBTtotYoVNF9DwsAoBTz9XNsqhPNj3/B/6jo42Lm0X/9NuUJXPe52VQAlfvfyxwDBhTO0ULVfm1z35U87izIl1lLggLrULN8LONMaQAteG+qW1n89WHF2ybS9iy9sid81ll70mOSnf+Co3osdNPDU70cdb0hIXzvrxBD03nE3dtmg31Wsw32u9xeAyLNJ87WQbvZQzwTnuSIABXha73EaqQtpT9UfoERNOGy1/M5FA+rdSJKtnwqh0EqluZPzMfzVUkNkK9WA/lyJ3PDdN+gY5W0zqHND9HqgjG5gTdqlQWlUrimTTWmXdFS8fRpWNxmnc4NcpTb86dax/D5m0f9vHqctEEI8m1JrmOmbtIJiuMqHfQlu9O4Bu6V7i7uiFFANmMSCNDdOZP4xACkpQktfMTFmps0NKvr51N4FgUk05MRrt21cbo28nEbxK4B6x9KeBvC2/jgq3abD7WwbcyL7T4PCsuULikAgSRFh6PnZPWxg8OSPFayKzsXKe9bqms/MDEPuX1G+/KZ0bCs9u+F7JqNyEx7GavP7rGQPW2rMd4im5r+vmGMCFCTcoaNMXNmAnBF0fgMGqosSEP2Yz5MRgWiQgeX8TkSFeqyA0Fv+MvaDVhX2a/12wjBVxjowpX6AVaNXmH6LNxp6LwttKNlBhZXvGHVZKIPNCMBtmN3h4hb+TOCcRcQ5O486jYSU8nIpjeyEVYLJAOKgbEy3zxD27r7gX4nzdlZjD3OtqSNCYfniVG6IM8KSUU9sD6O0NM2nXj3lNMAaQKePb6J6BO+fld6wu4ViK3UcNPteH7QOvYMZ3xrV4xbiDhsmNKd1NPz7CPg0/d9oJIAAa2CTDWZub2hS0LgJXbooJFPW8b8hoJSdnAPKvDOjEpkMXq7N+pxv25KKtPICB89hrBWbQnH6+I0S6vo4qFBrghrvtFCuwzkOM1IlEtDocUyr6MZWrJlDV2+zhlI6f/fdHwKQQ8YY94mE7exPKpgCnZNwh2ulILGx+PJ6TTIqoY1YD2v+tm6QGAGXKSRlmpAXPoLnnnKgnQKRofi7Tn2+/+1H33xlKaEXwaKC/MmGldpEhUTPvySlZpW3T2egq0w0o6W7AWNgzbTE7r/PLmmfZAQ89WyAC6FOhs/6E+fQZPtJ8TlnMUYb1DW7j4k6+DMu0JOYQWeCgD+c0w/FabsWSxpZaKimJ0fsGWSo4kJBNEakSv3tww5eZM1jZcB/d3zMNrcjZ7PL+YKvt3rBGvcrBBKI78RIVMrH4y1MYrDW+8aXcCQXySVlWexjOvSDjchKDsNcDGR9yQEyeXuYLdmnEWlh/XVYQseCbj/0xfVaehVeruF+TIyjYYveqss3iFFAgi/fKw5T12+mi4RxDjpiyw8Xg0K49rjbNbEEP7Vl3NumGSGG51V3nzmxJxOjPoDQTAMGyVGwsUrt206PmU2tA9TklFYTEjVUUmeV5E1HOU0CHBL+jZec60oEsJ8hHybN4C/57yluwzgVasSLjxQTa06Yd8ptai4cCGvN2tEHI1BeG8Cd0+TSzzzKoRlhfVUxvcm6T8R9ma/65W35XOaufZU/ib5iEZYMLYXqxYdXYoX43rMx6/Jxhi2BXhb12RCM3+jrhqy5iTUvRL+fFgHc7Tztbr4yU3dcWzto0Q6gvh8iSoAVGHT2BkuYOUQGrDuKfksjFLuNjLBwS9owiipa07yjEmn014afPwIojqcg7LcvjBnEbXDP8VcYjK5lZ8zRFT4GdYHJdUY+s/WBh3vjoRAuKtgiPDrartTyw0tlUHBR1DZndGzA9WAgsRWs9mbN8cx9vetSX17LvyjU4bFEscaK7XxJICTWJCce+cj4JPRMEZfQRyN8zx/krsTyFCPbeu6x2nCBCLAEp5bKKMpRWKF3kM7d1MGJgvWAjbNzGBrt72lO79YuoEa3gNmg6uz6BguwSegnMc5bIaQwVFMHqMruJMTDPQXVxcNSKGDy7ySP8+Nvm/gCNink7UexkCC64iQjeHjj0ci3nGvft/WWr706Fec82WvRq75x347LTjZtCSGwIUQ5ecl0vesGEqHT8zXWXfSdq/F700nEqm+lSUiBj9asoO8jIs5D6T5Uw4lhO4ZFWvGfMWKeOD6EU4inpTaJiYvCZNDx6uEpsQLHnDAZm+KVhe/UhC0PleVtTRPn8/BFj3dHWTtgZQvJEiOMvnhYbI3rNHl6y5s7uqdYXMKbteFpgOsZ6n/aMvKn+BPQAL/VSlbN0M80Jbupm+HUFyGWD1Gf5WgzbUdSVeEIhr9k6+h8NMkdFFNe5AjZ9k8Gcmw/iWqIGaOJ67sJAKbxHA+5Vm0DbNZt+kdSHv/cDq3w7ULiBJQQmxUV5ghDMAEVXmRcdbn9Rg6F/wdK8RIuN1O2C7EzPcFjQ/R7JYb1jqdEugqVeGgoMbWK9VM0/KtdNaILsTM9wWND9HslhvWOp0S6CpV4aCgxtYr1UzT8q101oguxMz3BY0P0eyWG9Y6nRLoKlXhoKDG1ivVTNPyrXTWiC7EzPcFjQ/U0IPTdQsPPiJo9VHb4hM3j028DDsM7TjW2s2YGsB3WXOLyleNlQZXkxa2mlmC0qVDcKEOYokBx2LHRe2tkQEf5re3grwnLO7EkE5dd9pkhG2giGsK/bHsgJvhhCKjyD6d9k6fvH0zecqW+gxdeiKALvsJuhf6nO1YE0AgKv3iPeRHkfoTjWTQa79TJy6antdRrQv6FeGACOHmfhVBArgKyK+3n40dKekfpdRfloxIo/cwiGsGqAdJmpxiDLBFWGAK/pHigh26fRbO7ZOr4zHypELG6N2UaEj9Kw09r1Q0Gjr2beRzDFursQD1VqHPbKonpEsQNlTvh5qtOZfkyO5msUngLP2adrpfRmdGmyvyuvFyQWeeIwVBUMFV3UWszL3s3SZrB1HGUjx8JJAURZY2YJcuvAbv9HLZ0+/d04RnRIXnZEAF99LAUtPczln93LiVNkVRyZamTnuoVQRclcdLO+8OKfHsA5rp4UU2fT7k81+qlgkEYVNQPXgVMx1YELD5lIdN0ahQn24R/6ijD/1qplaeuUxw8Myu7GBF9R7LVtK6SL23lI1aK0Oc8Y+r/p8E4QKB8sdZbJVDBC5CwHjsLfSitv+Ec9q9p6MTIor1A2fbl/xqUAvtX8qGc3kp3MvX92l+XxsZGmdkhgTNrhKcsgoVO7FMAu0VYRVTtQM8SqQpMx/yKkH0lzQx0Pz2rhn0ylitTEjGdTTFOnx7+BwJIasEXHEN/uxdbtisoORSOnDDgUMSFaX8rolk/Hl4hRzq976I/hHmqGe5mb1vln6sZ9oNJbBzP02+RBfVB6NSfnjZAjfx9OMtBaFTp1FzohENaGuJgFmACs3jutWn2vb5cIcaMBFFl5fzHzwasRMPZLjlHfJX5bfN+iRkSMpNvZ4tySuiCMEkJ0sOxvTFiXKqDBux6C0XgIPBqAJdTwLyDjVYJxuWhhIeKx/KityVs2BQzH2p2eGmYQWbPoIIazWeuA3KBBWOqjD/3TLl70DNOZGe8ej4D+aOvcuwzpc5jZTeiaA5PlgKfDnWhXfEVNJ33u0XgAl4iTcGgVyYsAQ6zwrR4wSzBZucUJt45jKG4J0WqotM9cKAf4VCHAgUQgMeb//+ZOSr0w786cqsTrgJPTiZUdu1z4naJHm6P3w6ovgCS6QUxUZVgb2ywn+JqkVsQzd6dutw3LNIeDRXkeIvTvuxzG2YK76LeDpXBcOLF11U12kS9fqdbaZKuGlUviRK/U4+lUrkZFQzLisgChVMlBYyH9+BPnU7FWZPxIs+ENfNL9kbxZ35Gfhk2JPj4AmjOGl+FQwOffcP7ySer4PKZp5waB1N1ctRubcruF3t9ln7BSU6rSsJ8VBGnG9DsW3e/NIXElYmT61c6e+FndfiBcziz3Uxo5GtZSdYT4pSGOzIe8Rox0DHxxrSBDqck9zJLO4PDjXvsqxgui1yws4NWM2AOAfLv3ZMyEzNRQ19jrsrfsjxM+b0AdIph+YFUVkjV4Xvw+79DGgi57AhHkUhX2QN+Bx1BqQib8U/NPk38e296LW5tLbDvjkHtAraOQ609M+nZdcGl6/BQ55FPkMC9DapxaCinntv2Obsjt99jTVkxdjhcO2mEYSBuloekh59rnZl7wX3rUE2BlaYbHT9Aj8KsN0wHApM1s4TD8RvsJ7a4LvqrzWGR56ZXBv/o9fh6N8PtoEo2bz1crUH0cTAPPCWXvA1WZG76+bpsCt+ky5A5irLGAWPdVdXXpCH5/1q/mUmTFvBgWTynZ4cXs9m9TqIj06Jq/U61sLJtSSyB9YxjcsafQCYpDNl22/z4PiV3gOtmvyTywmeE2cCU7z6/qbwDCRyacrm6bwwqGsY3tKgEfvAZw2Xf8Gt2OJE7OlSqv9Ai+EIcbG6BIqZMLpL50ZyveN1gmJRdaQRV1njs5o/COzM4e2fbfiMtZ1aJ8VjJ7OdieZ9+d2G8OP9aOcT1ow07hewGXM2QlIuW5u0x1kt1+B5FVRvFXtzjGq6TzO8Fsuxz6sUibkX9504di6oun8xavRLi9rGEdUPwfxEJfV/gIU7RT2TJwzPh3PzhsTcG8RSv/CJ0njvrJaOqngbTfyAslZPjLesmDX3sKnPs7Wv/QAzD+W7B+ML5HXDJmusVHgvvVI6Ywh3p2CfcOvLGFiIS7LQY3m8ZLLEauK5hsmXGK3joMxwmgn2FZI9vYElEtR5drPDssrVUFvH7sxfRFSa/clxTW2uvrKtDE98oNYP3ktAqkVfYSByWfazdafHwdO4BSosFeFCDWqkMYQXSdSYPs2MLXd3RXbMgivNXJxe8XlG+no6Pi0XPIyc7ERa3JQ5bcVt60BpxdUMB7+h26nJv7YZykgUeu9aPlhdKdrMeyxhmatCORjjVqNwRxjsXzBB0lHtquPCZJ9tJT53hsUsA+IxZ2zULQ2ulEzVDSLmcAgKBKy5zmrRDm145t2CaJ5hUdkf+AMJ4jqL+S9+A0qvwYsEKtWrm9veArrBdIQGiszx/lCuMAY7/+pPBfWWTm4Q2kJwzuFy/b98ETdZZjwx0r2dIwRpUtAy+ghhcPWxXhY+GkmpJLoDDQsu+KKnQ2XNyzMcD6Y0A8Ms9pTR4bhyEuBA8hhTlfcj2YVa/9U2/mexUKDGiUP49gN0uWM7oHFtwOJJw2nn085hmtbXa1mjlLdwtgIQxdWz50cxSaukjk5sVn9j91emTNtxhowR6Tb80K3GCH5j8ph+gk2Jc23UFd3w/UaxHoWKkbGwh4GEPoPuCGRBxQmdsfSd69eZ9fEbMAsy61jGw6ivdgWhvR9T93UHKRUanFPAfv9ziastdukgReBOJK0m1t5l2KYQaNJw/K1kJDdT2/88n4AMJHAkscfLqdBoTEN0dUOy51HV4WgtL4ijIUZ0ymSR9hpRZGXMYFcpKHgNrE1VStLtSl5dzjpSfbjyQGAV0JTcGrZNIVudDs5stAcjfVW3bAWLRRJWTca4aeS1HjOjlNRM2xcX9wTBnvLvZVXnxhC1IM+gGTJY0GPKbSjl6f/XK0nrHF1Halo7ffFqor2KI1ovST9ZoWJptGP3V4iNmzCodzUGtQCtNDxU4Sj6zXH4VFqVZaw9cpIJQQeu3PKsjVakULPgOzIjhs+brifcM8vRLwkoUc+Sfg1mjwfaZQ55MfW8GpwqYufLTwq2xknNrjR9J9IbZPAYS/rkTUNv062UjPF55yvPr4NT9SVV5Bn9sEAYhlWIsuMaOaJ8o649MD0lxxUpirHLeGSr3lHp0rqfZuGfxIcO89O40c/9wpy66FUP1PW/BpCAuKX5w7wOM/JXiV/ZhBAkNeCdMN5/0d2mWTyBo6q3BD5BQujINJq2OgpJwkTJjWsqH9F1BPsxZKj7X5Jd+ukj9uNLGyJNx+jjuWWh/BGouAQbjWU5by449p0sOrKavr20VnpiMIzghZJCbtq4P9MkPknx3JlRhCFUUYlq9h5tfnMAf1h4WzUGjx0+9OkXUn3jPidGkI8qKZJDGi50w5jav+E0whstPqZSykmG4HC1JkJ7ITsUAPFTal8vu75loQ2YvN9qIWWPBJaSGnVBYqd9KokMd8mt9Pjj7wzZYmZoQbvuNn5q7L4icrnaBt5DLUlTFsyZfJCHOa7JcA+RX1XZgmd8xetm9qlfDfZbqjoogyUm1pUWr7ebnR8oI3rkUeP6Ok9w8IFw/HefVXeKW+hTZ9e2+RVTCwtLYDjRq0WD82DT9sPj8eR7uI6uf4pGf/nHZk89iH0Vw1icVJ1ieEilXbB5lOoWXfHab3VeowHLeSe4efpyRugJudtZMqHV7gc22H6rrU7Fk3tAe53A6+KuQPhYC1R9hzh68ueonOSwksbujmFIQpHrlZXeaWEvmQNtSRL+QgsCe+aBimXl9L4CPJxJ1xW2eIZ3ZvAPIaLQrSVytssv0kB8KMPni1RWHDmQyfbH950oePDYOq220HQn7AdVMqQCL4u4BEg/36bJaUe2+5Gp+atnTsgbnr4+2l+5hdIKdWGBbWwjes36UrPuP05cSysvS0fUgFiGJ4DgZ0K2D+c6xAdKA/liU/D7VldjEL96n3htd9Mm8x5I+9MroqOFF7vzPEedok82ETWzRTTzC2KzblEHPmx/CCehJW5x/+OBVXFqz1VHwelEbHfHOJwLGk5b7cT4DpCVBb4+q0GBIl1FVUw5nKZl2DQNd4bD08pFupmHRU6JaJJVWbGK+h4knP+bKqm58zfi12jN8dxkn+o+2ygqTc+X9scV+rrqkifLzKigXLXLS0c5NQ0Kp1cSeW06yy+iGhn/SelEWuHBLAVDJpM5FOezlqUMokJ3Xe5+5gKFTLSCQ/g7+29/1As7q0El8tTGMpIK5wRXXhMzomfz0XfAcNKRaMC3Wg24cWv0ocnsMKnS3C6Ay0KzUQrMCV51qeB5HjAnD2nccmdj1wg/tfSeZq/Le2QFGJWElLxL94iQLzchRXW5sC22AN7tp2gBehdwuMgxFqc5LVORtiQyH83xrvwuZCwCzFD7SMpQz42KdG5imNtAskzyrlEAV0slFqk7TaSSGBVCD2kX5hO2paZTp1Jx+8gyMysuIgP9Jxe37a8/JCM3UcdPdnY3X/PJTGYNEr0gBQleFOMG+DIWeTIfFDHi6xjpRm0r5wnOViaRQKVRvnT/K7QgkQ7KFCgmkAIx/3jgqzbuHHv7oZokMaKKhvGTDNi11pmM3FaqUxdj1MH/EvCjwICYrLUA8pP5zXthSTVSBjb38UN2ykVxVP5slMJu/69PY/Ek7SkGG3XiNszZ/Wf7fpSLZM7/tWfJy1q9vcaIvfPa9MasQECCEvq5uWQvbbO3BM6Uh3jbafN+WlA4J8iCWFQ8/95r6CVq/W2+X1/OPrn35WZCnSWxhSyFKJMgQasZPwxuabN9OLum9TZkDLFpp1pP1zbK9dgZpISo+iyXU3a6+z+B0GH46uKZjP2KULbVtKhHjTZfT+lnfG1YxvZTF92cQu1Xu+G/iZ1nUitUZioJ4vtOGGceeYvdPtX+mod4S7TRi5LZsTG4hHAjWc5G9VSSXbDXrF5VrB1vVwoqp37i0oFbDI/efKI4tCiOy/wszGA4r7ozRBuMGA2SfNOVzacu1VxqUCaHEcGBlbB7UN/Lv+jh0bJKeCQVI+RjC3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYpz/ZPTAB8cv/97bn0xNLG1wrGYG8Ratat2TNAz/MxdinP9k9MAHxy//3tufTE0sbVvhUuX5rp0tffhRoAOLcX9HFymh8nCK/FNoL7pHJTa/3yG0+majE9PwQpUr3WTrk14OFTHVsp0ZSPss8x2+UhC/F8Ij+jQuqOzXoBqvJt13xFyNxTaRxNxbsOKZRf+vlmOp3GuRoNi2vXBJKsxO5RUgl//hT2cOCMSRD9h4R61u+3rDOykol203otKhH/oWts5tORDdbmwh+Bl1gg7ZQ5WgWR8YHLR1+Z4RGCYMsmVJ3JPQE2Fg8/ByMQ/Zjxw8G4aNBJJzyZKsOGGe9jj22N8oOvt3iUamndyHi6NuHOsQ+kUE7+2ZBq7WV9+zXpgRosJQEfOjaeSNB7I8Rt2TMFTzDvqbTlTKirH+nJzGpKqX5744xVWHfhaVObnVjaBXszHcrqX9G/iR0WdO+p55I1HjqPQqmPMcg/NvMR6ykh09NReeqJxTvTKrXIgygFNV6+QPC2OfflNfDKYW10W6FSlk95wx1mH60QJxEW4G7ivEzByTQrVuHpTD7Gf2dQpNsMyzKS2vzWKrO/ukAF2R9Ho8nqHQhBZiRuqhqyK2JjTVLC9MsP/KeMAfDBooUg1kg6ixhs4bYqiXaLWig6G/1UTYvDmasm+fMXIevPr1mZ+OsyS4gqLw3xY1A25nF0QdMQimTVH7TvKExqU5EikCvjOxjpeC5ZfUub0uYK+fS6kad3gtmh3b/Ex2qpaH2NJk1WE9NlKk83uXJSf7FzdZRoJ36Op5INF7vyXShom17QV1nJ5YD33qMNZfqDn34Qir8i/QJCRG8cjNiN+00Ne0dYEO1Sev0DSTRNy8Rmbxavo9WDFl334EtSudc1gxXabPTDD9coRJPIPuaK/ciXwpkfyfUg9HnB0IiBuzoafXQrGvRV0p6qcj5TLeWeRqVS1g475UkgRUqJCsqq4ADt+JfpqLOTal0asULHCNIOAy5qp03zxA48NkKrXpZ9gHjpVZ/Twc1IAVz1HxZzDkgfgLQ5oYsXinW98NnMYkuQsGyO9KNPKEG5LgAw9zzdcjI2YWjQRKVWRzIMWm48rRwu4aezy4iQnJgRDXjka8vZzTQ6cSdB8t4OGOJkISWOAEmIVA5yXSrxuohfCIsBG25h0cLCpy2fRx9YftDq2VvSD2F4O1YINBLOTtOOMdgn0PlHFxQu5KyIjYMAbNcEG0DaF5iDs10cRthiETvyTp3wpzITwq8tjQMIpTd503b3H3XcPxuues+FPv51QDzA0iqkJ+Uj1EknpBg08I3PBejcpL8zHHLTZX14KZBvo0GYOOS2C7pukC0J0oBxHyIUYuJAD6nPAcH6a56/5edSQnwITtpVjmtMMMxX+FO2RhcE5IYeGMgxKSm/fFFMhb4hGm0i5+9uGrLMyRMdzaT74TKCOkscrcNLvCj60kSNRblZE1B12xNKaKNMqBgxB8f0/AANEwz/HQajRnrs39V0UOWtAAV2ODiQkmT7MjzH8hgn8d1jAdP1hNjLHpRMJN4C0KQk2W9Yt0JeN38qPCmyF6YNkTTwAJMUjkI3POsUCPfA8VstGpoujAjZnEFhWXmLA6uHjNRGM4gC7+e8SzSu6AakguWsFmk6WiVFjefsoDaRBfiRK6q01N3l/I0lzaM4/5hvS0v257/ee69QIM4R+DThdzzWUAjPvi5f9KfLXhNh+OkI2xYQ9xWiDckXWw+DzI68Wt0wkQNAuO0mLxVhtU4dHYoS4CyuLWbOg3JDSH0jxCeSnWyGbB5CIMHvR7qvVMRKsh2UqYAppCSy8QD8/QfZAzpmR7EQa8fP1r0gksGqwMXMhDgYwA+JP6BKuNwg9ZEvKYLdIjBL1WscmoJ7BJaIX3eMOaODvwK4AataK8zMCU/qi2aUqUE5N4FlLldB57bFtZJBzdb/qryTxrTSJ/XiMsvOaRbDXwiWwK5TiMnz0CZGwENb42HJ3z3A+gnBq5J/pvpbCFyeD7fIHSAAHyRLTqyTtxYDBvgTVztmw0Peo2CZFK6V8cvpLBPTDN+E44oWr5jruJILWTKWB+v3HVEZYhzz4WUsmPFpbvMUeLcDxtqXR3iZOhT+n0uPiv5Pgid86eAtqvJu30runzLs6k7hXYpGguHmzqq1B9s8/j8PxPVfF8fKK68/63906i+EyH/pq9Tf2sbaJmGP33Uyg/BdeGL8FtRk1EP7Q/4U7D74s6Xlf0+VE1EoPcM1IceyntR0wv1q7/kXOsQWlUO1GmV6fnS1u+1RLmOjKF4u9TxXKm1vuHkv1vzYTso/AH8KLNVb4qAmpmOZGO5ndD2TXvZtkyMjauigZqVzwgaSYuORyaiWsfPcJ0q8FAY38V1XwAJQIsyJ5u5MCjU9VfpoHQagY3YZc/CdnYg62EDAlhVds3QQ5q5Dbdx8l/qO1F1Vy0jH76HsgHhlqhW4gMOzTzJcfmsQbpielWFLpId0/MVJQYLsJD9L2mYnaemo4Xu95vV9FLw9msmjLwnXYsP2CPysCMPl92FyFdECZtfJfdOlE1Ct+TYURvFL91DV8Z2lahAE/SVRDB0/KQIAu5n9sIQGJi3BgEriA0OJotb7ywEku7jiQ994aIbe8ZQmBrAldxMSTfVSzO0qah4WzghzPQu6aup1zQ+p1cAWMMF1FBStFCFWo3uArzaVRHgA5Uf/XI/Sah3ETW92oCT2cphp6Wn2w7n2XDc/4609eQgKoAGlzswVqq+LTb4+HkwGaZ+rviYWJfsKHsELPED5HaGbRp+wx7o7lmjb2+6I31zTuIlk3Jck/uvxXye0j0CpwcMUUmvX8iddiAWmwFVAeJRkJ5SyJqaimOClLOPMAmvfG0GOkJKroc5txpiilcEAa8RmC1PALytq2sOR/rFO1RvBogVuI1XGPeVYNbjPT/1hzCabJ0tHjmFJvkwADrHedx7rET0fBd7bIpt3BzLJmkdrYBq4kKyZ8+24+ZGRRh7KoguW0YmqAmSQ8zyFqHawbwMUnTdvA9OQKk5ycAeZHmp9rClUWQjG2iuUaBfG3pBTQl955oodhwrXeq4dUOsbSqZJMbZ1mkojwl3Kze/cfS+CYQV7CX1rrVn0pjAdCvCcEo97I+SsoG28mFDvPcjAkPuNn8DbD1PhNU25iAJImSR9zW8YED0ukEGixLEpmxOWlFnHpiiQFgjHY19eWZrv1KTHj1cilL/zExNCGV7kh2sYxlBqG/HIgI7Xy9XlYZePIJ+8r7/Z3lkJEYmE4tNjgWlIOmUH7X2Zh2ESq7gy7GLpebmxtaPev7nqe/S17ZEvURUEqdePriqDwlND7hmIwSOMSGoe2rDfktNjXSC27xpg5JHORN67ZVUGkPye5M273HOuGI9NCo3kUrOBU7/PST+1rjyM79itlYPtuoGTMkzKVy1eeJDwIrgNno9RLgtXHdtx9o+M4SoC4wWpt79JdyM2AUBTboLTmjr4PxjKc/n3LEgM+eFetIQjxwsE9j2Z0b65dtedw31NrwbpT5VJ3diVtAQ+wUYPfUwQjAcPx03dwcSV2Q2dFyTzA2Rub3J0A/i9Azv4CcnGThPBQQyF9Y35eUN2EBxJx8hbmcucgmzYDqwcSpLhMQPln8UXDku/Tl5XHpSQtbbIsxXTDaHcq1w9PinJv9oMQr64MoJn9T3R34vK7t7AJ8j1EVR+vxm6PYFi/Hz3alHln1BcawpLJ5nCWRXGTISRmpa9AtPNklKENZNwhhOyBCxWqMQnBWu0Bt0FsfrVnCvEHboxi4DGJwwY9aZPTVhEcTL884+0OffQBvohNIR1NML3DaD5elr09ijXeQgmHzL/K9CUZ8ON8e+zRx+f9fORnV1G+yZqI10mMPoJYgYfAHQa9vpd3mNqt2c6JXloT7PLx8s02BeJ1amHdiXqHLaSNgFX2nXHjXmT9nVh1bmCyxnxV2J/dkQ5PmSXx+MDcw3VUlvqnVblFFIOTa1HcG1qk/FmCzqEMOCP2mJXVQzaCSHaVvbkNw3k4OyR0a6q4YSMsTQNEveNGJQMD+hFAI2vOBjHI3ykfiRUNNOpL4Xb6YUQ2GdLPeZ2iLztUOmqi/N2vGj30rpCmLud6pMHn5dvDnEgZ3eCVWncXhPorbU6sJU2wAfm52Kz+5305r+30tjM75jxzg88GpymXFAhZkaOit5Bqdzsf3FK9fWfl+WkduAaxkDIJgY+3t93me2tKRuQ5ZZMl+o8LH89uCfv4W1oaNMM1N4kbUGOaE+mQcLCT4wqE4LvAsBSd2VkY7W6dZWVmKTzrRrbuqd5pns3ZdJtbkKZJNB5R7F6vlmykob1BWiUMxXFCOJY/qoSjtNHZE9mZX26pE71J3qkZnwsnmEulb0BWvZG6dEYfHINV6UHn61cUvFzGoTJy4LiPwOeAzs+FTls26yNFMcO9A7vmqYbrdHrgHKUrrnXfeWn/X40iD9TNC3vZ4NwY75/FYgvljiTEMT5FLy5zMzNqCXMqjl9Wo2Hhk1itM5mrOfm2f1vbxCDjUiRUevX2z9xTZiv8wCl/oyHIgLaOa41mhgd9p7u/EO0U3mHTjsnPhyr+wuKq1C98g+DFclUitwuN75OLLHIXJHGGY2sP6C0UZHiG39QxqqBg101PWFvJEG3BnVMkXpoS9jgNjgo9xG6I/tkw/rV4JuWtLixwNZz0YOMMHKdEIywmqkbrReO91d3Eh7oARQd8NHjiXCoDQaLBpF0jMQIAJ3NhM2HkEC9SyCOAp7t5QpVi8vZiVWuOUjgg65rSFvqrhxJVfpc/AAcaFKkktbYH5em56hp20X47rW0HcORyfClI24awRhreG8ATk5pFpvMZAmDti5YoLGyiE1tpCcTDaiCoFArPOl2QfxtTXfs/UCe+XEMjsZYwnOIdqF5PNMBvREZAygn9oH2IRX9y19CFsTBGq6IuaeD89UtDJHOlYF6ydX5XCQIOhBlUJMRsKMK4MSe3BIBaVfTIEXrU9NkJpGgCbYFSFmC63R2YGZUv5aKX8VGBti3/+gpbO59lkItqZSHqCkpOTUxFFMHguTIJCJl7NPsR7utXdp7WYdy3aNYdcW5e/V24xshpLp+EspcWkUeyeJToBBhhGAh3LkWp+jP51LwtnbjGyGkun4SylxaRR7J4lOgEGGEYCHcuRan6M/nUvC2duMbIaS6fhLKXFpFHsniU6AQYYRgIdy5Fqfoz+dS8LZVY0sXUB1yQj/1lEf0AZ3spAvHy6ZJ2RH7ITJF9UH3uxp1b3Ev6EY6gmlavCq3few8KsN0wHApM3rvfgJMm0tBjkl06XBWQZ77lM4Q1d7E+kNKLk6s5DZmH1iU0S4pHGS/wjCUxUr6/6ytpIEzPIQryKNyW5AKXGHFhWuv4ina46LyDaJt9V1SiafgDsc9n+GbxRR82yuSlauqFpLITSRzkoNDmYWe3X9Xjiqm1FJlHGbXx1hofbJ5UWylM6nGGnT7YRaDQ28CDdETdRCYsuFZ8ZetvDYqApQuOhsvZl3qNl8K1ETYa06paAYZdQUhLDmKGKnA5zIGqVAaBDrJ/6FMFpVhAg9DghEJKzNCn2Pu9IX3905YJYBKHVRSMJs6lR0aVriag//okiBhBiPEImQmEEbvdsLkmmWfm77b636LpsH+kQgaYMmYJ7oRsym3qeEtVz5NNWIce2VAFFju4M5jRglhBjkCfTRph5EpWoX7UVSomPxDBDE7Vs/QpcUkGkB4ChOdpGfdw0xI7brgIm7QiJNIQZHLApceFtp2PnWNlsunQI/qyD4Lty91BOvCfs7Uc2IOPnedkwmvXVdhfamfHQ5JL+ex9jottimYTfOv8BSxtqM6N2L3ia9DHAVNK2n4VY2afP0lsvmkWB2OcAoGg2TvNcITuzWeO2rnTpfZaPI5FPMQBjKh4BN/Iyx3o3OWJCZdh1FQdkm/5Nts3z33AXii1r6qnjhWz9UeB736xmVDwlXJUrNVkvorA2vRc6WM8cSOlG37wTeZEn8kC9ozb0I/WdwtFPph4KsMkkgevlAK0IgADcqlbOp9tTc2MnEOoyiyRlZveqWc5jEfoM9VyWv8bLJLITjPeh5D4YX0DHKt0bhAZg1HDiASTqGVwwV+ByiKYoCT+Pl9PwId+Yt/fAstY5GEFf1xKkElHqND/yMJ+hL+yAay+1BCBSN1l3r6pel4a930jI+7cuWIMYQwPT2/SOmG7nZnDxrhQdTX+hsIlSPox1hAWZIBVkPSSILnzdUPJX16Eetf/8J4SY9hezdwCvG+CCt3aw4QzTFLIjKEGoCnTQ258+4ejvOpq8Az5Q5SjFfXjwMriNXF2+OnUyRvGXjkVwnklW1Edi1mOtq5y74qmJ7tOanp1cvH02G92ojoglwqewErVVrzwtE+eL6mBcvWRUHNCPomW8830v7w9sC3DTCEZo93SYoZUURGBiMwe4/ZTfzXsvhald8OLUFLI6dY/LKjjPj3wWCeWVgUpRv1fxT5i5fVhBVUn/dv2AsWimF3aWvfWccZwjFk7OUgeIFyriVcdTNANTaF8kr13iZNqvDH+oK5BlsgRLx5M2pivG+Ppgq6cm+P4OJBv1z9ZGYzaW4KwR8ezToEY1UIug67EPxBvwygYveXtC2SN1VNt76gh2HA6pCDrZtHQqvCOGYe1pzyMNohg/rtE85srU4024RckmAm+vXMn45CyV71tXkPVO/rTNPe3KhT+toKH5TTArct3dqesj6f1/8YB5HBOiF8D6+C0tVllEMF6G5U/TJ8R1dRQY0BCCpXOZPWdD7zeL26032+WBzmw54rqcafNWVz0Fz8GTMxMYPBqK4qlEEBptEQ5JBMw1wIRg58XGAG4/O92XUEHp2dfZo3MHduTFx6Ovp181caR6IcGmu8k4so+p5WEjjxYOAufJAj4wVRF+PIl7cikGoF41CxtSTYhZzq9USIQpsjjk4qhPYQR2e/g1YKY+YkrQCwYVi/Fze62rFKd9IfeechD+dl8OOziS/L2NqOEBkt7H/NTX9YpeyuNN78GHkB+6+Z4uu14XK4wm8EwpMg7XJkDVnYR0PgvJS8UFbLhRFK6uO8yIEno8GmFkoZf/xCi1Y4HSmdRYLhixc1rrm6iHehOmSBNJhih0Qv49ObnkaiiwP/mYa3SLYH607bc5OmCZ2yIDcqfCDYWrrBJ/iLLtzga8Zz7hDghbxxc2Goh1ooQJYE+5u82cM96J/VKJ+IDgN0SqohcCkWWPCMYI3K8/bb0plSp4HZx/Q4mdWeXZyr7xMbPLQogY8kZ7JPVbO/HqoWxRZrrfwp1/vgubvVPLKC2KZGqbMLuKGbrkP/egn7xoJts+c2RhJ3jIzTieN6Sn+Yy99pyRdKjMRMPZDGihQLihtTRHs8wRniSAbVf9pHhE6lmptXrIHcnMbNY2IYJUGoOWz5S5Jqg6D+wwvPbyD2SZRr/Pk6aEXKLHO6dNGM6C9IINtuKqvE5sW6rASL7+oCXJmu9hqYhtgBw7vhIRhhBL0xW6sZS1iLvXjhawNYq/zin/k/mnFk72jz/jtpufQTMm3DBsUGKAZLnEE92Ps6OoCsM/TCnBCwmhJeNTnRr2cf7z1xTw3VdT4jWyOUiN5IqUiZjEUuMlG0CLgVB8EqyDUKL+v+k8KmY/z4WdJjlbFQmpTGgaJ0KN5ArX3lO9i6U8hTuIeLxK7O1foscFYqcjmd2j3zG/IFi8he8dccbDhJkaOOAgSq3O/fqcS+R4iOBkR32SkUBTbvy2/BMQHMhdyBZM2YlmoEcqerqDUxOhJPO2sGExow6E1pVUJjRBcurZ47mZwOjsBon0uLMXC/oaHpLPzNehqpj3RlOsvUduSSlMTWq0pOtIiv7QmFlmSqSTCJTRwQR0+yIHXt+SXkQv3N4a8svc8YzYuTdZOdDxQeUjfyBk3gRARbRa2JnG0JN2J3neTIbnu63m0Xd/kjNkXKlPwksx025elAj2Rk+OzbvI/Fm3rhrN5KH3qtZKdb6v9pmN/Pf8NdSvGhkwqZQhYpdqDHvjbhtQ2gIOklYxYZDvK/2uN07jXvXMZRRds+aKSAnkCnEYFjpPgZFoAjryGsBvDyTBVkes/rlCsxc87R7iAYIiUNp5MErXvl3CWxa7dpNiKhVPJzk0/XjN7h2hX1VrDvA9uDIZN6v68n4syWw5Svu7sTi09vagzlSDho8+9SvJIRnYGE07KMpaTaK85eb79f47+jEbl2tnh6r3DQ5DEdy947BYivS0aIGF8/6T7BzQNJuPuH7Nb2vxsJDlqjtG0aAP+9lrDfj5FLwKaBAo7w0P14WisTT7SQ/4TEVa9SlgbhDlP16p0NMjk2CoOMqBWrZ29qxFKQeCSbWkggnYzlnairqt8+UQ0L/vQAjZmFrVIU22aEd+AQPqrGVaMQ2glXKbFrxmFFl14p1m7jPQ7SxgX0DG7auvJCLENjU1DtNaKttNu/UobW/huDdbrz7tmG+5Z8gzL4MQn6WVSXK19Yh9lyrJiDr84mVGv0UdU4o7z7fQQvMbZECfq0xSqik2L2JwiOpk1sMaWElGGnWquZvSWDr/AqQN7YybTMmwso/j8grIdO9nXgLJUjE37O3vLOYPpAaESZIks++fqfN1S/6AAK6SmJKQzKUImhV5gARo4MJeRIlN/3Y9mAaFCXpvJIYrNRGx92cbmEkfo1B7VV3C/qCIeB7NSB2fcrSKpZVW7IlTqqZZBfu14C0Oghh94l9YPaZp8qLFAN85jgE5un3G5PZI8686txIYwtUtaxo71vOJ9pEqTmvNachFuh8nINO/ORzNOQndAb0LV3aDIZLnkcAj4o3m4wbKx4fhXm37dzJnZFTI0ZZZ1UWTf0zvCQF9deD1o4srPn388zC1zYclLHa2s4o18hoNH5gm5s4/I4eamsTBR+ekzKL4XrEAhG3lGoRdc8PgFBtmukXUz5lRFiuz98n+Z6c/KbMqZOevRnNcsOM1tje2+OcGQcYHc7owBJntRtVeNvhf7K4c9wBEuYVpkUaxtgBwvRfIBintoIG7jY9XycsrU7GnK+JYL2bg03WLypmt/44j37SGttm9iVhkrRAU+T/gcHi4JqylbC11xQEGSsjxr0JyiNntuaIpN1sOZdRcS2OeU0IXyRc80JyNHC5nAemJ5mCXM0ehMGXlg6Uc5+0pFoetXXPMRet08Ir4uR19W/gEEXpzTH/FkjHR0IbNA+8BrRtqrfruXnS4kwpapfF9mCbuvjpTV6Hey3f3yTorghdpuYaONDm0yHSB3kFGMg0jEHnAxg4SIETNwiuJwZyQql6/3NlgMgGVom4eZ3Z8Podcw38MItCgHo9xJw1Zq0VnctIH1wkAr/43V5EdtLMDLL+Xsln2hHPjQe8/quoqyV2zBkr+Ueh0Fx8jf0zvCQF9deCSngkFSPkYwt2TNAz/MxdinP9k9MAHxy//3tufTE0sbXCsZgbxFq1q3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYpz/ZPTAB8ctRGX8TfXrMYA/qIZLqidQw7wo4evv6gW6TFgDq1k1wZhCXNWKj5Lv/o7nlk0lxVUJs7/gK4hYkKvvDF6gWfwyKVgCXz71dAK1tr3PgtMPdH0GvQ2QTnmvSq2IdukeqHTEj/2avhmLkh4/Q3mgfMTW+qGq5f3Kizo24wB1qjyyCO5NslDf+xTRAhZcfzDaCV6XZ/883dFfP0qvG2oDxKTtxuR4fE0DRdoTQqxaCYkkwPK8iYTzhts1zqJ57lldE/j+MSK4MA8KJ17NXq7NMv+WNfvo1SV/CGk2pTlPgFxngMuaGn+ww49w/k3jSnQyQBGrr4hxpCRxHwzjGbM8IbTcU99LUWq1IPrQMW7d+ILfqBcRQkCw88o2yXjiqm1FJlHFgEOOfRoCQ3cOERjRUyrBxxeqygdzT4i4lHj02ZbllT9rLcKSIf9t4P4xN/mXrrqU+xDho+R1FqPIUOXbFnOAIDdX+KEr61SB4FHc/4bidg03f0iDk6O819m/tTJFgMgsCXf6uRgNKGxMCyeonjy4QJMGmXG75IBkoMlE5HszvkGOIFOukQV9u+x+BpV7yOkEFNAESLUDsKV3MROBrBIvK4hr3TZkTwrwaM736DSjxz+HXzgKL7wv4Hm9J/57h8U1C9JvvAqbGIREDbEuKcUf+EJ1cmlliOp/BCPnLFT6VL+PgU371sbyLMjAgEzjLtso11eAvDPy2MX1MyBsL/jpsEOjil+6q2YzXAeF+pau172IeXWNBmulkTUkjo+Do/sJjUWQESAiHW0/f1PO4E1OkSE3qwCys9MtwMBA8C6Y3m2poOLpf6vbuo1Oo9XBb4vVNh43rqbemgQyMlxl0sqx6jH+e0x+elINC45dGCP0LxlPXMzquEPdt7Gs/6ejhcfmWemkiJeGcukApS2VdzNODEjqU/Fx1zu4x6Gb/E3XeyeKcx8g4tq/m4Lv2SlaPqXGoEuaeiKkAsYod5uG+O0ama8NbJxOC/zPtLWCqpOCdPhKDEr7xslNz9SaQFRZV+uBjGKwDJ0cJz2DbOdWu9nFEoMMiNdr+OEMn0GBboNKVTDRhIFBE2Tayyg0BUgC11YSsDoZsNpq8YWY6h9GwEMVdlVIB1uJpN3iW7aqQGURpwLt8zXiH8Cr4T4pdu/eu4XnMDk6Pn5o/0w+aXG0je3GmvvkIArTDfZseEW7/UkAfYhws+Chd233jMNk+I3q+jaoSb920FSIaYhh/4lQcZTJK4gDP80uOZ5779towy3npWQSqR+E6+xl+dhtrXhTiB3BKAQOkeC7nGD50cYd8laFwx9XoD1YRHhcsP9XH7s4vKqbu8K7F3b1Qp7wxmPj7lpJRzWZpVn6U3DyozsCkmaCUTmKJ0FVm2j89Z6Fk7Zqvs/j70oaY0uuP3AHS57bnBFHLYcxX4pCjTLNMIjjuqOQQC5oZFruydFVjP4MJ50Lt4jcADhp7oUVwNObzp9zlpDSNyc8ComNhDw5hr6kDT4b8LMuBy/XlVm3IteMo+gnYxZP+s3M29sEE7iab+QIGJlgv/Jvhx9eQZFzopU8yN12szfBk5PAkeSJgraYbGwWm8p0z1gZRMOHkFL/u0ShDl4IcI1KPAgTlXBfOOyVCVQp26NUKKdmDH0NHBil/ES86gPnTzMlX8MpNWGmDmob2jsUFnEcxeDJP6RldvVlhTfZZ6igK9jP6sdJmG99a39NGLwBGs4OV6sDLzTcQvSghunAUYW+m6C89pBn5Efwfgnn7ZZGQtb8ISKfQOdKghkRF9mByHi6/Jige8ImdG8yLably574aptEzdOKlPHCU7FT0Ugt/+at2E/407X8vUjcq7FUBD6INo6iEGBC0cW9PcDSelwZXpgOJx7mlHQR/DqOf/bdr1RMmx+npep++z0zNME1eTqrDX8qTCWSTVpOc6s8FAsaHXKfIfhhvYIHfZLIsKV2U03C/Kl0yrGT48vMqxRxGuMHRlWfirHR43xiDXpPHcM17SGpIxxFPj2FOl7QC+fxsBBLweNM2P2/5M+3hKyAiLidocoUkuFB6H25s6Ooii22oJrbExApmFO3EjpIHkied4xlioQgteoy/QxTknUjxCJwyGGihAio7RpjkzNo7/unyNr7z82rDEy6tOrZN69J+xyiEhra12lZ6AKGHn9SKYZFjzmwrtoqLdTnOISY9zLc2mQm8idWr02ipdvplgmM9wjm3HhWerJSlk+gw8XYH0epPphVHzapmsbet9DO5zX/aJP9klkUIL3t3bHj2B+6n4f3ugplGuRdkstGPZHUeFlPsy6+Do2LppTXadDfWe9XeBNlmRv5x1VM+/dlTTm6tWCFgYAJuDkRDlNJ2kaSzQ62FnYeSZnzBUgiDoDFwH73l3HW4qAG8edM3UGUeYt3F578uk8bRklfDme+bxYdMxL9xScOhadIAF4V7BfO6CE4kw1EXXotoKuPtlmUHOjK6L6RJBkiknNLwTjTIjQGTr4B6pvQdQuS/4vwN1MmPOil/KmO+0asdBL9L8l75/a8dL/zwMwzKWz41LB6YruZWcN0j53oHwkcqPOJg71P6TI1K9tWjbrwxvSg7Om5xHx1mzzTODQAY3Nakspn9FvWjn3Ou2JnFlZ/IA5Qldjojeq1RT/G0fi9vtEeL15pKCXteIg/ZE03zcBRZ2zbtUBAPVWoc9sqiwOnvY0junz/OK6jZ+m+0uD4URgBjdxvEgORzqyKI7MpqchG5qTiJXtZMd3NZnOn7HqIB3v7FdJTRVj4VyA7J7QhMrixP9k1NYhB0oCYkBnhcw+ttrPcy1bJPsaCcIB/siJEZDEsF/KsWWBHE6otZAX18ycjWc6MEI9zpEkg0XWt0FPk9QY9L6NrMtsgBU4FHVukPAeMg+g+EavGWwfAp0AmF+nbj2DL/1SKFSEwJys2QbEE/4fES0T+rUn3KYUwMDAoDCGnSb7jQp4weCd8tCDZ5239vh3ps/+UpV56Qd9WHoVT758NjDAH4TlbY2UQ2tTlIknRES27Mk9RWJvCQYpDDnkkKhOUOA24AqPJVFtNUWtmnO2Cd3lj5NuHhOr3+7dcWj9JxyLozMD08SpwfOq4vMSMoitoqKxulN/S3ogskc/FSQf1x8oVQbzN+LWo4dIRPNe/jaMiVM1E/HUxhaspSm3aB0mQ7rdnmIJiYP8L2IqyoqsgoYFpZQoFJEFVwAd6ZxBx96jsJubOPyOHmptX5QKapaRGdt2TNAz/MxdinP9k9MAHxy//3tufTE0sbQwhh1DVQdU7WLrvqcM50+pnkpe3Rnvr49LyudDot+3pqcY1TIMwdoeH5pKgKEE1SORjp4e7MJTvTwNBkjLg1NaMlmNcH4wxP3C7SuUrVrELoZkTR6oqCIsnJgeDDaLNxPGABXfrEcg36VTw+b7kIV7V023YgGGDT6lr9sv/WyH4VJouMhIqGU0Pd+U1vB7n5cyd489LwuOHtM0H5tDGG0ojBLNtQ2EHm+v0aGE5YXdEKGq/KaqVeJvw/vFhVUyZqSr7acXqQw1aS3BRUhItsrkU+l9UDhBK8JqMl109EMUFZGTAOc+qKFGtbC0ADz8TyJZ+GCadkBwAM3KYXzQpDc/8RXYxFN5LYGDbFq8gT1Bln5IGXX4wIzAqPMoe6pVtp3x5G1jjzgxh12NqknEmSVXIyz0zacc0wd1z+lhYxlo0SenRgDzCo9js+kYTn1Y5t+M0s9KkTGYWUtoCYAlQuZWyy606zNwY71ZkMSpXFwPSf+gItH+G9ZeTx3urz5tdSbLLrTrM3BjvVmQxKlcXA9J/6Ai0f4b1l5PHe6vPm11JssutOszcGO9WZDEqVxcD0/KgaN8JmrNPubRFwZNMq7ULLJ9nIN5/X7VLc0cHwKjrQhRu8l7LkpDhk2SouTOpB+m3WBg5qtl82NZLgvgY2P/IX9jrY4Ve5OzXoBqvJt11KomNBEYnt0xR83fCYEcJC0z6e8Xv91IuNTYwmzt8KLnjRYY9/yVLmhG4YFpA8nZMvsXOVtiJE3zCP3BUGblp+PumuJHUNBpTMHZFfkgkjpxteufUt2qwAFNr4Bsk9/vIsacRXAYvKuoXZoYqpmEweo+fUV6XDhEF9HJm/EYpNkTprpfHM9aONMWnNAw7Bs0BHvHvuy8+CI2fi8bFx7Fvwc171lstDVJn+4muCe/OwlEit+GOfK4uu2lakecbBdOasJ8gIuGQ04um0FLNYCdLwKZUKS7m7pIpnXezCAan6+dRg0Z0h4a7cr9za8nrLIsb1k+QIaYDtllUEWJlaHlZe/XwfwmXNTfU0M+MKTIeme5Z8AlrtwmevYTil6ZV/YxIDScyN1mcm35FoklZyRgt9dAS/DLjUd25bC81PyFPDcCO8hGSu6vfj8GZJLbuMl9PJBvcypgf/KV0LGYchYm+WUiOOWEjc2sw1BoLALqm9Yz71lW5oF5cvMLIOn0ownuwDRrBnoqP9PDOrEFOyZ1bIbNCHZBKlYUZ2l0g/cyRZetN3T6Ptia3odbqCyadojSqIpUHedyC5jhdqGbObmHC8adLvBxYCa+yap+CPEmTFCPc/+vxiactpyQfx5PtUoGr3bbYPp/Fnx1C6zngyK2N6eieAQrZLd8Ko8cceId//g28MmPNSI/B732sR/AZJRiYvVwKDDbE9ul+PmILft1cdBzMlgiSRGcxMAHB0wep5FTxrRKiU7qe6cpbb9fncPGeDBpybsA15ycxAR6EQaeVTlV7i32XDC0FJzIZV67Uo2dq9JPujQyUkh/LxuXUUvfRITC6pyBtEEtw1GRPlQ5oYJushlFN4Fj9bK+k3we+sRmjc8i/yfS5Fpin4/7a5ZyexwAgfP7EbziPQqjSPLV9wGwnxIG6RE7MbXYXmha1H0QK0q+0kL59fsZj+vehTVg+uLiayfGv3IpHT0YmsMnQ6O9BkOWJwZQB5Cy9GQqib0lEt7NxCXsJbN429kGoQXOxykxfJJ63OtiUWxyKXup9g4O61IwixO0Bn/4ySaRjlWxyFh0pfXnttb0zZstTVS0iLvoRW+fJ9KlTqCxbBn4SOYUUK8TC7gtJtf6rwEcEhx6WC25LJH1yYQkE+eU6Fmh094YzeC8UYc4PfkiVmQl679vvt3OJBwLk8xh6A2XgwQ85HDcFcFzACTxBn7V5WFr0Hh3f+2RZVq40/r/kz7oWgdT/yHg5Pcu4IEHJyMv+adh6jCI4ANoY8xcCzWUROj1uIPpAPmhdwIS1t1nSJ2VMLdb4vr1AdIp+c5tak7++AkzDkCzCzja0r/rgwaaaZ9qVt2Ul3f4NcvYnPQApY9tLOayfP/lj348A+JCZbI32ZfIRxsw0JysTSoaHV4uQwPX/601za9ed10p3/s/bZuziV3Kjt6EH9AKsMZeeb2TJTZ0JFcOYG/muKLcHA0TFnc2sG/7UnMgBTbKLyW7IER4a0rsr8YoHU0FjbVaM8u99I2SGmniEIU2QMMpHwACIP/UvpFoBpJpuDWAfoMEDqonKt+A6lDlqZJ6gtaD36zUzrZh3yzRSPBeIUMj0yDrdgallyVOqxIy3Cu+L5Yo+t9aUyT6JeT8sat3l3EftThRwrjTzrXfRvrWiKkbr+rTkL+LnLWzqX1aP/M9qld5d3YHFy8K5IZFiGW89taoIs3DNTMtww6VcC3StnaOUm/YzSDaKUcL4H18PLF/Zn0ogfhU0ivFZ3rqbTLnNJgMAkwHLZx5nBy11JHqysTbJ5qvRhS4hQvRnDKys5J74Ji8IO3mwhoKt060hODMZ2kYwFWXbKvUf2oEPzxOWP7h/ABrjUzTUtXCkPFcZJOpgS5O0UXe1VP0JNBHuBR3foCpqWBm//bPivMG3nJr8zG8gaCAlKjwoMpPvVnFEfaVQZ4NJYyHffrPiOBzTi1sa4w6iIBhbMnI1wD6nKSmgt1A2SoRMwNYOCi6zBkRLEwIFABxpVrCdTd7TH5qhWAXILc+s8md0DVC32n/C4QePW9OfNXN7iUe7E/jXeiDTFW5qaaZ9WPQynjacBgRyH0Y80v5hxaXSNGzBQFFwZnQGeJCgvDjAbdwcqgW6m/Z3ebNUEymHAjos5YlSwRxGdTDn0oUd+lV07Nj8LeFKGaEuHZ4cjndUxyLp1x6YsZNipd9cSjy5RIiB0ilEzsw6TUQsD/Z5rXst7zLHgYvoFusWWeuzCf5hFMHSm/nfrzfoC4QdZajgsCM6x6I6hJ4YAjrpPPdeR0Sd1phqG4z1NvuOhGMRK1h7Ib1Zsb3rlbDHwCVL1kfSTMYHuFIgFWnQz0fq6bT2EkeIrujohnHVoKUsdBYhPreJQ0QDi9hX7N7St+IMgG27DYHcY7sJ2/0Dg36aZUWGwNkP743aQzQo3FNqZWPMLoXLpmLV1uEF6uHLGopM8/cTIRMnQaFDoukjXmngtQGZqXADqVwvl4fvibonopVsjk6FGJgbJLdA0NdB8bEZxODV6Uc1TVreB1bg1a+kDapqbBghtM6z8VqQTYpEXaFbFfp4sECFmh4g/pcqTR6wnz4QtVqmN+sG+sKbzERZXlsRWmnHhQlx5D1c1DtgU/B5/h++UdXAGW8m49niS4GUWEJxnueo5gXrlO1oUh/M9LxAON6MCLbpiIIgOv/+EHDdzIYVwJaL7OzA0dD5L27K284MK/vLkUYNvFiRB0weTzT+h9oRPwZJjaWrJ++sp3WzfSwXhHMzS43pwUuwIw1NqRpdgFLtb2whLH4tND+4Qs/moyNJn6Q+DHgdYNoYFOBbzqD1nVGUVW5dC8ZMVVOHOlC1o7luPSArJ1diFx77obM+N3DwK8kOryZkQUFNfSax/9J6s/xvrXIREHMuQVVmtT+Een8to+Ue3VHg8DnWCVHKsiwDRootydDHjIn1Y3E4aGrbln2Gsj2ZVe7uNgNnK5H81wefPwTUtnPuG8Q4ysEaUYWNKoY1P+dN/PdS6ACZk8uwqQU9/l/+qOFE/M0ezfHUe+57/ymbkkqkLLqsV5Bea9MVuIHKNfwgUKM5C7qfVMO/XjfPtrGMM/uljL5G1PjcZCOpAzxhfSWgIT6sKg0KmsWkHoRtCglPrcPkfq5c2pSGRiDcN9bEwjoGjlXhFWxpIz9bRfU79F26uS1d61LWKZppTnBZuindcg5k/eSilQevPUzDCQjxTVbSNJ4EqH0GDmZCrrA+TnG/AA7v9ELc+cRSlvb1UzT8q101oguxMz3BY0P0eyWG9Y6nRLoKlXhoKDG1iRLSBeyfoZiHr+8BCJqEVvKrgzOcLztrUGGpZv9C7oPsHJEk3QPRfZ0ZT6BUvT6RsdwZYr5eJ9lPpQSZr6kzyUw4lkKZfZcgutgSOlu2XbMnnX3cWbS1Y3WUJ2RSQnVtP6COVV4VnpBizVunSTiiSV6GM78gwMh3oRmoi2heB3ZrLgBRHizVSCaB/f11bWkFi8iZgMLHfa4hyzWCsJ2o/Qv/vXo4+FnZqTOIDKvrEv916L195pSr00YfTZJ3rciqQKAa3PJ1ySKc50e5aE/V7+ON2GDq1979cRjxUrNsVUPN10fsqcLVpHT+j/PhnalrqoHn/re5xRYvua0+qLiijTWxP7DoOthdUAP7deMy4Ad9s7tYjk2SgcRHUuu1p1B8NoBoihyWrCXXlWRCcmHdSMrM2TU/q3q54Dv4g4ZxGW1V5CUue11Rifffddfw7bL1u0zsG+EPJ2XiDuzHIx0+xwMpovuB2sWbAU6rxLbbEnWfI9qR8hA1a3ZO75qcc41iAWajv3jahfvZ+EpjYawT7P1/SJqCdj74hdNVC77uxb4/VPm7XVqA/8WAduUi2ROrqZOvIQAISvwv24DuulEh43vgYMuAYXzRaSKGGofU6Fno/WG1loFbfQ87MiTy762Ra8j9LE4A3pjTEFuHjKgcWlSkqfW1IKElW0HSawBXASgkCo8BKjzzY8B30Xv08E5ff/N4zSykzg/8ArzioLpjpAjH1RpJIsJinQzIwd4NFxRreseyNbGwYPYKVMCARu9nDVjMsQQgIqIai3OGzayW8gII3Tb1PFVre+eycr/jn8dTZ9iphqib8zLujle2pAHJE5PHe6vPm11JssutOszcGO9WZDEqVxcD0n/oCLR/hvWXk8d7q8+bXUmyy606zNwY71ZkMSpXFwPSf+gItH+G9ZeTx3urz5tdSbLLrTrM3Bjt9x82B/6uzEGI8Rpwje7r5uJKs1NxVIfEZScUGsWNzDFZKpi/E0q0Bz/IYaknsgkN/vYvu208ytWzZ5KsfmtlTHunsa15kXSln6tGIqAl1L+1pj2K5LhLBpBspTf2dSY3hTO1Clm5c87Su8G39KjkrgHBXxsdBAeTvpeN8DQTtkc2wskFEs8aNphTC2l8sPi44HK2wXe2ZiWh66H0obVT+SvWhdHssMVxrcOUPRtw3oIjxwzMJQOvuiaxdozLjm3peAmO5YUVuy44htqacEzWbWs4Whov+NrosIQ7FVL1gJostKli4k1MYLo1/ELeu2TLrxqeVOO0WAp3OLngeSpCehkEqyaDcadtocozAuYEGyNyYZPb/dmihgfiXFoOlNXHCEgf4rxqBiC0/lqLM+D6F9o4p8bX/pesEhyNPOSSQ7zMfsPEUTLKaBoir+/A1NJbbZXE4UrZHGeMOQigrEg6LqyiZncVsS/1EUSvyPnmguPQxVj3oPINhcpBEM+0csjvhGWo5CroEOUS9LZkvtQv6Uf8YtSDd08HgGrlymb4ei6EeC2TgKTs71UQIJeXDetON00gdVltH8SXHJw3sZvCNv5a6Ef858UwKXbBBuaDieGCdo/tKzd21R0oYhi4CJqkRvd+54e5kpEe4K+1n7+SOodtPtWhDXe0zAGKADJiNmHoZj1+5vhY4f7Um+meOwDcfKAGSVdeRujIUr4i0YQiZ3Tv7GBPSW9f2pc9hqTYbfQK/9mJD0qFX9c0/oCnmb0n0owuvKDqWNA1klUxVBnkUML4bm3aPr1pDYmix0poEbNQJbsZ6VwWD2qjGfq/aRekpUA5zjWJK8bCGFwgghCuvpbCWqWXxenE3deiBqBOm2rxgWxPqSN0C7UmUvhxPDpmuJkwR9fiBbj/14aTBrHdZo+vB8GLG/hGRm5vT3KSU7PilNx4sEw+cYnlglx2KBRvieajnooB9Kis/LBK28hBglt7c2U9VSY1HURqxr0JXcgHBZh03f5/Nn0eTQZYmkhkN66PIlfxsCIg0aXAMYorh4AN2fgSLZq0QwfGAH7y5aPXNDWDCNQYorQwNgQhRjw1JTGuHEFQfZ4E9nhoeSnlEj1Yk9FXS8CxoiQR/M47plJrMkNxuwOSo5AHrEeh4mgUu7bjfETgSXIZHSm6xPVI8JUOAAferyVPpv6X6gQa7Tj5Ei4M1/kA0BohTI7IILu52A491TeQq4D7GaBKGazfnzo1iiFH61lXJDJK4etylGrsWs2FCXBg0ap01HPSoYhMGbgrGlrukm7o3ThS91HZm9amzvJ/YzYHvYMT9QDskeFvs0f1e+5b+uWTUUDP8a51zRXq/Pw6Mul+Pylyb97BwvmKQGXSWEHmY1TIIU2ETtbA5K0BwoHSrIe5pzglZi0aVSCILjuFoeB1Fk5mfzXy5pkfB59LxrXz2nJgLV7HLbfZrsc3OOjLjKoEM7E4HgVdD3SZL3MFRwCZLqO/0VPJvTyoZ5sPeRhVv9XKPg4DBlWLlRKSbk3wSHWTan3v6NoptJvKD/PVETWFsaiF8C5Zk+XUjhvGzlgHgOUc/Pqa0W2Wc6vtBbmXouKGH8x2p/JPi6EirG3ASVn/awyXYDex2lN5SwKuvJ47qV+agfgeYRpYbJM+G0dWXxD0ypo5WWYEIlGgC/Ppyz8/jzW2AOuXuKQFnmDvVcijGFBbA8AoiTE7QTFTVBH5eQstYZr3aiR7Kcfa3suD0uF3G51GP6T5zLQoJ6LIAIIQ/7ibR+SR94nZyZ1GOdaFsjLOBYGKAl+FNynrE/LlDNo8t0IxXSsodqLXyXVmXCY/WRZ/WgCQaSAS13PO9iT99BFsNzZJfaZ0ca/gZ1wn1k+/xfMO7AXlbgD4jq00XCd6lW/QyVUG5Dki3JP+KjCEgVX26IUV3DgL2XR36x0yQWGLMPxaIRHrk1BtX/OHt2AxQJtoVFaWmxfBUHtXJvR8f+FBfbntFlql35kxzNnqkZ6h+Z+GkvPaA0FDmn0thPO5vMnQ435EjFCwgvJKZ1OxEMbaxyd2HtTKuc0TF7/YJNcAZSFLPq2w5OiK9FVVSkEtTlz3LK39mH28mZo7meGYfMQK1fy0OaDgv4fVOnsWoJsAsIKpPFyLWjKw//vO/M9afKsbw+UXkgWrNPrsuy+f5kOo355MgglciruuAKWU5h6/+610rGZcFL2JpZIWisa/j/6ZAY7Ja1pJtetE+578IkPP7FplWOSStNc05jcG5poarYFckuNYCt9onc++QA8cI9tw0Qg71GpY5Jwn6DMqO4Nc3K797jYPYOFfsKSHBbbeNpbQSJPTSibuVBDmThp62SwBwiOqQB9YDViB1Vtlk6WGQ92iQTthzg6BvCM+WGOvg0YdaXwvXTSBRcHIJEI5H4AZ+cHqZR30/rLqS/RFFIuStY5GHJkNmwt387tY/OOv1pQvAQHUkE12UmFcprrbcKpLWkn4c2o67Rqgt2yGh7vOkzAbJitzvcpu2gS88WyarlKUkDfrRiEusddOr1ZZqrKJKwp5CfOYvrMdmfDp8espOeUyi4loQcbakksqO8c+d6A4wh2cHS62xlooJyNuG1YeMnHOYNZ4SeEIdRYh/cwHD6km6xkGje9k9oT3UgGJzm9Q9gKMx21RUa22DMVdK+/4e0WVCEHRl6IEygnfUVpn20JLun1Iy6Hmmlvb4/ToGNJmJCvWKBZOMWkE5qRX/+J4ENJ07zF/lT3PVSu2u/kk6/4gavNz4UoDMBYmZ55Fz0p+b8uuk5c6L2i/L+DOYYWRU9fWtxSAsL2ZHwStwh5jcUGPLR6T2u/B7PUHO2RAFQ+g/wg6y+f5P2rE4Gx7FLAy6nIc2pfNPJVD5R5q7wK+8hiidZeU86bEp2ttaxLPDkicLGD+caYq+jWs82cBBB3Dq1vJsfibghoQZxwa3OmM2kB6XnZGdbj0PlyyDL3Amc+uFbcpGEy7o9SsWDp2XlVSiDIqy3mcDLne8aSMj90tNIXfRrnIZs8ZpG0Eq79ke0YFhRDPuG+nQBmxxur8xX2tUczSCGdLF3DJ+reh10Lf0x7tWSnxIjAvHSFXtJuQWVp3ZXKi0AzLPzR4cCjABg8CHm+btoxZH65nnV+iKWiXB3RBReiG3F8qjEoOa+PUpgJpgl76hMHBtSiwUJV6jaqseVDdE7Jd4GJ84GNcKL3VlpjZA+UfANN6as1cEdLLTjbFNe3oJUuPPwArqE2/bT1VYualmm30swiZaE2lvZBub0Cqj8eQET3IxroWYztItkYWK09Vz6wYyzzFQ+i477nHx+lTk66ZTtNPKs1ODG+Xnn2qUMHbowSWNEza9F7xyuqodsRc9wS42dMq+Jwh9adpCAAUSk78rJIUw0935dhudgnWq0QljnZzytAHMOUH7h+ry8DHApIf51Zpo5/F7uVrbITXdkKePfiFn+4y7lGmiips9UX/WISqzwHs2WrlLPmmdd5QxYOb5/oqMUv88qeQdzXumI2Q/FwO0h02wRi3eB7NRGWPB/Noiy3hkYPSJjgV3MEI2ykXdgrjzOkEj1vLwLJU7v5RzIY7R9LF4deAuCul3Go5RBaE5o+xUyYP9rBluKmvJiqCWlF4CBxqnZ1j1FszVRVgnRdxYzaXQ6GLrCjTVE0X25V0EE/dt61kzOyYRPtdCBinEuAJscKhOFyKp8FU96BsxZqSfKEaZpVwNKkww9mxz6N3vvLLsAWDYZaR2LT4yj1NhlqAt9N+12XfB4KkoKhGC+CqShC0VJtJAn4PY3FXbzCnE0EYdrOmJZilDhcrFKfwHjT/uky1KF42aVyR68A4odY71d58FAYnY56SbLeWAb9puv5S+LGPVl+UNDiqoyyVfe3wHp2Eg4W58TFqvF0qiio9peUXuBBXSX0JM1T2mEIz3Q82J1TnKyo6bHFPFzgn9IuNmiBMJubOPyOHmpimCvnoBdXMZzC1zYclLHa2s4o18hoNH5gQpJui3DmJyYSjBakNiGaVACqzFfS66bx0jz6fc1ySDndolpB7gq+UqCeCChO/jEjqYJ8S3cIKXFxD91Sqsje2R+DYkveiCacdqmkujpeZh8ohBFHFA6OAZwxiFqPc6LRusUgXnvFR3Tkwyssgr2TYDx+AOxnmYv+4l17AT7agPakpECcM6dkNtT0hvf6J0UeamiqDJbnht/RMbli01B9wtpkNsYVc+g82RBXPGkafoDk0YoLrPayKLFcUfAIEitUBKRXdLhYHvME2PwCrb8397EVWmSdXYRaQ2MsAe1zzRk4RUQaNzGs2YzSv4I/XauExkK7+za1Bk71whpaU598B6Xw5mvvN981PC7aPGSKCjqN/lK+g6nuQlmEglyeozMydM9P2k+QcDcCLkM/qOh4SCu5fMigHp/e2hVBff4EhNl8VjRon4XBl5p6Vcm33TfgzRuXabS07PebT2ju8KvIE40vhdHMImoMNpeaIZFN2U/P/BmBJbx8Zl8ihpmPzymkDf1pX1bj4efAu1QCKpRKPsvNAy3xpmtBEkCRs7ofCwaQS9Pzy6+BZfz2QYSxKxNa/uv2nh7W1VP1B1HgMe8GOAQYYRgIdy5Fqfoz+dS8LZ24xshpLp+EspcWkUeyeJToBBhhGAh3LkWp+jP51LwtnbjGyGkun4SylxaRR7J4lOgEGGEYCHcuRan6M/nUvC2duMbIaS6fhL2LwDKoB9qR9hEX81cwc9CKQj+bw2H+HKVMbsdioXf96/J1R/EETGfZl34EVcqcRcEPSzNYo32o4s/FoTz/kPXUMCa+vrBSIfeI0aq6gkJ3r+9C01LBwhhwAeB2SAGTaYrmMHT6Fc87NzVv5aSGVhDkRT/jPns1PHRQPhu3lfM7ysn8//19TcClnjSB46w8N9vBWQfDan6v8Fiw1E7QZxKTaHLcSFfla+51Uq/upj5+6ONL6qTRx7B3FwUeq6RaDCa35QBYNzxIrHfrpU7XTBMrG6mvnNM0Nmp/Mpcb8P4oYZKBTZEAUoCM/izAQweYInWGARFGWu86HnC0oj6Qi0pSFdEbVrC9FjYYAc4kh5Y+CgjRFMvZE5nlLtsefO5CAW885gLKGyatXwwc7HWqe+T8jTTW2zwL+zHZj/fkOIBLAnA9qGSb7unS3Ikwm3UewtzR3slIe9H3WbiYAyYYX4JZcaZJer7Wwymb7SBe5TAgJDCEmZiZTAuid0XqkQDWX94LLR6l1L4canLfv2LaRE61gPFuinTBtKjgyHT8BXibB5gqQ6pwq0VnphtKUz0cO+F46fiQ8E9UoqtPuRc7g0Nbmqv2+cZAUSV2gcGyH6DSbKkJyKHEsgcCPEPKoXh4AF4xYOPUxKYUoIYE4oe0XqGcvhjcsCqhE035si/VoId0YndCTrdXgJI2xwMuSuHq1jS29n8AtsnpFkKwyJYH4uKqyFWDurpFGjcENmikluROFlD+oDyjNAiTfsrLB/b+mtQIv3MuB7LzSdZ7ePHW2AgXOYbkjKTycomlXXbfoIW0GXTM74Y9K9mJKYmPRo0CkTZs1JgnlrDRM7jEko5kvLBP9OBY04pPOsTPjRn7P25OJQTmkbRgrD9Mnj2ew6XY9F455/zMlOGQtl6KZePc835r45m8d0G6h1caEdBaQMOiGyLwNUIrQCgWQE0IyojsMpHxPtlhpHuJOsctCKwBX4mI+fabpv9vLlvImBvvCltqke4zqmaT//gZdQYJoF+Lxk2M6guqvcB+jtJTsgooDEBCUzPJBa3EFJY1Jn2b7Zn5AglxhfI7LePf74R6iGNm16ALeK8DsSg9W8RhoaV/C+kNd6JAZNwUyMk3lzKwH8hhlfxtJozaOP8kpcQDOaefWZ0JamJpOXF73xTAniYksbxVd/VtRYKBb8XcNG36H/vUjmQJwwyVolV1RfNQAKTkIyp7GMm00IcUUULdfF2OFG6oJOi+I5s4wwTl5KJOByNHqJ5YvRp18Pb2qZj5aND3NHL/26Rfk5HRlc/mVKXoqLZC0yQ0RCzfb7d+DvzuU9xP8yTuMwndBOb4d7ZYiuUskBKJlCGAgjJDziYnHRs4c6Vp8qSbb+odlJC4RtOQMUysR4M8d3cfmeRWLbpiGCnHLhgX2TtS6WPcXcNHZYfElScqyW3QoDfvdqPaPb9yymgPmDIUXPokEa48q4ZeFO2/V4pvQPT+s5SxrIxAPb/ogo++6NeeUAswSY1ajZ3POtrTeQafvfTFkD1ywCtnF9jt6gGLT5CgImiHo+xrWyB5sTvEeK2dGix47dl2s8WAq7iGNQx096OGszCcQXlMj4VPVFPDGEjdzNbj30RU9/jripe0MxllMxAAMEzU0fyDRCbMb5MzDy/K5CNb/LfC1VPMuzJ1CZNYOGvZii3f2GP9JmcgkS7N+k0Z+l0OBrCzb1Vrl9smFIFSscg5dl/kVR+5ArEtTRhK9WssEC05D7VPmbjBxrPUFmg5yGNLqfAFzUu8tZJxdZ8pBqhkzYNlnQBXDBOO5Y+QZ9YEpPcxjLRb16O1Qp/8Kr+jS32uUtZilC2wsb9i2Rs+mBCFryqDzzOqA1lxkMbRezSXsy5sf8kfVGIGNNzdbZuLzJD/62Dk4Sendl9b6YvuSDTIi1QeVqNqUFC3xlAEVd4l+t1KktwgLF+Um8btVNioYkc/tH6g+RcmLmAy7w0uhK90OuiXJe/rYhiyje2IJsr0Vy+2riqlxkjjhi47DrRElPE0BDvtQKtHCVo7bnis9WnHVrc+pGHniyTZLDI/fyuJCrDh2XNpjeYS8PqWMAaswxPRBdNMWA8A5LMq/o0dPXnT5KPZfde+sIdObKZfW5KYFpuJ8+AK9iye3feW85wK4tn7jPXeQXrzXT79Ryop1xRnHmIAouTD2Rbgan+xOxNmUD+XcYWkyClmH4jLiBVhjR8LOUHvRxnJXCv/ijchn4FebsZSzXg6PcDHhiavEyIRNpjvwUxwCHUwS490BGwwlWhWGhxaucKXudkL+c9Ln6lxMEK+hVS3eGoeFt31cpJqQ/5zWYUFeyGGoqyLjpucOmIKUfLAhaXHjsw0n90IB2KVkC5NswVpeyou2NLuMFr5YObe3WazowHbD5wahOHNGknmutogl+Q38v3OmMUmAWxpVgi+jh12uttOcMKxxXuooRNu3tY7/g9T9GKI/kCLkT93qLauIMTa5ZCDqbYbzH9aTiXcR1sarhuM7t8w1b6xK/Bo3Z8eeSZKiWRXQyDxcW/zVglpS8tULCA2ttLTKQld8e9VAHHjdiunMJja4dIyaE4Kc4Nhp32jOT6P77eyv27YhTmVv8Tlg81LAJ2UGV6lFm5LBL64EZ1GuvAX7jnXom40yrhoyxSmsKQN7u6ZfF7TbdmJc/i44zlwqCTQ+EbXw8VKgsgUbMWga/QZJY9ZP8BULnG599RWWzVY9oiG/sfKAKz3YTpaJiEyOJENVZ3AzEl9Uo95A2JzCoxVoKXCPOTpXwe3CiS7uzfp3z7/yo8JtAKnqGhD4QwFzxKUGS++CYCDsNo2wWlJN3gWBZJ0xzrUhWVk/CNVW7nWM/DgDDq+CiMl7hTSENkvkEwW4oUow6jfjbotsU0ISmQdTmi3beeFZU7G48cKHFcV9Lmo0nUSJeDh+SaeUuXlelfu+ruB7s/fCvtLxRrcPwc9j4F1BaiRXRt+9NbR27PIwUMOZhAVhX1+gRNg49uQkbC3tnuPDfTnZ1lsrn5fuazlLh8pGfMYnBJGRzeXvb1n2sW71XRv1b3FzLmffuU/napDBcWTDwSrQdPio+YDYngDpWV02qsDxPP0ENNJJKIx+nzpVJMrLmP4fhGH0V2SikQRrLiJv6Oqw+aXSEqyP0ysgD/+KMAoNqPzAD8tA9c+udchWl5rrxAiSKBhioit9RjdzZxnOo14T5KlP+qlzuewM1zYzbE8ZByNRWcgcgFazU0OImbma9pr9YlJVrWdQnfQzseW0ORsId02Dq0MQkn1hxHwCnpdiWpzGVg21GiA+Ryg6oTzdsGCACRDkD3Tl1v/R62qLImwKKub+2RbIHf6bcfhd/62DUsDyGsUCfT7/aiTNHucWG4xnz84Aq616jFAnX1JspsrudwpEG9G6XGDURuJrAE3ncDSIsfIXUVSqHnkPbcpcU349bEgZU8KOGc6t7wpkrFRycyBy60Ia3lIX0MB8+3Zu9c8EB92zcd1T9oXdQm0iXkKOaj+cRGOScZNg0LzwIQlX3Jlzgw9aK4NBTXyxOxCKlt6Lh6ICTcFR7cJBdwBHEYO0J2ofkb7BfWzT5VgWZMM0WptNiQ2iGHLxDtLHKWbI5pcZHPVmbTSYIi7XMJX9E0eSOtC6DNCIY1JmV2e2vl0CnB86NRx/wojIQvZWgOUpIRvKzME3875uFCv8OOEi/e96VcRD9Wn2/mijWnxYXB9hWpG1nVypPehYXgJIAzxUi3UAK//ViTttXahHu2yYPlwEy1qfNi0fDckvshRZ2QIru0IvcjOfy8U/bv8c8lRrtD15oL82QoOUOMhcKkBeKHVlJW0zmYqzJLSBFz9mrdeV43qguNVwL8573gSjMjmZwjMdfbmFu5fwX27f/yZjB+TCqk//P/iwOSN8uuU2VzwD6nT73tDoxXqkRF+4LaW7TmHUnIJyyBeL9TXKa+sAc2dyuaGIrts2gTG+V0SXy+ibNRAIKvURhv6VajG8r7W/2Ds2F1+QZ+keHkvdkxZ4DCVAS/WaNF0DFGg5n5gzkw0cbvqgzNmAlEveEiccKWwvUneBDTbhLOp2Vb5mUvlPBxZiYsSnO1qkHZh7IosTFzGyMUS4GgtQ8ACAGNvSoECtDyvmeZAFgVcmsv9pxDK9nCPuRJALxYGTJHRKkhkoYDv1bURt3b5C3lQxQNBpoFT+Sg2yc6uuPr8MGycWGFcWnfOL8PQ37WhzlaG2i3pfWXktngRlqjG8xHB+L17oovbG6uknS6mHxTiLcsKfiPEyam99tzhf2e6hFXgp35stAbDlShp7l/GhUVcveA+20m15h00P/J9g3jYRTKCYhmURJARp282BIm+VLOW51LV8ZBXDO5q+JRFXPOyUsllk2YiYtGbkaa0cYa3C8ElTR4hgOomGJTxC9t9sLH5swm5N6uvsLHNcQ7rqNEYgc5UZ5FKOlFsDJRE9sZKCALRS47kKX9+HclRaqx56suzXi8RNH5PJm0u1v0dI1Qebaok7xn3Ip+rSicJqqrS5mGkaqcrEhDdnCdSSntC6IzDLo8KEtJ96fR+J59P5LUsLoMa08LNKHZN2d9xk/C0K4XKT6CWbVZ0NY0kaM/3WgmTDrbaVBrkIuN3PC9S3huxAHgzvRxcBksVo4SPZelrMSFBLd+5M7YU6mIjP5nV0m6eLWHD41WF/7ffYixnkwZY7mawB7x/s7/BFIik3BpPRJP7zNc7hsJjBvBZMjL1zD+ZFx+tNT2bzW0DjA8jP+gI1ib7i99+GtRZgdxBzy1mgOqXPlaXg4EOhGn8gU4F3CgHbRR4LKHB8E7+UM+jLATHwivPIVlO51hYgEZjekA+GUfGAFlqOwC9RWNVMV4GGK9lpKaug5W0EWK8Ug6poAFqRvRA0JFJIdbUDr2XwYPlvTiFlKeAMGC0S933nNJyawUNvi7osSauPCQKclHbgsH/deMDzfLkObmMVUWJhWwh4PZ2UIOZfw4fIg90moHpqOeBfNmZC1eL3HbJAlAob6rU/WQ/Dx5y0KPONLOy6/L5NanRvvNjaH3gI/xTZ1eJYsRvypkGo6IjQA0egwrNCBqAiYle6JPAtE973RMj6NJDks4PJLtF4LrusEZMCC7EzPcFjQ/R7JYb1jqdEugqVeGgoMbWK9VM0/KtdNaILsTM9wWND9HslhvWOp0S6CpV4aCgxtYr1UzT8q101oguxMz3BY0P0eyWG9Y6nRLoKlXhoKDG1ivVTNPyrXTWiC7EzPcFjQ/V6DyCitNPu9g0pUWebbaOwK9n5S1UUGvEFPQYCwaFoytRTnpVR4d2OWwVdkfK093WfqUE34G/ke7wo4evv6gW6TFgDq1k1wZvJFlpaMGe+leVl2Gu/6kFbcOQ7oeiqEmM44rvDxtM37TwcF+IDgqrlqOxBAyE4g6gTmFapfqPP3Y8TlNqIi5E/YMt6bLvpB5HphtKUz0cO+XO02mx/11AeVwTObS1UYsZhEhEgVqRXmIa/8jWSZ9ASpv6QiRLCAhinvH88q1Y5/9uSk3Ksfri7N0mFj7nSp1YNiqS4290FRNDW1JiwPmLf2jvmx1S5eLNVP2mLgzQ0+240Bkil7dNePhW4vW5DFhXthFQcqaa+awnrLpWzUAWoWSeDcDId+4FeP4DgwuUEEX2aCV+mBiCrxQRFUr9Ai2IGkcLz5eKf0lkGFYdXb/jQBa2GdIyXLcwa3oW4NmSKZi+6575+RPnhT8+qIRJs9aY+FyWjlBRaWlhH+BWEVjlA+Kc6vPbLqXE0W2C/ZrV61aVI3RmVuZYuHSub8tiXmre0W6KseTw94HC0bssDeLYT1eBgAjoNYGCNqqH/2IQNs5L7RvXLC3NVwXPw4pxYnYAlYz/pkzCZmj+UpLgRDPQSJ9s342Dg5wYyDv1afUYYmD0NEEtoe6sbW2+xuLu3e+KUvk1nx/PtxnYAJo50A9R5LznOvfQJ6b0H5EyyWpKtV1AnvUezoFcdOk/6dyNv/2tezVXdkqcbd2+UhvkUcDbuUU2/ryvxmPP+AyoW0vHBeXd5VAGwDnmEYVAsj8RDi7JzBkPxdOPD8rymLfwlxp8k7z05RyDftIrS0insGhQAVAZykwinCNijwYycgz8ykY2KDq1b+yrNnRDbqd43HgRuLYxkmSyzw/Y4DcOZUs9TB4olqbZccKeu2MjoCgH+z8i1h6MwHupA4/r9iw+bO0LauiJcnPJ99K5pdr7B0m+9M8lQian16o/tX58W4fjTVEKWyD+NwCc0BmHCovF2p10/up7ThCJ+iDl3P9VwFqHDNDoNfqcvDM1wfrVl0AkTs+rFMgNq/St1IWOxLMnDrejwI07FP/b4llRa60OzlL3heZ7HCJxh4Ojadkhmi4Q88U5I7UwhtzPU5v6mgGMS8Ygk75Jk+OzaZnX7q0SmqTGqyIlW0MmQsK4ZSsAN/wzrc0SxvvvXNFNY0lYD7LlIBnylxy9cAvg5pq3+jBy+rjmy+e5HvqsxHsNGsp+mFfazC1vhPr93LZZEJwzPUQjGNsQbaIkriSqJpW7d5/8WWd2m7w3M0bWNA5IqmG4GtJkSFePi7cHRP4WN+WxD/1HCrzotv5yTUu2m+nrzfUY2bzrDxJhl5ABBLe4GK7BxDmAdPZ13TuFNcqc1JmEqHc/gFsdA6H9zmdJaLBqCuMEb6BMN+V6BFMh+2yFCmAEaJfrw+dqgx1FdDmRQ7uAI4rXXIBDYqmcaYU2lNzbljWOr2gKrSo46FK3AcfGZu3nHBHYQsjSMKY33zcvrGne+vZP8zm1AvnYpFnA+/xYX/FMa3avo0RHWob8nvlvzIUi1j36HhWefiEMdXJ85IwPh6m6RrZEV6G3EKdx7yA6GUJ7W7PyiEHBQAVLWTMZBQQm8JFOLbRb4G+0E1gzup5cSip6gIc5H/AEHLXKXUIUwKpP/uwP8uTaJxdkaR0V1C8S5NZdaQKQBuyWQ5tcT9HD4863PJYWkAwJpXlSPGHqN0aotPlbgIdD35BoCj2og0LgQKwfq/Q5gVPA+paONMupfHL4aT0KnNmaUn/NlrxWT8p1zEfoXodcMFiOHvCpM2XHBMZbYyLZ0BOgogz1ayAwDU9AhGdaJ0I4uczTHQTt0eJ5Q8Jn4CgIiaAh50bEke6o5jKn4Y79/32hJastMS1PvNNmPQD/eYFmiX5uoKhS6NEVuj5cHw/HktbaSwCPkkmfzpjoEwNvwjyOKtKShJoty3XuiexW7pIUOaZ7oOKr+9FoCuo12tF6IDHjMh/daIGrhA1SZZ23MU3PFBinULMI63rqo4+BgNI60CtOjk69b0TTZuqkEaLY9xQpGkIfMwzZ9plBGjEVq8C1acsLTeugIucvw3YGiU0ecaFWT1PJaeMsng/jLSiojmwmsZiadZwo8yT4YmK+VE9/bnE+YmfMc0vbax9/VX94Tgsd+AlgDV/bgbeHmL6t95b/tZN7bA9/d3xFC/CWK01ls3hzplJ2i0fLMYcEmIpRP+eiCI+9Jhhf5TwCnpKHr1LLTDh9+3T/fGHJ5jUuwMOZxjH/nCEdHNYmO+AmS+W6Y59fJJdxgP1rynZCI3qaoSgRLLx1oSv3+6EQu5t/CVbTf7nEzF+FLGjt3/pfkCU+NAPxD0gOU9Dcw6Srk4cmLAugnxuXIUHvj1heyUzeWS0xJIh1uHQAnqaexUXRXPzVqCxQ7IspXvfBh+LKN2yFQOfIH3lwiakzT0eYINbqw8E98Or4D0pSBwHoepOYAZqDlnXFeXWKNJcNdS5qcS2lacoUkCu+iE71DBVOpQFa849Qb3z2hMoLZdzeDuBS0rLQEB+fPghV8bNeQWgXTbvGbz4Oxshos+K3ibpKDyL+10YDXFf458wxqrXRx0K4SdmCxq12N+JBvX2PhwmHuGaX/P6DG9v5lJxNQl3HN9crf3jOavb9kqdEJ0AzUX6lBduZDPsuPCkOmiF0KKyoPoupiS6rg+Rj5L96Yqxem6MYRUWSB88HuBM2R9FQNTfx3N89nA5Tu8fxSRIbGxmjQC91e4fxpuZEwpnKeA4HS4kmCKVnIuKhi/6wbV5xN8z+7v2YqUVUeQbkRSBegBIbLbc7Vm7M531yikKHMOugOwu3pB2jctzYeNNu6kM7pg0jyXFJ+zke1cNd5TYQ1jw37tqB66ZZn/OYCflwalkDVSx/My/Z10DbZOVl5UUQuorF2Lql1VqTosHhM33Rkgvpwrqj2XMdG8ocr0KS8VoQrinfE5kg3GD8w7L6GmQrFQ4V2HafLPN2tHlz8zSMcMow959+lvDAyL6en60Zzjxib0Vr9LtMs9AFm6b7nckzlD1EZng5XrXoi3+jRDjMEf1XtnaHxw2koH4hyDo0p077PNPj7d1qYi3NH+apPLOO2tZmlyuC6hTJk97z1t7UOAQuT0qpQuo8zQ5APxaT5D9HB2k/+7/R5MHgLLyNkCOwhE7epPlJds2O8OIbEzncwF1lT3PAMFzTQlnEvGxpnHo3bcSWV3koNUtbPL+FcwJGoMVCe0sYsmIEtuXfA9q/poIYFT9pfaF6oHmDsFzSGO3vK9Ja2/Pu3OZeFvka6j2oxfLYVPVL9IGTLr2/Lyv4qXDLKvL7G2wotj104TTArdDXsy9JZRpKgJtN/1VaPW/Fd7+upMInFL4z2A0/mPy8mqc9qdV5Y+Yr21+ECzTAvq8JRUICW0dqtEZAd/qJceUMQk+jePp78EUE+3ZxKjYpA8FbBhybO0pNU9SwOJidD/I57rJA3CnLkeA2udmjuAk9wADyDmXd5NO833/5x03jEjJ0Q4b4h49YfAFNYGYbx8XjsAK2lAd0NlOBs3mQFypJnKsoqOFlsJhRCpFhK5Bk+wMOZzAJ01tCdW+iokJkyGtftCD7H46c5m2x1mjN9blZDd32BQUkJXue8Ee4IPofPdHxNdt2d49KjGOmAzJ+PhdPIlFBra4NkuADJ2/V7pnoLfOFUu9fslM19RCporaoscuCwdV5shi6pVD3oAu8ZluOGo1xmpSfzvB39SsOfTreW0MLmcRPKoyIsMyMpl1AZonmSCrVkXHXKJ7Og6fXvab0c4+hT6vFlXbsyzkVrIBvmo2esDk7Cmix7uldVblvvehdmIkAPke8BHEUb4WGvDJLRG9YuC4KcDa8iPVIB25i+g9rHUvzrqTOa+6u2LHIdHiPd2+GEfKN/5VSkusaZ1RK5Tk8/iCaj7uenVwAZPom76OkNpw9nR+azndiv86s/EN4uHK1ogMQk8kBdzlzMbPOa8cQ3e29SGIwJWleux9rjA/MT4CcpgbbbTiYif1C88qdvOJAOHaExLwc2Z+iqHOFSbuuyd1Hx/CkYhOW1vY20dZeVGxycvGcKN6NAN16tnQarLbOLBkV3ZjayjDNEKfgJxLfxNbSJOOMg5SZWq6OBN9L09xx+z2xgMc5vRP68W5PAV0gLc3IQszUe7iWOjWRdX19wUUCf2pfsaMgEcd45twB1yI4jIkmM1TSAsL2ZHwStwKQA68VsoYBpdIzHWqeA4ToFvVP7aextVVLEYfbHbmPzUB9+6lLuTMEOQDMvpon9FHJ1vecP58NUhwX+SfNojHXZWV4vYSVJLqNiEYWkyDlgxE94sfCLQjTzgUw4UvteWGV9+JNF+5atYXwoRzVSsO/SjXRhzjQdlaPdyDvYP5BrB66ZRRfCsOnbcEQ3rXPP/w7TOCOdC6rSK2kLpMjv7H+yr+PzPlhb52whMJGud/VrDtM4I50LqtIraQukyO/sf7Kv4/M+WFvnbCEwka539WsO0zgjnQuq0itpC6TI7+x/sq/j8z5YW+dsITCRrnf1a4bIYdqMYokFZJbNpGe+LP/aEOgS6TwfnQggwe8sZ03jGUeX7TEQPsz9k6AMDsB5+VY0sXUB1yQj/1lEf0AZ3spAvHy6ZJ2RH7ITJF9UH3uxp1b3Ev6EY6v4MccrrtGUBW0tPkYNCZBfelrRNoWp8JdjVvMnOuT5Qw9D/Y4KDNMhGVQwbtFiYwe2ZO/uRFspJ32pZ+Pjz2wB02SVGwQp2+HEcfl1y/kngdaKt5Xd8rBPdF+YGYNJSzWHn+Y2ql96j8NqrEjQZLTyCftphBrs/0y2YRsRjgy4ltk3V0QU9DoGv7HYJaG16vzZJjSbNsXo4EUl07y6gfaIKx5n4+Sg4fB+qMI2+lB+WHlul139DwCLDwru1B4TC8t3Bbex2xVVsJHhdPm4Ph57G73qaSp87uEOLdIpeP4HH+zk3rUFjG64wXFzjAHuZyKI8J2i7iLJIVQuETXvG9LWhLDK80oN9E//R58FsKbZGGiUr5mfPjUeWQc93TJIxXGqn5seHN1q61stgYnAez5HycioaB2yLasxqk/HECMHuPh9BNoCMFierj6pFwz6Xmhg4U2ifVZuauRIv5F1zJ1bGDIvdwZRyiyvpzThmANXsYC7O+SciUJAivDOlujU2hZ+5Ajmy1jbxRjArGCRvUcqas4ZK0KpT03WI/9xvgnlNj+SxhtJYtNX1yR9kASUCV2Run0af+Rgw5NjrG3ut1KRRSVn/2o/XkM41S3KWvgplrSHnEeTL/+PLbqe2tAyrowpP33ATIES6uMRPJ8ANSQyDVqIaMORi6IYvBXYU91BZngP8fkQUYVo7T9MjWH5X2avTISVvz0nW8pYmsffVP2bCrMgZ356fyZDkH/dckUX7TUirMUNq6jbwxp/SQOB97MOsGMK+VpXpN+silFpr4aI38KAAcFwzl0DPLGSK7k/VaPlYvTuS6g/odpnIiF8qQlJMamGsrypEXuu+/O5j6xNkMfd6/CRWQHgFAgShmsPLGzBw8oVodZ/y9iT+3hK9QTvnKXQ1HroU59WUn64xQJy108geSJVNtYUAh8bnlX55HNxRT3T88oLHzyeoOTHbU12GYVp+kCT9fw3rpHXHZZDWP35kZTxdsGSQbuTLHI1badhUucxHQAD37G1X1xHuUWeGiy/pVdimg/KAYF93vttRjH/BzOBNcvgcQSj5vl1vH3HpUyMYLSgnej+3LqlYQOjFrBC8RsupKrxJeDfSsDUVGM93Lm3ewrYU3R3tkR3qZGyqQ5HB1xiAT2vC4rxQ0hTQF0JyWF6PgRQ8bYCBpYElCVMIDwLgLCGQNR1/rccnBFxS3dq1v4LpqMeT5HkNITo2tF27aXfP/1APbo5sE/yMl71K/bc1fiVa2vJ5Irh/+vM8vgBrPB2EW2XEnhDH3OZ6lZtiIaO2Eo06Aml3L2xVzL/OvV22EwzddySWTpbFpkSd43ZP38CCoSBTHdeB0YNGtrR/HyhnNLA5Lr1RKEqwpabvFApULGHVaEbCpRCi26TiYIaHAwogIawk5aVJ+5pZfYlXhLaGdwmyGZYVeFNu5mrqdJo/rJQCmGIOyIpjVCVhBPEoWG3Uo4WobsU1GyxaxXZ9eawH/socvajhDyrK3KKobmAvmm99XlEyJtORFjKXuZX5MokQxU52bA4/4p3ebBV5XwpPRCxujdlGhI9lnONff1uQy/5nXHL9gCt6xSJO5oSg4+orHayAcVGIlUSAgbwf4Zh+eiEhhXQWXd+GRzz1lH/iHVn8PWaoDAVjnn/YoLYdlYdddt2B4byCP5EfVaK/8gXG5iTiTP3bS070J5C4mIRt4OlllNhvvYBor0sSHBcKUoqAe9sSFHUTVqrNSz4BDDPPry/Ye4MUWhvU+L0fBpfyRKpZ4mFkcydanLA1/4fbgEJRwA5x53XX1kkhWkt2W0fmSyWYTJz2OFDhjo2/LhQZ0YkAHlf21eOKpJJkUZojNw7v2cmKdgM9AYE1XURpLeSnElEqbSKcE00nXxlAxtOhwnbiVeSUn8AEenu95yQtEEaPKJBXsIfXO1wXnpdoZ1EQOERaO2thidrPLoyP8EYP6GCDOZkNHNBvX6vw3iyqS/PGZpueWR9r5pkkctMA9fJI4M1OiQA/MKPhSZMOtYyfD+j/fGP0v1sNzpRf1/le5OFxuFbHwx6Nb5h3FVoMxCblz1n54xHfX9DrkUEHrJNCJWkFvYxpKfmtMoEPMjPkr9JEXQaNTDl+zT1QtiGfwMBrTwTx/OwwaAuL9MSNpYjB+9TvlMfrAEq8f+tjLNNO2qsy/WOGq7uYQqxclRX6KSzqmnjqxXnlNnB9JiGYoWFMrUaPl7PQkXA06pt9+9WnswCXXkGZfqR0rOlp1pEuYPzj65E793c5xZ8kb9wL8RAcUf001MCfHLZ5PFOgjKsqMnwLiNPyWs+bPHoFTA1nRTnsY9yLuoQ4FKR72Z9Q2OixWoWfmM8vO9DD0b02tTgcSwyBmVaFmMr4gWfdHB40qx96TndJpieRIUG+lhLuviH6VYcBrvaPLAo2ARnQxs2wTKZRT0ppV9lW25F+nAsEO7kIVL+0TuGL6M8HX/SbCoRk5Ttb9rAN9oHbnsvESf5c9tfv6mxRfZ5Nhg2e4NxNhMD4gWP4wDrfSiNcZyq2X40GhYRxPOZmjGUy5qlg2ekby8QCS3YAo+Xfb42keedKA76We7Y8jjFqLpeU1Bx2npEeKHrs4yKWxqDMhc+ilU0rsYs6rviYrt+s8t0AJqQeKzX7Oy24oLtci9mhKYDK731w0ss8J30JAs1/QqZOyoyzhVDEiLBRqJWRXbhEfTTji0wNYlpIFbhwyQLR80nKxX+whzb+qBaV70Yay1qxXrdzFLNI6ceFJ54T0Zw6OTww2TB9HVg7DvxYduqp2ogHyD6FvlVNOo4X+RMLtOodFZV2nt/Tp/uq523hIQ3bqqI06atq0gHVRj72rR1fZysqivbss7G1VvpxB+ECoV+9LbjmXQPFeBbcPHyinAYqukaEH+MWSekX83UrwMfIP4wn9bJ1T+h7uDoPnCtSOaDiKFLbtk6sQ0QPM9gUdzZzj8bHNsqLoU8kLY1zLefzjF3E2rq0HpFcY9AHT9TViYM0isSDJ7qym94YLm/jkV4/SfDxl29TgGzu3Sf/XpfOAgdqMEtTSBOPOQ+fXNIHDVRQca+3M7hYMs1XzvwTawbLSx9C81LjcJS/wocwv167jdHIciU1dhhRy/BAIHY9dwFf9/VVnLy7CsMcvx5xR4e6Rg7lW/frR9u5bVJ8Svrh6xKpkyCFdFHaCyvlrNTRVX20+o7mfUx8gQaIAmbeGMRFKJrHPIwD3ZMjgxo89kC/LuCLvBqb7osU3B7+T0c8LwbtBqxFNeLkoTovE0Cn6A9cM9gB7/mCHECdzK7mHJlG1hrNHTFkZPOXRf5Bz2Tb5S9uzzNeS3gfFxeoo5EHNcflK97FNalwm2fVap72pZnLauIPZpcvOoL3E2ig8h2kv2F0gvaoKKd+G86qY1KsLr4Z93opk48tSlV7kQBrSRRZolSCqurX2h8FfvkdHmnL55Q9gZyAT9ax1MBKheU30iyKCVmXQiuc+loeqc0RLqb7rk0yr2DJYLBNHftIQMuF2DZGF3AGtV8a/yCqTE/U4jnU/lN2y7eKTrstDGeTVk4iUSXyw5K4lClmjISeNPzdYhegULjPERHJK3MvWsDe09e1P9c6RowDSeN6CxQubxJGqQLvqnEkIMzlHXVE0bQSyHh3TCvx4gR3hbVxDZ1nUsPniIaEYyFYlSJ+6FRowHlsqpcCh58EqryckWvTcQd1eEusBiDy7Tp5rgmeZLeHBnH89Ejut5/2uwRH1MAe2GVre3grwnLO7E03bbJhwvfGM/0k7LMk1tu1WIbwZ+EjJuCf4ISxNFgwYiB4zEL6HJK1FOwR/99n7gan7cD6le5Aye7wsjUwexcvtdADJbqWzA/UB2INLupITb0nekcoTYvih0bW2f3qN+vTy3T0q3ppM85q//ahmHFo+uF6xLN99bcOROiExABJ4BO4dXsMp+o63regWuRRsAdLa/rlDDgNd3F08+HvDA24eJDSesdf83584fj91epTSwlaSHFv5ZW3YMZ3rL71PahjOpWS2+0/WpXvZwhHR9MOM56qdQkirOcjq7EC+VI1KbekV2WEBek5j5acuByXg0legB/+xtL02fSnnUZi9y4eDX/bx5Xyti8zCrvtOf06SXL4CyGilxKVcy+8JnF/c48fRxjsY7fUtEgAKPmghKY9P4gXO+g825c8H2YP8o3bi1eRpUnu7VEVPQ3u9gVOLJznEux4hL1PAFGDYWc/hOHD8DhEzg80ahWkkY4fzJgPh4uAGwGp6q9eiorOQmtn0yESruBMWPpGRJRpHNsDtXbuiRf0V4RMhJ4dw2QFHCXIB/aNGaj2YFG+/cYa1nl/SMh/bI+pC7r+jcaB4vuIJq4df1tA1CiG6YhZ8LAD9qGneMQxmos2BeuSHVc+zXKIthy7u/KRp2DScBuspTbIzJq6VLjNkWBXHUXcSVmetS6Ycf6gaKxXhRgFXs0boQS7T+fESx6+05CDhwIlJcfHWxngKE52kZ93DfNCLurXLjoR5cA0lZMwaDjkxai7azSwTziGGnXRBUHbRrBgHP0MsagyLvynUj2uywUcYCL/rk4uA1+5GoqUFEDr+QOAbJXnjR8XF6ijkQc1HqJXLjqwWRcVBc8idsdk91VhKTgrJkTeu3PpDQ0HcxIMxzQcGz1IM4f6dqhQ2xoTAnwiQXw8xWtzelGVO0/h5xwOBxr1rLpyNZhAd5TFWVp2KeranQrvDvan0/KvJIm70q4ZYyFmmxjZO/RTiRtCwVTFgIsde6BRCPBMPnIbfT/f8VyQHhJKUjBvmLkNAz2PVdhUk2/kTRPGVQRasoRjKXfYQHKXsHBAtQ38u/6OHRskp4JBUj5GMLdkzQM/zMXYpz/ZPTAB8cv/97bn0xNLG1wrGYG8Ratat2TNAz/MxdinP9k9MAHxy//3tufTE0sbXCsZgbxFq1q3ZM0DP8zF2Kc/2T0wAfHL//e259MTSxtcKxmBvEWrWrdkzQM/zMXYPl/XuoYLriy2ZMWQ2VPlmhOJ4oq3EUOU5suy4xi1xJU6Y0gjjNVCCWVCtxT+3xA99uGwgnW4laHWlfFWzIN72T1QtiGfwMBr20WunSyuRuk9nH7xOs9pckJaTS/RA3dBqlVAaLj4zqLwJZHz5xMLS2TbWVsy3zjOgG/nj3LuvYITb7xtlKjMtZd88UdmEenfeYL84pB3mh0FQ5+YIcYztuiYE0nd0N0dysRAPgwdd9cELd89kIUHfyS4QuHJcCcWEz/1VJM5b75l/KnorND8aJE5Hhh0HkUV1kzNzyTfguACmDf1ETPWoWUdApAalK0+X3DAasdl2lm4kqzU3FUh8aT1hGrb3zW1YM2ehtivucgsId9hR9QYMji7WAzNoQCguJKs1NxVIfFJznOUFVkxEawJQN/2TJgpyByVdAiPRxsE1Bd3vy7taAd5quFhxnJ7e0RgtH06miX+wTZreQN2OcXFS4Z5n4WBsFSGV1iLORI/X7xRgutZ1ovFvXyviHu++bw2xqwht1ZYJzHJlI4ZsBqg5O2pW9+xKFk81o5++zboYi3JJ2XrS/XE0ADpY0gDFYiB3pwUaEzB1fbVgpiQoi8Tp6yMrhip4qyxmy/UMqm/LSpR6kig/2r5Sm7g0iWbX7YvBWVsIH3opyQ/fC/qrWUKxSxXJRPuNnsEyQNztSre3jT0oFNOaoLQa6tImozBEQYtR9/zze4pUb4x8Hl4GFWa6N+rN0pQXdzr3OEnolkO7ou/cMAKULh8Duhnuk/DBX4Bt8xyT1erZmz/IrWsNPcmR1X1DGvsYiZ9e2cHzj0vOoVtZAFxZZhWhuHaTYGrc4na2eHJS94ov0ZZecowWu6vAyyB5Z44Zpt5nnkQctO8jb8EQC9VpD2yEHOq4dgpN2LWOfsuA/VS/2Vqc3mVWvX5d6HGqZ4/25XgvWljzxDPa6bvprhBBuQrQio1+n8KSSWSCmUQWiXcBbEJejrRbnz/YfSOTIMLHmLDGr2bDbvoaw1Ig3rZF2XRyRrhbnUMy4MPOqTPQbeD2n+T/ntdX5TPvLgzs3Lx5n/d0nt/fdVXunyXPBclOYwTYYNxBr3mnFU9uT0Bn0ySoAXizp3+0HJYns5zZFtDM6THxXUapZs5rcxoh9mgmBYn6tPguZ0+jrlqv+2JEVJUCV8bJmlqPDKjgQO2EEg5E9KbTjlGYQS+MUmJ8JSe6Scq4DLGEPmhbzKVgbL8brmSrvy0gxQTaTnStLb8KKmQhba0f3L6eMuiO36SxOi2L/VrrXamgaYsjivxLq+yMNDRo4TLtjhNT72Ab40LK478spdjWZH0iOmQeJ32enrIKPnaBZRA4JTfvp0BQHxihmdHYuH5FHBq0F+oRY/H8iYADGBLpmfnTh1sjiCwliL8IU1ePgvWxNtB7UIm+n7Izuh5Vus68+Nnow2EWI65Qek2OqHlE/9fQbx32tY9tua0kHNUaXnoMn19mmCc/+lLPY1G2uSaPK1QpH5Hoqk6/womxnmhSul1i8Ou0goybXz9c5TcumEEE2WFZu3J9GYmtvI3Ys5wYoSulVe7FPTo6PWMjp329tBV2oxGkEHGQL2mSsSuR/Thgv8gY/TU4X25E0i0vQts6+f0x7NvrlSIF9UxDXswSHJ63FLUyADGppr0Q0ISqBdGqlBYONTaCEX8gxFEp3P2jVSZUmSpydu9Ozt8U9jXscllDbXchTWU1STFEMU3yeQVCC5HnccOzaLYDWQHb/M0/c5y0fJypFGiJX3FdNLzh9m7Nw2OlUfRnx7Ztaob9rKK8skec1L/5Fr+5ammkjs3g16jtsyV04lyf6Ae1IUXEjo+nnEjpfPza/Cm42NZLruGU972xDy5xktdgoiyBVXNjA6xfqSef9mZYOxxauwoAvlKoS26XBiRzBBIlHQZJnxYCxCUtJMsq0xi53CGnucHgedymX2IBTm8bxvMnF55KEJsR5nDv94zHUbQiVdKGWf0OYGJbcjAWxEndjFkjal8YcwX1I1keYEitx9Qisyhlg3id5lu9NWW1pVKrgx4AvEzGP3qyo5wWOBc+21HHrEzwXCDjsq2hSkXruoazKcKC2hOtwpuSWnl2dfbAk14Z+EXBRGfPUkNrvu9WrIdQ2EiOiM3b5hc7mfu1HVhRT6zM+h+CeaksGnoXjUJBiwnqFwJrf/NT4mSve7hagClngVPjQZNK8GUxhnpFQZaJ0lt6v2YNau6eCGlLjfEzDfLswob/7FrINwiIMga644nEzkI8Rt6l7LEnOLnzlnEJ/cQm//p+yKK+8E/kJ7kDtcn4rB4IAGzTNWTA40rfqoLRj5cYtWZohB95XubxPTu5LukfB1OpZ8CaBKTcDcwCLxUtXEqDRbrQ3rz7n+eNo179f4/eKzreJSmnxoNFhb2gSlC9IRHK+Q7quzPZDtKggIxSQfVgP+7axHgcCNI2BThDW21UzM5NFnb9Fr9c848XbrRtNGa39B/8iPP4BlO/nZ45A5UNLEdZWqYottRH1EInij1LjrjOMEFlYZ1NNdTv4201bZifPudLwghzkBRAjEv2Cv5IH9hfBF2fCMyytDOmFOPINSc0+vT0Z6WZo4cJ0k1reIenvWfSMwy4ZYmExbmmoM+26jLcBF2pubqSCRrKgMOfKPzOt3hrvCKO24J7me9btt/FVjab8dtaO7XbyVwnOmShvhFKmf1bs/EfAwk4DeTX9Z2lLzFDloSyTMOEXOGZNL8GnpeiqK+eim/W4GSXhDO5TpfZ7pvKhqQW48OI5pE7ffnTfvEKfMmvHLfSgDCVr9Bkr/lOyueXsx4Mpt3/gJMUwgqZZaAGhmt3awajkCQ02pde6wtg/1JUlGUDZnu3h+VSWj8kGChnCH/d1zEV9oJk/YcvzxR8j7bnzmrybt9K7p8y37RwLenZgL3kxYA6tZNcGYLrheXL3OGb3YxumN9Ob3XGrOf0sVUhr3tPJ2dI60GnaYS1Ybj+By69Mrld6utYPEsp5aA4F5iW/XppOBQr3iqMXUCaHHxsOpsWLBkFkYaSgi/tbmOj/6M8zTW12MqofHkoTovE0Cn6A9cM9gB7/mCVrvTTPK7B8mQSEz+qPS9YwfoPg1O3IZW7kFtt5vEeBivcoQpsW4mj/otFNassUDuFIr1cDfAEv9P8IHwOBiPFVzp2NiRojSzHAlQhm7M8h0TLTtqh/gRms+T/S1JlOGDVTlPw3iYah/zaFsOyNePzDrDaCmlbADQo1Vf8jb0tkBE82/TWlrB5QLtfewZ5K1wFlrwpiUhsl8m4d+3MwLRuBY8y/MwWTxe7STA5fZ3JFrVJf+Ns9+O9rR9CaJxV1tXXslRQ02WLi7kWOnYF8SpodkWZLkoG2Bffgh0mScfMgmylU2uBlsumuL4ZJOUYXp72AVSVmZMCw4Yhn3kG0qeRrfeVD+HaX/vcrFyst8AAK6vy7yYk7AT76VippkzpSVjKM1tAkWY+QeWQqIWv5t4vO6Gh+XMlCtlLAporwwliNBVCgTpfoHJy5gnzihn4LwY4V8l6cQ1C37yyXp5w2/MeJJlQ7NYaldtoo3dDcImNTg9ULYhn8DAa2FMu4bWxNqwyVvm5s+0bLmjQKvy3MVNIb231t2/fNbfes7LG1OKpaRp+tK6UZmSEXLvc6w4Olyo+yHkMIpRwfon5FYUIGU91FGu75aWA3gTUTapOrkQvainRkGSECGLLqAFwH5YGWeXTJK5h8kX6cE6PjqJ6c4B1QEyhu1FuWPYC19G05AbQaMLsnhmAPPIW7dVNowgVoRvxrGQZtbQq3yqsECEsBPkFYkiBH4pVkuoTRu9GDaIoF0VLfVL4XKqYH5BL/UGv9Jdx4vlMcWJ9lZTYXTc0ejkja8y4AC9tk47/WGXA4MousYLPxJgY2cNX/ecYBB2SGsfCCC1uZ+WvtYLrySJ8ePswQ8o9p4MWqyzZuNEmDiD4YmVyCSfn8e+PL2YI/CHaNyxEvPPyhuAbE5AQjj3rEUvgwgish8+EufEBk49c1chBKw15TkSQre0OwKw9aDGWs1x4AO7hvNkFO7qFUWWzWaRaQAO2zWCTwB76Znh8HMRa5U2knYzlgAm17Zmi2m+qmBwOdx0wl1NTVZBQ+3Kkw7p0e67tcCgQ+Hs8xwuDw8yxjVB+m7rBZbpbexAxi+iwbBEA2uA5+Cto5IbKXUUQBW9hNHl6SW02yzZew+VRVTYbBGLJld0J+iXuH4ufeYhECJL+mx7H9+N6heFcr31mUuiJDSpORv5XLspWJW4Tklb4jyO8DEKumaZs7LWDqiDxxaMCst3/s4J5IwyARx3jm3AHXIjiMiSYzVNICwvZkfBK3CRRzyKDGXhOwUWjEffntVh7jc/tZkSxlvVDOUkT2sBHTIBHHeObcAdciOIyJJjNU0gLC9mR8ErcJFHPIoMZeE7YEJ2ovH0Ty3ozXPQaO3cjiqTCGBgSxUfjaMHxvutZQXWJtboL3JCJE1o4Y+chAdUPnW1eb+GulVWyxwhN5fCIqFAqKzpk0Sfw2SLAtyhlg9I05s8NX06axQWwVG8Mj67qMMSk900vI2YS2DIx2+aOpXmRagjxfhATX/02gKeumwajYGrkQtQnNu7O3jV+xECu6OV7akAckRdo8a0hPAZoazijXyGg0fmCbmzj8jh5qYpgr56AXVzGcwtc2HJSx2trOKNfIaDR+YJubOPyOHmpimCvnoBdXMZzC1zYclLHa2s4o18hoNH5gm5s4/I4eamKYK+egF1cxnMLXNhyUsdrazijXyGg0fmWKXP6PY73FJFPrMz6H4J5hXYUCPn1h/GrxK8/MrwWtBfscHEgivuQpkz90/wH+/stViG8GfhIybyIu43K/Yj8pdtwdVwyNuFHuM6pmk//4FxTfOJgDlqSwixGW5WPziDrI/kDSwqT+rQ22TqYqU2o5roMxx8S7mEk7MttIwOcfCNk2S7Hizgo9J/jHPizVCiiH3+UTddDnHMxnIfZwqc978jzUmoPTNvD47Rwa7NDlGyNGYaT+7EuWGROB/AzH+ZyBGX190/XB2wocWpF/kVrRjzU1R7RJSDsZO6EYN8053nLIg1RWVtwgHJ++gd4P4yXto7aaMmXUYU1Eo8fPIOETVNR5/an09J+F6aZkTuU7/fGA9Mx8/uWiDxn41SMdgtMM5gqTgDMhQu94zsKBo+o8m/MlKFApD8vy2/BMQHMhc1nSFsTgm2aD2bw/DWzgUuZ11kv9bvw9LJYaY4ysAW5YgADeN61K8A3QAmpB4rNftshLywYyjPIs2OlNbLOyxk1yD8Wzxf0PsvinWwo7UPC+xBkC2frNOWsbHTr0I8fzyprJzUZU1NFLdGCvjiXinfEzTNFHQGQECZ/0itFNEW9jtSYTwLEM8wcfGJlmmlcZMwZJP2F/8OLW5mD6qqv40Y678NLn/uncBVTmbcUoDlxQCe+Cqnp1XiYXmtYuDs1/r0sIQXc2iXKsYWDCcqdJtd0nC+2JjaY4zH/Ku9+4QdfuBOd2H9ihIfeMyYo7doTND7uObe+mqmNGtfRSz4tuKvvyqluj4X+2gS7EvBfCcnqEMtkG614VIyvHhB8z7TjAyfseM+navaC2azYH6/2zEsrQb+FoQHhv7VPb3/PoIZUbnsy5nUIBQyb3rxXZUtgm0PWeOt8dUJA98ss5lEXWnqqNYH2wwJ8PU37ZMSAEtrthfjgbhCsjwhWEkMs6rW5mQOAo4KK0tYO3c6J1xDkkSOmnk7+d2R1OeGGew34r8WCTgNKGUzvnTWgfHH72J1guAsFo3ifrxtcvlKgLoqVb/PrWFb7DGBTAwqeWgj9/sRMrDClHZqn4tJcjOzp/yrvTKYcb4JoqKtUl2tt93EqxkkYJsuoHL+p8iGde4H0GocXZPAUEiWRZIsUmwITx/fuRv04hxk/krvxKVDvM9TDDHHLhFJhTBzGSNjuqosQnBeU/mvuFh5RjC/x6cpDrv4K9suT2SAOxtihq5vQwpewrUT1Bfq+LaIFMDcksJZcgyIpmicmW4KV4SyTqHb2H+EbxmxVoA/eN1Cve5cjhoY8k1JE7NS1wuB4I9h4zhfg8wnDPkAOkgDacM4qIXsy+OzGIfjOMSFvM3PG/FASDSVUcRTmlJtkEW6jAwmzsq0LV/rQoLRmqOoYtGoshaTNPmaAR/PS0xdGJTE2XPascZvjBbS4ue9pjR8VfEfcgKe4HhB3XMzm46fiJz91DNd8lIYhc/MuooDLAUZIMuJRlyv5qiUxsXDlzyRS6Hv0U1MlazkZaMmBS2CDqQrb0IHxqkXoT2RyXzHznNKBwLQxrXYmQRijxisb6+/Mv8+V3KyPXa37Xgu85CJAix+rKbnoQyAkymFBCnijN2sYQfft/l8P9N+UINem3/X6q6tSkgO3ciLGnOe64Mj9gqJFwqozkqfDT4Lzsp3ZF8TgBVXD9YZL/7edLP9HdI90xaUlDJ5KifoaS3+JzimWO5DAS+B3J0DZ2/B/VeFTr+zmLpAjXCNuhkh9FtRCaev5Z2qtxCQpBpBfMT+cSajgAXA8NGpmSXqjQwIY92kymxnqiU/XF1jwu5vDMc0HBs9SDMLYvhRsIs4lvbqDAl1/vYfZLHh7s2xSBzyvQLeiJJwtY838s9Ai4eucsNPL31xIBAN+RmyeV7uWLW73uol2wfnm5VJrD+NfGQOQ7qmnQZOrg1qgTAEYIWCDQtaKNVNNR8k5R1rAwrktuIuz8YU+ZDcVQIw9PJPLGv5CUELUhO2GyDjVyU0yyjouclZWm+MCk0pEVS1VBmjU0QQNjPHoa/RyCfH6tEX372//SEXOt/p01Fr0MWe6H5v5i8wmV25HS3nNVZC8Wgo/QQeqq7W9o+zfa2sbrRnEpuN6whS88VNBbG67uYTGUE55OEIhk9Cuf4pmHbdh6Ao2uin92e8oM5R/wsW+Flj1kbGT0cKKhCuEpxvpicH5hv7b+oEKrIrNnrc1tTLAYEZLa9HdXXKQnFuF7O5L7hd5Ib97L8Ab0YlWaWm2YAnOZnipngcE2KSWyy4W0le1tFcZaPMpgxiLVAt0jfu5UlPeNxHwIkfU7mOwPyBpQBwv1kKqMWqcJ5ALWd74RAAJZhwmEqVQ7bDuKg6DcGtSww6r7GzbuERREW0cpp5rb45amHUe/izMPU+R2qi3bCOb8QOaQpF1PgdUGPxonqTzFZWMiJe0S8hnmkUzxcKw0oszNdTxfBGSfxCFlUPhKWhiITMyYBHvXAzyMo5fY1KCkaeLzoHehZ6+xxDO2wryxq+PvfKYA2SOUW4piREuwD9fE3en8iFAL6iJjVdPDaXkXxpgpeyD+8qpwEJTRvCQcEmdlkdPZgwkxsA1Exg7dOvjhKvAkQgGobGC8q1MKQ8EVwDy1TfQMT6lkV/hjyWdowty36zpsSl09j7ozn0GkVRXLjOldipHkVCnkZ4kFwChtjysRBVV309XA1WKer2Zh8AK8y90b0mnLzjLjZDayNZpZgU0eIdKuj4RCpDwQJL64PFLrfj3Jw3FV5Z+tE7D4c285GraNuniQv1mZ9e2eAc+MgJEMkEzR+SorRwgBjfa5IF8QEQvsYVt0S6AVsBM/IATbxqSYB7pl2ZzzFgAM1JoLBgY6BW6b9C8hxjr3sWCSRoGyb5hTjnBV0nu9nq90OgO6yB96QnwKTX8fn/NNfpsVp0b8UuE5D6l1+cSQWos3FnAQGDedXb/wAdwBoFr1x2ayzkWmlxhWuF+cgmtsl9iCBGgOd4h2pWuYWbQT+lo0vPtbpXKusjp6PZnzX/9g9vpB86yCyuyQTftubmKaAFHSKgF2UlU84YgkCmlEjtji8wWWQQ9Lxmloxfi30tcLGMx5Bh5ss0gnIftMZjXnI4yY+bJPt8A7wSSTYTn0yhTOF1GROmr6oARaGiciUj5SNaGi9znDT+a0kfj3HzVOFPf647ZE1cAjX/c3h+taF4UeWS1KtyJghhqD2Oawj35NiV7F4qqiWeTOAfWSq79Fd4bV0WbOp0xUgR555tPjgosPVHlBvtvdMvpG/FUZErNi1lulxLzrwwBOcISwYaTBpHNIybRBUdAIWa4VDU0BwF0lcxtj2fmTX9if/JTEb+X/KKt8CnqOE0Eb3NUiwjyVOeXGWfEMOsaZ8h7mPjJXPdwBCfpXEDkH1uN2wXnGQ1zI69YgM/38pWSrIi+M0DJUTx3aQTYWv9QJD/KFSOW+gRqffgPDJGl1CSsQGQbhBvrXBQfSDbfLxQqVxij4cOtJo0YRJC4noYh0dm7wVcbeBGLSGN8JsKRlHlB7LnMbCc/4cOhvG43aTr1e4GNyIn++NtZ1LtkUbLMk5QF/csUM/iRyy8ousOUl+D9WuLiaqNAnCy/pd8ILRwavim/TrR6tMQ0RT3W6842BM6RZo2ce1/8rt7WYIqG477RiMF0ddYcQ6qifWfvBiMcrWIwVLb+OcmYkAGbJBqXgl2M6BfkIP6SD5S/uX62khQ9VxSUDeaH5CCqRvrYIAJGjqx6AEstnLAI2fISzYS3ftDFJoQYFBhvQEndPyT2ujAQhHHD9qX2AO9RUFhxw3spzZwilfm+dJgNMXwgSCpsjk/vkHEigfqhrEARUPeC6Ocuh0qbigiYHGPQqwZ/yFkPk45UP8102IseZVdNUFKIbQsrHQujbxwNbD1T8Qk1o98UYQNqQNDIUP3TrpEErJUXw/CzR82X9gpJGNlhVfRKfJB5FhV7jSBy4msGE586LGt4m3OCPPGqEpo5ewKFxdrdIhA6F12Xj00EqA0hfvVVEk/MmnZ45dJvTJ2REsfiMymErFi92D0BLMT6mZQ9w1/Nj8z/1kIA9euF83sGE6CQlClauwPWL/TzAUWY87d3lG+zF4w0oO9nmWwwv7sT1wg8V+NVvNypZRqwgmw2Br/dgv49+2DrxC32XfkkaVOHQkPnQFx+ELPtpT0hBMLvPKUDvjZldb4cbxx5X68jiN5dGWohw1owPJy1HppYpYnqNOZeVoLHsosX83Ypt/a6JjbvrTgR7tZ/AwmcTz21rNiSzbaCiV9mVquqq14NsNB0hkgsdP9AJmx0AYGiMtxjao2oBzHAnolz8mAKxf6/NFErcUHF58JFBZmet7XawjUIqOAWOokhCM6oRB+EsxjCrwQCMb++gzjzzOCpMwA/uwtESx453DZGE6cepxlQuV3zbWgfW5phVJVtj4MyuAmOYIhYLeIwEVVULHYJ14h6qFibQVha3hD6n0m/Zkpz0FTRjN34HOE8p7YL/c6pkjed6lREZj6mQNTBGgHmKxvUXMB7Y8DngjrvsctV35YH4EbNztZiP4CLmmP7cLNgEU1H4FtZh3xjFyMMdhRakzC7gmJ1NQ9Jbt+qHBI7N5eRSjLyBSaJhfenHvAnMqvYI81fcZb0pFsG6vQE3yN2zuLEa7oykr+SyMMBItJZuT0SMqkTybEqfegZEJcqL72fPSmJ/atItfkHGQ4rdUb/TJIF4UhUXv76Nyy9+Ea3Z+P5qqUDqPUOC8KpArRcNl1tWgaxVySoY90sC6DcXaXVgpfVOshLXGSeVH/pG1bCm6q+HtvkqPlRXb68NstGg4J8stxAVNFjiUcV82AimAhLoHzkNwwRHQWfngKECtNZ7CQrjL/FYxsv6TKBkScAwc9vWEVsqTJHtZwsNakgM/BJFIu9M63RCmx8T1Vl//0omoWEIbRovzw8Mdg5kBs6teDSU9HStHI957bth7TDMfJvdLKuP82gq8/2DSza8WJ2d3UsNKOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QNegsKBwyLTTjbZ+2gDwkgv9vPWu/Ea9kwW4exetWYVNpH7f4Im8E6GRCsBie0Jm3vWu0FFxKvKgxJdBTAuGCDxkuzTog8+Rt9tidR+VZbtF9AmuJ6XBeA85wSA7CkHz1chQFvBLF9njP6a4KrEdF2GsUZXAPWMGr/YSTaGIUYX4Xf+40rLlhbHN3+bu1lRHaQtn2fb+qLuD5HNKeHhO0EujqOlGAzdTu4hzVsGh1Zf5/fZGVWgQ3iJK2TCRR39reiMdVhfYvnFSBauqOhgAssp+KD80IzXwy4KGYE5YnygVHMQMhRaH/4gJF9wtttiZpB87Lpm8eUQ+nM9GWl5YI0wBdRzkI+ubVAEF1kN6lBG+5tq3FdAcEOMeqzE1M38RWnkDXHaT3boJXb0X3mzxz0QA+ekMguMah8JPmSHQKOQJrvVQa3op8fb2GjUTbyz59egiX/jUkwo8B0C3OODCZS2eF7ys+cL7qXKH7ele7n2ZqC9Gctmji1wfIhMbQC1hHbptHzm3t4U+q8Nhd53CmvX1NcMXQQad6iCVvn8vumXHWvxP56jsjiZyAZLu4cVafIwT+GrYCOa9bYe88aHTKM63k8mapaW65tNOZ4ZvgmKwb7hQSIkEfy+EHn0KccwJBUB8lldTDeg8Bhj5Uc5vcIZmgqbqfn2gXEI8g6+l/n8cJyGVvZQ0xH8O0k2vNyUF/xXG/8kj3yE0Rk982RfIez9Lfli/ok7bj4jPWMPaO2Q8s+PY3HQiVJ8DttPtWBvdTkbYHUlyG/RaAv9klh6GhccXUHbUCju2pKHP8hSF5BaZLs4XNYsGALjloWVGalvJkXCa3OV2mi8d2k9D/sds3IxlrFmTQMKKYS8Ln4rSXQtkJNL97VAm9jdw20pceQ/VZOtiOnVBwGlfyilCExHR8wn1a3oC0ZOkulrszre544IbvsCGB5Fe8PLcyEUSy/eW6qI9tzQcTsTVbNzQDPoz/EFdaA/jkcUfX8GcrpnCH+Di0wQqZsi4ZBWBlqaXYgS3INO/BLpTYerzJNE3iEZQPKSnbvRM1elfioIqP2mVX1O3a3U8f5LlgdGFeOBcc2BmoYJ/h5iNHCiyB+AGtCcRDJ6I6vh5c4S1/9X5qUqFhlSLNJtFOaKGmloCguFnyDzTm1isGLtJO6D9l+zqIjHS/w98KaPz91A0FIXqmoy7KfyI5SfvtquItrcKAHHbjM+eyRTb+tSMonnMa4XevhI4uNEe5RiQIzeoF0G3SyngsFr+4fg8JFzccEPEBbV8JYh3Bd44keHq4q2YKxdapZbujj4rulmLYKn772fsP9OeGUgn1ISbT/q7rm/UwfjccswlyM9ywryTAllm7C17FxziD57mwEsZIaj13oIZiKmteydmtOpSoiQo0DZdk9bQocxTQDXlnh58lZwJAx8NrumFdK6UbxS/o5zKByQJCT61GOPJLQSNweu5mhDUdjskLEXMhKllbRkqiE+5ecHY4M2Ag+45w/yHOTFQUbQE+9GGgcxpE3qUh1cyIlyRhEzXQUgqgF1F6uF1L95aXJCZwJ0TmWSde5xKbHe3qWD7P+5m8qWl8FUMwewOPDCXyxr0laJCMoEhXqisLSM2gpNZ8NnFms/hNbkMPZVx46VRB0D1NfNexEwugKwJ7s9RmZVCNGPBuG/1nBhHPBD7218khgL66WGXi372dmqhN8PbdKB3vXJaKX12zXMuU7hF47oLjNbR67T9L3xaUavKdxAwELZ3kiBDsj6lvNoMS7O9daTgHfmsZa3zjndTUoCKAuT+0biMRhk3B3uKWhZewFWaw5wiBENfYx2I1TtCm0Fi3bjnXAloQUeeqBvxQj6GyPqHHg6ZFkkpLjwQRe/7EZxcm526p8prVBnXBnaoywu3UGia1jjh5QW9bbXcwtcMWd4I7A4lQzB3vs9HljlOJE6VhHUTWlIytGSNa9Xm561LpMwDent6dolQ01T65UZL5el2Evhk+4/YSgk+jJWWRFhjc2Jzquv34We+CRBKdQrf0XXq8UT+skZZQ8Z99VWRnUeT451qykGlNKfmeZevW1ogdrxhkVEa7untV7mARjKX+onYuWvr784C3g2RhWzU0O3zd5PxKtgtQ03IvqSXzb9h669G5nNUa4XtM7sEhV0fdZ8XU+2TRFdRSvM1MEaW6B9w2pReRToUYpUKGSjuheqczJ5f5sOdsbxrEi+VC9+/Km9lwupwyCJYnCslBPDQ/TapcpkDKa65Yw6l3MRgS1b3qieDeJ0qsO6uPg9k1srSED3NI3Shz9StykChME9sCA4sfRUgdCWu2Z3iBj0YRtYTTUtr/Wcuv2gv+QoSd/SWq1zkmlmOt5m0nflMmV0bZ2wzjJyDaHBwkwB5kJI/HcWoYxspa2fzoMe/9gOqZK+JscPDepdGJVicenfI2m1C6Di1/AH+OeuwVIGKXC1r1lUYKpHPnC710vjwS+GPjcFpBzlg+sKFTHUthVjNbrtUE1/iFKS4rsF137BjpKMAQveQU5qUPZiAIAq8ElkiA//NI5i7ulBchWXAo4kQUWkgU5uOSp/aggWjP8vxexqRQspxcY+qZimRrPoHm5yf+GsKiN1fGZiLTJGJMVmamToW5JL4nEKm4Iux45GIUVxY/uMZgbaebN02dbk0fO/1Uf8e9NgIqOaiQ8hBQP6tXkUccGdE0ecXDYjjWiXirh3vMsUJ9lHkFwR92Wo+BChR/L29gd71YryHClEL4WtMT+miV3PcuOSDkhM/1dbFPjr3B/VWpYysF1MZiDZFQYMDYcN0hGGLyVlcNR84qSgERwRIrue95s5dseU0i66zWsdUUilr9ls40wTxg069EuFjcfSDiyDQQxD4OIU0yKp/0PzG3yLUG4OF/vWPRsGOKZPO0IuhtvbzuOukcO/WIEnp1+a1rhh3uhraWdt2/9VLQrwlXgt65vEfvq4+um1nPiShKj6soeERnmaF52jAAUgSWMv0utOrIYO5/Z1350BaOEjqtvvYjeC4zj1HvOwSAosHgT59mZeu0wfVI7IuGDyH3WMXsddX4VHyRAJ7wFcM2VDboIbRB39PX3H4RBx3qtt57Q8AjDOpajjEebMSi+cD3HgW189V0L8iKvJ84XwjsCxBcSPYShOx9ell+Frmsr4XlWFReSbbu+tbyl8RK0DFKRVnBfSKPp5ltMzQ8TtKaLeBYfqPwJJ0EDcEek/sylFzpJbsdl5JD6HOpplCBnjvhDhHrQfafBH27ttffdSe3Ryu+E4urPINrgKcpwmNgNI3J1fre3m4bo7xpGqoNuy+uaJuyL0Cnik0EKaeNRCiQ4rUFTo9rxppWqjDzshQSumk+yh/03R4uw7iMjjVekJTSik1816LiTzgo9TR7XAfC6maR8KIhm4esZOLIj7rsjSN4C7RdH4v+STr99GuVEsUVo2VjpWH7G9Ja883vj9XjlDXHOv3PMJ43rNXKs21YmlW+51gYUsxhSMhwrtSo6jNmLtDHSmjtdQdeHwoTLl7ZCP1P3QSZW+chLeESGm/x38GWun4WPD6p6b8qRxd9kXCJ5iayPl9zWcx3tBY/F+gWZo8ZDNqKYBth3mfaeSnryiohmMRxmNcA5cVsWn1AsQWGPoMp1fEMZ4zQ7kake4DHR/YjM5C3QW4ROjyJs/7jT+IsGml8/6aD4eTO7yAAUIFwp3ACEwLfX0xLoG5l2p9AumJsKLiNnXgO+K3QJiAjG1GwxcYKuT0o3mbnMoPR5FNbcWrZipV2w77j28s5DergPUC8mqhQA3Py13NugVPDs2uigc0nXMGunuEQTbz6yY9E5iFK0FkiVeVLVTLZ5HojExp0NtWqVxBi+jV70m5uDZQiB7+H92xb/U3/NKmT0F+n1zjS7yZE5ucXsWa5N8Y3aWfJ+PPMk/4os2AIy13xtVhxwE+z6fdmhfqvw1cPzgeDpzCpVh80jRVCb+f1we3UbyeG3vWXSfK30FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe1/sIYK80K2PBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHvfxRK7PdozxP3zO4N0AmDwQaeui/ojdVYHWVWPjePdkH7ENEINUnW6PApTG3it8wvlTXC7hG/pcHE6gQsX/qP4brVIiAYnZzmr8mA4OMvfLXvkCYOFDQKZtnBexzumUrAtsfF0r/E+yqD1uEXVre8x1L7+zre9w4DVK16AB0j8W/TFALi+Kc2MV99V2C8HLnethJLKLPd1watdIxHLZiwxwUX5/yVOUp1PC3XFERXV6xhiLNO/E0z6fZ6JMEhRbxBZk0aQIArODr6f7wnf7jNs+1a30khbtKvEwW/9n58y7xiJXf2AXSP86ccr2kjN2LwgwqWqYHRKwCg4fQfeGkXxQdpbUSsBEu4dT35gMmVFMUr9ekQ/44T3Wq6EYWNEN4WEm0xXvg3sMx//NCmCdAHTC64Xly9zhm+/wr6lIW6yjlYNeFC3Zn6Gq/BrKOrOpknwG3kGrrMQB+kHYkP6bJh9lpukg2NIfBEO6MJFrMAjtfpwnUmdbHXzIFPCrrrNfZDiBVAo6Xyn/H65G8a76JiKJrlcyYxMeJ3ty4iewFhbOLy0PWYQl9o63qvUz25TUasfW8sJ06C7FoCs4LIvesESK7zw33CCN9y+nd0itpaTAIVHgl+tMTpEbYUM0v+qLQAmbNDhIuhJ4IyDh7qDhJJDGOhy9pdfBg+j1qPWpMdJG0CUiFKQ1HOEnAfmlh0w1yKAeUb21per7H2oOdLvU9omn9Css4tAjcmJO8mCYbXDoqLVeS2SrO7roPqFKUstW4O+1/tZzTQy+TkNf0WRlaYA1L+I7P0ArVtwSLw+qHu2jcisOi03QRdCA5EtQJqNCBNi9zgqfFLZMa9yoiWaaFYjNBJ8emxe/tHmWyCTB/efn8JB+u3PM2YQQa53wlTlyw9b8AzHWo93t7BuubnoCeaexEJKFNnO6wtwSXfRmcWcyj5xNCWhK7O+6Z3uBPy9y2Mtdt1n5Le8FZAlyQ/VraWNsusY+SjO0WDvEldKXjo+q87juolU20bLETENOOLLEiZ+ALUyU9fD2197209xWCiphfSggOnrIDmdv0rjvruYA2d1lRQl1FmNibkuEVP7CJEYBrv8llpiOWU3w7VUZuIfLwHyzbQ2JKSxF3AguOIsWKYKjRaRwhGSWgF2CEXZB5IknLCGFxHEkCh/SAcp1cVMlwnbin9JxFWkGWMBRfPRW/QRJBn19W65Jjh9bsaSZZcZhNlBFVmB8Elze/Vj8iuPi/9HpkHbJTAIsUmom0hcl3jDnVKO+N1bueUSrihQv3Hmi9pghSl8nXaLr2iQWa6zzTWiKSnFIkL1y9ZPa3Gs1EAait1mhV+jKqUyjQE8VHFJ7L2KNBXZ3X1aM/NbhtNEa7b/2GUiCUOn/at2pRqbyfJHQIEira/+a+8ayyhRM9/sFIvSIKqQRALqVP65WWDgWV1X+zX7V2IIob9sMTChZCX9C31q2xN6fHGhOrDkHCu7zYu2yryCQ0gictJqiyby6OSDpebxbuFeaH22cnNzAnIhXelk9m2CxNDWZ/cRQXx3ZSqBu70qJxYeyaUKlAtm5VVwTILYGXbLR4mJk87nsCp3J4JS3aHfxZsHTsXX3LNlgSxOiKcRgmS0Tb9fY1whKSUWC2hRefCgb3O1pGUECZuaI5TAGJS7LAux4ee1VN8pgL3zgd9z+1AsD/WBnPFXnirr6VlpWTRFupd0FP2tMP8ogD/DfA5M+Dn9DH4zZCQcDQzGq1SQeIX0bZZB/W2bQUJlYnbwuVCNJZCBiFUITpzT4b2sIaSDvbD51M0A7bDPYa4RTrqRNqrcbUIxfuro+TU+rmmxcndtu/2Pkn0daRq8NEUX8O50oaecbhuvdhOFNA0+wuQLDMkVzF1h+15YKxd4KdLiWBtRhbkntz/dJd4PbXCX+ojVE2Ckc63OuGH3kANH2PAXj1KGC00pa3Gu1LZ/vhWgKIWaN/m/BjBOZIlJckQB9ezlA/Uad/1OixjO6a7U0QhUtJIboW1w0WdZMKJoUKF/bsYBFuZZSvvWSdvbn1CszZRuE42lH97W+DEguURVq6ZcXyzb8w/Tj8TDviNXwJuoLaLTUOXQ0GfvQxpiyUXxGtExSgtHu/ABWRv+aa6oJHhfCT7m7xvz/bV+qhiPvtGL0AsD92yfqR+kLNA8aB7QuW/rrGDkD2tc2A/J1hRkwCavsKrTd1rHg1u5PUx6bNelDLsSPIFVm6+2nDCHHP4q6kNgT9e3vrN3UfEUcYbj6WixjEKgzcEmJQD29XGM0fGquiKR55pC9VtUE8oIjZ1xMSAGyDb9rQMPGB++fjPx/YD+DqmnNws1ufhDrsNKDC2B82xnW0nY4Pk5QkfQmC8rsQU2odEc/qIsC5K56NpM/vRkFEdrJwo6xNrGVw2+oJIqowL/6O3rHIKmu96gZ0TklMRue9Dq2g4d5+ViTEuZMnYbe4oJq4DdM7dIS9X5Yox08768pWK9E+VoEu9pXkkv3jkL+Z2jm2CxPiq0vZzN+G/2CyjpNlGrfM/4p6nwoirDFXSWez5iiJ1+cFXp+XS6tvToUgGMybemJIncAdLntucEUWXNUKuF3hPR9slIUGZIVrYtoxKBKyQbQ1g7U4W6jnMuUq74c5Iu4PeHCiX1CddcYQ4KEpaiFSOeE6rkXQNbRmvTfwPD3S4jWxZm0/w/2GIzaz7db7MtPQu/FN9xG/w4vl6AtVr2WTaJeK1p29xd6h2RQRoCn5KZ318xcebzxxp7doXkVeEVokjIq0q2BP28uXsYoKpEgyiVhMnb9PONpoLZKUzV05jsw9pI/yQaiQ16NYdb2oK+4BVvDEgWJZkOOfOQkpcNlLr/g7oYGRf+7ksd2oC75Wdda3+uas3vzQn4fH7ILuI1+zIBGaLyLhryXsxUzIzZT82bx/x6Nkp7obNRB26NqpsunhXWOQBGhGRxaeBLrR3FpxBtRkcGwCSKS4zNADTFc5/jsdx1C+hwd0TQv3N8m6HfjS07+pnXETwLM6HSnWsibIT0juq7WZt1lMhi4EBZeO+MjX/nl6P1SOWdbEbtZCUQ/dTy7FgMqAiZtx2+3PNhl/CwTgCE6ipJDksXDui5+emCz6Ksj6MLbImKbhpPJC9Pe516rk/M9StBmHvNFioc+EzCxsMEiw8gqXRovZLuRv1+QlUA2wl6AT69SwIuU6Enrx/1r/I19klADovX3vNh+CQ0N6NoH5BuZWfaBf1r5JSh1rNkOXsWbSTKjUOpwnWHSERdjY9Qxxgr/1+Kum1Aog7hbJ7FAuSmjVtPD6WVS0FPsXgEp0yHXQnGuCZ4e4PgBfHKnNqO1w+WcI1R/1lz3HKHjmHbHiyvLAWifxLcgWrqfEnbZklNPsUBsmuTV/LLx6Li6ugOLtfOeIMeq6ccpa1h8k7eb6y/n61JrNdBjp8eURuimdV/MDDE7hhP5GpDd983KtS/XeijQnyt7wWA0Mqji5kcaBvHYw8cY7vJ8PLkxBS3evYb1fjSlZxTw7/w7DrZbQivZlrdUhnREZedztlscqB37sHB3xjSSmLzcto3L7Xw1h2yONm7ozx3pxqlud1T0ALWW7CAUElO3c2/lFRZMLWKPehkJmXODzhPaJqFjc2TjfV6QlXZ/mRLeQzeYlfK6glWxItqnN1ofaga7g45OxgiMeU9RCGFmlj/drOMckoalUcwT2ydbbPG7WMYntMvw+IGZkLR9S1FT+jTpBcJubOPyOHmprJ9FanxDEntCOXpJ/kDhMuCrWgQPuD/KT8it5B8iqp0D5ipGP/2r8XE2SM8Dnic4ksaDbshGhD38HzEr9J/CETFXMCOaznb7WthE2rdVJ/FpmLEd/OhVrXaaqoaXXsp42iKzPNVf1CWC8673cLo7/OngnyVAsNidq7NySI7ET8ccASHXWEI2xLtAztoUA63Jq7j+VQKy4hiw7TOCOdC6rSK2kLpMjv7H+yr+PzPlhb52whMJGud/VrDtM4I50LqtIraQukyO/sf7Kv4/M+WFvnbCEwka539WsO0zgjnQuq0itpC6TI7+x/sq/j8z5YW+dsITCRrnf1aw7TOCOdC6rSK2kLpMjv7H3kVV4UKw9ehxHTgrLrMv+qjcKT8IPhrlqFKxUS5zezARCsBie0Jm3uZHAx3Kx9uRuc9zSIZHIOfXk77EtifmrqOYg/xrED9ToOvvWajOazBdlSfvxLpLNcKUXrUodKNtTbew+5gTD4bOXBvjym60LaQTCJx/iswqPbo2vcXyo0Ndq6F/xclAWOAUCC9qTM1EXdIglJ2uh8n+oXr8faWzLuMmjsrgkOzlb4pkev2SunUFm0PLqeB+1rXM11XT+psBX+X1fLqSOEfA4Fwq4+DCHeIJRjb0wBlzw2yw7TZ0HoUG2xNMFu8K4Dd1BujNw8b+B+HveOV+JtkUmjsZFrlg27Hn3e84VPUttG47UplUMOhzylx9nIJgdj+1fjPNVebTPRgVnwrD6HxQzcKCRpm1EwDZR5qTQAigQwz69iShbWIDzT9Cdjst1vSj6NHZYULPhydGObIKorFn6KkotMW2UPViDuFHTMQbbXq33uy7IV5dH+tnY/8Rhyp63+PPAtRYphP1S+xL9jAhh5wmZrPWfIONG79h86qnrpIfzkM0wuOMxwkbecJ3nYO3VrKQdM5JanaMyW5/ZDPBidzFKzwfQ+b4Fm9aPS6bYDIGWVeWhb5/4ocygDh9/fyrsw4C+EQAaADWa+2YMXJ5JvdrPut+9o/OqQ8Fx7tN3X6EvQa5O3bWdkJKzzEWw7TommZUzi2JQaDRbDEz5/ik0IFC/bfBQ3+9VCj3nu9s+aEH9LjoY+o8f9QK2VYFRdRM5Btnqi/FhRbo84v6cKuTA5zYZP/QgXgG8n5a0qVIFhCBZc3J8CjX0PnZpkyVOwO9ErCAXYqCJANM6dgqURM4gIuR9NxwdTdOqKLSeXD9p6iYofrh88FFAlcy0e8FR5TTasKv0zW8VkXFLUUITKrmzCR8S/09yBCDdjBaVMRVi7W72nvJacS0sMp1jhJz8bZHI9ffvQrUHlyXrT+asR3EnKH0m6W08pQgz5s1MWVDeBqem5+/Se344qRhNg2VrTi8moQMKp+VhPsqwKnoDJKBrOZPeMqRgM7xRt5hWpM3K1Zr1kZd99jIwyd5jBhbJXXngjMahasNCKrtbLw2Gnr4VJCQ+dttuv2bADvZVfm9zAchIoesINJB4WVgkTR7yuXJEnMls8MFxw7dfVwKJP6om5d8L9MtcUxNXvRzhCUq+ksD91izB6ngGKwSQgZUupiZ9VE98ebiYG1hwAWVh+HPOO8GYKWLRSIxS9B50fMaIMbqFcZmzT7hZ5VbKuet9/V+MQFU59hU8jzv04jO7ZTymcc2iBpgjGUJGHYhgaC8PZe1KOWxmsm4gJyaQ8YInaZyWwbqI5WeIemhukq38eArL2dFxyN9fjzip2LmHZAQk5RNE5SgvcVYT604Qk8qYHkzKT5U6g8LjY4/F83g8pROMNArIOGzu3w1V/X0zK3LGQqzAKn7XJWDXcp8rbrxSdzoxEchqRuF7LaMT/Yll+DuCZpoCpxBQcqeAmwBrsZKVq2Ku57PtS8kyLQYZdLxcd/PKjEMXuJzZToPgdgcK8px22bGdcuGL8R0ptDBlGVqeqbUfwywQk0WXOgWPC87wwDLE9bpV0b9LYwqvl4GDQOSiBohHaiUdkbx46LF3aC7FrB2/hMEpHUfwAna/v5TpwidsEQtpZhykdHkB/RL56ERXVh1w+3J5gzXdf26gPkf/13e1mPDHi6jLKnmqVTGbTzbatG2amRzHcgDHnlE28EFgV4Q2mkFJ5gyo7dtzgcLaSIfCMK27Bk85jgIyQe8U4mXat4BekEPc1jGxgpnHCnUj7v9owJXSmTOVn/psd/XRrkUmJvP3yDcmlHipoMKnCaOdEQh1mO0PCvvesoAtsTNiKN+KikOshacyhkTqzjEkP9tcOS+a4bmI1Ywa4GwcIRh5u/eFjSPWOyu2EqirIcDOKa6RBnusLPoIONOR3v0Qd7cIxBZmpN+vIVB2sbe5zlGJBjHfYBwvFt6qqoTInHs81rr4CQ8Mx8tqMqnqv0NJqtERw9OeHMntVb1XZRFaczeXLKhRmT8qEAbQQ0To7+jYUARRdXCBAeEYbrw2qN0w/vQgKM1aBdsOeR0dxAh680d2cXQ6e0xl+6JPMBRJrQWY/o1JP5uLCNLPetXWXI42J4+WE+0ClJdzs7ZB0oPSbu7vIdIv3lajbJfeb5xs+wFmB7J2FUmHGQb4DcHUCt0zDF7tIVG2ezXvgoc8iK0FRdszuyhMNQzkzmqbRSB8CotZvO80f/JGsrUIaVuqlYF//b2TlB8zqk37OuOOJu6V6PjoPuHtqx1hWXVQ7UlYw+fNgNmM3SEdY5fVcRs2WbciZMWWo9nZ3ihKiRuNsF2acKgQ9yLqezUk0iVFBDtvLezxUbxFW9JI3Q+isOR0kHvtgBRX7qOLVpDW8AWfKtPEdNOMpdmOWyFAKeSRdEK98cRfwHLBsYlu6lkfOpqzIdLo+ReEZ2BUiDPRw3bXp1cborEWxh/HflRBhf9qr1/VgzilomysFx4ghEzmlthx8vxUZB2ycdGpx4mCghQlbOp4MWKcwuCBt4svbZ0DE62C2FDAqJygFOQJE7kwhs7yiz+BW5Nfsfs4gtwFa37RV2Ip5brMctY+kik8BsrnQq6w1xqG0AgxPBufeQeO9EcY0JAYnruXEIGIxhV3KWb1QaDRBy7/rbF4HHcmhjLlizAIQUMdDvcOxhD9bCe0FNzhZnejy7bYWk6UdqBcpRRHd2wSF4xFughdmIXPbDlOETAx0EhlElNAY+CNhR0TyTUDeOivaWBko3QKNZyec7fZdiHTRLchWhNb/YVTxcngGytfTsUfs4xB6XORZdb8+guaUr2ulVR4B+7jJp4N9XSVVRA8nEZPOyOVwxDMTH6iC5v0oXlM8Oo5cceWFQwGf6Ha/r+KgnIanoKk4Uf+6WQagryuXUOQvdECb2NJEUWCGDwcwrjgq8NqefrxY+PlKYgoOv0goPnLSXVfb/xOGuESCMGMt4zNv5AW9hcdFb26SoCj6Ba+5aqATS3OOBZsFFzcrpAd7jY1kbBcv231lZvMcglclgkmXlNWJ1lpvNUG+vIhrRYOb5XAkgZOEOA4uGa+QeUJdyWPQFo8ffejEzD76kmi7scxWsobQ/1mRRdOhY3hbfoSVzROJChfdLRJkinMr1iUf+rmU2KOfRth0aVIbKU+S56BX6F3foTSJ3Xkns5w6ZVcJvAePQJYo6jA87PgueSAZNi96A2tjxLjV30if4bIxGh3bP705cWO9zTnhRQGgMPzPImt9N8bhWdEiijdz1eMthRHdTmLfSpgrCiWD9jFLrBQk0vwA9IfUO5GG33CSjM3hcw5KX6OkZH1vdz3vC1p9g5ySCzduRHuM6pmk//4GComlAb6PKL4ZQAely+BNrmMukNRa7YM2ofnKjRMtLWSUkMmAImLQQ2X5+oMrHkxpzQ0d5E3Tvi5XUttzE8t6RdU+rwLMbn5hSWUdJlo4Ki7uTzoeNGXInw7TOCOdC6rSK2kLpMjv7H+yr+PzPlhb52whMJGud/VrDtM4I50LqtIraQukyO/sf7Kv4/M+WFvnbCEwka539WsO0zgjnQuq0itpC6TI7+x/sq/j8z5YW+dsITCRrnf1aw7TOCOdC6rSK2kLpMjv7H0B7qn0TSgTH4jJxwjvztoejcKT8IPhrljrIcvfvdmFanDZ8YjqXyfDAVCFF/2kHrh++Zf4ffMyzzgEh8zIlVdUi7V0t922NyXfh+Xf00qsHOG+7H6nVrFEe162CPEbeFJcq2VDqeIOc3WI2KYMQWXD2ihxVqmMyrSwocYVNistFut3BLUzm8RKEWOOB6PSfz4eyhJaO8sss7WWsFoxoCpzyQKcDxWn8RyhMo2iSdaOzT9Kugq9JkYbiKxmgCHkr3qk614dhk7ZZm8YssKvtV7U+w9J2TP5JYtbIAlJHBlv7GYgid+uuhJZJ8FQT4OSXDHK97ODVhnTt69NqPfqwBfBk+7/VSnqvNEVta33nqpFpTVR6mjykHtLKjfUtxbvdz7F7XTqgfiUHYoox7UXjUhoFZ63wIgMqRrObbB5e2UDksfDwrh2Ee0btJS5AwNsreU2+EFAJi9KN9CakvggMLGo9DiHAIcGoYR9kOvoX93Q4A9CCtLnWM1VZ3Kh0ivh0Xgh3eKD98/oBcKzF8WjWpXWXrxqHVJRkgyLl09s7268fRKbWpdnvC0OM+e7pnLqDm9PDlqulk3d2GnyQr8NfNqs1fgkpmZX8I4sI9lRFKzkJSrCKoFZ+mWOW8xSTw+sUPSNnqWO/meBB/KejwjHvgMGwDgixAHF2Zohg3YiJHTZurXkdnYQcqN3EEAqyV0ypbJ0a6PwdQwtzxL7rybyeoVTBr5UYwpTzURtRHrLRk2WujrsYGp9kQd69tcCAEjeGeBRpNXOZ0c3DC5kuKlGNe8EENfIjqRjaVksEiLcxwWYu9xFFmvXZEMGtayv43VKCwOqvKQufDx5RVNztyQGbxd2vFOb2Ue6loYwCTD2FvQbwaODvO/dCmJXrSNlWD2Oc5WtMOoxCGJo5jNB/Yu70hA+1+y4ZgFVCHwjpvYW0oCtUSpAtlRXZqCNM/RrEzowyZZLvmbL5dHmlLU2/gzJjmcYQ2npUExszJ0oZtL0e/MrBklcb1OrJqH//W4d7Pgrh1bqiHSoLIeAWKN28YQCjs2URnkeQNO8j8dJ5rkPsBeH/annuMp4Bl6orrPHLemp7PiT9lmZWGMYvSosQq0R1eq64xLYb2PSXaVdRmM2hGIaYd4xW53btFlLn/O8vAXgOOXxMp/xlW1CPpe4fK+zk7BKkKzsndO24ze1hDgsYTXk88U4iXib4Yd7Jg1dFYKTPoIMvwyh9igNNvoPE8ACWXuff1x5eE4Ov9Uf1ukoUjjOahX6jYMnz/tDSeoemdjVBv35SRbfeZd5kNPIVvz0EtdGzN7HNknrIrdmhWAycaMf/Dr4P7PG7hcE345WWjaarfOws+UA/DId7j1/fB1AM2qAvejG/A7XNKE100T3wNOdxPBUSwCLpn+8KUI07KT20jWgKr5OIzlcoeHP55LCCITHPv0+t5bna5zK8tuwjYbEk78yEkR2z49SfZSN6vSb+s8Y+Sqad2PsA/wAfecFTfNeE1Kszj8vuzwxNDyJUgi0wy2pYCXykpj61SshpB0dFaRON7VXdFYE9tzpKkl202yqXcluXoOHOo46IBoLEZViMOaa8vVwuAUA0dRNEps9pUr5GwNpl+vra4BDSpeWHz5MV9s0Anz3QNlO+LrATMJaGey8JmA3hqNJRQEa6cJhzPrqlA+ICOvn1aAaw15GfK7+vP0KJ7rSMZyRvVhKiIV1bgZ+Px6lClKa4AqF8h0mdIw3oIFS4IWfuAjLqic1caqMoTDgKkzUo0gjHBw6h5jfMbNoxH3Aiq3yLdJgDoe80FzgQsLzvnHc9Re8jg2lTg5VoBx4l8MsI/TriCM3QPefAsh/PaHAqq7r50wzJqibwvCq9V5uc76rqK4+favh9CmbdBSwtCUcVlpb/JOqMsBWm1yBw7hAMjLnrREzJ8OyZRyeSENMULl7KlVni3uqy103kBNghRXymcjClCN3eYHw4ddrVvbI18Yd1sXP997k0MrdiqghvzPqwJ1T3ktAUDlNY8Ri1pCyIFmyzpcSgxDdy8WalEuv6pbSiSwZd7DE9sArdZzE36n8J0kLJ+IxFhMs4fLhO9Whb9bNcEImeQRSDbQrI/TPCjKgomEeYNbR7LdsjCZEAe7RQFXXnMUWlojGIbqvMTeWDMED//kRmL10mXuyLZpMdcmanNGkIXlAhrQT06NIx6g4iNDtNC0kpaIRz7CEsxC9opkeTZgdFAHERXt004NyNcAPpOLnMI3uoK2qZTk4eMdFv9jo/f54lhqt1G7s9WOTIvU+Y3Pz6Yw65NfQ8/tTuTOrdACakHis1+9sn1wD10DoYKWF3zBG3dY2ow/vr1y3kkTCJpb4ENnnTjIsLKNIeOEZCq7ASOXRvy+q/fCcpTJyrhB8LSrAqRVFYEWZqEJirEfDLcu1G9w2TuC5HZrbTCnkDTXBCX8FnFF/vRcmhkYx4/3N8yk3HD50ahibrRkr6Fn0DVW9cpZE1jnT7bwzsALcAkKiuZiuzOvTHpvy/BJgmaA6iDO6wueosYjGTM9WUJ4fL2sOXUNn6m2obwVI9TpfgoaOvAgmfNIi19y98mxvQcZNOQGF7oPUv1QG1a3uimMs5OIX+uvYz+hrrTes5Ql7vI9MyVfrRaZyGQVzWd3HiJd4J2VfwH+c9yj63NOPf12UTV2ENfVruiTHaF5+sOv1QTPC/CQqNBAtCPpMt2vFYVEfM4sjNas3eSdunE2PVNuB2e6usYNkYeiseYVlpgUGH3XcgYmOoMzqozBQLGOyrVOo0iUUDyV9NY8UJC+byQhYEDrba8lHQutBTBqRvObG9871cm7umx2vVo/zqM2gDvtS91MdDY0HkQ8cJWrbzoKryiTkHUagUWBFWDxmLeIimk1+F92NbBvfvZ7h4EzasRyKEKswGFUSSuHikYuULTgQHllK0G7jS66nwQbFYx4XFa+SaPHjiLAqOqsNxCxW6g4SefFxXtq4A+eSsVz90hwgtqbV89Bz9SsnmchmbtxrEH/DIpVPtsUaPm3BNW3Etu4FJlsZHN6YfjpQkzjIv9U+aAKyXT5/qxQx5pF7aq8VZTlzvbBLqNtXAO+nHTNRZnw6k5Woit0acnBNTyG+v+ImmJi1hwSr/5V4XoOMc18eIWPjgM4LjZADcWNSPdnVb1SbSZg9r0VLkrzELTHO1FD4XCQJeS+w/ahF/ZaLEbMI3zcwZqE4DCUEV1SpJI4Z1cp5zdUHuBo2eK2onVsyIEH+4KsU0H/sL3iXHg11GMq5W7cxLRN0VzkNhheHkzwaTr9gDcJTLh54ri4vWKnijqaSH9R4FYPxGlCagEGkmDuur0NVaa7/nLJOaBC0qmwuKCA5v8Q130QaafAw1G268Vl/Iv8uOYiqFZxQonOcr0vVIu5qvyHWhb3RvoyuzsPN7q//RwBRomH9byiDFiHz6l9aylVM6Opdt0T1nyhfwdPL9YpEPyc85cdn06YkYD+SgZmp9PAubr+01rMe1cekZFT8LeFKGaEuHHYX2RGvR9oba7NTTBmxTU5x+7GE6QYYoL1zvj2T2tcal0xhUGexh1bhxtiCcPYNtyIxF/ihuouNVEhoQ1Bl00W7b2qHYsZzZUqt84ync6Jbdg1fJVY47JQSJ1EtlEPS+ETIUsaeKZlS2lE0TypwToKN0NaMWtJA3bsjyxIqG5uji2sx7bn+w1Cb5WyTO84cOtmRIUp0IX43FSL22nkITLvD65h8GwJQbZpZFwG/Q4Iiyhh1T1rlPsFzdQSfSmCVSexr4QdT9ttK11JvPptbzVCmnBog38fOhBVnkpz1v5gGGKhJFRBUkBGto0mlmH4XyPyiE+/7Ze2tf7IW4Bm8gHC7N5FrYVjtOy1dmvu8nj3Q7NwrupofGQjDMO3GXfjamp8iUXeglsDdhyjw+Oa5Cwt2EngAxPduPMLOG/ysElz2X1dgwDFnL0lVdPnrbiT7xWOUw56FH3e38ZJ5UcvOLFIo051wQX0q6oeDT++3mtAyjG5Uai5LGeTB6zH3joVjh6l4x5A4dIrncYi5HN1C6yA7+ACT5gP70/tJ3v5gU4bECTv4S/50lhcwtc2HJSx2trOKNfIaDR+YJubOPyOHmpimCvnoBdXMZzC1zYclLHa2s4o18hoNH5gm5s4/I4eamKYK+egF1cxnMLXNhyUsdrazijXyGg0fmCbmzj8jh5qYpgr56AXVzGcwtc2HJSx2trOKNfIaDR+ZyrxrZSEbZE6WwDIgnhJR+aB95ltdV6Mz1RnlySCeSy1TAkcxXlYnkLExh4JXXp5J/UBntQHVH3SeQoXLsrJS/YngOBnQrYP4E8T1t2EiieUl/NxRWRRlcRs4gignKD+iTBniJNFtjsnUKsKzCxVovlwEblM84DQAJC6keRQGQci5RFuKZvinlVWGgERMEhePwMyz4IprU1G+H/8AfufM4uO3h4sW8kcOL6eXryqqHx+yHAVy6ROv7rsG8uj8t6y5WTzWxtyi4s2MCXPthxtezzv8EKJOL90MyqbqGbqdafk3lSqR7HhfYNsdwi5+zKZshmDg3+fdClAmcEczAHwkES51ZIxOozDHMG1nepexGa4+e1d7A50kF/9KqX45NbDLkFaxYxbURhFstCBJA7GKsxOz5rNIJ+cD6PfPHpTA0gdpsYv7fkXkEc78/t6EQvXk7ThD55kUtQ8DE5pSxa1RzFJwSEDsWnRqFCy091/XLcqDnRDE5fxgdOJJS+VZanu9EVnwy6WDAsQxbVPLAjrHxJ9yXL66+OMo+ZtPl8ua9vTBHgJuQJH3fbNLNxtSL9vcHGo3mnRw40ihMma5dxJJ8Kd0zrNPhDoQE9VZF5Ayy/+siHMyVppQrAXFC/t9qGvLBJ5b/MO2IMkJPLdi2hhHWq52A2wbxIzx8U/E53uYnHn9e7BWYaxTdqZ+IykE5/vXboaCvyGIf0K87sxMx0BGEfqtbUeilJ+u4VprREsT9rsr/Eb0Tcc41sPeSVRhS9sjSIKJopQHWYC7AkQ8ew1qOHzwtJJ+YMo2JazYH7mp4PuQ5vFAm2/5inHoUaBtpIq85QvecFIzSybGZL1sJK6QyhuVuP7IO7WORk+kxWFe5LnMC4syYKJa/eDm9QUH17pCuGmBjDC0D7cFF+f8lTlKdBTG7OfTpNW+3w4AZ62EozsFF+f8lTlKdp54RFLqpMA5TBepyLpylGBumdzFu0/ExWIT/FaE2W6iHyCOgrQHnxbrmaEDFsr9SrUGtlRZMaCZl9Gf6igjAdsLL9eIl2pFW3SSHUU70XUS2oVACHha9yvdJh/0mtPP+yYBT1Tny9goY4nwxRO/VtUGCXqFVNZU7iTH+toUHlFrbBWc/LDeOm/wHF3zy2XpJOBmNovQlTHnydQ5GzPtPM206/u6I4K2hn9qER//NgtMLCLgs/yVTFuK/uUfhDwl9WOEGOe+Y0Q1Syb2eoV/kIcgHWBRqXiHkVdvDtf+MluN7FTf6bu0DVDsr05BHuBOSguC6+vE+6cJGpb3VIwCqc7I2YmUyzALRDLa5r3JVYfMW5nsyeXZP90uNJ0MD8tnvEnG/4q2jfTXu39xdUTqo9knPXUydDVF1kzCBiQWj39NelMWc7G9l7bngX+cX2VV/qt+SBokbI8kIOUJGDsQzfRfihlnoEbVwbuP3y/Q6ixiFCRmR/JnTDug0OmUcCSTMv+2KGibO7w83A4uR1tvnauoEKZDiXTxHfX2ELErRzOrUU/IoeBVh0V8s7v6oaTsyodgX7XLfdAXpE1WuDOyz9HjIE6edCcJi8fpxSS+j/0ke6NiydXdERd1QwaPpOBsa/8cXyk80hlhYyS61t6kRl8eXRAi3AoQzmFI9OF2lHie3P9pwmLBM73IM8qhQS6u7r6yj6LVEFk7xJyeMOyWKTbVgiMN6py5MF/yENm36uu89etamcUX0ngweN8whZrjYm/FPWTa+gzf6VemHxg3ULfpzHaobSoHdPHsa6KiLDEyuN5AiOI4np8bFt1kl3zZ5ogekU189PaZ4yiUHUwCE1+ZivqnD+GteLNiqgV78zsHYyWRsvvPI9MUFY3dSxr+XPWTkaTvl3kMHQr6VoW0hvo0rBnN+GScTFNhW9AkpdygUI8dTvBCsz/Nb+GH/aYNyrUDGmDry19MhMVYPVTqpb5Y97QKd6Nufg5mT52sXKqeI1/EXCur1QQP6iq2a2ot9twa2eQt9kQTudLrBqn+pq/r3wFh/hPUvHdPe0N+/6sFQ2LtaukXIEBxxbWzbq9HIQB8tRc4bnq52mN1fK20N3Ps32gEKrFUlk84Pe/8YGoQmqRdF2FZD43GWEcCRAeNF0aVj7iRF1XP9saSrwR0AMddp5J7rZ4tYdvns+9pDUhOg9NCsCIogK1ntF49pA80+qhrxJR9IBnPhvQWP+XFgahzj2nL6dpDj46CDrJXnXMR9k73Nxj4Ij0V9tZ+yTmoqc69Tk5AC6E9lFK0Y6TpC/Mkj3fw649oFkHlPd/4WV/ziz1+xycVbVcAbO20waOI+Ko4JM2vCEGhmK9DLk1tSkBanMoSTTKRcUtHPA/PtZav8cAJmFvoldXqmjvZyKCeNYAF7DvJfMeH5/BmRaDX+VXR11LsHyLU7XqlykA4jTyKDHC1GYGcIMQK+0RSDaTSDgkcoouEnp7RETtxdGuDHg4yiVmKSkAhWr/mxfCdP8GY/9kWYwtvSmaMiROdmQQGMAEDZRQ31WSXiqUiKzjXe9C2HR8UW0BhYJpitSiVFqvM1+fGmU1xS8i6odkmIK2FZ53GlLNNnBvCEHIrnEOPWSveQRTCBZSZtZXtEjlKpb3x6SRrxkncCYp5XxIucO6vTfVwNupRe97StgLb2kTtW+KhseqnQ8AUmOrN1Qa//0kdoh9p390gC+Q7PD2rELAAGAsyOrP7GCPmZL3wp7ne1I+jc3lATYL7db2BYirDkcy/y475SDViVN2FPnKvdnV3hSVZGzz7wNbTNKsNWm/VvDZo7DTgwbd3NYMPgktryVjBwYgMgkBOrsqRO3CJ3oULc+OTAg/JetdNKiBz+U29JEHl1TKZzEmGIrA6h1pcycFwjyBgjkZCljDhJ+KTCQMVeUO6+HVH+rHqnv97asKbSrYmH+2h/5MtihfEH6Kc5CRs5V+W9AVR3i+7LUXyxCVBVJ+U0ahFUKHPtajKzqgA0VbdZvcalW1nOpucxnxIw1dJwAHohjmNWi5XgzQCIYgH2oOWVokOV36IfhwNYr327Cm3kMh0f3Bi+EZyygxskTcMZEQb8fueFBmP5DdB07DbAbI0hxz1bHqQoiMzVNvMVxUZp8bldDbHSm0P1/1JNJbVYBNUTDCFanCZMtKRjCaGPr5T3x1CqrwqKrOd6AQNvQOjymx4ei8x2PMoykvG8Q07cu6Ql4sOJR5SqlVmKB4D72jDdpBxPy5iJ9BdgcaJHQX+uSrU+ejoXDvzstpDsEGIldDH8+2tm8TVoHgbEv6kjivj7j0MBj4q7MrFnumzqukJ23eJUaW7xKr46triDqIQI2w7Ql+qdNZU5s1lulDfAlEeGM/sJJC5EexgwUr4+gI8hVRxhn9mD4zlAl5Zf0oDg76wFwICbN4FnfJHtI7mjoJOziaQiQu/6tQlhzCUZN4s63tCmbJv4/Hbm2u4sqD8abAju1Wpk7ThISIo9cjz8yhy1sPa5poTSBdOsm9MA5nPxfZ8G18uG6VBOP/owcU02poJclTzB1Q3Cy6J+PCBR1TtU3ShrUPYKPGlylyA5DB+V+ZEti0IcTGClxAd/61hovh56uEI54LbaFARyCINKzT9bjo2CNTmXqtbRQzjI4ReA9pSVIbfjUIwwwviu/nc3tQJSyVbwlInz0qulurijyw/lew1ZGKxCSqgJNs8T5W2ajm6nwe/zePBc/J5aUjXStfiwgpVpITUsZQyTY64L8/XSaCVoWy1O6VWEu5NdmUYNTeWrIb2jVCW+QaxM4Yf7C2tTnw4ALupWrO4BV4VZVm+9j8XSuBBTHwpBRcQ4Zgd/wlMfutfydlJBjN7UrN7SN1cXgrV+xaLf46UP5uMh0rtrE3/8HCEMpzH/tSWHWvHqTf+kIwxZEQT24v439Un7ejvBLQYPa1TloXmBAddOWmuqEaStaupp6gPpvucU68zBETn7Ryuh+W5xtm/6s1p/iNM7ELrC9oN7A9IzC7AJkSnJ9b+HyY6H9hpr3OKYgzKu/J+2rE4CjfWOOZvAtaVxqgcUIdzjY9trclI1yNzgVIBo1C5NM5PQkwrmwWJMWHWgL7WXRjYkd6qqPmhMA6wJubOPyOHmpuldqt6Hkcm8bLLrTrM3BjvVmQxKlcXA9J/6Ai0f4b1l5PHe6vPm11JssutOszcGO9WZDEqVxcD0n/oCLR/hvWXk8d7q8+bXUmyy606zNwY71ZkMSpXFwPSf+gItH+G9ZeTx3urz5tdSbLLrTrM3BjvVmQxKlcXA9NS4cn4HdRQqqPr9y3Ah9GSBzFz9i6vmSAosMJPDqHOqenkOteAY2svuedaNXbRJtw2For+bRgN450r1yFQTlG5ysqHCmV7twS5jPle+rGRJ7Cjs22526m44N/+gAQc2exx0WXkLXWOgjTDtIMUiQtao9oB3+pANGEylGKoCptRhL3ypFyNEO27nDyLDZywW3ToREio2k9ZqtzrP9VOgm5SZyKhBmukyT6BMUinEbEBCRiQ9Zp6RiTv2x5YQ5VewaKAU2mv7qh77IJWBbOf/LlY8qX5XWvGFD9tJBq5LfB6dlB30qjyxkNZctYDBrW89AKHQTnMAukiol2IufGsnawgcxf+YjJ/f/cZT3PCH5lE//SHpMThztvNVWmAWagKTcv9IE/RjyjcUJRDlN+CLEsRmhBbuid54w1NGFqmKz6/14eLxjplqyYDPYNM3vz8gUHm0gBn3yPT9HK18mNfDjsMv0/ie6FhOdN2s8AjIzSciKfDoJvaCQEY4W4GIfbKMGDwUQpO0zX7LP8V4EHhpk7tEF4YlDv/fJX+jFg0yN9CUftww/mu5KO5TqAH9H7VF9AvhK1B7QSaLP3d3EXXtqKkOhXkqhoOOKWsJKb3t4ksPAhT9hG2AYXtxuhBifr6AWix4wsR4PdOQVlrfNNrWQDuIsuIVdk+0PUqfr8SLg5Kp70kjAkiJ6VhiBXbmidduEQZwnrAmGUfPsHFZHq56naKmfo0vJSxk4rcFROBI3d0OmBYJ1Dg8RdcM5IAUFa1AmZCdwqEs6+Yzvgj6qlyiW+M2at50sjiBys04zhDPCSwaKzke2gUsUCMfBrz9ZASRnypcVJLP59PqutgyHbM2RBghaMI9oUDdJPnlmbjRI3KrdHBF7EAJBZCV+1iCTK6s7CbrQHrKB4QW5vAer1es3xS5TQlysG/wYXa0JcgehCJH4GrecOknBXR4LkfamXGM8WNR41WcN9SlAVAFvO6gLzeJc1cJOP7/M60amzO3yet/6ANSTlQ7XeVHPFOs2Zex+ttz8J3Cofp89ZSY8YlBhCSz+LTcoqi1/gc1ZhX5QfxlspzNMYh7ctvlHumxCl1pcgoFU6wPtNO+YZBtAlDTLYSe4vqk3WIJyoTtNDugxj2gpFh+KuuMDLDya7QPsbAS1Dap8v/kLULVYnjfvOsz/JnVGGKs6mUEldgGB5gu061698hUq+FU82xQSSV8Q01SqLW/EaAIdgPPpnA9ZL0GQ9A9EI/gzz9aIMmZwCrmGYjiJyZVrPVyuhQthiRak8z/Ume+oDepzsvkwDBYqX3fcVNgNh8TFC73SAGsTzaub3IHNv1YixDNEi5Vb9ya1v2iK9xoU5RT96UiSuDJiITxbzuyQ+3TlvshRfVuMZc1jBcUvOMtuTyCiTLzfc+DHwlrtUdqAvw27DbzDrbew8J4CysKZxrA/eD31jmRH3sfD9jVx2dwK7e4Ktf2iibaW2YQqIYIXUFHvC8ZIXeUoJ6CglEjxbJrJbzuRUTvKq1HcBV1lEKPrunA2VjI3lwb7tjGpZTdZ+SGSAMn12IkTG3Wmi9YQEMPms+7OWcPpGQ9auAVlp/D1MjRiTqvGE4GMowmZfo0Ovw53h3mNuAY2mAXTFxU5bx1ql0fH5LGFJ9HpHr+a9WSzqUYDI4qrPGjxLaIZ200AIt1lNLwZBuRtWEYm9eHIdFP10m+5Knl5/b7UGaJApG/vO4zvQL8LvQ7Lf3Mi5V1k/i26hOxwCOO7V+XCuAZj1vlPusWJBCEFso/iMDKRVK5o1bMVPnPpNwyUl5iUMgq574g4ayRICjDdl960Nh/VYtqAvdHuegq6aA/H5iKxUyQBYrzHQ6mlRNGelPkNU2jFwDSZ1/Ks2BdYBQTTV23ZM0DP8zF2Kc/2T0wAfHLIeEPub6Xb+WM/LgXBQ7mkDq4XbA/PsifzKQ27x/VZYc7lm/bGVVZMPctuxJMIJiS4+mecFlmMDxTPB/DMMXVGzqTG51g+YxN1k1ZzgNbnvsvCqck9XV+Yd/hd/Qx5TNjnPT5NbUN1fYLcgKBDNOTfgrDOcQTxsjH84+t1RAXjU8tpUp5IXYC3yhK/Wpp50Igo66z538tMo+eRUTz7GfGfT2sDtSAKCAla//vQzFxFdc8E6M2el/j3Ci+zl7p1zfE9sCLbteRXTpf36b5c+eDydU3t69n83g6JwxSXLoO6MPlgGK3yKLaGeIuGqPqJbKTk/hExJBT6P8fWBVk4lkzAKL0iI3BxQEb21t/jD3d+IHhpGG24oSeo4i88W8xviAOAhz/d65p3piES0u3/y4pa4TlhNf8U+6i79Q4dLozbxWvvZ90ZJzKP4WZkHMJXFRe9C83j4tjZn4/K4d0CNxAjeEVkfeYpQo7JZRZVSgeFjKykUddJ2Sc+wPK4gKlocIAr3jX+M7UY9FMgG6M+O7Kvmi0P+uuGv4vQcmGeXZKOmgCTv4S/50lhdvPEBpJ6TLE6qjcnAveBm4blMrVkMQ+JXo+IYn6gFESQfthHxvVITdXVh2dd2vGen7tDrbOZcNkEoRbx23QhIbJKLZI9+H56l8nRmlhy+39IsA+uNUvKnPwYrjFLSbEeil84YZ3OV2TrzsuVWyjN7sog1nq9TKCJPoKtkmbTqPYR7RNloSgAUxtwWVxyhuenmlGJ9BzWi02+DMYRV+nhp3P33UwKRLn2IImOhCdf1E1ggRGQGPn3TuN+46Yf7Bg1sHaa58DOhaEH3uq1LwhRlMWlQKIdnQZEgeMCFdoWCw7ETTCuSuK/ppCiRfXl3mP/WICpzMCFCDqEWwO1FJfpwXvoKH3DuRFTWTEurBBofawYx3E7BMX721q7Zg1Hnaa3QDsylBxCJnQ1oX+G9c7wNooNBfffih/g3y8wST98Tz9WBik+4E8P2TCnHbCCkfe+OVwuzvwTtB1qApv/3iBwTLiysdR5BezHm30glrCnD0rguxMz3BY0P0eyWG9Y6nRLoKlXhoKDG1ivVTNPyrXTWiC7EzPcFjQ/R7JYb1jqdEugqVeGgoMbWK9VM0/KtdNaILsTM9wWND9HslhvWOp0S6CpV4aCgxtYr1UzT8q101oguxMz3BY0P0eyWG9Y6nRLoKlXhoKDG1ivVTNPyrXTWiC7EzPcFjQ/R2b9YiIx2uIvHwGT0QJ4NecoOAtp14vNG4f38/BkJtM+bfb027upi+szWgLnUz13StVLYEMHbXQ0I1/PFSH+MAJx6CFCYvjfVHLWtDV5fSO+F3hi52GiPpHsBp+XKACQjVj3duG0ciAyMKJpYH54wYMmyVehm7he7QAaD3rX6wKYn5bhyoBDdy7A0AAbNvwvGrFEf5Vm+d3nIQ5O99G9yp/lhRvQY1t44FqDWjFq8jW7JHpfOGVHpSLw6umgFZqNFtkSo8Rxal1d2welLOdqpVjn0vuB/ddjJW2bIanjzxFbKCH0RLozJjXBSaBizF73byDnO9CeLtfBS1vF8i7Xrsj/DjTRHOvBaVCmfLFOSZRz9KebVGXBWI2vJ2zWoesPVVR7nV6Fhh7X+whgrzQrY8FgZH87yeF8YkESWCWYGFdVVHudXoWGHtf7CGCvNCtjwWBkfzvJ4XxiQRJYJZgYV1VUe51ehYYe1/sIYK80K2PBYGR/O8nhfGJBElglmBhXVVR7nV6Fhh7X+whgrzQrY+Ay64AAxDVUuLD1xKPzOzuA6NnGkFiCq/yHF1O9qqFuoKlZ8VXlZ9i4QmF0eIVNRuUp8+LNUpVeKiBA/aJ3rOPrkcNfrXY+L2rgHOzAXjViOAHyBXHD19pwQyS6jaJ6XoCmDf1ETPWodV1dSp2ZwvsVjWTbFtIVSGIctPmFcjKE6rbZv81FBMZd79WnJTc6RVSjRfiBGXzzfanY6bbg8AquRRZxULvkzvuiGGssicW+qnt+pvl5ozztx/OYgGgPS704W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpA452RAwdds+gJbb20Ha4swr04W1HHG6wivkQ3qtLVukDjnZEDB12z6AltvbQdrizCvThbUccbrCK+RDeq0tW6QOOdkQMHXbPoCW29tB2uLMK9OFtRxxusIr5EN6rS1bpAxjjnip5OUCEgW9CraCwKb91DVbdlmSvMbB3Ixs77uuWO+J8CTyvG6u4kUfG9eXltiXIxFQZN5ArDZ7uYrmxEXkKV5y37p1hAW9F2bsuz/j91DQpDR7I0oJlqFbnDNbCI+wOUNjpr/a2nq7EJ4h2p7W2XP+xyTk3prn0ea5Ak0KN/7I4u3YxyFLkfqI5sJ6V/UetwGAlQtmT0TDSFG2SmNxkvzZEteRztMSd1wpui79miENrsy/xW1/+hURQ3uh2VGfKRhEfR7GvB9AMCUy48nAwmPpIAvYwrsRuDtcewRpUKvmdzWen7aSNzovU9851VgpXnLfunWEBb0XZuy7P+P3Ldlx/Dp5+DFaw8Pk3Bi6u0NVHif7XG/OkOeWPww4IZR0Nd45Xg6+kE/CdqSrdr61c6f4vybfhImj0kNdefebTqBK9LKt0geJ0WSIcH2B/6inK2Tkko5fZeOmFLk0PddPrtPX8d7Ht6q3uBBz6Z9sFpAnFnuoG1BT5ijqi6zDKlEkQJI5bYwRnXYL4Y6TWupKhNp+gvfa/MGNjQEf5i0EP+AAJFn+kgkAjeQnNfvfw8e+PdDTdFZ/OKGFt1qy6kYcEb/yxlskdT8y/K+znQC7DP8+09B1U2KA8YPq66JbJjExJzCfK/UKb9MH2x1ryJFoF+KBumnPt2/Em/wvqU7FTCpR/N+OGf+K9WZ4J8SUa+ZvyPKHlXMLvcn2M4rzFwB/zPgKjG8flizZ3aEGPAh8ul0d1kMlnBYN2GhvPDNW5p+UMxliMxJevwF2qfCvx89JqqZlnD3S/7HwHei2YkC66wlB1FTHIfjTzvxeAyk9vURqLcRZmicAv/YjQJS7Fqx3OuNFJrsiw+OWYHBn6Cr1bAUhyR9JVNAAOkDemUkeoxKzBFUA3Tkd/+7burW8woN4kOb5ezejk/WAR7K46aOvTfYA+FlLkj0j5NPtwTo/M6YmHb/4zLlz/YjJAkSV9I7xtOFvm+TkO1V98vXfmV+PXEACMYK5GWN9U6jew50AD56DQsSi3FwavClect+6dYQFvRdm7Ls/4/ct2XH8Onn4MVrDw+TcGLq4G61f6zcqO2AlWnZadCOIHIA7WfveAU8XIe9Bppp61GNVdv6HK26+CClect+6dYQFvRdm7Ls/4/ct2XH8Onn4MVrDw+TcGLq6zRDFXhnEeFtjtiP5tYrdMpPYkqAisnVNO0jaeG0Zi1GwYNQ0teXbCZIewPGrgROribRQYyQK3WFWGNgJmRRPRQ7A3H3RCBodnqvBK+9Esk+fr5eBaQR1cF2ScuprD8lpDZaim0XFdw/hh/U5k/Sr4EgeO/LjbtC1LPKrSowpidlmu+wrylyKnZQGuW9cCmXXsmgbW3xZlqUbMJ5fCSvT/s/NKjbZjbE5AdXby5z14QGawL9bo/wNRpBOnNQvo/RU6FSPquPTFHHGvOwavjzU+Noxz3XOwtDpW1/aprDmLQ6t7q5uCGVkGiUalSdIAnVS/V41JkIcxH/6EgI+shEXk9jphUWRfav7vdWQfxSVA6PfIEGZ6Q7v9dfb0/FfxBu95EOS4LiLn/Vd1ykubv+7HQHFPzaO0HO0eQv9xR5G8bZX8FwMKr6RCfOQLDLXr1eto9JDXXn3m02C5oxibdMVk+Nb/7CYs1Vyv016rF8Kna5vhgWItjpO6qEr+F2bH57gG4vlPp5rKujq/TN3FBGCARajsPvcSmQsur/2wunba6gMHMsV0k9xbQT7VC85iH5qcblj+7E/jbqr+zYyIuK25UcWtbe+DcCwpVKx4OKlgXKCXpxUH7IgrzAaCCk6dffRBPtULzmIfmqcvK3CisoYmwjL8tisUA4dwsEIrpZjenvjCOWL9rsksjsjctZVwC1QUcPdD065kwkpCYcmsT05bQMw7y9nmtJMu6wyyscY5anwtA76WRfPeqZXyeL9MCtCWX6UwlAZXpttQj7PA4+EHWTbq9rNQzOb4EixyXuwU469u0vrngSY398gQZnpDu/119vT8V/EG73kQ5LguIuf9V3XKS5u/7seRlDWjlc7bUOfdWBMo09nPD9GewyaMyCPJiELQX6bJv+z7GiM3fBndPdi13DKxwP33yBBmekO7/XX29PxX8QbveRDkuC4i5/1XdcpLm7/ux06n2RI9PXXCmUV/D+yQRJtxXI54o1uexylpKOMcW5Ly6Obe9hQ+f69NJflyohKWnkMtShYj/HFCReZEw+mv1ZL7jcUdY3jzaFH0DX6Jd1XFpsXoY+rho07c9QfvMgRQlQ/RnsMmjMgj5H4Eo97WsHyDix2gVsZbICyN5JKE0O9G3PUH7zIEUJUP0Z7DJozII+R+BKPe1rB86yJeHTLqjxc5T2GB7U/nsexwPG7uu5Cw1PA5YIT119zmPBqTdte0Agj4EFuyvM3Cg4tQ+Ajil46MZSC2nve/ZN1GFT5GQGEdiLCVbYxI/g8Y8Ml+8KgUo1Nu1d6NJGsy/O+sEAJtk1dxCCh0dzDa9bEKEe6+casLW9BnFE185ykleQl8+DKdOrZc/7HJOTemufR5rkCTQo3/sji7djHIUuR+ojmwnpX9R63AYCVC2ZPRMNIUbZKY3GS/NkS15HO0xJ3XCm6Lv2ZnykYRH0exrzDXHwPFFsNyKYqJMHo1nczTwqQWexzMSejm3vYUPn+vTSX5cqISlp5DLUoWI/xxQkXmRMPpr9WSh8LrENo1+LLfRQJrSL6F9njJfOAX4HQMlALCCaRa6jk7tVjcEP7TlaJyl3c3EDenWBkvEIRKw/AHP3WNrj56Lq4qIBUdCUktTLH+HN6GcsmQjw19C+xcqKBHmKH7AVFalVrEGQR4FBdBNko2npCcI9QqTZpdLjoWxdRsH35gvPImp96hl0I6ptyAaWUJXKQ6jsjctZVwC1QUcPdD065kwkpCYcmsT05bG+/OVf99O6H1aC/969uL6vsZoVMs/axOSQq1brAvyTFay1r5Gy5xLlXHglrXJnkXaKwhSYyp4zJ6QQIchwh1qo7I3LWVcAtUFHD3Q9OuZMJKQmHJrE9OWzB9eDAv71NJy9vfiLGh7ZyplfJ4v0wK0PTFw/drrDHT8fEcxgOUGWEX4/VTZLzXZMYMEn4ADJfKaPXiwWzd4tBlk8vi0kNL7fzFOpcTFd2OHhWCyKNA/LbDr+wo5PF1N9XkEVyOA+sA/jRnne83RerFBsWN8n8trFH4tToBz7fyOEIRUVpOMMSCdr32dO/x6KFraSm8misedi1JSedMmku1YjaUrA1MkxHmE6CflWQ5jZKvWDgkrSKS6xQvSYYPZaR++pp2FNyx6FVp3HDVUFNGzCeXwkr0/7PzSo22Y2xOLyVOXwRZQ5S9DvGU6ptweYko9FhPqqkvRswnl8JK9P+z80qNtmNsTi8lTl8EWUOUvQ7xlOqbcHm4qqvgLUVWeB/NiH/uLOsY8RKOxZTdejKbGvh5zEMA8N6pV0LOnteUaX85Z4g6YoccvNgkvv3UiGWTy+LSQ0vt/MU6lxMV3Y62++uMhVYjrf5ORGqNllXvO2iD1tbfU4tb34l6rMYqRx9YrNGGrQCF8ReSBY+VLTrAdXY8QrxiWli6qd/DzpUSYvWAh+BKLrwSOV3HSFzsr6xJzvmviR3E943E84pG4ciYumtdc05MUbu3BwoVEqgbClect+6dYQFvRdm7Ls/4/ct2XH8Onn4MVrDw+TcGLq4G61f6zcqO2MDFmDntZqOgeUfM/CnMBIT7GaFTLP2sTgpXnLfunWEBb0XZuy7P+P3Ldlx/Dp5+DFaw8Pk3Bi6ugABG3TyVN3Wnnnzf6Znn+wQG07GERocvWTbq9rNQzOZhmQ/Qd6UrzUK6l8BLKLP5Rswnl8JK9P+z80qNtmNsTi8lTl8EWUOUvQ7xlOqbcHk7COZv9zpaY6vOdFBRtZatxZWYIgjnsILcn5ALSRKA2Ex/+Kj4j7qqFA+a9aMrpKSM1rnQTvlNjc3gqSLGJLPSUd2vtJu+F7NZNur2s1DM5o6A3Xv3k7K1f6JecPICBnptCV2ac1MU8UcmDldOR9aGoDB1bB2aEqUCgiMU/32XMQWPmap38gv4jZTkj4Sj1IsxtVV/+QymZlPLH5JvQInKylxfSlwmZJuNH/q7l0pbdohhhRbJZbPdZjFD8HyQS3eY8WqHHwtQoxlkQYxlnvFwhrWNECn/eMHxcpJwyxy9o1+HcV+Lx5wUW3/SIxZuosnir4TU9Rjg4pu3/TESXQvd/iDhbSkMGHGuIPxPrPx03YATONVmmNWlDPSh/Jvmm3Im/VGiXotL9k0l+XKiEpaeQy1KFiP8cUJF5kTD6a/VkkRmdT8fHHjyJ0Hg3TbUBb6q7GOEkvyf2xn9khkGY+bAjNSV3C0rhpU1dSWKO0wdpS37zH2KhNmraZaZNPlbCc0NI8Jvicmyuf9jzlG2nhw4kBAXZ+pOKwnFcyoySxdMT9pZTBe+zAd90gBF9zi+nzsMiCAiLI7qOS5EMDq08wDa0oT3jtVFf94Z/ZIZBmPmwIzUldwtK4aVNXUlijtMHaUXD9PrIG0PNwzz15ZqIGkEq4n9YpcjhbYextr8Ns7nPV9X7cSE26nF0gddpQeTw064/f4LmjSFZrPZ1Kdfet3laXw0Gpx9l1vuXTVYUbS+BGWTy+LSQ0vt/MU6lxMV3Y62++uMhVYjrTZ6drjvk8GtF5I2FS/btD5lk8vi0kNL7fzFOpcTFd2OtvvrjIVWI602ena475PBrXdKNjrFzbRT007WZv0JqERXvflHLUwwcwJPJ9Jzl5+S+ldJJtI9rabAdXY8QrxiWqYeuLFRVW7yQCKVu8JP2LNCupfASyiz+cSxgDoBU4H6WtYFUr334XPWnDOhbpn6o51anocenW6McAXTvEJ9xQLezzki2ujCgymoaSv4jTAHjYqPJRv8KIZdkQAAX2QGJVUic6ti7qC/LRarK/VP7jQdXI7sWPAdo1Yrf2PVSSRP5g9ctLzojmnQiWfJvFzmGYgJAqhRnhaACTGsDPDyR+fGLc0Ih0WlXAUdswWE5M/bhtK/qZwr+tUScsvckP1xDXAIkyZuFSjC0Ilnybxc5hmICQKoUZ4WgAtF77U4ESNTCHR24eOrA/5vC/ZeRnQiwh5lKLCS/oTCmPFqhx8LUKMZZEGMZZ7xcIa1jRAp/3jB0Pommh5I01omGvH2vQhck/uTFQ9Lxipom2ToiBKnyoG4il5kz+9VuoJ2vfZ07/HooWtpKbyaKx52LUlJ50yaS7ViNpSsDUyTEeYToJ+VZDmNkq9YOCStIpLrFC9Jhg9lpH76mnYU3LHoVWnccNVQU0bMJ5fCSvT/s/NKjbZjbE4vJU5fBFlDlL0O8ZTqm3B5iSj0WE+qqS9GzCeXwkr0/7PzSo22Y2xOLyVOXwRZQ5S9DvGU6ptwebiqq+AtRVZ4H82If+4s6xjxEo7FlN16Mpsa+HnMQwDw3qlXQs6e15RpfzlniDpihxy82CS+/dSIZZPL4tJDS+38xTqXExXdjrb764yFViOt/k5Eao2WVe87aIPW1t9Ti1vfiXqsxipHH1is0YatAIXxF5IFj5UtOsB1djxCvGJaWLqp38POlRJi9YCH4EouvA/RnsMmjMgj6AT0xDtX3yi5UXgqTfbDXnm+wY6Jyn92+u66yqYjcgc68+rvc7XjH5XAT1O2njVEubV7rMDYKZMGsKbXcwG9ALgzbbRC1gzO+jsgdnkQv2xzQxpzjgQQI/sSVh+UHu7z5Opq4I0Nv4ibdvfosI8vwSV5CXz4Mp06tlz/sck5N6a59HmuQJNCjf+yOLt2MchS5H6iObCelf1HrcBgJULZk9Ew0hRtkpjcZL82RLXkc7TEndcKbou/Zs5HdNV09TPAj/JjWIXoYv+DsoWSZpWaK6ylJ5Uo/0A2k4fz9My1pvwpNlCmGajD5ApXnLfunWEBb0XZuy7P+P3W+e8yKXbF86fmk44tDTRB0dkQFyfsbWVmnRXGCc0KG43Oi9T3znVWTKT60qyCVi8ifKiZZ6rqVjmfkp61pS9vEODvHbW1VQ1mnRXGCc0KG43Oi9T3znVWKxQ6NRZCjPJ8r1ADvwQYITfUD/ilOR3FTElTVDABAABJTkZPSUdOUggAAABDYXJ0b29uAElBUlRAAAAARXBpYyBTdG9jayBNZWRpYSwgR2VvcmdlIEh1Zm5hZ2wsIENvbGxpbiBTY3VkZGVyLCBKb2huIFNjdWRkZXIAAElDTVRUAAAAVGhpcyBpcyBhIHNvdW5kIGVmZmVjdCBmcm9tIHRoZSBFcGljIFN0b2NrIE1lZGlhIEV4cGxhaW5lciBWaWRlbyBTRlggc291bmQgbGlicmFyeS4ASUNPUEgAAAAyMDE5IEVwaWMgU3RvY2sgTWVkaWEgKEV4cGxhaW5lciBWaWRlbyBTRlgpIGh0dHBzOi8vZXBpY3N0b2NrbWVkaWEuY29tAABJU0ZUDAAAAFNvdW5kbWluZXIAAElDUkQMAAAAMjAxOS0wMi0yMQAAaVhNTO4CAAA8QldGWE1MPjxJWE1MX1ZFUlNJT04+MS42MTwvSVhNTF9WRVJTSU9OPjxTVEVJTkJFUkc+PEFUVFJfTElTVD48QVRUUj48TkFNRT5NZWRpYUxpYnJhcnk8L05BTUU+PFRZUEU+c3RyaW5nPC9UWVBFPjxWQUxVRT5FeHBsYWluZXIgVmlkZW8gU0ZYPC9WQUxVRT48L0FUVFI+PEFUVFI+PE5BTUU+TWVkaWFDYXRlZ29yeVBvc3Q8L05BTUU+PFRZUEU+c3RyaW5nPC9UWVBFPjxWQUxVRT5DYXJ0b29uPC9WQUxVRT48L0FUVFI+PEFUVFI+PE5BTUU+TWVkaWFMaWJyYXJ5TWFudWZhY3R1cmVyTmFtZTwvTkFNRT48VFlQRT5zdHJpbmc8L1RZUEU+PFZBTFVFPkVwaWMgU3RvY2sgTWVkaWE8L1ZBTFVFPjwvQVRUUj48QVRUUj48TkFNRT5BdWRpb1NvdW5kRWRpdG9yPC9OQU1FPjxUWVBFPnN0cmluZzwvVFlQRT48VkFMVUU+RXBpYyBTdG9jayBNZWRpYSwgR2VvcmdlIEh1Zm5hZ2wsIENvbGxpbiBTY3VkZGVyLCBKb2huIFNjdWRkZXI8L1ZBTFVFPjwvQVRUUj48QVRUUj48TkFNRT5NZWRpYUNvbW1lbnQ8L05BTUU+PFRZUEU+c3RyaW5nPC9UWVBFPjxWQUxVRT5UaGlzIGlzIGEgc291bmQgZWZmZWN0IGZyb20gdGhlIEVwaWMgU3RvY2sgTWVkaWEgRXhwbGFpbmVyIFZpZGVvIFNGWCBzb3VuZCBsaWJyYXJ5LjwvVkFMVUU+PC9BVFRSPjxBVFRSPjxOQU1FPk11c2ljYWxDYXRlZ29yeTwvTkFNRT48VFlQRT5zdHJpbmc8L1RZUEU+PFZBTFVFPkNhcnRvb248L1ZBTFVFPjwvQVRUUj48L0FUVFJfTElTVD48L1NURUlOQkVSRz48L0JXRlhNTD5fUE1YJA4AADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+Cjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNS4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICAgICAgICAgIHhtbG5zOnhtcERNPSJodHRwOi8vbnMuYWRvYmUuY29tL3htcC8xLjAvRHluYW1pY01lZGlhLyI+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+U291bmRtaW5lciB2NFBybzwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOk1ldGFkYXRhRGF0ZT4yMDE5LTAyLTIxVDE2OjM0OjEzLTA2OjAwPC94bXA6TWV0YWRhdGFEYXRlPgogICAgICAgICA8eG1wOk1vZGlmeURhdGU+MjAxOS0wMi0yMVQxNjozNDoxMy0wNjowMDwveG1wOk1vZGlmeURhdGU+CiAgICAgICAgIDx4bXA6cmF0aW5nPjAuMDAwMDAwPC94bXA6cmF0aW5nPgogICAgICAgICA8ZGM6ZGVzY3JpcHRpb24+CiAgICAgICAgICAgIDxyZGY6QWx0PgogICAgICAgICAgICAgICA8cmRmOmxpIHhtbDpsYW5nPSJ4LWRlZmF1bHQiPlRoaXMgaXMgYSBzb3VuZCBlZmZlY3QgZnJvbSB0aGUgRXBpYyBTdG9jayBNZWRpYSBFeHBsYWluZXIgVmlkZW8gU0ZYIHNvdW5kIGxpYnJhcnkuPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9ImVuLVVTIj5UaGlzIGlzIGEgc291bmQgZWZmZWN0IGZyb20gdGhlIEVwaWMgU3RvY2sgTWVkaWEgRXhwbGFpbmVyIFZpZGVvIFNGWCBzb3VuZCBsaWJyYXJ5LjwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpBbHQ+CiAgICAgICAgIDwvZGM6ZGVzY3JpcHRpb24+CiAgICAgICAgIDxkYzpwdWJsaXNoZXI+CiAgICAgICAgICAgIDxyZGY6QmFnPgogICAgICAgICAgICAgICA8cmRmOmxpLz4KICAgICAgICAgICAgPC9yZGY6QmFnPgogICAgICAgICA8L2RjOnB1Ymxpc2hlcj4KICAgICAgICAgPGRjOnRpdGxlPgogICAgICAgICAgICA8cmRmOkFsdD4KICAgICAgICAgICAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ii8+CiAgICAgICAgICAgICAgIDxyZGY6bGkgeG1sOmxhbmc9ImVuLVVTIi8+CiAgICAgICAgICAgIDwvcmRmOkFsdD4KICAgICAgICAgPC9kYzp0aXRsZT4KICAgICAgICAgPHhtcERNOmNvbW1lbnQvPgogICAgICAgICA8eG1wRE06YWxidW0vPgogICAgICAgICA8eG1wRE06YXJ0aXN0Lz4KICAgICAgICAgPHhtcERNOmNvbXBvc2VyLz4KICAgICAgICAgPHhtcERNOmdlbnJlPkNhcnRvb248L3htcERNOmdlbnJlPgogICAgICAgICA8eG1wRE06aW5zdHJ1bWVudC8+CiAgICAgICAgIDx4bXBETTprZXkvPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgIAo8P3hwYWNrZXQgZW5kPSJ3Ij8+", Uke = "data:image/svg+xml,%3csvg%20width='34'%20height='32'%20viewBox='0%200%2034%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6056%2016.4128H18.6146'%20stroke='%23ED0A34'%20stroke-width='2.66667'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M14.5963%2016.4128H14.6053'%20stroke='%23ED0A34'%20stroke-width='2.66667'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M10.5873%2016.4128H10.5963'%20stroke='%23ED0A34'%20stroke-width='2.66667'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.7371%2023.0698C18.682%2026.1264%2014.1556%2026.7867%2010.4523%2025.074C9.90562%2024.8539%206.36715%2025.8339%205.59936%2025.067C4.83157%2024.2991%205.81241%2020.7601%205.59232%2020.2134C3.87886%2016.5106%204.54013%2011.9826%207.59622%208.9271C11.4975%205.0243%2017.8358%205.0243%2021.7371%208.9271C25.6464%2012.8359%2025.6383%2019.1681%2021.7371%2023.0698Z'%20stroke='%23ED0A34'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24.6667%201.625C20.784%201.625%2017.625%204.784%2017.625%208.66667C17.625%2012.5493%2020.784%2015.7083%2024.6667%2015.7083C28.5493%2015.7083%2031.7083%2012.5493%2031.7083%208.66667C31.7083%204.784%2028.5493%201.625%2024.6667%201.625Z'%20fill='%23ED0A34'/%3e%3cpath%20d='M26.3997%2011.1584L27.166%2010.3922L25.4326%208.66028L27.166%206.93055L26.4004%206.16355L24.6664%207.89472L22.933%206.16211L22.1667%206.92839L23.8994%208.66028L22.1667%2010.39L22.9323%2011.1563L24.6656%209.42583L26.3997%2011.1584Z'%20fill='white'/%3e%3c/svg%3e", Nke = ({ setOpenCloseChatPopup: t, handleCloseChat: e }) => /* @__PURE__ */ h("div", { className: "q-close-chat-popup-container", onClick: () => t(!1), children: /* @__PURE__ */ k("div", { className: "q-close-chat-popup-content", onClick: (r) => r.stopPropagation(), children: [
  /* @__PURE__ */ h("div", { className: "q-close-chat-popup-icon", children: /* @__PURE__ */ h("img", { src: Uke, alt: "close chat" }) }),
  /* @__PURE__ */ k("div", { className: "q-close-chat-popup-text", children: [
    /* @__PURE__ */ h("div", { children: "Close chat?" }),
    /* @__PURE__ */ h("div", { children: "Once closed, the chat will be locked. Continue?" })
  ] }),
  /* @__PURE__ */ k("div", { className: "q-helphub-satisfied-close-chat", style: { maxWidth: "100%", width: "100%" }, children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "q-helphub-close-chat",
        style: { color: "#181818" },
        onClick: () => t(!1),
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: "q-helphub-close-chat",
        style: { background: "#ED0A34", color: "white", borderColor: "#ED0A34" },
        onClick: () => e(),
        children: "Close chat"
      }
    )
  ] })
] }) }), jke = ({
  handleRating: t,
  chatData: e,
  currentConversationId: r
}) => {
  const n = [SM, PM, kM, OM, FM], [A, i] = N(0);
  return le(() => {
    var o;
    if (e && (e == null ? void 0 : e.length) > 0) {
      const s = e.filter(
        (a) => a.conversationId === r
      );
      (s == null ? void 0 : s.length) > 0 && i(((o = s[0]) == null ? void 0 : o.feedbackRate) || 0);
    }
  }, [e, r]), /* @__PURE__ */ k("div", { className: "q-helphub-emojiRatingContainer", children: [
    /* @__PURE__ */ k("div", { className: "q-helphub-emoji-text", children: [
      /* @__PURE__ */ h("div", { children: "We Value Your Feedback!" }),
      /* @__PURE__ */ h("div", { className: "q-helphub-emoji-text2", children: "Thank you! Before you go, could you please provide feedback on our chat today?" })
    ] }),
    /* @__PURE__ */ h("div", { className: "emojiRatingContainer2", children: n.map((o, s) => /* @__PURE__ */ h(
      "div",
      {
        className: "emojiStyle2",
        onClick: () => {
          A === 0 && (t(s + 1), i(s + 1));
        },
        style: {
          borderColor: A !== s + 1 && A !== 0 ? "gray" : "",
          backgroundColor: A !== s + 1 && A !== 0 ? "#E0E0E0" : A === s + 1 ? "#FFDD7CBF" : "",
          opacity: A !== s + 1 && A !== 0 ? 0.5 : 1,
          pointerEvents: A > 0 ? "none" : "auto"
        },
        "aria-disabled": A > 0,
        children: /* @__PURE__ */ h(
          "img",
          {
            src: o,
            style: {
              width: "24px",
              height: "24px",
              filter: A !== s + 1 && A !== 0 ? "grayscale(100%)" : ""
            },
            alt: `emoji${s}`
          }
        )
      },
      s
    )) }),
    /* @__PURE__ */ k("div", { className: "q-helphub-emoji-text3", children: [
      /* @__PURE__ */ h("div", { children: "Not satisfied" }),
      /* @__PURE__ */ h("div", { children: "Very satisfied" })
    ] })
  ] });
}, Lke = (t, e, r, n) => {
  var o, s;
  const A = (a) => {
    const c = [];
    return a.split(/\n\s*\n/).forEach((u, f) => {
      f > 0 && c.push({ type: "paragraph" }), u.split(/\n/).forEach((g, m) => {
        var C;
        m > 0 && c.push({ type: "break" });
        let p = 0;
        const v = g.length;
        for (; p < v; ) {
          const w = (C = g == null ? void 0 : g.slice(p)) == null ? void 0 : C.match(/\[([^\]]+)\]\(([^)]+)\)/), B = g == null ? void 0 : g.slice(p).match(/https?:\/\/[^\s<>[\]()]+/), y = g == null ? void 0 : g.slice(p).match(/\*\*([^*]+)\*\*/), b = g == null ? void 0 : g.slice(p).match(/_([^_]+)_/);
          if (w && w.index === 0)
            c.push({
              type: "link",
              text: w[1],
              url: w[2]
            }), p += w[0].length;
          else if (B && B.index === 0) {
            const q = g == null ? void 0 : g.slice(
              Math.max(0, p - 30),
              p
            ), { text: E, url: x } = i(B[0], q);
            c.push({
              type: "link",
              text: E,
              url: x
            }), p += B[0].length;
          } else if (y && y.index === 0)
            c.push({
              type: "bold",
              content: y[1]
            }), p += y[0].length;
          else if (b && b.index === 0)
            c.push({
              type: "italic",
              content: b[1]
            }), p += b[0].length;
          else {
            const q = g == null ? void 0 : g.slice(p).match(/[\[\*_]|https?:\/\//), E = q && q.index ? p + q.index : v;
            if (E > p && c.push({
              type: "text",
              content: g == null ? void 0 : g.slice(p, E)
            }), p = E, !q) break;
          }
        }
      });
    }), c;
  }, i = (a, c = "") => {
    if (a = a.replace(/[.,;!?)]+$/, ""), a.includes("linkedin.com")) return { text: "LinkedIn Profile", url: a };
    if (a.includes("xing.com")) return { text: "Xing Profile", url: a };
    if (a.includes("behance.net")) return { text: "Behance Portfolio", url: a };
    if (a.includes("dribbble.com"))
      return { text: "Dribbble Portfolio", url: a };
    if (a.includes("researchgate.net"))
      return { text: "ResearchGate Profile", url: a };
    if (a.includes("academia.edu")) return { text: "Academia Profile", url: a };
    if (a.includes("twitter.com") || a.includes("x.com"))
      return { text: "Twitter Profile", url: a };
    if (a.includes("instagram.com"))
      return { text: "Instagram Profile", url: a };
    if (a.includes("facebook.com")) return { text: "Facebook Profile", url: a };
    if (a.includes("tiktok.com")) return { text: "TikTok Profile", url: a };
    if (a.includes("snapchat.com")) return { text: "Snapchat Profile", url: a };
    if (a.includes("pinterest.com"))
      return { text: "Pinterest Profile", url: a };
    if (a.includes("reddit.com/u/")) return { text: "Reddit Profile", url: a };
    if (a.includes("weibo.com")) return { text: "Weibo Profile", url: a };
    if (a.includes("vk.com")) return { text: "VK Profile", url: a };
    if (a.includes("github.com")) return { text: "GitHub Repository", url: a };
    if (a.includes("gitlab.com")) return { text: "GitLab Repository", url: a };
    if (a.includes("bitbucket.org"))
      return { text: "Bitbucket Repository", url: a };
    if (a.includes("stackoverflow.com"))
      return { text: "Stack Overflow", url: a };
    if (a.includes("dev.to")) return { text: "Dev.to Article", url: a };
    if (a.includes("hashnode.com")) return { text: "Hashnode Blog", url: a };
    if (a.includes("npm.com")) return { text: "NPM Package", url: a };
    if (a.includes("pypi.org")) return { text: "PyPI Package", url: a };
    if (a.includes("calendly.com")) return { text: "Book a Call", url: a };
    if (a.includes("zoom.us")) return { text: "Join Zoom", url: a };
    if (a.includes("teams.microsoft.com"))
      return { text: "Join Teams Meeting", url: a };
    if (a.includes("meet.google.com"))
      return { text: "Join Google Meet", url: a };
    if (a.includes("webex.com")) return { text: "Join Webex", url: a };
    if (a.includes("whereby.com")) return { text: "Join Whereby", url: a };
    if (a.includes("notion.so")) return { text: "Notion Page", url: a };
    if (a.includes("airtable.com")) return { text: "Airtable Base", url: a };
    if (a.includes("trello.com")) return { text: "Trello Board", url: a };
    if (a.includes("asana.com")) return { text: "Asana Project", url: a };
    if (a.includes("clickup.com")) return { text: "ClickUp Task", url: a };
    if (a.includes("monday.com")) return { text: "Monday Board", url: a };
    if (a.includes("miro.com")) return { text: "Miro Board", url: a };
    if (a.includes("figma.com")) return { text: "Figma Design", url: a };
    if (a.includes("sketch.com")) return { text: "Sketch Design", url: a };
    if (a.includes("invisionapp.com"))
      return { text: "InVision Prototype", url: a };
    if (a.includes("docs.google.com/document"))
      return { text: "Google Doc", url: a };
    if (a.includes("docs.google.com/spreadsheets"))
      return { text: "Google Sheet", url: a };
    if (a.includes("docs.google.com/presentation"))
      return { text: "Google Slides", url: a };
    if (a.includes("docs.google.com/forms"))
      return { text: "Google Form", url: a };
    if (a.includes("drive.google.com")) return { text: "Google Drive", url: a };
    if (a.includes("office.com/word")) return { text: "Word Online", url: a };
    if (a.includes("office.com/excel")) return { text: "Excel Online", url: a };
    if (a.includes("office.com/powerpoint"))
      return { text: "PowerPoint Online", url: a };
    if (a.includes("onedrive.live.com"))
      return { text: "OneDrive File", url: a };
    if (a.includes("sharepoint.com")) return { text: "SharePoint", url: a };
    if (a.includes("slack.com")) return { text: "Slack Channel", url: a };
    if (a.includes("discord.com") || a.includes("discord.gg"))
      return { text: "Discord Server", url: a };
    if (a.includes("telegram.me") || a.includes("t.me"))
      return { text: "Telegram", url: a };
    if (a.includes("whatsapp.com")) return { text: "WhatsApp", url: a };
    if (a.includes("messenger.com")) return { text: "Messenger", url: a };
    if (a.includes("skype.com")) return { text: "Skype", url: a };
    if (a.includes("medium.com")) return { text: "Medium Article", url: a };
    if (a.includes("substack.com"))
      return { text: "Substack Newsletter", url: a };
    if (a.includes("wordpress.com")) return { text: "WordPress Blog", url: a };
    if (a.includes("ghost.io")) return { text: "Ghost Blog", url: a };
    if (a.includes("wix.com")) return { text: "Wix Site", url: a };
    if (a.includes("squarespace.com"))
      return { text: "Squarespace Site", url: a };
    if (a.includes("youtube.com") || a.includes("youtu.be"))
      return { text: "YouTube Video", url: a };
    if (a.includes("vimeo.com")) return { text: "Vimeo Video", url: a };
    if (a.includes("twitch.tv")) return { text: "Twitch Channel", url: a };
    if (a.includes("dailymotion.com"))
      return { text: "Dailymotion Video", url: a };
    if (a.includes("loom.com")) return { text: "Loom Recording", url: a };
    if (a.includes("dropbox.com")) return { text: "Dropbox File", url: a };
    if (a.includes("box.com")) return { text: "Box File", url: a };
    if (a.includes("wetransfer.com")) return { text: "WeTransfer", url: a };
    if (a.includes("mega.nz")) return { text: "MEGA File", url: a };
    if (a.includes("mediafire.com"))
      return { text: "MediaFire Download", url: a };
    if (a.includes("coursera.org")) return { text: "Coursera Course", url: a };
    if (a.includes("udemy.com")) return { text: "Udemy Course", url: a };
    if (a.includes("pluralsight.com"))
      return { text: "Pluralsight Course", url: a };
    if (a.includes("skillshare.com"))
      return { text: "Skillshare Class", url: a };
    if (a.includes("edx.org")) return { text: "edX Course", url: a };
    if (a.includes("brilliant.org")) return { text: "Brilliant Course", url: a };
    if (a.includes("indeed.com")) return { text: "Indeed Job", url: a };
    if (a.includes("glassdoor.com")) return { text: "Glassdoor", url: a };
    if (a.includes("lever.co")) return { text: "Lever Job", url: a };
    if (a.includes("greenhouse.io")) return { text: "Greenhouse Job", url: a };
    if (a.includes("workday.com")) return { text: "Workday", url: a };
    if (a.includes("spotify.com")) return { text: "Spotify", url: a };
    if (a.includes("apple.com/music")) return { text: "Apple Music", url: a };
    if (a.includes("soundcloud.com")) return { text: "SoundCloud", url: a };
    if (a.includes("mixcloud.com")) return { text: "Mixcloud", url: a };
    if (a.includes("anchor.fm")) return { text: "Anchor Podcast", url: a };
    if (a.includes("zendesk.com")) return { text: "Zendesk", url: a };
    if (a.includes("intercom.com")) return { text: "Intercom", url: a };
    if (a.includes("freshdesk.com")) return { text: "Freshdesk", url: a };
    if (a.includes("help.com")) return { text: "Help Center", url: a };
    if (a.includes("paypal.com")) return { text: "PayPal", url: a };
    if (a.includes("stripe.com")) return { text: "Stripe", url: a };
    if (a.includes("wise.com")) return { text: "Wise Transfer", url: a };
    if (a.includes("coinbase.com")) return { text: "Coinbase", url: a };
    if (a.includes("shopify.com")) return { text: "Shopify Store", url: a };
    if (a.includes("etsy.com")) return { text: "Etsy Shop", url: a };
    if (a.includes("amazon.com")) return { text: "Amazon Product", url: a };
    if (a.includes("ebay.com")) return { text: "eBay Listing", url: a };
    if (c.match(
      /(?:visit|check|at|on|here|link to|view|see|find|contact)(?:\s+at|\s+on|\s*:\s*)?$/i
    ))
      return { text: "here", url: a };
    try {
      return {
        text: `Visit ${new URL(a).hostname.replace("www.", "")}`,
        url: a
      };
    } catch {
      return { text: "Visit Link", url: a };
    }
  };
  return /* @__PURE__ */ h(
    "div",
    {
      style: {
        color: (s = (o = r == null ? void 0 : r.Chat) == null ? void 0 : o.RecieverMessege) == null ? void 0 : s.color,
        margin: "0",
        fontSize: "14px",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word"
      },
      children: A(t).map((a, c) => {
        switch (a.type) {
          case "text":
            return /* @__PURE__ */ h("span", { children: a.content }, c);
          case "link":
            return /* @__PURE__ */ k(
              "div",
              {
                style: {
                  display: "block",
                  position: "relative"
                },
                children: [
                  /* @__PURE__ */ k(
                    "a",
                    {
                      href: a.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      title: a.url,
                      style: {
                        color: (n == null ? void 0 : n.accentColor) || "#6563FF",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: "14px",
                        margin: "0px 0px 5px 0px",
                        padding: "0 2px",
                        wordBreak: "break-all",
                        position: "relative",
                        transition: "all 0.2s ease",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px"
                      },
                      onMouseEnter: (l) => {
                        const u = l.currentTarget;
                        u.style.opacity = "0.8";
                        const f = u.nextElementSibling;
                        f && (f.style.opacity = "1", f.style.visibility = "visible");
                      },
                      onMouseLeave: (l) => {
                        const u = l.currentTarget;
                        u.style.opacity = "1";
                        const f = u.nextElementSibling;
                        f && (f.style.opacity = "0", f.style.visibility = "hidden");
                      },
                      children: [
                        a.text,
                        /* @__PURE__ */ k(
                          "svg",
                          {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                              /* @__PURE__ */ h("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
                              /* @__PURE__ */ h("polyline", { points: "15 3 21 3 21 9" }),
                              /* @__PURE__ */ h("line", { x1: "10", y1: "14", x2: "21", y2: "3" })
                            ]
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ k(
                    "div",
                    {
                      style: {
                        position: "absolute",
                        bottom: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        opacity: 0,
                        visibility: "hidden",
                        transition: "all 0.2s ease",
                        zIndex: 1e3,
                        marginBottom: "8px",
                        maxWidth: "300px",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      },
                      children: [
                        a.url,
                        /* @__PURE__ */ h(
                          "div",
                          {
                            style: {
                              position: "absolute",
                              top: "100%",
                              left: "50%",
                              transform: "translateX(-50%)",
                              borderWidth: "4px",
                              borderStyle: "solid",
                              borderColor: "rgba(0, 0, 0, 0.8) transparent transparent transparent"
                            }
                          }
                        )
                      ]
                    }
                  )
                ]
              },
              c
            );
          case "bold":
            return /* @__PURE__ */ h("strong", { children: a.content }, c);
          case "italic":
            return /* @__PURE__ */ h("em", { children: a.content }, c);
          case "break":
            return /* @__PURE__ */ h("br", {}, c);
          case "paragraph":
            return /* @__PURE__ */ h(
              "div",
              {
                style: {
                  height: "1em",
                  width: "100%"
                }
              },
              c
            );
          default:
            return null;
        }
      })
    },
    e
  );
}, Gke = ({
  message: t,
  entityImage: e,
  index: r,
  setOpenCloseChatPopup: n,
  setIfSatisfied: A,
  selectedConversationId: i,
  setData: o,
  isAdminCloseChat: s,
  isCloseChatAdmin: a,
  QuestThemeData: c,
  styleConfig: l
}) => {
  var g, m, p, v, C, w, B, y;
  const u = (b) => b.split(/\n\n+/).map((q, E) => q.trim() === "" ? /* @__PURE__ */ h("br", {}, `br-${E}`) : Lke(q, E, l, c)), f = () => {
    const b = localStorage.getItem("chatSatisfied"), q = b ? JSON.parse(b) : {};
    q[i] = {
      isSatisfied: !0,
      messageId: t._id
    }, localStorage.setItem("chatSatisfied", JSON.stringify(q)), o(
      (E) => E.filter((x) => x._id !== t._id)
    ), A(!1);
  }, d = () => t.content.includes("https://quest-media-storage-bucket") || t.content.includes("https://pin.questprotocol.xyz/ipfs") ? /* @__PURE__ */ h("div", { className: "chat-coversion-img", children: /* @__PURE__ */ h("img", { src: t.content, alt: "" }) }) : u(t.content);
  return /* @__PURE__ */ k(Ze, { children: [
    (t.senderRole === "ASSISTANT" || t.senderRole === "ADMIN") && Pc(t == null ? void 0 : t.content).closeChatTag !== "CLOSE_CHAT" && /* @__PURE__ */ k("div", { className: "chat-profile-img-receiver", children: [
      /* @__PURE__ */ h("img", { src: e || $l, alt: "Entity" }),
      /* @__PURE__ */ h("div", { id: "chat-profile-img-receiver-tag", children: t.senderRole == "ASSISTANT" ? /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                fill: (c == null ? void 0 : c.accentColor) || "#9035FF"
              }
            ),
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                stroke: "white"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                d: "M9.82478 5.41875H9.33746L9.82478 4.4731L9.33746 4.23655L8.36224 5.41818H7.26534V4.70909L7.87436 4.47254V4L5.9245 4.00055V4.47309L6.53409 4.70964V5.41873H5.43719L4.46254 4.23711L3.97465 4.47311L4.46254 5.41875H3.97465C3.43648 5.41875 3 5.84143 3 6.36439V7.30948C3 8.61464 4.09004 9.67273 5.43717 9.67273H8.36224C9.70994 9.67273 10.8 8.61464 10.8 7.30948V6.36439C10.8 5.84143 10.363 5.41875 9.82478 5.41875ZM5.55885 7.782C5.22178 7.782 4.94984 7.51775 4.94984 7.1909C4.94984 6.86405 5.22178 6.5998 5.55885 6.5998C5.89593 6.5998 6.16844 6.86405 6.16844 7.1909C6.16844 7.5183 5.8965 7.782 5.55885 7.782ZM8.24056 7.782C7.90349 7.782 7.63155 7.51775 7.63155 7.1909C7.63155 6.86405 7.90349 6.5998 8.24056 6.5998C8.57763 6.5998 8.85015 6.86405 8.85015 7.1909C8.85015 7.5183 8.57763 7.782 8.24056 7.782Z",
                fill: "white"
              }
            )
          ]
        }
      ) : /* @__PURE__ */ k(
        "svg",
        {
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                fill: (c == null ? void 0 : c.accentColor) || "#9035FF"
              }
            ),
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                stroke: "white"
              }
            ),
            /* @__PURE__ */ h("g", { "clip-path": "url(#clip0_11529_4203)", children: /* @__PURE__ */ h(
              "path",
              {
                d: "M9.4502 3.6167H4.5502C3.87236 3.6167 3.3252 4.15978 3.3252 4.82945V9.28437C3.3252 9.95403 3.87236 10.4971 4.5502 10.4971H4.86053C5.1872 10.4971 5.49753 10.6237 5.7262 10.8524L6.42445 11.5424C6.74295 11.8569 7.26153 11.8569 7.58003 11.5424L8.27828 10.8524C8.50695 10.6237 8.82136 10.4971 9.14395 10.4971H9.4502C10.128 10.4971 10.6752 9.95403 10.6752 9.28437V4.82945C10.6752 4.15978 10.128 3.6167 9.4502 3.6167ZM7.0002 5.14795C7.52695 5.14795 7.95161 5.57262 7.95161 6.09937C7.95161 6.62612 7.52695 7.05078 7.0002 7.05078C6.47345 7.05078 6.04878 6.62203 6.04878 6.09937C6.04878 5.57262 6.47345 5.14795 7.0002 5.14795ZM8.09453 8.94953H5.90586C5.57511 8.94953 5.3832 8.58203 5.56695 8.30845C5.84461 7.89603 6.38361 7.61837 7.0002 7.61837C7.61678 7.61837 8.15578 7.89603 8.43345 8.30845C8.6172 8.58203 8.4212 8.94953 8.09453 8.94953Z",
                fill: "white"
              }
            ) }),
            /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_11529_4203", children: /* @__PURE__ */ h(
              "rect",
              {
                width: "9.8",
                height: "7.7",
                fill: "white",
                transform: "translate(2.1001 2.80005)"
              }
            ) }) })
          ]
        }
      ) })
    ] }),
    (t.senderRole === "ASSISTANT" || t.senderRole === "ADMIN") && ((g = Pc(t == null ? void 0 : t.content)) == null ? void 0 : g.closeChatTag) == "CLOSE_CHAT" && !s && !a && /* @__PURE__ */ k("div", { className: "chat-profile-img-receiver", children: [
      /* @__PURE__ */ h("img", { src: e || $l, alt: "Entity" }),
      t.senderRole == "ASSISTANT" ? /* @__PURE__ */ k(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          children: [
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                fill: (c == null ? void 0 : c.accentColor) || "#9035FF"
              }
            ),
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                stroke: "white"
              }
            ),
            /* @__PURE__ */ h(
              "path",
              {
                d: "M9.82478 5.41875H9.33746L9.82478 4.4731L9.33746 4.23655L8.36224 5.41818H7.26534V4.70909L7.87436 4.47254V4L5.9245 4.00055V4.47309L6.53409 4.70964V5.41873H5.43719L4.46254 4.23711L3.97465 4.47311L4.46254 5.41875H3.97465C3.43648 5.41875 3 5.84143 3 6.36439V7.30948C3 8.61464 4.09004 9.67273 5.43717 9.67273H8.36224C9.70994 9.67273 10.8 8.61464 10.8 7.30948V6.36439C10.8 5.84143 10.363 5.41875 9.82478 5.41875ZM5.55885 7.782C5.22178 7.782 4.94984 7.51775 4.94984 7.1909C4.94984 6.86405 5.22178 6.5998 5.55885 6.5998C5.89593 6.5998 6.16844 6.86405 6.16844 7.1909C6.16844 7.5183 5.8965 7.782 5.55885 7.782ZM8.24056 7.782C7.90349 7.782 7.63155 7.51775 7.63155 7.1909C7.63155 6.86405 7.90349 6.5998 8.24056 6.5998C8.57763 6.5998 8.85015 6.86405 8.85015 7.1909C8.85015 7.5183 8.57763 7.782 8.24056 7.782Z",
                fill: "white"
              }
            )
          ]
        }
      ) : /* @__PURE__ */ k(
        "svg",
        {
          width: "14",
          height: "14",
          viewBox: "0 0 14 14",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                fill: (c == null ? void 0 : c.accentColor) || "#9035FF"
              }
            ),
            /* @__PURE__ */ h(
              "rect",
              {
                x: "0.5",
                y: "0.5",
                width: "13",
                height: "13",
                rx: "6.5",
                stroke: "white"
              }
            ),
            /* @__PURE__ */ h("g", { "clip-path": "url(#clip0_11529_4203)", children: /* @__PURE__ */ h(
              "path",
              {
                d: "M9.4502 3.6167H4.5502C3.87236 3.6167 3.3252 4.15978 3.3252 4.82945V9.28437C3.3252 9.95403 3.87236 10.4971 4.5502 10.4971H4.86053C5.1872 10.4971 5.49753 10.6237 5.7262 10.8524L6.42445 11.5424C6.74295 11.8569 7.26153 11.8569 7.58003 11.5424L8.27828 10.8524C8.50695 10.6237 8.82136 10.4971 9.14395 10.4971H9.4502C10.128 10.4971 10.6752 9.95403 10.6752 9.28437V4.82945C10.6752 4.15978 10.128 3.6167 9.4502 3.6167ZM7.0002 5.14795C7.52695 5.14795 7.95161 5.57262 7.95161 6.09937C7.95161 6.62612 7.52695 7.05078 7.0002 7.05078C6.47345 7.05078 6.04878 6.62203 6.04878 6.09937C6.04878 5.57262 6.47345 5.14795 7.0002 5.14795ZM8.09453 8.94953H5.90586C5.57511 8.94953 5.3832 8.58203 5.56695 8.30845C5.84461 7.89603 6.38361 7.61837 7.0002 7.61837C7.61678 7.61837 8.15578 7.89603 8.43345 8.30845C8.6172 8.58203 8.4212 8.94953 8.09453 8.94953Z",
                fill: "white"
              }
            ) }),
            /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_11529_4203", children: /* @__PURE__ */ h(
              "rect",
              {
                width: "9.8",
                height: "7.7",
                fill: "white",
                transform: "translate(2.1001 2.80005)"
              }
            ) }) })
          ]
        }
      )
    ] }),
    ((m = Pc(t == null ? void 0 : t.content)) == null ? void 0 : m.closeChatTag) === "CLOSE_CHAT" ? !s && !a ? /* @__PURE__ */ h("div", { style: { display: "flex", gap: "8px" }, children: /* @__PURE__ */ k("div", { className: "q-helphub-satisfied-user-reply2", children: [
      /* @__PURE__ */ h(
        "div",
        {
          className: "message receiver-role",
          id: "q-helphub-satisfied-user-reply",
          style: { ...(p = l == null ? void 0 : l.Chat) == null ? void 0 : p.RecieverMessege },
          children: /* @__PURE__ */ h("p", { style: { color: (C = (v = l == null ? void 0 : l.Chat) == null ? void 0 : v.RecieverMessege) == null ? void 0 : C.color }, children: ((w = Pc(t == null ? void 0 : t.content)) == null ? void 0 : w.regularString) || "Are you satisfied, or do you have any other queries? If not, would you like to close the chat?" })
        }
      ),
      /* @__PURE__ */ k("div", { className: "q-helphub-satisfied-close-chat", children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-helphub-close-chat",
            onClick: () => n(!0),
            children: "Close chat"
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "q-helphub-close-chat-continue",
            onClick: f,
            children: "Continue chat"
          }
        )
      ] })
    ] }) }) : /* @__PURE__ */ h(Ze, {}) : /* @__PURE__ */ k("div", { style: { width: "100%" }, children: [
      /* @__PURE__ */ h(
        "div",
        {
          className: `message ${t.senderRole === "USER" ? "sender-role" : "receiver-role"}`,
          style: t.senderRole === "USER" ? { ...(B = l == null ? void 0 : l.Chat) == null ? void 0 : B.SenderMessage } : { ...(y = l == null ? void 0 : l.Chat) == null ? void 0 : y.RecieverMessege },
          children: d()
        }
      ),
      /* @__PURE__ */ h(
        "div",
        {
          className: `message ${t.senderRole === "USER" ? "sender-role sender-time" : "receiver-role sender-time"}`,
          children: nj(t.timestamp)
        }
      )
    ] }, r)
  ] });
}, Rke = ({
  message: t,
  index: e,
  fontSize: r,
  QuestThemeData: n,
  styleConfig: A
}) => {
  var s, a;
  const i = (c, l) => {
    var g, m;
    const u = /(\bhttps?:\/\/[^\s)]+)/gi, d = c.split(u).map((p, v) => {
      if (u.test(p)) {
        const C = p.endsWith(".") || p.endsWith(")") || p.endsWith("]") || p.endsWith("}") ? p == null ? void 0 : p.slice(0, -1) : p;
        return /* @__PURE__ */ h(
          "a",
          {
            href: C,
            target: "_blank",
            style: { fontSize: r },
            children: C
          },
          v
        );
      }
      return p;
    });
    return /* @__PURE__ */ h(
      "p",
      {
        style: {
          color: ((m = (g = A == null ? void 0 : A.Chat) == null ? void 0 : g.SenderMessage) == null ? void 0 : m.color) || PA(n == null ? void 0 : n.accentColor, -0.5).darker
        },
        children: d
      },
      l
    );
  };
  function o(c) {
    return c.split(`
`).map((u, f) => i(u, f));
  }
  return /* @__PURE__ */ k(Ze, { children: [
    /* @__PURE__ */ k("div", { style: { width: "100%" }, children: [
      /* @__PURE__ */ h(
        "div",
        {
          className: `message ${(t == null ? void 0 : t.senderRole) === "USER" ? "sender-role" : "receiver-role"}`,
          style: (
            // message.senderRole === "USER"
            //   ? { ...styleConfig?.Chat?.SenderMessage }
            //   : { ...styleConfig?.Chat?.RecieverMessege }
            {
              background: kc(n == null ? void 0 : n.accentColor)
            }
          ),
          children: (s = t == null ? void 0 : t.content) != null && s.includes("https://quest-media-storage-bucket") || (a = t == null ? void 0 : t.content) != null && a.includes("https://pin.questprotocol.xyz/ipfs") ? /* @__PURE__ */ h("div", { className: "chat-coversion-img", children: /* @__PURE__ */ h("img", { src: t == null ? void 0 : t.content, alt: "" }) }) : /* @__PURE__ */ h(Ze, { children: o(t.content) })
        }
      ),
      /* @__PURE__ */ h(
        "div",
        {
          className: `message ${(t == null ? void 0 : t.senderRole) === "USER" ? "sender-role sender-time" : "receiver-role sender-time"}`,
          children: nj(t.timestamp)
        }
      )
    ] }, e),
    (t == null ? void 0 : t.senderRole) === "USER" && /* @__PURE__ */ h(
      "div",
      {
        className: "chat-profile-img-sender",
        style: { background: kc(n == null ? void 0 : n.accentColor), borderRadius: "50%" },
        children: /* @__PURE__ */ k(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: [
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z",
                  fill: (n == null ? void 0 : n.accentColor) || "#9035FF"
                }
              ),
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M12.8102 10.6124C10.7177 9.21741 7.30521 9.21741 5.19771 10.6124C4.24521 11.2499 3.72021 12.1124 3.72021 13.0349C3.72021 13.9574 4.24521 14.8124 5.19021 15.4424C6.24021 16.1474 7.62021 16.4999 9.00021 16.4999C10.3802 16.4999 11.7602 16.1474 12.8102 15.4424C13.7552 14.8049 14.2802 13.9499 14.2802 13.0199C14.2727 12.0974 13.7552 11.2424 12.8102 10.6124Z",
                  fill: (n == null ? void 0 : n.accentColor) || "#9035FF"
                }
              )
            ]
          }
        )
      }
    )
  ] });
};
let dP = "https://s3-alpha-sig.figma.com/img/c73b/ede1/44dae2a681a58d566da9f69147cc690d?Expires=1713744000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=XJcQc8XNhFza8CJhDAyWRNg9DCoXlrD4E2wn1JDTXS4GFD3XmwsrPggispX-rCLfIw~LJAZGJVvog4bAZ7y5T2UHfn7SkPWSqTZrCftSeZzVjMTej3u5y3ZL28S3tIekwU9BZ3fzSe1HgprPHdZNCxMgOlqyhA6pb9tCSQ6Vu0Z7W8z9Hh6OmCJje68iaAro9DsHtu~wvstZjyfEENlhWWG4wMK5tZTw3hRBYKAmSExdiFb25DjhBUG~cHoXYV6A5286pwskNTO0QrPHULje839o8TdBKsvI4CC2v7yCiYC1V7Qlcd-h6GH-P0DL2qfttlIlZD3frTKsnW1EA-0PHQ__";
const cm = (t) => {
  var jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn, dt;
  const {
    contentConfig: e,
    styleConfig: r,
    apiType: n,
    apiKey: A,
    entityId: i,
    token: o,
    userId: s,
    setShowBottomNavigation: a,
    entityImage: c,
    entityName: l,
    setHelpHub: u,
    uniqueUserId: f,
    uniqueEmailId: d,
    position: g,
    sendAutoMessage: m,
    setSendAutoMessage: p,
    chat: v,
    setChat: C,
    filterChat: w,
    setFilterChat: B,
    fetchData: y,
    entityAuthenticationToken: b,
    defaultAutoPopupMessagesApi: q = [],
    isPopMessageAudio: E,
    setOpenCloseChatPopup: x,
    openCloseChatPopup: M,
    isActive: O,
    BrandTheme: I,
    QuestThemeData: S
  } = t, { themeConfig: P } = Xe(ct.Context), [H, F] = N(!1), [T, U] = N(""), [D, Q] = N([]), Y = gt(null), j = gt(null), [Z, W] = N(!1), [R, K] = N(!1);
  let L = n == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const [G, V] = N(""), [_, J] = N(null), [X, ne] = N(""), [ee, $] = N(!0), [te, ae] = N(""), [se, ue] = N(!1), [fe, ve] = N(!1), [ge, oe] = N(!1), [ce, pe] = N(!1), [qe, Se] = N(""), [Te, be] = N(!1), [He, Ge] = N(!1), [Le, Ae] = N(""), [Pe, it] = N(!1), de = gt(null), [xe, he] = N(""), [Qe, Re] = N(!1), [pt, ze] = N(!1), [lt, st] = N(!1), [We, Je] = N(!1), ut = async () => {
    m != "" && (Qt(!0), $((ie) => !ie), setTimeout(() => {
      Q([]), ae(""), F((ie) => !ie), a && a((ie) => !ie), kt(!1), $((ie) => !ie), Ot(m || "");
    }, 100), p && p(""));
  }, Be = async (ie) => {
    let _e = await Ske({
      conversationId: te,
      feedbackRate: ie,
      entityId: i,
      userId: s,
      token: o,
      apikey: A,
      backend_url: L,
      uniqueUserId: f,
      uniqueEmailId: d,
      apiType: n,
      entityAuthenticationToken: b
    });
    if (_e != null && _e.success) {
      let Ne = w == null ? void 0 : w.map((Ee) => Ee.conversationId == te ? {
        ...Ee,
        feedbackRate: ie
      } : Ee);
      Ne && B && B(Ne), $((Ee) => !Ee), kt((Ee) => !Ee), St(!0), st(!0), Ge(() => !1), setTimeout(() => {
        a && a(!0), Qt(!1), F(!1);
      }, 250);
    }
  }, [Ct, Ye] = N(""), $e = async () => {
    Ct != "" && ($((ie) => !ie), Ot(Ct || ""), p && p(""));
  };
  le(() => {
    ut();
  }, [m]), le(() => {
    $e();
  }, [Ct]);
  const nt = async () => {
    var ie, _e;
    if (pt == !1 && D.length != 0 && (D.length == 2 || D.length % 9 == 0)) {
      let Ne = await xke(
        L,
        i,
        s,
        o,
        A,
        f,
        d,
        n,
        b
      );
      Ne != null && Ne.success && ((_e = (ie = Ne == null ? void 0 : Ne.data) == null ? void 0 : ie.emails) != null && _e.length ? (ze(!0), Re(!1)) : (Re(!0), it(!0)));
    }
  }, mt = async () => {
    if (Re(!1), it(!1), /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(xe)) {
      let _e = await Ike(
        L,
        i,
        s,
        o,
        A,
        f,
        d,
        n,
        xe,
        b
      );
      _e != null && _e.success && ze(!0);
    }
  };
  le(() => {
    nt();
  }, [D]), le(() => {
    var ie;
    (ie = de.current) == null || ie.focus();
  }, [v, Pe]);
  const me = (ie) => {
    var Ne;
    let _e = JSON.parse(
      localStorage.getItem("lastSeenRecord") || "{}"
    );
    (Ne = ie || v) == null || Ne.forEach((Ee) => {
      var et;
      _e[Ee.conversationId] = (et = Ee == null ? void 0 : Ee.conversations) == null ? void 0 : et.content;
    }), localStorage.setItem("lastSeenRecord", JSON.stringify(_e));
  }, yt = (ie) => {
    ie ? (ue(!1), Ge(!0)) : (ve(!0), ue(!1));
  }, Ue = (ie) => {
    ie == "option1" ? (Ot("I need more details"), ve(!1)) : (Ke(!1), ve(!1), be(!0), setTimeout(() => {
      be(!1);
    }, 2500));
  }, Ie = (ie) => ie.sort((Ne, Ee) => {
    var et, Ft;
    return new Date((et = Ee == null ? void 0 : Ee.conversations) == null ? void 0 : et.timestamp).getTime() - new Date((Ft = Ne == null ? void 0 : Ne.conversations) == null ? void 0 : Ft.timestamp).getTime();
  }), ot = async () => {
    let ie = await Eke(
      L,
      i,
      s,
      o,
      A,
      te,
      f,
      d,
      n,
      b
    );
    if (ie != null && ie.success && te != "") {
      let _e = (v == null ? void 0 : v.map((Ne) => Ne.conversationId == te ? {
        ...Ne,
        isClosed: !0
      } : Ne)) || [];
      C && C(Ie(_e)), B && B(Ie(_e)), oe(!1), Q((Ne) => Ne), ue(!1), ve(!1), Se(""), be(!1), Re(!1), st(!0), Ge(() => !1), setTimeout(() => {
      }, 250);
    }
  }, Ke = async (ie) => {
    let _e = await Bke(
      L,
      i,
      s,
      o,
      A,
      ie,
      te,
      f,
      d,
      n,
      b
    );
    if (_e != null && _e.success && (ue(!1), ie == !1)) {
      let Ne = (v == null ? void 0 : v.map((Ee) => Ee.conversationId == te ? {
        ...Ee,
        onlyAdminReply: !0,
        isResolved: !1
      } : Ee)) || [];
      C && C(Ie(Ne)), B && B(Ie(Ne)), oe(!0);
    }
  };
  le(() => {
    var _e;
    let ie = (v == null ? void 0 : v.filter((Ne) => Ne.conversationId == te)) || [];
    (ie == null ? void 0 : ie.length) > 0 && oe((_e = ie[0]) == null ? void 0 : _e.onlyAdminReply);
  }, [D]);
  const tt = (ie) => {
    let _e = ie ? Dke : Qke;
    const Ne = new Audio(_e);
    Ne.volume = 0.15, Ne.play().catch((Ee) => {
      console.error("Error playing the audio:", Ee);
    });
  };
  async function Ot(ie) {
    var Ft, je, ur, Me, De, Ce, Pt;
    if (Pe)
      return;
    W(!0), it(!0), ue(!1), Re(!1), ve(!1), be(!1), Ge(!1);
    let _e = {
      senderRole: "USER",
      _id: (/* @__PURE__ */ new Date()).toISOString(),
      senderId: s || "",
      content: ie,
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
    E && tt(!0), Q((Ut) => [...Ut, _e]);
    let Ne = v || [];
    te && (Ne = (v == null ? void 0 : v.map((Ut) => Ut.conversationId == te ? {
      ...Ut,
      conversations: _e
    } : Ut)) || [], C && C(Ie(Ne)), B && B(Ie(Ne)), me(Ne || []));
    let Ee = await bke(
      L,
      i,
      s,
      o,
      A,
      ie,
      te,
      f,
      d,
      n,
      b
    );
    if ((Ft = Ee == null ? void 0 : Ee.data) != null && Ft.replied) {
      te || ae(
        (ur = (je = Ee == null ? void 0 : Ee.data) == null ? void 0 : je.conversationData) == null ? void 0 : ur.conversationId
      );
      let Ut = te || ((De = (Me = Ee == null ? void 0 : Ee.data) == null ? void 0 : Me.conversationData) == null ? void 0 : De.conversationId);
      Q((at) => {
        var vt;
        return [...at, (vt = Ee == null ? void 0 : Ee.data) == null ? void 0 : vt.message];
      });
      let It = !1;
      if (Ne = (v == null ? void 0 : v.map((at) => {
        var vt, zt, Ht, _t, or;
        return at.conversationId == Ut ? (It = !0, {
          ...at,
          conversations: (vt = Ee == null ? void 0 : Ee.data) == null ? void 0 : vt.message,
          ...!!((Ht = (zt = Ee == null ? void 0 : Ee.data) == null ? void 0 : zt.conversationData) != null && Ht.title) && !qe && {
            title: (or = (_t = Ee == null ? void 0 : Ee.data) == null ? void 0 : _t.conversationData) == null ? void 0 : or.title
          }
        }) : at;
      })) || [], !It) {
        let at = (Ce = Ee == null ? void 0 : Ee.data) == null ? void 0 : Ce.conversationData;
        at.conversations = (Pt = Ee == null ? void 0 : Ee.data) == null ? void 0 : Pt.message, Ne = [...Ne, at];
      }
    }
    E && !ge && tt(!1), C && C(Ie(Ne)), B && B(Ie(Ne)), me(Ne || []), W((Ut) => !Ut), it((Ut) => !Ut);
    let et = JSON.parse(
      localStorage.getItem("askSatisfaction") || "{}"
    );
    te != "" && (et[te] ? et[te] += 1 : et[te] = 1, et[te] >= 3 && (ue(!0), et[te] = 0), localStorage.setItem("askSatisfaction", JSON.stringify(et)));
  }
  const Vt = () => {
    if (_) {
      debugger;
      it(!0), (async () => {
        var Ft, je;
        let _e = s, Ne = o;
        const Ee = await kke({
          entityId: i,
          userId: s,
          token: o,
          apiKey: A,
          uniqueUserId: f,
          uniqueEmailId: d,
          apiType: n,
          entityAuthenticationToken: b
        });
        if (Ee != null && Ee.success)
          _e = (Ft = Ee == null ? void 0 : Ee.data) == null ? void 0 : Ft.userId, Ne = (je = Ee == null ? void 0 : Ee.data) == null ? void 0 : je.token;
        else {
          console.log(Ee == null ? void 0 : Ee.error), it(!1);
          return;
        }
        let et = await ote(
          _,
          L,
          A,
          _e,
          Ne
        );
        V(et == null ? void 0 : et.imageUrl), J(null), ne(""), Ot(et == null ? void 0 : et.imageUrl), $((ur) => !ur);
      })(), j.current && j.current.value && (j.current.value = "");
    }
    T.length > 0 && Ot(T), U("");
  }, Mt = (ie) => {
    ie.target.files[0] && (J(ie.target.files[0]), ne(ie.target.files[0].name));
  }, lr = () => {
    const ie = document.getElementById("helpHub");
    if (ie && Y.current) {
      const _e = g == "POPUP" ? ie.clientHeight : window.innerHeight;
      Y.current.style.height = _e - 191 + "px";
    }
  };
  le(() => {
    Y.current && (Y.current.scrollTop = Y.current.scrollHeight), lr();
  }, [
    D,
    ee,
    g,
    He,
    We,
    lt
  ]), le(() => (window.addEventListener("resize", lr), lr(), () => window.removeEventListener("resize", lr)), []);
  const Lr = async (ie) => {
    var _e, Ne, Ee;
    if (ie) {
      pe(!0), ae(ie);
      let et = await fy(
        L,
        i,
        s,
        o,
        A,
        ie || "",
        f,
        d,
        n,
        b
      );
      Q((_e = et == null ? void 0 : et.data) == null ? void 0 : _e.conversations), pe(!1), (Ne = et == null ? void 0 : et.data) != null && Ne.title && !qe && Se((Ee = et == null ? void 0 : et.data) == null ? void 0 : Ee.title);
    }
  }, [Et, Qt] = N(
    null
  ), [Er, kt] = N(null), [en, St] = N(null);
  return le(() => {
    let ie = v && v.filter((_e) => {
      var Ne;
      return (Ne = _e == null ? void 0 : _e.title) == null ? void 0 : Ne.toLowerCase().includes(Le == null ? void 0 : Le.toString().toLowerCase());
    });
    ie && B && B(Ie(ie));
  }, [Le]), /* @__PURE__ */ k(Ze, { children: [
    !H && /* @__PURE__ */ k(
      "div",
      {
        className: `helpHubChat animatedDissolve ${Et ? "updateOutAnimation" : en ? "updateInAnimation" : ""}`,
        style: {
          background: P == null ? void 0 : P.backgroundColor,
          ...(jr = r == null ? void 0 : r.Chat) == null ? void 0 : jr.Form
        },
        children: [
          /* @__PURE__ */ h("div", { className: "q-helphub-chatpage-upper-container", children: /* @__PURE__ */ k("div", { className: "q-helphub-chatpage-text-container", children: [
            /* @__PURE__ */ k("div", { className: "q-helphub-chatpage-head-para", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q-helphub-chatpage-heading",
                  style: {
                    color: ((un = (ln = (cn = r == null ? void 0 : r.Chat) == null ? void 0 : cn.Topbar) == null ? void 0 : ln.Heading) == null ? void 0 : un.color) || (I == null ? void 0 : I.primaryColor) || (P == null ? void 0 : P.primaryColor),
                    ...(fn = (dn = r == null ? void 0 : r.Chat) == null ? void 0 : dn.Topbar) == null ? void 0 : fn.Heading
                  },
                  children: (e == null ? void 0 : e.heading) || "Chats"
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q-helphub-chatpage-para",
                  style: {
                    color: (I == null ? void 0 : I.secondaryColor) || (P == null ? void 0 : P.secondaryColor),
                    ...(En = (hn = r == null ? void 0 : r.Chat) == null ? void 0 : hn.Topbar) == null ? void 0 : En.SubHeading
                  },
                  children: (e == null ? void 0 : e.subHeading) || "Welcome back, Please talk to us to understand"
                }
              )
            ] }),
            /* @__PURE__ */ h("div", { className: "q-helphub-chatpage-btn-container", children: /* @__PURE__ */ h("img", { src: a9, alt: "", onClick: () => {
              u(!1), O && O(!1);
            } }) })
          ] }) }),
          /* @__PURE__ */ k("div", { className: "q-helphub-chatpage-lower-container", children: [
            !y && /* @__PURE__ */ k("div", { className: "q-helphub-search-chats-container", children: [
              /* @__PURE__ */ h("div", { className: "search-outer-div", children: /* @__PURE__ */ k(
                "div",
                {
                  className: "q-helphub-search-container-search",
                  style: { ...(xn = r == null ? void 0 : r.Chat) == null ? void 0 : xn.Searchbox },
                  children: [
                    /* @__PURE__ */ h(
                      "input",
                      {
                        className: "q-helphub-search-input",
                        type: "text",
                        placeholder: "Search for help...",
                        onChange: (ie) => {
                          Ae(ie.target.value);
                        }
                      }
                    ),
                    /* @__PURE__ */ h("div", { className: "q-helphub-search-btn", children: /* @__PURE__ */ h("img", { src: oj, alt: "" }) })
                  ]
                }
              ) }),
              /* @__PURE__ */ h("div", { className: "q-helphub-chats-section", children: v != null && v.length ? w == null ? void 0 : w.map((ie, _e) => {
                var Ne, Ee, et, Ft, je, ur, Me, De;
                return /* @__PURE__ */ k(
                  "div",
                  {
                    className: "q-helphub-chat-detail",
                    onClick: () => {
                      it(ie.isClosed), st(ie.isClosed), Qt(!0), $((Ce) => !Ce), Lr(ie == null ? void 0 : ie.conversationId), setTimeout(() => {
                        F((Ce) => !Ce), a && a((Ce) => !Ce), kt(!1), $((Ce) => !Ce);
                      }, 100);
                    },
                    style: { cursor: "pointer" },
                    children: [
                      /* @__PURE__ */ h(
                        "img",
                        {
                          src: c || dP,
                          alt: "",
                          className: "q-helphub-chat-sender-profile",
                          style: {
                            opacity: (ie == null ? void 0 : ie.isClosed) == !0 ? 0.5 : 1
                          }
                        }
                      ),
                      /* @__PURE__ */ k(
                        "div",
                        {
                          className: "q-helphub-chat-message",
                          style: {
                            opacity: (ie == null ? void 0 : ie.isClosed) == !0 ? 0.5 : 1
                          },
                          children: [
                            /* @__PURE__ */ h(
                              "div",
                              {
                                className: "q-helphub-chat-sender-name",
                                style: {
                                  color: (I == null ? void 0 : I.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                  ...(Ee = (Ne = r == null ? void 0 : r.Chat) == null ? void 0 : Ne.Card) == null ? void 0 : Ee.Heading
                                },
                                children: (ie == null ? void 0 : ie.title) || l || "Chat with AI"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                className: "q-helphub-chat-sender-message",
                                style: {
                                  color: (I == null ? void 0 : I.secondaryColor) || (P == null ? void 0 : P.primaryColor),
                                  ...(Ft = (et = r == null ? void 0 : r.Chat) == null ? void 0 : et.Card) == null ? void 0 : Ft.SubHeading
                                },
                                children: ((ur = Pc((je = ie == null ? void 0 : ie.conversations) == null ? void 0 : je.content)) == null ? void 0 : ur.closeChatTag) == "CLOSE_CHAT" ? Pc(
                                  (Me = ie == null ? void 0 : ie.conversations) == null ? void 0 : Me.content
                                ).regularString || "Chat Closdde" : (De = ie == null ? void 0 : ie.conversations) == null ? void 0 : De.content
                              }
                            )
                          ]
                        }
                      ),
                      (ie == null ? void 0 : ie.isClosed) == !0 && /* @__PURE__ */ h(
                        "p",
                        {
                          className: "q-helphub-closed-chat",
                          style: {
                            display: "flex",
                            alignItems: "center"
                          },
                          children: "CLOSED"
                        }
                      ),
                      /* @__PURE__ */ h(
                        "button",
                        {
                          className: "q-helphub-chat-btn",
                          children: /* @__PURE__ */ h("img", { src: l1, alt: "" })
                        }
                      )
                    ]
                  },
                  _e
                );
              }) : /* @__PURE__ */ k(
                "div",
                {
                  className: "q-helphub-chat-detail",
                  onClick: () => {
                    Qt(!0), $((ie) => !ie), setTimeout(() => {
                      F((ie) => !ie), a && a((ie) => !ie), kt(!1), $((ie) => !ie);
                    }, 100);
                  },
                  style: { cursor: "pointer" },
                  children: [
                    /* @__PURE__ */ h(
                      "img",
                      {
                        src: c || dP,
                        alt: "",
                        className: "q-helphub-chat-sender-profile",
                        style: { opacity: 1 }
                      }
                    ),
                    /* @__PURE__ */ k(
                      "div",
                      {
                        className: "q-helphub-chat-message",
                        style: { opacity: 1 },
                        children: [
                          /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q-helphub-chat-sender-name",
                              style: {
                                color: (I == null ? void 0 : I.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                ...(Sn = (In = r == null ? void 0 : r.Chat) == null ? void 0 : In.Card) == null ? void 0 : Sn.Heading
                              },
                              children: "Assistance Request"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              className: "q-helphub-chat-sender-message",
                              style: {
                                color: (I == null ? void 0 : I.primaryColor) || (P == null ? void 0 : P.primaryColor),
                                ...(kn = (Pn = r == null ? void 0 : r.Chat) == null ? void 0 : Pn.Card) == null ? void 0 : kn.SubHeading
                              },
                              children: "Hello there👋, I am Quest's new AI bot, I am here to help you?"
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ h(
                      "button",
                      {
                        className: "q-helphub-chat-btn",
                        style: { opacity: 1 },
                        children: /* @__PURE__ */ h("img", { src: l1, alt: "" })
                      }
                    )
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-helphub-send-message",
                style: {
                  background: P == null ? void 0 : P.backgroundColor,
                  ...(dt = r == null ? void 0 : r.Home) == null ? void 0 : dt.Card
                },
                children: /* @__PURE__ */ k(
                  "div",
                  {
                    onClick: () => {
                      Qt(!0), $((ie) => !ie), setTimeout(() => {
                        Q([]), st(!1), ae(""), F((ie) => !ie), a && a((ie) => !ie), kt(!1), $((ie) => !ie), it(!1), Ye("");
                      }, 100);
                    },
                    style: {
                      background: (S == null ? void 0 : S.buttonColor) || (S == null ? void 0 : S.accentColor) || (I == null ? void 0 : I.primaryButton) || (P == null ? void 0 : P.buttonColor)
                    },
                    children: [
                      /* @__PURE__ */ h(
                        "p",
                        {
                          style: {
                            fontFamily: (I == null ? void 0 : I.fontFamily) || (P == null ? void 0 : P.fontFamily)
                          },
                          children: "Send New Message"
                        }
                      ),
                      /* @__PURE__ */ h("img", { src: sm, alt: "" })
                    ]
                  }
                )
              }
            )
          ] })
        ]
      }
    ),
    H && /* @__PURE__ */ k(
      "div",
      {
        className: `quest-personal-chat-cont ${Er ? "updateOneOut" : "updateOneIn"}`,
        children: [
          /* @__PURE__ */ h("div", { className: "quest-personal-chat-head-cont", children: /* @__PURE__ */ k("div", { className: "quest-head-back-cont", children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "quest-back-btn",
                style: { cursor: "pointer" },
                onClick: () => {
                  oe(!1), Q([]), ue(!1), ve(!1), Se(""), be(!1), $((ie) => !ie), kt((ie) => !ie), St(!0), setTimeout(() => {
                    a && a(!0), Qt(!1), F(!1);
                  }, 250);
                },
                children: /* @__PURE__ */ h(Nn, { type: "BackButton" })
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "quest-labs-chat",
                style: {
                  fontFamily: (I == null ? void 0 : I.fontFamily) || (P == null ? void 0 : P.fontFamily),
                  color: (I == null ? void 0 : I.primaryColor) || (P == null ? void 0 : P.primaryColor)
                },
                children: qe || l
              }
            )
          ] }) }),
          /* @__PURE__ */ k(
            "div",
            {
              className: "quest-chat-personal-conversion-cont",
              ref: Y,
              style: {
                position: "relative"
              },
              children: [
                !ce && /* @__PURE__ */ k("div", { className: "q-chat-personal-container-body", children: [
                  /* @__PURE__ */ k("div", { className: "text", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-chat-personal-container-body-title",
                        style: {
                          fontFamily: (I == null ? void 0 : I.fontFamily) || (P == null ? void 0 : P.fontFamily),
                          color: (I == null ? void 0 : I.primaryColor) || (P == null ? void 0 : P.primaryColor)
                        },
                        children: "How can we help?"
                      }
                    ),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-chat-personal-container-body-description",
                        style: {
                          fontFamily: (I == null ? void 0 : I.fontFamily) || (P == null ? void 0 : P.fontFamily),
                          color: (I == null ? void 0 : I.secondaryColor) || (P == null ? void 0 : P.secondaryColor)
                        },
                        children: "Let us help with all your questions"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ k("div", { className: "q-chat-personal-container-body-icons", children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "q-chat-personal-container-body-icons-img1",
                        style: {
                          zIndex: 3
                        },
                        children: /* @__PURE__ */ h("img", { src: c || $l })
                      }
                    ),
                    /* @__PURE__ */ h(
                      "p",
                      {
                        style: {
                          color: S == null ? void 0 : S.accentColor,
                          WebkitTextFillColor: S == null ? void 0 : S.accentColor
                        },
                        children: "AI"
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ k("div", { className: "hepuhub-chat-container", id: "chatContainer", children: [
                  D && D.map((ie, _e) => {
                    var Ee, et, Ft, je, ur;
                    let Ne = JSON.parse(
                      localStorage.getItem("chatSatisfied") || "{}"
                    );
                    return ie.senderRole === "ADMIN" && ((Ee = Pc(ie.content)) == null ? void 0 : Ee.closeChatTag) === "CLOSE_CHAT" && _e < D.length - 1 || _e == D.length - 1 && Ne[te] && Ne[te].isSatisfied && Ne[te].messegeId == ie._id ? null : /* @__PURE__ */ k(
                      "div",
                      {
                        style: {
                          display: "flex",
                          gap: "8px",
                          marginBottom: "12px"
                        },
                        children: [
                          ((ie == null ? void 0 : ie.senderRole) == "ASSISTANT" || (ie == null ? void 0 : ie.senderRole) == "ADMIN") && /* @__PURE__ */ h(
                            Gke,
                            {
                              message: ie,
                              entityImage: c || $l,
                              index: _e,
                              fontSize: ((Ft = (et = r == null ? void 0 : r.Chat) == null ? void 0 : et.Form) == null ? void 0 : Ft.fontSize) || "14px",
                              setOpenCloseChatPopup: x,
                              setIfSatisfied: Ge,
                              selectedConversationId: te,
                              setData: Q,
                              isAdminCloseChat: Pe,
                              isCloseChatAdmin: We,
                              setCloseChatAdmin: Je,
                              QuestThemeData: S,
                              styleConfig: r
                            }
                          ),
                          (ie == null ? void 0 : ie.senderRole) === "USER" && /* @__PURE__ */ h(
                            Rke,
                            {
                              message: ie,
                              index: _e,
                              fontSize: ((ur = (je = r == null ? void 0 : r.Chat) == null ? void 0 : je.Form) == null ? void 0 : ur.fontSize) || "14px",
                              QuestThemeData: S,
                              BrandTheme: I,
                              styleConfig: r
                            }
                          )
                        ]
                      },
                      _e
                    );
                  }),
                  se && /* @__PURE__ */ k("div", { className: "q-helphub-satisfied", children: [
                    /* @__PURE__ */ h("p", { children: "Was your problem resolved by the customer support team?" }),
                    /* @__PURE__ */ k("div", { className: "q-helphub-satisfied-icons", children: [
                      /* @__PURE__ */ h(
                        "img",
                        {
                          src: Mke,
                          alt: "",
                          onClick: () => yt(!0)
                        }
                      ),
                      /* @__PURE__ */ h(
                        "img",
                        {
                          src: Hke,
                          alt: "",
                          onClick: () => yt(!1)
                        }
                      )
                    ] })
                  ] }),
                  fe && /* @__PURE__ */ k("div", { className: "q-helphub-satisfied2", children: [
                    /* @__PURE__ */ h("p", { onClick: () => Ue("option1"), children: "Require more details?" }),
                    /* @__PURE__ */ h("p", { onClick: () => Ue("option2"), children: "Prefer assistance from an admin?" })
                  ] }),
                  He && /* @__PURE__ */ k("div", { style: { display: "flex", gap: "8px" }, children: [
                    /* @__PURE__ */ k("div", { className: "chat-profile-img-receiver", children: [
                      /* @__PURE__ */ h("img", { src: c || $l }),
                      /* @__PURE__ */ h("img", { src: uP, id: "chat-profile-img-receiver-tag" })
                    ] }),
                    /* @__PURE__ */ k("div", { className: "q-helphub-satisfied-user-reply2", children: [
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "message receiver-role",
                          id: "q-helphub-satisfied-user-reply",
                          children: /* @__PURE__ */ h("p", { children: "Are you satisfied, or do you have any other queries? If not, would you like to close the chat?" })
                        }
                      ),
                      /* @__PURE__ */ k("div", { className: "q-helphub-satisfied-close-chat", children: [
                        /* @__PURE__ */ h(
                          "div",
                          {
                            className: "q-helphub-close-chat",
                            onClick: () => x(!0),
                            children: "Close chat"
                          }
                        ),
                        /* @__PURE__ */ h(
                          "div",
                          {
                            className: "q-helphub-close-chat-continue",
                            onClick: () => Ge(!1),
                            children: "Continue chat"
                          }
                        )
                      ] })
                    ] })
                  ] }),
                  lt && !ce && /* @__PURE__ */ k("div", { style: { display: "flex", gap: "8px" }, children: [
                    /* @__PURE__ */ k("div", { className: "chat-profile-img-receiver", children: [
                      /* @__PURE__ */ h("img", { src: c || $l }),
                      /* @__PURE__ */ h("img", { src: uP, id: "chat-profile-img-receiver-tag" })
                    ] }),
                    /* @__PURE__ */ h("div", { className: "q-helphub-satisfied-user-reply2", children: /* @__PURE__ */ h(
                      jke,
                      {
                        handleRating: Be,
                        chatData: w,
                        currentConversationId: te
                      }
                    ) })
                  ] }),
                  Te && /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-helphub-satisfied",
                      id: "q-helphub-satisfied-admin-reply",
                      children: /* @__PURE__ */ h("p", { children: "Please wait, Admin will get back to you soon." })
                    }
                  ),
                  M && /* @__PURE__ */ h(
                    Nke,
                    {
                      handleCloseChat: () => {
                        Ke(!0), ot(), x(!1), Ge(!1), Je(!0);
                      },
                      setOpenCloseChatPopup: x
                    }
                  ),
                  Z && !ge && /* @__PURE__ */ h("div", { className: "q-chat-bubble-sdk", children: /* @__PURE__ */ k("div", { className: "typing", children: [
                    /* @__PURE__ */ h("div", { className: "dot" }),
                    /* @__PURE__ */ h("div", { className: "dot" }),
                    /* @__PURE__ */ h("div", { className: "dot" })
                  ] }) }),
                  R && /* @__PURE__ */ h(
                    "div",
                    {
                      className: "message-failed",
                      style: {
                        position: "absolute"
                      },
                      children: "Something went wrong. PLease try again..."
                    }
                  ),
                  Qe ? /* @__PURE__ */ k("div", { className: "q-helphub-satisfied q-helphub-satisfied-email", children: [
                    /* @__PURE__ */ h("p", { children: "Provide your email ID to receive notifications from the admin." }),
                    /* @__PURE__ */ k("div", { children: [
                      /* @__PURE__ */ h(
                        "input",
                        {
                          type: "text",
                          name: "chatEmail",
                          value: xe,
                          id: "",
                          placeholder: "Enter Email ID",
                          onChange: (ie) => he(ie.target.value)
                        }
                      ),
                      /* @__PURE__ */ h(
                        "button",
                        {
                          style: {
                            background: (S == null ? void 0 : S.buttonColor) || (S == null ? void 0 : S.accentColor) || (I == null ? void 0 : I.primaryButton) || (P == null ? void 0 : P.buttonColor),
                            cursor: "pointer"
                          },
                          onClick: mt,
                          children: "Submit"
                        }
                      )
                    ] })
                  ] }) : /* @__PURE__ */ h(Ze, {})
                ] }),
                D.length == 0 && te.length === 0 && /* @__PURE__ */ h(
                  "div",
                  {
                    className: "home-user-msg-2",
                    style: {
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "flex-end",
                      gap: "8px",
                      margin: "0 20px 0 0",
                      position: "absolute",
                      bottom: "0",
                      right: "0"
                    },
                    children: q.map((ie, _e) => /* @__PURE__ */ h(
                      "p",
                      {
                        style: {
                          background: S == null ? void 0 : S.accentColor,
                          color: I == null ? void 0 : I.contentColor
                        },
                        onClick: () => Ye(ie),
                        children: ie
                      },
                      _e
                    ))
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ h("div", { className: "q-chat-personal-container-footer", children: /* @__PURE__ */ k(
            "div",
            {
              className: `${Pe ? "send-message-chat-btn-disable" : ""}`,
              children: [
                X ? /* @__PURE__ */ k("div", { className: "selected-file-div", children: [
                  /* @__PURE__ */ h("img", { src: Tke, alt: "" }),
                  /* @__PURE__ */ h("p", { children: X })
                ] }) : /* @__PURE__ */ h(
                  "input",
                  {
                    className: `${Pe ? "send-message-chat-btn-disable" : ""} q-chat-personal-container-footer-input`,
                    disabled: Pe,
                    ref: de,
                    onKeyUp: (ie) => {
                      ie.key === "Enter" && Vt();
                    },
                    placeholder: "Ask a question...",
                    value: T,
                    onChange: (ie) => U(ie.target.value)
                  }
                ),
                /* @__PURE__ */ k("div", { className: "q-chat-personal-container-footer-icons", children: [
                  /* @__PURE__ */ k("div", { className: "attach-file", children: [
                    X ? /* @__PURE__ */ h(
                      "img",
                      {
                        src: Fke,
                        style: {
                          cursor: "pointer"
                        },
                        onClick: () => {
                          J(null), ne(""), j.current && j.current.value && (j.current.value = "");
                        }
                      }
                    ) : /* @__PURE__ */ h("label", { htmlFor: "profile-img", children: /* @__PURE__ */ h(
                      "img",
                      {
                        src: Oke,
                        className: `${Pe ? "send-message-aero-dsable" : ""}`
                      }
                    ) }),
                    /* @__PURE__ */ h(
                      "input",
                      {
                        onChange: Mt,
                        id: "profile-img",
                        type: "file",
                        accept: "image/*",
                        ref: j,
                        disabled: Pe,
                        className: `${Pe || Qe ? "send-message-aero-dsable" : ""} hidden`
                      }
                    )
                  ] }),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: `${Pe ? "send-message-aero-dsable" : ""} sent-btn`,
                      onClick: Vt,
                      "aria-disabled": Pe && !Qe,
                      style: {
                        cursor: Pe ? "no-drop" : "pointer",
                        background: (S == null ? void 0 : S.buttonColor) || (S == null ? void 0 : S.accentColor) || (I == null ? void 0 : I.primaryButton)
                      },
                      children: /* @__PURE__ */ h(
                        "img",
                        {
                          src: sm,
                          className: `${Pe ? "send-message-aero-dsable" : ""}`
                        }
                      )
                    }
                  )
                ] })
              ]
            }
          ) })
        ]
      }
    )
  ] });
}, lm = (t) => {
  var m, p, v, C, w, B, y;
  const { faqData: e, contentConfig: r, styleConfig: n, setHelpHub: A, isActive: i, BrandTheme: o, QuestThemeData: s } = t, [a, c] = N(void 0), [l, u] = N(
    []
  ), [f, d] = N(""), { themeConfig: g } = Xe(ct.Context);
  return le(() => {
    let b = e.filter((q) => {
      var E;
      return (E = q == null ? void 0 : q.question) == null ? void 0 : E.toLowerCase().includes(f == null ? void 0 : f.toString().toLowerCase());
    });
    u(b);
  }, [e, f]), /* @__PURE__ */ k(
    "div",
    {
      className: "helpHubHelpCont animatedDissolve",
      style: {
        background: g == null ? void 0 : g.backgroundColor,
        ...(m = n == null ? void 0 : n.Help) == null ? void 0 : m.Form
      },
      children: [
        /* @__PURE__ */ h("div", { className: "q-helphub-help-upper-cont ", children: /* @__PURE__ */ k("div", { className: "q-helphub-help-upper-cont-text", children: [
          /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-helphub-help-upper-cont-text-head",
                style: {
                  color: (o == null ? void 0 : o.primaryColor) || (g == null ? void 0 : g.primaryColor),
                  ...(v = (p = n == null ? void 0 : n.Help) == null ? void 0 : p.Topbar) == null ? void 0 : v.Heading
                },
                children: (r == null ? void 0 : r.heading) || "Help Center"
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-helphub-help-upper-cont-text-para",
                style: {
                  color: (o == null ? void 0 : o.secondaryColor) || (g == null ? void 0 : g.secondaryColor),
                  ...(w = (C = n == null ? void 0 : n.Help) == null ? void 0 : C.Topbar) == null ? void 0 : w.SubHeading
                },
                children: (r == null ? void 0 : r.subHeading) || "Welcome back, Please talk to us to understand"
              }
            )
          ] }),
          /* @__PURE__ */ h("div", { className: "q-helphub-help-upper-cont-text-button", children: /* @__PURE__ */ h("img", { src: a9, alt: "", onClick: () => {
            A(!1), i && i(!1);
          } }) })
        ] }) }),
        /* @__PURE__ */ h("div", { className: "q-helphub-help-lower-cont", children: /* @__PURE__ */ k("div", { className: "q-helphub-help-lower-cont-data", children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-helphub-help-search-cont",
              style: { ...(B = n == null ? void 0 : n.Help) == null ? void 0 : B.Searchbox },
              children: [
                /* @__PURE__ */ h(
                  "input",
                  {
                    className: "q-helphub-search-input",
                    type: "text",
                    placeholder: "Search for FAQs...",
                    onChange: (b) => d(b.target.value),
                    style: {
                      color: (o == null ? void 0 : o.primaryColor) || (g == null ? void 0 : g.primaryColor)
                    }
                  }
                ),
                /* @__PURE__ */ h("img", { src: oj, alt: "" })
              ]
            }
          ),
          /* @__PURE__ */ k("div", { className: "q-helphub-help-faqs-cont", children: [
            /* @__PURE__ */ h("div", { className: "q-helphub-help-total-faqs", children: /* @__PURE__ */ k(
              "div",
              {
                style: {
                  color: (s == null ? void 0 : s.accentColor) || (o == null ? void 0 : o.tertiaryColor) || (g == null ? void 0 : g.secondaryColor),
                  fontFamily: (o == null ? void 0 : o.fontFamily) || (g == null ? void 0 : g.fontFamily),
                  WebkitTextFillColor: (s == null ? void 0 : s.accentColor) || (o == null ? void 0 : o.tertiaryColor) || "transparent",
                  ...(y = n == null ? void 0 : n.Help) == null ? void 0 : y.Form
                },
                children: [
                  l == null ? void 0 : l.length,
                  " FAQs"
                ]
              }
            ) }),
            /* @__PURE__ */ h("div", { className: "q-helphub-help-total-faqs-cont", children: l == null ? void 0 : l.map(
              (b, q) => {
                var E, x, M, O;
                return b.type === "VIEW_ONLY_TEXT" && /* @__PURE__ */ k(
                  "div",
                  {
                    className: "q-helphub-help-single-faq",
                    onClick: () => {
                      c(q === a ? void 0 : q);
                    },
                    children: [
                      /* @__PURE__ */ k(
                        "div",
                        {
                          className: "text",
                          onClick: () => {
                            c(q === a ? void 0 : q);
                          },
                          children: [
                            /* @__PURE__ */ h(
                              "div",
                              {
                                className: "head",
                                style: {
                                  color: (o == null ? void 0 : o.primaryColor) || (g == null ? void 0 : g.primaryColor),
                                  ...(x = (E = n == null ? void 0 : n.Help) == null ? void 0 : E.Card) == null ? void 0 : x.Heading
                                },
                                children: b == null ? void 0 : b.question
                              }
                            ),
                            /* @__PURE__ */ h("div", { className: "but", children: /* @__PURE__ */ h("img", { src: l1, alt: "" }) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: `${a === q ? "ansOpen" : "ansClose"}`,
                          style: {
                            color: (o == null ? void 0 : o.secondaryColor) || (g == null ? void 0 : g.secondaryColor),
                            ...(O = (M = n == null ? void 0 : n.Help) == null ? void 0 : M.Card) == null ? void 0 : O.SubHeading
                          },
                          children: b == null ? void 0 : b.answer
                        }
                      )
                    ]
                  },
                  q
                );
              }
            ) })
          ] })
        ] }) })
      ]
    }
  );
}, zke = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA9AAAAXsCAYAAADOxmEEAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAvSBSURBVHgB7L1t0CRned/bswjxIlaWLKSsFlUky7KFJROgZFSxAkdy5Cq7eIntD174gKHIKeRKjMOnlKtS9mE5kA9O6lTiisEFORUKnErB4hMnEabsKmRY20USYZVsw8rYkWWRCGmRrUhmeRMvz5z+9fa/95pr7u55eXqenVn9f1XzdE9Pv9x9d/c887+vt6oyxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMWbTTKfT5tUy4dW+nxRW57P4eVxnEvcZp4VjlrYr7quwn0lo96TweWkfE51noW2TuCy1ra8tk3Aek4HzmqT9T3o+m+R29Z1bfF+YL12zeN6TvnOv5s95UtpPYb3i9Sz1TejfSTV7HeP59vZNakOxjbkdpfbH9qb7f+7zgf3O3Rel7RY9C4V9zj1HVbh/B/ZV3Db1a2xr97mffz//1fw5+/kf3q+ffz//fv4rP/9hP37+qwvu+TdmMfmLrWoflrBs5gsuPXj5i680Xw18NvhPq5p/sCehHX3/1PKDOUlfGjNtKuwvntfccfN2VfqnmNpVXC/utyp/AU4KfTDJXx5p3d5rlpZVqc1z/Rv7JPVHPKcqrdfX/1WhTd21eMc73nGomv/ynplqndDHQ/04KVy7vvbMfK42Tef/4ffeN1W5f+euTWH74g+r2DdV4f7oOce8vHT9h/qq91nN+/Lz7+ffz7+ff+Hn38+/n38//3m7XX/+zTOX/EWbH7hmnarnZqvSF0k18HClG7D0hdL7GvjSXfSQL/qs2U/7pTvT/nBec+e7qA3sr9CX+Yuzr52xTd0+4vv8ec8+qqFzz/sf+ALNX4hzfVq4/jPHDMfK91hxf31tXvDqiNu116IqtHeS181tzX2YzyFtUxWegb6+m9l3X9+X7rV4b5Ve8Xj5x0Tf+gPXJG9Tldro59/Pv59/P/95PT//fv7Tsfz8F/bt53/4tcXPf2Tmmqf7y1yATPL89NyoSryRqkVfaj1fAFVVfii7B2JgWdeGws1dOl5VLXhgwujlXFsL51fcX2F56X010Ka+/Rb/cQz9cxnafmDd3vb39X/Vf31nlvXcF1U1cM/kazvU94vOvbSv+GU38E9h6T5d8tU3mj/TJ/nzKt2nhf1UVfm6zbW19ONqmX9ePdc+j+ov6qcqTv38D65fbKuf/8Xnt8y+/PxXC++pwjpVvoZ+/ovXoO99NdCmvv36+a/8/FeVn/8dfP6rwvtFy80uM50dFZkseFV979svqfi+6ntA05dZtcSx5tqZHsa+9lelY+eHJLZhwWjssq9q0bZD/1Dy+cV9DfRX3z/O2DfF8xzqr6rnS2KZdudzTcdYdKxim5b58q8W9FN+9XyhLrwm8Vzie82Hf+alazJ3jtOBkfuBNldpf9XQcUr3f7VkP1UD16b0/C/qx+ocg/tWu+P6fv4H+7Wvb4rnOdRfhc+Xbnc+13SMRccqtsnP/1ybq7S/aug4fv79/OfzHOqvwudLtzufazrGomMV2+Tnf67NVdpfNXQcP//zz8i0EJ6Q21fo58HzKvSr2VXiTVZ60Kv5m2boBpxbNrCvpW/knldV+qIfcmHSfN9IGctXcYHK+16mPdXiB2zlYy965X8CuR/i8r7zWNSfy26X1y1dk2XOtW/93A69z+e+3/7vO94y/d/Xj4vOa6hPh/az6NxL+8v9ka/fgn0cWqa9q/Rz4eXnf8m+8vPv53+Z8/Hz7+ffz/9qfeznv7iPnXz+aTevvuuUj5/7tmdgonScmX2Ez2coLbtQuGBODNE7qelZrinKeKJlQ+tx0QfWaT6M24D2z6rV7I3FQ1K9853vnNbT5j3z2m9exvs4r880H9HyPM3b3HzzzZNTp05NS/sqtWVovdwOlp84ceKQ9j/U3j762r3K9rFt+ZxK+8z9vczx+45TOm7Yd3P9h8551c+GzrVvH4v6te/6Dh13Ud8t0+9Dx1z2XJa5Z5Y4/5nntO8YQ89i1T7/Q89qWLfBz7+f/1U/GzrXvn34+ffzX9qXn38//6X9LnNcP/9z57UVzz/nUp3VIVXeZyTqosLywurTbqE+Z+Hx48cPpf13+0y6qbqQuCDOJohnXcDJ2cXzojoJ5byf0o0Q1+0V4D036KR9ILVO98GyD0ik9EUV/3npn2Tfl9aiZYu+OErt6TsH2nLs2LG9oX/U8Z/6ftrU9w88tm3R/vqOv4hVvsgXHXtov0PnlLeJ94HWX/TPL06HjrEqy55z6d7N/9D69l86x3XOI95Hyz5DfftZ5vrG9vn5X79Nfv5nt/Hz7+ffz7+ffz//z9znvzqn7fpEsz6bLFpeeB+FN0yy4bFt217eT9ROSYzPtXMXGOUhOWBKN0bpPKY9n82MjDQrzI/ANMI3Er/8ofTAxmV5X+8sjEL2PRBDD26pHUNt7NtPXrbOP5Shf1KxDfm95of+4cfPqyVY5wtpmX32/fMe+qJddf/VipTum6F184+L/Rxv6PjLtIVpaV/ZQqL11u3rRT+gSsuWaX/fj40lnls//5Wf/9L+qxXx879cm/Ox+tro59/Pf98+/fz7+e9bb1ee/77nb6j9+Rxb+DxbmbX83MJgaZazbjsfDZrRy3cnxTMcqnYPOns6nU/gcPbD+UD4OUGr9bh4up66edrtiyOZ8RW26ebbh2SSXroZm4coov3w5bHsF0NcL28T21Xa37LLFn3+wAMPDB7np3/6pw/l9pT2pS/M/E9V/VQaUV7Uzr4vziHydcn7LO170T/+cC7TvmOu8M+g2K6WhT9uakvAzD+mZY8Tj6dzysdf9RziPxS1P/yQmjmm+qhgpVh4PN2bC/qug3u69A+n9M8n3d8zz3/pWH7+/fyXjjn286/rktvq5392eWl9P/+Ljyf8/Pv5L80vs28///Ofb/r51/vS+n3HTfd+d57VWYNgN1+VLdPd5+3sJL4J20pYT3Y1TnoXBbQuxrkF8/MzoybTVAicG0BuBnGf7fYzN0X7YHQb5y/Fd4RRJT0kPIz6MosPZv3gzXx5xAcqf8FEhm78wpdJ3/JmGa/4ZZjbqPXU/jwPN91007R0jPh5bF/8ZxG/5PU+7ocvS/op9yPb53XzcWO/5DbnY8X50vFyG9v18vMySf+0unNg+tGPfnRuGx3jHbPu/DOfFb5o586Ba6j9lPok9r+2j8tK58l6ebnWDaPDc/2k+ynfp+kfYtdfLFefMw0/pJp1wz+omeuoe0Dr9V2vfNx8L8Rns9RuHUfzsb841/q6+vmv/PxXW/b867qoL7RvP/9+/rXMz7+ffz//z+jnf5qf/3yM1K5pOMeFAzEhJ9QkbDOtktdvu+6kncpi3Zd5fGvZ+kYGn/nJ7OJzFymHOVcpTrkv7jmOELWLuofznUu6i+QHWF9ipQebBy8+0KyrLxG957M4jceJy/XFyHvtV+vpAdd+F8H6y66bieeQzy+3o3QcnVPf+1XaEY+bjxPb0ne+fceO6y/bV/kaxv32tW9ov7ltWr/UNk3j/aM2lLZr98+X/rR0LL3P17ev3aV+XOa6sk77D2pm/Twff/jk/l3m+uT7Mj9Py+yn73z8/Pv5j/valuc/942ffz//sV1+/v38+/l/5jz/cd/Lap0S70xu4OnjmTxUpeTLWaNVO+bOvVanHTBdG4PTvEY0ionCRBpVmeZlq5DjcXQD64GHZb8Y1/2HFb/ktI+/+qu/mnzqU5/a69tf37H6vkiXoe+c6v44pPatsh+dV9+Dv+ifxR133HHoyiuvnJbaMVb/t9d44T/SoS+vVf4Rj3GPnE9KP1jy+evzoX3Ez/N+Fu1DfTFGn+R95Hu31N5Vlq3aBj//fv5L+Pk/h59/P/9+/s8Pfv7L59C3bNU27Of5jwK8TzxnAR9554I48qqHgnBudFzYrjNkVufcu6ttzty9rS7cGrFQz501Nwffek0lqBW7LBeBeDHfWQjCz1NRcl96oHVh0TyfnThxYtKO9nTblm7i/IWR19NyHo5qAe88m9VuBv3jWJfcvtjOOJ+3UXv7vsTi57zy+qVteF/qm9I/+jivPuDLhGnpyzIePx+j7zxT2/L7SanPdA6lfgwjjZM8+ls6Zl+7cpvj+3zuQ+vmY+TzyccvtXPoHildX+2H+XecrU3YS98/2zjtuw6gvsj/+ErT/Hmez/2qtsflfv7P4effz7+ffz//fv79/Mdl2o+f/9ljHOTz/0BwL//p1l1eWkfTaOnP270jxMRnw+Q7BuKwJZqDIM7nPKlS+d/JNqvnarst0JNWDU9SXeZmWbuO5uPnM+J5kcU5jJx0MQx9X+JD+8lfzMBDwf758m1HitjXdNFoUWlfyx5z1TbH9YaOu+xnHz0b99Ocb+nhzl9Yq/T10D/r+EUWRrR5O9juOHqdz6XvHJf9jOV9o/LhWlftOZV2nUcdu+Wsv8x9su41LR1/P+jaDfUHn+m5jeene6pdL84PWibqt5O+fg3H1bGKfernf/hY+TM//7PL/fyfOxZTP/9+/uN7P/9+/vW5n//deP6zZfqdCzKxRyOlMnTH0NyC+/Ykr7+tPKvaLprOrDtcirmZr9qRiZMnT1ZVKjelqZIM1F+IE11EzbMdL97Hg70zJLeoP2uWXXXVVd3NxChL/f7Qww8/3Cy/5JJLqvYzRmNw324ejK997WuTV7ziFc1ylon6s+79xz/+8eYBZRQnrhNpLdzN+aT9TNg+Lmu/TCdql9rBvBJM8Bnb5bZrPzo3nQtTRqRodz5mbDef6Zg6XphvvjjqtjT/wHRs9RkPIevrFc9Pn2lf+dxp73XXXdedpz7/4Ac/iHdApRfXmuNyTdgmHj/2BefEOvGa6gtbfSLUVvVfnOp65e3oS9qi40XUrva8JqV12ms6Dds07dX+FT6g9/S7rh19VPdb9w8o3zu817UuEa5xFa9H3JeWx2WlvmO9tt2TeLy4Lv3BufKe55Rrrn7VPRWfp3hN4n2k57C9l7pjxOc1nov+wcZnIp6Tn38///Ee8/Pv59/Pv59/P/9+/p9hz/9MP9eDTk17mXK94ryuM9qL97xa7dbpuaDrlLRMxtCzSrrWgcePH58WMndvlZreVmk/0y5Ebt2ZezEAvZpPFtZYopexPj+wRIKDPIIl9yDBaFIcWeJY3CSMZnKTSqzzmeb5TPvR8vh5XpaPEQcA4r7ifD6mPo/nkD8vbZfPo2/f8RgaIV107n3kdXJ/ad99behjUZvzOavP+9aD7//+7588+eSTe33tFbfffnvzDz22f6CpM+uz7lC/sS7oy6l0f/W1LV8bLS9d83z/DNHXXi1XP0Dp/Er3DOepL+O8Xrw2+RjL3iParu9+K23j53++D/38+/n38+/n38//Ofz8zy73879bz3+24PdZqaPLdykR8zsLdabzPvqSPZ/7eLaOdLUFLP0ldBBEN+zyx+c+L2Xnzheu5E7wQMqyl7IPTto4g17hXIIv0z//8z9f6YLmmzjug3mmq+6zb7tS+9Zp8xjbrrL9Kv8oV/2nOtSmdc+P7d7//vfvlb48qwVtXuWY++3//UK777rrrkOlNozRNu0j7mud6zu0jT7L172+fiyvVsHP/2a29/O/uK3nAz//5fauso2ffz//fv7L+Pk//89/HKDgfRTTGmz4aI/r/DtCaS9Y5NYdmCrvVSuk55JGh+lWcN6TiIVEYVk8T0XVdhwG6Orcyt16XDBllGNBsELHEY+Z48q1JV5IhPRPn01MUMXRnVIsT4YbUjdw3/s45Quob1/33Xdf1bdd3Gd+X3pIhpbndmo+tz2vGx/0VdpX2ufQefZ9+ZX2E/8Rldrcd5y+8yutV+qf+J7tYjvyF2Se72tz3/kuOo9F/Rs/P3PmTPEc+vYd9xPv3dK9UrqHFs3Hqe6veN/qmH3HK70fun/0WTxGe/0G99mHn38//37+5/up1DY//37+S/vOUz///W328z/fP/m9n//Vn395Nah/Phpi9NFE0cIfLdE5djvV4u7W6/MObt83GhCdF5KOgWYaj+NtqhG9DQ2hDVHszgjfIYYShMWYlY8WkhGIksuKiA+z3jONX7BxPhNH0fIX86J9XH311ZOPfexj01tuuaV5z0N1+PDh6bLt6GsX+yWe4fLLL5/mtjLli5XjLDq/0vKhZbRf5zLUZzpX1tX0ySefnDz00ENdXyxqi95zridPntyLfVY6Th75W+Z8ho67qH3AOeVrsMq5xfbn84nHuOmmm6rHHnus9zj00dDnQ8T+y20q3fP6XPfXoudi6LjxHu07L6acW76fIkPHi30Tt132Xvbz7+e/b7mffz//fv7L+PlffG6x/fl84jH8/Pv5z/vte/5L7vdDLvl5Wcm9WxZpJWmGvtJZioXOYbrtx3l+K9iKJGKMKGQLcYuSijVvlBiMV04MFmMkWJ8vDoLnY2B8Dswn6J6kFIyoMI0HzuIZrrjiimadH/zBHzz0la98pVn2xBNPdMv5wnre857Xrf/www/zfnLNNdc0D8A3v/lNHsjq6NGjzWdM437bL3weem7o7p8H+2Rd1tO62r/2d6iG9Vj/G9/4RndMPmO//+t//a/J9ddf3zyU9bT7TFPtm/3V2x5iH+wvHo91OR/tP8O6OgfW43j0sdqvc1G71Xa1WX2nftGxeNi1TO2NbXrJS15CPFJzres+m3zuc59r9l1/4TTHot/j8QX71znG89Q5sF8t07bxWj3nOc+Za0d8n69v/IxrkMnt472uY2wrn3Fvcp20PuvGfdK+NtFDpXXYj/pdfV/30UT3cmx3bEu+Plr29/7e32u2jecXz5l1Lrnkkrk+/9KXvtRcJ90b8fnhs9g+tUn3Ai/OM977ub/bfzbduXEspvG+ERy7dE9xvP/+3/97d9/Fz7U/iM+xn38///G9n38//37+/fz7+ffzv63PP/cR+6w1DaJ48oUvfKHRPixD23CNYn/xGesSCpsT32G0JAz2ve9971TztQar2uRiXdKxVrtxrjNu7LxnGrRg1H9bJ55hUm0Jrbt7X5xzw6KSVDER2EcL6ez7Au2VuEH0jSLqszi6ww2rdTSqo2WIeL7AGD3l5tV6Q+81H5ex33gcLYsjYfFzto3r5v3kfctlJB83fh6XlcjblfpDo8h9+4uf68ujWkA8J20bz7l0Pvma5b7TsXN/lfrtta99rTInzvRXbv/Q9Sz1XWm9Un/F8yz1WTyH22677dDTTz+9F88pHqOvHaXjxvPWKPcy98nQeSxzD5Uo9VPcJ+9L12PoGpXayFT77Ovr2FY//37+S/3j5798Hn7+/fz7+Z8/t6oHP/+z59i3T977+e9//vu0DcTPaiHe7TfqJVDCs0xM0FyyRkd64qLndGCh7NV5Y+WbfWzOhjjPFHtu3radNOPOXQhEr9pEYF0GuCCaOx/9RYnAEND1F8DcOiWXj/w5N+KpU6ea99HCzTLeaxqXZVhejx5N477i/urRrskLXvCCad/2pX0PrTtEbq/akdug933b63MeVtLla91Su/I6cOTIkck999wzzW2Ba6+9du7Ysa2r9FP8Mlm2D0t9pGOXiH0RvzhXvUasf+edd05Onz699BfHsn2R53U/LrOfRceL98rQfuI/Ka0LQ+3XvZCvf27/Imgj03hfLTrn+Izndvr59/Mv/Pz7+R/an59/P//L4Od//lh+/sttXeXeiu7c2VUd4oASglp6CUHdJ6RLicYgJG+O1ua5DN2xmlKzwmw96ElYXJ3POtEXVeeRlJZ8JkU58xRW12d0ZsF3fsooj4S0FrYF2fdKMc8Rjbi88Y1vvLx+EP9BfciXPutZz7qWaf3xd9WvyypjjDHGGGOMeebxhVqv8fqj73znO3/81FNP/d573vOeh/kghrvi1YtIVjK2eoqG64R0jpFuLdEz4jl8zPLmfa64pM9liZYHc3XAnE8LdHPswkhDN6LQV4oqksVzpJQgTO4J//Sf/tPL6hGfn6+PdXv9+j8qY4wxxhhjjDG91FrtT7797W//yte//vXfq/XUF3LOKAhlsGLJq86wKUu0yNWTWmWcl81UYWqnk+o8uHQfuIAOIwU64ZkhhLx+FNhRUONXH/3r5TIQty25br/vfe+77IYbbvgnhw4d+vnKFmZjjDHGGGOMWZm9vb0PPfHEE+86duzYw9EivUwJYMVGk3is3l5x0nNu3NV8Pei87MA5HxboSVvbOdrfq/b9zIqyPPcU4p5ZF1eBGMgu8RwD43/t137tlyycjTHGGGOMMWYcaov0u37u537uXUo4Rqy0SmTJI7hPVKPdTp061X0WRbSmpYRimj0fsdAHdkQVv44ZtuP7TEkwnzhxIgajd24Bsj5ni7Pctf/lv/yX1x4+fPj/q4/1dypjjDHGGGOMMWPy8N/8zd/86L/6V//qCxLQeYVo7IyJxZRUjD85sVjcvuTGHZyYD8wafag6AHRiMci7fa/Pm4k+i5bnsKwZncDEz0u74U8Wz7G4+Hvf+96fufTSSz9j8WyMMcYYY4wxG+G67/qu7/rDf/bP/tlPlD5EPDMNmq2Z4sKNzkP/ZQ2YDarJ8CrjLOvOxEtvmoO0eedj9Z5oyfqsumE5aRiWaCglC3vPe97zSxdddNEvVcYYY4wxxhhjNo5cupkfSjIWyYnFMsGwukxysY1y3mKgc8IwTv748eNz7WFUAsuzkoWJ7LYdA9fPnDkz+W//7b/9X7V4/sXKGGOMMcYYY8yBsbe3964777zz/2Y+6rTkxl1Fl24MpkoUrf3EXFgS0UE0N2I61YveOActoHPmNDGNNZ8zMWGYrM+lDNty3f43/+bf/IOLL774NypjjDHGGGOMMQfOt771rf/zbW9726/rfbRGS0hLRMeSV5BF9IJDKdHYgYjpA4mBbpmEjGlxvnnPHzpHHYRoZgSClwpwR/EsP/oMCcNq8fz/VsYYY4wxxhhjzgvPfvaz/593v/vd15Y+I/wWTZfDcBHSmu+LhQa0ZFg+mRygCfogBPSkmrU8N1POMZz45Pjx43MdFDsQ6OR6NKL5/K677pppO9bnJ598cnLppZd+onKZKmOMMcYYY4w5n1x25ZVXznkF14bQKhpD0XcylOLGLetzEs5zCcXQj9Eoq0rJ1YbZ9AHm4pw52VTTK4vr5vNFMc90ukYsJJ7/w3/4D7/kuGdjjDHGGGOM2Q5IKvZ3/+7ffdfhw4d7XbHbmtEzFZhS/PPM8rDpNJVL3ngisY0K6Fz7OSzvW8bCrqMQ0fKHVxFura9gdMU9v/vd776u7vg/r4wxxhhjjDHGbAtPPfjgg9//1re+9UmSPbMgi+mcmVtJxSIhL1YxmVj8bJNs0oV7Ems9g0zseXQAwQyqAab451Y0Hyr5xwPi+b777qt41Z1uy7MxxhhjjDHGbBeXXXfddT8vw+ctt9zSJX8W6D5Es6zQGFDlkVxKItbqR81L0x5IPehNCujpNGcKO1founmbph0nTpxolpGRTaMRuGzLVz52OBfgd3/3dwlOf1NljDHGGGOMMWaruOiii37+537u5y5Hu5Voy1lNYibu4NI9CSWslHA6JxuLdaI3ykXVBilkQ2tctOOC4Mc+kct2vWx60003NVZorM8SzLGGmCD2+ZJLLrm9MsYYY4wxxhizjVxW67u33Xfffe+SiI7ars1zNVW1JdWHhtaVuxganDgQN+6NCugqWJvlo362NFd34pMYHK71JaSZrztvWndsFUU0U9y2tU29v39SGWOMMcYYY4zZSp71rGfdfv3117+7NoBWDz300BQhffvtM3bQzgu5zcyNLpypCV0FkYy+PH78eFPNqRALvTE2foDSMWL2bQWHx6zbyritxGExYRjCWaMWWJ/f8573XOvkYcYYY4wxxhiz3fzJn/zJ33r3u9/9FPOXX355I4yzh3FOKAZJRFcF0RwrPG3UAr3RJGL8SWHQM9nSYmY1dQqiGbN9TBwWO/W1r31tZ4E+deoUGdzsvm2MMcYYY4wxW05tEH2d5jGGBq/iBsQz1ue4TDoxxj1jeW5nJZgnwc15o0biUQV0FsvQJg7rVgnZ0oonhqmeFyJaac5BVujHHnus2V9t/m8+e/azn/3SyhhjjDHGGGPMVnPRRRcVtZvCdDGi5qzboQb0ImEck4ltjFEFtGKcq2BGb5nJvB0KYk+j63ZMXY71uR6RaOYlpNWxjFYwvfnmm6tDhw79ncoYY4wxxhhjzFZT68VrNY8Ldy5pVRtRGx2IkFZpK5aHGtBV+77Rmq3enLTz0qEbZXQXbizOOpGYLCyuk0cVENES0qQup7Og7rxOPGPelyu3/OXbg1xbGWOMMcYYY4zZamrj50sJw4Xovs08uq8W1J1uREijDWNpK6E60NKb7fzGrc8wuoDOWbarJJ45WVmgmeLTLr92Oif6vDMCcfjw4Snu2oxOXHnllYfoXHX2V77yFda1gDbGGGOMMcaYLafWid+FFzGg7+RZLOSBTDgvUxlWSyJaFmh5PbfTaf58bDZhgY5v5Yce3bmLFugw33zWpjSfIqLrjttT5yKmeR05cuQgMogbY4wxxhhjjBmHy1ojaCOeKWcVP5QFWsmkVQ9artyRqDtDBu6JdGefN/R+GVtAd7HPcuPmVVuam+PoZGSBrkcfehOJIbLpODqRlzpXHf7ggw9WxhhjjDHGGGN2k9tuu+1QtELjfax5VWZCPGOBxuiqWOjjx49LNCt2+Kz5+VzFp0l1LqR4VDP0qGpc7tsynwdf7mkb1N0Q0o43RAu0oLM0H+s/08ES0fDxj3/8G5UxxhhjjDHGmK3n1a9+9XOZvuAFL5ii6x5//PE93qP10HxRREOsC03oL4ZWDLLUgtbyIKAnBY/oUWtDj56FW9PU8qXFM8KZVyxhRUfiti3xfMMNNzTL/9bf+lt24zbGGGOMMcaYHQNdh4hmXobSLJ6xQisOWm7ctTW60bCtrjxrYq6FcyuecymrUcUzjCmgo5jNjezeK/5Z5vfoz45wVsA4naeU5nSoMm8zQnHPPfccSIY1Y4wxxhhjjDHjI/EsQyl6T/oPYyrzbSbubhtpSDRla4Eu6cLOC7r5k5KN7ZexLLi9+8kNlQVapnctxxItt206i5JVct2mU+M+7MJtjDHGGGOMMbvHj/zIjzwPo+i1117bWaBBBlOF7qqEMQZWiWhVb8ogppPrNiiMeKow48I6KzOWBVrqvpQdbeZkZIGWeGYUQW7c0b89E0XzF77whWY9u3AbY4wxxhhjzO7wvOc9b4p4Zp6a0KoLjRWaF+JZyApd2g8JqUN1p0mwMssyHd23J2OI52ZH1UiQaTucQNNgqXymOfY5gogmsxoW6LZ8VfXYY491pnxZoaOIhq9//euTT37yk1+vjDHGGGOMMcZsPSQRwxBKyK4qK8kSLSs0XH311dOTJ0828zK0Rgs0AroW31Np0KA9lUlMIroKn+/bj3u0GOi64XvhLaWrmiDuReIZ6nVn3iOe6bBaUDf7lAu3OpYO53XddddVxhhjjDHGGGN2A3kRx6TRQNniWNLq6NGjjXFVBlZoS1k1mhDxzBTd2WrPqp1qHzP7H0M8z+10jH1Fq3MroM8W4mpPqLShXLjrEYWZzxHSMQY6WqBf/OIXUzNs+oEPfMAWaGOMMcYYY4zZAd7ylrc8T/PKuo0lWsZShLTcuDGqMq314lT1oPvioJM3NMRkYqNl4x7FAh18zWdKWcXazzk8WrHPJfGMcMZcnxOIUb5KL8TzV7/6VcdAG2OMMcYYY8yO8PDDD1dZx0UX7hgDDYhnpohnRLQ0pDJyA+7cMtaqpFXYRWfoHSMT9ygCuhXNvWIWF+7oxs3J4ratElZtR3RnowzcufOEfOWNMcYYY4wxxuwOhOFecskl0y996UuN/jt9+vScqlUGbsheyiKGAcudG1IS6xgfPYrxdUwL9Mw8IwCxuHXehFEDRhF4o6lENH7ufeIZ8Jtn5OKv/uqvxinmZYwxxhhjjDFm42Tr85EjR7r3eCCDyhpHIytINwosz3n/8o5up5NQvmq6TWWsGkom8VpEV22R64bgmz5HHF2g83jFTGxxdIKRiyuvvNIu3MYYY4wxxhizI2AExfpcKklM+K4SiSGi+6zPImbhFq2luYt/bvNyzWTk3g9junA3il4JxOKJYImO9Z9LycQoYaV5YqCZvva1r+0dnTDGGGOMMcYYs1tgCFUZKzJxYySVziOBmAyoWKCVG2tISEtbRv0ZrM6NmB6rBrR2OCaTwvtpFsxKHAbKpiYBzUhD3qlGIdSxdDSjFi94wQsOnThx4muVMcYYY4wxxpitp5SFGz796U83JYxzKK/ioVULGpRLK5dDBoR0qAWd2Zo60DFF+DS4cjfiueS2zUnXr2pZ8UwJK0Ynvvu7v7t5z6jFNddcUxljjDHGGGOM2Q3IZZVB5+G+HV24hTQi2lGgIWM8tGKhpTujdh4j83ZkFAt0MpF3lFy1o/UZ6Ig77rijE9DKwM17Ou/UqVPVtdde220jX/natD955JFHKlugjTHGGGOMMZsCrbO3t9fNbwMSiIcOHarGdE8+CI4dO/Z84qBx5QY8iylTrFrQMQeWiFm5P/WpTzUXoy1rtVdy4a7a2s9Bp3bJxfbbX2PGQM8I5mx5jnW6RBTPAvdsphp5qEcTmuU5yBzxbIwxxhhjjDGbQML5O9/5zmg1hMdC7aFtEve7QtRxSiYWyxSjA3kpIzdgYK2F8xQ3blmf8WjO+jMc5lwdq3MXbnuycOsCtoJ5GktZaZ3sn97GPs/tK/q8E/OMBRro3K9//evN/pT6XO+NMcYYY4wxZix2SZxK5O8KhOGqmlIpE7fIsdAYXmPiaelL3LdluM3lldsk15M2Jroag9Es0G2QNqMAh5jVSQyVrQJGERhNYD6a5oFAclmg4XnPe17zOYW36fijR49WxhhjjDHGGDMm22RtXoboZr4L4MLNVIZRCWnyXpXWLyUSE5SykuE2umujm7XOmGm4R6sDHazQM1euFAcNuQh2CYLIYyfSscQ+09GY/h999NHKGGOMMcYYY8Zi18SooM27IvyffvrpRtNJSONtzPQLX/hCMy3FQUNMJEaIcAwTxnCbhHRj4K1GZjQBrRrQVetvrovHieildZV2XMQkYkxj5jV1orj//vt3azjIGGOMMcYYszPsongWuyKgVU1JicQAYynex4Tw5kzcgNdyDAHGhVtu3BLPCiluV5luoj/GjCGWwu/NxI1/ehw1EPiyxxJWsXSVlkX/eGXgZvq+973vq5UxxhhjjDHGjICShu0iGDSf9axnVdvMbbfd9vwrrrhiEsNzZYEmCzfTbIGWC7dENAbZEydONPoQF+64boyHTuWs5kpcrcNF1TjMtQLhjGA+duxYl1q8PblBv3aENB1G1rXrr7+++QwhrU5tE4f17scYY4wxxhhj1mVXxTPsQtuxPtcG1L0XvvCFzXtl4r733nv3KF+MiMagKk0Yk4m1nsvNSfYJZ3Eud9hZB+mtSiJWBUGvBZxADOhW/eebbrpp5sRKFumYspxM3EzpVF6Y+RVs7hhoY4wxxhhjjNktyMIdE4ghoiWetQ4iGvGcakA38zmfFoZbdGceQEA0S6cipqsRGEtAx8Rm0xj/rIUSzhLSkEtZyY2bjiKBGPOqCSYL9MMPP9yY+Zl3Fm5jjDHGGGOM2T1IIIa2gxiuqzLGcuNGI0onRu0YE4hhuC2UspoEN+5pENP7YjQLdJjvxLSsz0MJxCIaXbj66qtnRgfUoYjoaIE2xhhjjDHGGLM7tCG5jRVaScRkLCV0F0v0Qw891GlGNKJ0YqkOdHivDNyl5GGN6/cYbtyjWaD505ayKgpkiehobmc+doL42Mc+1u0DMz7+8KV92oXbGGOMMcYYY3YHJQ+LRAu0qjApsbSsz6Ua0Lnak6pCyercLu4+H8ONexRLbjCNzyX4ilm4MbNnf3XFQBMQnjNx50La6lhM/fW6jfh3Fm5jjDHGGGPMWHz729+udpmLLhorT/Rm+Nmf/dlLaq03xYUbMR29jWMMNODGHWOgEdHyaI4WaGKg5cYds2+3xt1J6769PRboWP85EsVz+35uW/zYJZ7VORptyB0oMPXT6bZAG2OMMcYYY8zu8NnPfrYRz7hwy51byICKC3cuZXX77bc3UwyyvDDOyvpM5SetF0Uy84p93rYs3KJR+Fk4R3IMNC7cZFNDPMsCTWfRaQSQl0S0gs1L5n9jjDHGGGOMMdsJZawQz4hoLVMMNO7biGgSSsuoCujEkydPNtoRPUmCaoyz6E5EdEl/xipRMRt3tU9Gte+rzlauwQUyq3OiDzzwQLcc8dzW85qDAPK6A+eWt4nEENpOJmbW4syZM9UXv/jF6vOf/3wzz+vw4cPVi170ourGG29spsYYY4wxxqzKn/3ZnzVTflMexHa7ihKIRdB/iOhaO3bLoqcyYH1GT6rKU594Dm7cskRPxnDjHktAT7JZPJ8IZvX6ZA/l0lWRaIVuy1ipSHZ16623HlKRba2PG3e1Q/ziL/5i9Z//83+eWfbZz362WoeXvOQlM+9/4id+onr3u99dbRpE54//+I/PLOO4HH8X+MxnPlO9973vbb6gEM19UCLtjW98Y/X3//7ft5g2xhhjjDFLwW/MT37yk808vzV/6Id+aKnt/vAP/7B5iWeKiMazWHHQskJLPGcX7giashQeLIs0WrlqNaoYKwZ6LAE97VKdtY1sG53N6tOcRAwxXZviB3fOSETrtt1MMfnzJvvMG9MHwp8BjPjFNATx9f/iX/yL5vWP//E/rv7RP/pH1YWELO+CAQMPFBhjjDHGjId+dy4S0Vk8P1NoSxPPiGfAhVthvNHA2oe8n4MBtxPPQTCPIp5hFAEdRHOVa0Dn+QgjB3fcccchsqmpnBWdVL+fi82OGdo4JEK67lgLaLOQX//1X69+7dd+bdDiPAQW6//0n/5T9e/+3b+7YETm29/+9pkycAwQMFBgjDHGGGPWB8sxvzkliBeJ6CyeWe9Ctz5jBFUuq5Ibt7jvvvuqW265ZU7vtR7NnbdyqvqkilCdgbdqk3FvVRKxtnGxvlYxDjrDiUfxDIhnmetJJBZLWWlkoh2taKxmxgyB+MWK3CeeiXt+8Ytf3HxZMe0DsfkP/+E/bCzZxhhjjDHG9MHvyiiY+yzMJfG8rMv3LiPxTBIx6boYppuTSMf4Z8gezeTa4hX1Zy2qo86dtHp1MkYd6LGycEeF37hvD2XijqgONGCej77uxEGrkDbEjsWN22WszBBYjbE8lyBmG4vypz/96eYe/MAHPtBMiUknprtkabaINsYYY4wxy7BIRD9TxXMkZuLGUCrdR/4raHNiVdGFG+Nr3AelrEhUzYv30qDJmDsNsdD7zqE1dhmrmfTgNFyNZ8rIANnSomjuSygGdB7xz8xn33hjhkDkYnnOIIwRzojkV7ziFcVtEde//du/XYx7RkT/0i/9UmWMMcYYY8wQfSLa4vms9ZlpdOFG92F9jhm4hUS0dKRKI8dEYjEGOiYPq1qH6bGSiI0uoIUShymJWL1oopEBRLNOuhbUTR1obYevu6DzNBIRxfMll1zSzLsOtOmjFPMs8dwnnDPEBJcym5PJm5cxxhhjjDFDLLJEPxPFMzHQTz/99FyYLsTwXYELt9y4Vf44CudobdZ8FspjxkCPWge6Sq7cIrpzP/DAAzOfUxC7rw70kSNHZupAY4Vus3FjvncW7jVBWJKFGSstFtXzUf8YAapM0IpD5sX8fuG8crkwQDyvGjePNZo2/vIv/3K3jNJWy7ST7ThP2hPrTCPg93ueuoa5D5cdHNg0atMQ3Hv33nvvTB3ubToHY4wxxpgxkEDOcdDPRPEsrrnmmm4+exrjhSwrtLJwM8XoKu9lPJuz27bmceseYCZ31zqMLaC7UlbS0aGE1QwK/s5JxOof0cqcVp0+fXpam/GbkQh1bG3mbz776le/WpnVQMhhmf3d3/3d3qRaCEZcl/cjpBGNxApHVO9accl98etjHL8U98x+1006Rz1ozglxx/wiYaha00PlCBadZ6neNvHaHJt9//t//++L15BzZL8/+ZM/OdemfE0i9FnuN/b1O7/zO917jpvXiXXMc43tvhrn3AMMcPT1T985GGOMMcaY3afkRdxXB/qhhx7qdCJGV8ofox9x5eYlS/QyCaxbjbo9MdA0qHU2n/Etz+KZGGimcuGOaIThySef7LaJZnxZoJWtzS7cy0MpJwQZwmWonBOfs15f8q11QTAjrogfHkr+xvERelhW16XkXr3fEk2/8iu/0oi6ReIZSzXtX1TLj/NkBI3rsixct7e85S2DJbkUo03N64MCsU+7dN59bdN6tG+of3QOP/ZjP+aEbcYYY4zZeZbNwv1MBeHcl+vqlltumXkfk4hhkM01oPtKKbfCeRTv5dEs0K1oXtgouXDLAh2tzwoOZ7QBEZ1LWCGg20DzJuW5XbiXo2Q5XGYbKCXSWrcNJbfqEsp2jcv1UGmpEnJLj+ASfBAlzxCty54jIDRJdHbppZc2Full9r/slyztwCX/Z37mZ6pNQn8zELCoxjbrcU1XyZwf74MLpf62McYYY55ZlGKetTxOn0mu3KoDTSIxLMp4GA+5cOftyaFVT/aYD/m2GpiXN3S2SiOiz+YRm2yFC7d8yedcuBeBLzvmeCUSkwVa5ayUxvzWW2+ds5ZfCBZoCdVN7r8knhGVvK6++upG/ODWncUZ2/IwjxGTGoWlYl0RtQgrufxGeP/2t7+9+o3f+I2V4oVLAu0gvpD6Bgjoux/5kR9pzqGvn7Fa08ZFIjFa1tkfAhkee+yxoqWW644bNOvyioMIuZ+0TmQZ0YrAXSSe+bwknjke8eS6PtwHn/zkJ2fORdZoRLQxxhhjzC6xKGHYM1VES8NRxork0FE8Kwv3Qw89NKWMVa0Nu+0Q0xhfa4NsozvxaMaFGxFNTPSxY8f2mG+FcrNNm327Up6uMVy4xxLQS5nECejmpDhpThgrNNYrRh5iIjF1GPOkM4+1oHHhprOZvxAs0GO7SkcU8xxBtJBZGuESwVKJQEO0RkHE9mMmdSKGGHfqKNYQSaWazSwn1ncVK3hJSG7aelnqZ475rne9a67v6GeENqJZ/cx0WZHYd/3op5joTPvFFZ42MGAR45lxj46CVtdlVeI+NFjAucfri5t6ySsAt/gs2n/hF35hbtCH+5L7wzHRxhhjjNkVFolnW6LPVVaK8c+yPqMF0YRy4ZYlWi7chAXHTNwkFJM1WrHObYhxl+N6rEzcY8VAd5bnnECM0QCt1Pqp7+WNsT7HUlYZRLR84zVSoQ43/ZTEOaIliy8hURMZs2QTIg2BlEUTllHEW0korxIjDH2JtTZJqZ+HymXhrk0/RJbtZ7YrXT/6ttR/WLw3jcQ558wAAe3TufcNLrBun2cB90L+5/Ff/st/qYwxxhhjdoFlS1UtKnF1oYIRNBpCFaqL0RTdp+UyqIJCfUWu7CRC3POkpdGMqS70vhhLQHf1trKqx5SueVmdmdcUsD7zUoryuD1mfM3TsaQ8J/5Z5axMP1mQRWHTB5/nB3yVuN4+EE2L4nFLwklW1GUZowzWKtC+3D/LZPwurbNI7CJUh2Kl6d98/qvEHK+DxHDf+ZYGBbDMLyJbw1172xhjjDG7ACFpq9R5Lolo9nEhgwt3DMWVBZqQXWk/rM/6PNaBjmCozXHOvA96tPGSloF3DPdtGLWM1TTayFtSJjRGC2a2wY9dpayUhfu+++6bSSQWRyNqMbVHJ9ezjFxUu866bhqLRqcQnSXxhCvsqoxhxeQ8l7EEI/LzufElsmoyscgmRWSfuF+mn+mP2LZF1xT36CEU5xy/dPeTzXwZEMNDgxbENGewSq+TXVvu6MYYY4wxu8CydZ776kRfqCiJGEbR6FWMiKaEMUTrc0TakfnaUDtTLjnWfw66tJu2VuitSSLWuW63LZv0+ZdHKzQZ1IiHjpm4RSxlhXhuRXNXyqruuOpC4AMf+EC1Di95yUsGPy+JRoTwOmIYKyv7248rdJ/beGk9MlNHVhFbZLTOILyWyXK9DiWBikV6Hav9IrG7TCw3Aw0HOWq5SNCWrh3x3utwoY/GGmOMMWb3UZLXPL8IRLSMEqtst4vkRNBy4WaK8TR6IA9x4sSJCbHPet/GRDchwxKjwb472SoLdEgHPlkUmB1dt9sMah3ybWfEQRZofaaOZV5JxFwHup+x6+d++ctf3peAXta1uiQSV7Egl75wNim8FmWgXpWhgYqDKMU1NmP2z6bd0Y0xxhhjxmBdAXyhC+cSGEZrTVeV6kCrKlMM8411oBHPuGznUlZBNM94Ryu5WLVPxoqBVmD2wgZhgW5rdzE/85k6JovnmIUbZOp3Heh+xo4FHlsobgoEeBaaxM7ut/1jD0iY1fE1MMYYY4zZfaThYhbuRdvkJGJCLtxMU+hwE/Ibk4e1Ynrf+nEUC7TM4nl5PAkypSGe2/lmSgkrRPQdd9xR5QRiKmWFCT9mYzPrQ4btdWOJ9yvIl7UeltyYV7W84gZOWafIquWwMtQxBvaB27Is5aV+IanWuqWzdtHKPETuH+6/nOndGGOMMcY88yAGukoG2D73benEGAPdh6zPhY+WKr28iDHrQItio6jVFd23oRXUzbJSZjURa4MBnf3II49U11xzjV24eygJZSx4y8Yij82yccglAb2qeC8JaGoLk4RrnQEEttUAgOJ3VXarz+Xcya7OkmOyuQe5ngedLd0YY4wxxmwHTzzxxJTKStCG5s7EQLMcIU1iadWBFohnDLAYYoFM3DEOOtd6TuHFkza5WLUfRnPhrs4K4d7W4JeOiGZelmgEtU6+BIW06cR77723K4XVjlQQI2DxPADCJYuUZWvpInLGLhlEUq1l3KhLNZVXFaOlUlzw9re/fWU3YNpdapP2X2rbsgnE1s1GvUvkWB7ugWUzwXMP2m3bGGOMMebC4oorrphkN24ZS2+44YbOCo14jmG9IupHxUEzrxJW0+C3neo/j6IfxxTQTQPbV9c4nVAb3D1niY5x0NG3HfftekShygW1gY4m4Pzyyy+3a/cA2eKLdbckBjNkwcZl+cd+7MfWKntVAuGEJXeIaOkVWHjXsRr/83/+z4s1kTmvZUXZr//6r1e/+Iu/OLecfpVw5hhZrCP8luln2vLjP/7jzXSsfl6XTSXo+smf/Mm560DfLLoGfK7+4RpsuhyXMcYYY4w5GFQHOpawUhz0Pffc01mhVdp4yFMZYthw1SYO0zIEdfp834wioJVArC1QXR0/frzZLyb1Qh3omROIIwh0UgQLtMSzOhVzP1ZozP3OyjvMz/zMz8wtQ6QiSEoCBpHLZyp1Rf/isvzLv/zL1RjgVl0STxyXY5RE57pxy8QS/8Iv/MLccs5pkShDAL/lLW+ZK6cFCHrctyP5PdDPfUKRZexf9y/HG7Of14FrHtvKNRkjcRzi+Y1vfOPMMvY7NGhAfyjmHLDo8z1hEW2MMcYYc+Egz2Ksz7JAY0CNFmjoSyCG1iwsbpZRyko23Zihe7/u2zBaEjGlC49+5dEfXcQ60AJfdgLC1UmtkJ62nTI9cuTI5MEHH2z2pY42i5GIzMJMdYpjTDDihOLtWTQhGEtCfF0Qllh2sdpSs5nyWKXj6tj7qd/MtojCkjBXHyDw1Ae0gfX7hCPtIUFYTvSFNRqRWIq71rlyDPZLPxMTvOl+XgRtjq7mtIeBBe4JrguCmvbsJ/GaYD+ED0SBrsEZrg1toU/VP9wPGfp33QR4xhhjjDFme2hzWXXvFf8sz+OYSCzHQcckYngy33TTTd1nMtwinuv5Q5Ssaj2jpVO3R0CDGhNrbeGy3Ra07kA8I6I5KbJxt1m4ZxKJ1Z00wd8dCzSjELV47joWUz8iuu68ad9ohDkHwgNRUorL/eQnP9m8+kBc/ut//a9HyQxNYi9ZthFKQ8eNx94vWIcRhH3WXdqyTLx3n3gWDFSUxJ/OdVE/D+17EzC40HdPCMQ/989+E37p/Eru8wjpRTHjCOeSN4ExxhhjzCaQ2NpFxhCIm0biOcY/95WyilZotGLMwK38WhGsza1hdxoEs5bNZf1eh7FcuCfpfTPN4hlBDYholbISfWJYPvDEPKtjEc/1yMQhu3Avx7vf/e6VLYkSjGNZ/RBiy7ZBgmvMY//O7/zOWqWlaAsinIGeRQL3Ax/4wJy78iJo02/8xm8cePkqrL6LrPuI/2xVXxfOb53yXvQn2xljjDHGHBS7IEL72KW2YxTllSsuYUTNxDJWTBHP0paZnHn77KIJ229PEjEp/PB+JlibkYCSNRqIbWQkgU5BRPPC+kzAePSBJ9Bc2xD/zA/yC61m7iZBBCIiF5WxioJxbJdZ9ouY7xNRHBtRh6Ac+9jcK7/927/d1CBeppSX+oE+Q/gva4XFUorgK2UBz+1ZVphvCg2s9J3bMiJ7FXQNhu6BeGz6kf50yStjjDHGHCS7LKAPHRo1R/SBIUMpbtxoQCHhLGOrLNBRPBP2GxNXx/xcgUlr9N33xR3l7mgbMw3u21195zb7Ni7bk5hALMZCM5Igs3y0RCttuazQQMpzBDRWaKYnTpz4WmVWQrGmvJhXXV5E6xjCNSeBAsRQLPnEOvH4CCo+P0ixRBvUF6B+uPXWW0cRtXhIsG/FVY+9/7HI9wNtu/POOzd+LTie+gg4Lu72B30fGGOMMcZk9vb2mtcugXjeBQF92223Pf8lL3kJRtNpLmMFMqBiUNUydOKnPvWpaUxA3VqhY8WnuXrQMvK2FuhRGCuJmARzM1VCsZwynJPMWbhFTk+uGOhcwuq6667D3N9YoVU/zKwG4gSRsmp95TE538dXG2AZi/Q67IqXxPm6HzRgs6n+N8YYY4xZF4SoSvTuAmivXbE+EwP92c9+dnrjjTfOxEBHEZ0JRtZmHYQ0WhG9iQU6J68+fvy4DLxnN2rjoqtzmnVtRuvl6Vm6hi6qt5UzcYsopFUHWu/pWGKhhV24jTHGGGOMMZvgWc961k6IUtpIW3cJlSZmPmbhjtpP3sjow2xsJQxSIJ6j9RnIxM201aQS0tuTRAyQ9Ch9+ZzHz0piGhfu2iLdLMccz1Qx0LEedPSBByzQwknEjDHGGGOMMZsCcXrRRRc1022KjZbFeVdEfoQyViXwPM7aL6MkYhn0Zqs59XmjS2t9Kg/p7UoiVrWNQvm3cdCTPAoQQTwzVSbuQhmrbt1SFjZjjDHGGGOMOSgkVhHT2/CScN7FhGexBjRW6CHXbYg5skgiFq3PkVZ/dvuib0L/THLlqHUZ1QLdzjYNH4oXwH07unBjgea1TF3nyy+/fEKwOSMXduE2xhhjjDHGmN2DpNDoOmXgZhqTR4vsvk38MwZZBHPMrxW9nqVFQxKx0QYbxhLQ8aRUa6u4oqzPESzQvEr+7TkOmmxtTBm5sAu3McYYY4wxxuwWqqiEBVo5rrBEKwM3KAv3mTNnJjK0yvqMMRbBTJJqrR88oKdtmeWYRKyZVCMwmgs3f6LVWanEdSKq1XXixIkJIjoLaVmgsxWaUQhl4pZ5XwHnsTa0McYYY4wxxpjtB/GM9ZkXOa5UXUkW6IceemiqJGKE98rIGstYZYIF+mzGsBota0tajWKCHqsOdLevkB58LnkYKcazz7oCwUvu26U60Jj2EdC4cmOBvvvuu79aGWOMMcYYY4zZeo4dO/Z8WaCZKkn0vffe22TOViIxWaCjh3KsBY1BttabVSxjFeKgu/BilVjW+2qfjFUHuptPDZwhimdOGNM7geC8rzum+0ximpEHRiNqC3SzXP7xdLQOXRljjDHGGGOM2QnQd08//XQl8SwvY7yOceEmiXTMxo02zBZopjfddFMzn8QzRtzGy/r48eN79etQ684tQ+++GcWFW/Wfq1CsWsRs3NFHHfGMiMYCzSuWsmJKKavrr7++cd+OMdBYnxmtwAJdGWOMMcYYY4zZGRSGK8uzjKSA5/FQKSt5LwfR3H2mUlYKI8aqKy0aYqH3rSFHEdBy25baB7lv99WAZioLNC+Vsrr66qtn6kCDYqABP3mmSiZmjDHGGGOMMWY3oJoSCaGV1wokomMSMWnC6MLdlrFqsm/juo0LdySVUp7Ti2NYoUetuk2DlUisVAdaIwSxhBXEgtiPPfbYFMszL0YgYiembaYuY2WMMcYYY4wxu4PqQMswCnLjPnLkSKMBiX9W8jA8lJVwGt2IlsSzGSt0tEAXkJd0w1bVgUY06zVEHiEA4qIZSYhJxBQwLh94oY5V0HlljDHGGGOMMWYnUViuLND33HNPU8oK6zMvxT+r5DFCWhZo1pe+jNWfEqNrxtEs0CpO3fqXzwRyC40Q5BJWjCRodCHvV3Wg6dToHw+uA22MMcYYY4wxuwcu3Pfff3+jC6kFjeZT/DPeyFigIWvE7M0Min8uLdf8ViURS1m4m0X8ySehEYJ40op9hujfTgZupqoDLesz2PpsjDHGGGOMMbuNEomRWOzWW289FMsX57xYeC0rCzcu3CX37VaLqpQVmbiny3hKr8JoFmg1FjEt4dxjRp8BM/ztt9/evUdEU/+ZUQfct0sx0PKXdwy0McYYY4wxxuweoTRxA3WgsUJLRKMHmcrIqrxZKo1cCg9uDbuTKrhu1yL6rIv0SDHQo9SBBmXijjW2Smb0SOvKPTl58mTzXj7uxECTjZtlcRTCGGOMMcYYY8zuQh1olbISMVRXBlTlxRIYXvFerq3QjfV5IAN3ozGZUXjxgmRjKzGWBbpT+aHG1pwFWsHesYxVyYUbC3S9brOsZIHGX56Ac8dAG2OMMcYYY8zuIPFcCsvFAk0m7rhMMdBy35YFOiPjLZZmuWyn6fbEQE/P0sy27yu5cke1j6963hZfds3TObwYbVAMNNCRTBUHjQu360AbY4wxxhhjzG6BBXro89OnT09lfSYOWkZWCWcJaZGNtkpsLc9oadNWWO/bu3nsJGKyQndZuDGt66SwQGN9bmt3TXI2bjonxkCzTEnEmM9ZuI0xxhhjjDHG7A5YoB955JGZZTKUKgs3ehDxfPjw4a5SU/Rcjkmp+8KGFQ8trdoK630bYUctYxXqQc+cxIkTJ5rjYIGWeK7F9LSUglwdpFEHWZ9BHUuac2OMMcYYY4wxuwUW6CuuuGKixNARjKckkgbKWClHlj7Hezm7cGcLdCnjdqtRt8eFu+Vs/apztaAbOKG6EzoLdDvtGl/yYUc8M+JA56kONMtlgX75y1/eTHPwuTHGGGOMMcaY7eWJJ56YouPIayXDqHQe+a9khQbEc6wDTSZuuXCjLdtkYt3nwV27CsumZOKenPXnrvbLmGWsojW5y8IdSlp1MdDRdTueMJ2jel+4cNN5iGhcuBmpkAU6m/yNMcYYY4wxxmw/11xzzdwy6bxYgQk37iiegUzcTNGTvBQuLCt0dNcWCOf28+kkfrAmo7pwqz31iRzKtaBLdbo4aUpYKZEYIwyY6mPRbI1ARGuzzP2LAtCNMcYYY4wxxmwP0nDUgb7uuutmPovhuwrplQs34jknEAPChdvk1X3m5WnP/FqM6cLdERs/VAuaGOichRvxjIgWcRTCScSMMcYYY4wxZneRYTSLZ8B4SjUmSllhgWZZTCJG+G/rxt3pQsKF2+TVKmPV7a+dZ3lTG3prsnBXbfbtkESsGhgB6LKmkUyMKZ3AVBboSByFAPzknUTMGGOMMcYYYy4sMJ5iof70pz+9hwVaVZr0ORZoDLC5PHI02sZM262HdCOeq7Mu3FtjgVZDpqGRnYjOYlox0PXyPcQznZD920UMIgdGKjRa4SRixhhjjDHGGHNhQT6sUgy0DK9t8jC0YklDapm04mTIK3pVRnXhnqRiW/JFzw0mRpqpLNGY4pVhTSMMmO6ZkkQMK7Tct7E+k7GtMsYYY4wxxhizUyghtDQdCcRiqC4JpJkqBjqi8F/pSLlv5/VUskrT48ePM7tVLtygRnbzUArojmWs6IQYDB4zcQMdyEuZ2bA6O4mYMcYYY4wxxuweZOGOIjpWW6KM1eOPP76HETXHQGewQkPBWDtpDbqTlHV7OkIS7lFjoGV9bibxRPpM5rhyY4ZXLWj5uBMHjdmejrvhhhuazzQqYdFsjDHGGGOMMbuLSllhGMVAKq1HDLTKGUcLNCKaLNzoRoUDq4RV3rdKVlXBqBsqRm1PFm5lO9O0FP9Mseu0WRP/TEY1LdAIAy7cdNw999zTbK9RCbALtzHGGGOMMcbsHjKIIp4Jzy1VWkILXn311V2iaV5oRjyX5b4tC3SmNd6W3LVH0ZCjJREjo1kW0RDqQVcxW1o7ctA7AsDIQ14mES0XbmOMMcYYY4wxuwdGUSWHjsZSURtfi9tFC3QkG3BlcQ7h0KNoyFHLWAXTeEM8idbEPiOiNXqAOT7vUEnElIWbkQledDKdTeHto0ePVsYYY4wxxhhjdgNVUpIFOoMbNyG9pSRiEGtALxE2nPNc75tR9oKYL7UoWJ+bkz9x4sQhxTtHlI5c7tsKGBd0IlMENKMTmP2vvPLKSbvPr1VbzB//8R9Xf/3Xf1296EUvql784hcvXP/ee++tzpw5s/T6v//7v19985vfrL7ne74Hq321H+65555meuutt1aHDx+uzPrUA0DVX/7lX1YvfOELq5e+9KXVrvCnf/qn1aOPPrr0/bcfnn766eoP/uAPej/nHqQdvEocZFvNPPruoe/jNdJ32BjfScaMQd+9ajYLv334DQR33nlnZYwx4nWve90lsRxxrfX2NE/1JRlQMagipEGVmjC8KgE1luhshQZpz1ajxo+aTNz7rQU9igU6BWTPWMdjGSvSjDOV2X0ZVMaKeYlnffbc5z531DJcm4If+vwDX8SXv/zl5sfnKuvzz4n1n/Oc51T7hf3wYr9mf/DDgb5ESO8SX/ziF5t2M900CGjdc6UXz8Jv/uZvVh/60Iea/jyfbd1FNt0/3NvsH7FcOm7pmq0L30m6L8w51Cc8S6afvnt1m9nFNmfid7wxxpTAoxgrtDyNWUb1JfQflEJ6Y/WmKJ6j57O0aLbvjuTBPY6AbgO01cLGGJ1rQEeTejS7g1y4NbIAjDhgeWYEQrXA5MItakv11sdCyzLGP5JFP2Tj56usj3j2qLrZZX7gB36g8XzQC6u97mnE04c//GEL5RXhRyteJZ///OerXQcRwbnIS8acRX0y5mCF2Q4YROfa+nvPGHMhI49iiDHQskDnLNxxWxlk0ZvSnDH2uSSW23Dj7cjCHRoyM80u3H2Z0jSSQMdEEU0dMLlvR6KI3naiuF1kjcz/KBf949QPY7tJml2HgaYooF/1qldVP/VTP1W96U1v6sIJ+DFpS5sxxhhjzG4T3bdrkdyE6MoCjf5jijE1hvVKI7ZlrFTCama/0WAr63MU0u38vkOYx3aBJhV3Y5Eu1eTKqA408xLPTONogzoxQhIxOrvaESSgiYkdQp8TNwtDAjpaqIk1NOZC5NJLL61e85rXNPNYoi8Ea6oxxhhjzDMd3LeZ4lGsPFfxc9y3YymrCMZXxDNezT2JwxpiDHSY37cF+qJqXM5GZSeTeXDjnklHzknXndckEaMTo4gmYLzu0Jn9xNGJz372s1MV4N52oisqrnYSyBHEsKxrWOA+/vGPd8tK8c3Rmt3nvs22uD7SxwgRXmMkB9M+2T/75HyWjcGW8F9nW0EfLjqnZdbZVPuG9h2vxyr71vmwvrZd5bibOqeDgPZyj3MO67iq7uc5WLff43arhFionXA+QjP2c59tI9t675/Pft7U/4WxoG2PPPLIyn2Tr/U6z86m75dNXvf9Xtf9/H+K1+zKK690ElJjzEL4zqh13KRUmhjvYxlQ0YMnT57sEozFBGJt/PPM9kMGXLl1j5GJexQB3TaGBnflrCDGQPdRf9lOMcNTGFvimeXRZE8SMcVBC8RzTCi2zfCPnH8s/INC+Jb+aUoQsy4u2Vofi1spi7Os1dp3hO1ILsYru7yy/o/+6I+u9Q+OHxYkdipZxhXD2rffdbdlG16s84pXvKIYE0b/sD39wCBF3zq4BffBDxtizkrtk1vxfuBacB75enBer3zlK3t/qPRtxw8cthty39/P9SpB35LUix9LHB8X64P6oaTjrJLgTkn5eFZK/T50/kP9/upXv7r3h+/QdhyvL1t437ViO+7dZTO5c84kXYvkJD58B3Dtlm032XPHEvL5Hnr9618/+CP9E5/4xJzXwa/+6q/OvOdccvuGnud17n344Ac/2LSb78++6xj7/81vfvPcMda9PyKKbY/Qp5HSd9bQ88D9zPfjqtdZ14c+Hcqy3Nd3tJtrxLHxpCp9dy/6ruFcuNb5Plnl2Rn6ruz7/td14DiEmiipJ+2gP+Mztux1L11b+phXX3uG/t/33evxPn3b297W2774v7VEX7/pd4YxxvQxZASNWbjvu+8+RHSj99CJ6MWqFc21UbZZXuvIPfRmvc2kdevuRHQQy4qNngTdujajCOhW0U+iss/CGTO7MqXddNNNk/qku4a3nbE0jFbgxh3957cd/kHyT6rPLVvLJYji+qUfAFqff5CR+AMV+EfOiDDL2YYXCZn4577K6LeErNDoNPvlWMr2WxIXnEfMKq5t+Wcds1UPtYlRcZ0XPwb44cG2+vFAiRIE9qJ1Sj/y+MGjHyi0izawrfqM81b71rFGqO+0b6Zql/qtJCRin8saqT6jbXgp9P2YX+Z6LerzCMfleOdDPIPu52X7f9FzoH4vnUfsOz5jO1mmlNCsJNpi9vx4vdiGF/cY0/xjvHSdgXue9dkn06EBoP2w6Hzpx9L5rkppAGYT1uD4PEPf9w3fBQeZP6LveY73B+83UfYuPw/6fgR5dvD5GIOF68C9/kd/9Ecz3936rorPXP6uyuel79iqPS+enUV5E8b4/mcffcfa5HVnO85fnjlqu57foe85Qbv5/xj/P+n3hcpw5gE3fdb3f12/MxjkNcaYIagBrdxWGEbRdq3RtLNAR7BAoxsxwNZ6cibnFtWeShboWB5qrCRio7lwS+GHrGfT48ePd0nEdHLEPcf044qBHiJm4WbaFtye1ub9nShjBfxQkyDObtly7dZ6wD/ZvvWju3f+URt/oGbLEceh7i4/BhBDi6w/QiWFALHGD/m4HfvTj/y8X/2IUVuz9Tv+AGL6hje8odclm33GH/KyqPDjhTbyIwyRnH/s6wcC6+Q6oPoB03duah/H51irihgNWpT2rR9Wspoz+BDPV32ef9Sqn2Vlw3IT9xuvV6nPaQ/nvKjPI+qD8yGe4/OxjIiL9xQ/6oihzvec+o9+iD8OY9/lwYm4HdcLq1NE2/EMx2upz3hxH8ZrGY9XsvbwOc8s28miNgTrYFGCZayD8fjcn3H/i853FdYdgOEa8OKelZVV51ciPs991173Bud0kO6m8gIoecPo/mCdRdeY66mBU1njhwY48sDF0P8F2kC/HXRiSu5T3RexbbRJyQP5rstCjnZLPJfuXz6PA4mZeL+Unr/4/Z+fXUHb2IesyfTdxRdf3H2+ynWP13YZjwcJ3L7r+pGPfKSZMjjR97+LfeT/T8o3Iesyr7xv/V8vHVu/Ceh/Y4zpg3xWGEUlonl96UtfmlkHCzRISEs8My8LNEJaWjNm4obWsDuJ76vWEF3tg9EEaEHdd58NlbCiE1TGqoTqQEd3bVKe89olC3R0tc6uZhrtjTFL+mckq0lE/5BZJ/74U83I0g8R7Z9/dGwjd7Nl0A8Q/rHzzzyLbn4w6AcxYg4RK/TjpO9Hc1yuHyJ98OMknhPbxn/69FNeR9tpnZwJXe5yfefGMeSKVnKRWwaJ2LxvZZtWu6J3Aj9iEbZsl3+0Resd7cnJ6aJ4LvW5luuH8qJz4prEAYyDjm+L/b7MD3vOf0ioyQ1blpbY79wHbFP60ar7DWSdEoofhJIA4hpyPd/61rfOtVWf5wEWtUfXf0gIrEs839zueO/n812FaCXb9AAMIh2Grr0GjBZ934yJrKmQvYZA9wevscnPQ+n/As+Dnq3zle0ea2VuG23SfRkHjvVe3+dZPIPOa2jQLX7/l56/Zb7/WcZ3KQPHtIF7KwrRTV53tud/eqnvJOiB3xx911TnGM9d22qf+beCvov67imuG/s8H/eRMWZ3UDnioepKCOdshcb42mbinqqUVRbOIiQNa15jWJ9hNAE9WRCRrTTjOtGIXLhjfS+yrjFVHWjEcmt57tiVGGihbNlZxElQx39CQ+Wvsrt3aT99P1DZ78te9rKZ/QzBsfUDYMi1j3+kxPzxI0TH5gezts0Wubyt9p1/JEVKo/CcT8xCvmgdtQeiKBiy+tCfuhbrZIEeslpz3Gitj/CjrM/yEF0VlXRK+9A5DsWgSUjw42vIhVuxhZsWz9xnitXVix9tCC/9eFs2blX9OBS7x/mrb/M15Vr39Xt8tvLAVt8gjcj9rGeL7YaeLdoSXSPHZuh8abPavW6tYdUp3vQ9xDHURu7rvmvPcj0bQ983Y5I9dkpsKpFYfB6G+l7utqVB203D89g3OBa/m+P9r4HkRZ4Zfc9W/P4fev54Prg2yklSAk+H0v12ENcdYd7Xd3qu4wBfZtG5Q74f1A9D91T8v2mMMX0Qkqv5nIUbyIklK7TA+Io3M6HBCg8OJZNL+bcm8bVVLtwBNWqm8W0G7kl235YZPkPq8vhe7tugjG27JqD5Z8I/HsW/ZuGUf8TyT5HPsDBKhEVRmv9paj/se5HbWlx/CK0zJMoXbbtMtlHORdYAtsvnNpQRVLF8y6wTfyzHHwX8uBmq063tVv1hGYVuH4p379t3zHpeIlr81eccc79CRS7HwA+lTWYKXuQNIffKRcTnQzG8fcT1+j4v9TvXlM/icpbpOupa8sM2CtCMjsu2y1qX2e+mfpQOnS8M9WUfWHj1XDGItknvhdifi/ooXpPS983Y0CbuYSVr4piL7o8xiM/DouMoc7Usuwcpfobapkz23Jfxu07ntaiMY0ziGYnftzHJ3hCl72j2PTRgfVDXXRm+hz4vHXPomdRn2fIvFt0j+g1jjDGrEEsYU9q4/i7qElUD1mf0JLqyDQ2eSR5WsER3229VFm6YKovYWTofdI0CtPNVO9+4ciOeYwx0zMJNh8VM3BqVkJCOIxa7gkSiRvj556Mfl6UffTHWV8lV4qh7ju0Ti8RgRPvtQ/84JUBXQdsu86NZP0JoT/yRFD9fZh+rEH8MLStgVhURy/xIUt/mH2dDmYT72M/1inD/xB9NvN9EciPRN/ghN/Nlf8zHNi/7ozhf06GMvJFs0dEgl3IXxAGkUjZgtVWx/MuwCcvgsudbei6HUEiJ4BilZERjof5c5plb9H2zCTQAVLo/ls3AvSrxeVimX/RdfVB9Iha1jZjiLID13BLHvojS9mN9/y/6v7Pp696XQXtZhv5XlAaeI4v+t29ycMgYs9tQxgoWlSRGC9basNGIvI9hv8Q+x1JWUXM2C8+J5U4zjiGeYcwyVpMYqB3Fs9KKt8vn4qBL0GHUAYvLEM+4cRP/TN3oZf5xbhMSyXGEP5avysSslhIw+uc7NOrOD/mYxGSIZde7kOFHAhm8l2FVkb7Kj5p4LZS8Rp4KSkyTk8ll0TOWO6r2wz2H1wTH4YfapkT0OiV0FjFUVqcPZSMG9Xv+kcizyHqlZ0exmPyglUuxEu7Qf30x6cv+iN7vwEhG9xksOt9ViTHhEg+bvIe2Hfo33h8Kt1AiKxI9bSozuelnk9//2mZT1z1n0OeHaKl0mmORjTHbRkk4o/NkMI21oBN4M8vSHF24mcysH8WySldh761GcOMerYxVnGbzOGnFNR/FszJyywqN9bmt99V8TsdlEU2geS2iEc+TXXPhBrk0IUr4p9oXzyzkFsqPWERzztYt4g9r/oGO5ZK4H/dNbdsXexWJMVoHXVuYY5cSvIzBMucut7ucoZt2DdXKLVmnGVRSmMB+UfZv2sCxeCkecFuJ907px+QiYmbZvn6XMB4KF4jJt7gePMP6wSwrbNx+U/ffIhQ2MXS+MQv6qsQM8rKUlUT6GPTFpvehZ3PMQcRlLLf5/ohu/2QtXmfgp4/Yz4u8jbQOjD2wugmLtkIp+P5cNABV+h4+iO//yCauu7xshsqPsc6YAjp+Ryy6pw46lt4Ys7sgnBHQrYjuakGTEwtdiEZs60B3LtytppT1mcmMBToiS3RIKrYvNlIGqs88rnTjIlui6ZicaY0O1LxGJRDP1Y4iy7FqE+sfe5/1LSbxULZlxar1rbuMy+8ywi4ff9E/4Xzc6IK+qE3R5fygBFrMdL6ofev+AFlm3zFuWeiHR0wylin9ONE+lhE9Q/cAIkc/yGiD+ko1S7cVng311yIX7tJ5qM9IqNTX76sMJslNU0n0YtIqDXIt82wt+7yuis53KOHauseOGcSVbGiTma9XeZ7jvbGsJ5P6ZyjOdOizEsrsrvsjh07sl1Weh/g9vaw3yDJ9wn438Z2x7P+7vnCmg/j+72OM6z6UD0UMJQ9bl5hlfNE95fhnY0wf2Qgq6zMviWdQTiy5cIOST6sOdIx9DuK5ybqNUVfllcPyfTOKgA4VrDqf81I6cWXgLmXizjDigPW5VANaScSOHj1a7RoxoZYSJw0l6Ir/5GN5ohIxq/CQeGI/uG0uE/cVE7AM1XSUK+iHPvShmaQ1aiuWvb4fCDEGlB/dB+XCGAciFvXFhz/84ebc1vlBMLRvlZgBZUeHRT+m+gYl4r0ka2rf9v/xP/7H5pxKPzDzNVBW41ifeluRi3AcoCrB533n32cx6xuY0PPZlwwt9qf2HUM0FiX941qplu9Bsp/yVfE7LWe+XraEXomhcjzrfN8saw3X9/ZQJv6+67jo/lgUa7qIoe2WfR70/T6UETsTM7T37XtT3xdxAGrofur7HjyI7/9NXvfoJdD3P3OdqhGLiIkxh+4prsuyuViMMc88VIpYmg6k9aT9BN7JsVKTElDjtt26cc/Vfq6XoXEnobTypC25PIoRdhQBHSzOk/i+kEZ8Dty3cx1oOooRB1y45f8u0z4u3Eog9uijj1a7iP7xy5I1NNofk4vpn2xf/LOye7Ie9VDzP09ZvfmHvqwVLZbYYbQZl8/8D5MfFYqjhPiDVNsqtrRv22XK+WwCJX6K7YhoYEAxa6vGoKrWMD/i4r65Fizr+yEf62/2tamPKFS4D4b6HJaxwMVSY4pnLe1TcdvnE9ViVf3hUpy4+p6+jGJZPwyJS1yl3/VcKdY5H6+U/C/e72yT7xGI12pV8RzLauV7b7/nuw7c0xJzihFflvhsxP7tS+Q29H0Tn4lVvm/k5kv/5e9BWdb7rtGi+4P+h2gxXgb1S/yuz9/t+XnIokZt1/JV+oT/ZWrvb/3Wb82dP+e8CREHsUxS/C4V8Zr09Wn8/i99V+73+38/113HilZettHzq+zkoP1ElBxwE6jfdE+VnjPuB2OMWQSaDuNoJGfhxjs5JpqOKPs2mlO6Ex3aCuoZUd35b0/3b4TeRBkrmGpEIC5sS1nNuG4zipDrQLdu3E0W7lOnTjESMbPzNoHYzrpxZ8G8aLQ/loJQop8+cAnjH5riLfkHGmMD9c8Xa/WyP5T4AaaRdNXozRnCgX/4Ocsu62G9VC3YD37wg53lLW7Le9Y7qPhnQVvUPvo4ti/XQ0WYrto+WeH1QzJabGLG7HwtsEbjsk8f0Sb2wXrRIsh9UBrhZ132xzGVkb2vz1cpLcR9wL44Pv0VY2a5J1g+VErsoFC9YT0HTCVc5dKovs9ZcHnP+lwfrE7ywFC/x0SAEbaTxUU/lnWto9t2TqAVny3FRMYBM91/erZWuf+UvIv9cC60R6Vs9Jyue77rwvEk6Pl+ohb5MsQSS7qvgXZTf179Ep/nsb9vOL6eufg9GO8pPXcZPTvKrN93f6w6gMj3BPtj31hIOR+OwXOt+yg/DwjF+DzE77hVs0JrEIg25P7Wd5zeb8Kdl2soAadnSIPI8ZqUEi5CvF/yd2XsGyUCW/X7fz/Xneugdsdrq5J+se/ZL/8v1HZc6lmX64ylmr4YM66d49AfHFv/o3K/6f8L95sxxvSBpmvzW3VW6VICMTTi+9///j1in4mBBsVADxhsS8unW1XGCpThrEoN7ilqPYdGF2SBZhk+8HVHNp8nK/ROunBDdItepkYyFme5oS2KTWN//ChlfQmwaJHQP91VM+EqhlFJT+KPEYn6vrhRLDe0WyI1W574bB1xOhbLtI8fC+vEZmcLfu43DWTkfpPIkVUn/gDUj/8hFzn9EB67zzkuP+bkBhstOBDd0M8nEpwauMjPgQYZSqXj+NEna3DsX/bJZ/k6Cj7TINMqz52eLbnzl54trbNqH8Rz0X6jtWiZ89WgyRjPp1y5Jdo5ru6hRXDv4WYcs4JLGMe2bfJ5Vl/JmhifyZhpuXTefC8P3R+c36rJH+MATNxnruO87vOwShtUtiz2t8TepkRUPq8YzxyvyZAnxaa//9e97rRLAwNxu9y/6vvSNeVZW2SFXxd5Nui7I7ZLxx7DymOMubBpDaJTxHPMwo0BFerllSzQGFwZIFQWbmKgya8VY6H7Slllb+lqn7HQY1px5wpUl0RzLGNVn/Dk5MmTM59H87zqQMdM3LGUFQHod99991cr00sc5cZVd4wfwbLkMNU+l/3nHLeVdet8Wywjm24f12PVfef+XvWH3KbPSdZLiNbAbUEWEZ3/ss+BLGjr9LueO16rbLufZ2tRexadx37O9yCJceiL7uVN3fvxntIg6Cr7Xff+6COe56Ls82r72P8XIP6/Oejv9nhN1n12DuL7f9XrHs9r6NrGfa9TgWA/qH3n49jGmN3kda973SUxDlrCWcgCjQu3limRGN7LbSWnTjxH5L5NyapUyqpZdwwL9Nhu0NllO1ui5cY90YmznDhoCWdZoSWeQQJaweWKgbaANub8o9h4rCjKKmuMMcYYY0yJ22677fkMuCGea5E8+fznP78XP89x0DELt5KIQRTQpfJVkMorj+IaM7YFulP7fS7buZSVakCLevR3gqm+JKAhimgLaGPOP7hn4jKKeB6r/rgxxhhjjLkwOXbs2PM1HzNxyxKdBTTTkohuKzupFvQkum5DsjaPFlcydh3oppWlElYil7KKowhYnrN4lg98RNnaZPo3xpw/iIUjDtHi2RhjjDHGLCLXgQaJZ+pAa1lJPEfwbI4ZuFv6EoVN5MVd7ZOxBXRMHT5nSsf6LLft6L49tD9qgWkUQtZnY8z2EMvJGGOMMcYYsw5oPbTfkSNHJg899NBShtKbb765M9y2QjqWVZ7ZR2nZOowuoGPWxZwJDT91WZ6BeVmgcd3W6EIMGEc848IdxTNZuKE0emGMMcYYY4wxZjuJXsSxDrSs0KdPn56qIhMoV9anPvWpzpNZmvLUqVMz1Z6YD3q0mx/L+jzaThT3HMXz8ePH5/bNCIFqd+UkYlpHHZQzcEcBTfzzI488Ul1xxRWOgTbGGGOMMcaYHSEmEdOymIl7URZupkPlq1o0fy6D2FnRWu2XsSzQXVpwvTiB7MLNCIHmo3jWaAJQAxqy2T52Kp1NpzsG2hhjjDHGGGN2D1VWisj7WFoQbViKgaa6E+TE1en9zGeTMdRztYE60KKvBrTKWMXlskDL+kxHyWwfM3CDs3AbY4wxxhhjzG6S60AzLVmgoS8LNxbotjTynhJYh0TWvKQhm/lQzmr7YqBbZpKIhcDurgY072M8dIRM3BmEc04idvTo0coYY4wxxhhjzIWBqjBFF+4MmhIRXRDPDQjmNkN3o3fHEs8wioBuY59jgybRH13TbHmugtUa67NGFuTGrc4jnXkclYjB5sYYY4wxxhhjdoOhMFyszzfffHMzr5xY0fp8++23N1PFQEMU0e2iSQgp3tN6MV/XfhjNhVuJxLL6j0HdP/3TP10U7DmJWKwDDTmRWD0a0SQRswu3McYYY4wxxuwOJBEjGTRCOrtwL3LfDrmzOg/nSMGFu2PbkojJLF6VxLPm+1y2hWKg6SxeWKBjDLQ69v7772+mTiJmjDHGGGOMMbtDSTxjKMXrOOe/ikg810bZRjhLPOfE1VUoXzWzcJwcYqMJ6KVaE0cIopiWcAaNMGCFxnxPR+ozWaBVB9oYY4wxxhhjzO6hLNzSeNdee+1EWbh5L69kacU77rhjwov5GBosD2heCOeYMCyFGiOs962ixyxjVbQGxxEBJRCL4pm60BLNTNVBSl0uH/hcB5oprtyVMcYYY4wxxpidIGfgjpQs0NKKWKBlhY4x0NAmDIuVqho37mh1boX1vj2YL6rGI55s53eey1mp/nN4Twz0zI5IIkYm7nrUoetEmfaZr9efXnnllZNHH320MsYYY4wxxhizW2AULZWxuuGGG6rTp0/PZOGOHss1U1mgEdIxC3cWye37Zt0xxDOM6cIdrdBFy3AcKQilrObWK5WxMsYYY4wxxhhz4YILdy2eu5BeLY9W6FpTduKZaaz8JIuzYqCPHz9+ziQ9gvs2jOnCPdigekRg5r0s0VighUYW6CxeWJ9jJjaNTCgG2knEjDHGGGOMMWZ3oJJS32fRhVshvcn6TFjwtLU8d8uYD6WsJinB9TTERe+b0bJwt8y1SjHQJBDLIlqEdOQNysIdg8hLDHW+McYYY4wxxpjtJrpvC6oxXX/99XNaLxpfW305U85K75O1eVTNOMrOom95XBZN5iJmTANcuJVNDaIVWstyHWglEXMdaGOMMcYYY4zZHY4dO/b8+D7GQZfqQEOuBY2QzonEIMVBl7Tuvj2YR7FAl8zhLMs1uaJ4Vgw04vnKK6+cOxF1GKMPGTqZRGKVMcYYY4wxxpidAkMoei4nEcNwKv2HQfXqq6/u9CPCGd3YJ56Fcoa1b+N6C8OOl2FMc/bMvnL2bZCARjwTA00AOD7sdefN1PiS9Rm/d0z3dKSszw8//HBFBm7t88SJE1+rjDHGGGOMMcZsPdECnQV0tEADevDw4cMzy2R8zSI6Gm8xQwchLbfu5rP9xkKPHQPdoWLWmmcqq7MSiGm5YqCjaR4knpmPCcRKNcOMMcYYY4wxxmw3pTxWMpZK+9XiuBHPVGeKScT66kBnz+cYXlwbdg+lRftiNAGNop+25M9CavGZk21rQM/FPyvjmsz3X/jCF+bqgxljjDHGGGOM2X2izkMDPvDAA3NJxBT7DDfffHP3WRbPWY4qEzfzY4joUQR028hoJm9Es4SzTgoX7lIm7phEDFQHuu6YZnrttdd2ScRi515++eWjZlQzxhhjjDHGGLM5nnjiiUbP4VWs5NACF25pwJhEDKJmJBF1H6kW9OgG2DFduEs1t2I9rsb6jBVartyADzuvekShc+EmBlodlv3gZd5v17NF2hhjjDHGGGN2hGuuuaaZIp5zaK6SiMkjGaQRsUCTQytqSYyzMtymHFxNwrBQzkrz+zbAjpWFu+RT3lmitUAWaCUQ03LcuOsRhRn/9vvuu6+ZlupA55EKY4wxxhhjjDHbzyOPPDL4ORZoeSRjWJVGxAJ98uRJaclFhtRGn7YaNbpvb0cZq+psojM1Jk87ONGQQGyP0YOS+R3rs3zeFf9cohSAbowxxhhjjDFmO5EFWhCiKy/jG264oVmmqkzRjfv2229vvJfRkKruhHezSLHQXdxzFazOhXRdKzOaC3ewQM8EdOegboGQ5hV92WWex/pMZ2G6V/xziec973l24TbGGGOMMcaYHQP3bUoUxzxXDz74YPe5RLTA+oznsizQpdxaLdPort0mu25mtyaJGMSG8erxRZ9DqciZyjyPyZ4OwwqtGGhZm+lkY4wxxhhjjDG7h1y4Cct9+ctf3mlFPI+l/TCkYlDFwMorhvoCFmhZn2WwDbpT4cVT1YM+fvz4KPHPMGoSsT4rdFwJk7vin5kqFfldd911KCYR0/qKgZa1OdaBtgu3McYYY4wxxuwOV1xxxUxSaFmh8TyW9sOQqvhnXtKJuHAzjTHQCGd5PifjbZeoK5ay2i9jCug5H/MSmNwV/1yPHMxlV+sjZt82xhhjjDHGGLP7YCCNpYqBTNy5jBXgws1UMdA5ZLi2NHdCWfHOMe45ZOVemzEFdDVNUdmFUYAGxT/TAeoEkGle8c9xm9ipysJ99OjRyhhjjDHGGGPMbiDP4loHNtOYRAywQpOJW17J0dAqC7RKWeWw4dbgPFPOKmXi3pos3JNJqGWFjo7iWaMCdUfMiOm2/nPzWS5hpSzcuQ505NFHH62MMcYYY4wxxuwOxEHXWrDRe4TlyliK9uOFMVUG1agTZXyN2behZLgtiOlRPJovqsZhxn27VfZdA3UytSl+ZnlEIwt0kMTzUA1oRizqzrVbtzHGGGOMMcbsEJSyUhZuXLirViPWQroR0aoD3Qcu3DkOOq3S5g+bRJ26VTHQOavZzAnIAq1U4zK5l8BUX/J3F3Q0Hc6IhctYGWOMMcYYY8zuoCzcQTw3xJDdmFR6yIV7AAnmSYiFnmxTDHTMajbNsdAaEZCpnfhnfaYs3ALxjAs3RPftWB/s/vvvt3A2xhhjjDHGmB1DWbjlwh1B/2Uv5FzCqhbPcy7cmVaONiJalaKYblUMtGZCYxty3LOIowaKgxZ9JnsFl1MvTEHnxhhjjDHGGGN2A3kRqzSxjKTEQiOeqQfNexlVI8RAY4CNWbg1jXHQrVhuZttNt7KM1USW51APWnHP3cnJVx0rtGpC33HHHUWRTQfKCk3HqnOpF1YasTDGGGOMMcYYszvI0ziH5yovFmCFxugqF24gPDh4OneCOntDt5+PpnvHFqFzicMyGi1APMuVW9nUZJ6Xz3s030cXbuZJJsYoxd133/3VyhhjjDHGGGPM1nPbbbc9n5xWeBQrBjrGP8uAShZueSYrDjoKaIiJxKA12qIh96p5rdto62jsXYdRLdDxTSxoHZZ181E8ZxduJRGj82644YZmWRbPlTHGGGOMMcaYnQLxHMtYCblui76w3taLeco0as4wH8WzDNKNsN6veIbRY6Crgm+5TgbRnEcJGEXoc+GG06dPT3NnGmOMMcYYY4zZTVTGSu8xkl577bWdJlQN6BJoSryaSSQWvZ6ZT17Q05h1u+DZvRZjZuEWTSNpoISzTiQGfAuyqMkCjWmeYHFesZSVOlNJxIBRi6NHj1bGGGOMMcYYY3YHQnGZZs9iuW/H+OdYxkqhv0pIjd4sJK3W+6YONK/WdXsUBX1RNSJdteqCb3mbFY3Z7oMUB93EQCOehwpnUy+stlo3oxYkE6uMMcYYY4wxxuwMTzzxBEnDJjETd5vzaqaUcR8qY4WhNietllhup8rKrdjorSlj1RDFczSfa1QA63Op6LVGEuLoQimRGOArH839xhhjjDHGGGN2B4yhmZhIrM+FOyYRy57N6M9oyI0Bz9GVe7+MmYyrU/SqZnX8+PG5/ecTBQloOHPmzAQLNAI6Z+HWvEz9zsJtjDHGGGOMMbvD6173uksoWdWXhZsk0uTBYl5hvaUs3MqtpfrPhSTWsjrH9/tmFAt0zGxWnRX7k4ILdzPFAh2t0FE8Q3Tfjub72Kl0dmnUwhhjjDHGGGPM9qJ6zxLPgLGUxNG8EM8xHxbiWeWOa9E8EwMN0fM5JQrbSOWmjVig2/m5WtAl6zP01YEWJUu060AbY4wxxhhjzG5x7Nix5zMlLBdNxzQaSwFDKiJa+bFkgSb5NImpY2UnWaDje6YhFrrRqWOUsIIxk4hFE3k2lzfEpGFD0Fl9MdAgF26ycD/11FOVMcYYY4wxxpjtByMoVmiSQ9dW6Dm3asQzMdAIZ3knY2h9//vfv9eWP15GPE/P5Q87O21X2aokYpM8zwnoJEIW7gaZ3yMxiRhIPKsONNbnmOr80UcfrYwxxhhjjDHG7AZy4SY5tLRdzHcFKnMl0ImteO4gRFjiOZWyKhpzpyMVgh61jBWolBXzcTTgxIkTh0gxjrmdk8X0nmFkgc4hkdj111/fxUDHotrKwK3OvuyyyypjjDHGGGOMMdvPI4880mThJq8VIlrLMZpG3ScUAy1jK+G/DzzwAFqzE8TozJBMrK/m8yhW6FHLWFVnfcvnTOgQ6nNV2Y0bX3am6pyYSKzkwo253xhjjDHGGGPMbnHFFVc0+o4kYrE88VVXXdVp09qiPLNN9FSuteMeU3QllmdpzpSJe1KVM3Bvjwt3axKfq8WV04ln8cwIQjbH96HgckYqGLEgBtoYY4wxxhhjzO6Ai3YMzUXnybVbBlQSiJWQniQ8GCNtTlyd6AR1a5XedyaxsQT0fN2qHmLGNJD1OVqh+7bFN14i+umnn544BtoYY4wxxhhjdguJ5ZJnsfJfXX/99ZOrr766V2Mq7rlQ/zmS3ba3xgLd26CUFa2rBy0UC33XXXcdwn2bVy5jpU5EPCvA3HWgjTHGGGOMMWZ3US1oaTx0n9y3qcz02GOPFQUv1Z0UIiy9mTNytx7S03Y2u3SvzShJxNoaW90Usvu2TqavjJUszyQQu+WWW5qaX4w6kEhMweQ5O5sxxhhjjDHGmN1B1mcRjaR33nnn5MEHH6wef/zxJs6Z3FgxgZi8lltNObOf7Mo9aYtAV+dKWU2jXl2XUSzQalBViIGOU06U0YK4Tv2+uv3225t5JRDDAo14ZlkpiZgxxhhjjDHGmN2DLNzEQJNAjDjoGKZ7+vTpKQZUtGBMLC3InVWq5iSCAbeZTiZdpHEU0vti9CzcmonZ0LQsxz8DnXDy5MlmXiMLmOuZUkBbpazoWHzkY7C5McYYY4wxxpjdgVDcJ554ohHPMQs3YDzlhR5UEjFpxCuvvJKyV808uvKBBx5YpAsbi7Os0O38diQRk095ayYfXLfPhRuwQDNVDDQjD7JAKzMbnZw72hhjjDHGGGPM9qM60ELWZ+KfMZ4yjR7J0ohUb9I2C8TzNOjTzuyMVO2pD70SY7pwn23pEmbx6MatUQRgdIEXIw5HjhyZ9Llvywqd/eeNMcYYY4wxxmwvUTzjYaz4Z+W9EvJKFop/FiXvZiGhvMi4uw6jZuHOTuVy415UCxo0siDwf1f2baBjcxIxfOcrY4wxxhhjjDE7QdRwOQs3BlRl4VYJK7lwE/orK3TOqwVBc3YZt4M8nY4lpseOgYa5zNshtXizXCdMAjFejCaoY6KQpvNuuOGGZl6mfWOMMcYYY4wxu4m8iBWWi86T1lP+KyiVsJL3cjbIDtWCboWz0nDv2wA7ShmrlqFRgAaE9AMPPNC9Vwa16M8eOXXqFKMQzXwcqVDGtqNHj1bGGGOMMcYYY3YLJRGLXsa1kO5ENHHQuHHHMlaAdoxhwKr/HKfxONFJemtioAONuTxbnvN8HDHAAi2yG7fM9yDzPtDZCOpHH320MsYYY4wxxhizu0QrNEZUhLNioKN4BolnJRKL2jOKZ/lsy3V7lBpW1chZuKuzVuhpX+xzRG7csY6XOkdZuEEjENmFG9O/k4gZY4wxxhhjzG5BJu7akjwliRhEKzRG1KgHI9FzWXoya8+CYJ5OR8wmNmYSLvmVT9XYaHWO5LTj6ohogY6dRjB57NRYC/rEiRNfq4wxxhhjjDHGbD2ve93rLqn13V5tSZ6Qkfvzn//8Xl7n8ccf36OMVbRCkzdLxldl4CbHVq05u+2SBVru252htxqB0ZOIRdN4PIGSNRr37VL8czTTxzrQTOtO7NZ3Fm5jjDHGGGOM2R3wIkY8E/+MJToaSvE+5nXLLbdUDz30UCeez5w5MyELt9bDIMurTzwD8c6t4VkCfXtcuBNNQ3lFP3RZoznR6L4dA8Dvu+++Zlovm2uXOra2TE8x9zNvF25jjDHGGGOM2R1kBMV9GxEdQ3VlPMUbGRENeCkfPny4W6e2Pk/a6VzC6uSp3dh2Q+bt6RhZuMcS0LHAVtNQGaJDCaupyliV6kADnYSI1mgDqBZ07FhGLJjaAm2MMcYYY4wxu4OMoLEGtIyl0n6gkN6cRKw2yE6zeJbRtpQnLCybbGMW7i41eM6CJiGtky0Vv6ZzENEabdAIhDHGGGOMMcaYC4+Ygfvaa6/t9J/in3OlJsg5tXLuLSXgjvNjJRIbKwv3TLB2H/JRl9ldRDfuSByBiKjotjHGGGOMMcaY3QEvYoXkxuTQfUQLtEogZwu0kJBujbqdS3fIc71vRs/C3TLNjYwx0EwR0ZjfmY+JxBhhiBm4qQOmkQhM+7GT6fy77777q5UxxhhjjDHGmK3n2LFjz9e8DKOyQKuEsSjVgo7G1x5XbmlRfdbFQFcjsIkY6E7hI5r10uch5XiTDU2jCBDN84qDlnhGLNOx0fp89OjRyhhjjDHGGGPM7pEt0ArhZRrzYgFlrBDPMRT45ptv7vJthVWjIVellquxGNOFuwvcVoNLpatkgVYiMdXyijDSoDhoQbC5gsupFwZk5K6MMcYYY4wxxuwElK4SMo7GUlaAJZo60HEZZawwvqIjMcqiI2trdmOUTTHQ2fIcS1rtm1EEdCvx59R9DubO5ERi0TQvN+5oxpdpX53uLNzGGGOMMcYYs3soDhrQeTn/Vcl9W7WgMcrW4nla0pt4Q5fE8lgx0BuxQFc9/uWUsYp+6rGcVSm7GsRM3BqZUGfbhdsYY4wxxhhjdgd5E6uMlVDo7rKVmNCS0eM5zh8/fnwm7nmM+s9iLAt0M2nfTsN8dyJMlYUbSCIWLdCMLJRENCMRuRa0OvvRRx+tjDHGGGOMMcbsFsQ/P/zww43Gw1AqzceU+Of77ruv4lUC920Ms9ECzTx2XbRpENNaNlro76hJxNoT4DVT/7kVzzNZuMnAzahBTCImYkfdfPPNc1m4l0l3bowxxhhjjDFmu1AYrryK0XiIaGk+9B/xz7zIi5WNrOjHqCELlucZsRyMvaNoyLEEdJdZW1m4q9DAoVhoRg/IqMYLKzTiWQnEKGEVyVm4jTHGGGOMMcbsDiSHZhpduHMSMSzQOQs3GbjbElZdJm4ZZwEhXQvoaXDXnsZpGxe9bxE9loAWk5CFe1rKwl2CYHAFhCOeSSBG0DijD8YYY4wxxhhjLiwWeRXLqKokYrXFesIr5tGqhfReNNamRGFKvT2qG/dF1QjI11wVq7V8URbuSK4BndOWx1EJzP316MPEScSMMcYYY4wxZndQRaUbb7yxEbcPP/xwV2np4osvbubb+s7NvHTi+9///j2VQEZE19bn6sSJE5NTp05N4/pZRGvZWCJ6zCRiEs+9jYom9gwjCxpdQDxHkz2B5EogBjljmzHGGGOMMcaY3YBM3FigCc9F2+HW/X3f933NZ3ghSwvimSydKI9lIIEYbtyIZ95rKgNuX83nMWpBj+nCrcbOiOTsxp1rP0c0uoD7NiI6x0ALsrWBs3AbY4wxxhhjzO6gMlYiGkpJJEYZK7SgwnqlEcmZxZQEYhhmY4UnUPJq5mWF1lQe02MwWhbuaY+c1ygANaAh+qwDfuyalwWazmLK6AMdSEdGF27ct5nahdsYY4wxxhhjdgdl4RZR573gBS+Y8sICjXiO6wULdFF3ZsOt5Gl03R5DRI8ioNvY52Ze0xz/zAgBpnaZ27U8ZFObsUDnY8SRCWELtDHGGGOMMcbsDsrCXSJ6IMuoKiOryAZZkfVniHue85LeD2PGQM/ACIBe7fvG1M6rrf/cmeB5STznDopkEW0LtDHGGGOMMcbsLlHjqQqTEkpT4lg6UUZXMZRfS4RE183bagTGLmM1FJU9Y3mOIweY4yWc6SA6SmDC1zzm/Zju3BZoY4wxxhhjjNkdlIVbyIWbxNGyQCuJmEpZAaG/GF4Fns3Vckxad+5RyliNXgeaxmE+11QfMC83bi1DUMdsajELt5YRA82UjmV0gkxtvOh4W6CNMcYYY4wxZncgiRhlifNy8l7xYj7qweyhjIhGUyrHVokQ/zwNpasmY7hyjxUDzaSrsXX8+PFpKRZaZnZZorFCZ1M8aMQh+sBH0z5WaDreFmhjjDHGGGOM2S2UFBqizsMKrfmYF0tu3NSBVi1ojLM5bFjCOeTnmrSTaZv0eqvqQBffx5OKIwUS0ZjiEdGkJT9z5kyzoUz18oGXWV9TLNBMbYE2xhhjjDHGmN1CmbhrkdxUW5LOwwJdKmVcypPVlrKanDhxotO0tSGX/eR1eT+RmK72yUXVCJy1jE9aC/mseFY9rnY6E/uM+b1+j7Ce3HHHHYwsNMuVcU2UMnDT2dUFBAMi3/rWt6pvf/vb1Xe+851qb29vlELfxhhjjDHGmN0CTXXo0KHqWc96VnXRRRdVz372s0erY7wNkIkbN+76VV133XXFRGLkxYox0BhcsT63GnKi0OBacHfbtpboSawJXbVhxujVrSlj1fqVz4jnNuZ5poXxRNv3zTTX7CqVsYLYsbXInl4ILtwI5XoEpvryl79cfe1rX6u++c1vNgLa4tkYY4wxxphnJmgBNAHaAI3wN3/zN80U7bDryPqMG3d05RayQCOeZXmWpzK0InomBjrrTkKKC4ceZQRizGGMaC4v7bdJIhbTjWN5rk+cuwAL9ES+7SArNB2oYPJYZJs4aDr/7rvv/mq1g/BQfOMb36iefvrpyhhjjDHGGGOW4TnPeQ4W3GpX+dmf/dlLMIYyT2guRlIljGYZcdBYoaNRNbpwK4dWzsId46Bbw25j5G0/1vy+rZSjuHBD29BJaHADPunHjh3bQzwLhHMtpKe82prQc/ur10FszyxT58ZSVrsII0df+cpX5kaQcM/QC5cNXsYYY4wxxphnFrJAywrNVGCAI/TzBS94wU7qBbyI4wBAFM/QGk+nGFSjiJYLN0g8K1SYeblth9rPUTOOIp5hrB5v2kej2wZ3ZnT5pGNir0cSmmUI56Gd4e/+sY99bG4dOjfGPu9iEjFu/iyeEcw8ALye+9zndgLaGGOMMcYY88wDTYUmwNp8+PDhRifwXsggF4X1rqHE0A8//PDM8piJG12I9bkWzxUeyySgZrm8mmOsc7BAZ8vzqOGxY6q0Ln04FzzGNbdieipLMz7rysINqgUdTfPU/oru20DnytwPcX4X4EavreedeKafGH3JD4QxxhhjjDHGCBnc0A4yrGZtsSvICCqvYpKICblvA9Zn4qAJ8yXhdImS5pycZSa0WEbeMYT0WHWgp2G+a1gO5sbULnN767rdzN9+++3N54qBjtnW6hulWSfGP2u0YpcycdMn0fKMhZmHgFElY4wxxhhjjFkE2iG6bssSvUsJiEtG0FjGiqkSiUUDKy7ceTuVsAq1oKUPs06cS3q9LmNl4Z4xkeeGxZPB3K5SVop/lku3OghTPTD6cOTIkWZd/OLj6ATsUhZuEoZFy3M9CNCkpTfGGGOMMcaYZUFDoCWiJRqtsSs88sgjzfSaa67prNB4GiOiZTxFB1599dUzSabltQzKwk24cKn6E8RlhERXIzHKjkLisJksZ7EGtNZFQHPCEtEkFDt58mTzmTpIAePKxF2Pqsxk4VZH70oWbm5qylQJXC9seTbGGGOMMcasC8nEKIcrLr300p3Io/S6173uEupAMy/P4phETCK6lIW7LwO3yOWRq5CJu00sVu2XMS3QgwpfJxPFM/QlFEM8y/ocA8mBotvVDhFHhJQMwBhjjDHGGGPWBU0R8yjtSnlciecSWfdBdONWEjGsz6oDXYiDhrifopf0uoxaBzqWsCpZn4FM3MeOHevioJmqI6IF+qGHHppiYcYPnlEIrNBYoDHvU3Ab0z9m/xMnTnyt2mLoEwqfCycMM8YYY4wxxozBt7/97SYGGtBhWKHHEoqbQhZoWZ9BFmhZnwELNG7cjz322HSZOtBQsEBn9m2IHSuJWHF5TCsuiHmOFmje54BwOoss3MrAJhduUBw04nkXkohRo00Qr2DxbIwxxhhjjBkDtIX0BZosao9dJOo+jKqI5751ZYEO77syVmNl3C4xahKxONqRhXN+HxKJNQHhsj4rgZhgFCKb8jVasQtJxBgVEhdffHFljDHGGGOMMWMRDXRRe+wC5LbC+qxcV2g/ZeDGIzmui9FV1mfCgk+cONFnTG3kadCmUVjv2wA7tgW6mYlu25pvrdFVrP8Mqg0tKGGFiKbDGIGgA2+99damnXQunawkYrtALG7urNvGGGOMMcaYMYkCOmqPbQX3bWXixjCKeJYLNzmw5IWMR3LcDqOrQn8xxhIWXHLZLriwd6HGoT702mwkTVvpRGRil+U5CmnVgY6+7XQYIxDEQMesbHRy9JffdmJhcwtoY4wxxhhjzJjEzNtRe2wr5LmKJaxiWO6DDz7YrZct0BHin2sDbTO/RNxzJ6q3xgIdmLE8p4xo3UrKxM2UkQTKWCGe5cadRxsEoxO7ZH2G6Hu/7QH9xhhjjDHGmN0iCuhNxf2OjSzQ8OSTTzZWaIXtKg5amjAaWYWMs7EGdE5enb2kq7Ou3dthgS415Pjx43MZuEPcczeVHzvQOWRaizW/YiY2wPpMJu5dK2VljDHGGGOMMc90cOHGAg3ROIrnMdOs/2RkBbQjbtzROAs9rtwsUx3oaSuot8oCPdNorK06kVgDWunGmc/xz3ROzLRG/HPMxBZduSllNVRDzBhjjDHGGGPM9iG3bYyiUeMJuW8rwTQ6UZWbmD7wwAOdRkRrnjhxoqRrJ9FlOwjqfTFmErFJThfeZ4GuRfSE+fx5NM9jhVYAucz5ys6GeGaK/3xljDHGGGOMMWYniBqOEsXSeIDuw4CK+zYimgTTgE4k9LddrdOMEtK14XVGGKNJ0ZptCK2s0KMwSlHiUhmrSIyHJt24EojVJ9ydKCMJd9111yGNMtBpWKBrET03SoAbN+Z+W6CNMcYYY4wxZrcg7pkpoblR0+HGLRdu9GCtDaeHDx+eK4dMKeRaU07aZGJk7kY7Ttts29NWn3axz9WIjCKgW4dyieiuoYjmHNTdjg7ETNyTejShQjyzjA6qLcyHWrN9sx4dGUcmhC3QxhhjjDHGGLM7SDDjvo1ncW0cbZbjyo14xgL9+OOP72F9bi3Qc8nEKGHVznbTYHHuLNXylB4zmfNYe+pqa4nsni2UMQ3k0q16XgIf93pUollGB6o2WBTRjFbUHXzo7rvv/mq1xTz11FPd/GWXXVYZY4wxxhhjzJjskuaoxe/zMYQipFWeWHHQEtBMMahiXEUbSjzHBNTKrZVpPZ/73La3Iwa6KjQkJxATrcm9O5mYSIzOkXgmBloJxNShmuK+rThoY4wxxhhjjDG7ASWsZIXGKAoylBLCi3hmivX5zJkzM5pPhlc8maPOlJFW4lnJw1Ipq1HCf8dKIra0WVzxz6GUVTeSoPhnxDPzmO6VQCyDyd8x0MYYY4wxxhizO6iEFZBEDLK3sZJJK4mYSlkpEzdlrKLHM++DoO6Sh8Xw4ipl5V6X0SzQqxTtlohmyiiCrNB0EOZ5LNAEjfNSPTBQp8pf3jHQxhhjjDHGGLM7ZA0nK3QuZyXjKqARMbpifIUYFsy8cm+1orpz4UYwRyt0ENRrM4qAHrI+LyplRUeElOQN+Lur9lcupI37NiMVtkAbY4wxxhhjzG6Ts3ArjDeWsGIa3bfRkZSwamtAN8uZP378+Dm13OboklZdxeA7xGgu3Odm+xumOl3tCc+UsGJK52Cel/W5tA+VsLIF2hhjjDHGGGN2iyiYZX2OyICqpNJy3wZEtAyyCGmMtceOHdvT57WA1rpzOhG/7q1x4Q7KfhLN4jmBGJnS5L4dkSkeNMJAHDRWaALIM8rWZgu0McYYY4wxxuwWeBMzxbNYYbpMY/4rtCBu3DKysixm4YZYNjkgYar3XamrrXHhTmbnGMzdzUtMxwzcwChCLGNF59BZjDhcddVVh2IMdPaLN8YYY4wxxhizW8SKSrHiUtR+gBt3LGMVkes2SHcGA67ioKdjWJ0jm4iB7vR0LGXFSSnYO1qhb7/99rn9yX37hhtuqEpZuHHhZmoXbmOMMcYYY4y5sMCgqhjoEujJU6dOzejEkEQMorv2aCWs4KJqAyCoC6b0WLpKfuvMNxnSiIO+6667DmGmrwV0s/7p06ebUQhENFPM+vjJ1yMWlTHGGGOMMcaY3YNa0JSzuvzyyydYnjGMxvBcDKq1LpwePnx4mmOg0Y2tnpyWPJ5FCDHuEopVIwjpscpYxULV2XzeiWlioLWszZ7W7YBM3JjmGWlgxIEYaGVgA/nG4ydPDLSzcBtjjDHGGGPM7hFrQaPzpOswnEoDIqKz+3YsZZWR5iwZcscSzzB6DPSy6cEZNcjxzwIRraxrgPWZkQlGKPSKfvPGGGOMMcYYY3YDJRGrNd805rm6+eabuyzcGFSZZgs0U4UE1+vPWaDbUlaKf46HHSUL9ygu3HLZrtlTseqQQryDGOg4YqAsajLFywqtTnr88cf3SCSm9T//+c/vKe7ZAtoYY4wxxhizLt/+9rerL3/5y2gRcis1r29961tU+qme/exnI+Cqw4cPV9/93d9dmfFAzxGSi1cxhlGWSURjfcYKjZDGoIqILiUQwxjbCuamhFW0Orcu21ErNonEyMCdcnetxSgitPUpL+6rTR7W+aerFrQKYDOfrdAIaFmg6URGIWTKp8Nx4yaRGPN33333V6st5qmnnurmL7vsssoYY4wxxhhz/kA4k1fpf/7P/9nML+K5z31u9b3f+73Vi170ompb2SXNcezYseczRUCj6ZhGK3S2QINEdBv/3CyL4cEix0FX59y2J+n92oyWhVvm8ZILt0R0zMJdEs8I52iiBzJxSzzjHy/xzHvHQBtjjDHGGGOWpbZuVr/3e79HzqWlxDN84xvfqE6dOtVs97//9/+uzDgwiIF4zsvRfhLPJJgGacTozSxtmUVzjC6uZnN1jcJoWbgxibem8c5GngO46/dYoGe2w42bbNxk4C7t98EHH6yUhZuRCUS0Ritk8jfGGGOMMcaYPhDL999/P27BM8tx177qqqsad225bsudG7HM+swDQvoP//APm4pBGPnMeuBFXIvkPUJyaxHdmxgaj+RbbrllxoUb4yv6Eesz2hKy5kSXVmeF80Se0u2yURhFQEs4y4s7u3PLhVvu27I+C2KfmapzGGEgE7fqQaugtjJxI54VeG7W44tf/GIz8nbmzJnq6aef7pa/8IUvbL4UttlF5XxBjAz9BmQOJCbmIPjTP/3T6i//8i+b+JxLL720eb34xS/e+mvE/aV76wd+4AdW2fTA+pq+BfrU97wxxhhzYYJ4/sxnPtP87hXENeOWjXDO4LLN8qNHjzbvH3300eov/uIvOiHNbxywiF4PBHP96ios1Uzkwi3DKeJZtaBjJm7l0EJXYo3OtaBbJJxnxHQ1UhbusZKIdebxlpn3GhWQ63Z04a5HDyYnT56cEc/ajk6rR4RmxHZrdZ7WP6on/+N//A9boFcEYXLPPfd04iTD8j/+4z9uBMVP/dRPHZhI3AX40qXv4Ed/9EcbEbtpPv7xj3df0moD14jXm970pmqb4T7SfbaqgGa7g+hrHYP2WUAbY4wxFyZYnqN4RjjzWhaENIL6j/7oj7r98PsMa3Ut9iqzGtSAfs5znjNVUmjVgmae5GFVK3RbY2qv6C2JZ7lqq2yVDL0to4joMetAN1bmWAs6E8zs3XERzxEJaTpMFmjA+kzHkuqc9/WDYAv0iiCeP/KRj3Sipr5xG9GAeMgCgnU/+MEPkvm8MucHrKMSzwxovOpVr6puvfXWxkuAqTHGGGOMGYZw0Oi2vap4Frh3//AP/3BnlYZolTbLg3ch4lnxz9J3tXG0iTXnBRhT87Y5+XSOf5ZXtDRpdIweKw56LBfuRtq3icKyNXqO2uQ+UwybGGi5cQsCxzHd5/jnsN1oZvhnCr/5m7/ZudRi0UOQIaIjCOd77723E86///u/3whrW6IPHty2RfQGsHg2xhhjjFkM4jZ68q0rniM33nhjY4XmhWv45z73ueoVr3hFZfbP933f9zFp9F593fZw315ErvjU0pmdowl6rDjosbJwRzHbNDAHc2dU/BoknpWFm2xriGdGH3L8c0Q1oc1i/vqv/7pzOcGCiVtsFs+ApZPPJNIQ3J/4xCcqc/AwmAEewDDGGGOMWR0sxAIL8n7FM+C2/bKXvax7j3XbmblXQxqOLNwRLNAYTyljhSeyyhr31IHu5k+cONFo2iCkY03obh4tnepDr8VYLtwwYxEO1ugqLJsRzn289rWvbU4MH3jVAautonvyjVcZK7M8MeZ5GQsm65BMjJctnueHmNzNGGOMMcasxuOPP97N/+AP/mA1Fojx6MpNkjGzOm0CsY6LL7542sZAN5RcuJVEDA9mQSy0dGfUn63L9jSWtRrDCj1aGSulCI/LshVaCcQ0zxQ/dgpi50zcBOoz6kAdMKzP0QKtMlaVWZooxkqW5xKvfvWrq2Vh/4h0HWfVrMZsh5VcVle2x1K+bFv79jm0PRZ5khgA6+mY6xxH7kHsp36wz7vFmL4ka/c2tWnT5Ou5qXOOfTvGfWqMMcaY8UE8q84zgreUbXs/IKAlnKNQN4tR2SpVVpKQxvO41n6NFToK6ZiFG+GM9ZkyVmTiZqr1pD1rEb3XWppnQouT1/TajBoDnZdrBCAKaQlnZeKO4lkobTlxC3XnTWvLc9GF2yxP/IEfsxDul6Gs3ogLrNeLMigTc03G5pLFleRm7KMkhEiypSzKxAgj2GkH8dsIWs65lKma7VhnP22GoXMfavcQxKnn/fH+V3/1V2eWlTJT03/0Y19f0j8vfelLG6+CvvP50Ic+NLN/lrE/lTx729veVm0btC1m/I5wzpzLOkJa14Jreeeddzbz3KtjXm9jjDHGbIboVk2d57GhDBbCHL2CUOd3kn8HLAcu3E888cT0xhtvnNaG0WaZEkYzj3g+cuSItN+U8F71rVy38WyuNSZCe6Js3GhPjLr1dEYoF2TqvhgrBrozkfMnCOZJXyy0hHSMf47TGDQeOxRfeVufVydaVknBP4Z7MCI0ZvUGbm6JdcQX8dMkIitBGz784Q83okTtYdso9hG7MfnZEOyHddmmtL7iuYfKeKnNtGvomKxXEru53WMOVgxBe3JfZmgrZbFYZxkQpVxfpgd1HqvCteKcYmb5+M+L5fvNJk/fItK36XobY4wxZpj4P3ls63Npv/4NsBpk4pamQ99J64nTp09PSSrNfCmZGNWdENHHjh3bi8uPHz/eiOdJC8vGyr4tRnPhVnIzBHPdcE7kUM7ILVN73A4/dty4McsrgVhNEzgu033s0Je//OUElE/paFw0zXJgiZOFFhdUhBEWs+/5nu9Zy/0UQaHkYmyPZZOX9sUxEGqyDmLZ5fMIn7Me8BkJGSR+EC1/8Ad/0GyvzOBkDe8jWgY5T6yseRQQIS8hRXvImMh6tFlu2OyHL0DahTDDsl1CVl4sj1hqOabc0OkX9iEx3rePEpyjBLD2w+BHPvc4IML6UbzRFpW74txoh6ynrCMBPRTbjiDM/XnxxRdX20S8njrnGDbAOeic6Uv6Yx0X/Vj/m2PE+5w+iteb6/D617/eLt3GGGPMeUbu20Dir02ABVq4nNXyyIUb0HS8l8GU/FdYnxHQeCUjouW+jeeyLNBoSizQ9exMFu5SRag27rkR1q3j9L4U9agx0ECDGA2oWmt0OqGZjGklNMJQC+npVVdddUhJxKIVGlR42ywPbqgSWhJ3gOhAWCCSlo3nlFUZIRpLLAn2Qww1IlTCFKEZ9806bMcIVBaI7JftZfVDsCJe+trGOuzvNa95Ta+7t8QW69HmuC/mVQ+bfpGLN69SLDeilfZEEaq62m94wxsaazD9zParuPSUBJ722wfXQuI5twnoS8Wk6/pzPTSoUoJ2sw33zCqx7H1w3FVYNIqrewK4b0vx+qptrnOmn1YZzBCKyy+5zbP/N7/5zd19Lpd3J94zxhhjzi9RQD/3uc+tzG5A/qvacNHEQMsCLRbpyJzAujoXA93FQ4+RRGy0LNy5aHU0lYdY6Jks3MzHYtiMLmiEAQs0AeTxGIqDlrnfZaxWA0GEuMuWYIkRhMa//bf/trG2DQkYxKg+f+UrXzkoDhFgsvBK8AgEDuKDffQRhUisi1w6tz7xDLK60hbWGxokQMxz3Le+9a294lGx0iXYdyxvEOsPjg2CLVrVh4SbSpSJfD0yiisfAw1GLPuSaO1D11Mivw8+17XQvtdBngZ96D6HRf1qjDHGmM1z0UXn7ITf+MY3qk3wrW99q3g8sxwkhiaBWMx1FROI4ZkcS1ihG6Udo6aUsbYQOtzFUVfBAl3tkzHLWDWg6tuM3N2yeDJZRGeCG3cTQM4oBPNYn2WBprMrsxb8yEcgklyLH/0lV2cEMnGjfbGyUbD1JaSKx5NVtU9IDonZaJFV5uMSDAr0iWfEmAR/6XxL7RmydsMiYYlrfDz+ppALPCxj9YxW5yExiWAcMxGGjrvsa8jVWhnftd9FHhNR+K4roPOgU4Y26Dhy5TfGGGPM+SP+jtmUe3U0OEV3bjOMqqbEOtDSeWTi1jIMqmhD5cgClbFSPq1IskCrhlUVp2Mw1lDJRKK5FsiHZBovJRDDX13m9/bEVbbqECMMV199dbfs1KlTTRbuWjB3Ql8dTfxzrL9mVkNuvQgl4Ac/4oIEY/oy6IuVlThAKCg2dAgJyD5RofjjRW673/zmN3s/GxJc8bjLZNdehkWxtPStGGr3fomCMIr2IRhEUMmxPvfydWKFh1jVdTpmWM/E68mgyjL3oLwg1hG2cRBoCMS8rM8cZ+w+NMYYY8zyxN83ZOTehG6wgF4Pwjch14EGWaCpyISAxrBaSiK2BNEjehTXbTFaGauqNZFH5R/nEdOKgVYJK33WmuObdR977LFmetNNNzUdV4to1turRVwjotXRF1988cRFy8dDCZawtCEClM25FCurJFdMETqrkAXbUAmrsVinBvYiltmPRNsm6ctePkRMBsbgRklAb3MSrNinCNVVRPE63gDrxK9v+robY4wxZpj4/1s1ocd0s851pl3CankIw1UiMYyjUUi3FuhGPPM+i2d0o6zQbSmruf23ht1pDC9uX9MxhPQod1GurSW136YRr1SfixOsLdCdyb0WyZP6fXcSsYTVxz72sabjogs3/vHEP+PCTSZuj/RsBkQ0YkCJnxC5JQuiEo+tQhRvJHWSxU5Wvmi5FVinxxIkBykMOVcLqfGJfbqqq/k6139ZD4JNehoYY4wxZjWo08xvBIw3CN3asll97/d+bzUW7E9sqkzWhYrEM7ru5S9/eYWu02dKIA0YU9GFMQ5ambh5YXBVwuo4VXWo5s/INaBhzGh3pQVv3rTu3M089bnkzh1LWUXxDCplxbxGHejEJKKdROwAUByqXLsjsqwuSlo1RMyiXMqKHSFOYiwhisvvhTRCqD6jf3gtIxCj0NvFckuxfB336Vhu+X0se+/F9TwKbYwxxpx/rrrqqs7NGsGLG/cYBjh+x9air3s/pjB/JhAt0PzOr7VepwnRfRLRrR5s9KFEtLyZ69kJAjqGDBeycEe6RGLVPhk1iVgUz5F4YrkOdMzCLaj5lZdhfZYFWn7zjoFeDdWAXpY+cSVX1XUTMuVtyQw9JOT2W5g+up/vp83bSHQbHspSHlEyt2Vje7eNKE4P4nrGpGVDxHCGkieFMcYYYw6Wv/23/3YnmLFCf+5zn6v2CwnJ/uzP/qx7f+211zr+eUViHeiYHBqtRww0ebB4QczEjfWZ6R133NFoWHQlns7MozeD5iyJ5FHEM4wpoKPobcKiNQoQRwOUgbueNu/VEaDRBcz1vCiirc5TZrZ6VGLv/vvvdxbuFSDuk/JUuGSrfvMiYsKlLLLktl0qTVWCdZS5u8SQiFs1xrqEaiAD7VgkyOkv+mqZdc83XAsNPizTV5ybxOCq7vfbQqyLvUzyOdD1XJdFpchyOTEnEDPGGGPOP89+9rMrlUQCrMaI6FgjehUQz5/5zGdmYp9tfV4fiWcZStF7xEBzzXTdcgy0NCSaEs9mwoQLu54R0ujS6VmqMRhLQM/V3CL+uVSTKyQP68zwCgQHRPRrX/vaZp3Tp093dcBUH4xpvX4z7yRiy8EPesUeI576ylNFENpySVWmboHLrEQb+xoSMByPfX3iE5/oYqohWpz7rHtKYjYGcjVnn7/1W7/V65bL8o9//ONNm2jztlus6UeVWFJf96GBAbGu+/02sOz1BO4hXc91azSzXZ+I1j2T25bXGbrn+nAMvTHGGLM/iIWOIhf98OlPf3rl0la4gP/X//pfu5rSJCT7oR/6Idd/XgNcuHHdVlguyFgKMqBiUI3b1ZbnibQjmjJ7NpdcuFvRfC7OeATGEtBS93ONziciC7SENKMIcuOWeZ5EY4APvDowoozdduFente85jUzovdDH/pQYzGLJakQwggFakAP1XpmP69+9au77T784Q83+4zu4eyLZRJsbIOrtogWOsoQZaHKe7YdywIcY2Vp50c+8pHmHHNGcc5F58HAwabja8cg1sDm+nEOKlMFGojgnNWfiLxdjtPlemrgoHQ9QfeQBmG4lxfVcy7Bvcr9i0iOA0Zy7Y73DMfI9wzCm+cNL5As4Nkfy/k83usMdvAc8tmyXiPGGGOMKYOAjiIaEcz/V6zRi35rUgILqzNu27I8I5px3ab864MPPliZ1cCFWyG5ZOGO9aAheg1Q4jjWgY4gpqU1ceXGaBvk6FzM81gaerQhExocG6VMaLkWdC56rUBwRhTUOZdffrkycDcdKNO8rNCkOucm3lRR9AsRJerCWscXBT/QscgNgRhgm5LQQsDceeedjfiVQOuzFiM+8n7YHhHHNrKMsh6WcpJcSQgheJZ1012EYq0RMYvOn0GDV77yldUuoP7VgANiLlqaM/T7Llufxate9apmusz15P5nEGkdZOXnXh+6z/W8ZGKZNuajiNe+aD/3eRwU0D3PNi972cucmMwYY4zZBwhohG+MX8Yazeu5z31u839c/2sRyugMxHN298ZtG8sz4pn/1fp/fcMNN1RmObA+X3HFFU0iMTyLW1fuxoU7ZuHGfVsljvtQ5u16dio9GjJbz1ie28Xbk0SsbvhefB9OpgMzO77qeVtEdIQkYojoxx9/vNlnWw+sM+3HRGJmeSSiF1kfEQys8/rXv35wPSy0b3rTm3qttOyHdd7whjcUY0I5BiJIx5AVPIpnPh8zUzT7Q/j3nRfHYh0s7LuUoZov/Te/+c2D15ZBC13/C4Vlrifnyz24HwGqe72vZjaf9z0vMYldnIe4fpyP9178h26MMcaY9cFqzG8H3LojWKSp6/wXf/EXzQt37VjnGRDfiPAf/uEfbkR09IRlENyW6OVBxymRmOKg0XkkEFP1JcD6nLfFc1nxz4qHltFWBtwgmme2H0M8z+10jH21hau7qSzQKnSdfdVBLtzZPI+QxoVbAloWaKgtlYcYMbr77ru/Wm0xTz31VDd/2WWXVdsEVi7EKtYvQYmgdRIgKemY9qVESsuKULkcqxQTQmPTAlbtlWBf99y3kdyfnNuFLsLGvp5Y8elHDTyUjrPsvapa5jmfAPshezrtzOJan+ENYQFtjDHGjAsJxfg/n4VyRmIZ8Z3jnSW4xY033tisdz7YZs2ROXbs2PM1LwGNG7dENUJabtwYVZkS6qsa0JFonA3GW01j7q3RsnCPIqAllvP+svs2SEAzciB3bgR0FM8IZ4LGCTCXeIYooLFC87kFtDFmE/QJaGOMMcZcWCCmcdlWeChCmQzeWKpx7x4iimgGvLFQnw92SXPcdtttz5cLd7RAM40u3ICAVp4siCIaPYmBFoiBJuwXEa046BzzrA/2Gws9Sgx0STwPIfGsqUpZSUQjntvC2SQSm9ueEQqsS8YYY4wxxhizH2qR1rzWQcnJsGS7pNVytKG4UxJD1wJ6JgO3iHpQpY7zOhLPEMtZta7aM9bn1uA7GaOW1Sgx0LEdmpf1WcWtIbtvywJNAjGm6hgCxmtzfN/hEM9N6vNYhNsYY4wxxhhjDhrFRl911VWVWQxexPF99DJWBSbEMyI6C2fpRhG1plDpKhmcg7f0dIxM3KMlEYOSoI+jAW2wd6/ojW7clLKiA6MZP45OMHJRjxSNGcNtjDHGGGOMMWaDPPHEE431GaNo/ozwXSUSQ0TnHFnUgI7v5bYdl7VJxDoLdGt4jlbpfTGKgI6KXgnE8onwHgs0pvZcyipDDDTTO++8s3d0AkgiZowxxhhjjDFmN8AQqvJV5LXCSCqdRwIxGVCxQDPFCt1XCxpC0upzRaBnc3RNxqoBrR2OyaTwfhqTiWU3btKPEwieM3FLRINGIdSxdDSjFnXnHnISMWPMJiCBGJmwybBNJmxjjDHGmG1l17Nww7333tuUMC5l4NY6WKDRjZ/61KeadWMctGgTiU17VPN2xEBXs0HaMTZ7mutBK9U4rtx94rkPRifkts2oRay/ZowxY0L2bcpOWTwbY4wxxowHuawy6Dzct6MLt5BGVOJpRDQezdGrWbHQ0p1RO4+QN2yGsZKIxVpbndiX5blkgW5PulIBbBFHGOg8BZKL2jLdfI7pX/PGGGOMMcYYY7YfdFwU0VRYiqG6uHDL+hwhgRiG19YQ23wuwVyKhYbgyt3MjyGmx4yBnhHK2fJcz89th3jOmdTOnDkz03ky4cdOxdRfGrkwxhhjjDHGGLO9ZPF83XXXzSSLxohKOO99993XrYcVGgt0tD63daBn9Gc4TDcfjL3bk4Vbar4VzNNcyqqdn9mmrQE9ty9KWIkjR450Fmg6VSnPiYFmmlOgG2OMMcYYY4zZXrBAt7WgG/EcwYCqJGJRF4Is0HovfYn7tgy3ubxym+R60sZEV2MwmgW69dtmFOAQszqJkik9wiiC/Nlzna9Pf/rTe7JAg+o+Y4Gm0x0DbYwxxhhjjDG7BVZoZeHmvbyNc/yzkE7MZawA920ZbqO7NrpZ64yZhnu0OtDBCr0XlydTeseiUlZA7a/YiXQsScToaDrdZayMMcYYY4wxZvdQZSXm5cJNGSumpRhoiPmzCBGOYcIYbpOQbgy81ciMJqBVA7pq/c1lPudE9NK6CvoWioMulbBSJ4r777/ficOMMcYYY4wxZkcpuXBjLMX7mBDeqAcFXssxBBgXbrlxSzwrpLhdZTp2Bm4YM4ZYCn9mn9ECjX96zroN+LLHElbqsGx91jxWaCzQTN/3vve5DrQxxhhjjDHmGcsuaY7bbrvt+VdcccUkhufKAq3452yBlgu3RDQG2RMnTjT6EBfuuG6Mh07lrOZKXK3DRdU4zLUC4YxgPnbs2J5EdHtyg37tCGk6jKxrqr+KkFantonDevdjjDHGGGOMMWY7wfpcG1D3XvjCFzbv0XkYS++999496kAjojGoShPGZGKt53JXuiruN+feOpc77KyD9P/P3vnFzHLW9332xDHIxMSWMbUPrjCWI8AWAuTGFxbITo2UiMhNkKoDUlsolULVKmram/amlY7U9qK9aSJFrUikUmgvyNsoJD2AWgkXLBAXTi2DLDuuahkiGWMZrLicQGI3Odv9jOc7/Pb3PjM7u/u85+y85/uR9syefXdnZ56dnZ3v8/39OagiYk0Q9HqAHYgJ3er/fNddd63tWMmRjiXLqcTNkkHlhs2vZHPnQBtjjDHGGGPMvLj55psXsYAYIlriWc9BRCOeY6FpFZ/O9bQwbtGdOWQb0SydiphuKlBLQMfCZsuY/6wHJZwlpCG3slIYNwNFATHuP/PMM+3f5EDTKwybn/uuwm2MMcYYY4wx84MCYmg7iOm6amOsMG40onRi1I6xgBjGbaGV1SKEcS+DmN6Lag50uN+LabnPYwXEIppduPXWW9dmBzSgiOjoQBtjjDHGGGOMmQ9dSm7rQquImMxSUndxop999tleM6IRpRNLfaDD/1WBu1Q8rA39rhHGXc2B5p+ulVVRIEtER7ud+3EQxOc///l+Hdj4xMOX1ukQbmOMMcYYY4yZDyoeFokOtLowqbC03OdSD+jc7UldoeQ6dw/3f68Rxl3FyQ3W+LECX7EKNzZ7jldXDjQJ4bkSd26krYHF6l89txX/rsJtjDHGGGOMuZqZk+b4+3//779hpfWWhHAjpmO0ccyBBsK4Yw40IloRzdGBJgdaYdyx+nZn7i668O3DcaBj/+dIFM/d/4+9ljh2iWcNjmYb8gAKrH4GfQ4OdPyQLl261BhjjDHGGGNMLWIAcK1K0yfJE0880YpnQrgVzi1koBLCnVtZ3X///e0SQ5Yb5qzcZzo/6XlxDLiv3OdDq8ItWoWfhXMk50ATwk01NcSzHGgGi0EjgbwkopVsXrL/D40zZ348xBbQxhhjjDHGmJr85V/+ZX8/ao9DhTZWiGdEtB5TDjTh24hoCkrLVAV04iOPPNJqR/QkBaoxZ9GdiOiS/oxdomI17mZPqo6wYspzDy7AVmeZXWjEc9fP6xgkkOcwblCy+UpoH/wUy0/8xE/09//iL/6iMcYYY4wxxphaRAEdtcehg6aTrhPoP+VAixipDLjPsbPTkHgOYdztcjFQXWxbqhURy7Z43hFsdXY0lhvPxIFh1gH3mRuDqP5g8fmEcTcHzjXXXNPft4A2xhhjjDHG1OTVV1/t70ftMQeILEbjxSJiK+O1XeYQ7shQZ6dYiZtl1Mu1cqBrjfCyL3X2Y4Wv5O5oqy9zETFyoFdW/OjKmYnowrbbJZY//8kx84fIT/7kT/YhAwhobnM7sI0xxhhjjDGHB9oiOtBoj7nQtSY+ZpQSgaw03pjmO4Sin4OB26YVJ4O3iniGalW4m9D/GYbyoKPdzszBAw88cIZqarGd1er/a864wrjjzARCejWwZy5cuHDQVbhhJfSbV155pb2PeF5td2OMMcYYY4wx+7DSSX2U67XXXttcd911zaHz0EMPvUG1rN7whje0yxxpjICmJtY999zT/j9GKn/lK1+5hClLHnRed0gljp2hlgdXRKxTzrG/VjEPOsOOl8Sz7HoGLeZAa2C72Yrm7NmzzRx43ete19/nAJeYNsYYY4wxxphdQFPEFNHXv/71zRyQeKaImHRdNEpzEekoniFHNFNri1vUnyszN+rcRadXFzX6QNfKgV5G+5nw7bFK3BH1gQbs+RjrTh50TCKPA0sY9xzaWAHV8KKI/vM///O1UAtjjDHGGGOMmQpaAk0h0BpzqMAdiZW4MUql++jEBGhBljGEG/M1roP6WvR/5sb/pUGTmRtrhx1MEbGeWB6cDdfGs2RmAKs9imZyoIdg8Mh/5n6piNicYEZIBzVjtJptsYg2xhhjjDHGbAUaAi0hUYjGmIv7LCScYxVudB/us4qIRSSipSNVRCx2eIo50KnY9qKrSVUlD/rEpilUOExFxFYPLTQzgGjWTq8EddsHWq977LHH+nUweJqJiOJZsfJz6AMt+LDIfZaIpic0OQsO5zbGGGOMMcZMAe2AhkBLANoCjVErv/dyQCHo1X4cS9OFUgtjQrgVxq32x1E4R7dZ9/N4HFwOdKCo6jsh3d6PRcSAhthDfaBvueWWhRxowIWmeFhXkXsWVbgjHOAr8b/mRFNgLCb/G2OMMcYYY0wErYBmQDtE5zlqizlx22239fdjmi4ohBtiFW5MV4VwE9ms58TU4e7+mEY8mBxosdbKCoaKiSn5O8exX3/99f3/X3jhhaWSyBXCXWq4PSdobh6daNAX4uLFi30xgAo9vo0xxhhjjDEzBIcZTUCeMzohG25yntEWc6MURTzUB3qlj/rHMV1VfJpQbvKfhVKHxwpZd/pqb5FVzcHtKprJgZa1PtjKihBuiehYhZsZhj/5kz/p/59bWMU+0HB0dPSjZqbE9lbGGGOMMcYYswkKhpHzPKew7ci5c+f6Xluk5pZaWLGMxaUVwp3N15WmvBQLh4X04SbebxqlQC8OR0CX1lUS0DmEO4tn3UdE5xj4ODNByXNCuOfQB3oMZpeYWXr11VcbY4wxxhhjjMkglunzPMdq2xn1gY6FxKKIpgYWLjQCOrewQkBTQ2t195Iey67zQL7zsvvb3iK61ugf6wM9FRUQY6kBQjwzYMw+MIDccmw8zKmI2BB8AWh4/tM//dPtki8GoRhznVEyxhhjjDHG7AdaAE2ANkAjvPGNb0T7zF48gzQcUcVZPKsK97PPPrtEE2Kw6sbfMV9XhuwSU1Yh3Ji2R0dHZ3S/q7jda9LQJepwHWip/uxAs5M0tWanx0K4qcStvl+40Ajoe++9tx2UGMJ9GhxoY4wxxhhjjLlaUAi3OiuBRLTcZ0BE33PPPe39HMJNa+TSunGjOy2qVlYLGZN6vNmTmg50r/S1ker9rCchmFePXcovxn2OrawyVOJmULkhnhnsOODGGGOMMcYYYw4fTNDYTQmNR7Qx4jl2YJKhCjHVF3JasAgG7qJDodtNLWoJ6L7fVg49Xs0w9II5us5aAhXVuDEwOc5dSeTAwFLynPxntbIyxhhjjDHGGDMPCOGOqbjqtkTEsbQf7rP+HvtARzBqc/4z/w96lL8tZPDWcJ+hahD9siDtU1+uY68hfFtWfOzzpaprCuHW859++ulLuM+xErcxxhhjjDHGmMNH7jOmaHw85kJH9zkSU39XRu0yas3Y1qrTpbFL1LKLlj6cPtBS9svXGHweLrTuU0EN8RwHQsRWVlj5KiLG0u6zMcYYY4wxxsyPXAhaIdzcz12Yxjg6Olp7LmZtJ6iXix+r5hjSXaVQ8zVNBUI58MWmjYqh2xQTi3+T+8yMAw50FNFxYOU+n4Yq3MYYY4wxxhhzNYIxSnXx3AsaFJEc03xjH+gnn3xymXs/Q6dN27tRnB5aETElZm/cIBzorncX99f+poHJ4jmGcIMKiMXkc2OMMcYYY4wxh400nDRdqV1xJhcREwrhZplSh9u2VTEyuhPTe+vHKg50J+yPbUzcCSqlKXxbzvPKjW5F9AMPPNDkAmIkjuNEk0geq7EZY4wxxhhjjJk3XQ70YAHpiHRirJ81hNznwp+UF70XNatw61aEXl2Eb8cQ7pgPXaqsJvKsBIP93HPPOYTbGGOMMcYYY2bESy+91Gs4pebGHGjlQT/22GPHXot4jlHMsWUy5FpcKb14sazQz6pmFe5RS5y4dDW8lnDuBPXgCp988sl2EB999NG+FZaqtb397W+3eDbGGGOMMcaYGXHTTTctchi3cqDvvPPO3oW+55571gpLi6gflQfNfbWwiiI56eWDbGOlW79x2qEuubt3ovX3OIMQY9sJ317NKDS5oTYw0CSc33jjjQ7tNsYYY4wxxpiZoD7QEs8gB/rhhx9eRgea2lhjkcoQ04abrnCYHkNQp7/vTZWVqYWV1qdKaEdHR2eYFYjPJRc6v15trC5evLhgpgGYbcCBlnjWoCKaCd8GZi4uXLjww8YYY4wxxhhjzMFz7ty563QfER0rcMccaFXhhlIVbpzoqDVjJe7mtb7PuUPU4TjQnVXed6jWxmfxDDHvWWggJJ6ZbaCIGA40g4iVz8Byk3g2xhhjjDHGGDMvsp6TUUrkce4DnfOgZbxC7ugUKnHT2uqMwrkVHF0h/bmlWgi31H2U+YRsZwjfzq2sNBDMLHBDSBPCjQMNzzzzTD+wsvpXr1mePXu2McYYY4wxxhgzD2677bZ2GfOf0XqlzksyWJXqGx1o1deKYORi7HbLVqPS+7m7XyX6uoqAlvsc/t8uV8p/7XkS1IhotbISQ729NAtBzrNENOJ55Uyfef755xtjjDHGGGOMMfOC4tDc0HgxjFsmaiS2sWKJeC6ZtZArb7/20GK0Y9Q21ArhXqYm1WvJ2swAsINZUAOx68wkMCiIaG7kPxPzrhBunhdbVlHuHPfZDrQxxhhjjDHGzJsYxo0GFBLO2YGO4plWVrFwdadLl4UWVqNdo6ZSq4hYG2sebPG+SbUKirGMBcQI41Y1bmYSGBSJaD1HZctjLDyFwxDQuNAsj46OftQYY4wxxhhjjDl47rvvvuve9a53YZoucxsrkIGai4h95StfWcYWVp0LHTs+rbWv6nKg2/93DnQVqjnQnXh+Te53Id25ZHgpTl3k8uSqwp0TyW+//fZ2iXhW/zBjjDHGGGOMMYcPOdBPPPHEMudAj70Gk/WBBx7onyMhjd6k81N+/vnz5/s2VrHgdVPBQK5WRKyrcCYnemO/rdgLOhKFtPpA6/8MLLnQwiHcxhhjjDHGGDMvENHkP3NfOdDovqj9FI2sQtPx9bECN52fUgsrQrwvsVRV7tByeW8numYV7gVKXzHn8W8lMR0rcWPHs1QOdCxXHmPgQQ40uIiYMcYYY4wxxsyHobbEVOHO2i8T21hFQgur3mlGl6706bK7f1hFxJpuo1D+XSj3Is8CRNQLWpW4ZcdrZkHlyqFUhc0YY4wxxhhjzPxQGyvAhY75zyVijSyKiOX+z6LTn/26FL6t/+bOUbtS1YHu7rYbPtaomvDtGMKNA81tqJVV5MYbb1wQL8/MhUO4jTHGGGOMMWZ+UBQaXaf8Z5a5/hXk8G3ynzFkEcyxSHWMepYWDUXEmkptoKsJ6LhT6rVVfKLc5wgONLdSfHvOg6ZaG0tmLhzCbYwxxhhjjDHzQh2VcKBV4wonWhW4QVW4L168uJDRKvcZMxbBHItUhwjoZddmuW9lVUoz3pVqIdz8E11nlRLXjqhX19HR0QIRnYW0HOjsQjMLQTw892XvK+E89oY2xhhjjDHGGHP4IJ5xn7lR40rdleRAP/vss0sVESO9VyZrbGOVCQ60KnArLzpX4t6LWn2g+3V1PbaKbaxocp1j1pUIXgrfLvWBxtpHQBPKjQN94cKFHzbGGGOMMcYYYw6ec+fOXScHmqWKRD/66KNt5WwVEpMDHSOUYy9oDNmV3mw1JpW4eSzkQffpxa8Z0T+O7m725JqmAjFcO23gGlE8s8NY7ySC8//VwPR/k5hm5oHZiJUD3T6u+HgGWm/dGGOMMcYYY4yZBei7V155pZF4VpQxUceEcFNEOlbjRhtmB5rlXXfd1d5P4hkTt42yPn/+/KXV7UwXzi2jd2+qhHCr/3Pz4x5bPbEad4xRRzwjonGgucVWVixpZXXHHXe04dsxBxr3mdkKHOjGGGOMMcYYY8xsUBqunGeZpEDk8VgrK0UvB9Hc/02trJRGjKsrLRpyoffWkFUEtMK2pfZB4dtDPaBZyoHmplZWt95661ofaFAONBAnz1LFxIwxxhhjjDHGzAO6KVEQWnWtQCI6FhGTJowh3F0bq7b6NqHbhHBHUivlY3qxhgtdrY0VsMEqJFbqA60ZgtjCCmJD7O9+97tLnGduzEDEQUyvWbqNlTHGGGOMMcbMB/WBljEKCuO+5ZZbWg1I/rOKhxGhrILT6Ea0JJHNuNDRgS6gKOmWg+oDjWjWbYw8QwDkRTOTEIuIKWFcMfBCA6uk88YYY4wxxhhjzCxRWq4c6IcffrhtZYX7zE35z2p5jJCWA83zpS9j96dEdc1YzYFWc+ouvnwtkVtohiC3sGImQbMLeb3qA82gxvh4cB9oY4wxxhhjjJkfhHA//vjjrS6kFzSaT/nPRCPjQEPWiDmaGZT/XHpc9w+qiFiqwt0+xD95JzRDEHdauc8Q49upwM1SfaDlPoPdZ2OMMcYYY4yZNyokRmGxe++990xsX5zrYhG1rCrchHCXwrc7LapWVlTiXk6JlN6Gag60NhYxLeE8YKOvgQ1///339/9HRNP/mVkHwrdLOdCKl3cOtDHGGGOMMcbMj9CauIU+0LjQEtHoQZYyWVU3S62RS+nBnbG7aELo9kpEvxYiXSkHukofaFAl7thjq2SjR7pQ7sUjjzzS/l8x7uRAU42bx+IshDHGGGOMMcaY+UIfaLWyEjFVVwaq6mIJjFeil1cudOs+j1TgbjUmd5RevKHY2FbUcqB7lR96bB1zoJXsHdtYlUK4caBXz20fKznQxMuTcO4caGOMMcYYY4yZDxLPpbRcHGgqccfHlAOt8G050BmZtzjNCtlOy8PJgV6+Rnu3+3+jUO6o9olVz68lll33GRxuzDYoBxoYSJbKgyaE232gjTHGGGOMMWZe4ECP/f2FF15Yyn0mD1omq4SzhLTIpq0KWysyWtq0E9Z7RzfXLiImF7qvwo21rp3CgcZ97np3LXI1bgYn5kDzmIqIcT9X4TbGGGOMMcYYMx9woJ977rm1x2SUqgo3ehDxfP311/edmmLkcixKPZQ2rHxoadVOWO9twlZtYxX6Qa/txNHRUfs+ONASzysxvSyVINcAadZB7jNoYClzbowxxhhjjDFmXuBA33TTTQsVho5gnlJIGmhjpRpZ+jvRyzmEOzvQpYrbnUY9nBDujtf6V/24F3QLO7QahN6B7pb9xpdi2BHPzDgweOoDzeNyoN/73ve2y5x8bowxxhhjjDHmcHnppZeW6DjqWskYlc6j/pVcaEA8xz7QVOJWCDfasism1v89hGs34bEllbgXr8VzN/tSs41VdJP7KtyhpVWfAx1Dt+MOMzjq90UIN4OHiCaEm5kKOdDZ8jfGGGOMMcYYc/jcdtttxx6TzosdmAjjjuIZqMTNEj3JTenCcqFjuLZAOHd/Xy7iH3akagi3tme1I2dyL+hSny52mhZWKiTGDANWfWyarRmI6DbL7t+UgG6MMcYYY4wx5nCQhqMP9O233772t5i+q5RehXAjnnMBMSBduCtePWQvLwfu70TNEO6euPFjvaDJgc5VuBHPiGgRZyFcRMwYY4wxxhhj5ouM0SyeAfOUbky0ssKB5rFYRIz03y6Mu9eFpAt3xavVxqpfX3efx9ve0AdThbvpqm+HImLNyAxAXzWNYmIsGQSWcqAjcRYCiJN3ETFjjDHGGGOMOV1gnuJQf/3rX7+EA60uTfo7DjQGbG6PHE3bWGm7i5BuxXPzWgj3wTjQ2pBl2MheRGcxrRzo1eOXEM8MQo5vFzGJHJip0GyFi4gZY4wxxhhjzOmCelilHGgZr13xMLRiSUPqMWnFxVhU9LZUDeFepGZbikXPG0yONEs50VjxqrCmGQase5YUEcOFVvg27jMV2xpjjDHGGGOMMbNCBaGl6SggFlN1KSDNUjnQEaX/SkcqfDs/Ty2rtDx//jx3DyqEG7SR/X0oJXTHNlYMQkwGj5W4gQHkpspsuM4uImaMMcYYY4wx84Mq3FFEx25LtLF68cUXL2Gi5hzoDC40FMzaRWfoLlLV7WWFItxVc6DlPreLuCNDljmh3Njw6gWtGHfyoLHtGbg777yz/ZtmJSyajTHGGGOMMWa+qJUVxigGqbQeOdBqZxwdaEQ0VbjRjUoHVgurvG61rGqCqRs6Rh1OFW5VO9OylP9Ms+v0sjb/mYpqekAzDIRwM3APP/xw+3rNSoBDuI0xxhhjjDFmfsgQRTyTnlvqtIQWvPXWW/tC09zQjEQuK3xbDnSmM29L4dpVNGS1ImJUNMsiGkI/6CZWS+tmDgZnAJh5yI9JRCuE2xhjjDHGGGPM/MAUVXHoaJaKlflafF10oCPZwJXjHNKhq2jIqm2sgjXeEneis9jXRLRmD7Dj8wpVRExVuJmZ4MYgM9g03j579mxjjDHGGGOMMWYeqJOSHOgMYdyk9JaKiEHsAT0hbTjXud6bKgK6U/Ox91a7jDuBiD46OloojDvuuEK4Fb5Nwnh2oDUrwRLxfPPNN1Pa3E60McYYY4wxxswEhXBjiqLpovtM9yUKiaEHVVg6FhFT7SwohXBH/VkynA+mCndKyF5zx2MbK8qMs5TtPgW1seI+gxuLiL3+9a+v2obLGGOMMcYYY8zJgymKC61IYx6j+xL6D0opvbF7UwzhjpHP0qLZca4UwV3Nge6rcDedPZ57QMfZgOg+g0K41QMaCOHGvieEW73AFMIt7EAbY4wxxhhjzPzAfdb96EIrhTdX4Y6vlSGL3pTmjLnPJbHcpRsfRhXusCFry1BATDtYfL1mEhiYKKKx7xHR+flRRBtjjDHGGGOMmQfKgYaVSG5DuOVAo/9YYqaqDzRII3ZtrNTCam290bCV+xyFdHf/MEK4A5Tibh3pUk+ujPpAc1/imWWcbdAgRoiXZ7AbY4wxxhhjjDGzgvBtlkQUI55zFW7Ct2MrqwjmK+KZqOaBwmEt6NIopA+uD3THslTdLIRxrz2uUG5EtMSzZheovJaJA/vEE08s4+yFMcYYY4wxxpjD5rnnnmvDt0utiWP0MXrwkUceuSR9SNqvIpfRlbG7E4wZuENh3btQKwe6XTShnRVMcaFXg7eMOdCxEreeoyJikdtuu62JBcWMMcYYY4wxxhw26Lghou6jCjfaUPpQnZuAzk7clP989913H3Ojg7HLOjF6FwdVhVsbI2XPDqQ2Vv3zV7MFaxseB2MKmq2wA22MMcYYY4wx8yP2gJYxquLRkCOSMV2V/ov7zC12eyqZt8vXaEJl7sMJ4ZbClz1+/vz5fuO6mYH2PnnPq9mC/m8ahDFiFW6WDDZx83agjTHGGGOMMWZeUM+KwtAS0aUi0TjQ6gUNmK5EL3NfDjT3JZyzA93lPfeoVlezJ9UEdGz+3JUI7/821sIqhnCXUB/oKJaJmedmB9oYY4wxxhhj5oXaEY91V8KBzi405mtXiXupVlaxhVUkFA1TCHcV7VjTgR5V8wrh1o5GFMId+3tRdY2l+kAjlqPND3agjTHGGGOMMWZ+0FlJ93MVbqAmVnSgAfOVQmJENyvCObRMXhaqci/i7aBCuANS+Wuwg9js0YEeC9+mdHn8P+HbmqEgB7pUtc0YY4wxxhhjzDyJLYxpbXz99devaT7cZ+gKiLXLVHcra8T+/wdVhRuW61u0yFY695XsLReaGYQoolWiHGIvaGBWIs5MxBkLY4wxxhhjjDGHD22suG0CBzq2OY5pv10Bsb6VVS5gHbOL+zuLOvLxmqYCStDWkseihd6VFW+6x4/lQZdgwGIfMMCFJoyb/GeKiK2WjTHGGGOMMcaYeVBqY4XOk1mKBoxOdIBoZoVrxxBuFmvPj2K506jLroDY3mHc1dpYxWW2xykrrvtRPONEq5IaMMMQ49xLA0cYdyeeF86BNsYYY4wxxpj5IuH8V1YiGvGsXtCqiRX6QPch3FFTdvnQi0L+c0unURddoeuDzIEetMdValxkJxp7Pldai820NbiI58YYY4wxxhhjzKzIJuhf6dxnbmg/ikiDamLFNF8Vn1bodiwgFtKH25pcof9zfHxvqgjo4Dgv9f9SOXHlPpcqcWeYcWAGotQDWgXEzp492xhjjDHGGGOMmQdqRRyLQkvrSfsJopNjpyZFLxO23YVxr2nOToeicRehtfKiq9dVxYStGsLddBul/w/Z6BGKiOU+0AwUMw6EcCuMmxkJVeJWAbHnn3++McYYY4wxxhgzL9B0uU1xrsJNdDIOdBTRgtBt1d2S7kSHdoJ6TVSrTleNStw1Q6HjulqFXxLQOYwbVIk7DwyFxJ588smm5EIrB/rChQs/bIwxxhhjjDHGHDznzp27jiV1rTBH0XZypUEiOnZl+q3f+q1L9H8OOdB9GLcotLBq6QR0e7epQNUc6BBjviaEh3Ymo/h2HGjEM/cVAw/KgVY/aIdwG2OMMcYYY8z8UF0rxLOMUsBA5abi0mhEcp8xXRHOEs/RmM1ONMhtTtHSexvIVQU0G9eVB18j7kjMf17t+CL2gRZY9bkPdERWv0O4jTHGGGOMMWY+lDopySgFDFRuKi6do5TRk4jn6EBLbyp8O7jOLcuOpoILXVNAtxsz1qA69uvqdrxvY8XAxEbZcqAjmplwFW5jjDHGGGOMmR8vvfRSX0RsZZoO6jrpwViFG3InJ0hVuBe5vfLiNZoa1M6BbhtUs3FDBcRyDnR2oC9evLhgtiEKaKpx675ENEnnzoE2xhhjjDHGmPmgHGiIlbjlQudCYiyjiJYB20U2t/djNe5C6HbTVMp/htp9oNutLLWwErmVlQYAcKCzeCb+PaMQ7phsbowxxhhjjDHmsBkL4aYPtB4riecIkc0573nFcsBpXnTCem8D+ZqmMrHCmZK59TfcZ5K+QdZ7KQc6QgVuZiFwoWNy+Zx5+eWXm3/8j/9xe//v/t2/S0Pw/m/f+MY3ml//9V9vtuE973lPv75N8Dze/5d/+Zfb2xS+8pWvNP/pP/2n9r6WNYj7WnO9xhhjjDHGmHkhrXfLLbc0X//61y8pB3qMu+++e7FytC9JSJMyDEGT/riCWKVK3NXbWMWE7ZjMHe734hkXmvuIaEK3r7/++r7HVw7hzuJ5riHcuOcf+tCHWvEIn/rUp1oRLRCrP/dzP9dsAwL8y1/+8qTnUsF8NbPTzticP39+0msQtx//+Mfb+zV6p4m4rzXXa4wxxhhjjDlMYgi3WlnFImKlNla40Cvt0FbjXi0v8Zhqa2VWGmcZc6C7QtfVBHQVB1p5zxJBLFcb3gteiWdmCORASzzrOYjn0rpj/rNAPD/33HPNTTfd1MyJ3//932+FKA7wEBxAQwdDRjMsautljDHGGGOMMYcMOu62225r859Xt8mvQzyT/ouGVAXuZNTqMRYqcL3olirW1exLrRDu1h4vJWrHEO4nn3yyt9FjCLdmE/g//b6w65999tnlHXfc0b+WWQm50Az2atAXTcVk8JMEpxWXGecXELyI6JKQ5m9TnOEY8jxVcBtjjDHGGGPMIYApGouIgVJ3X3zxxTaEG21YMlrV3SkXrk61uNb+1onVw2hjVVLyhYTudkdjvy5gFkHiWUXEGKgonkW09qGUgH6IELYt8YyQfvzxx5uf/umfbvZB7jPrswNtjDHGGGOMmQM33XTToIZDPCOi0YKk9KINYx9o1c9CPFNfK7jOyyCeY+7zWmXuGtSuwi36HYlL7WiuxJ0pJYzjPuc86LNnzzZzgCJf5DqvDoJ2ecMNNzT7gPusSuSH5j7jqpPfzTbivI+Fq28L+0wYPDflkG/zupPYJmOMMcYYY0w91IUp5kBn0JQYsxLNuQsUgrkzdFu9Wyv/GWrlQLNRUekvYjy6lrkHdHh+O7NAcjjLzoFuB++tb31rX85cAhpBtHKum7mAgOZWi0N0n/lM/sk/+SetUM2wnQj9bbZVxc4ojsZ91vHII48cew7rjUXYIohsqo7n12mb/t2/+3d7T2YYY4wxxhhjpjPWihj3+e67727v40AjomMbq/vvvx9NuRbVXBDRiyCYe40ai13vQ7UQbnKyuR/DtuMsQLyv/GcVFIM4MArfZvAYRFpZxfd773vf2/7/+eefb642yI8+NPcZobr6THrxzGRBbM+F80u1bW33NvAaXosIRjCzTq2Xv1GUrZQzrmrnEs9sE227NJHBNrHNdqONMcYYY4y5fFBEbEoqbsmBRlP+1//6X1tDUaYi5F7Q4X71lN9qfaCl5qNQjjuiGYFYeTuj+HYN1te+9rVFFM8qJPb4448vVw70Ymz24jSCKPz0pz/d3kc07uM+IxynCtoxkSmhynMQp5/73OfWtksCWGJ3arstwWtwiXld7Jcd24Hx5YnCGugvzXPYFrnY8bUSz7w+vs4YY4wxxhhzcpADjY5TATFpvEcfffQS2k9trDIUnmaJCbtyoPvHY+Rzx6LkNtdwn6FWDvSkrYmOacx/jonhcqKx7HGgFb4NCuG+WotmKfeZ/f/Yxz7W7MNv/MZvNG9729sm3QjNHkKOeEmogh5HBJN/zG1bCLXOIje/X5yBAuVI/9Iv/VJxmxD63/rWtyyejTHGGGOMuQJQhZulNJ7Es9oYowdZSitSeFrFp2NqsIxabgjn2PO5Kx7WV+VW1PQ+1BLQii8/RnSkVUAsimcseIlm5UBznzZWLBUDHwuIabBXTnV1S/5QQaQeYu7zH/zBH7RLJkeG8omj4C/lSI+BwB3Kceb9fu3Xfq29n4uDaXwI4S457azX+c/GGGOMMcZcXhRFnFtYgcRzRFoRB1oudO7spA5QwWU+1mY51O3ai2oh3M26C90na+dWVjmEGwv+e9/73tqK1AuaqtUaxNgHevX8NoT7asqBVp6vCmftC+uY0m8acL4Jpc7g8kq0DglV8c1vfrNdIrgJr54KDvIYiGs55Iho8pz1OOHubCMh5KyHv9lxNsYYY4wx5soT+0DHdsV33nln88ILL6zlQMeI5RVLOdAI6VhALIvk7v/tc2uIZ6gloGNT6kUzENLNDmpncaER0zjQWdSU2lhdzcTc50NqWxUdX0T2tq+ZwiaXmL93ldrX1s0xRZg24prxI2SdG+xSFdwYY4wxxhhzshDCjXgGVeHmfnShEcsrTbmUCx07P0kkK4x7ZRj2OpXw7UNyoOU4D24Q4cdR/MVK3HKgNbOgeHc10s4uNMJnNWPRXC1FxKL7PBTOfKWhv/WhoarbONNMQCj/GrFPKDlO+L655MYYY4wxxpjpUIF7SMdJ/3GflF6MVbU71nMknqO+7FJd5UT3bnOXTrzsxHNTg5oh3HBsq2Sps3PsTGxdJZhJUEI4RLu+FAcvppQ/nzuH6j5DdIdxfE/C0d3kWPN33Gcovb8mHbjxXIQzxyHjSo9oQrudC22MMcYYY8yVIYZviyeffJJaWMcM2qglO325pjVVfysJ5qqasUoRsa66WfGx1Mrq2PO6EO72OXFmQS50LGOuHGgVEbsakON8iO4z7q7E56biYLv2W1aRsiHi+6rH8xBsK2P4+OOPt/fZpqmh58YYY4wxxpj9ie4zug6NJ50n7Uch6VIf6O9973ttCrDSgnPbZJalYmG13GeoIqBLG8RjsQI3xHLjqsSNeL755puPDY4GjNmHDMnmFBJrTjmEHFOcCw7NfRaqgk1+8VgRMdxeWmJtW4V7rPVVrEyeq2rzmqH2Wzzv3e9+d3t/V2FvjDHGGGOM2Q0iidFzuYgY0cfSfxiqt956a68fiVpGN3Z9oAe1oGqGdf+Nz1s2FdzoWm2sjqFS4qW/qYDYasdb8cxMAo/HHGhuxL3nNlaIJmYqqMJ92nOgVfn6kHOfEcZsH58L1a6ziEag8hzC0PnbLoL1Qx/60DGnGIHM43q/mIPNe/A3cpzjc+JrNTGxybU2xhhjjDHG1AUdh57Lj+NAS//B5z//+aWilDFepRujMSuieds1gI51utQjem/9eGICWs2sdZ+lXGcVENPj6ucVQ7jhjjvuWMQCYiwRa6WeYacNBGNJHB4auLlUu5aIxmV+73vf2zrCLPm/ql9TDG3biQD1l2YygXVpvYh1WlRpvTH/mefLscfx1usoKsbzeC0gntX2yhhjjDHGGHPylOpYySyV9lsZrWtFxPS8oT7QOfI5JkCvdMGZ9NBeVBPQUvQlVR9Ki6/tbFeBu98TDQ6DxVL2/R//8R8f6w922omhyYfeuxgh+uUvf7mvaI2wxeFVn2i2n7/vEoaO4OW1rAOBrvXqb4j30npxvXmdHGZeRz61Co7p78YYY4wxxpgrS9R5aMCVw9yaqfE5iGcVEesKjLVk8ZzlqCpxc7+GiK4iw7WRbJAqnsXwbVVHw2pX+Lb+VhLQEFtZ6TFmJtTKijDuG2+8cfHJT37yh405GBDMCFzELk4wAnaX6ty8BrGL+y7XmnVKlLPeqeHXvE431huLnxljjDHGGGMuH/fdd991t912WxtVjKZjKQEdC0jHImKKVI61s2TMZgEtut5V3D1WzXsfagroY7Z414drmXOhu3ZWa4+thPUClxERrabZWUTL2gdV4j46OvpRY04dJQFtjDHGGGOMmTfnzp27TvdzETEg+pgcacK3QeIZB7rTl5e6elprvaAhiOlWP3NHGrWrzt3ebfagVhXuUkz5sdLiONASzxQQ0+O40BLPeuyxxx5rl6U+0FdTGytjjDHGGGOMOS0899xzo3+niJjEM4aqNCJFxEjLlHhuxmn1aRTMNcQz1MqBjrnPednDjoYCYpcI56aPVwb3WTHvyn8uUUpAN8YYY4wxxhhzmBC+HVGKLvfvvPPO9jFFIscw7vvvv78N4UZDhj7Q/XpSKHef99yEqOsKRbjrFRELDvRa7vNQTDpCmhszCXpM9jzuM4NFMbG3vvWtgyL5tLexMsYYY4wxxpjTCOHb1ChSnSsee+aZZ/q/S0QL3Gcil2P49gAK3150/5FwXtYoIla7Cnd7l5v6QA/1ghYqRc5S9jyWPQOGC61EcrnNuaevOZ3QXorc510KkBljjDHGGGMOE4Vwk5b73ve+t9eKRB5L+2GkYqhisHKLqb6AAy33WYZt0J1KL16qkNj58+d7Qb0v1UKgVX276RpWawdyEbEu0fvMaqeX5EGzZCaBQdHgxNmGXIVb9xlwRPWFCxdchdsYY4wxxhhjZsBDDz30BkUSy4XGNBurxJ2rcA/1gVYR64G3rhK9XM2Bbgox5iWw3JX/jHjW4xqUIaJ4NsYYY4wxxhgzf6J4FvSCjvnPQi2QlQOdU4ZXTnOf+6x855j3rMrc+1BTQDfLlJVdamEFyn9mAEp9oJX/HF8TB1VVuM+ePdsYY4wxxhhjjJkHcp9XOrBvYRXNUiKQqcStqORotMqBxoxlmdOGQ99nsUyVuA+mCvdiEXpZoaOjeNaswGog1sQ0A6Ac6NzCSlW4o4Wfef755xtjjDHGGGOMMfOBPOiVFmz1Hmm5MXybG2aqDNWoE2W+xurbUDJuC2K6SkTzNU0d1sK3O2Xfb6B2ZmXFrz0e0cwCAyTxPNYDmhmL1eA6rNsYY4wxxhhjZgStrGL+c9NpxJWQbkW0+kAPQQh3zIMuRD139cMWUaceVA50rmq2tgNyoFVqXJZ7Caz6Ury7YKAZcGYs3MbKGGOMMcYYY+aDqnAH8dwSU3ZjUemxEO4RJJgXIRd6cUg50LFR9TLnQmtGQFY7+c/62+r+2ooQz4RwQwzfjv3BHn/8cQtnY4wxxhhjjJkZN910U6sFFcIdQf/lKOTcwmolno+FcGc6OdqKaPV+ZnlQOdC6Eza2Jec9izhroDxoMWTZK7mcfmGEcKs3tDHGGGOMMcaYwye2sGIpkxRth3imHzT/l6kaIQcaAzZW4dYy5kF3Yrm92700Gr57UbMK90LOs1Q+dHnP/c4pVh0XGhFNL+gHHnigKIQZQLnQDKwGd2XpLx3CbYwxxhhjjDHzRpHGWdupLhbgQmO6KoQbSA8Okc69oM7R0N3fq+ne2g7uscJhGc0WIJ4Vyq1qarLnFfMe7fsYws19iokxS3HhwoUfNsYYY4wxxhhjDp777rvvOmpaEVGsHOiY/ywDlSrcikxWHnQU0BALiUFn2qIhLzXHtW6rraPZuwtVHej4n9jQOjzW34/iOYdwq4gYg3fnnXe2j2Xx3BhjjDHGGGOMmRWI59jGSih0Wwyl9XZRzEuWUXOG+1E8y5BuhfW+4hmq50A3hdhy7QyiOc8SMIswFMINL7zwwjIPpjHGGGOMMcaYeaI2Vvo/Julb3/rWXhOqB3QJNCVRzRQSi1HP3E9R0MtYdbsQ2b0TNatwi3Yj2UAJZ+1ITPgWVFGTA401T7I4t9jKSoOpImLArMXZs2cbY4wxxhhjjDHzQcWgc2Sxwrdj/nNsY6XUXxWkRm8Wilbr/20faG5d6HYVBX1NU5G+W3Uhtryrisbd/g8pD7rNgUY8jzXOpl/YyrVuZy0oJtYYY4wxxhhjjJkNL730EkXDFrESd1fzaq2V8RBqY4VRm4tWSyx3S1XlVm70wbSxaoniOdrnmhXAfS41vdZMQpxdKBUSA2Llo91vjDHGGGOMMWY+YIZmYiGxoRDuWEQsRzajP6ORGxOeYyj3vtQsxtUrenWzOn/+/LH15x0FCWi4ePHiAgcaAZ2rcOu+rH5X4TbGGGOMMcaY+fDQQw+9gZZVQ1W4KSJNHSzuK623VIVbtbXU/7lQxFquc/z/3lRxoGNls+Y1sb8ohHC3Sxzo6EJH8QwxfDva93FQGezSrIUxxhhjjDHGmMNF/Z4lngGzlMLR3BDPsR4W4lntjleieS0HGmLkcyoUdiKdm07Ege7uH+sFXXKfYagPtCg50e4DbYwxxhhjjDHz4ty5c9exJC0XTccymqWAkYqIVn0sOdAUn6YwdezsJAc6/p9lyIVudWqNFlZQMwe6d6CbAXu8lP9cIs445BxoUAi3q3AbY4wxxhhjzHxQBW6KQ5dqWyGelQOt6GSMVsRzbn88Ip6XKhyGcO7Co6so6JoCepHvswPaiVCFu0X2eyQWEQOJZ/WBxn2Opc6ff/75xhhjjDHGGGPMPFAIN8Whpe1ivSuQyBboxIJ47iOeUyurnPv82oOVGkFXrcINccNiM+ujo6P2vbDbcaKfeuqpYzvAzIJ6QQOzD9xiU21mKVyF2xhjjDHGGGPmx3PPPdcuqWsVH5dpmok50N3rFqQGR3OWVlbBjV4M9Hyu4kLXFtDLWD0sVkIL/bka9X4W2PEsNTixkFgphBu73xhjjDHGGGPMvLjppptafUcRsWiMvvnNb+616cpRXntNjFReacdLLNGVOM/SnKkSdxbLy7TcmWoCunOej/XiyuXEs3hmBiHb8UMouRy7nxkL50AbY4wxxhhjzLwgRDum5qLzFNotA1VRyRnpSRxoTNpcuDrRC2rlRDd7UktAH+9bNUCsmAZyn6MLPfRaYuMlol955ZWFc6CNMcYYY4wxZl5ILJciixXKfccddyxuvfXWQY2pvOdC/+eIXn9wDvTgBqWqaH0/aEEZcvjEJz5xhvBtbrmNlQYR8awEc/eBNsYYY4wxxpj5ol7Q0njoPoVv05npu9/97mB3J6UIS2/mitxdhPSyu1utCvc1TQW6Hlv9EnL4tnYmh3ALOc8XL14kB7otJMasQywilquzGWOMMcYYY4yZD3KfRTRJH3zwwcUzzzzTvPjii22eM7WxVGia/ytqudOUa+vJodyLrgl0d5eHllGv7koVB1ob1BRyoOOSHc29oFf/b+6///72vgqI4UAjnnmsVETMGGOMMcYYY8z8oAo3OdAUECMPOqbpvvDCC20XJrRgLCwtqJ2lCOYSwcBtl4tFn2kchfReVK/CrTuxGpoey/nPwCA88sgj7X3NLGDXs6SBNgPIfQaWGPmYbG6MMcYYY4wxZj6QivvSSy+14jm3J8Y85YYeVBExacSbb755yY376EpaWW14q9Zxlgvd3d9bS9YK4W7VfA7jLjEUwg3q76UcaGYe5EB3ldkodd4+97QJacbt//2//9f8xV/8RfOXf/mXzaVLl5pKvb6NMcYYY4wxMwI9debMmeYnfuInmmuuuab5yZ/8yaaGe3oI4EDHelZyn5X//OSTTzYrE5WIZB5eKoSb7k0S0BvE8zLq06aLkh7oDb01NUO4taUbnx/DuDUIwMBwY8bhlltuWQyFb0s85/j5OYJQ/rM/+7PmBz/4QfOjH/2oefXVV1sBbfFsjDHGGGPM1QlaAE2ANkAj/N//+3/bJdph7kTxTISx8p9V90ooKlko/1mUopuFxPJJaKqqVbhzULnCuDf1gga5z4L4d1XfBgY2FxEjdr6ZKXyYEs6vvPKKBbMxxhhjjDFmEMQ02gENMWeihstVuDFQVYVbLawUwk3qLy4093NdLQias6+4HeTpspbeqhLCneiLieUiYrSwIumbHe4KisXXtEQhzeCtnOiGSmyxOtvcYeZodXAcm0EiPEM3Qja4GWOMMcYYY64u5EDLhWYpMN9I/fypn/qpWeoFRREr/1kh3KD6V1BqYaXo5VyFe6wXdJdivGh+HNq9l5KuKaDHZgFaENJPPfVU/39VUNNMQob4d4QmxJkKVWw7e/ZsMzc4+FfbviaeEcyvf/3r26UxxhhjjDHm6ga9J2Ptda97XVsn6c///M/bJciQoz4UedJzREXEokm6EtO9iKYuFmHcsY0VxFxoUP/nuIzvE4Oka+RB156yaO3y7Dzn+zGEO7jQx8K4Zd+D7H1gsBHUzz//fDMnONCjeObDpDAas0cWz8YYY4wxxpgSaAU0A9pBgjBrizmDCy0nGhMV4awc6CieIRcSi9ozimfFbCt0u0oPq6aSgO7KgctGXw7lPkcUtx77eGlwVIUbNAMRrX3A+p9TETE+uBi2TbgFXwJmlIwxxhhjjDFmE2iHGLotJ3pu9ZSoxL1ykpcUEYPoQmOiRj0YiZHL0pNZexYE83JZcYBq5hS/1qFaNcObddc5ksuOayCiAx0HjWTyOKixhdXR0dGPmhlAsj/5CsDwcODPNdzCGGOMMcYYc+UgLTQKZ4Q17vQceOihh96w2vZLKyd5QUXup59++piF/uKLL16ipXF0oanCLfNVFbipsbXSnP3rkgMd21gtm0LK8S5UzzqP1njcgZIbTfh2Kf852vSxDzTL1SD2z59LFW5mhiSegXxni2djjDHGGGPMLqAl0BQCrTGXUG6iiBHP5D/jREejlOhjbvfcc0/z7LPP9uL54sWLC6pw63kYstyGxDOQ79xNMGhgDieEO9FuKLcYhy43mh2N4dsxAfyxxx5rl6vHjm2XBnblTNNEu33NXEK4SfgXKgRgjDHGGGOMMbuCpoh1lKJhd8jIBCV8GxEdU3VlnhKNjIgGopSvv/76/jkr93nRLY8VrE6R2q2326UbwzLc35laAjo22Go3VEZ0aGFFbnT7WKkPNDBIiGjNNoB6QceBZcaC5RwcaD5ESs+LOFNkjDHGGGOMMbsStQWaYw650DJBYw9omaXSfqCU3lxEbGXILrN4lmlbqhMWHtu7hRWcRAh37zhHG11CWjtban7N4CCiNdugGYg5Q482QaiFq20bY4wxxhhjaqBWV4B4jtpjLsQK3G9961t7/af859ypCXJNrVx7SwW44/1ahcRqVeFeS9YeQjHqst1FDOOOxBmIiJpuzwH1aoNrr722McYYY4wxxphaRIMuao9DhShipeTG4tBDRAdaLZCzAy0kpDtTtw/pDnWu96Z6Fe6OZd7ImAPNEhGN/c79WEiMGYZYgZs+YJqJwNqPg8zgX7hw4YfNAXPx4sW2Sh6437MxxhhjjDGmJohmKnIDEa/XX399c8icO3fuOt2XMSoHWi2MRakXdDRfB0K5pUX1tz4HuqnASeRA9wof0ayb/h5KjrfV0DSLANGeVx60xDNimYGN7vPZs2ebQydWw3PlbWOMMcYYY0xN1BMa5lKJW2QHWim8LGNdLKCNFeI5pgLffffdfb2t8NRo5KrVclOLmiHcfeK2NrjUukoOtAqJqZdXhJkG5UELks2VXE6/MKAid3PgxA+rVtiAMcYYY4wxxkAU0HMoIkbrKiFzNLayApxo+kDHx2hjhfmKjsSURUeu3Ox2xiDlQGfnOba02psqArqT+MfUfU7mzuRCYtGaVxh3tPFl7WvQ59IH2hhjjDHGGGPMj1EeNKDzcv2rUvi2ekFjyq7E87KkN4mGLonlWmbmiTjQzUB8OW2sYpx6bGdVqq4GsRK3ZiY02HMI4TbGGGOMMcYY8xqKJlYbK6HU3amdmNCSMeI53j9//vxa3nON/s+ilgPdLrr/LsP9fkdYqgo3UEQsOtDMLJRENDMRuRe0Bvv5559vjDHGGGOMMcbMC/Kfv/3tb7caD6NUmo8l+c+PPfZYw60E4dsYs9GB5j6+Lto0iGk9Vi22vWoRsW4HuK31f+7E81oVbipwM2sQi4iJOFB33333sSrcU8qdG2OMMcYYY4w5LJSGq6hiNB4iWpoP/Uf+MzfqYmWTFf0YNWTBeV4Ty8HsraIhawnovrK2qnA3YQPHcqGZPaCiGjdcaMSzCojRwiqSq3AbY4wxxhhjjJkPFIdmGUO4cxExHOhchZsK3F0Lq74St8xZQEivBPQyhGsv47LLi95bRNcS0GIRqnAvS1W4S5AMroRwxDMFxEgaZ/bBGGOMMcYYY8zpYlNUsUxVFRFbOdYLbrGO1kpIX4pmbSoUptLbVcO4r2kqoFhzdazW45uqcEdyD+hctjzOSmD3r2YfFi4iZowxxhhjjDHzQR2V3v72t7fi9tvf/nbfaenaa69t73f9ndv70om/9Vu/dUktkBHRK/e5OTo6Wjz55JPL+PwsovVYLRFds4iYxPPgRkWLPcPMgmYXEM/RsieRXAXEIFdsM8YYY4wxxhgzD6jEjQNNei7ajrDun/mZn2n/RhSytCCRydKJilgGCogRxo145v9aysAd6vlcoxd0zRBubeyaSM5h3Ln3c0SzC4RvI6JzDrSgWhu4CrcxxhhjjDHGzAe1sRLRKKWQGG2s0IJK65VGpGYWSwqIYczGDk+g4tXclwutpSKma1CtCvdyQM5rFoAe0BBj1oE4dt2XA81gsWT2gQFkIGMIN+HbLB3CbYwxxhhjjDHzQVW4RdR5P/VTP7XkhgONeI7PCw50UXdm41byNIZu1xDRVQR0l/vc3tcy5z8zQ4DVLrtdj4dqamsOdH6PODMh7EAbY4wxxhhjzHxQFe4SMQJZpqpMVpENWZH1Z8h7PhYlvQ81c6DXYAZAt+7/rdXOrev/3Fvw3CSe8wBFsoi2A22MMcYYY4wx8yVqPHVhUkFpWhxLJ8p0FWP1tUQodN3+t6lA7TZWY1nZa85znDnAjpdwZoAYKIGFr/vY+7HcuR1oY4wxxhhjjJkPqsItFMJN4Wg50CoiplZWQOovxqsgsrmZxqIL567Sxqp6H2g2DvtcS/2B+wrj1mMI6lhNLVbh1mPkQLNkYJmdoFIbNwbeDrQxxhhjjDHGzAeKiNGWOD9O3Stu3I96MEcoI6LRlKqxVSLkPy9D66pFjVDuWjnQLPoeW+fPn1+WcqFls8uJxoXOVjxoxiHGwEdrHxeagbcDbYwxxhhjjDHzQkWhIeo8XGjdj3WxFMZNH2j1gsaczWnDEs6hPteiWyy7otcH1Qe6+P+4U3GmQCIaKx4RTVnyixcvti+UVa8YeNn6WuJAs7QDbYwxxhhjjDHzQpW4VyK57bYknYcDXWplXKqT1bWyWhwdHfWadmXksp78XP6/kJhu9qSWA714bbG+rYhmOdBdX67WddYN+x3xvBLWC0K5JZxVcU2UKnAz2I0xxhhjjDHGmFlBJW7CuB9//PFW55UKicW6WJD7QCs1eCW4+9d2TvQiVeTuc6BDOPfO1HKgper7x7qc5zWRi2iOOdCy33PPrlIbK4gDuxLZS4dwG2OMMcYYY8x8kPtMGHcM5RZyoDFX5TwrUhnQkEQzxxzorDtJKS68dRUD9pqmLn2CdhbF7OBqx5ax3DjO8+rxS83IzhAHr2Ty2GTbGGOMMcYYY8y8IA13ZYa290nNxSRVwej83NjqmIjllWvdRjBnYxZiHnRn7LYmL3dk+DYVqFaFW4XEcmUzxaST5C0QzixXYno51Ah79Zxjj2lQYysrY4wxxhhjjDHzIEcRZ/Es8zSn9RLCrQLUEs/RtJULrd7PzbpgLuVG70QtAd2Gb7PR3Qb3O6CYdBzou+++uxfOYysj3v3zn//8secwuDH32UXEjDHGGGOMMWZ+qDD0t7/97bXHYyVudCHu80o8N50DLT0Z62ytiekknteqc9egZh/ovnw4IrowG7BU42ti1lWFG9QLOlZXo/cX8e+agQAGl9xn/T/eN8YYY4wxxhhz2MgEVVTx7bff3v8N8awiYtTFIg+aMO6VXiyuq6Q5F6/Rpxa3/3Qmbw0hXasK9zLc7zcsJ3Njtctu76pwt/fvv//+9u+KcVc1bvipn/qp9jkx/1mzFa7EbYwxxhhjjDHzoWSCxjZWLFVILBqsqsIdUbpw6AUtfZh14rGi17tSqwr3mkWeNyzuDHa78p7Vykoh3RoglSxn9uGWW25pn0tcfJydAFfhNsYYY4wxxpj58Nxzz7XL2267rXehiTRGRMs8RQfeeuutCxmsoKhlUBVu0oVL3Z8gPpbrdO1DlRWFSmdRSC8Ukx43HgHNDktEU1DskUceaf+mASJhHMteieN/+qd/ulaFWwNNCfQLFy78sDlgXn755f7+DTfc0BhjjDHGGGNMTeakOR566KE30Aea+4osjkXEJKJja2MZrbmIWCZ3gmpCJW6ipg/NgR5V+NqZKJ5hqKAY4lnuc0wkB5puN8YYY4wxxhhjZoXEc4ms+yCGcauIGO6z+kCXKnE36xW3i1HSu1Izh3gRnOim5D4DlbjPnTvX50Gz1EBEB/rZZ59d4jATB88sBC40DjT2Pg23sf6x/Y+Ojn7UHDB2oI0xxhhjjDEnyRwdaLnPIAda7jPgQBPG/d3vfncZRfSYC11woDN7G7G1iogVH49lxQU5z9GB5v85IZzBogq3KrAphBuUB414dhExY4wxxhhjjDkdRN2HqYp4HnquHOjw/76NVa2K2yWqFhGLtngWzvn/oZBYmxAu91kFxASzENnK12yFi4gZY2rAueTpp59ujDHGGGPM5YPaVrjPqnWF9lMFbiKS43MxXeU+kxZ8dHQ0ZKa28jRo0yis9zZgr2kqEEK314qH8YBCuLvH2udkBzr29aKFVSeil29+85vPIJ7vvffeMwwst9Wg1uxdfdXwne98p/nDP/zD/v8/+7M/27zlLW858deaefDoo4+uTUg9+OCDzfXXX99cDfz7f//vm//wH/5De/9v/+2/3fyzf/bPGmN2IX6P3vjGNzZ//a//9eaQ4bz+P//n/2zP8asZ//axt7/97e05/tC33RhjzHwhfJt0XH5zMEZXt4VCuLsaWO19IpKbEHKN6fq9732vDeFGT3ZpwcdShgu5zoukV/eiioDOlGLPZbFLPMdiYvSBXtnzbYK4nGgNGDnQsSqb3GdV4jbT4ELpX/yLf9H//1/9q381WQTv81ozD/7bf/tvzR/8wR/0/19NWl01AlriGf7Lf/kvzd/5O3+nOXv2bGPMtsTvEcfQoYrQixcvNv/8n//zVjxnON/zPWD7mUyykDbGGFMb6lzddtttS/Qc2o60XOm9Z555Bhe6fR4ONOZqCfKfV8JZxcSWpTZWEYnq1wpxL/YS0bXd3H7Dc/4zOygknlkyk0Abq4J4PgbWvoWzMaYmJz1R8PM///PNu971rvb29/7e32vMbngc64B4/pt/828WxXMEJ/3Xfu3Xmv/8n/9zY4wxxtRGvaDhT/7kT9oQbqXtKg9amjAWEBMyZ2MP6CyiQw607uwtnqFWDvSxDTl//vyxmYCQ99wvFccODA6V1mLPr1iJDZiloBK3W1kZY2rwG7/xG21EBUIax83usznN/Jt/82/W0jU47n/pl36p+Qf/4B+0KQw5uujf/tt/24Z4G2OMMbUghJuC0BDNUSKPWWb9J5MV0I50cIrmLJQioDuNqj7Qy05Q723G1nSg1zYam1w7EntAq9w498l/jjA4sdIaCeSxElsM5aaV1VgPMWOMmQL5nv/9v//35utf/3orIIw5zfzv//2/+/uI5d/93d9t03L+4T/8h+0EEt8FxHQEEW2MMcbURN2UMEWjxhMqIKYC0+hEdW5i+dRTT/UaEa15dHRU0rWLWDQsCOq9qFlEbCGbPPaCjs/rnGdE9ILq2yxXO7/mQGuGAReantEUNsHOZ0ZC1dkQzyyJn2+MMcYYMwkmrnGgyXWmeEsp4gIxzd//1//6X+3/YxFJY4wxZl/QcCut197vWhT3mk6674477ljLgUYnkvrbvCaA5So3nZCmcveaMEaXnj9/fpFd6KYCVQR0qY1VJOZDU24c95n7UTwzk/CJT3zijGYZiHnHgV6J6GM7Shg3dr8d6MOGtkBqDURFWi7W5lp8jLxBwhi1P+wHF57b7E8eD17/jne8o9kFtufhhx/u13VoY8sFOhWJge0jTBSndyr7jDev5XUKO+U1jHONXGfWjZj4wQ9+UH3dV5LTul8RtSpjH3c5JkX8Hu8zTldyzPkuEbY9Bn+XgGZbGT+nNxhjTjuckz/3uc+1muZDH/rQVVNQ9UpA3jNLUnOjpkM8K4QbPbjShsvV53CsHTJm7EpTLrpiYguMV0R0Z+wuO33a5z43FanlQPezACEfehEromnZzQ70lbi5TxsrxDOPMUArh/lMZ9u3z4vuc8QO9OHBhRZFZ6jiyv0MF4h/62/9reaXf/mX1x6PrYSAcNqhkxbFhJTDx3P+x//4H8Xn8v733Xdf/38uCAlV3AZEGPtCZd3S/nAB/k//6T8dFcLs29B4cEFKuGQeD0HBJMG2/7W/9tfa6rm6sI0oj/FKCmkEAftb2j72lf3M4aGRTccP4/0v/+W/LO4jzye/M1YTjwyNz8c//vF+e9lGjqcMx8HQuJfWnY9nwfjEzxSeeOKJZhO8LhbOmtJuC5HHj4ugmjL53nm9Q58XjB1TjMkv/MIv9P/n+BwSZXn7/+N//I+TxGuNcfz93//99pgYOyYZz00XSRTdYntiCDTwOiq3jx3XEcaNfdrmON3l88+fD+PNuBtjjCnz/e9/v/nCF77QX38gpD/4wQ82b3rTmxpTFwlmwreJLF6Zo+3jXcviJSm8L7744iXc586BPlZMrGthBf0SvSlfV48p73nI6N2Fag506K1VrIIm1Auaf1RMjH5ecUAI31bVNQYQ8RwbbHevYYAtoA8ILtip2hoL1JSeQ0ssLkLjBSAXd/FCmYteLkpLr4/rl9tYuhiXQys2OS4ZLpgRTSUhJ7iwRaQQ8li6gI7irAT7wnjQxm3TBTj7yQX80PhyQc72kNN4JWZMh8SOYLt5DuPKhXxpGxEJcvdKsH+IgizWVFl47NhjfPTe2zj/CBG2a9O62TbWfRITGOq9Lled9+OYG/ucmYSI5PzuTZ+X3ocx47u67ffnSjPWqknomOR8M/bZjY0V78PfpxTamnos5eOUz5/JM51Lpnz+eXu3/fzyecvuszHmNMO1x1e/+tXmlVde6X8LOGcjot///vfvHDFohsEIXYnnvkVxzoOO7jMpvrkSNzqyq621pgdD5HP7tyScq4Rx1yoiViotvlZATHSWe78nsZAYg8NtZem3lbhVQEwDqiXh28qDNruhkLwptzEBKYYuDLnAK13kcXHPxa3QBaL48pe/XHyfkmsz5OTEdXAy3CZcEzHEZMCUfQcuoHO7F9zQ0kUo+5kv1Hn9pjxDxmzswhv4exZOlwMu+PMFO587+5p/dPiRKm0jIiaLZ41XPoYY2/jZ8No8NrxvPKaA12zzuQL7VVp33i+ec5LtlYjcEGw/+zwEf4/CMR//Q4Kw9H2VEJ1bHuyQeC4JQX12JRHM93rKWEn4DlE6R/L6qcdpjFLh8U3f8/h58flvI6DZ1nhedS9oY8xphpSzL33pS614fve7392GbnPjPo/xN6WlmTrQwkouNCHcIKOUFF5caJa4z6vfvDXNRwVulkQyR52ptlYSzyoellpZHU4OdNeQetJz1QM6tLJqV8FgkP/MQCGeu1zoS8xOqKR5pLP8G7MbCBButeDCMF7scVFIaLMu2rlo5II/XohygcaFmS7OeG4sWsP68sV86QK19FgWEPkCdQyF60bYNhxi7Y9EYLzIpFIt+yJxnAU8ocdjIob7m0Q+44HzxMUw9+Wgxe3ggn9qOGkt4lirHVS8YGe84jHCNuaw2TxpksN8NV4KmR16fyAMW0IpHnt8DlGITiGKel7PdsV1K+ScbdU+s30SPEQhSDTxnG3TCATrYx80hoxXKUoDiL6I38d4PCiEOMJnER1N9jlPACHohtIlTopdx5HPOx+TrCsec3xnGAeJZkWDxDBnpXBESuc2fQfHJmaIuol/z2Ouvss63nTc6jPm3MJztQ4+46HveZ5QmnI+UN0Bxi3v86ZwcWOMmSu4zt/85jfb+/fee297EzjPr3vd61rxzA0xzWNmf9TCCroiYo2ijdUL+u67724fVxExudDUzUI/dm2seo3I/4OgljZdhgjpXlDv2wu6mgMd1P1GVESMJcJZLjQDxMDgQGPbc4viWTMTipd3DvRhgNiNF2sSGVH8IDi4WMwXvfFCLTsk2WHL4du68FQxnsg+4dt5f7hwzfvDRTT7ogtT5RdSnEjQDobHuFAu5XwyHlHYa9JgDC5kowhgXJUbLRTWfjlhGxBXCItSLizjFUOI8wQHqJgSsF+l8WIceR/GPQq5+HnxXtFl1LHHeYbPBEGyjQiMOa+5ajH3+UxYN9um/Wb9/K3kdurxob8PwTrjGHK8DLnCWQDFscziWe2L4pgwhp/61KfWnMcprmdtdh3HvI98NvmY4bPKYdt5TKee2zjmN7m0/J3aDrFlVNwe1pNz1OMERv78OS6HPv8clTM2McdkIfnk1IvggiRO0gDb6vBtY8xpAzFMeDbiGZH8gQ98YE08Cx578MEH2+fwXF7Da81+ZA0nFzqHcau4NKAR6QGt+i5ynHVftbe6NOI+hBujN7rQ+4pnqCKgx9zngVZWTdfKilBslSTvoYCYen/lRtqEbzNTgYh2Fe7DIF+s4bQOCRQuWrNo1AUqF6djYdzxYpGL0SjSshjbJ3w778+Y+8LFJRfFuqjO+81jvH7oAjRfdI8J37EwzLyeXOjocsA+Ik6HhETe9ryvUchwTER3UJTGWO8d14srnCcjds1fiuvmGCyFTl+u3Kgs/kuClv2Pnz/jHvchh3aPuZOIvfh+cwjjzqKX/R/6fBgXzleROD75HDR2bpvq0qpI2ND2xHNg/o7kz78UWs53Jgrv/PlPRZOClzuaxRhjThom7D/72c+250uMD8K1x37H3/nOd/YVuXnN7/zO72yVCmY2k6twK403trBiGcO30ZG0sOp6QLePc//8+fM/VstdjS5p1W0M3zGqhXD/+O5wOLcaXnc7vNbCChGtPtA40EPvpRZWhG/bgd4dnIypeW1ckI4VG4oXeVNaw3ARGC/wWL/E1VgYd87J46JQAoK/6QJ2n/BtiNvG9my6+NzkZnIxjyNeyifPAnEsxxn3c4hDKW6h9lo5XHXouRGOgfgZExbLjc+AfeczHzq2mB2Onxvh9NymvHYTbJeOf7aZMF/WrdxV1n25xp9jje3RcV9KdciimkkewXc1jvvP/dzPNZvej/GbUz/gLDo3RZ9oUkbjEr+D8fu56dzGeYKxmjJ5xTjmiQ4R379UU2LT579v8TAmCUo5/sYYcxqIlbYlnqdEpVGJm+fiQKvVlSt0704UzF0bq7W/y0BVXaxYRAwRLRcaIY1Ze+7cuUt6Lb2fm9AnOhIKX++lpGtV4Q53F/0GxzZWQKU0LPZYRAwYBCpxQ2fPL5QH3eVAr72f+0DvDxdHUwXFpuqyOfd5E1kIxvVHsQLKAeQ58WJTwlYXvgrj5vF9wrfzvo6J1k2wTf/oH/2j0Src2zB2gj+EEEsVW9p1VlZ55lkAKKwW0cB+lqolMyFUyled8tpNIEA59uKkjI43TS4hoglfvxwtxHgv7afCquUS5smjPAG0iyvPc+IxfOj9gPM+TvlM2B+dX6IAz6kBm+A5YwJ6SqeCTXA+jMd5/PwhTnJsc54XQy31jDFm7kj4qtI2ApjQ7KkguD/ykY80X/ziF/sK3Yhqi+jdUEpulwPdd1x69NFHLyn/WRHJsRI30ctxPdKbqXC12ivr/9KnyxrtrKqEcKcE6JjM3d/XTmXxzCyC7HhgcBgsZhze/OY3n4k50Dku3syTMYE1FMY9JAqii67n7BO+XRPaKtUSz4cOTjGu7L4hTcqTHxI9CA8m3Eqh7kQgbHrtUKXlTZCbyvqH1s2xlwvpnRS5Yn2s/p6Lh9VoPTU1XzzmsM+NuI+xjsG2jH3+U1pYTSGHecfPPxcPy63LhtZnjDFXA6+++mpz7bXX9pW2txHPgteoQrf+b3YjdlSKHZdy8WjCuEttrECh2yDdGYS08qCXIVq6CieRA93r6djKqpsZaB9XETG4//77j61PPaDvvPPORpXYIrjPLB3CfRjEi88pxatKLYEiURQr5DSG9kZREO+rCm4U25tCVDNZIO2aS5wvZFkvDiXFpiiCpVvOv5wjparOseBXvE25WOczVQE2nLVSi59cJb30WsRDqdUUIdi7wPo2rbtmZfsxYlh2LKIXnclSznwWw1O+r/k7MPQZjonHy5krtu8+xtdve24bm5zJE0xMhDAxk78jU0Tv0Ocfz5NTW1dp0pLb3Hp9G2PMNuAUf+xjH6tSSZt1/Mqv/Mpl7UxxtYGhqhzoEujJJ598ck0nhiJisIhpxk2lFlZQJYQ7g6DOxcMgtK5SAjj3W0udPOhPfOITZwjbXgno9vkvvPBCOwuBiGaJrU+cvNtXHRZcCOoCNIZSD5ELfuULckIIudjU+hAFOXxbIGJiGHcWMLtcEHIhKedYAn7sBIlYzmGP2XmOrY9OG1lgqVJ4Rr3Hp8LnHFsFxV7EqkA8dJzl18b2QEMt0nbdruhqc2zvs+5ttiEep2rvFT+L0uRR/L5oe8eKX6mtUXy9yE7t2GTTWH/k2uSJDd57rN5Drn4f0zZYl47ZTee2nGZSeh+hat4lpnxHSp8/55d43pla+4FzpIWzMcaYyw29oGlndeONN7bh2xijMT0XQ3WlC5cK39bjRC53razakOxSxLNQCyuWKijWVBDStdpYxUbV2T7vxTQ50Hqsq57Wr0BFxJhpYMaBHGhVYAO1sCJOnhxoV+E+HPLFKUJnyHHiYja7JPmClwv8oRDFnNOZC/tsWvcU4vrYD8TXEIQu42j+/M//fLvfElJ5/4fEc87ZnaPIzqG7Q/sQP8cSjBnjWRpv1pmrAUehodeWit3x2tz7eZs2X5vW/Tf+xt9Ye+7lcmLjpE2p0N9Qj+gollTtfIhSv2jBdy9X6C45sDxWu/jY2DjmSu2cE4bevxTNEM9nWYSOpSmMjaPea2i9Ik9YjBE/X/YvR1ZEl9oYY4w5NGIvaHSedB3GqTQgIjqHb8dWVhlpzpKRW0s8Q/Uc6KnlwZk1yPnPAhEdK3HjPjMzwQyFbjFu3lxZck4mF+Xk/8aLVomQfLE61CIl958VJadkKEx72/BtwYVp7g2Lyxj3R+G6umjm/1z4Kp0hO5C5NZbc8ivRbqo22YksiRX2f0xgMHZMQvAc7iOioxjLYfwgoY4w12s5xhjX/NrcjmiqQ8y66I+rdeciaaXtyuvOLbb0/H37dfMdie8VhddY66IsrPW9jGOmYld5Qiq7r9GtZX/y90TfnX3zfmGbcczikW3gOIn7yLZxnso93+M+MkmRw7h5TXw/ifB8HGTyZ5UnG5QjPZX8+ec2f1Mn49hujnF6QV+uFARjjDEGM5TlSvMtY50rCoipCjeGKsvsQLNUSvDq+ccc6K6VlfKf49suauRDV6vCjdJfcUnNqrsS4mt0Fbj7/6uKmqz42MqKx1988cVLFBLT81cXLZeU92wBfVj863/9r9sLy9gKRheDXMiVLqDHQgdjGHekFD5JC6OSM7RrWCIXpeQmx4tZVVweg4t2XbTmlky6wNbfFep7GshtgHDV2T/EFeKaSYJNQjF/rryemyIIEBdxvKKYYxnFOe/Pjcd5TX7tNi16YsVriK21WG8+rvncS73AY2gtxwJChW3ieCDvdRd4Hxzh0sTE2LHPexK2HcUSxyY3bXvp2CSHP4syjvn4PYnf+9psM46MC9/XOKmg1mZD+8gxlcPZeS77GMdKhezkwMdjIH4PMrEdGM/5hV/4hT6iJvdunsrQ5z8lj1pwPMfv7j4t34wxxpgpoOdIySWqGGOUxySicZ9xoRHSamNVKiCGGdsJ5raFVXSdu5DtqBXVavmgqnBL8S/UrJr/xyJiLFc71r8mFhIDxHNer4qJaRZCdOXOXUTsgOAi8Hd/93eLVYqHxPNY7mUO4wZET8lVUa/a/Nx9+piqwM/UtkRcZMeL1uzKAxf0Eiq6YD0NuYcSGRE+c1xf9lXimbEcagvGOkotpnht7l3Mc3/913+9/z+fc+lYUq/dLLz5XKei1lqldefjmnWXwmZxfLOojhNN+4Q3l9Y9pfI8x2ppv0oh6Kyf8S3lEfM+U47hbcZ8iG3HkYrspW0r7SNjxjFVOr+MjVU8BnivsVxrJhnz8a1zQhTPcZs3uci7fv6iVJegRrSAMcYYM0ZMwyUXOqM2ViUHGtNV99GWsXBYFtHdban/N4Xe0LtQrQq37PFSCLd6c8Uq3CoklltYxQECKnErDp74eMSzqnA7B/qwUJ9dLgCHhCcXdlzYctsURpsvRmOu6T7PnQrr1P4MbSv7o2rRmU996lPt46WxkHs4NokwJ9iXsRZSGqexzxwhrPEegvUwUZMnR3gNDuSm1+5SzA1RzLqH8lbZJ96XoohDEzxDk0v79o3We0eG0iIym/YLNN5jjiafO+9Z+mxVLGuffupi23Hk+TrXDE2mafKHz25swm2svZrWwd/Hjq14fhzaFiYaphb/0mvyZzP189fr4/ZcybZ/xhhjrj4oDo0LnR9H+0k8U2AapBFjNLO0ZS4eFrOLm/VaXVWo6uB21njvkeeqaPz/qaeeWkQBDVy8UIE7rks50LLx1RNMxcQQ0Vj+n/zkJ3/YHDAvv/xyf/+GG25oriZU3ZYiU4TyDjnIcyEWSWJ/crGik3rt3MD1xcVScbF77713689dea27jNk+r9123SpUN3XdcWxqiZWYf8s6OZ9uu6/77peIx/m+USBj7DKOPJ/X6bjcdfvie+96bJXGe9djIedfT20XF1FOds75NsYYMx/mpDkeeuihN6w03iVScocKQ//Vv/pXLw2FcJMGHItTRzoxvSacaxYQa5pKAlrCORMbWks8l16PCx0rrHG/a2e1KFXiRjwz2Az60dHRj5oD5moW0MaYkwXRQy6twE3ECTVXB/78jTHGiDlpjnPnzl2n+3KglQMt45QU3tgLWjpRNbQANzr3gpYbnYRz7Ae9N7VCuPPGHGtqzVJ5zzH/eTV70P4timf9jUHL74XrzEC/973vXTgH2hhzNZMLSLl10ekm52778zfGGDNHyHtWFW5QITGIVbhVD2uILJ4B4RzFcyomdjg50M1rG9O6zLEXdEZFxFbL/n0feeSRtedISDNgcdBwn5mZoNQ5/3/88ced/2yMuaogXJcq11RO/vjHP74WujvWusqcDqgGzmy7P39jjDFzhh7QRBLLfZa++z//5/8gitsblMzU3AI55z+reJg0aYySrpUHXbMPdFsorOBGH+Opp55aa4Ydq6kJJY5j47NEPCuEu3vdwkXEjDFXC4TrIpjIM8Z5jJWbhyqAm9ODPn9yp/PnX6qEb4wxxsyNn/mZn2kI3+YWw7fHULHq9HDfrio2gp6iU6dQK4S7daD1X/6JBcRKxDButbBSFW7yn0kaZ/YhFw+LOITbGHO1EPtRRxBPpR7N5nQx9vlvqgBujDHGHBLScFThjuBAY54Swk0ksopKD/SB7u8fHR21mlZ1t5oQDR0taMK5U0j3TtQSoDExe22dqRJ3u6QCd6mVlfKfb731VgqO9euIlbgR0mpjxeBfuHDBVbiNMVcFVEtWxWSgijS9gC2erg78+RtjjBliblW4iSSOLayINkbvqQc0yIWOAjoWEYuVuAsutHKhl6lTVLMv1zSV6DZwUDyDhLPus0Q8E8ItF1oDdOONN7YuNOIZ0RwdaAZbItoYY64W6E2ee56bqwd//sYYY04DSsNVZ6Xbb7+9fRyzdKX9miykY7cm2nXiPiOe6fAURXToAHWpc5rXzN0UNb0z1XKgS2qemYA8GyDhLCEdxbNAOBPGTQg3Fr7KmhtjjDHGGGOMmS9EEVOJG1NU4jmapYjnW265pS8ojS4UCt0mshnxvHpujHZenj9/XqI55j43NamVA62qZu0/wXleDOVCS0jH/Oe4jEnjqsDNfWLl7T4bY4wxxhhjzDyhErc0HfouG6YvvPDCUkWlS8XE6O6EiD537tyl+PhKQLfiedHBY7Wqb4tabayk7FvBvNrwS51wXtvaaLELxbHLlmeGgXh3XGhZ93FA6f/MbAV2v6twG2OMMcYYY8x8iBoO8cz/5UATfYz7zP1cRCx2biJ8GxGtKtwsQ0XuNbM1VN9e1igiVk1Aq2l118qqT+SOIdwqIjYGMwzcENHkP+vx3AeaNlaNMcYYY4wxxphTAfrv4YcfVk2snAo8+tpSO6tu2edD12hlVdWBjk2ro1WunWGWILav4n5shs3sgmYYiHlXD2ihmYlYhbsxxhhjjDHGGDMrlAMd859jATEik2MFbnSjtGPUlEoZLqQO505Rh+VAi65U+FqydtyZLKIz6gMNDJ5caNxnhXLHkufGGGOMMcYYY+YBBcQg9oGWzqMStx7DUEUbqkYWKP1X9bQiyYF+rUBXZ+rWzIOu1cZqIdG8EshnZI2XCogRry77vdtxWfRnmGGgB7Qeowr3SkTTI6wX+hro1eC596UxxhhjjDHGzAgKiIEqcEfkQJPOi4DGWC0VEZtAjIiuErotqrWx0v2U87yMrayUA50daKx42fPf/e532+Vdd93VJpQjoh999NG+uhoDzW0luBfPP/98Y4wxxhhjjDFmHsQ03OhCgxxotbDK4jmm/w7V11J3qE40xzzo5mByoJX/LFRQTNXQjo6O2vchfBtkua9E8ppDHVtYff7zn29nHRhEbrL1lf9MMTFX4TbGGGOMMcaY+SANh66jw1L8G1W4dR8XmmXMg1YlbiKau1ZWfeFqRT+rO9Rrdys3gW7q5kBHI3pNUMf+XLGV1VNPPbUmgOPgaNYhDiIimvxnFxEzxhhjjDHGmPkRNRz50LFlcezCJD0Yc6ARzkQzr27t/2PKcKEKd+RYe6tdqVpETKI5C/24Y+RAx79FG16o51eE6mzcEM+Km3cOtDHGGGOMMcbMhxhFHItDo/XIgSaFlxvEStxynx944IFWw6Ir77777r4Cd9CcJSG9GHh8a2oK6Ch6l+oJzX/ibIDynzVrEBtiM7vAAGHXc6OJtgZPMxOrWYlLjz/+uEO3jTHGGGOMMWamSDzLKEXvkbpLETG1sso50NKQaEoim1dacUgsQ1+Je/kaTQ1qhUAfW0+pAjfIgWanY/lxnGjZ81TiVg40/8fKj/3BYgj3hQsXftgcMC+//HJ//4YbbmiMMcYYY4wxpiZz0hwPPfTQG1566aUlUcUS0TGMO1biRkDHNF+1sRIxPbgQwq2+z8tF12u5Rkp0LQda6v6YrM87Igda4plZBIVxa3BWIrt9LsJZDnRk9fz2eQ7hNsYYY4wxxpj5QAi3UnKpwp0rcct9BozVmAMdIR9aWpNQbgzcIEeV8xx7WTU1qBbCzQbHKmfamexE56bX7LjCuDU4N954Y+8+M4DMQsRZCdpYkXDuNlbGGGOMMcYYMx/QcSoktnKUF2g7RRvHAtK4z2pxPARaE92potXI0c7U7Z1nadTOjd6bagJ6teGX4v+1M/ExwrejzS4Q0RGKiCGiX3zxxXad6gcWW1lp1sIYY4wxxhhjzDxAx6mQWAzhxjSNVbhxn/NriVxW/nOsxC3tmUzdtdfX6AEN1YuIyTY/f/782gbS6JodzVW4IVfiRjyzxIWOIdyamWCgV89xCytjjDHGGGOMmTk40jJNpf+U1iuIWiYHmojmkqaEzsDVTVQtQF1FQHeiuf0ntrKK4ds0uo4oF1rE2HYcaEqWM3gayMzqOa7EbYwxxhhjjDEzIoZwCznShHDHHGhQnawHHnhgIdcZop5UDjT3CdVO4dq90VujEncVAd2J5smOsCpwa6eZTYjV1ai4hvucB0/kRHNjjDHGGGOMMYePQrhVGDrWuhLoQd0fKiIWDdrYzopQ7VCaq29ltahURaymA712XzMAam4N2WpXQTFmE1hKRJMwftdddw29XZtszsxFbMJtjDHGGGOMMeawye5zbFes8G3MVER0NFlBulFErSkUHd0tF514bh87pDZWLSVLPM4GdMneg6I3zi4Q884AxkpscXaCmQvnQRtjjDHGGGPMfKAHNO4zpmj+G+m7KiSGiM7uc+4DjdbMhas7p1mvW3YtoJfNFhHTY9QM4W4VfVc6/Fj/Z/6PA43VnltZZciBZvnggw8Ozk6A21gZY4wxxhhjzHzACEU8Uxia7kqYpNJ5VOKWgaowblzooTBuUORz1J/BdW7FdK0e0FphTRaF/y9jMbEcxk0iOG2sVIlbgyMRDZqF0MAy0MxarAb3zIULF37YHDAvv/xyf/+GG25ojDHGGGOMMaYmc9Ic586du0731cYKHn300baFsepgqTNTDOPGgUY3fuUrX2mfmwtVA0IaBlTz3inAtUK4e4u8+XG8efv/3A9afaAJ5R4Sz0MwO6GwbWYtzp492xhjjDHGGGOMmQfUssqg8wjfjiHcQhqRwtMs1coqRjUrF1q6M2rnGpW3I7WKiGmr1ixyOc8lB7rb6SaWIoc4w8DgxT7QoPZVWP9uZWWMMcYYY4wx8wEdF0U0HZZiqi4h3HKfIxQQw3jtjNj27xLMpVxoCKHcB9nGKvd9XnOeV/ePvQ7xnCupXbx4cW3wZOHHQcXqL81cGGOMMcYYY4w5XLJ4vv3229eKRWOiks772GOP9c/DhcaBju4zIjrrz/A2P+5j9WPVfDhVuKXmO8G8zK2suvtrr+l6QR9bFy2sxC233NI70AyqSp6TA80yl0A3xhhjjDHGGHO44EBzA8RzBANVRcSiLgQ50Pq/9CXh2zJuc3vlrsj1osuJbmpQzYHu4raZBTjDXe1EyUqPMIugePbc5+vrX//6JTnQoL7PONAMunOgjTHGGGOMMWZe4EKrCjf/V7Rxzn8W0om5jRUQvi3jNoZro5v1nJpluKv1gQ4u9KX4eLLSeza1sgJ6f8VBZGApIsZAM+huY2WMMcYYY4wx80OdlbivEG7aWLEs5UBDrJ9FinBME8a4TUK6NXibylQT0OoB3XTx5rLP2RHd9FwlfQvlQZdaWGkQxeOPP+7CYcYYY4wxxhgzU0oh3JilRB+Twhv1oCBqOaYAE8KtMG6JZ6UUd09Z1q7ADTVziKXw19YZHWji03PVbSCWPbaw0oBl91n3caFxoFl+8pOfdB/oEb75zW823//+99v79957b3P99ddvfM0PfvCD5g//8A/b+29729uIBGiMudJ85zvfaZ5++unm2muvbd7//vc3xswNzq2f+9zn2snmD37wg82b3vSmpja8x8MPP9ye91955ZX2Pd7ylre05//Xve51jZnGs88+244jY/bhD3/41I0d+wZTrwsOhUcffbS9vfvd7177HeB453oHHnzwweak4Dv1ta99rb3/vve9b9bHxaH/pnKuZBvZNj5vs5k59YG+7777rrvpppsWMT1XDrTyn7MDrRBuiWgM2aOjo1YfEsIdnxvzoVM7q2Mtrnahdh/oHoTzaqfOROc571yEQdHAMGCrH69lTCJnULlRqc3tq6aDAOZC4I/+6I+ar371q5New48Dz+fEdfPNNzfGHAIIA47Lb33rW01t9B25ePFiY8xJwUU+xxjHMufX2kigs24u9PWefGcsnl+DceG7zk1jVEJjyJiexvOCxoD9qwnHm64fTgLWDQi/SPxcT5L4Pq+++mozZ07yN3Vf4jlSJpA5XeA+r4zSSwhniWfMUiKPZaDKUI2VuCF2cEJbRn2Zo5672mH67zJETO9FLQHdC3o9wMbHhG71f77rrrvWxG/JkY4DRSVulgwqN2x+JZs7B3ozb3zjG9sZZkAkbPpR42TK82BuM9PG7AqTSzgyJ3XRZwwQzfOOd7yjX9aG41di70Mf+lDzq7/6q+3yJB25uYEA4rvObUwA4Xjh3ON+nUSkwGlFzj0u8UnwgQ98oP9czOlF166cK3UNa04fK5NuEQuIIaLf+ta3LmSeAiKaStyx0LSKT+d6WkQ6oztzyDaCWTqVQtxNBao50EHNL2P+sx6UcJaQhtzKSmHcDBQFxLj/zDPPtH+TrY8DzUwF912FexpcCOgCgB+2oVl3HtePHj9QJ3GBZ4wxVzMIAMK3T8IRlpPERSfncGCp+2Y6XMAz+eDQ0cOCY5nPxdcnpx+EM+dKGzmnGwqIoe0gpuuqjbHCuNGI0olRO8YCYhi3hVZWixDGvQxiei+qOdDhfi+m5T6PFRCLaHbh1ltvXZsd0IAioqMDbaaj2VrCYpQnlEE8y73gIs8YY8x80OSoHVNjjDGHzJ/92Z+1Wg4XWkXEZJYSwo0TTTqvnh9TfUt9oMP/VYG7VDysrddVI4T7mqYOsfL2stRnS5XRot3O/TgI4vOf//xSDjQ2/krYtZZ+fp5DuKfDrC0z6Yhnbu985zvXZvWisN4Uuo3IXn1u7cUas/RcrB1Kfp22Ddimqc7Lrq8rvV5jUgNyf5Sjtu127btPen/WMfY5T3nOEBxDCpvedRvHtpt11vw8Imy7xpj34HalZ8oP+bt5ksTPYtvPvMb35KS4HMdx3v+TOmb0XWdJbY3SvsTzwdT9PYTvYc1zbc3Pusb59XJ8Py7HcQ6Mh4rrQe3f6suxD1OI37VtvxO7HjNX+jy663bn88fV8pt5CKh4WERh3NwnF3r1nDaEGxca9xkBTQ/orB1l1Ob2VXKdm1TomjDu2B96F6oI6OVrW3KsQbVEc3Ci12x3UBw7CeExhHs1YH0V7pV4bp8rJxq7f/XcM6sBbcx0EMYU3uCE8aUvfakNgxIUnoGYM53h5IRLXcoTRZAPCe9Pf/rT7QmK9xs6qSESP/OZz7T3P/axj219AUTudqw4LjgREuo1VIF2aJ80DqUwMcaOcdTfS7mzvJ68w11/RNgXtiuH27Ne3pPJkKGTPDlovD5vE89XPlFpfGPFS35E2M9cPIfX6vjgufk52r7SMaT1E91AcTvyjnMhGF7Pvu0aNsmYse953NifX/zFX1zbb44ZVaIV7A+30v4K1s22Ey6b32fse1BCY6KwxDF4nr6n+Tuy73eTz2QoJHLsu5m/24wpnynbMfZ9r/X+MPZdGfoOwz7ffcaU77fWwXmH79amXOOxfYnfD45XjrHStjGu+bPXcSFUqVhoe6fsv54/dMxMGYO4n+Rhsy858invy5TnRPi8NSGcP3uOO8Yxvi6PCXD8ReJxqPMD2/DRj360KbHr786Uz5rH9fdtUSX2bY7tzNj3o3SO/83f/M1jr4+PlcZR+dLbfHfz8TcV/d6U3muf3+qhcSr95ugYnHK+j9+hKedSvWaolsem3yal8JW+g0O/6cCxXzp+Oe75HS+9Lo+DKqhzPDBuGpuh3we9nn362Z/92Z2O9bHzhyq873qsmWnQSYmi0Gi6ld5bxvBtzFNaWTWhtlZ0nxHRimju2li1zyMHWgXFQtj2ouml6kKP7x3DXUVAx/7PkdjCqvs/OdBrz0FQq40Vg8NSVdcYwNjKSmD1M+iy/800OKFxQtHJThfusfrw0EkyX3xolk4VSlV186Ras4yhkxywTfxAsNRMMydIxE6+EOM1EkuasVTVVW78jeXYDwcXQuw/6+WErfFQNdypP3xT94f18jnw99KFZfyc4mvz5zR0UQrMxKpiuz5n/Tixbv6PANZFe3yOtk8/niV4zmc/+9l2e+R4gV7Pe7PcpkgMnxvbowtZ9o0KjzzO/vA4P8ZjQm0K+lz1fWHbcdNUMXTK+EY4tmLV5LGZb1WX5XgaEwZX4rup8b/cRdjy8V76DvP/fCyWXgccK1O++3kdNaFFI98Btrt0XuG785GPfKQ/BvQ9Bx2XPEZrGhHvl7Z96JjZdBxPGQMJY33X8zmSFlG6cB97Tv5uxO87r2Gc5EJpUmHq93AXNp1rh353IjrXlj5r/b7w+m2+t/kclc+x+k5ss2/6frButkvpXvuIil2/u7sQJ2cYZ87ZcqM1Xpwft23ZqfEEfYe0Xv3mxGsA9kViW9dfQ2hsOCamiuf82xS/E/pOD7VkQ4QiYOP5JF5zQD4f6hjVb5fGgOOa7ZhynPC5TO0Qk9HvTryWiJ+rPpv8m5+vF2Qu6HpBk2LOvT5ZnnjiieVq7HGUF4peEGg/NCAh3Jiqkfvvv7/VkopoVs9nNOe5c+cuJRe6ifdzS6t9qBXCLVp7PDSxPkZXOKzfesSzXGg50Fj1VOJGIK9mE46JaJLNOQGW7H8zDidwVePmhMmPhk6OzLKVxAUnXj1HDkM8AetHhBPWF7/4xcvaM1NiEjTbGd+bbactl06mmtmUizj0Ov3gqt9kaX/0Y5NFcnRmef2mmeZIdGW32R+NhT6nodfy97GLUuD9s/Ojz1YXT6xr03M4lkrr14xv7u3I69k3Oehyo6eOG+875CZobHge4p/t4njnBlOc0PhjXXqfuP9f+MIXWpGzCRV44phhn4cEG+uOx4WI382S6xa/m2x7FF410TGpc8jlCqPVpEIpUkCfOc+JY7bpe6ILOp7DBVnpoppjlONBxRaZrKm1v/r+cW6Ox5e++zmCiG3EzQZNYgw5P1qP9p9t53sY95990yTW2Hli6hgwnrlnr8ZY33l9RvGziM/J3w1d4PLcPE7a7nyO1DGyb7QTTDnX6jsxdi7QeW7ss2YMtvkNiYKCMY/nM52jxgRLPD7G9o0lx56+W0QaxLEZc1ljwdL83dU+8z0Y+x2ZSk5Py98LTVhz21ZAs52l34J4DcB447yzD5oo0Pl+TBhrMnJqBepYgZ/jLU66xO8Ez8v7qUkL3ite7+Tf9HwtxLHN51W6LoznXz7D0r6yvRpD1s168mTfGOoYU7qW0Pcg/ubHbZN4zuemuO0O5T5Z+M1YgXjutVwM3yZ1l2OCiORYSOyRRx5pteZKO17q3Od2PYp6zu/TieZeVIf/76UhaxURa1Fp8JJ4xlZnmZO9Ec+xn1eEwRtyoAH7vzFbo9nAeJIZC92O4rlUPVY/lJp9HypSVps8M5ovBIELem1zPIHzfy4MdfLMr4uPje0Pz8s/DBIywI/V1B6G+Yd+m/2Jrx3aJ15LSNmUzym7Jhwf+pHRDC/H0dhzhnpL8jf9UEfyheRUd48xlrgccvx5Pzkcux6fvIe+K6X30eOKFtCP+yZ0MVMKJRPaZt4jXvxE8VxyuuJ3k3V/4xvfaE4CjieOeV1IXg7xHPvzli58+cy5kIziRT1c9ffS9ySKT4RCCR3DjG2uJ1GD973vfceOL95H35nY53lb4oQpn1nef8Zyyvl86hhwIZ8vUHWxDBJi+bPgORJ/OdWDv3GuKE2W8R2J599dx2mIqb87Eo8SH0PU/KxjNFkWzzAWEi+m7Ju+H6XUiSmwTkQln1O+7pDw1zlr3x7FMcWodI3DezEmHE/bwvaVfgvyeTd+h2Jb0aGx0+eYf+fH0HUG36scsaDP/Vd+5VcGJwn0ucbPW7/JIn8P1SIvi2ftp7Y9v07wXWJ7dC2mKI5tGLqW0DlA1yvxPfN11tA6a587TBk0nXSdQP8houNjilTW/zFjY2enEfHc34fFQHWxbanWxirb4nlHsNXZ0VhuPBMHhiJi2PfcGMSYWC4I427M1kSxrBOETl6ZOKs5FlIb3cLLJaB1Uh4T/8BJnB/r/Jwo+Ero4mNIACs3qEQsRDFVQEeRtO3+xBDg97znPYOvZbuGLkrjc0rHQhRGPKf0wx6fo+JnmU37F4/NKSHBEkSbhMy+x6fE51gemXIfYWh8M3JYxi4WY292Eb+bY1Xz43ezlANYg6HolZMku6Yl8oUkz9s0YQhyWhSymtn0+n0Ycr0hjvEu4fLafxjb/inn86ljMHQ+whXa9ByNA59DPm7529A4xc+9dlpBLHI2tv9Tz7VTPutci2IIvY+iAkqM/UbEc4qic0ro+5HFyTaM/X5G4bjv5xfPE6XPYRuRmhn7zcnnXaGoIxj6bulxjo1tJ+fiZ5i3Z0ycDkV7xRDy/FnzN8ZgaL06tsc+w9IkzTYMbXe8FonbHbdl7Bgfql9gTgYii9F4MQ+6y4Hu3ecSQ52dYiVullEvq27XvtQK4e4rbweF31dEC7b6Mje97nKgR1fOTASDy2q78O12Hc6B3h1V5FaVxqGTkE42Q6Iqwo+hZqQ5YZ10LrS2bcqP39iJMFasjOhHaOgCYWw8lIPIOqcKFr1PvLAcW39EwmuK+8ePGp+9LkrzukiPGIJjRQJkCF7Pc4Yu+jYdF9oH5QFu+nw1btEZKqHPQVU3t7kw0WtAudpDxOdNQfniMdwtEl2lHCYIU76bWr/2o/aFwa4XoPugcVOqBePBBRHjMXSMxe/yNhEOeX0neW4bG0tdBPM5vvrqq822xHPmNufz0vdl6hgMPS+eZ4aeEx9nf0vHraofZ/YZpzF0rp2y/xyPiKehc+3Uz3rq72l0Icfgsy2FcccqxpqYHEK/b0zK7PP9j50DIvF8vQ+a7FVYNdurPun7Ro5smjSMuePx8+f9h9J2lD8N20zScS7UBCmRhZpEmVJVOubJl+BvY797sZJ1RM8f+gyn/HaNsWnfdL0St3vqOVC54HahT56uNfExo1R50NxXjayx9eRK3E2XVpwM3iriGWpV4W6XXSXu9n50oEu2OjBz8MADD5yJJcm7EuXHnHHyncPMRNt0ezWwFtA7ohPmpkIWOvGMCSYRn8PrTlpA79vzdKxi5RQ2jYlO3lNPwBrrMQE7xDZjEX80SmJq7EclFi4aYlMO05RtLP3wDaGLDRVmmQLr3eaHOwqvTReWYpsf3rHiMnIvstsRW7FsQvl3JzW5daWKregCU1XnszuYL3CnTrZESp/jSToTm9Yt4bIL2xwz+XyeP+OpYzD0vHie2GU8h6qvnzS7nmtLEwC1P+up2zb0vlHwTP1+7DpBMfX3t8bnS4ix6mvoBowTbvyu0TObvkdDn3+cnMrne0U6bSvwFaZNXrJymvVbhWDH6R2LnBpj6O8xX32Moc9w3/PopteXrlc0GT3lHMjxsWuEhdkMJqhqWeUQ7gg1se65555jei/U1MrCWWJaPZ977XhwRcRCPHnvQvPQkHAW2vHYzwvxjF1PJW6qr735zW/uxbTsfc1WnD17tjGXhxoXjLUvdPZZX8z/1mRCns3cJo/1UDhts6XbHHeI0KnCcMqP59B2cCEytdBJyXUaWj8XObq4i87FUDGZXT/rbYq0HDrKl4wTEJp4wW3iYlS5iHo+jIW4ZrY9VszJgzCQg6rvTqm92dXqHu273yf9/ci/vyoelYuT1gq/Vy5vrEatCCfOE/z/pNsUqdI6xKijWGg0FoscCy8eQgUFYztB0O9KLra1L+qmARwz+Roq7s+hsM2kRO3oFbOOxHNXRGzxhje8Yc2FlvssYpov5Ihm1doiZViPrXTomVCXa5GqcV/5PtDNusKXeJ6UX72aQaAHdHu/s+fX8qDp50UIN/+PsfGEcT///PONOVn047gpzB6iW1gSDWMno11OVAoVnuJSZvQDOlZUhR+hyymgGTOFQW07I57b2IwRn3MlnMMp26jPdIr4VLi38rFOgjhOulCojSrkq8c4+x6LhOXPiuOf506ZIY85pNtOhl3pi4gp7x+LxqhIjCo14zzp4jhewJ7UsXLIxOq6m4jH1Uk67rsQC6ENCR/O3ychoHc9116OiSudCzdt29Dnr3MK43aS3w+1Nxr7/dWEWE1i/jHHNxNs7C/HCtuwbV0DfqvHfkPHfmtLUUcxgmafmhKxw0SsCM6kU63fr1hPIVf9FrHA56Ggc9mUY2uXa0uzPV0bq+VKQLdGqSpwr/RfmweNFlw9bRmLiBG5HNdBfa2V7uwfU/pwKmrd94Ju9qzADVWrcEMXzt1X49bGs2R24K677qL5df98cqCHYPCieM5FxMzJE39sNv0ox/ypUlj4mAifItAzOmFPOUFnkRHz2IZ+AC936M42RVPytinse0rFVoV1TcmNOgnGqo9CPNam/NBr3KZMdux6Qa18qKnvM7XoT0QXd6raGouKlS5mNTZDha4i8ZjK1eih9ndzKifx/ioOKGEVj7fYD3fTsbDLZ3joxKI+m/ZfxznjedLpONsQq6+PuWkn9fnpXLvpPAaX+1wbt22Mod8Yfc6cT07y+6HXIhKv1O8v+xqrgO8i9Db9VuvzLxXwitdJ+rxi+7Ba8B640nqvqSlIm9DnMybID1GAxsKEY5/flN9Vsz9qYRVDuNF9uM8qIhZRHrR0pIqIxQ5PMQc6FdtedG2squRBVxfQQoXDQk/o1k3mb4hm7fRKUPd9oIFYd8HgqYx5FM/Y/CzdB/rkic6XmtKXiDmFuYCJTtxj7Sim5ltF9COjPJwh+MEg1Ijen/rhlhswlttzucO3tT+b2p4grvL+xErOY6+NIVVj1bpPEgnEIcjhglj9c4w40z72g8hx8Nu//dtt3t0u6H3Y9rGLR8af8MRdjp9YtVcX6ENuRPxujh3/8buZhfiUSahdvptT2ef9dawPHUsSE1EIcG6a+j35vd/7vfZYOU1hwFHIjX0PYv7klSgQN5Wh8/dJ1CkQU8+1nMcv97lWBSg5Dw6df8a2O55Txo4P1sH3Q2HYQ88Ze/3Yczj+av3+8jlwfhz6bdDxvcuxoNaGJeJv7dB3KIr36Ohu248a2D96Nm/KN64dUTQ2bif527Er+RgvfX4qxGZOFnKgV2PdK9lcQCw/H/dZDrTaH0fhHN1m3c9CuWYOdG0BXVT1nZBu78eeXfDII480Q32gb7nlloUcaMCFpngYN3AV7stD7KnJCTqfcHh8rJ+0Ltr5QeGHLJ5wua/wom3hByEWEVJYWITH1cs1us0KTY8/WnGb2M7L7UDFaujKjcqwPxJL8Ycgj0Xph0Gfk97rcrcdEgpNzsKHcY/H19RwuhiWx+tLYiweB6VQSh0P8cI7V1BXqzf9uOYLMh037Ft0ybZBAo/Xa3vHqrLX+m6y7fmY2ee7OZX4/tueG/Sd53WlY0nFeKL7M+WcEcesdgjplYb9j8782Hli6Ji50sTPs3SOZPuH+nfn1+fv+xTyMVT6rbhS59pYaJDPNp8Lc+5xCZ1Tho6PuI7SdzOGuOfziYiT6qX1cy6rhX5r2JcsyuPk+65RFqVJhPz5D32HYtSR9nmXvvJ6Pfs3tD2K5Kk1IRajFYbG9VCjeGK6D+OltAUVddMYHvLk4Wnhtttu6+/HNF0gClnEKtyYrgrhVt4zFIpXj2nEvfVjrRxoEYuItQ+EFlZrKPk7VuCG1YmjL0b2wgsv0Ae6nYlQCPfK5m//9sMf/rAxlwdOIvwA8EOkYhRyMqJQ4P8U6sgnf/1IqG0DN/1oqEq11r8tvE6OpkRnDDuPoZux5zNiSO2BPv3pT7ev4YcutrTSNl/OoktsI+/NCV0//KWwOh573/vet/Za9knuAvvGrTQWyju7UnAxyTEk4SNRGsOl2JdtLjo57vjRU1EY1l0aNx3LpW2Sg42zzzbxOrZDz+f4Ztx4H/3wMpbafh3LwGt2CcOLxWW0rjH3qsZ3k31XHqCOmRrfzSnwXiqetu25QTnjcpjidyWGKOfPO35P8jkjHof6nhxa/u++MN4aU33mpWNmLD/1SsP285mrIJS2H5HA58e2c94euoDXd4xjBhGn7zvfkSkXzfEYisctXOlzrc5R7DvnQrYxn2MZv6Ec8XhOyb8jcR1D5xSOLyYweK5+W1VMUWOhlkscb/H3V2GzPL9WBWQmjDguJMxZr94rnrPj9cFU+A1GmGsfIJ93ec7Yd0i/PfH/26KJMfaPMYtjqu8E1JzM4XPWZ8T76v1A0VM6tx8abCufN+cQFZyMMJ6I7Oeee64xJ0cpijim68Y+0KvjqNeJmK4c1+hHQrm5yaRNOc9FahQQg2oONBvUBZuvudBZPJMDzbLU/FozDFTg1mPRxpcD3VXhdgj3ZYQfVH78oihRIS7ghDRUSAL4oY2CgtfqpM6JbB+XQ/mO+pGSENKPtrY9/ojpxzzmHceiYXGbLvcFNCdu7Y8EfWl/StvF38bGgs/gwx/+8BW9KNbY80OuPKR4UcbYb3sxw+s4/tj/XcaNWX993tomibiILoh1ERK3Xxd9HOv7HM98RtrGKW6E9itewG/z3eR4O6nv5hQ4Xnd5//yZK+xTF2+6wC9dMA59T3hfFRi70t+Tk0T7P3Q+Z/8PVTwDx4s+P33unL/VN55tH6sOHSe44vd9G8G26VzL36/EMTR2jtJ3YtN3Ov/ex+8HjJ1TdH6P46LexnFigbGJ69dkCORz0j7E3xuQYxrP2XFft4HvCePAvmqM4nmX9W4Kx1bUEahn9S6wno9+9KPHrmniZ1Z7MieeX/V+iurgGMqT/IcExxfjxVLRfNz4P58p++Uq3JcXhPNQrat77rln7f+xiBiGbO4BPdRKuRPOVaKXa4ZAH1tXyXnOIdzRfY5NshHROQY+2vuIaEK4L1y4cNBW9Msvv9zfv+GGG5rTgGZYWarAzFSRqYuUXV47Ba2b9yEHkhPipvXvsz8nTd6fbX7kdYHA66eOxUmisGd+WKNY1dhvu39j6EJ223GLxyehRWMXv3quLgo1xvvCe+OCQxTGU197qN/Nk37/XT/zQ/ueXG7yd3Bu+7/r5w5x36OQ2ZZDPYZqnF/3OT7ihMLQ9/lyHn8ndc4Gnbt2WS+OMWPAxEENhziOqYqVneTxGM/dl+P9LhfUmmG/4jXLoTMnzfHQQw+9ASM0FhKLApoaWLjQONC5hRUCmhpaq7t9y6rsPg/kOy+7vy32daFrCWi1n1oL4Z4ioLs2Vm0hMZZyoNULWjHwq4N3zS2XC310dPSj5oA5jQLamF0oCWhzHIUVIyKZITfGGHM6wbElDNzn+8Nin4nsK8mcNMe5c+eu032KQ0fxrB7Qzz777JI2VmhC/S23siKiWSHc5ETTB1oFrFWFu6u+HQX1wYRwT7LE6dPVzRj0IdxqYxULiTFgCuOORcQghnC7iJgx5jTBTH4MgTPGGHN6UX2HK1XU82rllQ1V4lXUbWo3ELM76qwUo4xlniKe0YR6PItn0oJjJW66PUXx3LnMyyieU2urnakloNut6vKg1wqIxQppXZz6pfxi3OfYyiqDiFZsPA23GWwNuDHGzBm1WCHkTlVvr2SVdGOMMScDBed0vlelas73ucWgOTkYf7W0VD68qsarTahyx69kwdXTDiZoNELReIhoQrejeYqI1v2Y6gs5qlmECOhFh0K3m1rUqsLdOtClFlay0rmP66zq21qC3GcGpptd6P+Gja9caAZ2ZeNTGY8KbG2FbmOMmSu4zariG6E4izHGmNODOgZkVAjRXB6Uqx6LnmWGqsybeuRC0KrATcruD3/4w9ZsVQg393MetIhh23oMA5eo545WVwaDt4qKrtrGatllZcfHUiU0ZgvWXkMRMbWyUhXuxx57rFEONOI5zkY8/fTTlzqbn5mLxhgzDyjSo+JQ5jUoNoPTrMI26hnqMTLGmNMFrdXy+Z6qz5sqdZu64PYTlk0LOxxoCWpQyHbshmFOBtxnRDRpuTGqGBEtgzS6zxFpR+6vxPMyief+eUGX9svOhd67iFg1AS1l321Z0Y2G6EKTD70S1Gt9oEVsZYV4Vmy8Wllx4WmMmQ+12pKcJhDKVF41xhhzukGc+Xx/GGjywtclV47sQCuEmyXmqQqJbeLo6IiC0/1zu5zoNmVYYjT4u3sLZ1FFQIdy4IPCWcTQbcRz/Jti21VxLYpoDSz3yYNm6T7QxhhjjDHGGDNPMEZXmq4p9YFWBe6Q5rvWBxrxTMi2iofp8SCa16KjQ3GxvahVREyJ2Rs3CAc6VOJe+5sGJotnQrjj82T1uwq3McYYY4wxxswHabhSFe4hchExoRBulil1uE35jcXDOjG9t36s4kDLFs+Px52gUppaV8l5poVV1wd6bWYBlDiOhZ9bWRljjDHGGGOMmS9da+I1o3QofFs6MeZADzFSMGxS6+VN1OwDrVsRenURvh1DuCWoYai6GuRZCQb7ueeecwi3McYYY4wxxsyIl156qddwSs2V3iMHWh2YKCydQTzHKObYMhlyu6qUXrxYVuhnVS2Eu3lNzQ8qeuLSEdHcl3DuBPXgCmmkzQA++uijfe/obqaiefvb327xbIwxxhhjjDEz4qabblrkMG7lQN955529C33PPfesFZYWUT8qD5r7LENR65akl6vox5oCut3A7tZvnHaoS+7unWj9Pc4gxNh2wrdXMwpNbqgNDDQJ5zfeeKNDu40xxhhjjDFmJhBFzC22sJID/fDDDy+jA01trLFIZYhpw01XOEyPIajT3/emioBWATE2kNv58+fb9WKpF/pAr+1AnEHINj0OtMSzBvW2225rXWjs/ueff74xxhhjjDHGGDMvFFmM+ywHGgM1OtAwVEAsh293tI/RykqebqzQvalj1BSqCOjOKlevrd5Gj325RMx7FkoE1yAhpCkipgHEytfAkvtsjDHGGGOMMWZ+ZD0no5TIY7nPIhusFBHT/dzRKVTiprXVGYVzS0hXSH9uqRbCLTUfe20Rsp0hfDu3stJAYM9zQ0gTwo0DDc8880w/sLL6V69Znj17tjHGGGOMMcYYMw+IKIaY/4zWK3Veyi50rMCt+loRjFyM3W7ZdBHSul8llLtWCHex+hkh2xEJakS0WlmJIWtesxDkPEtEI55XzvQZh3AbY4wxxhhjzPwghJsbGk8h3CATNRLbWLFEPJfMWsiVt197aDHaMWobaoVwL1OT6rVkbWYA2MEsqIEcaGYSGBRENDeqrZEwHmPgY8sq8p9xn+1AG2OMMcYYY8y8iWHcaEAh4Zwd6CieyYWOhatjfa7AojN993ahq9jY3cYsgy3eN6nuqm8Th76IBcQI41Y1bmYSGBSJaD1HZctjLDwlzxHQuNAsj46OftQcMC+//HJ//4YbbmiMMcYYY4wxpiZz0hz33Xffde9617swTZe5jRXIQMVQ1WPoxK985SvLWIC6c6Fjx6e19lVdDnT7/86BrkI1B7oTz6/J/S6kO5cML8Wpi1yeHPGsPtDx8dtvv71dIp7VP8wYY4wxxhhjzOFDDvQTTzyxzDnQY6/BZH3ggQf650hIozdXhuoxTXv+/Pm+jVUseN1UMJCvaSrRxXAvJKY39duKvaAj0YXGvqeSd2xlRS70Sjy3z3UId32effbZ5lvf+lbzpje9qXn3u9/dzI3vfOc7zdNPP91ce+21zfvf//5mLvzgBz9oPve5z7Vf8A9+8IPt+Is/+qM/asj3f8tb3tK84x3vaE4D3//+95tvfvOb7f0HH3ywOSR2OYb4/H7nd36ned3rXtd8+MMfbpeHxKOPPtpcvHixedvb3kaBxubQeOWVV9rjgWOd7XzjG9/YHu/ve9/7Dm4sjTHGGLM/ak2MiFYONOHb/E0h3ErrLfWBphD1ypxt76MXo/sMtLFaLRadM32pM3t7w3cfalbhXqD0FXMe/1YS07ESN3Y8S+VAx3LlMQYe5ECDi4htBxen3LhYHQJhw3MQ0nMEIcP2MwlQmynjtyuvvvpqKxzY/jz2CDrel+VpgTHUeB4auxxDPJd94rWX83PStm76vuoY4vt9iDB5JJEP2i++F8YYY4w5XQy1JcY0zdovE9tYRUILq95pRpeu9Omyu1+tiFgtB7rdKIT9SuGrefVyyIVWL2hV4pYdL/eZcuWrGYf2uYRxrwazMfvz8MMPt0tmfOzqbI/GT+5YTeT4IyDe+c53NmZeEBmwOqG336vL6fAijDkuOSYP0VmeAvsgYY/jz/eA/3O7/vrrG2OMMcacLtTGCnCh//RP//TS2PNVK4v7FBHDfY650CK70IUiYlVyoas60N3dVt2PNaomfDuGcONAcxtqZRVZ2fit1c/MhUO4zWkC8UD4tkXD/EA4f+ADH5hV2sChIPEc00a4f1rSFYwxxhhThqLQCuHm/yxz/SvIIdyIZwxZBHMsUh3NW2nRUESsqdQGupqAjjulXlvFJ8p9juBAc2Nw8gBh4yseHqjWxpKZC4dwG2PMvFFKhKNijDHGmKsHdVTCgabGFZAHrQrcoCrcFy9eXMhoxX0GzFgEcyxSHRzoZddmuW9lVUoz3pVqIdz8o3LhEEuJd/fbPtBHR0eLc+fOtY9nF/oTn/jEMUHPLIRCuFWhjYHm/7E3tDk5uMBVXicXuduELxOSTGjrLq8dA9eK9RK6ym1b15Z90rbtuo4p78G4sTyp9xDaF70XDt4+giRv+9T1Xc59hn2Or32PoX24ku8tGDsieRg3fcZT0fbv8toa7Hp87vo+MHR87XN+NMYYY65WEM+qwr1aNisRvUDbof0Q0c8+++zyjjvuaIuIkd4rk7UUui2C/uxbLOsxVeKuEcJdRUCrArf+y/2cA414psl1F7PeP65E8CyeGSwqrzGAJSufUG470JuhMA+3yKc//em1/xN6WgqX5MKQ/MpcoIgL1nvvvXc0xJILSt43F1TitYRp7lrhm8JCX/va144V8iJvmG3ahKr9csvr4MKXsYhihvdT7rOg4FGE943vzXq/+tWv9oWlSttZEky/+Zu/2S4/9KEPTb4IR8jwXqXCVbzXtlWMKd7E/m67vrHXlcZ1E/G4LR2ffC58hrko1pRjk9ex7l2PoRLst46LX/3VX137G983xCrh+Yzdl770pb5Ylth2jHivONaMv44f8bGPfay4vqHPirHj2BvbhqGx47VUU5963LINn/nMZ9YeY3viPrAutiey6Xgf+m7pe8x2fvSjH23fn32h2jriW++j92fsOO/lfeX1fAeUb14aj/wcY4wxxhwHB3q1WLCkSDS31W9qX4Vb4pn/xwjlmP8sgxaNSSXusPpem1KBuxPO1UK4qwjouDHawBKy3Lv7NMJekAjO/1cD0/9NFj0zD/R6lgOt+PhuwNu3bsyJwUU6F6xc9HORyUUi/+fiExHA/0tCOIqf6MjgWPFaLoBZbpsvmicD5DqpYi8X1WPCied98Ytf7EUXF9qkAvA4j/H6z372s+3F9K6OmtpRSSCxHi6o5VJpO2u0OuK9vvCFL7TvxbrYH95L+7Ptew1te1wfnyHjk9c3ts8Sl5vEmYifc0kMbzq+ODZZlsTwlGPopNq3sW617tJnxbhqnLYZo12Jn3E8XlQBfuj4Zxv57kSnFYHI4xp31js0GVdC+0mlbdbDOmkdJvIxhtjl3CGxqu3XeUlV3TdtQ15PCY4h9lXnPtC5j3FgjDRJOPScj3zkI5fdmTfGGGPmAPquu4ZoxTNRxjxOFW7MU4pIx2rcsYiYxDPL2MaKZYh+bo3Z8+fPX1rdznTh3FUKiEEtB7q3w7N6jk40MepK9EY8I6IfeOCBdgcJ4SYPWuKZVlbMPOA+kwOtXtCEb9MHGgd6NfiNGSe6o9Fd2XSRrgtlVcUV8QKci0cuVOOFLhewEii8jvfOf8dBRkjIjZ5CXC8Xpb/4i794zClmvdltj+BAcYFbcsvYL17LxTX7h0vFduNqqSr2FIeY/VIf2/wevDfrlvu1q9tZeq8svNSXWOJiijPI+A2tj/dCdKh/c9x2nDqJ5zw2cdLiG9/4xsZJEzl6kJ19iAI4H5txO3kO2xG3JR5DJcc3vvYk0DGfjwu9L2M1ZYxAjml2VjfB8a3PN4+NIjvYluz8KpqE7wTbn91VfS68lvVuOr+wDZyH4mujE5zRxAjwPMYoH2c6L/E8nlMSr+wff1ekAvsRRbtgX/kb+6rzV/xOSYCzDYosKD1naH+MMcaYqxml4ao9sfpAcx/ttxLPg0KX6GUM2CCaWxcapDklpLvuUNKo7XNqhHFXKSLWbcRCah+0A0M9oFnKgeamVla33nrrWh9okHgGxcqrmJg5ObjAzAKFC0+EB3CRmHvlRvHDRW52kWKY7DZCRc8dCjPdFH4b+yiXBLD2i8cV5r0L7DMX3VxU5/eIVYZ3XX9ETvrb3va2Y+PB/rANiKqpYbVsN7fS+GoyBBBhpe3IglXbwbjixm0ShnIGoSSeNckBJfGs7dTj+fjadAzxOtZ7En2+RenYGxvbk4Dw4rwNfH80bsotFprwAY6pUmgy26/vzklMQMQWckPfX44xfaY6jjJsH99DojLYX55fis5gffn8FSf8OOb5IebYHnpOHkdjjDHGvAY1WIgCVV0rUKRxLCImTRhDuLs2Vq0pS+i2xLNIrayO6cWDamMFbLBKhec+XN1j7TLmQENsiP3d7363TRiX+xwHMb1m6TZWJ8tQP2IuXuXuqIATyInkgnJMzMq1jsV3xuBiVQ7nWE6vLohLSJiwT2PumEI/9xEyvMdQ6KbWryJm+6D9YAxL6+Jz2iZMXI770PhItCCoojDQe8TPKTLkBkbYBzmMJfGs58CmyAW9No5L3DYmCYZgvSdVDRrhuWlsaxwXY/A5DOXmxjGN38vo2o9NxmjcOQ/UFI4cb9qe6Ahn1EoMhr4TQPTKps94yEWPoeFTnpNz9I0xxhjz4z7QMkZBDvQtt9zSasBYPIwIZbU8RjeiJYlsxoWWvhygd6AB97mpQK0Q7knPY4ZgNVuw9liXCL5cDdIZzS7EAmLEwOcq3Cp73pgTY1NlYC7EuTgkf1HE/MipLtSU8GIuoLXeTYV5+HvJ3dWF7CaHTBf+Eon7iClVKh6C99gn3xWxi9BXaDhONPu/bxXgWKE8Ej9r7mtsEAyEHvMaCmaxXWzLVAHP9hPmDbxmaPIlRjtsOr7iBA3bF4+hTePD82tECGTGJhHi3/Y9LsYY23fGRuMWP+soAqd8d3T81JqI0PtP+ex0zMXPPjK14vnQ+/D6bZ5zkpMhxhhjzGmAtFwiixXG/fDDDy/Jf5b7vBLRbf6zWh4jpFcPLyWi5UCXzNuO6pqxVhurXNWsWImbGQI1vs6VuBHFyn+OMIDMLqwuqo+55a7CfXLscgEfxec2AnoTugidckE+JFK0bbhjuar42PvuIgKGKhXXRvmXyp9VdXEYq0g8BttdqlA+BmNEWK1yUFXMSduIszk28cHr9H6IHo6JofxV2Ob4knDWcTalqFMUQDUZW+/l6oG86X3IB86fffxspkSMwNBnuAux6N8UeB7brM9+F8bei79xnJdyp/NzjDHGGDNM1wO6LSRGL+gXX3xxqeJhsQp3LCIGOZoZcv5zfFyPHVQRsVSFuy8klvOf5UDHnVbuM8ii5756f6kPtNxn/mb3+bBBNE2txHtSYmWIbUTlLqImFrlSqHteT80cUYQp74GwwY2WwEHAMlFAHufUzwIhLgHOtpfcuqFtV1Eo3henWPmfEl1DYdmgvFTGiefiRo9VDmefcbinQMHB/F5mN5iUmZo2U7MXso6D6IpPef5Jc7nexxhjjDnNqJAYhcUwTNF8SuHFhSaMW5D/rCrcuM+xgJhI1bYX58+fX65ur/3nkNpYgTY2NqzODnQJbHie88gjj7T/R0SvBucMF8ldCfNjfaCJl2fGwjnQh0W8oBzKn94FOT1TxM+Qo62wToTeVEG5LTE8fEww1i6yxD5xY8zZBvWvxQFDFCM2N13sx0JRQwW6phSIilXL1bYLYV+qih23Hweb9VPBWA5zLjomMa9c7W3Qa6e4gvs4l6cRxluOa83v9VS2+f7DNtEGxhhjjLlyEIG80nX9/1fXf5dYqp0VZurqv0u5z6rATQowwjmLZ+hE8pp2XAnoVkjXqMAN1YqIqRI3Qjr04BoVz6rGLfEs9xm7nr5eWPhZPJvDRWG6U6rPbhPeGAssbQohHQrP1sW0QovH2NWljOJ9qMjVSYsziUsqEmvSYEpBtJhnOrTt2xZEUqsofX5D26G+0motBIj5/FnLTZ5SpCr/Xa/d5xi6WtHnN+XzPwmHX+eVKZ9dPPfk6ANjjDHGHAb0gc6PEWmMcJZ45jGFcAuM166IWFMqHhbCt/vXIah5nGUtB7qWgF50t9hj61gMunpAxzZWOYSbJQXEVGysVIUb95mEc+dA78ZJhbHGcOUxpxIR+Xu/93t9zuwmEFa6iFf/1RLqi1wiVmYeuwhnHb/927/dt80psc/41WxThNAbatfD56BJgynbO+U5Q5MPjCfjNTT2sXp3iRgmjnjX81ln3K5YvX3T8fWZz3xm7fWxEviux9Ahc5Kh6XFibOz4RWDru1Nze2LxsLF1q8czTOlFbYwxxpgrg/pAl9Jy//iP/3hJJe74mExWhW/jQJeQeYvTrCLXaVklB7qKgF6+Rnu3+38rpLtQ7v55xKrn12LD6z6Dw43ZBnKg9TgDyVLlzQnhdh/o7ZG4jUKo9oVudBARKlmMcBEu4byNUNF6VXE6v1ZhwkOhyjF8mBzbkhDQNkOpQJAuyONr4/htmkDQNtaA90VMsM3sT2mcNVEwJZQ1uvylbeSxIfGEaOGYKn0uiFkdb1NDatWqKBcLy8eXwtQjOr7kVsbjYcoxxOc/p9zW6KzHz6fmJIAKwQGfdalCOZM5jKmoPYbxmCDMv3Scxc9U7ayMMcYYc3iUHOjICy+8sJT7TB60TFYJZwlpkU1buc1KMZY27YT13jZ0tSJinYCWC71WhVtLHGhV4F6JaR6/FAuKaXCUAw0qIgYqImZ2g4tgVVmm0BOCEDFBJedaRX94D4kwVYWO4kxhoMp7neoSqb0R62UdtEuKziYXzspvHhKpXITrIhshwPP0/qxTYph15PxbeM973tMKLMQCDqfGT4W6uMBXCySNsUQ1LaF4LtvId2VfgSMxqe3hphY+vJfWP9b3N6Kxk8hnqW1XyDTrKYU301f3C1/4Qvs56HOR2ImfN+M3BYVyq6gZ69M+xONLt3wcaB0cXxHWse8xdGjwGbEP6qPNZIXaSH30ox+tJmQZN8aM9+FzYXw0IRK/OzxGr/ba8LmwXiaNdJzp+IznFUA82302xhhjDhcc6Oeee67vBw0ySlWFm4hkDNXVb/pSVbhj5HKnIUfThpUPrQjpbrm3CVu1jVXoB72IMeZHR0dnaEWFAy3xvBLTy1IJcgZoNWB9L2jcZ2Lh+ZsqcVPm3Plt28NFMBebiBIuQmOLn5pVc1XpWg5hDJlWL+ddWiyNrVf5tmN9l1UpmtcjNOIYaNt4j6Ec4Cje4mt5TxUmQ0yzntL6tY2Er9eA7UFEIGgkbvLfhwqZlWDb2PZ8fACfGRMQJQHNNiBWJbzzdmi/t/m82XbeS+Hhsaf0puOL13IriccpxxAn9DkRJ4ZiL/aa32u1KtN3Z9txrwG5/ewPx4PanUX4G98/Fw8zxhhjDhsc6Jtuuomo4kv5b5in6D+EdFeBe62FlYqIRRc6F66W4xxRtHSNPOiqjm5X2ezY49oh5UBHGIA4m6AYd+x6BrfrA91WY5MDTf6zLnJX4vxHzQHz8ssv9/dvuOGG5hCQ28YSYXSSIavxvZj0QLzUeD8uniXworjahlhwCHE99cI77hMzZ0PCMBc0OklXrPY4x23fZnzlBrIdyl09yeNL78X7brvfu+7joVLjO7Hte2ncL7dovdzHmTHGGHPoHKLmGOK+++67Tu4zlbjVyiq2sAIMVbU5ziJa94lujtW4qbYdwrfbx4jhXj1+BqHdleJu9qGagFY8ebDGF3EmQH26Yhg3j+NGxyrc6veF+8xjEs+Iaex+RDRFxLReC2hjjDHGGGPM1cycNMe5c+eu030JaIVwQxbRLCWgqcSN+6yi1OjL2AEq50MnWo3a7BnGXbONVa/yVxt/RuI57NCx17DjiGfNIjAwiGdEtFAcvKq1AUXEWG5KQDfGGGOMMcYYczhIw0X3Wah4NAyJ5wzpwhvE83Lg/k5UE9CRuPFjvaBxoXMVbjnQIvaBdhExY4wxxhhjjJkvMkazeAbMU4qH0cpKEclK8SXtl/Tfrhd0rwuptRXzoENdrljounWfa1ThrtkHut1A3cbs8xi+zZJBYCkHOhJnIYACYtyMMcYYY4wxxpweME9xqL/+9a9fUg50zH/GgcaAze2Ro2nbdYTSfRZ96Hb8267UEtDakGUsDy4RncW0YtZpY4V4ZhA0s5BRCLdgpkKzFTGs2xhjjDHGGGPM/LnjjjtaBzprRBmvqq+10oolDanHpBUXY1HR21I1hHuRmm3FHtDxeeRIs5QTjRWfK6xh3bOkiBgutMK3cZ9jETFjjDHGGGOMMfNA3ZSk6dSqWH9XC2PlQEeU/isdqfDt/Lyl+lZ1S6pzE759SCHcoI3s70MpoZse0LrPIMRkcOVBCwaQmyqz4Tq7iJgxxhhjjDHGzA9aWEURjaaT1qMC94svvngJEzXnQGdwoaFg1i46Q3eReixX6QNdMwc6trFas8mHLHNCubHhcaBBMe7kQWPbM3B33nln+zfNSlg0G2OMMcYYY8x8UR9ojFG1Kub/5ECjA0njjQ40Ipoq3OjGUgurSPeYbi2hY9ThVOFWtTMtS/nP9IBOL2vzn6mopgc0w0AINwP38MMPt6+PvcEcwm2MMcYYY4wx80OGKOKZ9NxSpyW04K233toXmuaGZiRyWeHbcqAznXlbCteuoiGrFRGjolkW0RD6QTexWlo3czA4A8DMQ35MIloh3MYYY4wxxhhj5gemqIpDR7NUrMzX4uuiAx3JBq4c55AOXUVDVm1jFazxlrgTncW+JqI1e4Adn1eoImKqws3MBDcGmcGm8fbZs2cbY4wxxhhjjDHzQJ2U5EBnCOMmpbdURAxiD+gJacO5zvXeVBHQnZqPvbfaZdwJRPTR0dFCYdxxxxXCrfBtEsazA61ZCZaI55tvvpnS5naijTHGGGOMMWYmKIQbUxRNF91nui9RSAw9qMLSsYiYamdBKYQ76s+S4XwwVbhTQvaaOx7bWFFmnKVs9ymojRX3GdxYROz1r3991TZcxhhjjDHGGGNOHkxRXGhFGvMY3ZfQf1BK6Y3dm2IId4x8lhbNjnOlCO5qDnRfhbvp7PHcAzrOBkT3GRTCrR7QQAg39j0h3OoFphBuYQfaGGOMMcYYY+YH7rPuRxdaKby5Cnd8rQxZ9KY0Z8x9LonlLt34MKpwhw1ZW4YCYtrB4us1k8DARBGNfY+Izs+PItoYY4wxxhhjzDxQDjSsRHIbwi0HGv3HEjNVfaBBGrFrY6UWVmvrjYat3OcopLv7hxHCHaAUd+tIl3pyZdQHmvsSzyzjbIMGMUK8PIPdGGOMMcYYY4z5/+ydTawk513uq8efGXscR44te7DkYE0UyJCgyJIhlpAtwgrdAbFgFNiwAHx3ISxDFvcsLmwvZEeALR+zQTDAiqBYID4sWRY3OLJ0LWOkYTIyjGJ7FMd27Onbv5p6yk+/563uPqfrzHTNPD+pT1V/V71d3aee9/l/TArCt1kSUYx4LqtwE77trawczFfEM1HNA4XDWtClLqR3rg90x7xW3czCuJduVyg3IlriWbMLVF4r8YH91re+NffZixBCCCGEEEIIu82FCxfa8O1aa2KPPkYPPvfcc1elD0n7VeQyutK7O8EqA3corPswjJUD3S4aa2cFm7jQi8Gbew60V+LWY1REzHn00UcbLygWQgghhBBCCGG3QccN4bqPKtxoQ+lDdW4COjtxUf7z6dOn97nRZuzymhi9s52qwq2NkbJnB4o2Vv3jF7MFSxvug7EJmq2IAx1CCCGEEEII08N7QMsYVfFoKCOSMV2V/ov7zMW7PdXM2/k1GqvMvTsh3FL4ssf39vb6jetmBtp18p4XswX9fRqEVXgVbpYMNnHzcaBDCCGEEEIIYVpQz4rC0BLRtSLRONDqBQ2YrkQvsy4HmnUJ59KB7vKee1Srq9mS0QS0N3/uSoT3961qYeUh3DXUB9rFMjHzXOJAhxBCCCGEEMK0UDviVd2VcKBLFxrztavEPVcrK29h5VjRMIVwj6Idx3SgV6p5hXBrRx2FcHt/L6qusVQfaMSy2/wQBzqEEEIIIYQQpgedlbReVuEGamK5Aw2YrxQSI7pZEc7WMnleqco988tOhXAbUvlLsIPY7O5ArwrfpnS5Xyd8WzMU5EDXqraFEEIIIYQQQpgm3sKY1sYnTpxY0ny4z9AVEGuXRd2tUiP213eqCjfMl7doVlrprCvZWy40MwguolWiHLwXNDAr4TMTPmMRQgghhBBCCGH3oY0Vl3XgQHubY0/77QqI9a2sygLWnl3cr8zGkY+3NyOgBG0tuc0t9K6seNPdvi8PugYD5n3AABeaMG7ynykitlg2IYQQQgghhBCmQa2NFTpPZika0J1og2hmhWt7CDeLpce7WO406rwrILZ1GPdobax8WdrjlBXXuotnnGhVUgNmGDzOvTZwhHF34nmWHOgQQgghhBBCmC4SzohoxLN6QasmlvWB7kO4XVN2+dCzSv5zS6dRZ12h653MgR60x1VqXJRONPZ8WWnNm2lrcBHPzUTwsbh69WoTQgghhBBCCGPh5uVYYcpHSWmCyn3mgvajiDSoJpan+ar4tEK3vYCYpQ+3Nbms/7PfvjWjCGj70Oa6XisnrtznWiXuEmYcmIGo9YBWAbGTJ082u86xYx8OcQR0CCGEEEIIYUw++OCDft21x66iVsReFFpaT9pPEJ3snZoUvUzYdhfGvaQ5Ox3KIMystfKsq9c1yuzCqCHcTbdRuj5kozsUESv7QDNQzDgQwq0wbmYkVIlbBcQuXrzY7Dq33XZbv/7+++83IYQQQgghhDAWLqBde+w6aLqyTXFZhZvoZBxoF9GC0G3V3ZLuRId2gnpJVKtO1xiVuI9qimJea2atRG8P3WYWoewDzUCpCvdLL72078XJgW4mwu23f1inLQI6hBBCCCGEMCbvvfdev+7aY9dB02GOIqK9gFj5ODTi17/+9avoRnKguUhPrjBsa7fPxwhxH1VAW4z50pbVxHQNxbfjQFOFm3XFwIMGVv2gpxDCfccdd/SOPAI6IjqEEEIIIYQwBmgLd6DRHlNBda0I6VYIN2CgclFxaTQihiuRywvhjHhuc6C9vlbpRIPc5iJaemsFPaqAZuO68uBL+I54/vNix2feB1q4A11DVv8UQrgZkzvvvLO//s477zQhhBBCCCGEsC2uLdAcUywiBjJKAQOVi4pLl+Hb6EnEswqJgfSmwre7sO3+OfOOZoRCYmMK6HZjVn1o3q+r2/G+jRUD442y5UA7mpmYUhVuuOuuu/p1ZonefffdJoQQQgghhBAOC5rCo1vvvvvuZgpcvny5LyK2ME0HdZ30oFfhhrKTExRVuGdle+XZNZoxGFOI8lptg2o2bigevWxlVTrQV65cmTHb4ALaY+Elokk6Z/bi/Pnz32smwGJbe+HM+Nx7772TSvIPIYQQQggh7AaEbS80Ui8QMew+8pGPNFPg7Nmzx7XulbjlQpeFxFi6iJYB20U2t+tejbsSut00I7WwgrGLiPXJ3EN5z2UrKw0A4ECX4rlWREwh3CqBPgWYEVJZeT7UxQTAUr5CCCGEEEIIIawDDYGWkFBEY0xFPMOqEG76QOu2mnh2iGwu856b4UJhs268disHGqx0+L7iYbjPsty1rOVAO/QC0yyEJ5dPDbnOEtH0hGbWKOHcIYQQQgghhE1AO6Ah0BKAtkBj3Ayg9dB+Dz/88OzVV1/dyCg9ffp0b9x2QtrbKi+9Ru22wzC6gPbeWkUyd1stzYuIsS4HmtBtzS54ATHEMyHcLp5Vhbs2e7HLcIDfc889S040od18CVKdO4QQQgghhFADrYBmQDu48+zaYip4FLH3gZYLfenSpfnjjz/e6zwVEfvmN7/ZRzJLU7700ktzd6BZNz3ar4/lPo/2Isp7dvG8t7e377WZIaBvF7DTNRdaA6QwbuU/u4Am//nChQvNAw88MJkcaEfus2aOBDnRVM9jyWUKVfRCCCGEEEII44JO4KI2uKXZJud5auIZnnrqqeOPPvpoNf8ZFH3spqqMVpmvqsCt9lVat7fpC4r1N1wTrc22jCWgm6GyZmUxsVoRMWYT6O3FdRURo+8XMw+1AmKAiGZ57ty5t5uJ4oXFQgghhBBCCGEdFAyjvtJUzTYJaJCI9gJi6L/XX3/9qjThiRMnqgXE1N1JSEyrlVVT17pbh3CPXYW7p1aFW22shipxy32WeGbdBTRMtQr3EMws0b/tvffea0IIIYQQQgihBLFMpCrieYqus3PmzJl7FMZdCmjYpAo3DjSaciGkr0o0D4jndt36Qu9eDnTHUhExS+xuuh1dqsRdoqbZDsK5LCJ28uTJZurwBTh+/Hjz0Y9+tF0qhDvh2yGEEEIIIdyaoAWU3olGuO+++9pK21MXz5ugLkwewl2CpkREV8RzC4K5q9DdDthY4hlub0agU/Su9Gcej65l6Tzb41v3mZkFlp0D3Q7eY4891pczl4Am2Xwx89DcTGhWiUsIIYQQQggh3IysakWM+3z69Ol2nZpYiGh3n59++mk0ZZ8DDRURPTPB3GtUc6G3YjSbU4XESvXvSd2/+Iu/WJ0yKYuIeR9oKAuJLQayLSJ2M4RwhxBCCCGEEMKtAjnQFINGSNdyoPW4Wvi2KnE3nZtcy4NuBvKfxyoiNloMgDamJp61PhSyLZQDzWBxwYH2HGgN7IsvvtguV81ehBBCCCGEEELYLWriGaOUqOOy/pUj8bwwZVvhLPFcVN8Gb2X14Y0jpciOJaA32hqfIXAxLeEMmmHAhca+V/g2yIFWH+gQQgghhBBCCNNDXZWk8R577LGZqnBzXVHJ0op0bVLnJk8NVgQ0F4SzFwzrhHTf0goTutmSsQS0rPJ9+IyACoi5eKYvtESzcqBZf/XVV9vbFANfa2FFKHcTQgghhBBCCGESlBW4nZoDLa2IAy0X2nOgoSsY5p2VPRf62g0f1u3ailGKiHX4zvZx52U7q4XlXl4nB3rphSgiRiXuxaxDP4iy9llfPH7+4IMPzi5evNiEEEIIIYQQQpgWmKK1NlanTp1qLl26tFSF2yOWF8zlQCOkvYBYKZK76+1jxxDPMGYIt7vQVWfYZwqsldW+x9XaWIUQQgghhBBCuHkhhHshnvuUXt3uLvRCU/bimaV3fpLjrBzovb29Dy3pEcK3YcwQ7pUbtJgRWLouJxoHWmhmgcHigvvsldg0M6Ec6BQRCyGEEEIIIYTpQCelofs8hFspvYX7TFrwvHOe+9tYtzbKs6LA9XysFlYwdifufVulHGgKiJUiWlg58hZV4fYk8hqrBj+EEEIIIYQQwm7j4duCbkyPP/74Pq3n5munL5faWel64TaPqhlHeTGPLffb3DIXXjENCOFWNTVwF1q3lX2gVUQsfaBDCCGEEEIIYTqcPXv2uF/3POhaH2goe0EjpMtCYlDkQde07tYRzKM40DU7nNvKnlwunpUDjXh+8MEH9+2IBozZhxIGmUJiTQghhBBCCCGESYERip4ri4hhnEr/Yag+8sgjvX5EOKMbh8SzUM2w7qo/bm3a8SaMaWcvvVZZfRskoBHP5ECTAE4M+2Lwlnp8yX0m7h3rnoGU+/zaa681VODWa547d+7tJoQQQgghhBDCzuMOdCmg3YEG9OCJEyeWbpP5WopoN2+xoU1IK6y7vW/bXOixc6B71Mxa6yzlOquAmG5XDrRb8yDxzLoXEKv1DAshhBBCCCGEsNvU6ljJLJX2W4jjVjzTncmLiA31gS4jnz29eGHsHitu2orRBDSKft5R3melxZd2tusBvS//WRXXZN//x3/8x77+YCGEEEIIIYQQpo/rPDTgt7/97X1FxJT7DKdPn+7vK8VzKUdViZv1MUT0KAK620i3yVvRLOGsnSKEu1aJ24uIgfpALwamXT722GN9ETEf3I997GOjVlQLIYQQQgghhHB0XL58udVzRBWrOLQghFsa0IuIgWtGClEPUfSCHt2AHTOEu9Zzy/txte4zLrRCuYEYdi6LGYU+hJscaA1YGQcve797XBzpEEIIIYQQQpgIjz76aLtEPJepuSoipohkkEbEgaaGlmtJzFkZt0UNrrZgmLWz0vrWBuxYVbhrMeW9E60b5ECrgJhuJ4x7MaOwFN/+wgsvtMtaH+hypiKEEEIIIYQQwu5z4cKFlffjQCsiGWNVGhEH+rnnnpOWXGektvq006gevr0bbayaa4XOtDHlsocdtQJiV5k9qNnvuM+KeVf+c41aAnoIIYQQQgghhN1EDrQgRVdRxqdOnWpvU1cmD+N++umn2+hlNKS6OxHdLIpc6D7vuTHXuVKu68CMFsJtDvRSQneZ1C0Q0lw8ll32PO4zg4V1r/znGh/5yEcSwh1CCCGEEEIIE4PwbVoUe52rV155pb9fIlrgPhO5LAe6VlurY+7h2l2x63Z1Z4qIgW8Yl4FY9H2oFDlL2fNY9gwYLrRyoOU2M8ghhBBCCCGEEKaHQrhJy/3c5z7Xa0Uij6X9MFIxVDFYuXiqL+BAy32WYWu6U+nFc/WD3tvbGyX/GUYtIjbkQvuDsNyV/8xSpcifffbZY15ETI9XDrTcZu8DnRDuEEIIIYQQQpgODzzwwFJRaLnQRB5L+2GkKv+Zi3QiIdwsPQca4azI58K87Qt1eSurbRlTQO+LMa+B5a7858XMwb7qakN49e0QQgghhBBCCNMHg9RbFQOVuMs2VkAIN0vlQJcpwwunuRfKynf2vGeryn1oxhTQzbzIyq7MArQo/5kB0CCArHnlP/tzfFBVhfvkyZNNCCGEEEIIIYRpoMjihQ5sl15EDHChqcStqGQ3WuVAq5VVmTbcGc5L7ayKStw7U4V7NrNeVuhoF8+aFVgMxJKY7vo/t/eVLaxUhbvsA+1cvHixCSGEEEIIIYQwHciDXmjBVu+RliuzFO3HBTNVhqrrRJmvXn0basZtRUyPEtF8ezMOS+HbnbLvN1A7s7Dil253NLPAAEk8r+oBzYzFYnBvmrBuJh1+8IMfNO+//37zwQcfNFevXh2lzHoIIYQQQghhWiD+jh071tx2223N7bff3txxxx3NGBWkdwVaWakKNyHcTacRF0K6FdHqAz0EIdxlHnTxkK5+2Mx16k7lQJdVzZZ2QA60So3Lcq+BVV+LdxcMNAPOjMXN0MYKobyYdWneeuut5u23327ee++9VkBHPIcQQgghhHBrghZAE6AN0Ahvvvlmu0Q7TB1V4Tbx3OIpu15UelUI9wokmGeWCz3bpRxor2o2L3OhNSMgq538Z92nKtwC8UwIN3j4tvcHe/HFFyevLhkiCed33303gjmEEEIIIYQwCGIa7YCGmDKqwq0Qbgf9V0Yhly2sFuJ5Xwh3SaetWhEt557lGDnQY4Vw95a4bWwLec9d6PYSzBpISJMH/cwzz/TP6fpA73sTJZfTLwwRvRjgUYugXS+YOVocGPtmkAjP0IWQDS4hhBBCCCGEWws50HKhWQrMN1I/F1poknpBUcRqTawiYmpRTD9oiohhqpah3ORALzTkXCHcyn32XtCsF+2VR2thBaP2gZbz7PH5Es/aKcWqI57VE9rFs8Psg1xoBlYONP3CphrCzcFfimcEM18ALnfffXcvoEMIIYQQQgi3HugpNMFdd93VnDhxotUJXBcy5FxYTxVFGpfaTnWxABca01Uh3EB6sEU698Wr55XQ3sX9o4mrsTPR9xUOK1HPLnegVU1N9rxi3t2+9xBu1ikmxizF+fPnv9dMhNJ55ouBYOaLEUIIIYQQQgirwH1+5513+vRPTLepOdFPPfXUcWpaURRaOdCe/ywDlSrccqCVB+0CGryQGHSmLRryarNf67baettibKM60H7FG1rbbf26i2e1shIqIsbgnTp1qr2tFM/NxODDcvGsgz3iOYQQQgghhLAJaAcXzDLoplRPCfHsbawEodt+fagSdxfFPGfpmtPWXTzLkG6F9RiVzMeswi1qwrkP2y5nCZhFGArhhkuXLs3LwZwizBS583zPPfe0ZelDCCGEEEIIYVPQEGgJiUE0BlpjSqiNla5jkj722GO9JlQP6BpoSqKaKSTmUc+sF1HQc6+6PdYkw5hVuEW7kWygJ3OzpOK2QrgFVdTkQGPNkyzOxVtZaTBVRAyYtTh58mQzBTioCbcQhG1HPIcQQgghhBAOA1oCTSHQGlNqcaWCYWVkscK3Pf/Z21gp9VdtrNCbFK0uXl7X2z7QXLrQ7Z3qA93S++OV2HJ2rqzG3eVB962slAO9qnE2/cKAWQuKiTUTwGeEVAwghBBCCCGEEA4LmsILi7lht+tcvnx5jnguK3GXLayGUBsrjFovWt0VEeOqionxegrdHiUNeFQBPbsm71vx7Pa5ZgVwn2tNrzWT4LMLtUJiQKy82/27DuNB6XnhM0UhhBBCCCGEcFhcW6A5ppILjRla4oXEhkK4vYhYGdmM/nQj1xOePZR7W8YsxrWvF/Te3t6+1y93FCSg4cqVK7OuD/SsrMKtdVn9U6jCzYH89ttvt+uEWlCGPoQQQgghhBDGgCJi77//frt+/Pjx5s4772x2mTNnztxDy6qhKtwUkaYOFutK661V4VZtrbIXtCEH2q9vzSgOtFc2a66J/VklhLtd4kC7C+3iGTx8WzHw4IPKYNdmLXYRHcyw6wdzCCGEEEIIYVp4GLdrj11F/Z4lngGzlMLRXBDPXg8L8axU34VoXsqBBo98Lhz4Mc3iI3nR3oHu1vf1gq65zzDUB1rUnOip9IFeOOp9g/OyAXoIIYQQQgghbAOiGRcaphDxevbs2eMsSctVHrSbpYCRioimuDQGqxxoik9TP8s7O8mB9ussVTisC9+ej9HCCsbMge4d6GbAHq/lP9fwGYdaIrlCuKdQhdur4aXydgghhBBCCGFM1BMaplCJWxW4KQ5dq22FeFYOtKKTMVoRz2X74xXied5V3W4jo7vw6J0rIjYr11UJTeuqlgay3x0vIgYSz+oDjfvspc4vXrzY7DoeRjDWrEcIIYQQQgghgAvoKRQRUwg3xaGl7bzeFUhkC3RiRTz3Ec9FK6sy9/najSMNzqhVuME3zJtZnzt3rn0v7Hac6G9/+9v7doCZBfWCBmYfuHhTbWYpplSFO4QQQgghhBDCNS5cuNAuqWvlt8s0LfEc6O55M1KD3ZyllZW50bOBns+juNBjC+i5Vw/zSmjWn4u+z0sbjh3PUoPjhcRqIdzqBR1CCCGEEEIIYTo88MADrb6jiJgbow899FCvTReO8tJzPFJ5oR3bOHV0Jc6zNGdRibsUy/NieWhGE9DWqLqnVk68FM/MIJR2/BBKLsfuZ8ZiCjnQIYQQQgghhBA+hBBtT81F5ym0WwaqopJLpCdxoDFpy8LVBb2gVk50syVjCej9fasG8IppIPfZXeih5xIbLxH97rvvzqaQAx1CCCGEEEII4UMklmuRxQrlfvzxx2ePPPLIoMZU3nOl/7Oj5++cAz24QUVVtL4ftKAMOTz77LPHCN/mUrax0iAinpVgPpU+0CGEEEIIIYQQ9qNe0NJ46D6Fb9OZ6Tvf+c5gdyelCEtvlhW5uwjpebc6WhXuUZoSdz22+iWU4dvamTKEW8h5vnLlCjnQbSExZh28iFhZnS2EEEIIIYQQwnSQ+yzcJP3CF74we+WVV5rXX3+9zXOmNpYKTXNdUcudplx6nTKUe9Y1ge5WuWnuevWwjOJAa4OaSg60L9nRshf04nrz9NNPt+sqIIYDjXjmtloRsRBCCCGEEEII04Mq3ORAU0CMPGhP07106VLbhQkt6IWlBbWzFMFcwwzcdjmb9ZnGLqS3YvQq3Frxami6rcx/Bgbhueeea9c1s4Bdz5IG2gwg6wwsMfKebB5CCCGEEEIIYTqQinv58uVWPJftiTFPuaAHVURMGvHBBx+cc2EdXUkrqzVv1TrOcqG79d0oIqaY8s4mX/nYoRBuUH8v5UAz8yAHWpXZ0gc6hBBCCCGEEKYJDrTXs5L7TP4z5ilLj0iWRqR7k56zRjzPTZ/2tjNSdaA/9IEYM4T72pZuYIt7GLdmEYDZBS7MODz88MOzofBtudBl/HwIIYQQQgghhN3FxTMRxsp/Vt0roahkofxnUYtuFhLK68zdwzBqFe4yqFxh3Ot6QYNmFgTx76q+DQxsWUSM2PkmhBBCCCGEEMIkcA1XVuHGQFUVbrWwUgg3qb9yocu6WmCas6+4bfJ0PpaYHjsHGvZV3rbS4u3t2mEKiHFhNkED40KawTt16lS7Lms/hBBCCCGEEMI0URSx0nLRedJ6qn8FtRZWil4uDdlVvaA74awy3FsbsKO0sepYNQvQgpD+9re/3V9XBTWPZ3deeuklZiHadZ+pUMW2kydPNiGEEEIIIYQQpoWKiHmU8UJI9yKaPGjCuL2NFaAdPQ1Y/Z996e/jQdI7kwNttHZ56TyX6z5jgAMtyjBu2fcgex8YbAT1xYsXmxBCCCGEEEII08VdaExUhLNyoF08g8SzCom59nTxrJhthW6P0sOqGbkKd3PNhZ4P5T47CuP2Pl4aHFXhBs1AlCHcWP8pIhZCCCGEEEII04JK3AsneU4RMXAXGhPV9aDjkcvSk6X2rAjm+XzEamJjFuFSXPlcG+uus1OWHddAuAPtg0YyuQ+q94I+d+7c280O88Ybb/Tr999/fxNCCCGEEEIIYzIlzXHmzJl7Fvru6sJJnlGR++WXX75aPub111+/Shsrd6GpmyXzVRW4qbG10Jz98woHWuHbvdHbjMDoRcTcGvcdqLnRhG/X8p/dpvc+0CwXg9g/PlW4QwghhBBCCGE6EEWMeCb/GSfajVKij7k88cQTzauvvtqL5ytXrsyowq3HYchyGRLPQL5zZzxLoO9OCHdBu6FcPA5dbjQ76uHbngD+wgsvtMvFbfu2SwO7cKbn2P2sJ4Q7hBBCCCGEEKaDTFDCtxHRnqor85RoZEQ0EKV84sSJ/jEL93nWLfcVrC4itVtv1ypvz8eowj2WgPYGW+2Gyoi2FlZztbGq9YEGBgkRrdkGUC9oH1hmLFjGgQ4hhBBCCCGE6SAT1HtAyyyV9gOl9JZFxBaG7LwUzzJta3XC7LbZLlbh7kuDl1XQJKS1s7Xm1wwOIlqzDZqBCCGEEEIIIYRw8+EVuB977LFe/yn/uezUBGVNrbL2lgpw+/pYhcTGqsK9lKw9hGLUZbsLD+N2fAbCUdPtEEIIIYQQQgjTgShipeR6cegh3IFWC+TSgRYS0p2p24d0W53rrRm9CnfHvNxIz4FmiYjGfmfdC4kxw+AVuOkDppkIrH0fZAb//Pnz32t2mFThDiGEEEIIIRwlU9IcZ8+ePa51GaNyoNXCWNR6Qbv5OhDKLS2q+/oc6GYEjiIHulf4iGZddL+VHG+roWkWAdyeVx60xDNimYF19/nkyZNNCCGEEEIIIYTpUTrQSuFl6XWxgDZWiGdPBT59+nRfb8se6kauWi03YzFmCHefuK0NrrWukgOtQmLq5eUw06A8aEGyuZLL6RcGVORuQgghhBBCCCFMAlpXCZmj3soKcKLpA+230cYK8xUdiSmLjly42a0pW+RAl86zt7TamlEEdCfx96n7Mpm7pCwk5ta8wrjdxpe1r0FPFe4QQgghhBBCmB7KgwZ0Xln/qha+rV7QmLIL8Tyv6U2ioWtieawc6CNxoJuB+HLaWHmcurezqlVXA6/ErZkJDXZCuEMIIYQQQghhOiiaWG2shFJ3N+3EhJb0iGdf39vbW8p7HqP/sxjLgW4X3dW5rfc7wlJVuIEiYu5AM7NQE9HMRJS9oDXYFy9ebEIIIYQQQgghTAvyn1977bVW42GUSvOxJP/5hRdeaLjUIHwbY9YdaNbxddGmJqZ122ipv6MWEet2gMtS/+dOPC9V4aYCN7MGXkRM+ECdPn16XxXuTcqdhxBCCCGEEELYLZSGq6hiNB4iWpoP/Uf+MxfqYpUmK/rRNWTFeV4Sy2b2jqIhxxLQfWVtVeFubANX5UIze0BFNS640IhnFRCjhZVTVuEOIYQQQrjVWRgLTQghTAWKQ7P0EO6yiBgOdFmFmwrcXQurvhK3zFlASC8E9NzCtee+7PKitxbRtzfj4iXD5+Q8ryskBkoGB8QzBcRIGldZ8rA9/HP9p3/6p5WPWRy47eWhhx5qwo3HP7N77723+cmf/MkmhBDCjeWf//mfyc9r1z//+c9TQba5kbA9v/u7v9uuf/nLX74l/lcsDJXmG9/4BifY/eQB5y+f+cxnmi984QtNCGEadFHFg+aoTFUVEVs41n0XJwnoxfKq6020qBUQm/UNoT8M494NAa1Yc22gbt9EPIuyB3RZttxnJbD7F7MPsxQR2xz+2f/e7/3eRo/94R/+4ebnf/7n80/oBuOfGZMaEdAhhHDj+Yu/+Ivm3/7t39p1ibYbyR//8R/3IvIv//Ivb/r/FX/wB3/Q7mcJnwmi+k/+5E+aX/qlX8o5TAg7jDoqfepTn2oF7WuvvdZ3Wrrzzjvb9c5IbdelE7/+9a9fVQtkUoEX7nNz7ty52UsvvTT3xxfVtme6baxc6DGLiEk8D26UW+wlzCxodgHx7JY9ieQqIAZlxbYwLv/+7//ezmb/2q/9WvOtb32rCSGETeD34syZM+3lV3/1V5sQwuHg+6Pv0uuvv77ysR41drNHkHFuUhPPDu40j2OiI4Swu1CJGwea9Fy0HWHdn/zkJ9v7yIGWFiQyWTrRo5YpIIYLjXjmupYycId6Po/RC3qsHGjQxi6JZE/qhrL3s6PZBcK3EdFlDrSgWhukCvfhYXbWLz/3cz+3bxadf0K/9Vu/1c5uhxBCCGH3+M3f/M32f/gv//IvN7/+67/e3Kz87d/+beswCyLliNI6f/5886d/+qfN7/zO7yxNIPzhH/5hG+IdQtg91MZKuFFKITHaWKEFldYrjUjNLJYUEMOY9Q5PoOLVrMuF1lIR02MwVg70rAzfFpoFIB8ay917P4Ni2UGtrBgsrjP7wAAuBnIphJvwbZYJ4T48/KOtgWj+u7/7uyXRTDgUYWoJhwohhBB2C3Kwb2bhLAhTX5xQt6KYcxgm/wVjgAnwR3/0R+3Ev6LncKvJCw8h7BZU4VYhMVAVbtbvvffedokDrRxo0TnQ86ZomyxK49bSjPvQ7TFE9CgOdCee23Uty/xnZgiw2mW363arprbkQJfv4TMTIg70+CCU+afErK4XRiHnKFU+QwghhHAjkOOMs+ziucTvo8BaCGH3cPFc4hHIMlWV5itKQ1aU+tPE874o6W0YxYGuKXmfAejs9H5nVTnN+0A/++yz/QCVvb6Emmzrehzoo4NZ3q9+9avtTC4gnnGlN5nlZnZYYVNUjyakitfbRcgtY1sp2MW2ahZ7l+GzYJuJFjjM+PJ8Zudv9D6XYz/2ceL7CdsU+2Fb/+///b/96+xytfry82VMD7Ot/j1mf3mdG11tuIR9Hdom/57AYT//MY7T2rG4zXjyWpt8/8vj9jD7790AVm33GMddecwd9ntWbsthfiPHOHZgF/8f1vZvm+Nxm8+e57IdPkbrns/2rsI/K15/1e9EuLV46623mj/7sz9rfuRHfqT5qZ/6qWYb/v7v/76tGfSzP/uzzcc//vEmbIcbpUQggwpKdy2O2zxoma6CMG7M2VWvXRS6Xlmva1PGbmO1qjQ4zrOL6P5x2PESzlwYKP2DwcYnjJt1xHNX7rwlDvTRwj8h8qpUsIPcI8Kmhv4RIbB5bM2plrN90DBwXotiKnpNcpw2OZHhOSq8QvhW+b78s2d7VUm13Naf/umfHgxzJw9L1bHZFrZpCN5HkxDrHrsJFEUhpL4c403GlxMUIgmG9pliNczwO//7f//v5l/+5V/adYrKlffX2Hbsf+M3fmMrQa8CMof5bHmecuyUTzf0WuwXr+Mnel4dlu/OJhNOjAWfKRzkGPnKV77Sbxdhi3wv9R0s+bEf+7E2T3LdSS3HFcfY0Pe4ts/gn7ngOseUUzsehqh9d7R93Me+c8yXnyWfP+OJ81T7nqz6/B2e79WWD/M6q75zMDSewo9H/eb89m//9r6xZnsYK/3fHPoOrPqd8PHmfo7doeOpHPeh36V1+weHPeZq28zxNfR/aNPfllXPP8j/MI4fXosT7BJei9/Tslq2f95OWZCv/J3w35Dad0JoIpz3qI31ut8Jfx+1y2Kbay7vutda97lv+pu1CRHPQbz33nvt8l//9V+b//7v/27F71133XWQl2jefffd5m/+5m+a//zP/2yfe9Dnh2tQbdvzoBXCTeForquIGCLaw7hJ/SUPWpW414lnYzZWBW4Ys4gYtBuH46yl7mBdYdy6DRfaq6l5FW7d5uKZgaVSGxcGPg700eP/iPknV/tHyckaJya1Eyh/DP9oCb06SCg4//j8hGWTcCwErk4wa7nbnNBy0jV0UqsTcE5w1lU/vZ5w8jI0fuuqjnLCxGe0ap95bfUSFS6YJaRXwQnttmO/TeE6BMu6/eSz1Un3utdata2MKff75+EnxEMnqbXXEYetM8C4f+lLXxqsTss+cBJeOzkXjA2vsep7rH2+Ed8L375Vnwmf/9DY6/PnMas+G74HCNVtfiP4Lq46FrW97NMmv2sIsaGx12+wnOmh43bT6sSMDZNnQ8cT+67filW/S7XvSLk9mx5z64pB8Xx+X4ZeS+MyNNY8Z9X/MY3dJr9NPIbjpyae9Vrcfz2rRLPf/AYMCVbQ78Qm+8jnserY5bVW/VZwfK363Hk+r3+YImD+nHVudbi1wCn+hV/4hebEiROtAMaNvnLlysbPx8GmYB3Pve+++/rXCgcH8Uxb4vJ2CohxYd31YBnCjSmLpiTCeQhV2+7cZz1/NkYo95h9oL3HVpsTjWB2ES2bXeHbnQs990JioBkHYuApIAZu7eNCM/BxoI8ehfeqIAf/mPwkn39+5T9JHv8TP/ET7XO5nRMg3c8JA2FeBynqwftt6oLrMQKXyCn7R0qg0/uabeSftvZVJ1xlPviNgG1zl5LxZew5QfMTGB7zMz/zM0vbqxM/oedzYsF97LNeg7Hjfn3GrOvz12WVg3OQsed1eAzbockZPZ/90Htvik5KdUImV10nUP76csFXOYg6udMxghPC58Dr6HjmPTmm9To+XnJYVr3HusmeTWFbeR0/nnV8+GfCccB+DFXc17bwOkye8Dqs873ns+P+2vfi85//fPu95n59f7ivdNgO6ybxuuXvDK/lxznb6Me5xlP7wDhogkePJU2lhOPUxwxXFzfsIL8RfK6ISrHqc+E6x+266BrtG49he6D2/ddx6sdteRzUficcvaZeQ7/lPkGm3wr9LvFZs13sj//ml98RUf7v0HvxmqxrkkLHHOOz6rfYx8G3xT8vjaMiNhw+dxde5WfGBCKvwzat+n8gN17od47QZPZD36Om+xz47uh7oc9V+6PfMvbH3/Og3yP9Dygn+/w48s9W+7gq4ki/5X6c1T573reMqmHffIKH57Mt5RjpGKl9XqvgsxQ+piGARPSf//mft4KY5SZh2DjWf/3Xf90K7ojncVBRaHCdhwutMG6vi0WUMkJa7jOgNcu0YeU8W30uadT5GC2s4EhyoP16sVONZgokohHPxLMzk7Cw6FtHHKv+u9/9rqpw9+6z8p9xoBHRcaCvD5xA6ASknC1GhPhJbS1EkxMn/iFrVrsUaevgBHZTUSJBKDhJFJzUuoDj5AAHqUQnv8rNktO0C9ROsjkZ4QQc2Ga23098ODnSSbXCHB0e6+KWpX82iG19/rzX0Ek+Y+Un6T72PM/HHuFSiiuuc6xJeKhYzKawf5yAseSYYaz8pIvXR1TpOGR72PdVObS11yG0lfHWCXv5OoRQarw46V4loH28CPk+LIw9+1a2cdH2uFDR5IQjoQKqf+Cvw+P5POUElqJI3w9NsgDjMVb1W+Vqsm28Vy1fU98B4PNgv/0x7INPFPD5lRNC5W9EWenXH+e/ET4W+s0QtfGE8nPheF83WVfbHv9t1dhzLJSvxfGFwwqbTO7UjqdyokWivvzd53XLSsjle/Gb45NH5XvpmFNY85AQd9hfXqfMMeZ5+i3RZJ1vL9tZRoLwPffx45jSWK+KXuA+/d7WPi//HulzUKoH9+l301OXuH+bUGaPAijD/YWikPS7Vor7GrXPjX32/ycS5v4Yn9Co/U/SGDH+5fd4Fbyut67ieZuka4RbDwTwF7/4xT4UGxFNTjS50TVefvnlNueZ8O0f+qEfOlTod9iPKnEvRPKSkMaBpqezRLQoXWhQK6vFY2dnz569ym17e3u8HusuUNs0YxUVa7bMgx6rCvfs2mJ5WxDPcqC9kJguiGbE88KVnhHKrRh3VVwTtQrcPtjhaPF/Xi6WNVMs+Cc/JIrVa1oMhQYO4SchtNkawk9cNSsuyhOkIVHMP2//h84JzkHCzo8KTgRq4hVh6ONehm5yPzP4nOgM5eT6SQYnH/45u1O1Kiy5PCnysfdQRbahFM+Ck1TtI8fXQSqo8jyJEARL7aTLT8ZUSGcVQ6/jx0f5OmyH9p3bfVyccrJnaEw2pSaegZNc314XudoOfTd4bE3sAeOgk1o46Hd4WxgfTSCVn0np5PPdrn1u5Vj470V5nWN4qNIv3wnuUy6qf3/cgVs1nhIf2s51x7tycEu4rXx9/5wEgsl/g4fCi1e9LttQTvQwTrXffd9WviPl/w7/PR46dsGF7KrwYz22VqDLf1eg/E7675OOkaHfj3UTvxwL+r2tfV68rv/vOeoq0R4xA7UJBtB+63PQZOwqhj63MkpMReiEf4a1/2maCFkXlcHnyEQDF6KNPNRfr7GrxR7DjQcBjIv84z/+460w5nh//vnn9z2O27iPx/BYnhPxPA6IZ8K4X3zxxVbn1QqJURfLKftAKzUYwa3HdObtrKjIPZNwHiMPehQB3W3IUhvoLud5SeQimj0HWhZ82bOr1sYKfGAXInueEO4bi5+A1U6sSvyfainS1uHhvJx8DYmSUsSJUqysm5XmZL10pm40q07cXHwNicKa8BBlJe5aKCOsOqkqxYdQGGXtvhp+HK3K2R1iXQXXTcZKjxt6HcYEt3zodXwfS5FWu72ccDgoLtqH7vfP10/afZ1wx3WOk06+VXn3elE6go7vQ1m4rMS/B4pqgfI3ad1vBKJsKCJE1ESoU/5urhJTq0JR/Zj2z6hk6Du+7jVX3T70uPKYVBQB+HGz7tj1VIChOhzrtgU8paScPPDfp1XtkWDTSJFVws8/H4UqHxU+Xut+Z8qokVW/v6t+Z8v0jfJ/vT+P38Hasbip68xrl6/P2H/ta1/b2e4fYbfAeX7yySfbdcQyTrNgXaKax2xbuTt8CO4zS8K4PZRbqJUV5qqc5ytXrvSPU0cnz4EudefCia7pyVEM2KOowg2zUhSzg4sdmzNboNtwnhe3lxb7EsTBK5ncW1iF64f/cxsKwyLMdx38Q+Qfmp7H8iA5nx5KXAtDLV0ov99PmDZtseGh6+vcmqOGsVu1zS7mVsH+SCiUJ21+glvex8mQHEfCksvcuLJ42CoxTvGYVfh7H6aAjLZHIZLlyZV/lqtOXNeNKceRXqt8HcZHbplEWnlCODTZcxg2+f7598fHxLcDIUF171X4+DHG21RM35R131kXQESorHP1ymOMfSjrOBx2QsPHZ5Ox8TziVcf7quPRt3WM34kyv9wpizKtej+FMoOPr48Rt6875hYORb9e1uEQ69ow+XarnRjwuzdUCLCGjsV1E8D67ut3qPyNYFt1W+33YSz8mNrkd6Ym7mvbtu774ffXqrPr91EF8Dg2NdG3arJ31XYrKuSoxjLcvCCOyWf+h3/4h75CN6jS9qrw7nA4SMMlXRdIzVWqbi3qWO2NEdJELPM/gQjm0pgF6U/lQTfWIUqGbzMCowloFRKzDW45d+7cMWLSiU8XCOeFkEZML/WCdhaPwZpfuk2D662swtHjJzt+Aub/FDc92RxyJDaBsEkVdqqJEp8tL10EP2HadFuH9vVGsO0JAeNFLuFhqyevKya2auxLYb6qKnHJQbd3Xdugg7BN9VY+L5wqCaMyd9Mne5Tjvw3kfm+yTcKPZ1/nszrI9/J6TSytO/63mXTR5zA0UXgQyrHb5HX8MauO91Wf8TYFpmoc5Njf5Ngr8XE66DE3NEaH/Y1cVZhuiHUCeqit143At3OTz1WTtXreGAK6ROkL3pKN3xIumqit1TFYt93bpsGEW5sf/dEfRZS1hcIQzkCudPo8Hw1EEX/kIx/pr5fiuTNP56T1emRyrYVVJWV4XvR+FqP0gIaxBPSsq7o9U4UzErjZAcWk40AvxDTCGWG8cuO7ePe5ly8HBpfcZ/1TShGxo8edRbiRIVGrRImHaK+rZnyYE61dOBE6LF5kTDAG5TjUXBLHi2N5MbEyh3bVSQz3H1VVVBU48n04zH6OhYoOQVlobKziYWNzUOf1erjPB6WsWLyO5Ehef1x0H/SY2/XPy3sli9o2H3Yy86C40z32626DCjQyVuV5Bqjfe1nEMYSjxCt0o2tSafvowX1m+dprry0Jaq/EjS5cfA7zhXhu3IFWDrREs5Y8pyvMJR3Zrpcm7zaMGcLdx6GbZd6iHVo4ze0dxKyz7NpYNeoFjTUvm97aWPV7yuA2ZsWTB92EI6VsC+MnzEPFxVbhTsNhxPiQKPETlppA8xO2TV2z0pk4DLsgvL2nJ2NOuFxt7FXtdgiFxqlViXLaPQSYsS9Pdnzsx6zMXILz7JVm2c+awKud4B4F3gJOUROIu4NM9myKR1gMMXQs+udFmPeq1jW7ijtmTPQc5rdlUyd4FaUbu0lo7hi/M1PDx4RIn6HihteD8nM/6GfmlBXYV7moFL66XiJaEGWx7hgr016OUrx6UT+Fu6tdmLZ3VRcMT22KyA5jgev8K7/yK004WhTCTVQxIvoTn/hErxHKNlZdkelB97hsY0V6cOc8SzN6q+VG69swVhXuua33G1cmczNLILu9C91u159++un2folnVeOGxQlJ+xjPf9ZsRSpxHy1li6oyNNdDnDcp9lQW8jrMySL/JJXvqYIyZWGZWvGfMid3kxMX3yd/vofBrQs9vJ5Flmqo56ygIvCQuNhEhMkt9WJifsK4ydgf1aSCH1s40UPu6PWc1PDvjEIT1032HAZOOtfh3xH/7vo4bfI6u4jvz2GrGpdVmjc5Tmp5rb4tmxQfLHtO3wr4GN3o+hL8npf9xFfBb/7Q/4+ysOZQNXi4Xr9Dq6qP1/CK2eXYHCVspwrzuWBe1QWD7wsVz7nUerqHEHaXmgkqrSfzVIXEvH2VqnA7pAuzREirAnd3V6kT9xW9PixjVeF2i3yfqvedwW6X86z8Z4V0a4BUspzZh4cffrh9LHHxzE44qcJ9NPDPCjfPT/RrfZvpEektgbwVSA1/vVWVYtfhDhknn/zD1z/YocrJcgMF+7cKz1EFf27pWKw6KTnqFiXrKHO/hyYtOCncRDz52Msp0DgNhWKWY7/O/WVbOIE6aAVuP8lalet3PT8Tr37NWPHe6yZ7DkPZmqqE9xxqmVWeYK87yWZibZt8+qPA92FdqyNg+8t9KH+T1h2n/N7hIpav42N7/vz5ldtSdhS4VXI4/X/HQY65o5qQ9M99Xe/5VceF/96umhzj/8tBBPQmk5tD+P9tb7E2xFFM8NWQ41yD/zPb1EsJIew+Fy5caJePPvpoo9pWRBojomWeogMfeeSRmQxWUNQyqAo36cK17k/gt3Vtl0dhbAd6VoZvKybdi4jJeQbu+6//+q/2SR6+rYTxS5cu7ZtpSBGxo4F/rJwUfulLX1rq8Vr2ThXKSRaceAyJaE6AVhWaOgilKPETnlX5pP6eCAoPbXbK1yxbfzAefp3H1k5KdkFkeEjpKrG/7qRRuBiujdMQPvYcI0NjrzxmlozfuomOctvE0IlZGVVxPfD2OR5mvm3rqhL6X9f2TYXVRJmKURYxG3odUPg73+VaCGo5uXS9xpoCg96/lmNo6L0ZC7afS5kz7y2wVh2nPJdjX+kM/tvmue46nmvbUt43Vjj/FPDWeECNhqHvLGOrY47xOgoR7b9PbIenLjnl/7FVKDqqpAzzHsJ/z7aZ9PP/l6u+G9xX/s8aa4LPUe9mtgO3eei7sWnxMyYjbsTveghhOx544IFWyyGkFVlMX2gM08WkYa/zvvOd7+zTgeQ/s0Rbur7sblvSiJ2J6wbv7hQRK73w/UXPPhTSiGc50NC5z/sEMVXXcJ8R0N7KCmi6XesZFjZnXa9Uwck1oVFDJ/qcLPqsNieVKjDFcwhp44Sk7AO87YmiF7TyvNdVRY24D4HtobS0vCEknJBChYL7tvKatZMItt9bz3AywGw9r8NY8Dq78A/d83ABccRnL8eFbWcMDlK52Mdez1t38j809ohLHVscKxxL/nkeJB+X8ZeLzgk52yNHT4XOxqjOfVAQdxJbfkyMKZYYK/aRyS/2Wc4Rx2EZWcBJawn54jqx5nU4wWX7OJ6V915+N/helL8LCvnUZ8hr6reGz/uoCgIpt573A/9OaizYt9KBK/NT+azYR4kk/41gX5XLXv5GuADj9cjplQgrfx+AY70UWNr2WwWOH/1OMg4cg4yz11oojzl+D46icJ0irPS567di6H/DUBVunHV917VP3gucY2eTCAltk0LCOQ55P44hto3j9CC/H0T0aLJI328f6/K3FziGjyIn391+/63R91Tb4o8f+s3wehZ8T/n/llzoEKYBYnnoPs+BFh7GjfGKiFbtLUR0rRJ3Y3WzmhHDt2GsImJL1c1UkbvcGZZU4j579uxSEbEai5OOuYqILQZxrhAm7H3EMzMWC9s/RcSOCP4JcbKC6Fn1D4n7OCn2WW1OMoaECv8oxygY4ydZYhNXW+8tIcc/cHfbHbXaqJ1EcPKHMJGArLVi0Ul9WQH7elOePNXcZlXH3sRd8ZZWYpNK0rWxH3JiVo39qtfn5Esn5LxP7bPlOLkeRcQcrx4P6yZ7DgqfMc6qROLQ58jxWBtTjbd/j1cdCyqOVIPbdYyVx1vZzmtMGE/2Ty6/vpND+8HxUhMhvAbf3U1+IzTBWMLr8j/Lx2EoDFWC+1bJfxa1/x38pg6lkjCmQ8WkxkC/H/6bXvvcOX6Hjiv2qTz+a2423zfa5aya0OM3w0Wtf6+pQHsQAa2K1942atVYs49H1R2g9rkP/Wbx2FW5zf4/iLG+Xn3pQwjb8/3vf3+GiJb77JTimTBuli6iwftAu/NsRcVqudCjtLIaK4S7eruXExfkPLtw5nqZEE74NmHcGkC38pUHTcx8ioiNCyfWuFecpFCUY9MejJwM8PhVM9b8A+fEVCenY1D+g9/0HyfbOVSJGtg+TiCYzV4l4DgJGDrJYFu434vl3CjYT/ZlaHy4nZOZg4hVFXITm+ZuauyH3mvTsa8hETh0YnkYUT4WHtYL26Qw1OC1v/a1rw3uu47HVSfdPn5D31G9ziohw74OieSxZn6HYNs5dtZFQ6z67sIYvxGMA0Jq3bas+txudjjm2P9aNIPQxMhRVe8XfKZ8nkPbwrYi5tZ9d/ncV/3GsT+8zzpW/V4pGuIgSERv8t0Y+/epZNPfGo6NVb/X/n9nm7oqIYTdwnUfEcm1MG4hF9qu922svLD12Ix1NlN9nbIvF0uKiJWPw4pX/jMFxKjCzYDpfjnRXombPGhmL86fP7/TDXrfeOONfv3+++9vbgVU5VpRA5/97GePRLTgZmmmn3/EhznBYtYa10Hbyj/gg/4T5kSGfZbDdJjXuF4ot2wXtrU8Tsbcll37TFQYDSR2t/1OfOUrX+kdLE5GvS+3H9OH/f7h7mj8yKVn/A7yOuVn4IWjrgfl+7MPilw5CEfxG3HYbbnZ2faYO6ptOezvx1j/C8fYllWveaOPx222hdB6nktYe75P4VZnSprjzJkz98iBRtMtfievovPIgaaIGNoPI5WIZHVnwoHGdF0Yse110oKJbKaImF7XBHQ5aa9oaYVyb6WsRxHQlvPcblQZvi00S1A60FRU8wprqsK9+EdzjDj4J5988hgDym2LQe1d8wjoWxsvYoQDfqv0UA3Tg7BihYMedrKnZEhAhxBCCOHWY0qa4+zZs8dJx/3Upz7VC1lpvVOnTi0VkVZhaQ/hViGxrjB1rznLyGenE9WjWNKjhHCX1Da+FM9eiVt9oH1gCOFmBgLnWQMKzFTU4uXDrYW3mRpqnxTCLrBJn/IQQgghhFsFTFBvYeVpua+88kr/OBzoodcg/1lVuFcJZyFHeox2VmML6H6Dyvznso1V1wN6jvv83HPPteLZ21jVXhxrPy2sbk0QzCruQriXF2Q66nytEA4Cx6mK/6inuiZ7xm5dFUIIIYQwRdQLGr773e/O0XlEHnNdedDShGUBMbAq3LOyaLWwHGhvuby1ETtWG6t9raj29vb23Sb3uVjO1QeawVm40Yj6uXKgcaE9mRz3mUrcPGZxX8T0LQD5TUNFVxAkCV0NuwSCeai6btznEEIIIdzqkP+MAw2Yo4ouVtti9J8/HpNVIprwbbTjQiwvPaaWPmxiudWcXdrx1pW4x3SglzaEbZMDrSWOs8qNs07+s8PgeKU1EshdPHsoN62sVvUQCzcPq9pMRZCEXQLHeUg8D7WQCiGEEEK41VDY9kIMz13jCYVvqzYWOlGdm1h6YWq05rlz52q6duYh252g3g0HukvKnskmV4x5OQsgx3khomdUUGO52Pl+JzyMm4Tx06dPU5WtbajtVbgRzyyJn2/CTQ8tZWgHRc9KBAqVNqlCuq5HdQjXG7XCIYSbys3AsUukxNhVwNWPFphMCiGEEEKYAmi4hdZr17sWxb2mk+7jvKmswk3qb3NNAPeRzp2Qnns1bkCX7u3tzUw0b+08iyNvY6X1zoWeUW68dJ6x4ZlJePbZZ49ploGYd5UwH2pjxXLxem83O0yqcIcQQgghhBCOkim2sWIdB7qMKvYQbkT0iRMn9lXgxoxFUyq6GeMVEU0acS29uGMUAT2WA91vpMeaeyy6lt3sgFfini1mExrEM7cxQIuBOdbZ9u3jSvEs4kCHEEIIIYQQwnRw8UxksSJK1QeaFN7XX3/9Ku5z50DvKyZ29uxZrfdL9GYXCS2N2MnUZlb0hd6K0RzosmF1Gb4tVDENVExMRcQEYdwqIsYAqrG2i2gKidETOn2gQwghhBBCCLcyU+sDjRGKkFYBMeVBS0CzlPtcFhHT68h9Lukin4/MhR6riFittPhSATGBaJZwBg/nZnAknsmBVgExDaiWhG8rDzqEEEIIIYQQwjSghZVc6K67UiOjlNRdxDNL3OcrV64saT4Zr0Qyu86USSvxrOJhRSurUUK4RxHQXUnwjR7bhW17K6t+JkH5z4hn1rHu1Q+spBYvH0IIIYQQQghhd1ELK+iKiDVltDF1sEBFxFRoWpW4/9f/+l9LEc9cN0EtbTovWlktVeU+LKM50Kbu1yIRzZJZBLnQDBD2PA40RcS4qB8YaFAVL58c6BBCCCGEEEKYDqWGkwtdtrOSuQpoRExXzFfwtGDWVXurE9V9CDeC2V1oE9SHZhQBvcp9Hmhl1XStrAjFVknyHuLd1furbKRN+DYzFXGgQwghhBBCCGHauKbDPFUar7ewYunh2+hIWlh1PaDb21mnCrdeSzW6pFUPYviuYrQQ7g9XhzdMDa+7He4fKCtefaDlPtdeg0Rz5UDHgQ4hhBBCCCGE6eCCWe6zIwNVRaUVvg2IaBmyCGnM2rNnz17V/fR+7lb36cS2KfSuhHCbsp+5LV4WEKNSmsK3HVnxoBkG8qBxoUkgL1G1tjjQIYQQQgghhDAtiCZmSWSx0nRZev0rtCBh3DJZuc2rcIO3TTYkTHW9b3W1MyHche3sydz9usS0V+AGZhG8jRWDw2Ax4/DQQw8d8xzoMi4+hBBCCCGEEMK08I5K3nHJtR8Qxu1trByFboN0pxm4yoOej+E6O0eRA93raW9lxU4p2dtd6Keffnrf6yl8+9SpU02tCjch3CwTwh1CCCGEEEIINxcYqsqBroGefOmll5Z0ohURAw/XHq2FFdzeHAEI6oqV7q2rFLfOelshjTzoZ5999hg2/UJAt4+/dOlSOwuBiGaJrU+c/GLGogkhhBBCCCGEMD3oBU07q4997GMznGeMUU/PxVBd6ML5iRMn5mUONLqx05PzWsSzsBTjvqBYM4KQHquNlTeqLu3zXkyTA63buupp/QtQiRtrnpkGZhzIgVYFNlBsPHHy5ECnCncIIYQQQgghTA/vBY3Ok67DOJUGRESX4dveyqpEmrNm5I4lnmH0HOhNy4Mza1DmPwtEtKquAe4zMxPMUOjicfMhhBBCCCGEEKaBiogtNN/c61ydPn26r8KNocqydKBZKiV48fh9DnTXykr5z/62u1WFG6WvqmZsaE35e8NrYAZBldS8lZXuf/3116/6419++eWrL7744pxLE0IIIYQQQghhUhCujRlKVDHGqCKNAfdZXZhkqNYKiGHGoi1pYVUL3UYoV1otj1KFexQXt4spr75WVzysj09XL2g1wGa9dKGZZdCAMYjMQsjKZ8AJ46aQGOvnz5//XrPDvPHGG/36/fff34QQQgghhBDCmExJcyxE73GWCGg0HUt3oUsHGiSiu/zn9jZPDxalmG4+DNueFdcPzWgOtOzxWgi3RLRX4a6JZ4SzW/RAJW6JZ2YnJJ65nhzoEEIIIYQQQpgeFIdGPJe3o/0knikwDdKInv8sbVmKZs8ubpZrdY3CWEXEENFzVTeTR16GcS+u73seIdzMJJTCWbzyyit9KyvNTGigsfybEEIIIYQQQgiTgChicqAJ40ZEu/vsEJFMbSzcZznQMl9xn6UtS81pYdozFbnubtupImJsdB/FXYZzK4Rb4dtynwUVuFn64FCJW/erobbi43GgGXSSzpsQQgghhBBCCJOAKGIVhCa62HOgZZwinqUH3WhV/Sx0pRcQK5BwXhLTzUiMFcI9FGveolkBVUvTEhazB0vJ4T5ALqIFrjMO9Oc+97k2B7oJIYQQQgghhDAJ6AGtKtzgUcVehZs2Vqte56WXXtqnFRHO3vO5qLo9inYcsw906zJ7L+gSs9n7933uueeWHiMhzYD5oDEzgb0v1zmVuEMIIYQQQghhWtADWlW4uS599//+3/9DFDeqwl0zU8vi07UK3Fafaykweqw86DH7QLeFwjYpDb6w3JeaYauFlaPEcc9/dnufQU8RsRBCCCGEEEKYPp/85Cfb1F0uiGfyn9ehYtXFzXMJZ28EPUYLKxgrhLt1oHWVP7U+0I6HcSsHWlW4qbZG3DuzD2X+szOFEG6f9bh69WoTQgghhBBCCGPhzupAZ+GdQhqOAmIODjTmKSHcRCKv6QPdr587d67VtNY6uR8Et6CL3tCHZrQq3E0Xxq0rXduqpZ2l1LgL5yH+x//4H+2OeQz8888/f1UV2tTGagocO/bhEEdAhxBCCCGEEMbkgw8+6Ndde+w6FBBz7rzzzjn6T9RCuFVEbKEp+9vIhZbudP3ZTSy4CT0fw4UebYRruc+lC+3Vt70PtIdwM8Pwne98Z64QbvqA4T4/+eSTx+RC1/qF7Sq33XZbv/7+++83IYQQQgghhDAWLqBde+wqSsPFFHUXmshjtJ9yoIUXmZZwpo2VOjwJtGenPyWa+z7QMBvJnh8tB7q2PTUXWsJZTjTiWSHcArueMG4GDwd6qDfYFLj99tv79QjoEEIIIYQQwpi89957/bprj12FEG4qcWOKyoX2dF1c6IcffrgvKI0uFArdJrIZEe2trNCde3t7Es2e+9yMyVg50I2pfHeeZ0O50BLSnv/sS08aVwVu1pmlmFII9x133NF/aAjoiOgQQgghhBDCGKAt3IFGe0wBKnFL06HvSsP00qVLfURyrZgY3Z0Q0WfPnl3KkV0I6FY8zzq4bazq22K0EO5u+1rBvNjwq7LP/THMEpTPUxy7ksOZYSDeHRdaMfA+oPR/ZraC3mFTqMLNuNx555399XfeeacJIYQQQgghhG1xbYHmmEIRMddwiGeuy4Em+hj3mfWyiJin/RK+jYhWFW6Fb3fRz0uDYHnP850qIqam1V0rq6aWyM0swTqYYeCCiCYGXreXfaBpY9VMhLvuuqtfZ5bo3XffbUIIIYQQQgjhsKApPLr17rvvbqYO+u8b3/hGq/fkQAuvvF2j1s6qW8rYne1UEbGyabVb5doZZgm8Cjfr3gyb2QXNMBDzrh7QQjMTsvun0MYKqIbnIpqZIg+1CCGEEEIIIYRNQUu4+4zWmFIFblAOtOc/o/8UhUxksrewQjdKO7qmVMpwJXVY1/u86F1rY9WCqkc8e/iA70wpokvUBxoYPLnQuM8K5Z5SFW7BjJAOasZnMQkQER1CCCGEEEI4EGgItIQMSzTGlNxnCoiBV+CWzqMSt27DUEUbehVupf96dydRONDqYdX4cgzGKtM2k2heCORjssZrBcSIV5f93u24LPpjzDA88sgj/W1U4V6I6PlCMPdCXwO9GLzm5MmTzVRgbO69914mBNp+0FxY52B3dzqEEEIIIYQQahC2jfPs4hmNMYXcZ0EBMSj7QIMcaNJ5EdAYq7UiYhvgEdGjhG6L0dpYab3IeZ57KyvlQJcONFa87Hl6QLP89Kc/3SaUI6Kff/75vroaA81lIbhnFy9ebKYEB/hiMmDJif7+97/fCulU5w4hhBBCCCHUQCugGdAOLp5dW0wFT8N1FxrkQKuFVSmePf13qL6WukN1otnzoJudyYFW/rNQQTFVQzt37lz7PoRvgyz3hUhemirxFlZ/9Vd/1c46MIhcZOsr/5liYlOowl1Cc3NmifxA1xfiypUrfTGAscuthxBCCCGEEKYB0apoAtxmdEJpuMl5RltMDWk4dB0dlvw+qnBrHReapedBqxI3Ec1dK6u+cLWin9Ud6trq+Nb8qC9IUrYKiXXh3O3r+w4BYdz+PJ9JkIhW2XIoq3F7EbHz589/r5kozCClIncIIYQQQghhU0j/JA10SmHbzpkzZ+5xI3Sh9ZZ6ObuIViVuiWhyoIlmxpD1FsmVCtwlfSGxZktG9fv1IZYf5qbiWbh4FghniWfFzU8pB7rG4sBp7rvvvqU+0SGEEEIIIYTgoK8QzmgHNMRUxTO4ePbi0Gg9cqBJ4eUCXolb7vMzzzzTalh05enTp/sK3KY5ayJ5FPEMYwpo/xTn6gnNFZ8RUP7zYtle94bYuM8MEHY9F5poa/AUws0MxYsvvnjTxDcTfnH8+PHmox/9aLtETBOKMeUvRQghhBBCCOHwoAXQBGgDNIKE89TynVch8SyjFL1H6i5FxNTKqsyBloZEU+JAL7TikFiGvhL3/BrNGIyl0va9Tq0CN8iBlvWu23GiFb5NJW7lQHOdEG7vD3azhHCHEEIIIYQQwq0EIdyXL1+eE1UsES2zFLwSNwLac6DVxkqsCeNW3+c2z3h+Ld+42ZaxpjCk7vfJ+nJH5EBLPDOLoDBuDc5CZLePRTjLgXYWj28fN/UQ7hBCCCGEEEK4lSCEWym5VOEuK3HLfQaMVe8D7VBITFqTUG4MXJOj+3Kex4rwHS0GgA32KmfamdKJLptes+MK49bgkCwu95kBZBbCZyVoY0UD7qm1sQohhBBCCCGEWxl0nFpZLRzlGdpO0cZeQAz3WS2Oh0BrojvPnj3bFiLrClr34nnWwX2dG701ownoxYYvVU/TzvhthG+7zS4Q0Q5FxBDRr7/+evua6gfmraw0axFCCCGEEEIIYRqg41RIzEO4MU29+xLuc/lcIpeV/6x8aBUQU+cnM3WXnj9GD2gYvYiYbPO9vb2lDaTRNTtaVuGGshK3ypXjQnsIt2YmGOjFY1JlK4QQQgghhBAmDo60TFPpP6X1CqKWyYEmormmKaEzcHURoxagHkVAd6K5/eOtrDx8m0bXjnKhhce240BTspzB00CWLB5z01TiDiGEEEIIIYRbAQ/hFnKkCeH2HGhQnaxnnnlmJtcZXE8qB5p1QrWLcO3e6B2jEvcoAroTzRs7wqrArZ1mNsGrq1FxDfe5HDxRJpqHEEIIIYQQQth9FMKtwtBe60qgB7U+VETMDVpvZ0WotpXm6ltZzUaqIjamA720rhkANbeG0mpXQTFmE1hKRJMw/ulPf3ro7dpkc2YuvAl3CCGEEEIIIYTdpnSfvV2xwrcxUxHRbrKCdKNwrSkUHd0tZ514bm/bpTZWLTVL3GcDumTvQdHrswvEvDOAXonNZyeYuUgedAghhBBCCCFMB3pA4z5jipb3kb6rQmKI6NJ9LvtAozXLwtWd06znzbsW0PPmABHTqxgzhLtV9F3p8H39n7mOA43VXrayKiEHmuUXvvCFwdkJSBurEEIIIYQQQpgOGKGIZwpD010Jk1Q6j0rcMlAVxo0LPRTGDYp8dv1prnMrpsfqAa0XHJNZ5frci4mVYdwkgtPGSpW4NTgS0aBZCA0sA82sxWJwj50/f/57TQghhBBCCCGEnefs2bPHta42VvD888+3LYxVB0udmTyMGwca3fjNb36zfWxZqBoQ0jCgmrdOAR4rhLu3yJsP483b62U/aPWBJpR7SDwPweyEwraZtTh58mQTQgghhBBCCGEaUMuqBJ1H+LaHcAtpRApPs1QrK49qVi60dKdr5zEqbztjFRHTVi1Z5HKeaw50t9ONlyIHn2Fg8LwPNKh9FdZ/WlmFEEIIIYQQwnRAx7mIpsOSp+oSwi332aGAGMZrZ8S290sw13KhwUK5d7KNVdn3ecl5Xqzvex7iuaykduXKlaXBk4Xvg4rVX5u5CCGEEEIIIYSwu5Ti+ROf+MRSsWhMVNJ5X3jhhf5xuNA40O4+I6JL/Wlv82Efqw9V8+5U4Zaa7wTzvGxl1a0vPafrBb3vtWhhJR5++OHegWZQVfKcHGiWZQn0EEIIIYQQQgi7Cw40F0A8OxioKiLmuhDkQOu69CXh2zJuy/bKXZHrWZcT3YzBaA50F7fNLMAxVrUTNSvdYRZB8exln69//Md/vCoHGtT3GQeaQU8OdAghhBBCCCFMC1xoVeHmuqKNy/xnIZ1YtrECwrdl3Hq4NrpZjxmzDPdofaDNhb7qtxdWes+6VlZA7y8fRAaWImIMNIOeNlYhhBBCCCGEMD3UWYl1hXDTxoplLQcavH4WKcKeJoxxWwjp1uBtRmY0Aa0e0E0Xby77nB3RRY9V0rdQHnSthZUGUbz44ospHBZCCCGEEEIIE6UWwo1ZSvQxKbyuBwVRy54CTAi3wrglnpVS3D1kPnYFbhgzh1gKf+k13YEmPr2sug3EsnsLKw1Y6T5rHRcaB5rl7//+76cPdAghhBBCCCFMgKeeeur4Aw88MPP0XDnQyn8uHWiFcEtEY8ieO3eu1YeEcPtjPR+6aGe1r8XVYbi9GYd9W4FwRjCfPXv2qkR0t3Mr49oR0gwYVdcef/zx9j6EtAa1Kxw2+DohhBBCCCGEEHYT3OeFgXr14x//eHsdnYdZ+vzzz1+lDzQiGkNVmtCLiXWRy33rKn/dsvbWh7XDrgVI71QRscYEvW5gBzyhW/2fP/3pTy/tWM2R9pLlVOJmyaByweZXsnlyoEMIIYQQQghhWjz44IMzLyCGiJZ41mMQ0YhnLzSt4tNlPS2MW3RnGbKNaJZORUw3IzCWgPbCZnPPf9aNEs4S0lC2slIYNwNFATHWX3nllfY+OdD0CsPmZz1VuEMIIYQQQghhelBADG0Hnq6rNsYK40YjSie6dvQCYhi3lVZWMwvjnpuY3orRHGhb78W03OdVBcQczS488sgjS7MDGlBEtDvQIYQQQgghhBCmQ5eS27rQKiIms5TUXZzoV199tdeMaETpxFofaLuuCty14mFt6PcYYdyjOdD86VpZVQWyRLTb7az7IIi/+qu/6l8DG594+NprJoQ7hBBCCCGEEKaDioc57kCrC5MKS8t9rvWALrs9qSuUXOfu5v7+McK4R3FyzRrfV+DLq3Bjs5fx6sqBJiG8rMRdNtLWwGL1Lx7biv+bpQo3Y/iDH/ygef/995sPPviguXr16ighBiGEEEIIIYRpgbY6duxYc9tttzW33357c8cddzRjFcG60fzP//k/71lovTkh3Ihpjzb2HGggjNtzoBHRimh2B5ocaIVxe/XtztyddeHbu+NAe/9nx8Vzd33fc4ljl3jW4Gi2oRxAgdXPoN8MDjRC+fvf/37z1ltvNW+//Xbz3nvvtQI64jmEEEIIIYRbE7QAmgBtgEZ488032yXaYep861vfasUzIdwK5xYyUAnhLltZPf300+0SQ5YL5qzcZzo/6XEukllX7vOuVeEWrcIvhbNT5kATwk01NcSzHGgGi0EjgbwmopVsXrP/pwIfooTzu+++G8EcQgghhBBCGAQxjXZAQ0wZ2lghnhHRuk050IRvI6IpKC1TFdCJzz33XKsd0ZMUqMacRXciomv607tEeTXuZkvGjAOYlcred0S2OutFJW7182o8hJtWVg899NCSwPfYeAqJLYT2bIoh3MwcLQ6MfTNIhGfoQsgGlxBCCCGEEMKthRxoudAsHXTCwmicpF5YuMXHWaqzEkhAAyJ6oR3bdbnQZRg3y7I9MnglbgvjXgrp3taJHq2I2CrxDNjqCGcvN17iA8OsA+4zFwZR/cH88YRxNxODg78UzwhmvgBc7r777l5AhxBCCCGEEG490FVogrvuuqs5ceJEqxO4LmTIlcJ6ahBZjMZzo7QUzzWGOjt5JW6WHuU7Vg707c04zPtSZ91GaqMLW31eFhEjB3phxa98cUqZd2Hb7RLLnytlzPyuw4G+cM578cyQIZj5YoQQQgghhBBCDRlupH6+8847reaStpiqE921Jt5nlBLCrTReT/MdQq6zGbhtWnFh8I4inmG0KtyN9X+GoTzoInx7/swzzxzDhvd2VovrS0eAksl9ZgIhvRjYY+fPn59ECDdjdOXKlV48c5Dfc889bWW9EEIIIYQQQtgEXGc35dAVuNRTqdJ95syZe1TLSmHcZaQxApqaWE888UR73SOVv/nNb17FlF0Vwt0sd4aa71wRsU45e38t3/hB2PGaeJZdz6B5KysNbDdb0Zw8ebKZCswUufMc8RxCCCGEEEI4KGgItIQEIRoDrTEVJJ4pIiZd50ZpWUTaxTOUEc3U2uLi+nNh5rrOnXV6dTZGH+ixvP6528+Eb6+qxO2oDzRgz3usO3nQaqQNPrCEcU+ljRUHNeEWgrDtiOcQQgghhBDCYUBLoCkEWmNqLa68EjdGqXQfnZgALcjSQ7hVQExQX4tC1SpWLQ1amLlzy4XeuobW6MHyXh6cDdfGs2RmAKvdRTM50EMweOQ/s14rIjYVfEZIxQBCCCGEEEII4bCgKbywmBt2u46E8yc+8Yn+NnQf7rOKiDkS0dKRKiJGKyvhOdBFi+BZ18ZqlDzoI8s2V+EwFRFb3NS3sUI0a6cXgrrtA63n0b5KMHiaiXDxrFj5KfSB5sOj9LzwmaIQQgghhBBCOCyuLdAchXDcSSgEvRD7+9J0wdN3BSHcCuNW+2MXzu42a70UyjuXA21UVX0npNt1LyIGNMTWQJQ8/PDDMznQgAtN8bCuIvckqnD/4Ac/6NcJtfBZohBCCCGEEEI4LGgL6QtEomuPXebRRx/t1z1NFxTCDV6FG9NVIdxENusxnjrcra/SiDuTAy2WWlnBUDExJX+XcewnTpzor1+6dGmuJHKFcGPzu9W/67z//vv9+p133tmEEEIIIYQQwli4QefaY1epRREP9YG+cuVKfzumq4pPE8pN/rNQ6vCqQtadRt2dHGg2qAs2n69qZ6Vy47Xm15ph+O53v9s/x218OdCq1jaFEG5vbp7CYSGEEEIIIYQxcQHt2mMqYJIO1bpSGyvh5iuGbNkDuuJGt1DkuhmphfOYIdD7XqtWibsM4fYWVl5hDRFdxsD7zAQimhDuXe8D/eabb/aO/Ec/+tHJ9GcLIYQQQggh7D5U337rrbfadbQGmmOXUR9oLyTmApoaWLjQONBlCysENDW0Fqt9yfHSdR7Id5539806MX1oxnKg9/WB3hQVEGOpAUI8M2CEbzOAXMrYeJhKETER8RxCCCGEEEIYk2PHPpR0UygiJg1HG6tSPKsK96uvvjpHE2Kw6sL9mK8LQ3aOKasQbkzbc+fOHdN6V3G7HwvrErW1eIbR+kA3G7jZ7GQ3Y9CHcKuNlRcS04Cx7kXEwEO4p1BELIQQQgghhBDCMuqs5Eap94BGE+p2Ga0K4SYt2Ctx0+1J3Z86B7pNLXY3eqzJhTEd6F7payPV+1kP6uLU93X4xn32VlYliGjFxjNTwWBrwEMIIYQQQgghTANMUDdC0XiIaKKO3TxFRGvdU32hTAsWlkI861DodjMWYzrQrXAuw5TPnj3bC2ZcZ1Xf1hJwn7kwMGWcu6pwAwNLyXMcaLWyCiGEEEIIIYQwDQjh9lRcdVt68sknj0n7le5zqREBo7bMf+a66dE2SloG7xjh2zBqG6t5RdoXldD2PYc4dlnx3ueLHGiWFBJjNkKPf/nll6/iPuNENyGEEEIIIYQQJoPcZ6XlCs+FdvfZ8QLUC6N27lrT21p1urSt09UJ6nkXLb07faCl7OfXGHyct68iHxrx7AMhvJUVVr5i49XKKoQQQgghhBDCtCgLQSuEm/WyC9Mqzp07t/RYzNpOULeltrnNBPOsFi19GG5vRsDKgc/WbZSHblNBze+T+8yMAw60i2gfWLnPU6jCHUIIIYQQQghhPxijC03X1PpAKyLZ03y9DzSFwwjZVvEw3d5p03bVxakVF9uKUR3oxlpZDYEDbZW4l+7TwJTi2UO4QQXEUoU7hBBCCCGEEKaDNFytCvcQZRExoRBulkXqcNu2qmgp3N7WbMkoDnQn7PdtjO8EldIUvi3nmRZWiOhnnnmmKQuIkTiOE00iednKKoQQQgghhBDCdOlyoAcLSDvSiV4/awi5z5W7Nmq9vI4xq3DrUoVeXYRvewi350PXKquJclaCwb5w4UJCuEMIIYQQQghhQly+fLnXcErN9Rxo5UG/8MIL+56LePYoZm+ZDGUtriK9eDYfoZ/VmFW4V1rixKUjolmXcO4E9eAL0kibAXz++ef7Vliq1vapT30q4jmEEEIIIYQQJsQDDzwwK8O4lQN96tSp3oV+4oknlgpLC9ePyoNmXS2sXCQXenkn21jp0m+cdqhL7u6daN3vMwge20749mJGoSkbagMDTcL5xz72sYR2hxBCCCGEEMJEUB9oiWeQA/2Nb3xj7g40tbFWRSqDpw03XeEw3YagLu7fmlEEtAqIqTT43t5e+7pY6mUfaHKh/bk+g1Da9DjQEs8a1EcffbR1obH7L1682IQQQgghhBBCmBaKLMZ9lgONgeoONAwVECvDtzva2xbG7VV5ul6he4w2VqMI6M4q7ztUayOx1MvHet6zUCK4BgkhTRExDSBWvgaW3OcQQgghhBBCCNOj1HMySok8LvtAlwYrRcS0XnZ0skrctLY6pnBuCekR0p9bRgvhlpr3XluEbJcQvl22stJAYM9zQUgTwo0DDa+88ko/sLL6F8+Znzx5sgkhhBBCCCGEMA2IKAbPf0br1TovlS60V+BWfS0HIxdjt1s2XYS01kcJ5R4rhLta/YyQbUeCGhGtVlZiyJrXLAQ5zxLRiOeFM30sIdwhhBBCCCGEMD0I4eaCxlMIN8hEdbyNFUvEc82shbLy9rWbZis7Rh2EsUK450WT6qVkbWYA2MFSUAM50MwkMCiIaC5UWyNh3GPgvWUV+c+4z3GgQwghhBBCCGHaeBg3GlBIOJcOtItncqG9cLXX5zJmnem7tQs9io3dbczcbPG+SXVXfZs49JkXECOMW9W4mUlgUCSi9RiVLfdYeEqeI6BxoVmeO3fu7WaHeeONN/r1+++/vwkhhBBCCCGEMZmS5njqqaeOf+Yzn8E0nZdtrEAGKoaqbkMnfvOb35x7AerOhfaOT0vtq7oc6PZ650CPwmgOdCeer8n9LqS7LBlei1MXZXlyxLP6QPvtn/jEJ9ol4ln9w0IIIYQQQggh7D7kQH/rW9+alznQq56DyfrMM8/0j5GQRm8uDNV9mnZvb69vY+UFr5sRDOTRioh1Fc7kRK/tt+W9oB0X0uoDresMLLnQIiHcIYQQQgghhDAt1JqYdeVAo/tc+ykaWYWm/flegZvOT+4+A22sWKoqdxco3Ru+2zBmFe4ZSl8x535fTUx7JW7seJbKgfZy5R4DD3KgIUXEQgghhBBCCGE6DLUlpgp3qf1KvI2VYy2seqcZXbrQp/NufbeKiDXdRqH8u1DuWTkL4KgXtCpxy47XzILKlUOtClsIIYQQQgghhOmhNlaAC+35zzW8RhZFxMr+z6LTn/1rKXxbV8vOUYdlVAe6W203fFWjasK3PYQbB5rLUCsr52Mf+9iMeHlmLhLCHUIIIYQQQgjTg6LQ6DrlP7Ms619BGb5N/jOGLILZi1R71LO0qBURa0ZqAz2agPadUq+t6gPlPjs40Fxq8e1lHjTV2lgyc5EQ7hBCCCGEEEKYFuqohAOtGlc40arADarCfeXKlZmMVrnPmLEIZi9SbRHQ867Nct/KqpZmfFhGC+Hmj7vOKiWuHVGvrnPnzs0Q0aWQlgNdutDMQhAPz7rsfSWce2/oEEIIIYQQQgi7D+IZ95kLNa7UXUkO9KuvvjpXETHSe2WyehurEnOgVYFbedFlJe6tGKsPdP9aXY+tahsrmlyXMetKBK+Fb9f6QGPtI6AJ5caBPn/+/PeaHSZ9oEMIIYQQQghHyZQ0x9mzZ4/LgWapItHPP/98WzlbhcTkQHuEsveCxpBd6M1WY1KJm9ssD7pPL75mRH8Y3d1sye3NCHi4drGBS7h4Zoex3kkE5/piYPr7JKaZeWA2YuFAt7crPp6B1ls3IYQQQgghhBAmAfru3XffbSSeFWVM1DEh3BSR9mrcaMPSgWb56U9/ul0vxDMmbhtlvbe3d3VxOdaFc8vo3ZpRQrjV/7n5sMdWj1fj9hh1xDMiGgeai7eyYkkrq8cff7wN3/YcaNxnZitwoJsQQgghhBBCCJNBabhynmWSApHHq1pZKXrZRHN/n1pZKY0YV1da1HKht9aQowhohW1L7YPCt4d6QLOUA81FraweeeSRpT7QoBxoIE6epYqJhRBCCCGEEEKYBnRToiC06lqBRLQXEZMm9BDuro1VW32b0G1CuJ2ilfI+vTiGCz1aGytgg1VIrNYHWjME3sIKvCH2d77znTnOMxdmIHwQi+fM08YqhBBWs/jn1IQQQggh7ArqAy1jFBTG/fDDD7cakPxnFQ8jQlkFp9GNaEkim3Gh3YGuoCjplp0tItaudBZ5zX32Xl1AXjQx7ItBOqYB4nYVECMG3h1oZicoda4w7t///d9PEbEVfOtb3+KAbNcXkxLtZR08nueJz3/+8xzga5839F7//M//TDjGgV5rF2C7/+AP/qBd/7mf+7nm53/+55uwe/zt3/5t+1n9+7//e3tsPfTQQ+1x9oUvfKG51fnjP/7j5k/+5E/43Wx+53d+px2bXWeqvxebMtb+8XvLa/Gbq0kSfnN/8id/svnMZz7ThBBCuLWYWhExlgho9JwiixHRpO4Swk0tLG7zCtzQpf3OJaJ1e828LRkrD3qUImJQ5D63Id3siItoZgjU+Npd6C4Pel6rxM0AMrvw5JNP7nPL0wd6PYuDr/nDP/zDdp2TKk6i18GJ2e/93u/11++99972pGwdiE1EDHz5y1/uBTS3v/766+36Zz/72cmcEHOSq+2Oi7ebcGz95V/+5dJtHIP/8i//0orFW1lIcMwingGR9U//9E+TmASa6u/Fpmy7f3yWv/u7v9v827/92777uI3vw5QmTEIIIdy6dD2g20JiGKSL/49z5T8Tjawq3F5EDMpoZpDmLIW0cqJZ36kiYkUV7vYm/pQOtGLUfaeV+ww+MJp1UB9o2fqA+9yEjXDhizDeRAjiajjuRg/BSZ3Ec/m+uwRu5ZkzZ9oLJ6GbcrOdxN8McFy6eOYzkmBmGRdu+bhlIqyEMdT34Vd/9VebsNvwO/tbv/VbVfFcPu5LX/pSO4EaQggh7DIqJEZhMQxTb19c1sUi/1lVuHGfa+HbnRZVKysqcbcpxkozHoPRcqC1sYjpoRmAGtjwTz/9dH8dEU34NrMOhG/XcqAVL58c6PXgRLgLUYrjGuXJ2Te+8Y21z3GRjXC5GQSnC46a+Ag3Fj8umbD50z/909Z1Y/nVr361udXhO0gkCekHRIQkpH36EFEg95rP95d/+ZebP/qjP2rOnz/fHve/8Ru/0f/eM1nK9yHRMyGEEHYVa03cQh9oQrglotGDLGWyqm6WWiOXBcSgM3ZnjaUXL0R0uz5WDvRoAlqVuBHS1oNr5UaqGvdzzz3XXlcIN3Y9fb2w8H0WIhwOP3Fe5ybXXGqur3MyXMzcLCfqcZ13G+Xbgx9zfG757K7BBNqv//qvRzzfREggI45/6Zd+qb/OMf8zP/Mz7e06/vmOEHUTQggh7BL0gS5vo84VUcfqBc1tCuEWGK9dEbGm5j6beds/D0HdtbQqU44PzVgCulf51mNrnwOtAmLexqoWwo0DvXhse1vNgSZenoTz5EBvhoeyrnOg/X4XIauENwLbXeubMXQ2gmy3yecTbgWIJMBx5jJUEJJJE6IOxLpw7xBCCOF6oz7QtbRcHGgqcfttMlkVvi0HukTmLU6zQraL5Shx3KMUEet6V83chVYoN7MDsteJVS+rcBPLLjveiojNiXmXbc9AKg+a2QlCuBcim7viTm+AQqoRulwQw0Mi14Uy7oYKkFGUaagAkT+Hk7pNC9fgasvZ5qTvIMJb+6Fqtjyf9x5TSPl+rHpdtgWnR/tCuPdBxuF64eO9i9vIOF4PIVyOA2OwSXX6m3U7tqH2PTyqCTTei0JocNjjt/yusr1lmsumEErN67DvbI/n4B8167aX7VABOYV8hxDCrc5bb73V/Nmf/VnzIz/yI81P/dRPNdvw93//923tn5/92Z9tPv7xjzfhYOBAS0TXuHTp0lzuM5rwxIkT7TrCeWG+qih1//iycLUbuuhTBDW3KYR722JiowjoboPa1ebDjeqrcGuJeFYF7oWY5varXlBMDvRCVB/TiWRXRKxdV4PtcHDIEVWYNS5z7UTPC4FxUkk4ICdhOkkeEjjuWv/ET/xEsw5eiwJe5Ykd7/nTP/3TbV7fEGwDVWx5z1puH6GqhKz6drJfv/Zrv7bvsYxHmd9N+KOPjdaHhB1tgihkVduWH/uxH2t+8zd/c+OTc0ItVf2c498roQ/BWFJUSNuIM+Xbynb9xV/8xeA2/vAP/3A7MTIU4svnpDFal0e76rG+b9zO/do2taDaJE/X38PRGAi9h8M2MA5e7E5w7JE/6p8920dhLY0b279O4JbHGp9H+fmvOmbYDiauhsbBP29el9fXvjEuuI08X98htl/fM98Wv11wnWJiztBnsqoS9Lp9OCir3mvT79i678FBvqt8BnyGQ/vObxjfqcNOBrF9FADT58Mx52HZIYQQDsd7773XLv/1X/+1+e///u9W/N51110HeYnm3Xffbf7mb/6m+c///M/2uQd9frgG4vnChQt9P2hQwWhV4SYimaLSiGdV4fbI5U5DrkwbVj60BHW33NqFHjMHulGFszJB+9y5c+374EBLPC/E9LxWgtzzoFniPus+DSxlzsPB8JPZoTBud5I5oeSEzQXDUBi3376u+jYOEgKg5opwooxgl+tdu58TS4TCUGEc7kMIjVE4R61guNSEE0JeEww1OMFGqGxShA28JyzO1ibVz8tCWuXEAeO1ahsRk4iToTE/Ktg/bVtN0I4NggcBPPReqm7s48lYeijsJgX4yloALsh4D47NVZ+HxCKfxybHsF6TfbteoboIUd5z6P20Dwepcj/EuqrT3M5xtOqz8WNt3XeV42QVfOdXbY9+wxifwzi/bJ//PvIbREG8w7S6EmllFUII18Ap/oVf+AXczFYA40ZfuXJl4+fjYFOwkefed999/WuFg4MD/cADD8xUGNrBPKWQNNADumxhRfRyGcJdpg3XKm53GnV3Qrg7FMa9dGPnPrfrCt9GPOt+WfEO4hm7fjG4fR9oQrjlQH/uc5+bMWuxyvoPyyi8mRM0Ts64lCdWfhIqIYyjLCHHshTI3OYne+scOoUV4vRJpCNqXHhwgs77lm6gn1jyPFweHFRtu15DJ7FyAgmv1AQCz9f+sL1sg7PpiWrZQoltxXnivXh/7tO2ctJditsaEmwaI5arQkJ5Hx83d+4lPPwkntdiXDXmjJnuZ8yh5tSPDe/527/920vbxrG4ydgzjjpu2Xe9RilW/ThEFGlMYd1nxf16LY4xPZfHrXMWh4rplcevtkOfB7f7/vB5EBpcuugl5WtuOo5M1qjPub4PPK/8ftd+I3yyRfug8faoDpaM8TbHFMeJIl8YT77vqrmg3yuuI9a/9rWv7dtefQ9cOGubge+B/4bxWeu3pUSRA6LcJtJcNJZ634P2YmY/PLz8ML2c9fsndrWlYAgh3Agkov/8z/+8FcQsNwnDxrH+67/+61ZwRzxvz+XLl+e4z9S1ohI3razQeZil1L+SCw2IZxfRXRGxdl3Rze5AK5VYy+62+d7e3jFSi7t47mYbRhPQhevcimnfmS4Xeu5h3NzOY7wKN8KZ2QblPzMDgXhmpkI50IjncDDkJusEDye4PEmsFQLj5EsnzJwQEx7tuOguxWgNTjQReoR4Olx3MVCKR072OaHk/tqJJdvJ4+V6IUB4TVVklhAh1FVjwPauEyhDuDtcCxdmbHXyf5BQVp6nMNNVYfPlNrjog7LdDS5WKcb5LHmcXLfaxMVRoO3mffiMDpK7zucsQeDChzEe2m7GkLHhseyzu8pAqoJCZnksx4gmI5TXqs+iNokkfEKCffLtYYxd6NZCo3lP/zz4vvEaQ8ePT1x98YtfXIpgWIdELfvjAnrV9wFhxgSDb2/5PdZnqiiQbY8pXqP2fed7wnjzfVdtB9Z5nOPimdfhejnJx37xG6ffMj4DxtLfD1HropT31++L38ZY6nsvJ77cpiF4rLbhMOJZx65PCPE6qcAeQgjLIID5v6lQbEQ0OdHkRtd4+eWX25xnwrd/6Id+6FCh32EZD90WijTGgVYRacK4F/pw6XFU4u5yoBW+vdQBqgjX1rrCvee2fmhGDeHWhi42/ljZC7rWp4sdRzxjxXOdmQXEszfN1gyEu82y+2sl0MMwnp+MW+J4+yrv4+wFdmrtrFxAb3KiphPskrJybPk+OqHkRHfoxLIUUZuE3B6W0vWrgRhhW9muTYWNXC0hZ7iGn9D7c0pnGtE4JGD4LFwQ+mseJWyv8s2POreT/Sf/l/crxTOUwrEMuffj1R3IEm8X5O8jl9u3Z+i7wnv5c1e9HyhXnkmAox7HcsKi9j0G5UCLbb+HQ993jlt/n7IFn2+vXqcWIaMwad0n4e/4xAHvywREbbw5nr0HOduwrgUgMGmi447XRehvIp7ZTkLPuXAyyO+ji+dNxXsIIdxqIIBxkX/8x3+8Fcb8D3/++ef3PY7buI/H8FieE/G8PdJwcp8dT99VSq/cZ4nnEtKFVXdr4C3nA+uHYjQB7fjGr+oFjQst8QzuQAvvA50iYtvBSbbgpM5PNlcVAnOB5Y9DGLjLuYnLtEpk+/Yp1LxkXcVchXTDJieuh8Xf5+/+7u+qIuGwgsbHe6jokbudpcvk27LKwRSrRMhRwLisKhR3VKw6Pl1YyYn25+mYGxJEfBc0KVV+Hh4pUE4U1WBsPBd+VS7tYfJjD0uZb78K/y5vWgOgRhmaX1KG1Pskxqp89Boeau7PLdv0lVE4JRwvfqytq2VQphi4mF+Hp+QIfb+YWEn+cwghrAbn+cknn2zXEcs4zYJ1iWoes23l7vAhMkZL8QyYpxQPo5UVDjS3qUYWRcRI/+3CuHtdSLqvV+L2VGcrdK1uUVvrybFCuPdtLJW4h8SzdljFxNTGqnOgl56jFla6rgJiC+HdhIOxKhy1DAd2eIycMD+RLIXaJrjwrG2fQm1XoQJbNZHtxXOOUggiEBQqyXsStqmcasZrmxZROgFfFTbsQqF0Av2z3KQqurZVY7kqTHkMblT7LLVBIu+1dmyoRoAe68IMASaRw3FfChwXXGUqgxcu2+TzKNMtWNYmQfR9uV74d5+xWBUd4eh7epht3eQ4ZGz0++S/Bz7Rscnr+Gfq2+yvs2nLK68dwbgNtQB05xmYXDlsuDv7yPPHbucXQgg3O4hj8pn/4R/+oa/QDaq0vSq8O4wP5il1sP7xH//xKqaqFxCDzoGeU5zaby/aWLViuVtvH99d3zr/GcYS0L5RM/WFLttY6cHKgaaN1WIm4Rgu9MKiP1YOEDALoR6joJkKTnBSROzgcHKvEzuEACddZfuqUhx4ATLPy60VHVsHRYUOy6p2Ntcb9p/wSM/bZvs8fJoTe5ygwwgHRLE+J8SBj6+7nVCecLs43HS8XUBfDwf6eoPYW1WFeR2em14rJjZUzA38PTc9Fsrq3TWu5ziW23DQ6A6ef5jvwSb7WLZtq61v8t7lBB7/d7h+mM+P39HadpSU7jzXPQLhIDA5eb36UIcQws3Gj/7oj7bmHIXCEM5ArnT6PN84qIe1cKBxn5dENMYr2rGrr4VWpGp3qQmlO6VRZ2tCvA/EqCHcs6LZVk08d7e37ysnGiu+rLCGdc+SImK40ArfxoGmYlsTDkUtR7hsX1VStrPieZwQu5A96kqvtXY2OuH1y/UUFcoxHBLJnAwPtexaRxk27J9Rmfs8tTDN6y2gcfnKtlDlcbNuDD03XRNJwsPpvUr4zQxjcZDLYRnrWDnMxJ2OF5/A3ZSDbrcez3sSzRJCCOH6422uVGk74vloUEFoaToVitb9ij5WDrSj9F/pSIVvl49Tyyot9/b22gLcuxTCDYorX7LNayLa21gxCFjxi9mE9rryoIUGUAOL69y5obMUETs4KtqkyrUIgU2c5LKdlYfrX49CUF5VGuFKld+a20JoM7l/1wsVTOKi0PKync1BKvE6Zdiw9tfFWy2flm3SRMOmJ/+HcdlKDiM0jpqypU+terKgENOqyQ5PZfCoAA+nHwq1FptOprjju2k+7FHijiqQB3w9JkIYr3X7X+b/1tb5bm5yXPtraZ/9/YeiAUrcoV83TkzA0VZNlcv5fhMxMRT27XgYf8K2QwhhexDOv/Irv9KEo4Uq3IhotbIiZFtVuKnAjZG6MFBnuMuI6LIXtJALXTFrq9W4mw+rcG/FWA70rFmOM19qYTWUC00oNza8mmEzMKrEjW2P+3zq1Kn2Ps1KRDRvT1ngqNa+qqQsJHbQ6tvb4iekCKBVLYtuFJxoc9KLWHbBXFYD3hQPE8bNVpsavRZjUBMXnmdeVluv4SH82o8a68J2/TV2hXK/hqonw7pjx4tDqZhYWTysNgHln8cmBbXK6I5dcbT9O+eTBkfJugJc5WP82D1oRX7fJ8919skD75u9ik3b+6maeVm53CcMV8FvBBXmuWwiuEMIIYRdQa2s6K6EQSqtRw40OpA0XnegEdFU4UY31lpYOd1turRYx6jdqcItR1JL7YzvFD2gi6e1MexUVNMNqrLGzAMDtzjhbJ+vWQlICPd2DFV5XuUkl+2sVuXgHgVlVeQh1rX9GXrNw1CGVjtsowunTZ0rh89CDrNa65SVhWt4BeQywqCGO7TlMeD7sOp1DjtJcNS4K76qgB3iaZPjAadQMB7+eQy1dfL+zLUWSSX+edRqEtwoXAieP39+7Xh95Stf2df/+qAwvquez1j6/f7b4L9zvM66CSAfd9/XssPAulZvHBc+AcLnP4TnyyOA9T7qax1CCCHcjMgQRTyTnlvrtIQWfOSRR/pC01zQjEQuK3wbB7pGZ97WwrVH0ZBjCej5h7XDlqtxWz/oxquldTMHgzMAzDyUt0lEqw90OBxepdVPgtc5yTV37UZUVB5yvzY5WfdcyMO2bEIMIw7IbyZfsfaeCpHfFneVaJelE/OyVZJT9pLmRHzI+axVAXbK9k48vkRh6rsOwqb2mZRh3qtwMcxkjY/d0MSOT4QA+dhDIrr8PIZE+Vj4d7dsh1TiERH6zIeOfRX7Y1z5nhwW5QTX3ofv76p6AGU7KaJCVm2v31cWgitbvfEZ1uA+7xl90BoFhHFrjBXKvQqfWLuR0TchhBDCYcAUVYFoN0vFwnytPs8daKc0cOU4Wzr0KBpyzDZWfVlwd6E9B7qLU5/LidbsAXa8u9DArIPse1wkn5lgsGm8Lbc6HIyyTY5Y5yRzf+nwrgpPHBPPB1Z4oxd14iRyk+rcvo88jxPWM2fOtOsIrK997WtrXwPx+vbbb/evQe4s26KxYNvc2efxh3XpvfWYu9jrxp0cVbnCEghMPKg4GaHNXvwKEEjlJIm31ALGHiGPE8u28XydvHsbqF0BwasCYvq8EUOqrowrOdRru4bEsCp663mb9Ct2N5VtUl67Pg+2xY/hbQtwbQLHpn9uiF2+D8DnjOiUoGP55S9/uS9yxfaz3RyLQ8c+MOaHRW2k2C7qMBBFoO9qWVCw1luc91ZuMd8fvqu8jiIt2P5SfNaKAvJ4btcEEr83bMOqbWJsD9rvXKHcEugsh1I14P/8n//TRwPxuMPUWgghhBCuN+qkJAe67AdNGPcTTzwxaLZ6D+gybbgS0u11rndHQLclzSwhW6u+Q+zMuXPnjinf2Xdc4lmCmKbZ5QmDioixJNH8wQcfpLR5nOhD4kXBYJP+pjUReD3yn6EUIKzXXFW2Z1WeqQSQJgI4qXY3iedusk+c0HuF7aHt4f22ceDAW1qJdSfmtTZbnNwPTTIwvuQH13ARAjXHlu8rx9SmTu71gnFwQTLklrP9x48f32gShrEq97NWzK3cjoN8HhyDTIJcD8rx8e8DQtGPNSZYOE788d66zWGf2YdtUjwQ7HxevMdQeobGtvb7pUr57mIjOIdqA7CvQ66/bpeIXrVNet/DROdwfHkhQl6Hwoi19Brfj01ys0MIIYRdgBBuRDSmKO3DFv9Tr+o+ui9hoKIHMVSpjeVFxNCSXS/ovoiY4yK6K269dH8nW7fSkKOEcBcJ2UvuuFfgVo8u2e6boDZWrHfiuR+Fu+++e9Q2XLcSnicLmzjJZS7g9czP1EnyqrBlTrY3Eb+c1NcEz0Gq2LLvuNW8ztBJshyhbceoDEXdNCxU27iqFzXb9tWvfnVQPOt1OIEfEkIqnLarVYDZPiYA1n1Om1J+DxjDTT5jxpFiTxx/qz4PjmMu12s8GZ+hCZlaoUoeL2e0hsaHY2/bCTZ9NkOvo/dZNf7cp9cYGlO9z7qQee7nWBp6PznhfF+2SW3xUO5VKQbl70IIIYQwJYgoxoXGJFW0MR2Y0H9QS+mVeAYXzx6+LS1aEc/NGIwSAl0Y0C1DPaArhcTamQR3oTXjsDgBOUYpc2x87vNe0DjQiOnz58/vdOLXG2+80a/ff//9Tdgehd4qpFlC/qCCQ9WnSREgN3qbdlweYr3ta9XwFkuc6B/G1VPOt/b3MPnrPmbgOcFTgOOGcdyF7S+35bOf/ewNrbhdfq82GZuxvoubMNb3tUyHOOy48xp8fnot9lsh8dcT1YSY2ncxhBDCuExJc5w5c+YeD+Nm6TnQ6D+WZR9oXGj1gcaQ9SrcZfh2zX1uRqjADWPmELd50FoudqJ3hz0H2kO3HdpZyZ5fDMwx5UBLPEOZBx0BHW4FOOFXGDgn6EMFjEIIIYQQwq3JlDTH2bNnj2uddlYvv/zyVaXqSjxLC0pEK4Sb2lksqavVVeHuBTTLMgfahbSlHd/4EG6DUtytI13ryVWiPtCsSzyz9NkGDaKDeF48JgXEwi3B9azKHEIIIYQQwlFD+DZLalpJPPv9iGdvZeUQxi1jtox2dgrxvHt9oDvmtZw57ViZ5C03GhEt8azZBRLGS3xgF67cXNZ/CDcLKsik6tm0xJGAXtW6KoQQQgghhClw4cKFNh231prYo4/Rg88999xVd5+VA42u9BbJsMrARaOOlQM9ioBWb62mCwmXiN7EhSaOXVa8RDTr5EHrMSoi5mD3e0GxEG4GCNem6jA5z1/84heXqvzGfQ4hhBBCCFMHHTeE674XXnihjVKWPvS2x9TV4qJU4dOnT+9zo83YbVtiteW35/Ot9eNoVbi1MVL27EDRxqp//GK2YGnDyx7Q69BsRRzocLMxVG2Xyr5xn0MIIYQQws0ChaGFjFGqcOu2MiIZ01Xpv7jPXLzbU828nV+jscrcuxPCLYUve3xvb6/fuG5moF0n73kxW9Dfp0FYhQbSq3ATNx8HOtxsUGGbllJqXYVo3qS9TgghhBBCCFOBelaf+MQnehHNegkONBeB6aoq3HKgWfdK3P78Lu+5R7W6mi0ZTYBqA/22WlL3Jm2sWCqEW33AaGmlgaWImJ577ty5t5sdJlW4QwghhBBCCEfJFKtwlznQqndVa2OlPGjo0n8lmtvbrOtT6TCXVbln27rQYzrQK8W4QrhxoMv7SvEMVF1jefr06daBJlzbbX6IAx1CCCGEEEII08NN0bIKN2CougMNONAUEkM4u3jWsmLgzvyyUyHcRj8j4LCDuM/eB3pV+Daly/064dtyoJmtqFVtCyGEEEIIIYQwTbyFMQ70iRMnljQfkcvQFRBrl0XdrUEHeqeqcMN8eYtmpYXOupK95UIzg+Ai2q15t+yBWQmfmfAZixBCCCGEEEIIuw9trLisAwfa2xyrcxN0BcT6VlZlAWuTpv1tawKmN+b2ZgSU/+x50G6hd2XFm+72xl3oIRgw7wMGuNCEcdM3jCJii2UTQgghhBBCCGEa1NpYofNklqIB3Yk2iGZWuLaHcLNYeryL5U6jzrsCYruRA+0VuKG0xykrrnUXzzjRqqQGzDB4nHtt4Ajj7sTzLDnQIYQQQgghhDBdJJwR0Yhn9YJWTSzrA92HcLum7PKhZ7UC1tBp1Nbn3dUc6EF7vKzAXTrR2PNlvy9vpq3BRTw3IYQQQgghhBAmRWmCyn3mgvajiDSoJpan+ar4tEK3vYCYpQ+3Nbms/7PfvjWjCGhznOe6XisjrtznWiXuEmYcmIGo9YBWAbGTJ082IYQQQgghhBCmAd2VWHpRaGk9aT9BdLJ3alL0MmHbXRj3kubsdCgaV44zN8+6el2jmLCjhnA33Ubp+pCN7lBEzBPCgYFixoEQboVxMyOhStwqIHbx4sUmhBBCCCGEEMK0QNOVbYrLKtxEJ+NAu4gWhG6r7pZ0Jzq0E9RLolp1usaoxH0kIdwL5pUS4n2it4duM4tQ9oFmoFSF+6WXXtr34uRANyGEEEIIIYQQJgmaDnMUEe0FxMrHoRG//vWvX0U3kgPNRXpyhWFbu30+RiXuUQW0xZgvbVlNTNdQfDsONFW4WVcMPGhg1Q86IdwhhBBCCCGEMD1U14qQboVwAwYqFxWXRiNiuBK5vBDOiOc2B9rra5VONMhtLqKlt1bQowpoNq4rD76E74jnPy92fOZ9oIU70DVk9SeEO4QQQgghhBCmQ62TkoxSwEDlouLSZfg2ehLxrEJiIL2p8O0ubLt/zryjGaGQ2JgCut2YVba49+vqdrxvY8XAeKNsOdCOZiZShTuEEEIIIYQQpsfly5f7ImIL03RQ10kPehVuKDs5QVGFe1a2V55doxmDMYUor9U2qGbjhuLRy1ZWpQN95cqVGbMNLqA9Fl4imqRzZi/Onz//vWaHeeONN/r1+++/vwkhhBBCCCGEMZmS5jh79uxxrXslbrnQZSExli6iZcB2kc3tulfjroRuN81ILaxg7CJifTL3UN5z2cpKAwA40KV4rhURUwi3SqCHEEIIIYQQQth9VoVw0wdat9XEs0Nkc5n33AwXCpt1wnq3cqDBSofvKx6G+yzLXctaDrRDLzDNQnhyeQghhBBCCCGEmwO0Htrv4Ycfnr366qsbGaWnT5/ujdtOSHtb5aXXqN12GEYX0N5bq0jmbquleREx1uVAE7qt2QUvIIZ4JoTbxbOqcNdmL0IIIYQQQggh7CYeRex9oOVCX7p0af7444/3Ok9FxL75zW/2kczSlC+99NLcHWjWTY/262O5zzCKgFblbd/AckdYMkMg55md9gTwEydOVGcDar3AyH++cOFCE0IIIYQQQghhOkjHkf8sY3QTaGWF+YqGVGFqj3hWITFzmvtw7q5b1Cjpv2M50H0Fbl2KSmgtzBBo3UO4NZsA6vdV2vZe2pzBfvTRR5MDHUIIIYQQQggTBFO0vE3Rx9KCaMNaDjTdnaAsXF1cX7pvrDLcowjo2rZUErrbHfV+XcAsArMJrKuIGAPltr1wEQ0J4Q4hhBBCCCGE6fDAAw8MajjEMyIaLUhhabSh94FW/SwcaOpree0tK2TNRc9Zqsw9BqPnQHcsFRGzxO52R8tK3CVqmu2QA10WETt58mQTQgghhBBCCOHmQF2YvC5WCZoSY1aiuewCpZTixaXVu2MVEIOxcqDbhd3U7whXtCx7QDdmqzOzIHteYdwaPMqZu/vsyeYhhBBCCCGEEKbBqjRc3OfTp0+362pt7CHcTz/9dLv0qGYX0d1NM0spvqrHjeVCjxYCTSExNrRU/16J+xd/8Rergt1bWSGkvQ80qJCYHOjFbERbRIwQ7vPnz3+v2WHefPPN/sO67777mmPHjsr0DyGEEEIIIdxqoDXQHIAe++hHP9rsMk899dRxwrgR0tS24jaZpWpfDLU+0FY7q49wdioh3D3za4K12ZbR1Jw2piaetT4Usi0U385gccGB9ircGtgXX3yxXU6hiJgL5qtXrzYhhBBCCCGEMBYffPBBvz4Fs64mnjFKiTqudWASEs8LU7YVzrVK3B2zmts8Ug2x0QT0RlvjMwQupj0xXDMMuNDY9wyk7pMDfZBy5zea2267rV9///33mxBCCCGEEEIYCxfQrj12HVXhlsZ77LHHZqrCzXVFJUsrUnhaxac9NVgR0FwQzlyU81ykGs/UfnkbxmxjVXWDfUZABcRcPC/We9HMUgOk0uWKgfcCYhpsQrmbHef222/v1yOgQwghhBBCCGPy3nvv9euuPXYVRRHLgXZqDrS0Ig60XOiys5M6QJnL3IZxu+vcCeutI5jHHGHf2T7uvGxlpf7Pdp0c6KUXoogYlbgXsw79IMraZ33x+PmDDz44u3jxYrPr3HHHHWrc3QpoLlM4sEMIIYQQQgi7DdrCHWi0x1TAFC1zoOHUqVPNpUuXlqpwe8TygrkcaIS0V+EuRXJ3vX3sGOIZxgzhdhe66gz7TIG1str3uFobq6nC53XnnXf21995550mhBBCCCGEELbFtQWaY6w83xsFIdwL8dyn9Op2d6EXmrIXzyy985P2XznQe3t7H1rSI4Rvw5gh3Cs3aDEjsHRdTjQOtNDMAoPFRY20db9mJpQDPYUiYnDXXXf168wSvfvuu00IIYQQQgghHBY0haeI3n333c0UoJPS0H0ewq2U3sJ9Ji143jnP/W2sWyurWVHgem550Vszdpm2fVulHGgKiJUiWlg58hZV4fYk8hqrBn+XoBqei2hmijzUIoQQQgghhBA2BS3h7jNaY6rtcj18W9CN6fHHH9+n9dx87fTlUjsrXS/c5lE14ygv5rHlfptb5sIrpgEh3KqmBu5C67ayD7SKiE2hD7RgPK5cudK3suIAv+eeeyZVKS+EEEIIIYRwY0E8L/TQkq44ceLEZMK3z549e9yvex50rQ80lL2gEdJlITEo8qBrA7J1BPMo0xS1D4vbyp5cLp6VA414fvDBB/ftiAaM2YcSBplCYs2EYDwWB0Q/M8QBv5gYSDh3CCGEEEIIYSPQDmgIF89ojKnlPmOEoufKImIYp9J/GKqPPPJIv2MIZ3TjkHgWqhnWXfXHrU073oQxR3rptcrq2yABjXgmB5oEcGLYF4O31ONL7jNx71j3DKTc59dee62hArde89y5c283E6KcMQKqcpOzkOrcIYQQQgghhBJynQnZ9pznqUa0ugNdCmh3oAE9uHDXl26T+VqKaDdvsaFNSCusu71v28mGIwuUVzNrrbOU66wCYrpdOdBuzYPEM+teQKzWM2wqcIC7Ew18EZhJIsRbxQD0AYcQQgghhBBuLTDbJJrRCVxK8YymmGI6aK2OlcxSab+FOG7FM92ZvIjYUB/oMvLZ04sXxu6x4qatGM3y7ARf+6fcOist3j5GTnTXA7qfFdDgyHnGvn/sscea//iP/5gvljPvBT1lOODvu+8+Dp6lEG7caW4LIYQQQgghhBoUDCN6deotqxwvJKYQ7q6I2L7cZzh9+jRaccmsFWXFbVXiZn2MMRvFgZZ49nhzRLOEs3YK4VyrxO1FxEB9oBcD0y4RzywRzz64H/vYxyZ91HzkIx9phbT3iQ4hhBBCCCEEB52FcEY7oCGmLJ4vX77c6jmiilUcWhDCLQ3oRcTANSOFqIcoekGPHtY7Zgh3reeW9+NqrXZcaIVyAzHsXBYzCn0INznQGrAyDt4d6MXjJh/njBt9/Pjx5qMf/Wi7REwTinEzzSiFEEIIIYQQNgctgCZAG6ARJJyn2qrKefTRR9sl4rlMzVURMfWABmlEHGhqaLmWxJyVcVvU4GoLhlk7K61vLbJGCeEeCCjvnWjdgANdFhDjdsK4FzMKS/HtL7zwArZ9U+sDXc5U3AwwhHxB4kaHEEIIIYQQblYuXLjQi+gaONALM7Vdx1hdaMRWRONAP/fcc02nJdcZqS5R53Z9N9pYNdcKnWljymUPO2oFxK4ipmv2O+6zGmeT/9wMUEtADyGEEEIIIYSwm5Ti2etcnTp1qr1NXZk8jPvpp59uo5fRkKqp1dXYailyofu858Zc5zEKNY8WA2AKv1/xStwlCGkuHssuex73mcHCulf+c42PfOQjKVUdQgghhBBCCBOD8G1aFHudq1deeaW/XyJa4D4TuSwHulZbq2Pu4dqI5qJm11aMJqB9w7gMxKLvQ6XIWSqEmyJiDBgutHKg5TYzyCGEEEIIIYQQpgch3EBa7uc+97leKxJ5LO2HkYqhisHKxVN9AQda7rMMW9Odfbi2+kHv7e2Nkv8MoxYRG3Kh/UFY7uQ/s85SpcifffbZY15ETI9XDrTcZu8DnRDuEEIIIYQQQpgODzzwwFJRaLnQRB5L+2GkdvnP7UU6kRBulp4DjXBW5HNh3s4kUL2V1baMKaD3xZjXwHJX/rOKiIEGZYibof9zCCGEEEIIIYQPwSD1VsVAJe6yjRUQws1SOdBlyvDCae6FsvKdPe/ZqnIfmlHroM+LrOzKLECL8p8ZAA0CyJpX/rM/xwdVVbhPnjzZhBBCCCGEEEKYBoosXujAdulFxAAXmkrcikp2o1UOtFpZlWnDneG81M7Kq28v1nemCvdMcAUd7eJZswKLgVgS013/5/a+Sgur9nrZB9q5ePFiE0IIIYQQQghhOpAHvdCCrd4jLVdmKdqPC2aqDFXXiTJfvfo21IzbipgeJaJ5lD7QTRG+3Sn7fgO1Mwsrful2RzMLDJDE86oe0MxYLAY3Yd0hhBBCCCGEMCFoZaUq3IRwN51GXAjpVkRTVHoVhHCXedDFQ7r6YTPXqTuVA11WNVvaATnQKjUuy70GVn0t3l0w0Aw4MxZpYxVCCCGEEEII00FVuE08t3jKrheVXhXCvQIJ5pnlQs92KQfaq5rNy1xozQjIaif/WfepCrdAPBPCDR6+7f3BXnzxxQjnEEIIIYQQQpgYqsKtEG4H/VdGIZctrBbieV8Id0knR1sRrU5RLHcqB1ortrEtZd6z8FkD5UGLIcteyeX0CyOEO22sQgghhBBCCGE6KIpYrYllkqLtEM/0g+a6TFWHHGgMWK/CraXnQXdiuV3tnrqTbaxmcp6tH7TynvudU6w6LrR6Qj/zzDNVIcwAyoVmYDW49AtLCHcIIYQQQgghTBtFGpfaTnWxABca01Uh3EB6sEU694K6jIbu7h9N947t4O4rHFai2QLEs0K5VU1N9rxi3t2+9xBu1ikmxizF+fPnv9eEEEIIIYQQQth5nnrqqePUtCKiWDnQnv8sA5Uq3IpMVh60C2jwQmLQmbZoyKvNfq3bams3ew/DqA60X/GG1nZbv+7iuQzhVhExBu/UqVPtbaV4bkIIIYQQQgghTArEs7exEgrdFkNpvV0U85yla05bd/EsQ7oV1tuKZxg9B7qpxJZrZxDN5SwBswhDIdxw6dKleTmYIYQQQgghhBCmidpY6Tom6WOPPdZrQvWAroGmJKqZQmIe9cx6EQU996rblcjuQzFmFW7RbiQbKOGsHfGEb0EVNTnQWPMki3PxVlYaTBURA2YtTp482YQQQgghhBBCmA4qBl1GFit82/OfvY2VUn9VkBq9WSlarettH2guXej2KAr69mZE+m7Vldjyrioaq/0dRR50mwONeF7VOJt+YQvXup21oJhYE0IIIYQQQghhMly+fJmiYTOvxN3VvFpqZTyE2lhh1JZFqyWWu6Wqcis3emfaWLW4eHb7XLMCuM+1pteaSfDZhVohMSBW3u3+EEIIIYQQQgjTATO0xAuJDYVwexGxMrIZ/elGric8eyj3toxZjKtX9Opmtbe3t+/1yx0FCWi4cuXKDAcaAV1W4da6rP5U4Q4hhBBCCCGE6XDmzJl7aFk1VIWbItLUwWJdab21KtyqraX+z5Ui1nKd/frWjOJAe2Wz5prYn1VCuNslDrS70C6ewcO33b73QWWwa7MWIYQQQgghhBB2F/V7lngGzFIKR3NBPHs9LMSz2h0vRPNSDjR45HNRKOxIOjcdiQPdre/rBV1zn2GoD7SoOdHpAx1CCCGEEEII0+Ls2bPHWZKWi6Zj6WYpYKQiolUfSw40xacpTO2dneRA+3WWlgvd6tQxWljBmDnQvQPdDNjjtfznGj7jUOZAg0K4U4U7hBBCCCGEEKaDKnBTHLpW2wrxrBxoRSdjtCKey/bHK8TzXIXDEM5dePQoCnpMAT0r19kB7YRV4W6R/e54ETGQeFYfaNxnL3V+8eLFJoQQQgghhBDCNFAIN8Whpe283hVIZAt0YkU89xHPRSurMvf52o0jNYIetY0VqJUV6z4bcO7cuWOUGMduZ2ex3kuYWWBwKCT2+OOP9znQ3lRbsxRlz7Cpw+f5gx/8oHn//febDz74oLl69epozb5DCCGEEEII0wE5dezYsea2225rbr/99uaOO+5oxgpBvtFcuHChrcJNXStEtG7HNHXdJ5QDLbOV9N9vf/vbaM1eLKEzrZjYUM9nvfZWImvUNlbNtdjyfRY6WH+uRr2fBXY8Sw2OFxKrhXBj998sIJQXMyzNW2+91bz99tvNe++91wroiOcQQgghhBBuTdACaAK0ARrhzTffbJdoh6nzwAMPtPqOImIewv3QQw/12nThKC89xyOVF9qxHQR0Jc6zNGdRibsM2Z4Xy0MzmoDuLPF9vbjKcuKleGYGobTjh1ByOTMVzFhMOQea4ZJwfvfddyOYQwghhBBCCIMgptEOaIipQ4i2RxSj8xTaLQOVAmI1pCdJD8akLQtXF/SCWjnRzZaMFcI92zSkgBBur8atZHAtvUx5CbHxDO699947W4jO2VRzoJk5WhwY+2aQCM/QhZANLiGEEEIIIYRbCznQcqFZCsw3Uj8XmmiyekFimchib2cFhHLjQD/++OOzRx55ZF+dLIH77KHbA29Vhm1v7VoeRRur/jXLHVEv6JoL7aLZ21gxA+Hx8F5IbIptrDj4F9u/JJ4RzHfffXe7DCGEEEIIIQSHOknvvPNOuxSI53vuuafNk54SZ86cuUcC2kO4MUolnkGdmUoB/eCDD87p7uQFqsFyoL0Sd9Oty/DdWkCPoti6Hlv9EsrwbYnpUjwLDQwFxJ544om25xezDhQSc/HcTBhEs4tnxgrhfNdddzUhhBBCCCGEUAOjDccZ9xkhje6StpiaEy3xLBDO0nlf+MIXZq+88krz+uuvt4KJ2lheQEy1szpNufQ6pXk765pANx9GS89drx6WUUba1Py+HGhfsqNlL+jF9ebpp59u11VADAca8cxttSJiU4QPy8O2Ocg52COeQwghhBBCCJuAdnDBrNTQKdVTogo3kcS4z0QWK02X+y5dukS67hwt6IWlBSm/tW5Owgzcdjm7hq7PZiNUMh+9CrdWvBqabiP/uXwCg/Dcc8+165pZkF1PA221smJgiZGfavsqZorceZ5iuEUIIYQQQgjhxoKGQEtIDKIx0BpTgRZWly9fbsWzh3AD5ikX9KCKiEkjErrNhfWyrtYAreMsF7pb31pLjiKguw2ZdTb5yscOhXCD8qCVA83MgxxoVWZjkMuB3nU4qAm3EIRtRzyHEEIIIYQQDgNaAk0h0BpTaXGlPtBC7jP5z5inLD0iWRqRull6zhrxPDd92tvOSNWB/tAHYswQ7qVE7VV4GLdmEYDZBS7MODz88MOzofBtudBl/Pyu4jNC5C8kbDuEEEIIIYSwDWgKL0Lsht0u4+KZCGPlP6vulVBUslD+s6hFNwsJ5aMIbR8rhLuPMfcbFca9rhc0lK2riH9n9kHXGdiyiBix882Ow4dG6XnhM0UhhBBCCCGEcFhcW6A5ppAL7RpOLayk8zBQVYX7kUceaW9TCDepv3Khy7paYJpz1l28YNh8rLE5inJt+ypva6k2VtphCohxYTZBA+NCmsE7depUuy5rf2rQo00QapFWVSGEEEIIIYQxQFtIXyAQXXvsKmULK3SetJ7qX8F3vvOdffpP0culIVsatk4nnFWGe2sDdkw1t2oWoAUh/e1vf7u/rgpqHs/uvPTSS21VOfCZClVsO3nyZLPreK+2O++8swkhhBBCCCGEsUBAS3OwnIrmUBExjzJeCOleRJMHTRi3t7ECtKOnAXv/57KVMniQ9M7kQButXV46z+W6zxjgQIsyjFv2PcjeBwYbQX3x4sVm1/nggw/69RQOCyGEEEIIIYyJR7i69pgS7kJjoiKclQPt4hkknlVIzLWni2fFbCt0e5QeVs3IVbibay70fCj32VEYt/fx0uCoCjdoBqIM4cb6n0IRMa+GFwEdQgghhBBCGBP1hIYpVeJeOMlzioiBu9CYqK4HHY9clp4stWdFMM/nIyaHj1mES3Hlc22su85OWXZcA+EOtA8ayeQ+qN4L+ty5c283O8wbb7zRr99///1NCCGEEEIIIYzJlDTHmTNn7lnou6sLJ3lGRe6XX355n+p//fXXr9LGyl1o6mbJfFUFbmpsLTRn/7zCgVb4dm/0NiMwehExt8Z9B2puNOHbtfxnt+m9DzTLxSD2j59CFe4QQgghhBBCCNcgihjxTP4zTrQbpUQfc3niiSeaV199tRfPV65cmVGFW4/DkOUyJJ6BfOfOeJZA350Q7oJ2Q7l4HLrcaHbUw7c9AfyFF15ol4vb9m2XBnbhTM+x+1mfSh/oEEIIIYQQQggfmqCEbyOiPVVX5inRyIhoIEr5xIkT/WMW7vOsW+4rWF1EarferlXeno9RhXssAe0NttoNlRFtLazmamNV6wMNDBIiWrMNoF7QPrDMWLCMAx1CCCGEEEII00EmqPeAllkq7QdK6S2LiC0M2XkpnmXa1uqE2W2zXazC3ZcGL6ugSUhrZ2vNrxkcRLRmGzQDEUIIIYQQQgjh5sMrcD/22GO9/lP+c9mpCcqaWmXtLRXg9vWxComNVYV7KVl7CMWoy3YXHsbt+AyEo6bbIYQQQgghhBCmA1HESsn14tBDuAOtFsilAy0kpDtTtw/ptjrXWzN6Fe6OebmRngPNEhGN/c66FxJjhsErcNMHTDMRWPs+yAz++fPnv9fsMKnCHUIIIYQQQjhKpqQ5zp49e1zrMkblQKuFsaj1gnbzdSCUW1pU9/U50M0IHEUOdK/wEc266H4rOd5WQ9MsArg9rzxoiWfEMgPr7vPJkyebEEIIIYQQQgjTo3SglcLL0utiAW2sEM+eCnz69Om+3pY91I1ctVpuxmLMEO4+cVsbXGtdJQdahcTUy8thpkF50IJkcyWX0y8MqMjdhBBCCCGEEEKYBLSuEjJHvZUV4ETTB9pvo40V5is6ElMWHblws1tTtsiBLp1nb2m1NaMI6E7i71P3ZTJ3SVlIzK15hXG7jS9rX4OeKtwhhBBCCCGEMD2UBw3ovLL+VS18W72gMWUX4nle05tEQ9fE8lg50EfiQDcD8eW0sfI4dW9nVauuBl6JWzMTGuyEcIcQQgghhBDCdFA0sdpYCaXubtqJCS3pEc++vre3t5T3PEb/ZzGWA90uuqtzW+93hKWqcANFxNyBZmahJqKZiSh7QWuwL1682IQQQgghhBBCmBbkP7/22mutxsMoleZjSf7zCy+80HCpQfg2xqw70Kzj66JNTUzrttFSf0ctItbtAJel/s+deF6qwk0FbmYNvIiY8IE6ffr0vircm5Q7DyGEEEIIIYSwWygNV1HFaDxEtDQf+o/8Zy7UxSpNVvSja8iK87wkls3sHUVDjiWg+8raqsLd2AauyoVm9oCKalxwoRHPKiBGCyunrMIdQgghhBBCCGE6UByapYdwl0XEcKDLKtxU4O5aWPWVuGXOAkJ6IaDnFq4992WXF721iB5LQIuZVeGe16pw1yAZXAnhiGcKiJE0zuxDCCGEEEIIIYSbi3VRxTJVVURs4VjPuHgdrYWQvupmbVEoTKW3Rw3jvr0ZAcWaq2O1bl9Xhdspe0CXZct9VgK7fzH7MEsRsRBCCCGEEEKYDuqo9KlPfaoVt6+99lrfaenOO+9s17v+zu26dOLXv/71q2qBjIheuM/NuXPnZi+99NLcH1+KaN02loges4iYxPPgRrnFXsLMgmYXEM9u2ZNIrgJiUFZsCyGEEEIIIYQwDajEjQNNei7ajrDuT37yk+19RCFLCxKZLJ2oiGWggBhh3IhnrmspA3eo5/MYvaDHDOHWxi6J5DKMu+z97Gh2gfBtRHSZAy2o1gapwh1CCCGEEEII00FtrIQbpRQSo40VWlBpvdKI1MxiSQExjFnv8AQqXs26XGgtFTE9BqNV4Z4PyHnNAtADGjxmHYhj17ocaAaLJbMPDCAD6SHchG+zTAh3CCGEEEIIIUwHVeEWrvPuvffeORccaMSzP84c6KruLI1byVMP3R5DRI8ioLvc53ZdyzL/mRkCrHbZ7brdqqktOdDle/jMhIgDHUIIIYQQQgjTQVW4a3gEskxVmayiNGRFqT8t73lflPQ2jJkDvQQzALp011urnUvX/7m34LlIPJcD5JQiOg50CCGEEEIIIUwX13jqwqSC0rQ4lk6U6SpW1dcSVui6vdqMwNhtrFZlZS85zz5zgB0v4cwAMVACC1/r2Pte7jwOdAghhBBCCCFMB1XhFgrhpnC0HGgVEVMrKyD1F+NVENncbMasC+cepY3V6H2g2Tjscy11B+sK49ZtCGqvpuZVuHUbOdAsGVhmJ6jUxoWBjwMdQgghhBBCCNOBImK0JS5vp+4VF9ZdD5YRyohoNKVqbNWw/Oe5ta6ajRHKPVYONIu+x9be3t68lgstm11ONC50acWDZhw8Bt6tfVxoBj4OdAghhBBCCCFMCxWFBtd5uNBa97pYCuOmD7R6QWPOlmnDEs5Wn2vWLeZd0eud6gNdve475TMFEtFY8Yjo/8/e3wfbcp3nndja1+AXSMACQUAACJJXEGRQAEgTIgmLCCkgppxUaQRpOFW+1sfETg1lyilVLDlJjUu2M3OTsqRMKlWyNOU/SEmTqcyEki6TUkmgXI4sUASpIiWQDCiBgIAYhCgWCECgQDK8BD9E4u7pp08/fZ/9nnd1996nz717n/P8qs7p3r37Y/Xaa63ud71fCEt+9uzZ9kCq6mkDT7U+l9BAY2kNtDHGGGOMMcbsFozE3QjJbbYlynnQQGepjLM4WV0qq8WZM2d6mbZR5OI8cV98XlCYLgdkLg30Ym+xWlYIzdRAd3m5Wq0z/6B+h/DcCNYLmHJTcGbENZJF4EZlF2OMMcYYY4wxOwUiccOM+4EHHmjlvCyQmMbFAjEPNF2DG4G7P7bTRC9CRO7eB1rMuTdmLg00pfp+W+fzvCLkQmhWH2iq32POriyNFdCKbYTspU24jTHGGGOMMWZ3oPYZZtxqyk2ogYZylZpnWioDyJCwZlYf6Ch3wqU4ufQsCthLyrz0DtpRKMYNNje21HDj0Dw328+VgZuBHTydyTXJtjHGGGOMMcaY3QJuuI0ytF2Hay6UpAwYHffVVMewWG601q0Fc1TMAvWD7hS7rZIXK1T4lhmYLQo3A4nFyGa0SYeTN4HgjGUjTC9ribCbffZtY6VqKitjjDHGGGOMMbtBtCKOwjOVp9GtFybcDEBN4VmVttRCM/dzWRWYM9/ojZhLgG7Nt1HorsD9DdAmHRroW265pRech04Ge/f3v//9+/ZB5arvs4OIGbNKM7lUjAFuC9uJfxdjjDFmDwaG/sxnPrOyXSNxQy6E9rkRnkungaY8qXG2VoTpIDyvROeegzlNuHs7dFGZt/DG3ve+9+1LY4Ulc0GjcqimR+4v2L9zBgJ0ldtXCPygizkwf/RHf4R82+16M0lRXve615VdR+/pLW95Czpo/93jjz9e/sW/+Bfti+zP/MzPlLe//e3lKPDbv/3b5Vd/9Vfb3xD31/ShYg7G7//+7/fr3//93192BbT/f/Nv/k27jjb+vd/7veVC8uCDD7bt8c///M/bvoc/1B/GlquvvrocR5qZ9fLzP//z7fjzwz/8w+UnfuInijHGGHMcoQk3rIohRJ88ebJ9TgIIzwwihrhYXZDpqvY4aqDhHtwF5qLMqFrpwvWDMIsA3SWo5nq7pEZa9wsBxBCFuzXhvvPOO8t9993X27ijomgX/7KXvWzZCEJtaHPOTqCiUeGOxH1w0Fh/7ud+rv+MF91f+7VfWxE4d5Ff+ZVfKc8880y7/vrXv37lfvAdtUDvfe97j4wA/eu//uvtEr/p7/zO77SCkzkYv/RLv9Sv75IAjXbNNo62cKEEaFzzX//rf10+9alP7fsO247z5A4mNSA8A0wu/NAP/dCxnUwwxhhzvMmUoDTj7pSnSyhS3/rWt64oWGHCTcUrgbvwqVOnzokgvQhLwqDXWxOFe0VFHqV6hhPHOtTt1DwzlRVNuhlljSHLMftwzTXXtPuiQjE7oTgK98GBpkjBCzBe7o4yqmHf9hf5u+++u/8bQ+8Fgoo5vqhgVhPS3vnOd/Zti5NNB+UXf/EXV4RntEntb5jcgQA91/V2Ce2f1MobY4wxx5EnnniiXV5//fV9bCsoSiFEQ3mKz5ADr7322gWFZ6DCM6Nww104y/4EdFuM03UQ5tZAL2LEM80FTah5xjq+g/YZqPk2VPZwHH/66af3RUxzELH5oNZS+eM//uPyYz/2Y+WoAvNJgMmCo3SfP/3TP91qG5uBp/zoj/5oMceXf/bP/lmrhUZbgKbzQoDJOIwdBObKFJ7VfJmTdP/4H//jcpxAXaCPYoIBv4kFaGOMMceVK6+8stUyQ5CmHzTyQndm3L0Q/dRTT+3TFjOImAaoJuoPDbr1Pt3yciZH6Dk10IMSPm9GhWdQCygG4ZnaZ3UkB0i6XcyBwQsvNUHQWPKFDi+5UTN9lMB9QnDGC/xReonFb4h7svBs0K7ZFi5UG9cxA24RqnlG24TwSGDOfByBGwBcKxyfwBhjzHEGwnLtuyj3AVopAwYRg/aZ8beySNxl1Wc6tZLelLmicK9EN6P/s2qfuTxz5kzr+8xAYjUaIW557733tv7PdCQHUO8j4TZmLIYq34zT1G+/fuutt674AkOTaYwxm5CZjdutwBhjjDHga1/7WisXUvusqNwHohk3gUKWWmi1dq74Qtf8ojdiLhPuVKKPQjSAzzMDiPEzTqE27TDfhhk31hFJGUI0v4MfNEwAYTPvIGKbAxMJFaChkWXwKQBtEup5U+0VjsU58PvBjBQal00D5sx5rk2BVp4BgCAI4G+dMujxF+seIqhXlIlRD3FPKNemvzmsGf70T/+0XZ/7HrUNsKwXM1q83utB6g339dGPfnT0PPpbbUv7iWh5siBivE9wsYXpOKag7NuoFd7GccMYY3aVL3/5y+U3f/M3y2tf+9rytre9rRyED3/4w22miR/4gR8or3jFK4qZD8h9NOHu8kBXFabQQKspd5bGai6tszKLAL047wDdb4uCc/wsgcRaVTxnFhBArAtX3oIKjOmsGIXbQcQ2R80tmVoGf1in8Aw/xTEf4Z/92Z/tX5YZvRtRrlU4J9Bywzez9gI457mGgG8ofb9h4lq7R9YBJhWy3K0oA/yphyIc43hcq3Z8dg9aD0oMJAaLAY20jbRFrKuh9FwQwrBvdg2eF3VSq1u9DvxasV/tfGPnGmOorGgfqPtoio/UU4yejfaMMtZAW0dQqyn7jpVn6F5xHNMWocz4fdAOM0uPmOKo1oaGrldr4/rbKQgopkypiwjSxeGamFxAvSKlGu8D96/xFg4a+T67P/ZX3B/KoD7YBOXCsdnvB6Ee59Ky4ZyoG9Y92tWYoK2/NcBYht9It+MzttdYd9xYpx1rGxjbV8eif/kv/+UFT4dmjDFz8td//dft8k/+5E/KX/3VX7XC74te9KJ1TlG+8Y1vlH/37/5d+dznPtceu+7xZj+Q6Rqh+RyjcFP2gyYaFskqFyIKN2RHAGUsLJsRRCw57SIIzq1ATcH6oJG4ZzHhFn9sOnX3JVYTbswSRNPtTgPdg0qCEI0KwwwEKvD2229vy4lKRSU7iNjBqb3M/p2/83f6dQ0INAVoSv7pP/2n6Qs6wIsYXkZr3x/WuTaB16+9xLIMSAGGF/IMvKhCiBg6HvdwIf1BUV8MZDS0z1DdK3xxr50P52DO7XVhxObauXFO3s8m518XtImhuuO9jkWYZqqnmpsEhCcKQ2hbtTZ0kLo9DDCJoRM6FGb5G7FeMEEwd+o49CH0JQrwGajLofbEyRHtz7gnDcI2pa9qv8F9rjN5hN8SQuvYuIH+qWWBIMxJJI1tkaGTp5wszUB9sK4wuWDh2Riz60BT/I53vKNcdtllrQAMbfTZs2cnHw8N9m/8xm+0x15++eX9ucz6wA2XkbihGKXwjM+IgUUzblokE1gs0wcaythTp04t1f+ZJFrnBS2m50hjNYsGOpLdCJ28qXnWYGLIA/3UU0+t5PnqKqzNBcYKBbSVtxC9OfqCRS0eQZAbCo0MJjbVVBYvfTgvzokXx+/4ju9ozwMTF32pxEsqvhvS5Mx5rnVhbmx9CUUdQPOD8qAMWoeoL2xndG+Al/D4Io3j8SKKeoXwxONxD5p7G78HTVzjOZR1TZjxwo1rEf72qD+gdYu6xr60SqhB7Tx/J+yP+8K1eH+ozynWDBEVhli/LCvOz7Li/LBUOOy812gTvFeU5aqrrmo/Y6KJQgmFfmgqaybd3Jd1hiXOo3WGfXB/nOjCb4DJLU4abFq3aIME16PwhHag5d3UYgDlhMDJyQFtbwD3q9rZOUBd6IRgliJKNdYsJ+oT4wbrnu0p9mcseSzuC5+HzPWH+uwYaDs02ebx/G3wW99zzz19JHPU7S//8i/3vxX2Zb3DCiNrE5lwjX117NJ9ibYbY4zZZShE/9Zv/VYrEGM5xQwbGuvf/d3fbQVuC88HBz7Q119/fasYhWwHt1zKe4899ljrtgSiBlq5+eabYd3MYGLLLI2VQqF6L3nUwYTouQXoFc1zCCLWC9EUnrFsZhJOdGmsovC8D8xOsKKL2Rh9wYsvznyp54sYllMFNbzgQfCjWa+Cl2rVlkFAHjIdnPNc66LCM6MHxzqgSaq+dGPygXVJ4R9ljObUOBfqndrKaC6vL7P6Wx1EQMQ1IGQSCA4wyYx1CxNW1aKiLlS4z86Lc6H+dR+YVaup6BTBI6IaNty7TvRgHWXlbzO3RjMDdYLrRJNx3Bd+P7RDMEWozdo227VOrABcT7WgOC9+F9bPOnWLNoo/oKbJuMZcvrU4F4QvTMgoKPdhRIhXc2Scv9ZXh8qB9oQ/1CvQ/ow/dW3BsqaN1UmQmAN7DLQZjbOAtqATgzgXyoR+zIkrtBGOfSgTx+0hK4kIJoAyAfogEwHGGLPNQAD+kR/5kd4UG0I0fKLhG53xyCOPtD7PMN9+5StfuZHpt9kPNNCIaQW++MUvtlro+++//xyUp/SDpkJVo3AT+j9Hy2dV5EqcLvpEL+bQQM+VxmpfQU6fPr1vJkD8nvslc3kBVA4irSGIGLfRiZxAeEYkbqey2owYPCzLEasvh0MmfhmZwAsosOl5x1JlzXmuqcQX/8yPEuAFF0IdtFh4IY9CJr7DNhyfvXzieK37IZPqOUAAJ50UyIRnfqfCMH57aKiGwLky4U0FTQoe66DtrvYbwJQK178QAcWYJiy7Vwgg+nuORbGHABfrnz64Cvpi1kd1MgX1xEBwFxtO1EThObb3uUEfrPXV6K5SE+I5KQM4qUX0mKHfVvvKuver54WWvmZVo5MdOvZNMePmvircU6OtRPPtixmwzxhjDgMIwNAi/+2//bdbwRjjdyO87dsP2/Ad9sG+OMbC88GBCTeFZ7UqZsyrKP9pFG7IjjDjjnmgK6bcfR7o0scWO3gk7rnSWIGVQkPa541oDmio27ke/Z9ROZowG/7PGoFbTbmRyspprNZHhRi8RGUvaXhZ4gtTfJEcAi+gQ1osPW8sy2Geax1U6znFf/Ff/at/Vc21S81VDZ2oULPNw0AnTTLhTYnCzpAv/NDvhPvX9rWukKfnhaZtzLf4sBnLqQwhbuqEQa1dIBCXUtN04jo0ZwdRYL0Y0Hw9EzBpZn8YZBMPivbpMaFW61sntRhoEeB3zfor7pF9BWVaR2urAi/6zJi/cZzkJHpNjXoer/F3/+7f7eNd0IQ97ktsvm2MOcpA83z77be36xCWoWkmWKdQjX0OGrnbrMJsSlCKqoxHYL6NJWJjAciJCCKGdSwffvjhlWDVZ86cyeRa+D73+4lAfSDmTGO10DzQoKKBhhC9QAQ1LJubX9FAc4YBWuhbbrkFKvw2oTZmJKDax3cQnrFkDjEzHdXGDL1M4uWKL1F4IZ7iYznlRUvPOyQQzXmuddAX4zmC5jBNEU21a9r8ww4EpQKWCl418CLOtjIk3I+dS4Xgde8R7ZNm0XjBxx/aBSdPLrRWbOxeOWHANol6y8qI/YYmHWj6D4YmOnCtbRCcAcqr5ue4B4wZqDMGRMMkDu5HxxIEU+O9/sIv/ELZBA18GIna1TEhXveNEyDaJ9AW4+SjTlKtK3RqH4MgjkBiQzQvG/26tgE1446m2Vo+tEsI+exf+E6Fb5tvG2OOExCO4c/8h3/4h32EbsBI20Pm3WYzIMM1sl67jhTFRbTClPvwnFUfaMiJXdpj1SqXTpBexmjckEtPnz69iFroMgOHlsZKUXt0hBtnJG4VnjGT8K53vesEZxlg896FMN93o0xjZQ30eqh/HoBJSs08V18kqU0bE1imBPJSDd6Q0DvnudZBz7OOv24G0xRtQ5RkLcOUutU8vUPlH6ujg/jV4uX/q1/96kpUZGgF8QdBJks7dJhMqbcpEwZjdaYC9MXOlzwV/EbqIqDuFzBHpqDG342/GTW2B+lrQ8fG32BdVwncE+8D7ZH9OfM7V6Fz3YB5cbxdp5wx2CHbD91v1KwbMN8496dGnfvafNsYcxz57u/+7jY4KAKFQXAG8JV2nufDA37PWMI1V2U6CM804YY82MiGy2aCY0Xmg1IWythGplx0wcQQubtNadUpdpedfMrjZlW6zqWB1mTVfUFDELF22c0O9JG4sd7MJhQIz9iGCmoa8IlObd/up9pnxRro9YjC8jovaXjxHXuRmlNQ3Aah8yAw0I+SCZMXwiz5MOuSURIPCwjIMDeFABbNTJl2CMt1BZZNUGHEnAf1H/13ta1D0EQ75z7oG4yqT+aMol8jZhyYeoyuM8BiDCamk5Nj7icZsS6mWImQ2AdhuUFNOSNsq/m2auxpxUMzbtyfzbeNMccVjdAN2cuRtg8PCsww34ZlMZ+3zAMNF97muXUO2udOA93KfBpMDCmsutV+CXmTel1uo99zTdG7CbNpoCXK2YrAHOkicbd3wmBiMEfTCoH5NiNxowKZG0yFaFR4U8EWoCei/nmbELUZtWuMMVXDO+e51mEOrTbTVBG8wNb8Z+++++5y2ESzYNWq1VCT0ostNDLoGVOr0Zxb04htatK9zuTCFAFa2+1xEbbVhLjmv4vAV0z/hnqEhlqFxHUExnWI7fygqc7URBpL3qtOTm5iEaHlRF0cpJzoBxSgacZdM8lGVO9oxm3zbWPMcQZa53/0j/5RMYcPFKHQ+jO7UvSDVu0zXHxjJG7IkV1srRV5UCyf2++C4DyLGfdcQcSy0OIrAcRIp3Lv70QDiaFy8Neo9NtI3AwgxgrlEubb9IM209CXIggkyCc65U81Q2PBxKYI6KrdGHppnvNc66BCWNR4ZgxFugXMe5sJUxdSy66/41hUbaAC9IXQDk6BQdkgjCHCufrwq2+/mj2PTcSsE3wuBmWKqOkr2JZ6O2wQp4IMTRpo5HfUlfavLI3SHKAtHCQSfEQnamj6HIOHbRI7QdvKlHFnrIwa8EzvW823gQY6xL3gz+bbxhhjDhuksKIWGibcgIpSuPBCC40ltM9nz55dkfkQgRtLWDKrnMl0yRSeGTyMMbrKed/pAzOLAN0lpJ60L/2fJZVVYSor+j9DeMY6VPdwJM/OAw20faCnE6MwT0XN/cZS89Si0xIIbipgDL1oznmuddDz4EV27IUbwX4gIKN+KUyrYDwkUIwJZJGDCNzxdxzSrse8uRdLC4X7hW9t7b5VgFZBWbV5uM+h33AdYQUTSkO/QZykOo7Cx1CfRV+I+cLBlGj3B0Hbr7brDAbwyvIlE7gUELSfTcdWRVNQTcl8gPEP5ay1X73nX/zFX0zNt4lG4/6lX/qlfrvNt40xxhwWTGEFuiBiJVob33LLLe2SQcQYaJqRuJMc0Kq4pWy6VPfiEqJyb8psGmiR7kehEI0lZhGohUYFQT0PDTTU9vhjPjDASqW9vH2gpxGDh63zYq+BcqZocPCCXNPK0lSQZRjT0M15rqlEU2C8UGZCAeqCqZViih4VEGpRkqOQWkPPdZBUVzDVpJASIybHcmm9b6pROygQEN75zne2dYS6zQRXFR7UDxRlVoEMbSW713VTYw2lYoKgvw2TDpsyxSqhhqbe4qRHjaw/HLYfvU60YOyolY9tHxNzaBs/93M/l+6H+2W/xGRUjG49RznRZmtCNMc/lBNlzIR9LYda82TtspZOz+bbxhhjDosow1ELHc24qVwFkBGhdIXyFVDjzHXG3uqE6t6EGwKzaqFFoN6YuXygS02AzlJZdfmgF10FMCR5D/N+QYCmIzm/g/l2M1OxbCoalVjMONE/bx1tD14UoYngS9hQMDFGcIVwhmPwR6E7mmSP+fjNea51+emf/un2D9dDGbDO9EkoF4QuvLSqUIcgVqzXmJ8ax9MHmn68U6Nza1okvCzj94O5Oq6Pa059Yce1UU9MKYT7goDK8+F7CDfxvmrm54cNhGCWA2WCsADNH+sYwvOQYBDTcLEd4V7x+8VJpSng2rEsDL6k1hAxj/a2ov68qCvUB+oI94gJl6kCFNoH7jeeC+fXNo92nAUuhKCI6x7WRA1+jxgJ/AMf+MBKe4ptH+WGq0AG7xfn0dR0B9Wkoz+jftjfGTiP9Qhiu8f4kP1ONOPWNh7Nt3U7o3HHbcYYY8yFIEbhhnsYZEBNYYUlFK8QoiFLQqZ8+OGHoZA9hxzQCCoGIRoyKYVridGVft6UuaJwa6Szqjk3E153N7ySwgpCNPNAQwNduxZTWEF4tgZ6nBg8bBOtArTQPMdQMDEIaNDQ4Zr4q5lBYr+xF805z7UueHmE5lm1tEyflIEXXxWY8JKKbdR0QXjItFmMeDskyEHw5ost0+eQKZHRFezLelXhNIMCxMXQPgOUVetwSGOP+o4CK45Fm6VGje1I4aRCTdMYgQ8v2sRQWZjCaRcCiKHOVGjEOtsDxvB1xgoKf6xvPVcGBTzuA43vL//yLx+aKXdMiTb0G9LUfKgsOF88fo5JE7Yx1uPQuMP+XEMnkcBQvmxMYKgAPbSvMcYYc1BUYO7SWK18zzRWjIulQcQgRFMLDUEaytpGeD7HY5H7uUieaEUCXx9ICz2LCTdets6ngl6oM/dK4RApjebbCisBsHJQWdBEw4E8wmht9oEeRwWuTbUKGpQG1EwL+eJZe/HGeSCYTnkxn/Ncm0BBaEirhDJgn8zvEdugea4dixfwmoYrXkODL0XW9YvG/YzVG64JYeZim3CiDqGFG7J4gOCG3yAD22tCDX+7qcHnUP8Q1FF3tfKgvsYEr20i5muOrNO22F/HhEjWO/4g/LEu6VZwmIH12CfH2hMC1I25hGjwLYD953AjwXnRxobGDk5ujbW12H+HJsMyCw5jjDHmMIFLLpbwgaabLpYa/wqyIMy4qWTFNsbOIpo2WaBgys99qqs5TLhn0eB2kvy+c+nN8OaohSaMpEZQOagomG+r6TZhBUMLjWWjsv9q2WK+9KUv9evf9m3fVo4aCGRDDQle6PhSCQ0PzCIZoff1r3/9qGAx57nmhpr3zqRkJejPGNAmQcu8ybGxDNSizlEHNK3lOQ9StsMGZaS/OYCwohGWh4j3OYewo21ym+ttKtq2Dlo/rG9qUVEvNB/eljqKY8o67elComMHuBhjnzHGmN1gl2SORmN8KdehGI2+z9RAQ4COZtwqQEMJC+0zZc6gvD3v+HzeQnoW5etsPtBCb8ZNoVmW7Y3Sbh0733nnneW+++5bOR9zQN94440w8VtqIDFA4dkm3NsLXkY1ndC2nGtTDuIPOJd2atNcxzWoRdsFX0e2gU3Kehj3uQ1tck7mrJ9daFe78vvNNXYYY4wxu4YKzxldTK2VbUGQVnPtWa2WZxGgIxCeE1W6pq5i/i6stzcIP+h3vetdJzrtc7v/008/3QrPUOVjCe0z7OQdPMwYY4wxxhhjdhPkgkY6qyuuuGIBDTQUo+qeC4VqIxcuL7vsst58G8B6GXJjJ08uo8WzXkNcjDWA2IGF6bnSWGmi6n0qdN4YfKC5rdNC9ydgEDHMNGDGAT7QasJN023YyUPV7zzQxhhjjDHGGLN7aC5oyHmU66A4pQwIIVoDiAFNZRWhzJkpcuc04Z5FgNYk0FPzQWPWADMI0QcaQIjWSNzQPmNmAjMU/EMe6GKMMcYYY4wxZqdgELFG5lvxgb7lllt6H2goVLGMGmgsGZi62X+fBvr06dM0214G2XQh2aM2ZrYo3JD0GdUMBc0kf014DTCDQEdwqOKx1BmGZ5555pzu/8gjj5x74IEHlvgrxhhjjDHGGGN2CphrQxkKq2IoRmlpDKB9ZhYmKlRVPiRQxkK2RBCxzHQbgnJItdwutz4KN9AgYvjMKNwaSCyLxM0KQyViFoKqfFQ4zLgRSAzr99xzz+HlPZmBox6Fe87I0HNHmTbGGGOMMeY4sItRuCFAQ6aLkbijBhpQiO78n9tt6h5MojBdzpttL8LnjZlNA031eGbCTSGaGuia8AzBWVX0AJG4KTxjdoLCMz7bB/rig0i73//939/+HVTgnfNcxhhjjDHGmO0FwaEhPMftkP0oPCPANKCMqP7PlC2j0KzexWU1VtcszBVErA0Rzuhm1JFHM+7m877jYMKNmYQoOJPHHnusMKE2ZyZY0VD5F2OMMcYYY4wxOwGsiOEDDTNuCNExDzSBRTJiY0H7TA00la/QPlO2jDKnmGkvGOR6znRWcwURQ6F7K+5ozk0TbppvU/tMEIEbS60cROLm98wDTft4aKBR6XA6L8YYY4wxxhhjdgJYETMgNKyL1QeailMIz5QHVdHK+FmQKzWAWICC84owXWZiLhPumq15C2cFGC2NS9DMHqw4h2sFqRBNoHWGBvq2225rfaCLMcYYY4wxxpidADmgGYUbqFWxRuFGGquh8zz00EP7ZEUIzprzOUTdnkV2nDMPdKtl1lzQEVGz99e97777VvahII0K00rDzATU+9Q6OxK3McYYY4wxxuwWyAHNKNz4TPnuP/7H/wihuDAKd6ZMjcGnswjcEp9rxTB6Lj/oOfNAt4HCpoQGb1TuK8mwmcJKoeO4+j+reh+V7iBixhhjjDHGGLP7fNd3fVfruos/CM/wfx6DwarD5iUFZ00EPUcKKzCXCXergeZH/MvyQCtqxk0faEbhRrQ12L1j9iH6Pys24TbGGGOMMcaY3YEyHAKIKdBAQ3kKE25YIo/kge7Xz5w508q0kjq5lxFVBR1yQ2/MbFG4S2fGzQ9d2qqVm0WocRWca/zgD/5ge2NqA3///fefY4Q2prEyxhhjjDHGGLN7IICY8sIXvnAJ+Y9kJtwMItbIlP02+EJT7lT5s1M+qxJ6OYcWejYBOvN9jlpojb6teaDVhBszDE899dSSJtzIAwbt8+23336CWugsX5gxxhhjjDHGmO2GbrhQiqoWGpbHkP3oA000yDQFZ6SxYoYnAtmzkz8pNPd5oEHMFLUps/lAZ+XJtNAUnKmJhvBME24CdT3MuFF50EDXcoMZY4wxxhhjjNkdYMKNSNxQilILre660EJfc801fUBpyIWEptuwbIYQramsIHeePn2aQrP6Ppc5mcsHuoiUr5rnRc0XmoK0+j/rUp3GGYEb65ilsAm3McYYY4wxxuwmiMRNmQ7yXVSYPv30071FchZMDNmdIESfOnXqnG5vBOhWeF50YNtc0bfJbCbcXflagbkp+Dmqz3UfzBLE42jHTudwzDDA3h1aaNrAa4Ui/zNmK5A7zFG4jTHGGGOMMWZ3UBkOwjM+UwMN62Non7Eeg4ip2y/MtyFEMwo3zbc76+cVZav4PS+3KogYk1Z3qaxK5siNWYIxMMOAPwjRsIHn9pgHGmmsijHGGGOMMcaYIwHkv3vvvbeV96iBJhp5OyNLZ9UtqdhdbFUQsZi0WlXlvBnMEmgUbqxrMmzMLnCGATbvzAFNODNBdb/TWBljjDHGGGPM7kEfaPV/hvxHK2RYJmsKK8iNlB1VpqTLcOI6zM+9X/S2pbFqgVQP4VmdtfVmohAdYR5ogMqjFhraZ5pyOwq3McYYY4wxxuweCCAGNAI35TxE4uY2KFQhG2oUbrr/anYnEjTQzGFVdDkHl5R5WFBobgTkE1SNZwHEYK9O9Xt341TRn8AMw7XXXttvQxTuRoheNgJzL+izopvKK9ddd10xxhhjjDHGGLMbIIAYiHmgATXQcOeFAA3FahZEbAJqET2L6TaZLY0V14PP81JTWdEHOmqgoYqneh45oLG8+eabW4dyCNH3339/H10NFY2/RuBePPnkk8UYY4wxxhhjzG6gbriqhQbUQDOFVRSe1f23Fl+L2aE6oVn9oMvW+EDT/5kwoBijoZ05c6a9Dsy3AVXujZC8oqHWFFbvf//721kHVCL+qNan/zOCiTkKtzHGGGOMMcbsDpThINchw5J+hyjcXIcWGkv1g2Ykblg0d6ms+sDVtH5mdqi91ZmTQJd5faBVEb0iUGt+Lk1l9fDDD68IwFo5nHXQSoQQDf9nBxEzxhhjjDHGmN1DZTj4Q2vKYs3CRHlQfaAhOMOauflrP6vLcBKFW9mX3mpTZg0iRqE5Cvp6Y/CB1u9UDU+Y80tBdDb8QXim3bx9oI0xxhhjjDFmd1ArYg0ODVkPPtBw4cUf0Ejc1D7fddddrQwLufKWW27pI3CLzJkJ0ovK9rWZU4BWoXfJnND4oLMB9H/mrIEmxMbsAioI6nr8IYk2K48zE82sxLkHHnjAptvGGGOMMcYYs6NQeKaiFPIeXHcRRIyprKIPNGVIyJSwbG5kxZqwDPpI3Ms9yhzMZQK97zxZBG5ADTRuWsOPQxNN9TwicdMHGp+hytf8YGrCfc899zxXtpgvfelL/fq3fdu3FWOMMcYYY4yZk12SOe6+++6XPvvss0tYFVOIVjNujcQNAVrdfJnGiqh7cGLCzbzPy0WXa3kOl+i5NNCU7veJ9fFGqIGm8IxZBJpxs3IaIbvdF4IzNdBKs3+73y6YcOuPdO7cuWKMMcYYY4wxc1GLQ7WtwISbLrmIwh0jcVP7DKBYVR9oBf7QlDVhyg0FrtQFfZ41l1WZg9lMuFFgjXLGm4ma6Jj0GjdOM25WzhVXXNFrn1GBmIXQWQmksYLD+S6ksTpx4nwVW4A2xhhjjDHGzMnzzz/fr6vssa1AjmMgsUajvIBsR2tjDSAN7TNTHNeArAm5k0GrIY52St1e80wZtdNGH5jZargp+Ip0yJvRbTDfVjU7gRCtIIgYhOhnnnmmPSfzgWkqK85abDt/42/8jX79W9/6VjHGGGOMMcaYuVABWmWPbQVyHAOJqQk3lKYahRva53gsLJfp/6yRuCl7BqXuyvFz5IAGswcRo9r89OnTKwVEomvcaIzCDWIkbgjPWEILrSbcnJlARTf7bL99QsMll1zSr1uANsYYY4wxxszJX//1X/frKnvsEtBIU2lK+Y9uvQRWy/CBhkVzJlOCToHLPzJrAOpZBOhOaG7/aSorNd9GomuFvtBEbduhgUbIclQeKzLS7LMTkbhf8IIX9HUCAdpCtDHGGGOMMWYOIFuoBhqyx7ajJtyEGmmYcKsPNGCcrLvuumtBrTNQeZI+0FiHqXYw1+4VvXNE4p5FgO4ExMkaYUbg5k1jNkGjqyHiGrTPsfJIdDTfZlA3L3zhC/vPX//614sxxhhjjDHGHBSVLSBz7EIQMZpwMzC0xroikAe5XgsipgpaTWcFU22phz6V1WKmyplTA72yzhkAJrcGUdXOgGKYTcCSQjQcxm+++eba5Vpnc8xcaBLubeZFL3pRv45Zom984xvFGGOMMcYYYzYFMoVat774xS8uu0DUPmu6YppvQ5kKIVqVrIByI1FZk9A6ulsuOuG53bZNaaxaMpW4zgZ0zt5VoVdnF2DzjgrUSGw6O4GZi13xg0Y0PBWiMVOkphbGGGOMMcYYMxXIEqp9hqyxCxG4AXJAQ/sMpWj8Du67DCQGITpqn2MeaMiaMXB1p2nmccsuBfSyrGExPcScJtytRN+FDt+X/xmfoYGGqj2msorABxrLt7/97dXZCbALaawIZoTYqFE/zz33nIVoY4wxxhhjzFpAhoAsQeUlZIxd0T4DKEIhPCMwNLIrQUlKOQ+RuKlApRk3tNA1M25Ay2eVP0Xr3ArTc5q2z63BXSSflxpMLJpxwxEcaawYiZuVQyEacBaCFYuKxqxFU7kn7rnnnufKjoA80M299Pmg8UOisat22hhjjDHGGGMyYLYNzbMKz41MtDPaZ3Dq1KlLuc40VuD+++9vhSTGwWJmJjXjhgYacuMHP/jBdt8YqBpAkAYVqfnALsBz1XSvIi/n7c3bzzEfNPNAw5S7JjzXwOwEzbYxa3HdddeVXQINu2kkK5ror33ta61Q7ejcxhhjjDHGmAzICpAZIDuo8Kyyxa6AWFYRyHkw31YTbkIZEYGnsWQqK7Vqpi805U6VneeIvK3MFUSMpVpRkVPznGmgu5suGooc6AwDKk/zQAOmr4Lqf1dSWSlIbh5nidghzp492wcDmPuHNsYYY4wxxuwGsFiFTABtM+SEqHCj5hmyxa4BOU6FaGRYUlddmHBT+6wggBgUr50itv2eAnPmCw3ElHu2NFazmnA3gvIJFpyaZ7FJb1XsasIN4VkjqWF2AfmfEYU7mnCjUtU+HmbcWJ45c+arZUfBDJIjchtjjDHGGGOmAvdPuIHuQsqqjDvuuKM14YYgDbfckydP7ktlBSEaPtCQC8l73vOec1DAEgjR0YQ7CtGMyL3oIoltTRRuSvNdgZcxlVW3vnJMlwt637m0kq655ppeA41KZchzCs8xBPqu8ZKXvKRcfvnlK3mijTHGGGOMMUaB4AfBGbIDZIhdFZ4BBGf8AQjPCgRnBhFTuRBQA83PlC9hvk3BOaZX7oJczyY8g9micHd225gFOIFV3kSmSldgw0579pjn6yMf+cg5OpED5n2Gszkqfdd8oDNgfnHppZeWv/k3/2a7hDANU4xd7hTGGGOMMcaYzYEsAJkAsgFkBArOu+bvXAMm3IzCjc+0Mo7+z4RyYkxjBWC+TcWtmmtDbuY+c4bhvqTMBKX9pmyIiKYzA2lhx1JZAeT+0kpExSKIGCocodthAn1UwG+KDmJttDHGGGOMMeaow8xKCIRGE26ksYICNfOBBgxCDeAiDKiJpvswlpLCarb8z2S2KQzmgC5dASlQ4wb4x33p9E3oB52lsEIl6r4PPPCAo2sZY4wxxhhjzI6SmXBDWQrhGS68Kg8SWC2rCzAE50x4LudTVS0PIzDznNJ4KuGrBhr26THqNoAtu6awYoVF7TPXqYXG8t3vfvfO5IE2xhhjjDHGmOMMgohdeeWVC3XPpQaa/s9RA00TbgrRUMieOXOmlQ9hwq37qj90SGe1L8XVJsxlwr2vFBCcITCfOnXqHIXo7uYG7dohSKPCEI37hhtuaL+DIM1K7QKHza6KN8YYY4wxxhhzuHTRt8+94hWvaD8z09L9999/DnmgIURDoUqZUIOJdZbLfeoqPW+MvXU+dtiegfRWBRErItBzA25AHbqZvurmm29eubFMI42KIojEjSUqFX9Q89PZ/MknnyzGGGOMMcYYY3aHq666aqEBxCBEU3jmPhCiITxroGkGn47xtKC4hdwZTbYhNFNOhTBdZmAuAVoDmy3V/5kbKTiHPNArduw040ZFIYAY1h977LH2O2qgkWgban6sH4Uo3MYYY4wxxhhz3EAAMch2QN11mcaYZtyQESknquzIIGLdMcskldVCzLiXIkwfiNk00LLeC9PUPg8FEFM4u3DttdeuzA6wQiFEqwbaGGOMMcYYY8zu0LnktlpoBhGjshSuu9BEP/74473MCBmRcmKWB1o+M5VVFjysNf2ew4x7Ng00/qGgtVBnFKJV3Y51rQTy/ve/vz8H1Piwh8/OaRNuY4wxxhhjjNkdGDxMUQ00szAxsDS1z1kO6JjtiVmhqHXuNvffz2HGPYsmV1Tj+wJ8aRRuqNmjvTp9oOEQHiNxx0TarFio+pt9W+HfUbiNMcYYY4wxZjf4yZ/8yZc2st4SJtwQptXaWH2gAcy41QcaQjQtmlUDDR9omnFr9O1OubvozLe3RwOt+Z8VFZ67z/uOhR07hWdWDmcbYgUSqPpR6dZAG2OMMcYYY8zu8OCDD7bCM0y4ac5NqECFCXdMZXXnnXe2Syhk8QflLLXPyPzE/VRIxjp9n7ctCjdpJfwoOCvRBxom3IimBuGZGmhUFioNDuSZEE1n80z9b4wxxhhjjDFmO0EaKwjPEKK5jT7QMN+GEI2A0lSqAsiJ9913Xys7Qp5EgGooZyF3QojO5E/NEqXRuMsBmVWApk15zMEFoFbHMmqhITx3+bz2AQfyaMYN6GzeCNoOJmaMMcYYY4wxOwZkOsp1BPIffaCJWioDaJ81s1NNeBYz7na5qEQXW5fZgohFtXi8EajVcaMabjyiFYNZB2if8YdKZH4w3R9m3MUYY4wxxhhjzM4By2LIeBpErFG8tstowq3UMjtpJG4sVV6eywf6kjIPyz7U2XkJn87dqlZfxiBi8IFuVPGDJ8dMRGe23S6h8seHaDNvjDHGGGOMMWb76VIT71OUwgKZbrzq5luD1s+iwG3dioOCdzmXD/RsUbiL5H8GNT9oVbdj5uCuu+46gWhqms6q+byiGacZt85MQJBuKvbEPffc4yjcxhhjjDHGGLMD3H333S9lLKuXvvSl7TJaGkOARkysN77xje1ntVT+4Ac/eA5KWfhBx3OLK7FmhlpuXRCxTnLW/FqpH3QEN54Jz1TXo9LUB5oV281WlOuuu64YY4wxxhhjjNkNKDwjiBjlOlWUxiDSKjyDaNGMWFv4U/mzUeaqnLvo5NXFHHmg5/KBXqr6GebbQ5G4FeaBBlDPq607/KDViVwrFmbcTmNljDHGGGOMMbuHRuKGopRyHzIxAciCWKoJN5Sveg7E10L+Z/zhM2XQoMzV2GFbE0SsR8ODo+AsPJaYGYCqXYVm+EDXQOXB/xnrWRAxY4wxxhhjjDG7BQVnjcINuQ/aZwYRUyhEU45kEDHN8KQ+0CHY9qJLYzWLH/TsAjRh4DAGEWs2LTgzAKGZN90I1G0eaB73iU98oj8HKo8zESo801beeaCNMcYYY4wxZndAIOhvfOMb+9x0QZbCGCbcNONm+mMVnFXbzPUoKG+dD7SQSvWdIN2uaxAxgITYtTzQ11xzzYIaaAAtNIKHdRG5HYXbGGOMMcYYY3aM66+/vl9XN11AE26gUbihdKUJNyybuY+6DnfrQzLi1vhAk5VUVqAWTIzO39GO/bLLLus/P/3000s6kdOEO0u4bYwxxhhjjDFm+8msiGt5oM+ePdtvh9KVwadhyg3/Z0LX4aFA1p2Muj0+0ChQZ2y+HEpnxXDjWfJrzjB88Ytf7I9RNT410IzWZhNuY4wxxhhjjNldoCStxbpiGiuiylcoZGMO6EQb3YIg12WmFM5zmkDvO1cWiTuacGsKK42wBiE62sDrzASEaJhwOw+0McYYY4wxxuwGzAOtgcRUgEYMLGihoYGOKawgQCOGVrN6jtui1rni77zsvlt0wvTGzKWB3pcHeioMIIYlKwjCMyoM5tuoQPxF23hgDbQxxhhjjDHG7A6U4ZDGKgrPjML9+OOPLyETQsHKP3wP5WujkF1CKUsTbihtz5w5c4LrXcTtXiaVLFEHFp7BbHmgywRtNm6ymzHoTbiZxkoDibHCsK5BxICacDuImDHGGGOMMcbsHsyspIpSzQENmZDbqWilCTfcgjUSN7I9MftTp4FuXYtVG72OkneIOTXQvaTPQjL3M3fq7NTPxYOhfdZUVhEI0bSNx0wFKpsVbowxxhhjjDFmN4ASVBWhkPEgRMPqWJWnEKK5rq6+ILoFE3EhXnTQdLvMxZwa6FZwjvbmp06d6gVmaJ0ZfZtLAO0z/lAx0c6dUbgBKhYhz6GBZiorY4wxxhhjjDG7AUy41RWX2ZZuv/32E5T9ovY5yogAitro/4zPIo+2VtJU8M5hvg1mTWO1TET7EAlt3zGwY6cqXvN8wQcaSwQSw2wE93/kkUfOQfsMTXQxxhhjjDHGGLMzUPtMt1yivtCqfVY0AHWjqF2qrKlprTq5tI3T1QnUy85aenvyQFOyX+5R3U/TV8EfGsKzVgTRVFZQ5dM2nqmsjDHGGGOMMcbsFjEQNE24sR6zMA1x5syZlX2hrO0E6jbUNraJwLzIrKU34ZIyAxIOfDFWKDXdRgQ1/Y7aZ8w4QAOtQrRWLLXPjsJtjDHGGGOMMbsJFKONTFeyPNC0SFY3X80DjcBhMNlm8DBu72TTdlWFUwkudiBm1UAXSWVVAxpoicS98h0rJgrPasINGEDMUbiNMcYYY4wxZnegDJdF4a4Rg4gRmnBjGVyH27RVahndCdMHlh9n0UB3gv2+wuhNIFIazbepeUYKKwjRd911V4kBxOA4Dk00HMljKitjjDHGGGOMMbtL5wNdDSCtUE7U+Fk1qH1OvpqUenmMOaNw8y8Fubpgvq0m3OoPnUVWI3FWApX9xBNP2ITbGGOMMcYYY3aIZ599tpfh6JqrPtD0g/7EJz6x71gIz2rFrCmTQYzFFdyLF8sZ8lnNGYV7UCUOu3QI0Vin4NwJ1NUTIpE2KvD+++/vU2ExWttNN91k4dkYY4wxxhhjdogrr7xyEc246QN944039lroN77xjSuBpYnKj/SDxjpTWKmQHOTlrUxjxb++cLyhzrm710Tze51BUNt2mG83MwolJtQGqGg4nF9xxRU27TbGGGOMMcaYHYF5oCk8A2qg77333qVqoBEba8hSGajbcOkCh3EbBOrw/YGZ5WRMYcXzMRLamTNnTmBWQPeFL3Q8nmmszp49u8BMA8BsAzTQFJ5ZqRCaYb4NMHNxzz33PFeMMcYYY4wxxmw9p06dupTrEKI1Arf6QDMKN8iicEMTrbKmRuIue3mfY4ao7dFAd6ryPkM1Cx+FZ6B+z4QVQeEZsw0IIgYNNCoRqnxULP4oPBtjjDHGGGOM2S2iPEdFKSyPYx7o6AdNxSuIGZ0kEjdSW52gOTeNo2dwf26ZzYSb0r2K+TDZjsB8O6ayYkVgZgF/EKRhwg0NNHjsscf6iqWqvzlmed111xVjjDHGGGOMMbvB9ddf3y7V/xmyXpZ5iQpWuvqqBprxtRQocqHY7ZatjIrcz936LNbXswjQ1D7L53bZSP4r+1GghhDNVFakltuLsxDweaYQDeG50UyfePLJJ4sxxhhjjDHGmN0CwaHxBxlPzbipRFU0jRWWEJ4zZS2Ikbf3Ni0GM0atw1wm3MuQpHrFWRszALjBKFAD2K5jJgGVAiEaf/B/hs07Tbixn6asQrhzaJ+tgTbGGGOMMcaY3UbNuCEDEgrOUQOtwjNSWWng6k4uXSYprAazRk1lriBira25qMX7JNUMKIalBhCDGTejcWMmAZVCIZr7MGy52sIjcBgEaGihsTxz5sxXizHGGGOMMcaYreeOO+649HWvex2UpsuYxgpQgRqDiH3wgx9cagqrTgutGZ9W0ld1PtDt504DPQuzaaA74XlP3O9MumPI8MxOncTw5IzCHR3JT5482S4hPDN/mDHGGGOMMcaY7Qc+0A8++OAy+kAPHQMl61133dXvQ0Ea8iYyP8X9T58+3aex0oDXZQYF8mxBxLoIZ9REj+bb0lzQigrSzAPNz6hY+EITm3AbY4wxxhhjzG4BIRr+z1inDzTkPpX9aI3MQNN6vEbgRuankMIKJt7nsGRUbkm5fGBN9JxRuBeQ9Glzrt9lwrRG4oY6Hkv6QGu4crWBB9RAAwcRM8YYY4wxxpjdoZaWGFG4o+wX0TRWiqSw6jXNkEsb+XTZrW9XELHSFQqSf2fKvYizAApzQTMSN9XxnFlguHKQRWEzxhhjjDHGGLN7MI0VgBZa/Z8zNEYWgojF/M+kkz/7c9F8mx9j5qhNmVUD3a22BR9KVA3zbTXhhgYaf7VUVsoVV1yxgL08Zi5swm2MMcYYY4wxuweCQkOuo/8zljH+FYjm2/B/hkIWArMGqVarZ8qiEkSszJQGejYBWm+KubbSHal9VqCBxl9m3x79oBGtDUvMXNiE2xhjjDHGGGN2C2ZUggaaMa6giWYEbsAo3GfPnl1Q0UrtM5SxEJg1SLVYQC+7NMt9KqvMzXhTZjPhxj/VOjOUOG+EubrOnDmzgBAdBWlqoKMWGrMQsIfHOtX7dDjX3NDGGGOMMcYYY7YfCM/QPuMPMa6YXYka6Mcff3zJIGJw76WSVdNYRUQDzQjc9IuOkbgPxFx5oPtzdTm20jRWSHIdbdbpCJ6Zb2d5oKHahwANU25ooO+5557nijHGGGOMMcaYrefUqVOXUgONJYNE33///W3kbAYSowZaLZQ1FzQUso282cqYiMSNbeIH3bsX7ymiz1t3lwMyVx7oLMfWPlR4pgYajuD4o/m2VhBmHjSIGO3jUdE05d5Gav7f2K7f1dYvFlPLEH0K1r2Pw77vw6zLg557G+pnynV3nYt5L+7/046fuv+6uP9vhvv/4V7b/b9stP+6uP9vhvv/4V77qPT/OYG2+Rvf+EYvPMPKGH+Mwh2DSKuilcIzlhCeQRCesf0EFLmQnLHeyaj4apabnUsDveg0zyvnpBm3aqLV0RtC9F133dUK8ZhNgB80KwiprG644YbWkRw+0KhQap/x/YXQQKvTebYe4Xdqax/s7qvnqh0z9Xq18mX7HPTaQ/eUfa4dM3TNTcsXr6Pb4vYxsnPF77Prb7J/Vod67aF71f3ivkO/4Vg9Z9vjsVPLOKU82bWzc2T3Mba9VuZ1r+H+7/4/dp/u/2Wt+xi6dnaO7D7Gtrv/u//H7WO4/7v/x3Md1/6vbW1OoIFGQOibbrqpL5xG4qYfNDXQQJWsUL7S9xluwhSkyUA2qObWVuTWjZizVhYUmPEhy/0MIEBDcNYo3ICm3HfeeeeJ97///e05KEBzH2qgKURj9uKgArQ2mrh9jKHGPQeHff6h60y59oUq34W+1lys+zCd+3pzX2Ou80196I1tX3efuY91/3f/H8L9f73zuP9f2PMPXcf9/+C4/693Hvf/C3v+oetkbekwuOOOOy5lKiv4QHN7DCIGa2T1fwZdGqtll9Wp1z6TIDxjfRE+H5jZ0lgBFJiVnkn+DCRWE57BU089tYTgTOFZKzEcsxxKY4VyxL/su6kNQ/cbmq3ahHUb59yNObuPKXVzkAFrXbQ8h9WZp1K7ftw+VD/r1F3W9qacc+7Bd67z1c6z7vYaQ3U0NFk29Tj3//pxU3D/d/+fY3sN9//1cP9fD/f/wzmP+//h7D/GlP7PfXSZrevnKfVTE56xvOaaa1oZENpnCs+wUGbAaciNkCWhgYbwTPmyAm5mKWWcpRJnOUlXUf25WPGZFlpNuAH8ojF70FTSCVYQtjOAGGzgGYUbQAuNUOdwOocZ97vf/e7nBsq0wsWYpTrqXIh6GRqwjsos4BwctVn6Tb4/rFl/9/8c9//twf3f/f9C4/6/Pbj/u/9faNapl0zwhwk3lhCgIc8xthWEaLjuwg8a2mdsixpoCNLNYkkhmtsHzLZ7ugmCA/+gs2mgUTn8K52kH2+EMwQxhRVmElR4VpgHGoIzTbiJ5oGO2uahmaZY7imMdeIxDjJrtO6M2oXksAaVOPs11+zkukyZncw4jDYxNhM99OA4TDax4iBjv9+636876+/+fzDc/3Pc/6ft5/4/jvu/+3/c3/0//979/8KyjvA81I/hlvvAAw+0X0JBSuEZwBoZwjOIMmK0ZgZQ3GbKW902h/AMZovCTVQbHW+CDt560wgcxvUYgRtL5oFWx3Jon8sIU3/YqQPkOqYztYFi08a+7qBQY+7OFs+3zvnH9p3jwTjn/Y6VZx3zrXX20fNHM5mpzGkCdZDzH/bLzia4/2+O+3/9Wu7/m+93IXH/3xz3//q13P833+9C4v6/Oev0/ylt9+TJk+3yJS95yfL2228/ofGvEFRagf8zo3BD+5yZb3fXWXZ/5fTp08shIX4TZtNAs7CoRArOU1TpUMPfeeed/WcI0TDfxqwDzLczH2jay9MHekoDnlj+jb+v7ZtMLmwdQx0hq8uaSdU6g8RBBpSsLLVrbHrsute+UDPhF4ILea2xtnbQc07F/T//7P4/7Xj3/81w/7/4uP8f/Nru/5vh/n/xuVj9X0FMK/2MPNDQQlOIhjyIJZWsjJvF1Mgx+raUc9H9tTRC9KK7/iyNbU4TbtwY8m2VsUjchKbc9913X/uZ6nk4jTezCq35ts5CZGQzSAedlZmzoc91rk3PM2XmJ+sIte/iTOjYucbKdtDZ0XWPn1If8Xq1QeEwZl4P2l5Y1qnteq6H1th1pux7MfqK+7/7/9j13P/Xw/1//nO5/5+/fjzHOrj/5/vPifv//Oc6Cv0/67vIpBT3g6surI7xl6WxAlC8dkHESqZ9FuXtUq+P7UN9el3mEqB7KV9nJ6IGmgHEKDjDlDsz4YYGutm33ZZpoGEvzzzQJPuhh+Dgfe7cuY0a1tD+uszWa/to3elsTm09u2ZWHj1nrXNk9xqP0fqa0umysk0dMGv3kx2fmTfVjo91XNtXj8E9D5ENDFndxX2yfccmgsbKq79Pre1l5xpqRxlT7jHbN9s+dp0p1123rtz/3f9r7TIe4/5fqscO3WO2b7Z97DpTrrtuXbn/u//X2mU8xv2/VI8dusds32z72HWmXHfdunL/n7f/1xhrzzDXxjJzy4UGGpG4dRuVrDTfpgY6QuVtc81FpY1Pu4ERZhGgl3u0q93nQlNunR3QSGkEtuxcR+XgD7MN9IEGqEgs6QcNE25GaxsoU1nzHvY1Fg7MWcOrdY6sQccOUNtHO7M+FPRYwAG9dp54nKL3FM8bjx2aqYl1o5+zstXKqJ/j+eI5Y3n1eF1m91U7Pnug1spf+5s6qGTnzOo4a1tZnQ3dv/6+cRDLjs32GfpT9DpZW8rqQI+tnb9Wn/F62e8a62Ls93H/d/8fK7/7v/t/bd9au9Fz1fbluvu/+79eK7tuPFftPt3/3f8vVP8fYuz7TAOtPP3000tqn+EHTSUrBWcK0iQqbXUcaZZL+V3xYfDaU5g7iBi10O1N4GZgm86bggaaia8bYXoRo3GjctQHGtsYRAzrMQp3pQyjxAYWj40NKzakONjoebL9tDOMkQ3osaFm58u21TrYFIYG7FhWfl/rdLFOhn4rvX8MFNnDJS5rA0i2X62O9PrZA0nLXbufKW0wu36tnvV8J06cGH3QavlrLx9av/ElJbblWAZF6yQrQyyLHqfXyr7Xc+m6HlNK/UUoXiuWx/1/HPd/9/9YBsX9v6yUaWg/93/3/9r13P/d/2vX3rX+vwnQQD/xxBMr26goZRRuyIMQni+77LI+U5NaLmtQ6prbcFfWRfitNiu0MGsaK/mxV27izJkz7XWggabw3AjTyywEufpBY0ntM2DFIsx5ZOwHzAaJ2DGze4rnrzXK2Dlr+/K8WXmzzj10L/pZzYxqnT0rQ60c2f61Y7NOn52vVh88B/70oRnrf6xcY/vGa2UD51h91B7YsU6yfdYdZHT/ODuZlZ/HxPvQY4fuJX6fPeDisbU+VHvQ1frHOv1m6EUiO55L9pGx/p/1Qfd/9//s3O7/7v/u/+7/7v/u/+veR2RX+38s1zrtHBroK6+8csHA0AqUpwgkDZDGCrKhZmqC9XI04Y4a6IF6Xq8zVphNgG5oCxQ7Nm6oqYT2O/pAQ3jm95kNO4RnzDig8pgHGtupgb7tttvaJe3n08IkDTkbMLUzZR0LcFDP9tVrZINPLENs7GOdPfsOYEYyDqgkGzC1cceBr9bR9VxqNhKPGTJhyjq7/rGeeI448NbqJ7sv3T40+OFaWR3VTGP0Gqj3oetynb8P74l/2SCT3e/Q/Wv5a7+rUrtudp2he6sdP3Qf2YO0VhbeW3yB0jYCan2jVg+xrWXfD/U393/3f/d/93/3f/d/93/3f55rqA6PYv/P5Kd4XCzLUHsBzz777BJyHOJaUTFKOQ/xr6iFBhCeNQ80g4gByJZwF1YNtP7msm2JSNxgrGxTuKTMxHJV64ySrSSz7m5uqWbc2I59NAo3BGfMNtCEG0I0TLgxUwENNCo3qvwz4myVfq41GG2Q2oD1u2xgyGCD0/2nlGOo8WXHDu0X17P7ybbHjhLLNVaWrGPV6qFWz7WyZeeNA1tt4MrOF8uaLXWfqXWZDYBgqP1l9Va7Tta2ssF36DzZrGL2kKhdJ5Y9a3O1+szqN7uG9sVa3Q2VJ+t3teOG+oz7v/u/+7/7/1i/Iu7/7v/Z9+7/7v+72P85cTSlLLU+lZ33+uuv37eNlsbQQDOINMy4G/lwZT9E4oYATVdgdReGXKl1LuXGB+yzlPWNmdWEmwVtCn8i5oLO8nThxiE8M5AYZhggPGvSbM5AqLaZ6v4xB3QwtZPoejYA1c7Dc/FvqDPXBuDatbIGoN9zXfeLnSd78NWuOfSgiNtqnX7qd0OdXrfVHuZDA0P8rnaO7HPtmrUyxGPH9svukeVeTnhA1x5wsR1k1xj6XHsw8bzahoceeLXyZmT3EpnSX7Ly1I4fuoexdlX77P7v/p+dM9vP/b8M3kvE/d/9P+L+7/6fnSeuZ8e7/2/W/zOLh1iWrHx6vey8lOGQB/rkyZMr36n7Ll16acJN4TkCd+EueHWtopeV9Y2Y04S7Rws/lAsaWugYhZsaaKJ5oIeCiNUabu37WiPMGmQ8JjZsNowhE6BYrrGOxH2GGnUsV3aPYzO8tToaG+z1mFgvWZmyjjz2oKr9RvFz7betPRTGltm1agNxdg6drZsy2Ex5YOv+cT223aG2np1jrAzx/mvrtWNr59Pyx/ofO0d2vqGHRe0csb7c/1evn+3r/u/+Xzt3dmztfO7/ddz/3f8z3P/r5XP/P9z+r/tlv9fU/q/bqBiNwjOA8hTZmJDKChpobNMgYnD/7cy4+5PDXbgLXr3Qa8k6tmNle6Jwl71CrXSMgRmAPmoagolhiUrAkhpoRWchAOzkYxCxbMDTZSxbbd84AMWOrt/Hv7YSFovBwTo7Z4TXUH+PrMHWfJLiTFG8frxWdq+18mWdpvZ97Zz6XfTVqNUXiL9Lrfzx+Fp5x36DmhnUWDmxfP755wePicfXzL1q22qfY7uI16uVScsw9ttm18yO0X4Sr1lry3Ef/e21jLE8Q/0y+9N9a/2l1mbd/93/h8rp/r+H+7/7f63++Z37v/t/rOtav9IyxvIM9Uv3//n6P++x9rl2TPwu+z0zoDyFhvojH/nIOWigmaWJ30MDDQVsTI+sStuFRNrurovPrRC92KIo3CzIUgrZC9FRmKbNerP9HIRnVII6hyvqRA4wU8HZCjXrrjWW2Ki1ccb9ePzYrEzsUFyPHWysQ9U6aW0mKxLLquWMs7NjA0l27qFlVq6hTpsNIvGzzuzV9ql18qG6jeccO2/8TbPOr+u1+tNrD7WFrM0MDWTZucbafayXWO7aOWvlqs1Y60Cebee1dBm/j8fFMtT2i+fJyjml/2efuc393/0/rtfqz/1//3ZeS5fx+3hcLENtv3ge93/3f/09a8dl9ZKdg+eJ67X6c//fv53X0mX8Ph4Xy1DbL57H/X/e/q9ly8o11Gaz/aaCeFidD/TKzVLx2sXXgqyYNUpu4wUXQ1bR6zKrCfei+9W4pC16LDB8pLGkJhqqeEZY4wwDVPdYIogYtNA034b2GRHbeK6sgep67YeKjVQDFegsztAgGbdnHTwbPGtkg4yux+953rhvbUDNjs2o3bNeKw5+Q50526bnyTq7nnvsfLV6i9umlG/swZANSEPHD/3uWT1nv3E2EGe/cxzMa/eg+2cPg6yM2XE8Zqh9xrLHa8Zyx3YRzx+PH+v/NWpl0uip7v/u//Ea7v/u/1POE+vB/b/su35cd/93/3f/P39cXN+W/p/Vc9Z+htoUtzMgNGU6BormvgggjSV9oBW6/1KOpPl23G/ZFZLL06dPY3WrTLgBC9mvg8yhW9NYoRLUGZx+0AQViD9GZoPWeUoQseyHxTLOPmkjxDKGa88awdCgEsswdTAb+l4Hmli2uMzOWyvb0LWHBu8yUM5sUMzOH8teO38cEGr3WDtej6kFh4v3OTRYZvWin8ful/sPXUePY8qKeJ512lRsN9kLC/tG7QVg6KE11O5j/6ntn5UpnmOxmD7e8TwxLYa2gex3d/93/3f/339O9/+yclzE/d/93/1/dZv7/9Hu/2NtgfVdqxeAKNwqRDPbEj4jAvczzzxzDkrU6AMdgRYaJMraxWKv0rjsi7FOe6oxpw90W5quUCtq8prKHKbcUMMzFzRt3JnGChV34403tt9xVmKq0FxbjnVm3a4Drw5mWYPKGsrQNbJBtNbIsw6iHX1scKv5mGTXINm9ZteIZc2uUbunWL/ZvjqA6nqNofuq/fY6cA75kPB77rOQSZfa/Y+1lVr91+qvVv7sGJYxXm/oRaLWHrO6z37L7P6ntIcxf5jYHofa8NT+X2t3sQ24/4/fT6391/bL6jfb1/2/fp9D7YOf3f/d/93/93D/d/93/9+8/2cTCYvF8ERZ7V4UprKCYhQKUsp68IGGHAg3XtVAQ4hGFG7IjVkKK6Xbxr9Y7noHm8hsGuhYQZn/M3JAh8Na/2dEVOMGzjDAhBsVd++997bHc1YCqAl3rRztyZMBc2xg4nE6axW/qw1UQ9epDTLZeryf7NxTjquVmeesdVB9YMT7YVl0kKmVNTt3VtZY7qGyxuNjede5v6FyZefioDX1YT50jcUGM5a18muZY3lq+2bXy67BZYwsGtdrAylNompl0G21aw+17aHvWOZ4X9k9x3tx/3f/j+dy/6+f0/3f/T+WNTt3VtZY7qGyxuNjede5v6Fyuf+7/3NdOc79f0gQr5W1ViZChSiEZ7jnZpmWIAtee+217XYqWSEzwnKZ5tvUQEc65W1mrj3ecScwWxCxpuKW2Y8p+aCLRkvrZg6qIylmHuI2CtE04e4vLoNZTWgmte8zMxl+jsegYw4N6mODajxn9n0cmKaepzYw67myc2bbtE5r5dDrZWXR6w9dK9uP++r++nmow9bOlZ1Tv9Pja3WSXScbfIbI2li8z6nUXlr42+gyXl9fCIZ+Z+0ftfvJjtfYAkPtbujBH/edev1zA8FCatfLHlLu/+7/ut39P78f9/+SnrtW1qHv3f/P7+v+P4z7v/u/Xvuw+v9Yv431lJWlBpSiJ0+ebNdVWUoa5Wt6nGqglajA7cq27MqzXE4t2AizprGKlaw30anYV4Rozh5AHR9PyCBijMKNmQn8oZJR2Ui8fd111+1rxPrDZXU01DFjJ4rbeX9qwpOhg0aNod8vPiSyexk6vtb54v1NQa9fK4uWNZulys6px+m2bF81V4n71waxrL6y+8/Ow7Jl96y/zdBDeJ36jWUaOr42kGX3M2UQG9sve/jqdbQuYr/RgbfWDuIDPp43699Dv/lYvWe/92Lg5TDeq/u/+7/7v/u/+/9qebmv+39+/Rru/+7/2XW3rf/HssQ+we8z9wS9r7idmZSogY7AjBsuvVkQMaA5oCe4DS+6MiyGfpt1mEWAXu7VSF8iFk5vAkL0mTNnFjTj1hunCTfNt+EwHjXQnJXAEsLzVVddhdDmS72elCfdFv+yH7TWcLPPQ42F3w8RBxauR/OobMly1vxbsrJn9xG/H9qWPSDGfD+ye6x15Gw97pvVTW1QrA0+2T3Vfm+uZw/U+PvGNjX0F8+r58jWs/orlbpStD3UrCyG7r/2Owxtr/WRzIepdq6an1h8INf6uX7Orqf71MwRx+rD/d/9P96z+7/7v34/hPu/+7/7v/t/LOu29n+WOZa/NgbouWqTPjThhlIUMp1qn5F9CYHEIA8ysLQGEWPsLJCZcKv8mZVvuS1RuLvKYQmXWlhNY4Uw41hS7T4FprHCOipXg4i9+MUvPtFdcKUsSxm8k3L2ZPtox8zOm51raNDLOm4cgGudRa9ZW9ZmyeJ5a2WrlTPeX+27uI+WPc4s6rHZ/rXttc6c3dtyYECLg0d23kW4XqzfWM/ZYKzH1Wa6svLWyjVU9in3FO8t3md2rVjWrH1l38WyaRuoUStvLPdQ+bP2Fc+fDf5DZXH/H/8u7qNld/93/3f/d/93/y/VsmdlWS7d/7Nyu/9fnP6v+9IaZKyPaDmwjFr7WBYoRaGFpqUxtiH7EuQ/kLn0avYmNeFWy+fst8+uvylzaaBROpZwgcLGHNA6G6DaZ0ATbuaABjDhhvoeJtzMBUYTbgINdKyYGOhBf8SsMWWzYsn9VfepdaSMbBCpDSxD24fOkzXsoeOyBwi3Zw+BeI7aABkHumw9Xi+7xtggF8+V/e5Dg3c839AgEx+a2QCUrfPYqcRBULfHbUPH1QZdrnP/7HfR/bg9DrC1+8+Oj/0ylnuoHer1snuJ55na/7PrxutrGeJ6tt8Q7v/u/1Nw/3f/d//PyzdUZvd/93/3//n7v+6b9fcp/Z/f18zboX3mumqh6cIbo3DrsVTIQt6kzKm+z7W20vwN/2ATmEsDzYKsLCWAGG8wPZ4zCagYFaKhvocQHfc/KUJ0bXCIHWTKQByj9sn9VY9dZ4CMDW2oA2cdIRsEsvW4bxx8smvV1msPivjdlPrNrjM2mGadU/fVDlp7aEyph+zFYAo6MI21k6FrxAEpMw+LbXLstxq7p/hAHGuP2aA59CDLzpH1m6yOxu61xrLykJ/SPrOHkG7PjnX/d/93/y/7ruP+n5fN/X913f1//7r7v/v/tvX/2J+yfjZ23qxP0gcaNEJya8JNDTTkPyyhTGUeaEAZsUtjxRRWK9dWhW3Wprr1aZ18gNnSWHUsuspZZDm5IswDjXUKz1jqbAMrUYG9PCo7bo8VpCYSaWEXqzN22exI9gDJrjn0cMgaX61BTWmsMVBHdn39i/VQ60xDnSxerzYYD51zrB7H9s1+i6xO4jFc6u8bzxn9TjLLBObG02twm56fZO1Ly6/XrPkn6cMgu78h4jlr7S7eW/Yb6P56P3E7Pw+90Ohy7JqxnNm2Wr8Y8/kaOn/8LjuuVu6hex76HWrrtTobun78bbNyjN1rhvu/+7/eT9zOz+7/7v/Z/cTzZGWu7VtrA8D9fz/u/+7/sR5K2bz/x4mi7Jr6OduufYLAfBtLWBRDeI5RuGG+ramsFChfITzDqrkSOKwvh5a7Wx/vRCMcWAIP50KBFixgdkMxFzQFaKBCND5z1kG10KhgCNBPPPFEm4D7N37jN76qP1JtFonb4izO0CwQj0lvNmlEU8iuVztXnF09yDWmfDd2TpYxlndo1nDsHsbKo8fXrj/lfGO/+zrlWOe4TVinzmL9gPhdPDbbLxJ/O90Wj59SrjnacTx/Vo6h8o2dc+o5dB/3f/d/9//xcrn/j1/P/b9eXvf//d/HfYn7//7tU8459Ry6z3Ho/zhm7HeMv03W/+P+4G1ve9ulkOM0NbEK0FSgQqmq1slw+6XlsmZ2iibcJGm7y6zdr8tcPtDtopTz6azAFC30VVddtVQf6Cg8AwYRU1DpCCiGa8eOyr+kjPu2Z7M5Q2jjqHXc7Jih7bVz1cqcna+2jTnryKYPz1p96nrsaNkysskAlf2+tXKWpIzZeWvny77X+4z7Zd/rPkO/3ZSHje6bPaTG2kr2e+i22J+y82btdWhQHWsDtbqp/WZ63myfWvvIysB7zX6DWlnd/93/3f/d/93/V9fd//PvdR/3/zJ4T1lZ3f8vbv8Hai0R//R6U39z7gM5robKfYjCDdmQ8iEzNwEoZfFH4fmWW27Zp42WOsA5ITxDdqz/aBOZLQo3C8MKww2ENFb9/s2MwUrBtTKmwNkK2M8P/VBZxyDZoBC31wbvsfPVGnMcZKZ28infxzLzWtFsaKijZ2XOzl3r7EMDV22ArX2OA/mUAWus3rK2MHVAqdVBds/LkYfU2DXiupZ77MEXzzfUVuK22nWyc46146G2kO07hdqDep1z1K4f63LsOu7/+/dx/8/3rW2rXSOuu/+Xvlzu/+7/2bHcZ8r9uP+7/8dj3f9LWubserGtcFvss7UyxvMDzQHNTEsMHg2QC1qB0pXWy9BA40+zPWXK2+UeWkebN5qO2XygY+c7ffp0X7huZqBdh99zM1vQf6cm3DU0CjeWqGzYzWtKq4zYMYb2i0R/lqHzjg0o6iczZSAe+m6oTEA7Tvxu6NxTHwzZvQ/to3UQO9ZYnWD/WjCNoXLUfnfWi/qE1AaJ7LxD16rd71j709+q9jtzO/eLvljx/GPtZags8Tq1uowDZxyos+uM1XGc5czKFeMUDNVv7Xcaau9alhpZ24vXUtz/3f9rv5/+VrXf2f3f/X/o99R93f/d/8fay1BZ4nXc/8tgmWvlVY5S/8/WSdaXdOJA+7/2DcSzOnnyZC9EYz0CDTRzQQMoXWG9jHVqoLFOwTlqoLvr93T3N302ocJsAvRSao2VRoZSWKkJdwbzQKuwjJDn+NMIbl0ZVpaxHMqU7VmnyzphnDzI9uH54vm1IQ0NuHruWD5tpFnnzu4lu8ZY54plGaNW3lpdLCsDUVbeWietHa91pdcfq694nuxaQzN1U5ZDM5NZ/cdrxvsau37tXmvXyX7vuH82Eznlc3b/tW21a9fa7dDLUXZcvK6WtfbHY/TYbB+ez/3f/d/93/1fP2ftoFYfS/f/fesL93/3/+L+X6vr7F6ya9TqMSvLUH3WttX6P4KHYZkJzgQa6KiFhvK1i8S9ZCqrzP9Zyrzk32IG7TOYUwM9KM3ThJs3qtCEW/N7IeoalswDDWFZ1fyAQnXtR8qiJtY6U+WeVjpH/C4SO0hG1vFqx2edbagjZeXP7qW2T41sgK8NmBljHXXsevGaQ9fAPkxHxs/ZfnG9tk+sQ3zH2eX4MI73EIkDZHw4ZS8UtbJlbUDPMfTgm3Kv2XWG2k92/Wy/2gNkrB3W+tvQtvggXRf3//P7uP+7/7v/r36XXdv9fz/u/6vH6zHu/+7/teO3qf/Xyhn7f7aMVgN6HoLA0FyPUbgBYmKpBhpA+YpAYrBupoWzpExeJkGsF/q32CYTboFS/gq4QajZVQM9ZL6N0OX6GebbJ7sZCvhAa9S2+MPoANoWqDLYZMfWGmY28NBBv2YuUTtvrVxD188GQ92v1qFrDbl2zNDAUOuEut/QeeI+2efafY5dVzt07fdYdyAdGoB5nWzAyH7X2sMs2682iNbQQT7WRXzADZ1jbJ/sPLUXnVhvQ/1o7Lxj/SS7/ti+tQej+7/7vx7r/l/2lXnss/t/Xq5sm/u/+3/cz/3f/T9+f7H7P7+rtcdYPv08tQ1GNIUxonBfdtllKyeA9hl0AcTaZYi7FS/Yf163LDUOxYS7YRFV6Vinsze10JhBUCFaw5RrLmiAWQmdmeCMxdCMzNBApAPdUKepDQTg+eefXxkwsuPj9YcG2qEOG/1k4vHZcfrgq5Vv6AGQ7Vv7Xu+xVl4l61z6UIrXzXxssnLH77L6Hbq3rGya57F2v7X7q5Utbtcy1PJDZmXTbZnv0lg5smvq39Bvmq3H62f3XCuLfp/tk33W7fH6Q+erteFsH/d/9/+sDO7/7v/8fqg+gPu/+39W9qX7f/p9tk/2WbfH6w+dr9aGs33c/0v1u3iP2eRNrAO9HtIR428MaKCZ5hif1e23CyDWp7OKAayljIusLAdhlrN0lbWIlcabQFhxREbDOpNec5+ohdY0Vpr/GUALDTNu+D8jiBiW733ve78ay6LLuL32ORJnlrgtNpjsPNn22LDiQJjtP1bGqcRr1MqXNfp4TFxm5xsq+zp1qNeP22rXr+0zdL3aADl2H3F/BbOTcYCZwth5a8fU7le/X5esXsmU/jPUBzYlttNamzwoU9qO+7/7v/v/+LG6bcqxU87r/j8d9/8yeD33/+Hzcl1x/z8+/V+31fp/dr1sW/zux37sxy7leswFDQ00ZMAsF3QjQEOObNehkBUT7rbYpUJX9maxpAL2QJU8WxorXcYfh8IzUOEZN85IagDCs9q5qwqfnDx5slB4hg/00OCXrY/dAxmKwqf7Tzk3y8byaTlrg2ztXrJy8C/bnl1j6Hrcl3+1gTP7bmgw4HLKwKHliMdm159Sn/p9vN4mv4HeR2xr+It+H1PbSbxu7fpD+9f2nVKW2J+ydlQbOIfKpMdn16qVQbcNPTz5OTvHJv1/7OHl/u/+z+3u/+Nl0uOza9XKoNvc//NyuP+7/0/Z1/2/jvt/vf9nfe0g/T87ltDKGMpSCM/MBc2YWJIHujfhVpmy84deJP7PWpZFVz/DP/IEDsMHulo5DDVOYkRuzC7ESGuaTJuVC+GZ22odWjt/HIiz8tYGrXjO7LrZtddlaDDJGqTeW1aOWr1knW2oPFMHpVjPGVqeTLufXS8OOkP1rL/xlN89nmPqgzfWfdYusgf+FGoP5tr27Nja9qwu4wCc1f9QH9uE7Pfh9mzfeK1Yx9nx7v/u/+7/q9vd/93/3f/zMmXnq+3n/j98vTHc/0t6rdr2i93/p/xWm/b/mIoYgjPddSH7IYg0YEwsdfNl8GmabmsAMXEfXu5duq8P3X5gZhGg5Qdc8nMWTpy+z1kk7ghmHDADkeWApqr/uuuuW/nRYoPJOtrYQDClccZr1M47RDxX7fja9WvUBvpS9neKoXPGzlB7UGTXnXKuoftkubJtGUMD8thAG+thaBAfQgem2oAc9xsi1m9te3xp4D66LQbVy14AateK16k9aIaWcT89j5ZVt2VttXaO+HlK/8+O47GsL/d/9/+h62Zl0OuO7TeE+7/7f1a2Mdz/3f/d/93/uf8c/T+ru037f+yTTEWs5tuU9Sj7EVgna6YmWi/DbBt/UebE+ZttJ/Yu2/eP1n4byzIDs5pwl65Q/FxToyvwgY55oFFRmHGACTfNuDEjwUjcDCD25JNPtvvHHzPObtYG7KwRxQEl67BDAzLPu8mgotcYOveUfbPv9b6GBpR4/NigP7Vehsoar1F7GNaO0U45dI9xQNHjsmtkZckeONlgMtS+1mHoxaF2j/pd1h+GHoRD18n2r9X31PvU+s8+D72MZGS/zdCLUfx9tL7c/93/3f/d//W87v/1/dz/3f/d/49e/5/ClP5fux5kupimOEbhhnUyNNAqRBOYbjN1FeVOXL8TqFeE6kVXsHX7YcahmHA3LLNk1nT0VtNtzCLEPNCoKEbhfuihh/adHD7QXK8NTmODVhx8ah0s+67WSLLrjTXYKeeKA0vtPEP3mN1b7ZrZ/WYP07FjY9lrx+g1agPWWPl0OZXsemODst5HvKfag3pKueLLQvabD5V/6sM/XlOvNYUpv2e8l9p+WsbaMr4kxQdr7R7idvf//fdWu6b7f76vXtv93/2f+2T34/7v/u/+7/5/VPq/fjfW7uNxY3UAINOdPHmytTCmq24MIg0gI77nPe85B7kRPtD4ozw5oLDNti/Xafc1ZhWgu4rBv5WSZcJ0Bu3boYFGFG6s0wYesGJR0YAm3AorZSyUfq0hZ410qBHGzrLJj8Ljs8BlQ51x6nlBlhs7W3K9NvCwPEN1GPcdu94QsY7jOYa+yxgr8xjx2kMPLpY/kg32Y2k/hsqjA32tvoZeDHDtocE27q/rQ/dOsn4yFZaP54nXjfUV96ldK5uV1+N1m/v//vK4/7v/u/+7/9eup/uOXW8I9//x8rj/u/8PnRccdv+vjQdT+z/jWsGkmybcAApU/DG4NGREKFxhudwIzhCeWx9oja8VNdF6Pfl9FqUc3Ix7VgG6a1D7CqU3ov7PzY0vYhoroBroDKr6YcIdf+ihxjXUGMiURqx/8foxV2CtIw/lqqtti9/XGnJ2DHLW6XG1so0NPErtWvHhknWeoWNr96eDae2+aw+Q2n1l1xjbT7+v5a2s3XOtbHHf7B71OyXL/1grcyy7niM799S6qN0HzptNZg21gXitrBzZLOlQXcZt2k50n6welu7/KbVrad3UfpOhY2v3x/YU99XzuP+7/8fjsnO5/7v/x++yz7VzxN+7dvyU32u5dP/X7fFaWTnc/y9s/6+1DZLJYWOTR1iPQcQAFaUAClT8Mbh0NN+GPAnhmYHEAOVNmm/Hsiw7sFoOyCVlPlCYxdAMTOfojWjc7Y1j9qCZeWj9oFkxtHGnBlrhzIRG4a7NnMXtQx2r9lln9hTM5tQGnLFz1vYZ6wTZ9mxGbsrxel9jHVU/Z3WdXSt7iNXOO1SG7PxDM6VZvWTXmnqNrA0sl/tfDOL+2Tlr18/uZ7Go+zbFMtTuIbtm7ferXa9WvqHva+eJ+05Zz4jfsS9m32/St/Sz+//qse7/7v8R9/8yuazu/+7/7v/u/9m2be//69xT7AP4XOuTzz777PL6669vg4g1StOFCs8K5EHNA01iJicQLJ4Xsd90G4Z/vIkcWIUdztWUcdmWr2aPHlNZRQ302bNnF5htUAFabeEpRMPpHLMXv/Vbv/Xc1AYz9OMPPRzGqDXIsWOyMsb1oWvEc6BjZ/c5J7V7jIPM2AB6oa4/5ZrrPiRAVtfrPAji90P7r/Pd2IMpeyHg9/o5nm9qe93kN57Sf2rXHyt3duxQGWqfD1r+7JjsfuL60DXc/1e3Z9d3/3f/d/+fD/f/Pdz/3f/XKX92THY/cX3oGheq/2vfqt1jNBHPzhF/M/DjP/7jl3JdI3FTkI6BxLBUIZqRuDvL5nZdo3HHuuqYrYLmDiLWljJLYUViKitWAIDmOQrPWRAxmnAzBHqG/shsVFqJsRGMdS4eq+v8PGVAz8pXu2Ysa+1c8b5q54znGitbjVrH1msP1eO6g0tWzqE603Johx26xtA59fvsAV1rU7W2Eo8f+rzpd1kZavtnfaR2fv1+SvvX77PPsd6ywbV2fLzmULm17EPt3v1/HPf/1W3u/+7/7v/u//E87v9l5fvss/v/7vR//d036f+6T2TIhBt5oLktE54VWDZHv2dcsnKvi64smw2EwuxRuFFgTWit30H7TJU7l5kPtIJcYJyFUOfyqWWpDZSxI48NNDqQxP2mduqsfDVio41l13KPDUC1exl6UGUdWO+19oDSbdlgM4WsrocGMD1uqLNmTB1Q9Nx6j1kZdTCZUtdjZRorY+2hk7WbuDzobzRE7WE5dL5YX1Me8kPXH7u2+7/7v/u/+7/7f71s7v/u/xH3//PfHff+H/c9aP8HkPUg+11zzTWLxx9/fNKPfsstt/SK206QXsh1l8n9TW9MFWYXoPXHCs7cbbQ0DSKGdWqgYbrN2QUNIAbhGSbcKjyfPHmyXWL2otawteFlP1w8buqPHhtIPDY7pnaurDzZ9jgIZB16qBPVrl+75th+tTrX47P6z36j7PNQnce6jutTBzE931CdTSnD1AGIx45dKw6Y8bOay0TTmVpd67bYfmp1VnuID/2mun/2wMvOkVFrc+s8qKb8tu7/6+/n/u/+7/7v/u/+7/7v/n88+n9W57VxAG0y+/2ztqBWxJoHmlrop59+ennDDTf0BWKsrA9+8IPt95AhKVM+9NBDS9VAY12uGWXF4U44kVlOsuz8nrWCTp8+ve/cmCFA3i7QBRFr91EtNCuIZtz0f1YBGv7PTzzxRLnyyitbH+iuDCxLtfNO7Xj6fbwvbtP9tOHGAWhsAKl1xjGyc085Rq8xdI7aQylev3YP6x6/zv3Ea9bWY1k2rdsp9TTl+01+s3UYGyCz+6rtO/U6m9zPlN9jatvUcsQHyBx17f7v/u/+X7+O+7/7v/u/+/86uP/vXv+PdZ71X90n+40U+mvfeeedlzKIGL/TQGK0PlalKhWtVL4yAjfTV3FdLsf1hdzTVuWB3hPpF+dV+7iBaMKNGQKuq/DM2QTAfF9Rba+VispGpXP2go1Al7GRZI0gY2wQ0vPrOac2aC2b7q/bp5Qx65ixEev27BpD19N7jOfTY4celvH4obqK+2m5433Fa9QG1Kn3qmXTfbMBJw4Ste+y72NZ1xlwatdX9Deb2pZq+9bakfanWE9TqbWLuM/QebPfttb/h64Tcf9fLY/7v/u/Xtv93/1fj3X/d/93/z/e/Z/CcDyu1k6y8kMpGstA62PKgpANMx9oZHcCMXB1+LwI97Feo60wy0myc2VRuCWN1cp31EBT+4yKotpeI3CDLAo3PtfyN7cFW6wK0VkD1v3id7HRpDe/WH8mdeg8U7YPDfq6LTvH1Hsa2yfuN1QPcduUfWrXG6qjdcowtn2sHGCsnqdcb+j6HASzNr7JOae2pbH9N6mvWr8aq7OsrmtlnnKdddtGvEbt3tz/3f/d/6eXj9dz/189z5Tt7v/5dvf/sta1uY24/5fRa9fu7aj2fz1vtl+8fxWq4z76+R3veMdLqQilFjrTQINaFG5ooCFTvu997zvHANYSyBp/LHy7Lvez+Q/VMbsPdEdbsBhMjMJzjMQdYdJsBYJzDCJ23XXXtT9ITXjWBhAbd9Zw4g+utvy6XRtTbIhZQx4inqt2fDYg1K6h96tlzjrPUDl5nrFyc19d1s4XO/jQfWbXGdqeDZDx96oNwFPOn30/VN6h3ykeNzY4ahvPzpcNsLV2Gwcxbqv93kMPo1iGoeXQID/2wlErQ1bmrJ27/7v/x/O7/7v/D13D/d/9f+x79/+y7zv3/6PV/2vtLe6ry9r5snY4BLMwqQl3BDIlhOhEeO6v00XoPiFlH7/4BC4pM9BVjEr6C7VH5zJqnmX/VvuMmQUsOw10W3mvec1r+nDmFKDhbN7MPLTHveAFLyjGGGOMMcYYY7afoVTE0D7fcsst7TpiYkGIVu3znXfeCZmy94EGiRC9EIG5l1HHJg+mcvAzdCy7QGJR+len7r//9/9+qvGOQcQ0DzSIgcSaimyDiMGE+5577nmuGGOMMcYYY4zZeu64445LEQwagnQ04R4z35bYWb2Fs5KYcPcsl9sVRKyX5jPhmes1k21CH2hUFv6ggVYfaFbsAw880C6HZi+MMcYYY4wxxmwXmfAMRSmsjmP8K4XCc6OUbQVnCs8xcHUpZZGZis8hPIO5BOhJpdEZAhWmKTgDzjBACw31Pc23ATXQJ0+eLMYYY4wxxhhjdhNG4aaM95rXvGbBKNz4TKtkyop33XXXAn9YV9dgWkDjL/hwLztBmvIkBOsDS9FzprFKtcE6I8AAYio8Iy80hWb6QGOdoctpAx/zQGMJU+5ijDHGGGOMMWYniBG4lUwDTVkRGmhqodUHGnQBwxaiZVZf6L0N5+N2HYhZgoh16M32ducxnRXzP8tn+ECvnAhBxBCJu5l16CuRqn2sN/svr7rqqsWTTz5ZjDHGGGOMMcbsFlCKZmmsbrzxxvL000+vROFWi+WGJTXQEKQ1gFgUkrvP7b5zCM9gThNu1UKnmmGdKZBUVvv2y9JYGWOMMcYYY4w5usCEuxGee5deblctdCNT9sIzlpr5KabLOn369HmV9Azm22BOE+7BAjUzAiufqYmGBppwZgGVhT9onzUSG2cm6APtIGLGGGOMMcYYszsgk1LtOzXhpktv0D7DLXjZaZ77bViXNMqLEOB6OVcKKzBbFO6OfaWiDzQCiEUhmkg48hZG4VYn8oyhyjfGGGOMMcYYs92o+TZBNqYbbrhhn6ynytdOvlxJZ8XPQds8q8w4y8nUtly3qcqcaMQ0ABNuRlMDqoXmtpgHmkHEnAfaGGOMMcYYY3aHU6dOXaqf1Q86ywMNYi5oCNIxkBgIftCZrHtgC+ZZNNCZOhzbYk4uFZ7pAw3h+aqrrtp3I6wwzD5EUMkIJFaMMcYYY4wxxuwUUIRCnotBxKA4pfwHheq1117by48QnCE31oRnwphh3Ufdb9TteApzqrNXzhWjbwMK0BCe4QMNB3DYsDeVt5Lji9pn2L1DdY+KpPb5M5/5TEEEbp7zzJkzXy3GGGOMMcYYY7Ye1UBHAVo10ADy4GWXXbayjcrXKESr8hZqaBGkadbdfndQX+i5faB7mMya61hS68wAYtxOH2hVzQMKz1jXAGJZzjBjjDHGGGOMMdtNFseKylLKfo1w3ArPyM6kQcRqeaCj5bO6FzeK3RNh04GYTYCGRL/siN9JaPGVm+1yQO/zf2bENarv/+Iv/mJffjBjjDHGGGOMMbuPynmQAR9++OF9QcTo+wxuueWW/rsoPEdxlJG4sT6HED2LAN0VUtXkrdBMwZk3BRPuLBK3BhEDzAPdVEy7fM1rXtMHEdPKveKKK2aNqGaMMcYYY4wx5vB49tlnW3kOVsUMDk1gwk0ZUIOIAZUZEYi6RsgFPbsCdk4T7iznlubjarXP0ELTlBvAhh1/zYxCb8INH2hWWLSDp3q/288aaWOMMcYYY4zZEa6//vp2CeE5uuYyiBgtkgFlRGigEUNLZUkoZ6m4DTG42oBhks6K6wdWwM4VhTuzKe810dxADTQDiHE7zLibGYUV+/ZPfOIT7TLLAx1nKowxxhhjjDHGbD9PPPHE4PfQQNMiGYpVyojQQN93332UJccUqa182smoar69HWmsyl6gMxYmLntwoxJA7BxmDzL1O7TPtHmn/3NG5oBujDHGGGOMMWY7oQaawEWXVsY33nhju41ZmdSM+84772ytlyFDMrsTrJtJ8IXu/Z6LaJ2TcF1rM5sJt2igVxy6o1M3gSCNP7Vlp3oe2mdUFlT39H/OeMlLXmITbmOMMcYYY4zZMWC+jRTFGufqscce67+nEE2gfYblMjXQWWytjqWaa3fBrtvVrQkiBrRg+KvYou+DocixpHoeKntUGLTQ9IGmthmVbIwxxhhjjDFm96AJN9xyb7vttl5WhOUxZT8oUqFQhYIVf+rqC6CBpvaZCluRO+levGQ+6NOnT8/i/wxmDSJW00LrTlC50/8ZS4Yif9e73nVCg4hxf/pAU9useaBtwm2MMcYYY4wxu8OVV165EhSaWmhYHlP2gyKV/s/4o5wIE24s1QcagjMtn4Pytg/UpamsDsqcAvQ+G/MMqNzp/9zMHOyLrlZDo28bY4wxxhhjjNl9oCDVVMUAkbhjGisAE24s6QMdXYYbTXMvKNPfWf2eJSr3xswpQJdl8MpOZgFa6P+MCmAlAKrm6f+sx2ilMgr3ddddV4wxxhhjjDHG7Aa0LG7kwHapQcQAtNCIxE2rZFW0UgPNVFbRbbhTOK+kswqRuLcmCvdiIbmsIEer8MxZgaYiVoTpLv9z+11MYcUo3DEPtPLkk08WY4wxxhhjjDG7A/ygG1mwlffglktlKWQ//EGZSoWqyolUvmr0bZApbhNhehaL5kvKPKyYb3eSfV9A3kyjil/ZrnBmARVE4XkoBzRmLJrKtVm3McYYY4wxxuwQSGXFKNww4S6djNgI0q0QzTzQNWDCHf2gwy5d/LCFyqlb5QMdo5qt3AA10Aw1TpV7BlT1mb07QUWjwjFj4TRWxhhjjDHGGLM7MAq3CM8t6rKrQaWHTLgHoMC8EF/oxTb5QGtUs2X0heaMAFXt8H/md4zCTSA8w4QbqPm25gd74IEHLDgbY4wxxhhjzI7BKNw04VYg/0Ur5JjCqhGe95lwRzpxtBWimSkKy63ygeaKFLYl+j0TnTWgHzSpqezpXI58YTDhdhorY4wxxhhjjNkdaEXM1MRUkkK2g/CMfND4TKWqAh9oKGA1CjeX6gfdCcvtanfoVqaxWlDzLPmg6ffc3xxt1aGFZk7ou+66KxWEUYHUQqNiWbnIF2YTbmOMMcYYY4zZbWhpHGU7xsUC0EJD6UoTbgD3YLF07gXqaA3dfT+b3Du3Bndf4LAIZwsgPNOUm9HUqJ6nzbuq79WEG+sIJoZZinvuuee5YowxxhhjjDFm67njjjsuRUwrWBTTB1r9n6lARRRuWibTD1oFaKCBxECntIUMea7sl3Vb2VqVvZswqwZaP2hCa9nWr6vwHE24GUQMlXfjjTe226LwXIwxxhhjjDHG7BQQnjWNFaHpNqm59XZWzEssVeaUdRWeqZBuBeuDCs9gdh/oktiW82YgNMdZAswi1Ey4wdNPP72MlWmMMcYYY4wxZjdhGit+hpL0Na95TS8TMgd0BmRKWDUjkJhaPWM9WEEvNep2Ytm9EXNG4SZtIVFACs68EXX4JoiiRg00VPNwFsefprJiZTKIGMCsxXXXXVeMMcYYY4wxxuwODAYdLYtpvq3+z5rGiq6/DEgNeTMJWs3PbR5o/HWm27NI0JeUGemzVSe25V1UNKz2XwQ/6NYHGsLzUOJs5AtrtNbtrAWCiRVjjDHGGGOMMTvDs88+i6BhC43E3cW8WkllXINprKCojUGrKSx3S0blpm/01qSxalHhWdXnnBWA9jlLes2ZBJ1dyAKJAdjKq7rfGGOMMcYYY8zuAGVoRAOJ1Uy4NYhYtGyG/KmKXHV4VlPugzJnMK5eomc2q9OnT+87f7xRQAEanD17dgENNAToGIWb61T1Owq3McYYY4wxxuwOd99990uRsqoWhRtBpBEHC+t0682icDO2FvM/J0GsqXXWzwdmFg20RjYre8L+IjHhbpfQQKsWWoVnoObbqr7XSkVlZ7MWxhhjjDHGGGO2F+Z7pvAMoCxF4Gj8QXjWeFgQnpnuuBGaV3yggVo+h0Bhh5K56VA00N36vlzQmfYZ1PJAk0wT7TzQxhhjjDHGGLNbnDp16lIs4ZYLmQ5LVZYCKFIhRDM+FjXQCD6NwNSa2YkaaP2MpfhCt3LqHCmswJw+0L0GulTU45n/c4bOOEQfaEATbkfhNsYYY4wxxpjdgRG4ERw6i20F4Zk+0LROhqIVwnNMfzwgPC8ZOAyCc2cePYsEPacAvYjruAHehEThbqH6XdEgYoDCM/NAQ/usoc6ffPLJYowxxhhjjDFmN6AJN4JDU7bTeFeAQjaBnJgIz73Fc0hlFX2f9zbOlAh61ijcQAumyazPnDnTXgvqdmiiH3744X03gJkF5oIGmH3AnybVxiyFo3AbY4wxxhhjzO7xxBNPtEvEtdLtVJpG1Ae6O24B12BVziKVlWijF5Wcz7NooecWoJcaPUwjoUl+rsLczwTqeCxZORpILDPhhrrfGGOMMcYYY8xuceWVV7byHYKIqWL06quv7mXTRqO8coxaKjey4zksIVdC80yZM0TijsLyMiw3ZrYgYpqomvAm1C49BhKLUbhjILEoQNOMGzMWzb4n3v3udzuI2BHjW9/6FqKul69//evt58suu6z9e8lLXlKM2RS0q6997Wvly1/+cv8ZfwflxS9+cXnBC15QLrnkknL55Ze3S2OM2TY4BuLvm9/8ZruNz9kxMM698pWvHDy3n9tmXb7whS8gfe1az+IrrriivPzlLy9mt0EaKyxhyk0BOgsiBj9oDSBGmMpKA4mRkVRWXD+QED3Xm95ialQz3KgK0XQG5zKq6BUIz6jcpkIX3/jGNxb2gT5aYCD99Kc/jcmT9HsEjfvO7/xOP5DNZPBQhsUKxoqpL4oHhS+ObqvGmIsJhdpG4dA+X+eYMIxCNM75yCOPVGPS+LltMtBuHnjgger73hiNlrLceuutnrDecegHjfc0TWcFYMoNDfQNN9ywuPbaa/cJ0ATa52C6naHCsy43ZjYNdDkvzffnjDfCXNDRhBtaaBWaNY0VNNCoRPpBayAxp7E6GmA2/FOf+tTkgdQPZDOFZtxoJ2TmeGnclGbgLzfeeGMxx5uvfqWUB/+wlM8+3jzv/hKz7M2zrXlyPX+ilKefaV4mmyfaucXeEtueL3vL9rOuy9+3X7333bXN8qUvawSbq0r5O9/dvEy8upRXXVXMMecwxj8ILJr9BM/uj33sY6OTk9Bev/nNb/Yz2/RAeMbEzkGAJhrtyuwm0EBTgFYTbihKKTwDZmbKNNCIqaU+0ICCdIjEXbp1KnwPLEDPMnXTmW/3SxBs0HthOgrPhBVz9uxZ+EC3gcQw66BBxGJ0NrP7PPbYY+Wzn/3svoc8zHOgxcPsIgRrzJ4TzHTjz8KJyUBbevDBB/c9nNGW8AIHM2t+nmP2Gi+PMIfEdbWdgscffxyTgJ4pP6Z8+pOl/H/++1Ie/ZNV4fdbJ86v45HJB9uC09ASnYTfx4ff5z6/d/xnv9Cdq9n27t/bW37vzaW8639Ryn/yPcUcMzAO/dmf/Vl56qmn9n3HMRB/cDvhtiljE44ZE55rz23sg33vuOMOj4OmbRf6fEa7mjq5gnZHawe2MZtz7yYUngkEZ8p5b3/72xeQD5555pnWzxkm3Aw0jc+MndXJlCvnicrbRZcEupy3ll6qvLopswqkItn3N6AqdZhuY7ZAhejmc7vvfffdt8//GagPNCvWGujdB4MetM5x5hoDaTNh0j6EFQyamE2PZmKY2YZw4gHUkDizjbYBiwW+2B02zYBfHn300bbNEpibveENbyjm+HDPL5fy4f93J9xCg1xEgIbGmdtOnN+m3z+faaMX+b7nRFutwvl/+cOl/Ox/WswxIo5/FHxheo3n5Vzg+c3nMcbV2267rdUIKhgLsR8nyFEOPK/N8QLPQvg5Y6IZ73x4/6PF4SZtQtsenq14tjMWCdp7fH8020kzoXYpAom94hWvOAe5Dlpo+kBDecr9qIEGqoWe6AMdU1nN4v8M5n6b7AtKwVlnArKbhN8zhGdA/2dUFoRoOI5DywghGsIzbOSRL6yYnQUPUmqdFQo58QFMMChikMU+H//4x3vhBIMxPtus2wC0LX15RJvA34UED3T8YcIHfwAvkjCpxOSQOfp84L8r5aP/r06jDMIjnAZkixOlf4wvwvcrWmeNJxq+X9lnsbrvL/xOMyHdDJX/1x8t5hjwuc99bmX8w3iD8W/uiUPVAgI8m7NnNycO8YwGOOa1r32ttdDHAMYfySwMlU3e2fQYPFvxp0CY5jul3wm3l+uvvx6prJbNb7SI6YmpPH3Vq151DhbJGkSMgjNgXK1MvhRaK+7SZYrqsi3XUlxNZpY0Vl3BFlKwKjUTbhA10DDhZiViVoKR2pwHejeBAPGhD31oRXjGg/Smm24qb3rTm6rCs4LB8G1ve1t7jA6MeDDDRAwvEOZ4gpc6mEyTiyE8K/H6F9sf21wYHvlwKX/wfz//eZH9iWC9ECl4RSAOc+S9efeyP7TfrT2PXk/Mvv/t7zea8EeLOQZwwg5g7MFz8jCEVWgTCQQVCMo18L0+26OwY44eeBZ/5CMfaZ/HF+OZB8UK3wnVEsxsF8gDDSGaUPsM/2dooLGEPAhZENspI2r2ppjZKbAU+bS334aoelDhGcwiQItz9nKKTTnMuLmuMwmYXcAfNNDXXHPNIssBDWjCHe3nzXZCXymYtepg2vz25S1vectGWjkcA6FbfbIwaD700EPlox/9qAfNY4i+PGJy5WIKz0StKtD2MYlkjjZ/dKZ5Ji5H/KPCk2sxcZ9WMBZhu7ZP3P6vf6eYIw4mj+kSddjjnwrQUya+1aTWz+ajTeYbj0kcTLLAjQDvbnj30/03uQZB+0Nbx7kxWaMTRvS998T1dqLCM6wV6KbLuFdETbgB/Z/JkPaZgvKYcncT5pqapHP2yk1rJDQ15c600OocDp5++ullZ/JYDSAGH+hithqY1KpWENAce8qDdwieB4MmhCcOqni4f/jDH3aQsWOGvtRB87It0O0AYFZ8GwR7czh86alm9vz/W3rtcS/MLvYHAquaYFf2U5XzgueMZuGVYz7UaKC/9NVSvu3SYo4oarr96le/ulwopggnDFhmjj54F6PwXPON1yBidAXYJIgYwDtePD++R2o1tE2UBbKEn7vbB2Q4KkKZworpiqFAveWWW9rvrr322sVTTz21pIwI11+0n6Eo3N3qeYOu8w/LWQKIgcNwROlfAyg0S0AxCM+FgcQQQEyOadF0Vghh3miiWyFMo7OZ7QeD3Cc/+ckVoQZgEMMM5JxmZdBC4099TgEEdwykTp9x9EFwEm1rQyaFFxoGL8PDHP0CS/sAHk3+8j+W9SNzig+0CtOLKBGX8wI5fKchRC+779R8m0/g5XL1u9/5ZCn/8I5ijihf/vKX+/XDDqqpz1O9bg3NTuAAT0cb/a3h754pSmjWz0BitRziY+A5n50f74Pwg+bEtQXo7SSmsKIJN9AgYhCe47G0Xo5RuDX7U6QTnBelN5g+mBn3nG9xQ1HQWiBIP/zww/1nCNNA7dkVmOMiBQxQbTMqG2bcar5rtgeYkkVzbQyYzeRIn0LoMMAAiTYRg4zBpBua6m0Sqsy8RJ+8bYKRQVlGtE2/RB5N/uKBveWKIHxiv2CcaaP1+9e/vplAvhURT0p54FOlfPzhct4nOgrHy5JL7ctVX+s/QegJC9BHEkY3BpicO+zxRU1wx1IJweeZghLw2Hd0wTNO2+HQOzqCy+Edf1OfeLS3oejdNOfGeygnr61I2U4YgVuVpI0w3QvR8IOGGXe0VIbsqG7A0eo5yqCqdZ7DB3puNUivcY43UDPhhha6Uce366p9BtBAU4Cmeh+gsiFQ25dm+8BgiEGRYACj1vlCwCBjmHGEEA8weEIbDp9pp7s6muhkzTZqd/HSSAEaS79EHk3+/08GbbDQ+yd3ZHLvDTeU8s//j9CsnN/2D5u/p5t3zJ/6r0t54vP7A41FU/B+GQKTffbZYo4oOoF4IYQETApCOKLmEM/XbJKa6SrJOvl+ze6BiRwypixBG4IQrfnCp4DnO849xQUQ73sU0NFH3Pa2H9VCQ5Z461vfmqawAhSeGYVbrZ5VeO7VzZ3pNrXQ5YDMGoW7dDFCWfAhVToDiVELDVg5mgeaMxBaqQCqfwcR2y4woQG/E4LBatMgYQcF14QgrQMmHvIOJnE02XYB2hwPvvGV1c/tg1GfUsu6wPvt317K//n/sio8k2uabf/9/62Ua69ePXcZOHfUcv/FXxVzDLhQ/saaCYOT1AjYBDcqTF5jHdZgHJu3JbCjOTw0cNjUnOMMAjb1D+92U+Pn6LuA3/22E0TibjTJSwQRA6qFhhJV5UFFLZcpT0bZk4HDJD7XcjljNLG5onD3DttaNuaBznJB1wKJYRkjrgH7P28/GjwCD0tofC/mjF8sg6MgH13UGmUbZ5n1Qa6z9OZo8eWn95apiXYt8nYn+P7U/w7uSXubnnuulN/6nVJ+7wN72mdwWfPdf/VTIwHGklcD7v8lG2wdWTYRXA4KBPX4jIc2Ee8BeM6q2fY2vA+Yw2fbnsN+7m43sCR+0YtetGw0yYvbbrutDR6mylIEEnv88ceXFKIpIyIKN7XPnea5jbEV425JhqjSfT4xl/YZzK6q0UjcGn07RuIGnfn2PsEYmmhUKNY1DzSE6Ea4XjyHt4viKNzbhprhbEsCe5QBs1gOJmEimvZlU/CyivQZY6hWyDPhR5xom80gYfF7yQF9VaN9vvl15w/53/7TUp5qNMZoKfjuve/Z2/49tzSC9KX7heE+vZWYbVd9o42ZCQrGEJprgaBgto1gUrYMMhcaP3e3m86SuPV/bjTRC0bgxne0Pn7Vq15VPvGJTyzf+MY3trLh2bNnF53bb2++jWUjX1YDie1Zb7dW3OfK+XnnrfOBBkxcXU6fPt37QlN4xs0yCndnvr2kKr6ppIJKaoTnfZpxaqCbmYhlF758YRPu7UGDR+Chuk0B3hxMwkQgPKuv/kGZIkSbo0/rAy1BwxZdELF9wcOCEH31t58/x4MPIpZE6XeGBvqxPy/lxu/Y+/5vnSzl/j8LsvFS3gYkUrdu+qxNuI8sF1Pzx3SSmJjGewD9sbEdPtEWnI0xGUxjBfPtkydP7tM+Q4iG9rmRC9vtMYhYo31GYOplzAMNebORP5eiz211u50Qjc+zROGexYS76OR6V0AWXDXQULGDzHwbQHiGEA2VPbc1GsN9PtDUTlsDvT1suwmtBg9T0zJzPJkjB+BhnMvsOH0kkFLN69x+psa44zOPl/L5v9xbf+jB4B/d/HvZS8/ve/Y5Oc9y9dLteYPmuRfYPd1sDhEKzPRVxSS6hWdjTI0sBzSVpZT9AE24YxCxTHim9jl7LwsC9fZpoLtCLTQSN7Z3n1t7ddVC67GonEaIpqaZ5tt+7O8Aah5zoXyw1sEPcqPQQuKgkfy3zdrCXFwWQWjeJziXVZ9lemN9tVHa/Z/+eTN2vqzRNn+mFE1Z9b/+B3tBxMBT0Eb/hQjfi/2a6LI4L1gv5Dw25zYXE1j9AFvrGGMyVFH6mte8ppf/GBcraqABI3Dzc3QV7iJvt09BrjMa90GZRapYrurFqwWDozeA2r2IYAxn8CwXtM5AKMwDXczWsO0aaC2T058ZYMHXHAaLRUnzPg8e0/x9vhGOvyWm2zjuH/5oKf/5j5zf73c/uJoDOvurnd8PTHOxiC4zFqLNpngi5ugAK+JGUXqukelKJ9MNKkxVeEYMLbgBRw00oRJXhWcwh+k2mSsKt663lQD7c3zuTLf7wmK2AGr35ub6a0fhmep6BH+KoJItPBtjjNlKVPurn2UXFWj7t4bledNuPN7f8UOrwvO/+4NS/rvf3G+SvVzWNd0rgrNtucxFQoM1HjRwozm+PPjgg+1EDP4oSJvdBSbccMmFTAfFqGZbYhAxEKNwAwag7mTKfTJhJ3cyJlcrSKt78Rwchg907wc9lMaquTlEQ2tnEYhWDv2gOzV+O1MB9T4qmftYg2SMMWZbiObUi7ixkmZqRdhd7uWE/uEfOr/Pv/9AKb/w3+4/hkL3chm2h+vtK4cxxuwIcBGE8PzUU0/12xx75GgRFaPMwMRUVvod01gx/zNoFK59vC3ZVRND9VbSczGnCTdWtbBp6irOFND/GSp4RNVWYO+OgGIhj2A/O3H99de3ybcRkbsYY8wGrJvGamrKKnO8iZrfxfK8L7JG5O6FXz242+fW15Vydef3jCjc/81/O2AKXjET3/fZT0tjzI4B4fljH/tYH90dMEid2W0gx0GeA1SOaiorAE1089cbagFonxlHC0pZCM+nTp06FxW2JYkAsnU+0Co1a8Gi8ByJgcRg304tNFX2qLyYCxqVDhyF2xizCQdJY2Uh2kwhCsa93/LivB9zKYlQDA301ec//t69ZSX11YopePaqMHRuY4zZERCv5pOf/OQ+4Rl/5ujQKFFhXdyuQ85D/CtaHwMGEVMf6M6Euw1KnSlrAVMqR2F5LuuFWUy4l3s6cQ0dns51Mwo3P6vwrObbCoVnQA00KhtLz0AZYzZh0wHUZmNmiOjbvPKZwu3yvCCt+1Z9lFVLHf2pl/v9nPvzRrNua6CNMVsEtMuPPvpo+dSnPrWSyQVAeM40zxaejw7UPjONFaHwrPLfEJAl1XRb10+fPr0SjYRC9RzMpYFuF91Hmf8+b8YdZwgQiRt+0BSiVfusMBI3KpQaaFT2c889V5588slijDHrskkaK6esMqOsPP3Os6JBDk/KPuXUifOHPvPM+WP/8hkRxsWQLc7lpJ+1PJ77MWV915Uh7NZiDkLzTo93/HYdgvIb3vCG9jlL4Vnb6U033QQ5oJijB/yfoRilq+79999/DjIf5D/migaXXXbZvmPhBvzQQw+tyJdYRyDroNBdSEqrWZgrOW5bSuZ6LvLYjsIzfaARiRvCM4KINar4lZN94hOfKDfccEO7jkjcnIVAxToCtzFmDiwMm0NhGYRdmlMvVgN/KYuw/oHfLwVRNp9vPvyHD5TzErRE6i5lv/a5iIC9IqyXYh9ocyDXlSEsRJtN0PSiEKAhNN96662tRlqFZ2zz8/roATdcCMi0Kqb/MzXQXSamdr0z417EVFagUci2S5U1O83zubLq/1zKqrL3QMwVhbuPrM0o3EUKPeQLjdkDRFTDHyoGwjMCiIE40Mco3OZog4e9UxWYKWx7nu9tz5Nu5mcZg3sF8+v2ISlPs8VyVZC+995Sfv9e2Xdx/jSjqauCuXhNM26OF4fhgmK3FrMpL3/5y1vNMoHQ/PGPf7wXni+55JLy5je/2cLzEYXaZTXh1lRWABG4YxRuRODGX7PaR+LWVFYQpKGBFnPtpS67SNwHHrjm0kCTlXhi0EaPBRIDzOcFuujbC8w2MCy5OX7EmXLPcJsh8KAl0ZdqG1ABWstqjhaL8JcF9iplv8a5Z5n4RnNdA5HJvrpf9IWO5TLHm01cV4awW4s5KDDLxjMxKsyw7U1velO5/PLLiznadJbFVeUolarUPjca6/ZxBgUsBehmeU7lTciikrJq0WWLUjPu7RCgGXmbBeT2KcIziTmgb7jhhpVjdVYC6n4k3/bAfXRR8525/LXM0UV9Y77whS+UbcMa6OPBisArc99MXzUkRKuW+X/+9lLe+a5SvvJcKf/Dr5fy7/9gNR/HyrlHzMH3mXabI83YBKLfm8y2AQUJnouIuI32i3UIz35WHm2YUemmm25qn1Kf+cxnltz+whe+sF3vFKntOuXE97znPYif1R4LV+BG+1zOnDmzgC+07h+sYxbcNpcv9Cwm3HTU7oTnaqFUxR7BzAJnFyA8q8oejuSaFyxGbDPGHG/woKVmFw/gbRKiURZOAqGcWSAMczS4/NqgBZb1lWXHvgdiZ3b9Iz+OvJh76az+yU/s37c34V6E68h5F2H9NVcVc0RRQeOb3/xm2TY8gWjGgDn3W97yljbKtoXn4wMicUMDDfdcyHYw6/6u7/qu9jv4QFMWhGUy5US1WkZmJ2ihITzjM5dU4IoWeoXa9nWYywcasLArz3INJw6obs/g7ALMtyFE14JdNLMU7dJRuI0xRDUrn/70p8u2gIAopBnbijlerAiyi7pPtPKyl55ff+65/Fztcnne33mxLCsC+lIPsgbaGLPlQGiGAG3h+XjANFZEFaUIJIYA0pAF6dZLGRExs7BEEDEoZhtheeU8DF6NdWqhuaTF9BzMFoU7mm8TzgLAHxoqd839DGjLDpjKCpWFz4zADR8JNeGG+TaWNkXaHrbdB1Vn5e2DejTBOIFJNbS/Zgwpjz32WLnxxhvLxQRlUBcE57A82ry4E3wxM30u26GSgkqja+OrX3tPKf+g00LDhDv6Sa9I0jQRL7nmmYZqr3lFMUeUdZ6/m6SxOmi6KmugjTERRuHmZ0bhxvrLXvaydgkNNH2gSaeB5pTxPrkzKm7Fzbg33Z5DiJ7LB3oZpfzo/9zNEDBady9Id5HUWkFaNdAUoglzQOs2a6C3hxe84AX9+jaakOlLhZbVHB04e/3oo4+2n5uBt11eLCEawjPLADyzfvS5vJnTfeox+DPtmVm3LFZ9l9UvWYOBLWX7H/z+XgTubzXrz58oq77TGjisEgolM+n+tkuLOaJMzUJw0DRWmwrR2zipboy5uKjwHME41aWx6gNLaworEBWyRDXQQITnwlhiZQbm9IFeAYXnX/e5VbXjr8v/3Kvg8UfhOVaQoup9YA30drKND0stkzXQRxdooZtJuf4zBNgPfehDF9QnGtdCPksVnlEma5+PPn/zWhFwF8Fku3RCdRCAF510Hc2zub6I6aiWFd/psB5Nul99ZTFHFGiIyZAAfRCty0GO1TI5BoQxJkNlPArPDCiNFMeUE6l4JUPxtYgEum4/lhmYW5KozIfvfQdBmTMGOnMAdTzNt/GHimoqrf0OanyYcWMdGugu3HmLNdDbgz4U50iRoTPqc2jtVCtuDfTR5tZbb239jj//+c+3n5lbEi+ZaEv8I5hQQftFEJMxMBHz5S9/uZw9e3ZlUgZtnsHL4gQShOfXve51xRx9rvpbZV8qKrAo+9NPraSZGojQrZ81+rZqtvtrRA23nOhtry3miIJnGsYxjD34w3iUPTc3TWN1kHRVOlZqsEdz9Ng2V75ttIY050G0bfWDpgk3AkfjM4OIQYhWM25YLMMPmpG4EUhs4iUXc0XgBrPngUbhTp8+vUASayypgRaT7iVnC6CFboTnXgtOIVpTWKnw3Jlxt9sfffTRhV9Kt4epM+BT0Yf1HJYGeIgTz4AfbfAyedttt7WBxDSYGARp/ME/OgNt+M1vfnN1wgbtGprlqf6DeJmA1hlacXM8+K7vK9VczEBNudV3uRV2RfBeibIt5ysl12zrNWFXtvJdd97XvaqYIwwmAJ955pl2HcqFmsXLhbbcU+sfP3uPNtvmyqdCvN2ntg8Iz0xLrNsRQKxbXUlpHC2UoZRtZEtYOpcYSIyENMsMdD2LID2LCXcXDnzved8UEMJz5gutgjOW0EJHVTxg2HL11VHVPrTQqHhroLcHDJwcoOZKI4QH/RwPe9UKegb8+IAXyLe97W1tG5ry8IRgDAE5mzlfR3hG+4LQjJQcFp6PFy9q5INXfU9ZSVu1GDK5Xua+zNGsm9tU27wMJtqLcO6FrL+10T6/2kHEjjRXX311vw5f521xpWq0Sf26ltEcPbZNA+3gdduPCs8q51ELDeD/zHWacXdBqdttEJ6j2zDTVEl8rkW3gCwdnp6bMYskEX1j9LM6cnc32a5DiIYADVU8hGjMJDQq+lagh6oeWqIuCrdqn9sTI18YhGj7QG8XMFX97Gc/265D8zfFJPZCoBMtTiN0vMBDEybdAFYINLXWBys+84UTAvIjjzzSH0PQnik84yUBwXT0ZYETM5dffvmKNYY5fvzPfqKUz/yUCLSdtrlfj6uSiir7Xk2/e7PsELV7RXjeJ62X8k/+XjFHHDx/acaNsQpBDF/72otrt69ZCA5iBm52A7UwuJBxR2qo5aEVJ9sJI3E37+YrgjS00MjpTF9oksXJYiqrZt/FqVOn2gQYsIAue8kwoh3XgkHFygGF6Lk00HsT4iExNYRnaqC7qGit1pl/EJohPN98880L+EHTxj2LwB2vqZVttgOdXWYaoYsNyqACtAM5HV/wcEcbxUsc2gH/brrppvKGN7yh3w/tRR/+ELa1DeGlFMfoOXBOnNvCs4EG+k3/YG9dtcALFaSFqq90sh/P15+mm0enyfci8Yv+5+8o5Qe+p5gjDqzA9PmGyeyL9QyGEI+JyJiFwBxt1MJvLkvETVErDJTL7gPbCYRnmHE/8MAD7WMtCySGuFhKzANNH2gI3NynU94uQkaoBQXnOfyg54rC3Uv1BIWOqawgNKuzN9XvMWeXqusVrdhGQFvahHu7gMb51a9+df8ZD08Ec7oYgyiuiWvrA3yqKa85fqDtavRu9Z2G6TaZy63AHG2+/2dKeds799YHfaLF3FqF7T7atn7W48L6Smor2f6u/2Up/4f/tJhjAlxGdHxiFgKYUas27rDAZCOE9o985CO9NRrA2Opx83igbkuf/OQnW0H2QoP3P6azBLY83E6gfcYSZtzRDxrQjRfKVWqem3Gs3w8yJKyZadkMotwJl+Lk0rMoYOfU4lYM1c5/DxW7hhuH5rm58VbFDg00bdsBtdCoQDqUax5omHCj8u+5557nitkaEDgCEY/jw5qRjhktdE5BFrOMDFihZroKro0AUTbjMTXQbj760Y/2bYcvfDpRB59qT8KYqTz6oVI+8r5mQuaTpTy/2Ptjbud+fRG+4/fN8d86sfrduW65clyzD1rs87Lvm28u5af/s1K+97uLOWbgWahZCBQ+e/UZvMl4ps9cusRkz12AcRRWO372Hg/QLv7oj/5oxU2K739oa3wHnBO2xywTBq75pje9yc/tLeQnf/InXwplKNbhmktXXSpL4QcNLbQqVdWEmzG0YhRu9YPuFLvq3MT1A2ugZxOgu+TUWuCWM2fOnIBNOmcFOnU78kH3hYcaPgrQ1157LfZZEaCBprKyAL2dYCDD7N+2WAj4AW6mEiN3KzTXNmZdvvh0MxHzWKMRbATpv/pLZJco5fN/uSfsInDyPmE4WY8C91VXNwJ1s/3SlzbPxWb92ubvppON9vtNzYThpcUcc/D8xVg2R1aMTXAWguML2hwUKRer7RELz9vN3Xff/VKYcGMdAjSW0WUXqYyxpBANATpLYaUuw/yM5ZLC6SoHFp7BXBJFWz4UvotwVpjCijbpULE3wnQrFKvwnNHZu6+ELwcQnuH73AjQ7WebBG0nmGFEECY8PPEAhz/0hR5IGegJfqk23zFTQZvFBJCaHwL6TRuzCVdcs/d3y1uLMRcEuptAkEZ6K1pnHSZ47sIdBs9d/HnS+nhCwfVivv9h4gZ/boPbD4Xnz3zmMyuTHdRAA8iFl112GYTnVuEKCxtooOkD3cXZ6pc4pgvMtaJ5jkregzCXBjqJIboHZwRwQ82MQetzrWmssEQkbu4PLTQqCsJz1D5D43zy5MlCDTRohPKvFrP1wKQGD3Ca2cw5oGKAZP5BdD78OZiTOQh46MMUjJG1PQljjNl1+BwGfAZv+izmiy7NwZ0i0tRAm+N7H98B54TvgM6EsVtEE24so/k2mGLCTaFZZE5G4N4nmzLi9UEF6VlGOyao7tbbJTXSul8IILZgKqs777yz3HfffX1+L6axAlDff+UrX1lA+4zZCcA0Vo7EvTtgYLMQYnYFtFW3V2PMUUKfwx7fzIWCEbDd5oxC4VmhD3SnPIUVc3nrW9/aCs6UEWHCDS20Hkd3YQlKvQhLwqDXWxOFW1Xk+6R6hhPHOtTt1DwzlRVNujmzwJDlmH245ppr2n1RodA+K47CbYwxxhhjjDG7wxNPPNEur7/++t6yGIpSCNH0fYYciJhYGiNLhWdG4Ya7cJb9Cei2Lu3yLMxyIrEpX7E1V5t07gsBmppnfEZAMWifASsIEbihsmckbmigsWQUbgcRM8YYY4wxxpjdYyyIWAwgBqhorUXgJjE9chFTbrWaPghzaqAHJXzejArPoBZQDMIztc+whdfvkHS7GGOMMcYYY4zZKSg8Z0S5D6j/M2NnQfvMPNAqNIviVs8zi+8zmdOHeCW6WaZ9Bo06fnHq1Kk0iJhqoB9//PElNMywg49+0Ei4DdU/1P4OImaMMcYYY4wxuwE10NQ+A2qgqX0G0EDDjPupp55aTskDDRINdGQ7fKAZOCyi4cQJfJ5VA43PcAjXfVBZiMLNCGw04Qb0g4bw7CBixhhjjDHGGHM0ULkPSlUIz7V9qYGWz30aK8inNRn1oMwaREzV4lFwjp8lkFjrEE7tMwOIEcxCRFU+ZyscRMwYY4wxxhhjdhPEtoL2mbGuIPshAjeARbLuC6Urtc9wCz5z5kxNmdqKpyKbqmB9YAXs3BrolTxcut5po/sc0AQaaAUprCBEo8IwA4EKvP3229tyonJRyZoH2hhjjDHGGGPMbgDzbUbihmKUKazwGTGwaIUMi2Q9DkpXuv5CGQu34MxkO/F17l2NtyaNVSS7EarYqXlWQRp5oIHatqPCMAMBH2iNyoZKVnt5Y4wxxhhjjDG7AeJcaQordct97LHH+v2iBlqB/3OjoG3XJ/g990L11mighRXNc4iI1u/ESNxYYiYBaaw0SXacbSCYnbD22RhjjDHGGGN2F2qgwRe/+MVWC023XfpBUyZUJSuhclZzQMfg1dFKuuyZdm+HBjoryOnTp/dF4Ba/535JO3aAykGkNc35pZHYALTPiMTtVFbGGGOMMcYYs1vAhBsaaKDKUVgeYxnlPypZAWRHmHGrchZUTLmxjXmgl51AvVUa6JVCQ03OG9Ec0Aw3jvXo/4zK0Uhr8H/WSGxqyo1UVkM5xIwxxhhjjDHGbB8024ZSVGU8QvNtBpiGnMjMTVg+/PDDvYwIWfPMmTOZXLtQk20RqA/EnEHEFjFceE0D3QjRC6zH71U9Dy00Hcipzmd0NgjPWMJ+vhhjjDHGGGOM2QlUhkOKYsp4AHIfFKgw34YQjQDTAHIiXH+73XqZkYJ0o3hdEYwhk0LW7HyfqYWehUvKDGRprBT1h0a4cQYQa264v1HMJLzrXe86wVkGVBo00I0QvW+WAGbcUPdbA22MMcYYY4wxuwX8nrGEa67KdDDjpgk35MFGNlxedtll+9IhIxVyI1MuumBiiNwN2XHZRdtedvJp7/tcZmQWAbozKKcQ3RcUQnN06u5mBzQS96KZTSgQnrENFdRomE90avt2P1SkzkwQa6CNMcYYY4wxZnegwAzzbVgWN8rRdjtMuSE8QwP9zDPPnIP2udNAQ5AuKkgjhVW32i9F49xrqmkpXVP0bsJcZ+pza5Fonk0YMQ3QpJv5vAhs3JtZiXYbKpC5wVSIxmxFU8En7rnnnueKMcYYY4wxxpitpxF+L4UiFII00xPTD5oCNJZQqEJohmxIV18NQM3YWpHO8rlmtr0dPtAlKUgMIEY6lXt/MxpIDJVD4Rk+0AwgxgrlEubb9IM2xhhjjDHGGLMbIIUVtdBQigIqSuHCC+EZS2ifz549uyLzUfEKS2aVM6mkpfDM4GEhldUs7r9zBRGbrBan/7OksupnEuj/DOEZ61DdM4BYBCp/+0AbY4wxxhhjzO7AFFYAQcRAtDZmMGkGEWMqK0biRhortXjGZxGo++Bh6l5cQlTuTZlNA63Rt8egEI0lZhGohUYFQT0PDTScxvHHfGCAlUp7eftAG2OMMcYYY8zuEGU4aqFjOisqVwFkRChdoXwF6haMdcbe6oTq3oQbArNqoUWg3pjZBNBMC535QSPUOATn5rsTjMJNVTzt26mqhwCNJU25IUDDfBu28qhoCNFnzpz5ajHGGGOMMcYYs/XcfffdL6UlMeS6LA80zLhhlYx1TXUMIRqyJK2Zm/VzyAF96tSpc/jMKNzd+op8utzbUA7KXFG4NdJZ1ZybebpwwzGFFfJ6oXI0gFgGU1g1leco3IfA5z73OYSVR5Q7RD+fdMw3v/nN8uijj7br3/md3wmfhmLMhaAZA/o2i3WCNnjdddeVl7/85dX2qO321ltvLcaM8dWvlPI/vntv/bWvL+X7/t60437tPYjd0Ty/XlbKO/9xmY0//ONSPnz/3hT7f/EPSrnm6mIuMps8Qz/96U+349fVV1/d/l0MvvCFL5Qnn3yyXHLJJeW1r31tMceXZ555pv3bhAv9DohnOJ7lfN6b3UHdcLs0VivfM40V42JpEDEoXqmF7pSyCwrP4PTp09RA75MTIaSqgL0ps5hwQ2A+nwp6oc7cK4VDpDSabyusBMDKQWUh8hocyCOM1mYf6PnBgx8P0aZxTj7mW9/6VnsM/r7+9a8XYw4btLlHHnmkfPjDHy7NONG2W7Q9/uEzxo6Pfexj5bHHHqueg+32QkPBf9OXFHNxgBD8of+w9/dnfzr9uI99tJQ/+P1S/vijZVYe+0wp//4P9v6enj5km0Nkk2cohdezZ8+WiwXGzXXLPQWMc/jDeGt2A7RDPhvX/bvQ74B4hvrdc3eBSy6W8IGmmy6WGv8KsiDMuKlkxTaNwg00bbJAwZSf+1RXc5hwz5YHWtTO6szdr/PmNAI3yFJYIWE2zLebmdiV76JzuTHm+AHhE4IxH5jUNkPj84IXvKCdjcZDlVppCti33XZbq13ZBijgo+wXS+Nk1mcv+gievmU9uv0Xh/D0aqfZPZVsthQqQS699FIoRorZfvA7QZMcwfOUE86wrsiepy9+8YuLMVPRjEqacamLf9U/2ZgHWs24yZkzZxbMBw05E/KmKHDPOz6vEfB6CrO8TYYC9fI0hWZZttpmtVu/8847y3333bdyPvo+33jjjeXee+9daiAxABNuLG3CbczxAloMFZ5vuumm1EwSQikE6c9+9rOteSQE1gceeKC8+c1vLsYclLUfPMvumLkF3S5EysJPQmPMTMAUOjOHpqUEePWrX213PXPoQPvMCNwZkCdvvvnmlW1U3nZCtJprz/oEnisK9woQniUKWo+krqLTd6EvNPygO+1zv//TTz/dCs9U5UP7zChtxpjjB8yxKTzDb3nIxxDaaMyicyYdQnQzlhRjDgKF1a2SWa2BNsYYs2MgFzS44oor0kcqFKo039btzOBEeTJaPKsLsbgYM33VLI/vuQRoTVStkn8Lbww+0NzWaaH7EzCIGGYaMOMAH2hG3wY03YadPHygnQd6d4F/Df0/N/H5ghaSQS4wI7rpPodVPnM4wHwMGmUAwRlm21OAAM0AI5dffvngvmg3aC/4/bGc6rfH9rbucWYH2WAee52nNfysP/pHpfyHe0v50wf3Po+de6p2+2xzrvs+1kxYN3+feKiYHUVjKKz7jNLnmwZenALGNR6PcW7d4w/7OheqfGY6m75P6XHrvsOtQ3zmu81cWDQXtLroQnFKGRBCtAYQA5rKKkKZM8sExbzQZQZm94HuVOWjx2DWIPo/EwjRGokbWmjYxL/2ta/tBf7nxt4qzNYB7SEEoChcwGcGQs4rX/nK9Ljf+73fa5dve9vb2sEUJrl6DhyPqKH0JYWWMdsHGsuhKI1D5Rs71hw+GnAL5mPrgPYx5v+ctRteqxaVFg/bT33qU612OwKhPV4X5ue6L45n+yZo5zaNO2IsRdCt8GAjLP8/f31PaOYc+bLzt/5f/Ugp//mP7j9m6Hxv/c/2jj31g6X8F6dK+dUzpfzm756X//HdtVeV8oN3lfKuU8VsKfr8Y+aAON5MeUZh/ETgxRhsCeNU5u8aqY2PiD3xhje8YWXMgpkvxkUFY5+i1kEE4yGugbLG67Cc2diIffH8xnWnlM8cPrX2graKeCT4XdY9bug9MUPjpSBzD65LcP4Hm0E3C5oHH3D0J7eZwwfKUPhBN2PaShqrW265BYs+qDSWMQo3U1k1gjL2Xzz00EPtd1Tgnj59utdEB//n7YrCDUlfcm6lkr8mvAa4eUZSgwk3ljrD0Ayi53T/ZvA/98ADDyzxV8zOgIHqox/9aBvMCesQKOhjg3UMbgg08slPfnJQc4cHMtMOYfDlAIzjcSxmLPEQHdsnKx8GWZYPgyYGaQjkWMexH//4x9sZSnPxoADN32UdxoTn2G70RRSTKmg7ET6c+TKL41A2tjm8zMWXRnM0WHcOe2xO+bd/u5Sf/RcY43KN8v/jN0r53/xMKV95bqA8afzRRpPzlVJ+6r8q5cz7V7/C31PNu+N73te8aPzbYrYcjDd4DjFFFsYofb4NPaMwvmEMo/DM4zGOcpwa0rxB0MD4yOcjxjmOkXim4vl+UGstjqcUglFGPId5naFyYmKAk996HMb9ucpnpsPnadZe0Abxe2RaZbRfHoffjsfxPQzvibWsGhEVntEmXve61618j+8oPPPZzTKij7nNHD6IYwXhGVbFMOFWDTS0zwxASIVqFkAMyljIlkhhFTM/QTaF4BxSLbfLbYrCTUl+EcOFaxAxzBI8/PDD7ZcaSAzAhDueF2r7phLbXGBqzg0zbmigHUTs8MBM91RTlrH98HDjQJQFfcJsI2edMTjWtH0Y1KJW78tf/nL74oABFwI2yo2ZRgyW3Aflw2DI1EcxkBS24dzYHzOUMVIoy4eBfSivsDlc2IZqM9cHAZMnaJeY4dZ2g98dL240I1PBGu0ND2e0hze96U0r7QKz6GgvKDPOQU0L2x41NDgGmiWzOzA06F/95V46q1JyWVq3NY+xqrYYmudf/ZU9IfvSS0v50UbT/Pe+H+kaEY20lP+xEZ5/7wNNG/3zUv4HCNLvrJwoFKKNFl728kSf/Wop33NrKe88tad1pin3r7xvb597PtjM7n9HKT/2A8VsKRCAEdchPqMoWGOZPaMglGB8AzVtMZ6BGKcycPxTTz3VrkMrp64zem19tmIf7kcNOr6rReGOwk4sI77nBDjGTX2GM+USiO8XaiGEffC9OVy0vWW/h/6O3/d937dyLNtgfIfjd/jDRAkCDA+h7QntCO1Fz4VnOd8nsjbNMrrNHC7qhgtf6JfioSd0WuhUAw2lK024IVuWkAGKwnSUSekPXWYw454tCjdNtzMTbrmZRYzCrWbczO+loKM0QlWfGwxLRuG2D/ThgcEDOXYPCnP0gVrEZAotePhjcNSZQAUDYTSJhU8rzomBFWXO9sE27oMHKWc3gUaVhBCU+ciifNgPx6J8HlAvDrROOIwJDJwz/q7cRnNCtBNtl3iRxXd4KYxlQnujzzbazhQTSbNbPPKnpfzZg2ISXfiEXjWTPh/JJBeif+kX97Zf/e2l/PzPw8Li/Hff3mz73//0njD9W/c0f79TyjvuLuUa2WfoTQDfPdcIz9/VCMf/VgzAri17AvP3NO8n/+T03jZoou++qxGyLi1mC8EY9Ja3vGXfWMMJPE4Sx2cU40ZkggSA8ID3Nmp7ItDmIgUVxrMYdwLnxEsuNePYZ5PxGc/mmrDD60Coxj3iOjqZyQl8HBPfL3gcFDFOoXVhGGsvEFjxO+L31t8Ryg9aSEBJFtsAnqFq4VUjCs/oG/FcFJ6ZAjOWEW36+eefd5u5QCA4dPOb73uMQXH6qle9qrVERiAxuPdSiFb/Z2igIUTHXNAij7byZ+k00HOlspotCvdecLNeiO61z7pPN0uwAky4GYE7Oy80kozCTft4qPuxrEVtM9sDhVMMkkMRk/EdB6vMJwXg+8wUVwfATJiJ+6jGnOXDwDwUYIoCkM24jyY1ARcaH7ad6HeItojvai+M9MnnpI05OkSTaa4uFqs5mXu7sf7fKp9qBPDPd679b/+7q8Kzov7P/+EDZXoZy155/pt/nu/zxkaA/k/u2luHqff/78+L2VKGxhpOEgN9RuFZR2FBrWsiEHqGhAV8VwvaSFNpkMWCmALNeYfKqMIOn9uA+zMYVARjuAWhC8tQe4EAzHasJtL4nfhb/iVMbyrHDoE2QFeFzDJMrwVqlpZ4F3SbOXxgRUwfaAjR6gOtwIQbwjMEZ/WBxhLBqSlbRplTzLQXDHI9ZzqruUy4W9NtSvUxUzVnBR5++OGVNFaE5tusGAjTiMTNfNDMA60aaFR6MYcGHooYfKaAAaimreYDDSY5U67J2eWMqytvlzpA1oKoRHMwDsQcwDGQ1kzY+D3AAL3pLLuZB/4WczL0YJ4SuRttAu4EcTtBmcf8sM1usOgCe73xLaX8+D/Z/z210P2cd8N//V/igb9/3z9//LygCxf/9773/DHLsrp8aaMZ/kqjTf5Tic00ZQb5b93QaKwHhl9ond//wb1zfeLhPaHabB+15x+BwMLgS3xGqYAylrUAY+CYAEyBPI7BvNYmEYxxHDWPY1GQ+Z2WkybrNCfHfVJT6ef0xaXWXvgszALawWICfzgOn/H8neK2hWtA88w2PxQ4Du+jbDN4d2Wb0ckgc/jAirj56zMsNSwoRENxCtnvf2rv/WMtKc87z/fc4MYBQ4zBTjcCG7cgOLA4ImSRl2igHVaKs7KzWSn0rHCUzf7hONqd1WYVrTybH+P2ahJr/hrNeBLlxyiRnLEz0xMJjWGkJBoweBRnphVCxgwKFgw2Mbg7mLaxeyDQwK2pb9361v2e57xvVZ17694+p/l+pHOrTp2q91e9b9V93ud5nwfCM2NBqwk3/WdBroQ2mg7EAnQW1i0zThOZb4OpTLjlX4WGue+cFaDptppw17MHs4ceemhOeOZ1aLS6U8/9j9Bqnaurrrpq9sQTT1gDveJQiBgSQgAfdiVtHWcNx6RR+g0PTE1fX8hjZ885u2n2F96/+NKdKu2dUPLcbs5z6rfVRRendMX3jjt9y3ZsS/hWnhNFy/3/rvW+XbO5nc22GXhrAn7qbxbT1m1XxGpLI/6WAZPsK9++/R/FyW8ks6IMvf/0GcZ31DLLXvre0RBs6dNhalS4Us1yH1HIxmQ/12IjDaYDwQtRFJbx3Gx2D/oLl8z1EQVr+r/BO1X/J4MHbgi5fWuf4XdE/zeAJUbJnw7GUqnPUHvuPrP3YN3zhRde2Gig8R3yHQVo9cLdKlOLQm9OeG41zmk7QNS8F+60KmugU1uYWlDegNvwWcHAnE7EcF69bQoP4VmBIA0hmtpnrF0B0D6reh+euN/ylrdYgF4T9kJrOCWMEzwGPMzN/oNZY7xY8WKceh36Tmad6fkV0CNuTKfPqsGsJzt98+ZeVrPZdno//j9vrXXWddRE94OflTmT8Vw5/ZI8NyzzzlvlCTj4eWAUAjzf6v/FFt6BeCZPMbGJ9bE7gc4YUVZ8uB4bAj/WdmNbEqbMtNASAJT6S19MaNwn9WtDCwU4JoOQizXyuQkhnMN18HQ2VvKnA9hn1EkoxiEFd9RjyFmZ2R1tDOgZl+UilBW2tXI0HThwoDkHgjQ10ArDWPF7XP9MMbTVQM+JpVOtg540DjQqQGdhfedTeAZtHK8FL9zwugbVPdX4EJ7VxXk7Y2Ez7hWHWsMxpl3qDGS/wEwkQ18MmbiZcwtehtT2Ro/YQ0BTjBdsKY7ostBBGCg5xxtaFmDWlNlwTOfCZQu8/R3bQu773lcLEDelpYEjk81ZOc+Tz/Vf//VvbJ976IpkdgnNTZcxZx7z7sM5fesyVSCJ6eBZpM4zc8QlKKTPMzLB83inArQ+j0s+TMaCdwRN3dEe0EpCQMKzWteJm72D8b/R3nB6l+svFIxL0NkYoIaYGubohV3BNbj/6MvwpYNzb7vttt5+rx7jIThjMgj5QWBnuFWzv1x33XXYNG+1+j5sRuE5h0Z8ksOdQldV0FOEsAJTxYFWYbYpYC4OtAIzbu5TeIbmGR94W4PwjJnDuP5ZcRir1YcvfMbw7YPOT/YiTFEJrs0eUz6b6Z5b8CJjf8KLcZkwa/gHCi/FqQRavvxznl/jOeY8I2OKPYQ6GVPefXg7rfvv70/jS4/2pN9TnlP1o+2Rx8q//9vPb5cPnrnN7uD7q+TUKoL3Ht8tff+sD72j+P7EM4ll4PMS6ZcE5KH0+RzLeUYmO1n7TCAsMd0hE+5l3sFoAw1RNOYdb3aPhiwd6i9jJktwDia+saYZlJxy0ks3wH1H3hC4YSk2FowXCuGAk+Rmb6AMBwdiCjTQUJ4ihDGskQfiQHf7x48fb2RaEaRVI63euTU29I6ZzAt3CpZtoo1OcmxOcC7xwQ9+sKkYVPdoQOyfOHFikybcDGNlVp84s1dC16/sZ8gf9ZTcVz78I/TAAw80gpsF6XMHX8roKzArHPrHDf80wrEI7hlfxFMwpg/0/TPIfyxWfWmDKbP0S6haNLeGxvm/e+/W/uf/3ZZX7hz/5SspfeyXUvrfPpLSn/3HNL58bX6/96/y5/xFLVj/2we3zsVa6CP/fTK7ROMwD030MdY8wDV9k8d9Zq9IhwKiOhtDmjrpWHpujTHBLj2rkO8Y7XPfs46TkPg/oK+98I/2F77whTlheGh9tk5omP2j1N7qGT6e30bdyV6nPgByfUmFcZxLDTZNtBX0mb6x6T6zv7QOxDoOHDhQMQY0gAl3vIbm27BgJlgLTblT5c92PTQDRDX7U2ihJxOg6SJcj0UttHrf1jjQCGPF45hhOHnyZMXA2YgDBu3zrbfeukEtNO3lzeqDfyao5YVFQXw48qGJFyDAi3Q/HXShfBTyc+UD+OeCa8CAvTSeO+Dohuuf8RKGcKwaHMJ+hbVYXBtVCmmxE/QFi3wiONYnQKvDvBh2xqw2O5q9rcrX/t27t4//0v+X0j//HfzDsPUd//d95rMp/f1f3PqO6C6H3z2uTM30e2tu/sh/Tun/+gdbmmiYdOPzz4+n9H98fPv8jxxNZiL4zx+ePXhG5TTROMZ4tWAo6gWeYY888sjCM0LTwTlxkpDfWZZ4PYQLvH9L7zUK4BD0c3kPafj4rNPnYXxew9EXnZ7l2gvHkQ/MalEPvR7lwns71zb4znf6flq2vZFhO+cmQxijOQfOx/1FX8z9n8j3JPrJmPc4JpL4v2cUltFn0B9z4wHfmZf93ewt8MKNLZSiqoWG5TFkvxibXp1MU3BGGCtGeCKQPVv5k0Lz3NLi2USBoCddAx2PcwZABWkKzvTEDeE5rn+m23J05PpFVCEmXM6E26wHmAmEIAOBBw9HPLzwkGW4DTVf20/tM4FAxjU5Wj6AYywfjtkRybkH3jExw4x7hf6Dhyw+dOIVPXXjeF9Ii53ANfNcK4UthHvkj39I0Wf4e+l6/GMKyweUHedxPNx+++2epFlhduJ8oxFkC28waKEhRP/Lz26lfe+/Selzn2s9cKdtT9z47Rf+75S+V6MZVQPlqX+4+aYtzXcjRP/nea/e3PxPR1L64JFkJgLvMgjRGNt4FuH9p6bV+l7BcbxXhp5PeDfi3YSwO6VnXS4dvlfplAnXUyjm9YyxnFvigkltPKc4YcnnHK7FcWq5Sx6XIRzjWY3nIrTHDHmF9y49HUevyNhCeKFQrf8noC7qr4T/XzAkEcNXqaYzN7Fg9ga0M//f+7M/+7MuNBT7C/Zz/QXX4RpO6ECIpmd4OvgC6E9jQd9An8C1unY69hmUB31Q+8yUFmsmD0y4T58+XdXPguri1jumOozGM/TgwYN8c1ZY3stnKE23Ydlcy5jQWM/ojRuyJwTnejv3epxIbu6Yag10EilfBeZZaS00BWld/6xbXTSuDYpZCptwrxd4MMGZBB040dMh/4ngyw0v0HMhOJTKx7U2LF/JIYbZfzC7jP6Cf6T4DyP6E+4Z/6HEixsvSty3vbBqQNp8mSNPvPgpCGPme2iyBdezXBwPrIdZXXZs/tRz4f9aC9D/+J+KE7EqzWmt31sf/0e/ltL/eOf8dX3/D1ADjXR+7e/X79wPpjlVNV7Zl9b/s/w//3tK/+D/TGZiIBzCyy/XNcf3CsBveD6NcWAJYYLPstyzDsJBKR28v+LzhtfjWjxLSw7K8Kzltfqco/D8Az/wA73PVwjgqgVn/RlhhSANPtP1XP6fwDpGoSZeRyGMz1HWz6En9we0Nyescd9if8G9KFkD4Dr+H8a+xglp/O9VcthZQk25kT8127HP4Df3mXMDPHFTpoN8p9GWwKlTpzqL5JwzMUR3ghB99OjRTT1+7Nix5u03ExfcVTWt8fKUgmjnPKwu+Gb92ch4REtR1Q5gxo0tHYgBhrECUOVjC0EaccLg6hwNDU/cx48ffymZtQIPK3oFxYN01UyrVr18ZhH+k4UZZLxo8c/mfplfIV/kz3VZnHEfC66lGdmy15rzD8SGhuk2zLUvfktKN920GLpqDO//X7Zk8B+or/8n///Wsf9avy2feGor3vN116R08HtTuuSiZPYYarZU6zx2rP/Jn/xJs4XwSCFXnxnLPut287zhtTt5N1LbjS3y7Sszn6nLPs93ep3ZG/S9vGx/2a//w9xnzh210Nu9fWo5sIJJNxWm8H8F7TMEaPwOIZpOxGC5rM7DYMaNrcqc0QdXC025aTi9K4l6sv/UJGg1FnE3h/AnVGjOY1oOzjDUgnRVz3xu0IlYjAPNwNtm/egLxbEKrHr5zCLR6+x+QpO0neJJGqO843u3PjsJaZVDX5Rvqf9dublWyNyczH4ydt3mWHbzzDhX17INxjwr+Uxd9rm60+vM3rCb9/J+3UP3mdUEitP777+/cSZGDTQZkiMzwjMFZ5p071p4BpM5EYOGXEy5Z6oql7XQc164sU/tM8DsAmcYoIGGG3PNg+ugqe53GCtjjDGmB7vcNMYYs6LAMTQ8cauvK8h/dMYIy2QNYQW5kbKjypRU1maWDnfrqJNooNMumTKMVQOkegjPulhbKxOF6IiacaPxaL4N7TM10PbCbYwxxpThdLsxxhizajzzzDPNVj1wU86DJ24eg0IVsqF64WYYK43uRIIGmjGskm6nYCoT7hmF5lpA3qBqPOdADGugqX5vK0779g3MMBw6dKg7Bg+W8MJdC8ydoM+GhpOeMY43jDHGmDca1VzgDmOMMWZ1gAMxEONAA2qgEZEJAjQUqzknYiNQi+hJTLfJJBpojU6tkj/2+Wm/N8ejBhqqeKrnEQMa2xtuuKGJEQYh+sSJE513NTQ0PnAm1hdn1RhjjHmj8mM/ktIH3r+15tmsL/DmjY+dCxpjzid0Ga5qoQE10HQoHYVnXf5L2TLC6FCt0Ey5s7luCkF6ci/cgPJ060Y8aXwu9cJdC8mz+nulXrj5G2Yb0HA04Qawj8f6Z5hwcx20vXAbY4wxxhhjzHqgXrihjUaEJZpw04E0gBYaArSug6YnbnwgX9JhtW57sp5ECz3lGmhVRM+tgdb4XHQ3DiA8awLaOJx10EZEw6rwbCdixhhjjDHGGLM+qAyH9dAaaUmVp5QHVckKwRnWzPWn+a5LhkcIz5PIjpM6EaPQrMIz0IrFONCqhif1LMTCMWifqYGm3bzXQBtjjDHGGGPM+oBlutxX59CQ9bAGGkt48QHqiRvaZ2yPHDnSyLCQK2HpjH3ImyJz5gTpWVpBDbQKvY02WtY+z4WuarfNdzYEwOwCGgjqenwQRJuNx5mJelZi85FHHrEXbmOMMcYYY4xZUyg8U1EKeQ9roOFEjKGs4hpoypCQKWHZzGXCgTlBGnJptUWagqlMoBfSyXngBtRAo9LqfhyaaKrn4Yn7vvvuq6i2hypf44OpCfe99977YjLGGGOMMcYYs/J86EMfuvj06dMVrIopRKsZt3rijmugGcaK6PLgjAk34z5XszbWcrSU3glTaaAp3S+I9bEi1EBTeMYsAs242Ti1kN2cC8GZGmilPr85zybcxhhjjDHGGLM+wISbS3LhhTt64qb2GUCxqmugFayHpqwJU24ocEUc5ZpnjWWVpmAyE24UeCalYmWiJjoGvUbFacbNxrnssss67TMaELMQOiuBMFZYcO4wVsYYY4wxxhizPkCOoyOxWqM8g2xHa2N1IA3tM0Mcl6DnbTqthjjaKnU7zTNl1FYbvWsmE6Drgm/q95wbcZhvq5qdQIhW4EQMQvRzzz3XpMl4YBSi1ZGYMcYYY4wxxpj1AHIcHYmpCTeUpuqFG9rneC0sl7n+WT1xaygrUerOXT9FDGgwuRMxiQE9V0AEukZFoxduED1xQ3jGFlpoNeHmzAQauj7HIayMMcYYY4wxZs2BRppKU8p/XNZLYLWMNdCwaM7JlKBV4PJDJnVAPYkA3QrNzR8NZaXm2/X+3DVcC03Uth0aaLgsR+OxISMIuJ2MMcYYY4wxxqwNasJNqJGGCbeugQb0k3XkyJEZtc5A5UmugcY+TLWDuXan6J3CE/ckAnQrNI/WCNMDNyuN2QT1rgaPa9A+x8YjcaG5McYYY4wxxpjVhybcdAytvq4I5EHul5yIqYJWw1nBVFtcc3WhrGYTeRGbUgM9t88ZAAa3BlHVTodimE3AlkI0FozfcMMNpeyaxeaYudAg3MYYY4wxxhhjVpuofdZwxTTfhjIVQrQqWQHlRqKyJqF1dLudtcJzc2yVwlg15FTiOhvQLvYuCr06uwCbdzSgemLT2QnMXHgdtDHGGGOMMcasD4gBDe0zlKLxNyzfpSMxCNFR+xzjQEPWjI6rW00zr6vaENBVWsJiuo8pTbgbib51Hb4Q/xnfoYGGqj2GsopgDTS2d955Z3F2AjiMlTHGGGOMMcasD1CEQniGY2hEV4KSlHIePHFTgUozbmihS2bcgJbPKn+K1rkRpqeKAc0Ep2SW+V6pM7Foxo2F4AhjRU/cbBwK0YCzEGxYNDRmLerG3bj33ntfTMYYY4wxxhhjVp6jR49exH2GsQInTpxoQhjTDxYjM6kZNzTQkBsffPDB5tzoqBpAkAYFqXnXS4CnMuHuVORp2968+R7jQTMONEy5S8JzCcxO0GwbsxZXXnllMsYYY4wxxhizHsCXVQRyHsy31YSbUEaE42lsGcpKrZq5Fppyp8rOU3jeVqZyIsZSzanIqXnOaaDbSid1RQ50hgGNp3GgAcNXQfXvUFbGGGOMMcYYsz5AjlMhGhGWdKkuTLipfVbgQAyK11YR2/xOgTm3FhqIKfdKhrGKcZ/nNM/1/sJ1EJ6jJ7UzZ87MNR5V+NqoUPXnZi6MMcYYY4wxxqwuUXi+5ppr5pxFQ4mK5bwPP/xwdx600NBAq/YZQnSUPyWb7ThW21Lz6njhpjTfCsxVDGXV7s9d08aCXkgLIazIwYMHOw00GpUuz7EGGtvoAt0YY4wxxhhjzOoCDTQ+AMKzAgUqnYipXAiogeZ3ypcw36biNoZXbp1cz9o10WkKJtNAt3bbmAXYwC4rkVOlK5hFoD17jPP1xS9+cZMaaMC4z9BAo9G9BtoYY4wxxhhj1gtooemFG99pbRzXPxPKiTGMFYD5NhW3aq4NuZnnTOmGe7I40KKF3tTjQZXeMRTKCiD2lzYiGhZOxNDQaHSHsTLGGGOMMcaY9YORlbBPE26EscI2twYaqP8sLBHWZcJQ3AZBulHwpomZTIBmDOjU2ptTfY6K8MNzueibcB10LoQVG5E88sgjdhxmjDHGGGOMMWtKzoQbylJYH2MJr8qDBFbLugQYJtw046bwzCXF7SnV1B64wZRriCnhz6WpGmjYp0ev2wC27BrCig0Wtc/chxYaGmhsf+u3fstxoI0xxhhjjDFmDbjtttsuuvzyy2e6PJcaaK5/jhpomnBTiIZC9vjx4418CBNuPVfXQ4dwVgshrnbCBWkaFkoBwRkC89GjRzcpRLeV67VrhyCNBoPXtcOHDze/QZBmo7aOw4rpGGOMMcYYY4xZTaB9rhWom1dccUXzHXIelKUnTpzYRBxoCNFQqFImVGdireVyF7pK042+t7Z9h20ZSK+UE7EkAj0PoAK6oJvxn2+44Ya5iuU00uqyHJ64sUWj4gM1Pxebew20McYYY4wxxqwXb3/722fqQAxCNIVnngMhGsKzOpqm8+noTwuKW8id0WQbQjPlVAjTaQKmEqDVsVml6595kIIzBWkQQ1nRjBsNBQdi2H/yySeb36iBRqwwqPmxby/cxhhjjDHGGLN+wIEYZDugy3UZxphm3JARKSeq7KgOxKC4zYSymokZdyXC9K6YTAMt+50wTe1znwMxhbMLhw4dmpsdYINCiFYNtDHGGGOMMcaY9aFdkttooelEjMpSLN2FJvqpp57qZEbIiJQTc3Gg5Ts9cOechzWm31OYcU+mgcafNpRVVkCmEK3qduxrI5D77ruvSwNqfNjD59K0CbcxxhhjjDHGrA90HqaoBppRmOhYmtrnXAzoGO2JUaGodW4Pd79PYcY9iSZXVOMLDr7UCzfU7NFenWugsSA8euKOgbTZsFD11+c2wr+9cBtjjDHGGGPMevDRj3704lrWq2DCDWFarY11DTSAGbeugYYQTYtm1UBjDTTNuNX7dqvcnbXm26ujgdb4z4oKz+33hWthx07hmY3D2YbYgASqfjS6NdDGGGOMMcYYsz48+uijjfAME26acxMqUGHCHUNZ3XHHHc0WCll8oJyl9hmRn3ieCsnY59rnVfPCTRoJPwrOSlwDDRNueFOD8EwNNBoLjYYF5DkhmovNc+p/Y4wxxhhjjDGrCcJYQXiGEM1jXAMN820I0XAoTaUqgJz40EMPNbIj5Ek4qIZyFnInhOic/KlRotQbd9olkwrQtCmPMbgA1OrYRi00hOc2ntcCWEAezbgBF5vXgradiRljjDHGGGPMmgGZjnIdgfzHNdBELZUBtM8a2akkPIsZd7OdFbyLLctkTsSiWjxWBGp1VFTdjUe0YTDrAO0zPmhExgfT82HGnYwxxhhjjDHGrB2wLIaMp07EasVrs40m3EopspN64sZW5eWp1kBfkKah6lydbUv4XNytavUqOhHDGuhaFd+bOGYiWrPtZguVP75Em3ljjDHGGGOMMatPG5p4QVEKC2Qu49VlviVo/SwK3GZZcVDwVlOtgZ7MC3eS+M+gtA5a1e2YOThy5MgGvKlpOKv6+5xmnGbcOjMBQbpu2I17773XXriNMcYYY4wxZg340Ic+dDF9WV188cXNNloaQ4CGT6xbbrml+a6Wyg8++OAmlLJYBx3TlqXEGhmqWjknYq3krPG1suugI6h4Tnimuh6Npmug2bDtbEW68sorkzHGGGOMMcaY9YDCM5yIUa5TRWl0Iq3CM4gWzfC1hY/Kn7UyV+XcWSuvzqaIAz3VGuhK1c8w3+7zxK0wDjSAel5t3bEOWheRa8PCjNthrIwxxhhjjDFm/VBP3FCUUu5DJCYAWRBbNeGG8lXTgH8txH/GB98pgwZlrvoOWxknYh3qHhwFZ+GxxcwAVO0qNGMNdAk0HtY/Yz/nRMwYY4wxxhhjzHpBwVm9cEPug/aZTsQUCtGUI+lETCM86Rro4Gx71oaxmmQd9OQCNKHjMDoRqw/NODMAoZmVrgXqJg40r3v44Ye7NNB4nIlQ4Zm28o4DbYwxxhhjjDHrAxxBv/LKKwvLdEEuhDFMuGnGzfDHKjirtpn7UVBeuTXQQlaqbwXpZl+diAEExC7FgT548OCMGmgALTSch7Ueue2F2xhjjDHGGGPWjKuuuqrb12W6gCbcQL1wQ+lKE25YNvMcXTrc7vfJiCuzBprMhbICJWdiXPwd7dgvueSS7vupU6cqLiKnCXcu4LYxxhhjjDHGmNUnZ0VcigN95syZ7jiUrnQ+DVNurH8mXDrc58i6lVFXZw00CtQam1d94azobjwX/JozDN/61re6a1SNTw00vbXZhNsYY4wxxhhj1hcoSUu+rhjGiqjyFQrZGAM6o41ugJPrNFEI5ylNoBfSynnijibcGsJKPaxBiI428DozASEaJtyOA22MMcYYY4wx6wHjQKsjMRWg4QMLWmhooGMIKwjQ8KFV727yWNQ6F9Y7V+1vs1aY3jFTaaAX4kCPhQ7EsGUDQXhGg8F8Gw2IT7SNB9ZAG2OMMcYYY8z6QBkOYayi8Ewv3E899VQFmRAKVn7wO5SvtUK2glKWJtxQ2h4/fnyD+63H7U4mlShRuxaemdBUdGlR6o8aaFQSQa1RaZhwcx101ELDEzfjfkELDQH61ltvbRoFJtxobOxDA33PPfdYA22MMcYYY4wxa8Ddd999EbaMrAQoRFP7DCBE04SbilaacHNZcATa6FYWZSirGbXRPJ52yZQa6E7SZyEZ+5kntXbqm/FiaJ81lFUEnrhpGw/hGY2tDW6MMcYYY4wxZvWBElSjKUHGg7UxhGeNwESFKtClviAuCyaiwJ210HQ7TcVUAnQXbyvamx89erQTmFXrzC2ARzV80DDRzp1euAEaFi7Psf6ZoayMMcYYY4wxxqwHMOHWpbiMtgSLY8p+0D7zd40DrUBRG9c/47vIo43jMCp4p9A+g0nDWFUZ0T54Qlu4BubbVMVrnC+sgcaWJtw8//HHH9+E9plm3MYYY4wxxhhj1gNqnxlZiehaaNU+K7r0t1bUVipralirVi5t/HS1AnXVWkuvThxoSvbVFsXzNHwVPKhBeNaGIBrKCqp8OhFjKCtjjDHGGGOMMetFdARNE27sxyhMfRw/fnzuXChrW4G6mm1LzWrSnfPOvTQXpAkQd+CzoUKp6Tacielv1D5jxgEaaBWitWGpfbYXbmOMMcYYY4xZT6AYrWW6lIsDTYtkXearcaAfe+yxCibbEJrVlLuVTZtdFU5XzYkYF2YPFgga6DZ2F/bnfmPDROFZTbgBHYjp4nNjjDHGGGOMMasNZTjKdLlwxZHoRIzQhBvbsHS4CVulltGtML1r+XESDXQr2C8URisBT2k036bmudZGN0L0kSNHUnQghoXj0ERjIbl6YzPGGGOMMcYYs960a6CLDqQVyonqP6sEtc+Zn7gueldM6YWbnyyI1QXzbTXh1vXQOc9qJM5KoLGfeeYZm3AbY4wxxhhjzBpx+vTpTobj0lxdA8110A8//PDCtRCe1YpZQyaD6IsrLC+eVRPEs5rSC3evShx26Qx4TcG5FaiLCT722GNNI544caILhUVvbddff72FZ2OMMcYYY4xZIy6//PJZNOPmGuhrr72200Lfcsstc46licqPXAeNfYawUiE5yMsrGcaKn65wrFC7uLvTRPN3nUFQ23aYb9czCikG1AZoaCw4v+yyy2zabYwxxhhjjDFrAuNAU3gG1EDff//9lWqg4Rurz1IZ6LLh1DoO4zEI1OH3XTNJYgxhxfToCe348eMbmBXQc7EWOl7PMFZnzpyZYaYBYLYBGmgKz2xUCM0w3waYubjnnnteTMYYY4wxxhhjVp677777Iu5DiFYP3LoGml64Qc4LNzTRKmuqJ+60Ffc5RohaHQ10qyrvIlSz8FF4BrrumbAhKDxjtgFOxKCBRiNClY+GxYfCszHGGGOMMcaY9SLKc1SUwvI4xoGO66CpeAUxopN44kZoqw2ac9M4eoLlzw2TmXBTulcxHybbEZhvx1BWbAjMLOADQRom3NBAgyeffLJrWKr662uqK6+8MhljjDHGGGOMWQ+uuuqqZqvrnyHr5SIvUcHKpb6qgaZ/LQWKXCh2220joyL2c7s/ifX1JAI0tc/yvdnWkv/ceRSoIUQzlBUpxfbiLATWPFOIhvBca6Y3vv71rydjjDHGGGOMMesFnEPjAxlPzbipRFU0jBW2EJ5zyloQPW9vHZr1RoxahqlMuKsQpHpusTZmAFDBKFAD2K5jJgGNAiEaH6x/hs07TbhxnoasgrtzaJ+tgTbGGGOMMcaY9UbNuCEDEgrOUQOtwjNCWanj6lYurTIhrHqjRo1lKidija25qMW7INV0KIatOhCDGTe9cWMmAY1CIZrn0G252sLDcRgEaGihsf3sZz/7UjLGGGOMMcYYs/LcfvvtF910001QmlYxjBWgAjU6EXvwwQcrDWHVaqE14tNc+Kp2DXTzvdVAT8JkGuhWeN4S91uT7ugyPGenTqJ7cnrhjgvJr7nmmmYL4Znxw4wxxhhjjDHGrD5YA/3oo49WcQ103zVQsh45cqQ7h4I05E1EfornHzt2rAtjpQ6v0wQK5MmciLUezqiJHoy3pbGgFRWkGQea39GwWAtNbMJtjDHGGGOMMesFhGisf8Y+10BD7lPZj9bIdDSt16sHbkR+CiGsYOK9iS29ckvI5V1roqf0wj2DpE+bc/0tJ0yrJ26o47HlGmh1V6428IAaaGAnYsYYY4wxxhizPpTCEsMLd5T9IhrGSpEQVp2mGXJpLZ9W7f5qORFLbaEg+bem3LM4C6AwFjQ9cVMdz5kFuisHOS9sxhhjjDHGGGPWD4axAtBC6/rnHOojC07EYvxn0sqfXVo03+bXGDlqp0yqgW53m4L3BaqG+baacEMDjU8plJVy2WWXzWAvj5kLm3AbY4wxxhhjzPoBp9CQ67j+Gdvo/wpE822sf4ZCFgKzOqlWq2fKouJELE0UBnoyAVorxVhb2ROpfVaggcYnZ98e10HDWxu2mLmwCbcxxhhjjDHGrBeMqAQNNH1cQRNND9yAXrjPnDkzo6KV2mcoYyEwq5NqsYCu2jDLXSir3DLjnTKZCTf+qNaZrsRZEcbqOn78+AxCdBSkqYGOWmjMQsAeHvtU73PBucaGNsYYY4wxxhiz+kB4hvYZH/i4YnQlaqCfeuqpik7EsLyXSlYNYxURDTQ9cHNddPTEvSumigPdpdXG2MqGsUKQ62izzoXgOfPtXBxoqPYhQMOUGxroe+6558VkjDHGGGOMMWvAAw88kPaSH/mRH0mrzN13330RNdDY0kn0iRMnGs/ZdCRGDbRaKGssaChka3mzkTHhiRvHZB10t7x4SxG9bd2ddskFaQLUXDsUcA4VnlFhqN6xEBzf64bpfqMwjZkHzEbUGujmOO3j0dDMOhljjDHGGGOMWQsg373yyiuJwjOtjGF1DBNuOJFWb9yQDaMGGtsbbrih2Q/CM5S4jZX1sWPHNuvPRmvOTUXvrpnEhJvxn9N2jK0O9catNuoQniFEQwONj4aywhahrA4fPtyYb+saaGifMVsBDXQyxhhjjDHGGLM2cBkuNc9UkgJYHveFsqL1sgjN3W8MZcVlxNDqUhaVtdC7liEnEaBptk1pH9B8uxQDGltqoPFhKKtDhw7NxYEGXAMNYCePLZ2JGWOMMcYYY4xZDxBNCQ6h6dcKUIhWJ2KUCdWEuw1j1Xjfhuk2TLiVEEp5QV6cQgs9WRgrgALTkVguDjRnCDSEFdCA2CdPnqygecYHMxDaiOGaymGsjDHGGGOMMWZ9YBxoKkYBzbgPHjzYyIBY/0znYbBQpsNpyI2QJWHZDC20aqAz0Eq6YaXiQENo5qePOEMAsC4aMwnqRIwLxmkDT9iwXHSejNknzpw504RNwwdrNowxxhhjjDG7g8tyqYG+//77m1BW0D7jw/XPDHkMQZoaaJxP+VKjPwUmlxkncSIGwtrnxqQblVATbswQMPC1aqHbddBVzhM3bOAxu3DrrbcuCPvrEgcawtdnPvOZheOXXHJJghb9h37oh5r9NzKf+9znmnb68Ic/vKtzpubLX/5y84l9Dfft+uuvbz6rBIT7s2fPju5Pn//855v6/dzP/Vyagt/8zd9s2uT9739/MsYYY4wxpkQbA7pxJIZY0M8991zF9c+wRqZSVZ2IgWjNDChzRiGaa6Kxv1JOxIIX7uYQ/sT1z5wh0Epz7TPQhoEHbmwZB5raZ7Cu2mcKy/xAyIHwQsHQrBYQLvE5ffp0c79+9Ed/tPlAQMT9wm9//ud/nlaJRx99NDtZY4wxxhhjzKpBR2JwLAaFqYYvjn6xYLVML9ww4c6Zb7eyKENZwRN3NcZSehkmWwPNwkKYLs0A5IAa/o477ui+Q4hG/GfMOsB8O7cGmvby67YGOgrQP/7jP95o6iiMmdXhT//0T5vJDQjLd999d3O/3v3udzcf3DPcu8svv7wRoCG0GmOMMcYYMwWI49z36QP/q64LEpq4AXGgEX2JQjTkQWypZKXfLIZGzi0PbhW7sySm27UQ3eyv1BpoQE/cEKQlBldvIemN+6GHHmq+04Qb6nrE9YIKX2chzkcgoEGwhpYzAnNcHN+PdbfMZzeacK4TztVF0Xrthr1qG9QDQjEsBCAsX3jhhQvn4DcI0dhCiJ6iDGPqs599IsfYewzGlvVc18kYY4wx5nyAyp5VB3Gg4zGsgYbVMWNB4xhNuAkUr60TsZTTPovytrsOAnUb0iouOd4xU62B7kojMbYaoVqFaC725hpofNQDN2cXoIGuP80xNGAUomEvjwXn67IGeggIYVoXCBE5zSaE7dtuu60R6HA+TL8hxEVNPI7jd6wVjmthf+/3fq8xleAaVeQRBUDko+uyNS8IUF/60peadbZciwzhBxpbrYMKmArrxfzwO+q0DMjvj/7oj+aEfW0b5IFPrm0ANMvQ+Jd+R/3A0Dpe5PXe9763qXvdd9NNN93UtRWujeujS7+V7gHrM+Y8tAnSJliLTKZY30wriXiPP/CBDzSa+Aja+Itf/OJcWWl5ocT+ANCmy/YJY4wxxpg3MusiPAPGgW6X5c4JydBA33nnnbNTp051x7kGGoJzLTt2GugI1ztT0wy5tJVJO9k0TcAkAnQbu2qmWmiacmN2gOp12KpTiCawZacQLU7EGs9rVNujIbkOGrMTMOFuBezzQjsN4UQFpT/8wz9sjkEgg4CH3+jM6vnnn28cselxFQKpIQT4TQWWr3zlK42gwsFFQRPXI69LL720SR+CD/NRcC4ENQjgV1xxRZcfBLcDBw40giGOf+c732nSQD1+8id/shOiIWhCWGJ+KD/K9Md//MejnV5BcIfwjDLEtkFZIBQjbeSDtHMCMupBB245UEekO2aJQN1nm3qhvXYC7wHuCdLCPXj22WebNR+sD8A9RT4QVo8cOdK1HeqJtsd9RvvDAQOOT+3EC/cYbf/DP/zDTRlQNpQbx2Hirv0XbcG+hzZEn0N/wPk4D/cH4BytO+uECQzWyRhjjDHG9LNOwjOABppCdA4Iz9Q+43/i+v/2Zh+CM/4Pbp1Sd+dHx9VRoQuBuhWiKVjvSpCeRICmVJ9agZaCNCvDLYRnap9rYRrHN9WhGDXQtVC9UQvPzbHWiVizT/fm5xMQgCAcUSMJ4QHCCQQVChoAggjNhfGBcAGhA5pPCCgUYCg8Q8iJGnoIVzgPwicFoOgxGdchHwhGXANMcI0KxIDCs2qbkQYEaQjQEJzgeItm0agHhUKtF84bI0SjrmgXFa6QBsrAtsR31BFtg/NUuIOAhrL0CZj4PadVzYG08dmJ6fvQPcDEAuvDe4l1LywbjuNhie8oA52boY5TewenNlwnFdhPqH0nmICIWnaUEw861JfCMicdOCHAOqHv0KGEMcYYY4wps27CM4Dw/Mwzz3TxoAEdRtMLNyyS4VQawrOGsuL5rQzZu2yY66EpULfbXWuhp1wDrfGg5ypx/PjxJh9ooCk818J0lXNBruugsYX2mb+xYSEIriMQbOjZGR8IH9AqQhChQAihFd9VICEUBilMYbBw/SihRhpmsHFNM9qNggnTyAlaFGpjOyNNFXIhACF9pBGFX3xHXsyHaeW0ikg3t864RK7MTBdtzHPQNtEMnu07JKBB27rXsE1Q/wjuLbXrgEIzBFC9p9TC7zUoT9TIM++ofUf75u4RJoVwT1hvaNsB7lE0x9+POhljjDHGrDPrKDwDaKDr/21ndAytQHkKR9LglltuWQhhBevlaMIdHVfnPG63MurqmHC30Ix77mCrfW72ab4N4Zm/UxWvQHiGur5u3C4ONEy4qYG++eabZ5i16FP9ryJ1h5gTzGimSnNmAGG4byAwThqIZtw034b2D+fxN+RB820KNhR6dN3sEFEry7pQK14C5WJ+JbNomgUPAeEsp6lGXXEcbcx88FEzdqSPthsS0HBf+sqiGn/s6/dlYJuU1nEATo6gT6hpOtqLEyX7EUOc69zRLrFt4nea90dYTp6P+sDcn/0HdXrPe97T9N03elx0Y4wxxrxxeeGFF9Jb3/rW3nPWVXgG9f+VFbTP8GsFT9z43w9yHpSl8H9FLTSA8KxCdOtErNmndbNqoMOaZx6rjh07toGlxa09d9oNkwnQQevcCNNamXYtdKVm3DiOc9QLNwRnzDZw/TNmICA8Y6aCa6AhPK8j0fS4BAS4EtFLsZpxR8Fazbjxm677pfAL8+qS8DckFLIsqFffAFZhaKfC5hhQJ20flEvNoCnkD90DnKvm4ArSh2k6jnPNMdiNybGatEe0raDBhcAMM3+UDWVE/jlnbVOi69yjtQFM7yN9/TeCOqHvYFKA67xRv72ukzHGGGPMqlLLS83/R4cOHcr+vs7CM1DTbUJLY2ig6YUbZtyQdRR44m7XQNN8ey4CVDDX5j7NvSvZ3zGTCdBayLrwnWk41z/n4nSh4rBlpyMxzCzUwvOsdSDWnNOGsprTNkPdjxmLnAv0dSe3dlmBJlA1wRg8EKRw/PHHH+/MrwGEHZiK47e4nhlaQhwb6ywrBzWNY9JgfihL7tyxa4hxXk4I5/HYNvTKDYGMAvGQYMY25XUK1xpTGOe9inXKmYDH0E9sk9z1JVB2CJ1MD4It15nvFRDS0baMfa3kBOhS/6XGPbY/rQUAhGekiS3raYwxxhjzRuLll19Of/VXf9V8IlQ8cNlijqFY0ecaOhGj9lnB8l1qoLmkl9pnCs8RLBeGxXI05RYa5a7s74rJ1kArWvi+WNDQQkN45nfVQBMNYXU+OhGLYFDQ4VaE619VEKa2mR6y9TeacT/wwAPNd/2NjpxyptfUOPYNTECNdlzDSqD9hQDPsrAOkdL1JdBHIkw3zsYxtBTzyK03jtBLOK5j+RWa3dPzt4b8ooCZazuGxyJsk9y9jveAdVCQVz1Dl42dvJt43hGmHzXLXBaQy5sTA5oGhW0Ky/QirnA9/Jg408YYY4wx68ib3/zmtBPWXfNMqBjNWXBCeIbzsIMHDyKs8VykJihesfSxNePu5EIKz5Q7damzOLpmtKhdy5OTxoHWwsYY0AorTGdiDGNFDbSeyxBW/E6T2VrwXrs10GOAYAbBgqGR6AwL9YZQAqEpOmiCMExBRDWZasYdwzbhN0xUMNwU9ulNGsIoNKh08tQHtIQQ9PChIEnnXciX5tJ0jIbjmh/O4frXMY67kA7ageu5NS98j5pc5klnbWNNran91LRZRrQRzOaJlpvaeArfWsZYPzqPYzgoroWH8MhY29TyU9hkn+AxnKsO5yjA477ieJxwKVFaw8611gDhw9AudDDHsFQR/I66I2+GseLkj042oA1RB+3naDddq2+MMcYYc74BOeZrX/vaUtecL8LzEFCewg9W/b/sJuQFdSAGWg10BefUejyEseo0zuJ5uxGid7v+GUwlQGuhZowLHcNY8WSugUYYq3omYQNa6FpFvxEbCNCEm1AAevHFF9P5CAQSmMpCAGJ8Y1JaQ02T45x5MgSR3FpeQG0fhBtoiwnOZbzfIXAOQltBuFJtLdKNobjwPebH+qKefabrhCbMyG9M2yB9TjAsG1cY+UCAhTAbBUy0EdLjBIB6TsfaaAjsev9wPpzlaTsDpMEQXLl7wPupbaf1xv1VU+fobIwC/ZDZekmAZogtlBNp0ukc0sUxLBuIMIwYYz/z/Ngf0B7QoCPdeC8tQBtjjDHmfAX/Xy4jQL9RhGcF/rBqDTT9PXUyIhSvkB1b/1qQFeG1O8qQaq6N/Rll0jQBU5pEL6SVE57hRIyaZ3xHI8CeHSp5elijKTcajm7Mb7311sbcnI7EsAYa3z/72c++lM5TGKIKwgcEjb0M7YN8kF/Jy/UY6KGZmu8SWq+x8ZZzsMyMg1wCgj0EtA9/+MM7rlvfvYAAmPMczfYY26Zj7oGGLeurN/MeaptlwYTBMv1xzPn72c+NMcYYY1aBJ554YpQQnROeuTyzxKqvgb799tsvgiMxhrGCfHfttdemJ598sjsHjsTiGmigy3+phVZ5k0IyvW233rhn0VI67YKp1xTP2kLOeeHWSjGUVQSCNO3bucYVAnRcA00BGt8hRJ/PArTZPRAiP/OZz3SaVGOMMcYYY841r732WvqLv/iLOUvbSEnzvO4C9N13332ROhCjB24AwRlroOFoDJbIUYhWAboNYTWXtlpA6/FWgJ7EC/dUTsRmad7OfC6EVWktNCoNwZlxcNEw7TroRnhG42E2ArwRHIiZaaATNpgw06x8WfNtY4wxxhhj9ooLLrgg/eAP/mC6+uqrs7+fz2bb0DxTeL7kkkua2M+U+aA8hRyowjOAohVWy5AbcyGslPYYPw2QUWU99K6YzAs31eLcsjJaqYz2ubFhh/k2D1ALDeEZjYcF5GhUzEyggZMxA0CAxhpkxoDWtcTGGGOMMcasAhCir7vuunTbbbc1MZ/5/+r5vuaZS3Eh28FsGx638R0yH2NAQxas22RWfyoqWSEzwokYHVJjHXSOVnmb87g9iUJ2MidirY15542bHs7EjBv7FYVozhykQkXaUFZz6vxTp04156OxayHJGmmTBU6ssN55L9YAG2OMMcYYMyUIa/X93//9o89fdRPtsUCeqzXPjbxXy3md3AfNM+S9kydPNhMLETqkbjXQ3fGowKXGeWs59Jaf6ym8cE9pwq2q8QatBCuoLsc5ewB1fEyQdu6MCY2ZCXyg3kdjQyONxed1Q3w7GRNg2C4Lz8YYY4wxxqwOdB5GDXQE8Z/vuOMOCM/dumdd+6wxoEcsG55xifEUwjOYRIBm2Cp+j9pnACH6+PHjjP9cacWhikejaEPRlJtwVgJbOhKrGxfHXkjGGGOMMcYYY1aaWmx8mibcUIpCplPtM0y3oYGutc+zhx56qDmGCE7YQl6k7yyQM+FW+VM9b8uxXUvRkwjQYUF2pYVVD9yM0bVMDC545EZDYh+Nq165Dxw4sLG5ufloMsYYY4wxxhiz6jzNHfq4oqUxjsEHFiMyRYUqgOKVqAdutXymLBo1zjmBeidMpYHuvHCnVj2OAmoFonpdTbm5HpqxoQFMuKG+p0duHKMJNzl79mwtP29+NRljjDHGGGOMWWlq2e1L3NcoS6qF5hJeWiYDaqEJ5UfImzF0FWXRSLvceDW8cEtB5rZ9HrkVmnOjYVSIhvoeQnQ8X4Xo11577UvJGGOMMcYYY8xKUytAv8Q10OBtb3tbY8JNDbTGfYYZN8+jjAjBmfGfowm3KmypfVZBut1fDRNuAe7NUuvprPdEeOMWT9yd8IytzjZo/C+Aheawl6+PNxn85V/+5X3JGGOMMcYYY8xK8/zzz38BW5pvf/Ob32yEZ9VAA5hvQ4i+8sorc2bc0Dan1hN38/uxY8cWFLXqdVv2d62BnjIUFNJqnImxgJT46woV89HY0CpE4ztnHVQLjTXQUPej0f/2b/8WcaRnv//7v//H3/Vd3/V3kjHGGGOMMcaYlaOWDf/Tz/7sz77vq1/9arrpppsaQZFeuBn/GVCBCqWqWiczfJUuBQZcNpxb86zH2nhWabdMtQa62SQJZ9Vumx9yMwIEDaBroKPwDOhETIEQfc011zRu0F9//fUvJGOMMcYYY4wxK8nLL7/869hG4VlRuQ9euCEbUj4sCc+tFnoW1z2LsIwfGAx6dbxwszAseLQxR+UoSN94441zBdeQVnRXnuOxxx5rttA+44PZC7hBf/jhh3EzHM7KGGOMMcYYY1aQWkH67yG/QXDGB1pnfngOHYgBhDiGbEj5EEpXtV4Gsu65yjkIq7ZI4pl7NZyIAdE6zwnR9HamDsUYzgqwETSmVwQNCVV+LXg3Df300083H/7+qU996oWzZ8/+ejLGGGOMMcYYs1K89tpr/+KjH/3oV/mdHripIAXR6jgqVnMaaEBH1VG73MqiHfTVlXbJBWkiKvEcFmzNm0P8rt7RABqBi8B5rG2siovH8UXjgL3rXe/qZhouvvjiTgv9vve97+/VeX9PMsYYY4wxxhizEtTKz3+o32FNXCtGYZmclkEcUTcyImTL6H+LRKdhajW9G6bUQC9I/O3x7gNyoawoPH/jG9/IVghet3PH4USM+9BCv/rqq/8sGWOMMcYYY4xZCWrt8z/8lV/5lb+G82c9DufQ3If2mebbUKBSiQpgyk2gfEUIKwrOWCLcmmU3DsKisjbNO82erZQJd2oXZ6ftRdpzptxtBWdaqWjDHmHDoTHVEzdt5b/7u7+7WQfNWGI/8zM/86t1Po4LbYwxxhhjjDHnmFo2e/qnf/qnf61WlFb4lM6DvPfwww8nFZzBgw8+WKkpt8Z+hrwJ+VK1yq2yVtMo7e+YyUy4AzTlVsvuSrXSEKQxg6BCdD0rUeW00GjMulGbiylIc8YCQnSSmYWvfOUrf/fd7373f7AptzHGGGOMMcacM16oZbMP6AHIbk888UQ6cOBApebbrbwHAXougbvuugubRg5k5CYAzXP96X4TmRPMQggrhluehCk10HG9cyPYUljmzEBBtd4BIRoffof5NmckIDxzcTmciEELfe211ybVQv/yL//y0y+99NL/m4wxxhhjjDHGnBNefPHFj37yk5/8KjXPreIzXXfddQtrnw8fPgyfVs1+XL6rzqZhvg109TBNuNuvVfh925v1REwqQIumuRGe1fM2z1HhGcejJ7WcN242JjxxQ5iGEI1GhxYaLtBpT08h+iMf+ci/OHv27K8mY4wxxhhjjDH7CtY91zLZvVB0XnPNNc0HmmegYasAZDvKeRCea9mv+R3m29hCC821zzThDgrZWfTHJVTln3bGtKmFNIPqvKh5llBWVXQoVjcc1PnddXE9NIRoOBPDjAa2uDnwyo3ffvd3f/eX3/zmN/9iMsYYY4wxxhiz50B4/rEf+7FfhVxG4HUboauwxXcK0RCcsaXCFMLzkSNHuutgmUwZURWvMOHGVpYM87fOXFuXD0/JXgjQmvbc+mRlyJkYNNG1sNxpyGnGzX0I0eq5DeCmQHiGJppC9O/8zu986KKLLvptr4k2xhhjjDHGmD3jhVoG+9jP//zPfxpfKDTrfhu+ak54JupAjEt6IRNSA63nhshO3b4sG57UbFuZ1IRbifGfSdRCSyyvJNumoQ4fPrx5ySWXVPigQSE4qwY6qv8BzbjJT/3UT9335S9/+X+AB7hkjDHGGGOMMWZSEAnp8ccfv+0nfuInPk1FJoVnAL9V1D4DCs/R63YEMiFkxBtvvHGWybPdNEJzJzhPrXGO7Gnq6g1Nzbm5nxOmYxoQpms1fnP8+77v+5otNNFYaI79xx57LL3rXe9auEnt7EY3QQDz7j/4gz/4JZt0G2OMMcYYY8wkvHD27NlfRzhhHoDTMJhvq9YZAvSpU6fmBGjxvD0nRKtDaVLLhJtJzLMhRwYtdGptudNes9c50JGYxrKiID2jFzWFGmmuhQYa2opCdAxnRVSIBpgBqW/QrD6/WSP9yU9+8l31DfzFCy644KeSMcYYY4wxxphlaQTnWgj+9Y997GMvXHjhhRUdOwNaBcOSWC+CEJ0z3YaMR0GazsNqGpkQsmGUGyE8ByG6c2K9l+bbYM8E6Lbws/xPjTw908Xg8KiGhslpoVWAvuOOOxKCaaORGdYK2mgI0pzhwJYe3wD2cUMhQJ8+fRom4Ruf+tSnrj506NDfqTXSf68uynuTMcYYY4wxxpgir7/++r+vP1+g4HzVVVelZ555JmELqH0G0WGYokL0GA20roFuheZSbOc9FZ5T2icNtMjRc07FOGuAbc4TN6EADeEZnDx5svud5tyqic5pobHlzYUgje9XXnll8/sv/MIvvLO+5vYDBw68t9ZMQ5h+Z13mdyVjjDHGGGOMeePxQi3Hffu11157tN5/ut5+qea+T3/60y/wBFj4cl8FZ5Dztk0LYihAYbpdKzMryHV9AjQEZypaAcNYtcw5EosRoPaKvfbC3UsrQMdjC1poCNBsSOxDkKYQTc/cXBMdBWnVSKtZAYBp99e//vVEE29s+Vt9Ha5PL7/88qzWUlfY8rdXXnlldsUVVyBOGbTZM2x5nOfgOLb8rXRMib9r2vo9bsec++qrr87e9ra3LeTJc0rHcmUt5ZWrC/jmN7+Z3vSmN82VO+al9Yhl0bLH83P543zklyuz/lYqd66MWrbSNbH8sf1zZYrnpkC8v7kyMO0x9Sm1dy4f3rdYplw+Y+oV+26unrm0SuUokWtrLXdsrzhGSn1Lr4v1yeUV6+Xx7/FfaiOPf49/j3+P/xTw+Pf4j2XZyfjHMcgsEZ7z/PPPd8e+53u+Z5PyDmQfbBEmGFuVl/Q4hGZsIWMxChK2ddrVk08+2aTbp32GAE3LYgrRfdpnkRsbpWxr1tz8FkJZ7Sn7rYEGTYXjefjDmQUVoOmRm1AbzbXQJLcmOmqic0I0oEYaHYMdjgI1OtK3v/3tisI09nFu3clypuZIP6kgvQza6Z999tnNSy+9tEnnO9/5TsX9vmvr+lWXX3552g1DD8ccpQfWmLRzx1jfoXr3lRXXYjvUbnuF5j/mhVN6ye6U06dPp932hZ3ms5M+pEzVDjGdMf0JW5Sd58a69PWr3ba5x/8WHv+7x+Pf4383ZVjmGo///vw9/pfD43/vxj/WJ6cBKDQrKkDnjgONgATBua7LTL1tAwjRcd0zhGdsIUADrHumx21aI2cEZ9KlFa2d90MLvWdhrFoaT2gMYq2hrXgsFYR4NlhOeAaYpeAH33lTdJYDN09vIMwKYpgrmHUDrI2G0MzBwlkWdKb6uu6aKDjjdwrVEJ4BOik6PTsrB52SO4d5Y6sDBvt6nl7H7dmzZzcxeOIAyeUdf+MW1+rDgjNWmkYsN+BDir/Fc/k991DNHUN9kTe3ufrGa3Gc5+I774X+Hr+zfFp//S0N0NfWyJ/3EPem7z6wHmjHUp/JlS3eC71W7wmPaXlz9z7mG/PRa9k34gMb56K+uX6Sq08ObQetc6zL0H1COiw3+1M8R9sB94H3gmMO3zWPmIa2jbZFbK+Uqb/Hv8e/1sPjfwuPf49/j3+Pfz3X43/34z/+RrmFW8gyOeFZzbMhMENWwlaFZwIlJdE4zwD7UHBS2alQeAZtrOfGRxYF6TSCY8eOIV2eOzsvvHC3W1RKvaLNHU+tR261b4cWWmYdZgxlRajqj165SfTODdSUG2uh0TG4PhpQE52D5t0w7YYQHTtaNPnGMTX7BtBQczDkTCyouR7z8Ob5PBf78QEe8+Q+HiYw2Sjlg/MAzOK1bHo+02J5+TuvZf4sl37vyxfnqSY/nqv5cJaa+fG3vjxybRePs0591+h+LHdf3XLp5fLMWTFofnpPY7rxGO+BPoj1vvTVmf0z3tehttG09f5r2aLFRqx/3z3s6xvxe649uAQjLYm2fTxe6rO5az3+8/l6/M+XQ/H4z+dXOubx7/E/pu3icdap7xqP//628fjvv3Y/xz/3IShDdmFfzQnLgAKzmmrDX5QK0uosTE22o8YZRNNthq0Cl4hnbtE8d4pTdRhGWi00ZcdNOqzOhUpOe+xIbC8FaM4GdHnQaVhGkNZz5hKhObdqn3MMxYgGEJAxa0LTbhWe9Zxc+uhA/A1p0JRB10/rOmoK0hS4c2myQ8f9IROYoXR3AgfVWFjeWAdstVz6+9D1y+Y9dFzziOWKxHXuY/Irofev79rcfe57CQ/BeoIx5eXShK997Wuz+JCN52r7xHzGmmyNbZcxsJ3ivY3lnHKMKJpvX1/uK4PHv8e/x//O8Pj3+B867vE/fL7H/85Yl/FfEpJzqFwTj8djMb4zjuWE56effrq68cYbm/3obRsm3rW8VtXK0ex6Z1AQoCk7xt86mXK/4kDvpQk3K1fRXJtxulqz7q52ldhz08Y9BsZGA/PDY4wRxpBWhw4dmkF45o3CjdPZD3QEFZDRCWjSzW2tud5kh6GZAoRndCx+j8Iz9rHFebwWHRf7MP+maUTszNdee+2Mx/EgIxw8ep1eS203oRm5mpPHa3l9TIv7nJHS81JA8+Hg1RcU66TXqLae6fPBHdPmefid+fC75s1rNT18x3HNSx8w+oDN5Zmra7w3WqZYLn5Se/+0nlpGvT/1LN5mrANeCrlyxfNy9xR1RH6xHfRaPc561Q+ppG2W6wfoc6wjzmFe4NVXX93M9bdYDz1P+0Wuz7KspXa4+uqru/blvUXbceKK9Yv3K6YV93P9Lncu89X7GvPL9VXN3+N/Pm2Pf49/j3+Pf49/j3+P/52Pf55fyyeb+F3NrbFVTTL2+Tv3eR7PocwEGYkyE71s01Gz1KnZUu6i8KxQeE4FYLKND4RnKFApC2IL+bAVF7Uttw6ITNkKz3suQe+9iJ46r2jNbhLHYpSb2x+bcFb4ztBW2NfwVjiVqn1qpCFEw7xbNdAwC6BQjWNRE03QMaK79fe85z0bXBfNc9CZcOzyyy+fRSFcYVisErguercbSxw0PAb0uJ6Xm8lSE/OpUM17ThufOy/3fbew7nG7zLU7zbN0LFdH3hc9T/dz90id2pXuXyxLX51K6eTKO1THsemX6hC/j+3rTPPs2bMzPb7Tfobz3vnOd26oeZNakvTVd2z/8fj3+Pf49/j3+Pf49/jPn+vxPy79XJtQkQdZA8fj+mvKM2M1zST6jgI0vz516lTFJbPUOCM8FS2BqdDUJbfYp+yG7zvQQOdoZMSw3VP22olYg7gUn+l3bClYixI6UXgG4kysE55hI88Gj2ujKTxjXzXRINriq/AMMJuCDojOwtkWaKTxG9YasINxET32OXvD77ienxTAOTozxPNL+zozpI7M+NuBAweaj17H7/j9r//6rzdjmZC3zjRpPlpOLbeer8diHeM5LLvkPYvtE9tRr9M20WtK7YQ2wne2Ab+n7fubYt213TQ9LV+8F1oepqnHNS09l/nSy7ueh3TUeiFeyxcAfouzhFoWbRftG7HszCM6iMi9aNj3NA1t25hOTF/X0YD6Ib6px2OdkHasI2fWY34ob+7lGWda9d5qugquo/aA56Os2j9i/tzXexn7t+bp8e/x7/Hv8a9plfY9/j3+Pf49/seMf56r/bUWZhfGP44/+uijXVp9DsFITniGspHhqQjkq6hxhiANpSY+9FtFx8+Q3aJVMenxut2g8qKwr8Iz+K60x6CibSPEgTmLW8wsoFHj9jd+4zeaReXUOtda6UYofumll7o04UIeHwBNMY9zxqfuaI1jMcyQYPE7Zq1efPFF3PRZ6y2u2R46dAjCcvP7W9/61oQPrn3hhRfSO97xjmYfDgggbG9sbDShB5C+mnNL3s2n7pzNb9h/7bXX0JGbNe+1sN98rwdtM5nwpje9CQ/X5hqajeM793G8jVPXXIfz+WE6GAiYmXr99ddnLAPA8br8TdxrPsjq9qjq67CGpUmfZWJe/ACk/eyzz1YXXXQRrmmuQ5paB+avZcYW37UsgMdZd7QJ02H6PF+vYzvhHOTN83k96sgt2lzbpr7fTbrMk3m096irl9aDaaEuWtdMeWZaTt5DpqX58nrmwS3vPe5xW5YmbxzHMdwvvVeos5S92W/r1d0f1h+/sX/FfsH0kS62mIFluyA9bPW+8Fytv/Zdpqn3GedhHCBt9kXeQxzDFvXjWMEW3zlW2B5sL+SHa7DF9WxX3sd2rDGu49y4YX9hW7O+TEPHGduKdWK7oV4cP/qdfUHLwbp4/Hv8e/x7/Hv8e/x7/Hv8Tzn+8RvSbdujqmWThbFDGQXWuGyrSy+9tPkNQjLyqLeNMzDIOfyQevxg4gPb7ljbL7vzYO17/fXXV7fccktzf9v72fx28uTJRrYiJa0zrI3RPyBEY320IubcjaIV3rspY7ZbFaL3nP004W4qJWbbKRenS7XPChqIMcHoqY1AsFZzgLpzzOobuJDGt8RT98GDB5v9OItCG/4zBRt9XTQP6IgMnTYXY3oZYhrLfqc3vJiueszbaVn0OLYaMH1M2Upl2U27sSz0XpirY67upXbqI06QaDvkzkGeXAqAc+sJmo2+Wb6x+TLdoXvKduUW5z7yyCMLbZ27h0P3BGWqZxE3ea62Q6w3j++kD+bqE/Mo1XcoPZYlpjNEqe94/Hv8e/x7/Kdd4PG/HB7/Hv+l+g6l90Ya/6Wy5eI283uUc9RcG1soIxmWCt+fe+65TZpsA2ieIYOpt+0zGadhGuuZQHDWiExKMN/u9umJO+2T5pnsqwk3PaP1Cc/tQnHOMlTyW6fWP3r06EIjqSk3bhbNBBQ4S4BZNz7oCPigE+gH50GoxmwL9hlLGh91uc59DMToiCy3zwcNzcN5LY+DGKc6dnqanPManq/O0DQ/PiS4xTGeq7/lTDSYV6wbjkfT94g6GdDr8cHsFPfxYR31mNZR08z9jnyQJtON19HNv16r5YqO5OI+2wovDE0X5dY6xvLhwazf+fLM5csy85iWEy9PPZcPfNSX9y72L62jvsBQ3tgP8cCN/xTpPcGW+bAc8eXJfogP682Htt73WMZcu+l3PV/HBv4RiO3EvGK/07bQ9kK76j2K+cV2KvUfj/9FPP49/j3+Pf7j9R7/Hv+5PuHxv8VejX+mkxv/tTZ6QXhW6CAsKhqVXJgqKjCjzBQ9bqvwDPlO1jwvPJMKwvMszYdF3lf2XIAWz2gzjWy9FbZrq77qPEyvpUDN74wNzZkJBtjGDaFHbgVC9KFDh7rj9913X7ePGZJ4PmZTKFRjX28+QCeChprH0bkwELHVB6QOKHRU/K6DA985iPXhw3yGHjBxoCk4jljXOIczl1jHzevijCAeRozhFgcj09JtzEfLxnxiPTjgdXaMAzPWvVT/+Lu+wBQ+2Hkd24oB3vWBxfXtubrxOOB94vnxfvA6tjd//xvxThgfcvqgZxmxZRtp3fVctjHSxr1jeuh/ek/0Gs079h22pdYpvtyZT2seWPFFnGv/Uj7xmN4HXXfFNuf5bHPAfsp8OY70BaVliP1H2yvec8B2YN4ltA4e/x7/vM7j3+Pf49/j3+Pf45/7qzz+ITyfOHGiEZ4h0+CjikL233aJa0XtM8B3mGtjS19TdXtsXiahqiB73XHHHXNCtGqe05JAXpS1zyo4qzJ2lvaRC9IeIw7EuppT+0wHYseOHUv4qEZaBOe5GQpNuxakN2qheuFG0Jy7vVkzen/DrAhdqGMftvm44TTtvvrqqze5j45RC8zdPk0W6k7U5AETcHzHOoaUuWk0gXj88cc36bWbx9Q0gse5z990gMRYa/F6rnvi9e1gbs7RB1CbDwYj1mRs1mXDtc3aDRzDOfHBwe/YxnLUx2ZahujSnufqw5y/89xYL261Drl2Qj2w9iJ6Uke9WC5Nk8c03ViGiLar1Kf6m4HYdzG92KbtA23hfrb7Mbls/4h5sC64n0najXXv60P6YMdxLa++rEKd59oTxzTOeryfsS4spz6kUfe6LHPnqcf7+NLQdPW+xry1Xkw39pF4X3LtEu8D88z1H49/j//YhlpGj3+P/9gmWiePf4//XL09/ufrzH2P/+XHfy08N8dhbQvP8DyvpG1Wz9rYp/YYis1anupkLZ4Pf1JEBGdsmmsZpgoHMt62s2OSS4HTvAa6EovmpQXz3TBL+wvzm3s4alirTLir5oDaw6t9PNdGc00010fT6Rhu3Dda52OEXroJ4kefPHmyEaRVoB6itI5aKT1ocwNSXy6YRSqtmYnXAjhHg3OA3G9j04hlyL3sxqS97DV8CcbzSsdzaedexKW6LVP+vutL/zDk2rB0zRNPPAFNwEzvNe9lXxqazxSM7ac7SZPplu7RXtSnhLatlnPZ/s3rsO27xuPf47/vGo9/j//43eO//7jHv8f/TvH4X0yDJtiQZ+IaZ54PgfmDH/xgIyfFtHLLZelxGxronJIzh3je7uRDyHlUpsZlv5llwHvefyL7LUDn8u8aC4RG0fL1xonW2QwlJzxrPLIIhWd2pjjrovvYvuMd71gwg88N0mVhB2dcNXoQj+nymC7o5zG9NpfHFOUci5Zpt3lqWnfeeeesNIGB37kfHy4wxc9dp+045rjmBc/t1113XeorcxpZt1L5hq4be3zZc8bkj62mwxnpeC7Nf5bJU8uYK+/Q/SmllUNfeqV8c/Udm/4YPP7HpeXx35++x39/Wjk8/qfH49/jn3j8D7Nf4z+GnSqhptk5uFQWXrEV1Ty3ys0qrnuOaUnoqqzgnLYVrM32XGieyb44EYvIuui5fRAdi7WN1DQUZyJEkI4Lz+egVjq3Pppw9oRbCsYQntFp1LOcevbmcZ2lQYdkLDTu6zk8Fr/rce7TiRkGgg4eTZODmA8k7vM8HTxxob+ex3Q0vVj2eBzn8sM0Yj1ifZmn5hO3uXLGumo74CUT25DfcZ4+INCmPA/XadmZdt/LMzqc0zyR18033zzXVrpFOXLl1DoynaF64eWaazO9N6V21fsS70k8L5ZNyxPPyT3Y64fnZu46tCXPj/c8d/+x1TLynub6V64O+o8U70VMX8/FiwufWC+9rvTi9Pj3+M/VzePf49/j3+Pf49/jf1XGP+tDmYdbOlrmfsrAeM78QMuMz9vbuM6QuYLc1ey31sLNfkluUwqm2c0ByooUpNM54JxkqqGsUihL4beOUpirnPZZ+UYIdUXU1ICcPHlysF3gnl2Fa8BODHIBxXk+zou/q/mEEk0pxhDLgbwxG6gDBmVBnnxQ5/LlAC3NUvWVLdcWuXqXrtPzctfl8uas5jLtlTNVgVUBH0rMV8/jvcLvmAG///77K7Yz2jWWd+jex7KU2lXTifXGTC/vcek8lJtl1XKMuS9qkaF9qVQHLdtQPmPaZOi8Uv5D+ZTG3RC5vubxXy4Dj3n8e/znyu/x7/Gv13n8e/zH9Dz+x5dNy9E3/qkojGnAEpcCtSoOIffQKRhlJ70urHVugOa5PVblQlMp0ZF0y5yAfK7WO+c4JwJ0hoVyZNZFzwnPx44dg/OxGc25qfbn4nTsU6jWNdGlAlCALgnPNPuGqYKeo4I0O2Z8gLEjxvO43podWDttfADqOQjHpR7FNa00gtK5SLdtgwr1ah2tzeJ1sbyxzowBx2tje+iA7Vt3rvnE/Zh2Lg1ek5vsUJgG6l/3meLvuRcT8411Znsyvdy1peUB8Rymq3VlW5TKEsur7VNqv1xfju2a66ugr337KNV7iNjujDeYa5/cvdlpOXNpe/x7/Hv8e/x7/Hv8e/wvh8f/uRv/UXBmO6pQrEtdc2udqZTEVgVlNdPm95LGWZfk8ju2qkwN+5VEdDqnQvSOO9RUtG3RzDAEm3Y5pZrlFo9jq0I0BWbcyHoWZk6IBnQqBoGaXrpLjsZyUICGnT87FgVrDmDAGRt9YOXSyz2Y4u+5l01pny89wH09lku7lEe8Lj6M9DgGNF+6rH9ugMZj+pKO6eo5fJgwH712LLkXUKlcffWNZR+DtsvQedp2dG7HrZYr3jMeY3thX/um9guWJdYh5tM3M1m6x33o+bGupT5QaudcX2c7aD/J5a9tVOqTpfT7xhnx+Pf4j+cCj3+P/1ge7nv8e/x7/Hv8l9orfp9q/PM71zBDOVhyCoat/ka5iY7C1MO2XqsKTRWi6SwMWmkoRHEst4RXHEk3sl4r/51TwZmccwEatLMLM7Fpn/PGvXj61rrpqKEGIaZ0c3Nw42h3T4/dnC0hKkDnTL0JOk3dCZrfctrqPgdl7Hyl38eko2G4SufHa/lg5PG+Mpby1gdvLh2adqhZR19ey74Al70mliHu83uaiFw9l7nfQ+lq+/blkXtZD93vvnzjMe17O7mHmra+sJcpQ+znuXvKYyyvttNQufvGnuaxzLVjrx9TBo//YTz+Pf6x9fj3+Pf49/j3+B8e/yVHYBFqm1WOUuE5yFpZs22xHJ67/znLY/05rRh7Hgd6DFFYlgac5U/fPh8a6NwNUkdjuMkSd2xBeI5E4ZkdphWcO+G59GAG8TvOieeVOn3s4DEtDp74ACm9NOoBsZlLK/cAinXg73WePC87qBEPu/Rwjw8Onl9vF16ypRdcKMNcu5bKr2ljG/MpPXhzaebKF+GDua8vxDLl6pErSxtvPOnxXBniSzbe71ydcmmW+qL2PdyPeE7un6fSPdV+GculfadUrqF6SDpzY69dw5OtX0wv1ql03OPf49/j3+M//qZpevx7/Hv8e/znynquxz8Ug/V21q5hnqsnNc1ULMpy2E05d07z3MpkxbECVIimwEyRT4VonFPLeZurYratzNJqsSUZb6vteTObbbTlzqn3o5MxjRkNSs7GIBzX525y1oSdIZp2R3Pv3IMCM0RcaN9H3SEhrPeeU3oQTUkccHuVX9TsL5PHmBdlm8dgmy5D6WU65qU4ZZ67Rdeq9N2D3dalz3qj55runiHf3/7t395kGlO3RSk9zVfrMJS/x/94PP53nudu8fhPqS89j3+P/7H5evwP57PkNR7/S6Q/NaW06RAsR7TiVa3z0FpnCsxcfovfSuudkyhWV8l5GDknYax6YMPMdCsm2zM5B983+L20EJ2BuPldb26wx9+k0KwzKdqJMLAoPPM4O963vvWtTZ5z+PDhzXhdTKvNZ+Ec3ccW6XOrv0c38XqNlp3O0ehaPmVA2fmbzmbxWvymXsqVoTKUzte65c7BR9tL6x/bMQz+Kl4f3ernHgzxXB7nfdXfmR/PZT3wAC6lmTLE4/yu6ZTuM8/nNbEd43l8IfAFkcsLaH/T9iq1j95PWmr09bvc/cZLRMeTvoC1rTUt5hHbR/PRton9m2lwX1/aufxzbaq/e/x7/Hv8e/x7/Hv859JMGTz+t/D4X53xr3CpKoRj7kvZE39rv8/aa6qCJ+0GymkQ5drzmnOD9rmSNc6zGJmJ31eBVdNAAzZY17A8njm30uM6u6HXBsE6O0vCBe5RQx09yo0l57CsTa/zCK6L8FHuIdNypott6aHcB13L5wKaKxgsWAcR88hp41vNfVd2NfXQQale0HNlZ3v0lZnfmTbvt/6m5RDTk02tq9YjV0e+CLRMEgh+IY++soY1IgvLB8I96bbq5E7Lw/0SYS1KdrlCDOnGNGPfjNfhXouziIVyl8qTq3PpWK6PlNKPx2P75No8jke9ttT/xozLiMe/x7/Hv8e/x3/q8vT49/gfOubxP5wutudi/Idzmt9uvPHG2dGjR+fWOZfWN4O+dc+F75UcbxSopRDH54JV00CDqp2BYCPO0rYZd/Ga1iRg4cZEk27c6LrzdLNuOc30MqCz6QOFMzLsfJyR428cJDI7tomH0tDgYR46Gxjz5Dbuk7u21oI3gzAOHj2fAdHj9ToLyN9j2XGcdW6Pdw/nB8Oscq694vHYLpp2X7vx4dWeO9N0WQ+eo3WXcieddc/lk5lRjOdV8TfkpfkVyj8346t9hvttv1u470nWovS1DdtR0+QLVR/2BPuw0pB6VfIgTiVKL8rSjKbcl7k20u/yD9Bc/bUuvC7XfzDmpDzZ/if0Phc8/j3+9RyP/3k8/j3+Pf49/jUdj//1HP9tfefuDaIdRR9UlLmi7AWiyXZqBWJ8D5rleB4102mVWEUBeo5WnbzQmC2dqbc0btUeSDQTiDMeemPjTUYHUWEanYOdJrdNWwvpOyH8LvFCp5RmfO7qmQUK56USy6QLcgPwrgEte+6hrwM3llfLwQdH5mFalQbyXVtWAsUXgZqXxHLlyqnpxnN4LN43PEgyxxceUrn7rXXX83As5iflnisj6qgvylg2eVHOSvWLxIc988B3fdCHcnXtFOvQ9yAutEmzxcs4/jOhfah0T7ScufoPvUT0urjfd25Mn9u2j2gf9PgP5fD49/jXdIDHf3/+Hv8e/x7/Hv9yXhoq49Ax8vYty5Eqlk1ln7iV+nZOmylXYQtNNNPLaJ7nJWMRnpM4jm5/oxw3K3jiXilWu3SBQviq7iZsn7blW0ydjMWY0Zpu7lj4vdnmvH1HSk7KlNLDTo9Lp57xQa7nLfnC27P73PfgHlPO3Zwfrp17yCxTf823tF86P+an92yZ+uym7rtF+9hQ2Xm8re9M/0nJtAk2S9dL8xjzD0G87333b+yx+Du2U90fj/9yWh7/+4/Hv8f/TvH4n8/P43/uXGw8/kemt1/jfyfWtjGGMxFfUzP9PoYYsio4ia7ac2arEvM5x8proBVdXI5tq/afLZ42m99pzQTizdWb32qqF/LEzEp0yV5Kh+Rmw3RGR2fwAB8Aehx53tWaKcU0VZDXPPRYzKM0aEpO1XLp5o635czOFpYGbsyH348fPz7L5aN1j3nwWn2Qs41ZvnjtXYsz1XMzkrQwKD2kcrN1bAdaJWgZSmXXOmiad+Vn3Huv77t3vFbLoOfrAzq+PGO/uUtmfePLU/Npz+mddNI65R74pRe41rlOf8FiJKajfUzSjv/0VLkxghdYrEMc17G9Pf67enn8Sx08/st18vj3+Pf49/iPecRrPP6nHf8loizE60vrmvlbThFZcvpF3aY6DNu+pFOWLlXu/eaczHjtBJmliDMSqEOVghY6LZoAzB2LYa/ajtFI5UePHt2oO+FmSSud8fhdfFBg5iZ2+vi7dM4k5hHdwC7N/sTzYrrY6sOtVFamz7RK5cVkwr9u1wzx91zZSnXqq9dQOurkbehhwDxRXqzR6DtnTHql8vWdi21s+5g/KASZXyhbKRxbTJvp6n3MXVu6h7n+1Fd3poV/ftDW8frc/ee5vD+luuTyj2XJja+++sa2jXmzfHSMket3sQ/33WePf49/j3+Pf4//1Fsvj//+snn8e/znrp9i/Eta1cfL4YC7Y/A1pQ6aB5yCNXKV/hy+d5rndrnubNVCVfWxNgJ0gVL5q9Lv7c3tbmLGzr778vGe2TMlCuJ9nY+C+ti0x1IaGJ8oh/fqBkrfi0avqx8sG/G8vgHZl9bHe0zmM+ePykMGcjOpUnoY7ISBlzEeUhvtPyEL7Zsr/07arVSOvv7XvlC7/i4P6Fw/HSwT88+Y7ozqfzym1/aduxP6/jnpy2en+YcXn8f/cFk9/j3+Pf4nxOPf4z/uM5/k8T9Ypr7jY/JbxfGfa+fdjP+PfzzvWTuS86oNSkK1rHteO9az1Ns0D8r5CYzE/c4EQI6nJRamdw9hHogzL9h+osekgeiDNKaZOy/ul87ZLaUH2Zjrxj784oAt5feJntmvnZQndzz3ENjhA3OpMuoDKvcAmzKv3PXMb+i8XN8bW0buT9k3l/wnq1j+KctVypv7Q/2wr14e/x7/u80rdz3zGzrP439nePx7/Pfh8b88Hv87G/8UpD8xoGnW7zHP3DgBIgg3AnBYwzwnFMs19LLdyFM8P7VyWlpz1moNdIaFG8AbiRsFp2EpdTYBVebaaihtCM3oSPio4M1jcxe0HYy/oRO3QvPsEyNm9zDDy312avVup8eZj26V3G+5Yzt5sIx9oHIg8nzdz53Xl16ujqXylB6a+j2WJV7bR3w4D5U5zu6NeXku8+JLA2Xte2Dn8sn1w1If03vclw+2sS+Xflvm5Zkrfxw7uZfBUJ8qnZO7Jlf/nYwxj/9yeh7//ef1ldXj3+O/dMzjP1/2Pjz+56/3+F+t8f+JbasDlUWqUp1xjCGAP1GQaUAILZzE11QK1/AiOgWbtdfOXVdaG71OrLsA3SCOxZoNb6B0hkpuXnOsnRHROz90N7vfMzHL5sqh10gYrs5JWalD58wocuY63OqLKf7G83MPlrgdYuglnEuL5et7yeu1+jDGMa7hKKXd971UVs2jdM3Qy7HUtnov4z8OpYduTHfooRvr0VeG0vdYhlw+2uf68uH1Q/ny2qNHj26mAjmzsFL9Y7lK9dRZ/3gv+v6Zy50T8+srUyxzqX08/rev9fj3+Pf49/j3+M//nqtHXxlK32MZPP7nrzkfxr/IP0l/V6IME4VgppVZj1waxzOmS4/a1DrLdZXkt7Zm228EujsjnroXPuF4c13d2TYkje689pMKaaRc+rm8kD7223y63/V7aT/30fKynGOu60mr99iy6cbzS/dCf+c18Vw9vpP6aXq4fqi+7f7GyHtQbJ++Og+Vg7+XyjDUjwauTzGfQjnHtNNsqB4p5cfXMm3ZV9ZS3x/Tr9mnxtxrjuG+82KZ9HqP//728vj3+C+l11dWj3+P/6G0h/qQx3+2nB7/Ie9VHf96z2LeQX5J8bjmxWvjtuczhwjns7A1a0q2c2un0hdQ6hkE7SdFoVi12gXBOlWLQnj2XM0z7ucE/2o+nNfoAT3wSX3tIXVJPeVsKD0IMoM894Doa5M0Js1C+2T3h8pUynfkb6V7N1iO2B6F63P11PuVcvmU+ltKvX0m136pJ/+htIvt1vfiDWWfG0+FcajlSZrH2PEf/1n1+Pf4H/lb6d4NliO2R+H6XD31fqVcPh7/Hv+Zj8d/8vj3+H9jjP9cP1pm/KfF/mfON2TQ5H7DptQ5FwZZ7MgDD+6FDjg0u1Tq7Ms8cAuf1JNuig+SQn2HBlqscxqbVuF7GtE+KZUfVHFw96ZVupc99ySbLo/lXnwDdRm8/2GbBtJPmfKkXF6xrj0vuYV9tsOIPj53Lcel5lm6J7Hspdl1LUfIp7dd+457/OfT8/j3+Nd28Pj3+E+Z/ufxP7ouHv8e/2OOp6HzB9o+psvxn0Iblix5584x5ym5DpHSwgM6Bwd2d17fw18GRXdtGujMhQfiqMGU+gcI2EjlQVN80ZQeNCPLkXL5ZR4oaUTaKfdbLHfpBZ2pX4qz2mPqlHtZj22LZR9scn72eynNYPqWQhlS6YUU8x84R18iSa8J4ySmkTue+l4imfGQ+tqt75wqzDTLeaknvZSpl8f/uPxTT5opVyaP/4W6Zr+X0vT4L5/j8Z+vp8e/x3/Mf+Acj/833vjvyPVFY4bIDcSUtjuaHmvgoMs9PKowW1nolLnrZrkypdT7QNGXS7et+mdoex9OmZdgrtxsh+xLLJPmQnuEh3623qWHTlWYpUuLD64UyxDKq7OWKVfOVHgAFfLVdFIoYzbtKszqpoG+kumTuTrn/nnI5RPT1HKmQj6l9ujtZ9LGpXRi/l0ZMtemzH3U+iVph76yp1CPlMJY8PjPlpvt4PGfzztl2iGbtsf/QhvFOnn8jyizx3++v8UyePx7/JfK+QYa/wt1Mman5DpSfKAk6Zjx2t4HWSp31L4BuvCQ0IGp5QgDdqHMaf7hmSt3b1r68NKXXzg/m24hvZjnqPYfILZ7zCObZ+4eD6VVyHtWSKs7J5eePPRm8lBOA3VfeGnk0PzCPy1d3pkyzQr7o8j8M1Bq41L+uYf/wrnV4os9hT4566lL32/dMY//hbJ4/Jfz9vhPHv/J49/jP5+nx//iOR7/5278G2OMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhiz//w3+CYJJwuC7UYAAAAASUVORK5CYII=", fP = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='18'%20height='18'%20viewBox='0%200%2018%2018'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M14.6771%2011.6161C14.8792%2011.3802%2014.8519%2011.0251%2014.6161%2010.8229L9.36606%206.32291C9.15541%206.14235%208.84457%206.14235%208.63392%206.32291L3.38392%2010.8229C3.14805%2011.0251%203.12073%2011.3802%203.32291%2011.6161C3.52508%2011.8519%203.88019%2011.8792%204.11606%2011.6771L8.99999%207.49085L13.8839%2011.6771C14.1198%2011.8792%2014.4749%2011.8519%2014.6771%2011.6161Z'%20fill='%232C2C2C'/%3e%3c/svg%3e", Yke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%3e%3cpath%20opacity='0.24'%20d='M12%2022C17.5228%2022%2022%2017.5228%2022%2012C22%206.47715%2017.5228%202%2012%202C6.47715%202%202%206.47715%202%2012C2%2017.5228%206.47715%2022%2012%2022Z'%20fill='%23098849'/%3e%3cpath%20d='M10.5795%2015.5796C10.3795%2015.5796%2010.1895%2015.4996%2010.0495%2015.3596L7.21945%2012.5296C6.92945%2012.2396%206.92945%2011.7596%207.21945%2011.4696C7.50945%2011.1796%207.98945%2011.1796%208.27945%2011.4696L10.5795%2013.7696L15.7195%208.62961C16.0095%208.33961%2016.4895%208.33961%2016.7795%208.62961C17.0695%208.91961%2017.0695%209.39961%2016.7795%209.68961L11.1095%2015.3596C10.9695%2015.4996%2010.7795%2015.5796%2010.5795%2015.5796Z'%20fill='%23098849'/%3e%3c/svg%3e", um = (t) => {
  var O, I, S, P, H, F, T;
  const {
    tasksData: e,
    questId: r,
    userId: n,
    token: A,
    contentConfig: i,
    styleConfig: o,
    claimStatusTasks: s = [],
    setClaimStatusTasks: a,
    onlineComponent: c,
    setHelpHub: l,
    uniqueUserId: u,
    uniqueEmailId: f,
    campaignVariationId: d,
    entityAuthenticationToken: g,
    isActive: m,
    BrandTheme: p,
    QuestThemeData: v,
    contentData: C
  } = t, { apiKey: w, entityId: B, apiType: y, themeConfig: b } = Xe(
    ct.Context
  );
  let q = y == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const E = async (U, D) => {
    window.open(D, "_blank"), c ? (await dy(
      q,
      B,
      r,
      n,
      A,
      w,
      U,
      d,
      [],
      u,
      f,
      y,
      g
    )).success && (s.includes(U) || a && a([...s, U])) : s.includes(U) || a && a([...s, U]);
  }, [x, M] = N(void 0);
  return /* @__PURE__ */ k(
    "div",
    {
      className: "helpHubTaskCont animatedDissolve",
      style: {
        background: b == null ? void 0 : b.backgroundColor,
        ...(O = o == null ? void 0 : o.Tasks) == null ? void 0 : O.Form
      },
      children: [
        /* @__PURE__ */ k(
          "div",
          {
            className: "q-helphub-tasks-upper-cont",
            style: {
              background: b == null ? void 0 : b.backgroundColor,
              ...(I = o == null ? void 0 : o.Home) == null ? void 0 : I.Card
            },
            children: [
              /* @__PURE__ */ k("div", { className: "task-head-text-div", children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q-helphub-tasks-upper-cont-text-head",
                    style: {
                      color: (p == null ? void 0 : p.primaryColor) || (b == null ? void 0 : b.primaryColor),
                      ...(P = (S = o == null ? void 0 : o.Tasks) == null ? void 0 : S.Topbar) == null ? void 0 : P.Heading
                    },
                    children: (i == null ? void 0 : i.heading) || "Tasks"
                  }
                ),
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q-helphub-tasks-upper-cont-text-para",
                    style: {
                      color: (p == null ? void 0 : p.secondaryColor) || (b == null ? void 0 : b.secondaryColor),
                      ...(F = (H = o == null ? void 0 : o.Tasks) == null ? void 0 : H.Topbar) == null ? void 0 : F.SubHeading
                    },
                    children: (i == null ? void 0 : i.subHeading) || "Welcome back, Please talk to us to understand"
                  }
                )
              ] }),
              /* @__PURE__ */ h("div", { className: "q-helphub-tasks-upper-cont-text-button", children: /* @__PURE__ */ h("img", { src: a9, alt: "", onClick: () => {
                l(!1), m && m(!1);
              } }) })
            ]
          }
        ),
        /* @__PURE__ */ k("div", { className: "helphub-task-container", children: [
          /* @__PURE__ */ k("div", { className: "q-helphub-tasks-progress-cont", children: [
            /* @__PURE__ */ k(
              "div",
              {
                className: "q-helphub-tasks-progress-per",
                style: {
                  color: (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.tertiaryColor) || (b == null ? void 0 : b.secondaryColor),
                  fontFamily: (p == null ? void 0 : p.fontFamily) || (b == null ? void 0 : b.fontFamily),
                  WebkitTextFillColor: (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.tertiaryColor) || "transparent"
                },
                children: [
                  "STEP ",
                  s == null ? void 0 : s.length,
                  "/",
                  e == null ? void 0 : e.length
                ]
              }
            ),
            /* @__PURE__ */ k(
              "div",
              {
                style: {
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  gap: "8px"
                },
                children: [
                  c && (e == null ? void 0 : e.map((U, D) => /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-helphub-tasks-progress-bar-tabs ",
                      style: {
                        width: `${Math.ceil(100 / e.length)}%`,
                        background: `${U.completed || s.includes(U == null ? void 0 : U.criteriaId) ? (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.secondaryButton) || "var(--Primary, linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%))" : x === D ? (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.secondaryButton) || "var(--Primary-Grape-400, #A357FF)" : ""}`,
                        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.12)",
                        borderRadius: `${D == 0 ? "14px 0px 0px 14px" : D === (e == null ? void 0 : e.length) - 1 ? "0px 14px 14px 0px" : ""}`
                      }
                    }
                  ))),
                  !c && (e == null ? void 0 : e.map((U, D) => /* @__PURE__ */ h(
                    "div",
                    {
                      className: "q-helphub-tasks-progress-bar-tabs ",
                      style: {
                        width: `${Math.ceil(100 / e.length)}%`,
                        background: `${s.includes(U == null ? void 0 : U.criteriaId) ? (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.secondaryButton) || "var(--Primary, linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%))" : x === D ? (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.secondaryButton) || "var(--Primary-Grape-400, #A357FF)" : ""}`,
                        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.12)",
                        borderRadius: `${D == 0 ? "14px 0px 0px 14px" : D === (e == null ? void 0 : e.length) - 1 ? "0px 14px 14px 0px" : ""}`
                      }
                    }
                  )))
                ]
              }
            )
          ] }),
          /* @__PURE__ */ h("div", { className: "q-helphub-tasks-task-cont", children: e == null ? void 0 : e.map((U, D) => {
            var Q, Y, j, Z, W, R, K, L, G, V;
            return /* @__PURE__ */ k(
              "div",
              {
                className: "q-helphub-tasks-single-task",
                style: {
                  background: b == null ? void 0 : b.backgroundColor,
                  ...(Q = o == null ? void 0 : o.Home) == null ? void 0 : Q.Card
                },
                onClick: () => {
                  M(x === D ? void 0 : D);
                },
                children: [
                  /* @__PURE__ */ k("div", { className: "single-task-close-detail", children: [
                    /* @__PURE__ */ k("div", { className: "q-helphub-tasks-single-task-detail", children: [
                      /* @__PURE__ */ k(
                        "div",
                        {
                          className: "q-helphub-tasks-single-task-step",
                          style: {
                            color: (p == null ? void 0 : p.secondaryColor) || (b == null ? void 0 : b.secondaryColor),
                            fontFamily: b == null ? void 0 : b.fontFamily,
                            ...(j = (Y = o == null ? void 0 : o.Tasks) == null ? void 0 : Y.Card) == null ? void 0 : j.SubHeading
                          },
                          children: [
                            "STEP ",
                            D + 1
                          ]
                        }
                      ),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "q-helphub-tasks-single-task-head",
                          style: {
                            fontFamily: (p == null ? void 0 : p.fontFamily) || (b == null ? void 0 : b.fontFamily),
                            color: (p == null ? void 0 : p.primaryColor) || (b == null ? void 0 : b.primaryColor),
                            ...(W = (Z = o == null ? void 0 : o.Tasks) == null ? void 0 : Z.Card) == null ? void 0 : W.Heading
                          },
                          children: U == null ? void 0 : U.linkTitle
                        }
                      ),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "q-helphub-tasks-single-task-para",
                          style: {
                            fontFamily: (p == null ? void 0 : p.fontFamily) || (b == null ? void 0 : b.fontFamily),
                            color: (p == null ? void 0 : p.secondaryColor) || (b == null ? void 0 : b.secondaryColor),
                            ...(K = (R = o == null ? void 0 : o.Tasks) == null ? void 0 : R.Card) == null ? void 0 : K.SubHeading
                          },
                          children: U == null ? void 0 : U.description
                        }
                      )
                    ] }),
                    /* @__PURE__ */ h(
                      "img",
                      {
                        style: {
                          padding: s != null && s.includes(U == null ? void 0 : U.criteriaId) ? "5px 4px" : "",
                          rotate: s != null && s.includes(U == null ? void 0 : U.criteriaId) || D === x ? "" : "180deg"
                        },
                        src: U.completed || s != null && s.includes(U == null ? void 0 : U.criteriaId) ? Yke : fP,
                        alt: ""
                      }
                    )
                  ] }),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: ` ${D === x ? "single-task-open-div-cont" : "single-task-close-div-cont"}`,
                      children: /* @__PURE__ */ k("div", { children: [
                        /* @__PURE__ */ k(
                          "div",
                          {
                            className: "single-task-close-div-text",
                            style: {
                              width: U != null && U.imageUrl ? "calc(100% - 176px)" : "100%"
                            },
                            children: [
                              /* @__PURE__ */ h(
                                "p",
                                {
                                  style: {
                                    fontFamily: (p == null ? void 0 : p.fontFamily) || (b == null ? void 0 : b.fontFamily),
                                    color: (p == null ? void 0 : p.secondaryColor) || (b == null ? void 0 : b.secondaryColor),
                                    ...(G = (L = o == null ? void 0 : o.Tasks) == null ? void 0 : L.Card) == null ? void 0 : G.SubHeading,
                                    fontSize: "12px"
                                  },
                                  children: ((V = C == null ? void 0 : C.Task) == null ? void 0 : V.taskDescription) || "You can complete your user information details by sharing the details asked in the form."
                                }
                              ),
                              /* @__PURE__ */ h(
                                "button",
                                {
                                  style: {
                                    background: (v == null ? void 0 : v.buttonColor) || (v == null ? void 0 : v.accentColor) || (p == null ? void 0 : p.primaryButton) || (b == null ? void 0 : b.buttonColor),
                                    cursor: "pointer"
                                  },
                                  onClick: (_) => {
                                    _.stopPropagation(), E(U == null ? void 0 : U.criteriaId, U == null ? void 0 : U.linkUrl);
                                  },
                                  children: /* @__PURE__ */ h(
                                    "p",
                                    {
                                      style: {
                                        fontFamily: b == null ? void 0 : b.fontFamily
                                      },
                                      children: "Start Now"
                                    }
                                  )
                                }
                              )
                            ]
                          }
                        ),
                        (U == null ? void 0 : U.imageUrl) && /* @__PURE__ */ h("div", { className: "single-task-close-div-image-cont", style: { background: PA(v == null ? void 0 : v.accentColor, -0.05).lighter }, children: /* @__PURE__ */ h("img", { src: (U == null ? void 0 : U.imageUrl) || zke, alt: "" }) })
                      ] })
                    }
                  )
                ]
              },
              D
            );
          }) }),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q-helphub-tasks-lower-cont",
              style: {
                background: b == null ? void 0 : b.backgroundColor,
                ...(T = o == null ? void 0 : o.Home) == null ? void 0 : T.Card
              }
            }
          )
        ] })
      ]
    }
  );
}, Vke = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.67461%2013.0462C5.88428%2013.226%206.19993%2013.2017%206.37964%2012.992L10.3796%208.32535C10.5401%208.1381%2010.5401%207.8618%2010.3796%207.67456L6.37964%203.00789C6.19993%202.79823%205.88428%202.77394%205.67461%202.95366C5.46495%203.13337%205.44067%203.44902%205.62038%203.65868L9.34147%207.99995L5.62038%2012.3412C5.44067%2012.5509%205.46495%2012.8665%205.67461%2013.0462Z'%20fill='%232C2C2C'/%3e%3c/svg%3e", dm = (t) => {
  var L, G, V, _, J, X, ne;
  const {
    updateData: e,
    questId: r,
    userId: n,
    token: A,
    contentConfig: i,
    styleConfig: o,
    claimStatusUpdates: s = [],
    setClaimStatusUpdates: a,
    onlineComponent: c,
    setShowBottomNavigation: l,
    entityImage: u,
    setHelpHub: f,
    uniqueUserId: d,
    uniqueEmailId: g,
    campaignVariationId: m,
    entityAuthenticationToken: p,
    isActive: v,
    BrandTheme: C,
    QuestThemeData: w
  } = t, [B, y] = N(
    []
  ), [b, q] = N(""), { apiKey: E, entityId: x, apiType: M, themeConfig: O } = Xe(
    ct.Context
  );
  let I = M == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  le(() => {
    let ee = e.filter(($) => {
      var te;
      return (te = $ == null ? void 0 : $.linkTitle) == null ? void 0 : te.toLowerCase().includes(b == null ? void 0 : b.toString().toLowerCase());
    });
    y(ee);
  }, [e, b]);
  const S = (ee) => {
    let $ = ((/* @__PURE__ */ new Date()).getTime() - new Date(ee).getTime()) / 864e5;
    return $ > 1 ? `${Math.floor($)} days ago` : "Yesterday";
  }, P = async (ee, $) => {
    c ? (await dy(
      I,
      x,
      r,
      n,
      A,
      E,
      ee,
      m,
      [],
      d,
      g,
      M,
      p
    )).success && a && a([...s, ee]) : a && a([...s, ee]);
  }, [H, F] = N(!1), [T, U] = N(), [D, Q] = N(null), [Y, j] = N(
    null
  ), [Z, W] = N(null), R = (ee) => {
    j(!0), U(ee), setTimeout(() => {
      F(($) => !$), l && l(($) => !$), Q(!1);
    }, 100);
  }, K = (ee) => {
    const $ = /(\bhttps?:\/\/[^\s)]+)/gi, ae = ee.split($).map((se, ue) => {
      if ($.test(se)) {
        const fe = se.endsWith(".") || se.endsWith(")") || se.endsWith("]") || se.endsWith("}") ? se == null ? void 0 : se.slice(0, -1) : se;
        return /* @__PURE__ */ h("a", { href: fe, target: "_blank", children: fe }, ue);
      }
      return se;
    });
    return /* @__PURE__ */ h(Ze, { children: ae });
  };
  return /* @__PURE__ */ k(Ze, { children: [
    !H && /* @__PURE__ */ k(
      "div",
      {
        className: `helpHubUpdatesCont animatedDissolve ${Y ? "updateOutAnimation" : Z ? "updateInAnimation" : ""}`,
        style: {
          background: O == null ? void 0 : O.backgroundColor,
          ...(L = o == null ? void 0 : o.Updates) == null ? void 0 : L.Form
        },
        children: [
          /* @__PURE__ */ h("div", { className: "q-helphub-updates-upper-cont ", children: /* @__PURE__ */ k("div", { className: "q-helphub-updates-upper-cont-text", children: [
            /* @__PURE__ */ k("div", { children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q-helphub-updates-upper-cont-text-head",
                  style: {
                    color: (C == null ? void 0 : C.primaryColor) || (O == null ? void 0 : O.primaryColor),
                    ...(V = (G = o == null ? void 0 : o.Updates) == null ? void 0 : G.Topbar) == null ? void 0 : V.Heading
                  },
                  children: (i == null ? void 0 : i.heading) || "Updates"
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "q-helphub-updates-upper-cont-text-para",
                  style: {
                    color: (C == null ? void 0 : C.secondaryColor) || (O == null ? void 0 : O.secondaryColor),
                    ...(J = (_ = o == null ? void 0 : o.Updates) == null ? void 0 : _.Topbar) == null ? void 0 : J.SubHeading
                  },
                  children: (i == null ? void 0 : i.subHeading) || "Welcome back, Please talk to us to understand"
                }
              )
            ] }),
            /* @__PURE__ */ h("div", { className: "q-helphub-updates-upper-cont-text-button", children: /* @__PURE__ */ h("img", { src: a9, alt: "", onClick: () => {
              f(!1), v && v(!1);
            } }) })
          ] }) }),
          /* @__PURE__ */ h("div", { className: "q-helphub-updates-lower-cont", children: /* @__PURE__ */ h("div", { className: "q-helphub-updates-lower-cont-data", children: /* @__PURE__ */ h("div", { className: "q-helphub-updates-task-cont", children: B.map(
            (ee, $) => {
              var te, ae, se, ue, fe, ve, ge;
              return s.includes(ee == null ? void 0 : ee.criteriaId) ? /* @__PURE__ */ k(
                "div",
                {
                  className: "q-helphub-updates-single-update-read",
                  style: {
                    background: O == null ? void 0 : O.backgroundColor,
                    ...(te = o == null ? void 0 : o.Home) == null ? void 0 : te.Card
                  },
                  onClick: () => {
                    R(ee);
                  },
                  children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "update-img",
                        style: {
                          background: w == null ? void 0 : w.accentColor,
                          borderColor: PA(
                            w == null ? void 0 : w.accentColor,
                            -0.5
                          ).darker
                        },
                        children: /* @__PURE__ */ h(
                          "div",
                          {
                            style: {
                              width: "60px",
                              height: "60px",
                              flexShrink: "0",
                              borderRadius: "2.237px",
                              border: ` 0.447px solid ${PA(
                                w == null ? void 0 : w.accentColor,
                                -0.5
                              ).darker || "#9035FF"}`,
                              background: `url(${(ee == null ? void 0 : ee.imageUrl) || u}) aliceblue -3.73px -3.132px / 110.971% 102.745% no-repeat`,
                              objectFit: "contain",
                              backgroundSize: "cover",
                              backgroundPosition: "center top"
                            }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ k("div", { className: "read-task-details", children: [
                      /* @__PURE__ */ k("div", { className: "update-time", children: [
                        /* @__PURE__ */ k(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "8",
                            height: "8",
                            viewBox: "0 0 8 8",
                            fill: "none",
                            children: [
                              /* @__PURE__ */ h("g", { "clip-path": "url(#clip0_7694_4397)", children: /* @__PURE__ */ h(
                                "circle",
                                {
                                  cx: "4.00033",
                                  cy: "4.00002",
                                  r: "3.33333",
                                  fill: PA(
                                    w == null ? void 0 : w.accentColor,
                                    -0.5
                                  ).darker || "#6E6E6E"
                                }
                              ) }),
                              /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_7694_4397", children: /* @__PURE__ */ h("rect", { width: "8", height: "8", fill: "white" }) }) })
                            ]
                          }
                        ),
                        /* @__PURE__ */ h(
                          "p",
                          {
                            style: {
                              color: PA(
                                w == null ? void 0 : w.accentColor,
                                -0.5
                              ).darker || "#6E6E6E",
                              fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily),
                              WebkitTextFillColor: PA(
                                w == null ? void 0 : w.accentColor,
                                -0.5
                              ).darker || (C == null ? void 0 : C.tertiaryColor) || "transparent",
                              ...(se = (ae = o == null ? void 0 : o.Updates) == null ? void 0 : ae.Card) == null ? void 0 : se.SubHeading
                            },
                            children: S(ee == null ? void 0 : ee.createdAt)
                          }
                        )
                      ] }),
                      /* @__PURE__ */ k("div", { className: "update-head", children: [
                        /* @__PURE__ */ h(
                          "p",
                          {
                            style: {
                              color: (C == null ? void 0 : C.primaryColor) || (O == null ? void 0 : O.primaryColor),
                              fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily),
                              ...(fe = (ue = o == null ? void 0 : o.Updates) == null ? void 0 : ue.Card) == null ? void 0 : fe.Heading
                            },
                            children: ee == null ? void 0 : ee.linkTitle
                          }
                        ),
                        /* @__PURE__ */ h("img", { src: l1, alt: "" })
                      ] }),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "update-desc",
                          style: {
                            color: (C == null ? void 0 : C.secondaryColor) || (O == null ? void 0 : O.secondaryColor),
                            fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily),
                            ...(ge = (ve = o == null ? void 0 : o.Updates) == null ? void 0 : ve.Card) == null ? void 0 : ge.SubHeading
                          },
                          children: K(ee == null ? void 0 : ee.description)
                        }
                      )
                    ] })
                  ]
                },
                $
              ) : /* @__PURE__ */ k(
                "div",
                {
                  className: "q-helphub-updates-single-update-read",
                  onClick: () => {
                    R(ee), P(
                      ee == null ? void 0 : ee.criteriaId
                      // value?.data?.metadata?.linkActionUrl
                    );
                  },
                  children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "update-img",
                        style: {
                          background: w == null ? void 0 : w.accentColor,
                          borderColor: PA(
                            w == null ? void 0 : w.accentColor,
                            -0.5
                          ).darker
                        },
                        children: /* @__PURE__ */ h(
                          "div",
                          {
                            style: {
                              width: "60px",
                              height: "60px",
                              flexShrink: "0",
                              borderRadius: "2.237px",
                              border: ` 0.447px solid ${PA(
                                w == null ? void 0 : w.accentColor,
                                -0.5
                              ).darker || "#9035FF"}`,
                              background: `url(${(ee == null ? void 0 : ee.imageUrl) || u}) aliceblue -3.73px -3.132px / 110.971% 102.745% no-repeat`
                            }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ k("div", { className: "read-task-details-unread", children: [
                      /* @__PURE__ */ k("div", { className: "update-time", children: [
                        /* @__PURE__ */ k(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "8",
                            height: "8",
                            viewBox: "0 0 8 8",
                            fill: "none",
                            children: [
                              /* @__PURE__ */ h("g", { "clip-path": "url(#clip0_7694_4382)", children: /* @__PURE__ */ h(
                                "circle",
                                {
                                  cx: "4.00033",
                                  cy: "4.00002",
                                  r: "3.33333",
                                  fill: "url(#paint0_linear_7694_4382)"
                                }
                              ) }),
                              /* @__PURE__ */ k("defs", { children: [
                                /* @__PURE__ */ k(
                                  "linearGradient",
                                  {
                                    id: "paint0_linear_7694_4382",
                                    x1: "0.693659",
                                    y1: "7.33335",
                                    x2: "7.96673",
                                    y2: "6.58859",
                                    gradientUnits: "userSpaceOnUse",
                                    children: [
                                      /* @__PURE__ */ h(
                                        "stop",
                                        {
                                          "stop-color": (w == null ? void 0 : w.accentColor) || (C == null ? void 0 : C.tertiaryColor) || "#9035FF"
                                        }
                                      ),
                                      /* @__PURE__ */ h(
                                        "stop",
                                        {
                                          offset: "1",
                                          "stop-color": (w == null ? void 0 : w.accentColor) || (C == null ? void 0 : C.tertiaryColor) || "#0065FF"
                                        }
                                      )
                                    ]
                                  }
                                ),
                                /* @__PURE__ */ h("clipPath", { id: "clip0_7694_4382", children: /* @__PURE__ */ h("rect", { width: "8", height: "8", fill: "white" }) })
                              ] })
                            ]
                          }
                        ),
                        /* @__PURE__ */ h(
                          "p",
                          {
                            style: {
                              color: (w == null ? void 0 : w.accentColor) || (C == null ? void 0 : C.tertiaryColor) || (O == null ? void 0 : O.secondaryColor),
                              fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily),
                              WebkitTextFillColor: (w == null ? void 0 : w.accentColor) || (C == null ? void 0 : C.tertiaryColor) || "transparent"
                            },
                            children: S(ee == null ? void 0 : ee.createdAt)
                          }
                        )
                      ] }),
                      /* @__PURE__ */ k("div", { className: "update-head", children: [
                        /* @__PURE__ */ h(
                          "p",
                          {
                            style: {
                              color: (C == null ? void 0 : C.primaryColor) || (O == null ? void 0 : O.primaryColor),
                              fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily)
                            },
                            children: ee == null ? void 0 : ee.linkTitle
                          }
                        ),
                        /* @__PURE__ */ h("img", { src: Vke, alt: "" })
                      ] }),
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: "update-desc",
                          style: {
                            color: (C == null ? void 0 : C.secondaryColor) || (O == null ? void 0 : O.secondaryColor),
                            fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily)
                            // ...styleConfig?.Home?.Heading,
                          },
                          children: K(ee == null ? void 0 : ee.description)
                        }
                      )
                    ] })
                  ]
                },
                $
              );
            }
          ) }) }) })
        ]
      }
    ),
    H && /* @__PURE__ */ k(
      "div",
      {
        className: `q-update-one-container ${D ? "updateOneOut" : "updateOneIn"}`,
        children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-update-one-container-header",
              style: {
                background: O == null ? void 0 : O.backgroundColor,
                ...(X = o == null ? void 0 : o.Home) == null ? void 0 : X.Card
              },
              children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "image-div",
                    style: { cursor: "pointer" },
                    onClick: () => {
                      Q((ee) => !ee), W(!0), setTimeout(() => {
                        l && l(!0), j(!1), F((ee) => !ee);
                      }, 250);
                    },
                    children: /* @__PURE__ */ h(Nn, { type: "BackButton" })
                  }
                ),
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "q-update-one-container-header-title",
                    style: {
                      color: O == null ? void 0 : O.secondaryColor,
                      ...(ne = o == null ? void 0 : o.Home) == null ? void 0 : ne.Heading,
                      fontFamily: O == null ? void 0 : O.fontFamily
                    },
                    children: "New Updates Details"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ k(
            "div",
            {
              className: "q-update-one-container-data",
              style: {
                background: O == null ? void 0 : O.backgroundColor
                // ...styleConfig?.Home?.Card,
              },
              children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "update-one-img",
                    style: { background: w == null ? void 0 : w.accentColor },
                    children: /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          background: `url(${(T == null ? void 0 : T.imageUrl) || u})  aliceblue -10.312px -8.675px / 110.971% 102.745% no-repeat`,
                          objectFit: "contain",
                          borderColor: PA(
                            w == null ? void 0 : w.accentColor,
                            -0.5
                          ).darker
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ k("div", { className: "update-one-text-cont", children: [
                  /* @__PURE__ */ k("div", { className: "update-text-head-time", children: [
                    T != null && T.completed ? /* @__PURE__ */ k("div", { className: "update-one-time-read", children: [
                      /* @__PURE__ */ k(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "8",
                          height: "8",
                          viewBox: "0 0 8 8",
                          fill: "none",
                          children: [
                            /* @__PURE__ */ h("g", { "clip-path": "url(#clip0_7694_4397)", children: /* @__PURE__ */ h(
                              "circle",
                              {
                                cx: "4.00033",
                                cy: "4.00002",
                                r: "3.33333",
                                fill: PA(
                                  w == null ? void 0 : w.accentColor,
                                  -0.5
                                ).darker || "#6E6E6E"
                              }
                            ) }),
                            /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_7694_4397", children: /* @__PURE__ */ h("rect", { width: "8", height: "8", fill: "white" }) }) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ h(
                        "p",
                        {
                          style: {
                            color: PA(w == null ? void 0 : w.accentColor, -0.5).darker || (C == null ? void 0 : C.secondaryColor) || (O == null ? void 0 : O.secondaryColor),
                            fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily)
                            // ...styleConfig?.Home?.Heading,
                          },
                          children: S(T == null ? void 0 : T.createdAt)
                        }
                      )
                    ] }) : /* @__PURE__ */ k("div", { className: "update-one-time", children: [
                      /* @__PURE__ */ k(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "8",
                          height: "8",
                          viewBox: "0 0 8 8",
                          fill: "none",
                          children: [
                            /* @__PURE__ */ h("g", { "clip-path": "url(#clip0_7694_4382)", children: /* @__PURE__ */ h(
                              "circle",
                              {
                                cx: "4.00033",
                                cy: "4.00002",
                                r: "3.33333",
                                fill: "url(#paint0_linear_7694_4382)"
                              }
                            ) }),
                            /* @__PURE__ */ k("defs", { children: [
                              /* @__PURE__ */ k(
                                "linearGradient",
                                {
                                  id: "paint0_linear_7694_4382",
                                  x1: "0.693659",
                                  y1: "7.33335",
                                  x2: "7.96673",
                                  y2: "6.58859",
                                  gradientUnits: "userSpaceOnUse",
                                  children: [
                                    /* @__PURE__ */ h(
                                      "stop",
                                      {
                                        "stop-color": (w == null ? void 0 : w.accentColor) || (C == null ? void 0 : C.tertiaryColor) || "#9035FF"
                                      }
                                    ),
                                    /* @__PURE__ */ h(
                                      "stop",
                                      {
                                        offset: "1",
                                        "stop-color": (w == null ? void 0 : w.accentColor) || (C == null ? void 0 : C.tertiaryColor) || "#0065FF"
                                      }
                                    )
                                  ]
                                }
                              ),
                              /* @__PURE__ */ h("clipPath", { id: "clip0_7694_4382", children: /* @__PURE__ */ h("rect", { width: "8", height: "8", fill: "white" }) })
                            ] })
                          ]
                        }
                      ),
                      /* @__PURE__ */ h(
                        "p",
                        {
                          style: {
                            color: (w == null ? void 0 : w.accentColor) || (O == null ? void 0 : O.secondaryColor),
                            fontFamily: O == null ? void 0 : O.fontFamily,
                            WebkitTextFillColor: (w == null ? void 0 : w.accentColor) || "transparent"
                          },
                          children: S((T == null ? void 0 : T.createdAt) || "")
                        }
                      )
                    ] }),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "update-one-head",
                        style: {
                          color: (C == null ? void 0 : C.primaryColor) || (O == null ? void 0 : O.primaryColor),
                          fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily)
                        },
                        children: T == null ? void 0 : T.linkTitle
                      }
                    )
                  ] }),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: "update-one-update-desc",
                      style: {
                        color: (C == null ? void 0 : C.secondaryColor) || (O == null ? void 0 : O.secondaryColor),
                        fontFamily: (C == null ? void 0 : C.fontFamily) || (O == null ? void 0 : O.fontFamily)
                      },
                      children: T == null ? void 0 : T.description
                    }
                  )
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
}, Wke = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='vuesax/linear/add'%3e%3cg%20id='add'%3e%3cpath%20id='Vector'%20d='M8.00049%208.00049L24.0002%2024.0002'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20id='Vector_2'%20d='M7.99984%2024.0002L23.9995%208.00049'%20stroke='white'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", Xke = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJASURBVHgB7ZuBbcIwEEUvqAMwQjYonaBhAzYonaAdgRU6QRmhnQA6AWyQdIKywfVCgoQQZ8exE5zwn3RCwslhPxwbJ4YIAAAAAAAAAEDfJLYDmHkqL28SWR1jYC/xkSTJ2nagUZDISeVlI5HSOCkk5iKq0A6wCcppvHJOFBJPIulwrXCinSVyljR+OSWpxLtWONHPO44798KzVqBeYtKDmO4IucSuunigQImGgusXPyFgBIIsQJAFCLIAQRacZzEfQvx06HsWRQ+yAEEWIMgCBFmAIAuxClonChQLrEAesBuf1AHB2hUsUYOcfUpybVfsY9CSO+pJTYlF0N5QdnNJV3Htij45hanEjnu43IK1K1iihjn7lBQEU2O6yjkoSbbGdJUzNknRzWL1A7w5mQfuX7o1Tb7tLnMaetKKYsClMR3W4VLSimIhBkF1PU6SVg7nZOU4JZGfVX1Xv7egEMQiyAWpXiqxYTs5VztXvD5sUIKkajOJP25OeeyM2jIkQVz1HBc555JSasPABOXcng21YSiCpEoL9ifT8o/hlmuIWelFKxiDoEfyJ9MKnDdQxbY/KNRlr7ULTzUsjEFQiIWrujAeg6At+aMKct7dEeqad8Uw9q3JMAs15FsrMPWgLQ0A8bYlv7oWkuNLKzQJ+qHh8CpxIHdON+dUTNN8+SeWHUWy297284KrhWe5bJhSM45yJO2e2sLVIjDnCAhc3y373u64+OClxJ5viGN9y/XZ+qLORf1eRgAAAAAAAAAAouYfKqAw45UHclAAAAAASUVORK5CYII=", Kke = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJhSURBVHgB7ZvtUcMwDIaVHgOUDcIElA3CBt0AmIAVyghsUDagEzRM0DJBywSwgZFpevRH/aE4Tuz0fe50uYsdWX5R/NVABAAAAAAAAACgbwpXBaXUlC/PbFVjg1AwvnU55oovD3SIt2xubxtbsat36gJuqGTbqQQQxLv2cLfTdX18Fo4Gd/T/FxgUVwZxrDO+rNmm5McP2z273doqTcjc4CMlIo6LJhsk4lBTd+3KpMLS6IYvM0oEWwYFZnrNru9NhRPLg8mIY4PFmVNYplfqMKif5YqESGaTnphTOHrGq88VTCh/bimcylRge6/PTq2pZZDvEsCFqV9jyKCojEGgLwrHuBYag0A1hTNqgZYUzoqkhOyJ+sZz/2Xcl1EbMhNIb1K/lRz9TEltyEkgDYc2UzKRdN32u4XcBNIo/+OZunXmnDSWnUBHOMw525JtexL6vrlXSXz1vpLuQuQ+V/NYSTuAQA4gkAMI5AACOehdoOIMfPuaLBvGLpEuXwbPIHX4YVL/IpHkGfigAqUujmYwgXIQRzOIQJ7i9DImtUY6mAn8Ttk2yr2ZnMaIoTOfkYLzEWcZOYY0BZKKEyOGTn12HZxUnBgxtPHZ5yBtOxh/4/XiI+WEVGlPnwufzIkcQzc+YwTX+F34iBMLab/EX3eEwq/SoomnzOG1yv7jBSnSfuG4wwEEcgCBHEAgB+JZrIupPidsGVTT5dDq+6APuhxeTQW2dZA+1NIfk5c0bva8BLoxFRoziB/6+18G7YDGy54OfTRincVYpKO6T2yfNB708PHCdqf7SAAAAAAAAAAAkuIXSHQWjeXz/J0AAAAASUVORK5CYII=", Zke = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Frame%20427321497'%3e%3cg%20id='Vector'%3e%3cpath%20d='M26%202V10L18%2018V10H10V15.2817C10%2016.7833%2011.2167%2018%2012.7183%2018H18L10%2026C5.58167%2026%202%2022.4183%202%2018V2H26Z'%20fill='white'/%3e%3cpath%20d='M26%2018L18%2018L18%2026H26V18Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", zFe = (t) => {
  var jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn;
  let {
    userId: e,
    token: r,
    questId: n,
    uniqueUserId: A,
    uniqueEmailId: i,
    styleConfig: o,
    contentConfig: s,
    showFooter: a,
    helphubPosition: c = "USER_CHOICE",
    variation: l,
    entityLogo: u,
    defaultAutoPopupMessages: f,
    popupOpenDelay: d,
    autoPopupOpenAfter: g,
    footerText: m,
    footerLink: p,
    entityAuthenticationToken: v,
    isDynamicSuggetion: C = !1,
    isPopMessageAudio: w = !1,
    isActive: B,
    botLogo: y,
    isPopUp: b = !0,
    accent: q
  } = t;
  const { apiKey: E, entityId: x, apiType: M, themeConfig: O } = Xe(
    ct.Context
  );
  let I = M == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const [S, P] = N("Home"), [H, F] = N(""), [T, U] = N(!1), [D, Q] = N(), [Y, j] = N([]), [Z, W] = N([]), [R, K] = N([]), [L, G] = N(!0), [V, _] = N(!0), [J, X] = N(0), [ne, ee] = N([]), [$, te] = N(
    []
  ), [ae, se] = N([]), [ue, fe] = N([]), [ve, ge] = N(!1), [oe, ce] = N(""), [pe, qe] = N(""), [Se, Te] = N("SIDEBAR"), [be, He] = N(!1), [Ge, Le] = N(""), Ae = gt(T), [Pe, it] = N({}), [de, xe] = N({
    Chat: {},
    Help: {},
    Updates: {},
    Tasks: {},
    Home: {}
  }), [he, Qe] = N(!0), [Re, pt] = N(""), [ze, lt] = N(!0), [st, We] = N([]), [Je, ut] = N(!1), [Be, Ct] = N(2), [Ye, $e] = N(), [nt, mt] = N({}), [me, yt] = N({
    accentColor: q || "",
    borderRadius: "",
    images: [],
    buttonColor: ""
  }), [Ue, Ie] = N({});
  let ot = new Bt("mixpanel", M, E, x);
  le(() => {
    T == !0 && (Ae.current = T);
  }, [T]);
  const Ke = async () => {
    Pke(
      I,
      x,
      e,
      r,
      E,
      A,
      i,
      M,
      v
    ).then((dt) => {
      var ie, _e;
      console.log(dt, "result"), (ie = dt == null ? void 0 : dt.questions) != null && ie.length ? We(
        ((_e = dt == null ? void 0 : dt.questions) == null ? void 0 : _e.map((Ne) => Ne.text)) || f
      ) : f && We(f);
    });
  }, tt = () => {
    let dt = localStorage.getItem("lastPopupOpen"), ie = (/* @__PURE__ */ new Date()).getTime() - (dt ? new Date(dt).getTime() : (/* @__PURE__ */ new Date()).getTime()), _e = dt ? Ye == "ONE_DAY" ? ie >= 864e5 : Ye == "EVERY_TIME" ? !0 : !dt : !0;
    if (st.length && _e) {
      const Ne = setTimeout(() => {
        Ae.current === !1 && (He(!0), localStorage.setItem("lastPopupOpen", (/* @__PURE__ */ new Date()).toString()));
      }, Be * 1e3);
      return () => clearTimeout(Ne);
    }
  };
  le(() => {
    tt();
  }, [st, Be]), le(() => {
    ot.trackEvent(
      "quest-helphub-loaded",
      A || "quest-sdk-user",
      {},
      !0
    );
  }, []), le(() => {
    T == !0 && He(!1);
  }, [T]), le(() => {
    Ge != "" && (U(!0), P("Chat"));
  }, [Ge]);
  const Ot = async () => {
    let dt = localStorage.getItem("helphubPosition");
    Te(dt || "SIDEBAR");
  }, Vt = (dt) => {
    localStorage.setItem("helphubPosition", dt), Te(dt);
  };
  le(() => {
    c != "USER_CHOICE" ? Te(c) : Ot();
  }, []), le(() => {
    var dt;
    X(
      Math.ceil(
        100 * ((R == null ? void 0 : R.length) / ((dt = Y[3]) == null ? void 0 : dt.length))
      )
    );
  }, [R]);
  const Mt = async () => {
    var Ne, Ee, et, Ft, je, ur, Me, De, Ce, Pt, Ut, It, at, vt, zt, Ht, _t, or, tr, Cr, jt, dr, Xt, ui, sr, di, bo, Bo, Ws, Xs, Ks, Zs, Js, Kd, Zd, Jd, _d, $d;
    lt(!0);
    let ie = await wke(
      I,
      x,
      n || "q-default-helphub",
      e,
      r,
      E,
      A,
      i,
      M,
      l,
      v
    );
    lt(!1);
    const _e = {
      styleConfig: (et = (Ee = (Ne = ie == null ? void 0 : ie.data) == null ? void 0 : Ne.sdkConfig) == null ? void 0 : Ee.uiProps) == null ? void 0 : et.styleConfig,
      contentConfig: (ur = (je = (Ft = ie == null ? void 0 : ie.data) == null ? void 0 : Ft.sdkConfig) == null ? void 0 : je.uiProps) == null ? void 0 : ur.contentConfig
    };
    if (Qe(
      a || ((Ce = (De = (Me = ie == null ? void 0 : ie.data) == null ? void 0 : Me.sdkConfig) == null ? void 0 : De.uiProps) == null ? void 0 : Ce.showFooter) || !0
    ), mt(
      ((at = (It = (Ut = (Pt = ie == null ? void 0 : ie.data) == null ? void 0 : Pt.sdkConfig) == null ? void 0 : Ut.uiProps) == null ? void 0 : It.BrandTheme) == null ? void 0 : at.properties) || {}
    ), yt({
      ...(Ht = (zt = (vt = ie == null ? void 0 : ie.data) == null ? void 0 : vt.sdkConfig) == null ? void 0 : zt.uiProps) == null ? void 0 : Ht.questThemeData,
      accentColor: (tr = (or = (_t = ie == null ? void 0 : ie.data) == null ? void 0 : _t.sdkConfig) == null ? void 0 : or.uiProps) != null && tr.questThemeData.accentColor ? (dr = (jt = (Cr = ie == null ? void 0 : ie.data) == null ? void 0 : Cr.sdkConfig) == null ? void 0 : jt.uiProps) == null ? void 0 : dr.questThemeData.accentColor : q
    }), Ie(((sr = (ui = (Xt = ie == null ? void 0 : ie.data) == null ? void 0 : Xt.sdkConfig) == null ? void 0 : ui.uiProps) == null ? void 0 : sr.contentConfig) || {}), $e(
      g || ((Bo = (bo = (di = ie == null ? void 0 : ie.data) == null ? void 0 : di.sdkConfig) == null ? void 0 : bo.uiProps) == null ? void 0 : Bo.autoPopupOpenAfter) || "ONE_DAY"
    ), Ct(
      d || ((Ks = (Xs = (Ws = ie == null ? void 0 : ie.data) == null ? void 0 : Ws.sdkConfig) == null ? void 0 : Xs.uiProps) == null ? void 0 : Ks.popupOpenDelay) || 2
    ), We(
      f || ((Kd = (Js = (Zs = ie == null ? void 0 : ie.data) == null ? void 0 : Zs.sdkConfig) == null ? void 0 : Js.uiProps) == null ? void 0 : Kd.defaultAutoPopupMessages) || []
    ), pt(
      u || ((_d = (Jd = (Zd = ie == null ? void 0 : ie.data) == null ? void 0 : Zd.sdkConfig) == null ? void 0 : Jd.uiProps) == null ? void 0 : _d.entityLogo)
    ), it((Eo) => {
      var Ei, pn, Ki;
      return {
        ...Eo,
        ...(Ki = (pn = (Ei = ie == null ? void 0 : ie.data) == null ? void 0 : Ei.sdkConfig) == null ? void 0 : pn.uiProps) == null ? void 0 : Ki.styleConfig,
        ...o
      };
    }), localStorage.setItem(x, JSON.stringify(_e)), xe((Eo) => {
      var Ei, pn, Ki;
      return {
        ...Eo,
        ...(Ki = (pn = (Ei = ie == null ? void 0 : ie.data) == null ? void 0 : Ei.sdkConfig) == null ? void 0 : pn.uiProps) == null ? void 0 : Ki.contentConfig,
        ...s
      };
    }), !(ie != null && ie.success))
      lt(!0);
    else {
      let Eo = ($d = ie == null ? void 0 : ie.data.childCampaignActions) == null ? void 0 : $d.map(
        ({ actions: Ei }) => Ei == null ? void 0 : Ei.map((pn) => {
          var Ki, e0, t0, r0;
          return {
            type: pn.actionType,
            question: pn.title || "",
            description: pn.description || "",
            options: pn.options || [],
            criteriaId: pn.actionId,
            required: pn.isRequired,
            linkTitle: ((Ki = pn.metadata) == null ? void 0 : Ki.linkActionName) || pn.title || "",
            linkUrl: ((e0 = pn.metadata) == null ? void 0 : e0.link) || "",
            manualInput: !1,
            completed: !!pn.isCompleted,
            answer: ((t0 = pn.metadata) == null ? void 0 : t0.answer) || "",
            createdAt: pn.createdAt || "",
            imageUrl: ((r0 = pn.metadata) == null ? void 0 : r0.imageUrl) || ""
          };
        })
      );
      Q(ie == null ? void 0 : ie.data), ee(Eo[3]), te(Eo[2]), j(Eo);
    }
  }, lr = (dt) => dt == null ? void 0 : dt.sort((_e, Ne) => {
    var Ee, et;
    return new Date((Ee = Ne == null ? void 0 : Ne.conversations) == null ? void 0 : Ee.timestamp).getTime() - new Date((et = _e == null ? void 0 : _e.conversations) == null ? void 0 : et.timestamp).getTime();
  }), Lr = async () => {
    ge(!0);
    try {
      const dt = await fy(
        I,
        x,
        e,
        r,
        E,
        "",
        A,
        i,
        M,
        v
      );
      if (dt && dt.data) {
        const ie = lr(dt.data);
        se(ie), fe(ie);
      } else
        console.error("No data received or response is undefined.");
    } catch (dt) {
      console.error("Error fetching chat messages:", dt);
    } finally {
      ge(!1);
    }
  }, Et = async () => {
    try {
      const ie = await ij(
        I,
        x,
        n || "q-default-helphub",
        e,
        r,
        E,
        A,
        i,
        M,
        v
      );
      if (ie && ie.data) {
        const { data: _e } = ie;
        ce(_e.imageUrl), qe(_e.name);
      } else
        console.error("No data received or response is undefined.");
    } catch (dt) {
      console.error("Error fetching entity details:", dt);
    }
  };
  le(() => {
    ze || (C && Ke(), Lr(), Et());
  }, [ze]), le(() => {
    let dt = localStorage.getItem(x);
    dt && (it((ie) => ({
      ...ie,
      ...JSON.parse(dt).styleConfig,
      ...o
    })), xe((ie) => ({
      ...ie,
      ...JSON.parse(dt).contentConfig,
      ...s
    }))), Mt();
  }, []), le(() => {
    let dt = ne == null ? void 0 : ne.filter((ie) => ie.completed === !0).map((ie) => ie.criteriaId);
    K(dt);
  }, [ne]), le(() => {
    let dt = $.filter((ie) => ie.completed === !0).map((ie) => ie.criteriaId);
    W(dt);
  }, [$]), le(() => {
    F(S);
  }, [S]), le(() => {
    b || U(!0);
  }, []);
  const Qt = gt(null), Er = gt(null), kt = (dt) => {
    var _e, Ne;
    let ie = dt.target;
    (_e = Qt.current) != null && _e.contains(ie) || (Ne = Er.current) != null && Ne.contains(ie) || (U(!1), B && B(!1));
  }, en = me != null && me.accentColor ? ike(me.accentColor) : "144, 53, 255";
  if (ze)
    return null;
  function St() {
    return y != null && y.logo ? typeof y.logo == "string" ? /* @__PURE__ */ h(
      "img",
      {
        src: y.logo,
        className: `helphub-open-messagesIcon ${T ? "" : "show-icon"}`,
        alt: "Custom Logo",
        style: y.style
      }
    ) : /* @__PURE__ */ h(
      "div",
      {
        className: `helphub-open-messagesIcon ${T ? "" : "show-icon"}`,
        style: y.style,
        children: y.logo
      }
    ) : /* @__PURE__ */ h(
      "img",
      {
        src: Zke,
        className: `helphub-open-messagesIcon ${T ? "" : "show-icon"}`,
        alt: "Default Logo",
        style: y == null ? void 0 : y.style
      }
    );
  }
  return /* @__PURE__ */ k(Ze, { children: [
    b && /* @__PURE__ */ h(
      "div",
      {
        style: {
          fontFamily: O.fontFamily || "'Figtree', sans-serif",
          width: Se == "SIDEBAR" && T ? "100vw" : "",
          height: Se == "SIDEBAR" && T ? "100vh" : "",
          position: Se == "SIDEBAR" && T ? "fixed" : "static",
          top: "0",
          left: "0",
          zIndex: T ? 9999 : ""
        },
        onClick: (dt) => kt(dt),
        children: /* @__PURE__ */ k("div", { className: "helphubIconUpperCont", ref: Er, children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: "helhubIconCont",
              onClick: () => {
                U((dt) => !dt), B && B(!T);
              },
              style: {
                background: ((jr = o == null ? void 0 : o.QuestLogo) == null ? void 0 : jr.QuestLogoBackground) || (me == null ? void 0 : me.accentColor),
                boxShadow: `-1px -1px 50.3px -1px rgba(${en}, 0.75)`
              },
              children: [
                /* @__PURE__ */ h(
                  "img",
                  {
                    src: Wke,
                    className: `helphub-open-addIcon ${T ? "show-icon" : ""}`
                  }
                ),
                St()
              ]
            }
          ),
          c == "USER_CHOICE" && // <div className="helphub-open-resizeIcon" onClick={() => setPositionInLocal(position == "POPUP" ? "SIDEBAR" : "POPUP")}>
          /* @__PURE__ */ h(
            "img",
            {
              src: Se == "POPUP" ? Kke : Xke,
              alt: "",
              className: "helphub-open-resizeIcon",
              style: {
                background: ((cn = o == null ? void 0 : o.QuestLogo) == null ? void 0 : cn.QuestLogoBackground) || (me == null ? void 0 : me.accentColor)
              },
              onClick: () => Vt(
                Se == "POPUP" ? "SIDEBAR" : "POPUP"
              )
            }
          ),
          st.length ? /* @__PURE__ */ k(
            "div",
            {
              className: `helpHubMainCont-default-popup ${be ? "helpHubMainCont-default-popup-animated" : ""}`,
              children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: "home-back-btn",
                    onClick: () => He(!1),
                    children: /* @__PURE__ */ h(
                      "svg",
                      {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        children: /* @__PURE__ */ h(
                          "path",
                          {
                            d: "M5.63184 14.3697L10.001 10.0005L14.3702 14.3697M14.3702 5.63135L10.0002 10.0005L5.63184 5.63135",
                            stroke: "#696969",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ k("div", { className: "home-assistant-msg", children: [
                  /* @__PURE__ */ h(
                    "img",
                    {
                      style: {
                        background: ((ln = o == null ? void 0 : o.QuestLogo) == null ? void 0 : ln.QuestLogoBackground) || me.accentColor
                      },
                      src: Re || oe,
                      alt: ""
                    }
                  ),
                  /* @__PURE__ */ h("p", { children: "Hello there👋, How can I help you?" })
                ] }),
                /* @__PURE__ */ h("div", { className: "home-user-msg", children: st.map((dt, ie) => {
                  var _e, Ne, Ee, et, Ft;
                  return /* @__PURE__ */ h(
                    "p",
                    {
                      style: {
                        background: ((Ne = (_e = o == null ? void 0 : o.QuestLogo) == null ? void 0 : _e.QuestContent) == null ? void 0 : Ne.background) || me.accentColor,
                        color: ((et = (Ee = o == null ? void 0 : o.QuestLogo) == null ? void 0 : Ee.QuestContent) == null ? void 0 : et.color) || (nt == null ? void 0 : nt.contentColor),
                        ...(Ft = o == null ? void 0 : o.QuestLogo) == null ? void 0 : Ft.QuestContent
                      },
                      onClick: () => Le(dt),
                      children: dt
                    },
                    ie
                  );
                }) })
              ]
            }
          ) : "",
          /* @__PURE__ */ k(
            "div",
            {
              id: "helpHub",
              className: `${Se == "SIDEBAR" ? "helpHubMainCont-sidebar" : "helpHubMainCont"} ${T ? "animated" : ""}`,
              style: {
                height: Se === "SIDEBAR" ? "100vh" : (un = o == null ? void 0 : o.Main) == null ? void 0 : un.height,
                width: (dn = o == null ? void 0 : o.Main) == null ? void 0 : dn.width,
                borderRadius: (me == null ? void 0 : me.borderRadius) || (nt == null ? void 0 : nt.borderRadius),
                boxShadow: (fn = o == null ? void 0 : o.Main) == null ? void 0 : fn.boxShadow
              },
              ref: Qt,
              children: [
                S === "Home" ? /* @__PURE__ */ h(
                  am,
                  {
                    questsData: Y,
                    setSelectedSection: P,
                    parentQuest: D,
                    userId: e,
                    token: r,
                    styleConfig: Pe,
                    contentConfig: de == null ? void 0 : de.Home,
                    claimStatusTasks: R,
                    taskStatus: J,
                    onlineComponent: !0,
                    showFeedback: L,
                    setShowFeedback: G,
                    entityImage: Re || oe,
                    uniqueUserId: A,
                    uniqueEmailId: i,
                    entityAuthenticationToken: v,
                    BrandTheme: nt,
                    QuestThemeData: me,
                    contentData: Ue
                  }
                ) : "",
                S === "Chat" ? /* @__PURE__ */ h(
                  cm,
                  {
                    contentConfig: de == null ? void 0 : de.Chat,
                    apiType: M,
                    entityId: x,
                    userId: e,
                    token: r,
                    apiKey: E,
                    styleConfig: Pe,
                    showBottomNavigation: V,
                    setShowBottomNavigation: _,
                    entityImage: oe,
                    entityName: pe,
                    setHelpHub: U,
                    isActive: B,
                    uniqueUserId: A,
                    uniqueEmailId: i,
                    position: Se,
                    sendAutoMessage: Ge,
                    setSendAutoMessage: Le,
                    chat: ae,
                    setChat: se,
                    filterChat: ue,
                    setFilterChat: fe,
                    fetchData: ve,
                    setFetchData: ge,
                    entityAuthenticationToken: v,
                    defaultAutoPopupMessagesApi: st,
                    isPopMessageAudio: w,
                    setOpenCloseChatPopup: ut,
                    openCloseChatPopup: Je,
                    BrandTheme: nt,
                    QuestThemeData: me
                  }
                ) : "",
                S === "Help" ? /* @__PURE__ */ h(
                  lm,
                  {
                    faqData: Y != null && Y.length ? Y[1] : [],
                    styleConfig: Pe,
                    contentConfig: de == null ? void 0 : de.Help,
                    setHelpHub: U,
                    isActive: B,
                    uniqueUserId: A,
                    uniqueEmailId: i,
                    entityAuthenticationToken: v,
                    BrandTheme: nt,
                    QuestThemeData: me
                  }
                ) : "",
                S === "Updates" ? /* @__PURE__ */ h(
                  dm,
                  {
                    updateData: Y != null && Y.length ? $ : [],
                    contentConfig: de == null ? void 0 : de.Updates,
                    styleConfig: Pe,
                    questId: (D == null ? void 0 : D.childCampaignActions[2].campaignId) || "",
                    campaignVariationId: (D == null ? void 0 : D.childCampaignActions[2].campaignVariationId) || "",
                    userId: e,
                    token: r,
                    claimStatusUpdates: Z,
                    setClaimStatusUpdates: W,
                    onlineComponent: !0,
                    showBottomNavigation: V,
                    setShowBottomNavigation: _,
                    entityImage: oe,
                    setHelpHub: U,
                    isActive: B,
                    uniqueUserId: A,
                    uniqueEmailId: i,
                    entityAuthenticationToken: v,
                    BrandTheme: nt,
                    QuestThemeData: me
                  }
                ) : "",
                S === "Tasks" ? /* @__PURE__ */ h(
                  um,
                  {
                    tasksData: Y != null && Y.length ? ne : [],
                    contentConfig: de == null ? void 0 : de.Tasks,
                    styleConfig: Pe,
                    questId: ((hn = D == null ? void 0 : D.childCampaignActions[3]) == null ? void 0 : hn.campaignId) || "",
                    campaignVariationId: ((En = D == null ? void 0 : D.childCampaignActions[3]) == null ? void 0 : En.campaignVariationId) || "",
                    token: r,
                    userId: e,
                    claimStatusTasks: R,
                    setClaimStatusTasks: K,
                    onlineComponent: !0,
                    setHelpHub: U,
                    isActive: B,
                    uniqueUserId: A,
                    uniqueEmailId: i,
                    entityAuthenticationToken: v,
                    BrandTheme: nt,
                    QuestThemeData: me,
                    contentData: Ue
                  }
                ) : "",
                /* @__PURE__ */ k("div", { className: "helphubBottomCont", children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: `helphubSvgCont ${V ? "showNav" : "hideNav"}`,
                      children: /* @__PURE__ */ k("div", { children: [
                        /* @__PURE__ */ k("div", { onClick: () => P("Home"), children: [
                          /* @__PURE__ */ h(
                            Nn,
                            {
                              type: "home",
                              primaryColor: S == "Home" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                              secondaryColor: S == "Home" ? "white" : "#B9B9B9"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: S == "Home" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                fontWeight: S == "Home" ? "600" : "400"
                              },
                              className: "helphubSvgTitle",
                              children: "Home"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ k("div", { onClick: () => P("Chat"), children: [
                          /* @__PURE__ */ h(
                            Nn,
                            {
                              type: "Chat",
                              primaryColor: S == "Chat" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                              secondaryColor: S == "Chat" ? "white" : "#B9B9B9"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: S == "Chat" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                fontWeight: S == "Chat" ? "600" : "400"
                              },
                              className: "helphubSvgTitle",
                              children: "Chat"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ k("div", { onClick: () => P("Help"), children: [
                          /* @__PURE__ */ h(
                            Nn,
                            {
                              type: "Help",
                              primaryColor: S == "Help" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                              secondaryColor: S == "Help" ? "white" : "#B9B9B9"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: S == "Help" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                fontWeight: S == "Help" ? "600" : "400"
                              },
                              className: "helphubSvgTitle",
                              children: "FAQs"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ k("div", { onClick: () => P("Updates"), children: [
                          /* @__PURE__ */ h(
                            Nn,
                            {
                              type: "Updates",
                              primaryColor: S == "Updates" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                              secondaryColor: S == "Updates" ? "white" : "#B9B9B9"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: S == "Updates" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                fontWeight: S == "Updates" ? "600" : "400"
                              },
                              className: "helphubSvgTitle",
                              children: "Updates"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ k("div", { onClick: () => P("Tasks"), children: [
                          /* @__PURE__ */ h(
                            Nn,
                            {
                              type: "Tasks",
                              primaryColor: S == "Tasks" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                              secondaryColor: S == "Tasks" ? "white" : "#B9B9B9"
                            }
                          ),
                          /* @__PURE__ */ h(
                            "div",
                            {
                              style: {
                                color: S == "Tasks" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                fontWeight: S == "Tasks" ? "600" : "400"
                              },
                              className: "helphubSvgTitle",
                              children: "Tasks"
                            }
                          )
                        ] })
                      ] })
                    }
                  ),
                  he && /* @__PURE__ */ k(
                    "div",
                    {
                      className: "helphubFooterCont",
                      onClick: () => {
                        window.open(
                          p || "https://www.plgos.com/"
                        );
                      },
                      children: [
                        /* @__PURE__ */ h("div", { className: "helphubFooterText", children: m || "Powered by PLG OS" }),
                        /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(Nn, { type: "footerLogo" }) })
                      ]
                    }
                  )
                ] })
              ]
            }
          )
        ] })
      }
    ),
    !b && /* @__PURE__ */ h(
      "div",
      {
        style: {
          fontFamily: O.fontFamily || "'Figtree', sans-serif",
          // width: position == "SIDEBAR" && helpHub ? "100vw" : "",
          width: "100%",
          height: "100%"
          // height: position == "SIDEBAR" && helpHub ? "100vh" : "",
          // position: position == "SIDEBAR" && helpHub ? "fixed" : "static",
          // top: "0",
          // left: "0",
        },
        onClick: (dt) => kt(dt),
        children: /* @__PURE__ */ k(
          "div",
          {
            className: "helphubIconUpperCont",
            ref: Er,
            style: {
              height: "100%"
            },
            children: [
              st.length ? /* @__PURE__ */ k(
                "div",
                {
                  className: `helpHubMainCont-default-popup ${be ? "helpHubMainCont-default-popup-animated" : ""}`,
                  children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "home-back-btn",
                        onClick: () => He(!1),
                        children: /* @__PURE__ */ h(
                          "svg",
                          {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            children: /* @__PURE__ */ h(
                              "path",
                              {
                                d: "M5.63184 14.3697L10.001 10.0005L14.3702 14.3697M14.3702 5.63135L10.0002 10.0005L5.63184 5.63135",
                                stroke: "#696969",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }
                            )
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ k("div", { className: "home-assistant-msg", children: [
                      /* @__PURE__ */ h(
                        "img",
                        {
                          style: {
                            background: ((xn = o == null ? void 0 : o.QuestLogo) == null ? void 0 : xn.QuestLogoBackground) || me.accentColor
                          },
                          src: Re || oe,
                          alt: ""
                        }
                      ),
                      /* @__PURE__ */ h("p", { children: "Hello there👋, How can I help you?" })
                    ] }),
                    /* @__PURE__ */ h("div", { className: "home-user-msg", children: st.map((dt, ie) => {
                      var _e, Ne, Ee, et, Ft;
                      return /* @__PURE__ */ h(
                        "p",
                        {
                          style: {
                            background: ((Ne = (_e = o == null ? void 0 : o.QuestLogo) == null ? void 0 : _e.QuestContent) == null ? void 0 : Ne.background) || me.accentColor,
                            color: ((et = (Ee = o == null ? void 0 : o.QuestLogo) == null ? void 0 : Ee.QuestContent) == null ? void 0 : et.color) || (nt == null ? void 0 : nt.contentColor),
                            ...(Ft = o == null ? void 0 : o.QuestLogo) == null ? void 0 : Ft.QuestContent
                          },
                          onClick: () => Le(dt),
                          children: dt
                        },
                        ie
                      );
                    }) })
                  ]
                }
              ) : "",
              /* @__PURE__ */ k(
                "div",
                {
                  id: "helpHub",
                  className: `${Se == "SIDEBAR" ? "helpHubMainCont-sidebar" : "helpHubMainCont"} ${T ? "animated" : ""}`,
                  style: {
                    // height: position === "SIDEBAR" ? "100vh" : styleConfig?.Main?.height,
                    height: "100%",
                    width: (In = o == null ? void 0 : o.Main) == null ? void 0 : In.width,
                    borderRadius: (me == null ? void 0 : me.borderRadius) || (nt == null ? void 0 : nt.borderRadius),
                    boxShadow: (Sn = o == null ? void 0 : o.Main) == null ? void 0 : Sn.boxShadow
                  },
                  ref: Qt,
                  children: [
                    S === "Home" ? /* @__PURE__ */ h(
                      am,
                      {
                        questsData: Y,
                        setSelectedSection: P,
                        parentQuest: D,
                        userId: e,
                        token: r,
                        styleConfig: Pe,
                        contentConfig: de == null ? void 0 : de.Home,
                        claimStatusTasks: R,
                        taskStatus: J,
                        onlineComponent: !0,
                        showFeedback: L,
                        setShowFeedback: G,
                        entityImage: Re || oe,
                        uniqueUserId: A,
                        uniqueEmailId: i,
                        entityAuthenticationToken: v,
                        BrandTheme: nt,
                        QuestThemeData: me,
                        contentData: Ue
                      }
                    ) : "",
                    S === "Chat" ? /* @__PURE__ */ h(
                      cm,
                      {
                        contentConfig: de == null ? void 0 : de.Chat,
                        apiType: M,
                        entityId: x,
                        userId: e,
                        token: r,
                        apiKey: E,
                        styleConfig: Pe,
                        showBottomNavigation: V,
                        setShowBottomNavigation: _,
                        entityImage: oe,
                        entityName: pe,
                        setHelpHub: U,
                        isActive: B,
                        uniqueUserId: A,
                        uniqueEmailId: i,
                        position: Se,
                        sendAutoMessage: Ge,
                        setSendAutoMessage: Le,
                        chat: ae,
                        setChat: se,
                        filterChat: ue,
                        setFilterChat: fe,
                        fetchData: ve,
                        setFetchData: ge,
                        entityAuthenticationToken: v,
                        defaultAutoPopupMessagesApi: st,
                        isPopMessageAudio: w,
                        setOpenCloseChatPopup: ut,
                        openCloseChatPopup: Je,
                        BrandTheme: nt,
                        QuestThemeData: me
                      }
                    ) : "",
                    S === "Help" ? /* @__PURE__ */ h(
                      lm,
                      {
                        faqData: Y != null && Y.length ? Y[1] : [],
                        styleConfig: Pe,
                        contentConfig: de == null ? void 0 : de.Help,
                        setHelpHub: U,
                        isActive: B,
                        uniqueUserId: A,
                        uniqueEmailId: i,
                        entityAuthenticationToken: v,
                        BrandTheme: nt,
                        QuestThemeData: me
                      }
                    ) : "",
                    S === "Updates" ? /* @__PURE__ */ h(
                      dm,
                      {
                        updateData: Y != null && Y.length ? $ : [],
                        contentConfig: de == null ? void 0 : de.Updates,
                        styleConfig: Pe,
                        questId: (D == null ? void 0 : D.childCampaignActions[2].campaignId) || "",
                        campaignVariationId: (D == null ? void 0 : D.childCampaignActions[2].campaignVariationId) || "",
                        userId: e,
                        token: r,
                        claimStatusUpdates: Z,
                        setClaimStatusUpdates: W,
                        onlineComponent: !0,
                        showBottomNavigation: V,
                        setShowBottomNavigation: _,
                        entityImage: oe,
                        setHelpHub: U,
                        isActive: B,
                        uniqueUserId: A,
                        uniqueEmailId: i,
                        entityAuthenticationToken: v,
                        BrandTheme: nt,
                        QuestThemeData: me
                      }
                    ) : "",
                    S === "Tasks" ? /* @__PURE__ */ h(
                      um,
                      {
                        tasksData: Y != null && Y.length ? ne : [],
                        contentConfig: de == null ? void 0 : de.Tasks,
                        styleConfig: Pe,
                        questId: ((Pn = D == null ? void 0 : D.childCampaignActions[3]) == null ? void 0 : Pn.campaignId) || "",
                        campaignVariationId: ((kn = D == null ? void 0 : D.childCampaignActions[3]) == null ? void 0 : kn.campaignVariationId) || "",
                        token: r,
                        userId: e,
                        claimStatusTasks: R,
                        setClaimStatusTasks: K,
                        onlineComponent: !0,
                        setHelpHub: U,
                        isActive: B,
                        uniqueUserId: A,
                        uniqueEmailId: i,
                        entityAuthenticationToken: v,
                        BrandTheme: nt,
                        QuestThemeData: me,
                        contentData: Ue
                      }
                    ) : "",
                    /* @__PURE__ */ k("div", { className: "helphubBottomCont", children: [
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: `helphubSvgCont ${V ? "showNav" : "hideNav"}`,
                          children: /* @__PURE__ */ k("div", { children: [
                            /* @__PURE__ */ k("div", { onClick: () => P("Home"), children: [
                              /* @__PURE__ */ h(
                                Nn,
                                {
                                  type: "home",
                                  primaryColor: S == "Home" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                                  secondaryColor: S == "Home" ? "white" : "#B9B9B9"
                                }
                              ),
                              /* @__PURE__ */ h(
                                "div",
                                {
                                  style: {
                                    color: S == "Home" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                    fontWeight: S == "Home" ? "600" : "400"
                                  },
                                  className: "helphubSvgTitle",
                                  children: "Home"
                                }
                              )
                            ] }),
                            /* @__PURE__ */ k("div", { onClick: () => P("Chat"), children: [
                              /* @__PURE__ */ h(
                                Nn,
                                {
                                  type: "Chat",
                                  primaryColor: S == "Chat" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                                  secondaryColor: S == "Chat" ? "white" : "#B9B9B9"
                                }
                              ),
                              /* @__PURE__ */ h(
                                "div",
                                {
                                  style: {
                                    color: S == "Chat" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                    fontWeight: S == "Chat" ? "600" : "400"
                                  },
                                  className: "helphubSvgTitle",
                                  children: "Chat"
                                }
                              )
                            ] }),
                            /* @__PURE__ */ k("div", { onClick: () => P("Help"), children: [
                              /* @__PURE__ */ h(
                                Nn,
                                {
                                  type: "Help",
                                  primaryColor: S == "Help" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                                  secondaryColor: S == "Help" ? "white" : "#B9B9B9"
                                }
                              ),
                              /* @__PURE__ */ h(
                                "div",
                                {
                                  style: {
                                    color: S == "Help" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                    fontWeight: S == "Help" ? "600" : "400"
                                  },
                                  className: "helphubSvgTitle",
                                  children: "FAQs"
                                }
                              )
                            ] }),
                            /* @__PURE__ */ k("div", { onClick: () => P("Updates"), children: [
                              /* @__PURE__ */ h(
                                Nn,
                                {
                                  type: "Updates",
                                  primaryColor: S == "Updates" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                                  secondaryColor: S == "Updates" ? "white" : "#B9B9B9"
                                }
                              ),
                              /* @__PURE__ */ h(
                                "div",
                                {
                                  style: {
                                    color: S == "Updates" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                    fontWeight: S == "Updates" ? "600" : "400"
                                  },
                                  className: "helphubSvgTitle",
                                  children: "Updates"
                                }
                              )
                            ] }),
                            /* @__PURE__ */ k("div", { onClick: () => P("Tasks"), children: [
                              /* @__PURE__ */ h(
                                Nn,
                                {
                                  type: "Tasks",
                                  primaryColor: S == "Tasks" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#B9B9B9",
                                  secondaryColor: S == "Tasks" ? "white" : "#B9B9B9"
                                }
                              ),
                              /* @__PURE__ */ h(
                                "div",
                                {
                                  style: {
                                    color: S == "Tasks" ? (me == null ? void 0 : me.accentColor) || "#9035FF" : "#b9b9b9",
                                    fontWeight: S == "Tasks" ? "600" : "400"
                                  },
                                  className: "helphubSvgTitle",
                                  children: "Tasks"
                                }
                              )
                            ] })
                          ] })
                        }
                      ),
                      he && /* @__PURE__ */ k(
                        "div",
                        {
                          className: "helphubFooterCont",
                          onClick: () => {
                            window.open(
                              p || "https://www.plgos.com/"
                            );
                          },
                          children: [
                            /* @__PURE__ */ h("div", { className: "helphubFooterText", children: m || "Powered by PLG OS" }),
                            /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(Nn, { type: "footerLogo" }) })
                          ]
                        }
                      )
                    ] })
                  ]
                }
              )
            ]
          }
        )
      }
    )
  ] });
}, Tl = new zn(), Jke = (t) => ({
  "Content-Type": "application/json",
  ...t
}), _ke = async ({
  BACKEND_URL: t,
  apiKey: e,
  entityId: r,
  uniqueUserId: n,
  uniqueEmailId: A,
  userId: i,
  token: o,
  GeneralFunctions: s
}) => {
  var a;
  try {
    const c = Tl.get("externalUserId"), l = Tl.get("questUserId"), u = Tl.get("questUserToken");
    if (c && l && u && (c === n || c === A))
      return {
        userId: l,
        token: u
      };
    if (n) {
      const f = Jke({
        apiKey: e,
        ...o && { token: o },
        ...i && { userId: i }
      }), d = {
        externalUserId: n,
        entityId: r,
        email: A || null
      }, g = await Oe.post(
        `${t}api/users/external/login`,
        d,
        { headers: f }
      );
      if (!((a = g.data) != null && a.success))
        throw new Error("Invalid response from external login");
      const { userId: m, token: p } = g.data, v = /* @__PURE__ */ new Date();
      return v.setHours(v.getHours() + 12), Tl.set("externalUserId", n, { path: "/", expires: v }), Tl.set("questUserId", m, { path: "/", expires: v }), Tl.set("questUserToken", p, { path: "/", expires: v }), {
        userId: m,
        token: p
      };
    }
    return i && o ? { userId: i, token: o } : null;
  } catch (c) {
    return s.captureSentryException(c), null;
  }
}, $ke = async ({
  BACKEND_URL: t,
  apiKey: e,
  apiSecret: r,
  entityId: n,
  questId: A,
  enableVariation: i,
  userId: o,
  token: s,
  uniqueUserId: a,
  uniqueEmailId: c,
  setCriterias: l,
  setQuestThemeData: u,
  setBrandTheme: f,
  GeneralFunctions: d,
  setCampaignVariationId: g,
  setIsVerify: m,
  setClaimStatus: p,
  setCampaignXp: v
}) => {
  var C, w, B, y, b, q, E, x, M, O, I;
  try {
    const S = await Oe.get(
      `${t}api/v2/entities/${n}/campaigns/${A}`,
      {
        headers: {
          apiKey: e,
          apisecret: r,
          userId: o,
          token: s
        }
      }
    );
    if (!((C = S.data) != null && C.success))
      throw new Error("Failed to fetch campaign data");
    if (S.status === 200) {
      const P = [];
      p((B = (w = S == null ? void 0 : S.data) == null ? void 0 : w.data) == null ? void 0 : B.isClaimed);
      const H = (q = (b = (y = S == null ? void 0 : S.data) == null ? void 0 : y.data) == null ? void 0 : b.rewards) == null ? void 0 : q.find(
        (T) => T.rewardType === "REWARD_XP" && T.isEnabled
      ), F = H && H.xp || 0;
      if (v(F), (x = (E = S.data) == null ? void 0 : E.data) != null && x.actions) {
        let T = !1;
        for (let U of S.data.data.actions)
          P.push({
            completed: U.isCompleted,
            actionId: U.actionId,
            title: U.title,
            metricCount: ((M = U.metadata) == null ? void 0 : M.threshold) || 0,
            isLocked: !U.isEnabled,
            progressPercent: U.progressPercent,
            progressData: U.progressData,
            xp: U.xp || 0
          }), U.progressPercent == 100 && (T = !0);
        T && m(!0);
      }
      S.data.data.theme && u(S.data.data.theme), l(P), g == null || g((I = (O = S == null ? void 0 : S.data) == null ? void 0 : O.data) == null ? void 0 : I.campaignVariationId);
    } else
      console.error("Unexpected status code:", S.status);
  } catch (S) {
    console.error("Error fetching challenges data:", S), d.captureSentryException(S);
  }
}, eOe = async ({
  BACKEND_URL: t,
  apiKey: e,
  apiSecret: r,
  entityId: n,
  questId: A,
  criterias: i,
  userId: o,
  token: s,
  campaignVariationId: a,
  GeneralFunctions: c
}) => {
  var l;
  try {
    const u = {
      apiKey: e,
      apisecret: r,
      userId: o,
      token: s
    }, f = await Oe.post(
      `${t}api/v2/entities/${n}/campaigns/${A}/verify`,
      {
        actions: i,
        campaignVariationId: a
      },
      { headers: u }
    );
    if (!((l = f.data) != null && l.success))
      throw new Error("Failed to verify actions");
    return f.data;
  } catch (u) {
    console.error("Error verifying actions:", u), c.captureSentryException(u);
  }
}, hP = (t) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9426 1.25C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25H11.9426ZM11.25 2.75028C9.25629 2.75238 7.77266 2.77054 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.42514 4.56445 3.09825 5.33517 2.92637 6.61358C2.77054 7.77266 2.75238 9.25629 2.75028 11.25H6.91376C6.56279 10.8116 6.30055 10.2945 6.15756 9.72253C5.6193 7.56951 7.56951 5.6193 9.72253 6.15756C10.2945 6.30055 10.8116 6.56279 11.25 6.91376V2.75028ZM2.75028 12.75C2.75238 14.7437 2.77054 16.2273 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.77266 21.2295 9.25629 21.2476 11.25 21.2497V14.1236C10.4704 15.6809 8.86003 16.75 7 16.75C6.58579 16.75 6.25 16.4142 6.25 16C6.25 15.5858 6.58579 15.25 7 15.25C8.53679 15.25 9.82445 14.1834 10.163 12.75H10.0351L10.0259 12.75H2.75028ZM12.75 21.2497C14.7437 21.2476 16.2273 21.2295 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2295 16.2273 21.2476 14.7437 21.2497 12.75H13.9741L13.9649 12.75H13.837C14.1756 14.1834 15.4632 15.25 17 15.25C17.4142 15.25 17.75 15.5858 17.75 16C17.75 16.4142 17.4142 16.75 17 16.75C15.14 16.75 13.5296 15.6809 12.75 14.1236V21.2497ZM21.2497 11.25H17.0863C17.4372 10.8116 17.6995 10.2945 17.8425 9.72253C18.3807 7.56951 16.4305 5.6193 14.2775 6.15756C13.7055 6.30055 13.1884 6.56279 12.75 6.91376V2.75028C14.7437 2.75238 16.2273 2.77054 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2295 7.77266 21.2476 9.25629 21.2497 11.25ZM12.75 11.25L12.75 10.0291C12.7527 8.88589 13.5317 7.89017 14.6413 7.61277C15.6957 7.34916 16.6509 8.30428 16.3872 9.35872C16.1099 10.4679 15.1149 11.2467 13.9722 11.25H12.75ZM11.25 10.0275C11.2466 8.88494 10.4678 7.89004 9.35872 7.61277C8.30428 7.34916 7.34916 8.30428 7.61277 9.35872C7.89006 10.4679 8.88513 11.2467 10.0278 11.25H11.25V10.0275Z",
        fill: t
      }
    )
  }
), tOe = (t) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 9.30277V8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8V9.30277C18.9768 9.31872 19.1906 9.33948 19.3918 9.36652C20.2919 9.48754 21.0497 9.74643 21.6517 10.3483C22.2536 10.9503 22.5125 11.7081 22.6335 12.6082C22.75 13.4752 22.75 14.5775 22.75 15.9451V16.0549C22.75 17.4225 22.75 18.5248 22.6335 19.3918C22.5125 20.2919 22.2536 21.0497 21.6517 21.6516C21.0497 22.2536 20.2919 22.5125 19.3918 22.6335C18.5248 22.75 17.4225 22.75 16.0549 22.75H7.94513C6.57754 22.75 5.47522 22.75 4.60825 22.6335C3.70814 22.5125 2.95027 22.2536 2.34835 21.6516C1.74643 21.0497 1.48754 20.2919 1.36652 19.3918C1.24996 18.5248 1.24998 17.4225 1.25 16.0549V15.9451C1.24998 14.5775 1.24996 13.4752 1.36652 12.6082C1.48754 11.7081 1.74643 10.9503 2.34835 10.3483C2.95027 9.74643 3.70814 9.48754 4.60825 9.36652C4.80938 9.33948 5.02317 9.31872 5.25 9.30277ZM6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V9.25344C16.8765 9.24999 16.4784 9.24999 16.0549 9.25H7.94513C7.52161 9.24999 7.12353 9.24999 6.75 9.25344V8ZM3.40901 11.409C3.68577 11.1322 4.07435 10.9518 4.80812 10.8531C5.56347 10.7516 6.56459 10.75 8 10.75H16C17.4354 10.75 18.4365 10.7516 19.1919 10.8531C19.9257 10.9518 20.3142 11.1322 20.591 11.409C20.8678 11.6858 21.0482 12.0743 21.1469 12.8081C21.2484 13.5635 21.25 14.5646 21.25 16C21.25 17.4354 21.2484 18.4365 21.1469 19.1919C21.0482 19.9257 20.8678 20.3142 20.591 20.591C20.3142 20.8678 19.9257 21.0482 19.1919 21.1469C18.4365 21.2484 17.4354 21.25 16 21.25H8C6.56459 21.25 5.56347 21.2484 4.80812 21.1469C4.07435 21.0482 3.68577 20.8678 3.40901 20.591C3.13225 20.3142 2.9518 19.9257 2.85315 19.1919C2.75159 18.4365 2.75 17.4354 2.75 16C2.75 14.5646 2.75159 13.5635 2.85315 12.8081C2.9518 12.0743 3.13225 11.6858 3.40901 11.409Z",
        fill: "#B9B9B9"
      }
    )
  }
), rOe = ({
  title: t,
  islockedIcon: e,
  metricCount: r,
  progressbarPercent: n,
  progressData: A,
  themeManager: i,
  completedActionIcon: o,
  xp: s,
  showCoin: a,
  completed: c
}) => {
  const l = i.getIconStyles();
  return /* @__PURE__ */ k("div", { className: "q_challenges_inner_card_main_cont", children: [
    /* @__PURE__ */ h(
      "div",
      {
        style: { background: n ? "#F4EBFF" : "#EFEFEF" },
        className: "q_challenges_icon_main_cont",
        children: c ? o || hP(l) : e === "challengesIcon1" ? hP(l) : tOe()
      }
    ),
    /* @__PURE__ */ k("div", { className: "q_challenges_inner_card_name_cont", children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: i.getHeadingStyles(),
          className: "q_challenges_inner_card_name_head",
          children: t
        }
      ),
      /* @__PURE__ */ h("div", { className: "q_challenges_inner_card_progressbar", children: /* @__PURE__ */ h(
        "div",
        {
          style: {
            width: `${n}%`,
            background: i.getProgressBarColorStyles()
          },
          className: "q_challenges_inner_card_progressbar_inner"
        }
      ) }),
      /* @__PURE__ */ h(
        "div",
        {
          style: i.getPointsColorStyles(n),
          className: "q_challenges_inner_card_trips",
          children: n < 100 ? `${Number(r) - A} Points Left` : "Completed"
        }
      )
    ] }),
    a && s && s > 0 && !c ? /* @__PURE__ */ k("div", { className: "q_challenges_inner_card_points_cont", children: [
      /* @__PURE__ */ h("img", { src: Ta, alt: "coin" }),
      /* @__PURE__ */ h("p", { className: "q_challenges_inner_card_points", children: s })
    ] }) : null,
    a && s && s > 0 && c ? /* @__PURE__ */ h("div", { className: "q_challenges_inner_card_completed_cont", children: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "9", height: "6", viewBox: "0 0 9 6", fill: "none", children: /* @__PURE__ */ h(
      "path",
      {
        d: "M8.07574 0.697209C8.36863 0.990102 8.36863 1.46498 8.07574 1.75787L4.07574 5.75787C3.78707 6.04655 3.32052 6.05131 3.02601 5.76858L1.02601 3.84858C0.727204 3.56172 0.717515 3.08695 1.00437 2.78814C1.29123 2.48933 1.766 2.47964 2.06481 2.7665L3.5347 4.17759L7.01508 0.697209C7.30797 0.404316 7.78285 0.404316 8.07574 0.697209Z",
        fill: "#098849"
      }
    ) }) }) : null
  ] });
}, nOe = ({
  suggestions: t,
  setSearchTerm: e,
  themeManager: r,
  completedActionIcon: n,
  showCoin: A,
  campaignXp: i
}) => {
  const o = (s) => {
    e(s.target.value);
  };
  return /* @__PURE__ */ k(
    "div",
    {
      style: r.getChallengesCardStyles(),
      className: "q_challenges_card_cont_main",
      children: [
        /* @__PURE__ */ k("div", { className: "q_challenges_card_sub_heading_cont", children: [
          /* @__PURE__ */ h(
            "div",
            {
              style: r.getHeadingStyles(),
              className: "q_challenges_card_heading",
              children: "Task List"
            }
          ),
          A === !0 && i && i > 0 && /* @__PURE__ */ k("div", { className: "q_challenges_inner_card_points_cont", children: [
            /* @__PURE__ */ h("img", { src: Ta, alt: "coin" }),
            /* @__PURE__ */ h("p", { className: "q_challenges_inner_card_points", children: i })
          ] })
        ] }),
        /* @__PURE__ */ k(
          "div",
          {
            className: "q_challenges_card_input_cont",
            style: r.getSearchStyles(),
            children: [
              /* @__PURE__ */ h(
                "input",
                {
                  onChange: o,
                  className: "q_challenges_card_input",
                  placeholder: "Search for tasks...",
                  style: r.getSearchColorStyles()
                }
              ),
              /* @__PURE__ */ h("img", { src: fb, alt: fb })
            ]
          }
        ),
        /* @__PURE__ */ h("div", { className: "q_challenges_card_cont", children: t.map((s) => /* @__PURE__ */ h(
          rOe,
          {
            title: s.title,
            islockedIcon: s.progressPercent ? "challengesIcon1" : "challengesLock",
            metricCount: s.metricCount,
            progressbarPercent: s.progressPercent,
            progressData: s.progressData,
            isLocked: s.isLocked,
            themeManager: r,
            completed: s.completed || !1,
            completedActionIcon: n,
            xp: (s == null ? void 0 : s.xp) || 0,
            showCoin: A
          },
          s == null ? void 0 : s.actionId
        )) })
      ]
    }
  );
}, sj = ({
  suggestions: t,
  setSearchTerm: e,
  themeManager: r,
  showCoin: n,
  completedActionIcon: A,
  campaignXp: i
}) => /* @__PURE__ */ k(
  "div",
  {
    style: r.getFormStyles(),
    className: "q_challenges_main_cont",
    children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: r == null ? void 0 : r.getMainHeadingStyles(),
          className: "q_challenges_main_heading",
          children: "Challenges"
        }
      ),
      /* @__PURE__ */ k("div", { className: "q_challenges_card_main_container", children: [
        /* @__PURE__ */ h("div", { className: "q_top_challenges_card_main_cont", children: /* @__PURE__ */ h("div", { className: "q_top_challenges_card_img", children: /* @__PURE__ */ h("img", { src: Ete, alt: "Challenges Badge" }) }) }),
        /* @__PURE__ */ h(
          nOe,
          {
            suggestions: t,
            setSearchTerm: e,
            themeManager: r,
            completedActionIcon: A,
            showCoin: n,
            campaignXp: i
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "q_footer_challenges", children: /* @__PURE__ */ h(
        Pr,
        {
          style: r.getFooterStyles(),
          textStyle: r.getFooterTextStyle(),
          iconStyle: r.getFooterIconStyles(),
          text: r.getFooterText(),
          link: r.getFooterLinkStyles()
        }
      ) })
    ]
  }
);
let aj = class {
  constructor(e = {}, r = {}, n = {}, A = {}) {
    ke(this, "brandTheme");
    ke(this, "styleConfig");
    ke(this, "themeConfig");
    ke(this, "questThemeData");
    this.brandTheme = e, this.styleConfig = r, this.themeConfig = n, this.questThemeData = A;
  }
  getMainHeadingStyles() {
    var e, r, n, A;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.MainHeading) == null ? void 0 : r.color) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor),
      ...(A = this.styleConfig) == null ? void 0 : A.MainHeading
    };
  }
  getHeadingStyles() {
    var e, r, n;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor)
      // ...this.styleConfig?.Heading,
    };
  }
  getPointsColorStyles(e) {
    var r, n;
    return {
      color: e ? ((n = (r = this.styleConfig) == null ? void 0 : r.PointsColor) == null ? void 0 : n.color) || "#9035FF" : "#B9B9B9"
    };
  }
  getProgressBarColorStyles() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.ProgressBarColor) == null ? void 0 : r.background) || "#9035FF";
  }
  getSearchStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      background: (r = (e = this.styleConfig) == null ? void 0 : e.Search) != null && r.background ? (A = (n = this.styleConfig) == null ? void 0 : n.Search) == null ? void 0 : A.background : "",
      color: (o = (i = this.styleConfig) == null ? void 0 : i.Search) != null && o.color ? (a = (s = this.styleConfig) == null ? void 0 : s.Search) == null ? void 0 : a.color : ""
    };
  }
  getSearchColorStyles() {
    var e, r, n, A;
    return {
      color: (r = (e = this.styleConfig) == null ? void 0 : e.Search) != null && r.color ? (A = (n = this.styleConfig) == null ? void 0 : n.Search) == null ? void 0 : A.color : ""
    };
  }
  getFormStyles() {
    var e, r, n, A, i, o;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.themeConfig) == null ? void 0 : n.backgroundColor),
      fontFamily: ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.fontFamily) || this.themeConfig.fontFamily,
      ...(o = this.styleConfig) == null ? void 0 : o.Form
    };
  }
  getChallengesCardStyles() {
    var e, r, n;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.InnerBackground) == null ? void 0 : r.background) || ((n = this.themeConfig) == null ? void 0 : n.backgroundColor)
      // this.brandTheme?.background ||
      // this.questThemeData?.InnerBackground?.background,
    };
  }
  getLabelStyles() {
    var e, r, n, A;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Label) == null ? void 0 : r.color) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor),
      ...(A = this.styleConfig) == null ? void 0 : A.Label
    };
  }
  getIconStyles() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.IconStyle) == null ? void 0 : r.color) || "#9035FF";
  }
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.background) || ((a = this.themeConfig) == null ? void 0 : a.backgroundColor),
      ...(l = (c = this.styleConfig) == null ? void 0 : c.Footer) == null ? void 0 : l.FooterStyle
    };
  }
  getFooterIconStyles() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterIcon) || {};
  }
  getFooterLinkStyles() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterLink) || "";
  }
  getFooterTextStyle() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterTextStyle) || {};
  }
  getFooterText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterText) || "";
  }
};
const VFe = ({
  userId: t,
  token: e,
  questId: r,
  styleConfig: n,
  enableVariation: A,
  uniqueUserId: i,
  uniqueEmailId: o,
  isLoader: s,
  loaderComponent: a,
  showCoin: c,
  completedActionIcon: l
}) => {
  const { apiKey: u, apiSecret: f, entityId: d, apiType: g, themeConfig: m } = Xe(
    ct.Context
  );
  let p = new Bt("mixpanel", g);
  const [v, C] = N([]), [w, B] = N([]), [y, b] = N(""), [q, E] = N(!0), [x, M] = N(null), [O, I] = N(!1), [S, P] = N(!1), [H, F] = N(t || ""), [T, U] = N(e || ""), [D, Q] = N(""), [Y, j] = N(0), [Z, W] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }), [R, K] = N({
    accentColor: "",
    background: "",
    borderRadius: "",
    buttonColor: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }), L = new aj(
    R,
    n,
    m,
    Z
  ), G = g === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  le(() => {
    (async () => {
      try {
        E(!0);
        let J = await _ke({
          BACKEND_URL: G,
          apiKey: u,
          entityId: d,
          uniqueUserId: i,
          uniqueEmailId: o,
          userId: t,
          token: e,
          GeneralFunctions: p
        });
        F((J == null ? void 0 : J.userId) || ""), U((J == null ? void 0 : J.token) || ""), await $ke({
          BACKEND_URL: G,
          apiKey: u,
          apiSecret: f,
          entityId: d,
          questId: r,
          enableVariation: A,
          userId: J == null ? void 0 : J.userId,
          token: J == null ? void 0 : J.token,
          uniqueUserId: i,
          uniqueEmailId: o,
          setCriterias: C,
          setQuestThemeData: W,
          setBrandTheme: K,
          GeneralFunctions: p,
          setCampaignVariationId: Q,
          setIsVerify: P,
          setClaimStatus: M,
          setCampaignXp: j
        });
      } finally {
        E(!1);
      }
    })();
  }, []);
  const V = async () => {
    const _ = g === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
    p.fireTrackingEvent(
      "quest_challenges_verification",
      "gamifiedquiz"
    ), I(!0);
    try {
      let X = await eOe({
        BACKEND_URL: _,
        apiKey: u,
        apiSecret: f,
        entityId: d,
        questId: r,
        criterias: v,
        userId: H,
        token: T,
        campaignVariationId: D,
        GeneralFunctions: p
      });
      !(X != null && X.failedCriterias) || (X == null ? void 0 : X.failedCriterias.length) === 0 ? C(v.map((ne) => ({ ...ne, completed: !0 }))) : C(
        v.map((ne) => ({
          ...ne,
          completed: !(X != null && X.failedCriterias.includes(ne.actionId))
        }))
      );
    } catch (J) {
      p.captureSentryException(J), console.error("Error during verification:", J);
    }
  };
  return le(() => {
    const _ = v.filter(
      (J) => J.title && J.title.toLowerCase().includes(y.toLowerCase())
    );
    B(_);
  }, [y, v]), le(() => {
    v.length > 0 && x !== null && x !== !0 && O == !1 && S && V();
  }, [v]), q ? s ? a || /* @__PURE__ */ h("div", { children: "Loading..." }) : null : /* @__PURE__ */ h("div", { children: w && /* @__PURE__ */ h(
    sj,
    {
      suggestions: w,
      setSearchTerm: b,
      themeManager: L,
      completedActionIcon: l,
      showCoin: c,
      campaignXp: Y
    }
  ) });
}, WFe = ({
  styleConfig: t,
  offlineFormData: e = []
}) => {
  const { themeConfig: r } = Xe(ct.Context), [n, A] = N([]), [i, o] = N(""), [s, a] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }), [c, l] = N({
    accentColor: "",
    background: "",
    borderRadius: "",
    buttonColor: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }), u = new aj(
    c,
    t || {},
    r || {},
    s
  );
  return le(() => {
    let f = e.filter(
      (d) => d.title && d.title.toLowerCase().includes(i.toLowerCase())
    );
    A(f);
  }, [i, e]), /* @__PURE__ */ h("div", { children: n && /* @__PURE__ */ h(
    sj,
    {
      suggestions: n,
      setSearchTerm: o,
      themeManager: u
    }
  ) });
};
function XFe(t) {
  var Z, W, R, K;
  const {
    getAnswers: e,
    answer: r,
    setAnswer: n,
    customComponents: A,
    customComponentPositions: i,
    userId: o,
    token: s,
    questId: a,
    loadingTracker: c,
    setLoading: l = () => {
    },
    uniqueUserId: u,
    uniqueEmailId: f,
    styleConfig: d,
    variation: g
  } = t, [m, p] = N([]), [v, C] = N(!1), { apiKey: w, apiSecret: B, entityId: y, apiType: b, themeConfig: q } = Xe(ct.Context), [E, x] = N(""), [M, O] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }), I = new zn();
  let S = b == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, P = new Bt("mixpanel", b);
  const H = (L, G) => {
    const V = async (_) => {
      const J = `${S}api/entities/${y}/metrics/${_}/campaign`, X = await Oe.post(J, { campaignId: a, campaignVariationId: E, ...G }, { headers: L });
      if (X.status && X.data.success) return X;
      throw X.statusText;
    };
    return {
      async view() {
        return V("onboarding-view");
      },
      async page(_) {
        return V(`onboarding-complete-page-${_}`);
      },
      async complete() {
        return V("onboarding-complete");
      }
    };
  };
  le(() => {
    P.fireTrackingEvent("quest_onboarding_loaded", "onboarding"), y && (async () => {
      let G = I.get("externalUserId"), V = I.get("questUserId"), _ = I.get("questUserToken");
      const J = {
        externalUserId: !!u && u,
        entityId: y,
        email: f
      };
      let X = {
        apiKey: w,
        apisecret: B,
        userId: o,
        token: s
      };
      if (G && V && _ && G == u)
        X.userId = V, X.token = _;
      else if (u) {
        const $ = await Oe.post(`${S}api/users/external/login`, J, { headers: X });
        let { userId: te, token: ae } = $.data;
        const se = /* @__PURE__ */ new Date();
        se.setHours(se.getHours() + 12), I.set("externalUserId", u, {
          path: "/",
          expires: se
        }), I.set("questUserId", te, { path: "/", expires: se }), I.set("questUserToken", ae, { path: "/", expires: se }), X.userId = te, X.token = ae;
      }
      const ne = await ee(o, X);
      H(X, { campaignVariationId: ne.data.campaignVariationId }).view();
      async function ee($, te) {
        c && l(!0);
        const ae = new URLSearchParams();
        ae.set("platform", "REACT"), g && ae.set("variation", g);
        const se = `${S}api/v2/entities/${y}/campaigns/${a}?${ae.toString()}`;
        return await Oe.get(se, { headers: te }).then((ue) => {
          var oe, ce, pe, qe, Se, Te, be, He, Ge, Le;
          let fe = ue.data;
          (ce = (oe = fe.data.sdkConfig) == null ? void 0 : oe.uiProps) != null && ce.questThemeData && (O((Se = (qe = (pe = fe == null ? void 0 : fe.data) == null ? void 0 : pe.sdkConfig) == null ? void 0 : qe.uiProps) == null ? void 0 : Se.questThemeData), (be = (Te = fe.data.sdkConfig) == null ? void 0 : Te.uiProps) != null && be.questThemeData.theme), x((He = fe == null ? void 0 : fe.data) == null ? void 0 : He.campaignVariationId);
          let ve = (Le = (Ge = fe == null ? void 0 : fe.data) == null ? void 0 : Ge.actions) == null ? void 0 : Le.map(
            (Ae) => {
              var Pe, it, de;
              return {
                type: Ae == null ? void 0 : Ae.actionType,
                question: Ae == null ? void 0 : Ae.title,
                options: (Ae == null ? void 0 : Ae.options) || [],
                actionId: Ae == null ? void 0 : Ae.actionId,
                campaignVariationId: Ae == null ? void 0 : Ae.campaignVariationId,
                required: Ae == null ? void 0 : Ae.isRequired,
                placeholder: (Pe = Ae == null ? void 0 : Ae.metadata) == null ? void 0 : Pe.placeholder,
                linkTitle: (Ae == null ? void 0 : Ae.title) || "",
                linkUrl: ((it = Ae == null ? void 0 : Ae.metadata) == null ? void 0 : it.link) || "",
                manualInput: !!((de = Ae == null ? void 0 : Ae.metadata) != null && de.manualInput),
                answer: (Ae == null ? void 0 : Ae.answers) || ""
              };
            }
          );
          p([...ve]);
          let ge = {};
          return ve.forEach((Ae) => {
            var Pe, it;
            if (console.log(Ae), Ae.type == "USER_INPUT_MULTI_CHOICE") {
              r[Ae.actionId] || (ge[Ae.actionId] = ((Pe = Ae == null ? void 0 : Ae.answer) == null ? void 0 : Pe.length) > 0 ? Ae.answer : []);
              return;
            } else {
              r[Ae.actionId] || (ge[Ae.actionId] = ((it = Ae == null ? void 0 : Ae.answer) == null ? void 0 : it.length) > 0 ? Ae.answer[0] : "");
              return;
            }
          }), console.log(ge), n({ ...r, ...ge }), fe;
        }).catch((ue) => {
          P.captureSentryException(ue);
        });
      }
    })();
  }, []), console.log(r);
  const F = (L, G, V) => {
    if (L.target.checked == !0 && V == "check") {
      let _ = r[G] || [];
      _.push(L.target.value), n({
        ...r,
        [G]: _
      });
    } else if (L.target.checked == !1 && typeof r[G] == "object" && V == "check") {
      let J = r[G].filter(
        (X) => X != L.target.value
      );
      n({
        ...r,
        [G]: J
      });
    } else
      n({
        ...r,
        [G]: L.target.value
      });
  }, T = (L, G, V, _, J, X) => {
    var ne, ee, $, te;
    return /* @__PURE__ */ k("div", { children: [
      i == _ + 1 && /* @__PURE__ */ h("div", { style: { paddingBottom: "12px" }, children: A }),
      /* @__PURE__ */ h(WA, { htmlFor: "normalInput", style: { color: ((ne = d == null ? void 0 : d.Label) == null ? void 0 : ne.color) || (q == null ? void 0 : q.primaryColor), ...d == null ? void 0 : d.Label }, children: `${L} ${!!G && "*"}` }),
      /* @__PURE__ */ h(
        Li,
        {
          type: X,
          placeholder: J,
          value: r[V],
          iconColor: ((ee = d == null ? void 0 : d.Input) == null ? void 0 : ee.color) || (q == null ? void 0 : q.primaryColor) || "#B9B9B9",
          onChange: (ae) => F(ae, V, ""),
          style: {
            borderColor: (($ = d == null ? void 0 : d.Input) == null ? void 0 : $.borderColor) || (q == null ? void 0 : q.borderColor),
            color: ((te = d == null ? void 0 : d.Input) == null ? void 0 : te.color) || (q == null ? void 0 : q.primaryColor),
            ...d == null ? void 0 : d.Input
          }
        }
      )
    ] }, V);
  }, U = (L, G, V, _, J) => {
    var X, ne, ee;
    return /* @__PURE__ */ k("div", { children: [
      i == _ + 1 && /* @__PURE__ */ h("div", { style: { paddingBottom: "12px" }, children: A }),
      /* @__PURE__ */ h(WA, { htmlFor: "dateInput", style: { color: ((X = d == null ? void 0 : d.Label) == null ? void 0 : X.color) || (q == null ? void 0 : q.primaryColor), ...d == null ? void 0 : d.Label }, children: `${L} ${!!G && "*"}` }),
      /* @__PURE__ */ h(
        Li,
        {
          type: "date",
          placeholder: J,
          value: r[V],
          onChange: ($) => F($, V, ""),
          style: {
            borderColor: ((ne = d == null ? void 0 : d.Input) == null ? void 0 : ne.borderColor) || (q == null ? void 0 : q.borderColor),
            color: ((ee = d == null ? void 0 : d.Input) == null ? void 0 : ee.color) || (q == null ? void 0 : q.primaryColor),
            ...d == null ? void 0 : d.Input
          }
        }
      )
    ] }, V);
  }, D = (L, G, V, _, J) => {
    var X, ne, ee;
    return /* @__PURE__ */ k("div", { children: [
      i == _ + 1 && /* @__PURE__ */ h("div", { style: { paddingBottom: "12px" }, children: A }),
      /* @__PURE__ */ h(WA, { htmlFor: "textAreaInput", style: { color: ((X = d == null ? void 0 : d.Label) == null ? void 0 : X.color) || (q == null ? void 0 : q.primaryColor), ...d == null ? void 0 : d.Label }, children: `${L} ${!!G && "*"}` }),
      /* @__PURE__ */ h(
        b4,
        {
          onChange: ($) => F($, V, ""),
          placeholder: J,
          value: r[V],
          style: {
            borderColor: ((ne = d == null ? void 0 : d.TextArea) == null ? void 0 : ne.borderColor) || (q == null ? void 0 : q.borderColor),
            color: ((ee = d == null ? void 0 : d.TextArea) == null ? void 0 : ee.color) || (q == null ? void 0 : q.primaryColor),
            ...d == null ? void 0 : d.TextArea
          }
        }
      )
    ] }, V);
  }, Q = (L, G, V, _, J, X, ne) => {
    var ee, $, te, ae, se, ue, fe, ve, ge, oe, ce;
    return /* @__PURE__ */ k("div", { children: [
      i == J + 1 && /* @__PURE__ */ h("div", { style: { paddingBottom: "12px" }, children: A }),
      /* @__PURE__ */ h(WA, { htmlFor: "textAreaInput", style: { color: ((ee = d == null ? void 0 : d.Label) == null ? void 0 : ee.color) || (q == null ? void 0 : q.primaryColor), ...d == null ? void 0 : d.Label }, children: `${G} ${!!V && "*"}` }),
      /* @__PURE__ */ h(
        _N,
        {
          options: L,
          type: ne,
          onChange: (pe) => F({ target: pe }, _, ""),
          checked: r[_],
          style: {
            borderColor: ((te = ($ = d == null ? void 0 : d.SingleChoice) == null ? void 0 : $.style) == null ? void 0 : te.borderColor) || (q == null ? void 0 : q.borderColor),
            color: ((se = (ae = d == null ? void 0 : d.SingleChoice) == null ? void 0 : ae.style) == null ? void 0 : se.color) || (q == null ? void 0 : q.secondaryColor),
            ...(ue = d == null ? void 0 : d.SingleChoice) == null ? void 0 : ue.style
          },
          selectedStyle: {
            accentColor: ((ve = (fe = d == null ? void 0 : d.SingleChoice) == null ? void 0 : fe.selectedStyle) == null ? void 0 : ve.accentColor) || (q == null ? void 0 : q.primaryColor),
            ...(ge = d == null ? void 0 : d.SingleChoice) == null ? void 0 : ge.selectedStyle
          }
        }
      ),
      X != !1 && r[_] == X && /* @__PURE__ */ h(
        Li,
        {
          type: "text",
          onChange: (pe) => F(pe, _ + "/manual", ""),
          value: r[_ + "/manual"],
          placeholder: "Please fill manually",
          style: {
            borderColor: ((oe = d == null ? void 0 : d.Input) == null ? void 0 : oe.borderColor) || (q == null ? void 0 : q.borderColor),
            color: ((ce = d == null ? void 0 : d.Input) == null ? void 0 : ce.color) || (q == null ? void 0 : q.primaryColor),
            ...d == null ? void 0 : d.Input
          }
        }
      )
    ] }, _);
  }, Y = (L, G, V, _, J) => {
    var X, ne, ee, $, te, ae, se, ue, fe, ve;
    return /* @__PURE__ */ k("div", { children: [
      i == J + 1 && /* @__PURE__ */ h("div", { style: { paddingBottom: "12px" }, children: A }),
      /* @__PURE__ */ h(WA, { htmlFor: "textAreaInput", style: { color: ((X = d == null ? void 0 : d.Label) == null ? void 0 : X.color) || (q == null ? void 0 : q.primaryColor), ...d == null ? void 0 : d.Label }, children: `${G} ${!!V && "*"}` }),
      /* @__PURE__ */ h(
        $N,
        {
          options: L,
          checked: !!r[_] && r[_],
          onChange: (ge) => F(ge, _, "check"),
          style: {
            borderColor: ((ee = (ne = d == null ? void 0 : d.MultiChoice) == null ? void 0 : ne.style) == null ? void 0 : ee.borderColor) || (q == null ? void 0 : q.borderColor),
            ...($ = d == null ? void 0 : d.MultiChoice) == null ? void 0 : $.style,
            color: ((ae = (te = d == null ? void 0 : d.MultiChoice) == null ? void 0 : te.style) == null ? void 0 : ae.color) || (q == null ? void 0 : q.primaryColor),
            ...(se = d == null ? void 0 : d.MultiChoice) == null ? void 0 : se.style
          },
          selectedStyle: {
            color: ((fe = (ue = d == null ? void 0 : d.MultiChoice) == null ? void 0 : ue.selectedStyle) == null ? void 0 : fe.color) || (q == null ? void 0 : q.primaryColor),
            ...(ve = d == null ? void 0 : d.MultiChoice) == null ? void 0 : ve.selectedStyle
          }
        }
      )
    ] }, _);
  };
  function j() {
    P.fireTrackingEvent(
      "quest_onboarding_submit_btn_clicked",
      "onboarding"
    );
    let L = { ...r };
    for (let ne of Object.keys(L))
      if (ne.includes("/manual") && L[ne] != "") {
        let ee = ne.split("/manual")[0];
        m.filter(
          (te) => te.actionId == ee
        )[0].manualInput == L[ee] && (L[ee] = L[ne]);
      }
    let G = Object.keys(L).filter((ne) => !ne.includes("/manual")).map((ne) => ({
      actionId: ne,
      answers: typeof L[ne] == "object" ? L[ne] : [L[ne]]
    })), V = I.get("questUserId"), _ = I.get("questUserToken"), J = I.get("externalUserId"), X = {
      apikey: w,
      apisecret: B,
      userId: J && V && _ && J == u ? V : o,
      token: J && V && _ && J == u ? _ : s
    };
    e && e(L);
    try {
      Oe.post(
        `${S}api/v2/entities/${y}/campaigns/${a}/verify?editSubmissionCriteria=true`,
        { actions: G, campaignVariationId: E },
        { headers: X }
      );
    } catch (ne) {
      P.captureSentryException(ne);
    }
    try {
      H(X).complete();
    } catch (ne) {
      P.captureSentryException(ne);
    }
  }
  return m.length > 0 && /* @__PURE__ */ h("div", { className: "q-prof_home", style: {
    background: ((Z = d == null ? void 0 : d.Form) == null ? void 0 : Z.backgroundColor) || (q == null ? void 0 : q.backgroundColor) || "#fff",
    height: ((W = d == null ? void 0 : d.Form) == null ? void 0 : W.height) || "auto",
    fontFamily: q.fontFamily || "'Figtree', sans-serif",
    ...d == null ? void 0 : d.Form
  }, children: /* @__PURE__ */ k(
    "div",
    {
      className: "q-prof_ch",
      children: [
        m.length > 0 && /* @__PURE__ */ h("div", { className: "q-prof_main-first", children: m == null ? void 0 : m.map(
          (L, G) => L.type == "USER_INPUT_TEXT" ? T(
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G,
            (L == null ? void 0 : L.placeholder) || (L == null ? void 0 : L.question) || "",
            "text"
          ) : L.type == "USER_INPUT_EMAIL" ? T(
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G,
            (L == null ? void 0 : L.placeholder) || (L == null ? void 0 : L.question) || "",
            "email"
          ) : L.type == "USER_INPUT_PHONE" ? T(
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G,
            (L == null ? void 0 : L.placeholder) || (L == null ? void 0 : L.question) || "",
            "number"
          ) : L.type == "USER_INPUT_DATE" ? U(
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G,
            (L == null ? void 0 : L.placeholder) || (L == null ? void 0 : L.question) || ""
          ) : L.type == "USER_INPUT_SINGLE_CHOICE" ? Q(
            L.options || [],
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G,
            L == null ? void 0 : L.manualInput,
            "modal3"
          ) : null
        ) }),
        /* @__PURE__ */ k("div", { className: "q-prof_main-second", children: [
          m == null ? void 0 : m.map((L, G) => L.type == "USER_INPUT_MULTI_CHOICE" ? Y(
            L.options || [],
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G
          ) : null),
          m == null ? void 0 : m.map((L, G) => L.type == "USER_INPUT_TEXTAREA" ? D(
            (L == null ? void 0 : L.question) || "",
            (L == null ? void 0 : L.required) || !1,
            L.actionId || "",
            G,
            (L == null ? void 0 : L.placeholder) || (L == null ? void 0 : L.question) || ""
          ) : null),
          m.length > 0 && /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
            yr,
            {
              className: "q-prof_main-btn3",
              onClick: j,
              style: {
                border: ((R = d == null ? void 0 : d.SecondaryButton) == null ? void 0 : R.border) || "1.5px solid #afafaf",
                background: ((K = d == null ? void 0 : d.PrimaryButton) == null ? void 0 : K.background) || (q == null ? void 0 : q.buttonColor),
                ...d == null ? void 0 : d.PrimaryButton
              },
              children: v ? "Update Profile" : "Submit"
            }
          ) })
        ] })
      ]
    }
  ) });
}
const cj = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='150'%20height='150'%20viewBox='0%200%20150%20150'%20fill='none'%3e%3cpath%20d='M112.5%2025H37.5C27.1447%2025%2018.75%2033.3947%2018.75%2043.75V118.75C18.75%20129.105%2027.1447%20137.5%2037.5%20137.5H112.5C122.855%20137.5%20131.25%20129.105%20131.25%20118.75V43.75C131.25%2033.3947%20122.855%2025%20112.5%2025Z'%20fill='%23BF8AFF'/%3e%3cpath%20d='M93.75%2081.25H56.25C54.5924%2081.25%2053.0027%2080.5915%2051.8306%2079.4194C50.6585%2078.2473%2050%2076.6576%2050%2075C50%2073.3424%2050.6585%2071.7527%2051.8306%2070.5806C53.0027%2069.4085%2054.5924%2068.75%2056.25%2068.75H93.75C95.4076%2068.75%2096.9973%2069.4085%2098.1694%2070.5806C99.3415%2071.7527%20100%2073.3424%20100%2075C100%2076.6576%2099.3415%2078.2473%2098.1694%2079.4194C96.9973%2080.5915%2095.4076%2081.25%2093.75%2081.25ZM93.75%20106.25H56.25C54.5924%20106.25%2053.0027%20105.592%2051.8306%20104.419C50.6585%20103.247%2050%20101.658%2050%20100C50%2098.3424%2050.6585%2096.7527%2051.8306%2095.5806C53.0027%2094.4085%2054.5924%2093.75%2056.25%2093.75H93.75C95.4076%2093.75%2096.9973%2094.4085%2098.1694%2095.5806C99.3415%2096.7527%20100%2098.3424%20100%20100C100%20101.658%2099.3415%20103.247%2098.1694%20104.419C96.9973%20105.592%2095.4076%20106.25%2093.75%20106.25Z'%20fill='white'/%3e%3cpath%20d='M87.5%2012.5H62.5C57.5272%2012.5%2052.7581%2014.4754%2049.2417%2017.9917C45.7254%2021.5081%2043.75%2026.2772%2043.75%2031.25C43.75%2036.2228%2045.7254%2040.9919%2049.2417%2044.5083C52.7581%2048.0246%2057.5272%2050%2062.5%2050H87.5C92.4728%2050%2097.2419%2048.0246%20100.758%2044.5083C104.275%2040.9919%20106.25%2036.2228%20106.25%2031.25C106.25%2026.2772%20104.275%2021.5081%20100.758%2017.9917C97.2419%2014.4754%2092.4728%2012.5%2087.5%2012.5Z'%20fill='%236525B3'/%3e%3c/svg%3e", AOe = (t = "#B9B9B9") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
        fill: t
      }
    )
  }
), iOe = (t = "#9035FF") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z",
        fill: t
      }
    )
  }
), oOe = (t = "#B9B9B9") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z",
        fill: t
      }
    )
  }
), sOe = (t = "#9035FF") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z",
        fill: t
      }
    )
  }
), aOe = (t = "#B9B9B9") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M4.50513 11.4957L8.00046 8.00034L11.4958 11.4957M11.4958 4.505L7.99979 8.00034L4.50513 4.505",
        stroke: t,
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    )
  }
), lj = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_6585_146)'%3e%3cpath%20d='M40%2080C62.0914%2080%2080%2062.0914%2080%2040C80%2017.9086%2062.0914%200%2040%200C17.9086%200%200%2017.9086%200%2040C0%2062.0914%2017.9086%2080%2040%2080Z'%20fill='url(%23paint0_linear_6585_146)'/%3e%3cpath%20d='M48.4167%2079.0566C49.1837%2078.9078%2049.9463%2078.7367%2050.7033%2078.5432C51.987%2078.1844%2053.2519%2077.7617%2054.4933%2077.2766C55.7363%2076.7955%2056.9545%2076.2526%2058.1433%2075.6499C59.3325%2075.0449%2060.4906%2074.3807%2061.6133%2073.6599C62.7348%2072.939%2063.8195%2072.1625%2064.8633%2071.3332C65.9091%2070.5029%2066.9125%2069.6207%2067.87%2068.6899C68.8259%2067.7614%2069.7348%2066.7858%2070.5933%2065.7666C71.4526%2064.7465%2072.2603%2063.684%2073.0133%2062.5832C73.7662%2061.4843%2074.4638%2060.3484%2075.1033%2059.1799C75.743%2058.0097%2076.3237%2056.8082%2076.8433%2055.5799C77.3635%2054.3514%2077.8218%2053.0976%2078.2167%2051.8232C78.5548%2050.7075%2078.8439%2049.5776%2079.0833%2048.4366L55.3167%2024.6732C53.3096%2022.6573%2050.9236%2021.0581%2048.2961%2019.9677C45.6686%2018.8774%2042.8514%2018.3174%2040.0067%2018.3199C37.1594%2018.3168%2034.3395%2018.8765%2031.7092%2019.9668C29.0789%2021.0572%2026.6901%2022.6566%2024.68%2024.6732C22.6649%2026.6839%2021.0661%2029.0724%2019.9753%2031.7018C18.8845%2034.3312%2018.323%2037.1499%2018.323%2039.9966C18.323%2042.8433%2018.8845%2045.662%2019.9753%2048.2914C21.0661%2050.9208%2022.6649%2053.3092%2024.68%2055.3199L48.4167%2079.0566Z'%20fill='url(%23paint1_linear_6585_146)'/%3e%3cpath%20d='M40.0033%2018.3232C45.5433%2018.3232%2051.0833%2020.4398%2055.3233%2024.6765C57.3384%2026.6872%2058.9372%2029.0756%2060.028%2031.705C61.1188%2034.3344%2061.6803%2037.1532%2061.6803%2039.9998C61.6803%2042.8465%2061.1188%2045.6653%2060.028%2048.2947C58.9372%2050.9241%2057.3384%2053.3125%2055.3233%2055.3232C53.3126%2057.3383%2050.9242%2058.937%2048.2948%2060.0279C45.6654%2061.1187%2042.8467%2061.6802%2040%2061.6802C37.1533%2061.6802%2034.3346%2061.1187%2031.7052%2060.0279C29.0758%2058.937%2026.6873%2057.3383%2024.6767%2055.3232C22.6615%2053.3125%2021.0628%2050.9241%2019.972%2048.2947C18.8811%2045.6653%2018.3196%2042.8465%2018.3196%2039.9998C18.3196%2037.1532%2018.8811%2034.3344%2019.972%2031.705C21.0628%2029.0756%2022.6615%2026.6872%2024.6767%2024.6765C26.6867%2022.6599%2029.0756%2021.0604%2031.7059%2019.9701C34.3361%2018.8798%2037.156%2018.3201%2040.0033%2018.3232ZM49.87%2033.3298C49.5544%2033.3601%2049.2539%2033.4791%2049.0033%2033.6732L36.8233%2042.8065L31.18%2037.1665C29.9566%2035.8932%2027.5467%2038.2998%2028.8233%2039.5232L35.49%2046.1898C35.779%2046.4631%2036.1536%2046.6281%2036.5504%2046.6566C36.9471%2046.6852%2037.3415%2046.5756%2037.6667%2046.3465L51%2036.3465C52.12%2035.5298%2051.43%2033.3532%2050.0433%2033.3332C49.9867%2033.3303%2049.9299%2033.3303%2049.8733%2033.3332L49.87%2033.3298Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6585_146'%20x1='0.320001'%20y1='80'%20x2='87.5968'%20y2='71.0629'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%239035FF'/%3e%3cstop%20offset='1'%20stop-color='%230065FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_6585_146'%20x1='18.566'%20y1='79.0566'%20x2='84.8526'%20y2='72.2662'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%239035FF'/%3e%3cstop%20offset='1'%20stop-color='%230065FF'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_6585_146'%3e%3crect%20width='80'%20height='80'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", KFe = ({
  userId: t,
  token: e,
  questId: r,
  uniqueUserId: n,
  uniqueEmailId: A,
  heading: i,
  styleConfig: o,
  showFooter: s,
  thanksPopUpFooter: a,
  footerText: c,
  footerLink: l,
  sectionSubHeading: u = [],
  sectionHeading: f = [],
  questionSections: d = [],
  setGamifiedQuiz: g,
  gamifiedQuiz: m,
  setQuestions: p,
  questionsPerSection: v = 2,
  functionOnSubmit: C,
  feedbackContent: w,
  variation: B,
  isV1Api: y,
  Headers: b,
  CrossColor: q,
  isAccumulateAndSelf: E
}) => {
  var Ct, Ye, $e, nt, mt, me, yt, Ue, Ie, ot, Ke, tt, Ot, Vt, Mt, lr, Lr, Et, Qt, Er, kt, en, St, jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn, dt, ie, _e, Ne, Ee, et, Ft, je, ur;
  const { apiKey: x, apiSecret: M, entityId: O, apiType: I, themeConfig: S } = Xe(
    ct.Context
  ), P = y ? "criteriaId" : "actionId", H = new zn(), [F, T] = N([]), [U, D] = N(
    []
  ), [Q, Y] = N(
    {}
  ), [j, Z] = N(""), [W, R] = N(0), [K, L] = N(0);
  let G = I == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const [V, _] = N(0);
  let J = new Bt("mixpanel", I);
  const ne = new URLSearchParams(window.location.search).get("localeCode"), [ee, $] = N([]), [te, ae] = N([]), se = Ve.PHRASE_PROJECT_ID, ue = Ve.PHRASE_ACCESS_TOKEN, [fe, ve] = N(
    "Fill out the Details"
  ), [ge, oe] = N("Submit"), ce = async () => {
    try {
      const Ce = (await (await fetch(
        `https://api.phrase.com/v2/projects/${se}/locales`,
        {
          method: "GET",
          headers: {
            Authorization: `token ${ue}`,
            "Content-Type": "application/json"
          }
        }
      )).json()).filter(
        (It) => It.id !== "1c7c617229fb6d738a62f213edee028d"
        // english localeId
      );
      $(Ce);
      const Ut = (await Promise.all(
        Ce.map(async (It) => {
          const at = new URLSearchParams({
            q: `tags:${O},static`
          }).toString(), zt = await (await fetch(
            `https://api.phrase.com/v2/projects/${se}/locales/${It.id}/download?file_format=json&${at}`,
            {
              method: "GET",
              headers: {
                Authorization: `token ${ue}`,
                "Content-Type": "application/json"
              }
            }
          )).json();
          return Object.entries(zt).map(([Ht, _t]) => ({
            key: Ht,
            message: _t.message,
            localeId: It.id,
            name: It.name
          }));
        })
      )).flat();
      return Ut.filter((It) => {
        It.key === "Fill out the Details" && It.name === ne ? ve(It.message) : It.key === "Submit" && It.name === ne && oe(It.message);
      }), ae(Ut), Ut;
    } catch (Me) {
      console.error("Error fetching translations:", Me), J.captureSentryException(Me);
    }
  };
  le(() => {
    if (J.fireTrackingEvent(
      "quest_gamifiedquiz_loaded",
      "gamifiedquiz"
    ), O) {
      let Me = H.get("externalUserId"), De = H.get("questUserId"), Ce = H.get("questUserToken");
      const Pt = {
        apiKey: x,
        apisecret: M,
        userId: t,
        token: e
      }, Ut = {
        externalUserId: !!n && n,
        entityId: O,
        email: A
      };
      if (Me && De && Ce && Me == n) {
        let zt = { ...Pt, questUserId: De, questUserToken: Ce };
        try {
          Oe.post(
            `${G}api/entities/${O}/users/${De}/metrics/onboarding-view?userId=${De}&campaignId=${r}`,
            { count: 1 },
            { headers: zt }
          );
        } catch (Ht) {
          J.captureSentryException(Ht);
        }
      } else n && Oe.post(`${G}api/users/external/login`, Ut, { headers: Pt }).then((zt) => {
        let { userId: Ht, token: _t } = zt.data, or = { ...Pt, userId: Ht, token: _t };
        const tr = /* @__PURE__ */ new Date();
        tr.setHours(tr.getHours() + 12), H.set("externalUserId", n, {
          path: "/",
          expires: tr
        }), H.set("questUserId", Ht, { path: "/", expires: tr }), H.set("questUserToken", _t, { path: "/", expires: tr });
        try {
          Oe.post(
            `${G}api/entities/${O}/users/${Ht}/metrics/onboarding-view?userId=${Ht}&campaignId=${r}`,
            { count: 1 },
            { headers: or }
          );
        } catch (Cr) {
          J.captureSentryException(Cr);
        }
      }).catch((zt) => {
        J.captureSentryException(zt);
      });
      const It = async function(Ht, _t) {
        var Cr;
        let or = new URLSearchParams();
        or.set("platform", "REACT"), B && or.set("variation", B);
        const tr = `${G}api/v2/entities/${O}/campaigns/${r}?${or.toString()}`;
        try {
          const { data: jt } = await Oe.get(tr, { headers: _t });
          p(jt.data.actions.length);
          let dr = (Cr = jt == null ? void 0 : jt.data) == null ? void 0 : Cr.actions.map((Xt) => {
            var ui, sr, di;
            return {
              type: Xt == null ? void 0 : Xt.actionType,
              question: Xt == null ? void 0 : Xt.title,
              options: (Xt == null ? void 0 : Xt.options) || [],
              actionId: Xt == null ? void 0 : Xt.actionId,
              required: Xt == null ? void 0 : Xt.isRequired,
              placeholder: (ui = Xt == null ? void 0 : Xt.metadata) == null ? void 0 : ui.placeholder,
              preventFutureSelection: (sr = Xt == null ? void 0 : Xt.metadata) == null ? void 0 : sr.preventFutureSelection,
              preventPastSelection: (di = Xt == null ? void 0 : Xt.metadata) == null ? void 0 : di.preventPastSelection
            };
          });
          v > 0 && R(
            Math.ceil(jt.data.actions.length / v)
          ), (dr == null ? void 0 : dr.length) > 0 ? T([...dr]) : T([]), Z(jt.data.campaignVariationId);
        } catch (jt) {
          console.log(jt), J.captureSentryException(jt);
        }
      }, at = async function(Ht, _t) {
        var dr, Xt, ui;
        let or = await ce();
        const tr = `${G}api/entities/${O}/quests/${r}/criterias?userId=${Ht}&getVariation=${B || !1}`, { data: Cr } = await Oe.get(tr, { headers: _t });
        p((dr = Cr == null ? void 0 : Cr.data) == null ? void 0 : dr.eligibilityCriterias.length);
        let jt = (Xt = Cr == null ? void 0 : Cr.data) == null ? void 0 : Xt.eligibilityData.map(
          (sr) => {
            var di, bo, Bo, Ws, Xs, Ks, Zs, Js;
            return {
              type: sr == null ? void 0 : sr.criteriaType,
              question: (di = sr == null ? void 0 : sr.metadata) == null ? void 0 : di.title,
              options: ((bo = sr == null ? void 0 : sr.metadata) == null ? void 0 : bo.options) || [],
              criteriaId: sr == null ? void 0 : sr.criteriaId,
              required: (Bo = sr == null ? void 0 : sr.metadata) == null ? void 0 : Bo.isRequired,
              placeholder: (Ws = sr == null ? void 0 : sr.metadata) == null ? void 0 : Ws.placeholder,
              keyId: ((Xs = sr == null ? void 0 : sr.metadata) == null ? void 0 : Xs.keyId) || "",
              optionsKeyIds: ((Ks = sr == null ? void 0 : sr.metadata) == null ? void 0 : Ks.optionsKeyIds) || [],
              preventFutureSelection: (Zs = sr == null ? void 0 : sr.metadata) == null ? void 0 : Zs.preventFutureSelection,
              preventPastSelection: (Js = sr == null ? void 0 : sr.metadata) == null ? void 0 : Js.preventPastSelection
            };
          }
        );
        if (v > 0 && R(
          Math.ceil(
            ((ui = Cr == null ? void 0 : Cr.data) == null ? void 0 : ui.eligibilityCriterias.length) / v
          )
        ), (jt == null ? void 0 : jt.length) > 0) {
          const sr = vt(
            jt,
            or,
            !1
          ), di = vt(
            jt,
            or,
            !0
          ), [
            bo,
            Bo
          ] = await Promise.all([
            sr,
            di
          ]);
          T(bo), D(Bo);
        } else
          T([]);
      }, vt = async (zt, Ht, _t) => {
        try {
          return zt.map((tr) => {
            const Cr = Ht == null ? void 0 : Ht.find(
              (jt) => jt.name === ne && jt.key.includes(tr.criteriaId) && !jt.key.includes("OPTION")
            );
            return Cr ? {
              ...tr,
              question: Cr.message,
              options: _t ? tr.options.map((jt) => {
                const dr = Ht == null ? void 0 : Ht.find(
                  (Xt) => Xt.name === ne && Xt.key.includes(jt) && Xt.key.includes(tr.criteriaId)
                );
                return dr ? dr.message : jt;
              }) : tr == null ? void 0 : tr.options
            } : tr;
          });
        } catch (or) {
          return J.captureSentryException(or), console.error("Error updating translations:", or), zt;
        }
      };
      y ? at(t, Pt) : It(t, Pt);
    }
  }, []);
  const [pe, qe] = N({}), [Se, Te] = N(!0), [be, He] = N(!0), Ge = (Me, De) => {
    var Ce;
    (Ce = pe[De]) != null && Ce.includes(Me) ? qe((Pt) => ({
      ...Pt,
      [De]: Pt[De].filter((Ut) => Ut != Me)
    })) : Array.isArray(pe[De]) ? pe[De] = [...pe[De], Me] : (pe[De] = [], pe[De] = [...pe[De], Me]), He((Pt) => !Pt);
  }, Le = (Me, De) => {
    var Ce;
    (Ce = Q[De]) != null && Ce.includes(Me) ? Y((Pt) => ({ ...Pt, [De]: Pt[De] = [] })) : (Q[De] = [], Q[De] = [...Q[De], Me]), Te((Pt) => !Pt);
  }, [Ae, Pe] = N(!1);
  le(() => {
    var Me, De, Ce, Pt, Ut, It, at, vt, zt, Ht, _t, or, tr, Cr;
    if ((d == null ? void 0 : d.length) > 0) {
      for (let jt = 0; jt < d[V].length; jt++)
        if (((Me = F[d[V][jt] - 1]) == null ? void 0 : Me.type) === "USER_INPUT_MULTI_CHOICE") {
          const dr = pe[F[d[V][jt] - 1][P]];
          if ((De = F[d[V][jt] - 1]) != null && De.required) if ((dr == null ? void 0 : dr.length) > 0 && ((Ce = F[d[V][jt] - 1]) != null && Ce.required))
            Pe(!0);
          else {
            Pe(!1);
            break;
          }
        } else if (((Pt = F[d[V][jt] - 1]) == null ? void 0 : Pt.type) === "USER_INPUT_EMAIL") {
          const dr = Q[F[d[V][jt] - 1][P]], Xt = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (typeof dr == "string")
            if (Xt.test(dr))
              Pe(!0);
            else {
              Pe(!1);
              break;
            }
        } else if ((Ut = F[d[V][jt] - 1]) != null && Ut.required) if (((It = Q[F[d[V][jt] - 1][P]]) == null ? void 0 : It.length) > 0 && ((at = F[d[V][jt] - 1]) != null && at.required))
          Pe(!0);
        else {
          Pe(!1);
          break;
        }
    } else
      for (let jt = 0; jt < v; jt++) {
        let dr = K * v + jt;
        if (((vt = F[dr]) == null ? void 0 : vt.type) === "USER_INPUT_MULTI_CHOICE") {
          const Xt = pe[F[dr][P]];
          if ((zt = F[dr]) != null && zt.required) if ((Xt == null ? void 0 : Xt.length) > 0 && ((Ht = F[dr]) != null && Ht.required))
            Pe(!0);
          else {
            Pe(!1);
            break;
          }
        } else if (((_t = F[dr]) == null ? void 0 : _t.type) === "USER_INPUT_EMAIL") {
          const Xt = Q[F[dr][P]], ui = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (typeof Xt == "string")
            if (ui.test(Xt))
              Pe(!0);
            else {
              Pe(!1);
              break;
            }
        } else if ((or = F[dr]) != null && or.required) if (((tr = Q[F[dr][P]]) == null ? void 0 : tr.length) > 0 && ((Cr = F[dr]) != null && Cr.required))
          Pe(!0);
        else {
          Pe(!1);
          break;
        }
      }
  }, [
    Q,
    V,
    Se,
    V,
    be,
    V,
    K
  ]);
  const it = ({ value: Me }) => {
    const De = U.find(
      (Ce) => Ce.criteriaId === Me.criteriaId
    );
    return /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-options multi-option", children: Me == null ? void 0 : Me.options.map((Ce, Pt) => {
      var at, vt, zt, Ht, _t, or, tr;
      const Ut = {
        border: `2px solid ${(at = o == null ? void 0 : o.OptionsSelectedColor) == null ? void 0 : at.color}`,
        fontFamily: S == null ? void 0 : S.fontFamily
      }, It = {
        color: (vt = o == null ? void 0 : o.OptionsSelectedColor) == null ? void 0 : vt.color,
        fontFamily: S == null ? void 0 : S.fontFamily
      };
      return /* @__PURE__ */ k(
        "div",
        {
          onClick: () => Ge(Ce, Me[P]),
          className: `${(zt = pe[Me[P]]) != null && zt.includes(Ce) ? "selected-option" : "not-selected"}`,
          style: (Ht = pe[Me[P]]) != null && Ht.includes(Ce) ? Ut : { borderColor: S == null ? void 0 : S.borderColor },
          children: [
            (_t = pe[Me[P]]) != null && _t.includes(Ce) ? sOe(
              (or = o == null ? void 0 : o.OptionsSelectedColor) == null ? void 0 : or.color
            ) : oOe(S == null ? void 0 : S.borderColor),
            /* @__PURE__ */ h(
              "p",
              {
                style: (tr = pe[Me[P]]) != null && tr.includes(Ce) ? It : {
                  color: S == null ? void 0 : S.primaryColor,
                  fontFamily: S == null ? void 0 : S.fontFamily
                },
                children: y ? De == null ? void 0 : De.options[Pt] : Ce
              }
            )
          ]
        },
        Pt
      );
    }) });
  }, de = ({ value: Me }) => {
    const De = U.find(
      (Ce) => Ce.criteriaId === Me.criteriaId
    );
    return /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-options", children: Me == null ? void 0 : Me.options.map((Ce, Pt) => {
      var at, vt, zt, Ht, _t, or, tr;
      const Ut = {
        border: `2px solid ${(at = o == null ? void 0 : o.OptionsSelectedColor) == null ? void 0 : at.color}`
      }, It = {
        color: (vt = o == null ? void 0 : o.OptionsSelectedColor) == null ? void 0 : vt.color,
        fontFamily: S == null ? void 0 : S.fontFamily
      };
      return /* @__PURE__ */ k(
        "div",
        {
          onClick: () => Le(Ce, Me[P]),
          className: `${(zt = Q[Me[P]]) != null && zt.includes(Ce) ? "selected-option" : "not-selected"}`,
          style: (Ht = Q[Me[P]]) != null && Ht.includes(Ce) ? Ut : {
            borderColor: S == null ? void 0 : S.borderColor
          },
          children: [
            (_t = Q[Me[P]]) != null && _t.includes(Ce) ? iOe(
              (or = o == null ? void 0 : o.OptionsSelectedColor) == null ? void 0 : or.color
            ) : AOe(S == null ? void 0 : S.borderColor),
            /* @__PURE__ */ k(
              "p",
              {
                style: (tr = Q[Me[P]]) != null && tr.includes(Ce) ? It : {
                  color: S == null ? void 0 : S.primaryColor,
                  fontFamily: S == null ? void 0 : S.fontFamily
                },
                children: [
                  " ",
                  y ? De == null ? void 0 : De.options[Pt] : Ce
                ]
              }
            )
          ]
        },
        Pt
      );
    }) });
  }, [xe, he] = N(!1), [Qe, Re] = N(
    "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them"
  ), [pt, ze] = N("Feedback Submitted"), lt = () => {
    J.fireTrackingEvent(
      "quest_gamifiedquiz_submit_button_clicked",
      "gamifiedquiz"
    );
    for (const Me in pe)
      pe.hasOwnProperty(Me) && (Q[Me] = pe[Me]);
    if (y) {
      let Me = Object.keys(Q).map((Ce) => ({
        criteriaId: Ce,
        answer: typeof Q[Ce] == "object" ? Q[Ce] : [Q[Ce]],
        question: F[F.findIndex((Pt) => Pt.criteriaId == Ce)].question
      })), De = {
        apikey: x,
        apisecret: M,
        userId: n || t,
        token: e
      };
      Oe.post(
        `${G}api/entities/${O}/quests/${r}/verify-all?userId=${De.userId}`,
        { criterias: Me, userId: De.userId, isAccumulateAndSelf: E },
        { headers: De }
      ).then((Ce) => {
        C == null || C(), he(Ce.data.success), Ce.data.success ? he(Ce.data.success) : (ze("Feedback Not Submitted"), Re(Ce.data.error), he(!0));
      }).catch((Ce) => {
        J.captureSentryException(Ce), console.log("error", Ce);
      });
    } else {
      let Me = Object.keys(Q).map((Ce) => ({
        actionId: Ce,
        answers: Array.isArray(Q[Ce]) ? Q[Ce] : [Q[Ce]]
      })), De = {
        apikey: x,
        apisecret: M,
        userId: n || t,
        token: e
      };
      Oe.post(
        `${G}api/v2/entities/${O}/campaigns/${r}/verify`,
        { actions: Me, campaignVariationId: j },
        { headers: De }
      ).then((Ce) => {
        C == null || C(), he(Ce.data.success), Ce.data.success ? he(Ce.data.success) : (ze("Feedback Not Submitted"), Re(Ce.data.error), he(!0));
      }).catch((Ce) => {
        J.captureSentryException(Ce), console.log("error", Ce);
      });
    }
  }, st = (Me, De, Ce) => {
    Y((Pt) => ({ ...Pt, [De]: Me.target.value }));
  }, We = (Me, De, Ce, Pt, Ut, It) => {
    var at, vt, zt, Ht, _t, or, tr;
    return /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ h(
        "p",
        {
          className: "label-inputs",
          style: {
            color: ((at = o == null ? void 0 : o.LabelColor) == null ? void 0 : at.color) || (S == null ? void 0 : S.primaryColor),
            fontFamily: S == null ? void 0 : S.fontFamily
          },
          children: `${Me}${De ? "*" : ""}`
        }
      ),
      /* @__PURE__ */ h(
        Li,
        {
          type: It,
          placeholder: Ut,
          value: Q[Ce],
          iconColor: (vt = o == null ? void 0 : o.IconColor) == null ? void 0 : vt.color,
          onChange: (Cr) => st(Cr, Ce),
          style: {
            borderColor: ((zt = o == null ? void 0 : o.Input) == null ? void 0 : zt.borderColor) || (S == null ? void 0 : S.borderColor),
            color: ((Ht = o == null ? void 0 : o.Input) == null ? void 0 : Ht.color) || (S == null ? void 0 : S.primaryColor)
            // ...styleConfig?.Input,
          },
          emailtext: ((_t = o == null ? void 0 : o.EmailError) == null ? void 0 : _t.text) == null ? "Invalid email format" : (or = o == null ? void 0 : o.EmailError) == null ? void 0 : or.text,
          emailErrorStyle: {
            fontFamily: (S == null ? void 0 : S.fontFamily) || "Figtree",
            ...(tr = o == null ? void 0 : o.EmailError) == null ? void 0 : tr.errorStyle
          }
        }
      )
    ] }, Ce);
  }, Je = (Me, De, Ce, Pt, Ut, It, at) => {
    var vt, zt, Ht, _t;
    return /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ h(
        "p",
        {
          className: "label-inputs",
          style: {
            color: ((vt = o == null ? void 0 : o.LabelColor) == null ? void 0 : vt.color) || (S == null ? void 0 : S.primaryColor),
            fontFamily: (S == null ? void 0 : S.fontFamily) || "Figtree"
          },
          children: `${Me}${De ? "*" : ""}`
        }
      ),
      /* @__PURE__ */ h(
        Li,
        {
          type: "date",
          placeholder: Ut,
          value: Q[Ce],
          onChange: (or) => st(or, Ce),
          iconColor: (zt = o == null ? void 0 : o.IconColor) == null ? void 0 : zt.color,
          style: {
            borderColor: ((Ht = o == null ? void 0 : o.Input) == null ? void 0 : Ht.borderColor) || (S == null ? void 0 : S.borderColor),
            color: ((_t = o == null ? void 0 : o.Input) == null ? void 0 : _t.color) || (S == null ? void 0 : S.primaryColor),
            fontFamily: (S == null ? void 0 : S.fontFamily) || "Figtree",
            ...o == null ? void 0 : o.Input
          },
          preventFutureSelection: It,
          preventPastSelection: at
        }
      )
    ] }, Ce);
  }, ut = (Me, De, Ce, Pt, Ut) => {
    var It, at, vt;
    return /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ h(
        "p",
        {
          className: "label-inputs",
          style: {
            color: ((It = o == null ? void 0 : o.LabelColor) == null ? void 0 : It.color) || (S == null ? void 0 : S.primaryColor),
            fontFamily: S == null ? void 0 : S.fontFamily
          },
          children: `${Me}${De ? "*" : ""}`
        }
      ),
      /* @__PURE__ */ h(
        b4,
        {
          onChange: (zt) => st(zt, Ce),
          placeholder: Ut,
          value: Q[Ce],
          style: {
            borderColor: ((at = o == null ? void 0 : o.TextArea) == null ? void 0 : at.borderColor) || (S == null ? void 0 : S.borderColor),
            color: ((vt = o == null ? void 0 : o.TextArea) == null ? void 0 : vt.color) || (S == null ? void 0 : S.primaryColor),
            ...o == null ? void 0 : o.TextArea
          }
        }
      )
    ] }, Ce);
  }, Be = [];
  for (let Me = 0; Me < v; Me++) {
    let De = K * v + Me, Ce = F[De], Pt = De;
    Be.push(
      /* @__PURE__ */ h("div", { className: "gamified-quiz-action-div", children: /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-title-cont", children: /* @__PURE__ */ k("div", { className: "question-input-cont", children: [
        ((Ct = F[De]) == null ? void 0 : Ct.type) === "USER_INPUT_SINGLE_CHOICE" || ((Ye = F[De]) == null ? void 0 : Ye.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ k(
          "div",
          {
            className: "question",
            style: {
              fontFamily: S == null ? void 0 : S.fontFamily,
              ...o == null ? void 0 : o.Question,
              color: (($e = o == null ? void 0 : o.Question) == null ? void 0 : $e.color) || (S == null ? void 0 : S.primaryColor)
            },
            children: [
              (nt = F[De]) == null ? void 0 : nt.question,
              `${(mt = F[De]) != null && mt.required ? "*" : ""}`
            ]
          }
        ) : null,
        ((me = F[De]) == null ? void 0 : me.type) === "USER_INPUT_TEXT" ? We(
          Ce.question,
          Ce.required || !1,
          Ce[P],
          Pt,
          Ce.placeholder || Ce.question,
          "text"
        ) : ((yt = F[De]) == null ? void 0 : yt.type) === "USER_INPUT_EMAIL" ? We(
          Ce.question,
          Ce.required || !1,
          Ce[P],
          Pt,
          Ce.placeholder || Ce.question,
          "email"
        ) : ((Ue = F[De]) == null ? void 0 : Ue.type) === "USER_INPUT_PHONE" || ((Ie = F[De]) == null ? void 0 : Ie.type) === "USER_INPUT_NUMBER" ? We(
          Ce.question,
          Ce.required || !1,
          Ce[P],
          Pt,
          Ce.placeholder || Ce.question,
          "number"
        ) : ((ot = F[De]) == null ? void 0 : ot.type) === "USER_INPUT_DATE" ? Je(
          Ce.question,
          Ce.required || !1,
          Ce[P],
          Pt,
          Ce.placeholder || Ce.question,
          Ce.preventFutureSelection || !1,
          Ce.preventPastSelection || !1
        ) : ((Ke = F[De]) == null ? void 0 : Ke.type) === "USER_INPUT_TEXTAREA" ? ut(
          Ce.question,
          Ce.required || !1,
          Ce[P],
          Pt,
          Ce.placeholder || Ce.question
        ) : ((tt = F[De]) == null ? void 0 : tt.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ h(it, { value: Ce }) : ((Ot = F[De]) == null ? void 0 : Ot.type) === "USER_INPUT_SINGLE_CHOICE" ? /* @__PURE__ */ h(de, { value: Ce }) : ""
      ] }) }) }, Pt)
    );
  }
  return /* @__PURE__ */ k(Ze, { children: [
    xe ? /* @__PURE__ */ h("div", { className: "thanks-popup-upper-div", children: /* @__PURE__ */ k(
      "div",
      {
        className: "gamified-thanks-pop-up",
        style: {
          background: ((Vt = o == null ? void 0 : o.ThanksPopup) == null ? void 0 : Vt.background) || (S == null ? void 0 : S.backgroundColor),
          fontFamily: S == null ? void 0 : S.fontFamily
        },
        children: [
          /* @__PURE__ */ h("div", { className: "gamified-pop-up-cancel-btn-cont", children: /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
            "div",
            {
              onClick: () => {
                J.fireTrackingEvent(
                  "quest_gamifiedquiz_feedback_close_button_clicked",
                  "gamifiedquiz"
                ), g(!1), he(!1);
              },
              style: {
                background: (Mt = o == null ? void 0 : o.ThanksPopUpFooter) == null ? void 0 : Mt.background
              },
              children: aOe((lr = o == null ? void 0 : o.IconColor) == null ? void 0 : lr.color)
            }
          ) }) }),
          /* @__PURE__ */ h("div", { className: "gamified-pop-up-image-cont", children: /* @__PURE__ */ h("img", { src: lj, alt: "" }) }),
          /* @__PURE__ */ k("div", { className: "gamified-pop-up-message-cont", children: [
            /* @__PURE__ */ k("div", { className: "pop-up-message", children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "pop-up-message-heading",
                  style: {
                    color: ((Lr = o == null ? void 0 : o.ThanksPopupHeading) == null ? void 0 : Lr.color) || (S == null ? void 0 : S.primaryColor) || "var(--Neutral-Black-400, #2C2C2C)",
                    fontFamily: S == null ? void 0 : S.fontFamily
                  },
                  children: (w == null ? void 0 : w.FeedbackHeading) || pt
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: "pop-up-message-para",
                  style: {
                    color: ((Et = o == null ? void 0 : o.ThanksPopupDescription) == null ? void 0 : Et.color) || (S == null ? void 0 : S.secondaryColor) || "var(--Neutral-Black-100, #939393)",
                    fontFamily: S == null ? void 0 : S.fontFamily
                  },
                  children: (w == null ? void 0 : w.FeedbackDescription) || Qe
                }
              )
            ] }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "goto-home",
                style: {
                  borderColor: ((Qt = o == null ? void 0 : o.ThanksPopUpGotoHome) == null ? void 0 : Qt.borderColor) || (S == null ? void 0 : S.borderColor),
                  background: (Er = o == null ? void 0 : o.ThanksPopUpGotoHome) == null ? void 0 : Er.background,
                  color: (kt = o == null ? void 0 : o.ThanksPopUpGotoHome) == null ? void 0 : kt.color
                },
                onClick: () => {
                  J.fireTrackingEvent(
                    "quest_gamifiedquiz_feedback_gotohome_button_clicked",
                    "gamifiedquiz"
                  ), he((Me) => !Me);
                },
                children: "Go to home!"
              }
            )
          ] }),
          a ? /* @__PURE__ */ h(
            "div",
            {
              className: "gamified-quiz-footer-section",
              style: {
                background: (en = o == null ? void 0 : o.ThanksPopUpFooter) == null ? void 0 : en.background,
                color: ((St = o == null ? void 0 : o.ThanksPopUpFooter) == null ? void 0 : St.color) || (S == null ? void 0 : S.secondaryColor),
                fontFamily: S == null ? void 0 : S.fontFamily
              },
              children: c || "Powered by PLG OS"
            }
          ) : ""
        ]
      }
    ) }) : null,
    m && !xe ? /* @__PURE__ */ h("div", { className: "upper-div", children: /* @__PURE__ */ k("div", { className: "gamified-quiz", children: [
      /* @__PURE__ */ k(
        "div",
        {
          className: "gamified-quiz-header-section",
          style: {
            background: ((jr = o == null ? void 0 : o.Form) == null ? void 0 : jr.background) || (S == null ? void 0 : S.backgroundColor)
          },
          children: [
            /* @__PURE__ */ h("div", { className: "gamified-quiz-title-section", children: /* @__PURE__ */ h(
              "div",
              {
                className: "gamified-quiz-title-head",
                style: {
                  color: ((cn = o == null ? void 0 : o.Heading) == null ? void 0 : cn.color) || (S == null ? void 0 : S.primaryColor),
                  fontFamily: S == null ? void 0 : S.fontFamily
                },
                children: i || "Choose an option"
              }
            ) }),
            /* @__PURE__ */ k("div", { className: "div", children: [
              /* @__PURE__ */ h("div", { className: "gamified-quiz-header-task-logo-cont", children: /* @__PURE__ */ h("img", { src: cj, alt: "" }) }),
              /* @__PURE__ */ k(
                "form",
                {
                  className: "gamified-quiz-header-form",
                  style: o == null ? void 0 : o.FormContainer,
                  children: [
                    /* @__PURE__ */ k(
                      "div",
                      {
                        style: {
                          width: "100%",
                          display: "flex",
                          flexDirection: "column"
                        },
                        children: [
                          /* @__PURE__ */ k("div", { className: "heading-subheading-container", children: [
                            /* @__PURE__ */ k(
                              "div",
                              {
                                className: "quest-title",
                                style: {
                                  color: ((ln = o == null ? void 0 : o.SubHeading) == null ? void 0 : ln.color) || (S == null ? void 0 : S.secondaryColor),
                                  fontFamily: S == null ? void 0 : S.fontFamily,
                                  paddingBottom: "4px"
                                },
                                children: [
                                  b && b.length > 0 && ((un = b[K]) != null && un.heading) ? (dn = b[K]) == null ? void 0 : dn.heading : y ? te.length > 0 ? fe : "" : "Fill out the Details",
                                  y == !0 && te.length > 0 && /* @__PURE__ */ h(
                                    "div",
                                    {
                                      onClick: () => {
                                        g(!1);
                                      },
                                      children: /* @__PURE__ */ h(
                                        "svg",
                                        {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "none",
                                          children: /* @__PURE__ */ h(
                                            "path",
                                            {
                                              "fill-rule": "evenodd",
                                              "clip-rule": "evenodd",
                                              d: "M12.4713 4.47132C12.7317 4.21097 12.7317 3.78886 12.4713 3.52851C12.211 3.26816 11.7889 3.26816 11.5285 3.52851L7.99992 7.05711L4.47132 3.52851C4.21097 3.26816 3.78886 3.26816 3.52851 3.52851C3.26816 3.78886 3.26816 4.21097 3.52851 4.47132L7.05711 7.99992L3.52851 11.5285C3.26816 11.7889 3.26816 12.211 3.52851 12.4713C3.78886 12.7317 4.21097 12.7317 4.47132 12.4713L7.99992 8.94273L11.5285 12.4713C11.7889 12.7317 12.211 12.7317 12.4713 12.4713C12.7317 12.211 12.7317 11.7889 12.4713 11.5285L8.94273 7.99992L12.4713 4.47132Z",
                                              fill: q || "black"
                                            }
                                          )
                                        }
                                      )
                                    }
                                  )
                                ]
                              }
                            ),
                            b && (b == null ? void 0 : b.length) > 0 && ((fn = b[K]) == null ? void 0 : fn.subHeading) && /* @__PURE__ */ h(
                              "div",
                              {
                                className: "question",
                                style: {
                                  color: ((hn = o == null ? void 0 : o.Question) == null ? void 0 : hn.color) || (S == null ? void 0 : S.primaryColor),
                                  fontFamily: S == null ? void 0 : S.fontFamily
                                },
                                children: b[K].subHeading || "Fill out the Details"
                              }
                            )
                          ] }),
                          (d == null ? void 0 : d.length) > 0 ? d[V].map((Me) => {
                            var Pt, Ut, It, at, vt, zt, Ht, _t, or, tr, Cr, jt, dr;
                            Me = Me - 1;
                            const De = F[Me], Ce = Me;
                            return /* @__PURE__ */ h(
                              "div",
                              {
                                className: "gamified-quiz-action-div",
                                children: /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-title-cont", children: /* @__PURE__ */ k("div", { className: "question-input-cont", children: [
                                  ((Pt = F[Me]) == null ? void 0 : Pt.type) === "USER_INPUT_SINGLE_CHOICE" || ((Ut = F[Me]) == null ? void 0 : Ut.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ k(
                                    "div",
                                    {
                                      className: "question",
                                      style: {
                                        color: ((It = o == null ? void 0 : o.Question) == null ? void 0 : It.color) || (S == null ? void 0 : S.primaryColor),
                                        fontFamily: S == null ? void 0 : S.fontFamily
                                      },
                                      children: [
                                        (at = F[Me]) == null ? void 0 : at.question,
                                        `${(vt = F[Me]) != null && vt.required ? "*" : ""}`
                                      ]
                                    }
                                  ) : null,
                                  ((zt = F[Me]) == null ? void 0 : zt.type) === "USER_INPUT_TEXT" ? We(
                                    De.question,
                                    De.required || !1,
                                    De[P],
                                    Ce,
                                    De.placeholder || De.question,
                                    "text"
                                  ) : ((Ht = F[Me]) == null ? void 0 : Ht.type) === "USER_INPUT_EMAIL" ? We(
                                    De.question,
                                    De.required || !1,
                                    De[P],
                                    Ce,
                                    De.placeholder || De.question,
                                    "email"
                                  ) : ((_t = F[Me]) == null ? void 0 : _t.type) === "USER_INPUT_PHONE" || ((or = F[Me]) == null ? void 0 : or.type) === "USER_INPUT_NUMBER" ? We(
                                    De.question,
                                    De.required || !1,
                                    De[P],
                                    Ce,
                                    De.placeholder || De.question,
                                    "number"
                                  ) : ((tr = F[Me]) == null ? void 0 : tr.type) === "USER_INPUT_DATE" ? Je(
                                    De.question,
                                    De.required || !1,
                                    De[P],
                                    Ce,
                                    De.placeholder || De.question,
                                    De.preventFutureSelection || !1,
                                    De.preventPastSelection || !1
                                  ) : ((Cr = F[Me]) == null ? void 0 : Cr.type) === "USER_INPUT_TEXTAREA" ? ut(
                                    De.question,
                                    De.required || !1,
                                    De[P],
                                    Ce,
                                    De.placeholder || De.question
                                  ) : ((jt = F[Me]) == null ? void 0 : jt.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ h(it, { value: De }) : ((dr = F[Me]) == null ? void 0 : dr.type) === "USER_INPUT_SINGLE_CHOICE" ? /* @__PURE__ */ h(de, { value: De }) : ""
                                ] }) })
                              },
                              Ce
                            );
                          }) : Be
                        ]
                      }
                    ),
                    (d == null ? void 0 : d.length) > 0 ? /* @__PURE__ */ k("div", { className: "gamified-quiz-header-ques-cancel-next", children: [
                      /* @__PURE__ */ h(
                        "button",
                        {
                          onClick: () => {
                            V > 0 ? (_(V - 1), J.fireTrackingEvent(
                              "quest_gamifiedquiz_previous_section_button_clicked",
                              "gamifiedquiz"
                            )) : (g(!1), J.fireTrackingEvent(
                              "quest_gamifiedquiz_cancel_button_clicked",
                              "gamifiedquiz"
                            ));
                          },
                          type: "button",
                          className: "cancel-btn",
                          style: {
                            background: ((En = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : En.background) || "var(--Neutral-White-100, #FFF)",
                            color: ((xn = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : xn.color) || "var(--Neutral-Black-400, #2C2C2C)",
                            fontFamily: S == null ? void 0 : S.fontFamily,
                            borderColor: (In = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : In.borderColor
                          },
                          children: V > 0 ? "Previous" : "Cancel"
                        }
                      ),
                      /* @__PURE__ */ h(
                        yr,
                        {
                          type: "button",
                          onClick: () => {
                            const Me = Object.keys(d);
                            V < Me.length - 1 ? (J.fireTrackingEvent(
                              "quest_gamifiedquiz_next_section_button_clicked",
                              "gamifiedquiz"
                            ), _(V + 1)) : V >= Me.length - 1 && lt();
                          },
                          disabled: !Ae,
                          className: "q-onb-main-btn2",
                          style: {
                            font: "",
                            fontFamily: "Figtree",
                            background: ((Sn = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : Sn.background) || (S == null ? void 0 : S.buttonColor) || "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                            color: ((Pn = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : Pn.color) || "var(--Neutral-White-100, #FFF)",
                            border: `1.5px solid ${(kn = o == null ? void 0 : o.PrimaryButton) != null && kn.borderColor ? (dt = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : dt.borderColor : S != null && S.buttonColor ? S == null ? void 0 : S.buttonColor : "#D1ACFF"}`,
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "20px"
                          },
                          children: V >= d.length - 1 ? y ? te.length > 0 ? ge : "" : "Submit" : "Next"
                        }
                      )
                    ] }) : /* @__PURE__ */ k("div", { className: "gamified-quiz-header-ques-cancel-next", children: [
                      /* @__PURE__ */ h(
                        "button",
                        {
                          onClick: () => {
                            K > 0 ? (J.fireTrackingEvent(
                              "quest_gamifiedquiz_previous_section_button_clicked",
                              "gamifiedquiz"
                            ), L(K - 1)) : (g(!1), J.fireTrackingEvent(
                              "quest_gamifiedquiz_cancel_button_clicked",
                              "gamifiedquiz"
                            ));
                          },
                          type: "button",
                          className: "cancel-btn",
                          style: {
                            background: ((ie = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : ie.background) || "var(--Neutral-White-100, #FFF)",
                            color: ((_e = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : _e.color) || "var(--Neutral-Black-400, #2C2C2C)",
                            fontFamily: S == null ? void 0 : S.fontFamily,
                            borderColor: ((Ne = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : Ne.borderColor) || (S == null ? void 0 : S.borderColor)
                          },
                          children: V > 0 ? "Previous" : "Cancel"
                        }
                      ),
                      /* @__PURE__ */ h(
                        yr,
                        {
                          type: "button",
                          onClick: () => {
                            K < W - 1 ? (J.fireTrackingEvent(
                              "quest_gamifiedquiz_next_section_button_clicked",
                              "gamifiedquiz"
                            ), L(K + 1)) : K >= W - 1 && lt();
                          },
                          disabled: !Ae,
                          className: "q-onb-main-btn2",
                          style: {
                            font: "",
                            fontFamily: "Figtree",
                            background: ((Ee = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : Ee.background) || (S == null ? void 0 : S.buttonColor) || "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                            color: ((et = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : et.color) || "var(--Neutral-White-100, #FFF)",
                            border: `1.5px solid ${(Ft = o == null ? void 0 : o.PrimaryButton) != null && Ft.borderColor ? (je = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : je.borderColor : S != null && S.buttonColor ? S == null ? void 0 : S.buttonColor : "#D1ACFF"}`,
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "20px"
                          },
                          children: K >= W - 1 ? y ? te.length > 0 ? ge : "" : "Submit" : "Next"
                        }
                      )
                    ] })
                  ]
                }
              )
            ] })
          ]
        }
      ),
      s ? /* @__PURE__ */ h(
        "div",
        {
          className: "gamified-quiz-footer-section",
          style: o == null ? void 0 : o.Footer,
          onClick: () => window.open(
            l || "https://www.plgos.com/",
            "_blank"
          ),
          children: /* @__PURE__ */ h(
            "div",
            {
              className: "footer-content",
              style: {
                color: ((ur = o == null ? void 0 : o.Footer) == null ? void 0 : ur.color) || (S == null ? void 0 : S.secondaryColor),
                fontFamily: S == null ? void 0 : S.fontFamily
              },
              children: c || "Powered by PLG OS"
            }
          )
        }
      ) : null
    ] }) }) : null
  ] });
}, cOe = (t = "#B9B9B9") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M4.50513 11.4957L8.00046 8.00034L11.4958 11.4957M11.4958 4.505L7.99979 8.00034L4.50513 4.505",
        stroke: t,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), lOe = ({
  setThanksPopup: t,
  setGamifiedQuiz: e,
  feedbackContent: r,
  thanksPopUpFooter: n,
  footerText: A,
  GeneralFunctions: i,
  popUpHead: o,
  popUpMessage: s,
  themeManager: a
}) => /* @__PURE__ */ h("div", { className: "thanks-popup-upper-div", children: /* @__PURE__ */ k(
  "div",
  {
    className: "gamified-thanks-pop-up",
    style: a.getThanksPopupStyles(),
    children: [
      /* @__PURE__ */ h("div", { className: "gamified-pop-up-cancel-btn-cont", children: /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
        "div",
        {
          onClick: () => {
            i.fireTrackingEvent(
              "quest_gamifiedquiz_feedback_close_button_clicked",
              "gamifiedquiz_offline"
            ), e(!1), t(!1);
          },
          style: a.getThanksPopUpFooterStyles(),
          children: cOe(a.getCancelButtonStyles().color)
        }
      ) }) }),
      /* @__PURE__ */ h("div", { className: "gamified-pop-up-image-cont", children: /* @__PURE__ */ h("img", { src: lj, alt: "" }) }),
      /* @__PURE__ */ k("div", { className: "gamified-pop-up-message-cont", children: [
        /* @__PURE__ */ k("div", { className: "pop-up-message", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "pop-up-message-heading",
              style: a.getThanksPopupHeadingStyles(),
              children: (r == null ? void 0 : r.FeedbackHeading) || o
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "pop-up-message-para",
              style: a.getThanksPopupDescriptionStyles(),
              children: (r == null ? void 0 : r.FeedbackDescription) || s
            }
          )
        ] }),
        /* @__PURE__ */ h(
          "div",
          {
            className: "goto-home",
            style: a.getThanksPopUpGotoHomeStyles(),
            onClick: () => {
              i.fireTrackingEvent(
                "quest_gamifiedquiz_feedback_gotohome_button_clicked",
                "gamifiedquiz"
              ), t((c) => !c);
            },
            children: "Go to home!"
          }
        )
      ] }),
      n ? /* @__PURE__ */ h(
        "div",
        {
          className: "gamified-quiz-footer-section",
          style: a.getThanksPopUpFooterStyles(),
          children: A || "Powered by PLG OS"
        }
      ) : ""
    ]
  }
) });
class uOe {
  constructor(e = {}, r = {}, n = {}, A = {}) {
    ke(this, "brandTheme");
    ke(this, "styleConfig");
    ke(this, "themeConfig");
    ke(this, "questThemeData");
    this.brandTheme = e, this.styleConfig = r, this.themeConfig = n, this.questThemeData = A;
  }
  getTextInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.TextError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getTextInputErrorStyles() {
    var e, r;
    return (r = (e = this.styleConfig) == null ? void 0 : e.TextError) == null ? void 0 : r.errorStyle;
  }
  getTextInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.borderColor,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.Input) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.Input
    };
  }
  getEmailIconColor() {
    var e, r, n, A;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.color) || ((n = this == null ? void 0 : this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this == null ? void 0 : this.themeConfig) == null ? void 0 : A.primaryColor) || "#B9B9B9";
  }
  getNumberInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.NumberError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getNumberInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.NumberError) == null ? void 0 : r.errorStyle
    };
  }
  getThanksPopupStyles() {
    var e, r, n, A;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopup) == null ? void 0 : r.background) || ((n = this.themeConfig) == null ? void 0 : n.backgroundColor),
      fontFamily: (A = this.themeConfig) == null ? void 0 : A.fontFamily
    };
  }
  getCancelButtonStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.IconColor) == null ? void 0 : r.color) || ((A = (n = this.themeConfig) == null ? void 0 : n.IconColor) == null ? void 0 : A.color) || ((o = (i = this.questThemeData) == null ? void 0 : i.IconColor) == null ? void 0 : o.color) || ((a = (s = this.brandTheme) == null ? void 0 : s.IconColor) == null ? void 0 : a.color)
    };
  }
  getThanksPopUpFooterStyles() {
    var e, r, n, A, i, o;
    return {
      background: (r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopUpFooter) == null ? void 0 : r.background,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.ThanksPopUpFooter) == null ? void 0 : A.color) || ((i = this.themeConfig) == null ? void 0 : i.secondaryColor),
      fontFamily: (o = this.themeConfig) == null ? void 0 : o.fontFamily
    };
  }
  getThanksPopupHeadingStyles() {
    var e, r, n, A;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopupHeading) == null ? void 0 : r.color) || ((n = this.themeConfig) == null ? void 0 : n.primaryColor) || "var(--Neutral-Black-400, #2C2C2C)",
      fontFamily: (A = this.themeConfig) == null ? void 0 : A.fontFamily
    };
  }
  getThanksPopupDescriptionStyles() {
    var e, r, n, A;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopupDescription) == null ? void 0 : r.color) || ((n = this.themeConfig) == null ? void 0 : n.secondaryColor) || "var(--Neutral-Black-100, #939393)",
      fontFamily: (A = this.themeConfig) == null ? void 0 : A.fontFamily
    };
  }
  getThanksPopUpGotoHomeStyles() {
    var e, r, n, A, i, o, s, a, c;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.ThanksPopUpGotoHome) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      background: (i = (A = this.styleConfig) == null ? void 0 : A.ThanksPopUpGotoHome) == null ? void 0 : i.background,
      color: ((s = (o = this.styleConfig) == null ? void 0 : o.ThanksPopUpGotoHome) == null ? void 0 : s.color) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor),
      fontFamily: (c = this.themeConfig) == null ? void 0 : c.fontFamily
    };
  }
  getHeaderFormStyles() {
    var e, r, n, A;
    return {
      borderRadius: ((e = this.styleConfig) == null ? void 0 : e.borderRadius) || ((r = this.questThemeData) == null ? void 0 : r.borderRadius) || ((n = this.brandTheme) == null ? void 0 : n.borderRadius) || ((A = this.themeConfig) == null ? void 0 : A.borderRadius)
    };
  }
  getFormStyles() {
    var e, r, n, A, i, o, s, a, c, l;
    return {
      background: ((r = (e = this.styleConfig) == null ? void 0 : e.Form) == null ? void 0 : r.backgroundColor) || ((n = this.brandTheme) == null ? void 0 : n.background) || ((A = this.themeConfig) == null ? void 0 : A.backgroundColor),
      borderRadius: ((o = (i = this.styleConfig) == null ? void 0 : i.Form) == null ? void 0 : o.borderRadius) || ((s = this.questThemeData) == null ? void 0 : s.borderRadius) || ((a = this.brandTheme) == null ? void 0 : a.borderRadius) || "12px",
      fontFamily: ((c = this.brandTheme) == null ? void 0 : c.fontFamily) || this.themeConfig.fontFamily || "'Figtree', sans-serif",
      ...(l = this.styleConfig) == null ? void 0 : l.Form
    };
  }
  getQuestionContainerStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Question) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Question,
      fontFamily: (o = this.themeConfig) == null ? void 0 : o.fontFamily
    };
  }
  getLabelStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Label) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor) || "var(--Neutral-Black-300, #939393)",
      ...(i = this.styleConfig) == null ? void 0 : i.Label,
      fontFamily: (o = this.themeConfig) == null ? void 0 : o.fontFamily
      // fontSize: "16px",
    };
  }
  getRatingStyles() {
    var e;
    return {
      ...(e = this.styleConfig) == null ? void 0 : e.Rating
    };
  }
  getInputStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.Input) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      color: ((i = (A = this.styleConfig) == null ? void 0 : A.Input) == null ? void 0 : i.color) || ((o = this.brandTheme) == null ? void 0 : o.primaryColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor),
      ...(a = this.styleConfig) == null ? void 0 : a.Input
    };
  }
  getInputIconStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.IconColor) == null ? void 0 : r.color) || ((A = (n = this.brandTheme) == null ? void 0 : n.IconColor) == null ? void 0 : A.color) || ((o = (i = this.themeConfig) == null ? void 0 : i.IconColor) == null ? void 0 : o.color)
    };
  }
  getTextAreaStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      borderColor: ((r = (e = this.styleConfig) == null ? void 0 : e.TextArea) == null ? void 0 : r.borderColor) || ((n = this.themeConfig) == null ? void 0 : n.borderColor),
      color: ((i = (A = this.styleConfig) == null ? void 0 : A.TextArea) == null ? void 0 : i.color) || ((o = this.brandTheme) == null ? void 0 : o.primaryColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor),
      ...(a = this.styleConfig) == null ? void 0 : a.TextArea
    };
  }
  getSingleChoiceStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      borderColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.style) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor),
      color: ((s = (o = (i = this.styleConfig) == null ? void 0 : i.SingleChoice) == null ? void 0 : o.style) == null ? void 0 : s.color) || ((a = this.brandTheme) == null ? void 0 : a.primaryColor) || ((c = this.themeConfig) == null ? void 0 : c.primaryColor),
      ...(u = (l = this.styleConfig) == null ? void 0 : l.SingleChoice) == null ? void 0 : u.style
    };
  }
  getSingleChoiceSelectedStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      accentColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.accentColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || ((i = this.brandTheme) == null ? void 0 : i.accentColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(a = (s = this.styleConfig) == null ? void 0 : s.SingleChoice) == null ? void 0 : a.selectedStyle
    };
  }
  getSingleChoiceHoverStyles() {
    var e, r;
    return {
      background: (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.hoverBackground
    };
  }
  getSingleAccentColor() {
    var e, r, n;
    return ((n = (r = (e = this.styleConfig) == null ? void 0 : e.SingleChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.accentColor) || "#6525B3";
  }
  getMultiChoiceStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      borderColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.style) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor),
      color: ((s = (o = (i = this.styleConfig) == null ? void 0 : i.MultiChoice) == null ? void 0 : o.style) == null ? void 0 : s.color) || ((a = this.themeConfig) == null ? void 0 : a.secondaryColor) || ((c = this.brandTheme) == null ? void 0 : c.primaryColor),
      ...(u = (l = this.styleConfig) == null ? void 0 : l.MultiChoice) == null ? void 0 : u.style
    };
  }
  getMultiChoiceSelectedStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p;
    return {
      borderColor: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.borderColor) || ((A = this.questThemeData) == null ? void 0 : A.accentColor),
      color: ((s = (o = (i = this.styleConfig) == null ? void 0 : i.MultiChoice) == null ? void 0 : o.selectedStyle) == null ? void 0 : s.color) || ((a = this.questThemeData) == null ? void 0 : a.accentColor) || ((c = this.brandTheme) == null ? void 0 : c.primaryColor) || ((l = this.themeConfig) == null ? void 0 : l.primaryColor),
      accentColor: ((d = (f = (u = this.styleConfig) == null ? void 0 : u.MultiChoice) == null ? void 0 : f.selectedStyle) == null ? void 0 : d.accentColor) || ((g = this.questThemeData) == null ? void 0 : g.accentColor),
      ...(p = (m = this.styleConfig) == null ? void 0 : m.SingleChoice) == null ? void 0 : p.selectedStyle
    };
  }
  getMultiChoiceSelectedColorStyles() {
    var e, r, n, A, i, o, s, a;
    return {
      color: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.MultiChoice) == null ? void 0 : r.selectedStyle) == null ? void 0 : n.color) || ((A = this.questThemeData) == null ? void 0 : A.accentColor) || ((i = this.brandTheme) == null ? void 0 : i.accentColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(a = (s = this.styleConfig) == null ? void 0 : s.MultiChoice) == null ? void 0 : a.selectedStyle
    };
  }
  getMultiChoiceSelectedSVG() {
    var e, r, n;
    return {
      color: ((e = this.questThemeData) == null ? void 0 : e.accentColor) || ((r = this.themeConfig) == null ? void 0 : r.primaryColor) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor)
    };
  }
  getMultiChoiceSVG() {
    var e, r, n, A;
    return {
      color: ((e = this.themeConfig) == null ? void 0 : e.borderColor) || ((r = this.brandTheme) == null ? void 0 : r.borderColor) || ((n = this.styleConfig) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor)
    };
  }
  getMultiChoiceBorderStyle() {
    var e, r, n, A;
    return {
      border: ((e = this.themeConfig) == null ? void 0 : e.borderColor) || ((r = this.brandTheme) == null ? void 0 : r.borderColor) || ((n = this.styleConfig) == null ? void 0 : n.borderColor) || ((A = this.themeConfig) == null ? void 0 : A.borderColor)
    };
  }
  getMultiCholiceOptionSelectedStyle() {
    var e, r, n, A;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.OptionsSelectedColor) == null ? void 0 : r.color) || ((n = this.questThemeData) == null ? void 0 : n.accentColor),
      fontFamily: (A = this.themeConfig) == null ? void 0 : A.fontFamily
    };
  }
  getHeaderStyles() {
    var e, r, n, A, i, o, s, a, c, l, u;
    return {
      heading: {
        color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
        ...(i = this.styleConfig) == null ? void 0 : i.Heading,
        fontFamily: (o = this.themeConfig) == null ? void 0 : o.fontFamily
      },
      description: {
        color: ((a = (s = this.styleConfig) == null ? void 0 : s.Description) == null ? void 0 : a.color) || ((c = this.brandTheme) == null ? void 0 : c.secondaryColor) || ((l = this.themeConfig) == null ? void 0 : l.secondaryColor),
        ...(u = this.styleConfig) == null ? void 0 : u.Description
      }
    };
  }
  getSubHeadingStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.SubHeading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.SubHeading,
      paddingBottom: "4px",
      fontFamily: (o = this.themeConfig) == null ? void 0 : o.fontFamily
    };
  }
  getQuestionStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Question) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.primaryColor) || ((A = this.themeConfig) == null ? void 0 : A.primaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Question,
      fontFamily: (o = this.themeConfig) == null ? void 0 : o.fontFamily
    };
  }
  getEmailInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getEMailInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.errorStyle
    };
  }
  getTextAreaInputStyles() {
    var e, r, n, A, i, o, s;
    return {
      borderColor: (r = (e = this.styleConfig) == null ? void 0 : e.TextArea) == null ? void 0 : r.borderColor,
      color: ((A = (n = this.styleConfig) == null ? void 0 : n.TextArea) == null ? void 0 : A.color) || ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || ((o = this.themeConfig) == null ? void 0 : o.primaryColor),
      ...(s = this.styleConfig) == null ? void 0 : s.TextArea
    };
  }
  getTextAreaInputErrorText() {
    var e, r;
    return ((r = (e = this.styleConfig) == null ? void 0 : e.TextAreaError) == null ? void 0 : r.text) || "Invalid text format";
  }
  getTextAreaInputErrorStyles() {
    var e, r;
    return {
      ...(r = (e = this.styleConfig) == null ? void 0 : e.TextAreaError) == null ? void 0 : r.errorStyle
    };
  }
  getButtonStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w, B, y, b, q, E, x, M, O, I, S, P, H, F, T, U, D, Q, Y, j, Z, W, R, K, L, G;
    return {
      primary: {
        background: ((e = this.questThemeData) == null ? void 0 : e.buttonColor) || ((r = this.brandTheme) == null ? void 0 : r.buttonColor) || ((n = this.themeConfig) == null ? void 0 : n.buttonColor) || "linear-gradient(84deg, #9035ff 0.36%, #0065ff 100.36%)",
        // ...this.styleConfig?.PrimaryButton,
        color: ((i = (A = this.styleConfig) == null ? void 0 : A.PrimaryButton) == null ? void 0 : i.color) || ((o = this.brandTheme) == null ? void 0 : o.primaryColor) || ((s = this.themeConfig) == null ? void 0 : s.primaryColor) || "white",
        borderColor: ((c = (a = this.styleConfig) == null ? void 0 : a.PrimaryButton) == null ? void 0 : c.borderColor) || ((l = this.themeConfig) == null ? void 0 : l.borderColor) || ((u = this.brandTheme) == null ? void 0 : u.borderColor),
        fontFamily: ((f = this.themeConfig) == null ? void 0 : f.fontFamily) || "Figtree",
        fontWeight: ((g = (d = this.styleConfig) == null ? void 0 : d.PrimaryButton) == null ? void 0 : g.fontWeight) || ((m = this.brandTheme) == null ? void 0 : m.fontWeight) || ((p = this.themeConfig) == null ? void 0 : p.fontFamily) || "600",
        fontStyle: ((C = (v = this.styleConfig) == null ? void 0 : v.PrimaryButton) == null ? void 0 : C.fontStyle) || ((w = this.brandTheme) == null ? void 0 : w.fontWeight) || ((B = this.themeConfig) == null ? void 0 : B.fontFamily) || "normal",
        lineHeight: ((b = (y = this.styleConfig) == null ? void 0 : y.PrimaryButton) == null ? void 0 : b.lineHeight) || ((q = this.brandTheme) == null ? void 0 : q.fontWeight) || ((E = this.themeConfig) == null ? void 0 : E.fontFamily) || "20px",
        border: `1.5px solid ${(M = (x = this.styleConfig) == null ? void 0 : x.PrimaryButton) != null && M.borderColor ? (I = (O = this.styleConfig) == null ? void 0 : O.PrimaryButton) == null ? void 0 : I.borderColor : (S = this.themeConfig) != null && S.buttonColor ? (P = this.themeConfig) == null ? void 0 : P.buttonColor : "#D1ACFF"}`
      },
      secondary: {
        color: ((F = (H = this.styleConfig) == null ? void 0 : H.SecondaryButton) == null ? void 0 : F.color) || ((T = this.brandTheme) == null ? void 0 : T.secondaryColor) || ((U = this.themeConfig) == null ? void 0 : U.secondaryColor) || "var(--Neutral-White-100, black)",
        ...(D = this.styleConfig) == null ? void 0 : D.SecondaryButton,
        background: ((Y = (Q = this.styleConfig) == null ? void 0 : Q.SecondaryButton) == null ? void 0 : Y.background) || ((j = this.brandTheme) == null ? void 0 : j.secondaryButton) || ((Z = this.themeConfig) == null ? void 0 : Z.backgroundColor) || "var(--Neutral-White-100, #FFF)",
        borderColor: ((R = (W = this.styleConfig) == null ? void 0 : W.SecondaryButton) == null ? void 0 : R.borderColor) || ((K = this.themeConfig) == null ? void 0 : K.borderColor) || ((L = this.brandTheme) == null ? void 0 : L.borderColor),
        fontFamily: (G = this.themeConfig) == null ? void 0 : G.fontFamily
      }
    };
  }
  getEmailErrorStyles() {
    var e, r, n, A;
    return {
      text: ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) || "This is not a valid email",
      style: ((A = (n = this.styleConfig) == null ? void 0 : n.EmailError) == null ? void 0 : A.errorStyle) || {}
    };
  }
  getEmailTextStyles() {
    var e, r, n, A;
    return {
      text: ((r = (e = this.styleConfig) == null ? void 0 : e.EmailError) == null ? void 0 : r.text) || "Invalid email format",
      style: ((A = (n = this.styleConfig) == null ? void 0 : n.EmailError) == null ? void 0 : A.errorStyle) || {}
    };
  }
  getFooterStyles() {
    var e, r, n, A, i, o, s, a, c, l, u, f, d, g, m, p, v, C, w;
    return {
      style: {
        background: ((n = (r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.FooterStyle) == null ? void 0 : n.backgroundColor) || ((i = (A = this.styleConfig) == null ? void 0 : A.Form) == null ? void 0 : i.backgroundColor) || ((s = (o = this.styleConfig) == null ? void 0 : o.Form) == null ? void 0 : s.background) || ((a = this.brandTheme) == null ? void 0 : a.background) || ((c = this.themeConfig) == null ? void 0 : c.backgroundColor),
        ...(u = (l = this.styleConfig) == null ? void 0 : l.Footer) == null ? void 0 : u.FooterStyle
      },
      textStyle: ((d = (f = this.styleConfig) == null ? void 0 : f.Footer) == null ? void 0 : d.FooterTextStyle) || {},
      iconStyle: ((m = (g = this.styleConfig) == null ? void 0 : g.Footer) == null ? void 0 : m.FooterIcon) || {},
      text: (v = (p = this.styleConfig) == null ? void 0 : p.Footer) == null ? void 0 : v.FooterText,
      link: (w = (C = this.styleConfig) == null ? void 0 : C.Footer) == null ? void 0 : w.FooterLink
    };
  }
  getGamifiedQuizFooterStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Footer) == null ? void 0 : r.color) || ((n = this.themeConfig) == null ? void 0 : n.secondaryColor),
      ...(A = this.styleConfig) == null ? void 0 : A.Footer,
      fontFamily: (i = this.themeConfig) == null ? void 0 : i.fontFamily
    };
  }
  getTopBarStyles(e, r) {
    var n, A;
    return {
      headingStyle: this.getHeaderStyles().heading,
      descriptionStyle: this.getHeaderStyles().description,
      iconStyle: { display: "none" },
      topbarStyle: {
        display: e && ((n = e[r]) == null ? void 0 : n.showTopBar) === !1 ? "none" : "block",
        ...(A = this.styleConfig) == null ? void 0 : A.TopBar
      }
    };
  }
}
const dOe = (t = {}, e = {}, r = {}, n = {}) => MA(
  () => new uOe(t, e, r, n),
  [t, e, r, n]
), fOe = ({
  footerText: t,
  footerLink: e,
  themeManager: r
}) => /* @__PURE__ */ h(
  "div",
  {
    className: "gamified-quiz-footer-section",
    style: r.getGamifiedQuizFooterStyles(),
    children: /* @__PURE__ */ h(
      "div",
      {
        className: "footer-content",
        onClick: () => window.open(
          e || "https://www.plgos.com/",
          "_blank"
        ),
        style: r.getGamifiedQuizFooterStyles(),
        children: t || "Powered by PLG OS"
      }
    )
  }
), hOe = ({ backgroundColor: t = "#6525B3", color: e = "white" }) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
        fill: t
      }
    )
  }
), pOe = () => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
        fill: "#B9B9B9"
      }
    )
  }
), gOe = ({
  options: t,
  checked: e,
  selectedStyle: r = { color: "#6525B3" },
  style: n,
  onChange: A = () => {
  }
}) => {
  const i = (a) => {
    s((c) => c.includes(t[a]) ? c.filter((u) => u !== t[a]) : [...c, t[a]]);
  }, [o, s] = N(e || []);
  return /* @__PURE__ */ h("div", { className: "q_multi_choice_box_G", children: t.map((a, c) => /* @__PURE__ */ k(
    "div",
    {
      style: {
        ...n,
        borderColor: (o == null ? void 0 : o.includes(a)) && (r == null ? void 0 : r.borderColor) || (n == null ? void 0 : n.borderColor)
      },
      className: "q_mult_choice_option_G",
      onClick: () => {
        i(c), A({
          target: {
            value: a,
            checked: !o.includes(a)
          }
        });
      },
      children: [
        o != null && o.includes(a) ? /* @__PURE__ */ h(hOe, { backgroundColor: r == null ? void 0 : r.accentColor }) : /* @__PURE__ */ h(pOe, {}),
        /* @__PURE__ */ h(
          "p",
          {
            className: "label-input-cont-multi_G",
            style: o != null && o.includes(a) ? r : n,
            children: a
          }
        )
      ]
    },
    c
  )) });
}, mOe = ({
  options: t,
  checked: e,
  style: r,
  selectedStyle: n,
  onChange: A = () => {
  }
}) => {
  const i = (a) => {
    s((c) => c.includes(t[a]) ? c.filter((u) => u !== t[a]) : [...c, t[a]]);
  }, [o, s] = N(e || []);
  return /* @__PURE__ */ h("div", { className: "q_multi_choice_box_2_G", children: t.map((a, c) => /* @__PURE__ */ h(
    "div",
    {
      style: {
        ...o != null && o.includes(a) ? n : r
      },
      className: o != null && o.includes(a) ? "q_mult_choice_option_2_select_G" : "q_mult_choice_option_2_G",
      onClick: () => {
        i(c), A({
          target: {
            value: a,
            checked: !o.includes(a)
          }
        });
      },
      children: a
    },
    c
  )) });
}, vOe = ({
  options: t,
  checked: e,
  onChange: r,
  style: n,
  selectedStyle: A = { accentColor: "#6525B3" },
  type: i,
  hoverBackground: o
}) => {
  const { themeConfig: s } = Xe(ct.Context), a = (u) => {
    const f = {
      target: {
        value: u,
        type: "radio",
        checked: !0
      }
    };
    r == null || r(f);
  }, c = {
    ...n,
    flexDirection: i === "modal2" ? "column" : "row",
    gap: i === "modal2" ? "12px" : "8px"
  }, l = {
    control: (u) => ({
      ...u,
      background: (c == null ? void 0 : c.background) || (c == null ? void 0 : c.backgroundColor) || "transparent",
      fontSize: (c == null ? void 0 : c.fontSize) || "14px",
      border: `${(c == null ? void 0 : c.borderWidth) || "1px"} solid ${(c == null ? void 0 : c.borderColor) || (s == null ? void 0 : s.borderColor) || "var(--neutral-grey-100, #ECECEC)"}`,
      borderRadius: "10px",
      color: (c == null ? void 0 : c.color) || (s == null ? void 0 : s.primaryColor) || "black",
      fontFamily: (c == null ? void 0 : c.fontFamily) || (s == null ? void 0 : s.fontFamily) || "'Figtree', sans-serif",
      ...c
    }),
    option: (u, { isFocused: f }) => ({
      ...u,
      backgroundColor: f ? o || "#ADD8E6" : (c == null ? void 0 : c.background) || (c == null ? void 0 : c.backgroundColor) || "#f9fafb",
      color: (c == null ? void 0 : c.color) || "black",
      fontSize: (c == null ? void 0 : c.fontSize) || "14px",
      fontFamily: (c == null ? void 0 : c.fontFamily) || (s == null ? void 0 : s.fontFamily) || "'Figtree', sans-serif"
    }),
    menu: (u) => ({
      ...u,
      backgroundColor: (c == null ? void 0 : c.background) || (c == null ? void 0 : c.backgroundColor) || "#f9fafb"
    }),
    singleValue: (u) => ({
      ...u,
      color: (c == null ? void 0 : c.color) || (s == null ? void 0 : s.primaryColor) || "black",
      fontSize: (c == null ? void 0 : c.fontSize) || "14px",
      fontFamily: (c == null ? void 0 : c.fontFamily) || (s == null ? void 0 : s.fontFamily) || "'Figtree', sans-serif"
    })
  };
  return i === "modal3" ? /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
    Gv,
    {
      isSearchable: !0,
      name: "selectbox",
      options: t.map((u) => ({ value: u, label: u })),
      onChange: r,
      styles: l,
      value: e ? { value: e, label: e } : ""
    }
  ) }) : /* @__PURE__ */ h("div", { className: "q-singlechoice-input-cont_G", style: c, children: t.map((u, f) => {
    const d = {
      border: e === u ? `1px solid ${(A == null ? void 0 : A.borderColor) || (A == null ? void 0 : A.accentColor) || "#6525B3"}` : `1px solid ${(n == null ? void 0 : n.borderColor) || "#EFEFEF"}`,
      width: i === "modal2" ? "100%" : "fit-content",
      padding: i === "modal2" ? "10px 16px" : "8px 16px",
      gap: i === "modal2" ? "8px" : "4px",
      cursor: "pointer"
    };
    return /* @__PURE__ */ k(
      "div",
      {
        className: "q_singlehoice_label_cont_G",
        style: d,
        onClick: () => a(u),
        children: [
          /* @__PURE__ */ h(
            "input",
            {
              type: "radio",
              value: u,
              checked: e === u,
              readOnly: !0,
              className: "q-singlechoice-input_G",
              style: { accentColor: (A == null ? void 0 : A.accentColor) || "#6525B3" },
              id: u
            }
          ),
          /* @__PURE__ */ h(
            "label",
            {
              style: {
                color: e === u ? (A == null ? void 0 : A.color) || (A == null ? void 0 : A.accentColor) || "#6525B3" : (n == null ? void 0 : n.color) || "#2c2c2c",
                cursor: "pointer"
              },
              htmlFor: u,
              onClick: () => a(u),
              children: u
            }
          )
        ]
      },
      f
    );
  }) });
}, qOe = ({
  question: t,
  formdata: e,
  answer: r,
  handleUpdate: n,
  handleCheckboxChange: A,
  handleRadioChange: i,
  handleRatingChange: o,
  selectedOptions: s,
  newId: a,
  themeManager: c,
  singleChoiceModal: l,
  multiChoiceModal: u,
  ratingType: f,
  validateInputRegex: d
}) => {
  var w, B, y, b, q;
  const g = t - 1, m = e[g];
  if (!m) return null;
  const p = r && m[a] && Array.isArray(r[m[a]]) ? r[m[a]][0] : null, v = m[a] || "", C = r && v && Array.isArray(r[v]) && ((w = r[v][0]) == null ? void 0 : w.value) || "";
  return c.getEmailTextStyles(), /* @__PURE__ */ h("div", { className: "gamified-quiz-action-div", children: /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-title-cont", children: /* @__PURE__ */ h("div", { className: "question-input-cont", children: /* @__PURE__ */ k("div", { className: "gamified-quiz-criteria-div", children: [
    ((m == null ? void 0 : m.type) === "USER_INPUT_SINGLE_CHOICE" || (m == null ? void 0 : m.type) === "USER_INPUT_MULTI_CHOICE") && /* @__PURE__ */ k(
      "div",
      {
        className: "question",
        style: c.getQuestionContainerStyles(),
        children: [
          m == null ? void 0 : m.question,
          `${m != null && m.required ? "*" : ""}`
        ]
      }
    ),
    m.type === "USER_INPUT_TEXT" && /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
      /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(m == null ? void 0 : m.question) || ""} ${m != null && m.required ? "*" : ""}` }),
      /* @__PURE__ */ h(
        Hi,
        {
          placeholder: (m == null ? void 0 : m.placeholder) || (m == null ? void 0 : m.question) || "",
          value: r[(m == null ? void 0 : m.actionId) || ""],
          regexKey: m == null ? void 0 : m.regexKey,
          regexMessage: m == null ? void 0 : m.regexMessage,
          validateInputRegex: (E) => (
            // console.log(validation, value.regexKey)
            d(E, m.actionId)
          ),
          errorText: c.getTextInputErrorText(),
          textErrorStyle: c.getTextInputErrorStyles(),
          onChange: (E) => n(E, m.actionId || "", ""),
          style: c.getTextInputStyles()
        }
      )
    ] }) }),
    m.type === "USER_INPUT_EMAIL" && /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "label-input-cont", children: [
      /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(m == null ? void 0 : m.question) || ""} ${m != null && m.required ? "*" : ""}` }),
      /* @__PURE__ */ h(
        Fu,
        {
          placeholder: (m == null ? void 0 : m.placeholder) || (m == null ? void 0 : m.question) || "",
          value: r[(m == null ? void 0 : m.actionId) || ""],
          iconColor: c.getEmailIconColor(),
          validateInputRegex: (E) => d(E, m.actionId),
          regexKey: m == null ? void 0 : m.regexKey,
          regexMessage: m == null ? void 0 : m.regexMessage,
          onChange: (E) => n(E, m.actionId || "", ""),
          style: c.getTextInputStyles(),
          emailtext: c.getEmailInputErrorText(),
          emailErrorStyle: c.getEMailInputErrorStyles()
        }
      )
    ] }, m == null ? void 0 : m.actionId) }),
    ((m == null ? void 0 : m.type) === "USER_INPUT_PHONE" || (m == null ? void 0 : m.type) === "USER_INPUT_NUMBER") && /* @__PURE__ */ k("div", { className: "label-input-cont-question", children: [
      /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(m == null ? void 0 : m.question) || ""} ${m != null && m.required ? "*" : ""}` }),
      /* @__PURE__ */ h(
        Tu,
        {
          placeholder: (m == null ? void 0 : m.placeholder) || (m == null ? void 0 : m.question) || "",
          value: r[m.actionId || ""],
          iconColor: c.getEmailIconColor(),
          validateInputRegex: (E) => d(E, m.actionId),
          numbertext: c.getNumberInputErrorText(),
          numberErrorStyle: c.getNumberInputErrorStyles(),
          regexKey: m == null ? void 0 : m.regexKey,
          regexMessage: m == null ? void 0 : m.regexMessage,
          onChange: (E) => n(E, m.actionId || "", ""),
          style: c.getTextInputStyles()
        },
        m == null ? void 0 : m.actionId
      )
    ] }, m.actionId),
    m.type === "USER_INPUT_DATE" && /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "label-input-cont-question", children: [
      /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(m == null ? void 0 : m.question) || ""} ${m != null && m.required ? "*" : ""}` }),
      /* @__PURE__ */ h(
        Hu,
        {
          placeholder: (m == null ? void 0 : m.placeholder) || (m == null ? void 0 : m.question) || "",
          value: r[m.actionId || ""],
          onChange: (E) => n(E, m.actionId || "", ""),
          iconColor: c.getEmailIconColor(),
          style: c.getTextInputStyles(),
          preventFutureSelection: !0,
          preventPastSelection: !1,
          minDate: "",
          maxDate: ""
        }
      )
    ] }, m.actionId) }),
    m.type === "USER_INPUT_TEXTAREA" && /* @__PURE__ */ h(Ze, { children: /* @__PURE__ */ k("div", { className: "label-input-cont-question", children: [
      /* @__PURE__ */ h(Kt, { htmlFor: "", style: c.getLabelStyles(), children: `${(m == null ? void 0 : m.question) || ""} ${m != null && m.required ? "*" : ""}` }),
      /* @__PURE__ */ h(
        Mu,
        {
          value: r[m.actionId || ""],
          onChange: (E) => n(E, m.actionId || "", ""),
          style: c.getTextAreaInputStyles(),
          textareatext: c.getTextAreaInputErrorText(),
          textareaErrorStyle: c.getTextAreaInputErrorStyles(),
          validateInputRegex: (E) => d(E, m.actionId),
          placeholder: (m == null ? void 0 : m.placeholder) || (m == null ? void 0 : m.question) || ""
        },
        m == null ? void 0 : m.actionId
      )
    ] }) }),
    m.type === "RATING" && /* @__PURE__ */ k("div", { className: "mb-4", children: [
      /* @__PURE__ */ h(
        WA,
        {
          className: "q-fd-lebels",
          style: c.getLabelStyles(),
          children: `${m.question ? m.question : "Rating Scale"}${m.required === !0 ? "*" : ""}`
        }
      ),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            marginTop: "6px"
          },
          children: /* @__PURE__ */ h(
            zv,
            {
              count: 5,
              getCurrentRating: (E) => o(m.actionId, E),
              defaultRating: Number(r[m == null ? void 0 : m.actionId]),
              RatingStyle: c.getRatingStyles(),
              type: ((B = m == null ? void 0 : m.metadata) == null ? void 0 : B.ratingType) || f,
              leftText: (y = m == null ? void 0 : m.metadata) == null ? void 0 : y.leftRatingText,
              rightText: (b = m == null ? void 0 : m.metadata) == null ? void 0 : b.rightRatingText,
              centerRatingText: (q = m == null ? void 0 : m.metadata) == null ? void 0 : q.centerRatingText
            }
          )
        }
      )
    ] }),
    m.type === "USER_INPUT_MULTI_CHOICE" && (u === "modal1" ? /* @__PURE__ */ h(
      mOe,
      {
        options: m.options,
        checked: !!s[m[a]] && s[m[a]],
        onChange: (E) => A(E.target.value, m[a]),
        style: c.getMultiChoiceBorderStyle(),
        selectedStyle: c.getMultiChoiceSelectedColorStyles()
      }
    ) : /* @__PURE__ */ h(
      gOe,
      {
        options: m.options,
        checked: s[m[a]],
        onChange: (E) => A(E.target.value, m[a]),
        style: c.getMultiChoiceStyles(),
        selectedStyle: c.getMultiChoiceSelectedStyles()
      }
    )),
    m.type === "USER_INPUT_SINGLE_CHOICE" && /* @__PURE__ */ h(
      "div",
      {
        style: {
          // width: singleChoiceModal === "modal2" ? "91%" : "100%",
        },
        children: /* @__PURE__ */ h(
          vOe,
          {
            options: m.options,
            type: l,
            checked: l === "modal3" ? C : p,
            onChange: (E) => l === "modal3" ? i(E, v, "") : i(E.target.value, v, "radio"),
            style: c.getSingleChoiceStyles(),
            hoverBackground: c.getSingleChoiceHoverStyles(),
            selectedStyle: c.getSingleChoiceSelectedStyles()
          }
        )
      }
    )
  ] }) }) }) });
}, yOe = ({
  design: t,
  sectionNo: e,
  setSectionNo: r,
  GeneralFunctions: n,
  setGamifiedQuiz: A,
  formSubmitHandler: i,
  goToNextSection: o,
  isV1Api: s,
  translatedData: a,
  translatedButton: c,
  currentSection: l,
  setCurrentSection: u,
  totalSectionsPerSectionQuestion: f,
  themeManager: d,
  formData: g
}) => {
  const m = (v, C) => v >= C - 1 || !(g != null && g.length), p = (v, C) => m(v, C) ? s && a.length > 0 ? c : "Submit" : "Next";
  return /* @__PURE__ */ h(Ze, { children: (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ k("div", { className: "gamified-quiz-header-ques-cancel-next", children: [
    /* @__PURE__ */ h(
      "button",
      {
        onClick: () => {
          e > 0 ? (r(e - 1), n.fireTrackingEvent(
            "quest_gamifiedquiz_previous_section_button_clicked",
            "gamifiedquiz"
          )) : (A(!1), n.fireTrackingEvent(
            "quest_gamifiedquiz_cancel_button_clicked",
            "gamifiedquiz"
          ));
        },
        type: "button",
        className: "cancel-btn",
        style: d.getButtonStyles().secondary,
        children: e > 0 ? "Previous" : "Cancel"
      }
    ),
    /* @__PURE__ */ h(
      yr,
      {
        type: "button",
        onClick: () => {
          const v = Object.keys(t);
          e < v.length - 1 ? (n.fireTrackingEvent(
            "quest_gamifiedquiz_next_section_button_clicked",
            "gamifiedquiz"
          ), r(e + 1)) : i();
        },
        disabled: !o,
        className: "q-onb-main-btn2",
        style: d.getButtonStyles().primary,
        children: e >= t.length - 1 ? s ? a.length > 0 ? c : "" : "Submit" : "Next"
      }
    )
  ] }) : /* @__PURE__ */ k("div", { className: "gamified-quiz-header-ques-cancel-next", children: [
    /* @__PURE__ */ h(
      "button",
      {
        onClick: () => {
          l > 0 ? (n.fireTrackingEvent(
            "quest_gamifiedquiz_previous_section_button_clicked",
            "gamifiedquiz"
          ), u(l - 1)) : (A(!1), n.fireTrackingEvent(
            "quest_gamifiedquiz_cancel_button_clicked",
            "gamifiedquiz"
          ));
        },
        type: "button",
        className: "cancel-btn",
        style: d.getButtonStyles().secondary,
        children: l > 0 ? "Previous" : "Cancel"
      }
    ),
    /* @__PURE__ */ h(
      yr,
      {
        type: "button",
        onClick: () => {
          m(l, f) ? i() : (n.fireTrackingEvent(
            "quest_gamifiedquiz_next_section_button_clicked",
            "gamifiedquiz"
          ), u(l + 1));
        },
        disabled: !o,
        className: "q-onb-main-btn2",
        style: d.getButtonStyles().primary,
        children: p(l, f)
      }
    )
  ] }) });
}, COe = (t, e, r, n, A, i, o) => {
  var s, a, c, l, u, f, d;
  for (let g = 0; g < t[e].length; g++)
    if (((s = r[t[e][g] - 1]) == null ? void 0 : s.type) === "USER_INPUT_MULTI_CHOICE") {
      const m = n[r[t[e][g] - 1][o]];
      if ((a = r[t[e][g] - 1]) != null && a.required) if ((m == null ? void 0 : m.length) > 0 && ((c = r[t[e][g] - 1]) != null && c.required))
        i(!0);
      else {
        i(!1);
        break;
      }
    } else if (((l = r[t[e][g] - 1]) == null ? void 0 : l.type) === "USER_INPUT_EMAIL") {
      const m = A[r[t[e][g] - 1][o]], p = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (typeof m == "string")
        if (p.test(m))
          i(!0);
        else {
          i(!1);
          break;
        }
    } else if ((u = r[t[e][g] - 1]) != null && u.required) if (((f = A[r[t[e][g] - 1][o]]) == null ? void 0 : f.length) > 0 && ((d = r[t[e][g] - 1]) != null && d.required))
      i(!0);
    else {
      i(!1);
      break;
    }
}, wOe = (t, e, r, n, A, i, o) => {
  var s, a, c, l, u, f, d;
  for (let g = 0; g < e; g++) {
    let m = t * e + g;
    if (((s = r[m]) == null ? void 0 : s.type) === "USER_INPUT_MULTI_CHOICE") {
      const p = n[r[m][o]];
      if ((a = r[m]) != null && a.required) if ((p == null ? void 0 : p.length) > 0 && ((c = r[m]) != null && c.required))
        i(!0);
      else {
        i(!1);
        break;
      }
    } else if (((l = r[m]) == null ? void 0 : l.type) === "USER_INPUT_EMAIL") {
      const p = A[r[m][o]], v = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (typeof p == "string")
        if (v.test(p))
          i(!0);
        else {
          i(!1);
          break;
        }
    } else if ((u = r[m]) != null && u.required) if (((f = A[r[m][o]]) == null ? void 0 : f.length) > 0 && ((d = r[m]) != null && d.required))
      i(!0);
    else {
      i(!1);
      break;
    }
  }
}, bOe = (t, e, r, n, A, i) => {
  const [o, s] = N({}), [a, c] = N(
    {}
  ), [l, u] = N(!0), [f, d] = N(!0), [g, m] = N(!1), p = (B, y) => {
    s((b) => {
      const q = b[y] || [];
      return q.includes(B) ? {
        ...b,
        [y]: q.filter((E) => E !== B)
      } : {
        ...b,
        [y]: [...q, B]
      };
    });
  }, v = (B, y) => {
    c({
      ...a,
      [B]: String(y)
    });
  }, C = (B, y) => {
    c((b) => {
      var q;
      return {
        ...b,
        [y]: (q = b[y]) != null && q.includes(B) ? [] : [B]
      };
    }), u((b) => !b);
  }, w = (B, y, b) => {
    c(b ? (q) => ({
      ...q,
      [y]: b
    }) : (q) => ({
      ...q,
      [y]: B.target.value
    }));
  };
  return le(() => {
    (t == null ? void 0 : t.length) > 0 ? COe(
      t,
      e,
      r,
      o,
      a,
      m,
      i
    ) : wOe(
      A,
      n,
      r,
      o,
      a,
      m,
      i
    );
  }, [
    a,
    e,
    l,
    f,
    A,
    r,
    t,
    o,
    n
  ]), {
    selectedOptions: o,
    answer: a,
    goToNextSection: g,
    handleCheckboxChange: p,
    handleRadioChange: C,
    handleRatingChange: v,
    handleUpdate: w,
    setGoToNextSection: m
  };
}, pP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, BOe = (t, e, r, n, A) => {
  var s;
  let i = !0, o = !0;
  if (r.required)
    switch (r.type) {
      case "USER_INPUT_MULTI_CHOICE":
        i = ((s = n[t]) == null ? void 0 : s.length) > 0;
        break;
      case "USER_INPUT_SINGLE_CHOICE":
        i = !!A[t];
        break;
      case "RATING":
        i = A[t] !== void 0 && A[t] !== "";
        break;
      case "USER_INPUT_TEXT":
      case "USER_INPUT_EMAIL":
      case "USER_INPUT_TEXTAREA":
      case "USER_INPUT_DATE":
      case "USER_INPUT_PHONE":
      case "USER_INPUT_NUMBER":
        i = e !== void 0 && e !== "";
        break;
      default:
        i = !!e;
    }
  if (r.type === "USER_INPUT_EMAIL" && e)
    if (r.regexKey)
      try {
        o = new RegExp(r.regexKey).test(e.toString());
      } catch {
        o = pP.test(e.toString());
      }
    else
      o = pP.test(e.toString());
  else if (r.regexKey && e)
    try {
      o = new RegExp(r.regexKey).test(e.toString());
    } catch {
      o = !0;
    }
  return { isValid: i, regexValid: o };
}, ZFe = ({
  heading: t,
  styleConfig: e,
  showFooter: r,
  thanksPopUpFooter: n,
  feedbackContent: A,
  footerText: i,
  footerLink: o,
  design: s = [],
  setGamifiedQuiz: a,
  gamifiedQuiz: c,
  questionsPerSection: l = 0,
  functionOnSubmit: u,
  formDataOffline: f,
  setOfflineAnswer: d,
  Headers: g,
  singleChoiceModal: m,
  multiChoiceModal: p,
  ratingType: v,
  isV1Api: C,
  translatedData: w,
  translatedButton: B,
  BrandTheme: y,
  QuestThemeData: b
}) => {
  var $, te, ae;
  const { apiType: q, themeConfig: E } = Xe(ct.Context), [x, M] = N([]), [O, I] = N(0), [S, P] = N(0), [H, F] = N(0);
  let T = new Bt("mixpanel", q);
  const U = dOe(
    y,
    e,
    E,
    b
  );
  le(() => {
    T.fireTrackingEvent(
      "quest_gamifiedquiz_offline_loaded",
      "gamifiedquiz_offline"
    ), l > 0 && I(
      Math.ceil(f.length / l)
    ), M(f);
  }, [f]);
  const D = C ? "criteriaId" : "actionId", [Q, Y] = N(!1), {
    selectedOptions: j,
    answer: Z,
    goToNextSection: W,
    handleCheckboxChange: R,
    handleRadioChange: K,
    handleRatingChange: L,
    handleUpdate: G,
    setGoToNextSection: V
  } = bOe(
    s,
    H,
    x,
    l,
    S,
    D
  ), _ = () => {
    T.fireTrackingEvent(
      "quest_gamifiedquiz_offline_submit_button_clicked",
      "gamifiedquiz_offline"
    );
    for (const se in j)
      j.hasOwnProperty(se) && (Z[se] = j[se]);
    u(), d(Z), Y(!0);
  }, [J, X] = N({}), ne = () => {
    if (s[H]) {
      const se = {};
      s[H].forEach((fe) => {
        const ve = f[fe - 1];
        if (ve) {
          const ge = Z[ve[D]], oe = BOe(
            ve[D],
            ge,
            ve,
            j,
            Z
          );
          se[ve[D]] = oe;
        }
      }), X(se);
      const ue = Object.values(se).every(
        (fe) => fe.isValid && fe.regexValid
      );
      V(ue);
    }
  }, ee = (se, ue) => {
    if (!J[ue]) return;
    X((ve) => ({
      ...ve,
      [ue]: {
        ...ve[ue],
        regexValid: se
      }
    }));
    const fe = Object.values({
      ...J,
      [ue]: {
        ...J[ue],
        regexValid: se
      }
    }).every((ve) => ve.isValid && ve.regexValid);
    V(fe);
  };
  if (le(() => {
    ne();
  }, [Z, j, H]), f.length != 0)
    return /* @__PURE__ */ k(Ze, { children: [
      Q ? /* @__PURE__ */ h(
        lOe,
        {
          setThanksPopup: Y,
          setGamifiedQuiz: a,
          feedbackContent: A,
          thanksPopUpFooter: n,
          footerText: i,
          GeneralFunctions: T,
          popUpHead: A == null ? void 0 : A.FeedbackHeading,
          popUpMessage: A == null ? void 0 : A.FeedbackDescription,
          themeManager: U
        }
      ) : null,
      c && !Q ? /* @__PURE__ */ h("div", { className: "upper-div", children: /* @__PURE__ */ k(
        "div",
        {
          className: "gamified-quiz",
          style: U.getFormStyles(),
          children: [
            /* @__PURE__ */ k(
              "div",
              {
                className: "gamified-quiz-header-section",
                children: [
                  /* @__PURE__ */ h("div", { className: "gamified-quiz-title-section", children: /* @__PURE__ */ h(
                    "div",
                    {
                      className: "gamified-quiz-title-head",
                      style: U.getHeaderStyles().heading,
                      children: t || "Choose an option"
                    }
                  ) }),
                  /* @__PURE__ */ k("div", { className: "div", children: [
                    /* @__PURE__ */ h("div", { className: "gamified-quiz-header-task-logo-cont", children: /* @__PURE__ */ h("img", { src: cj, alt: "" }) }),
                    /* @__PURE__ */ k(
                      "div",
                      {
                        className: "gamified-quiz-header-form",
                        style: e == null ? void 0 : e.FormContainer,
                        children: [
                          /* @__PURE__ */ k("div", { className: "gamified-quiz-header-form-container", children: [
                            /* @__PURE__ */ k("div", { className: "heading-subheading-container", children: [
                              /* @__PURE__ */ h(
                                "div",
                                {
                                  className: "quest-title",
                                  style: U.getSubHeadingStyles(),
                                  children: g && g.length > 0 && (($ = g[H]) != null && $.heading) ? (te = g[H]) == null ? void 0 : te.heading : "Fill out the Details"
                                }
                              ),
                              g && (g == null ? void 0 : g.length) > 0 && ((ae = g[H]) == null ? void 0 : ae.subHeading) && /* @__PURE__ */ h(
                                "div",
                                {
                                  className: "question",
                                  style: U.getQuestionStyles(),
                                  children: g[H].subHeading || "Fill out the Details"
                                }
                              )
                            ] }),
                            (s == null ? void 0 : s.length) > 0 && s[H].map((se, ue) => /* @__PURE__ */ h(
                              qOe,
                              {
                                question: se,
                                formdata: f,
                                answer: Z,
                                handleUpdate: G,
                                styleConfig: e,
                                themeConfig: E,
                                questThemeData: b,
                                handleCheckboxChange: R,
                                handleRadioChange: K,
                                handleRatingChange: L,
                                selectedOptions: j,
                                newId: D,
                                themeManager: U,
                                singleChoiceModal: m,
                                multiChoiceModal: p,
                                ratingType: v,
                                validateInputRegex: ee
                              },
                              ue
                            ))
                          ] }),
                          /* @__PURE__ */ h(
                            yOe,
                            {
                              design: s,
                              sectionNo: H,
                              setSectionNo: F,
                              GeneralFunctions: T,
                              setGamifiedQuiz: a,
                              formSubmitHandler: _,
                              goToNextSection: W,
                              isV1Api: C,
                              translatedData: w,
                              translatedButton: B,
                              currentSection: S,
                              setCurrentSection: P,
                              totalSectionsPerSectionQuestion: O,
                              themeManager: U,
                              formData: f
                            }
                          )
                        ]
                      }
                    )
                  ] })
                ]
              }
            ),
            r && /* @__PURE__ */ h(
              fOe,
              {
                footerText: i,
                footerLink: o,
                themeManager: U
              }
            )
          ]
        }
      ) }) : null
    ] });
}, EOe = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='22'%20height='24'%20viewBox='0%200%2018%2020'%20fill='none'%20%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.17157%201.17157C0%202.34315%200%204.22876%200%208V12C0%2015.7712%200%2017.6569%201.17157%2018.8284C2.34315%2020%204.22876%2020%208%2020H10C13.7712%2020%2015.6569%2020%2016.8284%2018.8284C18%2017.6569%2018%2015.7712%2018%2012V8C18%204.22876%2018%202.34315%2016.8284%201.17157C15.6569%200%2013.7712%200%2010%200H8C4.22876%200%202.34315%200%201.17157%201.17157ZM5%207.25C4.58579%207.25%204.25%207.58579%204.25%208C4.25%208.41421%204.58579%208.75%205%208.75H13C13.4142%208.75%2013.75%208.41421%2013.75%208C13.75%207.58579%2013.4142%207.25%2013%207.25H5ZM5%2011.25C4.58579%2011.25%204.25%2011.5858%204.25%2012C4.25%2012.4142%204.58579%2012.75%205%2012.75H10C10.4142%2012.75%2010.75%2012.4142%2010.75%2012C10.75%2011.5858%2010.4142%2011.25%2010%2011.25H5Z'%20fill='white'%20/%3e%3c/svg%3e", JFe = (t) => {
  var ce, pe;
  const {
    userId: e,
    token: r,
    questId: n,
    styleConfig: A,
    contentConfig: i,
    BrandTheme: o,
    QuestThemeData: s,
    showFooter: a,
    ChildQuest: c = [],
    ParentQuest: l,
    entityLogo: u,
    defaultAutoPopupMessages: f,
    footerText: d,
    footerLink: g,
    popupOpenDelay: m = 2
  } = t, { apiKey: p, entityId: v, featureFlags: C, apiType: w, themeConfig: B } = Xe(
    ct.Context
  );
  let y = w == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  const [b, q] = N("Home"), [E, x] = N(!0), [M, O] = N([]), [I, S] = N([]), [P, H] = N(!0), [F, T] = N(!0), [U, D] = N(0), [Q, Y] = N([]), [j, Z] = N(
    []
  ), [W, R] = N([]), [K, L] = N([]), [G, V] = N(!1), [_, J] = N(""), [X, ne] = N(""), [ee, $] = N(""), [te, ae] = N(!1), [se, ue] = N(!1), fe = gt(E);
  le(() => {
    E == !0 && (fe.current = E);
  }, [E]), le(() => {
    if (f != null && f.length) {
      const qe = setTimeout(() => {
        fe.current === !1 && ae(!0);
      }, m * 1e3);
      return () => clearTimeout(qe);
    }
  }, []), le(() => {
    E == !0 && ae(!1);
  }, [E]), le(() => {
    ee != "" && (x(!0), q("Chat"));
  }, [ee]);
  const ve = (qe) => qe == null ? void 0 : qe.sort((Te, be) => {
    var He, Ge;
    return new Date((He = be == null ? void 0 : be.conversations) == null ? void 0 : He.timestamp).getTime() - new Date((Ge = Te == null ? void 0 : Te.conversations) == null ? void 0 : Ge.timestamp).getTime();
  }), ge = async () => {
    V(!0);
    let qe = await fy(
      y,
      v,
      e,
      r,
      p,
      "",
      "",
      "",
      w
    );
    R(ve(qe == null ? void 0 : qe.data)), L(ve(qe == null ? void 0 : qe.data)), V(!1);
  };
  le(() => {
    ge();
  }, []), le(() => {
    var qe;
    D(
      Math.ceil(
        100 * ((I == null ? void 0 : I.length) / ((qe = c[3]) == null ? void 0 : qe.length))
      )
    );
  }, [I]);
  const oe = async () => {
    let qe = n || "q-default-helphub", { data: Se } = await ij(
      y,
      v,
      qe,
      e,
      r,
      p
    );
    J(Se.imageUrl), ne(Se.name);
  };
  return le(() => {
    oe();
  }, []), le(() => {
    Q == null || Q.filter((qe) => qe.completed === !0).map((qe) => qe.criteriaId);
  }, [Q]), le(() => {
    j.filter((qe) => qe.completed === !0).map((qe) => qe.criteriaId);
  }, [j]), /* @__PURE__ */ h(
    "div",
    {
      style: { fontFamily: B.fontFamily || "'Figtree', sans-serif" },
      children: /* @__PURE__ */ k("div", { className: "helphubIconUpperCont", style: { position: "static" }, children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "helhubIconCont",
            onClick: () => x((qe) => !qe),
            style: { display: "none" },
            children: /* @__PURE__ */ h("img", { src: EOe })
          }
        ),
        E && /* @__PURE__ */ k(
          "div",
          {
            id: "helpHub",
            className: "helpHubMainCont animated",
            style: {
              height: (ce = A == null ? void 0 : A.Main) == null ? void 0 : ce.height,
              width: (pe = A == null ? void 0 : A.Main) == null ? void 0 : pe.width,
              borderRadius: (s == null ? void 0 : s.borderRadius) || (o == null ? void 0 : o.borderRadius),
              position: "static"
            },
            children: [
              b === "Home" ? /* @__PURE__ */ h(
                am,
                {
                  questsData: c,
                  setSelectedSection: q,
                  parentQuest: l,
                  userId: e,
                  token: r,
                  styleConfig: A,
                  contentConfig: i == null ? void 0 : i.Home,
                  claimStatusTasks: I,
                  taskStatus: U,
                  onlineComponent: !1,
                  showFeedback: P,
                  setShowFeedback: H,
                  entityImage: u || _,
                  BrandTheme: o,
                  QuestThemeData: s
                }
              ) : "",
              b === "Chat" ? /* @__PURE__ */ h(
                cm,
                {
                  contentConfig: i == null ? void 0 : i.Chat,
                  apiType: w,
                  entityId: v,
                  userId: e,
                  token: r,
                  apiKey: p,
                  styleConfig: A,
                  showBottomNavigation: F,
                  setShowBottomNavigation: T,
                  entityImage: u || _,
                  entityName: X,
                  chat: W,
                  setChat: R,
                  filterChat: K,
                  setFilterChat: L,
                  sendAutoMessage: ee,
                  fetchData: G,
                  setFetchData: V,
                  setHelpHub: x,
                  setOpenCloseChatPopup: ue,
                  openCloseChatPopup: se,
                  BrandTheme: o,
                  QuestThemeData: s
                }
              ) : "",
              b === "Help" ? /* @__PURE__ */ h(
                lm,
                {
                  faqData: c != null && c.length ? c[1] : [],
                  styleConfig: A,
                  contentConfig: i == null ? void 0 : i.Help,
                  setHelpHub: x,
                  BrandTheme: o,
                  QuestThemeData: s
                }
              ) : "",
              b === "Updates" ? /* @__PURE__ */ h(
                dm,
                {
                  updateData: c != null && c.length ? c[2] : [],
                  contentConfig: i == null ? void 0 : i.Updates,
                  styleConfig: A,
                  questId: (l == null ? void 0 : l.childQuestIDs[2]) || "",
                  userId: e,
                  token: r,
                  claimStatusUpdates: M,
                  setClaimStatusUpdates: O,
                  onlineComponent: !1,
                  showBottomNavigation: F,
                  setShowBottomNavigation: T,
                  entityImage: _,
                  campaignVariationId: "",
                  setHelpHub: x,
                  BrandTheme: o,
                  QuestThemeData: s
                }
              ) : "",
              b === "Tasks" ? /* @__PURE__ */ h(
                um,
                {
                  tasksData: c != null && c.length ? c[3] : [],
                  contentConfig: i == null ? void 0 : i.Tasks,
                  styleConfig: A,
                  questId: (l == null ? void 0 : l.childQuestIDs[3]) || "",
                  userId: e,
                  token: r,
                  claimStatusTasks: I,
                  setClaimStatusTasks: S,
                  onlineComponent: !1,
                  campaignVariationId: "",
                  setHelpHub: x,
                  BrandTheme: o,
                  QuestThemeData: s
                }
              ) : "",
              /* @__PURE__ */ k("div", { className: "helphubBottomCont", children: [
                /* @__PURE__ */ h(
                  "div",
                  {
                    className: `helphubSvgCont ${F ? "showNav" : "hideNav"}`,
                    children: /* @__PURE__ */ k(
                      "div",
                      {
                        className: `${F ? "showNav" : "hideNav"}`,
                        children: [
                          /* @__PURE__ */ k("div", { onClick: () => q("Home"), children: [
                            /* @__PURE__ */ h(
                              Nn,
                              {
                                type: "home",
                                primaryColor: b == "Home" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#B9B9B9",
                                secondaryColor: b == "Home" ? "white" : "#B9B9B9"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: b == "Home" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#b9b9b9",
                                  fontWeight: b == "Home" ? "600" : "400"
                                },
                                className: "helphubSvgTitle",
                                children: "Home"
                              }
                            )
                          ] }),
                          /* @__PURE__ */ k("div", { onClick: () => q("Chat"), children: [
                            /* @__PURE__ */ h(
                              Nn,
                              {
                                type: "Chat",
                                primaryColor: b == "Chat" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#B9B9B9",
                                secondaryColor: b == "Chat" ? "white" : "#B9B9B9"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: b == "Chat" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#b9b9b9",
                                  fontWeight: b == "Chat" ? "600" : "400"
                                },
                                className: "helphubSvgTitle",
                                children: "Chat"
                              }
                            )
                          ] }),
                          /* @__PURE__ */ k("div", { onClick: () => q("Help"), children: [
                            /* @__PURE__ */ h(
                              Nn,
                              {
                                type: "Help",
                                primaryColor: b == "Help" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#B9B9B9",
                                secondaryColor: b == "Help" ? "white" : "#B9B9B9"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: b == "Help" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#b9b9b9",
                                  fontWeight: b == "Help" ? "600" : "400"
                                },
                                className: "helphubSvgTitle",
                                children: "FAQs"
                              }
                            )
                          ] }),
                          /* @__PURE__ */ k("div", { onClick: () => q("Updates"), children: [
                            /* @__PURE__ */ h(
                              Nn,
                              {
                                type: "Updates",
                                primaryColor: b == "Updates" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#B9B9B9",
                                secondaryColor: b == "Updates" ? "white" : "#B9B9B9"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: b == "Updates" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#b9b9b9",
                                  fontWeight: b == "Updates" ? "600" : "400"
                                },
                                className: "helphubSvgTitle",
                                children: "Updates"
                              }
                            )
                          ] }),
                          /* @__PURE__ */ k("div", { onClick: () => q("Tasks"), children: [
                            /* @__PURE__ */ h(
                              Nn,
                              {
                                type: "Tasks",
                                primaryColor: b == "Tasks" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#B9B9B9",
                                secondaryColor: b == "Tasks" ? "white" : "#B9B9B9"
                              }
                            ),
                            /* @__PURE__ */ h(
                              "div",
                              {
                                style: {
                                  color: b == "Tasks" ? (A == null ? void 0 : A.FooterIconsColor) || (s == null ? void 0 : s.accentColor) || "#9035FF" : "#b9b9b9",
                                  fontWeight: b == "Tasks" ? "600" : "400"
                                },
                                className: "helphubSvgTitle",
                                children: "Tasks"
                              }
                            )
                          ] })
                        ]
                      }
                    )
                  }
                ),
                a != !1 && /* @__PURE__ */ k(
                  "div",
                  {
                    className: "helphubFooterCont",
                    onClick: () => {
                      window.open(g || "https://www.plgos.com/");
                    },
                    children: [
                      /* @__PURE__ */ h("div", { className: "helphubFooterText", children: d || "Powered by PLG OS" }),
                      /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(Nn, { type: "footerLogo" }) })
                    ]
                  }
                )
              ] })
            ]
          }
        )
      ] })
    }
  );
};
function uj({
  onChange: t,
  count: e,
  style: r,
  buttonStyle: n,
  selectedButtonStyle: A,
  initialState: i = -1
}) {
  const [o, s] = N(i), a = gt(Array(e).fill(0)).current, c = (l) => {
    s(l), t({ total: a.length, rate: l + 1 });
  };
  return /* @__PURE__ */ h("div", { className: "feedbackNumberContainer", style: { ...r }, children: a.map((l, u) => /* @__PURE__ */ h("div", { className: o == u ? "feedbackNumberSelected" : void 0, onClick: () => c(u), style: { ...o == u ? A : n }, children: u + 1 }, u)) });
}
const xOe = /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 25 25", fill: "none", children: [
  /* @__PURE__ */ k("g", { clipPath: "url(#clip0_8974_37200)", children: [
    /* @__PURE__ */ h("path", { d: "M12.658 23.999C19.0092 23.999 24.158 18.8502 24.158 12.499C24.158 6.1477 19.0092 0.998978 12.658 0.998978C6.30668 0.998978 1.15796 6.1477 1.15796 12.499C1.15796 18.8502 6.30668 23.999 12.658 23.999Z", fill: "#FFCE52" }),
    /* @__PURE__ */ h("path", { d: "M11.1509 18.4987L10.1509 18.4917C10.1509 16.9127 13.6084 16.4917 15.6509 16.4917V17.4917C12.7214 17.4917 11.2244 18.2212 11.1509 18.4987Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M20.2321 8.46336C20.2111 8.42636 20.1851 8.39236 20.1621 8.35636V9.00336C20.1621 9.26857 20.0568 9.52293 19.8692 9.71046C19.6817 9.898 19.4273 10.0034 19.1621 10.0034C18.8969 10.0034 18.6425 9.898 18.455 9.71046C18.2675 9.52293 18.1621 9.26857 18.1621 9.00336V8.00336H15.4321C14.9351 8.55073 14.6605 9.26401 14.6621 10.0034C14.6621 10.799 14.9782 11.5621 15.5408 12.1247C16.1034 12.6873 16.8665 13.0034 17.6621 13.0034C18.4578 13.0034 19.2208 12.6873 19.7834 12.1247C20.346 11.5621 20.6621 10.799 20.6621 10.0034C20.664 9.46012 20.5152 8.92701 20.2321 8.46336Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M19.1643 10.0034C19.4295 10.0034 19.6839 9.898 19.8714 9.71046C20.059 9.52293 20.1643 9.26857 20.1643 9.00336V8.35636C20.0847 8.2311 19.9943 8.113 19.8943 8.00336H18.1643V9.00336C18.1643 9.26857 18.2697 9.52293 18.4572 9.71046C18.6447 9.898 18.8991 10.0034 19.1643 10.0034Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M10.2302 8.46336C10.2092 8.42636 10.1832 8.39236 10.1602 8.35636V9.00336C10.1602 9.26857 10.0548 9.52293 9.86727 9.71046C9.67973 9.898 9.42538 10.0034 9.16016 10.0034C8.89495 10.0034 8.64059 9.898 8.45306 9.71046C8.26552 9.52293 8.16016 9.26857 8.16016 9.00336V8.00336H5.43016C4.93316 8.55073 4.65854 9.26401 4.66016 10.0034C4.66016 10.799 4.97623 11.5621 5.53884 12.1247C6.10145 12.6873 6.86451 13.0034 7.66016 13.0034C8.45581 13.0034 9.21887 12.6873 9.78148 12.1247C10.3441 11.5621 10.6602 10.799 10.6602 10.0034C10.6621 9.46012 10.5132 8.92701 10.2302 8.46336Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M9.16235 10.0034C9.42757 10.0034 9.68192 9.898 9.86946 9.71046C10.057 9.52293 10.1624 9.26857 10.1624 9.00336V8.35636C10.0827 8.2311 9.99239 8.113 9.89235 8.00336H8.16235V9.00336C8.16235 9.26857 8.26771 9.52293 8.45525 9.71046C8.64278 9.898 8.89714 10.0034 9.16235 10.0034Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M12.6455 2.49261C18.7205 2.49261 23.6455 6.74611 23.6455 11.9926H24.133C23.9951 9.03864 22.7246 6.2513 20.5854 4.20957C18.4462 2.16784 15.6026 1.02866 12.6455 1.02866C9.68827 1.02866 6.84474 2.16784 4.70551 4.20957C2.56629 6.2513 1.2958 9.03864 1.15796 11.9926H1.64546C1.64546 6.74611 6.57046 2.49261 12.6455 2.49261Z", fill: "#FFE369" }),
    /* @__PURE__ */ h("path", { d: "M23.658 12.0101C23.658 17.2566 18.733 21.5101 12.658 21.5101C6.58296 21.5101 1.65796 17.2566 1.65796 12.0101H1.17046C1.16346 12.1761 1.15796 12.3426 1.15796 12.5101C1.15796 15.5601 2.36956 18.4852 4.52623 20.6418C6.6829 22.7985 9.60797 24.0101 12.658 24.0101C15.7079 24.0101 18.633 22.7985 20.7897 20.6418C22.9464 18.4852 24.158 15.5601 24.158 12.5101C24.158 12.3426 24.1525 12.1761 24.1455 12.0101H23.658Z", fill: "#FFB32B" }),
    /* @__PURE__ */ h("path", { d: "M19.2977 5.15441C19.4587 4.99326 19.4075 4.68097 19.1833 4.45689C18.959 4.23281 18.6467 4.18179 18.4857 4.34294C18.3246 4.50408 18.3759 4.81637 18.6001 5.04046C18.8244 5.26454 19.1367 5.31556 19.2977 5.15441Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M15.9889 2.71437C16.0699 2.63326 16.0442 2.47618 15.9315 2.36352C15.8188 2.25086 15.6617 2.22529 15.5806 2.30641C15.4995 2.38752 15.5252 2.5446 15.638 2.65726C15.7507 2.76992 15.9078 2.79549 15.9889 2.71437Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M18.2058 4.56183C18.5278 4.23954 18.4252 3.6148 17.9765 3.16644C17.5278 2.71808 16.903 2.61588 16.581 2.93818C16.2589 3.26047 16.3615 3.88521 16.8102 4.33357C17.2589 4.78193 17.8837 4.88413 18.2058 4.56183Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M17.6602 12.9988C16.953 12.9982 16.2688 12.7477 15.7283 12.2917C15.1878 11.8356 14.8258 11.2033 14.7062 10.5063C14.6303 10.9378 14.6498 11.3808 14.7634 11.8039C14.8771 12.2271 15.082 12.6202 15.3638 12.9557C15.6457 13.2912 15.9976 13.5609 16.3948 13.7458C16.792 13.9307 17.2249 14.0263 17.6631 14.026C18.1012 14.0256 18.534 13.9293 18.931 13.7438C19.3279 13.5583 19.6794 13.2881 19.9607 12.9522C20.2421 12.6163 20.4464 12.2229 20.5594 11.7995C20.6723 11.3762 20.6912 10.9332 20.6147 10.5018C20.496 11.1997 20.1343 11.8331 19.5936 12.2901C19.0529 12.7471 18.3681 12.9981 17.6602 12.9988ZM7.66016 12.9988C6.95298 12.9982 6.26877 12.7477 5.72828 12.2917C5.1878 11.8356 4.82579 11.2033 4.70616 10.5063C4.63026 10.9378 4.64981 11.3808 4.76343 11.8039C4.87705 12.2271 5.08199 12.6202 5.36383 12.9557C5.64567 13.2912 5.99757 13.5609 6.3948 13.7458C6.79203 13.9307 7.22494 14.0263 7.6631 14.026C8.10125 14.0256 8.53401 13.9293 8.93096 13.7438C9.32791 13.5583 9.6794 13.2881 9.96073 12.9522C10.2421 12.6163 10.4464 12.2229 10.5594 11.7995C10.6723 11.3762 10.6912 10.9332 10.6147 10.5018C10.496 11.1997 10.1343 11.8331 9.59362 12.2901C9.05294 12.7471 8.36808 12.9981 7.66016 12.9988ZM18.1602 7.99881H19.8902C19.9902 8.10845 20.0805 8.22656 20.1602 8.35181C20.1832 8.38781 20.2102 8.42181 20.2302 8.45881C20.4734 8.86147 20.6159 9.31684 20.6457 9.78631C20.6547 9.69181 20.6602 9.59581 20.6602 9.49881C20.6621 8.95558 20.5132 8.42247 20.2302 7.95881C20.2092 7.92181 20.1832 7.88781 20.1602 7.85181C20.0805 7.72656 19.9902 7.60845 19.8902 7.49881H15.4302C14.9332 8.04618 14.6585 8.75947 14.6602 9.49881C14.6603 9.6047 14.6659 9.71052 14.6772 9.81581C14.714 9.14208 14.9796 8.50109 15.4302 7.99881H18.1602ZM8.16016 7.99881H9.89016C9.9902 8.10845 10.0805 8.22656 10.1602 8.35181C10.1832 8.38781 10.2102 8.42181 10.2302 8.45881C10.4734 8.86147 10.6159 9.31684 10.6457 9.78631C10.6547 9.69181 10.6602 9.59581 10.6602 9.49881C10.6621 8.95558 10.5132 8.42247 10.2302 7.95881C10.2092 7.92181 10.1832 7.88781 10.1602 7.85181C10.0805 7.72656 9.9902 7.60845 9.89016 7.49881H5.43016C4.93316 8.04618 4.65854 8.75947 4.66016 9.49881C4.66026 9.6047 4.66594 9.71052 4.67716 9.81581C4.714 9.14208 4.97963 8.50109 5.43016 7.99881H8.16016Z", fill: "#FBB40A" })
  ] }),
  /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_8974_37200", children: /* @__PURE__ */ h("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.599976 0.5)" }) }) })
] }), IOe = /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 25 25", fill: "none", children: [
  /* @__PURE__ */ k("g", { clipPath: "url(#clip0_8974_37215)", children: [
    /* @__PURE__ */ h("path", { d: "M12.7903 23.999C19.1416 23.999 24.2903 18.8502 24.2903 12.499C24.2903 6.1477 19.1416 0.998978 12.7903 0.998978C6.43901 0.998978 1.29028 6.1477 1.29028 12.499C1.29028 18.8502 6.43901 23.999 12.7903 23.999Z", fill: "#FFCE52" }),
    /* @__PURE__ */ h("path", { d: "M17.2739 11.4988C18.1024 11.4988 18.7739 10.6034 18.7739 9.49881C18.7739 8.39424 18.1024 7.49881 17.2739 7.49881C16.4455 7.49881 15.7739 8.39424 15.7739 9.49881C15.7739 10.6034 16.4455 11.4988 17.2739 11.4988Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M8.31067 11.4988C9.1391 11.4988 9.81067 10.6034 9.81067 9.49881C9.81067 8.39424 9.1391 7.49881 8.31067 7.49881C7.48224 7.49881 6.81067 8.39424 6.81067 9.49881C6.81067 10.6034 7.48224 11.4988 8.31067 11.4988Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M17.3081 11.0034C17.8604 11.0034 18.3081 10.3318 18.3081 9.50336C18.3081 8.67493 17.8604 8.00336 17.3081 8.00336C16.7558 8.00336 16.3081 8.67493 16.3081 9.50336C16.3081 10.3318 16.7558 11.0034 17.3081 11.0034Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M8.28552 11.0034C8.83781 11.0034 9.28552 10.3318 9.28552 9.50336C9.28552 8.67493 8.83781 8.00336 8.28552 8.00336C7.73324 8.00336 7.28552 8.67493 7.28552 9.50336C7.28552 10.3318 7.73324 11.0034 8.28552 11.0034Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M17.7876 9.5079C18.0637 9.5079 18.2876 9.28405 18.2876 9.0079C18.2876 8.73176 18.0637 8.5079 17.7876 8.5079C17.5115 8.5079 17.2876 8.73176 17.2876 9.0079C17.2876 9.28405 17.5115 9.5079 17.7876 9.5079Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M8.79468 9.5079C9.07082 9.5079 9.29468 9.28405 9.29468 9.0079C9.29468 8.73176 9.07082 8.5079 8.79468 8.5079C8.51854 8.5079 8.29468 8.73176 8.29468 9.0079C8.29468 9.28405 8.51854 9.5079 8.79468 9.5079Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M12.7778 2.49261C18.8528 2.49261 23.7778 6.74611 23.7778 11.9926H24.2653C24.1274 9.03864 22.857 6.2513 20.7177 4.20957C18.5785 2.16784 15.735 1.02866 12.7778 1.02866C9.8206 1.02866 6.97706 2.16784 4.83784 4.20957C2.69861 6.2513 1.42813 9.03864 1.29028 11.9926H1.77778C1.77778 6.74611 6.70278 2.49261 12.7778 2.49261Z", fill: "#FFE369" }),
    /* @__PURE__ */ h("path", { d: "M23.7903 12.0101C23.7903 17.2566 18.8653 21.5101 12.7903 21.5101C6.71528 21.5101 1.79028 17.2566 1.79028 12.0101H1.30278C1.29578 12.1761 1.29028 12.3426 1.29028 12.5101C1.29028 15.5601 2.50189 18.4852 4.65855 20.6418C6.81522 22.7985 9.74029 24.0101 12.7903 24.0101C15.8403 24.0101 18.7653 22.7985 20.922 20.6418C23.0787 18.4852 24.2903 15.5601 24.2903 12.5101C24.2903 12.3426 24.2848 12.1761 24.2778 12.0101H23.7903Z", fill: "#FFB32B" }),
    /* @__PURE__ */ h("path", { d: "M16.7992 16.4917H8.79919V17.4917H16.7992V16.4917Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M19.6971 5.4067C19.8582 5.24555 19.8069 4.93326 19.5827 4.70918C19.3584 4.4851 19.0461 4.43408 18.8851 4.59523C18.7241 4.75637 18.7753 5.06866 18.9995 5.29275C19.2238 5.51683 19.5361 5.56785 19.6971 5.4067Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M16.3883 2.95182C16.4693 2.8707 16.4437 2.71362 16.3309 2.60096C16.2182 2.4883 16.0611 2.46273 15.98 2.54385C15.899 2.62496 15.9246 2.78205 16.0374 2.8947C16.1501 3.00736 16.3072 3.03293 16.3883 2.95182Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M18.6052 4.79926C18.9272 4.47697 18.8246 3.85222 18.3759 3.40386C17.9273 2.9555 17.3024 2.85331 16.9804 3.1756C16.6583 3.4979 16.7609 4.12264 17.2096 4.571C17.6583 5.01936 18.2831 5.12156 18.6052 4.79926Z", fill: "#F6FAFD" })
  ] }),
  /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_8974_37215", children: /* @__PURE__ */ h("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.799927 0.5)" }) }) })
] }), SOe = /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", children: [
  /* @__PURE__ */ k("g", { clipPath: "url(#clip0_8974_37231)", children: [
    /* @__PURE__ */ h("path", { d: "M11.9969 23.999C18.3482 23.999 23.4969 18.8502 23.4969 12.499C23.4969 6.1477 18.3482 0.998978 11.9969 0.998978C5.64567 0.998978 0.496948 6.1477 0.496948 12.499C0.496948 18.8502 5.64567 23.999 11.9969 23.999Z", fill: "#FFCE52" }),
    /* @__PURE__ */ h("path", { d: "M16.4806 11.4988C17.309 11.4988 17.9806 10.6034 17.9806 9.49881C17.9806 8.39424 17.309 7.49881 16.4806 7.49881C15.6522 7.49881 14.9806 8.39424 14.9806 9.49881C14.9806 10.6034 15.6522 11.4988 16.4806 11.4988Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M7.51733 11.4988C8.34576 11.4988 9.01733 10.6034 9.01733 9.49881C9.01733 8.39424 8.34576 7.49881 7.51733 7.49881C6.68891 7.49881 6.01733 8.39424 6.01733 9.49881C6.01733 10.6034 6.68891 11.4988 7.51733 11.4988Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M16.5148 11.0034C17.0671 11.0034 17.5148 10.3318 17.5148 9.50336C17.5148 8.67493 17.0671 8.00336 16.5148 8.00336C15.9625 8.00336 15.5148 8.67493 15.5148 9.50336C15.5148 10.3318 15.9625 11.0034 16.5148 11.0034Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M7.49219 11.0034C8.04447 11.0034 8.49219 10.3318 8.49219 9.50336C8.49219 8.67493 8.04447 8.00336 7.49219 8.00336C6.9399 8.00336 6.49219 8.67493 6.49219 9.50336C6.49219 10.3318 6.9399 11.0034 7.49219 11.0034Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M16.9943 9.5079C17.2704 9.5079 17.4943 9.28405 17.4943 9.0079C17.4943 8.73176 17.2704 8.5079 16.9943 8.5079C16.7181 8.5079 16.4943 8.73176 16.4943 9.0079C16.4943 9.28405 16.7181 9.5079 16.9943 9.5079Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M8.00134 9.5079C8.27749 9.5079 8.50134 9.28405 8.50134 9.0079C8.50134 8.73176 8.27749 8.5079 8.00134 8.5079C7.7252 8.5079 7.50134 8.73176 7.50134 9.0079C7.50134 9.28405 7.7252 9.5079 8.00134 9.5079Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M12.0083 19.9941C8.1483 19.9941 5.0083 17.0781 5.0083 13.4941H6.0083C6.0083 16.5266 8.6998 18.9941 12.0083 18.9941C15.3168 18.9941 18.0083 16.5266 18.0083 13.4941H19.0083C19.0083 17.0781 15.8683 19.9941 12.0083 19.9941Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M11.9844 2.49261C18.0594 2.49261 22.9844 6.74611 22.9844 11.9926H23.4719C23.3341 9.03864 22.0636 6.2513 19.9244 4.20957C17.7852 2.16784 14.9416 1.02866 11.9844 1.02866C9.02726 1.02866 6.18373 2.16784 4.0445 4.20957C1.90528 6.2513 0.63479 9.03864 0.496948 11.9926H0.984448C0.984448 6.74611 5.90945 2.49261 11.9844 2.49261Z", fill: "#FFE369" }),
    /* @__PURE__ */ h("path", { d: "M22.9969 12.0101C22.9969 17.2566 18.0719 21.5101 11.9969 21.5101C5.92195 21.5101 0.996948 17.2566 0.996948 12.0101H0.509448C0.502448 12.1761 0.496948 12.3426 0.496948 12.5101C0.496948 15.5601 1.70855 18.4852 3.86522 20.6418C6.02189 22.7985 8.94696 24.0101 11.9969 24.0101C15.0469 24.0101 17.972 22.7985 20.1287 20.6418C22.2853 18.4852 23.4969 15.5601 23.4969 12.5101C23.4969 12.3426 23.4914 12.1761 23.4844 12.0101H22.9969Z", fill: "#FFB32B" }),
    /* @__PURE__ */ h("path", { d: "M18.9038 5.4067C19.0648 5.24555 19.0136 4.93326 18.7894 4.70918C18.5651 4.4851 18.2528 4.43408 18.0918 4.59523C17.9307 4.75637 17.982 5.06866 18.2062 5.29275C18.4304 5.51683 18.7428 5.56785 18.9038 5.4067Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M15.5949 2.95182C15.676 2.8707 15.6503 2.71362 15.5376 2.60096C15.4248 2.4883 15.2677 2.46273 15.1867 2.54385C15.1056 2.62496 15.1313 2.78205 15.244 2.8947C15.3568 3.00736 15.5139 3.03293 15.5949 2.95182Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M17.8118 4.79926C18.1339 4.47697 18.0313 3.85222 17.5826 3.40386C17.1339 2.9555 16.5091 2.85331 16.187 3.1756C15.865 3.4979 15.9676 4.12264 16.4163 4.571C16.865 5.01936 17.4898 5.12156 17.8118 4.79926Z", fill: "#F6FAFD" })
  ] }),
  /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_8974_37231", children: /* @__PURE__ */ h("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.5)" }) }) })
] }), POe = /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 25 25", fill: "none", children: [
  /* @__PURE__ */ k("g", { clipPath: "url(#clip0_8974_37247)", children: [
    /* @__PURE__ */ h("path", { d: "M12.2028 24.0048C18.554 24.0048 23.7028 18.8561 23.7028 12.5049C23.7028 6.15358 18.554 1.00485 12.2028 1.00485C5.85148 1.00485 0.702759 6.15358 0.702759 12.5049C0.702759 18.8561 5.85148 24.0048 12.2028 24.0048Z", fill: "#FFCE52" }),
    /* @__PURE__ */ h("path", { d: "M3.70032 13.5C3.70032 15.16 7.50032 17 12.2003 17C16.9003 17 20.7003 15.16 20.7003 13.5C20.6909 14.5275 20.4309 15.5373 19.943 16.4417C19.4551 17.3461 18.7539 18.1178 17.9003 18.69C16.2329 19.8677 14.2417 20.5 12.2003 20.5C10.159 20.5 8.1677 19.8677 6.50032 18.69C5.64672 18.1178 4.94556 17.3461 4.45764 16.4417C3.96972 15.5373 3.70977 14.5275 3.70032 13.5Z", fill: "#AE2D4C" }),
    /* @__PURE__ */ h("path", { d: "M20.7003 13.5C20.7003 15.16 16.9003 17 12.2003 17C7.50032 17 3.70032 15.16 3.70032 13.5C4.20032 14 7.70032 14.5 12.2003 14.5C16.7003 14.5 20.2003 14 20.7003 13.5Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M16.7161 11.5047C17.5445 11.5047 18.2161 10.6093 18.2161 9.50468C18.2161 8.40011 17.5445 7.50468 16.7161 7.50468C15.8876 7.50468 15.2161 8.40011 15.2161 9.50468C15.2161 10.6093 15.8876 11.5047 16.7161 11.5047Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M7.72314 11.5047C8.55157 11.5047 9.22314 10.6093 9.22314 9.50468C9.22314 8.40011 8.55157 7.50468 7.72314 7.50468C6.89472 7.50468 6.22314 8.40011 6.22314 9.50468C6.22314 10.6093 6.89472 11.5047 7.72314 11.5047Z", fill: "#273941" }),
    /* @__PURE__ */ h("path", { d: "M16.7206 11.0092C17.2729 11.0092 17.7206 10.3377 17.7206 9.50923C17.7206 8.6808 17.2729 8.00923 16.7206 8.00923C16.1683 8.00923 15.7206 8.6808 15.7206 9.50923C15.7206 10.3377 16.1683 11.0092 16.7206 11.0092Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M7.698 11.0092C8.25028 11.0092 8.698 10.3377 8.698 9.50923C8.698 8.6808 8.25028 8.00923 7.698 8.00923C7.14571 8.00923 6.698 8.6808 6.698 9.50923C6.698 10.3377 7.14571 11.0092 7.698 11.0092Z", fill: "#141E21" }),
    /* @__PURE__ */ h("path", { d: "M17.2 9.49895C17.4761 9.49895 17.7 9.27509 17.7 8.99895C17.7 8.7228 17.4761 8.49895 17.2 8.49895C16.9238 8.49895 16.7 8.7228 16.7 8.99895C16.7 9.27509 16.9238 9.49895 17.2 9.49895Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M8.20715 9.49895C8.4833 9.49895 8.70715 9.27509 8.70715 8.99895C8.70715 8.7228 8.4833 8.49895 8.20715 8.49895C7.93101 8.49895 7.70715 8.7228 7.70715 8.99895C7.70715 9.27509 7.93101 9.49895 8.20715 9.49895Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M12.2003 18C16.1813 18 19.5068 16.6795 20.4343 15.267C20.61 14.6944 20.6997 14.0989 20.7003 13.5C20.7003 15.16 16.9003 17 12.2003 17C7.50032 17 3.70032 15.16 3.70032 13.5C3.70095 14.0989 3.7906 14.6944 3.96632 15.267C4.89382 16.6795 8.21932 18 12.2003 18Z", fill: "#8A293D" }),
    /* @__PURE__ */ h("path", { d: "M19.9378 14.8275C20.1506 14.6717 20.3284 14.4731 20.4597 14.2445C20.591 14.0158 20.673 13.7622 20.7003 13.5C20.2003 14 16.7003 14.5 12.2003 14.5C7.70032 14.5 4.20032 14 3.70032 13.5C3.72764 13.7622 3.80961 14.0158 3.94094 14.2445C4.07227 14.4731 4.25005 14.6717 4.46282 14.8275C5.81182 15.197 8.70032 15.5 12.2003 15.5C15.7003 15.5 18.5888 15.197 19.9378 14.8275Z", fill: "#EDEDED" }),
    /* @__PURE__ */ h("path", { d: "M12.2199 2.49849C18.2949 2.49849 23.2199 6.75199 23.2199 11.9985H23.7074C23.5696 9.04451 22.2991 6.25717 20.1599 4.21544C18.0206 2.17371 15.1771 1.03453 12.2199 1.03453C9.26273 1.03453 6.4192 2.17371 4.27998 4.21544C2.14075 6.25717 0.870264 9.04451 0.732422 11.9985H1.21992C1.21992 6.75199 6.14492 2.49849 12.2199 2.49849Z", fill: "#FFE369" }),
    /* @__PURE__ */ h("path", { d: "M23.2028 12.0011C23.2028 17.2476 18.2778 21.5011 12.2028 21.5011C6.12776 21.5011 1.20276 17.2476 1.20276 12.0011H0.715259C0.708259 12.1671 0.702759 12.3336 0.702759 12.5011C0.702759 15.5511 1.91436 18.4762 4.07103 20.6329C6.2277 22.7895 9.15277 24.0011 12.2028 24.0011C15.2527 24.0011 18.1778 22.7895 20.3345 20.6329C22.4911 18.4762 23.7028 15.5511 23.7028 12.5011C23.7028 12.3336 23.6973 12.1671 23.6903 12.0011H23.2028Z", fill: "#FFB32B" }),
    /* @__PURE__ */ h("path", { d: "M19.1095 5.39773C19.2705 5.23658 19.2193 4.92429 18.995 4.70021C18.7708 4.47612 18.4585 4.42511 18.2974 4.58625C18.1364 4.7474 18.1876 5.05969 18.4119 5.28377C18.6361 5.50786 18.9484 5.55888 19.1095 5.39773Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M15.8007 2.94284C15.8818 2.86173 15.8561 2.70465 15.7434 2.59199C15.6307 2.47933 15.4736 2.45376 15.3925 2.53488C15.3114 2.61599 15.3371 2.77307 15.4499 2.88573C15.5626 2.99839 15.7197 3.02396 15.8007 2.94284Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M18.0175 4.80515C18.3396 4.48286 18.237 3.85811 17.7883 3.40975C17.3396 2.96139 16.7148 2.8592 16.3927 3.18149C16.0707 3.50379 16.1733 4.12853 16.622 4.57689C17.0706 5.02525 17.6955 5.12745 18.0175 4.80515Z", fill: "#F6FAFD" })
  ] }),
  /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "clip0_8974_37247", children: /* @__PURE__ */ h("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.199951 0.5)" }) }) })
] }), kOe = /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 25 25", fill: "none", children: [
  /* @__PURE__ */ k("g", { clipPath: "url(#clip0_8974_37265)", children: [
    /* @__PURE__ */ h("path", { d: "M12.4126 23.999C18.7639 23.999 23.9126 18.8502 23.9126 12.499C23.9126 6.1477 18.7639 0.998978 12.4126 0.998978C6.06132 0.998978 0.912598 6.1477 0.912598 12.499C0.912598 18.8502 6.06132 23.999 12.4126 23.999Z", fill: "#FFCE52" }),
    /* @__PURE__ */ h("path", { d: "M12.4001 2.49261C18.4751 2.49261 23.4001 6.74611 23.4001 11.9926H23.8876C23.7498 9.03864 22.4793 6.2513 20.34 4.20957C18.2008 2.16784 15.3573 1.02866 12.4001 1.02866C9.44291 1.02866 6.59938 2.16784 4.46015 4.20957C2.32092 6.2513 1.05044 9.03864 0.912598 11.9926H1.4001C1.4001 6.74611 6.3251 2.49261 12.4001 2.49261Z", fill: "#FFE369" }),
    /* @__PURE__ */ h("path", { d: "M23.4126 12.0101C23.4126 17.2566 18.4876 21.5101 12.4126 21.5101C6.3376 21.5101 1.4126 17.2566 1.4126 12.0101H0.925098C0.918098 12.1761 0.912598 12.3426 0.912598 12.5101C0.912598 15.5601 2.1242 18.4852 4.28087 20.6418C6.43754 22.7985 9.36261 24.0101 12.4126 24.0101C15.4626 24.0101 18.3877 22.7985 20.5443 20.6418C22.701 18.4852 23.9126 15.5601 23.9126 12.5101C23.9126 12.3426 23.9071 12.1761 23.9001 12.0101H23.4126Z", fill: "#FFB32B" }),
    /* @__PURE__ */ h("path", { d: "M19.0524 4.64986C19.2134 4.48872 19.1622 4.17643 18.9379 3.95234C18.7137 3.72826 18.4013 3.67724 18.2403 3.83839C18.0793 3.99954 18.1305 4.31183 18.3548 4.53591C18.579 4.75999 18.8913 4.81101 19.0524 4.64986Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M15.7435 2.71437C15.8246 2.63326 15.7989 2.47618 15.6861 2.36352C15.5734 2.25086 15.4163 2.22529 15.3352 2.30641C15.2542 2.38752 15.2799 2.5446 15.3926 2.65726C15.5053 2.76992 15.6624 2.79549 15.7435 2.71437Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M17.9604 4.05727C18.2825 3.73498 18.1798 3.11024 17.7312 2.66188C17.2825 2.21352 16.6577 2.11132 16.3356 2.43361C16.0135 2.75591 16.1162 3.38065 16.5648 3.82901C17.0135 4.27737 17.6383 4.37957 17.9604 4.05727Z", fill: "#F6FAFD" }),
    /* @__PURE__ */ h("path", { d: "M18.3962 12.4897C20.0531 12.4897 21.3962 11.1466 21.3962 9.4897C21.3962 7.83285 20.0531 6.4897 18.3962 6.4897C16.7394 6.4897 15.3962 7.83285 15.3962 9.4897C15.3962 11.1466 16.7394 12.4897 18.3962 12.4897Z", fill: "url(#paint0_radial_8974_37265)" }),
    /* @__PURE__ */ h("path", { d: "M6.40576 12.4897C8.06262 12.4897 9.40576 11.1466 9.40576 9.4897C9.40576 7.83285 8.06262 6.4897 6.40576 6.4897C4.74891 6.4897 3.40576 7.83285 3.40576 9.4897C3.40576 11.1466 4.74891 12.4897 6.40576 12.4897Z", fill: "url(#paint1_radial_8974_37265)" }),
    /* @__PURE__ */ h("path", { d: "M12.4238 14.5012C10.2183 14.5012 8.42383 12.9312 8.42383 11.0012H9.42383C9.42383 12.3797 10.7693 13.5012 12.4238 13.5012C14.0783 13.5012 15.4238 12.3797 15.4238 11.0012H16.4238C16.4238 12.9312 14.6293 14.5012 12.4238 14.5012ZM19.4238 7.00116H18.4238C18.4238 6.60333 18.2658 6.2218 17.9845 5.9405C17.7032 5.65919 17.3217 5.50116 16.9238 5.50116C16.526 5.50116 16.1445 5.65919 15.8632 5.9405C15.5819 6.2218 15.4238 6.60333 15.4238 7.00116H14.4238C14.4238 6.33812 14.6872 5.70223 15.1561 5.23339C15.6249 4.76455 16.2608 4.50116 16.9238 4.50116C17.5869 4.50116 18.2228 4.76455 18.6916 5.23339C19.1604 5.70223 19.4238 6.33812 19.4238 7.00116ZM10.4238 7.00116H9.42383C9.42383 6.60333 9.26579 6.2218 8.98449 5.9405C8.70318 5.65919 8.32165 5.50116 7.92383 5.50116C7.526 5.50116 7.14447 5.65919 6.86317 5.9405C6.58186 6.2218 6.42383 6.60333 6.42383 7.00116H5.42383C5.42383 6.33812 5.68722 5.70223 6.15606 5.23339C6.6249 4.76455 7.26079 4.50116 7.92383 4.50116C8.58687 4.50116 9.22275 4.76455 9.6916 5.23339C10.1604 5.70223 10.4238 6.33812 10.4238 7.00116Z", fill: "#273941" })
  ] }),
  /* @__PURE__ */ k("defs", { children: [
    /* @__PURE__ */ k("radialGradient", { id: "paint0_radial_8974_37265", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(18.3962 9.4897) scale(3)", children: [
      /* @__PURE__ */ h("stop", { stopColor: "#FF568D" }),
      /* @__PURE__ */ h("stop", { offset: "0.454", stopColor: "#FF9678" }),
      /* @__PURE__ */ h("stop", { offset: "0.817", stopColor: "#FFC26A" }),
      /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#FFD364" })
    ] }),
    /* @__PURE__ */ k("radialGradient", { id: "paint1_radial_8974_37265", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(6.40576 0.7397) scale(0.25)", children: [
      /* @__PURE__ */ h("stop", { stopColor: "#FF568D" }),
      /* @__PURE__ */ h("stop", { offset: "0.454", stopColor: "#FF9678" }),
      /* @__PURE__ */ h("stop", { offset: "0.817", stopColor: "#FFC26A" }),
      /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#FFD364" })
    ] }),
    /* @__PURE__ */ h("clipPath", { id: "clip0_8974_37265", children: /* @__PURE__ */ h("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.400146 0.5)" }) })
  ] })
] });
function dj({
  onChange: t,
  count: e,
  style: r,
  buttonStyle: n,
  selectedButtonStyle: A,
  initialState: i = -1
}) {
  const [o, s] = N(i), a = gt([xOe, IOe, SOe, POe, kOe]).current, c = (l) => {
    s(l), t({ total: a.length, rate: l + 1 });
  };
  return /* @__PURE__ */ h("div", { className: "feedbackEmojiContainer", style: { ...r }, children: a.map((l, u) => /* @__PURE__ */ h("div", { className: o == u ? "feedbackEmojiSelected" : void 0, onClick: () => c(u), style: { ...o == u ? A : n }, children: l }, u)) });
}
const OOe = /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "45", height: "42", viewBox: "0 0 45 42", fill: "none", children: /* @__PURE__ */ h("path", { d: "M14.8381 12.674L2.07807 14.524L1.85207 14.57C1.50995 14.6608 1.19806 14.8408 0.948255 15.0916C0.69845 15.3423 0.519678 15.6549 0.430195 15.9974C0.340713 16.3399 0.343725 16.7 0.438926 17.0409C0.534127 17.3818 0.718104 17.6914 0.972071 17.938L10.2161 26.936L8.03607 39.646L8.01007 39.866C7.98913 40.2199 8.0626 40.5729 8.22297 40.889C8.38334 41.2051 8.62484 41.4729 8.92274 41.665C9.22064 41.8571 9.56425 41.9666 9.91837 41.9822C10.2725 41.9979 10.6244 41.9191 10.9381 41.754L22.3501 35.754L33.7361 41.754L33.9361 41.846C34.2662 41.976 34.625 42.0159 34.9756 41.9615C35.3262 41.9071 35.656 41.7605 35.9313 41.5365C36.2065 41.3126 36.4172 41.0195 36.5417 40.6873C36.6663 40.3551 36.7002 39.9957 36.6401 39.646L34.4581 26.936L43.7061 17.936L43.8621 17.766C44.0849 17.4915 44.231 17.1629 44.2855 16.8135C44.34 16.4642 44.3009 16.1067 44.1722 15.7774C44.0436 15.4481 43.8299 15.1588 43.553 14.939C43.2762 14.7191 42.946 14.5766 42.5961 14.526L29.8361 12.674L24.1321 1.11393C23.967 0.778995 23.7115 0.496956 23.3945 0.299734C23.0774 0.102513 22.7115 -0.00201416 22.3381 -0.00201416C21.9647 -0.00201416 21.5987 0.102513 21.2817 0.299734C20.9646 0.496956 20.7091 0.778995 20.5441 1.11393L14.8381 12.674Z", fill: "rgba(226, 226, 226, 1)" }) });
function fj({
  onChange: t,
  count: e,
  style: r,
  buttonStyle: n,
  selectedButtonStyle: A,
  initialState: i = -1
}) {
  const [o, s] = N(i), a = gt(Array(e).fill(OOe)).current, c = (l) => {
    s(l), t({ total: a.length, rate: l + 1 });
  };
  return /* @__PURE__ */ h("div", { className: "feedbackStarContainer", style: { ...r }, children: a.map((l, u) => /* @__PURE__ */ h("div", { className: o >= u ? "feedbackStarSelected" : void 0, onClick: () => c(u), style: { ...o == u ? A : n }, children: l }, u)) });
}
function hy({
  onChange: t,
  count: e,
  style: r,
  buttonStyle: n,
  selectedButtonStyle: A,
  iconStyle: i,
  selectedIconStyle: o,
  initialState: s = -1
}) {
  const [a, c] = N(s), l = (u) => {
    c(u), t({ like: u == 1 });
  };
  return /* @__PURE__ */ k("div", { className: "feedbackNumbering", style: { ...r }, children: [
    /* @__PURE__ */ h("div", { className: a != 0 ? void 0 : "feedbackNumberingSelected", onClick: () => l(0), style: { ...a ? n : A }, children: /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", children: [
      /* @__PURE__ */ h("path", { d: "M4.49504 23.2034C4.96346 23.7665 5.55027 24.2195 6.2137 24.53C6.87713 24.8406 7.60086 25.0011 8.33337 25H15.9334L15.1267 27.1617C14.5611 28.5904 14.4677 30.1627 14.86 31.6484C15.2662 33.0914 16.1324 34.3624 17.327 35.2682C18.5216 36.174 19.9792 36.665 21.4784 36.6667C21.8015 36.6669 22.1178 36.5735 22.389 36.3978C22.6602 36.2221 22.8747 35.9717 23.0067 35.6767L27.7517 24.9967V3.33335H10.4567C9.2855 3.33325 8.15142 3.7443 7.25227 4.4948C6.35312 5.24532 5.74597 6.28766 5.53671 7.44002L3.41504 19.1067C3.28302 19.8269 3.31135 20.5674 3.49801 21.2755C3.68468 21.9836 4.0251 22.6418 4.49504 23.2034Z", fill: "#E2E2E2", style: a ? i : o }),
      /* @__PURE__ */ h("path", { d: "M27.75 25H31.6666C32.9923 24.9987 34.2633 24.4715 35.2007 23.5341C36.1381 22.5967 36.6653 21.3257 36.6666 20V8.33333C36.6653 7.00766 36.1381 5.73666 35.2007 4.79926C34.2633 3.86186 32.9923 3.33466 31.6666 3.33333H27.75V24.9967V25Z", fill: "#AFAFAF", style: a ? i : o, opacity: 0.5 })
    ] }) }),
    /* @__PURE__ */ h("div", { className: a != 1 ? void 0 : "feedbackNumberingSelected", onClick: () => l(1), style: { ...a ? A : n }, children: /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", children: [
      /* @__PURE__ */ h("path", { d: "M42.608 20.1591C42.0459 19.4833 41.3417 18.9397 40.5456 18.5671C39.7494 18.1944 38.881 18.0019 38.002 18.0031H28.882L29.85 15.4091C30.5287 13.6946 30.6408 11.8079 30.17 10.0251C29.6825 8.29342 28.6431 6.7682 27.2096 5.68126C25.7761 4.59431 24.0269 4.00508 22.228 4.00311C21.8402 4.00291 21.4607 4.11498 21.1352 4.3258C20.8098 4.53661 20.5523 4.83715 20.394 5.19111L14.7 18.0071V44.0031H35.454C36.8594 44.0032 38.2203 43.51 39.2993 42.6094C40.3783 41.7088 41.1068 40.458 41.358 39.0751L43.904 25.0751C44.0624 24.2108 44.0284 23.3222 43.8044 22.4725C43.5804 21.6229 43.1719 20.833 42.608 20.1591Z", fill: "#E2E2E2", style: a ? o : i }),
      /* @__PURE__ */ h("path", { d: "M14.6984 18H9.99841C8.4076 18.0016 6.8824 18.6342 5.75753 19.7591C4.63265 20.884 4 22.4092 3.99841 24V38C4 39.5908 4.63265 41.116 5.75753 42.2409C6.8824 43.3658 8.4076 43.9984 9.99841 44H14.6984V18.004V18Z", fill: "#AFAFAF", style: a ? o : i, opacity: 0.5 })
    ] }) })
  ] });
}
function hj({ closeFeedback: t }) {
  return /* @__PURE__ */ k("div", { className: "feedbackSuccessContainer", children: [
    /* @__PURE__ */ h("div", { onClick: t, style: { cursor: "pointer" }, children: /* @__PURE__ */ h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("path", { d: "M4.50513 11.4957L8.00046 8.00032L11.4958 11.4957M11.4958 4.50499L7.99979 8.00032L4.50513 4.50499", stroke: "#939393", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }) }) }),
    /* @__PURE__ */ k("center", { children: [
      /* @__PURE__ */ k("svg", { width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
        /* @__PURE__ */ k("g", { clipRule: "url(#clip0_4046_146)", children: [
          /* @__PURE__ */ h("path", { d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z", fill: "url(#paint0_linear_4046_146)" }),
          /* @__PURE__ */ h("path", { d: "M48.4167 79.0566C49.1837 78.9078 49.9463 78.7367 50.7033 78.5432C51.987 78.1844 53.2519 77.7617 54.4933 77.2766C55.7363 76.7955 56.9545 76.2526 58.1433 75.6499C59.3325 75.0449 60.4906 74.3807 61.6133 73.6599C62.7348 72.939 63.8195 72.1625 64.8633 71.3332C65.9091 70.5029 66.9125 69.6207 67.87 68.6899C68.8259 67.7614 69.7348 66.7858 70.5933 65.7666C71.4526 64.7465 72.2603 63.684 73.0133 62.5832C73.7662 61.4843 74.4638 60.3484 75.1033 59.1799C75.743 58.0097 76.3237 56.8082 76.8433 55.5799C77.3635 54.3514 77.8218 53.0976 78.2167 51.8232C78.5548 50.7075 78.8439 49.5776 79.0833 48.4366L55.3167 24.6732C53.3096 22.6573 50.9236 21.0581 48.2961 19.9677C45.6686 18.8774 42.8514 18.3174 40.0067 18.3199C37.1594 18.3168 34.3395 18.8765 31.7092 19.9668C29.0789 21.0572 26.6901 22.6566 24.68 24.6732C22.6649 26.6839 21.0661 29.0724 19.9753 31.7018C18.8845 34.3312 18.323 37.1499 18.323 39.9966C18.323 42.8433 18.8845 45.662 19.9753 48.2914C21.0661 50.9208 22.6649 53.3092 24.68 55.3199L48.4167 79.0566Z", fill: "url(#paint1_linear_4046_146)" }),
          /* @__PURE__ */ h("path", { d: "M40.0033 18.3232C45.5433 18.3232 51.0833 20.4398 55.3233 24.6765C57.3384 26.6872 58.9372 29.0756 60.028 31.705C61.1188 34.3344 61.6803 37.1532 61.6803 39.9998C61.6803 42.8465 61.1188 45.6653 60.028 48.2947C58.9372 50.9241 57.3384 53.3125 55.3233 55.3232C53.3126 57.3383 50.9242 58.937 48.2948 60.0279C45.6654 61.1187 42.8467 61.6802 40 61.6802C37.1533 61.6802 34.3346 61.1187 31.7052 60.0279C29.0758 58.937 26.6873 57.3383 24.6767 55.3232C22.6615 53.3125 21.0628 50.9241 19.972 48.2947C18.8811 45.6653 18.3196 42.8465 18.3196 39.9998C18.3196 37.1532 18.8811 34.3344 19.972 31.705C21.0628 29.0756 22.6615 26.6872 24.6767 24.6765C26.6867 22.6599 29.0756 21.0604 31.7059 19.9701C34.3361 18.8798 37.156 18.3201 40.0033 18.3232ZM49.87 33.3298C49.5544 33.3601 49.2539 33.4791 49.0033 33.6732L36.8233 42.8065L31.18 37.1665C29.9566 35.8932 27.5467 38.2998 28.8233 39.5232L35.49 46.1898C35.779 46.4631 36.1536 46.6281 36.5504 46.6566C36.9471 46.6852 37.3415 46.5756 37.6667 46.3465L51 36.3465C52.12 35.5298 51.43 33.3532 50.0433 33.3332C49.9867 33.3303 49.9299 33.3303 49.8733 33.3332L49.87 33.3298Z", fill: "white" })
        ] }),
        /* @__PURE__ */ k("defs", { children: [
          /* @__PURE__ */ k("linearGradient", { id: "paint0_linear_4046_146", x1: "0.320001", y1: "80", x2: "87.5968", y2: "71.0629", gradientUnits: "userSpaceOnUse", children: [
            /* @__PURE__ */ h("stop", { stopColor: "#9035FF" }),
            /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#0065FF" })
          ] }),
          /* @__PURE__ */ k("linearGradient", { id: "paint1_linear_4046_146", x1: "18.566", y1: "79.0566", x2: "84.8526", y2: "72.2662", gradientUnits: "userSpaceOnUse", children: [
            /* @__PURE__ */ h("stop", { stopColor: "#9035FF" }),
            /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#0065FF" })
          ] }),
          /* @__PURE__ */ h("clipPath", { id: "clip0_4046_146", children: /* @__PURE__ */ h("rect", { width: "80", height: "80", fill: "white" }) })
        ] })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ h("div", { className: "sdk-thanks-inline-head", children: "Feedback Submitted" }),
        /* @__PURE__ */ h("div", { className: "sdk-thanks-inline-para", children: "Thanks for submitting your feedback with us. We appreciate your review and will assure you to surely consider them." }),
        /* @__PURE__ */ h("button", { children: "Go to Home" })
      ] })
    ] })
  ] });
}
class FOe {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async getUserAuth({
    apiKey: e,
    entityId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    userId: i,
    token: o
  }) {
    var s;
    try {
      const a = this.cookies.get("externalUserId"), c = this.cookies.get("questUserId"), l = this.cookies.get("questUserToken");
      if (a && c && l && (a == n || a == A))
        return {
          userId: c,
          token: l
        };
      if (n) {
        const u = this.getAxiosHeaders({
          apiKey: e,
          ...o && { token: o },
          ...i && { userId: i }
        }), f = {
          externalUserId: n,
          entityId: r,
          email: A || null
        }, d = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          f,
          { headers: u }
        );
        if (!((s = d.data) != null && s.success))
          throw new Error("Invalid response from external login");
        const { userId: g, token: m } = d.data, p = /* @__PURE__ */ new Date();
        return p.setHours(p.getHours() + 12), this.cookies.set("externalUserId", n, {
          path: "/",
          expires: p
        }), this.cookies.set("questUserId", g, { path: "/", expires: p }), this.cookies.set("questUserToken", m, { path: "/", expires: p }), {
          userId: g,
          token: m
        };
      }
      return i && o ? { userId: i, token: o } : null;
    } catch (a) {
      return this.GeneralFunctions.captureSentryException(a), null;
    }
  }
  async getFeedbackData(e, r, n, A) {
    try {
      if (!n.userId || !n.token)
        throw new Error("Missing required headers");
      const i = new URLSearchParams();
      A && i.set("variation", A);
      const o = this.getAxiosHeaders(n), s = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}?${i.toString()}`, a = await Oe.get(s, {
        headers: o
      });
      if (!a.data)
        throw new Error("No data received from API");
      return a.data;
    } catch (i) {
      return this.GeneralFunctions.captureSentryException(i), null;
    }
  }
  async submitFeedback(e, r, n, A) {
    try {
      const i = this.getAxiosHeaders(n), o = `${this.BACKEND_URL}api/v2/entities/${e}/campaigns/${r}/verify`, s = {
        actions: [
          {
            actionId: A.actionId,
            answers: [A.answer]
          }
        ],
        campaignVariationId: A.campaignVariationId
      };
      return (await Oe.post(
        o,
        s,
        { headers: i }
      )).data;
    } catch (i) {
      throw this.GeneralFunctions.captureSentryException(i), i;
    }
  }
}
class pj {
  constructor(e = {}, r = {}, n = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }, A = {
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  }) {
    ke(this, "themeConfig");
    ke(this, "styleConfig");
    ke(this, "questThemeData");
    ke(this, "brandTheme");
    this.themeConfig = e, this.styleConfig = r, this.questThemeData = n, this.brandTheme = A;
  }
  getContainerStyles() {
    var r, n, A, i, o, s, a, c, l;
    const e = {
      "--backgroundColor": this.themeConfig.backgroundColor,
      "--borderColor": this.themeConfig.borderColor,
      "--buttonColor": ((r = this.brandTheme) == null ? void 0 : r.primaryButton) || ((n = this.questThemeData) == null ? void 0 : n.buttonColor) || this.themeConfig.buttonColor,
      "--fontFamily": ((A = this.brandTheme) == null ? void 0 : A.contentColor) || this.themeConfig.fontFamily,
      "--primaryColor": ((i = this.brandTheme) == null ? void 0 : i.primaryColor) || this.themeConfig.primaryColor,
      "--secondaryColor": ((o = this.brandTheme) == null ? void 0 : o.secondaryColor) || this.themeConfig.secondaryColor,
      "--borderRadius": ((s = this.styleConfig.Form) == null ? void 0 : s.borderRadius) || ((a = this.questThemeData) == null ? void 0 : a.borderRadius) || ((c = this.brandTheme) == null ? void 0 : c.borderRadius) || "12px"
    };
    return {
      ...(l = this.styleConfig) == null ? void 0 : l.Form,
      ...e
    };
  }
  getHeadingStyles() {
    var e, r, n, A, i, o;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Heading) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.titleColor) || ((A = this.brandTheme) == null ? void 0 : A.primaryColor) || ((i = this.themeConfig) == null ? void 0 : i.primaryColor) || "#2c2c2c",
      ...(o = this.styleConfig) == null ? void 0 : o.Heading
    };
  }
  getDescriptionStyles() {
    var e, r, n, A, i;
    return {
      color: ((r = (e = this.styleConfig) == null ? void 0 : e.Description) == null ? void 0 : r.color) || ((n = this.brandTheme) == null ? void 0 : n.secondaryColor) || ((A = this.themeConfig) == null ? void 0 : A.secondaryColor),
      ...(i = this.styleConfig) == null ? void 0 : i.Description
    };
  }
  getActionStyles() {
    var e, r, n, A, i;
    return {
      container: ((e = this.styleConfig) == null ? void 0 : e.ActionContainer) || {},
      button: ((r = this.styleConfig) == null ? void 0 : r.ActionButton) || {},
      selectedButton: ((n = this.styleConfig) == null ? void 0 : n.ActionSelectedButton) || {},
      icon: ((A = this.styleConfig) == null ? void 0 : A.IconStyle) || {},
      selectedIcon: ((i = this.styleConfig) == null ? void 0 : i.SelectedIconStyle) || {}
    };
  }
  getFooterStyles() {
    var e;
    return ((e = this.styleConfig) == null ? void 0 : e.Footer) || {};
  }
  getCloseIconColor() {
    var e;
    return ((e = this.styleConfig) == null ? void 0 : e.closeIconColor) || "#000000";
  }
  updateThemeConfig(e) {
    this.themeConfig = { ...this.themeConfig, ...e };
  }
  updateStyleConfig(e) {
    this.styleConfig = { ...this.styleConfig, ...e };
  }
  updateQuestTheme(e) {
    this.questThemeData = { ...this.questThemeData, ...e };
  }
  updateBrandTheme(e) {
    this.brandTheme = { ...this.brandTheme, ...e };
  }
}
const W6 = {
  number: uj,
  like: hy,
  emoji: dj,
  star: fj
};
function _Fe({
  userId: t,
  token: e,
  questId: r,
  heading: n = "Found it helpful",
  description: A = "Your feedback helps us improve search results!",
  type: i = "number",
  uniqueUserId: o,
  uniqueEmailId: s,
  Headers: a,
  count: c = 5,
  footerText: l,
  footerLink: u,
  styleConfig: f,
  onChange: d,
  onRequestClose: g,
  initialState: m,
  variation: p
}) {
  const [v, C] = N(null), [w, B] = N(!0), [y, b] = N(!1), [q, E] = N(i), [x, M] = N(Hs), [O, I] = N(Ms), { themeConfig: S, entityId: P, apiType: H, apiKey: F, apiSecret: T } = Xe(
    ct.Context
  ), U = gt(), D = new FOe(H), Q = new pj(
    S,
    f,
    O,
    x
  ), Y = W6[q] || hy;
  le(() => {
    (async () => {
      var V, _, J, X, ne, ee, $, te, ae, se, ue, fe;
      try {
        B(!0);
        const ve = await D.getUserAuth({
          apiKey: F,
          entityId: P,
          uniqueUserId: o,
          uniqueEmailId: s,
          userId: t,
          token: e
        });
        if (!ve) return;
        const ge = {
          apiKey: F,
          apisecret: T,
          userId: ve.userId,
          token: ve.token
        }, oe = await D.getFeedbackData(
          P,
          r,
          ge,
          p
        );
        if (oe) {
          if (C(oe), (J = (_ = (V = oe == null ? void 0 : oe.data) == null ? void 0 : V.sdkConfig) == null ? void 0 : _.uiProps) != null && J.questThemeData && (I((X = oe == null ? void 0 : oe.data) == null ? void 0 : X.sdkConfig.uiProps.questThemeData), Q.updateQuestTheme(
            (ne = oe == null ? void 0 : oe.data) == null ? void 0 : ne.sdkConfig.uiProps.questThemeData
          )), (te = ($ = (ee = oe == null ? void 0 : oe.data) == null ? void 0 : ee.sdkConfig) == null ? void 0 : $.uiProps) != null && te.BrandTheme) {
            const pe = (ae = oe == null ? void 0 : oe.data) == null ? void 0 : ae.sdkConfig.uiProps.BrandTheme.properties;
            M(pe), Q.updateBrandTheme(pe);
          }
          const ce = (fe = (ue = (se = oe.data) == null ? void 0 : se.actions[0]) == null ? void 0 : ue.metadata) == null ? void 0 : fe.ratingType;
          ce && W6[ce] && E(ce);
        }
      } catch {
        C(null);
      } finally {
        B(!1);
      }
    })();
  }, []), le(() => {
    var G, V, _;
    if ((_ = (V = (G = v == null ? void 0 : v.data) == null ? void 0 : G.actions[0]) == null ? void 0 : V.metadata) != null && _.ratingType) {
      const J = v.data.actions[0].metadata.ratingType;
      W6[J] ? E(J) : console.error("Invalid rating type received:", J);
    }
  }, [v]), le(() => {
    S && Q.updateThemeConfig(S), f && Q.updateStyleConfig(f), O && Q.updateQuestTheme(O), x && Q.updateBrandTheme(x);
  }, [S, f, O, x]);
  const j = async (G) => {
    var V, _;
    try {
      const J = await D.getUserAuth({
        apiKey: F,
        entityId: P,
        uniqueUserId: o,
        uniqueEmailId: s,
        userId: t,
        token: e
      });
      if (!J) return;
      const X = {
        apiKey: F,
        apisecret: T,
        userId: J.userId,
        token: J.token
      }, ne = (_ = (V = v == null ? void 0 : v.data) == null ? void 0 : V.actions) == null ? void 0 : _[0].actionId, ee = q === "like" ? G != null && G.like ? "like" : "dislike" : `${G.rate}`, $ = {
        actionId: ne,
        answer: ee,
        campaignVariationId: v == null ? void 0 : v.data.campaignVariationId
      };
      await D.submitFeedback(
        P,
        r,
        X,
        $
      ) && b(!0);
    } catch (J) {
      console.error(J);
    }
  }, Z = (G) => {
    U.current = G, j(G), d == null || d(G);
  };
  console.log(Q.getHeadingStyles());
  const W = () => {
    var G, V;
    return /* @__PURE__ */ k("div", { className: "feedbackHeader", children: [
      /* @__PURE__ */ k("div", { className: "inline-text-cont", style: { background: "transparent" }, children: [
        /* @__PURE__ */ h("div", { className: "inline-head", style: Q.getHeadingStyles(), children: ((G = a == null ? void 0 : a[0]) == null ? void 0 : G.heading) || n }),
        /* @__PURE__ */ h(
          "div",
          {
            className: "inline-desc",
            style: Q.getDescriptionStyles(),
            children: ((V = a == null ? void 0 : a[0]) == null ? void 0 : V.subHeading) || A
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { onClick: g, className: "inline-cross-btn", children: _g(Q.getCloseIconColor()) })
    ] });
  }, R = () => {
    var G, V, _, J, X, ne, ee, $;
    return /* @__PURE__ */ k("section", { className: "feedbackSection", children: [
      /* @__PURE__ */ h(
        Y,
        {
          onChange: Z,
          count: c,
          style: Q.getActionStyles().container,
          buttonStyle: Q.getActionStyles().button,
          selectedButtonStyle: Q.getActionStyles().selectedButton,
          iconStyle: Q.getActionStyles().icon,
          selectedIconStyle: Q.getActionStyles().selectedIcon,
          initialState: m
        }
      ),
      /* @__PURE__ */ k("div", { className: "feedbackMessage", children: [
        /* @__PURE__ */ h("span", { children: ((J = (_ = (V = (G = v == null ? void 0 : v.data) == null ? void 0 : G.actions) == null ? void 0 : V[0]) == null ? void 0 : _.metadata) == null ? void 0 : J.leftRatingText) || "Not satisfied" }),
        /* @__PURE__ */ h("span", { children: (($ = (ee = (ne = (X = v == null ? void 0 : v.data) == null ? void 0 : X.actions) == null ? void 0 : ne[0]) == null ? void 0 : ee.metadata) == null ? void 0 : $.rightRatingText) || "Very satisfied" })
      ] })
    ] });
  }, K = () => /* @__PURE__ */ k(
    "div",
    {
      className: "feedbackWatermark",
      onClick: () => window.open(u || "https://www.plgos.com/"),
      style: Q.getFooterStyles(),
      children: [
        /* @__PURE__ */ h("p", { children: l || "Powered by PLG OS" }),
        /* @__PURE__ */ k(
          "svg",
          {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z",
                  fill: "#B9B9B9"
                }
              ),
              /* @__PURE__ */ h("path", { d: "M12 8L8 8L8 12H12V8Z", fill: "#B9B9B9" })
            ]
          }
        )
      ]
    }
  );
  return v ? /* @__PURE__ */ k(
    "div",
    {
      className: "feedbackContainer",
      "data-type": q.toString(),
      style: Q.getContainerStyles(),
      children: [
        y ? /* @__PURE__ */ h(hj, { closeFeedback: () => b(!1) }) : /* @__PURE__ */ k(Ze, { children: [
          W(),
          R()
        ] }),
        K(),
        w && /* @__PURE__ */ h(rl, {})
      ]
    }
  ) : null;
}
const TOe = {
  number: uj,
  like: hy,
  emoji: dj,
  star: fj
};
function $Fe({
  heading: t = "Found it helpful",
  description: e = "Your feedback helps us improve search results!",
  Headers: r,
  type: n = "number",
  count: A = 5,
  styleConfig: i,
  footerText: o = "Powered by PLG OS",
  onChange: s,
  onRequestClose: a,
  initialState: c,
  offlineFormData: l,
  setAnswer: u,
  footerLink: f,
  BrandTheme: d,
  QuestThemeData: g
}) {
  var P, H;
  const [m, p] = N(null), [v, C] = N(!1), [w, B] = N(!1), { themeConfig: y } = Xe(ct.Context), b = gt(), q = new pj(
    y,
    i,
    g,
    d
  ), E = TOe[((H = (P = l[0]) == null ? void 0 : P.metadata) == null ? void 0 : H.ratingType) || n];
  le(() => {
    p(l);
  }, [l]);
  const x = (F) => {
    var U;
    const T = n === "like" ? F != null && F.like ? "like" : "dislike" : `${F.rate}/${F.total}`;
    u({ criteriaId: (U = m == null ? void 0 : m[0]) == null ? void 0 : U.criteriaId, answers: [T] }), setTimeout(() => B(!0), 1e3);
  }, M = (F) => {
    b.current = F, x(F), s == null || s(F);
  }, O = () => {
    var F, T;
    return /* @__PURE__ */ k("div", { className: "feedbackHeader", children: [
      /* @__PURE__ */ k("div", { className: "inline-text-cont", style: { background: "transparent" }, children: [
        /* @__PURE__ */ h("div", { className: "inline-head", style: q.getHeadingStyles(), children: ((F = r == null ? void 0 : r[0]) == null ? void 0 : F.heading) || t }),
        /* @__PURE__ */ h("div", { className: "inline-desc", style: q.getDescriptionStyles(), children: ((T = r == null ? void 0 : r[0]) == null ? void 0 : T.subHeading) || e })
      ] }),
      /* @__PURE__ */ h("div", { onClick: a, className: "inline-cross-btn", children: _g(q.getCloseIconColor()) })
    ] });
  }, I = () => {
    var F, T, U, D;
    return /* @__PURE__ */ k("section", { className: "feedbackSection", children: [
      /* @__PURE__ */ h(
        E,
        {
          onChange: M,
          count: A,
          style: q.getActionStyles().container,
          buttonStyle: q.getActionStyles().button,
          selectedButtonStyle: q.getActionStyles().selectedButton,
          iconStyle: q.getActionStyles().icon,
          selectedIconStyle: q.getActionStyles().selectedIcon,
          initialState: c
        }
      ),
      /* @__PURE__ */ k("div", { className: "feedbackMessage", children: [
        /* @__PURE__ */ h("span", { children: ((T = (F = m == null ? void 0 : m[0]) == null ? void 0 : F.metadata) == null ? void 0 : T.leftRatingText) || "Not satisfied" }),
        /* @__PURE__ */ h("span", { children: ((D = (U = m == null ? void 0 : m[0]) == null ? void 0 : U.metadata) == null ? void 0 : D.rightRatingText) || "Very satisfied" })
      ] })
    ] });
  }, S = () => /* @__PURE__ */ k(
    "div",
    {
      className: "feedbackWatermark",
      onClick: () => window.open(f || "https://www.plgos.com/"),
      style: q.getFooterStyles(),
      children: [
        /* @__PURE__ */ h("p", { children: o }),
        /* @__PURE__ */ k("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ h("path", { d: "M12 0V4L8 8V4H4V6.64083C4 7.39167 4.60833 8 5.35917 8H8L4 12C1.79083 12 0 10.2092 0 8V0H12Z", fill: "#B9B9B9" }),
          /* @__PURE__ */ h("path", { d: "M12 8L8 8L8 12H12V8Z", fill: "#B9B9B9" })
        ] })
      ]
    }
  );
  return m && /* @__PURE__ */ k("div", { className: "feedbackContainer", "data-type": n, style: q.getContainerStyles(), children: [
    w ? /* @__PURE__ */ h(hj, { closeFeedback: () => B(!1) }) : /* @__PURE__ */ k(Ze, { children: [
      O(),
      I()
    ] }),
    S(),
    v && /* @__PURE__ */ h(rl, {})
  ] });
}
const eTe = ({
  bgColor: t = "",
  description: e = "If you like this article share it with your friends",
  heading: r = "Share this article",
  headingColor: n = "",
  textColor: A = "",
  questId: i = "",
  token: o = "",
  userId: s = "",
  enableVariation: a = !1,
  linkActionUrl: c,
  offlineFormData: l,
  styleConfig: u,
  Headers: f
}) => {
  var p, v, C, w, B, y;
  const { apiType: d, themeConfig: g } = Xe(ct.Context);
  N("");
  let m = new Bt("mixpanel", d);
  return le(() => {
    m.fireTrackingEvent(
      "quest_share_article_offline_loaded",
      "share_article_offline"
    );
  }, []), /* @__PURE__ */ h(
    "div",
    {
      className: "q_share_article",
      style: {
        background: ((p = u == null ? void 0 : u.Form) == null ? void 0 : p.background) || (g == null ? void 0 : g.backgroundColor),
        ...u
      },
      children: /* @__PURE__ */ k("div", { className: "q_article_div", children: [
        /* @__PURE__ */ k("div", { className: "q_article_up", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_article_head",
              style: {
                color: ((v = u == null ? void 0 : u.Heading) == null ? void 0 : v.color) || (g == null ? void 0 : g.primaryColor),
                fontFamily: g == null ? void 0 : g.fontFamily,
                ...u == null ? void 0 : u.Heading
              },
              children: f && ((C = f[0]) == null ? void 0 : C.heading) || r
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_article_desc",
              style: {
                color: ((w = u == null ? void 0 : u.Description) == null ? void 0 : w.color) || (g == null ? void 0 : g.secondaryColor),
                fontFamily: g == null ? void 0 : g.fontFamily,
                ...u == null ? void 0 : u.Description
              },
              children: f && ((B = f[0]) == null ? void 0 : B.subHeading) || e
            }
          )
        ] }),
        /* @__PURE__ */ k("div", { className: "q_article_dn", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "q_article_wit",
              style: {
                color: (y = u == null ? void 0 : u.Description) == null ? void 0 : y.color,
                fontFamily: g == null ? void 0 : g.fontFamily
              },
              children: "Share with"
            }
          ),
          /* @__PURE__ */ k("div", { className: "q_article_img", children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "q-referShare-content-social-img-x",
                onClick: () => {
                  var b;
                  m.fireTrackingEvent(
                    "quest_share_article_twitter_clicked",
                    "share_article"
                  ), Gi((b = l[0]) == null ? void 0 : b.linkUrl, "twitter");
                },
                children: RM()
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q-referShare-content-social-img",
                src: Zg,
                onClick: () => {
                  var b;
                  m.fireTrackingEvent(
                    "quest_share_article_whatsapp_clicked",
                    "share_article"
                  ), Gi((b = l[0]) == null ? void 0 : b.linkUrl, "whatsapp");
                },
                alt: "Whatsapp"
              }
            ),
            /* @__PURE__ */ h(
              "img",
              {
                className: "q-referShare-content-social-img",
                onClick: () => {
                  var b;
                  m.fireTrackingEvent(
                    "quest_share_article_telegram_clicked",
                    "share_article"
                  ), Gi((b = l[0]) == null ? void 0 : b.linkUrl, "telegram");
                },
                src: Kg,
                width: "24px",
                alt: "telegramPng"
              }
            )
          ] })
        ] })
      ] })
    }
  );
}, MOe = async ({
  userId: t,
  token: e,
  entityId: r,
  apiKey: n,
  campaignId: A,
  variation: i = "",
  BACKEND_URL: o
}) => {
  const s = {
    apiKey: n,
    userId: t,
    token: e
  }, a = new URLSearchParams({
    platform: "REACT",
    variation: i
  }), c = `${o}api/v2/entities/${r}/campaigns/${A}?${a.toString()}`;
  try {
    const l = await Oe.get(c, {
      headers: s
    });
    return l.data.success ? l.data : (console.error(
      "API returned an error:",
      l.data.message || "Unknown error"
    ), null);
  } catch (l) {
    return console.error("Error fetching quest data:", l), null;
  }
}, HOe = async ({
  entityId: t,
  apiKey: e,
  uniqueUserId: r,
  uniqueEmailId: n,
  userId: A,
  token: i,
  apiType: o
}) => {
  const s = new zn(), a = s.get("externalUserId"), c = s.get("questUserId"), l = s.get("questUserToken");
  let u = o == "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL;
  if (!t)
    return console.error("Entity ID is required."), null;
  const f = {
    apiKey: e,
    ...i && { token: i },
    ...A && { userId: A }
  }, d = {
    externalUserId: r || null,
    entityId: t,
    email: n || null
  };
  if (a && c && l && (a == r || a == n))
    return { userId: c, token: l };
  if (r)
    try {
      const g = await Oe.post(
        `${u}api/users/external/login`,
        d,
        { headers: f }
      ), { userId: m, token: p } = g.data, v = /* @__PURE__ */ new Date();
      return v.setHours(v.getHours() + 12), s.set("externalUserId", r, { path: "/", expires: v }), s.set("questUserId", m, { path: "/", expires: v }), s.set("questUserToken", p, { path: "/", expires: v }), { token: p, userId: m };
    } catch (g) {
      return console.error("Error during external login:", g), null;
    }
  return null;
};
function tTe({
  campaignId: t,
  userId: e,
  token: r,
  uniqueUserId: n,
  uniqueEmailId: A,
  HideMethod: i = "display",
  variation: o = "DEFAULT",
  flagType: s = "killSwitch",
  waitForLoading: a = !1,
  disableCache: c = !1,
  onTargetRetrieved: l
}) {
  const [u, f] = N(e || ""), [d, g] = N(r || ""), { apiType: m, entityId: p, apiKey: v } = Xe(ct.Context), C = MA(() => m === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, [m]), w = gt(), B = gt(new CSSStyleSheet()).current, y = async () => {
    if (!w.current) return;
    const { metadata: b } = w.current;
    if (s === "custom" || (b == null ? void 0 : b.type) !== "kill-switch") {
      l == null || l(b.target || null), B.disabled = !0;
      return;
    }
    if (B.disabled = !!b.status, b.status) return;
    b.content && document.querySelectorAll(b.target).forEach((x) => {
      x.textContent.trim() !== b.content && x.setAttribute("quest-featureflag-prevent", "");
    });
    let q = {
      display: "display: none !important;",
      visibility: "visibility: hidden !important;",
      opacity: "opacity: 0 !important;"
    };
    B.replaceSync(`
            :is(${b.target}):not([quest-featureflag-prevent]) {
                ${q[i]}
            }
        `);
  };
  return _p(() => {
    B.disabled = !!t;
    const b = c ? {} : JSON.parse(localStorage.getItem("feature-flag-cache") || "{}"), q = b[t];
    q ? (w.current = { campaignId: t, metadata: b[t] }, y()) : a && document.documentElement.style.setProperty("display", "none", "important");
    let E = u, x = d;
    const M = async () => {
      try {
        const I = await HOe({
          uniqueEmailId: A,
          uniqueUserId: n,
          entityId: p,
          apiKey: v,
          token: r,
          userId: e,
          apiType: m
        });
        I != null && I.userId && (E = I.userId, x = I.token, f(E), g(x));
      } catch (I) {
        console.error("Error fetching external login data:", I);
      }
    };
    (async () => {
      var I, S;
      try {
        await M();
        const P = await MOe({
          userId: E,
          token: x,
          entityId: p,
          apiKey: v,
          campaignId: t,
          variation: o,
          BACKEND_URL: C
        });
        P != null && P.success && ((I = P.data) != null && I.metadata) ? (c || (b[`${P.data.campaignId}`] = (S = P.data) == null ? void 0 : S.metadata, localStorage.setItem("feature-flag-cache", JSON.stringify(b))), w.current = P.data, await y()) : console.warn("Quest response was not successful or missing data.");
      } catch (P) {
        console.error("Error in handleFeatureFlags:", P);
      } finally {
        !q && a && document.documentElement.style.removeProperty("display");
      }
    })();
  }, [
    t,
    A,
    n,
    p,
    v,
    r,
    e,
    m,
    o,
    C,
    s
  ]), le(() => (document.adoptedStyleSheets.push(B), y(), () => {
    document.adoptedStyleSheets = document.adoptedStyleSheets.filter((b) => b !== B);
  }), []), null;
}
const DOe = (t = "#B9B9B9") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z",
        fill: t
      }
    )
  }
), QOe = (t = "#9035FF") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z",
        fill: t
      }
    )
  }
), UOe = (t = "#B9B9B9") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
        fill: t
      }
    )
  }
), NOe = (t = "#9035FF") => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /* @__PURE__ */ h(
      "path",
      {
        d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z",
        fill: t
      }
    )
  }
), jOe = (t = "#B9B9B9") => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h("path", { d: "M19.5469 6.42188L13.9219 12.0469L19.5 17.625C19.9688 18.0469 19.9688 18.75 19.5 19.1719C19.0781 19.6406 18.375 19.6406 17.9531 19.1719L12.3281 13.5938L6.75 19.1719C6.32812 19.6406 5.625 19.6406 5.20312 19.1719C4.73438 18.75 4.73438 18.0469 5.20312 17.5781L10.7812 12L5.20312 6.42188C4.73438 6 4.73438 5.29688 5.20312 4.82812C5.625 4.40625 6.32812 4.40625 6.79688 4.82812L12.375 10.4531L17.9531 4.875C18.375 4.40625 19.0781 4.40625 19.5469 4.875C19.9688 5.29688 19.9688 6 19.5469 6.42188Z", fill: t }) }), gj = (t = "#B9B9B9") => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h("path", { d: "M19.5469 6.42188L13.9219 12.0469L19.5 17.625C19.9688 18.0469 19.9688 18.75 19.5 19.1719C19.0781 19.6406 18.375 19.6406 17.9531 19.1719L12.3281 13.5938L6.75 19.1719C6.32812 19.6406 5.625 19.6406 5.20312 19.1719C4.73438 18.75 4.73438 18.0469 5.20312 17.5781L10.7812 12L5.20312 6.42188C4.73438 6 4.73438 5.29688 5.20312 4.82812C5.625 4.40625 6.32812 4.40625 6.79688 4.82812L12.375 10.4531L17.9531 4.875C18.375 4.40625 19.0781 4.40625 19.5469 4.875C19.9688 5.29688 19.9688 6 19.5469 6.42188Z", fill: t }) }), LOe = (t = "#0DC268") => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ h("path", { d: "M8.01562 16C5.14062 16 2.51562 14.5 1.07812 12C-0.359375 9.53125 -0.359375 6.5 1.07812 4C2.51562 1.53125 5.14062 0 8.01562 0C10.8594 0 13.4844 1.53125 14.9219 4C16.3594 6.5 16.3594 9.53125 14.9219 12C13.4844 14.5 10.8594 16 8.01562 16ZM11.5469 6.53125H11.5156C11.8281 6.25 11.8281 5.78125 11.5156 5.46875C11.2344 5.1875 10.7656 5.1875 10.4844 5.46875L7.01562 8.96875L5.54688 7.5C5.23438 7.1875 4.76562 7.1875 4.48438 7.5C4.17188 7.78125 4.17188 8.25 4.48438 8.53125L6.48438 10.5312C6.76562 10.8438 7.23438 10.8438 7.54688 10.5312L11.5469 6.53125Z", fill: t }) }), GOe = (t = "#ED0A34") => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ h("path", { d: "M8.01562 16C5.14062 16 2.51562 14.5 1.07812 12C-0.359375 9.53125 -0.359375 6.5 1.07812 4C2.51562 1.53125 5.14062 0 8.01562 0C10.8594 0 13.4844 1.53125 14.9219 4C16.3594 6.5 16.3594 9.53125 14.9219 12C13.4844 14.5 10.8594 16 8.01562 16ZM5.48438 5.46875C5.17188 5.78125 5.17188 6.25 5.48438 6.53125L6.95312 8L5.48438 9.46875C5.17188 9.78125 5.17188 10.25 5.48438 10.5312C5.76562 10.8438 6.23438 10.8438 6.51562 10.5312L7.98438 9.0625L9.45312 10.5312C9.76562 10.8438 10.2344 10.8438 10.5156 10.5312C10.8281 10.25 10.8281 9.78125 10.5156 9.46875L9.04688 8L10.5156 6.53125C10.8281 6.25 10.8281 5.78125 10.5156 5.46875C10.2344 5.1875 9.76562 5.1875 9.45312 5.46875L7.98438 6.9375L6.51562 5.46875C6.23438 5.1875 5.76562 5.1875 5.48438 5.46875Z", fill: t }) }), mj = (t = "#090C0F") => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "14", viewBox: "0 0 16 14", fill: "none", children: /* @__PURE__ */ h("path", { d: "M0.25 7.48678C0.0714286 7.30821 0 7.09393 0 6.84393C0 6.62964 0.0714286 6.41536 0.25 6.23678L6.53571 0.236783C6.89286 -0.0846451 7.42857 -0.0846451 7.75 0.272498C8.07143 0.593926 8.07143 1.16535 7.71429 1.48678L2.96429 5.98678H15.1429C15.6071 5.98678 16 6.37964 16 6.84393C16 7.34393 15.6071 7.70107 15.1429 7.70107H2.96429L7.71429 12.2368C8.07143 12.5582 8.07143 13.0939 7.75 13.4511C7.42857 13.8082 6.89286 13.8082 6.53571 13.4868L0.25 7.48678Z", fill: t }) }), ROe = "data:image/svg+xml,%3csvg%20width='91'%20height='90'%20viewBox='0%200%2091%2090'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20x='0.5'%20width='90'%20height='90'%20fill='url(%23pattern0_15632_7843)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_15632_7843'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_15632_7843'%20transform='scale(0.00195312)'/%3e%3c/pattern%3e%3cimage%20id='image0_15632_7843'%20width='512'%20height='512'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", zOe = "data:image/png;base64,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", vj = ({
  totalQuestions: t,
  correctQuestions: e,
  onContinue: r,
  buttonStyles: n,
  GeneralFunctions: A,
  setIsResultPopup: i,
  setQuiz: o,
  styleConfig: s,
  isQuizOverview: a,
  ResultPopupCloseIcon: c,
  onTryAgain: l,
  isQuizOverviewTitle: u,
  questionDetails: f,
  expectedCorrectedAnswers: d,
  yourScore: g
}) => {
  var p, v, C, w, B, y, b, q, E, x;
  const m = () => /* @__PURE__ */ k(Ze, { children: [
    u && /* @__PURE__ */ h("p", { className: "quiz-overview-title", children: "Quiz Overview" }),
    /* @__PURE__ */ h("div", { className: "quiz-overview-cont", children: f == null ? void 0 : f.map((M, O) => /* @__PURE__ */ k("div", { className: "quiz-overview-item", children: [
      /* @__PURE__ */ h("p", { className: "quiz-overview-item-title", children: M.question }),
      M.isCorrectAnswer ? LOe() : GOe()
    ] }, O)) })
  ] });
  return /* @__PURE__ */ h("div", { className: "thanks-popup-upper-div", children: /* @__PURE__ */ k(
    "div",
    {
      className: "quiz-thanks-pop-up",
      style: { background: (p = s == null ? void 0 : s.ResultPopup) == null ? void 0 : p.background },
      children: [
        c && /* @__PURE__ */ h("div", { className: "quiz-pop-up-cancel-btn-cont", children: /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
          "div",
          {
            onClick: () => {
              A.fireTrackingEvent(
                "quest_quiz_feedback_close_button_clicked",
                "quiz"
              ), o(!1), i(!1);
            },
            children: jOe((v = s == null ? void 0 : s.IconColor) == null ? void 0 : v.color)
          }
        ) }) }),
        d === !0 ? /* @__PURE__ */ k("div", { className: "quiz-pop-up-message-cont", children: [
          /* @__PURE__ */ h("img", { src: ((C = s == null ? void 0 : s.ResultPopupImage) == null ? void 0 : C.passed) || zOe, alt: "", className: "quiz-pop-up-image" }),
          /* @__PURE__ */ k("div", { className: "pop-up-message", children: [
            /* @__PURE__ */ h("p", { className: "pop-up-message-heading", children: ((w = s == null ? void 0 : s.ResultPopupHeading) == null ? void 0 : w.passed) || "Congratulations!" }),
            /* @__PURE__ */ h("p", { className: "pop-up-message-para", children: ((B = s == null ? void 0 : s.ResultPopupDescription) == null ? void 0 : B.passed) || "You’ve successfully completed the quiz." }),
            /* @__PURE__ */ k("p", { className: "pop-up-message-scores", children: [
              g,
              ": ",
              /* @__PURE__ */ k("span", { children: [
                e,
                "/",
                t
              ] })
            ] })
          ] }),
          a && /* @__PURE__ */ h(m, {}),
          /* @__PURE__ */ h(
            yr,
            {
              type: "button",
              onClick: () => {
                r();
              },
              className: "q-onb-main-btn2",
              style: {
                font: "",
                fontFamily: "Figtree",
                background: (n == null ? void 0 : n.background) || "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                color: (n == null ? void 0 : n.color) || "var(--Neutral-White-100, #FFF)",
                border: `1.5px solid ${n != null && n.borderColor ? n == null ? void 0 : n.borderColor : "#D1ACFF"}`,
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                ...n
              },
              children: ((y = s == null ? void 0 : s.ResultPopupButtonText) == null ? void 0 : y.passed) || "Continue"
            }
          )
        ] }) : /* @__PURE__ */ k("div", { className: "quiz-pop-up-message-cont", children: [
          /* @__PURE__ */ h("img", { src: ((b = s == null ? void 0 : s.ResultPopupImage) == null ? void 0 : b.failed) || ROe, alt: "", className: "quiz-pop-up-image" }),
          /* @__PURE__ */ k("div", { className: "pop-up-message", children: [
            /* @__PURE__ */ h("p", { className: "pop-up-message-heading", children: ((q = s == null ? void 0 : s.ResultPopupHeading) == null ? void 0 : q.failed) || "Not this time.." }),
            /* @__PURE__ */ h("p", { className: "pop-up-message-para", children: ((E = s == null ? void 0 : s.ResultPopupDescription) == null ? void 0 : E.failed) || "You did not reach the required minimum score." }),
            /* @__PURE__ */ k("p", { className: "pop-up-message-scores", children: [
              g,
              ": ",
              /* @__PURE__ */ k("span", { children: [
                e,
                "/",
                t
              ] })
            ] })
          ] }),
          a && /* @__PURE__ */ h(m, {}),
          /* @__PURE__ */ h(
            yr,
            {
              type: "button",
              onClick: () => {
                l();
              },
              className: "q-onb-main-btn2",
              style: {
                font: "",
                fontFamily: "Figtree",
                background: (n == null ? void 0 : n.background) || "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                color: (n == null ? void 0 : n.color) || "var(--Neutral-White-100, #FFF)",
                border: `1.5px solid ${n != null && n.borderColor ? n == null ? void 0 : n.borderColor : "#D1ACFF"}`,
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                ...n
              },
              children: ((x = s == null ? void 0 : s.ResultPopupButtonText) == null ? void 0 : x.failed) || "Try Again"
            }
          )
        ] })
      ]
    }
  ) });
};
class qj {
  constructor(e) {
    ke(this, "BACKEND_URL");
    ke(this, "GeneralFunctions");
    ke(this, "cookies");
    this.BACKEND_URL = e === "STAGING" ? Ve.BACKEND_URL_STAGING : Ve.BACKEND_URL, this.GeneralFunctions = new Bt("mixpanel", e), this.cookies = new zn();
  }
  getAxiosHeaders(e) {
    return {
      "Content-Type": "application/json",
      ...e
    };
  }
  async handleUserMetrics({
    entityId: e,
    campaignId: r,
    uniqueUserId: n,
    uniqueEmailId: A,
    externalUserId: i,
    questUserId: o,
    questUserToken: s,
    headers: a
  }) {
    try {
      if (i && o && s && i === n) {
        const l = {
          ...this.getAxiosHeaders(a),
          userId: o,
          token: s
        };
        return await Oe.post(
          `${this.BACKEND_URL}api/entities/${e}/users/${o}/metrics/onboarding-view?userId=${o}&campaignId=${r}`,
          { count: 1 },
          {
            params: { userId: o, campaignId: r },
            headers: l
          }
        ), { userId: o, token: s };
      } else if (n) {
        const c = this.getAxiosHeaders(a), l = await Oe.post(
          `${this.BACKEND_URL}api/users/external/login`,
          {
            externalUserId: n,
            entityId: e,
            email: A
          },
          { headers: this.getAxiosHeaders(a) }
        ), { userId: u, token: f } = l.data, d = /* @__PURE__ */ new Date();
        d.setHours(d.getHours() + 12), this.cookies.set("externalUserId", n, {
          path: "/",
          expires: d
        }), this.cookies.set("questUserId", u, { path: "/", expires: d }), this.cookies.set("questUserToken", f, { path: "/", expires: d });
        const g = { ...c, userId: u, token: f };
        return await Oe.post(
          `${this.BACKEND_URL}api/entities/${e}/users/${o}/metrics/onboarding-view?userId=${o}&campaignId=${r}`,
          { count: 1 },
          {
            params: { userId: u, campaignId: r },
            headers: g
          }
        ), { userId: u, token: f };
      }
    } catch (c) {
      this.GeneralFunctions.captureSentryException(c);
    }
  }
  async submitFormData({
    isV1Api: e,
    entityId: r,
    campaignId: n,
    answer: A,
    selectedOptions: i,
    campaignVariationId: o,
    headers: s,
    formdata: a,
    isAccumulateAndSelf: c
  }) {
    try {
      let l = this.getAxiosHeaders(s);
      const u = { ...A };
      if (Object.keys(i).forEach((f) => {
        u[f] = i[f];
      }), e) {
        const f = Object.keys(u).map((g) => {
          var m;
          return {
            criteriaId: g,
            answer: Array.isArray(u[g]) ? u[g] : [u[g]],
            question: (m = a[a.findIndex((p) => p.criteriaId === g)]) == null ? void 0 : m.question
          };
        });
        return (await Oe.post(
          `${this.BACKEND_URL}api/entities/${r}/quests/${n}/verify-all?userId=${s.userId}`,
          { criterias: f, userId: s.userId, isAccumulateAndSelf: c },
          { headers: l }
        )).data;
      } else {
        const f = Object.keys(u).map((g) => {
          var m;
          return {
            actionId: g,
            answers: Array.isArray(u[g]) ? u[g] : [u[g]],
            question: (m = a[a.findIndex((p) => p.actionId === g)]) == null ? void 0 : m.question
          };
        });
        return (await Oe.post(
          `${this.BACKEND_URL}api/v2/entities/${r}/campaigns/${n}/verify`,
          { actions: f, campaignVariationId: o },
          { headers: l }
        )).data;
      }
    } catch (l) {
      throw this.GeneralFunctions.captureSentryException(l), l;
    }
  }
  async fetchLocalesAndTranslations() {
    const e = Ve.PHRASE_PROJECT_ID, r = Ve.PHRASE_ACCESS_TOKEN;
    try {
      return (await (await fetch(
        `https://api.phrase.com/v2/projects/${e}/locales`,
        {
          headers: {
            Authorization: `token ${r}`,
            "Content-Type": "application/json"
          }
        }
      )).json()).filter(
        (o) => o.id !== "1c7c617229fb6d738a62f213edee028d"
      );
    } catch (n) {
      throw this.GeneralFunctions.captureSentryException(n), n;
    }
  }
  async getTranslation(e, r) {
    const n = Ve.PHRASE_PROJECT_ID, A = Ve.PHRASE_ACCESS_TOKEN;
    try {
      const i = new URLSearchParams({
        q: `tags:${e},static`
      }).toString(), s = await (await fetch(
        `https://api.phrase.com/v2/projects/${n}/locales/${r.id}/download?file_format=json&${i}`,
        {
          method: "GET",
          headers: {
            Authorization: `token ${A}`,
            "Content-Type": "application/json"
          }
        }
      )).json();
      return Object.entries(s).map(([a, c]) => ({
        key: a,
        message: c.message,
        localeId: r.id,
        name: r.name
      }));
    } catch (i) {
      throw this.GeneralFunctions.captureSentryException(i), i;
    }
  }
  async getQuestDataV2({
    headers: e,
    campaignId: r,
    entityId: n,
    variation: A
  }) {
    try {
      let i = new URLSearchParams();
      i.set("platform", "REACT"), A && i.set("variation", A);
      const o = `${this.BACKEND_URL}api/v2/entities/${n}/campaigns/${r}?${i.toString()}`;
      return (await Oe.get(o, { headers: this.getAxiosHeaders(e) })).data;
    } catch (i) {
      throw this.GeneralFunctions.captureSentryException(i), i;
    }
  }
  async getQuestDataV1({
    headers: e,
    campaignId: r,
    entityId: n,
    userId: A,
    variation: i
  }) {
    try {
      const o = `${this.BACKEND_URL}api/entities/${n}/quests/${r}/criterias?userId=${A}&getVariation=${i || !1}`, { data: s } = await Oe.get(o, { headers: this.getAxiosHeaders(e) });
      return s;
    } catch (o) {
      throw this.GeneralFunctions.captureSentryException(o), o;
    }
  }
  async updateTranslations({
    criterias: e,
    isOption: r,
    localeCode: n,
    transition: A
  }) {
    try {
      return e.map((o) => {
        const s = A == null ? void 0 : A.find(
          (a) => a.name === n && a.key.includes(o.criteriaId) && !a.key.includes("OPTION")
        );
        return o;
      });
    } catch (i) {
      return this.GeneralFunctions.captureSentryException(i), e;
    }
  }
}
const Xp = ({
  value: t,
  selectedOptions: e,
  handleCheckboxChange: r,
  styleConfig: n,
  themeConfig: A,
  newId: i,
  isV1Api: o,
  formDataSecondary: s,
  questThemeData: a,
  optionsHeader: c,
  isOptionRank: l,
  unselectedSvg: u,
  selectedSvg: f,
  optionCheckboxes: d,
  multiTranslatedTitle: g
}) => {
  const m = s.find(
    (v) => v.criteriaId === t.criteriaId
  ), p = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  return /* @__PURE__ */ k(Ze, { children: [
    c == !0 && /* @__PURE__ */ h("p", { className: "quiz-options-header", children: g }),
    /* @__PURE__ */ h("div", { className: "quiz-header-ques-options multi-option", children: t == null ? void 0 : t.options.map((v, C) => {
      var b, q, E;
      const w = {
        border: `2px solid ${(a == null ? void 0 : a.accentColor) || "#9035FF"}`,
        fontFamily: A == null ? void 0 : A.fontFamily
      }, B = {
        color: ((b = n == null ? void 0 : n.OptionsSelectedColor) == null ? void 0 : b.color) || "#9035FF",
        fontFamily: A == null ? void 0 : A.fontFamily
      }, y = (q = e[t[i]]) == null ? void 0 : q.includes(v);
      return /* @__PURE__ */ k(
        "div",
        {
          onClick: () => r(v, t[i]),
          className: `${y ? "selected-option" : "not-selected"}`,
          style: y ? w : { borderColor: A == null ? void 0 : A.borderColor },
          children: [
            l && /* @__PURE__ */ h("span", { className: "option-rank", children: p[C] }),
            /* @__PURE__ */ h(
              "p",
              {
                style: y ? B : {
                  color: A == null ? void 0 : A.primaryColor,
                  fontFamily: A == null ? void 0 : A.fontFamily
                },
                children: o ? m == null ? void 0 : m.options[C] : v
              }
            ),
            d === !0 ? y ? f || QOe((E = n == null ? void 0 : n.OptionsSelectedColor) == null ? void 0 : E.color) : u || DOe(A == null ? void 0 : A.borderColor) : null
          ]
        },
        C
      );
    }) })
  ] });
}, Kp = ({
  value: t,
  answer: e,
  handleRadioChange: r,
  styleConfig: n,
  themeConfig: A,
  newId: i,
  isV1Api: o,
  formDataSecondary: s,
  questThemeData: a,
  optionsHeader: c,
  isOptionRank: l,
  unselectedSvg: u,
  selectedSvg: f,
  optionCheckboxes: d,
  singleTranslatedTitle: g
}) => {
  const m = s.find(
    (v) => v.criteriaId === t.criteriaId
  ), p = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  return /* @__PURE__ */ k(Ze, { children: [
    c == !0 && /* @__PURE__ */ h("p", { className: "quiz-options-header", children: g }),
    /* @__PURE__ */ h("div", { className: "quiz-header-ques-options", children: t == null ? void 0 : t.options.map((v, C) => {
      var y, b, q, E, x, M;
      const w = {
        border: `2px solid ${(a == null ? void 0 : a.accentColor) || "#9035FF"}`
      }, B = {
        color: ((y = n == null ? void 0 : n.OptionsSelectedColor) == null ? void 0 : y.color) || "#9035FF",
        fontFamily: A == null ? void 0 : A.fontFamily
      };
      return /* @__PURE__ */ k(
        "div",
        {
          onClick: () => r(v, t[i]),
          className: `${(b = e[t[i]]) != null && b.includes(v) ? "selected-option" : "not-selected"}`,
          style: (q = e[t[i]]) != null && q.includes(v) ? w : {
            borderColor: A == null ? void 0 : A.borderColor
          },
          children: [
            l && /* @__PURE__ */ h("span", { className: "option-rank", children: p[C] }),
            /* @__PURE__ */ h(
              "p",
              {
                style: (E = e[t[i]]) != null && E.includes(v) ? B : {
                  color: A == null ? void 0 : A.primaryColor,
                  fontFamily: A == null ? void 0 : A.fontFamily
                },
                children: o ? m == null ? void 0 : m.options[C] : v
              }
            ),
            d === !0 ? (x = e[t[i]]) != null && x.includes(v) ? f || NOe((M = n == null ? void 0 : n.OptionsSelectedColor) == null ? void 0 : M.color) : u || UOe(A == null ? void 0 : A.borderColor) : null
          ]
        },
        C
      );
    }) })
  ] });
}, rTe = ({
  userId: t,
  token: e,
  questId: r,
  // uniqueUserId,
  // uniqueEmailId,
  showFooter: n,
  footerText: A,
  footerLink: i,
  styleConfig: o,
  Quiz: s,
  setQuiz: a,
  // functionOnSubmit,
  setQuestions: c,
  variation: l,
  isV1Api: u,
  IconColor: f,
  // isAccumulateAndSelf,
  optionsHeader: d,
  isOptionRank: g,
  unselectedSvg: m,
  selectedSvg: p,
  onClose: v,
  isQuizOverview: C,
  // functionOnExceededRetryCount,
  // functionOnSuccessfulSubmit,
  ResultPopupCloseIcon: w,
  isQuizOverviewTitle: B,
  formDataOffline: y,
  optionCheckboxes: b
}) => {
  var Ae, Pe, it, de, xe, he, Qe, Re, pt, ze, lt, st, We, Je, ut, Be, Ct, Ye, $e, nt, mt, me, yt;
  const { apiKey: q, apiSecret: E, entityId: x, apiType: M, themeConfig: O } = Xe(
    ct.Context
  );
  new qj(M);
  let I = new Bt("mixpanel", M);
  const S = u ? "criteriaId" : "actionId", [P] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  });
  new URLSearchParams(window.location.search).get("localeCode"), N([]);
  const [F, T] = N([]), [U, D] = N(!1);
  new zn();
  const [Q, Y] = N(
    {}
  );
  N("");
  const [j, Z] = N(y || []), [W, R] = N(
    y || []
  ), [K, L] = N(0), [G, V] = N((y == null ? void 0 : y.length) || 0), [_, J] = N("Submit"), [X, ne] = N([]), [ee, $] = N(0), [te, ae] = N(!1);
  le(() => {
    Z(y || []), V((y == null ? void 0 : y.length) || 0);
  }, [y]), le(() => {
  }, []);
  const [se, ue] = N({}), [fe, ve] = N(!0), [ge, oe] = N(!0), [ce, pe] = N(!1), qe = (Ue, Ie) => {
    var ot;
    (ot = se[Ie]) != null && ot.includes(Ue) ? ue((Ke) => ({
      ...Ke,
      [Ie]: Ke[Ie].filter((tt) => tt != Ue)
    })) : Array.isArray(se[Ie]) ? se[Ie] = [...se[Ie], Ue] : (se[Ie] = [], se[Ie] = [...se[Ie], Ue]), oe((Ke) => !Ke);
  }, Se = (Ue, Ie) => {
    var ot;
    (ot = Q[Ie]) != null && ot.includes(Ue) ? Y((Ke) => ({ ...Ke, [Ie]: Ke[Ie] = [] })) : (Q[Ie] = [], Q[Ie] = [...Q[Ie], Ue]), ve((Ke) => !Ke);
  };
  le(() => {
    var Ke;
    const Ue = j[K], Ie = Ue == null ? void 0 : Ue[S], ot = Ue == null ? void 0 : Ue.required;
    if ((Ue == null ? void 0 : Ue.type) === "USER_INPUT_MULTI_CHOICE") {
      const tt = se[Ie];
      (tt == null ? void 0 : tt.length) > 0 ? pe(!0) : pe(!1);
    } else ((Ke = Q[Ie]) == null ? void 0 : Ke.length) > 0 && ot ? pe(!0) : pe(!1);
  }, [Q, fe, ge, se, j, K, y]);
  const Te = [];
  for (let Ue = 0; Ue < G; Ue++)
    Te.push(
      /* @__PURE__ */ h("div", { className: "gamified-quiz-action-div", children: /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-title-cont", children: /* @__PURE__ */ k("div", { className: "question-input-cont", children: [
        ((Ae = j[Ue]) == null ? void 0 : Ae.type) === "USER_INPUT_SINGLE_CHOICE" || ((Pe = j[Ue]) == null ? void 0 : Pe.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ k(
          "div",
          {
            className: "question",
            style: {
              fontFamily: O == null ? void 0 : O.fontFamily,
              ...o == null ? void 0 : o.Question,
              color: ((it = o == null ? void 0 : o.Question) == null ? void 0 : it.color) || (O == null ? void 0 : O.primaryColor)
            },
            children: [
              (de = j[Ue]) == null ? void 0 : de.question,
              `${(xe = j[Ue]) != null && xe.required ? "*" : ""}`
            ]
          }
        ) : null,
        ((he = j[Ue]) == null ? void 0 : he.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ h(
          Xp,
          {
            value: j[Ue],
            selectedOptions: se,
            handleCheckboxChange: qe,
            styleConfig: o,
            themeConfig: O,
            newId: S,
            isV1Api: u,
            formDataSecondary: W,
            questThemeData: P,
            optionsHeader: d,
            isOptionRank: g,
            unselectedSvg: m,
            selectedSvg: p,
            optionCheckboxes: b
          }
        ) : ((Qe = j[Ue]) == null ? void 0 : Qe.type) === "USER_INPUT_SINGLE_CHOICE" ? /* @__PURE__ */ h(
          Kp,
          {
            value: j[Ue],
            handleRadioChange: Se,
            styleConfig: o,
            themeConfig: O,
            newId: S,
            isV1Api: u,
            formDataSecondary: W,
            questThemeData: P,
            answer: Q,
            optionsHeader: d,
            isOptionRank: g,
            unselectedSvg: m,
            selectedSvg: p,
            optionCheckboxes: b
          }
        ) : ""
      ] }) }) }, Ue)
    );
  const be = async () => {
    try {
      const Ue = { ...Q };
      if (Object.keys(se).forEach((Ie) => {
        Ue[Ie] = se[Ie];
      }), u) {
        const Ie = Object.keys(Ue).map((tt) => {
          var Vt, Mt;
          const Ot = j.findIndex((lr) => lr.criteriaId === tt);
          return {
            criteriaId: tt,
            answer: Array.isArray(Ue[tt]) ? Ue[tt] : [Ue[tt]],
            question: (Vt = j[Ot]) == null ? void 0 : Vt.question,
            expectedAnswer: ((Mt = j[Ot]) == null ? void 0 : Mt.expectedAnswer) || []
          };
        });
        let ot = [];
        const Ke = Ie.filter((tt) => {
          var Vt;
          let Ot = (Vt = tt.expectedAnswer) == null ? void 0 : Vt.every(
            (Mt) => tt.answer.includes(Mt)
          );
          return Ot == !0 ? ot.push({
            question: tt.question,
            isCorrectAnswer: !0
          }) : ot.push({
            question: tt.question,
            isCorrectAnswer: !1
          }), Ot;
        });
        $(Ke.length), ne(ot), D(!0), ae(!0);
      } else {
        const Ie = Object.keys(Ue).map((tt) => {
          var Vt, Mt;
          const Ot = j.findIndex((lr) => lr.actionId === tt);
          return {
            actionId: tt,
            answers: Array.isArray(Ue[tt]) ? Ue[tt] : [Ue[tt]],
            question: (Vt = j[Ot]) == null ? void 0 : Vt.question,
            expectedAnswer: ((Mt = j[Ot]) == null ? void 0 : Mt.expectedAnswer) || []
          };
        });
        let ot = [];
        const Ke = Ie.filter((tt) => {
          var Vt;
          let Ot = (Vt = tt.expectedAnswer) == null ? void 0 : Vt.every(
            (Mt) => tt.answers.includes(Mt)
          );
          return Ot == !0 ? ot.push({
            question: tt.question,
            isCorrectAnswer: !0
          }) : ot.push({
            question: tt.question,
            isCorrectAnswer: !1
          }), Ot;
        });
        $(Ke.length), ne(ot), D(!0), ae(!0);
      }
    } catch (Ue) {
      console.error("Error submitting form:", Ue), I.captureSentryException(Ue);
    }
  }, He = () => {
    L(K - 1);
  }, Ge = () => {
    D(!1);
  }, Le = () => {
    D(!1);
  };
  return /* @__PURE__ */ h(Ze, { children: s ? /* @__PURE__ */ k("div", { className: "q-quiz-cont", children: [
    U ? /* @__PURE__ */ h(vj, { totalQuestions: G, correctQuestions: ee, onContinue: Ge, buttonStyles: o == null ? void 0 : o.ResultPopupButton, setQuiz: a, GeneralFunctions: I, setIsResultPopup: D, styleConfig: o, isQuizOverview: C, ResultPopupCloseIcon: w, onTryAgain: Le, isQuizOverviewTitle: B, questionDetails: X, expectedCorrectedAnswers: te }) : null,
    /* @__PURE__ */ h("div", { className: "upper-div", children: /* @__PURE__ */ k("div", { className: "quiz", children: [
      /* @__PURE__ */ h(
        "div",
        {
          className: "quiz-header-section",
          style: {
            background: ((Re = o == null ? void 0 : o.Form) == null ? void 0 : Re.background) || (O == null ? void 0 : O.backgroundColor)
          },
          children: /* @__PURE__ */ k("div", { className: "div", children: [
            /* @__PURE__ */ k("div", { className: "quiz-header-task-logo-cont", children: [
              /* @__PURE__ */ h("div", { className: "quiz-back-icon", onClick: He, children: u && K > 0 && mj(f || "black") }),
              /* @__PURE__ */ k("p", { children: [
                "Question ",
                /* @__PURE__ */ k("span", { children: [
                  K + 1,
                  "/",
                  G
                ] })
              ] }),
              /* @__PURE__ */ h("div", { className: "quiz-close-icon", onClick: v, children: u && gj(f || "black") })
            ] }),
            /* @__PURE__ */ h("div", { className: "select-option-cont", children: "Select an option" }),
            /* @__PURE__ */ k("div", { className: "question-input-cont", children: [
              ((pt = j[K]) == null ? void 0 : pt.type) === "USER_INPUT_SINGLE_CHOICE" || ((ze = j[K]) == null ? void 0 : ze.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ k(
                "div",
                {
                  className: "question",
                  style: {
                    color: ((lt = o == null ? void 0 : o.Question) == null ? void 0 : lt.color) || (O == null ? void 0 : O.primaryColor),
                    fontFamily: O == null ? void 0 : O.fontFamily
                  },
                  children: [
                    (st = j[K]) == null ? void 0 : st.question,
                    `${(We = j[K]) != null && We.required ? "*" : ""}`
                  ]
                }
              ) : null,
              /* @__PURE__ */ h("div", { className: "questionWithBg" })
            ] }),
            /* @__PURE__ */ k(
              "form",
              {
                className: "quiz-header-form",
                style: o == null ? void 0 : o.FormContainer,
                children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      style: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "column"
                      },
                      children: /* @__PURE__ */ h(
                        "div",
                        {
                          className: "quiz-action-div",
                          children: /* @__PURE__ */ h("div", { className: "quiz-header-ques-title-cont", children: /* @__PURE__ */ h("div", { className: "question-input-cont", children: ((Je = j[K]) == null ? void 0 : Je.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ h(
                            Xp,
                            {
                              value: j[K],
                              selectedOptions: se,
                              handleCheckboxChange: qe,
                              styleConfig: o,
                              themeConfig: O,
                              newId: S,
                              isV1Api: u,
                              formDataSecondary: W,
                              questThemeData: P,
                              optionsHeader: d,
                              isOptionRank: g,
                              unselectedSvg: m,
                              selectedSvg: p,
                              optionCheckboxes: b
                            }
                          ) : ((ut = j[K]) == null ? void 0 : ut.type) === "USER_INPUT_SINGLE_CHOICE" ? /* @__PURE__ */ h(
                            Kp,
                            {
                              value: j[K],
                              handleRadioChange: Se,
                              styleConfig: o,
                              themeConfig: O,
                              newId: S,
                              isV1Api: u,
                              formDataSecondary: W,
                              questThemeData: P,
                              answer: Q,
                              optionsHeader: d,
                              isOptionRank: g,
                              unselectedSvg: m,
                              selectedSvg: p,
                              optionCheckboxes: b
                            }
                          ) : "" }) })
                        }
                      )
                    }
                  ),
                  G > 0 ? /* @__PURE__ */ k("div", { className: "quiz-header-ques-cancel-next", children: [
                    /* @__PURE__ */ h(
                      "button",
                      {
                        onClick: () => {
                          K > 0 ? (L(K - 1), I.fireTrackingEvent(
                            "quest_quiz_previous_section_button_clicked",
                            "quiz"
                          )) : (a(!1), I.fireTrackingEvent(
                            "quest_quiz_cancel_button_clicked",
                            "quiz"
                          ));
                        },
                        type: "button",
                        className: "cancel-btn",
                        style: {
                          background: ((Be = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : Be.background) || "var(--Neutral-White-100, #FFF)",
                          color: ((Ct = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : Ct.color) || "var(--Neutral-Black-400, #2C2C2C)",
                          fontFamily: O == null ? void 0 : O.fontFamily,
                          borderColor: (Ye = o == null ? void 0 : o.SecondaryButton) == null ? void 0 : Ye.borderColor
                        },
                        children: K > 0 ? "Previous" : "Cancel"
                      }
                    ),
                    /* @__PURE__ */ h(
                      yr,
                      {
                        type: "button",
                        onClick: () => {
                          K < G - 1 ? (I.fireTrackingEvent(
                            "quest_quiz_next_section_button_clicked",
                            "quiz"
                          ), L(K + 1)) : K >= G - 1 && be();
                        },
                        disabled: !ce,
                        className: "q-onb-main-btn2",
                        style: {
                          font: "",
                          fontFamily: "Figtree",
                          background: (($e = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : $e.background) || (O == null ? void 0 : O.buttonColor) || "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                          color: ((nt = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : nt.color) || "var(--Neutral-White-100, #FFF)",
                          border: `1.5px solid ${(mt = o == null ? void 0 : o.PrimaryButton) != null && mt.borderColor ? (me = o == null ? void 0 : o.PrimaryButton) == null ? void 0 : me.borderColor : O != null && O.buttonColor ? O == null ? void 0 : O.buttonColor : "#D1ACFF"}`,
                          fontStyle: "normal",
                          fontWeight: "600",
                          lineHeight: "20px"
                        },
                        children: K >= G - 1 ? u && F.length > 0 ? _ : "Submit" : "Next"
                      }
                    )
                  ] }) : null
                ]
              }
            )
          ] })
        }
      ),
      n ? /* @__PURE__ */ h(
        "div",
        {
          className: "quiz-footer-section",
          style: o == null ? void 0 : o.Footer,
          onClick: () => window.open(
            i || "https://www.plgos.com/",
            "_blank"
          ),
          children: /* @__PURE__ */ h(
            "div",
            {
              className: "footer-content",
              style: {
                color: ((yt = o == null ? void 0 : o.Footer) == null ? void 0 : yt.color) || (O == null ? void 0 : O.secondaryColor),
                fontFamily: O == null ? void 0 : O.fontFamily
              },
              children: A || "Powered by PLG OS"
            }
          )
        }
      ) : null
    ] }) })
  ] }) : null });
}, nTe = ({
  userId: t,
  token: e,
  questId: r,
  uniqueUserId: n,
  uniqueEmailId: A,
  showFooter: i,
  footerText: o,
  footerLink: s,
  styleConfig: a,
  Quiz: c,
  setQuiz: l,
  functionOnSubmit: u,
  setQuestions: f,
  variation: d,
  isV1Api: g,
  IconColor: m,
  isAccumulateAndSelf: p,
  optionsHeader: v,
  isOptionRank: C,
  unselectedSvg: w,
  selectedSvg: B,
  onClose: y,
  isQuizOverview: b,
  functionOnExceededRetryCount: q,
  functionOnSuccessfulSubmit: E,
  ResultPopupCloseIcon: x,
  isQuizOverviewTitle: M,
  optionCheckboxes: O,
  enableLoadingIndicator: I,
  loadingComponent: S
}) => {
  var Et, Qt, Er, kt, en, St, jr, cn, ln, un, dn, fn, hn, En, xn, In, Sn, Pn, kn, dt, ie, _e, Ne;
  const { apiKey: P, apiSecret: H, entityId: F, apiType: T, themeConfig: U } = Xe(
    ct.Context
  );
  let D = new qj(T), Q = new Bt("mixpanel", T);
  const Y = g ? "criteriaId" : "actionId", [j, Z] = N(t || ""), [W, R] = N(e || ""), [K] = N({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  }), G = new URLSearchParams(window.location.search).get("localeCode"), [V, _] = N([]), [J, X] = N([]), [ne, ee] = N(!1), $ = new zn(), [te, ae] = N(
    {}
  ), [se, ue] = N(""), [fe, ve] = N(!1), [ge, oe] = N([]), [ce, pe] = N(
    []
  ), [qe, Se] = N([]), [Te, be] = N(0), [He, Ge] = N(0), [Le, Ae] = N("Submit"), [Pe, it] = N([]), [de, xe] = N(0), [he, Qe] = N(!1), [Re, pt] = N("Single Selection"), [ze, lt] = N("Multiple Selection"), [st, We] = N("Continue"), [Je, ut] = N("Your Score"), [Be, Ct] = N("Question"), Ye = async () => {
    try {
      const Ee = await D.fetchLocalesAndTranslations();
      _(Ee);
      const Ft = (await Promise.all(
        Ee.map(
          (je) => D.getTranslation(F, je)
        )
      )).flat();
      return Ft.forEach((je) => {
        je.key === "Submit" && je.name === G && Ae(je.message), je.key === "Single Selection" && je.name === G && pt(je.message), je.key === "Multiple Selection" && je.name === G && lt(je.message), je.key === "Continue" && je.name === G && We(je.message), je.key === "Your Score" && je.name === G && ut(je.message), je.key === "Question" && je.name === G && Ct(je.message);
      }), X(Ft), Ft;
    } catch (Ee) {
      console.error("Error fetching phrase data:", Ee);
    }
  };
  le(() => {
    (async () => {
      try {
        let et, Ft;
        if (!j || !W) {
          let Me = await D.handleUserMetrics({
            entityId: F,
            campaignId: r || "",
            uniqueUserId: n,
            uniqueEmailId: A,
            externalUserId: $.get("externalUserId"),
            questUserId: $.get("questUserId"),
            questUserToken: $.get("questUserToken"),
            headers: {
              apiKey: P,
              apisecret: H,
              userId: t,
              token: e
            }
          });
          console.log(Me), Z(Me == null ? void 0 : Me.userId), R(Me == null ? void 0 : Me.token), et = Me == null ? void 0 : Me.userId, Ft = Me == null ? void 0 : Me.token;
        }
        g ? await (async () => {
          var Me, De, Ce;
          try {
            let Pt = await Ye(), Ut = await D.getQuestDataV1({
              headers: {
                apiKey: P,
                apisecret: H,
                userId: j || et || "",
                token: W || Ft || ""
              },
              campaignId: r || "",
              entityId: F,
              userId: t,
              variation: d
            });
            f == null || f((De = (Me = Ut == null ? void 0 : Ut.data) == null ? void 0 : Me.eligibilityCriterias) == null ? void 0 : De.length);
            let It = (Ce = Ut == null ? void 0 : Ut.data) == null ? void 0 : Ce.eligibilityData.map(
              (at) => {
                var vt, zt, Ht, _t, or, tr, Cr, jt, dr;
                return {
                  type: at == null ? void 0 : at.criteriaType,
                  question: (vt = at == null ? void 0 : at.metadata) == null ? void 0 : vt.title,
                  options: ((zt = at == null ? void 0 : at.metadata) == null ? void 0 : zt.options) || [],
                  criteriaId: at == null ? void 0 : at.criteriaId,
                  required: (Ht = at == null ? void 0 : at.metadata) == null ? void 0 : Ht.isRequired,
                  placeholder: (_t = at == null ? void 0 : at.metadata) == null ? void 0 : _t.placeholder,
                  keyId: ((or = at == null ? void 0 : at.metadata) == null ? void 0 : or.keyId) || "",
                  optionsKeyIds: ((tr = at == null ? void 0 : at.metadata) == null ? void 0 : tr.optionsKeyIds) || [],
                  preventFutureSelection: (Cr = at == null ? void 0 : at.metadata) == null ? void 0 : Cr.preventFutureSelection,
                  preventPastSelection: (jt = at == null ? void 0 : at.metadata) == null ? void 0 : jt.preventPastSelection,
                  expectedAnswer: (dr = at == null ? void 0 : at.metadata) == null ? void 0 : dr.expectedAnswer
                };
              }
            );
            if (Ge(Ut.data.eligibilityCriterias.length), (It == null ? void 0 : It.length) > 0) {
              const at = await D.updateTranslations({
                criterias: It,
                isOption: !1,
                localeCode: G || "",
                transition: Pt
              }), vt = await D.updateTranslations({
                criterias: It,
                isOption: !0,
                localeCode: G || "",
                transition: Pt
              }), [
                zt,
                Ht
              ] = await Promise.all([
                at,
                vt
              ]);
              oe(zt), pe(Ht), Se(It);
            } else
              oe([]);
            ve(!0);
          } catch (Pt) {
            console.error("Error fetching v1 quest data:", Pt), Q.captureSentryException(Pt);
          }
        })() : await (async () => {
          var Me, De, Ce, Pt, Ut;
          try {
            let It = await D.getQuestDataV2({
              headers: {
                apiKey: P,
                apisecret: H,
                userId: j || et || "",
                token: W || Ft || ""
              },
              campaignId: r || "",
              entityId: F,
              variation: d
            });
            f == null || f((De = (Me = It == null ? void 0 : It.data) == null ? void 0 : Me.eligibilityCriterias) == null ? void 0 : De.length);
            let at = (Pt = (Ce = It == null ? void 0 : It.data) == null ? void 0 : Ce.actions) == null ? void 0 : Pt.map((vt) => {
              var zt, Ht, _t;
              return {
                type: vt == null ? void 0 : vt.actionType,
                question: vt == null ? void 0 : vt.title,
                options: (vt == null ? void 0 : vt.options) || [],
                actionId: vt == null ? void 0 : vt.actionId,
                required: vt == null ? void 0 : vt.isRequired,
                placeholder: (zt = vt == null ? void 0 : vt.metadata) == null ? void 0 : zt.placeholder,
                preventFutureSelection: (Ht = vt == null ? void 0 : vt.metadata) == null ? void 0 : Ht.preventFutureSelection,
                preventPastSelection: (_t = vt == null ? void 0 : vt.metadata) == null ? void 0 : _t.preventPastSelection,
                expectedAnswer: (vt == null ? void 0 : vt.expectedAnswer) || []
              };
            });
            Ge((Ut = It == null ? void 0 : It.data) == null ? void 0 : Ut.actions.length), (at == null ? void 0 : at.length) > 0 ? (oe([...at]), Se([...at])) : (oe([]), Se([])), ue(It.data.campaignVariationId), ve(!0);
          } catch (It) {
            console.error("Error fetching quest data:", It), Q.captureSentryException(It);
          }
        })();
      } catch (et) {
        console.error("Error in fetchData:", et), Q.captureSentryException(et);
      }
    })();
  }, []);
  const [$e, nt] = N({}), [mt, me] = N(!0), [yt, Ue] = N(!0), [Ie, ot] = N(!1), Ke = (Ee, et) => {
    var Ft;
    (Ft = $e[et]) != null && Ft.includes(Ee) ? nt((je) => ({
      ...je,
      [et]: je[et].filter((ur) => ur != Ee)
    })) : Array.isArray($e[et]) ? $e[et] = [...$e[et], Ee] : ($e[et] = [], $e[et] = [...$e[et], Ee]), Ue((je) => !je);
  }, tt = (Ee, et) => {
    var Ft;
    (Ft = te[et]) != null && Ft.includes(Ee) ? ae((je) => ({ ...je, [et]: je[et] = [] })) : (te[et] = [], te[et] = [...te[et], Ee]), me((je) => !je);
  };
  le(() => {
    var je;
    const Ee = ge[Te], et = Ee == null ? void 0 : Ee[Y], Ft = Ee == null ? void 0 : Ee.required;
    if ((Ee == null ? void 0 : Ee.type) === "USER_INPUT_MULTI_CHOICE") {
      const ur = $e[et];
      (ur == null ? void 0 : ur.length) > 0 ? ot(!0) : ot(!1);
    } else ((je = te[et]) == null ? void 0 : je.length) > 0 && Ft ? ot(!0) : ot(!1);
  }, [te, mt, yt, $e, ge, Te]);
  const Ot = [];
  for (let Ee = 0; Ee < He; Ee++)
    Ot.push(
      /* @__PURE__ */ h("div", { className: "gamified-quiz-action-div", children: /* @__PURE__ */ h("div", { className: "gamified-quiz-header-ques-title-cont", children: /* @__PURE__ */ k("div", { className: "question-input-cont", children: [
        ((Et = ge[Ee]) == null ? void 0 : Et.type) === "USER_INPUT_SINGLE_CHOICE" || ((Qt = ge[Ee]) == null ? void 0 : Qt.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ k(
          "div",
          {
            className: "question",
            style: {
              fontFamily: U == null ? void 0 : U.fontFamily,
              ...a == null ? void 0 : a.Question,
              color: ((Er = a == null ? void 0 : a.Question) == null ? void 0 : Er.color) || (U == null ? void 0 : U.primaryColor)
            },
            children: [
              (kt = ge[Ee]) == null ? void 0 : kt.question,
              `${(en = ge[Ee]) != null && en.required ? "*" : ""}`
            ]
          }
        ) : null,
        ((St = ge[Ee]) == null ? void 0 : St.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ h(
          Xp,
          {
            value: ge[Ee],
            selectedOptions: $e,
            handleCheckboxChange: Ke,
            styleConfig: a,
            themeConfig: U,
            newId: Y,
            isV1Api: g,
            formDataSecondary: ce,
            questThemeData: K,
            optionsHeader: v,
            isOptionRank: C,
            unselectedSvg: w,
            selectedSvg: B,
            optionCheckboxes: O,
            multiTranslatedTitle: ze
          }
        ) : ((jr = ge[Ee]) == null ? void 0 : jr.type) === "USER_INPUT_SINGLE_CHOICE" ? /* @__PURE__ */ h(
          Kp,
          {
            value: ge[Ee],
            handleRadioChange: tt,
            styleConfig: a,
            themeConfig: U,
            newId: Y,
            isV1Api: g,
            formDataSecondary: ce,
            questThemeData: K,
            answer: te,
            optionsHeader: v,
            isOptionRank: C,
            unselectedSvg: w,
            selectedSvg: B,
            optionCheckboxes: O,
            singleTranslatedTitle: Re
          }
        ) : ""
      ] }) }) }, Ee)
    );
  const Vt = async () => {
    var Ee, et, Ft;
    try {
      let je = await D.submitFormData({
        isV1Api: g,
        entityId: F,
        campaignId: r || "",
        answer: te,
        selectedOptions: $e,
        campaignVariationId: se,
        headers: {
          apiKey: P,
          apisecret: H,
          userId: j,
          token: W
        },
        formdata: qe,
        isAccumulateAndSelf: p
      });
      if (je != null && je.success)
        if ((je == null ? void 0 : je.exceededRetryCount) == !0 && (je == null ? void 0 : je.expectedCorrectedAnswers) == !1) {
          ee(!0), it(je == null ? void 0 : je.quizSummary);
          let ur = (Ee = je == null ? void 0 : je.quizSummary) == null ? void 0 : Ee.filter((Me) => Me.isCorrectAnswer == !0);
          xe(ur == null ? void 0 : ur.length), q == null || q();
        } else if ((je == null ? void 0 : je.expectedCorrectedAnswers) == !0) {
          ee(je.success), it(je == null ? void 0 : je.quizSummary);
          let ur = (et = je == null ? void 0 : je.quizSummary) == null ? void 0 : et.filter((Me) => Me.isCorrectAnswer == !0);
          xe(ur == null ? void 0 : ur.length), E == null || E(), Qe(je == null ? void 0 : je.expectedCorrectedAnswers);
        } else if ((je == null ? void 0 : je.expectedCorrectedAnswers) == !1 && ((je == null ? void 0 : je.exceededRetryCount) == !1 || (je == null ? void 0 : je.exceededRetryCount) == null)) {
          ee(!0), it(je == null ? void 0 : je.quizSummary);
          let ur = (Ft = je == null ? void 0 : je.quizSummary) == null ? void 0 : Ft.filter((Me) => Me.isCorrectAnswer == !0);
          xe(ur == null ? void 0 : ur.length), Qe(je == null ? void 0 : je.expectedCorrectedAnswers), u == null || u();
        } else
          l(!1), u == null || u();
    } catch (je) {
      console.error("Error submitting form:", je), Q.captureSentryException(je);
    }
  }, Mt = () => {
    be(Te - 1);
  }, lr = () => {
    ee(!1), l(!1), ae({});
  }, Lr = () => {
    ee(!1), l(!0), ae({});
  };
  return /* @__PURE__ */ k(Ze, { children: [
    c && !fe && I && /* @__PURE__ */ h(Ze, { children: S }),
    c && fe ? /* @__PURE__ */ k("div", { className: "q-quiz-cont", children: [
      ne ? /* @__PURE__ */ h(vj, { totalQuestions: He, correctQuestions: de || 0, onContinue: lr, buttonStyles: a == null ? void 0 : a.ResultPopupButton, setQuiz: l, GeneralFunctions: Q, setIsResultPopup: ee, styleConfig: a, isQuizOverview: b, ResultPopupCloseIcon: x, onTryAgain: Lr, isQuizOverviewTitle: M, questionDetails: Pe, expectedCorrectedAnswers: he, yourScore: Je }) : null,
      /* @__PURE__ */ h("div", { className: "upper-div", children: /* @__PURE__ */ k("div", { className: "quiz", children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "quiz-header-section",
            style: {
              background: ((cn = a == null ? void 0 : a.Form) == null ? void 0 : cn.background) || (U == null ? void 0 : U.backgroundColor)
            },
            children: /* @__PURE__ */ k("div", { className: "div", children: [
              /* @__PURE__ */ k("div", { className: "quiz-header-task-logo-cont", children: [
                /* @__PURE__ */ h("div", { className: "quiz-back-icon", onClick: Mt, children: g && Te > 0 && mj(m || "black") }),
                /* @__PURE__ */ k("p", { children: [
                  Be,
                  " ",
                  /* @__PURE__ */ k("span", { children: [
                    Te + 1,
                    "/",
                    He
                  ] })
                ] }),
                /* @__PURE__ */ h("div", { className: "quiz-close-icon", onClick: y, children: g && gj(m || "black") })
              ] }),
              /* @__PURE__ */ h("div", { className: "select-option-cont", children: "Select an option" }),
              /* @__PURE__ */ k("div", { className: "question-input-cont", children: [
                ((ln = ge[Te]) == null ? void 0 : ln.type) === "USER_INPUT_SINGLE_CHOICE" || ((un = ge[Te]) == null ? void 0 : un.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ k(
                  "div",
                  {
                    className: "question",
                    style: {
                      color: ((dn = a == null ? void 0 : a.Question) == null ? void 0 : dn.color) || (U == null ? void 0 : U.primaryColor),
                      fontFamily: U == null ? void 0 : U.fontFamily
                    },
                    children: [
                      (fn = ge[Te]) == null ? void 0 : fn.question,
                      `${(hn = ge[Te]) != null && hn.required ? "*" : ""}`
                    ]
                  }
                ) : null,
                /* @__PURE__ */ h("div", { className: "questionWithBg" })
              ] }),
              /* @__PURE__ */ k(
                "form",
                {
                  className: "quiz-header-form",
                  style: a == null ? void 0 : a.FormContainer,
                  children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          width: "100%",
                          display: "flex",
                          flexDirection: "column"
                        },
                        children: /* @__PURE__ */ h(
                          "div",
                          {
                            className: "quiz-action-div",
                            children: /* @__PURE__ */ h("div", { className: "quiz-header-ques-title-cont", children: /* @__PURE__ */ h("div", { className: "question-input-cont", children: ((En = ge[Te]) == null ? void 0 : En.type) === "USER_INPUT_MULTI_CHOICE" ? /* @__PURE__ */ h(
                              Xp,
                              {
                                value: ge[Te],
                                selectedOptions: $e,
                                handleCheckboxChange: Ke,
                                styleConfig: a,
                                themeConfig: U,
                                newId: Y,
                                isV1Api: g,
                                formDataSecondary: ce,
                                questThemeData: K,
                                optionsHeader: v,
                                isOptionRank: C,
                                unselectedSvg: w,
                                selectedSvg: B,
                                optionCheckboxes: O,
                                multiTranslatedTitle: ze
                              }
                            ) : ((xn = ge[Te]) == null ? void 0 : xn.type) === "USER_INPUT_SINGLE_CHOICE" ? /* @__PURE__ */ h(
                              Kp,
                              {
                                value: ge[Te],
                                handleRadioChange: tt,
                                styleConfig: a,
                                themeConfig: U,
                                newId: Y,
                                isV1Api: g,
                                formDataSecondary: ce,
                                questThemeData: K,
                                answer: te,
                                optionsHeader: v,
                                isOptionRank: C,
                                unselectedSvg: w,
                                selectedSvg: B,
                                optionCheckboxes: O,
                                singleTranslatedTitle: Re
                              }
                            ) : "" }) })
                          }
                        )
                      }
                    ),
                    He > 0 ? /* @__PURE__ */ k("div", { className: "quiz-header-ques-cancel-next", children: [
                      /* @__PURE__ */ h(
                        "button",
                        {
                          onClick: () => {
                            Te > 0 ? (be(Te - 1), Q.fireTrackingEvent(
                              "quest_quiz_previous_section_button_clicked",
                              "quiz"
                            )) : (l(!1), Q.fireTrackingEvent(
                              "quest_quiz_cancel_button_clicked",
                              "quiz"
                            ));
                          },
                          type: "button",
                          className: "cancel-btn",
                          style: {
                            background: ((In = a == null ? void 0 : a.SecondaryButton) == null ? void 0 : In.background) || "var(--Neutral-White-100, #FFF)",
                            color: ((Sn = a == null ? void 0 : a.SecondaryButton) == null ? void 0 : Sn.color) || "var(--Neutral-Black-400, #2C2C2C)",
                            fontFamily: U == null ? void 0 : U.fontFamily,
                            borderColor: (Pn = a == null ? void 0 : a.SecondaryButton) == null ? void 0 : Pn.borderColor
                          },
                          children: Te > 0 ? "Previous" : "Cancel"
                        }
                      ),
                      /* @__PURE__ */ h(
                        yr,
                        {
                          type: "button",
                          onClick: () => {
                            Te < He - 1 ? (Q.fireTrackingEvent(
                              "quest_quiz_next_section_button_clicked",
                              "quiz"
                            ), be(Te + 1)) : Te >= He - 1 && Vt();
                          },
                          disabled: !Ie,
                          className: "q-onb-main-btn2",
                          style: {
                            font: "",
                            fontFamily: "Figtree",
                            background: ((kn = a == null ? void 0 : a.PrimaryButton) == null ? void 0 : kn.background) || (U == null ? void 0 : U.buttonColor) || "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                            color: ((dt = a == null ? void 0 : a.PrimaryButton) == null ? void 0 : dt.color) || "var(--Neutral-White-100, #FFF)",
                            border: `1.5px solid ${(ie = a == null ? void 0 : a.PrimaryButton) != null && ie.borderColor ? (_e = a == null ? void 0 : a.PrimaryButton) == null ? void 0 : _e.borderColor : U != null && U.buttonColor ? U == null ? void 0 : U.buttonColor : "#D1ACFF"}`,
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "20px"
                          },
                          children: Te >= He - 1 ? g ? J.length > 0 ? Le : "" : "Submit" : st
                        }
                      )
                    ] }) : null
                  ]
                }
              )
            ] })
          }
        ),
        i ? /* @__PURE__ */ h(
          "div",
          {
            className: "quiz-footer-section",
            style: a == null ? void 0 : a.Footer,
            onClick: () => window.open(
              s || "https://www.plgos.com/",
              "_blank"
            ),
            children: /* @__PURE__ */ h(
              "div",
              {
                className: "footer-content",
                style: {
                  color: ((Ne = a == null ? void 0 : a.Footer) == null ? void 0 : Ne.color) || (U == null ? void 0 : U.secondaryColor),
                  fontFamily: U == null ? void 0 : U.fontFamily
                },
                children: o || "Powered by PLG OS"
              }
            )
          }
        ) : null
      ] }) })
    ] }) : null
  ] });
}, ATe = ({
  maxSpins: t,
  rewards: e,
  wheelColors: r,
  wheelImage: n,
  winningIndex: A,
  onSpinComplete: i,
  successCall: o,
  isAccumulateXP: s = !1,
  isImgShow: a,
  styleConfig: c,
  claimButtonText: l,
  wheelTextColor: u,
  winningSegmentColor: f,
  spinText: d,
  spinCenteredText: g,
  isSecondaryImage: m,
  onGuestUserClick: p,
  onCompletedCriteriaUserClick: v,
  isClaimTitle: C,
  isLoader: w,
  isPoint: B,
  loaderComponent: y
}) => {
  var X, ne;
  Xe(ct.Context);
  const [b, q] = N(0), E = gt(null), [x, M] = N(0), [O, I] = N(!1), [S, P] = N(B ? Ta : Gc), [H, F] = N("1"), [T, U] = N(""), [D, Q] = N(
    null
  );
  new Bt("");
  const [Y, j] = N(!1), [Z, W] = N(!0), [R, K] = N(e || Array(10).fill({ title: "" }));
  N(!1);
  const [L, G] = N(!0);
  le(() => {
    let ee = e == null ? void 0 : e.map(($) => {
      var ae, se, ue, fe, ve, ge;
      const te = ($ == null ? void 0 : $.rewardType) === "REWARD_XP";
      return {
        title: te ? B ? "Points" : "XP" : ((ae = $ == null ? void 0 : $.metadata) == null ? void 0 : ae.name) || ((se = $ == null ? void 0 : $.metadata) == null ? void 0 : se.title),
        value: te ? (ue = $ == null ? void 0 : $.metadata) == null ? void 0 : ue.xp : (fe = $ == null ? void 0 : $.metadata) == null ? void 0 : fe.gemsData,
        image: te ? B ? Ta : Gc : ((ve = $ == null ? void 0 : $.metadata) == null ? void 0 : ve.logo) || ((ge = $ == null ? void 0 : $.metadata) == null ? void 0 : ge.imageURL),
        rewardType: $ == null ? void 0 : $.rewardType
      };
    });
    K(ee || []);
  }, [e]);
  const V = async () => {
    var ee;
    if (E.current && !O && !Y && ((ee = R[0]) == null ? void 0 : ee.title) !== "") {
      I(!0), W(!1), E.current.style.transition = "transform 0s", E.current.style.transform = "rotate(0deg)", E.current.offsetHeight, E.current.style.transition = "transform 3s ease-out", E.current.style.transform = "rotate(2160deg)";
      try {
        const $ = Math.floor(Math.random() * R.length), te = R[$];
        if (te !== null) {
          const ue = (te == null ? void 0 : te.image) || (B ? Ta : Gc);
          P(ue);
          const fe = te == null ? void 0 : te.value;
          F(fe);
        }
        if ($ == null || $ == null) {
          console.error(
            "API response issue - winningIndex is null or already claimed reward"
          ), I(!1), M(0), i && i(), W(!0);
          return;
        }
        const ae = 360 / R.length, se = 360 * 4 + ae * ($ + 1) + 3;
        M(se), E.current.style.transition = "transform 1s ease-out", E.current.style.transform = `rotate(${se}deg)`, setTimeout(() => {
          E.current && (E.current.style.transition = "", q((ue) => ue + 1), M(0), Q($), setTimeout(() => {
            j(!0), I(!1);
          }, 1e3));
        }, 1e3);
      } catch {
        I(!1), M(0);
      }
    }
  };
  le(() => () => {
    I(!1), M(0);
  }, []);
  const _ = R == null ? void 0 : R.length, J = Array.from(
    { length: _ },
    (ee, $) => {
      const te = $ * (360 / _) % 360, ae = Math.abs(Math.sin(360 / _ / 2 * (Math.PI / 180))) * 100 + 1 + "%";
      return {
        background: $ % 2 === 0 ? r == null ? void 0 : r.primary : r == null ? void 0 : r.secondary,
        color: $ % 2 === 0 ? u == null ? void 0 : u.primary : (u == null ? void 0 : u.secondary) || "black",
        transform: `rotate(${te}deg)`,
        width: ae
      };
    }
  );
  return /* @__PURE__ */ k(Ze, { children: [
    L ? /* @__PURE__ */ k("div", { className: "mainContSpinWheel", children: [
      /* @__PURE__ */ h("div", { className: "spinMainContainerStyle", style: { background: ((X = c == null ? void 0 : c.wheelContainerStyle) == null ? void 0 : X.background) || "#969696", ...c == null ? void 0 : c.wheelContainerStyle }, children: /* @__PURE__ */ k(
        "div",
        {
          style: {
            filter: Y ? ((ne = c == null ? void 0 : c.successModalStyle) == null ? void 0 : ne.filter) || "blur(8.571428298950195px)" : "none"
          },
          onClick: V,
          children: [
            /* @__PURE__ */ k("div", { className: "spinContainerStyle", ref: E, style: { cursor: O ? "no-drop" : "" }, children: [
              /* @__PURE__ */ h("img", { src: QN, alt: "", className: "shadowImg" }),
              J == null ? void 0 : J.map((ee, $) => /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    //  ...spinDivStyle,
                    ...ee,
                    background: (D !== null && R.length - 1 - D) === $ ? f || "#FFDD7CBF" : ee.background,
                    clipPath: D !== null && R.length - 1 - D === $ ? "polygon(100% 0, 50% 100%, 0 0)" : "polygon(-2.5% 0, 102.5% 0, 52% 100%, 48% 100%)",
                    ...c == null ? void 0 : c.segmentContentStyle
                  },
                  className: `segment-${$ + 1}`,
                  id: "spinDivStyle",
                  children: /* @__PURE__ */ k("div", { className: "spinSegmentContent", children: [
                    /* @__PURE__ */ k("p", { children: [
                      R[R.length - $ - 1].value,
                      " ",
                      R[R.length - $ - 1].title
                    ] }),
                    a && /* @__PURE__ */ h("img", { src: R[R.length - $ - 1].image, alt: "", style: { transform: "rotate(180deg)" } })
                  ] })
                },
                $
              ))
            ] }),
            /* @__PURE__ */ k("div", { className: "spinCenteredImgContainerStyle", style: { cursor: O ? "no-drop" : "" }, children: [
              /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h("img", { src: DN, alt: "Pointer", className: "spinPointerStyle" }) }),
              /* @__PURE__ */ h("div", { className: "spinCenteredImgDivStyle", style: c == null ? void 0 : c.wheelImageStyle, children: n ? /* @__PURE__ */ h("img", { src: n, alt: "Mystic", className: "spinCenteredImgStyle" }) : /* @__PURE__ */ h("p", { className: "spinCenteredTextStyle", children: g || "Spin" }) })
            ] })
          ]
        }
      ) }),
      Y && /* @__PURE__ */ k("div", { className: "spinSuccessModal", style: c == null ? void 0 : c.successModalStyle, children: [
        /* @__PURE__ */ h("h5", { className: "spinH5Style", children: "Congratulations" }),
        /* @__PURE__ */ h("p", { className: "spinH2Style", children: "You have won:" }),
        /* @__PURE__ */ k("div", { className: "rewardImgContainer", children: [
          /* @__PURE__ */ h(
            "img",
            {
              src: S,
              alt: "Reward",
              style: { width: "60px", height: "60px", marginBottom: "0px" }
            }
          ),
          m === !0 && T && D !== null && R[D].rewardType === "REWARD_CUSTOM_REWARD" && /* @__PURE__ */ h(
            "img",
            {
              src: T,
              alt: "RewardSecondary",
              style: { width: "60px", height: "60px", marginBottom: "0px" }
            }
          )
        ] }),
        H && /* @__PURE__ */ h("p", { style: { textAlign: "center", marginLeft: "-6px" }, children: H }),
        /* @__PURE__ */ h(
          "div",
          {
            style: c == null ? void 0 : c.claimButtonStyle,
            className: "spinAmazingButtonStyle",
            onClick: () => {
              j(!1), Q(null), W(!0), o && o();
            },
            children: /* @__PURE__ */ h("p", { children: l || "Claim" })
          }
        )
      ] })
    ] }) : w && (y || /* @__PURE__ */ h(UN, {})),
    L && /* @__PURE__ */ h("p", { className: "spinText", style: d == null ? void 0 : d.style, children: Z ? (d == null ? void 0 : d.text) || "Tap the wheel to spin!" : "" })
  ] });
};
export {
  fFe as Badge,
  VFe as Challenges,
  WFe as ChallengesOffline,
  vFe as ChatSupport,
  gFe as CreditsPopup,
  hFe as CreditsPopupCheck,
  PFe as CrossSelling,
  kFe as CrossSellingOffline,
  A9 as DailyStreak,
  tTe as Featureflag,
  dFe as Feedback,
  gle as FeedbackWorkflow,
  LFe as FeedbackWorkflowOffline,
  KFe as GamifiedQuiz,
  ZFe as GamifiedQuizOffline,
  r9 as GetStarted,
  DFe as GetStartedOffline,
  EFe as HelpCenter,
  zFe as HelpHub,
  JFe as HelpHubOffline,
  _Fe as InlineFeedback,
  $Fe as InlineFeedbackOffline,
  GFe as LeaderBoard,
  RFe as LeaderBoardOffline,
  Rv as OnBoarding,
  uy as OnBoardingOffline,
  mFe as Payment,
  bFe as QuestChart,
  qFe as QuestForm,
  lFe as QuestLogin,
  OFe as QuestMOdal,
  UFe as QuestMOdalOffline,
  wG as QuestProvider,
  nTe as Quiz,
  rTe as QuizOffline,
  CFe as ReferEarn,
  yFe as ReferShare,
  FFe as Referral,
  TFe as ReferralOffline,
  xFe as Search,
  QFe as SearchOffline,
  aue as ShareArticle,
  eTe as ShareArticleOffline,
  SFe as SpinTheWheel,
  ATe as SpinTheWheelOffline,
  Rc as Survey,
  jFe as SurveyOffline,
  wFe as Table,
  lP as Toast,
  u4 as Tutorial,
  u4 as TutorialScreen,
  MFe as TutorialScreenOffline,
  XFe as UserProfile,
  pFe as VisitStreak,
  IFe as WalkThrough,
  HFe as WalkThroughOffline,
  dPe as confetti,
  rs as showToast
};
//# sourceMappingURL=index.es.js.map
